function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6582"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6582"] = parcelRequire;
}
parcelRequire.register("1yLTD", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $122e1ea1cfdbf7a8$export$ffb0004e005737fa; }, function (v) { return $122e1ea1cfdbf7a8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $122e1ea1cfdbf7a8$export$34b9dba7ce09269b; }, function (v) { return $122e1ea1cfdbf7a8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $122e1ea1cfdbf7a8$export$25062201e9e25d76; }, function (v) { return $122e1ea1cfdbf7a8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $122e1ea1cfdbf7a8$export$ffb0004e005737fa;
var $122e1ea1cfdbf7a8$export$34b9dba7ce09269b;
var $122e1ea1cfdbf7a8$export$25062201e9e25d76;
"use strict";

var $g5BLJ = parcelRequire("g5BLJ");
var $122e1ea1cfdbf7a8$var$k = Symbol.for("react.element"), $122e1ea1cfdbf7a8$var$l = Symbol.for("react.fragment"), $122e1ea1cfdbf7a8$var$m = Object.prototype.hasOwnProperty, $122e1ea1cfdbf7a8$var$n = $g5BLJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $122e1ea1cfdbf7a8$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $122e1ea1cfdbf7a8$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$122e1ea1cfdbf7a8$var$m.call(a, b) && !$122e1ea1cfdbf7a8$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $122e1ea1cfdbf7a8$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $122e1ea1cfdbf7a8$var$n.current
    };
}
$122e1ea1cfdbf7a8$export$ffb0004e005737fa = $122e1ea1cfdbf7a8$var$l;
$122e1ea1cfdbf7a8$export$34b9dba7ce09269b = $122e1ea1cfdbf7a8$var$q;
$122e1ea1cfdbf7a8$export$25062201e9e25d76 = $122e1ea1cfdbf7a8$var$q;

});
parcelRequire.register("g5BLJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fgrj3"));

});
parcelRequire.register("fgrj3", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b1cd8814c0972857$export$dca3b0875bd9a954; }, function (v) { return $b1cd8814c0972857$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b1cd8814c0972857$export$16fa2f45be04daa8; }, function (v) { return $b1cd8814c0972857$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b1cd8814c0972857$export$ffb0004e005737fa; }, function (v) { return $b1cd8814c0972857$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b1cd8814c0972857$export$e2c29f18771995cb; }, function (v) { return $b1cd8814c0972857$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b1cd8814c0972857$export$221d75b3f55bb0bd; }, function (v) { return $b1cd8814c0972857$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b1cd8814c0972857$export$5f8d39834fd61797; }, function (v) { return $b1cd8814c0972857$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b1cd8814c0972857$export$74bf444e3cd11ea5; }, function (v) { return $b1cd8814c0972857$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b1cd8814c0972857$export$ae55be85d98224ed; }, function (v) { return $b1cd8814c0972857$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b1cd8814c0972857$export$e530037191fcd5d7; }, function (v) { return $b1cd8814c0972857$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b1cd8814c0972857$export$fd42f52fd3ae1109; }, function (v) { return $b1cd8814c0972857$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b1cd8814c0972857$export$c8a8987d4410bf2d; }, function (v) { return $b1cd8814c0972857$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b1cd8814c0972857$export$d38cd72104c1f0e9; }, function (v) { return $b1cd8814c0972857$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b1cd8814c0972857$export$7d1e3a5e95ceca43; }, function (v) { return $b1cd8814c0972857$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b1cd8814c0972857$export$257a8862b851cb5b; }, function (v) { return $b1cd8814c0972857$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b1cd8814c0972857$export$a8257692ac88316c; }, function (v) { return $b1cd8814c0972857$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b1cd8814c0972857$export$488013bae63b21da; }, function (v) { return $b1cd8814c0972857$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b1cd8814c0972857$export$7c73462e0d25e514; }, function (v) { return $b1cd8814c0972857$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b1cd8814c0972857$export$7568632d0d33d16d; }, function (v) { return $b1cd8814c0972857$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b1cd8814c0972857$export$88948ce120ea2619; }, function (v) { return $b1cd8814c0972857$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b1cd8814c0972857$export$35808ee640e87ca7; }, function (v) { return $b1cd8814c0972857$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b1cd8814c0972857$export$fae74005e78b1a27; }, function (v) { return $b1cd8814c0972857$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b1cd8814c0972857$export$dc8fbce3eb94dc1e; }, function (v) { return $b1cd8814c0972857$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b1cd8814c0972857$export$6a7bc4e911dc01cf; }, function (v) { return $b1cd8814c0972857$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b1cd8814c0972857$export$6d9c69b0de29b591; }, function (v) { return $b1cd8814c0972857$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b1cd8814c0972857$export$f680877a34711e37; }, function (v) { return $b1cd8814c0972857$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b1cd8814c0972857$export$d5a552a76deda3c2; }, function (v) { return $b1cd8814c0972857$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b1cd8814c0972857$export$aaabe4eda9ed9969; }, function (v) { return $b1cd8814c0972857$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b1cd8814c0972857$export$e5c5a5f917a5871c; }, function (v) { return $b1cd8814c0972857$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b1cd8814c0972857$export$1538c33de8887b59; }, function (v) { return $b1cd8814c0972857$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b1cd8814c0972857$export$13e3392192263954; }, function (v) { return $b1cd8814c0972857$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b1cd8814c0972857$export$b8f5890fc79d6aca; }, function (v) { return $b1cd8814c0972857$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b1cd8814c0972857$export$60241385465d0a34; }, function (v) { return $b1cd8814c0972857$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b1cd8814c0972857$export$306c0aa65ff9ec16; }, function (v) { return $b1cd8814c0972857$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b1cd8814c0972857$export$7b286972b8d8ccbf; }, function (v) { return $b1cd8814c0972857$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b1cd8814c0972857$export$83d89fbfd8236492; }, function (v) { return $b1cd8814c0972857$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b1cd8814c0972857$export$dca3b0875bd9a954;
var $b1cd8814c0972857$export$16fa2f45be04daa8;
var $b1cd8814c0972857$export$ffb0004e005737fa;
var $b1cd8814c0972857$export$e2c29f18771995cb;
var $b1cd8814c0972857$export$221d75b3f55bb0bd;
var $b1cd8814c0972857$export$5f8d39834fd61797;
var $b1cd8814c0972857$export$74bf444e3cd11ea5;
var $b1cd8814c0972857$export$ae55be85d98224ed;
var $b1cd8814c0972857$export$e530037191fcd5d7;
var $b1cd8814c0972857$export$fd42f52fd3ae1109;
var $b1cd8814c0972857$export$c8a8987d4410bf2d;
var $b1cd8814c0972857$export$d38cd72104c1f0e9;
var $b1cd8814c0972857$export$7d1e3a5e95ceca43;
var $b1cd8814c0972857$export$257a8862b851cb5b;
var $b1cd8814c0972857$export$a8257692ac88316c;
var $b1cd8814c0972857$export$488013bae63b21da;
var $b1cd8814c0972857$export$7c73462e0d25e514;
var $b1cd8814c0972857$export$7568632d0d33d16d;
var $b1cd8814c0972857$export$88948ce120ea2619;
var $b1cd8814c0972857$export$35808ee640e87ca7;
var $b1cd8814c0972857$export$fae74005e78b1a27;
var $b1cd8814c0972857$export$dc8fbce3eb94dc1e;
var $b1cd8814c0972857$export$6a7bc4e911dc01cf;
var $b1cd8814c0972857$export$6d9c69b0de29b591;
var $b1cd8814c0972857$export$f680877a34711e37;
var $b1cd8814c0972857$export$d5a552a76deda3c2;
var $b1cd8814c0972857$export$aaabe4eda9ed9969;
var $b1cd8814c0972857$export$e5c5a5f917a5871c;
var $b1cd8814c0972857$export$1538c33de8887b59;
var $b1cd8814c0972857$export$13e3392192263954;
var $b1cd8814c0972857$export$b8f5890fc79d6aca;
var $b1cd8814c0972857$export$60241385465d0a34;
var $b1cd8814c0972857$export$306c0aa65ff9ec16;
var $b1cd8814c0972857$export$7b286972b8d8ccbf;
var $b1cd8814c0972857$export$83d89fbfd8236492;
"use strict";
var $b1cd8814c0972857$var$l = Symbol.for("react.element"), $b1cd8814c0972857$var$n = Symbol.for("react.portal"), $b1cd8814c0972857$var$p = Symbol.for("react.fragment"), $b1cd8814c0972857$var$q = Symbol.for("react.strict_mode"), $b1cd8814c0972857$var$r = Symbol.for("react.profiler"), $b1cd8814c0972857$var$t = Symbol.for("react.provider"), $b1cd8814c0972857$var$u = Symbol.for("react.context"), $b1cd8814c0972857$var$v = Symbol.for("react.forward_ref"), $b1cd8814c0972857$var$w = Symbol.for("react.suspense"), $b1cd8814c0972857$var$x = Symbol.for("react.memo"), $b1cd8814c0972857$var$y = Symbol.for("react.lazy"), $b1cd8814c0972857$var$z = Symbol.iterator;
function $b1cd8814c0972857$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b1cd8814c0972857$var$z && a[$b1cd8814c0972857$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b1cd8814c0972857$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b1cd8814c0972857$var$C = Object.assign, $b1cd8814c0972857$var$D = {};
function $b1cd8814c0972857$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b1cd8814c0972857$var$D;
    this.updater = e || $b1cd8814c0972857$var$B;
}
$b1cd8814c0972857$var$E.prototype.isReactComponent = {};
$b1cd8814c0972857$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b1cd8814c0972857$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b1cd8814c0972857$var$F() {}
$b1cd8814c0972857$var$F.prototype = $b1cd8814c0972857$var$E.prototype;
function $b1cd8814c0972857$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b1cd8814c0972857$var$D;
    this.updater = e || $b1cd8814c0972857$var$B;
}
var $b1cd8814c0972857$var$H = $b1cd8814c0972857$var$G.prototype = new $b1cd8814c0972857$var$F;
$b1cd8814c0972857$var$H.constructor = $b1cd8814c0972857$var$G;
$b1cd8814c0972857$var$C($b1cd8814c0972857$var$H, $b1cd8814c0972857$var$E.prototype);
$b1cd8814c0972857$var$H.isPureReactComponent = !0;
var $b1cd8814c0972857$var$I = Array.isArray, $b1cd8814c0972857$var$J = Object.prototype.hasOwnProperty, $b1cd8814c0972857$var$K = {
    current: null
}, $b1cd8814c0972857$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b1cd8814c0972857$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b1cd8814c0972857$var$J.call(b, d) && !$b1cd8814c0972857$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b1cd8814c0972857$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b1cd8814c0972857$var$K.current
    };
}
function $b1cd8814c0972857$var$N(a, b) {
    return {
        $$typeof: $b1cd8814c0972857$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b1cd8814c0972857$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b1cd8814c0972857$var$l;
}
function $b1cd8814c0972857$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b1cd8814c0972857$var$P = /\/+/g;
function $b1cd8814c0972857$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b1cd8814c0972857$var$escape("" + a.key) : b.toString(36);
}
function $b1cd8814c0972857$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b1cd8814c0972857$var$l:
                case $b1cd8814c0972857$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b1cd8814c0972857$var$Q(h, 0) : d, $b1cd8814c0972857$var$I(c) ? (e = "", null != a && (e = a.replace($b1cd8814c0972857$var$P, "$&/") + "/"), $b1cd8814c0972857$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b1cd8814c0972857$var$O(c) && (c = $b1cd8814c0972857$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b1cd8814c0972857$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b1cd8814c0972857$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b1cd8814c0972857$var$Q(k, g);
        h += $b1cd8814c0972857$var$R(k, b, e, f, c);
    }
    else if (f = $b1cd8814c0972857$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b1cd8814c0972857$var$Q(k, g++), h += $b1cd8814c0972857$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b1cd8814c0972857$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b1cd8814c0972857$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b1cd8814c0972857$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b1cd8814c0972857$var$U = {
    current: null
}, $b1cd8814c0972857$var$V = {
    transition: null
}, $b1cd8814c0972857$var$W = {
    ReactCurrentDispatcher: $b1cd8814c0972857$var$U,
    ReactCurrentBatchConfig: $b1cd8814c0972857$var$V,
    ReactCurrentOwner: $b1cd8814c0972857$var$K
};
$b1cd8814c0972857$export$dca3b0875bd9a954 = {
    map: $b1cd8814c0972857$var$S,
    forEach: function(a, b, e) {
        $b1cd8814c0972857$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b1cd8814c0972857$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b1cd8814c0972857$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b1cd8814c0972857$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b1cd8814c0972857$export$16fa2f45be04daa8 = $b1cd8814c0972857$var$E;
$b1cd8814c0972857$export$ffb0004e005737fa = $b1cd8814c0972857$var$p;
$b1cd8814c0972857$export$e2c29f18771995cb = $b1cd8814c0972857$var$r;
$b1cd8814c0972857$export$221d75b3f55bb0bd = $b1cd8814c0972857$var$G;
$b1cd8814c0972857$export$5f8d39834fd61797 = $b1cd8814c0972857$var$q;
$b1cd8814c0972857$export$74bf444e3cd11ea5 = $b1cd8814c0972857$var$w;
$b1cd8814c0972857$export$ae55be85d98224ed = $b1cd8814c0972857$var$W;
$b1cd8814c0972857$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b1cd8814c0972857$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b1cd8814c0972857$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b1cd8814c0972857$var$J.call(b, f) && !$b1cd8814c0972857$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b1cd8814c0972857$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b1cd8814c0972857$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b1cd8814c0972857$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b1cd8814c0972857$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b1cd8814c0972857$export$c8a8987d4410bf2d = $b1cd8814c0972857$var$M;
$b1cd8814c0972857$export$d38cd72104c1f0e9 = function(a) {
    var b = $b1cd8814c0972857$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b1cd8814c0972857$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b1cd8814c0972857$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b1cd8814c0972857$var$v,
        render: a
    };
};
$b1cd8814c0972857$export$a8257692ac88316c = $b1cd8814c0972857$var$O;
$b1cd8814c0972857$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b1cd8814c0972857$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b1cd8814c0972857$var$T
    };
};
$b1cd8814c0972857$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b1cd8814c0972857$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b1cd8814c0972857$export$7568632d0d33d16d = function(a) {
    var b = $b1cd8814c0972857$var$V.transition;
    $b1cd8814c0972857$var$V.transition = {};
    try {
        a();
    } finally{
        $b1cd8814c0972857$var$V.transition = b;
    }
};
$b1cd8814c0972857$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$b1cd8814c0972857$export$35808ee640e87ca7 = function(a, b) {
    return $b1cd8814c0972857$var$U.current.useCallback(a, b);
};
$b1cd8814c0972857$export$fae74005e78b1a27 = function(a) {
    return $b1cd8814c0972857$var$U.current.useContext(a);
};
$b1cd8814c0972857$export$dc8fbce3eb94dc1e = function() {};
$b1cd8814c0972857$export$6a7bc4e911dc01cf = function(a) {
    return $b1cd8814c0972857$var$U.current.useDeferredValue(a);
};
$b1cd8814c0972857$export$6d9c69b0de29b591 = function(a, b) {
    return $b1cd8814c0972857$var$U.current.useEffect(a, b);
};
$b1cd8814c0972857$export$f680877a34711e37 = function() {
    return $b1cd8814c0972857$var$U.current.useId();
};
$b1cd8814c0972857$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b1cd8814c0972857$var$U.current.useImperativeHandle(a, b, e);
};
$b1cd8814c0972857$export$aaabe4eda9ed9969 = function(a, b) {
    return $b1cd8814c0972857$var$U.current.useInsertionEffect(a, b);
};
$b1cd8814c0972857$export$e5c5a5f917a5871c = function(a, b) {
    return $b1cd8814c0972857$var$U.current.useLayoutEffect(a, b);
};
$b1cd8814c0972857$export$1538c33de8887b59 = function(a, b) {
    return $b1cd8814c0972857$var$U.current.useMemo(a, b);
};
$b1cd8814c0972857$export$13e3392192263954 = function(a, b, e) {
    return $b1cd8814c0972857$var$U.current.useReducer(a, b, e);
};
$b1cd8814c0972857$export$b8f5890fc79d6aca = function(a) {
    return $b1cd8814c0972857$var$U.current.useRef(a);
};
$b1cd8814c0972857$export$60241385465d0a34 = function(a) {
    return $b1cd8814c0972857$var$U.current.useState(a);
};
$b1cd8814c0972857$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b1cd8814c0972857$var$U.current.useSyncExternalStore(a, b, e);
};
$b1cd8814c0972857$export$7b286972b8d8ccbf = function() {
    return $b1cd8814c0972857$var$U.current.useTransition();
};
$b1cd8814c0972857$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("bcIJv", function(module, exports) {
// shim for using process in browser
var $828383bc888aa754$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $828383bc888aa754$var$cachedSetTimeout;
var $828383bc888aa754$var$cachedClearTimeout;
function $828383bc888aa754$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $828383bc888aa754$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $828383bc888aa754$var$cachedSetTimeout = setTimeout;
        else $828383bc888aa754$var$cachedSetTimeout = $828383bc888aa754$var$defaultSetTimout;
    } catch (e) {
        $828383bc888aa754$var$cachedSetTimeout = $828383bc888aa754$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $828383bc888aa754$var$cachedClearTimeout = clearTimeout;
        else $828383bc888aa754$var$cachedClearTimeout = $828383bc888aa754$var$defaultClearTimeout;
    } catch (e) {
        $828383bc888aa754$var$cachedClearTimeout = $828383bc888aa754$var$defaultClearTimeout;
    }
})();
function $828383bc888aa754$var$runTimeout(fun) {
    if ($828383bc888aa754$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($828383bc888aa754$var$cachedSetTimeout === $828383bc888aa754$var$defaultSetTimout || !$828383bc888aa754$var$cachedSetTimeout) && setTimeout) {
        $828383bc888aa754$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $828383bc888aa754$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $828383bc888aa754$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $828383bc888aa754$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $828383bc888aa754$var$runClearTimeout(marker) {
    if ($828383bc888aa754$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($828383bc888aa754$var$cachedClearTimeout === $828383bc888aa754$var$defaultClearTimeout || !$828383bc888aa754$var$cachedClearTimeout) && clearTimeout) {
        $828383bc888aa754$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $828383bc888aa754$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $828383bc888aa754$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $828383bc888aa754$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $828383bc888aa754$var$queue = [];
var $828383bc888aa754$var$draining = false;
var $828383bc888aa754$var$currentQueue;
var $828383bc888aa754$var$queueIndex = -1;
function $828383bc888aa754$var$cleanUpNextTick() {
    if (!$828383bc888aa754$var$draining || !$828383bc888aa754$var$currentQueue) return;
    $828383bc888aa754$var$draining = false;
    if ($828383bc888aa754$var$currentQueue.length) $828383bc888aa754$var$queue = $828383bc888aa754$var$currentQueue.concat($828383bc888aa754$var$queue);
    else $828383bc888aa754$var$queueIndex = -1;
    if ($828383bc888aa754$var$queue.length) $828383bc888aa754$var$drainQueue();
}
function $828383bc888aa754$var$drainQueue() {
    if ($828383bc888aa754$var$draining) return;
    var timeout = $828383bc888aa754$var$runTimeout($828383bc888aa754$var$cleanUpNextTick);
    $828383bc888aa754$var$draining = true;
    var len = $828383bc888aa754$var$queue.length;
    while(len){
        $828383bc888aa754$var$currentQueue = $828383bc888aa754$var$queue;
        $828383bc888aa754$var$queue = [];
        while(++$828383bc888aa754$var$queueIndex < len)if ($828383bc888aa754$var$currentQueue) $828383bc888aa754$var$currentQueue[$828383bc888aa754$var$queueIndex].run();
        $828383bc888aa754$var$queueIndex = -1;
        len = $828383bc888aa754$var$queue.length;
    }
    $828383bc888aa754$var$currentQueue = null;
    $828383bc888aa754$var$draining = false;
    $828383bc888aa754$var$runClearTimeout(timeout);
}
$828383bc888aa754$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $828383bc888aa754$var$queue.push(new $828383bc888aa754$var$Item(fun, args));
    if ($828383bc888aa754$var$queue.length === 1 && !$828383bc888aa754$var$draining) $828383bc888aa754$var$runTimeout($828383bc888aa754$var$drainQueue);
};
// v8 likes predictible objects
function $828383bc888aa754$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$828383bc888aa754$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$828383bc888aa754$var$process.title = "browser";
$828383bc888aa754$var$process.browser = true;
$828383bc888aa754$var$process.env = {};
$828383bc888aa754$var$process.argv = [];
$828383bc888aa754$var$process.version = ""; // empty string to avoid regexp issues
$828383bc888aa754$var$process.versions = {};
function $828383bc888aa754$var$noop() {}
$828383bc888aa754$var$process.on = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.addListener = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.once = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.off = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.removeListener = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.removeAllListeners = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.emit = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.prependListener = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.prependOnceListener = $828383bc888aa754$var$noop;
$828383bc888aa754$var$process.listeners = function(name) {
    return [];
};
$828383bc888aa754$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$828383bc888aa754$var$process.cwd = function() {
    return "/";
};
$828383bc888aa754$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$828383bc888aa754$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("5y3eZ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $40a2a441cde599fe$export$ae55be85d98224ed; }, function (v) { return $40a2a441cde599fe$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $40a2a441cde599fe$export$d39a5bbd09211389; }, function (v) { return $40a2a441cde599fe$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $40a2a441cde599fe$export$882461b6382ed46c; }, function (v) { return $40a2a441cde599fe$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $40a2a441cde599fe$export$466bfc07425424d5; }, function (v) { return $40a2a441cde599fe$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $40a2a441cde599fe$export$cd75ccfd720a3cd4; }, function (v) { return $40a2a441cde599fe$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $40a2a441cde599fe$export$fa8d919ba61d84db; }, function (v) { return $40a2a441cde599fe$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $40a2a441cde599fe$export$757ceba2d55c277e; }, function (v) { return $40a2a441cde599fe$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $40a2a441cde599fe$export$b3890eb0ae9dca99; }, function (v) { return $40a2a441cde599fe$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $40a2a441cde599fe$export$502457920280e6be; }, function (v) { return $40a2a441cde599fe$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $40a2a441cde599fe$export$c78a37762a8d58e1; }, function (v) { return $40a2a441cde599fe$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $40a2a441cde599fe$export$dc54d992c10e8a18; }, function (v) { return $40a2a441cde599fe$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $40a2a441cde599fe$export$83d89fbfd8236492; }, function (v) { return $40a2a441cde599fe$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $40a2a441cde599fe$export$ae55be85d98224ed;
var $40a2a441cde599fe$export$d39a5bbd09211389;
var $40a2a441cde599fe$export$882461b6382ed46c;
var $40a2a441cde599fe$export$466bfc07425424d5;
var $40a2a441cde599fe$export$cd75ccfd720a3cd4;
var $40a2a441cde599fe$export$fa8d919ba61d84db;
var $40a2a441cde599fe$export$757ceba2d55c277e;
var $40a2a441cde599fe$export$b3890eb0ae9dca99;
var $40a2a441cde599fe$export$502457920280e6be;
var $40a2a441cde599fe$export$c78a37762a8d58e1;
var $40a2a441cde599fe$export$dc54d992c10e8a18;
var $40a2a441cde599fe$export$83d89fbfd8236492;
"use strict";

var $g5BLJ = parcelRequire("g5BLJ");

var $1gMSY = parcelRequire("1gMSY");
function $40a2a441cde599fe$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $40a2a441cde599fe$var$da = new Set, $40a2a441cde599fe$var$ea = {};
function $40a2a441cde599fe$var$fa(a, b) {
    $40a2a441cde599fe$var$ha(a, b);
    $40a2a441cde599fe$var$ha(a + "Capture", b);
}
function $40a2a441cde599fe$var$ha(a, b) {
    $40a2a441cde599fe$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$40a2a441cde599fe$var$da.add(b[a]);
}
var $40a2a441cde599fe$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $40a2a441cde599fe$var$ja = Object.prototype.hasOwnProperty, $40a2a441cde599fe$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $40a2a441cde599fe$var$la = {}, $40a2a441cde599fe$var$ma = {};
function $40a2a441cde599fe$var$oa(a) {
    if ($40a2a441cde599fe$var$ja.call($40a2a441cde599fe$var$ma, a)) return !0;
    if ($40a2a441cde599fe$var$ja.call($40a2a441cde599fe$var$la, a)) return !1;
    if ($40a2a441cde599fe$var$ka.test(a)) return $40a2a441cde599fe$var$ma[a] = !0;
    $40a2a441cde599fe$var$la[a] = !0;
    return !1;
}
function $40a2a441cde599fe$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $40a2a441cde599fe$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $40a2a441cde599fe$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $40a2a441cde599fe$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $40a2a441cde599fe$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $40a2a441cde599fe$var$z[b] = new $40a2a441cde599fe$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $40a2a441cde599fe$var$ra = /[\-:]([a-z])/g;
function $40a2a441cde599fe$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($40a2a441cde599fe$var$ra, $40a2a441cde599fe$var$sa);
    $40a2a441cde599fe$var$z[b] = new $40a2a441cde599fe$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($40a2a441cde599fe$var$ra, $40a2a441cde599fe$var$sa);
    $40a2a441cde599fe$var$z[b] = new $40a2a441cde599fe$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($40a2a441cde599fe$var$ra, $40a2a441cde599fe$var$sa);
    $40a2a441cde599fe$var$z[b] = new $40a2a441cde599fe$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$40a2a441cde599fe$var$z.xlinkHref = new $40a2a441cde599fe$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $40a2a441cde599fe$var$z[a] = new $40a2a441cde599fe$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $40a2a441cde599fe$var$ta(a, b, c, d) {
    var e = $40a2a441cde599fe$var$z.hasOwnProperty(b) ? $40a2a441cde599fe$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $40a2a441cde599fe$var$qa(b, c, e, d) && (c = null), d || null === e ? $40a2a441cde599fe$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $40a2a441cde599fe$var$ua = $g5BLJ.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $40a2a441cde599fe$var$va = Symbol.for("react.element"), $40a2a441cde599fe$var$wa = Symbol.for("react.portal"), $40a2a441cde599fe$var$ya = Symbol.for("react.fragment"), $40a2a441cde599fe$var$za = Symbol.for("react.strict_mode"), $40a2a441cde599fe$var$Aa = Symbol.for("react.profiler"), $40a2a441cde599fe$var$Ba = Symbol.for("react.provider"), $40a2a441cde599fe$var$Ca = Symbol.for("react.context"), $40a2a441cde599fe$var$Da = Symbol.for("react.forward_ref"), $40a2a441cde599fe$var$Ea = Symbol.for("react.suspense"), $40a2a441cde599fe$var$Fa = Symbol.for("react.suspense_list"), $40a2a441cde599fe$var$Ga = Symbol.for("react.memo"), $40a2a441cde599fe$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $40a2a441cde599fe$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $40a2a441cde599fe$var$Ja = Symbol.iterator;
function $40a2a441cde599fe$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $40a2a441cde599fe$var$Ja && a[$40a2a441cde599fe$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $40a2a441cde599fe$var$A = Object.assign, $40a2a441cde599fe$var$La;
function $40a2a441cde599fe$var$Ma(a) {
    if (void 0 === $40a2a441cde599fe$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $40a2a441cde599fe$var$La = b && b[1] || "";
    }
    return "\n" + $40a2a441cde599fe$var$La + a;
}
var $40a2a441cde599fe$var$Na = !1;
function $40a2a441cde599fe$var$Oa(a, b) {
    if (!a || $40a2a441cde599fe$var$Na) return "";
    $40a2a441cde599fe$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $40a2a441cde599fe$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $40a2a441cde599fe$var$Ma(a) : "";
}
function $40a2a441cde599fe$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $40a2a441cde599fe$var$Ma(a.type);
        case 16:
            return $40a2a441cde599fe$var$Ma("Lazy");
        case 13:
            return $40a2a441cde599fe$var$Ma("Suspense");
        case 19:
            return $40a2a441cde599fe$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $40a2a441cde599fe$var$Oa(a.type, !1), a;
        case 11:
            return a = $40a2a441cde599fe$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $40a2a441cde599fe$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $40a2a441cde599fe$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $40a2a441cde599fe$var$ya:
            return "Fragment";
        case $40a2a441cde599fe$var$wa:
            return "Portal";
        case $40a2a441cde599fe$var$Aa:
            return "Profiler";
        case $40a2a441cde599fe$var$za:
            return "StrictMode";
        case $40a2a441cde599fe$var$Ea:
            return "Suspense";
        case $40a2a441cde599fe$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $40a2a441cde599fe$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $40a2a441cde599fe$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $40a2a441cde599fe$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $40a2a441cde599fe$var$Ga:
            return b = a.displayName || null, null !== b ? b : $40a2a441cde599fe$var$Qa(a.type) || "Memo";
        case $40a2a441cde599fe$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $40a2a441cde599fe$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $40a2a441cde599fe$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $40a2a441cde599fe$var$Qa(b);
        case 8:
            return b === $40a2a441cde599fe$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $40a2a441cde599fe$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $40a2a441cde599fe$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $40a2a441cde599fe$var$Ua(a) {
    var b = $40a2a441cde599fe$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $40a2a441cde599fe$var$Va(a) {
    a._valueTracker || (a._valueTracker = $40a2a441cde599fe$var$Ua(a));
}
function $40a2a441cde599fe$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $40a2a441cde599fe$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $40a2a441cde599fe$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $40a2a441cde599fe$var$Ya(a, b) {
    var c = b.checked;
    return $40a2a441cde599fe$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $40a2a441cde599fe$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $40a2a441cde599fe$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $40a2a441cde599fe$var$ab(a, b) {
    b = b.checked;
    null != b && $40a2a441cde599fe$var$ta(a, "checked", b, !1);
}
function $40a2a441cde599fe$var$bb(a, b) {
    $40a2a441cde599fe$var$ab(a, b);
    var c = $40a2a441cde599fe$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $40a2a441cde599fe$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $40a2a441cde599fe$var$cb(a, b.type, $40a2a441cde599fe$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $40a2a441cde599fe$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $40a2a441cde599fe$var$cb(a, b, c) {
    if ("number" !== b || $40a2a441cde599fe$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $40a2a441cde599fe$var$eb = Array.isArray;
function $40a2a441cde599fe$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $40a2a441cde599fe$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $40a2a441cde599fe$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($40a2a441cde599fe$var$p(91));
    return $40a2a441cde599fe$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $40a2a441cde599fe$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($40a2a441cde599fe$var$p(92));
            if ($40a2a441cde599fe$var$eb(c)) {
                if (1 < c.length) throw Error($40a2a441cde599fe$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $40a2a441cde599fe$var$Sa(c)
    };
}
function $40a2a441cde599fe$var$ib(a, b) {
    var c = $40a2a441cde599fe$var$Sa(b.value), d = $40a2a441cde599fe$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $40a2a441cde599fe$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $40a2a441cde599fe$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $40a2a441cde599fe$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $40a2a441cde599fe$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $40a2a441cde599fe$var$mb, $40a2a441cde599fe$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $40a2a441cde599fe$var$mb = $40a2a441cde599fe$var$mb || document.createElement("div");
        $40a2a441cde599fe$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $40a2a441cde599fe$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $40a2a441cde599fe$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $40a2a441cde599fe$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $40a2a441cde599fe$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($40a2a441cde599fe$var$pb).forEach(function(a) {
    $40a2a441cde599fe$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $40a2a441cde599fe$var$pb[b] = $40a2a441cde599fe$var$pb[a];
    });
});
function $40a2a441cde599fe$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $40a2a441cde599fe$var$pb.hasOwnProperty(a) && $40a2a441cde599fe$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $40a2a441cde599fe$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $40a2a441cde599fe$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $40a2a441cde599fe$var$tb = $40a2a441cde599fe$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $40a2a441cde599fe$var$ub(a, b) {
    if (b) {
        if ($40a2a441cde599fe$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($40a2a441cde599fe$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($40a2a441cde599fe$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($40a2a441cde599fe$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($40a2a441cde599fe$var$p(62));
    }
}
function $40a2a441cde599fe$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $40a2a441cde599fe$var$wb = null;
function $40a2a441cde599fe$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $40a2a441cde599fe$var$yb = null, $40a2a441cde599fe$var$zb = null, $40a2a441cde599fe$var$Ab = null;
function $40a2a441cde599fe$var$Bb(a) {
    if (a = $40a2a441cde599fe$var$Cb(a)) {
        if ("function" !== typeof $40a2a441cde599fe$var$yb) throw Error($40a2a441cde599fe$var$p(280));
        var b = a.stateNode;
        b && (b = $40a2a441cde599fe$var$Db(b), $40a2a441cde599fe$var$yb(a.stateNode, a.type, b));
    }
}
function $40a2a441cde599fe$var$Eb(a) {
    $40a2a441cde599fe$var$zb ? $40a2a441cde599fe$var$Ab ? $40a2a441cde599fe$var$Ab.push(a) : $40a2a441cde599fe$var$Ab = [
        a
    ] : $40a2a441cde599fe$var$zb = a;
}
function $40a2a441cde599fe$var$Fb() {
    if ($40a2a441cde599fe$var$zb) {
        var a = $40a2a441cde599fe$var$zb, b = $40a2a441cde599fe$var$Ab;
        $40a2a441cde599fe$var$Ab = $40a2a441cde599fe$var$zb = null;
        $40a2a441cde599fe$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$40a2a441cde599fe$var$Bb(b[a]);
    }
}
function $40a2a441cde599fe$var$Gb(a, b) {
    return a(b);
}
function $40a2a441cde599fe$var$Hb() {}
var $40a2a441cde599fe$var$Ib = !1;
function $40a2a441cde599fe$var$Jb(a, b, c) {
    if ($40a2a441cde599fe$var$Ib) return a(b, c);
    $40a2a441cde599fe$var$Ib = !0;
    try {
        return $40a2a441cde599fe$var$Gb(a, b, c);
    } finally{
        if ($40a2a441cde599fe$var$Ib = !1, null !== $40a2a441cde599fe$var$zb || null !== $40a2a441cde599fe$var$Ab) $40a2a441cde599fe$var$Hb(), $40a2a441cde599fe$var$Fb();
    }
}
function $40a2a441cde599fe$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $40a2a441cde599fe$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($40a2a441cde599fe$var$p(231, b, typeof c));
    return c;
}
var $40a2a441cde599fe$var$Lb = !1;
if ($40a2a441cde599fe$var$ia) try {
    var $40a2a441cde599fe$var$Mb = {};
    Object.defineProperty($40a2a441cde599fe$var$Mb, "passive", {
        get: function() {
            $40a2a441cde599fe$var$Lb = !0;
        }
    });
    window.addEventListener("test", $40a2a441cde599fe$var$Mb, $40a2a441cde599fe$var$Mb);
    window.removeEventListener("test", $40a2a441cde599fe$var$Mb, $40a2a441cde599fe$var$Mb);
} catch (a) {
    $40a2a441cde599fe$var$Lb = !1;
}
function $40a2a441cde599fe$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $40a2a441cde599fe$var$Ob = !1, $40a2a441cde599fe$var$Pb = null, $40a2a441cde599fe$var$Qb = !1, $40a2a441cde599fe$var$Rb = null, $40a2a441cde599fe$var$Sb = {
    onError: function(a) {
        $40a2a441cde599fe$var$Ob = !0;
        $40a2a441cde599fe$var$Pb = a;
    }
};
function $40a2a441cde599fe$var$Tb(a, b, c, d, e, f, g, h, k) {
    $40a2a441cde599fe$var$Ob = !1;
    $40a2a441cde599fe$var$Pb = null;
    $40a2a441cde599fe$var$Nb.apply($40a2a441cde599fe$var$Sb, arguments);
}
function $40a2a441cde599fe$var$Ub(a, b, c, d, e, f, g, h, k) {
    $40a2a441cde599fe$var$Tb.apply(this, arguments);
    if ($40a2a441cde599fe$var$Ob) {
        if ($40a2a441cde599fe$var$Ob) {
            var l = $40a2a441cde599fe$var$Pb;
            $40a2a441cde599fe$var$Ob = !1;
            $40a2a441cde599fe$var$Pb = null;
        } else throw Error($40a2a441cde599fe$var$p(198));
        $40a2a441cde599fe$var$Qb || ($40a2a441cde599fe$var$Qb = !0, $40a2a441cde599fe$var$Rb = l);
    }
}
function $40a2a441cde599fe$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $40a2a441cde599fe$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $40a2a441cde599fe$var$Xb(a) {
    if ($40a2a441cde599fe$var$Vb(a) !== a) throw Error($40a2a441cde599fe$var$p(188));
}
function $40a2a441cde599fe$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $40a2a441cde599fe$var$Vb(a);
        if (null === b) throw Error($40a2a441cde599fe$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $40a2a441cde599fe$var$Xb(e), a;
                if (f === d) return $40a2a441cde599fe$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($40a2a441cde599fe$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($40a2a441cde599fe$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($40a2a441cde599fe$var$p(190));
    }
    if (3 !== c.tag) throw Error($40a2a441cde599fe$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $40a2a441cde599fe$var$Zb(a) {
    a = $40a2a441cde599fe$var$Yb(a);
    return null !== a ? $40a2a441cde599fe$var$$b(a) : null;
}
function $40a2a441cde599fe$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $40a2a441cde599fe$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $40a2a441cde599fe$var$ac = $1gMSY.unstable_scheduleCallback, $40a2a441cde599fe$var$bc = $1gMSY.unstable_cancelCallback, $40a2a441cde599fe$var$cc = $1gMSY.unstable_shouldYield, $40a2a441cde599fe$var$dc = $1gMSY.unstable_requestPaint, $40a2a441cde599fe$var$B = $1gMSY.unstable_now, $40a2a441cde599fe$var$ec = $1gMSY.unstable_getCurrentPriorityLevel, $40a2a441cde599fe$var$fc = $1gMSY.unstable_ImmediatePriority, $40a2a441cde599fe$var$gc = $1gMSY.unstable_UserBlockingPriority, $40a2a441cde599fe$var$hc = $1gMSY.unstable_NormalPriority, $40a2a441cde599fe$var$ic = $1gMSY.unstable_LowPriority, $40a2a441cde599fe$var$jc = $1gMSY.unstable_IdlePriority, $40a2a441cde599fe$var$kc = null, $40a2a441cde599fe$var$lc = null;
function $40a2a441cde599fe$var$mc(a) {
    if ($40a2a441cde599fe$var$lc && "function" === typeof $40a2a441cde599fe$var$lc.onCommitFiberRoot) try {
        $40a2a441cde599fe$var$lc.onCommitFiberRoot($40a2a441cde599fe$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $40a2a441cde599fe$var$oc = Math.clz32 ? Math.clz32 : $40a2a441cde599fe$var$nc, $40a2a441cde599fe$var$pc = Math.log, $40a2a441cde599fe$var$qc = Math.LN2;
function $40a2a441cde599fe$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($40a2a441cde599fe$var$pc(a) / $40a2a441cde599fe$var$qc | 0) | 0;
}
var $40a2a441cde599fe$var$rc = 64, $40a2a441cde599fe$var$sc = 4194304;
function $40a2a441cde599fe$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $40a2a441cde599fe$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $40a2a441cde599fe$var$tc(h) : (f &= g, 0 !== f && (d = $40a2a441cde599fe$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $40a2a441cde599fe$var$tc(g) : 0 !== f && (d = $40a2a441cde599fe$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $40a2a441cde599fe$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $40a2a441cde599fe$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $40a2a441cde599fe$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $40a2a441cde599fe$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $40a2a441cde599fe$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $40a2a441cde599fe$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $40a2a441cde599fe$var$yc() {
    var a = $40a2a441cde599fe$var$rc;
    $40a2a441cde599fe$var$rc <<= 1;
    0 === ($40a2a441cde599fe$var$rc & 4194240) && ($40a2a441cde599fe$var$rc = 64);
    return a;
}
function $40a2a441cde599fe$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $40a2a441cde599fe$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $40a2a441cde599fe$var$oc(b);
    a[b] = c;
}
function $40a2a441cde599fe$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $40a2a441cde599fe$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $40a2a441cde599fe$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $40a2a441cde599fe$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $40a2a441cde599fe$var$C = 0;
function $40a2a441cde599fe$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $40a2a441cde599fe$var$Ec, $40a2a441cde599fe$var$Fc, $40a2a441cde599fe$var$Gc, $40a2a441cde599fe$var$Hc, $40a2a441cde599fe$var$Ic, $40a2a441cde599fe$var$Jc = !1, $40a2a441cde599fe$var$Kc = [], $40a2a441cde599fe$var$Lc = null, $40a2a441cde599fe$var$Mc = null, $40a2a441cde599fe$var$Nc = null, $40a2a441cde599fe$var$Oc = new Map, $40a2a441cde599fe$var$Pc = new Map, $40a2a441cde599fe$var$Qc = [], $40a2a441cde599fe$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $40a2a441cde599fe$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $40a2a441cde599fe$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $40a2a441cde599fe$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $40a2a441cde599fe$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $40a2a441cde599fe$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $40a2a441cde599fe$var$Pc.delete(b.pointerId);
    }
}
function $40a2a441cde599fe$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $40a2a441cde599fe$var$Cb(b), null !== b && $40a2a441cde599fe$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $40a2a441cde599fe$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $40a2a441cde599fe$var$Lc = $40a2a441cde599fe$var$Tc($40a2a441cde599fe$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $40a2a441cde599fe$var$Mc = $40a2a441cde599fe$var$Tc($40a2a441cde599fe$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $40a2a441cde599fe$var$Nc = $40a2a441cde599fe$var$Tc($40a2a441cde599fe$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $40a2a441cde599fe$var$Oc.set(f, $40a2a441cde599fe$var$Tc($40a2a441cde599fe$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $40a2a441cde599fe$var$Pc.set(f, $40a2a441cde599fe$var$Tc($40a2a441cde599fe$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $40a2a441cde599fe$var$Vc(a) {
    var b = $40a2a441cde599fe$var$Wc(a.target);
    if (null !== b) {
        var c = $40a2a441cde599fe$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $40a2a441cde599fe$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $40a2a441cde599fe$var$Ic(a.priority, function() {
                        $40a2a441cde599fe$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $40a2a441cde599fe$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $40a2a441cde599fe$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $40a2a441cde599fe$var$wb = d;
            c.target.dispatchEvent(d);
            $40a2a441cde599fe$var$wb = null;
        } else return b = $40a2a441cde599fe$var$Cb(c), null !== b && $40a2a441cde599fe$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $40a2a441cde599fe$var$Zc(a, b, c) {
    $40a2a441cde599fe$var$Xc(a) && c.delete(b);
}
function $40a2a441cde599fe$var$$c() {
    $40a2a441cde599fe$var$Jc = !1;
    null !== $40a2a441cde599fe$var$Lc && $40a2a441cde599fe$var$Xc($40a2a441cde599fe$var$Lc) && ($40a2a441cde599fe$var$Lc = null);
    null !== $40a2a441cde599fe$var$Mc && $40a2a441cde599fe$var$Xc($40a2a441cde599fe$var$Mc) && ($40a2a441cde599fe$var$Mc = null);
    null !== $40a2a441cde599fe$var$Nc && $40a2a441cde599fe$var$Xc($40a2a441cde599fe$var$Nc) && ($40a2a441cde599fe$var$Nc = null);
    $40a2a441cde599fe$var$Oc.forEach($40a2a441cde599fe$var$Zc);
    $40a2a441cde599fe$var$Pc.forEach($40a2a441cde599fe$var$Zc);
}
function $40a2a441cde599fe$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $40a2a441cde599fe$var$Jc || ($40a2a441cde599fe$var$Jc = !0, $1gMSY.unstable_scheduleCallback($1gMSY.unstable_NormalPriority, $40a2a441cde599fe$var$$c)));
}
function $40a2a441cde599fe$var$bd(a) {
    function b(b) {
        return $40a2a441cde599fe$var$ad(b, a);
    }
    if (0 < $40a2a441cde599fe$var$Kc.length) {
        $40a2a441cde599fe$var$ad($40a2a441cde599fe$var$Kc[0], a);
        for(var c = 1; c < $40a2a441cde599fe$var$Kc.length; c++){
            var d = $40a2a441cde599fe$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $40a2a441cde599fe$var$Lc && $40a2a441cde599fe$var$ad($40a2a441cde599fe$var$Lc, a);
    null !== $40a2a441cde599fe$var$Mc && $40a2a441cde599fe$var$ad($40a2a441cde599fe$var$Mc, a);
    null !== $40a2a441cde599fe$var$Nc && $40a2a441cde599fe$var$ad($40a2a441cde599fe$var$Nc, a);
    $40a2a441cde599fe$var$Oc.forEach(b);
    $40a2a441cde599fe$var$Pc.forEach(b);
    for(c = 0; c < $40a2a441cde599fe$var$Qc.length; c++)d = $40a2a441cde599fe$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $40a2a441cde599fe$var$Qc.length && (c = $40a2a441cde599fe$var$Qc[0], null === c.blockedOn);)$40a2a441cde599fe$var$Vc(c), null === c.blockedOn && $40a2a441cde599fe$var$Qc.shift();
}
var $40a2a441cde599fe$var$cd = $40a2a441cde599fe$var$ua.ReactCurrentBatchConfig, $40a2a441cde599fe$var$dd = !0;
function $40a2a441cde599fe$var$ed(a, b, c, d) {
    var e = $40a2a441cde599fe$var$C, f = $40a2a441cde599fe$var$cd.transition;
    $40a2a441cde599fe$var$cd.transition = null;
    try {
        $40a2a441cde599fe$var$C = 1, $40a2a441cde599fe$var$fd(a, b, c, d);
    } finally{
        $40a2a441cde599fe$var$C = e, $40a2a441cde599fe$var$cd.transition = f;
    }
}
function $40a2a441cde599fe$var$gd(a, b, c, d) {
    var e = $40a2a441cde599fe$var$C, f = $40a2a441cde599fe$var$cd.transition;
    $40a2a441cde599fe$var$cd.transition = null;
    try {
        $40a2a441cde599fe$var$C = 4, $40a2a441cde599fe$var$fd(a, b, c, d);
    } finally{
        $40a2a441cde599fe$var$C = e, $40a2a441cde599fe$var$cd.transition = f;
    }
}
function $40a2a441cde599fe$var$fd(a, b, c, d) {
    if ($40a2a441cde599fe$var$dd) {
        var e = $40a2a441cde599fe$var$Yc(a, b, c, d);
        if (null === e) $40a2a441cde599fe$var$hd(a, b, d, $40a2a441cde599fe$var$id, c), $40a2a441cde599fe$var$Sc(a, d);
        else if ($40a2a441cde599fe$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($40a2a441cde599fe$var$Sc(a, d), b & 4 && -1 < $40a2a441cde599fe$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $40a2a441cde599fe$var$Cb(e);
                null !== f && $40a2a441cde599fe$var$Ec(f);
                f = $40a2a441cde599fe$var$Yc(a, b, c, d);
                null === f && $40a2a441cde599fe$var$hd(a, b, d, $40a2a441cde599fe$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $40a2a441cde599fe$var$hd(a, b, d, null, c);
    }
}
var $40a2a441cde599fe$var$id = null;
function $40a2a441cde599fe$var$Yc(a, b, c, d) {
    $40a2a441cde599fe$var$id = null;
    a = $40a2a441cde599fe$var$xb(d);
    a = $40a2a441cde599fe$var$Wc(a);
    if (null !== a) {
        if (b = $40a2a441cde599fe$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $40a2a441cde599fe$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $40a2a441cde599fe$var$id = a;
    return null;
}
function $40a2a441cde599fe$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($40a2a441cde599fe$var$ec()){
                case $40a2a441cde599fe$var$fc:
                    return 1;
                case $40a2a441cde599fe$var$gc:
                    return 4;
                case $40a2a441cde599fe$var$hc:
                case $40a2a441cde599fe$var$ic:
                    return 16;
                case $40a2a441cde599fe$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $40a2a441cde599fe$var$kd = null, $40a2a441cde599fe$var$ld = null, $40a2a441cde599fe$var$md = null;
function $40a2a441cde599fe$var$nd() {
    if ($40a2a441cde599fe$var$md) return $40a2a441cde599fe$var$md;
    var a, b = $40a2a441cde599fe$var$ld, c = b.length, d, e = "value" in $40a2a441cde599fe$var$kd ? $40a2a441cde599fe$var$kd.value : $40a2a441cde599fe$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $40a2a441cde599fe$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $40a2a441cde599fe$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $40a2a441cde599fe$var$pd() {
    return !0;
}
function $40a2a441cde599fe$var$qd() {
    return !1;
}
function $40a2a441cde599fe$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $40a2a441cde599fe$var$pd : $40a2a441cde599fe$var$qd;
        this.isPropagationStopped = $40a2a441cde599fe$var$qd;
        return this;
    }
    $40a2a441cde599fe$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $40a2a441cde599fe$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $40a2a441cde599fe$var$pd);
        },
        persist: function() {},
        isPersistent: $40a2a441cde599fe$var$pd
    });
    return b;
}
var $40a2a441cde599fe$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $40a2a441cde599fe$var$td = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$sd), $40a2a441cde599fe$var$ud = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$sd, {
    view: 0,
    detail: 0
}), $40a2a441cde599fe$var$vd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$ud), $40a2a441cde599fe$var$wd, $40a2a441cde599fe$var$xd, $40a2a441cde599fe$var$yd, $40a2a441cde599fe$var$Ad = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $40a2a441cde599fe$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $40a2a441cde599fe$var$yd && ($40a2a441cde599fe$var$yd && "mousemove" === a.type ? ($40a2a441cde599fe$var$wd = a.screenX - $40a2a441cde599fe$var$yd.screenX, $40a2a441cde599fe$var$xd = a.screenY - $40a2a441cde599fe$var$yd.screenY) : $40a2a441cde599fe$var$xd = $40a2a441cde599fe$var$wd = 0, $40a2a441cde599fe$var$yd = a);
        return $40a2a441cde599fe$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $40a2a441cde599fe$var$xd;
    }
}), $40a2a441cde599fe$var$Bd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Ad), $40a2a441cde599fe$var$Cd = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$Ad, {
    dataTransfer: 0
}), $40a2a441cde599fe$var$Dd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Cd), $40a2a441cde599fe$var$Ed = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$ud, {
    relatedTarget: 0
}), $40a2a441cde599fe$var$Fd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Ed), $40a2a441cde599fe$var$Gd = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $40a2a441cde599fe$var$Hd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Gd), $40a2a441cde599fe$var$Id = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $40a2a441cde599fe$var$Jd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Id), $40a2a441cde599fe$var$Kd = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$sd, {
    data: 0
}), $40a2a441cde599fe$var$Ld = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Kd), $40a2a441cde599fe$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $40a2a441cde599fe$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $40a2a441cde599fe$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $40a2a441cde599fe$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $40a2a441cde599fe$var$Od[a]) ? !!b[a] : !1;
}
function $40a2a441cde599fe$var$zd() {
    return $40a2a441cde599fe$var$Pd;
}
var $40a2a441cde599fe$var$Qd = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $40a2a441cde599fe$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $40a2a441cde599fe$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $40a2a441cde599fe$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $40a2a441cde599fe$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $40a2a441cde599fe$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $40a2a441cde599fe$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $40a2a441cde599fe$var$Rd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Qd), $40a2a441cde599fe$var$Sd = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $40a2a441cde599fe$var$Td = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Sd), $40a2a441cde599fe$var$Ud = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $40a2a441cde599fe$var$zd
}), $40a2a441cde599fe$var$Vd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Ud), $40a2a441cde599fe$var$Wd = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $40a2a441cde599fe$var$Xd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Wd), $40a2a441cde599fe$var$Yd = $40a2a441cde599fe$var$A({}, $40a2a441cde599fe$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $40a2a441cde599fe$var$Zd = $40a2a441cde599fe$var$rd($40a2a441cde599fe$var$Yd), $40a2a441cde599fe$var$$d = [
    9,
    13,
    27,
    32
], $40a2a441cde599fe$var$ae = $40a2a441cde599fe$var$ia && "CompositionEvent" in window, $40a2a441cde599fe$var$be = null;
$40a2a441cde599fe$var$ia && "documentMode" in document && ($40a2a441cde599fe$var$be = document.documentMode);
var $40a2a441cde599fe$var$ce = $40a2a441cde599fe$var$ia && "TextEvent" in window && !$40a2a441cde599fe$var$be, $40a2a441cde599fe$var$de = $40a2a441cde599fe$var$ia && (!$40a2a441cde599fe$var$ae || $40a2a441cde599fe$var$be && 8 < $40a2a441cde599fe$var$be && 11 >= $40a2a441cde599fe$var$be), $40a2a441cde599fe$var$ee = String.fromCharCode(32), $40a2a441cde599fe$var$fe = !1;
function $40a2a441cde599fe$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $40a2a441cde599fe$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $40a2a441cde599fe$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $40a2a441cde599fe$var$ie = !1;
function $40a2a441cde599fe$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $40a2a441cde599fe$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $40a2a441cde599fe$var$fe = !0;
            return $40a2a441cde599fe$var$ee;
        case "textInput":
            return a = b.data, a === $40a2a441cde599fe$var$ee && $40a2a441cde599fe$var$fe ? null : a;
        default:
            return null;
    }
}
function $40a2a441cde599fe$var$ke(a, b) {
    if ($40a2a441cde599fe$var$ie) return "compositionend" === a || !$40a2a441cde599fe$var$ae && $40a2a441cde599fe$var$ge(a, b) ? (a = $40a2a441cde599fe$var$nd(), $40a2a441cde599fe$var$md = $40a2a441cde599fe$var$ld = $40a2a441cde599fe$var$kd = null, $40a2a441cde599fe$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $40a2a441cde599fe$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $40a2a441cde599fe$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $40a2a441cde599fe$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$40a2a441cde599fe$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $40a2a441cde599fe$var$ne(a, b, c, d) {
    $40a2a441cde599fe$var$Eb(d);
    b = $40a2a441cde599fe$var$oe(b, "onChange");
    0 < b.length && (c = new $40a2a441cde599fe$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $40a2a441cde599fe$var$pe = null, $40a2a441cde599fe$var$qe = null;
function $40a2a441cde599fe$var$re(a) {
    $40a2a441cde599fe$var$se(a, 0);
}
function $40a2a441cde599fe$var$te(a) {
    var b = $40a2a441cde599fe$var$ue(a);
    if ($40a2a441cde599fe$var$Wa(b)) return a;
}
function $40a2a441cde599fe$var$ve(a, b) {
    if ("change" === a) return b;
}
var $40a2a441cde599fe$var$we = !1;
if ($40a2a441cde599fe$var$ia) {
    var $40a2a441cde599fe$var$xe;
    if ($40a2a441cde599fe$var$ia) {
        var $40a2a441cde599fe$var$ye = "oninput" in document;
        if (!$40a2a441cde599fe$var$ye) {
            var $40a2a441cde599fe$var$ze = document.createElement("div");
            $40a2a441cde599fe$var$ze.setAttribute("oninput", "return;");
            $40a2a441cde599fe$var$ye = "function" === typeof $40a2a441cde599fe$var$ze.oninput;
        }
        $40a2a441cde599fe$var$xe = $40a2a441cde599fe$var$ye;
    } else $40a2a441cde599fe$var$xe = !1;
    $40a2a441cde599fe$var$we = $40a2a441cde599fe$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $40a2a441cde599fe$var$Ae() {
    $40a2a441cde599fe$var$pe && ($40a2a441cde599fe$var$pe.detachEvent("onpropertychange", $40a2a441cde599fe$var$Be), $40a2a441cde599fe$var$qe = $40a2a441cde599fe$var$pe = null);
}
function $40a2a441cde599fe$var$Be(a) {
    if ("value" === a.propertyName && $40a2a441cde599fe$var$te($40a2a441cde599fe$var$qe)) {
        var b = [];
        $40a2a441cde599fe$var$ne(b, $40a2a441cde599fe$var$qe, a, $40a2a441cde599fe$var$xb(a));
        $40a2a441cde599fe$var$Jb($40a2a441cde599fe$var$re, b);
    }
}
function $40a2a441cde599fe$var$Ce(a, b, c) {
    "focusin" === a ? ($40a2a441cde599fe$var$Ae(), $40a2a441cde599fe$var$pe = b, $40a2a441cde599fe$var$qe = c, $40a2a441cde599fe$var$pe.attachEvent("onpropertychange", $40a2a441cde599fe$var$Be)) : "focusout" === a && $40a2a441cde599fe$var$Ae();
}
function $40a2a441cde599fe$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $40a2a441cde599fe$var$te($40a2a441cde599fe$var$qe);
}
function $40a2a441cde599fe$var$Ee(a, b) {
    if ("click" === a) return $40a2a441cde599fe$var$te(b);
}
function $40a2a441cde599fe$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $40a2a441cde599fe$var$te(b);
}
function $40a2a441cde599fe$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $40a2a441cde599fe$var$He = "function" === typeof Object.is ? Object.is : $40a2a441cde599fe$var$Ge;
function $40a2a441cde599fe$var$Ie(a, b) {
    if ($40a2a441cde599fe$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$40a2a441cde599fe$var$ja.call(b, e) || !$40a2a441cde599fe$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $40a2a441cde599fe$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $40a2a441cde599fe$var$Ke(a, b) {
    var c = $40a2a441cde599fe$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $40a2a441cde599fe$var$Je(c);
    }
}
function $40a2a441cde599fe$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $40a2a441cde599fe$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $40a2a441cde599fe$var$Me() {
    for(var a = window, b = $40a2a441cde599fe$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $40a2a441cde599fe$var$Xa(a.document);
    }
    return b;
}
function $40a2a441cde599fe$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $40a2a441cde599fe$var$Oe(a) {
    var b = $40a2a441cde599fe$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $40a2a441cde599fe$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $40a2a441cde599fe$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $40a2a441cde599fe$var$Ke(c, f);
                var g = $40a2a441cde599fe$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $40a2a441cde599fe$var$Pe = $40a2a441cde599fe$var$ia && "documentMode" in document && 11 >= document.documentMode, $40a2a441cde599fe$var$Qe = null, $40a2a441cde599fe$var$Re = null, $40a2a441cde599fe$var$Se = null, $40a2a441cde599fe$var$Te = !1;
function $40a2a441cde599fe$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $40a2a441cde599fe$var$Te || null == $40a2a441cde599fe$var$Qe || $40a2a441cde599fe$var$Qe !== $40a2a441cde599fe$var$Xa(d) || (d = $40a2a441cde599fe$var$Qe, "selectionStart" in d && $40a2a441cde599fe$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $40a2a441cde599fe$var$Se && $40a2a441cde599fe$var$Ie($40a2a441cde599fe$var$Se, d) || ($40a2a441cde599fe$var$Se = d, d = $40a2a441cde599fe$var$oe($40a2a441cde599fe$var$Re, "onSelect"), 0 < d.length && (b = new $40a2a441cde599fe$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $40a2a441cde599fe$var$Qe)));
}
function $40a2a441cde599fe$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $40a2a441cde599fe$var$We = {
    animationend: $40a2a441cde599fe$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $40a2a441cde599fe$var$Ve("Animation", "AnimationIteration"),
    animationstart: $40a2a441cde599fe$var$Ve("Animation", "AnimationStart"),
    transitionend: $40a2a441cde599fe$var$Ve("Transition", "TransitionEnd")
}, $40a2a441cde599fe$var$Xe = {}, $40a2a441cde599fe$var$Ye = {};
$40a2a441cde599fe$var$ia && ($40a2a441cde599fe$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $40a2a441cde599fe$var$We.animationend.animation, delete $40a2a441cde599fe$var$We.animationiteration.animation, delete $40a2a441cde599fe$var$We.animationstart.animation), "TransitionEvent" in window || delete $40a2a441cde599fe$var$We.transitionend.transition);
function $40a2a441cde599fe$var$Ze(a) {
    if ($40a2a441cde599fe$var$Xe[a]) return $40a2a441cde599fe$var$Xe[a];
    if (!$40a2a441cde599fe$var$We[a]) return a;
    var b = $40a2a441cde599fe$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $40a2a441cde599fe$var$Ye) return $40a2a441cde599fe$var$Xe[a] = b[c];
    return a;
}
var $40a2a441cde599fe$var$$e = $40a2a441cde599fe$var$Ze("animationend"), $40a2a441cde599fe$var$af = $40a2a441cde599fe$var$Ze("animationiteration"), $40a2a441cde599fe$var$bf = $40a2a441cde599fe$var$Ze("animationstart"), $40a2a441cde599fe$var$cf = $40a2a441cde599fe$var$Ze("transitionend"), $40a2a441cde599fe$var$df = new Map, $40a2a441cde599fe$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $40a2a441cde599fe$var$ff(a, b) {
    $40a2a441cde599fe$var$df.set(a, b);
    $40a2a441cde599fe$var$fa(b, [
        a
    ]);
}
for(var $40a2a441cde599fe$var$gf = 0; $40a2a441cde599fe$var$gf < $40a2a441cde599fe$var$ef.length; $40a2a441cde599fe$var$gf++){
    var $40a2a441cde599fe$var$hf = $40a2a441cde599fe$var$ef[$40a2a441cde599fe$var$gf], $40a2a441cde599fe$var$jf = $40a2a441cde599fe$var$hf.toLowerCase(), $40a2a441cde599fe$var$kf = $40a2a441cde599fe$var$hf[0].toUpperCase() + $40a2a441cde599fe$var$hf.slice(1);
    $40a2a441cde599fe$var$ff($40a2a441cde599fe$var$jf, "on" + $40a2a441cde599fe$var$kf);
}
$40a2a441cde599fe$var$ff($40a2a441cde599fe$var$$e, "onAnimationEnd");
$40a2a441cde599fe$var$ff($40a2a441cde599fe$var$af, "onAnimationIteration");
$40a2a441cde599fe$var$ff($40a2a441cde599fe$var$bf, "onAnimationStart");
$40a2a441cde599fe$var$ff("dblclick", "onDoubleClick");
$40a2a441cde599fe$var$ff("focusin", "onFocus");
$40a2a441cde599fe$var$ff("focusout", "onBlur");
$40a2a441cde599fe$var$ff($40a2a441cde599fe$var$cf, "onTransitionEnd");
$40a2a441cde599fe$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$40a2a441cde599fe$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$40a2a441cde599fe$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$40a2a441cde599fe$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$40a2a441cde599fe$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$40a2a441cde599fe$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$40a2a441cde599fe$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$40a2a441cde599fe$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$40a2a441cde599fe$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$40a2a441cde599fe$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $40a2a441cde599fe$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $40a2a441cde599fe$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($40a2a441cde599fe$var$lf));
function $40a2a441cde599fe$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $40a2a441cde599fe$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $40a2a441cde599fe$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $40a2a441cde599fe$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $40a2a441cde599fe$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($40a2a441cde599fe$var$Qb) throw a = $40a2a441cde599fe$var$Rb, $40a2a441cde599fe$var$Qb = !1, $40a2a441cde599fe$var$Rb = null, a;
}
function $40a2a441cde599fe$var$D(a, b) {
    var c = b[$40a2a441cde599fe$var$of];
    void 0 === c && (c = b[$40a2a441cde599fe$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($40a2a441cde599fe$var$pf(b, a, 2, !1), c.add(d));
}
function $40a2a441cde599fe$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $40a2a441cde599fe$var$pf(c, a, d, b);
}
var $40a2a441cde599fe$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $40a2a441cde599fe$var$sf(a) {
    if (!a[$40a2a441cde599fe$var$rf]) {
        a[$40a2a441cde599fe$var$rf] = !0;
        $40a2a441cde599fe$var$da.forEach(function(b) {
            "selectionchange" !== b && ($40a2a441cde599fe$var$mf.has(b) || $40a2a441cde599fe$var$qf(b, !1, a), $40a2a441cde599fe$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$40a2a441cde599fe$var$rf] || (b[$40a2a441cde599fe$var$rf] = !0, $40a2a441cde599fe$var$qf("selectionchange", !1, b));
    }
}
function $40a2a441cde599fe$var$pf(a, b, c, d) {
    switch($40a2a441cde599fe$var$jd(b)){
        case 1:
            var e = $40a2a441cde599fe$var$ed;
            break;
        case 4:
            e = $40a2a441cde599fe$var$gd;
            break;
        default:
            e = $40a2a441cde599fe$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$40a2a441cde599fe$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $40a2a441cde599fe$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $40a2a441cde599fe$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $40a2a441cde599fe$var$Jb(function() {
        var d = f, e = $40a2a441cde599fe$var$xb(c), g = [];
        a: {
            var h = $40a2a441cde599fe$var$df.get(a);
            if (void 0 !== h) {
                var k = $40a2a441cde599fe$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $40a2a441cde599fe$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $40a2a441cde599fe$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $40a2a441cde599fe$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $40a2a441cde599fe$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $40a2a441cde599fe$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $40a2a441cde599fe$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $40a2a441cde599fe$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $40a2a441cde599fe$var$Vd;
                        break;
                    case $40a2a441cde599fe$var$$e:
                    case $40a2a441cde599fe$var$af:
                    case $40a2a441cde599fe$var$bf:
                        k = $40a2a441cde599fe$var$Hd;
                        break;
                    case $40a2a441cde599fe$var$cf:
                        k = $40a2a441cde599fe$var$Xd;
                        break;
                    case "scroll":
                        k = $40a2a441cde599fe$var$vd;
                        break;
                    case "wheel":
                        k = $40a2a441cde599fe$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $40a2a441cde599fe$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $40a2a441cde599fe$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $40a2a441cde599fe$var$Kb(w, x), null != F && t.push($40a2a441cde599fe$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $40a2a441cde599fe$var$wb && (n = c.relatedTarget || c.fromElement) && ($40a2a441cde599fe$var$Wc(n) || n[$40a2a441cde599fe$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $40a2a441cde599fe$var$Wc(n) : null, null !== n && (J = $40a2a441cde599fe$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $40a2a441cde599fe$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $40a2a441cde599fe$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $40a2a441cde599fe$var$ue(k);
                        u = null == n ? h : $40a2a441cde599fe$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $40a2a441cde599fe$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $40a2a441cde599fe$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $40a2a441cde599fe$var$vf(F))u++;
                            for(; 0 < w - u;)t = $40a2a441cde599fe$var$vf(t), w--;
                            for(; 0 < u - w;)x = $40a2a441cde599fe$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $40a2a441cde599fe$var$vf(t);
                                x = $40a2a441cde599fe$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $40a2a441cde599fe$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $40a2a441cde599fe$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $40a2a441cde599fe$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $40a2a441cde599fe$var$ve;
                else if ($40a2a441cde599fe$var$me(h)) {
                    if ($40a2a441cde599fe$var$we) na = $40a2a441cde599fe$var$Fe;
                    else {
                        na = $40a2a441cde599fe$var$De;
                        var xa = $40a2a441cde599fe$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $40a2a441cde599fe$var$Ee);
                if (na && (na = na(a, d))) {
                    $40a2a441cde599fe$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $40a2a441cde599fe$var$cb(h, "number", h.value);
            }
            xa = d ? $40a2a441cde599fe$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($40a2a441cde599fe$var$me(xa) || "true" === xa.contentEditable) $40a2a441cde599fe$var$Qe = xa, $40a2a441cde599fe$var$Re = d, $40a2a441cde599fe$var$Se = null;
                    break;
                case "focusout":
                    $40a2a441cde599fe$var$Se = $40a2a441cde599fe$var$Re = $40a2a441cde599fe$var$Qe = null;
                    break;
                case "mousedown":
                    $40a2a441cde599fe$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $40a2a441cde599fe$var$Te = !1;
                    $40a2a441cde599fe$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($40a2a441cde599fe$var$Pe) break;
                case "keydown":
                case "keyup":
                    $40a2a441cde599fe$var$Ue(g, c, e);
            }
            var $a;
            if ($40a2a441cde599fe$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $40a2a441cde599fe$var$ie ? $40a2a441cde599fe$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($40a2a441cde599fe$var$de && "ko" !== c.locale && ($40a2a441cde599fe$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $40a2a441cde599fe$var$ie && ($a = $40a2a441cde599fe$var$nd()) : ($40a2a441cde599fe$var$kd = e, $40a2a441cde599fe$var$ld = "value" in $40a2a441cde599fe$var$kd ? $40a2a441cde599fe$var$kd.value : $40a2a441cde599fe$var$kd.textContent, $40a2a441cde599fe$var$ie = !0)), xa = $40a2a441cde599fe$var$oe(d, ba), 0 < xa.length && (ba = new $40a2a441cde599fe$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $40a2a441cde599fe$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $40a2a441cde599fe$var$ce ? $40a2a441cde599fe$var$je(a, c) : $40a2a441cde599fe$var$ke(a, c)) d = $40a2a441cde599fe$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $40a2a441cde599fe$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $40a2a441cde599fe$var$se(g, b);
    });
}
function $40a2a441cde599fe$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $40a2a441cde599fe$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $40a2a441cde599fe$var$Kb(a, c), null != f && d.unshift($40a2a441cde599fe$var$tf(a, f, e)), f = $40a2a441cde599fe$var$Kb(a, b), null != f && d.push($40a2a441cde599fe$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $40a2a441cde599fe$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $40a2a441cde599fe$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $40a2a441cde599fe$var$Kb(c, f), null != k && g.unshift($40a2a441cde599fe$var$tf(c, k, h))) : e || (k = $40a2a441cde599fe$var$Kb(c, f), null != k && g.push($40a2a441cde599fe$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $40a2a441cde599fe$var$xf = /\r\n?/g, $40a2a441cde599fe$var$yf = /\u0000|\uFFFD/g;
function $40a2a441cde599fe$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($40a2a441cde599fe$var$xf, "\n").replace($40a2a441cde599fe$var$yf, "");
}
function $40a2a441cde599fe$var$Af(a, b, c) {
    b = $40a2a441cde599fe$var$zf(b);
    if ($40a2a441cde599fe$var$zf(a) !== b && c) throw Error($40a2a441cde599fe$var$p(425));
}
function $40a2a441cde599fe$var$Bf() {}
var $40a2a441cde599fe$var$Cf = null, $40a2a441cde599fe$var$Df = null;
function $40a2a441cde599fe$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $40a2a441cde599fe$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $40a2a441cde599fe$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $40a2a441cde599fe$var$Hf = "function" === typeof Promise ? Promise : void 0, $40a2a441cde599fe$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $40a2a441cde599fe$var$Hf ? function(a) {
    return $40a2a441cde599fe$var$Hf.resolve(null).then(a).catch($40a2a441cde599fe$var$If);
} : $40a2a441cde599fe$var$Ff;
function $40a2a441cde599fe$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $40a2a441cde599fe$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $40a2a441cde599fe$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $40a2a441cde599fe$var$bd(b);
}
function $40a2a441cde599fe$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $40a2a441cde599fe$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $40a2a441cde599fe$var$Nf = Math.random().toString(36).slice(2), $40a2a441cde599fe$var$Of = "__reactFiber$" + $40a2a441cde599fe$var$Nf, $40a2a441cde599fe$var$Pf = "__reactProps$" + $40a2a441cde599fe$var$Nf, $40a2a441cde599fe$var$uf = "__reactContainer$" + $40a2a441cde599fe$var$Nf, $40a2a441cde599fe$var$of = "__reactEvents$" + $40a2a441cde599fe$var$Nf, $40a2a441cde599fe$var$Qf = "__reactListeners$" + $40a2a441cde599fe$var$Nf, $40a2a441cde599fe$var$Rf = "__reactHandles$" + $40a2a441cde599fe$var$Nf;
function $40a2a441cde599fe$var$Wc(a) {
    var b = a[$40a2a441cde599fe$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$40a2a441cde599fe$var$uf] || c[$40a2a441cde599fe$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $40a2a441cde599fe$var$Mf(a); null !== a;){
                if (c = a[$40a2a441cde599fe$var$Of]) return c;
                a = $40a2a441cde599fe$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $40a2a441cde599fe$var$Cb(a) {
    a = a[$40a2a441cde599fe$var$Of] || a[$40a2a441cde599fe$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $40a2a441cde599fe$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($40a2a441cde599fe$var$p(33));
}
function $40a2a441cde599fe$var$Db(a) {
    return a[$40a2a441cde599fe$var$Pf] || null;
}
var $40a2a441cde599fe$var$Sf = [], $40a2a441cde599fe$var$Tf = -1;
function $40a2a441cde599fe$var$Uf(a) {
    return {
        current: a
    };
}
function $40a2a441cde599fe$var$E(a) {
    0 > $40a2a441cde599fe$var$Tf || (a.current = $40a2a441cde599fe$var$Sf[$40a2a441cde599fe$var$Tf], $40a2a441cde599fe$var$Sf[$40a2a441cde599fe$var$Tf] = null, $40a2a441cde599fe$var$Tf--);
}
function $40a2a441cde599fe$var$G(a, b) {
    $40a2a441cde599fe$var$Tf++;
    $40a2a441cde599fe$var$Sf[$40a2a441cde599fe$var$Tf] = a.current;
    a.current = b;
}
var $40a2a441cde599fe$var$Vf = {}, $40a2a441cde599fe$var$H = $40a2a441cde599fe$var$Uf($40a2a441cde599fe$var$Vf), $40a2a441cde599fe$var$Wf = $40a2a441cde599fe$var$Uf(!1), $40a2a441cde599fe$var$Xf = $40a2a441cde599fe$var$Vf;
function $40a2a441cde599fe$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $40a2a441cde599fe$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $40a2a441cde599fe$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $40a2a441cde599fe$var$$f() {
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Wf);
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$H);
}
function $40a2a441cde599fe$var$ag(a, b, c) {
    if ($40a2a441cde599fe$var$H.current !== $40a2a441cde599fe$var$Vf) throw Error($40a2a441cde599fe$var$p(168));
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$H, b);
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Wf, c);
}
function $40a2a441cde599fe$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($40a2a441cde599fe$var$p(108, $40a2a441cde599fe$var$Ra(a) || "Unknown", e));
    return $40a2a441cde599fe$var$A({}, c, d);
}
function $40a2a441cde599fe$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $40a2a441cde599fe$var$Vf;
    $40a2a441cde599fe$var$Xf = $40a2a441cde599fe$var$H.current;
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$H, a);
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Wf, $40a2a441cde599fe$var$Wf.current);
    return !0;
}
function $40a2a441cde599fe$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($40a2a441cde599fe$var$p(169));
    c ? (a = $40a2a441cde599fe$var$bg(a, b, $40a2a441cde599fe$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Wf), $40a2a441cde599fe$var$E($40a2a441cde599fe$var$H), $40a2a441cde599fe$var$G($40a2a441cde599fe$var$H, a)) : $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Wf);
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Wf, c);
}
var $40a2a441cde599fe$var$eg = null, $40a2a441cde599fe$var$fg = !1, $40a2a441cde599fe$var$gg = !1;
function $40a2a441cde599fe$var$hg(a) {
    null === $40a2a441cde599fe$var$eg ? $40a2a441cde599fe$var$eg = [
        a
    ] : $40a2a441cde599fe$var$eg.push(a);
}
function $40a2a441cde599fe$var$ig(a) {
    $40a2a441cde599fe$var$fg = !0;
    $40a2a441cde599fe$var$hg(a);
}
function $40a2a441cde599fe$var$jg() {
    if (!$40a2a441cde599fe$var$gg && null !== $40a2a441cde599fe$var$eg) {
        $40a2a441cde599fe$var$gg = !0;
        var a = 0, b = $40a2a441cde599fe$var$C;
        try {
            var c = $40a2a441cde599fe$var$eg;
            for($40a2a441cde599fe$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $40a2a441cde599fe$var$eg = null;
            $40a2a441cde599fe$var$fg = !1;
        } catch (e) {
            throw null !== $40a2a441cde599fe$var$eg && ($40a2a441cde599fe$var$eg = $40a2a441cde599fe$var$eg.slice(a + 1)), $40a2a441cde599fe$var$ac($40a2a441cde599fe$var$fc, $40a2a441cde599fe$var$jg), e;
        } finally{
            $40a2a441cde599fe$var$C = b, $40a2a441cde599fe$var$gg = !1;
        }
    }
    return null;
}
var $40a2a441cde599fe$var$kg = [], $40a2a441cde599fe$var$lg = 0, $40a2a441cde599fe$var$mg = null, $40a2a441cde599fe$var$ng = 0, $40a2a441cde599fe$var$og = [], $40a2a441cde599fe$var$pg = 0, $40a2a441cde599fe$var$qg = null, $40a2a441cde599fe$var$rg = 1, $40a2a441cde599fe$var$sg = "";
function $40a2a441cde599fe$var$tg(a, b) {
    $40a2a441cde599fe$var$kg[$40a2a441cde599fe$var$lg++] = $40a2a441cde599fe$var$ng;
    $40a2a441cde599fe$var$kg[$40a2a441cde599fe$var$lg++] = $40a2a441cde599fe$var$mg;
    $40a2a441cde599fe$var$mg = a;
    $40a2a441cde599fe$var$ng = b;
}
function $40a2a441cde599fe$var$ug(a, b, c) {
    $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg++] = $40a2a441cde599fe$var$rg;
    $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg++] = $40a2a441cde599fe$var$sg;
    $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg++] = $40a2a441cde599fe$var$qg;
    $40a2a441cde599fe$var$qg = a;
    var d = $40a2a441cde599fe$var$rg;
    a = $40a2a441cde599fe$var$sg;
    var e = 32 - $40a2a441cde599fe$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $40a2a441cde599fe$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $40a2a441cde599fe$var$rg = 1 << 32 - $40a2a441cde599fe$var$oc(b) + e | c << e | d;
        $40a2a441cde599fe$var$sg = f + a;
    } else $40a2a441cde599fe$var$rg = 1 << f | c << e | d, $40a2a441cde599fe$var$sg = a;
}
function $40a2a441cde599fe$var$vg(a) {
    null !== a.return && ($40a2a441cde599fe$var$tg(a, 1), $40a2a441cde599fe$var$ug(a, 1, 0));
}
function $40a2a441cde599fe$var$wg(a) {
    for(; a === $40a2a441cde599fe$var$mg;)$40a2a441cde599fe$var$mg = $40a2a441cde599fe$var$kg[--$40a2a441cde599fe$var$lg], $40a2a441cde599fe$var$kg[$40a2a441cde599fe$var$lg] = null, $40a2a441cde599fe$var$ng = $40a2a441cde599fe$var$kg[--$40a2a441cde599fe$var$lg], $40a2a441cde599fe$var$kg[$40a2a441cde599fe$var$lg] = null;
    for(; a === $40a2a441cde599fe$var$qg;)$40a2a441cde599fe$var$qg = $40a2a441cde599fe$var$og[--$40a2a441cde599fe$var$pg], $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg] = null, $40a2a441cde599fe$var$sg = $40a2a441cde599fe$var$og[--$40a2a441cde599fe$var$pg], $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg] = null, $40a2a441cde599fe$var$rg = $40a2a441cde599fe$var$og[--$40a2a441cde599fe$var$pg], $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg] = null;
}
var $40a2a441cde599fe$var$xg = null, $40a2a441cde599fe$var$yg = null, $40a2a441cde599fe$var$I = !1, $40a2a441cde599fe$var$zg = null;
function $40a2a441cde599fe$var$Ag(a, b) {
    var c = $40a2a441cde599fe$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $40a2a441cde599fe$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $40a2a441cde599fe$var$xg = a, $40a2a441cde599fe$var$yg = $40a2a441cde599fe$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $40a2a441cde599fe$var$xg = a, $40a2a441cde599fe$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $40a2a441cde599fe$var$qg ? {
                id: $40a2a441cde599fe$var$rg,
                overflow: $40a2a441cde599fe$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $40a2a441cde599fe$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $40a2a441cde599fe$var$xg = a, $40a2a441cde599fe$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $40a2a441cde599fe$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $40a2a441cde599fe$var$Eg(a) {
    if ($40a2a441cde599fe$var$I) {
        var b = $40a2a441cde599fe$var$yg;
        if (b) {
            var c = b;
            if (!$40a2a441cde599fe$var$Cg(a, b)) {
                if ($40a2a441cde599fe$var$Dg(a)) throw Error($40a2a441cde599fe$var$p(418));
                b = $40a2a441cde599fe$var$Lf(c.nextSibling);
                var d = $40a2a441cde599fe$var$xg;
                b && $40a2a441cde599fe$var$Cg(a, b) ? $40a2a441cde599fe$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $40a2a441cde599fe$var$I = !1, $40a2a441cde599fe$var$xg = a);
            }
        } else {
            if ($40a2a441cde599fe$var$Dg(a)) throw Error($40a2a441cde599fe$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $40a2a441cde599fe$var$I = !1;
            $40a2a441cde599fe$var$xg = a;
        }
    }
}
function $40a2a441cde599fe$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $40a2a441cde599fe$var$xg = a;
}
function $40a2a441cde599fe$var$Gg(a) {
    if (a !== $40a2a441cde599fe$var$xg) return !1;
    if (!$40a2a441cde599fe$var$I) return $40a2a441cde599fe$var$Fg(a), $40a2a441cde599fe$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$40a2a441cde599fe$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $40a2a441cde599fe$var$yg)) {
        if ($40a2a441cde599fe$var$Dg(a)) throw $40a2a441cde599fe$var$Hg(), Error($40a2a441cde599fe$var$p(418));
        for(; b;)$40a2a441cde599fe$var$Ag(a, b), b = $40a2a441cde599fe$var$Lf(b.nextSibling);
    }
    $40a2a441cde599fe$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($40a2a441cde599fe$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $40a2a441cde599fe$var$yg = $40a2a441cde599fe$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $40a2a441cde599fe$var$yg = null;
        }
    } else $40a2a441cde599fe$var$yg = $40a2a441cde599fe$var$xg ? $40a2a441cde599fe$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $40a2a441cde599fe$var$Hg() {
    for(var a = $40a2a441cde599fe$var$yg; a;)a = $40a2a441cde599fe$var$Lf(a.nextSibling);
}
function $40a2a441cde599fe$var$Ig() {
    $40a2a441cde599fe$var$yg = $40a2a441cde599fe$var$xg = null;
    $40a2a441cde599fe$var$I = !1;
}
function $40a2a441cde599fe$var$Jg(a) {
    null === $40a2a441cde599fe$var$zg ? $40a2a441cde599fe$var$zg = [
        a
    ] : $40a2a441cde599fe$var$zg.push(a);
}
var $40a2a441cde599fe$var$Kg = $40a2a441cde599fe$var$ua.ReactCurrentBatchConfig;
function $40a2a441cde599fe$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $40a2a441cde599fe$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $40a2a441cde599fe$var$Mg = $40a2a441cde599fe$var$Uf(null), $40a2a441cde599fe$var$Ng = null, $40a2a441cde599fe$var$Og = null, $40a2a441cde599fe$var$Pg = null;
function $40a2a441cde599fe$var$Qg() {
    $40a2a441cde599fe$var$Pg = $40a2a441cde599fe$var$Og = $40a2a441cde599fe$var$Ng = null;
}
function $40a2a441cde599fe$var$Rg(a) {
    var b = $40a2a441cde599fe$var$Mg.current;
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Mg);
    a._currentValue = b;
}
function $40a2a441cde599fe$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $40a2a441cde599fe$var$Tg(a, b) {
    $40a2a441cde599fe$var$Ng = a;
    $40a2a441cde599fe$var$Pg = $40a2a441cde599fe$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($40a2a441cde599fe$var$Ug = !0), a.firstContext = null);
}
function $40a2a441cde599fe$var$Vg(a) {
    var b = a._currentValue;
    if ($40a2a441cde599fe$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $40a2a441cde599fe$var$Og) {
            if (null === $40a2a441cde599fe$var$Ng) throw Error($40a2a441cde599fe$var$p(308));
            $40a2a441cde599fe$var$Og = a;
            $40a2a441cde599fe$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $40a2a441cde599fe$var$Og = $40a2a441cde599fe$var$Og.next = a;
    }
    return b;
}
var $40a2a441cde599fe$var$Wg = null;
function $40a2a441cde599fe$var$Xg(a) {
    null === $40a2a441cde599fe$var$Wg ? $40a2a441cde599fe$var$Wg = [
        a
    ] : $40a2a441cde599fe$var$Wg.push(a);
}
function $40a2a441cde599fe$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $40a2a441cde599fe$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $40a2a441cde599fe$var$Zg(a, d);
}
function $40a2a441cde599fe$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $40a2a441cde599fe$var$$g = !1;
function $40a2a441cde599fe$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $40a2a441cde599fe$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $40a2a441cde599fe$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $40a2a441cde599fe$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($40a2a441cde599fe$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $40a2a441cde599fe$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $40a2a441cde599fe$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $40a2a441cde599fe$var$Zg(a, c);
}
function $40a2a441cde599fe$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $40a2a441cde599fe$var$Cc(a, c);
    }
}
function $40a2a441cde599fe$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $40a2a441cde599fe$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $40a2a441cde599fe$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $40a2a441cde599fe$var$A({}, q, r);
                            break a;
                        case 2:
                            $40a2a441cde599fe$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $40a2a441cde599fe$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $40a2a441cde599fe$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($40a2a441cde599fe$var$p(191, e));
            e.call(d);
        }
    }
}
var $40a2a441cde599fe$var$jh = (new $g5BLJ.Component).refs;
function $40a2a441cde599fe$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $40a2a441cde599fe$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $40a2a441cde599fe$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $40a2a441cde599fe$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $40a2a441cde599fe$var$L(), e = $40a2a441cde599fe$var$lh(a), f = $40a2a441cde599fe$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $40a2a441cde599fe$var$dh(a, f, e);
        null !== b && ($40a2a441cde599fe$var$mh(b, a, e, d), $40a2a441cde599fe$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $40a2a441cde599fe$var$L(), e = $40a2a441cde599fe$var$lh(a), f = $40a2a441cde599fe$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $40a2a441cde599fe$var$dh(a, f, e);
        null !== b && ($40a2a441cde599fe$var$mh(b, a, e, d), $40a2a441cde599fe$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $40a2a441cde599fe$var$L(), d = $40a2a441cde599fe$var$lh(a), e = $40a2a441cde599fe$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $40a2a441cde599fe$var$dh(a, e, d);
        null !== b && ($40a2a441cde599fe$var$mh(b, a, d, c), $40a2a441cde599fe$var$eh(b, a, d));
    }
};
function $40a2a441cde599fe$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$40a2a441cde599fe$var$Ie(c, d) || !$40a2a441cde599fe$var$Ie(e, f) : !0;
}
function $40a2a441cde599fe$var$ph(a, b, c) {
    var d = !1, e = $40a2a441cde599fe$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $40a2a441cde599fe$var$Vg(f) : (e = $40a2a441cde599fe$var$Zf(b) ? $40a2a441cde599fe$var$Xf : $40a2a441cde599fe$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $40a2a441cde599fe$var$Yf(a, e) : $40a2a441cde599fe$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $40a2a441cde599fe$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $40a2a441cde599fe$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $40a2a441cde599fe$var$nh.enqueueReplaceState(b, b.state, null);
}
function $40a2a441cde599fe$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $40a2a441cde599fe$var$jh;
    $40a2a441cde599fe$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $40a2a441cde599fe$var$Vg(f) : (f = $40a2a441cde599fe$var$Zf(b) ? $40a2a441cde599fe$var$Xf : $40a2a441cde599fe$var$H.current, e.context = $40a2a441cde599fe$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($40a2a441cde599fe$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $40a2a441cde599fe$var$nh.enqueueReplaceState(e, e.state, null), $40a2a441cde599fe$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $40a2a441cde599fe$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($40a2a441cde599fe$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($40a2a441cde599fe$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $40a2a441cde599fe$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($40a2a441cde599fe$var$p(284));
        if (!c._owner) throw Error($40a2a441cde599fe$var$p(290, a));
    }
    return a;
}
function $40a2a441cde599fe$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($40a2a441cde599fe$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $40a2a441cde599fe$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $40a2a441cde599fe$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $40a2a441cde599fe$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $40a2a441cde599fe$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $40a2a441cde599fe$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $40a2a441cde599fe$var$Ha && $40a2a441cde599fe$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $40a2a441cde599fe$var$sh(a, b, c), d.return = a, d;
        d = $40a2a441cde599fe$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $40a2a441cde599fe$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $40a2a441cde599fe$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $40a2a441cde599fe$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $40a2a441cde599fe$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $40a2a441cde599fe$var$va:
                    return c = $40a2a441cde599fe$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $40a2a441cde599fe$var$sh(a, null, b), c.return = a, c;
                case $40a2a441cde599fe$var$wa:
                    return b = $40a2a441cde599fe$var$zh(b, a.mode, c), b.return = a, b;
                case $40a2a441cde599fe$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($40a2a441cde599fe$var$eb(b) || $40a2a441cde599fe$var$Ka(b)) return b = $40a2a441cde599fe$var$Ah(b, a.mode, c, null), b.return = a, b;
            $40a2a441cde599fe$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $40a2a441cde599fe$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $40a2a441cde599fe$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $40a2a441cde599fe$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($40a2a441cde599fe$var$eb(c) || $40a2a441cde599fe$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $40a2a441cde599fe$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $40a2a441cde599fe$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $40a2a441cde599fe$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $40a2a441cde599fe$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($40a2a441cde599fe$var$eb(d) || $40a2a441cde599fe$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $40a2a441cde599fe$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $40a2a441cde599fe$var$I && $40a2a441cde599fe$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $40a2a441cde599fe$var$I && $40a2a441cde599fe$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $40a2a441cde599fe$var$I && $40a2a441cde599fe$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $40a2a441cde599fe$var$Ka(h);
        if ("function" !== typeof l) throw Error($40a2a441cde599fe$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($40a2a441cde599fe$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $40a2a441cde599fe$var$I && $40a2a441cde599fe$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $40a2a441cde599fe$var$I && $40a2a441cde599fe$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $40a2a441cde599fe$var$I && $40a2a441cde599fe$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $40a2a441cde599fe$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $40a2a441cde599fe$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $40a2a441cde599fe$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $40a2a441cde599fe$var$Ha && $40a2a441cde599fe$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $40a2a441cde599fe$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $40a2a441cde599fe$var$ya ? (d = $40a2a441cde599fe$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $40a2a441cde599fe$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $40a2a441cde599fe$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $40a2a441cde599fe$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $40a2a441cde599fe$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $40a2a441cde599fe$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($40a2a441cde599fe$var$eb(f)) return n(a, d, f, h);
            if ($40a2a441cde599fe$var$Ka(f)) return t(a, d, f, h);
            $40a2a441cde599fe$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $40a2a441cde599fe$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $40a2a441cde599fe$var$Bh = $40a2a441cde599fe$var$vh(!0), $40a2a441cde599fe$var$Ch = $40a2a441cde599fe$var$vh(!1), $40a2a441cde599fe$var$Dh = {}, $40a2a441cde599fe$var$Eh = $40a2a441cde599fe$var$Uf($40a2a441cde599fe$var$Dh), $40a2a441cde599fe$var$Fh = $40a2a441cde599fe$var$Uf($40a2a441cde599fe$var$Dh), $40a2a441cde599fe$var$Gh = $40a2a441cde599fe$var$Uf($40a2a441cde599fe$var$Dh);
function $40a2a441cde599fe$var$Hh(a) {
    if (a === $40a2a441cde599fe$var$Dh) throw Error($40a2a441cde599fe$var$p(174));
    return a;
}
function $40a2a441cde599fe$var$Ih(a, b) {
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Gh, b);
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Fh, a);
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Eh, $40a2a441cde599fe$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $40a2a441cde599fe$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $40a2a441cde599fe$var$lb(b, a);
    }
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Eh);
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Eh, b);
}
function $40a2a441cde599fe$var$Jh() {
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Eh);
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Fh);
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Gh);
}
function $40a2a441cde599fe$var$Kh(a) {
    $40a2a441cde599fe$var$Hh($40a2a441cde599fe$var$Gh.current);
    var b = $40a2a441cde599fe$var$Hh($40a2a441cde599fe$var$Eh.current);
    var c = $40a2a441cde599fe$var$lb(b, a.type);
    b !== c && ($40a2a441cde599fe$var$G($40a2a441cde599fe$var$Fh, a), $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Eh, c));
}
function $40a2a441cde599fe$var$Lh(a) {
    $40a2a441cde599fe$var$Fh.current === a && ($40a2a441cde599fe$var$E($40a2a441cde599fe$var$Eh), $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Fh));
}
var $40a2a441cde599fe$var$M = $40a2a441cde599fe$var$Uf(0);
function $40a2a441cde599fe$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $40a2a441cde599fe$var$Nh = [];
function $40a2a441cde599fe$var$Oh() {
    for(var a = 0; a < $40a2a441cde599fe$var$Nh.length; a++)$40a2a441cde599fe$var$Nh[a]._workInProgressVersionPrimary = null;
    $40a2a441cde599fe$var$Nh.length = 0;
}
var $40a2a441cde599fe$var$Ph = $40a2a441cde599fe$var$ua.ReactCurrentDispatcher, $40a2a441cde599fe$var$Qh = $40a2a441cde599fe$var$ua.ReactCurrentBatchConfig, $40a2a441cde599fe$var$Rh = 0, $40a2a441cde599fe$var$N = null, $40a2a441cde599fe$var$O = null, $40a2a441cde599fe$var$P = null, $40a2a441cde599fe$var$Sh = !1, $40a2a441cde599fe$var$Th = !1, $40a2a441cde599fe$var$Uh = 0, $40a2a441cde599fe$var$Vh = 0;
function $40a2a441cde599fe$var$Q() {
    throw Error($40a2a441cde599fe$var$p(321));
}
function $40a2a441cde599fe$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$40a2a441cde599fe$var$He(a[c], b[c])) return !1;
    return !0;
}
function $40a2a441cde599fe$var$Xh(a, b, c, d, e, f) {
    $40a2a441cde599fe$var$Rh = f;
    $40a2a441cde599fe$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $40a2a441cde599fe$var$Ph.current = null === a || null === a.memoizedState ? $40a2a441cde599fe$var$Yh : $40a2a441cde599fe$var$Zh;
    a = c(d, e);
    if ($40a2a441cde599fe$var$Th) {
        f = 0;
        do {
            $40a2a441cde599fe$var$Th = !1;
            $40a2a441cde599fe$var$Uh = 0;
            if (25 <= f) throw Error($40a2a441cde599fe$var$p(301));
            f += 1;
            $40a2a441cde599fe$var$P = $40a2a441cde599fe$var$O = null;
            b.updateQueue = null;
            $40a2a441cde599fe$var$Ph.current = $40a2a441cde599fe$var$$h;
            a = c(d, e);
        }while ($40a2a441cde599fe$var$Th);
    }
    $40a2a441cde599fe$var$Ph.current = $40a2a441cde599fe$var$ai;
    b = null !== $40a2a441cde599fe$var$O && null !== $40a2a441cde599fe$var$O.next;
    $40a2a441cde599fe$var$Rh = 0;
    $40a2a441cde599fe$var$P = $40a2a441cde599fe$var$O = $40a2a441cde599fe$var$N = null;
    $40a2a441cde599fe$var$Sh = !1;
    if (b) throw Error($40a2a441cde599fe$var$p(300));
    return a;
}
function $40a2a441cde599fe$var$bi() {
    var a = 0 !== $40a2a441cde599fe$var$Uh;
    $40a2a441cde599fe$var$Uh = 0;
    return a;
}
function $40a2a441cde599fe$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $40a2a441cde599fe$var$P ? $40a2a441cde599fe$var$N.memoizedState = $40a2a441cde599fe$var$P = a : $40a2a441cde599fe$var$P = $40a2a441cde599fe$var$P.next = a;
    return $40a2a441cde599fe$var$P;
}
function $40a2a441cde599fe$var$di() {
    if (null === $40a2a441cde599fe$var$O) {
        var a = $40a2a441cde599fe$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $40a2a441cde599fe$var$O.next;
    var b = null === $40a2a441cde599fe$var$P ? $40a2a441cde599fe$var$N.memoizedState : $40a2a441cde599fe$var$P.next;
    if (null !== b) $40a2a441cde599fe$var$P = b, $40a2a441cde599fe$var$O = a;
    else {
        if (null === a) throw Error($40a2a441cde599fe$var$p(310));
        $40a2a441cde599fe$var$O = a;
        a = {
            memoizedState: $40a2a441cde599fe$var$O.memoizedState,
            baseState: $40a2a441cde599fe$var$O.baseState,
            baseQueue: $40a2a441cde599fe$var$O.baseQueue,
            queue: $40a2a441cde599fe$var$O.queue,
            next: null
        };
        null === $40a2a441cde599fe$var$P ? $40a2a441cde599fe$var$N.memoizedState = $40a2a441cde599fe$var$P = a : $40a2a441cde599fe$var$P = $40a2a441cde599fe$var$P.next = a;
    }
    return $40a2a441cde599fe$var$P;
}
function $40a2a441cde599fe$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $40a2a441cde599fe$var$fi(a) {
    var b = $40a2a441cde599fe$var$di(), c = b.queue;
    if (null === c) throw Error($40a2a441cde599fe$var$p(311));
    c.lastRenderedReducer = a;
    var d = $40a2a441cde599fe$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($40a2a441cde599fe$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $40a2a441cde599fe$var$N.lanes |= m;
                $40a2a441cde599fe$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $40a2a441cde599fe$var$He(d, b.memoizedState) || ($40a2a441cde599fe$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $40a2a441cde599fe$var$N.lanes |= f, $40a2a441cde599fe$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $40a2a441cde599fe$var$gi(a) {
    var b = $40a2a441cde599fe$var$di(), c = b.queue;
    if (null === c) throw Error($40a2a441cde599fe$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $40a2a441cde599fe$var$He(f, b.memoizedState) || ($40a2a441cde599fe$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $40a2a441cde599fe$var$hi() {}
function $40a2a441cde599fe$var$ii(a, b) {
    var c = $40a2a441cde599fe$var$N, d = $40a2a441cde599fe$var$di(), e = b(), f = !$40a2a441cde599fe$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $40a2a441cde599fe$var$Ug = !0);
    d = d.queue;
    $40a2a441cde599fe$var$ji($40a2a441cde599fe$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $40a2a441cde599fe$var$P && $40a2a441cde599fe$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $40a2a441cde599fe$var$li(9, $40a2a441cde599fe$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $40a2a441cde599fe$var$R) throw Error($40a2a441cde599fe$var$p(349));
        0 !== ($40a2a441cde599fe$var$Rh & 30) || $40a2a441cde599fe$var$ni(c, b, e);
    }
    return e;
}
function $40a2a441cde599fe$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $40a2a441cde599fe$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $40a2a441cde599fe$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $40a2a441cde599fe$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $40a2a441cde599fe$var$oi(b) && $40a2a441cde599fe$var$pi(a);
}
function $40a2a441cde599fe$var$ki(a, b, c) {
    return c(function() {
        $40a2a441cde599fe$var$oi(b) && $40a2a441cde599fe$var$pi(a);
    });
}
function $40a2a441cde599fe$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$40a2a441cde599fe$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $40a2a441cde599fe$var$pi(a) {
    var b = $40a2a441cde599fe$var$Zg(a, 1);
    null !== b && $40a2a441cde599fe$var$mh(b, a, 1, -1);
}
function $40a2a441cde599fe$var$qi(a) {
    var b = $40a2a441cde599fe$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $40a2a441cde599fe$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $40a2a441cde599fe$var$ri.bind(null, $40a2a441cde599fe$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $40a2a441cde599fe$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $40a2a441cde599fe$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $40a2a441cde599fe$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $40a2a441cde599fe$var$si() {
    return $40a2a441cde599fe$var$di().memoizedState;
}
function $40a2a441cde599fe$var$ti(a, b, c, d) {
    var e = $40a2a441cde599fe$var$ci();
    $40a2a441cde599fe$var$N.flags |= a;
    e.memoizedState = $40a2a441cde599fe$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $40a2a441cde599fe$var$ui(a, b, c, d) {
    var e = $40a2a441cde599fe$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $40a2a441cde599fe$var$O) {
        var g = $40a2a441cde599fe$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $40a2a441cde599fe$var$Wh(d, g.deps)) {
            e.memoizedState = $40a2a441cde599fe$var$li(b, c, f, d);
            return;
        }
    }
    $40a2a441cde599fe$var$N.flags |= a;
    e.memoizedState = $40a2a441cde599fe$var$li(1 | b, c, f, d);
}
function $40a2a441cde599fe$var$vi(a, b) {
    return $40a2a441cde599fe$var$ti(8390656, 8, a, b);
}
function $40a2a441cde599fe$var$ji(a, b) {
    return $40a2a441cde599fe$var$ui(2048, 8, a, b);
}
function $40a2a441cde599fe$var$wi(a, b) {
    return $40a2a441cde599fe$var$ui(4, 2, a, b);
}
function $40a2a441cde599fe$var$xi(a, b) {
    return $40a2a441cde599fe$var$ui(4, 4, a, b);
}
function $40a2a441cde599fe$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $40a2a441cde599fe$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $40a2a441cde599fe$var$ui(4, 4, $40a2a441cde599fe$var$yi.bind(null, b, a), c);
}
function $40a2a441cde599fe$var$Ai() {}
function $40a2a441cde599fe$var$Bi(a, b) {
    var c = $40a2a441cde599fe$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $40a2a441cde599fe$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $40a2a441cde599fe$var$Ci(a, b) {
    var c = $40a2a441cde599fe$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $40a2a441cde599fe$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $40a2a441cde599fe$var$Di(a, b, c) {
    if (0 === ($40a2a441cde599fe$var$Rh & 21)) return a.baseState && (a.baseState = !1, $40a2a441cde599fe$var$Ug = !0), a.memoizedState = c;
    $40a2a441cde599fe$var$He(c, b) || (c = $40a2a441cde599fe$var$yc(), $40a2a441cde599fe$var$N.lanes |= c, $40a2a441cde599fe$var$hh |= c, a.baseState = !0);
    return b;
}
function $40a2a441cde599fe$var$Ei(a, b) {
    var c = $40a2a441cde599fe$var$C;
    $40a2a441cde599fe$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $40a2a441cde599fe$var$Qh.transition;
    $40a2a441cde599fe$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $40a2a441cde599fe$var$C = c, $40a2a441cde599fe$var$Qh.transition = d;
    }
}
function $40a2a441cde599fe$var$Fi() {
    return $40a2a441cde599fe$var$di().memoizedState;
}
function $40a2a441cde599fe$var$Gi(a, b, c) {
    var d = $40a2a441cde599fe$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($40a2a441cde599fe$var$Hi(a)) $40a2a441cde599fe$var$Ii(b, c);
    else if (c = $40a2a441cde599fe$var$Yg(a, b, c, d), null !== c) {
        var e = $40a2a441cde599fe$var$L();
        $40a2a441cde599fe$var$mh(c, a, d, e);
        $40a2a441cde599fe$var$Ji(c, b, d);
    }
}
function $40a2a441cde599fe$var$ri(a, b, c) {
    var d = $40a2a441cde599fe$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($40a2a441cde599fe$var$Hi(a)) $40a2a441cde599fe$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($40a2a441cde599fe$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $40a2a441cde599fe$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $40a2a441cde599fe$var$Yg(a, b, e, d);
        null !== c && (e = $40a2a441cde599fe$var$L(), $40a2a441cde599fe$var$mh(c, a, d, e), $40a2a441cde599fe$var$Ji(c, b, d));
    }
}
function $40a2a441cde599fe$var$Hi(a) {
    var b = a.alternate;
    return a === $40a2a441cde599fe$var$N || null !== b && b === $40a2a441cde599fe$var$N;
}
function $40a2a441cde599fe$var$Ii(a, b) {
    $40a2a441cde599fe$var$Th = $40a2a441cde599fe$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $40a2a441cde599fe$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $40a2a441cde599fe$var$Cc(a, c);
    }
}
var $40a2a441cde599fe$var$ai = {
    readContext: $40a2a441cde599fe$var$Vg,
    useCallback: $40a2a441cde599fe$var$Q,
    useContext: $40a2a441cde599fe$var$Q,
    useEffect: $40a2a441cde599fe$var$Q,
    useImperativeHandle: $40a2a441cde599fe$var$Q,
    useInsertionEffect: $40a2a441cde599fe$var$Q,
    useLayoutEffect: $40a2a441cde599fe$var$Q,
    useMemo: $40a2a441cde599fe$var$Q,
    useReducer: $40a2a441cde599fe$var$Q,
    useRef: $40a2a441cde599fe$var$Q,
    useState: $40a2a441cde599fe$var$Q,
    useDebugValue: $40a2a441cde599fe$var$Q,
    useDeferredValue: $40a2a441cde599fe$var$Q,
    useTransition: $40a2a441cde599fe$var$Q,
    useMutableSource: $40a2a441cde599fe$var$Q,
    useSyncExternalStore: $40a2a441cde599fe$var$Q,
    useId: $40a2a441cde599fe$var$Q,
    unstable_isNewReconciler: !1
}, $40a2a441cde599fe$var$Yh = {
    readContext: $40a2a441cde599fe$var$Vg,
    useCallback: function(a, b) {
        $40a2a441cde599fe$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $40a2a441cde599fe$var$Vg,
    useEffect: $40a2a441cde599fe$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $40a2a441cde599fe$var$ti(4194308, 4, $40a2a441cde599fe$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $40a2a441cde599fe$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $40a2a441cde599fe$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $40a2a441cde599fe$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $40a2a441cde599fe$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $40a2a441cde599fe$var$Gi.bind(null, $40a2a441cde599fe$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $40a2a441cde599fe$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $40a2a441cde599fe$var$qi,
    useDebugValue: $40a2a441cde599fe$var$Ai,
    useDeferredValue: function(a) {
        return $40a2a441cde599fe$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $40a2a441cde599fe$var$qi(!1), b = a[0];
        a = $40a2a441cde599fe$var$Ei.bind(null, a[1]);
        $40a2a441cde599fe$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $40a2a441cde599fe$var$N, e = $40a2a441cde599fe$var$ci();
        if ($40a2a441cde599fe$var$I) {
            if (void 0 === c) throw Error($40a2a441cde599fe$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $40a2a441cde599fe$var$R) throw Error($40a2a441cde599fe$var$p(349));
            0 !== ($40a2a441cde599fe$var$Rh & 30) || $40a2a441cde599fe$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $40a2a441cde599fe$var$vi($40a2a441cde599fe$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $40a2a441cde599fe$var$li(9, $40a2a441cde599fe$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $40a2a441cde599fe$var$ci(), b = $40a2a441cde599fe$var$R.identifierPrefix;
        if ($40a2a441cde599fe$var$I) {
            var c = $40a2a441cde599fe$var$sg;
            var d = $40a2a441cde599fe$var$rg;
            c = (d & ~(1 << 32 - $40a2a441cde599fe$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $40a2a441cde599fe$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $40a2a441cde599fe$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $40a2a441cde599fe$var$Zh = {
    readContext: $40a2a441cde599fe$var$Vg,
    useCallback: $40a2a441cde599fe$var$Bi,
    useContext: $40a2a441cde599fe$var$Vg,
    useEffect: $40a2a441cde599fe$var$ji,
    useImperativeHandle: $40a2a441cde599fe$var$zi,
    useInsertionEffect: $40a2a441cde599fe$var$wi,
    useLayoutEffect: $40a2a441cde599fe$var$xi,
    useMemo: $40a2a441cde599fe$var$Ci,
    useReducer: $40a2a441cde599fe$var$fi,
    useRef: $40a2a441cde599fe$var$si,
    useState: function() {
        return $40a2a441cde599fe$var$fi($40a2a441cde599fe$var$ei);
    },
    useDebugValue: $40a2a441cde599fe$var$Ai,
    useDeferredValue: function(a) {
        var b = $40a2a441cde599fe$var$di();
        return $40a2a441cde599fe$var$Di(b, $40a2a441cde599fe$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $40a2a441cde599fe$var$fi($40a2a441cde599fe$var$ei)[0], b = $40a2a441cde599fe$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $40a2a441cde599fe$var$hi,
    useSyncExternalStore: $40a2a441cde599fe$var$ii,
    useId: $40a2a441cde599fe$var$Fi,
    unstable_isNewReconciler: !1
}, $40a2a441cde599fe$var$$h = {
    readContext: $40a2a441cde599fe$var$Vg,
    useCallback: $40a2a441cde599fe$var$Bi,
    useContext: $40a2a441cde599fe$var$Vg,
    useEffect: $40a2a441cde599fe$var$ji,
    useImperativeHandle: $40a2a441cde599fe$var$zi,
    useInsertionEffect: $40a2a441cde599fe$var$wi,
    useLayoutEffect: $40a2a441cde599fe$var$xi,
    useMemo: $40a2a441cde599fe$var$Ci,
    useReducer: $40a2a441cde599fe$var$gi,
    useRef: $40a2a441cde599fe$var$si,
    useState: function() {
        return $40a2a441cde599fe$var$gi($40a2a441cde599fe$var$ei);
    },
    useDebugValue: $40a2a441cde599fe$var$Ai,
    useDeferredValue: function(a) {
        var b = $40a2a441cde599fe$var$di();
        return null === $40a2a441cde599fe$var$O ? b.memoizedState = a : $40a2a441cde599fe$var$Di(b, $40a2a441cde599fe$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $40a2a441cde599fe$var$gi($40a2a441cde599fe$var$ei)[0], b = $40a2a441cde599fe$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $40a2a441cde599fe$var$hi,
    useSyncExternalStore: $40a2a441cde599fe$var$ii,
    useId: $40a2a441cde599fe$var$Fi,
    unstable_isNewReconciler: !1
};
function $40a2a441cde599fe$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $40a2a441cde599fe$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $40a2a441cde599fe$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $40a2a441cde599fe$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $40a2a441cde599fe$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $40a2a441cde599fe$var$Oi(a, b, c) {
    c = $40a2a441cde599fe$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $40a2a441cde599fe$var$Pi || ($40a2a441cde599fe$var$Pi = !0, $40a2a441cde599fe$var$Qi = d);
        $40a2a441cde599fe$var$Mi(a, b);
    };
    return c;
}
function $40a2a441cde599fe$var$Ri(a, b, c) {
    c = $40a2a441cde599fe$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $40a2a441cde599fe$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $40a2a441cde599fe$var$Mi(a, b);
        "function" !== typeof d && (null === $40a2a441cde599fe$var$Si ? $40a2a441cde599fe$var$Si = new Set([
            this
        ]) : $40a2a441cde599fe$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $40a2a441cde599fe$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $40a2a441cde599fe$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $40a2a441cde599fe$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $40a2a441cde599fe$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $40a2a441cde599fe$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $40a2a441cde599fe$var$ch(-1, 1), b.tag = 2, $40a2a441cde599fe$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $40a2a441cde599fe$var$Xi = $40a2a441cde599fe$var$ua.ReactCurrentOwner, $40a2a441cde599fe$var$Ug = !1;
function $40a2a441cde599fe$var$Yi(a, b, c, d) {
    b.child = null === a ? $40a2a441cde599fe$var$Ch(b, null, c, d) : $40a2a441cde599fe$var$Bh(b, a.child, c, d);
}
function $40a2a441cde599fe$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $40a2a441cde599fe$var$Tg(b, e);
    d = $40a2a441cde599fe$var$Xh(a, b, c, d, f, e);
    c = $40a2a441cde599fe$var$bi();
    if (null !== a && !$40a2a441cde599fe$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $40a2a441cde599fe$var$$i(a, b, e);
    $40a2a441cde599fe$var$I && c && $40a2a441cde599fe$var$vg(b);
    b.flags |= 1;
    $40a2a441cde599fe$var$Yi(a, b, d, e);
    return b.child;
}
function $40a2a441cde599fe$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$40a2a441cde599fe$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $40a2a441cde599fe$var$cj(a, b, f, d, e);
        a = $40a2a441cde599fe$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $40a2a441cde599fe$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $40a2a441cde599fe$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $40a2a441cde599fe$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $40a2a441cde599fe$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($40a2a441cde599fe$var$Ie(f, d) && a.ref === b.ref) {
            if ($40a2a441cde599fe$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($40a2a441cde599fe$var$Ug = !0);
            else return b.lanes = a.lanes, $40a2a441cde599fe$var$$i(a, b, e);
        }
    }
    return $40a2a441cde599fe$var$dj(a, b, c, d, e);
}
function $40a2a441cde599fe$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $40a2a441cde599fe$var$G($40a2a441cde599fe$var$fj, $40a2a441cde599fe$var$gj), $40a2a441cde599fe$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $40a2a441cde599fe$var$G($40a2a441cde599fe$var$fj, $40a2a441cde599fe$var$gj), $40a2a441cde599fe$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $40a2a441cde599fe$var$G($40a2a441cde599fe$var$fj, $40a2a441cde599fe$var$gj);
            $40a2a441cde599fe$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $40a2a441cde599fe$var$G($40a2a441cde599fe$var$fj, $40a2a441cde599fe$var$gj), $40a2a441cde599fe$var$gj |= d;
    $40a2a441cde599fe$var$Yi(a, b, e, c);
    return b.child;
}
function $40a2a441cde599fe$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $40a2a441cde599fe$var$dj(a, b, c, d, e) {
    var f = $40a2a441cde599fe$var$Zf(c) ? $40a2a441cde599fe$var$Xf : $40a2a441cde599fe$var$H.current;
    f = $40a2a441cde599fe$var$Yf(b, f);
    $40a2a441cde599fe$var$Tg(b, e);
    c = $40a2a441cde599fe$var$Xh(a, b, c, d, f, e);
    d = $40a2a441cde599fe$var$bi();
    if (null !== a && !$40a2a441cde599fe$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $40a2a441cde599fe$var$$i(a, b, e);
    $40a2a441cde599fe$var$I && d && $40a2a441cde599fe$var$vg(b);
    b.flags |= 1;
    $40a2a441cde599fe$var$Yi(a, b, c, e);
    return b.child;
}
function $40a2a441cde599fe$var$ij(a, b, c, d, e) {
    if ($40a2a441cde599fe$var$Zf(c)) {
        var f = !0;
        $40a2a441cde599fe$var$cg(b);
    } else f = !1;
    $40a2a441cde599fe$var$Tg(b, e);
    if (null === b.stateNode) $40a2a441cde599fe$var$jj(a, b), $40a2a441cde599fe$var$ph(b, c, d), $40a2a441cde599fe$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $40a2a441cde599fe$var$Vg(l) : (l = $40a2a441cde599fe$var$Zf(c) ? $40a2a441cde599fe$var$Xf : $40a2a441cde599fe$var$H.current, l = $40a2a441cde599fe$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $40a2a441cde599fe$var$qh(b, g, d, l);
        $40a2a441cde599fe$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $40a2a441cde599fe$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $40a2a441cde599fe$var$Wf.current || $40a2a441cde599fe$var$$g ? ("function" === typeof m && ($40a2a441cde599fe$var$kh(b, c, m, d), k = b.memoizedState), (h = $40a2a441cde599fe$var$$g || $40a2a441cde599fe$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $40a2a441cde599fe$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $40a2a441cde599fe$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $40a2a441cde599fe$var$Vg(k) : (k = $40a2a441cde599fe$var$Zf(c) ? $40a2a441cde599fe$var$Xf : $40a2a441cde599fe$var$H.current, k = $40a2a441cde599fe$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $40a2a441cde599fe$var$qh(b, g, d, k);
        $40a2a441cde599fe$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $40a2a441cde599fe$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $40a2a441cde599fe$var$Wf.current || $40a2a441cde599fe$var$$g ? ("function" === typeof y && ($40a2a441cde599fe$var$kh(b, c, y, d), n = b.memoizedState), (l = $40a2a441cde599fe$var$$g || $40a2a441cde599fe$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $40a2a441cde599fe$var$kj(a, b, c, d, f, e);
}
function $40a2a441cde599fe$var$kj(a, b, c, d, e, f) {
    $40a2a441cde599fe$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $40a2a441cde599fe$var$dg(b, c, !1), $40a2a441cde599fe$var$$i(a, b, f);
    d = b.stateNode;
    $40a2a441cde599fe$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $40a2a441cde599fe$var$Bh(b, a.child, null, f), b.child = $40a2a441cde599fe$var$Bh(b, null, h, f)) : $40a2a441cde599fe$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $40a2a441cde599fe$var$dg(b, c, !0);
    return b.child;
}
function $40a2a441cde599fe$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $40a2a441cde599fe$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $40a2a441cde599fe$var$ag(a, b.context, !1);
    $40a2a441cde599fe$var$Ih(a, b.containerInfo);
}
function $40a2a441cde599fe$var$mj(a, b, c, d, e) {
    $40a2a441cde599fe$var$Ig();
    $40a2a441cde599fe$var$Jg(e);
    b.flags |= 256;
    $40a2a441cde599fe$var$Yi(a, b, c, d);
    return b.child;
}
var $40a2a441cde599fe$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $40a2a441cde599fe$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $40a2a441cde599fe$var$pj(a, b, c) {
    var d = b.pendingProps, e = $40a2a441cde599fe$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, e & 1);
    if (null === a) {
        $40a2a441cde599fe$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $40a2a441cde599fe$var$qj(g, d, 0, null), a = $40a2a441cde599fe$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $40a2a441cde599fe$var$oj(c), b.memoizedState = $40a2a441cde599fe$var$nj, a) : $40a2a441cde599fe$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $40a2a441cde599fe$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $40a2a441cde599fe$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $40a2a441cde599fe$var$wh(h, f) : (f = $40a2a441cde599fe$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $40a2a441cde599fe$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $40a2a441cde599fe$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $40a2a441cde599fe$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $40a2a441cde599fe$var$rj(a, b) {
    b = $40a2a441cde599fe$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $40a2a441cde599fe$var$tj(a, b, c, d) {
    null !== d && $40a2a441cde599fe$var$Jg(d);
    $40a2a441cde599fe$var$Bh(b, a.child, null, c);
    a = $40a2a441cde599fe$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $40a2a441cde599fe$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $40a2a441cde599fe$var$Li(Error($40a2a441cde599fe$var$p(422))), $40a2a441cde599fe$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $40a2a441cde599fe$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $40a2a441cde599fe$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $40a2a441cde599fe$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $40a2a441cde599fe$var$oj(g);
        b.memoizedState = $40a2a441cde599fe$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $40a2a441cde599fe$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($40a2a441cde599fe$var$p(419));
        d = $40a2a441cde599fe$var$Li(f, d, void 0);
        return $40a2a441cde599fe$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($40a2a441cde599fe$var$Ug || h) {
        d = $40a2a441cde599fe$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $40a2a441cde599fe$var$Zg(a, e), $40a2a441cde599fe$var$mh(d, a, e, -1));
        }
        $40a2a441cde599fe$var$uj();
        d = $40a2a441cde599fe$var$Li(Error($40a2a441cde599fe$var$p(421)));
        return $40a2a441cde599fe$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $40a2a441cde599fe$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $40a2a441cde599fe$var$yg = $40a2a441cde599fe$var$Lf(e.nextSibling);
    $40a2a441cde599fe$var$xg = b;
    $40a2a441cde599fe$var$I = !0;
    $40a2a441cde599fe$var$zg = null;
    null !== a && ($40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg++] = $40a2a441cde599fe$var$rg, $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg++] = $40a2a441cde599fe$var$sg, $40a2a441cde599fe$var$og[$40a2a441cde599fe$var$pg++] = $40a2a441cde599fe$var$qg, $40a2a441cde599fe$var$rg = a.id, $40a2a441cde599fe$var$sg = a.overflow, $40a2a441cde599fe$var$qg = b);
    b = $40a2a441cde599fe$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $40a2a441cde599fe$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $40a2a441cde599fe$var$Sg(a.return, b, c);
}
function $40a2a441cde599fe$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $40a2a441cde599fe$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $40a2a441cde599fe$var$Yi(a, b, d.children, c);
    d = $40a2a441cde599fe$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $40a2a441cde599fe$var$wj(a, c, b);
            else if (19 === a.tag) $40a2a441cde599fe$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $40a2a441cde599fe$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $40a2a441cde599fe$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $40a2a441cde599fe$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $40a2a441cde599fe$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $40a2a441cde599fe$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $40a2a441cde599fe$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $40a2a441cde599fe$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $40a2a441cde599fe$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($40a2a441cde599fe$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $40a2a441cde599fe$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $40a2a441cde599fe$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $40a2a441cde599fe$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $40a2a441cde599fe$var$lj(b);
            $40a2a441cde599fe$var$Ig();
            break;
        case 5:
            $40a2a441cde599fe$var$Kh(b);
            break;
        case 1:
            $40a2a441cde599fe$var$Zf(b.type) && $40a2a441cde599fe$var$cg(b);
            break;
        case 4:
            $40a2a441cde599fe$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, $40a2a441cde599fe$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $40a2a441cde599fe$var$pj(a, b, c);
                $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, $40a2a441cde599fe$var$M.current & 1);
                a = $40a2a441cde599fe$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, $40a2a441cde599fe$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $40a2a441cde599fe$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, $40a2a441cde599fe$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $40a2a441cde599fe$var$ej(a, b, c);
    }
    return $40a2a441cde599fe$var$$i(a, b, c);
}
var $40a2a441cde599fe$var$Aj, $40a2a441cde599fe$var$Bj, $40a2a441cde599fe$var$Cj, $40a2a441cde599fe$var$Dj;
$40a2a441cde599fe$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$40a2a441cde599fe$var$Bj = function() {};
$40a2a441cde599fe$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $40a2a441cde599fe$var$Hh($40a2a441cde599fe$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $40a2a441cde599fe$var$Ya(a, e);
                d = $40a2a441cde599fe$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $40a2a441cde599fe$var$A({}, e, {
                    value: void 0
                });
                d = $40a2a441cde599fe$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $40a2a441cde599fe$var$gb(a, e);
                d = $40a2a441cde599fe$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $40a2a441cde599fe$var$Bf);
        }
        $40a2a441cde599fe$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($40a2a441cde599fe$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($40a2a441cde599fe$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $40a2a441cde599fe$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$40a2a441cde599fe$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $40a2a441cde599fe$var$Ej(a, b) {
    if (!$40a2a441cde599fe$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $40a2a441cde599fe$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $40a2a441cde599fe$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $40a2a441cde599fe$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $40a2a441cde599fe$var$S(b), null;
        case 1:
            return $40a2a441cde599fe$var$Zf(b.type) && $40a2a441cde599fe$var$$f(), $40a2a441cde599fe$var$S(b), null;
        case 3:
            d = b.stateNode;
            $40a2a441cde599fe$var$Jh();
            $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Wf);
            $40a2a441cde599fe$var$E($40a2a441cde599fe$var$H);
            $40a2a441cde599fe$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $40a2a441cde599fe$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $40a2a441cde599fe$var$zg && ($40a2a441cde599fe$var$Gj($40a2a441cde599fe$var$zg), $40a2a441cde599fe$var$zg = null));
            $40a2a441cde599fe$var$Bj(a, b);
            $40a2a441cde599fe$var$S(b);
            return null;
        case 5:
            $40a2a441cde599fe$var$Lh(b);
            var e = $40a2a441cde599fe$var$Hh($40a2a441cde599fe$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $40a2a441cde599fe$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($40a2a441cde599fe$var$p(166));
                    $40a2a441cde599fe$var$S(b);
                    return null;
                }
                a = $40a2a441cde599fe$var$Hh($40a2a441cde599fe$var$Eh.current);
                if ($40a2a441cde599fe$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$40a2a441cde599fe$var$Of] = b;
                    d[$40a2a441cde599fe$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $40a2a441cde599fe$var$D("cancel", d);
                            $40a2a441cde599fe$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $40a2a441cde599fe$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $40a2a441cde599fe$var$lf.length; e++)$40a2a441cde599fe$var$D($40a2a441cde599fe$var$lf[e], d);
                            break;
                        case "source":
                            $40a2a441cde599fe$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $40a2a441cde599fe$var$D("error", d);
                            $40a2a441cde599fe$var$D("load", d);
                            break;
                        case "details":
                            $40a2a441cde599fe$var$D("toggle", d);
                            break;
                        case "input":
                            $40a2a441cde599fe$var$Za(d, f);
                            $40a2a441cde599fe$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $40a2a441cde599fe$var$D("invalid", d);
                            break;
                        case "textarea":
                            $40a2a441cde599fe$var$hb(d, f), $40a2a441cde599fe$var$D("invalid", d);
                    }
                    $40a2a441cde599fe$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $40a2a441cde599fe$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $40a2a441cde599fe$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $40a2a441cde599fe$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $40a2a441cde599fe$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $40a2a441cde599fe$var$Va(d);
                            $40a2a441cde599fe$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $40a2a441cde599fe$var$Va(d);
                            $40a2a441cde599fe$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $40a2a441cde599fe$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $40a2a441cde599fe$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$40a2a441cde599fe$var$Of] = b;
                    a[$40a2a441cde599fe$var$Pf] = d;
                    $40a2a441cde599fe$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $40a2a441cde599fe$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $40a2a441cde599fe$var$D("cancel", a);
                                $40a2a441cde599fe$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $40a2a441cde599fe$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $40a2a441cde599fe$var$lf.length; e++)$40a2a441cde599fe$var$D($40a2a441cde599fe$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $40a2a441cde599fe$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $40a2a441cde599fe$var$D("error", a);
                                $40a2a441cde599fe$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $40a2a441cde599fe$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $40a2a441cde599fe$var$Za(a, d);
                                e = $40a2a441cde599fe$var$Ya(a, d);
                                $40a2a441cde599fe$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $40a2a441cde599fe$var$A({}, d, {
                                    value: void 0
                                });
                                $40a2a441cde599fe$var$D("invalid", a);
                                break;
                            case "textarea":
                                $40a2a441cde599fe$var$hb(a, d);
                                e = $40a2a441cde599fe$var$gb(a, d);
                                $40a2a441cde599fe$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $40a2a441cde599fe$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $40a2a441cde599fe$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $40a2a441cde599fe$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $40a2a441cde599fe$var$ob(a, k) : "number" === typeof k && $40a2a441cde599fe$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($40a2a441cde599fe$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $40a2a441cde599fe$var$D("scroll", a) : null != k && $40a2a441cde599fe$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $40a2a441cde599fe$var$Va(a);
                                $40a2a441cde599fe$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $40a2a441cde599fe$var$Va(a);
                                $40a2a441cde599fe$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $40a2a441cde599fe$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $40a2a441cde599fe$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $40a2a441cde599fe$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $40a2a441cde599fe$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $40a2a441cde599fe$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $40a2a441cde599fe$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($40a2a441cde599fe$var$p(166));
                c = $40a2a441cde599fe$var$Hh($40a2a441cde599fe$var$Gh.current);
                $40a2a441cde599fe$var$Hh($40a2a441cde599fe$var$Eh.current);
                if ($40a2a441cde599fe$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$40a2a441cde599fe$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $40a2a441cde599fe$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $40a2a441cde599fe$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $40a2a441cde599fe$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$40a2a441cde599fe$var$Of] = b, b.stateNode = d;
            }
            $40a2a441cde599fe$var$S(b);
            return null;
        case 13:
            $40a2a441cde599fe$var$E($40a2a441cde599fe$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($40a2a441cde599fe$var$I && null !== $40a2a441cde599fe$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $40a2a441cde599fe$var$Hg(), $40a2a441cde599fe$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $40a2a441cde599fe$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($40a2a441cde599fe$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($40a2a441cde599fe$var$p(317));
                        f[$40a2a441cde599fe$var$Of] = b;
                    } else $40a2a441cde599fe$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $40a2a441cde599fe$var$S(b);
                    f = !1;
                } else null !== $40a2a441cde599fe$var$zg && ($40a2a441cde599fe$var$Gj($40a2a441cde599fe$var$zg), $40a2a441cde599fe$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($40a2a441cde599fe$var$M.current & 1) ? 0 === $40a2a441cde599fe$var$T && ($40a2a441cde599fe$var$T = 3) : $40a2a441cde599fe$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $40a2a441cde599fe$var$S(b);
            return null;
        case 4:
            return $40a2a441cde599fe$var$Jh(), $40a2a441cde599fe$var$Bj(a, b), null === a && $40a2a441cde599fe$var$sf(b.stateNode.containerInfo), $40a2a441cde599fe$var$S(b), null;
        case 10:
            return $40a2a441cde599fe$var$Rg(b.type._context), $40a2a441cde599fe$var$S(b), null;
        case 17:
            return $40a2a441cde599fe$var$Zf(b.type) && $40a2a441cde599fe$var$$f(), $40a2a441cde599fe$var$S(b), null;
        case 19:
            $40a2a441cde599fe$var$E($40a2a441cde599fe$var$M);
            f = b.memoizedState;
            if (null === f) return $40a2a441cde599fe$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $40a2a441cde599fe$var$Ej(f, !1);
                else {
                    if (0 !== $40a2a441cde599fe$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $40a2a441cde599fe$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $40a2a441cde599fe$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, $40a2a441cde599fe$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $40a2a441cde599fe$var$B() > $40a2a441cde599fe$var$Hj && (b.flags |= 128, d = !0, $40a2a441cde599fe$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $40a2a441cde599fe$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $40a2a441cde599fe$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$40a2a441cde599fe$var$I) return $40a2a441cde599fe$var$S(b), null;
                    } else 2 * $40a2a441cde599fe$var$B() - f.renderingStartTime > $40a2a441cde599fe$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $40a2a441cde599fe$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $40a2a441cde599fe$var$B(), b.sibling = null, c = $40a2a441cde599fe$var$M.current, $40a2a441cde599fe$var$G($40a2a441cde599fe$var$M, d ? c & 1 | 2 : c & 1), b;
            $40a2a441cde599fe$var$S(b);
            return null;
        case 22:
        case 23:
            return $40a2a441cde599fe$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($40a2a441cde599fe$var$gj & 1073741824) && ($40a2a441cde599fe$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $40a2a441cde599fe$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($40a2a441cde599fe$var$p(156, b.tag));
}
function $40a2a441cde599fe$var$Jj(a, b) {
    $40a2a441cde599fe$var$wg(b);
    switch(b.tag){
        case 1:
            return $40a2a441cde599fe$var$Zf(b.type) && $40a2a441cde599fe$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $40a2a441cde599fe$var$Jh(), $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Wf), $40a2a441cde599fe$var$E($40a2a441cde599fe$var$H), $40a2a441cde599fe$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $40a2a441cde599fe$var$Lh(b), null;
        case 13:
            $40a2a441cde599fe$var$E($40a2a441cde599fe$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($40a2a441cde599fe$var$p(340));
                $40a2a441cde599fe$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $40a2a441cde599fe$var$E($40a2a441cde599fe$var$M), null;
        case 4:
            return $40a2a441cde599fe$var$Jh(), null;
        case 10:
            return $40a2a441cde599fe$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $40a2a441cde599fe$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $40a2a441cde599fe$var$Kj = !1, $40a2a441cde599fe$var$U = !1, $40a2a441cde599fe$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $40a2a441cde599fe$var$V = null;
function $40a2a441cde599fe$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $40a2a441cde599fe$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $40a2a441cde599fe$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $40a2a441cde599fe$var$W(a, b, d);
    }
}
var $40a2a441cde599fe$var$Oj = !1;
function $40a2a441cde599fe$var$Pj(a, b) {
    $40a2a441cde599fe$var$Cf = $40a2a441cde599fe$var$dd;
    a = $40a2a441cde599fe$var$Me();
    if ($40a2a441cde599fe$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $40a2a441cde599fe$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $40a2a441cde599fe$var$dd = !1;
    for($40a2a441cde599fe$var$V = b; null !== $40a2a441cde599fe$var$V;)if (b = $40a2a441cde599fe$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $40a2a441cde599fe$var$V = a;
    else for(; null !== $40a2a441cde599fe$var$V;){
        b = $40a2a441cde599fe$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $40a2a441cde599fe$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($40a2a441cde599fe$var$p(163));
            }
        } catch (F) {
            $40a2a441cde599fe$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $40a2a441cde599fe$var$V = a;
            break;
        }
        $40a2a441cde599fe$var$V = b.return;
    }
    n = $40a2a441cde599fe$var$Oj;
    $40a2a441cde599fe$var$Oj = !1;
    return n;
}
function $40a2a441cde599fe$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $40a2a441cde599fe$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $40a2a441cde599fe$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $40a2a441cde599fe$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $40a2a441cde599fe$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $40a2a441cde599fe$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$40a2a441cde599fe$var$Of], delete b[$40a2a441cde599fe$var$Pf], delete b[$40a2a441cde599fe$var$of], delete b[$40a2a441cde599fe$var$Qf], delete b[$40a2a441cde599fe$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $40a2a441cde599fe$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $40a2a441cde599fe$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $40a2a441cde599fe$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $40a2a441cde599fe$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $40a2a441cde599fe$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($40a2a441cde599fe$var$Wj(a, b, c), a = a.sibling; null !== a;)$40a2a441cde599fe$var$Wj(a, b, c), a = a.sibling;
}
function $40a2a441cde599fe$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($40a2a441cde599fe$var$Xj(a, b, c), a = a.sibling; null !== a;)$40a2a441cde599fe$var$Xj(a, b, c), a = a.sibling;
}
var $40a2a441cde599fe$var$X = null, $40a2a441cde599fe$var$Yj = !1;
function $40a2a441cde599fe$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$40a2a441cde599fe$var$ak(a, b, c), c = c.sibling;
}
function $40a2a441cde599fe$var$ak(a, b, c) {
    if ($40a2a441cde599fe$var$lc && "function" === typeof $40a2a441cde599fe$var$lc.onCommitFiberUnmount) try {
        $40a2a441cde599fe$var$lc.onCommitFiberUnmount($40a2a441cde599fe$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $40a2a441cde599fe$var$U || $40a2a441cde599fe$var$Mj(c, b);
        case 6:
            var d = $40a2a441cde599fe$var$X, e = $40a2a441cde599fe$var$Yj;
            $40a2a441cde599fe$var$X = null;
            $40a2a441cde599fe$var$Zj(a, b, c);
            $40a2a441cde599fe$var$X = d;
            $40a2a441cde599fe$var$Yj = e;
            null !== $40a2a441cde599fe$var$X && ($40a2a441cde599fe$var$Yj ? (a = $40a2a441cde599fe$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $40a2a441cde599fe$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $40a2a441cde599fe$var$X && ($40a2a441cde599fe$var$Yj ? (a = $40a2a441cde599fe$var$X, c = c.stateNode, 8 === a.nodeType ? $40a2a441cde599fe$var$Kf(a.parentNode, c) : 1 === a.nodeType && $40a2a441cde599fe$var$Kf(a, c), $40a2a441cde599fe$var$bd(a)) : $40a2a441cde599fe$var$Kf($40a2a441cde599fe$var$X, c.stateNode));
            break;
        case 4:
            d = $40a2a441cde599fe$var$X;
            e = $40a2a441cde599fe$var$Yj;
            $40a2a441cde599fe$var$X = c.stateNode.containerInfo;
            $40a2a441cde599fe$var$Yj = !0;
            $40a2a441cde599fe$var$Zj(a, b, c);
            $40a2a441cde599fe$var$X = d;
            $40a2a441cde599fe$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$40a2a441cde599fe$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $40a2a441cde599fe$var$Nj(c, b, g) : 0 !== (f & 4) && $40a2a441cde599fe$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $40a2a441cde599fe$var$Zj(a, b, c);
            break;
        case 1:
            if (!$40a2a441cde599fe$var$U && ($40a2a441cde599fe$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $40a2a441cde599fe$var$W(c, b, h);
            }
            $40a2a441cde599fe$var$Zj(a, b, c);
            break;
        case 21:
            $40a2a441cde599fe$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($40a2a441cde599fe$var$U = (d = $40a2a441cde599fe$var$U) || null !== c.memoizedState, $40a2a441cde599fe$var$Zj(a, b, c), $40a2a441cde599fe$var$U = d) : $40a2a441cde599fe$var$Zj(a, b, c);
            break;
        default:
            $40a2a441cde599fe$var$Zj(a, b, c);
    }
}
function $40a2a441cde599fe$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $40a2a441cde599fe$var$Lj);
        b.forEach(function(b) {
            var d = $40a2a441cde599fe$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $40a2a441cde599fe$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $40a2a441cde599fe$var$X = h.stateNode;
                        $40a2a441cde599fe$var$Yj = !1;
                        break a;
                    case 3:
                        $40a2a441cde599fe$var$X = h.stateNode.containerInfo;
                        $40a2a441cde599fe$var$Yj = !0;
                        break a;
                    case 4:
                        $40a2a441cde599fe$var$X = h.stateNode.containerInfo;
                        $40a2a441cde599fe$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $40a2a441cde599fe$var$X) throw Error($40a2a441cde599fe$var$p(160));
            $40a2a441cde599fe$var$ak(f, g, e);
            $40a2a441cde599fe$var$X = null;
            $40a2a441cde599fe$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $40a2a441cde599fe$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$40a2a441cde599fe$var$ek(b, a), b = b.sibling;
}
function $40a2a441cde599fe$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            if (d & 4) {
                try {
                    $40a2a441cde599fe$var$Qj(3, a, a.return), $40a2a441cde599fe$var$Rj(3, a);
                } catch (t) {
                    $40a2a441cde599fe$var$W(a, a.return, t);
                }
                try {
                    $40a2a441cde599fe$var$Qj(5, a, a.return);
                } catch (t) {
                    $40a2a441cde599fe$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            d & 512 && null !== c && $40a2a441cde599fe$var$Mj(c, c.return);
            break;
        case 5:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            d & 512 && null !== c && $40a2a441cde599fe$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $40a2a441cde599fe$var$ob(e, "");
                } catch (t) {
                    $40a2a441cde599fe$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $40a2a441cde599fe$var$ab(e, f);
                    $40a2a441cde599fe$var$vb(h, g);
                    var l = $40a2a441cde599fe$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $40a2a441cde599fe$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $40a2a441cde599fe$var$nb(e, q) : "children" === m ? $40a2a441cde599fe$var$ob(e, q) : $40a2a441cde599fe$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $40a2a441cde599fe$var$bb(e, f);
                            break;
                        case "textarea":
                            $40a2a441cde599fe$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $40a2a441cde599fe$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $40a2a441cde599fe$var$fb(e, !!f.multiple, f.defaultValue, !0) : $40a2a441cde599fe$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$40a2a441cde599fe$var$Pf] = f;
                } catch (t) {
                    $40a2a441cde599fe$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($40a2a441cde599fe$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $40a2a441cde599fe$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $40a2a441cde599fe$var$bd(b.containerInfo);
            } catch (t) {
                $40a2a441cde599fe$var$W(a, a.return, t);
            }
            break;
        case 4:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            break;
        case 13:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($40a2a441cde599fe$var$gk = $40a2a441cde599fe$var$B()));
            d & 4 && $40a2a441cde599fe$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($40a2a441cde599fe$var$U = (l = $40a2a441cde599fe$var$U) || m, $40a2a441cde599fe$var$dk(b, a), $40a2a441cde599fe$var$U = l) : $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($40a2a441cde599fe$var$V = a, m = a.child; null !== m;){
                    for(q = $40a2a441cde599fe$var$V = m; null !== $40a2a441cde599fe$var$V;){
                        r = $40a2a441cde599fe$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $40a2a441cde599fe$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $40a2a441cde599fe$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $40a2a441cde599fe$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $40a2a441cde599fe$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $40a2a441cde599fe$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $40a2a441cde599fe$var$V = y) : $40a2a441cde599fe$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $40a2a441cde599fe$var$rb("display", g));
                            } catch (t) {
                                $40a2a441cde599fe$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $40a2a441cde599fe$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $40a2a441cde599fe$var$dk(b, a);
            $40a2a441cde599fe$var$fk(a);
            d & 4 && $40a2a441cde599fe$var$bk(a);
            break;
        case 21:
            break;
        default:
            $40a2a441cde599fe$var$dk(b, a), $40a2a441cde599fe$var$fk(a);
    }
}
function $40a2a441cde599fe$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($40a2a441cde599fe$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($40a2a441cde599fe$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($40a2a441cde599fe$var$ob(e, ""), d.flags &= -33);
                    var f = $40a2a441cde599fe$var$Vj(a);
                    $40a2a441cde599fe$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $40a2a441cde599fe$var$Vj(a);
                    $40a2a441cde599fe$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($40a2a441cde599fe$var$p(161));
            }
        } catch (k) {
            $40a2a441cde599fe$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $40a2a441cde599fe$var$ik(a, b, c) {
    $40a2a441cde599fe$var$V = a;
    $40a2a441cde599fe$var$jk(a, b, c);
}
function $40a2a441cde599fe$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $40a2a441cde599fe$var$V;){
        var e = $40a2a441cde599fe$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $40a2a441cde599fe$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $40a2a441cde599fe$var$U;
                h = $40a2a441cde599fe$var$Kj;
                var l = $40a2a441cde599fe$var$U;
                $40a2a441cde599fe$var$Kj = g;
                if (($40a2a441cde599fe$var$U = k) && !l) for($40a2a441cde599fe$var$V = e; null !== $40a2a441cde599fe$var$V;)g = $40a2a441cde599fe$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $40a2a441cde599fe$var$kk(e) : null !== k ? (k.return = g, $40a2a441cde599fe$var$V = k) : $40a2a441cde599fe$var$kk(e);
                for(; null !== f;)$40a2a441cde599fe$var$V = f, $40a2a441cde599fe$var$jk(f, b, c), f = f.sibling;
                $40a2a441cde599fe$var$V = e;
                $40a2a441cde599fe$var$Kj = h;
                $40a2a441cde599fe$var$U = l;
            }
            $40a2a441cde599fe$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $40a2a441cde599fe$var$V = f) : $40a2a441cde599fe$var$lk(a, b, c);
    }
}
function $40a2a441cde599fe$var$lk(a) {
    for(; null !== $40a2a441cde599fe$var$V;){
        var b = $40a2a441cde599fe$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $40a2a441cde599fe$var$U || $40a2a441cde599fe$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$40a2a441cde599fe$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $40a2a441cde599fe$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $40a2a441cde599fe$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $40a2a441cde599fe$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $40a2a441cde599fe$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($40a2a441cde599fe$var$p(163));
                }
                $40a2a441cde599fe$var$U || b.flags & 512 && $40a2a441cde599fe$var$Sj(b);
            } catch (r) {
                $40a2a441cde599fe$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $40a2a441cde599fe$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $40a2a441cde599fe$var$V = c;
            break;
        }
        $40a2a441cde599fe$var$V = b.return;
    }
}
function $40a2a441cde599fe$var$hk(a) {
    for(; null !== $40a2a441cde599fe$var$V;){
        var b = $40a2a441cde599fe$var$V;
        if (b === a) {
            $40a2a441cde599fe$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $40a2a441cde599fe$var$V = c;
            break;
        }
        $40a2a441cde599fe$var$V = b.return;
    }
}
function $40a2a441cde599fe$var$kk(a) {
    for(; null !== $40a2a441cde599fe$var$V;){
        var b = $40a2a441cde599fe$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $40a2a441cde599fe$var$Rj(4, b);
                    } catch (k) {
                        $40a2a441cde599fe$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $40a2a441cde599fe$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $40a2a441cde599fe$var$Sj(b);
                    } catch (k) {
                        $40a2a441cde599fe$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $40a2a441cde599fe$var$Sj(b);
                    } catch (k) {
                        $40a2a441cde599fe$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $40a2a441cde599fe$var$W(b, b.return, k);
        }
        if (b === a) {
            $40a2a441cde599fe$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $40a2a441cde599fe$var$V = h;
            break;
        }
        $40a2a441cde599fe$var$V = b.return;
    }
}
var $40a2a441cde599fe$var$mk = Math.ceil, $40a2a441cde599fe$var$nk = $40a2a441cde599fe$var$ua.ReactCurrentDispatcher, $40a2a441cde599fe$var$ok = $40a2a441cde599fe$var$ua.ReactCurrentOwner, $40a2a441cde599fe$var$pk = $40a2a441cde599fe$var$ua.ReactCurrentBatchConfig, $40a2a441cde599fe$var$K = 0, $40a2a441cde599fe$var$R = null, $40a2a441cde599fe$var$Y = null, $40a2a441cde599fe$var$Z = 0, $40a2a441cde599fe$var$gj = 0, $40a2a441cde599fe$var$fj = $40a2a441cde599fe$var$Uf(0), $40a2a441cde599fe$var$T = 0, $40a2a441cde599fe$var$qk = null, $40a2a441cde599fe$var$hh = 0, $40a2a441cde599fe$var$rk = 0, $40a2a441cde599fe$var$sk = 0, $40a2a441cde599fe$var$tk = null, $40a2a441cde599fe$var$uk = null, $40a2a441cde599fe$var$gk = 0, $40a2a441cde599fe$var$Hj = Infinity, $40a2a441cde599fe$var$vk = null, $40a2a441cde599fe$var$Pi = !1, $40a2a441cde599fe$var$Qi = null, $40a2a441cde599fe$var$Si = null, $40a2a441cde599fe$var$wk = !1, $40a2a441cde599fe$var$xk = null, $40a2a441cde599fe$var$yk = 0, $40a2a441cde599fe$var$zk = 0, $40a2a441cde599fe$var$Ak = null, $40a2a441cde599fe$var$Bk = -1, $40a2a441cde599fe$var$Ck = 0;
function $40a2a441cde599fe$var$L() {
    return 0 !== ($40a2a441cde599fe$var$K & 6) ? $40a2a441cde599fe$var$B() : -1 !== $40a2a441cde599fe$var$Bk ? $40a2a441cde599fe$var$Bk : $40a2a441cde599fe$var$Bk = $40a2a441cde599fe$var$B();
}
function $40a2a441cde599fe$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($40a2a441cde599fe$var$K & 2) && 0 !== $40a2a441cde599fe$var$Z) return $40a2a441cde599fe$var$Z & -$40a2a441cde599fe$var$Z;
    if (null !== $40a2a441cde599fe$var$Kg.transition) return 0 === $40a2a441cde599fe$var$Ck && ($40a2a441cde599fe$var$Ck = $40a2a441cde599fe$var$yc()), $40a2a441cde599fe$var$Ck;
    a = $40a2a441cde599fe$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $40a2a441cde599fe$var$jd(a.type);
    return a;
}
function $40a2a441cde599fe$var$mh(a, b, c, d) {
    if (50 < $40a2a441cde599fe$var$zk) throw $40a2a441cde599fe$var$zk = 0, $40a2a441cde599fe$var$Ak = null, Error($40a2a441cde599fe$var$p(185));
    $40a2a441cde599fe$var$Ac(a, c, d);
    if (0 === ($40a2a441cde599fe$var$K & 2) || a !== $40a2a441cde599fe$var$R) a === $40a2a441cde599fe$var$R && (0 === ($40a2a441cde599fe$var$K & 2) && ($40a2a441cde599fe$var$rk |= c), 4 === $40a2a441cde599fe$var$T && $40a2a441cde599fe$var$Dk(a, $40a2a441cde599fe$var$Z)), $40a2a441cde599fe$var$Ek(a, d), 1 === c && 0 === $40a2a441cde599fe$var$K && 0 === (b.mode & 1) && ($40a2a441cde599fe$var$Hj = $40a2a441cde599fe$var$B() + 500, $40a2a441cde599fe$var$fg && $40a2a441cde599fe$var$jg());
}
function $40a2a441cde599fe$var$Ek(a, b) {
    var c = a.callbackNode;
    $40a2a441cde599fe$var$wc(a, b);
    var d = $40a2a441cde599fe$var$uc(a, a === $40a2a441cde599fe$var$R ? $40a2a441cde599fe$var$Z : 0);
    if (0 === d) null !== c && $40a2a441cde599fe$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $40a2a441cde599fe$var$bc(c);
        if (1 === b) 0 === a.tag ? $40a2a441cde599fe$var$ig($40a2a441cde599fe$var$Fk.bind(null, a)) : $40a2a441cde599fe$var$hg($40a2a441cde599fe$var$Fk.bind(null, a)), $40a2a441cde599fe$var$Jf(function() {
            0 === ($40a2a441cde599fe$var$K & 6) && $40a2a441cde599fe$var$jg();
        }), c = null;
        else {
            switch($40a2a441cde599fe$var$Dc(d)){
                case 1:
                    c = $40a2a441cde599fe$var$fc;
                    break;
                case 4:
                    c = $40a2a441cde599fe$var$gc;
                    break;
                case 16:
                    c = $40a2a441cde599fe$var$hc;
                    break;
                case 536870912:
                    c = $40a2a441cde599fe$var$jc;
                    break;
                default:
                    c = $40a2a441cde599fe$var$hc;
            }
            c = $40a2a441cde599fe$var$Gk(c, $40a2a441cde599fe$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $40a2a441cde599fe$var$Hk(a, b) {
    $40a2a441cde599fe$var$Bk = -1;
    $40a2a441cde599fe$var$Ck = 0;
    if (0 !== ($40a2a441cde599fe$var$K & 6)) throw Error($40a2a441cde599fe$var$p(327));
    var c = a.callbackNode;
    if ($40a2a441cde599fe$var$Ik() && a.callbackNode !== c) return null;
    var d = $40a2a441cde599fe$var$uc(a, a === $40a2a441cde599fe$var$R ? $40a2a441cde599fe$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $40a2a441cde599fe$var$Jk(a, d);
    else {
        b = d;
        var e = $40a2a441cde599fe$var$K;
        $40a2a441cde599fe$var$K |= 2;
        var f = $40a2a441cde599fe$var$Kk();
        if ($40a2a441cde599fe$var$R !== a || $40a2a441cde599fe$var$Z !== b) $40a2a441cde599fe$var$vk = null, $40a2a441cde599fe$var$Hj = $40a2a441cde599fe$var$B() + 500, $40a2a441cde599fe$var$Lk(a, b);
        for(;;)try {
            $40a2a441cde599fe$var$Mk();
            break;
        } catch (h) {
            $40a2a441cde599fe$var$Nk(a, h);
        }
        $40a2a441cde599fe$var$Qg();
        $40a2a441cde599fe$var$nk.current = f;
        $40a2a441cde599fe$var$K = e;
        null !== $40a2a441cde599fe$var$Y ? b = 0 : ($40a2a441cde599fe$var$R = null, $40a2a441cde599fe$var$Z = 0, b = $40a2a441cde599fe$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $40a2a441cde599fe$var$xc(a), 0 !== e && (d = e, b = $40a2a441cde599fe$var$Ok(a, e)));
        if (1 === b) throw c = $40a2a441cde599fe$var$qk, $40a2a441cde599fe$var$Lk(a, 0), $40a2a441cde599fe$var$Dk(a, d), $40a2a441cde599fe$var$Ek(a, $40a2a441cde599fe$var$B()), c;
        if (6 === b) $40a2a441cde599fe$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$40a2a441cde599fe$var$Pk(e) && (b = $40a2a441cde599fe$var$Jk(a, d), 2 === b && (f = $40a2a441cde599fe$var$xc(a), 0 !== f && (d = f, b = $40a2a441cde599fe$var$Ok(a, f))), 1 === b)) throw c = $40a2a441cde599fe$var$qk, $40a2a441cde599fe$var$Lk(a, 0), $40a2a441cde599fe$var$Dk(a, d), $40a2a441cde599fe$var$Ek(a, $40a2a441cde599fe$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($40a2a441cde599fe$var$p(345));
                case 2:
                    $40a2a441cde599fe$var$Qk(a, $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$vk);
                    break;
                case 3:
                    $40a2a441cde599fe$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $40a2a441cde599fe$var$gk + 500 - $40a2a441cde599fe$var$B(), 10 < b)) {
                        if (0 !== $40a2a441cde599fe$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $40a2a441cde599fe$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $40a2a441cde599fe$var$Ff($40a2a441cde599fe$var$Qk.bind(null, a, $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$vk), b);
                        break;
                    }
                    $40a2a441cde599fe$var$Qk(a, $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$vk);
                    break;
                case 4:
                    $40a2a441cde599fe$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $40a2a441cde599fe$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $40a2a441cde599fe$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $40a2a441cde599fe$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $40a2a441cde599fe$var$Ff($40a2a441cde599fe$var$Qk.bind(null, a, $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$vk), d);
                        break;
                    }
                    $40a2a441cde599fe$var$Qk(a, $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$vk);
                    break;
                case 5:
                    $40a2a441cde599fe$var$Qk(a, $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$vk);
                    break;
                default:
                    throw Error($40a2a441cde599fe$var$p(329));
            }
        }
    }
    $40a2a441cde599fe$var$Ek(a, $40a2a441cde599fe$var$B());
    return a.callbackNode === c ? $40a2a441cde599fe$var$Hk.bind(null, a) : null;
}
function $40a2a441cde599fe$var$Ok(a, b) {
    var c = $40a2a441cde599fe$var$tk;
    a.current.memoizedState.isDehydrated && ($40a2a441cde599fe$var$Lk(a, b).flags |= 256);
    a = $40a2a441cde599fe$var$Jk(a, b);
    2 !== a && (b = $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$uk = c, null !== b && $40a2a441cde599fe$var$Gj(b));
    return a;
}
function $40a2a441cde599fe$var$Gj(a) {
    null === $40a2a441cde599fe$var$uk ? $40a2a441cde599fe$var$uk = a : $40a2a441cde599fe$var$uk.push.apply($40a2a441cde599fe$var$uk, a);
}
function $40a2a441cde599fe$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$40a2a441cde599fe$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $40a2a441cde599fe$var$Dk(a, b) {
    b &= ~$40a2a441cde599fe$var$sk;
    b &= ~$40a2a441cde599fe$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $40a2a441cde599fe$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $40a2a441cde599fe$var$Fk(a) {
    if (0 !== ($40a2a441cde599fe$var$K & 6)) throw Error($40a2a441cde599fe$var$p(327));
    $40a2a441cde599fe$var$Ik();
    var b = $40a2a441cde599fe$var$uc(a, 0);
    if (0 === (b & 1)) return $40a2a441cde599fe$var$Ek(a, $40a2a441cde599fe$var$B()), null;
    var c = $40a2a441cde599fe$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $40a2a441cde599fe$var$xc(a);
        0 !== d && (b = d, c = $40a2a441cde599fe$var$Ok(a, d));
    }
    if (1 === c) throw c = $40a2a441cde599fe$var$qk, $40a2a441cde599fe$var$Lk(a, 0), $40a2a441cde599fe$var$Dk(a, b), $40a2a441cde599fe$var$Ek(a, $40a2a441cde599fe$var$B()), c;
    if (6 === c) throw Error($40a2a441cde599fe$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $40a2a441cde599fe$var$Qk(a, $40a2a441cde599fe$var$uk, $40a2a441cde599fe$var$vk);
    $40a2a441cde599fe$var$Ek(a, $40a2a441cde599fe$var$B());
    return null;
}
function $40a2a441cde599fe$var$Rk(a, b) {
    var c = $40a2a441cde599fe$var$K;
    $40a2a441cde599fe$var$K |= 1;
    try {
        return a(b);
    } finally{
        $40a2a441cde599fe$var$K = c, 0 === $40a2a441cde599fe$var$K && ($40a2a441cde599fe$var$Hj = $40a2a441cde599fe$var$B() + 500, $40a2a441cde599fe$var$fg && $40a2a441cde599fe$var$jg());
    }
}
function $40a2a441cde599fe$var$Sk(a) {
    null !== $40a2a441cde599fe$var$xk && 0 === $40a2a441cde599fe$var$xk.tag && 0 === ($40a2a441cde599fe$var$K & 6) && $40a2a441cde599fe$var$Ik();
    var b = $40a2a441cde599fe$var$K;
    $40a2a441cde599fe$var$K |= 1;
    var c = $40a2a441cde599fe$var$pk.transition, d = $40a2a441cde599fe$var$C;
    try {
        if ($40a2a441cde599fe$var$pk.transition = null, $40a2a441cde599fe$var$C = 1, a) return a();
    } finally{
        $40a2a441cde599fe$var$C = d, $40a2a441cde599fe$var$pk.transition = c, $40a2a441cde599fe$var$K = b, 0 === ($40a2a441cde599fe$var$K & 6) && $40a2a441cde599fe$var$jg();
    }
}
function $40a2a441cde599fe$var$Ij() {
    $40a2a441cde599fe$var$gj = $40a2a441cde599fe$var$fj.current;
    $40a2a441cde599fe$var$E($40a2a441cde599fe$var$fj);
}
function $40a2a441cde599fe$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $40a2a441cde599fe$var$Gf(c));
    if (null !== $40a2a441cde599fe$var$Y) for(c = $40a2a441cde599fe$var$Y.return; null !== c;){
        var d = c;
        $40a2a441cde599fe$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $40a2a441cde599fe$var$$f();
                break;
            case 3:
                $40a2a441cde599fe$var$Jh();
                $40a2a441cde599fe$var$E($40a2a441cde599fe$var$Wf);
                $40a2a441cde599fe$var$E($40a2a441cde599fe$var$H);
                $40a2a441cde599fe$var$Oh();
                break;
            case 5:
                $40a2a441cde599fe$var$Lh(d);
                break;
            case 4:
                $40a2a441cde599fe$var$Jh();
                break;
            case 13:
                $40a2a441cde599fe$var$E($40a2a441cde599fe$var$M);
                break;
            case 19:
                $40a2a441cde599fe$var$E($40a2a441cde599fe$var$M);
                break;
            case 10:
                $40a2a441cde599fe$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $40a2a441cde599fe$var$Ij();
        }
        c = c.return;
    }
    $40a2a441cde599fe$var$R = a;
    $40a2a441cde599fe$var$Y = a = $40a2a441cde599fe$var$wh(a.current, null);
    $40a2a441cde599fe$var$Z = $40a2a441cde599fe$var$gj = b;
    $40a2a441cde599fe$var$T = 0;
    $40a2a441cde599fe$var$qk = null;
    $40a2a441cde599fe$var$sk = $40a2a441cde599fe$var$rk = $40a2a441cde599fe$var$hh = 0;
    $40a2a441cde599fe$var$uk = $40a2a441cde599fe$var$tk = null;
    if (null !== $40a2a441cde599fe$var$Wg) {
        for(b = 0; b < $40a2a441cde599fe$var$Wg.length; b++)if (c = $40a2a441cde599fe$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $40a2a441cde599fe$var$Wg = null;
    }
    return a;
}
function $40a2a441cde599fe$var$Nk(a, b) {
    do {
        var c = $40a2a441cde599fe$var$Y;
        try {
            $40a2a441cde599fe$var$Qg();
            $40a2a441cde599fe$var$Ph.current = $40a2a441cde599fe$var$ai;
            if ($40a2a441cde599fe$var$Sh) {
                for(var d = $40a2a441cde599fe$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $40a2a441cde599fe$var$Sh = !1;
            }
            $40a2a441cde599fe$var$Rh = 0;
            $40a2a441cde599fe$var$P = $40a2a441cde599fe$var$O = $40a2a441cde599fe$var$N = null;
            $40a2a441cde599fe$var$Th = !1;
            $40a2a441cde599fe$var$Uh = 0;
            $40a2a441cde599fe$var$ok.current = null;
            if (null === c || null === c.return) {
                $40a2a441cde599fe$var$T = 1;
                $40a2a441cde599fe$var$qk = b;
                $40a2a441cde599fe$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $40a2a441cde599fe$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $40a2a441cde599fe$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $40a2a441cde599fe$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $40a2a441cde599fe$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $40a2a441cde599fe$var$Ti(f, l, b);
                            $40a2a441cde599fe$var$uj();
                            break a;
                        }
                        k = Error($40a2a441cde599fe$var$p(426));
                    }
                } else if ($40a2a441cde599fe$var$I && h.mode & 1) {
                    var J = $40a2a441cde599fe$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $40a2a441cde599fe$var$Wi(J, g, h, f, b);
                        $40a2a441cde599fe$var$Jg($40a2a441cde599fe$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $40a2a441cde599fe$var$Ki(k, h);
                4 !== $40a2a441cde599fe$var$T && ($40a2a441cde599fe$var$T = 2);
                null === $40a2a441cde599fe$var$tk ? $40a2a441cde599fe$var$tk = [
                    f
                ] : $40a2a441cde599fe$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $40a2a441cde599fe$var$Oi(f, k, b);
                            $40a2a441cde599fe$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $40a2a441cde599fe$var$Si || !$40a2a441cde599fe$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $40a2a441cde599fe$var$Ri(f, h, b);
                                $40a2a441cde599fe$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $40a2a441cde599fe$var$Tk(c);
        } catch (na) {
            b = na;
            $40a2a441cde599fe$var$Y === c && null !== c && ($40a2a441cde599fe$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $40a2a441cde599fe$var$Kk() {
    var a = $40a2a441cde599fe$var$nk.current;
    $40a2a441cde599fe$var$nk.current = $40a2a441cde599fe$var$ai;
    return null === a ? $40a2a441cde599fe$var$ai : a;
}
function $40a2a441cde599fe$var$uj() {
    if (0 === $40a2a441cde599fe$var$T || 3 === $40a2a441cde599fe$var$T || 2 === $40a2a441cde599fe$var$T) $40a2a441cde599fe$var$T = 4;
    null === $40a2a441cde599fe$var$R || 0 === ($40a2a441cde599fe$var$hh & 268435455) && 0 === ($40a2a441cde599fe$var$rk & 268435455) || $40a2a441cde599fe$var$Dk($40a2a441cde599fe$var$R, $40a2a441cde599fe$var$Z);
}
function $40a2a441cde599fe$var$Jk(a, b) {
    var c = $40a2a441cde599fe$var$K;
    $40a2a441cde599fe$var$K |= 2;
    var d = $40a2a441cde599fe$var$Kk();
    if ($40a2a441cde599fe$var$R !== a || $40a2a441cde599fe$var$Z !== b) $40a2a441cde599fe$var$vk = null, $40a2a441cde599fe$var$Lk(a, b);
    for(;;)try {
        $40a2a441cde599fe$var$Uk();
        break;
    } catch (e) {
        $40a2a441cde599fe$var$Nk(a, e);
    }
    $40a2a441cde599fe$var$Qg();
    $40a2a441cde599fe$var$K = c;
    $40a2a441cde599fe$var$nk.current = d;
    if (null !== $40a2a441cde599fe$var$Y) throw Error($40a2a441cde599fe$var$p(261));
    $40a2a441cde599fe$var$R = null;
    $40a2a441cde599fe$var$Z = 0;
    return $40a2a441cde599fe$var$T;
}
function $40a2a441cde599fe$var$Uk() {
    for(; null !== $40a2a441cde599fe$var$Y;)$40a2a441cde599fe$var$Vk($40a2a441cde599fe$var$Y);
}
function $40a2a441cde599fe$var$Mk() {
    for(; null !== $40a2a441cde599fe$var$Y && !$40a2a441cde599fe$var$cc();)$40a2a441cde599fe$var$Vk($40a2a441cde599fe$var$Y);
}
function $40a2a441cde599fe$var$Vk(a) {
    var b = $40a2a441cde599fe$var$Wk(a.alternate, a, $40a2a441cde599fe$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $40a2a441cde599fe$var$Tk(a) : $40a2a441cde599fe$var$Y = b;
    $40a2a441cde599fe$var$ok.current = null;
}
function $40a2a441cde599fe$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $40a2a441cde599fe$var$Fj(c, b, $40a2a441cde599fe$var$gj), null !== c) {
                $40a2a441cde599fe$var$Y = c;
                return;
            }
        } else {
            c = $40a2a441cde599fe$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $40a2a441cde599fe$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $40a2a441cde599fe$var$T = 6;
                $40a2a441cde599fe$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $40a2a441cde599fe$var$Y = b;
            return;
        }
        $40a2a441cde599fe$var$Y = b = a;
    }while (null !== b);
    0 === $40a2a441cde599fe$var$T && ($40a2a441cde599fe$var$T = 5);
}
function $40a2a441cde599fe$var$Qk(a, b, c) {
    var d = $40a2a441cde599fe$var$C, e = $40a2a441cde599fe$var$pk.transition;
    try {
        $40a2a441cde599fe$var$pk.transition = null, $40a2a441cde599fe$var$C = 1, $40a2a441cde599fe$var$Xk(a, b, c, d);
    } finally{
        $40a2a441cde599fe$var$pk.transition = e, $40a2a441cde599fe$var$C = d;
    }
    return null;
}
function $40a2a441cde599fe$var$Xk(a, b, c, d) {
    do $40a2a441cde599fe$var$Ik();
    while (null !== $40a2a441cde599fe$var$xk);
    if (0 !== ($40a2a441cde599fe$var$K & 6)) throw Error($40a2a441cde599fe$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($40a2a441cde599fe$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $40a2a441cde599fe$var$Bc(a, f);
    a === $40a2a441cde599fe$var$R && ($40a2a441cde599fe$var$Y = $40a2a441cde599fe$var$R = null, $40a2a441cde599fe$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $40a2a441cde599fe$var$wk || ($40a2a441cde599fe$var$wk = !0, $40a2a441cde599fe$var$Gk($40a2a441cde599fe$var$hc, function() {
        $40a2a441cde599fe$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $40a2a441cde599fe$var$pk.transition;
        $40a2a441cde599fe$var$pk.transition = null;
        var g = $40a2a441cde599fe$var$C;
        $40a2a441cde599fe$var$C = 1;
        var h = $40a2a441cde599fe$var$K;
        $40a2a441cde599fe$var$K |= 4;
        $40a2a441cde599fe$var$ok.current = null;
        $40a2a441cde599fe$var$Pj(a, c);
        $40a2a441cde599fe$var$ek(c, a);
        $40a2a441cde599fe$var$Oe($40a2a441cde599fe$var$Df);
        $40a2a441cde599fe$var$dd = !!$40a2a441cde599fe$var$Cf;
        $40a2a441cde599fe$var$Df = $40a2a441cde599fe$var$Cf = null;
        a.current = c;
        $40a2a441cde599fe$var$ik(c, a, e);
        $40a2a441cde599fe$var$dc();
        $40a2a441cde599fe$var$K = h;
        $40a2a441cde599fe$var$C = g;
        $40a2a441cde599fe$var$pk.transition = f;
    } else a.current = c;
    $40a2a441cde599fe$var$wk && ($40a2a441cde599fe$var$wk = !1, $40a2a441cde599fe$var$xk = a, $40a2a441cde599fe$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($40a2a441cde599fe$var$Si = null);
    $40a2a441cde599fe$var$mc(c.stateNode, d);
    $40a2a441cde599fe$var$Ek(a, $40a2a441cde599fe$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($40a2a441cde599fe$var$Pi) throw $40a2a441cde599fe$var$Pi = !1, a = $40a2a441cde599fe$var$Qi, $40a2a441cde599fe$var$Qi = null, a;
    0 !== ($40a2a441cde599fe$var$yk & 1) && 0 !== a.tag && $40a2a441cde599fe$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $40a2a441cde599fe$var$Ak ? $40a2a441cde599fe$var$zk++ : ($40a2a441cde599fe$var$zk = 0, $40a2a441cde599fe$var$Ak = a) : $40a2a441cde599fe$var$zk = 0;
    $40a2a441cde599fe$var$jg();
    return null;
}
function $40a2a441cde599fe$var$Ik() {
    if (null !== $40a2a441cde599fe$var$xk) {
        var a = $40a2a441cde599fe$var$Dc($40a2a441cde599fe$var$yk), b = $40a2a441cde599fe$var$pk.transition, c = $40a2a441cde599fe$var$C;
        try {
            $40a2a441cde599fe$var$pk.transition = null;
            $40a2a441cde599fe$var$C = 16 > a ? 16 : a;
            if (null === $40a2a441cde599fe$var$xk) var d = !1;
            else {
                a = $40a2a441cde599fe$var$xk;
                $40a2a441cde599fe$var$xk = null;
                $40a2a441cde599fe$var$yk = 0;
                if (0 !== ($40a2a441cde599fe$var$K & 6)) throw Error($40a2a441cde599fe$var$p(331));
                var e = $40a2a441cde599fe$var$K;
                $40a2a441cde599fe$var$K |= 4;
                for($40a2a441cde599fe$var$V = a.current; null !== $40a2a441cde599fe$var$V;){
                    var f = $40a2a441cde599fe$var$V, g = f.child;
                    if (0 !== ($40a2a441cde599fe$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($40a2a441cde599fe$var$V = l; null !== $40a2a441cde599fe$var$V;){
                                    var m = $40a2a441cde599fe$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $40a2a441cde599fe$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $40a2a441cde599fe$var$V = q;
                                    else for(; null !== $40a2a441cde599fe$var$V;){
                                        m = $40a2a441cde599fe$var$V;
                                        var r = m.sibling, y = m.return;
                                        $40a2a441cde599fe$var$Tj(m);
                                        if (m === l) {
                                            $40a2a441cde599fe$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $40a2a441cde599fe$var$V = r;
                                            break;
                                        }
                                        $40a2a441cde599fe$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $40a2a441cde599fe$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $40a2a441cde599fe$var$V = g;
                    else b: for(; null !== $40a2a441cde599fe$var$V;){
                        f = $40a2a441cde599fe$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $40a2a441cde599fe$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $40a2a441cde599fe$var$V = x;
                            break b;
                        }
                        $40a2a441cde599fe$var$V = f.return;
                    }
                }
                var w = a.current;
                for($40a2a441cde599fe$var$V = w; null !== $40a2a441cde599fe$var$V;){
                    g = $40a2a441cde599fe$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $40a2a441cde599fe$var$V = u;
                    else b: for(g = w; null !== $40a2a441cde599fe$var$V;){
                        h = $40a2a441cde599fe$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $40a2a441cde599fe$var$Rj(9, h);
                            }
                        } catch (na) {
                            $40a2a441cde599fe$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $40a2a441cde599fe$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $40a2a441cde599fe$var$V = F;
                            break b;
                        }
                        $40a2a441cde599fe$var$V = h.return;
                    }
                }
                $40a2a441cde599fe$var$K = e;
                $40a2a441cde599fe$var$jg();
                if ($40a2a441cde599fe$var$lc && "function" === typeof $40a2a441cde599fe$var$lc.onPostCommitFiberRoot) try {
                    $40a2a441cde599fe$var$lc.onPostCommitFiberRoot($40a2a441cde599fe$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $40a2a441cde599fe$var$C = c, $40a2a441cde599fe$var$pk.transition = b;
        }
    }
    return !1;
}
function $40a2a441cde599fe$var$Yk(a, b, c) {
    b = $40a2a441cde599fe$var$Ki(c, b);
    b = $40a2a441cde599fe$var$Oi(a, b, 1);
    a = $40a2a441cde599fe$var$dh(a, b, 1);
    b = $40a2a441cde599fe$var$L();
    null !== a && ($40a2a441cde599fe$var$Ac(a, 1, b), $40a2a441cde599fe$var$Ek(a, b));
}
function $40a2a441cde599fe$var$W(a, b, c) {
    if (3 === a.tag) $40a2a441cde599fe$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $40a2a441cde599fe$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $40a2a441cde599fe$var$Si || !$40a2a441cde599fe$var$Si.has(d))) {
                a = $40a2a441cde599fe$var$Ki(c, a);
                a = $40a2a441cde599fe$var$Ri(b, a, 1);
                b = $40a2a441cde599fe$var$dh(b, a, 1);
                a = $40a2a441cde599fe$var$L();
                null !== b && ($40a2a441cde599fe$var$Ac(b, 1, a), $40a2a441cde599fe$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $40a2a441cde599fe$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $40a2a441cde599fe$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $40a2a441cde599fe$var$R === a && ($40a2a441cde599fe$var$Z & c) === c && (4 === $40a2a441cde599fe$var$T || 3 === $40a2a441cde599fe$var$T && ($40a2a441cde599fe$var$Z & 130023424) === $40a2a441cde599fe$var$Z && 500 > $40a2a441cde599fe$var$B() - $40a2a441cde599fe$var$gk ? $40a2a441cde599fe$var$Lk(a, 0) : $40a2a441cde599fe$var$sk |= c);
    $40a2a441cde599fe$var$Ek(a, b);
}
function $40a2a441cde599fe$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $40a2a441cde599fe$var$sc, $40a2a441cde599fe$var$sc <<= 1, 0 === ($40a2a441cde599fe$var$sc & 130023424) && ($40a2a441cde599fe$var$sc = 4194304)));
    var c = $40a2a441cde599fe$var$L();
    a = $40a2a441cde599fe$var$Zg(a, b);
    null !== a && ($40a2a441cde599fe$var$Ac(a, b, c), $40a2a441cde599fe$var$Ek(a, c));
}
function $40a2a441cde599fe$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $40a2a441cde599fe$var$Zk(a, c);
}
function $40a2a441cde599fe$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($40a2a441cde599fe$var$p(314));
    }
    null !== d && d.delete(b);
    $40a2a441cde599fe$var$Zk(a, c);
}
var $40a2a441cde599fe$var$Wk;
$40a2a441cde599fe$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $40a2a441cde599fe$var$Wf.current) $40a2a441cde599fe$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $40a2a441cde599fe$var$Ug = !1, $40a2a441cde599fe$var$zj(a, b, c);
            $40a2a441cde599fe$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $40a2a441cde599fe$var$Ug = !1, $40a2a441cde599fe$var$I && 0 !== (b.flags & 1048576) && $40a2a441cde599fe$var$ug(b, $40a2a441cde599fe$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $40a2a441cde599fe$var$jj(a, b);
            a = b.pendingProps;
            var e = $40a2a441cde599fe$var$Yf(b, $40a2a441cde599fe$var$H.current);
            $40a2a441cde599fe$var$Tg(b, c);
            e = $40a2a441cde599fe$var$Xh(null, b, d, a, e, c);
            var f = $40a2a441cde599fe$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $40a2a441cde599fe$var$Zf(d) ? (f = !0, $40a2a441cde599fe$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $40a2a441cde599fe$var$ah(b), e.updater = $40a2a441cde599fe$var$nh, b.stateNode = e, e._reactInternals = b, $40a2a441cde599fe$var$rh(b, d, a, c), b = $40a2a441cde599fe$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $40a2a441cde599fe$var$I && f && $40a2a441cde599fe$var$vg(b), $40a2a441cde599fe$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $40a2a441cde599fe$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $40a2a441cde599fe$var$$k(d);
                a = $40a2a441cde599fe$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $40a2a441cde599fe$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $40a2a441cde599fe$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $40a2a441cde599fe$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $40a2a441cde599fe$var$aj(null, b, d, $40a2a441cde599fe$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($40a2a441cde599fe$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $40a2a441cde599fe$var$Lg(d, e), $40a2a441cde599fe$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $40a2a441cde599fe$var$Lg(d, e), $40a2a441cde599fe$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $40a2a441cde599fe$var$lj(b);
                if (null === a) throw Error($40a2a441cde599fe$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $40a2a441cde599fe$var$bh(a, b);
                $40a2a441cde599fe$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $40a2a441cde599fe$var$Ki(Error($40a2a441cde599fe$var$p(423)), b);
                        b = $40a2a441cde599fe$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $40a2a441cde599fe$var$Ki(Error($40a2a441cde599fe$var$p(424)), b);
                        b = $40a2a441cde599fe$var$mj(a, b, d, c, e);
                        break a;
                    } else for($40a2a441cde599fe$var$yg = $40a2a441cde599fe$var$Lf(b.stateNode.containerInfo.firstChild), $40a2a441cde599fe$var$xg = b, $40a2a441cde599fe$var$I = !0, $40a2a441cde599fe$var$zg = null, c = $40a2a441cde599fe$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $40a2a441cde599fe$var$Ig();
                    if (d === e) {
                        b = $40a2a441cde599fe$var$$i(a, b, c);
                        break a;
                    }
                    $40a2a441cde599fe$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $40a2a441cde599fe$var$Kh(b), null === a && $40a2a441cde599fe$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $40a2a441cde599fe$var$Ef(d, e) ? g = null : null !== f && $40a2a441cde599fe$var$Ef(d, f) && (b.flags |= 32), $40a2a441cde599fe$var$hj(a, b), $40a2a441cde599fe$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $40a2a441cde599fe$var$Eg(b), null;
        case 13:
            return $40a2a441cde599fe$var$pj(a, b, c);
        case 4:
            return $40a2a441cde599fe$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $40a2a441cde599fe$var$Bh(b, null, d, c) : $40a2a441cde599fe$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $40a2a441cde599fe$var$Lg(d, e), $40a2a441cde599fe$var$Zi(a, b, d, e, c);
        case 7:
            return $40a2a441cde599fe$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $40a2a441cde599fe$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $40a2a441cde599fe$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $40a2a441cde599fe$var$G($40a2a441cde599fe$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($40a2a441cde599fe$var$He(f.value, g)) {
                        if (f.children === e.children && !$40a2a441cde599fe$var$Wf.current) {
                            b = $40a2a441cde599fe$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $40a2a441cde599fe$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $40a2a441cde599fe$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($40a2a441cde599fe$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $40a2a441cde599fe$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $40a2a441cde599fe$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $40a2a441cde599fe$var$Tg(b, c), e = $40a2a441cde599fe$var$Vg(e), d = d(e), b.flags |= 1, $40a2a441cde599fe$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $40a2a441cde599fe$var$Lg(d, b.pendingProps), e = $40a2a441cde599fe$var$Lg(d.type, e), $40a2a441cde599fe$var$aj(a, b, d, e, c);
        case 15:
            return $40a2a441cde599fe$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $40a2a441cde599fe$var$Lg(d, e), $40a2a441cde599fe$var$jj(a, b), b.tag = 1, $40a2a441cde599fe$var$Zf(d) ? (a = !0, $40a2a441cde599fe$var$cg(b)) : a = !1, $40a2a441cde599fe$var$Tg(b, c), $40a2a441cde599fe$var$ph(b, d, e), $40a2a441cde599fe$var$rh(b, d, e, c), $40a2a441cde599fe$var$kj(null, b, d, !0, a, c);
        case 19:
            return $40a2a441cde599fe$var$yj(a, b, c);
        case 22:
            return $40a2a441cde599fe$var$ej(a, b, c);
    }
    throw Error($40a2a441cde599fe$var$p(156, b.tag));
};
function $40a2a441cde599fe$var$Gk(a, b) {
    return $40a2a441cde599fe$var$ac(a, b);
}
function $40a2a441cde599fe$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $40a2a441cde599fe$var$Bg(a, b, c, d) {
    return new $40a2a441cde599fe$var$al(a, b, c, d);
}
function $40a2a441cde599fe$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $40a2a441cde599fe$var$$k(a) {
    if ("function" === typeof a) return $40a2a441cde599fe$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $40a2a441cde599fe$var$Da) return 11;
        if (a === $40a2a441cde599fe$var$Ga) return 14;
    }
    return 2;
}
function $40a2a441cde599fe$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $40a2a441cde599fe$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $40a2a441cde599fe$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $40a2a441cde599fe$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $40a2a441cde599fe$var$ya:
            return $40a2a441cde599fe$var$Ah(c.children, e, f, b);
        case $40a2a441cde599fe$var$za:
            g = 8;
            e |= 8;
            break;
        case $40a2a441cde599fe$var$Aa:
            return a = $40a2a441cde599fe$var$Bg(12, c, b, e | 2), a.elementType = $40a2a441cde599fe$var$Aa, a.lanes = f, a;
        case $40a2a441cde599fe$var$Ea:
            return a = $40a2a441cde599fe$var$Bg(13, c, b, e), a.elementType = $40a2a441cde599fe$var$Ea, a.lanes = f, a;
        case $40a2a441cde599fe$var$Fa:
            return a = $40a2a441cde599fe$var$Bg(19, c, b, e), a.elementType = $40a2a441cde599fe$var$Fa, a.lanes = f, a;
        case $40a2a441cde599fe$var$Ia:
            return $40a2a441cde599fe$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $40a2a441cde599fe$var$Ba:
                    g = 10;
                    break a;
                case $40a2a441cde599fe$var$Ca:
                    g = 9;
                    break a;
                case $40a2a441cde599fe$var$Da:
                    g = 11;
                    break a;
                case $40a2a441cde599fe$var$Ga:
                    g = 14;
                    break a;
                case $40a2a441cde599fe$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($40a2a441cde599fe$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $40a2a441cde599fe$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $40a2a441cde599fe$var$Ah(a, b, c, d) {
    a = $40a2a441cde599fe$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $40a2a441cde599fe$var$qj(a, b, c, d) {
    a = $40a2a441cde599fe$var$Bg(22, a, d, b);
    a.elementType = $40a2a441cde599fe$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $40a2a441cde599fe$var$xh(a, b, c) {
    a = $40a2a441cde599fe$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $40a2a441cde599fe$var$zh(a, b, c) {
    b = $40a2a441cde599fe$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $40a2a441cde599fe$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $40a2a441cde599fe$var$zc(0);
    this.expirationTimes = $40a2a441cde599fe$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $40a2a441cde599fe$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $40a2a441cde599fe$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $40a2a441cde599fe$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $40a2a441cde599fe$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $40a2a441cde599fe$var$ah(f);
    return a;
}
function $40a2a441cde599fe$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $40a2a441cde599fe$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $40a2a441cde599fe$var$el(a) {
    if (!a) return $40a2a441cde599fe$var$Vf;
    a = a._reactInternals;
    a: {
        if ($40a2a441cde599fe$var$Vb(a) !== a || 1 !== a.tag) throw Error($40a2a441cde599fe$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($40a2a441cde599fe$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($40a2a441cde599fe$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($40a2a441cde599fe$var$Zf(c)) return $40a2a441cde599fe$var$bg(a, c, b);
    }
    return b;
}
function $40a2a441cde599fe$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $40a2a441cde599fe$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $40a2a441cde599fe$var$el(null);
    c = a.current;
    d = $40a2a441cde599fe$var$L();
    e = $40a2a441cde599fe$var$lh(c);
    f = $40a2a441cde599fe$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $40a2a441cde599fe$var$dh(c, f, e);
    a.current.lanes = e;
    $40a2a441cde599fe$var$Ac(a, e, d);
    $40a2a441cde599fe$var$Ek(a, d);
    return a;
}
function $40a2a441cde599fe$var$gl(a, b, c, d) {
    var e = b.current, f = $40a2a441cde599fe$var$L(), g = $40a2a441cde599fe$var$lh(e);
    c = $40a2a441cde599fe$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $40a2a441cde599fe$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $40a2a441cde599fe$var$dh(e, b, g);
    null !== a && ($40a2a441cde599fe$var$mh(a, e, g, f), $40a2a441cde599fe$var$eh(a, e, g));
    return g;
}
function $40a2a441cde599fe$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $40a2a441cde599fe$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $40a2a441cde599fe$var$jl(a, b) {
    $40a2a441cde599fe$var$il(a, b);
    (a = a.alternate) && $40a2a441cde599fe$var$il(a, b);
}
function $40a2a441cde599fe$var$kl() {
    return null;
}
var $40a2a441cde599fe$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $40a2a441cde599fe$var$ml(a) {
    this._internalRoot = a;
}
$40a2a441cde599fe$var$nl.prototype.render = $40a2a441cde599fe$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($40a2a441cde599fe$var$p(409));
    $40a2a441cde599fe$var$gl(a, b, null, null);
};
$40a2a441cde599fe$var$nl.prototype.unmount = $40a2a441cde599fe$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $40a2a441cde599fe$var$Sk(function() {
            $40a2a441cde599fe$var$gl(null, a, null, null);
        });
        b[$40a2a441cde599fe$var$uf] = null;
    }
};
function $40a2a441cde599fe$var$nl(a) {
    this._internalRoot = a;
}
$40a2a441cde599fe$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $40a2a441cde599fe$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $40a2a441cde599fe$var$Qc.length && 0 !== b && b < $40a2a441cde599fe$var$Qc[c].priority; c++);
        $40a2a441cde599fe$var$Qc.splice(c, 0, a);
        0 === c && $40a2a441cde599fe$var$Vc(a);
    }
};
function $40a2a441cde599fe$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $40a2a441cde599fe$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $40a2a441cde599fe$var$ql() {}
function $40a2a441cde599fe$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $40a2a441cde599fe$var$hl(g);
                f.call(a);
            };
        }
        var g = $40a2a441cde599fe$var$fl(b, d, a, 0, null, !1, !1, "", $40a2a441cde599fe$var$ql);
        a._reactRootContainer = g;
        a[$40a2a441cde599fe$var$uf] = g.current;
        $40a2a441cde599fe$var$sf(8 === a.nodeType ? a.parentNode : a);
        $40a2a441cde599fe$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $40a2a441cde599fe$var$hl(k);
            h.call(a);
        };
    }
    var k = $40a2a441cde599fe$var$cl(a, 0, !1, null, null, !1, !1, "", $40a2a441cde599fe$var$ql);
    a._reactRootContainer = k;
    a[$40a2a441cde599fe$var$uf] = k.current;
    $40a2a441cde599fe$var$sf(8 === a.nodeType ? a.parentNode : a);
    $40a2a441cde599fe$var$Sk(function() {
        $40a2a441cde599fe$var$gl(b, k, c, d);
    });
    return k;
}
function $40a2a441cde599fe$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $40a2a441cde599fe$var$hl(g);
                h.call(a);
            };
        }
        $40a2a441cde599fe$var$gl(b, g, a, e);
    } else g = $40a2a441cde599fe$var$rl(c, b, a, e, d);
    return $40a2a441cde599fe$var$hl(g);
}
$40a2a441cde599fe$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $40a2a441cde599fe$var$tc(b.pendingLanes);
                0 !== c && ($40a2a441cde599fe$var$Cc(b, c | 1), $40a2a441cde599fe$var$Ek(b, $40a2a441cde599fe$var$B()), 0 === ($40a2a441cde599fe$var$K & 6) && ($40a2a441cde599fe$var$Hj = $40a2a441cde599fe$var$B() + 500, $40a2a441cde599fe$var$jg()));
            }
            break;
        case 13:
            $40a2a441cde599fe$var$Sk(function() {
                var b = $40a2a441cde599fe$var$Zg(a, 1);
                if (null !== b) {
                    var c = $40a2a441cde599fe$var$L();
                    $40a2a441cde599fe$var$mh(b, a, 1, c);
                }
            }), $40a2a441cde599fe$var$jl(a, 1);
    }
};
$40a2a441cde599fe$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $40a2a441cde599fe$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $40a2a441cde599fe$var$L();
            $40a2a441cde599fe$var$mh(b, a, 134217728, c);
        }
        $40a2a441cde599fe$var$jl(a, 134217728);
    }
};
$40a2a441cde599fe$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $40a2a441cde599fe$var$lh(a), c = $40a2a441cde599fe$var$Zg(a, b);
        if (null !== c) {
            var d = $40a2a441cde599fe$var$L();
            $40a2a441cde599fe$var$mh(c, a, b, d);
        }
        $40a2a441cde599fe$var$jl(a, b);
    }
};
$40a2a441cde599fe$var$Hc = function() {
    return $40a2a441cde599fe$var$C;
};
$40a2a441cde599fe$var$Ic = function(a, b) {
    var c = $40a2a441cde599fe$var$C;
    try {
        return $40a2a441cde599fe$var$C = a, b();
    } finally{
        $40a2a441cde599fe$var$C = c;
    }
};
$40a2a441cde599fe$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $40a2a441cde599fe$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $40a2a441cde599fe$var$Db(d);
                        if (!e) throw Error($40a2a441cde599fe$var$p(90));
                        $40a2a441cde599fe$var$Wa(d);
                        $40a2a441cde599fe$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $40a2a441cde599fe$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $40a2a441cde599fe$var$fb(a, !!c.multiple, b, !1);
    }
};
$40a2a441cde599fe$var$Gb = $40a2a441cde599fe$var$Rk;
$40a2a441cde599fe$var$Hb = $40a2a441cde599fe$var$Sk;
var $40a2a441cde599fe$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $40a2a441cde599fe$var$Cb,
        $40a2a441cde599fe$var$ue,
        $40a2a441cde599fe$var$Db,
        $40a2a441cde599fe$var$Eb,
        $40a2a441cde599fe$var$Fb,
        $40a2a441cde599fe$var$Rk
    ]
}, $40a2a441cde599fe$var$ul = {
    findFiberByHostInstance: $40a2a441cde599fe$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $40a2a441cde599fe$var$vl = {
    bundleType: $40a2a441cde599fe$var$ul.bundleType,
    version: $40a2a441cde599fe$var$ul.version,
    rendererPackageName: $40a2a441cde599fe$var$ul.rendererPackageName,
    rendererConfig: $40a2a441cde599fe$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $40a2a441cde599fe$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $40a2a441cde599fe$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $40a2a441cde599fe$var$ul.findFiberByHostInstance || $40a2a441cde599fe$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $40a2a441cde599fe$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$40a2a441cde599fe$var$wl.isDisabled && $40a2a441cde599fe$var$wl.supportsFiber) try {
        $40a2a441cde599fe$var$kc = $40a2a441cde599fe$var$wl.inject($40a2a441cde599fe$var$vl), $40a2a441cde599fe$var$lc = $40a2a441cde599fe$var$wl;
    } catch (a) {}
}
$40a2a441cde599fe$export$ae55be85d98224ed = $40a2a441cde599fe$var$tl;
$40a2a441cde599fe$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$40a2a441cde599fe$var$ol(b)) throw Error($40a2a441cde599fe$var$p(200));
    return $40a2a441cde599fe$var$dl(a, b, null, c);
};
$40a2a441cde599fe$export$882461b6382ed46c = function(a, b) {
    if (!$40a2a441cde599fe$var$ol(a)) throw Error($40a2a441cde599fe$var$p(299));
    var c = !1, d = "", e = $40a2a441cde599fe$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $40a2a441cde599fe$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$40a2a441cde599fe$var$uf] = b.current;
    $40a2a441cde599fe$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $40a2a441cde599fe$var$ml(b);
};
$40a2a441cde599fe$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($40a2a441cde599fe$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($40a2a441cde599fe$var$p(268, a));
    }
    a = $40a2a441cde599fe$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$40a2a441cde599fe$export$cd75ccfd720a3cd4 = function(a) {
    return $40a2a441cde599fe$var$Sk(a);
};
$40a2a441cde599fe$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$40a2a441cde599fe$var$pl(b)) throw Error($40a2a441cde599fe$var$p(200));
    return $40a2a441cde599fe$var$sl(null, a, b, !0, c);
};
$40a2a441cde599fe$export$757ceba2d55c277e = function(a, b, c) {
    if (!$40a2a441cde599fe$var$ol(a)) throw Error($40a2a441cde599fe$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $40a2a441cde599fe$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $40a2a441cde599fe$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$40a2a441cde599fe$var$uf] = b.current;
    $40a2a441cde599fe$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $40a2a441cde599fe$var$nl(b);
};
$40a2a441cde599fe$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$40a2a441cde599fe$var$pl(b)) throw Error($40a2a441cde599fe$var$p(200));
    return $40a2a441cde599fe$var$sl(null, a, b, !1, c);
};
$40a2a441cde599fe$export$502457920280e6be = function(a) {
    if (!$40a2a441cde599fe$var$pl(a)) throw Error($40a2a441cde599fe$var$p(40));
    return a._reactRootContainer ? ($40a2a441cde599fe$var$Sk(function() {
        $40a2a441cde599fe$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$40a2a441cde599fe$var$uf] = null;
        });
    }), !0) : !1;
};
$40a2a441cde599fe$export$c78a37762a8d58e1 = $40a2a441cde599fe$var$Rk;
$40a2a441cde599fe$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$40a2a441cde599fe$var$pl(c)) throw Error($40a2a441cde599fe$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($40a2a441cde599fe$var$p(38));
    return $40a2a441cde599fe$var$sl(a, b, c, !1, d);
};
$40a2a441cde599fe$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("1gMSY", function(module, exports) {
"use strict";

module.exports = (parcelRequire("4RXOw"));

});
parcelRequire.register("4RXOw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $38ba827035400b5e$export$c4744153514ff05d; }, function (v) { return $38ba827035400b5e$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $38ba827035400b5e$export$3e506c1ccc9cc1a7; }, function (v) { return $38ba827035400b5e$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $38ba827035400b5e$export$e26fe2ed2fa76875; }, function (v) { return $38ba827035400b5e$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $38ba827035400b5e$export$502329bbf4b505b1; }, function (v) { return $38ba827035400b5e$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $38ba827035400b5e$export$6e3807111c4874c4; }, function (v) { return $38ba827035400b5e$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $38ba827035400b5e$export$c27134553091fb3a; }, function (v) { return $38ba827035400b5e$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $38ba827035400b5e$export$33ee1acdc04fd2a2; }, function (v) { return $38ba827035400b5e$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $38ba827035400b5e$export$b00a404bbd5edef2; }, function (v) { return $38ba827035400b5e$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $38ba827035400b5e$export$8352ce38b91d0c62; }, function (v) { return $38ba827035400b5e$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $38ba827035400b5e$export$d66a1c1c77bd778b; }, function (v) { return $38ba827035400b5e$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $38ba827035400b5e$export$d3dfb8e4810cb555; }, function (v) { return $38ba827035400b5e$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $38ba827035400b5e$export$839f9183b0465a69; }, function (v) { return $38ba827035400b5e$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $38ba827035400b5e$export$72fdf0e06517287b; }, function (v) { return $38ba827035400b5e$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $38ba827035400b5e$export$4b844e58a3e414b4; }, function (v) { return $38ba827035400b5e$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $38ba827035400b5e$export$816d2913ae6b83b1; }, function (v) { return $38ba827035400b5e$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $38ba827035400b5e$export$61bcfe829111a1d0; }, function (v) { return $38ba827035400b5e$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $38ba827035400b5e$export$7ee8c9beb337bc3f; }, function (v) { return $38ba827035400b5e$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $38ba827035400b5e$export$b5836b71941fa3ed; }, function (v) { return $38ba827035400b5e$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $38ba827035400b5e$export$cf845f2c119da08a; }, function (v) { return $38ba827035400b5e$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38ba827035400b5e$export$c4744153514ff05d;
var $38ba827035400b5e$export$3e506c1ccc9cc1a7;
var $38ba827035400b5e$export$e26fe2ed2fa76875;
var $38ba827035400b5e$export$502329bbf4b505b1;
var $38ba827035400b5e$export$6e3807111c4874c4;
var $38ba827035400b5e$export$c27134553091fb3a;
var $38ba827035400b5e$export$33ee1acdc04fd2a2;
var $38ba827035400b5e$export$b00a404bbd5edef2;
var $38ba827035400b5e$export$8352ce38b91d0c62;
var $38ba827035400b5e$export$d66a1c1c77bd778b;
var $38ba827035400b5e$export$d3dfb8e4810cb555;
var $38ba827035400b5e$export$839f9183b0465a69;
var $38ba827035400b5e$export$72fdf0e06517287b;
var $38ba827035400b5e$export$4b844e58a3e414b4;
var $38ba827035400b5e$export$816d2913ae6b83b1;
var $38ba827035400b5e$export$61bcfe829111a1d0;
var $38ba827035400b5e$export$7ee8c9beb337bc3f;
var $38ba827035400b5e$export$b5836b71941fa3ed;
var $38ba827035400b5e$export$cf845f2c119da08a;
"use strict";
function $38ba827035400b5e$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $38ba827035400b5e$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $38ba827035400b5e$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $38ba827035400b5e$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $38ba827035400b5e$var$g(C, c)) n < e && 0 > $38ba827035400b5e$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $38ba827035400b5e$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $38ba827035400b5e$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $38ba827035400b5e$var$l = performance;
    $38ba827035400b5e$export$c4744153514ff05d = function() {
        return $38ba827035400b5e$var$l.now();
    };
} else {
    var $38ba827035400b5e$var$p = Date, $38ba827035400b5e$var$q = $38ba827035400b5e$var$p.now();
    $38ba827035400b5e$export$c4744153514ff05d = function() {
        return $38ba827035400b5e$var$p.now() - $38ba827035400b5e$var$q;
    };
}
var $38ba827035400b5e$var$r = [], $38ba827035400b5e$var$t = [], $38ba827035400b5e$var$u = 1, $38ba827035400b5e$var$v = null, $38ba827035400b5e$var$y = 3, $38ba827035400b5e$var$z = !1, $38ba827035400b5e$var$A = !1, $38ba827035400b5e$var$B = !1, $38ba827035400b5e$var$D = "function" === typeof setTimeout ? setTimeout : null, $38ba827035400b5e$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $38ba827035400b5e$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $38ba827035400b5e$var$G(a) {
    for(var b = $38ba827035400b5e$var$h($38ba827035400b5e$var$t); null !== b;){
        if (null === b.callback) $38ba827035400b5e$var$k($38ba827035400b5e$var$t);
        else if (b.startTime <= a) $38ba827035400b5e$var$k($38ba827035400b5e$var$t), b.sortIndex = b.expirationTime, $38ba827035400b5e$var$f($38ba827035400b5e$var$r, b);
        else break;
        b = $38ba827035400b5e$var$h($38ba827035400b5e$var$t);
    }
}
function $38ba827035400b5e$var$H(a) {
    $38ba827035400b5e$var$B = !1;
    $38ba827035400b5e$var$G(a);
    if (!$38ba827035400b5e$var$A) {
        if (null !== $38ba827035400b5e$var$h($38ba827035400b5e$var$r)) $38ba827035400b5e$var$A = !0, $38ba827035400b5e$var$I($38ba827035400b5e$var$J);
        else {
            var b = $38ba827035400b5e$var$h($38ba827035400b5e$var$t);
            null !== b && $38ba827035400b5e$var$K($38ba827035400b5e$var$H, b.startTime - a);
        }
    }
}
function $38ba827035400b5e$var$J(a, b) {
    $38ba827035400b5e$var$A = !1;
    $38ba827035400b5e$var$B && ($38ba827035400b5e$var$B = !1, $38ba827035400b5e$var$E($38ba827035400b5e$var$L), $38ba827035400b5e$var$L = -1);
    $38ba827035400b5e$var$z = !0;
    var c = $38ba827035400b5e$var$y;
    try {
        $38ba827035400b5e$var$G(b);
        for($38ba827035400b5e$var$v = $38ba827035400b5e$var$h($38ba827035400b5e$var$r); null !== $38ba827035400b5e$var$v && (!($38ba827035400b5e$var$v.expirationTime > b) || a && !$38ba827035400b5e$var$M());){
            var d = $38ba827035400b5e$var$v.callback;
            if ("function" === typeof d) {
                $38ba827035400b5e$var$v.callback = null;
                $38ba827035400b5e$var$y = $38ba827035400b5e$var$v.priorityLevel;
                var e = d($38ba827035400b5e$var$v.expirationTime <= b);
                b = $38ba827035400b5e$export$c4744153514ff05d();
                "function" === typeof e ? $38ba827035400b5e$var$v.callback = e : $38ba827035400b5e$var$v === $38ba827035400b5e$var$h($38ba827035400b5e$var$r) && $38ba827035400b5e$var$k($38ba827035400b5e$var$r);
                $38ba827035400b5e$var$G(b);
            } else $38ba827035400b5e$var$k($38ba827035400b5e$var$r);
            $38ba827035400b5e$var$v = $38ba827035400b5e$var$h($38ba827035400b5e$var$r);
        }
        if (null !== $38ba827035400b5e$var$v) var w = !0;
        else {
            var m = $38ba827035400b5e$var$h($38ba827035400b5e$var$t);
            null !== m && $38ba827035400b5e$var$K($38ba827035400b5e$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $38ba827035400b5e$var$v = null, $38ba827035400b5e$var$y = c, $38ba827035400b5e$var$z = !1;
    }
}
var $38ba827035400b5e$var$N = !1, $38ba827035400b5e$var$O = null, $38ba827035400b5e$var$L = -1, $38ba827035400b5e$var$P = 5, $38ba827035400b5e$var$Q = -1;
function $38ba827035400b5e$var$M() {
    return $38ba827035400b5e$export$c4744153514ff05d() - $38ba827035400b5e$var$Q < $38ba827035400b5e$var$P ? !1 : !0;
}
function $38ba827035400b5e$var$R() {
    if (null !== $38ba827035400b5e$var$O) {
        var a = $38ba827035400b5e$export$c4744153514ff05d();
        $38ba827035400b5e$var$Q = a;
        var b = !0;
        try {
            b = $38ba827035400b5e$var$O(!0, a);
        } finally{
            b ? $38ba827035400b5e$var$S() : ($38ba827035400b5e$var$N = !1, $38ba827035400b5e$var$O = null);
        }
    } else $38ba827035400b5e$var$N = !1;
}
var $38ba827035400b5e$var$S;
if ("function" === typeof $38ba827035400b5e$var$F) $38ba827035400b5e$var$S = function() {
    $38ba827035400b5e$var$F($38ba827035400b5e$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $38ba827035400b5e$var$T = new MessageChannel, $38ba827035400b5e$var$U = $38ba827035400b5e$var$T.port2;
    $38ba827035400b5e$var$T.port1.onmessage = $38ba827035400b5e$var$R;
    $38ba827035400b5e$var$S = function() {
        $38ba827035400b5e$var$U.postMessage(null);
    };
} else $38ba827035400b5e$var$S = function() {
    $38ba827035400b5e$var$D($38ba827035400b5e$var$R, 0);
};
function $38ba827035400b5e$var$I(a) {
    $38ba827035400b5e$var$O = a;
    $38ba827035400b5e$var$N || ($38ba827035400b5e$var$N = !0, $38ba827035400b5e$var$S());
}
function $38ba827035400b5e$var$K(a, b) {
    $38ba827035400b5e$var$L = $38ba827035400b5e$var$D(function() {
        a($38ba827035400b5e$export$c4744153514ff05d());
    }, b);
}
$38ba827035400b5e$export$3e506c1ccc9cc1a7 = 5;
$38ba827035400b5e$export$e26fe2ed2fa76875 = 1;
$38ba827035400b5e$export$502329bbf4b505b1 = 4;
$38ba827035400b5e$export$6e3807111c4874c4 = 3;
$38ba827035400b5e$export$c27134553091fb3a = null;
$38ba827035400b5e$export$33ee1acdc04fd2a2 = 2;
$38ba827035400b5e$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$38ba827035400b5e$export$8352ce38b91d0c62 = function() {
    $38ba827035400b5e$var$A || $38ba827035400b5e$var$z || ($38ba827035400b5e$var$A = !0, $38ba827035400b5e$var$I($38ba827035400b5e$var$J));
};
$38ba827035400b5e$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $38ba827035400b5e$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$38ba827035400b5e$export$d3dfb8e4810cb555 = function() {
    return $38ba827035400b5e$var$y;
};
$38ba827035400b5e$export$839f9183b0465a69 = function() {
    return $38ba827035400b5e$var$h($38ba827035400b5e$var$r);
};
$38ba827035400b5e$export$72fdf0e06517287b = function(a) {
    switch($38ba827035400b5e$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $38ba827035400b5e$var$y;
    }
    var c = $38ba827035400b5e$var$y;
    $38ba827035400b5e$var$y = b;
    try {
        return a();
    } finally{
        $38ba827035400b5e$var$y = c;
    }
};
$38ba827035400b5e$export$4b844e58a3e414b4 = function() {};
$38ba827035400b5e$export$816d2913ae6b83b1 = function() {};
$38ba827035400b5e$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $38ba827035400b5e$var$y;
    $38ba827035400b5e$var$y = a;
    try {
        return b();
    } finally{
        $38ba827035400b5e$var$y = c;
    }
};
$38ba827035400b5e$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $38ba827035400b5e$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $38ba827035400b5e$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $38ba827035400b5e$var$f($38ba827035400b5e$var$t, a), null === $38ba827035400b5e$var$h($38ba827035400b5e$var$r) && a === $38ba827035400b5e$var$h($38ba827035400b5e$var$t) && ($38ba827035400b5e$var$B ? ($38ba827035400b5e$var$E($38ba827035400b5e$var$L), $38ba827035400b5e$var$L = -1) : $38ba827035400b5e$var$B = !0, $38ba827035400b5e$var$K($38ba827035400b5e$var$H, c - d))) : (a.sortIndex = e, $38ba827035400b5e$var$f($38ba827035400b5e$var$r, a), $38ba827035400b5e$var$A || $38ba827035400b5e$var$z || ($38ba827035400b5e$var$A = !0, $38ba827035400b5e$var$I($38ba827035400b5e$var$J)));
    return a;
};
$38ba827035400b5e$export$b5836b71941fa3ed = $38ba827035400b5e$var$M;
$38ba827035400b5e$export$cf845f2c119da08a = function(a) {
    var b = $38ba827035400b5e$var$y;
    return function() {
        var c = $38ba827035400b5e$var$y;
        $38ba827035400b5e$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $38ba827035400b5e$var$y = c;
        }
    };
};

});



parcelRequire.register("1p7jo", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $105dcc317080ad0e$export$bf730a2d8bf68b42; }, function (v) { return $105dcc317080ad0e$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $105dcc317080ad0e$export$bf730a2d8bf68b42;
"use strict";

var $g5BLJ = parcelRequire("g5BLJ");

var $aJnGI = parcelRequire("aJnGI");
function $105dcc317080ad0e$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $105dcc317080ad0e$var$q = "function" === typeof Object.is ? Object.is : $105dcc317080ad0e$var$p, $105dcc317080ad0e$var$r = $aJnGI.useSyncExternalStore, $105dcc317080ad0e$var$t = $g5BLJ.useRef, $105dcc317080ad0e$var$u = $g5BLJ.useEffect, $105dcc317080ad0e$var$v = $g5BLJ.useMemo, $105dcc317080ad0e$var$w = $g5BLJ.useDebugValue;
$105dcc317080ad0e$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $105dcc317080ad0e$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $105dcc317080ad0e$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($105dcc317080ad0e$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $105dcc317080ad0e$var$r(a, c[0], c[1]);
    $105dcc317080ad0e$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $105dcc317080ad0e$var$w(d);
    return d;
};

});
parcelRequire.register("aJnGI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hW4pV"));

});
parcelRequire.register("hW4pV", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $d0eb479b5ba76c9a$export$306c0aa65ff9ec16; }, function (v) { return $d0eb479b5ba76c9a$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d0eb479b5ba76c9a$export$306c0aa65ff9ec16;
"use strict";

var $g5BLJ = parcelRequire("g5BLJ");
function $d0eb479b5ba76c9a$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d0eb479b5ba76c9a$var$k = "function" === typeof Object.is ? Object.is : $d0eb479b5ba76c9a$var$h, $d0eb479b5ba76c9a$var$l = $g5BLJ.useState, $d0eb479b5ba76c9a$var$m = $g5BLJ.useEffect, $d0eb479b5ba76c9a$var$n = $g5BLJ.useLayoutEffect, $d0eb479b5ba76c9a$var$p = $g5BLJ.useDebugValue;
function $d0eb479b5ba76c9a$var$q(a, b) {
    var d = b(), f = $d0eb479b5ba76c9a$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $d0eb479b5ba76c9a$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $d0eb479b5ba76c9a$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $d0eb479b5ba76c9a$var$m(function() {
        $d0eb479b5ba76c9a$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $d0eb479b5ba76c9a$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $d0eb479b5ba76c9a$var$p(d);
    return d;
}
function $d0eb479b5ba76c9a$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$d0eb479b5ba76c9a$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $d0eb479b5ba76c9a$var$t(a, b) {
    return b();
}
var $d0eb479b5ba76c9a$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $d0eb479b5ba76c9a$var$t : $d0eb479b5ba76c9a$var$q;
$d0eb479b5ba76c9a$export$306c0aa65ff9ec16 = void 0 !== $g5BLJ.useSyncExternalStore ? $g5BLJ.useSyncExternalStore : $d0eb479b5ba76c9a$var$u;

});



parcelRequire.register("he7eL", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $c8a95b9803fa20ec$export$a7c73072b1a182ae; }, function (v) { return $c8a95b9803fa20ec$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $c8a95b9803fa20ec$export$9f27bc3417b4524d; }, function (v) { return $c8a95b9803fa20ec$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $c8a95b9803fa20ec$export$db77ccec0bb4ccac; }, function (v) { return $c8a95b9803fa20ec$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $c8a95b9803fa20ec$export$8392c0c9d3dcbd35; }, function (v) { return $c8a95b9803fa20ec$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c8a95b9803fa20ec$export$ffb0004e005737fa; }, function (v) { return $c8a95b9803fa20ec$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $c8a95b9803fa20ec$export$b624eff549462981; }, function (v) { return $c8a95b9803fa20ec$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $c8a95b9803fa20ec$export$7897aa7841a5380c; }, function (v) { return $c8a95b9803fa20ec$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $c8a95b9803fa20ec$export$602eac185826482c; }, function (v) { return $c8a95b9803fa20ec$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $c8a95b9803fa20ec$export$e2c29f18771995cb; }, function (v) { return $c8a95b9803fa20ec$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c8a95b9803fa20ec$export$5f8d39834fd61797; }, function (v) { return $c8a95b9803fa20ec$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c8a95b9803fa20ec$export$74bf444e3cd11ea5; }, function (v) { return $c8a95b9803fa20ec$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $c8a95b9803fa20ec$export$998bcd577473dd93; }, function (v) { return $c8a95b9803fa20ec$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $c8a95b9803fa20ec$export$92387174baf9b227; }, function (v) { return $c8a95b9803fa20ec$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $c8a95b9803fa20ec$export$ec112efeb987d9c6; }, function (v) { return $c8a95b9803fa20ec$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $c8a95b9803fa20ec$export$b706b080d889d2c9; }, function (v) { return $c8a95b9803fa20ec$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $c8a95b9803fa20ec$export$5be5a87408f70ddc; }, function (v) { return $c8a95b9803fa20ec$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $c8a95b9803fa20ec$export$45a5e7f76e0caa8d; }, function (v) { return $c8a95b9803fa20ec$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $c8a95b9803fa20ec$export$455c2e768291efa6; }, function (v) { return $c8a95b9803fa20ec$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $c8a95b9803fa20ec$export$9522e17588c12572; }, function (v) { return $c8a95b9803fa20ec$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $c8a95b9803fa20ec$export$2110ac352bb060b9; }, function (v) { return $c8a95b9803fa20ec$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $c8a95b9803fa20ec$export$56885ab8b9c456ab; }, function (v) { return $c8a95b9803fa20ec$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $c8a95b9803fa20ec$export$d927fcb6adf8f9de; }, function (v) { return $c8a95b9803fa20ec$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $c8a95b9803fa20ec$export$b82d16f27459e05a; }, function (v) { return $c8a95b9803fa20ec$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $c8a95b9803fa20ec$export$522c17b4f5e123e8; }, function (v) { return $c8a95b9803fa20ec$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $c8a95b9803fa20ec$export$1aabd8a0274ecfd6; }, function (v) { return $c8a95b9803fa20ec$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $c8a95b9803fa20ec$export$3d6c20d97e46b957; }, function (v) { return $c8a95b9803fa20ec$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $c8a95b9803fa20ec$export$9b621391a187a31a; }, function (v) { return $c8a95b9803fa20ec$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $c8a95b9803fa20ec$export$f5bbd400c2f4426f; }, function (v) { return $c8a95b9803fa20ec$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c8a95b9803fa20ec$export$a7c73072b1a182ae;
var $c8a95b9803fa20ec$export$9f27bc3417b4524d;
var $c8a95b9803fa20ec$export$db77ccec0bb4ccac;
var $c8a95b9803fa20ec$export$8392c0c9d3dcbd35;
var $c8a95b9803fa20ec$export$ffb0004e005737fa;
var $c8a95b9803fa20ec$export$b624eff549462981;
var $c8a95b9803fa20ec$export$7897aa7841a5380c;
var $c8a95b9803fa20ec$export$602eac185826482c;
var $c8a95b9803fa20ec$export$e2c29f18771995cb;
var $c8a95b9803fa20ec$export$5f8d39834fd61797;
var $c8a95b9803fa20ec$export$74bf444e3cd11ea5;
var $c8a95b9803fa20ec$export$998bcd577473dd93;
var $c8a95b9803fa20ec$export$92387174baf9b227;
var $c8a95b9803fa20ec$export$ec112efeb987d9c6;
var $c8a95b9803fa20ec$export$b706b080d889d2c9;
var $c8a95b9803fa20ec$export$5be5a87408f70ddc;
var $c8a95b9803fa20ec$export$45a5e7f76e0caa8d;
var $c8a95b9803fa20ec$export$455c2e768291efa6;
var $c8a95b9803fa20ec$export$9522e17588c12572;
var $c8a95b9803fa20ec$export$2110ac352bb060b9;
var $c8a95b9803fa20ec$export$56885ab8b9c456ab;
var $c8a95b9803fa20ec$export$d927fcb6adf8f9de;
var $c8a95b9803fa20ec$export$b82d16f27459e05a;
var $c8a95b9803fa20ec$export$522c17b4f5e123e8;
var $c8a95b9803fa20ec$export$1aabd8a0274ecfd6;
var $c8a95b9803fa20ec$export$3d6c20d97e46b957;
var $c8a95b9803fa20ec$export$9b621391a187a31a;
var $c8a95b9803fa20ec$export$f5bbd400c2f4426f;
"use strict";
var $c8a95b9803fa20ec$var$b = Symbol.for("react.element"), $c8a95b9803fa20ec$var$c = Symbol.for("react.portal"), $c8a95b9803fa20ec$var$d = Symbol.for("react.fragment"), $c8a95b9803fa20ec$var$e = Symbol.for("react.strict_mode"), $c8a95b9803fa20ec$var$f = Symbol.for("react.profiler"), $c8a95b9803fa20ec$var$g = Symbol.for("react.provider"), $c8a95b9803fa20ec$var$h = Symbol.for("react.context"), $c8a95b9803fa20ec$var$k = Symbol.for("react.server_context"), $c8a95b9803fa20ec$var$l = Symbol.for("react.forward_ref"), $c8a95b9803fa20ec$var$m = Symbol.for("react.suspense"), $c8a95b9803fa20ec$var$n = Symbol.for("react.suspense_list"), $c8a95b9803fa20ec$var$p = Symbol.for("react.memo"), $c8a95b9803fa20ec$var$q = Symbol.for("react.lazy"), $c8a95b9803fa20ec$var$t = Symbol.for("react.offscreen"), $c8a95b9803fa20ec$var$u;
$c8a95b9803fa20ec$var$u = Symbol.for("react.module.reference");
function $c8a95b9803fa20ec$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $c8a95b9803fa20ec$var$b:
                switch(a = a.type, a){
                    case $c8a95b9803fa20ec$var$d:
                    case $c8a95b9803fa20ec$var$f:
                    case $c8a95b9803fa20ec$var$e:
                    case $c8a95b9803fa20ec$var$m:
                    case $c8a95b9803fa20ec$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $c8a95b9803fa20ec$var$k:
                            case $c8a95b9803fa20ec$var$h:
                            case $c8a95b9803fa20ec$var$l:
                            case $c8a95b9803fa20ec$var$q:
                            case $c8a95b9803fa20ec$var$p:
                            case $c8a95b9803fa20ec$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $c8a95b9803fa20ec$var$c:
                return r;
        }
    }
}
$c8a95b9803fa20ec$export$a7c73072b1a182ae = $c8a95b9803fa20ec$var$h;
$c8a95b9803fa20ec$export$9f27bc3417b4524d = $c8a95b9803fa20ec$var$g;
$c8a95b9803fa20ec$export$db77ccec0bb4ccac = $c8a95b9803fa20ec$var$b;
$c8a95b9803fa20ec$export$8392c0c9d3dcbd35 = $c8a95b9803fa20ec$var$l;
$c8a95b9803fa20ec$export$ffb0004e005737fa = $c8a95b9803fa20ec$var$d;
$c8a95b9803fa20ec$export$b624eff549462981 = $c8a95b9803fa20ec$var$q;
$c8a95b9803fa20ec$export$7897aa7841a5380c = $c8a95b9803fa20ec$var$p;
$c8a95b9803fa20ec$export$602eac185826482c = $c8a95b9803fa20ec$var$c;
$c8a95b9803fa20ec$export$e2c29f18771995cb = $c8a95b9803fa20ec$var$f;
$c8a95b9803fa20ec$export$5f8d39834fd61797 = $c8a95b9803fa20ec$var$e;
$c8a95b9803fa20ec$export$74bf444e3cd11ea5 = $c8a95b9803fa20ec$var$m;
$c8a95b9803fa20ec$export$998bcd577473dd93 = $c8a95b9803fa20ec$var$n;
$c8a95b9803fa20ec$export$92387174baf9b227 = function() {
    return !1;
};
$c8a95b9803fa20ec$export$ec112efeb987d9c6 = function() {
    return !1;
};
$c8a95b9803fa20ec$export$b706b080d889d2c9 = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$h;
};
$c8a95b9803fa20ec$export$5be5a87408f70ddc = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$g;
};
$c8a95b9803fa20ec$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c8a95b9803fa20ec$var$b;
};
$c8a95b9803fa20ec$export$455c2e768291efa6 = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$l;
};
$c8a95b9803fa20ec$export$9522e17588c12572 = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$d;
};
$c8a95b9803fa20ec$export$2110ac352bb060b9 = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$q;
};
$c8a95b9803fa20ec$export$56885ab8b9c456ab = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$p;
};
$c8a95b9803fa20ec$export$d927fcb6adf8f9de = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$c;
};
$c8a95b9803fa20ec$export$b82d16f27459e05a = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$f;
};
$c8a95b9803fa20ec$export$522c17b4f5e123e8 = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$e;
};
$c8a95b9803fa20ec$export$1aabd8a0274ecfd6 = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$m;
};
$c8a95b9803fa20ec$export$3d6c20d97e46b957 = function(a) {
    return $c8a95b9803fa20ec$var$v(a) === $c8a95b9803fa20ec$var$n;
};
$c8a95b9803fa20ec$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $c8a95b9803fa20ec$var$d || a === $c8a95b9803fa20ec$var$f || a === $c8a95b9803fa20ec$var$e || a === $c8a95b9803fa20ec$var$m || a === $c8a95b9803fa20ec$var$n || a === $c8a95b9803fa20ec$var$t || "object" === typeof a && null !== a && (a.$$typeof === $c8a95b9803fa20ec$var$q || a.$$typeof === $c8a95b9803fa20ec$var$p || a.$$typeof === $c8a95b9803fa20ec$var$g || a.$$typeof === $c8a95b9803fa20ec$var$h || a.$$typeof === $c8a95b9803fa20ec$var$l || a.$$typeof === $c8a95b9803fa20ec$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$c8a95b9803fa20ec$export$f5bbd400c2f4426f = $c8a95b9803fa20ec$var$v;

});

parcelRequire.register("kSsR5", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $f32f3bd33ee1bf91$export$2b8d127b894957b9; }, function (v) { return $f32f3bd33ee1bf91$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $f32f3bd33ee1bf91$export$cea3a54a6425200c; }, function (v) { return $f32f3bd33ee1bf91$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $f32f3bd33ee1bf91$export$a7c73072b1a182ae; }, function (v) { return $f32f3bd33ee1bf91$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $f32f3bd33ee1bf91$export$9f27bc3417b4524d; }, function (v) { return $f32f3bd33ee1bf91$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $f32f3bd33ee1bf91$export$db77ccec0bb4ccac; }, function (v) { return $f32f3bd33ee1bf91$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $f32f3bd33ee1bf91$export$8392c0c9d3dcbd35; }, function (v) { return $f32f3bd33ee1bf91$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $f32f3bd33ee1bf91$export$ffb0004e005737fa; }, function (v) { return $f32f3bd33ee1bf91$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $f32f3bd33ee1bf91$export$b624eff549462981; }, function (v) { return $f32f3bd33ee1bf91$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $f32f3bd33ee1bf91$export$7897aa7841a5380c; }, function (v) { return $f32f3bd33ee1bf91$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $f32f3bd33ee1bf91$export$602eac185826482c; }, function (v) { return $f32f3bd33ee1bf91$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $f32f3bd33ee1bf91$export$e2c29f18771995cb; }, function (v) { return $f32f3bd33ee1bf91$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $f32f3bd33ee1bf91$export$5f8d39834fd61797; }, function (v) { return $f32f3bd33ee1bf91$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $f32f3bd33ee1bf91$export$74bf444e3cd11ea5; }, function (v) { return $f32f3bd33ee1bf91$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $f32f3bd33ee1bf91$export$92387174baf9b227; }, function (v) { return $f32f3bd33ee1bf91$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $f32f3bd33ee1bf91$export$ec112efeb987d9c6; }, function (v) { return $f32f3bd33ee1bf91$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $f32f3bd33ee1bf91$export$b706b080d889d2c9; }, function (v) { return $f32f3bd33ee1bf91$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $f32f3bd33ee1bf91$export$5be5a87408f70ddc; }, function (v) { return $f32f3bd33ee1bf91$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $f32f3bd33ee1bf91$export$45a5e7f76e0caa8d; }, function (v) { return $f32f3bd33ee1bf91$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $f32f3bd33ee1bf91$export$455c2e768291efa6; }, function (v) { return $f32f3bd33ee1bf91$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $f32f3bd33ee1bf91$export$9522e17588c12572; }, function (v) { return $f32f3bd33ee1bf91$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $f32f3bd33ee1bf91$export$2110ac352bb060b9; }, function (v) { return $f32f3bd33ee1bf91$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $f32f3bd33ee1bf91$export$56885ab8b9c456ab; }, function (v) { return $f32f3bd33ee1bf91$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $f32f3bd33ee1bf91$export$d927fcb6adf8f9de; }, function (v) { return $f32f3bd33ee1bf91$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $f32f3bd33ee1bf91$export$b82d16f27459e05a; }, function (v) { return $f32f3bd33ee1bf91$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $f32f3bd33ee1bf91$export$522c17b4f5e123e8; }, function (v) { return $f32f3bd33ee1bf91$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $f32f3bd33ee1bf91$export$1aabd8a0274ecfd6; }, function (v) { return $f32f3bd33ee1bf91$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $f32f3bd33ee1bf91$export$9b621391a187a31a; }, function (v) { return $f32f3bd33ee1bf91$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $f32f3bd33ee1bf91$export$f5bbd400c2f4426f; }, function (v) { return $f32f3bd33ee1bf91$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f32f3bd33ee1bf91$export$2b8d127b894957b9;
var $f32f3bd33ee1bf91$export$cea3a54a6425200c;
var $f32f3bd33ee1bf91$export$a7c73072b1a182ae;
var $f32f3bd33ee1bf91$export$9f27bc3417b4524d;
var $f32f3bd33ee1bf91$export$db77ccec0bb4ccac;
var $f32f3bd33ee1bf91$export$8392c0c9d3dcbd35;
var $f32f3bd33ee1bf91$export$ffb0004e005737fa;
var $f32f3bd33ee1bf91$export$b624eff549462981;
var $f32f3bd33ee1bf91$export$7897aa7841a5380c;
var $f32f3bd33ee1bf91$export$602eac185826482c;
var $f32f3bd33ee1bf91$export$e2c29f18771995cb;
var $f32f3bd33ee1bf91$export$5f8d39834fd61797;
var $f32f3bd33ee1bf91$export$74bf444e3cd11ea5;
var $f32f3bd33ee1bf91$export$92387174baf9b227;
var $f32f3bd33ee1bf91$export$ec112efeb987d9c6;
var $f32f3bd33ee1bf91$export$b706b080d889d2c9;
var $f32f3bd33ee1bf91$export$5be5a87408f70ddc;
var $f32f3bd33ee1bf91$export$45a5e7f76e0caa8d;
var $f32f3bd33ee1bf91$export$455c2e768291efa6;
var $f32f3bd33ee1bf91$export$9522e17588c12572;
var $f32f3bd33ee1bf91$export$2110ac352bb060b9;
var $f32f3bd33ee1bf91$export$56885ab8b9c456ab;
var $f32f3bd33ee1bf91$export$d927fcb6adf8f9de;
var $f32f3bd33ee1bf91$export$b82d16f27459e05a;
var $f32f3bd33ee1bf91$export$522c17b4f5e123e8;
var $f32f3bd33ee1bf91$export$1aabd8a0274ecfd6;
var $f32f3bd33ee1bf91$export$9b621391a187a31a;
var $f32f3bd33ee1bf91$export$f5bbd400c2f4426f;
"use strict";
var $f32f3bd33ee1bf91$var$b = "function" === typeof Symbol && Symbol.for, $f32f3bd33ee1bf91$var$c = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.element") : 60103, $f32f3bd33ee1bf91$var$d = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.portal") : 60106, $f32f3bd33ee1bf91$var$e = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.fragment") : 60107, $f32f3bd33ee1bf91$var$f = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.strict_mode") : 60108, $f32f3bd33ee1bf91$var$g = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.profiler") : 60114, $f32f3bd33ee1bf91$var$h = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.provider") : 60109, $f32f3bd33ee1bf91$var$k = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.context") : 60110, $f32f3bd33ee1bf91$var$l = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.async_mode") : 60111, $f32f3bd33ee1bf91$var$m = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.concurrent_mode") : 60111, $f32f3bd33ee1bf91$var$n = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.forward_ref") : 60112, $f32f3bd33ee1bf91$var$p = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.suspense") : 60113, $f32f3bd33ee1bf91$var$q = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.suspense_list") : 60120, $f32f3bd33ee1bf91$var$r = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.memo") : 60115, $f32f3bd33ee1bf91$var$t = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.lazy") : 60116, $f32f3bd33ee1bf91$var$v = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.block") : 60121, $f32f3bd33ee1bf91$var$w = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.fundamental") : 60117, $f32f3bd33ee1bf91$var$x = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.responder") : 60118, $f32f3bd33ee1bf91$var$y = $f32f3bd33ee1bf91$var$b ? Symbol.for("react.scope") : 60119;
function $f32f3bd33ee1bf91$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $f32f3bd33ee1bf91$var$c:
                switch(a = a.type, a){
                    case $f32f3bd33ee1bf91$var$l:
                    case $f32f3bd33ee1bf91$var$m:
                    case $f32f3bd33ee1bf91$var$e:
                    case $f32f3bd33ee1bf91$var$g:
                    case $f32f3bd33ee1bf91$var$f:
                    case $f32f3bd33ee1bf91$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $f32f3bd33ee1bf91$var$k:
                            case $f32f3bd33ee1bf91$var$n:
                            case $f32f3bd33ee1bf91$var$t:
                            case $f32f3bd33ee1bf91$var$r:
                            case $f32f3bd33ee1bf91$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $f32f3bd33ee1bf91$var$d:
                return u;
        }
    }
}
function $f32f3bd33ee1bf91$var$A(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$m;
}
$f32f3bd33ee1bf91$export$2b8d127b894957b9 = $f32f3bd33ee1bf91$var$l;
$f32f3bd33ee1bf91$export$cea3a54a6425200c = $f32f3bd33ee1bf91$var$m;
$f32f3bd33ee1bf91$export$a7c73072b1a182ae = $f32f3bd33ee1bf91$var$k;
$f32f3bd33ee1bf91$export$9f27bc3417b4524d = $f32f3bd33ee1bf91$var$h;
$f32f3bd33ee1bf91$export$db77ccec0bb4ccac = $f32f3bd33ee1bf91$var$c;
$f32f3bd33ee1bf91$export$8392c0c9d3dcbd35 = $f32f3bd33ee1bf91$var$n;
$f32f3bd33ee1bf91$export$ffb0004e005737fa = $f32f3bd33ee1bf91$var$e;
$f32f3bd33ee1bf91$export$b624eff549462981 = $f32f3bd33ee1bf91$var$t;
$f32f3bd33ee1bf91$export$7897aa7841a5380c = $f32f3bd33ee1bf91$var$r;
$f32f3bd33ee1bf91$export$602eac185826482c = $f32f3bd33ee1bf91$var$d;
$f32f3bd33ee1bf91$export$e2c29f18771995cb = $f32f3bd33ee1bf91$var$g;
$f32f3bd33ee1bf91$export$5f8d39834fd61797 = $f32f3bd33ee1bf91$var$f;
$f32f3bd33ee1bf91$export$74bf444e3cd11ea5 = $f32f3bd33ee1bf91$var$p;
$f32f3bd33ee1bf91$export$92387174baf9b227 = function(a) {
    return $f32f3bd33ee1bf91$var$A(a) || $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$l;
};
$f32f3bd33ee1bf91$export$ec112efeb987d9c6 = $f32f3bd33ee1bf91$var$A;
$f32f3bd33ee1bf91$export$b706b080d889d2c9 = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$k;
};
$f32f3bd33ee1bf91$export$5be5a87408f70ddc = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$h;
};
$f32f3bd33ee1bf91$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $f32f3bd33ee1bf91$var$c;
};
$f32f3bd33ee1bf91$export$455c2e768291efa6 = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$n;
};
$f32f3bd33ee1bf91$export$9522e17588c12572 = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$e;
};
$f32f3bd33ee1bf91$export$2110ac352bb060b9 = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$t;
};
$f32f3bd33ee1bf91$export$56885ab8b9c456ab = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$r;
};
$f32f3bd33ee1bf91$export$d927fcb6adf8f9de = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$d;
};
$f32f3bd33ee1bf91$export$b82d16f27459e05a = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$g;
};
$f32f3bd33ee1bf91$export$522c17b4f5e123e8 = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$f;
};
$f32f3bd33ee1bf91$export$1aabd8a0274ecfd6 = function(a) {
    return $f32f3bd33ee1bf91$var$z(a) === $f32f3bd33ee1bf91$var$p;
};
$f32f3bd33ee1bf91$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $f32f3bd33ee1bf91$var$e || a === $f32f3bd33ee1bf91$var$m || a === $f32f3bd33ee1bf91$var$g || a === $f32f3bd33ee1bf91$var$f || a === $f32f3bd33ee1bf91$var$p || a === $f32f3bd33ee1bf91$var$q || "object" === typeof a && null !== a && (a.$$typeof === $f32f3bd33ee1bf91$var$t || a.$$typeof === $f32f3bd33ee1bf91$var$r || a.$$typeof === $f32f3bd33ee1bf91$var$h || a.$$typeof === $f32f3bd33ee1bf91$var$k || a.$$typeof === $f32f3bd33ee1bf91$var$n || a.$$typeof === $f32f3bd33ee1bf91$var$w || a.$$typeof === $f32f3bd33ee1bf91$var$x || a.$$typeof === $f32f3bd33ee1bf91$var$y || a.$$typeof === $f32f3bd33ee1bf91$var$v);
};
$f32f3bd33ee1bf91$export$f5bbd400c2f4426f = $f32f3bd33ee1bf91$var$z;

});

parcelRequire.register("eYBdv", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['’]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "Ā": "A",
        "Ă": "A",
        "Ą": "A",
        "ā": "a",
        "ă": "a",
        "ą": "a",
        "Ć": "C",
        "Ĉ": "C",
        "Ċ": "C",
        "Č": "C",
        "ć": "c",
        "ĉ": "c",
        "ċ": "c",
        "č": "c",
        "Ď": "D",
        "Đ": "D",
        "ď": "d",
        "đ": "d",
        "Ē": "E",
        "Ĕ": "E",
        "Ė": "E",
        "Ę": "E",
        "Ě": "E",
        "ē": "e",
        "ĕ": "e",
        "ė": "e",
        "ę": "e",
        "ě": "e",
        "Ĝ": "G",
        "Ğ": "G",
        "Ġ": "G",
        "Ģ": "G",
        "ĝ": "g",
        "ğ": "g",
        "ġ": "g",
        "ģ": "g",
        "Ĥ": "H",
        "Ħ": "H",
        "ĥ": "h",
        "ħ": "h",
        "Ĩ": "I",
        "Ī": "I",
        "Ĭ": "I",
        "Į": "I",
        "İ": "I",
        "ĩ": "i",
        "ī": "i",
        "ĭ": "i",
        "į": "i",
        "ı": "i",
        "Ĵ": "J",
        "ĵ": "j",
        "Ķ": "K",
        "ķ": "k",
        "ĸ": "k",
        "Ĺ": "L",
        "Ļ": "L",
        "Ľ": "L",
        "Ŀ": "L",
        "Ł": "L",
        "ĺ": "l",
        "ļ": "l",
        "ľ": "l",
        "ŀ": "l",
        "ł": "l",
        "Ń": "N",
        "Ņ": "N",
        "Ň": "N",
        "Ŋ": "N",
        "ń": "n",
        "ņ": "n",
        "ň": "n",
        "ŋ": "n",
        "Ō": "O",
        "Ŏ": "O",
        "Ő": "O",
        "ō": "o",
        "ŏ": "o",
        "ő": "o",
        "Ŕ": "R",
        "Ŗ": "R",
        "Ř": "R",
        "ŕ": "r",
        "ŗ": "r",
        "ř": "r",
        "Ś": "S",
        "Ŝ": "S",
        "Ş": "S",
        "Š": "S",
        "ś": "s",
        "ŝ": "s",
        "ş": "s",
        "š": "s",
        "Ţ": "T",
        "Ť": "T",
        "Ŧ": "T",
        "ţ": "t",
        "ť": "t",
        "ŧ": "t",
        "Ũ": "U",
        "Ū": "U",
        "Ŭ": "U",
        "Ů": "U",
        "Ű": "U",
        "Ų": "U",
        "ũ": "u",
        "ū": "u",
        "ŭ": "u",
        "ů": "u",
        "ű": "u",
        "ų": "u",
        "Ŵ": "W",
        "ŵ": "w",
        "Ŷ": "Y",
        "ŷ": "y",
        "Ÿ": "Y",
        "Ź": "Z",
        "Ż": "Z",
        "Ž": "Z",
        "ź": "z",
        "ż": "z",
        "ž": "z",
        "Ĳ": "IJ",
        "ĳ": "ij",
        "Œ": "Oe",
        "œ": "oe",
        "ŉ": "'n",
        "ſ": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRequire.register("a35Mc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $e8M6t = parcelRequire("e8M6t");
function $750eaa48fae6d799$var$emptyFunction() {}
function $750eaa48fae6d799$var$emptyFunctionWithReset() {}
$750eaa48fae6d799$var$emptyFunctionWithReset.resetWarningCache = $750eaa48fae6d799$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $e8M6t) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $750eaa48fae6d799$var$emptyFunctionWithReset,
        resetWarningCache: $750eaa48fae6d799$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("e8M6t", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $a4b7206082170633$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $a4b7206082170633$var$ReactPropTypesSecret;

});


parcelRequire.register("7NPHw", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $5ae536c42e9d9d6b$export$2b8d127b894957b9; }, function (v) { return $5ae536c42e9d9d6b$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $5ae536c42e9d9d6b$export$cea3a54a6425200c; }, function (v) { return $5ae536c42e9d9d6b$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $5ae536c42e9d9d6b$export$a7c73072b1a182ae; }, function (v) { return $5ae536c42e9d9d6b$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $5ae536c42e9d9d6b$export$9f27bc3417b4524d; }, function (v) { return $5ae536c42e9d9d6b$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $5ae536c42e9d9d6b$export$db77ccec0bb4ccac; }, function (v) { return $5ae536c42e9d9d6b$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $5ae536c42e9d9d6b$export$8392c0c9d3dcbd35; }, function (v) { return $5ae536c42e9d9d6b$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5ae536c42e9d9d6b$export$ffb0004e005737fa; }, function (v) { return $5ae536c42e9d9d6b$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $5ae536c42e9d9d6b$export$b624eff549462981; }, function (v) { return $5ae536c42e9d9d6b$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $5ae536c42e9d9d6b$export$7897aa7841a5380c; }, function (v) { return $5ae536c42e9d9d6b$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $5ae536c42e9d9d6b$export$602eac185826482c; }, function (v) { return $5ae536c42e9d9d6b$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $5ae536c42e9d9d6b$export$e2c29f18771995cb; }, function (v) { return $5ae536c42e9d9d6b$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5ae536c42e9d9d6b$export$5f8d39834fd61797; }, function (v) { return $5ae536c42e9d9d6b$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5ae536c42e9d9d6b$export$74bf444e3cd11ea5; }, function (v) { return $5ae536c42e9d9d6b$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $5ae536c42e9d9d6b$export$92387174baf9b227; }, function (v) { return $5ae536c42e9d9d6b$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $5ae536c42e9d9d6b$export$ec112efeb987d9c6; }, function (v) { return $5ae536c42e9d9d6b$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $5ae536c42e9d9d6b$export$b706b080d889d2c9; }, function (v) { return $5ae536c42e9d9d6b$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $5ae536c42e9d9d6b$export$5be5a87408f70ddc; }, function (v) { return $5ae536c42e9d9d6b$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $5ae536c42e9d9d6b$export$45a5e7f76e0caa8d; }, function (v) { return $5ae536c42e9d9d6b$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $5ae536c42e9d9d6b$export$455c2e768291efa6; }, function (v) { return $5ae536c42e9d9d6b$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $5ae536c42e9d9d6b$export$9522e17588c12572; }, function (v) { return $5ae536c42e9d9d6b$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $5ae536c42e9d9d6b$export$2110ac352bb060b9; }, function (v) { return $5ae536c42e9d9d6b$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $5ae536c42e9d9d6b$export$56885ab8b9c456ab; }, function (v) { return $5ae536c42e9d9d6b$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $5ae536c42e9d9d6b$export$d927fcb6adf8f9de; }, function (v) { return $5ae536c42e9d9d6b$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $5ae536c42e9d9d6b$export$b82d16f27459e05a; }, function (v) { return $5ae536c42e9d9d6b$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $5ae536c42e9d9d6b$export$522c17b4f5e123e8; }, function (v) { return $5ae536c42e9d9d6b$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $5ae536c42e9d9d6b$export$1aabd8a0274ecfd6; }, function (v) { return $5ae536c42e9d9d6b$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $5ae536c42e9d9d6b$export$9b621391a187a31a; }, function (v) { return $5ae536c42e9d9d6b$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $5ae536c42e9d9d6b$export$f5bbd400c2f4426f; }, function (v) { return $5ae536c42e9d9d6b$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5ae536c42e9d9d6b$export$2b8d127b894957b9;
var $5ae536c42e9d9d6b$export$cea3a54a6425200c;
var $5ae536c42e9d9d6b$export$a7c73072b1a182ae;
var $5ae536c42e9d9d6b$export$9f27bc3417b4524d;
var $5ae536c42e9d9d6b$export$db77ccec0bb4ccac;
var $5ae536c42e9d9d6b$export$8392c0c9d3dcbd35;
var $5ae536c42e9d9d6b$export$ffb0004e005737fa;
var $5ae536c42e9d9d6b$export$b624eff549462981;
var $5ae536c42e9d9d6b$export$7897aa7841a5380c;
var $5ae536c42e9d9d6b$export$602eac185826482c;
var $5ae536c42e9d9d6b$export$e2c29f18771995cb;
var $5ae536c42e9d9d6b$export$5f8d39834fd61797;
var $5ae536c42e9d9d6b$export$74bf444e3cd11ea5;
var $5ae536c42e9d9d6b$export$92387174baf9b227;
var $5ae536c42e9d9d6b$export$ec112efeb987d9c6;
var $5ae536c42e9d9d6b$export$b706b080d889d2c9;
var $5ae536c42e9d9d6b$export$5be5a87408f70ddc;
var $5ae536c42e9d9d6b$export$45a5e7f76e0caa8d;
var $5ae536c42e9d9d6b$export$455c2e768291efa6;
var $5ae536c42e9d9d6b$export$9522e17588c12572;
var $5ae536c42e9d9d6b$export$2110ac352bb060b9;
var $5ae536c42e9d9d6b$export$56885ab8b9c456ab;
var $5ae536c42e9d9d6b$export$d927fcb6adf8f9de;
var $5ae536c42e9d9d6b$export$b82d16f27459e05a;
var $5ae536c42e9d9d6b$export$522c17b4f5e123e8;
var $5ae536c42e9d9d6b$export$1aabd8a0274ecfd6;
var $5ae536c42e9d9d6b$export$9b621391a187a31a;
var $5ae536c42e9d9d6b$export$f5bbd400c2f4426f;
"use strict";
var $5ae536c42e9d9d6b$var$b = "function" === typeof Symbol && Symbol.for, $5ae536c42e9d9d6b$var$c = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.element") : 60103, $5ae536c42e9d9d6b$var$d = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.portal") : 60106, $5ae536c42e9d9d6b$var$e = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.fragment") : 60107, $5ae536c42e9d9d6b$var$f = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.strict_mode") : 60108, $5ae536c42e9d9d6b$var$g = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.profiler") : 60114, $5ae536c42e9d9d6b$var$h = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.provider") : 60109, $5ae536c42e9d9d6b$var$k = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.context") : 60110, $5ae536c42e9d9d6b$var$l = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.async_mode") : 60111, $5ae536c42e9d9d6b$var$m = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.concurrent_mode") : 60111, $5ae536c42e9d9d6b$var$n = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.forward_ref") : 60112, $5ae536c42e9d9d6b$var$p = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.suspense") : 60113, $5ae536c42e9d9d6b$var$q = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.suspense_list") : 60120, $5ae536c42e9d9d6b$var$r = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.memo") : 60115, $5ae536c42e9d9d6b$var$t = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.lazy") : 60116, $5ae536c42e9d9d6b$var$v = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.block") : 60121, $5ae536c42e9d9d6b$var$w = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.fundamental") : 60117, $5ae536c42e9d9d6b$var$x = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.responder") : 60118, $5ae536c42e9d9d6b$var$y = $5ae536c42e9d9d6b$var$b ? Symbol.for("react.scope") : 60119;
function $5ae536c42e9d9d6b$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $5ae536c42e9d9d6b$var$c:
                switch(a = a.type, a){
                    case $5ae536c42e9d9d6b$var$l:
                    case $5ae536c42e9d9d6b$var$m:
                    case $5ae536c42e9d9d6b$var$e:
                    case $5ae536c42e9d9d6b$var$g:
                    case $5ae536c42e9d9d6b$var$f:
                    case $5ae536c42e9d9d6b$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $5ae536c42e9d9d6b$var$k:
                            case $5ae536c42e9d9d6b$var$n:
                            case $5ae536c42e9d9d6b$var$t:
                            case $5ae536c42e9d9d6b$var$r:
                            case $5ae536c42e9d9d6b$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $5ae536c42e9d9d6b$var$d:
                return u;
        }
    }
}
function $5ae536c42e9d9d6b$var$A(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$m;
}
$5ae536c42e9d9d6b$export$2b8d127b894957b9 = $5ae536c42e9d9d6b$var$l;
$5ae536c42e9d9d6b$export$cea3a54a6425200c = $5ae536c42e9d9d6b$var$m;
$5ae536c42e9d9d6b$export$a7c73072b1a182ae = $5ae536c42e9d9d6b$var$k;
$5ae536c42e9d9d6b$export$9f27bc3417b4524d = $5ae536c42e9d9d6b$var$h;
$5ae536c42e9d9d6b$export$db77ccec0bb4ccac = $5ae536c42e9d9d6b$var$c;
$5ae536c42e9d9d6b$export$8392c0c9d3dcbd35 = $5ae536c42e9d9d6b$var$n;
$5ae536c42e9d9d6b$export$ffb0004e005737fa = $5ae536c42e9d9d6b$var$e;
$5ae536c42e9d9d6b$export$b624eff549462981 = $5ae536c42e9d9d6b$var$t;
$5ae536c42e9d9d6b$export$7897aa7841a5380c = $5ae536c42e9d9d6b$var$r;
$5ae536c42e9d9d6b$export$602eac185826482c = $5ae536c42e9d9d6b$var$d;
$5ae536c42e9d9d6b$export$e2c29f18771995cb = $5ae536c42e9d9d6b$var$g;
$5ae536c42e9d9d6b$export$5f8d39834fd61797 = $5ae536c42e9d9d6b$var$f;
$5ae536c42e9d9d6b$export$74bf444e3cd11ea5 = $5ae536c42e9d9d6b$var$p;
$5ae536c42e9d9d6b$export$92387174baf9b227 = function(a) {
    return $5ae536c42e9d9d6b$var$A(a) || $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$l;
};
$5ae536c42e9d9d6b$export$ec112efeb987d9c6 = $5ae536c42e9d9d6b$var$A;
$5ae536c42e9d9d6b$export$b706b080d889d2c9 = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$k;
};
$5ae536c42e9d9d6b$export$5be5a87408f70ddc = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$h;
};
$5ae536c42e9d9d6b$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $5ae536c42e9d9d6b$var$c;
};
$5ae536c42e9d9d6b$export$455c2e768291efa6 = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$n;
};
$5ae536c42e9d9d6b$export$9522e17588c12572 = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$e;
};
$5ae536c42e9d9d6b$export$2110ac352bb060b9 = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$t;
};
$5ae536c42e9d9d6b$export$56885ab8b9c456ab = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$r;
};
$5ae536c42e9d9d6b$export$d927fcb6adf8f9de = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$d;
};
$5ae536c42e9d9d6b$export$b82d16f27459e05a = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$g;
};
$5ae536c42e9d9d6b$export$522c17b4f5e123e8 = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$f;
};
$5ae536c42e9d9d6b$export$1aabd8a0274ecfd6 = function(a) {
    return $5ae536c42e9d9d6b$var$z(a) === $5ae536c42e9d9d6b$var$p;
};
$5ae536c42e9d9d6b$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $5ae536c42e9d9d6b$var$e || a === $5ae536c42e9d9d6b$var$m || a === $5ae536c42e9d9d6b$var$g || a === $5ae536c42e9d9d6b$var$f || a === $5ae536c42e9d9d6b$var$p || a === $5ae536c42e9d9d6b$var$q || "object" === typeof a && null !== a && (a.$$typeof === $5ae536c42e9d9d6b$var$t || a.$$typeof === $5ae536c42e9d9d6b$var$r || a.$$typeof === $5ae536c42e9d9d6b$var$h || a.$$typeof === $5ae536c42e9d9d6b$var$k || a.$$typeof === $5ae536c42e9d9d6b$var$n || a.$$typeof === $5ae536c42e9d9d6b$var$w || a.$$typeof === $5ae536c42e9d9d6b$var$x || a.$$typeof === $5ae536c42e9d9d6b$var$y || a.$$typeof === $5ae536c42e9d9d6b$var$v);
};
$5ae536c42e9d9d6b$export$f5bbd400c2f4426f = $5ae536c42e9d9d6b$var$z;

});

parcelRequire.register("3bV2r", function(module, exports) {
"use strict";
var $252ea4d4845f827a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $252ea4d4845f827a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $252ea4d4845f827a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.forceInit = module.exports.util = module.exports.math = module.exports.random = module.exports.sources = module.exports.variation = module.exports.Emitter = module.exports.Particle = module.exports.settings = module.exports.scene = void 0;

var $Ic9gt = parcelRequire("Ic9gt");


$252ea4d4845f827a$var$__exportStar((parcelRequire("dyj7k")), module.exports);

$252ea4d4845f827a$var$__exportStar((parcelRequire("emA6W")), module.exports);

$252ea4d4845f827a$var$__exportStar((parcelRequire("9B07f")), module.exports);

$252ea4d4845f827a$var$__exportStar((parcelRequire("lcCa9")), module.exports);
// Create the lazy-initializing scene.
module.exports.scene = new (parcelRequire("jIw4J")).Lazy(function() {
    // The library requires the use of the DOM, hence it cannot run in non-browser environments.
    if (typeof document === "undefined" || typeof window === "undefined") throw new Error("It seems like you are trying to run party.js in a non-browser-like environment, which is not supported.");
    return new $Ic9gt.Scene();
});

var $gUFIr = parcelRequire("gUFIr");
Object.defineProperty(module.exports, "settings", {
    enumerable: true,
    get: function() {
        return $gUFIr.settings;
    }
});

var $i790t = parcelRequire("i790t");
Object.defineProperty(module.exports, "Particle", {
    enumerable: true,
    get: function() {
        return $i790t.Particle;
    }
});

var $jkafM = parcelRequire("jkafM");
Object.defineProperty(module.exports, "Emitter", {
    enumerable: true,
    get: function() {
        return $jkafM.Emitter;
    }
});

module.exports.variation = (parcelRequire("49jCK"));

module.exports.sources = (parcelRequire("4Tf2i"));

module.exports.random = (parcelRequire("4uhq2"));

module.exports.math = (parcelRequire("3cxgK"));

module.exports.util = (parcelRequire("jIw4J"));
/**
 * Forces the initialization of the otherwise lazy scene.
 */ function $252ea4d4845f827a$var$forceInit() {
    module.exports.scene.current;
}
module.exports.forceInit = $252ea4d4845f827a$var$forceInit;

module.exports.default = module.exports;

});
parcelRequire.register("Ic9gt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Scene = void 0;

var $99ysm = parcelRequire("99ysm");

var $jkafM = parcelRequire("jkafM");

var $4fYY2 = parcelRequire("4fYY2");
/**
 * Represents a scene that contains emitters and their particles.
 *
 * Scenes are responsible for spawning and updating emitters, and
 * removing them once they are done.
 *
 * Scenes are not explicitely present in the DOM as an element, only
 * the contained particles are.
 */ var $084d8899b5589aba$var$Scene = /** @class */ function() {
    /**
     * Initializes a new scene and starts the ticking job.
     */ function Scene() {
        /**
         * The emitters currently present in the scene.
         */ this.emitters = [];
        /**
         * The debug instance associated with the scene.
         */ this.debug = new $99ysm.Debug(this);
        /**
         * The renderer associated with the scene.
         */ this.renderer = new $4fYY2.Renderer();
        /**
         * The ID of the currently scheduled tick.
         */ this.scheduledTickId = undefined;
        /**
         * The timestamp of the last tick, used to calculate deltas.
         *
         * @initialValue `performance.now()` (time origin)
         * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp
         */ this.lastTickTimestamp = performance.now();
        // Ensure the scene context is preserved on the tick.
        this.tick = this.tick.bind(this);
        this.scheduleTick();
    }
    /**
     * Creates and returns a new, default emitter object.
     */ Scene.prototype.createEmitter = function(options) {
        var emitter = new $jkafM.Emitter(options);
        this.emitters.push(emitter);
        return emitter;
    };
    /**
     * Clears all emitters from the scene.
     *
     * @returns The number of cleared emitters.
     */ Scene.prototype.clearEmitters = function() {
        return this.emitters.splice(0).length;
    };
    /**
     * Clears the particles from all emitters in the scene.
     * Note that this does not remove the actual emitter objects though.
     *
     * @returns The number of cleared particles.
     */ Scene.prototype.clearParticles = function() {
        return this.emitters.reduce(function(sum, emitter) {
            return sum + emitter.clearParticles();
        }, 0);
    };
    /**
     * Schedules a tick in the scene.
     */ Scene.prototype.scheduleTick = function() {
        this.scheduledTickId = window.requestAnimationFrame(this.tick);
    };
    /**
     * Cancels a pending tick operation.
     */ Scene.prototype.cancelTick = function() {
        window.cancelAnimationFrame(this.scheduledTickId);
    };
    /**
     * Processes a tick cycle, updating all emitters contained in the scene.
     * This is handled as a JS animation frame event, hence the passed timestamp.
     *
     * @remarks
     * The emitter ticking and particle rendering is run using try-catch blocks,
     * to ensure that we can recover from potential errors.
     *
     * @param timestamp The current timestamp of the animation frame.
     */ Scene.prototype.tick = function(timestamp) {
        // Calculate the elapsed delta and convert it to seconds.
        var delta = (timestamp - this.lastTickTimestamp) / 1000;
        try {
            // Perform ticks for all the emitters in the scene.
            for(var i = 0; i < this.emitters.length; i++){
                var emitter = this.emitters[i];
                emitter.tick(delta);
                if (emitter.isExpired && emitter.canRemove) this.emitters.splice(i--, 1);
            }
        } catch (error) {
            console.error("An error occurred while updating the scene's emitters:\n\"" + error + '"');
        }
        try {
            // Instruct the renderer to draw the particles of all systems.
            this.renderer.begin();
            for(var _i = 0, _a = this.emitters; _i < _a.length; _i++){
                var emitter = _a[_i];
                for(var _b = 0, _c = emitter.particles; _b < _c.length; _b++){
                    var particle = _c[_b];
                    this.renderer.renderParticle(particle, emitter);
                }
            }
            this.renderer.end();
        } catch (error) {
            console.error("An error occurred while rendering the scene's particles:\n\"" + error + '"');
        }
        // Perform a tick on the debug interface
        this.debug.tick(delta);
        // Save the timestamp as the last tick timestamp and schedule a new tick.
        this.lastTickTimestamp = timestamp;
        this.scheduleTick();
    };
    return Scene;
}();
module.exports.Scene = $084d8899b5589aba$var$Scene;

});
parcelRequire.register("99ysm", function(module, exports) {
"use strict";
var $6a9faea47cb1c8bb$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Debug = void 0;

var $1C76P = parcelRequire("1C76P");

var $gUFIr = parcelRequire("gUFIr");
/**
 * Represents a utility module to view debug information inside the DOM.
 * This is disabled by default and needs to manually be enabled by setting
 * the '.enabled' field to true.
 *
 * While disabled, the utility will not fetch stats and update itself.
 */ var $6a9faea47cb1c8bb$var$Debug = /** @class */ function() {
    /**
     * Registers a new debug utility that is attached to the given scene.
     *
     * @param scene The scene to attach to.
     */ function Debug(scene) {
        this.scene = scene;
        /**
         * The rate at which the debug interface should refresh itself (per second).
         */ this.refreshRate = 8;
        /**
         * The timer counting down to refreshes.
         */ this.refreshTimer = 1 / this.refreshRate;
    }
    /**
     * Processes a tick event in the interface. This checks if enough has passed to
     * trigger a refresh, and if so, fetches the debug information and updates the DOM.
     *
     * @param delta The time that has elapsed since the last tick.
     */ Debug.prototype.tick = function(delta) {
        var container = $1C76P.debugContainer.current;
        // If the current display style does not match the style inferred from the
        // enabled-state, update it.
        var displayStyle = $gUFIr.settings.debug ? "block" : "none";
        if (container.style.display !== displayStyle) container.style.display = displayStyle;
        if (!$gUFIr.settings.debug) // If the interface is not enabled, don't fetch or update any infos.
        return;
        this.refreshTimer += delta;
        if (this.refreshTimer > 1 / this.refreshRate) {
            this.refreshTimer = 0;
            // Update the container with the fetched information joined on line breaks.
            container.innerHTML = this.getDebugInformation(delta).join("<br>");
        }
    };
    /**
     * Fetches the debug information from the specified delta and the linked scene.
     *
     * @returns An array of debugging information, formatted as HTML.
     */ Debug.prototype.getDebugInformation = function(delta) {
        // Count emitters and particles.
        var emitters = this.scene.emitters.length;
        var particles = this.scene.emitters.reduce(function(acc, cur) {
            return acc + cur.particles.length;
        }, 0);
        var infos = [
            "<b>party.js Debug</b>",
            "--------------",
            "FPS: " + Math.round(1 / delta),
            "Emitters: " + emitters,
            "Particles: " + particles
        ];
        // Emitter informations are formatted using their index, internal timer
        // and total particle count.
        var emitterInfos = this.scene.emitters.map(function(emitter) {
            return [
                // Show the current loop and the total loops.
                "⭯: " + (emitter["currentLoop"] + 1) + "/" + (emitter.options.loops >= 0 ? emitter.options.loops : "∞"),
                // Show the amount of particle contained.
                "Σp: " + emitter.particles.length,
                // Show the internal timer.
                !emitter.isExpired ? "Σt: " + emitter["durationTimer"].toFixed(3) + "s" : "<i>expired</i>"
            ].join(", ");
        });
        infos.push.apply(infos, $6a9faea47cb1c8bb$var$__spreadArray([
            "--------------"
        ], emitterInfos));
        return infos;
    };
    return Debug;
}();
module.exports.Debug = $6a9faea47cb1c8bb$var$Debug;

});
parcelRequire.register("1C76P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.particleContainer = module.exports.debugContainer = module.exports.rootContainer = void 0;

var $gUFIr = parcelRequire("gUFIr");

var $jIw4J = parcelRequire("jIw4J");
/**
 * The prefix to apply to the containers.
 */ var $12cedacad5a758a8$var$containerPrefix = "party-js-";
/**
 * Checks if the specified container is 'active', meaning not undefined and attached to the DOM.
 */ function $12cedacad5a758a8$var$isContainerActive(container) {
    return container && container.isConnected;
}
/**
 * A generic factory method for creating a DOM container. Prefixes the specified name with the
 * container prefix, applies the styles and adds it under the parent.
 */ function $12cedacad5a758a8$var$makeContainer(name, styles, parent) {
    var container = document.createElement("div");
    container.id = $12cedacad5a758a8$var$containerPrefix + name;
    Object.assign(container.style, styles);
    return parent.appendChild(container);
}
/**
 * Represents the root container for DOM elements of the library.
 */ module.exports.rootContainer = new $jIw4J.Lazy(function() {
    return $12cedacad5a758a8$var$makeContainer("container", {
        position: "fixed",
        left: "0",
        top: "0",
        height: "100vh",
        width: "100vw",
        pointerEvents: "none",
        userSelect: "none",
        zIndex: $gUFIr.settings.zIndex.toString()
    }, document.body);
}, $12cedacad5a758a8$var$isContainerActive);
/**
 * Represents the debugging container of the library, only active if debugging is enabled.
 */ module.exports.debugContainer = new $jIw4J.Lazy(function() {
    return $12cedacad5a758a8$var$makeContainer("debug", {
        position: "absolute",
        top: "0",
        left: "0",
        margin: "0.5em",
        padding: "0.5em 1em",
        border: "2px solid rgb(0, 0, 0, 0.2)",
        background: "rgb(0, 0, 0, 0.1)",
        color: "#555",
        fontFamily: "monospace"
    }, module.exports.rootContainer.current);
}, $12cedacad5a758a8$var$isContainerActive);
/**
 * Represents the particle container of the library.
 * This is where the particle DOM elements get rendered into.
 */ module.exports.particleContainer = new $jIw4J.Lazy(function() {
    return $12cedacad5a758a8$var$makeContainer("particles", {
        width: "100%",
        height: "100%",
        overflow: "hidden",
        perspective: "1200px"
    }, module.exports.rootContainer.current);
}, $12cedacad5a758a8$var$isContainerActive);

});
parcelRequire.register("gUFIr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.settings = void 0;
module.exports.settings = {
    debug: false,
    gravity: 800,
    zIndex: 99999,
    respectReducedMotion: true
};

});

parcelRequire.register("jIw4J", function(module, exports) {
"use strict";
var $e5ab01daecbd9bd3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e5ab01daecbd9bd3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e5ab01daecbd9bd3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e5ab01daecbd9bd3$var$__exportStar((parcelRequire("89N2W")), module.exports);

$e5ab01daecbd9bd3$var$__exportStar((parcelRequire("dRdBI")), module.exports);

$e5ab01daecbd9bd3$var$__exportStar((parcelRequire("3wB5D")), module.exports);

$e5ab01daecbd9bd3$var$__exportStar((parcelRequire("ksOLl")), module.exports);

});
parcelRequire.register("89N2W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.overrideDefaults = void 0;
/**
 * Replaces the supplied defaults with the properties specified in the overrides.
 * This returns a new object.
 */ function $5f05359605654a35$var$overrideDefaults(defaults, overrides) {
    return Object.assign({}, defaults, overrides);
}
module.exports.overrideDefaults = $5f05359605654a35$var$overrideDefaults;

});

parcelRequire.register("dRdBI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rotationToNormal = void 0;

var $dyj7k = parcelRequire("dyj7k");

var $3cxgK = parcelRequire("3cxgK");
/**
 * Converts the specified euler rotation (in degrees) into the corresponding normal vector.
 *
 * @remarks
 * The normal is calculated by placing a (figurative) plane in a coordinate-system's
 * origin, and rotating it by the specified angles. Note that the z-component of the
 * rotation is irrelevant for the normal and can be ignored. Then, two vectors
 * describing the orientation of the plane are calculated. Their cross product
 * denotes the normal vector.
 *
 * @param rotation The euler rotation angles (in degrees) to calculate the normal for.
 */ function $a16ac7b79b3617c9$var$rotationToNormal(rotation) {
    var alpha = rotation.x * $3cxgK.deg2rad;
    var beta = rotation.y * $3cxgK.deg2rad;
    var a = new $dyj7k.Vector(Math.cos(beta), 0, Math.sin(beta));
    var b = new $dyj7k.Vector(0, Math.cos(alpha), Math.sin(alpha));
    return a.cross(b);
}
module.exports.rotationToNormal = $a16ac7b79b3617c9$var$rotationToNormal;

});
parcelRequire.register("dyj7k", function(module, exports) {
"use strict";
var $9ddd479cea27b888$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9ddd479cea27b888$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9ddd479cea27b888$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$9ddd479cea27b888$var$__exportStar((parcelRequire("bNiNP")), module.exports);

$9ddd479cea27b888$var$__exportStar((parcelRequire("1JDg5")), module.exports);

$9ddd479cea27b888$var$__exportStar((parcelRequire("a4rvg")), module.exports);

$9ddd479cea27b888$var$__exportStar((parcelRequire("gwrfZ")), module.exports);

$9ddd479cea27b888$var$__exportStar((parcelRequire("kdTzs")), module.exports);

$9ddd479cea27b888$var$__exportStar((parcelRequire("04nSR")), module.exports);

});
parcelRequire.register("bNiNP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Circle = void 0;
/**
 * Represents a circle.
 */ var $8962db1d009a670c$var$Circle = /** @class */ function() {
    /**
     * Creates a new circle at the specified coordinates, with a default radius of 0.
     */ function Circle(x, y, radius) {
        if (radius === void 0) radius = 0;
        this.x = x;
        this.y = y;
        this.radius = radius;
    }
    Circle.zero = new Circle(0, 0);
    return Circle;
}();
module.exports.Circle = $8962db1d009a670c$var$Circle;

});

parcelRequire.register("1JDg5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Color = void 0;

var $3cxgK = parcelRequire("3cxgK");
/**
 * Represents a color consisting of RGB values. The components of it are
 * represented as integers in the range 0 to 255.
 *
 * @example
 * ```ts
 * const a = new Color(12, 59, 219);
 * const b = Color.fromHex("#ffa68d");
 * const result = a.mix(b);
 * ```
 */ var $14387259f4aec753$var$Color = /** @class */ function() {
    /**
     * Creates a new color instance from the specified RGB components.
     */ function Color(r, g, b) {
        this.values = new Float32Array(3);
        this.rgb = [
            r,
            g,
            b
        ];
    }
    Object.defineProperty(Color.prototype, "r", {
        /**
         * Returns the r-component of the color.
         */ get: function() {
            return this.values[0];
        },
        /**
         * Modifies the r-component of the color.
         * Note that this also floors the value.
         */ set: function(value) {
            this.values[0] = Math.floor(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "g", {
        /**
         * Returns the g-component of the color.
         */ get: function() {
            return this.values[1];
        },
        /**
         * Modifies the g-component of the color.
         * Note that this also floors the value.
         */ set: function(value) {
            this.values[1] = Math.floor(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "b", {
        /**
         * Returns the b-component of the color.
         * Note that this also floors the value.
         */ get: function() {
            return this.values[2];
        },
        /**
         * Modifies the b-component of the color.
         */ set: function(value) {
            this.values[2] = Math.floor(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "rgb", {
        /**
         * Returns the rgb-components of the color, bundled as a copied array.
         */ get: function() {
            return [
                this.r,
                this.g,
                this.b
            ];
        },
        /**
         * Simultaneously updates the rgb-components of the color, by passing an array.
         */ set: function(values) {
            this.r = values[0];
            this.g = values[1];
            this.b = values[2];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Mixes the two color together with an optional mixing weight.
     * This weight is 0.5 by default, perfectly averaging the color.
     */ Color.prototype.mix = function(color, weight) {
        if (weight === void 0) weight = 0.5;
        return new Color($3cxgK.lerp(this.r, color.r, weight), $3cxgK.lerp(this.g, color.g, weight), $3cxgK.lerp(this.b, color.b, weight));
    };
    /**
     * Returns the hexadecimal representation of the color, prefixed by '#'.
     */ Color.prototype.toHex = function() {
        var hex = function(v) {
            return v.toString(16).padStart(2, "0");
        };
        return "#" + hex(this.r) + hex(this.g) + hex(this.b);
    };
    /**
     * Returns a formatted representation of the color.
     */ Color.prototype.toString = function() {
        return "rgb(" + this.values.join(", ") + ")";
    };
    /**
     * Creates a color from the specified hexadecimal string.
     * This string can optionally be prefixed by '#'.
     */ Color.fromHex = function(hex) {
        if (hex.startsWith("#")) hex = hex.substr(1);
        return new Color(parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16));
    };
    /**
     * Creates a color from the specified HSL components.
     *
     * @see https://stackoverflow.com/a/9493060/5507624
     */ Color.fromHsl = function(h, s, l) {
        h /= 360;
        s /= 100;
        l /= 100;
        if (s === 0) return new Color(l, l, l);
        else {
            var hue2rgb = function(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 0.5) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };
            var to255 = function(v) {
                return Math.min(255, 256 * v);
            };
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            return new Color(to255(hue2rgb(p, q, h + 1 / 3)), to255(hue2rgb(p, q, h)), to255(hue2rgb(p, q, h - 1 / 3)));
        }
    };
    /**
     * Returns (1, 1, 1).
     */ Color.white = new Color(255, 255, 255);
    /**
     * Returns (0, 0, 0).
     */ Color.black = new Color(0, 0, 0);
    return Color;
}();
module.exports.Color = $14387259f4aec753$var$Color;

});
parcelRequire.register("3cxgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.approximately = module.exports.clamp = module.exports.invlerp = module.exports.slerp = module.exports.lerp = module.exports.epsilon = module.exports.rad2deg = module.exports.deg2rad = void 0;
/**
 * Constant coefficient to convert degrees to radians.
 */ module.exports.deg2rad = Math.PI / 180;
/**
 * Constant coefficient to convert radians to degrees.
 */ module.exports.rad2deg = 180 / Math.PI;
/**
 * A small value to approximately compare values.
 */ module.exports.epsilon = 0.000001;
/**
 * Linearly interpolates between a and b by t.
 */ function $254c4ca06f5afc5b$var$lerp(a, b, t) {
    return (1 - t) * a + t * b;
}
module.exports.lerp = $254c4ca06f5afc5b$var$lerp;
/**
 * Smoothly interpolates between a and b by t (using cosine interpolation).
 */ function $254c4ca06f5afc5b$var$slerp(a, b, t) {
    return $254c4ca06f5afc5b$var$lerp(a, b, (1 - Math.cos(t * Math.PI)) / 2);
}
module.exports.slerp = $254c4ca06f5afc5b$var$slerp;
/**
 * Inversely lerps v between a and b to find t.
 */ function $254c4ca06f5afc5b$var$invlerp(a, b, v) {
    return (v - a) / (b - a);
}
module.exports.invlerp = $254c4ca06f5afc5b$var$invlerp;
/**
 * Clamps the specified value between a minimum and a maximum.
 */ function $254c4ca06f5afc5b$var$clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
module.exports.clamp = $254c4ca06f5afc5b$var$clamp;
/**
 * Checks if a is approximately equal to b.
 */ function $254c4ca06f5afc5b$var$approximately(a, b) {
    return Math.abs(a - b) < module.exports.epsilon;
}
module.exports.approximately = $254c4ca06f5afc5b$var$approximately;

});


parcelRequire.register("a4rvg", function(module, exports) {
"use strict";
var $754f9caf51355d3a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $754f9caf51355d3a$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Gradient = void 0;

var $dlgtA = parcelRequire("dlgtA");
/**
 * Represents a gradient that can be used to interpolate between multiple color.
 */ var $754f9caf51355d3a$var$Gradient = /** @class */ function(_super) {
    $754f9caf51355d3a$var$__extends(Gradient, _super);
    function Gradient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Interpolates between two color on the gradient.
     */ Gradient.prototype.interpolate = function(a, b, t) {
        return a.mix(b, t);
    };
    /**
     * Returns a solid gradient from the given color.
     */ Gradient.solid = function(color) {
        return new Gradient({
            value: color,
            time: 0.5
        });
    };
    /**
     * Returns a gradient with evenly spaced keys from the given colors.
     */ Gradient.simple = function() {
        var colors = [];
        for(var _i = 0; _i < arguments.length; _i++)colors[_i] = arguments[_i];
        var step = 1 / (colors.length - 1);
        return new (Gradient.bind.apply(Gradient, $754f9caf51355d3a$var$__spreadArray([
            void 0
        ], colors.map(function(color, index) {
            return {
                value: color,
                time: index * step
            };
        }))))();
    };
    return Gradient;
}($dlgtA.Spline);
module.exports.Gradient = $754f9caf51355d3a$var$Gradient;

});
parcelRequire.register("dlgtA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Spline = void 0;

var $3cxgK = parcelRequire("3cxgK");
/**
 * Represents a spline that can be used to continueously evaluate a function
 * between keys. The base implementation is kept generic, so the functionality
 * can easily be implemented for similar constructs, such as gradients.
 */ var $9b6a0461720d36b3$var$Spline = /** @class */ function() {
    /**
     * Creates a new spline instance, using the specified keys.
     * Note that you have to pass at least one key.
     */ function Spline() {
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        if (keys.length === 0) throw new Error("Splines require at least one key.");
        if (Array.isArray(keys[0])) throw new Error("You are trying to pass an array to the spline constructor, which is not supported. Try to spread the array into the constructor instead.");
        this.keys = keys;
    }
    /**
     * Evaluates the spline at the given time.
     */ Spline.prototype.evaluate = function(time) {
        if (this.keys.length === 0) throw new Error("Attempt to evaluate a spline with no keys.");
        if (this.keys.length === 1) // The spline only contains one key, therefore is constant.
        return this.keys[0].value;
        // Sort the keys and figure out the first key above the passed time.
        var ascendingKeys = this.keys.sort(function(a, b) {
            return a.time - b.time;
        });
        var upperKeyIndex = ascendingKeys.findIndex(function(g) {
            return g.time > time;
        });
        // If the found index is either 0 or -1, the specified time falls out
        // of the range of the supplied keys. In that case, the value of the
        // nearest applicant key is returned.
        if (upperKeyIndex === 0) return ascendingKeys[0].value;
        if (upperKeyIndex === -1) return ascendingKeys[ascendingKeys.length - 1].value;
        // Otherwise, find the bounding keys, and extrapolate the time between
        // the two. This is then used to interpolate between the two keys,
        // using the provided implementation.
        var lowerKey = ascendingKeys[upperKeyIndex - 1];
        var upperKey = ascendingKeys[upperKeyIndex];
        var containedTime = $3cxgK.invlerp(lowerKey.time, upperKey.time, time);
        return this.interpolate(lowerKey.value, upperKey.value, containedTime);
    };
    return Spline;
}();
module.exports.Spline = $9b6a0461720d36b3$var$Spline;

});


parcelRequire.register("gwrfZ", function(module, exports) {
"use strict";
var $c074c7254e74824c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumericSpline = void 0;

var $3cxgK = parcelRequire("3cxgK");

var $dlgtA = parcelRequire("dlgtA");
/**
 * Represents a spline that can take numeric values.
 */ var $c074c7254e74824c$var$NumericSpline = /** @class */ function(_super) {
    $c074c7254e74824c$var$__extends(NumericSpline, _super);
    function NumericSpline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Smoothly interpolates between two keys on the spline.
     */ NumericSpline.prototype.interpolate = function(a, b, t) {
        return $3cxgK.slerp(a, b, t);
    };
    return NumericSpline;
}($dlgtA.Spline);
module.exports.NumericSpline = $c074c7254e74824c$var$NumericSpline;

});

parcelRequire.register("kdTzs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Rect = void 0;
/**
 * Represents a rectangle with an origin and size.
 */ var $eb9020c76bb66edc$var$Rect = /** @class */ function() {
    function Rect(x, y, width, height) {
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
     * Returns a new document-space rectangle from the viewport's bounds.
     */ Rect.fromScreen = function() {
        return new Rect(window.scrollX, window.scrollY, window.innerWidth, window.innerHeight);
    };
    /**
     * Returns a new document-space rectangle from the specified element.
     */ Rect.fromElement = function(element) {
        var r = element.getBoundingClientRect();
        return new Rect(window.scrollX + r.x, window.scrollY + r.y, r.width, r.height);
    };
    Rect.zero = new Rect(0, 0);
    return Rect;
}();
module.exports.Rect = $eb9020c76bb66edc$var$Rect;

});

parcelRequire.register("04nSR", function(module, exports) {
"use strict";
var $00d2e6b22a142e23$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Vector = void 0;

var $3cxgK = parcelRequire("3cxgK");
/**
 * Represents a structure used to process vectors.
 *
 * @remarks
 * Note that the operations in this class will **not** modify the original vector,
 * except for the property assignments. This is to ensure that vectors are not
 * unintentionally modified.
 *
 * @example
 * ```ts
 * const vectorA = new Vector(1, 3, 5);
 * const vectorB = new Vector(2, 3, 1);
 * const vectorC = vectorA.add(vectorB); // (3, 6, 6)
 * ```
 */ var $00d2e6b22a142e23$var$Vector = /** @class */ function() {
    /**
     * Creates a new vector with optional x-, y-, and z-components.
     * Omitted components are defaulted to 0.
     */ function Vector(x, y, z) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (z === void 0) z = 0;
        this.values = new Float32Array(3);
        this.xyz = [
            x,
            y,
            z
        ];
    }
    Object.defineProperty(Vector.prototype, "x", {
        /**
         * Returns the x-component of the vector.
         */ get: function() {
            return this.values[0];
        },
        /**
         * Modifies the x-component of the vector.
         */ set: function(value) {
            this.values[0] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "y", {
        /**
         * Returns the y-component of the vector.
         */ get: function() {
            return this.values[1];
        },
        /**
         * Modifies the y-component of the vector.
         */ set: function(value) {
            this.values[1] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "z", {
        /**
         * Returns the z-component of the vector.
         */ get: function() {
            return this.values[2];
        },
        /**
         * Modifies the z-component of the vector.
         */ set: function(value) {
            this.values[2] = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Vector.prototype, "xyz", {
        /**
         * Returns the xyz-components of the vector, bundled as a copied array.
         */ get: function() {
            return [
                this.x,
                this.y,
                this.z
            ];
        },
        /**
         * Simultaneously updates the xyz-components of the vector, by passing an array.
         */ set: function(values) {
            this.values[0] = values[0];
            this.values[1] = values[1];
            this.values[2] = values[2];
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns the length of the vector.
     */ Vector.prototype.magnitude = function() {
        return Math.sqrt(this.sqrMagnitude());
    };
    /**
     * Returns the squared length of the vector.
     */ Vector.prototype.sqrMagnitude = function() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    };
    /**
     * Adds the two vectors together, component-wise.
     */ Vector.prototype.add = function(vector) {
        return new Vector(this.x + vector.x, this.y + vector.y, this.z + vector.z);
    };
    /**
     * Subtracts the right vector from the left one, component-wise.
     */ Vector.prototype.subtract = function(vector) {
        return new Vector(this.x - vector.x, this.y - vector.y, this.z - vector.z);
    };
    /**
     * Scales the lefthand vector by another vector or by a number.
     */ Vector.prototype.scale = function(scalar) {
        if (typeof scalar === "number") return new Vector(this.x * scalar, this.y * scalar, this.z * scalar);
        else return new Vector(this.x * scalar.x, this.y * scalar.y, this.z * scalar.z);
    };
    /**
     * Normalizes the vector to a length of 1. If the length was previously zero,
     * then a zero-length vector will be returned.
     */ Vector.prototype.normalized = function() {
        var magnitude = this.magnitude();
        if (magnitude !== 0) return this.scale(1 / magnitude);
        return new (Vector.bind.apply(Vector, $00d2e6b22a142e23$var$__spreadArray([
            void 0
        ], this.xyz)))();
    };
    /**
     * Returns the angle between two vectors, in degrees.
     */ Vector.prototype.angle = function(vector) {
        return $3cxgK.rad2deg * Math.acos((this.x * vector.x + this.y * vector.y + this.z * vector.z) / (this.magnitude() * vector.magnitude()));
    };
    /**
     * Returns the cross-product of two vectors.
     */ Vector.prototype.cross = function(vector) {
        return new Vector(this.y * vector.z - this.z * vector.y, this.z * vector.x - this.x * vector.z, this.x * vector.y - this.y * vector.x);
    };
    /**
     * returns the dot-product of two vectors.
     */ Vector.prototype.dot = function(vector) {
        return this.magnitude() * vector.magnitude() * Math.cos($3cxgK.deg2rad * this.angle(vector));
    };
    /**
     * Returns a formatted representation of the vector.
     */ Vector.prototype.toString = function() {
        return "Vector(" + this.values.join(", ") + ")";
    };
    /**
     * Creates a new vector from an angle, in degrees. Note that the z-component will be zero.
     */ Vector.from2dAngle = function(angle) {
        return new Vector(Math.cos(angle * $3cxgK.deg2rad), Math.sin(angle * $3cxgK.deg2rad));
    };
    /**
     * Returns (0, 0, 0).
     */ Vector.zero = new Vector(0, 0, 0);
    /**
     * Returns (1, 1, 1).
     */ Vector.one = new Vector(1, 1, 1);
    /**
     * Returns (1, 0, 0).
     */ Vector.right = new Vector(1, 0, 0);
    /**
     * Returns (0, 1, 0).
     */ Vector.up = new Vector(0, 1, 0);
    /**
     * Returns (0, 0, 1).
     */ Vector.forward = new Vector(0, 0, 1);
    return Vector;
}();
module.exports.Vector = $00d2e6b22a142e23$var$Vector;

});



parcelRequire.register("3wB5D", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.despawningRules = void 0;
/**
 * Contains a set of pre-defined particle despawning rules.
 */ module.exports.despawningRules = {
    /**
     * A rule that despawns a particle once its lifetime is over.
     */ lifetime: function(particle) {
        return particle.lifetime <= 0;
    },
    /**
     * A rule that despawns a particle once its y-coordinate is outside of the document.
     */ bounds: function(particle) {
        // Get document height: https://stackoverflow.com/a/44077777/5507624
        var height = document.documentElement.scrollHeight;
        return particle.location.y > height;
    }
};

});

parcelRequire.register("ksOLl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lazy = void 0;
/**
 * A wrapper class to lazily initialize a value.
 * Supports custom factory and predicate methods.
 */ var $ee5dcc94877336be$var$Lazy = /** @class */ function() {
    function Lazy(factory, exists) {
        if (exists === void 0) exists = Lazy.defaultExists;
        this.factory = factory;
        this.exists = exists;
    }
    Object.defineProperty(Lazy.prototype, "current", {
        /**
         * The current value of the lazy object. Will be initialized, if the 'exists'
         * predicate doesn't match.
         */ get: function() {
            if (!this.exists(this.value)) this.value = this.factory();
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Lazy.defaultExists = function(value) {
        return typeof value !== "undefined";
    };
    return Lazy;
}();
module.exports.Lazy = $ee5dcc94877336be$var$Lazy;

});




parcelRequire.register("jkafM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Emitter = void 0;

var $04nSR = parcelRequire("04nSR");

var $gUFIr = parcelRequire("gUFIr");

var $49jCK = parcelRequire("49jCK");

var $89N2W = parcelRequire("89N2W");

var $ixs0B = parcelRequire("ixs0B");

var $i790t = parcelRequire("i790t");
/**
 * Represents an emitter that is responsible for spawning and updating particles.
 *
 * Particles themselves are just data-holders, with the system acting upon them and
 * modifying them. The modifications are done mainly via modules, that use the
 * particle's data together with some function to apply temporal transitions.
 *
 * @see Particle
 * @see ParticleModifierModule
 */ var $e117d6b0f69c4fde$var$Emitter = /** @class */ function() {
    /**
     * Creates a new emitter, using default options.
     */ function Emitter(options) {
        /**
         * The particles currently contained within the system.
         */ this.particles = [];
        this.currentLoop = 0; // The current loop index.
        this.durationTimer = 0; // Measures the current runtime duration, to allow loops to reset.
        this.emissionTimer = 0; // Measures the current emission timer, to allow spawning particles in intervals.
        this.attemptedBurstIndices = []; // The indices of the particle bursts that were attempted this loop.
        this.options = $89N2W.overrideDefaults($ixs0B.getDefaultEmitterOptions(), options === null || options === void 0 ? void 0 : options.emitterOptions);
        this.emission = $89N2W.overrideDefaults($ixs0B.getDefaultEmissionOptions(), options === null || options === void 0 ? void 0 : options.emissionOptions);
        this.renderer = $89N2W.overrideDefaults($ixs0B.getDefaultRendererOptions(), options === null || options === void 0 ? void 0 : options.rendererOptions);
    }
    Object.defineProperty(Emitter.prototype, "isExpired", {
        /**
         * Checks if the emitter is already expired and can be removed.
         * Expired emitters do not emit new particles.
         */ get: function() {
            return this.options.loops >= 0 && this.currentLoop >= this.options.loops;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Emitter.prototype, "canRemove", {
        /**
         * Checks if the emitter can safely be removed.
         * This is true if no more particles are active.
         */ get: function() {
            return this.particles.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clears all particles inside the emitter.
     *
     * @returns The number of cleared particles.
     */ Emitter.prototype.clearParticles = function() {
        return this.particles.splice(0).length;
    };
    /**
     * Processes a tick of the emitter, using the elapsed time.
     *
     * @remarks
     * This handles a few things, namely:
     * - Incrementing the duration timer and potentially incrementing the loop.
     * - Handling particle bursts & emissions.
     * - Despawning particles conditionally.
     *
     * @param delta The time, in seconds, passed since the last tick.
     */ Emitter.prototype.tick = function(delta) {
        if (!this.isExpired) {
            this.durationTimer += delta;
            if (this.durationTimer >= this.options.duration) {
                this.currentLoop++;
                // To start a new loop, the duration timer and attempted bursts are reset.
                this.durationTimer = 0;
                this.attemptedBurstIndices = [];
            }
            // We need to check the expiry again, in case the added loop or duration changed something.
            if (!this.isExpired) {
                // Iterate over the bursts, attempting to execute them if the time is ready.
                var burstIndex = 0;
                for(var _i = 0, _a = this.emission.bursts; _i < _a.length; _i++){
                    var burst = _a[_i];
                    if (burst.time <= this.durationTimer) // Has the burst already been attempted? If not ...
                    {
                        if (!this.attemptedBurstIndices.includes(burstIndex)) {
                            // Perform the burst, emitting a variable amount of particles.
                            var count = $49jCK.evaluateVariation(burst.count);
                            for(var i = 0; i < count; i++)this.emitParticle();
                            // Mark the burst as attempted.
                            this.attemptedBurstIndices.push(burstIndex);
                        }
                    }
                    burstIndex++;
                }
                // Handle the 'emission over time'. By using a while-loop instead of a simple
                // if-condition, we take high deltas into account, and ensure that the correct
                // number of particles will consistently be emitted.
                this.emissionTimer += delta;
                var delay = 1 / this.emission.rate;
                while(this.emissionTimer > delay){
                    this.emissionTimer -= delay;
                    this.emitParticle();
                }
            }
        }
        var _loop_1 = function(i) {
            var particle = this_1.particles[i];
            this_1.tickParticle(particle, delta);
            // Particles should be despawned (i.e. removed from the collection) if any of
            // the despawning rules apply to them.
            if (this_1.options.despawningRules.some(function(rule) {
                return rule(particle);
            })) this_1.particles.splice(i, 1);
        };
        var this_1 = this;
        for(var i = this.particles.length - 1; i >= 0; i--)_loop_1(i);
    };
    /**
     * Performs an internal tick for the particle.
     *
     * @remarks
     * This method controls the particle's lifetime, location and velocity, according
     * to the elapsed delta and the configuration. Additionally, each of the emitter's
     * modules is applied to the particle.
     *
     * @param particle The particle to apply the tick for.
     * @param delta The time, in seconds, passed since the last tick.
     */ Emitter.prototype.tickParticle = function(particle, delta) {
        particle.lifetime -= delta;
        if (this.options.useGravity) // Apply gravitational acceleration to the particle.
        particle.velocity = particle.velocity.add($04nSR.Vector.up.scale($gUFIr.settings.gravity * delta));
        // Apply the particle's velocity to its location.
        particle.location = particle.location.add(particle.velocity.scale(delta));
        // Apply the modules to the particle.
        for(var _i = 0, _a = this.options.modules; _i < _a.length; _i++){
            var moduleFunction = _a[_i];
            moduleFunction(particle);
        }
    };
    /**
     * Emits a particle using the registered settings.
     * Also may despawn a particle if the maximum number of particles is exceeded.
     */ Emitter.prototype.emitParticle = function() {
        var particle = new $i790t.Particle({
            location: this.emission.sourceSampler(),
            lifetime: $49jCK.evaluateVariation(this.emission.initialLifetime),
            velocity: $04nSR.Vector.from2dAngle($49jCK.evaluateVariation(this.emission.angle)).scale($49jCK.evaluateVariation(this.emission.initialSpeed)),
            size: $49jCK.evaluateVariation(this.emission.initialSize),
            rotation: $49jCK.evaluateVariation(this.emission.initialRotation),
            color: $49jCK.evaluateVariation(this.emission.initialColor)
        });
        this.particles.push(particle);
        // Ensure that no more particles than 'maxParticles' can exist.
        if (this.particles.length > this.options.maxParticles) this.particles.shift();
        return particle;
    };
    return Emitter;
}();
module.exports.Emitter = $e117d6b0f69c4fde$var$Emitter;

});
parcelRequire.register("49jCK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gradientSample = module.exports.splineSample = module.exports.skewRelative = module.exports.skew = module.exports.range = module.exports.evaluateVariation = void 0;

var $4uhq2 = parcelRequire("4uhq2");
/**
 * Returns a value instance of a variation.
 */ function $3057399a5a537aee$var$evaluateVariation(variation) {
    if (Array.isArray(variation)) return $4uhq2.pick(variation);
    if (typeof variation === "function") return variation();
    return variation;
}
module.exports.evaluateVariation = $3057399a5a537aee$var$evaluateVariation;
/**
 * Creates a variation function that returns a random number from min to max.
 */ function $3057399a5a537aee$var$range(min, max) {
    return function() {
        return $4uhq2.randomRange(min, max);
    };
}
module.exports.range = $3057399a5a537aee$var$range;
/**
 * Creates a variation function that skews the specified value by a specified, absolute
 * amount. This means that instead of the value itself, a random number that deviates
 * at most by the specified amount is returned.
 *
 * @remarks
 * If you want to skew by a percentage instead, use `skewRelative`.
 */ function $3057399a5a537aee$var$skew(value, amount) {
    return function() {
        return value + $4uhq2.randomRange(-amount, amount);
    };
}
module.exports.skew = $3057399a5a537aee$var$skew;
/**
 * Creates a variation function that skews the specified value by a specified percentage.
 * This means that instead of the value itself, a random number that deviates by a maximum
 * of the specified percentage is returned.
 */ function $3057399a5a537aee$var$skewRelative(value, percentage) {
    return function() {
        return value * (1 + $4uhq2.randomRange(-percentage, percentage));
    };
}
module.exports.skewRelative = $3057399a5a537aee$var$skewRelative;
/**
 * Creates a variation function that returns a random sample from the given spline.
 *
 * @param spline The spline to sample from.
 */ function $3057399a5a537aee$var$splineSample(spline) {
    return function() {
        return spline.evaluate(Math.random());
    };
}
module.exports.splineSample = $3057399a5a537aee$var$splineSample;
/**
 * Creates a variation function that returns a random sample from the given gradient.
 *
 * @remarks
 * This function is an alias for the spline variation, since a gradient is just
 * a spline under the hood.
 *
 * @param gradient The gradient to sample from.
 */ function $3057399a5a537aee$var$gradientSample(gradient) {
    return $3057399a5a537aee$var$splineSample(gradient);
}
module.exports.gradientSample = $3057399a5a537aee$var$gradientSample;

});
parcelRequire.register("4uhq2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomInsideCircle = module.exports.randomInsideRect = module.exports.randomUnitVector = module.exports.pick = module.exports.randomRange = void 0;

var $dyj7k = parcelRequire("dyj7k");

var $3cxgK = parcelRequire("3cxgK");
/**
 * Returns a random value from min to max.
 */ function $344779d57f4c92b1$var$randomRange(min, max) {
    if (min === void 0) min = 0;
    if (max === void 0) max = 1;
    return $3cxgK.lerp(min, max, Math.random());
}
module.exports.randomRange = $344779d57f4c92b1$var$randomRange;
/**
 * Picks a random element from the specified array. Returns undefined if the array is empty.
 */ function $344779d57f4c92b1$var$pick(arr) {
    return arr.length === 0 ? undefined : arr[Math.floor(Math.random() * arr.length)];
}
module.exports.pick = $344779d57f4c92b1$var$pick;
/**
 * Returns a random unit vector.
 */ function $344779d57f4c92b1$var$randomUnitVector() {
    var theta = $344779d57f4c92b1$var$randomRange(0, 2 * Math.PI);
    var z = $344779d57f4c92b1$var$randomRange(-1, 1);
    return new $dyj7k.Vector(Math.sqrt(1 - z * z) * Math.cos(theta), Math.sqrt(1 - z * z) * Math.sin(theta), z);
}
module.exports.randomUnitVector = $344779d57f4c92b1$var$randomUnitVector;
/**
 * Returns a random point inside the given rect.
 */ function $344779d57f4c92b1$var$randomInsideRect(rect) {
    return new $dyj7k.Vector(rect.x + $344779d57f4c92b1$var$randomRange(0, rect.width), rect.y + $344779d57f4c92b1$var$randomRange(0, rect.height));
}
module.exports.randomInsideRect = $344779d57f4c92b1$var$randomInsideRect;
function $344779d57f4c92b1$var$randomInsideCircle(circle) {
    var theta = $344779d57f4c92b1$var$randomRange(0, 2 * Math.PI);
    var radius = $344779d57f4c92b1$var$randomRange(0, circle.radius);
    return new $dyj7k.Vector(circle.x + Math.cos(theta) * radius, circle.y + Math.sin(theta) * radius);
}
module.exports.randomInsideCircle = $344779d57f4c92b1$var$randomInsideCircle;

});


parcelRequire.register("ixs0B", function(module, exports) {
"use strict";
var $d7f109034929a006$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d7f109034929a006$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d7f109034929a006$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$d7f109034929a006$var$__exportStar((parcelRequire("lAMUS")), module.exports);

$d7f109034929a006$var$__exportStar((parcelRequire("6Bduj")), module.exports);

$d7f109034929a006$var$__exportStar((parcelRequire("euKW8")), module.exports);

});
parcelRequire.register("lAMUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultEmitterOptions = void 0;

var $3wB5D = parcelRequire("3wB5D");
/**
 * Returns the default set of emitter options.
 */ function $fb82e78d4fdfa2c2$var$getDefaultEmitterOptions() {
    return {
        duration: 5,
        loops: 1,
        useGravity: true,
        maxParticles: 300,
        despawningRules: [
            $3wB5D.despawningRules.lifetime,
            $3wB5D.despawningRules.bounds
        ],
        modules: []
    };
}
module.exports.getDefaultEmitterOptions = $fb82e78d4fdfa2c2$var$getDefaultEmitterOptions;

});

parcelRequire.register("6Bduj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultEmissionOptions = void 0;

var $dyj7k = parcelRequire("dyj7k");

var $4Tf2i = parcelRequire("4Tf2i");
/**
 * Returns the default set of emission options.
 */ function $4ce0a933e3f38747$var$getDefaultEmissionOptions() {
    return {
        rate: 10,
        angle: 0,
        bursts: [],
        sourceSampler: $4Tf2i.rectSource($dyj7k.Rect.zero),
        initialLifetime: 5,
        initialSpeed: 5,
        initialSize: 1,
        initialRotation: $dyj7k.Vector.zero,
        initialColor: $dyj7k.Color.white
    };
}
module.exports.getDefaultEmissionOptions = $4ce0a933e3f38747$var$getDefaultEmissionOptions;

});
parcelRequire.register("4Tf2i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circleSource = module.exports.rectSource = module.exports.mouseSource = module.exports.elementSource = module.exports.dynamicSource = void 0;

var $dyj7k = parcelRequire("dyj7k");

var $4uhq2 = parcelRequire("4uhq2");
/**
 * Dynamically infers a source sampler for the specified source type.
 */ function $38f7f64f125c781b$var$dynamicSource(source) {
    if (source instanceof HTMLElement) return $38f7f64f125c781b$var$elementSource(source);
    if (source instanceof $dyj7k.Circle) return $38f7f64f125c781b$var$circleSource(source);
    if (source instanceof $dyj7k.Rect) return $38f7f64f125c781b$var$rectSource(source);
    if (source instanceof MouseEvent) return $38f7f64f125c781b$var$mouseSource(source);
    throw new Error("Cannot infer the source type of '" + source + "'.");
}
module.exports.dynamicSource = $38f7f64f125c781b$var$dynamicSource;
/**
 * Creates a sampler to retrieve random points inside a specified HTMLElement.
 */ function $38f7f64f125c781b$var$elementSource(source) {
    return function() {
        return $4uhq2.randomInsideRect($dyj7k.Rect.fromElement(source));
    };
}
module.exports.elementSource = $38f7f64f125c781b$var$elementSource;
/**
 * Creates a sampler to retrieve the position of a mouse event.
 */ function $38f7f64f125c781b$var$mouseSource(source) {
    return function() {
        return new $dyj7k.Vector(window.scrollX + source.clientX, window.scrollY + source.clientY);
    };
}
module.exports.mouseSource = $38f7f64f125c781b$var$mouseSource;
/**
 * Creates a sampler to retrieve random points inside a specified rectangle.
 */ function $38f7f64f125c781b$var$rectSource(source) {
    return function() {
        return $4uhq2.randomInsideRect(source);
    };
}
module.exports.rectSource = $38f7f64f125c781b$var$rectSource;
/**
 * Creates a sampler to retrieve random points inside a specified circle.
 */ function $38f7f64f125c781b$var$circleSource(source) {
    return function() {
        return $4uhq2.randomInsideCircle(source);
    };
}
module.exports.circleSource = $38f7f64f125c781b$var$circleSource;

});


parcelRequire.register("euKW8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultRendererOptions = void 0;
/**
 * Returns the default set of renderer options.
 */ function $a8d846ab78ad5dae$var$getDefaultRendererOptions() {
    return {
        shapeFactory: "square",
        applyColor: $a8d846ab78ad5dae$var$defaultApplyColor,
        applyOpacity: $a8d846ab78ad5dae$var$defaultApplyOpacity,
        applyLighting: $a8d846ab78ad5dae$var$defaultApplyLighting,
        applyTransform: $a8d846ab78ad5dae$var$defaultApplyTransform
    };
}
module.exports.getDefaultRendererOptions = $a8d846ab78ad5dae$var$getDefaultRendererOptions;
/**
 * Applies the specified color to the element.
 *
 * @remarks
 * This function is aware of the element's node type:
 * - `div` elements have their `background` set.
 * - `svg` elements have their `fill` and `color` set.
 * - Other elements have their `color` set.
 */ function $a8d846ab78ad5dae$var$defaultApplyColor(color, element) {
    var hex = color.toHex();
    // Note that by default, HTML node names are uppercase.
    switch(element.nodeName.toLowerCase()){
        case "div":
            element.style.background = hex;
            break;
        case "svg":
            element.style.fill = element.style.color = hex;
            break;
        default:
            element.style.color = hex;
            break;
    }
}
/**
 * Applies the specified opacity to the element.
 */ function $a8d846ab78ad5dae$var$defaultApplyOpacity(opacity, element) {
    element.style.opacity = opacity.toString();
}
/**
 * Applies the specified lighting to the element as a brightness filter.
 *
 * @remarks
 * This function assumes an ambient light with intensity 0.5, and that the
 * particle should be lit from both sides. The brightness filter can exceed 1,
 * to give the particles a "glossy" feel.
 */ function $a8d846ab78ad5dae$var$defaultApplyLighting(lighting, element) {
    element.style.filter = "brightness(" + (0.5 + Math.abs(lighting)) + ")";
}
/**
 * Applies the specified transform to the element as a 3D CSS transform.
 * Also takes into account the current window scroll, to make sure that particles are
 * rendered inside of the fixed container.
 */ function $a8d846ab78ad5dae$var$defaultApplyTransform(particle, element) {
    element.style.transform = // Make sure to take window scrolling into account.
    "translateX(" + (particle.location.x - window.scrollX).toFixed(3) + "px) " + ("translateY(" + (particle.location.y - window.scrollY).toFixed(3) + "px) ") + ("translateZ(" + particle.location.z.toFixed(3) + "px) ") + ("rotateX(" + particle.rotation.x.toFixed(3) + "deg) ") + ("rotateY(" + particle.rotation.y.toFixed(3) + "deg) ") + ("rotateZ(" + particle.rotation.z.toFixed(3) + "deg) ") + ("scale(" + particle.size.toFixed(3) + ")");
}

});


parcelRequire.register("i790t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Particle = void 0;

var $dyj7k = parcelRequire("dyj7k");

var $89N2W = parcelRequire("89N2W");
/**
 * Represents an emitted particle.
 */ var $d2ffddfce5126899$var$Particle = /** @class */ function() {
    /**
     * Creates a new particle instance through the specified options.
     */ function Particle(options) {
        var populatedOptions = $89N2W.overrideDefaults({
            lifetime: 0,
            size: 1,
            location: $dyj7k.Vector.zero,
            rotation: $dyj7k.Vector.zero,
            velocity: $dyj7k.Vector.zero,
            color: $dyj7k.Color.white,
            opacity: 1
        }, options);
        // Generate a symbolic ID.
        this.id = Symbol();
        // Assign various properties, together with some initials for later reference.
        this.size = this.initialSize = populatedOptions.size;
        this.lifetime = this.initialLifetime = populatedOptions.lifetime;
        this.rotation = this.initialRotation = populatedOptions.rotation;
        this.location = populatedOptions.location;
        this.velocity = populatedOptions.velocity;
        this.color = populatedOptions.color;
        this.opacity = populatedOptions.opacity;
    }
    return Particle;
}();
module.exports.Particle = $d2ffddfce5126899$var$Particle;

});


parcelRequire.register("4fYY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Renderer = void 0;

var $3bV2r = parcelRequire("3bV2r");

var $04nSR = parcelRequire("04nSR");

var $1C76P = parcelRequire("1C76P");

var $9B07f = parcelRequire("9B07f");

var $jIw4J = parcelRequire("jIw4J");
/**
 * Represents a renderer used to draw particles to the DOM via HTML
 * elements. Additionally, it is responsible for purging the elements
 * of destroyed particles from the DOM.
 */ var $3197dafda330280e$var$Renderer = /** @class */ function() {
    function Renderer() {
        /**
         * The lookup of elements currently handled by the renderer, with the
         * particle ID as key and a HTMLElement as the value.
         */ this.elements = new Map();
        /**
         * The normalized direction the light comes from.
         */ this.light = new $04nSR.Vector(0, 0, 1);
        /**
         * Whether or not the renderer should actually draw particles.
         */ this.enabled = true;
        // Respect that users might prefer reduced motion.
        // See: https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
        this.enabled = !$3bV2r.settings.respectReducedMotion || !window.matchMedia("(prefers-reduced-motion)").matches;
    }
    /**
     * Begins a new render block. During the rendering phase, a list of rendered particles
     * is tracked, so that stale particles can be removed later.
     */ Renderer.prototype.begin = function() {
        this.renderedParticles = [];
    };
    /**
     * Terminates an existing render block. This checks which particles were rendered
     * during the block and purges all unused HTMLElements from the DOM.
     *
     * @returns The amount of particles that were rendered.
     */ Renderer.prototype.end = function() {
        var it = this.elements.keys();
        var result = it.next();
        while(!result.done){
            var id = result.value;
            if (!this.renderedParticles.includes(id)) {
                this.elements.get(id).remove();
                this.elements.delete(id);
            }
            result = it.next();
        }
        return this.renderedParticles.length;
    };
    /**
     * Renders an individual particle to the DOM. If the particle is rendered for the first
     * time, a HTMLElement will be created using the emitter's render settings.
     *
     * @param particle The particle to be rendered.
     * @param emitter The system containing the particle.
     */ Renderer.prototype.renderParticle = function(particle, emitter) {
        if (!this.enabled) return;
        var options = emitter.renderer;
        // Ensure that an element for the particle exists.
        var element = this.elements.has(particle.id) ? this.elements.get(particle.id) : this.createParticleElement(particle, options);
        if (options.applyColor) // If the options offer a coloring method, apply it.
        options.applyColor(particle.color, element);
        if (options.applyOpacity) // If the options offer an opacity modifying method, apply it.
        options.applyOpacity(particle.opacity, element);
        if (options.applyLighting) {
            // If the options offer a lighting method, apply it.
            // Lighting is calculated as a combination of the particle's normal
            // direction and the lighting direction.
            var normal = $jIw4J.rotationToNormal(particle.rotation);
            var lightingCoefficient = normal.dot(this.light);
            options.applyLighting(lightingCoefficient, element);
        }
        if (options.applyTransform) // If the options offer a transformation method, apply it.
        // This ensures the particle is rendered at the correct position with the correct rotation.
        options.applyTransform(particle, element);
        // Mark the particle as rendered.
        this.renderedParticles.push(particle.id);
    };
    /**
     * Creates the HTMLElement for a particle that does not have one already.
     */ Renderer.prototype.createParticleElement = function(particle, options) {
        // Resolve the element returned from the factory.
        var resolved = $9B07f.resolveShapeFactory(options.shapeFactory);
        // Clone the node to ensure we do not break existing elements.
        var element = resolved.cloneNode(true);
        // Ensure that the elements can be "stacked" ontop of eachother.
        element.style.position = "absolute";
        // Register the new element in the map, while appending the new element to the DOM.
        this.elements.set(particle.id, $1C76P.particleContainer.current.appendChild(element));
        return element;
    };
    return Renderer;
}();
module.exports.Renderer = $3197dafda330280e$var$Renderer;

});
parcelRequire.register("9B07f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveShapeFactory = module.exports.resolvableShapes = void 0;

var $49jCK = parcelRequire("49jCK");
/**
 * Represents the lookup that maps resolveable element keys to their HTML strings.
 *
 * @remarks
 * The default shapes are made to fit inside a dimension of 10x10 pixels, except
 * the 'star' shape, which exceeds it slightly.
 */ module.exports.resolvableShapes = {
    square: '<div style="height: 10px; width: 10px;"></div>',
    rectangle: '<div style="height: 6px; width: 10px;"></div>',
    circle: '<svg viewBox="0 0 2 2" width="10" height="10"><circle cx="1" cy="1" r="1" fill="currentColor"/></svg>',
    roundedSquare: '<div style="height: 10px; width: 10px; border-radius: 3px;"></div>',
    roundedRectangle: '<div style="height: 6px; width: 10px; border-radius: 3px;"></div>',
    star: '<svg viewBox="0 0 512 512" width="15" height="15"><polygon fill="currentColor" points="512,197.816 325.961,185.585 255.898,9.569 185.835,185.585 0,197.816 142.534,318.842 95.762,502.431 255.898,401.21 416.035,502.431 369.263,318.842"/></svg>'
};
/**
 * Resolves the specified element factory using the resolvable elements, if needed.
 */ function $6fc7a8cb00413efb$var$resolveShapeFactory(factory) {
    // Retrieve the unresolved element from the factory.
    var shape = $49jCK.evaluateVariation(factory);
    // If a string is returned, we need to resolve the element. This means
    // looking up the string in the resolver lookup. If the key was not
    // resolvable, we throw an error.
    if (typeof shape === "string") {
        var resolved = module.exports.resolvableShapes[shape];
        if (!resolved) throw new Error("Failed to resolve shape key '" + shape + "'. Did you forget to add it to the 'resolvableShapes' lookup?");
        // We're in luck, we can resolve the element! We create a dummy <div> element
        // to set the innerHTML of, and return the first element child.
        var dummy = document.createElement("div");
        dummy.innerHTML = resolved;
        return dummy.firstElementChild;
    }
    return shape;
}
module.exports.resolveShapeFactory = $6fc7a8cb00413efb$var$resolveShapeFactory;

});



parcelRequire.register("emA6W", function(module, exports) {
"use strict";
var $a74f21a1efde8095$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a74f21a1efde8095$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a74f21a1efde8095$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a74f21a1efde8095$var$__exportStar((parcelRequire("7b3At")), module.exports);

$a74f21a1efde8095$var$__exportStar((parcelRequire("aCNlB")), module.exports);

});
parcelRequire.register("7b3At", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.confetti = void 0;

var $3bV2r = parcelRequire("3bV2r");

var $dyj7k = parcelRequire("dyj7k");

var $lcCa9 = parcelRequire("lcCa9");

var $4uhq2 = parcelRequire("4uhq2");

var $4Tf2i = parcelRequire("4Tf2i");

var $49jCK = parcelRequire("49jCK");

var $jIw4J = parcelRequire("jIw4J");
/**
 * The standard confetti template.
 *
 * @param source The source to emit the confetti from.
 * @param options The (optional) configuration overrides.
 */ function $539c57da982dceb7$var$confetti(source, options) {
    var populated = $jIw4J.overrideDefaults({
        count: $49jCK.range(20, 40),
        spread: $49jCK.range(35, 45),
        speed: $49jCK.range(300, 600),
        size: $49jCK.skew(1, 0.2),
        rotation: function() {
            return $4uhq2.randomUnitVector().scale(180);
        },
        color: function() {
            return $dyj7k.Color.fromHsl($4uhq2.randomRange(0, 360), 100, 70);
        },
        modules: [
            new $lcCa9.ModuleBuilder().drive("size").by(function(t) {
                return Math.min(1, t * 3);
            }).relative().build(),
            new $lcCa9.ModuleBuilder().drive("rotation").by(function(t) {
                return new $dyj7k.Vector(140, 200, 260).scale(t);
            }).relative().build()
        ],
        shapes: [
            "square",
            "circle"
        ]
    }, options);
    var emitter = $3bV2r.scene.current.createEmitter({
        emitterOptions: {
            loops: 1,
            duration: 8,
            modules: populated.modules
        },
        emissionOptions: {
            rate: 0,
            bursts: [
                {
                    time: 0,
                    count: populated.count
                }
            ],
            sourceSampler: $4Tf2i.dynamicSource(source),
            angle: $49jCK.skew(-90, $49jCK.evaluateVariation(populated.spread)),
            initialLifetime: 8,
            initialSpeed: populated.speed,
            initialSize: populated.size,
            initialRotation: populated.rotation,
            initialColor: populated.color
        },
        rendererOptions: {
            shapeFactory: populated.shapes
        }
    });
    return emitter;
}
module.exports.confetti = $539c57da982dceb7$var$confetti;

});
parcelRequire.register("lcCa9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ModuleBuilder = void 0;

var $dyj7k = parcelRequire("dyj7k");
/**
 * Represents a builder for particle modules. Returns an evaluatable module
 * function, that can be consumed by emitters.
 *
 * @remarks
 * Not all properties can be driven. TypeScript will validate this at compile time,
 * but no internal validation is performed due to performance reasons. Also, note
 * that the driving factor is "lifetime" by default.
 *
 * @example
 * ```ts
 * new ModuleBuilder()
 *     .drive("size")
 *     .by((t) => t * 2)
 *     .through("lifetime")
 *     .build();
 * ```
 */ var $f6f8524e73d590a0$var$ModuleBuilder = /** @class */ function() {
    function ModuleBuilder() {
        /**
         * The factor driving the built function.
         *
         * @defaultValue "lifetime"
         */ this.factor = "lifetime";
        this.isRelative = false;
    }
    /**
     * Specifies the key in the particle that should be driven.
     *
     * @remarks
     * Note that not all of a particle's properties are drivable through modules. If you
     * need full control of a particle inside of a module, you can use a module function directly.
     *
     * @returns The chained builder instance.
     */ ModuleBuilder.prototype.drive = function(key) {
        this.driverKey = key;
        return this;
    };
    /**
     * Specifies the factor to drive the evaluated value by. Supports "lifetime" and "size".
     *
     * @returns The chained builder instance.
     */ ModuleBuilder.prototype.through = function(factor) {
        this.factor = factor;
        return this;
    };
    /**
     * Specifies the value to drive the module behaviour by. This can be a constant,
     * a spline or an evaluable function. Note that in the last case, the driving
     * factor is passed as a parameter.
     *
     * @returns The chained builder instance.
     */ ModuleBuilder.prototype.by = function(driver) {
        this.driverValue = driver;
        return this;
    };
    /**
     * Specifies that the module function is supposed to act relative to the
     * properties initial value.
     *
     * @remarks
     * Note that this is only possible if an "initial*" property exists on the
     * particle object. The operation applied to the initial and new value
     * is dependant on their type:
     * - `Vector`: Both vectors are added.
     * - `number`: Both numbers are multiplied.
     *
     * For more advanced relative customizations, consider using the particle
     * object in the driver value function instead, like:
     * ```ts
     * .by((t, p) => p.initialSize + t * 2);
     * ```
     */ ModuleBuilder.prototype.relative = function(isRelative) {
        if (isRelative === void 0) isRelative = true;
        this.isRelative = isRelative;
        return this;
    };
    /**
     * Consumes the builder and returns an evaluatable module function.
     *
     * @remarks
     * Note that you need to specify the driving key and value, otherwise an error
     * will be thrown.
     */ ModuleBuilder.prototype.build = function() {
        var _this = this;
        if (typeof this.driverKey === "undefined") throw new Error("No driving key was provided in the module builder. Did you forget a '.drive()' call?");
        if (typeof this.driverValue === "undefined") throw new Error("No driving value was provided in the module builder. Did you forget a '.through()' call?");
        return function(particle) {
            $f6f8524e73d590a0$var$updateDrivenProperty(particle, _this.driverKey, $f6f8524e73d590a0$var$evaluateModuleDriver(_this.driverValue, $f6f8524e73d590a0$var$calculateModuleFactor(_this.factor, particle), particle), _this.isRelative);
        };
    };
    return ModuleBuilder;
}();
module.exports.ModuleBuilder = $f6f8524e73d590a0$var$ModuleBuilder;
/**
 * Evaluates the module driver using a specified factor.
 */ function $f6f8524e73d590a0$var$evaluateModuleDriver(driver, factor, particle) {
    if (typeof driver === "object" && "evaluate" in driver) return driver.evaluate(factor);
    if (typeof driver === "function") return driver(factor, particle);
    return driver;
}
/**
 * Calculates a module factor using a specified particle as context.
 */ function $f6f8524e73d590a0$var$calculateModuleFactor(factor, particle) {
    switch(factor){
        case "lifetime":
            return particle.initialLifetime - particle.lifetime;
        case "relativeLifetime":
            return (particle.initialLifetime - particle.lifetime) / particle.initialLifetime;
        case "size":
            return particle.size;
        default:
            throw new Error("Invalid driving factor '" + factor + "'.");
    }
}
/**
 * Updates a driven property of a particle using the specified value.
 *
 * @remarks
 * If the operation is marked as relative, the function infers the new value
 * through the value's type. Note that relative properties must have a
 * corresponding "initial*" value in the particle's properties.
 */ function $f6f8524e73d590a0$var$updateDrivenProperty(particle, key, value, relative) {
    if (relative === void 0) relative = false;
    if (!relative) particle[key] = value;
    else {
        var initial = particle["initial" + key[0].toUpperCase() + key.substr(1)];
        if (typeof initial === "undefined") throw new Error("Unable to use relative chaining with key '" + key + "'; no initial value exists.");
        if (value instanceof $dyj7k.Vector) $f6f8524e73d590a0$var$updateDrivenProperty(particle, key, initial.add(value));
        else if (typeof value === "number") $f6f8524e73d590a0$var$updateDrivenProperty(particle, key, initial * value);
        else throw new Error("Unable to use relative chaining with particle key '" + key + "'; no relative operation for '" + value + "' could be inferred.");
    }
}

});


parcelRequire.register("aCNlB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sparkles = void 0;

var $3bV2r = parcelRequire("3bV2r");

var $dyj7k = parcelRequire("dyj7k");

var $lcCa9 = parcelRequire("lcCa9");

var $4uhq2 = parcelRequire("4uhq2");

var $4Tf2i = parcelRequire("4Tf2i");

var $49jCK = parcelRequire("49jCK");

var $jIw4J = parcelRequire("jIw4J");
/**
 * The standard sparkles template.
 *
 * @param source The source to emit the sparkles from.
 * @param options The (optional) configuration overrides.
 */ function $7bc3bb61c2d3a44d$var$sparkles(source, options) {
    var populated = $jIw4J.overrideDefaults({
        lifetime: $49jCK.range(1, 2),
        count: $49jCK.range(10, 20),
        speed: $49jCK.range(100, 200),
        size: $49jCK.range(0.8, 1.8),
        rotation: function() {
            return new $dyj7k.Vector(0, 0, $4uhq2.randomRange(0, 360));
        },
        color: function() {
            return $dyj7k.Color.fromHsl(50, 100, $4uhq2.randomRange(55, 85));
        },
        modules: [
            new $lcCa9.ModuleBuilder().drive("rotation").by(function(t) {
                return new $dyj7k.Vector(0, 0, 200).scale(t);
            }).relative().build(),
            new $lcCa9.ModuleBuilder().drive("size").by(new $dyj7k.NumericSpline({
                time: 0,
                value: 0
            }, {
                time: 0.3,
                value: 1
            }, {
                time: 0.7,
                value: 1
            }, {
                time: 1,
                value: 0
            })).through("relativeLifetime").relative().build(),
            new $lcCa9.ModuleBuilder().drive("opacity").by(new $dyj7k.NumericSpline({
                time: 0,
                value: 1
            }, {
                time: 0.5,
                value: 1
            }, {
                time: 1,
                value: 0
            })).through("relativeLifetime").build()
        ],
        shapes: "star"
    }, options);
    var emitter = $3bV2r.scene.current.createEmitter({
        emitterOptions: {
            loops: 1,
            duration: 3,
            useGravity: false,
            modules: populated.modules
        },
        emissionOptions: {
            rate: 0,
            bursts: [
                {
                    time: 0,
                    count: populated.count
                }
            ],
            sourceSampler: $4Tf2i.dynamicSource(source),
            angle: $49jCK.range(0, 360),
            initialLifetime: populated.lifetime,
            initialSpeed: populated.speed,
            initialSize: populated.size,
            initialRotation: populated.rotation,
            initialColor: populated.color
        },
        rendererOptions: {
            applyLighting: undefined,
            shapeFactory: populated.shapes
        }
    });
    return emitter;
}
module.exports.sparkles = $7bc3bb61c2d3a44d$var$sparkles;

});



parcelRequire.register("bA65C", function(module, exports) {
typeof navigator !== "undefined" && function(global11, factory11) {
    module.exports = factory11();
}(this, function() {
    "use strict";
    var svgNS = "http://www.w3.org/2000/svg";
    var locationHref = "";
    var _useWebWorker = false;
    var initialDefaultFrame = -999999;
    var setWebWorker = function setWebWorker11(flag11) {
        _useWebWorker = !!flag11;
    };
    var getWebWorker = function getWebWorker11() {
        return _useWebWorker;
    };
    var setLocationHref = function setLocationHref11(value31) {
        locationHref = value31;
    };
    var getLocationHref = function getLocationHref11() {
        return locationHref;
    };
    function createTag(type11) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElement(type11);
    }
    function extendPrototype(sources11, destination11) {
        var i31;
        var len11 = sources11.length;
        var sourcePrototype11;
        for(i31 = 0; i31 < len11; i31 += 1){
            sourcePrototype11 = sources11[i31].prototype;
            for(var attr31 in sourcePrototype11)if (Object.prototype.hasOwnProperty.call(sourcePrototype11, attr31)) destination11.prototype[attr31] = sourcePrototype11[attr31];
        }
    }
    function getDescriptor(object11, prop11) {
        return Object.getOwnPropertyDescriptor(object11, prop11);
    }
    function createProxyFunction(prototype11) {
        function ProxyFunction11() {}
        ProxyFunction11.prototype = prototype11;
        return ProxyFunction11;
    }
    // import Howl from '../../3rd_party/howler';
    var audioControllerFactory = function() {
        function AudioController11(audioFactory11) {
            this.audios = [];
            this.audioFactory = audioFactory11;
            this._volume = 1;
            this._isMuted = false;
        }
        AudioController11.prototype = {
            addAudio: function addAudio11(audio11) {
                this.audios.push(audio11);
            },
            pause: function pause11() {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].pause();
            },
            resume: function resume11() {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].resume();
            },
            setRate: function setRate11(rateValue11) {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].setRate(rateValue11);
            },
            createAudio: function createAudio11(assetPath11) {
                if (this.audioFactory) return this.audioFactory(assetPath11);
                if (window.Howl) return new window.Howl({
                    src: [
                        assetPath11
                    ]
                });
                return {
                    isPlaying: false,
                    play: function play11() {
                        this.isPlaying = true;
                    },
                    seek: function seek11() {
                        this.isPlaying = false;
                    },
                    playing: function playing11() {},
                    rate: function rate11() {},
                    setVolume: function setVolume11() {}
                };
            },
            setAudioFactory: function setAudioFactory11(audioFactory11) {
                this.audioFactory = audioFactory11;
            },
            setVolume: function setVolume11(value31) {
                this._volume = value31;
                this._updateVolume();
            },
            mute: function mute11() {
                this._isMuted = true;
                this._updateVolume();
            },
            unmute: function unmute11() {
                this._isMuted = false;
                this._updateVolume();
            },
            getVolume: function getVolume11() {
                return this._volume;
            },
            _updateVolume: function _updateVolume11() {
                var i31;
                var len11 = this.audios.length;
                for(i31 = 0; i31 < len11; i31 += 1)this.audios[i31].volume(this._volume * (this._isMuted ? 0 : 1));
            }
        };
        return function() {
            return new AudioController11();
        };
    }();
    var createTypedArray = function() {
        function createRegularArray11(type11, len11) {
            var i31 = 0;
            var arr31 = [];
            var value31;
            switch(type11){
                case "int16":
                case "uint8c":
                    value31 = 1;
                    break;
                default:
                    value31 = 1.1;
                    break;
            }
            for(i31 = 0; i31 < len11; i31 += 1)arr31.push(value31);
            return arr31;
        }
        function createTypedArrayFactory11(type11, len11) {
            if (type11 === "float32") return new Float32Array(len11);
            if (type11 === "int16") return new Int16Array(len11);
            if (type11 === "uint8c") return new Uint8ClampedArray(len11);
            return createRegularArray11(type11, len11);
        }
        if (typeof Uint8ClampedArray === "function" && typeof Float32Array === "function") return createTypedArrayFactory11;
        return createRegularArray11;
    }();
    function createSizedArray(len11) {
        return Array.apply(null, {
            length: len11
        });
    }
    function _typeof$6(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$6 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$6 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$6(obj11);
    }
    var subframeEnabled = true;
    var expressionsPlugin = null;
    var expressionsInterfaces = null;
    var idPrefix$1 = "";
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    var _shouldRoundValues = false;
    var bmPow = Math.pow;
    var bmSqrt = Math.sqrt;
    var bmFloor = Math.floor;
    var bmMax = Math.max;
    var bmMin = Math.min;
    var BMMath = {};
    (function() {
        var propertyNames11 = [
            "abs",
            "acos",
            "acosh",
            "asin",
            "asinh",
            "atan",
            "atanh",
            "atan2",
            "ceil",
            "cbrt",
            "expm1",
            "clz32",
            "cos",
            "cosh",
            "exp",
            "floor",
            "fround",
            "hypot",
            "imul",
            "log",
            "log1p",
            "log2",
            "log10",
            "max",
            "min",
            "pow",
            "random",
            "round",
            "sign",
            "sin",
            "sinh",
            "sqrt",
            "tan",
            "tanh",
            "trunc",
            "E",
            "LN10",
            "LN2",
            "LOG10E",
            "LOG2E",
            "PI",
            "SQRT1_2",
            "SQRT2"
        ];
        var i31;
        var len11 = propertyNames11.length;
        for(i31 = 0; i31 < len11; i31 += 1)BMMath[propertyNames11[i31]] = Math[propertyNames11[i31]];
    })();
    function ProjectInterface$1() {
        return {};
    }
    BMMath.random = Math.random;
    BMMath.abs = function(val31) {
        var tOfVal11 = _typeof$6(val31);
        if (tOfVal11 === "object" && val31.length) {
            var absArr11 = createSizedArray(val31.length);
            var i31;
            var len11 = val31.length;
            for(i31 = 0; i31 < len11; i31 += 1)absArr11[i31] = Math.abs(val31[i31]);
            return absArr11;
        }
        return Math.abs(val31);
    };
    var defaultCurveSegments = 150;
    var degToRads = Math.PI / 180;
    var roundCorner = 0.5519;
    function roundValues(flag11) {
        _shouldRoundValues = !!flag11;
    }
    function bmRnd(value31) {
        if (_shouldRoundValues) return Math.round(value31);
        return value31;
    }
    function styleDiv(element11) {
        element11.style.position = "absolute";
        element11.style.top = 0;
        element11.style.left = 0;
        element11.style.display = "block";
        element11.style.transformOrigin = "0 0";
        element11.style.webkitTransformOrigin = "0 0";
        element11.style.backfaceVisibility = "visible";
        element11.style.webkitBackfaceVisibility = "visible";
        element11.style.transformStyle = "preserve-3d";
        element11.style.webkitTransformStyle = "preserve-3d";
        element11.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(type11, currentTime11, totalTime11, frameMultiplier11) {
        this.type = type11;
        this.currentTime = currentTime11;
        this.totalTime = totalTime11;
        this.direction = frameMultiplier11 < 0 ? -1 : 1;
    }
    function BMCompleteEvent(type11, frameMultiplier11) {
        this.type = type11;
        this.direction = frameMultiplier11 < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(type11, totalLoops11, currentLoop11, frameMultiplier11) {
        this.type = type11;
        this.currentLoop = currentLoop11;
        this.totalLoops = totalLoops11;
        this.direction = frameMultiplier11 < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(type11, firstFrame11, totalFrames11) {
        this.type = type11;
        this.firstFrame = firstFrame11;
        this.totalFrames = totalFrames11;
    }
    function BMDestroyEvent(type11, target11) {
        this.type = type11;
        this.target = target11;
    }
    function BMRenderFrameErrorEvent(nativeError11, currentTime11) {
        this.type = "renderFrameError";
        this.nativeError = nativeError11;
        this.currentTime = currentTime11;
    }
    function BMConfigErrorEvent(nativeError11) {
        this.type = "configError";
        this.nativeError = nativeError11;
    }
    function BMAnimationConfigErrorEvent(type11, nativeError11) {
        this.type = type11;
        this.nativeError = nativeError11;
    }
    var createElementID = function() {
        var _count11 = 0;
        return function createID11() {
            _count11 += 1;
            return idPrefix$1 + "__lottie_element_" + _count11;
        };
    }();
    function HSVtoRGB(h31, s41, v51) {
        var r11;
        var g31;
        var b31;
        var i31;
        var f31;
        var p61;
        var q11;
        var t31;
        i31 = Math.floor(h31 * 6);
        f31 = h31 * 6 - i31;
        p61 = v51 * (1 - s41);
        q11 = v51 * (1 - f31 * s41);
        t31 = v51 * (1 - (1 - f31) * s41);
        switch(i31 % 6){
            case 0:
                r11 = v51;
                g31 = t31;
                b31 = p61;
                break;
            case 1:
                r11 = q11;
                g31 = v51;
                b31 = p61;
                break;
            case 2:
                r11 = p61;
                g31 = v51;
                b31 = t31;
                break;
            case 3:
                r11 = p61;
                g31 = q11;
                b31 = v51;
                break;
            case 4:
                r11 = t31;
                g31 = p61;
                b31 = v51;
                break;
            case 5:
                r11 = v51;
                g31 = p61;
                b31 = q11;
                break;
            default:
                break;
        }
        return [
            r11,
            g31,
            b31
        ];
    }
    function RGBtoHSV(r11, g31, b31) {
        var max11 = Math.max(r11, g31, b31);
        var min11 = Math.min(r11, g31, b31);
        var d31 = max11 - min11;
        var h31;
        var s41 = max11 === 0 ? 0 : d31 / max11;
        var v51 = max11 / 255;
        switch(max11){
            case min11:
                h31 = 0;
                break;
            case r11:
                h31 = g31 - b31 + d31 * (g31 < b31 ? 6 : 0);
                h31 /= 6 * d31;
                break;
            case g31:
                h31 = b31 - r11 + d31 * 2;
                h31 /= 6 * d31;
                break;
            case b31:
                h31 = r11 - g31 + d31 * 4;
                h31 /= 6 * d31;
                break;
            default:
                break;
        }
        return [
            h31,
            s41,
            v51
        ];
    }
    function addSaturationToRGB(color41, offset11) {
        var hsv11 = RGBtoHSV(color41[0] * 255, color41[1] * 255, color41[2] * 255);
        hsv11[1] += offset11;
        if (hsv11[1] > 1) hsv11[1] = 1;
        else if (hsv11[1] <= 0) hsv11[1] = 0;
        return HSVtoRGB(hsv11[0], hsv11[1], hsv11[2]);
    }
    function addBrightnessToRGB(color41, offset11) {
        var hsv11 = RGBtoHSV(color41[0] * 255, color41[1] * 255, color41[2] * 255);
        hsv11[2] += offset11;
        if (hsv11[2] > 1) hsv11[2] = 1;
        else if (hsv11[2] < 0) hsv11[2] = 0;
        return HSVtoRGB(hsv11[0], hsv11[1], hsv11[2]);
    }
    function addHueToRGB(color41, offset11) {
        var hsv11 = RGBtoHSV(color41[0] * 255, color41[1] * 255, color41[2] * 255);
        hsv11[0] += offset11 / 360;
        if (hsv11[0] > 1) hsv11[0] -= 1;
        else if (hsv11[0] < 0) hsv11[0] += 1;
        return HSVtoRGB(hsv11[0], hsv11[1], hsv11[2]);
    }
    var rgbToHex = function() {
        var colorMap11 = [];
        var i31;
        var hex11;
        for(i31 = 0; i31 < 256; i31 += 1){
            hex11 = i31.toString(16);
            colorMap11[i31] = hex11.length === 1 ? "0" + hex11 : hex11;
        }
        return function(r11, g31, b31) {
            if (r11 < 0) r11 = 0;
            if (g31 < 0) g31 = 0;
            if (b31 < 0) b31 = 0;
            return "#" + colorMap11[r11] + colorMap11[g31] + colorMap11[b31];
        };
    }();
    var setSubframeEnabled = function setSubframeEnabled11(flag11) {
        subframeEnabled = !!flag11;
    };
    var getSubframeEnabled = function getSubframeEnabled11() {
        return subframeEnabled;
    };
    var setExpressionsPlugin = function setExpressionsPlugin11(value31) {
        expressionsPlugin = value31;
    };
    var getExpressionsPlugin = function getExpressionsPlugin11() {
        return expressionsPlugin;
    };
    var setExpressionInterfaces = function setExpressionInterfaces11(value31) {
        expressionsInterfaces = value31;
    };
    var getExpressionInterfaces = function getExpressionInterfaces11() {
        return expressionsInterfaces;
    };
    var setDefaultCurveSegments = function setDefaultCurveSegments11(value31) {
        defaultCurveSegments = value31;
    };
    var getDefaultCurveSegments = function getDefaultCurveSegments11() {
        return defaultCurveSegments;
    };
    var setIdPrefix = function setIdPrefix11(value31) {
        idPrefix$1 = value31;
    };
    var getIdPrefix = function getIdPrefix11() {
        return idPrefix$1;
    };
    function createNS(type11) {
        // return {appendChild:function(){},setAttribute:function(){},style:{}}
        return document.createElementNS(svgNS, type11);
    }
    function _typeof$5(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$5 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$5 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$5(obj11);
    }
    var dataManager = function() {
        var _counterId11 = 1;
        var processes11 = [];
        var workerFn11;
        var workerInstance11;
        var workerProxy11 = {
            onmessage: function onmessage11() {},
            postMessage: function postMessage11(path11) {
                workerFn11({
                    data: path11
                });
            }
        };
        var _workerSelf11 = {
            postMessage: function postMessage11(data11) {
                workerProxy11.onmessage({
                    data: data11
                });
            }
        };
        function createWorker11(fn11) {
            if (window.Worker && window.Blob && getWebWorker()) {
                var blob11 = new Blob([
                    "var _workerSelf = self; self.onmessage = ",
                    fn11.toString()
                ], {
                    type: "text/javascript"
                }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
                var url11 = URL.createObjectURL(blob11);
                return new Worker(url11);
            }
            workerFn11 = fn11;
            return workerProxy11;
        }
        function setupWorker11() {
            if (!workerInstance11) {
                workerInstance11 = createWorker11(function workerStart11(e31) {
                    function dataFunctionManager11() {
                        function completeLayers11(layers11, comps11) {
                            var layerData11;
                            var i31;
                            var len11 = layers11.length;
                            var j31;
                            var jLen11;
                            var k31;
                            var kLen11;
                            for(i31 = 0; i31 < len11; i31 += 1){
                                layerData11 = layers11[i31];
                                if ("ks" in layerData11 && !layerData11.completed) {
                                    layerData11.completed = true;
                                    if (layerData11.hasMask) {
                                        var maskProps11 = layerData11.masksProperties;
                                        jLen11 = maskProps11.length;
                                        for(j31 = 0; j31 < jLen11; j31 += 1)if (maskProps11[j31].pt.k.i) convertPathsToAbsoluteValues11(maskProps11[j31].pt.k);
                                        else {
                                            kLen11 = maskProps11[j31].pt.k.length;
                                            for(k31 = 0; k31 < kLen11; k31 += 1){
                                                if (maskProps11[j31].pt.k[k31].s) convertPathsToAbsoluteValues11(maskProps11[j31].pt.k[k31].s[0]);
                                                if (maskProps11[j31].pt.k[k31].e) convertPathsToAbsoluteValues11(maskProps11[j31].pt.k[k31].e[0]);
                                            }
                                        }
                                    }
                                    if (layerData11.ty === 0) {
                                        layerData11.layers = findCompLayers11(layerData11.refId, comps11);
                                        completeLayers11(layerData11.layers, comps11);
                                    } else if (layerData11.ty === 4) completeShapes11(layerData11.shapes);
                                    else if (layerData11.ty === 5) completeText11(layerData11);
                                }
                            }
                        }
                        function completeChars11(chars11, assets11) {
                            if (chars11) {
                                var i31 = 0;
                                var len11 = chars11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (chars11[i31].t === 1) {
                                    // var compData = findComp(chars[i].data.refId, assets);
                                    chars11[i31].data.layers = findCompLayers11(chars11[i31].data.refId, assets11); // chars[i].data.ip = 0;
                                    // chars[i].data.op = 99999;
                                    // chars[i].data.st = 0;
                                    // chars[i].data.sr = 1;
                                    // chars[i].w = compData.w;
                                    // chars[i].data.ks = {
                                    //   a: { k: [0, 0, 0], a: 0 },
                                    //   p: { k: [0, -compData.h, 0], a: 0 },
                                    //   r: { k: 0, a: 0 },
                                    //   s: { k: [100, 100], a: 0 },
                                    //   o: { k: 100, a: 0 },
                                    // };
                                    completeLayers11(chars11[i31].data.layers, assets11);
                                }
                            }
                        }
                        function findComp11(id11, comps11) {
                            var i31 = 0;
                            var len11 = comps11.length;
                            while(i31 < len11){
                                if (comps11[i31].id === id11) return comps11[i31];
                                i31 += 1;
                            }
                            return null;
                        }
                        function findCompLayers11(id11, comps11) {
                            var comp11 = findComp11(id11, comps11);
                            if (comp11) {
                                if (!comp11.layers.__used) {
                                    comp11.layers.__used = true;
                                    return comp11.layers;
                                }
                                return JSON.parse(JSON.stringify(comp11.layers));
                            }
                            return null;
                        }
                        function completeShapes11(arr31) {
                            var i31;
                            var len11 = arr31.length;
                            var j31;
                            var jLen11;
                            for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                                if (arr31[i31].ty === "sh") {
                                    if (arr31[i31].ks.k.i) convertPathsToAbsoluteValues11(arr31[i31].ks.k);
                                    else {
                                        jLen11 = arr31[i31].ks.k.length;
                                        for(j31 = 0; j31 < jLen11; j31 += 1){
                                            if (arr31[i31].ks.k[j31].s) convertPathsToAbsoluteValues11(arr31[i31].ks.k[j31].s[0]);
                                            if (arr31[i31].ks.k[j31].e) convertPathsToAbsoluteValues11(arr31[i31].ks.k[j31].e[0]);
                                        }
                                    }
                                } else if (arr31[i31].ty === "gr") completeShapes11(arr31[i31].it);
                            }
                        }
                        function convertPathsToAbsoluteValues11(path11) {
                            var i31;
                            var len11 = path11.i.length;
                            for(i31 = 0; i31 < len11; i31 += 1){
                                path11.i[i31][0] += path11.v[i31][0];
                                path11.i[i31][1] += path11.v[i31][1];
                                path11.o[i31][0] += path11.v[i31][0];
                                path11.o[i31][1] += path11.v[i31][1];
                            }
                        }
                        function checkVersion11(minimum11, animVersionString11) {
                            var animVersion11 = animVersionString11 ? animVersionString11.split(".") : [
                                100,
                                100,
                                100
                            ];
                            if (minimum11[0] > animVersion11[0]) return true;
                            if (animVersion11[0] > minimum11[0]) return false;
                            if (minimum11[1] > animVersion11[1]) return true;
                            if (animVersion11[1] > minimum11[1]) return false;
                            if (minimum11[2] > animVersion11[2]) return true;
                            if (animVersion11[2] > minimum11[2]) return false;
                            return null;
                        }
                        var checkText11 = function() {
                            var minimumVersion11 = [
                                4,
                                4,
                                14
                            ];
                            function updateTextLayer11(textLayer11) {
                                var documentData11 = textLayer11.t.d;
                                textLayer11.t.d = {
                                    k: [
                                        {
                                            s: documentData11,
                                            t: 0
                                        }
                                    ]
                                };
                            }
                            function iterateLayers11(layers11) {
                                var i31;
                                var len11 = layers11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (layers11[i31].ty === 5) updateTextLayer11(layers11[i31]);
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        var checkChars11 = function() {
                            var minimumVersion11 = [
                                4,
                                7,
                                99
                            ];
                            return function(animationData11) {
                                if (animationData11.chars && !checkVersion11(minimumVersion11, animationData11.v)) {
                                    var i31;
                                    var len11 = animationData11.chars.length;
                                    for(i31 = 0; i31 < len11; i31 += 1){
                                        var charData11 = animationData11.chars[i31];
                                        if (charData11.data && charData11.data.shapes) {
                                            completeShapes11(charData11.data.shapes);
                                            charData11.data.ip = 0;
                                            charData11.data.op = 99999;
                                            charData11.data.st = 0;
                                            charData11.data.sr = 1;
                                            charData11.data.ks = {
                                                p: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                s: {
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    a: 0
                                                },
                                                a: {
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    a: 0
                                                },
                                                r: {
                                                    k: 0,
                                                    a: 0
                                                },
                                                o: {
                                                    k: 100,
                                                    a: 0
                                                }
                                            };
                                            if (!animationData11.chars[i31].t) {
                                                charData11.data.shapes.push({
                                                    ty: "no"
                                                });
                                                charData11.data.shapes[0].it.push({
                                                    p: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    s: {
                                                        k: [
                                                            100,
                                                            100
                                                        ],
                                                        a: 0
                                                    },
                                                    a: {
                                                        k: [
                                                            0,
                                                            0
                                                        ],
                                                        a: 0
                                                    },
                                                    r: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    o: {
                                                        k: 100,
                                                        a: 0
                                                    },
                                                    sk: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    sa: {
                                                        k: 0,
                                                        a: 0
                                                    },
                                                    ty: "tr"
                                                });
                                            }
                                        }
                                    }
                                }
                            };
                        }();
                        var checkPathProperties11 = function() {
                            var minimumVersion11 = [
                                5,
                                7,
                                15
                            ];
                            function updateTextLayer11(textLayer11) {
                                var pathData11 = textLayer11.t.p;
                                if (typeof pathData11.a === "number") pathData11.a = {
                                    a: 0,
                                    k: pathData11.a
                                };
                                if (typeof pathData11.p === "number") pathData11.p = {
                                    a: 0,
                                    k: pathData11.p
                                };
                                if (typeof pathData11.r === "number") pathData11.r = {
                                    a: 0,
                                    k: pathData11.r
                                };
                            }
                            function iterateLayers11(layers11) {
                                var i31;
                                var len11 = layers11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (layers11[i31].ty === 5) updateTextLayer11(layers11[i31]);
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        var checkColors11 = function() {
                            var minimumVersion11 = [
                                4,
                                1,
                                9
                            ];
                            function iterateShapes11(shapes11) {
                                var i31;
                                var len11 = shapes11.length;
                                var j31;
                                var jLen11;
                                for(i31 = 0; i31 < len11; i31 += 1){
                                    if (shapes11[i31].ty === "gr") iterateShapes11(shapes11[i31].it);
                                    else if (shapes11[i31].ty === "fl" || shapes11[i31].ty === "st") {
                                        if (shapes11[i31].c.k && shapes11[i31].c.k[0].i) {
                                            jLen11 = shapes11[i31].c.k.length;
                                            for(j31 = 0; j31 < jLen11; j31 += 1){
                                                if (shapes11[i31].c.k[j31].s) {
                                                    shapes11[i31].c.k[j31].s[0] /= 255;
                                                    shapes11[i31].c.k[j31].s[1] /= 255;
                                                    shapes11[i31].c.k[j31].s[2] /= 255;
                                                    shapes11[i31].c.k[j31].s[3] /= 255;
                                                }
                                                if (shapes11[i31].c.k[j31].e) {
                                                    shapes11[i31].c.k[j31].e[0] /= 255;
                                                    shapes11[i31].c.k[j31].e[1] /= 255;
                                                    shapes11[i31].c.k[j31].e[2] /= 255;
                                                    shapes11[i31].c.k[j31].e[3] /= 255;
                                                }
                                            }
                                        } else {
                                            shapes11[i31].c.k[0] /= 255;
                                            shapes11[i31].c.k[1] /= 255;
                                            shapes11[i31].c.k[2] /= 255;
                                            shapes11[i31].c.k[3] /= 255;
                                        }
                                    }
                                }
                            }
                            function iterateLayers11(layers11) {
                                var i31;
                                var len11 = layers11.length;
                                for(i31 = 0; i31 < len11; i31 += 1)if (layers11[i31].ty === 4) iterateShapes11(layers11[i31].shapes);
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        var checkShapes11 = function() {
                            var minimumVersion11 = [
                                4,
                                4,
                                18
                            ];
                            function completeClosingShapes11(arr31) {
                                var i31;
                                var len11 = arr31.length;
                                var j31;
                                var jLen11;
                                for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                                    if (arr31[i31].ty === "sh") {
                                        if (arr31[i31].ks.k.i) arr31[i31].ks.k.c = arr31[i31].closed;
                                        else {
                                            jLen11 = arr31[i31].ks.k.length;
                                            for(j31 = 0; j31 < jLen11; j31 += 1){
                                                if (arr31[i31].ks.k[j31].s) arr31[i31].ks.k[j31].s[0].c = arr31[i31].closed;
                                                if (arr31[i31].ks.k[j31].e) arr31[i31].ks.k[j31].e[0].c = arr31[i31].closed;
                                            }
                                        }
                                    } else if (arr31[i31].ty === "gr") completeClosingShapes11(arr31[i31].it);
                                }
                            }
                            function iterateLayers11(layers11) {
                                var layerData11;
                                var i31;
                                var len11 = layers11.length;
                                var j31;
                                var jLen11;
                                var k31;
                                var kLen11;
                                for(i31 = 0; i31 < len11; i31 += 1){
                                    layerData11 = layers11[i31];
                                    if (layerData11.hasMask) {
                                        var maskProps11 = layerData11.masksProperties;
                                        jLen11 = maskProps11.length;
                                        for(j31 = 0; j31 < jLen11; j31 += 1)if (maskProps11[j31].pt.k.i) maskProps11[j31].pt.k.c = maskProps11[j31].cl;
                                        else {
                                            kLen11 = maskProps11[j31].pt.k.length;
                                            for(k31 = 0; k31 < kLen11; k31 += 1){
                                                if (maskProps11[j31].pt.k[k31].s) maskProps11[j31].pt.k[k31].s[0].c = maskProps11[j31].cl;
                                                if (maskProps11[j31].pt.k[k31].e) maskProps11[j31].pt.k[k31].e[0].c = maskProps11[j31].cl;
                                            }
                                        }
                                    }
                                    if (layerData11.ty === 4) completeClosingShapes11(layerData11.shapes);
                                }
                            }
                            return function(animationData11) {
                                if (checkVersion11(minimumVersion11, animationData11.v)) {
                                    iterateLayers11(animationData11.layers);
                                    if (animationData11.assets) {
                                        var i31;
                                        var len11 = animationData11.assets.length;
                                        for(i31 = 0; i31 < len11; i31 += 1)if (animationData11.assets[i31].layers) iterateLayers11(animationData11.assets[i31].layers);
                                    }
                                }
                            };
                        }();
                        function completeData11(animationData11) {
                            if (animationData11.__complete) return;
                            checkColors11(animationData11);
                            checkText11(animationData11);
                            checkChars11(animationData11);
                            checkPathProperties11(animationData11);
                            checkShapes11(animationData11);
                            completeLayers11(animationData11.layers, animationData11.assets);
                            completeChars11(animationData11.chars, animationData11.assets);
                            animationData11.__complete = true;
                        }
                        function completeText11(data11) {
                            data11.t.a.length === 0 && data11.t.p;
                        }
                        var moduleOb11 = {};
                        moduleOb11.completeData = completeData11;
                        moduleOb11.checkColors = checkColors11;
                        moduleOb11.checkChars = checkChars11;
                        moduleOb11.checkPathProperties = checkPathProperties11;
                        moduleOb11.checkShapes = checkShapes11;
                        moduleOb11.completeLayers = completeLayers11;
                        return moduleOb11;
                    }
                    if (!_workerSelf11.dataManager) _workerSelf11.dataManager = dataFunctionManager11();
                    if (!_workerSelf11.assetLoader) _workerSelf11.assetLoader = function() {
                        function formatResponse11(xhr11) {
                            // using typeof doubles the time of execution of this method,
                            // so if available, it's better to use the header to validate the type
                            var contentTypeHeader11 = xhr11.getResponseHeader("content-type");
                            if (contentTypeHeader11 && xhr11.responseType === "json" && contentTypeHeader11.indexOf("json") !== -1) return xhr11.response;
                            if (xhr11.response && _typeof$5(xhr11.response) === "object") return xhr11.response;
                            if (xhr11.response && typeof xhr11.response === "string") return JSON.parse(xhr11.response);
                            if (xhr11.responseText) return JSON.parse(xhr11.responseText);
                            return null;
                        }
                        function loadAsset11(path11, fullPath11, callback11, errorCallback11) {
                            var response11;
                            var xhr11 = new XMLHttpRequest(); // set responseType after calling open or IE will break.
                            try {
                                // This crashes on Android WebView prior to KitKat
                                xhr11.responseType = "json";
                            } catch (err11) {} // eslint-disable-line no-empty
                            xhr11.onreadystatechange = function() {
                                if (xhr11.readyState === 4) {
                                    if (xhr11.status === 200) {
                                        response11 = formatResponse11(xhr11);
                                        callback11(response11);
                                    } else try {
                                        response11 = formatResponse11(xhr11);
                                        callback11(response11);
                                    } catch (err11) {
                                        if (errorCallback11) errorCallback11(err11);
                                    }
                                }
                            };
                            try {
                                // Hack to workaround banner validation
                                xhr11.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), path11, true);
                            } catch (error11) {
                                // Hack to workaround banner validation
                                xhr11.open([
                                    "G",
                                    "E",
                                    "T"
                                ].join(""), fullPath11 + "/" + path11, true);
                            }
                            xhr11.send();
                        }
                        return {
                            load: loadAsset11
                        };
                    }();
                    if (e31.data.type === "loadAnimation") _workerSelf11.assetLoader.load(e31.data.path, e31.data.fullPath, function(data11) {
                        _workerSelf11.dataManager.completeData(data11);
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            payload: data11,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            status: "error"
                        });
                    });
                    else if (e31.data.type === "complete") {
                        var animation11 = e31.data.animation;
                        _workerSelf11.dataManager.completeData(animation11);
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            payload: animation11,
                            status: "success"
                        });
                    } else if (e31.data.type === "loadData") _workerSelf11.assetLoader.load(e31.data.path, e31.data.fullPath, function(data11) {
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            payload: data11,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf11.postMessage({
                            id: e31.data.id,
                            status: "error"
                        });
                    });
                });
                workerInstance11.onmessage = function(event11) {
                    var data11 = event11.data;
                    var id11 = data11.id;
                    var process11 = processes11[id11];
                    processes11[id11] = null;
                    if (data11.status === "success") process11.onComplete(data11.payload);
                    else if (process11.onError) process11.onError();
                };
            }
        }
        function createProcess11(onComplete11, onError11) {
            _counterId11 += 1;
            var id11 = "processId_" + _counterId11;
            processes11[id11] = {
                onComplete: onComplete11,
                onError: onError11
            };
            return id11;
        }
        function loadAnimation11(path11, onComplete11, onError11) {
            setupWorker11();
            var processId11 = createProcess11(onComplete11, onError11);
            workerInstance11.postMessage({
                type: "loadAnimation",
                path: path11,
                fullPath: window.location.origin + window.location.pathname,
                id: processId11
            });
        }
        function loadData11(path11, onComplete11, onError11) {
            setupWorker11();
            var processId11 = createProcess11(onComplete11, onError11);
            workerInstance11.postMessage({
                type: "loadData",
                path: path11,
                fullPath: window.location.origin + window.location.pathname,
                id: processId11
            });
        }
        function completeAnimation11(anim11, onComplete11, onError11) {
            setupWorker11();
            var processId11 = createProcess11(onComplete11, onError11);
            workerInstance11.postMessage({
                type: "complete",
                animation: anim11,
                id: processId11
            });
        }
        return {
            loadAnimation: loadAnimation11,
            loadData: loadData11,
            completeAnimation: completeAnimation11
        };
    }();
    var ImagePreloader = function() {
        var proxyImage11 = function() {
            var canvas11 = createTag("canvas");
            canvas11.width = 1;
            canvas11.height = 1;
            var ctx11 = canvas11.getContext("2d");
            ctx11.fillStyle = "rgba(0,0,0,0)";
            ctx11.fillRect(0, 0, 1, 1);
            return canvas11;
        }();
        function imageLoaded11() {
            this.loadedAssets += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function footageLoaded11() {
            this.loadedFootagesCount += 1;
            if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
                if (this.imagesLoadedCb) this.imagesLoadedCb(null);
            }
        }
        function getAssetsPath11(assetData11, assetsPath11, originalPath11) {
            var path11 = "";
            if (assetData11.e) path11 = assetData11.p;
            else if (assetsPath11) {
                var imagePath11 = assetData11.p;
                if (imagePath11.indexOf("images/") !== -1) imagePath11 = imagePath11.split("/")[1];
                path11 = assetsPath11 + imagePath11;
            } else {
                path11 = originalPath11;
                path11 += assetData11.u ? assetData11.u : "";
                path11 += assetData11.p;
            }
            return path11;
        }
        function testImageLoaded11(img11) {
            var _count11 = 0;
            var intervalId11 = setInterval((function() {
                var box11 = img11.getBBox();
                if (box11.width || _count11 > 500) {
                    this._imageLoaded();
                    clearInterval(intervalId11);
                }
                _count11 += 1;
            }).bind(this), 50);
        }
        function createImageData11(assetData11) {
            var path11 = getAssetsPath11(assetData11, this.assetsPath, this.path);
            var img11 = createNS("image");
            if (isSafari) this.testImageLoaded(img11);
            else img11.addEventListener("load", this._imageLoaded, false);
            img11.addEventListener("error", (function() {
                ob11.img = proxyImage11;
                this._imageLoaded();
            }).bind(this), false);
            img11.setAttributeNS("http://www.w3.org/1999/xlink", "href", path11);
            if (this._elementHelper.append) this._elementHelper.append(img11);
            else this._elementHelper.appendChild(img11);
            var ob11 = {
                img: img11,
                assetData: assetData11
            };
            return ob11;
        }
        function createImgData11(assetData11) {
            var path11 = getAssetsPath11(assetData11, this.assetsPath, this.path);
            var img11 = createTag("img");
            img11.crossOrigin = "anonymous";
            img11.addEventListener("load", this._imageLoaded, false);
            img11.addEventListener("error", (function() {
                ob11.img = proxyImage11;
                this._imageLoaded();
            }).bind(this), false);
            img11.src = path11;
            var ob11 = {
                img: img11,
                assetData: assetData11
            };
            return ob11;
        }
        function createFootageData11(data11) {
            var ob11 = {
                assetData: data11
            };
            var path11 = getAssetsPath11(data11, this.assetsPath, this.path);
            dataManager.loadData(path11, (function(footageData11) {
                ob11.img = footageData11;
                this._footageLoaded();
            }).bind(this), (function() {
                ob11.img = {};
                this._footageLoaded();
            }).bind(this));
            return ob11;
        }
        function loadAssets11(assets11, cb11) {
            this.imagesLoadedCb = cb11;
            var i31;
            var len11 = assets11.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (!assets11[i31].layers) {
                if (!assets11[i31].t || assets11[i31].t === "seq") {
                    this.totalImages += 1;
                    this.images.push(this._createImageData(assets11[i31]));
                } else if (assets11[i31].t === 3) {
                    this.totalFootages += 1;
                    this.images.push(this.createFootageData(assets11[i31]));
                }
            }
        }
        function setPath11(path11) {
            this.path = path11 || "";
        }
        function setAssetsPath11(path11) {
            this.assetsPath = path11 || "";
        }
        function getAsset11(assetData11) {
            var i31 = 0;
            var len11 = this.images.length;
            while(i31 < len11){
                if (this.images[i31].assetData === assetData11) return this.images[i31].img;
                i31 += 1;
            }
            return null;
        }
        function destroy11() {
            this.imagesLoadedCb = null;
            this.images.length = 0;
        }
        function loadedImages11() {
            return this.totalImages === this.loadedAssets;
        }
        function loadedFootages11() {
            return this.totalFootages === this.loadedFootagesCount;
        }
        function setCacheType11(type11, elementHelper11) {
            if (type11 === "svg") {
                this._elementHelper = elementHelper11;
                this._createImageData = this.createImageData.bind(this);
            } else this._createImageData = this.createImgData.bind(this);
        }
        function ImagePreloaderFactory11() {
            this._imageLoaded = imageLoaded11.bind(this);
            this._footageLoaded = footageLoaded11.bind(this);
            this.testImageLoaded = testImageLoaded11.bind(this);
            this.createFootageData = createFootageData11.bind(this);
            this.assetsPath = "";
            this.path = "";
            this.totalImages = 0;
            this.totalFootages = 0;
            this.loadedAssets = 0;
            this.loadedFootagesCount = 0;
            this.imagesLoadedCb = null;
            this.images = [];
        }
        ImagePreloaderFactory11.prototype = {
            loadAssets: loadAssets11,
            setAssetsPath: setAssetsPath11,
            setPath: setPath11,
            loadedImages: loadedImages11,
            loadedFootages: loadedFootages11,
            destroy: destroy11,
            getAsset: getAsset11,
            createImgData: createImgData11,
            createImageData: createImageData11,
            imageLoaded: imageLoaded11,
            footageLoaded: footageLoaded11,
            setCacheType: setCacheType11
        };
        return ImagePreloaderFactory11;
    }();
    function BaseEvent() {}
    BaseEvent.prototype = {
        triggerEvent: function triggerEvent11(eventName11, args11) {
            if (this._cbs[eventName11]) {
                var callbacks11 = this._cbs[eventName11];
                for(var i31 = 0; i31 < callbacks11.length; i31 += 1)callbacks11[i31](args11);
            }
        },
        addEventListener: function addEventListener11(eventName11, callback11) {
            if (!this._cbs[eventName11]) this._cbs[eventName11] = [];
            this._cbs[eventName11].push(callback11);
            return (function() {
                this.removeEventListener(eventName11, callback11);
            }).bind(this);
        },
        removeEventListener: function removeEventListener11(eventName11, callback11) {
            if (!callback11) this._cbs[eventName11] = null;
            else if (this._cbs[eventName11]) {
                var i31 = 0;
                var len11 = this._cbs[eventName11].length;
                while(i31 < len11){
                    if (this._cbs[eventName11][i31] === callback11) {
                        this._cbs[eventName11].splice(i31, 1);
                        i31 -= 1;
                        len11 -= 1;
                    }
                    i31 += 1;
                }
                if (!this._cbs[eventName11].length) this._cbs[eventName11] = null;
            }
        }
    };
    var markerParser = function() {
        function parsePayloadLines11(payload11) {
            var lines11 = payload11.split("\r\n");
            var keys11 = {};
            var line11;
            var keysCount11 = 0;
            for(var i31 = 0; i31 < lines11.length; i31 += 1){
                line11 = lines11[i31].split(":");
                if (line11.length === 2) {
                    keys11[line11[0]] = line11[1].trim();
                    keysCount11 += 1;
                }
            }
            if (keysCount11 === 0) throw new Error();
            return keys11;
        }
        return function(_markers11) {
            var markers11 = [];
            for(var i31 = 0; i31 < _markers11.length; i31 += 1){
                var _marker11 = _markers11[i31];
                var markerData11 = {
                    time: _marker11.tm,
                    duration: _marker11.dr
                };
                try {
                    markerData11.payload = JSON.parse(_markers11[i31].cm);
                } catch (_11) {
                    try {
                        markerData11.payload = parsePayloadLines11(_markers11[i31].cm);
                    } catch (__11) {
                        markerData11.payload = {
                            name: _markers11[i31].cm
                        };
                    }
                }
                markers11.push(markerData11);
            }
            return markers11;
        };
    }();
    var ProjectInterface = function() {
        function registerComposition11(comp11) {
            this.compositions.push(comp11);
        }
        return function() {
            function _thisProjectFunction11(name11) {
                var i31 = 0;
                var len11 = this.compositions.length;
                while(i31 < len11){
                    if (this.compositions[i31].data && this.compositions[i31].data.nm === name11) {
                        if (this.compositions[i31].prepareFrame && this.compositions[i31].data.xt) this.compositions[i31].prepareFrame(this.currentFrame);
                        return this.compositions[i31].compInterface;
                    }
                    i31 += 1;
                }
                return null;
            }
            _thisProjectFunction11.compositions = [];
            _thisProjectFunction11.currentFrame = 0;
            _thisProjectFunction11.registerComposition = registerComposition11;
            return _thisProjectFunction11;
        };
    }();
    var renderers = {};
    var registerRenderer = function registerRenderer11(key11, value31) {
        renderers[key11] = value31;
    };
    function getRenderer(key11) {
        return renderers[key11];
    }
    function getRegisteredRenderer() {
        // Returns canvas by default for compatibility
        if (renderers.canvas) return "canvas";
         // Returns any renderer that is registered
        for(var key11 in renderers){
            if (renderers[key11]) return key11;
        }
        return "";
    }
    function _typeof$4(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$4 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$4 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$4(obj11);
    }
    var AnimationItem = function AnimationItem11() {
        this._cbs = [];
        this.name = "";
        this.path = "";
        this.isLoaded = false;
        this.currentFrame = 0;
        this.currentRawFrame = 0;
        this.firstFrame = 0;
        this.totalFrames = 0;
        this.frameRate = 0;
        this.frameMult = 0;
        this.playSpeed = 1;
        this.playDirection = 1;
        this.playCount = 0;
        this.animationData = {};
        this.assets = [];
        this.isPaused = true;
        this.autoplay = false;
        this.loop = true;
        this.renderer = null;
        this.animationID = createElementID();
        this.assetsPath = "";
        this.timeCompleted = 0;
        this.segmentPos = 0;
        this.isSubframeEnabled = getSubframeEnabled();
        this.segments = [];
        this._idle = true;
        this._completedLoop = false;
        this.projectInterface = ProjectInterface();
        this.imagePreloader = new ImagePreloader();
        this.audioController = audioControllerFactory();
        this.markers = [];
        this.configAnimation = this.configAnimation.bind(this);
        this.onSetupError = this.onSetupError.bind(this);
        this.onSegmentComplete = this.onSegmentComplete.bind(this);
        this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0);
        this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([
        BaseEvent
    ], AnimationItem);
    AnimationItem.prototype.setParams = function(params11) {
        if (params11.wrapper || params11.container) this.wrapper = params11.wrapper || params11.container;
        var animType11 = "svg";
        if (params11.animType) animType11 = params11.animType;
        else if (params11.renderer) animType11 = params11.renderer;
        var RendererClass11 = getRenderer(animType11);
        this.renderer = new RendererClass11(this, params11.rendererSettings);
        this.imagePreloader.setCacheType(animType11, this.renderer.globalData.defs);
        this.renderer.setProjectInterface(this.projectInterface);
        this.animType = animType11;
        if (params11.loop === "" || params11.loop === null || params11.loop === undefined || params11.loop === true) this.loop = true;
        else if (params11.loop === false) this.loop = false;
        else this.loop = parseInt(params11.loop, 10);
        this.autoplay = "autoplay" in params11 ? params11.autoplay : true;
        this.name = params11.name ? params11.name : "";
        this.autoloadSegments = Object.prototype.hasOwnProperty.call(params11, "autoloadSegments") ? params11.autoloadSegments : true;
        this.assetsPath = params11.assetsPath;
        this.initialSegment = params11.initialSegment;
        if (params11.audioFactory) this.audioController.setAudioFactory(params11.audioFactory);
        if (params11.animationData) this.setupAnimation(params11.animationData);
        else if (params11.path) {
            if (params11.path.lastIndexOf("\\") !== -1) this.path = params11.path.substr(0, params11.path.lastIndexOf("\\") + 1);
            else this.path = params11.path.substr(0, params11.path.lastIndexOf("/") + 1);
            this.fileName = params11.path.substr(params11.path.lastIndexOf("/") + 1);
            this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json"));
            dataManager.loadAnimation(params11.path, this.configAnimation, this.onSetupError);
        }
    };
    AnimationItem.prototype.onSetupError = function() {
        this.trigger("data_failed");
    };
    AnimationItem.prototype.setupAnimation = function(data11) {
        dataManager.completeAnimation(data11, this.configAnimation);
    };
    AnimationItem.prototype.setData = function(wrapper11, animationData11) {
        if (animationData11) {
            if (_typeof$4(animationData11) !== "object") animationData11 = JSON.parse(animationData11);
        }
        var params11 = {
            wrapper: wrapper11,
            animationData: animationData11
        };
        var wrapperAttributes11 = wrapper11.attributes;
        params11.path = wrapperAttributes11.getNamedItem("data-animation-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-animation-path").value : wrapperAttributes11.getNamedItem("data-bm-path") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-path").value : wrapperAttributes11.getNamedItem("bm-path") ? wrapperAttributes11.getNamedItem("bm-path").value : "";
        params11.animType = wrapperAttributes11.getNamedItem("data-anim-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-type").value : wrapperAttributes11.getNamedItem("data-bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-type").value : wrapperAttributes11.getNamedItem("bm-type") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("bm-type").value : wrapperAttributes11.getNamedItem("data-bm-renderer") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-renderer").value : wrapperAttributes11.getNamedItem("bm-renderer") ? wrapperAttributes11.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
        var loop11 = wrapperAttributes11.getNamedItem("data-anim-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-loop").value : wrapperAttributes11.getNamedItem("data-bm-loop") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-loop").value : wrapperAttributes11.getNamedItem("bm-loop") ? wrapperAttributes11.getNamedItem("bm-loop").value : "";
        if (loop11 === "false") params11.loop = false;
        else if (loop11 === "true") params11.loop = true;
        else if (loop11 !== "") params11.loop = parseInt(loop11, 10);
        var autoplay11 = wrapperAttributes11.getNamedItem("data-anim-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-autoplay").value : wrapperAttributes11.getNamedItem("data-bm-autoplay") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-autoplay").value : wrapperAttributes11.getNamedItem("bm-autoplay") ? wrapperAttributes11.getNamedItem("bm-autoplay").value : true;
        params11.autoplay = autoplay11 !== "false";
        params11.name = wrapperAttributes11.getNamedItem("data-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-name").value : wrapperAttributes11.getNamedItem("data-bm-name") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-name").value : wrapperAttributes11.getNamedItem("bm-name") ? wrapperAttributes11.getNamedItem("bm-name").value : "";
        var prerender11 = wrapperAttributes11.getNamedItem("data-anim-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-anim-prerender").value : wrapperAttributes11.getNamedItem("data-bm-prerender") // eslint-disable-line no-nested-ternary
         ? wrapperAttributes11.getNamedItem("data-bm-prerender").value : wrapperAttributes11.getNamedItem("bm-prerender") ? wrapperAttributes11.getNamedItem("bm-prerender").value : "";
        if (prerender11 === "false") params11.prerender = false;
        if (!params11.path) this.trigger("destroy");
        else this.setParams(params11);
    };
    AnimationItem.prototype.includeLayers = function(data11) {
        if (data11.op > this.animationData.op) {
            this.animationData.op = data11.op;
            this.totalFrames = Math.floor(data11.op - this.animationData.ip);
        }
        var layers11 = this.animationData.layers;
        var i31;
        var len11 = layers11.length;
        var newLayers11 = data11.layers;
        var j31;
        var jLen11 = newLayers11.length;
        for(j31 = 0; j31 < jLen11; j31 += 1){
            i31 = 0;
            while(i31 < len11){
                if (layers11[i31].id === newLayers11[j31].id) {
                    layers11[i31] = newLayers11[j31];
                    break;
                }
                i31 += 1;
            }
        }
        if (data11.chars || data11.fonts) {
            this.renderer.globalData.fontManager.addChars(data11.chars);
            this.renderer.globalData.fontManager.addFonts(data11.fonts, this.renderer.globalData.defs);
        }
        if (data11.assets) {
            len11 = data11.assets.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.animationData.assets.push(data11.assets[i31]);
        }
        this.animationData.__complete = false;
        dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    };
    AnimationItem.prototype.onSegmentComplete = function(data11) {
        this.animationData = data11;
        var expressionsPlugin11 = getExpressionsPlugin();
        if (expressionsPlugin11) expressionsPlugin11.initExpressions(this);
        this.loadNextSegment();
    };
    AnimationItem.prototype.loadNextSegment = function() {
        var segments11 = this.animationData.segments;
        if (!segments11 || segments11.length === 0 || !this.autoloadSegments) {
            this.trigger("data_ready");
            this.timeCompleted = this.totalFrames;
            return;
        }
        var segment11 = segments11.shift();
        this.timeCompleted = segment11.time * this.frameRate;
        var segmentPath11 = this.path + this.fileName + "_" + this.segmentPos + ".json";
        this.segmentPos += 1;
        dataManager.loadData(segmentPath11, this.includeLayers.bind(this), (function() {
            this.trigger("data_failed");
        }).bind(this));
    };
    AnimationItem.prototype.loadSegments = function() {
        var segments11 = this.animationData.segments;
        if (!segments11) this.timeCompleted = this.totalFrames;
        this.loadNextSegment();
    };
    AnimationItem.prototype.imagesLoaded = function() {
        this.trigger("loaded_images");
        this.checkLoaded();
    };
    AnimationItem.prototype.preloadImages = function() {
        this.imagePreloader.setAssetsPath(this.assetsPath);
        this.imagePreloader.setPath(this.path);
        this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    };
    AnimationItem.prototype.configAnimation = function(animData11) {
        if (!this.renderer) return;
        try {
            this.animationData = animData11;
            if (this.initialSegment) {
                this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
                this.firstFrame = Math.round(this.initialSegment[0]);
            } else {
                this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
                this.firstFrame = Math.round(this.animationData.ip);
            }
            this.renderer.configAnimation(animData11);
            if (!animData11.assets) animData11.assets = [];
            this.assets = this.animationData.assets;
            this.frameRate = this.animationData.fr;
            this.frameMult = this.animationData.fr / 1000;
            this.renderer.searchExtraCompositions(animData11.assets);
            this.markers = markerParser(animData11.markers || []);
            this.trigger("config_ready");
            this.preloadImages();
            this.loadSegments();
            this.updaFrameModifier();
            this.waitForFontsLoaded();
            if (this.isPaused) this.audioController.pause();
        } catch (error11) {
            this.triggerConfigError(error11);
        }
    };
    AnimationItem.prototype.waitForFontsLoaded = function() {
        if (!this.renderer) return;
        if (this.renderer.globalData.fontManager.isLoaded) this.checkLoaded();
        else setTimeout(this.waitForFontsLoaded.bind(this), 20);
    };
    AnimationItem.prototype.checkLoaded = function() {
        if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
            this.isLoaded = true;
            var expressionsPlugin11 = getExpressionsPlugin();
            if (expressionsPlugin11) expressionsPlugin11.initExpressions(this);
            this.renderer.initItems();
            setTimeout((function() {
                this.trigger("DOMLoaded");
            }).bind(this), 0);
            this.gotoFrame();
            if (this.autoplay) this.play();
        }
    };
    AnimationItem.prototype.resize = function(width11, height11) {
        // Adding this validation for backwards compatibility in case an event object was being passed down
        var _width11 = typeof width11 === "number" ? width11 : undefined;
        var _height11 = typeof height11 === "number" ? height11 : undefined;
        this.renderer.updateContainerSize(_width11, _height11);
    };
    AnimationItem.prototype.setSubframe = function(flag11) {
        this.isSubframeEnabled = !!flag11;
    };
    AnimationItem.prototype.gotoFrame = function() {
        this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise
        if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) this.currentFrame = this.timeCompleted;
        this.trigger("enterFrame");
        this.renderFrame();
        this.trigger("drawnFrame");
    };
    AnimationItem.prototype.renderFrame = function() {
        if (this.isLoaded === false || !this.renderer) return;
        try {
            if (this.expressionsPlugin) this.expressionsPlugin.resetFrame();
            this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (error11) {
            this.triggerRenderFrameError(error11);
        }
    };
    AnimationItem.prototype.play = function(name11) {
        if (name11 && this.name !== name11) return;
        if (this.isPaused === true) {
            this.isPaused = false;
            this.trigger("_play");
            this.audioController.resume();
            if (this._idle) {
                this._idle = false;
                this.trigger("_active");
            }
        }
    };
    AnimationItem.prototype.pause = function(name11) {
        if (name11 && this.name !== name11) return;
        if (this.isPaused === false) {
            this.isPaused = true;
            this.trigger("_pause");
            this._idle = true;
            this.trigger("_idle");
            this.audioController.pause();
        }
    };
    AnimationItem.prototype.togglePause = function(name11) {
        if (name11 && this.name !== name11) return;
        if (this.isPaused === true) this.play();
        else this.pause();
    };
    AnimationItem.prototype.stop = function(name11) {
        if (name11 && this.name !== name11) return;
        this.pause();
        this.playCount = 0;
        this._completedLoop = false;
        this.setCurrentRawFrameValue(0);
    };
    AnimationItem.prototype.getMarkerData = function(markerName11) {
        var marker11;
        for(var i31 = 0; i31 < this.markers.length; i31 += 1){
            marker11 = this.markers[i31];
            if (marker11.payload && marker11.payload.name === markerName11) return marker11;
        }
        return null;
    };
    AnimationItem.prototype.goToAndStop = function(value31, isFrame11, name11) {
        if (name11 && this.name !== name11) return;
        var numValue11 = Number(value31);
        if (isNaN(numValue11)) {
            var marker11 = this.getMarkerData(value31);
            if (marker11) this.goToAndStop(marker11.time, true);
        } else if (isFrame11) this.setCurrentRawFrameValue(value31);
        else this.setCurrentRawFrameValue(value31 * this.frameModifier);
        this.pause();
    };
    AnimationItem.prototype.goToAndPlay = function(value31, isFrame11, name11) {
        if (name11 && this.name !== name11) return;
        var numValue11 = Number(value31);
        if (isNaN(numValue11)) {
            var marker11 = this.getMarkerData(value31);
            if (marker11) {
                if (!marker11.duration) this.goToAndStop(marker11.time, true);
                else this.playSegments([
                    marker11.time,
                    marker11.time + marker11.duration
                ], true);
            }
        } else this.goToAndStop(numValue11, isFrame11, name11);
        this.play();
    };
    AnimationItem.prototype.advanceTime = function(value31) {
        if (this.isPaused === true || this.isLoaded === false) return;
        var nextValue11 = this.currentRawFrame + value31 * this.frameModifier;
        var _isComplete11 = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
        // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.
        if (nextValue11 >= this.totalFrames - 1 && this.frameModifier > 0) {
            if (!this.loop || this.playCount === this.loop) {
                if (!this.checkSegments(nextValue11 > this.totalFrames ? nextValue11 % this.totalFrames : 0)) {
                    _isComplete11 = true;
                    nextValue11 = this.totalFrames - 1;
                }
            } else if (nextValue11 >= this.totalFrames) {
                this.playCount += 1;
                if (!this.checkSegments(nextValue11 % this.totalFrames)) {
                    this.setCurrentRawFrameValue(nextValue11 % this.totalFrames);
                    this._completedLoop = true;
                    this.trigger("loopComplete");
                }
            } else this.setCurrentRawFrameValue(nextValue11);
        } else if (nextValue11 < 0) {
            if (!this.checkSegments(nextValue11 % this.totalFrames)) {
                if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
                    // eslint-disable-line no-plusplus
                    this.setCurrentRawFrameValue(this.totalFrames + nextValue11 % this.totalFrames);
                    if (!this._completedLoop) this._completedLoop = true;
                    else this.trigger("loopComplete");
                } else {
                    _isComplete11 = true;
                    nextValue11 = 0;
                }
            }
        } else this.setCurrentRawFrameValue(nextValue11);
        if (_isComplete11) {
            this.setCurrentRawFrameValue(nextValue11);
            this.pause();
            this.trigger("complete");
        }
    };
    AnimationItem.prototype.adjustSegment = function(arr31, offset11) {
        this.playCount = 0;
        if (arr31[1] < arr31[0]) {
            if (this.frameModifier > 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(-1);
            }
            this.totalFrames = arr31[0] - arr31[1];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr31[1];
            this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset11);
        } else if (arr31[1] > arr31[0]) {
            if (this.frameModifier < 0) {
                if (this.playSpeed < 0) this.setSpeed(-this.playSpeed);
                else this.setDirection(1);
            }
            this.totalFrames = arr31[1] - arr31[0];
            this.timeCompleted = this.totalFrames;
            this.firstFrame = arr31[0];
            this.setCurrentRawFrameValue(0.001 + offset11);
        }
        this.trigger("segmentStart");
    };
    AnimationItem.prototype.setSegment = function(init11, end31) {
        var pendingFrame11 = -1;
        if (this.isPaused) {
            if (this.currentRawFrame + this.firstFrame < init11) pendingFrame11 = init11;
            else if (this.currentRawFrame + this.firstFrame > end31) pendingFrame11 = end31 - init11;
        }
        this.firstFrame = init11;
        this.totalFrames = end31 - init11;
        this.timeCompleted = this.totalFrames;
        if (pendingFrame11 !== -1) this.goToAndStop(pendingFrame11, true);
    };
    AnimationItem.prototype.playSegments = function(arr31, forceFlag11) {
        if (forceFlag11) this.segments.length = 0;
        if (_typeof$4(arr31[0]) === "object") {
            var i31;
            var len11 = arr31.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.segments.push(arr31[i31]);
        } else this.segments.push(arr31);
        if (this.segments.length && forceFlag11) this.adjustSegment(this.segments.shift(), 0);
        if (this.isPaused) this.play();
    };
    AnimationItem.prototype.resetSegments = function(forceFlag11) {
        this.segments.length = 0;
        this.segments.push([
            this.animationData.ip,
            this.animationData.op
        ]);
        if (forceFlag11) this.checkSegments(0);
    };
    AnimationItem.prototype.checkSegments = function(offset11) {
        if (this.segments.length) {
            this.adjustSegment(this.segments.shift(), offset11);
            return true;
        }
        return false;
    };
    AnimationItem.prototype.destroy = function(name11) {
        if (name11 && this.name !== name11 || !this.renderer) return;
        this.renderer.destroy();
        this.imagePreloader.destroy();
        this.trigger("destroy");
        this._cbs = null;
        this.onEnterFrame = null;
        this.onLoopComplete = null;
        this.onComplete = null;
        this.onSegmentStart = null;
        this.onDestroy = null;
        this.renderer = null;
        this.expressionsPlugin = null;
        this.imagePreloader = null;
        this.projectInterface = null;
    };
    AnimationItem.prototype.setCurrentRawFrameValue = function(value31) {
        this.currentRawFrame = value31;
        this.gotoFrame();
    };
    AnimationItem.prototype.setSpeed = function(val31) {
        this.playSpeed = val31;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setDirection = function(val31) {
        this.playDirection = val31 < 0 ? -1 : 1;
        this.updaFrameModifier();
    };
    AnimationItem.prototype.setLoop = function(isLooping11) {
        this.loop = isLooping11;
    };
    AnimationItem.prototype.setVolume = function(val31, name11) {
        if (name11 && this.name !== name11) return;
        this.audioController.setVolume(val31);
    };
    AnimationItem.prototype.getVolume = function() {
        return this.audioController.getVolume();
    };
    AnimationItem.prototype.mute = function(name11) {
        if (name11 && this.name !== name11) return;
        this.audioController.mute();
    };
    AnimationItem.prototype.unmute = function(name11) {
        if (name11 && this.name !== name11) return;
        this.audioController.unmute();
    };
    AnimationItem.prototype.updaFrameModifier = function() {
        this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
        this.audioController.setRate(this.playSpeed * this.playDirection);
    };
    AnimationItem.prototype.getPath = function() {
        return this.path;
    };
    AnimationItem.prototype.getAssetsPath = function(assetData11) {
        var path11 = "";
        if (assetData11.e) path11 = assetData11.p;
        else if (this.assetsPath) {
            var imagePath11 = assetData11.p;
            if (imagePath11.indexOf("images/") !== -1) imagePath11 = imagePath11.split("/")[1];
            path11 = this.assetsPath + imagePath11;
        } else {
            path11 = this.path;
            path11 += assetData11.u ? assetData11.u : "";
            path11 += assetData11.p;
        }
        return path11;
    };
    AnimationItem.prototype.getAssetData = function(id11) {
        var i31 = 0;
        var len11 = this.assets.length;
        while(i31 < len11){
            if (id11 === this.assets[i31].id) return this.assets[i31];
            i31 += 1;
        }
        return null;
    };
    AnimationItem.prototype.hide = function() {
        this.renderer.hide();
    };
    AnimationItem.prototype.show = function() {
        this.renderer.show();
    };
    AnimationItem.prototype.getDuration = function(isFrame11) {
        return isFrame11 ? this.totalFrames : this.totalFrames / this.frameRate;
    };
    AnimationItem.prototype.updateDocumentData = function(path11, documentData11, index11) {
        try {
            var element11 = this.renderer.getElementByPath(path11);
            element11.updateDocumentData(documentData11, index11);
        } catch (error11) {}
    };
    AnimationItem.prototype.trigger = function(name11) {
        if (this._cbs && this._cbs[name11]) switch(name11){
            case "enterFrame":
                this.triggerEvent(name11, new BMEnterFrameEvent(name11, this.currentFrame, this.totalFrames, this.frameModifier));
                break;
            case "drawnFrame":
                this.drawnFrameEvent.currentTime = this.currentFrame;
                this.drawnFrameEvent.totalTime = this.totalFrames;
                this.drawnFrameEvent.direction = this.frameModifier;
                this.triggerEvent(name11, this.drawnFrameEvent);
                break;
            case "loopComplete":
                this.triggerEvent(name11, new BMCompleteLoopEvent(name11, this.loop, this.playCount, this.frameMult));
                break;
            case "complete":
                this.triggerEvent(name11, new BMCompleteEvent(name11, this.frameMult));
                break;
            case "segmentStart":
                this.triggerEvent(name11, new BMSegmentStartEvent(name11, this.firstFrame, this.totalFrames));
                break;
            case "destroy":
                this.triggerEvent(name11, new BMDestroyEvent(name11, this));
                break;
            default:
                this.triggerEvent(name11);
        }
        if (name11 === "enterFrame" && this.onEnterFrame) this.onEnterFrame.call(this, new BMEnterFrameEvent(name11, this.currentFrame, this.totalFrames, this.frameMult));
        if (name11 === "loopComplete" && this.onLoopComplete) this.onLoopComplete.call(this, new BMCompleteLoopEvent(name11, this.loop, this.playCount, this.frameMult));
        if (name11 === "complete" && this.onComplete) this.onComplete.call(this, new BMCompleteEvent(name11, this.frameMult));
        if (name11 === "segmentStart" && this.onSegmentStart) this.onSegmentStart.call(this, new BMSegmentStartEvent(name11, this.firstFrame, this.totalFrames));
        if (name11 === "destroy" && this.onDestroy) this.onDestroy.call(this, new BMDestroyEvent(name11, this));
    };
    AnimationItem.prototype.triggerRenderFrameError = function(nativeError11) {
        var error11 = new BMRenderFrameErrorEvent(nativeError11, this.currentFrame);
        this.triggerEvent("error", error11);
        if (this.onError) this.onError.call(this, error11);
    };
    AnimationItem.prototype.triggerConfigError = function(nativeError11) {
        var error11 = new BMConfigErrorEvent(nativeError11, this.currentFrame);
        this.triggerEvent("error", error11);
        if (this.onError) this.onError.call(this, error11);
    };
    var animationManager = function() {
        var moduleOb11 = {};
        var registeredAnimations11 = [];
        var initTime11 = 0;
        var len11 = 0;
        var playingAnimationsNum11 = 0;
        var _stopped11 = true;
        var _isFrozen11 = false;
        function removeElement11(ev11) {
            var i31 = 0;
            var animItem11 = ev11.target;
            while(i31 < len11){
                if (registeredAnimations11[i31].animation === animItem11) {
                    registeredAnimations11.splice(i31, 1);
                    i31 -= 1;
                    len11 -= 1;
                    if (!animItem11.isPaused) subtractPlayingCount11();
                }
                i31 += 1;
            }
        }
        function registerAnimation11(element11, animationData11) {
            if (!element11) return null;
            var i31 = 0;
            while(i31 < len11){
                if (registeredAnimations11[i31].elem === element11 && registeredAnimations11[i31].elem !== null) return registeredAnimations11[i31].animation;
                i31 += 1;
            }
            var animItem11 = new AnimationItem();
            setupAnimation11(animItem11, element11);
            animItem11.setData(element11, animationData11);
            return animItem11;
        }
        function getRegisteredAnimations11() {
            var i31;
            var lenAnims11 = registeredAnimations11.length;
            var animations11 = [];
            for(i31 = 0; i31 < lenAnims11; i31 += 1)animations11.push(registeredAnimations11[i31].animation);
            return animations11;
        }
        function addPlayingCount11() {
            playingAnimationsNum11 += 1;
            activate11();
        }
        function subtractPlayingCount11() {
            playingAnimationsNum11 -= 1;
        }
        function setupAnimation11(animItem11, element11) {
            animItem11.addEventListener("destroy", removeElement11);
            animItem11.addEventListener("_active", addPlayingCount11);
            animItem11.addEventListener("_idle", subtractPlayingCount11);
            registeredAnimations11.push({
                elem: element11,
                animation: animItem11
            });
            len11 += 1;
        }
        function loadAnimation11(params11) {
            var animItem11 = new AnimationItem();
            setupAnimation11(animItem11, null);
            animItem11.setParams(params11);
            return animItem11;
        }
        function setSpeed11(val31, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.setSpeed(val31, animation11);
        }
        function setDirection11(val31, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.setDirection(val31, animation11);
        }
        function play11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.play(animation11);
        }
        function resume11(nowTime11) {
            var elapsedTime11 = nowTime11 - initTime11;
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.advanceTime(elapsedTime11);
            initTime11 = nowTime11;
            if (playingAnimationsNum11 && !_isFrozen11) window.requestAnimationFrame(resume11);
            else _stopped11 = true;
        }
        function first11(nowTime11) {
            initTime11 = nowTime11;
            window.requestAnimationFrame(resume11);
        }
        function pause11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.pause(animation11);
        }
        function goToAndStop11(value31, isFrame11, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.goToAndStop(value31, isFrame11, animation11);
        }
        function stop11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.stop(animation11);
        }
        function togglePause11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.togglePause(animation11);
        }
        function destroy11(animation11) {
            var i31;
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1)registeredAnimations11[i31].animation.destroy(animation11);
        }
        function searchAnimations11(animationData11, standalone11, renderer11) {
            var animElements11 = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin")));
            var i31;
            var lenAnims11 = animElements11.length;
            for(i31 = 0; i31 < lenAnims11; i31 += 1){
                if (renderer11) animElements11[i31].setAttribute("data-bm-type", renderer11);
                registerAnimation11(animElements11[i31], animationData11);
            }
            if (standalone11 && lenAnims11 === 0) {
                if (!renderer11) renderer11 = "svg";
                var body11 = document.getElementsByTagName("body")[0];
                body11.innerText = "";
                var div11 = createTag("div");
                div11.style.width = "100%";
                div11.style.height = "100%";
                div11.setAttribute("data-bm-type", renderer11);
                body11.appendChild(div11);
                registerAnimation11(div11, animationData11);
            }
        }
        function resize11() {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.resize();
        }
        function activate11() {
            if (!_isFrozen11 && playingAnimationsNum11) {
                if (_stopped11) {
                    window.requestAnimationFrame(first11);
                    _stopped11 = false;
                }
            }
        }
        function freeze11() {
            _isFrozen11 = true;
        }
        function unfreeze11() {
            _isFrozen11 = false;
            activate11();
        }
        function setVolume11(val31, animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.setVolume(val31, animation11);
        }
        function mute11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.mute(animation11);
        }
        function unmute11(animation11) {
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1)registeredAnimations11[i31].animation.unmute(animation11);
        }
        moduleOb11.registerAnimation = registerAnimation11;
        moduleOb11.loadAnimation = loadAnimation11;
        moduleOb11.setSpeed = setSpeed11;
        moduleOb11.setDirection = setDirection11;
        moduleOb11.play = play11;
        moduleOb11.pause = pause11;
        moduleOb11.stop = stop11;
        moduleOb11.togglePause = togglePause11;
        moduleOb11.searchAnimations = searchAnimations11;
        moduleOb11.resize = resize11; // moduleOb.start = start;
        moduleOb11.goToAndStop = goToAndStop11;
        moduleOb11.destroy = destroy11;
        moduleOb11.freeze = freeze11;
        moduleOb11.unfreeze = unfreeze11;
        moduleOb11.setVolume = setVolume11;
        moduleOb11.mute = mute11;
        moduleOb11.unmute = unmute11;
        moduleOb11.getRegisteredAnimations = getRegisteredAnimations11;
        return moduleOb11;
    }();
    /* eslint-disable */ var BezierFactory = function() {
        /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */ var ob11 = {};
        ob11.getBezierEasing = getBezierEasing11;
        var beziers11 = {};
        function getBezierEasing11(a31, b31, c41, d31, nm11) {
            var str11 = nm11 || ("bez_" + a31 + "_" + b31 + "_" + c41 + "_" + d31).replace(/\./g, "p");
            if (beziers11[str11]) return beziers11[str11];
            var bezEasing11 = new BezierEasing11([
                a31,
                b31,
                c41,
                d31
            ]);
            beziers11[str11] = bezEasing11;
            return bezEasing11;
        } // These values are established by empiricism with tests (tradeoff: performance VS precision)
        var NEWTON_ITERATIONS11 = 4;
        var NEWTON_MIN_SLOPE11 = 0.001;
        var SUBDIVISION_PRECISION11 = 0.0000001;
        var SUBDIVISION_MAX_ITERATIONS11 = 10;
        var kSplineTableSize11 = 11;
        var kSampleStepSize11 = 1.0 / (kSplineTableSize11 - 1.0);
        var float32ArraySupported11 = typeof Float32Array === "function";
        function A11(aA111, aA211) {
            return 1.0 - 3.0 * aA211 + 3.0 * aA111;
        }
        function B11(aA111, aA211) {
            return 3.0 * aA211 - 6.0 * aA111;
        }
        function C11(aA111) {
            return 3.0 * aA111;
        } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
        function calcBezier11(aT11, aA111, aA211) {
            return ((A11(aA111, aA211) * aT11 + B11(aA111, aA211)) * aT11 + C11(aA111)) * aT11;
        } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
        function getSlope11(aT11, aA111, aA211) {
            return 3.0 * A11(aA111, aA211) * aT11 * aT11 + 2.0 * B11(aA111, aA211) * aT11 + C11(aA111);
        }
        function binarySubdivide11(aX11, aA31, aB11, mX111, mX211) {
            var currentX11, currentT11, i31 = 0;
            do {
                currentT11 = aA31 + (aB11 - aA31) / 2.0;
                currentX11 = calcBezier11(currentT11, mX111, mX211) - aX11;
                if (currentX11 > 0.0) aB11 = currentT11;
                else aA31 = currentT11;
            }while (Math.abs(currentX11) > SUBDIVISION_PRECISION11 && ++i31 < SUBDIVISION_MAX_ITERATIONS11);
            return currentT11;
        }
        function newtonRaphsonIterate11(aX11, aGuessT11, mX111, mX211) {
            for(var i31 = 0; i31 < NEWTON_ITERATIONS11; ++i31){
                var currentSlope11 = getSlope11(aGuessT11, mX111, mX211);
                if (currentSlope11 === 0.0) return aGuessT11;
                var currentX11 = calcBezier11(aGuessT11, mX111, mX211) - aX11;
                aGuessT11 -= currentX11 / currentSlope11;
            }
            return aGuessT11;
        }
        /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */ function BezierEasing11(points11) {
            this._p = points11;
            this._mSampleValues = float32ArraySupported11 ? new Float32Array(kSplineTableSize11) : new Array(kSplineTableSize11);
            this._precomputed = false;
            this.get = this.get.bind(this);
        }
        BezierEasing11.prototype = {
            get: function get11(x41) {
                var mX111 = this._p[0], mY111 = this._p[1], mX211 = this._p[2], mY211 = this._p[3];
                if (!this._precomputed) this._precompute();
                if (mX111 === mY111 && mX211 === mY211) return x41; // linear
                // Because JavaScript number are imprecise, we should guarantee the extremes are right.
                if (x41 === 0) return 0;
                if (x41 === 1) return 1;
                return calcBezier11(this._getTForX(x41), mY111, mY211);
            },
            // Private part
            _precompute: function _precompute11() {
                var mX111 = this._p[0], mY111 = this._p[1], mX211 = this._p[2], mY211 = this._p[3];
                this._precomputed = true;
                if (mX111 !== mY111 || mX211 !== mY211) this._calcSampleValues();
            },
            _calcSampleValues: function _calcSampleValues11() {
                var mX111 = this._p[0], mX211 = this._p[2];
                for(var i31 = 0; i31 < kSplineTableSize11; ++i31)this._mSampleValues[i31] = calcBezier11(i31 * kSampleStepSize11, mX111, mX211);
            },
            /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */ _getTForX: function _getTForX11(aX11) {
                var mX111 = this._p[0], mX211 = this._p[2], mSampleValues11 = this._mSampleValues;
                var intervalStart11 = 0.0;
                var currentSample11 = 1;
                var lastSample11 = kSplineTableSize11 - 1;
                for(; currentSample11 !== lastSample11 && mSampleValues11[currentSample11] <= aX11; ++currentSample11)intervalStart11 += kSampleStepSize11;
                --currentSample11; // Interpolate to provide an initial guess for t
                var dist41 = (aX11 - mSampleValues11[currentSample11]) / (mSampleValues11[currentSample11 + 1] - mSampleValues11[currentSample11]);
                var guessForT11 = intervalStart11 + dist41 * kSampleStepSize11;
                var initialSlope11 = getSlope11(guessForT11, mX111, mX211);
                if (initialSlope11 >= NEWTON_MIN_SLOPE11) return newtonRaphsonIterate11(aX11, guessForT11, mX111, mX211);
                if (initialSlope11 === 0.0) return guessForT11;
                return binarySubdivide11(aX11, intervalStart11, intervalStart11 + kSampleStepSize11, mX111, mX211);
            }
        };
        return ob11;
    }();
    var pooling = function() {
        function _double11(arr31) {
            return arr31.concat(createSizedArray(arr31.length));
        }
        return {
            "double": _double11
        };
    }();
    var poolFactory = function() {
        return function(initialLength11, _create11, _release11) {
            var _length11 = 0;
            var _maxLength11 = initialLength11;
            var pool11 = createSizedArray(_maxLength11);
            var ob11 = {
                newElement: newElement11,
                release: release11
            };
            function newElement11() {
                var element11;
                if (_length11) {
                    _length11 -= 1;
                    element11 = pool11[_length11];
                } else element11 = _create11();
                return element11;
            }
            function release11(element11) {
                if (_length11 === _maxLength11) {
                    pool11 = pooling["double"](pool11);
                    _maxLength11 *= 2;
                }
                if (_release11) _release11(element11);
                pool11[_length11] = element11;
                _length11 += 1;
            }
            return ob11;
        };
    }();
    var bezierLengthPool = function() {
        function create11() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }
        return poolFactory(8, create11);
    }();
    var segmentsLengthPool = function() {
        function create11() {
            return {
                lengths: [],
                totalLength: 0
            };
        }
        function release11(element11) {
            var i31;
            var len11 = element11.lengths.length;
            for(i31 = 0; i31 < len11; i31 += 1)bezierLengthPool.release(element11.lengths[i31]);
            element11.lengths.length = 0;
        }
        return poolFactory(8, create11, release11);
    }();
    function bezFunction() {
        var math11 = Math;
        function pointOnLine2D11(x111, y111, x211, y211, x311, y311) {
            var det111 = x111 * y211 + y111 * x311 + x211 * y311 - x311 * y211 - y311 * x111 - x211 * y111;
            return det111 > -0.001 && det111 < 0.001;
        }
        function pointOnLine3D11(x111, y111, z111, x211, y211, z211, x311, y311, z311) {
            if (z111 === 0 && z211 === 0 && z311 === 0) return pointOnLine2D11(x111, y111, x211, y211, x311, y311);
            var dist111 = math11.sqrt(math11.pow(x211 - x111, 2) + math11.pow(y211 - y111, 2) + math11.pow(z211 - z111, 2));
            var dist211 = math11.sqrt(math11.pow(x311 - x111, 2) + math11.pow(y311 - y111, 2) + math11.pow(z311 - z111, 2));
            var dist311 = math11.sqrt(math11.pow(x311 - x211, 2) + math11.pow(y311 - y211, 2) + math11.pow(z311 - z211, 2));
            var diffDist11;
            if (dist111 > dist211) {
                if (dist111 > dist311) diffDist11 = dist111 - dist211 - dist311;
                else diffDist11 = dist311 - dist211 - dist111;
            } else if (dist311 > dist211) diffDist11 = dist311 - dist211 - dist111;
            else diffDist11 = dist211 - dist111 - dist311;
            return diffDist11 > -0.0001 && diffDist11 < 0.0001;
        }
        var getBezierLength11 = function() {
            return function(pt111, pt211, pt311, pt411) {
                var curveSegments11 = getDefaultCurveSegments();
                var k31;
                var i31;
                var len11;
                var ptCoord11;
                var perc11;
                var addedLength11 = 0;
                var ptDistance11;
                var point11 = [];
                var lastPoint11 = [];
                var lengthData11 = bezierLengthPool.newElement();
                len11 = pt311.length;
                for(k31 = 0; k31 < curveSegments11; k31 += 1){
                    perc11 = k31 / (curveSegments11 - 1);
                    ptDistance11 = 0;
                    for(i31 = 0; i31 < len11; i31 += 1){
                        ptCoord11 = bmPow(1 - perc11, 3) * pt111[i31] + 3 * bmPow(1 - perc11, 2) * perc11 * pt311[i31] + 3 * (1 - perc11) * bmPow(perc11, 2) * pt411[i31] + bmPow(perc11, 3) * pt211[i31];
                        point11[i31] = ptCoord11;
                        if (lastPoint11[i31] !== null) ptDistance11 += bmPow(point11[i31] - lastPoint11[i31], 2);
                        lastPoint11[i31] = point11[i31];
                    }
                    if (ptDistance11) {
                        ptDistance11 = bmSqrt(ptDistance11);
                        addedLength11 += ptDistance11;
                    }
                    lengthData11.percents[k31] = perc11;
                    lengthData11.lengths[k31] = addedLength11;
                }
                lengthData11.addedLength = addedLength11;
                return lengthData11;
            };
        }();
        function getSegmentsLength11(shapeData11) {
            var segmentsLength11 = segmentsLengthPool.newElement();
            var closed11 = shapeData11.c;
            var pathV11 = shapeData11.v;
            var pathO11 = shapeData11.o;
            var pathI11 = shapeData11.i;
            var i31;
            var len11 = shapeData11._length;
            var lengths11 = segmentsLength11.lengths;
            var totalLength11 = 0;
            for(i31 = 0; i31 < len11 - 1; i31 += 1){
                lengths11[i31] = getBezierLength11(pathV11[i31], pathV11[i31 + 1], pathO11[i31], pathI11[i31 + 1]);
                totalLength11 += lengths11[i31].addedLength;
            }
            if (closed11 && len11) {
                lengths11[i31] = getBezierLength11(pathV11[i31], pathV11[0], pathO11[i31], pathI11[0]);
                totalLength11 += lengths11[i31].addedLength;
            }
            segmentsLength11.totalLength = totalLength11;
            return segmentsLength11;
        }
        function BezierData11(length11) {
            this.segmentLength = 0;
            this.points = new Array(length11);
        }
        function PointData11(partial11, point11) {
            this.partialLength = partial11;
            this.point = point11;
        }
        var buildBezierData11 = function() {
            var storedData11 = {};
            return function(pt111, pt211, pt311, pt411) {
                var bezierName11 = (pt111[0] + "_" + pt111[1] + "_" + pt211[0] + "_" + pt211[1] + "_" + pt311[0] + "_" + pt311[1] + "_" + pt411[0] + "_" + pt411[1]).replace(/\./g, "p");
                if (!storedData11[bezierName11]) {
                    var curveSegments11 = getDefaultCurveSegments();
                    var k31;
                    var i31;
                    var len11;
                    var ptCoord11;
                    var perc11;
                    var addedLength11 = 0;
                    var ptDistance11;
                    var point11;
                    var lastPoint11 = null;
                    if (pt111.length === 2 && (pt111[0] !== pt211[0] || pt111[1] !== pt211[1]) && pointOnLine2D11(pt111[0], pt111[1], pt211[0], pt211[1], pt111[0] + pt311[0], pt111[1] + pt311[1]) && pointOnLine2D11(pt111[0], pt111[1], pt211[0], pt211[1], pt211[0] + pt411[0], pt211[1] + pt411[1])) curveSegments11 = 2;
                    var bezierData11 = new BezierData11(curveSegments11);
                    len11 = pt311.length;
                    for(k31 = 0; k31 < curveSegments11; k31 += 1){
                        point11 = createSizedArray(len11);
                        perc11 = k31 / (curveSegments11 - 1);
                        ptDistance11 = 0;
                        for(i31 = 0; i31 < len11; i31 += 1){
                            ptCoord11 = bmPow(1 - perc11, 3) * pt111[i31] + 3 * bmPow(1 - perc11, 2) * perc11 * (pt111[i31] + pt311[i31]) + 3 * (1 - perc11) * bmPow(perc11, 2) * (pt211[i31] + pt411[i31]) + bmPow(perc11, 3) * pt211[i31];
                            point11[i31] = ptCoord11;
                            if (lastPoint11 !== null) ptDistance11 += bmPow(point11[i31] - lastPoint11[i31], 2);
                        }
                        ptDistance11 = bmSqrt(ptDistance11);
                        addedLength11 += ptDistance11;
                        bezierData11.points[k31] = new PointData11(ptDistance11, point11);
                        lastPoint11 = point11;
                    }
                    bezierData11.segmentLength = addedLength11;
                    storedData11[bezierName11] = bezierData11;
                }
                return storedData11[bezierName11];
            };
        }();
        function getDistancePerc11(perc11, bezierData11) {
            var percents11 = bezierData11.percents;
            var lengths11 = bezierData11.lengths;
            var len11 = percents11.length;
            var initPos11 = bmFloor((len11 - 1) * perc11);
            var lengthPos11 = perc11 * bezierData11.addedLength;
            var lPerc11 = 0;
            if (initPos11 === len11 - 1 || initPos11 === 0 || lengthPos11 === lengths11[initPos11]) return percents11[initPos11];
            var dir11 = lengths11[initPos11] > lengthPos11 ? -1 : 1;
            var flag11 = true;
            while(flag11){
                if (lengths11[initPos11] <= lengthPos11 && lengths11[initPos11 + 1] > lengthPos11) {
                    lPerc11 = (lengthPos11 - lengths11[initPos11]) / (lengths11[initPos11 + 1] - lengths11[initPos11]);
                    flag11 = false;
                } else initPos11 += dir11;
                if (initPos11 < 0 || initPos11 >= len11 - 1) {
                    // FIX for TypedArrays that don't store floating point values with enough accuracy
                    if (initPos11 === len11 - 1) return percents11[initPos11];
                    flag11 = false;
                }
            }
            return percents11[initPos11] + (percents11[initPos11 + 1] - percents11[initPos11]) * lPerc11;
        }
        function getPointInSegment11(pt111, pt211, pt311, pt411, percent11, bezierData11) {
            var t111 = getDistancePerc11(percent11, bezierData11);
            var u111 = 1 - t111;
            var ptX11 = math11.round((u111 * u111 * u111 * pt111[0] + (t111 * u111 * u111 + u111 * t111 * u111 + u111 * u111 * t111) * pt311[0] + (t111 * t111 * u111 + u111 * t111 * t111 + t111 * u111 * t111) * pt411[0] + t111 * t111 * t111 * pt211[0]) * 1000) / 1000;
            var ptY11 = math11.round((u111 * u111 * u111 * pt111[1] + (t111 * u111 * u111 + u111 * t111 * u111 + u111 * u111 * t111) * pt311[1] + (t111 * t111 * u111 + u111 * t111 * t111 + t111 * u111 * t111) * pt411[1] + t111 * t111 * t111 * pt211[1]) * 1000) / 1000;
            return [
                ptX11,
                ptY11
            ];
        }
        var bezierSegmentPoints11 = createTypedArray("float32", 8);
        function getNewSegment11(pt111, pt211, pt311, pt411, startPerc11, endPerc11, bezierData11) {
            if (startPerc11 < 0) startPerc11 = 0;
            else if (startPerc11 > 1) startPerc11 = 1;
            var t011 = getDistancePerc11(startPerc11, bezierData11);
            endPerc11 = endPerc11 > 1 ? 1 : endPerc11;
            var t111 = getDistancePerc11(endPerc11, bezierData11);
            var i31;
            var len11 = pt111.length;
            var u011 = 1 - t011;
            var u111 = 1 - t111;
            var u0u0u011 = u011 * u011 * u011;
            var t0u0u0_311 = t011 * u011 * u011 * 3; // eslint-disable-line camelcase
            var t0t0u0_311 = t011 * t011 * u011 * 3; // eslint-disable-line camelcase
            var t0t0t011 = t011 * t011 * t011; //
            var u0u0u111 = u011 * u011 * u111;
            var t0u0u1_311 = t011 * u011 * u111 + u011 * t011 * u111 + u011 * u011 * t111; // eslint-disable-line camelcase
            var t0t0u1_311 = t011 * t011 * u111 + u011 * t011 * t111 + t011 * u011 * t111; // eslint-disable-line camelcase
            var t0t0t111 = t011 * t011 * t111; //
            var u0u1u111 = u011 * u111 * u111;
            var t0u1u1_311 = t011 * u111 * u111 + u011 * t111 * u111 + u011 * u111 * t111; // eslint-disable-line camelcase
            var t0t1u1_311 = t011 * t111 * u111 + u011 * t111 * t111 + t011 * u111 * t111; // eslint-disable-line camelcase
            var t0t1t111 = t011 * t111 * t111; //
            var u1u1u111 = u111 * u111 * u111;
            var t1u1u1_311 = t111 * u111 * u111 + u111 * t111 * u111 + u111 * u111 * t111; // eslint-disable-line camelcase
            var t1t1u1_311 = t111 * t111 * u111 + u111 * t111 * t111 + t111 * u111 * t111; // eslint-disable-line camelcase
            var t1t1t111 = t111 * t111 * t111;
            for(i31 = 0; i31 < len11; i31 += 1){
                bezierSegmentPoints11[i31 * 4] = math11.round((u0u0u011 * pt111[i31] + t0u0u0_311 * pt311[i31] + t0t0u0_311 * pt411[i31] + t0t0t011 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints11[i31 * 4 + 1] = math11.round((u0u0u111 * pt111[i31] + t0u0u1_311 * pt311[i31] + t0t0u1_311 * pt411[i31] + t0t0t111 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints11[i31 * 4 + 2] = math11.round((u0u1u111 * pt111[i31] + t0u1u1_311 * pt311[i31] + t0t1u1_311 * pt411[i31] + t0t1t111 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
                bezierSegmentPoints11[i31 * 4 + 3] = math11.round((u1u1u111 * pt111[i31] + t1u1u1_311 * pt311[i31] + t1t1u1_311 * pt411[i31] + t1t1t111 * pt211[i31]) * 1000) / 1000; // eslint-disable-line camelcase
            }
            return bezierSegmentPoints11;
        }
        return {
            getSegmentsLength: getSegmentsLength11,
            getNewSegment: getNewSegment11,
            getPointInSegment: getPointInSegment11,
            buildBezierData: buildBezierData11,
            pointOnLine2D: pointOnLine2D11,
            pointOnLine3D: pointOnLine3D11
        };
    }
    var bez = bezFunction();
    var initFrame = initialDefaultFrame;
    var mathAbs = Math.abs;
    function interpolateValue(frameNum11, caching11) {
        var offsetTime11 = this.offsetTime;
        var newValue11;
        if (this.propType === "multidimensional") newValue11 = createTypedArray("float32", this.pv.length);
        var iterationIndex11 = caching11.lastIndex;
        var i31 = iterationIndex11;
        var len11 = this.keyframes.length - 1;
        var flag11 = true;
        var keyData11;
        var nextKeyData11;
        var keyframeMetadata11;
        while(flag11){
            keyData11 = this.keyframes[i31];
            nextKeyData11 = this.keyframes[i31 + 1];
            if (i31 === len11 - 1 && frameNum11 >= nextKeyData11.t - offsetTime11) {
                if (keyData11.h) keyData11 = nextKeyData11;
                iterationIndex11 = 0;
                break;
            }
            if (nextKeyData11.t - offsetTime11 > frameNum11) {
                iterationIndex11 = i31;
                break;
            }
            if (i31 < len11 - 1) i31 += 1;
            else {
                iterationIndex11 = 0;
                flag11 = false;
            }
        }
        keyframeMetadata11 = this.keyframesMetadata[i31] || {};
        var k31;
        var kLen11;
        var perc11;
        var jLen11;
        var j31;
        var fnc11;
        var nextKeyTime11 = nextKeyData11.t - offsetTime11;
        var keyTime11 = keyData11.t - offsetTime11;
        var endValue11;
        if (keyData11.to) {
            if (!keyframeMetadata11.bezierData) keyframeMetadata11.bezierData = bez.buildBezierData(keyData11.s, nextKeyData11.s || keyData11.e, keyData11.to, keyData11.ti);
            var bezierData11 = keyframeMetadata11.bezierData;
            if (frameNum11 >= nextKeyTime11 || frameNum11 < keyTime11) {
                var ind11 = frameNum11 >= nextKeyTime11 ? bezierData11.points.length - 1 : 0;
                kLen11 = bezierData11.points[ind11].point.length;
                for(k31 = 0; k31 < kLen11; k31 += 1)newValue11[k31] = bezierData11.points[ind11].point[k31];
                 // caching._lastKeyframeIndex = -1;
            } else {
                if (keyframeMetadata11.__fnct) fnc11 = keyframeMetadata11.__fnct;
                else {
                    fnc11 = BezierFactory.getBezierEasing(keyData11.o.x, keyData11.o.y, keyData11.i.x, keyData11.i.y, keyData11.n).get;
                    keyframeMetadata11.__fnct = fnc11;
                }
                perc11 = fnc11((frameNum11 - keyTime11) / (nextKeyTime11 - keyTime11));
                var distanceInLine11 = bezierData11.segmentLength * perc11;
                var segmentPerc11;
                var addedLength11 = caching11.lastFrame < frameNum11 && caching11._lastKeyframeIndex === i31 ? caching11._lastAddedLength : 0;
                j31 = caching11.lastFrame < frameNum11 && caching11._lastKeyframeIndex === i31 ? caching11._lastPoint : 0;
                flag11 = true;
                jLen11 = bezierData11.points.length;
                while(flag11){
                    addedLength11 += bezierData11.points[j31].partialLength;
                    if (distanceInLine11 === 0 || perc11 === 0 || j31 === bezierData11.points.length - 1) {
                        kLen11 = bezierData11.points[j31].point.length;
                        for(k31 = 0; k31 < kLen11; k31 += 1)newValue11[k31] = bezierData11.points[j31].point[k31];
                        break;
                    } else if (distanceInLine11 >= addedLength11 && distanceInLine11 < addedLength11 + bezierData11.points[j31 + 1].partialLength) {
                        segmentPerc11 = (distanceInLine11 - addedLength11) / bezierData11.points[j31 + 1].partialLength;
                        kLen11 = bezierData11.points[j31].point.length;
                        for(k31 = 0; k31 < kLen11; k31 += 1)newValue11[k31] = bezierData11.points[j31].point[k31] + (bezierData11.points[j31 + 1].point[k31] - bezierData11.points[j31].point[k31]) * segmentPerc11;
                        break;
                    }
                    if (j31 < jLen11 - 1) j31 += 1;
                    else flag11 = false;
                }
                caching11._lastPoint = j31;
                caching11._lastAddedLength = addedLength11 - bezierData11.points[j31].partialLength;
                caching11._lastKeyframeIndex = i31;
            }
        } else {
            var outX11;
            var outY11;
            var inX11;
            var inY11;
            var keyValue11;
            len11 = keyData11.s.length;
            endValue11 = nextKeyData11.s || keyData11.e;
            if (this.sh && keyData11.h !== 1) {
                if (frameNum11 >= nextKeyTime11) {
                    newValue11[0] = endValue11[0];
                    newValue11[1] = endValue11[1];
                    newValue11[2] = endValue11[2];
                } else if (frameNum11 <= keyTime11) {
                    newValue11[0] = keyData11.s[0];
                    newValue11[1] = keyData11.s[1];
                    newValue11[2] = keyData11.s[2];
                } else {
                    var quatStart11 = createQuaternion(keyData11.s);
                    var quatEnd11 = createQuaternion(endValue11);
                    var time11 = (frameNum11 - keyTime11) / (nextKeyTime11 - keyTime11);
                    quaternionToEuler(newValue11, slerp(quatStart11, quatEnd11, time11));
                }
            } else for(i31 = 0; i31 < len11; i31 += 1){
                if (keyData11.h !== 1) {
                    if (frameNum11 >= nextKeyTime11) perc11 = 1;
                    else if (frameNum11 < keyTime11) perc11 = 0;
                    else {
                        if (keyData11.o.x.constructor === Array) {
                            if (!keyframeMetadata11.__fnct) keyframeMetadata11.__fnct = [];
                            if (!keyframeMetadata11.__fnct[i31]) {
                                outX11 = keyData11.o.x[i31] === undefined ? keyData11.o.x[0] : keyData11.o.x[i31];
                                outY11 = keyData11.o.y[i31] === undefined ? keyData11.o.y[0] : keyData11.o.y[i31];
                                inX11 = keyData11.i.x[i31] === undefined ? keyData11.i.x[0] : keyData11.i.x[i31];
                                inY11 = keyData11.i.y[i31] === undefined ? keyData11.i.y[0] : keyData11.i.y[i31];
                                fnc11 = BezierFactory.getBezierEasing(outX11, outY11, inX11, inY11).get;
                                keyframeMetadata11.__fnct[i31] = fnc11;
                            } else fnc11 = keyframeMetadata11.__fnct[i31];
                        } else if (!keyframeMetadata11.__fnct) {
                            outX11 = keyData11.o.x;
                            outY11 = keyData11.o.y;
                            inX11 = keyData11.i.x;
                            inY11 = keyData11.i.y;
                            fnc11 = BezierFactory.getBezierEasing(outX11, outY11, inX11, inY11).get;
                            keyData11.keyframeMetadata = fnc11;
                        } else fnc11 = keyframeMetadata11.__fnct;
                        perc11 = fnc11((frameNum11 - keyTime11) / (nextKeyTime11 - keyTime11));
                    }
                }
                endValue11 = nextKeyData11.s || keyData11.e;
                keyValue11 = keyData11.h === 1 ? keyData11.s[i31] : keyData11.s[i31] + (endValue11[i31] - keyData11.s[i31]) * perc11;
                if (this.propType === "multidimensional") newValue11[i31] = keyValue11;
                else newValue11 = keyValue11;
            }
        }
        caching11.lastIndex = iterationIndex11;
        return newValue11;
    } // based on @Toji's https://github.com/toji/gl-matrix/
    function slerp(a31, b31, t31) {
        var out11 = [];
        var ax11 = a31[0];
        var ay11 = a31[1];
        var az11 = a31[2];
        var aw11 = a31[3];
        var bx11 = b31[0];
        var by11 = b31[1];
        var bz11 = b31[2];
        var bw11 = b31[3];
        var omega11;
        var cosom11;
        var sinom11;
        var scale011;
        var scale111;
        cosom11 = ax11 * bx11 + ay11 * by11 + az11 * bz11 + aw11 * bw11;
        if (cosom11 < 0.0) {
            cosom11 = -cosom11;
            bx11 = -bx11;
            by11 = -by11;
            bz11 = -bz11;
            bw11 = -bw11;
        }
        if (1.0 - cosom11 > 0.000001) {
            omega11 = Math.acos(cosom11);
            sinom11 = Math.sin(omega11);
            scale011 = Math.sin((1.0 - t31) * omega11) / sinom11;
            scale111 = Math.sin(t31 * omega11) / sinom11;
        } else {
            scale011 = 1.0 - t31;
            scale111 = t31;
        }
        out11[0] = scale011 * ax11 + scale111 * bx11;
        out11[1] = scale011 * ay11 + scale111 * by11;
        out11[2] = scale011 * az11 + scale111 * bz11;
        out11[3] = scale011 * aw11 + scale111 * bw11;
        return out11;
    }
    function quaternionToEuler(out11, quat11) {
        var qx11 = quat11[0];
        var qy11 = quat11[1];
        var qz11 = quat11[2];
        var qw11 = quat11[3];
        var heading11 = Math.atan2(2 * qy11 * qw11 - 2 * qx11 * qz11, 1 - 2 * qy11 * qy11 - 2 * qz11 * qz11);
        var attitude11 = Math.asin(2 * qx11 * qy11 + 2 * qz11 * qw11);
        var bank11 = Math.atan2(2 * qx11 * qw11 - 2 * qy11 * qz11, 1 - 2 * qx11 * qx11 - 2 * qz11 * qz11);
        out11[0] = heading11 / degToRads;
        out11[1] = attitude11 / degToRads;
        out11[2] = bank11 / degToRads;
    }
    function createQuaternion(values11) {
        var heading11 = values11[0] * degToRads;
        var attitude11 = values11[1] * degToRads;
        var bank11 = values11[2] * degToRads;
        var c111 = Math.cos(heading11 / 2);
        var c211 = Math.cos(attitude11 / 2);
        var c311 = Math.cos(bank11 / 2);
        var s111 = Math.sin(heading11 / 2);
        var s211 = Math.sin(attitude11 / 2);
        var s311 = Math.sin(bank11 / 2);
        var w11 = c111 * c211 * c311 - s111 * s211 * s311;
        var x41 = s111 * s211 * c311 + c111 * c211 * s311;
        var y41 = s111 * c211 * c311 + c111 * s211 * s311;
        var z41 = c111 * s211 * c311 - s111 * c211 * s311;
        return [
            x41,
            y41,
            z41,
            w11
        ];
    }
    function getValueAtCurrentTime() {
        var frameNum11 = this.comp.renderedFrame - this.offsetTime;
        var initTime11 = this.keyframes[0].t - this.offsetTime;
        var endTime11 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
        if (!(frameNum11 === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime11 && frameNum11 >= endTime11 || this._caching.lastFrame < initTime11 && frameNum11 < initTime11))) {
            if (this._caching.lastFrame >= frameNum11) {
                this._caching._lastKeyframeIndex = -1;
                this._caching.lastIndex = 0;
            }
            var renderResult11 = this.interpolateValue(frameNum11, this._caching);
            this.pv = renderResult11;
        }
        this._caching.lastFrame = frameNum11;
        return this.pv;
    }
    function setVValue(val31) {
        var multipliedValue11;
        if (this.propType === "unidimensional") {
            multipliedValue11 = val31 * this.mult;
            if (mathAbs(this.v - multipliedValue11) > 0.00001) {
                this.v = multipliedValue11;
                this._mdf = true;
            }
        } else {
            var i31 = 0;
            var len11 = this.v.length;
            while(i31 < len11){
                multipliedValue11 = val31[i31] * this.mult;
                if (mathAbs(this.v[i31] - multipliedValue11) > 0.00001) {
                    this.v[i31] = multipliedValue11;
                    this._mdf = true;
                }
                i31 += 1;
            }
        }
    }
    function processEffectsSequence() {
        if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) return;
        if (this.lock) {
            this.setVValue(this.pv);
            return;
        }
        this.lock = true;
        this._mdf = this._isFirstFrame;
        var i31;
        var len11 = this.effectsSequence.length;
        var finalValue11 = this.kf ? this.pv : this.data.k;
        for(i31 = 0; i31 < len11; i31 += 1)finalValue11 = this.effectsSequence[i31](finalValue11);
        this.setVValue(finalValue11);
        this._isFirstFrame = false;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    }
    function addEffect(effectFunction11) {
        this.effectsSequence.push(effectFunction11);
        this.container.addDynamicProperty(this);
    }
    function ValueProperty(elem31, data11, mult11, container11) {
        this.propType = "unidimensional";
        this.mult = mult11 || 1;
        this.data = data11;
        this.v = mult11 ? data11.k * mult11 : data11.k;
        this.pv = data11.k;
        this._mdf = false;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.k = false;
        this.kf = false;
        this.vel = 0;
        this.effectsSequence = [];
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(elem31, data11, mult11, container11) {
        this.propType = "multidimensional";
        this.mult = mult11 || 1;
        this.data = data11;
        this._mdf = false;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.k = false;
        this.kf = false;
        this.frameId = -1;
        var i31;
        var len11 = data11.k.length;
        this.v = createTypedArray("float32", len11);
        this.pv = createTypedArray("float32", len11);
        this.vel = createTypedArray("float32", len11);
        for(i31 = 0; i31 < len11; i31 += 1){
            this.v[i31] = data11.k[i31] * this.mult;
            this.pv[i31] = data11.k[i31];
        }
        this._isFirstFrame = true;
        this.effectsSequence = [];
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.addEffect = addEffect;
    }
    function KeyframedValueProperty(elem31, data11, mult11, container11) {
        this.propType = "unidimensional";
        this.keyframes = data11.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem31.data.st;
        this.frameId = -1;
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: 0,
            _lastKeyframeIndex: -1
        };
        this.k = true;
        this.kf = true;
        this.data = data11;
        this.mult = mult11 || 1;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.v = initFrame;
        this.pv = initFrame;
        this._isFirstFrame = true;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(elem31, data11, mult11, container11) {
        this.propType = "multidimensional";
        var i31;
        var len11 = data11.k.length;
        var s41;
        var e31;
        var to11;
        var ti11;
        for(i31 = 0; i31 < len11 - 1; i31 += 1)if (data11.k[i31].to && data11.k[i31].s && data11.k[i31 + 1] && data11.k[i31 + 1].s) {
            s41 = data11.k[i31].s;
            e31 = data11.k[i31 + 1].s;
            to11 = data11.k[i31].to;
            ti11 = data11.k[i31].ti;
            if (s41.length === 2 && !(s41[0] === e31[0] && s41[1] === e31[1]) && bez.pointOnLine2D(s41[0], s41[1], e31[0], e31[1], s41[0] + to11[0], s41[1] + to11[1]) && bez.pointOnLine2D(s41[0], s41[1], e31[0], e31[1], e31[0] + ti11[0], e31[1] + ti11[1]) || s41.length === 3 && !(s41[0] === e31[0] && s41[1] === e31[1] && s41[2] === e31[2]) && bez.pointOnLine3D(s41[0], s41[1], s41[2], e31[0], e31[1], e31[2], s41[0] + to11[0], s41[1] + to11[1], s41[2] + to11[2]) && bez.pointOnLine3D(s41[0], s41[1], s41[2], e31[0], e31[1], e31[2], e31[0] + ti11[0], e31[1] + ti11[1], e31[2] + ti11[2])) {
                data11.k[i31].to = null;
                data11.k[i31].ti = null;
            }
            if (s41[0] === e31[0] && s41[1] === e31[1] && to11[0] === 0 && to11[1] === 0 && ti11[0] === 0 && ti11[1] === 0) {
                if (s41.length === 2 || s41[2] === e31[2] && to11[2] === 0 && ti11[2] === 0) {
                    data11.k[i31].to = null;
                    data11.k[i31].ti = null;
                }
            }
        }
        this.effectsSequence = [
            getValueAtCurrentTime.bind(this)
        ];
        this.data = data11;
        this.keyframes = data11.k;
        this.keyframesMetadata = [];
        this.offsetTime = elem31.data.st;
        this.k = true;
        this.kf = true;
        this._isFirstFrame = true;
        this.mult = mult11 || 1;
        this.elem = elem31;
        this.container = container11;
        this.comp = elem31.comp;
        this.getValue = processEffectsSequence;
        this.setVValue = setVValue;
        this.interpolateValue = interpolateValue;
        this.frameId = -1;
        var arrLen11 = data11.k[0].s.length;
        this.v = createTypedArray("float32", arrLen11);
        this.pv = createTypedArray("float32", arrLen11);
        for(i31 = 0; i31 < arrLen11; i31 += 1){
            this.v[i31] = initFrame;
            this.pv[i31] = initFrame;
        }
        this._caching = {
            lastFrame: initFrame,
            lastIndex: 0,
            value: createTypedArray("float32", arrLen11)
        };
        this.addEffect = addEffect;
    }
    var PropertyFactory = function() {
        function getProp11(elem31, data11, type11, mult11, container11) {
            if (data11.sid) data11 = elem31.globalData.slotManager.getProp(data11);
            var p61;
            if (!data11.k.length) p61 = new ValueProperty(elem31, data11, mult11, container11);
            else if (typeof data11.k[0] === "number") p61 = new MultiDimensionalProperty(elem31, data11, mult11, container11);
            else switch(type11){
                case 0:
                    p61 = new KeyframedValueProperty(elem31, data11, mult11, container11);
                    break;
                case 1:
                    p61 = new KeyframedMultidimensionalProperty(elem31, data11, mult11, container11);
                    break;
                default:
                    break;
            }
            if (p61.effectsSequence.length) container11.addDynamicProperty(p61);
            return p61;
        }
        var ob11 = {
            getProp: getProp11
        };
        return ob11;
    }();
    function DynamicPropertyContainer() {}
    DynamicPropertyContainer.prototype = {
        addDynamicProperty: function addDynamicProperty11(prop11) {
            if (this.dynamicProperties.indexOf(prop11) === -1) {
                this.dynamicProperties.push(prop11);
                this.container.addDynamicProperty(this);
                this._isAnimated = true;
            }
        },
        iterateDynamicProperties: function iterateDynamicProperties11() {
            this._mdf = false;
            var i31;
            var len11 = this.dynamicProperties.length;
            for(i31 = 0; i31 < len11; i31 += 1){
                this.dynamicProperties[i31].getValue();
                if (this.dynamicProperties[i31]._mdf) this._mdf = true;
            }
        },
        initDynamicPropertyContainer: function initDynamicPropertyContainer11(container11) {
            this.container = container11;
            this.dynamicProperties = [];
            this._mdf = false;
            this._isAnimated = false;
        }
    };
    var pointPool = function() {
        function create11() {
            return createTypedArray("float32", 2);
        }
        return poolFactory(8, create11);
    }();
    function ShapePath() {
        this.c = false;
        this._length = 0;
        this._maxLength = 8;
        this.v = createSizedArray(this._maxLength);
        this.o = createSizedArray(this._maxLength);
        this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(closed11, len11) {
        this.c = closed11;
        this.setLength(len11);
        var i31 = 0;
        while(i31 < len11){
            this.v[i31] = pointPool.newElement();
            this.o[i31] = pointPool.newElement();
            this.i[i31] = pointPool.newElement();
            i31 += 1;
        }
    };
    ShapePath.prototype.setLength = function(len11) {
        while(this._maxLength < len11)this.doubleArrayLength();
        this._length = len11;
    };
    ShapePath.prototype.doubleArrayLength = function() {
        this.v = this.v.concat(createSizedArray(this._maxLength));
        this.i = this.i.concat(createSizedArray(this._maxLength));
        this.o = this.o.concat(createSizedArray(this._maxLength));
        this._maxLength *= 2;
    };
    ShapePath.prototype.setXYAt = function(x41, y41, type11, pos11, replace11) {
        var arr31;
        this._length = Math.max(this._length, pos11 + 1);
        if (this._length >= this._maxLength) this.doubleArrayLength();
        switch(type11){
            case "v":
                arr31 = this.v;
                break;
            case "i":
                arr31 = this.i;
                break;
            case "o":
                arr31 = this.o;
                break;
            default:
                arr31 = [];
                break;
        }
        if (!arr31[pos11] || arr31[pos11] && !replace11) arr31[pos11] = pointPool.newElement();
        arr31[pos11][0] = x41;
        arr31[pos11][1] = y41;
    };
    ShapePath.prototype.setTripleAt = function(vX11, vY11, oX11, oY11, iX11, iY11, pos11, replace11) {
        this.setXYAt(vX11, vY11, "v", pos11, replace11);
        this.setXYAt(oX11, oY11, "o", pos11, replace11);
        this.setXYAt(iX11, iY11, "i", pos11, replace11);
    };
    ShapePath.prototype.reverse = function() {
        var newPath11 = new ShapePath();
        newPath11.setPathData(this.c, this._length);
        var vertices11 = this.v;
        var outPoints11 = this.o;
        var inPoints11 = this.i;
        var init11 = 0;
        if (this.c) {
            newPath11.setTripleAt(vertices11[0][0], vertices11[0][1], inPoints11[0][0], inPoints11[0][1], outPoints11[0][0], outPoints11[0][1], 0, false);
            init11 = 1;
        }
        var cnt11 = this._length - 1;
        var len11 = this._length;
        var i31;
        for(i31 = init11; i31 < len11; i31 += 1){
            newPath11.setTripleAt(vertices11[cnt11][0], vertices11[cnt11][1], inPoints11[cnt11][0], inPoints11[cnt11][1], outPoints11[cnt11][0], outPoints11[cnt11][1], i31, false);
            cnt11 -= 1;
        }
        return newPath11;
    };
    ShapePath.prototype.length = function() {
        return this._length;
    };
    var shapePool = function() {
        function create11() {
            return new ShapePath();
        }
        function release11(shapePath11) {
            var len11 = shapePath11._length;
            var i31;
            for(i31 = 0; i31 < len11; i31 += 1){
                pointPool.release(shapePath11.v[i31]);
                pointPool.release(shapePath11.i[i31]);
                pointPool.release(shapePath11.o[i31]);
                shapePath11.v[i31] = null;
                shapePath11.i[i31] = null;
                shapePath11.o[i31] = null;
            }
            shapePath11._length = 0;
            shapePath11.c = false;
        }
        function clone11(shape31) {
            var cloned11 = factory11.newElement();
            var i31;
            var len11 = shape31._length === undefined ? shape31.v.length : shape31._length;
            cloned11.setLength(len11);
            cloned11.c = shape31.c;
            for(i31 = 0; i31 < len11; i31 += 1)cloned11.setTripleAt(shape31.v[i31][0], shape31.v[i31][1], shape31.o[i31][0], shape31.o[i31][1], shape31.i[i31][0], shape31.i[i31][1], i31);
            return cloned11;
        }
        var factory11 = poolFactory(4, create11, release11);
        factory11.clone = clone11;
        return factory11;
    }();
    function ShapeCollection() {
        this._length = 0;
        this._maxLength = 4;
        this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(shapeData11) {
        if (this._length === this._maxLength) {
            this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
            this._maxLength *= 2;
        }
        this.shapes[this._length] = shapeData11;
        this._length += 1;
    };
    ShapeCollection.prototype.releaseShapes = function() {
        var i31;
        for(i31 = 0; i31 < this._length; i31 += 1)shapePool.release(this.shapes[i31]);
        this._length = 0;
    };
    var shapeCollectionPool = function() {
        var ob11 = {
            newShapeCollection: newShapeCollection11,
            release: release11
        };
        var _length11 = 0;
        var _maxLength11 = 4;
        var pool11 = createSizedArray(_maxLength11);
        function newShapeCollection11() {
            var shapeCollection11;
            if (_length11) {
                _length11 -= 1;
                shapeCollection11 = pool11[_length11];
            } else shapeCollection11 = new ShapeCollection();
            return shapeCollection11;
        }
        function release11(shapeCollection11) {
            var i31;
            var len11 = shapeCollection11._length;
            for(i31 = 0; i31 < len11; i31 += 1)shapePool.release(shapeCollection11.shapes[i31]);
            shapeCollection11._length = 0;
            if (_length11 === _maxLength11) {
                pool11 = pooling["double"](pool11);
                _maxLength11 *= 2;
            }
            pool11[_length11] = shapeCollection11;
            _length11 += 1;
        }
        return ob11;
    }();
    var ShapePropertyFactory = function() {
        var initFrame11 = -999999;
        function interpolateShape11(frameNum11, previousValue11, caching11) {
            var iterationIndex11 = caching11.lastIndex;
            var keyPropS11;
            var keyPropE11;
            var isHold11;
            var j31;
            var k31;
            var jLen11;
            var kLen11;
            var perc11;
            var vertexValue11;
            var kf11 = this.keyframes;
            if (frameNum11 < kf11[0].t - this.offsetTime) {
                keyPropS11 = kf11[0].s[0];
                isHold11 = true;
                iterationIndex11 = 0;
            } else if (frameNum11 >= kf11[kf11.length - 1].t - this.offsetTime) {
                keyPropS11 = kf11[kf11.length - 1].s ? kf11[kf11.length - 1].s[0] : kf11[kf11.length - 2].e[0];
                /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */ isHold11 = true;
            } else {
                var i31 = iterationIndex11;
                var len11 = kf11.length - 1;
                var flag11 = true;
                var keyData11;
                var nextKeyData11;
                var keyframeMetadata11;
                while(flag11){
                    keyData11 = kf11[i31];
                    nextKeyData11 = kf11[i31 + 1];
                    if (nextKeyData11.t - this.offsetTime > frameNum11) break;
                    if (i31 < len11 - 1) i31 += 1;
                    else flag11 = false;
                }
                keyframeMetadata11 = this.keyframesMetadata[i31] || {};
                isHold11 = keyData11.h === 1;
                iterationIndex11 = i31;
                if (!isHold11) {
                    if (frameNum11 >= nextKeyData11.t - this.offsetTime) perc11 = 1;
                    else if (frameNum11 < keyData11.t - this.offsetTime) perc11 = 0;
                    else {
                        var fnc11;
                        if (keyframeMetadata11.__fnct) fnc11 = keyframeMetadata11.__fnct;
                        else {
                            fnc11 = BezierFactory.getBezierEasing(keyData11.o.x, keyData11.o.y, keyData11.i.x, keyData11.i.y).get;
                            keyframeMetadata11.__fnct = fnc11;
                        }
                        perc11 = fnc11((frameNum11 - (keyData11.t - this.offsetTime)) / (nextKeyData11.t - this.offsetTime - (keyData11.t - this.offsetTime)));
                    }
                    keyPropE11 = nextKeyData11.s ? nextKeyData11.s[0] : keyData11.e[0];
                }
                keyPropS11 = keyData11.s[0];
            }
            jLen11 = previousValue11._length;
            kLen11 = keyPropS11.i[0].length;
            caching11.lastIndex = iterationIndex11;
            for(j31 = 0; j31 < jLen11; j31 += 1)for(k31 = 0; k31 < kLen11; k31 += 1){
                vertexValue11 = isHold11 ? keyPropS11.i[j31][k31] : keyPropS11.i[j31][k31] + (keyPropE11.i[j31][k31] - keyPropS11.i[j31][k31]) * perc11;
                previousValue11.i[j31][k31] = vertexValue11;
                vertexValue11 = isHold11 ? keyPropS11.o[j31][k31] : keyPropS11.o[j31][k31] + (keyPropE11.o[j31][k31] - keyPropS11.o[j31][k31]) * perc11;
                previousValue11.o[j31][k31] = vertexValue11;
                vertexValue11 = isHold11 ? keyPropS11.v[j31][k31] : keyPropS11.v[j31][k31] + (keyPropE11.v[j31][k31] - keyPropS11.v[j31][k31]) * perc11;
                previousValue11.v[j31][k31] = vertexValue11;
            }
        }
        function interpolateShapeCurrentTime11() {
            var frameNum11 = this.comp.renderedFrame - this.offsetTime;
            var initTime11 = this.keyframes[0].t - this.offsetTime;
            var endTime11 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            var lastFrame11 = this._caching.lastFrame;
            if (!(lastFrame11 !== initFrame11 && (lastFrame11 < initTime11 && frameNum11 < initTime11 || lastFrame11 > endTime11 && frameNum11 > endTime11))) {
                /// /
                this._caching.lastIndex = lastFrame11 < frameNum11 ? this._caching.lastIndex : 0;
                this.interpolateShape(frameNum11, this.pv, this._caching); /// /
            }
            this._caching.lastFrame = frameNum11;
            return this.pv;
        }
        function resetShape11() {
            this.paths = this.localShapeCollection;
        }
        function shapesEqual11(shape111, shape211) {
            if (shape111._length !== shape211._length || shape111.c !== shape211.c) return false;
            var i31;
            var len11 = shape111._length;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (shape111.v[i31][0] !== shape211.v[i31][0] || shape111.v[i31][1] !== shape211.v[i31][1] || shape111.o[i31][0] !== shape211.o[i31][0] || shape111.o[i31][1] !== shape211.o[i31][1] || shape111.i[i31][0] !== shape211.i[i31][0] || shape111.i[i31][1] !== shape211.i[i31][1]) return false;
            }
            return true;
        }
        function setVValue11(newPath11) {
            if (!shapesEqual11(this.v, newPath11)) {
                this.v = shapePool.clone(newPath11);
                this.localShapeCollection.releaseShapes();
                this.localShapeCollection.addShape(this.v);
                this._mdf = true;
                this.paths = this.localShapeCollection;
            }
        }
        function processEffectsSequence11() {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (!this.effectsSequence.length) {
                this._mdf = false;
                return;
            }
            if (this.lock) {
                this.setVValue(this.pv);
                return;
            }
            this.lock = true;
            this._mdf = false;
            var finalValue11;
            if (this.kf) finalValue11 = this.pv;
            else if (this.data.ks) finalValue11 = this.data.ks.k;
            else finalValue11 = this.data.pt.k;
            var i31;
            var len11 = this.effectsSequence.length;
            for(i31 = 0; i31 < len11; i31 += 1)finalValue11 = this.effectsSequence[i31](finalValue11);
            this.setVValue(finalValue11);
            this.lock = false;
            this.frameId = this.elem.globalData.frameId;
        }
        function ShapeProperty11(elem31, data11, type11) {
            this.propType = "shape";
            this.comp = elem31.comp;
            this.container = elem31;
            this.elem = elem31;
            this.data = data11;
            this.k = false;
            this.kf = false;
            this._mdf = false;
            var pathData11 = type11 === 3 ? data11.pt.k : data11.ks.k;
            this.v = shapePool.clone(pathData11);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.reset = resetShape11;
            this.effectsSequence = [];
        }
        function addEffect11(effectFunction11) {
            this.effectsSequence.push(effectFunction11);
            this.container.addDynamicProperty(this);
        }
        ShapeProperty11.prototype.interpolateShape = interpolateShape11;
        ShapeProperty11.prototype.getValue = processEffectsSequence11;
        ShapeProperty11.prototype.setVValue = setVValue11;
        ShapeProperty11.prototype.addEffect = addEffect11;
        function KeyframedShapeProperty11(elem31, data11, type11) {
            this.propType = "shape";
            this.comp = elem31.comp;
            this.elem = elem31;
            this.container = elem31;
            this.offsetTime = elem31.data.st;
            this.keyframes = type11 === 3 ? data11.pt.k : data11.ks.k;
            this.keyframesMetadata = [];
            this.k = true;
            this.kf = true;
            var len11 = this.keyframes[0].s[0].i.length;
            this.v = shapePool.newElement();
            this.v.setPathData(this.keyframes[0].s[0].c, len11);
            this.pv = shapePool.clone(this.v);
            this.localShapeCollection = shapeCollectionPool.newShapeCollection();
            this.paths = this.localShapeCollection;
            this.paths.addShape(this.v);
            this.lastFrame = initFrame11;
            this.reset = resetShape11;
            this._caching = {
                lastFrame: initFrame11,
                lastIndex: 0
            };
            this.effectsSequence = [
                interpolateShapeCurrentTime11.bind(this)
            ];
        }
        KeyframedShapeProperty11.prototype.getValue = processEffectsSequence11;
        KeyframedShapeProperty11.prototype.interpolateShape = interpolateShape11;
        KeyframedShapeProperty11.prototype.setVValue = setVValue11;
        KeyframedShapeProperty11.prototype.addEffect = addEffect11;
        var EllShapeProperty11 = function() {
            var cPoint11 = roundCorner;
            function EllShapePropertyFactory11(elem31, data11) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 4);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.paths = this.localShapeCollection;
                this.localShapeCollection.addShape(this.v);
                this.d = data11.d;
                this.elem = elem31;
                this.comp = elem31.comp;
                this.frameId = -1;
                this.initDynamicPropertyContainer(elem31);
                this.p = PropertyFactory.getProp(elem31, data11.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem31, data11.s, 1, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertEllToPath();
                }
            }
            EllShapePropertyFactory11.prototype = {
                reset: resetShape11,
                getValue: function getValue11() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertEllToPath();
                },
                convertEllToPath: function convertEllToPath11() {
                    var p011 = this.p.v[0];
                    var p141 = this.p.v[1];
                    var s011 = this.s.v[0] / 2;
                    var s111 = this.s.v[1] / 2;
                    var _cw11 = this.d !== 3;
                    var _v11 = this.v;
                    _v11.v[0][0] = p011;
                    _v11.v[0][1] = p141 - s111;
                    _v11.v[1][0] = _cw11 ? p011 + s011 : p011 - s011;
                    _v11.v[1][1] = p141;
                    _v11.v[2][0] = p011;
                    _v11.v[2][1] = p141 + s111;
                    _v11.v[3][0] = _cw11 ? p011 - s011 : p011 + s011;
                    _v11.v[3][1] = p141;
                    _v11.i[0][0] = _cw11 ? p011 - s011 * cPoint11 : p011 + s011 * cPoint11;
                    _v11.i[0][1] = p141 - s111;
                    _v11.i[1][0] = _cw11 ? p011 + s011 : p011 - s011;
                    _v11.i[1][1] = p141 - s111 * cPoint11;
                    _v11.i[2][0] = _cw11 ? p011 + s011 * cPoint11 : p011 - s011 * cPoint11;
                    _v11.i[2][1] = p141 + s111;
                    _v11.i[3][0] = _cw11 ? p011 - s011 : p011 + s011;
                    _v11.i[3][1] = p141 + s111 * cPoint11;
                    _v11.o[0][0] = _cw11 ? p011 + s011 * cPoint11 : p011 - s011 * cPoint11;
                    _v11.o[0][1] = p141 - s111;
                    _v11.o[1][0] = _cw11 ? p011 + s011 : p011 - s011;
                    _v11.o[1][1] = p141 + s111 * cPoint11;
                    _v11.o[2][0] = _cw11 ? p011 - s011 * cPoint11 : p011 + s011 * cPoint11;
                    _v11.o[2][1] = p141 + s111;
                    _v11.o[3][0] = _cw11 ? p011 - s011 : p011 + s011;
                    _v11.o[3][1] = p141 - s111 * cPoint11;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], EllShapePropertyFactory11);
            return EllShapePropertyFactory11;
        }();
        var StarShapeProperty11 = function() {
            function StarShapePropertyFactory11(elem31, data11) {
                this.v = shapePool.newElement();
                this.v.setPathData(true, 0);
                this.elem = elem31;
                this.comp = elem31.comp;
                this.data = data11;
                this.frameId = -1;
                this.d = data11.d;
                this.initDynamicPropertyContainer(elem31);
                if (data11.sy === 1) {
                    this.ir = PropertyFactory.getProp(elem31, data11.ir, 0, 0, this);
                    this.is = PropertyFactory.getProp(elem31, data11.is, 0, 0.01, this);
                    this.convertToPath = this.convertStarToPath;
                } else this.convertToPath = this.convertPolygonToPath;
                this.pt = PropertyFactory.getProp(elem31, data11.pt, 0, 0, this);
                this.p = PropertyFactory.getProp(elem31, data11.p, 1, 0, this);
                this.r = PropertyFactory.getProp(elem31, data11.r, 0, degToRads, this);
                this.or = PropertyFactory.getProp(elem31, data11.or, 0, 0, this);
                this.os = PropertyFactory.getProp(elem31, data11.os, 0, 0.01, this);
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertToPath();
                }
            }
            StarShapePropertyFactory11.prototype = {
                reset: resetShape11,
                getValue: function getValue11() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertToPath();
                },
                convertStarToPath: function convertStarToPath11() {
                    var numPts11 = Math.floor(this.pt.v) * 2;
                    var angle11 = Math.PI * 2 / numPts11;
                    /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */ var longFlag11 = true;
                    var longRad11 = this.or.v;
                    var shortRad11 = this.ir.v;
                    var longRound11 = this.os.v;
                    var shortRound11 = this.is.v;
                    var longPerimSegment11 = 2 * Math.PI * longRad11 / (numPts11 * 2);
                    var shortPerimSegment11 = 2 * Math.PI * shortRad11 / (numPts11 * 2);
                    var i31;
                    var rad11;
                    var roundness11;
                    var perimSegment11;
                    var currentAng11 = -Math.PI / 2;
                    currentAng11 += this.r.v;
                    var dir11 = this.data.d === 3 ? -1 : 1;
                    this.v._length = 0;
                    for(i31 = 0; i31 < numPts11; i31 += 1){
                        rad11 = longFlag11 ? longRad11 : shortRad11;
                        roundness11 = longFlag11 ? longRound11 : shortRound11;
                        perimSegment11 = longFlag11 ? longPerimSegment11 : shortPerimSegment11;
                        var x41 = rad11 * Math.cos(currentAng11);
                        var y41 = rad11 * Math.sin(currentAng11);
                        var ox11 = x41 === 0 && y41 === 0 ? 0 : y41 / Math.sqrt(x41 * x41 + y41 * y41);
                        var oy11 = x41 === 0 && y41 === 0 ? 0 : -x41 / Math.sqrt(x41 * x41 + y41 * y41);
                        x41 += +this.p.v[0];
                        y41 += +this.p.v[1];
                        this.v.setTripleAt(x41, y41, x41 - ox11 * perimSegment11 * roundness11 * dir11, y41 - oy11 * perimSegment11 * roundness11 * dir11, x41 + ox11 * perimSegment11 * roundness11 * dir11, y41 + oy11 * perimSegment11 * roundness11 * dir11, i31, true);
                        /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */ longFlag11 = !longFlag11;
                        currentAng11 += angle11 * dir11;
                    }
                },
                convertPolygonToPath: function convertPolygonToPath11() {
                    var numPts11 = Math.floor(this.pt.v);
                    var angle11 = Math.PI * 2 / numPts11;
                    var rad11 = this.or.v;
                    var roundness11 = this.os.v;
                    var perimSegment11 = 2 * Math.PI * rad11 / (numPts11 * 4);
                    var i31;
                    var currentAng11 = -Math.PI * 0.5;
                    var dir11 = this.data.d === 3 ? -1 : 1;
                    currentAng11 += this.r.v;
                    this.v._length = 0;
                    for(i31 = 0; i31 < numPts11; i31 += 1){
                        var x41 = rad11 * Math.cos(currentAng11);
                        var y41 = rad11 * Math.sin(currentAng11);
                        var ox11 = x41 === 0 && y41 === 0 ? 0 : y41 / Math.sqrt(x41 * x41 + y41 * y41);
                        var oy11 = x41 === 0 && y41 === 0 ? 0 : -x41 / Math.sqrt(x41 * x41 + y41 * y41);
                        x41 += +this.p.v[0];
                        y41 += +this.p.v[1];
                        this.v.setTripleAt(x41, y41, x41 - ox11 * perimSegment11 * roundness11 * dir11, y41 - oy11 * perimSegment11 * roundness11 * dir11, x41 + ox11 * perimSegment11 * roundness11 * dir11, y41 + oy11 * perimSegment11 * roundness11 * dir11, i31, true);
                        currentAng11 += angle11 * dir11;
                    }
                    this.paths.length = 0;
                    this.paths[0] = this.v;
                }
            };
            extendPrototype([
                DynamicPropertyContainer
            ], StarShapePropertyFactory11);
            return StarShapePropertyFactory11;
        }();
        var RectShapeProperty11 = function() {
            function RectShapePropertyFactory11(elem31, data11) {
                this.v = shapePool.newElement();
                this.v.c = true;
                this.localShapeCollection = shapeCollectionPool.newShapeCollection();
                this.localShapeCollection.addShape(this.v);
                this.paths = this.localShapeCollection;
                this.elem = elem31;
                this.comp = elem31.comp;
                this.frameId = -1;
                this.d = data11.d;
                this.initDynamicPropertyContainer(elem31);
                this.p = PropertyFactory.getProp(elem31, data11.p, 1, 0, this);
                this.s = PropertyFactory.getProp(elem31, data11.s, 1, 0, this);
                this.r = PropertyFactory.getProp(elem31, data11.r, 0, 0, this);
                if (this.dynamicProperties.length) this.k = true;
                else {
                    this.k = false;
                    this.convertRectToPath();
                }
            }
            RectShapePropertyFactory11.prototype = {
                convertRectToPath: function convertRectToPath11() {
                    var p011 = this.p.v[0];
                    var p141 = this.p.v[1];
                    var v011 = this.s.v[0] / 2;
                    var v111 = this.s.v[1] / 2;
                    var round11 = bmMin(v011, v111, this.r.v);
                    var cPoint11 = round11 * (1 - roundCorner);
                    this.v._length = 0;
                    if (this.d === 2 || this.d === 1) {
                        this.v.setTripleAt(p011 + v011, p141 - v111 + round11, p011 + v011, p141 - v111 + round11, p011 + v011, p141 - v111 + cPoint11, 0, true);
                        this.v.setTripleAt(p011 + v011, p141 + v111 - round11, p011 + v011, p141 + v111 - cPoint11, p011 + v011, p141 + v111 - round11, 1, true);
                        if (round11 !== 0) {
                            this.v.setTripleAt(p011 + v011 - round11, p141 + v111, p011 + v011 - round11, p141 + v111, p011 + v011 - cPoint11, p141 + v111, 2, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 + v111, p011 - v011 + cPoint11, p141 + v111, p011 - v011 + round11, p141 + v111, 3, true);
                            this.v.setTripleAt(p011 - v011, p141 + v111 - round11, p011 - v011, p141 + v111 - round11, p011 - v011, p141 + v111 - cPoint11, 4, true);
                            this.v.setTripleAt(p011 - v011, p141 - v111 + round11, p011 - v011, p141 - v111 + cPoint11, p011 - v011, p141 - v111 + round11, 5, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 - v111, p011 - v011 + round11, p141 - v111, p011 - v011 + cPoint11, p141 - v111, 6, true);
                            this.v.setTripleAt(p011 + v011 - round11, p141 - v111, p011 + v011 - cPoint11, p141 - v111, p011 + v011 - round11, p141 - v111, 7, true);
                        } else {
                            this.v.setTripleAt(p011 - v011, p141 + v111, p011 - v011 + cPoint11, p141 + v111, p011 - v011, p141 + v111, 2);
                            this.v.setTripleAt(p011 - v011, p141 - v111, p011 - v011, p141 - v111 + cPoint11, p011 - v011, p141 - v111, 3);
                        }
                    } else {
                        this.v.setTripleAt(p011 + v011, p141 - v111 + round11, p011 + v011, p141 - v111 + cPoint11, p011 + v011, p141 - v111 + round11, 0, true);
                        if (round11 !== 0) {
                            this.v.setTripleAt(p011 + v011 - round11, p141 - v111, p011 + v011 - round11, p141 - v111, p011 + v011 - cPoint11, p141 - v111, 1, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 - v111, p011 - v011 + cPoint11, p141 - v111, p011 - v011 + round11, p141 - v111, 2, true);
                            this.v.setTripleAt(p011 - v011, p141 - v111 + round11, p011 - v011, p141 - v111 + round11, p011 - v011, p141 - v111 + cPoint11, 3, true);
                            this.v.setTripleAt(p011 - v011, p141 + v111 - round11, p011 - v011, p141 + v111 - cPoint11, p011 - v011, p141 + v111 - round11, 4, true);
                            this.v.setTripleAt(p011 - v011 + round11, p141 + v111, p011 - v011 + round11, p141 + v111, p011 - v011 + cPoint11, p141 + v111, 5, true);
                            this.v.setTripleAt(p011 + v011 - round11, p141 + v111, p011 + v011 - cPoint11, p141 + v111, p011 + v011 - round11, p141 + v111, 6, true);
                            this.v.setTripleAt(p011 + v011, p141 + v111 - round11, p011 + v011, p141 + v111 - round11, p011 + v011, p141 + v111 - cPoint11, 7, true);
                        } else {
                            this.v.setTripleAt(p011 - v011, p141 - v111, p011 - v011 + cPoint11, p141 - v111, p011 - v011, p141 - v111, 1, true);
                            this.v.setTripleAt(p011 - v011, p141 + v111, p011 - v011, p141 + v111 - cPoint11, p011 - v011, p141 + v111, 2, true);
                            this.v.setTripleAt(p011 + v011, p141 + v111, p011 + v011 - cPoint11, p141 + v111, p011 + v011, p141 + v111, 3, true);
                        }
                    }
                },
                getValue: function getValue11() {
                    if (this.elem.globalData.frameId === this.frameId) return;
                    this.frameId = this.elem.globalData.frameId;
                    this.iterateDynamicProperties();
                    if (this._mdf) this.convertRectToPath();
                },
                reset: resetShape11
            };
            extendPrototype([
                DynamicPropertyContainer
            ], RectShapePropertyFactory11);
            return RectShapePropertyFactory11;
        }();
        function getShapeProp11(elem31, data11, type11) {
            var prop11;
            if (type11 === 3 || type11 === 4) {
                var dataProp11 = type11 === 3 ? data11.pt : data11.ks;
                var keys11 = dataProp11.k;
                if (keys11.length) prop11 = new KeyframedShapeProperty11(elem31, data11, type11);
                else prop11 = new ShapeProperty11(elem31, data11, type11);
            } else if (type11 === 5) prop11 = new RectShapeProperty11(elem31, data11);
            else if (type11 === 6) prop11 = new EllShapeProperty11(elem31, data11);
            else if (type11 === 7) prop11 = new StarShapeProperty11(elem31, data11);
            if (prop11.k) elem31.addDynamicProperty(prop11);
            return prop11;
        }
        function getConstructorFunction11() {
            return ShapeProperty11;
        }
        function getKeyframedConstructorFunction11() {
            return KeyframedShapeProperty11;
        }
        var ob11 = {};
        ob11.getShapeProp = getShapeProp11;
        ob11.getConstructorFunction = getConstructorFunction11;
        ob11.getKeyframedConstructorFunction = getKeyframedConstructorFunction11;
        return ob11;
    }();
    /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */ /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */ var Matrix = function() {
        var _cos11 = Math.cos;
        var _sin11 = Math.sin;
        var _tan11 = Math.tan;
        var _rnd11 = Math.round;
        function reset11() {
            this.props[0] = 1;
            this.props[1] = 0;
            this.props[2] = 0;
            this.props[3] = 0;
            this.props[4] = 0;
            this.props[5] = 1;
            this.props[6] = 0;
            this.props[7] = 0;
            this.props[8] = 0;
            this.props[9] = 0;
            this.props[10] = 1;
            this.props[11] = 0;
            this.props[12] = 0;
            this.props[13] = 0;
            this.props[14] = 0;
            this.props[15] = 1;
            return this;
        }
        function rotate11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function rotateX11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(1, 0, 0, 0, 0, mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1);
        }
        function rotateY11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, 0, mSin11, 0, 0, 1, 0, 0, -mSin11, 0, mCos11, 0, 0, 0, 0, 1);
        }
        function rotateZ11(angle11) {
            if (angle11 === 0) return this;
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        }
        function shear11(sx11, sy11) {
            return this._t(1, sy11, sx11, 1, 0, 0);
        }
        function skew11(ax11, ay11) {
            return this.shear(_tan11(ax11), _tan11(ay11));
        }
        function skewFromAxis11(ax11, angle11) {
            var mCos11 = _cos11(angle11);
            var mSin11 = _sin11(angle11);
            return this._t(mCos11, mSin11, 0, 0, -mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan11(ax11), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos11, -mSin11, 0, 0, mSin11, mCos11, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
        }
        function scale21(sx11, sy11, sz11) {
            if (!sz11 && sz11 !== 0) sz11 = 1;
            if (sx11 === 1 && sy11 === 1 && sz11 === 1) return this;
            return this._t(sx11, 0, 0, 0, 0, sy11, 0, 0, 0, 0, sz11, 0, 0, 0, 0, 1);
        }
        function setTransform11(a31, b31, c41, d31, e31, f31, g31, h31, i31, j31, k31, l31, m31, n31, o31, p61) {
            this.props[0] = a31;
            this.props[1] = b31;
            this.props[2] = c41;
            this.props[3] = d31;
            this.props[4] = e31;
            this.props[5] = f31;
            this.props[6] = g31;
            this.props[7] = h31;
            this.props[8] = i31;
            this.props[9] = j31;
            this.props[10] = k31;
            this.props[11] = l31;
            this.props[12] = m31;
            this.props[13] = n31;
            this.props[14] = o31;
            this.props[15] = p61;
            return this;
        }
        function translate11(tx11, ty11, tz11) {
            tz11 = tz11 || 0;
            if (tx11 !== 0 || ty11 !== 0 || tz11 !== 0) return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx11, ty11, tz11, 1);
            return this;
        }
        function transform11(a211, b211, c211, d211, e211, f211, g211, h211, i211, j211, k211, l211, m211, n211, o211, p221) {
            var _p11 = this.props;
            if (a211 === 1 && b211 === 0 && c211 === 0 && d211 === 0 && e211 === 0 && f211 === 1 && g211 === 0 && h211 === 0 && i211 === 0 && j211 === 0 && k211 === 1 && l211 === 0) {
                // NOTE: commenting this condition because TurboFan deoptimizes code when present
                // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
                _p11[12] = _p11[12] * a211 + _p11[15] * m211;
                _p11[13] = _p11[13] * f211 + _p11[15] * n211;
                _p11[14] = _p11[14] * k211 + _p11[15] * o211;
                _p11[15] *= p221; // }
                this._identityCalculated = false;
                return this;
            }
            var a111 = _p11[0];
            var b111 = _p11[1];
            var c111 = _p11[2];
            var d111 = _p11[3];
            var e111 = _p11[4];
            var f111 = _p11[5];
            var g111 = _p11[6];
            var h111 = _p11[7];
            var i111 = _p11[8];
            var j111 = _p11[9];
            var k111 = _p11[10];
            var l111 = _p11[11];
            var m111 = _p11[12];
            var n111 = _p11[13];
            var o111 = _p11[14];
            var p141 = _p11[15];
            /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */ _p11[0] = a111 * a211 + b111 * e211 + c111 * i211 + d111 * m211;
            _p11[1] = a111 * b211 + b111 * f211 + c111 * j211 + d111 * n211;
            _p11[2] = a111 * c211 + b111 * g211 + c111 * k211 + d111 * o211;
            _p11[3] = a111 * d211 + b111 * h211 + c111 * l211 + d111 * p221;
            _p11[4] = e111 * a211 + f111 * e211 + g111 * i211 + h111 * m211;
            _p11[5] = e111 * b211 + f111 * f211 + g111 * j211 + h111 * n211;
            _p11[6] = e111 * c211 + f111 * g211 + g111 * k211 + h111 * o211;
            _p11[7] = e111 * d211 + f111 * h211 + g111 * l211 + h111 * p221;
            _p11[8] = i111 * a211 + j111 * e211 + k111 * i211 + l111 * m211;
            _p11[9] = i111 * b211 + j111 * f211 + k111 * j211 + l111 * n211;
            _p11[10] = i111 * c211 + j111 * g211 + k111 * k211 + l111 * o211;
            _p11[11] = i111 * d211 + j111 * h211 + k111 * l211 + l111 * p221;
            _p11[12] = m111 * a211 + n111 * e211 + o111 * i211 + p141 * m211;
            _p11[13] = m111 * b211 + n111 * f211 + o111 * j211 + p141 * n211;
            _p11[14] = m111 * c211 + n111 * g211 + o111 * k211 + p141 * o211;
            _p11[15] = m111 * d211 + n111 * h211 + o111 * l211 + p141 * p221;
            this._identityCalculated = false;
            return this;
        }
        function multiply11(matrix11) {
            var matrixProps11 = matrix11.props;
            return this.transform(matrixProps11[0], matrixProps11[1], matrixProps11[2], matrixProps11[3], matrixProps11[4], matrixProps11[5], matrixProps11[6], matrixProps11[7], matrixProps11[8], matrixProps11[9], matrixProps11[10], matrixProps11[11], matrixProps11[12], matrixProps11[13], matrixProps11[14], matrixProps11[15]);
        }
        function isIdentity11() {
            if (!this._identityCalculated) {
                this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
                this._identityCalculated = true;
            }
            return this._identity;
        }
        function equals11(matr11) {
            var i31 = 0;
            while(i31 < 16){
                if (matr11.props[i31] !== this.props[i31]) return false;
                i31 += 1;
            }
            return true;
        }
        function clone11(matr11) {
            var i31;
            for(i31 = 0; i31 < 16; i31 += 1)matr11.props[i31] = this.props[i31];
            return matr11;
        }
        function cloneFromProps11(props11) {
            var i31;
            for(i31 = 0; i31 < 16; i31 += 1)this.props[i31] = props11[i31];
        }
        function applyToPoint11(x41, y41, z41) {
            return {
                x: x41 * this.props[0] + y41 * this.props[4] + z41 * this.props[8] + this.props[12],
                y: x41 * this.props[1] + y41 * this.props[5] + z41 * this.props[9] + this.props[13],
                z: x41 * this.props[2] + y41 * this.props[6] + z41 * this.props[10] + this.props[14]
            };
        /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */ }
        function applyToX11(x41, y41, z41) {
            return x41 * this.props[0] + y41 * this.props[4] + z41 * this.props[8] + this.props[12];
        }
        function applyToY11(x41, y41, z41) {
            return x41 * this.props[1] + y41 * this.props[5] + z41 * this.props[9] + this.props[13];
        }
        function applyToZ11(x41, y41, z41) {
            return x41 * this.props[2] + y41 * this.props[6] + z41 * this.props[10] + this.props[14];
        }
        function getInverseMatrix11() {
            var determinant11 = this.props[0] * this.props[5] - this.props[1] * this.props[4];
            var a31 = this.props[5] / determinant11;
            var b31 = -this.props[1] / determinant11;
            var c41 = -this.props[4] / determinant11;
            var d31 = this.props[0] / determinant11;
            var e31 = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant11;
            var f31 = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant11;
            var inverseMatrix11 = new Matrix();
            inverseMatrix11.props[0] = a31;
            inverseMatrix11.props[1] = b31;
            inverseMatrix11.props[4] = c41;
            inverseMatrix11.props[5] = d31;
            inverseMatrix11.props[12] = e31;
            inverseMatrix11.props[13] = f31;
            return inverseMatrix11;
        }
        function inversePoint11(pt51) {
            var inverseMatrix11 = this.getInverseMatrix();
            return inverseMatrix11.applyToPointArray(pt51[0], pt51[1], pt51[2] || 0);
        }
        function inversePoints11(pts11) {
            var i31;
            var len11 = pts11.length;
            var retPts11 = [];
            for(i31 = 0; i31 < len11; i31 += 1)retPts11[i31] = inversePoint11(pts11[i31]);
            return retPts11;
        }
        function applyToTriplePoints11(pt111, pt211, pt311) {
            var arr31 = createTypedArray("float32", 6);
            if (this.isIdentity()) {
                arr31[0] = pt111[0];
                arr31[1] = pt111[1];
                arr31[2] = pt211[0];
                arr31[3] = pt211[1];
                arr31[4] = pt311[0];
                arr31[5] = pt311[1];
            } else {
                var p011 = this.props[0];
                var p141 = this.props[1];
                var p411 = this.props[4];
                var p511 = this.props[5];
                var p1211 = this.props[12];
                var p1311 = this.props[13];
                arr31[0] = pt111[0] * p011 + pt111[1] * p411 + p1211;
                arr31[1] = pt111[0] * p141 + pt111[1] * p511 + p1311;
                arr31[2] = pt211[0] * p011 + pt211[1] * p411 + p1211;
                arr31[3] = pt211[0] * p141 + pt211[1] * p511 + p1311;
                arr31[4] = pt311[0] * p011 + pt311[1] * p411 + p1211;
                arr31[5] = pt311[0] * p141 + pt311[1] * p511 + p1311;
            }
            return arr31;
        }
        function applyToPointArray11(x41, y41, z41) {
            var arr31;
            if (this.isIdentity()) arr31 = [
                x41,
                y41,
                z41
            ];
            else arr31 = [
                x41 * this.props[0] + y41 * this.props[4] + z41 * this.props[8] + this.props[12],
                x41 * this.props[1] + y41 * this.props[5] + z41 * this.props[9] + this.props[13],
                x41 * this.props[2] + y41 * this.props[6] + z41 * this.props[10] + this.props[14]
            ];
            return arr31;
        }
        function applyToPointStringified11(x41, y41) {
            if (this.isIdentity()) return x41 + "," + y41;
            var _p11 = this.props;
            return Math.round((x41 * _p11[0] + y41 * _p11[4] + _p11[12]) * 100) / 100 + "," + Math.round((x41 * _p11[1] + y41 * _p11[5] + _p11[13]) * 100) / 100;
        }
        function toCSS11() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var i31 = 0;
            var props11 = this.props;
            var cssValue11 = "matrix3d(";
            var v51 = 10000;
            while(i31 < 16){
                cssValue11 += _rnd11(props11[i31] * v51) / v51;
                cssValue11 += i31 === 15 ? ")" : ",";
                i31 += 1;
            }
            return cssValue11;
        }
        function roundMatrixProperty11(val31) {
            var v51 = 10000;
            if (val31 < 0.000001 && val31 > 0 || val31 > -0.000001 && val31 < 0) return _rnd11(val31 * v51) / v51;
            return val31;
        }
        function to2dCSS11() {
            // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
            /* if(this.isIdentity()) {
              return '';
          } */ var props11 = this.props;
            var _a11 = roundMatrixProperty11(props11[0]);
            var _b11 = roundMatrixProperty11(props11[1]);
            var _c11 = roundMatrixProperty11(props11[4]);
            var _d11 = roundMatrixProperty11(props11[5]);
            var _e11 = roundMatrixProperty11(props11[12]);
            var _f11 = roundMatrixProperty11(props11[13]);
            return "matrix(" + _a11 + "," + _b11 + "," + _c11 + "," + _d11 + "," + _e11 + "," + _f11 + ")";
        }
        return function() {
            this.reset = reset11;
            this.rotate = rotate11;
            this.rotateX = rotateX11;
            this.rotateY = rotateY11;
            this.rotateZ = rotateZ11;
            this.skew = skew11;
            this.skewFromAxis = skewFromAxis11;
            this.shear = shear11;
            this.scale = scale21;
            this.setTransform = setTransform11;
            this.translate = translate11;
            this.transform = transform11;
            this.multiply = multiply11;
            this.applyToPoint = applyToPoint11;
            this.applyToX = applyToX11;
            this.applyToY = applyToY11;
            this.applyToZ = applyToZ11;
            this.applyToPointArray = applyToPointArray11;
            this.applyToTriplePoints = applyToTriplePoints11;
            this.applyToPointStringified = applyToPointStringified11;
            this.toCSS = toCSS11;
            this.to2dCSS = to2dCSS11;
            this.clone = clone11;
            this.cloneFromProps = cloneFromProps11;
            this.equals = equals11;
            this.inversePoints = inversePoints11;
            this.inversePoint = inversePoint11;
            this.getInverseMatrix = getInverseMatrix11;
            this._t = this.transform;
            this.isIdentity = isIdentity11;
            this._identity = true;
            this._identityCalculated = false;
            this.props = createTypedArray("float32", 16);
            this.reset();
        };
    }();
    function _typeof$3(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$3 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$3 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$3(obj11);
    }
    var lottie = {};
    var standalone = "__[STANDALONE]__";
    var animationData = "__[ANIMATIONDATA]__";
    var renderer = "";
    function setLocation(href11) {
        setLocationHref(href11);
    }
    function searchAnimations() {
        if (standalone === true) animationManager.searchAnimations(animationData, standalone, renderer);
        else animationManager.searchAnimations();
    }
    function setSubframeRendering(flag11) {
        setSubframeEnabled(flag11);
    }
    function setPrefix(prefix11) {
        setIdPrefix(prefix11);
    }
    function loadAnimation(params11) {
        if (standalone === true) params11.animationData = JSON.parse(animationData);
        return animationManager.loadAnimation(params11);
    }
    function setQuality(value31) {
        if (typeof value31 === "string") switch(value31){
            case "high":
                setDefaultCurveSegments(200);
                break;
            default:
            case "medium":
                setDefaultCurveSegments(50);
                break;
            case "low":
                setDefaultCurveSegments(10);
                break;
        }
        else if (!isNaN(value31) && value31 > 1) setDefaultCurveSegments(value31);
        if (getDefaultCurveSegments() >= 50) roundValues(false);
        else roundValues(true);
    }
    function inBrowser() {
        return typeof navigator !== "undefined";
    }
    function installPlugin(type11, plugin11) {
        if (type11 === "expressions") setExpressionsPlugin(plugin11);
    }
    function getFactory(name11) {
        switch(name11){
            case "propertyFactory":
                return PropertyFactory;
            case "shapePropertyFactory":
                return ShapePropertyFactory;
            case "matrix":
                return Matrix;
            default:
                return null;
        }
    }
    lottie.play = animationManager.play;
    lottie.pause = animationManager.pause;
    lottie.setLocationHref = setLocation;
    lottie.togglePause = animationManager.togglePause;
    lottie.setSpeed = animationManager.setSpeed;
    lottie.setDirection = animationManager.setDirection;
    lottie.stop = animationManager.stop;
    lottie.searchAnimations = searchAnimations;
    lottie.registerAnimation = animationManager.registerAnimation;
    lottie.loadAnimation = loadAnimation;
    lottie.setSubframeRendering = setSubframeRendering;
    lottie.resize = animationManager.resize; // lottie.start = start;
    lottie.goToAndStop = animationManager.goToAndStop;
    lottie.destroy = animationManager.destroy;
    lottie.setQuality = setQuality;
    lottie.inBrowser = inBrowser;
    lottie.installPlugin = installPlugin;
    lottie.freeze = animationManager.freeze;
    lottie.unfreeze = animationManager.unfreeze;
    lottie.setVolume = animationManager.setVolume;
    lottie.mute = animationManager.mute;
    lottie.unmute = animationManager.unmute;
    lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
    lottie.useWebWorker = setWebWorker;
    lottie.setIDPrefix = setPrefix;
    lottie.__getFactory = getFactory;
    lottie.version = "5.12.0";
    function checkReady() {
        if (document.readyState === "complete") {
            clearInterval(readyStateCheckInterval);
            searchAnimations();
        }
    }
    function getQueryVariable(variable11) {
        var vars11 = queryString.split("&");
        for(var i31 = 0; i31 < vars11.length; i31 += 1){
            var pair11 = vars11[i31].split("=");
            if (decodeURIComponent(pair11[0]) == variable11) // eslint-disable-line eqeqeq
            return decodeURIComponent(pair11[1]);
        }
        return null;
    }
    var queryString = "";
    if (standalone) {
        var scripts = document.getElementsByTagName("script");
        var index = scripts.length - 1;
        var myScript = scripts[index] || {
            src: ""
        };
        queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : ""; // eslint-disable-line no-useless-escape
        renderer = getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility
    try {
        if (!(_typeof$3(exports) === "object" && true) && !(typeof define === "function" && define.amd // eslint-disable-line no-undef
        )) window.bodymovin = lottie;
    } catch (err) {}
    var ShapeModifiers = function() {
        var ob11 = {};
        var modifiers11 = {};
        ob11.registerModifier = registerModifier11;
        ob11.getModifier = getModifier11;
        function registerModifier11(nm11, factory11) {
            if (!modifiers11[nm11]) modifiers11[nm11] = factory11;
        }
        function getModifier11(nm11, elem31, data11) {
            return new modifiers11[nm11](elem31, data11);
        }
        return ob11;
    }();
    function ShapeModifier() {}
    ShapeModifier.prototype.initModifierProperties = function() {};
    ShapeModifier.prototype.addShapeToModifier = function() {};
    ShapeModifier.prototype.addShape = function(data11) {
        if (!this.closed) {
            // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
            data11.sh.container.addDynamicProperty(data11.sh);
            var shapeData11 = {
                shape: data11.sh,
                data: data11,
                localShapeCollection: shapeCollectionPool.newShapeCollection()
            };
            this.shapes.push(shapeData11);
            this.addShapeToModifier(shapeData11);
            if (this._isAnimated) data11.setAsAnimated();
        }
    };
    ShapeModifier.prototype.init = function(elem31, data11) {
        this.shapes = [];
        this.elem = elem31;
        this.initDynamicPropertyContainer(elem31);
        this.initModifierProperties(elem31, data11);
        this.frameId = initialDefaultFrame;
        this.closed = false;
        this.k = false;
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    ShapeModifier.prototype.processKeys = function() {
        if (this.elem.globalData.frameId === this.frameId) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    extendPrototype([
        DynamicPropertyContainer
    ], ShapeModifier);
    function TrimModifier() {}
    extendPrototype([
        ShapeModifier
    ], TrimModifier);
    TrimModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.s = PropertyFactory.getProp(elem31, data11.s, 0, 0.01, this);
        this.e = PropertyFactory.getProp(elem31, data11.e, 0, 0.01, this);
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0, this);
        this.sValue = 0;
        this.eValue = 0;
        this.getValue = this.processKeys;
        this.m = data11.m;
        this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    };
    TrimModifier.prototype.addShapeToModifier = function(shapeData11) {
        shapeData11.pathsData = [];
    };
    TrimModifier.prototype.calculateShapeEdges = function(s41, e31, shapeLength11, addedLength11, totalModifierLength11) {
        var segments11 = [];
        if (e31 <= 1) segments11.push({
            s: s41,
            e: e31
        });
        else if (s41 >= 1) segments11.push({
            s: s41 - 1,
            e: e31 - 1
        });
        else {
            segments11.push({
                s: s41,
                e: 1
            });
            segments11.push({
                s: 0,
                e: e31 - 1
            });
        }
        var shapeSegments11 = [];
        var i31;
        var len11 = segments11.length;
        var segmentOb11;
        for(i31 = 0; i31 < len11; i31 += 1){
            segmentOb11 = segments11[i31];
            if (!(segmentOb11.e * totalModifierLength11 < addedLength11 || segmentOb11.s * totalModifierLength11 > addedLength11 + shapeLength11)) {
                var shapeS11;
                var shapeE11;
                if (segmentOb11.s * totalModifierLength11 <= addedLength11) shapeS11 = 0;
                else shapeS11 = (segmentOb11.s * totalModifierLength11 - addedLength11) / shapeLength11;
                if (segmentOb11.e * totalModifierLength11 >= addedLength11 + shapeLength11) shapeE11 = 1;
                else shapeE11 = (segmentOb11.e * totalModifierLength11 - addedLength11) / shapeLength11;
                shapeSegments11.push([
                    shapeS11,
                    shapeE11
                ]);
            }
        }
        if (!shapeSegments11.length) shapeSegments11.push([
            0,
            0
        ]);
        return shapeSegments11;
    };
    TrimModifier.prototype.releasePathsData = function(pathsData11) {
        var i31;
        var len11 = pathsData11.length;
        for(i31 = 0; i31 < len11; i31 += 1)segmentsLengthPool.release(pathsData11[i31]);
        pathsData11.length = 0;
        return pathsData11;
    };
    TrimModifier.prototype.processShapes = function(_isFirstFrame11) {
        var s41;
        var e31;
        if (this._mdf || _isFirstFrame11) {
            var o31 = this.o.v % 360 / 360;
            if (o31 < 0) o31 += 1;
            if (this.s.v > 1) s41 = 1 + o31;
            else if (this.s.v < 0) s41 = 0 + o31;
            else s41 = this.s.v + o31;
            if (this.e.v > 1) e31 = 1 + o31;
            else if (this.e.v < 0) e31 = 0 + o31;
            else e31 = this.e.v + o31;
            if (s41 > e31) {
                var _s11 = s41;
                s41 = e31;
                e31 = _s11;
            }
            s41 = Math.round(s41 * 10000) * 0.0001;
            e31 = Math.round(e31 * 10000) * 0.0001;
            this.sValue = s41;
            this.eValue = e31;
        } else {
            s41 = this.sValue;
            e31 = this.eValue;
        }
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var pathsData11;
        var pathData11;
        var totalShapeLength11;
        var totalModifierLength11 = 0;
        if (e31 === s41) for(i31 = 0; i31 < len11; i31 += 1){
            this.shapes[i31].localShapeCollection.releaseShapes();
            this.shapes[i31].shape._mdf = true;
            this.shapes[i31].shape.paths = this.shapes[i31].localShapeCollection;
            if (this._mdf) this.shapes[i31].pathsData.length = 0;
        }
        else if (!(e31 === 1 && s41 === 0 || e31 === 0 && s41 === 1)) {
            var segments11 = [];
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used
                if (!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11 && this.m !== 2) shapeData11.shape.paths = shapeData11.localShapeCollection;
                else {
                    shapePaths11 = shapeData11.shape.paths;
                    jLen11 = shapePaths11._length;
                    totalShapeLength11 = 0;
                    if (!shapeData11.shape._mdf && shapeData11.pathsData.length) totalShapeLength11 = shapeData11.totalShapeLength;
                    else {
                        pathsData11 = this.releasePathsData(shapeData11.pathsData);
                        for(j31 = 0; j31 < jLen11; j31 += 1){
                            pathData11 = bez.getSegmentsLength(shapePaths11.shapes[j31]);
                            pathsData11.push(pathData11);
                            totalShapeLength11 += pathData11.totalLength;
                        }
                        shapeData11.totalShapeLength = totalShapeLength11;
                        shapeData11.pathsData = pathsData11;
                    }
                    totalModifierLength11 += totalShapeLength11;
                    shapeData11.shape._mdf = true;
                }
            }
            var shapeS11 = s41;
            var shapeE11 = e31;
            var addedLength11 = 0;
            var edges11;
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                shapeData11 = this.shapes[i31];
                if (shapeData11.shape._mdf) {
                    localShapeCollection11 = shapeData11.localShapeCollection;
                    localShapeCollection11.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group
                    if (this.m === 2 && len11 > 1) {
                        edges11 = this.calculateShapeEdges(s41, e31, shapeData11.totalShapeLength, addedLength11, totalModifierLength11);
                        addedLength11 += shapeData11.totalShapeLength;
                    } else edges11 = [
                        [
                            shapeS11,
                            shapeE11
                        ]
                    ];
                    jLen11 = edges11.length;
                    for(j31 = 0; j31 < jLen11; j31 += 1){
                        shapeS11 = edges11[j31][0];
                        shapeE11 = edges11[j31][1];
                        segments11.length = 0;
                        if (shapeE11 <= 1) segments11.push({
                            s: shapeData11.totalShapeLength * shapeS11,
                            e: shapeData11.totalShapeLength * shapeE11
                        });
                        else if (shapeS11 >= 1) segments11.push({
                            s: shapeData11.totalShapeLength * (shapeS11 - 1),
                            e: shapeData11.totalShapeLength * (shapeE11 - 1)
                        });
                        else {
                            segments11.push({
                                s: shapeData11.totalShapeLength * shapeS11,
                                e: shapeData11.totalShapeLength
                            });
                            segments11.push({
                                s: 0,
                                e: shapeData11.totalShapeLength * (shapeE11 - 1)
                            });
                        }
                        var newShapesData11 = this.addShapes(shapeData11, segments11[0]);
                        if (segments11[0].s !== segments11[0].e) {
                            if (segments11.length > 1) {
                                var lastShapeInCollection11 = shapeData11.shape.paths.shapes[shapeData11.shape.paths._length - 1];
                                if (lastShapeInCollection11.c) {
                                    var lastShape11 = newShapesData11.pop();
                                    this.addPaths(newShapesData11, localShapeCollection11);
                                    newShapesData11 = this.addShapes(shapeData11, segments11[1], lastShape11);
                                } else {
                                    this.addPaths(newShapesData11, localShapeCollection11);
                                    newShapesData11 = this.addShapes(shapeData11, segments11[1]);
                                }
                            }
                            this.addPaths(newShapesData11, localShapeCollection11);
                        }
                    }
                    shapeData11.shape.paths = localShapeCollection11;
                }
            }
        } else if (this._mdf) for(i31 = 0; i31 < len11; i31 += 1){
            // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
            // Don't remove this even if it's losing cached info.
            this.shapes[i31].pathsData.length = 0;
            this.shapes[i31].shape._mdf = true;
        }
    };
    TrimModifier.prototype.addPaths = function(newPaths11, localShapeCollection11) {
        var i31;
        var len11 = newPaths11.length;
        for(i31 = 0; i31 < len11; i31 += 1)localShapeCollection11.addShape(newPaths11[i31]);
    };
    TrimModifier.prototype.addSegment = function(pt111, pt211, pt311, pt411, shapePath11, pos11, newShape11) {
        shapePath11.setXYAt(pt211[0], pt211[1], "o", pos11);
        shapePath11.setXYAt(pt311[0], pt311[1], "i", pos11 + 1);
        if (newShape11) shapePath11.setXYAt(pt111[0], pt111[1], "v", pos11);
        shapePath11.setXYAt(pt411[0], pt411[1], "v", pos11 + 1);
    };
    TrimModifier.prototype.addSegmentFromArray = function(points11, shapePath11, pos11, newShape11) {
        shapePath11.setXYAt(points11[1], points11[5], "o", pos11);
        shapePath11.setXYAt(points11[2], points11[6], "i", pos11 + 1);
        if (newShape11) shapePath11.setXYAt(points11[0], points11[4], "v", pos11);
        shapePath11.setXYAt(points11[3], points11[7], "v", pos11 + 1);
    };
    TrimModifier.prototype.addShapes = function(shapeData11, shapeSegment11, shapePath11) {
        var pathsData11 = shapeData11.pathsData;
        var shapePaths11 = shapeData11.shape.paths.shapes;
        var i31;
        var len11 = shapeData11.shape.paths._length;
        var j31;
        var jLen11;
        var addedLength11 = 0;
        var currentLengthData11;
        var segmentCount11;
        var lengths11;
        var segment11;
        var shapes11 = [];
        var initPos11;
        var newShape11 = true;
        if (!shapePath11) {
            shapePath11 = shapePool.newElement();
            segmentCount11 = 0;
            initPos11 = 0;
        } else {
            segmentCount11 = shapePath11._length;
            initPos11 = shapePath11._length;
        }
        shapes11.push(shapePath11);
        for(i31 = 0; i31 < len11; i31 += 1){
            lengths11 = pathsData11[i31].lengths;
            shapePath11.c = shapePaths11[i31].c;
            jLen11 = shapePaths11[i31].c ? lengths11.length : lengths11.length + 1;
            for(j31 = 1; j31 < jLen11; j31 += 1){
                currentLengthData11 = lengths11[j31 - 1];
                if (addedLength11 + currentLengthData11.addedLength < shapeSegment11.s) {
                    addedLength11 += currentLengthData11.addedLength;
                    shapePath11.c = false;
                } else if (addedLength11 > shapeSegment11.e) {
                    shapePath11.c = false;
                    break;
                } else {
                    if (shapeSegment11.s <= addedLength11 && shapeSegment11.e >= addedLength11 + currentLengthData11.addedLength) {
                        this.addSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[j31], shapePaths11[i31].v[j31], shapePath11, segmentCount11, newShape11);
                        newShape11 = false;
                    } else {
                        segment11 = bez.getNewSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].v[j31], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[j31], (shapeSegment11.s - addedLength11) / currentLengthData11.addedLength, (shapeSegment11.e - addedLength11) / currentLengthData11.addedLength, lengths11[j31 - 1]);
                        this.addSegmentFromArray(segment11, shapePath11, segmentCount11, newShape11); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape11 = false;
                        shapePath11.c = false;
                    }
                    addedLength11 += currentLengthData11.addedLength;
                    segmentCount11 += 1;
                }
            }
            if (shapePaths11[i31].c && lengths11.length) {
                currentLengthData11 = lengths11[j31 - 1];
                if (addedLength11 <= shapeSegment11.e) {
                    var segmentLength11 = lengths11[j31 - 1].addedLength;
                    if (shapeSegment11.s <= addedLength11 && shapeSegment11.e >= addedLength11 + segmentLength11) {
                        this.addSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[0], shapePaths11[i31].v[0], shapePath11, segmentCount11, newShape11);
                        newShape11 = false;
                    } else {
                        segment11 = bez.getNewSegment(shapePaths11[i31].v[j31 - 1], shapePaths11[i31].v[0], shapePaths11[i31].o[j31 - 1], shapePaths11[i31].i[0], (shapeSegment11.s - addedLength11) / segmentLength11, (shapeSegment11.e - addedLength11) / segmentLength11, lengths11[j31 - 1]);
                        this.addSegmentFromArray(segment11, shapePath11, segmentCount11, newShape11); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);
                        newShape11 = false;
                        shapePath11.c = false;
                    }
                } else shapePath11.c = false;
                addedLength11 += currentLengthData11.addedLength;
                segmentCount11 += 1;
            }
            if (shapePath11._length) {
                shapePath11.setXYAt(shapePath11.v[initPos11][0], shapePath11.v[initPos11][1], "i", initPos11);
                shapePath11.setXYAt(shapePath11.v[shapePath11._length - 1][0], shapePath11.v[shapePath11._length - 1][1], "o", shapePath11._length - 1);
            }
            if (addedLength11 > shapeSegment11.e) break;
            if (i31 < len11 - 1) {
                shapePath11 = shapePool.newElement();
                newShape11 = true;
                shapes11.push(shapePath11);
                segmentCount11 = 0;
            }
        }
        return shapes11;
    };
    function PuckerAndBloatModifier() {}
    extendPrototype([
        ShapeModifier
    ], PuckerAndBloatModifier);
    PuckerAndBloatModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem31, data11.a, 0, null, this);
        this._isAnimated = !!this.amount.effectsSequence.length;
    };
    PuckerAndBloatModifier.prototype.processPath = function(path11, amount11) {
        var percent11 = amount11 / 100;
        var centerPoint11 = [
            0,
            0
        ];
        var pathLength11 = path11._length;
        var i31 = 0;
        for(i31 = 0; i31 < pathLength11; i31 += 1){
            centerPoint11[0] += path11.v[i31][0];
            centerPoint11[1] += path11.v[i31][1];
        }
        centerPoint11[0] /= pathLength11;
        centerPoint11[1] /= pathLength11;
        var clonedPath11 = shapePool.newElement();
        clonedPath11.c = path11.c;
        var vX11;
        var vY11;
        var oX11;
        var oY11;
        var iX11;
        var iY11;
        for(i31 = 0; i31 < pathLength11; i31 += 1){
            vX11 = path11.v[i31][0] + (centerPoint11[0] - path11.v[i31][0]) * percent11;
            vY11 = path11.v[i31][1] + (centerPoint11[1] - path11.v[i31][1]) * percent11;
            oX11 = path11.o[i31][0] + (centerPoint11[0] - path11.o[i31][0]) * -percent11;
            oY11 = path11.o[i31][1] + (centerPoint11[1] - path11.o[i31][1]) * -percent11;
            iX11 = path11.i[i31][0] + (centerPoint11[0] - path11.i[i31][0]) * -percent11;
            iY11 = path11.i[i31][1] + (centerPoint11[1] - path11.i[i31][1]) * -percent11;
            clonedPath11.setTripleAt(vX11, vY11, oX11, oY11, iX11, iY11, i31);
        }
        return clonedPath11;
    };
    PuckerAndBloatModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var amount11 = this.amount.v;
        if (amount11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], amount11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    var TransformPropertyFactory = function() {
        var defaultVector11 = [
            0,
            0
        ];
        function applyToMatrix11(mat11) {
            var _mdf11 = this._mdf;
            this.iterateDynamicProperties();
            this._mdf = this._mdf || _mdf11;
            if (this.a) mat11.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
            if (this.s) mat11.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
            if (this.sk) mat11.skewFromAxis(-this.sk.v, this.sa.v);
            if (this.r) mat11.rotate(-this.r.v);
            else mat11.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
            if (this.data.p.s) {
                if (this.data.p.z) mat11.translate(this.px.v, this.py.v, -this.pz.v);
                else mat11.translate(this.px.v, this.py.v, 0);
            } else mat11.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
        function processKeys11(forceRender11) {
            if (this.elem.globalData.frameId === this.frameId) return;
            if (this._isDirty) {
                this.precalculateMatrix();
                this._isDirty = false;
            }
            this.iterateDynamicProperties();
            if (this._mdf || forceRender11) {
                var frameRate11;
                this.v.cloneFromProps(this.pre.props);
                if (this.appliedTransformations < 1) this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                if (this.appliedTransformations < 2) this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                if (this.sk && this.appliedTransformations < 3) this.v.skewFromAxis(-this.sk.v, this.sa.v);
                if (this.r && this.appliedTransformations < 4) this.v.rotate(-this.r.v);
                else if (!this.r && this.appliedTransformations < 4) this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                if (this.autoOriented) {
                    var v111;
                    var v211;
                    frameRate11 = this.elem.globalData.frameRate;
                    if (this.p && this.p.keyframes && this.p.getValueAtTime) {
                        if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
                            v111 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate11, 0);
                            v211 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate11, 0);
                        } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
                            v111 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate11, 0);
                            v211 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate11, 0);
                        } else {
                            v111 = this.p.pv;
                            v211 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate11, this.p.offsetTime);
                        }
                    } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                        v111 = [];
                        v211 = [];
                        var px11 = this.px;
                        var py11 = this.py;
                        if (px11._caching.lastFrame + px11.offsetTime <= px11.keyframes[0].t) {
                            v111[0] = px11.getValueAtTime((px11.keyframes[0].t + 0.01) / frameRate11, 0);
                            v111[1] = py11.getValueAtTime((py11.keyframes[0].t + 0.01) / frameRate11, 0);
                            v211[0] = px11.getValueAtTime(px11.keyframes[0].t / frameRate11, 0);
                            v211[1] = py11.getValueAtTime(py11.keyframes[0].t / frameRate11, 0);
                        } else if (px11._caching.lastFrame + px11.offsetTime >= px11.keyframes[px11.keyframes.length - 1].t) {
                            v111[0] = px11.getValueAtTime(px11.keyframes[px11.keyframes.length - 1].t / frameRate11, 0);
                            v111[1] = py11.getValueAtTime(py11.keyframes[py11.keyframes.length - 1].t / frameRate11, 0);
                            v211[0] = px11.getValueAtTime((px11.keyframes[px11.keyframes.length - 1].t - 0.01) / frameRate11, 0);
                            v211[1] = py11.getValueAtTime((py11.keyframes[py11.keyframes.length - 1].t - 0.01) / frameRate11, 0);
                        } else {
                            v111 = [
                                px11.pv,
                                py11.pv
                            ];
                            v211[0] = px11.getValueAtTime((px11._caching.lastFrame + px11.offsetTime - 0.01) / frameRate11, px11.offsetTime);
                            v211[1] = py11.getValueAtTime((py11._caching.lastFrame + py11.offsetTime - 0.01) / frameRate11, py11.offsetTime);
                        }
                    } else {
                        v211 = defaultVector11;
                        v111 = v211;
                    }
                    this.v.rotate(-Math.atan2(v111[1] - v211[1], v111[0] - v211[0]));
                }
                if (this.data.p && this.data.p.s) {
                    if (this.data.p.z) this.v.translate(this.px.v, this.py.v, -this.pz.v);
                    else this.v.translate(this.px.v, this.py.v, 0);
                } else this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
            }
            this.frameId = this.elem.globalData.frameId;
        }
        function precalculateMatrix11() {
            if (!this.a.k) {
                this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
                this.appliedTransformations = 1;
            } else return;
            if (!this.s.effectsSequence.length) {
                this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
                this.appliedTransformations = 2;
            } else return;
            if (this.sk) {
                if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
                    this.pre.skewFromAxis(-this.sk.v, this.sa.v);
                    this.appliedTransformations = 3;
                } else return;
            }
            if (this.r) {
                if (!this.r.effectsSequence.length) {
                    this.pre.rotate(-this.r.v);
                    this.appliedTransformations = 4;
                }
            } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
                this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
                this.appliedTransformations = 4;
            }
        }
        function autoOrient11() {
        // var prevP = this.getValueAtTime();
        }
        function addDynamicProperty11(prop11) {
            this._addDynamicProperty(prop11);
            this.elem.addDynamicProperty(prop11);
            this._isDirty = true;
        }
        function TransformProperty11(elem31, data11, container11) {
            this.elem = elem31;
            this.frameId = -1;
            this.propType = "transform";
            this.data = data11;
            this.v = new Matrix(); // Precalculated matrix with non animated properties
            this.pre = new Matrix();
            this.appliedTransformations = 0;
            this.initDynamicPropertyContainer(container11 || elem31);
            if (data11.p && data11.p.s) {
                this.px = PropertyFactory.getProp(elem31, data11.p.x, 0, 0, this);
                this.py = PropertyFactory.getProp(elem31, data11.p.y, 0, 0, this);
                if (data11.p.z) this.pz = PropertyFactory.getProp(elem31, data11.p.z, 0, 0, this);
            } else this.p = PropertyFactory.getProp(elem31, data11.p || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            if (data11.rx) {
                this.rx = PropertyFactory.getProp(elem31, data11.rx, 0, degToRads, this);
                this.ry = PropertyFactory.getProp(elem31, data11.ry, 0, degToRads, this);
                this.rz = PropertyFactory.getProp(elem31, data11.rz, 0, degToRads, this);
                if (data11.or.k[0].ti) {
                    var i31;
                    var len11 = data11.or.k.length;
                    for(i31 = 0; i31 < len11; i31 += 1){
                        data11.or.k[i31].to = null;
                        data11.or.k[i31].ti = null;
                    }
                }
                this.or = PropertyFactory.getProp(elem31, data11.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180
                this.or.sh = true;
            } else this.r = PropertyFactory.getProp(elem31, data11.r || {
                k: 0
            }, 0, degToRads, this);
            if (data11.sk) {
                this.sk = PropertyFactory.getProp(elem31, data11.sk, 0, degToRads, this);
                this.sa = PropertyFactory.getProp(elem31, data11.sa, 0, degToRads, this);
            }
            this.a = PropertyFactory.getProp(elem31, data11.a || {
                k: [
                    0,
                    0,
                    0
                ]
            }, 1, 0, this);
            this.s = PropertyFactory.getProp(elem31, data11.s || {
                k: [
                    100,
                    100,
                    100
                ]
            }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.
            if (data11.o) this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, elem31);
            else this.o = {
                _mdf: false,
                v: 1
            };
            this._isDirty = true;
            if (!this.dynamicProperties.length) this.getValue(true);
        }
        TransformProperty11.prototype = {
            applyToMatrix: applyToMatrix11,
            getValue: processKeys11,
            precalculateMatrix: precalculateMatrix11,
            autoOrient: autoOrient11
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TransformProperty11);
        TransformProperty11.prototype.addDynamicProperty = addDynamicProperty11;
        TransformProperty11.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
        function getTransformProperty11(elem31, data11, container11) {
            return new TransformProperty11(elem31, data11, container11);
        }
        return {
            getTransformProperty: getTransformProperty11
        };
    }();
    function RepeaterModifier() {}
    extendPrototype([
        ShapeModifier
    ], RepeaterModifier);
    RepeaterModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.c = PropertyFactory.getProp(elem31, data11.c, 0, null, this);
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, null, this);
        this.tr = TransformPropertyFactory.getTransformProperty(elem31, data11.tr, this);
        this.so = PropertyFactory.getProp(elem31, data11.tr.so, 0, 0.01, this);
        this.eo = PropertyFactory.getProp(elem31, data11.tr.eo, 0, 0.01, this);
        this.data = data11;
        if (!this.dynamicProperties.length) this.getValue(true);
        this._isAnimated = !!this.dynamicProperties.length;
        this.pMatrix = new Matrix();
        this.rMatrix = new Matrix();
        this.sMatrix = new Matrix();
        this.tMatrix = new Matrix();
        this.matrix = new Matrix();
    };
    RepeaterModifier.prototype.applyTransforms = function(pMatrix11, rMatrix11, sMatrix11, transform11, perc11, inv11) {
        var dir11 = inv11 ? -1 : 1;
        var scaleX11 = transform11.s.v[0] + (1 - transform11.s.v[0]) * (1 - perc11);
        var scaleY11 = transform11.s.v[1] + (1 - transform11.s.v[1]) * (1 - perc11);
        pMatrix11.translate(transform11.p.v[0] * dir11 * perc11, transform11.p.v[1] * dir11 * perc11, transform11.p.v[2]);
        rMatrix11.translate(-transform11.a.v[0], -transform11.a.v[1], transform11.a.v[2]);
        rMatrix11.rotate(-transform11.r.v * dir11 * perc11);
        rMatrix11.translate(transform11.a.v[0], transform11.a.v[1], transform11.a.v[2]);
        sMatrix11.translate(-transform11.a.v[0], -transform11.a.v[1], transform11.a.v[2]);
        sMatrix11.scale(inv11 ? 1 / scaleX11 : scaleX11, inv11 ? 1 / scaleY11 : scaleY11);
        sMatrix11.translate(transform11.a.v[0], transform11.a.v[1], transform11.a.v[2]);
    };
    RepeaterModifier.prototype.init = function(elem31, arr31, pos11, elemsData11) {
        this.elem = elem31;
        this.arr = arr31;
        this.pos = pos11;
        this.elemsData = elemsData11;
        this._currentCopies = 0;
        this._elements = [];
        this._groups = [];
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem31);
        this.initModifierProperties(elem31, arr31[pos11]);
        while(pos11 > 0){
            pos11 -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);
            this._elements.unshift(arr31[pos11]);
        }
        if (this.dynamicProperties.length) this.k = true;
        else this.getValue(true);
    };
    RepeaterModifier.prototype.resetElements = function(elements11) {
        var i31;
        var len11 = elements11.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            elements11[i31]._processed = false;
            if (elements11[i31].ty === "gr") this.resetElements(elements11[i31].it);
        }
    };
    RepeaterModifier.prototype.cloneElements = function(elements11) {
        var newElements11 = JSON.parse(JSON.stringify(elements11));
        this.resetElements(newElements11);
        return newElements11;
    };
    RepeaterModifier.prototype.changeGroupRender = function(elements11, renderFlag11) {
        var i31;
        var len11 = elements11.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            elements11[i31]._render = renderFlag11;
            if (elements11[i31].ty === "gr") this.changeGroupRender(elements11[i31].it, renderFlag11);
        }
    };
    RepeaterModifier.prototype.processShapes = function(_isFirstFrame11) {
        var items11;
        var itemsTransform11;
        var i31;
        var dir11;
        var cont11;
        var hasReloaded11 = false;
        if (this._mdf || _isFirstFrame11) {
            var copies11 = Math.ceil(this.c.v);
            if (this._groups.length < copies11) {
                while(this._groups.length < copies11){
                    var group11 = {
                        it: this.cloneElements(this._elements),
                        ty: "gr"
                    };
                    group11.it.push({
                        a: {
                            a: 0,
                            ix: 1,
                            k: [
                                0,
                                0
                            ]
                        },
                        nm: "Transform",
                        o: {
                            a: 0,
                            ix: 7,
                            k: 100
                        },
                        p: {
                            a: 0,
                            ix: 2,
                            k: [
                                0,
                                0
                            ]
                        },
                        r: {
                            a: 1,
                            ix: 6,
                            k: [
                                {
                                    s: 0,
                                    e: 0,
                                    t: 0
                                },
                                {
                                    s: 0,
                                    e: 0,
                                    t: 1
                                }
                            ]
                        },
                        s: {
                            a: 0,
                            ix: 3,
                            k: [
                                100,
                                100
                            ]
                        },
                        sa: {
                            a: 0,
                            ix: 5,
                            k: 0
                        },
                        sk: {
                            a: 0,
                            ix: 4,
                            k: 0
                        },
                        ty: "tr"
                    });
                    this.arr.splice(0, 0, group11);
                    this._groups.splice(0, 0, group11);
                    this._currentCopies += 1;
                }
                this.elem.reloadShapes();
                hasReloaded11 = true;
            }
            cont11 = 0;
            var renderFlag11;
            for(i31 = 0; i31 <= this._groups.length - 1; i31 += 1){
                renderFlag11 = cont11 < copies11;
                this._groups[i31]._render = renderFlag11;
                this.changeGroupRender(this._groups[i31].it, renderFlag11);
                if (!renderFlag11) {
                    var elems11 = this.elemsData[i31].it;
                    var transformData11 = elems11[elems11.length - 1];
                    if (transformData11.transform.op.v !== 0) {
                        transformData11.transform.op._mdf = true;
                        transformData11.transform.op.v = 0;
                    } else transformData11.transform.op._mdf = false;
                }
                cont11 += 1;
            }
            this._currentCopies = copies11; /// /
            var offset11 = this.o.v;
            var offsetModulo11 = offset11 % 1;
            var roundOffset11 = offset11 > 0 ? Math.floor(offset11) : Math.ceil(offset11);
            var pProps11 = this.pMatrix.props;
            var rProps11 = this.rMatrix.props;
            var sProps11 = this.sMatrix.props;
            this.pMatrix.reset();
            this.rMatrix.reset();
            this.sMatrix.reset();
            this.tMatrix.reset();
            this.matrix.reset();
            var iteration11 = 0;
            if (offset11 > 0) {
                while(iteration11 < roundOffset11){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    iteration11 += 1;
                }
                if (offsetModulo11) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo11, false);
                    iteration11 += offsetModulo11;
                }
            } else if (offset11 < 0) {
                while(iteration11 > roundOffset11){
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
                    iteration11 -= 1;
                }
                if (offsetModulo11) {
                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo11, true);
                    iteration11 -= offsetModulo11;
                }
            }
            i31 = this.data.m === 1 ? 0 : this._currentCopies - 1;
            dir11 = this.data.m === 1 ? 1 : -1;
            cont11 = this._currentCopies;
            var j31;
            var jLen11;
            while(cont11){
                items11 = this.elemsData[i31].it;
                itemsTransform11 = items11[items11.length - 1].transform.mProps.v.props;
                jLen11 = itemsTransform11.length;
                items11[items11.length - 1].transform.mProps._mdf = true;
                items11[items11.length - 1].transform.op._mdf = true;
                items11[items11.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i31 / (this._currentCopies - 1));
                if (iteration11 !== 0) {
                    if (i31 !== 0 && dir11 === 1 || i31 !== this._currentCopies - 1 && dir11 === -1) this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
                    this.matrix.transform(rProps11[0], rProps11[1], rProps11[2], rProps11[3], rProps11[4], rProps11[5], rProps11[6], rProps11[7], rProps11[8], rProps11[9], rProps11[10], rProps11[11], rProps11[12], rProps11[13], rProps11[14], rProps11[15]);
                    this.matrix.transform(sProps11[0], sProps11[1], sProps11[2], sProps11[3], sProps11[4], sProps11[5], sProps11[6], sProps11[7], sProps11[8], sProps11[9], sProps11[10], sProps11[11], sProps11[12], sProps11[13], sProps11[14], sProps11[15]);
                    this.matrix.transform(pProps11[0], pProps11[1], pProps11[2], pProps11[3], pProps11[4], pProps11[5], pProps11[6], pProps11[7], pProps11[8], pProps11[9], pProps11[10], pProps11[11], pProps11[12], pProps11[13], pProps11[14], pProps11[15]);
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsTransform11[j31] = this.matrix.props[j31];
                    this.matrix.reset();
                } else {
                    this.matrix.reset();
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsTransform11[j31] = this.matrix.props[j31];
                }
                iteration11 += 1;
                cont11 -= 1;
                i31 += dir11;
            }
        } else {
            cont11 = this._currentCopies;
            i31 = 0;
            dir11 = 1;
            while(cont11){
                items11 = this.elemsData[i31].it;
                itemsTransform11 = items11[items11.length - 1].transform.mProps.v.props;
                items11[items11.length - 1].transform.mProps._mdf = false;
                items11[items11.length - 1].transform.op._mdf = false;
                cont11 -= 1;
                i31 += dir11;
            }
        }
        return hasReloaded11;
    };
    RepeaterModifier.prototype.addShape = function() {};
    function RoundCornersModifier() {}
    extendPrototype([
        ShapeModifier
    ], RoundCornersModifier);
    RoundCornersModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.rd = PropertyFactory.getProp(elem31, data11.r, 0, null, this);
        this._isAnimated = !!this.rd.effectsSequence.length;
    };
    RoundCornersModifier.prototype.processPath = function(path11, round11) {
        var clonedPath11 = shapePool.newElement();
        clonedPath11.c = path11.c;
        var i31;
        var len11 = path11._length;
        var currentV11;
        var currentI11;
        var currentO11;
        var closerV11;
        var distance11;
        var newPosPerc11;
        var index11 = 0;
        var vX11;
        var vY11;
        var oX11;
        var oY11;
        var iX11;
        var iY11;
        for(i31 = 0; i31 < len11; i31 += 1){
            currentV11 = path11.v[i31];
            currentO11 = path11.o[i31];
            currentI11 = path11.i[i31];
            if (currentV11[0] === currentO11[0] && currentV11[1] === currentO11[1] && currentV11[0] === currentI11[0] && currentV11[1] === currentI11[1]) {
                if ((i31 === 0 || i31 === len11 - 1) && !path11.c) {
                    clonedPath11.setTripleAt(currentV11[0], currentV11[1], currentO11[0], currentO11[1], currentI11[0], currentI11[1], index11);
                    /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */ index11 += 1;
                } else {
                    if (i31 === 0) closerV11 = path11.v[len11 - 1];
                    else closerV11 = path11.v[i31 - 1];
                    distance11 = Math.sqrt(Math.pow(currentV11[0] - closerV11[0], 2) + Math.pow(currentV11[1] - closerV11[1], 2));
                    newPosPerc11 = distance11 ? Math.min(distance11 / 2, round11) / distance11 : 0;
                    iX11 = currentV11[0] + (closerV11[0] - currentV11[0]) * newPosPerc11;
                    vX11 = iX11;
                    iY11 = currentV11[1] - (currentV11[1] - closerV11[1]) * newPosPerc11;
                    vY11 = iY11;
                    oX11 = vX11 - (vX11 - currentV11[0]) * roundCorner;
                    oY11 = vY11 - (vY11 - currentV11[1]) * roundCorner;
                    clonedPath11.setTripleAt(vX11, vY11, oX11, oY11, iX11, iY11, index11);
                    index11 += 1;
                    if (i31 === len11 - 1) closerV11 = path11.v[0];
                    else closerV11 = path11.v[i31 + 1];
                    distance11 = Math.sqrt(Math.pow(currentV11[0] - closerV11[0], 2) + Math.pow(currentV11[1] - closerV11[1], 2));
                    newPosPerc11 = distance11 ? Math.min(distance11 / 2, round11) / distance11 : 0;
                    oX11 = currentV11[0] + (closerV11[0] - currentV11[0]) * newPosPerc11;
                    vX11 = oX11;
                    oY11 = currentV11[1] + (closerV11[1] - currentV11[1]) * newPosPerc11;
                    vY11 = oY11;
                    iX11 = vX11 - (vX11 - currentV11[0]) * roundCorner;
                    iY11 = vY11 - (vY11 - currentV11[1]) * roundCorner;
                    clonedPath11.setTripleAt(vX11, vY11, oX11, oY11, iX11, iY11, index11);
                    index11 += 1;
                }
            } else {
                clonedPath11.setTripleAt(path11.v[i31][0], path11.v[i31][1], path11.o[i31][0], path11.o[i31][1], path11.i[i31][0], path11.i[i31][1], index11);
                index11 += 1;
            }
        }
        return clonedPath11;
    };
    RoundCornersModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var rd11 = this.rd.v;
        if (rd11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], rd11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function floatEqual(a31, b31) {
        return Math.abs(a31 - b31) * 100000 <= Math.min(Math.abs(a31), Math.abs(b31));
    }
    function floatZero(f31) {
        return Math.abs(f31) <= 0.00001;
    }
    function lerp(p011, p141, amount11) {
        return p011 * (1 - amount11) + p141 * amount11;
    }
    function lerpPoint(p011, p141, amount11) {
        return [
            lerp(p011[0], p141[0], amount11),
            lerp(p011[1], p141[1], amount11)
        ];
    }
    function quadRoots(a31, b31, c41) {
        // no root
        if (a31 === 0) return [];
        var s41 = b31 * b31 - 4 * a31 * c41; // Complex roots
        if (s41 < 0) return [];
        var singleRoot11 = -b31 / (2 * a31); // 1 root
        if (s41 === 0) return [
            singleRoot11
        ];
        var delta11 = Math.sqrt(s41) / (2 * a31); // 2 roots
        return [
            singleRoot11 - delta11,
            singleRoot11 + delta11
        ];
    }
    function polynomialCoefficients(p011, p141, p221, p311) {
        return [
            -p011 + 3 * p141 - 3 * p221 + p311,
            3 * p011 - 6 * p141 + 3 * p221,
            -3 * p011 + 3 * p141,
            p011
        ];
    }
    function singlePoint(p61) {
        return new PolynomialBezier(p61, p61, p61, p61, false);
    }
    function PolynomialBezier(p011, p141, p221, p311, linearize11) {
        if (linearize11 && pointEqual(p011, p141)) p141 = lerpPoint(p011, p311, 1 / 3);
        if (linearize11 && pointEqual(p221, p311)) p221 = lerpPoint(p011, p311, 2 / 3);
        var coeffx11 = polynomialCoefficients(p011[0], p141[0], p221[0], p311[0]);
        var coeffy11 = polynomialCoefficients(p011[1], p141[1], p221[1], p311[1]);
        this.a = [
            coeffx11[0],
            coeffy11[0]
        ];
        this.b = [
            coeffx11[1],
            coeffy11[1]
        ];
        this.c = [
            coeffx11[2],
            coeffy11[2]
        ];
        this.d = [
            coeffx11[3],
            coeffy11[3]
        ];
        this.points = [
            p011,
            p141,
            p221,
            p311
        ];
    }
    PolynomialBezier.prototype.point = function(t31) {
        return [
            ((this.a[0] * t31 + this.b[0]) * t31 + this.c[0]) * t31 + this.d[0],
            ((this.a[1] * t31 + this.b[1]) * t31 + this.c[1]) * t31 + this.d[1]
        ];
    };
    PolynomialBezier.prototype.derivative = function(t31) {
        return [
            (3 * t31 * this.a[0] + 2 * this.b[0]) * t31 + this.c[0],
            (3 * t31 * this.a[1] + 2 * this.b[1]) * t31 + this.c[1]
        ];
    };
    PolynomialBezier.prototype.tangentAngle = function(t31) {
        var p61 = this.derivative(t31);
        return Math.atan2(p61[1], p61[0]);
    };
    PolynomialBezier.prototype.normalAngle = function(t31) {
        var p61 = this.derivative(t31);
        return Math.atan2(p61[0], p61[1]);
    };
    PolynomialBezier.prototype.inflectionPoints = function() {
        var denom11 = this.a[1] * this.b[0] - this.a[0] * this.b[1];
        if (floatZero(denom11)) return [];
        var tcusp11 = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom11;
        var square11 = tcusp11 * tcusp11 - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom11;
        if (square11 < 0) return [];
        var root11 = Math.sqrt(square11);
        if (floatZero(root11)) {
            if (root11 > 0 && root11 < 1) return [
                tcusp11
            ];
            return [];
        }
        return [
            tcusp11 - root11,
            tcusp11 + root11
        ].filter(function(r11) {
            return r11 > 0 && r11 < 1;
        });
    };
    PolynomialBezier.prototype.split = function(t31) {
        if (t31 <= 0) return [
            singlePoint(this.points[0]),
            this
        ];
        if (t31 >= 1) return [
            this,
            singlePoint(this.points[this.points.length - 1])
        ];
        var p1011 = lerpPoint(this.points[0], this.points[1], t31);
        var p1111 = lerpPoint(this.points[1], this.points[2], t31);
        var p1211 = lerpPoint(this.points[2], this.points[3], t31);
        var p2011 = lerpPoint(p1011, p1111, t31);
        var p2111 = lerpPoint(p1111, p1211, t31);
        var p311 = lerpPoint(p2011, p2111, t31);
        return [
            new PolynomialBezier(this.points[0], p1011, p2011, p311, true),
            new PolynomialBezier(p311, p2111, p1211, this.points[3], true)
        ];
    };
    function extrema(bez11, comp11) {
        var min11 = bez11.points[0][comp11];
        var max11 = bez11.points[bez11.points.length - 1][comp11];
        if (min11 > max11) {
            var e31 = max11;
            max11 = min11;
            min11 = e31;
        } // Derivative roots to find min/max
        var f31 = quadRoots(3 * bez11.a[comp11], 2 * bez11.b[comp11], bez11.c[comp11]);
        for(var i31 = 0; i31 < f31.length; i31 += 1)if (f31[i31] > 0 && f31[i31] < 1) {
            var val31 = bez11.point(f31[i31])[comp11];
            if (val31 < min11) min11 = val31;
            else if (val31 > max11) max11 = val31;
        }
        return {
            min: min11,
            max: max11
        };
    }
    PolynomialBezier.prototype.bounds = function() {
        return {
            x: extrema(this, 0),
            y: extrema(this, 1)
        };
    };
    PolynomialBezier.prototype.boundingBox = function() {
        var bounds11 = this.bounds();
        return {
            left: bounds11.x.min,
            right: bounds11.x.max,
            top: bounds11.y.min,
            bottom: bounds11.y.max,
            width: bounds11.x.max - bounds11.x.min,
            height: bounds11.y.max - bounds11.y.min,
            cx: (bounds11.x.max + bounds11.x.min) / 2,
            cy: (bounds11.y.max + bounds11.y.min) / 2
        };
    };
    function intersectData(bez11, t111, t211) {
        var box11 = bez11.boundingBox();
        return {
            cx: box11.cx,
            cy: box11.cy,
            width: box11.width,
            height: box11.height,
            bez: bez11,
            t: (t111 + t211) / 2,
            t1: t111,
            t2: t211
        };
    }
    function splitData(data11) {
        var split11 = data11.bez.split(0.5);
        return [
            intersectData(split11[0], data11.t1, data11.t),
            intersectData(split11[1], data11.t, data11.t2)
        ];
    }
    function boxIntersect(b111, b211) {
        return Math.abs(b111.cx - b211.cx) * 2 < b111.width + b211.width && Math.abs(b111.cy - b211.cy) * 2 < b111.height + b211.height;
    }
    function intersectsImpl(d111, d211, depth11, tolerance11, intersections11, maxRecursion11) {
        if (!boxIntersect(d111, d211)) return;
        if (depth11 >= maxRecursion11 || d111.width <= tolerance11 && d111.height <= tolerance11 && d211.width <= tolerance11 && d211.height <= tolerance11) {
            intersections11.push([
                d111.t,
                d211.t
            ]);
            return;
        }
        var d1s11 = splitData(d111);
        var d2s11 = splitData(d211);
        intersectsImpl(d1s11[0], d2s11[0], depth11 + 1, tolerance11, intersections11, maxRecursion11);
        intersectsImpl(d1s11[0], d2s11[1], depth11 + 1, tolerance11, intersections11, maxRecursion11);
        intersectsImpl(d1s11[1], d2s11[0], depth11 + 1, tolerance11, intersections11, maxRecursion11);
        intersectsImpl(d1s11[1], d2s11[1], depth11 + 1, tolerance11, intersections11, maxRecursion11);
    }
    PolynomialBezier.prototype.intersections = function(other11, tolerance11, maxRecursion11) {
        if (tolerance11 === undefined) tolerance11 = 2;
        if (maxRecursion11 === undefined) maxRecursion11 = 7;
        var intersections11 = [];
        intersectsImpl(intersectData(this, 0, 1), intersectData(other11, 0, 1), 0, tolerance11, intersections11, maxRecursion11);
        return intersections11;
    };
    PolynomialBezier.shapeSegment = function(shapePath11, index11) {
        var nextIndex11 = (index11 + 1) % shapePath11.length();
        return new PolynomialBezier(shapePath11.v[index11], shapePath11.o[index11], shapePath11.i[nextIndex11], shapePath11.v[nextIndex11], true);
    };
    PolynomialBezier.shapeSegmentInverted = function(shapePath11, index11) {
        var nextIndex11 = (index11 + 1) % shapePath11.length();
        return new PolynomialBezier(shapePath11.v[nextIndex11], shapePath11.i[nextIndex11], shapePath11.o[index11], shapePath11.v[index11], true);
    };
    function crossProduct(a31, b31) {
        return [
            a31[1] * b31[2] - a31[2] * b31[1],
            a31[2] * b31[0] - a31[0] * b31[2],
            a31[0] * b31[1] - a31[1] * b31[0]
        ];
    }
    function lineIntersection(start111, end111, start211, end211) {
        var v111 = [
            start111[0],
            start111[1],
            1
        ];
        var v211 = [
            end111[0],
            end111[1],
            1
        ];
        var v311 = [
            start211[0],
            start211[1],
            1
        ];
        var v411 = [
            end211[0],
            end211[1],
            1
        ];
        var r11 = crossProduct(crossProduct(v111, v211), crossProduct(v311, v411));
        if (floatZero(r11[2])) return null;
        return [
            r11[0] / r11[2],
            r11[1] / r11[2]
        ];
    }
    function polarOffset(p61, angle11, length11) {
        return [
            p61[0] + Math.cos(angle11) * length11,
            p61[1] - Math.sin(angle11) * length11
        ];
    }
    function pointDistance(p141, p221) {
        return Math.hypot(p141[0] - p221[0], p141[1] - p221[1]);
    }
    function pointEqual(p141, p221) {
        return floatEqual(p141[0], p221[0]) && floatEqual(p141[1], p221[1]);
    }
    function ZigZagModifier() {}
    extendPrototype([
        ShapeModifier
    ], ZigZagModifier);
    ZigZagModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.amplitude = PropertyFactory.getProp(elem31, data11.s, 0, null, this);
        this.frequency = PropertyFactory.getProp(elem31, data11.r, 0, null, this);
        this.pointsType = PropertyFactory.getProp(elem31, data11.pt, 0, null, this);
        this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(outputBezier11, point11, angle11, direction11, amplitude11, outAmplitude11, inAmplitude11) {
        var angO11 = angle11 - Math.PI / 2;
        var angI11 = angle11 + Math.PI / 2;
        var px11 = point11[0] + Math.cos(angle11) * direction11 * amplitude11;
        var py11 = point11[1] - Math.sin(angle11) * direction11 * amplitude11;
        outputBezier11.setTripleAt(px11, py11, px11 + Math.cos(angO11) * outAmplitude11, py11 - Math.sin(angO11) * outAmplitude11, px11 + Math.cos(angI11) * inAmplitude11, py11 - Math.sin(angI11) * inAmplitude11, outputBezier11.length());
    }
    function getPerpendicularVector(pt111, pt211) {
        var vector11 = [
            pt211[0] - pt111[0],
            pt211[1] - pt111[1]
        ];
        var rot11 = -Math.PI * 0.5;
        var rotatedVector11 = [
            Math.cos(rot11) * vector11[0] - Math.sin(rot11) * vector11[1],
            Math.sin(rot11) * vector11[0] + Math.cos(rot11) * vector11[1]
        ];
        return rotatedVector11;
    }
    function getProjectingAngle(path11, cur11) {
        var prevIndex11 = cur11 === 0 ? path11.length() - 1 : cur11 - 1;
        var nextIndex11 = (cur11 + 1) % path11.length();
        var prevPoint11 = path11.v[prevIndex11];
        var nextPoint11 = path11.v[nextIndex11];
        var pVector11 = getPerpendicularVector(prevPoint11, nextPoint11);
        return Math.atan2(0, 1) - Math.atan2(pVector11[1], pVector11[0]);
    }
    function zigZagCorner(outputBezier11, path11, cur11, amplitude11, frequency11, pointType11, direction11) {
        var angle11 = getProjectingAngle(path11, cur11);
        var point11 = path11.v[cur11 % path11._length];
        var prevPoint11 = path11.v[cur11 === 0 ? path11._length - 1 : cur11 - 1];
        var nextPoint11 = path11.v[(cur11 + 1) % path11._length];
        var prevDist11 = pointType11 === 2 ? Math.sqrt(Math.pow(point11[0] - prevPoint11[0], 2) + Math.pow(point11[1] - prevPoint11[1], 2)) : 0;
        var nextDist11 = pointType11 === 2 ? Math.sqrt(Math.pow(point11[0] - nextPoint11[0], 2) + Math.pow(point11[1] - nextPoint11[1], 2)) : 0;
        setPoint(outputBezier11, path11.v[cur11 % path11._length], angle11, direction11, amplitude11, nextDist11 / ((frequency11 + 1) * 2), prevDist11 / ((frequency11 + 1) * 2), pointType11);
    }
    function zigZagSegment(outputBezier11, segment11, amplitude11, frequency11, pointType11, direction11) {
        for(var i31 = 0; i31 < frequency11; i31 += 1){
            var t31 = (i31 + 1) / (frequency11 + 1);
            var dist41 = pointType11 === 2 ? Math.sqrt(Math.pow(segment11.points[3][0] - segment11.points[0][0], 2) + Math.pow(segment11.points[3][1] - segment11.points[0][1], 2)) : 0;
            var angle11 = segment11.normalAngle(t31);
            var point11 = segment11.point(t31);
            setPoint(outputBezier11, point11, angle11, direction11, amplitude11, dist41 / ((frequency11 + 1) * 2), dist41 / ((frequency11 + 1) * 2), pointType11);
            direction11 = -direction11;
        }
        return direction11;
    }
    ZigZagModifier.prototype.processPath = function(path11, amplitude11, frequency11, pointType11) {
        var count11 = path11._length;
        var clonedPath11 = shapePool.newElement();
        clonedPath11.c = path11.c;
        if (!path11.c) count11 -= 1;
        if (count11 === 0) return clonedPath11;
        var direction11 = -1;
        var segment11 = PolynomialBezier.shapeSegment(path11, 0);
        zigZagCorner(clonedPath11, path11, 0, amplitude11, frequency11, pointType11, direction11);
        for(var i31 = 0; i31 < count11; i31 += 1){
            direction11 = zigZagSegment(clonedPath11, segment11, amplitude11, frequency11, pointType11, -direction11);
            if (i31 === count11 - 1 && !path11.c) segment11 = null;
            else segment11 = PolynomialBezier.shapeSegment(path11, (i31 + 1) % count11);
            zigZagCorner(clonedPath11, path11, i31 + 1, amplitude11, frequency11, pointType11, direction11);
        }
        return clonedPath11;
    };
    ZigZagModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var amplitude11 = this.amplitude.v;
        var frequency11 = Math.max(0, Math.round(this.frequency.v));
        var pointType11 = this.pointsType.v;
        if (amplitude11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], amplitude11, frequency11, pointType11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function linearOffset(p141, p221, amount11) {
        var angle11 = Math.atan2(p221[0] - p141[0], p221[1] - p141[1]);
        return [
            polarOffset(p141, angle11, amount11),
            polarOffset(p221, angle11, amount11)
        ];
    }
    function offsetSegment(segment11, amount11) {
        var p011;
        var p1a11;
        var p1b11;
        var p2b11;
        var p2a11;
        var p311;
        var e31;
        e31 = linearOffset(segment11.points[0], segment11.points[1], amount11);
        p011 = e31[0];
        p1a11 = e31[1];
        e31 = linearOffset(segment11.points[1], segment11.points[2], amount11);
        p1b11 = e31[0];
        p2b11 = e31[1];
        e31 = linearOffset(segment11.points[2], segment11.points[3], amount11);
        p2a11 = e31[0];
        p311 = e31[1];
        var p141 = lineIntersection(p011, p1a11, p1b11, p2b11);
        if (p141 === null) p141 = p1a11;
        var p221 = lineIntersection(p2a11, p311, p1b11, p2b11);
        if (p221 === null) p221 = p2a11;
        return new PolynomialBezier(p011, p141, p221, p311);
    }
    function joinLines(outputBezier11, seg111, seg211, lineJoin11, miterLimit11) {
        var p011 = seg111.points[3];
        var p141 = seg211.points[0]; // Bevel
        if (lineJoin11 === 3) return p011; // Connected, they don't need a joint
        if (pointEqual(p011, p141)) return p011; // Round
        if (lineJoin11 === 2) {
            var angleOut11 = -seg111.tangentAngle(1);
            var angleIn11 = -seg211.tangentAngle(0) + Math.PI;
            var center11 = lineIntersection(p011, polarOffset(p011, angleOut11 + Math.PI / 2, 100), p141, polarOffset(p141, angleOut11 + Math.PI / 2, 100));
            var radius11 = center11 ? pointDistance(center11, p011) : pointDistance(p011, p141) / 2;
            var tan11 = polarOffset(p011, angleOut11, 2 * radius11 * roundCorner);
            outputBezier11.setXYAt(tan11[0], tan11[1], "o", outputBezier11.length() - 1);
            tan11 = polarOffset(p141, angleIn11, 2 * radius11 * roundCorner);
            outputBezier11.setTripleAt(p141[0], p141[1], p141[0], p141[1], tan11[0], tan11[1], outputBezier11.length());
            return p141;
        } // Miter
        var t011 = pointEqual(p011, seg111.points[2]) ? seg111.points[0] : seg111.points[2];
        var t111 = pointEqual(p141, seg211.points[1]) ? seg211.points[3] : seg211.points[1];
        var intersection11 = lineIntersection(t011, p011, p141, t111);
        if (intersection11 && pointDistance(intersection11, p011) < miterLimit11) {
            outputBezier11.setTripleAt(intersection11[0], intersection11[1], intersection11[0], intersection11[1], intersection11[0], intersection11[1], outputBezier11.length());
            return intersection11;
        }
        return p011;
    }
    function getIntersection(a31, b31) {
        var intersect11 = a31.intersections(b31);
        if (intersect11.length && floatEqual(intersect11[0][0], 1)) intersect11.shift();
        if (intersect11.length) return intersect11[0];
        return null;
    }
    function pruneSegmentIntersection(a31, b31) {
        var outa11 = a31.slice();
        var outb11 = b31.slice();
        var intersect11 = getIntersection(a31[a31.length - 1], b31[0]);
        if (intersect11) {
            outa11[a31.length - 1] = a31[a31.length - 1].split(intersect11[0])[0];
            outb11[0] = b31[0].split(intersect11[1])[1];
        }
        if (a31.length > 1 && b31.length > 1) {
            intersect11 = getIntersection(a31[0], b31[b31.length - 1]);
            if (intersect11) return [
                [
                    a31[0].split(intersect11[0])[0]
                ],
                [
                    b31[b31.length - 1].split(intersect11[1])[1]
                ]
            ];
        }
        return [
            outa11,
            outb11
        ];
    }
    function pruneIntersections(segments11) {
        var e31;
        for(var i31 = 1; i31 < segments11.length; i31 += 1){
            e31 = pruneSegmentIntersection(segments11[i31 - 1], segments11[i31]);
            segments11[i31 - 1] = e31[0];
            segments11[i31] = e31[1];
        }
        if (segments11.length > 1) {
            e31 = pruneSegmentIntersection(segments11[segments11.length - 1], segments11[0]);
            segments11[segments11.length - 1] = e31[0];
            segments11[0] = e31[1];
        }
        return segments11;
    }
    function offsetSegmentSplit(segment11, amount11) {
        /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */ var flex11 = segment11.inflectionPoints();
        var left11;
        var right11;
        var split11;
        var mid11;
        if (flex11.length === 0) return [
            offsetSegment(segment11, amount11)
        ];
        if (flex11.length === 1 || floatEqual(flex11[1], 1)) {
            split11 = segment11.split(flex11[0]);
            left11 = split11[0];
            right11 = split11[1];
            return [
                offsetSegment(left11, amount11),
                offsetSegment(right11, amount11)
            ];
        }
        split11 = segment11.split(flex11[0]);
        left11 = split11[0];
        var t31 = (flex11[1] - flex11[0]) / (1 - flex11[0]);
        split11 = split11[1].split(t31);
        mid11 = split11[0];
        right11 = split11[1];
        return [
            offsetSegment(left11, amount11),
            offsetSegment(mid11, amount11),
            offsetSegment(right11, amount11)
        ];
    }
    function OffsetPathModifier() {}
    extendPrototype([
        ShapeModifier
    ], OffsetPathModifier);
    OffsetPathModifier.prototype.initModifierProperties = function(elem31, data11) {
        this.getValue = this.processKeys;
        this.amount = PropertyFactory.getProp(elem31, data11.a, 0, null, this);
        this.miterLimit = PropertyFactory.getProp(elem31, data11.ml, 0, null, this);
        this.lineJoin = data11.lj;
        this._isAnimated = this.amount.effectsSequence.length !== 0;
    };
    OffsetPathModifier.prototype.processPath = function(inputBezier11, amount11, lineJoin11, miterLimit11) {
        var outputBezier11 = shapePool.newElement();
        outputBezier11.c = inputBezier11.c;
        var count11 = inputBezier11.length();
        if (!inputBezier11.c) count11 -= 1;
        var i31;
        var j31;
        var segment11;
        var multiSegments11 = [];
        for(i31 = 0; i31 < count11; i31 += 1){
            segment11 = PolynomialBezier.shapeSegment(inputBezier11, i31);
            multiSegments11.push(offsetSegmentSplit(segment11, amount11));
        }
        if (!inputBezier11.c) for(i31 = count11 - 1; i31 >= 0; i31 -= 1){
            segment11 = PolynomialBezier.shapeSegmentInverted(inputBezier11, i31);
            multiSegments11.push(offsetSegmentSplit(segment11, amount11));
        }
        multiSegments11 = pruneIntersections(multiSegments11); // Add bezier segments to the output and apply line joints
        var lastPoint11 = null;
        var lastSeg11 = null;
        for(i31 = 0; i31 < multiSegments11.length; i31 += 1){
            var multiSegment11 = multiSegments11[i31];
            if (lastSeg11) lastPoint11 = joinLines(outputBezier11, lastSeg11, multiSegment11[0], lineJoin11, miterLimit11);
            lastSeg11 = multiSegment11[multiSegment11.length - 1];
            for(j31 = 0; j31 < multiSegment11.length; j31 += 1){
                segment11 = multiSegment11[j31];
                if (lastPoint11 && pointEqual(segment11.points[0], lastPoint11)) outputBezier11.setXYAt(segment11.points[1][0], segment11.points[1][1], "o", outputBezier11.length() - 1);
                else outputBezier11.setTripleAt(segment11.points[0][0], segment11.points[0][1], segment11.points[1][0], segment11.points[1][1], segment11.points[0][0], segment11.points[0][1], outputBezier11.length());
                outputBezier11.setTripleAt(segment11.points[3][0], segment11.points[3][1], segment11.points[3][0], segment11.points[3][1], segment11.points[2][0], segment11.points[2][1], outputBezier11.length());
                lastPoint11 = segment11.points[3];
            }
        }
        if (multiSegments11.length) joinLines(outputBezier11, lastSeg11, multiSegments11[0][0], lineJoin11, miterLimit11);
        return outputBezier11;
    };
    OffsetPathModifier.prototype.processShapes = function(_isFirstFrame11) {
        var shapePaths11;
        var i31;
        var len11 = this.shapes.length;
        var j31;
        var jLen11;
        var amount11 = this.amount.v;
        var miterLimit11 = this.miterLimit.v;
        var lineJoin11 = this.lineJoin;
        if (amount11 !== 0) {
            var shapeData11;
            var localShapeCollection11;
            for(i31 = 0; i31 < len11; i31 += 1){
                shapeData11 = this.shapes[i31];
                localShapeCollection11 = shapeData11.localShapeCollection;
                if (!(!shapeData11.shape._mdf && !this._mdf && !_isFirstFrame11)) {
                    localShapeCollection11.releaseShapes();
                    shapeData11.shape._mdf = true;
                    shapePaths11 = shapeData11.shape.paths.shapes;
                    jLen11 = shapeData11.shape.paths._length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)localShapeCollection11.addShape(this.processPath(shapePaths11[j31], amount11, lineJoin11, miterLimit11));
                }
                shapeData11.shape.paths = shapeData11.localShapeCollection;
            }
        }
        if (!this.dynamicProperties.length) this._mdf = false;
    };
    function getFontProperties(fontData11) {
        var styles11 = fontData11.fStyle ? fontData11.fStyle.split(" ") : [];
        var fWeight11 = "normal";
        var fStyle11 = "normal";
        var len11 = styles11.length;
        var styleName11;
        for(var i31 = 0; i31 < len11; i31 += 1){
            styleName11 = styles11[i31].toLowerCase();
            switch(styleName11){
                case "italic":
                    fStyle11 = "italic";
                    break;
                case "bold":
                    fWeight11 = "700";
                    break;
                case "black":
                    fWeight11 = "900";
                    break;
                case "medium":
                    fWeight11 = "500";
                    break;
                case "regular":
                case "normal":
                    fWeight11 = "400";
                    break;
                case "light":
                case "thin":
                    fWeight11 = "200";
                    break;
                default:
                    break;
            }
        }
        return {
            style: fStyle11,
            weight: fontData11.fWeight || fWeight11
        };
    }
    var FontManager = function() {
        var maxWaitingTime11 = 5000;
        var emptyChar11 = {
            w: 0,
            size: 0,
            shapes: [],
            data: {
                shapes: []
            }
        };
        var combinedCharacters11 = []; // Hindi characters
        combinedCharacters11 = combinedCharacters11.concat([
            2304,
            2305,
            2306,
            2307,
            2362,
            2363,
            2364,
            2364,
            2366,
            2367,
            2368,
            2369,
            2370,
            2371,
            2372,
            2373,
            2374,
            2375,
            2376,
            2377,
            2378,
            2379,
            2380,
            2381,
            2382,
            2383,
            2387,
            2388,
            2389,
            2390,
            2391,
            2402,
            2403
        ]);
        var surrogateModifiers11 = [
            "d83cdffb",
            "d83cdffc",
            "d83cdffd",
            "d83cdffe",
            "d83cdfff"
        ];
        var zeroWidthJoiner11 = [
            65039,
            8205
        ];
        function trimFontOptions11(font11) {
            var familyArray11 = font11.split(",");
            var i31;
            var len11 = familyArray11.length;
            var enabledFamilies11 = [];
            for(i31 = 0; i31 < len11; i31 += 1)if (familyArray11[i31] !== "sans-serif" && familyArray11[i31] !== "monospace") enabledFamilies11.push(familyArray11[i31]);
            return enabledFamilies11.join(",");
        }
        function setUpNode11(font11, family11) {
            var parentNode11 = createTag("span"); // Node is invisible to screen readers.
            parentNode11.setAttribute("aria-hidden", true);
            parentNode11.style.fontFamily = family11;
            var node11 = createTag("span"); // Characters that vary significantly among different fonts
            node11.innerText = "giItT1WQy@!-/#"; // Visible - so we can measure it - but not on the screen
            parentNode11.style.position = "absolute";
            parentNode11.style.left = "-10000px";
            parentNode11.style.top = "-10000px"; // Large font size makes even subtle changes obvious
            parentNode11.style.fontSize = "300px"; // Reset any font properties
            parentNode11.style.fontVariant = "normal";
            parentNode11.style.fontStyle = "normal";
            parentNode11.style.fontWeight = "normal";
            parentNode11.style.letterSpacing = "0";
            parentNode11.appendChild(node11);
            document.body.appendChild(parentNode11); // Remember width with no applied web font
            var width11 = node11.offsetWidth;
            node11.style.fontFamily = trimFontOptions11(font11) + ", " + family11;
            return {
                node: node11,
                w: width11,
                parent: parentNode11
            };
        }
        function checkLoadedFonts11() {
            var i31;
            var len11 = this.fonts.length;
            var node11;
            var w11;
            var loadedCount11 = len11;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (this.fonts[i31].loaded) loadedCount11 -= 1;
                else if (this.fonts[i31].fOrigin === "n" || this.fonts[i31].origin === 0) this.fonts[i31].loaded = true;
                else {
                    node11 = this.fonts[i31].monoCase.node;
                    w11 = this.fonts[i31].monoCase.w;
                    if (node11.offsetWidth !== w11) {
                        loadedCount11 -= 1;
                        this.fonts[i31].loaded = true;
                    } else {
                        node11 = this.fonts[i31].sansCase.node;
                        w11 = this.fonts[i31].sansCase.w;
                        if (node11.offsetWidth !== w11) {
                            loadedCount11 -= 1;
                            this.fonts[i31].loaded = true;
                        }
                    }
                    if (this.fonts[i31].loaded) {
                        this.fonts[i31].sansCase.parent.parentNode.removeChild(this.fonts[i31].sansCase.parent);
                        this.fonts[i31].monoCase.parent.parentNode.removeChild(this.fonts[i31].monoCase.parent);
                    }
                }
            }
            if (loadedCount11 !== 0 && Date.now() - this.initTime < maxWaitingTime11) setTimeout(this.checkLoadedFontsBinded, 20);
            else setTimeout(this.setIsLoadedBinded, 10);
        }
        function createHelper11(fontData11, def11) {
            var engine11 = document.body && def11 ? "svg" : "canvas";
            var helper11;
            var fontProps11 = getFontProperties(fontData11);
            if (engine11 === "svg") {
                var tHelper11 = createNS("text");
                tHelper11.style.fontSize = "100px"; // tHelper.style.fontFamily = fontData.fFamily;
                tHelper11.setAttribute("font-family", fontData11.fFamily);
                tHelper11.setAttribute("font-style", fontProps11.style);
                tHelper11.setAttribute("font-weight", fontProps11.weight);
                tHelper11.textContent = "1";
                if (fontData11.fClass) {
                    tHelper11.style.fontFamily = "inherit";
                    tHelper11.setAttribute("class", fontData11.fClass);
                } else tHelper11.style.fontFamily = fontData11.fFamily;
                def11.appendChild(tHelper11);
                helper11 = tHelper11;
            } else {
                var tCanvasHelper11 = new OffscreenCanvas(500, 500).getContext("2d");
                tCanvasHelper11.font = fontProps11.style + " " + fontProps11.weight + " 100px " + fontData11.fFamily;
                helper11 = tCanvasHelper11;
            }
            function measure11(text11) {
                if (engine11 === "svg") {
                    helper11.textContent = text11;
                    return helper11.getComputedTextLength();
                }
                return helper11.measureText(text11).width;
            }
            return {
                measureText: measure11
            };
        }
        function addFonts11(fontData11, defs11) {
            if (!fontData11) {
                this.isLoaded = true;
                return;
            }
            if (this.chars) {
                this.isLoaded = true;
                this.fonts = fontData11.list;
                return;
            }
            if (!document.body) {
                this.isLoaded = true;
                fontData11.list.forEach(function(data11) {
                    data11.helper = createHelper11(data11);
                    data11.cache = {};
                });
                this.fonts = fontData11.list;
                return;
            }
            var fontArr11 = fontData11.list;
            var i31;
            var len11 = fontArr11.length;
            var _pendingFonts11 = len11;
            for(i31 = 0; i31 < len11; i31 += 1){
                var shouldLoadFont11 = true;
                var loadedSelector11;
                var j31;
                fontArr11[i31].loaded = false;
                fontArr11[i31].monoCase = setUpNode11(fontArr11[i31].fFamily, "monospace");
                fontArr11[i31].sansCase = setUpNode11(fontArr11[i31].fFamily, "sans-serif");
                if (!fontArr11[i31].fPath) {
                    fontArr11[i31].loaded = true;
                    _pendingFonts11 -= 1;
                } else if (fontArr11[i31].fOrigin === "p" || fontArr11[i31].origin === 3) {
                    loadedSelector11 = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr11[i31].fFamily + '"], style[f-origin="3"][f-family="' + fontArr11[i31].fFamily + '"]');
                    if (loadedSelector11.length > 0) shouldLoadFont11 = false;
                    if (shouldLoadFont11) {
                        var s41 = createTag("style");
                        s41.setAttribute("f-forigin", fontArr11[i31].fOrigin);
                        s41.setAttribute("f-origin", fontArr11[i31].origin);
                        s41.setAttribute("f-family", fontArr11[i31].fFamily);
                        s41.type = "text/css";
                        s41.innerText = "@font-face {font-family: " + fontArr11[i31].fFamily + "; font-style: normal; src: url('" + fontArr11[i31].fPath + "');}";
                        defs11.appendChild(s41);
                    }
                } else if (fontArr11[i31].fOrigin === "g" || fontArr11[i31].origin === 1) {
                    loadedSelector11 = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');
                    for(j31 = 0; j31 < loadedSelector11.length; j31 += 1)if (loadedSelector11[j31].href.indexOf(fontArr11[i31].fPath) !== -1) // Font is already loaded
                    shouldLoadFont11 = false;
                    if (shouldLoadFont11) {
                        var l31 = createTag("link");
                        l31.setAttribute("f-forigin", fontArr11[i31].fOrigin);
                        l31.setAttribute("f-origin", fontArr11[i31].origin);
                        l31.type = "text/css";
                        l31.rel = "stylesheet";
                        l31.href = fontArr11[i31].fPath;
                        document.body.appendChild(l31);
                    }
                } else if (fontArr11[i31].fOrigin === "t" || fontArr11[i31].origin === 2) {
                    loadedSelector11 = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');
                    for(j31 = 0; j31 < loadedSelector11.length; j31 += 1)if (fontArr11[i31].fPath === loadedSelector11[j31].src) // Font is already loaded
                    shouldLoadFont11 = false;
                    if (shouldLoadFont11) {
                        var sc11 = createTag("link");
                        sc11.setAttribute("f-forigin", fontArr11[i31].fOrigin);
                        sc11.setAttribute("f-origin", fontArr11[i31].origin);
                        sc11.setAttribute("rel", "stylesheet");
                        sc11.setAttribute("href", fontArr11[i31].fPath);
                        defs11.appendChild(sc11);
                    }
                }
                fontArr11[i31].helper = createHelper11(fontArr11[i31], defs11);
                fontArr11[i31].cache = {};
                this.fonts.push(fontArr11[i31]);
            }
            if (_pendingFonts11 === 0) this.isLoaded = true;
            else // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
            // Adding this timeout seems to fix it
            setTimeout(this.checkLoadedFonts.bind(this), 100);
        }
        function addChars11(chars11) {
            if (!chars11) return;
            if (!this.chars) this.chars = [];
            var i31;
            var len11 = chars11.length;
            var j31;
            var jLen11 = this.chars.length;
            var found11;
            for(i31 = 0; i31 < len11; i31 += 1){
                j31 = 0;
                found11 = false;
                while(j31 < jLen11){
                    if (this.chars[j31].style === chars11[i31].style && this.chars[j31].fFamily === chars11[i31].fFamily && this.chars[j31].ch === chars11[i31].ch) found11 = true;
                    j31 += 1;
                }
                if (!found11) {
                    this.chars.push(chars11[i31]);
                    jLen11 += 1;
                }
            }
        }
        function getCharData11(_char11, style11, font11) {
            var i31 = 0;
            var len11 = this.chars.length;
            while(i31 < len11){
                if (this.chars[i31].ch === _char11 && this.chars[i31].style === style11 && this.chars[i31].fFamily === font11) return this.chars[i31];
                i31 += 1;
            }
            if ((typeof _char11 === "string" && _char11.charCodeAt(0) !== 13 || !_char11) && console && console.warn // eslint-disable-line no-console
             && !this._warned) {
                this._warned = true;
                console.warn("Missing character from exported characters list: ", _char11, style11, font11); // eslint-disable-line no-console
            }
            return emptyChar11;
        }
        function measureText11(_char211, fontName11, size11) {
            var fontData11 = this.getFontByName(fontName11);
            var index11 = _char211.charCodeAt(0);
            if (!fontData11.cache[index11 + 1]) {
                var tHelper11 = fontData11.helper;
                if (_char211 === " ") {
                    var doubleSize11 = tHelper11.measureText("|" + _char211 + "|");
                    var singleSize11 = tHelper11.measureText("||");
                    fontData11.cache[index11 + 1] = (doubleSize11 - singleSize11) / 100;
                } else fontData11.cache[index11 + 1] = tHelper11.measureText(_char211) / 100;
            }
            return fontData11.cache[index11 + 1] * size11;
        }
        function getFontByName11(name11) {
            var i31 = 0;
            var len11 = this.fonts.length;
            while(i31 < len11){
                if (this.fonts[i31].fName === name11) return this.fonts[i31];
                i31 += 1;
            }
            return this.fonts[0];
        }
        function isModifier11(firstCharCode11, secondCharCode11) {
            var sum11 = firstCharCode11.toString(16) + secondCharCode11.toString(16);
            return surrogateModifiers11.indexOf(sum11) !== -1;
        }
        function isZeroWidthJoiner11(firstCharCode11, secondCharCode11) {
            if (!secondCharCode11) return firstCharCode11 === zeroWidthJoiner11[1];
            return firstCharCode11 === zeroWidthJoiner11[0] && secondCharCode11 === zeroWidthJoiner11[1];
        }
        function isCombinedCharacter11(_char311) {
            return combinedCharacters11.indexOf(_char311) !== -1;
        }
        function setIsLoaded11() {
            this.isLoaded = true;
        }
        var Font11 = function Font11() {
            this.fonts = [];
            this.chars = null;
            this.typekitLoaded = 0;
            this.isLoaded = false;
            this._warned = false;
            this.initTime = Date.now();
            this.setIsLoadedBinded = this.setIsLoaded.bind(this);
            this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
        };
        Font11.isModifier = isModifier11;
        Font11.isZeroWidthJoiner = isZeroWidthJoiner11;
        Font11.isCombinedCharacter = isCombinedCharacter11;
        var fontPrototype11 = {
            addChars: addChars11,
            addFonts: addFonts11,
            getCharData: getCharData11,
            getFontByName: getFontByName11,
            measureText: measureText11,
            checkLoadedFonts: checkLoadedFonts11,
            setIsLoaded: setIsLoaded11
        };
        Font11.prototype = fontPrototype11;
        return Font11;
    }();
    function SlotManager(animationData11) {
        this.animationData = animationData11;
    }
    SlotManager.prototype.getProp = function(data11) {
        if (this.animationData.slots && this.animationData.slots[data11.sid]) return Object.assign(data11, this.animationData.slots[data11.sid].p);
        return data11;
    };
    function slotFactory(animationData11) {
        return new SlotManager(animationData11);
    }
    function RenderableElement() {}
    RenderableElement.prototype = {
        initRenderable: function initRenderable11() {
            // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
            this.isInRange = false; // layer's display state
            this.hidden = false; // If layer's transparency equals 0, it can be hidden
            this.isTransparent = false; // list of animated components
            this.renderableComponents = [];
        },
        addRenderableComponent: function addRenderableComponent11(component11) {
            if (this.renderableComponents.indexOf(component11) === -1) this.renderableComponents.push(component11);
        },
        removeRenderableComponent: function removeRenderableComponent11(component11) {
            if (this.renderableComponents.indexOf(component11) !== -1) this.renderableComponents.splice(this.renderableComponents.indexOf(component11), 1);
        },
        prepareRenderableFrame: function prepareRenderableFrame11(num11) {
            this.checkLayerLimits(num11);
        },
        checkTransparency: function checkTransparency11() {
            if (this.finalTransform.mProp.o.v <= 0) {
                if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
                    this.isTransparent = true;
                    this.hide();
                }
            } else if (this.isTransparent) {
                this.isTransparent = false;
                this.show();
            }
        },
        /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */ checkLayerLimits: function checkLayerLimits11(num11) {
            if (this.data.ip - this.data.st <= num11 && this.data.op - this.data.st > num11) {
                if (this.isInRange !== true) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                    this.isInRange = true;
                    this.show();
                }
            } else if (this.isInRange !== false) {
                this.globalData._mdf = true;
                this.isInRange = false;
                this.hide();
            }
        },
        renderRenderable: function renderRenderable11() {
            var i31;
            var len11 = this.renderableComponents.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.renderableComponents[i31].renderFrame(this._isFirstFrame);
        /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */ },
        sourceRectAtTime: function sourceRectAtTime11() {
            return {
                top: 0,
                left: 0,
                width: 100,
                height: 100
            };
        },
        getLayerSize: function getLayerSize11() {
            if (this.data.ty === 5) return {
                w: this.data.textData.width,
                h: this.data.textData.height
            };
            return {
                w: this.data.width,
                h: this.data.height
            };
        }
    };
    var getBlendMode = function() {
        var blendModeEnums11 = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        };
        return function(mode11) {
            return blendModeEnums11[mode11] || "";
        };
    }();
    function SliderEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function AngleEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function ColorEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 1, 0, container11);
    }
    function PointEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 1, 0, container11);
    }
    function LayerIndexEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function MaskIndexEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function CheckboxEffect(data11, elem31, container11) {
        this.p = PropertyFactory.getProp(elem31, data11.v, 0, 0, container11);
    }
    function NoValueEffect() {
        this.p = {};
    }
    function EffectsManager(data11, element11) {
        var effects11 = data11.ef || [];
        this.effectElements = [];
        var i31;
        var len11 = effects11.length;
        var effectItem11;
        for(i31 = 0; i31 < len11; i31 += 1){
            effectItem11 = new GroupEffect(effects11[i31], element11);
            this.effectElements.push(effectItem11);
        }
    }
    function GroupEffect(data11, element11) {
        this.init(data11, element11);
    }
    extendPrototype([
        DynamicPropertyContainer
    ], GroupEffect);
    GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;
    GroupEffect.prototype.init = function(data11, element11) {
        this.data = data11;
        this.effectElements = [];
        this.initDynamicPropertyContainer(element11);
        var i31;
        var len11 = this.data.ef.length;
        var eff11;
        var effects11 = this.data.ef;
        for(i31 = 0; i31 < len11; i31 += 1){
            eff11 = null;
            switch(effects11[i31].ty){
                case 0:
                    eff11 = new SliderEffect(effects11[i31], element11, this);
                    break;
                case 1:
                    eff11 = new AngleEffect(effects11[i31], element11, this);
                    break;
                case 2:
                    eff11 = new ColorEffect(effects11[i31], element11, this);
                    break;
                case 3:
                    eff11 = new PointEffect(effects11[i31], element11, this);
                    break;
                case 4:
                case 7:
                    eff11 = new CheckboxEffect(effects11[i31], element11, this);
                    break;
                case 10:
                    eff11 = new LayerIndexEffect(effects11[i31], element11, this);
                    break;
                case 11:
                    eff11 = new MaskIndexEffect(effects11[i31], element11, this);
                    break;
                case 5:
                    eff11 = new EffectsManager(effects11[i31], element11, this);
                    break;
                // case 6:
                default:
                    eff11 = new NoValueEffect(effects11[i31], element11, this);
                    break;
            }
            if (eff11) this.effectElements.push(eff11);
        }
    };
    function BaseElement() {}
    BaseElement.prototype = {
        checkMasks: function checkMasks11() {
            if (!this.data.hasMask) return false;
            var i31 = 0;
            var len11 = this.data.masksProperties.length;
            while(i31 < len11){
                if (this.data.masksProperties[i31].mode !== "n" && this.data.masksProperties[i31].cl !== false) return true;
                i31 += 1;
            }
            return false;
        },
        initExpressions: function initExpressions11() {
            var expressionsInterfaces11 = getExpressionInterfaces();
            if (!expressionsInterfaces11) return;
            var LayerExpressionInterface11 = expressionsInterfaces11("layer");
            var EffectsExpressionInterface11 = expressionsInterfaces11("effects");
            var ShapeExpressionInterface11 = expressionsInterfaces11("shape");
            var TextExpressionInterface11 = expressionsInterfaces11("text");
            var CompExpressionInterface11 = expressionsInterfaces11("comp");
            this.layerInterface = LayerExpressionInterface11(this);
            if (this.data.hasMask && this.maskManager) this.layerInterface.registerMaskInterface(this.maskManager);
            var effectsInterface11 = EffectsExpressionInterface11.createEffectsInterface(this, this.layerInterface);
            this.layerInterface.registerEffectsInterface(effectsInterface11);
            if (this.data.ty === 0 || this.data.xt) this.compInterface = CompExpressionInterface11(this);
            else if (this.data.ty === 4) {
                this.layerInterface.shapeInterface = ShapeExpressionInterface11(this.shapesData, this.itemsData, this.layerInterface);
                this.layerInterface.content = this.layerInterface.shapeInterface;
            } else if (this.data.ty === 5) {
                this.layerInterface.textInterface = TextExpressionInterface11(this);
                this.layerInterface.text = this.layerInterface.textInterface;
            }
        },
        setBlendMode: function setBlendMode11() {
            var blendModeValue11 = getBlendMode(this.data.bm);
            var elem31 = this.baseElement || this.layerElement;
            elem31.style["mix-blend-mode"] = blendModeValue11;
        },
        initBaseData: function initBaseData11(data11, globalData11, comp11) {
            this.globalData = globalData11;
            this.comp = comp11;
            this.data = data11;
            this.layerId = createElementID(); // Stretch factor for old animations missing this property.
            if (!this.data.sr) this.data.sr = 1;
             // effects manager
            this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
        },
        getType: function getType11() {
            return this.type;
        },
        sourceRectAtTime: function sourceRectAtTime11() {}
    };
    /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */ function FrameElement() {}
    FrameElement.prototype = {
        /**
       * @function
       * Initializes frame related properties.
       *
       */ initFrame: function initFrame11() {
            // set to true when inpoint is rendered
            this._isFirstFrame = false; // list of animated properties
            this.dynamicProperties = []; // If layer has been modified in current tick this will be true
            this._mdf = false;
        },
        /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */ prepareProperties: function prepareProperties11(num11, isVisible11) {
            var i31;
            var len11 = this.dynamicProperties.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (isVisible11 || this._isParent && this.dynamicProperties[i31].propType === "transform") {
                this.dynamicProperties[i31].getValue();
                if (this.dynamicProperties[i31]._mdf) {
                    this.globalData._mdf = true;
                    this._mdf = true;
                }
            }
        },
        addDynamicProperty: function addDynamicProperty11(prop11) {
            if (this.dynamicProperties.indexOf(prop11) === -1) this.dynamicProperties.push(prop11);
        }
    };
    function FootageElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData11.getAssetData(data11.refId);
        this.footageData = globalData11.imageLoader.getAsset(this.assetData);
        this.initBaseData(data11, globalData11, comp11);
    }
    FootageElement.prototype.prepareFrame = function() {};
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], FootageElement);
    FootageElement.prototype.getBaseElement = function() {
        return null;
    };
    FootageElement.prototype.renderFrame = function() {};
    FootageElement.prototype.destroy = function() {};
    FootageElement.prototype.initExpressions = function() {
        var expressionsInterfaces11 = getExpressionInterfaces();
        if (!expressionsInterfaces11) return;
        var FootageInterface11 = expressionsInterfaces11("footage");
        this.layerInterface = FootageInterface11(this);
    };
    FootageElement.prototype.getFootageData = function() {
        return this.footageData;
    };
    function AudioElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initRenderable();
        this.assetData = globalData11.getAssetData(data11.refId);
        this.initBaseData(data11, globalData11, comp11);
        this._isPlaying = false;
        this._canPlay = false;
        var assetPath11 = this.globalData.getAssetsPath(this.assetData);
        this.audio = this.globalData.audioController.createAudio(assetPath11);
        this._currentTime = 0;
        this.globalData.audioController.addAudio(this);
        this._volumeMultiplier = 1;
        this._volume = 1;
        this._previousVolume = null;
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
        this.lv = PropertyFactory.getProp(this, data11.au && data11.au.lv ? data11.au.lv : {
            k: [
                100
            ]
        }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(num11) {
        this.prepareRenderableFrame(num11, true);
        this.prepareProperties(num11, true);
        if (!this.tm._placeholder) {
            var timeRemapped11 = this.tm.v;
            this._currentTime = timeRemapped11;
        } else this._currentTime = num11 / this.data.sr;
        this._volume = this.lv.v[0];
        var totalVolume11 = this._volume * this._volumeMultiplier;
        if (this._previousVolume !== totalVolume11) {
            this._previousVolume = totalVolume11;
            this.audio.volume(totalVolume11);
        }
    };
    extendPrototype([
        RenderableElement,
        BaseElement,
        FrameElement
    ], AudioElement);
    AudioElement.prototype.renderFrame = function() {
        if (this.isInRange && this._canPlay) {
            if (!this._isPlaying) {
                this.audio.play();
                this.audio.seek(this._currentTime / this.globalData.frameRate);
                this._isPlaying = true;
            } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) this.audio.seek(this._currentTime / this.globalData.frameRate);
        }
    };
    AudioElement.prototype.show = function() {};
    AudioElement.prototype.hide = function() {
        this.audio.pause();
        this._isPlaying = false;
    };
    AudioElement.prototype.pause = function() {
        this.audio.pause();
        this._isPlaying = false;
        this._canPlay = false;
    };
    AudioElement.prototype.resume = function() {
        this._canPlay = true;
    };
    AudioElement.prototype.setRate = function(rateValue11) {
        this.audio.rate(rateValue11);
    };
    AudioElement.prototype.volume = function(volumeValue11) {
        this._volumeMultiplier = volumeValue11;
        this._previousVolume = volumeValue11 * this._volume;
        this.audio.volume(this._previousVolume);
    };
    AudioElement.prototype.getBaseElement = function() {
        return null;
    };
    AudioElement.prototype.destroy = function() {};
    AudioElement.prototype.sourceRectAtTime = function() {};
    AudioElement.prototype.initExpressions = function() {};
    function BaseRenderer() {}
    BaseRenderer.prototype.checkLayers = function(num11) {
        var i31;
        var len11 = this.layers.length;
        var data11;
        this.completeLayers = true;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
            if (!this.elements[i31]) {
                data11 = this.layers[i31];
                if (data11.ip - data11.st <= num11 - this.layers[i31].st && data11.op - data11.st > num11 - this.layers[i31].st) this.buildItem(i31);
            }
            this.completeLayers = this.elements[i31] ? this.completeLayers : false;
        }
        this.checkPendingElements();
    };
    BaseRenderer.prototype.createItem = function(layer11) {
        switch(layer11.ty){
            case 2:
                return this.createImage(layer11);
            case 0:
                return this.createComp(layer11);
            case 1:
                return this.createSolid(layer11);
            case 3:
                return this.createNull(layer11);
            case 4:
                return this.createShape(layer11);
            case 5:
                return this.createText(layer11);
            case 6:
                return this.createAudio(layer11);
            case 13:
                return this.createCamera(layer11);
            case 15:
                return this.createFootage(layer11);
            default:
                return this.createNull(layer11);
        }
    };
    BaseRenderer.prototype.createCamera = function() {
        throw new Error("You're using a 3d camera. Try the html renderer.");
    };
    BaseRenderer.prototype.createAudio = function(data11) {
        return new AudioElement(data11, this.globalData, this);
    };
    BaseRenderer.prototype.createFootage = function(data11) {
        return new FootageElement(data11, this.globalData, this);
    };
    BaseRenderer.prototype.buildAllItems = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.buildItem(i31);
        this.checkPendingElements();
    };
    BaseRenderer.prototype.includeLayers = function(newLayers11) {
        this.completeLayers = false;
        var i31;
        var len11 = newLayers11.length;
        var j31;
        var jLen11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            j31 = 0;
            while(j31 < jLen11){
                if (this.layers[j31].id === newLayers11[i31].id) {
                    this.layers[j31] = newLayers11[i31];
                    break;
                }
                j31 += 1;
            }
        }
    };
    BaseRenderer.prototype.setProjectInterface = function(pInterface11) {
        this.globalData.projectInterface = pInterface11;
    };
    BaseRenderer.prototype.initItems = function() {
        if (!this.globalData.progressiveLoad) this.buildAllItems();
    };
    BaseRenderer.prototype.buildElementParenting = function(element11, parentName11, hierarchy11) {
        var elements11 = this.elements;
        var layers11 = this.layers;
        var i31 = 0;
        var len11 = layers11.length;
        while(i31 < len11){
            if (layers11[i31].ind == parentName11) {
                // eslint-disable-line eqeqeq
                if (!elements11[i31] || elements11[i31] === true) {
                    this.buildItem(i31);
                    this.addPendingElement(element11);
                } else {
                    hierarchy11.push(elements11[i31]);
                    elements11[i31].setAsParent();
                    if (layers11[i31].parent !== undefined) this.buildElementParenting(element11, layers11[i31].parent, hierarchy11);
                    else element11.setHierarchy(hierarchy11);
                }
            }
            i31 += 1;
        }
    };
    BaseRenderer.prototype.addPendingElement = function(element11) {
        this.pendingElements.push(element11);
    };
    BaseRenderer.prototype.searchExtraCompositions = function(assets11) {
        var i31;
        var len11 = assets11.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (assets11[i31].xt) {
            var comp11 = this.createComp(assets11[i31]);
            comp11.initExpressions();
            this.globalData.projectInterface.registerComposition(comp11);
        }
    };
    BaseRenderer.prototype.getElementById = function(ind11) {
        var i31;
        var len11 = this.elements.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.elements[i31].data.ind === ind11) return this.elements[i31];
        }
        return null;
    };
    BaseRenderer.prototype.getElementByPath = function(path11) {
        var pathValue11 = path11.shift();
        var element11;
        if (typeof pathValue11 === "number") element11 = this.elements[pathValue11];
        else {
            var i31;
            var len11 = this.elements.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31].data.nm === pathValue11) {
                element11 = this.elements[i31];
                break;
            }
        }
        if (path11.length === 0) return element11;
        return element11.getElementByPath(path11);
    };
    BaseRenderer.prototype.setupGlobalData = function(animData11, fontsContainer11) {
        this.globalData.fontManager = new FontManager();
        this.globalData.slotManager = slotFactory(animData11);
        this.globalData.fontManager.addChars(animData11.chars);
        this.globalData.fontManager.addFonts(animData11.fonts, fontsContainer11);
        this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
        this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
        this.globalData.imageLoader = this.animationItem.imagePreloader;
        this.globalData.audioController = this.animationItem.audioController;
        this.globalData.frameId = 0;
        this.globalData.frameRate = animData11.fr;
        this.globalData.nm = animData11.nm;
        this.globalData.compSize = {
            w: animData11.w,
            h: animData11.h
        };
    };
    var effectTypes = {
        TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {}
    TransformElement.prototype = {
        initTransform: function initTransform11() {
            var mat11 = new Matrix();
            this.finalTransform = {
                mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                    o: 0
                },
                _matMdf: false,
                _localMatMdf: false,
                _opMdf: false,
                mat: mat11,
                localMat: mat11,
                localOpacity: 1
            };
            if (this.data.ao) this.finalTransform.mProp.autoOriented = true;
             // TODO: check TYPE 11: Guided elements
            this.data.ty;
        },
        renderTransform: function renderTransform11() {
            this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
            this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;
            if (this.hierarchy) {
                var mat11;
                var finalMat11 = this.finalTransform.mat;
                var i31 = 0;
                var len11 = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.
                if (!this.finalTransform._matMdf) while(i31 < len11){
                    if (this.hierarchy[i31].finalTransform.mProp._mdf) {
                        this.finalTransform._matMdf = true;
                        break;
                    }
                    i31 += 1;
                }
                if (this.finalTransform._matMdf) {
                    mat11 = this.finalTransform.mProp.v.props;
                    finalMat11.cloneFromProps(mat11);
                    for(i31 = 0; i31 < len11; i31 += 1)finalMat11.multiply(this.hierarchy[i31].finalTransform.mProp.v);
                }
            }
            if (this.finalTransform._matMdf) this.finalTransform._localMatMdf = this.finalTransform._matMdf;
            if (this.finalTransform._opMdf) this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
        },
        renderLocalTransform: function renderLocalTransform11() {
            if (this.localTransforms) {
                var i31 = 0;
                var len11 = this.localTransforms.length;
                this.finalTransform._localMatMdf = this.finalTransform._matMdf;
                if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) while(i31 < len11){
                    if (this.localTransforms[i31]._mdf) this.finalTransform._localMatMdf = true;
                    if (this.localTransforms[i31]._opMdf) this.finalTransform._opMdf = true;
                    i31 += 1;
                }
                if (this.finalTransform._localMatMdf) {
                    var localMat11 = this.finalTransform.localMat;
                    this.localTransforms[0].matrix.clone(localMat11);
                    for(i31 = 1; i31 < len11; i31 += 1){
                        var lmat11 = this.localTransforms[i31].matrix;
                        localMat11.multiply(lmat11);
                    }
                    localMat11.multiply(this.finalTransform.mat);
                }
                if (this.finalTransform._opMdf) {
                    var localOp11 = this.finalTransform.localOpacity;
                    for(i31 = 0; i31 < len11; i31 += 1)localOp11 *= this.localTransforms[i31].opacity * 0.01;
                    this.finalTransform.localOpacity = localOp11;
                }
            }
        },
        searchEffectTransforms: function searchEffectTransforms11() {
            if (this.renderableEffectsManager) {
                var transformEffects11 = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                if (transformEffects11.length) {
                    this.localTransforms = [];
                    this.finalTransform.localMat = new Matrix();
                    var i31 = 0;
                    var len11 = transformEffects11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)this.localTransforms.push(transformEffects11[i31]);
                }
            }
        },
        globalToLocal: function globalToLocal11(pt51) {
            var transforms11 = [];
            transforms11.push(this.finalTransform);
            var flag11 = true;
            var comp11 = this.comp;
            while(flag11)if (comp11.finalTransform) {
                if (comp11.data.hasMask) transforms11.splice(0, 0, comp11.finalTransform);
                comp11 = comp11.comp;
            } else flag11 = false;
            var i31;
            var len11 = transforms11.length;
            var ptNew11;
            for(i31 = 0; i31 < len11; i31 += 1){
                ptNew11 = transforms11[i31].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
                pt51 = [
                    pt51[0] - ptNew11[0],
                    pt51[1] - ptNew11[1],
                    0
                ];
            }
            return pt51;
        },
        mHelper: new Matrix()
    };
    function MaskElement(data11, element11, globalData11) {
        this.data = data11;
        this.element = element11;
        this.globalData = globalData11;
        this.storedData = [];
        this.masksProperties = this.data.masksProperties || [];
        this.maskElement = null;
        var defs11 = this.globalData.defs;
        var i31;
        var len11 = this.masksProperties ? this.masksProperties.length : 0;
        this.viewData = createSizedArray(len11);
        this.solidPath = "";
        var path11;
        var properties11 = this.masksProperties;
        var count11 = 0;
        var currentMasks11 = [];
        var j31;
        var jLen11;
        var layerId11 = createElementID();
        var rect11;
        var expansor11;
        var feMorph11;
        var x41;
        var maskType11 = "clipPath";
        var maskRef11 = "clip-path";
        for(i31 = 0; i31 < len11; i31 += 1){
            if (properties11[i31].mode !== "a" && properties11[i31].mode !== "n" || properties11[i31].inv || properties11[i31].o.k !== 100 || properties11[i31].o.x) {
                maskType11 = "mask";
                maskRef11 = "mask";
            }
            if ((properties11[i31].mode === "s" || properties11[i31].mode === "i") && count11 === 0) {
                rect11 = createNS("rect");
                rect11.setAttribute("fill", "#ffffff");
                rect11.setAttribute("width", this.element.comp.data.w || 0);
                rect11.setAttribute("height", this.element.comp.data.h || 0);
                currentMasks11.push(rect11);
            } else rect11 = null;
            path11 = createNS("path");
            if (properties11[i31].mode === "n") {
                // TODO move this to a factory or to a constructor
                this.viewData[i31] = {
                    op: PropertyFactory.getProp(this.element, properties11[i31].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties11[i31], 3),
                    elem: path11,
                    lastPath: ""
                };
                defs11.appendChild(path11);
            } else {
                count11 += 1;
                path11.setAttribute("fill", properties11[i31].mode === "s" ? "#000000" : "#ffffff");
                path11.setAttribute("clip-rule", "nonzero");
                var filterID11;
                if (properties11[i31].x.k !== 0) {
                    maskType11 = "mask";
                    maskRef11 = "mask";
                    x41 = PropertyFactory.getProp(this.element, properties11[i31].x, 0, null, this.element);
                    filterID11 = createElementID();
                    expansor11 = createNS("filter");
                    expansor11.setAttribute("id", filterID11);
                    feMorph11 = createNS("feMorphology");
                    feMorph11.setAttribute("operator", "erode");
                    feMorph11.setAttribute("in", "SourceGraphic");
                    feMorph11.setAttribute("radius", "0");
                    expansor11.appendChild(feMorph11);
                    defs11.appendChild(expansor11);
                    path11.setAttribute("stroke", properties11[i31].mode === "s" ? "#000000" : "#ffffff");
                } else {
                    feMorph11 = null;
                    x41 = null;
                } // TODO move this to a factory or to a constructor
                this.storedData[i31] = {
                    elem: path11,
                    x: x41,
                    expan: feMorph11,
                    lastPath: "",
                    lastOperator: "",
                    filterId: filterID11,
                    lastRadius: 0
                };
                if (properties11[i31].mode === "i") {
                    jLen11 = currentMasks11.length;
                    var g31 = createNS("g");
                    for(j31 = 0; j31 < jLen11; j31 += 1)g31.appendChild(currentMasks11[j31]);
                    var mask11 = createNS("mask");
                    mask11.setAttribute("mask-type", "alpha");
                    mask11.setAttribute("id", layerId11 + "_" + count11);
                    mask11.appendChild(path11);
                    defs11.appendChild(mask11);
                    g31.setAttribute("mask", "url(" + getLocationHref() + "#" + layerId11 + "_" + count11 + ")");
                    currentMasks11.length = 0;
                    currentMasks11.push(g31);
                } else currentMasks11.push(path11);
                if (properties11[i31].inv && !this.solidPath) this.solidPath = this.createLayerSolidPath();
                 // TODO move this to a factory or to a constructor
                this.viewData[i31] = {
                    elem: path11,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, properties11[i31].o, 0, 0.01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, properties11[i31], 3),
                    invRect: rect11
                };
                if (!this.viewData[i31].prop.k) this.drawPath(properties11[i31], this.viewData[i31].prop.v, this.viewData[i31]);
            }
        }
        this.maskElement = createNS(maskType11);
        len11 = currentMasks11.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.maskElement.appendChild(currentMasks11[i31]);
        if (count11 > 0) {
            this.maskElement.setAttribute("id", layerId11);
            this.element.maskedElement.setAttribute(maskRef11, "url(" + getLocationHref() + "#" + layerId11 + ")");
            defs11.appendChild(this.maskElement);
        }
        if (this.viewData.length) this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(pos11) {
        return this.viewData[pos11].prop;
    };
    MaskElement.prototype.renderFrame = function(isFirstFrame11) {
        var finalMat11 = this.element.finalTransform.mat;
        var i31;
        var len11 = this.masksProperties.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.viewData[i31].prop._mdf || isFirstFrame11) this.drawPath(this.masksProperties[i31], this.viewData[i31].prop.v, this.viewData[i31]);
            if (this.viewData[i31].op._mdf || isFirstFrame11) this.viewData[i31].elem.setAttribute("fill-opacity", this.viewData[i31].op.v);
            if (this.masksProperties[i31].mode !== "n") {
                if (this.viewData[i31].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame11)) this.viewData[i31].invRect.setAttribute("transform", finalMat11.getInverseMatrix().to2dCSS());
                if (this.storedData[i31].x && (this.storedData[i31].x._mdf || isFirstFrame11)) {
                    var feMorph11 = this.storedData[i31].expan;
                    if (this.storedData[i31].x.v < 0) {
                        if (this.storedData[i31].lastOperator !== "erode") {
                            this.storedData[i31].lastOperator = "erode";
                            this.storedData[i31].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[i31].filterId + ")");
                        }
                        feMorph11.setAttribute("radius", -this.storedData[i31].x.v);
                    } else {
                        if (this.storedData[i31].lastOperator !== "dilate") {
                            this.storedData[i31].lastOperator = "dilate";
                            this.storedData[i31].elem.setAttribute("filter", null);
                        }
                        this.storedData[i31].elem.setAttribute("stroke-width", this.storedData[i31].x.v * 2);
                    }
                }
            }
        }
    };
    MaskElement.prototype.getMaskelement = function() {
        return this.maskElement;
    };
    MaskElement.prototype.createLayerSolidPath = function() {
        var path11 = "M0,0 ";
        path11 += " h" + this.globalData.compSize.w;
        path11 += " v" + this.globalData.compSize.h;
        path11 += " h-" + this.globalData.compSize.w;
        path11 += " v-" + this.globalData.compSize.h + " ";
        return path11;
    };
    MaskElement.prototype.drawPath = function(pathData11, pathNodes11, viewData11) {
        var pathString11 = " M" + pathNodes11.v[0][0] + "," + pathNodes11.v[0][1];
        var i31;
        var len11;
        len11 = pathNodes11._length;
        for(i31 = 1; i31 < len11; i31 += 1)// pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
        pathString11 += " C" + pathNodes11.o[i31 - 1][0] + "," + pathNodes11.o[i31 - 1][1] + " " + pathNodes11.i[i31][0] + "," + pathNodes11.i[i31][1] + " " + pathNodes11.v[i31][0] + "," + pathNodes11.v[i31][1];
         // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
        if (pathNodes11.c && len11 > 1) pathString11 += " C" + pathNodes11.o[i31 - 1][0] + "," + pathNodes11.o[i31 - 1][1] + " " + pathNodes11.i[0][0] + "," + pathNodes11.i[0][1] + " " + pathNodes11.v[0][0] + "," + pathNodes11.v[0][1];
         // pathNodes.__renderedString = pathString;
        if (viewData11.lastPath !== pathString11) {
            var pathShapeValue11 = "";
            if (viewData11.elem) {
                if (pathNodes11.c) pathShapeValue11 = pathData11.inv ? this.solidPath + pathString11 : pathString11;
                viewData11.elem.setAttribute("d", pathShapeValue11);
            }
            viewData11.lastPath = pathString11;
        }
    };
    MaskElement.prototype.destroy = function() {
        this.element = null;
        this.globalData = null;
        this.maskElement = null;
        this.data = null;
        this.masksProperties = null;
    };
    var filtersFactory = function() {
        var ob11 = {};
        ob11.createFilter = createFilter11;
        ob11.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter11;
        function createFilter11(filId11, skipCoordinates11) {
            var fil11 = createNS("filter");
            fil11.setAttribute("id", filId11);
            if (skipCoordinates11 !== true) {
                fil11.setAttribute("filterUnits", "objectBoundingBox");
                fil11.setAttribute("x", "0%");
                fil11.setAttribute("y", "0%");
                fil11.setAttribute("width", "100%");
                fil11.setAttribute("height", "100%");
            }
            return fil11;
        }
        function createAlphaToLuminanceFilter11() {
            var feColorMatrix11 = createNS("feColorMatrix");
            feColorMatrix11.setAttribute("type", "matrix");
            feColorMatrix11.setAttribute("color-interpolation-filters", "sRGB");
            feColorMatrix11.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1");
            return feColorMatrix11;
        }
        return ob11;
    }();
    var featureSupport = function() {
        var ob11 = {
            maskType: true,
            svgLumaHidden: true,
            offscreenCanvas: typeof OffscreenCanvas !== "undefined"
        };
        if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) ob11.maskType = false;
        if (/firefox/i.test(navigator.userAgent)) ob11.svgLumaHidden = false;
        return ob11;
    }();
    var registeredEffects$1 = {};
    var idPrefix = "filter_result_";
    function SVGEffects(elem31) {
        var i31;
        var source11 = "SourceGraphic";
        var len11 = elem31.data.ef ? elem31.data.ef.length : 0;
        var filId11 = createElementID();
        var fil11 = filtersFactory.createFilter(filId11, true);
        var count11 = 0;
        this.filters = [];
        var filterManager11;
        for(i31 = 0; i31 < len11; i31 += 1){
            filterManager11 = null;
            var type11 = elem31.data.ef[i31].ty;
            if (registeredEffects$1[type11]) {
                var Effect11 = registeredEffects$1[type11].effect;
                filterManager11 = new Effect11(fil11, elem31.effectsManager.effectElements[i31], elem31, idPrefix + count11, source11);
                source11 = idPrefix + count11;
                if (registeredEffects$1[type11].countsAsEffect) count11 += 1;
            }
            if (filterManager11) this.filters.push(filterManager11);
        }
        if (count11) {
            elem31.globalData.defs.appendChild(fil11);
            elem31.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + filId11 + ")");
        }
        if (this.filters.length) elem31.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(_isFirstFrame11) {
        var i31;
        var len11 = this.filters.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.filters[i31].renderFrame(_isFirstFrame11);
    };
    SVGEffects.prototype.getEffects = function(type11) {
        var i31;
        var len11 = this.filters.length;
        var effects11 = [];
        for(i31 = 0; i31 < len11; i31 += 1)if (this.filters[i31].type === type11) effects11.push(this.filters[i31]);
        return effects11;
    };
    function registerEffect$1(id11, effect11, countsAsEffect11) {
        registeredEffects$1[id11] = {
            effect: effect11,
            countsAsEffect: countsAsEffect11
        };
    }
    function SVGBaseElement() {}
    SVGBaseElement.prototype = {
        initRendererElement: function initRendererElement11() {
            this.layerElement = createNS("g");
        },
        createContainerElements: function createContainerElements11() {
            this.matteElement = createNS("g");
            this.transformedElement = this.layerElement;
            this.maskedElement = this.layerElement;
            this._sizeChanged = false;
            var layerElementParent11 = null; // If this layer acts as a mask for the following layer
            if (this.data.td) {
                this.matteMasks = {};
                var gg11 = createNS("g");
                gg11.setAttribute("id", this.layerId);
                gg11.appendChild(this.layerElement);
                layerElementParent11 = gg11;
                this.globalData.defs.appendChild(gg11);
            } else if (this.data.tt) {
                this.matteElement.appendChild(this.layerElement);
                layerElementParent11 = this.matteElement;
                this.baseElement = this.matteElement;
            } else this.baseElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
             // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped
            if (this.data.ty === 0 && !this.data.hd) {
                var cp11 = createNS("clipPath");
                var pt51 = createNS("path");
                pt51.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                var clipId11 = createElementID();
                cp11.setAttribute("id", clipId11);
                cp11.appendChild(pt51);
                this.globalData.defs.appendChild(cp11);
                if (this.checkMasks()) {
                    var cpGroup11 = createNS("g");
                    cpGroup11.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId11 + ")");
                    cpGroup11.appendChild(this.layerElement);
                    this.transformedElement = cpGroup11;
                    if (layerElementParent11) layerElementParent11.appendChild(this.transformedElement);
                    else this.baseElement = this.transformedElement;
                } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + clipId11 + ")");
            }
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement11() {
            if (this.finalTransform._localMatMdf) this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS());
            if (this.finalTransform._opMdf) this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
        },
        destroyBaseElement: function destroyBaseElement11() {
            this.layerElement = null;
            this.matteElement = null;
            this.maskManager.destroy();
        },
        getBaseElement: function getBaseElement11() {
            if (this.data.hd) return null;
            return this.baseElement;
        },
        createRenderableComponents: function createRenderableComponents11() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
            this.renderableEffectsManager = new SVGEffects(this);
            this.searchEffectTransforms();
        },
        getMatte: function getMatte11(matteType11) {
            // This should not be a common case. But for backward compatibility, we'll create the matte object.
            // It solves animations that have two consecutive layers marked as matte masks.
            // Which is an undefined behavior in AE.
            if (!this.matteMasks) this.matteMasks = {};
            if (!this.matteMasks[matteType11]) {
                var id11 = this.layerId + "_" + matteType11;
                var filId11;
                var fil11;
                var useElement11;
                var gg11;
                if (matteType11 === 1 || matteType11 === 3) {
                    var masker11 = createNS("mask");
                    masker11.setAttribute("id", id11);
                    masker11.setAttribute("mask-type", matteType11 === 3 ? "luminance" : "alpha");
                    useElement11 = createNS("use");
                    useElement11.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    masker11.appendChild(useElement11);
                    this.globalData.defs.appendChild(masker11);
                    if (!featureSupport.maskType && matteType11 === 1) {
                        masker11.setAttribute("mask-type", "luminance");
                        filId11 = createElementID();
                        fil11 = filtersFactory.createFilter(filId11);
                        this.globalData.defs.appendChild(fil11);
                        fil11.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg11 = createNS("g");
                        gg11.appendChild(useElement11);
                        masker11.appendChild(gg11);
                        gg11.setAttribute("filter", "url(" + getLocationHref() + "#" + filId11 + ")");
                    }
                } else if (matteType11 === 2) {
                    var maskGroup11 = createNS("mask");
                    maskGroup11.setAttribute("id", id11);
                    maskGroup11.setAttribute("mask-type", "alpha");
                    var maskGrouper11 = createNS("g");
                    maskGroup11.appendChild(maskGrouper11);
                    filId11 = createElementID();
                    fil11 = filtersFactory.createFilter(filId11); /// /
                    var feCTr11 = createNS("feComponentTransfer");
                    feCTr11.setAttribute("in", "SourceGraphic");
                    fil11.appendChild(feCTr11);
                    var feFunc11 = createNS("feFuncA");
                    feFunc11.setAttribute("type", "table");
                    feFunc11.setAttribute("tableValues", "1.0 0.0");
                    feCTr11.appendChild(feFunc11); /// /
                    this.globalData.defs.appendChild(fil11);
                    var alphaRect11 = createNS("rect");
                    alphaRect11.setAttribute("width", this.comp.data.w);
                    alphaRect11.setAttribute("height", this.comp.data.h);
                    alphaRect11.setAttribute("x", "0");
                    alphaRect11.setAttribute("y", "0");
                    alphaRect11.setAttribute("fill", "#ffffff");
                    alphaRect11.setAttribute("opacity", "0");
                    maskGrouper11.setAttribute("filter", "url(" + getLocationHref() + "#" + filId11 + ")");
                    maskGrouper11.appendChild(alphaRect11);
                    useElement11 = createNS("use");
                    useElement11.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId);
                    maskGrouper11.appendChild(useElement11);
                    if (!featureSupport.maskType) {
                        maskGroup11.setAttribute("mask-type", "luminance");
                        fil11.appendChild(filtersFactory.createAlphaToLuminanceFilter());
                        gg11 = createNS("g");
                        maskGrouper11.appendChild(alphaRect11);
                        gg11.appendChild(this.layerElement);
                        maskGrouper11.appendChild(gg11);
                    }
                    this.globalData.defs.appendChild(maskGroup11);
                }
                this.matteMasks[matteType11] = id11;
            }
            return this.matteMasks[matteType11];
        },
        setMatte: function setMatte11(id11) {
            if (!this.matteElement) return;
            this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + id11 + ")");
        }
    };
    /**
   * @file
   * Handles AE's layer parenting property.
   *
   */ function HierarchyElement() {}
    HierarchyElement.prototype = {
        /**
       * @function
       * Initializes hierarchy properties
       *
       */ initHierarchy: function initHierarchy11() {
            // element's parent list
            this.hierarchy = []; // if element is parent of another layer _isParent will be true
            this._isParent = false;
            this.checkParenting();
        },
        /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */ setHierarchy: function setHierarchy11(hierarchy11) {
            this.hierarchy = hierarchy11;
        },
        /**
       * @function
       * Sets layer as parent.
       *
       */ setAsParent: function setAsParent11() {
            this._isParent = true;
        },
        /**
       * @function
       * Searches layer's parenting chain
       *
       */ checkParenting: function checkParenting11() {
            if (this.data.parent !== undefined) this.comp.buildElementParenting(this, this.data.parent, []);
        }
    };
    function RenderableDOMElement() {}
    (function() {
        var _prototype11 = {
            initElement: function initElement11(data11, globalData11, comp11) {
                this.initFrame();
                this.initBaseData(data11, globalData11, comp11);
                this.initTransform(data11, globalData11, comp11);
                this.initHierarchy();
                this.initRenderable();
                this.initRendererElement();
                this.createContainerElements();
                this.createRenderableComponents();
                this.createContent();
                this.hide();
            },
            hide: function hide11() {
                // console.log('HIDE', this);
                if (!this.hidden && (!this.isInRange || this.isTransparent)) {
                    var elem31 = this.baseElement || this.layerElement;
                    elem31.style.display = "none";
                    this.hidden = true;
                }
            },
            show: function show11() {
                // console.log('SHOW', this);
                if (this.isInRange && !this.isTransparent) {
                    if (!this.data.hd) {
                        var elem31 = this.baseElement || this.layerElement;
                        elem31.style.display = "block";
                    }
                    this.hidden = false;
                    this._isFirstFrame = true;
                }
            },
            renderFrame: function renderFrame11() {
                // If it is exported as hidden (data.hd === true) no need to render
                // If it is not visible no need to render
                if (this.data.hd || this.hidden) return;
                this.renderTransform();
                this.renderRenderable();
                this.renderLocalTransform();
                this.renderElement();
                this.renderInnerContent();
                if (this._isFirstFrame) this._isFirstFrame = false;
            },
            renderInnerContent: function renderInnerContent11() {},
            prepareFrame: function prepareFrame11(num11) {
                this._mdf = false;
                this.prepareRenderableFrame(num11);
                this.prepareProperties(num11, this.isInRange);
                this.checkTransparency();
            },
            destroy: function destroy11() {
                this.innerElem = null;
                this.destroyBaseElement();
            }
        };
        extendPrototype([
            RenderableElement,
            createProxyFunction(_prototype11)
        ], RenderableDOMElement);
    })();
    function IImageElement(data11, globalData11, comp11) {
        this.assetData = globalData11.getAssetData(data11.refId);
        if (this.assetData && this.assetData.sid) this.assetData = globalData11.slotManager.getProp(this.assetData);
        this.initElement(data11, globalData11, comp11);
        this.sourceRect = {
            top: 0,
            left: 0,
            width: this.assetData.w,
            height: this.assetData.h
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], IImageElement);
    IImageElement.prototype.createContent = function() {
        var assetPath11 = this.globalData.getAssetsPath(this.assetData);
        this.innerElem = createNS("image");
        this.innerElem.setAttribute("width", this.assetData.w + "px");
        this.innerElem.setAttribute("height", this.assetData.h + "px");
        this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
        this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath11);
        this.layerElement.appendChild(this.innerElem);
    };
    IImageElement.prototype.sourceRectAtTime = function() {
        return this.sourceRect;
    };
    function ProcessedElement(element11, position11) {
        this.elem = element11;
        this.pos = position11;
    }
    function IShapeElement() {}
    IShapeElement.prototype = {
        addShapeToModifiers: function addShapeToModifiers11(data11) {
            var i31;
            var len11 = this.shapeModifiers.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.shapeModifiers[i31].addShape(data11);
        },
        isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers11(data11) {
            var i31 = 0;
            var len11 = this.shapeModifiers.length;
            while(i31 < len11){
                if (this.shapeModifiers[i31].isAnimatedWithShape(data11)) return true;
            }
            return false;
        },
        renderModifiers: function renderModifiers11() {
            if (!this.shapeModifiers.length) return;
            var i31;
            var len11 = this.shapes.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.shapes[i31].sh.reset();
            len11 = this.shapeModifiers.length;
            var shouldBreakProcess11;
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1){
                shouldBreakProcess11 = this.shapeModifiers[i31].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
                // TODO: find a better solution for this
                if (shouldBreakProcess11) break;
            }
        },
        searchProcessedElement: function searchProcessedElement11(elem31) {
            var elements11 = this.processedElements;
            var i31 = 0;
            var len11 = elements11.length;
            while(i31 < len11){
                if (elements11[i31].elem === elem31) return elements11[i31].pos;
                i31 += 1;
            }
            return 0;
        },
        addProcessedElement: function addProcessedElement11(elem31, pos11) {
            var elements11 = this.processedElements;
            var i31 = elements11.length;
            while(i31){
                i31 -= 1;
                if (elements11[i31].elem === elem31) {
                    elements11[i31].pos = pos11;
                    return;
                }
            }
            elements11.push(new ProcessedElement(elem31, pos11));
        },
        prepareFrame: function prepareFrame11(num11) {
            this.prepareRenderableFrame(num11);
            this.prepareProperties(num11, this.isInRange);
        }
    };
    var lineCapEnum = {
        1: "butt",
        2: "round",
        3: "square"
    };
    var lineJoinEnum = {
        1: "miter",
        2: "round",
        3: "bevel"
    };
    function SVGShapeData(transformers11, level11, shape31) {
        this.caches = [];
        this.styles = [];
        this.transformers = transformers11;
        this.lStr = "";
        this.sh = shape31;
        this.lvl = level11; // TODO find if there are some cases where _isAnimated can be false.
        // For now, since shapes add up with other shapes. They have to be calculated every time.
        // One way of finding out is checking if all styles associated to this shape depend only of this shape
        this._isAnimated = !!shape31.k; // TODO: commenting this for now since all shapes are animated
        var i31 = 0;
        var len11 = transformers11.length;
        while(i31 < len11){
            if (transformers11[i31].mProps.dynamicProperties.length) {
                this._isAnimated = true;
                break;
            }
            i31 += 1;
        }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
        this._isAnimated = true;
    };
    function SVGStyleData(data11, level11) {
        this.data = data11;
        this.type = data11.ty;
        this.d = "";
        this.lvl = level11;
        this._mdf = false;
        this.closed = data11.hd === true;
        this.pElem = createNS("path");
        this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
        this.d = "";
        this._mdf = false;
    };
    function DashProperty(elem31, data11, renderer11, container11) {
        this.elem = elem31;
        this.frameId = -1;
        this.dataProps = createSizedArray(data11.length);
        this.renderer = renderer11;
        this.k = false;
        this.dashStr = "";
        this.dashArray = createTypedArray("float32", data11.length ? data11.length - 1 : 0);
        this.dashoffset = createTypedArray("float32", 1);
        this.initDynamicPropertyContainer(container11);
        var i31;
        var len11 = data11.length || 0;
        var prop11;
        for(i31 = 0; i31 < len11; i31 += 1){
            prop11 = PropertyFactory.getProp(elem31, data11[i31].v, 0, 0, this);
            this.k = prop11.k || this.k;
            this.dataProps[i31] = {
                n: data11[i31].n,
                p: prop11
            };
        }
        if (!this.k) this.getValue(true);
        this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(forceRender11) {
        if (this.elem.globalData.frameId === this.frameId && !forceRender11) return;
        this.frameId = this.elem.globalData.frameId;
        this.iterateDynamicProperties();
        this._mdf = this._mdf || forceRender11;
        if (this._mdf) {
            var i31 = 0;
            var len11 = this.dataProps.length;
            if (this.renderer === "svg") this.dashStr = "";
            for(i31 = 0; i31 < len11; i31 += 1)if (this.dataProps[i31].n !== "o") {
                if (this.renderer === "svg") this.dashStr += " " + this.dataProps[i31].p.v;
                else this.dashArray[i31] = this.dataProps[i31].p.v;
            } else this.dashoffset[0] = this.dataProps[i31].p.v;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], DashProperty);
    function SVGStrokeStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, this);
        this.w = PropertyFactory.getProp(elem31, data11.w, 0, null, this);
        this.d = new DashProperty(elem31, data11.d || {}, "svg", this);
        this.c = PropertyFactory.getProp(elem31, data11.c, 1, 255, this);
        this.style = styleOb11;
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGStrokeStyleData);
    function SVGFillStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, this);
        this.c = PropertyFactory.getProp(elem31, data11.c, 1, 255, this);
        this.style = styleOb11;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGFillStyleData);
    function SVGNoStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.style = styleOb11;
    }
    extendPrototype([
        DynamicPropertyContainer
    ], SVGNoStyleData);
    function GradientProperty(elem31, data11, container11) {
        this.data = data11;
        this.c = createTypedArray("uint8c", data11.p * 4);
        var cLength11 = data11.k.k[0].s ? data11.k.k[0].s.length - data11.p * 4 : data11.k.k.length - data11.p * 4;
        this.o = createTypedArray("float32", cLength11);
        this._cmdf = false;
        this._omdf = false;
        this._collapsable = this.checkCollapsable();
        this._hasOpacity = cLength11;
        this.initDynamicPropertyContainer(container11);
        this.prop = PropertyFactory.getProp(elem31, data11.k, 1, null, this);
        this.k = this.prop.k;
        this.getValue(true);
    }
    GradientProperty.prototype.comparePoints = function(values11, points11) {
        var i31 = 0;
        var len11 = this.o.length / 2;
        var diff11;
        while(i31 < len11){
            diff11 = Math.abs(values11[i31 * 4] - values11[points11 * 4 + i31 * 2]);
            if (diff11 > 0.01) return false;
            i31 += 1;
        }
        return true;
    };
    GradientProperty.prototype.checkCollapsable = function() {
        if (this.o.length / 2 !== this.c.length / 4) return false;
        if (this.data.k.k[0].s) {
            var i31 = 0;
            var len11 = this.data.k.k.length;
            while(i31 < len11){
                if (!this.comparePoints(this.data.k.k[i31].s, this.data.p)) return false;
                i31 += 1;
            }
        } else if (!this.comparePoints(this.data.k.k, this.data.p)) return false;
        return true;
    };
    GradientProperty.prototype.getValue = function(forceRender11) {
        this.prop.getValue();
        this._mdf = false;
        this._cmdf = false;
        this._omdf = false;
        if (this.prop._mdf || forceRender11) {
            var i31;
            var len11 = this.data.p * 4;
            var mult11;
            var val31;
            for(i31 = 0; i31 < len11; i31 += 1){
                mult11 = i31 % 4 === 0 ? 100 : 255;
                val31 = Math.round(this.prop.v[i31] * mult11);
                if (this.c[i31] !== val31) {
                    this.c[i31] = val31;
                    this._cmdf = !forceRender11;
                }
            }
            if (this.o.length) {
                len11 = this.prop.v.length;
                for(i31 = this.data.p * 4; i31 < len11; i31 += 1){
                    mult11 = i31 % 2 === 0 ? 100 : 1;
                    val31 = i31 % 2 === 0 ? Math.round(this.prop.v[i31] * 100) : this.prop.v[i31];
                    if (this.o[i31 - this.data.p * 4] !== val31) {
                        this.o[i31 - this.data.p * 4] = val31;
                        this._omdf = !forceRender11;
                    }
                }
            }
            this._mdf = !forceRender11;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], GradientProperty);
    function SVGGradientFillStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.initGradientData(elem31, data11, styleOb11);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(elem31, data11, styleOb11) {
        this.o = PropertyFactory.getProp(elem31, data11.o, 0, 0.01, this);
        this.s = PropertyFactory.getProp(elem31, data11.s, 1, null, this);
        this.e = PropertyFactory.getProp(elem31, data11.e, 1, null, this);
        this.h = PropertyFactory.getProp(elem31, data11.h || {
            k: 0
        }, 0, 0.01, this);
        this.a = PropertyFactory.getProp(elem31, data11.a || {
            k: 0
        }, 0, degToRads, this);
        this.g = new GradientProperty(elem31, data11.g, this);
        this.style = styleOb11;
        this.stops = [];
        this.setGradientData(styleOb11.pElem, data11);
        this.setGradientOpacity(data11, styleOb11);
        this._isAnimated = !!this._isAnimated;
    };
    SVGGradientFillStyleData.prototype.setGradientData = function(pathElement11, data11) {
        var gradientId11 = createElementID();
        var gfill11 = createNS(data11.t === 1 ? "linearGradient" : "radialGradient");
        gfill11.setAttribute("id", gradientId11);
        gfill11.setAttribute("spreadMethod", "pad");
        gfill11.setAttribute("gradientUnits", "userSpaceOnUse");
        var stops11 = [];
        var stop11;
        var j31;
        var jLen11;
        jLen11 = data11.g.p * 4;
        for(j31 = 0; j31 < jLen11; j31 += 4){
            stop11 = createNS("stop");
            gfill11.appendChild(stop11);
            stops11.push(stop11);
        }
        pathElement11.setAttribute(data11.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + gradientId11 + ")");
        this.gf = gfill11;
        this.cst = stops11;
    };
    SVGGradientFillStyleData.prototype.setGradientOpacity = function(data11, styleOb11) {
        if (this.g._hasOpacity && !this.g._collapsable) {
            var stop11;
            var j31;
            var jLen11;
            var mask11 = createNS("mask");
            var maskElement11 = createNS("path");
            mask11.appendChild(maskElement11);
            var opacityId11 = createElementID();
            var maskId11 = createElementID();
            mask11.setAttribute("id", maskId11);
            var opFill11 = createNS(data11.t === 1 ? "linearGradient" : "radialGradient");
            opFill11.setAttribute("id", opacityId11);
            opFill11.setAttribute("spreadMethod", "pad");
            opFill11.setAttribute("gradientUnits", "userSpaceOnUse");
            jLen11 = data11.g.k.k[0].s ? data11.g.k.k[0].s.length : data11.g.k.k.length;
            var stops11 = this.stops;
            for(j31 = data11.g.p * 4; j31 < jLen11; j31 += 2){
                stop11 = createNS("stop");
                stop11.setAttribute("stop-color", "rgb(255,255,255)");
                opFill11.appendChild(stop11);
                stops11.push(stop11);
            }
            maskElement11.setAttribute(data11.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + opacityId11 + ")");
            if (data11.ty === "gs") {
                maskElement11.setAttribute("stroke-linecap", lineCapEnum[data11.lc || 2]);
                maskElement11.setAttribute("stroke-linejoin", lineJoinEnum[data11.lj || 2]);
                if (data11.lj === 1) maskElement11.setAttribute("stroke-miterlimit", data11.ml);
            }
            this.of = opFill11;
            this.ms = mask11;
            this.ost = stops11;
            this.maskId = maskId11;
            styleOb11.msElem = maskElement11;
        }
    };
    extendPrototype([
        DynamicPropertyContainer
    ], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(elem31, data11, styleOb11) {
        this.initDynamicPropertyContainer(elem31);
        this.getValue = this.iterateDynamicProperties;
        this.w = PropertyFactory.getProp(elem31, data11.w, 0, null, this);
        this.d = new DashProperty(elem31, data11.d || {}, "svg", this);
        this.initGradientData(elem31, data11, styleOb11);
        this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([
        SVGGradientFillStyleData,
        DynamicPropertyContainer
    ], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
        this.it = [];
        this.prevViewData = [];
        this.gr = createNS("g");
    }
    function SVGTransformData(mProps11, op11, container11) {
        this.transform = {
            mProps: mProps11,
            op: op11,
            container: container11
        };
        this.elements = [];
        this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function buildShapeString11(pathNodes11, length11, closed11, mat11) {
        if (length11 === 0) return "";
        var _o11 = pathNodes11.o;
        var _i11 = pathNodes11.i;
        var _v11 = pathNodes11.v;
        var i31;
        var shapeString11 = " M" + mat11.applyToPointStringified(_v11[0][0], _v11[0][1]);
        for(i31 = 1; i31 < length11; i31 += 1)shapeString11 += " C" + mat11.applyToPointStringified(_o11[i31 - 1][0], _o11[i31 - 1][1]) + " " + mat11.applyToPointStringified(_i11[i31][0], _i11[i31][1]) + " " + mat11.applyToPointStringified(_v11[i31][0], _v11[i31][1]);
        if (closed11 && length11) {
            shapeString11 += " C" + mat11.applyToPointStringified(_o11[i31 - 1][0], _o11[i31 - 1][1]) + " " + mat11.applyToPointStringified(_i11[0][0], _i11[0][1]) + " " + mat11.applyToPointStringified(_v11[0][0], _v11[0][1]);
            shapeString11 += "z";
        }
        return shapeString11;
    };
    var SVGElementsRenderer = function() {
        var _identityMatrix11 = new Matrix();
        var _matrixHelper11 = new Matrix();
        var ob11 = {
            createRenderFunction: createRenderFunction11
        };
        function createRenderFunction11(data11) {
            switch(data11.ty){
                case "fl":
                    return renderFill11;
                case "gf":
                    return renderGradient11;
                case "gs":
                    return renderGradientStroke11;
                case "st":
                    return renderStroke11;
                case "sh":
                case "el":
                case "rc":
                case "sr":
                    return renderPath11;
                case "tr":
                    return renderContentTransform11;
                case "no":
                    return renderNoop11;
                default:
                    return null;
            }
        }
        function renderContentTransform11(styleData11, itemData11, isFirstFrame11) {
            if (isFirstFrame11 || itemData11.transform.op._mdf) itemData11.transform.container.setAttribute("opacity", itemData11.transform.op.v);
            if (isFirstFrame11 || itemData11.transform.mProps._mdf) itemData11.transform.container.setAttribute("transform", itemData11.transform.mProps.v.to2dCSS());
        }
        function renderNoop11() {}
        function renderPath11(styleData11, itemData11, isFirstFrame11) {
            var j31;
            var jLen11;
            var pathStringTransformed11;
            var redraw11;
            var pathNodes11;
            var l31;
            var lLen11 = itemData11.styles.length;
            var lvl11 = itemData11.lvl;
            var paths11;
            var mat11;
            var iterations11;
            var k31;
            for(l31 = 0; l31 < lLen11; l31 += 1){
                redraw11 = itemData11.sh._mdf || isFirstFrame11;
                if (itemData11.styles[l31].lvl < lvl11) {
                    mat11 = _matrixHelper11.reset();
                    iterations11 = lvl11 - itemData11.styles[l31].lvl;
                    k31 = itemData11.transformers.length - 1;
                    while(!redraw11 && iterations11 > 0){
                        redraw11 = itemData11.transformers[k31].mProps._mdf || redraw11;
                        iterations11 -= 1;
                        k31 -= 1;
                    }
                    if (redraw11) {
                        iterations11 = lvl11 - itemData11.styles[l31].lvl;
                        k31 = itemData11.transformers.length - 1;
                        while(iterations11 > 0){
                            mat11.multiply(itemData11.transformers[k31].mProps.v);
                            iterations11 -= 1;
                            k31 -= 1;
                        }
                    }
                } else mat11 = _identityMatrix11;
                paths11 = itemData11.sh.paths;
                jLen11 = paths11._length;
                if (redraw11) {
                    pathStringTransformed11 = "";
                    for(j31 = 0; j31 < jLen11; j31 += 1){
                        pathNodes11 = paths11.shapes[j31];
                        if (pathNodes11 && pathNodes11._length) pathStringTransformed11 += buildShapeString(pathNodes11, pathNodes11._length, pathNodes11.c, mat11);
                    }
                    itemData11.caches[l31] = pathStringTransformed11;
                } else pathStringTransformed11 = itemData11.caches[l31];
                itemData11.styles[l31].d += styleData11.hd === true ? "" : pathStringTransformed11;
                itemData11.styles[l31]._mdf = redraw11 || itemData11.styles[l31]._mdf;
            }
        }
        function renderFill11(styleData11, itemData11, isFirstFrame11) {
            var styleElem11 = itemData11.style;
            if (itemData11.c._mdf || isFirstFrame11) styleElem11.pElem.setAttribute("fill", "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")");
            if (itemData11.o._mdf || isFirstFrame11) styleElem11.pElem.setAttribute("fill-opacity", itemData11.o.v);
        }
        function renderGradientStroke11(styleData11, itemData11, isFirstFrame11) {
            renderGradient11(styleData11, itemData11, isFirstFrame11);
            renderStroke11(styleData11, itemData11, isFirstFrame11);
        }
        function renderGradient11(styleData11, itemData11, isFirstFrame11) {
            var gfill11 = itemData11.gf;
            var hasOpacity11 = itemData11.g._hasOpacity;
            var pt111 = itemData11.s.v;
            var pt211 = itemData11.e.v;
            if (itemData11.o._mdf || isFirstFrame11) {
                var attr31 = styleData11.ty === "gf" ? "fill-opacity" : "stroke-opacity";
                itemData11.style.pElem.setAttribute(attr31, itemData11.o.v);
            }
            if (itemData11.s._mdf || isFirstFrame11) {
                var attr111 = styleData11.t === 1 ? "x1" : "cx";
                var attr211 = attr111 === "x1" ? "y1" : "cy";
                gfill11.setAttribute(attr111, pt111[0]);
                gfill11.setAttribute(attr211, pt111[1]);
                if (hasOpacity11 && !itemData11.g._collapsable) {
                    itemData11.of.setAttribute(attr111, pt111[0]);
                    itemData11.of.setAttribute(attr211, pt111[1]);
                }
            }
            var stops11;
            var i31;
            var len11;
            var stop11;
            if (itemData11.g._cmdf || isFirstFrame11) {
                stops11 = itemData11.cst;
                var cValues11 = itemData11.g.c;
                len11 = stops11.length;
                for(i31 = 0; i31 < len11; i31 += 1){
                    stop11 = stops11[i31];
                    stop11.setAttribute("offset", cValues11[i31 * 4] + "%");
                    stop11.setAttribute("stop-color", "rgb(" + cValues11[i31 * 4 + 1] + "," + cValues11[i31 * 4 + 2] + "," + cValues11[i31 * 4 + 3] + ")");
                }
            }
            if (hasOpacity11 && (itemData11.g._omdf || isFirstFrame11)) {
                var oValues11 = itemData11.g.o;
                if (itemData11.g._collapsable) stops11 = itemData11.cst;
                else stops11 = itemData11.ost;
                len11 = stops11.length;
                for(i31 = 0; i31 < len11; i31 += 1){
                    stop11 = stops11[i31];
                    if (!itemData11.g._collapsable) stop11.setAttribute("offset", oValues11[i31 * 2] + "%");
                    stop11.setAttribute("stop-opacity", oValues11[i31 * 2 + 1]);
                }
            }
            if (styleData11.t === 1) {
                if (itemData11.e._mdf || isFirstFrame11) {
                    gfill11.setAttribute("x2", pt211[0]);
                    gfill11.setAttribute("y2", pt211[1]);
                    if (hasOpacity11 && !itemData11.g._collapsable) {
                        itemData11.of.setAttribute("x2", pt211[0]);
                        itemData11.of.setAttribute("y2", pt211[1]);
                    }
                }
            } else {
                var rad11;
                if (itemData11.s._mdf || itemData11.e._mdf || isFirstFrame11) {
                    rad11 = Math.sqrt(Math.pow(pt111[0] - pt211[0], 2) + Math.pow(pt111[1] - pt211[1], 2));
                    gfill11.setAttribute("r", rad11);
                    if (hasOpacity11 && !itemData11.g._collapsable) itemData11.of.setAttribute("r", rad11);
                }
                if (itemData11.e._mdf || itemData11.h._mdf || itemData11.a._mdf || isFirstFrame11) {
                    if (!rad11) rad11 = Math.sqrt(Math.pow(pt111[0] - pt211[0], 2) + Math.pow(pt111[1] - pt211[1], 2));
                    var ang11 = Math.atan2(pt211[1] - pt111[1], pt211[0] - pt111[0]);
                    var percent11 = itemData11.h.v;
                    if (percent11 >= 1) percent11 = 0.99;
                    else if (percent11 <= -1) percent11 = -0.99;
                    var dist41 = rad11 * percent11;
                    var x41 = Math.cos(ang11 + itemData11.a.v) * dist41 + pt111[0];
                    var y41 = Math.sin(ang11 + itemData11.a.v) * dist41 + pt111[1];
                    gfill11.setAttribute("fx", x41);
                    gfill11.setAttribute("fy", y41);
                    if (hasOpacity11 && !itemData11.g._collapsable) {
                        itemData11.of.setAttribute("fx", x41);
                        itemData11.of.setAttribute("fy", y41);
                    }
                } // gfill.setAttribute('fy','200');
            }
        }
        function renderStroke11(styleData11, itemData11, isFirstFrame11) {
            var styleElem11 = itemData11.style;
            var d31 = itemData11.d;
            if (d31 && (d31._mdf || isFirstFrame11) && d31.dashStr) {
                styleElem11.pElem.setAttribute("stroke-dasharray", d31.dashStr);
                styleElem11.pElem.setAttribute("stroke-dashoffset", d31.dashoffset[0]);
            }
            if (itemData11.c && (itemData11.c._mdf || isFirstFrame11)) styleElem11.pElem.setAttribute("stroke", "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")");
            if (itemData11.o._mdf || isFirstFrame11) styleElem11.pElem.setAttribute("stroke-opacity", itemData11.o.v);
            if (itemData11.w._mdf || isFirstFrame11) {
                styleElem11.pElem.setAttribute("stroke-width", itemData11.w.v);
                if (styleElem11.msElem) styleElem11.msElem.setAttribute("stroke-width", itemData11.w.v);
            }
        }
        return ob11;
    }();
    function SVGShapeElement(data11, globalData11, comp11) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data11.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.initElement(data11, globalData11, comp11); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], SVGShapeElement);
    SVGShapeElement.prototype.initSecondaryElement = function() {};
    SVGShapeElement.prototype.identityMatrix = new Matrix();
    SVGShapeElement.prototype.buildExpressionInterface = function() {};
    SVGShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
    };
    /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */ SVGShapeElement.prototype.filterUniqueShapes = function() {
        var i31;
        var len11 = this.shapes.length;
        var shape31;
        var j31;
        var jLen11 = this.stylesList.length;
        var style11;
        var tempShapes11 = [];
        var areAnimated11 = false;
        for(j31 = 0; j31 < jLen11; j31 += 1){
            style11 = this.stylesList[j31];
            areAnimated11 = false;
            tempShapes11.length = 0;
            for(i31 = 0; i31 < len11; i31 += 1){
                shape31 = this.shapes[i31];
                if (shape31.styles.indexOf(style11) !== -1) {
                    tempShapes11.push(shape31);
                    areAnimated11 = shape31._isAnimated || areAnimated11;
                }
            }
            if (tempShapes11.length > 1 && areAnimated11) this.setShapesAsAnimated(tempShapes11);
        }
    };
    SVGShapeElement.prototype.setShapesAsAnimated = function(shapes11) {
        var i31;
        var len11 = shapes11.length;
        for(i31 = 0; i31 < len11; i31 += 1)shapes11[i31].setAsAnimated();
    };
    SVGShapeElement.prototype.createStyleElement = function(data11, level11) {
        // TODO: prevent drawing of hidden styles
        var elementData11;
        var styleOb11 = new SVGStyleData(data11, level11);
        var pathElement11 = styleOb11.pElem;
        if (data11.ty === "st") elementData11 = new SVGStrokeStyleData(this, data11, styleOb11);
        else if (data11.ty === "fl") elementData11 = new SVGFillStyleData(this, data11, styleOb11);
        else if (data11.ty === "gf" || data11.ty === "gs") {
            var GradientConstructor11 = data11.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
            elementData11 = new GradientConstructor11(this, data11, styleOb11);
            this.globalData.defs.appendChild(elementData11.gf);
            if (elementData11.maskId) {
                this.globalData.defs.appendChild(elementData11.ms);
                this.globalData.defs.appendChild(elementData11.of);
                pathElement11.setAttribute("mask", "url(" + getLocationHref() + "#" + elementData11.maskId + ")");
            }
        } else if (data11.ty === "no") elementData11 = new SVGNoStyleData(this, data11, styleOb11);
        if (data11.ty === "st" || data11.ty === "gs") {
            pathElement11.setAttribute("stroke-linecap", lineCapEnum[data11.lc || 2]);
            pathElement11.setAttribute("stroke-linejoin", lineJoinEnum[data11.lj || 2]);
            pathElement11.setAttribute("fill-opacity", "0");
            if (data11.lj === 1) pathElement11.setAttribute("stroke-miterlimit", data11.ml);
        }
        if (data11.r === 2) pathElement11.setAttribute("fill-rule", "evenodd");
        if (data11.ln) pathElement11.setAttribute("id", data11.ln);
        if (data11.cl) pathElement11.setAttribute("class", data11.cl);
        if (data11.bm) pathElement11.style["mix-blend-mode"] = getBlendMode(data11.bm);
        this.stylesList.push(styleOb11);
        this.addToAnimatedContents(data11, elementData11);
        return elementData11;
    };
    SVGShapeElement.prototype.createGroupElement = function(data11) {
        var elementData11 = new ShapeGroupData();
        if (data11.ln) elementData11.gr.setAttribute("id", data11.ln);
        if (data11.cl) elementData11.gr.setAttribute("class", data11.cl);
        if (data11.bm) elementData11.gr.style["mix-blend-mode"] = getBlendMode(data11.bm);
        return elementData11;
    };
    SVGShapeElement.prototype.createTransformElement = function(data11, container11) {
        var transformProperty11 = TransformPropertyFactory.getTransformProperty(this, data11, this);
        var elementData11 = new SVGTransformData(transformProperty11, transformProperty11.o, container11);
        this.addToAnimatedContents(data11, elementData11);
        return elementData11;
    };
    SVGShapeElement.prototype.createShapeElement = function(data11, ownTransformers11, level11) {
        var ty11 = 4;
        if (data11.ty === "rc") ty11 = 5;
        else if (data11.ty === "el") ty11 = 6;
        else if (data11.ty === "sr") ty11 = 7;
        var shapeProperty11 = ShapePropertyFactory.getShapeProp(this, data11, ty11, this);
        var elementData11 = new SVGShapeData(ownTransformers11, level11, shapeProperty11);
        this.shapes.push(elementData11);
        this.addShapeToModifiers(elementData11);
        this.addToAnimatedContents(data11, elementData11);
        return elementData11;
    };
    SVGShapeElement.prototype.addToAnimatedContents = function(data11, element11) {
        var i31 = 0;
        var len11 = this.animatedContents.length;
        while(i31 < len11){
            if (this.animatedContents[i31].element === element11) return;
            i31 += 1;
        }
        this.animatedContents.push({
            fn: SVGElementsRenderer.createRenderFunction(data11),
            element: element11,
            data: data11
        });
    };
    SVGShapeElement.prototype.setElementStyles = function(elementData11) {
        var arr31 = elementData11.styles;
        var j31;
        var jLen11 = this.stylesList.length;
        for(j31 = 0; j31 < jLen11; j31 += 1)if (!this.stylesList[j31].closed) arr31.push(this.stylesList[j31]);
    };
    SVGShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i31;
        var len11 = this.itemsData.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.prevViewData[i31] = this.itemsData[i31];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
        this.filterUniqueShapes();
        len11 = this.dynamicProperties.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.dynamicProperties[i31].getValue();
        this.renderModifiers();
    };
    SVGShapeElement.prototype.searchShapes = function(arr31, itemsData11, prevViewData11, container11, level11, transformers11, render11) {
        var ownTransformers11 = [].concat(transformers11);
        var i31;
        var len11 = arr31.length - 1;
        var j31;
        var jLen11;
        var ownStyles11 = [];
        var ownModifiers11 = [];
        var currentTransform11;
        var modifier11;
        var processedPos11;
        for(i31 = len11; i31 >= 0; i31 -= 1){
            processedPos11 = this.searchProcessedElement(arr31[i31]);
            if (!processedPos11) arr31[i31]._render = render11;
            else itemsData11[i31] = prevViewData11[processedPos11 - 1];
            if (arr31[i31].ty === "fl" || arr31[i31].ty === "st" || arr31[i31].ty === "gf" || arr31[i31].ty === "gs" || arr31[i31].ty === "no") {
                if (!processedPos11) itemsData11[i31] = this.createStyleElement(arr31[i31], level11);
                else itemsData11[i31].style.closed = false;
                if (arr31[i31]._render) {
                    if (itemsData11[i31].style.pElem.parentNode !== container11) container11.appendChild(itemsData11[i31].style.pElem);
                }
                ownStyles11.push(itemsData11[i31].style);
            } else if (arr31[i31].ty === "gr") {
                if (!processedPos11) itemsData11[i31] = this.createGroupElement(arr31[i31]);
                else {
                    jLen11 = itemsData11[i31].it.length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsData11[i31].prevViewData[j31] = itemsData11[i31].it[j31];
                }
                this.searchShapes(arr31[i31].it, itemsData11[i31].it, itemsData11[i31].prevViewData, itemsData11[i31].gr, level11 + 1, ownTransformers11, render11);
                if (arr31[i31]._render) {
                    if (itemsData11[i31].gr.parentNode !== container11) container11.appendChild(itemsData11[i31].gr);
                }
            } else if (arr31[i31].ty === "tr") {
                if (!processedPos11) itemsData11[i31] = this.createTransformElement(arr31[i31], container11);
                currentTransform11 = itemsData11[i31].transform;
                ownTransformers11.push(currentTransform11);
            } else if (arr31[i31].ty === "sh" || arr31[i31].ty === "rc" || arr31[i31].ty === "el" || arr31[i31].ty === "sr") {
                if (!processedPos11) itemsData11[i31] = this.createShapeElement(arr31[i31], ownTransformers11, level11);
                this.setElementStyles(itemsData11[i31]);
            } else if (arr31[i31].ty === "tm" || arr31[i31].ty === "rd" || arr31[i31].ty === "ms" || arr31[i31].ty === "pb" || arr31[i31].ty === "zz" || arr31[i31].ty === "op") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    modifier11.init(this, arr31[i31]);
                    itemsData11[i31] = modifier11;
                    this.shapeModifiers.push(modifier11);
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = false;
                }
                ownModifiers11.push(modifier11);
            } else if (arr31[i31].ty === "rp") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    itemsData11[i31] = modifier11;
                    modifier11.init(this, arr31, i31, itemsData11);
                    this.shapeModifiers.push(modifier11);
                    render11 = false;
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = true;
                }
                ownModifiers11.push(modifier11);
            }
            this.addProcessedElement(arr31[i31], i31 + 1);
        }
        len11 = ownStyles11.length;
        for(i31 = 0; i31 < len11; i31 += 1)ownStyles11[i31].closed = true;
        len11 = ownModifiers11.length;
        for(i31 = 0; i31 < len11; i31 += 1)ownModifiers11[i31].closed = true;
    };
    SVGShapeElement.prototype.renderInnerContent = function() {
        this.renderModifiers();
        var i31;
        var len11 = this.stylesList.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.stylesList[i31].reset();
        this.renderShape();
        for(i31 = 0; i31 < len11; i31 += 1)if (this.stylesList[i31]._mdf || this._isFirstFrame) {
            if (this.stylesList[i31].msElem) {
                this.stylesList[i31].msElem.setAttribute("d", this.stylesList[i31].d); // Adding M0 0 fixes same mask bug on all browsers
                this.stylesList[i31].d = "M0 0" + this.stylesList[i31].d;
            }
            this.stylesList[i31].pElem.setAttribute("d", this.stylesList[i31].d || "M0 0");
        }
    };
    SVGShapeElement.prototype.renderShape = function() {
        var i31;
        var len11 = this.animatedContents.length;
        var animatedContent11;
        for(i31 = 0; i31 < len11; i31 += 1){
            animatedContent11 = this.animatedContents[i31];
            if ((this._isFirstFrame || animatedContent11.element._isAnimated) && animatedContent11.data !== true) animatedContent11.fn(animatedContent11.data, animatedContent11.element, this._isFirstFrame);
        }
    };
    SVGShapeElement.prototype.destroy = function() {
        this.destroyBaseElement();
        this.shapesData = null;
        this.itemsData = null;
    };
    function LetterProps(o31, sw11, sc11, fc11, m31, p61) {
        this.o = o31;
        this.sw = sw11;
        this.sc = sc11;
        this.fc = fc11;
        this.m = m31;
        this.p = p61;
        this._mdf = {
            o: true,
            sw: !!sw11,
            sc: !!sc11,
            fc: !!fc11,
            m: true,
            p: true
        };
    }
    LetterProps.prototype.update = function(o31, sw11, sc11, fc11, m31, p61) {
        this._mdf.o = false;
        this._mdf.sw = false;
        this._mdf.sc = false;
        this._mdf.fc = false;
        this._mdf.m = false;
        this._mdf.p = false;
        var updated11 = false;
        if (this.o !== o31) {
            this.o = o31;
            this._mdf.o = true;
            updated11 = true;
        }
        if (this.sw !== sw11) {
            this.sw = sw11;
            this._mdf.sw = true;
            updated11 = true;
        }
        if (this.sc !== sc11) {
            this.sc = sc11;
            this._mdf.sc = true;
            updated11 = true;
        }
        if (this.fc !== fc11) {
            this.fc = fc11;
            this._mdf.fc = true;
            updated11 = true;
        }
        if (this.m !== m31) {
            this.m = m31;
            this._mdf.m = true;
            updated11 = true;
        }
        if (p61.length && (this.p[0] !== p61[0] || this.p[1] !== p61[1] || this.p[4] !== p61[4] || this.p[5] !== p61[5] || this.p[12] !== p61[12] || this.p[13] !== p61[13])) {
            this.p = p61;
            this._mdf.p = true;
            updated11 = true;
        }
        return updated11;
    };
    function TextProperty(elem31, data11) {
        this._frameId = initialDefaultFrame;
        this.pv = "";
        this.v = "";
        this.kf = false;
        this._isFirstFrame = true;
        this._mdf = false;
        if (data11.d && data11.d.sid) data11.d = elem31.globalData.slotManager.getProp(data11.d);
        this.data = data11;
        this.elem = elem31;
        this.comp = this.elem.comp;
        this.keysIndex = 0;
        this.canResize = false;
        this.minimumFontSize = 1;
        this.effectsSequence = [];
        this.currentData = {
            ascent: 0,
            boxWidth: this.defaultBoxWidth,
            f: "",
            fStyle: "",
            fWeight: "",
            fc: "",
            j: "",
            justifyOffset: "",
            l: [],
            lh: 0,
            lineWidths: [],
            ls: "",
            of: "",
            s: "",
            sc: "",
            sw: 0,
            t: 0,
            tr: 0,
            sz: 0,
            ps: null,
            fillColorAnim: false,
            strokeColorAnim: false,
            strokeWidthAnim: false,
            yOffset: 0,
            finalSize: 0,
            finalText: [],
            finalLineHeight: 0,
            __complete: false
        };
        this.copyData(this.currentData, this.data.d.k[0].s);
        if (!this.searchProperty()) this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [
        0,
        0
    ];
    TextProperty.prototype.copyData = function(obj11, data11) {
        for(var s41 in data11)if (Object.prototype.hasOwnProperty.call(data11, s41)) obj11[s41] = data11[s41];
        return obj11;
    };
    TextProperty.prototype.setCurrentData = function(data11) {
        if (!data11.__complete) this.completeTextData(data11);
        this.currentData = data11;
        this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
        this._mdf = true;
    };
    TextProperty.prototype.searchProperty = function() {
        return this.searchKeyframes();
    };
    TextProperty.prototype.searchKeyframes = function() {
        this.kf = this.data.d.k.length > 1;
        if (this.kf) this.addEffect(this.getKeyframeValue.bind(this));
        return this.kf;
    };
    TextProperty.prototype.addEffect = function(effectFunction11) {
        this.effectsSequence.push(effectFunction11);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.getValue = function(_finalValue11) {
        if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue11) return;
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var currentValue11 = this.currentData;
        var currentIndex11 = this.keysIndex;
        if (this.lock) {
            this.setCurrentData(this.currentData);
            return;
        }
        this.lock = true;
        this._mdf = false;
        var i31;
        var len11 = this.effectsSequence.length;
        var finalValue11 = _finalValue11 || this.data.d.k[this.keysIndex].s;
        for(i31 = 0; i31 < len11; i31 += 1)// Checking if index changed to prevent creating a new object every time the expression updates.
        if (currentIndex11 !== this.keysIndex) finalValue11 = this.effectsSequence[i31](finalValue11, finalValue11.t);
        else finalValue11 = this.effectsSequence[i31](this.currentData, finalValue11.t);
        if (currentValue11 !== finalValue11) this.setCurrentData(finalValue11);
        this.v = this.currentData;
        this.pv = this.v;
        this.lock = false;
        this.frameId = this.elem.globalData.frameId;
    };
    TextProperty.prototype.getKeyframeValue = function() {
        var textKeys11 = this.data.d.k;
        var frameNum11 = this.elem.comp.renderedFrame;
        var i31 = 0;
        var len11 = textKeys11.length;
        while(i31 <= len11 - 1){
            if (i31 === len11 - 1 || textKeys11[i31 + 1].t > frameNum11) break;
            i31 += 1;
        }
        if (this.keysIndex !== i31) this.keysIndex = i31;
        return this.data.d.k[this.keysIndex].s;
    };
    TextProperty.prototype.buildFinalText = function(text11) {
        var charactersArray11 = [];
        var i31 = 0;
        var len11 = text11.length;
        var charCode11;
        var secondCharCode11;
        var shouldCombine11 = false;
        while(i31 < len11){
            charCode11 = text11.charCodeAt(i31);
            if (FontManager.isCombinedCharacter(charCode11)) charactersArray11[charactersArray11.length - 1] += text11.charAt(i31);
            else if (charCode11 >= 0xD800 && charCode11 <= 0xDBFF) {
                secondCharCode11 = text11.charCodeAt(i31 + 1);
                if (secondCharCode11 >= 0xDC00 && secondCharCode11 <= 0xDFFF) {
                    if (shouldCombine11 || FontManager.isModifier(charCode11, secondCharCode11)) {
                        charactersArray11[charactersArray11.length - 1] += text11.substr(i31, 2);
                        shouldCombine11 = false;
                    } else charactersArray11.push(text11.substr(i31, 2));
                    i31 += 1;
                } else charactersArray11.push(text11.charAt(i31));
            } else if (charCode11 > 0xDBFF) {
                secondCharCode11 = text11.charCodeAt(i31 + 1);
                if (FontManager.isZeroWidthJoiner(charCode11, secondCharCode11)) {
                    shouldCombine11 = true;
                    charactersArray11[charactersArray11.length - 1] += text11.substr(i31, 2);
                    i31 += 1;
                } else charactersArray11.push(text11.charAt(i31));
            } else if (FontManager.isZeroWidthJoiner(charCode11)) {
                charactersArray11[charactersArray11.length - 1] += text11.charAt(i31);
                shouldCombine11 = true;
            } else charactersArray11.push(text11.charAt(i31));
            i31 += 1;
        }
        return charactersArray11;
    };
    TextProperty.prototype.completeTextData = function(documentData11) {
        documentData11.__complete = true;
        var fontManager11 = this.elem.globalData.fontManager;
        var data11 = this.data;
        var letters11 = [];
        var i31;
        var len11;
        var newLineFlag11;
        var index11 = 0;
        var val31;
        var anchorGrouping11 = data11.m.g;
        var currentSize11 = 0;
        var currentPos11 = 0;
        var currentLine11 = 0;
        var lineWidths11 = [];
        var lineWidth11 = 0;
        var maxLineWidth11 = 0;
        var j31;
        var jLen11;
        var fontData11 = fontManager11.getFontByName(documentData11.f);
        var charData11;
        var cLength11 = 0;
        var fontProps11 = getFontProperties(fontData11);
        documentData11.fWeight = fontProps11.weight;
        documentData11.fStyle = fontProps11.style;
        documentData11.finalSize = documentData11.s;
        documentData11.finalText = this.buildFinalText(documentData11.t);
        len11 = documentData11.finalText.length;
        documentData11.finalLineHeight = documentData11.lh;
        var trackingOffset11 = documentData11.tr / 1000 * documentData11.finalSize;
        var charCode11;
        if (documentData11.sz) {
            var flag11 = true;
            var boxWidth11 = documentData11.sz[0];
            var boxHeight11 = documentData11.sz[1];
            var currentHeight11;
            var finalText11;
            while(flag11){
                finalText11 = this.buildFinalText(documentData11.t);
                currentHeight11 = 0;
                lineWidth11 = 0;
                len11 = finalText11.length;
                trackingOffset11 = documentData11.tr / 1000 * documentData11.finalSize;
                var lastSpaceIndex11 = -1;
                for(i31 = 0; i31 < len11; i31 += 1){
                    charCode11 = finalText11[i31].charCodeAt(0);
                    newLineFlag11 = false;
                    if (finalText11[i31] === " ") lastSpaceIndex11 = i31;
                    else if (charCode11 === 13 || charCode11 === 3) {
                        lineWidth11 = 0;
                        newLineFlag11 = true;
                        currentHeight11 += documentData11.finalLineHeight || documentData11.finalSize * 1.2;
                    }
                    if (fontManager11.chars) {
                        charData11 = fontManager11.getCharData(finalText11[i31], fontData11.fStyle, fontData11.fFamily);
                        cLength11 = newLineFlag11 ? 0 : charData11.w * documentData11.finalSize / 100;
                    } else // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
                    cLength11 = fontManager11.measureText(finalText11[i31], documentData11.f, documentData11.finalSize);
                    if (lineWidth11 + cLength11 > boxWidth11 && finalText11[i31] !== " ") {
                        if (lastSpaceIndex11 === -1) len11 += 1;
                        else i31 = lastSpaceIndex11;
                        currentHeight11 += documentData11.finalLineHeight || documentData11.finalSize * 1.2;
                        finalText11.splice(i31, lastSpaceIndex11 === i31 ? 1 : 0, "\r"); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);
                        lastSpaceIndex11 = -1;
                        lineWidth11 = 0;
                    } else {
                        lineWidth11 += cLength11;
                        lineWidth11 += trackingOffset11;
                    }
                }
                currentHeight11 += fontData11.ascent * documentData11.finalSize / 100;
                if (this.canResize && documentData11.finalSize > this.minimumFontSize && boxHeight11 < currentHeight11) {
                    documentData11.finalSize -= 1;
                    documentData11.finalLineHeight = documentData11.finalSize * documentData11.lh / documentData11.s;
                } else {
                    documentData11.finalText = finalText11;
                    len11 = documentData11.finalText.length;
                    flag11 = false;
                }
            }
        }
        lineWidth11 = -trackingOffset11;
        cLength11 = 0;
        var uncollapsedSpaces11 = 0;
        var currentChar11;
        for(i31 = 0; i31 < len11; i31 += 1){
            newLineFlag11 = false;
            currentChar11 = documentData11.finalText[i31];
            charCode11 = currentChar11.charCodeAt(0);
            if (charCode11 === 13 || charCode11 === 3) {
                uncollapsedSpaces11 = 0;
                lineWidths11.push(lineWidth11);
                maxLineWidth11 = lineWidth11 > maxLineWidth11 ? lineWidth11 : maxLineWidth11;
                lineWidth11 = -2 * trackingOffset11;
                val31 = "";
                newLineFlag11 = true;
                currentLine11 += 1;
            } else val31 = currentChar11;
            if (fontManager11.chars) {
                charData11 = fontManager11.getCharData(currentChar11, fontData11.fStyle, fontManager11.getFontByName(documentData11.f).fFamily);
                cLength11 = newLineFlag11 ? 0 : charData11.w * documentData11.finalSize / 100;
            } else // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
            // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
            cLength11 = fontManager11.measureText(val31, documentData11.f, documentData11.finalSize);
             //
            if (currentChar11 === " ") uncollapsedSpaces11 += cLength11 + trackingOffset11;
            else {
                lineWidth11 += cLength11 + trackingOffset11 + uncollapsedSpaces11;
                uncollapsedSpaces11 = 0;
            }
            letters11.push({
                l: cLength11,
                an: cLength11,
                add: currentSize11,
                n: newLineFlag11,
                anIndexes: [],
                val: val31,
                line: currentLine11,
                animatorJustifyOffset: 0
            });
            if (anchorGrouping11 == 2) {
                // eslint-disable-line eqeqeq
                currentSize11 += cLength11;
                if (val31 === "" || val31 === " " || i31 === len11 - 1) {
                    if (val31 === "" || val31 === " ") currentSize11 -= cLength11;
                    while(currentPos11 <= i31){
                        letters11[currentPos11].an = currentSize11;
                        letters11[currentPos11].ind = index11;
                        letters11[currentPos11].extra = cLength11;
                        currentPos11 += 1;
                    }
                    index11 += 1;
                    currentSize11 = 0;
                }
            } else if (anchorGrouping11 == 3) {
                // eslint-disable-line eqeqeq
                currentSize11 += cLength11;
                if (val31 === "" || i31 === len11 - 1) {
                    if (val31 === "") currentSize11 -= cLength11;
                    while(currentPos11 <= i31){
                        letters11[currentPos11].an = currentSize11;
                        letters11[currentPos11].ind = index11;
                        letters11[currentPos11].extra = cLength11;
                        currentPos11 += 1;
                    }
                    currentSize11 = 0;
                    index11 += 1;
                }
            } else {
                letters11[index11].ind = index11;
                letters11[index11].extra = 0;
                index11 += 1;
            }
        }
        documentData11.l = letters11;
        maxLineWidth11 = lineWidth11 > maxLineWidth11 ? lineWidth11 : maxLineWidth11;
        lineWidths11.push(lineWidth11);
        if (documentData11.sz) {
            documentData11.boxWidth = documentData11.sz[0];
            documentData11.justifyOffset = 0;
        } else {
            documentData11.boxWidth = maxLineWidth11;
            switch(documentData11.j){
                case 1:
                    documentData11.justifyOffset = -documentData11.boxWidth;
                    break;
                case 2:
                    documentData11.justifyOffset = -documentData11.boxWidth / 2;
                    break;
                default:
                    documentData11.justifyOffset = 0;
            }
        }
        documentData11.lineWidths = lineWidths11;
        var animators11 = data11.a;
        var animatorData11;
        var letterData11;
        jLen11 = animators11.length;
        var based11;
        var ind11;
        var indexes11 = [];
        for(j31 = 0; j31 < jLen11; j31 += 1){
            animatorData11 = animators11[j31];
            if (animatorData11.a.sc) documentData11.strokeColorAnim = true;
            if (animatorData11.a.sw) documentData11.strokeWidthAnim = true;
            if (animatorData11.a.fc || animatorData11.a.fh || animatorData11.a.fs || animatorData11.a.fb) documentData11.fillColorAnim = true;
            ind11 = 0;
            based11 = animatorData11.s.b;
            for(i31 = 0; i31 < len11; i31 += 1){
                letterData11 = letters11[i31];
                letterData11.anIndexes[j31] = ind11;
                if (based11 == 1 && letterData11.val !== "" || based11 == 2 && letterData11.val !== "" && letterData11.val !== " " || based11 == 3 && (letterData11.n || letterData11.val == " " || i31 == len11 - 1) || based11 == 4 && (letterData11.n || i31 == len11 - 1)) {
                    // eslint-disable-line eqeqeq
                    if (animatorData11.s.rn === 1) indexes11.push(ind11);
                    ind11 += 1;
                }
            }
            data11.a[j31].s.totalChars = ind11;
            var currentInd11 = -1;
            var newInd11;
            if (animatorData11.s.rn === 1) for(i31 = 0; i31 < len11; i31 += 1){
                letterData11 = letters11[i31];
                if (currentInd11 != letterData11.anIndexes[j31]) {
                    // eslint-disable-line eqeqeq
                    currentInd11 = letterData11.anIndexes[j31];
                    newInd11 = indexes11.splice(Math.floor(Math.random() * indexes11.length), 1)[0];
                }
                letterData11.anIndexes[j31] = newInd11;
            }
        }
        documentData11.yOffset = documentData11.finalLineHeight || documentData11.finalSize * 1.2;
        documentData11.ls = documentData11.ls || 0;
        documentData11.ascent = fontData11.ascent * documentData11.finalSize / 100;
    };
    TextProperty.prototype.updateDocumentData = function(newData11, index11) {
        index11 = index11 === undefined ? this.keysIndex : index11;
        var dData11 = this.copyData({}, this.data.d.k[index11].s);
        dData11 = this.copyData(dData11, newData11);
        this.data.d.k[index11].s = dData11;
        this.recalculate(index11);
        this.setCurrentData(dData11);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.recalculate = function(index11) {
        var dData11 = this.data.d.k[index11].s;
        dData11.__complete = false;
        this.keysIndex = 0;
        this._isFirstFrame = true;
        this.getValue(dData11);
    };
    TextProperty.prototype.canResizeFont = function(_canResize11) {
        this.canResize = _canResize11;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    TextProperty.prototype.setMinimumFontSize = function(_fontValue11) {
        this.minimumFontSize = Math.floor(_fontValue11) || 1;
        this.recalculate(this.keysIndex);
        this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
        var max11 = Math.max;
        var min11 = Math.min;
        var floor11 = Math.floor;
        function TextSelectorPropFactory11(elem31, data11) {
            this._currentTextLength = -1;
            this.k = false;
            this.data = data11;
            this.elem = elem31;
            this.comp = elem31.comp;
            this.finalS = 0;
            this.finalE = 0;
            this.initDynamicPropertyContainer(elem31);
            this.s = PropertyFactory.getProp(elem31, data11.s || {
                k: 0
            }, 0, 0, this);
            if ("e" in data11) this.e = PropertyFactory.getProp(elem31, data11.e, 0, 0, this);
            else this.e = {
                v: 100
            };
            this.o = PropertyFactory.getProp(elem31, data11.o || {
                k: 0
            }, 0, 0, this);
            this.xe = PropertyFactory.getProp(elem31, data11.xe || {
                k: 0
            }, 0, 0, this);
            this.ne = PropertyFactory.getProp(elem31, data11.ne || {
                k: 0
            }, 0, 0, this);
            this.sm = PropertyFactory.getProp(elem31, data11.sm || {
                k: 100
            }, 0, 0, this);
            this.a = PropertyFactory.getProp(elem31, data11.a, 0, 0.01, this);
            if (!this.dynamicProperties.length) this.getValue();
        }
        TextSelectorPropFactory11.prototype = {
            getMult: function getMult11(ind11) {
                if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) this.getValue();
                var x111 = 0;
                var y111 = 0;
                var x211 = 1;
                var y211 = 1;
                if (this.ne.v > 0) x111 = this.ne.v / 100.0;
                else y111 = -this.ne.v / 100.0;
                if (this.xe.v > 0) x211 = 1.0 - this.xe.v / 100.0;
                else y211 = 1.0 + this.xe.v / 100.0;
                var easer11 = BezierFactory.getBezierEasing(x111, y111, x211, y211).get;
                var mult11 = 0;
                var s41 = this.finalS;
                var e31 = this.finalE;
                var type11 = this.data.sh;
                if (type11 === 2) {
                    if (e31 === s41) mult11 = ind11 >= e31 ? 1 : 0;
                    else mult11 = max11(0, min11(0.5 / (e31 - s41) + (ind11 - s41) / (e31 - s41), 1));
                    mult11 = easer11(mult11);
                } else if (type11 === 3) {
                    if (e31 === s41) mult11 = ind11 >= e31 ? 0 : 1;
                    else mult11 = 1 - max11(0, min11(0.5 / (e31 - s41) + (ind11 - s41) / (e31 - s41), 1));
                    mult11 = easer11(mult11);
                } else if (type11 === 4) {
                    if (e31 === s41) mult11 = 0;
                    else {
                        mult11 = max11(0, min11(0.5 / (e31 - s41) + (ind11 - s41) / (e31 - s41), 1));
                        if (mult11 < 0.5) mult11 *= 2;
                        else mult11 = 1 - 2 * (mult11 - 0.5);
                    }
                    mult11 = easer11(mult11);
                } else if (type11 === 5) {
                    if (e31 === s41) mult11 = 0;
                    else {
                        var tot11 = e31 - s41;
                        /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */ ind11 = min11(max11(0, ind11 + 0.5 - s41), e31 - s41);
                        var x41 = -tot11 / 2 + ind11;
                        var a31 = tot11 / 2;
                        mult11 = Math.sqrt(1 - x41 * x41 / (a31 * a31));
                    }
                    mult11 = easer11(mult11);
                } else if (type11 === 6) {
                    if (e31 === s41) mult11 = 0;
                    else {
                        ind11 = min11(max11(0, ind11 + 0.5 - s41), e31 - s41);
                        mult11 = (1 + Math.cos(Math.PI + Math.PI * 2 * ind11 / (e31 - s41))) / 2; // eslint-disable-line
                    }
                    mult11 = easer11(mult11);
                } else {
                    if (ind11 >= floor11(s41)) {
                        if (ind11 - s41 < 0) mult11 = max11(0, min11(min11(e31, 1) - (s41 - ind11), 1));
                        else mult11 = max11(0, min11(e31 - ind11, 1));
                    }
                    mult11 = easer11(mult11);
                } // Smoothness implementation.
                // The smoothness represents a reduced range of the original [0; 1] range.
                // if smoothness is 25%, the new range will be [0.375; 0.625]
                // Steps are:
                // - find the lower value of the new range (threshold)
                // - if multiplier is smaller than that value, floor it to 0
                // - if it is larger,
                //     - subtract the threshold
                //     - divide it by the smoothness (this will return the range to [0; 1])
                // Note: If it doesn't work on some scenarios, consider applying it before the easer.
                if (this.sm.v !== 100) {
                    var smoothness11 = this.sm.v * 0.01;
                    if (smoothness11 === 0) smoothness11 = 0.00000001;
                    var threshold11 = 0.5 - smoothness11 * 0.5;
                    if (mult11 < threshold11) mult11 = 0;
                    else {
                        mult11 = (mult11 - threshold11) / smoothness11;
                        if (mult11 > 1) mult11 = 1;
                    }
                }
                return mult11 * this.a.v;
            },
            getValue: function getValue11(newCharsFlag11) {
                this.iterateDynamicProperties();
                this._mdf = newCharsFlag11 || this._mdf;
                this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;
                if (newCharsFlag11 && this.data.r === 2) this.e.v = this._currentTextLength;
                var divisor11 = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
                var o31 = this.o.v / divisor11;
                var s41 = this.s.v / divisor11 + o31;
                var e31 = this.e.v / divisor11 + o31;
                if (s41 > e31) {
                    var _s11 = s41;
                    s41 = e31;
                    e31 = _s11;
                }
                this.finalS = s41;
                this.finalE = e31;
            }
        };
        extendPrototype([
            DynamicPropertyContainer
        ], TextSelectorPropFactory11);
        function getTextSelectorProp11(elem31, data11, arr31) {
            return new TextSelectorPropFactory11(elem31, data11, arr31);
        }
        return {
            getTextSelectorProp: getTextSelectorProp11
        };
    }();
    function TextAnimatorDataProperty(elem31, animatorProps11, container11) {
        var defaultData11 = {
            propType: false
        };
        var getProp11 = PropertyFactory.getProp;
        var textAnimatorAnimatables11 = animatorProps11.a;
        this.a = {
            r: textAnimatorAnimatables11.r ? getProp11(elem31, textAnimatorAnimatables11.r, 0, degToRads, container11) : defaultData11,
            rx: textAnimatorAnimatables11.rx ? getProp11(elem31, textAnimatorAnimatables11.rx, 0, degToRads, container11) : defaultData11,
            ry: textAnimatorAnimatables11.ry ? getProp11(elem31, textAnimatorAnimatables11.ry, 0, degToRads, container11) : defaultData11,
            sk: textAnimatorAnimatables11.sk ? getProp11(elem31, textAnimatorAnimatables11.sk, 0, degToRads, container11) : defaultData11,
            sa: textAnimatorAnimatables11.sa ? getProp11(elem31, textAnimatorAnimatables11.sa, 0, degToRads, container11) : defaultData11,
            s: textAnimatorAnimatables11.s ? getProp11(elem31, textAnimatorAnimatables11.s, 1, 0.01, container11) : defaultData11,
            a: textAnimatorAnimatables11.a ? getProp11(elem31, textAnimatorAnimatables11.a, 1, 0, container11) : defaultData11,
            o: textAnimatorAnimatables11.o ? getProp11(elem31, textAnimatorAnimatables11.o, 0, 0.01, container11) : defaultData11,
            p: textAnimatorAnimatables11.p ? getProp11(elem31, textAnimatorAnimatables11.p, 1, 0, container11) : defaultData11,
            sw: textAnimatorAnimatables11.sw ? getProp11(elem31, textAnimatorAnimatables11.sw, 0, 0, container11) : defaultData11,
            sc: textAnimatorAnimatables11.sc ? getProp11(elem31, textAnimatorAnimatables11.sc, 1, 0, container11) : defaultData11,
            fc: textAnimatorAnimatables11.fc ? getProp11(elem31, textAnimatorAnimatables11.fc, 1, 0, container11) : defaultData11,
            fh: textAnimatorAnimatables11.fh ? getProp11(elem31, textAnimatorAnimatables11.fh, 0, 0, container11) : defaultData11,
            fs: textAnimatorAnimatables11.fs ? getProp11(elem31, textAnimatorAnimatables11.fs, 0, 0.01, container11) : defaultData11,
            fb: textAnimatorAnimatables11.fb ? getProp11(elem31, textAnimatorAnimatables11.fb, 0, 0.01, container11) : defaultData11,
            t: textAnimatorAnimatables11.t ? getProp11(elem31, textAnimatorAnimatables11.t, 0, 0, container11) : defaultData11
        };
        this.s = TextSelectorProp.getTextSelectorProp(elem31, animatorProps11.s, container11);
        this.s.t = animatorProps11.s.t;
    }
    function TextAnimatorProperty(textData11, renderType11, elem31) {
        this._isFirstFrame = true;
        this._hasMaskedPath = false;
        this._frameId = -1;
        this._textData = textData11;
        this._renderType = renderType11;
        this._elem = elem31;
        this._animatorsData = createSizedArray(this._textData.a.length);
        this._pathData = {};
        this._moreOptions = {
            alignment: {}
        };
        this.renderedLetters = [];
        this.lettersChangedFlag = false;
        this.initDynamicPropertyContainer(elem31);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
        var i31;
        var len11 = this._textData.a.length;
        var animatorProps11;
        var getProp11 = PropertyFactory.getProp;
        for(i31 = 0; i31 < len11; i31 += 1){
            animatorProps11 = this._textData.a[i31];
            this._animatorsData[i31] = new TextAnimatorDataProperty(this._elem, animatorProps11, this);
        }
        if (this._textData.p && "m" in this._textData.p) {
            this._pathData = {
                a: getProp11(this._elem, this._textData.p.a, 0, 0, this),
                f: getProp11(this._elem, this._textData.p.f, 0, 0, this),
                l: getProp11(this._elem, this._textData.p.l, 0, 0, this),
                r: getProp11(this._elem, this._textData.p.r, 0, 0, this),
                p: getProp11(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            };
            this._hasMaskedPath = true;
        } else this._hasMaskedPath = false;
        this._moreOptions.alignment = getProp11(this._elem, this._textData.m.a, 1, 0, this);
    };
    TextAnimatorProperty.prototype.getMeasures = function(documentData11, lettersChangedFlag11) {
        this.lettersChangedFlag = lettersChangedFlag11;
        if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag11 && (!this._hasMaskedPath || !this._pathData.m._mdf)) return;
        this._isFirstFrame = false;
        var alignment11 = this._moreOptions.alignment.v;
        var animators11 = this._animatorsData;
        var textData11 = this._textData;
        var matrixHelper11 = this.mHelper;
        var renderType11 = this._renderType;
        var renderedLettersCount11 = this.renderedLetters.length;
        var xPos11;
        var yPos11;
        var i31;
        var len11;
        var letters11 = documentData11.l;
        var pathInfo11;
        var currentLength11;
        var currentPoint11;
        var segmentLength11;
        var flag11;
        var pointInd11;
        var segmentInd11;
        var prevPoint11;
        var points11;
        var segments11;
        var partialLength11;
        var totalLength11;
        var perc11;
        var tanAngle11;
        var mask11;
        if (this._hasMaskedPath) {
            mask11 = this._pathData.m;
            if (!this._pathData.n || this._pathData._mdf) {
                var paths11 = mask11.v;
                if (this._pathData.r.v) paths11 = paths11.reverse();
                 // TODO: release bezier data cached from previous pathInfo: this._pathData.pi
                pathInfo11 = {
                    tLength: 0,
                    segments: []
                };
                len11 = paths11._length - 1;
                var bezierData11;
                totalLength11 = 0;
                for(i31 = 0; i31 < len11; i31 += 1){
                    bezierData11 = bez.buildBezierData(paths11.v[i31], paths11.v[i31 + 1], [
                        paths11.o[i31][0] - paths11.v[i31][0],
                        paths11.o[i31][1] - paths11.v[i31][1]
                    ], [
                        paths11.i[i31 + 1][0] - paths11.v[i31 + 1][0],
                        paths11.i[i31 + 1][1] - paths11.v[i31 + 1][1]
                    ]);
                    pathInfo11.tLength += bezierData11.segmentLength;
                    pathInfo11.segments.push(bezierData11);
                    totalLength11 += bezierData11.segmentLength;
                }
                i31 = len11;
                if (mask11.v.c) {
                    bezierData11 = bez.buildBezierData(paths11.v[i31], paths11.v[0], [
                        paths11.o[i31][0] - paths11.v[i31][0],
                        paths11.o[i31][1] - paths11.v[i31][1]
                    ], [
                        paths11.i[0][0] - paths11.v[0][0],
                        paths11.i[0][1] - paths11.v[0][1]
                    ]);
                    pathInfo11.tLength += bezierData11.segmentLength;
                    pathInfo11.segments.push(bezierData11);
                    totalLength11 += bezierData11.segmentLength;
                }
                this._pathData.pi = pathInfo11;
            }
            pathInfo11 = this._pathData.pi;
            currentLength11 = this._pathData.f.v;
            segmentInd11 = 0;
            pointInd11 = 1;
            segmentLength11 = 0;
            flag11 = true;
            segments11 = pathInfo11.segments;
            if (currentLength11 < 0 && mask11.v.c) {
                if (pathInfo11.tLength < Math.abs(currentLength11)) currentLength11 = -Math.abs(currentLength11) % pathInfo11.tLength;
                segmentInd11 = segments11.length - 1;
                points11 = segments11[segmentInd11].points;
                pointInd11 = points11.length - 1;
                while(currentLength11 < 0){
                    currentLength11 += points11[pointInd11].partialLength;
                    pointInd11 -= 1;
                    if (pointInd11 < 0) {
                        segmentInd11 -= 1;
                        points11 = segments11[segmentInd11].points;
                        pointInd11 = points11.length - 1;
                    }
                }
            }
            points11 = segments11[segmentInd11].points;
            prevPoint11 = points11[pointInd11 - 1];
            currentPoint11 = points11[pointInd11];
            partialLength11 = currentPoint11.partialLength;
        }
        len11 = letters11.length;
        xPos11 = 0;
        yPos11 = 0;
        var yOff11 = documentData11.finalSize * 1.2 * 0.714;
        var firstLine11 = true;
        var animatorProps11;
        var animatorSelector11;
        var j31;
        var jLen11;
        var letterValue11;
        jLen11 = animators11.length;
        var mult11;
        var ind11 = -1;
        var offf11;
        var xPathPos11;
        var yPathPos11;
        var initPathPos11 = currentLength11;
        var initSegmentInd11 = segmentInd11;
        var initPointInd11 = pointInd11;
        var currentLine11 = -1;
        var elemOpacity11;
        var sc11;
        var sw11;
        var fc11;
        var k31;
        var letterSw11;
        var letterSc11;
        var letterFc11;
        var letterM11 = "";
        var letterP11 = this.defaultPropsArray;
        var letterO11; //
        if (documentData11.j === 2 || documentData11.j === 1) {
            var animatorJustifyOffset11 = 0;
            var animatorFirstCharOffset11 = 0;
            var justifyOffsetMult11 = documentData11.j === 2 ? -0.5 : -1;
            var lastIndex11 = 0;
            var isNewLine11 = true;
            for(i31 = 0; i31 < len11; i31 += 1)if (letters11[i31].n) {
                if (animatorJustifyOffset11) animatorJustifyOffset11 += animatorFirstCharOffset11;
                while(lastIndex11 < i31){
                    letters11[lastIndex11].animatorJustifyOffset = animatorJustifyOffset11;
                    lastIndex11 += 1;
                }
                animatorJustifyOffset11 = 0;
                isNewLine11 = true;
            } else {
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.t.propType) {
                        if (isNewLine11 && documentData11.j === 2) animatorFirstCharOffset11 += animatorProps11.t.v * justifyOffsetMult11;
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (mult11.length) animatorJustifyOffset11 += animatorProps11.t.v * mult11[0] * justifyOffsetMult11;
                        else animatorJustifyOffset11 += animatorProps11.t.v * mult11 * justifyOffsetMult11;
                    }
                }
                isNewLine11 = false;
            }
            if (animatorJustifyOffset11) animatorJustifyOffset11 += animatorFirstCharOffset11;
            while(lastIndex11 < i31){
                letters11[lastIndex11].animatorJustifyOffset = animatorJustifyOffset11;
                lastIndex11 += 1;
            }
        } //
        for(i31 = 0; i31 < len11; i31 += 1){
            matrixHelper11.reset();
            elemOpacity11 = 1;
            if (letters11[i31].n) {
                xPos11 = 0;
                yPos11 += documentData11.yOffset;
                yPos11 += firstLine11 ? 1 : 0;
                currentLength11 = initPathPos11;
                firstLine11 = false;
                if (this._hasMaskedPath) {
                    segmentInd11 = initSegmentInd11;
                    pointInd11 = initPointInd11;
                    points11 = segments11[segmentInd11].points;
                    prevPoint11 = points11[pointInd11 - 1];
                    currentPoint11 = points11[pointInd11];
                    partialLength11 = currentPoint11.partialLength;
                    segmentLength11 = 0;
                }
                letterM11 = "";
                letterFc11 = "";
                letterSw11 = "";
                letterO11 = "";
                letterP11 = this.defaultPropsArray;
            } else {
                if (this._hasMaskedPath) {
                    if (currentLine11 !== letters11[i31].line) {
                        switch(documentData11.j){
                            case 1:
                                currentLength11 += totalLength11 - documentData11.lineWidths[letters11[i31].line];
                                break;
                            case 2:
                                currentLength11 += (totalLength11 - documentData11.lineWidths[letters11[i31].line]) / 2;
                                break;
                            default:
                                break;
                        }
                        currentLine11 = letters11[i31].line;
                    }
                    if (ind11 !== letters11[i31].ind) {
                        if (letters11[ind11]) currentLength11 += letters11[ind11].extra;
                        currentLength11 += letters11[i31].an / 2;
                        ind11 = letters11[i31].ind;
                    }
                    currentLength11 += alignment11[0] * letters11[i31].an * 0.005;
                    var animatorOffset11 = 0;
                    for(j31 = 0; j31 < jLen11; j31 += 1){
                        animatorProps11 = animators11[j31].a;
                        if (animatorProps11.p.propType) {
                            animatorSelector11 = animators11[j31].s;
                            mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                            if (mult11.length) animatorOffset11 += animatorProps11.p.v[0] * mult11[0];
                            else animatorOffset11 += animatorProps11.p.v[0] * mult11;
                        }
                        if (animatorProps11.a.propType) {
                            animatorSelector11 = animators11[j31].s;
                            mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                            if (mult11.length) animatorOffset11 += animatorProps11.a.v[0] * mult11[0];
                            else animatorOffset11 += animatorProps11.a.v[0] * mult11;
                        }
                    }
                    flag11 = true; // Force alignment only works with a single line for now
                    if (this._pathData.a.v) {
                        currentLength11 = letters11[0].an * 0.5 + (totalLength11 - this._pathData.f.v - letters11[0].an * 0.5 - letters11[letters11.length - 1].an * 0.5) * ind11 / (len11 - 1);
                        currentLength11 += this._pathData.f.v;
                    }
                    while(flag11){
                        if (segmentLength11 + partialLength11 >= currentLength11 + animatorOffset11 || !points11) {
                            perc11 = (currentLength11 + animatorOffset11 - segmentLength11) / currentPoint11.partialLength;
                            xPathPos11 = prevPoint11.point[0] + (currentPoint11.point[0] - prevPoint11.point[0]) * perc11;
                            yPathPos11 = prevPoint11.point[1] + (currentPoint11.point[1] - prevPoint11.point[1]) * perc11;
                            matrixHelper11.translate(-alignment11[0] * letters11[i31].an * 0.005, -(alignment11[1] * yOff11) * 0.01);
                            flag11 = false;
                        } else if (points11) {
                            segmentLength11 += currentPoint11.partialLength;
                            pointInd11 += 1;
                            if (pointInd11 >= points11.length) {
                                pointInd11 = 0;
                                segmentInd11 += 1;
                                if (!segments11[segmentInd11]) {
                                    if (mask11.v.c) {
                                        pointInd11 = 0;
                                        segmentInd11 = 0;
                                        points11 = segments11[segmentInd11].points;
                                    } else {
                                        segmentLength11 -= currentPoint11.partialLength;
                                        points11 = null;
                                    }
                                } else points11 = segments11[segmentInd11].points;
                            }
                            if (points11) {
                                prevPoint11 = currentPoint11;
                                currentPoint11 = points11[pointInd11];
                                partialLength11 = currentPoint11.partialLength;
                            }
                        }
                    }
                    offf11 = letters11[i31].an / 2 - letters11[i31].add;
                    matrixHelper11.translate(-offf11, 0, 0);
                } else {
                    offf11 = letters11[i31].an / 2 - letters11[i31].add;
                    matrixHelper11.translate(-offf11, 0, 0); // Grouping alignment
                    matrixHelper11.translate(-alignment11[0] * letters11[i31].an * 0.005, -alignment11[1] * yOff11 * 0.01, 0);
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.t.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"
                        if (xPos11 !== 0 || documentData11.j !== 0) {
                            if (this._hasMaskedPath) {
                                if (mult11.length) currentLength11 += animatorProps11.t.v * mult11[0];
                                else currentLength11 += animatorProps11.t.v * mult11;
                            } else if (mult11.length) xPos11 += animatorProps11.t.v * mult11[0];
                            else xPos11 += animatorProps11.t.v * mult11;
                        }
                    }
                }
                if (documentData11.strokeWidthAnim) sw11 = documentData11.sw || 0;
                if (documentData11.strokeColorAnim) {
                    if (documentData11.sc) sc11 = [
                        documentData11.sc[0],
                        documentData11.sc[1],
                        documentData11.sc[2]
                    ];
                    else sc11 = [
                        0,
                        0,
                        0
                    ];
                }
                if (documentData11.fillColorAnim && documentData11.fc) fc11 = [
                    documentData11.fc[0],
                    documentData11.fc[1],
                    documentData11.fc[2]
                ];
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.a.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (mult11.length) matrixHelper11.translate(-animatorProps11.a.v[0] * mult11[0], -animatorProps11.a.v[1] * mult11[1], animatorProps11.a.v[2] * mult11[2]);
                        else matrixHelper11.translate(-animatorProps11.a.v[0] * mult11, -animatorProps11.a.v[1] * mult11, animatorProps11.a.v[2] * mult11);
                    }
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.s.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (mult11.length) matrixHelper11.scale(1 + (animatorProps11.s.v[0] - 1) * mult11[0], 1 + (animatorProps11.s.v[1] - 1) * mult11[1], 1);
                        else matrixHelper11.scale(1 + (animatorProps11.s.v[0] - 1) * mult11, 1 + (animatorProps11.s.v[1] - 1) * mult11, 1);
                    }
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    animatorSelector11 = animators11[j31].s;
                    mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                    if (animatorProps11.sk.propType) {
                        if (mult11.length) matrixHelper11.skewFromAxis(-animatorProps11.sk.v * mult11[0], animatorProps11.sa.v * mult11[1]);
                        else matrixHelper11.skewFromAxis(-animatorProps11.sk.v * mult11, animatorProps11.sa.v * mult11);
                    }
                    if (animatorProps11.r.propType) {
                        if (mult11.length) matrixHelper11.rotateZ(-animatorProps11.r.v * mult11[2]);
                        else matrixHelper11.rotateZ(-animatorProps11.r.v * mult11);
                    }
                    if (animatorProps11.ry.propType) {
                        if (mult11.length) matrixHelper11.rotateY(animatorProps11.ry.v * mult11[1]);
                        else matrixHelper11.rotateY(animatorProps11.ry.v * mult11);
                    }
                    if (animatorProps11.rx.propType) {
                        if (mult11.length) matrixHelper11.rotateX(animatorProps11.rx.v * mult11[0]);
                        else matrixHelper11.rotateX(animatorProps11.rx.v * mult11);
                    }
                    if (animatorProps11.o.propType) {
                        if (mult11.length) elemOpacity11 += (animatorProps11.o.v * mult11[0] - elemOpacity11) * mult11[0];
                        else elemOpacity11 += (animatorProps11.o.v * mult11 - elemOpacity11) * mult11;
                    }
                    if (documentData11.strokeWidthAnim && animatorProps11.sw.propType) {
                        if (mult11.length) sw11 += animatorProps11.sw.v * mult11[0];
                        else sw11 += animatorProps11.sw.v * mult11;
                    }
                    if (documentData11.strokeColorAnim && animatorProps11.sc.propType) {
                        for(k31 = 0; k31 < 3; k31 += 1)if (mult11.length) sc11[k31] += (animatorProps11.sc.v[k31] - sc11[k31]) * mult11[0];
                        else sc11[k31] += (animatorProps11.sc.v[k31] - sc11[k31]) * mult11;
                    }
                    if (documentData11.fillColorAnim && documentData11.fc) {
                        if (animatorProps11.fc.propType) {
                            for(k31 = 0; k31 < 3; k31 += 1)if (mult11.length) fc11[k31] += (animatorProps11.fc.v[k31] - fc11[k31]) * mult11[0];
                            else fc11[k31] += (animatorProps11.fc.v[k31] - fc11[k31]) * mult11;
                        }
                        if (animatorProps11.fh.propType) {
                            if (mult11.length) fc11 = addHueToRGB(fc11, animatorProps11.fh.v * mult11[0]);
                            else fc11 = addHueToRGB(fc11, animatorProps11.fh.v * mult11);
                        }
                        if (animatorProps11.fs.propType) {
                            if (mult11.length) fc11 = addSaturationToRGB(fc11, animatorProps11.fs.v * mult11[0]);
                            else fc11 = addSaturationToRGB(fc11, animatorProps11.fs.v * mult11);
                        }
                        if (animatorProps11.fb.propType) {
                            if (mult11.length) fc11 = addBrightnessToRGB(fc11, animatorProps11.fb.v * mult11[0]);
                            else fc11 = addBrightnessToRGB(fc11, animatorProps11.fb.v * mult11);
                        }
                    }
                }
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    animatorProps11 = animators11[j31].a;
                    if (animatorProps11.p.propType) {
                        animatorSelector11 = animators11[j31].s;
                        mult11 = animatorSelector11.getMult(letters11[i31].anIndexes[j31], textData11.a[j31].s.totalChars);
                        if (this._hasMaskedPath) {
                            if (mult11.length) matrixHelper11.translate(0, animatorProps11.p.v[1] * mult11[0], -animatorProps11.p.v[2] * mult11[1]);
                            else matrixHelper11.translate(0, animatorProps11.p.v[1] * mult11, -animatorProps11.p.v[2] * mult11);
                        } else if (mult11.length) matrixHelper11.translate(animatorProps11.p.v[0] * mult11[0], animatorProps11.p.v[1] * mult11[1], -animatorProps11.p.v[2] * mult11[2]);
                        else matrixHelper11.translate(animatorProps11.p.v[0] * mult11, animatorProps11.p.v[1] * mult11, -animatorProps11.p.v[2] * mult11);
                    }
                }
                if (documentData11.strokeWidthAnim) letterSw11 = sw11 < 0 ? 0 : sw11;
                if (documentData11.strokeColorAnim) letterSc11 = "rgb(" + Math.round(sc11[0] * 255) + "," + Math.round(sc11[1] * 255) + "," + Math.round(sc11[2] * 255) + ")";
                if (documentData11.fillColorAnim && documentData11.fc) letterFc11 = "rgb(" + Math.round(fc11[0] * 255) + "," + Math.round(fc11[1] * 255) + "," + Math.round(fc11[2] * 255) + ")";
                if (this._hasMaskedPath) {
                    matrixHelper11.translate(0, -documentData11.ls);
                    matrixHelper11.translate(0, alignment11[1] * yOff11 * 0.01 + yPos11, 0);
                    if (this._pathData.p.v) {
                        tanAngle11 = (currentPoint11.point[1] - prevPoint11.point[1]) / (currentPoint11.point[0] - prevPoint11.point[0]);
                        var rot11 = Math.atan(tanAngle11) * 180 / Math.PI;
                        if (currentPoint11.point[0] < prevPoint11.point[0]) rot11 += 180;
                        matrixHelper11.rotate(-rot11 * Math.PI / 180);
                    }
                    matrixHelper11.translate(xPathPos11, yPathPos11, 0);
                    currentLength11 -= alignment11[0] * letters11[i31].an * 0.005;
                    if (letters11[i31 + 1] && ind11 !== letters11[i31 + 1].ind) {
                        currentLength11 += letters11[i31].an / 2;
                        currentLength11 += documentData11.tr * 0.001 * documentData11.finalSize;
                    }
                } else {
                    matrixHelper11.translate(xPos11, yPos11, 0);
                    if (documentData11.ps) // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
                    matrixHelper11.translate(documentData11.ps[0], documentData11.ps[1] + documentData11.ascent, 0);
                    switch(documentData11.j){
                        case 1:
                            matrixHelper11.translate(letters11[i31].animatorJustifyOffset + documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[letters11[i31].line]), 0, 0);
                            break;
                        case 2:
                            matrixHelper11.translate(letters11[i31].animatorJustifyOffset + documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[letters11[i31].line]) / 2, 0, 0);
                            break;
                        default:
                            break;
                    }
                    matrixHelper11.translate(0, -documentData11.ls);
                    matrixHelper11.translate(offf11, 0, 0);
                    matrixHelper11.translate(alignment11[0] * letters11[i31].an * 0.005, alignment11[1] * yOff11 * 0.01, 0);
                    xPos11 += letters11[i31].l + documentData11.tr * 0.001 * documentData11.finalSize;
                }
                if (renderType11 === "html") letterM11 = matrixHelper11.toCSS();
                else if (renderType11 === "svg") letterM11 = matrixHelper11.to2dCSS();
                else letterP11 = [
                    matrixHelper11.props[0],
                    matrixHelper11.props[1],
                    matrixHelper11.props[2],
                    matrixHelper11.props[3],
                    matrixHelper11.props[4],
                    matrixHelper11.props[5],
                    matrixHelper11.props[6],
                    matrixHelper11.props[7],
                    matrixHelper11.props[8],
                    matrixHelper11.props[9],
                    matrixHelper11.props[10],
                    matrixHelper11.props[11],
                    matrixHelper11.props[12],
                    matrixHelper11.props[13],
                    matrixHelper11.props[14],
                    matrixHelper11.props[15]
                ];
                letterO11 = elemOpacity11;
            }
            if (renderedLettersCount11 <= i31) {
                letterValue11 = new LetterProps(letterO11, letterSw11, letterSc11, letterFc11, letterM11, letterP11);
                this.renderedLetters.push(letterValue11);
                renderedLettersCount11 += 1;
                this.lettersChangedFlag = true;
            } else {
                letterValue11 = this.renderedLetters[i31];
                this.lettersChangedFlag = letterValue11.update(letterO11, letterSw11, letterSc11, letterFc11, letterM11, letterP11) || this.lettersChangedFlag;
            }
        }
    };
    TextAnimatorProperty.prototype.getValue = function() {
        if (this._elem.globalData.frameId === this._frameId) return;
        this._frameId = this._elem.globalData.frameId;
        this.iterateDynamicProperties();
    };
    TextAnimatorProperty.prototype.mHelper = new Matrix();
    TextAnimatorProperty.prototype.defaultPropsArray = [];
    extendPrototype([
        DynamicPropertyContainer
    ], TextAnimatorProperty);
    function ITextElement() {}
    ITextElement.prototype.initElement = function(data11, globalData11, comp11) {
        this.lettersChangedFlag = true;
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.textProperty = new TextProperty(this, data11.t, this.dynamicProperties);
        this.textAnimator = new TextAnimatorProperty(data11.t, this.renderType, this);
        this.initTransform(data11, globalData11, comp11);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
        this.textAnimator.searchProperties(this.dynamicProperties);
    };
    ITextElement.prototype.prepareFrame = function(num11) {
        this._mdf = false;
        this.prepareRenderableFrame(num11);
        this.prepareProperties(num11, this.isInRange);
    };
    ITextElement.prototype.createPathShape = function(matrixHelper11, shapes11) {
        var j31;
        var jLen11 = shapes11.length;
        var pathNodes11;
        var shapeStr11 = "";
        for(j31 = 0; j31 < jLen11; j31 += 1)if (shapes11[j31].ty === "sh") {
            pathNodes11 = shapes11[j31].ks.k;
            shapeStr11 += buildShapeString(pathNodes11, pathNodes11.i.length, true, matrixHelper11);
        }
        return shapeStr11;
    };
    ITextElement.prototype.updateDocumentData = function(newData11, index11) {
        this.textProperty.updateDocumentData(newData11, index11);
    };
    ITextElement.prototype.canResizeFont = function(_canResize11) {
        this.textProperty.canResizeFont(_canResize11);
    };
    ITextElement.prototype.setMinimumFontSize = function(_fontSize11) {
        this.textProperty.setMinimumFontSize(_fontSize11);
    };
    ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData11, matrixHelper11, lineNumber11, xPos11, yPos11) {
        if (documentData11.ps) matrixHelper11.translate(documentData11.ps[0], documentData11.ps[1] + documentData11.ascent, 0);
        matrixHelper11.translate(0, -documentData11.ls, 0);
        switch(documentData11.j){
            case 1:
                matrixHelper11.translate(documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[lineNumber11]), 0, 0);
                break;
            case 2:
                matrixHelper11.translate(documentData11.justifyOffset + (documentData11.boxWidth - documentData11.lineWidths[lineNumber11]) / 2, 0, 0);
                break;
            default:
                break;
        }
        matrixHelper11.translate(xPos11, yPos11, 0);
    };
    ITextElement.prototype.buildColor = function(colorData11) {
        return "rgb(" + Math.round(colorData11[0] * 255) + "," + Math.round(colorData11[1] * 255) + "," + Math.round(colorData11[2] * 255) + ")";
    };
    ITextElement.prototype.emptyProp = new LetterProps();
    ITextElement.prototype.destroy = function() {};
    ITextElement.prototype.validateText = function() {
        if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
            this.buildNewText();
            this.textProperty._isFirstFrame = false;
            this.textProperty._mdf = false;
        }
    };
    var emptyShapeData = {
        shapes: []
    };
    function SVGTextLottieElement(data11, globalData11, comp11) {
        this.textSpans = [];
        this.renderType = "svg";
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        SVGBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], SVGTextLottieElement);
    SVGTextLottieElement.prototype.createContent = function() {
        if (this.data.singleShape && !this.globalData.fontManager.chars) this.textContainer = createNS("text");
    };
    SVGTextLottieElement.prototype.buildTextContents = function(textArray11) {
        var i31 = 0;
        var len11 = textArray11.length;
        var textContents11 = [];
        var currentTextContent11 = "";
        while(i31 < len11){
            if (textArray11[i31] === String.fromCharCode(13) || textArray11[i31] === String.fromCharCode(3)) {
                textContents11.push(currentTextContent11);
                currentTextContent11 = "";
            } else currentTextContent11 += textArray11[i31];
            i31 += 1;
        }
        textContents11.push(currentTextContent11);
        return textContents11;
    };
    SVGTextLottieElement.prototype.buildShapeData = function(data11, scale21) {
        // data should probably be cloned to apply scale separately to each instance of a text on different layers
        // but since text internal content gets only rendered once and then it's never rerendered,
        // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
        // Avoiding cloning is preferred since cloning each character shape data is expensive
        if (data11.shapes && data11.shapes.length) {
            var shape31 = data11.shapes[0];
            if (shape31.it) {
                var shapeItem11 = shape31.it[shape31.it.length - 1];
                if (shapeItem11.s) {
                    shapeItem11.s.k[0] = scale21;
                    shapeItem11.s.k[1] = scale21;
                }
            }
        }
        return data11;
    };
    SVGTextLottieElement.prototype.buildNewText = function() {
        this.addDynamicProperty(this);
        var i31;
        var len11;
        var documentData11 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData11 ? documentData11.l.length : 0);
        if (documentData11.fc) this.layerElement.setAttribute("fill", this.buildColor(documentData11.fc));
        else this.layerElement.setAttribute("fill", "rgba(0,0,0,0)");
        if (documentData11.sc) {
            this.layerElement.setAttribute("stroke", this.buildColor(documentData11.sc));
            this.layerElement.setAttribute("stroke-width", documentData11.sw);
        }
        this.layerElement.setAttribute("font-size", documentData11.finalSize);
        var fontData11 = this.globalData.fontManager.getFontByName(documentData11.f);
        if (fontData11.fClass) this.layerElement.setAttribute("class", fontData11.fClass);
        else {
            this.layerElement.setAttribute("font-family", fontData11.fFamily);
            var fWeight11 = documentData11.fWeight;
            var fStyle11 = documentData11.fStyle;
            this.layerElement.setAttribute("font-style", fStyle11);
            this.layerElement.setAttribute("font-weight", fWeight11);
        }
        this.layerElement.setAttribute("aria-label", documentData11.t);
        var letters11 = documentData11.l || [];
        var usesGlyphs11 = !!this.globalData.fontManager.chars;
        len11 = letters11.length;
        var tSpan11;
        var matrixHelper11 = this.mHelper;
        var shapeStr11 = "";
        var singleShape11 = this.data.singleShape;
        var xPos11 = 0;
        var yPos11 = 0;
        var firstLine11 = true;
        var trackingOffset11 = documentData11.tr * 0.001 * documentData11.finalSize;
        if (singleShape11 && !usesGlyphs11 && !documentData11.sz) {
            var tElement11 = this.textContainer;
            var justify11 = "start";
            switch(documentData11.j){
                case 1:
                    justify11 = "end";
                    break;
                case 2:
                    justify11 = "middle";
                    break;
                default:
                    justify11 = "start";
                    break;
            }
            tElement11.setAttribute("text-anchor", justify11);
            tElement11.setAttribute("letter-spacing", trackingOffset11);
            var textContent11 = this.buildTextContents(documentData11.finalText);
            len11 = textContent11.length;
            yPos11 = documentData11.ps ? documentData11.ps[1] + documentData11.ascent : 0;
            for(i31 = 0; i31 < len11; i31 += 1){
                tSpan11 = this.textSpans[i31].span || createNS("tspan");
                tSpan11.textContent = textContent11[i31];
                tSpan11.setAttribute("x", 0);
                tSpan11.setAttribute("y", yPos11);
                tSpan11.style.display = "inherit";
                tElement11.appendChild(tSpan11);
                if (!this.textSpans[i31]) this.textSpans[i31] = {
                    span: null,
                    glyph: null
                };
                this.textSpans[i31].span = tSpan11;
                yPos11 += documentData11.finalLineHeight;
            }
            this.layerElement.appendChild(tElement11);
        } else {
            var cachedSpansLength11 = this.textSpans.length;
            var charData11;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (!this.textSpans[i31]) this.textSpans[i31] = {
                    span: null,
                    childSpan: null,
                    glyph: null
                };
                if (!usesGlyphs11 || !singleShape11 || i31 === 0) {
                    tSpan11 = cachedSpansLength11 > i31 ? this.textSpans[i31].span : createNS(usesGlyphs11 ? "g" : "text");
                    if (cachedSpansLength11 <= i31) {
                        tSpan11.setAttribute("stroke-linecap", "butt");
                        tSpan11.setAttribute("stroke-linejoin", "round");
                        tSpan11.setAttribute("stroke-miterlimit", "4");
                        this.textSpans[i31].span = tSpan11;
                        if (usesGlyphs11) {
                            var childSpan11 = createNS("g");
                            tSpan11.appendChild(childSpan11);
                            this.textSpans[i31].childSpan = childSpan11;
                        }
                        this.textSpans[i31].span = tSpan11;
                        this.layerElement.appendChild(tSpan11);
                    }
                    tSpan11.style.display = "inherit";
                }
                matrixHelper11.reset();
                if (singleShape11) {
                    if (letters11[i31].n) {
                        xPos11 = -trackingOffset11;
                        yPos11 += documentData11.yOffset;
                        yPos11 += firstLine11 ? 1 : 0;
                        firstLine11 = false;
                    }
                    this.applyTextPropertiesToMatrix(documentData11, matrixHelper11, letters11[i31].line, xPos11, yPos11);
                    xPos11 += letters11[i31].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;
                    xPos11 += trackingOffset11;
                }
                if (usesGlyphs11) {
                    charData11 = this.globalData.fontManager.getCharData(documentData11.finalText[i31], fontData11.fStyle, this.globalData.fontManager.getFontByName(documentData11.f).fFamily);
                    var glyphElement11; // t === 1 means the character has been replaced with an animated shaped
                    if (charData11.t === 1) glyphElement11 = new SVGCompElement(charData11.data, this.globalData, this);
                    else {
                        var data11 = emptyShapeData;
                        if (charData11.data && charData11.data.shapes) data11 = this.buildShapeData(charData11.data, documentData11.finalSize);
                        glyphElement11 = new SVGShapeElement(data11, this.globalData, this);
                    }
                    if (this.textSpans[i31].glyph) {
                        var glyph11 = this.textSpans[i31].glyph;
                        this.textSpans[i31].childSpan.removeChild(glyph11.layerElement);
                        glyph11.destroy();
                    }
                    this.textSpans[i31].glyph = glyphElement11;
                    glyphElement11._debug = true;
                    glyphElement11.prepareFrame(0);
                    glyphElement11.renderFrame();
                    this.textSpans[i31].childSpan.appendChild(glyphElement11.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
                    // this might have issues with strokes and might need a different solution
                    if (charData11.t === 1) this.textSpans[i31].childSpan.setAttribute("transform", "scale(" + documentData11.finalSize / 100 + "," + documentData11.finalSize / 100 + ")");
                } else {
                    if (singleShape11) tSpan11.setAttribute("transform", "translate(" + matrixHelper11.props[12] + "," + matrixHelper11.props[13] + ")");
                    tSpan11.textContent = letters11[i31].val;
                    tSpan11.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                } //
            }
            if (singleShape11 && tSpan11) tSpan11.setAttribute("d", shapeStr11);
        }
        while(i31 < this.textSpans.length){
            this.textSpans[i31].span.style.display = "none";
            i31 += 1;
        }
        this._sizeChanged = true;
    };
    SVGTextLottieElement.prototype.sourceRectAtTime = function() {
        this.prepareFrame(this.comp.renderedFrame - this.data.st);
        this.renderInnerContent();
        if (this._sizeChanged) {
            this._sizeChanged = false;
            var textBox11 = this.layerElement.getBBox();
            this.bbox = {
                top: textBox11.y,
                left: textBox11.x,
                width: textBox11.width,
                height: textBox11.height
            };
        }
        return this.bbox;
    };
    SVGTextLottieElement.prototype.getValue = function() {
        var i31;
        var len11 = this.textSpans.length;
        var glyphElement11;
        this.renderedFrame = this.comp.renderedFrame;
        for(i31 = 0; i31 < len11; i31 += 1){
            glyphElement11 = this.textSpans[i31].glyph;
            if (glyphElement11) {
                glyphElement11.prepareFrame(this.comp.renderedFrame - this.data.st);
                if (glyphElement11._mdf) this._mdf = true;
            }
        }
    };
    SVGTextLottieElement.prototype.renderInnerContent = function() {
        this.validateText();
        if (!this.data.singleShape || this._mdf) {
            this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                this._sizeChanged = true;
                var i31;
                var len11;
                var renderedLetters11 = this.textAnimator.renderedLetters;
                var letters11 = this.textProperty.currentData.l;
                len11 = letters11.length;
                var renderedLetter11;
                var textSpan11;
                var glyphElement11;
                for(i31 = 0; i31 < len11; i31 += 1)if (!letters11[i31].n) {
                    renderedLetter11 = renderedLetters11[i31];
                    textSpan11 = this.textSpans[i31].span;
                    glyphElement11 = this.textSpans[i31].glyph;
                    if (glyphElement11) glyphElement11.renderFrame();
                    if (renderedLetter11._mdf.m) textSpan11.setAttribute("transform", renderedLetter11.m);
                    if (renderedLetter11._mdf.o) textSpan11.setAttribute("opacity", renderedLetter11.o);
                    if (renderedLetter11._mdf.sw) textSpan11.setAttribute("stroke-width", renderedLetter11.sw);
                    if (renderedLetter11._mdf.sc) textSpan11.setAttribute("stroke", renderedLetter11.sc);
                    if (renderedLetter11._mdf.fc) textSpan11.setAttribute("fill", renderedLetter11.fc);
                }
            }
        }
    };
    function ISolidElement(data11, globalData11, comp11) {
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        IImageElement
    ], ISolidElement);
    ISolidElement.prototype.createContent = function() {
        var rect11 = createNS("rect"); /// /rect.style.width = this.data.sw;
        /// /rect.style.height = this.data.sh;
        /// /rect.style.fill = this.data.sc;
        rect11.setAttribute("width", this.data.sw);
        rect11.setAttribute("height", this.data.sh);
        rect11.setAttribute("fill", this.data.sc);
        this.layerElement.appendChild(rect11);
    };
    function NullElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.initFrame();
        this.initTransform(data11, globalData11, comp11);
        this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(num11) {
        this.prepareProperties(num11, true);
    };
    NullElement.prototype.renderFrame = function() {};
    NullElement.prototype.getBaseElement = function() {
        return null;
    };
    NullElement.prototype.destroy = function() {};
    NullElement.prototype.sourceRectAtTime = function() {};
    NullElement.prototype.hide = function() {};
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement
    ], NullElement);
    function SVGRendererBase() {}
    extendPrototype([
        BaseRenderer
    ], SVGRendererBase);
    SVGRendererBase.prototype.createNull = function(data11) {
        return new NullElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createShape = function(data11) {
        return new SVGShapeElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createText = function(data11) {
        return new SVGTextLottieElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createImage = function(data11) {
        return new IImageElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.createSolid = function(data11) {
        return new ISolidElement(data11, this.globalData, this);
    };
    SVGRendererBase.prototype.configAnimation = function(animData11) {
        this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg");
        this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
        if (this.renderConfig.viewBoxSize) this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize);
        else this.svgElement.setAttribute("viewBox", "0 0 " + animData11.w + " " + animData11.h);
        if (!this.renderConfig.viewBoxOnly) {
            this.svgElement.setAttribute("width", animData11.w);
            this.svgElement.setAttribute("height", animData11.h);
            this.svgElement.style.width = "100%";
            this.svgElement.style.height = "100%";
            this.svgElement.style.transform = "translate3d(0,0,0)";
            this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
        }
        if (this.renderConfig.width) this.svgElement.setAttribute("width", this.renderConfig.width);
        if (this.renderConfig.height) this.svgElement.setAttribute("height", this.renderConfig.height);
        if (this.renderConfig.className) this.svgElement.setAttribute("class", this.renderConfig.className);
        if (this.renderConfig.id) this.svgElement.setAttribute("id", this.renderConfig.id);
        if (this.renderConfig.focusable !== undefined) this.svgElement.setAttribute("focusable", this.renderConfig.focusable);
        this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
        // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
        this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation
        var defs11 = this.globalData.defs;
        this.setupGlobalData(animData11, defs11);
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.data = animData11;
        var maskElement11 = createNS("clipPath");
        var rect11 = createNS("rect");
        rect11.setAttribute("width", animData11.w);
        rect11.setAttribute("height", animData11.h);
        rect11.setAttribute("x", 0);
        rect11.setAttribute("y", 0);
        var maskId11 = createElementID();
        maskElement11.setAttribute("id", maskId11);
        maskElement11.appendChild(rect11);
        this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + maskId11 + ")");
        defs11.appendChild(maskElement11);
        this.layers = animData11.layers;
        this.elements = createSizedArray(animData11.layers.length);
    };
    SVGRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.layerElement = null;
        this.globalData.defs = null;
        var i31;
        var len11 = this.layers ? this.layers.length : 0;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31] && this.elements[i31].destroy) this.elements[i31].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    SVGRendererBase.prototype.updateContainerSize = function() {};
    SVGRendererBase.prototype.findIndexByInd = function(ind11) {
        var i31 = 0;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.layers[i31].ind === ind11) return i31;
        }
        return -1;
    };
    SVGRendererBase.prototype.buildItem = function(pos11) {
        var elements11 = this.elements;
        if (elements11[pos11] || this.layers[pos11].ty === 99) return;
        elements11[pos11] = true;
        var element11 = this.createItem(this.layers[pos11]);
        elements11[pos11] = element11;
        if (getExpressionsPlugin()) {
            if (this.layers[pos11].ty === 0) this.globalData.projectInterface.registerComposition(element11);
            element11.initExpressions();
        }
        this.appendElementInPos(element11, pos11);
        if (this.layers[pos11].tt) {
            var elementIndex11 = "tp" in this.layers[pos11] ? this.findIndexByInd(this.layers[pos11].tp) : pos11 - 1;
            if (elementIndex11 === -1) return;
            if (!this.elements[elementIndex11] || this.elements[elementIndex11] === true) {
                this.buildItem(elementIndex11);
                this.addPendingElement(element11);
            } else {
                var matteElement11 = elements11[elementIndex11];
                var matteMask11 = matteElement11.getMatte(this.layers[pos11].tt);
                element11.setMatte(matteMask11);
            }
        }
    };
    SVGRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element11 = this.pendingElements.pop();
            element11.checkParenting();
            if (element11.data.tt) {
                var i31 = 0;
                var len11 = this.elements.length;
                while(i31 < len11){
                    if (this.elements[i31] === element11) {
                        var elementIndex11 = "tp" in element11.data ? this.findIndexByInd(element11.data.tp) : i31 - 1;
                        var matteElement11 = this.elements[elementIndex11];
                        var matteMask11 = matteElement11.getMatte(this.layers[i31].tt);
                        element11.setMatte(matteMask11);
                        break;
                    }
                    i31 += 1;
                }
            }
        }
    };
    SVGRendererBase.prototype.renderFrame = function(num11) {
        if (this.renderedFrame === num11 || this.destroyed) return;
        if (num11 === null) num11 = this.renderedFrame;
        else this.renderedFrame = num11;
         // console.log('-------');
        // console.log('FRAME ',num);
        this.globalData.frameNum = num11;
        this.globalData.frameId += 1;
        this.globalData.projectInterface.currentFrame = num11;
        this.globalData._mdf = false;
        var i31;
        var len11 = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num11);
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].prepareFrame(num11 - this.layers[i31].st);
        if (this.globalData._mdf) {
            for(i31 = 0; i31 < len11; i31 += 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
        }
    };
    SVGRendererBase.prototype.appendElementInPos = function(element11, pos11) {
        var newElement11 = element11.getBaseElement();
        if (!newElement11) return;
        var i31 = 0;
        var nextElement11;
        while(i31 < pos11){
            if (this.elements[i31] && this.elements[i31] !== true && this.elements[i31].getBaseElement()) nextElement11 = this.elements[i31].getBaseElement();
            i31 += 1;
        }
        if (nextElement11) this.layerElement.insertBefore(newElement11, nextElement11);
        else this.layerElement.appendChild(newElement11);
    };
    SVGRendererBase.prototype.hide = function() {
        this.layerElement.style.display = "none";
    };
    SVGRendererBase.prototype.show = function() {
        this.layerElement.style.display = "block";
    };
    function ICompElement() {}
    extendPrototype([
        BaseElement,
        TransformElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], ICompElement);
    ICompElement.prototype.initElement = function(data11, globalData11, comp11) {
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.initTransform(data11, globalData11, comp11);
        this.initRenderable();
        this.initHierarchy();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        if (this.data.xt || !globalData11.progressiveLoad) this.buildAllItems();
        this.hide();
    };
    /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */ ICompElement.prototype.prepareFrame = function(num11) {
        this._mdf = false;
        this.prepareRenderableFrame(num11);
        this.prepareProperties(num11, this.isInRange);
        if (!this.isInRange && !this.data.xt) return;
        if (!this.tm._placeholder) {
            var timeRemapped11 = this.tm.v;
            if (timeRemapped11 === this.data.op) timeRemapped11 = this.data.op - 1;
            this.renderedFrame = timeRemapped11;
        } else this.renderedFrame = num11 / this.data.sr;
        var i31;
        var len11 = this.elements.length;
        if (!this.completeLayers) this.checkLayers(this.renderedFrame);
         // This iteration needs to be backwards because of how expressions connect between each other
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) {
            this.elements[i31].prepareFrame(this.renderedFrame - this.layers[i31].st);
            if (this.elements[i31]._mdf) this._mdf = true;
        }
    };
    ICompElement.prototype.renderInnerContent = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
    };
    ICompElement.prototype.setElements = function(elems11) {
        this.elements = elems11;
    };
    ICompElement.prototype.getElements = function() {
        return this.elements;
    };
    ICompElement.prototype.destroyElements = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31]) this.elements[i31].destroy();
    };
    ICompElement.prototype.destroy = function() {
        this.destroyElements();
        this.destroyBaseElement();
    };
    function SVGCompElement(data11, globalData11, comp11) {
        this.layers = data11.layers;
        this.supports3d = true;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data11, globalData11, comp11);
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        SVGRendererBase,
        ICompElement,
        SVGBaseElement
    ], SVGCompElement);
    SVGCompElement.prototype.createComp = function(data11) {
        return new SVGCompElement(data11, this.globalData, this);
    };
    function SVGRenderer(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.layers = null;
        this.renderedFrame = -1;
        this.svgElement = createNS("svg");
        var ariaLabel11 = "";
        if (config11 && config11.title) {
            var titleElement11 = createNS("title");
            var titleId11 = createElementID();
            titleElement11.setAttribute("id", titleId11);
            titleElement11.textContent = config11.title;
            this.svgElement.appendChild(titleElement11);
            ariaLabel11 += titleId11;
        }
        if (config11 && config11.description) {
            var descElement11 = createNS("desc");
            var descId11 = createElementID();
            descElement11.setAttribute("id", descId11);
            descElement11.textContent = config11.description;
            this.svgElement.appendChild(descElement11);
            ariaLabel11 += " " + descId11;
        }
        if (ariaLabel11) this.svgElement.setAttribute("aria-labelledby", ariaLabel11);
        var defs11 = createNS("defs");
        this.svgElement.appendChild(defs11);
        var maskElement11 = createNS("g");
        this.svgElement.appendChild(maskElement11);
        this.layerElement = maskElement11;
        this.renderConfig = {
            preserveAspectRatio: config11 && config11.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config11 && config11.contentVisibility || "visible",
            progressiveLoad: config11 && config11.progressiveLoad || false,
            hideOnTransparent: !(config11 && config11.hideOnTransparent === false),
            viewBoxOnly: config11 && config11.viewBoxOnly || false,
            viewBoxSize: config11 && config11.viewBoxSize || false,
            className: config11 && config11.className || "",
            id: config11 && config11.id || "",
            focusable: config11 && config11.focusable,
            filterSize: {
                width: config11 && config11.filterSize && config11.filterSize.width || "100%",
                height: config11 && config11.filterSize && config11.filterSize.height || "100%",
                x: config11 && config11.filterSize && config11.filterSize.x || "0%",
                y: config11 && config11.filterSize && config11.filterSize.y || "0%"
            },
            width: config11 && config11.width,
            height: config11 && config11.height,
            runExpressions: !config11 || config11.runExpressions === undefined || config11.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            defs: defs11,
            renderConfig: this.renderConfig
        };
        this.elements = [];
        this.pendingElements = [];
        this.destroyed = false;
        this.rendererType = "svg";
    }
    extendPrototype([
        SVGRendererBase
    ], SVGRenderer);
    SVGRenderer.prototype.createComp = function(data11) {
        return new SVGCompElement(data11, this.globalData, this);
    };
    function CVContextData() {
        this.saved = [];
        this.cArrPos = 0;
        this.cTr = new Matrix();
        this.cO = 1;
        var i31;
        var len11 = 15;
        this.savedOp = createTypedArray("float32", len11);
        for(i31 = 0; i31 < len11; i31 += 1)this.saved[i31] = createTypedArray("float32", 16);
        this._length = len11;
    }
    CVContextData.prototype.duplicate = function() {
        var newLength11 = this._length * 2;
        var currentSavedOp11 = this.savedOp;
        this.savedOp = createTypedArray("float32", newLength11);
        this.savedOp.set(currentSavedOp11);
        var i31 = 0;
        for(i31 = this._length; i31 < newLength11; i31 += 1)this.saved[i31] = createTypedArray("float32", 16);
        this._length = newLength11;
    };
    CVContextData.prototype.reset = function() {
        this.cArrPos = 0;
        this.cTr.reset();
        this.cO = 1;
    };
    CVContextData.prototype.popTransform = function() {
        var popped11 = this.saved[this.cArrPos];
        var i31;
        var arr31 = this.cTr.props;
        for(i31 = 0; i31 < 16; i31 += 1)arr31[i31] = popped11[i31];
        return popped11;
    };
    CVContextData.prototype.popOpacity = function() {
        var popped11 = this.savedOp[this.cArrPos];
        this.cO = popped11;
        return popped11;
    };
    CVContextData.prototype.pop = function() {
        this.cArrPos -= 1;
        var transform11 = this.popTransform();
        var opacity11 = this.popOpacity();
        return {
            transform: transform11,
            opacity: opacity11
        };
    };
    CVContextData.prototype.push = function() {
        var props11 = this.cTr.props;
        if (this._length <= this.cArrPos) this.duplicate();
        var i31;
        var arr31 = this.saved[this.cArrPos];
        for(i31 = 0; i31 < 16; i31 += 1)arr31[i31] = props11[i31];
        this.savedOp[this.cArrPos] = this.cO;
        this.cArrPos += 1;
    };
    CVContextData.prototype.getTransform = function() {
        return this.cTr;
    };
    CVContextData.prototype.getOpacity = function() {
        return this.cO;
    };
    CVContextData.prototype.setOpacity = function(value31) {
        this.cO = value31;
    };
    function ShapeTransformManager() {
        this.sequences = {};
        this.sequenceList = [];
        this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
        addTransformSequence: function addTransformSequence11(transforms11) {
            var i31;
            var len11 = transforms11.length;
            var key11 = "_";
            for(i31 = 0; i31 < len11; i31 += 1)key11 += transforms11[i31].transform.key + "_";
            var sequence11 = this.sequences[key11];
            if (!sequence11) {
                sequence11 = {
                    transforms: [].concat(transforms11),
                    finalTransform: new Matrix(),
                    _mdf: false
                };
                this.sequences[key11] = sequence11;
                this.sequenceList.push(sequence11);
            }
            return sequence11;
        },
        processSequence: function processSequence11(sequence11, isFirstFrame11) {
            var i31 = 0;
            var len11 = sequence11.transforms.length;
            var _mdf11 = isFirstFrame11;
            while(i31 < len11 && !isFirstFrame11){
                if (sequence11.transforms[i31].transform.mProps._mdf) {
                    _mdf11 = true;
                    break;
                }
                i31 += 1;
            }
            if (_mdf11) {
                sequence11.finalTransform.reset();
                for(i31 = len11 - 1; i31 >= 0; i31 -= 1)sequence11.finalTransform.multiply(sequence11.transforms[i31].transform.mProps.v);
            }
            sequence11._mdf = _mdf11;
        },
        processSequences: function processSequences11(isFirstFrame11) {
            var i31;
            var len11 = this.sequenceList.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.processSequence(this.sequenceList[i31], isFirstFrame11);
        },
        getNewKey: function getNewKey11() {
            this.transform_key_count += 1;
            return "_" + this.transform_key_count;
        }
    };
    var lumaLoader = function lumaLoader11() {
        var id11 = "__lottie_element_luma_buffer";
        var lumaBuffer11 = null;
        var lumaBufferCtx11 = null;
        var svg11 = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
        // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
        // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
        // Naming it solution 2 to mark the extra comment lines.
        /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */ function createLumaSvgFilter11() {
            var _svg11 = createNS("svg");
            var fil11 = createNS("filter");
            var matrix11 = createNS("feColorMatrix");
            fil11.setAttribute("id", id11);
            matrix11.setAttribute("type", "matrix");
            matrix11.setAttribute("color-interpolation-filters", "sRGB");
            matrix11.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0");
            fil11.appendChild(matrix11);
            _svg11.appendChild(fil11);
            _svg11.setAttribute("id", id11 + "_svg");
            if (featureSupport.svgLumaHidden) _svg11.style.display = "none";
            return _svg11;
        }
        function loadLuma11() {
            if (!lumaBuffer11) {
                svg11 = createLumaSvgFilter11();
                document.body.appendChild(svg11);
                lumaBuffer11 = createTag("canvas");
                lumaBufferCtx11 = lumaBuffer11.getContext("2d"); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
                lumaBufferCtx11.filter = "url(#" + id11 + ")";
                lumaBufferCtx11.fillStyle = "rgba(0,0,0,0)";
                lumaBufferCtx11.fillRect(0, 0, 1, 1);
            }
        }
        function getLuma11(canvas11) {
            if (!lumaBuffer11) loadLuma11();
            lumaBuffer11.width = canvas11.width;
            lumaBuffer11.height = canvas11.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2
            lumaBufferCtx11.filter = "url(#" + id11 + ")";
            return lumaBuffer11;
        }
        return {
            load: loadLuma11,
            get: getLuma11
        };
    };
    function createCanvas(width11, height11) {
        if (featureSupport.offscreenCanvas) return new OffscreenCanvas(width11, height11);
        var canvas11 = createTag("canvas");
        canvas11.width = width11;
        canvas11.height = height11;
        return canvas11;
    }
    var assetLoader = function() {
        return {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        };
    }();
    var registeredEffects = {};
    function CVEffects(elem31) {
        var i31;
        var len11 = elem31.data.ef ? elem31.data.ef.length : 0;
        this.filters = [];
        var filterManager11;
        for(i31 = 0; i31 < len11; i31 += 1){
            filterManager11 = null;
            var type11 = elem31.data.ef[i31].ty;
            if (registeredEffects[type11]) {
                var Effect11 = registeredEffects[type11].effect;
                filterManager11 = new Effect11(elem31.effectsManager.effectElements[i31], elem31);
            }
            if (filterManager11) this.filters.push(filterManager11);
        }
        if (this.filters.length) elem31.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(_isFirstFrame11) {
        var i31;
        var len11 = this.filters.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.filters[i31].renderFrame(_isFirstFrame11);
    };
    CVEffects.prototype.getEffects = function(type11) {
        var i31;
        var len11 = this.filters.length;
        var effects11 = [];
        for(i31 = 0; i31 < len11; i31 += 1)if (this.filters[i31].type === type11) effects11.push(this.filters[i31]);
        return effects11;
    };
    function registerEffect(id11, effect11) {
        registeredEffects[id11] = {
            effect: effect11
        };
    }
    function CVMaskElement(data11, element11) {
        this.data = data11;
        this.element = element11;
        this.masksProperties = this.data.masksProperties || [];
        this.viewData = createSizedArray(this.masksProperties.length);
        var i31;
        var len11 = this.masksProperties.length;
        var hasMasks11 = false;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.masksProperties[i31].mode !== "n") hasMasks11 = true;
            this.viewData[i31] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i31], 3);
        }
        this.hasMasks = hasMasks11;
        if (hasMasks11) this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
        if (!this.hasMasks) return;
        var transform11 = this.element.finalTransform.mat;
        var ctx11 = this.element.canvasContext;
        var i31;
        var len11 = this.masksProperties.length;
        var pt51;
        var pts11;
        var data11;
        ctx11.beginPath();
        for(i31 = 0; i31 < len11; i31 += 1)if (this.masksProperties[i31].mode !== "n") {
            if (this.masksProperties[i31].inv) {
                ctx11.moveTo(0, 0);
                ctx11.lineTo(this.element.globalData.compSize.w, 0);
                ctx11.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
                ctx11.lineTo(0, this.element.globalData.compSize.h);
                ctx11.lineTo(0, 0);
            }
            data11 = this.viewData[i31].v;
            pt51 = transform11.applyToPointArray(data11.v[0][0], data11.v[0][1], 0);
            ctx11.moveTo(pt51[0], pt51[1]);
            var j31;
            var jLen11 = data11._length;
            for(j31 = 1; j31 < jLen11; j31 += 1){
                pts11 = transform11.applyToTriplePoints(data11.o[j31 - 1], data11.i[j31], data11.v[j31]);
                ctx11.bezierCurveTo(pts11[0], pts11[1], pts11[2], pts11[3], pts11[4], pts11[5]);
            }
            pts11 = transform11.applyToTriplePoints(data11.o[j31 - 1], data11.i[0], data11.v[0]);
            ctx11.bezierCurveTo(pts11[0], pts11[1], pts11[2], pts11[3], pts11[4], pts11[5]);
        }
        this.element.globalData.renderer.save(true);
        ctx11.clip();
    };
    CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
    CVMaskElement.prototype.destroy = function() {
        this.element = null;
    };
    function CVBaseElement() {}
    var operationsMap = {
        1: "source-in",
        2: "source-out",
        3: "source-in",
        4: "source-out"
    };
    CVBaseElement.prototype = {
        createElements: function createElements11() {},
        initRendererElement: function initRendererElement11() {},
        createContainerElements: function createContainerElements11() {
            // If the layer is masked we will use two buffers to store each different states of the drawing
            // This solution is not ideal for several reason. But unfortunately, because of the recursive
            // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
            // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
            // It might be challenging because the layer most likely is transformed in some way
            if (this.data.tt >= 1) {
                this.buffers = [];
                var canvasContext11 = this.globalData.canvasContext;
                var bufferCanvas11 = assetLoader.createCanvas(canvasContext11.canvas.width, canvasContext11.canvas.height);
                this.buffers.push(bufferCanvas11);
                var bufferCanvas211 = assetLoader.createCanvas(canvasContext11.canvas.width, canvasContext11.canvas.height);
                this.buffers.push(bufferCanvas211);
                if (this.data.tt >= 3 && !document._isProxy) assetLoader.loadLumaCanvas();
            }
            this.canvasContext = this.globalData.canvasContext;
            this.transformCanvas = this.globalData.transformCanvas;
            this.renderableEffectsManager = new CVEffects(this);
            this.searchEffectTransforms();
        },
        createContent: function createContent11() {},
        setBlendMode: function setBlendMode11() {
            var globalData11 = this.globalData;
            if (globalData11.blendMode !== this.data.bm) {
                globalData11.blendMode = this.data.bm;
                var blendModeValue11 = getBlendMode(this.data.bm);
                globalData11.canvasContext.globalCompositeOperation = blendModeValue11;
            }
        },
        createRenderableComponents: function createRenderableComponents11() {
            this.maskManager = new CVMaskElement(this.data, this);
            this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
        },
        hideElement: function hideElement11() {
            if (!this.hidden && (!this.isInRange || this.isTransparent)) this.hidden = true;
        },
        showElement: function showElement11() {
            if (this.isInRange && !this.isTransparent) {
                this.hidden = false;
                this._isFirstFrame = true;
                this.maskManager._isFirstFrame = true;
            }
        },
        clearCanvas: function clearCanvas11(canvasContext11) {
            canvasContext11.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
        },
        prepareLayer: function prepareLayer11() {
            if (this.data.tt >= 1) {
                var buffer11 = this.buffers[0];
                var bufferCtx11 = buffer11.getContext("2d");
                this.clearCanvas(bufferCtx11); // on the first buffer we store the current state of the global drawing
                bufferCtx11.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
                // TODO: Check if there is a way to clear the canvas without resetting the transform
                this.currentTransform = this.canvasContext.getTransform();
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform);
            }
        },
        exitLayer: function exitLayer11() {
            if (this.data.tt >= 1) {
                var buffer11 = this.buffers[1]; // On the second buffer we store the current state of the global drawing
                // that only contains the content of this layer
                // (if it is a composition, it also includes the nested layers)
                var bufferCtx11 = buffer11.getContext("2d");
                this.clearCanvas(bufferCtx11);
                bufferCtx11.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
                this.clearCanvas(this.canvasContext);
                this.canvasContext.setTransform(this.currentTransform); // We draw the mask
                var mask11 = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
                mask11.renderFrame(true); // We draw the second buffer (that contains the content of this layer)
                this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
                // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error
                if (this.data.tt >= 3 && !document._isProxy) {
                    // We copy the painted mask to a buffer that has a color matrix filter applied to it
                    // that applies the rgb values to the alpha channel
                    var lumaBuffer11 = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                    var lumaBufferCtx11 = lumaBuffer11.getContext("2d");
                    lumaBufferCtx11.drawImage(this.canvasContext.canvas, 0, 0);
                    this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it
                    this.canvasContext.drawImage(lumaBuffer11, 0, 0);
                }
                this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
                this.canvasContext.drawImage(buffer11, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
                // We use destination-over to draw the global drawing below the current layer
                this.canvasContext.globalCompositeOperation = "destination-over";
                this.canvasContext.drawImage(this.buffers[0], 0, 0);
                this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation
                this.canvasContext.globalCompositeOperation = "source-over";
            }
        },
        renderFrame: function renderFrame11(forceRender11) {
            if (this.hidden || this.data.hd) return;
            if (this.data.td === 1 && !forceRender11) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderLocalTransform();
            this.setBlendMode();
            var forceRealStack11 = this.data.ty === 0;
            this.prepareLayer();
            this.globalData.renderer.save(forceRealStack11);
            this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
            this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
            this.renderInnerContent();
            this.globalData.renderer.restore(forceRealStack11);
            this.exitLayer();
            if (this.maskManager.hasMasks) this.globalData.renderer.restore(true);
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy11() {
            this.canvasContext = null;
            this.data = null;
            this.globalData = null;
            this.maskManager.destroy();
        },
        mHelper: new Matrix()
    };
    CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
    CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(element11, data11, styles11, transformsManager11) {
        this.styledShapes = [];
        this.tr = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var ty11 = 4;
        if (data11.ty === "rc") ty11 = 5;
        else if (data11.ty === "el") ty11 = 6;
        else if (data11.ty === "sr") ty11 = 7;
        this.sh = ShapePropertyFactory.getShapeProp(element11, data11, ty11, element11);
        var i31;
        var len11 = styles11.length;
        var styledShape11;
        for(i31 = 0; i31 < len11; i31 += 1)if (!styles11[i31].closed) {
            styledShape11 = {
                transforms: transformsManager11.addTransformSequence(styles11[i31].transforms),
                trNodes: []
            };
            this.styledShapes.push(styledShape11);
            styles11[i31].elements.push(styledShape11);
        }
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(data11, globalData11, comp11) {
        this.shapes = [];
        this.shapesData = data11.shapes;
        this.stylesList = [];
        this.itemsData = [];
        this.prevViewData = [];
        this.shapeModifiers = [];
        this.processedElements = [];
        this.transformsManager = new ShapeTransformManager();
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        IShapeElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVShapeElement);
    CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
    CVShapeElement.prototype.transformHelper = {
        opacity: 1,
        _opMdf: false
    };
    CVShapeElement.prototype.dashResetter = [];
    CVShapeElement.prototype.createContent = function() {
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    };
    CVShapeElement.prototype.createStyleElement = function(data11, transforms11) {
        var styleElem11 = {
            data: data11,
            type: data11.ty,
            preTransforms: this.transformsManager.addTransformSequence(transforms11),
            transforms: [],
            elements: [],
            closed: data11.hd === true
        };
        var elementData11 = {};
        if (data11.ty === "fl" || data11.ty === "st") {
            elementData11.c = PropertyFactory.getProp(this, data11.c, 1, 255, this);
            if (!elementData11.c.k) styleElem11.co = "rgb(" + bmFloor(elementData11.c.v[0]) + "," + bmFloor(elementData11.c.v[1]) + "," + bmFloor(elementData11.c.v[2]) + ")";
        } else if (data11.ty === "gf" || data11.ty === "gs") {
            elementData11.s = PropertyFactory.getProp(this, data11.s, 1, null, this);
            elementData11.e = PropertyFactory.getProp(this, data11.e, 1, null, this);
            elementData11.h = PropertyFactory.getProp(this, data11.h || {
                k: 0
            }, 0, 0.01, this);
            elementData11.a = PropertyFactory.getProp(this, data11.a || {
                k: 0
            }, 0, degToRads, this);
            elementData11.g = new GradientProperty(this, data11.g, this);
        }
        elementData11.o = PropertyFactory.getProp(this, data11.o, 0, 0.01, this);
        if (data11.ty === "st" || data11.ty === "gs") {
            styleElem11.lc = lineCapEnum[data11.lc || 2];
            styleElem11.lj = lineJoinEnum[data11.lj || 2];
            if (data11.lj == 1) // eslint-disable-line eqeqeq
            styleElem11.ml = data11.ml;
            elementData11.w = PropertyFactory.getProp(this, data11.w, 0, null, this);
            if (!elementData11.w.k) styleElem11.wi = elementData11.w.v;
            if (data11.d) {
                var d31 = new DashProperty(this, data11.d, "canvas", this);
                elementData11.d = d31;
                if (!elementData11.d.k) {
                    styleElem11.da = elementData11.d.dashArray;
                    styleElem11["do"] = elementData11.d.dashoffset[0];
                }
            }
        } else styleElem11.r = data11.r === 2 ? "evenodd" : "nonzero";
        this.stylesList.push(styleElem11);
        elementData11.style = styleElem11;
        return elementData11;
    };
    CVShapeElement.prototype.createGroupElement = function() {
        var elementData11 = {
            it: [],
            prevViewData: []
        };
        return elementData11;
    };
    CVShapeElement.prototype.createTransformElement = function(data11) {
        var elementData11 = {
            transform: {
                opacity: 1,
                _opMdf: false,
                key: this.transformsManager.getNewKey(),
                op: PropertyFactory.getProp(this, data11.o, 0, 0.01, this),
                mProps: TransformPropertyFactory.getTransformProperty(this, data11, this)
            }
        };
        return elementData11;
    };
    CVShapeElement.prototype.createShapeElement = function(data11) {
        var elementData11 = new CVShapeData(this, data11, this.stylesList, this.transformsManager);
        this.shapes.push(elementData11);
        this.addShapeToModifiers(elementData11);
        return elementData11;
    };
    CVShapeElement.prototype.reloadShapes = function() {
        this._isFirstFrame = true;
        var i31;
        var len11 = this.itemsData.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.prevViewData[i31] = this.itemsData[i31];
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
        len11 = this.dynamicProperties.length;
        for(i31 = 0; i31 < len11; i31 += 1)this.dynamicProperties[i31].getValue();
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
    };
    CVShapeElement.prototype.addTransformToStyleList = function(transform11) {
        var i31;
        var len11 = this.stylesList.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (!this.stylesList[i31].closed) this.stylesList[i31].transforms.push(transform11);
    };
    CVShapeElement.prototype.removeTransformFromStyleList = function() {
        var i31;
        var len11 = this.stylesList.length;
        for(i31 = 0; i31 < len11; i31 += 1)if (!this.stylesList[i31].closed) this.stylesList[i31].transforms.pop();
    };
    CVShapeElement.prototype.closeStyles = function(styles11) {
        var i31;
        var len11 = styles11.length;
        for(i31 = 0; i31 < len11; i31 += 1)styles11[i31].closed = true;
    };
    CVShapeElement.prototype.searchShapes = function(arr31, itemsData11, prevViewData11, shouldRender11, transforms11) {
        var i31;
        var len11 = arr31.length - 1;
        var j31;
        var jLen11;
        var ownStyles11 = [];
        var ownModifiers11 = [];
        var processedPos11;
        var modifier11;
        var currentTransform11;
        var ownTransforms11 = [].concat(transforms11);
        for(i31 = len11; i31 >= 0; i31 -= 1){
            processedPos11 = this.searchProcessedElement(arr31[i31]);
            if (!processedPos11) arr31[i31]._shouldRender = shouldRender11;
            else itemsData11[i31] = prevViewData11[processedPos11 - 1];
            if (arr31[i31].ty === "fl" || arr31[i31].ty === "st" || arr31[i31].ty === "gf" || arr31[i31].ty === "gs") {
                if (!processedPos11) itemsData11[i31] = this.createStyleElement(arr31[i31], ownTransforms11);
                else itemsData11[i31].style.closed = false;
                ownStyles11.push(itemsData11[i31].style);
            } else if (arr31[i31].ty === "gr") {
                if (!processedPos11) itemsData11[i31] = this.createGroupElement(arr31[i31]);
                else {
                    jLen11 = itemsData11[i31].it.length;
                    for(j31 = 0; j31 < jLen11; j31 += 1)itemsData11[i31].prevViewData[j31] = itemsData11[i31].it[j31];
                }
                this.searchShapes(arr31[i31].it, itemsData11[i31].it, itemsData11[i31].prevViewData, shouldRender11, ownTransforms11);
            } else if (arr31[i31].ty === "tr") {
                if (!processedPos11) {
                    currentTransform11 = this.createTransformElement(arr31[i31]);
                    itemsData11[i31] = currentTransform11;
                }
                ownTransforms11.push(itemsData11[i31]);
                this.addTransformToStyleList(itemsData11[i31]);
            } else if (arr31[i31].ty === "sh" || arr31[i31].ty === "rc" || arr31[i31].ty === "el" || arr31[i31].ty === "sr") {
                if (!processedPos11) itemsData11[i31] = this.createShapeElement(arr31[i31]);
            } else if (arr31[i31].ty === "tm" || arr31[i31].ty === "rd" || arr31[i31].ty === "pb" || arr31[i31].ty === "zz" || arr31[i31].ty === "op") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    modifier11.init(this, arr31[i31]);
                    itemsData11[i31] = modifier11;
                    this.shapeModifiers.push(modifier11);
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = false;
                }
                ownModifiers11.push(modifier11);
            } else if (arr31[i31].ty === "rp") {
                if (!processedPos11) {
                    modifier11 = ShapeModifiers.getModifier(arr31[i31].ty);
                    itemsData11[i31] = modifier11;
                    modifier11.init(this, arr31, i31, itemsData11);
                    this.shapeModifiers.push(modifier11);
                    shouldRender11 = false;
                } else {
                    modifier11 = itemsData11[i31];
                    modifier11.closed = true;
                }
                ownModifiers11.push(modifier11);
            }
            this.addProcessedElement(arr31[i31], i31 + 1);
        }
        this.removeTransformFromStyleList();
        this.closeStyles(ownStyles11);
        len11 = ownModifiers11.length;
        for(i31 = 0; i31 < len11; i31 += 1)ownModifiers11[i31].closed = true;
    };
    CVShapeElement.prototype.renderInnerContent = function() {
        this.transformHelper.opacity = 1;
        this.transformHelper._opMdf = false;
        this.renderModifiers();
        this.transformsManager.processSequences(this._isFirstFrame);
        this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
    };
    CVShapeElement.prototype.renderShapeTransform = function(parentTransform11, groupTransform11) {
        if (parentTransform11._opMdf || groupTransform11.op._mdf || this._isFirstFrame) {
            groupTransform11.opacity = parentTransform11.opacity;
            groupTransform11.opacity *= groupTransform11.op.v;
            groupTransform11._opMdf = true;
        }
    };
    CVShapeElement.prototype.drawLayer = function() {
        var i31;
        var len11 = this.stylesList.length;
        var j31;
        var jLen11;
        var k31;
        var kLen11;
        var elems11;
        var nodes11;
        var renderer11 = this.globalData.renderer;
        var ctx11 = this.globalData.canvasContext;
        var type11;
        var currentStyle11;
        for(i31 = 0; i31 < len11; i31 += 1){
            currentStyle11 = this.stylesList[i31];
            type11 = currentStyle11.type; // Skipping style when
            // Stroke width equals 0
            // style should not be rendered (extra unused repeaters)
            // current opacity equals 0
            // global opacity equals 0
            if (!((type11 === "st" || type11 === "gs") && currentStyle11.wi === 0 || !currentStyle11.data._shouldRender || currentStyle11.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
                renderer11.save();
                elems11 = currentStyle11.elements;
                if (type11 === "st" || type11 === "gs") {
                    ctx11.strokeStyle = type11 === "st" ? currentStyle11.co : currentStyle11.grd;
                    ctx11.lineWidth = currentStyle11.wi;
                    ctx11.lineCap = currentStyle11.lc;
                    ctx11.lineJoin = currentStyle11.lj;
                    ctx11.miterLimit = currentStyle11.ml || 0;
                } else ctx11.fillStyle = type11 === "fl" ? currentStyle11.co : currentStyle11.grd;
                renderer11.ctxOpacity(currentStyle11.coOp);
                if (type11 !== "st" && type11 !== "gs") ctx11.beginPath();
                renderer11.ctxTransform(currentStyle11.preTransforms.finalTransform.props);
                jLen11 = elems11.length;
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    if (type11 === "st" || type11 === "gs") {
                        ctx11.beginPath();
                        if (currentStyle11.da) {
                            ctx11.setLineDash(currentStyle11.da);
                            ctx11.lineDashOffset = currentStyle11["do"];
                        }
                    }
                    nodes11 = elems11[j31].trNodes;
                    kLen11 = nodes11.length;
                    for(k31 = 0; k31 < kLen11; k31 += 1){
                        if (nodes11[k31].t === "m") ctx11.moveTo(nodes11[k31].p[0], nodes11[k31].p[1]);
                        else if (nodes11[k31].t === "c") ctx11.bezierCurveTo(nodes11[k31].pts[0], nodes11[k31].pts[1], nodes11[k31].pts[2], nodes11[k31].pts[3], nodes11[k31].pts[4], nodes11[k31].pts[5]);
                        else ctx11.closePath();
                    }
                    if (type11 === "st" || type11 === "gs") {
                        ctx11.stroke();
                        if (currentStyle11.da) ctx11.setLineDash(this.dashResetter);
                    }
                }
                if (type11 !== "st" && type11 !== "gs") ctx11.fill(currentStyle11.r);
                renderer11.restore();
            }
        }
    };
    CVShapeElement.prototype.renderShape = function(parentTransform11, items11, data11, isMain11) {
        var i31;
        var len11 = items11.length - 1;
        var groupTransform11;
        groupTransform11 = parentTransform11;
        for(i31 = len11; i31 >= 0; i31 -= 1){
            if (items11[i31].ty === "tr") {
                groupTransform11 = data11[i31].transform;
                this.renderShapeTransform(parentTransform11, groupTransform11);
            } else if (items11[i31].ty === "sh" || items11[i31].ty === "el" || items11[i31].ty === "rc" || items11[i31].ty === "sr") this.renderPath(items11[i31], data11[i31]);
            else if (items11[i31].ty === "fl") this.renderFill(items11[i31], data11[i31], groupTransform11);
            else if (items11[i31].ty === "st") this.renderStroke(items11[i31], data11[i31], groupTransform11);
            else if (items11[i31].ty === "gf" || items11[i31].ty === "gs") this.renderGradientFill(items11[i31], data11[i31], groupTransform11);
            else if (items11[i31].ty === "gr") this.renderShape(groupTransform11, items11[i31].it, data11[i31].it);
            else items11[i31].ty;
        }
        if (isMain11) this.drawLayer();
    };
    CVShapeElement.prototype.renderStyledShape = function(styledShape11, shape31) {
        if (this._isFirstFrame || shape31._mdf || styledShape11.transforms._mdf) {
            var shapeNodes11 = styledShape11.trNodes;
            var paths11 = shape31.paths;
            var i31;
            var len11;
            var j31;
            var jLen11 = paths11._length;
            shapeNodes11.length = 0;
            var groupTransformMat11 = styledShape11.transforms.finalTransform;
            for(j31 = 0; j31 < jLen11; j31 += 1){
                var pathNodes11 = paths11.shapes[j31];
                if (pathNodes11 && pathNodes11.v) {
                    len11 = pathNodes11._length;
                    for(i31 = 1; i31 < len11; i31 += 1){
                        if (i31 === 1) shapeNodes11.push({
                            t: "m",
                            p: groupTransformMat11.applyToPointArray(pathNodes11.v[0][0], pathNodes11.v[0][1], 0)
                        });
                        shapeNodes11.push({
                            t: "c",
                            pts: groupTransformMat11.applyToTriplePoints(pathNodes11.o[i31 - 1], pathNodes11.i[i31], pathNodes11.v[i31])
                        });
                    }
                    if (len11 === 1) shapeNodes11.push({
                        t: "m",
                        p: groupTransformMat11.applyToPointArray(pathNodes11.v[0][0], pathNodes11.v[0][1], 0)
                    });
                    if (pathNodes11.c && len11) {
                        shapeNodes11.push({
                            t: "c",
                            pts: groupTransformMat11.applyToTriplePoints(pathNodes11.o[i31 - 1], pathNodes11.i[0], pathNodes11.v[0])
                        });
                        shapeNodes11.push({
                            t: "z"
                        });
                    }
                }
            }
            styledShape11.trNodes = shapeNodes11;
        }
    };
    CVShapeElement.prototype.renderPath = function(pathData11, itemData11) {
        if (pathData11.hd !== true && pathData11._shouldRender) {
            var i31;
            var len11 = itemData11.styledShapes.length;
            for(i31 = 0; i31 < len11; i31 += 1)this.renderStyledShape(itemData11.styledShapes[i31], itemData11.sh);
        }
    };
    CVShapeElement.prototype.renderFill = function(styleData11, itemData11, groupTransform11) {
        var styleElem11 = itemData11.style;
        if (itemData11.c._mdf || this._isFirstFrame) styleElem11.co = "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")";
        if (itemData11.o._mdf || groupTransform11._opMdf || this._isFirstFrame) styleElem11.coOp = itemData11.o.v * groupTransform11.opacity;
    };
    CVShapeElement.prototype.renderGradientFill = function(styleData11, itemData11, groupTransform11) {
        var styleElem11 = itemData11.style;
        var grd11;
        if (!styleElem11.grd || itemData11.g._mdf || itemData11.s._mdf || itemData11.e._mdf || styleData11.t !== 1 && (itemData11.h._mdf || itemData11.a._mdf)) {
            var ctx11 = this.globalData.canvasContext;
            var pt111 = itemData11.s.v;
            var pt211 = itemData11.e.v;
            if (styleData11.t === 1) grd11 = ctx11.createLinearGradient(pt111[0], pt111[1], pt211[0], pt211[1]);
            else {
                var rad11 = Math.sqrt(Math.pow(pt111[0] - pt211[0], 2) + Math.pow(pt111[1] - pt211[1], 2));
                var ang11 = Math.atan2(pt211[1] - pt111[1], pt211[0] - pt111[0]);
                var percent11 = itemData11.h.v;
                if (percent11 >= 1) percent11 = 0.99;
                else if (percent11 <= -1) percent11 = -0.99;
                var dist41 = rad11 * percent11;
                var x41 = Math.cos(ang11 + itemData11.a.v) * dist41 + pt111[0];
                var y41 = Math.sin(ang11 + itemData11.a.v) * dist41 + pt111[1];
                grd11 = ctx11.createRadialGradient(x41, y41, 0, pt111[0], pt111[1], rad11);
            }
            var i31;
            var len11 = styleData11.g.p;
            var cValues11 = itemData11.g.c;
            var opacity11 = 1;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (itemData11.g._hasOpacity && itemData11.g._collapsable) opacity11 = itemData11.g.o[i31 * 2 + 1];
                grd11.addColorStop(cValues11[i31 * 4] / 100, "rgba(" + cValues11[i31 * 4 + 1] + "," + cValues11[i31 * 4 + 2] + "," + cValues11[i31 * 4 + 3] + "," + opacity11 + ")");
            }
            styleElem11.grd = grd11;
        }
        styleElem11.coOp = itemData11.o.v * groupTransform11.opacity;
    };
    CVShapeElement.prototype.renderStroke = function(styleData11, itemData11, groupTransform11) {
        var styleElem11 = itemData11.style;
        var d31 = itemData11.d;
        if (d31 && (d31._mdf || this._isFirstFrame)) {
            styleElem11.da = d31.dashArray;
            styleElem11["do"] = d31.dashoffset[0];
        }
        if (itemData11.c._mdf || this._isFirstFrame) styleElem11.co = "rgb(" + bmFloor(itemData11.c.v[0]) + "," + bmFloor(itemData11.c.v[1]) + "," + bmFloor(itemData11.c.v[2]) + ")";
        if (itemData11.o._mdf || groupTransform11._opMdf || this._isFirstFrame) styleElem11.coOp = itemData11.o.v * groupTransform11.opacity;
        if (itemData11.w._mdf || this._isFirstFrame) styleElem11.wi = itemData11.w.v;
    };
    CVShapeElement.prototype.destroy = function() {
        this.shapesData = null;
        this.globalData = null;
        this.canvasContext = null;
        this.stylesList.length = 0;
        this.itemsData.length = 0;
    };
    function CVTextElement(data11, globalData11, comp11) {
        this.textSpans = [];
        this.yOffset = 0;
        this.fillColorAnim = false;
        this.strokeColorAnim = false;
        this.strokeWidthAnim = false;
        this.stroke = false;
        this.fill = false;
        this.justifyOffset = 0;
        this.currentRender = null;
        this.renderType = "canvas";
        this.values = {
            fill: "rgba(0,0,0,0)",
            stroke: "rgba(0,0,0,0)",
            sWidth: 0,
            fValue: ""
        };
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement,
        ITextElement
    ], CVTextElement);
    CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d");
    CVTextElement.prototype.buildNewText = function() {
        var documentData11 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData11.l ? documentData11.l.length : 0);
        var hasFill11 = false;
        if (documentData11.fc) {
            hasFill11 = true;
            this.values.fill = this.buildColor(documentData11.fc);
        } else this.values.fill = "rgba(0,0,0,0)";
        this.fill = hasFill11;
        var hasStroke11 = false;
        if (documentData11.sc) {
            hasStroke11 = true;
            this.values.stroke = this.buildColor(documentData11.sc);
            this.values.sWidth = documentData11.sw;
        }
        var fontData11 = this.globalData.fontManager.getFontByName(documentData11.f);
        var i31;
        var len11;
        var letters11 = documentData11.l;
        var matrixHelper11 = this.mHelper;
        this.stroke = hasStroke11;
        this.values.fValue = documentData11.finalSize + "px " + this.globalData.fontManager.getFontByName(documentData11.f).fFamily;
        len11 = documentData11.finalText.length; // this.tHelper.font = this.values.fValue;
        var charData11;
        var shapeData11;
        var k31;
        var kLen11;
        var shapes11;
        var j31;
        var jLen11;
        var pathNodes11;
        var commands11;
        var pathArr11;
        var singleShape11 = this.data.singleShape;
        var trackingOffset11 = documentData11.tr * 0.001 * documentData11.finalSize;
        var xPos11 = 0;
        var yPos11 = 0;
        var firstLine11 = true;
        var cnt11 = 0;
        for(i31 = 0; i31 < len11; i31 += 1){
            charData11 = this.globalData.fontManager.getCharData(documentData11.finalText[i31], fontData11.fStyle, this.globalData.fontManager.getFontByName(documentData11.f).fFamily);
            shapeData11 = charData11 && charData11.data || {};
            matrixHelper11.reset();
            if (singleShape11 && letters11[i31].n) {
                xPos11 = -trackingOffset11;
                yPos11 += documentData11.yOffset;
                yPos11 += firstLine11 ? 1 : 0;
                firstLine11 = false;
            }
            shapes11 = shapeData11.shapes ? shapeData11.shapes[0].it : [];
            jLen11 = shapes11.length;
            matrixHelper11.scale(documentData11.finalSize / 100, documentData11.finalSize / 100);
            if (singleShape11) this.applyTextPropertiesToMatrix(documentData11, matrixHelper11, letters11[i31].line, xPos11, yPos11);
            commands11 = createSizedArray(jLen11 - 1);
            var commandsCounter11 = 0;
            for(j31 = 0; j31 < jLen11; j31 += 1)if (shapes11[j31].ty === "sh") {
                kLen11 = shapes11[j31].ks.k.i.length;
                pathNodes11 = shapes11[j31].ks.k;
                pathArr11 = [];
                for(k31 = 1; k31 < kLen11; k31 += 1){
                    if (k31 === 1) pathArr11.push(matrixHelper11.applyToX(pathNodes11.v[0][0], pathNodes11.v[0][1], 0), matrixHelper11.applyToY(pathNodes11.v[0][0], pathNodes11.v[0][1], 0));
                    pathArr11.push(matrixHelper11.applyToX(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToY(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToX(pathNodes11.i[k31][0], pathNodes11.i[k31][1], 0), matrixHelper11.applyToY(pathNodes11.i[k31][0], pathNodes11.i[k31][1], 0), matrixHelper11.applyToX(pathNodes11.v[k31][0], pathNodes11.v[k31][1], 0), matrixHelper11.applyToY(pathNodes11.v[k31][0], pathNodes11.v[k31][1], 0));
                }
                pathArr11.push(matrixHelper11.applyToX(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToY(pathNodes11.o[k31 - 1][0], pathNodes11.o[k31 - 1][1], 0), matrixHelper11.applyToX(pathNodes11.i[0][0], pathNodes11.i[0][1], 0), matrixHelper11.applyToY(pathNodes11.i[0][0], pathNodes11.i[0][1], 0), matrixHelper11.applyToX(pathNodes11.v[0][0], pathNodes11.v[0][1], 0), matrixHelper11.applyToY(pathNodes11.v[0][0], pathNodes11.v[0][1], 0));
                commands11[commandsCounter11] = pathArr11;
                commandsCounter11 += 1;
            }
            if (singleShape11) {
                xPos11 += letters11[i31].l;
                xPos11 += trackingOffset11;
            }
            if (this.textSpans[cnt11]) this.textSpans[cnt11].elem = commands11;
            else this.textSpans[cnt11] = {
                elem: commands11
            };
            cnt11 += 1;
        }
    };
    CVTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var ctx11 = this.canvasContext;
        ctx11.font = this.values.fValue;
        ctx11.lineCap = "butt";
        ctx11.lineJoin = "miter";
        ctx11.miterLimit = 4;
        if (!this.data.singleShape) this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        var i31;
        var len11;
        var j31;
        var jLen11;
        var k31;
        var kLen11;
        var renderedLetters11 = this.textAnimator.renderedLetters;
        var letters11 = this.textProperty.currentData.l;
        len11 = letters11.length;
        var renderedLetter11;
        var lastFill11 = null;
        var lastStroke11 = null;
        var lastStrokeW11 = null;
        var commands11;
        var pathArr11;
        for(i31 = 0; i31 < len11; i31 += 1)if (!letters11[i31].n) {
            renderedLetter11 = renderedLetters11[i31];
            if (renderedLetter11) {
                this.globalData.renderer.save();
                this.globalData.renderer.ctxTransform(renderedLetter11.p);
                this.globalData.renderer.ctxOpacity(renderedLetter11.o);
            }
            if (this.fill) {
                if (renderedLetter11 && renderedLetter11.fc) {
                    if (lastFill11 !== renderedLetter11.fc) {
                        lastFill11 = renderedLetter11.fc;
                        ctx11.fillStyle = renderedLetter11.fc;
                    }
                } else if (lastFill11 !== this.values.fill) {
                    lastFill11 = this.values.fill;
                    ctx11.fillStyle = this.values.fill;
                }
                commands11 = this.textSpans[i31].elem;
                jLen11 = commands11.length;
                this.globalData.canvasContext.beginPath();
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    pathArr11 = commands11[j31];
                    kLen11 = pathArr11.length;
                    this.globalData.canvasContext.moveTo(pathArr11[0], pathArr11[1]);
                    for(k31 = 2; k31 < kLen11; k31 += 6)this.globalData.canvasContext.bezierCurveTo(pathArr11[k31], pathArr11[k31 + 1], pathArr11[k31 + 2], pathArr11[k31 + 3], pathArr11[k31 + 4], pathArr11[k31 + 5]);
                }
                this.globalData.canvasContext.closePath();
                this.globalData.canvasContext.fill(); /// ctx.fillText(this.textSpans[i].val,0,0);
            }
            if (this.stroke) {
                if (renderedLetter11 && renderedLetter11.sw) {
                    if (lastStrokeW11 !== renderedLetter11.sw) {
                        lastStrokeW11 = renderedLetter11.sw;
                        ctx11.lineWidth = renderedLetter11.sw;
                    }
                } else if (lastStrokeW11 !== this.values.sWidth) {
                    lastStrokeW11 = this.values.sWidth;
                    ctx11.lineWidth = this.values.sWidth;
                }
                if (renderedLetter11 && renderedLetter11.sc) {
                    if (lastStroke11 !== renderedLetter11.sc) {
                        lastStroke11 = renderedLetter11.sc;
                        ctx11.strokeStyle = renderedLetter11.sc;
                    }
                } else if (lastStroke11 !== this.values.stroke) {
                    lastStroke11 = this.values.stroke;
                    ctx11.strokeStyle = this.values.stroke;
                }
                commands11 = this.textSpans[i31].elem;
                jLen11 = commands11.length;
                this.globalData.canvasContext.beginPath();
                for(j31 = 0; j31 < jLen11; j31 += 1){
                    pathArr11 = commands11[j31];
                    kLen11 = pathArr11.length;
                    this.globalData.canvasContext.moveTo(pathArr11[0], pathArr11[1]);
                    for(k31 = 2; k31 < kLen11; k31 += 6)this.globalData.canvasContext.bezierCurveTo(pathArr11[k31], pathArr11[k31 + 1], pathArr11[k31 + 2], pathArr11[k31 + 3], pathArr11[k31 + 4], pathArr11[k31 + 5]);
                }
                this.globalData.canvasContext.closePath();
                this.globalData.canvasContext.stroke(); /// ctx.strokeText(letters[i].val,0,0);
            }
            if (renderedLetter11) this.globalData.renderer.restore();
        }
    };
    function CVImageElement(data11, globalData11, comp11) {
        this.assetData = globalData11.getAssetData(data11.refId);
        this.img = globalData11.imageLoader.getAsset(this.assetData);
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVImageElement);
    CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVImageElement.prototype.createContent = function() {
        if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
            var canvas11 = createTag("canvas");
            canvas11.width = this.assetData.w;
            canvas11.height = this.assetData.h;
            var ctx11 = canvas11.getContext("2d");
            var imgW11 = this.img.width;
            var imgH11 = this.img.height;
            var imgRel11 = imgW11 / imgH11;
            var canvasRel11 = this.assetData.w / this.assetData.h;
            var widthCrop11;
            var heightCrop11;
            var par11 = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
            if (imgRel11 > canvasRel11 && par11 === "xMidYMid slice" || imgRel11 < canvasRel11 && par11 !== "xMidYMid slice") {
                heightCrop11 = imgH11;
                widthCrop11 = heightCrop11 * canvasRel11;
            } else {
                widthCrop11 = imgW11;
                heightCrop11 = widthCrop11 / canvasRel11;
            }
            ctx11.drawImage(this.img, (imgW11 - widthCrop11) / 2, (imgH11 - heightCrop11) / 2, widthCrop11, heightCrop11, 0, 0, this.assetData.w, this.assetData.h);
            this.img = canvas11;
        }
    };
    CVImageElement.prototype.renderInnerContent = function() {
        this.canvasContext.drawImage(this.img, 0, 0);
    };
    CVImageElement.prototype.destroy = function() {
        this.img = null;
    };
    function CVSolidElement(data11, globalData11, comp11) {
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        CVBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], CVSolidElement);
    CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
    CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;
    CVSolidElement.prototype.renderInnerContent = function() {
        var ctx11 = this.canvasContext;
        ctx11.fillStyle = this.data.sc;
        ctx11.fillRect(0, 0, this.data.sw, this.data.sh); //
    };
    function CanvasRendererBase(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.renderConfig = {
            clearCanvas: config11 && config11.clearCanvas !== undefined ? config11.clearCanvas : true,
            context: config11 && config11.context || null,
            progressiveLoad: config11 && config11.progressiveLoad || false,
            preserveAspectRatio: config11 && config11.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config11 && config11.contentVisibility || "visible",
            className: config11 && config11.className || "",
            id: config11 && config11.id || ""
        };
        this.renderConfig.dpr = config11 && config11.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config11 && config11.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = "canvas";
    }
    extendPrototype([
        BaseRenderer
    ], CanvasRendererBase);
    CanvasRendererBase.prototype.createShape = function(data11) {
        return new CVShapeElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createText = function(data11) {
        return new CVTextElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createImage = function(data11) {
        return new CVImageElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createSolid = function(data11) {
        return new CVSolidElement(data11, this.globalData, this);
    };
    CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    CanvasRendererBase.prototype.ctxTransform = function(props11) {
        if (props11[0] === 1 && props11[1] === 0 && props11[4] === 0 && props11[5] === 1 && props11[12] === 0 && props11[13] === 0) return;
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.transform(props11[0], props11[1], props11[4], props11[5], props11[12], props11[13]);
            return;
        } // Resetting the canvas transform matrix to the new transform
        this.transformMat.cloneFromProps(props11); // Taking the last transform value from the stored stack of transforms
        var currentTransform11 = this.contextData.getTransform(); // Applying the last transform value after the new transform to respect the order of transformations
        this.transformMat.multiply(currentTransform11); // Storing the new transformed value in the stored transform
        currentTransform11.cloneFromProps(this.transformMat.props);
        var trProps11 = currentTransform11.props; // Applying the new transform to the canvas
        this.canvasContext.setTransform(trProps11[0], trProps11[1], trProps11[4], trProps11[5], trProps11[12], trProps11[13]);
    };
    CanvasRendererBase.prototype.ctxOpacity = function(op11) {
        /* if(op === 1){
          return;
      } */ var currentOpacity11 = this.contextData.getOpacity();
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.globalAlpha *= op11 < 0 ? 0 : op11;
            this.globalData.currentGlobalAlpha = currentOpacity11;
            return;
        }
        currentOpacity11 *= op11 < 0 ? 0 : op11;
        this.contextData.setOpacity(currentOpacity11);
        if (this.globalData.currentGlobalAlpha !== currentOpacity11) {
            this.canvasContext.globalAlpha = currentOpacity11;
            this.globalData.currentGlobalAlpha = currentOpacity11;
        }
    };
    CanvasRendererBase.prototype.reset = function() {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        this.contextData.reset();
    };
    CanvasRendererBase.prototype.save = function(actionFlag11) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.save();
            return;
        }
        if (actionFlag11) this.canvasContext.save();
        this.contextData.push();
    };
    CanvasRendererBase.prototype.restore = function(actionFlag11) {
        if (!this.renderConfig.clearCanvas) {
            this.canvasContext.restore();
            return;
        }
        if (actionFlag11) {
            this.canvasContext.restore();
            this.globalData.blendMode = "source-over";
        }
        var popped11 = this.contextData.pop();
        var transform11 = popped11.transform;
        var opacity11 = popped11.opacity;
        this.canvasContext.setTransform(transform11[0], transform11[1], transform11[4], transform11[5], transform11[12], transform11[13]);
        if (this.globalData.currentGlobalAlpha !== opacity11) {
            this.canvasContext.globalAlpha = opacity11;
            this.globalData.currentGlobalAlpha = opacity11;
        }
    };
    CanvasRendererBase.prototype.configAnimation = function(animData11) {
        if (this.animationItem.wrapper) {
            this.animationItem.container = createTag("canvas");
            var containerStyle11 = this.animationItem.container.style;
            containerStyle11.width = "100%";
            containerStyle11.height = "100%";
            var origin11 = "0px 0px 0px";
            containerStyle11.transformOrigin = origin11;
            containerStyle11.mozTransformOrigin = origin11;
            containerStyle11.webkitTransformOrigin = origin11;
            containerStyle11["-webkit-transform"] = origin11;
            containerStyle11.contentVisibility = this.renderConfig.contentVisibility;
            this.animationItem.wrapper.appendChild(this.animationItem.container);
            this.canvasContext = this.animationItem.container.getContext("2d");
            if (this.renderConfig.className) this.animationItem.container.setAttribute("class", this.renderConfig.className);
            if (this.renderConfig.id) this.animationItem.container.setAttribute("id", this.renderConfig.id);
        } else this.canvasContext = this.renderConfig.context;
        this.data = animData11;
        this.layers = animData11.layers;
        this.transformCanvas = {
            w: animData11.w,
            h: animData11.h,
            sx: 0,
            sy: 0,
            tx: 0,
            ty: 0
        };
        this.setupGlobalData(animData11, document.body);
        this.globalData.canvasContext = this.canvasContext;
        this.globalData.renderer = this;
        this.globalData.isDashed = false;
        this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
        this.globalData.transformCanvas = this.transformCanvas;
        this.elements = createSizedArray(animData11.layers.length);
        this.updateContainerSize();
    };
    CanvasRendererBase.prototype.updateContainerSize = function(width11, height11) {
        this.reset();
        var elementWidth11;
        var elementHeight11;
        if (width11) {
            elementWidth11 = width11;
            elementHeight11 = height11;
            this.canvasContext.canvas.width = elementWidth11;
            this.canvasContext.canvas.height = elementHeight11;
        } else {
            if (this.animationItem.wrapper && this.animationItem.container) {
                elementWidth11 = this.animationItem.wrapper.offsetWidth;
                elementHeight11 = this.animationItem.wrapper.offsetHeight;
            } else {
                elementWidth11 = this.canvasContext.canvas.width;
                elementHeight11 = this.canvasContext.canvas.height;
            }
            this.canvasContext.canvas.width = elementWidth11 * this.renderConfig.dpr;
            this.canvasContext.canvas.height = elementHeight11 * this.renderConfig.dpr;
        }
        var elementRel11;
        var animationRel11;
        if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
            var par11 = this.renderConfig.preserveAspectRatio.split(" ");
            var fillType11 = par11[1] || "meet";
            var pos11 = par11[0] || "xMidYMid";
            var xPos11 = pos11.substr(0, 4);
            var yPos11 = pos11.substr(4);
            elementRel11 = elementWidth11 / elementHeight11;
            animationRel11 = this.transformCanvas.w / this.transformCanvas.h;
            if (animationRel11 > elementRel11 && fillType11 === "meet" || animationRel11 < elementRel11 && fillType11 === "slice") {
                this.transformCanvas.sx = elementWidth11 / (this.transformCanvas.w / this.renderConfig.dpr);
                this.transformCanvas.sy = elementWidth11 / (this.transformCanvas.w / this.renderConfig.dpr);
            } else {
                this.transformCanvas.sx = elementHeight11 / (this.transformCanvas.h / this.renderConfig.dpr);
                this.transformCanvas.sy = elementHeight11 / (this.transformCanvas.h / this.renderConfig.dpr);
            }
            if (xPos11 === "xMid" && (animationRel11 < elementRel11 && fillType11 === "meet" || animationRel11 > elementRel11 && fillType11 === "slice")) this.transformCanvas.tx = (elementWidth11 - this.transformCanvas.w * (elementHeight11 / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
            else if (xPos11 === "xMax" && (animationRel11 < elementRel11 && fillType11 === "meet" || animationRel11 > elementRel11 && fillType11 === "slice")) this.transformCanvas.tx = (elementWidth11 - this.transformCanvas.w * (elementHeight11 / this.transformCanvas.h)) * this.renderConfig.dpr;
            else this.transformCanvas.tx = 0;
            if (yPos11 === "YMid" && (animationRel11 > elementRel11 && fillType11 === "meet" || animationRel11 < elementRel11 && fillType11 === "slice")) this.transformCanvas.ty = (elementHeight11 - this.transformCanvas.h * (elementWidth11 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
            else if (yPos11 === "YMax" && (animationRel11 > elementRel11 && fillType11 === "meet" || animationRel11 < elementRel11 && fillType11 === "slice")) this.transformCanvas.ty = (elementHeight11 - this.transformCanvas.h * (elementWidth11 / this.transformCanvas.w)) * this.renderConfig.dpr;
            else this.transformCanvas.ty = 0;
        } else if (this.renderConfig.preserveAspectRatio === "none") {
            this.transformCanvas.sx = elementWidth11 / (this.transformCanvas.w / this.renderConfig.dpr);
            this.transformCanvas.sy = elementHeight11 / (this.transformCanvas.h / this.renderConfig.dpr);
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        } else {
            this.transformCanvas.sx = this.renderConfig.dpr;
            this.transformCanvas.sy = this.renderConfig.dpr;
            this.transformCanvas.tx = 0;
            this.transformCanvas.ty = 0;
        }
        this.transformCanvas.props = [
            this.transformCanvas.sx,
            0,
            0,
            0,
            0,
            this.transformCanvas.sy,
            0,
            0,
            0,
            0,
            1,
            0,
            this.transformCanvas.tx,
            this.transformCanvas.ty,
            0,
            1
        ];
        /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */ this.ctxTransform(this.transformCanvas.props);
        this.canvasContext.beginPath();
        this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
        this.canvasContext.closePath();
        this.canvasContext.clip();
        this.renderFrame(this.renderedFrame, true);
    };
    CanvasRendererBase.prototype.destroy = function() {
        if (this.renderConfig.clearCanvas && this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        var i31;
        var len11 = this.layers ? this.layers.length : 0;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.elements[i31] && this.elements[i31].destroy) this.elements[i31].destroy();
        this.elements.length = 0;
        this.globalData.canvasContext = null;
        this.animationItem.container = null;
        this.destroyed = true;
    };
    CanvasRendererBase.prototype.renderFrame = function(num11, forceRender11) {
        if (this.renderedFrame === num11 && this.renderConfig.clearCanvas === true && !forceRender11 || this.destroyed || num11 === -1) return;
        this.renderedFrame = num11;
        this.globalData.frameNum = num11 - this.animationItem._isFirstFrame;
        this.globalData.frameId += 1;
        this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender11;
        this.globalData.projectInterface.currentFrame = num11; // console.log('--------');
        // console.log('NEW: ',num);
        var i31;
        var len11 = this.layers.length;
        if (!this.completeLayers) this.checkLayers(num11);
        for(i31 = 0; i31 < len11; i31 += 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].prepareFrame(num11 - this.layers[i31].st);
        if (this.globalData._mdf) {
            if (this.renderConfig.clearCanvas === true) this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
            else this.save();
            for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
            if (this.renderConfig.clearCanvas !== true) this.restore();
        }
    };
    CanvasRendererBase.prototype.buildItem = function(pos11) {
        var elements11 = this.elements;
        if (elements11[pos11] || this.layers[pos11].ty === 99) return;
        var element11 = this.createItem(this.layers[pos11], this, this.globalData);
        elements11[pos11] = element11;
        element11.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */ };
    CanvasRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element11 = this.pendingElements.pop();
            element11.checkParenting();
        }
    };
    CanvasRendererBase.prototype.hide = function() {
        this.animationItem.container.style.display = "none";
    };
    CanvasRendererBase.prototype.show = function() {
        this.animationItem.container.style.display = "block";
    };
    function CVCompElement(data11, globalData11, comp11) {
        this.completeLayers = false;
        this.layers = data11.layers;
        this.pendingElements = [];
        this.elements = createSizedArray(this.layers.length);
        this.initElement(data11, globalData11, comp11);
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        CanvasRendererBase,
        ICompElement,
        CVBaseElement
    ], CVCompElement);
    CVCompElement.prototype.renderInnerContent = function() {
        var ctx11 = this.canvasContext;
        ctx11.beginPath();
        ctx11.moveTo(0, 0);
        ctx11.lineTo(this.data.w, 0);
        ctx11.lineTo(this.data.w, this.data.h);
        ctx11.lineTo(0, this.data.h);
        ctx11.lineTo(0, 0);
        ctx11.clip();
        var i31;
        var len11 = this.layers.length;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.completeLayers || this.elements[i31]) this.elements[i31].renderFrame();
    };
    CVCompElement.prototype.destroy = function() {
        var i31;
        var len11 = this.layers.length;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)if (this.elements[i31]) this.elements[i31].destroy();
        this.layers = null;
        this.elements = null;
    };
    CVCompElement.prototype.createComp = function(data11) {
        return new CVCompElement(data11, this.globalData, this);
    };
    function CanvasRenderer(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.renderConfig = {
            clearCanvas: config11 && config11.clearCanvas !== undefined ? config11.clearCanvas : true,
            context: config11 && config11.context || null,
            progressiveLoad: config11 && config11.progressiveLoad || false,
            preserveAspectRatio: config11 && config11.preserveAspectRatio || "xMidYMid meet",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            contentVisibility: config11 && config11.contentVisibility || "visible",
            className: config11 && config11.className || "",
            id: config11 && config11.id || "",
            runExpressions: !config11 || config11.runExpressions === undefined || config11.runExpressions
        };
        this.renderConfig.dpr = config11 && config11.dpr || 1;
        if (this.animationItem.wrapper) this.renderConfig.dpr = config11 && config11.dpr || window.devicePixelRatio || 1;
        this.renderedFrame = -1;
        this.globalData = {
            frameNum: -1,
            _mdf: false,
            renderConfig: this.renderConfig,
            currentGlobalAlpha: -1
        };
        this.contextData = new CVContextData();
        this.elements = [];
        this.pendingElements = [];
        this.transformMat = new Matrix();
        this.completeLayers = false;
        this.rendererType = "canvas";
    }
    extendPrototype([
        CanvasRendererBase
    ], CanvasRenderer);
    CanvasRenderer.prototype.createComp = function(data11) {
        return new CVCompElement(data11, this.globalData, this);
    };
    function HBaseElement() {}
    HBaseElement.prototype = {
        checkBlendMode: function checkBlendMode11() {},
        initRendererElement: function initRendererElement11() {
            this.baseElement = createTag(this.data.tg || "div");
            if (this.data.hasMask) {
                this.svgElement = createNS("svg");
                this.layerElement = createNS("g");
                this.maskedElement = this.layerElement;
                this.svgElement.appendChild(this.layerElement);
                this.baseElement.appendChild(this.svgElement);
            } else this.layerElement = this.baseElement;
            styleDiv(this.baseElement);
        },
        createContainerElements: function createContainerElements11() {
            this.renderableEffectsManager = new CVEffects(this);
            this.transformedElement = this.baseElement;
            this.maskedElement = this.layerElement;
            if (this.data.ln) this.layerElement.setAttribute("id", this.data.ln);
            if (this.data.cl) this.layerElement.setAttribute("class", this.data.cl);
            if (this.data.bm !== 0) this.setBlendMode();
        },
        renderElement: function renderElement11() {
            var transformedElementStyle11 = this.transformedElement ? this.transformedElement.style : {};
            if (this.finalTransform._matMdf) {
                var matrixValue11 = this.finalTransform.mat.toCSS();
                transformedElementStyle11.transform = matrixValue11;
                transformedElementStyle11.webkitTransform = matrixValue11;
            }
            if (this.finalTransform._opMdf) transformedElementStyle11.opacity = this.finalTransform.mProp.o.v;
        },
        renderFrame: function renderFrame11() {
            // If it is exported as hidden (data.hd === true) no need to render
            // If it is not visible no need to render
            if (this.data.hd || this.hidden) return;
            this.renderTransform();
            this.renderRenderable();
            this.renderElement();
            this.renderInnerContent();
            if (this._isFirstFrame) this._isFirstFrame = false;
        },
        destroy: function destroy11() {
            this.layerElement = null;
            this.transformedElement = null;
            if (this.matteElement) this.matteElement = null;
            if (this.maskManager) {
                this.maskManager.destroy();
                this.maskManager = null;
            }
        },
        createRenderableComponents: function createRenderableComponents11() {
            this.maskManager = new MaskElement(this.data, this, this.globalData);
        },
        addEffects: function addEffects11() {},
        setMatte: function setMatte11() {}
    };
    HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
    HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
    HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(data11, globalData11, comp11) {
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement
    ], HSolidElement);
    HSolidElement.prototype.createContent = function() {
        var rect11;
        if (this.data.hasMask) {
            rect11 = createNS("rect");
            rect11.setAttribute("width", this.data.sw);
            rect11.setAttribute("height", this.data.sh);
            rect11.setAttribute("fill", this.data.sc);
            this.svgElement.setAttribute("width", this.data.sw);
            this.svgElement.setAttribute("height", this.data.sh);
        } else {
            rect11 = createTag("div");
            rect11.style.width = this.data.sw + "px";
            rect11.style.height = this.data.sh + "px";
            rect11.style.backgroundColor = this.data.sc;
        }
        this.layerElement.appendChild(rect11);
    };
    function HShapeElement(data11, globalData11, comp11) {
        // List of drawable elements
        this.shapes = []; // Full shape data
        this.shapesData = data11.shapes; // List of styles that will be applied to shapes
        this.stylesList = []; // List of modifiers that will be applied to shapes
        this.shapeModifiers = []; // List of items in shape tree
        this.itemsData = []; // List of items in previous shape tree
        this.processedElements = []; // List of animated components
        this.animatedContents = [];
        this.shapesContainer = createNS("g");
        this.initElement(data11, globalData11, comp11); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
        // List of elements that have been created
        this.prevViewData = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HSolidElement,
        SVGShapeElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HShapeElement);
    HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;
    HShapeElement.prototype.createContent = function() {
        var cont11;
        this.baseElement.style.fontSize = 0;
        if (this.data.hasMask) {
            this.layerElement.appendChild(this.shapesContainer);
            cont11 = this.svgElement;
        } else {
            cont11 = createNS("svg");
            var size11 = this.comp.data ? this.comp.data : this.globalData.compSize;
            cont11.setAttribute("width", size11.w);
            cont11.setAttribute("height", size11.h);
            cont11.appendChild(this.shapesContainer);
            this.layerElement.appendChild(cont11);
        }
        this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
        this.filterUniqueShapes();
        this.shapeCont = cont11;
    };
    HShapeElement.prototype.getTransformedPoint = function(transformers11, point11) {
        var i31;
        var len11 = transformers11.length;
        for(i31 = 0; i31 < len11; i31 += 1)point11 = transformers11[i31].mProps.v.applyToPointArray(point11[0], point11[1], 0);
        return point11;
    };
    HShapeElement.prototype.calculateShapeBoundingBox = function(item11, boundingBox11) {
        var shape31 = item11.sh.v;
        var transformers11 = item11.transformers;
        var i31;
        var len11 = shape31._length;
        var vPoint11;
        var oPoint11;
        var nextIPoint11;
        var nextVPoint11;
        if (len11 <= 1) return;
        for(i31 = 0; i31 < len11 - 1; i31 += 1){
            vPoint11 = this.getTransformedPoint(transformers11, shape31.v[i31]);
            oPoint11 = this.getTransformedPoint(transformers11, shape31.o[i31]);
            nextIPoint11 = this.getTransformedPoint(transformers11, shape31.i[i31 + 1]);
            nextVPoint11 = this.getTransformedPoint(transformers11, shape31.v[i31 + 1]);
            this.checkBounds(vPoint11, oPoint11, nextIPoint11, nextVPoint11, boundingBox11);
        }
        if (shape31.c) {
            vPoint11 = this.getTransformedPoint(transformers11, shape31.v[i31]);
            oPoint11 = this.getTransformedPoint(transformers11, shape31.o[i31]);
            nextIPoint11 = this.getTransformedPoint(transformers11, shape31.i[0]);
            nextVPoint11 = this.getTransformedPoint(transformers11, shape31.v[0]);
            this.checkBounds(vPoint11, oPoint11, nextIPoint11, nextVPoint11, boundingBox11);
        }
    };
    HShapeElement.prototype.checkBounds = function(vPoint11, oPoint11, nextIPoint11, nextVPoint11, boundingBox11) {
        this.getBoundsOfCurve(vPoint11, oPoint11, nextIPoint11, nextVPoint11);
        var bounds11 = this.shapeBoundingBox;
        boundingBox11.x = bmMin(bounds11.left, boundingBox11.x);
        boundingBox11.xMax = bmMax(bounds11.right, boundingBox11.xMax);
        boundingBox11.y = bmMin(bounds11.top, boundingBox11.y);
        boundingBox11.yMax = bmMax(bounds11.bottom, boundingBox11.yMax);
    };
    HShapeElement.prototype.shapeBoundingBox = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
    };
    HShapeElement.prototype.tempBoundingBox = {
        x: 0,
        xMax: 0,
        y: 0,
        yMax: 0,
        width: 0,
        height: 0
    };
    HShapeElement.prototype.getBoundsOfCurve = function(p011, p141, p221, p311) {
        var bounds11 = [
            [
                p011[0],
                p311[0]
            ],
            [
                p011[1],
                p311[1]
            ]
        ];
        for(var a31, b31, c41, t31, b2ac11, t111, t211, i31 = 0; i31 < 2; ++i31){
            // eslint-disable-line no-plusplus
            b31 = 6 * p011[i31] - 12 * p141[i31] + 6 * p221[i31];
            a31 = -3 * p011[i31] + 9 * p141[i31] - 9 * p221[i31] + 3 * p311[i31];
            c41 = 3 * p141[i31] - 3 * p011[i31];
            b31 |= 0; // eslint-disable-line no-bitwise
            a31 |= 0; // eslint-disable-line no-bitwise
            c41 |= 0; // eslint-disable-line no-bitwise
            if (a31 === 0 && b31 === 0) ;
            else if (a31 === 0) {
                t31 = -c41 / b31;
                if (t31 > 0 && t31 < 1) bounds11[i31].push(this.calculateF(t31, p011, p141, p221, p311, i31));
            } else {
                b2ac11 = b31 * b31 - 4 * c41 * a31;
                if (b2ac11 >= 0) {
                    t111 = (-b31 + bmSqrt(b2ac11)) / (2 * a31);
                    if (t111 > 0 && t111 < 1) bounds11[i31].push(this.calculateF(t111, p011, p141, p221, p311, i31));
                    t211 = (-b31 - bmSqrt(b2ac11)) / (2 * a31);
                    if (t211 > 0 && t211 < 1) bounds11[i31].push(this.calculateF(t211, p011, p141, p221, p311, i31));
                }
            }
        }
        this.shapeBoundingBox.left = bmMin.apply(null, bounds11[0]);
        this.shapeBoundingBox.top = bmMin.apply(null, bounds11[1]);
        this.shapeBoundingBox.right = bmMax.apply(null, bounds11[0]);
        this.shapeBoundingBox.bottom = bmMax.apply(null, bounds11[1]);
    };
    HShapeElement.prototype.calculateF = function(t31, p011, p141, p221, p311, i31) {
        return bmPow(1 - t31, 3) * p011[i31] + 3 * bmPow(1 - t31, 2) * t31 * p141[i31] + 3 * (1 - t31) * bmPow(t31, 2) * p221[i31] + bmPow(t31, 3) * p311[i31];
    };
    HShapeElement.prototype.calculateBoundingBox = function(itemsData11, boundingBox11) {
        var i31;
        var len11 = itemsData11.length;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (itemsData11[i31] && itemsData11[i31].sh) this.calculateShapeBoundingBox(itemsData11[i31], boundingBox11);
            else if (itemsData11[i31] && itemsData11[i31].it) this.calculateBoundingBox(itemsData11[i31].it, boundingBox11);
            else if (itemsData11[i31] && itemsData11[i31].style && itemsData11[i31].w) this.expandStrokeBoundingBox(itemsData11[i31].w, boundingBox11);
        }
    };
    HShapeElement.prototype.expandStrokeBoundingBox = function(widthProperty11, boundingBox11) {
        var width11 = 0;
        if (widthProperty11.keyframes) {
            for(var i31 = 0; i31 < widthProperty11.keyframes.length; i31 += 1){
                var kfw11 = widthProperty11.keyframes[i31].s;
                if (kfw11 > width11) width11 = kfw11;
            }
            width11 *= widthProperty11.mult;
        } else width11 = widthProperty11.v * widthProperty11.mult;
        boundingBox11.x -= width11;
        boundingBox11.xMax += width11;
        boundingBox11.y -= width11;
        boundingBox11.yMax += width11;
    };
    HShapeElement.prototype.currentBoxContains = function(box11) {
        return this.currentBBox.x <= box11.x && this.currentBBox.y <= box11.y && this.currentBBox.width + this.currentBBox.x >= box11.x + box11.width && this.currentBBox.height + this.currentBBox.y >= box11.y + box11.height;
    };
    HShapeElement.prototype.renderInnerContent = function() {
        this._renderShapeFrame();
        if (!this.hidden && (this._isFirstFrame || this._mdf)) {
            var tempBoundingBox11 = this.tempBoundingBox;
            var max11 = 999999;
            tempBoundingBox11.x = max11;
            tempBoundingBox11.xMax = -max11;
            tempBoundingBox11.y = max11;
            tempBoundingBox11.yMax = -max11;
            this.calculateBoundingBox(this.itemsData, tempBoundingBox11);
            tempBoundingBox11.width = tempBoundingBox11.xMax < tempBoundingBox11.x ? 0 : tempBoundingBox11.xMax - tempBoundingBox11.x;
            tempBoundingBox11.height = tempBoundingBox11.yMax < tempBoundingBox11.y ? 0 : tempBoundingBox11.yMax - tempBoundingBox11.y; // var tempBoundingBox = this.shapeCont.getBBox();
            if (this.currentBoxContains(tempBoundingBox11)) return;
            var changed11 = false;
            if (this.currentBBox.w !== tempBoundingBox11.width) {
                this.currentBBox.w = tempBoundingBox11.width;
                this.shapeCont.setAttribute("width", tempBoundingBox11.width);
                changed11 = true;
            }
            if (this.currentBBox.h !== tempBoundingBox11.height) {
                this.currentBBox.h = tempBoundingBox11.height;
                this.shapeCont.setAttribute("height", tempBoundingBox11.height);
                changed11 = true;
            }
            if (changed11 || this.currentBBox.x !== tempBoundingBox11.x || this.currentBBox.y !== tempBoundingBox11.y) {
                this.currentBBox.w = tempBoundingBox11.width;
                this.currentBBox.h = tempBoundingBox11.height;
                this.currentBBox.x = tempBoundingBox11.x;
                this.currentBBox.y = tempBoundingBox11.y;
                this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                var shapeStyle11 = this.shapeCont.style;
                var shapeTransform11 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                shapeStyle11.transform = shapeTransform11;
                shapeStyle11.webkitTransform = shapeTransform11;
            }
        }
    };
    function HTextElement(data11, globalData11, comp11) {
        this.textSpans = [];
        this.textPaths = [];
        this.currentBBox = {
            x: 999999,
            y: -999999,
            h: 0,
            w: 0
        };
        this.renderType = "svg";
        this.isMasked = false;
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HierarchyElement,
        FrameElement,
        RenderableDOMElement,
        ITextElement
    ], HTextElement);
    HTextElement.prototype.createContent = function() {
        this.isMasked = this.checkMasks();
        if (this.isMasked) {
            this.renderType = "svg";
            this.compW = this.comp.data.w;
            this.compH = this.comp.data.h;
            this.svgElement.setAttribute("width", this.compW);
            this.svgElement.setAttribute("height", this.compH);
            var g31 = createNS("g");
            this.maskedElement.appendChild(g31);
            this.innerElem = g31;
        } else {
            this.renderType = "html";
            this.innerElem = this.layerElement;
        }
        this.checkParenting();
    };
    HTextElement.prototype.buildNewText = function() {
        var documentData11 = this.textProperty.currentData;
        this.renderedLetters = createSizedArray(documentData11.l ? documentData11.l.length : 0);
        var innerElemStyle11 = this.innerElem.style;
        var textColor11 = documentData11.fc ? this.buildColor(documentData11.fc) : "rgba(0,0,0,0)";
        innerElemStyle11.fill = textColor11;
        innerElemStyle11.color = textColor11;
        if (documentData11.sc) {
            innerElemStyle11.stroke = this.buildColor(documentData11.sc);
            innerElemStyle11.strokeWidth = documentData11.sw + "px";
        }
        var fontData11 = this.globalData.fontManager.getFontByName(documentData11.f);
        if (!this.globalData.fontManager.chars) {
            innerElemStyle11.fontSize = documentData11.finalSize + "px";
            innerElemStyle11.lineHeight = documentData11.finalSize + "px";
            if (fontData11.fClass) this.innerElem.className = fontData11.fClass;
            else {
                innerElemStyle11.fontFamily = fontData11.fFamily;
                var fWeight11 = documentData11.fWeight;
                var fStyle11 = documentData11.fStyle;
                innerElemStyle11.fontStyle = fStyle11;
                innerElemStyle11.fontWeight = fWeight11;
            }
        }
        var i31;
        var len11;
        var letters11 = documentData11.l;
        len11 = letters11.length;
        var tSpan11;
        var tParent11;
        var tCont11;
        var matrixHelper11 = this.mHelper;
        var shapes11;
        var shapeStr11 = "";
        var cnt11 = 0;
        for(i31 = 0; i31 < len11; i31 += 1){
            if (this.globalData.fontManager.chars) {
                if (!this.textPaths[cnt11]) {
                    tSpan11 = createNS("path");
                    tSpan11.setAttribute("stroke-linecap", lineCapEnum[1]);
                    tSpan11.setAttribute("stroke-linejoin", lineJoinEnum[2]);
                    tSpan11.setAttribute("stroke-miterlimit", "4");
                } else tSpan11 = this.textPaths[cnt11];
                if (!this.isMasked) {
                    if (this.textSpans[cnt11]) {
                        tParent11 = this.textSpans[cnt11];
                        tCont11 = tParent11.children[0];
                    } else {
                        tParent11 = createTag("div");
                        tParent11.style.lineHeight = 0;
                        tCont11 = createNS("svg");
                        tCont11.appendChild(tSpan11);
                        styleDiv(tParent11);
                    }
                }
            } else if (!this.isMasked) {
                if (this.textSpans[cnt11]) {
                    tParent11 = this.textSpans[cnt11];
                    tSpan11 = this.textPaths[cnt11];
                } else {
                    tParent11 = createTag("span");
                    styleDiv(tParent11);
                    tSpan11 = createTag("span");
                    styleDiv(tSpan11);
                    tParent11.appendChild(tSpan11);
                }
            } else tSpan11 = this.textPaths[cnt11] ? this.textPaths[cnt11] : createNS("text");
             // tSpan.setAttribute('visibility', 'hidden');
            if (this.globalData.fontManager.chars) {
                var charData11 = this.globalData.fontManager.getCharData(documentData11.finalText[i31], fontData11.fStyle, this.globalData.fontManager.getFontByName(documentData11.f).fFamily);
                var shapeData11;
                if (charData11) shapeData11 = charData11.data;
                else shapeData11 = null;
                matrixHelper11.reset();
                if (shapeData11 && shapeData11.shapes && shapeData11.shapes.length) {
                    shapes11 = shapeData11.shapes[0].it;
                    matrixHelper11.scale(documentData11.finalSize / 100, documentData11.finalSize / 100);
                    shapeStr11 = this.createPathShape(matrixHelper11, shapes11);
                    tSpan11.setAttribute("d", shapeStr11);
                }
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent11);
                    if (shapeData11 && shapeData11.shapes) {
                        // document.body.appendChild is needed to get exact measure of shape
                        document.body.appendChild(tCont11);
                        var boundingBox11 = tCont11.getBBox();
                        tCont11.setAttribute("width", boundingBox11.width + 2);
                        tCont11.setAttribute("height", boundingBox11.height + 2);
                        tCont11.setAttribute("viewBox", boundingBox11.x - 1 + " " + (boundingBox11.y - 1) + " " + (boundingBox11.width + 2) + " " + (boundingBox11.height + 2));
                        var tContStyle11 = tCont11.style;
                        var tContTranslation11 = "translate(" + (boundingBox11.x - 1) + "px," + (boundingBox11.y - 1) + "px)";
                        tContStyle11.transform = tContTranslation11;
                        tContStyle11.webkitTransform = tContTranslation11;
                        letters11[i31].yOffset = boundingBox11.y - 1;
                    } else {
                        tCont11.setAttribute("width", 1);
                        tCont11.setAttribute("height", 1);
                    }
                    tParent11.appendChild(tCont11);
                } else this.innerElem.appendChild(tSpan11);
            } else {
                tSpan11.textContent = letters11[i31].val;
                tSpan11.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                if (!this.isMasked) {
                    this.innerElem.appendChild(tParent11); //
                    var tStyle11 = tSpan11.style;
                    var tSpanTranslation11 = "translate3d(0," + -documentData11.finalSize / 1.2 + "px,0)";
                    tStyle11.transform = tSpanTranslation11;
                    tStyle11.webkitTransform = tSpanTranslation11;
                } else this.innerElem.appendChild(tSpan11);
            } //
            if (!this.isMasked) this.textSpans[cnt11] = tParent11;
            else this.textSpans[cnt11] = tSpan11;
            this.textSpans[cnt11].style.display = "block";
            this.textPaths[cnt11] = tSpan11;
            cnt11 += 1;
        }
        while(cnt11 < this.textSpans.length){
            this.textSpans[cnt11].style.display = "none";
            cnt11 += 1;
        }
    };
    HTextElement.prototype.renderInnerContent = function() {
        this.validateText();
        var svgStyle11;
        if (this.data.singleShape) {
            if (!this._isFirstFrame && !this.lettersChangedFlag) return;
            if (this.isMasked && this.finalTransform._matMdf) {
                // Todo Benchmark if using this is better than getBBox
                this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH);
                svgStyle11 = this.svgElement.style;
                var translation11 = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                svgStyle11.transform = translation11;
                svgStyle11.webkitTransform = translation11;
            }
        }
        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
        if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) return;
        var i31;
        var len11;
        var count11 = 0;
        var renderedLetters11 = this.textAnimator.renderedLetters;
        var letters11 = this.textProperty.currentData.l;
        len11 = letters11.length;
        var renderedLetter11;
        var textSpan11;
        var textPath11;
        for(i31 = 0; i31 < len11; i31 += 1)if (letters11[i31].n) count11 += 1;
        else {
            textSpan11 = this.textSpans[i31];
            textPath11 = this.textPaths[i31];
            renderedLetter11 = renderedLetters11[count11];
            count11 += 1;
            if (renderedLetter11._mdf.m) {
                if (!this.isMasked) {
                    textSpan11.style.webkitTransform = renderedLetter11.m;
                    textSpan11.style.transform = renderedLetter11.m;
                } else textSpan11.setAttribute("transform", renderedLetter11.m);
            } /// /textSpan.setAttribute('opacity',renderedLetter.o);
            textSpan11.style.opacity = renderedLetter11.o;
            if (renderedLetter11.sw && renderedLetter11._mdf.sw) textPath11.setAttribute("stroke-width", renderedLetter11.sw);
            if (renderedLetter11.sc && renderedLetter11._mdf.sc) textPath11.setAttribute("stroke", renderedLetter11.sc);
            if (renderedLetter11.fc && renderedLetter11._mdf.fc) {
                textPath11.setAttribute("fill", renderedLetter11.fc);
                textPath11.style.color = renderedLetter11.fc;
            }
        }
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
            var boundingBox11 = this.innerElem.getBBox();
            if (this.currentBBox.w !== boundingBox11.width) {
                this.currentBBox.w = boundingBox11.width;
                this.svgElement.setAttribute("width", boundingBox11.width);
            }
            if (this.currentBBox.h !== boundingBox11.height) {
                this.currentBBox.h = boundingBox11.height;
                this.svgElement.setAttribute("height", boundingBox11.height);
            }
            var margin11 = 1;
            if (this.currentBBox.w !== boundingBox11.width + margin11 * 2 || this.currentBBox.h !== boundingBox11.height + margin11 * 2 || this.currentBBox.x !== boundingBox11.x - margin11 || this.currentBBox.y !== boundingBox11.y - margin11) {
                this.currentBBox.w = boundingBox11.width + margin11 * 2;
                this.currentBBox.h = boundingBox11.height + margin11 * 2;
                this.currentBBox.x = boundingBox11.x - margin11;
                this.currentBBox.y = boundingBox11.y - margin11;
                this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                svgStyle11 = this.svgElement.style;
                var svgTransform11 = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                svgStyle11.transform = svgTransform11;
                svgStyle11.webkitTransform = svgTransform11;
            }
        }
    };
    function HCameraElement(data11, globalData11, comp11) {
        this.initFrame();
        this.initBaseData(data11, globalData11, comp11);
        this.initHierarchy();
        var getProp11 = PropertyFactory.getProp;
        this.pe = getProp11(this, data11.pe, 0, 0, this);
        if (data11.ks.p.s) {
            this.px = getProp11(this, data11.ks.p.x, 1, 0, this);
            this.py = getProp11(this, data11.ks.p.y, 1, 0, this);
            this.pz = getProp11(this, data11.ks.p.z, 1, 0, this);
        } else this.p = getProp11(this, data11.ks.p, 1, 0, this);
        if (data11.ks.a) this.a = getProp11(this, data11.ks.a, 1, 0, this);
        if (data11.ks.or.k.length && data11.ks.or.k[0].to) {
            var i31;
            var len11 = data11.ks.or.k.length;
            for(i31 = 0; i31 < len11; i31 += 1){
                data11.ks.or.k[i31].to = null;
                data11.ks.or.k[i31].ti = null;
            }
        }
        this.or = getProp11(this, data11.ks.or, 1, degToRads, this);
        this.or.sh = true;
        this.rx = getProp11(this, data11.ks.rx, 0, degToRads, this);
        this.ry = getProp11(this, data11.ks.ry, 0, degToRads, this);
        this.rz = getProp11(this, data11.ks.rz, 0, degToRads, this);
        this.mat = new Matrix();
        this._prevMat = new Matrix();
        this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.
        this.finalTransform = {
            mProp: this
        };
    }
    extendPrototype([
        BaseElement,
        FrameElement,
        HierarchyElement
    ], HCameraElement);
    HCameraElement.prototype.setup = function() {
        var i31;
        var len11 = this.comp.threeDElements.length;
        var comp11;
        var perspectiveStyle11;
        var containerStyle11;
        for(i31 = 0; i31 < len11; i31 += 1){
            // [perspectiveElem,container]
            comp11 = this.comp.threeDElements[i31];
            if (comp11.type === "3d") {
                perspectiveStyle11 = comp11.perspectiveElem.style;
                containerStyle11 = comp11.container.style;
                var perspective11 = this.pe.v + "px";
                var origin11 = "0px 0px 0px";
                var matrix11 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                perspectiveStyle11.perspective = perspective11;
                perspectiveStyle11.webkitPerspective = perspective11;
                containerStyle11.transformOrigin = origin11;
                containerStyle11.mozTransformOrigin = origin11;
                containerStyle11.webkitTransformOrigin = origin11;
                perspectiveStyle11.transform = matrix11;
                perspectiveStyle11.webkitTransform = matrix11;
            }
        }
    };
    HCameraElement.prototype.createElements = function() {};
    HCameraElement.prototype.hide = function() {};
    HCameraElement.prototype.renderFrame = function() {
        var _mdf11 = this._isFirstFrame;
        var i31;
        var len11;
        if (this.hierarchy) {
            len11 = this.hierarchy.length;
            for(i31 = 0; i31 < len11; i31 += 1)_mdf11 = this.hierarchy[i31].finalTransform.mProp._mdf || _mdf11;
        }
        if (_mdf11 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
            this.mat.reset();
            if (this.hierarchy) {
                len11 = this.hierarchy.length - 1;
                for(i31 = len11; i31 >= 0; i31 -= 1){
                    var mTransf11 = this.hierarchy[i31].finalTransform.mProp;
                    this.mat.translate(-mTransf11.p.v[0], -mTransf11.p.v[1], mTransf11.p.v[2]);
                    this.mat.rotateX(-mTransf11.or.v[0]).rotateY(-mTransf11.or.v[1]).rotateZ(mTransf11.or.v[2]);
                    this.mat.rotateX(-mTransf11.rx.v).rotateY(-mTransf11.ry.v).rotateZ(mTransf11.rz.v);
                    this.mat.scale(1 / mTransf11.s.v[0], 1 / mTransf11.s.v[1], 1 / mTransf11.s.v[2]);
                    this.mat.translate(mTransf11.a.v[0], mTransf11.a.v[1], mTransf11.a.v[2]);
                }
            }
            if (this.p) this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
            else this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
            if (this.a) {
                var diffVector11;
                if (this.p) diffVector11 = [
                    this.p.v[0] - this.a.v[0],
                    this.p.v[1] - this.a.v[1],
                    this.p.v[2] - this.a.v[2]
                ];
                else diffVector11 = [
                    this.px.v - this.a.v[0],
                    this.py.v - this.a.v[1],
                    this.pz.v - this.a.v[2]
                ];
                var mag11 = Math.sqrt(Math.pow(diffVector11[0], 2) + Math.pow(diffVector11[1], 2) + Math.pow(diffVector11[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
                var lookDir11 = [
                    diffVector11[0] / mag11,
                    diffVector11[1] / mag11,
                    diffVector11[2] / mag11
                ];
                var lookLengthOnXZ11 = Math.sqrt(lookDir11[2] * lookDir11[2] + lookDir11[0] * lookDir11[0]);
                var mRotationX11 = Math.atan2(lookDir11[1], lookLengthOnXZ11);
                var mRotationY11 = Math.atan2(lookDir11[0], -lookDir11[2]);
                this.mat.rotateY(mRotationY11).rotateX(-mRotationX11);
            }
            this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
            this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
            this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
            this.mat.translate(0, 0, this.pe.v);
            var hasMatrixChanged11 = !this._prevMat.equals(this.mat);
            if ((hasMatrixChanged11 || this.pe._mdf) && this.comp.threeDElements) {
                len11 = this.comp.threeDElements.length;
                var comp11;
                var perspectiveStyle11;
                var containerStyle11;
                for(i31 = 0; i31 < len11; i31 += 1){
                    comp11 = this.comp.threeDElements[i31];
                    if (comp11.type === "3d") {
                        if (hasMatrixChanged11) {
                            var matValue11 = this.mat.toCSS();
                            containerStyle11 = comp11.container.style;
                            containerStyle11.transform = matValue11;
                            containerStyle11.webkitTransform = matValue11;
                        }
                        if (this.pe._mdf) {
                            perspectiveStyle11 = comp11.perspectiveElem.style;
                            perspectiveStyle11.perspective = this.pe.v + "px";
                            perspectiveStyle11.webkitPerspective = this.pe.v + "px";
                        }
                    }
                }
                this.mat.clone(this._prevMat);
            }
        }
        this._isFirstFrame = false;
    };
    HCameraElement.prototype.prepareFrame = function(num11) {
        this.prepareProperties(num11, true);
    };
    HCameraElement.prototype.destroy = function() {};
    HCameraElement.prototype.getBaseElement = function() {
        return null;
    };
    function HImageElement(data11, globalData11, comp11) {
        this.assetData = globalData11.getAssetData(data11.refId);
        this.initElement(data11, globalData11, comp11);
    }
    extendPrototype([
        BaseElement,
        TransformElement,
        HBaseElement,
        HSolidElement,
        HierarchyElement,
        FrameElement,
        RenderableElement
    ], HImageElement);
    HImageElement.prototype.createContent = function() {
        var assetPath11 = this.globalData.getAssetsPath(this.assetData);
        var img11 = new Image();
        if (this.data.hasMask) {
            this.imageElem = createNS("image");
            this.imageElem.setAttribute("width", this.assetData.w + "px");
            this.imageElem.setAttribute("height", this.assetData.h + "px");
            this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", assetPath11);
            this.layerElement.appendChild(this.imageElem);
            this.baseElement.setAttribute("width", this.assetData.w);
            this.baseElement.setAttribute("height", this.assetData.h);
        } else this.layerElement.appendChild(img11);
        img11.crossOrigin = "anonymous";
        img11.src = assetPath11;
        if (this.data.ln) this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config11 && config11.className || "",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config11 && config11.hideOnTransparent === false),
            filterSize: {
                width: config11 && config11.filterSize && config11.filterSize.width || "400%",
                height: config11 && config11.filterSize && config11.filterSize.height || "400%",
                x: config11 && config11.filterSize && config11.filterSize.x || "-100%",
                y: config11 && config11.filterSize && config11.filterSize.y || "-100%"
            }
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        BaseRenderer
    ], HybridRendererBase);
    HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;
    HybridRendererBase.prototype.checkPendingElements = function() {
        while(this.pendingElements.length){
            var element11 = this.pendingElements.pop();
            element11.checkParenting();
        }
    };
    HybridRendererBase.prototype.appendElementInPos = function(element11, pos11) {
        var newDOMElement11 = element11.getBaseElement();
        if (!newDOMElement11) return;
        var layer11 = this.layers[pos11];
        if (!layer11.ddd || !this.supports3d) {
            if (this.threeDElements) this.addTo3dContainer(newDOMElement11, pos11);
            else {
                var i31 = 0;
                var nextDOMElement11;
                var nextLayer11;
                var tmpDOMElement11;
                while(i31 < pos11){
                    if (this.elements[i31] && this.elements[i31] !== true && this.elements[i31].getBaseElement) {
                        nextLayer11 = this.elements[i31];
                        tmpDOMElement11 = this.layers[i31].ddd ? this.getThreeDContainerByPos(i31) : nextLayer11.getBaseElement();
                        nextDOMElement11 = tmpDOMElement11 || nextDOMElement11;
                    }
                    i31 += 1;
                }
                if (nextDOMElement11) {
                    if (!layer11.ddd || !this.supports3d) this.layerElement.insertBefore(newDOMElement11, nextDOMElement11);
                } else if (!layer11.ddd || !this.supports3d) this.layerElement.appendChild(newDOMElement11);
            }
        } else this.addTo3dContainer(newDOMElement11, pos11);
    };
    HybridRendererBase.prototype.createShape = function(data11) {
        if (!this.supports3d) return new SVGShapeElement(data11, this.globalData, this);
        return new HShapeElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createText = function(data11) {
        if (!this.supports3d) return new SVGTextLottieElement(data11, this.globalData, this);
        return new HTextElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createCamera = function(data11) {
        this.camera = new HCameraElement(data11, this.globalData, this);
        return this.camera;
    };
    HybridRendererBase.prototype.createImage = function(data11) {
        if (!this.supports3d) return new IImageElement(data11, this.globalData, this);
        return new HImageElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createSolid = function(data11) {
        if (!this.supports3d) return new ISolidElement(data11, this.globalData, this);
        return new HSolidElement(data11, this.globalData, this);
    };
    HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;
    HybridRendererBase.prototype.getThreeDContainerByPos = function(pos11) {
        var i31 = 0;
        var len11 = this.threeDElements.length;
        while(i31 < len11){
            if (this.threeDElements[i31].startPos <= pos11 && this.threeDElements[i31].endPos >= pos11) return this.threeDElements[i31].perspectiveElem;
            i31 += 1;
        }
        return null;
    };
    HybridRendererBase.prototype.createThreeDContainer = function(pos11, type11) {
        var perspectiveElem11 = createTag("div");
        var style11;
        var containerStyle11;
        styleDiv(perspectiveElem11);
        var container11 = createTag("div");
        styleDiv(container11);
        if (type11 === "3d") {
            style11 = perspectiveElem11.style;
            style11.width = this.globalData.compSize.w + "px";
            style11.height = this.globalData.compSize.h + "px";
            var center11 = "50% 50%";
            style11.webkitTransformOrigin = center11;
            style11.mozTransformOrigin = center11;
            style11.transformOrigin = center11;
            containerStyle11 = container11.style;
            var matrix11 = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
            containerStyle11.transform = matrix11;
            containerStyle11.webkitTransform = matrix11;
        }
        perspectiveElem11.appendChild(container11); // this.resizerElem.appendChild(perspectiveElem);
        var threeDContainerData11 = {
            container: container11,
            perspectiveElem: perspectiveElem11,
            startPos: pos11,
            endPos: pos11,
            type: type11
        };
        this.threeDElements.push(threeDContainerData11);
        return threeDContainerData11;
    };
    HybridRendererBase.prototype.build3dContainers = function() {
        var i31;
        var len11 = this.layers.length;
        var lastThreeDContainerData11;
        var currentContainer11 = "";
        for(i31 = 0; i31 < len11; i31 += 1)if (this.layers[i31].ddd && this.layers[i31].ty !== 3) {
            if (currentContainer11 !== "3d") {
                currentContainer11 = "3d";
                lastThreeDContainerData11 = this.createThreeDContainer(i31, "3d");
            }
            lastThreeDContainerData11.endPos = Math.max(lastThreeDContainerData11.endPos, i31);
        } else {
            if (currentContainer11 !== "2d") {
                currentContainer11 = "2d";
                lastThreeDContainerData11 = this.createThreeDContainer(i31, "2d");
            }
            lastThreeDContainerData11.endPos = Math.max(lastThreeDContainerData11.endPos, i31);
        }
        len11 = this.threeDElements.length;
        for(i31 = len11 - 1; i31 >= 0; i31 -= 1)this.resizerElem.appendChild(this.threeDElements[i31].perspectiveElem);
    };
    HybridRendererBase.prototype.addTo3dContainer = function(elem31, pos11) {
        var i31 = 0;
        var len11 = this.threeDElements.length;
        while(i31 < len11){
            if (pos11 <= this.threeDElements[i31].endPos) {
                var j31 = this.threeDElements[i31].startPos;
                var nextElement11;
                while(j31 < pos11){
                    if (this.elements[j31] && this.elements[j31].getBaseElement) nextElement11 = this.elements[j31].getBaseElement();
                    j31 += 1;
                }
                if (nextElement11) this.threeDElements[i31].container.insertBefore(elem31, nextElement11);
                else this.threeDElements[i31].container.appendChild(elem31);
                break;
            }
            i31 += 1;
        }
    };
    HybridRendererBase.prototype.configAnimation = function(animData11) {
        var resizerElem11 = createTag("div");
        var wrapper11 = this.animationItem.wrapper;
        var style11 = resizerElem11.style;
        style11.width = animData11.w + "px";
        style11.height = animData11.h + "px";
        this.resizerElem = resizerElem11;
        styleDiv(resizerElem11);
        style11.transformStyle = "flat";
        style11.mozTransformStyle = "flat";
        style11.webkitTransformStyle = "flat";
        if (this.renderConfig.className) resizerElem11.setAttribute("class", this.renderConfig.className);
        wrapper11.appendChild(resizerElem11);
        style11.overflow = "hidden";
        var svg11 = createNS("svg");
        svg11.setAttribute("width", "1");
        svg11.setAttribute("height", "1");
        styleDiv(svg11);
        this.resizerElem.appendChild(svg11);
        var defs11 = createNS("defs");
        svg11.appendChild(defs11);
        this.data = animData11; // Mask animation
        this.setupGlobalData(animData11, svg11);
        this.globalData.defs = defs11;
        this.layers = animData11.layers;
        this.layerElement = this.resizerElem;
        this.build3dContainers();
        this.updateContainerSize();
    };
    HybridRendererBase.prototype.destroy = function() {
        if (this.animationItem.wrapper) this.animationItem.wrapper.innerText = "";
        this.animationItem.container = null;
        this.globalData.defs = null;
        var i31;
        var len11 = this.layers ? this.layers.length : 0;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.elements[i31] && this.elements[i31].destroy) this.elements[i31].destroy();
        this.elements.length = 0;
        this.destroyed = true;
        this.animationItem = null;
    };
    HybridRendererBase.prototype.updateContainerSize = function() {
        var elementWidth11 = this.animationItem.wrapper.offsetWidth;
        var elementHeight11 = this.animationItem.wrapper.offsetHeight;
        var elementRel11 = elementWidth11 / elementHeight11;
        var animationRel11 = this.globalData.compSize.w / this.globalData.compSize.h;
        var sx11;
        var sy11;
        var tx11;
        var ty11;
        if (animationRel11 > elementRel11) {
            sx11 = elementWidth11 / this.globalData.compSize.w;
            sy11 = elementWidth11 / this.globalData.compSize.w;
            tx11 = 0;
            ty11 = (elementHeight11 - this.globalData.compSize.h * (elementWidth11 / this.globalData.compSize.w)) / 2;
        } else {
            sx11 = elementHeight11 / this.globalData.compSize.h;
            sy11 = elementHeight11 / this.globalData.compSize.h;
            tx11 = (elementWidth11 - this.globalData.compSize.w * (elementHeight11 / this.globalData.compSize.h)) / 2;
            ty11 = 0;
        }
        var style11 = this.resizerElem.style;
        style11.webkitTransform = "matrix3d(" + sx11 + ",0,0,0,0," + sy11 + ",0,0,0,0,1,0," + tx11 + "," + ty11 + ",0,1)";
        style11.transform = style11.webkitTransform;
    };
    HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
    HybridRendererBase.prototype.hide = function() {
        this.resizerElem.style.display = "none";
    };
    HybridRendererBase.prototype.show = function() {
        this.resizerElem.style.display = "block";
    };
    HybridRendererBase.prototype.initItems = function() {
        this.buildAllItems();
        if (this.camera) this.camera.setup();
        else {
            var cWidth11 = this.globalData.compSize.w;
            var cHeight11 = this.globalData.compSize.h;
            var i31;
            var len11 = this.threeDElements.length;
            for(i31 = 0; i31 < len11; i31 += 1){
                var style11 = this.threeDElements[i31].perspectiveElem.style;
                style11.webkitPerspective = Math.sqrt(Math.pow(cWidth11, 2) + Math.pow(cHeight11, 2)) + "px";
                style11.perspective = style11.webkitPerspective;
            }
        }
    };
    HybridRendererBase.prototype.searchExtraCompositions = function(assets11) {
        var i31;
        var len11 = assets11.length;
        var floatingContainer11 = createTag("div");
        for(i31 = 0; i31 < len11; i31 += 1)if (assets11[i31].xt) {
            var comp11 = this.createComp(assets11[i31], floatingContainer11, this.globalData.comp, null);
            comp11.initExpressions();
            this.globalData.projectInterface.registerComposition(comp11);
        }
    };
    function HCompElement(data11, globalData11, comp11) {
        this.layers = data11.layers;
        this.supports3d = !data11.hasMask;
        this.completeLayers = false;
        this.pendingElements = [];
        this.elements = this.layers ? createSizedArray(this.layers.length) : [];
        this.initElement(data11, globalData11, comp11);
        this.tm = data11.tm ? PropertyFactory.getProp(this, data11.tm, 0, globalData11.frameRate, this) : {
            _placeholder: true
        };
    }
    extendPrototype([
        HybridRendererBase,
        ICompElement,
        HBaseElement
    ], HCompElement);
    HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;
    HCompElement.prototype.createContainerElements = function() {
        this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
        if (this.data.hasMask) {
            this.svgElement.setAttribute("width", this.data.w);
            this.svgElement.setAttribute("height", this.data.h);
            this.transformedElement = this.baseElement;
        } else this.transformedElement = this.layerElement;
    };
    HCompElement.prototype.addTo3dContainer = function(elem31, pos11) {
        var j31 = 0;
        var nextElement11;
        while(j31 < pos11){
            if (this.elements[j31] && this.elements[j31].getBaseElement) nextElement11 = this.elements[j31].getBaseElement();
            j31 += 1;
        }
        if (nextElement11) this.layerElement.insertBefore(elem31, nextElement11);
        else this.layerElement.appendChild(elem31);
    };
    HCompElement.prototype.createComp = function(data11) {
        if (!this.supports3d) return new SVGCompElement(data11, this.globalData, this);
        return new HCompElement(data11, this.globalData, this);
    };
    function HybridRenderer(animationItem11, config11) {
        this.animationItem = animationItem11;
        this.layers = null;
        this.renderedFrame = -1;
        this.renderConfig = {
            className: config11 && config11.className || "",
            imagePreserveAspectRatio: config11 && config11.imagePreserveAspectRatio || "xMidYMid slice",
            hideOnTransparent: !(config11 && config11.hideOnTransparent === false),
            filterSize: {
                width: config11 && config11.filterSize && config11.filterSize.width || "400%",
                height: config11 && config11.filterSize && config11.filterSize.height || "400%",
                x: config11 && config11.filterSize && config11.filterSize.x || "-100%",
                y: config11 && config11.filterSize && config11.filterSize.y || "-100%"
            },
            runExpressions: !config11 || config11.runExpressions === undefined || config11.runExpressions
        };
        this.globalData = {
            _mdf: false,
            frameNum: -1,
            renderConfig: this.renderConfig
        };
        this.pendingElements = [];
        this.elements = [];
        this.threeDElements = [];
        this.destroyed = false;
        this.camera = null;
        this.supports3d = true;
        this.rendererType = "html";
    }
    extendPrototype([
        HybridRendererBase
    ], HybridRenderer);
    HybridRenderer.prototype.createComp = function(data11) {
        if (!this.supports3d) return new SVGCompElement(data11, this.globalData, this);
        return new HCompElement(data11, this.globalData, this);
    };
    var CompExpressionInterface = function() {
        return function(comp11) {
            function _thisLayerFunction11(name11) {
                var i31 = 0;
                var len11 = comp11.layers.length;
                while(i31 < len11){
                    if (comp11.layers[i31].nm === name11 || comp11.layers[i31].ind === name11) return comp11.elements[i31].layerInterface;
                    i31 += 1;
                }
                return null; // return {active:false};
            }
            Object.defineProperty(_thisLayerFunction11, "_name", {
                value: comp11.data.nm
            });
            _thisLayerFunction11.layer = _thisLayerFunction11;
            _thisLayerFunction11.pixelAspect = 1;
            _thisLayerFunction11.height = comp11.data.h || comp11.globalData.compSize.h;
            _thisLayerFunction11.width = comp11.data.w || comp11.globalData.compSize.w;
            _thisLayerFunction11.pixelAspect = 1;
            _thisLayerFunction11.frameDuration = 1 / comp11.globalData.frameRate;
            _thisLayerFunction11.displayStartTime = 0;
            _thisLayerFunction11.numLayers = comp11.layers.length;
            return _thisLayerFunction11;
        };
    }();
    function _typeof$2(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$2 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$2 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$2(obj11);
    }
    /* eslint-disable */ /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */ function seedRandom(pool11, math11) {
        //
        // The following constants are related to IEEE 754 limits.
        //
        var global11 = this, width11 = 256, // each RC4 output is 0 <= x < 256
        chunks11 = 6, // at least six RC4 outputs for each double
        digits11 = 52, // there are 52 significant digits in a double
        rngname11 = "random", // rngname: name for Math.random and Math.seedrandom
        startdenom11 = math11.pow(width11, chunks11), significance11 = math11.pow(2, digits11), overflow11 = significance11 * 2, mask11 = width11 - 1, nodecrypto11; // node.js crypto module, initialized at the bottom.
        //
        // seedrandom()
        // This is the seedrandom function described above.
        //
        function seedrandom11(seed11, options11, callback11) {
            var key11 = [];
            options11 = options11 === true ? {
                entropy: true
            } : options11 || {}; // Flatten the seed string or build one from local entropy if needed.
            var shortseed11 = mixkey11(flatten11(options11.entropy ? [
                seed11,
                tostring11(pool11)
            ] : seed11 === null ? autoseed11() : seed11, 3), key11); // Use the seed to initialize an ARC4 generator.
            var arc411 = new ARC411(key11); // This function returns a random double in [0, 1) that contains
            // randomness in every bit of the mantissa of the IEEE 754 value.
            var prng11 = function prng11() {
                var n31 = arc411.g(chunks11), // Start with a numerator n < 2 ^ 48
                d31 = startdenom11, //   and denominator d = 2 ^ 48.
                x41 = 0; //   and no 'extra last byte'.
                while(n31 < significance11){
                    // Fill up all significant digits by
                    n31 = (n31 + x41) * width11; //   shifting numerator and
                    d31 *= width11; //   denominator and generating a
                    x41 = arc411.g(1); //   new least-significant-byte.
                }
                while(n31 >= overflow11){
                    // To avoid rounding up, before adding
                    n31 /= 2; //   last byte, shift everything
                    d31 /= 2; //   right using integer math until
                    x41 >>>= 1; //   we have exactly the desired bits.
                }
                return (n31 + x41) / d31; // Form the number within [0, 1).
            };
            prng11.int32 = function() {
                return arc411.g(4) | 0;
            };
            prng11.quick = function() {
                return arc411.g(4) / 0x100000000;
            };
            prng11["double"] = prng11; // Mix the randomness into accumulated entropy.
            mixkey11(tostring11(arc411.S), pool11); // Calling convention: what to return as a function of prng, seed, is_math.
            return (options11.pass || callback11 || function(prng11, seed11, is_math_call11, state11) {
                if (state11) {
                    // Load the arc4 state from the given state if it has an S array.
                    if (state11.S) copy11(state11, arc411);
                     // Only provide the .state method if requested via options.state.
                    prng11.state = function() {
                        return copy11(arc411, {});
                    };
                } // If called as a method of Math (Math.seedrandom()), mutate
                // Math.random because that is how seedrandom.js has worked since v1.0.
                if (is_math_call11) {
                    math11[rngname11] = prng11;
                    return seed11;
                } else return prng11;
            })(prng11, shortseed11, "global" in options11 ? options11.global : this == math11, options11.state);
        }
        math11["seed" + rngname11] = seedrandom11; //
        // ARC4
        //
        // An ARC4 implementation.  The constructor takes a key in the form of
        // an array of at most (width) integers that should be 0 <= x < (width).
        //
        // The g(count) method returns a pseudorandom integer that concatenates
        // the next (count) outputs from ARC4.  Its return value is a number x
        // that is in the range 0 <= x < (width ^ count).
        //
        function ARC411(key11) {
            var t31, keylen11 = key11.length, me11 = this, i31 = 0, j31 = me11.i = me11.j = 0, s41 = me11.S = []; // The empty key [] is treated as [0].
            if (!keylen11) key11 = [
                keylen11++
            ];
             // Set up S using the standard key scheduling algorithm.
            while(i31 < width11)s41[i31] = i31++;
            for(i31 = 0; i31 < width11; i31++){
                s41[i31] = s41[j31 = mask11 & j31 + key11[i31 % keylen11] + (t31 = s41[i31])];
                s41[j31] = t31;
            } // The "g" method returns the next (count) outputs as one number.
            me11.g = function(count11) {
                // Using instance members instead of closure state nearly doubles speed.
                var t31, r11 = 0, i31 = me11.i, j31 = me11.j, s41 = me11.S;
                while(count11--){
                    t31 = s41[i31 = mask11 & i31 + 1];
                    r11 = r11 * width11 + s41[mask11 & (s41[i31] = s41[j31 = mask11 & j31 + t31]) + (s41[j31] = t31)];
                }
                me11.i = i31;
                me11.j = j31;
                return r11; // For robust unpredictability, the function call below automatically
            // discards an initial batch of values.  This is called RC4-drop[256].
            // See http://google.com/search?q=rsa+fluhrer+response&btnI
            };
        } //
        // copy()
        // Copies internal state of ARC4 to or from a plain object.
        //
        function copy11(f31, t31) {
            t31.i = f31.i;
            t31.j = f31.j;
            t31.S = f31.S.slice();
            return t31;
        } //
        // flatten()
        // Converts an object tree to nested arrays of strings.
        //
        function flatten11(obj11, depth11) {
            var result11 = [], typ11 = _typeof$2(obj11), prop11;
            if (depth11 && typ11 == "object") {
                for(prop11 in obj11)try {
                    result11.push(flatten11(obj11[prop11], depth11 - 1));
                } catch (e31) {}
            }
            return result11.length ? result11 : typ11 == "string" ? obj11 : obj11 + "\x00";
        } //
        // mixkey()
        // Mixes a string seed into a key that is an array of integers, and
        // returns a shortened string seed that is equivalent to the result key.
        //
        function mixkey11(seed11, key11) {
            var stringseed11 = seed11 + "", smear11, j31 = 0;
            while(j31 < stringseed11.length)key11[mask11 & j31] = mask11 & (smear11 ^= key11[mask11 & j31] * 19) + stringseed11.charCodeAt(j31++);
            return tostring11(key11);
        } //
        // autoseed()
        // Returns an object for autoseeding, using window.crypto and Node crypto
        // module if available.
        //
        function autoseed11() {
            try {
                if (nodecrypto11) return tostring11(nodecrypto11.randomBytes(width11));
                var out11 = new Uint8Array(width11);
                (global11.crypto || global11.msCrypto).getRandomValues(out11);
                return tostring11(out11);
            } catch (e31) {
                var browser11 = global11.navigator, plugins11 = browser11 && browser11.plugins;
                return [
                    +new Date(),
                    global11,
                    plugins11,
                    global11.screen,
                    tostring11(pool11)
                ];
            }
        } //
        // tostring()
        // Converts an array of charcodes to a string
        //
        function tostring11(a31) {
            return String.fromCharCode.apply(0, a31);
        } //
        // When seedrandom.js is loaded, we immediately mix a few bits
        // from the built-in RNG into the entropy pool.  Because we do
        // not want to interfere with deterministic PRNG state later,
        // seedrandom will not call math.random on its own again after
        // initialization.
        //
        mixkey11(math11.random(), pool11); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
    }
    function initialize$2(BMMath11) {
        seedRandom([], BMMath11);
    }
    var propTypes = {
        SHAPE: "shape"
    };
    function _typeof$1(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof$1 = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof$1 = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof$1(obj11);
    }
    var ExpressionManager = function() {
        "use strict";
        var ob = {};
        var Math = BMMath;
        var window = null;
        var document = null;
        var XMLHttpRequest = null;
        var fetch = null;
        var frames = null;
        var _lottieGlobal = {};
        initialize$2(BMMath);
        function resetFrame() {
            _lottieGlobal = {};
        }
        function $bm_isInstanceOfArray(arr31) {
            return arr31.constructor === Array || arr31.constructor === Float32Array;
        }
        function isNumerable(tOfV11, v51) {
            return tOfV11 === "number" || tOfV11 === "boolean" || tOfV11 === "string" || v51 instanceof Number;
        }
        function $bm_neg(a31) {
            var tOfA11 = _typeof$1(a31);
            if (tOfA11 === "number" || tOfA11 === "boolean" || a31 instanceof Number) return -a31;
            if ($bm_isInstanceOfArray(a31)) {
                var i31;
                var lenA11 = a31.length;
                var retArr11 = [];
                for(i31 = 0; i31 < lenA11; i31 += 1)retArr11[i31] = -a31[i31];
                return retArr11;
            }
            if (a31.propType) return a31.v;
            return -a31;
        }
        var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get;
        var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get;
        var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
        function sum(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            if (tOfA11 === "string" || tOfB11 === "string") return a31 + b31;
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31)) return a31 + b31;
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                a31 = a31.slice(0);
                a31[0] += b31;
                return a31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                b31 = b31.slice(0);
                b31[0] = a31 + b31[0];
                return b31;
            }
            if ($bm_isInstanceOfArray(a31) && $bm_isInstanceOfArray(b31)) {
                var i31 = 0;
                var lenA11 = a31.length;
                var lenB11 = b31.length;
                var retArr11 = [];
                while(i31 < lenA11 || i31 < lenB11){
                    if ((typeof a31[i31] === "number" || a31[i31] instanceof Number) && (typeof b31[i31] === "number" || b31[i31] instanceof Number)) retArr11[i31] = a31[i31] + b31[i31];
                    else retArr11[i31] = b31[i31] === undefined ? a31[i31] : a31[i31] || b31[i31];
                    i31 += 1;
                }
                return retArr11;
            }
            return 0;
        }
        var add = sum;
        function sub(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31)) {
                if (tOfA11 === "string") a31 = parseInt(a31, 10);
                if (tOfB11 === "string") b31 = parseInt(b31, 10);
                return a31 - b31;
            }
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                a31 = a31.slice(0);
                a31[0] -= b31;
                return a31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                b31 = b31.slice(0);
                b31[0] = a31 - b31[0];
                return b31;
            }
            if ($bm_isInstanceOfArray(a31) && $bm_isInstanceOfArray(b31)) {
                var i31 = 0;
                var lenA11 = a31.length;
                var lenB11 = b31.length;
                var retArr11 = [];
                while(i31 < lenA11 || i31 < lenB11){
                    if ((typeof a31[i31] === "number" || a31[i31] instanceof Number) && (typeof b31[i31] === "number" || b31[i31] instanceof Number)) retArr11[i31] = a31[i31] - b31[i31];
                    else retArr11[i31] = b31[i31] === undefined ? a31[i31] : a31[i31] || b31[i31];
                    i31 += 1;
                }
                return retArr11;
            }
            return 0;
        }
        function mul(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            var arr31;
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31)) return a31 * b31;
            var i31;
            var len11;
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                len11 = a31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31[i31] * b31;
                return arr31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                len11 = b31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31 * b31[i31];
                return arr31;
            }
            return 0;
        }
        function div(a31, b31) {
            var tOfA11 = _typeof$1(a31);
            var tOfB11 = _typeof$1(b31);
            var arr31;
            if (isNumerable(tOfA11, a31) && isNumerable(tOfB11, b31)) return a31 / b31;
            var i31;
            var len11;
            if ($bm_isInstanceOfArray(a31) && isNumerable(tOfB11, b31)) {
                len11 = a31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31[i31] / b31;
                return arr31;
            }
            if (isNumerable(tOfA11, a31) && $bm_isInstanceOfArray(b31)) {
                len11 = b31.length;
                arr31 = createTypedArray("float32", len11);
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = a31 / b31[i31];
                return arr31;
            }
            return 0;
        }
        function mod(a31, b31) {
            if (typeof a31 === "string") a31 = parseInt(a31, 10);
            if (typeof b31 === "string") b31 = parseInt(b31, 10);
            return a31 % b31;
        }
        var $bm_sum = sum;
        var $bm_sub = sub;
        var $bm_mul = mul;
        var $bm_div = div;
        var $bm_mod = mod;
        function clamp(num11, min11, max11) {
            if (min11 > max11) {
                var mm11 = max11;
                max11 = min11;
                min11 = mm11;
            }
            return Math.min(Math.max(num11, min11), max11);
        }
        function radiansToDegrees(val31) {
            return val31 / degToRads;
        }
        var radians_to_degrees = radiansToDegrees;
        function degreesToRadians(val31) {
            return val31 * degToRads;
        }
        var degrees_to_radians = radiansToDegrees;
        var helperLengthArray = [
            0,
            0,
            0,
            0,
            0,
            0
        ];
        function length(arr111, arr211) {
            if (typeof arr111 === "number" || arr111 instanceof Number) {
                arr211 = arr211 || 0;
                return Math.abs(arr111 - arr211);
            }
            if (!arr211) arr211 = helperLengthArray;
            var i31;
            var len11 = Math.min(arr111.length, arr211.length);
            var addedLength11 = 0;
            for(i31 = 0; i31 < len11; i31 += 1)addedLength11 += Math.pow(arr211[i31] - arr111[i31], 2);
            return Math.sqrt(addedLength11);
        }
        function normalize(vec11) {
            return div(vec11, length(vec11));
        }
        function rgbToHsl(val31) {
            var r11 = val31[0];
            var g31 = val31[1];
            var b31 = val31[2];
            var max11 = Math.max(r11, g31, b31);
            var min11 = Math.min(r11, g31, b31);
            var h31;
            var s41;
            var l31 = (max11 + min11) / 2;
            if (max11 === min11) {
                h31 = 0; // achromatic
                s41 = 0; // achromatic
            } else {
                var d31 = max11 - min11;
                s41 = l31 > 0.5 ? d31 / (2 - max11 - min11) : d31 / (max11 + min11);
                switch(max11){
                    case r11:
                        h31 = (g31 - b31) / d31 + (g31 < b31 ? 6 : 0);
                        break;
                    case g31:
                        h31 = (b31 - r11) / d31 + 2;
                        break;
                    case b31:
                        h31 = (r11 - g31) / d31 + 4;
                        break;
                    default:
                        break;
                }
                h31 /= 6;
            }
            return [
                h31,
                s41,
                l31,
                val31[3]
            ];
        }
        function hue2rgb(p61, q11, t31) {
            if (t31 < 0) t31 += 1;
            if (t31 > 1) t31 -= 1;
            if (t31 < 1 / 6) return p61 + (q11 - p61) * 6 * t31;
            if (t31 < 0.5) return q11;
            if (t31 < 2 / 3) return p61 + (q11 - p61) * (2 / 3 - t31) * 6;
            return p61;
        }
        function hslToRgb(val31) {
            var h31 = val31[0];
            var s41 = val31[1];
            var l31 = val31[2];
            var r11;
            var g31;
            var b31;
            if (s41 === 0) {
                r11 = l31; // achromatic
                b31 = l31; // achromatic
                g31 = l31; // achromatic
            } else {
                var q11 = l31 < 0.5 ? l31 * (1 + s41) : l31 + s41 - l31 * s41;
                var p61 = 2 * l31 - q11;
                r11 = hue2rgb(p61, q11, h31 + 1 / 3);
                g31 = hue2rgb(p61, q11, h31);
                b31 = hue2rgb(p61, q11, h31 - 1 / 3);
            }
            return [
                r11,
                g31,
                b31,
                val31[3]
            ];
        }
        function linear(t31, tMin11, tMax11, value111, value211) {
            if (value111 === undefined || value211 === undefined) {
                value111 = tMin11;
                value211 = tMax11;
                tMin11 = 0;
                tMax11 = 1;
            }
            if (tMax11 < tMin11) {
                var _tMin11 = tMax11;
                tMax11 = tMin11;
                tMin11 = _tMin11;
            }
            if (t31 <= tMin11) return value111;
            if (t31 >= tMax11) return value211;
            var perc11 = tMax11 === tMin11 ? 0 : (t31 - tMin11) / (tMax11 - tMin11);
            if (!value111.length) return value111 + (value211 - value111) * perc11;
            var i31;
            var len11 = value111.length;
            var arr31 = createTypedArray("float32", len11);
            for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = value111[i31] + (value211[i31] - value111[i31]) * perc11;
            return arr31;
        }
        function random(min11, max11) {
            if (max11 === undefined) {
                if (min11 === undefined) {
                    min11 = 0;
                    max11 = 1;
                } else {
                    max11 = min11;
                    min11 = undefined;
                }
            }
            if (max11.length) {
                var i31;
                var len11 = max11.length;
                if (!min11) min11 = createTypedArray("float32", len11);
                var arr31 = createTypedArray("float32", len11);
                var rnd11 = BMMath.random();
                for(i31 = 0; i31 < len11; i31 += 1)arr31[i31] = min11[i31] + rnd11 * (max11[i31] - min11[i31]);
                return arr31;
            }
            if (min11 === undefined) min11 = 0;
            var rndm11 = BMMath.random();
            return min11 + rndm11 * (max11 - min11);
        }
        function createPath(points11, inTangents11, outTangents11, closed11) {
            var i31;
            var len11 = points11.length;
            var path11 = shapePool.newElement();
            path11.setPathData(!!closed11, len11);
            var arrPlaceholder11 = [
                0,
                0
            ];
            var inVertexPoint11;
            var outVertexPoint11;
            for(i31 = 0; i31 < len11; i31 += 1){
                inVertexPoint11 = inTangents11 && inTangents11[i31] ? inTangents11[i31] : arrPlaceholder11;
                outVertexPoint11 = outTangents11 && outTangents11[i31] ? outTangents11[i31] : arrPlaceholder11;
                path11.setTripleAt(points11[i31][0], points11[i31][1], outVertexPoint11[0] + points11[i31][0], outVertexPoint11[1] + points11[i31][1], inVertexPoint11[0] + points11[i31][0], inVertexPoint11[1] + points11[i31][1], i31, true);
            }
            return path11;
        }
        function initiateExpression(elem, data, property) {
            // Bail out if we don't want expressions
            function noOp(_value11) {
                return _value11;
            }
            if (!elem.globalData.renderConfig.runExpressions) return noOp;
            var val = data.x;
            var needsVelocity = /velocity(?![\w\d])/.test(val);
            var _needsRandom = val.indexOf("random") !== -1;
            var elemType = elem.data.ty;
            var transform;
            var $bm_transform;
            var content;
            var effect;
            var thisProperty = property;
            thisProperty.valueAtTime = thisProperty.getValueAtTime;
            Object.defineProperty(thisProperty, "value", {
                get: function get11() {
                    return thisProperty.v;
                }
            });
            elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
            elem.comp.displayStartTime = 0;
            var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
            var outPoint = elem.data.op / elem.comp.globalData.frameRate;
            var width = elem.data.sw ? elem.data.sw : 0;
            var height = elem.data.sh ? elem.data.sh : 0;
            var name = elem.data.nm;
            var loopIn;
            var loop_in;
            var loopOut;
            var loop_out;
            var smooth;
            var toWorld;
            var fromWorld;
            var fromComp;
            var toComp;
            var fromCompToSurface;
            var position;
            var rotation;
            var anchorPoint;
            var scale;
            var thisLayer;
            var thisComp;
            var mask;
            var valueAtTime;
            var velocityAtTime;
            var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls
            var expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0]; // eslint-disable-line no-eval
            var numKeys = property.kf ? data.k.length : 0;
            var active = !this.data || this.data.hd !== true;
            var wiggle = (function wiggle11(freq11, amp11) {
                var iWiggle11;
                var j31;
                var lenWiggle11 = this.pv.length ? this.pv.length : 1;
                var addedAmps11 = createTypedArray("float32", lenWiggle11);
                freq11 = 5;
                var iterations11 = Math.floor(time * freq11);
                iWiggle11 = 0;
                j31 = 0;
                while(iWiggle11 < iterations11){
                    // var rnd = BMMath.random();
                    for(j31 = 0; j31 < lenWiggle11; j31 += 1)addedAmps11[j31] += -amp11 + amp11 * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
                    iWiggle11 += 1;
                } // var rnd2 = BMMath.random();
                var periods11 = time * freq11;
                var perc11 = periods11 - Math.floor(periods11);
                var arr31 = createTypedArray("float32", lenWiggle11);
                if (lenWiggle11 > 1) {
                    for(j31 = 0; j31 < lenWiggle11; j31 += 1)arr31[j31] = this.pv[j31] + addedAmps11[j31] + (-amp11 + amp11 * 2 * BMMath.random()) * perc11; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
                    return arr31;
                }
                return this.pv + addedAmps11[0] + (-amp11 + amp11 * 2 * BMMath.random()) * perc11;
            }).bind(this);
            if (thisProperty.loopIn) {
                loopIn = thisProperty.loopIn.bind(thisProperty);
                loop_in = loopIn;
            }
            if (thisProperty.loopOut) {
                loopOut = thisProperty.loopOut.bind(thisProperty);
                loop_out = loopOut;
            }
            if (thisProperty.smooth) smooth = thisProperty.smooth.bind(thisProperty);
            function loopInDuration(type11, duration11) {
                return loopIn(type11, duration11, true);
            }
            function loopOutDuration(type11, duration11) {
                return loopOut(type11, duration11, true);
            }
            if (this.getValueAtTime) valueAtTime = this.getValueAtTime.bind(this);
            if (this.getVelocityAtTime) velocityAtTime = this.getVelocityAtTime.bind(this);
            var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
            function lookAt(elem111, elem211) {
                var fVec11 = [
                    elem211[0] - elem111[0],
                    elem211[1] - elem111[1],
                    elem211[2] - elem111[2]
                ];
                var pitch11 = Math.atan2(fVec11[0], Math.sqrt(fVec11[1] * fVec11[1] + fVec11[2] * fVec11[2])) / degToRads;
                var yaw11 = -Math.atan2(fVec11[1], fVec11[2]) / degToRads;
                return [
                    yaw11,
                    pitch11,
                    0
                ];
            }
            function easeOut(t31, tMin11, tMax11, val111, val211) {
                return applyEase(easeOutBez, t31, tMin11, tMax11, val111, val211);
            }
            function easeIn(t31, tMin11, tMax11, val111, val211) {
                return applyEase(easeInBez, t31, tMin11, tMax11, val111, val211);
            }
            function ease(t31, tMin11, tMax11, val111, val211) {
                return applyEase(easeInOutBez, t31, tMin11, tMax11, val111, val211);
            }
            function applyEase(fn11, t31, tMin11, tMax11, val111, val211) {
                if (val111 === undefined) {
                    val111 = tMin11;
                    val211 = tMax11;
                } else t31 = (t31 - tMin11) / (tMax11 - tMin11);
                if (t31 > 1) t31 = 1;
                else if (t31 < 0) t31 = 0;
                var mult11 = fn11(t31);
                if ($bm_isInstanceOfArray(val111)) {
                    var iKey11;
                    var lenKey11 = val111.length;
                    var arr31 = createTypedArray("float32", lenKey11);
                    for(iKey11 = 0; iKey11 < lenKey11; iKey11 += 1)arr31[iKey11] = (val211[iKey11] - val111[iKey11]) * mult11 + val111[iKey11];
                    return arr31;
                }
                return (val211 - val111) * mult11 + val111;
            }
            function nearestKey(time11) {
                var iKey11;
                var lenKey11 = data.k.length;
                var index11;
                var keyTime11;
                if (!data.k.length || typeof data.k[0] === "number") {
                    index11 = 0;
                    keyTime11 = 0;
                } else {
                    index11 = -1;
                    time11 *= elem.comp.globalData.frameRate;
                    if (time11 < data.k[0].t) {
                        index11 = 1;
                        keyTime11 = data.k[0].t;
                    } else {
                        for(iKey11 = 0; iKey11 < lenKey11 - 1; iKey11 += 1){
                            if (time11 === data.k[iKey11].t) {
                                index11 = iKey11 + 1;
                                keyTime11 = data.k[iKey11].t;
                                break;
                            } else if (time11 > data.k[iKey11].t && time11 < data.k[iKey11 + 1].t) {
                                if (time11 - data.k[iKey11].t > data.k[iKey11 + 1].t - time11) {
                                    index11 = iKey11 + 2;
                                    keyTime11 = data.k[iKey11 + 1].t;
                                } else {
                                    index11 = iKey11 + 1;
                                    keyTime11 = data.k[iKey11].t;
                                }
                                break;
                            }
                        }
                        if (index11 === -1) {
                            index11 = iKey11 + 1;
                            keyTime11 = data.k[iKey11].t;
                        }
                    }
                }
                var obKey11 = {};
                obKey11.index = index11;
                obKey11.time = keyTime11 / elem.comp.globalData.frameRate;
                return obKey11;
            }
            function key(ind11) {
                var obKey11;
                var iKey11;
                var lenKey11;
                if (!data.k.length || typeof data.k[0] === "number") throw new Error("The property has no keyframe at index " + ind11);
                ind11 -= 1;
                obKey11 = {
                    time: data.k[ind11].t / elem.comp.globalData.frameRate,
                    value: []
                };
                var arr31 = Object.prototype.hasOwnProperty.call(data.k[ind11], "s") ? data.k[ind11].s : data.k[ind11 - 1].e;
                lenKey11 = arr31.length;
                for(iKey11 = 0; iKey11 < lenKey11; iKey11 += 1){
                    obKey11[iKey11] = arr31[iKey11];
                    obKey11.value[iKey11] = arr31[iKey11];
                }
                return obKey11;
            }
            function framesToTime(fr11, fps11) {
                if (!fps11) fps11 = elem.comp.globalData.frameRate;
                return fr11 / fps11;
            }
            function timeToFrames(t31, fps11) {
                if (!t31 && t31 !== 0) t31 = time;
                if (!fps11) fps11 = elem.comp.globalData.frameRate;
                return t31 * fps11;
            }
            function seedRandom(seed11) {
                BMMath.seedrandom(randSeed + seed11);
            }
            function sourceRectAtTime() {
                return elem.sourceRectAtTime();
            }
            function substring(init11, end31) {
                if (typeof value === "string") {
                    if (end31 === undefined) return value.substring(init11);
                    return value.substring(init11, end31);
                }
                return "";
            }
            function substr(init11, end31) {
                if (typeof value === "string") {
                    if (end31 === undefined) return value.substr(init11);
                    return value.substr(init11, end31);
                }
                return "";
            }
            function posterizeTime(framesPerSecond11) {
                time = framesPerSecond11 === 0 ? 0 : Math.floor(time * framesPerSecond11) / framesPerSecond11;
                value = valueAtTime(time);
            }
            var time;
            var velocity;
            var value;
            var text;
            var textIndex;
            var textTotal;
            var selectorValue;
            var index = elem.data.ind;
            var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
            var parent;
            var randSeed = Math.floor(Math.random() * 1000000);
            var globalData = elem.globalData;
            function executeExpression(_value11) {
                // globalData.pushExpression();
                value = _value11;
                if (this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector") return value;
                if (this.propType === "textSelector") {
                    textIndex = this.textIndex;
                    textTotal = this.textTotal;
                    selectorValue = this.selectorValue;
                }
                if (!thisLayer) {
                    text = elem.layerInterface.text;
                    thisLayer = elem.layerInterface;
                    thisComp = elem.comp.compInterface;
                    toWorld = thisLayer.toWorld.bind(thisLayer);
                    fromWorld = thisLayer.fromWorld.bind(thisLayer);
                    fromComp = thisLayer.fromComp.bind(thisLayer);
                    toComp = thisLayer.toComp.bind(thisLayer);
                    mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
                    fromCompToSurface = fromComp;
                }
                if (!transform) {
                    transform = elem.layerInterface("ADBE Transform Group");
                    $bm_transform = transform;
                    if (transform) anchorPoint = transform.anchorPoint;
                }
                if (elemType === 4 && !content) content = thisLayer("ADBE Root Vectors Group");
                if (!effect) effect = thisLayer(4);
                hasParent = !!(elem.hierarchy && elem.hierarchy.length);
                if (hasParent && !parent) parent = elem.hierarchy[0].layerInterface;
                time = this.comp.renderedFrame / this.comp.globalData.frameRate;
                if (_needsRandom) seedRandom(randSeed + time);
                if (needsVelocity) velocity = velocityAtTime(time);
                expression_function();
                this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
                // Changed this to a ternary operation because Rollup failed compiling it correctly
                scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
                return scoped_bm_rt;
            } // Bundlers will see these as dead code and unless we reference them
            executeExpression.__preventDeadCodeRemoval = [
                $bm_transform,
                anchorPoint,
                time,
                velocity,
                inPoint,
                outPoint,
                width,
                height,
                name,
                loop_in,
                loop_out,
                smooth,
                toComp,
                fromCompToSurface,
                toWorld,
                fromWorld,
                mask,
                position,
                rotation,
                scale,
                thisComp,
                numKeys,
                active,
                wiggle,
                loopInDuration,
                loopOutDuration,
                comp,
                lookAt,
                easeOut,
                easeIn,
                ease,
                nearestKey,
                key,
                text,
                textIndex,
                textTotal,
                selectorValue,
                framesToTime,
                timeToFrames,
                sourceRectAtTime,
                substring,
                substr,
                posterizeTime,
                index,
                globalData
            ];
            return executeExpression;
        }
        ob.initiateExpression = initiateExpression;
        ob.__preventDeadCodeRemoval = [
            window,
            document,
            XMLHttpRequest,
            fetch,
            frames,
            $bm_neg,
            add,
            $bm_sum,
            $bm_sub,
            $bm_mul,
            $bm_div,
            $bm_mod,
            clamp,
            radians_to_degrees,
            degreesToRadians,
            degrees_to_radians,
            normalize,
            rgbToHsl,
            hslToRgb,
            linear,
            random,
            createPath,
            _lottieGlobal
        ];
        ob.resetFrame = resetFrame;
        return ob;
    }();
    var Expressions = function() {
        var ob11 = {};
        ob11.initExpressions = initExpressions11;
        ob11.resetFrame = ExpressionManager.resetFrame;
        function initExpressions11(animation11) {
            var stackCount11 = 0;
            var registers11 = [];
            function pushExpression11() {
                stackCount11 += 1;
            }
            function popExpression11() {
                stackCount11 -= 1;
                if (stackCount11 === 0) releaseInstances11();
            }
            function registerExpressionProperty11(expression11) {
                if (registers11.indexOf(expression11) === -1) registers11.push(expression11);
            }
            function releaseInstances11() {
                var i31;
                var len11 = registers11.length;
                for(i31 = 0; i31 < len11; i31 += 1)registers11[i31].release();
                registers11.length = 0;
            }
            animation11.renderer.compInterface = CompExpressionInterface(animation11.renderer);
            animation11.renderer.globalData.projectInterface.registerComposition(animation11.renderer);
            animation11.renderer.globalData.pushExpression = pushExpression11;
            animation11.renderer.globalData.popExpression = popExpression11;
            animation11.renderer.globalData.registerExpressionProperty = registerExpressionProperty11;
        }
        return ob11;
    }();
    var MaskManagerInterface = function() {
        function MaskInterface11(mask11, data11) {
            this._mask = mask11;
            this._data = data11;
        }
        Object.defineProperty(MaskInterface11.prototype, "maskPath", {
            get: function get11() {
                if (this._mask.prop.k) this._mask.prop.getValue();
                return this._mask.prop;
            }
        });
        Object.defineProperty(MaskInterface11.prototype, "maskOpacity", {
            get: function get11() {
                if (this._mask.op.k) this._mask.op.getValue();
                return this._mask.op.v * 100;
            }
        });
        var MaskManager11 = function MaskManager11(maskManager11) {
            var _masksInterfaces11 = createSizedArray(maskManager11.viewData.length);
            var i31;
            var len11 = maskManager11.viewData.length;
            for(i31 = 0; i31 < len11; i31 += 1)_masksInterfaces11[i31] = new MaskInterface11(maskManager11.viewData[i31], maskManager11.masksProperties[i31]);
            var maskFunction11 = function maskFunction11(name11) {
                i31 = 0;
                while(i31 < len11){
                    if (maskManager11.masksProperties[i31].nm === name11) return _masksInterfaces11[i31];
                    i31 += 1;
                }
                return null;
            };
            return maskFunction11;
        };
        return MaskManager11;
    }();
    var ExpressionPropertyInterface = function() {
        var defaultUnidimensionalValue11 = {
            pv: 0,
            v: 0,
            mult: 1
        };
        var defaultMultidimensionalValue11 = {
            pv: [
                0,
                0,
                0
            ],
            v: [
                0,
                0,
                0
            ],
            mult: 1
        };
        function completeProperty11(expressionValue11, property11, type11) {
            Object.defineProperty(expressionValue11, "velocity", {
                get: function get11() {
                    return property11.getVelocityAtTime(property11.comp.currentFrame);
                }
            });
            expressionValue11.numKeys = property11.keyframes ? property11.keyframes.length : 0;
            expressionValue11.key = function(pos11) {
                if (!expressionValue11.numKeys) return 0;
                var value31 = "";
                if ("s" in property11.keyframes[pos11 - 1]) value31 = property11.keyframes[pos11 - 1].s;
                else if ("e" in property11.keyframes[pos11 - 2]) value31 = property11.keyframes[pos11 - 2].e;
                else value31 = property11.keyframes[pos11 - 2].s;
                var valueProp11 = type11 === "unidimensional" ? new Number(value31) : Object.assign({}, value31); // eslint-disable-line no-new-wrappers
                valueProp11.time = property11.keyframes[pos11 - 1].t / property11.elem.comp.globalData.frameRate;
                valueProp11.value = type11 === "unidimensional" ? value31[0] : value31;
                return valueProp11;
            };
            expressionValue11.valueAtTime = property11.getValueAtTime;
            expressionValue11.speedAtTime = property11.getSpeedAtTime;
            expressionValue11.velocityAtTime = property11.getVelocityAtTime;
            expressionValue11.propertyGroup = property11.propertyGroup;
        }
        function UnidimensionalPropertyInterface11(property11) {
            if (!property11 || !("pv" in property11)) property11 = defaultUnidimensionalValue11;
            var mult11 = 1 / property11.mult;
            var val31 = property11.pv * mult11;
            var expressionValue11 = new Number(val31); // eslint-disable-line no-new-wrappers
            expressionValue11.value = val31;
            completeProperty11(expressionValue11, property11, "unidimensional");
            return function() {
                if (property11.k) property11.getValue();
                val31 = property11.v * mult11;
                if (expressionValue11.value !== val31) {
                    expressionValue11 = new Number(val31); // eslint-disable-line no-new-wrappers
                    expressionValue11.value = val31;
                    completeProperty11(expressionValue11, property11, "unidimensional");
                }
                return expressionValue11;
            };
        }
        function MultidimensionalPropertyInterface11(property11) {
            if (!property11 || !("pv" in property11)) property11 = defaultMultidimensionalValue11;
            var mult11 = 1 / property11.mult;
            var len11 = property11.data && property11.data.l || property11.pv.length;
            var expressionValue11 = createTypedArray("float32", len11);
            var arrValue11 = createTypedArray("float32", len11);
            expressionValue11.value = arrValue11;
            completeProperty11(expressionValue11, property11, "multidimensional");
            return function() {
                if (property11.k) property11.getValue();
                for(var i31 = 0; i31 < len11; i31 += 1){
                    arrValue11[i31] = property11.v[i31] * mult11;
                    expressionValue11[i31] = arrValue11[i31];
                }
                return expressionValue11;
            };
        } // TODO: try to avoid using this getter
        function defaultGetter11() {
            return defaultUnidimensionalValue11;
        }
        return function(property11) {
            if (!property11) return defaultGetter11;
            if (property11.propType === "unidimensional") return UnidimensionalPropertyInterface11(property11);
            return MultidimensionalPropertyInterface11(property11);
        };
    }();
    var TransformExpressionInterface = function() {
        return function(transform11) {
            function _thisFunction11(name11) {
                switch(name11){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return _thisFunction11.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return _thisFunction11.rotation;
                    case "ADBE Rotate X":
                        return _thisFunction11.xRotation;
                    case "ADBE Rotate Y":
                        return _thisFunction11.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return _thisFunction11.position;
                    case "ADBE Position_0":
                        return _thisFunction11.xPosition;
                    case "ADBE Position_1":
                        return _thisFunction11.yPosition;
                    case "ADBE Position_2":
                        return _thisFunction11.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return _thisFunction11.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return _thisFunction11.opacity;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisFunction11, "rotation", {
                get: ExpressionPropertyInterface(transform11.r || transform11.rz)
            });
            Object.defineProperty(_thisFunction11, "zRotation", {
                get: ExpressionPropertyInterface(transform11.rz || transform11.r)
            });
            Object.defineProperty(_thisFunction11, "xRotation", {
                get: ExpressionPropertyInterface(transform11.rx)
            });
            Object.defineProperty(_thisFunction11, "yRotation", {
                get: ExpressionPropertyInterface(transform11.ry)
            });
            Object.defineProperty(_thisFunction11, "scale", {
                get: ExpressionPropertyInterface(transform11.s)
            });
            var _px11;
            var _py11;
            var _pz11;
            var _transformFactory11;
            if (transform11.p) _transformFactory11 = ExpressionPropertyInterface(transform11.p);
            else {
                _px11 = ExpressionPropertyInterface(transform11.px);
                _py11 = ExpressionPropertyInterface(transform11.py);
                if (transform11.pz) _pz11 = ExpressionPropertyInterface(transform11.pz);
            }
            Object.defineProperty(_thisFunction11, "position", {
                get: function get11() {
                    if (transform11.p) return _transformFactory11();
                    return [
                        _px11(),
                        _py11(),
                        _pz11 ? _pz11() : 0
                    ];
                }
            });
            Object.defineProperty(_thisFunction11, "xPosition", {
                get: ExpressionPropertyInterface(transform11.px)
            });
            Object.defineProperty(_thisFunction11, "yPosition", {
                get: ExpressionPropertyInterface(transform11.py)
            });
            Object.defineProperty(_thisFunction11, "zPosition", {
                get: ExpressionPropertyInterface(transform11.pz)
            });
            Object.defineProperty(_thisFunction11, "anchorPoint", {
                get: ExpressionPropertyInterface(transform11.a)
            });
            Object.defineProperty(_thisFunction11, "opacity", {
                get: ExpressionPropertyInterface(transform11.o)
            });
            Object.defineProperty(_thisFunction11, "skew", {
                get: ExpressionPropertyInterface(transform11.sk)
            });
            Object.defineProperty(_thisFunction11, "skewAxis", {
                get: ExpressionPropertyInterface(transform11.sa)
            });
            Object.defineProperty(_thisFunction11, "orientation", {
                get: ExpressionPropertyInterface(transform11.or)
            });
            return _thisFunction11;
        };
    }();
    var LayerExpressionInterface = function() {
        function getMatrix11(time11) {
            var toWorldMat11 = new Matrix();
            if (time11 !== undefined) {
                var propMatrix11 = this._elem.finalTransform.mProp.getValueAtTime(time11);
                propMatrix11.clone(toWorldMat11);
            } else {
                var transformMat11 = this._elem.finalTransform.mProp;
                transformMat11.applyToMatrix(toWorldMat11);
            }
            return toWorldMat11;
        }
        function toWorldVec11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            toWorldMat11.props[12] = 0;
            toWorldMat11.props[13] = 0;
            toWorldMat11.props[14] = 0;
            return this.applyPoint(toWorldMat11, arr31);
        }
        function toWorld11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            return this.applyPoint(toWorldMat11, arr31);
        }
        function fromWorldVec11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            toWorldMat11.props[12] = 0;
            toWorldMat11.props[13] = 0;
            toWorldMat11.props[14] = 0;
            return this.invertPoint(toWorldMat11, arr31);
        }
        function fromWorld11(arr31, time11) {
            var toWorldMat11 = this.getMatrix(time11);
            return this.invertPoint(toWorldMat11, arr31);
        }
        function applyPoint11(matrix11, arr31) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i31;
                var len11 = this._elem.hierarchy.length;
                for(i31 = 0; i31 < len11; i31 += 1)this._elem.hierarchy[i31].finalTransform.mProp.applyToMatrix(matrix11);
            }
            return matrix11.applyToPointArray(arr31[0], arr31[1], arr31[2] || 0);
        }
        function invertPoint11(matrix11, arr31) {
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i31;
                var len11 = this._elem.hierarchy.length;
                for(i31 = 0; i31 < len11; i31 += 1)this._elem.hierarchy[i31].finalTransform.mProp.applyToMatrix(matrix11);
            }
            return matrix11.inversePoint(arr31);
        }
        function fromComp11(arr31) {
            var toWorldMat11 = new Matrix();
            toWorldMat11.reset();
            this._elem.finalTransform.mProp.applyToMatrix(toWorldMat11);
            if (this._elem.hierarchy && this._elem.hierarchy.length) {
                var i31;
                var len11 = this._elem.hierarchy.length;
                for(i31 = 0; i31 < len11; i31 += 1)this._elem.hierarchy[i31].finalTransform.mProp.applyToMatrix(toWorldMat11);
                return toWorldMat11.inversePoint(arr31);
            }
            return toWorldMat11.inversePoint(arr31);
        }
        function sampleImage11() {
            return [
                1,
                1,
                1,
                1
            ];
        }
        return function(elem31) {
            var transformInterface11;
            function _registerMaskInterface11(maskManager11) {
                _thisLayerFunction11.mask = new MaskManagerInterface(maskManager11, elem31);
            }
            function _registerEffectsInterface11(effects11) {
                _thisLayerFunction11.effect = effects11;
            }
            function _thisLayerFunction11(name11) {
                switch(name11){
                    case "ADBE Root Vectors Group":
                    case "Contents":
                    case 2:
                        return _thisLayerFunction11.shapeInterface;
                    case 1:
                    case 6:
                    case "Transform":
                    case "transform":
                    case "ADBE Transform Group":
                        return transformInterface11;
                    case 4:
                    case "ADBE Effect Parade":
                    case "effects":
                    case "Effects":
                        return _thisLayerFunction11.effect;
                    case "ADBE Text Properties":
                        return _thisLayerFunction11.textInterface;
                    default:
                        return null;
                }
            }
            _thisLayerFunction11.getMatrix = getMatrix11;
            _thisLayerFunction11.invertPoint = invertPoint11;
            _thisLayerFunction11.applyPoint = applyPoint11;
            _thisLayerFunction11.toWorld = toWorld11;
            _thisLayerFunction11.toWorldVec = toWorldVec11;
            _thisLayerFunction11.fromWorld = fromWorld11;
            _thisLayerFunction11.fromWorldVec = fromWorldVec11;
            _thisLayerFunction11.toComp = toWorld11;
            _thisLayerFunction11.fromComp = fromComp11;
            _thisLayerFunction11.sampleImage = sampleImage11;
            _thisLayerFunction11.sourceRectAtTime = elem31.sourceRectAtTime.bind(elem31);
            _thisLayerFunction11._elem = elem31;
            transformInterface11 = TransformExpressionInterface(elem31.finalTransform.mProp);
            var anchorPointDescriptor11 = getDescriptor(transformInterface11, "anchorPoint");
            Object.defineProperties(_thisLayerFunction11, {
                hasParent: {
                    get: function get11() {
                        return elem31.hierarchy.length;
                    }
                },
                parent: {
                    get: function get11() {
                        return elem31.hierarchy[0].layerInterface;
                    }
                },
                rotation: getDescriptor(transformInterface11, "rotation"),
                scale: getDescriptor(transformInterface11, "scale"),
                position: getDescriptor(transformInterface11, "position"),
                opacity: getDescriptor(transformInterface11, "opacity"),
                anchorPoint: anchorPointDescriptor11,
                anchor_point: anchorPointDescriptor11,
                transform: {
                    get: function get11() {
                        return transformInterface11;
                    }
                },
                active: {
                    get: function get11() {
                        return elem31.isInRange;
                    }
                }
            });
            _thisLayerFunction11.startTime = elem31.data.st;
            _thisLayerFunction11.index = elem31.data.ind;
            _thisLayerFunction11.source = elem31.data.refId;
            _thisLayerFunction11.height = elem31.data.ty === 0 ? elem31.data.h : 100;
            _thisLayerFunction11.width = elem31.data.ty === 0 ? elem31.data.w : 100;
            _thisLayerFunction11.inPoint = elem31.data.ip / elem31.comp.globalData.frameRate;
            _thisLayerFunction11.outPoint = elem31.data.op / elem31.comp.globalData.frameRate;
            _thisLayerFunction11._name = elem31.data.nm;
            _thisLayerFunction11.registerMaskInterface = _registerMaskInterface11;
            _thisLayerFunction11.registerEffectsInterface = _registerEffectsInterface11;
            return _thisLayerFunction11;
        };
    }();
    var propertyGroupFactory = function() {
        return function(interfaceFunction11, parentPropertyGroup11) {
            return function(val31) {
                val31 = val31 === undefined ? 1 : val31;
                if (val31 <= 0) return interfaceFunction11;
                return parentPropertyGroup11(val31 - 1);
            };
        };
    }();
    var PropertyInterface = function() {
        return function(propertyName11, propertyGroup11) {
            var interfaceFunction11 = {
                _name: propertyName11
            };
            function _propertyGroup11(val31) {
                val31 = val31 === undefined ? 1 : val31;
                if (val31 <= 0) return interfaceFunction11;
                return propertyGroup11(val31 - 1);
            }
            return _propertyGroup11;
        };
    }();
    var EffectsExpressionInterface = function() {
        var ob11 = {
            createEffectsInterface: createEffectsInterface11
        };
        function createEffectsInterface11(elem31, propertyGroup11) {
            if (elem31.effectsManager) {
                var effectElements11 = [];
                var effectsData11 = elem31.data.ef;
                var i31;
                var len11 = elem31.effectsManager.effectElements.length;
                for(i31 = 0; i31 < len11; i31 += 1)effectElements11.push(createGroupInterface11(effectsData11[i31], elem31.effectsManager.effectElements[i31], propertyGroup11, elem31));
                var effects11 = elem31.data.ef || [];
                var groupInterface11 = function groupInterface11(name11) {
                    i31 = 0;
                    len11 = effects11.length;
                    while(i31 < len11){
                        if (name11 === effects11[i31].nm || name11 === effects11[i31].mn || name11 === effects11[i31].ix) return effectElements11[i31];
                        i31 += 1;
                    }
                    return null;
                };
                Object.defineProperty(groupInterface11, "numProperties", {
                    get: function get11() {
                        return effects11.length;
                    }
                });
                return groupInterface11;
            }
            return null;
        }
        function createGroupInterface11(data11, elements11, propertyGroup11, elem31) {
            function groupInterface11(name11) {
                var effects11 = data11.ef;
                var i31 = 0;
                var len11 = effects11.length;
                while(i31 < len11){
                    if (name11 === effects11[i31].nm || name11 === effects11[i31].mn || name11 === effects11[i31].ix) {
                        if (effects11[i31].ty === 5) return effectElements11[i31];
                        return effectElements11[i31]();
                    }
                    i31 += 1;
                }
                throw new Error();
            }
            var _propertyGroup11 = propertyGroupFactory(groupInterface11, propertyGroup11);
            var effectElements11 = [];
            var i31;
            var len11 = data11.ef.length;
            for(i31 = 0; i31 < len11; i31 += 1)if (data11.ef[i31].ty === 5) effectElements11.push(createGroupInterface11(data11.ef[i31], elements11.effectElements[i31], elements11.effectElements[i31].propertyGroup, elem31));
            else effectElements11.push(createValueInterface11(elements11.effectElements[i31], data11.ef[i31].ty, elem31, _propertyGroup11));
            if (data11.mn === "ADBE Color Control") Object.defineProperty(groupInterface11, "color", {
                get: function get11() {
                    return effectElements11[0]();
                }
            });
            Object.defineProperties(groupInterface11, {
                numProperties: {
                    get: function get11() {
                        return data11.np;
                    }
                },
                _name: {
                    value: data11.nm
                },
                propertyGroup: {
                    value: _propertyGroup11
                }
            });
            groupInterface11.enabled = data11.en !== 0;
            groupInterface11.active = groupInterface11.enabled;
            return groupInterface11;
        }
        function createValueInterface11(element11, type11, elem31, propertyGroup11) {
            var expressionProperty11 = ExpressionPropertyInterface(element11.p);
            function interfaceFunction11() {
                if (type11 === 10) return elem31.comp.compInterface(element11.p.v);
                return expressionProperty11();
            }
            if (element11.p.setGroupProperty) element11.p.setGroupProperty(PropertyInterface("", propertyGroup11));
            return interfaceFunction11;
        }
        return ob11;
    }();
    var ShapePathInterface = function() {
        return function pathInterfaceFactory11(shape31, view11, propertyGroup11) {
            var prop11 = view11.sh;
            function interfaceFunction11(val31) {
                if (val31 === "Shape" || val31 === "shape" || val31 === "Path" || val31 === "path" || val31 === "ADBE Vector Shape" || val31 === 2) return interfaceFunction11.path;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            prop11.setGroupProperty(PropertyInterface("Path", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                path: {
                    get: function get11() {
                        if (prop11.k) prop11.getValue();
                        return prop11;
                    }
                },
                shape: {
                    get: function get11() {
                        if (prop11.k) prop11.getValue();
                        return prop11;
                    }
                },
                _name: {
                    value: shape31.nm
                },
                ix: {
                    value: shape31.ix
                },
                propertyIndex: {
                    value: shape31.ix
                },
                mn: {
                    value: shape31.mn
                },
                propertyGroup: {
                    value: propertyGroup11
                }
            });
            return interfaceFunction11;
        };
    }();
    var ShapeExpressionInterface = function() {
        function iterateElements11(shapes11, view11, propertyGroup11) {
            var arr31 = [];
            var i31;
            var len11 = shapes11 ? shapes11.length : 0;
            for(i31 = 0; i31 < len11; i31 += 1){
                if (shapes11[i31].ty === "gr") arr31.push(groupInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "fl") arr31.push(fillInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "st") arr31.push(strokeInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "tm") arr31.push(trimInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "tr") ;
                else if (shapes11[i31].ty === "el") arr31.push(ellipseInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "sr") arr31.push(starInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "sh") arr31.push(ShapePathInterface(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "rc") arr31.push(rectInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "rd") arr31.push(roundedInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "rp") arr31.push(repeaterInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else if (shapes11[i31].ty === "gf") arr31.push(gradientFillInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
                else arr31.push(defaultInterfaceFactory11(shapes11[i31], view11[i31], propertyGroup11));
            }
            return arr31;
        }
        function contentsInterfaceFactory11(shape31, view11, propertyGroup11) {
            var interfaces11;
            var interfaceFunction11 = function _interfaceFunction11(value31) {
                var i31 = 0;
                var len11 = interfaces11.length;
                while(i31 < len11){
                    if (interfaces11[i31]._name === value31 || interfaces11[i31].mn === value31 || interfaces11[i31].propertyIndex === value31 || interfaces11[i31].ix === value31 || interfaces11[i31].ind === value31) return interfaces11[i31];
                    i31 += 1;
                }
                if (typeof value31 === "number") return interfaces11[value31 - 1];
                return null;
            };
            interfaceFunction11.propertyGroup = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            interfaces11 = iterateElements11(shape31.it, view11.it, interfaceFunction11.propertyGroup);
            interfaceFunction11.numProperties = interfaces11.length;
            var transformInterface11 = transformInterfaceFactory11(shape31.it[shape31.it.length - 1], view11.it[view11.it.length - 1], interfaceFunction11.propertyGroup);
            interfaceFunction11.transform = transformInterface11;
            interfaceFunction11.propertyIndex = shape31.cix;
            interfaceFunction11._name = shape31.nm;
            return interfaceFunction11;
        }
        function groupInterfaceFactory11(shape31, view11, propertyGroup11) {
            var interfaceFunction11 = function _interfaceFunction11(value31) {
                switch(value31){
                    case "ADBE Vectors Group":
                    case "Contents":
                    case 2:
                        return interfaceFunction11.content;
                    // Not necessary for now. Keeping them here in case a new case appears
                    // case 'ADBE Vector Transform Group':
                    // case 3:
                    default:
                        return interfaceFunction11.transform;
                }
            };
            interfaceFunction11.propertyGroup = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var content11 = contentsInterfaceFactory11(shape31, view11, interfaceFunction11.propertyGroup);
            var transformInterface11 = transformInterfaceFactory11(shape31.it[shape31.it.length - 1], view11.it[view11.it.length - 1], interfaceFunction11.propertyGroup);
            interfaceFunction11.content = content11;
            interfaceFunction11.transform = transformInterface11;
            Object.defineProperty(interfaceFunction11, "_name", {
                get: function get11() {
                    return shape31.nm;
                }
            }); // interfaceFunction.content = interfaceFunction;
            interfaceFunction11.numProperties = shape31.np;
            interfaceFunction11.propertyIndex = shape31.ix;
            interfaceFunction11.nm = shape31.nm;
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function fillInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(val31) {
                if (val31 === "Color" || val31 === "color") return interfaceFunction11.color;
                if (val31 === "Opacity" || val31 === "opacity") return interfaceFunction11.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction11, {
                color: {
                    get: ExpressionPropertyInterface(view11.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                _name: {
                    value: shape31.nm
                },
                mn: {
                    value: shape31.mn
                }
            });
            view11.c.setGroupProperty(PropertyInterface("Color", propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup11));
            return interfaceFunction11;
        }
        function gradientFillInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(val31) {
                if (val31 === "Start Point" || val31 === "start point") return interfaceFunction11.startPoint;
                if (val31 === "End Point" || val31 === "end point") return interfaceFunction11.endPoint;
                if (val31 === "Opacity" || val31 === "opacity") return interfaceFunction11.opacity;
                return null;
            }
            Object.defineProperties(interfaceFunction11, {
                startPoint: {
                    get: ExpressionPropertyInterface(view11.s)
                },
                endPoint: {
                    get: ExpressionPropertyInterface(view11.e)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                type: {
                    get: function get11() {
                        return "a";
                    }
                },
                _name: {
                    value: shape31.nm
                },
                mn: {
                    value: shape31.mn
                }
            });
            view11.s.setGroupProperty(PropertyInterface("Start Point", propertyGroup11));
            view11.e.setGroupProperty(PropertyInterface("End Point", propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Opacity", propertyGroup11));
            return interfaceFunction11;
        }
        function defaultInterfaceFactory11() {
            function interfaceFunction11() {
                return null;
            }
            return interfaceFunction11;
        }
        function strokeInterfaceFactory11(shape31, view11, propertyGroup11) {
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var _dashPropertyGroup11 = propertyGroupFactory(dashOb11, _propertyGroup11);
            function addPropertyToDashOb11(i31) {
                Object.defineProperty(dashOb11, shape31.d[i31].nm, {
                    get: ExpressionPropertyInterface(view11.d.dataProps[i31].p)
                });
            }
            var i31;
            var len11 = shape31.d ? shape31.d.length : 0;
            var dashOb11 = {};
            for(i31 = 0; i31 < len11; i31 += 1){
                addPropertyToDashOb11(i31);
                view11.d.dataProps[i31].p.setGroupProperty(_dashPropertyGroup11);
            }
            function interfaceFunction11(val31) {
                if (val31 === "Color" || val31 === "color") return interfaceFunction11.color;
                if (val31 === "Opacity" || val31 === "opacity") return interfaceFunction11.opacity;
                if (val31 === "Stroke Width" || val31 === "stroke width") return interfaceFunction11.strokeWidth;
                return null;
            }
            Object.defineProperties(interfaceFunction11, {
                color: {
                    get: ExpressionPropertyInterface(view11.c)
                },
                opacity: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                strokeWidth: {
                    get: ExpressionPropertyInterface(view11.w)
                },
                dash: {
                    get: function get11() {
                        return dashOb11;
                    }
                },
                _name: {
                    value: shape31.nm
                },
                mn: {
                    value: shape31.mn
                }
            });
            view11.c.setGroupProperty(PropertyInterface("Color", _propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup11));
            view11.w.setGroupProperty(PropertyInterface("Stroke Width", _propertyGroup11));
            return interfaceFunction11;
        }
        function trimInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(val31) {
                if (val31 === shape31.e.ix || val31 === "End" || val31 === "end") return interfaceFunction11.end;
                if (val31 === shape31.s.ix) return interfaceFunction11.start;
                if (val31 === shape31.o.ix) return interfaceFunction11.offset;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            interfaceFunction11.propertyIndex = shape31.ix;
            view11.s.setGroupProperty(PropertyInterface("Start", _propertyGroup11));
            view11.e.setGroupProperty(PropertyInterface("End", _propertyGroup11));
            view11.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup11));
            interfaceFunction11.propertyIndex = shape31.ix;
            interfaceFunction11.propertyGroup = propertyGroup11;
            Object.defineProperties(interfaceFunction11, {
                start: {
                    get: ExpressionPropertyInterface(view11.s)
                },
                end: {
                    get: ExpressionPropertyInterface(view11.e)
                },
                offset: {
                    get: ExpressionPropertyInterface(view11.o)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function transformInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.a.ix === value31 || value31 === "Anchor Point") return interfaceFunction11.anchorPoint;
                if (shape31.o.ix === value31 || value31 === "Opacity") return interfaceFunction11.opacity;
                if (shape31.p.ix === value31 || value31 === "Position") return interfaceFunction11.position;
                if (shape31.r.ix === value31 || value31 === "Rotation" || value31 === "ADBE Vector Rotation") return interfaceFunction11.rotation;
                if (shape31.s.ix === value31 || value31 === "Scale") return interfaceFunction11.scale;
                if (shape31.sk && shape31.sk.ix === value31 || value31 === "Skew") return interfaceFunction11.skew;
                if (shape31.sa && shape31.sa.ix === value31 || value31 === "Skew Axis") return interfaceFunction11.skewAxis;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            view11.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", _propertyGroup11));
            view11.transform.mProps.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            view11.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", _propertyGroup11));
            view11.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", _propertyGroup11));
            view11.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup11));
            if (view11.transform.mProps.sk) {
                view11.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", _propertyGroup11));
                view11.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", _propertyGroup11));
            }
            view11.transform.op.setGroupProperty(PropertyInterface("Opacity", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                opacity: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.o)
                },
                position: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.p)
                },
                anchorPoint: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.a)
                },
                scale: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.s)
                },
                rotation: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.r)
                },
                skew: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.sk)
                },
                skewAxis: {
                    get: ExpressionPropertyInterface(view11.transform.mProps.sa)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.ty = "tr";
            interfaceFunction11.mn = shape31.mn;
            interfaceFunction11.propertyGroup = propertyGroup11;
            return interfaceFunction11;
        }
        function ellipseInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.p.ix === value31) return interfaceFunction11.position;
                if (shape31.s.ix === value31) return interfaceFunction11.size;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            interfaceFunction11.propertyIndex = shape31.ix;
            var prop11 = view11.sh.ty === "tm" ? view11.sh.prop : view11.sh;
            prop11.s.setGroupProperty(PropertyInterface("Size", _propertyGroup11));
            prop11.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                size: {
                    get: ExpressionPropertyInterface(prop11.s)
                },
                position: {
                    get: ExpressionPropertyInterface(prop11.p)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function starInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.p.ix === value31) return interfaceFunction11.position;
                if (shape31.r.ix === value31) return interfaceFunction11.rotation;
                if (shape31.pt.ix === value31) return interfaceFunction11.points;
                if (shape31.or.ix === value31 || value31 === "ADBE Vector Star Outer Radius") return interfaceFunction11.outerRadius;
                if (shape31.os.ix === value31) return interfaceFunction11.outerRoundness;
                if (shape31.ir && (shape31.ir.ix === value31 || value31 === "ADBE Vector Star Inner Radius")) return interfaceFunction11.innerRadius;
                if (shape31.is && shape31.is.ix === value31) return interfaceFunction11.innerRoundness;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11.sh.ty === "tm" ? view11.sh.prop : view11.sh;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.or.setGroupProperty(PropertyInterface("Outer Radius", _propertyGroup11));
            prop11.os.setGroupProperty(PropertyInterface("Outer Roundness", _propertyGroup11));
            prop11.pt.setGroupProperty(PropertyInterface("Points", _propertyGroup11));
            prop11.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            prop11.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup11));
            if (shape31.ir) {
                prop11.ir.setGroupProperty(PropertyInterface("Inner Radius", _propertyGroup11));
                prop11.is.setGroupProperty(PropertyInterface("Inner Roundness", _propertyGroup11));
            }
            Object.defineProperties(interfaceFunction11, {
                position: {
                    get: ExpressionPropertyInterface(prop11.p)
                },
                rotation: {
                    get: ExpressionPropertyInterface(prop11.r)
                },
                points: {
                    get: ExpressionPropertyInterface(prop11.pt)
                },
                outerRadius: {
                    get: ExpressionPropertyInterface(prop11.or)
                },
                outerRoundness: {
                    get: ExpressionPropertyInterface(prop11.os)
                },
                innerRadius: {
                    get: ExpressionPropertyInterface(prop11.ir)
                },
                innerRoundness: {
                    get: ExpressionPropertyInterface(prop11.is)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function rectInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.p.ix === value31) return interfaceFunction11.position;
                if (shape31.r.ix === value31) return interfaceFunction11.roundness;
                if (shape31.s.ix === value31 || value31 === "Size" || value31 === "ADBE Vector Rect Size") return interfaceFunction11.size;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11.sh.ty === "tm" ? view11.sh.prop : view11.sh;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.p.setGroupProperty(PropertyInterface("Position", _propertyGroup11));
            prop11.s.setGroupProperty(PropertyInterface("Size", _propertyGroup11));
            prop11.r.setGroupProperty(PropertyInterface("Rotation", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                position: {
                    get: ExpressionPropertyInterface(prop11.p)
                },
                roundness: {
                    get: ExpressionPropertyInterface(prop11.r)
                },
                size: {
                    get: ExpressionPropertyInterface(prop11.s)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function roundedInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.r.ix === value31 || value31 === "Round Corners 1") return interfaceFunction11.radius;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.rd.setGroupProperty(PropertyInterface("Radius", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                radius: {
                    get: ExpressionPropertyInterface(prop11.rd)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        function repeaterInterfaceFactory11(shape31, view11, propertyGroup11) {
            function interfaceFunction11(value31) {
                if (shape31.c.ix === value31 || value31 === "Copies") return interfaceFunction11.copies;
                if (shape31.o.ix === value31 || value31 === "Offset") return interfaceFunction11.offset;
                return null;
            }
            var _propertyGroup11 = propertyGroupFactory(interfaceFunction11, propertyGroup11);
            var prop11 = view11;
            interfaceFunction11.propertyIndex = shape31.ix;
            prop11.c.setGroupProperty(PropertyInterface("Copies", _propertyGroup11));
            prop11.o.setGroupProperty(PropertyInterface("Offset", _propertyGroup11));
            Object.defineProperties(interfaceFunction11, {
                copies: {
                    get: ExpressionPropertyInterface(prop11.c)
                },
                offset: {
                    get: ExpressionPropertyInterface(prop11.o)
                },
                _name: {
                    value: shape31.nm
                }
            });
            interfaceFunction11.mn = shape31.mn;
            return interfaceFunction11;
        }
        return function(shapes11, view11, propertyGroup11) {
            var interfaces11;
            function _interfaceFunction11(value31) {
                if (typeof value31 === "number") {
                    value31 = value31 === undefined ? 1 : value31;
                    if (value31 === 0) return propertyGroup11;
                    return interfaces11[value31 - 1];
                }
                var i31 = 0;
                var len11 = interfaces11.length;
                while(i31 < len11){
                    if (interfaces11[i31]._name === value31) return interfaces11[i31];
                    i31 += 1;
                }
                return null;
            }
            function parentGroupWrapper11() {
                return propertyGroup11;
            }
            _interfaceFunction11.propertyGroup = propertyGroupFactory(_interfaceFunction11, parentGroupWrapper11);
            interfaces11 = iterateElements11(shapes11, view11, _interfaceFunction11.propertyGroup);
            _interfaceFunction11.numProperties = interfaces11.length;
            _interfaceFunction11._name = "Contents";
            return _interfaceFunction11;
        };
    }();
    var TextExpressionInterface = function() {
        return function(elem31) {
            var _sourceText11;
            function _thisLayerFunction11(name11) {
                switch(name11){
                    case "ADBE Text Document":
                        return _thisLayerFunction11.sourceText;
                    default:
                        return null;
                }
            }
            Object.defineProperty(_thisLayerFunction11, "sourceText", {
                get: function get11() {
                    elem31.textProperty.getValue();
                    var stringValue11 = elem31.textProperty.currentData.t;
                    if (!_sourceText11 || stringValue11 !== _sourceText11.value) {
                        _sourceText11 = new String(stringValue11); // eslint-disable-line no-new-wrappers
                        // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
                        _sourceText11.value = stringValue11 || new String(stringValue11); // eslint-disable-line no-new-wrappers
                        Object.defineProperty(_sourceText11, "style", {
                            get: function get11() {
                                return {
                                    fillColor: elem31.textProperty.currentData.fc
                                };
                            }
                        });
                    }
                    return _sourceText11;
                }
            });
            return _thisLayerFunction11;
        };
    }();
    function _typeof(obj11) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof11(obj11) {
            return typeof obj11;
        };
        else _typeof = function _typeof11(obj11) {
            return obj11 && typeof Symbol === "function" && obj11.constructor === Symbol && obj11 !== Symbol.prototype ? "symbol" : typeof obj11;
        };
        return _typeof(obj11);
    }
    var FootageInterface = function() {
        var outlineInterfaceFactory11 = function outlineInterfaceFactory11(elem31) {
            var currentPropertyName11 = "";
            var currentProperty11 = elem31.getFootageData();
            function init11() {
                currentPropertyName11 = "";
                currentProperty11 = elem31.getFootageData();
                return searchProperty11;
            }
            function searchProperty11(value31) {
                if (currentProperty11[value31]) {
                    currentPropertyName11 = value31;
                    currentProperty11 = currentProperty11[value31];
                    if (_typeof(currentProperty11) === "object") return searchProperty11;
                    return currentProperty11;
                }
                var propertyNameIndex11 = value31.indexOf(currentPropertyName11);
                if (propertyNameIndex11 !== -1) {
                    var index11 = parseInt(value31.substr(propertyNameIndex11 + currentPropertyName11.length), 10);
                    currentProperty11 = currentProperty11[index11];
                    if (_typeof(currentProperty11) === "object") return searchProperty11;
                    return currentProperty11;
                }
                return "";
            }
            return init11;
        };
        var dataInterfaceFactory11 = function dataInterfaceFactory11(elem31) {
            function interfaceFunction11(value31) {
                if (value31 === "Outline") return interfaceFunction11.outlineInterface();
                return null;
            }
            interfaceFunction11._name = "Outline";
            interfaceFunction11.outlineInterface = outlineInterfaceFactory11(elem31);
            return interfaceFunction11;
        };
        return function(elem31) {
            function _interfaceFunction11(value31) {
                if (value31 === "Data") return _interfaceFunction11.dataInterface;
                return null;
            }
            _interfaceFunction11._name = "Data";
            _interfaceFunction11.dataInterface = dataInterfaceFactory11(elem31);
            return _interfaceFunction11;
        };
    }();
    var interfaces = {
        layer: LayerExpressionInterface,
        effects: EffectsExpressionInterface,
        comp: CompExpressionInterface,
        shape: ShapeExpressionInterface,
        text: TextExpressionInterface,
        footage: FootageInterface
    };
    function getInterface(type11) {
        return interfaces[type11] || null;
    }
    var expressionHelpers = function() {
        function searchExpressions11(elem31, data11, prop11) {
            if (data11.x) {
                prop11.k = true;
                prop11.x = true;
                prop11.initiateExpression = ExpressionManager.initiateExpression;
                prop11.effectsSequence.push(prop11.initiateExpression(elem31, data11, prop11).bind(prop11));
            }
        }
        function getValueAtTime11(frameNum11) {
            frameNum11 *= this.elem.globalData.frameRate;
            frameNum11 -= this.offsetTime;
            if (frameNum11 !== this._cachingAtTime.lastFrame) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum11 ? this._cachingAtTime.lastIndex : 0;
                this._cachingAtTime.value = this.interpolateValue(frameNum11, this._cachingAtTime);
                this._cachingAtTime.lastFrame = frameNum11;
            }
            return this._cachingAtTime.value;
        }
        function getSpeedAtTime11(frameNum11) {
            var delta11 = -0.01;
            var v111 = this.getValueAtTime(frameNum11);
            var v211 = this.getValueAtTime(frameNum11 + delta11);
            var speed11 = 0;
            if (v111.length) {
                var i31;
                for(i31 = 0; i31 < v111.length; i31 += 1)speed11 += Math.pow(v211[i31] - v111[i31], 2);
                speed11 = Math.sqrt(speed11) * 100;
            } else speed11 = 0;
            return speed11;
        }
        function getVelocityAtTime11(frameNum11) {
            if (this.vel !== undefined) return this.vel;
            var delta11 = -0.001; // frameNum += this.elem.data.st;
            var v111 = this.getValueAtTime(frameNum11);
            var v211 = this.getValueAtTime(frameNum11 + delta11);
            var velocity11;
            if (v111.length) {
                velocity11 = createTypedArray("float32", v111.length);
                var i31;
                for(i31 = 0; i31 < v111.length; i31 += 1)// removing frameRate
                // if needed, don't add it here
                // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
                velocity11[i31] = (v211[i31] - v111[i31]) / delta11;
            } else velocity11 = (v211 - v111) / delta11;
            return velocity11;
        }
        function getStaticValueAtTime11() {
            return this.pv;
        }
        function setGroupProperty11(propertyGroup11) {
            this.propertyGroup = propertyGroup11;
        }
        return {
            searchExpressions: searchExpressions11,
            getSpeedAtTime: getSpeedAtTime11,
            getVelocityAtTime: getVelocityAtTime11,
            getValueAtTime: getValueAtTime11,
            getStaticValueAtTime: getStaticValueAtTime11,
            setGroupProperty: setGroupProperty11
        };
    }();
    function addPropertyDecorator() {
        function loopOut11(type11, duration11, durationFlag11) {
            if (!this.k || !this.keyframes) return this.pv;
            type11 = type11 ? type11.toLowerCase() : "";
            var currentFrame11 = this.comp.renderedFrame;
            var keyframes11 = this.keyframes;
            var lastKeyFrame11 = keyframes11[keyframes11.length - 1].t;
            if (currentFrame11 <= lastKeyFrame11) return this.pv;
            var cycleDuration11;
            var firstKeyFrame11;
            if (!durationFlag11) {
                if (!duration11 || duration11 > keyframes11.length - 1) duration11 = keyframes11.length - 1;
                firstKeyFrame11 = keyframes11[keyframes11.length - 1 - duration11].t;
                cycleDuration11 = lastKeyFrame11 - firstKeyFrame11;
            } else {
                if (!duration11) cycleDuration11 = Math.max(0, lastKeyFrame11 - this.elem.data.ip);
                else cycleDuration11 = Math.abs(lastKeyFrame11 - this.elem.comp.globalData.frameRate * duration11);
                firstKeyFrame11 = lastKeyFrame11 - cycleDuration11;
            }
            var i31;
            var len11;
            var ret11;
            if (type11 === "pingpong") {
                var iterations11 = Math.floor((currentFrame11 - firstKeyFrame11) / cycleDuration11);
                if (iterations11 % 2 !== 0) return this.getValueAtTime((cycleDuration11 - (currentFrame11 - firstKeyFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type11 === "offset") {
                var initV11 = this.getValueAtTime(firstKeyFrame11 / this.comp.globalData.frameRate, 0);
                var endV11 = this.getValueAtTime(lastKeyFrame11 / this.comp.globalData.frameRate, 0);
                var current11 = this.getValueAtTime(((currentFrame11 - firstKeyFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
                var repeats11 = Math.floor((currentFrame11 - firstKeyFrame11) / cycleDuration11);
                if (this.pv.length) {
                    ret11 = new Array(initV11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = (endV11[i31] - initV11[i31]) * repeats11 + current11[i31];
                    return ret11;
                }
                return (endV11 - initV11) * repeats11 + current11;
            } else if (type11 === "continue") {
                var lastValue11 = this.getValueAtTime(lastKeyFrame11 / this.comp.globalData.frameRate, 0);
                var nextLastValue11 = this.getValueAtTime((lastKeyFrame11 - 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret11 = new Array(lastValue11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = lastValue11[i31] + (lastValue11[i31] - nextLastValue11[i31]) * ((currentFrame11 - lastKeyFrame11) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
                    return ret11;
                }
                return lastValue11 + (lastValue11 - nextLastValue11) * ((currentFrame11 - lastKeyFrame11) / 0.001);
            }
            return this.getValueAtTime(((currentFrame11 - firstKeyFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function loopIn11(type11, duration11, durationFlag11) {
            if (!this.k) return this.pv;
            type11 = type11 ? type11.toLowerCase() : "";
            var currentFrame11 = this.comp.renderedFrame;
            var keyframes11 = this.keyframes;
            var firstKeyFrame11 = keyframes11[0].t;
            if (currentFrame11 >= firstKeyFrame11) return this.pv;
            var cycleDuration11;
            var lastKeyFrame11;
            if (!durationFlag11) {
                if (!duration11 || duration11 > keyframes11.length - 1) duration11 = keyframes11.length - 1;
                lastKeyFrame11 = keyframes11[duration11].t;
                cycleDuration11 = lastKeyFrame11 - firstKeyFrame11;
            } else {
                if (!duration11) cycleDuration11 = Math.max(0, this.elem.data.op - firstKeyFrame11);
                else cycleDuration11 = Math.abs(this.elem.comp.globalData.frameRate * duration11);
                lastKeyFrame11 = firstKeyFrame11 + cycleDuration11;
            }
            var i31;
            var len11;
            var ret11;
            if (type11 === "pingpong") {
                var iterations11 = Math.floor((firstKeyFrame11 - currentFrame11) / cycleDuration11);
                if (iterations11 % 2 === 0) return this.getValueAtTime(((firstKeyFrame11 - currentFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0); // eslint-disable-line
            } else if (type11 === "offset") {
                var initV11 = this.getValueAtTime(firstKeyFrame11 / this.comp.globalData.frameRate, 0);
                var endV11 = this.getValueAtTime(lastKeyFrame11 / this.comp.globalData.frameRate, 0);
                var current11 = this.getValueAtTime((cycleDuration11 - (firstKeyFrame11 - currentFrame11) % cycleDuration11 + firstKeyFrame11) / this.comp.globalData.frameRate, 0);
                var repeats11 = Math.floor((firstKeyFrame11 - currentFrame11) / cycleDuration11) + 1;
                if (this.pv.length) {
                    ret11 = new Array(initV11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = current11[i31] - (endV11[i31] - initV11[i31]) * repeats11;
                    return ret11;
                }
                return current11 - (endV11 - initV11) * repeats11;
            } else if (type11 === "continue") {
                var firstValue11 = this.getValueAtTime(firstKeyFrame11 / this.comp.globalData.frameRate, 0);
                var nextFirstValue11 = this.getValueAtTime((firstKeyFrame11 + 0.001) / this.comp.globalData.frameRate, 0);
                if (this.pv.length) {
                    ret11 = new Array(firstValue11.length);
                    len11 = ret11.length;
                    for(i31 = 0; i31 < len11; i31 += 1)ret11[i31] = firstValue11[i31] + (firstValue11[i31] - nextFirstValue11[i31]) * (firstKeyFrame11 - currentFrame11) / 0.001;
                    return ret11;
                }
                return firstValue11 + (firstValue11 - nextFirstValue11) * (firstKeyFrame11 - currentFrame11) / 0.001;
            }
            return this.getValueAtTime((cycleDuration11 - ((firstKeyFrame11 - currentFrame11) % cycleDuration11 + firstKeyFrame11)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
        function smooth11(width11, samples11) {
            if (!this.k) return this.pv;
            width11 = (width11 || 0.4) * 0.5;
            samples11 = Math.floor(samples11 || 5);
            if (samples11 <= 1) return this.pv;
            var currentTime11 = this.comp.renderedFrame / this.comp.globalData.frameRate;
            var initFrame11 = currentTime11 - width11;
            var endFrame11 = currentTime11 + width11;
            var sampleFrequency11 = samples11 > 1 ? (endFrame11 - initFrame11) / (samples11 - 1) : 1;
            var i31 = 0;
            var j31 = 0;
            var value31;
            if (this.pv.length) value31 = createTypedArray("float32", this.pv.length);
            else value31 = 0;
            var sampleValue11;
            while(i31 < samples11){
                sampleValue11 = this.getValueAtTime(initFrame11 + i31 * sampleFrequency11);
                if (this.pv.length) for(j31 = 0; j31 < this.pv.length; j31 += 1)value31[j31] += sampleValue11[j31];
                else value31 += sampleValue11;
                i31 += 1;
            }
            if (this.pv.length) for(j31 = 0; j31 < this.pv.length; j31 += 1)value31[j31] /= samples11;
            else value31 /= samples11;
            return value31;
        }
        function getTransformValueAtTime11(time11) {
            if (!this._transformCachingAtTime) this._transformCachingAtTime = {
                v: new Matrix()
            };
             /// /
            var matrix11 = this._transformCachingAtTime.v;
            matrix11.cloneFromProps(this.pre.props);
            if (this.appliedTransformations < 1) {
                var anchor11 = this.a.getValueAtTime(time11);
                matrix11.translate(-anchor11[0] * this.a.mult, -anchor11[1] * this.a.mult, anchor11[2] * this.a.mult);
            }
            if (this.appliedTransformations < 2) {
                var scale21 = this.s.getValueAtTime(time11);
                matrix11.scale(scale21[0] * this.s.mult, scale21[1] * this.s.mult, scale21[2] * this.s.mult);
            }
            if (this.sk && this.appliedTransformations < 3) {
                var skew11 = this.sk.getValueAtTime(time11);
                var skewAxis11 = this.sa.getValueAtTime(time11);
                matrix11.skewFromAxis(-skew11 * this.sk.mult, skewAxis11 * this.sa.mult);
            }
            if (this.r && this.appliedTransformations < 4) {
                var rotation11 = this.r.getValueAtTime(time11);
                matrix11.rotate(-rotation11 * this.r.mult);
            } else if (!this.r && this.appliedTransformations < 4) {
                var rotationZ11 = this.rz.getValueAtTime(time11);
                var rotationY11 = this.ry.getValueAtTime(time11);
                var rotationX11 = this.rx.getValueAtTime(time11);
                var orientation11 = this.or.getValueAtTime(time11);
                matrix11.rotateZ(-rotationZ11 * this.rz.mult).rotateY(rotationY11 * this.ry.mult).rotateX(rotationX11 * this.rx.mult).rotateZ(-orientation11[2] * this.or.mult).rotateY(orientation11[1] * this.or.mult).rotateX(orientation11[0] * this.or.mult);
            }
            if (this.data.p && this.data.p.s) {
                var positionX11 = this.px.getValueAtTime(time11);
                var positionY11 = this.py.getValueAtTime(time11);
                if (this.data.p.z) {
                    var positionZ11 = this.pz.getValueAtTime(time11);
                    matrix11.translate(positionX11 * this.px.mult, positionY11 * this.py.mult, -positionZ11 * this.pz.mult);
                } else matrix11.translate(positionX11 * this.px.mult, positionY11 * this.py.mult, 0);
            } else {
                var position11 = this.p.getValueAtTime(time11);
                matrix11.translate(position11[0] * this.p.mult, position11[1] * this.p.mult, -position11[2] * this.p.mult);
            }
            return matrix11; /// /
        }
        function getTransformStaticValueAtTime11() {
            return this.v.clone(new Matrix());
        }
        var getTransformProperty11 = TransformPropertyFactory.getTransformProperty;
        TransformPropertyFactory.getTransformProperty = function(elem31, data11, container11) {
            var prop11 = getTransformProperty11(elem31, data11, container11);
            if (prop11.dynamicProperties.length) prop11.getValueAtTime = getTransformValueAtTime11.bind(prop11);
            else prop11.getValueAtTime = getTransformStaticValueAtTime11.bind(prop11);
            prop11.setGroupProperty = expressionHelpers.setGroupProperty;
            return prop11;
        };
        var propertyGetProp11 = PropertyFactory.getProp;
        PropertyFactory.getProp = function(elem31, data11, type11, mult11, container11) {
            var prop11 = propertyGetProp11(elem31, data11, type11, mult11, container11); // prop.getVelocityAtTime = getVelocityAtTime;
            // prop.loopOut = loopOut;
            // prop.loopIn = loopIn;
            if (prop11.kf) prop11.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop11);
            else prop11.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop11);
            prop11.setGroupProperty = expressionHelpers.setGroupProperty;
            prop11.loopOut = loopOut11;
            prop11.loopIn = loopIn11;
            prop11.smooth = smooth11;
            prop11.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop11);
            prop11.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop11);
            prop11.numKeys = data11.a === 1 ? data11.k.length : 0;
            prop11.propertyIndex = data11.ix;
            var value31 = 0;
            if (type11 !== 0) value31 = createTypedArray("float32", data11.a === 1 ? data11.k[0].s.length : data11.k.length);
            prop11._cachingAtTime = {
                lastFrame: initialDefaultFrame,
                lastIndex: 0,
                value: value31
            };
            expressionHelpers.searchExpressions(elem31, data11, prop11);
            if (prop11.k) container11.addDynamicProperty(prop11);
            return prop11;
        };
        function getShapeValueAtTime11(frameNum11) {
            // For now this caching object is created only when needed instead of creating it when the shape is initialized.
            if (!this._cachingAtTime) this._cachingAtTime = {
                shapeValue: shapePool.clone(this.pv),
                lastIndex: 0,
                lastTime: initialDefaultFrame
            };
            frameNum11 *= this.elem.globalData.frameRate;
            frameNum11 -= this.offsetTime;
            if (frameNum11 !== this._cachingAtTime.lastTime) {
                this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum11 ? this._caching.lastIndex : 0;
                this._cachingAtTime.lastTime = frameNum11;
                this.interpolateShape(frameNum11, this._cachingAtTime.shapeValue, this._cachingAtTime);
            }
            return this._cachingAtTime.shapeValue;
        }
        var ShapePropertyConstructorFunction11 = ShapePropertyFactory.getConstructorFunction();
        var KeyframedShapePropertyConstructorFunction11 = ShapePropertyFactory.getKeyframedConstructorFunction();
        function ShapeExpressions11() {}
        ShapeExpressions11.prototype = {
            vertices: function vertices11(prop11, time11) {
                if (this.k) this.getValue();
                var shapePath11 = this.v;
                if (time11 !== undefined) shapePath11 = this.getValueAtTime(time11, 0);
                var i31;
                var len11 = shapePath11._length;
                var vertices11 = shapePath11[prop11];
                var points11 = shapePath11.v;
                var arr31 = createSizedArray(len11);
                for(i31 = 0; i31 < len11; i31 += 1)if (prop11 === "i" || prop11 === "o") arr31[i31] = [
                    vertices11[i31][0] - points11[i31][0],
                    vertices11[i31][1] - points11[i31][1]
                ];
                else arr31[i31] = [
                    vertices11[i31][0],
                    vertices11[i31][1]
                ];
                return arr31;
            },
            points: function points11(time11) {
                return this.vertices("v", time11);
            },
            inTangents: function inTangents11(time11) {
                return this.vertices("i", time11);
            },
            outTangents: function outTangents11(time11) {
                return this.vertices("o", time11);
            },
            isClosed: function isClosed11() {
                return this.v.c;
            },
            pointOnPath: function pointOnPath11(perc11, time11) {
                var shapePath11 = this.v;
                if (time11 !== undefined) shapePath11 = this.getValueAtTime(time11, 0);
                if (!this._segmentsLength) this._segmentsLength = bez.getSegmentsLength(shapePath11);
                var segmentsLength11 = this._segmentsLength;
                var lengths11 = segmentsLength11.lengths;
                var lengthPos11 = segmentsLength11.totalLength * perc11;
                var i31 = 0;
                var len11 = lengths11.length;
                var accumulatedLength11 = 0;
                var pt51;
                while(i31 < len11){
                    if (accumulatedLength11 + lengths11[i31].addedLength > lengthPos11) {
                        var initIndex11 = i31;
                        var endIndex11 = shapePath11.c && i31 === len11 - 1 ? 0 : i31 + 1;
                        var segmentPerc11 = (lengthPos11 - accumulatedLength11) / lengths11[i31].addedLength;
                        pt51 = bez.getPointInSegment(shapePath11.v[initIndex11], shapePath11.v[endIndex11], shapePath11.o[initIndex11], shapePath11.i[endIndex11], segmentPerc11, lengths11[i31]);
                        break;
                    } else accumulatedLength11 += lengths11[i31].addedLength;
                    i31 += 1;
                }
                if (!pt51) pt51 = shapePath11.c ? [
                    shapePath11.v[0][0],
                    shapePath11.v[0][1]
                ] : [
                    shapePath11.v[shapePath11._length - 1][0],
                    shapePath11.v[shapePath11._length - 1][1]
                ];
                return pt51;
            },
            vectorOnPath: function vectorOnPath11(perc11, time11, vectorType11) {
                // perc doesn't use triple equality because it can be a Number object as well as a primitive.
                if (perc11 == 1) // eslint-disable-line eqeqeq
                perc11 = this.v.c;
                else if (perc11 == 0) // eslint-disable-line eqeqeq
                perc11 = 0.999;
                var pt111 = this.pointOnPath(perc11, time11);
                var pt211 = this.pointOnPath(perc11 + 0.001, time11);
                var xLength11 = pt211[0] - pt111[0];
                var yLength11 = pt211[1] - pt111[1];
                var magnitude11 = Math.sqrt(Math.pow(xLength11, 2) + Math.pow(yLength11, 2));
                if (magnitude11 === 0) return [
                    0,
                    0
                ];
                var unitVector11 = vectorType11 === "tangent" ? [
                    xLength11 / magnitude11,
                    yLength11 / magnitude11
                ] : [
                    -yLength11 / magnitude11,
                    xLength11 / magnitude11
                ];
                return unitVector11;
            },
            tangentOnPath: function tangentOnPath11(perc11, time11) {
                return this.vectorOnPath(perc11, time11, "tangent");
            },
            normalOnPath: function normalOnPath11(perc11, time11) {
                return this.vectorOnPath(perc11, time11, "normal");
            },
            setGroupProperty: expressionHelpers.setGroupProperty,
            getValueAtTime: expressionHelpers.getStaticValueAtTime
        };
        extendPrototype([
            ShapeExpressions11
        ], ShapePropertyConstructorFunction11);
        extendPrototype([
            ShapeExpressions11
        ], KeyframedShapePropertyConstructorFunction11);
        KeyframedShapePropertyConstructorFunction11.prototype.getValueAtTime = getShapeValueAtTime11;
        KeyframedShapePropertyConstructorFunction11.prototype.initiateExpression = ExpressionManager.initiateExpression;
        var propertyGetShapeProp11 = ShapePropertyFactory.getShapeProp;
        ShapePropertyFactory.getShapeProp = function(elem31, data11, type11, arr31, trims11) {
            var prop11 = propertyGetShapeProp11(elem31, data11, type11, arr31, trims11);
            prop11.propertyIndex = data11.ix;
            prop11.lock = false;
            if (type11 === 3) expressionHelpers.searchExpressions(elem31, data11.pt, prop11);
            else if (type11 === 4) expressionHelpers.searchExpressions(elem31, data11.ks, prop11);
            if (prop11.k) elem31.addDynamicProperty(prop11);
            return prop11;
        };
    }
    function initialize$1() {
        addPropertyDecorator();
    }
    function addDecorator() {
        function searchExpressions11() {
            if (this.data.d.x) {
                this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
                this.addEffect(this.getExpressionValue.bind(this));
                return true;
            }
            return null;
        }
        TextProperty.prototype.getExpressionValue = function(currentValue11, text11) {
            var newValue11 = this.calculateExpression(text11);
            if (currentValue11.t !== newValue11) {
                var newData11 = {};
                this.copyData(newData11, currentValue11);
                newData11.t = newValue11.toString();
                newData11.__complete = false;
                return newData11;
            }
            return currentValue11;
        };
        TextProperty.prototype.searchProperty = function() {
            var isKeyframed11 = this.searchKeyframes();
            var hasExpressions11 = this.searchExpressions();
            this.kf = isKeyframed11 || hasExpressions11;
            return this.kf;
        };
        TextProperty.prototype.searchExpressions = searchExpressions11;
    }
    function initialize() {
        addDecorator();
    }
    function SVGComposableEffect() {}
    SVGComposableEffect.prototype = {
        createMergeNode: function createMergeNode11(resultId11, ins11) {
            var feMerge11 = createNS("feMerge");
            feMerge11.setAttribute("result", resultId11);
            var feMergeNode11;
            var i31;
            for(i31 = 0; i31 < ins11.length; i31 += 1){
                feMergeNode11 = createNS("feMergeNode");
                feMergeNode11.setAttribute("in", ins11[i31]);
                feMerge11.appendChild(feMergeNode11);
                feMerge11.appendChild(feMergeNode11);
            }
            return feMerge11;
        }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(filter11, filterManager11, elem31, id11, source11) {
        this.filterManager = filterManager11;
        var feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix11.setAttribute("values", linearFilterValue + " 1 0");
        this.linearFilter = feColorMatrix11;
        feColorMatrix11.setAttribute("result", id11 + "_tint_1");
        filter11.appendChild(feColorMatrix11);
        feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix11.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix11.setAttribute("result", id11 + "_tint_2");
        filter11.appendChild(feColorMatrix11);
        this.matrixFilter = feColorMatrix11;
        var feMerge11 = this.createMergeNode(id11, [
            source11,
            id11 + "_tint_1",
            id11 + "_tint_2"
        ]);
        filter11.appendChild(feMerge11);
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGTintFilter);
    SVGTintFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var colorBlack11 = this.filterManager.effectElements[0].p.v;
            var colorWhite11 = this.filterManager.effectElements[1].p.v;
            var opacity11 = this.filterManager.effectElements[2].p.v / 100;
            this.linearFilter.setAttribute("values", linearFilterValue + " " + opacity11 + " 0");
            this.matrixFilter.setAttribute("values", colorWhite11[0] - colorBlack11[0] + " 0 0 0 " + colorBlack11[0] + " " + (colorWhite11[1] - colorBlack11[1]) + " 0 0 0 " + colorBlack11[1] + " " + (colorWhite11[2] - colorBlack11[2]) + " 0 0 0 " + colorBlack11[2] + " 0 0 0 1 0");
        }
    };
    function SVGFillFilter(filter11, filterManager11, elem31, id11) {
        this.filterManager = filterManager11;
        var feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "sRGB");
        feColorMatrix11.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0");
        feColorMatrix11.setAttribute("result", id11);
        filter11.appendChild(feColorMatrix11);
        this.matrixFilter = feColorMatrix11;
    }
    SVGFillFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var color41 = this.filterManager.effectElements[2].p.v;
            var opacity11 = this.filterManager.effectElements[6].p.v;
            this.matrixFilter.setAttribute("values", "0 0 0 0 " + color41[0] + " 0 0 0 0 " + color41[1] + " 0 0 0 0 " + color41[2] + " 0 0 0 " + opacity11 + " 0");
        }
    };
    function SVGStrokeEffect(fil11, filterManager11, elem31) {
        this.initialized = false;
        this.filterManager = filterManager11;
        this.elem = elem31;
        this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
        var elemChildren11 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
        var path11;
        var groupPath11;
        var i31;
        var len11;
        if (this.filterManager.effectElements[1].p.v === 1) {
            len11 = this.elem.maskManager.masksProperties.length;
            i31 = 0;
        } else {
            i31 = this.filterManager.effectElements[0].p.v - 1;
            len11 = i31 + 1;
        }
        groupPath11 = createNS("g");
        groupPath11.setAttribute("fill", "none");
        groupPath11.setAttribute("stroke-linecap", "round");
        groupPath11.setAttribute("stroke-dashoffset", 1);
        for(i31; i31 < len11; i31 += 1){
            path11 = createNS("path");
            groupPath11.appendChild(path11);
            this.paths.push({
                p: path11,
                m: i31
            });
        }
        if (this.filterManager.effectElements[10].p.v === 3) {
            var mask11 = createNS("mask");
            var id11 = createElementID();
            mask11.setAttribute("id", id11);
            mask11.setAttribute("mask-type", "alpha");
            mask11.appendChild(groupPath11);
            this.elem.globalData.defs.appendChild(mask11);
            var g31 = createNS("g");
            g31.setAttribute("mask", "url(" + getLocationHref() + "#" + id11 + ")");
            while(elemChildren11[0])g31.appendChild(elemChildren11[0]);
            this.elem.layerElement.appendChild(g31);
            this.masker = mask11;
            groupPath11.setAttribute("stroke", "#fff");
        } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (this.filterManager.effectElements[10].p.v === 2) {
                elemChildren11 = this.elem.layerElement.children || this.elem.layerElement.childNodes;
                while(elemChildren11.length)this.elem.layerElement.removeChild(elemChildren11[0]);
            }
            this.elem.layerElement.appendChild(groupPath11);
            this.elem.layerElement.removeAttribute("mask");
            groupPath11.setAttribute("stroke", "#fff");
        }
        this.initialized = true;
        this.pathMasker = groupPath11;
    };
    SVGStrokeEffect.prototype.renderFrame = function(forceRender11) {
        if (!this.initialized) this.initialize();
        var i31;
        var len11 = this.paths.length;
        var mask11;
        var path11;
        for(i31 = 0; i31 < len11; i31 += 1)if (this.paths[i31].m !== -1) {
            mask11 = this.elem.maskManager.viewData[this.paths[i31].m];
            path11 = this.paths[i31].p;
            if (forceRender11 || this.filterManager._mdf || mask11.prop._mdf) path11.setAttribute("d", mask11.lastPath);
            if (forceRender11 || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask11.prop._mdf) {
                var dasharrayValue11;
                if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
                    var s41 = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var e31 = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
                    var l31 = path11.getTotalLength();
                    dasharrayValue11 = "0 0 0 " + l31 * s41 + " ";
                    var lineLength11 = l31 * (e31 - s41);
                    var segment11 = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                    var units11 = Math.floor(lineLength11 / segment11);
                    var j31;
                    for(j31 = 0; j31 < units11; j31 += 1)dasharrayValue11 += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
                    dasharrayValue11 += "0 " + l31 * 10 + " 0 0";
                } else dasharrayValue11 = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
                path11.setAttribute("stroke-dasharray", dasharrayValue11);
            }
        }
        if (forceRender11 || this.filterManager.effectElements[4].p._mdf) this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2);
        if (forceRender11 || this.filterManager.effectElements[6].p._mdf) this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v);
        if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
            if (forceRender11 || this.filterManager.effectElements[3].p._mdf) {
                var color41 = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(color41[0] * 255) + "," + bmFloor(color41[1] * 255) + "," + bmFloor(color41[2] * 255) + ")");
            }
        }
    };
    function SVGTritoneFilter(filter11, filterManager11, elem31, id11) {
        this.filterManager = filterManager11;
        var feColorMatrix11 = createNS("feColorMatrix");
        feColorMatrix11.setAttribute("type", "matrix");
        feColorMatrix11.setAttribute("color-interpolation-filters", "linearRGB");
        feColorMatrix11.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0");
        filter11.appendChild(feColorMatrix11);
        var feComponentTransfer11 = createNS("feComponentTransfer");
        feComponentTransfer11.setAttribute("color-interpolation-filters", "sRGB");
        feComponentTransfer11.setAttribute("result", id11);
        this.matrixFilter = feComponentTransfer11;
        var feFuncR11 = createNS("feFuncR");
        feFuncR11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFuncR11);
        this.feFuncR = feFuncR11;
        var feFuncG11 = createNS("feFuncG");
        feFuncG11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFuncG11);
        this.feFuncG = feFuncG11;
        var feFuncB11 = createNS("feFuncB");
        feFuncB11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFuncB11);
        this.feFuncB = feFuncB11;
        filter11.appendChild(feComponentTransfer11);
    }
    SVGTritoneFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var color111 = this.filterManager.effectElements[0].p.v;
            var color211 = this.filterManager.effectElements[1].p.v;
            var color311 = this.filterManager.effectElements[2].p.v;
            var tableR11 = color311[0] + " " + color211[0] + " " + color111[0];
            var tableG11 = color311[1] + " " + color211[1] + " " + color111[1];
            var tableB11 = color311[2] + " " + color211[2] + " " + color111[2];
            this.feFuncR.setAttribute("tableValues", tableR11);
            this.feFuncG.setAttribute("tableValues", tableG11);
            this.feFuncB.setAttribute("tableValues", tableB11);
        }
    };
    function SVGProLevelsFilter(filter11, filterManager11, elem31, id11) {
        this.filterManager = filterManager11;
        var effectElements11 = this.filterManager.effectElements;
        var feComponentTransfer11 = createNS("feComponentTransfer"); // Red
        if (effectElements11[10].p.k || effectElements11[10].p.v !== 0 || effectElements11[11].p.k || effectElements11[11].p.v !== 1 || effectElements11[12].p.k || effectElements11[12].p.v !== 1 || effectElements11[13].p.k || effectElements11[13].p.v !== 0 || effectElements11[14].p.k || effectElements11[14].p.v !== 1) this.feFuncR = this.createFeFunc("feFuncR", feComponentTransfer11);
         // Green
        if (effectElements11[17].p.k || effectElements11[17].p.v !== 0 || effectElements11[18].p.k || effectElements11[18].p.v !== 1 || effectElements11[19].p.k || effectElements11[19].p.v !== 1 || effectElements11[20].p.k || effectElements11[20].p.v !== 0 || effectElements11[21].p.k || effectElements11[21].p.v !== 1) this.feFuncG = this.createFeFunc("feFuncG", feComponentTransfer11);
         // Blue
        if (effectElements11[24].p.k || effectElements11[24].p.v !== 0 || effectElements11[25].p.k || effectElements11[25].p.v !== 1 || effectElements11[26].p.k || effectElements11[26].p.v !== 1 || effectElements11[27].p.k || effectElements11[27].p.v !== 0 || effectElements11[28].p.k || effectElements11[28].p.v !== 1) this.feFuncB = this.createFeFunc("feFuncB", feComponentTransfer11);
         // Alpha
        if (effectElements11[31].p.k || effectElements11[31].p.v !== 0 || effectElements11[32].p.k || effectElements11[32].p.v !== 1 || effectElements11[33].p.k || effectElements11[33].p.v !== 1 || effectElements11[34].p.k || effectElements11[34].p.v !== 0 || effectElements11[35].p.k || effectElements11[35].p.v !== 1) this.feFuncA = this.createFeFunc("feFuncA", feComponentTransfer11);
         // RGB
        if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
            feComponentTransfer11.setAttribute("color-interpolation-filters", "sRGB");
            filter11.appendChild(feComponentTransfer11);
        }
        if (effectElements11[3].p.k || effectElements11[3].p.v !== 0 || effectElements11[4].p.k || effectElements11[4].p.v !== 1 || effectElements11[5].p.k || effectElements11[5].p.v !== 1 || effectElements11[6].p.k || effectElements11[6].p.v !== 0 || effectElements11[7].p.k || effectElements11[7].p.v !== 1) {
            feComponentTransfer11 = createNS("feComponentTransfer");
            feComponentTransfer11.setAttribute("color-interpolation-filters", "sRGB");
            feComponentTransfer11.setAttribute("result", id11);
            filter11.appendChild(feComponentTransfer11);
            this.feFuncRComposed = this.createFeFunc("feFuncR", feComponentTransfer11);
            this.feFuncGComposed = this.createFeFunc("feFuncG", feComponentTransfer11);
            this.feFuncBComposed = this.createFeFunc("feFuncB", feComponentTransfer11);
        }
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(type11, feComponentTransfer11) {
        var feFunc11 = createNS(type11);
        feFunc11.setAttribute("type", "table");
        feComponentTransfer11.appendChild(feFunc11);
        return feFunc11;
    };
    SVGProLevelsFilter.prototype.getTableValue = function(inputBlack11, inputWhite11, gamma11, outputBlack11, outputWhite11) {
        var cnt11 = 0;
        var segments11 = 256;
        var perc11;
        var min11 = Math.min(inputBlack11, inputWhite11);
        var max11 = Math.max(inputBlack11, inputWhite11);
        var table11 = Array.call(null, {
            length: segments11
        });
        var colorValue11;
        var pos11 = 0;
        var outputDelta11 = outputWhite11 - outputBlack11;
        var inputDelta11 = inputWhite11 - inputBlack11;
        while(cnt11 <= 256){
            perc11 = cnt11 / 256;
            if (perc11 <= min11) colorValue11 = inputDelta11 < 0 ? outputWhite11 : outputBlack11;
            else if (perc11 >= max11) colorValue11 = inputDelta11 < 0 ? outputBlack11 : outputWhite11;
            else colorValue11 = outputBlack11 + outputDelta11 * Math.pow((perc11 - inputBlack11) / inputDelta11, 1 / gamma11);
            table11[pos11] = colorValue11;
            pos11 += 1;
            cnt11 += 256 / (segments11 - 1);
        }
        return table11.join(" ");
    };
    SVGProLevelsFilter.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            var val31;
            var effectElements11 = this.filterManager.effectElements;
            if (this.feFuncRComposed && (forceRender11 || effectElements11[3].p._mdf || effectElements11[4].p._mdf || effectElements11[5].p._mdf || effectElements11[6].p._mdf || effectElements11[7].p._mdf)) {
                val31 = this.getTableValue(effectElements11[3].p.v, effectElements11[4].p.v, effectElements11[5].p.v, effectElements11[6].p.v, effectElements11[7].p.v);
                this.feFuncRComposed.setAttribute("tableValues", val31);
                this.feFuncGComposed.setAttribute("tableValues", val31);
                this.feFuncBComposed.setAttribute("tableValues", val31);
            }
            if (this.feFuncR && (forceRender11 || effectElements11[10].p._mdf || effectElements11[11].p._mdf || effectElements11[12].p._mdf || effectElements11[13].p._mdf || effectElements11[14].p._mdf)) {
                val31 = this.getTableValue(effectElements11[10].p.v, effectElements11[11].p.v, effectElements11[12].p.v, effectElements11[13].p.v, effectElements11[14].p.v);
                this.feFuncR.setAttribute("tableValues", val31);
            }
            if (this.feFuncG && (forceRender11 || effectElements11[17].p._mdf || effectElements11[18].p._mdf || effectElements11[19].p._mdf || effectElements11[20].p._mdf || effectElements11[21].p._mdf)) {
                val31 = this.getTableValue(effectElements11[17].p.v, effectElements11[18].p.v, effectElements11[19].p.v, effectElements11[20].p.v, effectElements11[21].p.v);
                this.feFuncG.setAttribute("tableValues", val31);
            }
            if (this.feFuncB && (forceRender11 || effectElements11[24].p._mdf || effectElements11[25].p._mdf || effectElements11[26].p._mdf || effectElements11[27].p._mdf || effectElements11[28].p._mdf)) {
                val31 = this.getTableValue(effectElements11[24].p.v, effectElements11[25].p.v, effectElements11[26].p.v, effectElements11[27].p.v, effectElements11[28].p.v);
                this.feFuncB.setAttribute("tableValues", val31);
            }
            if (this.feFuncA && (forceRender11 || effectElements11[31].p._mdf || effectElements11[32].p._mdf || effectElements11[33].p._mdf || effectElements11[34].p._mdf || effectElements11[35].p._mdf)) {
                val31 = this.getTableValue(effectElements11[31].p.v, effectElements11[32].p.v, effectElements11[33].p.v, effectElements11[34].p.v, effectElements11[35].p.v);
                this.feFuncA.setAttribute("tableValues", val31);
            }
        }
    };
    function SVGDropShadowEffect(filter11, filterManager11, elem31, id11, source11) {
        var globalFilterSize11 = filterManager11.container.globalData.renderConfig.filterSize;
        var filterSize11 = filterManager11.data.fs || globalFilterSize11;
        filter11.setAttribute("x", filterSize11.x || globalFilterSize11.x);
        filter11.setAttribute("y", filterSize11.y || globalFilterSize11.y);
        filter11.setAttribute("width", filterSize11.width || globalFilterSize11.width);
        filter11.setAttribute("height", filterSize11.height || globalFilterSize11.height);
        this.filterManager = filterManager11;
        var feGaussianBlur11 = createNS("feGaussianBlur");
        feGaussianBlur11.setAttribute("in", "SourceAlpha");
        feGaussianBlur11.setAttribute("result", id11 + "_drop_shadow_1");
        feGaussianBlur11.setAttribute("stdDeviation", "0");
        this.feGaussianBlur = feGaussianBlur11;
        filter11.appendChild(feGaussianBlur11);
        var feOffset11 = createNS("feOffset");
        feOffset11.setAttribute("dx", "25");
        feOffset11.setAttribute("dy", "0");
        feOffset11.setAttribute("in", id11 + "_drop_shadow_1");
        feOffset11.setAttribute("result", id11 + "_drop_shadow_2");
        this.feOffset = feOffset11;
        filter11.appendChild(feOffset11);
        var feFlood11 = createNS("feFlood");
        feFlood11.setAttribute("flood-color", "#00ff00");
        feFlood11.setAttribute("flood-opacity", "1");
        feFlood11.setAttribute("result", id11 + "_drop_shadow_3");
        this.feFlood = feFlood11;
        filter11.appendChild(feFlood11);
        var feComposite11 = createNS("feComposite");
        feComposite11.setAttribute("in", id11 + "_drop_shadow_3");
        feComposite11.setAttribute("in2", id11 + "_drop_shadow_2");
        feComposite11.setAttribute("operator", "in");
        feComposite11.setAttribute("result", id11 + "_drop_shadow_4");
        filter11.appendChild(feComposite11);
        var feMerge11 = this.createMergeNode(id11, [
            id11 + "_drop_shadow_4",
            source11
        ]);
        filter11.appendChild(feMerge11); //
    }
    extendPrototype([
        SVGComposableEffect
    ], SVGDropShadowEffect);
    SVGDropShadowEffect.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            if (forceRender11 || this.filterManager.effectElements[4].p._mdf) this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4);
            if (forceRender11 || this.filterManager.effectElements[0].p._mdf) {
                var col11 = this.filterManager.effectElements[0].p.v;
                this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(col11[0] * 255), Math.round(col11[1] * 255), Math.round(col11[2] * 255)));
            }
            if (forceRender11 || this.filterManager.effectElements[1].p._mdf) this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255);
            if (forceRender11 || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                var distance11 = this.filterManager.effectElements[3].p.v;
                var angle11 = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
                var x41 = distance11 * Math.cos(angle11);
                var y41 = distance11 * Math.sin(angle11);
                this.feOffset.setAttribute("dx", x41);
                this.feOffset.setAttribute("dy", y41);
            }
        }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(filterElem11, filterManager11, elem31) {
        this.initialized = false;
        this.filterManager = filterManager11;
        this.filterElem = filterElem11;
        this.elem = elem31;
        elem31.matteElement = createNS("g");
        elem31.matteElement.appendChild(elem31.layerElement);
        elem31.matteElement.appendChild(elem31.transformedElement);
        elem31.baseElement = elem31.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(mask11) {
        var i31 = 0;
        var len11 = _svgMatteSymbols.length;
        while(i31 < len11){
            if (_svgMatteSymbols[i31] === mask11) return _svgMatteSymbols[i31];
            i31 += 1;
        }
        return null;
    };
    SVGMatte3Effect.prototype.replaceInParent = function(mask11, symbolId11) {
        var parentNode11 = mask11.layerElement.parentNode;
        if (!parentNode11) return;
        var children11 = parentNode11.children;
        var i31 = 0;
        var len11 = children11.length;
        while(i31 < len11){
            if (children11[i31] === mask11.layerElement) break;
            i31 += 1;
        }
        var nextChild11;
        if (i31 <= len11 - 2) nextChild11 = children11[i31 + 1];
        var useElem11 = createNS("use");
        useElem11.setAttribute("href", "#" + symbolId11);
        if (nextChild11) parentNode11.insertBefore(useElem11, nextChild11);
        else parentNode11.appendChild(useElem11);
    };
    SVGMatte3Effect.prototype.setElementAsMask = function(elem31, mask11) {
        if (!this.findSymbol(mask11)) {
            var symbolId11 = createElementID();
            var masker11 = createNS("mask");
            masker11.setAttribute("id", mask11.layerId);
            masker11.setAttribute("mask-type", "alpha");
            _svgMatteSymbols.push(mask11);
            var defs11 = elem31.globalData.defs;
            defs11.appendChild(masker11);
            var symbol11 = createNS("symbol");
            symbol11.setAttribute("id", symbolId11);
            this.replaceInParent(mask11, symbolId11);
            symbol11.appendChild(mask11.layerElement);
            defs11.appendChild(symbol11);
            var useElem11 = createNS("use");
            useElem11.setAttribute("href", "#" + symbolId11);
            masker11.appendChild(useElem11);
            mask11.data.hd = false;
            mask11.show();
        }
        elem31.setMatte(mask11.layerId);
    };
    SVGMatte3Effect.prototype.initialize = function() {
        var ind11 = this.filterManager.effectElements[0].p.v;
        var elements11 = this.elem.comp.elements;
        var i31 = 0;
        var len11 = elements11.length;
        while(i31 < len11){
            if (elements11[i31] && elements11[i31].data.ind === ind11) this.setElementAsMask(this.elem, elements11[i31]);
            i31 += 1;
        }
        this.initialized = true;
    };
    SVGMatte3Effect.prototype.renderFrame = function() {
        if (!this.initialized) this.initialize();
    };
    function SVGGaussianBlurEffect(filter11, filterManager11, elem31, id11) {
        // Outset the filter region by 100% on all sides to accommodate blur expansion.
        filter11.setAttribute("x", "-100%");
        filter11.setAttribute("y", "-100%");
        filter11.setAttribute("width", "300%");
        filter11.setAttribute("height", "300%");
        this.filterManager = filterManager11;
        var feGaussianBlur11 = createNS("feGaussianBlur");
        feGaussianBlur11.setAttribute("result", id11);
        filter11.appendChild(feGaussianBlur11);
        this.feGaussianBlur = feGaussianBlur11;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(forceRender11) {
        if (forceRender11 || this.filterManager._mdf) {
            // Empirical value, matching AE's blur appearance.
            var kBlurrinessToSigma11 = 0.3;
            var sigma11 = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma11; // Dimensions mapping:
            //
            //   1 -> horizontal & vertical
            //   2 -> horizontal only
            //   3 -> vertical only
            //
            var dimensions11 = this.filterManager.effectElements[1].p.v;
            var sigmaX11 = dimensions11 == 3 ? 0 : sigma11; // eslint-disable-line eqeqeq
            var sigmaY11 = dimensions11 == 2 ? 0 : sigma11; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("stdDeviation", sigmaX11 + " " + sigmaY11); // Repeat edges mapping:
            //
            //   0 -> off -> duplicate
            //   1 -> on  -> wrap
            var edgeMode11 = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate"; // eslint-disable-line eqeqeq
            this.feGaussianBlur.setAttribute("edgeMode", edgeMode11);
        }
    };
    function TransformEffect() {}
    TransformEffect.prototype.init = function(effectsManager11) {
        this.effectsManager = effectsManager11;
        this.type = effectTypes.TRANSFORM_EFFECT;
        this.matrix = new Matrix();
        this.opacity = -1;
        this._mdf = false;
        this._opMdf = false;
    };
    TransformEffect.prototype.renderFrame = function(forceFrame11) {
        this._opMdf = false;
        this._mdf = false;
        if (forceFrame11 || this.effectsManager._mdf) {
            var effectElements11 = this.effectsManager.effectElements;
            var anchor11 = effectElements11[0].p.v;
            var position11 = effectElements11[1].p.v;
            var scaleHeight11 = effectElements11[3].p.v;
            var scaleWidth11 = effectElements11[4].p.v;
            var skew11 = effectElements11[5].p.v;
            var skewAxis11 = effectElements11[6].p.v;
            var rotation11 = effectElements11[7].p.v;
            this.matrix.reset();
            this.matrix.translate(-anchor11[0], -anchor11[1], anchor11[2]);
            this.matrix.scale(scaleWidth11 * 0.01, scaleHeight11 * 0.01, 1);
            this.matrix.rotate(-rotation11 * degToRads);
            this.matrix.skewFromAxis(-skew11 * degToRads, (skewAxis11 + 90) * degToRads);
            this.matrix.translate(position11[0], position11[1], 0);
            this._mdf = true;
            if (this.opacity !== effectElements11[8].p.v) {
                this.opacity = effectElements11[8].p.v;
                this._opMdf = true;
            }
        }
    };
    function SVGTransformEffect(_11, filterManager11) {
        this.init(filterManager11);
    }
    extendPrototype([
        TransformEffect
    ], SVGTransformEffect);
    function CVTransformEffect(effectsManager11) {
        this.init(effectsManager11);
    }
    extendPrototype([
        TransformEffect
    ], CVTransformEffect);
    registerRenderer("canvas", CanvasRenderer);
    registerRenderer("html", HybridRenderer);
    registerRenderer("svg", SVGRenderer); // Registering shape modifiers
    ShapeModifiers.registerModifier("tm", TrimModifier);
    ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier);
    ShapeModifiers.registerModifier("rp", RepeaterModifier);
    ShapeModifiers.registerModifier("rd", RoundCornersModifier);
    ShapeModifiers.registerModifier("zz", ZigZagModifier);
    ShapeModifiers.registerModifier("op", OffsetPathModifier); // Registering expression plugin
    setExpressionsPlugin(Expressions);
    setExpressionInterfaces(getInterface);
    initialize$1();
    initialize(); // Registering svg effects
    registerEffect$1(20, SVGTintFilter, true);
    registerEffect$1(21, SVGFillFilter, true);
    registerEffect$1(22, SVGStrokeEffect, false);
    registerEffect$1(23, SVGTritoneFilter, true);
    registerEffect$1(24, SVGProLevelsFilter, true);
    registerEffect$1(25, SVGDropShadowEffect, true);
    registerEffect$1(28, SVGMatte3Effect, false);
    registerEffect$1(29, SVGGaussianBlurEffect, true);
    registerEffect$1(35, SVGTransformEffect, false);
    registerEffect(35, CVTransformEffect);
    return lottie;
});

});

parcelRequire.register("bKfU0", function(module, exports) {

module.exports = import("./" + (parcelRequire("3TfdU")).resolve("23p3k")).then(()=>parcelRequire("cPYZq"));

});

parcelRequire.register("bR7Up", function(module, exports) {

var $bcIJv = parcelRequire("bcIJv");

var $bR0Jr = parcelRequire("bR0Jr");
var $8a1ac77efddccc8e$require$Buffer = $bR0Jr.Buffer;







/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2021 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */ (function webpackUniversalModuleDefinition11(root11, factory11) {
    module.exports = factory11();
})(this, function() {
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.addLinkAttributes = addLinkAttributes11;
                exports11.deprecated = deprecated11;
                exports11.getFilenameFromUrl = getFilenameFromUrl11;
                exports11.getPdfFilenameFromUrl = getPdfFilenameFromUrl11;
                exports11.getXfaPageViewport = getXfaPageViewport11;
                exports11.isDataScheme = isDataScheme11;
                exports11.isPdfFile = isPdfFile11;
                exports11.isValidFetchUrl = isValidFetchUrl11;
                exports11.loadScript = loadScript11;
                exports11.StatTimer = exports11.RenderingCancelledException = exports11.PDFDateString = exports11.PageViewport = exports11.LinkTarget = exports11.DOMSVGFactory = exports11.DOMStandardFontDataFactory = exports11.DOMCMapReaderFactory = exports11.DOMCanvasFactory = exports11.DEFAULT_LINK_REL = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                var _base_factory11 = __w_pdfjs_require__11(5);
                const DEFAULT_LINK_REL11 = "noopener noreferrer nofollow";
                exports11.DEFAULT_LINK_REL = DEFAULT_LINK_REL11;
                const SVG_NS11 = "http://www.w3.org/2000/svg";
                class DOMCanvasFactory11 extends _base_factory11.BaseCanvasFactory {
                    constructor({ ownerDocument: ownerDocument11 = globalThis.document  } = {}){
                        super();
                        this._document = ownerDocument11;
                    }
                    _createCanvas(width21, height11) {
                        const canvas11 = this._document.createElement("canvas");
                        canvas11.width = width21;
                        canvas11.height = height11;
                        return canvas11;
                    }
                }
                exports11.DOMCanvasFactory = DOMCanvasFactory11;
                async function fetchData11(url11, asTypedArray11 = false) {
                    if (isValidFetchUrl11(url11, document.baseURI)) {
                        const response11 = await fetch(url11);
                        if (!response11.ok) throw new Error(response11.statusText);
                        return asTypedArray11 ? new Uint8Array(await response11.arrayBuffer()) : (0, _util11.stringToBytes)(await response11.text());
                    }
                    return new Promise((resolve11, reject11)=>{
                        const request11 = new XMLHttpRequest();
                        request11.open("GET", url11, true);
                        if (asTypedArray11) request11.responseType = "arraybuffer";
                        request11.onreadystatechange = ()=>{
                            if (request11.readyState !== XMLHttpRequest.DONE) return;
                            if (request11.status === 200 || request11.status === 0) {
                                let data11;
                                if (asTypedArray11 && request11.response) data11 = new Uint8Array(request11.response);
                                else if (!asTypedArray11 && request11.responseText) data11 = (0, _util11.stringToBytes)(request11.responseText);
                                if (data11) {
                                    resolve11(data11);
                                    return;
                                }
                            }
                            reject11(new Error(request11.statusText));
                        };
                        request11.send(null);
                    });
                }
                class DOMCMapReaderFactory11 extends _base_factory11.BaseCMapReaderFactory {
                    _fetchData(url11, compressionType11) {
                        return fetchData11(url11, this.isCompressed).then((data11)=>{
                            return {
                                cMapData: data11,
                                compressionType: compressionType11
                            };
                        });
                    }
                }
                exports11.DOMCMapReaderFactory = DOMCMapReaderFactory11;
                class DOMStandardFontDataFactory11 extends _base_factory11.BaseStandardFontDataFactory {
                    _fetchData(url11) {
                        return fetchData11(url11, true);
                    }
                }
                exports11.DOMStandardFontDataFactory = DOMStandardFontDataFactory11;
                class DOMSVGFactory11 extends _base_factory11.BaseSVGFactory {
                    _createSVG(type11) {
                        return document.createElementNS(SVG_NS11, type11);
                    }
                }
                exports11.DOMSVGFactory = DOMSVGFactory11;
                class PageViewport11 {
                    constructor({ viewBox: viewBox11 , scale: scale11 , rotation: rotation11 , offsetX: offsetX11 = 0 , offsetY: offsetY11 = 0 , dontFlip: dontFlip11 = false  }){
                        this.viewBox = viewBox11;
                        this.scale = scale11;
                        this.rotation = rotation11;
                        this.offsetX = offsetX11;
                        this.offsetY = offsetY11;
                        const centerX11 = (viewBox11[2] + viewBox11[0]) / 2;
                        const centerY11 = (viewBox11[3] + viewBox11[1]) / 2;
                        let rotateA11, rotateB11, rotateC11, rotateD11;
                        rotation11 %= 360;
                        if (rotation11 < 0) rotation11 += 360;
                        switch(rotation11){
                            case 180:
                                rotateA11 = -1;
                                rotateB11 = 0;
                                rotateC11 = 0;
                                rotateD11 = 1;
                                break;
                            case 90:
                                rotateA11 = 0;
                                rotateB11 = 1;
                                rotateC11 = 1;
                                rotateD11 = 0;
                                break;
                            case 270:
                                rotateA11 = 0;
                                rotateB11 = -1;
                                rotateC11 = -1;
                                rotateD11 = 0;
                                break;
                            case 0:
                                rotateA11 = 1;
                                rotateB11 = 0;
                                rotateC11 = 0;
                                rotateD11 = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip11) {
                            rotateC11 = -rotateC11;
                            rotateD11 = -rotateD11;
                        }
                        let offsetCanvasX11, offsetCanvasY11;
                        let width21, height11;
                        if (rotateA11 === 0) {
                            offsetCanvasX11 = Math.abs(centerY11 - viewBox11[1]) * scale11 + offsetX11;
                            offsetCanvasY11 = Math.abs(centerX11 - viewBox11[0]) * scale11 + offsetY11;
                            width21 = Math.abs(viewBox11[3] - viewBox11[1]) * scale11;
                            height11 = Math.abs(viewBox11[2] - viewBox11[0]) * scale11;
                        } else {
                            offsetCanvasX11 = Math.abs(centerX11 - viewBox11[0]) * scale11 + offsetX11;
                            offsetCanvasY11 = Math.abs(centerY11 - viewBox11[1]) * scale11 + offsetY11;
                            width21 = Math.abs(viewBox11[2] - viewBox11[0]) * scale11;
                            height11 = Math.abs(viewBox11[3] - viewBox11[1]) * scale11;
                        }
                        this.transform = [
                            rotateA11 * scale11,
                            rotateB11 * scale11,
                            rotateC11 * scale11,
                            rotateD11 * scale11,
                            offsetCanvasX11 - rotateA11 * scale11 * centerX11 - rotateC11 * scale11 * centerY11,
                            offsetCanvasY11 - rotateB11 * scale11 * centerX11 - rotateD11 * scale11 * centerY11
                        ];
                        this.width = width21;
                        this.height = height11;
                    }
                    clone({ scale: scale11 = this.scale , rotation: rotation11 = this.rotation , offsetX: offsetX11 = this.offsetX , offsetY: offsetY11 = this.offsetY , dontFlip: dontFlip11 = false  } = {}) {
                        return new PageViewport11({
                            viewBox: this.viewBox.slice(),
                            scale: scale11,
                            rotation: rotation11,
                            offsetX: offsetX11,
                            offsetY: offsetY11,
                            dontFlip: dontFlip11
                        });
                    }
                    convertToViewportPoint(x41, y41) {
                        return _util11.Util.applyTransform([
                            x41,
                            y41
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect31) {
                        const topLeft11 = _util11.Util.applyTransform([
                            rect31[0],
                            rect31[1]
                        ], this.transform);
                        const bottomRight11 = _util11.Util.applyTransform([
                            rect31[2],
                            rect31[3]
                        ], this.transform);
                        return [
                            topLeft11[0],
                            topLeft11[1],
                            bottomRight11[0],
                            bottomRight11[1]
                        ];
                    }
                    convertToPdfPoint(x41, y41) {
                        return _util11.Util.applyInverseTransform([
                            x41,
                            y41
                        ], this.transform);
                    }
                }
                exports11.PageViewport = PageViewport11;
                class RenderingCancelledException11 extends _util11.BaseException {
                    constructor(msg11, type11){
                        super(msg11);
                        this.type = type11;
                    }
                }
                exports11.RenderingCancelledException = RenderingCancelledException11;
                const LinkTarget11 = {
                    NONE: 0,
                    SELF: 1,
                    BLANK: 2,
                    PARENT: 3,
                    TOP: 4
                };
                exports11.LinkTarget = LinkTarget11;
                function addLinkAttributes11(link11, { url: url11 , target: target11 , rel: rel11 , enabled: enabled11 = true  } = {}) {
                    (0, _util11.assert)(url11 && typeof url11 === "string", 'addLinkAttributes: A valid "url" parameter must provided.');
                    const urlNullRemoved11 = (0, _util11.removeNullCharacters)(url11);
                    if (enabled11) link11.href = link11.title = urlNullRemoved11;
                    else {
                        link11.href = "";
                        link11.title = `Disabled: ${urlNullRemoved11}`;
                        link11.onclick = ()=>{
                            return false;
                        };
                    }
                    let targetStr11 = "";
                    switch(target11){
                        case LinkTarget11.NONE:
                            break;
                        case LinkTarget11.SELF:
                            targetStr11 = "_self";
                            break;
                        case LinkTarget11.BLANK:
                            targetStr11 = "_blank";
                            break;
                        case LinkTarget11.PARENT:
                            targetStr11 = "_parent";
                            break;
                        case LinkTarget11.TOP:
                            targetStr11 = "_top";
                            break;
                    }
                    link11.target = targetStr11;
                    link11.rel = typeof rel11 === "string" ? rel11 : DEFAULT_LINK_REL11;
                }
                function isDataScheme11(url11) {
                    const ii11 = url11.length;
                    let i11 = 0;
                    while(i11 < ii11 && url11[i11].trim() === "")i11++;
                    return url11.substring(i11, i11 + 5).toLowerCase() === "data:";
                }
                function isPdfFile11(filename11) {
                    return typeof filename11 === "string" && /\.pdf$/i.test(filename11);
                }
                function getFilenameFromUrl11(url11) {
                    const anchor11 = url11.indexOf("#");
                    const query11 = url11.indexOf("?");
                    const end11 = Math.min(anchor11 > 0 ? anchor11 : url11.length, query11 > 0 ? query11 : url11.length);
                    return url11.substring(url11.lastIndexOf("/", end11) + 1, end11);
                }
                function getPdfFilenameFromUrl11(url11, defaultFilename11 = "document.pdf") {
                    if (typeof url11 !== "string") return defaultFilename11;
                    if (isDataScheme11(url11)) {
                        (0, _util11.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename11;
                    }
                    const reURI11 = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename11 = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI11 = reURI11.exec(url11);
                    let suggestedFilename11 = reFilename11.exec(splitURI11[1]) || reFilename11.exec(splitURI11[2]) || reFilename11.exec(splitURI11[3]);
                    if (suggestedFilename11) {
                        suggestedFilename11 = suggestedFilename11[0];
                        if (suggestedFilename11.includes("%")) try {
                            suggestedFilename11 = reFilename11.exec(decodeURIComponent(suggestedFilename11))[0];
                        } catch (ex11) {}
                    }
                    return suggestedFilename11 || defaultFilename11;
                }
                class StatTimer11 {
                    constructor(){
                        this.started = Object.create(null);
                        this.times = [];
                    }
                    time(name11) {
                        if (name11 in this.started) (0, _util11.warn)(`Timer is already running for ${name11}`);
                        this.started[name11] = Date.now();
                    }
                    timeEnd(name11) {
                        if (!(name11 in this.started)) (0, _util11.warn)(`Timer has not been started for ${name11}`);
                        this.times.push({
                            name: name11,
                            start: this.started[name11],
                            end: Date.now()
                        });
                        delete this.started[name11];
                    }
                    toString() {
                        const outBuf11 = [];
                        let longest11 = 0;
                        for (const time11 of this.times){
                            const name11 = time11.name;
                            if (name11.length > longest11) longest11 = name11.length;
                        }
                        for (const time11 of this.times){
                            const duration11 = time11.end - time11.start;
                            outBuf11.push(`${time11.name.padEnd(longest11)} ${duration11}ms\n`);
                        }
                        return outBuf11.join("");
                    }
                }
                exports11.StatTimer = StatTimer11;
                function isValidFetchUrl11(url11, baseUrl11) {
                    try {
                        const { protocol: protocol11  } = baseUrl11 ? new URL(url11, baseUrl11) : new URL(url11);
                        return protocol11 === "http:" || protocol11 === "https:";
                    } catch (ex11) {
                        return false;
                    }
                }
                function loadScript11(src11, removeScriptElement11 = false) {
                    return new Promise((resolve11, reject11)=>{
                        const script11 = document.createElement("script");
                        script11.src = src11;
                        script11.onload = function(evt11) {
                            if (removeScriptElement11) script11.remove();
                            resolve11(evt11);
                        };
                        script11.onerror = function() {
                            reject11(new Error(`Cannot load script at: ${script11.src}`));
                        };
                        (document.head || document.documentElement).appendChild(script11);
                    });
                }
                function deprecated11(details11) {
                    console.log("Deprecated API usage: " + details11);
                }
                let pdfDateStringRegex11;
                class PDFDateString11 {
                    static toDateObject(input11) {
                        if (!input11 || !(0, _util11.isString)(input11)) return null;
                        if (!pdfDateStringRegex11) pdfDateStringRegex11 = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?");
                        const matches11 = pdfDateStringRegex11.exec(input11);
                        if (!matches11) return null;
                        const year11 = parseInt(matches11[1], 10);
                        let month11 = parseInt(matches11[2], 10);
                        month11 = month11 >= 1 && month11 <= 12 ? month11 - 1 : 0;
                        let day11 = parseInt(matches11[3], 10);
                        day11 = day11 >= 1 && day11 <= 31 ? day11 : 1;
                        let hour11 = parseInt(matches11[4], 10);
                        hour11 = hour11 >= 0 && hour11 <= 23 ? hour11 : 0;
                        let minute11 = parseInt(matches11[5], 10);
                        minute11 = minute11 >= 0 && minute11 <= 59 ? minute11 : 0;
                        let second11 = parseInt(matches11[6], 10);
                        second11 = second11 >= 0 && second11 <= 59 ? second11 : 0;
                        const universalTimeRelation11 = matches11[7] || "Z";
                        let offsetHour11 = parseInt(matches11[8], 10);
                        offsetHour11 = offsetHour11 >= 0 && offsetHour11 <= 23 ? offsetHour11 : 0;
                        let offsetMinute11 = parseInt(matches11[9], 10) || 0;
                        offsetMinute11 = offsetMinute11 >= 0 && offsetMinute11 <= 59 ? offsetMinute11 : 0;
                        if (universalTimeRelation11 === "-") {
                            hour11 += offsetHour11;
                            minute11 += offsetMinute11;
                        } else if (universalTimeRelation11 === "+") {
                            hour11 -= offsetHour11;
                            minute11 -= offsetMinute11;
                        }
                        return new Date(Date.UTC(year11, month11, day11, hour11, minute11, second11));
                    }
                }
                exports11.PDFDateString = PDFDateString11;
                function getXfaPageViewport11(xfaPage11, { scale: scale11 = 1 , rotation: rotation11 = 0  }) {
                    const { width: width21 , height: height11  } = xfaPage11.attributes.style;
                    const viewBox11 = [
                        0,
                        0,
                        parseInt(width21),
                        parseInt(height11)
                    ];
                    return new PageViewport11({
                        viewBox: viewBox11,
                        scale: scale11,
                        rotation: rotation11
                    });
                }
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.arrayByteLength = arrayByteLength11;
                exports11.arraysToBytes = arraysToBytes11;
                exports11.assert = assert11;
                exports11.bytesToString = bytesToString11;
                exports11.createObjectURL = createObjectURL11;
                exports11.createPromiseCapability = createPromiseCapability11;
                exports11.createValidAbsoluteUrl = createValidAbsoluteUrl11;
                exports11.escapeString = escapeString11;
                exports11.getModificationDate = getModificationDate11;
                exports11.getVerbosityLevel = getVerbosityLevel11;
                exports11.info = info11;
                exports11.isArrayBuffer = isArrayBuffer11;
                exports11.isArrayEqual = isArrayEqual11;
                exports11.isAscii = isAscii11;
                exports11.isBool = isBool11;
                exports11.isNum = isNum11;
                exports11.isSameOrigin = isSameOrigin11;
                exports11.isString = isString11;
                exports11.objectFromMap = objectFromMap11;
                exports11.objectSize = objectSize11;
                exports11.removeNullCharacters = removeNullCharacters11;
                exports11.setVerbosityLevel = setVerbosityLevel11;
                exports11.shadow = shadow11;
                exports11.string32 = string3211;
                exports11.stringToBytes = stringToBytes11;
                exports11.stringToPDFString = stringToPDFString11;
                exports11.stringToUTF16BEString = stringToUTF16BEString11;
                exports11.stringToUTF8String = stringToUTF8String11;
                exports11.unreachable = unreachable11;
                exports11.utf8StringToString = utf8StringToString11;
                exports11.warn = warn11;
                exports11.VerbosityLevel = exports11.Util = exports11.UNSUPPORTED_FEATURES = exports11.UnknownErrorException = exports11.UnexpectedResponseException = exports11.TextRenderingMode = exports11.StreamType = exports11.PermissionFlag = exports11.PasswordResponses = exports11.PasswordException = exports11.PageActionEventType = exports11.OPS = exports11.MissingPDFException = exports11.IsLittleEndianCached = exports11.IsEvalSupportedCached = exports11.InvalidPDFException = exports11.ImageKind = exports11.IDENTITY_MATRIX = exports11.FormatError = exports11.FontType = exports11.FONT_IDENTITY_MATRIX = exports11.DocumentActionEventType = exports11.CMapCompressionType = exports11.BaseException = exports11.AnnotationType = exports11.AnnotationStateModelType = exports11.AnnotationReviewState = exports11.AnnotationReplyType = exports11.AnnotationMarkedState = exports11.AnnotationFlag = exports11.AnnotationFieldFlag = exports11.AnnotationBorderStyleType = exports11.AnnotationActionEventType = exports11.AbortException = void 0;
                __w_pdfjs_require__11(3);
                const IDENTITY_MATRIX11 = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports11.IDENTITY_MATRIX = IDENTITY_MATRIX11;
                const FONT_IDENTITY_MATRIX11 = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports11.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX11;
                const PermissionFlag11 = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports11.PermissionFlag = PermissionFlag11;
                const TextRenderingMode11 = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports11.TextRenderingMode = TextRenderingMode11;
                const ImageKind11 = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports11.ImageKind = ImageKind11;
                const AnnotationType11 = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports11.AnnotationType = AnnotationType11;
                const AnnotationStateModelType11 = {
                    MARKED: "Marked",
                    REVIEW: "Review"
                };
                exports11.AnnotationStateModelType = AnnotationStateModelType11;
                const AnnotationMarkedState11 = {
                    MARKED: "Marked",
                    UNMARKED: "Unmarked"
                };
                exports11.AnnotationMarkedState = AnnotationMarkedState11;
                const AnnotationReviewState11 = {
                    ACCEPTED: "Accepted",
                    REJECTED: "Rejected",
                    CANCELLED: "Cancelled",
                    COMPLETED: "Completed",
                    NONE: "None"
                };
                exports11.AnnotationReviewState = AnnotationReviewState11;
                const AnnotationReplyType11 = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports11.AnnotationReplyType = AnnotationReplyType11;
                const AnnotationFlag11 = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports11.AnnotationFlag = AnnotationFlag11;
                const AnnotationFieldFlag11 = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports11.AnnotationFieldFlag = AnnotationFieldFlag11;
                const AnnotationBorderStyleType11 = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports11.AnnotationBorderStyleType = AnnotationBorderStyleType11;
                const AnnotationActionEventType11 = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports11.AnnotationActionEventType = AnnotationActionEventType11;
                const DocumentActionEventType11 = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports11.DocumentActionEventType = DocumentActionEventType11;
                const PageActionEventType11 = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports11.PageActionEventType = PageActionEventType11;
                const StreamType11 = {
                    UNKNOWN: "UNKNOWN",
                    FLATE: "FLATE",
                    LZW: "LZW",
                    DCT: "DCT",
                    JPX: "JPX",
                    JBIG: "JBIG",
                    A85: "A85",
                    AHX: "AHX",
                    CCF: "CCF",
                    RLX: "RLX"
                };
                exports11.StreamType = StreamType11;
                const FontType11 = {
                    UNKNOWN: "UNKNOWN",
                    TYPE1: "TYPE1",
                    TYPE1STANDARD: "TYPE1STANDARD",
                    TYPE1C: "TYPE1C",
                    CIDFONTTYPE0: "CIDFONTTYPE0",
                    CIDFONTTYPE0C: "CIDFONTTYPE0C",
                    TRUETYPE: "TRUETYPE",
                    CIDFONTTYPE2: "CIDFONTTYPE2",
                    TYPE3: "TYPE3",
                    OPENTYPE: "OPENTYPE",
                    TYPE0: "TYPE0",
                    MMTYPE1: "MMTYPE1"
                };
                exports11.FontType = FontType11;
                const VerbosityLevel11 = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports11.VerbosityLevel = VerbosityLevel11;
                const CMapCompressionType11 = {
                    NONE: 0,
                    BINARY: 1,
                    STREAM: 2
                };
                exports11.CMapCompressionType = CMapCompressionType11;
                const OPS11 = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotations: 78,
                    endAnnotations: 79,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintJpegXObject: 82,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports11.OPS = OPS11;
                const UNSUPPORTED_FEATURES11 = {
                    unknown: "unknown",
                    forms: "forms",
                    javaScript: "javaScript",
                    signatures: "signatures",
                    smask: "smask",
                    shadingPattern: "shadingPattern",
                    font: "font",
                    errorTilingPattern: "errorTilingPattern",
                    errorExtGState: "errorExtGState",
                    errorXObject: "errorXObject",
                    errorFontLoadType3: "errorFontLoadType3",
                    errorFontState: "errorFontState",
                    errorFontMissing: "errorFontMissing",
                    errorFontTranslate: "errorFontTranslate",
                    errorColorSpace: "errorColorSpace",
                    errorOperatorList: "errorOperatorList",
                    errorFontToUnicode: "errorFontToUnicode",
                    errorFontLoadNative: "errorFontLoadNative",
                    errorFontBuildPath: "errorFontBuildPath",
                    errorFontGetPath: "errorFontGetPath",
                    errorMarkedContent: "errorMarkedContent"
                };
                exports11.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES11;
                const PasswordResponses11 = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports11.PasswordResponses = PasswordResponses11;
                let verbosity11 = VerbosityLevel11.WARNINGS;
                function setVerbosityLevel11(level11) {
                    if (Number.isInteger(level11)) verbosity11 = level11;
                }
                function getVerbosityLevel11() {
                    return verbosity11;
                }
                function info11(msg11) {
                    if (verbosity11 >= VerbosityLevel11.INFOS) console.log(`Info: ${msg11}`);
                }
                function warn11(msg11) {
                    if (verbosity11 >= VerbosityLevel11.WARNINGS) console.log(`Warning: ${msg11}`);
                }
                function unreachable11(msg11) {
                    throw new Error(msg11);
                }
                function assert11(cond11, msg11) {
                    if (!cond11) unreachable11(msg11);
                }
                function isSameOrigin11(baseUrl11, otherUrl11) {
                    let base11;
                    try {
                        base11 = new URL(baseUrl11);
                        if (!base11.origin || base11.origin === "null") return false;
                    } catch (e11) {
                        return false;
                    }
                    const other11 = new URL(otherUrl11, base11);
                    return base11.origin === other11.origin;
                }
                function _isValidProtocol11(url11) {
                    if (!url11) return false;
                    switch(url11.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl11(url11, baseUrl11) {
                    if (!url11) return null;
                    try {
                        const absoluteUrl11 = baseUrl11 ? new URL(url11, baseUrl11) : new URL(url11);
                        if (_isValidProtocol11(absoluteUrl11)) return absoluteUrl11;
                    } catch (ex11) {}
                    return null;
                }
                function shadow11(obj11, prop11, value11) {
                    Object.defineProperty(obj11, prop11, {
                        value: value11,
                        enumerable: true,
                        configurable: true,
                        writable: false
                    });
                    return value11;
                }
                const BaseException11 = function BaseExceptionClosure11() {
                    function BaseException11(message11) {
                        if (this.constructor === BaseException11) unreachable11("Cannot initialize BaseException.");
                        this.message = message11;
                        this.name = this.constructor.name;
                    }
                    BaseException11.prototype = new Error();
                    BaseException11.constructor = BaseException11;
                    return BaseException11;
                }();
                exports11.BaseException = BaseException11;
                class PasswordException11 extends BaseException11 {
                    constructor(msg11, code11){
                        super(msg11);
                        this.code = code11;
                    }
                }
                exports11.PasswordException = PasswordException11;
                class UnknownErrorException11 extends BaseException11 {
                    constructor(msg11, details11){
                        super(msg11);
                        this.details = details11;
                    }
                }
                exports11.UnknownErrorException = UnknownErrorException11;
                class InvalidPDFException11 extends BaseException11 {
                }
                exports11.InvalidPDFException = InvalidPDFException11;
                class MissingPDFException11 extends BaseException11 {
                }
                exports11.MissingPDFException = MissingPDFException11;
                class UnexpectedResponseException11 extends BaseException11 {
                    constructor(msg11, status11){
                        super(msg11);
                        this.status = status11;
                    }
                }
                exports11.UnexpectedResponseException = UnexpectedResponseException11;
                class FormatError11 extends BaseException11 {
                }
                exports11.FormatError = FormatError11;
                class AbortException11 extends BaseException11 {
                }
                exports11.AbortException = AbortException11;
                const NullCharactersRegExp11 = /\x00/g;
                function removeNullCharacters11(str11) {
                    if (typeof str11 !== "string") {
                        warn11("The argument for removeNullCharacters must be a string.");
                        return str11;
                    }
                    return str11.replace(NullCharactersRegExp11, "");
                }
                function bytesToString11(bytes11) {
                    assert11(bytes11 !== null && typeof bytes11 === "object" && bytes11.length !== undefined, "Invalid argument for bytesToString");
                    const length11 = bytes11.length;
                    const MAX_ARGUMENT_COUNT11 = 8192;
                    if (length11 < MAX_ARGUMENT_COUNT11) return String.fromCharCode.apply(null, bytes11);
                    const strBuf11 = [];
                    for(let i11 = 0; i11 < length11; i11 += MAX_ARGUMENT_COUNT11){
                        const chunkEnd11 = Math.min(i11 + MAX_ARGUMENT_COUNT11, length11);
                        const chunk31 = bytes11.subarray(i11, chunkEnd11);
                        strBuf11.push(String.fromCharCode.apply(null, chunk31));
                    }
                    return strBuf11.join("");
                }
                function stringToBytes11(str11) {
                    assert11(typeof str11 === "string", "Invalid argument for stringToBytes");
                    const length11 = str11.length;
                    const bytes11 = new Uint8Array(length11);
                    for(let i11 = 0; i11 < length11; ++i11)bytes11[i11] = str11.charCodeAt(i11) & 0xff;
                    return bytes11;
                }
                function arrayByteLength11(arr31) {
                    if (arr31.length !== undefined) return arr31.length;
                    assert11(arr31.byteLength !== undefined, "arrayByteLength - invalid argument.");
                    return arr31.byteLength;
                }
                function arraysToBytes11(arr31) {
                    const length11 = arr31.length;
                    if (length11 === 1 && arr31[0] instanceof Uint8Array) return arr31[0];
                    let resultLength11 = 0;
                    for(let i11 = 0; i11 < length11; i11++)resultLength11 += arrayByteLength11(arr31[i11]);
                    let pos11 = 0;
                    const data11 = new Uint8Array(resultLength11);
                    for(let i11 = 0; i11 < length11; i11++){
                        let item11 = arr31[i11];
                        if (!(item11 instanceof Uint8Array)) {
                            if (typeof item11 === "string") item11 = stringToBytes11(item11);
                            else item11 = new Uint8Array(item11);
                        }
                        const itemLength11 = item11.byteLength;
                        data11.set(item11, pos11);
                        pos11 += itemLength11;
                    }
                    return data11;
                }
                function string3211(value11) {
                    return String.fromCharCode(value11 >> 24 & 0xff, value11 >> 16 & 0xff, value11 >> 8 & 0xff, value11 & 0xff);
                }
                function objectSize11(obj11) {
                    return Object.keys(obj11).length;
                }
                function objectFromMap11(map11) {
                    const obj11 = Object.create(null);
                    for (const [key11, value11] of map11)obj11[key11] = value11;
                    return obj11;
                }
                function isLittleEndian11() {
                    const buffer811 = new Uint8Array(4);
                    buffer811[0] = 1;
                    const view3211 = new Uint32Array(buffer811.buffer, 0, 1);
                    return view3211[0] === 1;
                }
                const IsLittleEndianCached11 = {
                    get value () {
                        return shadow11(this, "value", isLittleEndian11());
                    }
                };
                exports11.IsLittleEndianCached = IsLittleEndianCached11;
                function isEvalSupported11() {
                    try {
                        new Function("");
                        return true;
                    } catch (e11) {
                        return false;
                    }
                }
                const IsEvalSupportedCached11 = {
                    get value () {
                        return shadow11(this, "value", isEvalSupported11());
                    }
                };
                exports11.IsEvalSupportedCached = IsEvalSupportedCached11;
                const hexNumbers11 = [
                    ...Array(256).keys()
                ].map((n11)=>n11.toString(16).padStart(2, "0"));
                class Util11 {
                    static makeHexColor(r11, g11, b41) {
                        return `#${hexNumbers11[r11]}${hexNumbers11[g11]}${hexNumbers11[b41]}`;
                    }
                    static transform(m111, m211) {
                        return [
                            m111[0] * m211[0] + m111[2] * m211[1],
                            m111[1] * m211[0] + m111[3] * m211[1],
                            m111[0] * m211[2] + m111[2] * m211[3],
                            m111[1] * m211[2] + m111[3] * m211[3],
                            m111[0] * m211[4] + m111[2] * m211[5] + m111[4],
                            m111[1] * m211[4] + m111[3] * m211[5] + m111[5]
                        ];
                    }
                    static applyTransform(p51, m31) {
                        const xt11 = p51[0] * m31[0] + p51[1] * m31[2] + m31[4];
                        const yt11 = p51[0] * m31[1] + p51[1] * m31[3] + m31[5];
                        return [
                            xt11,
                            yt11
                        ];
                    }
                    static applyInverseTransform(p51, m31) {
                        const d51 = m31[0] * m31[3] - m31[1] * m31[2];
                        const xt11 = (p51[0] * m31[3] - p51[1] * m31[2] + m31[2] * m31[5] - m31[4] * m31[3]) / d51;
                        const yt11 = (-p51[0] * m31[1] + p51[1] * m31[0] + m31[4] * m31[1] - m31[5] * m31[0]) / d51;
                        return [
                            xt11,
                            yt11
                        ];
                    }
                    static getAxialAlignedBoundingBox(r11, m31) {
                        const p111 = Util11.applyTransform(r11, m31);
                        const p211 = Util11.applyTransform(r11.slice(2, 4), m31);
                        const p311 = Util11.applyTransform([
                            r11[0],
                            r11[3]
                        ], m31);
                        const p411 = Util11.applyTransform([
                            r11[2],
                            r11[1]
                        ], m31);
                        return [
                            Math.min(p111[0], p211[0], p311[0], p411[0]),
                            Math.min(p111[1], p211[1], p311[1], p411[1]),
                            Math.max(p111[0], p211[0], p311[0], p411[0]),
                            Math.max(p111[1], p211[1], p311[1], p411[1])
                        ];
                    }
                    static inverseTransform(m31) {
                        const d51 = m31[0] * m31[3] - m31[1] * m31[2];
                        return [
                            m31[3] / d51,
                            -m31[1] / d51,
                            -m31[2] / d51,
                            m31[0] / d51,
                            (m31[2] * m31[5] - m31[4] * m31[3]) / d51,
                            (m31[4] * m31[1] - m31[5] * m31[0]) / d51
                        ];
                    }
                    static apply3dTransform(m31, v11) {
                        return [
                            m31[0] * v11[0] + m31[1] * v11[1] + m31[2] * v11[2],
                            m31[3] * v11[0] + m31[4] * v11[1] + m31[5] * v11[2],
                            m31[6] * v11[0] + m31[7] * v11[1] + m31[8] * v11[2]
                        ];
                    }
                    static singularValueDecompose2dScale(m31) {
                        const transpose11 = [
                            m31[0],
                            m31[2],
                            m31[1],
                            m31[3]
                        ];
                        const a11 = m31[0] * transpose11[0] + m31[1] * transpose11[2];
                        const b41 = m31[0] * transpose11[1] + m31[1] * transpose11[3];
                        const c41 = m31[2] * transpose11[0] + m31[3] * transpose11[2];
                        const d51 = m31[2] * transpose11[1] + m31[3] * transpose11[3];
                        const first11 = (a11 + d51) / 2;
                        const second11 = Math.sqrt((a11 + d51) ** 2 - 4 * (a11 * d51 - c41 * b41)) / 2;
                        const sx11 = first11 + second11 || 1;
                        const sy11 = first11 - second11 || 1;
                        return [
                            Math.sqrt(sx11),
                            Math.sqrt(sy11)
                        ];
                    }
                    static normalizeRect(rect31) {
                        const r11 = rect31.slice(0);
                        if (rect31[0] > rect31[2]) {
                            r11[0] = rect31[2];
                            r11[2] = rect31[0];
                        }
                        if (rect31[1] > rect31[3]) {
                            r11[1] = rect31[3];
                            r11[3] = rect31[1];
                        }
                        return r11;
                    }
                    static intersect(rect111, rect211) {
                        function compare11(a11, b41) {
                            return a11 - b41;
                        }
                        const orderedX11 = [
                            rect111[0],
                            rect111[2],
                            rect211[0],
                            rect211[2]
                        ].sort(compare11);
                        const orderedY11 = [
                            rect111[1],
                            rect111[3],
                            rect211[1],
                            rect211[3]
                        ].sort(compare11);
                        const result11 = [];
                        rect111 = Util11.normalizeRect(rect111);
                        rect211 = Util11.normalizeRect(rect211);
                        if (orderedX11[0] === rect111[0] && orderedX11[1] === rect211[0] || orderedX11[0] === rect211[0] && orderedX11[1] === rect111[0]) {
                            result11[0] = orderedX11[1];
                            result11[2] = orderedX11[2];
                        } else return null;
                        if (orderedY11[0] === rect111[1] && orderedY11[1] === rect211[1] || orderedY11[0] === rect211[1] && orderedY11[1] === rect111[1]) {
                            result11[1] = orderedY11[1];
                            result11[3] = orderedY11[2];
                        } else return null;
                        return result11;
                    }
                }
                exports11.Util = Util11;
                const PDFStringTranslateTable11 = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString11(str11) {
                    const length11 = str11.length, strBuf11 = [];
                    if (str11[0] === "\xfe" && str11[1] === "\xff") for(let i11 = 2; i11 < length11; i11 += 2)strBuf11.push(String.fromCharCode(str11.charCodeAt(i11) << 8 | str11.charCodeAt(i11 + 1)));
                    else if (str11[0] === "\xff" && str11[1] === "\xfe") for(let i11 = 2; i11 < length11; i11 += 2)strBuf11.push(String.fromCharCode(str11.charCodeAt(i11 + 1) << 8 | str11.charCodeAt(i11)));
                    else for(let i11 = 0; i11 < length11; ++i11){
                        const code11 = PDFStringTranslateTable11[str11.charCodeAt(i11)];
                        strBuf11.push(code11 ? String.fromCharCode(code11) : str11.charAt(i11));
                    }
                    return strBuf11.join("");
                }
                function escapeString11(str11) {
                    return str11.replace(/([()\\\n\r])/g, (match11)=>{
                        if (match11 === "\n") return "\\n";
                        else if (match11 === "\r") return "\\r";
                        return `\\${match11}`;
                    });
                }
                function isAscii11(str11) {
                    return /^[\x00-\x7F]*$/.test(str11);
                }
                function stringToUTF16BEString11(str11) {
                    const buf11 = [
                        "\xfe\xff"
                    ];
                    for(let i11 = 0, ii11 = str11.length; i11 < ii11; i11++){
                        const char11 = str11.charCodeAt(i11);
                        buf11.push(String.fromCharCode(char11 >> 8 & 0xff), String.fromCharCode(char11 & 0xff));
                    }
                    return buf11.join("");
                }
                function stringToUTF8String11(str11) {
                    return decodeURIComponent(escape(str11));
                }
                function utf8StringToString11(str11) {
                    return unescape(encodeURIComponent(str11));
                }
                function isBool11(v11) {
                    return typeof v11 === "boolean";
                }
                function isNum11(v11) {
                    return typeof v11 === "number";
                }
                function isString11(v11) {
                    return typeof v11 === "string";
                }
                function isArrayBuffer11(v11) {
                    return typeof v11 === "object" && v11 !== null && v11.byteLength !== undefined;
                }
                function isArrayEqual11(arr111, arr211) {
                    if (arr111.length !== arr211.length) return false;
                    for(let i11 = 0, ii11 = arr111.length; i11 < ii11; i11++){
                        if (arr111[i11] !== arr211[i11]) return false;
                    }
                    return true;
                }
                function getModificationDate11(date11 = new Date()) {
                    const buffer11 = [
                        date11.getUTCFullYear().toString(),
                        (date11.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date11.getUTCDate().toString().padStart(2, "0"),
                        date11.getUTCHours().toString().padStart(2, "0"),
                        date11.getUTCMinutes().toString().padStart(2, "0"),
                        date11.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer11.join("");
                }
                function createPromiseCapability11() {
                    const capability11 = Object.create(null);
                    let isSettled11 = false;
                    Object.defineProperty(capability11, "settled", {
                        get () {
                            return isSettled11;
                        }
                    });
                    capability11.promise = new Promise(function(resolve11, reject11) {
                        capability11.resolve = function(data11) {
                            isSettled11 = true;
                            resolve11(data11);
                        };
                        capability11.reject = function(reason11) {
                            isSettled11 = true;
                            reject11(reason11);
                        };
                    });
                    return capability11;
                }
                function createObjectURL11(data11, contentType11 = "", forceDataSchema11 = false) {
                    if (URL.createObjectURL && !forceDataSchema11) return URL.createObjectURL(new Blob([
                        data11
                    ], {
                        type: contentType11
                    }));
                    const digits11 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer11 = `data:${contentType11};base64,`;
                    for(let i11 = 0, ii11 = data11.length; i11 < ii11; i11 += 3){
                        const b111 = data11[i11] & 0xff;
                        const b211 = data11[i11 + 1] & 0xff;
                        const b311 = data11[i11 + 2] & 0xff;
                        const d111 = b111 >> 2, d211 = (b111 & 3) << 4 | b211 >> 4;
                        const d311 = i11 + 1 < ii11 ? (b211 & 0xf) << 2 | b311 >> 6 : 64;
                        const d411 = i11 + 2 < ii11 ? b311 & 0x3f : 64;
                        buffer11 += digits11[d111] + digits11[d211] + digits11[d311] + digits11[d411];
                    }
                    return buffer11;
                }
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module11, __unused_webpack_exports11, __w_pdfjs_require__11)=>{
                var _is_node11 = __w_pdfjs_require__11(4);
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.isNodeJS = void 0;
                const isNodeJS11 = typeof $bcIJv === "object" && $bcIJv + "" === "[object process]" && !$bcIJv.versions.nw && !($bcIJv.versions.electron && $bcIJv.type && $bcIJv.type !== "browser");
                exports11.isNodeJS = isNodeJS11;
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.BaseSVGFactory = exports11.BaseStandardFontDataFactory = exports11.BaseCMapReaderFactory = exports11.BaseCanvasFactory = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                class BaseCanvasFactory11 {
                    constructor(){
                        if (this.constructor === BaseCanvasFactory11) (0, _util11.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                    create(width21, height11) {
                        if (width21 <= 0 || height11 <= 0) throw new Error("Invalid canvas size");
                        const canvas11 = this._createCanvas(width21, height11);
                        return {
                            canvas: canvas11,
                            context: canvas11.getContext("2d")
                        };
                    }
                    reset(canvasAndContext11, width21, height11) {
                        if (!canvasAndContext11.canvas) throw new Error("Canvas is not specified");
                        if (width21 <= 0 || height11 <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext11.canvas.width = width21;
                        canvasAndContext11.canvas.height = height11;
                    }
                    destroy(canvasAndContext11) {
                        if (!canvasAndContext11.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext11.canvas.width = 0;
                        canvasAndContext11.canvas.height = 0;
                        canvasAndContext11.canvas = null;
                        canvasAndContext11.context = null;
                    }
                    _createCanvas(width21, height11) {
                        (0, _util11.unreachable)("Abstract method `_createCanvas` called.");
                    }
                }
                exports11.BaseCanvasFactory = BaseCanvasFactory11;
                class BaseCMapReaderFactory11 {
                    constructor({ baseUrl: baseUrl11 = null , isCompressed: isCompressed11 = false  }){
                        if (this.constructor === BaseCMapReaderFactory11) (0, _util11.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl11;
                        this.isCompressed = isCompressed11;
                    }
                    async fetch({ name: name11  }) {
                        if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                        if (!name11) throw new Error("CMap name must be specified.");
                        const url11 = this.baseUrl + name11 + (this.isCompressed ? ".bcmap" : "");
                        const compressionType11 = this.isCompressed ? _util11.CMapCompressionType.BINARY : _util11.CMapCompressionType.NONE;
                        return this._fetchData(url11, compressionType11).catch((reason11)=>{
                            throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url11}`);
                        });
                    }
                    _fetchData(url11, compressionType11) {
                        (0, _util11.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports11.BaseCMapReaderFactory = BaseCMapReaderFactory11;
                class BaseStandardFontDataFactory11 {
                    constructor({ baseUrl: baseUrl11 = null  }){
                        if (this.constructor === BaseStandardFontDataFactory11) (0, _util11.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl11;
                    }
                    async fetch({ filename: filename11  }) {
                        if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                        if (!filename11) throw new Error("Font filename must be specified.");
                        const url11 = `${this.baseUrl}${filename11}`;
                        return this._fetchData(url11).catch((reason11)=>{
                            throw new Error(`Unable to load font data at: ${url11}`);
                        });
                    }
                    _fetchData(url11) {
                        (0, _util11.unreachable)("Abstract method `_fetchData` called.");
                    }
                }
                exports11.BaseStandardFontDataFactory = BaseStandardFontDataFactory11;
                class BaseSVGFactory11 {
                    constructor(){
                        if (this.constructor === BaseSVGFactory11) (0, _util11.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                    create(width21, height11) {
                        if (width21 <= 0 || height11 <= 0) throw new Error("Invalid SVG dimensions");
                        const svg11 = this._createSVG("svg:svg");
                        svg11.setAttribute("version", "1.1");
                        svg11.setAttribute("width", `${width21}px`);
                        svg11.setAttribute("height", `${height11}px`);
                        svg11.setAttribute("preserveAspectRatio", "none");
                        svg11.setAttribute("viewBox", `0 0 ${width21} ${height11}`);
                        return svg11;
                    }
                    createElement(type11) {
                        if (typeof type11 !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type11);
                    }
                    _createSVG(type11) {
                        (0, _util11.unreachable)("Abstract method `_createSVG` called.");
                    }
                }
                exports11.BaseSVGFactory = BaseSVGFactory11;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getDocument = getDocument;
                exports.setPDFNetworkStreamFactory = setPDFNetworkStreamFactory;
                exports.version = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultCMapReaderFactory = exports.DefaultCanvasFactory = exports.build = void 0;
                var _util = __w_pdfjs_require__(2);
                var _display_utils = __w_pdfjs_require__(1);
                var _font_loader = __w_pdfjs_require__(7);
                var _node_utils = __w_pdfjs_require__(8);
                var _annotation_storage = __w_pdfjs_require__(9);
                var _canvas = __w_pdfjs_require__(10);
                var _worker_options = __w_pdfjs_require__(12);
                var _is_node = __w_pdfjs_require__(4);
                var _message_handler = __w_pdfjs_require__(13);
                var _metadata = __w_pdfjs_require__(14);
                var _optional_content_config = __w_pdfjs_require__(15);
                var _transport_stream = __w_pdfjs_require__(16);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DefaultCanvasFactory = _is_node.isNodeJS ? _node_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _is_node.isNodeJS ? _node_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultStandardFontDataFactory = _is_node.isNodeJS ? _node_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                let createPDFNetworkStream;
                function setPDFNetworkStreamFactory(pdfNetworkStreamFactory11) {
                    createPDFNetworkStream = pdfNetworkStreamFactory11;
                }
                function getDocument(src11) {
                    const task11 = new PDFDocumentLoadingTask();
                    let source11;
                    if (typeof src11 === "string" || src11 instanceof URL) source11 = {
                        url: src11
                    };
                    else if ((0, _util.isArrayBuffer)(src11)) source11 = {
                        data: src11
                    };
                    else if (src11 instanceof PDFDataRangeTransport) source11 = {
                        range: src11
                    };
                    else {
                        if (typeof src11 !== "object") throw new Error("Invalid parameter in getDocument, need either string, URL, Uint8Array, or parameter object.");
                        if (!src11.url && !src11.data && !src11.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                        source11 = src11;
                    }
                    const params11 = Object.create(null);
                    let rangeTransport11 = null, worker11 = null;
                    for(const key11 in source11){
                        const value11 = source11[key11];
                        switch(key11){
                            case "url":
                                if (typeof window !== "undefined") try {
                                    params11[key11] = new URL(value11, window.location).href;
                                    continue;
                                } catch (ex11) {
                                    (0, _util.warn)(`Cannot create valid URL: "${ex11}".`);
                                }
                                else if (typeof value11 === "string" || value11 instanceof URL) {
                                    params11[key11] = value11.toString();
                                    continue;
                                }
                                throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                            case "range":
                                rangeTransport11 = value11;
                                continue;
                            case "worker":
                                worker11 = value11;
                                continue;
                            case "data":
                                if (_is_node.isNodeJS && typeof $8a1ac77efddccc8e$require$Buffer !== "undefined" && value11 instanceof $8a1ac77efddccc8e$require$Buffer) params11[key11] = new Uint8Array(value11);
                                else if (value11 instanceof Uint8Array) break;
                                else if (typeof value11 === "string") params11[key11] = (0, _util.stringToBytes)(value11);
                                else if (typeof value11 === "object" && value11 !== null && !isNaN(value11.length)) params11[key11] = new Uint8Array(value11);
                                else if ((0, _util.isArrayBuffer)(value11)) params11[key11] = new Uint8Array(value11);
                                else throw new Error("Invalid PDF binary data: either typed array, string, or array-like object is expected in the data property.");
                                continue;
                        }
                        params11[key11] = value11;
                    }
                    params11.rangeChunkSize = params11.rangeChunkSize || DEFAULT_RANGE_CHUNK_SIZE;
                    params11.CMapReaderFactory = params11.CMapReaderFactory || DefaultCMapReaderFactory;
                    params11.StandardFontDataFactory = params11.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    params11.ignoreErrors = params11.stopAtErrors !== true;
                    params11.fontExtraProperties = params11.fontExtraProperties === true;
                    params11.pdfBug = params11.pdfBug === true;
                    params11.enableXfa = params11.enableXfa === true;
                    if (typeof params11.docBaseUrl !== "string" || (0, _display_utils.isDataScheme)(params11.docBaseUrl)) params11.docBaseUrl = null;
                    if (!Number.isInteger(params11.maxImageSize)) params11.maxImageSize = -1;
                    if (typeof params11.useWorkerFetch !== "boolean") params11.useWorkerFetch = params11.CMapReaderFactory === _display_utils.DOMCMapReaderFactory && params11.StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory;
                    if (typeof params11.isEvalSupported !== "boolean") params11.isEvalSupported = true;
                    if (typeof params11.disableFontFace !== "boolean") params11.disableFontFace = _is_node.isNodeJS;
                    if (typeof params11.useSystemFonts !== "boolean") params11.useSystemFonts = !_is_node.isNodeJS && !params11.disableFontFace;
                    if (typeof params11.ownerDocument === "undefined") params11.ownerDocument = globalThis.document;
                    if (typeof params11.disableRange !== "boolean") params11.disableRange = false;
                    if (typeof params11.disableStream !== "boolean") params11.disableStream = false;
                    if (typeof params11.disableAutoFetch !== "boolean") params11.disableAutoFetch = false;
                    (0, _util.setVerbosityLevel)(params11.verbosity);
                    if (!worker11) {
                        const workerParams11 = {
                            verbosity: params11.verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker11 = workerParams11.port ? PDFWorker.fromPort(workerParams11) : new PDFWorker(workerParams11);
                        task11._worker = worker11;
                    }
                    const docId11 = task11.docId;
                    worker11.promise.then(function() {
                        if (task11.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise11 = _fetchDocument(worker11, params11, rangeTransport11, docId11);
                        const networkStreamPromise11 = new Promise(function(resolve11) {
                            let networkStream11;
                            if (rangeTransport11) networkStream11 = new _transport_stream.PDFDataTransportStream({
                                length: params11.length,
                                initialData: params11.initialData,
                                progressiveDone: params11.progressiveDone,
                                contentDispositionFilename: params11.contentDispositionFilename,
                                disableRange: params11.disableRange,
                                disableStream: params11.disableStream
                            }, rangeTransport11);
                            else if (!params11.data) networkStream11 = createPDFNetworkStream({
                                url: params11.url,
                                length: params11.length,
                                httpHeaders: params11.httpHeaders,
                                withCredentials: params11.withCredentials,
                                rangeChunkSize: params11.rangeChunkSize,
                                disableRange: params11.disableRange,
                                disableStream: params11.disableStream
                            });
                            resolve11(networkStream11);
                        });
                        return Promise.all([
                            workerIdPromise11,
                            networkStreamPromise11
                        ]).then(function([workerId11, networkStream11]) {
                            if (task11.destroyed) throw new Error("Loading aborted");
                            const messageHandler11 = new _message_handler.MessageHandler(docId11, workerId11, worker11.port);
                            messageHandler11.postMessageTransfers = worker11.postMessageTransfers;
                            const transport11 = new WorkerTransport(messageHandler11, task11, networkStream11, params11);
                            task11._transport = transport11;
                            messageHandler11.send("Ready", null);
                        });
                    }).catch(task11._capability.reject);
                    return task11;
                }
                function _fetchDocument(worker11, source11, pdfDataRangeTransport11, docId11) {
                    if (worker11.destroyed) return Promise.reject(new Error("Worker was destroyed"));
                    if (pdfDataRangeTransport11) {
                        source11.length = pdfDataRangeTransport11.length;
                        source11.initialData = pdfDataRangeTransport11.initialData;
                        source11.progressiveDone = pdfDataRangeTransport11.progressiveDone;
                        source11.contentDispositionFilename = pdfDataRangeTransport11.contentDispositionFilename;
                    }
                    return worker11.messageHandler.sendWithPromise("GetDocRequest", {
                        docId: docId11,
                        apiVersion: "2.10.377",
                        source: {
                            data: source11.data,
                            url: source11.url,
                            password: source11.password,
                            disableAutoFetch: source11.disableAutoFetch,
                            rangeChunkSize: source11.rangeChunkSize,
                            length: source11.length
                        },
                        maxImageSize: source11.maxImageSize,
                        disableFontFace: source11.disableFontFace,
                        postMessageTransfers: worker11.postMessageTransfers,
                        docBaseUrl: source11.docBaseUrl,
                        ignoreErrors: source11.ignoreErrors,
                        isEvalSupported: source11.isEvalSupported,
                        fontExtraProperties: source11.fontExtraProperties,
                        enableXfa: source11.enableXfa,
                        useSystemFonts: source11.useSystemFonts,
                        cMapUrl: source11.useWorkerFetch ? source11.cMapUrl : null,
                        standardFontDataUrl: source11.useWorkerFetch ? source11.standardFontDataUrl : null
                    }).then(function(workerId11) {
                        if (worker11.destroyed) throw new Error("Worker was destroyed");
                        return workerId11;
                    });
                }
                const PDFDocumentLoadingTask = function PDFDocumentLoadingTaskClosure11() {
                    let nextDocumentId11 = 0;
                    class PDFDocumentLoadingTask11 {
                        constructor(){
                            this._capability = (0, _util.createPromiseCapability)();
                            this._transport = null;
                            this._worker = null;
                            this.docId = "d" + nextDocumentId11++;
                            this.destroyed = false;
                            this.onPassword = null;
                            this.onProgress = null;
                            this.onUnsupportedFeature = null;
                        }
                        get promise() {
                            return this._capability.promise;
                        }
                        destroy() {
                            this.destroyed = true;
                            const transportDestroyed11 = !this._transport ? Promise.resolve() : this._transport.destroy();
                            return transportDestroyed11.then(()=>{
                                this._transport = null;
                                if (this._worker) {
                                    this._worker.destroy();
                                    this._worker = null;
                                }
                            });
                        }
                    }
                    return PDFDocumentLoadingTask11;
                }();
                class PDFDataRangeTransport {
                    constructor(length11, initialData11, progressiveDone11 = false, contentDispositionFilename11 = null){
                        this.length = length11;
                        this.initialData = initialData11;
                        this.progressiveDone = progressiveDone11;
                        this.contentDispositionFilename = contentDispositionFilename11;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = (0, _util.createPromiseCapability)();
                    }
                    addRangeListener(listener11) {
                        this._rangeListeners.push(listener11);
                    }
                    addProgressListener(listener11) {
                        this._progressListeners.push(listener11);
                    }
                    addProgressiveReadListener(listener11) {
                        this._progressiveReadListeners.push(listener11);
                    }
                    addProgressiveDoneListener(listener11) {
                        this._progressiveDoneListeners.push(listener11);
                    }
                    onDataRange(begin11, chunk31) {
                        for (const listener11 of this._rangeListeners)listener11(begin11, chunk31);
                    }
                    onDataProgress(loaded11, total11) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener11 of this._progressListeners)listener11(loaded11, total11);
                        });
                    }
                    onDataProgressiveRead(chunk31) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener11 of this._progressiveReadListeners)listener11(chunk31);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener11 of this._progressiveDoneListeners)listener11();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin11, end11) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    constructor(pdfInfo11, transport11){
                        this._pdfInfo = pdfInfo11;
                        this._transport = transport11;
                        Object.defineProperty(this, "fingerprint", {
                            get () {
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.fingerprint`, please use `PDFDocumentProxy.fingerprints` instead.");
                                return this.fingerprints[0];
                            }
                        });
                    }
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return !!this._transport._htmlForXfa;
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber11) {
                        return this._transport.getPage(pageNumber11);
                    }
                    getPageIndex(ref11) {
                        return this._transport.getPageIndex(ref11);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id11) {
                        return this._transport.getDestination(id11);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJavaScript() {
                        return this._transport.getJavaScript();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    getStats() {
                        return this._transport.getStats();
                    }
                    cleanup(keepLoadedFonts11 = false) {
                        return this._transport.startCleanup(keepLoadedFonts11 || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    saveDocument() {
                        if (this._transport.annotationStorage.size <= 0) (0, _display_utils.deprecated)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        return this._transport.saveDocument();
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                class PDFPageProxy {
                    constructor(pageIndex11, pageInfo11, transport11, ownerDocument11, pdfBug11 = false){
                        this._pageIndex = pageIndex11;
                        this._pageInfo = pageInfo11;
                        this._ownerDocument = ownerDocument11;
                        this._transport = transport11;
                        this._stats = pdfBug11 ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug11;
                        this.commonObjs = transport11.commonObjs;
                        this.objs = new PDFObjects();
                        this.cleanupAfterRender = false;
                        this.pendingCleanup = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale: scale11 , rotation: rotation11 = this.rotate , offsetX: offsetX11 = 0 , offsetY: offsetY11 = 0 , dontFlip: dontFlip11 = false  } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale11,
                            rotation: rotation11,
                            offsetX: offsetX11,
                            offsetY: offsetY11,
                            dontFlip: dontFlip11
                        });
                    }
                    getAnnotations({ intent: intent11 = null  } = {}) {
                        const renderingIntent11 = intent11 === "display" || intent11 === "print" ? intent11 : null;
                        if (!this._annotationsPromise || this._annotationsIntent !== renderingIntent11) {
                            this._annotationsPromise = this._transport.getAnnotations(this._pageIndex, renderingIntent11);
                            this._annotationsIntent = renderingIntent11;
                        }
                        return this._annotationsPromise;
                    }
                    getJSActions() {
                        return this._jsActionsPromise || (this._jsActionsPromise = this._transport.getPageJSActions(this._pageIndex));
                    }
                    async getXfa() {
                        return this._transport._htmlForXfa?.children[this._pageIndex] || null;
                    }
                    render({ canvasContext: canvasContext11 , viewport: viewport11 , intent: intent11 = "display" , renderInteractiveForms: renderInteractiveForms11 = false , transform: transform11 = null , imageLayer: imageLayer11 = null , canvasFactory: canvasFactory11 = null , background: background11 = null , includeAnnotationStorage: includeAnnotationStorage11 = false , optionalContentConfigPromise: optionalContentConfigPromise11 = null  }) {
                        var _intentState11;
                        if (this._stats) this._stats.time("Overall");
                        const renderingIntent11 = intent11 === "print" ? "print" : "display";
                        this.pendingCleanup = false;
                        if (!optionalContentConfigPromise11) optionalContentConfigPromise11 = this._transport.getOptionalContentConfig();
                        let intentState11 = this._intentStates.get(renderingIntent11);
                        if (!intentState11) {
                            intentState11 = Object.create(null);
                            this._intentStates.set(renderingIntent11, intentState11);
                        }
                        if (intentState11.streamReaderCancelTimeout) {
                            clearTimeout(intentState11.streamReaderCancelTimeout);
                            intentState11.streamReaderCancelTimeout = null;
                        }
                        const canvasFactoryInstance11 = canvasFactory11 || new DefaultCanvasFactory({
                            ownerDocument: this._ownerDocument
                        });
                        const annotationStorage11 = includeAnnotationStorage11 ? this._transport.annotationStorage.serializable : null;
                        if (!intentState11.displayReadyCapability) {
                            intentState11.displayReadyCapability = (0, _util.createPromiseCapability)();
                            intentState11.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false
                            };
                            if (this._stats) this._stats.time("Page Request");
                            this._pumpOperatorList({
                                pageIndex: this._pageIndex,
                                intent: renderingIntent11,
                                renderInteractiveForms: renderInteractiveForms11 === true,
                                annotationStorage: annotationStorage11
                            });
                        }
                        const complete11 = (error11)=>{
                            intentState11.renderTasks.delete(internalRenderTask11);
                            if (this.cleanupAfterRender || renderingIntent11 === "print") this.pendingCleanup = true;
                            this._tryCleanup();
                            if (error11) {
                                internalRenderTask11.capability.reject(error11);
                                this._abortOperatorList({
                                    intentState: intentState11,
                                    reason: error11
                                });
                            } else internalRenderTask11.capability.resolve();
                            if (this._stats) {
                                this._stats.timeEnd("Rendering");
                                this._stats.timeEnd("Overall");
                            }
                        };
                        const internalRenderTask11 = new InternalRenderTask({
                            callback: complete11,
                            params: {
                                canvasContext: canvasContext11,
                                viewport: viewport11,
                                transform: transform11,
                                imageLayer: imageLayer11,
                                background: background11
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            operatorList: intentState11.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: canvasFactoryInstance11,
                            useRequestAnimationFrame: renderingIntent11 !== "print",
                            pdfBug: this._pdfBug
                        });
                        ((_intentState11 = intentState11).renderTasks || (_intentState11.renderTasks = new Set())).add(internalRenderTask11);
                        const renderTask11 = internalRenderTask11.task;
                        Promise.all([
                            intentState11.displayReadyCapability.promise,
                            optionalContentConfigPromise11
                        ]).then(([transparency11, optionalContentConfig11])=>{
                            if (this.pendingCleanup) {
                                complete11();
                                return;
                            }
                            if (this._stats) this._stats.time("Rendering");
                            internalRenderTask11.initializeGraphics({
                                transparency: transparency11,
                                optionalContentConfig: optionalContentConfig11
                            });
                            internalRenderTask11.operatorListChanged();
                        }).catch(complete11);
                        return renderTask11;
                    }
                    getOperatorList({ intent: intent11 = "display"  } = {}) {
                        function operatorListChanged11() {
                            if (intentState11.operatorList.lastChunk) {
                                intentState11.opListReadCapability.resolve(intentState11.operatorList);
                                intentState11.renderTasks.delete(opListTask11);
                            }
                        }
                        const renderingIntent11 = `oplist-${intent11 === "print" ? "print" : "display"}`;
                        let intentState11 = this._intentStates.get(renderingIntent11);
                        if (!intentState11) {
                            intentState11 = Object.create(null);
                            this._intentStates.set(renderingIntent11, intentState11);
                        }
                        let opListTask11;
                        if (!intentState11.opListReadCapability) {
                            var _intentState211;
                            opListTask11 = Object.create(null);
                            opListTask11.operatorListChanged = operatorListChanged11;
                            intentState11.opListReadCapability = (0, _util.createPromiseCapability)();
                            ((_intentState211 = intentState11).renderTasks || (_intentState211.renderTasks = new Set())).add(opListTask11);
                            intentState11.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false
                            };
                            if (this._stats) this._stats.time("Page Request");
                            this._pumpOperatorList({
                                pageIndex: this._pageIndex,
                                intent: renderingIntent11
                            });
                        }
                        return intentState11.opListReadCapability.promise;
                    }
                    streamTextContent({ normalizeWhitespace: normalizeWhitespace11 = false , disableCombineTextItems: disableCombineTextItems11 = false , includeMarkedContent: includeMarkedContent11 = false  } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE11 = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            normalizeWhitespace: normalizeWhitespace11 === true,
                            combineTextItems: disableCombineTextItems11 !== true,
                            includeMarkedContent: includeMarkedContent11 === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE11,
                            size (textContent11) {
                                return textContent11.items.length;
                            }
                        });
                    }
                    getTextContent(params11 = {}) {
                        const readableStream11 = this.streamTextContent(params11);
                        return new Promise(function(resolve11, reject11) {
                            function pump11() {
                                reader11.read().then(function({ value: value11 , done: done11  }) {
                                    if (done11) {
                                        resolve11(textContent11);
                                        return;
                                    }
                                    Object.assign(textContent11.styles, value11.styles);
                                    textContent11.items.push(...value11.items);
                                    pump11();
                                }, reject11);
                            }
                            const reader11 = readableStream11.getReader();
                            const textContent11 = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump11();
                        });
                    }
                    getStructTree() {
                        return this._structTreePromise || (this._structTreePromise = this._transport.getStructTree(this._pageIndex));
                    }
                    _destroy() {
                        this.destroyed = true;
                        this._transport.pageCache[this._pageIndex] = null;
                        const waitOn11 = [];
                        for (const [intent11, intentState11] of this._intentStates){
                            this._abortOperatorList({
                                intentState: intentState11,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intent11.startsWith("oplist-")) continue;
                            for (const internalRenderTask11 of intentState11.renderTasks){
                                waitOn11.push(internalRenderTask11.completed);
                                internalRenderTask11.cancel();
                            }
                        }
                        this.objs.clear();
                        this._annotationsPromise = null;
                        this._jsActionsPromise = null;
                        this._structTreePromise = null;
                        this.pendingCleanup = false;
                        return Promise.all(waitOn11);
                    }
                    cleanup(resetStats11 = false) {
                        this.pendingCleanup = true;
                        return this._tryCleanup(resetStats11);
                    }
                    _tryCleanup(resetStats11 = false) {
                        if (!this.pendingCleanup) return false;
                        for (const { renderTasks: renderTasks11 , operatorList: operatorList11  } of this._intentStates.values()){
                            if (renderTasks11.size > 0 || !operatorList11.lastChunk) return false;
                        }
                        this._intentStates.clear();
                        this.objs.clear();
                        this._annotationsPromise = null;
                        this._jsActionsPromise = null;
                        this._structTreePromise = null;
                        if (resetStats11 && this._stats) this._stats = new _display_utils.StatTimer();
                        this.pendingCleanup = false;
                        return true;
                    }
                    _startRenderPage(transparency11, intent11) {
                        const intentState11 = this._intentStates.get(intent11);
                        if (!intentState11) return;
                        if (this._stats) this._stats.timeEnd("Page Request");
                        if (intentState11.displayReadyCapability) intentState11.displayReadyCapability.resolve(transparency11);
                    }
                    _renderPageChunk(operatorListChunk11, intentState11) {
                        for(let i11 = 0, ii11 = operatorListChunk11.length; i11 < ii11; i11++){
                            intentState11.operatorList.fnArray.push(operatorListChunk11.fnArray[i11]);
                            intentState11.operatorList.argsArray.push(operatorListChunk11.argsArray[i11]);
                        }
                        intentState11.operatorList.lastChunk = operatorListChunk11.lastChunk;
                        for (const internalRenderTask11 of intentState11.renderTasks)internalRenderTask11.operatorListChanged();
                        if (operatorListChunk11.lastChunk) this._tryCleanup();
                    }
                    _pumpOperatorList(args11) {
                        (0, _util.assert)(args11.intent, 'PDFPageProxy._pumpOperatorList: Expected "intent" argument.');
                        const readableStream11 = this._transport.messageHandler.sendWithStream("GetOperatorList", args11);
                        const reader11 = readableStream11.getReader();
                        const intentState11 = this._intentStates.get(args11.intent);
                        intentState11.streamReader = reader11;
                        const pump11 = ()=>{
                            reader11.read().then(({ value: value11 , done: done11  })=>{
                                if (done11) {
                                    intentState11.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value11, intentState11);
                                pump11();
                            }, (reason11)=>{
                                intentState11.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState11.operatorList) {
                                    intentState11.operatorList.lastChunk = true;
                                    for (const internalRenderTask11 of intentState11.renderTasks)internalRenderTask11.operatorListChanged();
                                    this._tryCleanup();
                                }
                                if (intentState11.displayReadyCapability) intentState11.displayReadyCapability.reject(reason11);
                                else if (intentState11.opListReadCapability) intentState11.opListReadCapability.reject(reason11);
                                else throw reason11;
                            });
                        };
                        pump11();
                    }
                    _abortOperatorList({ intentState: intentState11 , reason: reason11 , force: force11 = false  }) {
                        (0, _util.assert)(reason11 instanceof Error || typeof reason11 === "object" && reason11 !== null, 'PDFPageProxy._abortOperatorList: Expected "reason" argument.');
                        if (!intentState11.streamReader) return;
                        if (!force11) {
                            if (intentState11.renderTasks.size > 0) return;
                            if (reason11 instanceof _display_utils.RenderingCancelledException) {
                                intentState11.streamReaderCancelTimeout = setTimeout(()=>{
                                    this._abortOperatorList({
                                        intentState: intentState11,
                                        reason: reason11,
                                        force: true
                                    });
                                    intentState11.streamReaderCancelTimeout = null;
                                }, RENDERING_CANCELLED_TIMEOUT);
                                return;
                            }
                        }
                        intentState11.streamReader.cancel(new _util.AbortException(reason11?.message));
                        intentState11.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [intent11, curIntentState11] of this._intentStates)if (curIntentState11 === intentState11) {
                            this._intentStates.delete(intent11);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                class LoopbackPort {
                    constructor(){
                        this._listeners = [];
                        this._deferred = Promise.resolve(undefined);
                    }
                    postMessage(obj11, transfers11) {
                        function cloneValue11(value11) {
                            if (typeof value11 === "function" || typeof value11 === "symbol" || value11 instanceof URL) throw new Error(`LoopbackPort.postMessage - cannot clone: ${value11?.toString()}`);
                            if (typeof value11 !== "object" || value11 === null) return value11;
                            if (cloned11.has(value11)) return cloned11.get(value11);
                            let buffer11, result11;
                            if ((buffer11 = value11.buffer) && (0, _util.isArrayBuffer)(buffer11)) {
                                if (transfers11?.includes(buffer11)) result11 = new value11.constructor(buffer11, value11.byteOffset, value11.byteLength);
                                else result11 = new value11.constructor(value11);
                                cloned11.set(value11, result11);
                                return result11;
                            }
                            if (value11 instanceof Map) {
                                result11 = new Map();
                                cloned11.set(value11, result11);
                                for (const [key11, val11] of value11)result11.set(key11, cloneValue11(val11));
                                return result11;
                            }
                            if (value11 instanceof Set) {
                                result11 = new Set();
                                cloned11.set(value11, result11);
                                for (const val11 of value11)result11.add(cloneValue11(val11));
                                return result11;
                            }
                            result11 = Array.isArray(value11) ? [] : Object.create(null);
                            cloned11.set(value11, result11);
                            for(const i11 in value11){
                                let desc11, p51 = value11;
                                while(!(desc11 = Object.getOwnPropertyDescriptor(p51, i11)))p51 = Object.getPrototypeOf(p51);
                                if (typeof desc11.value === "undefined") continue;
                                if (typeof desc11.value === "function" && !value11.hasOwnProperty?.(i11)) continue;
                                result11[i11] = cloneValue11(desc11.value);
                            }
                            return result11;
                        }
                        const cloned11 = new WeakMap();
                        const event11 = {
                            data: cloneValue11(obj11)
                        };
                        this._deferred.then(()=>{
                            for (const listener11 of this._listeners)listener11.call(this, event11);
                        });
                    }
                    addEventListener(name11, listener11) {
                        this._listeners.push(listener11);
                    }
                    removeEventListener(name11, listener11) {
                        const i11 = this._listeners.indexOf(listener11);
                        this._listeners.splice(i11, 1);
                    }
                    terminate() {
                        this._listeners.length = 0;
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorker = function PDFWorkerClosure() {
                    const pdfWorkerPorts = new WeakMap();
                    let isWorkerDisabled = false;
                    let fallbackWorkerSrc;
                    let nextFakeWorkerId = 0;
                    let fakeWorkerCapability;
                    if (_is_node.isNodeJS && true) {
                        isWorkerDisabled = true;
                        fallbackWorkerSrc = "./pdf.worker.js";
                    } else if (typeof document === "object" && "currentScript" in document) {
                        const pdfjsFilePath = document.currentScript?.src;
                        if (pdfjsFilePath) fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                    }
                    function getWorkerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (typeof fallbackWorkerSrc !== "undefined") {
                            if (!_is_node.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    function getMainThreadWorkerMessageHandler() {
                        let mainWorkerMessageHandler11;
                        try {
                            mainWorkerMessageHandler11 = globalThis.pdfjsWorker?.WorkerMessageHandler;
                        } catch (ex11) {}
                        return mainWorkerMessageHandler11 || null;
                    }
                    function setupFakeWorkerGlobal() {
                        if (fakeWorkerCapability) return fakeWorkerCapability.promise;
                        fakeWorkerCapability = (0, _util.createPromiseCapability)();
                        const loader = async function() {
                            const mainWorkerMessageHandler = getMainThreadWorkerMessageHandler();
                            if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                            if (_is_node.isNodeJS && true) {
                                const worker = eval("require")(getWorkerSrc());
                                return worker.WorkerMessageHandler;
                            }
                            await (0, _display_utils.loadScript)(getWorkerSrc());
                            return window.pdfjsWorker.WorkerMessageHandler;
                        };
                        loader().then(fakeWorkerCapability.resolve, fakeWorkerCapability.reject);
                        return fakeWorkerCapability.promise;
                    }
                    function createCDNWrapper(url11) {
                        const wrapper11 = "importScripts('" + url11 + "');";
                        return URL.createObjectURL(new Blob([
                            wrapper11
                        ]));
                    }
                    class PDFWorker {
                        constructor({ name: name11 = null , port: port11 = null , verbosity: verbosity11 = (0, _util.getVerbosityLevel)()  } = {}){
                            if (port11 && pdfWorkerPorts.has(port11)) throw new Error("Cannot use more than one PDFWorker per port");
                            this.name = name11;
                            this.destroyed = false;
                            this.postMessageTransfers = true;
                            this.verbosity = verbosity11;
                            this._readyCapability = (0, _util.createPromiseCapability)();
                            this._port = null;
                            this._webWorker = null;
                            this._messageHandler = null;
                            if (port11) {
                                pdfWorkerPorts.set(port11, this);
                                this._initializeFromPort(port11);
                                return;
                            }
                            this._initialize();
                        }
                        get promise() {
                            return this._readyCapability.promise;
                        }
                        get port() {
                            return this._port;
                        }
                        get messageHandler() {
                            return this._messageHandler;
                        }
                        _initializeFromPort(port11) {
                            this._port = port11;
                            this._messageHandler = new _message_handler.MessageHandler("main", "worker", port11);
                            this._messageHandler.on("ready", function() {});
                            this._readyCapability.resolve();
                        }
                        _initialize() {
                            if (typeof Worker !== "undefined" && !isWorkerDisabled && !getMainThreadWorkerMessageHandler()) {
                                let workerSrc11 = getWorkerSrc();
                                try {
                                    if (!(0, _util.isSameOrigin)(window.location.href, workerSrc11)) workerSrc11 = createCDNWrapper(new URL(workerSrc11, window.location).href);
                                    const worker11 = new Worker(workerSrc11);
                                    const messageHandler11 = new _message_handler.MessageHandler("main", "worker", worker11);
                                    const terminateEarly11 = ()=>{
                                        worker11.removeEventListener("error", onWorkerError11);
                                        messageHandler11.destroy();
                                        worker11.terminate();
                                        if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                        else this._setupFakeWorker();
                                    };
                                    const onWorkerError11 = ()=>{
                                        if (!this._webWorker) terminateEarly11();
                                    };
                                    worker11.addEventListener("error", onWorkerError11);
                                    messageHandler11.on("test", (data11)=>{
                                        worker11.removeEventListener("error", onWorkerError11);
                                        if (this.destroyed) {
                                            terminateEarly11();
                                            return;
                                        }
                                        if (data11) {
                                            this._messageHandler = messageHandler11;
                                            this._port = worker11;
                                            this._webWorker = worker11;
                                            if (!data11.supportTransfers) this.postMessageTransfers = false;
                                            this._readyCapability.resolve();
                                            messageHandler11.send("configure", {
                                                verbosity: this.verbosity
                                            });
                                        } else {
                                            this._setupFakeWorker();
                                            messageHandler11.destroy();
                                            worker11.terminate();
                                        }
                                    });
                                    messageHandler11.on("ready", (data11)=>{
                                        worker11.removeEventListener("error", onWorkerError11);
                                        if (this.destroyed) {
                                            terminateEarly11();
                                            return;
                                        }
                                        try {
                                            sendTest11();
                                        } catch (e11) {
                                            this._setupFakeWorker();
                                        }
                                    });
                                    const sendTest11 = ()=>{
                                        const testObj11 = new Uint8Array([
                                            this.postMessageTransfers ? 255 : 0
                                        ]);
                                        try {
                                            messageHandler11.send("test", testObj11, [
                                                testObj11.buffer
                                            ]);
                                        } catch (ex11) {
                                            (0, _util.warn)("Cannot use postMessage transfers.");
                                            testObj11[0] = 0;
                                            messageHandler11.send("test", testObj11);
                                        }
                                    };
                                    sendTest11();
                                    return;
                                } catch (e11) {
                                    (0, _util.info)("The worker has been disabled.");
                                }
                            }
                            this._setupFakeWorker();
                        }
                        _setupFakeWorker() {
                            if (!isWorkerDisabled) {
                                (0, _util.warn)("Setting up fake worker.");
                                isWorkerDisabled = true;
                            }
                            setupFakeWorkerGlobal().then((WorkerMessageHandler11)=>{
                                if (this.destroyed) {
                                    this._readyCapability.reject(new Error("Worker was destroyed"));
                                    return;
                                }
                                const port11 = new LoopbackPort();
                                this._port = port11;
                                const id11 = "fake" + nextFakeWorkerId++;
                                const workerHandler11 = new _message_handler.MessageHandler(id11 + "_worker", id11, port11);
                                WorkerMessageHandler11.setup(workerHandler11, port11);
                                const messageHandler11 = new _message_handler.MessageHandler(id11, id11 + "_worker", port11);
                                this._messageHandler = messageHandler11;
                                this._readyCapability.resolve();
                                messageHandler11.send("configure", {
                                    verbosity: this.verbosity
                                });
                            }).catch((reason11)=>{
                                this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason11.message}".`));
                            });
                        }
                        destroy() {
                            this.destroyed = true;
                            if (this._webWorker) {
                                this._webWorker.terminate();
                                this._webWorker = null;
                            }
                            pdfWorkerPorts.delete(this._port);
                            this._port = null;
                            if (this._messageHandler) {
                                this._messageHandler.destroy();
                                this._messageHandler = null;
                            }
                        }
                        static fromPort(params11) {
                            if (!params11 || !params11.port) throw new Error("PDFWorker.fromPort - invalid method signature.");
                            if (pdfWorkerPorts.has(params11.port)) return pdfWorkerPorts.get(params11.port);
                            return new PDFWorker(params11);
                        }
                        static getWorkerSrc() {
                            return getWorkerSrc();
                        }
                    }
                    return PDFWorker;
                }();
                exports.PDFWorker = PDFWorker;
                class WorkerTransport {
                    constructor(messageHandler11, loadingTask11, networkStream11, params11){
                        this.messageHandler = messageHandler11;
                        this.loadingTask = loadingTask11;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            docId: loadingTask11.docId,
                            onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                            ownerDocument: params11.ownerDocument,
                            styleElement: params11.styleElement
                        });
                        this._params = params11;
                        if (!params11.useWorkerFetch) {
                            this.CMapReaderFactory = new params11.CMapReaderFactory({
                                baseUrl: params11.cMapUrl,
                                isCompressed: params11.cMapPacked
                            });
                            this.StandardFontDataFactory = new params11.StandardFontDataFactory({
                                baseUrl: params11.standardFontDataUrl
                            });
                        }
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._passwordCapability = null;
                        this._networkStream = networkStream11;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.pageCache = [];
                        this.pagePromises = [];
                        this.downloadInfoCapability = (0, _util.createPromiseCapability)();
                        this.setupMessageHandler();
                    }
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    destroy() {
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = (0, _util.createPromiseCapability)();
                        if (this._passwordCapability) this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn11 = [];
                        for (const page11 of this.pageCache)if (page11) waitOn11.push(page11._destroy());
                        this.pageCache.length = 0;
                        this.pagePromises.length = 0;
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated11 = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn11.push(terminated11);
                        Promise.all(waitOn11).then(()=>{
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            this._hasJSActionsPromise = null;
                            if (this._networkStream) this._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler: messageHandler11 , loadingTask: loadingTask11  } = this;
                        messageHandler11.on("GetReader", (data11, sink11)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt11)=>{
                                this._lastProgress = {
                                    loaded: evt11.loaded,
                                    total: evt11.total
                                };
                            };
                            sink11.onPull = ()=>{
                                this._fullReader.read().then(function({ value: value11 , done: done11  }) {
                                    if (done11) {
                                        sink11.close();
                                        return;
                                    }
                                    (0, _util.assert)((0, _util.isArrayBuffer)(value11), "GetReader - expected an ArrayBuffer.");
                                    sink11.enqueue(new Uint8Array(value11), 1, [
                                        value11
                                    ]);
                                }).catch((reason11)=>{
                                    sink11.error(reason11);
                                });
                            };
                            sink11.onCancel = (reason11)=>{
                                this._fullReader.cancel(reason11);
                                sink11.ready.catch((readyReason11)=>{
                                    if (this.destroyed) return;
                                    throw readyReason11;
                                });
                            };
                        });
                        messageHandler11.on("ReaderHeadersReady", (data11)=>{
                            const headersCapability11 = (0, _util.createPromiseCapability)();
                            const fullReader11 = this._fullReader;
                            fullReader11.headersReady.then(()=>{
                                if (!fullReader11.isStreamingSupported || !fullReader11.isRangeSupported) {
                                    if (this._lastProgress && loadingTask11.onProgress) loadingTask11.onProgress(this._lastProgress);
                                    fullReader11.onProgress = (evt11)=>{
                                        if (loadingTask11.onProgress) loadingTask11.onProgress({
                                            loaded: evt11.loaded,
                                            total: evt11.total
                                        });
                                    };
                                }
                                headersCapability11.resolve({
                                    isStreamingSupported: fullReader11.isStreamingSupported,
                                    isRangeSupported: fullReader11.isRangeSupported,
                                    contentLength: fullReader11.contentLength
                                });
                            }, headersCapability11.reject);
                            return headersCapability11.promise;
                        });
                        messageHandler11.on("GetRangeReader", (data11, sink11)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader11 = this._networkStream.getRangeReader(data11.begin, data11.end);
                            if (!rangeReader11) {
                                sink11.close();
                                return;
                            }
                            sink11.onPull = ()=>{
                                rangeReader11.read().then(function({ value: value11 , done: done11  }) {
                                    if (done11) {
                                        sink11.close();
                                        return;
                                    }
                                    (0, _util.assert)((0, _util.isArrayBuffer)(value11), "GetRangeReader - expected an ArrayBuffer.");
                                    sink11.enqueue(new Uint8Array(value11), 1, [
                                        value11
                                    ]);
                                }).catch((reason11)=>{
                                    sink11.error(reason11);
                                });
                            };
                            sink11.onCancel = (reason11)=>{
                                rangeReader11.cancel(reason11);
                                sink11.ready.catch((readyReason11)=>{
                                    if (this.destroyed) return;
                                    throw readyReason11;
                                });
                            };
                        });
                        messageHandler11.on("GetDoc", ({ pdfInfo: pdfInfo11  })=>{
                            this._numPages = pdfInfo11.numPages;
                            this._htmlForXfa = pdfInfo11.htmlForXfa;
                            delete pdfInfo11.htmlForXfa;
                            loadingTask11._capability.resolve(new PDFDocumentProxy(pdfInfo11, this));
                        });
                        messageHandler11.on("DocException", function(ex11) {
                            let reason11;
                            switch(ex11.name){
                                case "PasswordException":
                                    reason11 = new _util.PasswordException(ex11.message, ex11.code);
                                    break;
                                case "InvalidPDFException":
                                    reason11 = new _util.InvalidPDFException(ex11.message);
                                    break;
                                case "MissingPDFException":
                                    reason11 = new _util.MissingPDFException(ex11.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason11 = new _util.UnexpectedResponseException(ex11.message, ex11.status);
                                    break;
                                case "UnknownErrorException":
                                    reason11 = new _util.UnknownErrorException(ex11.message, ex11.details);
                                    break;
                            }
                            if (!(reason11 instanceof Error)) {
                                const msg11 = "DocException - expected a valid Error.";
                                (0, _util.warn)(msg11);
                            }
                            loadingTask11._capability.reject(reason11);
                        });
                        messageHandler11.on("PasswordRequest", (exception11)=>{
                            this._passwordCapability = (0, _util.createPromiseCapability)();
                            if (loadingTask11.onPassword) {
                                const updatePassword11 = (password11)=>{
                                    this._passwordCapability.resolve({
                                        password: password11
                                    });
                                };
                                try {
                                    loadingTask11.onPassword(updatePassword11, exception11.code);
                                } catch (ex11) {
                                    this._passwordCapability.reject(ex11);
                                }
                            } else this._passwordCapability.reject(new _util.PasswordException(exception11.message, exception11.code));
                            return this._passwordCapability.promise;
                        });
                        messageHandler11.on("DataLoaded", (data11)=>{
                            if (loadingTask11.onProgress) loadingTask11.onProgress({
                                loaded: data11.length,
                                total: data11.length
                            });
                            this.downloadInfoCapability.resolve(data11);
                        });
                        messageHandler11.on("StartRenderPage", (data11)=>{
                            if (this.destroyed) return;
                            const page11 = this.pageCache[data11.pageIndex];
                            page11._startRenderPage(data11.transparency, data11.intent);
                        });
                        messageHandler11.on("commonobj", (data11)=>{
                            if (this.destroyed) return;
                            const [id11, type11, exportedData11] = data11;
                            if (this.commonObjs.has(id11)) return;
                            switch(type11){
                                case "Font":
                                    const params11 = this._params;
                                    if ("error" in exportedData11) {
                                        const exportedError11 = exportedData11.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError11}`);
                                        this.commonObjs.resolve(id11, exportedError11);
                                        break;
                                    }
                                    let fontRegistry11 = null;
                                    if (params11.pdfBug && globalThis.FontInspector?.enabled) fontRegistry11 = {
                                        registerFont (font11, url11) {
                                            globalThis.FontInspector.fontAdded(font11, url11);
                                        }
                                    };
                                    const font11 = new _font_loader.FontFaceObject(exportedData11, {
                                        isEvalSupported: params11.isEvalSupported,
                                        disableFontFace: params11.disableFontFace,
                                        ignoreErrors: params11.ignoreErrors,
                                        onUnsupportedFeature: this._onUnsupportedFeature.bind(this),
                                        fontRegistry: fontRegistry11
                                    });
                                    this.fontLoader.bind(font11).catch((reason11)=>{
                                        return messageHandler11.sendWithPromise("FontFallback", {
                                            id: id11
                                        });
                                    }).finally(()=>{
                                        if (!params11.fontExtraProperties && font11.data) font11.data = null;
                                        this.commonObjs.resolve(id11, font11);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                    this.commonObjs.resolve(id11, exportedData11);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type11}`);
                            }
                        });
                        messageHandler11.on("obj", (data11)=>{
                            if (this.destroyed) return undefined;
                            const [id11, pageIndex11, type11, imageData11] = data11;
                            const pageProxy11 = this.pageCache[pageIndex11];
                            if (pageProxy11.objs.has(id11)) return undefined;
                            switch(type11){
                                case "Image":
                                    pageProxy11.objs.resolve(id11, imageData11);
                                    const MAX_IMAGE_SIZE_TO_STORE11 = 8000000;
                                    if (imageData11?.data?.length > MAX_IMAGE_SIZE_TO_STORE11) pageProxy11.cleanupAfterRender = true;
                                    break;
                                case "Pattern":
                                    pageProxy11.objs.resolve(id11, imageData11);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type11}`);
                            }
                            return undefined;
                        });
                        messageHandler11.on("DocProgress", (data11)=>{
                            if (this.destroyed) return;
                            if (loadingTask11.onProgress) loadingTask11.onProgress({
                                loaded: data11.loaded,
                                total: data11.total
                            });
                        });
                        messageHandler11.on("UnsupportedFeature", this._onUnsupportedFeature.bind(this));
                        messageHandler11.on("FetchBuiltInCMap", (data11)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.CMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.CMapReaderFactory.fetch(data11);
                        });
                        messageHandler11.on("FetchStandardFontData", (data11)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.StandardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.StandardFontDataFactory.fetch(data11);
                        });
                    }
                    _onUnsupportedFeature({ featureId: featureId11  }) {
                        if (this.destroyed) return;
                        if (this.loadingTask.onUnsupportedFeature) this.loadingTask.onUnsupportedFeature(featureId11);
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    getPage(pageNumber11) {
                        if (!Number.isInteger(pageNumber11) || pageNumber11 <= 0 || pageNumber11 > this._numPages) return Promise.reject(new Error("Invalid page request"));
                        const pageIndex11 = pageNumber11 - 1;
                        if (pageIndex11 in this.pagePromises) return this.pagePromises[pageIndex11];
                        const promise11 = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex11
                        }).then((pageInfo11)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page11 = new PDFPageProxy(pageIndex11, pageInfo11, this, this._params.ownerDocument, this._params.pdfBug);
                            this.pageCache[pageIndex11] = page11;
                            return page11;
                        });
                        this.pagePromises[pageIndex11] = promise11;
                        return promise11;
                    }
                    getPageIndex(ref11) {
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            ref: ref11
                        }).catch(function(reason11) {
                            return Promise.reject(new Error(reason11));
                        });
                    }
                    getAnnotations(pageIndex11, intent11) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex11,
                            intent: intent11
                        });
                    }
                    saveDocument() {
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: this.annotationStorage.serializable,
                            filename: this._fullReader?.filename ?? null
                        }).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getFieldObjects() {
                        return this.messageHandler.sendWithPromise("GetFieldObjects", null);
                    }
                    hasJSActions() {
                        return this._hasJSActionsPromise || (this._hasJSActionsPromise = this.messageHandler.sendWithPromise("HasJSActions", null));
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id11) {
                        if (typeof id11 !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id11
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getJavaScript() {
                        return this.messageHandler.sendWithPromise("GetJavaScript", null);
                    }
                    getDocJSActions() {
                        return this.messageHandler.sendWithPromise("GetDocJSActions", null);
                    }
                    getPageJSActions(pageIndex11) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex11
                        });
                    }
                    getStructTree(pageIndex11) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex11
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results11)=>{
                            return new _optional_content_config.OptionalContentConfig(results11);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        return this.messageHandler.sendWithPromise("GetMetadata", null).then((results11)=>{
                            return {
                                info: results11[0],
                                metadata: results11[1] ? new _metadata.Metadata(results11[1]) : null,
                                contentDispositionFilename: this._fullReader?.filename ?? null,
                                contentLength: this._fullReader?.contentLength ?? null
                            };
                        });
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    getStats() {
                        return this.messageHandler.sendWithPromise("GetStats", null);
                    }
                    async startCleanup(keepLoadedFonts11 = false) {
                        await this.messageHandler.sendWithPromise("Cleanup", null);
                        if (this.destroyed) return;
                        for(let i11 = 0, ii11 = this.pageCache.length; i11 < ii11; i11++){
                            const page11 = this.pageCache[i11];
                            if (!page11) continue;
                            const cleanupSuccessful11 = page11.cleanup();
                            if (!cleanupSuccessful11) throw new Error(`startCleanup: Page ${i11 + 1} is currently rendering.`);
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts11) this.fontLoader.clear();
                        this._hasJSActionsPromise = null;
                    }
                    get loadingParams() {
                        const params11 = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: params11.disableAutoFetch
                        });
                    }
                }
                class PDFObjects {
                    constructor(){
                        this._objs = Object.create(null);
                    }
                    _ensureObj(objId11) {
                        if (this._objs[objId11]) return this._objs[objId11];
                        return this._objs[objId11] = {
                            capability: (0, _util.createPromiseCapability)(),
                            data: null,
                            resolved: false
                        };
                    }
                    get(objId11, callback11 = null) {
                        if (callback11) {
                            this._ensureObj(objId11).capability.promise.then(callback11);
                            return null;
                        }
                        const obj11 = this._objs[objId11];
                        if (!obj11 || !obj11.resolved) throw new Error(`Requesting object that isn't resolved yet ${objId11}.`);
                        return obj11.data;
                    }
                    has(objId11) {
                        const obj11 = this._objs[objId11];
                        return obj11?.resolved || false;
                    }
                    resolve(objId11, data11) {
                        const obj11 = this._ensureObj(objId11);
                        obj11.resolved = true;
                        obj11.data = data11;
                        obj11.capability.resolve(data11);
                    }
                    clear() {
                        this._objs = Object.create(null);
                    }
                }
                class RenderTask {
                    constructor(internalRenderTask11){
                        this._internalRenderTask = internalRenderTask11;
                        this.onContinue = null;
                    }
                    get promise() {
                        return this._internalRenderTask.capability.promise;
                    }
                    cancel() {
                        this._internalRenderTask.cancel();
                    }
                }
                const InternalRenderTask = function InternalRenderTaskClosure11() {
                    const canvasInRendering11 = new WeakSet();
                    class InternalRenderTask11 {
                        constructor({ callback: callback11 , params: params11 , objs: objs11 , commonObjs: commonObjs11 , operatorList: operatorList11 , pageIndex: pageIndex11 , canvasFactory: canvasFactory11 , useRequestAnimationFrame: useRequestAnimationFrame11 = false , pdfBug: pdfBug11 = false  }){
                            this.callback = callback11;
                            this.params = params11;
                            this.objs = objs11;
                            this.commonObjs = commonObjs11;
                            this.operatorListIdx = null;
                            this.operatorList = operatorList11;
                            this._pageIndex = pageIndex11;
                            this.canvasFactory = canvasFactory11;
                            this._pdfBug = pdfBug11;
                            this.running = false;
                            this.graphicsReadyCallback = null;
                            this.graphicsReady = false;
                            this._useRequestAnimationFrame = useRequestAnimationFrame11 === true && typeof window !== "undefined";
                            this.cancelled = false;
                            this.capability = (0, _util.createPromiseCapability)();
                            this.task = new RenderTask(this);
                            this._cancelBound = this.cancel.bind(this);
                            this._continueBound = this._continue.bind(this);
                            this._scheduleNextBound = this._scheduleNext.bind(this);
                            this._nextBound = this._next.bind(this);
                            this._canvas = params11.canvasContext.canvas;
                        }
                        get completed() {
                            return this.capability.promise.catch(function() {});
                        }
                        initializeGraphics({ transparency: transparency11 = false , optionalContentConfig: optionalContentConfig11  }) {
                            if (this.cancelled) return;
                            if (this._canvas) {
                                if (canvasInRendering11.has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                                canvasInRendering11.add(this._canvas);
                            }
                            if (this._pdfBug && globalThis.StepperManager?.enabled) {
                                this.stepper = globalThis.StepperManager.create(this._pageIndex);
                                this.stepper.init(this.operatorList);
                                this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                            }
                            const { canvasContext: canvasContext11 , viewport: viewport11 , transform: transform11 , imageLayer: imageLayer11 , background: background11  } = this.params;
                            this.gfx = new _canvas.CanvasGraphics(canvasContext11, this.commonObjs, this.objs, this.canvasFactory, imageLayer11, optionalContentConfig11);
                            this.gfx.beginDrawing({
                                transform: transform11,
                                viewport: viewport11,
                                transparency: transparency11,
                                background: background11
                            });
                            this.operatorListIdx = 0;
                            this.graphicsReady = true;
                            if (this.graphicsReadyCallback) this.graphicsReadyCallback();
                        }
                        cancel(error11 = null) {
                            this.running = false;
                            this.cancelled = true;
                            if (this.gfx) this.gfx.endDrawing();
                            if (this._canvas) canvasInRendering11.delete(this._canvas);
                            this.callback(error11 || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, "canvas"));
                        }
                        operatorListChanged() {
                            if (!this.graphicsReady) {
                                if (!this.graphicsReadyCallback) this.graphicsReadyCallback = this._continueBound;
                                return;
                            }
                            if (this.stepper) this.stepper.updateOperatorList(this.operatorList);
                            if (this.running) return;
                            this._continue();
                        }
                        _continue() {
                            this.running = true;
                            if (this.cancelled) return;
                            if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                            else this._scheduleNext();
                        }
                        _scheduleNext() {
                            if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                                this._nextBound().catch(this._cancelBound);
                            });
                            else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                        }
                        async _next() {
                            if (this.cancelled) return;
                            this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                            if (this.operatorListIdx === this.operatorList.argsArray.length) {
                                this.running = false;
                                if (this.operatorList.lastChunk) {
                                    this.gfx.endDrawing();
                                    if (this._canvas) canvasInRendering11.delete(this._canvas);
                                    this.callback();
                                }
                            }
                        }
                    }
                    return InternalRenderTask11;
                }();
                const version = "2.10.377";
                exports.version = version;
                const build = "156762c48";
                exports.build = build;
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.FontLoader = exports11.FontFaceObject = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                class BaseFontLoader11 {
                    constructor({ docId: docId11 , onUnsupportedFeature: onUnsupportedFeature11 , ownerDocument: ownerDocument11 = globalThis.document , styleElement: styleElement11 = null  }){
                        if (this.constructor === BaseFontLoader11) (0, _util11.unreachable)("Cannot initialize BaseFontLoader.");
                        this.docId = docId11;
                        this._onUnsupportedFeature = onUnsupportedFeature11;
                        this._document = ownerDocument11;
                        this.nativeFontFaces = [];
                        this.styleElement = null;
                    }
                    addNativeFontFace(nativeFontFace11) {
                        this.nativeFontFaces.push(nativeFontFace11);
                        this._document.fonts.add(nativeFontFace11);
                    }
                    insertRule(rule11) {
                        let styleElement11 = this.styleElement;
                        if (!styleElement11) {
                            styleElement11 = this.styleElement = this._document.createElement("style");
                            styleElement11.id = `PDFJS_FONT_STYLE_TAG_${this.docId}`;
                            this._document.documentElement.getElementsByTagName("head")[0].appendChild(styleElement11);
                        }
                        const styleSheet11 = styleElement11.sheet;
                        styleSheet11.insertRule(rule11, styleSheet11.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace11 of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace11);
                        this.nativeFontFaces.length = 0;
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    async bind(font11) {
                        if (font11.attached || font11.missingFile) return;
                        font11.attached = true;
                        if (this.isFontLoadingAPISupported) {
                            const nativeFontFace11 = font11.createNativeFontFace();
                            if (nativeFontFace11) {
                                this.addNativeFontFace(nativeFontFace11);
                                try {
                                    await nativeFontFace11.loaded;
                                } catch (ex11) {
                                    this._onUnsupportedFeature({
                                        featureId: _util11.UNSUPPORTED_FEATURES.errorFontLoadNative
                                    });
                                    (0, _util11.warn)(`Failed to load font '${nativeFontFace11.family}': '${ex11}'.`);
                                    font11.disableFontFace = true;
                                    throw ex11;
                                }
                            }
                            return;
                        }
                        const rule11 = font11.createFontFaceRule();
                        if (rule11) {
                            this.insertRule(rule11);
                            if (this.isSyncFontLoadingSupported) return;
                            await new Promise((resolve11)=>{
                                const request11 = this._queueLoadingCallback(resolve11);
                                this._prepareFontLoadEvent([
                                    rule11
                                ], [
                                    font11
                                ], request11);
                            });
                        }
                    }
                    _queueLoadingCallback(callback11) {
                        (0, _util11.unreachable)("Abstract method `_queueLoadingCallback`.");
                    }
                    get isFontLoadingAPISupported() {
                        const hasFonts11 = !!this._document?.fonts;
                        return (0, _util11.shadow)(this, "isFontLoadingAPISupported", hasFonts11);
                    }
                    get isSyncFontLoadingSupported() {
                        (0, _util11.unreachable)("Abstract method `isSyncFontLoadingSupported`.");
                    }
                    get _loadTestFont() {
                        (0, _util11.unreachable)("Abstract method `_loadTestFont`.");
                    }
                    _prepareFontLoadEvent(rules11, fontsToLoad11, request11) {
                        (0, _util11.unreachable)("Abstract method `_prepareFontLoadEvent`.");
                    }
                }
                let FontLoader11;
                exports11.FontLoader = FontLoader11;
                exports11.FontLoader = FontLoader11 = class GenericFontLoader11 extends BaseFontLoader11 {
                    constructor(params11){
                        super(params11);
                        this.loadingContext = {
                            requests: [],
                            nextRequestId: 0
                        };
                        this.loadTestFontId = 0;
                    }
                    get isSyncFontLoadingSupported() {
                        let supported11 = false;
                        if (typeof navigator === "undefined") supported11 = true;
                        else {
                            const m31 = /Mozilla\/5.0.*?rv:(\d+).*? Gecko/.exec(navigator.userAgent);
                            if (m31?.[1] >= 14) supported11 = true;
                        }
                        return (0, _util11.shadow)(this, "isSyncFontLoadingSupported", supported11);
                    }
                    _queueLoadingCallback(callback11) {
                        function completeRequest11() {
                            (0, _util11.assert)(!request11.done, "completeRequest() cannot be called twice.");
                            request11.done = true;
                            while(context11.requests.length > 0 && context11.requests[0].done){
                                const otherRequest11 = context11.requests.shift();
                                setTimeout(otherRequest11.callback, 0);
                            }
                        }
                        const context11 = this.loadingContext;
                        const request11 = {
                            id: `pdfjs-font-loading-${context11.nextRequestId++}`,
                            done: false,
                            complete: completeRequest11,
                            callback: callback11
                        };
                        context11.requests.push(request11);
                        return request11;
                    }
                    get _loadTestFont() {
                        const getLoadTestFont11 = function() {
                            return atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        };
                        return (0, _util11.shadow)(this, "_loadTestFont", getLoadTestFont11());
                    }
                    _prepareFontLoadEvent(rules11, fonts11, request11) {
                        function int3211(data11, offset11) {
                            return data11.charCodeAt(offset11) << 24 | data11.charCodeAt(offset11 + 1) << 16 | data11.charCodeAt(offset11 + 2) << 8 | data11.charCodeAt(offset11 + 3) & 0xff;
                        }
                        function spliceString11(s11, offset11, remove11, insert11) {
                            const chunk111 = s11.substring(0, offset11);
                            const chunk211 = s11.substring(offset11 + remove11);
                            return chunk111 + insert11 + chunk211;
                        }
                        let i11, ii11;
                        const canvas11 = this._document.createElement("canvas");
                        canvas11.width = 1;
                        canvas11.height = 1;
                        const ctx11 = canvas11.getContext("2d");
                        let called11 = 0;
                        function isFontReady11(name11, callback11) {
                            called11++;
                            if (called11 > 30) {
                                (0, _util11.warn)("Load test font never loaded.");
                                callback11();
                                return;
                            }
                            ctx11.font = "30px " + name11;
                            ctx11.fillText(".", 0, 20);
                            const imageData11 = ctx11.getImageData(0, 0, 1, 1);
                            if (imageData11.data[3] > 0) {
                                callback11();
                                return;
                            }
                            setTimeout(isFontReady11.bind(null, name11, callback11));
                        }
                        const loadTestFontId11 = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data11 = this._loadTestFont;
                        const COMMENT_OFFSET11 = 976;
                        data11 = spliceString11(data11, COMMENT_OFFSET11, loadTestFontId11.length, loadTestFontId11);
                        const CFF_CHECKSUM_OFFSET11 = 16;
                        const XXXX_VALUE11 = 0x58585858;
                        let checksum11 = int3211(data11, CFF_CHECKSUM_OFFSET11);
                        for(i11 = 0, ii11 = loadTestFontId11.length - 3; i11 < ii11; i11 += 4)checksum11 = checksum11 - XXXX_VALUE11 + int3211(loadTestFontId11, i11) | 0;
                        if (i11 < loadTestFontId11.length) checksum11 = checksum11 - XXXX_VALUE11 + int3211(loadTestFontId11 + "XXX", i11) | 0;
                        data11 = spliceString11(data11, CFF_CHECKSUM_OFFSET11, 4, (0, _util11.string32)(checksum11));
                        const url11 = `url(data:font/opentype;base64,${btoa(data11)});`;
                        const rule11 = `@font-face {font-family:"${loadTestFontId11}";src:${url11}}`;
                        this.insertRule(rule11);
                        const names11 = [];
                        for (const font11 of fonts11)names11.push(font11.loadedName);
                        names11.push(loadTestFontId11);
                        const div11 = this._document.createElement("div");
                        div11.style.visibility = "hidden";
                        div11.style.width = div11.style.height = "10px";
                        div11.style.position = "absolute";
                        div11.style.top = div11.style.left = "0px";
                        for (const name11 of names11){
                            const span11 = this._document.createElement("span");
                            span11.textContent = "Hi";
                            span11.style.fontFamily = name11;
                            div11.appendChild(span11);
                        }
                        this._document.body.appendChild(div11);
                        isFontReady11(loadTestFontId11, ()=>{
                            this._document.body.removeChild(div11);
                            request11.complete();
                        });
                    }
                };
                class FontFaceObject11 {
                    constructor(translatedData11, { isEvalSupported: isEvalSupported11 = true , disableFontFace: disableFontFace11 = false , ignoreErrors: ignoreErrors11 = false , onUnsupportedFeature: onUnsupportedFeature11 , fontRegistry: fontRegistry11 = null  }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i11 in translatedData11)this[i11] = translatedData11[i11];
                        this.isEvalSupported = isEvalSupported11 !== false;
                        this.disableFontFace = disableFontFace11 === true;
                        this.ignoreErrors = ignoreErrors11 === true;
                        this._onUnsupportedFeature = onUnsupportedFeature11;
                        this.fontRegistry = fontRegistry11;
                    }
                    createNativeFontFace() {
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace11;
                        if (!this.cssFontInfo) nativeFontFace11 = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css11 = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css11.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace11 = new FontFace(this.cssFontInfo.fontFamily, this.data, css11);
                        }
                        if (this.fontRegistry) this.fontRegistry.registerFont(this);
                        return nativeFontFace11;
                    }
                    createFontFaceRule() {
                        if (!this.data || this.disableFontFace) return null;
                        const data11 = (0, _util11.bytesToString)(this.data);
                        const url11 = `url(data:${this.mimetype};base64,${btoa(data11)});`;
                        let rule11;
                        if (!this.cssFontInfo) rule11 = `@font-face {font-family:"${this.loadedName}";src:${url11}}`;
                        else {
                            let css11 = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css11 += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule11 = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css11}src:${url11}}`;
                        }
                        if (this.fontRegistry) this.fontRegistry.registerFont(this, url11);
                        return rule11;
                    }
                    getPathGenerator(objs11, character11) {
                        if (this.compiledGlyphs[character11] !== undefined) return this.compiledGlyphs[character11];
                        let cmds11;
                        try {
                            cmds11 = objs11.get(this.loadedName + "_path_" + character11);
                        } catch (ex11) {
                            if (!this.ignoreErrors) throw ex11;
                            this._onUnsupportedFeature({
                                featureId: _util11.UNSUPPORTED_FEATURES.errorFontGetPath
                            });
                            (0, _util11.warn)(`getPathGenerator - ignoring character: "${ex11}".`);
                            return this.compiledGlyphs[character11] = function(c41, size11) {};
                        }
                        if (this.isEvalSupported && _util11.IsEvalSupportedCached.value) {
                            const jsBuf11 = [];
                            for (const current11 of cmds11){
                                const args11 = current11.args !== undefined ? current11.args.join(",") : "";
                                jsBuf11.push("c.", current11.cmd, "(", args11, ");\n");
                            }
                            return this.compiledGlyphs[character11] = new Function("c", "size", jsBuf11.join(""));
                        }
                        return this.compiledGlyphs[character11] = function(c41, size11) {
                            for (const current11 of cmds11){
                                if (current11.cmd === "scale") current11.args = [
                                    size11,
                                    -size11
                                ];
                                c41[current11.cmd].apply(c41, current11.args);
                            }
                        };
                    }
                }
                exports11.FontFaceObject = FontFaceObject11;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.NodeStandardFontDataFactory = exports11.NodeCMapReaderFactory = exports11.NodeCanvasFactory = void 0;
                var _base_factory11 = __w_pdfjs_require__11(5);
                var _is_node11 = __w_pdfjs_require__11(4);
                var _util11 = __w_pdfjs_require__11(2);
                let NodeCanvasFactory11 = class {
                    constructor(){
                        (0, _util11.unreachable)("Not implemented: NodeCanvasFactory");
                    }
                };
                exports11.NodeCanvasFactory = NodeCanvasFactory11;
                let NodeCMapReaderFactory11 = class {
                    constructor(){
                        (0, _util11.unreachable)("Not implemented: NodeCMapReaderFactory");
                    }
                };
                exports11.NodeCMapReaderFactory = NodeCMapReaderFactory11;
                let NodeStandardFontDataFactory11 = class {
                    constructor(){
                        (0, _util11.unreachable)("Not implemented: NodeStandardFontDataFactory");
                    }
                };
                exports11.NodeStandardFontDataFactory = NodeStandardFontDataFactory11;
                if (_is_node11.isNodeJS) {
                    const fetchData11 = function(url11) {
                        return new Promise((resolve11, reject11)=>{
                            const fs11 = (parcelRequire("7Fvv0"));
                            fs11.readFile(url11, (error11, data11)=>{
                                if (error11 || !data11) {
                                    reject11(new Error(error11));
                                    return;
                                }
                                resolve11(new Uint8Array(data11));
                            });
                        });
                    };
                    exports11.NodeCanvasFactory = NodeCanvasFactory11 = class extends _base_factory11.BaseCanvasFactory {
                        _createCanvas(width21, height11) {
                            const Canvas11 = (parcelRequire("7Fvv0"));
                            return Canvas11.createCanvas(width21, height11);
                        }
                    };
                    exports11.NodeCMapReaderFactory = NodeCMapReaderFactory11 = class extends _base_factory11.BaseCMapReaderFactory {
                        _fetchData(url11, compressionType11) {
                            return fetchData11(url11).then((data11)=>{
                                return {
                                    cMapData: data11,
                                    compressionType: compressionType11
                                };
                            });
                        }
                    };
                    exports11.NodeStandardFontDataFactory = NodeStandardFontDataFactory11 = class extends _base_factory11.BaseStandardFontDataFactory {
                        _fetchData(url11) {
                            return fetchData11(url11);
                        }
                    };
                }
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.AnnotationStorage = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                class AnnotationStorage11 {
                    constructor(){
                        this._storage = new Map();
                        this._modified = false;
                        this.onSetModified = null;
                        this.onResetModified = null;
                    }
                    getValue(key11, defaultValue11) {
                        const obj11 = this._storage.get(key11);
                        return obj11 !== undefined ? obj11 : defaultValue11;
                    }
                    setValue(key11, value11) {
                        const obj11 = this._storage.get(key11);
                        let modified11 = false;
                        if (obj11 !== undefined) {
                            for (const [entry11, val11] of Object.entries(value11))if (obj11[entry11] !== val11) {
                                modified11 = true;
                                obj11[entry11] = val11;
                            }
                        } else {
                            this._storage.set(key11, value11);
                            modified11 = true;
                        }
                        if (modified11) this._setModified();
                    }
                    getAll() {
                        return this._storage.size > 0 ? (0, _util11.objectFromMap)(this._storage) : null;
                    }
                    get size() {
                        return this._storage.size;
                    }
                    _setModified() {
                        if (!this._modified) {
                            this._modified = true;
                            if (typeof this.onSetModified === "function") this.onSetModified();
                        }
                    }
                    resetModified() {
                        if (this._modified) {
                            this._modified = false;
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get serializable() {
                        return this._storage.size > 0 ? this._storage : null;
                    }
                }
                exports11.AnnotationStorage = AnnotationStorage11;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.CanvasGraphics = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                var _pattern_helper11 = __w_pdfjs_require__11(11);
                const MIN_FONT_SIZE11 = 16;
                const MAX_FONT_SIZE11 = 100;
                const MAX_GROUP_SIZE11 = 4096;
                const COMPILE_TYPE3_GLYPHS11 = true;
                const MAX_SIZE_TO_COMPILE11 = 1000;
                const FULL_CHUNK_HEIGHT11 = 16;
                const LINEWIDTH_SCALE_FACTOR11 = 1.000001;
                function addContextCurrentTransform11(ctx11) {
                    if (ctx11.mozCurrentTransform) return;
                    ctx11._originalSave = ctx11.save;
                    ctx11._originalRestore = ctx11.restore;
                    ctx11._originalRotate = ctx11.rotate;
                    ctx11._originalScale = ctx11.scale;
                    ctx11._originalTranslate = ctx11.translate;
                    ctx11._originalTransform = ctx11.transform;
                    ctx11._originalSetTransform = ctx11.setTransform;
                    ctx11._originalResetTransform = ctx11.resetTransform;
                    ctx11._transformMatrix = ctx11._transformMatrix || [
                        1,
                        0,
                        0,
                        1,
                        0,
                        0
                    ];
                    ctx11._transformStack = [];
                    try {
                        const desc11 = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(ctx11), "lineWidth");
                        ctx11._setLineWidth = desc11.set;
                        ctx11._getLineWidth = desc11.get;
                        Object.defineProperty(ctx11, "lineWidth", {
                            set: function setLineWidth11(width21) {
                                this._setLineWidth(width21 * LINEWIDTH_SCALE_FACTOR11);
                            },
                            get: function getLineWidth11() {
                                return this._getLineWidth();
                            }
                        });
                    } catch (_11) {}
                    Object.defineProperty(ctx11, "mozCurrentTransform", {
                        get: function getCurrentTransform11() {
                            return this._transformMatrix;
                        }
                    });
                    Object.defineProperty(ctx11, "mozCurrentTransformInverse", {
                        get: function getCurrentTransformInverse11() {
                            const [a11, b41, c41, d51, e11, f11] = this._transformMatrix;
                            const ad_bc11 = a11 * d51 - b41 * c41;
                            const bc_ad11 = b41 * c41 - a11 * d51;
                            return [
                                d51 / ad_bc11,
                                b41 / bc_ad11,
                                c41 / bc_ad11,
                                a11 / ad_bc11,
                                (d51 * e11 - c41 * f11) / bc_ad11,
                                (b41 * e11 - a11 * f11) / ad_bc11
                            ];
                        }
                    });
                    ctx11.save = function ctxSave11() {
                        const old11 = this._transformMatrix;
                        this._transformStack.push(old11);
                        this._transformMatrix = old11.slice(0, 6);
                        this._originalSave();
                    };
                    ctx11.restore = function ctxRestore11() {
                        const prev11 = this._transformStack.pop();
                        if (prev11) {
                            this._transformMatrix = prev11;
                            this._originalRestore();
                        }
                    };
                    ctx11.translate = function ctxTranslate11(x41, y41) {
                        const m31 = this._transformMatrix;
                        m31[4] = m31[0] * x41 + m31[2] * y41 + m31[4];
                        m31[5] = m31[1] * x41 + m31[3] * y41 + m31[5];
                        this._originalTranslate(x41, y41);
                    };
                    ctx11.scale = function ctxScale11(x41, y41) {
                        const m31 = this._transformMatrix;
                        m31[0] *= x41;
                        m31[1] *= x41;
                        m31[2] *= y41;
                        m31[3] *= y41;
                        this._originalScale(x41, y41);
                    };
                    ctx11.transform = function ctxTransform11(a11, b41, c41, d51, e11, f11) {
                        const m31 = this._transformMatrix;
                        this._transformMatrix = [
                            m31[0] * a11 + m31[2] * b41,
                            m31[1] * a11 + m31[3] * b41,
                            m31[0] * c41 + m31[2] * d51,
                            m31[1] * c41 + m31[3] * d51,
                            m31[0] * e11 + m31[2] * f11 + m31[4],
                            m31[1] * e11 + m31[3] * f11 + m31[5]
                        ];
                        ctx11._originalTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.setTransform = function ctxSetTransform11(a11, b41, c41, d51, e11, f11) {
                        this._transformMatrix = [
                            a11,
                            b41,
                            c41,
                            d51,
                            e11,
                            f11
                        ];
                        ctx11._originalSetTransform(a11, b41, c41, d51, e11, f11);
                    };
                    ctx11.resetTransform = function ctxResetTransform11() {
                        this._transformMatrix = [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        ctx11._originalResetTransform();
                    };
                    ctx11.rotate = function ctxRotate11(angle11) {
                        const cosValue11 = Math.cos(angle11);
                        const sinValue11 = Math.sin(angle11);
                        const m31 = this._transformMatrix;
                        this._transformMatrix = [
                            m31[0] * cosValue11 + m31[2] * sinValue11,
                            m31[1] * cosValue11 + m31[3] * sinValue11,
                            m31[0] * -sinValue11 + m31[2] * cosValue11,
                            m31[1] * -sinValue11 + m31[3] * cosValue11,
                            m31[4],
                            m31[5]
                        ];
                        this._originalRotate(angle11);
                    };
                }
                class CachedCanvases11 {
                    constructor(canvasFactory11){
                        this.canvasFactory = canvasFactory11;
                        this.cache = Object.create(null);
                    }
                    getCanvas(id11, width21, height11, trackTransform11) {
                        let canvasEntry11;
                        if (this.cache[id11] !== undefined) {
                            canvasEntry11 = this.cache[id11];
                            this.canvasFactory.reset(canvasEntry11, width21, height11);
                            canvasEntry11.context.setTransform(1, 0, 0, 1, 0, 0);
                        } else {
                            canvasEntry11 = this.canvasFactory.create(width21, height11);
                            this.cache[id11] = canvasEntry11;
                        }
                        if (trackTransform11) addContextCurrentTransform11(canvasEntry11.context);
                        return canvasEntry11;
                    }
                    clear() {
                        for(const id11 in this.cache){
                            const canvasEntry11 = this.cache[id11];
                            this.canvasFactory.destroy(canvasEntry11);
                            delete this.cache[id11];
                        }
                    }
                }
                function compileType3Glyph11(imgData11) {
                    const POINT_TO_PROCESS_LIMIT11 = 1000;
                    const POINT_TYPES11 = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width21 = imgData11.width, height11 = imgData11.height, width111 = width21 + 1;
                    let i11, ii11, j11, j011;
                    const points11 = new Uint8Array(width111 * (height11 + 1));
                    const lineSize11 = width21 + 7 & -8, data011 = imgData11.data;
                    const data11 = new Uint8Array(lineSize11 * height11);
                    let pos11 = 0;
                    for(i11 = 0, ii11 = data011.length; i11 < ii11; i11++){
                        const elem11 = data011[i11];
                        let mask11 = 128;
                        while(mask11 > 0){
                            data11[pos11++] = elem11 & mask11 ? 0 : 255;
                            mask11 >>= 1;
                        }
                    }
                    let count11 = 0;
                    pos11 = 0;
                    if (data11[pos11] !== 0) {
                        points11[0] = 1;
                        ++count11;
                    }
                    for(j11 = 1; j11 < width21; j11++){
                        if (data11[pos11] !== data11[pos11 + 1]) {
                            points11[j11] = data11[pos11] ? 2 : 1;
                            ++count11;
                        }
                        pos11++;
                    }
                    if (data11[pos11] !== 0) {
                        points11[j11] = 2;
                        ++count11;
                    }
                    for(i11 = 1; i11 < height11; i11++){
                        pos11 = i11 * lineSize11;
                        j011 = i11 * width111;
                        if (data11[pos11 - lineSize11] !== data11[pos11]) {
                            points11[j011] = data11[pos11] ? 1 : 8;
                            ++count11;
                        }
                        let sum11 = (data11[pos11] ? 4 : 0) + (data11[pos11 - lineSize11] ? 8 : 0);
                        for(j11 = 1; j11 < width21; j11++){
                            sum11 = (sum11 >> 2) + (data11[pos11 + 1] ? 4 : 0) + (data11[pos11 - lineSize11 + 1] ? 8 : 0);
                            if (POINT_TYPES11[sum11]) {
                                points11[j011 + j11] = POINT_TYPES11[sum11];
                                ++count11;
                            }
                            pos11++;
                        }
                        if (data11[pos11 - lineSize11] !== data11[pos11]) {
                            points11[j011 + j11] = data11[pos11] ? 2 : 4;
                            ++count11;
                        }
                        if (count11 > POINT_TO_PROCESS_LIMIT11) return null;
                    }
                    pos11 = lineSize11 * (height11 - 1);
                    j011 = i11 * width111;
                    if (data11[pos11] !== 0) {
                        points11[j011] = 8;
                        ++count11;
                    }
                    for(j11 = 1; j11 < width21; j11++){
                        if (data11[pos11] !== data11[pos11 + 1]) {
                            points11[j011 + j11] = data11[pos11] ? 4 : 8;
                            ++count11;
                        }
                        pos11++;
                    }
                    if (data11[pos11] !== 0) {
                        points11[j011 + j11] = 4;
                        ++count11;
                    }
                    if (count11 > POINT_TO_PROCESS_LIMIT11) return null;
                    const steps11 = new Int32Array([
                        0,
                        width111,
                        -1,
                        0,
                        -width111,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const outlines11 = [];
                    for(i11 = 0; count11 && i11 <= height11; i11++){
                        let p51 = i11 * width111;
                        const end11 = p51 + width21;
                        while(p51 < end11 && !points11[p51])p51++;
                        if (p51 === end11) continue;
                        const coords11 = [
                            p51 % width111,
                            i11
                        ];
                        const p011 = p51;
                        let type11 = points11[p51];
                        do {
                            const step11 = steps11[type11];
                            do p51 += step11;
                            while (!points11[p51]);
                            const pp11 = points11[p51];
                            if (pp11 !== 5 && pp11 !== 10) {
                                type11 = pp11;
                                points11[p51] = 0;
                            } else {
                                type11 = pp11 & 0x33 * type11 >> 4;
                                points11[p51] &= type11 >> 2 | type11 << 2;
                            }
                            coords11.push(p51 % width111, p51 / width111 | 0);
                            if (!points11[p51]) --count11;
                        }while (p011 !== p51);
                        outlines11.push(coords11);
                        --i11;
                    }
                    const drawOutline11 = function(c41) {
                        c41.save();
                        c41.scale(1 / width21, -1 / height11);
                        c41.translate(0, -height11);
                        c41.beginPath();
                        for(let k11 = 0, kk11 = outlines11.length; k11 < kk11; k11++){
                            const o11 = outlines11[k11];
                            c41.moveTo(o11[0], o11[1]);
                            for(let l11 = 2, ll11 = o11.length; l11 < ll11; l11 += 2)c41.lineTo(o11[l11], o11[l11 + 1]);
                        }
                        c41.fill();
                        c41.beginPath();
                        c41.restore();
                    };
                    return drawOutline11;
                }
                class CanvasExtraState11 {
                    constructor(){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util11.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util11.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util11.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.resumeSMaskCtx = null;
                        this.transferMaps = null;
                    }
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x41, y41) {
                        this.x = x41;
                        this.y = y41;
                    }
                }
                const CanvasGraphics11 = function CanvasGraphicsClosure11() {
                    const EXECUTION_TIME11 = 15;
                    const EXECUTION_STEPS11 = 10;
                    function putBinaryImageData11(ctx11, imgData11, transferMaps11 = null) {
                        if (typeof ImageData !== "undefined" && imgData11 instanceof ImageData) {
                            ctx11.putImageData(imgData11, 0, 0);
                            return;
                        }
                        const height11 = imgData11.height, width21 = imgData11.width;
                        const partialChunkHeight11 = height11 % FULL_CHUNK_HEIGHT11;
                        const fullChunks11 = (height11 - partialChunkHeight11) / FULL_CHUNK_HEIGHT11;
                        const totalChunks11 = partialChunkHeight11 === 0 ? fullChunks11 : fullChunks11 + 1;
                        const chunkImgData11 = ctx11.createImageData(width21, FULL_CHUNK_HEIGHT11);
                        let srcPos11 = 0, destPos11;
                        const src11 = imgData11.data;
                        const dest11 = chunkImgData11.data;
                        let i11, j11, thisChunkHeight11, elemsInThisChunk11;
                        let transferMapRed11, transferMapGreen11, transferMapBlue11, transferMapGray11;
                        if (transferMaps11) switch(transferMaps11.length){
                            case 1:
                                transferMapRed11 = transferMaps11[0];
                                transferMapGreen11 = transferMaps11[0];
                                transferMapBlue11 = transferMaps11[0];
                                transferMapGray11 = transferMaps11[0];
                                break;
                            case 4:
                                transferMapRed11 = transferMaps11[0];
                                transferMapGreen11 = transferMaps11[1];
                                transferMapBlue11 = transferMaps11[2];
                                transferMapGray11 = transferMaps11[3];
                                break;
                        }
                        if (imgData11.kind === _util11.ImageKind.GRAYSCALE_1BPP) {
                            const srcLength11 = src11.byteLength;
                            const dest3211 = new Uint32Array(dest11.buffer, 0, dest11.byteLength >> 2);
                            const dest32DataLength11 = dest3211.length;
                            const fullSrcDiff11 = width21 + 7 >> 3;
                            let white11 = 0xffffffff;
                            let black11 = _util11.IsLittleEndianCached.value ? 0xff000000 : 0x000000ff;
                            if (transferMapGray11) {
                                if (transferMapGray11[0] === 0xff && transferMapGray11[0xff] === 0) [white11, black11] = [
                                    black11,
                                    white11
                                ];
                            }
                            for(i11 = 0; i11 < totalChunks11; i11++){
                                thisChunkHeight11 = i11 < fullChunks11 ? FULL_CHUNK_HEIGHT11 : partialChunkHeight11;
                                destPos11 = 0;
                                for(j11 = 0; j11 < thisChunkHeight11; j11++){
                                    const srcDiff11 = srcLength11 - srcPos11;
                                    let k11 = 0;
                                    const kEnd11 = srcDiff11 > fullSrcDiff11 ? width21 : srcDiff11 * 8 - 7;
                                    const kEndUnrolled11 = kEnd11 & -8;
                                    let mask11 = 0;
                                    let srcByte11 = 0;
                                    for(; k11 < kEndUnrolled11; k11 += 8){
                                        srcByte11 = src11[srcPos11++];
                                        dest3211[destPos11++] = srcByte11 & 128 ? white11 : black11;
                                        dest3211[destPos11++] = srcByte11 & 64 ? white11 : black11;
                                        dest3211[destPos11++] = srcByte11 & 32 ? white11 : black11;
                                        dest3211[destPos11++] = srcByte11 & 16 ? white11 : black11;
                                        dest3211[destPos11++] = srcByte11 & 8 ? white11 : black11;
                                        dest3211[destPos11++] = srcByte11 & 4 ? white11 : black11;
                                        dest3211[destPos11++] = srcByte11 & 2 ? white11 : black11;
                                        dest3211[destPos11++] = srcByte11 & 1 ? white11 : black11;
                                    }
                                    for(; k11 < kEnd11; k11++){
                                        if (mask11 === 0) {
                                            srcByte11 = src11[srcPos11++];
                                            mask11 = 128;
                                        }
                                        dest3211[destPos11++] = srcByte11 & mask11 ? white11 : black11;
                                        mask11 >>= 1;
                                    }
                                }
                                while(destPos11 < dest32DataLength11)dest3211[destPos11++] = 0;
                                ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                            }
                        } else if (imgData11.kind === _util11.ImageKind.RGBA_32BPP) {
                            const hasTransferMaps11 = !!(transferMapRed11 || transferMapGreen11 || transferMapBlue11);
                            j11 = 0;
                            elemsInThisChunk11 = width21 * FULL_CHUNK_HEIGHT11 * 4;
                            for(i11 = 0; i11 < fullChunks11; i11++){
                                dest11.set(src11.subarray(srcPos11, srcPos11 + elemsInThisChunk11));
                                srcPos11 += elemsInThisChunk11;
                                if (hasTransferMaps11) for(let k11 = 0; k11 < elemsInThisChunk11; k11 += 4){
                                    if (transferMapRed11) dest11[k11 + 0] = transferMapRed11[dest11[k11 + 0]];
                                    if (transferMapGreen11) dest11[k11 + 1] = transferMapGreen11[dest11[k11 + 1]];
                                    if (transferMapBlue11) dest11[k11 + 2] = transferMapBlue11[dest11[k11 + 2]];
                                }
                                ctx11.putImageData(chunkImgData11, 0, j11);
                                j11 += FULL_CHUNK_HEIGHT11;
                            }
                            if (i11 < totalChunks11) {
                                elemsInThisChunk11 = width21 * partialChunkHeight11 * 4;
                                dest11.set(src11.subarray(srcPos11, srcPos11 + elemsInThisChunk11));
                                if (hasTransferMaps11) for(let k11 = 0; k11 < elemsInThisChunk11; k11 += 4){
                                    if (transferMapRed11) dest11[k11 + 0] = transferMapRed11[dest11[k11 + 0]];
                                    if (transferMapGreen11) dest11[k11 + 1] = transferMapGreen11[dest11[k11 + 1]];
                                    if (transferMapBlue11) dest11[k11 + 2] = transferMapBlue11[dest11[k11 + 2]];
                                }
                                ctx11.putImageData(chunkImgData11, 0, j11);
                            }
                        } else if (imgData11.kind === _util11.ImageKind.RGB_24BPP) {
                            const hasTransferMaps11 = !!(transferMapRed11 || transferMapGreen11 || transferMapBlue11);
                            thisChunkHeight11 = FULL_CHUNK_HEIGHT11;
                            elemsInThisChunk11 = width21 * thisChunkHeight11;
                            for(i11 = 0; i11 < totalChunks11; i11++){
                                if (i11 >= fullChunks11) {
                                    thisChunkHeight11 = partialChunkHeight11;
                                    elemsInThisChunk11 = width21 * thisChunkHeight11;
                                }
                                destPos11 = 0;
                                for(j11 = elemsInThisChunk11; j11--;){
                                    dest11[destPos11++] = src11[srcPos11++];
                                    dest11[destPos11++] = src11[srcPos11++];
                                    dest11[destPos11++] = src11[srcPos11++];
                                    dest11[destPos11++] = 255;
                                }
                                if (hasTransferMaps11) for(let k11 = 0; k11 < destPos11; k11 += 4){
                                    if (transferMapRed11) dest11[k11 + 0] = transferMapRed11[dest11[k11 + 0]];
                                    if (transferMapGreen11) dest11[k11 + 1] = transferMapGreen11[dest11[k11 + 1]];
                                    if (transferMapBlue11) dest11[k11 + 2] = transferMapBlue11[dest11[k11 + 2]];
                                }
                                ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                            }
                        } else throw new Error(`bad image kind: ${imgData11.kind}`);
                    }
                    function putBinaryImageMask11(ctx11, imgData11) {
                        const height11 = imgData11.height, width21 = imgData11.width;
                        const partialChunkHeight11 = height11 % FULL_CHUNK_HEIGHT11;
                        const fullChunks11 = (height11 - partialChunkHeight11) / FULL_CHUNK_HEIGHT11;
                        const totalChunks11 = partialChunkHeight11 === 0 ? fullChunks11 : fullChunks11 + 1;
                        const chunkImgData11 = ctx11.createImageData(width21, FULL_CHUNK_HEIGHT11);
                        let srcPos11 = 0;
                        const src11 = imgData11.data;
                        const dest11 = chunkImgData11.data;
                        for(let i11 = 0; i11 < totalChunks11; i11++){
                            const thisChunkHeight11 = i11 < fullChunks11 ? FULL_CHUNK_HEIGHT11 : partialChunkHeight11;
                            let destPos11 = 3;
                            for(let j11 = 0; j11 < thisChunkHeight11; j11++){
                                let elem11, mask11 = 0;
                                for(let k11 = 0; k11 < width21; k11++){
                                    if (!mask11) {
                                        elem11 = src11[srcPos11++];
                                        mask11 = 128;
                                    }
                                    dest11[destPos11] = elem11 & mask11 ? 0 : 255;
                                    destPos11 += 4;
                                    mask11 >>= 1;
                                }
                            }
                            ctx11.putImageData(chunkImgData11, 0, i11 * FULL_CHUNK_HEIGHT11);
                        }
                    }
                    function copyCtxState11(sourceCtx11, destCtx11) {
                        const properties11 = [
                            "strokeStyle",
                            "fillStyle",
                            "fillRule",
                            "globalAlpha",
                            "lineWidth",
                            "lineCap",
                            "lineJoin",
                            "miterLimit",
                            "globalCompositeOperation",
                            "font"
                        ];
                        for(let i11 = 0, ii11 = properties11.length; i11 < ii11; i11++){
                            const property11 = properties11[i11];
                            if (sourceCtx11[property11] !== undefined) destCtx11[property11] = sourceCtx11[property11];
                        }
                        if (sourceCtx11.setLineDash !== undefined) {
                            destCtx11.setLineDash(sourceCtx11.getLineDash());
                            destCtx11.lineDashOffset = sourceCtx11.lineDashOffset;
                        }
                    }
                    function resetCtxToDefault11(ctx11) {
                        ctx11.strokeStyle = "#000000";
                        ctx11.fillStyle = "#000000";
                        ctx11.fillRule = "nonzero";
                        ctx11.globalAlpha = 1;
                        ctx11.lineWidth = 1;
                        ctx11.lineCap = "butt";
                        ctx11.lineJoin = "miter";
                        ctx11.miterLimit = 10;
                        ctx11.globalCompositeOperation = "source-over";
                        ctx11.font = "10px sans-serif";
                        if (ctx11.setLineDash !== undefined) {
                            ctx11.setLineDash([]);
                            ctx11.lineDashOffset = 0;
                        }
                    }
                    function composeSMaskBackdrop11(bytes11, r011, g011, b011) {
                        const length11 = bytes11.length;
                        for(let i11 = 3; i11 < length11; i11 += 4){
                            const alpha11 = bytes11[i11];
                            if (alpha11 === 0) {
                                bytes11[i11 - 3] = r011;
                                bytes11[i11 - 2] = g011;
                                bytes11[i11 - 1] = b011;
                            } else if (alpha11 < 255) {
                                const alpha_11 = 255 - alpha11;
                                bytes11[i11 - 3] = bytes11[i11 - 3] * alpha11 + r011 * alpha_11 >> 8;
                                bytes11[i11 - 2] = bytes11[i11 - 2] * alpha11 + g011 * alpha_11 >> 8;
                                bytes11[i11 - 1] = bytes11[i11 - 1] * alpha11 + b011 * alpha_11 >> 8;
                            }
                        }
                    }
                    function composeSMaskAlpha11(maskData11, layerData11, transferMap11) {
                        const length11 = maskData11.length;
                        const scale11 = 1 / 255;
                        for(let i11 = 3; i11 < length11; i11 += 4){
                            const alpha11 = transferMap11 ? transferMap11[maskData11[i11]] : maskData11[i11];
                            layerData11[i11] = layerData11[i11] * alpha11 * scale11 | 0;
                        }
                    }
                    function composeSMaskLuminosity11(maskData11, layerData11, transferMap11) {
                        const length11 = maskData11.length;
                        for(let i11 = 3; i11 < length11; i11 += 4){
                            const y41 = maskData11[i11 - 3] * 77 + maskData11[i11 - 2] * 152 + maskData11[i11 - 1] * 28;
                            layerData11[i11] = transferMap11 ? layerData11[i11] * transferMap11[y41 >> 8] >> 8 : layerData11[i11] * y41 >> 16;
                        }
                    }
                    function genericComposeSMask11(maskCtx11, layerCtx11, width21, height11, subtype11, backdrop11, transferMap11) {
                        const hasBackdrop11 = !!backdrop11;
                        const r011 = hasBackdrop11 ? backdrop11[0] : 0;
                        const g011 = hasBackdrop11 ? backdrop11[1] : 0;
                        const b011 = hasBackdrop11 ? backdrop11[2] : 0;
                        let composeFn11;
                        if (subtype11 === "Luminosity") composeFn11 = composeSMaskLuminosity11;
                        else composeFn11 = composeSMaskAlpha11;
                        const PIXELS_TO_PROCESS11 = 1048576;
                        const chunkSize11 = Math.min(height11, Math.ceil(PIXELS_TO_PROCESS11 / width21));
                        for(let row11 = 0; row11 < height11; row11 += chunkSize11){
                            const chunkHeight11 = Math.min(chunkSize11, height11 - row11);
                            const maskData11 = maskCtx11.getImageData(0, row11, width21, chunkHeight11);
                            const layerData11 = layerCtx11.getImageData(0, row11, width21, chunkHeight11);
                            if (hasBackdrop11) composeSMaskBackdrop11(maskData11.data, r011, g011, b011);
                            composeFn11(maskData11.data, layerData11.data, transferMap11);
                            maskCtx11.putImageData(layerData11, 0, row11);
                        }
                    }
                    function composeSMask11(ctx11, smask11, layerCtx11) {
                        const mask11 = smask11.canvas;
                        const maskCtx11 = smask11.context;
                        ctx11.setTransform(smask11.scaleX, 0, 0, smask11.scaleY, smask11.offsetX, smask11.offsetY);
                        genericComposeSMask11(maskCtx11, layerCtx11, mask11.width, mask11.height, smask11.subtype, smask11.backdrop, smask11.transferMap);
                        ctx11.drawImage(mask11, 0, 0);
                    }
                    const LINE_CAP_STYLES11 = [
                        "butt",
                        "round",
                        "square"
                    ];
                    const LINE_JOIN_STYLES11 = [
                        "miter",
                        "round",
                        "bevel"
                    ];
                    const NORMAL_CLIP11 = {};
                    const EO_CLIP11 = {};
                    class CanvasGraphics11 {
                        constructor(canvasCtx11, commonObjs11, objs11, canvasFactory11, imageLayer11, optionalContentConfig11){
                            this.ctx = canvasCtx11;
                            this.current = new CanvasExtraState11();
                            this.stateStack = [];
                            this.pendingClip = null;
                            this.pendingEOFill = false;
                            this.res = null;
                            this.xobjs = null;
                            this.commonObjs = commonObjs11;
                            this.objs = objs11;
                            this.canvasFactory = canvasFactory11;
                            this.imageLayer = imageLayer11;
                            this.groupStack = [];
                            this.processingType3 = null;
                            this.baseTransform = null;
                            this.baseTransformStack = [];
                            this.groupLevel = 0;
                            this.smaskStack = [];
                            this.smaskCounter = 0;
                            this.tempSMask = null;
                            this.contentVisible = true;
                            this.markedContentStack = [];
                            this.optionalContentConfig = optionalContentConfig11;
                            this.cachedCanvases = new CachedCanvases11(this.canvasFactory);
                            this.cachedPatterns = new Map();
                            if (canvasCtx11) addContextCurrentTransform11(canvasCtx11);
                            this._cachedGetSinglePixelWidth = null;
                        }
                        beginDrawing({ transform: transform11 , viewport: viewport11 , transparency: transparency11 = false , background: background11 = null  }) {
                            const width21 = this.ctx.canvas.width;
                            const height11 = this.ctx.canvas.height;
                            this.ctx.save();
                            this.ctx.fillStyle = background11 || "rgb(255, 255, 255)";
                            this.ctx.fillRect(0, 0, width21, height11);
                            this.ctx.restore();
                            if (transparency11) {
                                const transparentCanvas11 = this.cachedCanvases.getCanvas("transparent", width21, height11, true);
                                this.compositeCtx = this.ctx;
                                this.transparentCanvas = transparentCanvas11.canvas;
                                this.ctx = transparentCanvas11.context;
                                this.ctx.save();
                                this.ctx.transform.apply(this.ctx, this.compositeCtx.mozCurrentTransform);
                            }
                            this.ctx.save();
                            resetCtxToDefault11(this.ctx);
                            if (transform11) this.ctx.transform.apply(this.ctx, transform11);
                            this.ctx.transform.apply(this.ctx, viewport11.transform);
                            this.baseTransform = this.ctx.mozCurrentTransform.slice();
                            this._combinedScaleFactor = Math.hypot(this.baseTransform[0], this.baseTransform[2]);
                            if (this.imageLayer) this.imageLayer.beginLayout();
                        }
                        executeOperatorList(operatorList11, executionStartIdx11, continueCallback11, stepper11) {
                            const argsArray11 = operatorList11.argsArray;
                            const fnArray11 = operatorList11.fnArray;
                            let i11 = executionStartIdx11 || 0;
                            const argsArrayLen11 = argsArray11.length;
                            if (argsArrayLen11 === i11) return i11;
                            const chunkOperations11 = argsArrayLen11 - i11 > EXECUTION_STEPS11 && typeof continueCallback11 === "function";
                            const endTime11 = chunkOperations11 ? Date.now() + EXECUTION_TIME11 : 0;
                            let steps11 = 0;
                            const commonObjs11 = this.commonObjs;
                            const objs11 = this.objs;
                            let fnId11;
                            while(true){
                                if (stepper11 !== undefined && i11 === stepper11.nextBreakPoint) {
                                    stepper11.breakIt(i11, continueCallback11);
                                    return i11;
                                }
                                fnId11 = fnArray11[i11];
                                if (fnId11 !== _util11.OPS.dependency) this[fnId11].apply(this, argsArray11[i11]);
                                else for (const depObjId11 of argsArray11[i11]){
                                    const objsPool11 = depObjId11.startsWith("g_") ? commonObjs11 : objs11;
                                    if (!objsPool11.has(depObjId11)) {
                                        objsPool11.get(depObjId11, continueCallback11);
                                        return i11;
                                    }
                                }
                                i11++;
                                if (i11 === argsArrayLen11) return i11;
                                if (chunkOperations11 && ++steps11 > EXECUTION_STEPS11) {
                                    if (Date.now() > endTime11) {
                                        continueCallback11();
                                        return i11;
                                    }
                                    steps11 = 0;
                                }
                            }
                        }
                        endDrawing() {
                            while(this.stateStack.length || this.current.activeSMask !== null)this.restore();
                            this.ctx.restore();
                            if (this.transparentCanvas) {
                                this.ctx = this.compositeCtx;
                                this.ctx.save();
                                this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                                this.ctx.drawImage(this.transparentCanvas, 0, 0);
                                this.ctx.restore();
                                this.transparentCanvas = null;
                            }
                            this.cachedCanvases.clear();
                            this.cachedPatterns.clear();
                            if (this.imageLayer) this.imageLayer.endLayout();
                        }
                        _scaleImage(img11, inverseTransform11) {
                            const width21 = img11.width;
                            const height11 = img11.height;
                            let widthScale11 = Math.max(Math.hypot(inverseTransform11[0], inverseTransform11[1]), 1);
                            let heightScale11 = Math.max(Math.hypot(inverseTransform11[2], inverseTransform11[3]), 1);
                            let paintWidth11 = width21, paintHeight11 = height11;
                            let tmpCanvasId11 = "prescale1";
                            let tmpCanvas11, tmpCtx11;
                            while(widthScale11 > 2 && paintWidth11 > 1 || heightScale11 > 2 && paintHeight11 > 1){
                                let newWidth11 = paintWidth11, newHeight11 = paintHeight11;
                                if (widthScale11 > 2 && paintWidth11 > 1) {
                                    newWidth11 = Math.ceil(paintWidth11 / 2);
                                    widthScale11 /= paintWidth11 / newWidth11;
                                }
                                if (heightScale11 > 2 && paintHeight11 > 1) {
                                    newHeight11 = Math.ceil(paintHeight11 / 2);
                                    heightScale11 /= paintHeight11 / newHeight11;
                                }
                                tmpCanvas11 = this.cachedCanvases.getCanvas(tmpCanvasId11, newWidth11, newHeight11);
                                tmpCtx11 = tmpCanvas11.context;
                                tmpCtx11.clearRect(0, 0, newWidth11, newHeight11);
                                tmpCtx11.drawImage(img11, 0, 0, paintWidth11, paintHeight11, 0, 0, newWidth11, newHeight11);
                                img11 = tmpCanvas11.canvas;
                                paintWidth11 = newWidth11;
                                paintHeight11 = newHeight11;
                                tmpCanvasId11 = tmpCanvasId11 === "prescale1" ? "prescale2" : "prescale1";
                            }
                            return {
                                img: img11,
                                paintWidth: paintWidth11,
                                paintHeight: paintHeight11
                            };
                        }
                        _createMaskCanvas(img11) {
                            const ctx11 = this.ctx;
                            const width21 = img11.width, height11 = img11.height;
                            const fillColor11 = this.current.fillColor;
                            const isPatternFill11 = this.current.patternFill;
                            const maskCanvas11 = this.cachedCanvases.getCanvas("maskCanvas", width21, height11);
                            const maskCtx11 = maskCanvas11.context;
                            putBinaryImageMask11(maskCtx11, img11);
                            const objToCanvas11 = ctx11.mozCurrentTransform;
                            let maskToCanvas11 = _util11.Util.transform(objToCanvas11, [
                                1 / width21,
                                0,
                                0,
                                -1 / height11,
                                0,
                                0
                            ]);
                            maskToCanvas11 = _util11.Util.transform(maskToCanvas11, [
                                1,
                                0,
                                0,
                                1,
                                0,
                                -height11
                            ]);
                            const cord111 = _util11.Util.applyTransform([
                                0,
                                0
                            ], maskToCanvas11);
                            const cord211 = _util11.Util.applyTransform([
                                width21,
                                height11
                            ], maskToCanvas11);
                            const rect31 = _util11.Util.normalizeRect([
                                cord111[0],
                                cord111[1],
                                cord211[0],
                                cord211[1]
                            ]);
                            const drawnWidth11 = Math.ceil(rect31[2] - rect31[0]);
                            const drawnHeight11 = Math.ceil(rect31[3] - rect31[1]);
                            const fillCanvas11 = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth11, drawnHeight11, true);
                            const fillCtx11 = fillCanvas11.context;
                            const offsetX11 = Math.min(cord111[0], cord211[0]);
                            const offsetY11 = Math.min(cord111[1], cord211[1]);
                            fillCtx11.translate(-offsetX11, -offsetY11);
                            fillCtx11.transform.apply(fillCtx11, maskToCanvas11);
                            const scaled11 = this._scaleImage(maskCanvas11.canvas, fillCtx11.mozCurrentTransformInverse);
                            fillCtx11.drawImage(scaled11.img, 0, 0, scaled11.img.width, scaled11.img.height, 0, 0, width21, height11);
                            fillCtx11.globalCompositeOperation = "source-in";
                            const inverse11 = _util11.Util.transform(fillCtx11.mozCurrentTransformInverse, [
                                1,
                                0,
                                0,
                                1,
                                -offsetX11,
                                -offsetY11
                            ]);
                            fillCtx11.fillStyle = isPatternFill11 ? fillColor11.getPattern(ctx11, this, inverse11, false) : fillColor11;
                            fillCtx11.fillRect(0, 0, width21, height11);
                            return {
                                canvas: fillCanvas11.canvas,
                                offsetX: Math.round(offsetX11),
                                offsetY: Math.round(offsetY11)
                            };
                        }
                        setLineWidth(width21) {
                            this.current.lineWidth = width21;
                            this.ctx.lineWidth = width21;
                        }
                        setLineCap(style11) {
                            this.ctx.lineCap = LINE_CAP_STYLES11[style11];
                        }
                        setLineJoin(style11) {
                            this.ctx.lineJoin = LINE_JOIN_STYLES11[style11];
                        }
                        setMiterLimit(limit11) {
                            this.ctx.miterLimit = limit11;
                        }
                        setDash(dashArray11, dashPhase11) {
                            const ctx11 = this.ctx;
                            if (ctx11.setLineDash !== undefined) {
                                ctx11.setLineDash(dashArray11);
                                ctx11.lineDashOffset = dashPhase11;
                            }
                        }
                        setRenderingIntent(intent11) {}
                        setFlatness(flatness11) {}
                        setGState(states11) {
                            for(let i11 = 0, ii11 = states11.length; i11 < ii11; i11++){
                                const state11 = states11[i11];
                                const key11 = state11[0];
                                const value11 = state11[1];
                                switch(key11){
                                    case "LW":
                                        this.setLineWidth(value11);
                                        break;
                                    case "LC":
                                        this.setLineCap(value11);
                                        break;
                                    case "LJ":
                                        this.setLineJoin(value11);
                                        break;
                                    case "ML":
                                        this.setMiterLimit(value11);
                                        break;
                                    case "D":
                                        this.setDash(value11[0], value11[1]);
                                        break;
                                    case "RI":
                                        this.setRenderingIntent(value11);
                                        break;
                                    case "FL":
                                        this.setFlatness(value11);
                                        break;
                                    case "Font":
                                        this.setFont(value11[0], value11[1]);
                                        break;
                                    case "CA":
                                        this.current.strokeAlpha = state11[1];
                                        break;
                                    case "ca":
                                        this.current.fillAlpha = state11[1];
                                        this.ctx.globalAlpha = state11[1];
                                        break;
                                    case "BM":
                                        this.ctx.globalCompositeOperation = value11;
                                        break;
                                    case "SMask":
                                        if (this.current.activeSMask) {
                                            if (this.stateStack.length > 0 && this.stateStack[this.stateStack.length - 1].activeSMask === this.current.activeSMask) this.suspendSMaskGroup();
                                            else this.endSMaskGroup();
                                        }
                                        this.current.activeSMask = value11 ? this.tempSMask : null;
                                        if (this.current.activeSMask) this.beginSMaskGroup();
                                        this.tempSMask = null;
                                        break;
                                    case "TR":
                                        this.current.transferMaps = value11;
                                }
                            }
                        }
                        beginSMaskGroup() {
                            const activeSMask11 = this.current.activeSMask;
                            const drawnWidth11 = activeSMask11.canvas.width;
                            const drawnHeight11 = activeSMask11.canvas.height;
                            const cacheId11 = "smaskGroupAt" + this.groupLevel;
                            const scratchCanvas11 = this.cachedCanvases.getCanvas(cacheId11, drawnWidth11, drawnHeight11, true);
                            const currentCtx11 = this.ctx;
                            const currentTransform11 = currentCtx11.mozCurrentTransform;
                            this.ctx.save();
                            const groupCtx11 = scratchCanvas11.context;
                            groupCtx11.scale(1 / activeSMask11.scaleX, 1 / activeSMask11.scaleY);
                            groupCtx11.translate(-activeSMask11.offsetX, -activeSMask11.offsetY);
                            groupCtx11.transform.apply(groupCtx11, currentTransform11);
                            activeSMask11.startTransformInverse = groupCtx11.mozCurrentTransformInverse;
                            copyCtxState11(currentCtx11, groupCtx11);
                            this.ctx = groupCtx11;
                            this.setGState([
                                [
                                    "BM",
                                    "source-over"
                                ],
                                [
                                    "ca",
                                    1
                                ],
                                [
                                    "CA",
                                    1
                                ]
                            ]);
                            this.groupStack.push(currentCtx11);
                            this.groupLevel++;
                        }
                        suspendSMaskGroup() {
                            const groupCtx11 = this.ctx;
                            this.groupLevel--;
                            this.ctx = this.groupStack.pop();
                            composeSMask11(this.ctx, this.current.activeSMask, groupCtx11);
                            this.ctx.restore();
                            this.ctx.save();
                            copyCtxState11(groupCtx11, this.ctx);
                            this.current.resumeSMaskCtx = groupCtx11;
                            const deltaTransform11 = _util11.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx11.mozCurrentTransform);
                            this.ctx.transform.apply(this.ctx, deltaTransform11);
                            groupCtx11.save();
                            groupCtx11.setTransform(1, 0, 0, 1, 0, 0);
                            groupCtx11.clearRect(0, 0, groupCtx11.canvas.width, groupCtx11.canvas.height);
                            groupCtx11.restore();
                        }
                        resumeSMaskGroup() {
                            const groupCtx11 = this.current.resumeSMaskCtx;
                            const currentCtx11 = this.ctx;
                            this.ctx = groupCtx11;
                            this.groupStack.push(currentCtx11);
                            this.groupLevel++;
                        }
                        endSMaskGroup() {
                            const groupCtx11 = this.ctx;
                            this.groupLevel--;
                            this.ctx = this.groupStack.pop();
                            composeSMask11(this.ctx, this.current.activeSMask, groupCtx11);
                            this.ctx.restore();
                            copyCtxState11(groupCtx11, this.ctx);
                            const deltaTransform11 = _util11.Util.transform(this.current.activeSMask.startTransformInverse, groupCtx11.mozCurrentTransform);
                            this.ctx.transform.apply(this.ctx, deltaTransform11);
                        }
                        save() {
                            this.ctx.save();
                            const old11 = this.current;
                            this.stateStack.push(old11);
                            this.current = old11.clone();
                            this.current.resumeSMaskCtx = null;
                        }
                        restore() {
                            if (this.current.resumeSMaskCtx) this.resumeSMaskGroup();
                            if (this.current.activeSMask !== null && (this.stateStack.length === 0 || this.stateStack[this.stateStack.length - 1].activeSMask !== this.current.activeSMask)) this.endSMaskGroup();
                            if (this.stateStack.length !== 0) {
                                this.current = this.stateStack.pop();
                                this.ctx.restore();
                                this.pendingClip = null;
                                this._cachedGetSinglePixelWidth = null;
                            } else this.current.activeSMask = null;
                        }
                        transform(a11, b41, c41, d51, e11, f11) {
                            this.ctx.transform(a11, b41, c41, d51, e11, f11);
                            this._cachedGetSinglePixelWidth = null;
                        }
                        constructPath(ops11, args11) {
                            const ctx11 = this.ctx;
                            const current11 = this.current;
                            let x41 = current11.x, y41 = current11.y;
                            for(let i11 = 0, j11 = 0, ii11 = ops11.length; i11 < ii11; i11++)switch(ops11[i11] | 0){
                                case _util11.OPS.rectangle:
                                    x41 = args11[j11++];
                                    y41 = args11[j11++];
                                    const width21 = args11[j11++];
                                    const height11 = args11[j11++];
                                    const xw11 = x41 + width21;
                                    const yh11 = y41 + height11;
                                    ctx11.moveTo(x41, y41);
                                    if (width21 === 0 || height11 === 0) ctx11.lineTo(xw11, yh11);
                                    else {
                                        ctx11.lineTo(xw11, y41);
                                        ctx11.lineTo(xw11, yh11);
                                        ctx11.lineTo(x41, yh11);
                                    }
                                    ctx11.closePath();
                                    break;
                                case _util11.OPS.moveTo:
                                    x41 = args11[j11++];
                                    y41 = args11[j11++];
                                    ctx11.moveTo(x41, y41);
                                    break;
                                case _util11.OPS.lineTo:
                                    x41 = args11[j11++];
                                    y41 = args11[j11++];
                                    ctx11.lineTo(x41, y41);
                                    break;
                                case _util11.OPS.curveTo:
                                    x41 = args11[j11 + 4];
                                    y41 = args11[j11 + 5];
                                    ctx11.bezierCurveTo(args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3], x41, y41);
                                    j11 += 6;
                                    break;
                                case _util11.OPS.curveTo2:
                                    ctx11.bezierCurveTo(x41, y41, args11[j11], args11[j11 + 1], args11[j11 + 2], args11[j11 + 3]);
                                    x41 = args11[j11 + 2];
                                    y41 = args11[j11 + 3];
                                    j11 += 4;
                                    break;
                                case _util11.OPS.curveTo3:
                                    x41 = args11[j11 + 2];
                                    y41 = args11[j11 + 3];
                                    ctx11.bezierCurveTo(args11[j11], args11[j11 + 1], x41, y41, x41, y41);
                                    j11 += 4;
                                    break;
                                case _util11.OPS.closePath:
                                    ctx11.closePath();
                                    break;
                            }
                            current11.setCurrentPoint(x41, y41);
                        }
                        closePath() {
                            this.ctx.closePath();
                        }
                        stroke(consumePath11) {
                            consumePath11 = typeof consumePath11 !== "undefined" ? consumePath11 : true;
                            const ctx11 = this.ctx;
                            const strokeColor11 = this.current.strokeColor;
                            ctx11.globalAlpha = this.current.strokeAlpha;
                            if (this.contentVisible) {
                                if (typeof strokeColor11 === "object" && strokeColor11?.getPattern) {
                                    const lineWidth11 = this.getSinglePixelWidth();
                                    ctx11.save();
                                    ctx11.strokeStyle = strokeColor11.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse);
                                    ctx11.lineWidth = Math.max(lineWidth11, this.current.lineWidth);
                                    ctx11.stroke();
                                    ctx11.restore();
                                } else {
                                    const lineWidth11 = this.getSinglePixelWidth();
                                    if (lineWidth11 < 0 && -lineWidth11 >= this.current.lineWidth) {
                                        ctx11.save();
                                        ctx11.resetTransform();
                                        ctx11.lineWidth = Math.round(this._combinedScaleFactor);
                                        ctx11.stroke();
                                        ctx11.restore();
                                    } else {
                                        ctx11.lineWidth = Math.max(lineWidth11, this.current.lineWidth);
                                        ctx11.stroke();
                                    }
                                }
                            }
                            if (consumePath11) this.consumePath();
                            ctx11.globalAlpha = this.current.fillAlpha;
                        }
                        closeStroke() {
                            this.closePath();
                            this.stroke();
                        }
                        fill(consumePath11) {
                            consumePath11 = typeof consumePath11 !== "undefined" ? consumePath11 : true;
                            const ctx11 = this.ctx;
                            const fillColor11 = this.current.fillColor;
                            const isPatternFill11 = this.current.patternFill;
                            let needRestore11 = false;
                            if (isPatternFill11) {
                                ctx11.save();
                                ctx11.fillStyle = fillColor11.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse);
                                needRestore11 = true;
                            }
                            if (this.contentVisible) {
                                if (this.pendingEOFill) {
                                    ctx11.fill("evenodd");
                                    this.pendingEOFill = false;
                                } else ctx11.fill();
                            }
                            if (needRestore11) ctx11.restore();
                            if (consumePath11) this.consumePath();
                        }
                        eoFill() {
                            this.pendingEOFill = true;
                            this.fill();
                        }
                        fillStroke() {
                            this.fill(false);
                            this.stroke(false);
                            this.consumePath();
                        }
                        eoFillStroke() {
                            this.pendingEOFill = true;
                            this.fillStroke();
                        }
                        closeFillStroke() {
                            this.closePath();
                            this.fillStroke();
                        }
                        closeEOFillStroke() {
                            this.pendingEOFill = true;
                            this.closePath();
                            this.fillStroke();
                        }
                        endPath() {
                            this.consumePath();
                        }
                        clip() {
                            this.pendingClip = NORMAL_CLIP11;
                        }
                        eoClip() {
                            this.pendingClip = EO_CLIP11;
                        }
                        beginText() {
                            this.current.textMatrix = _util11.IDENTITY_MATRIX;
                            this.current.textMatrixScale = 1;
                            this.current.x = this.current.lineX = 0;
                            this.current.y = this.current.lineY = 0;
                        }
                        endText() {
                            const paths11 = this.pendingTextPaths;
                            const ctx11 = this.ctx;
                            if (paths11 === undefined) {
                                ctx11.beginPath();
                                return;
                            }
                            ctx11.save();
                            ctx11.beginPath();
                            for(let i11 = 0; i11 < paths11.length; i11++){
                                const path11 = paths11[i11];
                                ctx11.setTransform.apply(ctx11, path11.transform);
                                ctx11.translate(path11.x, path11.y);
                                path11.addToPath(ctx11, path11.fontSize);
                            }
                            ctx11.restore();
                            ctx11.clip();
                            ctx11.beginPath();
                            delete this.pendingTextPaths;
                        }
                        setCharSpacing(spacing11) {
                            this.current.charSpacing = spacing11;
                        }
                        setWordSpacing(spacing11) {
                            this.current.wordSpacing = spacing11;
                        }
                        setHScale(scale11) {
                            this.current.textHScale = scale11 / 100;
                        }
                        setLeading(leading11) {
                            this.current.leading = -leading11;
                        }
                        setFont(fontRefName11, size11) {
                            const fontObj11 = this.commonObjs.get(fontRefName11);
                            const current11 = this.current;
                            if (!fontObj11) throw new Error(`Can't find font for ${fontRefName11}`);
                            current11.fontMatrix = fontObj11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                            if (current11.fontMatrix[0] === 0 || current11.fontMatrix[3] === 0) (0, _util11.warn)("Invalid font matrix for font " + fontRefName11);
                            if (size11 < 0) {
                                size11 = -size11;
                                current11.fontDirection = -1;
                            } else current11.fontDirection = 1;
                            this.current.font = fontObj11;
                            this.current.fontSize = size11;
                            if (fontObj11.isType3Font) return;
                            const name11 = fontObj11.loadedName || "sans-serif";
                            let bold11 = "normal";
                            if (fontObj11.black) bold11 = "900";
                            else if (fontObj11.bold) bold11 = "bold";
                            const italic11 = fontObj11.italic ? "italic" : "normal";
                            const typeface11 = `"${name11}", ${fontObj11.fallbackName}`;
                            let browserFontSize11 = size11;
                            if (size11 < MIN_FONT_SIZE11) browserFontSize11 = MIN_FONT_SIZE11;
                            else if (size11 > MAX_FONT_SIZE11) browserFontSize11 = MAX_FONT_SIZE11;
                            this.current.fontSizeScale = size11 / browserFontSize11;
                            this.ctx.font = `${italic11} ${bold11} ${browserFontSize11}px ${typeface11}`;
                        }
                        setTextRenderingMode(mode11) {
                            this.current.textRenderingMode = mode11;
                        }
                        setTextRise(rise11) {
                            this.current.textRise = rise11;
                        }
                        moveText(x41, y41) {
                            this.current.x = this.current.lineX += x41;
                            this.current.y = this.current.lineY += y41;
                        }
                        setLeadingMoveText(x41, y41) {
                            this.setLeading(-y41);
                            this.moveText(x41, y41);
                        }
                        setTextMatrix(a11, b41, c41, d51, e11, f11) {
                            this.current.textMatrix = [
                                a11,
                                b41,
                                c41,
                                d51,
                                e11,
                                f11
                            ];
                            this.current.textMatrixScale = Math.hypot(a11, b41);
                            this.current.x = this.current.lineX = 0;
                            this.current.y = this.current.lineY = 0;
                        }
                        nextLine() {
                            this.moveText(0, this.current.leading);
                        }
                        paintChar(character11, x41, y41, patternTransform11, resetLineWidthToOne11) {
                            const ctx11 = this.ctx;
                            const current11 = this.current;
                            const font11 = current11.font;
                            const textRenderingMode11 = current11.textRenderingMode;
                            const fontSize11 = current11.fontSize / current11.fontSizeScale;
                            const fillStrokeMode11 = textRenderingMode11 & _util11.TextRenderingMode.FILL_STROKE_MASK;
                            const isAddToPathSet11 = !!(textRenderingMode11 & _util11.TextRenderingMode.ADD_TO_PATH_FLAG);
                            const patternFill11 = current11.patternFill && !font11.missingFile;
                            let addToPath11;
                            if (font11.disableFontFace || isAddToPathSet11 || patternFill11) addToPath11 = font11.getPathGenerator(this.commonObjs, character11);
                            if (font11.disableFontFace || patternFill11) {
                                ctx11.save();
                                ctx11.translate(x41, y41);
                                ctx11.beginPath();
                                addToPath11(ctx11, fontSize11);
                                if (patternTransform11) ctx11.setTransform.apply(ctx11, patternTransform11);
                                if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.fill();
                                if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                    if (resetLineWidthToOne11) {
                                        ctx11.resetTransform();
                                        ctx11.lineWidth = Math.round(this._combinedScaleFactor);
                                    }
                                    ctx11.stroke();
                                }
                                ctx11.restore();
                            } else {
                                if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) ctx11.fillText(character11, x41, y41);
                                if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                    if (resetLineWidthToOne11) {
                                        ctx11.save();
                                        ctx11.moveTo(x41, y41);
                                        ctx11.resetTransform();
                                        ctx11.lineWidth = Math.round(this._combinedScaleFactor);
                                        ctx11.strokeText(character11, 0, 0);
                                        ctx11.restore();
                                    } else ctx11.strokeText(character11, x41, y41);
                                }
                            }
                            if (isAddToPathSet11) {
                                const paths11 = this.pendingTextPaths || (this.pendingTextPaths = []);
                                paths11.push({
                                    transform: ctx11.mozCurrentTransform,
                                    x: x41,
                                    y: y41,
                                    fontSize: fontSize11,
                                    addToPath: addToPath11
                                });
                            }
                        }
                        get isFontSubpixelAAEnabled() {
                            const { context: ctx11  } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                            ctx11.scale(1.5, 1);
                            ctx11.fillText("I", 0, 10);
                            const data11 = ctx11.getImageData(0, 0, 10, 10).data;
                            let enabled11 = false;
                            for(let i11 = 3; i11 < data11.length; i11 += 4)if (data11[i11] > 0 && data11[i11] < 255) {
                                enabled11 = true;
                                break;
                            }
                            return (0, _util11.shadow)(this, "isFontSubpixelAAEnabled", enabled11);
                        }
                        showText(glyphs11) {
                            const current11 = this.current;
                            const font11 = current11.font;
                            if (font11.isType3Font) return this.showType3Text(glyphs11);
                            const fontSize11 = current11.fontSize;
                            if (fontSize11 === 0) return undefined;
                            const ctx11 = this.ctx;
                            const fontSizeScale11 = current11.fontSizeScale;
                            const charSpacing11 = current11.charSpacing;
                            const wordSpacing11 = current11.wordSpacing;
                            const fontDirection11 = current11.fontDirection;
                            const textHScale11 = current11.textHScale * fontDirection11;
                            const glyphsLength11 = glyphs11.length;
                            const vertical11 = font11.vertical;
                            const spacingDir11 = vertical11 ? 1 : -1;
                            const defaultVMetrics11 = font11.defaultVMetrics;
                            const widthAdvanceScale11 = fontSize11 * current11.fontMatrix[0];
                            const simpleFillText11 = current11.textRenderingMode === _util11.TextRenderingMode.FILL && !font11.disableFontFace && !current11.patternFill;
                            ctx11.save();
                            let patternTransform11;
                            if (current11.patternFill) {
                                ctx11.save();
                                const pattern11 = current11.fillColor.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse);
                                patternTransform11 = ctx11.mozCurrentTransform;
                                ctx11.restore();
                                ctx11.fillStyle = pattern11;
                            }
                            ctx11.transform.apply(ctx11, current11.textMatrix);
                            ctx11.translate(current11.x, current11.y + current11.textRise);
                            if (fontDirection11 > 0) ctx11.scale(textHScale11, -1);
                            else ctx11.scale(textHScale11, 1);
                            let lineWidth11 = current11.lineWidth;
                            let resetLineWidthToOne11 = false;
                            const scale11 = current11.textMatrixScale;
                            if (scale11 === 0 || lineWidth11 === 0) {
                                const fillStrokeMode11 = current11.textRenderingMode & _util11.TextRenderingMode.FILL_STROKE_MASK;
                                if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                    this._cachedGetSinglePixelWidth = null;
                                    lineWidth11 = this.getSinglePixelWidth();
                                    resetLineWidthToOne11 = lineWidth11 < 0;
                                }
                            } else lineWidth11 /= scale11;
                            if (fontSizeScale11 !== 1.0) {
                                ctx11.scale(fontSizeScale11, fontSizeScale11);
                                lineWidth11 /= fontSizeScale11;
                            }
                            ctx11.lineWidth = lineWidth11;
                            let x41 = 0, i11;
                            for(i11 = 0; i11 < glyphsLength11; ++i11){
                                const glyph11 = glyphs11[i11];
                                if ((0, _util11.isNum)(glyph11)) {
                                    x41 += spacingDir11 * glyph11 * fontSize11 / 1000;
                                    continue;
                                }
                                let restoreNeeded11 = false;
                                const spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                                const character11 = glyph11.fontChar;
                                const accent11 = glyph11.accent;
                                let scaledX11, scaledY11;
                                let width21 = glyph11.width;
                                if (vertical11) {
                                    const vmetric11 = glyph11.vmetric || defaultVMetrics11;
                                    const vx11 = -(glyph11.vmetric ? vmetric11[1] : width21 * 0.5) * widthAdvanceScale11;
                                    const vy11 = vmetric11[2] * widthAdvanceScale11;
                                    width21 = vmetric11 ? -vmetric11[0] : width21;
                                    scaledX11 = vx11 / fontSizeScale11;
                                    scaledY11 = (x41 + vy11) / fontSizeScale11;
                                } else {
                                    scaledX11 = x41 / fontSizeScale11;
                                    scaledY11 = 0;
                                }
                                if (font11.remeasure && width21 > 0) {
                                    const measuredWidth11 = ctx11.measureText(character11).width * 1000 / fontSize11 * fontSizeScale11;
                                    if (width21 < measuredWidth11 && this.isFontSubpixelAAEnabled) {
                                        const characterScaleX11 = width21 / measuredWidth11;
                                        restoreNeeded11 = true;
                                        ctx11.save();
                                        ctx11.scale(characterScaleX11, 1);
                                        scaledX11 /= characterScaleX11;
                                    } else if (width21 !== measuredWidth11) scaledX11 += (width21 - measuredWidth11) / 2000 * fontSize11 / fontSizeScale11;
                                }
                                if (this.contentVisible && (glyph11.isInFont || font11.missingFile)) {
                                    if (simpleFillText11 && !accent11) ctx11.fillText(character11, scaledX11, scaledY11);
                                    else {
                                        this.paintChar(character11, scaledX11, scaledY11, patternTransform11, resetLineWidthToOne11);
                                        if (accent11) {
                                            const scaledAccentX11 = scaledX11 + fontSize11 * accent11.offset.x / fontSizeScale11;
                                            const scaledAccentY11 = scaledY11 - fontSize11 * accent11.offset.y / fontSizeScale11;
                                            this.paintChar(accent11.fontChar, scaledAccentX11, scaledAccentY11, patternTransform11, resetLineWidthToOne11);
                                        }
                                    }
                                }
                                let charWidth11;
                                if (vertical11) charWidth11 = width21 * widthAdvanceScale11 - spacing11 * fontDirection11;
                                else charWidth11 = width21 * widthAdvanceScale11 + spacing11 * fontDirection11;
                                x41 += charWidth11;
                                if (restoreNeeded11) ctx11.restore();
                            }
                            if (vertical11) current11.y -= x41;
                            else current11.x += x41 * textHScale11;
                            ctx11.restore();
                            return undefined;
                        }
                        showType3Text(glyphs11) {
                            const ctx11 = this.ctx;
                            const current11 = this.current;
                            const font11 = current11.font;
                            const fontSize11 = current11.fontSize;
                            const fontDirection11 = current11.fontDirection;
                            const spacingDir11 = font11.vertical ? 1 : -1;
                            const charSpacing11 = current11.charSpacing;
                            const wordSpacing11 = current11.wordSpacing;
                            const textHScale11 = current11.textHScale * fontDirection11;
                            const fontMatrix11 = current11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                            const glyphsLength11 = glyphs11.length;
                            const isTextInvisible11 = current11.textRenderingMode === _util11.TextRenderingMode.INVISIBLE;
                            let i11, glyph11, width21, spacingLength11;
                            if (isTextInvisible11 || fontSize11 === 0) return;
                            this._cachedGetSinglePixelWidth = null;
                            ctx11.save();
                            ctx11.transform.apply(ctx11, current11.textMatrix);
                            ctx11.translate(current11.x, current11.y);
                            ctx11.scale(textHScale11, fontDirection11);
                            for(i11 = 0; i11 < glyphsLength11; ++i11){
                                glyph11 = glyphs11[i11];
                                if ((0, _util11.isNum)(glyph11)) {
                                    spacingLength11 = spacingDir11 * glyph11 * fontSize11 / 1000;
                                    this.ctx.translate(spacingLength11, 0);
                                    current11.x += spacingLength11 * textHScale11;
                                    continue;
                                }
                                const spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                                const operatorList11 = font11.charProcOperatorList[glyph11.operatorListId];
                                if (!operatorList11) {
                                    (0, _util11.warn)(`Type3 character "${glyph11.operatorListId}" is not available.`);
                                    continue;
                                }
                                if (this.contentVisible) {
                                    this.processingType3 = glyph11;
                                    this.save();
                                    ctx11.scale(fontSize11, fontSize11);
                                    ctx11.transform.apply(ctx11, fontMatrix11);
                                    this.executeOperatorList(operatorList11);
                                    this.restore();
                                }
                                const transformed11 = _util11.Util.applyTransform([
                                    glyph11.width,
                                    0
                                ], fontMatrix11);
                                width21 = transformed11[0] * fontSize11 + spacing11;
                                ctx11.translate(width21, 0);
                                current11.x += width21 * textHScale11;
                            }
                            ctx11.restore();
                            this.processingType3 = null;
                        }
                        setCharWidth(xWidth11, yWidth11) {}
                        setCharWidthAndBounds(xWidth11, yWidth11, llx11, lly11, urx11, ury11) {
                            this.ctx.rect(llx11, lly11, urx11 - llx11, ury11 - lly11);
                            this.clip();
                            this.endPath();
                        }
                        getColorN_Pattern(IR11) {
                            let pattern11;
                            if (IR11[0] === "TilingPattern") {
                                const color11 = IR11[1];
                                const baseTransform11 = this.baseTransform || this.ctx.mozCurrentTransform.slice();
                                const canvasGraphicsFactory11 = {
                                    createCanvasGraphics: (ctx11)=>{
                                        return new CanvasGraphics11(ctx11, this.commonObjs, this.objs, this.canvasFactory);
                                    }
                                };
                                pattern11 = new _pattern_helper11.TilingPattern(IR11, color11, this.ctx, canvasGraphicsFactory11, baseTransform11);
                            } else pattern11 = this._getPattern(IR11[1]);
                            return pattern11;
                        }
                        setStrokeColorN() {
                            this.current.strokeColor = this.getColorN_Pattern(arguments);
                        }
                        setFillColorN() {
                            this.current.fillColor = this.getColorN_Pattern(arguments);
                            this.current.patternFill = true;
                        }
                        setStrokeRGBColor(r11, g11, b41) {
                            const color11 = _util11.Util.makeHexColor(r11, g11, b41);
                            this.ctx.strokeStyle = color11;
                            this.current.strokeColor = color11;
                        }
                        setFillRGBColor(r11, g11, b41) {
                            const color11 = _util11.Util.makeHexColor(r11, g11, b41);
                            this.ctx.fillStyle = color11;
                            this.current.fillColor = color11;
                            this.current.patternFill = false;
                        }
                        _getPattern(objId11) {
                            if (this.cachedPatterns.has(objId11)) return this.cachedPatterns.get(objId11);
                            const pattern11 = (0, _pattern_helper11.getShadingPattern)(this.objs.get(objId11));
                            this.cachedPatterns.set(objId11, pattern11);
                            return pattern11;
                        }
                        shadingFill(objId11) {
                            if (!this.contentVisible) return;
                            const ctx11 = this.ctx;
                            this.save();
                            const pattern11 = this._getPattern(objId11);
                            ctx11.fillStyle = pattern11.getPattern(ctx11, this, ctx11.mozCurrentTransformInverse, true);
                            const inv11 = ctx11.mozCurrentTransformInverse;
                            if (inv11) {
                                const canvas11 = ctx11.canvas;
                                const width21 = canvas11.width;
                                const height11 = canvas11.height;
                                const bl11 = _util11.Util.applyTransform([
                                    0,
                                    0
                                ], inv11);
                                const br11 = _util11.Util.applyTransform([
                                    0,
                                    height11
                                ], inv11);
                                const ul11 = _util11.Util.applyTransform([
                                    width21,
                                    0
                                ], inv11);
                                const ur11 = _util11.Util.applyTransform([
                                    width21,
                                    height11
                                ], inv11);
                                const x011 = Math.min(bl11[0], br11[0], ul11[0], ur11[0]);
                                const y011 = Math.min(bl11[1], br11[1], ul11[1], ur11[1]);
                                const x111 = Math.max(bl11[0], br11[0], ul11[0], ur11[0]);
                                const y111 = Math.max(bl11[1], br11[1], ul11[1], ur11[1]);
                                this.ctx.fillRect(x011, y011, x111 - x011, y111 - y011);
                            } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                            this.restore();
                        }
                        beginInlineImage() {
                            (0, _util11.unreachable)("Should not call beginInlineImage");
                        }
                        beginImageData() {
                            (0, _util11.unreachable)("Should not call beginImageData");
                        }
                        paintFormXObjectBegin(matrix11, bbox11) {
                            if (!this.contentVisible) return;
                            this.save();
                            this.baseTransformStack.push(this.baseTransform);
                            if (Array.isArray(matrix11) && matrix11.length === 6) this.transform.apply(this, matrix11);
                            this.baseTransform = this.ctx.mozCurrentTransform;
                            if (bbox11) {
                                const width21 = bbox11[2] - bbox11[0];
                                const height11 = bbox11[3] - bbox11[1];
                                this.ctx.rect(bbox11[0], bbox11[1], width21, height11);
                                this.clip();
                                this.endPath();
                            }
                        }
                        paintFormXObjectEnd() {
                            if (!this.contentVisible) return;
                            this.restore();
                            this.baseTransform = this.baseTransformStack.pop();
                        }
                        beginGroup(group11) {
                            if (!this.contentVisible) return;
                            this.save();
                            const currentCtx11 = this.ctx;
                            if (!group11.isolated) (0, _util11.info)("TODO: Support non-isolated groups.");
                            if (group11.knockout) (0, _util11.warn)("Knockout groups not supported.");
                            const currentTransform11 = currentCtx11.mozCurrentTransform;
                            if (group11.matrix) currentCtx11.transform.apply(currentCtx11, group11.matrix);
                            if (!group11.bbox) throw new Error("Bounding box is required.");
                            let bounds11 = _util11.Util.getAxialAlignedBoundingBox(group11.bbox, currentCtx11.mozCurrentTransform);
                            const canvasBounds11 = [
                                0,
                                0,
                                currentCtx11.canvas.width,
                                currentCtx11.canvas.height
                            ];
                            bounds11 = _util11.Util.intersect(bounds11, canvasBounds11) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const offsetX11 = Math.floor(bounds11[0]);
                            const offsetY11 = Math.floor(bounds11[1]);
                            let drawnWidth11 = Math.max(Math.ceil(bounds11[2]) - offsetX11, 1);
                            let drawnHeight11 = Math.max(Math.ceil(bounds11[3]) - offsetY11, 1);
                            let scaleX11 = 1, scaleY11 = 1;
                            if (drawnWidth11 > MAX_GROUP_SIZE11) {
                                scaleX11 = drawnWidth11 / MAX_GROUP_SIZE11;
                                drawnWidth11 = MAX_GROUP_SIZE11;
                            }
                            if (drawnHeight11 > MAX_GROUP_SIZE11) {
                                scaleY11 = drawnHeight11 / MAX_GROUP_SIZE11;
                                drawnHeight11 = MAX_GROUP_SIZE11;
                            }
                            let cacheId11 = "groupAt" + this.groupLevel;
                            if (group11.smask) cacheId11 += "_smask_" + this.smaskCounter++ % 2;
                            const scratchCanvas11 = this.cachedCanvases.getCanvas(cacheId11, drawnWidth11, drawnHeight11, true);
                            const groupCtx11 = scratchCanvas11.context;
                            groupCtx11.scale(1 / scaleX11, 1 / scaleY11);
                            groupCtx11.translate(-offsetX11, -offsetY11);
                            groupCtx11.transform.apply(groupCtx11, currentTransform11);
                            if (group11.smask) this.smaskStack.push({
                                canvas: scratchCanvas11.canvas,
                                context: groupCtx11,
                                offsetX: offsetX11,
                                offsetY: offsetY11,
                                scaleX: scaleX11,
                                scaleY: scaleY11,
                                subtype: group11.smask.subtype,
                                backdrop: group11.smask.backdrop,
                                transferMap: group11.smask.transferMap || null,
                                startTransformInverse: null
                            });
                            else {
                                currentCtx11.setTransform(1, 0, 0, 1, 0, 0);
                                currentCtx11.translate(offsetX11, offsetY11);
                                currentCtx11.scale(scaleX11, scaleY11);
                            }
                            copyCtxState11(currentCtx11, groupCtx11);
                            this.ctx = groupCtx11;
                            this.setGState([
                                [
                                    "BM",
                                    "source-over"
                                ],
                                [
                                    "ca",
                                    1
                                ],
                                [
                                    "CA",
                                    1
                                ]
                            ]);
                            this.groupStack.push(currentCtx11);
                            this.groupLevel++;
                            this.current.activeSMask = null;
                        }
                        endGroup(group11) {
                            if (!this.contentVisible) return;
                            this.groupLevel--;
                            const groupCtx11 = this.ctx;
                            this.ctx = this.groupStack.pop();
                            if (this.ctx.imageSmoothingEnabled !== undefined) this.ctx.imageSmoothingEnabled = false;
                            else this.ctx.mozImageSmoothingEnabled = false;
                            if (group11.smask) this.tempSMask = this.smaskStack.pop();
                            else this.ctx.drawImage(groupCtx11.canvas, 0, 0);
                            this.restore();
                        }
                        beginAnnotations() {
                            this.save();
                            if (this.baseTransform) this.ctx.setTransform.apply(this.ctx, this.baseTransform);
                        }
                        endAnnotations() {
                            this.restore();
                        }
                        beginAnnotation(id11, rect31, transform11, matrix11) {
                            this.save();
                            resetCtxToDefault11(this.ctx);
                            this.current = new CanvasExtraState11();
                            if (Array.isArray(rect31) && rect31.length === 4) {
                                const width21 = rect31[2] - rect31[0];
                                const height11 = rect31[3] - rect31[1];
                                this.ctx.rect(rect31[0], rect31[1], width21, height11);
                                this.clip();
                                this.endPath();
                            }
                            this.transform.apply(this, transform11);
                            this.transform.apply(this, matrix11);
                        }
                        endAnnotation() {
                            this.restore();
                        }
                        paintImageMaskXObject(img11) {
                            if (!this.contentVisible) return;
                            const ctx11 = this.ctx;
                            const width21 = img11.width, height11 = img11.height;
                            const glyph11 = this.processingType3;
                            if (COMPILE_TYPE3_GLYPHS11 && glyph11 && glyph11.compiled === undefined) {
                                if (width21 <= MAX_SIZE_TO_COMPILE11 && height11 <= MAX_SIZE_TO_COMPILE11) glyph11.compiled = compileType3Glyph11({
                                    data: img11.data,
                                    width: width21,
                                    height: height11
                                });
                                else glyph11.compiled = null;
                            }
                            if (glyph11?.compiled) {
                                glyph11.compiled(ctx11);
                                return;
                            }
                            const mask11 = this._createMaskCanvas(img11);
                            const maskCanvas11 = mask11.canvas;
                            ctx11.save();
                            ctx11.setTransform(1, 0, 0, 1, 0, 0);
                            ctx11.drawImage(maskCanvas11, mask11.offsetX, mask11.offsetY);
                            ctx11.restore();
                        }
                        paintImageMaskXObjectRepeat(imgData11, scaleX11, skewX11 = 0, skewY11 = 0, scaleY11, positions11) {
                            if (!this.contentVisible) return;
                            const ctx11 = this.ctx;
                            ctx11.save();
                            const currentTransform11 = ctx11.mozCurrentTransform;
                            ctx11.transform(scaleX11, skewX11, skewY11, scaleY11, 0, 0);
                            const mask11 = this._createMaskCanvas(imgData11);
                            ctx11.setTransform(1, 0, 0, 1, 0, 0);
                            for(let i11 = 0, ii11 = positions11.length; i11 < ii11; i11 += 2){
                                const trans11 = _util11.Util.transform(currentTransform11, [
                                    scaleX11,
                                    skewX11,
                                    skewY11,
                                    scaleY11,
                                    positions11[i11],
                                    positions11[i11 + 1]
                                ]);
                                const [x41, y41] = _util11.Util.applyTransform([
                                    0,
                                    0
                                ], trans11);
                                ctx11.drawImage(mask11.canvas, x41, y41);
                            }
                            ctx11.restore();
                        }
                        paintImageMaskXObjectGroup(images11) {
                            if (!this.contentVisible) return;
                            const ctx11 = this.ctx;
                            const fillColor11 = this.current.fillColor;
                            const isPatternFill11 = this.current.patternFill;
                            for(let i11 = 0, ii11 = images11.length; i11 < ii11; i11++){
                                const image11 = images11[i11];
                                const width21 = image11.width, height11 = image11.height;
                                const maskCanvas11 = this.cachedCanvases.getCanvas("maskCanvas", width21, height11);
                                const maskCtx11 = maskCanvas11.context;
                                maskCtx11.save();
                                putBinaryImageMask11(maskCtx11, image11);
                                maskCtx11.globalCompositeOperation = "source-in";
                                maskCtx11.fillStyle = isPatternFill11 ? fillColor11.getPattern(maskCtx11, this, ctx11.mozCurrentTransformInverse, false) : fillColor11;
                                maskCtx11.fillRect(0, 0, width21, height11);
                                maskCtx11.restore();
                                ctx11.save();
                                ctx11.transform.apply(ctx11, image11.transform);
                                ctx11.scale(1, -1);
                                ctx11.drawImage(maskCanvas11.canvas, 0, 0, width21, height11, 0, -1, 1, 1);
                                ctx11.restore();
                            }
                        }
                        paintImageXObject(objId11) {
                            if (!this.contentVisible) return;
                            const imgData11 = objId11.startsWith("g_") ? this.commonObjs.get(objId11) : this.objs.get(objId11);
                            if (!imgData11) {
                                (0, _util11.warn)("Dependent image isn't ready yet");
                                return;
                            }
                            this.paintInlineImageXObject(imgData11);
                        }
                        paintImageXObjectRepeat(objId11, scaleX11, scaleY11, positions11) {
                            if (!this.contentVisible) return;
                            const imgData11 = objId11.startsWith("g_") ? this.commonObjs.get(objId11) : this.objs.get(objId11);
                            if (!imgData11) {
                                (0, _util11.warn)("Dependent image isn't ready yet");
                                return;
                            }
                            const width21 = imgData11.width;
                            const height11 = imgData11.height;
                            const map11 = [];
                            for(let i11 = 0, ii11 = positions11.length; i11 < ii11; i11 += 2)map11.push({
                                transform: [
                                    scaleX11,
                                    0,
                                    0,
                                    scaleY11,
                                    positions11[i11],
                                    positions11[i11 + 1]
                                ],
                                x: 0,
                                y: 0,
                                w: width21,
                                h: height11
                            });
                            this.paintInlineImageXObjectGroup(imgData11, map11);
                        }
                        paintInlineImageXObject(imgData11) {
                            if (!this.contentVisible) return;
                            const width21 = imgData11.width;
                            const height11 = imgData11.height;
                            const ctx11 = this.ctx;
                            this.save();
                            ctx11.scale(1 / width21, -1 / height11);
                            let imgToPaint11;
                            if (typeof HTMLElement === "function" && imgData11 instanceof HTMLElement || !imgData11.data) imgToPaint11 = imgData11;
                            else {
                                const tmpCanvas11 = this.cachedCanvases.getCanvas("inlineImage", width21, height11);
                                const tmpCtx11 = tmpCanvas11.context;
                                putBinaryImageData11(tmpCtx11, imgData11, this.current.transferMaps);
                                imgToPaint11 = tmpCanvas11.canvas;
                            }
                            const scaled11 = this._scaleImage(imgToPaint11, ctx11.mozCurrentTransformInverse);
                            ctx11.drawImage(scaled11.img, 0, 0, scaled11.paintWidth, scaled11.paintHeight, 0, -height11, width21, height11);
                            if (this.imageLayer) {
                                const position11 = this.getCanvasPosition(0, -height11);
                                this.imageLayer.appendImage({
                                    imgData: imgData11,
                                    left: position11[0],
                                    top: position11[1],
                                    width: width21 / ctx11.mozCurrentTransformInverse[0],
                                    height: height11 / ctx11.mozCurrentTransformInverse[3]
                                });
                            }
                            this.restore();
                        }
                        paintInlineImageXObjectGroup(imgData11, map11) {
                            if (!this.contentVisible) return;
                            const ctx11 = this.ctx;
                            const w11 = imgData11.width;
                            const h11 = imgData11.height;
                            const tmpCanvas11 = this.cachedCanvases.getCanvas("inlineImage", w11, h11);
                            const tmpCtx11 = tmpCanvas11.context;
                            putBinaryImageData11(tmpCtx11, imgData11, this.current.transferMaps);
                            for(let i11 = 0, ii11 = map11.length; i11 < ii11; i11++){
                                const entry11 = map11[i11];
                                ctx11.save();
                                ctx11.transform.apply(ctx11, entry11.transform);
                                ctx11.scale(1, -1);
                                ctx11.drawImage(tmpCanvas11.canvas, entry11.x, entry11.y, entry11.w, entry11.h, 0, -1, 1, 1);
                                if (this.imageLayer) {
                                    const position11 = this.getCanvasPosition(entry11.x, entry11.y);
                                    this.imageLayer.appendImage({
                                        imgData: imgData11,
                                        left: position11[0],
                                        top: position11[1],
                                        width: w11,
                                        height: h11
                                    });
                                }
                                ctx11.restore();
                            }
                        }
                        paintSolidColorImageMask() {
                            if (!this.contentVisible) return;
                            this.ctx.fillRect(0, 0, 1, 1);
                        }
                        markPoint(tag11) {}
                        markPointProps(tag11, properties11) {}
                        beginMarkedContent(tag11) {
                            this.markedContentStack.push({
                                visible: true
                            });
                        }
                        beginMarkedContentProps(tag11, properties11) {
                            if (tag11 === "OC") this.markedContentStack.push({
                                visible: this.optionalContentConfig.isVisible(properties11)
                            });
                            else this.markedContentStack.push({
                                visible: true
                            });
                            this.contentVisible = this.isContentVisible();
                        }
                        endMarkedContent() {
                            this.markedContentStack.pop();
                            this.contentVisible = this.isContentVisible();
                        }
                        beginCompat() {}
                        endCompat() {}
                        consumePath() {
                            const ctx11 = this.ctx;
                            if (this.pendingClip) {
                                if (this.pendingClip === EO_CLIP11) ctx11.clip("evenodd");
                                else ctx11.clip();
                                this.pendingClip = null;
                            }
                            ctx11.beginPath();
                        }
                        getSinglePixelWidth() {
                            if (this._cachedGetSinglePixelWidth === null) {
                                const m31 = this.ctx.mozCurrentTransform;
                                const absDet11 = Math.abs(m31[0] * m31[3] - m31[2] * m31[1]);
                                const sqNorm111 = m31[0] ** 2 + m31[2] ** 2;
                                const sqNorm211 = m31[1] ** 2 + m31[3] ** 2;
                                const pixelHeight11 = Math.sqrt(Math.max(sqNorm111, sqNorm211)) / absDet11;
                                if (sqNorm111 !== sqNorm211 && this._combinedScaleFactor * pixelHeight11 > 1) this._cachedGetSinglePixelWidth = -(this._combinedScaleFactor * pixelHeight11);
                                else if (absDet11 > Number.EPSILON) this._cachedGetSinglePixelWidth = pixelHeight11;
                                else this._cachedGetSinglePixelWidth = 1;
                            }
                            return this._cachedGetSinglePixelWidth;
                        }
                        getCanvasPosition(x41, y41) {
                            const transform11 = this.ctx.mozCurrentTransform;
                            return [
                                transform11[0] * x41 + transform11[2] * y41 + transform11[4],
                                transform11[1] * x41 + transform11[3] * y41 + transform11[5]
                            ];
                        }
                        isContentVisible() {
                            for(let i11 = this.markedContentStack.length - 1; i11 >= 0; i11--){
                                if (!this.markedContentStack[i11].visible) return false;
                            }
                            return true;
                        }
                    }
                    for(const op11 in _util11.OPS)CanvasGraphics11.prototype[_util11.OPS[op11]] = CanvasGraphics11.prototype[op11];
                    return CanvasGraphics11;
                }();
                exports11.CanvasGraphics = CanvasGraphics11;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.getShadingPattern = getShadingPattern11;
                exports11.TilingPattern = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                function applyBoundingBox11(ctx11, bbox11) {
                    if (!bbox11 || typeof Path2D === "undefined") return;
                    const width21 = bbox11[2] - bbox11[0];
                    const height11 = bbox11[3] - bbox11[1];
                    const region11 = new Path2D();
                    region11.rect(bbox11[0], bbox11[1], width21, height11);
                    ctx11.clip(region11);
                }
                class BaseShadingPattern11 {
                    constructor(){
                        if (this.constructor === BaseShadingPattern11) (0, _util11.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                    getPattern() {
                        (0, _util11.unreachable)("Abstract method `getPattern` called.");
                    }
                }
                class RadialAxialShadingPattern11 extends BaseShadingPattern11 {
                    constructor(IR11){
                        super();
                        this._type = IR11[1];
                        this._bbox = IR11[2];
                        this._colorStops = IR11[3];
                        this._p0 = IR11[4];
                        this._p1 = IR11[5];
                        this._r0 = IR11[6];
                        this._r1 = IR11[7];
                        this._matrix = IR11[8];
                        this._patternCache = null;
                    }
                    _createGradient(ctx11) {
                        let grad11;
                        if (this._type === "axial") grad11 = ctx11.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad11 = ctx11.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop11 of this._colorStops)grad11.addColorStop(colorStop11[0], colorStop11[1]);
                        return grad11;
                    }
                    getPattern(ctx11, owner11, inverse11, shadingFill11 = false) {
                        let pattern11;
                        if (this._patternCache) pattern11 = this._patternCache;
                        else {
                            if (!shadingFill11) {
                                const tmpCanvas11 = owner11.cachedCanvases.getCanvas("pattern", owner11.ctx.canvas.width, owner11.ctx.canvas.height, true);
                                const tmpCtx11 = tmpCanvas11.context;
                                tmpCtx11.clearRect(0, 0, tmpCtx11.canvas.width, tmpCtx11.canvas.height);
                                tmpCtx11.beginPath();
                                tmpCtx11.rect(0, 0, tmpCtx11.canvas.width, tmpCtx11.canvas.height);
                                tmpCtx11.setTransform.apply(tmpCtx11, owner11.baseTransform);
                                if (this._matrix) tmpCtx11.transform.apply(tmpCtx11, this._matrix);
                                applyBoundingBox11(tmpCtx11, this._bbox);
                                tmpCtx11.fillStyle = this._createGradient(tmpCtx11);
                                tmpCtx11.fill();
                                pattern11 = ctx11.createPattern(tmpCanvas11.canvas, "repeat");
                            } else {
                                applyBoundingBox11(ctx11, this._bbox);
                                pattern11 = this._createGradient(ctx11);
                            }
                            this._patternCache = pattern11;
                        }
                        if (!shadingFill11) {
                            const domMatrix11 = new DOMMatrix(inverse11);
                            try {
                                pattern11.setTransform(domMatrix11);
                            } catch (ex11) {
                                (0, _util11.warn)(`RadialAxialShadingPattern.getPattern: "${ex11?.message}".`);
                            }
                        }
                        return pattern11;
                    }
                }
                function drawTriangle11(data11, context11, p111, p211, p311, c111, c211, c311) {
                    const coords11 = context11.coords, colors11 = context11.colors;
                    const bytes11 = data11.data, rowSize11 = data11.width * 4;
                    let tmp11;
                    if (coords11[p111 + 1] > coords11[p211 + 1]) {
                        tmp11 = p111;
                        p111 = p211;
                        p211 = tmp11;
                        tmp11 = c111;
                        c111 = c211;
                        c211 = tmp11;
                    }
                    if (coords11[p211 + 1] > coords11[p311 + 1]) {
                        tmp11 = p211;
                        p211 = p311;
                        p311 = tmp11;
                        tmp11 = c211;
                        c211 = c311;
                        c311 = tmp11;
                    }
                    if (coords11[p111 + 1] > coords11[p211 + 1]) {
                        tmp11 = p111;
                        p111 = p211;
                        p211 = tmp11;
                        tmp11 = c111;
                        c111 = c211;
                        c211 = tmp11;
                    }
                    const x111 = (coords11[p111] + context11.offsetX) * context11.scaleX;
                    const y111 = (coords11[p111 + 1] + context11.offsetY) * context11.scaleY;
                    const x211 = (coords11[p211] + context11.offsetX) * context11.scaleX;
                    const y211 = (coords11[p211 + 1] + context11.offsetY) * context11.scaleY;
                    const x311 = (coords11[p311] + context11.offsetX) * context11.scaleX;
                    const y311 = (coords11[p311 + 1] + context11.offsetY) * context11.scaleY;
                    if (y111 >= y311) return;
                    const c1r11 = colors11[c111], c1g11 = colors11[c111 + 1], c1b11 = colors11[c111 + 2];
                    const c2r11 = colors11[c211], c2g11 = colors11[c211 + 1], c2b11 = colors11[c211 + 2];
                    const c3r11 = colors11[c311], c3g11 = colors11[c311 + 1], c3b11 = colors11[c311 + 2];
                    const minY11 = Math.round(y111), maxY11 = Math.round(y311);
                    let xa11, car11, cag11, cab11;
                    let xb11, cbr11, cbg11, cbb11;
                    for(let y41 = minY11; y41 <= maxY11; y41++){
                        if (y41 < y211) {
                            let k11;
                            if (y41 < y111) k11 = 0;
                            else k11 = (y111 - y41) / (y111 - y211);
                            xa11 = x111 - (x111 - x211) * k11;
                            car11 = c1r11 - (c1r11 - c2r11) * k11;
                            cag11 = c1g11 - (c1g11 - c2g11) * k11;
                            cab11 = c1b11 - (c1b11 - c2b11) * k11;
                        } else {
                            let k11;
                            if (y41 > y311) k11 = 1;
                            else if (y211 === y311) k11 = 0;
                            else k11 = (y211 - y41) / (y211 - y311);
                            xa11 = x211 - (x211 - x311) * k11;
                            car11 = c2r11 - (c2r11 - c3r11) * k11;
                            cag11 = c2g11 - (c2g11 - c3g11) * k11;
                            cab11 = c2b11 - (c2b11 - c3b11) * k11;
                        }
                        let k11;
                        if (y41 < y111) k11 = 0;
                        else if (y41 > y311) k11 = 1;
                        else k11 = (y111 - y41) / (y111 - y311);
                        xb11 = x111 - (x111 - x311) * k11;
                        cbr11 = c1r11 - (c1r11 - c3r11) * k11;
                        cbg11 = c1g11 - (c1g11 - c3g11) * k11;
                        cbb11 = c1b11 - (c1b11 - c3b11) * k11;
                        const x1_11 = Math.round(Math.min(xa11, xb11));
                        const x2_11 = Math.round(Math.max(xa11, xb11));
                        let j11 = rowSize11 * y41 + x1_11 * 4;
                        for(let x41 = x1_11; x41 <= x2_11; x41++){
                            k11 = (xa11 - x41) / (xa11 - xb11);
                            if (k11 < 0) k11 = 0;
                            else if (k11 > 1) k11 = 1;
                            bytes11[j11++] = car11 - (car11 - cbr11) * k11 | 0;
                            bytes11[j11++] = cag11 - (cag11 - cbg11) * k11 | 0;
                            bytes11[j11++] = cab11 - (cab11 - cbb11) * k11 | 0;
                            bytes11[j11++] = 255;
                        }
                    }
                }
                function drawFigure11(data11, figure11, context11) {
                    const ps11 = figure11.coords;
                    const cs11 = figure11.colors;
                    let i11, ii11;
                    switch(figure11.type){
                        case "lattice":
                            const verticesPerRow11 = figure11.verticesPerRow;
                            const rows11 = Math.floor(ps11.length / verticesPerRow11) - 1;
                            const cols11 = verticesPerRow11 - 1;
                            for(i11 = 0; i11 < rows11; i11++){
                                let q11 = i11 * verticesPerRow11;
                                for(let j11 = 0; j11 < cols11; j11++, q11++){
                                    drawTriangle11(data11, context11, ps11[q11], ps11[q11 + 1], ps11[q11 + verticesPerRow11], cs11[q11], cs11[q11 + 1], cs11[q11 + verticesPerRow11]);
                                    drawTriangle11(data11, context11, ps11[q11 + verticesPerRow11 + 1], ps11[q11 + 1], ps11[q11 + verticesPerRow11], cs11[q11 + verticesPerRow11 + 1], cs11[q11 + 1], cs11[q11 + verticesPerRow11]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i11 = 0, ii11 = ps11.length; i11 < ii11; i11 += 3)drawTriangle11(data11, context11, ps11[i11], ps11[i11 + 1], ps11[i11 + 2], cs11[i11], cs11[i11 + 1], cs11[i11 + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern11 extends BaseShadingPattern11 {
                    constructor(IR11){
                        super();
                        this._coords = IR11[2];
                        this._colors = IR11[3];
                        this._figures = IR11[4];
                        this._bounds = IR11[5];
                        this._matrix = IR11[6];
                        this._bbox = IR11[7];
                        this._background = IR11[8];
                    }
                    _createMeshCanvas(combinedScale11, backgroundColor11, cachedCanvases11) {
                        const EXPECTED_SCALE11 = 1.1;
                        const MAX_PATTERN_SIZE11 = 3000;
                        const BORDER_SIZE11 = 2;
                        const offsetX11 = Math.floor(this._bounds[0]);
                        const offsetY11 = Math.floor(this._bounds[1]);
                        const boundsWidth11 = Math.ceil(this._bounds[2]) - offsetX11;
                        const boundsHeight11 = Math.ceil(this._bounds[3]) - offsetY11;
                        const width21 = Math.min(Math.ceil(Math.abs(boundsWidth11 * combinedScale11[0] * EXPECTED_SCALE11)), MAX_PATTERN_SIZE11);
                        const height11 = Math.min(Math.ceil(Math.abs(boundsHeight11 * combinedScale11[1] * EXPECTED_SCALE11)), MAX_PATTERN_SIZE11);
                        const scaleX11 = boundsWidth11 / width21;
                        const scaleY11 = boundsHeight11 / height11;
                        const context11 = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX11,
                            offsetY: -offsetY11,
                            scaleX: 1 / scaleX11,
                            scaleY: 1 / scaleY11
                        };
                        const paddedWidth11 = width21 + BORDER_SIZE11 * 2;
                        const paddedHeight11 = height11 + BORDER_SIZE11 * 2;
                        const tmpCanvas11 = cachedCanvases11.getCanvas("mesh", paddedWidth11, paddedHeight11, false);
                        const tmpCtx11 = tmpCanvas11.context;
                        const data11 = tmpCtx11.createImageData(width21, height11);
                        if (backgroundColor11) {
                            const bytes11 = data11.data;
                            for(let i11 = 0, ii11 = bytes11.length; i11 < ii11; i11 += 4){
                                bytes11[i11] = backgroundColor11[0];
                                bytes11[i11 + 1] = backgroundColor11[1];
                                bytes11[i11 + 2] = backgroundColor11[2];
                                bytes11[i11 + 3] = 255;
                            }
                        }
                        for (const figure11 of this._figures)drawFigure11(data11, figure11, context11);
                        tmpCtx11.putImageData(data11, BORDER_SIZE11, BORDER_SIZE11);
                        const canvas11 = tmpCanvas11.canvas;
                        return {
                            canvas: canvas11,
                            offsetX: offsetX11 - BORDER_SIZE11 * scaleX11,
                            offsetY: offsetY11 - BORDER_SIZE11 * scaleY11,
                            scaleX: scaleX11,
                            scaleY: scaleY11
                        };
                    }
                    getPattern(ctx11, owner11, inverse11, shadingFill11 = false) {
                        applyBoundingBox11(ctx11, this._bbox);
                        let scale11;
                        if (shadingFill11) scale11 = _util11.Util.singularValueDecompose2dScale(ctx11.mozCurrentTransform);
                        else {
                            scale11 = _util11.Util.singularValueDecompose2dScale(owner11.baseTransform);
                            if (this._matrix) {
                                const matrixScale11 = _util11.Util.singularValueDecompose2dScale(this._matrix);
                                scale11 = [
                                    scale11[0] * matrixScale11[0],
                                    scale11[1] * matrixScale11[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas11 = this._createMeshCanvas(scale11, shadingFill11 ? null : this._background, owner11.cachedCanvases);
                        if (!shadingFill11) {
                            ctx11.setTransform.apply(ctx11, owner11.baseTransform);
                            if (this._matrix) ctx11.transform.apply(ctx11, this._matrix);
                        }
                        ctx11.translate(temporaryPatternCanvas11.offsetX, temporaryPatternCanvas11.offsetY);
                        ctx11.scale(temporaryPatternCanvas11.scaleX, temporaryPatternCanvas11.scaleY);
                        return ctx11.createPattern(temporaryPatternCanvas11.canvas, "no-repeat");
                    }
                }
                class DummyShadingPattern11 extends BaseShadingPattern11 {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern11(IR11) {
                    switch(IR11[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern11(IR11);
                        case "Mesh":
                            return new MeshShadingPattern11(IR11);
                        case "Dummy":
                            return new DummyShadingPattern11();
                    }
                    throw new Error(`Unknown IR type: ${IR11[0]}`);
                }
                const PaintType11 = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern11 {
                    static get MAX_PATTERN_SIZE() {
                        return (0, _util11.shadow)(this, "MAX_PATTERN_SIZE", 3000);
                    }
                    constructor(IR11, color11, ctx11, canvasGraphicsFactory11, baseTransform11){
                        this.operatorList = IR11[2];
                        this.matrix = IR11[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR11[4];
                        this.xstep = IR11[5];
                        this.ystep = IR11[6];
                        this.paintType = IR11[7];
                        this.tilingType = IR11[8];
                        this.color = color11;
                        this.ctx = ctx11;
                        this.canvasGraphicsFactory = canvasGraphicsFactory11;
                        this.baseTransform = baseTransform11;
                    }
                    createPatternCanvas(owner11) {
                        const operatorList11 = this.operatorList;
                        const bbox11 = this.bbox;
                        const xstep11 = this.xstep;
                        const ystep11 = this.ystep;
                        const paintType11 = this.paintType;
                        const tilingType11 = this.tilingType;
                        const color11 = this.color;
                        const canvasGraphicsFactory11 = this.canvasGraphicsFactory;
                        (0, _util11.info)("TilingType: " + tilingType11);
                        const x011 = bbox11[0], y011 = bbox11[1], x111 = bbox11[2], y111 = bbox11[3];
                        const matrixScale11 = _util11.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale11 = _util11.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale11 = [
                            matrixScale11[0] * curMatrixScale11[0],
                            matrixScale11[1] * curMatrixScale11[1]
                        ];
                        const dimx11 = this.getSizeAndScale(xstep11, this.ctx.canvas.width, combinedScale11[0]);
                        const dimy11 = this.getSizeAndScale(ystep11, this.ctx.canvas.height, combinedScale11[1]);
                        const tmpCanvas11 = owner11.cachedCanvases.getCanvas("pattern", dimx11.size, dimy11.size, true);
                        const tmpCtx11 = tmpCanvas11.context;
                        const graphics11 = canvasGraphicsFactory11.createCanvasGraphics(tmpCtx11);
                        graphics11.groupLevel = owner11.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics11, paintType11, color11);
                        let adjustedX011 = x011;
                        let adjustedY011 = y011;
                        let adjustedX111 = x111;
                        let adjustedY111 = y111;
                        if (x011 < 0) {
                            adjustedX011 = 0;
                            adjustedX111 += Math.abs(x011);
                        }
                        if (y011 < 0) {
                            adjustedY011 = 0;
                            adjustedY111 += Math.abs(y011);
                        }
                        tmpCtx11.translate(-(dimx11.scale * adjustedX011), -(dimy11.scale * adjustedY011));
                        graphics11.transform(dimx11.scale, 0, 0, dimy11.scale, 0, 0);
                        this.clipBbox(graphics11, adjustedX011, adjustedY011, adjustedX111, adjustedY111);
                        graphics11.baseTransform = graphics11.ctx.mozCurrentTransform.slice();
                        graphics11.executeOperatorList(operatorList11);
                        graphics11.endDrawing();
                        return {
                            canvas: tmpCanvas11.canvas,
                            scaleX: dimx11.scale,
                            scaleY: dimy11.scale,
                            offsetX: adjustedX011,
                            offsetY: adjustedY011
                        };
                    }
                    getSizeAndScale(step11, realOutputSize11, scale11) {
                        step11 = Math.abs(step11);
                        const maxSize11 = Math.max(TilingPattern11.MAX_PATTERN_SIZE, realOutputSize11);
                        let size11 = Math.ceil(step11 * scale11);
                        if (size11 >= maxSize11) size11 = maxSize11;
                        else scale11 = size11 / step11;
                        return {
                            scale: scale11,
                            size: size11
                        };
                    }
                    clipBbox(graphics11, x011, y011, x111, y111) {
                        const bboxWidth11 = x111 - x011;
                        const bboxHeight11 = y111 - y011;
                        graphics11.ctx.rect(x011, y011, bboxWidth11, bboxHeight11);
                        graphics11.clip();
                        graphics11.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics11, paintType11, color11) {
                        const context11 = graphics11.ctx, current11 = graphics11.current;
                        switch(paintType11){
                            case PaintType11.COLORED:
                                const ctx11 = this.ctx;
                                context11.fillStyle = ctx11.fillStyle;
                                context11.strokeStyle = ctx11.strokeStyle;
                                current11.fillColor = ctx11.fillStyle;
                                current11.strokeColor = ctx11.strokeStyle;
                                break;
                            case PaintType11.UNCOLORED:
                                const cssColor11 = _util11.Util.makeHexColor(color11[0], color11[1], color11[2]);
                                context11.fillStyle = cssColor11;
                                context11.strokeStyle = cssColor11;
                                current11.fillColor = cssColor11;
                                current11.strokeColor = cssColor11;
                                break;
                            default:
                                throw new _util11.FormatError(`Unsupported paint type: ${paintType11}`);
                        }
                    }
                    getPattern(ctx11, owner11, inverse11, shadingFill11 = false) {
                        let matrix11 = inverse11;
                        if (!shadingFill11) {
                            matrix11 = _util11.Util.transform(matrix11, owner11.baseTransform);
                            if (this.matrix) matrix11 = _util11.Util.transform(matrix11, this.matrix);
                        }
                        const temporaryPatternCanvas11 = this.createPatternCanvas(owner11);
                        let domMatrix11 = new DOMMatrix(matrix11);
                        domMatrix11 = domMatrix11.translate(temporaryPatternCanvas11.offsetX, temporaryPatternCanvas11.offsetY);
                        domMatrix11 = domMatrix11.scale(1 / temporaryPatternCanvas11.scaleX, 1 / temporaryPatternCanvas11.scaleY);
                        const pattern11 = ctx11.createPattern(temporaryPatternCanvas11.canvas, "repeat");
                        try {
                            pattern11.setTransform(domMatrix11);
                        } catch (ex11) {
                            (0, _util11.warn)(`TilingPattern.getPattern: "${ex11?.message}".`);
                        }
                        return pattern11;
                    }
                }
                exports11.TilingPattern = TilingPattern11;
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions11 = Object.create(null);
                exports11.GlobalWorkerOptions = GlobalWorkerOptions11;
                GlobalWorkerOptions11.workerPort = GlobalWorkerOptions11.workerPort === undefined ? null : GlobalWorkerOptions11.workerPort;
                GlobalWorkerOptions11.workerSrc = GlobalWorkerOptions11.workerSrc === undefined ? "" : GlobalWorkerOptions11.workerSrc;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.MessageHandler = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                const CallbackKind11 = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind11 = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason11(reason11) {
                    if (typeof reason11 !== "object" || reason11 === null) return reason11;
                    switch(reason11.name){
                        case "AbortException":
                            return new _util11.AbortException(reason11.message);
                        case "MissingPDFException":
                            return new _util11.MissingPDFException(reason11.message);
                        case "UnexpectedResponseException":
                            return new _util11.UnexpectedResponseException(reason11.message, reason11.status);
                        case "UnknownErrorException":
                            return new _util11.UnknownErrorException(reason11.message, reason11.details);
                        default:
                            return new _util11.UnknownErrorException(reason11.message, reason11.toString());
                    }
                }
                class MessageHandler11 {
                    constructor(sourceName11, targetName11, comObj11){
                        this.sourceName = sourceName11;
                        this.targetName = targetName11;
                        this.comObj = comObj11;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.postMessageTransfers = true;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event11)=>{
                            const data11 = event11.data;
                            if (data11.targetName !== this.sourceName) return;
                            if (data11.stream) {
                                this._processStreamMessage(data11);
                                return;
                            }
                            if (data11.callback) {
                                const callbackId11 = data11.callbackId;
                                const capability11 = this.callbackCapabilities[callbackId11];
                                if (!capability11) throw new Error(`Cannot resolve callback ${callbackId11}`);
                                delete this.callbackCapabilities[callbackId11];
                                if (data11.callback === CallbackKind11.DATA) capability11.resolve(data11.data);
                                else if (data11.callback === CallbackKind11.ERROR) capability11.reject(wrapReason11(data11.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action11 = this.actionHandler[data11.action];
                            if (!action11) throw new Error(`Unknown action from worker: ${data11.action}`);
                            if (data11.callbackId) {
                                const cbSourceName11 = this.sourceName;
                                const cbTargetName11 = data11.sourceName;
                                new Promise(function(resolve11) {
                                    resolve11(action11(data11.data));
                                }).then(function(result11) {
                                    comObj11.postMessage({
                                        sourceName: cbSourceName11,
                                        targetName: cbTargetName11,
                                        callback: CallbackKind11.DATA,
                                        callbackId: data11.callbackId,
                                        data: result11
                                    });
                                }, function(reason11) {
                                    comObj11.postMessage({
                                        sourceName: cbSourceName11,
                                        targetName: cbTargetName11,
                                        callback: CallbackKind11.ERROR,
                                        callbackId: data11.callbackId,
                                        reason: wrapReason11(reason11)
                                    });
                                });
                                return;
                            }
                            if (data11.streamId) {
                                this._createStreamSink(data11);
                                return;
                            }
                            action11(data11.data);
                        };
                        comObj11.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName11, handler11) {
                        const ah11 = this.actionHandler;
                        if (ah11[actionName11]) throw new Error(`There is already an actionName called "${actionName11}"`);
                        ah11[actionName11] = handler11;
                    }
                    send(actionName11, data11, transfers11) {
                        this._postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName11,
                            data: data11
                        }, transfers11);
                    }
                    sendWithPromise(actionName11, data11, transfers11) {
                        const callbackId11 = this.callbackId++;
                        const capability11 = (0, _util11.createPromiseCapability)();
                        this.callbackCapabilities[callbackId11] = capability11;
                        try {
                            this._postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName11,
                                callbackId: callbackId11,
                                data: data11
                            }, transfers11);
                        } catch (ex11) {
                            capability11.reject(ex11);
                        }
                        return capability11.promise;
                    }
                    sendWithStream(actionName11, data11, queueingStrategy11, transfers11) {
                        const streamId11 = this.streamId++;
                        const sourceName11 = this.sourceName;
                        const targetName11 = this.targetName;
                        const comObj11 = this.comObj;
                        return new ReadableStream({
                            start: (controller11)=>{
                                const startCapability11 = (0, _util11.createPromiseCapability)();
                                this.streamControllers[streamId11] = {
                                    controller: controller11,
                                    startCall: startCapability11,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                this._postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    action: actionName11,
                                    streamId: streamId11,
                                    data: data11,
                                    desiredSize: controller11.desiredSize
                                }, transfers11);
                                return startCapability11.promise;
                            },
                            pull: (controller11)=>{
                                const pullCapability11 = (0, _util11.createPromiseCapability)();
                                this.streamControllers[streamId11].pullCall = pullCapability11;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.PULL,
                                    streamId: streamId11,
                                    desiredSize: controller11.desiredSize
                                });
                                return pullCapability11.promise;
                            },
                            cancel: (reason11)=>{
                                (0, _util11.assert)(reason11 instanceof Error, "cancel must have a valid reason");
                                const cancelCapability11 = (0, _util11.createPromiseCapability)();
                                this.streamControllers[streamId11].cancelCall = cancelCapability11;
                                this.streamControllers[streamId11].isClosed = true;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.CANCEL,
                                    streamId: streamId11,
                                    reason: wrapReason11(reason11)
                                });
                                return cancelCapability11.promise;
                            }
                        }, queueingStrategy11);
                    }
                    _createStreamSink(data11) {
                        const self11 = this;
                        const action11 = this.actionHandler[data11.action];
                        const streamId11 = data11.streamId;
                        const sourceName11 = this.sourceName;
                        const targetName11 = data11.sourceName;
                        const comObj11 = this.comObj;
                        const streamSink11 = {
                            enqueue (chunk31, size11 = 1, transfers11) {
                                if (this.isCancelled) return;
                                const lastDesiredSize11 = this.desiredSize;
                                this.desiredSize -= size11;
                                if (lastDesiredSize11 > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = (0, _util11.createPromiseCapability)();
                                    this.ready = this.sinkCapability.promise;
                                }
                                self11._postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.ENQUEUE,
                                    streamId: streamId11,
                                    chunk: chunk31
                                }, transfers11);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.CLOSE,
                                    streamId: streamId11
                                });
                                delete self11.streamSinks[streamId11];
                            },
                            error (reason11) {
                                (0, _util11.assert)(reason11 instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj11.postMessage({
                                    sourceName: sourceName11,
                                    targetName: targetName11,
                                    stream: StreamKind11.ERROR,
                                    streamId: streamId11,
                                    reason: wrapReason11(reason11)
                                });
                            },
                            sinkCapability: (0, _util11.createPromiseCapability)(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data11.desiredSize,
                            ready: null
                        };
                        streamSink11.sinkCapability.resolve();
                        streamSink11.ready = streamSink11.sinkCapability.promise;
                        this.streamSinks[streamId11] = streamSink11;
                        new Promise(function(resolve11) {
                            resolve11(action11(data11.data, streamSink11));
                        }).then(function() {
                            comObj11.postMessage({
                                sourceName: sourceName11,
                                targetName: targetName11,
                                stream: StreamKind11.START_COMPLETE,
                                streamId: streamId11,
                                success: true
                            });
                        }, function(reason11) {
                            comObj11.postMessage({
                                sourceName: sourceName11,
                                targetName: targetName11,
                                stream: StreamKind11.START_COMPLETE,
                                streamId: streamId11,
                                reason: wrapReason11(reason11)
                            });
                        });
                    }
                    _processStreamMessage(data11) {
                        const streamId11 = data11.streamId;
                        const sourceName11 = this.sourceName;
                        const targetName11 = data11.sourceName;
                        const comObj11 = this.comObj;
                        switch(data11.stream){
                            case StreamKind11.START_COMPLETE:
                                if (data11.success) this.streamControllers[streamId11].startCall.resolve();
                                else this.streamControllers[streamId11].startCall.reject(wrapReason11(data11.reason));
                                break;
                            case StreamKind11.PULL_COMPLETE:
                                if (data11.success) this.streamControllers[streamId11].pullCall.resolve();
                                else this.streamControllers[streamId11].pullCall.reject(wrapReason11(data11.reason));
                                break;
                            case StreamKind11.PULL:
                                if (!this.streamSinks[streamId11]) {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.PULL_COMPLETE,
                                        streamId: streamId11,
                                        success: true
                                    });
                                    break;
                                }
                                if (this.streamSinks[streamId11].desiredSize <= 0 && data11.desiredSize > 0) this.streamSinks[streamId11].sinkCapability.resolve();
                                this.streamSinks[streamId11].desiredSize = data11.desiredSize;
                                const { onPull: onPull11  } = this.streamSinks[data11.streamId];
                                new Promise(function(resolve11) {
                                    resolve11(onPull11 && onPull11());
                                }).then(function() {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.PULL_COMPLETE,
                                        streamId: streamId11,
                                        success: true
                                    });
                                }, function(reason11) {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.PULL_COMPLETE,
                                        streamId: streamId11,
                                        reason: wrapReason11(reason11)
                                    });
                                });
                                break;
                            case StreamKind11.ENQUEUE:
                                (0, _util11.assert)(this.streamControllers[streamId11], "enqueue should have stream controller");
                                if (this.streamControllers[streamId11].isClosed) break;
                                this.streamControllers[streamId11].controller.enqueue(data11.chunk);
                                break;
                            case StreamKind11.CLOSE:
                                (0, _util11.assert)(this.streamControllers[streamId11], "close should have stream controller");
                                if (this.streamControllers[streamId11].isClosed) break;
                                this.streamControllers[streamId11].isClosed = true;
                                this.streamControllers[streamId11].controller.close();
                                this._deleteStreamController(streamId11);
                                break;
                            case StreamKind11.ERROR:
                                (0, _util11.assert)(this.streamControllers[streamId11], "error should have stream controller");
                                this.streamControllers[streamId11].controller.error(wrapReason11(data11.reason));
                                this._deleteStreamController(streamId11);
                                break;
                            case StreamKind11.CANCEL_COMPLETE:
                                if (data11.success) this.streamControllers[streamId11].cancelCall.resolve();
                                else this.streamControllers[streamId11].cancelCall.reject(wrapReason11(data11.reason));
                                this._deleteStreamController(streamId11);
                                break;
                            case StreamKind11.CANCEL:
                                if (!this.streamSinks[streamId11]) break;
                                const { onCancel: onCancel11  } = this.streamSinks[data11.streamId];
                                new Promise(function(resolve11) {
                                    resolve11(onCancel11 && onCancel11(wrapReason11(data11.reason)));
                                }).then(function() {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.CANCEL_COMPLETE,
                                        streamId: streamId11,
                                        success: true
                                    });
                                }, function(reason11) {
                                    comObj11.postMessage({
                                        sourceName: sourceName11,
                                        targetName: targetName11,
                                        stream: StreamKind11.CANCEL_COMPLETE,
                                        streamId: streamId11,
                                        reason: wrapReason11(reason11)
                                    });
                                });
                                this.streamSinks[streamId11].sinkCapability.reject(wrapReason11(data11.reason));
                                this.streamSinks[streamId11].isCancelled = true;
                                delete this.streamSinks[streamId11];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async _deleteStreamController(streamId11) {
                        await Promise.allSettled([
                            this.streamControllers[streamId11].startCall,
                            this.streamControllers[streamId11].pullCall,
                            this.streamControllers[streamId11].cancelCall
                        ].map(function(capability11) {
                            return capability11 && capability11.promise;
                        }));
                        delete this.streamControllers[streamId11];
                    }
                    _postMessage(message11, transfers11) {
                        if (transfers11 && this.postMessageTransfers) this.comObj.postMessage(message11, transfers11);
                        else this.comObj.postMessage(message11);
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports11.MessageHandler = MessageHandler11;
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.Metadata = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                class Metadata11 {
                    constructor({ parsedData: parsedData11 , rawData: rawData11  }){
                        this._metadataMap = parsedData11;
                        this._data = rawData11;
                    }
                    getRaw() {
                        return this._data;
                    }
                    get(name11) {
                        return this._metadataMap.get(name11) ?? null;
                    }
                    getAll() {
                        return (0, _util11.objectFromMap)(this._metadataMap);
                    }
                    has(name11) {
                        return this._metadataMap.has(name11);
                    }
                }
                exports11.Metadata = Metadata11;
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.OptionalContentConfig = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                class OptionalContentGroup11 {
                    constructor(name11, intent11){
                        this.visible = true;
                        this.name = name11;
                        this.intent = intent11;
                    }
                }
                class OptionalContentConfig11 {
                    constructor(data11){
                        this.name = null;
                        this.creator = null;
                        this._order = null;
                        this._groups = new Map();
                        if (data11 === null) return;
                        this.name = data11.name;
                        this.creator = data11.creator;
                        this._order = data11.order;
                        for (const group11 of data11.groups)this._groups.set(group11.id, new OptionalContentGroup11(group11.name, group11.intent));
                        if (data11.baseState === "OFF") for (const group11 of this._groups)group11.visible = false;
                        for (const on11 of data11.on)this._groups.get(on11).visible = true;
                        for (const off11 of data11.off)this._groups.get(off11).visible = false;
                    }
                    _evaluateVisibilityExpression(array11) {
                        const length11 = array11.length;
                        if (length11 < 2) return true;
                        const operator11 = array11[0];
                        for(let i11 = 1; i11 < length11; i11++){
                            const element11 = array11[i11];
                            let state11;
                            if (Array.isArray(element11)) state11 = this._evaluateVisibilityExpression(element11);
                            else if (this._groups.has(element11)) state11 = this._groups.get(element11).visible;
                            else {
                                (0, _util11.warn)(`Optional content group not found: ${element11}`);
                                return true;
                            }
                            switch(operator11){
                                case "And":
                                    if (!state11) return false;
                                    break;
                                case "Or":
                                    if (state11) return true;
                                    break;
                                case "Not":
                                    return !state11;
                                default:
                                    return true;
                            }
                        }
                        return operator11 === "And";
                    }
                    isVisible(group11) {
                        if (group11.type === "OCG") {
                            if (!this._groups.has(group11.id)) {
                                (0, _util11.warn)(`Optional content group not found: ${group11.id}`);
                                return true;
                            }
                            return this._groups.get(group11.id).visible;
                        } else if (group11.type === "OCMD") {
                            if (group11.expression) return this._evaluateVisibilityExpression(group11.expression);
                            if (!group11.policy || group11.policy === "AnyOn") {
                                for (const id11 of group11.ids){
                                    if (!this._groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (this._groups.get(id11).visible) return true;
                                }
                                return false;
                            } else if (group11.policy === "AllOn") {
                                for (const id11 of group11.ids){
                                    if (!this._groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (!this._groups.get(id11).visible) return false;
                                }
                                return true;
                            } else if (group11.policy === "AnyOff") {
                                for (const id11 of group11.ids){
                                    if (!this._groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (!this._groups.get(id11).visible) return true;
                                }
                                return false;
                            } else if (group11.policy === "AllOff") {
                                for (const id11 of group11.ids){
                                    if (!this._groups.has(id11)) {
                                        (0, _util11.warn)(`Optional content group not found: ${id11}`);
                                        return true;
                                    }
                                    if (this._groups.get(id11).visible) return false;
                                }
                                return true;
                            }
                            (0, _util11.warn)(`Unknown optional content policy ${group11.policy}.`);
                            return true;
                        }
                        (0, _util11.warn)(`Unknown group type ${group11.type}.`);
                        return true;
                    }
                    setVisibility(id11, visible11 = true) {
                        if (!this._groups.has(id11)) {
                            (0, _util11.warn)(`Optional content group not found: ${id11}`);
                            return;
                        }
                        this._groups.get(id11).visible = !!visible11;
                    }
                    getOrder() {
                        if (!this._groups.size) return null;
                        if (this._order) return this._order.slice();
                        return Array.from(this._groups.keys());
                    }
                    getGroups() {
                        return this._groups.size > 0 ? (0, _util11.objectFromMap)(this._groups) : null;
                    }
                    getGroup(id11) {
                        return this._groups.get(id11) || null;
                    }
                }
                exports11.OptionalContentConfig = OptionalContentConfig11;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFDataTransportStream = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                var _display_utils11 = __w_pdfjs_require__11(1);
                class PDFDataTransportStream11 {
                    constructor(params11, pdfDataRangeTransport11){
                        (0, _util11.assert)(pdfDataRangeTransport11, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = params11.progressiveDone || false;
                        this._contentDispositionFilename = params11.contentDispositionFilename || null;
                        const initialData11 = params11.initialData;
                        if (initialData11?.length > 0) {
                            const buffer11 = new Uint8Array(initialData11).buffer;
                            this._queuedChunks.push(buffer11);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport11;
                        this._isStreamingSupported = !params11.disableStream;
                        this._isRangeSupported = !params11.disableRange;
                        this._contentLength = params11.length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin11, chunk31)=>{
                            this._onReceiveData({
                                begin: begin11,
                                chunk: chunk31
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded11, total11)=>{
                            this._onProgress({
                                loaded: loaded11,
                                total: total11
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk31)=>{
                            this._onReceiveData({
                                chunk: chunk31
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                    _onReceiveData(args11) {
                        const buffer11 = new Uint8Array(args11.chunk).buffer;
                        if (args11.begin === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer11);
                            else this._queuedChunks.push(buffer11);
                        } else {
                            const found11 = this._rangeReaders.some(function(rangeReader11) {
                                if (rangeReader11._begin !== args11.begin) return false;
                                rangeReader11._enqueue(buffer11);
                                return true;
                            });
                            (0, _util11.assert)(found11, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    _onProgress(evt11) {
                        if (evt11.total === undefined) {
                            const firstReader11 = this._rangeReaders[0];
                            if (firstReader11?.onProgress) firstReader11.onProgress({
                                loaded: evt11.loaded
                            });
                        } else {
                            const fullReader11 = this._fullRequestReader;
                            if (fullReader11?.onProgress) fullReader11.onProgress({
                                loaded: evt11.loaded,
                                total: evt11.total
                            });
                        }
                    }
                    _onProgressiveDone() {
                        if (this._fullRequestReader) this._fullRequestReader.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader11) {
                        const i11 = this._rangeReaders.indexOf(reader11);
                        if (i11 >= 0) this._rangeReaders.splice(i11, 1);
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks11 = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader11(this, queuedChunks11, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin11, end11) {
                        if (end11 <= this._progressiveDataLength) return null;
                        const reader11 = new PDFDataTransportStreamRangeReader11(this, begin11, end11);
                        this._pdfDataRangeTransport.requestDataRange(begin11, end11);
                        this._rangeReaders.push(reader11);
                        return reader11;
                    }
                    cancelAllRequests(reason11) {
                        if (this._fullRequestReader) this._fullRequestReader.cancel(reason11);
                        for (const reader11 of this._rangeReaders.slice(0))reader11.cancel(reason11);
                        this._pdfDataRangeTransport.abort();
                    }
                }
                exports11.PDFDataTransportStream = PDFDataTransportStream11;
                class PDFDataTransportStreamReader11 {
                    constructor(stream11, queuedChunks11, progressiveDone11 = false, contentDispositionFilename11 = null){
                        this._stream = stream11;
                        this._done = progressiveDone11 || false;
                        this._filename = (0, _display_utils11.isPdfFile)(contentDispositionFilename11) ? contentDispositionFilename11 : null;
                        this._queuedChunks = queuedChunks11 || [];
                        this._loaded = 0;
                        for (const chunk31 of this._queuedChunks)this._loaded += chunk31.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream11._fullRequestReader = this;
                        this.onProgress = null;
                    }
                    _enqueue(chunk31) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability11 = this._requests.shift();
                            requestCapability11.resolve({
                                value: chunk31,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk31);
                        this._loaded += chunk31.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    async read() {
                        if (this._queuedChunks.length > 0) {
                            const chunk31 = this._queuedChunks.shift();
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = (0, _util11.createPromiseCapability)();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                }
                class PDFDataTransportStreamRangeReader11 {
                    constructor(stream11, begin11, end11){
                        this._stream = stream11;
                        this._begin = begin11;
                        this._end = end11;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                    _enqueue(chunk31) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk31;
                        else {
                            const requestsCapability11 = this._requests.shift();
                            requestsCapability11.resolve({
                                value: chunk31,
                                done: false
                            });
                            for (const requestCapability11 of this._requests)requestCapability11.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk) {
                            const chunk31 = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = (0, _util11.createPromiseCapability)();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                }
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.AnnotationLayer = void 0;
                var _display_utils11 = __w_pdfjs_require__11(1);
                var _util11 = __w_pdfjs_require__11(2);
                var _annotation_storage11 = __w_pdfjs_require__11(9);
                var _scripting_utils11 = __w_pdfjs_require__11(18);
                class AnnotationElementFactory11 {
                    static create(parameters11) {
                        const subtype11 = parameters11.data.annotationType;
                        switch(subtype11){
                            case _util11.AnnotationType.LINK:
                                return new LinkAnnotationElement11(parameters11);
                            case _util11.AnnotationType.TEXT:
                                return new TextAnnotationElement11(parameters11);
                            case _util11.AnnotationType.WIDGET:
                                const fieldType11 = parameters11.data.fieldType;
                                switch(fieldType11){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement11(parameters11);
                                    case "Btn":
                                        if (parameters11.data.radioButton) return new RadioButtonWidgetAnnotationElement11(parameters11);
                                        else if (parameters11.data.checkBox) return new CheckboxWidgetAnnotationElement11(parameters11);
                                        return new PushButtonWidgetAnnotationElement11(parameters11);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement11(parameters11);
                                }
                                return new WidgetAnnotationElement11(parameters11);
                            case _util11.AnnotationType.POPUP:
                                return new PopupAnnotationElement11(parameters11);
                            case _util11.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement11(parameters11);
                            case _util11.AnnotationType.LINE:
                                return new LineAnnotationElement11(parameters11);
                            case _util11.AnnotationType.SQUARE:
                                return new SquareAnnotationElement11(parameters11);
                            case _util11.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement11(parameters11);
                            case _util11.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement11(parameters11);
                            case _util11.AnnotationType.CARET:
                                return new CaretAnnotationElement11(parameters11);
                            case _util11.AnnotationType.INK:
                                return new InkAnnotationElement11(parameters11);
                            case _util11.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement11(parameters11);
                            case _util11.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement11(parameters11);
                            case _util11.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement11(parameters11);
                            case _util11.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement11(parameters11);
                            case _util11.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement11(parameters11);
                            case _util11.AnnotationType.STAMP:
                                return new StampAnnotationElement11(parameters11);
                            case _util11.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement11(parameters11);
                            default:
                                return new AnnotationElement11(parameters11);
                        }
                    }
                }
                class AnnotationElement11 {
                    constructor(parameters11, { isRenderable: isRenderable11 = false , ignoreBorder: ignoreBorder11 = false , createQuadrilaterals: createQuadrilaterals11 = false  } = {}){
                        this.isRenderable = isRenderable11;
                        this.data = parameters11.data;
                        this.layer = parameters11.layer;
                        this.page = parameters11.page;
                        this.viewport = parameters11.viewport;
                        this.linkService = parameters11.linkService;
                        this.downloadManager = parameters11.downloadManager;
                        this.imageResourcesPath = parameters11.imageResourcesPath;
                        this.renderInteractiveForms = parameters11.renderInteractiveForms;
                        this.svgFactory = parameters11.svgFactory;
                        this.annotationStorage = parameters11.annotationStorage;
                        this.enableScripting = parameters11.enableScripting;
                        this.hasJSActions = parameters11.hasJSActions;
                        this._mouseState = parameters11.mouseState;
                        if (isRenderable11) this.container = this._createContainer(ignoreBorder11);
                        if (createQuadrilaterals11) this.quadrilaterals = this._createQuadrilaterals(ignoreBorder11);
                    }
                    _createContainer(ignoreBorder11 = false) {
                        const data11 = this.data, page11 = this.page, viewport11 = this.viewport;
                        const container11 = document.createElement("section");
                        let width21 = data11.rect[2] - data11.rect[0];
                        let height11 = data11.rect[3] - data11.rect[1];
                        container11.setAttribute("data-annotation-id", data11.id);
                        const rect31 = _util11.Util.normalizeRect([
                            data11.rect[0],
                            page11.view[3] - data11.rect[1] + page11.view[1],
                            data11.rect[2],
                            page11.view[3] - data11.rect[3] + page11.view[1]
                        ]);
                        container11.style.transform = `matrix(${viewport11.transform.join(",")})`;
                        container11.style.transformOrigin = `${-rect31[0]}px ${-rect31[1]}px`;
                        if (!ignoreBorder11 && data11.borderStyle.width > 0) {
                            container11.style.borderWidth = `${data11.borderStyle.width}px`;
                            if (data11.borderStyle.style !== _util11.AnnotationBorderStyleType.UNDERLINE) {
                                width21 -= 2 * data11.borderStyle.width;
                                height11 -= 2 * data11.borderStyle.width;
                            }
                            const horizontalRadius11 = data11.borderStyle.horizontalCornerRadius;
                            const verticalRadius11 = data11.borderStyle.verticalCornerRadius;
                            if (horizontalRadius11 > 0 || verticalRadius11 > 0) {
                                const radius11 = `${horizontalRadius11}px / ${verticalRadius11}px`;
                                container11.style.borderRadius = radius11;
                            }
                            switch(data11.borderStyle.style){
                                case _util11.AnnotationBorderStyleType.SOLID:
                                    container11.style.borderStyle = "solid";
                                    break;
                                case _util11.AnnotationBorderStyleType.DASHED:
                                    container11.style.borderStyle = "dashed";
                                    break;
                                case _util11.AnnotationBorderStyleType.BEVELED:
                                    (0, _util11.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util11.AnnotationBorderStyleType.INSET:
                                    (0, _util11.warn)("Unimplemented border style: inset");
                                    break;
                                case _util11.AnnotationBorderStyleType.UNDERLINE:
                                    container11.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            if (data11.color) container11.style.borderColor = _util11.Util.makeHexColor(data11.color[0] | 0, data11.color[1] | 0, data11.color[2] | 0);
                            else container11.style.borderWidth = 0;
                        }
                        container11.style.left = `${rect31[0]}px`;
                        container11.style.top = `${rect31[1]}px`;
                        container11.style.width = `${width21}px`;
                        container11.style.height = `${height11}px`;
                        return container11;
                    }
                    _createQuadrilaterals(ignoreBorder11 = false) {
                        if (!this.data.quadPoints) return null;
                        const quadrilaterals11 = [];
                        const savedRect11 = this.data.rect;
                        for (const quadPoint11 of this.data.quadPoints){
                            this.data.rect = [
                                quadPoint11[2].x,
                                quadPoint11[2].y,
                                quadPoint11[1].x,
                                quadPoint11[1].y
                            ];
                            quadrilaterals11.push(this._createContainer(ignoreBorder11));
                        }
                        this.data.rect = savedRect11;
                        return quadrilaterals11;
                    }
                    _createPopup(trigger11, data11) {
                        let container11 = this.container;
                        if (this.quadrilaterals) {
                            trigger11 = trigger11 || this.quadrilaterals;
                            container11 = this.quadrilaterals[0];
                        }
                        if (!trigger11) {
                            trigger11 = document.createElement("div");
                            trigger11.style.height = container11.style.height;
                            trigger11.style.width = container11.style.width;
                            container11.appendChild(trigger11);
                        }
                        const popupElement11 = new PopupElement11({
                            container: container11,
                            trigger: trigger11,
                            color: data11.color,
                            title: data11.title,
                            modificationDate: data11.modificationDate,
                            contents: data11.contents,
                            hideWrapper: true
                        });
                        const popup11 = popupElement11.render();
                        popup11.style.left = container11.style.width;
                        container11.appendChild(popup11);
                    }
                    _renderQuadrilaterals(className11) {
                        for (const quadrilateral11 of this.quadrilaterals)quadrilateral11.className = className11;
                        return this.quadrilaterals;
                    }
                    render() {
                        (0, _util11.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                }
                class LinkAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.url || parameters11.data.dest || parameters11.data.action || parameters11.data.isTooltipOnly || parameters11.data.actions && (parameters11.data.actions.Action || parameters11.data.actions["Mouse Up"] || parameters11.data.actions["Mouse Down"]));
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        const { data: data11 , linkService: linkService11  } = this;
                        const link11 = document.createElement("a");
                        if (data11.url) (0, _display_utils11.addLinkAttributes)(link11, {
                            url: data11.url,
                            target: data11.newWindow ? _display_utils11.LinkTarget.BLANK : linkService11.externalLinkTarget,
                            rel: linkService11.externalLinkRel,
                            enabled: linkService11.externalLinkEnabled
                        });
                        else if (data11.action) this._bindNamedAction(link11, data11.action);
                        else if (data11.dest) this._bindLink(link11, data11.dest);
                        else if (data11.actions && (data11.actions.Action || data11.actions["Mouse Up"] || data11.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) this._bindJSAction(link11, data11);
                        else this._bindLink(link11, "");
                        if (this.quadrilaterals) return this._renderQuadrilaterals("linkAnnotation").map((quadrilateral11, index11)=>{
                            const linkElement11 = index11 === 0 ? link11 : link11.cloneNode();
                            quadrilateral11.appendChild(linkElement11);
                            return quadrilateral11;
                        });
                        this.container.className = "linkAnnotation";
                        this.container.appendChild(link11);
                        return this.container;
                    }
                    _bindLink(link11, destination11) {
                        link11.href = this.linkService.getDestinationHash(destination11);
                        link11.onclick = ()=>{
                            if (destination11) this.linkService.goToDestination(destination11);
                            return false;
                        };
                        if (destination11 || destination11 === "") link11.className = "internalLink";
                    }
                    _bindNamedAction(link11, action11) {
                        link11.href = this.linkService.getAnchorUrl("");
                        link11.onclick = ()=>{
                            this.linkService.executeNamedAction(action11);
                            return false;
                        };
                        link11.className = "internalLink";
                    }
                    _bindJSAction(link11, data11) {
                        link11.href = this.linkService.getAnchorUrl("");
                        const map11 = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name11 of Object.keys(data11.actions)){
                            const jsName11 = map11.get(name11);
                            if (!jsName11) continue;
                            link11[jsName11] = ()=>{
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data11.id,
                                        name: name11
                                    }
                                });
                                return false;
                            };
                        }
                        link11.className = "internalLink";
                    }
                }
                class TextAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11
                        });
                    }
                    render() {
                        this.container.className = "textAnnotation";
                        const image11 = document.createElement("img");
                        image11.style.height = this.container.style.height;
                        image11.style.width = this.container.style.width;
                        image11.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image11.alt = "[{{type}} Annotation]";
                        image11.dataset.l10nId = "text_annotation_type";
                        image11.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.hasPopup) this._createPopup(image11, this.data);
                        this.container.appendChild(image11);
                        return this.container;
                    }
                }
                class WidgetAnnotationElement11 extends AnnotationElement11 {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    _getKeyModifier(event11) {
                        return navigator.platform.includes("Win") && event11.ctrlKey || navigator.platform.includes("Mac") && event11.metaKey;
                    }
                    _setEventListener(element11, baseName11, eventName11, valueGetter11) {
                        if (baseName11.includes("mouse")) element11.addEventListener(baseName11, (event11)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName11,
                                    value: valueGetter11(event11),
                                    shift: event11.shiftKey,
                                    modifier: this._getKeyModifier(event11)
                                }
                            });
                        });
                        else element11.addEventListener(baseName11, (event11)=>{
                            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName11,
                                    value: event11.target.checked
                                }
                            });
                        });
                    }
                    _setEventListeners(element11, names11, getter11) {
                        for (const [baseName11, eventName11] of names11)if (eventName11 === "Action" || this.data.actions?.[eventName11]) this._setEventListener(element11, baseName11, eventName11, getter11);
                    }
                    _dispatchEventFromSandbox(actions11, jsEvent11) {
                        const setColor11 = (jsName11, styleName11, event11)=>{
                            const color11 = event11.detail[jsName11];
                            event11.target.style[styleName11] = _scripting_utils11.ColorConverters[`${color11[0]}_HTML`](color11.slice(1));
                        };
                        const commonActions11 = {
                            display: (event11)=>{
                                const hidden11 = event11.detail.display % 2 === 1;
                                event11.target.style.visibility = hidden11 ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    hidden: hidden11,
                                    print: event11.detail.display === 0 || event11.detail.display === 3
                                });
                            },
                            print: (event11)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    print: event11.detail.print
                                });
                            },
                            hidden: (event11)=>{
                                event11.target.style.visibility = event11.detail.hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    hidden: event11.detail.hidden
                                });
                            },
                            focus: (event11)=>{
                                setTimeout(()=>event11.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event11)=>{
                                event11.target.title = event11.detail.userName;
                            },
                            readonly: (event11)=>{
                                if (event11.detail.readonly) event11.target.setAttribute("readonly", "");
                                else event11.target.removeAttribute("readonly");
                            },
                            required: (event11)=>{
                                if (event11.detail.required) event11.target.setAttribute("required", "");
                                else event11.target.removeAttribute("required");
                            },
                            bgColor: (event11)=>{
                                setColor11("bgColor", "backgroundColor", event11);
                            },
                            fillColor: (event11)=>{
                                setColor11("fillColor", "backgroundColor", event11);
                            },
                            fgColor: (event11)=>{
                                setColor11("fgColor", "color", event11);
                            },
                            textColor: (event11)=>{
                                setColor11("textColor", "color", event11);
                            },
                            borderColor: (event11)=>{
                                setColor11("borderColor", "borderColor", event11);
                            },
                            strokeColor: (event11)=>{
                                setColor11("strokeColor", "borderColor", event11);
                            }
                        };
                        for (const name11 of Object.keys(jsEvent11.detail)){
                            const action11 = actions11[name11] || commonActions11[name11];
                            if (action11) action11(jsEvent11);
                        }
                    }
                }
                class TextWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = parameters11.renderInteractiveForms || !parameters11.data.hasAppearance && !!parameters11.data.fieldValue;
                        super(parameters11, {
                            isRenderable: isRenderable11
                        });
                    }
                    setPropertyOnSiblings(base11, key11, value11, keyInStorage11) {
                        const storage11 = this.annotationStorage;
                        for (const element11 of document.getElementsByName(base11.name))if (element11 !== base11) {
                            element11[key11] = value11;
                            const data11 = Object.create(null);
                            data11[keyInStorage11] = value11;
                            storage11.setValue(element11.getAttribute("id"), data11);
                        }
                    }
                    render() {
                        const storage11 = this.annotationStorage;
                        const id11 = this.data.id;
                        this.container.className = "textWidgetAnnotation";
                        let element11 = null;
                        if (this.renderInteractiveForms) {
                            const storedData11 = storage11.getValue(id11, {
                                value: this.data.fieldValue,
                                valueAsString: this.data.fieldValue
                            });
                            const textContent11 = storedData11.valueAsString || storedData11.value || "";
                            const elementData11 = {
                                userValue: null,
                                formattedValue: null,
                                beforeInputSelectionRange: null,
                                beforeInputValue: null
                            };
                            if (this.data.multiLine) {
                                element11 = document.createElement("textarea");
                                element11.textContent = textContent11;
                            } else {
                                element11 = document.createElement("input");
                                element11.type = "text";
                                element11.setAttribute("value", textContent11);
                            }
                            elementData11.userValue = textContent11;
                            element11.setAttribute("id", id11);
                            element11.addEventListener("input", (event11)=>{
                                storage11.setValue(id11, {
                                    value: event11.target.value
                                });
                                this.setPropertyOnSiblings(element11, "value", event11.target.value, "value");
                            });
                            let blurListener11 = (event11)=>{
                                if (elementData11.formattedValue) event11.target.value = elementData11.formattedValue;
                                event11.target.scrollLeft = 0;
                                elementData11.beforeInputSelectionRange = null;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                element11.addEventListener("focus", (event11)=>{
                                    if (elementData11.userValue) event11.target.value = elementData11.userValue;
                                });
                                element11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                    const actions11 = {
                                        value (event11) {
                                            elementData11.userValue = event11.detail.value || "";
                                            storage11.setValue(id11, {
                                                value: elementData11.userValue.toString()
                                            });
                                            if (!elementData11.formattedValue) event11.target.value = elementData11.userValue;
                                        },
                                        valueAsString (event11) {
                                            elementData11.formattedValue = event11.detail.valueAsString || "";
                                            if (event11.target !== document.activeElement) event11.target.value = elementData11.formattedValue;
                                            storage11.setValue(id11, {
                                                formattedValue: elementData11.formattedValue
                                            });
                                        },
                                        selRange (event11) {
                                            const [selStart11, selEnd11] = event11.detail.selRange;
                                            if (selStart11 >= 0 && selEnd11 < event11.target.value.length) event11.target.setSelectionRange(selStart11, selEnd11);
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions11, jsEvent11);
                                });
                                element11.addEventListener("keydown", (event11)=>{
                                    elementData11.beforeInputValue = event11.target.value;
                                    let commitKey11 = -1;
                                    if (event11.key === "Escape") commitKey11 = 0;
                                    else if (event11.key === "Enter") commitKey11 = 2;
                                    else if (event11.key === "Tab") commitKey11 = 3;
                                    if (commitKey11 === -1) return;
                                    elementData11.userValue = event11.target.value;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id11,
                                            name: "Keystroke",
                                            value: event11.target.value,
                                            willCommit: true,
                                            commitKey: commitKey11,
                                            selStart: event11.target.selectionStart,
                                            selEnd: event11.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener11 = blurListener11;
                                blurListener11 = null;
                                element11.addEventListener("blur", (event11)=>{
                                    if (this._mouseState.isDown) {
                                        elementData11.userValue = event11.target.value;
                                        this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                            source: this,
                                            detail: {
                                                id: id11,
                                                name: "Keystroke",
                                                value: event11.target.value,
                                                willCommit: true,
                                                commitKey: 1,
                                                selStart: event11.target.selectionStart,
                                                selEnd: event11.target.selectionEnd
                                            }
                                        });
                                    }
                                    _blurListener11(event11);
                                });
                                element11.addEventListener("mousedown", (event11)=>{
                                    elementData11.beforeInputValue = event11.target.value;
                                    elementData11.beforeInputSelectionRange = null;
                                });
                                element11.addEventListener("keyup", (event11)=>{
                                    if (event11.target.selectionStart === event11.target.selectionEnd) elementData11.beforeInputSelectionRange = null;
                                });
                                element11.addEventListener("select", (event11)=>{
                                    elementData11.beforeInputSelectionRange = [
                                        event11.target.selectionStart,
                                        event11.target.selectionEnd
                                    ];
                                });
                                if (this.data.actions?.Keystroke) element11.addEventListener("input", (event11)=>{
                                    let selStart11 = -1;
                                    let selEnd11 = -1;
                                    if (elementData11.beforeInputSelectionRange) [selStart11, selEnd11] = elementData11.beforeInputSelectionRange;
                                    this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id11,
                                            name: "Keystroke",
                                            value: elementData11.beforeInputValue,
                                            change: event11.data,
                                            willCommit: false,
                                            selStart: selStart11,
                                            selEnd: selEnd11
                                        }
                                    });
                                });
                                this._setEventListeners(element11, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event11)=>event11.target.value);
                            }
                            if (blurListener11) element11.addEventListener("blur", blurListener11);
                            element11.disabled = this.data.readOnly;
                            element11.name = this.data.fieldName;
                            if (this.data.maxLen !== null) element11.maxLength = this.data.maxLen;
                            if (this.data.comb) {
                                const fieldWidth11 = this.data.rect[2] - this.data.rect[0];
                                const combWidth11 = fieldWidth11 / this.data.maxLen;
                                element11.classList.add("comb");
                                element11.style.letterSpacing = `calc(${combWidth11}px - 1ch)`;
                            }
                        } else {
                            element11 = document.createElement("div");
                            element11.textContent = this.data.fieldValue;
                            element11.style.verticalAlign = "middle";
                            element11.style.display = "table-cell";
                        }
                        this._setTextStyle(element11);
                        this.container.appendChild(element11);
                        return this.container;
                    }
                    _setTextStyle(element11) {
                        const TEXT_ALIGNMENT11 = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontSize: fontSize11 , fontColor: fontColor11  } = this.data.defaultAppearanceData;
                        const style11 = element11.style;
                        if (fontSize11) style11.fontSize = `${fontSize11}px`;
                        style11.color = _util11.Util.makeHexColor(fontColor11[0], fontColor11[1], fontColor11[2]);
                        if (this.data.textAlignment !== null) style11.textAlign = TEXT_ALIGNMENT11[this.data.textAlignment];
                    }
                }
                class CheckboxWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: parameters11.renderInteractiveForms
                        });
                    }
                    render() {
                        const storage11 = this.annotationStorage;
                        const data11 = this.data;
                        const id11 = data11.id;
                        let value11 = storage11.getValue(id11, {
                            value: data11.fieldValue && (data11.exportValue && data11.exportValue === data11.fieldValue || !data11.exportValue && data11.fieldValue !== "Off")
                        }).value;
                        if (typeof value11 === "string") {
                            value11 = value11 !== "Off";
                            storage11.setValue(id11, {
                                value: value11
                            });
                        }
                        this.container.className = "buttonWidgetAnnotation checkBox";
                        const element11 = document.createElement("input");
                        element11.disabled = data11.readOnly;
                        element11.type = "checkbox";
                        element11.name = this.data.fieldName;
                        if (value11) element11.setAttribute("checked", true);
                        element11.setAttribute("id", id11);
                        element11.addEventListener("change", function(event11) {
                            const name11 = event11.target.name;
                            for (const checkbox11 of document.getElementsByName(name11))if (checkbox11 !== event11.target) {
                                checkbox11.checked = false;
                                storage11.setValue(checkbox11.parentNode.getAttribute("data-annotation-id"), {
                                    value: false
                                });
                            }
                            storage11.setValue(id11, {
                                value: event11.target.checked
                            });
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                const actions11 = {
                                    value (event11) {
                                        event11.target.checked = event11.detail.value !== "Off";
                                        storage11.setValue(id11, {
                                            value: event11.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions11, jsEvent11);
                            });
                            this._setEventListeners(element11, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event11)=>event11.target.checked);
                        }
                        this.container.appendChild(element11);
                        return this.container;
                    }
                }
                class RadioButtonWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: parameters11.renderInteractiveForms
                        });
                    }
                    render() {
                        this.container.className = "buttonWidgetAnnotation radioButton";
                        const storage11 = this.annotationStorage;
                        const data11 = this.data;
                        const id11 = data11.id;
                        let value11 = storage11.getValue(id11, {
                            value: data11.fieldValue === data11.buttonValue
                        }).value;
                        if (typeof value11 === "string") {
                            value11 = value11 !== data11.buttonValue;
                            storage11.setValue(id11, {
                                value: value11
                            });
                        }
                        const element11 = document.createElement("input");
                        element11.disabled = data11.readOnly;
                        element11.type = "radio";
                        element11.name = data11.fieldName;
                        if (value11) element11.setAttribute("checked", true);
                        element11.setAttribute("id", id11);
                        element11.addEventListener("change", function(event11) {
                            const { target: target11  } = event11;
                            for (const radio11 of document.getElementsByName(target11.name))if (radio11 !== target11) storage11.setValue(radio11.getAttribute("id"), {
                                value: false
                            });
                            storage11.setValue(id11, {
                                value: target11.checked
                            });
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue11 = data11.buttonValue;
                            element11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                const actions11 = {
                                    value (event11) {
                                        const checked11 = pdfButtonValue11 === event11.detail.value;
                                        for (const radio11 of document.getElementsByName(event11.target.name)){
                                            const radioId11 = radio11.getAttribute("id");
                                            radio11.checked = radioId11 === id11 && checked11;
                                            storage11.setValue(radioId11, {
                                                value: radio11.checked
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions11, jsEvent11);
                            });
                            this._setEventListeners(element11, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event11)=>event11.target.checked);
                        }
                        this.container.appendChild(element11);
                        return this.container;
                    }
                }
                class PushButtonWidgetAnnotationElement11 extends LinkAnnotationElement11 {
                    render() {
                        const container11 = super.render();
                        container11.className = "buttonWidgetAnnotation pushButton";
                        if (this.data.alternativeText) container11.title = this.data.alternativeText;
                        return container11;
                    }
                }
                class ChoiceWidgetAnnotationElement11 extends WidgetAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: parameters11.renderInteractiveForms
                        });
                    }
                    render() {
                        this.container.className = "choiceWidgetAnnotation";
                        const storage11 = this.annotationStorage;
                        const id11 = this.data.id;
                        storage11.getValue(id11, {
                            value: this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : undefined
                        });
                        const selectElement11 = document.createElement("select");
                        selectElement11.disabled = this.data.readOnly;
                        selectElement11.name = this.data.fieldName;
                        selectElement11.setAttribute("id", id11);
                        if (!this.data.combo) {
                            selectElement11.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement11.multiple = true;
                        }
                        for (const option11 of this.data.options){
                            const optionElement11 = document.createElement("option");
                            optionElement11.textContent = option11.displayValue;
                            optionElement11.value = option11.exportValue;
                            if (this.data.fieldValue.includes(option11.exportValue)) optionElement11.setAttribute("selected", true);
                            selectElement11.appendChild(optionElement11);
                        }
                        const getValue11 = (event11, isExport11)=>{
                            const name11 = isExport11 ? "value" : "textContent";
                            const options11 = event11.target.options;
                            if (!event11.target.multiple) return options11.selectedIndex === -1 ? null : options11[options11.selectedIndex][name11];
                            return Array.prototype.filter.call(options11, (option11)=>option11.selected).map((option11)=>option11[name11]);
                        };
                        const getItems11 = (event11)=>{
                            const options11 = event11.target.options;
                            return Array.prototype.map.call(options11, (option11)=>{
                                return {
                                    displayValue: option11.textContent,
                                    exportValue: option11.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement11.addEventListener("updatefromsandbox", (jsEvent11)=>{
                                const actions11 = {
                                    value (event11) {
                                        const options11 = selectElement11.options;
                                        const value11 = event11.detail.value;
                                        const values11 = new Set(Array.isArray(value11) ? value11 : [
                                            value11
                                        ]);
                                        Array.prototype.forEach.call(options11, (option11)=>{
                                            option11.selected = values11.has(option11.value);
                                        });
                                        storage11.setValue(id11, {
                                            value: getValue11(event11, true)
                                        });
                                    },
                                    multipleSelection (event11) {
                                        selectElement11.multiple = true;
                                    },
                                    remove (event11) {
                                        const options11 = selectElement11.options;
                                        const index11 = event11.detail.remove;
                                        options11[index11].selected = false;
                                        selectElement11.remove(index11);
                                        if (options11.length > 0) {
                                            const i11 = Array.prototype.findIndex.call(options11, (option11)=>option11.selected);
                                            if (i11 === -1) options11[0].selected = true;
                                        }
                                        storage11.setValue(id11, {
                                            value: getValue11(event11, true),
                                            items: getItems11(event11)
                                        });
                                    },
                                    clear (event11) {
                                        while(selectElement11.length !== 0)selectElement11.remove(0);
                                        storage11.setValue(id11, {
                                            value: null,
                                            items: []
                                        });
                                    },
                                    insert (event11) {
                                        const { index: index11 , displayValue: displayValue11 , exportValue: exportValue11  } = event11.detail.insert;
                                        const optionElement11 = document.createElement("option");
                                        optionElement11.textContent = displayValue11;
                                        optionElement11.value = exportValue11;
                                        selectElement11.insertBefore(optionElement11, selectElement11.children[index11]);
                                        storage11.setValue(id11, {
                                            value: getValue11(event11, true),
                                            items: getItems11(event11)
                                        });
                                    },
                                    items (event11) {
                                        const { items: items11  } = event11.detail;
                                        while(selectElement11.length !== 0)selectElement11.remove(0);
                                        for (const item11 of items11){
                                            const { displayValue: displayValue11 , exportValue: exportValue11  } = item11;
                                            const optionElement11 = document.createElement("option");
                                            optionElement11.textContent = displayValue11;
                                            optionElement11.value = exportValue11;
                                            selectElement11.appendChild(optionElement11);
                                        }
                                        if (selectElement11.options.length > 0) selectElement11.options[0].selected = true;
                                        storage11.setValue(id11, {
                                            value: getValue11(event11, true),
                                            items: getItems11(event11)
                                        });
                                    },
                                    indices (event11) {
                                        const indices11 = new Set(event11.detail.indices);
                                        const options11 = event11.target.options;
                                        Array.prototype.forEach.call(options11, (option11, i11)=>{
                                            option11.selected = indices11.has(i11);
                                        });
                                        storage11.setValue(id11, {
                                            value: getValue11(event11, true)
                                        });
                                    },
                                    editable (event11) {
                                        event11.target.disabled = !event11.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions11, jsEvent11);
                            });
                            selectElement11.addEventListener("input", (event11)=>{
                                const exportValue11 = getValue11(event11, true);
                                const value11 = getValue11(event11, false);
                                storage11.setValue(id11, {
                                    value: exportValue11
                                });
                                this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id11,
                                        name: "Keystroke",
                                        value: value11,
                                        changeEx: exportValue11,
                                        willCommit: true,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement11, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ]
                            ], (event11)=>event11.target.checked);
                        } else selectElement11.addEventListener("input", function(event11) {
                            storage11.setValue(id11, {
                                value: getValue11(event11)
                            });
                        });
                        this.container.appendChild(selectElement11);
                        return this.container;
                    }
                }
                class PopupAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11
                        });
                    }
                    render() {
                        const IGNORE_TYPES11 = [
                            "Line",
                            "Square",
                            "Circle",
                            "PolyLine",
                            "Polygon",
                            "Ink"
                        ];
                        this.container.className = "popupAnnotation";
                        if (IGNORE_TYPES11.includes(this.data.parentType)) return this.container;
                        const selector11 = `[data-annotation-id="${this.data.parentId}"]`;
                        const parentElements11 = this.layer.querySelectorAll(selector11);
                        if (parentElements11.length === 0) return this.container;
                        const popup11 = new PopupElement11({
                            container: this.container,
                            trigger: Array.from(parentElements11),
                            color: this.data.color,
                            title: this.data.title,
                            modificationDate: this.data.modificationDate,
                            contents: this.data.contents
                        });
                        const page11 = this.page;
                        const rect31 = _util11.Util.normalizeRect([
                            this.data.parentRect[0],
                            page11.view[3] - this.data.parentRect[1] + page11.view[1],
                            this.data.parentRect[2],
                            page11.view[3] - this.data.parentRect[3] + page11.view[1]
                        ]);
                        const popupLeft11 = rect31[0] + this.data.parentRect[2] - this.data.parentRect[0];
                        const popupTop11 = rect31[1];
                        this.container.style.transformOrigin = `${-popupLeft11}px ${-popupTop11}px`;
                        this.container.style.left = `${popupLeft11}px`;
                        this.container.style.top = `${popupTop11}px`;
                        this.container.appendChild(popup11.render());
                        return this.container;
                    }
                }
                class PopupElement11 {
                    constructor(parameters11){
                        this.container = parameters11.container;
                        this.trigger = parameters11.trigger;
                        this.color = parameters11.color;
                        this.title = parameters11.title;
                        this.modificationDate = parameters11.modificationDate;
                        this.contents = parameters11.contents;
                        this.hideWrapper = parameters11.hideWrapper || false;
                        this.pinned = false;
                    }
                    render() {
                        const BACKGROUND_ENLIGHT11 = 0.7;
                        const wrapper11 = document.createElement("div");
                        wrapper11.className = "popupWrapper";
                        this.hideElement = this.hideWrapper ? wrapper11 : this.container;
                        this.hideElement.hidden = true;
                        const popup11 = document.createElement("div");
                        popup11.className = "popup";
                        const color11 = this.color;
                        if (color11) {
                            const r11 = BACKGROUND_ENLIGHT11 * (255 - color11[0]) + color11[0];
                            const g11 = BACKGROUND_ENLIGHT11 * (255 - color11[1]) + color11[1];
                            const b41 = BACKGROUND_ENLIGHT11 * (255 - color11[2]) + color11[2];
                            popup11.style.backgroundColor = _util11.Util.makeHexColor(r11 | 0, g11 | 0, b41 | 0);
                        }
                        const title11 = document.createElement("h1");
                        title11.textContent = this.title;
                        popup11.appendChild(title11);
                        const dateObject11 = _display_utils11.PDFDateString.toDateObject(this.modificationDate);
                        if (dateObject11) {
                            const modificationDate11 = document.createElement("span");
                            modificationDate11.textContent = "{{date}}, {{time}}";
                            modificationDate11.dataset.l10nId = "annotation_date_string";
                            modificationDate11.dataset.l10nArgs = JSON.stringify({
                                date: dateObject11.toLocaleDateString(),
                                time: dateObject11.toLocaleTimeString()
                            });
                            popup11.appendChild(modificationDate11);
                        }
                        const contents11 = this._formatContents(this.contents);
                        popup11.appendChild(contents11);
                        if (!Array.isArray(this.trigger)) this.trigger = [
                            this.trigger
                        ];
                        for (const element11 of this.trigger){
                            element11.addEventListener("click", this._toggle.bind(this));
                            element11.addEventListener("mouseover", this._show.bind(this, false));
                            element11.addEventListener("mouseout", this._hide.bind(this, false));
                        }
                        popup11.addEventListener("click", this._hide.bind(this, true));
                        wrapper11.appendChild(popup11);
                        return wrapper11;
                    }
                    _formatContents(contents11) {
                        const p51 = document.createElement("p");
                        const lines11 = contents11.split(/(?:\r\n?|\n)/);
                        for(let i11 = 0, ii11 = lines11.length; i11 < ii11; ++i11){
                            const line11 = lines11[i11];
                            p51.appendChild(document.createTextNode(line11));
                            if (i11 < ii11 - 1) p51.appendChild(document.createElement("br"));
                        }
                        return p51;
                    }
                    _toggle() {
                        if (this.pinned) this._hide(true);
                        else this._show(true);
                    }
                    _show(pin11 = false) {
                        if (pin11) this.pinned = true;
                        if (this.hideElement.hidden) {
                            this.hideElement.hidden = false;
                            this.container.style.zIndex += 1;
                        }
                    }
                    _hide(unpin11 = true) {
                        if (unpin11) this.pinned = false;
                        if (!this.hideElement.hidden && !this.pinned) {
                            this.hideElement.hidden = true;
                            this.container.style.zIndex -= 1;
                        }
                    }
                }
                class FreeTextAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.className = "freeTextAnnotation";
                        if (!this.data.hasPopup) this._createPopup(null, this.data);
                        return this.container;
                    }
                }
                class LineAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.className = "lineAnnotation";
                        const data11 = this.data;
                        const width21 = data11.rect[2] - data11.rect[0];
                        const height11 = data11.rect[3] - data11.rect[1];
                        const svg11 = this.svgFactory.create(width21, height11);
                        const line11 = this.svgFactory.createElement("svg:line");
                        line11.setAttribute("x1", data11.rect[2] - data11.lineCoordinates[0]);
                        line11.setAttribute("y1", data11.rect[3] - data11.lineCoordinates[1]);
                        line11.setAttribute("x2", data11.rect[2] - data11.lineCoordinates[2]);
                        line11.setAttribute("y2", data11.rect[3] - data11.lineCoordinates[3]);
                        line11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                        line11.setAttribute("stroke", "transparent");
                        svg11.appendChild(line11);
                        this.container.append(svg11);
                        this._createPopup(line11, data11);
                        return this.container;
                    }
                }
                class SquareAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.className = "squareAnnotation";
                        const data11 = this.data;
                        const width21 = data11.rect[2] - data11.rect[0];
                        const height11 = data11.rect[3] - data11.rect[1];
                        const svg11 = this.svgFactory.create(width21, height11);
                        const borderWidth11 = data11.borderStyle.width;
                        const square11 = this.svgFactory.createElement("svg:rect");
                        square11.setAttribute("x", borderWidth11 / 2);
                        square11.setAttribute("y", borderWidth11 / 2);
                        square11.setAttribute("width", width21 - borderWidth11);
                        square11.setAttribute("height", height11 - borderWidth11);
                        square11.setAttribute("stroke-width", borderWidth11 || 1);
                        square11.setAttribute("stroke", "transparent");
                        square11.setAttribute("fill", "none");
                        svg11.appendChild(square11);
                        this.container.append(svg11);
                        this._createPopup(square11, data11);
                        return this.container;
                    }
                }
                class CircleAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.className = "circleAnnotation";
                        const data11 = this.data;
                        const width21 = data11.rect[2] - data11.rect[0];
                        const height11 = data11.rect[3] - data11.rect[1];
                        const svg11 = this.svgFactory.create(width21, height11);
                        const borderWidth11 = data11.borderStyle.width;
                        const circle11 = this.svgFactory.createElement("svg:ellipse");
                        circle11.setAttribute("cx", width21 / 2);
                        circle11.setAttribute("cy", height11 / 2);
                        circle11.setAttribute("rx", width21 / 2 - borderWidth11 / 2);
                        circle11.setAttribute("ry", height11 / 2 - borderWidth11 / 2);
                        circle11.setAttribute("stroke-width", borderWidth11 || 1);
                        circle11.setAttribute("stroke", "transparent");
                        circle11.setAttribute("fill", "none");
                        svg11.appendChild(circle11);
                        this.container.append(svg11);
                        this._createPopup(circle11, data11);
                        return this.container;
                    }
                }
                class PolylineAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.className = this.containerClassName;
                        const data11 = this.data;
                        const width21 = data11.rect[2] - data11.rect[0];
                        const height11 = data11.rect[3] - data11.rect[1];
                        const svg11 = this.svgFactory.create(width21, height11);
                        let points11 = [];
                        for (const coordinate11 of data11.vertices){
                            const x41 = coordinate11.x - data11.rect[0];
                            const y41 = data11.rect[3] - coordinate11.y;
                            points11.push(x41 + "," + y41);
                        }
                        points11 = points11.join(" ");
                        const polyline11 = this.svgFactory.createElement(this.svgElementName);
                        polyline11.setAttribute("points", points11);
                        polyline11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                        polyline11.setAttribute("stroke", "transparent");
                        polyline11.setAttribute("fill", "none");
                        svg11.appendChild(polyline11);
                        this.container.append(svg11);
                        this._createPopup(polyline11, data11);
                        return this.container;
                    }
                }
                class PolygonAnnotationElement11 extends PolylineAnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.className = "caretAnnotation";
                        if (!this.data.hasPopup) this._createPopup(null, this.data);
                        return this.container;
                    }
                }
                class InkAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                    render() {
                        this.container.className = this.containerClassName;
                        const data11 = this.data;
                        const width21 = data11.rect[2] - data11.rect[0];
                        const height11 = data11.rect[3] - data11.rect[1];
                        const svg11 = this.svgFactory.create(width21, height11);
                        for (const inkList11 of data11.inkLists){
                            let points11 = [];
                            for (const coordinate11 of inkList11){
                                const x41 = coordinate11.x - data11.rect[0];
                                const y41 = data11.rect[3] - coordinate11.y;
                                points11.push(`${x41},${y41}`);
                            }
                            points11 = points11.join(" ");
                            const polyline11 = this.svgFactory.createElement(this.svgElementName);
                            polyline11.setAttribute("points", points11);
                            polyline11.setAttribute("stroke-width", data11.borderStyle.width || 1);
                            polyline11.setAttribute("stroke", "transparent");
                            polyline11.setAttribute("fill", "none");
                            this._createPopup(polyline11, data11);
                            svg11.appendChild(polyline11);
                        }
                        this.container.append(svg11);
                        return this.container;
                    }
                }
                class HighlightAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.hasPopup) this._createPopup(null, this.data);
                        if (this.quadrilaterals) return this._renderQuadrilaterals("highlightAnnotation");
                        this.container.className = "highlightAnnotation";
                        return this.container;
                    }
                }
                class UnderlineAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.hasPopup) this._createPopup(null, this.data);
                        if (this.quadrilaterals) return this._renderQuadrilaterals("underlineAnnotation");
                        this.container.className = "underlineAnnotation";
                        return this.container;
                    }
                }
                class SquigglyAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.hasPopup) this._createPopup(null, this.data);
                        if (this.quadrilaterals) return this._renderQuadrilaterals("squigglyAnnotation");
                        this.container.className = "squigglyAnnotation";
                        return this.container;
                    }
                }
                class StrikeOutAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                    render() {
                        if (!this.data.hasPopup) this._createPopup(null, this.data);
                        if (this.quadrilaterals) return this._renderQuadrilaterals("strikeoutAnnotation");
                        this.container.className = "strikeoutAnnotation";
                        return this.container;
                    }
                }
                class StampAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        const isRenderable11 = !!(parameters11.data.hasPopup || parameters11.data.title || parameters11.data.contents);
                        super(parameters11, {
                            isRenderable: isRenderable11,
                            ignoreBorder: true
                        });
                    }
                    render() {
                        this.container.className = "stampAnnotation";
                        if (!this.data.hasPopup) this._createPopup(null, this.data);
                        return this.container;
                    }
                }
                class FileAttachmentAnnotationElement11 extends AnnotationElement11 {
                    constructor(parameters11){
                        super(parameters11, {
                            isRenderable: true
                        });
                        const { filename: filename11 , content: content11  } = this.data.file;
                        this.filename = (0, _display_utils11.getFilenameFromUrl)(filename11);
                        this.content = content11;
                        this.linkService.eventBus?.dispatch("fileattachmentannotation", {
                            source: this,
                            id: (0, _util11.stringToPDFString)(filename11),
                            filename: filename11,
                            content: content11
                        });
                    }
                    render() {
                        this.container.className = "fileAttachmentAnnotation";
                        const trigger11 = document.createElement("div");
                        trigger11.style.height = this.container.style.height;
                        trigger11.style.width = this.container.style.width;
                        trigger11.addEventListener("dblclick", this._download.bind(this));
                        if (!this.data.hasPopup && (this.data.title || this.data.contents)) this._createPopup(trigger11, this.data);
                        this.container.appendChild(trigger11);
                        return this.container;
                    }
                    _download() {
                        this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
                    }
                }
                class AnnotationLayer11 {
                    static render(parameters11) {
                        const sortedAnnotations11 = [], popupAnnotations11 = [];
                        for (const data11 of parameters11.annotations){
                            if (!data11) continue;
                            if (data11.annotationType === _util11.AnnotationType.POPUP) {
                                popupAnnotations11.push(data11);
                                continue;
                            }
                            sortedAnnotations11.push(data11);
                        }
                        if (popupAnnotations11.length) sortedAnnotations11.push(...popupAnnotations11);
                        for (const data11 of sortedAnnotations11){
                            const element11 = AnnotationElementFactory11.create({
                                data: data11,
                                layer: parameters11.div,
                                page: parameters11.page,
                                viewport: parameters11.viewport,
                                linkService: parameters11.linkService,
                                downloadManager: parameters11.downloadManager,
                                imageResourcesPath: parameters11.imageResourcesPath || "",
                                renderInteractiveForms: parameters11.renderInteractiveForms !== false,
                                svgFactory: new _display_utils11.DOMSVGFactory(),
                                annotationStorage: parameters11.annotationStorage || new _annotation_storage11.AnnotationStorage(),
                                enableScripting: parameters11.enableScripting,
                                hasJSActions: parameters11.hasJSActions,
                                mouseState: parameters11.mouseState || {
                                    isDown: false
                                }
                            });
                            if (element11.isRenderable) {
                                const rendered11 = element11.render();
                                if (data11.hidden) rendered11.style.visibility = "hidden";
                                if (Array.isArray(rendered11)) for (const renderedElement11 of rendered11)parameters11.div.appendChild(renderedElement11);
                                else if (element11 instanceof PopupAnnotationElement11) parameters11.div.prepend(rendered11);
                                else parameters11.div.appendChild(rendered11);
                            }
                        }
                    }
                    static update(parameters11) {
                        const transform11 = `matrix(${parameters11.viewport.transform.join(",")})`;
                        for (const data11 of parameters11.annotations){
                            const elements11 = parameters11.div.querySelectorAll(`[data-annotation-id="${data11.id}"]`);
                            if (elements11) for (const element11 of elements11)element11.style.transform = transform11;
                        }
                        parameters11.div.hidden = false;
                    }
                }
                exports11.AnnotationLayer = AnnotationLayer11;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.ColorConverters = void 0;
                function makeColorComp11(n11) {
                    return Math.floor(Math.max(0, Math.min(1, n11)) * 255).toString(16).padStart(2, "0");
                }
                class ColorConverters11 {
                    static CMYK_G([c41, y41, m31, k11]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c41 + 0.59 * m31 + 0.11 * y41 + k11)
                        ];
                    }
                    static G_CMYK([g11]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g11
                        ];
                    }
                    static G_RGB([g11]) {
                        return [
                            "RGB",
                            g11,
                            g11,
                            g11
                        ];
                    }
                    static G_HTML([g11]) {
                        const G11 = makeColorComp11(g11);
                        return `#${G11}${G11}${G11}`;
                    }
                    static RGB_G([r11, g11, b41]) {
                        return [
                            "G",
                            0.3 * r11 + 0.59 * g11 + 0.11 * b41
                        ];
                    }
                    static RGB_HTML([r11, g11, b41]) {
                        const R11 = makeColorComp11(r11);
                        const G11 = makeColorComp11(g11);
                        const B11 = makeColorComp11(b41);
                        return `#${R11}${G11}${B11}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static CMYK_RGB([c41, y41, m31, k11]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c41 + k11),
                            1 - Math.min(1, m31 + k11),
                            1 - Math.min(1, y41 + k11)
                        ];
                    }
                    static CMYK_HTML(components11) {
                        return this.RGB_HTML(this.CMYK_RGB(components11));
                    }
                    static RGB_CMYK([r11, g11, b41]) {
                        const c41 = 1 - r11;
                        const m31 = 1 - g11;
                        const y41 = 1 - b41;
                        const k11 = Math.min(c41, m31, y41);
                        return [
                            "CMYK",
                            c41,
                            m31,
                            y41,
                            k11
                        ];
                    }
                }
                exports11.ColorConverters = ColorConverters11;
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.renderTextLayer = renderTextLayer11;
                var _util11 = __w_pdfjs_require__11(2);
                const MAX_TEXT_DIVS_TO_RENDER11 = 100000;
                const DEFAULT_FONT_SIZE11 = 30;
                const DEFAULT_FONT_ASCENT11 = 0.8;
                const ascentCache11 = new Map();
                const AllWhitespaceRegexp11 = /^\s+$/g;
                function getAscent11(fontFamily11, ctx11) {
                    const cachedAscent11 = ascentCache11.get(fontFamily11);
                    if (cachedAscent11) return cachedAscent11;
                    ctx11.save();
                    ctx11.font = `${DEFAULT_FONT_SIZE11}px ${fontFamily11}`;
                    const metrics11 = ctx11.measureText("");
                    let ascent11 = metrics11.fontBoundingBoxAscent;
                    let descent11 = Math.abs(metrics11.fontBoundingBoxDescent);
                    if (ascent11) {
                        ctx11.restore();
                        const ratio11 = ascent11 / (ascent11 + descent11);
                        ascentCache11.set(fontFamily11, ratio11);
                        return ratio11;
                    }
                    ctx11.strokeStyle = "red";
                    ctx11.clearRect(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11);
                    ctx11.strokeText("g", 0, 0);
                    let pixels11 = ctx11.getImageData(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11).data;
                    descent11 = 0;
                    for(let i11 = pixels11.length - 1 - 3; i11 >= 0; i11 -= 4)if (pixels11[i11] > 0) {
                        descent11 = Math.ceil(i11 / 4 / DEFAULT_FONT_SIZE11);
                        break;
                    }
                    ctx11.clearRect(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11);
                    ctx11.strokeText("A", 0, DEFAULT_FONT_SIZE11);
                    pixels11 = ctx11.getImageData(0, 0, DEFAULT_FONT_SIZE11, DEFAULT_FONT_SIZE11).data;
                    ascent11 = 0;
                    for(let i11 = 0, ii11 = pixels11.length; i11 < ii11; i11 += 4)if (pixels11[i11] > 0) {
                        ascent11 = DEFAULT_FONT_SIZE11 - Math.floor(i11 / 4 / DEFAULT_FONT_SIZE11);
                        break;
                    }
                    ctx11.restore();
                    if (ascent11) {
                        const ratio11 = ascent11 / (ascent11 + descent11);
                        ascentCache11.set(fontFamily11, ratio11);
                        return ratio11;
                    }
                    ascentCache11.set(fontFamily11, DEFAULT_FONT_ASCENT11);
                    return DEFAULT_FONT_ASCENT11;
                }
                function appendText11(task11, geom11, styles11, ctx11) {
                    const textDiv11 = document.createElement("span");
                    const textDivProperties11 = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom11.str !== "",
                        hasEOL: geom11.hasEOL,
                        originalTransform: null,
                        paddingBottom: 0,
                        paddingLeft: 0,
                        paddingRight: 0,
                        paddingTop: 0,
                        scale: 1
                    };
                    task11._textDivs.push(textDiv11);
                    const tx21 = _util11.Util.transform(task11._viewport.transform, geom11.transform);
                    let angle11 = Math.atan2(tx21[1], tx21[0]);
                    const style11 = styles11[geom11.fontName];
                    if (style11.vertical) angle11 += Math.PI / 2;
                    const fontHeight11 = Math.hypot(tx21[2], tx21[3]);
                    const fontAscent11 = fontHeight11 * getAscent11(style11.fontFamily, ctx11);
                    let left11, top11;
                    if (angle11 === 0) {
                        left11 = tx21[4];
                        top11 = tx21[5] - fontAscent11;
                    } else {
                        left11 = tx21[4] + fontAscent11 * Math.sin(angle11);
                        top11 = tx21[5] - fontAscent11 * Math.cos(angle11);
                    }
                    textDiv11.style.left = `${left11}px`;
                    textDiv11.style.top = `${top11}px`;
                    textDiv11.style.fontSize = `${fontHeight11}px`;
                    textDiv11.style.fontFamily = style11.fontFamily;
                    textDiv11.setAttribute("role", "presentation");
                    textDiv11.textContent = geom11.str;
                    textDiv11.dir = geom11.dir;
                    if (task11._fontInspectorEnabled) textDiv11.dataset.fontName = geom11.fontName;
                    if (angle11 !== 0) textDivProperties11.angle = angle11 * (180 / Math.PI);
                    let shouldScaleText11 = false;
                    if (geom11.str.length > 1 || task11._enhanceTextSelection && AllWhitespaceRegexp11.test(geom11.str)) shouldScaleText11 = true;
                    else if (geom11.transform[0] !== geom11.transform[3]) {
                        const absScaleX11 = Math.abs(geom11.transform[0]), absScaleY11 = Math.abs(geom11.transform[3]);
                        if (absScaleX11 !== absScaleY11 && Math.max(absScaleX11, absScaleY11) / Math.min(absScaleX11, absScaleY11) > 1.5) shouldScaleText11 = true;
                    }
                    if (shouldScaleText11) {
                        if (style11.vertical) textDivProperties11.canvasWidth = geom11.height * task11._viewport.scale;
                        else textDivProperties11.canvasWidth = geom11.width * task11._viewport.scale;
                    }
                    task11._textDivProperties.set(textDiv11, textDivProperties11);
                    if (task11._textContentStream) task11._layoutText(textDiv11);
                    if (task11._enhanceTextSelection && textDivProperties11.hasText) {
                        let angleCos11 = 1, angleSin11 = 0;
                        if (angle11 !== 0) {
                            angleCos11 = Math.cos(angle11);
                            angleSin11 = Math.sin(angle11);
                        }
                        const divWidth11 = (style11.vertical ? geom11.height : geom11.width) * task11._viewport.scale;
                        const divHeight11 = fontHeight11;
                        let m31, b41;
                        if (angle11 !== 0) {
                            m31 = [
                                angleCos11,
                                angleSin11,
                                -angleSin11,
                                angleCos11,
                                left11,
                                top11
                            ];
                            b41 = _util11.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                divWidth11,
                                divHeight11
                            ], m31);
                        } else b41 = [
                            left11,
                            top11,
                            left11 + divWidth11,
                            top11 + divHeight11
                        ];
                        task11._bounds.push({
                            left: b41[0],
                            top: b41[1],
                            right: b41[2],
                            bottom: b41[3],
                            div: textDiv11,
                            size: [
                                divWidth11,
                                divHeight11
                            ],
                            m: m31
                        });
                    }
                }
                function render11(task11) {
                    if (task11._canceled) return;
                    const textDivs11 = task11._textDivs;
                    const capability11 = task11._capability;
                    const textDivsLength11 = textDivs11.length;
                    if (textDivsLength11 > MAX_TEXT_DIVS_TO_RENDER11) {
                        task11._renderingDone = true;
                        capability11.resolve();
                        return;
                    }
                    if (!task11._textContentStream) for(let i11 = 0; i11 < textDivsLength11; i11++)task11._layoutText(textDivs11[i11]);
                    task11._renderingDone = true;
                    capability11.resolve();
                }
                function findPositiveMin11(ts11, offset11, count11) {
                    let result11 = 0;
                    for(let i11 = 0; i11 < count11; i11++){
                        const t11 = ts11[offset11++];
                        if (t11 > 0) result11 = result11 ? Math.min(t11, result11) : t11;
                    }
                    return result11;
                }
                function expand11(task11) {
                    const bounds11 = task11._bounds;
                    const viewport11 = task11._viewport;
                    const expanded11 = expandBounds11(viewport11.width, viewport11.height, bounds11);
                    for(let i11 = 0; i11 < expanded11.length; i11++){
                        const div11 = bounds11[i11].div;
                        const divProperties11 = task11._textDivProperties.get(div11);
                        if (divProperties11.angle === 0) {
                            divProperties11.paddingLeft = bounds11[i11].left - expanded11[i11].left;
                            divProperties11.paddingTop = bounds11[i11].top - expanded11[i11].top;
                            divProperties11.paddingRight = expanded11[i11].right - bounds11[i11].right;
                            divProperties11.paddingBottom = expanded11[i11].bottom - bounds11[i11].bottom;
                            task11._textDivProperties.set(div11, divProperties11);
                            continue;
                        }
                        const e11 = expanded11[i11], b41 = bounds11[i11];
                        const m31 = b41.m, c41 = m31[0], s11 = m31[1];
                        const points11 = [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                b41.size[1]
                            ],
                            [
                                b41.size[0],
                                0
                            ],
                            b41.size
                        ];
                        const ts11 = new Float64Array(64);
                        for(let j11 = 0, jj11 = points11.length; j11 < jj11; j11++){
                            const t11 = _util11.Util.applyTransform(points11[j11], m31);
                            ts11[j11 + 0] = c41 && (e11.left - t11[0]) / c41;
                            ts11[j11 + 4] = s11 && (e11.top - t11[1]) / s11;
                            ts11[j11 + 8] = c41 && (e11.right - t11[0]) / c41;
                            ts11[j11 + 12] = s11 && (e11.bottom - t11[1]) / s11;
                            ts11[j11 + 16] = s11 && (e11.left - t11[0]) / -s11;
                            ts11[j11 + 20] = c41 && (e11.top - t11[1]) / c41;
                            ts11[j11 + 24] = s11 && (e11.right - t11[0]) / -s11;
                            ts11[j11 + 28] = c41 && (e11.bottom - t11[1]) / c41;
                            ts11[j11 + 32] = c41 && (e11.left - t11[0]) / -c41;
                            ts11[j11 + 36] = s11 && (e11.top - t11[1]) / -s11;
                            ts11[j11 + 40] = c41 && (e11.right - t11[0]) / -c41;
                            ts11[j11 + 44] = s11 && (e11.bottom - t11[1]) / -s11;
                            ts11[j11 + 48] = s11 && (e11.left - t11[0]) / s11;
                            ts11[j11 + 52] = c41 && (e11.top - t11[1]) / -c41;
                            ts11[j11 + 56] = s11 && (e11.right - t11[0]) / s11;
                            ts11[j11 + 60] = c41 && (e11.bottom - t11[1]) / -c41;
                        }
                        const boxScale11 = 1 + Math.min(Math.abs(c41), Math.abs(s11));
                        divProperties11.paddingLeft = findPositiveMin11(ts11, 32, 16) / boxScale11;
                        divProperties11.paddingTop = findPositiveMin11(ts11, 48, 16) / boxScale11;
                        divProperties11.paddingRight = findPositiveMin11(ts11, 0, 16) / boxScale11;
                        divProperties11.paddingBottom = findPositiveMin11(ts11, 16, 16) / boxScale11;
                        task11._textDivProperties.set(div11, divProperties11);
                    }
                }
                function expandBounds11(width21, height11, boxes11) {
                    const bounds11 = boxes11.map(function(box11, i11) {
                        return {
                            x1: box11.left,
                            y1: box11.top,
                            x2: box11.right,
                            y2: box11.bottom,
                            index: i11,
                            x1New: undefined,
                            x2New: undefined
                        };
                    });
                    expandBoundsLTR11(width21, bounds11);
                    const expanded11 = new Array(boxes11.length);
                    for (const b41 of bounds11){
                        const i11 = b41.index;
                        expanded11[i11] = {
                            left: b41.x1New,
                            top: 0,
                            right: b41.x2New,
                            bottom: 0
                        };
                    }
                    boxes11.map(function(box11, i11) {
                        const e11 = expanded11[i11], b41 = bounds11[i11];
                        b41.x1 = box11.top;
                        b41.y1 = width21 - e11.right;
                        b41.x2 = box11.bottom;
                        b41.y2 = width21 - e11.left;
                        b41.index = i11;
                        b41.x1New = undefined;
                        b41.x2New = undefined;
                    });
                    expandBoundsLTR11(height11, bounds11);
                    for (const b41 of bounds11){
                        const i11 = b41.index;
                        expanded11[i11].top = b41.x1New;
                        expanded11[i11].bottom = b41.x2New;
                    }
                    return expanded11;
                }
                function expandBoundsLTR11(width21, bounds11) {
                    bounds11.sort(function(a11, b41) {
                        return a11.x1 - b41.x1 || a11.index - b41.index;
                    });
                    const fakeBoundary11 = {
                        x1: -Infinity,
                        y1: -Infinity,
                        x2: 0,
                        y2: Infinity,
                        index: -1,
                        x1New: 0,
                        x2New: 0
                    };
                    const horizon11 = [
                        {
                            start: -Infinity,
                            end: Infinity,
                            boundary: fakeBoundary11
                        }
                    ];
                    for (const boundary11 of bounds11){
                        let i11 = 0;
                        while(i11 < horizon11.length && horizon11[i11].end <= boundary11.y1)i11++;
                        let j11 = horizon11.length - 1;
                        while(j11 >= 0 && horizon11[j11].start >= boundary11.y2)j11--;
                        let horizonPart11, affectedBoundary11;
                        let q11, k11, maxXNew11 = -Infinity;
                        for(q11 = i11; q11 <= j11; q11++){
                            horizonPart11 = horizon11[q11];
                            affectedBoundary11 = horizonPart11.boundary;
                            let xNew11;
                            if (affectedBoundary11.x2 > boundary11.x1) xNew11 = affectedBoundary11.index > boundary11.index ? affectedBoundary11.x1New : boundary11.x1;
                            else if (affectedBoundary11.x2New === undefined) xNew11 = (affectedBoundary11.x2 + boundary11.x1) / 2;
                            else xNew11 = affectedBoundary11.x2New;
                            if (xNew11 > maxXNew11) maxXNew11 = xNew11;
                        }
                        boundary11.x1New = maxXNew11;
                        for(q11 = i11; q11 <= j11; q11++){
                            horizonPart11 = horizon11[q11];
                            affectedBoundary11 = horizonPart11.boundary;
                            if (affectedBoundary11.x2New === undefined) {
                                if (affectedBoundary11.x2 > boundary11.x1) {
                                    if (affectedBoundary11.index > boundary11.index) affectedBoundary11.x2New = affectedBoundary11.x2;
                                } else affectedBoundary11.x2New = maxXNew11;
                            } else if (affectedBoundary11.x2New > maxXNew11) affectedBoundary11.x2New = Math.max(maxXNew11, affectedBoundary11.x2);
                        }
                        const changedHorizon11 = [];
                        let lastBoundary11 = null;
                        for(q11 = i11; q11 <= j11; q11++){
                            horizonPart11 = horizon11[q11];
                            affectedBoundary11 = horizonPart11.boundary;
                            const useBoundary11 = affectedBoundary11.x2 > boundary11.x2 ? affectedBoundary11 : boundary11;
                            if (lastBoundary11 === useBoundary11) changedHorizon11[changedHorizon11.length - 1].end = horizonPart11.end;
                            else {
                                changedHorizon11.push({
                                    start: horizonPart11.start,
                                    end: horizonPart11.end,
                                    boundary: useBoundary11
                                });
                                lastBoundary11 = useBoundary11;
                            }
                        }
                        if (horizon11[i11].start < boundary11.y1) {
                            changedHorizon11[0].start = boundary11.y1;
                            changedHorizon11.unshift({
                                start: horizon11[i11].start,
                                end: boundary11.y1,
                                boundary: horizon11[i11].boundary
                            });
                        }
                        if (boundary11.y2 < horizon11[j11].end) {
                            changedHorizon11[changedHorizon11.length - 1].end = boundary11.y2;
                            changedHorizon11.push({
                                start: boundary11.y2,
                                end: horizon11[j11].end,
                                boundary: horizon11[j11].boundary
                            });
                        }
                        for(q11 = i11; q11 <= j11; q11++){
                            horizonPart11 = horizon11[q11];
                            affectedBoundary11 = horizonPart11.boundary;
                            if (affectedBoundary11.x2New !== undefined) continue;
                            let used11 = false;
                            for(k11 = i11 - 1; !used11 && k11 >= 0 && horizon11[k11].start >= affectedBoundary11.y1; k11--)used11 = horizon11[k11].boundary === affectedBoundary11;
                            for(k11 = j11 + 1; !used11 && k11 < horizon11.length && horizon11[k11].end <= affectedBoundary11.y2; k11++)used11 = horizon11[k11].boundary === affectedBoundary11;
                            for(k11 = 0; !used11 && k11 < changedHorizon11.length; k11++)used11 = changedHorizon11[k11].boundary === affectedBoundary11;
                            if (!used11) affectedBoundary11.x2New = maxXNew11;
                        }
                        Array.prototype.splice.apply(horizon11, [
                            i11,
                            j11 - i11 + 1
                        ].concat(changedHorizon11));
                    }
                    for (const horizonPart11 of horizon11){
                        const affectedBoundary11 = horizonPart11.boundary;
                        if (affectedBoundary11.x2New === undefined) affectedBoundary11.x2New = Math.max(width21, affectedBoundary11.x2);
                    }
                }
                class TextLayerRenderTask11 {
                    constructor({ textContent: textContent11 , textContentStream: textContentStream11 , container: container11 , viewport: viewport11 , textDivs: textDivs11 , textContentItemsStr: textContentItemsStr11 , enhanceTextSelection: enhanceTextSelection11  }){
                        this._textContent = textContent11;
                        this._textContentStream = textContentStream11;
                        this._container = container11;
                        this._document = container11.ownerDocument;
                        this._viewport = viewport11;
                        this._textDivs = textDivs11 || [];
                        this._textContentItemsStr = textContentItemsStr11 || [];
                        this._enhanceTextSelection = !!enhanceTextSelection11;
                        this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
                        this._reader = null;
                        this._layoutTextLastFontSize = null;
                        this._layoutTextLastFontFamily = null;
                        this._layoutTextCtx = null;
                        this._textDivProperties = new WeakMap();
                        this._renderingDone = false;
                        this._canceled = false;
                        this._capability = (0, _util11.createPromiseCapability)();
                        this._renderTimer = null;
                        this._bounds = [];
                        this._capability.promise.finally(()=>{
                            if (this._layoutTextCtx) {
                                this._layoutTextCtx.canvas.width = 0;
                                this._layoutTextCtx.canvas.height = 0;
                                this._layoutTextCtx = null;
                            }
                        }).catch(()=>{});
                    }
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util11.AbortException("TextLayer task cancelled."));
                            this._reader = null;
                        }
                        if (this._renderTimer !== null) {
                            clearTimeout(this._renderTimer);
                            this._renderTimer = null;
                        }
                        this._capability.reject(new Error("TextLayer task cancelled."));
                    }
                    _processItems(items11, styleCache11) {
                        for(let i11 = 0, len11 = items11.length; i11 < len11; i11++){
                            if (items11[i11].str === undefined) {
                                if (items11[i11].type === "beginMarkedContentProps" || items11[i11].type === "beginMarkedContent") {
                                    const parent11 = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (items11[i11].id !== null) this._container.setAttribute("id", `${items11[i11].id}`);
                                    parent11.appendChild(this._container);
                                } else if (items11[i11].type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(items11[i11].str);
                            appendText11(this, items11[i11], styleCache11, this._layoutTextCtx);
                        }
                    }
                    _layoutText(textDiv11) {
                        const textDivProperties11 = this._textDivProperties.get(textDiv11);
                        let transform11 = "";
                        if (textDivProperties11.canvasWidth !== 0 && textDivProperties11.hasText) {
                            const { fontSize: fontSize11 , fontFamily: fontFamily11  } = textDiv11.style;
                            if (fontSize11 !== this._layoutTextLastFontSize || fontFamily11 !== this._layoutTextLastFontFamily) {
                                this._layoutTextCtx.font = `${fontSize11} ${fontFamily11}`;
                                this._layoutTextLastFontSize = fontSize11;
                                this._layoutTextLastFontFamily = fontFamily11;
                            }
                            const { width: width21  } = this._layoutTextCtx.measureText(textDiv11.textContent);
                            if (width21 > 0) {
                                textDivProperties11.scale = textDivProperties11.canvasWidth / width21;
                                transform11 = `scaleX(${textDivProperties11.scale})`;
                            }
                        }
                        if (textDivProperties11.angle !== 0) transform11 = `rotate(${textDivProperties11.angle}deg) ${transform11}`;
                        if (transform11.length > 0) {
                            if (this._enhanceTextSelection) textDivProperties11.originalTransform = transform11;
                            textDiv11.style.transform = transform11;
                        }
                        if (textDivProperties11.hasText) this._container.appendChild(textDiv11);
                        if (textDivProperties11.hasEOL) {
                            const br11 = document.createElement("br");
                            br11.setAttribute("role", "presentation");
                            this._container.appendChild(br11);
                        }
                    }
                    _render(timeout11 = 0) {
                        const capability11 = (0, _util11.createPromiseCapability)();
                        let styleCache11 = Object.create(null);
                        const canvas11 = this._document.createElement("canvas");
                        canvas11.height = canvas11.width = DEFAULT_FONT_SIZE11;
                        canvas11.mozOpaque = true;
                        this._layoutTextCtx = canvas11.getContext("2d", {
                            alpha: false
                        });
                        if (this._textContent) {
                            const textItems11 = this._textContent.items;
                            const textStyles11 = this._textContent.styles;
                            this._processItems(textItems11, textStyles11);
                            capability11.resolve();
                        } else if (this._textContentStream) {
                            const pump11 = ()=>{
                                this._reader.read().then(({ value: value11 , done: done11  })=>{
                                    if (done11) {
                                        capability11.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache11, value11.styles);
                                    this._processItems(value11.items, styleCache11);
                                    pump11();
                                }, capability11.reject);
                            };
                            this._reader = this._textContentStream.getReader();
                            pump11();
                        } else throw new Error('Neither "textContent" nor "textContentStream" parameters specified.');
                        capability11.promise.then(()=>{
                            styleCache11 = null;
                            if (!timeout11) render11(this);
                            else this._renderTimer = setTimeout(()=>{
                                render11(this);
                                this._renderTimer = null;
                            }, timeout11);
                        }, this._capability.reject);
                    }
                    expandTextDivs(expandDivs11 = false) {
                        if (!this._enhanceTextSelection || !this._renderingDone) return;
                        if (this._bounds !== null) {
                            expand11(this);
                            this._bounds = null;
                        }
                        const transformBuf11 = [], paddingBuf11 = [];
                        for(let i11 = 0, ii11 = this._textDivs.length; i11 < ii11; i11++){
                            const div11 = this._textDivs[i11];
                            const divProps11 = this._textDivProperties.get(div11);
                            if (!divProps11.hasText) continue;
                            if (expandDivs11) {
                                transformBuf11.length = 0;
                                paddingBuf11.length = 0;
                                if (divProps11.originalTransform) transformBuf11.push(divProps11.originalTransform);
                                if (divProps11.paddingTop > 0) {
                                    paddingBuf11.push(`${divProps11.paddingTop}px`);
                                    transformBuf11.push(`translateY(${-divProps11.paddingTop}px)`);
                                } else paddingBuf11.push(0);
                                if (divProps11.paddingRight > 0) paddingBuf11.push(`${divProps11.paddingRight / divProps11.scale}px`);
                                else paddingBuf11.push(0);
                                if (divProps11.paddingBottom > 0) paddingBuf11.push(`${divProps11.paddingBottom}px`);
                                else paddingBuf11.push(0);
                                if (divProps11.paddingLeft > 0) {
                                    paddingBuf11.push(`${divProps11.paddingLeft / divProps11.scale}px`);
                                    transformBuf11.push(`translateX(${-divProps11.paddingLeft / divProps11.scale}px)`);
                                } else paddingBuf11.push(0);
                                div11.style.padding = paddingBuf11.join(" ");
                                if (transformBuf11.length) div11.style.transform = transformBuf11.join(" ");
                            } else {
                                div11.style.padding = null;
                                div11.style.transform = divProps11.originalTransform;
                            }
                        }
                    }
                }
                function renderTextLayer11(renderParameters11) {
                    const task11 = new TextLayerRenderTask11({
                        textContent: renderParameters11.textContent,
                        textContentStream: renderParameters11.textContentStream,
                        container: renderParameters11.container,
                        viewport: renderParameters11.viewport,
                        textDivs: renderParameters11.textDivs,
                        textContentItemsStr: renderParameters11.textContentItemsStr,
                        enhanceTextSelection: renderParameters11.enhanceTextSelection
                    });
                    task11._render(renderParameters11.timeout);
                    return task11;
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.SVGGraphics = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                var _display_utils11 = __w_pdfjs_require__11(1);
                var _is_node11 = __w_pdfjs_require__11(4);
                let SVGGraphics11 = class {
                    constructor(){
                        (0, _util11.unreachable)("Not implemented: SVGGraphics");
                    }
                };
                exports11.SVGGraphics = SVGGraphics11;
                {
                    const SVG_DEFAULTS11 = {
                        fontStyle: "normal",
                        fontWeight: "normal",
                        fillColor: "#000000"
                    };
                    const XML_NS11 = "http://www.w3.org/XML/1998/namespace";
                    const XLINK_NS11 = "http://www.w3.org/1999/xlink";
                    const LINE_CAP_STYLES11 = [
                        "butt",
                        "round",
                        "square"
                    ];
                    const LINE_JOIN_STYLES11 = [
                        "miter",
                        "round",
                        "bevel"
                    ];
                    const convertImgDataToPng11 = function() {
                        const PNG_HEADER11 = new Uint8Array([
                            0x89,
                            0x50,
                            0x4e,
                            0x47,
                            0x0d,
                            0x0a,
                            0x1a,
                            0x0a
                        ]);
                        const CHUNK_WRAPPER_SIZE11 = 12;
                        const crcTable11 = new Int32Array(256);
                        for(let i11 = 0; i11 < 256; i11++){
                            let c41 = i11;
                            for(let h11 = 0; h11 < 8; h11++)if (c41 & 1) c41 = 0xedb88320 ^ c41 >> 1 & 0x7fffffff;
                            else c41 = c41 >> 1 & 0x7fffffff;
                            crcTable11[i11] = c41;
                        }
                        function crc3211(data11, start11, end11) {
                            let crc11 = -1;
                            for(let i11 = start11; i11 < end11; i11++){
                                const a11 = (crc11 ^ data11[i11]) & 0xff;
                                const b41 = crcTable11[a11];
                                crc11 = crc11 >>> 8 ^ b41;
                            }
                            return crc11 ^ -1;
                        }
                        function writePngChunk11(type11, body11, data11, offset11) {
                            let p51 = offset11;
                            const len11 = body11.length;
                            data11[p51] = len11 >> 24 & 0xff;
                            data11[p51 + 1] = len11 >> 16 & 0xff;
                            data11[p51 + 2] = len11 >> 8 & 0xff;
                            data11[p51 + 3] = len11 & 0xff;
                            p51 += 4;
                            data11[p51] = type11.charCodeAt(0) & 0xff;
                            data11[p51 + 1] = type11.charCodeAt(1) & 0xff;
                            data11[p51 + 2] = type11.charCodeAt(2) & 0xff;
                            data11[p51 + 3] = type11.charCodeAt(3) & 0xff;
                            p51 += 4;
                            data11.set(body11, p51);
                            p51 += body11.length;
                            const crc11 = crc3211(data11, offset11 + 4, p51);
                            data11[p51] = crc11 >> 24 & 0xff;
                            data11[p51 + 1] = crc11 >> 16 & 0xff;
                            data11[p51 + 2] = crc11 >> 8 & 0xff;
                            data11[p51 + 3] = crc11 & 0xff;
                        }
                        function adler3211(data11, start11, end11) {
                            let a11 = 1;
                            let b41 = 0;
                            for(let i11 = start11; i11 < end11; ++i11){
                                a11 = (a11 + (data11[i11] & 0xff)) % 65521;
                                b41 = (b41 + a11) % 65521;
                            }
                            return b41 << 16 | a11;
                        }
                        function deflateSync11(literals11) {
                            if (!_is_node11.isNodeJS) return deflateSyncUncompressed11(literals11);
                            try {
                                let input11;
                                if (parseInt($bcIJv.versions.node) >= 8) input11 = literals11;
                                else input11 = $8a1ac77efddccc8e$require$Buffer.from(literals11);
                                const output11 = (parcelRequire("7Fvv0")).deflateSync(input11, {
                                    level: 9
                                });
                                return output11 instanceof Uint8Array ? output11 : new Uint8Array(output11);
                            } catch (e11) {
                                (0, _util11.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e11);
                            }
                            return deflateSyncUncompressed11(literals11);
                        }
                        function deflateSyncUncompressed11(literals11) {
                            let len11 = literals11.length;
                            const maxBlockLength11 = 0xffff;
                            const deflateBlocks11 = Math.ceil(len11 / maxBlockLength11);
                            const idat11 = new Uint8Array(2 + len11 + deflateBlocks11 * 5 + 4);
                            let pi11 = 0;
                            idat11[pi11++] = 0x78;
                            idat11[pi11++] = 0x9c;
                            let pos11 = 0;
                            while(len11 > maxBlockLength11){
                                idat11[pi11++] = 0x00;
                                idat11[pi11++] = 0xff;
                                idat11[pi11++] = 0xff;
                                idat11[pi11++] = 0x00;
                                idat11[pi11++] = 0x00;
                                idat11.set(literals11.subarray(pos11, pos11 + maxBlockLength11), pi11);
                                pi11 += maxBlockLength11;
                                pos11 += maxBlockLength11;
                                len11 -= maxBlockLength11;
                            }
                            idat11[pi11++] = 0x01;
                            idat11[pi11++] = len11 & 0xff;
                            idat11[pi11++] = len11 >> 8 & 0xff;
                            idat11[pi11++] = ~len11 & 255;
                            idat11[pi11++] = (~len11 & 0xffff) >> 8 & 0xff;
                            idat11.set(literals11.subarray(pos11), pi11);
                            pi11 += literals11.length - pos11;
                            const adler11 = adler3211(literals11, 0, literals11.length);
                            idat11[pi11++] = adler11 >> 24 & 0xff;
                            idat11[pi11++] = adler11 >> 16 & 0xff;
                            idat11[pi11++] = adler11 >> 8 & 0xff;
                            idat11[pi11++] = adler11 & 0xff;
                            return idat11;
                        }
                        function encode11(imgData11, kind11, forceDataSchema11, isMask11) {
                            const width21 = imgData11.width;
                            const height11 = imgData11.height;
                            let bitDepth11, colorType11, lineSize11;
                            const bytes11 = imgData11.data;
                            switch(kind11){
                                case _util11.ImageKind.GRAYSCALE_1BPP:
                                    colorType11 = 0;
                                    bitDepth11 = 1;
                                    lineSize11 = width21 + 7 >> 3;
                                    break;
                                case _util11.ImageKind.RGB_24BPP:
                                    colorType11 = 2;
                                    bitDepth11 = 8;
                                    lineSize11 = width21 * 3;
                                    break;
                                case _util11.ImageKind.RGBA_32BPP:
                                    colorType11 = 6;
                                    bitDepth11 = 8;
                                    lineSize11 = width21 * 4;
                                    break;
                                default:
                                    throw new Error("invalid format");
                            }
                            const literals11 = new Uint8Array((1 + lineSize11) * height11);
                            let offsetLiterals11 = 0, offsetBytes11 = 0;
                            for(let y41 = 0; y41 < height11; ++y41){
                                literals11[offsetLiterals11++] = 0;
                                literals11.set(bytes11.subarray(offsetBytes11, offsetBytes11 + lineSize11), offsetLiterals11);
                                offsetBytes11 += lineSize11;
                                offsetLiterals11 += lineSize11;
                            }
                            if (kind11 === _util11.ImageKind.GRAYSCALE_1BPP && isMask11) {
                                offsetLiterals11 = 0;
                                for(let y41 = 0; y41 < height11; y41++){
                                    offsetLiterals11++;
                                    for(let i11 = 0; i11 < lineSize11; i11++)literals11[offsetLiterals11++] ^= 0xff;
                                }
                            }
                            const ihdr11 = new Uint8Array([
                                width21 >> 24 & 0xff,
                                width21 >> 16 & 0xff,
                                width21 >> 8 & 0xff,
                                width21 & 0xff,
                                height11 >> 24 & 0xff,
                                height11 >> 16 & 0xff,
                                height11 >> 8 & 0xff,
                                height11 & 0xff,
                                bitDepth11,
                                colorType11,
                                0x00,
                                0x00,
                                0x00
                            ]);
                            const idat11 = deflateSync11(literals11);
                            const pngLength11 = PNG_HEADER11.length + CHUNK_WRAPPER_SIZE11 * 3 + ihdr11.length + idat11.length;
                            const data11 = new Uint8Array(pngLength11);
                            let offset11 = 0;
                            data11.set(PNG_HEADER11, offset11);
                            offset11 += PNG_HEADER11.length;
                            writePngChunk11("IHDR", ihdr11, data11, offset11);
                            offset11 += CHUNK_WRAPPER_SIZE11 + ihdr11.length;
                            writePngChunk11("IDATA", idat11, data11, offset11);
                            offset11 += CHUNK_WRAPPER_SIZE11 + idat11.length;
                            writePngChunk11("IEND", new Uint8Array(0), data11, offset11);
                            return (0, _util11.createObjectURL)(data11, "image/png", forceDataSchema11);
                        }
                        return function convertImgDataToPng11(imgData11, forceDataSchema11, isMask11) {
                            const kind11 = imgData11.kind === undefined ? _util11.ImageKind.GRAYSCALE_1BPP : imgData11.kind;
                            return encode11(imgData11, kind11, forceDataSchema11, isMask11);
                        };
                    }();
                    class SVGExtraState11 {
                        constructor(){
                            this.fontSizeScale = 1;
                            this.fontWeight = SVG_DEFAULTS11.fontWeight;
                            this.fontSize = 0;
                            this.textMatrix = _util11.IDENTITY_MATRIX;
                            this.fontMatrix = _util11.FONT_IDENTITY_MATRIX;
                            this.leading = 0;
                            this.textRenderingMode = _util11.TextRenderingMode.FILL;
                            this.textMatrixScale = 1;
                            this.x = 0;
                            this.y = 0;
                            this.lineX = 0;
                            this.lineY = 0;
                            this.charSpacing = 0;
                            this.wordSpacing = 0;
                            this.textHScale = 1;
                            this.textRise = 0;
                            this.fillColor = SVG_DEFAULTS11.fillColor;
                            this.strokeColor = "#000000";
                            this.fillAlpha = 1;
                            this.strokeAlpha = 1;
                            this.lineWidth = 1;
                            this.lineJoin = "";
                            this.lineCap = "";
                            this.miterLimit = 0;
                            this.dashArray = [];
                            this.dashPhase = 0;
                            this.dependencies = [];
                            this.activeClipUrl = null;
                            this.clipGroup = null;
                            this.maskId = "";
                        }
                        clone() {
                            return Object.create(this);
                        }
                        setCurrentPoint(x41, y41) {
                            this.x = x41;
                            this.y = y41;
                        }
                    }
                    function opListToTree11(opList11) {
                        let opTree11 = [];
                        const tmp11 = [];
                        for (const opListElement11 of opList11){
                            if (opListElement11.fn === "save") {
                                opTree11.push({
                                    fnId: 92,
                                    fn: "group",
                                    items: []
                                });
                                tmp11.push(opTree11);
                                opTree11 = opTree11[opTree11.length - 1].items;
                                continue;
                            }
                            if (opListElement11.fn === "restore") opTree11 = tmp11.pop();
                            else opTree11.push(opListElement11);
                        }
                        return opTree11;
                    }
                    function pf11(value11) {
                        if (Number.isInteger(value11)) return value11.toString();
                        const s11 = value11.toFixed(10);
                        let i11 = s11.length - 1;
                        if (s11[i11] !== "0") return s11;
                        do i11--;
                        while (s11[i11] === "0");
                        return s11.substring(0, s11[i11] === "." ? i11 : i11 + 1);
                    }
                    function pm11(m31) {
                        if (m31[4] === 0 && m31[5] === 0) {
                            if (m31[1] === 0 && m31[2] === 0) {
                                if (m31[0] === 1 && m31[3] === 1) return "";
                                return `scale(${pf11(m31[0])} ${pf11(m31[3])})`;
                            }
                            if (m31[0] === m31[3] && m31[1] === -m31[2]) {
                                const a11 = Math.acos(m31[0]) * 180 / Math.PI;
                                return `rotate(${pf11(a11)})`;
                            }
                        } else {
                            if (m31[0] === 1 && m31[1] === 0 && m31[2] === 0 && m31[3] === 1) return `translate(${pf11(m31[4])} ${pf11(m31[5])})`;
                        }
                        return `matrix(${pf11(m31[0])} ${pf11(m31[1])} ${pf11(m31[2])} ${pf11(m31[3])} ${pf11(m31[4])} ` + `${pf11(m31[5])})`;
                    }
                    let clipCount11 = 0;
                    let maskCount11 = 0;
                    let shadingCount11 = 0;
                    exports11.SVGGraphics = SVGGraphics11 = class {
                        constructor(commonObjs11, objs11, forceDataSchema11 = false){
                            this.svgFactory = new _display_utils11.DOMSVGFactory();
                            this.current = new SVGExtraState11();
                            this.transformMatrix = _util11.IDENTITY_MATRIX;
                            this.transformStack = [];
                            this.extraStack = [];
                            this.commonObjs = commonObjs11;
                            this.objs = objs11;
                            this.pendingClip = null;
                            this.pendingEOFill = false;
                            this.embedFonts = false;
                            this.embeddedFonts = Object.create(null);
                            this.cssStyle = null;
                            this.forceDataSchema = !!forceDataSchema11;
                            this._operatorIdMapping = [];
                            for(const op11 in _util11.OPS)this._operatorIdMapping[_util11.OPS[op11]] = op11;
                        }
                        save() {
                            this.transformStack.push(this.transformMatrix);
                            const old11 = this.current;
                            this.extraStack.push(old11);
                            this.current = old11.clone();
                        }
                        restore() {
                            this.transformMatrix = this.transformStack.pop();
                            this.current = this.extraStack.pop();
                            this.pendingClip = null;
                            this.tgrp = null;
                        }
                        group(items11) {
                            this.save();
                            this.executeOpTree(items11);
                            this.restore();
                        }
                        loadDependencies(operatorList11) {
                            const fnArray11 = operatorList11.fnArray;
                            const argsArray11 = operatorList11.argsArray;
                            for(let i11 = 0, ii11 = fnArray11.length; i11 < ii11; i11++){
                                if (fnArray11[i11] !== _util11.OPS.dependency) continue;
                                for (const obj11 of argsArray11[i11]){
                                    const objsPool11 = obj11.startsWith("g_") ? this.commonObjs : this.objs;
                                    const promise11 = new Promise((resolve11)=>{
                                        objsPool11.get(obj11, resolve11);
                                    });
                                    this.current.dependencies.push(promise11);
                                }
                            }
                            return Promise.all(this.current.dependencies);
                        }
                        transform(a11, b41, c41, d51, e11, f11) {
                            const transformMatrix11 = [
                                a11,
                                b41,
                                c41,
                                d51,
                                e11,
                                f11
                            ];
                            this.transformMatrix = _util11.Util.transform(this.transformMatrix, transformMatrix11);
                            this.tgrp = null;
                        }
                        getSVG(operatorList11, viewport11) {
                            this.viewport = viewport11;
                            const svgElement11 = this._initialize(viewport11);
                            return this.loadDependencies(operatorList11).then(()=>{
                                this.transformMatrix = _util11.IDENTITY_MATRIX;
                                this.executeOpTree(this.convertOpList(operatorList11));
                                return svgElement11;
                            });
                        }
                        convertOpList(operatorList11) {
                            const operatorIdMapping11 = this._operatorIdMapping;
                            const argsArray11 = operatorList11.argsArray;
                            const fnArray11 = operatorList11.fnArray;
                            const opList11 = [];
                            for(let i11 = 0, ii11 = fnArray11.length; i11 < ii11; i11++){
                                const fnId11 = fnArray11[i11];
                                opList11.push({
                                    fnId: fnId11,
                                    fn: operatorIdMapping11[fnId11],
                                    args: argsArray11[i11]
                                });
                            }
                            return opListToTree11(opList11);
                        }
                        executeOpTree(opTree11) {
                            for (const opTreeElement11 of opTree11){
                                const fn11 = opTreeElement11.fn;
                                const fnId11 = opTreeElement11.fnId;
                                const args11 = opTreeElement11.args;
                                switch(fnId11 | 0){
                                    case _util11.OPS.beginText:
                                        this.beginText();
                                        break;
                                    case _util11.OPS.dependency:
                                        break;
                                    case _util11.OPS.setLeading:
                                        this.setLeading(args11);
                                        break;
                                    case _util11.OPS.setLeadingMoveText:
                                        this.setLeadingMoveText(args11[0], args11[1]);
                                        break;
                                    case _util11.OPS.setFont:
                                        this.setFont(args11);
                                        break;
                                    case _util11.OPS.showText:
                                        this.showText(args11[0]);
                                        break;
                                    case _util11.OPS.showSpacedText:
                                        this.showText(args11[0]);
                                        break;
                                    case _util11.OPS.endText:
                                        this.endText();
                                        break;
                                    case _util11.OPS.moveText:
                                        this.moveText(args11[0], args11[1]);
                                        break;
                                    case _util11.OPS.setCharSpacing:
                                        this.setCharSpacing(args11[0]);
                                        break;
                                    case _util11.OPS.setWordSpacing:
                                        this.setWordSpacing(args11[0]);
                                        break;
                                    case _util11.OPS.setHScale:
                                        this.setHScale(args11[0]);
                                        break;
                                    case _util11.OPS.setTextMatrix:
                                        this.setTextMatrix(args11[0], args11[1], args11[2], args11[3], args11[4], args11[5]);
                                        break;
                                    case _util11.OPS.setTextRise:
                                        this.setTextRise(args11[0]);
                                        break;
                                    case _util11.OPS.setTextRenderingMode:
                                        this.setTextRenderingMode(args11[0]);
                                        break;
                                    case _util11.OPS.setLineWidth:
                                        this.setLineWidth(args11[0]);
                                        break;
                                    case _util11.OPS.setLineJoin:
                                        this.setLineJoin(args11[0]);
                                        break;
                                    case _util11.OPS.setLineCap:
                                        this.setLineCap(args11[0]);
                                        break;
                                    case _util11.OPS.setMiterLimit:
                                        this.setMiterLimit(args11[0]);
                                        break;
                                    case _util11.OPS.setFillRGBColor:
                                        this.setFillRGBColor(args11[0], args11[1], args11[2]);
                                        break;
                                    case _util11.OPS.setStrokeRGBColor:
                                        this.setStrokeRGBColor(args11[0], args11[1], args11[2]);
                                        break;
                                    case _util11.OPS.setStrokeColorN:
                                        this.setStrokeColorN(args11);
                                        break;
                                    case _util11.OPS.setFillColorN:
                                        this.setFillColorN(args11);
                                        break;
                                    case _util11.OPS.shadingFill:
                                        this.shadingFill(args11[0]);
                                        break;
                                    case _util11.OPS.setDash:
                                        this.setDash(args11[0], args11[1]);
                                        break;
                                    case _util11.OPS.setRenderingIntent:
                                        this.setRenderingIntent(args11[0]);
                                        break;
                                    case _util11.OPS.setFlatness:
                                        this.setFlatness(args11[0]);
                                        break;
                                    case _util11.OPS.setGState:
                                        this.setGState(args11[0]);
                                        break;
                                    case _util11.OPS.fill:
                                        this.fill();
                                        break;
                                    case _util11.OPS.eoFill:
                                        this.eoFill();
                                        break;
                                    case _util11.OPS.stroke:
                                        this.stroke();
                                        break;
                                    case _util11.OPS.fillStroke:
                                        this.fillStroke();
                                        break;
                                    case _util11.OPS.eoFillStroke:
                                        this.eoFillStroke();
                                        break;
                                    case _util11.OPS.clip:
                                        this.clip("nonzero");
                                        break;
                                    case _util11.OPS.eoClip:
                                        this.clip("evenodd");
                                        break;
                                    case _util11.OPS.paintSolidColorImageMask:
                                        this.paintSolidColorImageMask();
                                        break;
                                    case _util11.OPS.paintImageXObject:
                                        this.paintImageXObject(args11[0]);
                                        break;
                                    case _util11.OPS.paintInlineImageXObject:
                                        this.paintInlineImageXObject(args11[0]);
                                        break;
                                    case _util11.OPS.paintImageMaskXObject:
                                        this.paintImageMaskXObject(args11[0]);
                                        break;
                                    case _util11.OPS.paintFormXObjectBegin:
                                        this.paintFormXObjectBegin(args11[0], args11[1]);
                                        break;
                                    case _util11.OPS.paintFormXObjectEnd:
                                        this.paintFormXObjectEnd();
                                        break;
                                    case _util11.OPS.closePath:
                                        this.closePath();
                                        break;
                                    case _util11.OPS.closeStroke:
                                        this.closeStroke();
                                        break;
                                    case _util11.OPS.closeFillStroke:
                                        this.closeFillStroke();
                                        break;
                                    case _util11.OPS.closeEOFillStroke:
                                        this.closeEOFillStroke();
                                        break;
                                    case _util11.OPS.nextLine:
                                        this.nextLine();
                                        break;
                                    case _util11.OPS.transform:
                                        this.transform(args11[0], args11[1], args11[2], args11[3], args11[4], args11[5]);
                                        break;
                                    case _util11.OPS.constructPath:
                                        this.constructPath(args11[0], args11[1]);
                                        break;
                                    case _util11.OPS.endPath:
                                        this.endPath();
                                        break;
                                    case 92:
                                        this.group(opTreeElement11.items);
                                        break;
                                    default:
                                        (0, _util11.warn)(`Unimplemented operator ${fn11}`);
                                        break;
                                }
                            }
                        }
                        setWordSpacing(wordSpacing11) {
                            this.current.wordSpacing = wordSpacing11;
                        }
                        setCharSpacing(charSpacing11) {
                            this.current.charSpacing = charSpacing11;
                        }
                        nextLine() {
                            this.moveText(0, this.current.leading);
                        }
                        setTextMatrix(a11, b41, c41, d51, e11, f11) {
                            const current11 = this.current;
                            current11.textMatrix = current11.lineMatrix = [
                                a11,
                                b41,
                                c41,
                                d51,
                                e11,
                                f11
                            ];
                            current11.textMatrixScale = Math.hypot(a11, b41);
                            current11.x = current11.lineX = 0;
                            current11.y = current11.lineY = 0;
                            current11.xcoords = [];
                            current11.ycoords = [];
                            current11.tspan = this.svgFactory.createElement("svg:tspan");
                            current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                            current11.tspan.setAttributeNS(null, "font-size", `${pf11(current11.fontSize)}px`);
                            current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                            current11.txtElement = this.svgFactory.createElement("svg:text");
                            current11.txtElement.appendChild(current11.tspan);
                        }
                        beginText() {
                            const current11 = this.current;
                            current11.x = current11.lineX = 0;
                            current11.y = current11.lineY = 0;
                            current11.textMatrix = _util11.IDENTITY_MATRIX;
                            current11.lineMatrix = _util11.IDENTITY_MATRIX;
                            current11.textMatrixScale = 1;
                            current11.tspan = this.svgFactory.createElement("svg:tspan");
                            current11.txtElement = this.svgFactory.createElement("svg:text");
                            current11.txtgrp = this.svgFactory.createElement("svg:g");
                            current11.xcoords = [];
                            current11.ycoords = [];
                        }
                        moveText(x41, y41) {
                            const current11 = this.current;
                            current11.x = current11.lineX += x41;
                            current11.y = current11.lineY += y41;
                            current11.xcoords = [];
                            current11.ycoords = [];
                            current11.tspan = this.svgFactory.createElement("svg:tspan");
                            current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                            current11.tspan.setAttributeNS(null, "font-size", `${pf11(current11.fontSize)}px`);
                            current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                        }
                        showText(glyphs11) {
                            const current11 = this.current;
                            const font11 = current11.font;
                            const fontSize11 = current11.fontSize;
                            if (fontSize11 === 0) return;
                            const fontSizeScale11 = current11.fontSizeScale;
                            const charSpacing11 = current11.charSpacing;
                            const wordSpacing11 = current11.wordSpacing;
                            const fontDirection11 = current11.fontDirection;
                            const textHScale11 = current11.textHScale * fontDirection11;
                            const vertical11 = font11.vertical;
                            const spacingDir11 = vertical11 ? 1 : -1;
                            const defaultVMetrics11 = font11.defaultVMetrics;
                            const widthAdvanceScale11 = fontSize11 * current11.fontMatrix[0];
                            let x41 = 0;
                            for (const glyph11 of glyphs11){
                                if (glyph11 === null) {
                                    x41 += fontDirection11 * wordSpacing11;
                                    continue;
                                } else if ((0, _util11.isNum)(glyph11)) {
                                    x41 += spacingDir11 * glyph11 * fontSize11 / 1000;
                                    continue;
                                }
                                const spacing11 = (glyph11.isSpace ? wordSpacing11 : 0) + charSpacing11;
                                const character11 = glyph11.fontChar;
                                let scaledX11, scaledY11;
                                let width21 = glyph11.width;
                                if (vertical11) {
                                    let vx11;
                                    const vmetric11 = glyph11.vmetric || defaultVMetrics11;
                                    vx11 = glyph11.vmetric ? vmetric11[1] : width21 * 0.5;
                                    vx11 = -vx11 * widthAdvanceScale11;
                                    const vy11 = vmetric11[2] * widthAdvanceScale11;
                                    width21 = vmetric11 ? -vmetric11[0] : width21;
                                    scaledX11 = vx11 / fontSizeScale11;
                                    scaledY11 = (x41 + vy11) / fontSizeScale11;
                                } else {
                                    scaledX11 = x41 / fontSizeScale11;
                                    scaledY11 = 0;
                                }
                                if (glyph11.isInFont || font11.missingFile) {
                                    current11.xcoords.push(current11.x + scaledX11);
                                    if (vertical11) current11.ycoords.push(-current11.y + scaledY11);
                                    current11.tspan.textContent += character11;
                                }
                                let charWidth11;
                                if (vertical11) charWidth11 = width21 * widthAdvanceScale11 - spacing11 * fontDirection11;
                                else charWidth11 = width21 * widthAdvanceScale11 + spacing11 * fontDirection11;
                                x41 += charWidth11;
                            }
                            current11.tspan.setAttributeNS(null, "x", current11.xcoords.map(pf11).join(" "));
                            if (vertical11) current11.tspan.setAttributeNS(null, "y", current11.ycoords.map(pf11).join(" "));
                            else current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                            if (vertical11) current11.y -= x41;
                            else current11.x += x41 * textHScale11;
                            current11.tspan.setAttributeNS(null, "font-family", current11.fontFamily);
                            current11.tspan.setAttributeNS(null, "font-size", `${pf11(current11.fontSize)}px`);
                            if (current11.fontStyle !== SVG_DEFAULTS11.fontStyle) current11.tspan.setAttributeNS(null, "font-style", current11.fontStyle);
                            if (current11.fontWeight !== SVG_DEFAULTS11.fontWeight) current11.tspan.setAttributeNS(null, "font-weight", current11.fontWeight);
                            const fillStrokeMode11 = current11.textRenderingMode & _util11.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode11 === _util11.TextRenderingMode.FILL || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                if (current11.fillColor !== SVG_DEFAULTS11.fillColor) current11.tspan.setAttributeNS(null, "fill", current11.fillColor);
                                if (current11.fillAlpha < 1) current11.tspan.setAttributeNS(null, "fill-opacity", current11.fillAlpha);
                            } else if (current11.textRenderingMode === _util11.TextRenderingMode.ADD_TO_PATH) current11.tspan.setAttributeNS(null, "fill", "transparent");
                            else current11.tspan.setAttributeNS(null, "fill", "none");
                            if (fillStrokeMode11 === _util11.TextRenderingMode.STROKE || fillStrokeMode11 === _util11.TextRenderingMode.FILL_STROKE) {
                                const lineWidthScale11 = 1 / (current11.textMatrixScale || 1);
                                this._setStrokeAttributes(current11.tspan, lineWidthScale11);
                            }
                            let textMatrix11 = current11.textMatrix;
                            if (current11.textRise !== 0) {
                                textMatrix11 = textMatrix11.slice();
                                textMatrix11[5] += current11.textRise;
                            }
                            current11.txtElement.setAttributeNS(null, "transform", `${pm11(textMatrix11)} scale(${pf11(textHScale11)}, -1)`);
                            current11.txtElement.setAttributeNS(XML_NS11, "xml:space", "preserve");
                            current11.txtElement.appendChild(current11.tspan);
                            current11.txtgrp.appendChild(current11.txtElement);
                            this._ensureTransformGroup().appendChild(current11.txtElement);
                        }
                        setLeadingMoveText(x41, y41) {
                            this.setLeading(-y41);
                            this.moveText(x41, y41);
                        }
                        addFontStyle(fontObj11) {
                            if (!fontObj11.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                            if (!this.cssStyle) {
                                this.cssStyle = this.svgFactory.createElement("svg:style");
                                this.cssStyle.setAttributeNS(null, "type", "text/css");
                                this.defs.appendChild(this.cssStyle);
                            }
                            const url11 = (0, _util11.createObjectURL)(fontObj11.data, fontObj11.mimetype, this.forceDataSchema);
                            this.cssStyle.textContent += `@font-face { font-family: "${fontObj11.loadedName}";` + ` src: url(${url11}); }\n`;
                        }
                        setFont(details11) {
                            const current11 = this.current;
                            const fontObj11 = this.commonObjs.get(details11[0]);
                            let size11 = details11[1];
                            current11.font = fontObj11;
                            if (this.embedFonts && !fontObj11.missingFile && !this.embeddedFonts[fontObj11.loadedName]) {
                                this.addFontStyle(fontObj11);
                                this.embeddedFonts[fontObj11.loadedName] = fontObj11;
                            }
                            current11.fontMatrix = fontObj11.fontMatrix || _util11.FONT_IDENTITY_MATRIX;
                            let bold11 = "normal";
                            if (fontObj11.black) bold11 = "900";
                            else if (fontObj11.bold) bold11 = "bold";
                            const italic11 = fontObj11.italic ? "italic" : "normal";
                            if (size11 < 0) {
                                size11 = -size11;
                                current11.fontDirection = -1;
                            } else current11.fontDirection = 1;
                            current11.fontSize = size11;
                            current11.fontFamily = fontObj11.loadedName;
                            current11.fontWeight = bold11;
                            current11.fontStyle = italic11;
                            current11.tspan = this.svgFactory.createElement("svg:tspan");
                            current11.tspan.setAttributeNS(null, "y", pf11(-current11.y));
                            current11.xcoords = [];
                            current11.ycoords = [];
                        }
                        endText() {
                            const current11 = this.current;
                            if (current11.textRenderingMode & _util11.TextRenderingMode.ADD_TO_PATH_FLAG && current11.txtElement?.hasChildNodes()) {
                                current11.element = current11.txtElement;
                                this.clip("nonzero");
                                this.endPath();
                            }
                        }
                        setLineWidth(width21) {
                            if (width21 > 0) this.current.lineWidth = width21;
                        }
                        setLineCap(style11) {
                            this.current.lineCap = LINE_CAP_STYLES11[style11];
                        }
                        setLineJoin(style11) {
                            this.current.lineJoin = LINE_JOIN_STYLES11[style11];
                        }
                        setMiterLimit(limit11) {
                            this.current.miterLimit = limit11;
                        }
                        setStrokeAlpha(strokeAlpha11) {
                            this.current.strokeAlpha = strokeAlpha11;
                        }
                        setStrokeRGBColor(r11, g11, b41) {
                            this.current.strokeColor = _util11.Util.makeHexColor(r11, g11, b41);
                        }
                        setFillAlpha(fillAlpha11) {
                            this.current.fillAlpha = fillAlpha11;
                        }
                        setFillRGBColor(r11, g11, b41) {
                            this.current.fillColor = _util11.Util.makeHexColor(r11, g11, b41);
                            this.current.tspan = this.svgFactory.createElement("svg:tspan");
                            this.current.xcoords = [];
                            this.current.ycoords = [];
                        }
                        setStrokeColorN(args11) {
                            this.current.strokeColor = this._makeColorN_Pattern(args11);
                        }
                        setFillColorN(args11) {
                            this.current.fillColor = this._makeColorN_Pattern(args11);
                        }
                        shadingFill(args11) {
                            const width21 = this.viewport.width;
                            const height11 = this.viewport.height;
                            const inv11 = _util11.Util.inverseTransform(this.transformMatrix);
                            const bl11 = _util11.Util.applyTransform([
                                0,
                                0
                            ], inv11);
                            const br11 = _util11.Util.applyTransform([
                                0,
                                height11
                            ], inv11);
                            const ul11 = _util11.Util.applyTransform([
                                width21,
                                0
                            ], inv11);
                            const ur11 = _util11.Util.applyTransform([
                                width21,
                                height11
                            ], inv11);
                            const x011 = Math.min(bl11[0], br11[0], ul11[0], ur11[0]);
                            const y011 = Math.min(bl11[1], br11[1], ul11[1], ur11[1]);
                            const x111 = Math.max(bl11[0], br11[0], ul11[0], ur11[0]);
                            const y111 = Math.max(bl11[1], br11[1], ul11[1], ur11[1]);
                            const rect31 = this.svgFactory.createElement("svg:rect");
                            rect31.setAttributeNS(null, "x", x011);
                            rect31.setAttributeNS(null, "y", y011);
                            rect31.setAttributeNS(null, "width", x111 - x011);
                            rect31.setAttributeNS(null, "height", y111 - y011);
                            rect31.setAttributeNS(null, "fill", this._makeShadingPattern(args11));
                            if (this.current.fillAlpha < 1) rect31.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                            this._ensureTransformGroup().appendChild(rect31);
                        }
                        _makeColorN_Pattern(args11) {
                            if (args11[0] === "TilingPattern") return this._makeTilingPattern(args11);
                            return this._makeShadingPattern(args11);
                        }
                        _makeTilingPattern(args11) {
                            const color11 = args11[1];
                            const operatorList11 = args11[2];
                            const matrix11 = args11[3] || _util11.IDENTITY_MATRIX;
                            const [x011, y011, x111, y111] = args11[4];
                            const xstep11 = args11[5];
                            const ystep11 = args11[6];
                            const paintType11 = args11[7];
                            const tilingId11 = `shading${shadingCount11++}`;
                            const [tx011, ty011, tx111, ty111] = _util11.Util.normalizeRect([
                                ..._util11.Util.applyTransform([
                                    x011,
                                    y011
                                ], matrix11),
                                ..._util11.Util.applyTransform([
                                    x111,
                                    y111
                                ], matrix11)
                            ]);
                            const [xscale11, yscale11] = _util11.Util.singularValueDecompose2dScale(matrix11);
                            const txstep11 = xstep11 * xscale11;
                            const tystep11 = ystep11 * yscale11;
                            const tiling11 = this.svgFactory.createElement("svg:pattern");
                            tiling11.setAttributeNS(null, "id", tilingId11);
                            tiling11.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                            tiling11.setAttributeNS(null, "width", txstep11);
                            tiling11.setAttributeNS(null, "height", tystep11);
                            tiling11.setAttributeNS(null, "x", `${tx011}`);
                            tiling11.setAttributeNS(null, "y", `${ty011}`);
                            const svg11 = this.svg;
                            const transformMatrix11 = this.transformMatrix;
                            const fillColor11 = this.current.fillColor;
                            const strokeColor11 = this.current.strokeColor;
                            const bbox11 = this.svgFactory.create(tx111 - tx011, ty111 - ty011);
                            this.svg = bbox11;
                            this.transformMatrix = matrix11;
                            if (paintType11 === 2) {
                                const cssColor11 = _util11.Util.makeHexColor(...color11);
                                this.current.fillColor = cssColor11;
                                this.current.strokeColor = cssColor11;
                            }
                            this.executeOpTree(this.convertOpList(operatorList11));
                            this.svg = svg11;
                            this.transformMatrix = transformMatrix11;
                            this.current.fillColor = fillColor11;
                            this.current.strokeColor = strokeColor11;
                            tiling11.appendChild(bbox11.childNodes[0]);
                            this.defs.appendChild(tiling11);
                            return `url(#${tilingId11})`;
                        }
                        _makeShadingPattern(args11) {
                            switch(args11[0]){
                                case "RadialAxial":
                                    const shadingId11 = `shading${shadingCount11++}`;
                                    const colorStops11 = args11[3];
                                    let gradient11;
                                    switch(args11[1]){
                                        case "axial":
                                            const point011 = args11[4];
                                            const point111 = args11[5];
                                            gradient11 = this.svgFactory.createElement("svg:linearGradient");
                                            gradient11.setAttributeNS(null, "id", shadingId11);
                                            gradient11.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                            gradient11.setAttributeNS(null, "x1", point011[0]);
                                            gradient11.setAttributeNS(null, "y1", point011[1]);
                                            gradient11.setAttributeNS(null, "x2", point111[0]);
                                            gradient11.setAttributeNS(null, "y2", point111[1]);
                                            break;
                                        case "radial":
                                            const focalPoint11 = args11[4];
                                            const circlePoint11 = args11[5];
                                            const focalRadius11 = args11[6];
                                            const circleRadius11 = args11[7];
                                            gradient11 = this.svgFactory.createElement("svg:radialGradient");
                                            gradient11.setAttributeNS(null, "id", shadingId11);
                                            gradient11.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                            gradient11.setAttributeNS(null, "cx", circlePoint11[0]);
                                            gradient11.setAttributeNS(null, "cy", circlePoint11[1]);
                                            gradient11.setAttributeNS(null, "r", circleRadius11);
                                            gradient11.setAttributeNS(null, "fx", focalPoint11[0]);
                                            gradient11.setAttributeNS(null, "fy", focalPoint11[1]);
                                            gradient11.setAttributeNS(null, "fr", focalRadius11);
                                            break;
                                        default:
                                            throw new Error(`Unknown RadialAxial type: ${args11[1]}`);
                                    }
                                    for (const colorStop11 of colorStops11){
                                        const stop11 = this.svgFactory.createElement("svg:stop");
                                        stop11.setAttributeNS(null, "offset", colorStop11[0]);
                                        stop11.setAttributeNS(null, "stop-color", colorStop11[1]);
                                        gradient11.appendChild(stop11);
                                    }
                                    this.defs.appendChild(gradient11);
                                    return `url(#${shadingId11})`;
                                case "Mesh":
                                    (0, _util11.warn)("Unimplemented pattern Mesh");
                                    return null;
                                case "Dummy":
                                    return "hotpink";
                                default:
                                    throw new Error(`Unknown IR type: ${args11[0]}`);
                            }
                        }
                        setDash(dashArray11, dashPhase11) {
                            this.current.dashArray = dashArray11;
                            this.current.dashPhase = dashPhase11;
                        }
                        constructPath(ops11, args11) {
                            const current11 = this.current;
                            let x41 = current11.x, y41 = current11.y;
                            let d51 = [];
                            let j11 = 0;
                            for (const op11 of ops11)switch(op11 | 0){
                                case _util11.OPS.rectangle:
                                    x41 = args11[j11++];
                                    y41 = args11[j11++];
                                    const width21 = args11[j11++];
                                    const height11 = args11[j11++];
                                    const xw11 = x41 + width21;
                                    const yh11 = y41 + height11;
                                    d51.push("M", pf11(x41), pf11(y41), "L", pf11(xw11), pf11(y41), "L", pf11(xw11), pf11(yh11), "L", pf11(x41), pf11(yh11), "Z");
                                    break;
                                case _util11.OPS.moveTo:
                                    x41 = args11[j11++];
                                    y41 = args11[j11++];
                                    d51.push("M", pf11(x41), pf11(y41));
                                    break;
                                case _util11.OPS.lineTo:
                                    x41 = args11[j11++];
                                    y41 = args11[j11++];
                                    d51.push("L", pf11(x41), pf11(y41));
                                    break;
                                case _util11.OPS.curveTo:
                                    x41 = args11[j11 + 4];
                                    y41 = args11[j11 + 5];
                                    d51.push("C", pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(args11[j11 + 2]), pf11(args11[j11 + 3]), pf11(x41), pf11(y41));
                                    j11 += 6;
                                    break;
                                case _util11.OPS.curveTo2:
                                    d51.push("C", pf11(x41), pf11(y41), pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(args11[j11 + 2]), pf11(args11[j11 + 3]));
                                    x41 = args11[j11 + 2];
                                    y41 = args11[j11 + 3];
                                    j11 += 4;
                                    break;
                                case _util11.OPS.curveTo3:
                                    x41 = args11[j11 + 2];
                                    y41 = args11[j11 + 3];
                                    d51.push("C", pf11(args11[j11]), pf11(args11[j11 + 1]), pf11(x41), pf11(y41), pf11(x41), pf11(y41));
                                    j11 += 4;
                                    break;
                                case _util11.OPS.closePath:
                                    d51.push("Z");
                                    break;
                            }
                            d51 = d51.join(" ");
                            if (current11.path && ops11.length > 0 && ops11[0] !== _util11.OPS.rectangle && ops11[0] !== _util11.OPS.moveTo) d51 = current11.path.getAttributeNS(null, "d") + d51;
                            else {
                                current11.path = this.svgFactory.createElement("svg:path");
                                this._ensureTransformGroup().appendChild(current11.path);
                            }
                            current11.path.setAttributeNS(null, "d", d51);
                            current11.path.setAttributeNS(null, "fill", "none");
                            current11.element = current11.path;
                            current11.setCurrentPoint(x41, y41);
                        }
                        endPath() {
                            const current11 = this.current;
                            current11.path = null;
                            if (!this.pendingClip) return;
                            if (!current11.element) {
                                this.pendingClip = null;
                                return;
                            }
                            const clipId11 = `clippath${clipCount11++}`;
                            const clipPath11 = this.svgFactory.createElement("svg:clipPath");
                            clipPath11.setAttributeNS(null, "id", clipId11);
                            clipPath11.setAttributeNS(null, "transform", pm11(this.transformMatrix));
                            const clipElement11 = current11.element.cloneNode(true);
                            if (this.pendingClip === "evenodd") clipElement11.setAttributeNS(null, "clip-rule", "evenodd");
                            else clipElement11.setAttributeNS(null, "clip-rule", "nonzero");
                            this.pendingClip = null;
                            clipPath11.appendChild(clipElement11);
                            this.defs.appendChild(clipPath11);
                            if (current11.activeClipUrl) {
                                current11.clipGroup = null;
                                for (const prev11 of this.extraStack)prev11.clipGroup = null;
                                clipPath11.setAttributeNS(null, "clip-path", current11.activeClipUrl);
                            }
                            current11.activeClipUrl = `url(#${clipId11})`;
                            this.tgrp = null;
                        }
                        clip(type11) {
                            this.pendingClip = type11;
                        }
                        closePath() {
                            const current11 = this.current;
                            if (current11.path) {
                                const d51 = `${current11.path.getAttributeNS(null, "d")}Z`;
                                current11.path.setAttributeNS(null, "d", d51);
                            }
                        }
                        setLeading(leading11) {
                            this.current.leading = -leading11;
                        }
                        setTextRise(textRise11) {
                            this.current.textRise = textRise11;
                        }
                        setTextRenderingMode(textRenderingMode11) {
                            this.current.textRenderingMode = textRenderingMode11;
                        }
                        setHScale(scale11) {
                            this.current.textHScale = scale11 / 100;
                        }
                        setRenderingIntent(intent11) {}
                        setFlatness(flatness11) {}
                        setGState(states11) {
                            for (const [key11, value11] of states11)switch(key11){
                                case "LW":
                                    this.setLineWidth(value11);
                                    break;
                                case "LC":
                                    this.setLineCap(value11);
                                    break;
                                case "LJ":
                                    this.setLineJoin(value11);
                                    break;
                                case "ML":
                                    this.setMiterLimit(value11);
                                    break;
                                case "D":
                                    this.setDash(value11[0], value11[1]);
                                    break;
                                case "RI":
                                    this.setRenderingIntent(value11);
                                    break;
                                case "FL":
                                    this.setFlatness(value11);
                                    break;
                                case "Font":
                                    this.setFont(value11);
                                    break;
                                case "CA":
                                    this.setStrokeAlpha(value11);
                                    break;
                                case "ca":
                                    this.setFillAlpha(value11);
                                    break;
                                default:
                                    (0, _util11.warn)(`Unimplemented graphic state operator ${key11}`);
                                    break;
                            }
                        }
                        fill() {
                            const current11 = this.current;
                            if (current11.element) {
                                current11.element.setAttributeNS(null, "fill", current11.fillColor);
                                current11.element.setAttributeNS(null, "fill-opacity", current11.fillAlpha);
                                this.endPath();
                            }
                        }
                        stroke() {
                            const current11 = this.current;
                            if (current11.element) {
                                this._setStrokeAttributes(current11.element);
                                current11.element.setAttributeNS(null, "fill", "none");
                                this.endPath();
                            }
                        }
                        _setStrokeAttributes(element11, lineWidthScale11 = 1) {
                            const current11 = this.current;
                            let dashArray11 = current11.dashArray;
                            if (lineWidthScale11 !== 1 && dashArray11.length > 0) dashArray11 = dashArray11.map(function(value11) {
                                return lineWidthScale11 * value11;
                            });
                            element11.setAttributeNS(null, "stroke", current11.strokeColor);
                            element11.setAttributeNS(null, "stroke-opacity", current11.strokeAlpha);
                            element11.setAttributeNS(null, "stroke-miterlimit", pf11(current11.miterLimit));
                            element11.setAttributeNS(null, "stroke-linecap", current11.lineCap);
                            element11.setAttributeNS(null, "stroke-linejoin", current11.lineJoin);
                            element11.setAttributeNS(null, "stroke-width", pf11(lineWidthScale11 * current11.lineWidth) + "px");
                            element11.setAttributeNS(null, "stroke-dasharray", dashArray11.map(pf11).join(" "));
                            element11.setAttributeNS(null, "stroke-dashoffset", pf11(lineWidthScale11 * current11.dashPhase) + "px");
                        }
                        eoFill() {
                            if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                            this.fill();
                        }
                        fillStroke() {
                            this.stroke();
                            this.fill();
                        }
                        eoFillStroke() {
                            if (this.current.element) this.current.element.setAttributeNS(null, "fill-rule", "evenodd");
                            this.fillStroke();
                        }
                        closeStroke() {
                            this.closePath();
                            this.stroke();
                        }
                        closeFillStroke() {
                            this.closePath();
                            this.fillStroke();
                        }
                        closeEOFillStroke() {
                            this.closePath();
                            this.eoFillStroke();
                        }
                        paintSolidColorImageMask() {
                            const rect31 = this.svgFactory.createElement("svg:rect");
                            rect31.setAttributeNS(null, "x", "0");
                            rect31.setAttributeNS(null, "y", "0");
                            rect31.setAttributeNS(null, "width", "1px");
                            rect31.setAttributeNS(null, "height", "1px");
                            rect31.setAttributeNS(null, "fill", this.current.fillColor);
                            this._ensureTransformGroup().appendChild(rect31);
                        }
                        paintImageXObject(objId11) {
                            const imgData11 = objId11.startsWith("g_") ? this.commonObjs.get(objId11) : this.objs.get(objId11);
                            if (!imgData11) {
                                (0, _util11.warn)(`Dependent image with object ID ${objId11} is not ready yet`);
                                return;
                            }
                            this.paintInlineImageXObject(imgData11);
                        }
                        paintInlineImageXObject(imgData11, mask11) {
                            const width21 = imgData11.width;
                            const height11 = imgData11.height;
                            const imgSrc11 = convertImgDataToPng11(imgData11, this.forceDataSchema, !!mask11);
                            const cliprect11 = this.svgFactory.createElement("svg:rect");
                            cliprect11.setAttributeNS(null, "x", "0");
                            cliprect11.setAttributeNS(null, "y", "0");
                            cliprect11.setAttributeNS(null, "width", pf11(width21));
                            cliprect11.setAttributeNS(null, "height", pf11(height11));
                            this.current.element = cliprect11;
                            this.clip("nonzero");
                            const imgEl11 = this.svgFactory.createElement("svg:image");
                            imgEl11.setAttributeNS(XLINK_NS11, "xlink:href", imgSrc11);
                            imgEl11.setAttributeNS(null, "x", "0");
                            imgEl11.setAttributeNS(null, "y", pf11(-height11));
                            imgEl11.setAttributeNS(null, "width", pf11(width21) + "px");
                            imgEl11.setAttributeNS(null, "height", pf11(height11) + "px");
                            imgEl11.setAttributeNS(null, "transform", `scale(${pf11(1 / width21)} ${pf11(-1 / height11)})`);
                            if (mask11) mask11.appendChild(imgEl11);
                            else this._ensureTransformGroup().appendChild(imgEl11);
                        }
                        paintImageMaskXObject(imgData11) {
                            const current11 = this.current;
                            const width21 = imgData11.width;
                            const height11 = imgData11.height;
                            const fillColor11 = current11.fillColor;
                            current11.maskId = `mask${maskCount11++}`;
                            const mask11 = this.svgFactory.createElement("svg:mask");
                            mask11.setAttributeNS(null, "id", current11.maskId);
                            const rect31 = this.svgFactory.createElement("svg:rect");
                            rect31.setAttributeNS(null, "x", "0");
                            rect31.setAttributeNS(null, "y", "0");
                            rect31.setAttributeNS(null, "width", pf11(width21));
                            rect31.setAttributeNS(null, "height", pf11(height11));
                            rect31.setAttributeNS(null, "fill", fillColor11);
                            rect31.setAttributeNS(null, "mask", `url(#${current11.maskId})`);
                            this.defs.appendChild(mask11);
                            this._ensureTransformGroup().appendChild(rect31);
                            this.paintInlineImageXObject(imgData11, mask11);
                        }
                        paintFormXObjectBegin(matrix11, bbox11) {
                            if (Array.isArray(matrix11) && matrix11.length === 6) this.transform(matrix11[0], matrix11[1], matrix11[2], matrix11[3], matrix11[4], matrix11[5]);
                            if (bbox11) {
                                const width21 = bbox11[2] - bbox11[0];
                                const height11 = bbox11[3] - bbox11[1];
                                const cliprect11 = this.svgFactory.createElement("svg:rect");
                                cliprect11.setAttributeNS(null, "x", bbox11[0]);
                                cliprect11.setAttributeNS(null, "y", bbox11[1]);
                                cliprect11.setAttributeNS(null, "width", pf11(width21));
                                cliprect11.setAttributeNS(null, "height", pf11(height11));
                                this.current.element = cliprect11;
                                this.clip("nonzero");
                                this.endPath();
                            }
                        }
                        paintFormXObjectEnd() {}
                        _initialize(viewport11) {
                            const svg11 = this.svgFactory.create(viewport11.width, viewport11.height);
                            const definitions11 = this.svgFactory.createElement("svg:defs");
                            svg11.appendChild(definitions11);
                            this.defs = definitions11;
                            const rootGroup11 = this.svgFactory.createElement("svg:g");
                            rootGroup11.setAttributeNS(null, "transform", pm11(viewport11.transform));
                            svg11.appendChild(rootGroup11);
                            this.svg = rootGroup11;
                            return svg11;
                        }
                        _ensureClipGroup() {
                            if (!this.current.clipGroup) {
                                const clipGroup11 = this.svgFactory.createElement("svg:g");
                                clipGroup11.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                                this.svg.appendChild(clipGroup11);
                                this.current.clipGroup = clipGroup11;
                            }
                            return this.current.clipGroup;
                        }
                        _ensureTransformGroup() {
                            if (!this.tgrp) {
                                this.tgrp = this.svgFactory.createElement("svg:g");
                                this.tgrp.setAttributeNS(null, "transform", pm11(this.transformMatrix));
                                if (this.current.activeClipUrl) this._ensureClipGroup().appendChild(this.tgrp);
                                else this.svg.appendChild(this.tgrp);
                            }
                            return this.tgrp;
                        }
                    };
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module11, exports11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.XfaLayer = void 0;
                class XfaLayer11 {
                    static setupStorage(html11, id11, element11, storage11, intent11) {
                        const storedData11 = storage11.getValue(id11, {
                            value: null
                        });
                        switch(element11.name){
                            case "textarea":
                                if (storedData11.value !== null) html11.textContent = storedData11.value;
                                if (intent11 === "print") break;
                                html11.addEventListener("input", (event11)=>{
                                    storage11.setValue(id11, {
                                        value: event11.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element11.attributes.type === "radio" || element11.attributes.type === "checkbox") {
                                    if (storedData11.value === element11.attributes.xfaOn) html11.setAttribute("checked", true);
                                    if (intent11 === "print") break;
                                    html11.addEventListener("change", (event11)=>{
                                        storage11.setValue(id11, {
                                            value: event11.target.getAttribute("xfaOn")
                                        });
                                    });
                                } else {
                                    if (storedData11.value !== null) html11.setAttribute("value", storedData11.value);
                                    if (intent11 === "print") break;
                                    html11.addEventListener("input", (event11)=>{
                                        storage11.setValue(id11, {
                                            value: event11.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData11.value !== null) {
                                    for (const option11 of element11.children)if (option11.attributes.value === storedData11.value) option11.attributes.selected = true;
                                }
                                html11.addEventListener("input", (event11)=>{
                                    const options11 = event11.target.options;
                                    const value11 = options11.selectedIndex === -1 ? "" : options11[options11.selectedIndex].value;
                                    storage11.setValue(id11, {
                                        value: value11
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes(html11, element11, storage11, intent11) {
                        const { attributes: attributes11  } = element11;
                        if (attributes11.type === "radio") attributes11.name = `${attributes11.name}-${intent11}`;
                        for (const [key11, value11] of Object.entries(attributes11)){
                            if (value11 === null || value11 === undefined || key11 === "dataId") continue;
                            if (key11 !== "style") {
                                if (key11 === "textContent") html11.textContent = value11;
                                else if (key11 === "class") html11.setAttribute(key11, value11.join(" "));
                                else html11.setAttribute(key11, value11);
                            } else Object.assign(html11.style, value11);
                        }
                        if (storage11 && attributes11.dataId) this.setupStorage(html11, attributes11.dataId, element11, storage11);
                    }
                    static render(parameters11) {
                        const storage11 = parameters11.annotationStorage;
                        const root11 = parameters11.xfa;
                        const intent11 = parameters11.intent || "display";
                        const rootHtml11 = document.createElement(root11.name);
                        if (root11.attributes) this.setAttributes(rootHtml11, root11);
                        const stack11 = [
                            [
                                root11,
                                -1,
                                rootHtml11
                            ]
                        ];
                        const rootDiv11 = parameters11.div;
                        rootDiv11.appendChild(rootHtml11);
                        const transform11 = `matrix(${parameters11.viewport.transform.join(",")})`;
                        rootDiv11.style.transform = transform11;
                        rootDiv11.setAttribute("class", "xfaLayer xfaFont");
                        while(stack11.length > 0){
                            const [parent11, i11, html11] = stack11[stack11.length - 1];
                            if (i11 + 1 === parent11.children.length) {
                                stack11.pop();
                                continue;
                            }
                            const child11 = parent11.children[++stack11[stack11.length - 1][1]];
                            if (child11 === null) continue;
                            const { name: name11  } = child11;
                            if (name11 === "#text") {
                                html11.appendChild(document.createTextNode(child11.value));
                                continue;
                            }
                            let childHtml11;
                            if (child11?.attributes?.xmlns) childHtml11 = document.createElementNS(child11.attributes.xmlns, name11);
                            else childHtml11 = document.createElement(name11);
                            html11.appendChild(childHtml11);
                            if (child11.attributes) this.setAttributes(childHtml11, child11, storage11, intent11);
                            if (child11.children && child11.children.length > 0) stack11.push([
                                child11,
                                -1,
                                childHtml11
                            ]);
                            else if (child11.value) childHtml11.appendChild(document.createTextNode(child11.value));
                        }
                        for (const el11 of rootDiv11.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el11.setAttribute("readOnly", true);
                    }
                    static update(parameters11) {
                        const transform11 = `matrix(${parameters11.viewport.transform.join(",")})`;
                        parameters11.div.style.transform = transform11;
                        parameters11.div.hidden = false;
                    }
                }
                exports11.XfaLayer = XfaLayer11;
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFNodeStream = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                var _network_utils11 = __w_pdfjs_require__11(23);
                const fs11 = (parcelRequire("7Fvv0"));
                const http11 = (parcelRequire("7Fvv0"));
                const https11 = (parcelRequire("7Fvv0"));
                const url11 = (parcelRequire("7Fvv0"));
                const fileUriRegex11 = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl11(sourceUrl11) {
                    const parsedUrl11 = url11.parse(sourceUrl11);
                    if (parsedUrl11.protocol === "file:" || parsedUrl11.host) return parsedUrl11;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl11)) return url11.parse(`file:///${sourceUrl11}`);
                    if (!parsedUrl11.host) parsedUrl11.protocol = "file:";
                    return parsedUrl11;
                }
                class PDFNodeStream11 {
                    constructor(source11){
                        this.source = source11;
                        this.url = parseUrl11(source11.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source11.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader11(this) : new PDFNodeStreamFullReader11(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start11, end11) {
                        if (end11 <= this._progressiveDataLength) return null;
                        const rangeReader11 = this.isFsUrl ? new PDFNodeStreamFsRangeReader11(this, start11, end11) : new PDFNodeStreamRangeReader11(this, start11, end11);
                        this._rangeRequestReaders.push(rangeReader11);
                        return rangeReader11;
                    }
                    cancelAllRequests(reason11) {
                        if (this._fullRequestReader) this._fullRequestReader.cancel(reason11);
                        for (const reader11 of this._rangeRequestReaders.slice(0))reader11.cancel(reason11);
                    }
                }
                exports11.PDFNodeStream = PDFNodeStream11;
                class BaseFullReader11 {
                    constructor(stream11){
                        this._url = stream11.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source11 = stream11.source;
                        this._contentLength = source11.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source11.disableRange || false;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source11.disableStream;
                        this._isRangeSupported = !source11.disableRange;
                        this._readableStream = null;
                        this._readCapability = (0, _util11.createPromiseCapability)();
                        this._headersCapability = (0, _util11.createPromiseCapability)();
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk31 = this._readableStream.read();
                        if (chunk31 === null) {
                            this._readCapability = (0, _util11.createPromiseCapability)();
                            return this.read();
                        }
                        this._loaded += chunk31.length;
                        if (this.onProgress) this.onProgress({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer11 = new Uint8Array(chunk31).buffer;
                        return {
                            value: buffer11,
                            done: false
                        };
                    }
                    cancel(reason11) {
                        if (!this._readableStream) {
                            this._error(reason11);
                            return;
                        }
                        this._readableStream.destroy(reason11);
                    }
                    _error(reason11) {
                        this._storedError = reason11;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream11) {
                        this._readableStream = readableStream11;
                        readableStream11.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream11.on("end", ()=>{
                            readableStream11.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream11.on("error", (reason11)=>{
                            this._error(reason11);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util11.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                class BaseRangeReader11 {
                    constructor(stream11){
                        this._url = stream11.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = (0, _util11.createPromiseCapability)();
                        const source11 = stream11.source;
                        this._isStreamingSupported = !source11.disableStream;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        if (this._storedError) throw this._storedError;
                        const chunk31 = this._readableStream.read();
                        if (chunk31 === null) {
                            this._readCapability = (0, _util11.createPromiseCapability)();
                            return this.read();
                        }
                        this._loaded += chunk31.length;
                        if (this.onProgress) this.onProgress({
                            loaded: this._loaded
                        });
                        const buffer11 = new Uint8Array(chunk31).buffer;
                        return {
                            value: buffer11,
                            done: false
                        };
                    }
                    cancel(reason11) {
                        if (!this._readableStream) {
                            this._error(reason11);
                            return;
                        }
                        this._readableStream.destroy(reason11);
                    }
                    _error(reason11) {
                        this._storedError = reason11;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream11) {
                        this._readableStream = readableStream11;
                        readableStream11.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream11.on("end", ()=>{
                            readableStream11.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream11.on("error", (reason11)=>{
                            this._error(reason11);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                }
                function createRequestOptions11(parsedUrl11, headers11) {
                    return {
                        protocol: parsedUrl11.protocol,
                        auth: parsedUrl11.auth,
                        host: parsedUrl11.hostname,
                        port: parsedUrl11.port,
                        path: parsedUrl11.path,
                        method: "GET",
                        headers: headers11
                    };
                }
                class PDFNodeStreamFullReader11 extends BaseFullReader11 {
                    constructor(stream11){
                        super(stream11);
                        const handleResponse11 = (response11)=>{
                            if (response11.statusCode === 404) {
                                const error11 = new _util11.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error11;
                                this._headersCapability.reject(error11);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response11);
                            const getResponseHeader11 = (name11)=>{
                                return this._readableStream.headers[name11.toLowerCase()];
                            };
                            const { allowRangeRequests: allowRangeRequests11 , suggestedLength: suggestedLength11  } = (0, _network_utils11.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader11,
                                isHttp: stream11.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests11;
                            this._contentLength = suggestedLength11 || this._contentLength;
                            this._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") this._request = http11.request(createRequestOptions11(this._url, stream11.httpHeaders), handleResponse11);
                        else this._request = https11.request(createRequestOptions11(this._url, stream11.httpHeaders), handleResponse11);
                        this._request.on("error", (reason11)=>{
                            this._storedError = reason11;
                            this._headersCapability.reject(reason11);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader11 extends BaseRangeReader11 {
                    constructor(stream11, start11, end11){
                        super(stream11);
                        this._httpHeaders = {};
                        for(const property11 in stream11.httpHeaders){
                            const value11 = stream11.httpHeaders[property11];
                            if (typeof value11 === "undefined") continue;
                            this._httpHeaders[property11] = value11;
                        }
                        this._httpHeaders.Range = `bytes=${start11}-${end11 - 1}`;
                        const handleResponse11 = (response11)=>{
                            if (response11.statusCode === 404) {
                                const error11 = new _util11.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error11;
                                return;
                            }
                            this._setReadableStream(response11);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") this._request = http11.request(createRequestOptions11(this._url, this._httpHeaders), handleResponse11);
                        else this._request = https11.request(createRequestOptions11(this._url, this._httpHeaders), handleResponse11);
                        this._request.on("error", (reason11)=>{
                            this._storedError = reason11;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader11 extends BaseFullReader11 {
                    constructor(stream11){
                        super(stream11);
                        let path11 = decodeURIComponent(this._url.path);
                        if (fileUriRegex11.test(this._url.href)) path11 = path11.replace(/^\//, "");
                        fs11.lstat(path11, (error11, stat11)=>{
                            if (error11) {
                                if (error11.code === "ENOENT") error11 = new _util11.MissingPDFException(`Missing PDF "${path11}".`);
                                this._storedError = error11;
                                this._headersCapability.reject(error11);
                                return;
                            }
                            this._contentLength = stat11.size;
                            this._setReadableStream(fs11.createReadStream(path11));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader11 extends BaseRangeReader11 {
                    constructor(stream11, start11, end11){
                        super(stream11);
                        let path11 = decodeURIComponent(this._url.path);
                        if (fileUriRegex11.test(this._url.href)) path11 = path11.replace(/^\//, "");
                        this._setReadableStream(fs11.createReadStream(path11, {
                            start: start11,
                            end: end11 - 1
                        }));
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.createResponseStatusError = createResponseStatusError11;
                exports11.extractFilenameFromHeader = extractFilenameFromHeader11;
                exports11.validateRangeRequestCapabilities = validateRangeRequestCapabilities11;
                exports11.validateResponseStatus = validateResponseStatus11;
                var _util11 = __w_pdfjs_require__11(2);
                var _content_disposition11 = __w_pdfjs_require__11(24);
                var _display_utils11 = __w_pdfjs_require__11(1);
                function validateRangeRequestCapabilities11({ getResponseHeader: getResponseHeader11 , isHttp: isHttp11 , rangeChunkSize: rangeChunkSize11 , disableRange: disableRange11  }) {
                    (0, _util11.assert)(rangeChunkSize11 > 0, "Range chunk size must be larger than zero");
                    const returnValues11 = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length11 = parseInt(getResponseHeader11("Content-Length"), 10);
                    if (!Number.isInteger(length11)) return returnValues11;
                    returnValues11.suggestedLength = length11;
                    if (length11 <= 2 * rangeChunkSize11) return returnValues11;
                    if (disableRange11 || !isHttp11) return returnValues11;
                    if (getResponseHeader11("Accept-Ranges") !== "bytes") return returnValues11;
                    const contentEncoding11 = getResponseHeader11("Content-Encoding") || "identity";
                    if (contentEncoding11 !== "identity") return returnValues11;
                    returnValues11.allowRangeRequests = true;
                    return returnValues11;
                }
                function extractFilenameFromHeader11(getResponseHeader11) {
                    const contentDisposition11 = getResponseHeader11("Content-Disposition");
                    if (contentDisposition11) {
                        let filename11 = (0, _content_disposition11.getFilenameFromContentDispositionHeader)(contentDisposition11);
                        if (filename11.includes("%")) try {
                            filename11 = decodeURIComponent(filename11);
                        } catch (ex11) {}
                        if ((0, _display_utils11.isPdfFile)(filename11)) return filename11;
                    }
                    return null;
                }
                function createResponseStatusError11(status11, url11) {
                    if (status11 === 404 || status11 === 0 && url11.startsWith("file:")) return new _util11.MissingPDFException('Missing PDF "' + url11 + '".');
                    return new _util11.UnexpectedResponseException(`Unexpected server response (${status11}) while retrieving PDF "${url11}".`, status11);
                }
                function validateResponseStatus11(status11) {
                    return status11 === 200 || status11 === 206;
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader11;
                var _util11 = __w_pdfjs_require__11(2);
                function getFilenameFromContentDispositionHeader11(contentDisposition11) {
                    let needsEncodingFixup11 = true;
                    let tmp11 = toParamRegExp11("filename\\*", "i").exec(contentDisposition11);
                    if (tmp11) {
                        tmp11 = tmp11[1];
                        let filename11 = rfc2616unquote11(tmp11);
                        filename11 = unescape(filename11);
                        filename11 = rfc5987decode11(filename11);
                        filename11 = rfc2047decode11(filename11);
                        return fixupEncoding11(filename11);
                    }
                    tmp11 = rfc2231getparam11(contentDisposition11);
                    if (tmp11) {
                        const filename11 = rfc2047decode11(tmp11);
                        return fixupEncoding11(filename11);
                    }
                    tmp11 = toParamRegExp11("filename", "i").exec(contentDisposition11);
                    if (tmp11) {
                        tmp11 = tmp11[1];
                        let filename11 = rfc2616unquote11(tmp11);
                        filename11 = rfc2047decode11(filename11);
                        return fixupEncoding11(filename11);
                    }
                    function toParamRegExp11(attributePattern11, flags11) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern11 + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags11);
                    }
                    function textdecode11(encoding11, value11) {
                        if (encoding11) {
                            if (!/^[\x00-\xFF]+$/.test(value11)) return value11;
                            try {
                                const decoder11 = new TextDecoder(encoding11, {
                                    fatal: true
                                });
                                const buffer11 = (0, _util11.stringToBytes)(value11);
                                value11 = decoder11.decode(buffer11);
                                needsEncodingFixup11 = false;
                            } catch (e11) {
                                if (/^utf-?8$/i.test(encoding11)) try {
                                    value11 = decodeURIComponent(escape(value11));
                                    needsEncodingFixup11 = false;
                                } catch (err11) {}
                            }
                        }
                        return value11;
                    }
                    function fixupEncoding11(value11) {
                        if (needsEncodingFixup11 && /[\x80-\xff]/.test(value11)) {
                            value11 = textdecode11("utf-8", value11);
                            if (needsEncodingFixup11) value11 = textdecode11("iso-8859-1", value11);
                        }
                        return value11;
                    }
                    function rfc2231getparam11(contentDispositionStr11) {
                        const matches11 = [];
                        let match11;
                        const iter11 = toParamRegExp11("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match11 = iter11.exec(contentDispositionStr11)) !== null){
                            let [, n11, quot11, part11] = match11;
                            n11 = parseInt(n11, 10);
                            if (n11 in matches11) {
                                if (n11 === 0) break;
                                continue;
                            }
                            matches11[n11] = [
                                quot11,
                                part11
                            ];
                        }
                        const parts11 = [];
                        for(let n11 = 0; n11 < matches11.length; ++n11){
                            if (!(n11 in matches11)) break;
                            let [quot11, part11] = matches11[n11];
                            part11 = rfc2616unquote11(part11);
                            if (quot11) {
                                part11 = unescape(part11);
                                if (n11 === 0) part11 = rfc5987decode11(part11);
                            }
                            parts11.push(part11);
                        }
                        return parts11.join("");
                    }
                    function rfc2616unquote11(value11) {
                        if (value11.startsWith('"')) {
                            const parts11 = value11.slice(1).split('\\"');
                            for(let i11 = 0; i11 < parts11.length; ++i11){
                                const quotindex11 = parts11[i11].indexOf('"');
                                if (quotindex11 !== -1) {
                                    parts11[i11] = parts11[i11].slice(0, quotindex11);
                                    parts11.length = i11 + 1;
                                }
                                parts11[i11] = parts11[i11].replace(/\\(.)/g, "$1");
                            }
                            value11 = parts11.join('"');
                        }
                        return value11;
                    }
                    function rfc5987decode11(extvalue11) {
                        const encodingend11 = extvalue11.indexOf("'");
                        if (encodingend11 === -1) return extvalue11;
                        const encoding11 = extvalue11.slice(0, encodingend11);
                        const langvalue11 = extvalue11.slice(encodingend11 + 1);
                        const value11 = langvalue11.replace(/^[^']*'/, "");
                        return textdecode11(encoding11, value11);
                    }
                    function rfc2047decode11(value11) {
                        if (!value11.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value11)) return value11;
                        return value11.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches11, charset11, encoding11, text11) {
                            if (encoding11 === "q" || encoding11 === "Q") {
                                text11 = text11.replace(/_/g, " ");
                                text11 = text11.replace(/=([0-9a-fA-F]{2})/g, function(match11, hex11) {
                                    return String.fromCharCode(parseInt(hex11, 16));
                                });
                                return textdecode11(charset11, text11);
                            }
                            try {
                                text11 = atob(text11);
                            } catch (e11) {}
                            return textdecode11(charset11, text11);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFNetworkStream = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                var _network_utils11 = __w_pdfjs_require__11(23);
                const OK_RESPONSE11 = 200;
                const PARTIAL_CONTENT_RESPONSE11 = 206;
                function getArrayBuffer11(xhr11) {
                    const data11 = xhr11.response;
                    if (typeof data11 !== "string") return data11;
                    const array11 = (0, _util11.stringToBytes)(data11);
                    return array11.buffer;
                }
                class NetworkManager11 {
                    constructor(url11, args11){
                        this.url = url11;
                        args11 = args11 || {};
                        this.isHttp = /^https?:/i.test(url11);
                        this.httpHeaders = this.isHttp && args11.httpHeaders || {};
                        this.withCredentials = args11.withCredentials || false;
                        this.getXhr = args11.getXhr || function NetworkManager_getXhr11() {
                            return new XMLHttpRequest();
                        };
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                    requestRange(begin11, end11, listeners11) {
                        const args11 = {
                            begin: begin11,
                            end: end11
                        };
                        for(const prop11 in listeners11)args11[prop11] = listeners11[prop11];
                        return this.request(args11);
                    }
                    requestFull(listeners11) {
                        return this.request(listeners11);
                    }
                    request(args11) {
                        const xhr11 = this.getXhr();
                        const xhrId11 = this.currXhrId++;
                        const pendingRequest11 = this.pendingRequests[xhrId11] = {
                            xhr: xhr11
                        };
                        xhr11.open("GET", this.url);
                        xhr11.withCredentials = this.withCredentials;
                        for(const property11 in this.httpHeaders){
                            const value11 = this.httpHeaders[property11];
                            if (typeof value11 === "undefined") continue;
                            xhr11.setRequestHeader(property11, value11);
                        }
                        if (this.isHttp && "begin" in args11 && "end" in args11) {
                            xhr11.setRequestHeader("Range", `bytes=${args11.begin}-${args11.end - 1}`);
                            pendingRequest11.expectedStatus = PARTIAL_CONTENT_RESPONSE11;
                        } else pendingRequest11.expectedStatus = OK_RESPONSE11;
                        xhr11.responseType = "arraybuffer";
                        if (args11.onError) xhr11.onerror = function(evt11) {
                            args11.onError(xhr11.status);
                        };
                        xhr11.onreadystatechange = this.onStateChange.bind(this, xhrId11);
                        xhr11.onprogress = this.onProgress.bind(this, xhrId11);
                        pendingRequest11.onHeadersReceived = args11.onHeadersReceived;
                        pendingRequest11.onDone = args11.onDone;
                        pendingRequest11.onError = args11.onError;
                        pendingRequest11.onProgress = args11.onProgress;
                        xhr11.send(null);
                        return xhrId11;
                    }
                    onProgress(xhrId11, evt11) {
                        const pendingRequest11 = this.pendingRequests[xhrId11];
                        if (!pendingRequest11) return;
                        if (pendingRequest11.onProgress) pendingRequest11.onProgress(evt11);
                    }
                    onStateChange(xhrId11, evt11) {
                        const pendingRequest11 = this.pendingRequests[xhrId11];
                        if (!pendingRequest11) return;
                        const xhr11 = pendingRequest11.xhr;
                        if (xhr11.readyState >= 2 && pendingRequest11.onHeadersReceived) {
                            pendingRequest11.onHeadersReceived();
                            delete pendingRequest11.onHeadersReceived;
                        }
                        if (xhr11.readyState !== 4) return;
                        if (!(xhrId11 in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId11];
                        if (xhr11.status === 0 && this.isHttp) {
                            if (pendingRequest11.onError) pendingRequest11.onError(xhr11.status);
                            return;
                        }
                        const xhrStatus11 = xhr11.status || OK_RESPONSE11;
                        const ok_response_on_range_request11 = xhrStatus11 === OK_RESPONSE11 && pendingRequest11.expectedStatus === PARTIAL_CONTENT_RESPONSE11;
                        if (!ok_response_on_range_request11 && xhrStatus11 !== pendingRequest11.expectedStatus) {
                            if (pendingRequest11.onError) pendingRequest11.onError(xhr11.status);
                            return;
                        }
                        const chunk31 = getArrayBuffer11(xhr11);
                        if (xhrStatus11 === PARTIAL_CONTENT_RESPONSE11) {
                            const rangeHeader11 = xhr11.getResponseHeader("Content-Range");
                            const matches11 = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader11);
                            pendingRequest11.onDone({
                                begin: parseInt(matches11[1], 10),
                                chunk: chunk31
                            });
                        } else if (chunk31) pendingRequest11.onDone({
                            begin: 0,
                            chunk: chunk31
                        });
                        else if (pendingRequest11.onError) pendingRequest11.onError(xhr11.status);
                    }
                    getRequestXhr(xhrId11) {
                        return this.pendingRequests[xhrId11].xhr;
                    }
                    isPendingRequest(xhrId11) {
                        return xhrId11 in this.pendingRequests;
                    }
                    abortRequest(xhrId11) {
                        const xhr11 = this.pendingRequests[xhrId11].xhr;
                        delete this.pendingRequests[xhrId11];
                        xhr11.abort();
                    }
                }
                class PDFNetworkStream11 {
                    constructor(source11){
                        this._source = source11;
                        this._manager = new NetworkManager11(source11.url, {
                            httpHeaders: source11.httpHeaders,
                            withCredentials: source11.withCredentials
                        });
                        this._rangeChunkSize = source11.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    _onRangeRequestReaderClosed(reader11) {
                        const i11 = this._rangeRequestReaders.indexOf(reader11);
                        if (i11 >= 0) this._rangeRequestReaders.splice(i11, 1);
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader11(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin11, end11) {
                        const reader11 = new PDFNetworkStreamRangeRequestReader11(this._manager, begin11, end11);
                        reader11.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader11);
                        return reader11;
                    }
                    cancelAllRequests(reason11) {
                        if (this._fullRequestReader) this._fullRequestReader.cancel(reason11);
                        for (const reader11 of this._rangeRequestReaders.slice(0))reader11.cancel(reason11);
                    }
                }
                exports11.PDFNetworkStream = PDFNetworkStream11;
                class PDFNetworkStreamFullRequestReader11 {
                    constructor(manager11, source11){
                        this._manager = manager11;
                        const args11 = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source11.url;
                        this._fullRequestId = manager11.requestFull(args11);
                        this._headersReceivedCapability = (0, _util11.createPromiseCapability)();
                        this._disableRange = source11.disableRange || false;
                        this._contentLength = source11.length;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                    _onHeadersReceived() {
                        const fullRequestXhrId11 = this._fullRequestId;
                        const fullRequestXhr11 = this._manager.getRequestXhr(fullRequestXhrId11);
                        const getResponseHeader11 = (name11)=>{
                            return fullRequestXhr11.getResponseHeader(name11);
                        };
                        const { allowRangeRequests: allowRangeRequests11 , suggestedLength: suggestedLength11  } = (0, _network_utils11.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader11,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests11) this._isRangeSupported = true;
                        this._contentLength = suggestedLength11 || this._contentLength;
                        this._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId11);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(args11) {
                        if (args11) {
                            if (this._requests.length > 0) {
                                const requestCapability11 = this._requests.shift();
                                requestCapability11.resolve({
                                    value: args11.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(args11.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status11) {
                        const url11 = this._url;
                        const exception11 = (0, _network_utils11.createResponseStatusError)(status11, url11);
                        this._storedError = exception11;
                        this._headersReceivedCapability.reject(exception11);
                        for (const requestCapability11 of this._requests)requestCapability11.reject(exception11);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(data11) {
                        if (this.onProgress) this.onProgress({
                            loaded: data11.loaded,
                            total: data11.lengthComputable ? data11.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    async read() {
                        if (this._storedError) throw this._storedError;
                        if (this._cachedChunks.length > 0) {
                            const chunk31 = this._cachedChunks.shift();
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = (0, _util11.createPromiseCapability)();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason11);
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader11 {
                    constructor(manager11, begin11, end11){
                        this._manager = manager11;
                        const args11 = {
                            onDone: this._onDone.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._requestId = manager11.requestRange(begin11, end11, args11);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                    _close() {
                        if (this.onClosed) this.onClosed(this);
                    }
                    _onDone(data11) {
                        const chunk31 = data11.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability11 = this._requests.shift();
                            requestCapability11.resolve({
                                value: chunk31,
                                done: false
                            });
                        } else this._queuedChunk = chunk31;
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onProgress(evt11) {
                        if (!this.isStreamingSupported && this.onProgress) this.onProgress({
                            loaded: evt11.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        if (this._queuedChunk !== null) {
                            const chunk31 = this._queuedChunk;
                            this._queuedChunk = null;
                            return {
                                value: chunk31,
                                done: false
                            };
                        }
                        if (this._done) return {
                            value: undefined,
                            done: true
                        };
                        const requestCapability11 = (0, _util11.createPromiseCapability)();
                        this._requests.push(requestCapability11);
                        return requestCapability11.promise;
                    }
                    cancel(reason11) {
                        this._done = true;
                        for (const requestCapability11 of this._requests)requestCapability11.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                }
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module11, exports11, __w_pdfjs_require__11)=>{
                Object.defineProperty(exports11, "__esModule", {
                    value: true
                });
                exports11.PDFFetchStream = void 0;
                var _util11 = __w_pdfjs_require__11(2);
                var _network_utils11 = __w_pdfjs_require__11(23);
                function createFetchOptions11(headers11, withCredentials11, abortController11) {
                    return {
                        method: "GET",
                        headers: headers11,
                        signal: abortController11?.signal,
                        mode: "cors",
                        credentials: withCredentials11 ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders11(httpHeaders11) {
                    const headers11 = new Headers();
                    for(const property11 in httpHeaders11){
                        const value11 = httpHeaders11[property11];
                        if (typeof value11 === "undefined") continue;
                        headers11.append(property11, value11);
                    }
                    return headers11;
                }
                class PDFFetchStream11 {
                    constructor(source11){
                        this.source = source11;
                        this.isHttp = /^https?:/i.test(source11.url);
                        this.httpHeaders = this.isHttp && source11.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    get _progressiveDataLength() {
                        return this._fullRequestReader?._loaded ?? 0;
                    }
                    getFullReader() {
                        (0, _util11.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader11(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin11, end11) {
                        if (end11 <= this._progressiveDataLength) return null;
                        const reader11 = new PDFFetchStreamRangeReader11(this, begin11, end11);
                        this._rangeRequestReaders.push(reader11);
                        return reader11;
                    }
                    cancelAllRequests(reason11) {
                        if (this._fullRequestReader) this._fullRequestReader.cancel(reason11);
                        for (const reader11 of this._rangeRequestReaders.slice(0))reader11.cancel(reason11);
                    }
                }
                exports11.PDFFetchStream = PDFFetchStream11;
                class PDFFetchStreamReader11 {
                    constructor(stream11){
                        this._stream = stream11;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source11 = stream11.source;
                        this._withCredentials = source11.withCredentials || false;
                        this._contentLength = source11.length;
                        this._headersCapability = (0, _util11.createPromiseCapability)();
                        this._disableRange = source11.disableRange || false;
                        this._rangeChunkSize = source11.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._isStreamingSupported = !source11.disableStream;
                        this._isRangeSupported = !source11.disableRange;
                        this._headers = createHeaders11(this._stream.httpHeaders);
                        const url11 = source11.url;
                        fetch(url11, createFetchOptions11(this._headers, this._withCredentials, this._abortController)).then((response11)=>{
                            if (!(0, _network_utils11.validateResponseStatus)(response11.status)) throw (0, _network_utils11.createResponseStatusError)(response11.status, url11);
                            this._reader = response11.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader11 = (name11)=>{
                                return response11.headers.get(name11);
                            };
                            const { allowRangeRequests: allowRangeRequests11 , suggestedLength: suggestedLength11  } = (0, _network_utils11.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader11,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests11;
                            this._contentLength = suggestedLength11 || this._contentLength;
                            this._filename = (0, _network_utils11.extractFilenameFromHeader)(getResponseHeader11);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util11.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._headersCapability.promise;
                        const { value: value11 , done: done11  } = await this._reader.read();
                        if (done11) return {
                            value: value11,
                            done: done11
                        };
                        this._loaded += value11.byteLength;
                        if (this.onProgress) this.onProgress({
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        const buffer11 = new Uint8Array(value11).buffer;
                        return {
                            value: buffer11,
                            done: false
                        };
                    }
                    cancel(reason11) {
                        if (this._reader) this._reader.cancel(reason11);
                        if (this._abortController) this._abortController.abort();
                    }
                }
                class PDFFetchStreamRangeReader11 {
                    constructor(stream11, begin11, end11){
                        this._stream = stream11;
                        this._reader = null;
                        this._loaded = 0;
                        const source11 = stream11.source;
                        this._withCredentials = source11.withCredentials || false;
                        this._readCapability = (0, _util11.createPromiseCapability)();
                        this._isStreamingSupported = !source11.disableStream;
                        if (typeof AbortController !== "undefined") this._abortController = new AbortController();
                        this._headers = createHeaders11(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin11}-${end11 - 1}`);
                        const url11 = source11.url;
                        fetch(url11, createFetchOptions11(this._headers, this._withCredentials, this._abortController)).then((response11)=>{
                            if (!(0, _network_utils11.validateResponseStatus)(response11.status)) throw (0, _network_utils11.createResponseStatusError)(response11.status, url11);
                            this._readCapability.resolve();
                            this._reader = response11.body.getReader();
                        }).catch((reason11)=>{
                            if (reason11?.name === "AbortError") return;
                            throw reason11;
                        });
                        this.onProgress = null;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    async read() {
                        await this._readCapability.promise;
                        const { value: value11 , done: done11  } = await this._reader.read();
                        if (done11) return {
                            value: value11,
                            done: done11
                        };
                        this._loaded += value11.byteLength;
                        if (this.onProgress) this.onProgress({
                            loaded: this._loaded
                        });
                        const buffer11 = new Uint8Array(value11).buffer;
                        return {
                            value: buffer11,
                            done: false
                        };
                    }
                    cancel(reason11) {
                        if (this._reader) this._reader.cancel(reason11);
                        if (this._abortController) this._abortController.abort();
                    }
                }
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId11) {
            /******/ // Check if module is in cache
            /******/ var cachedModule11 = __webpack_module_cache__[moduleId11];
            /******/ if (cachedModule11 !== undefined) /******/ return cachedModule11.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module11 = __webpack_module_cache__[moduleId11] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId11](module11, module11.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module11.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports11 = __webpack_exports__;
            Object.defineProperty(exports11, "__esModule", {
                value: true
            });
            Object.defineProperty(exports11, "addLinkAttributes", {
                enumerable: true,
                get: function() {
                    return _display_utils11.addLinkAttributes;
                }
            });
            Object.defineProperty(exports11, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils11.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports11, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils11.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports11, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils11.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports11, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils11.isPdfFile;
                }
            });
            Object.defineProperty(exports11, "LinkTarget", {
                enumerable: true,
                get: function() {
                    return _display_utils11.LinkTarget;
                }
            });
            Object.defineProperty(exports11, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils11.loadScript;
                }
            });
            Object.defineProperty(exports11, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils11.PDFDateString;
                }
            });
            Object.defineProperty(exports11, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils11.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports11, "build", {
                enumerable: true,
                get: function() {
                    return _api11.build;
                }
            });
            Object.defineProperty(exports11, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api11.getDocument;
                }
            });
            Object.defineProperty(exports11, "LoopbackPort", {
                enumerable: true,
                get: function() {
                    return _api11.LoopbackPort;
                }
            });
            Object.defineProperty(exports11, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api11.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports11, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api11.PDFWorker;
                }
            });
            Object.defineProperty(exports11, "version", {
                enumerable: true,
                get: function() {
                    return _api11.version;
                }
            });
            Object.defineProperty(exports11, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util11.CMapCompressionType;
                }
            });
            Object.defineProperty(exports11, "createObjectURL", {
                enumerable: true,
                get: function() {
                    return _util11.createObjectURL;
                }
            });
            Object.defineProperty(exports11, "createPromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util11.createPromiseCapability;
                }
            });
            Object.defineProperty(exports11, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util11.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports11, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util11.InvalidPDFException;
                }
            });
            Object.defineProperty(exports11, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util11.MissingPDFException;
                }
            });
            Object.defineProperty(exports11, "OPS", {
                enumerable: true,
                get: function() {
                    return _util11.OPS;
                }
            });
            Object.defineProperty(exports11, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util11.PasswordResponses;
                }
            });
            Object.defineProperty(exports11, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util11.PermissionFlag;
                }
            });
            Object.defineProperty(exports11, "removeNullCharacters", {
                enumerable: true,
                get: function() {
                    return _util11.removeNullCharacters;
                }
            });
            Object.defineProperty(exports11, "shadow", {
                enumerable: true,
                get: function() {
                    return _util11.shadow;
                }
            });
            Object.defineProperty(exports11, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util11.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports11, "UNSUPPORTED_FEATURES", {
                enumerable: true,
                get: function() {
                    return _util11.UNSUPPORTED_FEATURES;
                }
            });
            Object.defineProperty(exports11, "Util", {
                enumerable: true,
                get: function() {
                    return _util11.Util;
                }
            });
            Object.defineProperty(exports11, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util11.VerbosityLevel;
                }
            });
            Object.defineProperty(exports11, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer11.AnnotationLayer;
                }
            });
            Object.defineProperty(exports11, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options11.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports11, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer11.renderTextLayer;
                }
            });
            Object.defineProperty(exports11, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _svg11.SVGGraphics;
                }
            });
            Object.defineProperty(exports11, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer11.XfaLayer;
                }
            });
            var _display_utils11 = __w_pdfjs_require__(1);
            var _api11 = __w_pdfjs_require__(6);
            var _util11 = __w_pdfjs_require__(2);
            var _annotation_layer11 = __w_pdfjs_require__(17);
            var _worker_options11 = __w_pdfjs_require__(12);
            var _is_node11 = __w_pdfjs_require__(4);
            var _text_layer11 = __w_pdfjs_require__(19);
            var _svg11 = __w_pdfjs_require__(20);
            var _xfa_layer11 = __w_pdfjs_require__(21);
            const pdfjsVersion11 = "2.10.377";
            const pdfjsBuild11 = "156762c48";
            if (_is_node11.isNodeJS) {
                const { PDFNodeStream: PDFNodeStream11  } = __w_pdfjs_require__(22);
                (0, _api11.setPDFNetworkStreamFactory)((params11)=>{
                    return new PDFNodeStream11(params11);
                });
            } else {
                const { PDFNetworkStream: PDFNetworkStream11  } = __w_pdfjs_require__(25);
                const { PDFFetchStream: PDFFetchStream11  } = __w_pdfjs_require__(26);
                (0, _api11.setPDFNetworkStreamFactory)((params11)=>{
                    if ((0, _display_utils11.isValidFetchUrl)(params11.url)) return new PDFFetchStream11(params11);
                    return new PDFNetworkStream11(params11);
                });
            }
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRequire.register("bR0Jr", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $8a15364802de8752$export$a143d493d941bafc; }, function (v) { return $8a15364802de8752$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $8a15364802de8752$export$f99ded8fe4b79145; }, function (v) { return $8a15364802de8752$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8a15364802de8752$export$a143d493d941bafc;
var $8a15364802de8752$export$e4cf37d7f6fb9e0a;
var $8a15364802de8752$export$f99ded8fe4b79145;
/*
 * Export kMaxLength after typed array support is determined.
 */ var $8a15364802de8752$export$599f31c3813fae4d;
"use strict";

var $gsbgv = parcelRequire("gsbgv");

var $cbqcH = parcelRequire("cbqcH");

var $iLTtJ = parcelRequire("iLTtJ");
$8a15364802de8752$export$a143d493d941bafc = $8a15364802de8752$var$Buffer;
$8a15364802de8752$export$e4cf37d7f6fb9e0a = $8a15364802de8752$var$SlowBuffer;
$8a15364802de8752$export$f99ded8fe4b79145 = 50;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */ $8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT = $parcel$global.TYPED_ARRAY_SUPPORT !== undefined ? $parcel$global.TYPED_ARRAY_SUPPORT : $8a15364802de8752$var$typedArraySupport();
$8a15364802de8752$export$599f31c3813fae4d = $8a15364802de8752$var$kMaxLength();
function $8a15364802de8752$var$typedArraySupport() {
    try {
        var arr = new Uint8Array(1);
        arr.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function() {
                return 42;
            }
        };
        return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === "function" && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
        ;
    } catch (e) {
        return false;
    }
}
function $8a15364802de8752$var$kMaxLength() {
    return $8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT ? 0x7fffffff : 0x3fffffff;
}
function $8a15364802de8752$var$createBuffer(that, length) {
    if ($8a15364802de8752$var$kMaxLength() < length) throw new RangeError("Invalid typed array length");
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = new Uint8Array(length);
        that.__proto__ = $8a15364802de8752$var$Buffer.prototype;
    } else {
        // Fallback: Return an object instance of the Buffer class
        if (that === null) that = new $8a15364802de8752$var$Buffer(length);
        that.length = length;
    }
    return that;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8a15364802de8752$var$Buffer(arg, encodingOrOffset, length) {
    if (!$8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof $8a15364802de8752$var$Buffer)) return new $8a15364802de8752$var$Buffer(arg, encodingOrOffset, length);
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new Error("If encoding is specified then the first argument must be a string");
        return $8a15364802de8752$var$allocUnsafe(this, arg);
    }
    return $8a15364802de8752$var$from(this, arg, encodingOrOffset, length);
}
$8a15364802de8752$var$Buffer.poolSize = 8192 // not used by this implementation
;
// TODO: Legacy, not needed anymore. Remove in next major version.
$8a15364802de8752$var$Buffer._augment = function(arr) {
    arr.__proto__ = $8a15364802de8752$var$Buffer.prototype;
    return arr;
};
function $8a15364802de8752$var$from(that, value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('"value" argument must not be a number');
    if (typeof ArrayBuffer !== "undefined" && value instanceof ArrayBuffer) return $8a15364802de8752$var$fromArrayBuffer(that, value, encodingOrOffset, length);
    if (typeof value === "string") return $8a15364802de8752$var$fromString(that, value, encodingOrOffset);
    return $8a15364802de8752$var$fromObject(that, value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8a15364802de8752$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8a15364802de8752$var$from(null, value, encodingOrOffset, length);
};
if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
    $8a15364802de8752$var$Buffer.prototype.__proto__ = Uint8Array.prototype;
    $8a15364802de8752$var$Buffer.__proto__ = Uint8Array;
    if (typeof Symbol !== "undefined" && Symbol.species && $8a15364802de8752$var$Buffer[Symbol.species] === $8a15364802de8752$var$Buffer) // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty($8a15364802de8752$var$Buffer, Symbol.species, {
        value: null,
        configurable: true
    });
}
function $8a15364802de8752$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be a number');
    else if (size < 0) throw new RangeError('"size" argument must not be negative');
}
function $8a15364802de8752$var$alloc(that, size, fill, encoding) {
    $8a15364802de8752$var$assertSize(size);
    if (size <= 0) return $8a15364802de8752$var$createBuffer(that, size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === "string" ? $8a15364802de8752$var$createBuffer(that, size).fill(fill, encoding) : $8a15364802de8752$var$createBuffer(that, size).fill(fill);
    return $8a15364802de8752$var$createBuffer(that, size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8a15364802de8752$var$Buffer.alloc = function(size, fill, encoding) {
    return $8a15364802de8752$var$alloc(null, size, fill, encoding);
};
function $8a15364802de8752$var$allocUnsafe(that, size) {
    $8a15364802de8752$var$assertSize(size);
    that = $8a15364802de8752$var$createBuffer(that, size < 0 ? 0 : $8a15364802de8752$var$checked(size) | 0);
    if (!$8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) for(var i = 0; i < size; ++i)that[i] = 0;
    return that;
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8a15364802de8752$var$Buffer.allocUnsafe = function(size) {
    return $8a15364802de8752$var$allocUnsafe(null, size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8a15364802de8752$var$Buffer.allocUnsafeSlow = function(size) {
    return $8a15364802de8752$var$allocUnsafe(null, size);
};
function $8a15364802de8752$var$fromString(that, string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$8a15364802de8752$var$Buffer.isEncoding(encoding)) throw new TypeError('"encoding" must be a valid string encoding');
    var length = $8a15364802de8752$var$byteLength(string, encoding) | 0;
    that = $8a15364802de8752$var$createBuffer(that, length);
    var actual = that.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual);
    return that;
}
function $8a15364802de8752$var$fromArrayLike(that, array) {
    var length = array.length < 0 ? 0 : $8a15364802de8752$var$checked(array.length) | 0;
    that = $8a15364802de8752$var$createBuffer(that, length);
    for(var i = 0; i < length; i += 1)that[i] = array[i] & 255;
    return that;
}
function $8a15364802de8752$var$fromArrayBuffer(that, array, byteOffset, length) {
    array.byteLength // this throws if `array` is not a valid ArrayBuffer
    ;
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError("'offset' is out of bounds");
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError("'length' is out of bounds");
    if (byteOffset === undefined && length === undefined) array = new Uint8Array(array);
    else if (length === undefined) array = new Uint8Array(array, byteOffset);
    else array = new Uint8Array(array, byteOffset, length);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        // Return an augmented `Uint8Array` instance, for best performance
        that = array;
        that.__proto__ = $8a15364802de8752$var$Buffer.prototype;
    } else // Fallback: Return an object instance of the Buffer class
    that = $8a15364802de8752$var$fromArrayLike(that, array);
    return that;
}
function $8a15364802de8752$var$fromObject(that, obj) {
    if ($8a15364802de8752$var$Buffer.isBuffer(obj)) {
        var len = $8a15364802de8752$var$checked(obj.length) | 0;
        that = $8a15364802de8752$var$createBuffer(that, len);
        if (that.length === 0) return that;
        obj.copy(that, 0, 0, len);
        return that;
    }
    if (obj) {
        if (typeof ArrayBuffer !== "undefined" && obj.buffer instanceof ArrayBuffer || "length" in obj) {
            if (typeof obj.length !== "number" || $8a15364802de8752$var$isnan(obj.length)) return $8a15364802de8752$var$createBuffer(that, 0);
            return $8a15364802de8752$var$fromArrayLike(that, obj);
        }
        if (obj.type === "Buffer" && $iLTtJ(obj.data)) return $8a15364802de8752$var$fromArrayLike(that, obj.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
}
function $8a15364802de8752$var$checked(length) {
    // Note: cannot use `length < kMaxLength()` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8a15364802de8752$var$kMaxLength()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8a15364802de8752$var$kMaxLength().toString(16) + " bytes");
    return length | 0;
}
function $8a15364802de8752$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8a15364802de8752$var$Buffer.alloc(+length);
}
$8a15364802de8752$var$Buffer.isBuffer = function isBuffer(b) {
    return !!(b != null && b._isBuffer);
};
$8a15364802de8752$var$Buffer.compare = function compare(a, b) {
    if (!$8a15364802de8752$var$Buffer.isBuffer(a) || !$8a15364802de8752$var$Buffer.isBuffer(b)) throw new TypeError("Arguments must be Buffers");
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8a15364802de8752$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$8a15364802de8752$var$Buffer.concat = function concat(list, length) {
    if (!$iLTtJ(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8a15364802de8752$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $8a15364802de8752$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if (!$8a15364802de8752$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8a15364802de8752$var$byteLength(string, encoding) {
    if ($8a15364802de8752$var$Buffer.isBuffer(string)) return string.length;
    if (typeof ArrayBuffer !== "undefined" && typeof ArrayBuffer.isView === "function" && (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") string = "" + string;
    var len = string.length;
    if (len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
        case undefined:
            return $8a15364802de8752$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $8a15364802de8752$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return $8a15364802de8752$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8a15364802de8752$var$Buffer.byteLength = $8a15364802de8752$var$byteLength;
function $8a15364802de8752$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $8a15364802de8752$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $8a15364802de8752$var$utf8Slice(this, start, end);
        case "ascii":
            return $8a15364802de8752$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $8a15364802de8752$var$latin1Slice(this, start, end);
        case "base64":
            return $8a15364802de8752$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8a15364802de8752$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
$8a15364802de8752$var$Buffer.prototype._isBuffer = true;
function $8a15364802de8752$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8a15364802de8752$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$8a15364802de8752$var$swap(this, i, i + 1);
    return this;
};
$8a15364802de8752$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $8a15364802de8752$var$swap(this, i, i + 3);
        $8a15364802de8752$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8a15364802de8752$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $8a15364802de8752$var$swap(this, i, i + 7);
        $8a15364802de8752$var$swap(this, i + 1, i + 6);
        $8a15364802de8752$var$swap(this, i + 2, i + 5);
        $8a15364802de8752$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8a15364802de8752$var$Buffer.prototype.toString = function toString() {
    var length = this.length | 0;
    if (length === 0) return "";
    if (arguments.length === 0) return $8a15364802de8752$var$utf8Slice(this, 0, length);
    return $8a15364802de8752$var$slowToString.apply(this, arguments);
};
$8a15364802de8752$var$Buffer.prototype.equals = function equals(b) {
    if (!$8a15364802de8752$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $8a15364802de8752$var$Buffer.compare(this, b) === 0;
};
$8a15364802de8752$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $8a15364802de8752$export$f99ded8fe4b79145;
    if (this.length > 0) {
        str = this.toString("hex", 0, max).match(/.{2}/g).join(" ");
        if (this.length > max) str += " ... ";
    }
    return "<Buffer " + str + ">";
};
$8a15364802de8752$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (!$8a15364802de8752$var$Buffer.isBuffer(target)) throw new TypeError("Argument must be a Buffer");
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8a15364802de8752$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (isNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $8a15364802de8752$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8a15364802de8752$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8a15364802de8752$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8a15364802de8752$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $8a15364802de8752$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8a15364802de8752$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8a15364802de8752$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8a15364802de8752$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8a15364802de8752$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8a15364802de8752$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8a15364802de8752$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    // must be an even number of digits
    var strLen = string.length;
    if (strLen % 2 !== 0) throw new TypeError("Invalid hex string");
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if (isNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8a15364802de8752$var$utf8Write(buf, string, offset, length) {
    return $8a15364802de8752$var$blitBuffer($8a15364802de8752$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8a15364802de8752$var$asciiWrite(buf, string, offset, length) {
    return $8a15364802de8752$var$blitBuffer($8a15364802de8752$var$asciiToBytes(string), buf, offset, length);
}
function $8a15364802de8752$var$latin1Write(buf, string, offset, length) {
    return $8a15364802de8752$var$asciiWrite(buf, string, offset, length);
}
function $8a15364802de8752$var$base64Write(buf, string, offset, length) {
    return $8a15364802de8752$var$blitBuffer($8a15364802de8752$var$base64ToBytes(string), buf, offset, length);
}
function $8a15364802de8752$var$ucs2Write(buf, string, offset, length) {
    return $8a15364802de8752$var$blitBuffer($8a15364802de8752$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8a15364802de8752$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset | 0;
        if (isFinite(length)) {
            length = length | 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    // legacy write(string, encoding, offset, length) - remove in v0.13
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $8a15364802de8752$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $8a15364802de8752$var$utf8Write(this, string, offset, length);
        case "ascii":
            return $8a15364802de8752$var$asciiWrite(this, string, offset, length);
        case "latin1":
        case "binary":
            return $8a15364802de8752$var$latin1Write(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $8a15364802de8752$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $8a15364802de8752$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8a15364802de8752$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8a15364802de8752$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $gsbgv.fromByteArray(buf);
    else return $gsbgv.fromByteArray(buf.slice(start, end));
}
function $8a15364802de8752$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8a15364802de8752$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $8a15364802de8752$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8a15364802de8752$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $8a15364802de8752$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8a15364802de8752$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8a15364802de8752$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8a15364802de8752$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8a15364802de8752$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $8a15364802de8752$var$toHex(buf[i]);
    return out;
}
function $8a15364802de8752$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8a15364802de8752$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf;
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        newBuf = this.subarray(start, end);
        newBuf.__proto__ = $8a15364802de8752$var$Buffer.prototype;
    } else {
        var sliceLen = end - start;
        newBuf = new $8a15364802de8752$var$Buffer(sliceLen, undefined);
        for(var i = 0; i < sliceLen; ++i)newBuf[i] = this[i + start];
    }
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8a15364802de8752$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$8a15364802de8752$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8a15364802de8752$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8a15364802de8752$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8a15364802de8752$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8a15364802de8752$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8a15364802de8752$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8a15364802de8752$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8a15364802de8752$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8a15364802de8752$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8a15364802de8752$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8a15364802de8752$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8a15364802de8752$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8a15364802de8752$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8a15364802de8752$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8a15364802de8752$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 4, this.length);
    return $cbqcH.read(this, offset, true, 23, 4);
};
$8a15364802de8752$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 4, this.length);
    return $cbqcH.read(this, offset, false, 23, 4);
};
$8a15364802de8752$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 8, this.length);
    return $cbqcH.read(this, offset, true, 52, 8);
};
$8a15364802de8752$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkOffset(offset, 8, this.length);
    return $cbqcH.read(this, offset, false, 52, 8);
};
function $8a15364802de8752$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8a15364802de8752$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$8a15364802de8752$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8a15364802de8752$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8a15364802de8752$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    byteLength = byteLength | 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8a15364802de8752$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8a15364802de8752$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 1, 0xff, 0);
    if (!$8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    this[offset] = value & 0xff;
    return offset + 1;
};
function $8a15364802de8752$var$objectWriteUInt16(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i)buf[offset + i] = (value & 0xff << 8 * (littleEndian ? i : 1 - i)) >>> (littleEndian ? i : 1 - i) * 8;
}
$8a15364802de8752$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $8a15364802de8752$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$8a15364802de8752$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 2, 0xffff, 0);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $8a15364802de8752$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
function $8a15364802de8752$var$objectWriteUInt32(buf, value, offset, littleEndian) {
    if (value < 0) value = 0xffffffff + value + 1;
    for(var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i)buf[offset + i] = value >>> (littleEndian ? i : 3 - i) * 8 & 0xff;
}
$8a15364802de8752$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
    } else $8a15364802de8752$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$8a15364802de8752$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $8a15364802de8752$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
$8a15364802de8752$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8a15364802de8752$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8a15364802de8752$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $8a15364802de8752$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8a15364802de8752$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (!$8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8a15364802de8752$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
    } else $8a15364802de8752$var$objectWriteUInt16(this, value, offset, true);
    return offset + 2;
};
$8a15364802de8752$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
    } else $8a15364802de8752$var$objectWriteUInt16(this, value, offset, false);
    return offset + 2;
};
$8a15364802de8752$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
    } else $8a15364802de8752$var$objectWriteUInt32(this, value, offset, true);
    return offset + 4;
};
$8a15364802de8752$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset | 0;
    if (!noAssert) $8a15364802de8752$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    if ($8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) {
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
    } else $8a15364802de8752$var$objectWriteUInt32(this, value, offset, false);
    return offset + 4;
};
function $8a15364802de8752$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $8a15364802de8752$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $cbqcH.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8a15364802de8752$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8a15364802de8752$var$writeFloat(this, value, offset, true, noAssert);
};
$8a15364802de8752$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8a15364802de8752$var$writeFloat(this, value, offset, false, noAssert);
};
function $8a15364802de8752$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    if (!noAssert) $8a15364802de8752$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $cbqcH.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8a15364802de8752$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8a15364802de8752$var$writeDouble(this, value, offset, true, noAssert);
};
$8a15364802de8752$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8a15364802de8752$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8a15364802de8752$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("sourceStart out of bounds");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    var i;
    if (this === target && start < targetStart && targetStart < end) // descending copy from end
    for(i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
    else if (len < 1000 || !$8a15364802de8752$var$Buffer.TYPED_ARRAY_SUPPORT) // ascending copy from start
    for(i = 0; i < len; ++i)target[i + targetStart] = this[i + start];
    else Uint8Array.prototype.set.call(target, this.subarray(start, start + len), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8a15364802de8752$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (code < 256) val = code;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$8a15364802de8752$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    } else if (typeof val === "number") val = val & 255;
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $8a15364802de8752$var$Buffer.isBuffer(val) ? val : $8a15364802de8752$var$utf8ToBytes(new $8a15364802de8752$var$Buffer(val, encoding).toString());
        var len = bytes.length;
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $8a15364802de8752$var$INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g;
function $8a15364802de8752$var$base64clean(str) {
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = $8a15364802de8752$var$stringtrim(str).replace($8a15364802de8752$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $8a15364802de8752$var$stringtrim(str) {
    if (str.trim) return str.trim();
    return str.replace(/^\s+|\s+$/g, "");
}
function $8a15364802de8752$var$toHex(n) {
    if (n < 16) return "0" + n.toString(16);
    return n.toString(16);
}
function $8a15364802de8752$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $8a15364802de8752$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8a15364802de8752$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8a15364802de8752$var$base64ToBytes(str) {
    return $gsbgv.toByteArray($8a15364802de8752$var$base64clean(str));
}
function $8a15364802de8752$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
function $8a15364802de8752$var$isnan(val) {
    return val !== val // eslint-disable-line no-self-compare
    ;
}

});
parcelRequire.register("gsbgv", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $bfa7ffece2a4eb2d$export$d622b2ad8d90c771; }, function (v) { return $bfa7ffece2a4eb2d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $bfa7ffece2a4eb2d$export$6100ba28696e12de; }, function (v) { return $bfa7ffece2a4eb2d$export$6100ba28696e12de = v; });
var $bfa7ffece2a4eb2d$export$a48f0734ac7c2329;
var $bfa7ffece2a4eb2d$export$d622b2ad8d90c771;
var $bfa7ffece2a4eb2d$export$6100ba28696e12de;
"use strict";
$bfa7ffece2a4eb2d$export$a48f0734ac7c2329 = $bfa7ffece2a4eb2d$var$byteLength;
$bfa7ffece2a4eb2d$export$d622b2ad8d90c771 = $bfa7ffece2a4eb2d$var$toByteArray;
$bfa7ffece2a4eb2d$export$6100ba28696e12de = $bfa7ffece2a4eb2d$var$fromByteArray;
var $bfa7ffece2a4eb2d$var$lookup = [];
var $bfa7ffece2a4eb2d$var$revLookup = [];
var $bfa7ffece2a4eb2d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $bfa7ffece2a4eb2d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $bfa7ffece2a4eb2d$var$i = 0, $bfa7ffece2a4eb2d$var$len = $bfa7ffece2a4eb2d$var$code.length; $bfa7ffece2a4eb2d$var$i < $bfa7ffece2a4eb2d$var$len; ++$bfa7ffece2a4eb2d$var$i){
    $bfa7ffece2a4eb2d$var$lookup[$bfa7ffece2a4eb2d$var$i] = $bfa7ffece2a4eb2d$var$code[$bfa7ffece2a4eb2d$var$i];
    $bfa7ffece2a4eb2d$var$revLookup[$bfa7ffece2a4eb2d$var$code.charCodeAt($bfa7ffece2a4eb2d$var$i)] = $bfa7ffece2a4eb2d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bfa7ffece2a4eb2d$var$revLookup["-".charCodeAt(0)] = 62;
$bfa7ffece2a4eb2d$var$revLookup["_".charCodeAt(0)] = 63;
function $bfa7ffece2a4eb2d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bfa7ffece2a4eb2d$var$byteLength(b64) {
    var lens = $bfa7ffece2a4eb2d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa7ffece2a4eb2d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa7ffece2a4eb2d$var$toByteArray(b64) {
    var tmp;
    var lens = $bfa7ffece2a4eb2d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bfa7ffece2a4eb2d$var$Arr($bfa7ffece2a4eb2d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i)] << 18 | $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i)] << 2 | $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i)] << 10 | $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bfa7ffece2a4eb2d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bfa7ffece2a4eb2d$var$tripletToBase64(num) {
    return $bfa7ffece2a4eb2d$var$lookup[num >> 18 & 0x3F] + $bfa7ffece2a4eb2d$var$lookup[num >> 12 & 0x3F] + $bfa7ffece2a4eb2d$var$lookup[num >> 6 & 0x3F] + $bfa7ffece2a4eb2d$var$lookup[num & 0x3F];
}
function $bfa7ffece2a4eb2d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bfa7ffece2a4eb2d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $bfa7ffece2a4eb2d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bfa7ffece2a4eb2d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bfa7ffece2a4eb2d$var$lookup[tmp >> 2] + $bfa7ffece2a4eb2d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bfa7ffece2a4eb2d$var$lookup[tmp >> 10] + $bfa7ffece2a4eb2d$var$lookup[tmp >> 4 & 0x3F] + $bfa7ffece2a4eb2d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("cbqcH", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $8dead6a67b1d63e6$export$aafa59e2e03f2942; }, function (v) { return $8dead6a67b1d63e6$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $8dead6a67b1d63e6$export$68d8715fc104d294; }, function (v) { return $8dead6a67b1d63e6$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $8dead6a67b1d63e6$export$aafa59e2e03f2942;
var $8dead6a67b1d63e6$export$68d8715fc104d294;
$8dead6a67b1d63e6$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$8dead6a67b1d63e6$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});

parcelRequire.register("iLTtJ", function(module, exports) {
var $daa7a6a728c34eb0$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $daa7a6a728c34eb0$var$toString.call(arr) == "[object Array]";
};

});


parcelRequire.register("7Fvv0", function(module, exports) {
"use strict";

});


parcelRequire.register("51nHm", function(module, exports) {

var $bcIJv = parcelRequire("bcIJv");
/**
 * @licstart The following is the entire license notice for the
 * Javascript code in this page
 *
 * Copyright 2021 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * Javascript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WorkerTask = exports.WorkerMessageHandler = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _pdf_manager = __w_pdfjs_require__(7);
                var _writer = __w_pdfjs_require__(71);
                var _is_node = __w_pdfjs_require__(4);
                var _message_handler = __w_pdfjs_require__(99);
                var _worker_stream = __w_pdfjs_require__(100);
                var _core_utils = __w_pdfjs_require__(9);
                class WorkerTask {
                    constructor(name){
                        this.name = name;
                        this.terminated = false;
                        this._capability = (0, _util.createPromiseCapability)();
                    }
                    get finished() {
                        return this._capability.promise;
                    }
                    finish() {
                        this._capability.resolve();
                    }
                    terminate() {
                        this.terminated = true;
                    }
                    ensureNotTerminated() {
                        if (this.terminated) throw new Error("Worker task was terminated");
                    }
                }
                exports.WorkerTask = WorkerTask;
                class WorkerMessageHandler {
                    static setup(handler, port) {
                        let testMessageProcessed = false;
                        handler.on("test", function wphSetupTest(data) {
                            if (testMessageProcessed) return;
                            testMessageProcessed = true;
                            if (!(data instanceof Uint8Array)) {
                                handler.send("test", null);
                                return;
                            }
                            const supportTransfers = data[0] === 255;
                            handler.postMessageTransfers = supportTransfers;
                            handler.send("test", {
                                supportTransfers: supportTransfers
                            });
                        });
                        handler.on("configure", function wphConfigure(data) {
                            (0, _util.setVerbosityLevel)(data.verbosity);
                        });
                        handler.on("GetDocRequest", function wphSetupDoc(data) {
                            return WorkerMessageHandler.createDocumentHandler(data, port);
                        });
                    }
                    static createDocumentHandler(docParams, port) {
                        let pdfManager;
                        let terminated = false;
                        let cancelXHRs = null;
                        const WorkerTasks = [];
                        const verbosity = (0, _util.getVerbosityLevel)();
                        const apiVersion = docParams.apiVersion;
                        const workerVersion = "2.10.377";
                        if (apiVersion !== workerVersion) throw new Error(`The API version "${apiVersion}" does not match ` + `the Worker version "${workerVersion}".`);
                        const enumerableProperties = [];
                        for(const property in [])enumerableProperties.push(property);
                        if (enumerableProperties.length) throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + enumerableProperties.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
                        if (typeof ReadableStream === "undefined") throw new Error("The browser/environment lacks native support for critical functionality used by the PDF.js library (e.g. `ReadableStream`); please use a `legacy`-build instead.");
                        const docId = docParams.docId;
                        const docBaseUrl = docParams.docBaseUrl;
                        const workerHandlerName = docParams.docId + "_worker";
                        let handler = new _message_handler.MessageHandler(workerHandlerName, docId, port);
                        handler.postMessageTransfers = docParams.postMessageTransfers;
                        function ensureNotTerminated() {
                            if (terminated) throw new Error("Worker was terminated");
                        }
                        function startWorkerTask(task) {
                            WorkerTasks.push(task);
                        }
                        function finishWorkerTask(task) {
                            task.finish();
                            const i = WorkerTasks.indexOf(task);
                            WorkerTasks.splice(i, 1);
                        }
                        async function loadDocument(recoveryMode) {
                            await pdfManager.ensureDoc("checkHeader");
                            await pdfManager.ensureDoc("parseStartXRef");
                            await pdfManager.ensureDoc("parse", [
                                recoveryMode
                            ]);
                            if (!recoveryMode) await pdfManager.ensureDoc("checkFirstPage");
                            const isPureXfa = await pdfManager.ensureDoc("isPureXfa");
                            if (isPureXfa) {
                                const task = new WorkerTask("loadXfaFonts");
                                startWorkerTask(task);
                                await Promise.all([
                                    pdfManager.loadXfaFonts(handler, task).catch((reason)=>{}).then(()=>finishWorkerTask(task)),
                                    pdfManager.loadXfaImages()
                                ]);
                            }
                            const [numPages, fingerprints] = await Promise.all([
                                pdfManager.ensureDoc("numPages"),
                                pdfManager.ensureDoc("fingerprints")
                            ]);
                            const htmlForXfa = isPureXfa ? await pdfManager.ensureDoc("htmlForXfa") : null;
                            return {
                                numPages: numPages,
                                fingerprints: fingerprints,
                                htmlForXfa: htmlForXfa
                            };
                        }
                        function getPdfManager(data, evaluatorOptions, enableXfa) {
                            const pdfManagerCapability = (0, _util.createPromiseCapability)();
                            let newPdfManager;
                            const source = data.source;
                            if (source.data) {
                                try {
                                    newPdfManager = new _pdf_manager.LocalPdfManager(docId, source.data, source.password, evaluatorOptions, enableXfa, docBaseUrl);
                                    pdfManagerCapability.resolve(newPdfManager);
                                } catch (ex) {
                                    pdfManagerCapability.reject(ex);
                                }
                                return pdfManagerCapability.promise;
                            }
                            let pdfStream, cachedChunks = [];
                            try {
                                pdfStream = new _worker_stream.PDFWorkerStream(handler);
                            } catch (ex) {
                                pdfManagerCapability.reject(ex);
                                return pdfManagerCapability.promise;
                            }
                            const fullRequest = pdfStream.getFullReader();
                            fullRequest.headersReady.then(function() {
                                if (!fullRequest.isRangeSupported) return;
                                const disableAutoFetch = source.disableAutoFetch || fullRequest.isStreamingSupported;
                                newPdfManager = new _pdf_manager.NetworkPdfManager(docId, pdfStream, {
                                    msgHandler: handler,
                                    password: source.password,
                                    length: fullRequest.contentLength,
                                    disableAutoFetch: disableAutoFetch,
                                    rangeChunkSize: source.rangeChunkSize
                                }, evaluatorOptions, enableXfa, docBaseUrl);
                                for(let i = 0; i < cachedChunks.length; i++)newPdfManager.sendProgressiveData(cachedChunks[i]);
                                cachedChunks = [];
                                pdfManagerCapability.resolve(newPdfManager);
                                cancelXHRs = null;
                            }).catch(function(reason) {
                                pdfManagerCapability.reject(reason);
                                cancelXHRs = null;
                            });
                            let loaded = 0;
                            const flushChunks = function() {
                                const pdfFile = (0, _util.arraysToBytes)(cachedChunks);
                                if (source.length && pdfFile.length !== source.length) (0, _util.warn)("reported HTTP length is different from actual");
                                try {
                                    newPdfManager = new _pdf_manager.LocalPdfManager(docId, pdfFile, source.password, evaluatorOptions, enableXfa, docBaseUrl);
                                    pdfManagerCapability.resolve(newPdfManager);
                                } catch (ex) {
                                    pdfManagerCapability.reject(ex);
                                }
                                cachedChunks = [];
                            };
                            const readPromise = new Promise(function(resolve, reject) {
                                const readChunk = function({ value: value , done: done  }) {
                                    try {
                                        ensureNotTerminated();
                                        if (done) {
                                            if (!newPdfManager) flushChunks();
                                            cancelXHRs = null;
                                            return;
                                        }
                                        loaded += (0, _util.arrayByteLength)(value);
                                        if (!fullRequest.isStreamingSupported) handler.send("DocProgress", {
                                            loaded: loaded,
                                            total: Math.max(loaded, fullRequest.contentLength || 0)
                                        });
                                        if (newPdfManager) newPdfManager.sendProgressiveData(value);
                                        else cachedChunks.push(value);
                                        fullRequest.read().then(readChunk, reject);
                                    } catch (e) {
                                        reject(e);
                                    }
                                };
                                fullRequest.read().then(readChunk, reject);
                            });
                            readPromise.catch(function(e) {
                                pdfManagerCapability.reject(e);
                                cancelXHRs = null;
                            });
                            cancelXHRs = function(reason) {
                                pdfStream.cancelAllRequests(reason);
                            };
                            return pdfManagerCapability.promise;
                        }
                        function setupDoc(data) {
                            function onSuccess(doc) {
                                ensureNotTerminated();
                                handler.send("GetDoc", {
                                    pdfInfo: doc
                                });
                            }
                            function onFailure(ex) {
                                ensureNotTerminated();
                                if (ex instanceof _util.PasswordException) {
                                    const task = new WorkerTask(`PasswordException: response ${ex.code}`);
                                    startWorkerTask(task);
                                    handler.sendWithPromise("PasswordRequest", ex).then(function({ password: password  }) {
                                        finishWorkerTask(task);
                                        pdfManager.updatePassword(password);
                                        pdfManagerReady();
                                    }).catch(function() {
                                        finishWorkerTask(task);
                                        handler.send("DocException", ex);
                                    });
                                } else if (ex instanceof _util.InvalidPDFException || ex instanceof _util.MissingPDFException || ex instanceof _util.UnexpectedResponseException || ex instanceof _util.UnknownErrorException) handler.send("DocException", ex);
                                else handler.send("DocException", new _util.UnknownErrorException(ex.message, ex.toString()));
                            }
                            function pdfManagerReady() {
                                ensureNotTerminated();
                                loadDocument(false).then(onSuccess, function(reason) {
                                    ensureNotTerminated();
                                    if (!(reason instanceof _core_utils.XRefParseException)) {
                                        onFailure(reason);
                                        return;
                                    }
                                    pdfManager.requestLoadedStream();
                                    pdfManager.onLoadedStream().then(function() {
                                        ensureNotTerminated();
                                        loadDocument(true).then(onSuccess, onFailure);
                                    });
                                });
                            }
                            ensureNotTerminated();
                            const evaluatorOptions = {
                                maxImageSize: data.maxImageSize,
                                disableFontFace: data.disableFontFace,
                                ignoreErrors: data.ignoreErrors,
                                isEvalSupported: data.isEvalSupported,
                                fontExtraProperties: data.fontExtraProperties,
                                useSystemFonts: data.useSystemFonts,
                                cMapUrl: data.cMapUrl,
                                standardFontDataUrl: data.standardFontDataUrl
                            };
                            getPdfManager(data, evaluatorOptions, data.enableXfa).then(function(newPdfManager) {
                                if (terminated) {
                                    newPdfManager.terminate(new _util.AbortException("Worker was terminated."));
                                    throw new Error("Worker was terminated");
                                }
                                pdfManager = newPdfManager;
                                pdfManager.onLoadedStream().then(function(stream) {
                                    handler.send("DataLoaded", {
                                        length: stream.bytes.byteLength
                                    });
                                });
                            }).then(pdfManagerReady, onFailure);
                        }
                        handler.on("GetPage", function wphSetupGetPage(data) {
                            return pdfManager.getPage(data.pageIndex).then(function(page) {
                                return Promise.all([
                                    pdfManager.ensure(page, "rotate"),
                                    pdfManager.ensure(page, "ref"),
                                    pdfManager.ensure(page, "userUnit"),
                                    pdfManager.ensure(page, "view")
                                ]).then(function([rotate, ref, userUnit, view]) {
                                    return {
                                        rotate: rotate,
                                        ref: ref,
                                        userUnit: userUnit,
                                        view: view
                                    };
                                });
                            });
                        });
                        handler.on("GetPageIndex", function wphSetupGetPageIndex({ ref: ref  }) {
                            const pageRef = _primitives.Ref.get(ref.num, ref.gen);
                            return pdfManager.ensureCatalog("getPageIndex", [
                                pageRef
                            ]);
                        });
                        handler.on("GetDestinations", function wphSetupGetDestinations(data) {
                            return pdfManager.ensureCatalog("destinations");
                        });
                        handler.on("GetDestination", function wphSetupGetDestination(data) {
                            return pdfManager.ensureCatalog("getDestination", [
                                data.id
                            ]);
                        });
                        handler.on("GetPageLabels", function wphSetupGetPageLabels(data) {
                            return pdfManager.ensureCatalog("pageLabels");
                        });
                        handler.on("GetPageLayout", function wphSetupGetPageLayout(data) {
                            return pdfManager.ensureCatalog("pageLayout");
                        });
                        handler.on("GetPageMode", function wphSetupGetPageMode(data) {
                            return pdfManager.ensureCatalog("pageMode");
                        });
                        handler.on("GetViewerPreferences", function(data) {
                            return pdfManager.ensureCatalog("viewerPreferences");
                        });
                        handler.on("GetOpenAction", function(data) {
                            return pdfManager.ensureCatalog("openAction");
                        });
                        handler.on("GetAttachments", function wphSetupGetAttachments(data) {
                            return pdfManager.ensureCatalog("attachments");
                        });
                        handler.on("GetJavaScript", function wphSetupGetJavaScript(data) {
                            return pdfManager.ensureCatalog("javaScript");
                        });
                        handler.on("GetDocJSActions", function wphSetupGetDocJSActions(data) {
                            return pdfManager.ensureCatalog("jsActions");
                        });
                        handler.on("GetPageJSActions", function({ pageIndex: pageIndex  }) {
                            return pdfManager.getPage(pageIndex).then(function(page) {
                                return pdfManager.ensure(page, "jsActions");
                            });
                        });
                        handler.on("GetOutline", function wphSetupGetOutline(data) {
                            return pdfManager.ensureCatalog("documentOutline");
                        });
                        handler.on("GetOptionalContentConfig", function(data) {
                            return pdfManager.ensureCatalog("optionalContentConfig");
                        });
                        handler.on("GetPermissions", function(data) {
                            return pdfManager.ensureCatalog("permissions");
                        });
                        handler.on("GetMetadata", function wphSetupGetMetadata(data) {
                            return Promise.all([
                                pdfManager.ensureDoc("documentInfo"),
                                pdfManager.ensureCatalog("metadata")
                            ]);
                        });
                        handler.on("GetMarkInfo", function wphSetupGetMarkInfo(data) {
                            return pdfManager.ensureCatalog("markInfo");
                        });
                        handler.on("GetData", function wphSetupGetData(data) {
                            pdfManager.requestLoadedStream();
                            return pdfManager.onLoadedStream().then(function(stream) {
                                return stream.bytes;
                            });
                        });
                        handler.on("GetStats", function wphSetupGetStats(data) {
                            return pdfManager.ensureXRef("stats");
                        });
                        handler.on("GetAnnotations", function({ pageIndex: pageIndex , intent: intent  }) {
                            return pdfManager.getPage(pageIndex).then(function(page) {
                                return page.getAnnotationsData(intent);
                            });
                        });
                        handler.on("GetFieldObjects", function(data) {
                            return pdfManager.ensureDoc("fieldObjects");
                        });
                        handler.on("HasJSActions", function(data) {
                            return pdfManager.ensureDoc("hasJSActions");
                        });
                        handler.on("GetCalculationOrderIds", function(data) {
                            return pdfManager.ensureDoc("calculationOrderIds");
                        });
                        handler.on("SaveDocument", function({ isPureXfa: isPureXfa , numPages: numPages , annotationStorage: annotationStorage , filename: filename  }) {
                            pdfManager.requestLoadedStream();
                            const promises = [
                                pdfManager.onLoadedStream(),
                                pdfManager.ensureCatalog("acroForm"),
                                pdfManager.ensureDoc("xref"),
                                pdfManager.ensureDoc("startXRef")
                            ];
                            if (isPureXfa) promises.push(pdfManager.serializeXfaData(annotationStorage));
                            else for(let pageIndex = 0; pageIndex < numPages; pageIndex++)promises.push(pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`Save: page ${pageIndex}`);
                                return page.save(handler, task, annotationStorage).finally(function() {
                                    finishWorkerTask(task);
                                });
                            }));
                            return Promise.all(promises).then(function([stream, acroForm, xref, startXRef, ...refs]) {
                                let newRefs = [];
                                let xfaData = null;
                                if (isPureXfa) {
                                    xfaData = refs[0];
                                    if (!xfaData) return stream.bytes;
                                } else {
                                    for (const ref of refs)newRefs = ref.filter((x)=>x !== null).reduce((a, b)=>a.concat(b), newRefs);
                                    if (newRefs.length === 0) return stream.bytes;
                                }
                                const xfa = acroForm instanceof _primitives.Dict && acroForm.get("XFA") || [];
                                let xfaDatasets = null;
                                if (Array.isArray(xfa)) {
                                    for(let i = 0, ii = xfa.length; i < ii; i += 2)if (xfa[i] === "datasets") xfaDatasets = xfa[i + 1];
                                } else (0, _util.warn)("Unsupported XFA type.");
                                let newXrefInfo = Object.create(null);
                                if (xref.trailer) {
                                    const infoObj = Object.create(null);
                                    const xrefInfo = xref.trailer.get("Info") || null;
                                    if (xrefInfo instanceof _primitives.Dict) xrefInfo.forEach((key, value)=>{
                                        if ((0, _util.isString)(key) && (0, _util.isString)(value)) infoObj[key] = (0, _util.stringToPDFString)(value);
                                    });
                                    newXrefInfo = {
                                        rootRef: xref.trailer.getRaw("Root") || null,
                                        encryptRef: xref.trailer.getRaw("Encrypt") || null,
                                        newRef: xref.getNewRef(),
                                        infoRef: xref.trailer.getRaw("Info") || null,
                                        info: infoObj,
                                        fileIds: xref.trailer.get("ID") || null,
                                        startXRef: startXRef,
                                        filename: filename
                                    };
                                }
                                xref.resetNewRef();
                                return (0, _writer.incrementalUpdate)({
                                    originalData: stream.bytes,
                                    xrefInfo: newXrefInfo,
                                    newRefs: newRefs,
                                    xref: xref,
                                    datasetsRef: xfaDatasets,
                                    xfaData: xfaData
                                });
                            });
                        });
                        handler.on("GetOperatorList", function wphSetupRenderPage(data, sink) {
                            const pageIndex = data.pageIndex;
                            pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask(`GetOperatorList: page ${pageIndex}`);
                                startWorkerTask(task);
                                const start = verbosity >= _util.VerbosityLevel.INFOS ? Date.now() : 0;
                                page.getOperatorList({
                                    handler: handler,
                                    sink: sink,
                                    task: task,
                                    intent: data.intent,
                                    renderInteractiveForms: data.renderInteractiveForms,
                                    annotationStorage: data.annotationStorage
                                }).then(function(operatorListInfo) {
                                    finishWorkerTask(task);
                                    if (start) (0, _util.info)(`page=${pageIndex + 1} - getOperatorList: time=` + `${Date.now() - start}ms, len=${operatorListInfo.length}`);
                                    sink.close();
                                }, function(reason) {
                                    finishWorkerTask(task);
                                    if (task.terminated) return;
                                    handler.send("UnsupportedFeature", {
                                        featureId: _util.UNSUPPORTED_FEATURES.errorOperatorList
                                    });
                                    sink.error(reason);
                                });
                            });
                        });
                        handler.on("GetTextContent", function wphExtractText(data, sink) {
                            const pageIndex = data.pageIndex;
                            sink.onPull = function(desiredSize) {};
                            sink.onCancel = function(reason) {};
                            pdfManager.getPage(pageIndex).then(function(page) {
                                const task = new WorkerTask("GetTextContent: page " + pageIndex);
                                startWorkerTask(task);
                                const start = verbosity >= _util.VerbosityLevel.INFOS ? Date.now() : 0;
                                page.extractTextContent({
                                    handler: handler,
                                    task: task,
                                    sink: sink,
                                    normalizeWhitespace: data.normalizeWhitespace,
                                    includeMarkedContent: data.includeMarkedContent,
                                    combineTextItems: data.combineTextItems
                                }).then(function() {
                                    finishWorkerTask(task);
                                    if (start) (0, _util.info)(`page=${pageIndex + 1} - getTextContent: time=` + `${Date.now() - start}ms`);
                                    sink.close();
                                }, function(reason) {
                                    finishWorkerTask(task);
                                    if (task.terminated) return;
                                    sink.error(reason);
                                });
                            });
                        });
                        handler.on("GetStructTree", function wphGetStructTree(data) {
                            return pdfManager.getPage(data.pageIndex).then(function(page) {
                                return pdfManager.ensure(page, "getStructTree");
                            });
                        });
                        handler.on("FontFallback", function(data) {
                            return pdfManager.fontFallback(data.id, handler);
                        });
                        handler.on("Cleanup", function wphCleanup(data) {
                            return pdfManager.cleanup(true);
                        });
                        handler.on("Terminate", function wphTerminate(data) {
                            terminated = true;
                            const waitOn = [];
                            if (pdfManager) {
                                pdfManager.terminate(new _util.AbortException("Worker was terminated."));
                                const cleanupPromise = pdfManager.cleanup();
                                waitOn.push(cleanupPromise);
                                pdfManager = null;
                            } else (0, _primitives.clearPrimitiveCaches)();
                            if (cancelXHRs) cancelXHRs(new _util.AbortException("Worker was terminated."));
                            for (const task of WorkerTasks){
                                waitOn.push(task.finished);
                                task.terminate();
                            }
                            return Promise.all(waitOn).then(function() {
                                handler.destroy();
                                handler = null;
                            });
                        });
                        handler.on("Ready", function wphReady(data) {
                            setupDoc(docParams);
                            docParams = null;
                        });
                        return workerHandlerName;
                    }
                    static initializeFromPort(port) {
                        const handler = new _message_handler.MessageHandler("worker", "main", port);
                        WorkerMessageHandler.setup(handler, port);
                        handler.send("ready", null);
                    }
                }
                exports.WorkerMessageHandler = WorkerMessageHandler;
                function isMessagePort(maybePort) {
                    return typeof maybePort.postMessage === "function" && "onmessage" in maybePort;
                }
                if (typeof window === "undefined" && !_is_node.isNodeJS && typeof self !== "undefined" && isMessagePort(self)) WorkerMessageHandler.initializeFromPort(self);
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.arrayByteLength = arrayByteLength;
                exports.arraysToBytes = arraysToBytes;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createObjectURL = createObjectURL;
                exports.createPromiseCapability = createPromiseCapability;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.escapeString = escapeString;
                exports.getModificationDate = getModificationDate;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isAscii = isAscii;
                exports.isBool = isBool;
                exports.isNum = isNum;
                exports.isSameOrigin = isSameOrigin;
                exports.isString = isString;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.removeNullCharacters = removeNullCharacters;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF16BEString = stringToUTF16BEString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                exports.VerbosityLevel = exports.Util = exports.UNSUPPORTED_FEATURES = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.StreamType = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.IsLittleEndianCached = exports.IsEvalSupportedCached = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FontType = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.AnnotationType = exports.AnnotationStateModelType = exports.AnnotationReviewState = exports.AnnotationReplyType = exports.AnnotationMarkedState = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                __w_pdfjs_require__(3);
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationStateModelType = {
                    MARKED: "Marked",
                    REVIEW: "Review"
                };
                exports.AnnotationStateModelType = AnnotationStateModelType;
                const AnnotationMarkedState = {
                    MARKED: "Marked",
                    UNMARKED: "Unmarked"
                };
                exports.AnnotationMarkedState = AnnotationMarkedState;
                const AnnotationReviewState = {
                    ACCEPTED: "Accepted",
                    REJECTED: "Rejected",
                    CANCELLED: "Cancelled",
                    COMPLETED: "Completed",
                    NONE: "None"
                };
                exports.AnnotationReviewState = AnnotationReviewState;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const StreamType = {
                    UNKNOWN: "UNKNOWN",
                    FLATE: "FLATE",
                    LZW: "LZW",
                    DCT: "DCT",
                    JPX: "JPX",
                    JBIG: "JBIG",
                    A85: "A85",
                    AHX: "AHX",
                    CCF: "CCF",
                    RLX: "RLX"
                };
                exports.StreamType = StreamType;
                const FontType = {
                    UNKNOWN: "UNKNOWN",
                    TYPE1: "TYPE1",
                    TYPE1STANDARD: "TYPE1STANDARD",
                    TYPE1C: "TYPE1C",
                    CIDFONTTYPE0: "CIDFONTTYPE0",
                    CIDFONTTYPE0C: "CIDFONTTYPE0C",
                    TRUETYPE: "TRUETYPE",
                    CIDFONTTYPE2: "CIDFONTTYPE2",
                    TYPE3: "TYPE3",
                    OPENTYPE: "OPENTYPE",
                    TYPE0: "TYPE0",
                    MMTYPE1: "MMTYPE1"
                };
                exports.FontType = FontType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1,
                    STREAM: 2
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotations: 78,
                    endAnnotations: 79,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintJpegXObject: 82,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const UNSUPPORTED_FEATURES = {
                    unknown: "unknown",
                    forms: "forms",
                    javaScript: "javaScript",
                    signatures: "signatures",
                    smask: "smask",
                    shadingPattern: "shadingPattern",
                    font: "font",
                    errorTilingPattern: "errorTilingPattern",
                    errorExtGState: "errorExtGState",
                    errorXObject: "errorXObject",
                    errorFontLoadType3: "errorFontLoadType3",
                    errorFontState: "errorFontState",
                    errorFontMissing: "errorFontMissing",
                    errorFontTranslate: "errorFontTranslate",
                    errorColorSpace: "errorColorSpace",
                    errorOperatorList: "errorOperatorList",
                    errorFontToUnicode: "errorFontToUnicode",
                    errorFontLoadNative: "errorFontLoadNative",
                    errorFontBuildPath: "errorFontBuildPath",
                    errorFontGetPath: "errorFontGetPath",
                    errorMarkedContent: "errorMarkedContent"
                };
                exports.UNSUPPORTED_FEATURES = UNSUPPORTED_FEATURES;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function isSameOrigin(baseUrl, otherUrl) {
                    let base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch (e) {
                        return false;
                    }
                    const other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                }
                function _isValidProtocol(url) {
                    if (!url) return false;
                    switch(url.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl) {
                    if (!url) return null;
                    try {
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch (ex) {}
                    return null;
                }
                function shadow(obj, prop, value) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = this.constructor.name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg);
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg);
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg);
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                }
                exports.AbortException = AbortException;
                const NullCharactersRegExp = /\x00/g;
                function removeNullCharacters(str) {
                    if (typeof str !== "string") {
                        warn("The argument for removeNullCharacters must be a string.");
                        return str;
                    }
                    return str.replace(NullCharactersRegExp, "");
                }
                function bytesToString(bytes) {
                    assert(bytes !== null && typeof bytes === "object" && bytes.length !== undefined, "Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    assert(typeof str === "string", "Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function arrayByteLength(arr) {
                    if (arr.length !== undefined) return arr.length;
                    assert(arr.byteLength !== undefined, "arrayByteLength - invalid argument.");
                    return arr.byteLength;
                }
                function arraysToBytes(arr) {
                    const length = arr.length;
                    if (length === 1 && arr[0] instanceof Uint8Array) return arr[0];
                    let resultLength = 0;
                    for(let i = 0; i < length; i++)resultLength += arrayByteLength(arr[i]);
                    let pos = 0;
                    const data = new Uint8Array(resultLength);
                    for(let i = 0; i < length; i++){
                        let item = arr[i];
                        if (!(item instanceof Uint8Array)) {
                            if (typeof item === "string") item = stringToBytes(item);
                            else item = new Uint8Array(item);
                        }
                        const itemLength = item.byteLength;
                        data.set(item, pos);
                        pos += itemLength;
                    }
                    return data;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                const IsLittleEndianCached = {
                    get value () {
                        return shadow(this, "value", isLittleEndian());
                    }
                };
                exports.IsLittleEndianCached = IsLittleEndianCached;
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                const IsEvalSupportedCached = {
                    get value () {
                        return shadow(this, "value", isEvalSupported());
                    }
                };
                exports.IsEvalSupportedCached = IsEvalSupportedCached;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = Util.applyTransform(r, m);
                        const p2 = Util.applyTransform(r.slice(2, 4), m);
                        const p3 = Util.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = Util.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static apply3dTransform(m, v) {
                        return [
                            m[0] * v[0] + m[1] * v[1] + m[2] * v[2],
                            m[3] * v[0] + m[4] * v[1] + m[5] * v[2],
                            m[6] * v[0] + m[7] * v[1] + m[8] * v[2]
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        function compare(a, b) {
                            return a - b;
                        }
                        const orderedX = [
                            rect1[0],
                            rect1[2],
                            rect2[0],
                            rect2[2]
                        ].sort(compare);
                        const orderedY = [
                            rect1[1],
                            rect1[3],
                            rect2[1],
                            rect2[3]
                        ].sort(compare);
                        const result = [];
                        rect1 = Util.normalizeRect(rect1);
                        rect2 = Util.normalizeRect(rect2);
                        if (orderedX[0] === rect1[0] && orderedX[1] === rect2[0] || orderedX[0] === rect2[0] && orderedX[1] === rect1[0]) {
                            result[0] = orderedX[1];
                            result[2] = orderedX[2];
                        } else return null;
                        if (orderedY[0] === rect1[1] && orderedY[1] === rect2[1] || orderedY[0] === rect2[1] && orderedY[1] === rect1[1]) {
                            result[1] = orderedY[1];
                            result[3] = orderedY[2];
                        } else return null;
                        return result;
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    const length = str.length, strBuf = [];
                    if (str[0] === "\xfe" && str[1] === "\xff") for(let i = 2; i < length; i += 2)strBuf.push(String.fromCharCode(str.charCodeAt(i) << 8 | str.charCodeAt(i + 1)));
                    else if (str[0] === "\xff" && str[1] === "\xfe") for(let i = 2; i < length; i += 2)strBuf.push(String.fromCharCode(str.charCodeAt(i + 1) << 8 | str.charCodeAt(i)));
                    else for(let i = 0; i < length; ++i){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function escapeString(str) {
                    return str.replace(/([()\\\n\r])/g, (match)=>{
                        if (match === "\n") return "\\n";
                        else if (match === "\r") return "\\r";
                        return `\\${match}`;
                    });
                }
                function isAscii(str) {
                    return /^[\x00-\x7F]*$/.test(str);
                }
                function stringToUTF16BEString(str) {
                    const buf = [
                        "\xfe\xff"
                    ];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        buf.push(String.fromCharCode(char >> 8 & 0xff), String.fromCharCode(char & 0xff));
                    }
                    return buf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isBool(v) {
                    return typeof v === "boolean";
                }
                function isNum(v) {
                    return typeof v === "number";
                }
                function isString(v) {
                    return typeof v === "string";
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && v !== null && v.byteLength !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                function createPromiseCapability() {
                    const capability = Object.create(null);
                    let isSettled = false;
                    Object.defineProperty(capability, "settled", {
                        get () {
                            return isSettled;
                        }
                    });
                    capability.promise = new Promise(function(resolve, reject) {
                        capability.resolve = function(data) {
                            isSettled = true;
                            resolve(data);
                        };
                        capability.reject = function(reason) {
                            isSettled = true;
                            reject(reason);
                        };
                    });
                    return capability;
                }
                function createObjectURL(data, contentType = "", forceDataSchema = false) {
                    if (URL.createObjectURL && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer = `data:${contentType};base64,`;
                    for(let i = 0, ii = data.length; i < ii; i += 3){
                        const b1 = data[i] & 0xff;
                        const b2 = data[i + 1] & 0xff;
                        const b3 = data[i + 2] & 0xff;
                        const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                }
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__)=>{
                var _is_node = __w_pdfjs_require__(4);
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.isNodeJS = void 0;
                const isNodeJS = typeof $bcIJv === "object" && $bcIJv + "" === "[object process]" && !$bcIJv.versions.nw && !($bcIJv.versions.electron && $bcIJv.type && $bcIJv.type !== "browser");
                exports.isNodeJS = isNodeJS;
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearPrimitiveCaches = clearPrimitiveCaches;
                exports.isCmd = isCmd;
                exports.isDict = isDict;
                exports.isEOF = isEOF;
                exports.isName = isName;
                exports.isRef = isRef;
                exports.isRefsEqual = isRefsEqual;
                exports.isStream = isStream;
                exports.RefSetCache = exports.RefSet = exports.Ref = exports.Name = exports.EOF = exports.Dict = exports.Cmd = void 0;
                var _util = __w_pdfjs_require__(2);
                var _base_stream = __w_pdfjs_require__(6);
                const EOF = {};
                exports.EOF = EOF;
                const Name = function NameClosure() {
                    let nameCache = Object.create(null);
                    class Name {
                        constructor(name){
                            this.name = name;
                        }
                        static get(name) {
                            const nameValue = nameCache[name];
                            return nameValue ? nameValue : nameCache[name] = new Name(name);
                        }
                        static _clearCache() {
                            nameCache = Object.create(null);
                        }
                    }
                    return Name;
                }();
                exports.Name = Name;
                const Cmd = function CmdClosure() {
                    let cmdCache = Object.create(null);
                    class Cmd {
                        constructor(cmd){
                            this.cmd = cmd;
                        }
                        static get(cmd) {
                            const cmdValue = cmdCache[cmd];
                            return cmdValue ? cmdValue : cmdCache[cmd] = new Cmd(cmd);
                        }
                        static _clearCache() {
                            cmdCache = Object.create(null);
                        }
                    }
                    return Cmd;
                }();
                exports.Cmd = Cmd;
                const nonSerializable = function nonSerializableClosure() {
                    return nonSerializable;
                };
                class Dict {
                    constructor(xref = null){
                        this._map = Object.create(null);
                        this.xref = xref;
                        this.objId = null;
                        this.suppressEncryption = false;
                        this.__nonSerializable__ = nonSerializable;
                    }
                    assignXref(newXref) {
                        this.xref = newXref;
                    }
                    get size() {
                        return Object.keys(this._map).length;
                    }
                    get(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) return this.xref.fetch(value, this.suppressEncryption);
                        return value;
                    }
                    async getAsync(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) return this.xref.fetchAsync(value, this.suppressEncryption);
                        return value;
                    }
                    getArray(key1, key2, key3) {
                        let value = this._map[key1];
                        if (value === undefined && key2 !== undefined) {
                            value = this._map[key2];
                            if (value === undefined && key3 !== undefined) value = this._map[key3];
                        }
                        if (value instanceof Ref && this.xref) value = this.xref.fetch(value, this.suppressEncryption);
                        if (Array.isArray(value)) {
                            value = value.slice();
                            for(let i = 0, ii = value.length; i < ii; i++)if (value[i] instanceof Ref && this.xref) value[i] = this.xref.fetch(value[i], this.suppressEncryption);
                        }
                        return value;
                    }
                    getRaw(key) {
                        return this._map[key];
                    }
                    getKeys() {
                        return Object.keys(this._map);
                    }
                    getRawValues() {
                        return Object.values(this._map);
                    }
                    set(key, value) {
                        this._map[key] = value;
                    }
                    has(key) {
                        return this._map[key] !== undefined;
                    }
                    forEach(callback) {
                        for(const key in this._map)callback(key, this.get(key));
                    }
                    static get empty() {
                        const emptyDict = new Dict(null);
                        emptyDict.set = (key, value)=>{
                            (0, _util.unreachable)("Should not call `set` on the empty dictionary.");
                        };
                        return (0, _util.shadow)(this, "empty", emptyDict);
                    }
                    static merge({ xref: xref , dictArray: dictArray , mergeSubDicts: mergeSubDicts = false  }) {
                        const mergedDict = new Dict(xref), properties = new Map();
                        for (const dict of dictArray){
                            if (!(dict instanceof Dict)) continue;
                            for (const [key, value] of Object.entries(dict._map)){
                                let property = properties.get(key);
                                if (property === undefined) {
                                    property = [];
                                    properties.set(key, property);
                                } else if (!mergeSubDicts) continue;
                                property.push(value);
                            }
                        }
                        for (const [name, values] of properties){
                            if (values.length === 1 || !(values[0] instanceof Dict)) {
                                mergedDict._map[name] = values[0];
                                continue;
                            }
                            const subDict = new Dict(xref);
                            for (const dict of values){
                                if (!(dict instanceof Dict)) continue;
                                for (const [key, value] of Object.entries(dict._map))if (subDict._map[key] === undefined) subDict._map[key] = value;
                            }
                            if (subDict.size > 0) mergedDict._map[name] = subDict;
                        }
                        properties.clear();
                        return mergedDict.size > 0 ? mergedDict : Dict.empty;
                    }
                }
                exports.Dict = Dict;
                const Ref = function RefClosure() {
                    let refCache = Object.create(null);
                    class Ref {
                        constructor(num, gen){
                            this.num = num;
                            this.gen = gen;
                        }
                        toString() {
                            if (this.gen === 0) return `${this.num}R`;
                            return `${this.num}R${this.gen}`;
                        }
                        static get(num, gen) {
                            const key = gen === 0 ? `${num}R` : `${num}R${gen}`;
                            const refValue = refCache[key];
                            return refValue ? refValue : refCache[key] = new Ref(num, gen);
                        }
                        static _clearCache() {
                            refCache = Object.create(null);
                        }
                    }
                    return Ref;
                }();
                exports.Ref = Ref;
                class RefSet {
                    constructor(parent = null){
                        this._set = new Set(parent && parent._set);
                    }
                    has(ref) {
                        return this._set.has(ref.toString());
                    }
                    put(ref) {
                        this._set.add(ref.toString());
                    }
                    remove(ref) {
                        this._set.delete(ref.toString());
                    }
                    forEach(callback) {
                        for (const ref of this._set.values())callback(ref);
                    }
                    clear() {
                        this._set.clear();
                    }
                }
                exports.RefSet = RefSet;
                class RefSetCache {
                    constructor(){
                        this._map = new Map();
                    }
                    get size() {
                        return this._map.size;
                    }
                    get(ref) {
                        return this._map.get(ref.toString());
                    }
                    has(ref) {
                        return this._map.has(ref.toString());
                    }
                    put(ref, obj) {
                        this._map.set(ref.toString(), obj);
                    }
                    putAlias(ref, aliasRef) {
                        this._map.set(ref.toString(), this.get(aliasRef));
                    }
                    forEach(callback) {
                        for (const value of this._map.values())callback(value);
                    }
                    clear() {
                        this._map.clear();
                    }
                }
                exports.RefSetCache = RefSetCache;
                function isEOF(v) {
                    return v === EOF;
                }
                function isName(v, name) {
                    return v instanceof Name && (name === undefined || v.name === name);
                }
                function isCmd(v, cmd) {
                    return v instanceof Cmd && (cmd === undefined || v.cmd === cmd);
                }
                function isDict(v, type) {
                    return v instanceof Dict && (type === undefined || isName(v.get("Type"), type));
                }
                function isRef(v) {
                    return v instanceof Ref;
                }
                function isRefsEqual(v1, v2) {
                    return v1.num === v2.num && v1.gen === v2.gen;
                }
                function isStream(v) {
                    return v instanceof _base_stream.BaseStream;
                }
                function clearPrimitiveCaches() {
                    Cmd._clearCache();
                    Name._clearCache();
                    Ref._clearCache();
                }
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStream = void 0;
                var _util = __w_pdfjs_require__(2);
                class BaseStream {
                    constructor(){
                        if (this.constructor === BaseStream) (0, _util.unreachable)("Cannot initialize BaseStream.");
                    }
                    get length() {
                        (0, _util.unreachable)("Abstract getter `length` accessed");
                    }
                    get isEmpty() {
                        (0, _util.unreachable)("Abstract getter `isEmpty` accessed");
                    }
                    get isDataLoaded() {
                        return (0, _util.shadow)(this, "isDataLoaded", true);
                    }
                    getByte() {
                        (0, _util.unreachable)("Abstract method `getByte` called");
                    }
                    getBytes(length, forceClamped = false) {
                        (0, _util.unreachable)("Abstract method `getBytes` called");
                    }
                    peekByte() {
                        const peekedByte = this.getByte();
                        if (peekedByte !== -1) this.pos--;
                        return peekedByte;
                    }
                    peekBytes(length, forceClamped = false) {
                        const bytes = this.getBytes(length, forceClamped);
                        this.pos -= bytes.length;
                        return bytes;
                    }
                    getUint16() {
                        const b0 = this.getByte();
                        const b1 = this.getByte();
                        if (b0 === -1 || b1 === -1) return -1;
                        return (b0 << 8) + b1;
                    }
                    getInt32() {
                        const b0 = this.getByte();
                        const b1 = this.getByte();
                        const b2 = this.getByte();
                        const b3 = this.getByte();
                        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
                    }
                    getByteRange(begin, end) {
                        (0, _util.unreachable)("Abstract method `getByteRange` called");
                    }
                    getString(length) {
                        return (0, _util.bytesToString)(this.getBytes(length, false));
                    }
                    skip(n) {
                        this.pos += n || 1;
                    }
                    reset() {
                        (0, _util.unreachable)("Abstract method `reset` called");
                    }
                    moveStart() {
                        (0, _util.unreachable)("Abstract method `moveStart` called");
                    }
                    makeSubStream(start, length, dict = null) {
                        (0, _util.unreachable)("Abstract method `makeSubStream` called");
                    }
                    getBaseStreams() {
                        return null;
                    }
                }
                exports.BaseStream = BaseStream;
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NetworkPdfManager = exports.LocalPdfManager = void 0;
                var _util = __w_pdfjs_require__(2);
                var _chunked_stream = __w_pdfjs_require__(8);
                var _core_utils = __w_pdfjs_require__(9);
                var _document = __w_pdfjs_require__(11);
                var _stream = __w_pdfjs_require__(10);
                function parseDocBaseUrl(url) {
                    if (url) {
                        const absoluteUrl = (0, _util.createValidAbsoluteUrl)(url);
                        if (absoluteUrl) return absoluteUrl.href;
                        (0, _util.warn)(`Invalid absolute docBaseUrl: "${url}".`);
                    }
                    return null;
                }
                class BasePdfManager {
                    constructor(){
                        if (this.constructor === BasePdfManager) (0, _util.unreachable)("Cannot initialize BasePdfManager.");
                    }
                    get docId() {
                        return this._docId;
                    }
                    get password() {
                        return this._password;
                    }
                    get docBaseUrl() {
                        return this._docBaseUrl;
                    }
                    onLoadedStream() {
                        (0, _util.unreachable)("Abstract method `onLoadedStream` called");
                    }
                    ensureDoc(prop, args) {
                        return this.ensure(this.pdfDocument, prop, args);
                    }
                    ensureXRef(prop, args) {
                        return this.ensure(this.pdfDocument.xref, prop, args);
                    }
                    ensureCatalog(prop, args) {
                        return this.ensure(this.pdfDocument.catalog, prop, args);
                    }
                    getPage(pageIndex) {
                        return this.pdfDocument.getPage(pageIndex);
                    }
                    fontFallback(id, handler) {
                        return this.pdfDocument.fontFallback(id, handler);
                    }
                    loadXfaFonts(handler, task) {
                        return this.pdfDocument.loadXfaFonts(handler, task);
                    }
                    loadXfaImages() {
                        return this.pdfDocument.loadXfaImages();
                    }
                    serializeXfaData(annotationStorage) {
                        return this.pdfDocument.serializeXfaData(annotationStorage);
                    }
                    cleanup(manuallyTriggered = false) {
                        return this.pdfDocument.cleanup(manuallyTriggered);
                    }
                    async ensure(obj, prop, args) {
                        (0, _util.unreachable)("Abstract method `ensure` called");
                    }
                    requestRange(begin, end) {
                        (0, _util.unreachable)("Abstract method `requestRange` called");
                    }
                    requestLoadedStream() {
                        (0, _util.unreachable)("Abstract method `requestLoadedStream` called");
                    }
                    sendProgressiveData(chunk) {
                        (0, _util.unreachable)("Abstract method `sendProgressiveData` called");
                    }
                    updatePassword(password) {
                        this._password = password;
                    }
                    terminate(reason) {
                        (0, _util.unreachable)("Abstract method `terminate` called");
                    }
                }
                class LocalPdfManager extends BasePdfManager {
                    constructor(docId, data, password, evaluatorOptions, enableXfa, docBaseUrl){
                        super();
                        this._docId = docId;
                        this._password = password;
                        this._docBaseUrl = parseDocBaseUrl(docBaseUrl);
                        this.evaluatorOptions = evaluatorOptions;
                        this.enableXfa = enableXfa;
                        const stream = new _stream.Stream(data);
                        this.pdfDocument = new _document.PDFDocument(this, stream);
                        this._loadedStreamPromise = Promise.resolve(stream);
                    }
                    async ensure(obj, prop, args) {
                        const value = obj[prop];
                        if (typeof value === "function") return value.apply(obj, args);
                        return value;
                    }
                    requestRange(begin, end) {
                        return Promise.resolve();
                    }
                    requestLoadedStream() {}
                    onLoadedStream() {
                        return this._loadedStreamPromise;
                    }
                    terminate(reason) {}
                }
                exports.LocalPdfManager = LocalPdfManager;
                class NetworkPdfManager extends BasePdfManager {
                    constructor(docId, pdfNetworkStream, args, evaluatorOptions, enableXfa, docBaseUrl){
                        super();
                        this._docId = docId;
                        this._password = args.password;
                        this._docBaseUrl = parseDocBaseUrl(docBaseUrl);
                        this.msgHandler = args.msgHandler;
                        this.evaluatorOptions = evaluatorOptions;
                        this.enableXfa = enableXfa;
                        this.streamManager = new _chunked_stream.ChunkedStreamManager(pdfNetworkStream, {
                            msgHandler: args.msgHandler,
                            length: args.length,
                            disableAutoFetch: args.disableAutoFetch,
                            rangeChunkSize: args.rangeChunkSize
                        });
                        this.pdfDocument = new _document.PDFDocument(this, this.streamManager.getStream());
                    }
                    async ensure(obj, prop, args) {
                        try {
                            const value = obj[prop];
                            if (typeof value === "function") return value.apply(obj, args);
                            return value;
                        } catch (ex) {
                            if (!(ex instanceof _core_utils.MissingDataException)) throw ex;
                            await this.requestRange(ex.begin, ex.end);
                            return this.ensure(obj, prop, args);
                        }
                    }
                    requestRange(begin, end) {
                        return this.streamManager.requestRange(begin, end);
                    }
                    requestLoadedStream() {
                        this.streamManager.requestAllChunks();
                    }
                    sendProgressiveData(chunk) {
                        this.streamManager.onReceiveData({
                            chunk: chunk
                        });
                    }
                    onLoadedStream() {
                        return this.streamManager.onLoadedStream();
                    }
                    terminate(reason) {
                        this.streamManager.abort(reason);
                    }
                }
                exports.NetworkPdfManager = NetworkPdfManager;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ChunkedStreamManager = exports.ChunkedStream = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(10);
                class ChunkedStream extends _stream.Stream {
                    constructor(length, chunkSize, manager){
                        super(new Uint8Array(length), 0, length, null);
                        this.chunkSize = chunkSize;
                        this._loadedChunks = new Set();
                        this.numChunks = Math.ceil(length / chunkSize);
                        this.manager = manager;
                        this.progressiveDataLength = 0;
                        this.lastSuccessfulEnsureByteChunk = -1;
                    }
                    getMissingChunks() {
                        const chunks = [];
                        for(let chunk = 0, n = this.numChunks; chunk < n; ++chunk)if (!this._loadedChunks.has(chunk)) chunks.push(chunk);
                        return chunks;
                    }
                    get numChunksLoaded() {
                        return this._loadedChunks.size;
                    }
                    get isDataLoaded() {
                        return this.numChunksLoaded === this.numChunks;
                    }
                    onReceiveData(begin, chunk) {
                        const chunkSize = this.chunkSize;
                        if (begin % chunkSize !== 0) throw new Error(`Bad begin offset: ${begin}`);
                        const end = begin + chunk.byteLength;
                        if (end % chunkSize !== 0 && end !== this.bytes.length) throw new Error(`Bad end offset: ${end}`);
                        this.bytes.set(new Uint8Array(chunk), begin);
                        const beginChunk = Math.floor(begin / chunkSize);
                        const endChunk = Math.floor((end - 1) / chunkSize) + 1;
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk)this._loadedChunks.add(curChunk);
                    }
                    onReceiveProgressiveData(data) {
                        let position = this.progressiveDataLength;
                        const beginChunk = Math.floor(position / this.chunkSize);
                        this.bytes.set(new Uint8Array(data), position);
                        position += data.byteLength;
                        this.progressiveDataLength = position;
                        const endChunk = position >= this.end ? this.numChunks : Math.floor(position / this.chunkSize);
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk)this._loadedChunks.add(curChunk);
                    }
                    ensureByte(pos) {
                        if (pos < this.progressiveDataLength) return;
                        const chunk = Math.floor(pos / this.chunkSize);
                        if (chunk === this.lastSuccessfulEnsureByteChunk) return;
                        if (!this._loadedChunks.has(chunk)) throw new _core_utils.MissingDataException(pos, pos + 1);
                        this.lastSuccessfulEnsureByteChunk = chunk;
                    }
                    ensureRange(begin, end) {
                        if (begin >= end) return;
                        if (end <= this.progressiveDataLength) return;
                        const chunkSize = this.chunkSize;
                        const beginChunk = Math.floor(begin / chunkSize);
                        const endChunk = Math.floor((end - 1) / chunkSize) + 1;
                        for(let chunk = beginChunk; chunk < endChunk; ++chunk){
                            if (!this._loadedChunks.has(chunk)) throw new _core_utils.MissingDataException(begin, end);
                        }
                    }
                    nextEmptyChunk(beginChunk) {
                        const numChunks = this.numChunks;
                        for(let i = 0; i < numChunks; ++i){
                            const chunk = (beginChunk + i) % numChunks;
                            if (!this._loadedChunks.has(chunk)) return chunk;
                        }
                        return null;
                    }
                    hasChunk(chunk) {
                        return this._loadedChunks.has(chunk);
                    }
                    getByte() {
                        const pos = this.pos;
                        if (pos >= this.end) return -1;
                        if (pos >= this.progressiveDataLength) this.ensureByte(pos);
                        return this.bytes[this.pos++];
                    }
                    getBytes(length, forceClamped = false) {
                        const bytes = this.bytes;
                        const pos = this.pos;
                        const strEnd = this.end;
                        if (!length) {
                            if (strEnd > this.progressiveDataLength) this.ensureRange(pos, strEnd);
                            const subarray = bytes.subarray(pos, strEnd);
                            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
                        }
                        let end = pos + length;
                        if (end > strEnd) end = strEnd;
                        if (end > this.progressiveDataLength) this.ensureRange(pos, end);
                        this.pos = end;
                        const subarray = bytes.subarray(pos, end);
                        return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
                    }
                    getByteRange(begin, end) {
                        if (begin < 0) begin = 0;
                        if (end > this.end) end = this.end;
                        if (end > this.progressiveDataLength) this.ensureRange(begin, end);
                        return this.bytes.subarray(begin, end);
                    }
                    makeSubStream(start, length, dict = null) {
                        if (length) {
                            if (start + length > this.progressiveDataLength) this.ensureRange(start, start + length);
                        } else if (start >= this.progressiveDataLength) this.ensureByte(start);
                        function ChunkedStreamSubstream() {}
                        ChunkedStreamSubstream.prototype = Object.create(this);
                        ChunkedStreamSubstream.prototype.getMissingChunks = function() {
                            const chunkSize = this.chunkSize;
                            const beginChunk = Math.floor(this.start / chunkSize);
                            const endChunk = Math.floor((this.end - 1) / chunkSize) + 1;
                            const missingChunks = [];
                            for(let chunk = beginChunk; chunk < endChunk; ++chunk)if (!this._loadedChunks.has(chunk)) missingChunks.push(chunk);
                            return missingChunks;
                        };
                        Object.defineProperty(ChunkedStreamSubstream.prototype, "isDataLoaded", {
                            get () {
                                if (this.numChunksLoaded === this.numChunks) return true;
                                return this.getMissingChunks().length === 0;
                            },
                            configurable: true
                        });
                        const subStream = new ChunkedStreamSubstream();
                        subStream.pos = subStream.start = start;
                        subStream.end = start + length || this.end;
                        subStream.dict = dict;
                        return subStream;
                    }
                    getBaseStreams() {
                        return [
                            this
                        ];
                    }
                }
                exports.ChunkedStream = ChunkedStream;
                class ChunkedStreamManager {
                    constructor(pdfNetworkStream, args){
                        this.length = args.length;
                        this.chunkSize = args.rangeChunkSize;
                        this.stream = new ChunkedStream(this.length, this.chunkSize, this);
                        this.pdfNetworkStream = pdfNetworkStream;
                        this.disableAutoFetch = args.disableAutoFetch;
                        this.msgHandler = args.msgHandler;
                        this.currRequestId = 0;
                        this._chunksNeededByRequest = new Map();
                        this._requestsByChunk = new Map();
                        this._promisesByRequest = new Map();
                        this.progressiveDataLength = 0;
                        this.aborted = false;
                        this._loadedStreamCapability = (0, _util.createPromiseCapability)();
                    }
                    onLoadedStream() {
                        return this._loadedStreamCapability.promise;
                    }
                    sendRequest(begin, end) {
                        const rangeReader = this.pdfNetworkStream.getRangeReader(begin, end);
                        if (!rangeReader.isStreamingSupported) rangeReader.onProgress = this.onProgress.bind(this);
                        let chunks = [], loaded = 0;
                        const promise = new Promise((resolve, reject)=>{
                            const readChunk = (chunk)=>{
                                try {
                                    if (!chunk.done) {
                                        const data = chunk.value;
                                        chunks.push(data);
                                        loaded += (0, _util.arrayByteLength)(data);
                                        if (rangeReader.isStreamingSupported) this.onProgress({
                                            loaded: loaded
                                        });
                                        rangeReader.read().then(readChunk, reject);
                                        return;
                                    }
                                    const chunkData = (0, _util.arraysToBytes)(chunks);
                                    chunks = null;
                                    resolve(chunkData);
                                } catch (e) {
                                    reject(e);
                                }
                            };
                            rangeReader.read().then(readChunk, reject);
                        });
                        promise.then((data)=>{
                            if (this.aborted) return;
                            this.onReceiveData({
                                chunk: data,
                                begin: begin
                            });
                        });
                    }
                    requestAllChunks() {
                        const missingChunks = this.stream.getMissingChunks();
                        this._requestChunks(missingChunks);
                        return this._loadedStreamCapability.promise;
                    }
                    _requestChunks(chunks) {
                        const requestId = this.currRequestId++;
                        const chunksNeeded = new Set();
                        this._chunksNeededByRequest.set(requestId, chunksNeeded);
                        for (const chunk of chunks)if (!this.stream.hasChunk(chunk)) chunksNeeded.add(chunk);
                        if (chunksNeeded.size === 0) return Promise.resolve();
                        const capability = (0, _util.createPromiseCapability)();
                        this._promisesByRequest.set(requestId, capability);
                        const chunksToRequest = [];
                        for (const chunk of chunksNeeded){
                            let requestIds = this._requestsByChunk.get(chunk);
                            if (!requestIds) {
                                requestIds = [];
                                this._requestsByChunk.set(chunk, requestIds);
                                chunksToRequest.push(chunk);
                            }
                            requestIds.push(requestId);
                        }
                        if (chunksToRequest.length > 0) {
                            const groupedChunksToRequest = this.groupChunks(chunksToRequest);
                            for (const groupedChunk of groupedChunksToRequest){
                                const begin = groupedChunk.beginChunk * this.chunkSize;
                                const end = Math.min(groupedChunk.endChunk * this.chunkSize, this.length);
                                this.sendRequest(begin, end);
                            }
                        }
                        return capability.promise.catch((reason)=>{
                            if (this.aborted) return;
                            throw reason;
                        });
                    }
                    getStream() {
                        return this.stream;
                    }
                    requestRange(begin, end) {
                        end = Math.min(end, this.length);
                        const beginChunk = this.getBeginChunk(begin);
                        const endChunk = this.getEndChunk(end);
                        const chunks = [];
                        for(let chunk = beginChunk; chunk < endChunk; ++chunk)chunks.push(chunk);
                        return this._requestChunks(chunks);
                    }
                    requestRanges(ranges = []) {
                        const chunksToRequest = [];
                        for (const range of ranges){
                            const beginChunk = this.getBeginChunk(range.begin);
                            const endChunk = this.getEndChunk(range.end);
                            for(let chunk = beginChunk; chunk < endChunk; ++chunk)if (!chunksToRequest.includes(chunk)) chunksToRequest.push(chunk);
                        }
                        chunksToRequest.sort(function(a, b) {
                            return a - b;
                        });
                        return this._requestChunks(chunksToRequest);
                    }
                    groupChunks(chunks) {
                        const groupedChunks = [];
                        let beginChunk = -1;
                        let prevChunk = -1;
                        for(let i = 0, ii = chunks.length; i < ii; ++i){
                            const chunk = chunks[i];
                            if (beginChunk < 0) beginChunk = chunk;
                            if (prevChunk >= 0 && prevChunk + 1 !== chunk) {
                                groupedChunks.push({
                                    beginChunk: beginChunk,
                                    endChunk: prevChunk + 1
                                });
                                beginChunk = chunk;
                            }
                            if (i + 1 === chunks.length) groupedChunks.push({
                                beginChunk: beginChunk,
                                endChunk: chunk + 1
                            });
                            prevChunk = chunk;
                        }
                        return groupedChunks;
                    }
                    onProgress(args) {
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize + args.loaded,
                            total: this.length
                        });
                    }
                    onReceiveData(args) {
                        const chunk = args.chunk;
                        const isProgressive = args.begin === undefined;
                        const begin = isProgressive ? this.progressiveDataLength : args.begin;
                        const end = begin + chunk.byteLength;
                        const beginChunk = Math.floor(begin / this.chunkSize);
                        const endChunk = end < this.length ? Math.floor(end / this.chunkSize) : Math.ceil(end / this.chunkSize);
                        if (isProgressive) {
                            this.stream.onReceiveProgressiveData(chunk);
                            this.progressiveDataLength = end;
                        } else this.stream.onReceiveData(begin, chunk);
                        if (this.stream.isDataLoaded) this._loadedStreamCapability.resolve(this.stream);
                        const loadedRequests = [];
                        for(let curChunk = beginChunk; curChunk < endChunk; ++curChunk){
                            const requestIds = this._requestsByChunk.get(curChunk);
                            if (!requestIds) continue;
                            this._requestsByChunk.delete(curChunk);
                            for (const requestId of requestIds){
                                const chunksNeeded = this._chunksNeededByRequest.get(requestId);
                                if (chunksNeeded.has(curChunk)) chunksNeeded.delete(curChunk);
                                if (chunksNeeded.size > 0) continue;
                                loadedRequests.push(requestId);
                            }
                        }
                        if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                            let nextEmptyChunk;
                            if (this.stream.numChunksLoaded === 1) {
                                const lastChunk = this.stream.numChunks - 1;
                                if (!this.stream.hasChunk(lastChunk)) nextEmptyChunk = lastChunk;
                            } else nextEmptyChunk = this.stream.nextEmptyChunk(endChunk);
                            if (Number.isInteger(nextEmptyChunk)) this._requestChunks([
                                nextEmptyChunk
                            ]);
                        }
                        for (const requestId of loadedRequests){
                            const capability = this._promisesByRequest.get(requestId);
                            this._promisesByRequest.delete(requestId);
                            capability.resolve();
                        }
                        this.msgHandler.send("DocProgress", {
                            loaded: this.stream.numChunksLoaded * this.chunkSize,
                            total: this.length
                        });
                    }
                    onError(err) {
                        this._loadedStreamCapability.reject(err);
                    }
                    getBeginChunk(begin) {
                        return Math.floor(begin / this.chunkSize);
                    }
                    getEndChunk(end) {
                        return Math.floor((end - 1) / this.chunkSize) + 1;
                    }
                    abort(reason) {
                        this.aborted = true;
                        if (this.pdfNetworkStream) this.pdfNetworkStream.cancelAllRequests(reason);
                        for (const capability of this._promisesByRequest.values())capability.reject(reason);
                    }
                }
                exports.ChunkedStreamManager = ChunkedStreamManager;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.collectActions = collectActions;
                exports.encodeToXmlString = encodeToXmlString;
                exports.escapePDFName = escapePDFName;
                exports.getArrayLookupTableFactory = getArrayLookupTableFactory;
                exports.getInheritableProperty = getInheritableProperty;
                exports.getLookupTableFactory = getLookupTableFactory;
                exports.isWhiteSpace = isWhiteSpace;
                exports.log2 = log2;
                exports.parseXFAPath = parseXFAPath;
                exports.readInt8 = readInt8;
                exports.readUint16 = readUint16;
                exports.readUint32 = readUint32;
                exports.toRomanNumerals = toRomanNumerals;
                exports.validateCSSFont = validateCSSFont;
                exports.XRefParseException = exports.XRefEntryException = exports.ParserEOFException = exports.MissingDataException = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                function getLookupTableFactory(initializer) {
                    let lookup;
                    return function() {
                        if (initializer) {
                            lookup = Object.create(null);
                            initializer(lookup);
                            initializer = null;
                        }
                        return lookup;
                    };
                }
                function getArrayLookupTableFactory(initializer) {
                    let lookup;
                    return function() {
                        if (initializer) {
                            let arr = initializer();
                            initializer = null;
                            lookup = Object.create(null);
                            for(let i = 0, ii = arr.length; i < ii; i += 2)lookup[arr[i]] = arr[i + 1];
                            arr = null;
                        }
                        return lookup;
                    };
                }
                class MissingDataException extends _util.BaseException {
                    constructor(begin, end){
                        super(`Missing data [${begin}, ${end})`);
                        this.begin = begin;
                        this.end = end;
                    }
                }
                exports.MissingDataException = MissingDataException;
                class ParserEOFException extends _util.BaseException {
                }
                exports.ParserEOFException = ParserEOFException;
                class XRefEntryException extends _util.BaseException {
                }
                exports.XRefEntryException = XRefEntryException;
                class XRefParseException extends _util.BaseException {
                }
                exports.XRefParseException = XRefParseException;
                function getInheritableProperty({ dict: dict , key: key , getArray: getArray = false , stopWhenFound: stopWhenFound = true  }) {
                    let values;
                    const visited = new _primitives.RefSet();
                    while(dict instanceof _primitives.Dict && !(dict.objId && visited.has(dict.objId))){
                        if (dict.objId) visited.put(dict.objId);
                        const value = getArray ? dict.getArray(key) : dict.get(key);
                        if (value !== undefined) {
                            if (stopWhenFound) return value;
                            if (!values) values = [];
                            values.push(value);
                        }
                        dict = dict.get("Parent");
                    }
                    return values;
                }
                const ROMAN_NUMBER_MAP = [
                    "",
                    "C",
                    "CC",
                    "CCC",
                    "CD",
                    "D",
                    "DC",
                    "DCC",
                    "DCCC",
                    "CM",
                    "",
                    "X",
                    "XX",
                    "XXX",
                    "XL",
                    "L",
                    "LX",
                    "LXX",
                    "LXXX",
                    "XC",
                    "",
                    "I",
                    "II",
                    "III",
                    "IV",
                    "V",
                    "VI",
                    "VII",
                    "VIII",
                    "IX"
                ];
                function toRomanNumerals(number, lowerCase = false) {
                    (0, _util.assert)(Number.isInteger(number) && number > 0, "The number should be a positive integer.");
                    const romanBuf = [];
                    let pos;
                    while(number >= 1000){
                        number -= 1000;
                        romanBuf.push("M");
                    }
                    pos = number / 100 | 0;
                    number %= 100;
                    romanBuf.push(ROMAN_NUMBER_MAP[pos]);
                    pos = number / 10 | 0;
                    number %= 10;
                    romanBuf.push(ROMAN_NUMBER_MAP[10 + pos]);
                    romanBuf.push(ROMAN_NUMBER_MAP[20 + number]);
                    const romanStr = romanBuf.join("");
                    return lowerCase ? romanStr.toLowerCase() : romanStr;
                }
                function log2(x) {
                    if (x <= 0) return 0;
                    return Math.ceil(Math.log2(x));
                }
                function readInt8(data, offset) {
                    return data[offset] << 24 >> 24;
                }
                function readUint16(data, offset) {
                    return data[offset] << 8 | data[offset + 1];
                }
                function readUint32(data, offset) {
                    return (data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3]) >>> 0;
                }
                function isWhiteSpace(ch) {
                    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
                }
                function parseXFAPath(path) {
                    const positionPattern = /(.+)\[([0-9]+)\]$/;
                    return path.split(".").map((component)=>{
                        const m = component.match(positionPattern);
                        if (m) return {
                            name: m[1],
                            pos: parseInt(m[2], 10)
                        };
                        return {
                            name: component,
                            pos: 0
                        };
                    });
                }
                function escapePDFName(str) {
                    const buffer = [];
                    let start = 0;
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.charCodeAt(i);
                        if (char < 0x21 || char > 0x7e || char === 0x23 || char === 0x28 || char === 0x29 || char === 0x3c || char === 0x3e || char === 0x5b || char === 0x5d || char === 0x7b || char === 0x7d || char === 0x2f || char === 0x25) {
                            if (start < i) buffer.push(str.substring(start, i));
                            buffer.push(`#${char.toString(16)}`);
                            start = i + 1;
                        }
                    }
                    if (buffer.length === 0) return str;
                    if (start < str.length) buffer.push(str.substring(start, str.length));
                    return buffer.join("");
                }
                function _collectJS(entry, xref, list, parents) {
                    if (!entry) return;
                    let parent = null;
                    if ((0, _primitives.isRef)(entry)) {
                        if (parents.has(entry)) return;
                        parent = entry;
                        parents.put(parent);
                        entry = xref.fetch(entry);
                    }
                    if (Array.isArray(entry)) for (const element of entry)_collectJS(element, xref, list, parents);
                    else if (entry instanceof _primitives.Dict) {
                        if ((0, _primitives.isName)(entry.get("S"), "JavaScript") && entry.has("JS")) {
                            const js = entry.get("JS");
                            let code;
                            if ((0, _primitives.isStream)(js)) code = js.getString();
                            else code = js;
                            code = (0, _util.stringToPDFString)(code);
                            if (code) list.push(code);
                        }
                        _collectJS(entry.getRaw("Next"), xref, list, parents);
                    }
                    if (parent) parents.remove(parent);
                }
                function collectActions(xref, dict, eventType) {
                    const actions = Object.create(null);
                    const additionalActionsDicts = getInheritableProperty({
                        dict: dict,
                        key: "AA",
                        stopWhenFound: false
                    });
                    if (additionalActionsDicts) for(let i = additionalActionsDicts.length - 1; i >= 0; i--){
                        const additionalActions = additionalActionsDicts[i];
                        if (!(additionalActions instanceof _primitives.Dict)) continue;
                        for (const key of additionalActions.getKeys()){
                            const action = eventType[key];
                            if (!action) continue;
                            const actionDict = additionalActions.getRaw(key);
                            const parents = new _primitives.RefSet();
                            const list = [];
                            _collectJS(actionDict, xref, list, parents);
                            if (list.length > 0) actions[action] = list;
                        }
                    }
                    if (dict.has("A")) {
                        const actionDict = dict.get("A");
                        const parents = new _primitives.RefSet();
                        const list = [];
                        _collectJS(actionDict, xref, list, parents);
                        if (list.length > 0) actions.Action = list;
                    }
                    return (0, _util.objectSize)(actions) > 0 ? actions : null;
                }
                const XMLEntities = {
                    0x3c: "&lt;",
                    0x3e: "&gt;",
                    0x26: "&amp;",
                    0x22: "&quot;",
                    0x27: "&apos;"
                };
                function encodeToXmlString(str) {
                    const buffer = [];
                    let start = 0;
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const char = str.codePointAt(i);
                        if (0x20 <= char && char <= 0x7e) {
                            const entity = XMLEntities[char];
                            if (entity) {
                                if (start < i) buffer.push(str.substring(start, i));
                                buffer.push(entity);
                                start = i + 1;
                            }
                        } else {
                            if (start < i) buffer.push(str.substring(start, i));
                            buffer.push(`&#x${char.toString(16).toUpperCase()};`);
                            if (char > 0xd7ff && (char < 0xe000 || char > 0xfffd)) i++;
                            start = i + 1;
                        }
                    }
                    if (buffer.length === 0) return str;
                    if (start < str.length) buffer.push(str.substring(start, str.length));
                    return buffer.join("");
                }
                function validateCSSFont(cssFontInfo) {
                    const DEFAULT_CSS_FONT_OBLIQUE = "14";
                    const DEFAULT_CSS_FONT_WEIGHT = "400";
                    const CSS_FONT_WEIGHT_VALUES = new Set([
                        "100",
                        "200",
                        "300",
                        "400",
                        "500",
                        "600",
                        "700",
                        "800",
                        "900",
                        "1000",
                        "normal",
                        "bold",
                        "bolder",
                        "lighter"
                    ]);
                    const { fontFamily: fontFamily , fontWeight: fontWeight , italicAngle: italicAngle  } = cssFontInfo;
                    if (/^".*"$/.test(fontFamily)) {
                        if (/[^\\]"/.test(fontFamily.slice(1, fontFamily.length - 1))) {
                            (0, _util.warn)(`XFA - FontFamily contains some unescaped ": ${fontFamily}.`);
                            return false;
                        }
                    } else if (/^'.*'$/.test(fontFamily)) {
                        if (/[^\\]'/.test(fontFamily.slice(1, fontFamily.length - 1))) {
                            (0, _util.warn)(`XFA - FontFamily contains some unescaped ': ${fontFamily}.`);
                            return false;
                        }
                    } else {
                        for (const ident of fontFamily.split(/[ \t]+/))if (/^([0-9]|(-([0-9]|-)))/.test(ident) || !/^[a-zA-Z0-9\-_\\]+$/.test(ident)) {
                            (0, _util.warn)(`XFA - FontFamily contains some invalid <custom-ident>: ${fontFamily}.`);
                            return false;
                        }
                    }
                    const weight = fontWeight ? fontWeight.toString() : "";
                    cssFontInfo.fontWeight = CSS_FONT_WEIGHT_VALUES.has(weight) ? weight : DEFAULT_CSS_FONT_WEIGHT;
                    const angle = parseFloat(italicAngle);
                    cssFontInfo.italicAngle = isNaN(angle) || angle < -90 || angle > 90 ? DEFAULT_CSS_FONT_OBLIQUE : italicAngle.toString();
                    return true;
                }
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StringStream = exports.Stream = exports.NullStream = void 0;
                var _base_stream = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(2);
                class Stream extends _base_stream.BaseStream {
                    constructor(arrayBuffer, start, length, dict){
                        super();
                        this.bytes = arrayBuffer instanceof Uint8Array ? arrayBuffer : new Uint8Array(arrayBuffer);
                        this.start = start || 0;
                        this.pos = this.start;
                        this.end = start + length || this.bytes.length;
                        this.dict = dict;
                    }
                    get length() {
                        return this.end - this.start;
                    }
                    get isEmpty() {
                        return this.length === 0;
                    }
                    getByte() {
                        if (this.pos >= this.end) return -1;
                        return this.bytes[this.pos++];
                    }
                    getBytes(length, forceClamped = false) {
                        const bytes = this.bytes;
                        const pos = this.pos;
                        const strEnd = this.end;
                        if (!length) {
                            const subarray = bytes.subarray(pos, strEnd);
                            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
                        }
                        let end = pos + length;
                        if (end > strEnd) end = strEnd;
                        this.pos = end;
                        const subarray = bytes.subarray(pos, end);
                        return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
                    }
                    getByteRange(begin, end) {
                        if (begin < 0) begin = 0;
                        if (end > this.end) end = this.end;
                        return this.bytes.subarray(begin, end);
                    }
                    reset() {
                        this.pos = this.start;
                    }
                    moveStart() {
                        this.start = this.pos;
                    }
                    makeSubStream(start, length, dict = null) {
                        return new Stream(this.bytes.buffer, start, length, dict);
                    }
                }
                exports.Stream = Stream;
                class StringStream extends Stream {
                    constructor(str){
                        super((0, _util.stringToBytes)(str));
                    }
                }
                exports.StringStream = StringStream;
                class NullStream extends Stream {
                    constructor(){
                        super(new Uint8Array(0));
                    }
                }
                exports.NullStream = NullStream;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDocument = exports.Page = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(10);
                var _annotation = __w_pdfjs_require__(12);
                var _base_stream = __w_pdfjs_require__(6);
                var _crypto = __w_pdfjs_require__(72);
                var _catalog = __w_pdfjs_require__(64);
                var _xfa_fonts = __w_pdfjs_require__(55);
                var _parser = __w_pdfjs_require__(17);
                var _object_loader = __w_pdfjs_require__(70);
                var _operator_list = __w_pdfjs_require__(62);
                var _evaluator = __w_pdfjs_require__(15);
                var _decode_stream = __w_pdfjs_require__(19);
                var _struct_tree = __w_pdfjs_require__(69);
                var _factory = __w_pdfjs_require__(74);
                var _xref = __w_pdfjs_require__(98);
                const DEFAULT_USER_UNIT = 1.0;
                const LETTER_SIZE_MEDIABOX = [
                    0,
                    0,
                    612,
                    792
                ];
                class Page {
                    constructor({ pdfManager: pdfManager , xref: xref , pageIndex: pageIndex , pageDict: pageDict , ref: ref , globalIdFactory: globalIdFactory , fontCache: fontCache , builtInCMapCache: builtInCMapCache , standardFontDataCache: standardFontDataCache , globalImageCache: globalImageCache , nonBlendModesSet: nonBlendModesSet , xfaFactory: xfaFactory  }){
                        this.pdfManager = pdfManager;
                        this.pageIndex = pageIndex;
                        this.pageDict = pageDict;
                        this.xref = xref;
                        this.ref = ref;
                        this.fontCache = fontCache;
                        this.builtInCMapCache = builtInCMapCache;
                        this.standardFontDataCache = standardFontDataCache;
                        this.globalImageCache = globalImageCache;
                        this.nonBlendModesSet = nonBlendModesSet;
                        this.evaluatorOptions = pdfManager.evaluatorOptions;
                        this.resourcesPromise = null;
                        this.xfaFactory = xfaFactory;
                        const idCounters = {
                            obj: 0
                        };
                        this._localIdFactory = class extends globalIdFactory {
                            static createObjId() {
                                return `p${pageIndex}_${++idCounters.obj}`;
                            }
                            static getPageObjId() {
                                return `page${ref.toString()}`;
                            }
                        };
                    }
                    _getInheritableProperty(key, getArray = false) {
                        const value = (0, _core_utils.getInheritableProperty)({
                            dict: this.pageDict,
                            key: key,
                            getArray: getArray,
                            stopWhenFound: false
                        });
                        if (!Array.isArray(value)) return value;
                        if (value.length === 1 || !(0, _primitives.isDict)(value[0])) return value[0];
                        return _primitives.Dict.merge({
                            xref: this.xref,
                            dictArray: value
                        });
                    }
                    get content() {
                        return this.pageDict.getArray("Contents");
                    }
                    get resources() {
                        return (0, _util.shadow)(this, "resources", this._getInheritableProperty("Resources") || _primitives.Dict.empty);
                    }
                    _getBoundingBox(name) {
                        if (this.xfaData) return this.xfaData.bbox;
                        const box = this._getInheritableProperty(name, true);
                        if (Array.isArray(box) && box.length === 4) {
                            if (box[2] - box[0] !== 0 && box[3] - box[1] !== 0) return box;
                            (0, _util.warn)(`Empty /${name} entry.`);
                        }
                        return null;
                    }
                    get mediaBox() {
                        return (0, _util.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || LETTER_SIZE_MEDIABOX);
                    }
                    get cropBox() {
                        return (0, _util.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
                    }
                    get userUnit() {
                        let obj = this.pageDict.get("UserUnit");
                        if (!(0, _util.isNum)(obj) || obj <= 0) obj = DEFAULT_USER_UNIT;
                        return (0, _util.shadow)(this, "userUnit", obj);
                    }
                    get view() {
                        const { cropBox: cropBox , mediaBox: mediaBox  } = this;
                        let view;
                        if (cropBox === mediaBox || (0, _util.isArrayEqual)(cropBox, mediaBox)) view = mediaBox;
                        else {
                            const box = _util.Util.intersect(cropBox, mediaBox);
                            if (box && box[2] - box[0] !== 0 && box[3] - box[1] !== 0) view = box;
                            else (0, _util.warn)("Empty /CropBox and /MediaBox intersection.");
                        }
                        return (0, _util.shadow)(this, "view", view || mediaBox);
                    }
                    get rotate() {
                        let rotate = this._getInheritableProperty("Rotate") || 0;
                        if (rotate % 90 !== 0) rotate = 0;
                        else if (rotate >= 360) rotate %= 360;
                        else if (rotate < 0) rotate = (rotate % 360 + 360) % 360;
                        return (0, _util.shadow)(this, "rotate", rotate);
                    }
                    getContentStream() {
                        return this.pdfManager.ensure(this, "content").then((content)=>{
                            if (content instanceof _base_stream.BaseStream) return content;
                            if (Array.isArray(content)) return new _decode_stream.StreamsSequenceStream(content);
                            return new _stream.NullStream();
                        });
                    }
                    get xfaData() {
                        if (this.xfaFactory) return (0, _util.shadow)(this, "xfaData", {
                            bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
                        });
                        return (0, _util.shadow)(this, "xfaData", null);
                    }
                    save(handler, task, annotationStorage) {
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            options: this.evaluatorOptions
                        });
                        return this._parsedAnnotations.then(function(annotations) {
                            const newRefsPromises = [];
                            for (const annotation of annotations){
                                if (!annotation.mustBePrinted(annotationStorage)) continue;
                                newRefsPromises.push(annotation.save(partialEvaluator, task, annotationStorage).catch(function(reason) {
                                    (0, _util.warn)("save - ignoring annotation data during " + `"${task.name}" task: "${reason}".`);
                                    return null;
                                }));
                            }
                            return Promise.all(newRefsPromises);
                        });
                    }
                    loadResources(keys) {
                        if (!this.resourcesPromise) this.resourcesPromise = this.pdfManager.ensure(this, "resources");
                        return this.resourcesPromise.then(()=>{
                            const objectLoader = new _object_loader.ObjectLoader(this.resources, keys, this.xref);
                            return objectLoader.load();
                        });
                    }
                    getOperatorList({ handler: handler , sink: sink , task: task , intent: intent , renderInteractiveForms: renderInteractiveForms , annotationStorage: annotationStorage  }) {
                        const contentStreamPromise = this.getContentStream();
                        const resourcesPromise = this.loadResources([
                            "ColorSpace",
                            "ExtGState",
                            "Font",
                            "Pattern",
                            "Properties",
                            "Shading",
                            "XObject"
                        ]);
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: this.pageIndex,
                            idFactory: this._localIdFactory,
                            fontCache: this.fontCache,
                            builtInCMapCache: this.builtInCMapCache,
                            standardFontDataCache: this.standardFontDataCache,
                            globalImageCache: this.globalImageCache,
                            options: this.evaluatorOptions
                        });
                        const dataPromises = Promise.all([
                            contentStreamPromise,
                            resourcesPromise
                        ]);
                        const pageListPromise = dataPromises.then(([contentStream])=>{
                            const opList = new _operator_list.OperatorList(intent, sink);
                            handler.send("StartRenderPage", {
                                transparency: partialEvaluator.hasBlendModes(this.resources, this.nonBlendModesSet),
                                pageIndex: this.pageIndex,
                                intent: intent
                            });
                            return partialEvaluator.getOperatorList({
                                stream: contentStream,
                                task: task,
                                resources: this.resources,
                                operatorList: opList
                            }).then(function() {
                                return opList;
                            });
                        });
                        return Promise.all([
                            pageListPromise,
                            this._parsedAnnotations
                        ]).then(function([pageOpList, annotations]) {
                            if (annotations.length === 0) {
                                pageOpList.flush(true);
                                return {
                                    length: pageOpList.totalLength
                                };
                            }
                            const annotationIntent = intent.startsWith("oplist-") ? intent.split("-")[1] : intent;
                            const opListPromises = [];
                            for (const annotation of annotations)if (annotationIntent === "display" && annotation.mustBeViewed(annotationStorage) || annotationIntent === "print" && annotation.mustBePrinted(annotationStorage)) opListPromises.push(annotation.getOperatorList(partialEvaluator, task, renderInteractiveForms, annotationStorage).catch(function(reason) {
                                (0, _util.warn)("getOperatorList - ignoring annotation data during " + `"${task.name}" task: "${reason}".`);
                                return null;
                            }));
                            return Promise.all(opListPromises).then(function(opLists) {
                                pageOpList.addOp(_util.OPS.beginAnnotations, []);
                                for (const opList of opLists)pageOpList.addOpList(opList);
                                pageOpList.addOp(_util.OPS.endAnnotations, []);
                                pageOpList.flush(true);
                                return {
                                    length: pageOpList.totalLength
                                };
                            });
                        });
                    }
                    extractTextContent({ handler: handler , task: task , normalizeWhitespace: normalizeWhitespace , includeMarkedContent: includeMarkedContent , sink: sink , combineTextItems: combineTextItems  }) {
                        const contentStreamPromise = this.getContentStream();
                        const resourcesPromise = this.loadResources([
                            "ExtGState",
                            "Font",
                            "Properties",
                            "XObject"
                        ]);
                        const dataPromises = Promise.all([
                            contentStreamPromise,
                            resourcesPromise
                        ]);
                        return dataPromises.then(([contentStream])=>{
                            const partialEvaluator = new _evaluator.PartialEvaluator({
                                xref: this.xref,
                                handler: handler,
                                pageIndex: this.pageIndex,
                                idFactory: this._localIdFactory,
                                fontCache: this.fontCache,
                                builtInCMapCache: this.builtInCMapCache,
                                standardFontDataCache: this.standardFontDataCache,
                                globalImageCache: this.globalImageCache,
                                options: this.evaluatorOptions
                            });
                            return partialEvaluator.getTextContent({
                                stream: contentStream,
                                task: task,
                                resources: this.resources,
                                normalizeWhitespace: normalizeWhitespace,
                                includeMarkedContent: includeMarkedContent,
                                combineTextItems: combineTextItems,
                                sink: sink
                            });
                        });
                    }
                    async getStructTree() {
                        const structTreeRoot = await this.pdfManager.ensureCatalog("structTreeRoot");
                        if (!structTreeRoot) return null;
                        const structTree = await this.pdfManager.ensure(this, "_parseStructTree", [
                            structTreeRoot
                        ]);
                        return structTree.serializable;
                    }
                    _parseStructTree(structTreeRoot) {
                        const tree = new _struct_tree.StructTreePage(structTreeRoot, this.pageDict);
                        tree.parse();
                        return tree;
                    }
                    getAnnotationsData(intent) {
                        return this._parsedAnnotations.then(function(annotations) {
                            const annotationsData = [];
                            for(let i = 0, ii = annotations.length; i < ii; i++)if (!intent || intent === "display" && annotations[i].viewable || intent === "print" && annotations[i].printable) annotationsData.push(annotations[i].data);
                            return annotationsData;
                        });
                    }
                    get annotations() {
                        const annots = this._getInheritableProperty("Annots");
                        return (0, _util.shadow)(this, "annotations", Array.isArray(annots) ? annots : []);
                    }
                    get _parsedAnnotations() {
                        const parsedAnnotations = this.pdfManager.ensure(this, "annotations").then(()=>{
                            const annotationPromises = [];
                            for (const annotationRef of this.annotations)annotationPromises.push(_annotation.AnnotationFactory.create(this.xref, annotationRef, this.pdfManager, this._localIdFactory, false).catch(function(reason) {
                                (0, _util.warn)(`_parsedAnnotations: "${reason}".`);
                                return null;
                            }));
                            return Promise.all(annotationPromises).then(function(annotations) {
                                return annotations.filter((annotation)=>!!annotation);
                            });
                        });
                        return (0, _util.shadow)(this, "_parsedAnnotations", parsedAnnotations);
                    }
                    get jsActions() {
                        const actions = (0, _core_utils.collectActions)(this.xref, this.pageDict, _util.PageActionEventType);
                        return (0, _util.shadow)(this, "jsActions", actions);
                    }
                }
                exports.Page = Page;
                const PDF_HEADER_SIGNATURE = new Uint8Array([
                    0x25,
                    0x50,
                    0x44,
                    0x46,
                    0x2d
                ]);
                const STARTXREF_SIGNATURE = new Uint8Array([
                    0x73,
                    0x74,
                    0x61,
                    0x72,
                    0x74,
                    0x78,
                    0x72,
                    0x65,
                    0x66
                ]);
                const ENDOBJ_SIGNATURE = new Uint8Array([
                    0x65,
                    0x6e,
                    0x64,
                    0x6f,
                    0x62,
                    0x6a
                ]);
                const FINGERPRINT_FIRST_BYTES = 1024;
                const EMPTY_FINGERPRINT = "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00";
                const PDF_HEADER_VERSION_REGEXP = /^[1-9]\.[0-9]$/;
                function find(stream, signature, limit = 1024, backwards = false) {
                    const signatureLength = signature.length;
                    const scanBytes = stream.peekBytes(limit);
                    const scanLength = scanBytes.length - signatureLength;
                    if (scanLength <= 0) return false;
                    if (backwards) {
                        const signatureEnd = signatureLength - 1;
                        let pos = scanBytes.length - 1;
                        while(pos >= signatureEnd){
                            let j = 0;
                            while(j < signatureLength && scanBytes[pos - j] === signature[signatureEnd - j])j++;
                            if (j >= signatureLength) {
                                stream.pos += pos - signatureEnd;
                                return true;
                            }
                            pos--;
                        }
                    } else {
                        let pos = 0;
                        while(pos <= scanLength){
                            let j = 0;
                            while(j < signatureLength && scanBytes[pos + j] === signature[j])j++;
                            if (j >= signatureLength) {
                                stream.pos += pos;
                                return true;
                            }
                            pos++;
                        }
                    }
                    return false;
                }
                class PDFDocument {
                    constructor(pdfManager, arg){
                        let stream;
                        if ((0, _primitives.isStream)(arg)) stream = arg;
                        else if ((0, _util.isArrayBuffer)(arg)) stream = new _stream.Stream(arg);
                        else throw new Error("PDFDocument: Unknown argument type");
                        if (stream.length <= 0) throw new _util.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
                        this.pdfManager = pdfManager;
                        this.stream = stream;
                        this.xref = new _xref.XRef(stream, pdfManager);
                        this._pagePromises = [];
                        this._version = null;
                        const idCounters = {
                            font: 0
                        };
                        this._globalIdFactory = class {
                            static getDocId() {
                                return `g_${pdfManager.docId}`;
                            }
                            static createFontId() {
                                return `f${++idCounters.font}`;
                            }
                            static createObjId() {
                                (0, _util.unreachable)("Abstract method `createObjId` called.");
                            }
                            static getPageObjId() {
                                (0, _util.unreachable)("Abstract method `getPageObjId` called.");
                            }
                        };
                    }
                    parse(recoveryMode) {
                        this.xref.parse(recoveryMode);
                        this.catalog = new _catalog.Catalog(this.pdfManager, this.xref);
                        if (this.catalog.version) this._version = this.catalog.version;
                    }
                    get linearization() {
                        let linearization = null;
                        try {
                            linearization = _parser.Linearization.create(this.stream);
                        } catch (err) {
                            if (err instanceof _core_utils.MissingDataException) throw err;
                            (0, _util.info)(err);
                        }
                        return (0, _util.shadow)(this, "linearization", linearization);
                    }
                    get startXRef() {
                        const stream = this.stream;
                        let startXRef = 0;
                        if (this.linearization) {
                            stream.reset();
                            if (find(stream, ENDOBJ_SIGNATURE)) startXRef = stream.pos + 6 - stream.start;
                        } else {
                            const step = 1024;
                            const startXRefLength = STARTXREF_SIGNATURE.length;
                            let found = false, pos = stream.end;
                            while(!found && pos > 0){
                                pos -= step - startXRefLength;
                                if (pos < 0) pos = 0;
                                stream.pos = pos;
                                found = find(stream, STARTXREF_SIGNATURE, step, true);
                            }
                            if (found) {
                                stream.skip(9);
                                let ch;
                                do ch = stream.getByte();
                                while ((0, _core_utils.isWhiteSpace)(ch));
                                let str = "";
                                while(ch >= 0x20 && ch <= 0x39){
                                    str += String.fromCharCode(ch);
                                    ch = stream.getByte();
                                }
                                startXRef = parseInt(str, 10);
                                if (isNaN(startXRef)) startXRef = 0;
                            }
                        }
                        return (0, _util.shadow)(this, "startXRef", startXRef);
                    }
                    checkHeader() {
                        const stream = this.stream;
                        stream.reset();
                        if (!find(stream, PDF_HEADER_SIGNATURE)) return;
                        stream.moveStart();
                        const MAX_PDF_VERSION_LENGTH = 12;
                        let version = "", ch;
                        while((ch = stream.getByte()) > 0x20){
                            if (version.length >= MAX_PDF_VERSION_LENGTH) break;
                            version += String.fromCharCode(ch);
                        }
                        if (!this._version) this._version = version.substring(5);
                    }
                    parseStartXRef() {
                        this.xref.setStartXRef(this.startXRef);
                    }
                    get numPages() {
                        if (this.xfaFactory) return (0, _util.shadow)(this, "numPages", this.xfaFactory.numberPages);
                        const linearization = this.linearization;
                        const num = linearization ? linearization.numPages : this.catalog.numPages;
                        return (0, _util.shadow)(this, "numPages", num);
                    }
                    _hasOnlyDocumentSignatures(fields, recursionDepth = 0) {
                        const RECURSION_LIMIT = 10;
                        if (!Array.isArray(fields)) return false;
                        return fields.every((field)=>{
                            field = this.xref.fetchIfRef(field);
                            if (!(field instanceof _primitives.Dict)) return false;
                            if (field.has("Kids")) {
                                if (++recursionDepth > RECURSION_LIMIT) {
                                    (0, _util.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached");
                                    return false;
                                }
                                return this._hasOnlyDocumentSignatures(field.get("Kids"), recursionDepth);
                            }
                            const isSignature = (0, _primitives.isName)(field.get("FT"), "Sig");
                            const rectangle = field.get("Rect");
                            const isInvisible = Array.isArray(rectangle) && rectangle.every((value)=>value === 0);
                            return isSignature && isInvisible;
                        });
                    }
                    get xfaData() {
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm) return null;
                        const xfa = acroForm.get("XFA");
                        const entries = {
                            "xdp:xdp": "",
                            template: "",
                            datasets: "",
                            config: "",
                            connectionSet: "",
                            localeSet: "",
                            stylesheet: "",
                            "/xdp:xdp": ""
                        };
                        if ((0, _primitives.isStream)(xfa) && !xfa.isEmpty) try {
                            entries["xdp:xdp"] = (0, _util.stringToUTF8String)(xfa.getString());
                            return entries;
                        } catch (_) {
                            (0, _util.warn)("XFA - Invalid utf-8 string.");
                            return null;
                        }
                        if (!Array.isArray(xfa) || xfa.length === 0) return null;
                        for(let i = 0, ii = xfa.length; i < ii; i += 2){
                            let name;
                            if (i === 0) name = "xdp:xdp";
                            else if (i === ii - 2) name = "/xdp:xdp";
                            else name = xfa[i];
                            if (!entries.hasOwnProperty(name)) continue;
                            const data = this.xref.fetchIfRef(xfa[i + 1]);
                            if (!(0, _primitives.isStream)(data) || data.isEmpty) continue;
                            try {
                                entries[name] = (0, _util.stringToUTF8String)(data.getString());
                            } catch (_) {
                                (0, _util.warn)("XFA - Invalid utf-8 string.");
                                return null;
                            }
                        }
                        return entries;
                    }
                    get xfaFactory() {
                        if (this.pdfManager.enableXfa && this.formInfo.hasXfa && !this.formInfo.hasAcroForm) {
                            const data = this.xfaData;
                            return (0, _util.shadow)(this, "xfaFactory", data ? new _factory.XFAFactory(data) : null);
                        }
                        return (0, _util.shadow)(this, "xfaFaxtory", null);
                    }
                    get isPureXfa() {
                        return this.xfaFactory && this.xfaFactory.isValid();
                    }
                    get htmlForXfa() {
                        if (this.xfaFactory) return this.xfaFactory.getPages();
                        return null;
                    }
                    async loadXfaImages() {
                        const xfaImagesDict = await this.pdfManager.ensureCatalog("xfaImages");
                        if (!xfaImagesDict) return;
                        const keys = xfaImagesDict.getKeys();
                        const objectLoader = new _object_loader.ObjectLoader(xfaImagesDict, keys, this.xref);
                        await objectLoader.load();
                        const xfaImages = new Map();
                        for (const key of keys){
                            const stream = xfaImagesDict.get(key);
                            if (!(0, _primitives.isStream)(stream)) continue;
                            xfaImages.set(key, stream.getBytes());
                        }
                        this.xfaFactory.setImages(xfaImages);
                    }
                    async loadXfaFonts(handler, task) {
                        const acroForm = await this.pdfManager.ensureCatalog("acroForm");
                        if (!acroForm) return;
                        const resources = await acroForm.getAsync("DR");
                        if (!(resources instanceof _primitives.Dict)) return;
                        const objectLoader = new _object_loader.ObjectLoader(resources, [
                            "Font"
                        ], this.xref);
                        await objectLoader.load();
                        const fontRes = resources.get("Font");
                        if (!(fontRes instanceof _primitives.Dict)) return;
                        const options = Object.assign(Object.create(null), this.pdfManager.evaluatorOptions);
                        options.useSystemFonts = false;
                        const partialEvaluator = new _evaluator.PartialEvaluator({
                            xref: this.xref,
                            handler: handler,
                            pageIndex: -1,
                            idFactory: this._globalIdFactory,
                            fontCache: this.catalog.fontCache,
                            builtInCMapCache: this.catalog.builtInCMapCache,
                            standardFontDataCache: this.catalog.standardFontDataCache,
                            options: options
                        });
                        const operatorList = new _operator_list.OperatorList();
                        const pdfFonts = [];
                        const initialState = {
                            get font () {
                                return pdfFonts[pdfFonts.length - 1];
                            },
                            set font (font){
                                pdfFonts.push(font);
                            },
                            clone () {
                                return this;
                            }
                        };
                        const fonts = new Map();
                        fontRes.forEach((fontName, font1)=>{
                            fonts.set(fontName, font1);
                        });
                        const promises = [];
                        for (const [fontName, font1] of fonts){
                            const descriptor = font1.get("FontDescriptor");
                            if (!(descriptor instanceof _primitives.Dict)) continue;
                            let fontFamily = descriptor.get("FontFamily");
                            fontFamily = fontFamily.replace(/[ ]+([0-9])/g, "$1");
                            const fontWeight = descriptor.get("FontWeight");
                            const italicAngle = -descriptor.get("ItalicAngle");
                            const cssFontInfo = {
                                fontFamily: fontFamily,
                                fontWeight: fontWeight,
                                italicAngle: italicAngle
                            };
                            if (!(0, _core_utils.validateCSSFont)(cssFontInfo)) continue;
                            promises.push(partialEvaluator.handleSetFont(resources, [
                                _primitives.Name.get(fontName),
                                1
                            ], null, operatorList, task, initialState, null, cssFontInfo).catch(function(reason) {
                                (0, _util.warn)(`loadXfaFonts: "${reason}".`);
                                return null;
                            }));
                        }
                        await Promise.all(promises);
                        const missingFonts = this.xfaFactory.setFonts(pdfFonts);
                        if (!missingFonts) return;
                        options.ignoreErrors = true;
                        promises.length = 0;
                        pdfFonts.length = 0;
                        const reallyMissingFonts = new Set();
                        for (const missing of missingFonts)if (!(0, _xfa_fonts.getXfaFontWidths)(`${missing}-Regular`)) reallyMissingFonts.add(missing);
                        if (reallyMissingFonts.size) missingFonts.push("PdfJS-Fallback");
                        for (const missing of missingFonts){
                            if (reallyMissingFonts.has(missing)) continue;
                            for (const fontInfo of [
                                {
                                    name: "Regular",
                                    fontWeight: 400,
                                    italicAngle: 0
                                },
                                {
                                    name: "Bold",
                                    fontWeight: 700,
                                    italicAngle: 0
                                },
                                {
                                    name: "Italic",
                                    fontWeight: 400,
                                    italicAngle: 12
                                },
                                {
                                    name: "BoldItalic",
                                    fontWeight: 700,
                                    italicAngle: 12
                                }
                            ]){
                                const name = `${missing}-${fontInfo.name}`;
                                const widths = (0, _xfa_fonts.getXfaFontWidths)(name);
                                const dict = new _primitives.Dict(null);
                                dict.set("BaseFont", _primitives.Name.get(name));
                                dict.set("Type", _primitives.Name.get("Font"));
                                dict.set("Subtype", _primitives.Name.get("TrueType"));
                                dict.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                                const descriptor = new _primitives.Dict(null);
                                descriptor.set("Widths", widths);
                                dict.set("FontDescriptor", descriptor);
                                promises.push(partialEvaluator.handleSetFont(resources, [
                                    _primitives.Name.get(name),
                                    1
                                ], null, operatorList, task, initialState, dict, {
                                    fontFamily: missing,
                                    fontWeight: fontInfo.fontWeight,
                                    italicAngle: fontInfo.italicAngle
                                }).catch(function(reason) {
                                    (0, _util.warn)(`loadXfaFonts: "${reason}".`);
                                    return null;
                                }));
                            }
                        }
                        await Promise.all(promises);
                        this.xfaFactory.appendFonts(pdfFonts, reallyMissingFonts);
                    }
                    async serializeXfaData(annotationStorage) {
                        if (this.xfaFactory) return this.xfaFactory.serializeData(annotationStorage);
                        return null;
                    }
                    get formInfo() {
                        const formInfo = {
                            hasFields: false,
                            hasAcroForm: false,
                            hasXfa: false,
                            hasSignatures: false
                        };
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm) return (0, _util.shadow)(this, "formInfo", formInfo);
                        try {
                            const fields = acroForm.get("Fields");
                            const hasFields = Array.isArray(fields) && fields.length > 0;
                            formInfo.hasFields = hasFields;
                            const xfa = acroForm.get("XFA");
                            formInfo.hasXfa = Array.isArray(xfa) && xfa.length > 0 || (0, _primitives.isStream)(xfa) && !xfa.isEmpty;
                            const sigFlags = acroForm.get("SigFlags");
                            const hasSignatures = !!(sigFlags & 0x1);
                            const hasOnlyDocumentSignatures = hasSignatures && this._hasOnlyDocumentSignatures(fields);
                            formInfo.hasAcroForm = hasFields && !hasOnlyDocumentSignatures;
                            formInfo.hasSignatures = hasSignatures;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Cannot fetch form information: "${ex}".`);
                        }
                        return (0, _util.shadow)(this, "formInfo", formInfo);
                    }
                    get documentInfo() {
                        const DocumentInfoValidators = {
                            Title: _util.isString,
                            Author: _util.isString,
                            Subject: _util.isString,
                            Keywords: _util.isString,
                            Creator: _util.isString,
                            Producer: _util.isString,
                            CreationDate: _util.isString,
                            ModDate: _util.isString,
                            Trapped: _primitives.isName
                        };
                        let version = this._version;
                        if (typeof version !== "string" || !PDF_HEADER_VERSION_REGEXP.test(version)) {
                            (0, _util.warn)(`Invalid PDF header version number: ${version}`);
                            version = null;
                        }
                        const docInfo = {
                            PDFFormatVersion: version,
                            IsLinearized: !!this.linearization,
                            IsAcroFormPresent: this.formInfo.hasAcroForm,
                            IsXFAPresent: this.formInfo.hasXfa,
                            IsCollectionPresent: !!this.catalog.collection,
                            IsSignaturesPresent: this.formInfo.hasSignatures
                        };
                        let infoDict;
                        try {
                            infoDict = this.xref.trailer.get("Info");
                        } catch (err) {
                            if (err instanceof _core_utils.MissingDataException) throw err;
                            (0, _util.info)("The document information dictionary is invalid.");
                        }
                        if ((0, _primitives.isDict)(infoDict)) for (const key of infoDict.getKeys()){
                            const value = infoDict.get(key);
                            if (DocumentInfoValidators[key]) {
                                if (DocumentInfoValidators[key](value)) docInfo[key] = typeof value !== "string" ? value : (0, _util.stringToPDFString)(value);
                                else (0, _util.info)(`Bad value in document info for "${key}".`);
                            } else if (typeof key === "string") {
                                let customValue;
                                if ((0, _util.isString)(value)) customValue = (0, _util.stringToPDFString)(value);
                                else if ((0, _primitives.isName)(value) || (0, _util.isNum)(value) || (0, _util.isBool)(value)) customValue = value;
                                else {
                                    (0, _util.info)(`Unsupported value in document info for (custom) "${key}".`);
                                    continue;
                                }
                                if (!docInfo.Custom) docInfo.Custom = Object.create(null);
                                docInfo.Custom[key] = customValue;
                            }
                        }
                        return (0, _util.shadow)(this, "documentInfo", docInfo);
                    }
                    get fingerprints() {
                        function validate(data) {
                            return typeof data === "string" && data.length > 0 && data !== EMPTY_FINGERPRINT;
                        }
                        function hexString(hash) {
                            const buf = [];
                            for(let i = 0, ii = hash.length; i < ii; i++){
                                const hex = hash[i].toString(16);
                                buf.push(hex.padStart(2, "0"));
                            }
                            return buf.join("");
                        }
                        const idArray = this.xref.trailer.get("ID");
                        let hashOriginal, hashModified;
                        if (Array.isArray(idArray) && validate(idArray[0])) {
                            hashOriginal = (0, _util.stringToBytes)(idArray[0]);
                            if (idArray[1] !== idArray[0] && validate(idArray[1])) hashModified = (0, _util.stringToBytes)(idArray[1]);
                        } else hashOriginal = (0, _crypto.calculateMD5)(this.stream.getByteRange(0, FINGERPRINT_FIRST_BYTES), 0, FINGERPRINT_FIRST_BYTES);
                        return (0, _util.shadow)(this, "fingerprints", [
                            hexString(hashOriginal),
                            hashModified ? hexString(hashModified) : null
                        ]);
                    }
                    _getLinearizationPage(pageIndex) {
                        const { catalog: catalog , linearization: linearization  } = this;
                        const ref = _primitives.Ref.get(linearization.objectNumberFirst, 0);
                        return this.xref.fetchAsync(ref).then((obj)=>{
                            if ((0, _primitives.isDict)(obj, "Page") || (0, _primitives.isDict)(obj) && !obj.has("Type") && obj.has("Contents")) {
                                if (ref && !catalog.pageKidsCountCache.has(ref)) catalog.pageKidsCountCache.put(ref, 1);
                                return [
                                    obj,
                                    ref
                                ];
                            }
                            throw new _util.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
                        }).catch((reason)=>{
                            (0, _util.info)(reason);
                            return catalog.getPageDict(pageIndex);
                        });
                    }
                    getPage(pageIndex) {
                        if (this._pagePromises[pageIndex] !== undefined) return this._pagePromises[pageIndex];
                        const { catalog: catalog , linearization: linearization  } = this;
                        if (this.xfaFactory) return Promise.resolve(new Page({
                            pdfManager: this.pdfManager,
                            xref: this.xref,
                            pageIndex: pageIndex,
                            pageDict: _primitives.Dict.empty,
                            ref: null,
                            globalIdFactory: this._globalIdFactory,
                            fontCache: catalog.fontCache,
                            builtInCMapCache: catalog.builtInCMapCache,
                            standardFontDataCache: catalog.standardFontDataCache,
                            globalImageCache: catalog.globalImageCache,
                            nonBlendModesSet: catalog.nonBlendModesSet,
                            xfaFactory: this.xfaFactory
                        }));
                        const promise = linearization && linearization.pageFirst === pageIndex ? this._getLinearizationPage(pageIndex) : catalog.getPageDict(pageIndex);
                        return this._pagePromises[pageIndex] = promise.then(([pageDict, ref])=>{
                            return new Page({
                                pdfManager: this.pdfManager,
                                xref: this.xref,
                                pageIndex: pageIndex,
                                pageDict: pageDict,
                                ref: ref,
                                globalIdFactory: this._globalIdFactory,
                                fontCache: catalog.fontCache,
                                builtInCMapCache: catalog.builtInCMapCache,
                                standardFontDataCache: catalog.standardFontDataCache,
                                globalImageCache: catalog.globalImageCache,
                                nonBlendModesSet: catalog.nonBlendModesSet,
                                xfaFactory: null
                            });
                        });
                    }
                    checkFirstPage() {
                        return this.getPage(0).catch(async (reason)=>{
                            if (reason instanceof _core_utils.XRefEntryException) {
                                this._pagePromises.length = 0;
                                await this.cleanup();
                                throw new _core_utils.XRefParseException();
                            }
                        });
                    }
                    fontFallback(id, handler) {
                        return this.catalog.fontFallback(id, handler);
                    }
                    async cleanup(manuallyTriggered = false) {
                        return this.catalog ? this.catalog.cleanup(manuallyTriggered) : (0, _primitives.clearPrimitiveCaches)();
                    }
                    _collectFieldObjects(name, fieldRef, promises) {
                        const field = this.xref.fetchIfRef(fieldRef);
                        if (field.has("T")) {
                            const partName = (0, _util.stringToPDFString)(field.get("T"));
                            if (name === "") name = partName;
                            else name = `${name}.${partName}`;
                        }
                        if (!promises.has(name)) promises.set(name, []);
                        promises.get(name).push(_annotation.AnnotationFactory.create(this.xref, fieldRef, this.pdfManager, this._localIdFactory, true).then((annotation)=>annotation && annotation.getFieldObject()).catch(function(reason) {
                            (0, _util.warn)(`_collectFieldObjects: "${reason}".`);
                            return null;
                        }));
                        if (field.has("Kids")) {
                            const kids = field.get("Kids");
                            for (const kid of kids)this._collectFieldObjects(name, kid, promises);
                        }
                    }
                    get fieldObjects() {
                        if (!this.formInfo.hasFields) return (0, _util.shadow)(this, "fieldObjects", Promise.resolve(null));
                        const allFields = Object.create(null);
                        const fieldPromises = new Map();
                        for (const fieldRef of this.catalog.acroForm.get("Fields"))this._collectFieldObjects("", fieldRef, fieldPromises);
                        const allPromises = [];
                        for (const [name, promises] of fieldPromises)allPromises.push(Promise.all(promises).then((fields)=>{
                            fields = fields.filter((field)=>!!field);
                            if (fields.length > 0) allFields[name] = fields;
                        }));
                        return (0, _util.shadow)(this, "fieldObjects", Promise.all(allPromises).then(()=>allFields));
                    }
                    get hasJSActions() {
                        const promise = this.pdfManager.ensureDoc("_parseHasJSActions");
                        return (0, _util.shadow)(this, "hasJSActions", promise);
                    }
                    async _parseHasJSActions() {
                        const [catalogJsActions, fieldObjects] = await Promise.all([
                            this.pdfManager.ensureCatalog("jsActions"),
                            this.pdfManager.ensureDoc("fieldObjects")
                        ]);
                        if (catalogJsActions) return true;
                        if (fieldObjects) return Object.values(fieldObjects).some((fieldObject)=>fieldObject.some((object)=>object.actions !== null));
                        return false;
                    }
                    get calculationOrderIds() {
                        const acroForm = this.catalog.acroForm;
                        if (!acroForm || !acroForm.has("CO")) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        const calculationOrder = acroForm.get("CO");
                        if (!Array.isArray(calculationOrder) || calculationOrder.length === 0) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        const ids = calculationOrder.filter(_primitives.isRef).map((ref)=>ref.toString());
                        if (ids.length === 0) return (0, _util.shadow)(this, "calculationOrderIds", null);
                        return (0, _util.shadow)(this, "calculationOrderIds", ids);
                    }
                }
                exports.PDFDocument = PDFDocument;
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getQuadPoints = getQuadPoints;
                exports.MarkupAnnotation = exports.AnnotationFactory = exports.AnnotationBorderStyle = exports.Annotation = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(9);
                var _default_appearance = __w_pdfjs_require__(13);
                var _primitives = __w_pdfjs_require__(5);
                var _catalog = __w_pdfjs_require__(64);
                var _colorspace = __w_pdfjs_require__(14);
                var _file_spec = __w_pdfjs_require__(66);
                var _object_loader = __w_pdfjs_require__(70);
                var _operator_list = __w_pdfjs_require__(62);
                var _stream = __w_pdfjs_require__(10);
                var _writer = __w_pdfjs_require__(71);
                class AnnotationFactory {
                    static create(xref, ref, pdfManager, idFactory, collectFields) {
                        return Promise.all([
                            pdfManager.ensureCatalog("acroForm"),
                            collectFields ? this._getPageIndex(xref, ref, pdfManager) : -1
                        ]).then(([acroForm, pageIndex])=>pdfManager.ensure(this, "_create", [
                                xref,
                                ref,
                                pdfManager,
                                idFactory,
                                acroForm,
                                collectFields,
                                pageIndex
                            ]));
                    }
                    static _create(xref, ref, pdfManager, idFactory, acroForm, collectFields, pageIndex = -1) {
                        const dict = xref.fetchIfRef(ref);
                        if (!(0, _primitives.isDict)(dict)) return undefined;
                        const id = (0, _primitives.isRef)(ref) ? ref.toString() : `annot_${idFactory.createObjId()}`;
                        let subtype = dict.get("Subtype");
                        subtype = (0, _primitives.isName)(subtype) ? subtype.name : null;
                        const parameters = {
                            xref: xref,
                            ref: ref,
                            dict: dict,
                            subtype: subtype,
                            id: id,
                            pdfManager: pdfManager,
                            acroForm: acroForm instanceof _primitives.Dict ? acroForm : _primitives.Dict.empty,
                            collectFields: collectFields,
                            pageIndex: pageIndex
                        };
                        switch(subtype){
                            case "Link":
                                return new LinkAnnotation(parameters);
                            case "Text":
                                return new TextAnnotation(parameters);
                            case "Widget":
                                let fieldType = (0, _core_utils.getInheritableProperty)({
                                    dict: dict,
                                    key: "FT"
                                });
                                fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotation(parameters);
                                    case "Btn":
                                        return new ButtonWidgetAnnotation(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotation(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotation(parameters);
                                }
                                (0, _util.warn)(`Unimplemented widget field type "${fieldType}", ` + "falling back to base field type.");
                                return new WidgetAnnotation(parameters);
                            case "Popup":
                                return new PopupAnnotation(parameters);
                            case "FreeText":
                                return new FreeTextAnnotation(parameters);
                            case "Line":
                                return new LineAnnotation(parameters);
                            case "Square":
                                return new SquareAnnotation(parameters);
                            case "Circle":
                                return new CircleAnnotation(parameters);
                            case "PolyLine":
                                return new PolylineAnnotation(parameters);
                            case "Polygon":
                                return new PolygonAnnotation(parameters);
                            case "Caret":
                                return new CaretAnnotation(parameters);
                            case "Ink":
                                return new InkAnnotation(parameters);
                            case "Highlight":
                                return new HighlightAnnotation(parameters);
                            case "Underline":
                                return new UnderlineAnnotation(parameters);
                            case "Squiggly":
                                return new SquigglyAnnotation(parameters);
                            case "StrikeOut":
                                return new StrikeOutAnnotation(parameters);
                            case "Stamp":
                                return new StampAnnotation(parameters);
                            case "FileAttachment":
                                return new FileAttachmentAnnotation(parameters);
                            default:
                                if (!collectFields) {
                                    if (!subtype) (0, _util.warn)("Annotation is missing the required /Subtype.");
                                    else (0, _util.warn)(`Unimplemented annotation type "${subtype}", ` + "falling back to base annotation.");
                                }
                                return new Annotation(parameters);
                        }
                    }
                    static async _getPageIndex(xref, ref, pdfManager) {
                        try {
                            const annotDict = await xref.fetchIfRefAsync(ref);
                            if (!(0, _primitives.isDict)(annotDict)) return -1;
                            const pageRef = annotDict.getRaw("P");
                            if (!(0, _primitives.isRef)(pageRef)) return -1;
                            const pageIndex = await pdfManager.ensureCatalog("getPageIndex", [
                                pageRef
                            ]);
                            return pageIndex;
                        } catch (ex) {
                            (0, _util.warn)(`_getPageIndex: "${ex}".`);
                            return -1;
                        }
                    }
                }
                exports.AnnotationFactory = AnnotationFactory;
                function getRgbColor(color) {
                    const rgbColor = new Uint8ClampedArray(3);
                    if (!Array.isArray(color)) return rgbColor;
                    switch(color.length){
                        case 0:
                            return null;
                        case 1:
                            _colorspace.ColorSpace.singletons.gray.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        case 3:
                            _colorspace.ColorSpace.singletons.rgb.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        case 4:
                            _colorspace.ColorSpace.singletons.cmyk.getRgbItem(color, 0, rgbColor, 0);
                            return rgbColor;
                        default:
                            return rgbColor;
                    }
                }
                function getQuadPoints(dict, rect) {
                    if (!dict.has("QuadPoints")) return null;
                    const quadPoints = dict.getArray("QuadPoints");
                    if (!Array.isArray(quadPoints) || quadPoints.length === 0 || quadPoints.length % 8 > 0) return null;
                    const quadPointsLists = [];
                    for(let i = 0, ii = quadPoints.length / 8; i < ii; i++){
                        quadPointsLists.push([]);
                        for(let j = i * 8, jj = i * 8 + 8; j < jj; j += 2){
                            const x = quadPoints[j];
                            const y = quadPoints[j + 1];
                            if (rect !== null && (x < rect[0] || x > rect[2] || y < rect[1] || y > rect[3])) return null;
                            quadPointsLists[i].push({
                                x: x,
                                y: y
                            });
                        }
                    }
                    return quadPointsLists.map((quadPointsList)=>{
                        const [minX, maxX, minY, maxY] = quadPointsList.reduce(([mX, MX, mY, MY], quadPoint)=>[
                                Math.min(mX, quadPoint.x),
                                Math.max(MX, quadPoint.x),
                                Math.min(mY, quadPoint.y),
                                Math.max(MY, quadPoint.y)
                            ], [
                            Number.MAX_VALUE,
                            Number.MIN_VALUE,
                            Number.MAX_VALUE,
                            Number.MIN_VALUE
                        ]);
                        return [
                            {
                                x: minX,
                                y: maxY
                            },
                            {
                                x: maxX,
                                y: maxY
                            },
                            {
                                x: minX,
                                y: minY
                            },
                            {
                                x: maxX,
                                y: minY
                            }
                        ];
                    });
                }
                function getTransformMatrix(rect, bbox, matrix) {
                    const [minX, minY, maxX, maxY] = _util.Util.getAxialAlignedBoundingBox(bbox, matrix);
                    if (minX === maxX || minY === maxY) return [
                        1,
                        0,
                        0,
                        1,
                        rect[0],
                        rect[1]
                    ];
                    const xRatio = (rect[2] - rect[0]) / (maxX - minX);
                    const yRatio = (rect[3] - rect[1]) / (maxY - minY);
                    return [
                        xRatio,
                        0,
                        0,
                        yRatio,
                        rect[0] - minX * xRatio,
                        rect[1] - minY * yRatio
                    ];
                }
                class Annotation {
                    constructor(params){
                        const dict = params.dict;
                        this.setContents(dict.get("Contents"));
                        this.setModificationDate(dict.get("M"));
                        this.setFlags(dict.get("F"));
                        this.setRectangle(dict.getArray("Rect"));
                        this.setColor(dict.getArray("C"));
                        this.setBorderStyle(dict);
                        this.setAppearance(dict);
                        this._streams = [];
                        if (this.appearance) this._streams.push(this.appearance);
                        this.data = {
                            annotationFlags: this.flags,
                            borderStyle: this.borderStyle,
                            color: this.color,
                            contents: this.contents,
                            hasAppearance: !!this.appearance,
                            id: params.id,
                            modificationDate: this.modificationDate,
                            rect: this.rectangle,
                            subtype: params.subtype
                        };
                        if (params.collectFields) {
                            const kids = dict.get("Kids");
                            if (Array.isArray(kids)) {
                                const kidIds = [];
                                for (const kid of kids)if ((0, _primitives.isRef)(kid)) kidIds.push(kid.toString());
                                if (kidIds.length !== 0) this.data.kidIds = kidIds;
                            }
                            this.data.actions = (0, _core_utils.collectActions)(params.xref, dict, _util.AnnotationActionEventType);
                            this.data.fieldName = this._constructFieldName(dict);
                            this.data.pageIndex = params.pageIndex;
                        }
                        this._fallbackFontDict = null;
                    }
                    _hasFlag(flags, flag) {
                        return !!(flags & flag);
                    }
                    _isViewable(flags) {
                        return !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE) && !this._hasFlag(flags, _util.AnnotationFlag.NOVIEW);
                    }
                    _isPrintable(flags) {
                        return this._hasFlag(flags, _util.AnnotationFlag.PRINT) && !this._hasFlag(flags, _util.AnnotationFlag.INVISIBLE);
                    }
                    mustBeViewed(annotationStorage) {
                        const storageEntry = annotationStorage && annotationStorage.get(this.data.id);
                        if (storageEntry && storageEntry.hidden !== undefined) return !storageEntry.hidden;
                        return this.viewable && !this._hasFlag(this.flags, _util.AnnotationFlag.HIDDEN);
                    }
                    mustBePrinted(annotationStorage) {
                        const storageEntry = annotationStorage && annotationStorage.get(this.data.id);
                        if (storageEntry && storageEntry.print !== undefined) return storageEntry.print;
                        return this.printable;
                    }
                    get viewable() {
                        if (this.data.quadPoints === null) return false;
                        if (this.flags === 0) return true;
                        return this._isViewable(this.flags);
                    }
                    get printable() {
                        if (this.data.quadPoints === null) return false;
                        if (this.flags === 0) return false;
                        return this._isPrintable(this.flags);
                    }
                    setContents(contents) {
                        this.contents = (0, _util.stringToPDFString)(contents || "");
                    }
                    setModificationDate(modificationDate) {
                        this.modificationDate = (0, _util.isString)(modificationDate) ? modificationDate : null;
                    }
                    setFlags(flags) {
                        this.flags = Number.isInteger(flags) && flags > 0 ? flags : 0;
                    }
                    hasFlag(flag) {
                        return this._hasFlag(this.flags, flag);
                    }
                    setRectangle(rectangle) {
                        if (Array.isArray(rectangle) && rectangle.length === 4) this.rectangle = _util.Util.normalizeRect(rectangle);
                        else this.rectangle = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    setColor(color) {
                        this.color = getRgbColor(color);
                    }
                    setBorderStyle(borderStyle) {
                        this.borderStyle = new AnnotationBorderStyle();
                        if (!(0, _primitives.isDict)(borderStyle)) return;
                        if (borderStyle.has("BS")) {
                            const dict = borderStyle.get("BS");
                            const dictType = dict.get("Type");
                            if (!dictType || (0, _primitives.isName)(dictType, "Border")) {
                                this.borderStyle.setWidth(dict.get("W"), this.rectangle);
                                this.borderStyle.setStyle(dict.get("S"));
                                this.borderStyle.setDashArray(dict.getArray("D"));
                            }
                        } else if (borderStyle.has("Border")) {
                            const array = borderStyle.getArray("Border");
                            if (Array.isArray(array) && array.length >= 3) {
                                this.borderStyle.setHorizontalCornerRadius(array[0]);
                                this.borderStyle.setVerticalCornerRadius(array[1]);
                                this.borderStyle.setWidth(array[2], this.rectangle);
                                if (array.length === 4) this.borderStyle.setDashArray(array[3]);
                            }
                        } else this.borderStyle.setWidth(0);
                    }
                    setAppearance(dict) {
                        this.appearance = null;
                        const appearanceStates = dict.get("AP");
                        if (!(0, _primitives.isDict)(appearanceStates)) return;
                        const normalAppearanceState = appearanceStates.get("N");
                        if ((0, _primitives.isStream)(normalAppearanceState)) {
                            this.appearance = normalAppearanceState;
                            return;
                        }
                        if (!(0, _primitives.isDict)(normalAppearanceState)) return;
                        const as = dict.get("AS");
                        if (!(0, _primitives.isName)(as) || !normalAppearanceState.has(as.name)) return;
                        this.appearance = normalAppearanceState.get(as.name);
                    }
                    loadResources(keys) {
                        return this.appearance.dict.getAsync("Resources").then((resources)=>{
                            if (!resources) return undefined;
                            const objectLoader = new _object_loader.ObjectLoader(resources, keys, resources.xref);
                            return objectLoader.load().then(function() {
                                return resources;
                            });
                        });
                    }
                    getOperatorList(evaluator, task, renderForms, annotationStorage) {
                        if (!this.appearance) return Promise.resolve(new _operator_list.OperatorList());
                        const appearance = this.appearance;
                        const data = this.data;
                        const appearanceDict = appearance.dict;
                        const resourcesPromise = this.loadResources([
                            "ExtGState",
                            "ColorSpace",
                            "Pattern",
                            "Shading",
                            "XObject",
                            "Font"
                        ]);
                        const bbox = appearanceDict.getArray("BBox") || [
                            0,
                            0,
                            1,
                            1
                        ];
                        const matrix = appearanceDict.getArray("Matrix") || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        const transform = getTransformMatrix(data.rect, bbox, matrix);
                        return resourcesPromise.then((resources)=>{
                            const opList = new _operator_list.OperatorList();
                            opList.addOp(_util.OPS.beginAnnotation, [
                                data.id,
                                data.rect,
                                transform,
                                matrix
                            ]);
                            return evaluator.getOperatorList({
                                stream: appearance,
                                task: task,
                                resources: resources,
                                operatorList: opList,
                                fallbackFontDict: this._fallbackFontDict
                            }).then(()=>{
                                opList.addOp(_util.OPS.endAnnotation, []);
                                this.reset();
                                return opList;
                            });
                        });
                    }
                    async save(evaluator, task, annotationStorage) {
                        return null;
                    }
                    getFieldObject() {
                        if (this.data.kidIds) return {
                            id: this.data.id,
                            actions: this.data.actions,
                            name: this.data.fieldName,
                            type: "",
                            kidIds: this.data.kidIds,
                            page: this.data.pageIndex
                        };
                        return null;
                    }
                    reset() {
                        for (const stream of this._streams)stream.reset();
                    }
                    _constructFieldName(dict) {
                        if (!dict.has("T") && !dict.has("Parent")) {
                            (0, _util.warn)("Unknown field name, falling back to empty field name.");
                            return "";
                        }
                        if (!dict.has("Parent")) return (0, _util.stringToPDFString)(dict.get("T"));
                        const fieldName = [];
                        if (dict.has("T")) fieldName.unshift((0, _util.stringToPDFString)(dict.get("T")));
                        let loopDict = dict;
                        const visited = new _primitives.RefSet();
                        if (dict.objId) visited.put(dict.objId);
                        while(loopDict.has("Parent")){
                            loopDict = loopDict.get("Parent");
                            if (!(loopDict instanceof _primitives.Dict) || loopDict.objId && visited.has(loopDict.objId)) break;
                            if (loopDict.objId) visited.put(loopDict.objId);
                            if (loopDict.has("T")) fieldName.unshift((0, _util.stringToPDFString)(loopDict.get("T")));
                        }
                        return fieldName.join(".");
                    }
                }
                exports.Annotation = Annotation;
                class AnnotationBorderStyle {
                    constructor(){
                        this.width = 1;
                        this.style = _util.AnnotationBorderStyleType.SOLID;
                        this.dashArray = [
                            3
                        ];
                        this.horizontalCornerRadius = 0;
                        this.verticalCornerRadius = 0;
                    }
                    setWidth(width, rect = [
                        0,
                        0,
                        0,
                        0
                    ]) {
                        if ((0, _primitives.isName)(width)) {
                            this.width = 0;
                            return;
                        }
                        if (Number.isInteger(width)) {
                            if (width > 0) {
                                const maxWidth = (rect[2] - rect[0]) / 2;
                                const maxHeight = (rect[3] - rect[1]) / 2;
                                if (maxWidth > 0 && maxHeight > 0 && (width > maxWidth || width > maxHeight)) {
                                    (0, _util.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${width}`);
                                    width = 1;
                                }
                            }
                            this.width = width;
                        }
                    }
                    setStyle(style) {
                        if (!(0, _primitives.isName)(style)) return;
                        switch(style.name){
                            case "S":
                                this.style = _util.AnnotationBorderStyleType.SOLID;
                                break;
                            case "D":
                                this.style = _util.AnnotationBorderStyleType.DASHED;
                                break;
                            case "B":
                                this.style = _util.AnnotationBorderStyleType.BEVELED;
                                break;
                            case "I":
                                this.style = _util.AnnotationBorderStyleType.INSET;
                                break;
                            case "U":
                                this.style = _util.AnnotationBorderStyleType.UNDERLINE;
                                break;
                            default:
                                break;
                        }
                    }
                    setDashArray(dashArray) {
                        if (Array.isArray(dashArray) && dashArray.length > 0) {
                            let isValid = true;
                            let allZeros = true;
                            for (const element of dashArray){
                                const validNumber = +element >= 0;
                                if (!validNumber) {
                                    isValid = false;
                                    break;
                                } else if (element > 0) allZeros = false;
                            }
                            if (isValid && !allZeros) this.dashArray = dashArray;
                            else this.width = 0;
                        } else if (dashArray) this.width = 0;
                    }
                    setHorizontalCornerRadius(radius) {
                        if (Number.isInteger(radius)) this.horizontalCornerRadius = radius;
                    }
                    setVerticalCornerRadius(radius) {
                        if (Number.isInteger(radius)) this.verticalCornerRadius = radius;
                    }
                }
                exports.AnnotationBorderStyle = AnnotationBorderStyle;
                class MarkupAnnotation extends Annotation {
                    constructor(parameters){
                        super(parameters);
                        const dict = parameters.dict;
                        if (dict.has("IRT")) {
                            const rawIRT = dict.getRaw("IRT");
                            this.data.inReplyTo = (0, _primitives.isRef)(rawIRT) ? rawIRT.toString() : null;
                            const rt = dict.get("RT");
                            this.data.replyType = (0, _primitives.isName)(rt) ? rt.name : _util.AnnotationReplyType.REPLY;
                        }
                        if (this.data.replyType === _util.AnnotationReplyType.GROUP) {
                            const parent = dict.get("IRT");
                            this.data.title = (0, _util.stringToPDFString)(parent.get("T") || "");
                            this.setContents(parent.get("Contents"));
                            this.data.contents = this.contents;
                            if (!parent.has("CreationDate")) this.data.creationDate = null;
                            else {
                                this.setCreationDate(parent.get("CreationDate"));
                                this.data.creationDate = this.creationDate;
                            }
                            if (!parent.has("M")) this.data.modificationDate = null;
                            else {
                                this.setModificationDate(parent.get("M"));
                                this.data.modificationDate = this.modificationDate;
                            }
                            this.data.hasPopup = parent.has("Popup");
                            if (!parent.has("C")) this.data.color = null;
                            else {
                                this.setColor(parent.getArray("C"));
                                this.data.color = this.color;
                            }
                        } else {
                            this.data.title = (0, _util.stringToPDFString)(dict.get("T") || "");
                            this.setCreationDate(dict.get("CreationDate"));
                            this.data.creationDate = this.creationDate;
                            this.data.hasPopup = dict.has("Popup");
                            if (!dict.has("C")) this.data.color = null;
                        }
                    }
                    setCreationDate(creationDate) {
                        this.creationDate = (0, _util.isString)(creationDate) ? creationDate : null;
                    }
                    _setDefaultAppearance({ xref: xref , extra: extra , strokeColor: strokeColor , fillColor: fillColor , blendMode: blendMode , strokeAlpha: strokeAlpha , fillAlpha: fillAlpha , pointsCallback: pointsCallback  }) {
                        let minX = Number.MAX_VALUE;
                        let minY = Number.MAX_VALUE;
                        let maxX = Number.MIN_VALUE;
                        let maxY = Number.MIN_VALUE;
                        const buffer = [
                            "q"
                        ];
                        if (extra) buffer.push(extra);
                        if (strokeColor) buffer.push(`${strokeColor[0]} ${strokeColor[1]} ${strokeColor[2]} RG`);
                        if (fillColor) buffer.push(`${fillColor[0]} ${fillColor[1]} ${fillColor[2]} rg`);
                        let pointsArray = this.data.quadPoints;
                        if (!pointsArray) pointsArray = [
                            [
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[3]
                                },
                                {
                                    x: this.rectangle[0],
                                    y: this.rectangle[1]
                                },
                                {
                                    x: this.rectangle[2],
                                    y: this.rectangle[1]
                                }
                            ]
                        ];
                        for (const points of pointsArray){
                            const [mX, MX, mY, MY] = pointsCallback(buffer, points);
                            minX = Math.min(minX, mX);
                            maxX = Math.max(maxX, MX);
                            minY = Math.min(minY, mY);
                            maxY = Math.max(maxY, MY);
                        }
                        buffer.push("Q");
                        const formDict = new _primitives.Dict(xref);
                        const appearanceStreamDict = new _primitives.Dict(xref);
                        appearanceStreamDict.set("Subtype", _primitives.Name.get("Form"));
                        const appearanceStream = new _stream.StringStream(buffer.join(" "));
                        appearanceStream.dict = appearanceStreamDict;
                        formDict.set("Fm0", appearanceStream);
                        const gsDict = new _primitives.Dict(xref);
                        if (blendMode) gsDict.set("BM", _primitives.Name.get(blendMode));
                        if (typeof strokeAlpha === "number") gsDict.set("CA", strokeAlpha);
                        if (typeof fillAlpha === "number") gsDict.set("ca", fillAlpha);
                        const stateDict = new _primitives.Dict(xref);
                        stateDict.set("GS0", gsDict);
                        const resources = new _primitives.Dict(xref);
                        resources.set("ExtGState", stateDict);
                        resources.set("XObject", formDict);
                        const appearanceDict = new _primitives.Dict(xref);
                        appearanceDict.set("Resources", resources);
                        const bbox = this.data.rect = [
                            minX,
                            minY,
                            maxX,
                            maxY
                        ];
                        appearanceDict.set("BBox", bbox);
                        this.appearance = new _stream.StringStream("/GS0 gs /Fm0 Do");
                        this.appearance.dict = appearanceDict;
                        this._streams.push(this.appearance, appearanceStream);
                    }
                }
                exports.MarkupAnnotation = MarkupAnnotation;
                class WidgetAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        const dict = params.dict;
                        const data = this.data;
                        this.ref = params.ref;
                        data.annotationType = _util.AnnotationType.WIDGET;
                        if (data.fieldName === undefined) data.fieldName = this._constructFieldName(dict);
                        if (data.actions === undefined) data.actions = (0, _core_utils.collectActions)(params.xref, dict, _util.AnnotationActionEventType);
                        const fieldValue = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "V",
                            getArray: true
                        });
                        data.fieldValue = this._decodeFormValue(fieldValue);
                        const defaultFieldValue = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DV",
                            getArray: true
                        });
                        data.defaultFieldValue = this._decodeFormValue(defaultFieldValue);
                        data.alternativeText = (0, _util.stringToPDFString)(dict.get("TU") || "");
                        const defaultAppearance = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DA"
                        }) || params.acroForm.get("DA");
                        this._defaultAppearance = (0, _util.isString)(defaultAppearance) ? defaultAppearance : "";
                        data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance);
                        const fieldType = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "FT"
                        });
                        data.fieldType = (0, _primitives.isName)(fieldType) ? fieldType.name : null;
                        const localResources = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "DR"
                        });
                        const acroFormResources = params.acroForm.get("DR");
                        const appearanceResources = this.appearance && this.appearance.dict.get("Resources");
                        this._fieldResources = {
                            localResources: localResources,
                            acroFormResources: acroFormResources,
                            appearanceResources: appearanceResources,
                            mergedResources: _primitives.Dict.merge({
                                xref: params.xref,
                                dictArray: [
                                    localResources,
                                    appearanceResources,
                                    acroFormResources
                                ],
                                mergeSubDicts: true
                            })
                        };
                        data.fieldFlags = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Ff"
                        });
                        if (!Number.isInteger(data.fieldFlags) || data.fieldFlags < 0) data.fieldFlags = 0;
                        data.readOnly = this.hasFieldFlag(_util.AnnotationFieldFlag.READONLY);
                        data.hidden = this._hasFlag(data.annotationFlags, _util.AnnotationFlag.HIDDEN);
                    }
                    _decodeFormValue(formValue) {
                        if (Array.isArray(formValue)) return formValue.filter((item)=>(0, _util.isString)(item)).map((item)=>(0, _util.stringToPDFString)(item));
                        else if ((0, _primitives.isName)(formValue)) return (0, _util.stringToPDFString)(formValue.name);
                        else if ((0, _util.isString)(formValue)) return (0, _util.stringToPDFString)(formValue);
                        return null;
                    }
                    hasFieldFlag(flag) {
                        return !!(this.data.fieldFlags & flag);
                    }
                    getOperatorList(evaluator, task, renderForms, annotationStorage) {
                        if (renderForms && !(this instanceof SignatureWidgetAnnotation)) return Promise.resolve(new _operator_list.OperatorList());
                        if (!this._hasText) return super.getOperatorList(evaluator, task, renderForms, annotationStorage);
                        return this._getAppearance(evaluator, task, annotationStorage).then((content)=>{
                            if (this.appearance && content === null) return super.getOperatorList(evaluator, task, renderForms, annotationStorage);
                            const operatorList = new _operator_list.OperatorList();
                            if (!this._defaultAppearance || content === null) return operatorList;
                            const matrix = [
                                1,
                                0,
                                0,
                                1,
                                0,
                                0
                            ];
                            const bbox = [
                                0,
                                0,
                                this.data.rect[2] - this.data.rect[0],
                                this.data.rect[3] - this.data.rect[1]
                            ];
                            const transform = getTransformMatrix(this.data.rect, bbox, matrix);
                            operatorList.addOp(_util.OPS.beginAnnotation, [
                                this.data.id,
                                this.data.rect,
                                transform,
                                matrix
                            ]);
                            const stream = new _stream.StringStream(content);
                            return evaluator.getOperatorList({
                                stream: stream,
                                task: task,
                                resources: this._fieldResources.mergedResources,
                                operatorList: operatorList
                            }).then(function() {
                                operatorList.addOp(_util.OPS.endAnnotation, []);
                                return operatorList;
                            });
                        });
                    }
                    async save(evaluator, task, annotationStorage) {
                        if (!annotationStorage) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        const value = storageEntry && storageEntry.value;
                        if (value === this.data.fieldValue || value === undefined) return null;
                        let appearance = await this._getAppearance(evaluator, task, annotationStorage);
                        if (appearance === null) return null;
                        const { xref: xref  } = evaluator;
                        const dict = xref.fetchIfRef(this.ref);
                        if (!(0, _primitives.isDict)(dict)) return null;
                        const bbox = [
                            0,
                            0,
                            this.data.rect[2] - this.data.rect[0],
                            this.data.rect[3] - this.data.rect[1]
                        ];
                        const xfa = {
                            path: (0, _util.stringToPDFString)(dict.get("T") || ""),
                            value: value
                        };
                        const newRef = xref.getNewRef();
                        const AP = new _primitives.Dict(xref);
                        AP.set("N", newRef);
                        const encrypt = xref.encrypt;
                        let originalTransform = null;
                        let newTransform = null;
                        if (encrypt) {
                            originalTransform = encrypt.createCipherTransform(this.ref.num, this.ref.gen);
                            newTransform = encrypt.createCipherTransform(newRef.num, newRef.gen);
                            appearance = newTransform.encryptString(appearance);
                        }
                        dict.set("V", (0, _util.isAscii)(value) ? value : (0, _util.stringToUTF16BEString)(value));
                        dict.set("AP", AP);
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        const appearanceDict = new _primitives.Dict(xref);
                        appearanceDict.set("Length", appearance.length);
                        appearanceDict.set("Subtype", _primitives.Name.get("Form"));
                        appearanceDict.set("Resources", this._getSaveFieldResources(xref));
                        appearanceDict.set("BBox", bbox);
                        const bufferOriginal = [
                            `${this.ref.num} ${this.ref.gen} obj\n`
                        ];
                        (0, _writer.writeDict)(dict, bufferOriginal, originalTransform);
                        bufferOriginal.push("\nendobj\n");
                        const bufferNew = [
                            `${newRef.num} ${newRef.gen} obj\n`
                        ];
                        (0, _writer.writeDict)(appearanceDict, bufferNew, newTransform);
                        bufferNew.push(" stream\n", appearance, "\nendstream\nendobj\n");
                        return [
                            {
                                ref: this.ref,
                                data: bufferOriginal.join(""),
                                xfa: xfa
                            },
                            {
                                ref: newRef,
                                data: bufferNew.join(""),
                                xfa: null
                            }
                        ];
                    }
                    async _getAppearance(evaluator, task, annotationStorage) {
                        const isPassword = this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD);
                        if (!annotationStorage || isPassword) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        let value = storageEntry && storageEntry.value;
                        if (value === undefined) return null;
                        value = value.trim();
                        if (value === "") return "";
                        let lineCount = -1;
                        if (this.data.multiLine) lineCount = value.split(/\r\n|\r|\n/).length;
                        const defaultPadding = 2;
                        const hPadding = defaultPadding;
                        const totalHeight = this.data.rect[3] - this.data.rect[1];
                        const totalWidth = this.data.rect[2] - this.data.rect[0];
                        if (!this._defaultAppearance) this.data.defaultAppearanceData = (0, _default_appearance.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g");
                        const [defaultAppearance, fontSize] = this._computeFontSize(totalHeight, lineCount);
                        const font1 = await this._getFontData(evaluator, task);
                        let descent = font1.descent;
                        if (isNaN(descent)) descent = 0;
                        const vPadding = defaultPadding + Math.abs(descent) * fontSize;
                        const alignment = this.data.textAlignment;
                        if (this.data.multiLine) return this._getMultilineAppearance(defaultAppearance, value, font1, fontSize, totalWidth, totalHeight, alignment, hPadding, vPadding);
                        const encodedString = font1.encodeString(value).join("");
                        if (this.data.comb) return this._getCombAppearance(defaultAppearance, font1, encodedString, totalWidth, hPadding, vPadding);
                        if (alignment === 0 || alignment > 2) return "/Tx BMC q BT " + defaultAppearance + ` 1 0 0 1 ${hPadding} ${vPadding} Tm (${(0, _util.escapeString)(encodedString)}) Tj` + " ET Q EMC";
                        const renderedText = this._renderText(encodedString, font1, fontSize, totalWidth, alignment, hPadding, vPadding);
                        return "/Tx BMC q BT " + defaultAppearance + ` 1 0 0 1 0 0 Tm ${renderedText}` + " ET Q EMC";
                    }
                    async _getFontData(evaluator, task) {
                        const operatorList = new _operator_list.OperatorList();
                        const initialState = {
                            font: null,
                            clone () {
                                return this;
                            }
                        };
                        const { fontName: fontName , fontSize: fontSize  } = this.data.defaultAppearanceData;
                        await evaluator.handleSetFont(this._fieldResources.mergedResources, [
                            fontName && _primitives.Name.get(fontName),
                            fontSize
                        ], null, operatorList, task, initialState, null);
                        return initialState.font;
                    }
                    _computeFontSize(height, lineCount) {
                        let { fontSize: fontSize  } = this.data.defaultAppearanceData;
                        if (!fontSize) {
                            const roundWithOneDigit = (x)=>Math.round(x * 10) / 10;
                            const FONT_FACTOR = 0.8;
                            if (lineCount === -1) fontSize = roundWithOneDigit(FONT_FACTOR * height);
                            else {
                                fontSize = 10;
                                let lineHeight = fontSize / FONT_FACTOR;
                                let numberOfLines = Math.round(height / lineHeight);
                                numberOfLines = Math.max(numberOfLines, lineCount);
                                lineHeight = height / numberOfLines;
                                fontSize = roundWithOneDigit(FONT_FACTOR * lineHeight);
                            }
                            const { fontName: fontName , fontColor: fontColor  } = this.data.defaultAppearanceData;
                            this._defaultAppearance = (0, _default_appearance.createDefaultAppearance)({
                                fontSize: fontSize,
                                fontName: fontName,
                                fontColor: fontColor
                            });
                        }
                        return [
                            this._defaultAppearance,
                            fontSize
                        ];
                    }
                    _renderText(text, font1, fontSize, totalWidth, alignment, hPadding, vPadding) {
                        const glyphs = font1.charsToGlyphs(text);
                        const scale = fontSize / 1000;
                        let width = 0;
                        for (const glyph of glyphs)width += glyph.width * scale;
                        let shift;
                        if (alignment === 1) shift = (totalWidth - width) / 2;
                        else if (alignment === 2) shift = totalWidth - width - hPadding;
                        else shift = hPadding;
                        shift = shift.toFixed(2);
                        vPadding = vPadding.toFixed(2);
                        return `${shift} ${vPadding} Td (${(0, _util.escapeString)(text)}) Tj`;
                    }
                    _getSaveFieldResources(xref) {
                        const { localResources: localResources , appearanceResources: appearanceResources , acroFormResources: acroFormResources  } = this._fieldResources;
                        const fontName = this.data.defaultAppearanceData && this.data.defaultAppearanceData.fontName;
                        if (!fontName) return localResources || _primitives.Dict.empty;
                        for (const resources of [
                            localResources,
                            appearanceResources
                        ])if (resources instanceof _primitives.Dict) {
                            const localFont = resources.get("Font");
                            if (localFont instanceof _primitives.Dict && localFont.has(fontName)) return resources;
                        }
                        if (acroFormResources instanceof _primitives.Dict) {
                            const acroFormFont = acroFormResources.get("Font");
                            if (acroFormFont instanceof _primitives.Dict && acroFormFont.has(fontName)) {
                                const subFontDict = new _primitives.Dict(xref);
                                subFontDict.set(fontName, acroFormFont.getRaw(fontName));
                                const subResourcesDict = new _primitives.Dict(xref);
                                subResourcesDict.set("Font", subFontDict);
                                return _primitives.Dict.merge({
                                    xref: xref,
                                    dictArray: [
                                        subResourcesDict,
                                        localResources
                                    ],
                                    mergeSubDicts: true
                                });
                            }
                        }
                        return localResources || _primitives.Dict.empty;
                    }
                    getFieldObject() {
                        return null;
                    }
                }
                class TextWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this._hasText = true;
                        const dict = params.dict;
                        if (!(0, _util.isString)(this.data.fieldValue)) this.data.fieldValue = "";
                        let alignment = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "Q"
                        });
                        if (!Number.isInteger(alignment) || alignment < 0 || alignment > 2) alignment = null;
                        this.data.textAlignment = alignment;
                        let maximumLength = (0, _core_utils.getInheritableProperty)({
                            dict: dict,
                            key: "MaxLen"
                        });
                        if (!Number.isInteger(maximumLength) || maximumLength < 0) maximumLength = null;
                        this.data.maxLen = maximumLength;
                        this.data.multiLine = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE);
                        this.data.comb = this.hasFieldFlag(_util.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(_util.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(_util.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== null;
                    }
                    _getCombAppearance(defaultAppearance, font1, text, width, hPadding, vPadding) {
                        const combWidth = (width / this.data.maxLen).toFixed(2);
                        const buf = [];
                        const positions = font1.getCharPositions(text);
                        for (const [start, end] of positions)buf.push(`(${(0, _util.escapeString)(text.substring(start, end))}) Tj`);
                        const renderedComb = buf.join(` ${combWidth} 0 Td `);
                        return "/Tx BMC q BT " + defaultAppearance + ` 1 0 0 1 ${hPadding} ${vPadding} Tm ${renderedComb}` + " ET Q EMC";
                    }
                    _getMultilineAppearance(defaultAppearance, text, font1, fontSize, width, height, alignment, hPadding, vPadding) {
                        const lines = text.split(/\r\n|\r|\n/);
                        const buf = [];
                        const totalWidth = width - 2 * hPadding;
                        for (const line of lines){
                            const chunks = this._splitLine(line, font1, fontSize, totalWidth);
                            for (const chunk of chunks){
                                const padding = buf.length === 0 ? hPadding : 0;
                                buf.push(this._renderText(chunk, font1, fontSize, width, alignment, padding, -fontSize));
                            }
                        }
                        const renderedText = buf.join("\n");
                        return "/Tx BMC q BT " + defaultAppearance + ` 1 0 0 1 0 ${height} Tm ${renderedText}` + " ET Q EMC";
                    }
                    _splitLine(line, font1, fontSize, width) {
                        line = font1.encodeString(line).join("");
                        const glyphs = font1.charsToGlyphs(line);
                        if (glyphs.length <= 1) return [
                            line
                        ];
                        const positions = font1.getCharPositions(line);
                        const scale = fontSize / 1000;
                        const chunks = [];
                        let lastSpacePosInStringStart = -1, lastSpacePosInStringEnd = -1, lastSpacePos = -1, startChunk = 0, currentWidth = 0;
                        for(let i = 0, ii = glyphs.length; i < ii; i++){
                            const [start, end] = positions[i];
                            const glyph = glyphs[i];
                            const glyphWidth = glyph.width * scale;
                            if (glyph.unicode === " ") {
                                if (currentWidth + glyphWidth > width) {
                                    chunks.push(line.substring(startChunk, start));
                                    startChunk = start;
                                    currentWidth = glyphWidth;
                                    lastSpacePosInStringStart = -1;
                                    lastSpacePos = -1;
                                } else {
                                    currentWidth += glyphWidth;
                                    lastSpacePosInStringStart = start;
                                    lastSpacePosInStringEnd = end;
                                    lastSpacePos = i;
                                }
                            } else if (currentWidth + glyphWidth > width) {
                                if (lastSpacePosInStringStart !== -1) {
                                    chunks.push(line.substring(startChunk, lastSpacePosInStringEnd));
                                    startChunk = lastSpacePosInStringEnd;
                                    i = lastSpacePos + 1;
                                    lastSpacePosInStringStart = -1;
                                    currentWidth = 0;
                                } else {
                                    chunks.push(line.substring(startChunk, start));
                                    startChunk = start;
                                    currentWidth = glyphWidth;
                                }
                            } else currentWidth += glyphWidth;
                        }
                        if (startChunk < line.length) chunks.push(line.substring(startChunk, line.length));
                        return chunks;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue,
                            defaultValue: this.data.defaultFieldValue,
                            multiline: this.data.multiLine,
                            password: this.hasFieldFlag(_util.AnnotationFieldFlag.PASSWORD),
                            charLimit: this.data.maxLen,
                            comb: this.data.comb,
                            editable: !this.data.readOnly,
                            hidden: this.data.hidden,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            type: "text"
                        };
                    }
                }
                class ButtonWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.checkedAppearance = null;
                        this.uncheckedAppearance = null;
                        this.data.checkBox = !this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.radioButton = this.hasFieldFlag(_util.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.pushButton = this.hasFieldFlag(_util.AnnotationFieldFlag.PUSHBUTTON);
                        this.data.isTooltipOnly = false;
                        if (this.data.checkBox) this._processCheckBox(params);
                        else if (this.data.radioButton) this._processRadioButton(params);
                        else if (this.data.pushButton) this._processPushButton(params);
                        else (0, _util.warn)("Invalid field flags for button widget annotation");
                    }
                    getOperatorList(evaluator, task, renderForms, annotationStorage) {
                        if (this.data.pushButton) return super.getOperatorList(evaluator, task, false, annotationStorage);
                        if (annotationStorage) {
                            const storageEntry = annotationStorage.get(this.data.id);
                            const value = storageEntry && storageEntry.value;
                            if (value === undefined) return super.getOperatorList(evaluator, task, renderForms, annotationStorage);
                            let appearance;
                            if (value) appearance = this.checkedAppearance;
                            else appearance = this.uncheckedAppearance;
                            if (appearance) {
                                const savedAppearance = this.appearance;
                                this.appearance = appearance;
                                const operatorList = super.getOperatorList(evaluator, task, renderForms, annotationStorage);
                                this.appearance = savedAppearance;
                                return operatorList;
                            }
                            return Promise.resolve(new _operator_list.OperatorList());
                        }
                        return super.getOperatorList(evaluator, task, renderForms, annotationStorage);
                    }
                    async save(evaluator, task, annotationStorage) {
                        if (this.data.checkBox) return this._saveCheckbox(evaluator, task, annotationStorage);
                        if (this.data.radioButton) return this._saveRadioButton(evaluator, task, annotationStorage);
                        return null;
                    }
                    async _saveCheckbox(evaluator, task, annotationStorage) {
                        if (!annotationStorage) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        const value = storageEntry && storageEntry.value;
                        if (value === undefined) return null;
                        const defaultValue = this.data.fieldValue && this.data.fieldValue !== "Off";
                        if (defaultValue === value) return null;
                        const dict = evaluator.xref.fetchIfRef(this.ref);
                        if (!(0, _primitives.isDict)(dict)) return null;
                        const xfa = {
                            path: (0, _util.stringToPDFString)(dict.get("T") || ""),
                            value: value ? this.data.exportValue : ""
                        };
                        const name = _primitives.Name.get(value ? this.data.exportValue : "Off");
                        dict.set("V", name);
                        dict.set("AS", name);
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        const encrypt = evaluator.xref.encrypt;
                        let originalTransform = null;
                        if (encrypt) originalTransform = encrypt.createCipherTransform(this.ref.num, this.ref.gen);
                        const buffer = [
                            `${this.ref.num} ${this.ref.gen} obj\n`
                        ];
                        (0, _writer.writeDict)(dict, buffer, originalTransform);
                        buffer.push("\nendobj\n");
                        return [
                            {
                                ref: this.ref,
                                data: buffer.join(""),
                                xfa: xfa
                            }
                        ];
                    }
                    async _saveRadioButton(evaluator, task, annotationStorage) {
                        if (!annotationStorage) return null;
                        const storageEntry = annotationStorage.get(this.data.id);
                        const value = storageEntry && storageEntry.value;
                        if (value === undefined) return null;
                        const defaultValue = this.data.fieldValue === this.data.buttonValue;
                        if (defaultValue === value) return null;
                        const dict = evaluator.xref.fetchIfRef(this.ref);
                        if (!(0, _primitives.isDict)(dict)) return null;
                        const xfa = {
                            path: (0, _util.stringToPDFString)(dict.get("T") || ""),
                            value: value ? this.data.buttonValue : ""
                        };
                        const name = _primitives.Name.get(value ? this.data.buttonValue : "Off");
                        let parentBuffer = null;
                        const encrypt = evaluator.xref.encrypt;
                        if (value) {
                            if ((0, _primitives.isRef)(this.parent)) {
                                const parent = evaluator.xref.fetch(this.parent);
                                let parentTransform = null;
                                if (encrypt) parentTransform = encrypt.createCipherTransform(this.parent.num, this.parent.gen);
                                parent.set("V", name);
                                parentBuffer = [
                                    `${this.parent.num} ${this.parent.gen} obj\n`
                                ];
                                (0, _writer.writeDict)(parent, parentBuffer, parentTransform);
                                parentBuffer.push("\nendobj\n");
                            } else if ((0, _primitives.isDict)(this.parent)) this.parent.set("V", name);
                        }
                        dict.set("AS", name);
                        dict.set("M", `D:${(0, _util.getModificationDate)()}`);
                        let originalTransform = null;
                        if (encrypt) originalTransform = encrypt.createCipherTransform(this.ref.num, this.ref.gen);
                        const buffer = [
                            `${this.ref.num} ${this.ref.gen} obj\n`
                        ];
                        (0, _writer.writeDict)(dict, buffer, originalTransform);
                        buffer.push("\nendobj\n");
                        const newRefs = [
                            {
                                ref: this.ref,
                                data: buffer.join(""),
                                xfa: xfa
                            }
                        ];
                        if (parentBuffer !== null) newRefs.push({
                            ref: this.parent,
                            data: parentBuffer.join(""),
                            xfa: null
                        });
                        return newRefs;
                    }
                    _processCheckBox(params) {
                        const customAppearance = params.dict.get("AP");
                        if (!(0, _primitives.isDict)(customAppearance)) return;
                        const normalAppearance = customAppearance.get("N");
                        if (!(0, _primitives.isDict)(normalAppearance)) return;
                        const exportValues = normalAppearance.getKeys();
                        if (!exportValues.includes("Off")) exportValues.push("Off");
                        if (!exportValues.includes(this.data.fieldValue)) this.data.fieldValue = null;
                        if (exportValues.length !== 2) return;
                        this.data.exportValue = exportValues[0] === "Off" ? exportValues[1] : exportValues[0];
                        this.checkedAppearance = normalAppearance.get(this.data.exportValue);
                        this.uncheckedAppearance = normalAppearance.get("Off") || null;
                        this._streams.push(this.checkedAppearance);
                        if (this.uncheckedAppearance) this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                    }
                    _processRadioButton(params) {
                        this.data.fieldValue = this.data.buttonValue = null;
                        const fieldParent = params.dict.get("Parent");
                        if ((0, _primitives.isDict)(fieldParent)) {
                            this.parent = params.dict.getRaw("Parent");
                            const fieldParentValue = fieldParent.get("V");
                            if ((0, _primitives.isName)(fieldParentValue)) this.data.fieldValue = this._decodeFormValue(fieldParentValue);
                        }
                        const appearanceStates = params.dict.get("AP");
                        if (!(0, _primitives.isDict)(appearanceStates)) return;
                        const normalAppearance = appearanceStates.get("N");
                        if (!(0, _primitives.isDict)(normalAppearance)) return;
                        for (const key of normalAppearance.getKeys())if (key !== "Off") {
                            this.data.buttonValue = this._decodeFormValue(key);
                            break;
                        }
                        this.checkedAppearance = normalAppearance.get(this.data.buttonValue);
                        this.uncheckedAppearance = normalAppearance.get("Off") || null;
                        this._streams.push(this.checkedAppearance);
                        if (this.uncheckedAppearance) this._streams.push(this.uncheckedAppearance);
                        this._fallbackFontDict = this.fallbackFontDict;
                    }
                    _processPushButton(params) {
                        if (!params.dict.has("A") && !params.dict.has("AA") && !this.data.alternativeText) {
                            (0, _util.warn)("Push buttons without action dictionaries are not supported");
                            return;
                        }
                        this.data.isTooltipOnly = !params.dict.has("A") && !params.dict.has("AA");
                        _catalog.Catalog.parseDestDictionary({
                            destDict: params.dict,
                            resultObj: this.data,
                            docBaseUrl: params.pdfManager.docBaseUrl
                        });
                    }
                    getFieldObject() {
                        let type = "button";
                        let exportValues;
                        if (this.data.checkBox) {
                            type = "checkbox";
                            exportValues = this.data.exportValue;
                        } else if (this.data.radioButton) {
                            type = "radiobutton";
                            exportValues = this.data.buttonValue;
                        }
                        return {
                            id: this.data.id,
                            value: this.data.fieldValue || "Off",
                            defaultValue: this.data.defaultFieldValue,
                            exportValues: exportValues,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            page: this.data.pageIndex,
                            type: type
                        };
                    }
                    get fallbackFontDict() {
                        const dict = new _primitives.Dict();
                        dict.set("BaseFont", _primitives.Name.get("ZapfDingbats"));
                        dict.set("Type", _primitives.Name.get("FallbackType"));
                        dict.set("Subtype", _primitives.Name.get("FallbackType"));
                        dict.set("Encoding", _primitives.Name.get("ZapfDingbatsEncoding"));
                        return (0, _util.shadow)(this, "fallbackFontDict", dict);
                    }
                }
                class ChoiceWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.data.options = [];
                        const options = (0, _core_utils.getInheritableProperty)({
                            dict: params.dict,
                            key: "Opt"
                        });
                        if (Array.isArray(options)) {
                            const xref = params.xref;
                            for(let i = 0, ii = options.length; i < ii; i++){
                                const option = xref.fetchIfRef(options[i]);
                                const isOptionArray = Array.isArray(option);
                                this.data.options[i] = {
                                    exportValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[0]) : option),
                                    displayValue: this._decodeFormValue(isOptionArray ? xref.fetchIfRef(option[1]) : option)
                                };
                            }
                        }
                        if ((0, _util.isString)(this.data.fieldValue)) this.data.fieldValue = [
                            this.data.fieldValue
                        ];
                        else if (!this.data.fieldValue) this.data.fieldValue = [];
                        this.data.combo = this.hasFieldFlag(_util.AnnotationFieldFlag.COMBO);
                        this.data.multiSelect = this.hasFieldFlag(_util.AnnotationFieldFlag.MULTISELECT);
                        this._hasText = true;
                    }
                    getFieldObject() {
                        const type = this.data.combo ? "combobox" : "listbox";
                        const value = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
                        return {
                            id: this.data.id,
                            value: value,
                            defaultValue: this.data.defaultFieldValue,
                            editable: !this.data.readOnly,
                            name: this.data.fieldName,
                            rect: this.data.rect,
                            numItems: this.data.fieldValue.length,
                            multipleSelection: this.data.multiSelect,
                            hidden: this.data.hidden,
                            actions: this.data.actions,
                            items: this.data.options,
                            page: this.data.pageIndex,
                            type: type
                        };
                    }
                }
                class SignatureWidgetAnnotation extends WidgetAnnotation {
                    constructor(params){
                        super(params);
                        this.data.fieldValue = null;
                    }
                    getFieldObject() {
                        return {
                            id: this.data.id,
                            value: null,
                            page: this.data.pageIndex,
                            type: "signature"
                        };
                    }
                }
                class TextAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        const DEFAULT_ICON_SIZE = 22;
                        super(parameters);
                        const dict = parameters.dict;
                        this.data.annotationType = _util.AnnotationType.TEXT;
                        if (this.data.hasAppearance) this.data.name = "NoIcon";
                        else {
                            this.data.rect[1] = this.data.rect[3] - DEFAULT_ICON_SIZE;
                            this.data.rect[2] = this.data.rect[0] + DEFAULT_ICON_SIZE;
                            this.data.name = dict.has("Name") ? dict.get("Name").name : "Note";
                        }
                        if (dict.has("State")) {
                            this.data.state = dict.get("State") || null;
                            this.data.stateModel = dict.get("StateModel") || null;
                        } else {
                            this.data.state = null;
                            this.data.stateModel = null;
                        }
                    }
                }
                class LinkAnnotation extends Annotation {
                    constructor(params){
                        super(params);
                        this.data.annotationType = _util.AnnotationType.LINK;
                        const quadPoints = getQuadPoints(params.dict, this.rectangle);
                        if (quadPoints) this.data.quadPoints = quadPoints;
                        _catalog.Catalog.parseDestDictionary({
                            destDict: params.dict,
                            resultObj: this.data,
                            docBaseUrl: params.pdfManager.docBaseUrl
                        });
                    }
                }
                class PopupAnnotation extends Annotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.POPUP;
                        let parentItem = parameters.dict.get("Parent");
                        if (!parentItem) {
                            (0, _util.warn)("Popup annotation has a missing or invalid parent annotation.");
                            return;
                        }
                        const parentSubtype = parentItem.get("Subtype");
                        this.data.parentType = (0, _primitives.isName)(parentSubtype) ? parentSubtype.name : null;
                        const rawParent = parameters.dict.getRaw("Parent");
                        this.data.parentId = (0, _primitives.isRef)(rawParent) ? rawParent.toString() : null;
                        const parentRect = parentItem.getArray("Rect");
                        if (Array.isArray(parentRect) && parentRect.length === 4) this.data.parentRect = _util.Util.normalizeRect(parentRect);
                        else this.data.parentRect = [
                            0,
                            0,
                            0,
                            0
                        ];
                        const rt = parentItem.get("RT");
                        if ((0, _primitives.isName)(rt, _util.AnnotationReplyType.GROUP)) parentItem = parentItem.get("IRT");
                        if (!parentItem.has("M")) this.data.modificationDate = null;
                        else {
                            this.setModificationDate(parentItem.get("M"));
                            this.data.modificationDate = this.modificationDate;
                        }
                        if (!parentItem.has("C")) this.data.color = null;
                        else {
                            this.setColor(parentItem.getArray("C"));
                            this.data.color = this.color;
                        }
                        if (!this.viewable) {
                            const parentFlags = parentItem.get("F");
                            if (this._isViewable(parentFlags)) this.setFlags(parentFlags);
                        }
                        this.data.title = (0, _util.stringToPDFString)(parentItem.get("T") || "");
                        this.data.contents = (0, _util.stringToPDFString)(parentItem.get("Contents") || "");
                    }
                }
                class FreeTextAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.FREETEXT;
                    }
                }
                class LineAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.LINE;
                        const lineCoordinates = parameters.dict.getArray("L");
                        this.data.lineCoordinates = _util.Util.normalizeRect(lineCoordinates);
                        if (!this.appearance) {
                            const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = parameters.dict.get("CA");
                            let fillColor = null, interiorColor = parameters.dict.getArray("IC");
                            if (interiorColor) {
                                interiorColor = getRgbColor(interiorColor);
                                fillColor = interiorColor ? Array.from(interiorColor).map((c)=>c / 255) : null;
                            }
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                this.data.lineCoordinates[0] - borderAdjust,
                                this.data.lineCoordinates[1] - borderAdjust,
                                this.data.lineCoordinates[2] + borderAdjust,
                                this.data.lineCoordinates[3] + borderAdjust
                            ];
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: parameters.xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    buffer.push(`${lineCoordinates[0]} ${lineCoordinates[1]} m`, `${lineCoordinates[2]} ${lineCoordinates[3]} l`, "S");
                                    return [
                                        points[0].x - borderWidth,
                                        points[1].x + borderWidth,
                                        points[3].y - borderWidth,
                                        points[1].y + borderWidth
                                    ];
                                }
                            });
                        }
                    }
                }
                class SquareAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.SQUARE;
                        if (!this.appearance) {
                            const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = parameters.dict.get("CA");
                            let fillColor = null, interiorColor = parameters.dict.getArray("IC");
                            if (interiorColor) {
                                interiorColor = getRgbColor(interiorColor);
                                fillColor = interiorColor ? Array.from(interiorColor).map((c)=>c / 255) : null;
                            }
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            this._setDefaultAppearance({
                                xref: parameters.xref,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const x = points[2].x + this.borderStyle.width / 2;
                                    const y = points[2].y + this.borderStyle.width / 2;
                                    const width = points[3].x - points[2].x - this.borderStyle.width;
                                    const height = points[1].y - points[3].y - this.borderStyle.width;
                                    buffer.push(`${x} ${y} ${width} ${height} re`);
                                    if (fillColor) buffer.push("B");
                                    else buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class CircleAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.CIRCLE;
                        if (!this.appearance) {
                            const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = parameters.dict.get("CA");
                            let fillColor = null;
                            let interiorColor = parameters.dict.getArray("IC");
                            if (interiorColor) {
                                interiorColor = getRgbColor(interiorColor);
                                fillColor = interiorColor ? Array.from(interiorColor).map((c)=>c / 255) : null;
                            }
                            const fillAlpha = fillColor ? strokeAlpha : null;
                            const controlPointsDistance = 4 / 3 * Math.tan(Math.PI / 8);
                            this._setDefaultAppearance({
                                xref: parameters.xref,
                                extra: `${this.borderStyle.width} w`,
                                strokeColor: strokeColor,
                                fillColor: fillColor,
                                strokeAlpha: strokeAlpha,
                                fillAlpha: fillAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const x0 = points[0].x + this.borderStyle.width / 2;
                                    const y0 = points[0].y - this.borderStyle.width / 2;
                                    const x1 = points[3].x - this.borderStyle.width / 2;
                                    const y1 = points[3].y + this.borderStyle.width / 2;
                                    const xMid = x0 + (x1 - x0) / 2;
                                    const yMid = y0 + (y1 - y0) / 2;
                                    const xOffset = (x1 - x0) / 2 * controlPointsDistance;
                                    const yOffset = (y1 - y0) / 2 * controlPointsDistance;
                                    buffer.push(`${xMid} ${y1} m`, `${xMid + xOffset} ${y1} ${x1} ${yMid + yOffset} ${x1} ${yMid} c`, `${x1} ${yMid - yOffset} ${xMid + xOffset} ${y0} ${xMid} ${y0} c`, `${xMid - xOffset} ${y0} ${x0} ${yMid - yOffset} ${x0} ${yMid} c`, `${x0} ${yMid + yOffset} ${xMid - xOffset} ${y1} ${xMid} ${y1} c`, "h");
                                    if (fillColor) buffer.push("B");
                                    else buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class PolylineAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.POLYLINE;
                        this.data.vertices = [];
                        const rawVertices = parameters.dict.getArray("Vertices");
                        if (!Array.isArray(rawVertices)) return;
                        for(let i = 0, ii = rawVertices.length; i < ii; i += 2)this.data.vertices.push({
                            x: rawVertices[i],
                            y: rawVertices[i + 1]
                        });
                        if (!this.appearance) {
                            const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = parameters.dict.get("CA");
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            for (const vertex of this.data.vertices){
                                bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                                bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                                bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                                bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                            }
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: parameters.xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                strokeAlpha: strokeAlpha,
                                pointsCallback: (buffer, points)=>{
                                    const vertices = this.data.vertices;
                                    for(let i = 0, ii = vertices.length; i < ii; i++)buffer.push(`${vertices[i].x} ${vertices[i].y} ${i === 0 ? "m" : "l"}`);
                                    buffer.push("S");
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class PolygonAnnotation extends PolylineAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.POLYGON;
                    }
                }
                class CaretAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.CARET;
                    }
                }
                class InkAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.INK;
                        this.data.inkLists = [];
                        const rawInkLists = parameters.dict.getArray("InkList");
                        if (!Array.isArray(rawInkLists)) return;
                        const xref = parameters.xref;
                        for(let i = 0, ii = rawInkLists.length; i < ii; ++i){
                            this.data.inkLists.push([]);
                            for(let j = 0, jj = rawInkLists[i].length; j < jj; j += 2)this.data.inkLists[i].push({
                                x: xref.fetchIfRef(rawInkLists[i][j]),
                                y: xref.fetchIfRef(rawInkLists[i][j + 1])
                            });
                        }
                        if (!this.appearance) {
                            const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                0,
                                0,
                                0
                            ];
                            const strokeAlpha = parameters.dict.get("CA");
                            const borderWidth = this.borderStyle.width || 1, borderAdjust = 2 * borderWidth;
                            const bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            for (const inkLists of this.data.inkLists)for (const vertex of inkLists){
                                bbox[0] = Math.min(bbox[0], vertex.x - borderAdjust);
                                bbox[1] = Math.min(bbox[1], vertex.y - borderAdjust);
                                bbox[2] = Math.max(bbox[2], vertex.x + borderAdjust);
                                bbox[3] = Math.max(bbox[3], vertex.y + borderAdjust);
                            }
                            if (!_util.Util.intersect(this.rectangle, bbox)) this.rectangle = bbox;
                            this._setDefaultAppearance({
                                xref: parameters.xref,
                                extra: `${borderWidth} w`,
                                strokeColor: strokeColor,
                                strokeAlpha: strokeAlpha,
                                pointsCallback: (buffer, points)=>{
                                    for (const inkList of this.data.inkLists){
                                        for(let i = 0, ii = inkList.length; i < ii; i++)buffer.push(`${inkList[i].x} ${inkList[i].y} ${i === 0 ? "m" : "l"}`);
                                        buffer.push("S");
                                    }
                                    return [
                                        points[0].x,
                                        points[1].x,
                                        points[3].y,
                                        points[1].y
                                    ];
                                }
                            });
                        }
                    }
                }
                class HighlightAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.HIGHLIGHT;
                        const quadPoints = this.data.quadPoints = getQuadPoints(parameters.dict, null);
                        if (quadPoints) {
                            const resources = this.appearance && this.appearance.dict.get("Resources");
                            if (!this.appearance || !(resources && resources.has("ExtGState"))) {
                                if (this.appearance) (0, _util.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                                const fillColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                    1,
                                    1,
                                    0
                                ];
                                const fillAlpha = parameters.dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: parameters.xref,
                                    fillColor: fillColor,
                                    blendMode: "Multiply",
                                    fillAlpha: fillAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${points[0].x} ${points[0].y} m`, `${points[1].x} ${points[1].y} l`, `${points[3].x} ${points[3].y} l`, `${points[2].x} ${points[2].y} l`, "f");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.hasPopup = false;
                    }
                }
                class UnderlineAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.UNDERLINE;
                        const quadPoints = this.data.quadPoints = getQuadPoints(parameters.dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = parameters.dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: parameters.xref,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${points[2].x} ${points[2].y} m`, `${points[3].x} ${points[3].y} l`, "S");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.hasPopup = false;
                    }
                }
                class SquigglyAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.SQUIGGLY;
                        const quadPoints = this.data.quadPoints = getQuadPoints(parameters.dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = parameters.dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: parameters.xref,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        const dy = (points[0].y - points[2].y) / 6;
                                        let shift = dy;
                                        let x = points[2].x;
                                        const y = points[2].y;
                                        const xEnd = points[3].x;
                                        buffer.push(`${x} ${y + shift} m`);
                                        do {
                                            x += 2;
                                            shift = shift === 0 ? dy : 0;
                                            buffer.push(`${x} ${y + shift} l`);
                                        }while (x < xEnd);
                                        buffer.push("S");
                                        return [
                                            points[2].x,
                                            xEnd,
                                            y - 2 * dy,
                                            y + 2 * dy
                                        ];
                                    }
                                });
                            }
                        } else this.data.hasPopup = false;
                    }
                }
                class StrikeOutAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.STRIKEOUT;
                        const quadPoints = this.data.quadPoints = getQuadPoints(parameters.dict, null);
                        if (quadPoints) {
                            if (!this.appearance) {
                                const strokeColor = this.color ? Array.from(this.color).map((c)=>c / 255) : [
                                    0,
                                    0,
                                    0
                                ];
                                const strokeAlpha = parameters.dict.get("CA");
                                this._setDefaultAppearance({
                                    xref: parameters.xref,
                                    extra: "[] 0 d 1 w",
                                    strokeColor: strokeColor,
                                    strokeAlpha: strokeAlpha,
                                    pointsCallback: (buffer, points)=>{
                                        buffer.push(`${(points[0].x + points[2].x) / 2} ` + `${(points[0].y + points[2].y) / 2} m`, `${(points[1].x + points[3].x) / 2} ` + `${(points[1].y + points[3].y) / 2} l`, "S");
                                        return [
                                            points[0].x,
                                            points[1].x,
                                            points[3].y,
                                            points[1].y
                                        ];
                                    }
                                });
                            }
                        } else this.data.hasPopup = false;
                    }
                }
                class StampAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        this.data.annotationType = _util.AnnotationType.STAMP;
                    }
                }
                class FileAttachmentAnnotation extends MarkupAnnotation {
                    constructor(parameters){
                        super(parameters);
                        const file = new _file_spec.FileSpec(parameters.dict.get("FS"), parameters.xref);
                        this.data.annotationType = _util.AnnotationType.FILEATTACHMENT;
                        this.data.file = file.serializable;
                    }
                }
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createDefaultAppearance = createDefaultAppearance;
                exports.parseDefaultAppearance = parseDefaultAppearance;
                var _util = __w_pdfjs_require__(2);
                var _colorspace = __w_pdfjs_require__(14);
                var _core_utils = __w_pdfjs_require__(9);
                var _evaluator = __w_pdfjs_require__(15);
                var _primitives = __w_pdfjs_require__(5);
                var _stream = __w_pdfjs_require__(10);
                class DefaultAppearanceEvaluator extends _evaluator.EvaluatorPreprocessor {
                    constructor(str){
                        super(new _stream.StringStream(str));
                    }
                    parse() {
                        const operation = {
                            fn: 0,
                            args: []
                        };
                        const result = {
                            fontSize: 0,
                            fontName: "",
                            fontColor: new Uint8ClampedArray(3)
                        };
                        try {
                            while(true){
                                operation.args.length = 0;
                                if (!this.read(operation)) break;
                                if (this.savedStatesDepth !== 0) continue;
                                const { fn: fn , args: args  } = operation;
                                switch(fn | 0){
                                    case _util.OPS.setFont:
                                        const [fontName, fontSize] = args;
                                        if (fontName instanceof _primitives.Name) result.fontName = fontName.name;
                                        if (typeof fontSize === "number" && fontSize > 0) result.fontSize = fontSize;
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        _colorspace.ColorSpace.singletons.rgb.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillGray:
                                        _colorspace.ColorSpace.singletons.gray.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                    case _util.OPS.setFillColorSpace:
                                        _colorspace.ColorSpace.singletons.cmyk.getRgbItem(args, 0, result.fontColor, 0);
                                        break;
                                }
                            }
                        } catch (reason) {
                            (0, _util.warn)(`parseDefaultAppearance - ignoring errors: "${reason}".`);
                        }
                        return result;
                    }
                }
                function parseDefaultAppearance(str) {
                    return new DefaultAppearanceEvaluator(str).parse();
                }
                function createDefaultAppearance({ fontSize: fontSize , fontName: fontName , fontColor: fontColor  }) {
                    let colorCmd;
                    if (fontColor.every((c)=>c === 0)) colorCmd = "0 g";
                    else colorCmd = Array.from(fontColor).map((c)=>(c / 255).toFixed(2)).join(" ") + " rg";
                    return `/${(0, _core_utils.escapePDFName)(fontName)} ${fontSize} Tf ${colorCmd}`;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorSpace = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                function resizeRgbImage(src, dest, w1, h1, w2, h2, alpha01) {
                    const COMPONENTS = 3;
                    alpha01 = alpha01 !== 1 ? 0 : alpha01;
                    const xRatio = w1 / w2;
                    const yRatio = h1 / h2;
                    let newIndex = 0, oldIndex;
                    const xScaled = new Uint16Array(w2);
                    const w1Scanline = w1 * COMPONENTS;
                    for(let i = 0; i < w2; i++)xScaled[i] = Math.floor(i * xRatio) * COMPONENTS;
                    for(let i = 0; i < h2; i++){
                        const py = Math.floor(i * yRatio) * w1Scanline;
                        for(let j = 0; j < w2; j++){
                            oldIndex = py + xScaled[j];
                            dest[newIndex++] = src[oldIndex++];
                            dest[newIndex++] = src[oldIndex++];
                            dest[newIndex++] = src[oldIndex++];
                            newIndex += alpha01;
                        }
                    }
                }
                class ColorSpace {
                    constructor(name, numComps){
                        if (this.constructor === ColorSpace) (0, _util.unreachable)("Cannot initialize ColorSpace.");
                        this.name = name;
                        this.numComps = numComps;
                    }
                    getRgb(src, srcOffset) {
                        const rgb = new Uint8ClampedArray(3);
                        this.getRgbItem(src, srcOffset, rgb, 0);
                        return rgb;
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        (0, _util.unreachable)("Should not call ColorSpace.getRgbItem");
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        (0, _util.unreachable)("Should not call ColorSpace.getRgbBuffer");
                    }
                    getOutputLength(inputLength, alpha01) {
                        (0, _util.unreachable)("Should not call ColorSpace.getOutputLength");
                    }
                    isPassthrough(bits) {
                        return false;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        return ColorSpace.isDefaultDecode(decodeMap, this.numComps);
                    }
                    fillRgb(dest, originalWidth, originalHeight, width, height, actualHeight, bpc, comps, alpha01) {
                        const count = originalWidth * originalHeight;
                        let rgbBuf = null;
                        const numComponentColors = 1 << bpc;
                        const needsResizing = originalHeight !== height || originalWidth !== width;
                        if (this.isPassthrough(bpc)) rgbBuf = comps;
                        else if (this.numComps === 1 && count > numComponentColors && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                            const allColors = bpc <= 8 ? new Uint8Array(numComponentColors) : new Uint16Array(numComponentColors);
                            for(let i = 0; i < numComponentColors; i++)allColors[i] = i;
                            const colorMap = new Uint8ClampedArray(numComponentColors * 3);
                            this.getRgbBuffer(allColors, 0, numComponentColors, colorMap, 0, bpc, 0);
                            if (!needsResizing) {
                                let destPos = 0;
                                for(let i = 0; i < count; ++i){
                                    const key = comps[i] * 3;
                                    dest[destPos++] = colorMap[key];
                                    dest[destPos++] = colorMap[key + 1];
                                    dest[destPos++] = colorMap[key + 2];
                                    destPos += alpha01;
                                }
                            } else {
                                rgbBuf = new Uint8Array(count * 3);
                                let rgbPos = 0;
                                for(let i = 0; i < count; ++i){
                                    const key = comps[i] * 3;
                                    rgbBuf[rgbPos++] = colorMap[key];
                                    rgbBuf[rgbPos++] = colorMap[key + 1];
                                    rgbBuf[rgbPos++] = colorMap[key + 2];
                                }
                            }
                        } else if (!needsResizing) this.getRgbBuffer(comps, 0, width * actualHeight, dest, 0, bpc, alpha01);
                        else {
                            rgbBuf = new Uint8ClampedArray(count * 3);
                            this.getRgbBuffer(comps, 0, count, rgbBuf, 0, bpc, 0);
                        }
                        if (rgbBuf) {
                            if (needsResizing) resizeRgbImage(rgbBuf, dest, originalWidth, originalHeight, width, height, alpha01);
                            else {
                                let destPos = 0, rgbPos = 0;
                                for(let i = 0, ii = width * actualHeight; i < ii; i++){
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    dest[destPos++] = rgbBuf[rgbPos++];
                                    destPos += alpha01;
                                }
                            }
                        }
                    }
                    get usesZeroToOneRange() {
                        return (0, _util.shadow)(this, "usesZeroToOneRange", true);
                    }
                    static _cache(cacheKey, xref, localColorSpaceCache, parsedColorSpace) {
                        if (!localColorSpaceCache) throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
                        if (!parsedColorSpace) throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
                        let csName, csRef;
                        if (cacheKey instanceof _primitives.Ref) {
                            csRef = cacheKey;
                            cacheKey = xref.fetch(cacheKey);
                        }
                        if (cacheKey instanceof _primitives.Name) csName = cacheKey.name;
                        if (csName || csRef) localColorSpaceCache.set(csName, csRef, parsedColorSpace);
                    }
                    static getCached(cacheKey, xref, localColorSpaceCache) {
                        if (!localColorSpaceCache) throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
                        if (cacheKey instanceof _primitives.Ref) {
                            const localColorSpace = localColorSpaceCache.getByRef(cacheKey);
                            if (localColorSpace) return localColorSpace;
                            try {
                                cacheKey = xref.fetch(cacheKey);
                            } catch (ex) {
                                if (ex instanceof _core_utils.MissingDataException) throw ex;
                            }
                        }
                        if (cacheKey instanceof _primitives.Name) {
                            const localColorSpace = localColorSpaceCache.getByName(cacheKey.name);
                            if (localColorSpace) return localColorSpace;
                        }
                        return null;
                    }
                    static async parseAsync({ cs: cs , xref: xref , resources: resources = null , pdfFunctionFactory: pdfFunctionFactory , localColorSpaceCache: localColorSpaceCache  }) {
                        const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                        this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                        return parsedColorSpace;
                    }
                    static parse({ cs: cs , xref: xref , resources: resources = null , pdfFunctionFactory: pdfFunctionFactory , localColorSpaceCache: localColorSpaceCache  }) {
                        const cachedColorSpace = this.getCached(cs, xref, localColorSpaceCache);
                        if (cachedColorSpace) return cachedColorSpace;
                        const parsedColorSpace = this._parse(cs, xref, resources, pdfFunctionFactory);
                        this._cache(cs, xref, localColorSpaceCache, parsedColorSpace);
                        return parsedColorSpace;
                    }
                    static _parse(cs, xref, resources = null, pdfFunctionFactory) {
                        cs = xref.fetchIfRef(cs);
                        if ((0, _primitives.isName)(cs)) switch(cs.name){
                            case "DeviceGray":
                            case "G":
                                return this.singletons.gray;
                            case "DeviceRGB":
                            case "RGB":
                                return this.singletons.rgb;
                            case "DeviceCMYK":
                            case "CMYK":
                                return this.singletons.cmyk;
                            case "Pattern":
                                return new PatternCS(null);
                            default:
                                if ((0, _primitives.isDict)(resources)) {
                                    const colorSpaces = resources.get("ColorSpace");
                                    if ((0, _primitives.isDict)(colorSpaces)) {
                                        const resourcesCS = colorSpaces.get(cs.name);
                                        if (resourcesCS) {
                                            if ((0, _primitives.isName)(resourcesCS)) return this._parse(resourcesCS, xref, resources, pdfFunctionFactory);
                                            cs = resourcesCS;
                                            break;
                                        }
                                    }
                                }
                                throw new _util.FormatError(`Unrecognized ColorSpace: ${cs.name}`);
                        }
                        if (Array.isArray(cs)) {
                            const mode = xref.fetchIfRef(cs[0]).name;
                            let params, numComps, baseCS, whitePoint, blackPoint, gamma;
                            switch(mode){
                                case "DeviceGray":
                                case "G":
                                    return this.singletons.gray;
                                case "DeviceRGB":
                                case "RGB":
                                    return this.singletons.rgb;
                                case "DeviceCMYK":
                                case "CMYK":
                                    return this.singletons.cmyk;
                                case "CalGray":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    gamma = params.get("Gamma");
                                    return new CalGrayCS(whitePoint, blackPoint, gamma);
                                case "CalRGB":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    gamma = params.getArray("Gamma");
                                    const matrix = params.getArray("Matrix");
                                    return new CalRGBCS(whitePoint, blackPoint, gamma, matrix);
                                case "ICCBased":
                                    const stream = xref.fetchIfRef(cs[1]);
                                    const dict = stream.dict;
                                    numComps = dict.get("N");
                                    const alt = dict.get("Alternate");
                                    if (alt) {
                                        const altCS = this._parse(alt, xref, resources, pdfFunctionFactory);
                                        if (altCS.numComps === numComps) return altCS;
                                        (0, _util.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                                    }
                                    if (numComps === 1) return this.singletons.gray;
                                    else if (numComps === 3) return this.singletons.rgb;
                                    else if (numComps === 4) return this.singletons.cmyk;
                                    break;
                                case "Pattern":
                                    baseCS = cs[1] || null;
                                    if (baseCS) baseCS = this._parse(baseCS, xref, resources, pdfFunctionFactory);
                                    return new PatternCS(baseCS);
                                case "Indexed":
                                case "I":
                                    baseCS = this._parse(cs[1], xref, resources, pdfFunctionFactory);
                                    const hiVal = xref.fetchIfRef(cs[2]) + 1;
                                    const lookup = xref.fetchIfRef(cs[3]);
                                    return new IndexedCS(baseCS, hiVal, lookup);
                                case "Separation":
                                case "DeviceN":
                                    const name = xref.fetchIfRef(cs[1]);
                                    numComps = Array.isArray(name) ? name.length : 1;
                                    baseCS = this._parse(cs[2], xref, resources, pdfFunctionFactory);
                                    const tintFn = pdfFunctionFactory.create(cs[3]);
                                    return new AlternateCS(numComps, baseCS, tintFn);
                                case "Lab":
                                    params = xref.fetchIfRef(cs[1]);
                                    whitePoint = params.getArray("WhitePoint");
                                    blackPoint = params.getArray("BlackPoint");
                                    const range = params.getArray("Range");
                                    return new LabCS(whitePoint, blackPoint, range);
                                default:
                                    throw new _util.FormatError(`Unimplemented ColorSpace object: ${mode}`);
                            }
                        }
                        throw new _util.FormatError(`Unrecognized ColorSpace object: ${cs}`);
                    }
                    static isDefaultDecode(decode, numComps) {
                        if (!Array.isArray(decode)) return true;
                        if (numComps * 2 !== decode.length) {
                            (0, _util.warn)("The decode map is not the correct length");
                            return true;
                        }
                        for(let i = 0, ii = decode.length; i < ii; i += 2){
                            if (decode[i] !== 0 || decode[i + 1] !== 1) return false;
                        }
                        return true;
                    }
                    static get singletons() {
                        return (0, _util.shadow)(this, "singletons", {
                            get gray () {
                                return (0, _util.shadow)(this, "gray", new DeviceGrayCS());
                            },
                            get rgb () {
                                return (0, _util.shadow)(this, "rgb", new DeviceRgbCS());
                            },
                            get cmyk () {
                                return (0, _util.shadow)(this, "cmyk", new DeviceCmykCS());
                            }
                        });
                    }
                }
                exports.ColorSpace = ColorSpace;
                class AlternateCS extends ColorSpace {
                    constructor(numComps, base, tintFn){
                        super("Alternate", numComps);
                        this.base = base;
                        this.tintFn = tintFn;
                        this.tmpBuf = new Float32Array(base.numComps);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const tmpBuf = this.tmpBuf;
                        this.tintFn(src, srcOffset, tmpBuf, 0);
                        this.base.getRgbItem(tmpBuf, 0, dest, destOffset);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const tintFn = this.tintFn;
                        const base = this.base;
                        const scale = 1 / ((1 << bits) - 1);
                        const baseNumComps = base.numComps;
                        const usesZeroToOneRange = base.usesZeroToOneRange;
                        const isPassthrough = (base.isPassthrough(8) || !usesZeroToOneRange) && alpha01 === 0;
                        let pos = isPassthrough ? destOffset : 0;
                        const baseBuf = isPassthrough ? dest : new Uint8ClampedArray(baseNumComps * count);
                        const numComps = this.numComps;
                        const scaled = new Float32Array(numComps);
                        const tinted = new Float32Array(baseNumComps);
                        let i, j;
                        for(i = 0; i < count; i++){
                            for(j = 0; j < numComps; j++)scaled[j] = src[srcOffset++] * scale;
                            tintFn(scaled, 0, tinted, 0);
                            if (usesZeroToOneRange) for(j = 0; j < baseNumComps; j++)baseBuf[pos++] = tinted[j] * 255;
                            else {
                                base.getRgbItem(tinted, 0, baseBuf, pos);
                                pos += baseNumComps;
                            }
                        }
                        if (!isPassthrough) base.getRgbBuffer(baseBuf, 0, count, dest, destOffset, 8, alpha01);
                    }
                    getOutputLength(inputLength, alpha01) {
                        return this.base.getOutputLength(inputLength * this.base.numComps / this.numComps, alpha01);
                    }
                }
                class PatternCS extends ColorSpace {
                    constructor(baseCS){
                        super("Pattern", null);
                        this.base = baseCS;
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        (0, _util.unreachable)("Should not call PatternCS.isDefaultDecode");
                    }
                }
                class IndexedCS extends ColorSpace {
                    constructor(base, highVal, lookup){
                        super("Indexed", 1);
                        this.base = base;
                        this.highVal = highVal;
                        const length = base.numComps * highVal;
                        this.lookup = new Uint8Array(length);
                        if ((0, _primitives.isStream)(lookup)) {
                            const bytes = lookup.getBytes(length);
                            this.lookup.set(bytes);
                        } else if (typeof lookup === "string") for(let i = 0; i < length; ++i)this.lookup[i] = lookup.charCodeAt(i) & 0xff;
                        else throw new _util.FormatError(`IndexedCS - unrecognized lookup table: ${lookup}`);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const numComps = this.base.numComps;
                        const start = src[srcOffset] * numComps;
                        this.base.getRgbBuffer(this.lookup, start, 1, dest, destOffset, 8, 0);
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const base = this.base;
                        const numComps = base.numComps;
                        const outputDelta = base.getOutputLength(numComps, alpha01);
                        const lookup = this.lookup;
                        for(let i = 0; i < count; ++i){
                            const lookupPos = src[srcOffset++] * numComps;
                            base.getRgbBuffer(lookup, lookupPos, 1, dest, destOffset, 8, alpha01);
                            destOffset += outputDelta;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return this.base.getOutputLength(inputLength * this.base.numComps, alpha01);
                    }
                    isDefaultDecode(decodeMap, bpc) {
                        if (!Array.isArray(decodeMap)) return true;
                        if (decodeMap.length !== 2) {
                            (0, _util.warn)("Decode map length is not correct");
                            return true;
                        }
                        if (!Number.isInteger(bpc) || bpc < 1) {
                            (0, _util.warn)("Bits per component is not correct");
                            return true;
                        }
                        return decodeMap[0] === 0 && decodeMap[1] === (1 << bpc) - 1;
                    }
                }
                class DeviceGrayCS extends ColorSpace {
                    constructor(){
                        super("DeviceGray", 1);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        const c = src[srcOffset] * 255;
                        dest[destOffset] = dest[destOffset + 1] = dest[destOffset + 2] = c;
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        const scale = 255 / ((1 << bits) - 1);
                        let j = srcOffset, q = destOffset;
                        for(let i = 0; i < count; ++i){
                            const c = scale * src[j++];
                            dest[q++] = c;
                            dest[q++] = c;
                            dest[q++] = c;
                            q += alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01);
                    }
                }
                class DeviceRgbCS extends ColorSpace {
                    constructor(){
                        super("DeviceRGB", 3);
                    }
                    getRgbItem(src, srcOffset, dest, destOffset) {
                        dest[destOffset] = src[srcOffset] * 255;
                        dest[destOffset + 1] = src[srcOffset + 1] * 255;
                        dest[destOffset + 2] = src[srcOffset + 2] * 255;
                    }
                    getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                        if (bits === 8 && alpha01 === 0) {
                            dest.set(src.subarray(srcOffset, srcOffset + count * 3), destOffset);
                            return;
                        }
                        const scale = 255 / ((1 << bits) - 1);
                        let j = srcOffset, q = destOffset;
                        for(let i = 0; i < count; ++i){
                            dest[q++] = scale * src[j++];
                            dest[q++] = scale * src[j++];
                            dest[q++] = scale * src[j++];
                            q += alpha01;
                        }
                    }
                    getOutputLength(inputLength, alpha01) {
                        return inputLength * (3 + alpha01) / 3 | 0;
                    }
                    isPassthrough(bits) {
                        return bits === 8;
                    }
                }
                const DeviceCmykCS = function DeviceCmykCSClosure() {
                    function convertToRgb(src, srcOffset, srcScale, dest, destOffset) {
                        const c = src[srcOffset] * srcScale;
                        const m = src[srcOffset + 1] * srcScale;
                        const y = src[srcOffset + 2] * srcScale;
                        const k = src[srcOffset + 3] * srcScale;
                        dest[destOffset] = 255 + c * (-4.387332384609988 * c + 54.48615194189176 * m + 18.82290502165302 * y + 212.25662451639585 * k + -285.2331026137004) + m * (1.7149763477362134 * m - 5.6096736904047315 * y + -17.873870861415444 * k - 5.497006427196366) + y * (-2.5217340131683033 * y - 21.248923337353073 * k + 17.5119270841813) + k * (-21.86122147463605 * k - 189.48180835922747);
                        dest[destOffset + 1] = 255 + c * (8.841041422036149 * c + 60.118027045597366 * m + 6.871425592049007 * y + 31.159100130055922 * k + -79.2970844816548) + m * (-15.310361306967817 * m + 17.575251261109482 * y + 131.35250912493976 * k - 190.9453302588951) + y * (4.444339102852739 * y + 9.8632861493405 * k - 24.86741582555878) + k * (-20.737325471181034 * k - 187.80453709719578);
                        dest[destOffset + 2] = 255 + c * (0.8842522430003296 * c + 8.078677503112928 * m + 30.89978309703729 * y - 0.23883238689178934 * k + -14.183576799673286) + m * (10.49593273432072 * m + 63.02378494754052 * y + 50.606957656360734 * k - 112.23884253719248) + y * (0.03296041114873217 * y + 115.60384449646641 * k + -193.58209356861505) + k * (-22.33816807309886 * k - 180.12613974708367);
                    }
                    class DeviceCmykCS extends ColorSpace {
                        constructor(){
                            super("DeviceCMYK", 4);
                        }
                        getRgbItem(src, srcOffset, dest, destOffset) {
                            convertToRgb(src, srcOffset, 1, dest, destOffset);
                        }
                        getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                            const scale = 1 / ((1 << bits) - 1);
                            for(let i = 0; i < count; i++){
                                convertToRgb(src, srcOffset, scale, dest, destOffset);
                                srcOffset += 4;
                                destOffset += 3 + alpha01;
                            }
                        }
                        getOutputLength(inputLength, alpha01) {
                            return inputLength / 4 * (3 + alpha01) | 0;
                        }
                    }
                    return DeviceCmykCS;
                }();
                const CalGrayCS = function CalGrayCSClosure() {
                    function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
                        const A = src[srcOffset] * scale;
                        const AG = A ** cs.G;
                        const L = cs.YW * AG;
                        const val = Math.max(295.8 * L ** 0.333333333333333333 - 40.8, 0);
                        dest[destOffset] = val;
                        dest[destOffset + 1] = val;
                        dest[destOffset + 2] = val;
                    }
                    class CalGrayCS extends ColorSpace {
                        constructor(whitePoint, blackPoint, gamma){
                            super("CalGray", 1);
                            if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space CalGray");
                            blackPoint = blackPoint || [
                                0,
                                0,
                                0
                            ];
                            gamma = gamma || 1;
                            this.XW = whitePoint[0];
                            this.YW = whitePoint[1];
                            this.ZW = whitePoint[2];
                            this.XB = blackPoint[0];
                            this.YB = blackPoint[1];
                            this.ZB = blackPoint[2];
                            this.G = gamma;
                            if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new _util.FormatError(`Invalid WhitePoint components for ${this.name}` + ", no fallback available");
                            if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                                (0, _util.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`);
                                this.XB = this.YB = this.ZB = 0;
                            }
                            if (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) (0, _util.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ` + `ZB: ${this.ZB}, only default values are supported.`);
                            if (this.G < 1) {
                                (0, _util.info)(`Invalid Gamma: ${this.G} for ${this.name}, ` + "falling back to default.");
                                this.G = 1;
                            }
                        }
                        getRgbItem(src, srcOffset, dest, destOffset) {
                            convertToRgb(this, src, srcOffset, dest, destOffset, 1);
                        }
                        getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                            const scale = 1 / ((1 << bits) - 1);
                            for(let i = 0; i < count; ++i){
                                convertToRgb(this, src, srcOffset, dest, destOffset, scale);
                                srcOffset += 1;
                                destOffset += 3 + alpha01;
                            }
                        }
                        getOutputLength(inputLength, alpha01) {
                            return inputLength * (3 + alpha01);
                        }
                    }
                    return CalGrayCS;
                }();
                const CalRGBCS = function CalRGBCSClosure() {
                    const BRADFORD_SCALE_MATRIX = new Float32Array([
                        0.8951,
                        0.2664,
                        -0.1614,
                        -0.7502,
                        1.7135,
                        0.0367,
                        0.0389,
                        -0.0685,
                        1.0296
                    ]);
                    const BRADFORD_SCALE_INVERSE_MATRIX = new Float32Array([
                        0.9869929,
                        -0.1470543,
                        0.1599627,
                        0.4323053,
                        0.5183603,
                        0.0492912,
                        -0.0085287,
                        0.0400428,
                        0.9684867
                    ]);
                    const SRGB_D65_XYZ_TO_RGB_MATRIX = new Float32Array([
                        3.2404542,
                        -1.5371385,
                        -0.4985314,
                        -0.969266,
                        1.8760108,
                        0.0415560,
                        0.0556434,
                        -0.2040259,
                        1.0572252
                    ]);
                    const FLAT_WHITEPOINT_MATRIX = new Float32Array([
                        1,
                        1,
                        1
                    ]);
                    const tempNormalizeMatrix = new Float32Array(3);
                    const tempConvertMatrix1 = new Float32Array(3);
                    const tempConvertMatrix2 = new Float32Array(3);
                    const DECODE_L_CONSTANT = (24 / 116) ** 3 / 8.0;
                    function matrixProduct(a, b, result) {
                        result[0] = a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
                        result[1] = a[3] * b[0] + a[4] * b[1] + a[5] * b[2];
                        result[2] = a[6] * b[0] + a[7] * b[1] + a[8] * b[2];
                    }
                    function convertToFlat(sourceWhitePoint, LMS, result) {
                        result[0] = LMS[0] * 1 / sourceWhitePoint[0];
                        result[1] = LMS[1] * 1 / sourceWhitePoint[1];
                        result[2] = LMS[2] * 1 / sourceWhitePoint[2];
                    }
                    function convertToD65(sourceWhitePoint, LMS, result) {
                        const D65X = 0.95047;
                        const D65Y = 1;
                        const D65Z = 1.08883;
                        result[0] = LMS[0] * D65X / sourceWhitePoint[0];
                        result[1] = LMS[1] * D65Y / sourceWhitePoint[1];
                        result[2] = LMS[2] * D65Z / sourceWhitePoint[2];
                    }
                    function sRGBTransferFunction(color) {
                        if (color <= 0.0031308) return adjustToRange(0, 1, 12.92 * color);
                        if (color >= 0.99554525) return 1;
                        return adjustToRange(0, 1, 1.055 * color ** (1 / 2.4) - 0.055);
                    }
                    function adjustToRange(min, max, value) {
                        return Math.max(min, Math.min(max, value));
                    }
                    function decodeL(L) {
                        if (L < 0) return -decodeL(-L);
                        if (L > 8.0) return ((L + 16) / 116) ** 3;
                        return L * DECODE_L_CONSTANT;
                    }
                    function compensateBlackPoint(sourceBlackPoint, XYZ_Flat, result) {
                        if (sourceBlackPoint[0] === 0 && sourceBlackPoint[1] === 0 && sourceBlackPoint[2] === 0) {
                            result[0] = XYZ_Flat[0];
                            result[1] = XYZ_Flat[1];
                            result[2] = XYZ_Flat[2];
                            return;
                        }
                        const zeroDecodeL = decodeL(0);
                        const X_DST = zeroDecodeL;
                        const X_SRC = decodeL(sourceBlackPoint[0]);
                        const Y_DST = zeroDecodeL;
                        const Y_SRC = decodeL(sourceBlackPoint[1]);
                        const Z_DST = zeroDecodeL;
                        const Z_SRC = decodeL(sourceBlackPoint[2]);
                        const X_Scale = (1 - X_DST) / (1 - X_SRC);
                        const X_Offset = 1 - X_Scale;
                        const Y_Scale = (1 - Y_DST) / (1 - Y_SRC);
                        const Y_Offset = 1 - Y_Scale;
                        const Z_Scale = (1 - Z_DST) / (1 - Z_SRC);
                        const Z_Offset = 1 - Z_Scale;
                        result[0] = XYZ_Flat[0] * X_Scale + X_Offset;
                        result[1] = XYZ_Flat[1] * Y_Scale + Y_Offset;
                        result[2] = XYZ_Flat[2] * Z_Scale + Z_Offset;
                    }
                    function normalizeWhitePointToFlat(sourceWhitePoint, XYZ_In, result) {
                        if (sourceWhitePoint[0] === 1 && sourceWhitePoint[2] === 1) {
                            result[0] = XYZ_In[0];
                            result[1] = XYZ_In[1];
                            result[2] = XYZ_In[2];
                            return;
                        }
                        const LMS = result;
                        matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                        const LMS_Flat = tempNormalizeMatrix;
                        convertToFlat(sourceWhitePoint, LMS, LMS_Flat);
                        matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_Flat, result);
                    }
                    function normalizeWhitePointToD65(sourceWhitePoint, XYZ_In, result) {
                        const LMS = result;
                        matrixProduct(BRADFORD_SCALE_MATRIX, XYZ_In, LMS);
                        const LMS_D65 = tempNormalizeMatrix;
                        convertToD65(sourceWhitePoint, LMS, LMS_D65);
                        matrixProduct(BRADFORD_SCALE_INVERSE_MATRIX, LMS_D65, result);
                    }
                    function convertToRgb(cs, src, srcOffset, dest, destOffset, scale) {
                        const A = adjustToRange(0, 1, src[srcOffset] * scale);
                        const B = adjustToRange(0, 1, src[srcOffset + 1] * scale);
                        const C = adjustToRange(0, 1, src[srcOffset + 2] * scale);
                        const AGR = A === 1 ? 1 : A ** cs.GR;
                        const BGG = B === 1 ? 1 : B ** cs.GG;
                        const CGB = C === 1 ? 1 : C ** cs.GB;
                        const X = cs.MXA * AGR + cs.MXB * BGG + cs.MXC * CGB;
                        const Y = cs.MYA * AGR + cs.MYB * BGG + cs.MYC * CGB;
                        const Z = cs.MZA * AGR + cs.MZB * BGG + cs.MZC * CGB;
                        const XYZ = tempConvertMatrix1;
                        XYZ[0] = X;
                        XYZ[1] = Y;
                        XYZ[2] = Z;
                        const XYZ_Flat = tempConvertMatrix2;
                        normalizeWhitePointToFlat(cs.whitePoint, XYZ, XYZ_Flat);
                        const XYZ_Black = tempConvertMatrix1;
                        compensateBlackPoint(cs.blackPoint, XYZ_Flat, XYZ_Black);
                        const XYZ_D65 = tempConvertMatrix2;
                        normalizeWhitePointToD65(FLAT_WHITEPOINT_MATRIX, XYZ_Black, XYZ_D65);
                        const SRGB = tempConvertMatrix1;
                        matrixProduct(SRGB_D65_XYZ_TO_RGB_MATRIX, XYZ_D65, SRGB);
                        dest[destOffset] = sRGBTransferFunction(SRGB[0]) * 255;
                        dest[destOffset + 1] = sRGBTransferFunction(SRGB[1]) * 255;
                        dest[destOffset + 2] = sRGBTransferFunction(SRGB[2]) * 255;
                    }
                    class CalRGBCS extends ColorSpace {
                        constructor(whitePoint, blackPoint, gamma, matrix){
                            super("CalRGB", 3);
                            if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space CalRGB");
                            blackPoint = blackPoint || new Float32Array(3);
                            gamma = gamma || new Float32Array([
                                1,
                                1,
                                1
                            ]);
                            matrix = matrix || new Float32Array([
                                1,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                1
                            ]);
                            const XW = whitePoint[0];
                            const YW = whitePoint[1];
                            const ZW = whitePoint[2];
                            this.whitePoint = whitePoint;
                            const XB = blackPoint[0];
                            const YB = blackPoint[1];
                            const ZB = blackPoint[2];
                            this.blackPoint = blackPoint;
                            this.GR = gamma[0];
                            this.GG = gamma[1];
                            this.GB = gamma[2];
                            this.MXA = matrix[0];
                            this.MYA = matrix[1];
                            this.MZA = matrix[2];
                            this.MXB = matrix[3];
                            this.MYB = matrix[4];
                            this.MZB = matrix[5];
                            this.MXC = matrix[6];
                            this.MYC = matrix[7];
                            this.MZC = matrix[8];
                            if (XW < 0 || ZW < 0 || YW !== 1) throw new _util.FormatError(`Invalid WhitePoint components for ${this.name}` + ", no fallback available");
                            if (XB < 0 || YB < 0 || ZB < 0) {
                                (0, _util.info)(`Invalid BlackPoint for ${this.name} [${XB}, ${YB}, ${ZB}], ` + "falling back to default.");
                                this.blackPoint = new Float32Array(3);
                            }
                            if (this.GR < 0 || this.GG < 0 || this.GB < 0) {
                                (0, _util.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ` + `${this.name}, falling back to default.`);
                                this.GR = this.GG = this.GB = 1;
                            }
                        }
                        getRgbItem(src, srcOffset, dest, destOffset) {
                            convertToRgb(this, src, srcOffset, dest, destOffset, 1);
                        }
                        getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                            const scale = 1 / ((1 << bits) - 1);
                            for(let i = 0; i < count; ++i){
                                convertToRgb(this, src, srcOffset, dest, destOffset, scale);
                                srcOffset += 3;
                                destOffset += 3 + alpha01;
                            }
                        }
                        getOutputLength(inputLength, alpha01) {
                            return inputLength * (3 + alpha01) / 3 | 0;
                        }
                    }
                    return CalRGBCS;
                }();
                const LabCS = function LabCSClosure() {
                    function fn_g(x) {
                        let result;
                        if (x >= 6 / 29) result = x ** 3;
                        else result = 108 / 841 * (x - 4 / 29);
                        return result;
                    }
                    function decode(value, high1, low2, high2) {
                        return low2 + value * (high2 - low2) / high1;
                    }
                    function convertToRgb(cs, src, srcOffset, maxVal, dest, destOffset) {
                        let Ls = src[srcOffset];
                        let as = src[srcOffset + 1];
                        let bs = src[srcOffset + 2];
                        if (maxVal !== false) {
                            Ls = decode(Ls, maxVal, 0, 100);
                            as = decode(as, maxVal, cs.amin, cs.amax);
                            bs = decode(bs, maxVal, cs.bmin, cs.bmax);
                        }
                        if (as > cs.amax) as = cs.amax;
                        else if (as < cs.amin) as = cs.amin;
                        if (bs > cs.bmax) bs = cs.bmax;
                        else if (bs < cs.bmin) bs = cs.bmin;
                        const M = (Ls + 16) / 116;
                        const L = M + as / 500;
                        const N = M - bs / 200;
                        const X = cs.XW * fn_g(L);
                        const Y = cs.YW * fn_g(M);
                        const Z = cs.ZW * fn_g(N);
                        let r, g, b;
                        if (cs.ZW < 1) {
                            r = X * 3.1339 + Y * -1.617 + Z * -0.4906;
                            g = X * -0.9785 + Y * 1.916 + Z * 0.0333;
                            b = X * 0.072 + Y * -0.229 + Z * 1.4057;
                        } else {
                            r = X * 3.2406 + Y * -1.5372 + Z * -0.4986;
                            g = X * -0.9689 + Y * 1.8758 + Z * 0.0415;
                            b = X * 0.0557 + Y * -0.204 + Z * 1.057;
                        }
                        dest[destOffset] = Math.sqrt(r) * 255;
                        dest[destOffset + 1] = Math.sqrt(g) * 255;
                        dest[destOffset + 2] = Math.sqrt(b) * 255;
                    }
                    class LabCS extends ColorSpace {
                        constructor(whitePoint, blackPoint, range){
                            super("Lab", 3);
                            if (!whitePoint) throw new _util.FormatError("WhitePoint missing - required for color space Lab");
                            blackPoint = blackPoint || [
                                0,
                                0,
                                0
                            ];
                            range = range || [
                                -100,
                                100,
                                -100,
                                100
                            ];
                            this.XW = whitePoint[0];
                            this.YW = whitePoint[1];
                            this.ZW = whitePoint[2];
                            this.amin = range[0];
                            this.amax = range[1];
                            this.bmin = range[2];
                            this.bmax = range[3];
                            this.XB = blackPoint[0];
                            this.YB = blackPoint[1];
                            this.ZB = blackPoint[2];
                            if (this.XW < 0 || this.ZW < 0 || this.YW !== 1) throw new _util.FormatError("Invalid WhitePoint components, no fallback available");
                            if (this.XB < 0 || this.YB < 0 || this.ZB < 0) {
                                (0, _util.info)("Invalid BlackPoint, falling back to default");
                                this.XB = this.YB = this.ZB = 0;
                            }
                            if (this.amin > this.amax || this.bmin > this.bmax) {
                                (0, _util.info)("Invalid Range, falling back to defaults");
                                this.amin = -100;
                                this.amax = 100;
                                this.bmin = -100;
                                this.bmax = 100;
                            }
                        }
                        getRgbItem(src, srcOffset, dest, destOffset) {
                            convertToRgb(this, src, srcOffset, false, dest, destOffset);
                        }
                        getRgbBuffer(src, srcOffset, count, dest, destOffset, bits, alpha01) {
                            const maxVal = (1 << bits) - 1;
                            for(let i = 0; i < count; i++){
                                convertToRgb(this, src, srcOffset, maxVal, dest, destOffset);
                                srcOffset += 3;
                                destOffset += 3 + alpha01;
                            }
                        }
                        getOutputLength(inputLength, alpha01) {
                            return inputLength * (3 + alpha01) / 3 | 0;
                        }
                        isDefaultDecode(decodeMap, bpc) {
                            return true;
                        }
                        get usesZeroToOneRange() {
                            return (0, _util.shadow)(this, "usesZeroToOneRange", false);
                        }
                    }
                    return LabCS;
                }();
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PartialEvaluator = exports.EvaluatorPreprocessor = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cmap = __w_pdfjs_require__(16);
                var _primitives = __w_pdfjs_require__(5);
                var _fonts = __w_pdfjs_require__(34);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _encodings = __w_pdfjs_require__(37);
                var _standard_fonts = __w_pdfjs_require__(41);
                var _unicode = __w_pdfjs_require__(40);
                var _pattern = __w_pdfjs_require__(49);
                var _to_unicode_map = __w_pdfjs_require__(42);
                var _function = __w_pdfjs_require__(50);
                var _parser = __w_pdfjs_require__(17);
                var _image_utils = __w_pdfjs_require__(52);
                var _stream = __w_pdfjs_require__(10);
                var _bidi = __w_pdfjs_require__(53);
                var _colorspace = __w_pdfjs_require__(14);
                var _decode_stream = __w_pdfjs_require__(19);
                var _glyphlist = __w_pdfjs_require__(39);
                var _core_utils = __w_pdfjs_require__(9);
                var _metrics = __w_pdfjs_require__(54);
                var _xfa_fonts = __w_pdfjs_require__(55);
                var _murmurhash = __w_pdfjs_require__(61);
                var _operator_list = __w_pdfjs_require__(62);
                var _image = __w_pdfjs_require__(63);
                const DefaultPartialEvaluatorOptions = Object.freeze({
                    maxImageSize: -1,
                    disableFontFace: false,
                    ignoreErrors: false,
                    isEvalSupported: true,
                    fontExtraProperties: false,
                    useSystemFonts: true,
                    cMapUrl: null,
                    standardFontDataUrl: null
                });
                const PatternType = {
                    TILING: 1,
                    SHADING: 2
                };
                const deferred = Promise.resolve();
                function normalizeBlendMode(value, parsingArray = false) {
                    if (Array.isArray(value)) {
                        for(let i = 0, ii = value.length; i < ii; i++){
                            const maybeBM = normalizeBlendMode(value[i], true);
                            if (maybeBM) return maybeBM;
                        }
                        (0, _util.warn)(`Unsupported blend mode Array: ${value}`);
                        return "source-over";
                    }
                    if (!(0, _primitives.isName)(value)) {
                        if (parsingArray) return null;
                        return "source-over";
                    }
                    switch(value.name){
                        case "Normal":
                        case "Compatible":
                            return "source-over";
                        case "Multiply":
                            return "multiply";
                        case "Screen":
                            return "screen";
                        case "Overlay":
                            return "overlay";
                        case "Darken":
                            return "darken";
                        case "Lighten":
                            return "lighten";
                        case "ColorDodge":
                            return "color-dodge";
                        case "ColorBurn":
                            return "color-burn";
                        case "HardLight":
                            return "hard-light";
                        case "SoftLight":
                            return "soft-light";
                        case "Difference":
                            return "difference";
                        case "Exclusion":
                            return "exclusion";
                        case "Hue":
                            return "hue";
                        case "Saturation":
                            return "saturation";
                        case "Color":
                            return "color";
                        case "Luminosity":
                            return "luminosity";
                    }
                    if (parsingArray) return null;
                    (0, _util.warn)(`Unsupported blend mode: ${value.name}`);
                    return "source-over";
                }
                class TimeSlotManager {
                    static get TIME_SLOT_DURATION_MS() {
                        return (0, _util.shadow)(this, "TIME_SLOT_DURATION_MS", 20);
                    }
                    static get CHECK_TIME_EVERY() {
                        return (0, _util.shadow)(this, "CHECK_TIME_EVERY", 100);
                    }
                    constructor(){
                        this.reset();
                    }
                    check() {
                        if (++this.checked < TimeSlotManager.CHECK_TIME_EVERY) return false;
                        this.checked = 0;
                        return this.endTime <= Date.now();
                    }
                    reset() {
                        this.endTime = Date.now() + TimeSlotManager.TIME_SLOT_DURATION_MS;
                        this.checked = 0;
                    }
                }
                class PartialEvaluator {
                    constructor({ xref: xref , handler: handler , pageIndex: pageIndex , idFactory: idFactory , fontCache: fontCache , builtInCMapCache: builtInCMapCache , standardFontDataCache: standardFontDataCache , globalImageCache: globalImageCache , options: options = null  }){
                        this.xref = xref;
                        this.handler = handler;
                        this.pageIndex = pageIndex;
                        this.idFactory = idFactory;
                        this.fontCache = fontCache;
                        this.builtInCMapCache = builtInCMapCache;
                        this.standardFontDataCache = standardFontDataCache;
                        this.globalImageCache = globalImageCache;
                        this.options = options || DefaultPartialEvaluatorOptions;
                        this.parsingType3Font = false;
                        this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this);
                    }
                    get _pdfFunctionFactory() {
                        const pdfFunctionFactory = new _function.PDFFunctionFactory({
                            xref: this.xref,
                            isEvalSupported: this.options.isEvalSupported
                        });
                        return (0, _util.shadow)(this, "_pdfFunctionFactory", pdfFunctionFactory);
                    }
                    clone(newOptions = null) {
                        const newEvaluator = Object.create(this);
                        newEvaluator.options = Object.assign(Object.create(null), this.options, newOptions);
                        return newEvaluator;
                    }
                    hasBlendModes(resources, nonBlendModesSet) {
                        if (!(resources instanceof _primitives.Dict)) return false;
                        if (resources.objId && nonBlendModesSet.has(resources.objId)) return false;
                        const processed = new _primitives.RefSet(nonBlendModesSet);
                        if (resources.objId) processed.put(resources.objId);
                        const nodes = [
                            resources
                        ], xref = this.xref;
                        while(nodes.length){
                            const node = nodes.shift();
                            const graphicStates = node.get("ExtGState");
                            if (graphicStates instanceof _primitives.Dict) for (let graphicState of graphicStates.getRawValues()){
                                if (graphicState instanceof _primitives.Ref) {
                                    if (processed.has(graphicState)) continue;
                                    try {
                                        graphicState = xref.fetch(graphicState);
                                    } catch (ex) {
                                        processed.put(graphicState);
                                        (0, _util.info)(`hasBlendModes - ignoring ExtGState: "${ex}".`);
                                        continue;
                                    }
                                }
                                if (!(graphicState instanceof _primitives.Dict)) continue;
                                if (graphicState.objId) processed.put(graphicState.objId);
                                const bm = graphicState.get("BM");
                                if (bm instanceof _primitives.Name) {
                                    if (bm.name !== "Normal") return true;
                                    continue;
                                }
                                if (bm !== undefined && Array.isArray(bm)) for (const element of bm){
                                    if (element instanceof _primitives.Name && element.name !== "Normal") return true;
                                }
                            }
                            const xObjects = node.get("XObject");
                            if (!(xObjects instanceof _primitives.Dict)) continue;
                            for (let xObject of xObjects.getRawValues()){
                                if (xObject instanceof _primitives.Ref) {
                                    if (processed.has(xObject)) continue;
                                    try {
                                        xObject = xref.fetch(xObject);
                                    } catch (ex) {
                                        processed.put(xObject);
                                        (0, _util.info)(`hasBlendModes - ignoring XObject: "${ex}".`);
                                        continue;
                                    }
                                }
                                if (!(0, _primitives.isStream)(xObject)) continue;
                                if (xObject.dict.objId) processed.put(xObject.dict.objId);
                                const xResources = xObject.dict.get("Resources");
                                if (!(xResources instanceof _primitives.Dict)) continue;
                                if (xResources.objId && processed.has(xResources.objId)) continue;
                                nodes.push(xResources);
                                if (xResources.objId) processed.put(xResources.objId);
                            }
                        }
                        processed.forEach((ref)=>{
                            nonBlendModesSet.put(ref);
                        });
                        return false;
                    }
                    async fetchBuiltInCMap(name) {
                        const cachedData = this.builtInCMapCache.get(name);
                        if (cachedData) return cachedData;
                        let data;
                        if (this.options.cMapUrl !== null) {
                            const url = `${this.options.cMapUrl}${name}.bcmap`;
                            const response = await fetch(url);
                            if (!response.ok) throw new Error(`fetchBuiltInCMap: failed to fetch file "${url}" with "${response.statusText}".`);
                            data = {
                                cMapData: new Uint8Array(await response.arrayBuffer()),
                                compressionType: _util.CMapCompressionType.BINARY
                            };
                        } else data = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                            name: name
                        });
                        if (data.compressionType !== _util.CMapCompressionType.NONE) this.builtInCMapCache.set(name, data);
                        return data;
                    }
                    async fetchStandardFontData(name) {
                        const cachedData = this.standardFontDataCache.get(name);
                        if (cachedData) return new _stream.Stream(cachedData);
                        if (this.options.useSystemFonts && name !== "Symbol" && name !== "ZapfDingbats") return null;
                        const standardFontNameToFileName = (0, _standard_fonts.getFontNameToFileMap)(), filename = standardFontNameToFileName[name];
                        let data;
                        if (this.options.standardFontDataUrl !== null) {
                            const url = `${this.options.standardFontDataUrl}${filename}`;
                            const response = await fetch(url);
                            if (!response.ok) (0, _util.warn)(`fetchStandardFontData: failed to fetch file "${url}" with "${response.statusText}".`);
                            else data = await response.arrayBuffer();
                        } else try {
                            data = await this.handler.sendWithPromise("FetchStandardFontData", {
                                filename: filename
                            });
                        } catch (e) {
                            (0, _util.warn)(`fetchStandardFontData: failed to fetch file "${filename}" with "${e}".`);
                        }
                        if (!data) return null;
                        this.standardFontDataCache.set(name, data);
                        return new _stream.Stream(data);
                    }
                    async buildFormXObject(resources, xobj, smask, operatorList, task, initialState, localColorSpaceCache) {
                        const dict = xobj.dict;
                        const matrix = dict.getArray("Matrix");
                        let bbox = dict.getArray("BBox");
                        if (Array.isArray(bbox) && bbox.length === 4) bbox = _util.Util.normalizeRect(bbox);
                        else bbox = null;
                        let optionalContent = null, groupOptions;
                        if (dict.has("OC")) {
                            optionalContent = await this.parseMarkedContentProps(dict.get("OC"), resources);
                            operatorList.addOp(_util.OPS.beginMarkedContentProps, [
                                "OC",
                                optionalContent
                            ]);
                        }
                        const group = dict.get("Group");
                        if (group) {
                            groupOptions = {
                                matrix: matrix,
                                bbox: bbox,
                                smask: smask,
                                isolated: false,
                                knockout: false
                            };
                            const groupSubtype = group.get("S");
                            let colorSpace = null;
                            if ((0, _primitives.isName)(groupSubtype, "Transparency")) {
                                groupOptions.isolated = group.get("I") || false;
                                groupOptions.knockout = group.get("K") || false;
                                if (group.has("CS")) {
                                    const cs = group.getRaw("CS");
                                    const cachedColorSpace = _colorspace.ColorSpace.getCached(cs, this.xref, localColorSpaceCache);
                                    if (cachedColorSpace) colorSpace = cachedColorSpace;
                                    else colorSpace = await this.parseColorSpace({
                                        cs: cs,
                                        resources: resources,
                                        localColorSpaceCache: localColorSpaceCache
                                    });
                                }
                            }
                            if (smask && smask.backdrop) {
                                colorSpace = colorSpace || _colorspace.ColorSpace.singletons.rgb;
                                smask.backdrop = colorSpace.getRgb(smask.backdrop, 0);
                            }
                            operatorList.addOp(_util.OPS.beginGroup, [
                                groupOptions
                            ]);
                        }
                        operatorList.addOp(_util.OPS.paintFormXObjectBegin, [
                            matrix,
                            bbox
                        ]);
                        return this.getOperatorList({
                            stream: xobj,
                            task: task,
                            resources: dict.get("Resources") || resources,
                            operatorList: operatorList,
                            initialState: initialState
                        }).then(function() {
                            operatorList.addOp(_util.OPS.paintFormXObjectEnd, []);
                            if (group) operatorList.addOp(_util.OPS.endGroup, [
                                groupOptions
                            ]);
                            if (optionalContent) operatorList.addOp(_util.OPS.endMarkedContent, []);
                        });
                    }
                    _sendImgData(objId, imgData, cacheGlobally = false) {
                        const transfers = imgData ? [
                            imgData.data.buffer
                        ] : null;
                        if (this.parsingType3Font || cacheGlobally) return this.handler.send("commonobj", [
                            objId,
                            "Image",
                            imgData
                        ], transfers);
                        return this.handler.send("obj", [
                            objId,
                            this.pageIndex,
                            "Image",
                            imgData
                        ], transfers);
                    }
                    async buildPaintImageXObject({ resources: resources , image: image , isInline: isInline = false , operatorList: operatorList , cacheKey: cacheKey , localImageCache: localImageCache , localColorSpaceCache: localColorSpaceCache  }) {
                        const dict = image.dict;
                        const imageRef = dict.objId;
                        const w = dict.get("Width", "W");
                        const h = dict.get("Height", "H");
                        if (!(w && (0, _util.isNum)(w)) || !(h && (0, _util.isNum)(h))) {
                            (0, _util.warn)("Image dimensions are missing, or not numbers.");
                            return undefined;
                        }
                        const maxImageSize = this.options.maxImageSize;
                        if (maxImageSize !== -1 && w * h > maxImageSize) {
                            (0, _util.warn)("Image exceeded maximum allowed size and was removed.");
                            return undefined;
                        }
                        const imageMask = dict.get("ImageMask", "IM") || false;
                        let imgData, args;
                        if (imageMask) {
                            const width = dict.get("Width", "W");
                            const height = dict.get("Height", "H");
                            const bitStrideLength = width + 7 >> 3;
                            const imgArray = image.getBytes(bitStrideLength * height, true);
                            const decode = dict.getArray("Decode", "D");
                            imgData = _image.PDFImage.createMask({
                                imgArray: imgArray,
                                width: width,
                                height: height,
                                imageIsFromDecodeStream: image instanceof _decode_stream.DecodeStream,
                                inverseDecode: !!decode && decode[0] > 0
                            });
                            imgData.cached = !!cacheKey;
                            args = [
                                imgData
                            ];
                            operatorList.addOp(_util.OPS.paintImageMaskXObject, args);
                            if (cacheKey) localImageCache.set(cacheKey, imageRef, {
                                fn: _util.OPS.paintImageMaskXObject,
                                args: args
                            });
                            return undefined;
                        }
                        const softMask = dict.get("SMask", "SM") || false;
                        const mask = dict.get("Mask") || false;
                        const SMALL_IMAGE_DIMENSIONS = 200;
                        if (isInline && !softMask && !mask && w + h < SMALL_IMAGE_DIMENSIONS) {
                            const imageObj = new _image.PDFImage({
                                xref: this.xref,
                                res: resources,
                                image: image,
                                isInline: isInline,
                                pdfFunctionFactory: this._pdfFunctionFactory,
                                localColorSpaceCache: localColorSpaceCache
                            });
                            imgData = imageObj.createImageData(true);
                            operatorList.addOp(_util.OPS.paintInlineImageXObject, [
                                imgData
                            ]);
                            return undefined;
                        }
                        let objId = `img_${this.idFactory.createObjId()}`, cacheGlobally = false;
                        if (this.parsingType3Font) objId = `${this.idFactory.getDocId()}_type3_${objId}`;
                        else if (imageRef) {
                            cacheGlobally = this.globalImageCache.shouldCache(imageRef, this.pageIndex);
                            if (cacheGlobally) objId = `${this.idFactory.getDocId()}_${objId}`;
                        }
                        operatorList.addDependency(objId);
                        args = [
                            objId,
                            w,
                            h
                        ];
                        _image.PDFImage.buildImage({
                            xref: this.xref,
                            res: resources,
                            image: image,
                            isInline: isInline,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        }).then((imageObj)=>{
                            imgData = imageObj.createImageData(false);
                            if (cacheKey && imageRef && cacheGlobally) this.globalImageCache.addByteSize(imageRef, imgData.data.length);
                            return this._sendImgData(objId, imgData, cacheGlobally);
                        }).catch((reason)=>{
                            (0, _util.warn)(`Unable to decode image "${objId}": "${reason}".`);
                            return this._sendImgData(objId, null, cacheGlobally);
                        });
                        operatorList.addOp(_util.OPS.paintImageXObject, args);
                        if (cacheKey) {
                            localImageCache.set(cacheKey, imageRef, {
                                fn: _util.OPS.paintImageXObject,
                                args: args
                            });
                            if (imageRef) {
                                (0, _util.assert)(!isInline, "Cannot cache an inline image globally.");
                                this.globalImageCache.addPageIndex(imageRef, this.pageIndex);
                                if (cacheGlobally) this.globalImageCache.setData(imageRef, {
                                    objId: objId,
                                    fn: _util.OPS.paintImageXObject,
                                    args: args,
                                    byteSize: 0
                                });
                            }
                        }
                        return undefined;
                    }
                    handleSMask(smask, resources, operatorList, task, stateManager, localColorSpaceCache) {
                        const smaskContent = smask.get("G");
                        const smaskOptions = {
                            subtype: smask.get("S").name,
                            backdrop: smask.get("BC")
                        };
                        const transferObj = smask.get("TR");
                        if ((0, _function.isPDFFunction)(transferObj)) {
                            const transferFn = this._pdfFunctionFactory.create(transferObj);
                            const transferMap = new Uint8Array(256);
                            const tmp = new Float32Array(1);
                            for(let i = 0; i < 256; i++){
                                tmp[0] = i / 255;
                                transferFn(tmp, 0, tmp, 0);
                                transferMap[i] = tmp[0] * 255 | 0;
                            }
                            smaskOptions.transferMap = transferMap;
                        }
                        return this.buildFormXObject(resources, smaskContent, smaskOptions, operatorList, task, stateManager.state.clone(), localColorSpaceCache);
                    }
                    handleTransferFunction(tr) {
                        let transferArray;
                        if (Array.isArray(tr)) transferArray = tr;
                        else if ((0, _function.isPDFFunction)(tr)) transferArray = [
                            tr
                        ];
                        else return null;
                        const transferMaps = [];
                        let numFns = 0, numEffectfulFns = 0;
                        for (const entry of transferArray){
                            const transferObj = this.xref.fetchIfRef(entry);
                            numFns++;
                            if ((0, _primitives.isName)(transferObj, "Identity")) {
                                transferMaps.push(null);
                                continue;
                            } else if (!(0, _function.isPDFFunction)(transferObj)) return null;
                            const transferFn = this._pdfFunctionFactory.create(transferObj);
                            const transferMap = new Uint8Array(256), tmp = new Float32Array(1);
                            for(let j = 0; j < 256; j++){
                                tmp[0] = j / 255;
                                transferFn(tmp, 0, tmp, 0);
                                transferMap[j] = tmp[0] * 255 | 0;
                            }
                            transferMaps.push(transferMap);
                            numEffectfulFns++;
                        }
                        if (!(numFns === 1 || numFns === 4)) return null;
                        if (numEffectfulFns === 0) return null;
                        return transferMaps;
                    }
                    handleTilingType(fn, color, resources, pattern, patternDict, operatorList, task, cacheKey, localTilingPatternCache) {
                        const tilingOpList = new _operator_list.OperatorList();
                        const patternResources = _primitives.Dict.merge({
                            xref: this.xref,
                            dictArray: [
                                patternDict.get("Resources"),
                                resources
                            ]
                        });
                        return this.getOperatorList({
                            stream: pattern,
                            task: task,
                            resources: patternResources,
                            operatorList: tilingOpList
                        }).then(function() {
                            const operatorListIR = tilingOpList.getIR();
                            const tilingPatternIR = (0, _pattern.getTilingPatternIR)(operatorListIR, patternDict, color);
                            operatorList.addDependencies(tilingOpList.dependencies);
                            operatorList.addOp(fn, tilingPatternIR);
                            if (cacheKey) localTilingPatternCache.set(cacheKey, patternDict.objId, {
                                operatorListIR: operatorListIR,
                                dict: patternDict
                            });
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                this.handler.send("UnsupportedFeature", {
                                    featureId: _util.UNSUPPORTED_FEATURES.errorTilingPattern
                                });
                                (0, _util.warn)(`handleTilingType - ignoring pattern: "${reason}".`);
                                return;
                            }
                            throw reason;
                        });
                    }
                    handleSetFont(resources, fontArgs, fontRef, operatorList, task, state, fallbackFontDict = null, cssFontInfo = null) {
                        const fontName = fontArgs && fontArgs[0] instanceof _primitives.Name ? fontArgs[0].name : null;
                        return this.loadFont(fontName, fontRef, resources, fallbackFontDict, cssFontInfo).then((translated)=>{
                            if (!translated.font.isType3Font) return translated;
                            return translated.loadType3Data(this, resources, task).then(function() {
                                operatorList.addDependencies(translated.type3Dependencies);
                                return translated;
                            }).catch((reason)=>{
                                this.handler.send("UnsupportedFeature", {
                                    featureId: _util.UNSUPPORTED_FEATURES.errorFontLoadType3
                                });
                                return new TranslatedFont({
                                    loadedName: "g_font_error",
                                    font: new _fonts.ErrorFont(`Type3 font load error: ${reason}`),
                                    dict: translated.font,
                                    evaluatorOptions: this.options
                                });
                            });
                        }).then((translated)=>{
                            state.font = translated.font;
                            translated.send(this.handler);
                            return translated.loadedName;
                        });
                    }
                    handleText(chars, state) {
                        const font1 = state.font;
                        const glyphs = font1.charsToGlyphs(chars);
                        if (font1.data) {
                            const isAddToPathSet = !!(state.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                            if (isAddToPathSet || state.fillColorSpace.name === "Pattern" || font1.disableFontFace || this.options.disableFontFace) PartialEvaluator.buildFontPaths(font1, glyphs, this.handler, this.options);
                        }
                        return glyphs;
                    }
                    ensureStateFont(state) {
                        if (state.font) return;
                        const reason = new _util.FormatError("Missing setFont (Tf) operator before text rendering operator.");
                        if (this.options.ignoreErrors) {
                            this.handler.send("UnsupportedFeature", {
                                featureId: _util.UNSUPPORTED_FEATURES.errorFontState
                            });
                            (0, _util.warn)(`ensureStateFont: "${reason}".`);
                            return;
                        }
                        throw reason;
                    }
                    async setGState({ resources: resources , gState: gState , operatorList: operatorList , cacheKey: cacheKey , task: task , stateManager: stateManager , localGStateCache: localGStateCache , localColorSpaceCache: localColorSpaceCache  }) {
                        const gStateRef = gState.objId;
                        let isSimpleGState = true;
                        const gStateObj = [];
                        const gStateKeys = gState.getKeys();
                        let promise = Promise.resolve();
                        for(let i = 0, ii = gStateKeys.length; i < ii; i++){
                            const key = gStateKeys[i];
                            const value = gState.get(key);
                            switch(key){
                                case "Type":
                                    break;
                                case "LW":
                                case "LC":
                                case "LJ":
                                case "ML":
                                case "D":
                                case "RI":
                                case "FL":
                                case "CA":
                                case "ca":
                                    gStateObj.push([
                                        key,
                                        value
                                    ]);
                                    break;
                                case "Font":
                                    isSimpleGState = false;
                                    promise = promise.then(()=>{
                                        return this.handleSetFont(resources, null, value[0], operatorList, task, stateManager.state).then(function(loadedName) {
                                            operatorList.addDependency(loadedName);
                                            gStateObj.push([
                                                key,
                                                [
                                                    loadedName,
                                                    value[1]
                                                ]
                                            ]);
                                        });
                                    });
                                    break;
                                case "BM":
                                    gStateObj.push([
                                        key,
                                        normalizeBlendMode(value)
                                    ]);
                                    break;
                                case "SMask":
                                    if ((0, _primitives.isName)(value, "None")) {
                                        gStateObj.push([
                                            key,
                                            false
                                        ]);
                                        break;
                                    }
                                    if ((0, _primitives.isDict)(value)) {
                                        isSimpleGState = false;
                                        promise = promise.then(()=>{
                                            return this.handleSMask(value, resources, operatorList, task, stateManager, localColorSpaceCache);
                                        });
                                        gStateObj.push([
                                            key,
                                            true
                                        ]);
                                    } else (0, _util.warn)("Unsupported SMask type");
                                    break;
                                case "TR":
                                    const transferMaps = this.handleTransferFunction(value);
                                    gStateObj.push([
                                        key,
                                        transferMaps
                                    ]);
                                    break;
                                case "OP":
                                case "op":
                                case "OPM":
                                case "BG":
                                case "BG2":
                                case "UCR":
                                case "UCR2":
                                case "TR2":
                                case "HT":
                                case "SM":
                                case "SA":
                                case "AIS":
                                case "TK":
                                    (0, _util.info)("graphic state operator " + key);
                                    break;
                                default:
                                    (0, _util.info)("Unknown graphic state operator " + key);
                                    break;
                            }
                        }
                        return promise.then(function() {
                            if (gStateObj.length > 0) operatorList.addOp(_util.OPS.setGState, [
                                gStateObj
                            ]);
                            if (isSimpleGState) localGStateCache.set(cacheKey, gStateRef, gStateObj);
                        });
                    }
                    loadFont(fontName, font1, resources, fallbackFontDict = null, cssFontInfo = null) {
                        const errorFont = async ()=>{
                            return new TranslatedFont({
                                loadedName: "g_font_error",
                                font: new _fonts.ErrorFont(`Font "${fontName}" is not available.`),
                                dict: font1,
                                evaluatorOptions: this.options
                            });
                        };
                        const xref = this.xref;
                        let fontRef;
                        if (font1) {
                            if (!(0, _primitives.isRef)(font1)) throw new _util.FormatError('The "font" object should be a reference.');
                            fontRef = font1;
                        } else {
                            const fontRes = resources.get("Font");
                            if (fontRes) fontRef = fontRes.getRaw(fontName);
                        }
                        if (!fontRef) {
                            const partialMsg = `Font "${fontName || font1 && font1.toString()}" is not available`;
                            if (!this.options.ignoreErrors && !this.parsingType3Font) {
                                (0, _util.warn)(`${partialMsg}.`);
                                return errorFont();
                            }
                            this.handler.send("UnsupportedFeature", {
                                featureId: _util.UNSUPPORTED_FEATURES.errorFontMissing
                            });
                            (0, _util.warn)(`${partialMsg} -- attempting to fallback to a default font.`);
                            if (fallbackFontDict) fontRef = fallbackFontDict;
                            else fontRef = PartialEvaluator.fallbackFontDict;
                        }
                        if (this.fontCache.has(fontRef)) return this.fontCache.get(fontRef);
                        font1 = xref.fetchIfRef(fontRef);
                        if (!(0, _primitives.isDict)(font1)) return errorFont();
                        if (font1.cacheKey && this.fontCache.has(font1.cacheKey)) return this.fontCache.get(font1.cacheKey);
                        const fontCapability = (0, _util.createPromiseCapability)();
                        let preEvaluatedFont;
                        try {
                            preEvaluatedFont = this.preEvaluateFont(font1);
                            preEvaluatedFont.cssFontInfo = cssFontInfo;
                        } catch (reason) {
                            (0, _util.warn)(`loadFont - preEvaluateFont failed: "${reason}".`);
                            return errorFont();
                        }
                        const { descriptor: descriptor , hash: hash  } = preEvaluatedFont;
                        const fontRefIsRef = (0, _primitives.isRef)(fontRef);
                        let fontID;
                        if (fontRefIsRef) fontID = `f${fontRef.toString()}`;
                        if (hash && (0, _primitives.isDict)(descriptor)) {
                            if (!descriptor.fontAliases) descriptor.fontAliases = Object.create(null);
                            const fontAliases = descriptor.fontAliases;
                            if (fontAliases[hash]) {
                                const aliasFontRef = fontAliases[hash].aliasRef;
                                if (fontRefIsRef && aliasFontRef && this.fontCache.has(aliasFontRef)) {
                                    this.fontCache.putAlias(fontRef, aliasFontRef);
                                    return this.fontCache.get(fontRef);
                                }
                            } else fontAliases[hash] = {
                                fontID: this.idFactory.createFontId()
                            };
                            if (fontRefIsRef) fontAliases[hash].aliasRef = fontRef;
                            fontID = fontAliases[hash].fontID;
                        }
                        if (fontRefIsRef) this.fontCache.put(fontRef, fontCapability.promise);
                        else {
                            if (!fontID) fontID = this.idFactory.createFontId();
                            font1.cacheKey = `cacheKey_${fontID}`;
                            this.fontCache.put(font1.cacheKey, fontCapability.promise);
                        }
                        (0, _util.assert)(fontID && fontID.startsWith("f"), 'The "fontID" must be (correctly) defined.');
                        font1.loadedName = `${this.idFactory.getDocId()}_${fontID}`;
                        this.translateFont(preEvaluatedFont).then((translatedFont)=>{
                            if (translatedFont.fontType !== undefined) {
                                const xrefFontStats = xref.stats.fontTypes;
                                xrefFontStats[translatedFont.fontType] = true;
                            }
                            fontCapability.resolve(new TranslatedFont({
                                loadedName: font1.loadedName,
                                font: translatedFont,
                                dict: font1,
                                evaluatorOptions: this.options
                            }));
                        }).catch((reason)=>{
                            this.handler.send("UnsupportedFeature", {
                                featureId: _util.UNSUPPORTED_FEATURES.errorFontTranslate
                            });
                            (0, _util.warn)(`loadFont - translateFont failed: "${reason}".`);
                            try {
                                const fontFile3 = descriptor && descriptor.get("FontFile3");
                                const subtype = fontFile3 && fontFile3.get("Subtype");
                                const fontType = (0, _fonts_utils.getFontType)(preEvaluatedFont.type, subtype && subtype.name);
                                const xrefFontStats = xref.stats.fontTypes;
                                xrefFontStats[fontType] = true;
                            } catch (ex) {}
                            fontCapability.resolve(new TranslatedFont({
                                loadedName: font1.loadedName,
                                font: new _fonts.ErrorFont(reason instanceof Error ? reason.message : reason),
                                dict: font1,
                                evaluatorOptions: this.options
                            }));
                        });
                        return fontCapability.promise;
                    }
                    buildPath(operatorList, fn, args, parsingText = false) {
                        const lastIndex = operatorList.length - 1;
                        if (!args) args = [];
                        if (lastIndex < 0 || operatorList.fnArray[lastIndex] !== _util.OPS.constructPath) {
                            if (parsingText) {
                                (0, _util.warn)(`Encountered path operator "${fn}" inside of a text object.`);
                                operatorList.addOp(_util.OPS.save, null);
                            }
                            operatorList.addOp(_util.OPS.constructPath, [
                                [
                                    fn
                                ],
                                args
                            ]);
                            if (parsingText) operatorList.addOp(_util.OPS.restore, null);
                        } else {
                            const opArgs = operatorList.argsArray[lastIndex];
                            opArgs[0].push(fn);
                            Array.prototype.push.apply(opArgs[1], args);
                        }
                    }
                    parseColorSpace({ cs: cs , resources: resources , localColorSpaceCache: localColorSpaceCache  }) {
                        return _colorspace.ColorSpace.parseAsync({
                            cs: cs,
                            xref: this.xref,
                            resources: resources,
                            pdfFunctionFactory: this._pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                this.handler.send("UnsupportedFeature", {
                                    featureId: _util.UNSUPPORTED_FEATURES.errorColorSpace
                                });
                                (0, _util.warn)(`parseColorSpace - ignoring ColorSpace: "${reason}".`);
                                return null;
                            }
                            throw reason;
                        });
                    }
                    parseShading({ keyObj: keyObj , shading: shading , resources: resources , localColorSpaceCache: localColorSpaceCache , localShadingPatternCache: localShadingPatternCache , matrix: matrix = null  }) {
                        let id = localShadingPatternCache.get(keyObj);
                        if (!id) {
                            var shadingFill = _pattern.Pattern.parseShading(shading, matrix, this.xref, resources, this.handler, this._pdfFunctionFactory, localColorSpaceCache);
                            const patternIR = shadingFill.getIR();
                            id = `pattern_${this.idFactory.createObjId()}`;
                            localShadingPatternCache.set(keyObj, id);
                            this.handler.send("obj", [
                                id,
                                this.pageIndex,
                                "Pattern",
                                patternIR
                            ]);
                        }
                        return id;
                    }
                    handleColorN(operatorList, fn, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache) {
                        const patternName = args.pop();
                        if (patternName instanceof _primitives.Name) {
                            const name = patternName.name;
                            const localTilingPattern = localTilingPatternCache.getByName(name);
                            if (localTilingPattern) try {
                                const color = cs.base ? cs.base.getRgb(args, 0) : null;
                                const tilingPatternIR = (0, _pattern.getTilingPatternIR)(localTilingPattern.operatorListIR, localTilingPattern.dict, color);
                                operatorList.addOp(fn, tilingPatternIR);
                                return undefined;
                            } catch (ex) {}
                            const pattern = patterns.get(name);
                            if (pattern) {
                                const dict = (0, _primitives.isStream)(pattern) ? pattern.dict : pattern;
                                const typeNum = dict.get("PatternType");
                                if (typeNum === PatternType.TILING) {
                                    const color = cs.base ? cs.base.getRgb(args, 0) : null;
                                    return this.handleTilingType(fn, color, resources, pattern, dict, operatorList, task, name, localTilingPatternCache);
                                } else if (typeNum === PatternType.SHADING) {
                                    const shading = dict.get("Shading");
                                    const matrix = dict.getArray("Matrix");
                                    const objId = this.parseShading({
                                        keyObj: pattern,
                                        shading: shading,
                                        matrix: matrix,
                                        resources: resources,
                                        localColorSpaceCache: localColorSpaceCache,
                                        localShadingPatternCache: localShadingPatternCache
                                    });
                                    operatorList.addOp(fn, [
                                        "Shading",
                                        objId
                                    ]);
                                    return undefined;
                                }
                                throw new _util.FormatError(`Unknown PatternType: ${typeNum}`);
                            }
                        }
                        throw new _util.FormatError(`Unknown PatternName: ${patternName}`);
                    }
                    _parseVisibilityExpression(array, nestingCounter, currentResult) {
                        const MAX_NESTING = 10;
                        if (++nestingCounter > MAX_NESTING) {
                            (0, _util.warn)("Visibility expression is too deeply nested");
                            return;
                        }
                        const length = array.length;
                        const operator = this.xref.fetchIfRef(array[0]);
                        if (length < 2 || !(0, _primitives.isName)(operator)) {
                            (0, _util.warn)("Invalid visibility expression");
                            return;
                        }
                        switch(operator.name){
                            case "And":
                            case "Or":
                            case "Not":
                                currentResult.push(operator.name);
                                break;
                            default:
                                (0, _util.warn)(`Invalid operator ${operator.name} in visibility expression`);
                                return;
                        }
                        for(let i = 1; i < length; i++){
                            const raw = array[i];
                            const object = this.xref.fetchIfRef(raw);
                            if (Array.isArray(object)) {
                                const nestedResult = [];
                                currentResult.push(nestedResult);
                                this._parseVisibilityExpression(object, nestingCounter, nestedResult);
                            } else if ((0, _primitives.isRef)(raw)) currentResult.push(raw.toString());
                        }
                    }
                    async parseMarkedContentProps(contentProperties, resources) {
                        let optionalContent;
                        if ((0, _primitives.isName)(contentProperties)) {
                            const properties = resources.get("Properties");
                            optionalContent = properties.get(contentProperties.name);
                        } else if ((0, _primitives.isDict)(contentProperties)) optionalContent = contentProperties;
                        else throw new _util.FormatError("Optional content properties malformed.");
                        const optionalContentType = optionalContent.get("Type").name;
                        if (optionalContentType === "OCG") return {
                            type: optionalContentType,
                            id: optionalContent.objId
                        };
                        else if (optionalContentType === "OCMD") {
                            const expression = optionalContent.get("VE");
                            if (Array.isArray(expression)) {
                                const result = [];
                                this._parseVisibilityExpression(expression, 0, result);
                                if (result.length > 0) return {
                                    type: "OCMD",
                                    expression: result
                                };
                            }
                            const optionalContentGroups = optionalContent.get("OCGs");
                            if (Array.isArray(optionalContentGroups) || (0, _primitives.isDict)(optionalContentGroups)) {
                                const groupIds = [];
                                if (Array.isArray(optionalContentGroups)) for (const ocg of optionalContentGroups)groupIds.push(ocg.toString());
                                else groupIds.push(optionalContentGroups.objId);
                                return {
                                    type: optionalContentType,
                                    ids: groupIds,
                                    policy: (0, _primitives.isName)(optionalContent.get("P")) ? optionalContent.get("P").name : null,
                                    expression: null
                                };
                            } else if ((0, _primitives.isRef)(optionalContentGroups)) return {
                                type: optionalContentType,
                                id: optionalContentGroups.toString()
                            };
                        }
                        return null;
                    }
                    getOperatorList({ stream: stream , task: task , resources: resources , operatorList: operatorList , initialState: initialState = null , fallbackFontDict: fallbackFontDict = null  }) {
                        resources = resources || _primitives.Dict.empty;
                        initialState = initialState || new EvalState();
                        if (!operatorList) throw new Error('getOperatorList: missing "operatorList" parameter');
                        const self1 = this;
                        const xref = this.xref;
                        let parsingText = false;
                        const localImageCache = new _image_utils.LocalImageCache();
                        const localColorSpaceCache = new _image_utils.LocalColorSpaceCache();
                        const localGStateCache = new _image_utils.LocalGStateCache();
                        const localTilingPatternCache = new _image_utils.LocalTilingPatternCache();
                        const localShadingPatternCache = new Map();
                        const xobjs = resources.get("XObject") || _primitives.Dict.empty;
                        const patterns = resources.get("Pattern") || _primitives.Dict.empty;
                        const stateManager = new StateManager(initialState);
                        const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                        const timeSlotManager = new TimeSlotManager();
                        function closePendingRestoreOPS(argument) {
                            for(let i = 0, ii = preprocessor.savedStatesDepth; i < ii; i++)operatorList.addOp(_util.OPS.restore, []);
                        }
                        return new Promise(function promiseBody(resolve, reject) {
                            const next = function(promise) {
                                Promise.all([
                                    promise,
                                    operatorList.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(resolve, reject);
                                    } catch (ex) {
                                        reject(ex);
                                    }
                                }, reject);
                            };
                            task.ensureNotTerminated();
                            timeSlotManager.reset();
                            const operation = {};
                            let stop, i, ii, cs, name, isValidName;
                            while(!(stop = timeSlotManager.check())){
                                operation.args = null;
                                if (!preprocessor.read(operation)) break;
                                let args = operation.args;
                                let fn = operation.fn;
                                switch(fn | 0){
                                    case _util.OPS.paintXObject:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName) {
                                            const localImage = localImageCache.getByName(name);
                                            if (localImage) {
                                                operatorList.addOp(localImage.fn, localImage.args);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(resolveXObject, rejectXObject) {
                                            if (!isValidName) throw new _util.FormatError("XObject must be referred to by name.");
                                            let xobj = xobjs.getRaw(name);
                                            if (xobj instanceof _primitives.Ref) {
                                                const localImage = localImageCache.getByRef(xobj);
                                                if (localImage) {
                                                    operatorList.addOp(localImage.fn, localImage.args);
                                                    resolveXObject();
                                                    return;
                                                }
                                                const globalImage = self1.globalImageCache.getData(xobj, self1.pageIndex);
                                                if (globalImage) {
                                                    operatorList.addDependency(globalImage.objId);
                                                    operatorList.addOp(globalImage.fn, globalImage.args);
                                                    resolveXObject();
                                                    return;
                                                }
                                                xobj = xref.fetch(xobj);
                                            }
                                            if (!(0, _primitives.isStream)(xobj)) throw new _util.FormatError("XObject should be a stream");
                                            const type = xobj.dict.get("Subtype");
                                            if (!(0, _primitives.isName)(type)) throw new _util.FormatError("XObject should have a Name subtype");
                                            if (type.name === "Form") {
                                                stateManager.save();
                                                self1.buildFormXObject(resources, xobj, null, operatorList, task, stateManager.state.clone(), localColorSpaceCache).then(function() {
                                                    stateManager.restore();
                                                    resolveXObject();
                                                }, rejectXObject);
                                                return;
                                            } else if (type.name === "Image") {
                                                self1.buildPaintImageXObject({
                                                    resources: resources,
                                                    image: xobj,
                                                    operatorList: operatorList,
                                                    cacheKey: name,
                                                    localImageCache: localImageCache,
                                                    localColorSpaceCache: localColorSpaceCache
                                                }).then(resolveXObject, rejectXObject);
                                                return;
                                            } else if (type.name === "PS") (0, _util.info)("Ignored XObject subtype PS");
                                            else throw new _util.FormatError(`Unhandled XObject subtype ${type.name}`);
                                            resolveXObject();
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                self1.handler.send("UnsupportedFeature", {
                                                    featureId: _util.UNSUPPORTED_FEATURES.errorXObject
                                                });
                                                (0, _util.warn)(`getOperatorList - ignoring XObject: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.setFont:
                                        var fontSize = args[1];
                                        next(self1.handleSetFont(resources, args, null, operatorList, task, stateManager.state, fallbackFontDict).then(function(loadedName) {
                                            operatorList.addDependency(loadedName);
                                            operatorList.addOp(_util.OPS.setFont, [
                                                loadedName,
                                                fontSize
                                            ]);
                                        }));
                                        return;
                                    case _util.OPS.beginText:
                                        parsingText = true;
                                        break;
                                    case _util.OPS.endText:
                                        parsingText = false;
                                        break;
                                    case _util.OPS.endInlineImage:
                                        var cacheKey = args[0].cacheKey;
                                        if (cacheKey) {
                                            const localImage = localImageCache.getByName(cacheKey);
                                            if (localImage) {
                                                operatorList.addOp(localImage.fn, localImage.args);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(self1.buildPaintImageXObject({
                                            resources: resources,
                                            image: args[0],
                                            isInline: true,
                                            operatorList: operatorList,
                                            cacheKey: cacheKey,
                                            localImageCache: localImageCache,
                                            localColorSpaceCache: localColorSpaceCache
                                        }));
                                        return;
                                    case _util.OPS.showText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        break;
                                    case _util.OPS.showSpacedText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        var arr = args[0];
                                        var combinedGlyphs = [];
                                        var arrLength = arr.length;
                                        var state = stateManager.state;
                                        for(i = 0; i < arrLength; ++i){
                                            const arrItem = arr[i];
                                            if ((0, _util.isString)(arrItem)) Array.prototype.push.apply(combinedGlyphs, self1.handleText(arrItem, state));
                                            else if ((0, _util.isNum)(arrItem)) combinedGlyphs.push(arrItem);
                                        }
                                        args[0] = combinedGlyphs;
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.nextLineShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        operatorList.addOp(_util.OPS.nextLine);
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        operatorList.addOp(_util.OPS.nextLine);
                                        operatorList.addOp(_util.OPS.setWordSpacing, [
                                            args.shift()
                                        ]);
                                        operatorList.addOp(_util.OPS.setCharSpacing, [
                                            args.shift()
                                        ]);
                                        args[0] = self1.handleText(args[0], stateManager.state);
                                        fn = _util.OPS.showText;
                                        break;
                                    case _util.OPS.setTextRenderingMode:
                                        stateManager.state.textRenderingMode = args[0];
                                        break;
                                    case _util.OPS.setFillColorSpace:
                                        {
                                            const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                                            if (cachedColorSpace) {
                                                stateManager.state.fillColorSpace = cachedColorSpace;
                                                continue;
                                            }
                                            next(self1.parseColorSpace({
                                                cs: args[0],
                                                resources: resources,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(function(colorSpace) {
                                                if (colorSpace) stateManager.state.fillColorSpace = colorSpace;
                                            }));
                                            return;
                                        }
                                    case _util.OPS.setStrokeColorSpace:
                                        {
                                            const cachedColorSpace = _colorspace.ColorSpace.getCached(args[0], xref, localColorSpaceCache);
                                            if (cachedColorSpace) {
                                                stateManager.state.strokeColorSpace = cachedColorSpace;
                                                continue;
                                            }
                                            next(self1.parseColorSpace({
                                                cs: args[0],
                                                resources: resources,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(function(colorSpace) {
                                                if (colorSpace) stateManager.state.strokeColorSpace = colorSpace;
                                            }));
                                            return;
                                        }
                                    case _util.OPS.setFillColor:
                                        cs = stateManager.state.fillColorSpace;
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeColor:
                                        cs = stateManager.state.strokeColorSpace;
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillGray:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                                        args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeGray:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                                        args = _colorspace.ColorSpace.singletons.gray.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillCMYKColor:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                                        args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeCMYKColor:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.cmyk;
                                        args = _colorspace.ColorSpace.singletons.cmyk.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.setFillRGBColor:
                                        stateManager.state.fillColorSpace = _colorspace.ColorSpace.singletons.rgb;
                                        args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                                        break;
                                    case _util.OPS.setStrokeRGBColor:
                                        stateManager.state.strokeColorSpace = _colorspace.ColorSpace.singletons.rgb;
                                        args = _colorspace.ColorSpace.singletons.rgb.getRgb(args, 0);
                                        break;
                                    case _util.OPS.setFillColorN:
                                        cs = stateManager.state.fillColorSpace;
                                        if (cs.name === "Pattern") {
                                            next(self1.handleColorN(operatorList, _util.OPS.setFillColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                                            return;
                                        }
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setFillRGBColor;
                                        break;
                                    case _util.OPS.setStrokeColorN:
                                        cs = stateManager.state.strokeColorSpace;
                                        if (cs.name === "Pattern") {
                                            next(self1.handleColorN(operatorList, _util.OPS.setStrokeColorN, args, cs, patterns, resources, task, localColorSpaceCache, localTilingPatternCache, localShadingPatternCache));
                                            return;
                                        }
                                        args = cs.getRgb(args, 0);
                                        fn = _util.OPS.setStrokeRGBColor;
                                        break;
                                    case _util.OPS.shadingFill:
                                        var shadingRes = resources.get("Shading");
                                        if (!shadingRes) throw new _util.FormatError("No shading resource found");
                                        var shading = shadingRes.get(args[0].name);
                                        if (!shading) throw new _util.FormatError("No shading object found");
                                        const patternId = self1.parseShading({
                                            keyObj: shading,
                                            shading: shading,
                                            resources: resources,
                                            localColorSpaceCache: localColorSpaceCache,
                                            localShadingPatternCache: localShadingPatternCache
                                        });
                                        args = [
                                            patternId
                                        ];
                                        fn = _util.OPS.shadingFill;
                                        break;
                                    case _util.OPS.setGState:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName) {
                                            const localGStateObj = localGStateCache.getByName(name);
                                            if (localGStateObj) {
                                                if (localGStateObj.length > 0) operatorList.addOp(_util.OPS.setGState, [
                                                    localGStateObj
                                                ]);
                                                args = null;
                                                continue;
                                            }
                                        }
                                        next(new Promise(function(resolveGState, rejectGState) {
                                            if (!isValidName) throw new _util.FormatError("GState must be referred to by name.");
                                            const extGState = resources.get("ExtGState");
                                            if (!(extGState instanceof _primitives.Dict)) throw new _util.FormatError("ExtGState should be a dictionary.");
                                            const gState = extGState.get(name);
                                            if (!(gState instanceof _primitives.Dict)) throw new _util.FormatError("GState should be a dictionary.");
                                            self1.setGState({
                                                resources: resources,
                                                gState: gState,
                                                operatorList: operatorList,
                                                cacheKey: name,
                                                task: task,
                                                stateManager: stateManager,
                                                localGStateCache: localGStateCache,
                                                localColorSpaceCache: localColorSpaceCache
                                            }).then(resolveGState, rejectGState);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                self1.handler.send("UnsupportedFeature", {
                                                    featureId: _util.UNSUPPORTED_FEATURES.errorExtGState
                                                });
                                                (0, _util.warn)(`getOperatorList - ignoring ExtGState: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.moveTo:
                                    case _util.OPS.lineTo:
                                    case _util.OPS.curveTo:
                                    case _util.OPS.curveTo2:
                                    case _util.OPS.curveTo3:
                                    case _util.OPS.closePath:
                                    case _util.OPS.rectangle:
                                        self1.buildPath(operatorList, fn, args, parsingText);
                                        continue;
                                    case _util.OPS.markPoint:
                                    case _util.OPS.markPointProps:
                                    case _util.OPS.beginCompat:
                                    case _util.OPS.endCompat:
                                        continue;
                                    case _util.OPS.beginMarkedContentProps:
                                        if (!(0, _primitives.isName)(args[0])) {
                                            (0, _util.warn)(`Expected name for beginMarkedContentProps arg0=${args[0]}`);
                                            continue;
                                        }
                                        if (args[0].name === "OC") {
                                            next(self1.parseMarkedContentProps(args[1], resources).then((data)=>{
                                                operatorList.addOp(_util.OPS.beginMarkedContentProps, [
                                                    "OC",
                                                    data
                                                ]);
                                            }).catch((reason)=>{
                                                if (reason instanceof _util.AbortException) return;
                                                if (self1.options.ignoreErrors) {
                                                    self1.handler.send("UnsupportedFeature", {
                                                        featureId: _util.UNSUPPORTED_FEATURES.errorMarkedContent
                                                    });
                                                    (0, _util.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${reason}".`);
                                                    return;
                                                }
                                                throw reason;
                                            }));
                                            return;
                                        }
                                        args = [
                                            args[0].name,
                                            args[1] instanceof _primitives.Dict ? args[1].get("MCID") : null
                                        ];
                                        break;
                                    case _util.OPS.beginMarkedContent:
                                    case _util.OPS.endMarkedContent:
                                    default:
                                        if (args !== null) {
                                            for(i = 0, ii = args.length; i < ii; i++){
                                                if (args[i] instanceof _primitives.Dict) break;
                                            }
                                            if (i < ii) {
                                                (0, _util.warn)("getOperatorList - ignoring operator: " + fn);
                                                continue;
                                            }
                                        }
                                }
                                operatorList.addOp(fn, args);
                            }
                            if (stop) {
                                next(deferred);
                                return;
                            }
                            closePendingRestoreOPS();
                            resolve();
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                this.handler.send("UnsupportedFeature", {
                                    featureId: _util.UNSUPPORTED_FEATURES.errorOperatorList
                                });
                                (0, _util.warn)(`getOperatorList - ignoring errors during "${task.name}" ` + `task: "${reason}".`);
                                closePendingRestoreOPS();
                                return;
                            }
                            throw reason;
                        });
                    }
                    getTextContent({ stream: stream , task: task , resources: resources , stateManager: stateManager = null , normalizeWhitespace: normalizeWhitespace = false , combineTextItems: combineTextItems = false , includeMarkedContent: includeMarkedContent = false , sink: sink , seenStyles: seenStyles = new Set()  }) {
                        resources = resources || _primitives.Dict.empty;
                        stateManager = stateManager || new StateManager(new TextState());
                        const WhitespaceRegexp = /\s/g;
                        const textContent = {
                            items: [],
                            styles: Object.create(null)
                        };
                        const textContentItem = {
                            initialized: false,
                            str: [],
                            totalWidth: 0,
                            totalHeight: 0,
                            width: 0,
                            height: 0,
                            vertical: false,
                            lastCharSize: 0,
                            prevTransform: null,
                            textAdvanceScale: 0,
                            spaceWidth: 0,
                            spaceInFlowMin: 0,
                            spaceInFlowMax: 0,
                            trackingSpaceMin: Infinity,
                            transform: null,
                            fontName: null,
                            hasEOL: false,
                            isLastCharWhiteSpace: false
                        };
                        const TRACKING_SPACE_FACTOR = 0.3;
                        const SPACE_IN_FLOW_MIN_FACTOR = 0.3;
                        const SPACE_IN_FLOW_MAX_FACTOR = 1.3;
                        const self1 = this;
                        const xref = this.xref;
                        const showSpacedTextBuffer = [];
                        let xobjs = null;
                        const emptyXObjectCache = new _image_utils.LocalImageCache();
                        const emptyGStateCache = new _image_utils.LocalGStateCache();
                        const preprocessor = new EvaluatorPreprocessor(stream, xref, stateManager);
                        let textState;
                        function getCurrentTextTransform() {
                            const font1 = textState.font;
                            const tsm = [
                                textState.fontSize * textState.textHScale,
                                0,
                                0,
                                textState.fontSize,
                                0,
                                textState.textRise
                            ];
                            if (font1.isType3Font && (textState.fontSize <= 1 || font1.isCharBBox) && !(0, _util.isArrayEqual)(textState.fontMatrix, _util.FONT_IDENTITY_MATRIX)) {
                                const glyphHeight = font1.bbox[3] - font1.bbox[1];
                                if (glyphHeight > 0) tsm[3] *= glyphHeight * textState.fontMatrix[3];
                            }
                            return _util.Util.transform(textState.ctm, _util.Util.transform(textState.textMatrix, tsm));
                        }
                        function ensureTextContentItem() {
                            if (textContentItem.initialized) return textContentItem;
                            const font1 = textState.font, loadedName = font1.loadedName;
                            if (!seenStyles.has(loadedName)) {
                                seenStyles.add(loadedName);
                                textContent.styles[loadedName] = {
                                    fontFamily: font1.fallbackName,
                                    ascent: font1.ascent,
                                    descent: font1.descent,
                                    vertical: font1.vertical
                                };
                            }
                            textContentItem.fontName = loadedName;
                            const trm = textContentItem.transform = getCurrentTextTransform();
                            if (!font1.vertical) {
                                textContentItem.width = textContentItem.totalWidth = 0;
                                textContentItem.height = textContentItem.totalHeight = Math.hypot(trm[2], trm[3]);
                                textContentItem.vertical = false;
                            } else {
                                textContentItem.width = textContentItem.totalWidth = Math.hypot(trm[0], trm[1]);
                                textContentItem.height = textContentItem.totalHeight = 0;
                                textContentItem.vertical = true;
                            }
                            const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                            const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                            textContentItem.textAdvanceScale = scaleCtmX * scaleLineX;
                            textContentItem.lastCharSize = textContentItem.lastCharSize || 0;
                            const spaceWidth = font1.spaceWidth / 1000 * textState.fontSize;
                            if (spaceWidth) {
                                textContentItem.spaceWidth = spaceWidth;
                                textContentItem.trackingSpaceMin = spaceWidth * TRACKING_SPACE_FACTOR;
                                textContentItem.spaceInFlowMin = spaceWidth * SPACE_IN_FLOW_MIN_FACTOR;
                                textContentItem.spaceInFlowMax = spaceWidth * SPACE_IN_FLOW_MAX_FACTOR;
                            } else {
                                textContentItem.spaceWidth = 0;
                                textContentItem.trackingSpaceMin = Infinity;
                            }
                            textContentItem.hasEOL = false;
                            textContentItem.initialized = true;
                            return textContentItem;
                        }
                        function updateAdvanceScale() {
                            if (!textContentItem.initialized) return;
                            const scaleLineX = Math.hypot(textState.textLineMatrix[0], textState.textLineMatrix[1]);
                            const scaleCtmX = Math.hypot(textState.ctm[0], textState.ctm[1]);
                            const scaleFactor = scaleCtmX * scaleLineX;
                            if (scaleFactor === textContentItem.textAdvanceScale) return;
                            if (!textContentItem.vertical) {
                                textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                                textContentItem.width = 0;
                            } else {
                                textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                                textContentItem.height = 0;
                            }
                            textContentItem.textAdvanceScale = scaleFactor;
                        }
                        function replaceWhitespace(str) {
                            const ii = str.length;
                            let i = 0, code;
                            while(i < ii && (code = str.charCodeAt(i)) >= 0x20 && code <= 0x7f)i++;
                            return i < ii ? str.replace(WhitespaceRegexp, " ") : str;
                        }
                        function runBidiTransform(textChunk) {
                            const text = textChunk.str.join("");
                            const bidiResult = (0, _bidi.bidi)(text, -1, textChunk.vertical);
                            const str = normalizeWhitespace ? replaceWhitespace(bidiResult.str) : bidiResult.str;
                            return {
                                str: str,
                                dir: bidiResult.dir,
                                width: textChunk.totalWidth,
                                height: textChunk.totalHeight,
                                transform: textChunk.transform,
                                fontName: textChunk.fontName,
                                hasEOL: textChunk.hasEOL
                            };
                        }
                        function handleSetFont(fontName, fontRef) {
                            return self1.loadFont(fontName, fontRef, resources).then(function(translated) {
                                if (!translated.font.isType3Font) return translated;
                                return translated.loadType3Data(self1, resources, task).catch(function() {}).then(function() {
                                    return translated;
                                });
                            }).then(function(translated) {
                                textState.font = translated.font;
                                textState.fontMatrix = translated.font.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                            });
                        }
                        function compareWithLastPosition(fontSize) {
                            if (!combineTextItems || !textState.font || !textContentItem.prevTransform) return;
                            const currentTransform = getCurrentTextTransform();
                            const posX = currentTransform[4];
                            const posY = currentTransform[5];
                            const lastPosX = textContentItem.prevTransform[4];
                            const lastPosY = textContentItem.prevTransform[5];
                            if (lastPosX === posX && lastPosY === posY) return;
                            const advanceX = (posX - lastPosX) / textContentItem.textAdvanceScale;
                            const advanceY = (posY - lastPosY) / textContentItem.textAdvanceScale;
                            const HALF_LAST_CHAR = -0.5 * textContentItem.lastCharSize;
                            if (textState.font.vertical) {
                                if (Math.abs(advanceX) > textContentItem.width / textContentItem.textAdvanceScale) {
                                    appendEOL();
                                    return;
                                }
                                if (HALF_LAST_CHAR > advanceY) return;
                                if (advanceY > textContentItem.trackingSpaceMin) textContentItem.height += advanceY;
                                else if (!addFakeSpaces(advanceY, 0, textContentItem.prevTransform)) {
                                    if (textContentItem.str.length === 0) {
                                        textContent.items.push({
                                            str: " ",
                                            dir: "ltr",
                                            width: 0,
                                            height: advanceY,
                                            transform: textContentItem.prevTransform,
                                            fontName: textContentItem.fontName,
                                            hasEOL: false
                                        });
                                        textContentItem.isLastCharWhiteSpace = true;
                                    } else textContentItem.height += advanceY;
                                }
                                return;
                            }
                            if (Math.abs(advanceY) > textContentItem.height / textContentItem.textAdvanceScale) {
                                appendEOL();
                                return;
                            }
                            if (HALF_LAST_CHAR > advanceX) return;
                            if (advanceX <= textContentItem.trackingSpaceMin) textContentItem.width += advanceX;
                            else if (!addFakeSpaces(advanceX, 0, textContentItem.prevTransform)) {
                                if (textContentItem.str.length === 0) {
                                    textContent.items.push({
                                        str: " ",
                                        dir: "ltr",
                                        width: advanceX,
                                        height: 0,
                                        transform: textContentItem.prevTransform,
                                        fontName: textContentItem.fontName,
                                        hasEOL: false
                                    });
                                    textContentItem.isLastCharWhiteSpace = true;
                                } else textContentItem.width += advanceX;
                            }
                        }
                        function buildTextContentItem({ chars: chars , extraSpacing: extraSpacing , isFirstChunk: isFirstChunk  }) {
                            const font1 = textState.font;
                            if (!chars) {
                                const charSpacing = textState.charSpacing + extraSpacing;
                                if (charSpacing) {
                                    if (!font1.vertical) textState.translateTextMatrix(charSpacing * textState.textHScale, 0);
                                    else textState.translateTextMatrix(0, charSpacing);
                                }
                                return;
                            }
                            const NormalizedUnicodes = (0, _unicode.getNormalizedUnicodes)();
                            const glyphs = font1.charsToGlyphs(chars);
                            const scale = textState.fontMatrix[0] * textState.fontSize;
                            if (isFirstChunk) compareWithLastPosition(scale);
                            let textChunk = ensureTextContentItem();
                            let size = 0;
                            let lastCharSize = 0;
                            for(let i = 0, ii = glyphs.length; i < ii; i++){
                                const glyph = glyphs[i];
                                let charSpacing = textState.charSpacing + (i === ii - 1 ? extraSpacing : 0);
                                let glyphUnicode = glyph.unicode;
                                if (glyph.isSpace) {
                                    charSpacing += textState.wordSpacing;
                                    textChunk.isLastCharWhiteSpace = true;
                                } else {
                                    glyphUnicode = NormalizedUnicodes[glyphUnicode] || glyphUnicode;
                                    glyphUnicode = (0, _unicode.reverseIfRtl)(glyphUnicode);
                                    textChunk.isLastCharWhiteSpace = false;
                                }
                                textChunk.str.push(glyphUnicode);
                                const glyphWidth = font1.vertical && glyph.vmetric ? glyph.vmetric[0] : glyph.width;
                                let scaledDim = glyphWidth * scale;
                                if (!font1.vertical) {
                                    scaledDim *= textState.textHScale;
                                    textState.translateTextMatrix(scaledDim, 0);
                                } else {
                                    textState.translateTextMatrix(0, scaledDim);
                                    scaledDim = Math.abs(scaledDim);
                                }
                                size += scaledDim;
                                if (charSpacing) {
                                    if (!font1.vertical) charSpacing *= textState.textHScale;
                                    scaledDim += charSpacing;
                                    const wasSplit = charSpacing > textContentItem.trackingSpaceMin && addFakeSpaces(charSpacing, size);
                                    if (!font1.vertical) textState.translateTextMatrix(charSpacing, 0);
                                    else textState.translateTextMatrix(0, charSpacing);
                                    if (wasSplit) {
                                        textChunk = ensureTextContentItem();
                                        size = 0;
                                    } else size += charSpacing;
                                }
                                lastCharSize = scaledDim;
                            }
                            textChunk.lastCharSize = lastCharSize;
                            if (!font1.vertical) textChunk.width += size;
                            else textChunk.height += size;
                            textChunk.prevTransform = getCurrentTextTransform();
                        }
                        function appendEOL() {
                            if (textContentItem.initialized) {
                                textContentItem.hasEOL = true;
                                flushTextContentItem();
                            } else if (textContent.items.length > 0) textContent.items[textContent.items.length - 1].hasEOL = true;
                            else textContent.items.push({
                                str: "",
                                dir: "ltr",
                                width: 0,
                                height: 0,
                                transform: getCurrentTextTransform(),
                                fontName: textState.font.loadedName,
                                hasEOL: true
                            });
                            textContentItem.isLastCharWhiteSpace = false;
                            textContentItem.lastCharSize = 0;
                        }
                        function addFakeSpaces(width, size, transf = null) {
                            if (textContentItem.spaceInFlowMin <= width && width <= textContentItem.spaceInFlowMax) {
                                if (textContentItem.initialized) {
                                    textContentItem.str.push(" ");
                                    textContentItem.isLastCharWhiteSpace = true;
                                }
                                return false;
                            }
                            const fontName = textContentItem.fontName;
                            let height = 0;
                            width *= textContentItem.textAdvanceScale;
                            if (!textContentItem.vertical) textContentItem.width += size;
                            else {
                                textContentItem.height += size;
                                height = width;
                                width = 0;
                            }
                            flushTextContentItem();
                            if (textContentItem.isLastCharWhiteSpace) return true;
                            textContentItem.isLastCharWhiteSpace = true;
                            textContent.items.push({
                                str: " ",
                                dir: "ltr",
                                width: width,
                                height: height,
                                transform: transf ? transf : getCurrentTextTransform(),
                                fontName: fontName,
                                hasEOL: false
                            });
                            return true;
                        }
                        function flushTextContentItem() {
                            if (!textContentItem.initialized || !textContentItem.str) return;
                            if (!textContentItem.vertical) textContentItem.totalWidth += textContentItem.width * textContentItem.textAdvanceScale;
                            else textContentItem.totalHeight += textContentItem.height * textContentItem.textAdvanceScale;
                            textContent.items.push(runBidiTransform(textContentItem));
                            textContentItem.initialized = false;
                            textContentItem.str.length = 0;
                        }
                        function enqueueChunk() {
                            const length = textContent.items.length;
                            if (length > 0) {
                                sink.enqueue(textContent, length);
                                textContent.items = [];
                                textContent.styles = Object.create(null);
                            }
                        }
                        const timeSlotManager = new TimeSlotManager();
                        return new Promise(function promiseBody(resolve, reject) {
                            const next = function(promise) {
                                enqueueChunk();
                                Promise.all([
                                    promise,
                                    sink.ready
                                ]).then(function() {
                                    try {
                                        promiseBody(resolve, reject);
                                    } catch (ex) {
                                        reject(ex);
                                    }
                                }, reject);
                            };
                            task.ensureNotTerminated();
                            timeSlotManager.reset();
                            const operation = {};
                            let stop, args = [];
                            while(!(stop = timeSlotManager.check())){
                                args.length = 0;
                                operation.args = args;
                                if (!preprocessor.read(operation)) break;
                                textState = stateManager.state;
                                const fn = operation.fn;
                                args = operation.args;
                                switch(fn | 0){
                                    case _util.OPS.setFont:
                                        var fontNameArg = args[0].name, fontSizeArg = args[1];
                                        if (textState.font && fontNameArg === textState.fontName && fontSizeArg === textState.fontSize) break;
                                        flushTextContentItem();
                                        textState.fontName = fontNameArg;
                                        textState.fontSize = fontSizeArg;
                                        next(handleSetFont(fontNameArg, null));
                                        return;
                                    case _util.OPS.setTextRise:
                                        flushTextContentItem();
                                        textState.textRise = args[0];
                                        break;
                                    case _util.OPS.setHScale:
                                        flushTextContentItem();
                                        textState.textHScale = args[0] / 100;
                                        break;
                                    case _util.OPS.setLeading:
                                        flushTextContentItem();
                                        textState.leading = args[0];
                                        break;
                                    case _util.OPS.moveText:
                                        textState.translateTextLineMatrix(args[0], args[1]);
                                        textState.textMatrix = textState.textLineMatrix.slice();
                                        break;
                                    case _util.OPS.setLeadingMoveText:
                                        flushTextContentItem();
                                        textState.leading = -args[1];
                                        textState.translateTextLineMatrix(args[0], args[1]);
                                        textState.textMatrix = textState.textLineMatrix.slice();
                                        break;
                                    case _util.OPS.nextLine:
                                        appendEOL();
                                        textState.carriageReturn();
                                        break;
                                    case _util.OPS.setTextMatrix:
                                        textState.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                        textState.setTextLineMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                        updateAdvanceScale();
                                        break;
                                    case _util.OPS.setCharSpacing:
                                        textState.charSpacing = args[0];
                                        break;
                                    case _util.OPS.setWordSpacing:
                                        textState.wordSpacing = args[0];
                                        break;
                                    case _util.OPS.beginText:
                                        flushTextContentItem();
                                        textState.textMatrix = _util.IDENTITY_MATRIX.slice();
                                        textState.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                                        break;
                                    case _util.OPS.showSpacedText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        const spaceFactor = (textState.font.vertical ? 1 : -1) * textState.fontSize / 1000;
                                        const elements = args[0];
                                        let isFirstChunk = true;
                                        for(let i = 0, ii = elements.length; i < ii - 1; i++){
                                            const item = elements[i];
                                            if (typeof item === "string") showSpacedTextBuffer.push(item);
                                            else if (typeof item === "number" && item !== 0) {
                                                const str = showSpacedTextBuffer.join("");
                                                showSpacedTextBuffer.length = 0;
                                                buildTextContentItem({
                                                    chars: str,
                                                    extraSpacing: item * spaceFactor,
                                                    isFirstChunk: isFirstChunk
                                                });
                                                if (str && isFirstChunk) isFirstChunk = false;
                                            }
                                        }
                                        const item = elements[elements.length - 1];
                                        if (typeof item === "string") showSpacedTextBuffer.push(item);
                                        if (showSpacedTextBuffer.length > 0) {
                                            const str = showSpacedTextBuffer.join("");
                                            showSpacedTextBuffer.length = 0;
                                            buildTextContentItem({
                                                chars: str,
                                                extraSpacing: 0,
                                                isFirstChunk: isFirstChunk
                                            });
                                        }
                                        break;
                                    case _util.OPS.showText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        buildTextContentItem({
                                            chars: args[0],
                                            extraSpacing: 0,
                                            isFirstChunk: true
                                        });
                                        break;
                                    case _util.OPS.nextLineShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        textContentItem.hasEOL = true;
                                        flushTextContentItem();
                                        textState.carriageReturn();
                                        buildTextContentItem({
                                            chars: args[0],
                                            extraSpacing: 0,
                                            isFirstChunk: true
                                        });
                                        break;
                                    case _util.OPS.nextLineSetSpacingShowText:
                                        if (!stateManager.state.font) {
                                            self1.ensureStateFont(stateManager.state);
                                            continue;
                                        }
                                        textContentItem.hasEOL = true;
                                        flushTextContentItem();
                                        textState.wordSpacing = args[0];
                                        textState.charSpacing = args[1];
                                        textState.carriageReturn();
                                        buildTextContentItem({
                                            chars: args[2],
                                            extraSpacing: 0,
                                            isFirstChunk: true
                                        });
                                        break;
                                    case _util.OPS.paintXObject:
                                        flushTextContentItem();
                                        if (!xobjs) xobjs = resources.get("XObject") || _primitives.Dict.empty;
                                        var isValidName = args[0] instanceof _primitives.Name;
                                        var name = args[0].name;
                                        if (isValidName && emptyXObjectCache.getByName(name)) break;
                                        next(new Promise(function(resolveXObject, rejectXObject) {
                                            if (!isValidName) throw new _util.FormatError("XObject must be referred to by name.");
                                            let xobj = xobjs.getRaw(name);
                                            if (xobj instanceof _primitives.Ref) {
                                                if (emptyXObjectCache.getByRef(xobj)) {
                                                    resolveXObject();
                                                    return;
                                                }
                                                const globalImage = self1.globalImageCache.getData(xobj, self1.pageIndex);
                                                if (globalImage) {
                                                    resolveXObject();
                                                    return;
                                                }
                                                xobj = xref.fetch(xobj);
                                            }
                                            if (!(0, _primitives.isStream)(xobj)) throw new _util.FormatError("XObject should be a stream");
                                            const type = xobj.dict.get("Subtype");
                                            if (!(0, _primitives.isName)(type)) throw new _util.FormatError("XObject should have a Name subtype");
                                            if (type.name !== "Form") {
                                                emptyXObjectCache.set(name, xobj.dict.objId, true);
                                                resolveXObject();
                                                return;
                                            }
                                            const currentState = stateManager.state.clone();
                                            const xObjStateManager = new StateManager(currentState);
                                            const matrix = xobj.dict.getArray("Matrix");
                                            if (Array.isArray(matrix) && matrix.length === 6) xObjStateManager.transform(matrix);
                                            enqueueChunk();
                                            const sinkWrapper = {
                                                enqueueInvoked: false,
                                                enqueue (chunk, size) {
                                                    this.enqueueInvoked = true;
                                                    sink.enqueue(chunk, size);
                                                },
                                                get desiredSize () {
                                                    return sink.desiredSize;
                                                },
                                                get ready () {
                                                    return sink.ready;
                                                }
                                            };
                                            self1.getTextContent({
                                                stream: xobj,
                                                task: task,
                                                resources: xobj.dict.get("Resources") || resources,
                                                stateManager: xObjStateManager,
                                                normalizeWhitespace: normalizeWhitespace,
                                                combineTextItems: combineTextItems,
                                                includeMarkedContent: includeMarkedContent,
                                                sink: sinkWrapper,
                                                seenStyles: seenStyles
                                            }).then(function() {
                                                if (!sinkWrapper.enqueueInvoked) emptyXObjectCache.set(name, xobj.dict.objId, true);
                                                resolveXObject();
                                            }, rejectXObject);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getTextContent - ignoring XObject: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.setGState:
                                        isValidName = args[0] instanceof _primitives.Name;
                                        name = args[0].name;
                                        if (isValidName && emptyGStateCache.getByName(name)) break;
                                        next(new Promise(function(resolveGState, rejectGState) {
                                            if (!isValidName) throw new _util.FormatError("GState must be referred to by name.");
                                            const extGState = resources.get("ExtGState");
                                            if (!(extGState instanceof _primitives.Dict)) throw new _util.FormatError("ExtGState should be a dictionary.");
                                            const gState = extGState.get(name);
                                            if (!(gState instanceof _primitives.Dict)) throw new _util.FormatError("GState should be a dictionary.");
                                            const gStateFont = gState.get("Font");
                                            if (!gStateFont) {
                                                emptyGStateCache.set(name, gState.objId, true);
                                                resolveGState();
                                                return;
                                            }
                                            flushTextContentItem();
                                            textState.fontName = null;
                                            textState.fontSize = gStateFont[1];
                                            handleSetFont(null, gStateFont[0]).then(resolveGState, rejectGState);
                                        }).catch(function(reason) {
                                            if (reason instanceof _util.AbortException) return;
                                            if (self1.options.ignoreErrors) {
                                                (0, _util.warn)(`getTextContent - ignoring ExtGState: "${reason}".`);
                                                return;
                                            }
                                            throw reason;
                                        }));
                                        return;
                                    case _util.OPS.beginMarkedContent:
                                        if (includeMarkedContent) textContent.items.push({
                                            type: "beginMarkedContent",
                                            tag: (0, _primitives.isName)(args[0]) ? args[0].name : null
                                        });
                                        break;
                                    case _util.OPS.beginMarkedContentProps:
                                        if (includeMarkedContent) {
                                            flushTextContentItem();
                                            let mcid = null;
                                            if ((0, _primitives.isDict)(args[1])) mcid = args[1].get("MCID");
                                            textContent.items.push({
                                                type: "beginMarkedContentProps",
                                                id: Number.isInteger(mcid) ? `${self1.idFactory.getPageObjId()}_mcid${mcid}` : null,
                                                tag: (0, _primitives.isName)(args[0]) ? args[0].name : null
                                            });
                                        }
                                        break;
                                    case _util.OPS.endMarkedContent:
                                        if (includeMarkedContent) {
                                            flushTextContentItem();
                                            textContent.items.push({
                                                type: "endMarkedContent"
                                            });
                                        }
                                        break;
                                }
                                if (textContent.items.length >= sink.desiredSize) {
                                    stop = true;
                                    break;
                                }
                            }
                            if (stop) {
                                next(deferred);
                                return;
                            }
                            flushTextContentItem();
                            enqueueChunk();
                            resolve();
                        }).catch((reason)=>{
                            if (reason instanceof _util.AbortException) return;
                            if (this.options.ignoreErrors) {
                                (0, _util.warn)(`getTextContent - ignoring errors during "${task.name}" ` + `task: "${reason}".`);
                                flushTextContentItem();
                                enqueueChunk();
                                return;
                            }
                            throw reason;
                        });
                    }
                    extractDataStructures(dict, baseDict, properties) {
                        const xref = this.xref;
                        let cidToGidBytes;
                        const toUnicodePromise = this.readToUnicode(properties.toUnicode || dict.get("ToUnicode") || baseDict.get("ToUnicode"));
                        if (properties.composite) {
                            const cidSystemInfo = dict.get("CIDSystemInfo");
                            if ((0, _primitives.isDict)(cidSystemInfo)) properties.cidSystemInfo = {
                                registry: (0, _util.stringToPDFString)(cidSystemInfo.get("Registry")),
                                ordering: (0, _util.stringToPDFString)(cidSystemInfo.get("Ordering")),
                                supplement: cidSystemInfo.get("Supplement")
                            };
                            const cidToGidMap = dict.get("CIDToGIDMap");
                            if ((0, _primitives.isStream)(cidToGidMap)) cidToGidBytes = cidToGidMap.getBytes();
                        }
                        const differences = [];
                        let baseEncodingName = null;
                        let encoding;
                        if (dict.has("Encoding")) {
                            encoding = dict.get("Encoding");
                            if ((0, _primitives.isDict)(encoding)) {
                                baseEncodingName = encoding.get("BaseEncoding");
                                baseEncodingName = (0, _primitives.isName)(baseEncodingName) ? baseEncodingName.name : null;
                                if (encoding.has("Differences")) {
                                    const diffEncoding = encoding.get("Differences");
                                    let index = 0;
                                    for(let j = 0, jj = diffEncoding.length; j < jj; j++){
                                        const data = xref.fetchIfRef(diffEncoding[j]);
                                        if ((0, _util.isNum)(data)) index = data;
                                        else if ((0, _primitives.isName)(data)) differences[index++] = data.name;
                                        else throw new _util.FormatError(`Invalid entry in 'Differences' array: ${data}`);
                                    }
                                }
                            } else if ((0, _primitives.isName)(encoding)) baseEncodingName = encoding.name;
                            else throw new _util.FormatError("Encoding is not a Name nor a Dict");
                            if (baseEncodingName !== "MacRomanEncoding" && baseEncodingName !== "MacExpertEncoding" && baseEncodingName !== "WinAnsiEncoding") baseEncodingName = null;
                        }
                        if (baseEncodingName) properties.defaultEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                        else {
                            const isSymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Symbolic);
                            const isNonsymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Nonsymbolic);
                            encoding = _encodings.StandardEncoding;
                            if (properties.type === "TrueType" && !isNonsymbolicFont) encoding = _encodings.WinAnsiEncoding;
                            if (isSymbolicFont) {
                                encoding = _encodings.MacRomanEncoding;
                                if (!properties.file || properties.isInternalFont) {
                                    if (/Symbol/i.test(properties.name)) encoding = _encodings.SymbolSetEncoding;
                                    else if (/Dingbats|Wingdings/i.test(properties.name)) encoding = _encodings.ZapfDingbatsEncoding;
                                }
                            }
                            properties.defaultEncoding = encoding;
                        }
                        properties.differences = differences;
                        properties.baseEncodingName = baseEncodingName;
                        properties.hasEncoding = !!baseEncodingName || differences.length > 0;
                        properties.dict = dict;
                        return toUnicodePromise.then((readToUnicode)=>{
                            properties.toUnicode = readToUnicode;
                            return this.buildToUnicode(properties);
                        }).then((builtToUnicode)=>{
                            properties.toUnicode = builtToUnicode;
                            if (cidToGidBytes) properties.cidToGidMap = this.readCidToGidMap(cidToGidBytes, builtToUnicode);
                            return properties;
                        });
                    }
                    _simpleFontToUnicode(properties, forceGlyphs = false) {
                        (0, _util.assert)(!properties.composite, "Must be a simple font.");
                        const toUnicode = [];
                        const encoding = properties.defaultEncoding.slice();
                        const baseEncodingName = properties.baseEncodingName;
                        const differences = properties.differences;
                        for(const charcode in differences){
                            const glyphName = differences[charcode];
                            if (glyphName === ".notdef") continue;
                            encoding[charcode] = glyphName;
                        }
                        const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                        for(const charcode in encoding){
                            let glyphName = encoding[charcode];
                            if (glyphName === "") continue;
                            else if (glyphsUnicodeMap[glyphName] === undefined) {
                                let code = 0;
                                switch(glyphName[0]){
                                    case "G":
                                        if (glyphName.length === 3) code = parseInt(glyphName.substring(1), 16);
                                        break;
                                    case "g":
                                        if (glyphName.length === 5) code = parseInt(glyphName.substring(1), 16);
                                        break;
                                    case "C":
                                    case "c":
                                        if (glyphName.length >= 3 && glyphName.length <= 4) {
                                            const codeStr = glyphName.substring(1);
                                            if (forceGlyphs) {
                                                code = parseInt(codeStr, 16);
                                                break;
                                            }
                                            code = +codeStr;
                                            if (Number.isNaN(code) && Number.isInteger(parseInt(codeStr, 16))) return this._simpleFontToUnicode(properties, true);
                                        }
                                        break;
                                    default:
                                        const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                                        if (unicode !== -1) code = unicode;
                                }
                                if (code > 0 && code <= 0x10ffff && Number.isInteger(code)) {
                                    if (baseEncodingName && code === +charcode) {
                                        const baseEncoding = (0, _encodings.getEncoding)(baseEncodingName);
                                        if (baseEncoding && (glyphName = baseEncoding[charcode])) {
                                            toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
                                            continue;
                                        }
                                    }
                                    toUnicode[charcode] = String.fromCodePoint(code);
                                }
                                continue;
                            }
                            toUnicode[charcode] = String.fromCharCode(glyphsUnicodeMap[glyphName]);
                        }
                        return toUnicode;
                    }
                    async buildToUnicode(properties) {
                        properties.hasIncludedToUnicodeMap = !!properties.toUnicode && properties.toUnicode.length > 0;
                        if (properties.hasIncludedToUnicodeMap) {
                            if (!properties.composite && properties.hasEncoding) properties.fallbackToUnicode = this._simpleFontToUnicode(properties);
                            return properties.toUnicode;
                        }
                        if (!properties.composite) return new _to_unicode_map.ToUnicodeMap(this._simpleFontToUnicode(properties));
                        if (properties.composite && (properties.cMap.builtInCMap && !(properties.cMap instanceof _cmap.IdentityCMap) || properties.cidSystemInfo.registry === "Adobe" && (properties.cidSystemInfo.ordering === "GB1" || properties.cidSystemInfo.ordering === "CNS1" || properties.cidSystemInfo.ordering === "Japan1" || properties.cidSystemInfo.ordering === "Korea1"))) {
                            const { registry: registry , ordering: ordering  } = properties.cidSystemInfo;
                            const ucs2CMapName = _primitives.Name.get(`${registry}-${ordering}-UCS2`);
                            const ucs2CMap = await _cmap.CMapFactory.create({
                                encoding: ucs2CMapName,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            });
                            const toUnicode = [];
                            properties.cMap.forEach(function(charcode, cid) {
                                if (cid > 0xffff) throw new _util.FormatError("Max size of CID is 65,535");
                                const ucs2 = ucs2CMap.lookup(cid);
                                if (ucs2) toUnicode[charcode] = String.fromCharCode((ucs2.charCodeAt(0) << 8) + ucs2.charCodeAt(1));
                            });
                            return new _to_unicode_map.ToUnicodeMap(toUnicode);
                        }
                        return new _to_unicode_map.IdentityToUnicodeMap(properties.firstChar, properties.lastChar);
                    }
                    readToUnicode(cmapObj) {
                        if (!cmapObj) return Promise.resolve(null);
                        if ((0, _primitives.isName)(cmapObj)) return _cmap.CMapFactory.create({
                            encoding: cmapObj,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(cmap) {
                            if (cmap instanceof _cmap.IdentityCMap) return new _to_unicode_map.IdentityToUnicodeMap(0, 0xffff);
                            return new _to_unicode_map.ToUnicodeMap(cmap.getMap());
                        });
                        else if ((0, _primitives.isStream)(cmapObj)) return _cmap.CMapFactory.create({
                            encoding: cmapObj,
                            fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                            useCMap: null
                        }).then(function(cmap) {
                            if (cmap instanceof _cmap.IdentityCMap) return new _to_unicode_map.IdentityToUnicodeMap(0, 0xffff);
                            const map = new Array(cmap.length);
                            cmap.forEach(function(charCode, token) {
                                const str = [];
                                for(let k = 0; k < token.length; k += 2){
                                    const w1 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                                    if ((w1 & 0xf800) !== 0xd800) {
                                        str.push(w1);
                                        continue;
                                    }
                                    k += 2;
                                    const w2 = token.charCodeAt(k) << 8 | token.charCodeAt(k + 1);
                                    str.push(((w1 & 0x3ff) << 10) + (w2 & 0x3ff) + 0x10000);
                                }
                                map[charCode] = String.fromCodePoint.apply(String, str);
                            });
                            return new _to_unicode_map.ToUnicodeMap(map);
                        }, (reason)=>{
                            if (reason instanceof _util.AbortException) return null;
                            if (this.options.ignoreErrors) {
                                this.handler.send("UnsupportedFeature", {
                                    featureId: _util.UNSUPPORTED_FEATURES.errorFontToUnicode
                                });
                                (0, _util.warn)(`readToUnicode - ignoring ToUnicode data: "${reason}".`);
                                return null;
                            }
                            throw reason;
                        });
                        return Promise.resolve(null);
                    }
                    readCidToGidMap(glyphsData, toUnicode) {
                        const result = [];
                        for(let j = 0, jj = glyphsData.length; j < jj; j++){
                            const glyphID = glyphsData[j++] << 8 | glyphsData[j];
                            const code = j >> 1;
                            if (glyphID === 0 && !toUnicode.has(code)) continue;
                            result[code] = glyphID;
                        }
                        return result;
                    }
                    extractWidths(dict, descriptor, properties) {
                        const xref = this.xref;
                        let glyphsWidths = [];
                        let defaultWidth = 0;
                        const glyphsVMetrics = [];
                        let defaultVMetrics;
                        let i, ii, j, jj, start, code, widths;
                        if (properties.composite) {
                            defaultWidth = dict.has("DW") ? dict.get("DW") : 1000;
                            widths = dict.get("W");
                            if (widths) for(i = 0, ii = widths.length; i < ii; i++){
                                start = xref.fetchIfRef(widths[i++]);
                                code = xref.fetchIfRef(widths[i]);
                                if (Array.isArray(code)) for(j = 0, jj = code.length; j < jj; j++)glyphsWidths[start++] = xref.fetchIfRef(code[j]);
                                else {
                                    const width = xref.fetchIfRef(widths[++i]);
                                    for(j = start; j <= code; j++)glyphsWidths[j] = width;
                                }
                            }
                            if (properties.vertical) {
                                let vmetrics = dict.getArray("DW2") || [
                                    880,
                                    -1000
                                ];
                                defaultVMetrics = [
                                    vmetrics[1],
                                    defaultWidth * 0.5,
                                    vmetrics[0]
                                ];
                                vmetrics = dict.get("W2");
                                if (vmetrics) for(i = 0, ii = vmetrics.length; i < ii; i++){
                                    start = xref.fetchIfRef(vmetrics[i++]);
                                    code = xref.fetchIfRef(vmetrics[i]);
                                    if (Array.isArray(code)) for(j = 0, jj = code.length; j < jj; j++)glyphsVMetrics[start++] = [
                                        xref.fetchIfRef(code[j++]),
                                        xref.fetchIfRef(code[j++]),
                                        xref.fetchIfRef(code[j])
                                    ];
                                    else {
                                        const vmetric = [
                                            xref.fetchIfRef(vmetrics[++i]),
                                            xref.fetchIfRef(vmetrics[++i]),
                                            xref.fetchIfRef(vmetrics[++i])
                                        ];
                                        for(j = start; j <= code; j++)glyphsVMetrics[j] = vmetric;
                                    }
                                }
                            }
                        } else {
                            const firstChar = properties.firstChar;
                            widths = dict.get("Widths");
                            if (widths) {
                                j = firstChar;
                                for(i = 0, ii = widths.length; i < ii; i++)glyphsWidths[j++] = xref.fetchIfRef(widths[i]);
                                defaultWidth = parseFloat(descriptor.get("MissingWidth")) || 0;
                            } else {
                                const baseFontName = dict.get("BaseFont");
                                if ((0, _primitives.isName)(baseFontName)) {
                                    const metrics = this.getBaseFontMetrics(baseFontName.name);
                                    glyphsWidths = this.buildCharCodeToWidth(metrics.widths, properties);
                                    defaultWidth = metrics.defaultWidth;
                                }
                            }
                        }
                        let isMonospace = true;
                        let firstWidth = defaultWidth;
                        for(const glyph in glyphsWidths){
                            const glyphWidth = glyphsWidths[glyph];
                            if (!glyphWidth) continue;
                            if (!firstWidth) {
                                firstWidth = glyphWidth;
                                continue;
                            }
                            if (firstWidth !== glyphWidth) {
                                isMonospace = false;
                                break;
                            }
                        }
                        if (isMonospace) properties.flags |= _fonts_utils.FontFlags.FixedPitch;
                        properties.defaultWidth = defaultWidth;
                        properties.widths = glyphsWidths;
                        properties.defaultVMetrics = defaultVMetrics;
                        properties.vmetrics = glyphsVMetrics;
                    }
                    isSerifFont(baseFontName) {
                        const fontNameWoStyle = baseFontName.split("-")[0];
                        return fontNameWoStyle in (0, _standard_fonts.getSerifFonts)() || fontNameWoStyle.search(/serif/gi) !== -1;
                    }
                    getBaseFontMetrics(name) {
                        let defaultWidth = 0;
                        let widths = Object.create(null);
                        let monospace = false;
                        const stdFontMap = (0, _standard_fonts.getStdFontMap)();
                        let lookupName = stdFontMap[name] || name;
                        const Metrics = (0, _metrics.getMetrics)();
                        if (!(lookupName in Metrics)) {
                            if (this.isSerifFont(name)) lookupName = "Times-Roman";
                            else lookupName = "Helvetica";
                        }
                        const glyphWidths = Metrics[lookupName];
                        if ((0, _util.isNum)(glyphWidths)) {
                            defaultWidth = glyphWidths;
                            monospace = true;
                        } else widths = glyphWidths();
                        return {
                            defaultWidth: defaultWidth,
                            monospace: monospace,
                            widths: widths
                        };
                    }
                    buildCharCodeToWidth(widthsByGlyphName, properties) {
                        const widths = Object.create(null);
                        const differences = properties.differences;
                        const encoding = properties.defaultEncoding;
                        for(let charCode = 0; charCode < 256; charCode++){
                            if (charCode in differences && widthsByGlyphName[differences[charCode]]) {
                                widths[charCode] = widthsByGlyphName[differences[charCode]];
                                continue;
                            }
                            if (charCode in encoding && widthsByGlyphName[encoding[charCode]]) {
                                widths[charCode] = widthsByGlyphName[encoding[charCode]];
                                continue;
                            }
                        }
                        return widths;
                    }
                    preEvaluateFont(dict) {
                        const baseDict = dict;
                        let type = dict.get("Subtype");
                        if (!(0, _primitives.isName)(type)) throw new _util.FormatError("invalid font Subtype");
                        let composite = false;
                        let hash, toUnicode;
                        if (type.name === "Type0") {
                            const df = dict.get("DescendantFonts");
                            if (!df) throw new _util.FormatError("Descendant fonts are not specified");
                            dict = Array.isArray(df) ? this.xref.fetchIfRef(df[0]) : df;
                            if (!(dict instanceof _primitives.Dict)) throw new _util.FormatError("Descendant font is not a dictionary.");
                            type = dict.get("Subtype");
                            if (!(0, _primitives.isName)(type)) throw new _util.FormatError("invalid font Subtype");
                            composite = true;
                        }
                        const firstChar = dict.get("FirstChar") || 0, lastChar = dict.get("LastChar") || (composite ? 0xffff : 0xff);
                        const descriptor = dict.get("FontDescriptor");
                        if (descriptor) {
                            hash = new _murmurhash.MurmurHash3_64();
                            const encoding = baseDict.getRaw("Encoding");
                            if ((0, _primitives.isName)(encoding)) hash.update(encoding.name);
                            else if ((0, _primitives.isRef)(encoding)) hash.update(encoding.toString());
                            else if ((0, _primitives.isDict)(encoding)) for (const entry of encoding.getRawValues()){
                                if ((0, _primitives.isName)(entry)) hash.update(entry.name);
                                else if ((0, _primitives.isRef)(entry)) hash.update(entry.toString());
                                else if (Array.isArray(entry)) {
                                    const diffLength = entry.length, diffBuf = new Array(diffLength);
                                    for(let j = 0; j < diffLength; j++){
                                        const diffEntry = entry[j];
                                        if ((0, _primitives.isName)(diffEntry)) diffBuf[j] = diffEntry.name;
                                        else if ((0, _util.isNum)(diffEntry) || (0, _primitives.isRef)(diffEntry)) diffBuf[j] = diffEntry.toString();
                                    }
                                    hash.update(diffBuf.join());
                                }
                            }
                            hash.update(`${firstChar}-${lastChar}`);
                            toUnicode = dict.get("ToUnicode") || baseDict.get("ToUnicode");
                            if ((0, _primitives.isStream)(toUnicode)) {
                                const stream = toUnicode.str || toUnicode;
                                const uint8array = stream.buffer ? new Uint8Array(stream.buffer.buffer, 0, stream.bufferLength) : new Uint8Array(stream.bytes.buffer, stream.start, stream.end - stream.start);
                                hash.update(uint8array);
                            } else if ((0, _primitives.isName)(toUnicode)) hash.update(toUnicode.name);
                            const widths = dict.get("Widths") || baseDict.get("Widths");
                            if (Array.isArray(widths)) {
                                const widthsBuf = [];
                                for (const entry of widths)if ((0, _util.isNum)(entry) || (0, _primitives.isRef)(entry)) widthsBuf.push(entry.toString());
                                hash.update(widthsBuf.join());
                            }
                            if (composite) {
                                hash.update("compositeFont");
                                const compositeWidths = dict.get("W") || baseDict.get("W");
                                if (Array.isArray(compositeWidths)) {
                                    const widthsBuf = [];
                                    for (const entry of compositeWidths){
                                        if ((0, _util.isNum)(entry) || (0, _primitives.isRef)(entry)) widthsBuf.push(entry.toString());
                                        else if (Array.isArray(entry)) {
                                            const subWidthsBuf = [];
                                            for (const element of entry)if ((0, _util.isNum)(element) || (0, _primitives.isRef)(element)) subWidthsBuf.push(element.toString());
                                            widthsBuf.push(`[${subWidthsBuf.join()}]`);
                                        }
                                    }
                                    hash.update(widthsBuf.join());
                                }
                            }
                        }
                        return {
                            descriptor: descriptor,
                            dict: dict,
                            baseDict: baseDict,
                            composite: composite,
                            type: type.name,
                            firstChar: firstChar,
                            lastChar: lastChar,
                            toUnicode: toUnicode,
                            hash: hash ? hash.hexdigest() : ""
                        };
                    }
                    async translateFont({ descriptor: descriptor , dict: dict , baseDict: baseDict , composite: composite , type: type , firstChar: firstChar , lastChar: lastChar , toUnicode: toUnicode , cssFontInfo: cssFontInfo  }) {
                        const isType3Font = type === "Type3";
                        let properties;
                        if (!descriptor) {
                            if (isType3Font) {
                                descriptor = new _primitives.Dict(null);
                                descriptor.set("FontName", _primitives.Name.get(type));
                                descriptor.set("FontBBox", dict.getArray("FontBBox") || [
                                    0,
                                    0,
                                    0,
                                    0
                                ]);
                            } else {
                                let baseFontName = dict.get("BaseFont");
                                if (!(0, _primitives.isName)(baseFontName)) throw new _util.FormatError("Base font is not specified");
                                baseFontName = baseFontName.name.replace(/[,_]/g, "-");
                                const metrics = this.getBaseFontMetrics(baseFontName);
                                const fontNameWoStyle = baseFontName.split("-")[0];
                                const flags = (this.isSerifFont(fontNameWoStyle) ? _fonts_utils.FontFlags.Serif : 0) | (metrics.monospace ? _fonts_utils.FontFlags.FixedPitch : 0) | ((0, _standard_fonts.getSymbolsFonts)()[fontNameWoStyle] ? _fonts_utils.FontFlags.Symbolic : _fonts_utils.FontFlags.Nonsymbolic);
                                properties = {
                                    type: type,
                                    name: baseFontName,
                                    loadedName: baseDict.loadedName,
                                    widths: metrics.widths,
                                    defaultWidth: metrics.defaultWidth,
                                    flags: flags,
                                    firstChar: firstChar,
                                    lastChar: lastChar,
                                    toUnicode: toUnicode,
                                    xHeight: 0,
                                    capHeight: 0,
                                    italicAngle: 0,
                                    isType3Font: isType3Font
                                };
                                const widths = dict.get("Widths");
                                const standardFontName = (0, _standard_fonts.getStandardFontName)(baseFontName);
                                let file = null;
                                if (standardFontName) {
                                    properties.isStandardFont = true;
                                    file = await this.fetchStandardFontData(standardFontName);
                                    properties.isInternalFont = !!file;
                                }
                                return this.extractDataStructures(dict, dict, properties).then((newProperties)=>{
                                    if (widths) {
                                        const glyphWidths = [];
                                        let j = firstChar;
                                        for(let i = 0, ii = widths.length; i < ii; i++)glyphWidths[j++] = this.xref.fetchIfRef(widths[i]);
                                        newProperties.widths = glyphWidths;
                                    } else newProperties.widths = this.buildCharCodeToWidth(metrics.widths, newProperties);
                                    return new _fonts.Font(baseFontName, file, newProperties);
                                });
                            }
                        }
                        let fontName = descriptor.get("FontName");
                        let baseFont = dict.get("BaseFont");
                        if ((0, _util.isString)(fontName)) fontName = _primitives.Name.get(fontName);
                        if ((0, _util.isString)(baseFont)) baseFont = _primitives.Name.get(baseFont);
                        if (!isType3Font) {
                            const fontNameStr = fontName && fontName.name;
                            const baseFontStr = baseFont && baseFont.name;
                            if (fontNameStr !== baseFontStr) {
                                (0, _util.info)(`The FontDescriptor's FontName is "${fontNameStr}" but ` + `should be the same as the Font's BaseFont "${baseFontStr}".`);
                                if (fontNameStr && baseFontStr && baseFontStr.startsWith(fontNameStr)) fontName = baseFont;
                            }
                        }
                        fontName = fontName || baseFont;
                        if (!(0, _primitives.isName)(fontName)) throw new _util.FormatError("invalid font name");
                        let fontFile, subtype, length1, length2, length3;
                        try {
                            fontFile = descriptor.get("FontFile", "FontFile2", "FontFile3");
                        } catch (ex) {
                            if (!this.options.ignoreErrors) throw ex;
                            (0, _util.warn)(`translateFont - fetching "${fontName.name}" font file: "${ex}".`);
                            fontFile = new _stream.NullStream();
                        }
                        let isStandardFont = false;
                        let isInternalFont = false;
                        let glyphScaleFactors = null;
                        if (fontFile) {
                            if (fontFile.dict) {
                                const subtypeEntry = fontFile.dict.get("Subtype");
                                if (subtypeEntry instanceof _primitives.Name) subtype = subtypeEntry.name;
                                length1 = fontFile.dict.get("Length1");
                                length2 = fontFile.dict.get("Length2");
                                length3 = fontFile.dict.get("Length3");
                            }
                        } else if (cssFontInfo) {
                            const standardFontName = (0, _xfa_fonts.getXfaFontName)(fontName.name);
                            if (standardFontName) {
                                cssFontInfo.fontFamily = `${cssFontInfo.fontFamily}-PdfJS-XFA`;
                                cssFontInfo.lineHeight = standardFontName.lineHeight || null;
                                glyphScaleFactors = standardFontName.factors || null;
                                fontFile = await this.fetchStandardFontData(standardFontName.name);
                                isInternalFont = !!fontFile;
                                type = "TrueType";
                            }
                        } else if (!isType3Font) {
                            const standardFontName = (0, _standard_fonts.getStandardFontName)(fontName.name);
                            if (standardFontName) {
                                isStandardFont = true;
                                fontFile = await this.fetchStandardFontData(standardFontName);
                                isInternalFont = !!fontFile;
                            }
                        }
                        properties = {
                            type: type,
                            name: fontName.name,
                            subtype: subtype,
                            file: fontFile,
                            length1: length1,
                            length2: length2,
                            length3: length3,
                            isStandardFont: isStandardFont,
                            isInternalFont: isInternalFont,
                            loadedName: baseDict.loadedName,
                            composite: composite,
                            fixedPitch: false,
                            fontMatrix: dict.getArray("FontMatrix") || _util.FONT_IDENTITY_MATRIX,
                            firstChar: firstChar,
                            lastChar: lastChar,
                            toUnicode: toUnicode,
                            bbox: descriptor.getArray("FontBBox") || dict.getArray("FontBBox"),
                            ascent: descriptor.get("Ascent"),
                            descent: descriptor.get("Descent"),
                            xHeight: descriptor.get("XHeight") || 0,
                            capHeight: descriptor.get("CapHeight") || 0,
                            flags: descriptor.get("Flags"),
                            italicAngle: descriptor.get("ItalicAngle") || 0,
                            isType3Font: isType3Font,
                            cssFontInfo: cssFontInfo,
                            scaleFactors: glyphScaleFactors
                        };
                        if (composite) {
                            const cidEncoding = baseDict.get("Encoding");
                            if ((0, _primitives.isName)(cidEncoding)) properties.cidEncoding = cidEncoding.name;
                            const cMap = await _cmap.CMapFactory.create({
                                encoding: cidEncoding,
                                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                                useCMap: null
                            });
                            properties.cMap = cMap;
                            properties.vertical = properties.cMap.vertical;
                        }
                        return this.extractDataStructures(dict, baseDict, properties).then((newProperties)=>{
                            this.extractWidths(dict, descriptor, newProperties);
                            return new _fonts.Font(fontName.name, fontFile, newProperties);
                        });
                    }
                    static buildFontPaths(font1, glyphs, handler, evaluatorOptions) {
                        function buildPath(fontChar) {
                            const glyphName = `${font1.loadedName}_path_${fontChar}`;
                            try {
                                if (font1.renderer.hasBuiltPath(fontChar)) return;
                                handler.send("commonobj", [
                                    glyphName,
                                    "FontPath",
                                    font1.renderer.getPathJs(fontChar)
                                ]);
                            } catch (reason) {
                                if (evaluatorOptions.ignoreErrors) {
                                    handler.send("UnsupportedFeature", {
                                        featureId: _util.UNSUPPORTED_FEATURES.errorFontBuildPath
                                    });
                                    (0, _util.warn)(`buildFontPaths - ignoring ${glyphName} glyph: "${reason}".`);
                                    return;
                                }
                                throw reason;
                            }
                        }
                        for (const glyph of glyphs){
                            buildPath(glyph.fontChar);
                            const accent = glyph.accent;
                            if (accent && accent.fontChar) buildPath(accent.fontChar);
                        }
                    }
                    static get fallbackFontDict() {
                        const dict = new _primitives.Dict();
                        dict.set("BaseFont", _primitives.Name.get("PDFJS-FallbackFont"));
                        dict.set("Type", _primitives.Name.get("FallbackType"));
                        dict.set("Subtype", _primitives.Name.get("FallbackType"));
                        dict.set("Encoding", _primitives.Name.get("WinAnsiEncoding"));
                        return (0, _util.shadow)(this, "fallbackFontDict", dict);
                    }
                }
                exports.PartialEvaluator = PartialEvaluator;
                class TranslatedFont {
                    constructor({ loadedName: loadedName , font: font1 , dict: dict , evaluatorOptions: evaluatorOptions  }){
                        this.loadedName = loadedName;
                        this.font = font1;
                        this.dict = dict;
                        this._evaluatorOptions = evaluatorOptions || DefaultPartialEvaluatorOptions;
                        this.type3Loaded = null;
                        this.type3Dependencies = font1.isType3Font ? new Set() : null;
                        this.sent = false;
                    }
                    send(handler) {
                        if (this.sent) return;
                        this.sent = true;
                        handler.send("commonobj", [
                            this.loadedName,
                            "Font",
                            this.font.exportData(this._evaluatorOptions.fontExtraProperties)
                        ]);
                    }
                    fallback(handler) {
                        if (!this.font.data) return;
                        this.font.disableFontFace = true;
                        PartialEvaluator.buildFontPaths(this.font, this.font.glyphCacheValues, handler, this._evaluatorOptions);
                    }
                    loadType3Data(evaluator, resources, task) {
                        if (this.type3Loaded) return this.type3Loaded;
                        if (!this.font.isType3Font) throw new Error("Must be a Type3 font.");
                        const type3Evaluator = evaluator.clone({
                            ignoreErrors: false
                        });
                        type3Evaluator.parsingType3Font = true;
                        const translatedFont = this.font, type3Dependencies = this.type3Dependencies;
                        let loadCharProcsPromise = Promise.resolve();
                        const charProcs = this.dict.get("CharProcs");
                        const fontResources = this.dict.get("Resources") || resources;
                        const charProcOperatorList = Object.create(null);
                        const isEmptyBBox = !translatedFont.bbox || (0, _util.isArrayEqual)(translatedFont.bbox, [
                            0,
                            0,
                            0,
                            0
                        ]);
                        for (const key of charProcs.getKeys())loadCharProcsPromise = loadCharProcsPromise.then(()=>{
                            const glyphStream = charProcs.get(key);
                            const operatorList = new _operator_list.OperatorList();
                            return type3Evaluator.getOperatorList({
                                stream: glyphStream,
                                task: task,
                                resources: fontResources,
                                operatorList: operatorList
                            }).then(()=>{
                                if (operatorList.fnArray[0] === _util.OPS.setCharWidthAndBounds) this._removeType3ColorOperators(operatorList, isEmptyBBox);
                                charProcOperatorList[key] = operatorList.getIR();
                                for (const dependency of operatorList.dependencies)type3Dependencies.add(dependency);
                            }).catch(function(reason) {
                                (0, _util.warn)(`Type3 font resource "${key}" is not available.`);
                                const dummyOperatorList = new _operator_list.OperatorList();
                                charProcOperatorList[key] = dummyOperatorList.getIR();
                            });
                        });
                        this.type3Loaded = loadCharProcsPromise.then(()=>{
                            translatedFont.charProcOperatorList = charProcOperatorList;
                            if (this._bbox) {
                                translatedFont.isCharBBox = true;
                                translatedFont.bbox = this._bbox;
                            }
                        });
                        return this.type3Loaded;
                    }
                    _removeType3ColorOperators(operatorList, isEmptyBBox = false) {
                        if (isEmptyBBox) {
                            if (!this._bbox) this._bbox = [
                                Infinity,
                                Infinity,
                                -Infinity,
                                -Infinity
                            ];
                            const charBBox = _util.Util.normalizeRect(operatorList.argsArray[0].slice(2));
                            this._bbox[0] = Math.min(this._bbox[0], charBBox[0]);
                            this._bbox[1] = Math.min(this._bbox[1], charBBox[1]);
                            this._bbox[2] = Math.max(this._bbox[2], charBBox[2]);
                            this._bbox[3] = Math.max(this._bbox[3], charBBox[3]);
                        }
                        let i = 1, ii = operatorList.length;
                        while(i < ii){
                            switch(operatorList.fnArray[i]){
                                case _util.OPS.setStrokeColorSpace:
                                case _util.OPS.setFillColorSpace:
                                case _util.OPS.setStrokeColor:
                                case _util.OPS.setStrokeColorN:
                                case _util.OPS.setFillColor:
                                case _util.OPS.setFillColorN:
                                case _util.OPS.setStrokeGray:
                                case _util.OPS.setFillGray:
                                case _util.OPS.setStrokeRGBColor:
                                case _util.OPS.setFillRGBColor:
                                case _util.OPS.setStrokeCMYKColor:
                                case _util.OPS.setFillCMYKColor:
                                case _util.OPS.shadingFill:
                                case _util.OPS.setRenderingIntent:
                                    operatorList.fnArray.splice(i, 1);
                                    operatorList.argsArray.splice(i, 1);
                                    ii--;
                                    continue;
                                case _util.OPS.setGState:
                                    const [gStateObj] = operatorList.argsArray[i];
                                    let j = 0, jj = gStateObj.length;
                                    while(j < jj){
                                        const [gStateKey] = gStateObj[j];
                                        switch(gStateKey){
                                            case "TR":
                                            case "TR2":
                                            case "HT":
                                            case "BG":
                                            case "BG2":
                                            case "UCR":
                                            case "UCR2":
                                                gStateObj.splice(j, 1);
                                                jj--;
                                                continue;
                                        }
                                        j++;
                                    }
                                    break;
                            }
                            i++;
                        }
                    }
                }
                class StateManager {
                    constructor(initialState = new EvalState()){
                        this.state = initialState;
                        this.stateStack = [];
                    }
                    save() {
                        const old = this.state;
                        this.stateStack.push(this.state);
                        this.state = old.clone();
                    }
                    restore() {
                        const prev = this.stateStack.pop();
                        if (prev) this.state = prev;
                    }
                    transform(args) {
                        this.state.ctm = _util.Util.transform(this.state.ctm, args);
                    }
                }
                class TextState {
                    constructor(){
                        this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
                        this.fontName = null;
                        this.fontSize = 0;
                        this.font = null;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.textMatrix = _util.IDENTITY_MATRIX.slice();
                        this.textLineMatrix = _util.IDENTITY_MATRIX.slice();
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.leading = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const m = this.textMatrix;
                        m[0] = a;
                        m[1] = b;
                        m[2] = c;
                        m[3] = d;
                        m[4] = e;
                        m[5] = f;
                    }
                    setTextLineMatrix(a, b, c, d, e, f) {
                        const m = this.textLineMatrix;
                        m[0] = a;
                        m[1] = b;
                        m[2] = c;
                        m[3] = d;
                        m[4] = e;
                        m[5] = f;
                    }
                    translateTextMatrix(x, y) {
                        const m = this.textMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                    }
                    translateTextLineMatrix(x, y) {
                        const m = this.textLineMatrix;
                        m[4] = m[0] * x + m[2] * y + m[4];
                        m[5] = m[1] * x + m[3] * y + m[5];
                    }
                    carriageReturn() {
                        this.translateTextLineMatrix(0, -this.leading);
                        this.textMatrix = this.textLineMatrix.slice();
                    }
                    clone() {
                        const clone = Object.create(this);
                        clone.textMatrix = this.textMatrix.slice();
                        clone.textLineMatrix = this.textLineMatrix.slice();
                        clone.fontMatrix = this.fontMatrix.slice();
                        return clone;
                    }
                }
                class EvalState {
                    constructor(){
                        this.ctm = new Float32Array(_util.IDENTITY_MATRIX);
                        this.font = null;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.fillColorSpace = _colorspace.ColorSpace.singletons.gray;
                        this.strokeColorSpace = _colorspace.ColorSpace.singletons.gray;
                    }
                    clone() {
                        return Object.create(this);
                    }
                }
                class EvaluatorPreprocessor {
                    static get opMap() {
                        const getOPMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                            t.w = {
                                id: _util.OPS.setLineWidth,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.J = {
                                id: _util.OPS.setLineCap,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.j = {
                                id: _util.OPS.setLineJoin,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.M = {
                                id: _util.OPS.setMiterLimit,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.d = {
                                id: _util.OPS.setDash,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.ri = {
                                id: _util.OPS.setRenderingIntent,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.i = {
                                id: _util.OPS.setFlatness,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.gs = {
                                id: _util.OPS.setGState,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.q = {
                                id: _util.OPS.save,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.Q = {
                                id: _util.OPS.restore,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.cm = {
                                id: _util.OPS.transform,
                                numArgs: 6,
                                variableArgs: false
                            };
                            t.m = {
                                id: _util.OPS.moveTo,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.l = {
                                id: _util.OPS.lineTo,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.c = {
                                id: _util.OPS.curveTo,
                                numArgs: 6,
                                variableArgs: false
                            };
                            t.v = {
                                id: _util.OPS.curveTo2,
                                numArgs: 4,
                                variableArgs: false
                            };
                            t.y = {
                                id: _util.OPS.curveTo3,
                                numArgs: 4,
                                variableArgs: false
                            };
                            t.h = {
                                id: _util.OPS.closePath,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.re = {
                                id: _util.OPS.rectangle,
                                numArgs: 4,
                                variableArgs: false
                            };
                            t.S = {
                                id: _util.OPS.stroke,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.s = {
                                id: _util.OPS.closeStroke,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.f = {
                                id: _util.OPS.fill,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.F = {
                                id: _util.OPS.fill,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t["f*"] = {
                                id: _util.OPS.eoFill,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.B = {
                                id: _util.OPS.fillStroke,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t["B*"] = {
                                id: _util.OPS.eoFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.b = {
                                id: _util.OPS.closeFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t["b*"] = {
                                id: _util.OPS.closeEOFillStroke,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.n = {
                                id: _util.OPS.endPath,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.W = {
                                id: _util.OPS.clip,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t["W*"] = {
                                id: _util.OPS.eoClip,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.BT = {
                                id: _util.OPS.beginText,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.ET = {
                                id: _util.OPS.endText,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.Tc = {
                                id: _util.OPS.setCharSpacing,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.Tw = {
                                id: _util.OPS.setWordSpacing,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.Tz = {
                                id: _util.OPS.setHScale,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.TL = {
                                id: _util.OPS.setLeading,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.Tf = {
                                id: _util.OPS.setFont,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.Tr = {
                                id: _util.OPS.setTextRenderingMode,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.Ts = {
                                id: _util.OPS.setTextRise,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.Td = {
                                id: _util.OPS.moveText,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.TD = {
                                id: _util.OPS.setLeadingMoveText,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.Tm = {
                                id: _util.OPS.setTextMatrix,
                                numArgs: 6,
                                variableArgs: false
                            };
                            t["T*"] = {
                                id: _util.OPS.nextLine,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.Tj = {
                                id: _util.OPS.showText,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.TJ = {
                                id: _util.OPS.showSpacedText,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t["'"] = {
                                id: _util.OPS.nextLineShowText,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t['"'] = {
                                id: _util.OPS.nextLineSetSpacingShowText,
                                numArgs: 3,
                                variableArgs: false
                            };
                            t.d0 = {
                                id: _util.OPS.setCharWidth,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.d1 = {
                                id: _util.OPS.setCharWidthAndBounds,
                                numArgs: 6,
                                variableArgs: false
                            };
                            t.CS = {
                                id: _util.OPS.setStrokeColorSpace,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.cs = {
                                id: _util.OPS.setFillColorSpace,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.SC = {
                                id: _util.OPS.setStrokeColor,
                                numArgs: 4,
                                variableArgs: true
                            };
                            t.SCN = {
                                id: _util.OPS.setStrokeColorN,
                                numArgs: 33,
                                variableArgs: true
                            };
                            t.sc = {
                                id: _util.OPS.setFillColor,
                                numArgs: 4,
                                variableArgs: true
                            };
                            t.scn = {
                                id: _util.OPS.setFillColorN,
                                numArgs: 33,
                                variableArgs: true
                            };
                            t.G = {
                                id: _util.OPS.setStrokeGray,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.g = {
                                id: _util.OPS.setFillGray,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.RG = {
                                id: _util.OPS.setStrokeRGBColor,
                                numArgs: 3,
                                variableArgs: false
                            };
                            t.rg = {
                                id: _util.OPS.setFillRGBColor,
                                numArgs: 3,
                                variableArgs: false
                            };
                            t.K = {
                                id: _util.OPS.setStrokeCMYKColor,
                                numArgs: 4,
                                variableArgs: false
                            };
                            t.k = {
                                id: _util.OPS.setFillCMYKColor,
                                numArgs: 4,
                                variableArgs: false
                            };
                            t.sh = {
                                id: _util.OPS.shadingFill,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.BI = {
                                id: _util.OPS.beginInlineImage,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.ID = {
                                id: _util.OPS.beginImageData,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.EI = {
                                id: _util.OPS.endInlineImage,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.Do = {
                                id: _util.OPS.paintXObject,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.MP = {
                                id: _util.OPS.markPoint,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.DP = {
                                id: _util.OPS.markPointProps,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.BMC = {
                                id: _util.OPS.beginMarkedContent,
                                numArgs: 1,
                                variableArgs: false
                            };
                            t.BDC = {
                                id: _util.OPS.beginMarkedContentProps,
                                numArgs: 2,
                                variableArgs: false
                            };
                            t.EMC = {
                                id: _util.OPS.endMarkedContent,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.BX = {
                                id: _util.OPS.beginCompat,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.EX = {
                                id: _util.OPS.endCompat,
                                numArgs: 0,
                                variableArgs: false
                            };
                            t.BM = null;
                            t.BD = null;
                            t.true = null;
                            t.fa = null;
                            t.fal = null;
                            t.fals = null;
                            t.false = null;
                            t.nu = null;
                            t.nul = null;
                            t.null = null;
                        });
                        return (0, _util.shadow)(this, "opMap", getOPMap());
                    }
                    static get MAX_INVALID_PATH_OPS() {
                        return (0, _util.shadow)(this, "MAX_INVALID_PATH_OPS", 20);
                    }
                    constructor(stream, xref, stateManager = new StateManager()){
                        this.parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream, EvaluatorPreprocessor.opMap),
                            xref: xref
                        });
                        this.stateManager = stateManager;
                        this.nonProcessedArgs = [];
                        this._numInvalidPathOPS = 0;
                    }
                    get savedStatesDepth() {
                        return this.stateManager.stateStack.length;
                    }
                    read(operation) {
                        let args = operation.args;
                        while(true){
                            const obj = this.parser.getObj();
                            if (obj instanceof _primitives.Cmd) {
                                const cmd = obj.cmd;
                                const opSpec = EvaluatorPreprocessor.opMap[cmd];
                                if (!opSpec) {
                                    (0, _util.warn)(`Unknown command "${cmd}".`);
                                    continue;
                                }
                                const fn = opSpec.id;
                                const numArgs = opSpec.numArgs;
                                let argsLength = args !== null ? args.length : 0;
                                if (!opSpec.variableArgs) {
                                    if (argsLength !== numArgs) {
                                        const nonProcessedArgs = this.nonProcessedArgs;
                                        while(argsLength > numArgs){
                                            nonProcessedArgs.push(args.shift());
                                            argsLength--;
                                        }
                                        while(argsLength < numArgs && nonProcessedArgs.length !== 0){
                                            if (args === null) args = [];
                                            args.unshift(nonProcessedArgs.pop());
                                            argsLength++;
                                        }
                                    }
                                    if (argsLength < numArgs) {
                                        const partialMsg = `command ${cmd}: expected ${numArgs} args, ` + `but received ${argsLength} args.`;
                                        if (fn >= _util.OPS.moveTo && fn <= _util.OPS.endPath && ++this._numInvalidPathOPS > EvaluatorPreprocessor.MAX_INVALID_PATH_OPS) throw new _util.FormatError(`Invalid ${partialMsg}`);
                                        (0, _util.warn)(`Skipping ${partialMsg}`);
                                        if (args !== null) args.length = 0;
                                        continue;
                                    }
                                } else if (argsLength > numArgs) (0, _util.info)(`Command ${cmd}: expected [0, ${numArgs}] args, ` + `but received ${argsLength} args.`);
                                this.preprocessCommand(fn, args);
                                operation.fn = fn;
                                operation.args = args;
                                return true;
                            }
                            if (obj === _primitives.EOF) return false;
                            if (obj !== null) {
                                if (args === null) args = [];
                                args.push(obj);
                                if (args.length > 33) throw new _util.FormatError("Too many arguments");
                            }
                        }
                    }
                    preprocessCommand(fn, args) {
                        switch(fn | 0){
                            case _util.OPS.save:
                                this.stateManager.save();
                                break;
                            case _util.OPS.restore:
                                this.stateManager.restore();
                                break;
                            case _util.OPS.transform:
                                this.stateManager.transform(args);
                                break;
                        }
                    }
                }
                exports.EvaluatorPreprocessor = EvaluatorPreprocessor;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.IdentityCMap = exports.CMapFactory = exports.CMap = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _parser = __w_pdfjs_require__(17);
                var _core_utils = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(10);
                const BUILT_IN_CMAPS = [
                    "Adobe-GB1-UCS2",
                    "Adobe-CNS1-UCS2",
                    "Adobe-Japan1-UCS2",
                    "Adobe-Korea1-UCS2",
                    "78-EUC-H",
                    "78-EUC-V",
                    "78-H",
                    "78-RKSJ-H",
                    "78-RKSJ-V",
                    "78-V",
                    "78ms-RKSJ-H",
                    "78ms-RKSJ-V",
                    "83pv-RKSJ-H",
                    "90ms-RKSJ-H",
                    "90ms-RKSJ-V",
                    "90msp-RKSJ-H",
                    "90msp-RKSJ-V",
                    "90pv-RKSJ-H",
                    "90pv-RKSJ-V",
                    "Add-H",
                    "Add-RKSJ-H",
                    "Add-RKSJ-V",
                    "Add-V",
                    "Adobe-CNS1-0",
                    "Adobe-CNS1-1",
                    "Adobe-CNS1-2",
                    "Adobe-CNS1-3",
                    "Adobe-CNS1-4",
                    "Adobe-CNS1-5",
                    "Adobe-CNS1-6",
                    "Adobe-GB1-0",
                    "Adobe-GB1-1",
                    "Adobe-GB1-2",
                    "Adobe-GB1-3",
                    "Adobe-GB1-4",
                    "Adobe-GB1-5",
                    "Adobe-Japan1-0",
                    "Adobe-Japan1-1",
                    "Adobe-Japan1-2",
                    "Adobe-Japan1-3",
                    "Adobe-Japan1-4",
                    "Adobe-Japan1-5",
                    "Adobe-Japan1-6",
                    "Adobe-Korea1-0",
                    "Adobe-Korea1-1",
                    "Adobe-Korea1-2",
                    "B5-H",
                    "B5-V",
                    "B5pc-H",
                    "B5pc-V",
                    "CNS-EUC-H",
                    "CNS-EUC-V",
                    "CNS1-H",
                    "CNS1-V",
                    "CNS2-H",
                    "CNS2-V",
                    "ETHK-B5-H",
                    "ETHK-B5-V",
                    "ETen-B5-H",
                    "ETen-B5-V",
                    "ETenms-B5-H",
                    "ETenms-B5-V",
                    "EUC-H",
                    "EUC-V",
                    "Ext-H",
                    "Ext-RKSJ-H",
                    "Ext-RKSJ-V",
                    "Ext-V",
                    "GB-EUC-H",
                    "GB-EUC-V",
                    "GB-H",
                    "GB-V",
                    "GBK-EUC-H",
                    "GBK-EUC-V",
                    "GBK2K-H",
                    "GBK2K-V",
                    "GBKp-EUC-H",
                    "GBKp-EUC-V",
                    "GBT-EUC-H",
                    "GBT-EUC-V",
                    "GBT-H",
                    "GBT-V",
                    "GBTpc-EUC-H",
                    "GBTpc-EUC-V",
                    "GBpc-EUC-H",
                    "GBpc-EUC-V",
                    "H",
                    "HKdla-B5-H",
                    "HKdla-B5-V",
                    "HKdlb-B5-H",
                    "HKdlb-B5-V",
                    "HKgccs-B5-H",
                    "HKgccs-B5-V",
                    "HKm314-B5-H",
                    "HKm314-B5-V",
                    "HKm471-B5-H",
                    "HKm471-B5-V",
                    "HKscs-B5-H",
                    "HKscs-B5-V",
                    "Hankaku",
                    "Hiragana",
                    "KSC-EUC-H",
                    "KSC-EUC-V",
                    "KSC-H",
                    "KSC-Johab-H",
                    "KSC-Johab-V",
                    "KSC-V",
                    "KSCms-UHC-H",
                    "KSCms-UHC-HW-H",
                    "KSCms-UHC-HW-V",
                    "KSCms-UHC-V",
                    "KSCpc-EUC-H",
                    "KSCpc-EUC-V",
                    "Katakana",
                    "NWP-H",
                    "NWP-V",
                    "RKSJ-H",
                    "RKSJ-V",
                    "Roman",
                    "UniCNS-UCS2-H",
                    "UniCNS-UCS2-V",
                    "UniCNS-UTF16-H",
                    "UniCNS-UTF16-V",
                    "UniCNS-UTF32-H",
                    "UniCNS-UTF32-V",
                    "UniCNS-UTF8-H",
                    "UniCNS-UTF8-V",
                    "UniGB-UCS2-H",
                    "UniGB-UCS2-V",
                    "UniGB-UTF16-H",
                    "UniGB-UTF16-V",
                    "UniGB-UTF32-H",
                    "UniGB-UTF32-V",
                    "UniGB-UTF8-H",
                    "UniGB-UTF8-V",
                    "UniJIS-UCS2-H",
                    "UniJIS-UCS2-HW-H",
                    "UniJIS-UCS2-HW-V",
                    "UniJIS-UCS2-V",
                    "UniJIS-UTF16-H",
                    "UniJIS-UTF16-V",
                    "UniJIS-UTF32-H",
                    "UniJIS-UTF32-V",
                    "UniJIS-UTF8-H",
                    "UniJIS-UTF8-V",
                    "UniJIS2004-UTF16-H",
                    "UniJIS2004-UTF16-V",
                    "UniJIS2004-UTF32-H",
                    "UniJIS2004-UTF32-V",
                    "UniJIS2004-UTF8-H",
                    "UniJIS2004-UTF8-V",
                    "UniJISPro-UCS2-HW-V",
                    "UniJISPro-UCS2-V",
                    "UniJISPro-UTF8-V",
                    "UniJISX0213-UTF32-H",
                    "UniJISX0213-UTF32-V",
                    "UniJISX02132004-UTF32-H",
                    "UniJISX02132004-UTF32-V",
                    "UniKS-UCS2-H",
                    "UniKS-UCS2-V",
                    "UniKS-UTF16-H",
                    "UniKS-UTF16-V",
                    "UniKS-UTF32-H",
                    "UniKS-UTF32-V",
                    "UniKS-UTF8-H",
                    "UniKS-UTF8-V",
                    "V",
                    "WP-Symbol"
                ];
                const MAX_MAP_RANGE = 2 ** 24 - 1;
                class CMap {
                    constructor(builtInCMap = false){
                        this.codespaceRanges = [
                            [],
                            [],
                            [],
                            []
                        ];
                        this.numCodespaceRanges = 0;
                        this._map = [];
                        this.name = "";
                        this.vertical = false;
                        this.useCMap = null;
                        this.builtInCMap = builtInCMap;
                    }
                    addCodespaceRange(n, low, high) {
                        this.codespaceRanges[n - 1].push(low, high);
                        this.numCodespaceRanges++;
                    }
                    mapCidRange(low, high, dstLow) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
                        while(low <= high)this._map[low++] = dstLow++;
                    }
                    mapBfRange(low, high, dstLow) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
                        const lastByte = dstLow.length - 1;
                        while(low <= high){
                            this._map[low++] = dstLow;
                            dstLow = dstLow.substring(0, lastByte) + String.fromCharCode(dstLow.charCodeAt(lastByte) + 1);
                        }
                    }
                    mapBfRangeToArray(low, high, array) {
                        if (high - low > MAX_MAP_RANGE) throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
                        const ii = array.length;
                        let i = 0;
                        while(low <= high && i < ii){
                            this._map[low] = array[i++];
                            ++low;
                        }
                    }
                    mapOne(src, dst) {
                        this._map[src] = dst;
                    }
                    lookup(code) {
                        return this._map[code];
                    }
                    contains(code) {
                        return this._map[code] !== undefined;
                    }
                    forEach(callback) {
                        const map = this._map;
                        const length = map.length;
                        if (length <= 0x10000) {
                            for(let i = 0; i < length; i++)if (map[i] !== undefined) callback(i, map[i]);
                        } else for(const i in map)callback(i, map[i]);
                    }
                    charCodeOf(value) {
                        const map = this._map;
                        if (map.length <= 0x10000) return map.indexOf(value);
                        for(const charCode in map){
                            if (map[charCode] === value) return charCode | 0;
                        }
                        return -1;
                    }
                    getMap() {
                        return this._map;
                    }
                    readCharCode(str, offset, out) {
                        let c = 0;
                        const codespaceRanges = this.codespaceRanges;
                        for(let n = 0, nn = codespaceRanges.length; n < nn; n++){
                            c = (c << 8 | str.charCodeAt(offset + n)) >>> 0;
                            const codespaceRange = codespaceRanges[n];
                            for(let k = 0, kk = codespaceRange.length; k < kk;){
                                const low = codespaceRange[k++];
                                const high = codespaceRange[k++];
                                if (c >= low && c <= high) {
                                    out.charcode = c;
                                    out.length = n + 1;
                                    return;
                                }
                            }
                        }
                        out.charcode = 0;
                        out.length = 1;
                    }
                    getCharCodeLength(charCode) {
                        const codespaceRanges = this.codespaceRanges;
                        for(let n = 0, nn = codespaceRanges.length; n < nn; n++){
                            const codespaceRange = codespaceRanges[n];
                            for(let k = 0, kk = codespaceRange.length; k < kk;){
                                const low = codespaceRange[k++];
                                const high = codespaceRange[k++];
                                if (charCode >= low && charCode <= high) return n + 1;
                            }
                        }
                        return 1;
                    }
                    get length() {
                        return this._map.length;
                    }
                    get isIdentityCMap() {
                        if (!(this.name === "Identity-H" || this.name === "Identity-V")) return false;
                        if (this._map.length !== 0x10000) return false;
                        for(let i = 0; i < 0x10000; i++){
                            if (this._map[i] !== i) return false;
                        }
                        return true;
                    }
                }
                exports.CMap = CMap;
                class IdentityCMap extends CMap {
                    constructor(vertical, n){
                        super();
                        this.vertical = vertical;
                        this.addCodespaceRange(n, 0, 0xffff);
                    }
                    mapCidRange(low, high, dstLow) {
                        (0, _util.unreachable)("should not call mapCidRange");
                    }
                    mapBfRange(low, high, dstLow) {
                        (0, _util.unreachable)("should not call mapBfRange");
                    }
                    mapBfRangeToArray(low, high, array) {
                        (0, _util.unreachable)("should not call mapBfRangeToArray");
                    }
                    mapOne(src, dst) {
                        (0, _util.unreachable)("should not call mapCidOne");
                    }
                    lookup(code) {
                        return Number.isInteger(code) && code <= 0xffff ? code : undefined;
                    }
                    contains(code) {
                        return Number.isInteger(code) && code <= 0xffff;
                    }
                    forEach(callback) {
                        for(let i = 0; i <= 0xffff; i++)callback(i, i);
                    }
                    charCodeOf(value) {
                        return Number.isInteger(value) && value <= 0xffff ? value : -1;
                    }
                    getMap() {
                        const map = new Array(0x10000);
                        for(let i = 0; i <= 0xffff; i++)map[i] = i;
                        return map;
                    }
                    get length() {
                        return 0x10000;
                    }
                    get isIdentityCMap() {
                        (0, _util.unreachable)("should not access .isIdentityCMap");
                    }
                }
                exports.IdentityCMap = IdentityCMap;
                const BinaryCMapReader = function BinaryCMapReaderClosure() {
                    function hexToInt(a, size) {
                        let n = 0;
                        for(let i = 0; i <= size; i++)n = n << 8 | a[i];
                        return n >>> 0;
                    }
                    function hexToStr(a, size) {
                        if (size === 1) return String.fromCharCode(a[0], a[1]);
                        if (size === 3) return String.fromCharCode(a[0], a[1], a[2], a[3]);
                        return String.fromCharCode.apply(null, a.subarray(0, size + 1));
                    }
                    function addHex(a, b, size) {
                        let c = 0;
                        for(let i = size; i >= 0; i--){
                            c += a[i] + b[i];
                            a[i] = c & 255;
                            c >>= 8;
                        }
                    }
                    function incHex(a, size) {
                        let c = 1;
                        for(let i = size; i >= 0 && c > 0; i--){
                            c += a[i];
                            a[i] = c & 255;
                            c >>= 8;
                        }
                    }
                    const MAX_NUM_SIZE = 16;
                    const MAX_ENCODED_NUM_SIZE = 19;
                    class BinaryCMapStream {
                        constructor(data){
                            this.buffer = data;
                            this.pos = 0;
                            this.end = data.length;
                            this.tmpBuf = new Uint8Array(MAX_ENCODED_NUM_SIZE);
                        }
                        readByte() {
                            if (this.pos >= this.end) return -1;
                            return this.buffer[this.pos++];
                        }
                        readNumber() {
                            let n = 0;
                            let last;
                            do {
                                const b = this.readByte();
                                if (b < 0) throw new _util.FormatError("unexpected EOF in bcmap");
                                last = !(b & 0x80);
                                n = n << 7 | b & 0x7f;
                            }while (!last);
                            return n;
                        }
                        readSigned() {
                            const n = this.readNumber();
                            return n & 1 ? ~(n >>> 1) : n >>> 1;
                        }
                        readHex(num, size) {
                            num.set(this.buffer.subarray(this.pos, this.pos + size + 1));
                            this.pos += size + 1;
                        }
                        readHexNumber(num, size) {
                            let last;
                            const stack = this.tmpBuf;
                            let sp = 0;
                            do {
                                const b = this.readByte();
                                if (b < 0) throw new _util.FormatError("unexpected EOF in bcmap");
                                last = !(b & 0x80);
                                stack[sp++] = b & 0x7f;
                            }while (!last);
                            let i = size, buffer = 0, bufferSize = 0;
                            while(i >= 0){
                                while(bufferSize < 8 && stack.length > 0){
                                    buffer |= stack[--sp] << bufferSize;
                                    bufferSize += 7;
                                }
                                num[i] = buffer & 255;
                                i--;
                                buffer >>= 8;
                                bufferSize -= 8;
                            }
                        }
                        readHexSigned(num, size) {
                            this.readHexNumber(num, size);
                            const sign = num[size] & 1 ? 255 : 0;
                            let c = 0;
                            for(let i = 0; i <= size; i++){
                                c = (c & 1) << 8 | num[i];
                                num[i] = c >> 1 ^ sign;
                            }
                        }
                        readString() {
                            const len = this.readNumber();
                            let s = "";
                            for(let i = 0; i < len; i++)s += String.fromCharCode(this.readNumber());
                            return s;
                        }
                    }
                    class BinaryCMapReader {
                        async process(data, cMap, extend) {
                            const stream = new BinaryCMapStream(data);
                            const header = stream.readByte();
                            cMap.vertical = !!(header & 1);
                            let useCMap = null;
                            const start = new Uint8Array(MAX_NUM_SIZE);
                            const end = new Uint8Array(MAX_NUM_SIZE);
                            const char = new Uint8Array(MAX_NUM_SIZE);
                            const charCode = new Uint8Array(MAX_NUM_SIZE);
                            const tmp = new Uint8Array(MAX_NUM_SIZE);
                            let code;
                            let b;
                            while((b = stream.readByte()) >= 0){
                                const type = b >> 5;
                                if (type === 7) {
                                    switch(b & 0x1f){
                                        case 0:
                                            stream.readString();
                                            break;
                                        case 1:
                                            useCMap = stream.readString();
                                            break;
                                    }
                                    continue;
                                }
                                const sequence = !!(b & 0x10);
                                const dataSize = b & 15;
                                if (dataSize + 1 > MAX_NUM_SIZE) throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                                const ucs2DataSize = 1;
                                const subitemsCount = stream.readNumber();
                                switch(type){
                                    case 0:
                                        stream.readHex(start, dataSize);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                                        for(let i = 1; i < subitemsCount; i++){
                                            incHex(end, dataSize);
                                            stream.readHexNumber(start, dataSize);
                                            addHex(start, end, dataSize);
                                            stream.readHexNumber(end, dataSize);
                                            addHex(end, start, dataSize);
                                            cMap.addCodespaceRange(dataSize + 1, hexToInt(start, dataSize), hexToInt(end, dataSize));
                                        }
                                        break;
                                    case 1:
                                        stream.readHex(start, dataSize);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        stream.readNumber();
                                        for(let i = 1; i < subitemsCount; i++){
                                            incHex(end, dataSize);
                                            stream.readHexNumber(start, dataSize);
                                            addHex(start, end, dataSize);
                                            stream.readHexNumber(end, dataSize);
                                            addHex(end, start, dataSize);
                                            stream.readNumber();
                                        }
                                        break;
                                    case 2:
                                        stream.readHex(char, dataSize);
                                        code = stream.readNumber();
                                        cMap.mapOne(hexToInt(char, dataSize), code);
                                        for(let i = 1; i < subitemsCount; i++){
                                            incHex(char, dataSize);
                                            if (!sequence) {
                                                stream.readHexNumber(tmp, dataSize);
                                                addHex(char, tmp, dataSize);
                                            }
                                            code = stream.readSigned() + (code + 1);
                                            cMap.mapOne(hexToInt(char, dataSize), code);
                                        }
                                        break;
                                    case 3:
                                        stream.readHex(start, dataSize);
                                        stream.readHexNumber(end, dataSize);
                                        addHex(end, start, dataSize);
                                        code = stream.readNumber();
                                        cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                                        for(let i = 1; i < subitemsCount; i++){
                                            incHex(end, dataSize);
                                            if (!sequence) {
                                                stream.readHexNumber(start, dataSize);
                                                addHex(start, end, dataSize);
                                            } else start.set(end);
                                            stream.readHexNumber(end, dataSize);
                                            addHex(end, start, dataSize);
                                            code = stream.readNumber();
                                            cMap.mapCidRange(hexToInt(start, dataSize), hexToInt(end, dataSize), code);
                                        }
                                        break;
                                    case 4:
                                        stream.readHex(char, ucs2DataSize);
                                        stream.readHex(charCode, dataSize);
                                        cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                                        for(let i = 1; i < subitemsCount; i++){
                                            incHex(char, ucs2DataSize);
                                            if (!sequence) {
                                                stream.readHexNumber(tmp, ucs2DataSize);
                                                addHex(char, tmp, ucs2DataSize);
                                            }
                                            incHex(charCode, dataSize);
                                            stream.readHexSigned(tmp, dataSize);
                                            addHex(charCode, tmp, dataSize);
                                            cMap.mapOne(hexToInt(char, ucs2DataSize), hexToStr(charCode, dataSize));
                                        }
                                        break;
                                    case 5:
                                        stream.readHex(start, ucs2DataSize);
                                        stream.readHexNumber(end, ucs2DataSize);
                                        addHex(end, start, ucs2DataSize);
                                        stream.readHex(charCode, dataSize);
                                        cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                                        for(let i = 1; i < subitemsCount; i++){
                                            incHex(end, ucs2DataSize);
                                            if (!sequence) {
                                                stream.readHexNumber(start, ucs2DataSize);
                                                addHex(start, end, ucs2DataSize);
                                            } else start.set(end);
                                            stream.readHexNumber(end, ucs2DataSize);
                                            addHex(end, start, ucs2DataSize);
                                            stream.readHex(charCode, dataSize);
                                            cMap.mapBfRange(hexToInt(start, ucs2DataSize), hexToInt(end, ucs2DataSize), hexToStr(charCode, dataSize));
                                        }
                                        break;
                                    default:
                                        throw new Error(`BinaryCMapReader.process - unknown type: ${type}`);
                                }
                            }
                            if (useCMap) return extend(useCMap);
                            return cMap;
                        }
                    }
                    return BinaryCMapReader;
                }();
                const CMapFactory = function CMapFactoryClosure() {
                    function strToInt(str) {
                        let a = 0;
                        for(let i = 0; i < str.length; i++)a = a << 8 | str.charCodeAt(i);
                        return a >>> 0;
                    }
                    function expectString(obj) {
                        if (!(0, _util.isString)(obj)) throw new _util.FormatError("Malformed CMap: expected string.");
                    }
                    function expectInt(obj) {
                        if (!Number.isInteger(obj)) throw new _util.FormatError("Malformed CMap: expected int.");
                    }
                    function parseBfChar(cMap, lexer) {
                        while(true){
                            let obj = lexer.getObj();
                            if ((0, _primitives.isEOF)(obj)) break;
                            if ((0, _primitives.isCmd)(obj, "endbfchar")) return;
                            expectString(obj);
                            const src = strToInt(obj);
                            obj = lexer.getObj();
                            expectString(obj);
                            const dst = obj;
                            cMap.mapOne(src, dst);
                        }
                    }
                    function parseBfRange(cMap, lexer) {
                        while(true){
                            let obj = lexer.getObj();
                            if ((0, _primitives.isEOF)(obj)) break;
                            if ((0, _primitives.isCmd)(obj, "endbfrange")) return;
                            expectString(obj);
                            const low = strToInt(obj);
                            obj = lexer.getObj();
                            expectString(obj);
                            const high = strToInt(obj);
                            obj = lexer.getObj();
                            if (Number.isInteger(obj) || (0, _util.isString)(obj)) {
                                const dstLow = Number.isInteger(obj) ? String.fromCharCode(obj) : obj;
                                cMap.mapBfRange(low, high, dstLow);
                            } else if ((0, _primitives.isCmd)(obj, "[")) {
                                obj = lexer.getObj();
                                const array = [];
                                while(!(0, _primitives.isCmd)(obj, "]") && !(0, _primitives.isEOF)(obj)){
                                    array.push(obj);
                                    obj = lexer.getObj();
                                }
                                cMap.mapBfRangeToArray(low, high, array);
                            } else break;
                        }
                        throw new _util.FormatError("Invalid bf range.");
                    }
                    function parseCidChar(cMap, lexer) {
                        while(true){
                            let obj = lexer.getObj();
                            if ((0, _primitives.isEOF)(obj)) break;
                            if ((0, _primitives.isCmd)(obj, "endcidchar")) return;
                            expectString(obj);
                            const src = strToInt(obj);
                            obj = lexer.getObj();
                            expectInt(obj);
                            const dst = obj;
                            cMap.mapOne(src, dst);
                        }
                    }
                    function parseCidRange(cMap, lexer) {
                        while(true){
                            let obj = lexer.getObj();
                            if ((0, _primitives.isEOF)(obj)) break;
                            if ((0, _primitives.isCmd)(obj, "endcidrange")) return;
                            expectString(obj);
                            const low = strToInt(obj);
                            obj = lexer.getObj();
                            expectString(obj);
                            const high = strToInt(obj);
                            obj = lexer.getObj();
                            expectInt(obj);
                            const dstLow = obj;
                            cMap.mapCidRange(low, high, dstLow);
                        }
                    }
                    function parseCodespaceRange(cMap, lexer) {
                        while(true){
                            let obj = lexer.getObj();
                            if ((0, _primitives.isEOF)(obj)) break;
                            if ((0, _primitives.isCmd)(obj, "endcodespacerange")) return;
                            if (!(0, _util.isString)(obj)) break;
                            const low = strToInt(obj);
                            obj = lexer.getObj();
                            if (!(0, _util.isString)(obj)) break;
                            const high = strToInt(obj);
                            cMap.addCodespaceRange(obj.length, low, high);
                        }
                        throw new _util.FormatError("Invalid codespace range.");
                    }
                    function parseWMode(cMap, lexer) {
                        const obj = lexer.getObj();
                        if (Number.isInteger(obj)) cMap.vertical = !!obj;
                    }
                    function parseCMapName(cMap, lexer) {
                        const obj = lexer.getObj();
                        if ((0, _primitives.isName)(obj) && (0, _util.isString)(obj.name)) cMap.name = obj.name;
                    }
                    async function parseCMap(cMap, lexer, fetchBuiltInCMap, useCMap) {
                        let previous, embeddedUseCMap;
                        objLoop: while(true)try {
                            const obj = lexer.getObj();
                            if ((0, _primitives.isEOF)(obj)) break;
                            else if ((0, _primitives.isName)(obj)) {
                                if (obj.name === "WMode") parseWMode(cMap, lexer);
                                else if (obj.name === "CMapName") parseCMapName(cMap, lexer);
                                previous = obj;
                            } else if ((0, _primitives.isCmd)(obj)) switch(obj.cmd){
                                case "endcmap":
                                    break objLoop;
                                case "usecmap":
                                    if ((0, _primitives.isName)(previous)) embeddedUseCMap = previous.name;
                                    break;
                                case "begincodespacerange":
                                    parseCodespaceRange(cMap, lexer);
                                    break;
                                case "beginbfchar":
                                    parseBfChar(cMap, lexer);
                                    break;
                                case "begincidchar":
                                    parseCidChar(cMap, lexer);
                                    break;
                                case "beginbfrange":
                                    parseBfRange(cMap, lexer);
                                    break;
                                case "begincidrange":
                                    parseCidRange(cMap, lexer);
                                    break;
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Invalid cMap data: " + ex);
                            continue;
                        }
                        if (!useCMap && embeddedUseCMap) useCMap = embeddedUseCMap;
                        if (useCMap) return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                        return cMap;
                    }
                    async function extendCMap(cMap, fetchBuiltInCMap, useCMap) {
                        cMap.useCMap = await createBuiltInCMap(useCMap, fetchBuiltInCMap);
                        if (cMap.numCodespaceRanges === 0) {
                            const useCodespaceRanges = cMap.useCMap.codespaceRanges;
                            for(let i = 0; i < useCodespaceRanges.length; i++)cMap.codespaceRanges[i] = useCodespaceRanges[i].slice();
                            cMap.numCodespaceRanges = cMap.useCMap.numCodespaceRanges;
                        }
                        cMap.useCMap.forEach(function(key, value) {
                            if (!cMap.contains(key)) cMap.mapOne(key, cMap.useCMap.lookup(key));
                        });
                        return cMap;
                    }
                    async function createBuiltInCMap(name, fetchBuiltInCMap) {
                        if (name === "Identity-H") return new IdentityCMap(false, 2);
                        else if (name === "Identity-V") return new IdentityCMap(true, 2);
                        if (!BUILT_IN_CMAPS.includes(name)) throw new Error("Unknown CMap name: " + name);
                        if (!fetchBuiltInCMap) throw new Error("Built-in CMap parameters are not provided.");
                        const { cMapData: cMapData , compressionType: compressionType  } = await fetchBuiltInCMap(name);
                        const cMap = new CMap(true);
                        if (compressionType === _util.CMapCompressionType.BINARY) return new BinaryCMapReader().process(cMapData, cMap, (useCMap)=>{
                            return extendCMap(cMap, fetchBuiltInCMap, useCMap);
                        });
                        if (compressionType === _util.CMapCompressionType.NONE) {
                            const lexer = new _parser.Lexer(new _stream.Stream(cMapData));
                            return parseCMap(cMap, lexer, fetchBuiltInCMap, null);
                        }
                        throw new Error("TODO: Only BINARY/NONE CMap compression is currently supported.");
                    }
                    return {
                        async create (params) {
                            const encoding = params.encoding;
                            const fetchBuiltInCMap = params.fetchBuiltInCMap;
                            const useCMap = params.useCMap;
                            if ((0, _primitives.isName)(encoding)) return createBuiltInCMap(encoding.name, fetchBuiltInCMap);
                            else if ((0, _primitives.isStream)(encoding)) {
                                const parsedCMap = await parseCMap(new CMap(), new _parser.Lexer(encoding), fetchBuiltInCMap, useCMap);
                                if (parsedCMap.isIdentityCMap) return createBuiltInCMap(parsedCMap.name, fetchBuiltInCMap);
                                return parsedCMap;
                            }
                            throw new Error("Encoding required.");
                        }
                    };
                }();
                exports.CMapFactory = CMapFactory;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Parser = exports.Linearization = exports.Lexer = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                var _ascii_85_stream = __w_pdfjs_require__(18);
                var _ascii_hex_stream = __w_pdfjs_require__(20);
                var _ccitt_stream = __w_pdfjs_require__(21);
                var _flate_stream = __w_pdfjs_require__(23);
                var _jbig2_stream = __w_pdfjs_require__(24);
                var _jpeg_stream = __w_pdfjs_require__(27);
                var _jpx_stream = __w_pdfjs_require__(29);
                var _lzw_stream = __w_pdfjs_require__(31);
                var _stream = __w_pdfjs_require__(10);
                var _predictor_stream = __w_pdfjs_require__(32);
                var _run_length_stream = __w_pdfjs_require__(33);
                const MAX_LENGTH_TO_CACHE = 1000;
                const MAX_ADLER32_LENGTH = 5552;
                function computeAdler32(bytes) {
                    const bytesLength = bytes.length;
                    let a = 1, b = 0;
                    for(let i = 0; i < bytesLength; ++i){
                        a += bytes[i] & 0xff;
                        b += a;
                    }
                    return b % 65521 << 16 | a % 65521;
                }
                class Parser {
                    constructor({ lexer: lexer , xref: xref , allowStreams: allowStreams = false , recoveryMode: recoveryMode = false  }){
                        this.lexer = lexer;
                        this.xref = xref;
                        this.allowStreams = allowStreams;
                        this.recoveryMode = recoveryMode;
                        this.imageCache = Object.create(null);
                        this.refill();
                    }
                    refill() {
                        this.buf1 = this.lexer.getObj();
                        this.buf2 = this.lexer.getObj();
                    }
                    shift() {
                        if (this.buf2 instanceof _primitives.Cmd && this.buf2.cmd === "ID") {
                            this.buf1 = this.buf2;
                            this.buf2 = null;
                        } else {
                            this.buf1 = this.buf2;
                            this.buf2 = this.lexer.getObj();
                        }
                    }
                    tryShift() {
                        try {
                            this.shift();
                            return true;
                        } catch (e) {
                            if (e instanceof _core_utils.MissingDataException) throw e;
                            return false;
                        }
                    }
                    getObj(cipherTransform = null) {
                        const buf1 = this.buf1;
                        this.shift();
                        if (buf1 instanceof _primitives.Cmd) switch(buf1.cmd){
                            case "BI":
                                return this.makeInlineImage(cipherTransform);
                            case "[":
                                const array = [];
                                while(!(0, _primitives.isCmd)(this.buf1, "]") && !(0, _primitives.isEOF)(this.buf1))array.push(this.getObj(cipherTransform));
                                if ((0, _primitives.isEOF)(this.buf1)) {
                                    if (this.recoveryMode) return array;
                                    throw new _core_utils.ParserEOFException("End of file inside array.");
                                }
                                this.shift();
                                return array;
                            case "<<":
                                const dict = new _primitives.Dict(this.xref);
                                while(!(0, _primitives.isCmd)(this.buf1, ">>") && !(0, _primitives.isEOF)(this.buf1)){
                                    if (!(0, _primitives.isName)(this.buf1)) {
                                        (0, _util.info)("Malformed dictionary: key must be a name object");
                                        this.shift();
                                        continue;
                                    }
                                    const key = this.buf1.name;
                                    this.shift();
                                    if ((0, _primitives.isEOF)(this.buf1)) break;
                                    dict.set(key, this.getObj(cipherTransform));
                                }
                                if ((0, _primitives.isEOF)(this.buf1)) {
                                    if (this.recoveryMode) return dict;
                                    throw new _core_utils.ParserEOFException("End of file inside dictionary.");
                                }
                                if ((0, _primitives.isCmd)(this.buf2, "stream")) return this.allowStreams ? this.makeStream(dict, cipherTransform) : dict;
                                this.shift();
                                return dict;
                            default:
                                return buf1;
                        }
                        if (Number.isInteger(buf1)) {
                            if (Number.isInteger(this.buf1) && (0, _primitives.isCmd)(this.buf2, "R")) {
                                const ref = _primitives.Ref.get(buf1, this.buf1);
                                this.shift();
                                this.shift();
                                return ref;
                            }
                            return buf1;
                        }
                        if (typeof buf1 === "string") {
                            if (cipherTransform) return cipherTransform.decryptString(buf1);
                            return buf1;
                        }
                        return buf1;
                    }
                    findDefaultInlineStreamEnd(stream) {
                        const E = 0x45, I = 0x49, SPACE = 0x20, LF = 0xa, CR = 0xd, NUL = 0x0;
                        const lexer = this.lexer, startPos = stream.pos, n = 10;
                        let state = 0, ch, maybeEIPos;
                        while((ch = stream.getByte()) !== -1){
                            if (state === 0) state = ch === E ? 1 : 0;
                            else if (state === 1) state = ch === I ? 2 : 0;
                            else {
                                (0, _util.assert)(state === 2, "findDefaultInlineStreamEnd - invalid state.");
                                if (ch === SPACE || ch === LF || ch === CR) {
                                    maybeEIPos = stream.pos;
                                    const followingBytes = stream.peekBytes(n);
                                    for(let i = 0, ii = followingBytes.length; i < ii; i++){
                                        ch = followingBytes[i];
                                        if (ch === NUL && followingBytes[i + 1] !== NUL) continue;
                                        if (ch !== LF && ch !== CR && (ch < SPACE || ch > 0x7f)) {
                                            state = 0;
                                            break;
                                        }
                                    }
                                    if (state !== 2) continue;
                                    if (lexer.knownCommands) {
                                        const nextObj = lexer.peekObj();
                                        if (nextObj instanceof _primitives.Cmd && !lexer.knownCommands[nextObj.cmd]) state = 0;
                                    } else (0, _util.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                                    if (state === 2) break;
                                } else state = 0;
                            }
                        }
                        if (ch === -1) {
                            (0, _util.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker");
                            if (maybeEIPos) {
                                (0, _util.warn)('... trying to recover by using the last "EI" occurrence.');
                                stream.skip(-(stream.pos - maybeEIPos));
                            }
                        }
                        let endOffset = 4;
                        stream.skip(-endOffset);
                        ch = stream.peekByte();
                        stream.skip(endOffset);
                        if (!(0, _core_utils.isWhiteSpace)(ch)) endOffset--;
                        return stream.pos - endOffset - startPos;
                    }
                    findDCTDecodeInlineStreamEnd(stream) {
                        const startPos = stream.pos;
                        let foundEOI = false, b, markerLength;
                        while((b = stream.getByte()) !== -1){
                            if (b !== 0xff) continue;
                            switch(stream.getByte()){
                                case 0x00:
                                    break;
                                case 0xff:
                                    stream.skip(-1);
                                    break;
                                case 0xd9:
                                    foundEOI = true;
                                    break;
                                case 0xc0:
                                case 0xc1:
                                case 0xc2:
                                case 0xc3:
                                case 0xc5:
                                case 0xc6:
                                case 0xc7:
                                case 0xc9:
                                case 0xca:
                                case 0xcb:
                                case 0xcd:
                                case 0xce:
                                case 0xcf:
                                case 0xc4:
                                case 0xcc:
                                case 0xda:
                                case 0xdb:
                                case 0xdc:
                                case 0xdd:
                                case 0xde:
                                case 0xdf:
                                case 0xe0:
                                case 0xe1:
                                case 0xe2:
                                case 0xe3:
                                case 0xe4:
                                case 0xe5:
                                case 0xe6:
                                case 0xe7:
                                case 0xe8:
                                case 0xe9:
                                case 0xea:
                                case 0xeb:
                                case 0xec:
                                case 0xed:
                                case 0xee:
                                case 0xef:
                                case 0xfe:
                                    markerLength = stream.getUint16();
                                    if (markerLength > 2) stream.skip(markerLength - 2);
                                    else stream.skip(-2);
                                    break;
                            }
                            if (foundEOI) break;
                        }
                        const length = stream.pos - startPos;
                        if (b === -1) {
                            (0, _util.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    findASCII85DecodeInlineStreamEnd(stream) {
                        const TILDE = 0x7e, GT = 0x3e;
                        const startPos = stream.pos;
                        let ch;
                        while((ch = stream.getByte()) !== -1)if (ch === TILDE) {
                            const tildePos = stream.pos;
                            ch = stream.peekByte();
                            while((0, _core_utils.isWhiteSpace)(ch)){
                                stream.skip();
                                ch = stream.peekByte();
                            }
                            if (ch === GT) {
                                stream.skip();
                                break;
                            }
                            if (stream.pos > tildePos) {
                                const maybeEI = stream.peekBytes(2);
                                if (maybeEI[0] === 0x45 && maybeEI[1] === 0x49) break;
                            }
                        }
                        const length = stream.pos - startPos;
                        if (ch === -1) {
                            (0, _util.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    findASCIIHexDecodeInlineStreamEnd(stream) {
                        const GT = 0x3e;
                        const startPos = stream.pos;
                        let ch;
                        while((ch = stream.getByte()) !== -1){
                            if (ch === GT) break;
                        }
                        const length = stream.pos - startPos;
                        if (ch === -1) {
                            (0, _util.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead.");
                            stream.skip(-length);
                            return this.findDefaultInlineStreamEnd(stream);
                        }
                        this.inlineStreamSkipEI(stream);
                        return length;
                    }
                    inlineStreamSkipEI(stream) {
                        const E = 0x45, I = 0x49;
                        let state = 0, ch;
                        while((ch = stream.getByte()) !== -1){
                            if (state === 0) state = ch === E ? 1 : 0;
                            else if (state === 1) state = ch === I ? 2 : 0;
                            else if (state === 2) break;
                        }
                    }
                    makeInlineImage(cipherTransform) {
                        const lexer = this.lexer;
                        const stream = lexer.stream;
                        const dict = new _primitives.Dict(this.xref);
                        let dictLength;
                        while(!(0, _primitives.isCmd)(this.buf1, "ID") && !(0, _primitives.isEOF)(this.buf1)){
                            if (!(0, _primitives.isName)(this.buf1)) throw new _util.FormatError("Dictionary key must be a name object");
                            const key = this.buf1.name;
                            this.shift();
                            if ((0, _primitives.isEOF)(this.buf1)) break;
                            dict.set(key, this.getObj(cipherTransform));
                        }
                        if (lexer.beginInlineImagePos !== -1) dictLength = stream.pos - lexer.beginInlineImagePos;
                        const filter = dict.get("Filter", "F");
                        let filterName;
                        if ((0, _primitives.isName)(filter)) filterName = filter.name;
                        else if (Array.isArray(filter)) {
                            const filterZero = this.xref.fetchIfRef(filter[0]);
                            if ((0, _primitives.isName)(filterZero)) filterName = filterZero.name;
                        }
                        const startPos = stream.pos;
                        let length;
                        if (filterName === "DCTDecode" || filterName === "DCT") length = this.findDCTDecodeInlineStreamEnd(stream);
                        else if (filterName === "ASCII85Decode" || filterName === "A85") length = this.findASCII85DecodeInlineStreamEnd(stream);
                        else if (filterName === "ASCIIHexDecode" || filterName === "AHx") length = this.findASCIIHexDecodeInlineStreamEnd(stream);
                        else length = this.findDefaultInlineStreamEnd(stream);
                        let imageStream = stream.makeSubStream(startPos, length, dict);
                        let cacheKey;
                        if (length < MAX_LENGTH_TO_CACHE && dictLength < MAX_ADLER32_LENGTH) {
                            const imageBytes = imageStream.getBytes();
                            imageStream.reset();
                            const initialStreamPos = stream.pos;
                            stream.pos = lexer.beginInlineImagePos;
                            const dictBytes = stream.getBytes(dictLength);
                            stream.pos = initialStreamPos;
                            cacheKey = computeAdler32(imageBytes) + "_" + computeAdler32(dictBytes);
                            const cacheEntry = this.imageCache[cacheKey];
                            if (cacheEntry !== undefined) {
                                this.buf2 = _primitives.Cmd.get("EI");
                                this.shift();
                                cacheEntry.reset();
                                return cacheEntry;
                            }
                        }
                        if (cipherTransform) imageStream = cipherTransform.createStream(imageStream, length);
                        imageStream = this.filter(imageStream, dict, length);
                        imageStream.dict = dict;
                        if (cacheKey !== undefined) {
                            imageStream.cacheKey = `inline_${length}_${cacheKey}`;
                            this.imageCache[cacheKey] = imageStream;
                        }
                        this.buf2 = _primitives.Cmd.get("EI");
                        this.shift();
                        return imageStream;
                    }
                    _findStreamLength(startPos, signature) {
                        const { stream: stream  } = this.lexer;
                        stream.pos = startPos;
                        const SCAN_BLOCK_LENGTH = 2048;
                        const signatureLength = signature.length;
                        while(stream.pos < stream.end){
                            const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                            const scanLength = scanBytes.length - signatureLength;
                            if (scanLength <= 0) break;
                            let pos = 0;
                            while(pos < scanLength){
                                let j = 0;
                                while(j < signatureLength && scanBytes[pos + j] === signature[j])j++;
                                if (j >= signatureLength) {
                                    stream.pos += pos;
                                    return stream.pos - startPos;
                                }
                                pos++;
                            }
                            stream.pos += scanLength;
                        }
                        return -1;
                    }
                    makeStream(dict, cipherTransform) {
                        const lexer = this.lexer;
                        let stream = lexer.stream;
                        lexer.skipToNextLine();
                        const startPos = stream.pos - 1;
                        let length = dict.get("Length");
                        if (!Number.isInteger(length)) {
                            (0, _util.info)(`Bad length "${length}" in stream`);
                            length = 0;
                        }
                        stream.pos = startPos + length;
                        lexer.nextChar();
                        if (this.tryShift() && (0, _primitives.isCmd)(this.buf2, "endstream")) this.shift();
                        else {
                            const ENDSTREAM_SIGNATURE = new Uint8Array([
                                0x65,
                                0x6e,
                                0x64,
                                0x73,
                                0x74,
                                0x72,
                                0x65,
                                0x61,
                                0x6d
                            ]);
                            let actualLength = this._findStreamLength(startPos, ENDSTREAM_SIGNATURE);
                            if (actualLength < 0) {
                                const MAX_TRUNCATION = 1;
                                for(let i = 1; i <= MAX_TRUNCATION; i++){
                                    const end = ENDSTREAM_SIGNATURE.length - i;
                                    const TRUNCATED_SIGNATURE = ENDSTREAM_SIGNATURE.slice(0, end);
                                    const maybeLength = this._findStreamLength(startPos, TRUNCATED_SIGNATURE);
                                    if (maybeLength >= 0) {
                                        const lastByte = stream.peekBytes(end + 1)[end];
                                        if (!(0, _core_utils.isWhiteSpace)(lastByte)) break;
                                        (0, _util.info)(`Found "${(0, _util.bytesToString)(TRUNCATED_SIGNATURE)}" when ` + "searching for endstream command.");
                                        actualLength = maybeLength;
                                        break;
                                    }
                                }
                                if (actualLength < 0) throw new _util.FormatError("Missing endstream command.");
                            }
                            length = actualLength;
                            lexer.nextChar();
                            this.shift();
                            this.shift();
                        }
                        this.shift();
                        stream = stream.makeSubStream(startPos, length, dict);
                        if (cipherTransform) stream = cipherTransform.createStream(stream, length);
                        stream = this.filter(stream, dict, length);
                        stream.dict = dict;
                        return stream;
                    }
                    filter(stream, dict, length) {
                        let filter = dict.get("Filter", "F");
                        let params = dict.get("DecodeParms", "DP");
                        if ((0, _primitives.isName)(filter)) {
                            if (Array.isArray(params)) (0, _util.warn)("/DecodeParms should not contain an Array, when /Filter contains a Name.");
                            return this.makeFilter(stream, filter.name, length, params);
                        }
                        let maybeLength = length;
                        if (Array.isArray(filter)) {
                            const filterArray = filter;
                            const paramsArray = params;
                            for(let i = 0, ii = filterArray.length; i < ii; ++i){
                                filter = this.xref.fetchIfRef(filterArray[i]);
                                if (!(0, _primitives.isName)(filter)) throw new _util.FormatError(`Bad filter name "${filter}"`);
                                params = null;
                                if (Array.isArray(paramsArray) && i in paramsArray) params = this.xref.fetchIfRef(paramsArray[i]);
                                stream = this.makeFilter(stream, filter.name, maybeLength, params);
                                maybeLength = null;
                            }
                        }
                        return stream;
                    }
                    makeFilter(stream, name, maybeLength, params) {
                        if (maybeLength === 0) {
                            (0, _util.warn)(`Empty "${name}" stream.`);
                            return new _stream.NullStream();
                        }
                        try {
                            const xrefStreamStats = this.xref.stats.streamTypes;
                            if (name === "FlateDecode" || name === "Fl") {
                                xrefStreamStats[_util.StreamType.FLATE] = true;
                                if (params) return new _predictor_stream.PredictorStream(new _flate_stream.FlateStream(stream, maybeLength), maybeLength, params);
                                return new _flate_stream.FlateStream(stream, maybeLength);
                            }
                            if (name === "LZWDecode" || name === "LZW") {
                                xrefStreamStats[_util.StreamType.LZW] = true;
                                let earlyChange = 1;
                                if (params) {
                                    if (params.has("EarlyChange")) earlyChange = params.get("EarlyChange");
                                    return new _predictor_stream.PredictorStream(new _lzw_stream.LZWStream(stream, maybeLength, earlyChange), maybeLength, params);
                                }
                                return new _lzw_stream.LZWStream(stream, maybeLength, earlyChange);
                            }
                            if (name === "DCTDecode" || name === "DCT") {
                                xrefStreamStats[_util.StreamType.DCT] = true;
                                return new _jpeg_stream.JpegStream(stream, maybeLength, params);
                            }
                            if (name === "JPXDecode" || name === "JPX") {
                                xrefStreamStats[_util.StreamType.JPX] = true;
                                return new _jpx_stream.JpxStream(stream, maybeLength, params);
                            }
                            if (name === "ASCII85Decode" || name === "A85") {
                                xrefStreamStats[_util.StreamType.A85] = true;
                                return new _ascii_85_stream.Ascii85Stream(stream, maybeLength);
                            }
                            if (name === "ASCIIHexDecode" || name === "AHx") {
                                xrefStreamStats[_util.StreamType.AHX] = true;
                                return new _ascii_hex_stream.AsciiHexStream(stream, maybeLength);
                            }
                            if (name === "CCITTFaxDecode" || name === "CCF") {
                                xrefStreamStats[_util.StreamType.CCF] = true;
                                return new _ccitt_stream.CCITTFaxStream(stream, maybeLength, params);
                            }
                            if (name === "RunLengthDecode" || name === "RL") {
                                xrefStreamStats[_util.StreamType.RLX] = true;
                                return new _run_length_stream.RunLengthStream(stream, maybeLength);
                            }
                            if (name === "JBIG2Decode") {
                                xrefStreamStats[_util.StreamType.JBIG] = true;
                                return new _jbig2_stream.Jbig2Stream(stream, maybeLength, params);
                            }
                            (0, _util.warn)(`Filter "${name}" is not supported.`);
                            return stream;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Invalid stream: "${ex}"`);
                            return new _stream.NullStream();
                        }
                    }
                }
                exports.Parser = Parser;
                const specialChars = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                function toHexDigit(ch) {
                    if (ch >= 0x30 && ch <= 0x39) return ch & 0x0f;
                    if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) return (ch & 0x0f) + 9;
                    return -1;
                }
                class Lexer {
                    constructor(stream, knownCommands = null){
                        this.stream = stream;
                        this.nextChar();
                        this.strBuf = [];
                        this.knownCommands = knownCommands;
                        this._hexStringNumWarn = 0;
                        this.beginInlineImagePos = -1;
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    peekChar() {
                        return this.stream.peekByte();
                    }
                    getNumber() {
                        let ch = this.currentChar;
                        let eNotation = false;
                        let divideBy = 0;
                        let sign = 0;
                        if (ch === 0x2d) {
                            sign = -1;
                            ch = this.nextChar();
                            if (ch === 0x2d) ch = this.nextChar();
                        } else if (ch === 0x2b) {
                            sign = 1;
                            ch = this.nextChar();
                        }
                        if (ch === 0x0a || ch === 0x0d) do ch = this.nextChar();
                        while (ch === 0x0a || ch === 0x0d);
                        if (ch === 0x2e) {
                            divideBy = 10;
                            ch = this.nextChar();
                        }
                        if (ch < 0x30 || ch > 0x39) {
                            if (divideBy === 10 && sign === 0 && ((0, _core_utils.isWhiteSpace)(ch) || ch === -1)) {
                                (0, _util.warn)("Lexer.getNumber - treating a single decimal point as zero.");
                                return 0;
                            }
                            throw new _util.FormatError(`Invalid number: ${String.fromCharCode(ch)} (charCode ${ch})`);
                        }
                        sign = sign || 1;
                        let baseValue = ch - 0x30;
                        let powerValue = 0;
                        let powerValueSign = 1;
                        while((ch = this.nextChar()) >= 0){
                            if (ch >= 0x30 && ch <= 0x39) {
                                const currentDigit = ch - 0x30;
                                if (eNotation) powerValue = powerValue * 10 + currentDigit;
                                else {
                                    if (divideBy !== 0) divideBy *= 10;
                                    baseValue = baseValue * 10 + currentDigit;
                                }
                            } else if (ch === 0x2e) {
                                if (divideBy === 0) divideBy = 1;
                                else break;
                            } else if (ch === 0x2d) (0, _util.warn)("Badly formatted number: minus sign in the middle");
                            else if (ch === 0x45 || ch === 0x65) {
                                ch = this.peekChar();
                                if (ch === 0x2b || ch === 0x2d) {
                                    powerValueSign = ch === 0x2d ? -1 : 1;
                                    this.nextChar();
                                } else if (ch < 0x30 || ch > 0x39) break;
                                eNotation = true;
                            } else break;
                        }
                        if (divideBy !== 0) baseValue /= divideBy;
                        if (eNotation) baseValue *= 10 ** (powerValueSign * powerValue);
                        return sign * baseValue;
                    }
                    getString() {
                        let numParen = 1;
                        let done = false;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        let ch = this.nextChar();
                        while(true){
                            let charBuffered = false;
                            switch(ch | 0){
                                case -1:
                                    (0, _util.warn)("Unterminated string");
                                    done = true;
                                    break;
                                case 0x28:
                                    ++numParen;
                                    strBuf.push("(");
                                    break;
                                case 0x29:
                                    if (--numParen === 0) {
                                        this.nextChar();
                                        done = true;
                                    } else strBuf.push(")");
                                    break;
                                case 0x5c:
                                    ch = this.nextChar();
                                    switch(ch){
                                        case -1:
                                            (0, _util.warn)("Unterminated string");
                                            done = true;
                                            break;
                                        case 0x6e:
                                            strBuf.push("\n");
                                            break;
                                        case 0x72:
                                            strBuf.push("\r");
                                            break;
                                        case 0x74:
                                            strBuf.push("	");
                                            break;
                                        case 0x62:
                                            strBuf.push("\b");
                                            break;
                                        case 0x66:
                                            strBuf.push("\f");
                                            break;
                                        case 0x5c:
                                        case 0x28:
                                        case 0x29:
                                            strBuf.push(String.fromCharCode(ch));
                                            break;
                                        case 0x30:
                                        case 0x31:
                                        case 0x32:
                                        case 0x33:
                                        case 0x34:
                                        case 0x35:
                                        case 0x36:
                                        case 0x37:
                                            let x = ch & 0x0f;
                                            ch = this.nextChar();
                                            charBuffered = true;
                                            if (ch >= 0x30 && ch <= 0x37) {
                                                x = (x << 3) + (ch & 0x0f);
                                                ch = this.nextChar();
                                                if (ch >= 0x30 && ch <= 0x37) {
                                                    charBuffered = false;
                                                    x = (x << 3) + (ch & 0x0f);
                                                }
                                            }
                                            strBuf.push(String.fromCharCode(x));
                                            break;
                                        case 0x0d:
                                            if (this.peekChar() === 0x0a) this.nextChar();
                                            break;
                                        case 0x0a:
                                            break;
                                        default:
                                            strBuf.push(String.fromCharCode(ch));
                                            break;
                                    }
                                    break;
                                default:
                                    strBuf.push(String.fromCharCode(ch));
                                    break;
                            }
                            if (done) break;
                            if (!charBuffered) ch = this.nextChar();
                        }
                        return strBuf.join("");
                    }
                    getName() {
                        let ch, previousCh;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        while((ch = this.nextChar()) >= 0 && !specialChars[ch])if (ch === 0x23) {
                            ch = this.nextChar();
                            if (specialChars[ch]) {
                                (0, _util.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number.");
                                strBuf.push("#");
                                break;
                            }
                            const x = toHexDigit(ch);
                            if (x !== -1) {
                                previousCh = ch;
                                ch = this.nextChar();
                                const x2 = toHexDigit(ch);
                                if (x2 === -1) {
                                    (0, _util.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(ch)}) ` + "in hexadecimal number.");
                                    strBuf.push("#", String.fromCharCode(previousCh));
                                    if (specialChars[ch]) break;
                                    strBuf.push(String.fromCharCode(ch));
                                    continue;
                                }
                                strBuf.push(String.fromCharCode(x << 4 | x2));
                            } else strBuf.push("#", String.fromCharCode(ch));
                        } else strBuf.push(String.fromCharCode(ch));
                        if (strBuf.length > 127) (0, _util.warn)(`Name token is longer than allowed by the spec: ${strBuf.length}`);
                        else if (strBuf.length === 0) (0, _util.warn)("Name token is empty.");
                        return _primitives.Name.get(strBuf.join(""));
                    }
                    _hexStringWarn(ch) {
                        const MAX_HEX_STRING_NUM_WARN = 5;
                        if (this._hexStringNumWarn++ === MAX_HEX_STRING_NUM_WARN) {
                            (0, _util.warn)("getHexString - ignoring additional invalid characters.");
                            return;
                        }
                        if (this._hexStringNumWarn > MAX_HEX_STRING_NUM_WARN) return;
                        (0, _util.warn)(`getHexString - ignoring invalid character: ${ch}`);
                    }
                    getHexString() {
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        let ch = this.currentChar;
                        let isFirstHex = true;
                        let firstDigit, secondDigit;
                        this._hexStringNumWarn = 0;
                        while(true){
                            if (ch < 0) {
                                (0, _util.warn)("Unterminated hex string");
                                break;
                            } else if (ch === 0x3e) {
                                this.nextChar();
                                break;
                            } else if (specialChars[ch] === 1) {
                                ch = this.nextChar();
                                continue;
                            } else {
                                if (isFirstHex) {
                                    firstDigit = toHexDigit(ch);
                                    if (firstDigit === -1) {
                                        this._hexStringWarn(ch);
                                        ch = this.nextChar();
                                        continue;
                                    }
                                } else {
                                    secondDigit = toHexDigit(ch);
                                    if (secondDigit === -1) {
                                        this._hexStringWarn(ch);
                                        ch = this.nextChar();
                                        continue;
                                    }
                                    strBuf.push(String.fromCharCode(firstDigit << 4 | secondDigit));
                                }
                                isFirstHex = !isFirstHex;
                                ch = this.nextChar();
                            }
                        }
                        return strBuf.join("");
                    }
                    getObj() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch < 0) return _primitives.EOF;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (specialChars[ch] !== 1) break;
                            ch = this.nextChar();
                        }
                        switch(ch | 0){
                            case 0x30:
                            case 0x31:
                            case 0x32:
                            case 0x33:
                            case 0x34:
                            case 0x35:
                            case 0x36:
                            case 0x37:
                            case 0x38:
                            case 0x39:
                            case 0x2b:
                            case 0x2d:
                            case 0x2e:
                                return this.getNumber();
                            case 0x28:
                                return this.getString();
                            case 0x2f:
                                return this.getName();
                            case 0x5b:
                                this.nextChar();
                                return _primitives.Cmd.get("[");
                            case 0x5d:
                                this.nextChar();
                                return _primitives.Cmd.get("]");
                            case 0x3c:
                                ch = this.nextChar();
                                if (ch === 0x3c) {
                                    this.nextChar();
                                    return _primitives.Cmd.get("<<");
                                }
                                return this.getHexString();
                            case 0x3e:
                                ch = this.nextChar();
                                if (ch === 0x3e) {
                                    this.nextChar();
                                    return _primitives.Cmd.get(">>");
                                }
                                return _primitives.Cmd.get(">");
                            case 0x7b:
                                this.nextChar();
                                return _primitives.Cmd.get("{");
                            case 0x7d:
                                this.nextChar();
                                return _primitives.Cmd.get("}");
                            case 0x29:
                                this.nextChar();
                                throw new _util.FormatError(`Illegal character: ${ch}`);
                        }
                        let str = String.fromCharCode(ch);
                        const knownCommands = this.knownCommands;
                        let knownCommandFound = knownCommands && knownCommands[str] !== undefined;
                        while((ch = this.nextChar()) >= 0 && !specialChars[ch]){
                            const possibleCommand = str + String.fromCharCode(ch);
                            if (knownCommandFound && knownCommands[possibleCommand] === undefined) break;
                            if (str.length === 128) throw new _util.FormatError(`Command token too long: ${str.length}`);
                            str = possibleCommand;
                            knownCommandFound = knownCommands && knownCommands[str] !== undefined;
                        }
                        if (str === "true") return true;
                        if (str === "false") return false;
                        if (str === "null") return null;
                        if (str === "BI") this.beginInlineImagePos = this.stream.pos;
                        return _primitives.Cmd.get(str);
                    }
                    peekObj() {
                        const streamPos = this.stream.pos, currentChar = this.currentChar, beginInlineImagePos = this.beginInlineImagePos;
                        let nextObj;
                        try {
                            nextObj = this.getObj();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`peekObj: ${ex}`);
                        }
                        this.stream.pos = streamPos;
                        this.currentChar = currentChar;
                        this.beginInlineImagePos = beginInlineImagePos;
                        return nextObj;
                    }
                    skipToNextLine() {
                        let ch = this.currentChar;
                        while(ch >= 0){
                            if (ch === 0x0d) {
                                ch = this.nextChar();
                                if (ch === 0x0a) this.nextChar();
                                break;
                            } else if (ch === 0x0a) {
                                this.nextChar();
                                break;
                            }
                            ch = this.nextChar();
                        }
                    }
                }
                exports.Lexer = Lexer;
                class Linearization {
                    static create(stream) {
                        function getInt(linDict, name, allowZeroValue = false) {
                            const obj = linDict.get(name);
                            if (Number.isInteger(obj) && (allowZeroValue ? obj >= 0 : obj > 0)) return obj;
                            throw new Error(`The "${name}" parameter in the linearization ` + "dictionary is invalid.");
                        }
                        function getHints(linDict) {
                            const hints = linDict.get("H");
                            let hintsLength;
                            if (Array.isArray(hints) && ((hintsLength = hints.length) === 2 || hintsLength === 4)) {
                                for(let index = 0; index < hintsLength; index++){
                                    const hint = hints[index];
                                    if (!(Number.isInteger(hint) && hint > 0)) throw new Error(`Hint (${index}) in the linearization dictionary is invalid.`);
                                }
                                return hints;
                            }
                            throw new Error("Hint array in the linearization dictionary is invalid.");
                        }
                        const parser = new Parser({
                            lexer: new Lexer(stream),
                            xref: null
                        });
                        const obj1 = parser.getObj();
                        const obj2 = parser.getObj();
                        const obj3 = parser.getObj();
                        const linDict = parser.getObj();
                        let obj, length;
                        if (!(Number.isInteger(obj1) && Number.isInteger(obj2) && (0, _primitives.isCmd)(obj3, "obj") && (0, _primitives.isDict)(linDict) && (0, _util.isNum)(obj = linDict.get("Linearized")) && obj > 0)) return null;
                        else if ((length = getInt(linDict, "L")) !== stream.length) throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
                        return {
                            length: length,
                            hints: getHints(linDict),
                            objectNumberFirst: getInt(linDict, "O"),
                            endFirst: getInt(linDict, "E"),
                            numPages: getInt(linDict, "N"),
                            mainXRefEntriesOffset: getInt(linDict, "T"),
                            pageFirst: linDict.has("P") ? getInt(linDict, "P", true) : 0
                        };
                    }
                }
                exports.Linearization = Linearization;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Ascii85Stream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                var _core_utils = __w_pdfjs_require__(9);
                class Ascii85Stream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        if (maybeLength) maybeLength *= 0.8;
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.input = new Uint8Array(5);
                    }
                    readBlock() {
                        const TILDA_CHAR = 0x7e;
                        const Z_LOWER_CHAR = 0x7a;
                        const EOF = -1;
                        const str = this.str;
                        let c = str.getByte();
                        while((0, _core_utils.isWhiteSpace)(c))c = str.getByte();
                        if (c === EOF || c === TILDA_CHAR) {
                            this.eof = true;
                            return;
                        }
                        const bufferLength = this.bufferLength;
                        let buffer, i;
                        if (c === Z_LOWER_CHAR) {
                            buffer = this.ensureBuffer(bufferLength + 4);
                            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
                            this.bufferLength += 4;
                        } else {
                            const input = this.input;
                            input[0] = c;
                            for(i = 1; i < 5; ++i){
                                c = str.getByte();
                                while((0, _core_utils.isWhiteSpace)(c))c = str.getByte();
                                input[i] = c;
                                if (c === EOF || c === TILDA_CHAR) break;
                            }
                            buffer = this.ensureBuffer(bufferLength + i - 1);
                            this.bufferLength += i - 1;
                            if (i < 5) {
                                for(; i < 5; ++i)input[i] = 117;
                                this.eof = true;
                            }
                            let t = 0;
                            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
                            for(i = 3; i >= 0; --i){
                                buffer[bufferLength + i] = t & 0xff;
                                t >>= 8;
                            }
                        }
                    }
                }
                exports.Ascii85Stream = Ascii85Stream;
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StreamsSequenceStream = exports.DecodeStream = void 0;
                var _base_stream = __w_pdfjs_require__(6);
                var _stream = __w_pdfjs_require__(10);
                const emptyBuffer = new Uint8Array(0);
                class DecodeStream extends _base_stream.BaseStream {
                    constructor(maybeMinBufferLength){
                        super();
                        this._rawMinBufferLength = maybeMinBufferLength || 0;
                        this.pos = 0;
                        this.bufferLength = 0;
                        this.eof = false;
                        this.buffer = emptyBuffer;
                        this.minBufferLength = 512;
                        if (maybeMinBufferLength) while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
                    }
                    get isEmpty() {
                        while(!this.eof && this.bufferLength === 0)this.readBlock();
                        return this.bufferLength === 0;
                    }
                    ensureBuffer(requested) {
                        const buffer = this.buffer;
                        if (requested <= buffer.byteLength) return buffer;
                        let size = this.minBufferLength;
                        while(size < requested)size *= 2;
                        const buffer2 = new Uint8Array(size);
                        buffer2.set(buffer);
                        return this.buffer = buffer2;
                    }
                    getByte() {
                        const pos = this.pos;
                        while(this.bufferLength <= pos){
                            if (this.eof) return -1;
                            this.readBlock();
                        }
                        return this.buffer[this.pos++];
                    }
                    getBytes(length, forceClamped = false) {
                        const pos = this.pos;
                        let end;
                        if (length) {
                            this.ensureBuffer(pos + length);
                            end = pos + length;
                            while(!this.eof && this.bufferLength < end)this.readBlock();
                            const bufEnd = this.bufferLength;
                            if (end > bufEnd) end = bufEnd;
                        } else {
                            while(!this.eof)this.readBlock();
                            end = this.bufferLength;
                        }
                        this.pos = end;
                        const subarray = this.buffer.subarray(pos, end);
                        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
                    }
                    reset() {
                        this.pos = 0;
                    }
                    makeSubStream(start, length, dict = null) {
                        if (length === undefined) while(!this.eof)this.readBlock();
                        else {
                            const end = start + length;
                            while(this.bufferLength <= end && !this.eof)this.readBlock();
                        }
                        return new _stream.Stream(this.buffer, start, length, dict);
                    }
                    getBaseStreams() {
                        return this.str ? this.str.getBaseStreams() : null;
                    }
                }
                exports.DecodeStream = DecodeStream;
                class StreamsSequenceStream extends DecodeStream {
                    constructor(streams){
                        let maybeLength = 0;
                        for (const stream of streams)maybeLength += stream instanceof DecodeStream ? stream._rawMinBufferLength : stream.length;
                        super(maybeLength);
                        this.streams = streams;
                    }
                    readBlock() {
                        const streams = this.streams;
                        if (streams.length === 0) {
                            this.eof = true;
                            return;
                        }
                        const stream = streams.shift();
                        const chunk = stream.getBytes();
                        const bufferLength = this.bufferLength;
                        const newLength = bufferLength + chunk.length;
                        const buffer = this.ensureBuffer(newLength);
                        buffer.set(chunk, bufferLength);
                        this.bufferLength = newLength;
                    }
                    getBaseStreams() {
                        const baseStreamsBuf = [];
                        for (const stream of this.streams){
                            const baseStreams = stream.getBaseStreams();
                            if (baseStreams) baseStreamsBuf.push(...baseStreams);
                        }
                        return baseStreamsBuf.length > 0 ? baseStreamsBuf : null;
                    }
                }
                exports.StreamsSequenceStream = StreamsSequenceStream;
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AsciiHexStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                class AsciiHexStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        if (maybeLength) maybeLength *= 0.5;
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.firstDigit = -1;
                    }
                    readBlock() {
                        const UPSTREAM_BLOCK_SIZE = 8000;
                        const bytes = this.str.getBytes(UPSTREAM_BLOCK_SIZE);
                        if (!bytes.length) {
                            this.eof = true;
                            return;
                        }
                        const maxDecodeLength = bytes.length + 1 >> 1;
                        const buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
                        let bufferLength = this.bufferLength;
                        let firstDigit = this.firstDigit;
                        for (const ch of bytes){
                            let digit;
                            if (ch >= 0x30 && ch <= 0x39) digit = ch & 0x0f;
                            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) digit = (ch & 0x0f) + 9;
                            else if (ch === 0x3e) {
                                this.eof = true;
                                break;
                            } else continue;
                            if (firstDigit < 0) firstDigit = digit;
                            else {
                                buffer[bufferLength++] = firstDigit << 4 | digit;
                                firstDigit = -1;
                            }
                        }
                        if (firstDigit >= 0 && this.eof) {
                            buffer[bufferLength++] = firstDigit << 4;
                            firstDigit = -1;
                        }
                        this.firstDigit = firstDigit;
                        this.bufferLength = bufferLength;
                    }
                }
                exports.AsciiHexStream = AsciiHexStream;
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CCITTFaxStream = void 0;
                var _primitives = __w_pdfjs_require__(5);
                var _ccitt = __w_pdfjs_require__(22);
                var _decode_stream = __w_pdfjs_require__(19);
                class CCITTFaxStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, params){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        if (!(0, _primitives.isDict)(params)) params = _primitives.Dict.empty;
                        const source = {
                            next () {
                                return str.getByte();
                            }
                        };
                        this.ccittFaxDecoder = new _ccitt.CCITTFaxDecoder(source, {
                            K: params.get("K"),
                            EndOfLine: params.get("EndOfLine"),
                            EncodedByteAlign: params.get("EncodedByteAlign"),
                            Columns: params.get("Columns"),
                            Rows: params.get("Rows"),
                            EndOfBlock: params.get("EndOfBlock"),
                            BlackIs1: params.get("BlackIs1")
                        });
                    }
                    readBlock() {
                        while(!this.eof){
                            const c = this.ccittFaxDecoder.readNextChar();
                            if (c === -1) {
                                this.eof = true;
                                return;
                            }
                            this.ensureBuffer(this.bufferLength + 1);
                            this.buffer[this.bufferLength++] = c;
                        }
                    }
                }
                exports.CCITTFaxStream = CCITTFaxStream;
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CCITTFaxDecoder = void 0;
                var _util = __w_pdfjs_require__(2);
                const ccittEOL = -2;
                const ccittEOF = -1;
                const twoDimPass = 0;
                const twoDimHoriz = 1;
                const twoDimVert0 = 2;
                const twoDimVertR1 = 3;
                const twoDimVertL1 = 4;
                const twoDimVertR2 = 5;
                const twoDimVertL2 = 6;
                const twoDimVertR3 = 7;
                const twoDimVertL3 = 8;
                const twoDimTable = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        7,
                        twoDimVertL3
                    ],
                    [
                        7,
                        twoDimVertR3
                    ],
                    [
                        6,
                        twoDimVertL2
                    ],
                    [
                        6,
                        twoDimVertL2
                    ],
                    [
                        6,
                        twoDimVertR2
                    ],
                    [
                        6,
                        twoDimVertR2
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        4,
                        twoDimPass
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimHoriz
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertL1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        3,
                        twoDimVertR1
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ],
                    [
                        1,
                        twoDimVert0
                    ]
                ];
                const whiteTable1 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ]
                ];
                const whiteTable2 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        29
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        30
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        45
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        8,
                        46
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        22
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        7,
                        23
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        47
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        8,
                        48
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        6,
                        13
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        7,
                        20
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        33
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        34
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        35
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        36
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        37
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        8,
                        38
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        7,
                        19
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        31
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        8,
                        32
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        6,
                        12
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        53
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        8,
                        54
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        7,
                        26
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        39
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        40
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        41
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        42
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        43
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        8,
                        44
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        21
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        7,
                        28
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        61
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        62
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        63
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        0
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        320
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        8,
                        384
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        10
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        5,
                        11
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        7,
                        27
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        59
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        8,
                        60
                    ],
                    [
                        9,
                        1472
                    ],
                    [
                        9,
                        1536
                    ],
                    [
                        9,
                        1600
                    ],
                    [
                        9,
                        1728
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        18
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        7,
                        24
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        49
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        50
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        51
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        8,
                        52
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        7,
                        25
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        55
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        56
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        57
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        8,
                        58
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        192
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        6,
                        1664
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        448
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        8,
                        512
                    ],
                    [
                        9,
                        704
                    ],
                    [
                        9,
                        768
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        640
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        8,
                        576
                    ],
                    [
                        9,
                        832
                    ],
                    [
                        9,
                        896
                    ],
                    [
                        9,
                        960
                    ],
                    [
                        9,
                        1024
                    ],
                    [
                        9,
                        1088
                    ],
                    [
                        9,
                        1152
                    ],
                    [
                        9,
                        1216
                    ],
                    [
                        9,
                        1280
                    ],
                    [
                        9,
                        1344
                    ],
                    [
                        9,
                        1408
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        7,
                        256
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        2
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        4,
                        3
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        128
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        8
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        5,
                        9
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        16
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        6,
                        17
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        4
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        14
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        6,
                        15
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        5,
                        64
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ],
                    [
                        4,
                        7
                    ]
                ];
                const blackTable1 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        12,
                        ccittEOL
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        11,
                        1792
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        1984
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2048
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2112
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2176
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2240
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        12,
                        2304
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1856
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        11,
                        1920
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2368
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2432
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2496
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        12,
                        2560
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        10,
                        18
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        12,
                        52
                    ],
                    [
                        13,
                        640
                    ],
                    [
                        13,
                        704
                    ],
                    [
                        13,
                        768
                    ],
                    [
                        13,
                        832
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        55
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        12,
                        56
                    ],
                    [
                        13,
                        1280
                    ],
                    [
                        13,
                        1344
                    ],
                    [
                        13,
                        1408
                    ],
                    [
                        13,
                        1472
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        59
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        12,
                        60
                    ],
                    [
                        13,
                        1536
                    ],
                    [
                        13,
                        1600
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        24
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        11,
                        25
                    ],
                    [
                        13,
                        1664
                    ],
                    [
                        13,
                        1728
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        320
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        384
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        12,
                        448
                    ],
                    [
                        13,
                        512
                    ],
                    [
                        13,
                        576
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        53
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        12,
                        54
                    ],
                    [
                        13,
                        896
                    ],
                    [
                        13,
                        960
                    ],
                    [
                        13,
                        1024
                    ],
                    [
                        13,
                        1088
                    ],
                    [
                        13,
                        1152
                    ],
                    [
                        13,
                        1216
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ],
                    [
                        10,
                        64
                    ]
                ];
                const blackTable2 = [
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        8,
                        13
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        11,
                        23
                    ],
                    [
                        12,
                        50
                    ],
                    [
                        12,
                        51
                    ],
                    [
                        12,
                        44
                    ],
                    [
                        12,
                        45
                    ],
                    [
                        12,
                        46
                    ],
                    [
                        12,
                        47
                    ],
                    [
                        12,
                        57
                    ],
                    [
                        12,
                        58
                    ],
                    [
                        12,
                        61
                    ],
                    [
                        12,
                        256
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        16
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        10,
                        17
                    ],
                    [
                        12,
                        48
                    ],
                    [
                        12,
                        49
                    ],
                    [
                        12,
                        62
                    ],
                    [
                        12,
                        63
                    ],
                    [
                        12,
                        30
                    ],
                    [
                        12,
                        31
                    ],
                    [
                        12,
                        32
                    ],
                    [
                        12,
                        33
                    ],
                    [
                        12,
                        40
                    ],
                    [
                        12,
                        41
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        11,
                        22
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        8,
                        14
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        10
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        7,
                        11
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        9,
                        15
                    ],
                    [
                        12,
                        128
                    ],
                    [
                        12,
                        192
                    ],
                    [
                        12,
                        26
                    ],
                    [
                        12,
                        27
                    ],
                    [
                        12,
                        28
                    ],
                    [
                        12,
                        29
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        19
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        11,
                        20
                    ],
                    [
                        12,
                        34
                    ],
                    [
                        12,
                        35
                    ],
                    [
                        12,
                        36
                    ],
                    [
                        12,
                        37
                    ],
                    [
                        12,
                        38
                    ],
                    [
                        12,
                        39
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        11,
                        21
                    ],
                    [
                        12,
                        42
                    ],
                    [
                        12,
                        43
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        10,
                        0
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ],
                    [
                        7,
                        12
                    ]
                ];
                const blackTable3 = [
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        -1,
                        -1
                    ],
                    [
                        6,
                        9
                    ],
                    [
                        6,
                        8
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        5,
                        7
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        6
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        3,
                        4
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        2,
                        2
                    ]
                ];
                class CCITTFaxDecoder {
                    constructor(source, options = {}){
                        if (!source || typeof source.next !== "function") throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
                        this.source = source;
                        this.eof = false;
                        this.encoding = options.K || 0;
                        this.eoline = options.EndOfLine || false;
                        this.byteAlign = options.EncodedByteAlign || false;
                        this.columns = options.Columns || 1728;
                        this.rows = options.Rows || 0;
                        let eoblock = options.EndOfBlock;
                        if (eoblock === null || eoblock === undefined) eoblock = true;
                        this.eoblock = eoblock;
                        this.black = options.BlackIs1 || false;
                        this.codingLine = new Uint32Array(this.columns + 1);
                        this.refLine = new Uint32Array(this.columns + 2);
                        this.codingLine[0] = this.columns;
                        this.codingPos = 0;
                        this.row = 0;
                        this.nextLine2D = this.encoding < 0;
                        this.inputBits = 0;
                        this.inputBuf = 0;
                        this.outputBits = 0;
                        this.rowsDone = false;
                        let code1;
                        while((code1 = this._lookBits(12)) === 0)this._eatBits(1);
                        if (code1 === 1) this._eatBits(12);
                        if (this.encoding > 0) {
                            this.nextLine2D = !this._lookBits(1);
                            this._eatBits(1);
                        }
                    }
                    readNextChar() {
                        if (this.eof) return -1;
                        const refLine = this.refLine;
                        const codingLine = this.codingLine;
                        const columns = this.columns;
                        let refPos, blackPixels, bits, i;
                        if (this.outputBits === 0) {
                            if (this.rowsDone) this.eof = true;
                            if (this.eof) return -1;
                            this.err = false;
                            let code1, code2, code3;
                            if (this.nextLine2D) {
                                for(i = 0; codingLine[i] < columns; ++i)refLine[i] = codingLine[i];
                                refLine[i++] = columns;
                                refLine[i] = columns;
                                codingLine[0] = 0;
                                this.codingPos = 0;
                                refPos = 0;
                                blackPixels = 0;
                                while(codingLine[this.codingPos] < columns){
                                    code1 = this._getTwoDimCode();
                                    switch(code1){
                                        case twoDimPass:
                                            this._addPixels(refLine[refPos + 1], blackPixels);
                                            if (refLine[refPos + 1] < columns) refPos += 2;
                                            break;
                                        case twoDimHoriz:
                                            code1 = code2 = 0;
                                            if (blackPixels) {
                                                do code1 += code3 = this._getBlackCode();
                                                while (code3 >= 64);
                                                do code2 += code3 = this._getWhiteCode();
                                                while (code3 >= 64);
                                            } else {
                                                do code1 += code3 = this._getWhiteCode();
                                                while (code3 >= 64);
                                                do code2 += code3 = this._getBlackCode();
                                                while (code3 >= 64);
                                            }
                                            this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                                            if (codingLine[this.codingPos] < columns) this._addPixels(codingLine[this.codingPos] + code2, blackPixels ^ 1);
                                            while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            break;
                                        case twoDimVertR3:
                                            this._addPixels(refLine[refPos] + 3, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertR2:
                                            this._addPixels(refLine[refPos] + 2, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertR1:
                                            this._addPixels(refLine[refPos] + 1, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVert0:
                                            this._addPixels(refLine[refPos], blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL3:
                                            this._addPixelsNeg(refLine[refPos] - 3, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL2:
                                            this._addPixelsNeg(refLine[refPos] - 2, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case twoDimVertL1:
                                            this._addPixelsNeg(refLine[refPos] - 1, blackPixels);
                                            blackPixels ^= 1;
                                            if (codingLine[this.codingPos] < columns) {
                                                if (refPos > 0) --refPos;
                                                else ++refPos;
                                                while(refLine[refPos] <= codingLine[this.codingPos] && refLine[refPos] < columns)refPos += 2;
                                            }
                                            break;
                                        case ccittEOF:
                                            this._addPixels(columns, 0);
                                            this.eof = true;
                                            break;
                                        default:
                                            (0, _util.info)("bad 2d code");
                                            this._addPixels(columns, 0);
                                            this.err = true;
                                    }
                                }
                            } else {
                                codingLine[0] = 0;
                                this.codingPos = 0;
                                blackPixels = 0;
                                while(codingLine[this.codingPos] < columns){
                                    code1 = 0;
                                    if (blackPixels) do code1 += code3 = this._getBlackCode();
                                    while (code3 >= 64);
                                    else do code1 += code3 = this._getWhiteCode();
                                    while (code3 >= 64);
                                    this._addPixels(codingLine[this.codingPos] + code1, blackPixels);
                                    blackPixels ^= 1;
                                }
                            }
                            let gotEOL = false;
                            if (this.byteAlign) this.inputBits &= -8;
                            if (!this.eoblock && this.row === this.rows - 1) this.rowsDone = true;
                            else {
                                code1 = this._lookBits(12);
                                if (this.eoline) while(code1 !== ccittEOF && code1 !== 1){
                                    this._eatBits(1);
                                    code1 = this._lookBits(12);
                                }
                                else while(code1 === 0){
                                    this._eatBits(1);
                                    code1 = this._lookBits(12);
                                }
                                if (code1 === 1) {
                                    this._eatBits(12);
                                    gotEOL = true;
                                } else if (code1 === ccittEOF) this.eof = true;
                            }
                            if (!this.eof && this.encoding > 0 && !this.rowsDone) {
                                this.nextLine2D = !this._lookBits(1);
                                this._eatBits(1);
                            }
                            if (this.eoblock && gotEOL && this.byteAlign) {
                                code1 = this._lookBits(12);
                                if (code1 === 1) {
                                    this._eatBits(12);
                                    if (this.encoding > 0) {
                                        this._lookBits(1);
                                        this._eatBits(1);
                                    }
                                    if (this.encoding >= 0) for(i = 0; i < 4; ++i){
                                        code1 = this._lookBits(12);
                                        if (code1 !== 1) (0, _util.info)("bad rtc code: " + code1);
                                        this._eatBits(12);
                                        if (this.encoding > 0) {
                                            this._lookBits(1);
                                            this._eatBits(1);
                                        }
                                    }
                                    this.eof = true;
                                }
                            } else if (this.err && this.eoline) {
                                while(true){
                                    code1 = this._lookBits(13);
                                    if (code1 === ccittEOF) {
                                        this.eof = true;
                                        return -1;
                                    }
                                    if (code1 >> 1 === 1) break;
                                    this._eatBits(1);
                                }
                                this._eatBits(12);
                                if (this.encoding > 0) {
                                    this._eatBits(1);
                                    this.nextLine2D = !(code1 & 1);
                                }
                            }
                            if (codingLine[0] > 0) this.outputBits = codingLine[this.codingPos = 0];
                            else this.outputBits = codingLine[this.codingPos = 1];
                            this.row++;
                        }
                        let c;
                        if (this.outputBits >= 8) {
                            c = this.codingPos & 1 ? 0 : 0xff;
                            this.outputBits -= 8;
                            if (this.outputBits === 0 && codingLine[this.codingPos] < columns) {
                                this.codingPos++;
                                this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                            }
                        } else {
                            bits = 8;
                            c = 0;
                            do if (this.outputBits > bits) {
                                c <<= bits;
                                if (!(this.codingPos & 1)) c |= 0xff >> 8 - bits;
                                this.outputBits -= bits;
                                bits = 0;
                            } else {
                                c <<= this.outputBits;
                                if (!(this.codingPos & 1)) c |= 0xff >> 8 - this.outputBits;
                                bits -= this.outputBits;
                                this.outputBits = 0;
                                if (codingLine[this.codingPos] < columns) {
                                    this.codingPos++;
                                    this.outputBits = codingLine[this.codingPos] - codingLine[this.codingPos - 1];
                                } else if (bits > 0) {
                                    c <<= bits;
                                    bits = 0;
                                }
                            }
                            while (bits);
                        }
                        if (this.black) c ^= 0xff;
                        return c;
                    }
                    _addPixels(a1, blackPixels) {
                        const codingLine = this.codingLine;
                        let codingPos = this.codingPos;
                        if (a1 > codingLine[codingPos]) {
                            if (a1 > this.columns) {
                                (0, _util.info)("row is wrong length");
                                this.err = true;
                                a1 = this.columns;
                            }
                            if (codingPos & 1 ^ blackPixels) ++codingPos;
                            codingLine[codingPos] = a1;
                        }
                        this.codingPos = codingPos;
                    }
                    _addPixelsNeg(a1, blackPixels) {
                        const codingLine = this.codingLine;
                        let codingPos = this.codingPos;
                        if (a1 > codingLine[codingPos]) {
                            if (a1 > this.columns) {
                                (0, _util.info)("row is wrong length");
                                this.err = true;
                                a1 = this.columns;
                            }
                            if (codingPos & 1 ^ blackPixels) ++codingPos;
                            codingLine[codingPos] = a1;
                        } else if (a1 < codingLine[codingPos]) {
                            if (a1 < 0) {
                                (0, _util.info)("invalid code");
                                this.err = true;
                                a1 = 0;
                            }
                            while(codingPos > 0 && a1 < codingLine[codingPos - 1])--codingPos;
                            codingLine[codingPos] = a1;
                        }
                        this.codingPos = codingPos;
                    }
                    _findTableCode(start, end, table, limit) {
                        const limitValue = limit || 0;
                        for(let i = start; i <= end; ++i){
                            let code = this._lookBits(i);
                            if (code === ccittEOF) return [
                                true,
                                1,
                                false
                            ];
                            if (i < end) code <<= end - i;
                            if (!limitValue || code >= limitValue) {
                                const p = table[code - limitValue];
                                if (p[0] === i) {
                                    this._eatBits(i);
                                    return [
                                        true,
                                        p[1],
                                        true
                                    ];
                                }
                            }
                        }
                        return [
                            false,
                            0,
                            false
                        ];
                    }
                    _getTwoDimCode() {
                        let code = 0;
                        let p;
                        if (this.eoblock) {
                            code = this._lookBits(7);
                            p = twoDimTable[code];
                            if (p && p[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            const result = this._findTableCode(1, 7, twoDimTable);
                            if (result[0] && result[2]) return result[1];
                        }
                        (0, _util.info)("Bad two dim code");
                        return ccittEOF;
                    }
                    _getWhiteCode() {
                        let code = 0;
                        let p;
                        if (this.eoblock) {
                            code = this._lookBits(12);
                            if (code === ccittEOF) return 1;
                            if (code >> 5 === 0) p = whiteTable1[code];
                            else p = whiteTable2[code >> 3];
                            if (p[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            let result = this._findTableCode(1, 9, whiteTable2);
                            if (result[0]) return result[1];
                            result = this._findTableCode(11, 12, whiteTable1);
                            if (result[0]) return result[1];
                        }
                        (0, _util.info)("bad white code");
                        this._eatBits(1);
                        return 1;
                    }
                    _getBlackCode() {
                        let code, p;
                        if (this.eoblock) {
                            code = this._lookBits(13);
                            if (code === ccittEOF) return 1;
                            if (code >> 7 === 0) p = blackTable1[code];
                            else if (code >> 9 === 0 && code >> 7 !== 0) p = blackTable2[(code >> 1) - 64];
                            else p = blackTable3[code >> 7];
                            if (p[0] > 0) {
                                this._eatBits(p[0]);
                                return p[1];
                            }
                        } else {
                            let result = this._findTableCode(2, 6, blackTable3);
                            if (result[0]) return result[1];
                            result = this._findTableCode(7, 12, blackTable2, 64);
                            if (result[0]) return result[1];
                            result = this._findTableCode(10, 13, blackTable1);
                            if (result[0]) return result[1];
                        }
                        (0, _util.info)("bad black code");
                        this._eatBits(1);
                        return 1;
                    }
                    _lookBits(n) {
                        let c;
                        while(this.inputBits < n){
                            if ((c = this.source.next()) === -1) {
                                if (this.inputBits === 0) return ccittEOF;
                                return this.inputBuf << n - this.inputBits & 0xffff >> 16 - n;
                            }
                            this.inputBuf = this.inputBuf << 8 | c;
                            this.inputBits += 8;
                        }
                        return this.inputBuf >> this.inputBits - n & 0xffff >> 16 - n;
                    }
                    _eatBits(n) {
                        if ((this.inputBits -= n) < 0) this.inputBits = 0;
                    }
                }
                exports.CCITTFaxDecoder = CCITTFaxDecoder;
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FlateStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                var _util = __w_pdfjs_require__(2);
                const codeLenCodeMap = new Int32Array([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]);
                const lengthDecode = new Int32Array([
                    0x00003,
                    0x00004,
                    0x00005,
                    0x00006,
                    0x00007,
                    0x00008,
                    0x00009,
                    0x0000a,
                    0x1000b,
                    0x1000d,
                    0x1000f,
                    0x10011,
                    0x20013,
                    0x20017,
                    0x2001b,
                    0x2001f,
                    0x30023,
                    0x3002b,
                    0x30033,
                    0x3003b,
                    0x40043,
                    0x40053,
                    0x40063,
                    0x40073,
                    0x50083,
                    0x500a3,
                    0x500c3,
                    0x500e3,
                    0x00102,
                    0x00102,
                    0x00102
                ]);
                const distDecode = new Int32Array([
                    0x00001,
                    0x00002,
                    0x00003,
                    0x00004,
                    0x10005,
                    0x10007,
                    0x20009,
                    0x2000d,
                    0x30011,
                    0x30019,
                    0x40021,
                    0x40031,
                    0x50041,
                    0x50061,
                    0x60081,
                    0x600c1,
                    0x70101,
                    0x70181,
                    0x80201,
                    0x80301,
                    0x90401,
                    0x90601,
                    0xa0801,
                    0xa0c01,
                    0xb1001,
                    0xb1801,
                    0xc2001,
                    0xc3001,
                    0xd4001,
                    0xd6001
                ]);
                const fixedLitCodeTab = [
                    new Int32Array([
                        0x70100,
                        0x80050,
                        0x80010,
                        0x80118,
                        0x70110,
                        0x80070,
                        0x80030,
                        0x900c0,
                        0x70108,
                        0x80060,
                        0x80020,
                        0x900a0,
                        0x80000,
                        0x80080,
                        0x80040,
                        0x900e0,
                        0x70104,
                        0x80058,
                        0x80018,
                        0x90090,
                        0x70114,
                        0x80078,
                        0x80038,
                        0x900d0,
                        0x7010c,
                        0x80068,
                        0x80028,
                        0x900b0,
                        0x80008,
                        0x80088,
                        0x80048,
                        0x900f0,
                        0x70102,
                        0x80054,
                        0x80014,
                        0x8011c,
                        0x70112,
                        0x80074,
                        0x80034,
                        0x900c8,
                        0x7010a,
                        0x80064,
                        0x80024,
                        0x900a8,
                        0x80004,
                        0x80084,
                        0x80044,
                        0x900e8,
                        0x70106,
                        0x8005c,
                        0x8001c,
                        0x90098,
                        0x70116,
                        0x8007c,
                        0x8003c,
                        0x900d8,
                        0x7010e,
                        0x8006c,
                        0x8002c,
                        0x900b8,
                        0x8000c,
                        0x8008c,
                        0x8004c,
                        0x900f8,
                        0x70101,
                        0x80052,
                        0x80012,
                        0x8011a,
                        0x70111,
                        0x80072,
                        0x80032,
                        0x900c4,
                        0x70109,
                        0x80062,
                        0x80022,
                        0x900a4,
                        0x80002,
                        0x80082,
                        0x80042,
                        0x900e4,
                        0x70105,
                        0x8005a,
                        0x8001a,
                        0x90094,
                        0x70115,
                        0x8007a,
                        0x8003a,
                        0x900d4,
                        0x7010d,
                        0x8006a,
                        0x8002a,
                        0x900b4,
                        0x8000a,
                        0x8008a,
                        0x8004a,
                        0x900f4,
                        0x70103,
                        0x80056,
                        0x80016,
                        0x8011e,
                        0x70113,
                        0x80076,
                        0x80036,
                        0x900cc,
                        0x7010b,
                        0x80066,
                        0x80026,
                        0x900ac,
                        0x80006,
                        0x80086,
                        0x80046,
                        0x900ec,
                        0x70107,
                        0x8005e,
                        0x8001e,
                        0x9009c,
                        0x70117,
                        0x8007e,
                        0x8003e,
                        0x900dc,
                        0x7010f,
                        0x8006e,
                        0x8002e,
                        0x900bc,
                        0x8000e,
                        0x8008e,
                        0x8004e,
                        0x900fc,
                        0x70100,
                        0x80051,
                        0x80011,
                        0x80119,
                        0x70110,
                        0x80071,
                        0x80031,
                        0x900c2,
                        0x70108,
                        0x80061,
                        0x80021,
                        0x900a2,
                        0x80001,
                        0x80081,
                        0x80041,
                        0x900e2,
                        0x70104,
                        0x80059,
                        0x80019,
                        0x90092,
                        0x70114,
                        0x80079,
                        0x80039,
                        0x900d2,
                        0x7010c,
                        0x80069,
                        0x80029,
                        0x900b2,
                        0x80009,
                        0x80089,
                        0x80049,
                        0x900f2,
                        0x70102,
                        0x80055,
                        0x80015,
                        0x8011d,
                        0x70112,
                        0x80075,
                        0x80035,
                        0x900ca,
                        0x7010a,
                        0x80065,
                        0x80025,
                        0x900aa,
                        0x80005,
                        0x80085,
                        0x80045,
                        0x900ea,
                        0x70106,
                        0x8005d,
                        0x8001d,
                        0x9009a,
                        0x70116,
                        0x8007d,
                        0x8003d,
                        0x900da,
                        0x7010e,
                        0x8006d,
                        0x8002d,
                        0x900ba,
                        0x8000d,
                        0x8008d,
                        0x8004d,
                        0x900fa,
                        0x70101,
                        0x80053,
                        0x80013,
                        0x8011b,
                        0x70111,
                        0x80073,
                        0x80033,
                        0x900c6,
                        0x70109,
                        0x80063,
                        0x80023,
                        0x900a6,
                        0x80003,
                        0x80083,
                        0x80043,
                        0x900e6,
                        0x70105,
                        0x8005b,
                        0x8001b,
                        0x90096,
                        0x70115,
                        0x8007b,
                        0x8003b,
                        0x900d6,
                        0x7010d,
                        0x8006b,
                        0x8002b,
                        0x900b6,
                        0x8000b,
                        0x8008b,
                        0x8004b,
                        0x900f6,
                        0x70103,
                        0x80057,
                        0x80017,
                        0x8011f,
                        0x70113,
                        0x80077,
                        0x80037,
                        0x900ce,
                        0x7010b,
                        0x80067,
                        0x80027,
                        0x900ae,
                        0x80007,
                        0x80087,
                        0x80047,
                        0x900ee,
                        0x70107,
                        0x8005f,
                        0x8001f,
                        0x9009e,
                        0x70117,
                        0x8007f,
                        0x8003f,
                        0x900de,
                        0x7010f,
                        0x8006f,
                        0x8002f,
                        0x900be,
                        0x8000f,
                        0x8008f,
                        0x8004f,
                        0x900fe,
                        0x70100,
                        0x80050,
                        0x80010,
                        0x80118,
                        0x70110,
                        0x80070,
                        0x80030,
                        0x900c1,
                        0x70108,
                        0x80060,
                        0x80020,
                        0x900a1,
                        0x80000,
                        0x80080,
                        0x80040,
                        0x900e1,
                        0x70104,
                        0x80058,
                        0x80018,
                        0x90091,
                        0x70114,
                        0x80078,
                        0x80038,
                        0x900d1,
                        0x7010c,
                        0x80068,
                        0x80028,
                        0x900b1,
                        0x80008,
                        0x80088,
                        0x80048,
                        0x900f1,
                        0x70102,
                        0x80054,
                        0x80014,
                        0x8011c,
                        0x70112,
                        0x80074,
                        0x80034,
                        0x900c9,
                        0x7010a,
                        0x80064,
                        0x80024,
                        0x900a9,
                        0x80004,
                        0x80084,
                        0x80044,
                        0x900e9,
                        0x70106,
                        0x8005c,
                        0x8001c,
                        0x90099,
                        0x70116,
                        0x8007c,
                        0x8003c,
                        0x900d9,
                        0x7010e,
                        0x8006c,
                        0x8002c,
                        0x900b9,
                        0x8000c,
                        0x8008c,
                        0x8004c,
                        0x900f9,
                        0x70101,
                        0x80052,
                        0x80012,
                        0x8011a,
                        0x70111,
                        0x80072,
                        0x80032,
                        0x900c5,
                        0x70109,
                        0x80062,
                        0x80022,
                        0x900a5,
                        0x80002,
                        0x80082,
                        0x80042,
                        0x900e5,
                        0x70105,
                        0x8005a,
                        0x8001a,
                        0x90095,
                        0x70115,
                        0x8007a,
                        0x8003a,
                        0x900d5,
                        0x7010d,
                        0x8006a,
                        0x8002a,
                        0x900b5,
                        0x8000a,
                        0x8008a,
                        0x8004a,
                        0x900f5,
                        0x70103,
                        0x80056,
                        0x80016,
                        0x8011e,
                        0x70113,
                        0x80076,
                        0x80036,
                        0x900cd,
                        0x7010b,
                        0x80066,
                        0x80026,
                        0x900ad,
                        0x80006,
                        0x80086,
                        0x80046,
                        0x900ed,
                        0x70107,
                        0x8005e,
                        0x8001e,
                        0x9009d,
                        0x70117,
                        0x8007e,
                        0x8003e,
                        0x900dd,
                        0x7010f,
                        0x8006e,
                        0x8002e,
                        0x900bd,
                        0x8000e,
                        0x8008e,
                        0x8004e,
                        0x900fd,
                        0x70100,
                        0x80051,
                        0x80011,
                        0x80119,
                        0x70110,
                        0x80071,
                        0x80031,
                        0x900c3,
                        0x70108,
                        0x80061,
                        0x80021,
                        0x900a3,
                        0x80001,
                        0x80081,
                        0x80041,
                        0x900e3,
                        0x70104,
                        0x80059,
                        0x80019,
                        0x90093,
                        0x70114,
                        0x80079,
                        0x80039,
                        0x900d3,
                        0x7010c,
                        0x80069,
                        0x80029,
                        0x900b3,
                        0x80009,
                        0x80089,
                        0x80049,
                        0x900f3,
                        0x70102,
                        0x80055,
                        0x80015,
                        0x8011d,
                        0x70112,
                        0x80075,
                        0x80035,
                        0x900cb,
                        0x7010a,
                        0x80065,
                        0x80025,
                        0x900ab,
                        0x80005,
                        0x80085,
                        0x80045,
                        0x900eb,
                        0x70106,
                        0x8005d,
                        0x8001d,
                        0x9009b,
                        0x70116,
                        0x8007d,
                        0x8003d,
                        0x900db,
                        0x7010e,
                        0x8006d,
                        0x8002d,
                        0x900bb,
                        0x8000d,
                        0x8008d,
                        0x8004d,
                        0x900fb,
                        0x70101,
                        0x80053,
                        0x80013,
                        0x8011b,
                        0x70111,
                        0x80073,
                        0x80033,
                        0x900c7,
                        0x70109,
                        0x80063,
                        0x80023,
                        0x900a7,
                        0x80003,
                        0x80083,
                        0x80043,
                        0x900e7,
                        0x70105,
                        0x8005b,
                        0x8001b,
                        0x90097,
                        0x70115,
                        0x8007b,
                        0x8003b,
                        0x900d7,
                        0x7010d,
                        0x8006b,
                        0x8002b,
                        0x900b7,
                        0x8000b,
                        0x8008b,
                        0x8004b,
                        0x900f7,
                        0x70103,
                        0x80057,
                        0x80017,
                        0x8011f,
                        0x70113,
                        0x80077,
                        0x80037,
                        0x900cf,
                        0x7010b,
                        0x80067,
                        0x80027,
                        0x900af,
                        0x80007,
                        0x80087,
                        0x80047,
                        0x900ef,
                        0x70107,
                        0x8005f,
                        0x8001f,
                        0x9009f,
                        0x70117,
                        0x8007f,
                        0x8003f,
                        0x900df,
                        0x7010f,
                        0x8006f,
                        0x8002f,
                        0x900bf,
                        0x8000f,
                        0x8008f,
                        0x8004f,
                        0x900ff
                    ]),
                    9
                ];
                const fixedDistCodeTab = [
                    new Int32Array([
                        0x50000,
                        0x50010,
                        0x50008,
                        0x50018,
                        0x50004,
                        0x50014,
                        0x5000c,
                        0x5001c,
                        0x50002,
                        0x50012,
                        0x5000a,
                        0x5001a,
                        0x50006,
                        0x50016,
                        0x5000e,
                        0x00000,
                        0x50001,
                        0x50011,
                        0x50009,
                        0x50019,
                        0x50005,
                        0x50015,
                        0x5000d,
                        0x5001d,
                        0x50003,
                        0x50013,
                        0x5000b,
                        0x5001b,
                        0x50007,
                        0x50017,
                        0x5000f,
                        0x00000
                    ]),
                    5
                ];
                class FlateStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        const cmf = str.getByte();
                        const flg = str.getByte();
                        if (cmf === -1 || flg === -1) throw new _util.FormatError(`Invalid header in flate stream: ${cmf}, ${flg}`);
                        if ((cmf & 0x0f) !== 0x08) throw new _util.FormatError(`Unknown compression method in flate stream: ${cmf}, ${flg}`);
                        if (((cmf << 8) + flg) % 31 !== 0) throw new _util.FormatError(`Bad FCHECK in flate stream: ${cmf}, ${flg}`);
                        if (flg & 0x20) throw new _util.FormatError(`FDICT bit set in flate stream: ${cmf}, ${flg}`);
                        this.codeSize = 0;
                        this.codeBuf = 0;
                    }
                    getBits(bits) {
                        const str = this.str;
                        let codeSize = this.codeSize;
                        let codeBuf = this.codeBuf;
                        let b;
                        while(codeSize < bits){
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad encoding in flate stream");
                            codeBuf |= b << codeSize;
                            codeSize += 8;
                        }
                        b = codeBuf & (1 << bits) - 1;
                        this.codeBuf = codeBuf >> bits;
                        this.codeSize = codeSize -= bits;
                        return b;
                    }
                    getCode(table) {
                        const str = this.str;
                        const codes = table[0];
                        const maxLen = table[1];
                        let codeSize = this.codeSize;
                        let codeBuf = this.codeBuf;
                        let b;
                        while(codeSize < maxLen){
                            if ((b = str.getByte()) === -1) break;
                            codeBuf |= b << codeSize;
                            codeSize += 8;
                        }
                        const code = codes[codeBuf & (1 << maxLen) - 1];
                        const codeLen = code >> 16;
                        const codeVal = code & 0xffff;
                        if (codeLen < 1 || codeSize < codeLen) throw new _util.FormatError("Bad encoding in flate stream");
                        this.codeBuf = codeBuf >> codeLen;
                        this.codeSize = codeSize - codeLen;
                        return codeVal;
                    }
                    generateHuffmanTable(lengths) {
                        const n = lengths.length;
                        let maxLen = 0;
                        let i;
                        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
                        const size = 1 << maxLen;
                        const codes = new Int32Array(size);
                        for(let len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
                            for(let val = 0; val < n; ++val)if (lengths[val] === len) {
                                let code2 = 0;
                                let t = code;
                                for(i = 0; i < len; ++i){
                                    code2 = code2 << 1 | t & 1;
                                    t >>= 1;
                                }
                                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                                ++code;
                            }
                        }
                        return [
                            codes,
                            maxLen
                        ];
                    }
                    readBlock() {
                        let buffer, len;
                        const str = this.str;
                        let hdr = this.getBits(3);
                        if (hdr & 1) this.eof = true;
                        hdr >>= 1;
                        if (hdr === 0) {
                            let b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            let blockLen = b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            blockLen |= b << 8;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            let check = b;
                            if ((b = str.getByte()) === -1) throw new _util.FormatError("Bad block header in flate stream");
                            check |= b << 8;
                            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) throw new _util.FormatError("Bad uncompressed block length in flate stream");
                            this.codeBuf = 0;
                            this.codeSize = 0;
                            const bufferLength = this.bufferLength, end = bufferLength + blockLen;
                            buffer = this.ensureBuffer(end);
                            this.bufferLength = end;
                            if (blockLen === 0) {
                                if (str.peekByte() === -1) this.eof = true;
                            } else {
                                const block = str.getBytes(blockLen);
                                buffer.set(block, bufferLength);
                                if (block.length < blockLen) this.eof = true;
                            }
                            return;
                        }
                        let litCodeTable;
                        let distCodeTable;
                        if (hdr === 1) {
                            litCodeTable = fixedLitCodeTab;
                            distCodeTable = fixedDistCodeTab;
                        } else if (hdr === 2) {
                            const numLitCodes = this.getBits(5) + 257;
                            const numDistCodes = this.getBits(5) + 1;
                            const numCodeLenCodes = this.getBits(4) + 4;
                            const codeLenCodeLengths = new Uint8Array(codeLenCodeMap.length);
                            let i;
                            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[codeLenCodeMap[i]] = this.getBits(3);
                            const codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
                            len = 0;
                            i = 0;
                            const codes = numLitCodes + numDistCodes;
                            const codeLengths = new Uint8Array(codes);
                            let bitsLength, bitsOffset, what;
                            while(i < codes){
                                const code = this.getCode(codeLenCodeTab);
                                if (code === 16) {
                                    bitsLength = 2;
                                    bitsOffset = 3;
                                    what = len;
                                } else if (code === 17) {
                                    bitsLength = 3;
                                    bitsOffset = 3;
                                    what = len = 0;
                                } else if (code === 18) {
                                    bitsLength = 7;
                                    bitsOffset = 11;
                                    what = len = 0;
                                } else {
                                    codeLengths[i++] = len = code;
                                    continue;
                                }
                                let repeatLength = this.getBits(bitsLength) + bitsOffset;
                                while(repeatLength-- > 0)codeLengths[i++] = what;
                            }
                            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
                            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
                        } else throw new _util.FormatError("Unknown block type in flate stream");
                        buffer = this.buffer;
                        let limit = buffer ? buffer.length : 0;
                        let pos = this.bufferLength;
                        while(true){
                            let code1 = this.getCode(litCodeTable);
                            if (code1 < 256) {
                                if (pos + 1 >= limit) {
                                    buffer = this.ensureBuffer(pos + 1);
                                    limit = buffer.length;
                                }
                                buffer[pos++] = code1;
                                continue;
                            }
                            if (code1 === 256) {
                                this.bufferLength = pos;
                                return;
                            }
                            code1 -= 257;
                            code1 = lengthDecode[code1];
                            let code2 = code1 >> 16;
                            if (code2 > 0) code2 = this.getBits(code2);
                            len = (code1 & 0xffff) + code2;
                            code1 = this.getCode(distCodeTable);
                            code1 = distDecode[code1];
                            code2 = code1 >> 16;
                            if (code2 > 0) code2 = this.getBits(code2);
                            const dist = (code1 & 0xffff) + code2;
                            if (pos + len >= limit) {
                                buffer = this.ensureBuffer(pos + len);
                                limit = buffer.length;
                            }
                            for(let k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
                        }
                    }
                }
                exports.FlateStream = FlateStream;
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Jbig2Stream = void 0;
                var _primitives = __w_pdfjs_require__(5);
                var _decode_stream = __w_pdfjs_require__(19);
                var _jbig = __w_pdfjs_require__(25);
                var _util = __w_pdfjs_require__(2);
                class Jbig2Stream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jbig2Image = new _jbig.Jbig2Image();
                        const chunks = [];
                        if ((0, _primitives.isDict)(this.params)) {
                            const globalsStream = this.params.get("JBIG2Globals");
                            if ((0, _primitives.isStream)(globalsStream)) {
                                const globals = globalsStream.getBytes();
                                chunks.push({
                                    data: globals,
                                    start: 0,
                                    end: globals.length
                                });
                            }
                        }
                        chunks.push({
                            data: this.bytes,
                            start: 0,
                            end: this.bytes.length
                        });
                        const data = jbig2Image.parseChunks(chunks);
                        const dataLength = data.length;
                        for(let i = 0; i < dataLength; i++)data[i] ^= 0xff;
                        this.buffer = data;
                        this.bufferLength = dataLength;
                        this.eof = true;
                    }
                }
                exports.Jbig2Stream = Jbig2Stream;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Jbig2Image = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(9);
                var _arithmetic_decoder = __w_pdfjs_require__(26);
                var _ccitt = __w_pdfjs_require__(22);
                class Jbig2Error extends _util.BaseException {
                    constructor(msg){
                        super(`JBIG2 error: ${msg}`);
                    }
                }
                class ContextCache {
                    getContexts(id) {
                        if (id in this) return this[id];
                        return this[id] = new Int8Array(65536);
                    }
                }
                class DecodingContext {
                    constructor(data, start, end){
                        this.data = data;
                        this.start = start;
                        this.end = end;
                    }
                    get decoder() {
                        const decoder = new _arithmetic_decoder.ArithmeticDecoder(this.data, this.start, this.end);
                        return (0, _util.shadow)(this, "decoder", decoder);
                    }
                    get contextCache() {
                        const cache = new ContextCache();
                        return (0, _util.shadow)(this, "contextCache", cache);
                    }
                }
                function decodeInteger(contextCache, procedure, decoder) {
                    const contexts = contextCache.getContexts(procedure);
                    let prev = 1;
                    function readBits(length) {
                        let v = 0;
                        for(let i = 0; i < length; i++){
                            const bit = decoder.readBit(contexts, prev);
                            prev = prev < 256 ? prev << 1 | bit : (prev << 1 | bit) & 511 | 256;
                            v = v << 1 | bit;
                        }
                        return v >>> 0;
                    }
                    const sign = readBits(1);
                    const value = readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(1) ? readBits(32) + 4436 : readBits(12) + 340 : readBits(8) + 84 : readBits(6) + 20 : readBits(4) + 4 : readBits(2);
                    if (sign === 0) return value;
                    else if (value > 0) return -value;
                    return null;
                }
                function decodeIAID(contextCache, decoder, codeLength) {
                    const contexts = contextCache.getContexts("IAID");
                    let prev = 1;
                    for(let i = 0; i < codeLength; i++){
                        const bit = decoder.readBit(contexts, prev);
                        prev = prev << 1 | bit;
                    }
                    if (codeLength < 31) return prev & (1 << codeLength) - 1;
                    return prev & 0x7fffffff;
                }
                const SegmentTypes = [
                    "SymbolDictionary",
                    null,
                    null,
                    null,
                    "IntermediateTextRegion",
                    null,
                    "ImmediateTextRegion",
                    "ImmediateLosslessTextRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "PatternDictionary",
                    null,
                    null,
                    null,
                    "IntermediateHalftoneRegion",
                    null,
                    "ImmediateHalftoneRegion",
                    "ImmediateLosslessHalftoneRegion",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "IntermediateGenericRegion",
                    null,
                    "ImmediateGenericRegion",
                    "ImmediateLosslessGenericRegion",
                    "IntermediateGenericRefinementRegion",
                    null,
                    "ImmediateGenericRefinementRegion",
                    "ImmediateLosslessGenericRefinementRegion",
                    null,
                    null,
                    null,
                    null,
                    "PageInformation",
                    "EndOfPage",
                    "EndOfStripe",
                    "EndOfFile",
                    "Profiles",
                    "Tables",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                    "Extension"
                ];
                const CodingTemplates = [
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: 2,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: 2,
                            y: -1
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -1,
                            y: -2
                        },
                        {
                            x: 0,
                            y: -2
                        },
                        {
                            x: 1,
                            y: -2
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ],
                    [
                        {
                            x: -3,
                            y: -1
                        },
                        {
                            x: -2,
                            y: -1
                        },
                        {
                            x: -1,
                            y: -1
                        },
                        {
                            x: 0,
                            y: -1
                        },
                        {
                            x: 1,
                            y: -1
                        },
                        {
                            x: -4,
                            y: 0
                        },
                        {
                            x: -3,
                            y: 0
                        },
                        {
                            x: -2,
                            y: 0
                        },
                        {
                            x: -1,
                            y: 0
                        }
                    ]
                ];
                const RefinementTemplates = [
                    {
                        coding: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: -1,
                                y: 1
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    },
                    {
                        coding: [
                            {
                                x: -1,
                                y: -1
                            },
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: 1,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            }
                        ],
                        reference: [
                            {
                                x: 0,
                                y: -1
                            },
                            {
                                x: -1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 0
                            },
                            {
                                x: 1,
                                y: 0
                            },
                            {
                                x: 0,
                                y: 1
                            },
                            {
                                x: 1,
                                y: 1
                            }
                        ]
                    }
                ];
                const ReusedContexts = [
                    0x9b25,
                    0x0795,
                    0x00e5,
                    0x0195
                ];
                const RefinementReusedContexts = [
                    0x0020,
                    0x0008
                ];
                function decodeBitmapTemplate0(width, height, decodingContext) {
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GB");
                    const bitmap = [];
                    let contextLabel, i, j, pixel, row, row1, row2;
                    const OLD_PIXEL_MASK = 0x7bf7;
                    for(i = 0; i < height; i++){
                        row = bitmap[i] = new Uint8Array(width);
                        row1 = i < 1 ? row : bitmap[i - 1];
                        row2 = i < 2 ? row : bitmap[i - 2];
                        contextLabel = row2[0] << 13 | row2[1] << 12 | row2[2] << 11 | row1[0] << 7 | row1[1] << 6 | row1[2] << 5 | row1[3] << 4;
                        for(j = 0; j < width; j++){
                            row[j] = pixel = decoder.readBit(contexts, contextLabel);
                            contextLabel = (contextLabel & OLD_PIXEL_MASK) << 1 | (j + 3 < width ? row2[j + 3] << 11 : 0) | (j + 4 < width ? row1[j + 4] << 4 : 0) | pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeBitmap(mmr, width, height, templateIndex, prediction, skip, at, decodingContext) {
                    if (mmr) {
                        const input = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                        return decodeMMRBitmap(input, width, height, false);
                    }
                    if (templateIndex === 0 && !skip && !prediction && at.length === 4 && at[0].x === 3 && at[0].y === -1 && at[1].x === -3 && at[1].y === -1 && at[2].x === 2 && at[2].y === -2 && at[3].x === -2 && at[3].y === -2) return decodeBitmapTemplate0(width, height, decodingContext);
                    const useskip = !!skip;
                    const template = CodingTemplates[templateIndex].concat(at);
                    template.sort(function(a, b) {
                        return a.y - b.y || a.x - b.x;
                    });
                    const templateLength = template.length;
                    const templateX = new Int8Array(templateLength);
                    const templateY = new Int8Array(templateLength);
                    const changingTemplateEntries = [];
                    let reuseMask = 0, minX = 0, maxX = 0, minY = 0;
                    let c, k;
                    for(k = 0; k < templateLength; k++){
                        templateX[k] = template[k].x;
                        templateY[k] = template[k].y;
                        minX = Math.min(minX, template[k].x);
                        maxX = Math.max(maxX, template[k].x);
                        minY = Math.min(minY, template[k].y);
                        if (k < templateLength - 1 && template[k].y === template[k + 1].y && template[k].x === template[k + 1].x - 1) reuseMask |= 1 << templateLength - 1 - k;
                        else changingTemplateEntries.push(k);
                    }
                    const changingEntriesLength = changingTemplateEntries.length;
                    const changingTemplateX = new Int8Array(changingEntriesLength);
                    const changingTemplateY = new Int8Array(changingEntriesLength);
                    const changingTemplateBit = new Uint16Array(changingEntriesLength);
                    for(c = 0; c < changingEntriesLength; c++){
                        k = changingTemplateEntries[c];
                        changingTemplateX[c] = template[k].x;
                        changingTemplateY[c] = template[k].y;
                        changingTemplateBit[c] = 1 << templateLength - 1 - k;
                    }
                    const sbb_left = -minX;
                    const sbb_top = -minY;
                    const sbb_right = width - maxX;
                    const pseudoPixelContext = ReusedContexts[templateIndex];
                    let row = new Uint8Array(width);
                    const bitmap = [];
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GB");
                    let ltp = 0, j, i0, j0, contextLabel = 0, bit, shift;
                    for(let i = 0; i < height; i++){
                        if (prediction) {
                            const sltp = decoder.readBit(contexts, pseudoPixelContext);
                            ltp ^= sltp;
                            if (ltp) {
                                bitmap.push(row);
                                continue;
                            }
                        }
                        row = new Uint8Array(row);
                        bitmap.push(row);
                        for(j = 0; j < width; j++){
                            if (useskip && skip[i][j]) {
                                row[j] = 0;
                                continue;
                            }
                            if (j >= sbb_left && j < sbb_right && i >= sbb_top) {
                                contextLabel = contextLabel << 1 & reuseMask;
                                for(k = 0; k < changingEntriesLength; k++){
                                    i0 = i + changingTemplateY[k];
                                    j0 = j + changingTemplateX[k];
                                    bit = bitmap[i0][j0];
                                    if (bit) {
                                        bit = changingTemplateBit[k];
                                        contextLabel |= bit;
                                    }
                                }
                            } else {
                                contextLabel = 0;
                                shift = templateLength - 1;
                                for(k = 0; k < templateLength; k++, shift--){
                                    j0 = j + templateX[k];
                                    if (j0 >= 0 && j0 < width) {
                                        i0 = i + templateY[k];
                                        if (i0 >= 0) {
                                            bit = bitmap[i0][j0];
                                            if (bit) contextLabel |= bit << shift;
                                        }
                                    }
                                }
                            }
                            const pixel = decoder.readBit(contexts, contextLabel);
                            row[j] = pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeRefinement(width, height, templateIndex, referenceBitmap, offsetX, offsetY, prediction, at, decodingContext) {
                    let codingTemplate = RefinementTemplates[templateIndex].coding;
                    if (templateIndex === 0) codingTemplate = codingTemplate.concat([
                        at[0]
                    ]);
                    const codingTemplateLength = codingTemplate.length;
                    const codingTemplateX = new Int32Array(codingTemplateLength);
                    const codingTemplateY = new Int32Array(codingTemplateLength);
                    let k;
                    for(k = 0; k < codingTemplateLength; k++){
                        codingTemplateX[k] = codingTemplate[k].x;
                        codingTemplateY[k] = codingTemplate[k].y;
                    }
                    let referenceTemplate = RefinementTemplates[templateIndex].reference;
                    if (templateIndex === 0) referenceTemplate = referenceTemplate.concat([
                        at[1]
                    ]);
                    const referenceTemplateLength = referenceTemplate.length;
                    const referenceTemplateX = new Int32Array(referenceTemplateLength);
                    const referenceTemplateY = new Int32Array(referenceTemplateLength);
                    for(k = 0; k < referenceTemplateLength; k++){
                        referenceTemplateX[k] = referenceTemplate[k].x;
                        referenceTemplateY[k] = referenceTemplate[k].y;
                    }
                    const referenceWidth = referenceBitmap[0].length;
                    const referenceHeight = referenceBitmap.length;
                    const pseudoPixelContext = RefinementReusedContexts[templateIndex];
                    const bitmap = [];
                    const decoder = decodingContext.decoder;
                    const contexts = decodingContext.contextCache.getContexts("GR");
                    let ltp = 0;
                    for(let i = 0; i < height; i++){
                        if (prediction) {
                            const sltp = decoder.readBit(contexts, pseudoPixelContext);
                            ltp ^= sltp;
                            if (ltp) throw new Jbig2Error("prediction is not supported");
                        }
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        for(let j = 0; j < width; j++){
                            let i0, j0;
                            let contextLabel = 0;
                            for(k = 0; k < codingTemplateLength; k++){
                                i0 = i + codingTemplateY[k];
                                j0 = j + codingTemplateX[k];
                                if (i0 < 0 || j0 < 0 || j0 >= width) contextLabel <<= 1;
                                else contextLabel = contextLabel << 1 | bitmap[i0][j0];
                            }
                            for(k = 0; k < referenceTemplateLength; k++){
                                i0 = i + referenceTemplateY[k] - offsetY;
                                j0 = j + referenceTemplateX[k] - offsetX;
                                if (i0 < 0 || i0 >= referenceHeight || j0 < 0 || j0 >= referenceWidth) contextLabel <<= 1;
                                else contextLabel = contextLabel << 1 | referenceBitmap[i0][j0];
                            }
                            const pixel = decoder.readBit(contexts, contextLabel);
                            row[j] = pixel;
                        }
                    }
                    return bitmap;
                }
                function decodeSymbolDictionary(huffman, refinement, symbols, numberOfNewSymbols, numberOfExportedSymbols, huffmanTables, templateIndex, at, refinementTemplateIndex, refinementAt, decodingContext, huffmanInput) {
                    if (huffman && refinement) throw new Jbig2Error("symbol refinement with Huffman is not supported");
                    const newSymbols = [];
                    let currentHeight = 0;
                    let symbolCodeLength = (0, _core_utils.log2)(symbols.length + numberOfNewSymbols);
                    const decoder = decodingContext.decoder;
                    const contextCache = decodingContext.contextCache;
                    let tableB1, symbolWidths;
                    if (huffman) {
                        tableB1 = getStandardTable(1);
                        symbolWidths = [];
                        symbolCodeLength = Math.max(symbolCodeLength, 1);
                    }
                    while(newSymbols.length < numberOfNewSymbols){
                        const deltaHeight = huffman ? huffmanTables.tableDeltaHeight.decode(huffmanInput) : decodeInteger(contextCache, "IADH", decoder);
                        currentHeight += deltaHeight;
                        let currentWidth = 0, totalWidth = 0;
                        const firstSymbol = huffman ? symbolWidths.length : 0;
                        while(true){
                            const deltaWidth = huffman ? huffmanTables.tableDeltaWidth.decode(huffmanInput) : decodeInteger(contextCache, "IADW", decoder);
                            if (deltaWidth === null) break;
                            currentWidth += deltaWidth;
                            totalWidth += currentWidth;
                            let bitmap;
                            if (refinement) {
                                const numberOfInstances = decodeInteger(contextCache, "IAAI", decoder);
                                if (numberOfInstances > 1) bitmap = decodeTextRegion(huffman, refinement, currentWidth, currentHeight, 0, numberOfInstances, 1, symbols.concat(newSymbols), symbolCodeLength, 0, 0, 1, 0, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, 0, huffmanInput);
                                else {
                                    const symbolId = decodeIAID(contextCache, decoder, symbolCodeLength);
                                    const rdx = decodeInteger(contextCache, "IARDX", decoder);
                                    const rdy = decodeInteger(contextCache, "IARDY", decoder);
                                    const symbol = symbolId < symbols.length ? symbols[symbolId] : newSymbols[symbolId - symbols.length];
                                    bitmap = decodeRefinement(currentWidth, currentHeight, refinementTemplateIndex, symbol, rdx, rdy, false, refinementAt, decodingContext);
                                }
                                newSymbols.push(bitmap);
                            } else if (huffman) symbolWidths.push(currentWidth);
                            else {
                                bitmap = decodeBitmap(false, currentWidth, currentHeight, templateIndex, false, null, at, decodingContext);
                                newSymbols.push(bitmap);
                            }
                        }
                        if (huffman && !refinement) {
                            const bitmapSize = huffmanTables.tableBitmapSize.decode(huffmanInput);
                            huffmanInput.byteAlign();
                            let collectiveBitmap;
                            if (bitmapSize === 0) collectiveBitmap = readUncompressedBitmap(huffmanInput, totalWidth, currentHeight);
                            else {
                                const originalEnd = huffmanInput.end;
                                const bitmapEnd = huffmanInput.position + bitmapSize;
                                huffmanInput.end = bitmapEnd;
                                collectiveBitmap = decodeMMRBitmap(huffmanInput, totalWidth, currentHeight, false);
                                huffmanInput.end = originalEnd;
                                huffmanInput.position = bitmapEnd;
                            }
                            const numberOfSymbolsDecoded = symbolWidths.length;
                            if (firstSymbol === numberOfSymbolsDecoded - 1) newSymbols.push(collectiveBitmap);
                            else {
                                let i, y, xMin = 0, xMax, bitmapWidth, symbolBitmap;
                                for(i = firstSymbol; i < numberOfSymbolsDecoded; i++){
                                    bitmapWidth = symbolWidths[i];
                                    xMax = xMin + bitmapWidth;
                                    symbolBitmap = [];
                                    for(y = 0; y < currentHeight; y++)symbolBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                                    newSymbols.push(symbolBitmap);
                                    xMin = xMax;
                                }
                            }
                        }
                    }
                    const exportedSymbols = [], flags = [];
                    let currentFlag = false, i, ii;
                    const totalSymbolsLength = symbols.length + numberOfNewSymbols;
                    while(flags.length < totalSymbolsLength){
                        let runLength = huffman ? tableB1.decode(huffmanInput) : decodeInteger(contextCache, "IAEX", decoder);
                        while(runLength--)flags.push(currentFlag);
                        currentFlag = !currentFlag;
                    }
                    for(i = 0, ii = symbols.length; i < ii; i++)if (flags[i]) exportedSymbols.push(symbols[i]);
                    for(let j = 0; j < numberOfNewSymbols; i++, j++)if (flags[i]) exportedSymbols.push(newSymbols[j]);
                    return exportedSymbols;
                }
                function decodeTextRegion(huffman, refinement, width, height, defaultPixelValue, numberOfSymbolInstances, stripSize, inputSymbols, symbolCodeLength, transposed, dsOffset, referenceCorner, combinationOperator, huffmanTables, refinementTemplateIndex, refinementAt, decodingContext, logStripSize, huffmanInput) {
                    if (huffman && refinement) throw new Jbig2Error("refinement with Huffman is not supported");
                    const bitmap = [];
                    let i, row;
                    for(i = 0; i < height; i++){
                        row = new Uint8Array(width);
                        if (defaultPixelValue) for(let j = 0; j < width; j++)row[j] = defaultPixelValue;
                        bitmap.push(row);
                    }
                    const decoder = decodingContext.decoder;
                    const contextCache = decodingContext.contextCache;
                    let stripT = huffman ? -huffmanTables.tableDeltaT.decode(huffmanInput) : -decodeInteger(contextCache, "IADT", decoder);
                    let firstS = 0;
                    i = 0;
                    while(i < numberOfSymbolInstances){
                        const deltaT = huffman ? huffmanTables.tableDeltaT.decode(huffmanInput) : decodeInteger(contextCache, "IADT", decoder);
                        stripT += deltaT;
                        const deltaFirstS = huffman ? huffmanTables.tableFirstS.decode(huffmanInput) : decodeInteger(contextCache, "IAFS", decoder);
                        firstS += deltaFirstS;
                        let currentS = firstS;
                        do {
                            let currentT = 0;
                            if (stripSize > 1) currentT = huffman ? huffmanInput.readBits(logStripSize) : decodeInteger(contextCache, "IAIT", decoder);
                            const t = stripSize * stripT + currentT;
                            const symbolId = huffman ? huffmanTables.symbolIDTable.decode(huffmanInput) : decodeIAID(contextCache, decoder, symbolCodeLength);
                            const applyRefinement = refinement && (huffman ? huffmanInput.readBit() : decodeInteger(contextCache, "IARI", decoder));
                            let symbolBitmap = inputSymbols[symbolId];
                            let symbolWidth = symbolBitmap[0].length;
                            let symbolHeight = symbolBitmap.length;
                            if (applyRefinement) {
                                const rdw = decodeInteger(contextCache, "IARDW", decoder);
                                const rdh = decodeInteger(contextCache, "IARDH", decoder);
                                const rdx = decodeInteger(contextCache, "IARDX", decoder);
                                const rdy = decodeInteger(contextCache, "IARDY", decoder);
                                symbolWidth += rdw;
                                symbolHeight += rdh;
                                symbolBitmap = decodeRefinement(symbolWidth, symbolHeight, refinementTemplateIndex, symbolBitmap, (rdw >> 1) + rdx, (rdh >> 1) + rdy, false, refinementAt, decodingContext);
                            }
                            const offsetT = t - (referenceCorner & 1 ? 0 : symbolHeight - 1);
                            const offsetS = currentS - (referenceCorner & 2 ? symbolWidth - 1 : 0);
                            let s2, t2, symbolRow;
                            if (transposed) {
                                for(s2 = 0; s2 < symbolHeight; s2++){
                                    row = bitmap[offsetS + s2];
                                    if (!row) continue;
                                    symbolRow = symbolBitmap[s2];
                                    const maxWidth = Math.min(width - offsetT, symbolWidth);
                                    switch(combinationOperator){
                                        case 0:
                                            for(t2 = 0; t2 < maxWidth; t2++)row[offsetT + t2] |= symbolRow[t2];
                                            break;
                                        case 2:
                                            for(t2 = 0; t2 < maxWidth; t2++)row[offsetT + t2] ^= symbolRow[t2];
                                            break;
                                        default:
                                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                                    }
                                }
                                currentS += symbolHeight - 1;
                            } else {
                                for(t2 = 0; t2 < symbolHeight; t2++){
                                    row = bitmap[offsetT + t2];
                                    if (!row) continue;
                                    symbolRow = symbolBitmap[t2];
                                    switch(combinationOperator){
                                        case 0:
                                            for(s2 = 0; s2 < symbolWidth; s2++)row[offsetS + s2] |= symbolRow[s2];
                                            break;
                                        case 2:
                                            for(s2 = 0; s2 < symbolWidth; s2++)row[offsetS + s2] ^= symbolRow[s2];
                                            break;
                                        default:
                                            throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                                    }
                                }
                                currentS += symbolWidth - 1;
                            }
                            i++;
                            const deltaS = huffman ? huffmanTables.tableDeltaS.decode(huffmanInput) : decodeInteger(contextCache, "IADS", decoder);
                            if (deltaS === null) break;
                            currentS += deltaS + dsOffset;
                        }while (true);
                    }
                    return bitmap;
                }
                function decodePatternDictionary(mmr, patternWidth, patternHeight, maxPatternIndex, template, decodingContext) {
                    const at = [];
                    if (!mmr) {
                        at.push({
                            x: -patternWidth,
                            y: 0
                        });
                        if (template === 0) at.push({
                            x: -3,
                            y: -1
                        }, {
                            x: 2,
                            y: -2
                        }, {
                            x: -2,
                            y: -2
                        });
                    }
                    const collectiveWidth = (maxPatternIndex + 1) * patternWidth;
                    const collectiveBitmap = decodeBitmap(mmr, collectiveWidth, patternHeight, template, false, null, at, decodingContext);
                    const patterns = [];
                    for(let i = 0; i <= maxPatternIndex; i++){
                        const patternBitmap = [];
                        const xMin = patternWidth * i;
                        const xMax = xMin + patternWidth;
                        for(let y = 0; y < patternHeight; y++)patternBitmap.push(collectiveBitmap[y].subarray(xMin, xMax));
                        patterns.push(patternBitmap);
                    }
                    return patterns;
                }
                function decodeHalftoneRegion(mmr, patterns, template, regionWidth, regionHeight, defaultPixelValue, enableSkip, combinationOperator, gridWidth, gridHeight, gridOffsetX, gridOffsetY, gridVectorX, gridVectorY, decodingContext) {
                    const skip = null;
                    if (enableSkip) throw new Jbig2Error("skip is not supported");
                    if (combinationOperator !== 0) throw new Jbig2Error(`operator "${combinationOperator}" is not supported in halftone region`);
                    const regionBitmap = [];
                    let i, j, row;
                    for(i = 0; i < regionHeight; i++){
                        row = new Uint8Array(regionWidth);
                        if (defaultPixelValue) for(j = 0; j < regionWidth; j++)row[j] = defaultPixelValue;
                        regionBitmap.push(row);
                    }
                    const numberOfPatterns = patterns.length;
                    const pattern0 = patterns[0];
                    const patternWidth = pattern0[0].length, patternHeight = pattern0.length;
                    const bitsPerValue = (0, _core_utils.log2)(numberOfPatterns);
                    const at = [];
                    if (!mmr) {
                        at.push({
                            x: template <= 1 ? 3 : 2,
                            y: -1
                        });
                        if (template === 0) at.push({
                            x: -3,
                            y: -1
                        }, {
                            x: 2,
                            y: -2
                        }, {
                            x: -2,
                            y: -2
                        });
                    }
                    const grayScaleBitPlanes = [];
                    let mmrInput, bitmap;
                    if (mmr) mmrInput = new Reader(decodingContext.data, decodingContext.start, decodingContext.end);
                    for(i = bitsPerValue - 1; i >= 0; i--){
                        if (mmr) bitmap = decodeMMRBitmap(mmrInput, gridWidth, gridHeight, true);
                        else bitmap = decodeBitmap(false, gridWidth, gridHeight, template, false, skip, at, decodingContext);
                        grayScaleBitPlanes[i] = bitmap;
                    }
                    let mg, ng, bit, patternIndex, patternBitmap, x, y, patternRow, regionRow;
                    for(mg = 0; mg < gridHeight; mg++)for(ng = 0; ng < gridWidth; ng++){
                        bit = 0;
                        patternIndex = 0;
                        for(j = bitsPerValue - 1; j >= 0; j--){
                            bit ^= grayScaleBitPlanes[j][mg][ng];
                            patternIndex |= bit << j;
                        }
                        patternBitmap = patterns[patternIndex];
                        x = gridOffsetX + mg * gridVectorY + ng * gridVectorX >> 8;
                        y = gridOffsetY + mg * gridVectorX - ng * gridVectorY >> 8;
                        if (x >= 0 && x + patternWidth <= regionWidth && y >= 0 && y + patternHeight <= regionHeight) for(i = 0; i < patternHeight; i++){
                            regionRow = regionBitmap[y + i];
                            patternRow = patternBitmap[i];
                            for(j = 0; j < patternWidth; j++)regionRow[x + j] |= patternRow[j];
                        }
                        else {
                            let regionX, regionY;
                            for(i = 0; i < patternHeight; i++){
                                regionY = y + i;
                                if (regionY < 0 || regionY >= regionHeight) continue;
                                regionRow = regionBitmap[regionY];
                                patternRow = patternBitmap[i];
                                for(j = 0; j < patternWidth; j++){
                                    regionX = x + j;
                                    if (regionX >= 0 && regionX < regionWidth) regionRow[regionX] |= patternRow[j];
                                }
                            }
                        }
                    }
                    return regionBitmap;
                }
                function readSegmentHeader(data, start) {
                    const segmentHeader = {};
                    segmentHeader.number = (0, _core_utils.readUint32)(data, start);
                    const flags = data[start + 4];
                    const segmentType = flags & 0x3f;
                    if (!SegmentTypes[segmentType]) throw new Jbig2Error("invalid segment type: " + segmentType);
                    segmentHeader.type = segmentType;
                    segmentHeader.typeName = SegmentTypes[segmentType];
                    segmentHeader.deferredNonRetain = !!(flags & 0x80);
                    const pageAssociationFieldSize = !!(flags & 0x40);
                    const referredFlags = data[start + 5];
                    let referredToCount = referredFlags >> 5 & 7;
                    const retainBits = [
                        referredFlags & 31
                    ];
                    let position = start + 6;
                    if (referredFlags === 7) {
                        referredToCount = (0, _core_utils.readUint32)(data, position - 1) & 0x1fffffff;
                        position += 3;
                        let bytes = referredToCount + 7 >> 3;
                        retainBits[0] = data[position++];
                        while(--bytes > 0)retainBits.push(data[position++]);
                    } else if (referredFlags === 5 || referredFlags === 6) throw new Jbig2Error("invalid referred-to flags");
                    segmentHeader.retainBits = retainBits;
                    let referredToSegmentNumberSize = 4;
                    if (segmentHeader.number <= 256) referredToSegmentNumberSize = 1;
                    else if (segmentHeader.number <= 65536) referredToSegmentNumberSize = 2;
                    const referredTo = [];
                    let i, ii;
                    for(i = 0; i < referredToCount; i++){
                        let number;
                        if (referredToSegmentNumberSize === 1) number = data[position];
                        else if (referredToSegmentNumberSize === 2) number = (0, _core_utils.readUint16)(data, position);
                        else number = (0, _core_utils.readUint32)(data, position);
                        referredTo.push(number);
                        position += referredToSegmentNumberSize;
                    }
                    segmentHeader.referredTo = referredTo;
                    if (!pageAssociationFieldSize) segmentHeader.pageAssociation = data[position++];
                    else {
                        segmentHeader.pageAssociation = (0, _core_utils.readUint32)(data, position);
                        position += 4;
                    }
                    segmentHeader.length = (0, _core_utils.readUint32)(data, position);
                    position += 4;
                    if (segmentHeader.length === 0xffffffff) {
                        if (segmentType === 38) {
                            const genericRegionInfo = readRegionSegmentInformation(data, position);
                            const genericRegionSegmentFlags = data[position + RegionSegmentInformationFieldLength];
                            const genericRegionMmr = !!(genericRegionSegmentFlags & 1);
                            const searchPatternLength = 6;
                            const searchPattern = new Uint8Array(searchPatternLength);
                            if (!genericRegionMmr) {
                                searchPattern[0] = 0xff;
                                searchPattern[1] = 0xac;
                            }
                            searchPattern[2] = genericRegionInfo.height >>> 24 & 0xff;
                            searchPattern[3] = genericRegionInfo.height >> 16 & 0xff;
                            searchPattern[4] = genericRegionInfo.height >> 8 & 0xff;
                            searchPattern[5] = genericRegionInfo.height & 0xff;
                            for(i = position, ii = data.length; i < ii; i++){
                                let j = 0;
                                while(j < searchPatternLength && searchPattern[j] === data[i + j])j++;
                                if (j === searchPatternLength) {
                                    segmentHeader.length = i + searchPatternLength;
                                    break;
                                }
                            }
                            if (segmentHeader.length === 0xffffffff) throw new Jbig2Error("segment end was not found");
                        } else throw new Jbig2Error("invalid unknown segment length");
                    }
                    segmentHeader.headerEnd = position;
                    return segmentHeader;
                }
                function readSegments(header, data, start, end) {
                    const segments = [];
                    let position = start;
                    while(position < end){
                        const segmentHeader = readSegmentHeader(data, position);
                        position = segmentHeader.headerEnd;
                        const segment = {
                            header: segmentHeader,
                            data: data
                        };
                        if (!header.randomAccess) {
                            segment.start = position;
                            position += segmentHeader.length;
                            segment.end = position;
                        }
                        segments.push(segment);
                        if (segmentHeader.type === 51) break;
                    }
                    if (header.randomAccess) for(let i = 0, ii = segments.length; i < ii; i++){
                        segments[i].start = position;
                        position += segments[i].header.length;
                        segments[i].end = position;
                    }
                    return segments;
                }
                function readRegionSegmentInformation(data, start) {
                    return {
                        width: (0, _core_utils.readUint32)(data, start),
                        height: (0, _core_utils.readUint32)(data, start + 4),
                        x: (0, _core_utils.readUint32)(data, start + 8),
                        y: (0, _core_utils.readUint32)(data, start + 12),
                        combinationOperator: data[start + 16] & 7
                    };
                }
                const RegionSegmentInformationFieldLength = 17;
                function processSegment(segment, visitor) {
                    const header = segment.header;
                    const data = segment.data, end = segment.end;
                    let position = segment.start;
                    let args, at, i, atLength;
                    switch(header.type){
                        case 0:
                            const dictionary = {};
                            const dictionaryFlags = (0, _core_utils.readUint16)(data, position);
                            dictionary.huffman = !!(dictionaryFlags & 1);
                            dictionary.refinement = !!(dictionaryFlags & 2);
                            dictionary.huffmanDHSelector = dictionaryFlags >> 2 & 3;
                            dictionary.huffmanDWSelector = dictionaryFlags >> 4 & 3;
                            dictionary.bitmapSizeSelector = dictionaryFlags >> 6 & 1;
                            dictionary.aggregationInstancesSelector = dictionaryFlags >> 7 & 1;
                            dictionary.bitmapCodingContextUsed = !!(dictionaryFlags & 256);
                            dictionary.bitmapCodingContextRetained = !!(dictionaryFlags & 512);
                            dictionary.template = dictionaryFlags >> 10 & 3;
                            dictionary.refinementTemplate = dictionaryFlags >> 12 & 1;
                            position += 2;
                            if (!dictionary.huffman) {
                                atLength = dictionary.template === 0 ? 4 : 1;
                                at = [];
                                for(i = 0; i < atLength; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                dictionary.at = at;
                            }
                            if (dictionary.refinement && !dictionary.refinementTemplate) {
                                at = [];
                                for(i = 0; i < 2; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                dictionary.refinementAt = at;
                            }
                            dictionary.numberOfExportedSymbols = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            dictionary.numberOfNewSymbols = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                dictionary,
                                header.number,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 6:
                        case 7:
                            const textRegion = {};
                            textRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const textRegionSegmentFlags = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            textRegion.huffman = !!(textRegionSegmentFlags & 1);
                            textRegion.refinement = !!(textRegionSegmentFlags & 2);
                            textRegion.logStripSize = textRegionSegmentFlags >> 2 & 3;
                            textRegion.stripSize = 1 << textRegion.logStripSize;
                            textRegion.referenceCorner = textRegionSegmentFlags >> 4 & 3;
                            textRegion.transposed = !!(textRegionSegmentFlags & 64);
                            textRegion.combinationOperator = textRegionSegmentFlags >> 7 & 3;
                            textRegion.defaultPixelValue = textRegionSegmentFlags >> 9 & 1;
                            textRegion.dsOffset = textRegionSegmentFlags << 17 >> 27;
                            textRegion.refinementTemplate = textRegionSegmentFlags >> 15 & 1;
                            if (textRegion.huffman) {
                                const textRegionHuffmanFlags = (0, _core_utils.readUint16)(data, position);
                                position += 2;
                                textRegion.huffmanFS = textRegionHuffmanFlags & 3;
                                textRegion.huffmanDS = textRegionHuffmanFlags >> 2 & 3;
                                textRegion.huffmanDT = textRegionHuffmanFlags >> 4 & 3;
                                textRegion.huffmanRefinementDW = textRegionHuffmanFlags >> 6 & 3;
                                textRegion.huffmanRefinementDH = textRegionHuffmanFlags >> 8 & 3;
                                textRegion.huffmanRefinementDX = textRegionHuffmanFlags >> 10 & 3;
                                textRegion.huffmanRefinementDY = textRegionHuffmanFlags >> 12 & 3;
                                textRegion.huffmanRefinementSizeSelector = !!(textRegionHuffmanFlags & 0x4000);
                            }
                            if (textRegion.refinement && !textRegion.refinementTemplate) {
                                at = [];
                                for(i = 0; i < 2; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                textRegion.refinementAt = at;
                            }
                            textRegion.numberOfSymbolInstances = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                textRegion,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 16:
                            const patternDictionary = {};
                            const patternDictionaryFlags = data[position++];
                            patternDictionary.mmr = !!(patternDictionaryFlags & 1);
                            patternDictionary.template = patternDictionaryFlags >> 1 & 3;
                            patternDictionary.patternWidth = data[position++];
                            patternDictionary.patternHeight = data[position++];
                            patternDictionary.maxPatternIndex = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            args = [
                                patternDictionary,
                                header.number,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 22:
                        case 23:
                            const halftoneRegion = {};
                            halftoneRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const halftoneRegionFlags = data[position++];
                            halftoneRegion.mmr = !!(halftoneRegionFlags & 1);
                            halftoneRegion.template = halftoneRegionFlags >> 1 & 3;
                            halftoneRegion.enableSkip = !!(halftoneRegionFlags & 8);
                            halftoneRegion.combinationOperator = halftoneRegionFlags >> 4 & 7;
                            halftoneRegion.defaultPixelValue = halftoneRegionFlags >> 7 & 1;
                            halftoneRegion.gridWidth = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            halftoneRegion.gridHeight = (0, _core_utils.readUint32)(data, position);
                            position += 4;
                            halftoneRegion.gridOffsetX = (0, _core_utils.readUint32)(data, position) & 0xffffffff;
                            position += 4;
                            halftoneRegion.gridOffsetY = (0, _core_utils.readUint32)(data, position) & 0xffffffff;
                            position += 4;
                            halftoneRegion.gridVectorX = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            halftoneRegion.gridVectorY = (0, _core_utils.readUint16)(data, position);
                            position += 2;
                            args = [
                                halftoneRegion,
                                header.referredTo,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 38:
                        case 39:
                            const genericRegion = {};
                            genericRegion.info = readRegionSegmentInformation(data, position);
                            position += RegionSegmentInformationFieldLength;
                            const genericRegionSegmentFlags = data[position++];
                            genericRegion.mmr = !!(genericRegionSegmentFlags & 1);
                            genericRegion.template = genericRegionSegmentFlags >> 1 & 3;
                            genericRegion.prediction = !!(genericRegionSegmentFlags & 8);
                            if (!genericRegion.mmr) {
                                atLength = genericRegion.template === 0 ? 4 : 1;
                                at = [];
                                for(i = 0; i < atLength; i++){
                                    at.push({
                                        x: (0, _core_utils.readInt8)(data, position),
                                        y: (0, _core_utils.readInt8)(data, position + 1)
                                    });
                                    position += 2;
                                }
                                genericRegion.at = at;
                            }
                            args = [
                                genericRegion,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 48:
                            const pageInfo = {
                                width: (0, _core_utils.readUint32)(data, position),
                                height: (0, _core_utils.readUint32)(data, position + 4),
                                resolutionX: (0, _core_utils.readUint32)(data, position + 8),
                                resolutionY: (0, _core_utils.readUint32)(data, position + 12)
                            };
                            if (pageInfo.height === 0xffffffff) delete pageInfo.height;
                            const pageSegmentFlags = data[position + 16];
                            (0, _core_utils.readUint16)(data, position + 17);
                            pageInfo.lossless = !!(pageSegmentFlags & 1);
                            pageInfo.refinement = !!(pageSegmentFlags & 2);
                            pageInfo.defaultPixelValue = pageSegmentFlags >> 2 & 1;
                            pageInfo.combinationOperator = pageSegmentFlags >> 3 & 3;
                            pageInfo.requiresBuffer = !!(pageSegmentFlags & 32);
                            pageInfo.combinationOperatorOverride = !!(pageSegmentFlags & 64);
                            args = [
                                pageInfo
                            ];
                            break;
                        case 49:
                            break;
                        case 50:
                            break;
                        case 51:
                            break;
                        case 53:
                            args = [
                                header.number,
                                data,
                                position,
                                end
                            ];
                            break;
                        case 62:
                            break;
                        default:
                            throw new Jbig2Error(`segment type ${header.typeName}(${header.type})` + " is not implemented");
                    }
                    const callbackName = "on" + header.typeName;
                    if (callbackName in visitor) visitor[callbackName].apply(visitor, args);
                }
                function processSegments(segments, visitor) {
                    for(let i = 0, ii = segments.length; i < ii; i++)processSegment(segments[i], visitor);
                }
                function parseJbig2Chunks(chunks) {
                    const visitor = new SimpleSegmentVisitor();
                    for(let i = 0, ii = chunks.length; i < ii; i++){
                        const chunk = chunks[i];
                        const segments = readSegments({}, chunk.data, chunk.start, chunk.end);
                        processSegments(segments, visitor);
                    }
                    return visitor.buffer;
                }
                function parseJbig2(data) {
                    const end = data.length;
                    let position = 0;
                    if (data[position] !== 0x97 || data[position + 1] !== 0x4a || data[position + 2] !== 0x42 || data[position + 3] !== 0x32 || data[position + 4] !== 0x0d || data[position + 5] !== 0x0a || data[position + 6] !== 0x1a || data[position + 7] !== 0x0a) throw new Jbig2Error("parseJbig2 - invalid header.");
                    const header = Object.create(null);
                    position += 8;
                    const flags = data[position++];
                    header.randomAccess = !(flags & 1);
                    if (!(flags & 2)) {
                        header.numberOfPages = (0, _core_utils.readUint32)(data, position);
                        position += 4;
                    }
                    const segments = readSegments(header, data, position, end);
                    const visitor = new SimpleSegmentVisitor();
                    processSegments(segments, visitor);
                    const { width: width , height: height  } = visitor.currentPageInfo;
                    const bitPacked = visitor.buffer;
                    const imgData = new Uint8ClampedArray(width * height);
                    let q = 0, k = 0;
                    for(let i = 0; i < height; i++){
                        let mask = 0, buffer;
                        for(let j = 0; j < width; j++){
                            if (!mask) {
                                mask = 128;
                                buffer = bitPacked[k++];
                            }
                            imgData[q++] = buffer & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    return {
                        imgData: imgData,
                        width: width,
                        height: height
                    };
                }
                class SimpleSegmentVisitor {
                    onPageInformation(info) {
                        this.currentPageInfo = info;
                        const rowSize = info.width + 7 >> 3;
                        const buffer = new Uint8ClampedArray(rowSize * info.height);
                        if (info.defaultPixelValue) for(let i = 0, ii = buffer.length; i < ii; i++)buffer[i] = 0xff;
                        this.buffer = buffer;
                    }
                    drawBitmap(regionInfo, bitmap) {
                        const pageInfo = this.currentPageInfo;
                        const width = regionInfo.width, height = regionInfo.height;
                        const rowSize = pageInfo.width + 7 >> 3;
                        const combinationOperator = pageInfo.combinationOperatorOverride ? regionInfo.combinationOperator : pageInfo.combinationOperator;
                        const buffer = this.buffer;
                        const mask0 = 128 >> (regionInfo.x & 7);
                        let offset0 = regionInfo.y * rowSize + (regionInfo.x >> 3);
                        let i, j, mask, offset;
                        switch(combinationOperator){
                            case 0:
                                for(i = 0; i < height; i++){
                                    mask = mask0;
                                    offset = offset0;
                                    for(j = 0; j < width; j++){
                                        if (bitmap[i][j]) buffer[offset] |= mask;
                                        mask >>= 1;
                                        if (!mask) {
                                            mask = 128;
                                            offset++;
                                        }
                                    }
                                    offset0 += rowSize;
                                }
                                break;
                            case 2:
                                for(i = 0; i < height; i++){
                                    mask = mask0;
                                    offset = offset0;
                                    for(j = 0; j < width; j++){
                                        if (bitmap[i][j]) buffer[offset] ^= mask;
                                        mask >>= 1;
                                        if (!mask) {
                                            mask = 128;
                                            offset++;
                                        }
                                    }
                                    offset0 += rowSize;
                                }
                                break;
                            default:
                                throw new Jbig2Error(`operator ${combinationOperator} is not supported`);
                        }
                    }
                    onImmediateGenericRegion(region, data, start, end) {
                        const regionInfo = region.info;
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeBitmap(region.mmr, regionInfo.width, regionInfo.height, region.template, region.prediction, null, region.at, decodingContext);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessGenericRegion() {
                        this.onImmediateGenericRegion.apply(this, arguments);
                    }
                    onSymbolDictionary(dictionary, currentSegment, referredSegments, data, start, end) {
                        let huffmanTables, huffmanInput;
                        if (dictionary.huffman) {
                            huffmanTables = getSymbolDictionaryHuffmanTables(dictionary, referredSegments, this.customTables);
                            huffmanInput = new Reader(data, start, end);
                        }
                        let symbols = this.symbols;
                        if (!symbols) this.symbols = symbols = {};
                        let inputSymbols = [];
                        for(let i = 0, ii = referredSegments.length; i < ii; i++){
                            const referredSymbols = symbols[referredSegments[i]];
                            if (referredSymbols) inputSymbols = inputSymbols.concat(referredSymbols);
                        }
                        const decodingContext = new DecodingContext(data, start, end);
                        symbols[currentSegment] = decodeSymbolDictionary(dictionary.huffman, dictionary.refinement, inputSymbols, dictionary.numberOfNewSymbols, dictionary.numberOfExportedSymbols, huffmanTables, dictionary.template, dictionary.at, dictionary.refinementTemplate, dictionary.refinementAt, decodingContext, huffmanInput);
                    }
                    onImmediateTextRegion(region, referredSegments, data, start, end) {
                        const regionInfo = region.info;
                        let huffmanTables, huffmanInput;
                        const symbols = this.symbols;
                        let inputSymbols = [];
                        for(let i = 0, ii = referredSegments.length; i < ii; i++){
                            const referredSymbols = symbols[referredSegments[i]];
                            if (referredSymbols) inputSymbols = inputSymbols.concat(referredSymbols);
                        }
                        const symbolCodeLength = (0, _core_utils.log2)(inputSymbols.length);
                        if (region.huffman) {
                            huffmanInput = new Reader(data, start, end);
                            huffmanTables = getTextRegionHuffmanTables(region, referredSegments, this.customTables, inputSymbols.length, huffmanInput);
                        }
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeTextRegion(region.huffman, region.refinement, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.numberOfSymbolInstances, region.stripSize, inputSymbols, symbolCodeLength, region.transposed, region.dsOffset, region.referenceCorner, region.combinationOperator, huffmanTables, region.refinementTemplate, region.refinementAt, decodingContext, region.logStripSize, huffmanInput);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessTextRegion() {
                        this.onImmediateTextRegion.apply(this, arguments);
                    }
                    onPatternDictionary(dictionary, currentSegment, data, start, end) {
                        let patterns = this.patterns;
                        if (!patterns) this.patterns = patterns = {};
                        const decodingContext = new DecodingContext(data, start, end);
                        patterns[currentSegment] = decodePatternDictionary(dictionary.mmr, dictionary.patternWidth, dictionary.patternHeight, dictionary.maxPatternIndex, dictionary.template, decodingContext);
                    }
                    onImmediateHalftoneRegion(region, referredSegments, data, start, end) {
                        const patterns = this.patterns[referredSegments[0]];
                        const regionInfo = region.info;
                        const decodingContext = new DecodingContext(data, start, end);
                        const bitmap = decodeHalftoneRegion(region.mmr, patterns, region.template, regionInfo.width, regionInfo.height, region.defaultPixelValue, region.enableSkip, region.combinationOperator, region.gridWidth, region.gridHeight, region.gridOffsetX, region.gridOffsetY, region.gridVectorX, region.gridVectorY, decodingContext);
                        this.drawBitmap(regionInfo, bitmap);
                    }
                    onImmediateLosslessHalftoneRegion() {
                        this.onImmediateHalftoneRegion.apply(this, arguments);
                    }
                    onTables(currentSegment, data, start, end) {
                        let customTables = this.customTables;
                        if (!customTables) this.customTables = customTables = {};
                        customTables[currentSegment] = decodeTablesSegment(data, start, end);
                    }
                }
                class HuffmanLine {
                    constructor(lineData){
                        if (lineData.length === 2) {
                            this.isOOB = true;
                            this.rangeLow = 0;
                            this.prefixLength = lineData[0];
                            this.rangeLength = 0;
                            this.prefixCode = lineData[1];
                            this.isLowerRange = false;
                        } else {
                            this.isOOB = false;
                            this.rangeLow = lineData[0];
                            this.prefixLength = lineData[1];
                            this.rangeLength = lineData[2];
                            this.prefixCode = lineData[3];
                            this.isLowerRange = lineData[4] === "lower";
                        }
                    }
                }
                class HuffmanTreeNode {
                    constructor(line){
                        this.children = [];
                        if (line) {
                            this.isLeaf = true;
                            this.rangeLength = line.rangeLength;
                            this.rangeLow = line.rangeLow;
                            this.isLowerRange = line.isLowerRange;
                            this.isOOB = line.isOOB;
                        } else this.isLeaf = false;
                    }
                    buildTree(line, shift) {
                        const bit = line.prefixCode >> shift & 1;
                        if (shift <= 0) this.children[bit] = new HuffmanTreeNode(line);
                        else {
                            let node = this.children[bit];
                            if (!node) this.children[bit] = node = new HuffmanTreeNode(null);
                            node.buildTree(line, shift - 1);
                        }
                    }
                    decodeNode(reader) {
                        if (this.isLeaf) {
                            if (this.isOOB) return null;
                            const htOffset = reader.readBits(this.rangeLength);
                            return this.rangeLow + (this.isLowerRange ? -htOffset : htOffset);
                        }
                        const node = this.children[reader.readBit()];
                        if (!node) throw new Jbig2Error("invalid Huffman data");
                        return node.decodeNode(reader);
                    }
                }
                class HuffmanTable {
                    constructor(lines, prefixCodesDone){
                        if (!prefixCodesDone) this.assignPrefixCodes(lines);
                        this.rootNode = new HuffmanTreeNode(null);
                        for(let i = 0, ii = lines.length; i < ii; i++){
                            const line = lines[i];
                            if (line.prefixLength > 0) this.rootNode.buildTree(line, line.prefixLength - 1);
                        }
                    }
                    decode(reader) {
                        return this.rootNode.decodeNode(reader);
                    }
                    assignPrefixCodes(lines) {
                        const linesLength = lines.length;
                        let prefixLengthMax = 0;
                        for(let i = 0; i < linesLength; i++)prefixLengthMax = Math.max(prefixLengthMax, lines[i].prefixLength);
                        const histogram = new Uint32Array(prefixLengthMax + 1);
                        for(let i = 0; i < linesLength; i++)histogram[lines[i].prefixLength]++;
                        let currentLength = 1, firstCode = 0, currentCode, currentTemp, line;
                        histogram[0] = 0;
                        while(currentLength <= prefixLengthMax){
                            firstCode = firstCode + histogram[currentLength - 1] << 1;
                            currentCode = firstCode;
                            currentTemp = 0;
                            while(currentTemp < linesLength){
                                line = lines[currentTemp];
                                if (line.prefixLength === currentLength) {
                                    line.prefixCode = currentCode;
                                    currentCode++;
                                }
                                currentTemp++;
                            }
                            currentLength++;
                        }
                    }
                }
                function decodeTablesSegment(data, start, end) {
                    const flags = data[start];
                    const lowestValue = (0, _core_utils.readUint32)(data, start + 1) & 0xffffffff;
                    const highestValue = (0, _core_utils.readUint32)(data, start + 5) & 0xffffffff;
                    const reader = new Reader(data, start + 9, end);
                    const prefixSizeBits = (flags >> 1 & 7) + 1;
                    const rangeSizeBits = (flags >> 4 & 7) + 1;
                    const lines = [];
                    let prefixLength, rangeLength, currentRangeLow = lowestValue;
                    do {
                        prefixLength = reader.readBits(prefixSizeBits);
                        rangeLength = reader.readBits(rangeSizeBits);
                        lines.push(new HuffmanLine([
                            currentRangeLow,
                            prefixLength,
                            rangeLength,
                            0
                        ]));
                        currentRangeLow += 1 << rangeLength;
                    }while (currentRangeLow < highestValue);
                    prefixLength = reader.readBits(prefixSizeBits);
                    lines.push(new HuffmanLine([
                        lowestValue - 1,
                        prefixLength,
                        32,
                        0,
                        "lower"
                    ]));
                    prefixLength = reader.readBits(prefixSizeBits);
                    lines.push(new HuffmanLine([
                        highestValue,
                        prefixLength,
                        32,
                        0
                    ]));
                    if (flags & 1) {
                        prefixLength = reader.readBits(prefixSizeBits);
                        lines.push(new HuffmanLine([
                            prefixLength,
                            0
                        ]));
                    }
                    return new HuffmanTable(lines, false);
                }
                const standardTablesCache = {};
                function getStandardTable(number) {
                    let table = standardTablesCache[number];
                    if (table) return table;
                    let lines;
                    switch(number){
                        case 1:
                            lines = [
                                [
                                    0,
                                    1,
                                    4,
                                    0x0
                                ],
                                [
                                    16,
                                    2,
                                    8,
                                    0x2
                                ],
                                [
                                    272,
                                    3,
                                    16,
                                    0x6
                                ],
                                [
                                    65808,
                                    3,
                                    32,
                                    0x7
                                ]
                            ];
                            break;
                        case 2:
                            lines = [
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    75,
                                    6,
                                    32,
                                    0x3e
                                ],
                                [
                                    6,
                                    0x3f
                                ]
                            ];
                            break;
                        case 3:
                            lines = [
                                [
                                    -256,
                                    8,
                                    8,
                                    0xfe
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    3,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    11,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    -257,
                                    8,
                                    32,
                                    0xff,
                                    "lower"
                                ],
                                [
                                    75,
                                    7,
                                    32,
                                    0x7e
                                ],
                                [
                                    6,
                                    0x3e
                                ]
                            ];
                            break;
                        case 4:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    76,
                                    5,
                                    32,
                                    0x1f
                                ]
                            ];
                            break;
                        case 5:
                            lines = [
                                [
                                    -255,
                                    7,
                                    8,
                                    0x7e
                                ],
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    4,
                                    4,
                                    3,
                                    0xe
                                ],
                                [
                                    12,
                                    5,
                                    6,
                                    0x1e
                                ],
                                [
                                    -256,
                                    7,
                                    32,
                                    0x7f,
                                    "lower"
                                ],
                                [
                                    76,
                                    6,
                                    32,
                                    0x3e
                                ]
                            ];
                            break;
                        case 6:
                            lines = [
                                [
                                    -2048,
                                    5,
                                    10,
                                    0x1c
                                ],
                                [
                                    -1024,
                                    4,
                                    9,
                                    0x8
                                ],
                                [
                                    -512,
                                    4,
                                    8,
                                    0x9
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    0xa
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    0x1d
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    0x1e
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    0,
                                    2,
                                    7,
                                    0x0
                                ],
                                [
                                    128,
                                    3,
                                    7,
                                    0x2
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    0x3
                                ],
                                [
                                    512,
                                    4,
                                    9,
                                    0xc
                                ],
                                [
                                    1024,
                                    4,
                                    10,
                                    0xd
                                ],
                                [
                                    -2049,
                                    6,
                                    32,
                                    0x3e,
                                    "lower"
                                ],
                                [
                                    2048,
                                    6,
                                    32,
                                    0x3f
                                ]
                            ];
                            break;
                        case 7:
                            lines = [
                                [
                                    -1024,
                                    4,
                                    9,
                                    0x8
                                ],
                                [
                                    -512,
                                    3,
                                    8,
                                    0x0
                                ],
                                [
                                    -256,
                                    4,
                                    7,
                                    0x9
                                ],
                                [
                                    -128,
                                    5,
                                    6,
                                    0x1a
                                ],
                                [
                                    -64,
                                    5,
                                    5,
                                    0x1b
                                ],
                                [
                                    -32,
                                    4,
                                    5,
                                    0xa
                                ],
                                [
                                    0,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    32,
                                    5,
                                    5,
                                    0x1c
                                ],
                                [
                                    64,
                                    5,
                                    6,
                                    0x1d
                                ],
                                [
                                    128,
                                    4,
                                    7,
                                    0xc
                                ],
                                [
                                    256,
                                    3,
                                    8,
                                    0x1
                                ],
                                [
                                    512,
                                    3,
                                    9,
                                    0x2
                                ],
                                [
                                    1024,
                                    3,
                                    10,
                                    0x3
                                ],
                                [
                                    -1025,
                                    5,
                                    32,
                                    0x1e,
                                    "lower"
                                ],
                                [
                                    2048,
                                    5,
                                    32,
                                    0x1f
                                ]
                            ];
                            break;
                        case 8:
                            lines = [
                                [
                                    -15,
                                    8,
                                    3,
                                    0xfc
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    0x1fc
                                ],
                                [
                                    -5,
                                    8,
                                    1,
                                    0xfd
                                ],
                                [
                                    -3,
                                    9,
                                    0,
                                    0x1fd
                                ],
                                [
                                    -2,
                                    7,
                                    0,
                                    0x7c
                                ],
                                [
                                    -1,
                                    4,
                                    0,
                                    0xa
                                ],
                                [
                                    0,
                                    2,
                                    1,
                                    0x0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    0x1a
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    0x3a
                                ],
                                [
                                    4,
                                    3,
                                    4,
                                    0x4
                                ],
                                [
                                    20,
                                    6,
                                    1,
                                    0x3b
                                ],
                                [
                                    22,
                                    4,
                                    4,
                                    0xb
                                ],
                                [
                                    38,
                                    4,
                                    5,
                                    0xc
                                ],
                                [
                                    70,
                                    5,
                                    6,
                                    0x1b
                                ],
                                [
                                    134,
                                    5,
                                    7,
                                    0x1c
                                ],
                                [
                                    262,
                                    6,
                                    7,
                                    0x3c
                                ],
                                [
                                    390,
                                    7,
                                    8,
                                    0x7d
                                ],
                                [
                                    646,
                                    6,
                                    10,
                                    0x3d
                                ],
                                [
                                    -16,
                                    9,
                                    32,
                                    0x1fe,
                                    "lower"
                                ],
                                [
                                    1670,
                                    9,
                                    32,
                                    0x1ff
                                ],
                                [
                                    2,
                                    0x1
                                ]
                            ];
                            break;
                        case 9:
                            lines = [
                                [
                                    -31,
                                    8,
                                    4,
                                    0xfc
                                ],
                                [
                                    -15,
                                    9,
                                    2,
                                    0x1fc
                                ],
                                [
                                    -11,
                                    8,
                                    2,
                                    0xfd
                                ],
                                [
                                    -7,
                                    9,
                                    1,
                                    0x1fd
                                ],
                                [
                                    -5,
                                    7,
                                    1,
                                    0x7c
                                ],
                                [
                                    -3,
                                    4,
                                    1,
                                    0xa
                                ],
                                [
                                    -1,
                                    3,
                                    1,
                                    0x2
                                ],
                                [
                                    1,
                                    3,
                                    1,
                                    0x3
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    0x1a
                                ],
                                [
                                    5,
                                    6,
                                    1,
                                    0x3a
                                ],
                                [
                                    7,
                                    3,
                                    5,
                                    0x4
                                ],
                                [
                                    39,
                                    6,
                                    2,
                                    0x3b
                                ],
                                [
                                    43,
                                    4,
                                    5,
                                    0xb
                                ],
                                [
                                    75,
                                    4,
                                    6,
                                    0xc
                                ],
                                [
                                    139,
                                    5,
                                    7,
                                    0x1b
                                ],
                                [
                                    267,
                                    5,
                                    8,
                                    0x1c
                                ],
                                [
                                    523,
                                    6,
                                    8,
                                    0x3c
                                ],
                                [
                                    779,
                                    7,
                                    9,
                                    0x7d
                                ],
                                [
                                    1291,
                                    6,
                                    11,
                                    0x3d
                                ],
                                [
                                    -32,
                                    9,
                                    32,
                                    0x1fe,
                                    "lower"
                                ],
                                [
                                    3339,
                                    9,
                                    32,
                                    0x1ff
                                ],
                                [
                                    2,
                                    0x0
                                ]
                            ];
                            break;
                        case 10:
                            lines = [
                                [
                                    -21,
                                    7,
                                    4,
                                    0x7a
                                ],
                                [
                                    -5,
                                    8,
                                    0,
                                    0xfc
                                ],
                                [
                                    -4,
                                    7,
                                    0,
                                    0x7b
                                ],
                                [
                                    -3,
                                    5,
                                    0,
                                    0x18
                                ],
                                [
                                    -2,
                                    2,
                                    2,
                                    0x0
                                ],
                                [
                                    2,
                                    5,
                                    0,
                                    0x19
                                ],
                                [
                                    3,
                                    6,
                                    0,
                                    0x36
                                ],
                                [
                                    4,
                                    7,
                                    0,
                                    0x7c
                                ],
                                [
                                    5,
                                    8,
                                    0,
                                    0xfd
                                ],
                                [
                                    6,
                                    2,
                                    6,
                                    0x1
                                ],
                                [
                                    70,
                                    5,
                                    5,
                                    0x1a
                                ],
                                [
                                    102,
                                    6,
                                    5,
                                    0x37
                                ],
                                [
                                    134,
                                    6,
                                    6,
                                    0x38
                                ],
                                [
                                    198,
                                    6,
                                    7,
                                    0x39
                                ],
                                [
                                    326,
                                    6,
                                    8,
                                    0x3a
                                ],
                                [
                                    582,
                                    6,
                                    9,
                                    0x3b
                                ],
                                [
                                    1094,
                                    6,
                                    10,
                                    0x3c
                                ],
                                [
                                    2118,
                                    7,
                                    11,
                                    0x7d
                                ],
                                [
                                    -22,
                                    8,
                                    32,
                                    0xfe,
                                    "lower"
                                ],
                                [
                                    4166,
                                    8,
                                    32,
                                    0xff
                                ],
                                [
                                    2,
                                    0x2
                                ]
                            ];
                            break;
                        case 11:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    1,
                                    0x2
                                ],
                                [
                                    4,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    0xd
                                ],
                                [
                                    7,
                                    5,
                                    1,
                                    0x1c
                                ],
                                [
                                    9,
                                    5,
                                    2,
                                    0x1d
                                ],
                                [
                                    13,
                                    6,
                                    2,
                                    0x3c
                                ],
                                [
                                    17,
                                    7,
                                    2,
                                    0x7a
                                ],
                                [
                                    21,
                                    7,
                                    3,
                                    0x7b
                                ],
                                [
                                    29,
                                    7,
                                    4,
                                    0x7c
                                ],
                                [
                                    45,
                                    7,
                                    5,
                                    0x7d
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    0x7e
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        case 12:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    2,
                                    0,
                                    0x2
                                ],
                                [
                                    3,
                                    3,
                                    1,
                                    0x6
                                ],
                                [
                                    5,
                                    5,
                                    0,
                                    0x1c
                                ],
                                [
                                    6,
                                    5,
                                    1,
                                    0x1d
                                ],
                                [
                                    8,
                                    6,
                                    1,
                                    0x3c
                                ],
                                [
                                    10,
                                    7,
                                    0,
                                    0x7a
                                ],
                                [
                                    11,
                                    7,
                                    1,
                                    0x7b
                                ],
                                [
                                    13,
                                    7,
                                    2,
                                    0x7c
                                ],
                                [
                                    17,
                                    7,
                                    3,
                                    0x7d
                                ],
                                [
                                    25,
                                    7,
                                    4,
                                    0x7e
                                ],
                                [
                                    41,
                                    8,
                                    5,
                                    0xfe
                                ],
                                [
                                    73,
                                    8,
                                    32,
                                    0xff
                                ]
                            ];
                            break;
                        case 13:
                            lines = [
                                [
                                    1,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    3,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    4,
                                    5,
                                    0,
                                    0x1c
                                ],
                                [
                                    5,
                                    4,
                                    1,
                                    0xd
                                ],
                                [
                                    7,
                                    3,
                                    3,
                                    0x5
                                ],
                                [
                                    15,
                                    6,
                                    1,
                                    0x3a
                                ],
                                [
                                    17,
                                    6,
                                    2,
                                    0x3b
                                ],
                                [
                                    21,
                                    6,
                                    3,
                                    0x3c
                                ],
                                [
                                    29,
                                    6,
                                    4,
                                    0x3d
                                ],
                                [
                                    45,
                                    6,
                                    5,
                                    0x3e
                                ],
                                [
                                    77,
                                    7,
                                    6,
                                    0x7e
                                ],
                                [
                                    141,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        case 14:
                            lines = [
                                [
                                    -2,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    0x5
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    0x6
                                ],
                                [
                                    2,
                                    3,
                                    0,
                                    0x7
                                ]
                            ];
                            break;
                        case 15:
                            lines = [
                                [
                                    -24,
                                    7,
                                    4,
                                    0x7c
                                ],
                                [
                                    -8,
                                    6,
                                    2,
                                    0x3c
                                ],
                                [
                                    -4,
                                    5,
                                    1,
                                    0x1c
                                ],
                                [
                                    -2,
                                    4,
                                    0,
                                    0xc
                                ],
                                [
                                    -1,
                                    3,
                                    0,
                                    0x4
                                ],
                                [
                                    0,
                                    1,
                                    0,
                                    0x0
                                ],
                                [
                                    1,
                                    3,
                                    0,
                                    0x5
                                ],
                                [
                                    2,
                                    4,
                                    0,
                                    0xd
                                ],
                                [
                                    3,
                                    5,
                                    1,
                                    0x1d
                                ],
                                [
                                    5,
                                    6,
                                    2,
                                    0x3d
                                ],
                                [
                                    9,
                                    7,
                                    4,
                                    0x7d
                                ],
                                [
                                    -25,
                                    7,
                                    32,
                                    0x7e,
                                    "lower"
                                ],
                                [
                                    25,
                                    7,
                                    32,
                                    0x7f
                                ]
                            ];
                            break;
                        default:
                            throw new Jbig2Error(`standard table B.${number} does not exist`);
                    }
                    for(let i = 0, ii = lines.length; i < ii; i++)lines[i] = new HuffmanLine(lines[i]);
                    table = new HuffmanTable(lines, true);
                    standardTablesCache[number] = table;
                    return table;
                }
                class Reader {
                    constructor(data, start, end){
                        this.data = data;
                        this.start = start;
                        this.end = end;
                        this.position = start;
                        this.shift = -1;
                        this.currentByte = 0;
                    }
                    readBit() {
                        if (this.shift < 0) {
                            if (this.position >= this.end) throw new Jbig2Error("end of data while reading bit");
                            this.currentByte = this.data[this.position++];
                            this.shift = 7;
                        }
                        const bit = this.currentByte >> this.shift & 1;
                        this.shift--;
                        return bit;
                    }
                    readBits(numBits) {
                        let result = 0, i;
                        for(i = numBits - 1; i >= 0; i--)result |= this.readBit() << i;
                        return result;
                    }
                    byteAlign() {
                        this.shift = -1;
                    }
                    next() {
                        if (this.position >= this.end) return -1;
                        return this.data[this.position++];
                    }
                }
                function getCustomHuffmanTable(index, referredTo, customTables) {
                    let currentIndex = 0;
                    for(let i = 0, ii = referredTo.length; i < ii; i++){
                        const table = customTables[referredTo[i]];
                        if (table) {
                            if (index === currentIndex) return table;
                            currentIndex++;
                        }
                    }
                    throw new Jbig2Error("can't find custom Huffman table");
                }
                function getTextRegionHuffmanTables(textRegion, referredTo, customTables, numberOfSymbols, reader) {
                    const codes = [];
                    for(let i = 0; i <= 34; i++){
                        const codeLength = reader.readBits(4);
                        codes.push(new HuffmanLine([
                            i,
                            codeLength,
                            0,
                            0
                        ]));
                    }
                    const runCodesTable = new HuffmanTable(codes, false);
                    codes.length = 0;
                    for(let i = 0; i < numberOfSymbols;){
                        const codeLength = runCodesTable.decode(reader);
                        if (codeLength >= 32) {
                            let repeatedLength, numberOfRepeats, j;
                            switch(codeLength){
                                case 32:
                                    if (i === 0) throw new Jbig2Error("no previous value in symbol ID table");
                                    numberOfRepeats = reader.readBits(2) + 3;
                                    repeatedLength = codes[i - 1].prefixLength;
                                    break;
                                case 33:
                                    numberOfRepeats = reader.readBits(3) + 3;
                                    repeatedLength = 0;
                                    break;
                                case 34:
                                    numberOfRepeats = reader.readBits(7) + 11;
                                    repeatedLength = 0;
                                    break;
                                default:
                                    throw new Jbig2Error("invalid code length in symbol ID table");
                            }
                            for(j = 0; j < numberOfRepeats; j++){
                                codes.push(new HuffmanLine([
                                    i,
                                    repeatedLength,
                                    0,
                                    0
                                ]));
                                i++;
                            }
                        } else {
                            codes.push(new HuffmanLine([
                                i,
                                codeLength,
                                0,
                                0
                            ]));
                            i++;
                        }
                    }
                    reader.byteAlign();
                    const symbolIDTable = new HuffmanTable(codes, false);
                    let customIndex = 0, tableFirstS, tableDeltaS, tableDeltaT;
                    switch(textRegion.huffmanFS){
                        case 0:
                        case 1:
                            tableFirstS = getStandardTable(textRegion.huffmanFS + 6);
                            break;
                        case 3:
                            tableFirstS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman FS selector");
                    }
                    switch(textRegion.huffmanDS){
                        case 0:
                        case 1:
                        case 2:
                            tableDeltaS = getStandardTable(textRegion.huffmanDS + 8);
                            break;
                        case 3:
                            tableDeltaS = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DS selector");
                    }
                    switch(textRegion.huffmanDT){
                        case 0:
                        case 1:
                        case 2:
                            tableDeltaT = getStandardTable(textRegion.huffmanDT + 11);
                            break;
                        case 3:
                            tableDeltaT = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DT selector");
                    }
                    if (textRegion.refinement) throw new Jbig2Error("refinement with Huffman is not supported");
                    return {
                        symbolIDTable: symbolIDTable,
                        tableFirstS: tableFirstS,
                        tableDeltaS: tableDeltaS,
                        tableDeltaT: tableDeltaT
                    };
                }
                function getSymbolDictionaryHuffmanTables(dictionary, referredTo, customTables) {
                    let customIndex = 0, tableDeltaHeight, tableDeltaWidth;
                    switch(dictionary.huffmanDHSelector){
                        case 0:
                        case 1:
                            tableDeltaHeight = getStandardTable(dictionary.huffmanDHSelector + 4);
                            break;
                        case 3:
                            tableDeltaHeight = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DH selector");
                    }
                    switch(dictionary.huffmanDWSelector){
                        case 0:
                        case 1:
                            tableDeltaWidth = getStandardTable(dictionary.huffmanDWSelector + 2);
                            break;
                        case 3:
                            tableDeltaWidth = getCustomHuffmanTable(customIndex, referredTo, customTables);
                            customIndex++;
                            break;
                        default:
                            throw new Jbig2Error("invalid Huffman DW selector");
                    }
                    let tableBitmapSize, tableAggregateInstances;
                    if (dictionary.bitmapSizeSelector) {
                        tableBitmapSize = getCustomHuffmanTable(customIndex, referredTo, customTables);
                        customIndex++;
                    } else tableBitmapSize = getStandardTable(1);
                    if (dictionary.aggregationInstancesSelector) tableAggregateInstances = getCustomHuffmanTable(customIndex, referredTo, customTables);
                    else tableAggregateInstances = getStandardTable(1);
                    return {
                        tableDeltaHeight: tableDeltaHeight,
                        tableDeltaWidth: tableDeltaWidth,
                        tableBitmapSize: tableBitmapSize,
                        tableAggregateInstances: tableAggregateInstances
                    };
                }
                function readUncompressedBitmap(reader, width, height) {
                    const bitmap = [];
                    for(let y = 0; y < height; y++){
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        for(let x = 0; x < width; x++)row[x] = reader.readBit();
                        reader.byteAlign();
                    }
                    return bitmap;
                }
                function decodeMMRBitmap(input, width, height, endOfBlock) {
                    const params = {
                        K: -1,
                        Columns: width,
                        Rows: height,
                        BlackIs1: true,
                        EndOfBlock: endOfBlock
                    };
                    const decoder = new _ccitt.CCITTFaxDecoder(input, params);
                    const bitmap = [];
                    let currentByte, eof = false;
                    for(let y = 0; y < height; y++){
                        const row = new Uint8Array(width);
                        bitmap.push(row);
                        let shift = -1;
                        for(let x = 0; x < width; x++){
                            if (shift < 0) {
                                currentByte = decoder.readNextChar();
                                if (currentByte === -1) {
                                    currentByte = 0;
                                    eof = true;
                                }
                                shift = 7;
                            }
                            row[x] = currentByte >> shift & 1;
                            shift--;
                        }
                    }
                    if (endOfBlock && !eof) {
                        const lookForEOFLimit = 5;
                        for(let i = 0; i < lookForEOFLimit; i++){
                            if (decoder.readNextChar() === -1) break;
                        }
                    }
                    return bitmap;
                }
                class Jbig2Image {
                    parseChunks(chunks) {
                        return parseJbig2Chunks(chunks);
                    }
                    parse(data) {
                        const { imgData: imgData , width: width , height: height  } = parseJbig2(data);
                        this.width = width;
                        this.height = height;
                        return imgData;
                    }
                }
                exports.Jbig2Image = Jbig2Image;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ArithmeticDecoder = void 0;
                const QeTable = [
                    {
                        qe: 0x5601,
                        nmps: 1,
                        nlps: 1,
                        switchFlag: 1
                    },
                    {
                        qe: 0x3401,
                        nmps: 2,
                        nlps: 6,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1801,
                        nmps: 3,
                        nlps: 9,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0ac1,
                        nmps: 4,
                        nlps: 12,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0521,
                        nmps: 5,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0221,
                        nmps: 38,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 7,
                        nlps: 6,
                        switchFlag: 1
                    },
                    {
                        qe: 0x5401,
                        nmps: 8,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x4801,
                        nmps: 9,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3801,
                        nmps: 10,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3001,
                        nmps: 11,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2401,
                        nmps: 12,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1c01,
                        nmps: 13,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1601,
                        nmps: 29,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 15,
                        nlps: 14,
                        switchFlag: 1
                    },
                    {
                        qe: 0x5401,
                        nmps: 16,
                        nlps: 14,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5101,
                        nmps: 17,
                        nlps: 15,
                        switchFlag: 0
                    },
                    {
                        qe: 0x4801,
                        nmps: 18,
                        nlps: 16,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3801,
                        nmps: 19,
                        nlps: 17,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3401,
                        nmps: 20,
                        nlps: 18,
                        switchFlag: 0
                    },
                    {
                        qe: 0x3001,
                        nmps: 21,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2801,
                        nmps: 22,
                        nlps: 19,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2401,
                        nmps: 23,
                        nlps: 20,
                        switchFlag: 0
                    },
                    {
                        qe: 0x2201,
                        nmps: 24,
                        nlps: 21,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1c01,
                        nmps: 25,
                        nlps: 22,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1801,
                        nmps: 26,
                        nlps: 23,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1601,
                        nmps: 27,
                        nlps: 24,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1401,
                        nmps: 28,
                        nlps: 25,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1201,
                        nmps: 29,
                        nlps: 26,
                        switchFlag: 0
                    },
                    {
                        qe: 0x1101,
                        nmps: 30,
                        nlps: 27,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0ac1,
                        nmps: 31,
                        nlps: 28,
                        switchFlag: 0
                    },
                    {
                        qe: 0x09c1,
                        nmps: 32,
                        nlps: 29,
                        switchFlag: 0
                    },
                    {
                        qe: 0x08a1,
                        nmps: 33,
                        nlps: 30,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0521,
                        nmps: 34,
                        nlps: 31,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0441,
                        nmps: 35,
                        nlps: 32,
                        switchFlag: 0
                    },
                    {
                        qe: 0x02a1,
                        nmps: 36,
                        nlps: 33,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0221,
                        nmps: 37,
                        nlps: 34,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0141,
                        nmps: 38,
                        nlps: 35,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0111,
                        nmps: 39,
                        nlps: 36,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0085,
                        nmps: 40,
                        nlps: 37,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0049,
                        nmps: 41,
                        nlps: 38,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0025,
                        nmps: 42,
                        nlps: 39,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0015,
                        nmps: 43,
                        nlps: 40,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0009,
                        nmps: 44,
                        nlps: 41,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0005,
                        nmps: 45,
                        nlps: 42,
                        switchFlag: 0
                    },
                    {
                        qe: 0x0001,
                        nmps: 45,
                        nlps: 43,
                        switchFlag: 0
                    },
                    {
                        qe: 0x5601,
                        nmps: 46,
                        nlps: 46,
                        switchFlag: 0
                    }
                ];
                class ArithmeticDecoder {
                    constructor(data, start, end){
                        this.data = data;
                        this.bp = start;
                        this.dataEnd = end;
                        this.chigh = data[start];
                        this.clow = 0;
                        this.byteIn();
                        this.chigh = this.chigh << 7 & 0xffff | this.clow >> 9 & 0x7f;
                        this.clow = this.clow << 7 & 0xffff;
                        this.ct -= 7;
                        this.a = 0x8000;
                    }
                    byteIn() {
                        const data = this.data;
                        let bp = this.bp;
                        if (data[bp] === 0xff) {
                            if (data[bp + 1] > 0x8f) {
                                this.clow += 0xff00;
                                this.ct = 8;
                            } else {
                                bp++;
                                this.clow += data[bp] << 9;
                                this.ct = 7;
                                this.bp = bp;
                            }
                        } else {
                            bp++;
                            this.clow += bp < this.dataEnd ? data[bp] << 8 : 0xff00;
                            this.ct = 8;
                            this.bp = bp;
                        }
                        if (this.clow > 0xffff) {
                            this.chigh += this.clow >> 16;
                            this.clow &= 0xffff;
                        }
                    }
                    readBit(contexts, pos) {
                        let cx_index = contexts[pos] >> 1, cx_mps = contexts[pos] & 1;
                        const qeTableIcx = QeTable[cx_index];
                        const qeIcx = qeTableIcx.qe;
                        let d;
                        let a = this.a - qeIcx;
                        if (this.chigh < qeIcx) {
                            if (a < qeIcx) {
                                a = qeIcx;
                                d = cx_mps;
                                cx_index = qeTableIcx.nmps;
                            } else {
                                a = qeIcx;
                                d = 1 ^ cx_mps;
                                if (qeTableIcx.switchFlag === 1) cx_mps = d;
                                cx_index = qeTableIcx.nlps;
                            }
                        } else {
                            this.chigh -= qeIcx;
                            if ((a & 0x8000) !== 0) {
                                this.a = a;
                                return cx_mps;
                            }
                            if (a < qeIcx) {
                                d = 1 ^ cx_mps;
                                if (qeTableIcx.switchFlag === 1) cx_mps = d;
                                cx_index = qeTableIcx.nlps;
                            } else {
                                d = cx_mps;
                                cx_index = qeTableIcx.nmps;
                            }
                        }
                        do {
                            if (this.ct === 0) this.byteIn();
                            a <<= 1;
                            this.chigh = this.chigh << 1 & 0xffff | this.clow >> 15 & 1;
                            this.clow = this.clow << 1 & 0xffff;
                            this.ct--;
                        }while ((a & 0x8000) === 0);
                        this.a = a;
                        contexts[pos] = cx_index << 1 | cx_mps;
                        return d;
                    }
                }
                exports.ArithmeticDecoder = ArithmeticDecoder;
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpegStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                var _primitives = __w_pdfjs_require__(5);
                var _jpg = __w_pdfjs_require__(28);
                var _util = __w_pdfjs_require__(2);
                class JpegStream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        let ch;
                        while((ch = stream.getByte()) !== -1)if (ch === 0xff) {
                            stream.skip(-1);
                            break;
                        }
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jpegOptions = {
                            decodeTransform: undefined,
                            colorTransform: undefined
                        };
                        const decodeArr = this.dict.getArray("Decode", "D");
                        if (this.forceRGB && Array.isArray(decodeArr)) {
                            const bitsPerComponent = this.dict.get("BitsPerComponent") || 8;
                            const decodeArrLength = decodeArr.length;
                            const transform = new Int32Array(decodeArrLength);
                            let transformNeeded = false;
                            const maxValue = (1 << bitsPerComponent) - 1;
                            for(let i = 0; i < decodeArrLength; i += 2){
                                transform[i] = (decodeArr[i + 1] - decodeArr[i]) * 256 | 0;
                                transform[i + 1] = decodeArr[i] * maxValue | 0;
                                if (transform[i] !== 256 || transform[i + 1] !== 0) transformNeeded = true;
                            }
                            if (transformNeeded) jpegOptions.decodeTransform = transform;
                        }
                        if ((0, _primitives.isDict)(this.params)) {
                            const colorTransform = this.params.get("ColorTransform");
                            if (Number.isInteger(colorTransform)) jpegOptions.colorTransform = colorTransform;
                        }
                        const jpegImage = new _jpg.JpegImage(jpegOptions);
                        jpegImage.parse(this.bytes);
                        const data = jpegImage.getData({
                            width: this.drawWidth,
                            height: this.drawHeight,
                            forceRGB: this.forceRGB,
                            isSourcePDF: true
                        });
                        this.buffer = data;
                        this.bufferLength = data.length;
                        this.eof = true;
                    }
                }
                exports.JpegStream = JpegStream;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpegImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(9);
                class JpegError extends _util.BaseException {
                    constructor(msg){
                        super(`JPEG error: ${msg}`);
                    }
                }
                class DNLMarkerError extends _util.BaseException {
                    constructor(message, scanLines){
                        super(message);
                        this.scanLines = scanLines;
                    }
                }
                class EOIMarkerError extends _util.BaseException {
                }
                const dctZigZag = new Uint8Array([
                    0,
                    1,
                    8,
                    16,
                    9,
                    2,
                    3,
                    10,
                    17,
                    24,
                    32,
                    25,
                    18,
                    11,
                    4,
                    5,
                    12,
                    19,
                    26,
                    33,
                    40,
                    48,
                    41,
                    34,
                    27,
                    20,
                    13,
                    6,
                    7,
                    14,
                    21,
                    28,
                    35,
                    42,
                    49,
                    56,
                    57,
                    50,
                    43,
                    36,
                    29,
                    22,
                    15,
                    23,
                    30,
                    37,
                    44,
                    51,
                    58,
                    59,
                    52,
                    45,
                    38,
                    31,
                    39,
                    46,
                    53,
                    60,
                    61,
                    54,
                    47,
                    55,
                    62,
                    63
                ]);
                const dctCos1 = 4017;
                const dctSin1 = 799;
                const dctCos3 = 3406;
                const dctSin3 = 2276;
                const dctCos6 = 1567;
                const dctSin6 = 3784;
                const dctSqrt2 = 5793;
                const dctSqrt1d2 = 2896;
                function buildHuffmanTable(codeLengths, values) {
                    let k = 0, i, j, length = 16;
                    while(length > 0 && !codeLengths[length - 1])length--;
                    const code = [
                        {
                            children: [],
                            index: 0
                        }
                    ];
                    let p = code[0], q;
                    for(i = 0; i < length; i++){
                        for(j = 0; j < codeLengths[i]; j++){
                            p = code.pop();
                            p.children[p.index] = values[k];
                            while(p.index > 0)p = code.pop();
                            p.index++;
                            code.push(p);
                            while(code.length <= i){
                                code.push(q = {
                                    children: [],
                                    index: 0
                                });
                                p.children[p.index] = q.children;
                                p = q;
                            }
                            k++;
                        }
                        if (i + 1 < length) {
                            code.push(q = {
                                children: [],
                                index: 0
                            });
                            p.children[p.index] = q.children;
                            p = q;
                        }
                    }
                    return code[0].children;
                }
                function getBlockBufferOffset(component, row, col) {
                    return 64 * ((component.blocksPerLine + 1) * row + col);
                }
                function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive, parseDNLMarker = false) {
                    const mcusPerLine = frame.mcusPerLine;
                    const progressive = frame.progressive;
                    const startOffset = offset;
                    let bitsData = 0, bitsCount = 0;
                    function readBit() {
                        if (bitsCount > 0) {
                            bitsCount--;
                            return bitsData >> bitsCount & 1;
                        }
                        bitsData = data[offset++];
                        if (bitsData === 0xff) {
                            const nextByte = data[offset++];
                            if (nextByte) {
                                if (nextByte === 0xdc && parseDNLMarker) {
                                    offset += 2;
                                    const scanLines = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    if (scanLines > 0 && scanLines !== frame.scanLines) throw new DNLMarkerError("Found DNL marker (0xFFDC) while parsing scan data", scanLines);
                                } else if (nextByte === 0xd9) {
                                    if (parseDNLMarker) {
                                        const maybeScanLines = blockRow * (frame.precision === 8 ? 8 : 0);
                                        if (maybeScanLines > 0 && Math.round(frame.scanLines / maybeScanLines) >= 10) throw new DNLMarkerError("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", maybeScanLines);
                                    }
                                    throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
                                }
                                throw new JpegError(`unexpected marker ${(bitsData << 8 | nextByte).toString(16)}`);
                            }
                        }
                        bitsCount = 7;
                        return bitsData >>> 7;
                    }
                    function decodeHuffman(tree) {
                        let node = tree;
                        while(true){
                            node = node[readBit()];
                            switch(typeof node){
                                case "number":
                                    return node;
                                case "object":
                                    continue;
                            }
                            throw new JpegError("invalid huffman sequence");
                        }
                    }
                    function receive(length) {
                        let n = 0;
                        while(length > 0){
                            n = n << 1 | readBit();
                            length--;
                        }
                        return n;
                    }
                    function receiveAndExtend(length) {
                        if (length === 1) return readBit() === 1 ? 1 : -1;
                        const n = receive(length);
                        if (n >= 1 << length - 1) return n;
                        return n + (-1 << length) + 1;
                    }
                    function decodeBaseline(component, blockOffset) {
                        const t = decodeHuffman(component.huffmanTableDC);
                        const diff = t === 0 ? 0 : receiveAndExtend(t);
                        component.blockData[blockOffset] = component.pred += diff;
                        let k = 1;
                        while(k < 64){
                            const rs = decodeHuffman(component.huffmanTableAC);
                            const s = rs & 15, r = rs >> 4;
                            if (s === 0) {
                                if (r < 15) break;
                                k += 16;
                                continue;
                            }
                            k += r;
                            const z = dctZigZag[k];
                            component.blockData[blockOffset + z] = receiveAndExtend(s);
                            k++;
                        }
                    }
                    function decodeDCFirst(component, blockOffset) {
                        const t = decodeHuffman(component.huffmanTableDC);
                        const diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
                        component.blockData[blockOffset] = component.pred += diff;
                    }
                    function decodeDCSuccessive(component, blockOffset) {
                        component.blockData[blockOffset] |= readBit() << successive;
                    }
                    let eobrun = 0;
                    function decodeACFirst(component, blockOffset) {
                        if (eobrun > 0) {
                            eobrun--;
                            return;
                        }
                        let k = spectralStart;
                        const e = spectralEnd;
                        while(k <= e){
                            const rs = decodeHuffman(component.huffmanTableAC);
                            const s = rs & 15, r = rs >> 4;
                            if (s === 0) {
                                if (r < 15) {
                                    eobrun = receive(r) + (1 << r) - 1;
                                    break;
                                }
                                k += 16;
                                continue;
                            }
                            k += r;
                            const z = dctZigZag[k];
                            component.blockData[blockOffset + z] = receiveAndExtend(s) * (1 << successive);
                            k++;
                        }
                    }
                    let successiveACState = 0, successiveACNextValue;
                    function decodeACSuccessive(component, blockOffset) {
                        let k = spectralStart;
                        const e = spectralEnd;
                        let r = 0;
                        let s;
                        let rs;
                        while(k <= e){
                            const offsetZ = blockOffset + dctZigZag[k];
                            const sign = component.blockData[offsetZ] < 0 ? -1 : 1;
                            switch(successiveACState){
                                case 0:
                                    rs = decodeHuffman(component.huffmanTableAC);
                                    s = rs & 15;
                                    r = rs >> 4;
                                    if (s === 0) {
                                        if (r < 15) {
                                            eobrun = receive(r) + (1 << r);
                                            successiveACState = 4;
                                        } else {
                                            r = 16;
                                            successiveACState = 1;
                                        }
                                    } else {
                                        if (s !== 1) throw new JpegError("invalid ACn encoding");
                                        successiveACNextValue = receiveAndExtend(s);
                                        successiveACState = r ? 2 : 3;
                                    }
                                    continue;
                                case 1:
                                case 2:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    else {
                                        r--;
                                        if (r === 0) successiveACState = successiveACState === 2 ? 3 : 0;
                                    }
                                    break;
                                case 3:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    else {
                                        component.blockData[offsetZ] = successiveACNextValue << successive;
                                        successiveACState = 0;
                                    }
                                    break;
                                case 4:
                                    if (component.blockData[offsetZ]) component.blockData[offsetZ] += sign * (readBit() << successive);
                                    break;
                            }
                            k++;
                        }
                        if (successiveACState === 4) {
                            eobrun--;
                            if (eobrun === 0) successiveACState = 0;
                        }
                    }
                    let blockRow = 0;
                    function decodeMcu(component, decode, mcu, row, col) {
                        const mcuRow = mcu / mcusPerLine | 0;
                        const mcuCol = mcu % mcusPerLine;
                        blockRow = mcuRow * component.v + row;
                        const blockCol = mcuCol * component.h + col;
                        const blockOffset = getBlockBufferOffset(component, blockRow, blockCol);
                        decode(component, blockOffset);
                    }
                    function decodeBlock(component, decode, mcu) {
                        blockRow = mcu / component.blocksPerLine | 0;
                        const blockCol = mcu % component.blocksPerLine;
                        const blockOffset = getBlockBufferOffset(component, blockRow, blockCol);
                        decode(component, blockOffset);
                    }
                    const componentsLength = components.length;
                    let component, i, j, k, n;
                    let decodeFn;
                    if (progressive) {
                        if (spectralStart === 0) decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
                        else decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
                    } else decodeFn = decodeBaseline;
                    let mcu = 0, fileMarker;
                    let mcuExpected;
                    if (componentsLength === 1) mcuExpected = components[0].blocksPerLine * components[0].blocksPerColumn;
                    else mcuExpected = mcusPerLine * frame.mcusPerColumn;
                    let h, v;
                    while(mcu <= mcuExpected){
                        const mcuToRead = resetInterval ? Math.min(mcuExpected - mcu, resetInterval) : mcuExpected;
                        if (mcuToRead > 0) {
                            for(i = 0; i < componentsLength; i++)components[i].pred = 0;
                            eobrun = 0;
                            if (componentsLength === 1) {
                                component = components[0];
                                for(n = 0; n < mcuToRead; n++){
                                    decodeBlock(component, decodeFn, mcu);
                                    mcu++;
                                }
                            } else for(n = 0; n < mcuToRead; n++){
                                for(i = 0; i < componentsLength; i++){
                                    component = components[i];
                                    h = component.h;
                                    v = component.v;
                                    for(j = 0; j < v; j++)for(k = 0; k < h; k++)decodeMcu(component, decodeFn, mcu, j, k);
                                }
                                mcu++;
                            }
                        }
                        bitsCount = 0;
                        fileMarker = findNextFileMarker(data, offset);
                        if (!fileMarker) break;
                        if (fileMarker.invalid) {
                            const partialMsg = mcuToRead > 0 ? "unexpected" : "excessive";
                            (0, _util.warn)(`decodeScan - ${partialMsg} MCU data, current marker is: ${fileMarker.invalid}`);
                            offset = fileMarker.offset;
                        }
                        if (fileMarker.marker >= 0xffd0 && fileMarker.marker <= 0xffd7) offset += 2;
                        else break;
                    }
                    return offset - startOffset;
                }
                function quantizeAndInverse(component, blockBufferOffset, p) {
                    const qt = component.quantizationTable, blockData = component.blockData;
                    let v0, v1, v2, v3, v4, v5, v6, v7;
                    let p0, p1, p2, p3, p4, p5, p6, p7;
                    let t;
                    if (!qt) throw new JpegError("missing required Quantization Table.");
                    for(let row = 0; row < 64; row += 8){
                        p0 = blockData[blockBufferOffset + row];
                        p1 = blockData[blockBufferOffset + row + 1];
                        p2 = blockData[blockBufferOffset + row + 2];
                        p3 = blockData[blockBufferOffset + row + 3];
                        p4 = blockData[blockBufferOffset + row + 4];
                        p5 = blockData[blockBufferOffset + row + 5];
                        p6 = blockData[blockBufferOffset + row + 6];
                        p7 = blockData[blockBufferOffset + row + 7];
                        p0 *= qt[row];
                        if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                            t = dctSqrt2 * p0 + 512 >> 10;
                            p[row] = t;
                            p[row + 1] = t;
                            p[row + 2] = t;
                            p[row + 3] = t;
                            p[row + 4] = t;
                            p[row + 5] = t;
                            p[row + 6] = t;
                            p[row + 7] = t;
                            continue;
                        }
                        p1 *= qt[row + 1];
                        p2 *= qt[row + 2];
                        p3 *= qt[row + 3];
                        p4 *= qt[row + 4];
                        p5 *= qt[row + 5];
                        p6 *= qt[row + 6];
                        p7 *= qt[row + 7];
                        v0 = dctSqrt2 * p0 + 128 >> 8;
                        v1 = dctSqrt2 * p4 + 128 >> 8;
                        v2 = p2;
                        v3 = p6;
                        v4 = dctSqrt1d2 * (p1 - p7) + 128 >> 8;
                        v7 = dctSqrt1d2 * (p1 + p7) + 128 >> 8;
                        v5 = p3 << 4;
                        v6 = p5 << 4;
                        v0 = v0 + v1 + 1 >> 1;
                        v1 = v0 - v1;
                        t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
                        v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
                        v3 = t;
                        v4 = v4 + v6 + 1 >> 1;
                        v6 = v4 - v6;
                        v7 = v7 + v5 + 1 >> 1;
                        v5 = v7 - v5;
                        v0 = v0 + v3 + 1 >> 1;
                        v3 = v0 - v3;
                        v1 = v1 + v2 + 1 >> 1;
                        v2 = v1 - v2;
                        t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                        v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                        v7 = t;
                        t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                        v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                        v6 = t;
                        p[row] = v0 + v7;
                        p[row + 7] = v0 - v7;
                        p[row + 1] = v1 + v6;
                        p[row + 6] = v1 - v6;
                        p[row + 2] = v2 + v5;
                        p[row + 5] = v2 - v5;
                        p[row + 3] = v3 + v4;
                        p[row + 4] = v3 - v4;
                    }
                    for(let col = 0; col < 8; ++col){
                        p0 = p[col];
                        p1 = p[col + 8];
                        p2 = p[col + 16];
                        p3 = p[col + 24];
                        p4 = p[col + 32];
                        p5 = p[col + 40];
                        p6 = p[col + 48];
                        p7 = p[col + 56];
                        if ((p1 | p2 | p3 | p4 | p5 | p6 | p7) === 0) {
                            t = dctSqrt2 * p0 + 8192 >> 14;
                            if (t < -2040) t = 0;
                            else if (t >= 2024) t = 255;
                            else t = t + 2056 >> 4;
                            blockData[blockBufferOffset + col] = t;
                            blockData[blockBufferOffset + col + 8] = t;
                            blockData[blockBufferOffset + col + 16] = t;
                            blockData[blockBufferOffset + col + 24] = t;
                            blockData[blockBufferOffset + col + 32] = t;
                            blockData[blockBufferOffset + col + 40] = t;
                            blockData[blockBufferOffset + col + 48] = t;
                            blockData[blockBufferOffset + col + 56] = t;
                            continue;
                        }
                        v0 = dctSqrt2 * p0 + 2048 >> 12;
                        v1 = dctSqrt2 * p4 + 2048 >> 12;
                        v2 = p2;
                        v3 = p6;
                        v4 = dctSqrt1d2 * (p1 - p7) + 2048 >> 12;
                        v7 = dctSqrt1d2 * (p1 + p7) + 2048 >> 12;
                        v5 = p3;
                        v6 = p5;
                        v0 = (v0 + v1 + 1 >> 1) + 4112;
                        v1 = v0 - v1;
                        t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
                        v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
                        v3 = t;
                        v4 = v4 + v6 + 1 >> 1;
                        v6 = v4 - v6;
                        v7 = v7 + v5 + 1 >> 1;
                        v5 = v7 - v5;
                        v0 = v0 + v3 + 1 >> 1;
                        v3 = v0 - v3;
                        v1 = v1 + v2 + 1 >> 1;
                        v2 = v1 - v2;
                        t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                        v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                        v7 = t;
                        t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                        v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                        v6 = t;
                        p0 = v0 + v7;
                        p7 = v0 - v7;
                        p1 = v1 + v6;
                        p6 = v1 - v6;
                        p2 = v2 + v5;
                        p5 = v2 - v5;
                        p3 = v3 + v4;
                        p4 = v3 - v4;
                        if (p0 < 16) p0 = 0;
                        else if (p0 >= 4080) p0 = 255;
                        else p0 >>= 4;
                        if (p1 < 16) p1 = 0;
                        else if (p1 >= 4080) p1 = 255;
                        else p1 >>= 4;
                        if (p2 < 16) p2 = 0;
                        else if (p2 >= 4080) p2 = 255;
                        else p2 >>= 4;
                        if (p3 < 16) p3 = 0;
                        else if (p3 >= 4080) p3 = 255;
                        else p3 >>= 4;
                        if (p4 < 16) p4 = 0;
                        else if (p4 >= 4080) p4 = 255;
                        else p4 >>= 4;
                        if (p5 < 16) p5 = 0;
                        else if (p5 >= 4080) p5 = 255;
                        else p5 >>= 4;
                        if (p6 < 16) p6 = 0;
                        else if (p6 >= 4080) p6 = 255;
                        else p6 >>= 4;
                        if (p7 < 16) p7 = 0;
                        else if (p7 >= 4080) p7 = 255;
                        else p7 >>= 4;
                        blockData[blockBufferOffset + col] = p0;
                        blockData[blockBufferOffset + col + 8] = p1;
                        blockData[blockBufferOffset + col + 16] = p2;
                        blockData[blockBufferOffset + col + 24] = p3;
                        blockData[blockBufferOffset + col + 32] = p4;
                        blockData[blockBufferOffset + col + 40] = p5;
                        blockData[blockBufferOffset + col + 48] = p6;
                        blockData[blockBufferOffset + col + 56] = p7;
                    }
                }
                function buildComponentData(frame, component) {
                    const blocksPerLine = component.blocksPerLine;
                    const blocksPerColumn = component.blocksPerColumn;
                    const computationBuffer = new Int16Array(64);
                    for(let blockRow = 0; blockRow < blocksPerColumn; blockRow++)for(let blockCol = 0; blockCol < blocksPerLine; blockCol++){
                        const offset = getBlockBufferOffset(component, blockRow, blockCol);
                        quantizeAndInverse(component, offset, computationBuffer);
                    }
                    return component.blockData;
                }
                function findNextFileMarker(data, currentPos, startPos = currentPos) {
                    const maxPos = data.length - 1;
                    let newPos = startPos < currentPos ? startPos : currentPos;
                    if (currentPos >= maxPos) return null;
                    const currentMarker = (0, _core_utils.readUint16)(data, currentPos);
                    if (currentMarker >= 0xffc0 && currentMarker <= 0xfffe) return {
                        invalid: null,
                        marker: currentMarker,
                        offset: currentPos
                    };
                    let newMarker = (0, _core_utils.readUint16)(data, newPos);
                    while(!(newMarker >= 0xffc0 && newMarker <= 0xfffe)){
                        if (++newPos >= maxPos) return null;
                        newMarker = (0, _core_utils.readUint16)(data, newPos);
                    }
                    return {
                        invalid: currentMarker.toString(16),
                        marker: newMarker,
                        offset: newPos
                    };
                }
                class JpegImage {
                    constructor({ decodeTransform: decodeTransform = null , colorTransform: colorTransform = -1  } = {}){
                        this._decodeTransform = decodeTransform;
                        this._colorTransform = colorTransform;
                    }
                    parse(data, { dnlScanLines: dnlScanLines = null  } = {}) {
                        function readDataBlock() {
                            const length = (0, _core_utils.readUint16)(data, offset);
                            offset += 2;
                            let endOffset = offset + length - 2;
                            const fileMarker = findNextFileMarker(data, endOffset, offset);
                            if (fileMarker && fileMarker.invalid) {
                                (0, _util.warn)("readDataBlock - incorrect length, current marker is: " + fileMarker.invalid);
                                endOffset = fileMarker.offset;
                            }
                            const array = data.subarray(offset, endOffset);
                            offset += array.length;
                            return array;
                        }
                        function prepareComponents(frame) {
                            const mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / frame.maxH);
                            const mcusPerColumn = Math.ceil(frame.scanLines / 8 / frame.maxV);
                            for(let i = 0, ii = frame.components.length; i < ii; i++){
                                const component = frame.components[i];
                                const blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / frame.maxH);
                                const blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / frame.maxV);
                                const blocksPerLineForMcu = mcusPerLine * component.h;
                                const blocksPerColumnForMcu = mcusPerColumn * component.v;
                                const blocksBufferSize = 64 * blocksPerColumnForMcu * (blocksPerLineForMcu + 1);
                                component.blockData = new Int16Array(blocksBufferSize);
                                component.blocksPerLine = blocksPerLine;
                                component.blocksPerColumn = blocksPerColumn;
                            }
                            frame.mcusPerLine = mcusPerLine;
                            frame.mcusPerColumn = mcusPerColumn;
                        }
                        let offset = 0;
                        let jfif = null;
                        let adobe = null;
                        let frame, resetInterval;
                        let numSOSMarkers = 0;
                        const quantizationTables = [];
                        const huffmanTablesAC = [], huffmanTablesDC = [];
                        let fileMarker = (0, _core_utils.readUint16)(data, offset);
                        offset += 2;
                        if (fileMarker !== 0xffd8) throw new JpegError("SOI not found");
                        fileMarker = (0, _core_utils.readUint16)(data, offset);
                        offset += 2;
                        markerLoop: while(fileMarker !== 0xffd9){
                            let i, j, l;
                            switch(fileMarker){
                                case 0xffe0:
                                case 0xffe1:
                                case 0xffe2:
                                case 0xffe3:
                                case 0xffe4:
                                case 0xffe5:
                                case 0xffe6:
                                case 0xffe7:
                                case 0xffe8:
                                case 0xffe9:
                                case 0xffea:
                                case 0xffeb:
                                case 0xffec:
                                case 0xffed:
                                case 0xffee:
                                case 0xffef:
                                case 0xfffe:
                                    const appData = readDataBlock();
                                    if (fileMarker === 0xffe0) {
                                        if (appData[0] === 0x4a && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) jfif = {
                                            version: {
                                                major: appData[5],
                                                minor: appData[6]
                                            },
                                            densityUnits: appData[7],
                                            xDensity: appData[8] << 8 | appData[9],
                                            yDensity: appData[10] << 8 | appData[11],
                                            thumbWidth: appData[12],
                                            thumbHeight: appData[13],
                                            thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                                        };
                                    }
                                    if (fileMarker === 0xffee) {
                                        if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6f && appData[3] === 0x62 && appData[4] === 0x65) adobe = {
                                            version: appData[5] << 8 | appData[6],
                                            flags0: appData[7] << 8 | appData[8],
                                            flags1: appData[9] << 8 | appData[10],
                                            transformCode: appData[11]
                                        };
                                    }
                                    break;
                                case 0xffdb:
                                    const quantizationTablesLength = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    const quantizationTablesEnd = quantizationTablesLength + offset - 2;
                                    let z;
                                    while(offset < quantizationTablesEnd){
                                        const quantizationTableSpec = data[offset++];
                                        const tableData = new Uint16Array(64);
                                        if (quantizationTableSpec >> 4 === 0) for(j = 0; j < 64; j++){
                                            z = dctZigZag[j];
                                            tableData[z] = data[offset++];
                                        }
                                        else if (quantizationTableSpec >> 4 === 1) for(j = 0; j < 64; j++){
                                            z = dctZigZag[j];
                                            tableData[z] = (0, _core_utils.readUint16)(data, offset);
                                            offset += 2;
                                        }
                                        else throw new JpegError("DQT - invalid table spec");
                                        quantizationTables[quantizationTableSpec & 15] = tableData;
                                    }
                                    break;
                                case 0xffc0:
                                case 0xffc1:
                                case 0xffc2:
                                    if (frame) throw new JpegError("Only single frame JPEGs supported");
                                    offset += 2;
                                    frame = {};
                                    frame.extended = fileMarker === 0xffc1;
                                    frame.progressive = fileMarker === 0xffc2;
                                    frame.precision = data[offset++];
                                    const sofScanLines = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    frame.scanLines = dnlScanLines || sofScanLines;
                                    frame.samplesPerLine = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    frame.components = [];
                                    frame.componentIds = {};
                                    const componentsCount = data[offset++];
                                    let maxH = 0, maxV = 0;
                                    for(i = 0; i < componentsCount; i++){
                                        const componentId = data[offset];
                                        const h = data[offset + 1] >> 4;
                                        const v = data[offset + 1] & 15;
                                        if (maxH < h) maxH = h;
                                        if (maxV < v) maxV = v;
                                        const qId = data[offset + 2];
                                        l = frame.components.push({
                                            h: h,
                                            v: v,
                                            quantizationId: qId,
                                            quantizationTable: null
                                        });
                                        frame.componentIds[componentId] = l - 1;
                                        offset += 3;
                                    }
                                    frame.maxH = maxH;
                                    frame.maxV = maxV;
                                    prepareComponents(frame);
                                    break;
                                case 0xffc4:
                                    const huffmanLength = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    for(i = 2; i < huffmanLength;){
                                        const huffmanTableSpec = data[offset++];
                                        const codeLengths = new Uint8Array(16);
                                        let codeLengthSum = 0;
                                        for(j = 0; j < 16; j++, offset++)codeLengthSum += codeLengths[j] = data[offset];
                                        const huffmanValues = new Uint8Array(codeLengthSum);
                                        for(j = 0; j < codeLengthSum; j++, offset++)huffmanValues[j] = data[offset];
                                        i += 17 + codeLengthSum;
                                        (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                                    }
                                    break;
                                case 0xffdd:
                                    offset += 2;
                                    resetInterval = (0, _core_utils.readUint16)(data, offset);
                                    offset += 2;
                                    break;
                                case 0xffda:
                                    const parseDNLMarker = ++numSOSMarkers === 1 && !dnlScanLines;
                                    offset += 2;
                                    const selectorsCount = data[offset++], components = [];
                                    for(i = 0; i < selectorsCount; i++){
                                        const index = data[offset++];
                                        const componentIndex = frame.componentIds[index];
                                        const component = frame.components[componentIndex];
                                        component.index = index;
                                        const tableSpec = data[offset++];
                                        component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
                                        component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
                                        components.push(component);
                                    }
                                    const spectralStart = data[offset++], spectralEnd = data[offset++], successiveApproximation = data[offset++];
                                    try {
                                        const processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15, parseDNLMarker);
                                        offset += processed;
                                    } catch (ex) {
                                        if (ex instanceof DNLMarkerError) {
                                            (0, _util.warn)(`${ex.message} -- attempting to re-parse the JPEG image.`);
                                            return this.parse(data, {
                                                dnlScanLines: ex.scanLines
                                            });
                                        } else if (ex instanceof EOIMarkerError) {
                                            (0, _util.warn)(`${ex.message} -- ignoring the rest of the image data.`);
                                            break markerLoop;
                                        }
                                        throw ex;
                                    }
                                    break;
                                case 0xffdc:
                                    offset += 4;
                                    break;
                                case 0xffff:
                                    if (data[offset] !== 0xff) offset--;
                                    break;
                                default:
                                    const nextFileMarker = findNextFileMarker(data, offset - 2, offset - 3);
                                    if (nextFileMarker && nextFileMarker.invalid) {
                                        (0, _util.warn)("JpegImage.parse - unexpected data, current marker is: " + nextFileMarker.invalid);
                                        offset = nextFileMarker.offset;
                                        break;
                                    }
                                    if (!nextFileMarker || offset >= data.length - 1) {
                                        (0, _util.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                                        break markerLoop;
                                    }
                                    throw new JpegError("JpegImage.parse - unknown marker: " + fileMarker.toString(16));
                            }
                            fileMarker = (0, _core_utils.readUint16)(data, offset);
                            offset += 2;
                        }
                        this.width = frame.samplesPerLine;
                        this.height = frame.scanLines;
                        this.jfif = jfif;
                        this.adobe = adobe;
                        this.components = [];
                        for(let i = 0, ii = frame.components.length; i < ii; i++){
                            const component = frame.components[i];
                            const quantizationTable = quantizationTables[component.quantizationId];
                            if (quantizationTable) component.quantizationTable = quantizationTable;
                            this.components.push({
                                index: component.index,
                                output: buildComponentData(frame, component),
                                scaleX: component.h / frame.maxH,
                                scaleY: component.v / frame.maxV,
                                blocksPerLine: component.blocksPerLine,
                                blocksPerColumn: component.blocksPerColumn
                            });
                        }
                        this.numComponents = this.components.length;
                        return undefined;
                    }
                    _getLinearizedBlockData(width, height, isSourcePDF = false) {
                        const scaleX = this.width / width, scaleY = this.height / height;
                        let component, componentScaleX, componentScaleY, blocksPerScanline;
                        let x, y, i, j, k;
                        let index;
                        let offset = 0;
                        let output;
                        const numComponents = this.components.length;
                        const dataLength = width * height * numComponents;
                        const data = new Uint8ClampedArray(dataLength);
                        const xScaleBlockOffset = new Uint32Array(width);
                        const mask3LSB = 0xfffffff8;
                        let lastComponentScaleX;
                        for(i = 0; i < numComponents; i++){
                            component = this.components[i];
                            componentScaleX = component.scaleX * scaleX;
                            componentScaleY = component.scaleY * scaleY;
                            offset = i;
                            output = component.output;
                            blocksPerScanline = component.blocksPerLine + 1 << 3;
                            if (componentScaleX !== lastComponentScaleX) {
                                for(x = 0; x < width; x++){
                                    j = 0 | x * componentScaleX;
                                    xScaleBlockOffset[x] = (j & mask3LSB) << 3 | j & 7;
                                }
                                lastComponentScaleX = componentScaleX;
                            }
                            for(y = 0; y < height; y++){
                                j = 0 | y * componentScaleY;
                                index = blocksPerScanline * (j & mask3LSB) | (j & 7) << 3;
                                for(x = 0; x < width; x++){
                                    data[offset] = output[index + xScaleBlockOffset[x]];
                                    offset += numComponents;
                                }
                            }
                        }
                        let transform = this._decodeTransform;
                        if (!isSourcePDF && numComponents === 4 && !transform) transform = new Int32Array([
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255,
                            -256,
                            255
                        ]);
                        if (transform) {
                            for(i = 0; i < dataLength;)for(j = 0, k = 0; j < numComponents; j++, i++, k += 2)data[i] = (data[i] * transform[k] >> 8) + transform[k + 1];
                        }
                        return data;
                    }
                    get _isColorConversionNeeded() {
                        if (this.adobe) return !!this.adobe.transformCode;
                        if (this.numComponents === 3) {
                            if (this._colorTransform === 0) return false;
                            else if (this.components[0].index === 0x52 && this.components[1].index === 0x47 && this.components[2].index === 0x42) return false;
                            return true;
                        }
                        if (this._colorTransform === 1) return true;
                        return false;
                    }
                    _convertYccToRgb(data) {
                        let Y, Cb, Cr;
                        for(let i = 0, length = data.length; i < length; i += 3){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            data[i] = Y - 179.456 + 1.402 * Cr;
                            data[i + 1] = Y + 135.459 - 0.344 * Cb - 0.714 * Cr;
                            data[i + 2] = Y - 226.816 + 1.772 * Cb;
                        }
                        return data;
                    }
                    _convertYcckToRgb(data) {
                        let Y, Cb, Cr, k;
                        let offset = 0;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            k = data[i + 3];
                            data[offset++] = -122.67195406894 + Cb * (-0.0000660635669420364 * Cb + 0.000437130475926232 * Cr - 5.4080610064599e-5 * Y + 0.00048449797120281 * k - 0.154362151871126) + Cr * (-0.000957964378445773 * Cr + 0.000817076911346625 * Y - 0.00477271405408747 * k + 1.53380253221734) + Y * (0.000961250184130688 * Y - 0.00266257332283933 * k + 0.48357088451265) + k * (-0.000336197177618394 * k + 0.484791561490776);
                            data[offset++] = 107.268039397724 + Cb * (2.19927104525741e-5 * Cb - 0.000640992018297945 * Cr + 0.000659397001245577 * Y + 0.000426105652938837 * k - 0.176491792462875) + Cr * (-0.000778269941513683 * Cr + 0.00130872261408275 * Y + 0.000770482631801132 * k - 0.151051492775562) + Y * (0.00126935368114843 * Y - 0.00265090189010898 * k + 0.25802910206845) + k * (-0.000318913117588328 * k - 0.213742400323665);
                            data[offset++] = -20.810012546947 + Cb * (-0.000570115196973677 * Cb - 2.63409051004589e-5 * Cr + 0.0020741088115012 * Y - 0.00288260236853442 * k + 0.814272968359295) + Cr * (-0.0000153496057440975 * Cr - 0.000132689043961446 * Y + 0.000560833691242812 * k - 0.195152027534049) + Y * (0.00174418132927582 * Y - 0.00255243321439347 * k + 0.116935020465145) + k * (-0.000343531996510555 * k + 0.24165260232407);
                        }
                        return data.subarray(0, offset);
                    }
                    _convertYcckToCmyk(data) {
                        let Y, Cb, Cr;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            Y = data[i];
                            Cb = data[i + 1];
                            Cr = data[i + 2];
                            data[i] = 434.456 - Y - 1.402 * Cr;
                            data[i + 1] = 119.541 - Y + 0.344 * Cb + 0.714 * Cr;
                            data[i + 2] = 481.816 - Y - 1.772 * Cb;
                        }
                        return data;
                    }
                    _convertCmykToRgb(data) {
                        let c, m, y, k;
                        let offset = 0;
                        for(let i = 0, length = data.length; i < length; i += 4){
                            c = data[i];
                            m = data[i + 1];
                            y = data[i + 2];
                            k = data[i + 3];
                            data[offset++] = 255 + c * (-0.00006747147073602441 * c + 0.0008379262121013727 * m + 0.0002894718188643294 * y + 0.003264231057537806 * k - 1.1185611867203937) + m * (0.000026374107616089405 * m - 0.00008626949158638572 * y - 0.0002748769067499491 * k - 0.02155688794978967) + y * (-0.00003878099212869363 * y - 0.0003267808279485286 * k + 0.0686742238595345) - k * (0.0003361971776183937 * k + 0.7430659151342254);
                            data[offset++] = 255 + c * (0.00013596372813588848 * c + 0.000924537132573585 * m + 0.00010567359618683593 * y + 0.0004791864687436512 * k - 0.3109689587515875) + m * (-0.00023545346108370344 * m + 0.0002702845253534714 * y + 0.0020200308977307156 * k - 0.7488052167015494) + y * (0.00006834815998235662 * y + 0.00015168452363460973 * k - 0.09751927774728933) - k * (0.00031891311758832814 * k + 0.7364883807733168);
                            data[offset++] = 255 + c * (0.000013598650411385307 * c + 0.00012423956175490851 * m + 0.0004751985097583589 * y - 0.0000036729317476630422 * k - 0.05562186980264034) + m * (0.00016141380598724676 * m + 0.0009692239130725186 * y + 0.0007782692450036253 * k - 0.44015232367526463) + y * (5.068882914068769e-7 * y + 0.0017778369011375071 * k - 0.7591454649749609) - k * (0.0003435319965105553 * k + 0.7063770186160144);
                        }
                        return data.subarray(0, offset);
                    }
                    getData({ width: width , height: height , forceRGB: forceRGB = false , isSourcePDF: isSourcePDF = false  }) {
                        if (this.numComponents > 4) throw new JpegError("Unsupported color mode");
                        const data = this._getLinearizedBlockData(width, height, isSourcePDF);
                        if (this.numComponents === 1 && forceRGB) {
                            const dataLength = data.length;
                            const rgbData = new Uint8ClampedArray(dataLength * 3);
                            let offset = 0;
                            for(let i = 0; i < dataLength; i++){
                                const grayColor = data[i];
                                rgbData[offset++] = grayColor;
                                rgbData[offset++] = grayColor;
                                rgbData[offset++] = grayColor;
                            }
                            return rgbData;
                        } else if (this.numComponents === 3 && this._isColorConversionNeeded) return this._convertYccToRgb(data);
                        else if (this.numComponents === 4) {
                            if (this._isColorConversionNeeded) {
                                if (forceRGB) return this._convertYcckToRgb(data);
                                return this._convertYcckToCmyk(data);
                            } else if (forceRGB) return this._convertCmykToRgb(data);
                        }
                        return data;
                    }
                }
                exports.JpegImage = JpegImage;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpxStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                var _jpx = __w_pdfjs_require__(30);
                var _util = __w_pdfjs_require__(2);
                class JpxStream extends _decode_stream.DecodeStream {
                    constructor(stream, maybeLength, params){
                        super(maybeLength);
                        this.stream = stream;
                        this.dict = stream.dict;
                        this.maybeLength = maybeLength;
                        this.params = params;
                    }
                    get bytes() {
                        return (0, _util.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
                    }
                    ensureBuffer(requested) {}
                    readBlock() {
                        if (this.eof) return;
                        const jpxImage = new _jpx.JpxImage();
                        jpxImage.parse(this.bytes);
                        const width = jpxImage.width;
                        const height = jpxImage.height;
                        const componentsCount = jpxImage.componentsCount;
                        const tileCount = jpxImage.tiles.length;
                        if (tileCount === 1) this.buffer = jpxImage.tiles[0].items;
                        else {
                            const data = new Uint8ClampedArray(width * height * componentsCount);
                            for(let k = 0; k < tileCount; k++){
                                const tileComponents = jpxImage.tiles[k];
                                const tileWidth = tileComponents.width;
                                const tileHeight = tileComponents.height;
                                const tileLeft = tileComponents.left;
                                const tileTop = tileComponents.top;
                                const src = tileComponents.items;
                                let srcPosition = 0;
                                let dataPosition = (width * tileTop + tileLeft) * componentsCount;
                                const imgRowSize = width * componentsCount;
                                const tileRowSize = tileWidth * componentsCount;
                                for(let j = 0; j < tileHeight; j++){
                                    const rowBytes = src.subarray(srcPosition, srcPosition + tileRowSize);
                                    data.set(rowBytes, dataPosition);
                                    srcPosition += tileRowSize;
                                    dataPosition += imgRowSize;
                                }
                            }
                            this.buffer = data;
                        }
                        this.bufferLength = this.buffer.length;
                        this.eof = true;
                    }
                }
                exports.JpxStream = JpxStream;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.JpxImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(9);
                var _arithmetic_decoder = __w_pdfjs_require__(26);
                class JpxError extends _util.BaseException {
                    constructor(msg){
                        super(`JPX error: ${msg}`);
                    }
                }
                const SubbandsGainLog2 = {
                    LL: 0,
                    LH: 1,
                    HL: 1,
                    HH: 2
                };
                class JpxImage {
                    constructor(){
                        this.failOnCorruptedImage = false;
                    }
                    parse(data) {
                        const head = (0, _core_utils.readUint16)(data, 0);
                        if (head === 0xff4f) {
                            this.parseCodestream(data, 0, data.length);
                            return;
                        }
                        const length = data.length;
                        let position = 0;
                        while(position < length){
                            let headerSize = 8;
                            let lbox = (0, _core_utils.readUint32)(data, position);
                            const tbox = (0, _core_utils.readUint32)(data, position + 4);
                            position += headerSize;
                            if (lbox === 1) {
                                lbox = (0, _core_utils.readUint32)(data, position) * 4294967296 + (0, _core_utils.readUint32)(data, position + 4);
                                position += 8;
                                headerSize += 8;
                            }
                            if (lbox === 0) lbox = length - position + headerSize;
                            if (lbox < headerSize) throw new JpxError("Invalid box field size");
                            const dataLength = lbox - headerSize;
                            let jumpDataLength = true;
                            switch(tbox){
                                case 0x6a703268:
                                    jumpDataLength = false;
                                    break;
                                case 0x636f6c72:
                                    const method = data[position];
                                    if (method === 1) {
                                        const colorspace = (0, _core_utils.readUint32)(data, position + 3);
                                        switch(colorspace){
                                            case 16:
                                            case 17:
                                            case 18:
                                                break;
                                            default:
                                                (0, _util.warn)("Unknown colorspace " + colorspace);
                                                break;
                                        }
                                    } else if (method === 2) (0, _util.info)("ICC profile not supported");
                                    break;
                                case 0x6a703263:
                                    this.parseCodestream(data, position, position + dataLength);
                                    break;
                                case 0x6a502020:
                                    if ((0, _core_utils.readUint32)(data, position) !== 0x0d0a870a) (0, _util.warn)("Invalid JP2 signature");
                                    break;
                                case 0x6a501a1a:
                                case 0x66747970:
                                case 0x72726571:
                                case 0x72657320:
                                case 0x69686472:
                                    break;
                                default:
                                    const headerType = String.fromCharCode(tbox >> 24 & 0xff, tbox >> 16 & 0xff, tbox >> 8 & 0xff, tbox & 0xff);
                                    (0, _util.warn)(`Unsupported header type ${tbox} (${headerType}).`);
                                    break;
                            }
                            if (jumpDataLength) position += dataLength;
                        }
                    }
                    parseImageProperties(stream) {
                        let newByte = stream.getByte();
                        while(newByte >= 0){
                            const oldByte = newByte;
                            newByte = stream.getByte();
                            const code = oldByte << 8 | newByte;
                            if (code === 0xff51) {
                                stream.skip(4);
                                const Xsiz = stream.getInt32() >>> 0;
                                const Ysiz = stream.getInt32() >>> 0;
                                const XOsiz = stream.getInt32() >>> 0;
                                const YOsiz = stream.getInt32() >>> 0;
                                stream.skip(16);
                                const Csiz = stream.getUint16();
                                this.width = Xsiz - XOsiz;
                                this.height = Ysiz - YOsiz;
                                this.componentsCount = Csiz;
                                this.bitsPerComponent = 8;
                                return;
                            }
                        }
                        throw new JpxError("No size marker found in JPX stream");
                    }
                    parseCodestream(data, start, end) {
                        const context = {};
                        let doNotRecover = false;
                        try {
                            let position = start;
                            while(position + 1 < end){
                                const code = (0, _core_utils.readUint16)(data, position);
                                position += 2;
                                let length = 0, j, sqcd, spqcds, spqcdSize, scalarExpounded, tile;
                                switch(code){
                                    case 0xff4f:
                                        context.mainHeader = true;
                                        break;
                                    case 0xffd9:
                                        break;
                                    case 0xff51:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const siz = {};
                                        siz.Xsiz = (0, _core_utils.readUint32)(data, position + 4);
                                        siz.Ysiz = (0, _core_utils.readUint32)(data, position + 8);
                                        siz.XOsiz = (0, _core_utils.readUint32)(data, position + 12);
                                        siz.YOsiz = (0, _core_utils.readUint32)(data, position + 16);
                                        siz.XTsiz = (0, _core_utils.readUint32)(data, position + 20);
                                        siz.YTsiz = (0, _core_utils.readUint32)(data, position + 24);
                                        siz.XTOsiz = (0, _core_utils.readUint32)(data, position + 28);
                                        siz.YTOsiz = (0, _core_utils.readUint32)(data, position + 32);
                                        const componentsCount = (0, _core_utils.readUint16)(data, position + 36);
                                        siz.Csiz = componentsCount;
                                        const components = [];
                                        j = position + 38;
                                        for(let i = 0; i < componentsCount; i++){
                                            const component = {
                                                precision: (data[j] & 0x7f) + 1,
                                                isSigned: !!(data[j] & 0x80),
                                                XRsiz: data[j + 1],
                                                YRsiz: data[j + 2]
                                            };
                                            j += 3;
                                            calculateComponentDimensions(component, siz);
                                            components.push(component);
                                        }
                                        context.SIZ = siz;
                                        context.components = components;
                                        calculateTileGrids(context, components);
                                        context.QCC = [];
                                        context.COC = [];
                                        break;
                                    case 0xff5c:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const qcd = {};
                                        j = position + 2;
                                        sqcd = data[j++];
                                        switch(sqcd & 0x1f){
                                            case 0:
                                                spqcdSize = 8;
                                                scalarExpounded = true;
                                                break;
                                            case 1:
                                                spqcdSize = 16;
                                                scalarExpounded = false;
                                                break;
                                            case 2:
                                                spqcdSize = 16;
                                                scalarExpounded = true;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + sqcd);
                                        }
                                        qcd.noQuantization = spqcdSize === 8;
                                        qcd.scalarExpounded = scalarExpounded;
                                        qcd.guardBits = sqcd >> 5;
                                        spqcds = [];
                                        while(j < length + position){
                                            const spqcd = {};
                                            if (spqcdSize === 8) {
                                                spqcd.epsilon = data[j++] >> 3;
                                                spqcd.mu = 0;
                                            } else {
                                                spqcd.epsilon = data[j] >> 3;
                                                spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                                                j += 2;
                                            }
                                            spqcds.push(spqcd);
                                        }
                                        qcd.SPqcds = spqcds;
                                        if (context.mainHeader) context.QCD = qcd;
                                        else {
                                            context.currentTile.QCD = qcd;
                                            context.currentTile.QCC = [];
                                        }
                                        break;
                                    case 0xff5d:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const qcc = {};
                                        j = position + 2;
                                        let cqcc;
                                        if (context.SIZ.Csiz < 257) cqcc = data[j++];
                                        else {
                                            cqcc = (0, _core_utils.readUint16)(data, j);
                                            j += 2;
                                        }
                                        sqcd = data[j++];
                                        switch(sqcd & 0x1f){
                                            case 0:
                                                spqcdSize = 8;
                                                scalarExpounded = true;
                                                break;
                                            case 1:
                                                spqcdSize = 16;
                                                scalarExpounded = false;
                                                break;
                                            case 2:
                                                spqcdSize = 16;
                                                scalarExpounded = true;
                                                break;
                                            default:
                                                throw new Error("Invalid SQcd value " + sqcd);
                                        }
                                        qcc.noQuantization = spqcdSize === 8;
                                        qcc.scalarExpounded = scalarExpounded;
                                        qcc.guardBits = sqcd >> 5;
                                        spqcds = [];
                                        while(j < length + position){
                                            const spqcd = {};
                                            if (spqcdSize === 8) {
                                                spqcd.epsilon = data[j++] >> 3;
                                                spqcd.mu = 0;
                                            } else {
                                                spqcd.epsilon = data[j] >> 3;
                                                spqcd.mu = (data[j] & 0x7) << 8 | data[j + 1];
                                                j += 2;
                                            }
                                            spqcds.push(spqcd);
                                        }
                                        qcc.SPqcds = spqcds;
                                        if (context.mainHeader) context.QCC[cqcc] = qcc;
                                        else context.currentTile.QCC[cqcc] = qcc;
                                        break;
                                    case 0xff52:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        const cod = {};
                                        j = position + 2;
                                        const scod = data[j++];
                                        cod.entropyCoderWithCustomPrecincts = !!(scod & 1);
                                        cod.sopMarkerUsed = !!(scod & 2);
                                        cod.ephMarkerUsed = !!(scod & 4);
                                        cod.progressionOrder = data[j++];
                                        cod.layersCount = (0, _core_utils.readUint16)(data, j);
                                        j += 2;
                                        cod.multipleComponentTransform = data[j++];
                                        cod.decompositionLevelsCount = data[j++];
                                        cod.xcb = (data[j++] & 0xf) + 2;
                                        cod.ycb = (data[j++] & 0xf) + 2;
                                        const blockStyle = data[j++];
                                        cod.selectiveArithmeticCodingBypass = !!(blockStyle & 1);
                                        cod.resetContextProbabilities = !!(blockStyle & 2);
                                        cod.terminationOnEachCodingPass = !!(blockStyle & 4);
                                        cod.verticallyStripe = !!(blockStyle & 8);
                                        cod.predictableTermination = !!(blockStyle & 16);
                                        cod.segmentationSymbolUsed = !!(blockStyle & 32);
                                        cod.reversibleTransformation = data[j++];
                                        if (cod.entropyCoderWithCustomPrecincts) {
                                            const precinctsSizes = [];
                                            while(j < length + position){
                                                const precinctsSize = data[j++];
                                                precinctsSizes.push({
                                                    PPx: precinctsSize & 0xf,
                                                    PPy: precinctsSize >> 4
                                                });
                                            }
                                            cod.precinctsSizes = precinctsSizes;
                                        }
                                        const unsupported = [];
                                        if (cod.selectiveArithmeticCodingBypass) unsupported.push("selectiveArithmeticCodingBypass");
                                        if (cod.resetContextProbabilities) unsupported.push("resetContextProbabilities");
                                        if (cod.terminationOnEachCodingPass) unsupported.push("terminationOnEachCodingPass");
                                        if (cod.verticallyStripe) unsupported.push("verticallyStripe");
                                        if (cod.predictableTermination) unsupported.push("predictableTermination");
                                        if (unsupported.length > 0) {
                                            doNotRecover = true;
                                            (0, _util.warn)(`JPX: Unsupported COD options (${unsupported.join(", ")}).`);
                                        }
                                        if (context.mainHeader) context.COD = cod;
                                        else {
                                            context.currentTile.COD = cod;
                                            context.currentTile.COC = [];
                                        }
                                        break;
                                    case 0xff90:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        tile = {};
                                        tile.index = (0, _core_utils.readUint16)(data, position + 2);
                                        tile.length = (0, _core_utils.readUint32)(data, position + 4);
                                        tile.dataEnd = tile.length + position - 2;
                                        tile.partIndex = data[position + 8];
                                        tile.partsCount = data[position + 9];
                                        context.mainHeader = false;
                                        if (tile.partIndex === 0) {
                                            tile.COD = context.COD;
                                            tile.COC = context.COC.slice(0);
                                            tile.QCD = context.QCD;
                                            tile.QCC = context.QCC.slice(0);
                                        }
                                        context.currentTile = tile;
                                        break;
                                    case 0xff93:
                                        tile = context.currentTile;
                                        if (tile.partIndex === 0) {
                                            initializeTile(context, tile.index);
                                            buildPackets(context);
                                        }
                                        length = tile.dataEnd - position;
                                        parseTilePackets(context, data, position, length);
                                        break;
                                    case 0xff53:
                                        (0, _util.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                                    case 0xff55:
                                    case 0xff57:
                                    case 0xff58:
                                    case 0xff64:
                                        length = (0, _core_utils.readUint16)(data, position);
                                        break;
                                    default:
                                        throw new Error("Unknown codestream code: " + code.toString(16));
                                }
                                position += length;
                            }
                        } catch (e) {
                            if (doNotRecover || this.failOnCorruptedImage) throw new JpxError(e.message);
                            else (0, _util.warn)(`JPX: Trying to recover from: "${e.message}".`);
                        }
                        this.tiles = transformComponents(context);
                        this.width = context.SIZ.Xsiz - context.SIZ.XOsiz;
                        this.height = context.SIZ.Ysiz - context.SIZ.YOsiz;
                        this.componentsCount = context.SIZ.Csiz;
                    }
                }
                exports.JpxImage = JpxImage;
                function calculateComponentDimensions(component, siz) {
                    component.x0 = Math.ceil(siz.XOsiz / component.XRsiz);
                    component.x1 = Math.ceil(siz.Xsiz / component.XRsiz);
                    component.y0 = Math.ceil(siz.YOsiz / component.YRsiz);
                    component.y1 = Math.ceil(siz.Ysiz / component.YRsiz);
                    component.width = component.x1 - component.x0;
                    component.height = component.y1 - component.y0;
                }
                function calculateTileGrids(context, components) {
                    const siz = context.SIZ;
                    const tiles = [];
                    let tile;
                    const numXtiles = Math.ceil((siz.Xsiz - siz.XTOsiz) / siz.XTsiz);
                    const numYtiles = Math.ceil((siz.Ysiz - siz.YTOsiz) / siz.YTsiz);
                    for(let q = 0; q < numYtiles; q++)for(let p = 0; p < numXtiles; p++){
                        tile = {};
                        tile.tx0 = Math.max(siz.XTOsiz + p * siz.XTsiz, siz.XOsiz);
                        tile.ty0 = Math.max(siz.YTOsiz + q * siz.YTsiz, siz.YOsiz);
                        tile.tx1 = Math.min(siz.XTOsiz + (p + 1) * siz.XTsiz, siz.Xsiz);
                        tile.ty1 = Math.min(siz.YTOsiz + (q + 1) * siz.YTsiz, siz.Ysiz);
                        tile.width = tile.tx1 - tile.tx0;
                        tile.height = tile.ty1 - tile.ty0;
                        tile.components = [];
                        tiles.push(tile);
                    }
                    context.tiles = tiles;
                    const componentsCount = siz.Csiz;
                    for(let i = 0, ii = componentsCount; i < ii; i++){
                        const component = components[i];
                        for(let j = 0, jj = tiles.length; j < jj; j++){
                            const tileComponent = {};
                            tile = tiles[j];
                            tileComponent.tcx0 = Math.ceil(tile.tx0 / component.XRsiz);
                            tileComponent.tcy0 = Math.ceil(tile.ty0 / component.YRsiz);
                            tileComponent.tcx1 = Math.ceil(tile.tx1 / component.XRsiz);
                            tileComponent.tcy1 = Math.ceil(tile.ty1 / component.YRsiz);
                            tileComponent.width = tileComponent.tcx1 - tileComponent.tcx0;
                            tileComponent.height = tileComponent.tcy1 - tileComponent.tcy0;
                            tile.components[i] = tileComponent;
                        }
                    }
                }
                function getBlocksDimensions(context, component, r) {
                    const codOrCoc = component.codingStyleParameters;
                    const result = {};
                    if (!codOrCoc.entropyCoderWithCustomPrecincts) {
                        result.PPx = 15;
                        result.PPy = 15;
                    } else {
                        result.PPx = codOrCoc.precinctsSizes[r].PPx;
                        result.PPy = codOrCoc.precinctsSizes[r].PPy;
                    }
                    result.xcb_ = r > 0 ? Math.min(codOrCoc.xcb, result.PPx - 1) : Math.min(codOrCoc.xcb, result.PPx);
                    result.ycb_ = r > 0 ? Math.min(codOrCoc.ycb, result.PPy - 1) : Math.min(codOrCoc.ycb, result.PPy);
                    return result;
                }
                function buildPrecincts(context, resolution, dimensions) {
                    const precinctWidth = 1 << dimensions.PPx;
                    const precinctHeight = 1 << dimensions.PPy;
                    const isZeroRes = resolution.resLevel === 0;
                    const precinctWidthInSubband = 1 << dimensions.PPx + (isZeroRes ? 0 : -1);
                    const precinctHeightInSubband = 1 << dimensions.PPy + (isZeroRes ? 0 : -1);
                    const numprecinctswide = resolution.trx1 > resolution.trx0 ? Math.ceil(resolution.trx1 / precinctWidth) - Math.floor(resolution.trx0 / precinctWidth) : 0;
                    const numprecinctshigh = resolution.try1 > resolution.try0 ? Math.ceil(resolution.try1 / precinctHeight) - Math.floor(resolution.try0 / precinctHeight) : 0;
                    const numprecincts = numprecinctswide * numprecinctshigh;
                    resolution.precinctParameters = {
                        precinctWidth: precinctWidth,
                        precinctHeight: precinctHeight,
                        numprecinctswide: numprecinctswide,
                        numprecinctshigh: numprecinctshigh,
                        numprecincts: numprecincts,
                        precinctWidthInSubband: precinctWidthInSubband,
                        precinctHeightInSubband: precinctHeightInSubband
                    };
                }
                function buildCodeblocks(context, subband, dimensions) {
                    const xcb_ = dimensions.xcb_;
                    const ycb_ = dimensions.ycb_;
                    const codeblockWidth = 1 << xcb_;
                    const codeblockHeight = 1 << ycb_;
                    const cbx0 = subband.tbx0 >> xcb_;
                    const cby0 = subband.tby0 >> ycb_;
                    const cbx1 = subband.tbx1 + codeblockWidth - 1 >> xcb_;
                    const cby1 = subband.tby1 + codeblockHeight - 1 >> ycb_;
                    const precinctParameters = subband.resolution.precinctParameters;
                    const codeblocks = [];
                    const precincts = [];
                    let i, j, codeblock, precinctNumber;
                    for(j = cby0; j < cby1; j++)for(i = cbx0; i < cbx1; i++){
                        codeblock = {
                            cbx: i,
                            cby: j,
                            tbx0: codeblockWidth * i,
                            tby0: codeblockHeight * j,
                            tbx1: codeblockWidth * (i + 1),
                            tby1: codeblockHeight * (j + 1)
                        };
                        codeblock.tbx0_ = Math.max(subband.tbx0, codeblock.tbx0);
                        codeblock.tby0_ = Math.max(subband.tby0, codeblock.tby0);
                        codeblock.tbx1_ = Math.min(subband.tbx1, codeblock.tbx1);
                        codeblock.tby1_ = Math.min(subband.tby1, codeblock.tby1);
                        const pi = Math.floor((codeblock.tbx0_ - subband.tbx0) / precinctParameters.precinctWidthInSubband);
                        const pj = Math.floor((codeblock.tby0_ - subband.tby0) / precinctParameters.precinctHeightInSubband);
                        precinctNumber = pi + pj * precinctParameters.numprecinctswide;
                        codeblock.precinctNumber = precinctNumber;
                        codeblock.subbandType = subband.type;
                        codeblock.Lblock = 3;
                        if (codeblock.tbx1_ <= codeblock.tbx0_ || codeblock.tby1_ <= codeblock.tby0_) continue;
                        codeblocks.push(codeblock);
                        let precinct = precincts[precinctNumber];
                        if (precinct !== undefined) {
                            if (i < precinct.cbxMin) precinct.cbxMin = i;
                            else if (i > precinct.cbxMax) precinct.cbxMax = i;
                            if (j < precinct.cbyMin) precinct.cbxMin = j;
                            else if (j > precinct.cbyMax) precinct.cbyMax = j;
                        } else precincts[precinctNumber] = precinct = {
                            cbxMin: i,
                            cbyMin: j,
                            cbxMax: i,
                            cbyMax: j
                        };
                        codeblock.precinct = precinct;
                    }
                    subband.codeblockParameters = {
                        codeblockWidth: xcb_,
                        codeblockHeight: ycb_,
                        numcodeblockwide: cbx1 - cbx0 + 1,
                        numcodeblockhigh: cby1 - cby0 + 1
                    };
                    subband.codeblocks = codeblocks;
                    subband.precincts = precincts;
                }
                function createPacket(resolution, precinctNumber, layerNumber) {
                    const precinctCodeblocks = [];
                    const subbands = resolution.subbands;
                    for(let i = 0, ii = subbands.length; i < ii; i++){
                        const subband = subbands[i];
                        const codeblocks = subband.codeblocks;
                        for(let j = 0, jj = codeblocks.length; j < jj; j++){
                            const codeblock = codeblocks[j];
                            if (codeblock.precinctNumber !== precinctNumber) continue;
                            precinctCodeblocks.push(codeblock);
                        }
                    }
                    return {
                        layerNumber: layerNumber,
                        codeblocks: precinctCodeblocks
                    };
                }
                function LayerResolutionComponentPositionIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let maxDecompositionLevelsCount = 0;
                    for(let q = 0; q < componentsCount; q++)maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                    let l = 0, r = 0, i = 0, k = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; l < layersCount; l++){
                            for(; r <= maxDecompositionLevelsCount; r++){
                                for(; i < componentsCount; i++){
                                    const component = tile.components[i];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    for(; k < numprecincts;){
                                        const packet = createPacket(resolution, k, l);
                                        k++;
                                        return packet;
                                    }
                                    k = 0;
                                }
                                i = 0;
                            }
                            r = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionLayerComponentPositionIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let maxDecompositionLevelsCount = 0;
                    for(let q = 0; q < componentsCount; q++)maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, tile.components[q].codingStyleParameters.decompositionLevelsCount);
                    let r = 0, l = 0, i = 0, k = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; r <= maxDecompositionLevelsCount; r++){
                            for(; l < layersCount; l++){
                                for(; i < componentsCount; i++){
                                    const component = tile.components[i];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    for(; k < numprecincts;){
                                        const packet = createPacket(resolution, k, l);
                                        k++;
                                        return packet;
                                    }
                                    k = 0;
                                }
                                i = 0;
                            }
                            l = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ResolutionPositionComponentLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    let l, r, c, p;
                    let maxDecompositionLevelsCount = 0;
                    for(c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        maxDecompositionLevelsCount = Math.max(maxDecompositionLevelsCount, component.codingStyleParameters.decompositionLevelsCount);
                    }
                    const maxNumPrecinctsInLevel = new Int32Array(maxDecompositionLevelsCount + 1);
                    for(r = 0; r <= maxDecompositionLevelsCount; ++r){
                        let maxNumPrecincts = 0;
                        for(c = 0; c < componentsCount; ++c){
                            const resolutions = tile.components[c].resolutions;
                            if (r < resolutions.length) maxNumPrecincts = Math.max(maxNumPrecincts, resolutions[r].precinctParameters.numprecincts);
                        }
                        maxNumPrecinctsInLevel[r] = maxNumPrecincts;
                    }
                    l = 0;
                    r = 0;
                    c = 0;
                    p = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; r <= maxDecompositionLevelsCount; r++){
                            for(; p < maxNumPrecinctsInLevel[r]; p++){
                                for(; c < componentsCount; c++){
                                    const component = tile.components[c];
                                    if (r > component.codingStyleParameters.decompositionLevelsCount) continue;
                                    const resolution = component.resolutions[r];
                                    const numprecincts = resolution.precinctParameters.numprecincts;
                                    if (p >= numprecincts) continue;
                                    for(; l < layersCount;){
                                        const packet = createPacket(resolution, p, l);
                                        l++;
                                        return packet;
                                    }
                                    l = 0;
                                }
                                c = 0;
                            }
                            p = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function PositionComponentResolutionLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    const precinctsSizes = getPrecinctSizesInImageScale(tile);
                    const precinctsIterationSizes = precinctsSizes;
                    let l = 0, r = 0, c = 0, px = 0, py = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; py < precinctsIterationSizes.maxNumHigh; py++){
                            for(; px < precinctsIterationSizes.maxNumWide; px++){
                                for(; c < componentsCount; c++){
                                    const component = tile.components[c];
                                    const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                                    for(; r <= decompositionLevelsCount; r++){
                                        const resolution = component.resolutions[r];
                                        const sizeInImageScale = precinctsSizes.components[c].resolutions[r];
                                        const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                                        if (k === null) continue;
                                        for(; l < layersCount;){
                                            const packet = createPacket(resolution, k, l);
                                            l++;
                                            return packet;
                                        }
                                        l = 0;
                                    }
                                    r = 0;
                                }
                                c = 0;
                            }
                            px = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function ComponentPositionResolutionLayerIterator(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const layersCount = tile.codingStyleDefaultParameters.layersCount;
                    const componentsCount = siz.Csiz;
                    const precinctsSizes = getPrecinctSizesInImageScale(tile);
                    let l = 0, r = 0, c = 0, px = 0, py = 0;
                    this.nextPacket = function JpxImage_nextPacket() {
                        for(; c < componentsCount; ++c){
                            const component = tile.components[c];
                            const precinctsIterationSizes = precinctsSizes.components[c];
                            const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                            for(; py < precinctsIterationSizes.maxNumHigh; py++){
                                for(; px < precinctsIterationSizes.maxNumWide; px++){
                                    for(; r <= decompositionLevelsCount; r++){
                                        const resolution = component.resolutions[r];
                                        const sizeInImageScale = precinctsIterationSizes.resolutions[r];
                                        const k = getPrecinctIndexIfExist(px, py, sizeInImageScale, precinctsIterationSizes, resolution);
                                        if (k === null) continue;
                                        for(; l < layersCount;){
                                            const packet = createPacket(resolution, k, l);
                                            l++;
                                            return packet;
                                        }
                                        l = 0;
                                    }
                                    r = 0;
                                }
                                px = 0;
                            }
                            py = 0;
                        }
                        throw new JpxError("Out of packets");
                    };
                }
                function getPrecinctIndexIfExist(pxIndex, pyIndex, sizeInImageScale, precinctIterationSizes, resolution) {
                    const posX = pxIndex * precinctIterationSizes.minWidth;
                    const posY = pyIndex * precinctIterationSizes.minHeight;
                    if (posX % sizeInImageScale.width !== 0 || posY % sizeInImageScale.height !== 0) return null;
                    const startPrecinctRowIndex = posY / sizeInImageScale.width * resolution.precinctParameters.numprecinctswide;
                    return posX / sizeInImageScale.height + startPrecinctRowIndex;
                }
                function getPrecinctSizesInImageScale(tile) {
                    const componentsCount = tile.components.length;
                    let minWidth = Number.MAX_VALUE;
                    let minHeight = Number.MAX_VALUE;
                    let maxNumWide = 0;
                    let maxNumHigh = 0;
                    const sizePerComponent = new Array(componentsCount);
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                        const sizePerResolution = new Array(decompositionLevelsCount + 1);
                        let minWidthCurrentComponent = Number.MAX_VALUE;
                        let minHeightCurrentComponent = Number.MAX_VALUE;
                        let maxNumWideCurrentComponent = 0;
                        let maxNumHighCurrentComponent = 0;
                        let scale = 1;
                        for(let r = decompositionLevelsCount; r >= 0; --r){
                            const resolution = component.resolutions[r];
                            const widthCurrentResolution = scale * resolution.precinctParameters.precinctWidth;
                            const heightCurrentResolution = scale * resolution.precinctParameters.precinctHeight;
                            minWidthCurrentComponent = Math.min(minWidthCurrentComponent, widthCurrentResolution);
                            minHeightCurrentComponent = Math.min(minHeightCurrentComponent, heightCurrentResolution);
                            maxNumWideCurrentComponent = Math.max(maxNumWideCurrentComponent, resolution.precinctParameters.numprecinctswide);
                            maxNumHighCurrentComponent = Math.max(maxNumHighCurrentComponent, resolution.precinctParameters.numprecinctshigh);
                            sizePerResolution[r] = {
                                width: widthCurrentResolution,
                                height: heightCurrentResolution
                            };
                            scale <<= 1;
                        }
                        minWidth = Math.min(minWidth, minWidthCurrentComponent);
                        minHeight = Math.min(minHeight, minHeightCurrentComponent);
                        maxNumWide = Math.max(maxNumWide, maxNumWideCurrentComponent);
                        maxNumHigh = Math.max(maxNumHigh, maxNumHighCurrentComponent);
                        sizePerComponent[c] = {
                            resolutions: sizePerResolution,
                            minWidth: minWidthCurrentComponent,
                            minHeight: minHeightCurrentComponent,
                            maxNumWide: maxNumWideCurrentComponent,
                            maxNumHigh: maxNumHighCurrentComponent
                        };
                    }
                    return {
                        components: sizePerComponent,
                        minWidth: minWidth,
                        minHeight: minHeight,
                        maxNumWide: maxNumWide,
                        maxNumHigh: maxNumHigh
                    };
                }
                function buildPackets(context) {
                    const siz = context.SIZ;
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const componentsCount = siz.Csiz;
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const decompositionLevelsCount = component.codingStyleParameters.decompositionLevelsCount;
                        const resolutions = [];
                        const subbands = [];
                        for(let r = 0; r <= decompositionLevelsCount; r++){
                            const blocksDimensions = getBlocksDimensions(context, component, r);
                            const resolution = {};
                            const scale = 1 << decompositionLevelsCount - r;
                            resolution.trx0 = Math.ceil(component.tcx0 / scale);
                            resolution.try0 = Math.ceil(component.tcy0 / scale);
                            resolution.trx1 = Math.ceil(component.tcx1 / scale);
                            resolution.try1 = Math.ceil(component.tcy1 / scale);
                            resolution.resLevel = r;
                            buildPrecincts(context, resolution, blocksDimensions);
                            resolutions.push(resolution);
                            let subband;
                            if (r === 0) {
                                subband = {};
                                subband.type = "LL";
                                subband.tbx0 = Math.ceil(component.tcx0 / scale);
                                subband.tby0 = Math.ceil(component.tcy0 / scale);
                                subband.tbx1 = Math.ceil(component.tcx1 / scale);
                                subband.tby1 = Math.ceil(component.tcy1 / scale);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolution.subbands = [
                                    subband
                                ];
                            } else {
                                const bscale = 1 << decompositionLevelsCount - r + 1;
                                const resolutionSubbands = [];
                                subband = {};
                                subband.type = "HL";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                subband = {};
                                subband.type = "LH";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                subband = {};
                                subband.type = "HH";
                                subband.tbx0 = Math.ceil(component.tcx0 / bscale - 0.5);
                                subband.tby0 = Math.ceil(component.tcy0 / bscale - 0.5);
                                subband.tbx1 = Math.ceil(component.tcx1 / bscale - 0.5);
                                subband.tby1 = Math.ceil(component.tcy1 / bscale - 0.5);
                                subband.resolution = resolution;
                                buildCodeblocks(context, subband, blocksDimensions);
                                subbands.push(subband);
                                resolutionSubbands.push(subband);
                                resolution.subbands = resolutionSubbands;
                            }
                        }
                        component.resolutions = resolutions;
                        component.subbands = subbands;
                    }
                    const progressionOrder = tile.codingStyleDefaultParameters.progressionOrder;
                    switch(progressionOrder){
                        case 0:
                            tile.packetsIterator = new LayerResolutionComponentPositionIterator(context);
                            break;
                        case 1:
                            tile.packetsIterator = new ResolutionLayerComponentPositionIterator(context);
                            break;
                        case 2:
                            tile.packetsIterator = new ResolutionPositionComponentLayerIterator(context);
                            break;
                        case 3:
                            tile.packetsIterator = new PositionComponentResolutionLayerIterator(context);
                            break;
                        case 4:
                            tile.packetsIterator = new ComponentPositionResolutionLayerIterator(context);
                            break;
                        default:
                            throw new JpxError(`Unsupported progression order ${progressionOrder}`);
                    }
                }
                function parseTilePackets(context, data, offset, dataLength) {
                    let position = 0;
                    let buffer, bufferSize = 0, skipNextBit = false;
                    function readBits(count) {
                        while(bufferSize < count){
                            const b = data[offset + position];
                            position++;
                            if (skipNextBit) {
                                buffer = buffer << 7 | b;
                                bufferSize += 7;
                                skipNextBit = false;
                            } else {
                                buffer = buffer << 8 | b;
                                bufferSize += 8;
                            }
                            if (b === 0xff) skipNextBit = true;
                        }
                        bufferSize -= count;
                        return buffer >>> bufferSize & (1 << count) - 1;
                    }
                    function skipMarkerIfEqual(value) {
                        if (data[offset + position - 1] === 0xff && data[offset + position] === value) {
                            skipBytes(1);
                            return true;
                        } else if (data[offset + position] === 0xff && data[offset + position + 1] === value) {
                            skipBytes(2);
                            return true;
                        }
                        return false;
                    }
                    function skipBytes(count) {
                        position += count;
                    }
                    function alignToByte() {
                        bufferSize = 0;
                        if (skipNextBit) {
                            position++;
                            skipNextBit = false;
                        }
                    }
                    function readCodingpasses() {
                        if (readBits(1) === 0) return 1;
                        if (readBits(1) === 0) return 2;
                        let value = readBits(2);
                        if (value < 3) return value + 3;
                        value = readBits(5);
                        if (value < 31) return value + 6;
                        value = readBits(7);
                        return value + 37;
                    }
                    const tileIndex = context.currentTile.index;
                    const tile = context.tiles[tileIndex];
                    const sopMarkerUsed = context.COD.sopMarkerUsed;
                    const ephMarkerUsed = context.COD.ephMarkerUsed;
                    const packetsIterator = tile.packetsIterator;
                    while(position < dataLength){
                        alignToByte();
                        if (sopMarkerUsed && skipMarkerIfEqual(0x91)) skipBytes(4);
                        const packet = packetsIterator.nextPacket();
                        if (!readBits(1)) continue;
                        const layerNumber = packet.layerNumber, queue = [];
                        let codeblock;
                        for(let i = 0, ii = packet.codeblocks.length; i < ii; i++){
                            codeblock = packet.codeblocks[i];
                            let precinct = codeblock.precinct;
                            const codeblockColumn = codeblock.cbx - precinct.cbxMin;
                            const codeblockRow = codeblock.cby - precinct.cbyMin;
                            let codeblockIncluded = false;
                            let firstTimeInclusion = false;
                            let valueReady, zeroBitPlanesTree;
                            if (codeblock.included !== undefined) codeblockIncluded = !!readBits(1);
                            else {
                                precinct = codeblock.precinct;
                                let inclusionTree;
                                if (precinct.inclusionTree !== undefined) inclusionTree = precinct.inclusionTree;
                                else {
                                    const width = precinct.cbxMax - precinct.cbxMin + 1;
                                    const height = precinct.cbyMax - precinct.cbyMin + 1;
                                    inclusionTree = new InclusionTree(width, height, layerNumber);
                                    zeroBitPlanesTree = new TagTree(width, height);
                                    precinct.inclusionTree = inclusionTree;
                                    precinct.zeroBitPlanesTree = zeroBitPlanesTree;
                                }
                                if (inclusionTree.reset(codeblockColumn, codeblockRow, layerNumber)) {
                                    while(true)if (readBits(1)) {
                                        valueReady = !inclusionTree.nextLevel();
                                        if (valueReady) {
                                            codeblock.included = true;
                                            codeblockIncluded = firstTimeInclusion = true;
                                            break;
                                        }
                                    } else {
                                        inclusionTree.incrementValue(layerNumber);
                                        break;
                                    }
                                }
                            }
                            if (!codeblockIncluded) continue;
                            if (firstTimeInclusion) {
                                zeroBitPlanesTree = precinct.zeroBitPlanesTree;
                                zeroBitPlanesTree.reset(codeblockColumn, codeblockRow);
                                while(true)if (readBits(1)) {
                                    valueReady = !zeroBitPlanesTree.nextLevel();
                                    if (valueReady) break;
                                } else zeroBitPlanesTree.incrementValue();
                                codeblock.zeroBitPlanes = zeroBitPlanesTree.value;
                            }
                            const codingpasses = readCodingpasses();
                            while(readBits(1))codeblock.Lblock++;
                            const codingpassesLog2 = (0, _core_utils.log2)(codingpasses);
                            const bits = (codingpasses < 1 << codingpassesLog2 ? codingpassesLog2 - 1 : codingpassesLog2) + codeblock.Lblock;
                            const codedDataLength = readBits(bits);
                            queue.push({
                                codeblock: codeblock,
                                codingpasses: codingpasses,
                                dataLength: codedDataLength
                            });
                        }
                        alignToByte();
                        if (ephMarkerUsed) skipMarkerIfEqual(0x92);
                        while(queue.length > 0){
                            const packetItem = queue.shift();
                            codeblock = packetItem.codeblock;
                            if (codeblock.data === undefined) codeblock.data = [];
                            codeblock.data.push({
                                data: data,
                                start: offset + position,
                                end: offset + position + packetItem.dataLength,
                                codingpasses: packetItem.codingpasses
                            });
                            position += packetItem.dataLength;
                        }
                    }
                    return position;
                }
                function copyCoefficients(coefficients, levelWidth, levelHeight, subband, delta, mb, reversible, segmentationSymbolUsed) {
                    const x0 = subband.tbx0;
                    const y0 = subband.tby0;
                    const width = subband.tbx1 - subband.tbx0;
                    const codeblocks = subband.codeblocks;
                    const right = subband.type.charAt(0) === "H" ? 1 : 0;
                    const bottom = subband.type.charAt(1) === "H" ? levelWidth : 0;
                    for(let i = 0, ii = codeblocks.length; i < ii; ++i){
                        const codeblock = codeblocks[i];
                        const blockWidth = codeblock.tbx1_ - codeblock.tbx0_;
                        const blockHeight = codeblock.tby1_ - codeblock.tby0_;
                        if (blockWidth === 0 || blockHeight === 0) continue;
                        if (codeblock.data === undefined) continue;
                        const bitModel = new BitModel(blockWidth, blockHeight, codeblock.subbandType, codeblock.zeroBitPlanes, mb);
                        let currentCodingpassType = 2;
                        const data = codeblock.data;
                        let totalLength = 0, codingpasses = 0;
                        let j, jj, dataItem;
                        for(j = 0, jj = data.length; j < jj; j++){
                            dataItem = data[j];
                            totalLength += dataItem.end - dataItem.start;
                            codingpasses += dataItem.codingpasses;
                        }
                        const encodedData = new Uint8Array(totalLength);
                        let position = 0;
                        for(j = 0, jj = data.length; j < jj; j++){
                            dataItem = data[j];
                            const chunk = dataItem.data.subarray(dataItem.start, dataItem.end);
                            encodedData.set(chunk, position);
                            position += chunk.length;
                        }
                        const decoder = new _arithmetic_decoder.ArithmeticDecoder(encodedData, 0, totalLength);
                        bitModel.setDecoder(decoder);
                        for(j = 0; j < codingpasses; j++){
                            switch(currentCodingpassType){
                                case 0:
                                    bitModel.runSignificancePropagationPass();
                                    break;
                                case 1:
                                    bitModel.runMagnitudeRefinementPass();
                                    break;
                                case 2:
                                    bitModel.runCleanupPass();
                                    if (segmentationSymbolUsed) bitModel.checkSegmentationSymbol();
                                    break;
                            }
                            currentCodingpassType = (currentCodingpassType + 1) % 3;
                        }
                        let offset = codeblock.tbx0_ - x0 + (codeblock.tby0_ - y0) * width;
                        const sign = bitModel.coefficentsSign;
                        const magnitude = bitModel.coefficentsMagnitude;
                        const bitsDecoded = bitModel.bitsDecoded;
                        const magnitudeCorrection = reversible ? 0 : 0.5;
                        let k, n, nb;
                        position = 0;
                        const interleave = subband.type !== "LL";
                        for(j = 0; j < blockHeight; j++){
                            const row = offset / width | 0;
                            const levelOffset = 2 * row * (levelWidth - width) + right + bottom;
                            for(k = 0; k < blockWidth; k++){
                                n = magnitude[position];
                                if (n !== 0) {
                                    n = (n + magnitudeCorrection) * delta;
                                    if (sign[position] !== 0) n = -n;
                                    nb = bitsDecoded[position];
                                    const pos = interleave ? levelOffset + (offset << 1) : offset;
                                    if (reversible && nb >= mb) coefficients[pos] = n;
                                    else coefficients[pos] = n * (1 << mb - nb);
                                }
                                offset++;
                                position++;
                            }
                            offset += width - blockWidth;
                        }
                    }
                }
                function transformTile(context, tile, c) {
                    const component = tile.components[c];
                    const codingStyleParameters = component.codingStyleParameters;
                    const quantizationParameters = component.quantizationParameters;
                    const decompositionLevelsCount = codingStyleParameters.decompositionLevelsCount;
                    const spqcds = quantizationParameters.SPqcds;
                    const scalarExpounded = quantizationParameters.scalarExpounded;
                    const guardBits = quantizationParameters.guardBits;
                    const segmentationSymbolUsed = codingStyleParameters.segmentationSymbolUsed;
                    const precision = context.components[c].precision;
                    const reversible = codingStyleParameters.reversibleTransformation;
                    const transform = reversible ? new ReversibleTransform() : new IrreversibleTransform();
                    const subbandCoefficients = [];
                    let b = 0;
                    for(let i = 0; i <= decompositionLevelsCount; i++){
                        const resolution = component.resolutions[i];
                        const width = resolution.trx1 - resolution.trx0;
                        const height = resolution.try1 - resolution.try0;
                        const coefficients = new Float32Array(width * height);
                        for(let j = 0, jj = resolution.subbands.length; j < jj; j++){
                            let mu, epsilon;
                            if (!scalarExpounded) {
                                mu = spqcds[0].mu;
                                epsilon = spqcds[0].epsilon + (i > 0 ? 1 - i : 0);
                            } else {
                                mu = spqcds[b].mu;
                                epsilon = spqcds[b].epsilon;
                                b++;
                            }
                            const subband = resolution.subbands[j];
                            const gainLog2 = SubbandsGainLog2[subband.type];
                            const delta = reversible ? 1 : 2 ** (precision + gainLog2 - epsilon) * (1 + mu / 2048);
                            const mb = guardBits + epsilon - 1;
                            copyCoefficients(coefficients, width, height, subband, delta, mb, reversible, segmentationSymbolUsed);
                        }
                        subbandCoefficients.push({
                            width: width,
                            height: height,
                            items: coefficients
                        });
                    }
                    const result = transform.calculate(subbandCoefficients, component.tcx0, component.tcy0);
                    return {
                        left: component.tcx0,
                        top: component.tcy0,
                        width: result.width,
                        height: result.height,
                        items: result.items
                    };
                }
                function transformComponents(context) {
                    const siz = context.SIZ;
                    const components = context.components;
                    const componentsCount = siz.Csiz;
                    const resultImages = [];
                    for(let i = 0, ii = context.tiles.length; i < ii; i++){
                        const tile = context.tiles[i];
                        const transformedTiles = [];
                        for(let c = 0; c < componentsCount; c++)transformedTiles[c] = transformTile(context, tile, c);
                        const tile0 = transformedTiles[0];
                        const out = new Uint8ClampedArray(tile0.items.length * componentsCount);
                        const result = {
                            left: tile0.left,
                            top: tile0.top,
                            width: tile0.width,
                            height: tile0.height,
                            items: out
                        };
                        let shift, offset;
                        let pos = 0, j, jj, y0, y1, y2;
                        if (tile.codingStyleDefaultParameters.multipleComponentTransform) {
                            const fourComponents = componentsCount === 4;
                            const y0items = transformedTiles[0].items;
                            const y1items = transformedTiles[1].items;
                            const y2items = transformedTiles[2].items;
                            const y3items = fourComponents ? transformedTiles[3].items : null;
                            shift = components[0].precision - 8;
                            offset = (128 << shift) + 0.5;
                            const component0 = tile.components[0];
                            const alpha01 = componentsCount - 3;
                            jj = y0items.length;
                            if (!component0.codingStyleParameters.reversibleTransformation) for(j = 0; j < jj; j++, pos += alpha01){
                                y0 = y0items[j] + offset;
                                y1 = y1items[j];
                                y2 = y2items[j];
                                out[pos++] = y0 + 1.402 * y2 >> shift;
                                out[pos++] = y0 - 0.34413 * y1 - 0.71414 * y2 >> shift;
                                out[pos++] = y0 + 1.772 * y1 >> shift;
                            }
                            else for(j = 0; j < jj; j++, pos += alpha01){
                                y0 = y0items[j] + offset;
                                y1 = y1items[j];
                                y2 = y2items[j];
                                const g = y0 - (y2 + y1 >> 2);
                                out[pos++] = g + y2 >> shift;
                                out[pos++] = g >> shift;
                                out[pos++] = g + y1 >> shift;
                            }
                            if (fourComponents) for(j = 0, pos = 3; j < jj; j++, pos += 4)out[pos] = y3items[j] + offset >> shift;
                        } else for(let c = 0; c < componentsCount; c++){
                            const items = transformedTiles[c].items;
                            shift = components[c].precision - 8;
                            offset = (128 << shift) + 0.5;
                            for(pos = c, j = 0, jj = items.length; j < jj; j++){
                                out[pos] = items[j] + offset >> shift;
                                pos += componentsCount;
                            }
                        }
                        resultImages.push(result);
                    }
                    return resultImages;
                }
                function initializeTile(context, tileIndex) {
                    const siz = context.SIZ;
                    const componentsCount = siz.Csiz;
                    const tile = context.tiles[tileIndex];
                    for(let c = 0; c < componentsCount; c++){
                        const component = tile.components[c];
                        const qcdOrQcc = context.currentTile.QCC[c] !== undefined ? context.currentTile.QCC[c] : context.currentTile.QCD;
                        component.quantizationParameters = qcdOrQcc;
                        const codOrCoc = context.currentTile.COC[c] !== undefined ? context.currentTile.COC[c] : context.currentTile.COD;
                        component.codingStyleParameters = codOrCoc;
                    }
                    tile.codingStyleDefaultParameters = context.currentTile.COD;
                }
                class TagTree {
                    constructor(width, height){
                        const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                        this.levels = [];
                        for(let i = 0; i < levelsLength; i++){
                            const level = {
                                width: width,
                                height: height,
                                items: []
                            };
                            this.levels.push(level);
                            width = Math.ceil(width / 2);
                            height = Math.ceil(height / 2);
                        }
                    }
                    reset(i, j) {
                        let currentLevel = 0, value = 0, level;
                        while(currentLevel < this.levels.length){
                            level = this.levels[currentLevel];
                            const index = i + j * level.width;
                            if (level.items[index] !== undefined) {
                                value = level.items[index];
                                break;
                            }
                            level.index = index;
                            i >>= 1;
                            j >>= 1;
                            currentLevel++;
                        }
                        currentLevel--;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        this.currentLevel = currentLevel;
                        delete this.value;
                    }
                    incrementValue() {
                        const level = this.levels[this.currentLevel];
                        level.items[level.index]++;
                    }
                    nextLevel() {
                        let currentLevel = this.currentLevel;
                        let level = this.levels[currentLevel];
                        const value = level.items[level.index];
                        currentLevel--;
                        if (currentLevel < 0) {
                            this.value = value;
                            return false;
                        }
                        this.currentLevel = currentLevel;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        return true;
                    }
                }
                class InclusionTree {
                    constructor(width, height, defaultValue){
                        const levelsLength = (0, _core_utils.log2)(Math.max(width, height)) + 1;
                        this.levels = [];
                        for(let i = 0; i < levelsLength; i++){
                            const items = new Uint8Array(width * height);
                            for(let j = 0, jj = items.length; j < jj; j++)items[j] = defaultValue;
                            const level = {
                                width: width,
                                height: height,
                                items: items
                            };
                            this.levels.push(level);
                            width = Math.ceil(width / 2);
                            height = Math.ceil(height / 2);
                        }
                    }
                    reset(i, j, stopValue) {
                        let currentLevel = 0;
                        while(currentLevel < this.levels.length){
                            const level = this.levels[currentLevel];
                            const index = i + j * level.width;
                            level.index = index;
                            const value = level.items[index];
                            if (value === 0xff) break;
                            if (value > stopValue) {
                                this.currentLevel = currentLevel;
                                this.propagateValues();
                                return false;
                            }
                            i >>= 1;
                            j >>= 1;
                            currentLevel++;
                        }
                        this.currentLevel = currentLevel - 1;
                        return true;
                    }
                    incrementValue(stopValue) {
                        const level = this.levels[this.currentLevel];
                        level.items[level.index] = stopValue + 1;
                        this.propagateValues();
                    }
                    propagateValues() {
                        let levelIndex = this.currentLevel;
                        let level = this.levels[levelIndex];
                        const currentValue = level.items[level.index];
                        while(--levelIndex >= 0){
                            level = this.levels[levelIndex];
                            level.items[level.index] = currentValue;
                        }
                    }
                    nextLevel() {
                        let currentLevel = this.currentLevel;
                        let level = this.levels[currentLevel];
                        const value = level.items[level.index];
                        level.items[level.index] = 0xff;
                        currentLevel--;
                        if (currentLevel < 0) return false;
                        this.currentLevel = currentLevel;
                        level = this.levels[currentLevel];
                        level.items[level.index] = value;
                        return true;
                    }
                }
                const BitModel = function BitModelClosure() {
                    const UNIFORM_CONTEXT = 17;
                    const RUNLENGTH_CONTEXT = 18;
                    const LLAndLHContextsLabel = new Uint8Array([
                        0,
                        5,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        6,
                        8,
                        0,
                        3,
                        7,
                        8,
                        0,
                        4,
                        7,
                        8
                    ]);
                    const HLContextLabel = new Uint8Array([
                        0,
                        3,
                        4,
                        0,
                        5,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        3,
                        4,
                        0,
                        6,
                        7,
                        7,
                        0,
                        8,
                        8,
                        8
                    ]);
                    const HHContextLabel = new Uint8Array([
                        0,
                        1,
                        2,
                        0,
                        1,
                        2,
                        2,
                        0,
                        2,
                        2,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        4,
                        5,
                        0,
                        4,
                        5,
                        5,
                        0,
                        5,
                        5,
                        5,
                        0,
                        0,
                        0,
                        0,
                        0,
                        6,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        7,
                        7,
                        7,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        0,
                        0,
                        0,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8,
                        0,
                        8,
                        8,
                        8
                    ]);
                    class BitModel {
                        constructor(width, height, subband, zeroBitPlanes, mb){
                            this.width = width;
                            this.height = height;
                            let contextLabelTable;
                            if (subband === "HH") contextLabelTable = HHContextLabel;
                            else if (subband === "HL") contextLabelTable = HLContextLabel;
                            else contextLabelTable = LLAndLHContextsLabel;
                            this.contextLabelTable = contextLabelTable;
                            const coefficientCount = width * height;
                            this.neighborsSignificance = new Uint8Array(coefficientCount);
                            this.coefficentsSign = new Uint8Array(coefficientCount);
                            let coefficentsMagnitude;
                            if (mb > 14) coefficentsMagnitude = new Uint32Array(coefficientCount);
                            else if (mb > 6) coefficentsMagnitude = new Uint16Array(coefficientCount);
                            else coefficentsMagnitude = new Uint8Array(coefficientCount);
                            this.coefficentsMagnitude = coefficentsMagnitude;
                            this.processingFlags = new Uint8Array(coefficientCount);
                            const bitsDecoded = new Uint8Array(coefficientCount);
                            if (zeroBitPlanes !== 0) for(let i = 0; i < coefficientCount; i++)bitsDecoded[i] = zeroBitPlanes;
                            this.bitsDecoded = bitsDecoded;
                            this.reset();
                        }
                        setDecoder(decoder) {
                            this.decoder = decoder;
                        }
                        reset() {
                            this.contexts = new Int8Array(19);
                            this.contexts[0] = 8;
                            this.contexts[UNIFORM_CONTEXT] = 92;
                            this.contexts[RUNLENGTH_CONTEXT] = 6;
                        }
                        setNeighborsSignificance(row, column, index) {
                            const neighborsSignificance = this.neighborsSignificance;
                            const width = this.width, height = this.height;
                            const left = column > 0;
                            const right = column + 1 < width;
                            let i;
                            if (row > 0) {
                                i = index - width;
                                if (left) neighborsSignificance[i - 1] += 0x10;
                                if (right) neighborsSignificance[i + 1] += 0x10;
                                neighborsSignificance[i] += 0x04;
                            }
                            if (row + 1 < height) {
                                i = index + width;
                                if (left) neighborsSignificance[i - 1] += 0x10;
                                if (right) neighborsSignificance[i + 1] += 0x10;
                                neighborsSignificance[i] += 0x04;
                            }
                            if (left) neighborsSignificance[index - 1] += 0x01;
                            if (right) neighborsSignificance[index + 1] += 0x01;
                            neighborsSignificance[index] |= 0x80;
                        }
                        runSignificancePropagationPass() {
                            const decoder = this.decoder;
                            const width = this.width, height = this.height;
                            const coefficentsMagnitude = this.coefficentsMagnitude;
                            const coefficentsSign = this.coefficentsSign;
                            const neighborsSignificance = this.neighborsSignificance;
                            const processingFlags = this.processingFlags;
                            const contexts = this.contexts;
                            const labels = this.contextLabelTable;
                            const bitsDecoded = this.bitsDecoded;
                            const processedInverseMask = -2;
                            const processedMask = 1;
                            const firstMagnitudeBitMask = 2;
                            for(let i0 = 0; i0 < height; i0 += 4)for(let j = 0; j < width; j++){
                                let index = i0 * width + j;
                                for(let i1 = 0; i1 < 4; i1++, index += width){
                                    const i = i0 + i1;
                                    if (i >= height) break;
                                    processingFlags[index] &= processedInverseMask;
                                    if (coefficentsMagnitude[index] || !neighborsSignificance[index]) continue;
                                    const contextLabel = labels[neighborsSignificance[index]];
                                    const decision = decoder.readBit(contexts, contextLabel);
                                    if (decision) {
                                        const sign = this.decodeSignBit(i, j, index);
                                        coefficentsSign[index] = sign;
                                        coefficentsMagnitude[index] = 1;
                                        this.setNeighborsSignificance(i, j, index);
                                        processingFlags[index] |= firstMagnitudeBitMask;
                                    }
                                    bitsDecoded[index]++;
                                    processingFlags[index] |= processedMask;
                                }
                            }
                        }
                        decodeSignBit(row, column, index) {
                            const width = this.width, height = this.height;
                            const coefficentsMagnitude = this.coefficentsMagnitude;
                            const coefficentsSign = this.coefficentsSign;
                            let contribution, sign0, sign1, significance1;
                            let contextLabel, decoded;
                            significance1 = column > 0 && coefficentsMagnitude[index - 1] !== 0;
                            if (column + 1 < width && coefficentsMagnitude[index + 1] !== 0) {
                                sign1 = coefficentsSign[index + 1];
                                if (significance1) {
                                    sign0 = coefficentsSign[index - 1];
                                    contribution = 1 - sign1 - sign0;
                                } else contribution = 1 - sign1 - sign1;
                            } else if (significance1) {
                                sign0 = coefficentsSign[index - 1];
                                contribution = 1 - sign0 - sign0;
                            } else contribution = 0;
                            const horizontalContribution = 3 * contribution;
                            significance1 = row > 0 && coefficentsMagnitude[index - width] !== 0;
                            if (row + 1 < height && coefficentsMagnitude[index + width] !== 0) {
                                sign1 = coefficentsSign[index + width];
                                if (significance1) {
                                    sign0 = coefficentsSign[index - width];
                                    contribution = 1 - sign1 - sign0 + horizontalContribution;
                                } else contribution = 1 - sign1 - sign1 + horizontalContribution;
                            } else if (significance1) {
                                sign0 = coefficentsSign[index - width];
                                contribution = 1 - sign0 - sign0 + horizontalContribution;
                            } else contribution = horizontalContribution;
                            if (contribution >= 0) {
                                contextLabel = 9 + contribution;
                                decoded = this.decoder.readBit(this.contexts, contextLabel);
                            } else {
                                contextLabel = 9 - contribution;
                                decoded = this.decoder.readBit(this.contexts, contextLabel) ^ 1;
                            }
                            return decoded;
                        }
                        runMagnitudeRefinementPass() {
                            const decoder = this.decoder;
                            const width = this.width, height = this.height;
                            const coefficentsMagnitude = this.coefficentsMagnitude;
                            const neighborsSignificance = this.neighborsSignificance;
                            const contexts = this.contexts;
                            const bitsDecoded = this.bitsDecoded;
                            const processingFlags = this.processingFlags;
                            const processedMask = 1;
                            const firstMagnitudeBitMask = 2;
                            const length = width * height;
                            const width4 = width * 4;
                            for(let index0 = 0, indexNext; index0 < length; index0 = indexNext){
                                indexNext = Math.min(length, index0 + width4);
                                for(let j = 0; j < width; j++)for(let index = index0 + j; index < indexNext; index += width){
                                    if (!coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) continue;
                                    let contextLabel = 16;
                                    if ((processingFlags[index] & firstMagnitudeBitMask) !== 0) {
                                        processingFlags[index] ^= firstMagnitudeBitMask;
                                        const significance = neighborsSignificance[index] & 127;
                                        contextLabel = significance === 0 ? 15 : 14;
                                    }
                                    const bit = decoder.readBit(contexts, contextLabel);
                                    coefficentsMagnitude[index] = coefficentsMagnitude[index] << 1 | bit;
                                    bitsDecoded[index]++;
                                    processingFlags[index] |= processedMask;
                                }
                            }
                        }
                        runCleanupPass() {
                            const decoder = this.decoder;
                            const width = this.width, height = this.height;
                            const neighborsSignificance = this.neighborsSignificance;
                            const coefficentsMagnitude = this.coefficentsMagnitude;
                            const coefficentsSign = this.coefficentsSign;
                            const contexts = this.contexts;
                            const labels = this.contextLabelTable;
                            const bitsDecoded = this.bitsDecoded;
                            const processingFlags = this.processingFlags;
                            const processedMask = 1;
                            const firstMagnitudeBitMask = 2;
                            const oneRowDown = width;
                            const twoRowsDown = width * 2;
                            const threeRowsDown = width * 3;
                            let iNext;
                            for(let i0 = 0; i0 < height; i0 = iNext){
                                iNext = Math.min(i0 + 4, height);
                                const indexBase = i0 * width;
                                const checkAllEmpty = i0 + 3 < height;
                                for(let j = 0; j < width; j++){
                                    const index0 = indexBase + j;
                                    const allEmpty = checkAllEmpty && processingFlags[index0] === 0 && processingFlags[index0 + oneRowDown] === 0 && processingFlags[index0 + twoRowsDown] === 0 && processingFlags[index0 + threeRowsDown] === 0 && neighborsSignificance[index0] === 0 && neighborsSignificance[index0 + oneRowDown] === 0 && neighborsSignificance[index0 + twoRowsDown] === 0 && neighborsSignificance[index0 + threeRowsDown] === 0;
                                    let i1 = 0, index = index0;
                                    let i = i0, sign;
                                    if (allEmpty) {
                                        const hasSignificantCoefficent = decoder.readBit(contexts, RUNLENGTH_CONTEXT);
                                        if (!hasSignificantCoefficent) {
                                            bitsDecoded[index0]++;
                                            bitsDecoded[index0 + oneRowDown]++;
                                            bitsDecoded[index0 + twoRowsDown]++;
                                            bitsDecoded[index0 + threeRowsDown]++;
                                            continue;
                                        }
                                        i1 = decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
                                        if (i1 !== 0) {
                                            i = i0 + i1;
                                            index += i1 * width;
                                        }
                                        sign = this.decodeSignBit(i, j, index);
                                        coefficentsSign[index] = sign;
                                        coefficentsMagnitude[index] = 1;
                                        this.setNeighborsSignificance(i, j, index);
                                        processingFlags[index] |= firstMagnitudeBitMask;
                                        index = index0;
                                        for(let i2 = i0; i2 <= i; i2++, index += width)bitsDecoded[index]++;
                                        i1++;
                                    }
                                    for(i = i0 + i1; i < iNext; i++, index += width){
                                        if (coefficentsMagnitude[index] || (processingFlags[index] & processedMask) !== 0) continue;
                                        const contextLabel = labels[neighborsSignificance[index]];
                                        const decision = decoder.readBit(contexts, contextLabel);
                                        if (decision === 1) {
                                            sign = this.decodeSignBit(i, j, index);
                                            coefficentsSign[index] = sign;
                                            coefficentsMagnitude[index] = 1;
                                            this.setNeighborsSignificance(i, j, index);
                                            processingFlags[index] |= firstMagnitudeBitMask;
                                        }
                                        bitsDecoded[index]++;
                                    }
                                }
                            }
                        }
                        checkSegmentationSymbol() {
                            const decoder = this.decoder;
                            const contexts = this.contexts;
                            const symbol = decoder.readBit(contexts, UNIFORM_CONTEXT) << 3 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 2 | decoder.readBit(contexts, UNIFORM_CONTEXT) << 1 | decoder.readBit(contexts, UNIFORM_CONTEXT);
                            if (symbol !== 0xa) throw new JpxError("Invalid segmentation symbol");
                        }
                    }
                    return BitModel;
                }();
                class Transform {
                    constructor(){
                        if (this.constructor === Transform) (0, _util.unreachable)("Cannot initialize Transform.");
                    }
                    calculate(subbands, u0, v0) {
                        let ll = subbands[0];
                        for(let i = 1, ii = subbands.length; i < ii; i++)ll = this.iterate(ll, subbands[i], u0, v0);
                        return ll;
                    }
                    extend(buffer, offset, size) {
                        let i1 = offset - 1, j1 = offset + 1;
                        let i2 = offset + size - 2, j2 = offset + size;
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1--] = buffer[j1++];
                        buffer[j2++] = buffer[i2--];
                        buffer[i1] = buffer[j1];
                        buffer[j2] = buffer[i2];
                    }
                    filter(x, offset, length) {
                        (0, _util.unreachable)("Abstract method `filter` called");
                    }
                    iterate(ll, hl_lh_hh, u0, v0) {
                        const llWidth = ll.width, llHeight = ll.height;
                        let llItems = ll.items;
                        const width = hl_lh_hh.width;
                        const height = hl_lh_hh.height;
                        const items = hl_lh_hh.items;
                        let i, j, k, l, u, v;
                        for(k = 0, i = 0; i < llHeight; i++){
                            l = i * 2 * width;
                            for(j = 0; j < llWidth; j++, k++, l += 2)items[l] = llItems[k];
                        }
                        llItems = ll.items = null;
                        const bufferPadding = 4;
                        const rowBuffer = new Float32Array(width + 2 * bufferPadding);
                        if (width === 1) {
                            if ((u0 & 1) !== 0) for(v = 0, k = 0; v < height; v++, k += width)items[k] *= 0.5;
                        } else for(v = 0, k = 0; v < height; v++, k += width){
                            rowBuffer.set(items.subarray(k, k + width), bufferPadding);
                            this.extend(rowBuffer, bufferPadding, width);
                            this.filter(rowBuffer, bufferPadding, width);
                            items.set(rowBuffer.subarray(bufferPadding, bufferPadding + width), k);
                        }
                        let numBuffers = 16;
                        const colBuffers = [];
                        for(i = 0; i < numBuffers; i++)colBuffers.push(new Float32Array(height + 2 * bufferPadding));
                        let b, currentBuffer = 0;
                        ll = bufferPadding + height;
                        if (height === 1) {
                            if ((v0 & 1) !== 0) for(u = 0; u < width; u++)items[u] *= 0.5;
                        } else for(u = 0; u < width; u++){
                            if (currentBuffer === 0) {
                                numBuffers = Math.min(width - u, numBuffers);
                                for(k = u, l = bufferPadding; l < ll; k += width, l++)for(b = 0; b < numBuffers; b++)colBuffers[b][l] = items[k + b];
                                currentBuffer = numBuffers;
                            }
                            currentBuffer--;
                            const buffer = colBuffers[currentBuffer];
                            this.extend(buffer, bufferPadding, height);
                            this.filter(buffer, bufferPadding, height);
                            if (currentBuffer === 0) {
                                k = u - numBuffers + 1;
                                for(l = bufferPadding; l < ll; k += width, l++)for(b = 0; b < numBuffers; b++)items[k + b] = colBuffers[b][l];
                            }
                        }
                        return {
                            width: width,
                            height: height,
                            items: items
                        };
                    }
                }
                class IrreversibleTransform extends Transform {
                    filter(x, offset, length) {
                        const len = length >> 1;
                        offset |= 0;
                        let j, n, current, next;
                        const alpha = -1.586134342059924;
                        const beta = -0.052980118572961;
                        const gamma = 0.882911075530934;
                        const delta = 0.443506852043971;
                        const K = 1.230174104914001;
                        const K_ = 1 / K;
                        j = offset - 3;
                        for(n = len + 4; n--; j += 2)x[j] *= K_;
                        j = offset - 2;
                        current = delta * x[j - 1];
                        for(n = len + 3; n--; j += 2){
                            next = delta * x[j + 1];
                            x[j] = K * x[j] - current - next;
                            if (n--) {
                                j += 2;
                                current = delta * x[j + 1];
                                x[j] = K * x[j] - current - next;
                            } else break;
                        }
                        j = offset - 1;
                        current = gamma * x[j - 1];
                        for(n = len + 2; n--; j += 2){
                            next = gamma * x[j + 1];
                            x[j] -= current + next;
                            if (n--) {
                                j += 2;
                                current = gamma * x[j + 1];
                                x[j] -= current + next;
                            } else break;
                        }
                        j = offset;
                        current = beta * x[j - 1];
                        for(n = len + 1; n--; j += 2){
                            next = beta * x[j + 1];
                            x[j] -= current + next;
                            if (n--) {
                                j += 2;
                                current = beta * x[j + 1];
                                x[j] -= current + next;
                            } else break;
                        }
                        if (len !== 0) {
                            j = offset + 1;
                            current = alpha * x[j - 1];
                            for(n = len; n--; j += 2){
                                next = alpha * x[j + 1];
                                x[j] -= current + next;
                                if (n--) {
                                    j += 2;
                                    current = alpha * x[j + 1];
                                    x[j] -= current + next;
                                } else break;
                            }
                        }
                    }
                }
                class ReversibleTransform extends Transform {
                    filter(x, offset, length) {
                        const len = length >> 1;
                        offset |= 0;
                        let j, n;
                        for(j = offset, n = len + 1; n--; j += 2)x[j] -= x[j - 1] + x[j + 1] + 2 >> 2;
                        for(j = offset + 1, n = len; n--; j += 2)x[j] += x[j - 1] + x[j + 1] >> 1;
                    }
                }
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LZWStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                class LZWStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, earlyChange){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.cachedData = 0;
                        this.bitsCached = 0;
                        const maxLzwDictionarySize = 4096;
                        const lzwState = {
                            earlyChange: earlyChange,
                            codeLength: 9,
                            nextCode: 258,
                            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
                            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
                            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
                            currentSequence: new Uint8Array(maxLzwDictionarySize),
                            currentSequenceLength: 0
                        };
                        for(let i = 0; i < 256; ++i){
                            lzwState.dictionaryValues[i] = i;
                            lzwState.dictionaryLengths[i] = 1;
                        }
                        this.lzwState = lzwState;
                    }
                    readBits(n) {
                        let bitsCached = this.bitsCached;
                        let cachedData = this.cachedData;
                        while(bitsCached < n){
                            const c = this.str.getByte();
                            if (c === -1) {
                                this.eof = true;
                                return null;
                            }
                            cachedData = cachedData << 8 | c;
                            bitsCached += 8;
                        }
                        this.bitsCached = bitsCached -= n;
                        this.cachedData = cachedData;
                        this.lastCode = null;
                        return cachedData >>> bitsCached & (1 << n) - 1;
                    }
                    readBlock() {
                        const blockSize = 512, decodedSizeDelta = blockSize;
                        let estimatedDecodedSize = blockSize * 2;
                        let i, j, q;
                        const lzwState = this.lzwState;
                        if (!lzwState) return;
                        const earlyChange = lzwState.earlyChange;
                        let nextCode = lzwState.nextCode;
                        const dictionaryValues = lzwState.dictionaryValues;
                        const dictionaryLengths = lzwState.dictionaryLengths;
                        const dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
                        let codeLength = lzwState.codeLength;
                        let prevCode = lzwState.prevCode;
                        const currentSequence = lzwState.currentSequence;
                        let currentSequenceLength = lzwState.currentSequenceLength;
                        let decodedLength = 0;
                        let currentBufferLength = this.bufferLength;
                        let buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                        for(i = 0; i < blockSize; i++){
                            const code = this.readBits(codeLength);
                            const hasPrev = currentSequenceLength > 0;
                            if (code < 256) {
                                currentSequence[0] = code;
                                currentSequenceLength = 1;
                            } else if (code >= 258) {
                                if (code < nextCode) {
                                    currentSequenceLength = dictionaryLengths[code];
                                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                                        currentSequence[j] = dictionaryValues[q];
                                        q = dictionaryPrevCodes[q];
                                    }
                                } else currentSequence[currentSequenceLength++] = currentSequence[0];
                            } else if (code === 256) {
                                codeLength = 9;
                                nextCode = 258;
                                currentSequenceLength = 0;
                                continue;
                            } else {
                                this.eof = true;
                                delete this.lzwState;
                                break;
                            }
                            if (hasPrev) {
                                dictionaryPrevCodes[nextCode] = prevCode;
                                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                                dictionaryValues[nextCode] = currentSequence[0];
                                nextCode++;
                                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
                            }
                            prevCode = code;
                            decodedLength += currentSequenceLength;
                            if (estimatedDecodedSize < decodedLength) {
                                do estimatedDecodedSize += decodedSizeDelta;
                                while (estimatedDecodedSize < decodedLength);
                                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
                            }
                            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
                        }
                        lzwState.nextCode = nextCode;
                        lzwState.codeLength = codeLength;
                        lzwState.prevCode = prevCode;
                        lzwState.currentSequenceLength = currentSequenceLength;
                        this.bufferLength = currentBufferLength;
                    }
                }
                exports.LZWStream = LZWStream;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PredictorStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                class PredictorStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, params){
                        super(maybeLength);
                        if (!(0, _primitives.isDict)(params)) return str;
                        const predictor = this.predictor = params.get("Predictor") || 1;
                        if (predictor <= 1) return str;
                        if (predictor !== 2 && (predictor < 10 || predictor > 15)) throw new _util.FormatError(`Unsupported predictor: ${predictor}`);
                        if (predictor === 2) this.readBlock = this.readBlockTiff;
                        else this.readBlock = this.readBlockPng;
                        this.str = str;
                        this.dict = str.dict;
                        const colors = this.colors = params.get("Colors") || 1;
                        const bits = this.bits = params.get("BitsPerComponent") || 8;
                        const columns = this.columns = params.get("Columns") || 1;
                        this.pixBytes = colors * bits + 7 >> 3;
                        this.rowBytes = columns * colors * bits + 7 >> 3;
                        return this;
                    }
                    readBlockTiff() {
                        const rowBytes = this.rowBytes;
                        const bufferLength = this.bufferLength;
                        const buffer = this.ensureBuffer(bufferLength + rowBytes);
                        const bits = this.bits;
                        const colors = this.colors;
                        const rawBytes = this.str.getBytes(rowBytes);
                        this.eof = !rawBytes.length;
                        if (this.eof) return;
                        let inbuf = 0, outbuf = 0;
                        let inbits = 0, outbits = 0;
                        let pos = bufferLength;
                        let i;
                        if (bits === 1 && colors === 1) for(i = 0; i < rowBytes; ++i){
                            let c = rawBytes[i] ^ inbuf;
                            c ^= c >> 1;
                            c ^= c >> 2;
                            c ^= c >> 4;
                            inbuf = (c & 1) << 7;
                            buffer[pos++] = c;
                        }
                        else if (bits === 8) {
                            for(i = 0; i < colors; ++i)buffer[pos++] = rawBytes[i];
                            for(; i < rowBytes; ++i){
                                buffer[pos] = buffer[pos - colors] + rawBytes[i];
                                pos++;
                            }
                        } else if (bits === 16) {
                            const bytesPerPixel = colors * 2;
                            for(i = 0; i < bytesPerPixel; ++i)buffer[pos++] = rawBytes[i];
                            for(; i < rowBytes; i += 2){
                                const sum = ((rawBytes[i] & 0xff) << 8) + (rawBytes[i + 1] & 0xff) + ((buffer[pos - bytesPerPixel] & 0xff) << 8) + (buffer[pos - bytesPerPixel + 1] & 0xff);
                                buffer[pos++] = sum >> 8 & 0xff;
                                buffer[pos++] = sum & 0xff;
                            }
                        } else {
                            const compArray = new Uint8Array(colors + 1);
                            const bitMask = (1 << bits) - 1;
                            let j = 0, k = bufferLength;
                            const columns = this.columns;
                            for(i = 0; i < columns; ++i)for(let kk = 0; kk < colors; ++kk){
                                if (inbits < bits) {
                                    inbuf = inbuf << 8 | rawBytes[j++] & 0xff;
                                    inbits += 8;
                                }
                                compArray[kk] = compArray[kk] + (inbuf >> inbits - bits) & bitMask;
                                inbits -= bits;
                                outbuf = outbuf << bits | compArray[kk];
                                outbits += bits;
                                if (outbits >= 8) {
                                    buffer[k++] = outbuf >> outbits - 8 & 0xff;
                                    outbits -= 8;
                                }
                            }
                            if (outbits > 0) buffer[k++] = (outbuf << 8 - outbits) + (inbuf & (1 << 8 - outbits) - 1);
                        }
                        this.bufferLength += rowBytes;
                    }
                    readBlockPng() {
                        const rowBytes = this.rowBytes;
                        const pixBytes = this.pixBytes;
                        const predictor = this.str.getByte();
                        const rawBytes = this.str.getBytes(rowBytes);
                        this.eof = !rawBytes.length;
                        if (this.eof) return;
                        const bufferLength = this.bufferLength;
                        const buffer = this.ensureBuffer(bufferLength + rowBytes);
                        let prevRow = buffer.subarray(bufferLength - rowBytes, bufferLength);
                        if (prevRow.length === 0) prevRow = new Uint8Array(rowBytes);
                        let i, j = bufferLength, up, c;
                        switch(predictor){
                            case 0:
                                for(i = 0; i < rowBytes; ++i)buffer[j++] = rawBytes[i];
                                break;
                            case 1:
                                for(i = 0; i < pixBytes; ++i)buffer[j++] = rawBytes[i];
                                for(; i < rowBytes; ++i){
                                    buffer[j] = buffer[j - pixBytes] + rawBytes[i] & 0xff;
                                    j++;
                                }
                                break;
                            case 2:
                                for(i = 0; i < rowBytes; ++i)buffer[j++] = prevRow[i] + rawBytes[i] & 0xff;
                                break;
                            case 3:
                                for(i = 0; i < pixBytes; ++i)buffer[j++] = (prevRow[i] >> 1) + rawBytes[i];
                                for(; i < rowBytes; ++i){
                                    buffer[j] = (prevRow[i] + buffer[j - pixBytes] >> 1) + rawBytes[i] & 0xff;
                                    j++;
                                }
                                break;
                            case 4:
                                for(i = 0; i < pixBytes; ++i){
                                    up = prevRow[i];
                                    c = rawBytes[i];
                                    buffer[j++] = up + c;
                                }
                                for(; i < rowBytes; ++i){
                                    up = prevRow[i];
                                    const upLeft = prevRow[i - pixBytes];
                                    const left = buffer[j - pixBytes];
                                    const p = left + up - upLeft;
                                    let pa = p - left;
                                    if (pa < 0) pa = -pa;
                                    let pb = p - up;
                                    if (pb < 0) pb = -pb;
                                    let pc = p - upLeft;
                                    if (pc < 0) pc = -pc;
                                    c = rawBytes[i];
                                    if (pa <= pb && pa <= pc) buffer[j++] = left + c;
                                    else if (pb <= pc) buffer[j++] = up + c;
                                    else buffer[j++] = upLeft + c;
                                }
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported predictor: ${predictor}`);
                        }
                        this.bufferLength += rowBytes;
                    }
                }
                exports.PredictorStream = PredictorStream;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RunLengthStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                class RunLengthStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                    }
                    readBlock() {
                        const repeatHeader = this.str.getBytes(2);
                        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
                            this.eof = true;
                            return;
                        }
                        let buffer;
                        let bufferLength = this.bufferLength;
                        let n = repeatHeader[0];
                        if (n < 128) {
                            buffer = this.ensureBuffer(bufferLength + n + 1);
                            buffer[bufferLength++] = repeatHeader[1];
                            if (n > 0) {
                                const source = this.str.getBytes(n);
                                buffer.set(source, bufferLength);
                                bufferLength += n;
                            }
                        } else {
                            n = 257 - n;
                            const b = repeatHeader[1];
                            buffer = this.ensureBuffer(bufferLength + n + 1);
                            for(let i = 0; i < n; i++)buffer[bufferLength++] = b;
                        }
                        this.bufferLength = bufferLength;
                    }
                }
                exports.RunLengthStream = RunLengthStream;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Font = exports.ErrorFont = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cff_parser = __w_pdfjs_require__(35);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _glyphlist = __w_pdfjs_require__(39);
                var _encodings = __w_pdfjs_require__(37);
                var _standard_fonts = __w_pdfjs_require__(41);
                var _unicode = __w_pdfjs_require__(40);
                var _to_unicode_map = __w_pdfjs_require__(42);
                var _cff_font = __w_pdfjs_require__(43);
                var _font_renderer = __w_pdfjs_require__(44);
                var _glyf = __w_pdfjs_require__(45);
                var _cmap = __w_pdfjs_require__(16);
                var _opentype_file_builder = __w_pdfjs_require__(46);
                var _core_utils = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(10);
                var _type1_font = __w_pdfjs_require__(47);
                const PRIVATE_USE_AREAS = [
                    [
                        0xe000,
                        0xf8ff
                    ],
                    [
                        0x100000,
                        0x10fffd
                    ]
                ];
                const PDF_GLYPH_SPACE_UNITS = 1000;
                const EXPORT_DATA_PROPERTIES = [
                    "ascent",
                    "bbox",
                    "black",
                    "bold",
                    "charProcOperatorList",
                    "composite",
                    "cssFontInfo",
                    "data",
                    "defaultVMetrics",
                    "defaultWidth",
                    "descent",
                    "fallbackName",
                    "fontMatrix",
                    "fontType",
                    "isMonospace",
                    "isSerifFont",
                    "isType3Font",
                    "italic",
                    "loadedName",
                    "mimetype",
                    "missingFile",
                    "name",
                    "remeasure",
                    "subtype",
                    "type",
                    "vertical"
                ];
                const EXPORT_DATA_EXTRA_PROPERTIES = [
                    "cMap",
                    "defaultEncoding",
                    "differences",
                    "isSymbolicFont",
                    "seacMap",
                    "toFontChar",
                    "toUnicode",
                    "vmetrics",
                    "widths"
                ];
                function adjustWidths(properties) {
                    if (!properties.fontMatrix) return;
                    if (properties.fontMatrix[0] === _util.FONT_IDENTITY_MATRIX[0]) return;
                    const scale = 0.001 / properties.fontMatrix[0];
                    const glyphsWidths = properties.widths;
                    for(const glyph in glyphsWidths)glyphsWidths[glyph] *= scale;
                    properties.defaultWidth *= scale;
                }
                function adjustToUnicode(properties, builtInEncoding) {
                    if (properties.isInternalFont) return;
                    if (builtInEncoding === properties.defaultEncoding) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    const toUnicode = [], glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                    for(const charCode in builtInEncoding){
                        if (properties.hasIncludedToUnicodeMap) {
                            if (properties.toUnicode.has(charCode)) continue;
                        } else {
                            if (properties.hasEncoding && properties.differences[charCode] !== undefined) continue;
                        }
                        const glyphName = builtInEncoding[charCode];
                        const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                        if (unicode !== -1) toUnicode[charCode] = String.fromCharCode(unicode);
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                function amendFallbackToUnicode(properties) {
                    if (!properties.fallbackToUnicode) return;
                    if (properties.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) return;
                    const toUnicode = [];
                    for(const charCode in properties.fallbackToUnicode){
                        if (properties.toUnicode.has(charCode)) continue;
                        toUnicode[charCode] = properties.fallbackToUnicode[charCode];
                    }
                    if (toUnicode.length > 0) properties.toUnicode.amend(toUnicode);
                }
                class Glyph {
                    constructor(originalCharCode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont){
                        this.originalCharCode = originalCharCode;
                        this.fontChar = fontChar;
                        this.unicode = unicode;
                        this.accent = accent;
                        this.width = width;
                        this.vmetric = vmetric;
                        this.operatorListId = operatorListId;
                        this.isSpace = isSpace;
                        this.isInFont = isInFont;
                    }
                    matchesForCache(originalCharCode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont) {
                        return this.originalCharCode === originalCharCode && this.fontChar === fontChar && this.unicode === unicode && this.accent === accent && this.width === width && this.vmetric === vmetric && this.operatorListId === operatorListId && this.isSpace === isSpace && this.isInFont === isInFont;
                    }
                }
                function int16(b0, b1) {
                    return (b0 << 8) + b1;
                }
                function writeSignedInt16(bytes, index, value) {
                    bytes[index + 1] = value;
                    bytes[index] = value >>> 8;
                }
                function signedInt16(b0, b1) {
                    const value = (b0 << 8) + b1;
                    return value & 32768 ? value - 0x10000 : value;
                }
                function int32(b0, b1, b2, b3) {
                    return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
                }
                function string16(value) {
                    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
                }
                function safeString16(value) {
                    if (value > 0x7fff) value = 0x7fff;
                    else if (value < -32768) value = -32768;
                    return String.fromCharCode(value >> 8 & 0xff, value & 0xff);
                }
                function isTrueTypeFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _core_utils.readUint32)(header, 0) === 0x00010000 || (0, _util.bytesToString)(header) === "true";
                }
                function isTrueTypeCollectionFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _util.bytesToString)(header) === "ttcf";
                }
                function isOpenTypeFile(file) {
                    const header = file.peekBytes(4);
                    return (0, _util.bytesToString)(header) === "OTTO";
                }
                function isType1File(file) {
                    const header = file.peekBytes(2);
                    if (header[0] === 0x25 && header[1] === 0x21) return true;
                    if (header[0] === 0x80 && header[1] === 0x01) return true;
                    return false;
                }
                function isCFFFile(file) {
                    const header = file.peekBytes(4);
                    if (header[0] >= 1 && header[3] >= 1 && header[3] <= 4) return true;
                    return false;
                }
                function getFontFileType(file, { type: type , subtype: subtype , composite: composite  }) {
                    let fileType, fileSubtype;
                    if (isTrueTypeFile(file) || isTrueTypeCollectionFile(file)) {
                        if (composite) fileType = "CIDFontType2";
                        else fileType = "TrueType";
                    } else if (isOpenTypeFile(file)) {
                        if (composite) fileType = "CIDFontType2";
                        else fileType = "OpenType";
                    } else if (isType1File(file)) {
                        if (composite) fileType = "CIDFontType0";
                        else fileType = type === "MMType1" ? "MMType1" : "Type1";
                    } else if (isCFFFile(file)) {
                        if (composite) {
                            fileType = "CIDFontType0";
                            fileSubtype = "CIDFontType0C";
                        } else {
                            fileType = type === "MMType1" ? "MMType1" : "Type1";
                            fileSubtype = "Type1C";
                        }
                    } else {
                        (0, _util.warn)("getFontFileType: Unable to detect correct font file Type/Subtype.");
                        fileType = type;
                        fileSubtype = subtype;
                    }
                    return [
                        fileType,
                        fileSubtype
                    ];
                }
                function buildToFontChar(encoding, glyphsUnicodeMap, differences) {
                    const toFontChar = [];
                    let unicode;
                    for(let i = 0, ii = encoding.length; i < ii; i++){
                        unicode = (0, _unicode.getUnicodeForGlyph)(encoding[i], glyphsUnicodeMap);
                        if (unicode !== -1) toFontChar[i] = unicode;
                    }
                    for(const charCode in differences){
                        unicode = (0, _unicode.getUnicodeForGlyph)(differences[charCode], glyphsUnicodeMap);
                        if (unicode !== -1) toFontChar[+charCode] = unicode;
                    }
                    return toFontChar;
                }
                function adjustMapping(charCodeToGlyphId, hasGlyph, newGlyphZeroId) {
                    const newMap = Object.create(null);
                    const toFontChar = [];
                    let privateUseAreaIndex = 0;
                    let nextAvailableFontCharCode = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                    let privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                    for(let originalCharCode in charCodeToGlyphId){
                        originalCharCode |= 0;
                        let glyphId = charCodeToGlyphId[originalCharCode];
                        if (!hasGlyph(glyphId)) continue;
                        if (nextAvailableFontCharCode > privateUseOffetEnd) {
                            privateUseAreaIndex++;
                            if (privateUseAreaIndex >= PRIVATE_USE_AREAS.length) {
                                (0, _util.warn)("Ran out of space in font private use area.");
                                break;
                            }
                            nextAvailableFontCharCode = PRIVATE_USE_AREAS[privateUseAreaIndex][0];
                            privateUseOffetEnd = PRIVATE_USE_AREAS[privateUseAreaIndex][1];
                        }
                        const fontCharCode = nextAvailableFontCharCode++;
                        if (glyphId === 0) glyphId = newGlyphZeroId;
                        newMap[fontCharCode] = glyphId;
                        toFontChar[originalCharCode] = fontCharCode;
                    }
                    return {
                        toFontChar: toFontChar,
                        charCodeToGlyphId: newMap,
                        nextAvailableFontCharCode: nextAvailableFontCharCode
                    };
                }
                function getRanges(glyphs, numGlyphs) {
                    const codes = [];
                    for(const charCode in glyphs){
                        if (glyphs[charCode] >= numGlyphs) continue;
                        codes.push({
                            fontCharCode: charCode | 0,
                            glyphId: glyphs[charCode]
                        });
                    }
                    if (codes.length === 0) codes.push({
                        fontCharCode: 0,
                        glyphId: 0
                    });
                    codes.sort(function fontGetRangesSort(a, b) {
                        return a.fontCharCode - b.fontCharCode;
                    });
                    const ranges = [];
                    const length = codes.length;
                    for(let n = 0; n < length;){
                        const start = codes[n].fontCharCode;
                        const codeIndices = [
                            codes[n].glyphId
                        ];
                        ++n;
                        let end = start;
                        while(n < length && end + 1 === codes[n].fontCharCode){
                            codeIndices.push(codes[n].glyphId);
                            ++end;
                            ++n;
                            if (end === 0xffff) break;
                        }
                        ranges.push([
                            start,
                            end,
                            codeIndices
                        ]);
                    }
                    return ranges;
                }
                function createCmapTable(glyphs, numGlyphs) {
                    const ranges = getRanges(glyphs, numGlyphs);
                    const numTables = ranges[ranges.length - 1][1] > 0xffff ? 2 : 1;
                    let cmap = "\x00\x00" + string16(numTables) + "\x00\x03" + "\x00\x01" + (0, _util.string32)(4 + numTables * 8);
                    let i, ii, j, jj;
                    for(i = ranges.length - 1; i >= 0; --i){
                        if (ranges[i][0] <= 0xffff) break;
                    }
                    const bmpLength = i + 1;
                    if (ranges[i][0] < 0xffff && ranges[i][1] === 0xffff) ranges[i][1] = 0xfffe;
                    const trailingRangesCount = ranges[i][1] < 0xffff ? 1 : 0;
                    const segCount = bmpLength + trailingRangesCount;
                    const searchParams = _opentype_file_builder.OpenTypeFileBuilder.getSearchParams(segCount, 2);
                    let startCount = "";
                    let endCount = "";
                    let idDeltas = "";
                    let idRangeOffsets = "";
                    let glyphsIds = "";
                    let bias = 0;
                    let range, start, end, codes;
                    for(i = 0, ii = bmpLength; i < ii; i++){
                        range = ranges[i];
                        start = range[0];
                        end = range[1];
                        startCount += string16(start);
                        endCount += string16(end);
                        codes = range[2];
                        let contiguous = true;
                        for(j = 1, jj = codes.length; j < jj; ++j)if (codes[j] !== codes[j - 1] + 1) {
                            contiguous = false;
                            break;
                        }
                        if (!contiguous) {
                            const offset = (segCount - i) * 2 + bias * 2;
                            bias += end - start + 1;
                            idDeltas += string16(0);
                            idRangeOffsets += string16(offset);
                            for(j = 0, jj = codes.length; j < jj; ++j)glyphsIds += string16(codes[j]);
                        } else {
                            const startCode = codes[0];
                            idDeltas += string16(startCode - start & 0xffff);
                            idRangeOffsets += string16(0);
                        }
                    }
                    if (trailingRangesCount > 0) {
                        endCount += "\xff\xff";
                        startCount += "\xff\xff";
                        idDeltas += "\x00\x01";
                        idRangeOffsets += "\x00\x00";
                    }
                    const format314 = "\x00\x00" + string16(2 * segCount) + string16(searchParams.range) + string16(searchParams.entry) + string16(searchParams.rangeShift) + endCount + "\x00\x00" + startCount + idDeltas + idRangeOffsets + glyphsIds;
                    let format31012 = "";
                    let header31012 = "";
                    if (numTables > 1) {
                        cmap += "\x00\x03\x00\n" + (0, _util.string32)(4 + numTables * 8 + 4 + format314.length);
                        format31012 = "";
                        for(i = 0, ii = ranges.length; i < ii; i++){
                            range = ranges[i];
                            start = range[0];
                            codes = range[2];
                            let code = codes[0];
                            for(j = 1, jj = codes.length; j < jj; ++j)if (codes[j] !== codes[j - 1] + 1) {
                                end = range[0] + j - 1;
                                format31012 += (0, _util.string32)(start) + (0, _util.string32)(end) + (0, _util.string32)(code);
                                start = end + 1;
                                code = codes[j];
                            }
                            format31012 += (0, _util.string32)(start) + (0, _util.string32)(range[1]) + (0, _util.string32)(code);
                        }
                        header31012 = "\x00\f\x00\x00" + (0, _util.string32)(format31012.length + 16) + "\x00\x00\x00\x00" + (0, _util.string32)(format31012.length / 12);
                    }
                    return cmap + "\x00\x04" + string16(format314.length + 4) + format314 + header31012 + format31012;
                }
                function validateOS2Table(os2, file) {
                    file.pos = (file.start || 0) + os2.offset;
                    const version = file.getUint16();
                    file.skip(60);
                    const selection = file.getUint16();
                    if (version < 4 && selection & 0x0300) return false;
                    const firstChar = file.getUint16();
                    const lastChar = file.getUint16();
                    if (firstChar > lastChar) return false;
                    file.skip(6);
                    const usWinAscent = file.getUint16();
                    if (usWinAscent === 0) return false;
                    os2.data[8] = os2.data[9] = 0;
                    return true;
                }
                function createOS2Table(properties, charstrings, override) {
                    override = override || {
                        unitsPerEm: 0,
                        yMax: 0,
                        yMin: 0,
                        ascent: 0,
                        descent: 0
                    };
                    let ulUnicodeRange1 = 0;
                    let ulUnicodeRange2 = 0;
                    let ulUnicodeRange3 = 0;
                    let ulUnicodeRange4 = 0;
                    let firstCharIndex = null;
                    let lastCharIndex = 0;
                    if (charstrings) {
                        for(let code in charstrings){
                            code |= 0;
                            if (firstCharIndex > code || !firstCharIndex) firstCharIndex = code;
                            if (lastCharIndex < code) lastCharIndex = code;
                            const position = (0, _unicode.getUnicodeRangeFor)(code);
                            if (position < 32) ulUnicodeRange1 |= 1 << position;
                            else if (position < 64) ulUnicodeRange2 |= 1 << position - 32;
                            else if (position < 96) ulUnicodeRange3 |= 1 << position - 64;
                            else if (position < 123) ulUnicodeRange4 |= 1 << position - 96;
                            else throw new _util.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
                        }
                        if (lastCharIndex > 0xffff) lastCharIndex = 0xffff;
                    } else {
                        firstCharIndex = 0;
                        lastCharIndex = 255;
                    }
                    const bbox = properties.bbox || [
                        0,
                        0,
                        0,
                        0
                    ];
                    const unitsPerEm = override.unitsPerEm || 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
                    const scale = properties.ascentScaled ? 1.0 : unitsPerEm / PDF_GLYPH_SPACE_UNITS;
                    const typoAscent = override.ascent || Math.round(scale * (properties.ascent || bbox[3]));
                    let typoDescent = override.descent || Math.round(scale * (properties.descent || bbox[1]));
                    if (typoDescent > 0 && properties.descent > 0 && bbox[1] < 0) typoDescent = -typoDescent;
                    const winAscent = override.yMax || typoAscent;
                    const winDescent = -override.yMin || -typoDescent;
                    return "\x00\x03\x02$\x01\xf4\x00\x05\x00\x00\x02\x8a\x02\xbb\x00\x00\x00\x8c\x02\x8a\x02\xbb\x00\x00\x01\xdf\x001\x01\x02\x00\x00\x00\x00\x06" + String.fromCharCode(properties.fixedPitch ? 0x09 : 0x00) + "\x00\x00\x00\x00\x00\x00" + (0, _util.string32)(ulUnicodeRange1) + (0, _util.string32)(ulUnicodeRange2) + (0, _util.string32)(ulUnicodeRange3) + (0, _util.string32)(ulUnicodeRange4) + "*21*" + string16(properties.italicAngle ? 1 : 0) + string16(firstCharIndex || properties.firstChar) + string16(lastCharIndex || properties.lastChar) + string16(typoAscent) + string16(typoDescent) + "\x00d" + string16(winAscent) + string16(winDescent) + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + string16(properties.xHeight) + string16(properties.capHeight) + string16(0) + string16(firstCharIndex || properties.firstChar) + "\x00\x03";
                }
                function createPostTable(properties) {
                    const angle = Math.floor(properties.italicAngle * 2 ** 16);
                    return "\x00\x03\x00\x00" + (0, _util.string32)(angle) + "\x00\x00" + "\x00\x00" + (0, _util.string32)(properties.fixedPitch ? 1 : 0) + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + "\x00\x00\x00\x00" + "\x00\x00\x00\x00";
                }
                function createPostscriptName(name) {
                    return name.replace(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
                }
                function createNameTable(name, proto) {
                    if (!proto) proto = [
                        [],
                        []
                    ];
                    const strings = [
                        proto[0][0] || "Original licence",
                        proto[0][1] || name,
                        proto[0][2] || "Unknown",
                        proto[0][3] || "uniqueID",
                        proto[0][4] || name,
                        proto[0][5] || "Version 0.11",
                        proto[0][6] || createPostscriptName(name),
                        proto[0][7] || "Unknown",
                        proto[0][8] || "Unknown",
                        proto[0][9] || "Unknown"
                    ];
                    const stringsUnicode = [];
                    let i, ii, j, jj, str;
                    for(i = 0, ii = strings.length; i < ii; i++){
                        str = proto[1][i] || strings[i];
                        const strBufUnicode = [];
                        for(j = 0, jj = str.length; j < jj; j++)strBufUnicode.push(string16(str.charCodeAt(j)));
                        stringsUnicode.push(strBufUnicode.join(""));
                    }
                    const names = [
                        strings,
                        stringsUnicode
                    ];
                    const platforms = [
                        "\x00\x01",
                        "\x00\x03"
                    ];
                    const encodings = [
                        "\x00\x00",
                        "\x00\x01"
                    ];
                    const languages = [
                        "\x00\x00",
                        "\x04	"
                    ];
                    const namesRecordCount = strings.length * platforms.length;
                    let nameTable = "\x00\x00" + string16(namesRecordCount) + string16(namesRecordCount * 12 + 6);
                    let strOffset = 0;
                    for(i = 0, ii = platforms.length; i < ii; i++){
                        const strs = names[i];
                        for(j = 0, jj = strs.length; j < jj; j++){
                            str = strs[j];
                            const nameRecord = platforms[i] + encodings[i] + languages[i] + string16(j) + string16(str.length) + string16(strOffset);
                            nameTable += nameRecord;
                            strOffset += str.length;
                        }
                    }
                    nameTable += strings.join("") + stringsUnicode.join("");
                    return nameTable;
                }
                class Font {
                    constructor(name, file, properties){
                        this.name = name;
                        this.psName = null;
                        this.mimetype = null;
                        this.disableFontFace = false;
                        this.loadedName = properties.loadedName;
                        this.isType3Font = properties.isType3Font;
                        this.missingFile = false;
                        this.cssFontInfo = properties.cssFontInfo;
                        this._charsCache = Object.create(null);
                        this._glyphCache = Object.create(null);
                        this.isSerifFont = !!(properties.flags & _fonts_utils.FontFlags.Serif);
                        this.isSymbolicFont = !!(properties.flags & _fonts_utils.FontFlags.Symbolic);
                        this.isMonospace = !!(properties.flags & _fonts_utils.FontFlags.FixedPitch);
                        let type = properties.type;
                        let subtype = properties.subtype;
                        this.type = type;
                        this.subtype = subtype;
                        let fallbackName = "sans-serif";
                        if (this.isMonospace) fallbackName = "monospace";
                        else if (this.isSerifFont) fallbackName = "serif";
                        this.fallbackName = fallbackName;
                        this.differences = properties.differences;
                        this.widths = properties.widths;
                        this.defaultWidth = properties.defaultWidth;
                        this.composite = properties.composite;
                        this.cMap = properties.cMap;
                        this.capHeight = properties.capHeight / PDF_GLYPH_SPACE_UNITS;
                        this.ascent = properties.ascent / PDF_GLYPH_SPACE_UNITS;
                        this.descent = properties.descent / PDF_GLYPH_SPACE_UNITS;
                        this.lineHeight = this.ascent - this.descent;
                        this.fontMatrix = properties.fontMatrix;
                        this.bbox = properties.bbox;
                        this.defaultEncoding = properties.defaultEncoding;
                        this.toUnicode = properties.toUnicode;
                        this.toFontChar = [];
                        if (properties.type === "Type3") {
                            for(let charCode = 0; charCode < 256; charCode++)this.toFontChar[charCode] = this.differences[charCode] || properties.defaultEncoding[charCode];
                            this.fontType = _util.FontType.TYPE3;
                            return;
                        }
                        this.cidEncoding = properties.cidEncoding;
                        this.vertical = !!properties.vertical;
                        if (this.vertical) {
                            this.vmetrics = properties.vmetrics;
                            this.defaultVMetrics = properties.defaultVMetrics;
                        }
                        if (!file || file.isEmpty) {
                            if (file) (0, _util.warn)('Font file is empty in "' + name + '" (' + this.loadedName + ")");
                            this.fallbackToSystemFont(properties);
                            return;
                        }
                        [type, subtype] = getFontFileType(file, properties);
                        if (type !== this.type || subtype !== this.subtype) (0, _util.info)("Inconsistent font file Type/SubType, expected: " + `${this.type}/${this.subtype} but found: ${type}/${subtype}.`);
                        let data;
                        try {
                            switch(type){
                                case "MMType1":
                                    (0, _util.info)("MMType1 font (" + name + "), falling back to Type1.");
                                case "Type1":
                                case "CIDFontType0":
                                    this.mimetype = "font/opentype";
                                    const cff = subtype === "Type1C" || subtype === "CIDFontType0C" ? new _cff_font.CFFFont(file, properties) : new _type1_font.Type1Font(name, file, properties);
                                    adjustWidths(properties);
                                    data = this.convert(name, cff, properties);
                                    break;
                                case "OpenType":
                                case "TrueType":
                                case "CIDFontType2":
                                    this.mimetype = "font/opentype";
                                    data = this.checkAndRepair(name, file, properties);
                                    if (this.isOpenType) {
                                        adjustWidths(properties);
                                        type = "OpenType";
                                    }
                                    break;
                                default:
                                    throw new _util.FormatError(`Font ${type} is not supported`);
                            }
                        } catch (e) {
                            (0, _util.warn)(e);
                            this.fallbackToSystemFont(properties);
                            return;
                        }
                        amendFallbackToUnicode(properties);
                        this.data = data;
                        this.fontType = (0, _fonts_utils.getFontType)(type, subtype, properties.isStandardFont);
                        this.fontMatrix = properties.fontMatrix;
                        this.widths = properties.widths;
                        this.defaultWidth = properties.defaultWidth;
                        this.toUnicode = properties.toUnicode;
                        this.seacMap = properties.seacMap;
                    }
                    get renderer() {
                        const renderer = _font_renderer.FontRendererFactory.create(this, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        return (0, _util.shadow)(this, "renderer", renderer);
                    }
                    exportData(extraProperties = false) {
                        const exportDataProperties = extraProperties ? [
                            ...EXPORT_DATA_PROPERTIES,
                            ...EXPORT_DATA_EXTRA_PROPERTIES
                        ] : EXPORT_DATA_PROPERTIES;
                        const data = Object.create(null);
                        let property, value;
                        for (property of exportDataProperties){
                            value = this[property];
                            if (value !== undefined) data[property] = value;
                        }
                        return data;
                    }
                    fallbackToSystemFont(properties) {
                        this.missingFile = true;
                        const name = this.name;
                        const type = this.type;
                        const subtype = this.subtype;
                        let fontName = (0, _fonts_utils.normalizeFontName)(name);
                        const stdFontMap = (0, _standard_fonts.getStdFontMap)(), nonStdFontMap = (0, _standard_fonts.getNonStdFontMap)();
                        const isStandardFont = !!stdFontMap[fontName];
                        const isMappedToStandardFont = !!(nonStdFontMap[fontName] && stdFontMap[nonStdFontMap[fontName]]);
                        fontName = stdFontMap[fontName] || nonStdFontMap[fontName] || fontName;
                        this.bold = fontName.search(/bold/gi) !== -1;
                        this.italic = fontName.search(/oblique/gi) !== -1 || fontName.search(/italic/gi) !== -1;
                        this.black = name.search(/Black/g) !== -1;
                        const isNarrow = name.search(/Narrow/g) !== -1;
                        this.remeasure = (!isStandardFont || isNarrow) && Object.keys(this.widths).length > 0;
                        if ((isStandardFont || isMappedToStandardFont) && type === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                            const GlyphMapForStandardFonts = (0, _standard_fonts.getGlyphMapForStandardFonts)(), cidToGidMap = properties.cidToGidMap;
                            const map = [];
                            for(const charCode in GlyphMapForStandardFonts)map[+charCode] = GlyphMapForStandardFonts[charCode];
                            if (/Arial-?Black/i.test(name)) {
                                const SupplementalGlyphMapForArialBlack = (0, _standard_fonts.getSupplementalGlyphMapForArialBlack)();
                                for(const charCode in SupplementalGlyphMapForArialBlack)map[+charCode] = SupplementalGlyphMapForArialBlack[charCode];
                            } else if (/Calibri/i.test(name)) {
                                const SupplementalGlyphMapForCalibri = (0, _standard_fonts.getSupplementalGlyphMapForCalibri)();
                                for(const charCode in SupplementalGlyphMapForCalibri)map[+charCode] = SupplementalGlyphMapForCalibri[charCode];
                            }
                            if (cidToGidMap) for(const charCode in map){
                                const cid = map[charCode];
                                if (cidToGidMap[cid] !== undefined) map[+charCode] = cidToGidMap[cid];
                            }
                            const isIdentityUnicode = this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap;
                            if (!isIdentityUnicode) this.toUnicode.forEach(function(charCode, unicodeCharCode) {
                                map[+charCode] = unicodeCharCode;
                            });
                            this.toFontChar = map;
                            this.toUnicode = new _to_unicode_map.ToUnicodeMap(map);
                        } else if (/Symbol/i.test(fontName)) this.toFontChar = buildToFontChar(_encodings.SymbolSetEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                        else if (/Dingbats/i.test(fontName)) {
                            if (/Wingdings/i.test(name)) (0, _util.warn)("Non-embedded Wingdings font, falling back to ZapfDingbats.");
                            this.toFontChar = buildToFontChar(_encodings.ZapfDingbatsEncoding, (0, _glyphlist.getDingbatsGlyphsUnicode)(), this.differences);
                        } else if (isStandardFont) this.toFontChar = buildToFontChar(this.defaultEncoding, (0, _glyphlist.getGlyphsUnicode)(), this.differences);
                        else {
                            const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const map = [];
                            this.toUnicode.forEach((charCode, unicodeCharCode)=>{
                                if (!this.composite) {
                                    const glyphName = this.differences[charCode] || this.defaultEncoding[charCode];
                                    const unicode = (0, _unicode.getUnicodeForGlyph)(glyphName, glyphsUnicodeMap);
                                    if (unicode !== -1) unicodeCharCode = unicode;
                                }
                                map[+charCode] = unicodeCharCode;
                            });
                            if (this.composite && this.toUnicode instanceof _to_unicode_map.IdentityToUnicodeMap) {
                                if (/Verdana/i.test(name)) {
                                    const GlyphMapForStandardFonts = (0, _standard_fonts.getGlyphMapForStandardFonts)();
                                    for(const charCode in GlyphMapForStandardFonts)map[+charCode] = GlyphMapForStandardFonts[charCode];
                                }
                            }
                            this.toFontChar = map;
                        }
                        amendFallbackToUnicode(properties);
                        this.loadedName = fontName.split("-")[0];
                        this.fontType = (0, _fonts_utils.getFontType)(type, subtype, properties.isStandardFont);
                    }
                    checkAndRepair(name, font1, properties) {
                        const VALID_TABLES = [
                            "OS/2",
                            "cmap",
                            "head",
                            "hhea",
                            "hmtx",
                            "maxp",
                            "name",
                            "post",
                            "loca",
                            "glyf",
                            "fpgm",
                            "prep",
                            "cvt ",
                            "CFF "
                        ];
                        function readTables(file, numTables) {
                            const tables = Object.create(null);
                            tables["OS/2"] = null;
                            tables.cmap = null;
                            tables.head = null;
                            tables.hhea = null;
                            tables.hmtx = null;
                            tables.maxp = null;
                            tables.name = null;
                            tables.post = null;
                            for(let i = 0; i < numTables; i++){
                                const table = readTableEntry(file);
                                if (!VALID_TABLES.includes(table.tag)) continue;
                                if (table.length === 0) continue;
                                tables[table.tag] = table;
                            }
                            return tables;
                        }
                        function readTableEntry(file) {
                            const tag = file.getString(4);
                            const checksum = file.getInt32() >>> 0;
                            const offset = file.getInt32() >>> 0;
                            const length = file.getInt32() >>> 0;
                            const previousPosition = file.pos;
                            file.pos = file.start ? file.start : 0;
                            file.skip(offset);
                            const data = file.getBytes(length);
                            file.pos = previousPosition;
                            if (tag === "head") {
                                data[8] = data[9] = data[10] = data[11] = 0;
                                data[17] |= 0x20;
                            }
                            return {
                                tag: tag,
                                checksum: checksum,
                                length: length,
                                offset: offset,
                                data: data
                            };
                        }
                        function readOpenTypeHeader(ttf) {
                            return {
                                version: ttf.getString(4),
                                numTables: ttf.getUint16(),
                                searchRange: ttf.getUint16(),
                                entrySelector: ttf.getUint16(),
                                rangeShift: ttf.getUint16()
                            };
                        }
                        function readTrueTypeCollectionHeader(ttc) {
                            const ttcTag = ttc.getString(4);
                            (0, _util.assert)(ttcTag === "ttcf", "Must be a TrueType Collection font.");
                            const majorVersion = ttc.getUint16();
                            const minorVersion = ttc.getUint16();
                            const numFonts = ttc.getInt32() >>> 0;
                            const offsetTable = [];
                            for(let i = 0; i < numFonts; i++)offsetTable.push(ttc.getInt32() >>> 0);
                            const header = {
                                ttcTag: ttcTag,
                                majorVersion: majorVersion,
                                minorVersion: minorVersion,
                                numFonts: numFonts,
                                offsetTable: offsetTable
                            };
                            switch(majorVersion){
                                case 1:
                                    return header;
                                case 2:
                                    header.dsigTag = ttc.getInt32() >>> 0;
                                    header.dsigLength = ttc.getInt32() >>> 0;
                                    header.dsigOffset = ttc.getInt32() >>> 0;
                                    return header;
                            }
                            throw new _util.FormatError(`Invalid TrueType Collection majorVersion: ${majorVersion}.`);
                        }
                        function readTrueTypeCollectionData(ttc, fontName) {
                            const { numFonts: numFonts , offsetTable: offsetTable  } = readTrueTypeCollectionHeader(ttc);
                            const fontNameParts = fontName.split("+");
                            let fallbackData;
                            for(let i = 0; i < numFonts; i++){
                                ttc.pos = (ttc.start || 0) + offsetTable[i];
                                const potentialHeader = readOpenTypeHeader(ttc);
                                const potentialTables = readTables(ttc, potentialHeader.numTables);
                                if (!potentialTables.name) throw new _util.FormatError('TrueType Collection font must contain a "name" table.');
                                const nameTable = readNameTable(potentialTables.name);
                                for(let j = 0, jj = nameTable.length; j < jj; j++)for(let k = 0, kk = nameTable[j].length; k < kk; k++){
                                    const nameEntry = nameTable[j][k] && nameTable[j][k].replace(/\s/g, "");
                                    if (!nameEntry) continue;
                                    if (nameEntry === fontName) return {
                                        header: potentialHeader,
                                        tables: potentialTables
                                    };
                                    if (fontNameParts.length < 2) continue;
                                    for (const part of fontNameParts)if (nameEntry === part) fallbackData = {
                                        name: part,
                                        header: potentialHeader,
                                        tables: potentialTables
                                    };
                                }
                            }
                            if (fallbackData) {
                                (0, _util.warn)(`TrueType Collection does not contain "${fontName}" font, ` + `falling back to "${fallbackData.name}" font instead.`);
                                return {
                                    header: fallbackData.header,
                                    tables: fallbackData.tables
                                };
                            }
                            throw new _util.FormatError(`TrueType Collection does not contain "${fontName}" font.`);
                        }
                        function readCmapTable(cmap, file, isSymbolicFont, hasEncoding) {
                            if (!cmap) {
                                (0, _util.warn)("No cmap table available.");
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            let segment;
                            let start = (file.start ? file.start : 0) + cmap.offset;
                            file.pos = start;
                            file.skip(2);
                            const numTables = file.getUint16();
                            let potentialTable;
                            let canBreak = false;
                            for(let i = 0; i < numTables; i++){
                                const platformId = file.getUint16();
                                const encodingId = file.getUint16();
                                const offset = file.getInt32() >>> 0;
                                let useTable = false;
                                if (potentialTable && potentialTable.platformId === platformId && potentialTable.encodingId === encodingId) continue;
                                if (platformId === 0 && (encodingId === 0 || encodingId === 1 || encodingId === 3)) useTable = true;
                                else if (platformId === 1 && encodingId === 0) useTable = true;
                                else if (platformId === 3 && encodingId === 1 && (hasEncoding || !potentialTable)) {
                                    useTable = true;
                                    if (!isSymbolicFont) canBreak = true;
                                } else if (isSymbolicFont && platformId === 3 && encodingId === 0) {
                                    useTable = true;
                                    let correctlySorted = true;
                                    if (i < numTables - 1) {
                                        const nextBytes = file.peekBytes(2), nextPlatformId = int16(nextBytes[0], nextBytes[1]);
                                        if (nextPlatformId < platformId) correctlySorted = false;
                                    }
                                    if (correctlySorted) canBreak = true;
                                }
                                if (useTable) potentialTable = {
                                    platformId: platformId,
                                    encodingId: encodingId,
                                    offset: offset
                                };
                                if (canBreak) break;
                            }
                            if (potentialTable) file.pos = start + potentialTable.offset;
                            if (!potentialTable || file.peekByte() === -1) {
                                (0, _util.warn)("Could not find a preferred cmap table.");
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            const format = file.getUint16();
                            file.skip(4);
                            let hasShortCmap = false;
                            const mappings = [];
                            let j, glyphId;
                            if (format === 0) {
                                for(j = 0; j < 256; j++){
                                    const index = file.getByte();
                                    if (!index) continue;
                                    mappings.push({
                                        charCode: j,
                                        glyphId: index
                                    });
                                }
                                hasShortCmap = true;
                            } else if (format === 4) {
                                const segCount = file.getUint16() >> 1;
                                file.skip(6);
                                const segments = [];
                                let segIndex;
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments.push({
                                    end: file.getUint16()
                                });
                                file.skip(2);
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments[segIndex].start = file.getUint16();
                                for(segIndex = 0; segIndex < segCount; segIndex++)segments[segIndex].delta = file.getUint16();
                                let offsetsCount = 0, offsetIndex;
                                for(segIndex = 0; segIndex < segCount; segIndex++){
                                    segment = segments[segIndex];
                                    const rangeOffset = file.getUint16();
                                    if (!rangeOffset) {
                                        segment.offsetIndex = -1;
                                        continue;
                                    }
                                    offsetIndex = (rangeOffset >> 1) - (segCount - segIndex);
                                    segment.offsetIndex = offsetIndex;
                                    offsetsCount = Math.max(offsetsCount, offsetIndex + segment.end - segment.start + 1);
                                }
                                const offsets = [];
                                for(j = 0; j < offsetsCount; j++)offsets.push(file.getUint16());
                                for(segIndex = 0; segIndex < segCount; segIndex++){
                                    segment = segments[segIndex];
                                    start = segment.start;
                                    const end = segment.end;
                                    const delta = segment.delta;
                                    offsetIndex = segment.offsetIndex;
                                    for(j = start; j <= end; j++){
                                        if (j === 0xffff) continue;
                                        glyphId = offsetIndex < 0 ? j : offsets[offsetIndex + j - start];
                                        glyphId = glyphId + delta & 0xffff;
                                        mappings.push({
                                            charCode: j,
                                            glyphId: glyphId
                                        });
                                    }
                                }
                            } else if (format === 6) {
                                const firstCode = file.getUint16();
                                const entryCount = file.getUint16();
                                for(j = 0; j < entryCount; j++){
                                    glyphId = file.getUint16();
                                    const charCode = firstCode + j;
                                    mappings.push({
                                        charCode: charCode,
                                        glyphId: glyphId
                                    });
                                }
                            } else {
                                (0, _util.warn)("cmap table has unsupported format: " + format);
                                return {
                                    platformId: -1,
                                    encodingId: -1,
                                    mappings: [],
                                    hasShortCmap: false
                                };
                            }
                            mappings.sort(function(a, b) {
                                return a.charCode - b.charCode;
                            });
                            for(let i = 1; i < mappings.length; i++)if (mappings[i - 1].charCode === mappings[i].charCode) {
                                mappings.splice(i, 1);
                                i--;
                            }
                            return {
                                platformId: potentialTable.platformId,
                                encodingId: potentialTable.encodingId,
                                mappings: mappings,
                                hasShortCmap: hasShortCmap
                            };
                        }
                        function sanitizeMetrics(file, header, metrics, headTable, numGlyphs, dupFirstEntry) {
                            if (!header) {
                                if (metrics) metrics.data = null;
                                return;
                            }
                            file.pos = (file.start ? file.start : 0) + header.offset;
                            file.pos += 4;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            file.pos += 2;
                            const caretOffset = file.getUint16();
                            file.pos += 8;
                            file.pos += 2;
                            let numOfMetrics = file.getUint16();
                            if (caretOffset !== 0) {
                                const macStyle = int16(headTable.data[44], headTable.data[45]);
                                if (!(macStyle & 2)) {
                                    header.data[22] = 0;
                                    header.data[23] = 0;
                                }
                            }
                            if (numOfMetrics > numGlyphs) {
                                (0, _util.info)(`The numOfMetrics (${numOfMetrics}) should not be ` + `greater than the numGlyphs (${numGlyphs}).`);
                                numOfMetrics = numGlyphs;
                                header.data[34] = (numOfMetrics & 0xff00) >> 8;
                                header.data[35] = numOfMetrics & 0x00ff;
                            }
                            const numOfSidebearings = numGlyphs - numOfMetrics;
                            const numMissing = numOfSidebearings - (metrics.length - numOfMetrics * 4 >> 1);
                            if (numMissing > 0) {
                                const entries = new Uint8Array(metrics.length + numMissing * 2);
                                entries.set(metrics.data);
                                if (dupFirstEntry) {
                                    entries[metrics.length] = metrics.data[2];
                                    entries[metrics.length + 1] = metrics.data[3];
                                }
                                metrics.data = entries;
                            }
                        }
                        function sanitizeGlyph(source, sourceStart, sourceEnd, dest, destStart, hintsValid) {
                            const glyphProfile = {
                                length: 0,
                                sizeOfInstructions: 0
                            };
                            if (sourceEnd - sourceStart <= 12) return glyphProfile;
                            const glyf = source.subarray(sourceStart, sourceEnd);
                            let contoursCount = signedInt16(glyf[0], glyf[1]);
                            if (contoursCount < 0) {
                                contoursCount = -1;
                                writeSignedInt16(glyf, 0, contoursCount);
                                dest.set(glyf, destStart);
                                glyphProfile.length = glyf.length;
                                return glyphProfile;
                            }
                            let i, j = 10, flagsCount = 0;
                            for(i = 0; i < contoursCount; i++){
                                const endPoint = glyf[j] << 8 | glyf[j + 1];
                                flagsCount = endPoint + 1;
                                j += 2;
                            }
                            const instructionsStart = j;
                            const instructionsLength = glyf[j] << 8 | glyf[j + 1];
                            glyphProfile.sizeOfInstructions = instructionsLength;
                            j += 2 + instructionsLength;
                            const instructionsEnd = j;
                            let coordinatesLength = 0;
                            for(i = 0; i < flagsCount; i++){
                                const flag = glyf[j++];
                                if (flag & 0xc0) glyf[j - 1] = flag & 0x3f;
                                let xLength = 2;
                                if (flag & 2) xLength = 1;
                                else if (flag & 16) xLength = 0;
                                let yLength = 2;
                                if (flag & 4) yLength = 1;
                                else if (flag & 32) yLength = 0;
                                const xyLength = xLength + yLength;
                                coordinatesLength += xyLength;
                                if (flag & 8) {
                                    const repeat = glyf[j++];
                                    i += repeat;
                                    coordinatesLength += repeat * xyLength;
                                }
                            }
                            if (coordinatesLength === 0) return glyphProfile;
                            let glyphDataLength = j + coordinatesLength;
                            if (glyphDataLength > glyf.length) return glyphProfile;
                            if (!hintsValid && instructionsLength > 0) {
                                dest.set(glyf.subarray(0, instructionsStart), destStart);
                                dest.set([
                                    0,
                                    0
                                ], destStart + instructionsStart);
                                dest.set(glyf.subarray(instructionsEnd, glyphDataLength), destStart + instructionsStart + 2);
                                glyphDataLength -= instructionsLength;
                                if (glyf.length - glyphDataLength > 3) glyphDataLength = glyphDataLength + 3 & -4;
                                glyphProfile.length = glyphDataLength;
                                return glyphProfile;
                            }
                            if (glyf.length - glyphDataLength > 3) {
                                glyphDataLength = glyphDataLength + 3 & -4;
                                dest.set(glyf.subarray(0, glyphDataLength), destStart);
                                glyphProfile.length = glyphDataLength;
                                return glyphProfile;
                            }
                            dest.set(glyf, destStart);
                            glyphProfile.length = glyf.length;
                            return glyphProfile;
                        }
                        function sanitizeHead(head, numGlyphs, locaLength) {
                            const data = head.data;
                            const version = int32(data[0], data[1], data[2], data[3]);
                            if (version >> 16 !== 1) {
                                (0, _util.info)("Attempting to fix invalid version in head table: " + version);
                                data[0] = 0;
                                data[1] = 1;
                                data[2] = 0;
                                data[3] = 0;
                            }
                            const indexToLocFormat = int16(data[50], data[51]);
                            if (indexToLocFormat < 0 || indexToLocFormat > 1) {
                                (0, _util.info)("Attempting to fix invalid indexToLocFormat in head table: " + indexToLocFormat);
                                const numGlyphsPlusOne = numGlyphs + 1;
                                if (locaLength === numGlyphsPlusOne << 1) {
                                    data[50] = 0;
                                    data[51] = 0;
                                } else if (locaLength === numGlyphsPlusOne << 2) {
                                    data[50] = 0;
                                    data[51] = 1;
                                } else throw new _util.FormatError("Could not fix indexToLocFormat: " + indexToLocFormat);
                            }
                        }
                        function sanitizeGlyphLocations(loca, glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions) {
                            let itemSize, itemDecode, itemEncode;
                            if (isGlyphLocationsLong) {
                                itemSize = 4;
                                itemDecode = function fontItemDecodeLong(data, offset) {
                                    return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
                                };
                                itemEncode = function fontItemEncodeLong(data, offset, value) {
                                    data[offset] = value >>> 24 & 0xff;
                                    data[offset + 1] = value >> 16 & 0xff;
                                    data[offset + 2] = value >> 8 & 0xff;
                                    data[offset + 3] = value & 0xff;
                                };
                            } else {
                                itemSize = 2;
                                itemDecode = function fontItemDecode(data, offset) {
                                    return data[offset] << 9 | data[offset + 1] << 1;
                                };
                                itemEncode = function fontItemEncode(data, offset, value) {
                                    data[offset] = value >> 9 & 0xff;
                                    data[offset + 1] = value >> 1 & 0xff;
                                };
                            }
                            const numGlyphsOut = dupFirstEntry ? numGlyphs + 1 : numGlyphs;
                            const locaDataSize = itemSize * (1 + numGlyphsOut);
                            const locaData = new Uint8Array(locaDataSize);
                            locaData.set(loca.data.subarray(0, locaDataSize));
                            loca.data = locaData;
                            const oldGlyfData = glyf.data;
                            const oldGlyfDataLength = oldGlyfData.length;
                            const newGlyfData = new Uint8Array(oldGlyfDataLength);
                            let i, j;
                            const locaEntries = [];
                            for(i = 0, j = 0; i < numGlyphs + 1; i++, j += itemSize){
                                let offset = itemDecode(locaData, j);
                                if (offset > oldGlyfDataLength) offset = oldGlyfDataLength;
                                locaEntries.push({
                                    index: i,
                                    offset: offset,
                                    endOffset: 0
                                });
                            }
                            locaEntries.sort((a, b)=>{
                                return a.offset - b.offset;
                            });
                            for(i = 0; i < numGlyphs; i++)locaEntries[i].endOffset = locaEntries[i + 1].offset;
                            locaEntries.sort((a, b)=>{
                                return a.index - b.index;
                            });
                            const missingGlyphs = Object.create(null);
                            let writeOffset = 0;
                            itemEncode(locaData, 0, writeOffset);
                            for(i = 0, j = itemSize; i < numGlyphs; i++, j += itemSize){
                                const glyphProfile = sanitizeGlyph(oldGlyfData, locaEntries[i].offset, locaEntries[i].endOffset, newGlyfData, writeOffset, hintsValid);
                                const newLength = glyphProfile.length;
                                if (newLength === 0) missingGlyphs[i] = true;
                                if (glyphProfile.sizeOfInstructions > maxSizeOfInstructions) maxSizeOfInstructions = glyphProfile.sizeOfInstructions;
                                writeOffset += newLength;
                                itemEncode(locaData, j, writeOffset);
                            }
                            if (writeOffset === 0) {
                                const simpleGlyph = new Uint8Array([
                                    0,
                                    1,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    0,
                                    49,
                                    0
                                ]);
                                for(i = 0, j = itemSize; i < numGlyphsOut; i++, j += itemSize)itemEncode(locaData, j, simpleGlyph.length);
                                glyf.data = simpleGlyph;
                            } else if (dupFirstEntry) {
                                const firstEntryLength = itemDecode(locaData, itemSize);
                                if (newGlyfData.length > firstEntryLength + writeOffset) glyf.data = newGlyfData.subarray(0, firstEntryLength + writeOffset);
                                else {
                                    glyf.data = new Uint8Array(firstEntryLength + writeOffset);
                                    glyf.data.set(newGlyfData.subarray(0, writeOffset));
                                }
                                glyf.data.set(newGlyfData.subarray(0, firstEntryLength), writeOffset);
                                itemEncode(loca.data, locaData.length - itemSize, writeOffset + firstEntryLength);
                            } else glyf.data = newGlyfData.subarray(0, writeOffset);
                            return {
                                missingGlyphs: missingGlyphs,
                                maxSizeOfInstructions: maxSizeOfInstructions
                            };
                        }
                        function readPostScriptTable(post, propertiesObj, maxpNumGlyphs) {
                            const start = (font1.start ? font1.start : 0) + post.offset;
                            font1.pos = start;
                            const length = post.length, end = start + length;
                            const version = font1.getInt32();
                            font1.skip(28);
                            let glyphNames;
                            let valid = true;
                            let i;
                            switch(version){
                                case 0x00010000:
                                    glyphNames = _fonts_utils.MacStandardGlyphOrdering;
                                    break;
                                case 0x00020000:
                                    const numGlyphs = font1.getUint16();
                                    if (numGlyphs !== maxpNumGlyphs) {
                                        valid = false;
                                        break;
                                    }
                                    const glyphNameIndexes = [];
                                    for(i = 0; i < numGlyphs; ++i){
                                        const index = font1.getUint16();
                                        if (index >= 32768) {
                                            valid = false;
                                            break;
                                        }
                                        glyphNameIndexes.push(index);
                                    }
                                    if (!valid) break;
                                    const customNames = [], strBuf = [];
                                    while(font1.pos < end){
                                        const stringLength = font1.getByte();
                                        strBuf.length = stringLength;
                                        for(i = 0; i < stringLength; ++i)strBuf[i] = String.fromCharCode(font1.getByte());
                                        customNames.push(strBuf.join(""));
                                    }
                                    glyphNames = [];
                                    for(i = 0; i < numGlyphs; ++i){
                                        const j = glyphNameIndexes[i];
                                        if (j < 258) {
                                            glyphNames.push(_fonts_utils.MacStandardGlyphOrdering[j]);
                                            continue;
                                        }
                                        glyphNames.push(customNames[j - 258]);
                                    }
                                    break;
                                case 0x00030000:
                                    break;
                                default:
                                    (0, _util.warn)("Unknown/unsupported post table version " + version);
                                    valid = false;
                                    if (propertiesObj.defaultEncoding) glyphNames = propertiesObj.defaultEncoding;
                                    break;
                            }
                            propertiesObj.glyphNames = glyphNames;
                            return valid;
                        }
                        function readNameTable(nameTable) {
                            const start = (font1.start ? font1.start : 0) + nameTable.offset;
                            font1.pos = start;
                            const names = [
                                [],
                                []
                            ];
                            const length = nameTable.length, end = start + length;
                            const format = font1.getUint16();
                            const FORMAT_0_HEADER_LENGTH = 6;
                            if (format !== 0 || length < FORMAT_0_HEADER_LENGTH) return names;
                            const numRecords = font1.getUint16();
                            const stringsStart = font1.getUint16();
                            const records = [];
                            const NAME_RECORD_LENGTH = 12;
                            let i, ii;
                            for(i = 0; i < numRecords && font1.pos + NAME_RECORD_LENGTH <= end; i++){
                                const r = {
                                    platform: font1.getUint16(),
                                    encoding: font1.getUint16(),
                                    language: font1.getUint16(),
                                    name: font1.getUint16(),
                                    length: font1.getUint16(),
                                    offset: font1.getUint16()
                                };
                                if (r.platform === 1 && r.encoding === 0 && r.language === 0 || r.platform === 3 && r.encoding === 1 && r.language === 0x409) records.push(r);
                            }
                            for(i = 0, ii = records.length; i < ii; i++){
                                const record = records[i];
                                if (record.length <= 0) continue;
                                const pos = start + stringsStart + record.offset;
                                if (pos + record.length > end) continue;
                                font1.pos = pos;
                                const nameIndex = record.name;
                                if (record.encoding) {
                                    let str = "";
                                    for(let j = 0, jj = record.length; j < jj; j += 2)str += String.fromCharCode(font1.getUint16());
                                    names[1][nameIndex] = str;
                                } else names[0][nameIndex] = font1.getString(record.length);
                            }
                            return names;
                        }
                        const TTOpsStackDeltas = [
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -2,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            -5,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            1,
                            -1,
                            -999,
                            0,
                            1,
                            0,
                            -1,
                            -2,
                            0,
                            -1,
                            -2,
                            -1,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            0,
                            -999,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -2,
                            -999,
                            -2,
                            -2,
                            -999,
                            0,
                            -2,
                            -2,
                            0,
                            0,
                            -2,
                            0,
                            -2,
                            0,
                            0,
                            0,
                            -2,
                            -1,
                            -1,
                            1,
                            1,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            -1,
                            0,
                            -1,
                            -1,
                            0,
                            -999,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            -1,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            -2,
                            -999,
                            -999,
                            -999,
                            -999,
                            -999,
                            -1,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -999,
                            -2,
                            -2,
                            0,
                            0,
                            -1,
                            -2,
                            -2,
                            0,
                            0,
                            0,
                            -1,
                            -1,
                            -1,
                            -2
                        ];
                        function sanitizeTTProgram(table, ttContext) {
                            let data = table.data;
                            let i = 0, j, n, b, funcId, pc, lastEndf = 0, lastDeff = 0;
                            const stack = [];
                            const callstack = [];
                            const functionsCalled = [];
                            let tooComplexToFollowFunctions = ttContext.tooComplexToFollowFunctions;
                            let inFDEF = false, ifLevel = 0, inELSE = 0;
                            for(let ii = data.length; i < ii;){
                                const op = data[i++];
                                if (op === 0x40) {
                                    n = data[i++];
                                    if (inFDEF || inELSE) i += n;
                                    else for(j = 0; j < n; j++)stack.push(data[i++]);
                                } else if (op === 0x41) {
                                    n = data[i++];
                                    if (inFDEF || inELSE) i += n * 2;
                                    else for(j = 0; j < n; j++){
                                        b = data[i++];
                                        stack.push(b << 8 | data[i++]);
                                    }
                                } else if ((op & 0xf8) === 0xb0) {
                                    n = op - 0xb0 + 1;
                                    if (inFDEF || inELSE) i += n;
                                    else for(j = 0; j < n; j++)stack.push(data[i++]);
                                } else if ((op & 0xf8) === 0xb8) {
                                    n = op - 0xb8 + 1;
                                    if (inFDEF || inELSE) i += n * 2;
                                    else for(j = 0; j < n; j++){
                                        b = data[i++];
                                        stack.push(b << 8 | data[i++]);
                                    }
                                } else if (op === 0x2b && !tooComplexToFollowFunctions) {
                                    if (!inFDEF && !inELSE) {
                                        funcId = stack[stack.length - 1];
                                        if (isNaN(funcId)) (0, _util.info)("TT: CALL empty stack (or invalid entry).");
                                        else {
                                            ttContext.functionsUsed[funcId] = true;
                                            if (funcId in ttContext.functionsStackDeltas) {
                                                const newStackLength = stack.length + ttContext.functionsStackDeltas[funcId];
                                                if (newStackLength < 0) {
                                                    (0, _util.warn)("TT: CALL invalid functions stack delta.");
                                                    ttContext.hintsValid = false;
                                                    return;
                                                }
                                                stack.length = newStackLength;
                                            } else if (funcId in ttContext.functionsDefined && !functionsCalled.includes(funcId)) {
                                                callstack.push({
                                                    data: data,
                                                    i: i,
                                                    stackTop: stack.length - 1
                                                });
                                                functionsCalled.push(funcId);
                                                pc = ttContext.functionsDefined[funcId];
                                                if (!pc) {
                                                    (0, _util.warn)("TT: CALL non-existent function");
                                                    ttContext.hintsValid = false;
                                                    return;
                                                }
                                                data = pc.data;
                                                i = pc.i;
                                            }
                                        }
                                    }
                                } else if (op === 0x2c && !tooComplexToFollowFunctions) {
                                    if (inFDEF || inELSE) {
                                        (0, _util.warn)("TT: nested FDEFs not allowed");
                                        tooComplexToFollowFunctions = true;
                                    }
                                    inFDEF = true;
                                    lastDeff = i;
                                    funcId = stack.pop();
                                    ttContext.functionsDefined[funcId] = {
                                        data: data,
                                        i: i
                                    };
                                } else if (op === 0x2d) {
                                    if (inFDEF) {
                                        inFDEF = false;
                                        lastEndf = i;
                                    } else {
                                        pc = callstack.pop();
                                        if (!pc) {
                                            (0, _util.warn)("TT: ENDF bad stack");
                                            ttContext.hintsValid = false;
                                            return;
                                        }
                                        funcId = functionsCalled.pop();
                                        data = pc.data;
                                        i = pc.i;
                                        ttContext.functionsStackDeltas[funcId] = stack.length - pc.stackTop;
                                    }
                                } else if (op === 0x89) {
                                    if (inFDEF || inELSE) {
                                        (0, _util.warn)("TT: nested IDEFs not allowed");
                                        tooComplexToFollowFunctions = true;
                                    }
                                    inFDEF = true;
                                    lastDeff = i;
                                } else if (op === 0x58) ++ifLevel;
                                else if (op === 0x1b) inELSE = ifLevel;
                                else if (op === 0x59) {
                                    if (inELSE === ifLevel) inELSE = 0;
                                    --ifLevel;
                                } else if (op === 0x1c) {
                                    if (!inFDEF && !inELSE) {
                                        const offset = stack[stack.length - 1];
                                        if (offset > 0) i += offset - 1;
                                    }
                                }
                                if (!inFDEF && !inELSE) {
                                    let stackDelta = 0;
                                    if (op <= 0x8e) stackDelta = TTOpsStackDeltas[op];
                                    else if (op >= 0xc0 && op <= 0xdf) stackDelta = -1;
                                    else if (op >= 0xe0) stackDelta = -2;
                                    if (op >= 0x71 && op <= 0x75) {
                                        n = stack.pop();
                                        if (!isNaN(n)) stackDelta = -n * 2;
                                    }
                                    while(stackDelta < 0 && stack.length > 0){
                                        stack.pop();
                                        stackDelta++;
                                    }
                                    while(stackDelta > 0){
                                        stack.push(NaN);
                                        stackDelta--;
                                    }
                                }
                            }
                            ttContext.tooComplexToFollowFunctions = tooComplexToFollowFunctions;
                            const content = [
                                data
                            ];
                            if (i > data.length) content.push(new Uint8Array(i - data.length));
                            if (lastDeff > lastEndf) {
                                (0, _util.warn)("TT: complementing a missing function tail");
                                content.push(new Uint8Array([
                                    0x22,
                                    0x2d
                                ]));
                            }
                            foldTTTable(table, content);
                        }
                        function checkInvalidFunctions(ttContext, maxFunctionDefs) {
                            if (ttContext.tooComplexToFollowFunctions) return;
                            if (ttContext.functionsDefined.length > maxFunctionDefs) {
                                (0, _util.warn)("TT: more functions defined than expected");
                                ttContext.hintsValid = false;
                                return;
                            }
                            for(let j = 0, jj = ttContext.functionsUsed.length; j < jj; j++){
                                if (j > maxFunctionDefs) {
                                    (0, _util.warn)("TT: invalid function id: " + j);
                                    ttContext.hintsValid = false;
                                    return;
                                }
                                if (ttContext.functionsUsed[j] && !ttContext.functionsDefined[j]) {
                                    (0, _util.warn)("TT: undefined function: " + j);
                                    ttContext.hintsValid = false;
                                    return;
                                }
                            }
                        }
                        function foldTTTable(table, content) {
                            if (content.length > 1) {
                                let newLength = 0;
                                let j, jj;
                                for(j = 0, jj = content.length; j < jj; j++)newLength += content[j].length;
                                newLength = newLength + 3 & -4;
                                const result = new Uint8Array(newLength);
                                let pos = 0;
                                for(j = 0, jj = content.length; j < jj; j++){
                                    result.set(content[j], pos);
                                    pos += content[j].length;
                                }
                                table.data = result;
                                table.length = newLength;
                            }
                        }
                        function sanitizeTTPrograms(fpgm, prep, cvt, maxFunctionDefs) {
                            const ttContext = {
                                functionsDefined: [],
                                functionsUsed: [],
                                functionsStackDeltas: [],
                                tooComplexToFollowFunctions: false,
                                hintsValid: true
                            };
                            if (fpgm) sanitizeTTProgram(fpgm, ttContext);
                            if (prep) sanitizeTTProgram(prep, ttContext);
                            if (fpgm) checkInvalidFunctions(ttContext, maxFunctionDefs);
                            if (cvt && cvt.length & 1) {
                                const cvtData = new Uint8Array(cvt.length + 1);
                                cvtData.set(cvt.data);
                                cvt.data = cvtData;
                            }
                            return ttContext.hintsValid;
                        }
                        font1 = new _stream.Stream(new Uint8Array(font1.getBytes()));
                        let header, tables;
                        if (isTrueTypeCollectionFile(font1)) {
                            const ttcData = readTrueTypeCollectionData(font1, this.name);
                            header = ttcData.header;
                            tables = ttcData.tables;
                        } else {
                            header = readOpenTypeHeader(font1);
                            tables = readTables(font1, header.numTables);
                        }
                        let cff, cffFile;
                        const isTrueType = !tables["CFF "];
                        if (!isTrueType) {
                            const isComposite = properties.composite && ((properties.cidToGidMap || []).length > 0 || !(properties.cMap instanceof _cmap.IdentityCMap));
                            if (header.version === "OTTO" && !isComposite || !tables.head || !tables.hhea || !tables.maxp || !tables.post) {
                                cffFile = new _stream.Stream(tables["CFF "].data);
                                cff = new _cff_font.CFFFont(cffFile, properties);
                                adjustWidths(properties);
                                return this.convert(name, cff, properties);
                            }
                            delete tables.glyf;
                            delete tables.loca;
                            delete tables.fpgm;
                            delete tables.prep;
                            delete tables["cvt "];
                            this.isOpenType = true;
                        } else {
                            if (!tables.loca) throw new _util.FormatError('Required "loca" table is not found');
                            if (!tables.glyf) {
                                (0, _util.warn)('Required "glyf" table is not found -- trying to recover.');
                                tables.glyf = {
                                    tag: "glyf",
                                    data: new Uint8Array(0)
                                };
                            }
                            this.isOpenType = false;
                        }
                        if (!tables.maxp) throw new _util.FormatError('Required "maxp" table is not found');
                        font1.pos = (font1.start || 0) + tables.maxp.offset;
                        const version = font1.getInt32();
                        const numGlyphs = font1.getUint16();
                        if (properties.scaleFactors && properties.scaleFactors.length === numGlyphs && isTrueType) {
                            const { scaleFactors: scaleFactors  } = properties;
                            const isGlyphLocationsLong = int16(tables.head.data[50], tables.head.data[51]);
                            const glyphs = new _glyf.GlyfTable({
                                glyfTable: tables.glyf.data,
                                isGlyphLocationsLong: isGlyphLocationsLong,
                                locaTable: tables.loca.data,
                                numGlyphs: numGlyphs
                            });
                            glyphs.scale(scaleFactors);
                            const { glyf: glyf , loca: loca , isLocationLong: isLocationLong  } = glyphs.write();
                            tables.glyf.data = glyf;
                            tables.loca.data = loca;
                            if (isLocationLong !== !!isGlyphLocationsLong) {
                                tables.head.data[50] = 0;
                                tables.head.data[51] = isLocationLong ? 1 : 0;
                            }
                            const metrics = tables.hmtx.data;
                            for(let i = 0; i < numGlyphs; i++){
                                const j = 4 * i;
                                const advanceWidth = Math.round(scaleFactors[i] * int16(metrics[j], metrics[j + 1]));
                                metrics[j] = advanceWidth >> 8 & 0xff;
                                metrics[j + 1] = advanceWidth & 0xff;
                                const lsb = Math.round(scaleFactors[i] * signedInt16(metrics[j + 2], metrics[j + 3]));
                                writeSignedInt16(metrics, j + 2, lsb);
                            }
                        }
                        let numGlyphsOut = numGlyphs + 1;
                        let dupFirstEntry = true;
                        if (numGlyphsOut > 0xffff) {
                            dupFirstEntry = false;
                            numGlyphsOut = numGlyphs;
                            (0, _util.warn)("Not enough space in glyfs to duplicate first glyph.");
                        }
                        let maxFunctionDefs = 0;
                        let maxSizeOfInstructions = 0;
                        if (version >= 0x00010000 && tables.maxp.length >= 22) {
                            font1.pos += 8;
                            const maxZones = font1.getUint16();
                            if (maxZones > 2) {
                                tables.maxp.data[14] = 0;
                                tables.maxp.data[15] = 2;
                            }
                            font1.pos += 4;
                            maxFunctionDefs = font1.getUint16();
                            font1.pos += 4;
                            maxSizeOfInstructions = font1.getUint16();
                        }
                        tables.maxp.data[4] = numGlyphsOut >> 8;
                        tables.maxp.data[5] = numGlyphsOut & 255;
                        const hintsValid = sanitizeTTPrograms(tables.fpgm, tables.prep, tables["cvt "], maxFunctionDefs);
                        if (!hintsValid) {
                            delete tables.fpgm;
                            delete tables.prep;
                            delete tables["cvt "];
                        }
                        sanitizeMetrics(font1, tables.hhea, tables.hmtx, tables.head, numGlyphsOut, dupFirstEntry);
                        if (!tables.head) throw new _util.FormatError('Required "head" table is not found');
                        sanitizeHead(tables.head, numGlyphs, isTrueType ? tables.loca.length : 0);
                        let missingGlyphs = Object.create(null);
                        if (isTrueType) {
                            const isGlyphLocationsLong = int16(tables.head.data[50], tables.head.data[51]);
                            const glyphsInfo = sanitizeGlyphLocations(tables.loca, tables.glyf, numGlyphs, isGlyphLocationsLong, hintsValid, dupFirstEntry, maxSizeOfInstructions);
                            missingGlyphs = glyphsInfo.missingGlyphs;
                            if (version >= 0x00010000 && tables.maxp.length >= 22) {
                                tables.maxp.data[26] = glyphsInfo.maxSizeOfInstructions >> 8;
                                tables.maxp.data[27] = glyphsInfo.maxSizeOfInstructions & 255;
                            }
                        }
                        if (!tables.hhea) throw new _util.FormatError('Required "hhea" table is not found');
                        if (tables.hhea.data[10] === 0 && tables.hhea.data[11] === 0) {
                            tables.hhea.data[10] = 0xff;
                            tables.hhea.data[11] = 0xff;
                        }
                        const metricsOverride = {
                            unitsPerEm: int16(tables.head.data[18], tables.head.data[19]),
                            yMax: int16(tables.head.data[42], tables.head.data[43]),
                            yMin: signedInt16(tables.head.data[38], tables.head.data[39]),
                            ascent: signedInt16(tables.hhea.data[4], tables.hhea.data[5]),
                            descent: signedInt16(tables.hhea.data[6], tables.hhea.data[7]),
                            lineGap: signedInt16(tables.hhea.data[8], tables.hhea.data[9])
                        };
                        this.ascent = metricsOverride.ascent / metricsOverride.unitsPerEm;
                        this.descent = metricsOverride.descent / metricsOverride.unitsPerEm;
                        this.lineGap = metricsOverride.lineGap / metricsOverride.unitsPerEm;
                        if (this.cssFontInfo && this.cssFontInfo.lineHeight) this.lineHeight = this.cssFontInfo.lineHeight;
                        else this.lineHeight = this.ascent - this.descent + this.lineGap;
                        if (tables.post) readPostScriptTable(tables.post, properties, numGlyphs);
                        tables.post = {
                            tag: "post",
                            data: createPostTable(properties)
                        };
                        const charCodeToGlyphId = [];
                        function hasGlyph(glyphId) {
                            return !missingGlyphs[glyphId];
                        }
                        if (properties.composite) {
                            const cidToGidMap = properties.cidToGidMap || [];
                            const isCidToGidMapEmpty = cidToGidMap.length === 0;
                            properties.cMap.forEach(function(charCode, cid) {
                                if (cid > 0xffff) throw new _util.FormatError("Max size of CID is 65,535");
                                let glyphId = -1;
                                if (isCidToGidMapEmpty) glyphId = cid;
                                else if (cidToGidMap[cid] !== undefined) glyphId = cidToGidMap[cid];
                                if (glyphId >= 0 && glyphId < numGlyphs && hasGlyph(glyphId)) charCodeToGlyphId[charCode] = glyphId;
                            });
                        } else {
                            const cmapTable = readCmapTable(tables.cmap, font1, this.isSymbolicFont, properties.hasEncoding);
                            const cmapPlatformId = cmapTable.platformId;
                            const cmapEncodingId = cmapTable.encodingId;
                            const cmapMappings = cmapTable.mappings;
                            const cmapMappingsLength = cmapMappings.length;
                            let baseEncoding = [];
                            if (properties.hasEncoding && (properties.baseEncodingName === "MacRomanEncoding" || properties.baseEncodingName === "WinAnsiEncoding")) baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
                            if (properties.hasEncoding && !this.isSymbolicFont && (cmapPlatformId === 3 && cmapEncodingId === 1 || cmapPlatformId === 1 && cmapEncodingId === 0)) {
                                const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                                for(let charCode = 0; charCode < 256; charCode++){
                                    let glyphName;
                                    if (this.differences[charCode] !== undefined) glyphName = this.differences[charCode];
                                    else if (baseEncoding[charCode] !== "") glyphName = baseEncoding[charCode];
                                    else glyphName = _encodings.StandardEncoding[charCode];
                                    if (!glyphName) continue;
                                    const standardGlyphName = (0, _fonts_utils.recoverGlyphName)(glyphName, glyphsUnicodeMap);
                                    let unicodeOrCharCode;
                                    if (cmapPlatformId === 3 && cmapEncodingId === 1) unicodeOrCharCode = glyphsUnicodeMap[standardGlyphName];
                                    else if (cmapPlatformId === 1 && cmapEncodingId === 0) unicodeOrCharCode = _encodings.MacRomanEncoding.indexOf(standardGlyphName);
                                    for(let i = 0; i < cmapMappingsLength; ++i){
                                        if (cmapMappings[i].charCode !== unicodeOrCharCode) continue;
                                        charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
                                        break;
                                    }
                                }
                            } else if (cmapPlatformId === 0) for(let i = 0; i < cmapMappingsLength; ++i)charCodeToGlyphId[cmapMappings[i].charCode] = cmapMappings[i].glyphId;
                            else for(let i = 0; i < cmapMappingsLength; ++i){
                                let charCode = cmapMappings[i].charCode;
                                if (cmapPlatformId === 3 && charCode >= 0xf000 && charCode <= 0xf0ff) charCode &= 0xff;
                                charCodeToGlyphId[charCode] = cmapMappings[i].glyphId;
                            }
                            if (properties.glyphNames && (baseEncoding.length || this.differences.length)) for(let i = 0; i < 256; ++i){
                                if (charCodeToGlyphId[i] !== undefined) continue;
                                const glyphName = this.differences[i] || baseEncoding[i];
                                if (!glyphName) continue;
                                const glyphId = properties.glyphNames.indexOf(glyphName);
                                if (glyphId > 0 && hasGlyph(glyphId)) charCodeToGlyphId[i] = glyphId;
                            }
                        }
                        if (charCodeToGlyphId.length === 0) charCodeToGlyphId[0] = 0;
                        let glyphZeroId = numGlyphsOut - 1;
                        if (!dupFirstEntry) glyphZeroId = 0;
                        if (!properties.cssFontInfo) {
                            const newMapping = adjustMapping(charCodeToGlyphId, hasGlyph, glyphZeroId);
                            this.toFontChar = newMapping.toFontChar;
                            tables.cmap = {
                                tag: "cmap",
                                data: createCmapTable(newMapping.charCodeToGlyphId, numGlyphsOut)
                            };
                            if (!tables["OS/2"] || !validateOS2Table(tables["OS/2"], font1)) tables["OS/2"] = {
                                tag: "OS/2",
                                data: createOS2Table(properties, newMapping.charCodeToGlyphId, metricsOverride)
                            };
                        }
                        if (!isTrueType) try {
                            cffFile = new _stream.Stream(tables["CFF "].data);
                            const parser = new _cff_parser.CFFParser(cffFile, properties, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                            cff = parser.parse();
                            cff.duplicateFirstGlyph();
                            const compiler = new _cff_parser.CFFCompiler(cff);
                            tables["CFF "].data = compiler.compile();
                        } catch (e) {
                            (0, _util.warn)("Failed to compile font " + properties.loadedName);
                        }
                        if (!tables.name) tables.name = {
                            tag: "name",
                            data: createNameTable(this.name)
                        };
                        else {
                            const namePrototype = readNameTable(tables.name);
                            tables.name.data = createNameTable(name, namePrototype);
                            this.psName = namePrototype[0][6] || null;
                        }
                        const builder = new _opentype_file_builder.OpenTypeFileBuilder(header.version);
                        for(const tableTag in tables)builder.addTable(tableTag, tables[tableTag].data);
                        return builder.toArray();
                    }
                    convert(fontName, font1, properties) {
                        properties.fixedPitch = false;
                        if (properties.builtInEncoding) adjustToUnicode(properties, properties.builtInEncoding);
                        let glyphZeroId = 1;
                        if (font1 instanceof _cff_font.CFFFont) glyphZeroId = font1.numGlyphs - 1;
                        const mapping = font1.getGlyphMapping(properties);
                        let newMapping = null;
                        let newCharCodeToGlyphId = mapping;
                        if (!properties.cssFontInfo) {
                            newMapping = adjustMapping(mapping, font1.hasGlyphId.bind(font1), glyphZeroId);
                            this.toFontChar = newMapping.toFontChar;
                            newCharCodeToGlyphId = newMapping.charCodeToGlyphId;
                        }
                        const numGlyphs = font1.numGlyphs;
                        function getCharCodes(charCodeToGlyphId, glyphId) {
                            let charCodes = null;
                            for(const charCode in charCodeToGlyphId)if (glyphId === charCodeToGlyphId[charCode]) {
                                if (!charCodes) charCodes = [];
                                charCodes.push(charCode | 0);
                            }
                            return charCodes;
                        }
                        function createCharCode(charCodeToGlyphId, glyphId) {
                            for(const charCode in charCodeToGlyphId){
                                if (glyphId === charCodeToGlyphId[charCode]) return charCode | 0;
                            }
                            newMapping.charCodeToGlyphId[newMapping.nextAvailableFontCharCode] = glyphId;
                            return newMapping.nextAvailableFontCharCode++;
                        }
                        const seacs = font1.seacs;
                        if (newMapping && _fonts_utils.SEAC_ANALYSIS_ENABLED && seacs && seacs.length) {
                            const matrix = properties.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                            const charset = font1.getCharset();
                            const seacMap = Object.create(null);
                            for(let glyphId in seacs){
                                glyphId |= 0;
                                const seac = seacs[glyphId];
                                const baseGlyphName = _encodings.StandardEncoding[seac[2]];
                                const accentGlyphName = _encodings.StandardEncoding[seac[3]];
                                const baseGlyphId = charset.indexOf(baseGlyphName);
                                const accentGlyphId = charset.indexOf(accentGlyphName);
                                if (baseGlyphId < 0 || accentGlyphId < 0) continue;
                                const accentOffset = {
                                    x: seac[0] * matrix[0] + seac[1] * matrix[2] + matrix[4],
                                    y: seac[0] * matrix[1] + seac[1] * matrix[3] + matrix[5]
                                };
                                const charCodes = getCharCodes(mapping, glyphId);
                                if (!charCodes) continue;
                                for(let i = 0, ii = charCodes.length; i < ii; i++){
                                    const charCode = charCodes[i];
                                    const charCodeToGlyphId = newMapping.charCodeToGlyphId;
                                    const baseFontCharCode = createCharCode(charCodeToGlyphId, baseGlyphId);
                                    const accentFontCharCode = createCharCode(charCodeToGlyphId, accentGlyphId);
                                    seacMap[charCode] = {
                                        baseFontCharCode: baseFontCharCode,
                                        accentFontCharCode: accentFontCharCode,
                                        accentOffset: accentOffset
                                    };
                                }
                            }
                            properties.seacMap = seacMap;
                        }
                        const unitsPerEm = 1 / (properties.fontMatrix || _util.FONT_IDENTITY_MATRIX)[0];
                        const builder = new _opentype_file_builder.OpenTypeFileBuilder("OTTO");
                        builder.addTable("CFF ", font1.data);
                        builder.addTable("OS/2", createOS2Table(properties, newCharCodeToGlyphId));
                        builder.addTable("cmap", createCmapTable(newCharCodeToGlyphId, numGlyphs));
                        builder.addTable("head", "\x00\x01\x00\x00\x00\x00\x10\x00\x00\x00\x00\x00_\x0f<\xf5\x00\x00" + safeString16(unitsPerEm) + "\x00\x00\x00\x00\x9e\v~'" + "\x00\x00\x00\x00\x9e\v~'" + "\x00\x00" + safeString16(properties.descent) + "\x0f\xff" + safeString16(properties.ascent) + string16(properties.italicAngle ? 2 : 0) + "\x00\x11" + "\x00\x00" + "\x00\x00" + "\x00\x00");
                        builder.addTable("hhea", "\x00\x01\x00\x00" + safeString16(properties.ascent) + safeString16(properties.descent) + "\x00\x00" + "\xff\xff" + "\x00\x00" + "\x00\x00" + "\x00\x00" + safeString16(properties.capHeight) + safeString16(Math.tan(properties.italicAngle) * properties.xHeight) + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + "\x00\x00" + string16(numGlyphs));
                        builder.addTable("hmtx", function fontFieldsHmtx() {
                            const charstrings = font1.charstrings;
                            const cffWidths = font1.cff ? font1.cff.widths : null;
                            let hmtx = "\x00\x00\x00\x00";
                            for(let i = 1, ii = numGlyphs; i < ii; i++){
                                let width = 0;
                                if (charstrings) {
                                    const charstring = charstrings[i - 1];
                                    width = "width" in charstring ? charstring.width : 0;
                                } else if (cffWidths) width = Math.ceil(cffWidths[i] || 0);
                                hmtx += string16(width) + string16(0);
                            }
                            return hmtx;
                        }());
                        builder.addTable("maxp", "\x00\x00P\x00" + string16(numGlyphs));
                        builder.addTable("name", createNameTable(fontName));
                        builder.addTable("post", createPostTable(properties));
                        return builder.toArray();
                    }
                    get spaceWidth() {
                        const possibleSpaceReplacements = [
                            "space",
                            "minus",
                            "one",
                            "i",
                            "I"
                        ];
                        let width;
                        for(let i = 0, ii = possibleSpaceReplacements.length; i < ii; i++){
                            const glyphName = possibleSpaceReplacements[i];
                            if (glyphName in this.widths) {
                                width = this.widths[glyphName];
                                break;
                            }
                            const glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const glyphUnicode = glyphsUnicodeMap[glyphName];
                            let charcode = 0;
                            if (this.composite && this.cMap.contains(glyphUnicode)) charcode = this.cMap.lookup(glyphUnicode);
                            if (!charcode && this.toUnicode) charcode = this.toUnicode.charCodeOf(glyphUnicode);
                            if (charcode <= 0) charcode = glyphUnicode;
                            width = this.widths[charcode];
                            if (width) break;
                        }
                        width = width || this.defaultWidth;
                        return (0, _util.shadow)(this, "spaceWidth", width);
                    }
                    _charToGlyph(charcode, isSpace = false) {
                        let fontCharCode, width, operatorListId;
                        let widthCode = charcode;
                        if (this.cMap && this.cMap.contains(charcode)) widthCode = this.cMap.lookup(charcode);
                        width = this.widths[widthCode];
                        width = (0, _util.isNum)(width) ? width : this.defaultWidth;
                        const vmetric = this.vmetrics && this.vmetrics[widthCode];
                        let unicode = this.toUnicode.get(charcode) || charcode;
                        if (typeof unicode === "number") unicode = String.fromCharCode(unicode);
                        let isInFont = this.toFontChar[charcode] !== undefined;
                        fontCharCode = this.toFontChar[charcode] || charcode;
                        if (this.missingFile) {
                            const glyphName = this.differences[charcode] || this.defaultEncoding[charcode];
                            if ((glyphName === ".notdef" || glyphName === "") && this.type === "Type1") fontCharCode = 0x20;
                            fontCharCode = (0, _unicode.mapSpecialUnicodeValues)(fontCharCode);
                        }
                        if (this.isType3Font) operatorListId = fontCharCode;
                        let accent = null;
                        if (this.seacMap && this.seacMap[charcode]) {
                            isInFont = true;
                            const seac = this.seacMap[charcode];
                            fontCharCode = seac.baseFontCharCode;
                            accent = {
                                fontChar: String.fromCodePoint(seac.accentFontCharCode),
                                offset: seac.accentOffset
                            };
                        }
                        let fontChar = "";
                        if (typeof fontCharCode === "number") {
                            if (fontCharCode <= 0x10ffff) fontChar = String.fromCodePoint(fontCharCode);
                            else (0, _util.warn)(`charToGlyph - invalid fontCharCode: ${fontCharCode}`);
                        }
                        let glyph = this._glyphCache[charcode];
                        if (!glyph || !glyph.matchesForCache(charcode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont)) {
                            glyph = new Glyph(charcode, fontChar, unicode, accent, width, vmetric, operatorListId, isSpace, isInFont);
                            this._glyphCache[charcode] = glyph;
                        }
                        return glyph;
                    }
                    charsToGlyphs(chars) {
                        let glyphs = this._charsCache[chars];
                        if (glyphs) return glyphs;
                        glyphs = [];
                        if (this.cMap) {
                            const c = Object.create(null), ii = chars.length;
                            let i = 0;
                            while(i < ii){
                                this.cMap.readCharCode(chars, i, c);
                                const { charcode: charcode , length: length  } = c;
                                i += length;
                                const glyph = this._charToGlyph(charcode, length === 1 && chars.charCodeAt(i - 1) === 0x20);
                                glyphs.push(glyph);
                            }
                        } else for(let i = 0, ii = chars.length; i < ii; ++i){
                            const charcode = chars.charCodeAt(i);
                            const glyph = this._charToGlyph(charcode, charcode === 0x20);
                            glyphs.push(glyph);
                        }
                        return this._charsCache[chars] = glyphs;
                    }
                    getCharPositions(chars) {
                        const positions = [];
                        if (this.cMap) {
                            const c = Object.create(null);
                            let i = 0;
                            while(i < chars.length){
                                this.cMap.readCharCode(chars, i, c);
                                const length = c.length;
                                positions.push([
                                    i,
                                    i + length
                                ]);
                                i += length;
                            }
                        } else for(let i = 0, ii = chars.length; i < ii; ++i)positions.push([
                            i,
                            i + 1
                        ]);
                        return positions;
                    }
                    get glyphCacheValues() {
                        return Object.values(this._glyphCache);
                    }
                    encodeString(str) {
                        const buffers = [];
                        const currentBuf = [];
                        const hasCurrentBufErrors = ()=>buffers.length % 2 === 1;
                        for(let i = 0, ii = str.length; i < ii; i++){
                            const unicode = str.codePointAt(i);
                            if (unicode > 0xd7ff && (unicode < 0xe000 || unicode > 0xfffd)) i++;
                            if (this.toUnicode) {
                                const char = String.fromCodePoint(unicode);
                                const charCode = this.toUnicode.charCodeOf(char);
                                if (charCode !== -1) {
                                    if (hasCurrentBufErrors()) {
                                        buffers.push(currentBuf.join(""));
                                        currentBuf.length = 0;
                                    }
                                    const charCodeLength = this.cMap ? this.cMap.getCharCodeLength(charCode) : 1;
                                    for(let j = charCodeLength - 1; j >= 0; j--)currentBuf.push(String.fromCharCode(charCode >> 8 * j & 0xff));
                                    continue;
                                }
                            }
                            if (!hasCurrentBufErrors()) {
                                buffers.push(currentBuf.join(""));
                                currentBuf.length = 0;
                            }
                            currentBuf.push(String.fromCodePoint(unicode));
                        }
                        buffers.push(currentBuf.join(""));
                        return buffers;
                    }
                }
                exports.Font = Font;
                class ErrorFont {
                    constructor(error){
                        this.error = error;
                        this.loadedName = "g_font_error";
                        this.missingFile = true;
                    }
                    charsToGlyphs() {
                        return [];
                    }
                    encodeString(chars) {
                        return [
                            chars
                        ];
                    }
                    exportData(extraProperties = false) {
                        return {
                            error: this.error
                        };
                    }
                }
                exports.ErrorFont = ErrorFont;
            /***/ },
            /* 35 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CFFTopDict = exports.CFFStrings = exports.CFFStandardStrings = exports.CFFPrivateDict = exports.CFFParser = exports.CFFIndex = exports.CFFHeader = exports.CFFFDSelect = exports.CFFCompiler = exports.CFFCharset = exports.CFF = void 0;
                var _util = __w_pdfjs_require__(2);
                var _charsets = __w_pdfjs_require__(36);
                var _encodings = __w_pdfjs_require__(37);
                const MAX_SUBR_NESTING = 10;
                const CFFStandardStrings = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall",
                    "001.000",
                    "001.001",
                    "001.002",
                    "001.003",
                    "Black",
                    "Bold",
                    "Book",
                    "Light",
                    "Medium",
                    "Regular",
                    "Roman",
                    "Semibold"
                ];
                exports.CFFStandardStrings = CFFStandardStrings;
                const NUM_STANDARD_CFF_STRINGS = 391;
                const CFFParser = function CFFParserClosure() {
                    const CharstringValidationData = [
                        null,
                        {
                            id: "hstem",
                            min: 2,
                            stackClearing: true,
                            stem: true
                        },
                        null,
                        {
                            id: "vstem",
                            min: 2,
                            stackClearing: true,
                            stem: true
                        },
                        {
                            id: "vmoveto",
                            min: 1,
                            stackClearing: true
                        },
                        {
                            id: "rlineto",
                            min: 2,
                            resetStack: true
                        },
                        {
                            id: "hlineto",
                            min: 1,
                            resetStack: true
                        },
                        {
                            id: "vlineto",
                            min: 1,
                            resetStack: true
                        },
                        {
                            id: "rrcurveto",
                            min: 6,
                            resetStack: true
                        },
                        null,
                        {
                            id: "callsubr",
                            min: 1,
                            undefStack: true
                        },
                        {
                            id: "return",
                            min: 0,
                            undefStack: true
                        },
                        null,
                        null,
                        {
                            id: "endchar",
                            min: 0,
                            stackClearing: true
                        },
                        null,
                        null,
                        null,
                        {
                            id: "hstemhm",
                            min: 2,
                            stackClearing: true,
                            stem: true
                        },
                        {
                            id: "hintmask",
                            min: 0,
                            stackClearing: true
                        },
                        {
                            id: "cntrmask",
                            min: 0,
                            stackClearing: true
                        },
                        {
                            id: "rmoveto",
                            min: 2,
                            stackClearing: true
                        },
                        {
                            id: "hmoveto",
                            min: 1,
                            stackClearing: true
                        },
                        {
                            id: "vstemhm",
                            min: 2,
                            stackClearing: true,
                            stem: true
                        },
                        {
                            id: "rcurveline",
                            min: 8,
                            resetStack: true
                        },
                        {
                            id: "rlinecurve",
                            min: 8,
                            resetStack: true
                        },
                        {
                            id: "vvcurveto",
                            min: 4,
                            resetStack: true
                        },
                        {
                            id: "hhcurveto",
                            min: 4,
                            resetStack: true
                        },
                        null,
                        {
                            id: "callgsubr",
                            min: 1,
                            undefStack: true
                        },
                        {
                            id: "vhcurveto",
                            min: 4,
                            resetStack: true
                        },
                        {
                            id: "hvcurveto",
                            min: 4,
                            resetStack: true
                        }
                    ];
                    const CharstringValidationData12 = [
                        null,
                        null,
                        null,
                        {
                            id: "and",
                            min: 2,
                            stackDelta: -1
                        },
                        {
                            id: "or",
                            min: 2,
                            stackDelta: -1
                        },
                        {
                            id: "not",
                            min: 1,
                            stackDelta: 0
                        },
                        null,
                        null,
                        null,
                        {
                            id: "abs",
                            min: 1,
                            stackDelta: 0
                        },
                        {
                            id: "add",
                            min: 2,
                            stackDelta: -1,
                            stackFn: function stack_div(stack, index) {
                                stack[index - 2] = stack[index - 2] + stack[index - 1];
                            }
                        },
                        {
                            id: "sub",
                            min: 2,
                            stackDelta: -1,
                            stackFn: function stack_div(stack, index) {
                                stack[index - 2] = stack[index - 2] - stack[index - 1];
                            }
                        },
                        {
                            id: "div",
                            min: 2,
                            stackDelta: -1,
                            stackFn: function stack_div(stack, index) {
                                stack[index - 2] = stack[index - 2] / stack[index - 1];
                            }
                        },
                        null,
                        {
                            id: "neg",
                            min: 1,
                            stackDelta: 0,
                            stackFn: function stack_div(stack, index) {
                                stack[index - 1] = -stack[index - 1];
                            }
                        },
                        {
                            id: "eq",
                            min: 2,
                            stackDelta: -1
                        },
                        null,
                        null,
                        {
                            id: "drop",
                            min: 1,
                            stackDelta: -1
                        },
                        null,
                        {
                            id: "put",
                            min: 2,
                            stackDelta: -2
                        },
                        {
                            id: "get",
                            min: 1,
                            stackDelta: 0
                        },
                        {
                            id: "ifelse",
                            min: 4,
                            stackDelta: -3
                        },
                        {
                            id: "random",
                            min: 0,
                            stackDelta: 1
                        },
                        {
                            id: "mul",
                            min: 2,
                            stackDelta: -1,
                            stackFn: function stack_div(stack, index) {
                                stack[index - 2] = stack[index - 2] * stack[index - 1];
                            }
                        },
                        null,
                        {
                            id: "sqrt",
                            min: 1,
                            stackDelta: 0
                        },
                        {
                            id: "dup",
                            min: 1,
                            stackDelta: 1
                        },
                        {
                            id: "exch",
                            min: 2,
                            stackDelta: 0
                        },
                        {
                            id: "index",
                            min: 2,
                            stackDelta: 0
                        },
                        {
                            id: "roll",
                            min: 3,
                            stackDelta: -2
                        },
                        null,
                        null,
                        null,
                        {
                            id: "hflex",
                            min: 7,
                            resetStack: true
                        },
                        {
                            id: "flex",
                            min: 13,
                            resetStack: true
                        },
                        {
                            id: "hflex1",
                            min: 9,
                            resetStack: true
                        },
                        {
                            id: "flex1",
                            min: 11,
                            resetStack: true
                        }
                    ];
                    class CFFParser {
                        constructor(file, properties, seacAnalysisEnabled){
                            this.bytes = file.getBytes();
                            this.properties = properties;
                            this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                        }
                        parse() {
                            const properties = this.properties;
                            const cff = new CFF();
                            this.cff = cff;
                            const header = this.parseHeader();
                            const nameIndex = this.parseIndex(header.endPos);
                            const topDictIndex = this.parseIndex(nameIndex.endPos);
                            const stringIndex = this.parseIndex(topDictIndex.endPos);
                            const globalSubrIndex = this.parseIndex(stringIndex.endPos);
                            const topDictParsed = this.parseDict(topDictIndex.obj.get(0));
                            const topDict = this.createDict(CFFTopDict, topDictParsed, cff.strings);
                            cff.header = header.obj;
                            cff.names = this.parseNameIndex(nameIndex.obj);
                            cff.strings = this.parseStringIndex(stringIndex.obj);
                            cff.topDict = topDict;
                            cff.globalSubrIndex = globalSubrIndex.obj;
                            this.parsePrivateDict(cff.topDict);
                            cff.isCIDFont = topDict.hasName("ROS");
                            const charStringOffset = topDict.getByName("CharStrings");
                            const charStringIndex = this.parseIndex(charStringOffset).obj;
                            const fontMatrix = topDict.getByName("FontMatrix");
                            if (fontMatrix) properties.fontMatrix = fontMatrix;
                            const fontBBox = topDict.getByName("FontBBox");
                            if (fontBBox) {
                                properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
                                properties.descent = Math.min(fontBBox[1], fontBBox[3]);
                                properties.ascentScaled = true;
                            }
                            let charset, encoding;
                            if (cff.isCIDFont) {
                                const fdArrayIndex = this.parseIndex(topDict.getByName("FDArray")).obj;
                                for(let i = 0, ii = fdArrayIndex.count; i < ii; ++i){
                                    const dictRaw = fdArrayIndex.get(i);
                                    const fontDict = this.createDict(CFFTopDict, this.parseDict(dictRaw), cff.strings);
                                    this.parsePrivateDict(fontDict);
                                    cff.fdArray.push(fontDict);
                                }
                                encoding = null;
                                charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, true);
                                cff.fdSelect = this.parseFDSelect(topDict.getByName("FDSelect"), charStringIndex.count);
                            } else {
                                charset = this.parseCharsets(topDict.getByName("charset"), charStringIndex.count, cff.strings, false);
                                encoding = this.parseEncoding(topDict.getByName("Encoding"), properties, cff.strings, charset.charset);
                            }
                            cff.charset = charset;
                            cff.encoding = encoding;
                            const charStringsAndSeacs = this.parseCharStrings({
                                charStrings: charStringIndex,
                                localSubrIndex: topDict.privateDict.subrsIndex,
                                globalSubrIndex: globalSubrIndex.obj,
                                fdSelect: cff.fdSelect,
                                fdArray: cff.fdArray,
                                privateDict: topDict.privateDict
                            });
                            cff.charStrings = charStringsAndSeacs.charStrings;
                            cff.seacs = charStringsAndSeacs.seacs;
                            cff.widths = charStringsAndSeacs.widths;
                            return cff;
                        }
                        parseHeader() {
                            let bytes = this.bytes;
                            const bytesLength = bytes.length;
                            let offset = 0;
                            while(offset < bytesLength && bytes[offset] !== 1)++offset;
                            if (offset >= bytesLength) throw new _util.FormatError("Invalid CFF header");
                            if (offset !== 0) {
                                (0, _util.info)("cff data is shifted");
                                bytes = bytes.subarray(offset);
                                this.bytes = bytes;
                            }
                            const major = bytes[0];
                            const minor = bytes[1];
                            const hdrSize = bytes[2];
                            const offSize = bytes[3];
                            const header = new CFFHeader(major, minor, hdrSize, offSize);
                            return {
                                obj: header,
                                endPos: hdrSize
                            };
                        }
                        parseDict(dict) {
                            let pos = 0;
                            function parseOperand() {
                                let value = dict[pos++];
                                if (value === 30) return parseFloatOperand();
                                else if (value === 28) {
                                    value = dict[pos++];
                                    value = (value << 24 | dict[pos++] << 16) >> 16;
                                    return value;
                                } else if (value === 29) {
                                    value = dict[pos++];
                                    value = value << 8 | dict[pos++];
                                    value = value << 8 | dict[pos++];
                                    value = value << 8 | dict[pos++];
                                    return value;
                                } else if (value >= 32 && value <= 246) return value - 139;
                                else if (value >= 247 && value <= 250) return (value - 247) * 256 + dict[pos++] + 108;
                                else if (value >= 251 && value <= 254) return -((value - 251) * 256) - dict[pos++] - 108;
                                (0, _util.warn)('CFFParser_parseDict: "' + value + '" is a reserved command.');
                                return NaN;
                            }
                            function parseFloatOperand() {
                                let str = "";
                                const eof = 15;
                                const lookup = [
                                    "0",
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "7",
                                    "8",
                                    "9",
                                    ".",
                                    "E",
                                    "E-",
                                    null,
                                    "-"
                                ];
                                const length = dict.length;
                                while(pos < length){
                                    const b = dict[pos++];
                                    const b1 = b >> 4;
                                    const b2 = b & 15;
                                    if (b1 === eof) break;
                                    str += lookup[b1];
                                    if (b2 === eof) break;
                                    str += lookup[b2];
                                }
                                return parseFloat(str);
                            }
                            let operands = [];
                            const entries = [];
                            pos = 0;
                            const end = dict.length;
                            while(pos < end){
                                let b = dict[pos];
                                if (b <= 21) {
                                    if (b === 12) b = b << 8 | dict[++pos];
                                    entries.push([
                                        b,
                                        operands
                                    ]);
                                    operands = [];
                                    ++pos;
                                } else operands.push(parseOperand());
                            }
                            return entries;
                        }
                        parseIndex(pos) {
                            const cffIndex = new CFFIndex();
                            const bytes = this.bytes;
                            const count = bytes[pos++] << 8 | bytes[pos++];
                            const offsets = [];
                            let end = pos;
                            let i, ii;
                            if (count !== 0) {
                                const offsetSize = bytes[pos++];
                                const startPos = pos + (count + 1) * offsetSize - 1;
                                for(i = 0, ii = count + 1; i < ii; ++i){
                                    let offset = 0;
                                    for(let j = 0; j < offsetSize; ++j){
                                        offset <<= 8;
                                        offset += bytes[pos++];
                                    }
                                    offsets.push(startPos + offset);
                                }
                                end = offsets[count];
                            }
                            for(i = 0, ii = offsets.length - 1; i < ii; ++i){
                                const offsetStart = offsets[i];
                                const offsetEnd = offsets[i + 1];
                                cffIndex.add(bytes.subarray(offsetStart, offsetEnd));
                            }
                            return {
                                obj: cffIndex,
                                endPos: end
                            };
                        }
                        parseNameIndex(index) {
                            const names = [];
                            for(let i = 0, ii = index.count; i < ii; ++i){
                                const name = index.get(i);
                                names.push((0, _util.bytesToString)(name));
                            }
                            return names;
                        }
                        parseStringIndex(index) {
                            const strings = new CFFStrings();
                            for(let i = 0, ii = index.count; i < ii; ++i){
                                const data = index.get(i);
                                strings.add((0, _util.bytesToString)(data));
                            }
                            return strings;
                        }
                        createDict(Type, dict, strings) {
                            const cffDict = new Type(strings);
                            for(let i = 0, ii = dict.length; i < ii; ++i){
                                const pair = dict[i];
                                const key = pair[0];
                                const value = pair[1];
                                cffDict.setByKey(key, value);
                            }
                            return cffDict;
                        }
                        parseCharString(state, data, localSubrIndex, globalSubrIndex) {
                            if (!data || state.callDepth > MAX_SUBR_NESTING) return false;
                            let stackSize = state.stackSize;
                            const stack = state.stack;
                            const length = data.length;
                            for(let j = 0; j < length;){
                                const value = data[j++];
                                let validationCommand = null;
                                if (value === 12) {
                                    const q = data[j++];
                                    if (q === 0) {
                                        data[j - 2] = 139;
                                        data[j - 1] = 22;
                                        stackSize = 0;
                                    } else validationCommand = CharstringValidationData12[q];
                                } else if (value === 28) {
                                    stack[stackSize] = (data[j] << 24 | data[j + 1] << 16) >> 16;
                                    j += 2;
                                    stackSize++;
                                } else if (value === 14) {
                                    if (stackSize >= 4) {
                                        stackSize -= 4;
                                        if (this.seacAnalysisEnabled) {
                                            state.seac = stack.slice(stackSize, stackSize + 4);
                                            return false;
                                        }
                                    }
                                    validationCommand = CharstringValidationData[value];
                                } else if (value >= 32 && value <= 246) {
                                    stack[stackSize] = value - 139;
                                    stackSize++;
                                } else if (value >= 247 && value <= 254) {
                                    stack[stackSize] = value < 251 ? (value - 247 << 8) + data[j] + 108 : -(value - 251 << 8) - data[j] - 108;
                                    j++;
                                    stackSize++;
                                } else if (value === 255) {
                                    stack[stackSize] = (data[j] << 24 | data[j + 1] << 16 | data[j + 2] << 8 | data[j + 3]) / 65536;
                                    j += 4;
                                    stackSize++;
                                } else if (value === 19 || value === 20) {
                                    state.hints += stackSize >> 1;
                                    j += state.hints + 7 >> 3;
                                    stackSize %= 2;
                                    validationCommand = CharstringValidationData[value];
                                } else if (value === 10 || value === 29) {
                                    let subrsIndex;
                                    if (value === 10) subrsIndex = localSubrIndex;
                                    else subrsIndex = globalSubrIndex;
                                    if (!subrsIndex) {
                                        validationCommand = CharstringValidationData[value];
                                        (0, _util.warn)("Missing subrsIndex for " + validationCommand.id);
                                        return false;
                                    }
                                    let bias = 32768;
                                    if (subrsIndex.count < 1240) bias = 107;
                                    else if (subrsIndex.count < 33900) bias = 1131;
                                    const subrNumber = stack[--stackSize] + bias;
                                    if (subrNumber < 0 || subrNumber >= subrsIndex.count || isNaN(subrNumber)) {
                                        validationCommand = CharstringValidationData[value];
                                        (0, _util.warn)("Out of bounds subrIndex for " + validationCommand.id);
                                        return false;
                                    }
                                    state.stackSize = stackSize;
                                    state.callDepth++;
                                    const valid = this.parseCharString(state, subrsIndex.get(subrNumber), localSubrIndex, globalSubrIndex);
                                    if (!valid) return false;
                                    state.callDepth--;
                                    stackSize = state.stackSize;
                                    continue;
                                } else if (value === 11) {
                                    state.stackSize = stackSize;
                                    return true;
                                } else if (value === 0 && j === data.length) {
                                    data[j - 1] = 14;
                                    validationCommand = CharstringValidationData[14];
                                } else validationCommand = CharstringValidationData[value];
                                if (validationCommand) {
                                    if (validationCommand.stem) {
                                        state.hints += stackSize >> 1;
                                        if (value === 3 || value === 23) state.hasVStems = true;
                                        else if (state.hasVStems && (value === 1 || value === 18)) {
                                            (0, _util.warn)("CFF stem hints are in wrong order");
                                            data[j - 1] = value === 1 ? 3 : 23;
                                        }
                                    }
                                    if ("min" in validationCommand) {
                                        if (!state.undefStack && stackSize < validationCommand.min) {
                                            (0, _util.warn)("Not enough parameters for " + validationCommand.id + "; actual: " + stackSize + ", expected: " + validationCommand.min);
                                            if (stackSize === 0) {
                                                data[j - 1] = 14;
                                                return true;
                                            }
                                            return false;
                                        }
                                    }
                                    if (state.firstStackClearing && validationCommand.stackClearing) {
                                        state.firstStackClearing = false;
                                        stackSize -= validationCommand.min;
                                        if (stackSize >= 2 && validationCommand.stem) stackSize %= 2;
                                        else if (stackSize > 1) (0, _util.warn)("Found too many parameters for stack-clearing command");
                                        if (stackSize > 0) state.width = stack[stackSize - 1];
                                    }
                                    if ("stackDelta" in validationCommand) {
                                        if ("stackFn" in validationCommand) validationCommand.stackFn(stack, stackSize);
                                        stackSize += validationCommand.stackDelta;
                                    } else if (validationCommand.stackClearing) stackSize = 0;
                                    else if (validationCommand.resetStack) {
                                        stackSize = 0;
                                        state.undefStack = false;
                                    } else if (validationCommand.undefStack) {
                                        stackSize = 0;
                                        state.undefStack = true;
                                        state.firstStackClearing = false;
                                    }
                                }
                            }
                            state.stackSize = stackSize;
                            return true;
                        }
                        parseCharStrings({ charStrings: charStrings , localSubrIndex: localSubrIndex , globalSubrIndex: globalSubrIndex , fdSelect: fdSelect , fdArray: fdArray , privateDict: privateDict  }) {
                            const seacs = [];
                            const widths = [];
                            const count = charStrings.count;
                            for(let i = 0; i < count; i++){
                                const charstring = charStrings.get(i);
                                const state = {
                                    callDepth: 0,
                                    stackSize: 0,
                                    stack: [],
                                    undefStack: true,
                                    hints: 0,
                                    firstStackClearing: true,
                                    seac: null,
                                    width: null,
                                    hasVStems: false
                                };
                                let valid = true;
                                let localSubrToUse = null;
                                let privateDictToUse = privateDict;
                                if (fdSelect && fdArray.length) {
                                    const fdIndex = fdSelect.getFDIndex(i);
                                    if (fdIndex === -1) {
                                        (0, _util.warn)("Glyph index is not in fd select.");
                                        valid = false;
                                    }
                                    if (fdIndex >= fdArray.length) {
                                        (0, _util.warn)("Invalid fd index for glyph index.");
                                        valid = false;
                                    }
                                    if (valid) {
                                        privateDictToUse = fdArray[fdIndex].privateDict;
                                        localSubrToUse = privateDictToUse.subrsIndex;
                                    }
                                } else if (localSubrIndex) localSubrToUse = localSubrIndex;
                                if (valid) valid = this.parseCharString(state, charstring, localSubrToUse, globalSubrIndex);
                                if (state.width !== null) {
                                    const nominalWidth = privateDictToUse.getByName("nominalWidthX");
                                    widths[i] = nominalWidth + state.width;
                                } else {
                                    const defaultWidth = privateDictToUse.getByName("defaultWidthX");
                                    widths[i] = defaultWidth;
                                }
                                if (state.seac !== null) seacs[i] = state.seac;
                                if (!valid) charStrings.set(i, new Uint8Array([
                                    14
                                ]));
                            }
                            return {
                                charStrings: charStrings,
                                seacs: seacs,
                                widths: widths
                            };
                        }
                        emptyPrivateDictionary(parentDict) {
                            const privateDict = this.createDict(CFFPrivateDict, [], parentDict.strings);
                            parentDict.setByKey(18, [
                                0,
                                0
                            ]);
                            parentDict.privateDict = privateDict;
                        }
                        parsePrivateDict(parentDict) {
                            if (!parentDict.hasName("Private")) {
                                this.emptyPrivateDictionary(parentDict);
                                return;
                            }
                            const privateOffset = parentDict.getByName("Private");
                            if (!Array.isArray(privateOffset) || privateOffset.length !== 2) {
                                parentDict.removeByName("Private");
                                return;
                            }
                            const size = privateOffset[0];
                            const offset = privateOffset[1];
                            if (size === 0 || offset >= this.bytes.length) {
                                this.emptyPrivateDictionary(parentDict);
                                return;
                            }
                            const privateDictEnd = offset + size;
                            const dictData = this.bytes.subarray(offset, privateDictEnd);
                            const dict = this.parseDict(dictData);
                            const privateDict = this.createDict(CFFPrivateDict, dict, parentDict.strings);
                            parentDict.privateDict = privateDict;
                            if (!privateDict.getByName("Subrs")) return;
                            const subrsOffset = privateDict.getByName("Subrs");
                            const relativeOffset = offset + subrsOffset;
                            if (subrsOffset === 0 || relativeOffset >= this.bytes.length) {
                                this.emptyPrivateDictionary(parentDict);
                                return;
                            }
                            const subrsIndex = this.parseIndex(relativeOffset);
                            privateDict.subrsIndex = subrsIndex.obj;
                        }
                        parseCharsets(pos, length, strings, cid) {
                            if (pos === 0) return new CFFCharset(true, CFFCharsetPredefinedTypes.ISO_ADOBE, _charsets.ISOAdobeCharset);
                            else if (pos === 1) return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT, _charsets.ExpertCharset);
                            else if (pos === 2) return new CFFCharset(true, CFFCharsetPredefinedTypes.EXPERT_SUBSET, _charsets.ExpertSubsetCharset);
                            const bytes = this.bytes;
                            const start = pos;
                            const format = bytes[pos++];
                            const charset = [
                                cid ? 0 : ".notdef"
                            ];
                            let id, count, i;
                            length -= 1;
                            switch(format){
                                case 0:
                                    for(i = 0; i < length; i++){
                                        id = bytes[pos++] << 8 | bytes[pos++];
                                        charset.push(cid ? id : strings.get(id));
                                    }
                                    break;
                                case 1:
                                    while(charset.length <= length){
                                        id = bytes[pos++] << 8 | bytes[pos++];
                                        count = bytes[pos++];
                                        for(i = 0; i <= count; i++)charset.push(cid ? id++ : strings.get(id++));
                                    }
                                    break;
                                case 2:
                                    while(charset.length <= length){
                                        id = bytes[pos++] << 8 | bytes[pos++];
                                        count = bytes[pos++] << 8 | bytes[pos++];
                                        for(i = 0; i <= count; i++)charset.push(cid ? id++ : strings.get(id++));
                                    }
                                    break;
                                default:
                                    throw new _util.FormatError("Unknown charset format");
                            }
                            const end = pos;
                            const raw = bytes.subarray(start, end);
                            return new CFFCharset(false, format, charset, raw);
                        }
                        parseEncoding(pos, properties, strings, charset) {
                            const encoding = Object.create(null);
                            const bytes = this.bytes;
                            let predefined = false;
                            let format, i, ii;
                            let raw = null;
                            function readSupplement() {
                                const supplementsCount = bytes[pos++];
                                for(i = 0; i < supplementsCount; i++){
                                    const code = bytes[pos++];
                                    const sid = (bytes[pos++] << 8) + (bytes[pos++] & 0xff);
                                    encoding[code] = charset.indexOf(strings.get(sid));
                                }
                            }
                            if (pos === 0 || pos === 1) {
                                predefined = true;
                                format = pos;
                                const baseEncoding = pos ? _encodings.ExpertEncoding : _encodings.StandardEncoding;
                                for(i = 0, ii = charset.length; i < ii; i++){
                                    const index = baseEncoding.indexOf(charset[i]);
                                    if (index !== -1) encoding[index] = i;
                                }
                            } else {
                                const dataStart = pos;
                                format = bytes[pos++];
                                switch(format & 0x7f){
                                    case 0:
                                        const glyphsCount = bytes[pos++];
                                        for(i = 1; i <= glyphsCount; i++)encoding[bytes[pos++]] = i;
                                        break;
                                    case 1:
                                        const rangesCount = bytes[pos++];
                                        let gid = 1;
                                        for(i = 0; i < rangesCount; i++){
                                            const start = bytes[pos++];
                                            const left = bytes[pos++];
                                            for(let j = start; j <= start + left; j++)encoding[j] = gid++;
                                        }
                                        break;
                                    default:
                                        throw new _util.FormatError(`Unknown encoding format: ${format} in CFF`);
                                }
                                const dataEnd = pos;
                                if (format & 0x80) {
                                    bytes[dataStart] &= 0x7f;
                                    readSupplement();
                                }
                                raw = bytes.subarray(dataStart, dataEnd);
                            }
                            format &= 0x7f;
                            return new CFFEncoding(predefined, format, encoding, raw);
                        }
                        parseFDSelect(pos, length) {
                            const bytes = this.bytes;
                            const format = bytes[pos++];
                            const fdSelect = [];
                            let i;
                            switch(format){
                                case 0:
                                    for(i = 0; i < length; ++i){
                                        const id = bytes[pos++];
                                        fdSelect.push(id);
                                    }
                                    break;
                                case 3:
                                    const rangesCount = bytes[pos++] << 8 | bytes[pos++];
                                    for(i = 0; i < rangesCount; ++i){
                                        let first = bytes[pos++] << 8 | bytes[pos++];
                                        if (i === 0 && first !== 0) {
                                            (0, _util.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover.");
                                            first = 0;
                                        }
                                        const fdIndex = bytes[pos++];
                                        const next = bytes[pos] << 8 | bytes[pos + 1];
                                        for(let j = first; j < next; ++j)fdSelect.push(fdIndex);
                                    }
                                    pos += 2;
                                    break;
                                default:
                                    throw new _util.FormatError(`parseFDSelect: Unknown format "${format}".`);
                            }
                            if (fdSelect.length !== length) throw new _util.FormatError("parseFDSelect: Invalid font data.");
                            return new CFFFDSelect(format, fdSelect);
                        }
                    }
                    return CFFParser;
                }();
                exports.CFFParser = CFFParser;
                class CFF {
                    constructor(){
                        this.header = null;
                        this.names = [];
                        this.topDict = null;
                        this.strings = new CFFStrings();
                        this.globalSubrIndex = null;
                        this.encoding = null;
                        this.charset = null;
                        this.charStrings = null;
                        this.fdArray = [];
                        this.fdSelect = null;
                        this.isCIDFont = false;
                    }
                    duplicateFirstGlyph() {
                        if (this.charStrings.count >= 65535) {
                            (0, _util.warn)("Not enough space in charstrings to duplicate first glyph.");
                            return;
                        }
                        const glyphZero = this.charStrings.get(0);
                        this.charStrings.add(glyphZero);
                        if (this.isCIDFont) this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
                    }
                    hasGlyphId(id) {
                        if (id < 0 || id >= this.charStrings.count) return false;
                        const glyph = this.charStrings.get(id);
                        return glyph.length > 0;
                    }
                }
                exports.CFF = CFF;
                class CFFHeader {
                    constructor(major, minor, hdrSize, offSize){
                        this.major = major;
                        this.minor = minor;
                        this.hdrSize = hdrSize;
                        this.offSize = offSize;
                    }
                }
                exports.CFFHeader = CFFHeader;
                class CFFStrings {
                    constructor(){
                        this.strings = [];
                    }
                    get(index) {
                        if (index >= 0 && index <= NUM_STANDARD_CFF_STRINGS - 1) return CFFStandardStrings[index];
                        if (index - NUM_STANDARD_CFF_STRINGS <= this.strings.length) return this.strings[index - NUM_STANDARD_CFF_STRINGS];
                        return CFFStandardStrings[0];
                    }
                    getSID(str) {
                        let index = CFFStandardStrings.indexOf(str);
                        if (index !== -1) return index;
                        index = this.strings.indexOf(str);
                        if (index !== -1) return index + NUM_STANDARD_CFF_STRINGS;
                        return -1;
                    }
                    add(value) {
                        this.strings.push(value);
                    }
                    get count() {
                        return this.strings.length;
                    }
                }
                exports.CFFStrings = CFFStrings;
                class CFFIndex {
                    constructor(){
                        this.objects = [];
                        this.length = 0;
                    }
                    add(data) {
                        this.length += data.length;
                        this.objects.push(data);
                    }
                    set(index, data) {
                        this.length += data.length - this.objects[index].length;
                        this.objects[index] = data;
                    }
                    get(index) {
                        return this.objects[index];
                    }
                    get count() {
                        return this.objects.length;
                    }
                }
                exports.CFFIndex = CFFIndex;
                class CFFDict {
                    constructor(tables, strings){
                        this.keyToNameMap = tables.keyToNameMap;
                        this.nameToKeyMap = tables.nameToKeyMap;
                        this.defaults = tables.defaults;
                        this.types = tables.types;
                        this.opcodes = tables.opcodes;
                        this.order = tables.order;
                        this.strings = strings;
                        this.values = Object.create(null);
                    }
                    setByKey(key, value) {
                        if (!(key in this.keyToNameMap)) return false;
                        const valueLength = value.length;
                        if (valueLength === 0) return true;
                        for(let i = 0; i < valueLength; i++)if (isNaN(value[i])) {
                            (0, _util.warn)('Invalid CFFDict value: "' + value + '" for key "' + key + '".');
                            return true;
                        }
                        const type = this.types[key];
                        if (type === "num" || type === "sid" || type === "offset") value = value[0];
                        this.values[key] = value;
                        return true;
                    }
                    setByName(name, value) {
                        if (!(name in this.nameToKeyMap)) throw new _util.FormatError(`Invalid dictionary name "${name}"`);
                        this.values[this.nameToKeyMap[name]] = value;
                    }
                    hasName(name) {
                        return this.nameToKeyMap[name] in this.values;
                    }
                    getByName(name) {
                        if (!(name in this.nameToKeyMap)) throw new _util.FormatError(`Invalid dictionary name ${name}"`);
                        const key = this.nameToKeyMap[name];
                        if (!(key in this.values)) return this.defaults[key];
                        return this.values[key];
                    }
                    removeByName(name) {
                        delete this.values[this.nameToKeyMap[name]];
                    }
                    static createTables(layout) {
                        const tables = {
                            keyToNameMap: {},
                            nameToKeyMap: {},
                            defaults: {},
                            types: {},
                            opcodes: {},
                            order: []
                        };
                        for(let i = 0, ii = layout.length; i < ii; ++i){
                            const entry = layout[i];
                            const key = Array.isArray(entry[0]) ? (entry[0][0] << 8) + entry[0][1] : entry[0];
                            tables.keyToNameMap[key] = entry[1];
                            tables.nameToKeyMap[entry[1]] = key;
                            tables.types[key] = entry[2];
                            tables.defaults[key] = entry[3];
                            tables.opcodes[key] = Array.isArray(entry[0]) ? entry[0] : [
                                entry[0]
                            ];
                            tables.order.push(key);
                        }
                        return tables;
                    }
                }
                const CFFTopDict = function CFFTopDictClosure() {
                    const layout = [
                        [
                            [
                                12,
                                30
                            ],
                            "ROS",
                            [
                                "sid",
                                "sid",
                                "num"
                            ],
                            null
                        ],
                        [
                            [
                                12,
                                20
                            ],
                            "SyntheticBase",
                            "num",
                            null
                        ],
                        [
                            0,
                            "version",
                            "sid",
                            null
                        ],
                        [
                            1,
                            "Notice",
                            "sid",
                            null
                        ],
                        [
                            [
                                12,
                                0
                            ],
                            "Copyright",
                            "sid",
                            null
                        ],
                        [
                            2,
                            "FullName",
                            "sid",
                            null
                        ],
                        [
                            3,
                            "FamilyName",
                            "sid",
                            null
                        ],
                        [
                            4,
                            "Weight",
                            "sid",
                            null
                        ],
                        [
                            [
                                12,
                                1
                            ],
                            "isFixedPitch",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                2
                            ],
                            "ItalicAngle",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                3
                            ],
                            "UnderlinePosition",
                            "num",
                            -100
                        ],
                        [
                            [
                                12,
                                4
                            ],
                            "UnderlineThickness",
                            "num",
                            50
                        ],
                        [
                            [
                                12,
                                5
                            ],
                            "PaintType",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                6
                            ],
                            "CharstringType",
                            "num",
                            2
                        ],
                        [
                            [
                                12,
                                7
                            ],
                            "FontMatrix",
                            [
                                "num",
                                "num",
                                "num",
                                "num",
                                "num",
                                "num"
                            ],
                            [
                                0.001,
                                0,
                                0,
                                0.001,
                                0,
                                0
                            ]
                        ],
                        [
                            13,
                            "UniqueID",
                            "num",
                            null
                        ],
                        [
                            5,
                            "FontBBox",
                            [
                                "num",
                                "num",
                                "num",
                                "num"
                            ],
                            [
                                0,
                                0,
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                12,
                                8
                            ],
                            "StrokeWidth",
                            "num",
                            0
                        ],
                        [
                            14,
                            "XUID",
                            "array",
                            null
                        ],
                        [
                            15,
                            "charset",
                            "offset",
                            0
                        ],
                        [
                            16,
                            "Encoding",
                            "offset",
                            0
                        ],
                        [
                            17,
                            "CharStrings",
                            "offset",
                            0
                        ],
                        [
                            18,
                            "Private",
                            [
                                "offset",
                                "offset"
                            ],
                            null
                        ],
                        [
                            [
                                12,
                                21
                            ],
                            "PostScript",
                            "sid",
                            null
                        ],
                        [
                            [
                                12,
                                22
                            ],
                            "BaseFontName",
                            "sid",
                            null
                        ],
                        [
                            [
                                12,
                                23
                            ],
                            "BaseFontBlend",
                            "delta",
                            null
                        ],
                        [
                            [
                                12,
                                31
                            ],
                            "CIDFontVersion",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                32
                            ],
                            "CIDFontRevision",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                33
                            ],
                            "CIDFontType",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                34
                            ],
                            "CIDCount",
                            "num",
                            8720
                        ],
                        [
                            [
                                12,
                                35
                            ],
                            "UIDBase",
                            "num",
                            null
                        ],
                        [
                            [
                                12,
                                37
                            ],
                            "FDSelect",
                            "offset",
                            null
                        ],
                        [
                            [
                                12,
                                36
                            ],
                            "FDArray",
                            "offset",
                            null
                        ],
                        [
                            [
                                12,
                                38
                            ],
                            "FontName",
                            "sid",
                            null
                        ]
                    ];
                    let tables = null;
                    class CFFTopDict extends CFFDict {
                        constructor(strings){
                            if (tables === null) tables = CFFDict.createTables(layout);
                            super(tables, strings);
                            this.privateDict = null;
                        }
                    }
                    return CFFTopDict;
                }();
                exports.CFFTopDict = CFFTopDict;
                const CFFPrivateDict = function CFFPrivateDictClosure() {
                    const layout = [
                        [
                            6,
                            "BlueValues",
                            "delta",
                            null
                        ],
                        [
                            7,
                            "OtherBlues",
                            "delta",
                            null
                        ],
                        [
                            8,
                            "FamilyBlues",
                            "delta",
                            null
                        ],
                        [
                            9,
                            "FamilyOtherBlues",
                            "delta",
                            null
                        ],
                        [
                            [
                                12,
                                9
                            ],
                            "BlueScale",
                            "num",
                            0.039625
                        ],
                        [
                            [
                                12,
                                10
                            ],
                            "BlueShift",
                            "num",
                            7
                        ],
                        [
                            [
                                12,
                                11
                            ],
                            "BlueFuzz",
                            "num",
                            1
                        ],
                        [
                            10,
                            "StdHW",
                            "num",
                            null
                        ],
                        [
                            11,
                            "StdVW",
                            "num",
                            null
                        ],
                        [
                            [
                                12,
                                12
                            ],
                            "StemSnapH",
                            "delta",
                            null
                        ],
                        [
                            [
                                12,
                                13
                            ],
                            "StemSnapV",
                            "delta",
                            null
                        ],
                        [
                            [
                                12,
                                14
                            ],
                            "ForceBold",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                17
                            ],
                            "LanguageGroup",
                            "num",
                            0
                        ],
                        [
                            [
                                12,
                                18
                            ],
                            "ExpansionFactor",
                            "num",
                            0.06
                        ],
                        [
                            [
                                12,
                                19
                            ],
                            "initialRandomSeed",
                            "num",
                            0
                        ],
                        [
                            20,
                            "defaultWidthX",
                            "num",
                            0
                        ],
                        [
                            21,
                            "nominalWidthX",
                            "num",
                            0
                        ],
                        [
                            19,
                            "Subrs",
                            "offset",
                            null
                        ]
                    ];
                    let tables = null;
                    class CFFPrivateDict extends CFFDict {
                        constructor(strings){
                            if (tables === null) tables = CFFDict.createTables(layout);
                            super(tables, strings);
                            this.subrsIndex = null;
                        }
                    }
                    return CFFPrivateDict;
                }();
                exports.CFFPrivateDict = CFFPrivateDict;
                const CFFCharsetPredefinedTypes = {
                    ISO_ADOBE: 0,
                    EXPERT: 1,
                    EXPERT_SUBSET: 2
                };
                class CFFCharset {
                    constructor(predefined, format, charset, raw){
                        this.predefined = predefined;
                        this.format = format;
                        this.charset = charset;
                        this.raw = raw;
                    }
                }
                exports.CFFCharset = CFFCharset;
                class CFFEncoding {
                    constructor(predefined, format, encoding, raw){
                        this.predefined = predefined;
                        this.format = format;
                        this.encoding = encoding;
                        this.raw = raw;
                    }
                }
                class CFFFDSelect {
                    constructor(format, fdSelect){
                        this.format = format;
                        this.fdSelect = fdSelect;
                    }
                    getFDIndex(glyphIndex) {
                        if (glyphIndex < 0 || glyphIndex >= this.fdSelect.length) return -1;
                        return this.fdSelect[glyphIndex];
                    }
                }
                exports.CFFFDSelect = CFFFDSelect;
                class CFFOffsetTracker {
                    constructor(){
                        this.offsets = Object.create(null);
                    }
                    isTracking(key) {
                        return key in this.offsets;
                    }
                    track(key, location) {
                        if (key in this.offsets) throw new _util.FormatError(`Already tracking location of ${key}`);
                        this.offsets[key] = location;
                    }
                    offset(value) {
                        for(const key in this.offsets)this.offsets[key] += value;
                    }
                    setEntryLocation(key, values, output) {
                        if (!(key in this.offsets)) throw new _util.FormatError(`Not tracking location of ${key}`);
                        const data = output.data;
                        const dataOffset = this.offsets[key];
                        const size = 5;
                        for(let i = 0, ii = values.length; i < ii; ++i){
                            const offset0 = i * size + dataOffset;
                            const offset1 = offset0 + 1;
                            const offset2 = offset0 + 2;
                            const offset3 = offset0 + 3;
                            const offset4 = offset0 + 4;
                            if (data[offset0] !== 0x1d || data[offset1] !== 0 || data[offset2] !== 0 || data[offset3] !== 0 || data[offset4] !== 0) throw new _util.FormatError("writing to an offset that is not empty");
                            const value = values[i];
                            data[offset0] = 0x1d;
                            data[offset1] = value >> 24 & 0xff;
                            data[offset2] = value >> 16 & 0xff;
                            data[offset3] = value >> 8 & 0xff;
                            data[offset4] = value & 0xff;
                        }
                    }
                }
                class CFFCompiler {
                    constructor(cff){
                        this.cff = cff;
                    }
                    compile() {
                        const cff = this.cff;
                        const output = {
                            data: [],
                            length: 0,
                            add: function CFFCompiler_add(data) {
                                this.data = this.data.concat(data);
                                this.length = this.data.length;
                            }
                        };
                        const header = this.compileHeader(cff.header);
                        output.add(header);
                        const nameIndex = this.compileNameIndex(cff.names);
                        output.add(nameIndex);
                        if (cff.isCIDFont) {
                            if (cff.topDict.hasName("FontMatrix")) {
                                const base = cff.topDict.getByName("FontMatrix");
                                cff.topDict.removeByName("FontMatrix");
                                for(let i = 0, ii = cff.fdArray.length; i < ii; i++){
                                    const subDict = cff.fdArray[i];
                                    let matrix = base.slice(0);
                                    if (subDict.hasName("FontMatrix")) matrix = _util.Util.transform(matrix, subDict.getByName("FontMatrix"));
                                    subDict.setByName("FontMatrix", matrix);
                                }
                            }
                        }
                        const xuid = cff.topDict.getByName("XUID");
                        if (xuid && xuid.length > 16) cff.topDict.removeByName("XUID");
                        cff.topDict.setByName("charset", 0);
                        let compiled = this.compileTopDicts([
                            cff.topDict
                        ], output.length, cff.isCIDFont);
                        output.add(compiled.output);
                        const topDictTracker = compiled.trackers[0];
                        const stringIndex = this.compileStringIndex(cff.strings.strings);
                        output.add(stringIndex);
                        const globalSubrIndex = this.compileIndex(cff.globalSubrIndex);
                        output.add(globalSubrIndex);
                        if (cff.encoding && cff.topDict.hasName("Encoding")) {
                            if (cff.encoding.predefined) topDictTracker.setEntryLocation("Encoding", [
                                cff.encoding.format
                            ], output);
                            else {
                                const encoding = this.compileEncoding(cff.encoding);
                                topDictTracker.setEntryLocation("Encoding", [
                                    output.length
                                ], output);
                                output.add(encoding);
                            }
                        }
                        const charset = this.compileCharset(cff.charset, cff.charStrings.count, cff.strings, cff.isCIDFont);
                        topDictTracker.setEntryLocation("charset", [
                            output.length
                        ], output);
                        output.add(charset);
                        const charStrings = this.compileCharStrings(cff.charStrings);
                        topDictTracker.setEntryLocation("CharStrings", [
                            output.length
                        ], output);
                        output.add(charStrings);
                        if (cff.isCIDFont) {
                            topDictTracker.setEntryLocation("FDSelect", [
                                output.length
                            ], output);
                            const fdSelect = this.compileFDSelect(cff.fdSelect);
                            output.add(fdSelect);
                            compiled = this.compileTopDicts(cff.fdArray, output.length, true);
                            topDictTracker.setEntryLocation("FDArray", [
                                output.length
                            ], output);
                            output.add(compiled.output);
                            const fontDictTrackers = compiled.trackers;
                            this.compilePrivateDicts(cff.fdArray, fontDictTrackers, output);
                        }
                        this.compilePrivateDicts([
                            cff.topDict
                        ], [
                            topDictTracker
                        ], output);
                        output.add([
                            0
                        ]);
                        return output.data;
                    }
                    encodeNumber(value) {
                        if (Number.isInteger(value)) return this.encodeInteger(value);
                        return this.encodeFloat(value);
                    }
                    static get EncodeFloatRegExp() {
                        return (0, _util.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
                    }
                    encodeFloat(num) {
                        let value = num.toString();
                        const m = CFFCompiler.EncodeFloatRegExp.exec(value);
                        if (m) {
                            const epsilon = parseFloat("1e" + ((m[2] ? +m[2] : 0) + m[1].length));
                            value = (Math.round(num * epsilon) / epsilon).toString();
                        }
                        let nibbles = "";
                        let i, ii;
                        for(i = 0, ii = value.length; i < ii; ++i){
                            const a = value[i];
                            if (a === "e") nibbles += value[++i] === "-" ? "c" : "b";
                            else if (a === ".") nibbles += "a";
                            else if (a === "-") nibbles += "e";
                            else nibbles += a;
                        }
                        nibbles += nibbles.length & 1 ? "f" : "ff";
                        const out = [
                            30
                        ];
                        for(i = 0, ii = nibbles.length; i < ii; i += 2)out.push(parseInt(nibbles.substring(i, i + 2), 16));
                        return out;
                    }
                    encodeInteger(value) {
                        let code;
                        if (value >= -107 && value <= 107) code = [
                            value + 139
                        ];
                        else if (value >= 108 && value <= 1131) {
                            value -= 108;
                            code = [
                                (value >> 8) + 247,
                                value & 0xff
                            ];
                        } else if (value >= -1131 && value <= -108) {
                            value = -value - 108;
                            code = [
                                (value >> 8) + 251,
                                value & 0xff
                            ];
                        } else if (value >= -32768 && value <= 32767) code = [
                            0x1c,
                            value >> 8 & 0xff,
                            value & 0xff
                        ];
                        else code = [
                            0x1d,
                            value >> 24 & 0xff,
                            value >> 16 & 0xff,
                            value >> 8 & 0xff,
                            value & 0xff
                        ];
                        return code;
                    }
                    compileHeader(header) {
                        return [
                            header.major,
                            header.minor,
                            4,
                            header.offSize
                        ];
                    }
                    compileNameIndex(names) {
                        const nameIndex = new CFFIndex();
                        for(let i = 0, ii = names.length; i < ii; ++i){
                            const name = names[i];
                            const length = Math.min(name.length, 127);
                            let sanitizedName = new Array(length);
                            for(let j = 0; j < length; j++){
                                let char = name[j];
                                if (char < "!" || char > "~" || char === "[" || char === "]" || char === "(" || char === ")" || char === "{" || char === "}" || char === "<" || char === ">" || char === "/" || char === "%") char = "_";
                                sanitizedName[j] = char;
                            }
                            sanitizedName = sanitizedName.join("");
                            if (sanitizedName === "") sanitizedName = "Bad_Font_Name";
                            nameIndex.add((0, _util.stringToBytes)(sanitizedName));
                        }
                        return this.compileIndex(nameIndex);
                    }
                    compileTopDicts(dicts, length, removeCidKeys) {
                        const fontDictTrackers = [];
                        let fdArrayIndex = new CFFIndex();
                        for(let i = 0, ii = dicts.length; i < ii; ++i){
                            const fontDict = dicts[i];
                            if (removeCidKeys) {
                                fontDict.removeByName("CIDFontVersion");
                                fontDict.removeByName("CIDFontRevision");
                                fontDict.removeByName("CIDFontType");
                                fontDict.removeByName("CIDCount");
                                fontDict.removeByName("UIDBase");
                            }
                            const fontDictTracker = new CFFOffsetTracker();
                            const fontDictData = this.compileDict(fontDict, fontDictTracker);
                            fontDictTrackers.push(fontDictTracker);
                            fdArrayIndex.add(fontDictData);
                            fontDictTracker.offset(length);
                        }
                        fdArrayIndex = this.compileIndex(fdArrayIndex, fontDictTrackers);
                        return {
                            trackers: fontDictTrackers,
                            output: fdArrayIndex
                        };
                    }
                    compilePrivateDicts(dicts, trackers, output) {
                        for(let i = 0, ii = dicts.length; i < ii; ++i){
                            const fontDict = dicts[i];
                            const privateDict = fontDict.privateDict;
                            if (!privateDict || !fontDict.hasName("Private")) throw new _util.FormatError("There must be a private dictionary.");
                            const privateDictTracker = new CFFOffsetTracker();
                            const privateDictData = this.compileDict(privateDict, privateDictTracker);
                            let outputLength = output.length;
                            privateDictTracker.offset(outputLength);
                            if (!privateDictData.length) outputLength = 0;
                            trackers[i].setEntryLocation("Private", [
                                privateDictData.length,
                                outputLength
                            ], output);
                            output.add(privateDictData);
                            if (privateDict.subrsIndex && privateDict.hasName("Subrs")) {
                                const subrs = this.compileIndex(privateDict.subrsIndex);
                                privateDictTracker.setEntryLocation("Subrs", [
                                    privateDictData.length
                                ], output);
                                output.add(subrs);
                            }
                        }
                    }
                    compileDict(dict, offsetTracker) {
                        let out = [];
                        const order = dict.order;
                        for(let i = 0; i < order.length; ++i){
                            const key = order[i];
                            if (!(key in dict.values)) continue;
                            let values = dict.values[key];
                            let types = dict.types[key];
                            if (!Array.isArray(types)) types = [
                                types
                            ];
                            if (!Array.isArray(values)) values = [
                                values
                            ];
                            if (values.length === 0) continue;
                            for(let j = 0, jj = types.length; j < jj; ++j){
                                const type = types[j];
                                const value = values[j];
                                switch(type){
                                    case "num":
                                    case "sid":
                                        out = out.concat(this.encodeNumber(value));
                                        break;
                                    case "offset":
                                        const name = dict.keyToNameMap[key];
                                        if (!offsetTracker.isTracking(name)) offsetTracker.track(name, out.length);
                                        out = out.concat([
                                            0x1d,
                                            0,
                                            0,
                                            0,
                                            0
                                        ]);
                                        break;
                                    case "array":
                                    case "delta":
                                        out = out.concat(this.encodeNumber(value));
                                        for(let k = 1, kk = values.length; k < kk; ++k)out = out.concat(this.encodeNumber(values[k]));
                                        break;
                                    default:
                                        throw new _util.FormatError(`Unknown data type of ${type}`);
                                }
                            }
                            out = out.concat(dict.opcodes[key]);
                        }
                        return out;
                    }
                    compileStringIndex(strings) {
                        const stringIndex = new CFFIndex();
                        for(let i = 0, ii = strings.length; i < ii; ++i)stringIndex.add((0, _util.stringToBytes)(strings[i]));
                        return this.compileIndex(stringIndex);
                    }
                    compileGlobalSubrIndex() {
                        const globalSubrIndex = this.cff.globalSubrIndex;
                        this.out.writeByteArray(this.compileIndex(globalSubrIndex));
                    }
                    compileCharStrings(charStrings) {
                        const charStringsIndex = new CFFIndex();
                        for(let i = 0; i < charStrings.count; i++){
                            const glyph = charStrings.get(i);
                            if (glyph.length === 0) {
                                charStringsIndex.add(new Uint8Array([
                                    0x8b,
                                    0x0e
                                ]));
                                continue;
                            }
                            charStringsIndex.add(glyph);
                        }
                        return this.compileIndex(charStringsIndex);
                    }
                    compileCharset(charset, numGlyphs, strings, isCIDFont) {
                        let out;
                        const numGlyphsLessNotDef = numGlyphs - 1;
                        if (isCIDFont) out = new Uint8Array([
                            2,
                            0,
                            0,
                            numGlyphsLessNotDef >> 8 & 0xff,
                            numGlyphsLessNotDef & 0xff
                        ]);
                        else {
                            const length = 1 + numGlyphsLessNotDef * 2;
                            out = new Uint8Array(length);
                            out[0] = 0;
                            let charsetIndex = 0;
                            const numCharsets = charset.charset.length;
                            let warned = false;
                            for(let i = 1; i < out.length; i += 2){
                                let sid = 0;
                                if (charsetIndex < numCharsets) {
                                    const name = charset.charset[charsetIndex++];
                                    sid = strings.getSID(name);
                                    if (sid === -1) {
                                        sid = 0;
                                        if (!warned) {
                                            warned = true;
                                            (0, _util.warn)(`Couldn't find ${name} in CFF strings`);
                                        }
                                    }
                                }
                                out[i] = sid >> 8 & 0xff;
                                out[i + 1] = sid & 0xff;
                            }
                        }
                        return this.compileTypedArray(out);
                    }
                    compileEncoding(encoding) {
                        return this.compileTypedArray(encoding.raw);
                    }
                    compileFDSelect(fdSelect) {
                        const format = fdSelect.format;
                        let out, i;
                        switch(format){
                            case 0:
                                out = new Uint8Array(1 + fdSelect.fdSelect.length);
                                out[0] = format;
                                for(i = 0; i < fdSelect.fdSelect.length; i++)out[i + 1] = fdSelect.fdSelect[i];
                                break;
                            case 3:
                                const start = 0;
                                let lastFD = fdSelect.fdSelect[0];
                                const ranges = [
                                    format,
                                    0,
                                    0,
                                    start >> 8 & 0xff,
                                    start & 0xff,
                                    lastFD
                                ];
                                for(i = 1; i < fdSelect.fdSelect.length; i++){
                                    const currentFD = fdSelect.fdSelect[i];
                                    if (currentFD !== lastFD) {
                                        ranges.push(i >> 8 & 0xff, i & 0xff, currentFD);
                                        lastFD = currentFD;
                                    }
                                }
                                const numRanges = (ranges.length - 3) / 3;
                                ranges[1] = numRanges >> 8 & 0xff;
                                ranges[2] = numRanges & 0xff;
                                ranges.push(i >> 8 & 0xff, i & 0xff);
                                out = new Uint8Array(ranges);
                                break;
                        }
                        return this.compileTypedArray(out);
                    }
                    compileTypedArray(data) {
                        const out = [];
                        for(let i = 0, ii = data.length; i < ii; ++i)out[i] = data[i];
                        return out;
                    }
                    compileIndex(index, trackers = []) {
                        const objects = index.objects;
                        const count = objects.length;
                        if (count === 0) return [
                            0,
                            0,
                            0
                        ];
                        const data = [
                            count >> 8 & 0xff,
                            count & 0xff
                        ];
                        let lastOffset = 1, i;
                        for(i = 0; i < count; ++i)lastOffset += objects[i].length;
                        let offsetSize;
                        if (lastOffset < 0x100) offsetSize = 1;
                        else if (lastOffset < 0x10000) offsetSize = 2;
                        else if (lastOffset < 0x1000000) offsetSize = 3;
                        else offsetSize = 4;
                        data.push(offsetSize);
                        let relativeOffset = 1;
                        for(i = 0; i < count + 1; i++){
                            if (offsetSize === 1) data.push(relativeOffset & 0xff);
                            else if (offsetSize === 2) data.push(relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            else if (offsetSize === 3) data.push(relativeOffset >> 16 & 0xff, relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            else data.push(relativeOffset >>> 24 & 0xff, relativeOffset >> 16 & 0xff, relativeOffset >> 8 & 0xff, relativeOffset & 0xff);
                            if (objects[i]) relativeOffset += objects[i].length;
                        }
                        for(i = 0; i < count; i++){
                            if (trackers[i]) trackers[i].offset(data.length);
                            for(let j = 0, jj = objects[i].length; j < jj; j++)data.push(objects[i][j]);
                        }
                        return data;
                    }
                }
                exports.CFFCompiler = CFFCompiler;
            /***/ },
            /* 36 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ISOAdobeCharset = exports.ExpertSubsetCharset = exports.ExpertCharset = void 0;
                const ISOAdobeCharset = [
                    ".notdef",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "questiondown",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "AE",
                    "ordfeminine",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "ae",
                    "dotlessi",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "onesuperior",
                    "logicalnot",
                    "mu",
                    "trademark",
                    "Eth",
                    "onehalf",
                    "plusminus",
                    "Thorn",
                    "onequarter",
                    "divide",
                    "brokenbar",
                    "degree",
                    "thorn",
                    "threequarters",
                    "twosuperior",
                    "registered",
                    "minus",
                    "eth",
                    "multiply",
                    "threesuperior",
                    "copyright",
                    "Aacute",
                    "Acircumflex",
                    "Adieresis",
                    "Agrave",
                    "Aring",
                    "Atilde",
                    "Ccedilla",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Ntilde",
                    "Oacute",
                    "Ocircumflex",
                    "Odieresis",
                    "Ograve",
                    "Otilde",
                    "Scaron",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Ugrave",
                    "Yacute",
                    "Ydieresis",
                    "Zcaron",
                    "aacute",
                    "acircumflex",
                    "adieresis",
                    "agrave",
                    "aring",
                    "atilde",
                    "ccedilla",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "egrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "igrave",
                    "ntilde",
                    "oacute",
                    "ocircumflex",
                    "odieresis",
                    "ograve",
                    "otilde",
                    "scaron",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "ugrave",
                    "yacute",
                    "ydieresis",
                    "zcaron"
                ];
                exports.ISOAdobeCharset = ISOAdobeCharset;
                const ExpertCharset = [
                    ".notdef",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "Dotaccentsmall",
                    "Macronsmall",
                    "figuredash",
                    "hypheninferior",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                exports.ExpertCharset = ExpertCharset;
                const ExpertSubsetCharset = [
                    ".notdef",
                    "space",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "isuperior",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "parenrightinferior",
                    "hyphensuperior",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "centoldstyle",
                    "figuredash",
                    "hypheninferior",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior"
                ];
                exports.ExpertSubsetCharset = ExpertSubsetCharset;
            /***/ },
            /* 37 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getEncoding = getEncoding;
                exports.ZapfDingbatsEncoding = exports.WinAnsiEncoding = exports.SymbolSetEncoding = exports.StandardEncoding = exports.MacRomanEncoding = exports.ExpertEncoding = void 0;
                const ExpertEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "commasuperior",
                    "threequartersemdash",
                    "periodsuperior",
                    "questionsmall",
                    "",
                    "asuperior",
                    "bsuperior",
                    "centsuperior",
                    "dsuperior",
                    "esuperior",
                    "",
                    "",
                    "",
                    "isuperior",
                    "",
                    "",
                    "lsuperior",
                    "msuperior",
                    "nsuperior",
                    "osuperior",
                    "",
                    "",
                    "rsuperior",
                    "ssuperior",
                    "tsuperior",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hyphensuperior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "centoldstyle",
                    "Lslashsmall",
                    "",
                    "",
                    "Scaronsmall",
                    "Zcaronsmall",
                    "Dieresissmall",
                    "Brevesmall",
                    "Caronsmall",
                    "",
                    "Dotaccentsmall",
                    "",
                    "",
                    "Macronsmall",
                    "",
                    "",
                    "figuredash",
                    "hypheninferior",
                    "",
                    "",
                    "Ogoneksmall",
                    "Ringsmall",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondownsmall",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "zerosuperior",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "eightsuperior",
                    "ninesuperior",
                    "zeroinferior",
                    "oneinferior",
                    "twoinferior",
                    "threeinferior",
                    "fourinferior",
                    "fiveinferior",
                    "sixinferior",
                    "seveninferior",
                    "eightinferior",
                    "nineinferior",
                    "centinferior",
                    "dollarinferior",
                    "periodinferior",
                    "commainferior",
                    "Agravesmall",
                    "Aacutesmall",
                    "Acircumflexsmall",
                    "Atildesmall",
                    "Adieresissmall",
                    "Aringsmall",
                    "AEsmall",
                    "Ccedillasmall",
                    "Egravesmall",
                    "Eacutesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Igravesmall",
                    "Iacutesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ethsmall",
                    "Ntildesmall",
                    "Ogravesmall",
                    "Oacutesmall",
                    "Ocircumflexsmall",
                    "Otildesmall",
                    "Odieresissmall",
                    "OEsmall",
                    "Oslashsmall",
                    "Ugravesmall",
                    "Uacutesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "Yacutesmall",
                    "Thornsmall",
                    "Ydieresissmall"
                ];
                exports.ExpertEncoding = ExpertEncoding;
                const MacExpertEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclamsmall",
                    "Hungarumlautsmall",
                    "centoldstyle",
                    "dollaroldstyle",
                    "dollarsuperior",
                    "ampersandsmall",
                    "Acutesmall",
                    "parenleftsuperior",
                    "parenrightsuperior",
                    "twodotenleader",
                    "onedotenleader",
                    "comma",
                    "hyphen",
                    "period",
                    "fraction",
                    "zerooldstyle",
                    "oneoldstyle",
                    "twooldstyle",
                    "threeoldstyle",
                    "fouroldstyle",
                    "fiveoldstyle",
                    "sixoldstyle",
                    "sevenoldstyle",
                    "eightoldstyle",
                    "nineoldstyle",
                    "colon",
                    "semicolon",
                    "",
                    "threequartersemdash",
                    "",
                    "questionsmall",
                    "",
                    "",
                    "",
                    "",
                    "Ethsmall",
                    "",
                    "",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "oneeighth",
                    "threeeighths",
                    "fiveeighths",
                    "seveneighths",
                    "onethird",
                    "twothirds",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ff",
                    "fi",
                    "fl",
                    "ffi",
                    "ffl",
                    "parenleftinferior",
                    "",
                    "parenrightinferior",
                    "Circumflexsmall",
                    "hypheninferior",
                    "Gravesmall",
                    "Asmall",
                    "Bsmall",
                    "Csmall",
                    "Dsmall",
                    "Esmall",
                    "Fsmall",
                    "Gsmall",
                    "Hsmall",
                    "Ismall",
                    "Jsmall",
                    "Ksmall",
                    "Lsmall",
                    "Msmall",
                    "Nsmall",
                    "Osmall",
                    "Psmall",
                    "Qsmall",
                    "Rsmall",
                    "Ssmall",
                    "Tsmall",
                    "Usmall",
                    "Vsmall",
                    "Wsmall",
                    "Xsmall",
                    "Ysmall",
                    "Zsmall",
                    "colonmonetary",
                    "onefitted",
                    "rupiah",
                    "Tildesmall",
                    "",
                    "",
                    "asuperior",
                    "centsuperior",
                    "",
                    "",
                    "",
                    "",
                    "Aacutesmall",
                    "Agravesmall",
                    "Acircumflexsmall",
                    "Adieresissmall",
                    "Atildesmall",
                    "Aringsmall",
                    "Ccedillasmall",
                    "Eacutesmall",
                    "Egravesmall",
                    "Ecircumflexsmall",
                    "Edieresissmall",
                    "Iacutesmall",
                    "Igravesmall",
                    "Icircumflexsmall",
                    "Idieresissmall",
                    "Ntildesmall",
                    "Oacutesmall",
                    "Ogravesmall",
                    "Ocircumflexsmall",
                    "Odieresissmall",
                    "Otildesmall",
                    "Uacutesmall",
                    "Ugravesmall",
                    "Ucircumflexsmall",
                    "Udieresissmall",
                    "",
                    "eightsuperior",
                    "fourinferior",
                    "threeinferior",
                    "sixinferior",
                    "eightinferior",
                    "seveninferior",
                    "Scaronsmall",
                    "",
                    "centinferior",
                    "twoinferior",
                    "",
                    "Dieresissmall",
                    "",
                    "Caronsmall",
                    "osuperior",
                    "fiveinferior",
                    "",
                    "commainferior",
                    "periodinferior",
                    "Yacutesmall",
                    "",
                    "dollarinferior",
                    "",
                    "",
                    "Thornsmall",
                    "",
                    "nineinferior",
                    "zeroinferior",
                    "Zcaronsmall",
                    "AEsmall",
                    "Oslashsmall",
                    "questiondownsmall",
                    "oneinferior",
                    "Lslashsmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Cedillasmall",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "OEsmall",
                    "figuredash",
                    "hyphensuperior",
                    "",
                    "",
                    "",
                    "",
                    "exclamdownsmall",
                    "",
                    "Ydieresissmall",
                    "",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "foursuperior",
                    "fivesuperior",
                    "sixsuperior",
                    "sevensuperior",
                    "ninesuperior",
                    "zerosuperior",
                    "",
                    "esuperior",
                    "rsuperior",
                    "tsuperior",
                    "",
                    "",
                    "isuperior",
                    "ssuperior",
                    "dsuperior",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "lsuperior",
                    "Ogoneksmall",
                    "Brevesmall",
                    "Macronsmall",
                    "bsuperior",
                    "nsuperior",
                    "msuperior",
                    "commasuperior",
                    "periodsuperior",
                    "Dotaccentsmall",
                    "Ringsmall",
                    "",
                    "",
                    "",
                    ""
                ];
                const MacRomanEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "space",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron"
                ];
                exports.MacRomanEncoding = MacRomanEncoding;
                const StandardEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quoteright",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "quoteleft",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "fraction",
                    "yen",
                    "florin",
                    "section",
                    "currency",
                    "quotesingle",
                    "quotedblleft",
                    "guillemotleft",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "",
                    "endash",
                    "dagger",
                    "daggerdbl",
                    "periodcentered",
                    "",
                    "paragraph",
                    "bullet",
                    "quotesinglbase",
                    "quotedblbase",
                    "quotedblright",
                    "guillemotright",
                    "ellipsis",
                    "perthousand",
                    "",
                    "questiondown",
                    "",
                    "grave",
                    "acute",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "dieresis",
                    "",
                    "ring",
                    "cedilla",
                    "",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "emdash",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "AE",
                    "",
                    "ordfeminine",
                    "",
                    "",
                    "",
                    "",
                    "Lslash",
                    "Oslash",
                    "OE",
                    "ordmasculine",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "ae",
                    "",
                    "",
                    "",
                    "dotlessi",
                    "",
                    "",
                    "lslash",
                    "oslash",
                    "oe",
                    "germandbls",
                    "",
                    "",
                    "",
                    ""
                ];
                exports.StandardEncoding = StandardEncoding;
                const WinAnsiEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "bullet",
                    "Euro",
                    "bullet",
                    "quotesinglbase",
                    "florin",
                    "quotedblbase",
                    "ellipsis",
                    "dagger",
                    "daggerdbl",
                    "circumflex",
                    "perthousand",
                    "Scaron",
                    "guilsinglleft",
                    "OE",
                    "bullet",
                    "Zcaron",
                    "bullet",
                    "bullet",
                    "quoteleft",
                    "quoteright",
                    "quotedblleft",
                    "quotedblright",
                    "bullet",
                    "endash",
                    "emdash",
                    "tilde",
                    "trademark",
                    "scaron",
                    "guilsinglright",
                    "oe",
                    "bullet",
                    "zcaron",
                    "Ydieresis",
                    "space",
                    "exclamdown",
                    "cent",
                    "sterling",
                    "currency",
                    "yen",
                    "brokenbar",
                    "section",
                    "dieresis",
                    "copyright",
                    "ordfeminine",
                    "guillemotleft",
                    "logicalnot",
                    "hyphen",
                    "registered",
                    "macron",
                    "degree",
                    "plusminus",
                    "twosuperior",
                    "threesuperior",
                    "acute",
                    "mu",
                    "paragraph",
                    "periodcentered",
                    "cedilla",
                    "onesuperior",
                    "ordmasculine",
                    "guillemotright",
                    "onequarter",
                    "onehalf",
                    "threequarters",
                    "questiondown",
                    "Agrave",
                    "Aacute",
                    "Acircumflex",
                    "Atilde",
                    "Adieresis",
                    "Aring",
                    "AE",
                    "Ccedilla",
                    "Egrave",
                    "Eacute",
                    "Ecircumflex",
                    "Edieresis",
                    "Igrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Eth",
                    "Ntilde",
                    "Ograve",
                    "Oacute",
                    "Ocircumflex",
                    "Otilde",
                    "Odieresis",
                    "multiply",
                    "Oslash",
                    "Ugrave",
                    "Uacute",
                    "Ucircumflex",
                    "Udieresis",
                    "Yacute",
                    "Thorn",
                    "germandbls",
                    "agrave",
                    "aacute",
                    "acircumflex",
                    "atilde",
                    "adieresis",
                    "aring",
                    "ae",
                    "ccedilla",
                    "egrave",
                    "eacute",
                    "ecircumflex",
                    "edieresis",
                    "igrave",
                    "iacute",
                    "icircumflex",
                    "idieresis",
                    "eth",
                    "ntilde",
                    "ograve",
                    "oacute",
                    "ocircumflex",
                    "otilde",
                    "odieresis",
                    "divide",
                    "oslash",
                    "ugrave",
                    "uacute",
                    "ucircumflex",
                    "udieresis",
                    "yacute",
                    "thorn",
                    "ydieresis"
                ];
                exports.WinAnsiEncoding = WinAnsiEncoding;
                const SymbolSetEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "exclam",
                    "universal",
                    "numbersign",
                    "existential",
                    "percent",
                    "ampersand",
                    "suchthat",
                    "parenleft",
                    "parenright",
                    "asteriskmath",
                    "plus",
                    "comma",
                    "minus",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "congruent",
                    "Alpha",
                    "Beta",
                    "Chi",
                    "Delta",
                    "Epsilon",
                    "Phi",
                    "Gamma",
                    "Eta",
                    "Iota",
                    "theta1",
                    "Kappa",
                    "Lambda",
                    "Mu",
                    "Nu",
                    "Omicron",
                    "Pi",
                    "Theta",
                    "Rho",
                    "Sigma",
                    "Tau",
                    "Upsilon",
                    "sigma1",
                    "Omega",
                    "Xi",
                    "Psi",
                    "Zeta",
                    "bracketleft",
                    "therefore",
                    "bracketright",
                    "perpendicular",
                    "underscore",
                    "radicalex",
                    "alpha",
                    "beta",
                    "chi",
                    "delta",
                    "epsilon",
                    "phi",
                    "gamma",
                    "eta",
                    "iota",
                    "phi1",
                    "kappa",
                    "lambda",
                    "mu",
                    "nu",
                    "omicron",
                    "pi",
                    "theta",
                    "rho",
                    "sigma",
                    "tau",
                    "upsilon",
                    "omega1",
                    "omega",
                    "xi",
                    "psi",
                    "zeta",
                    "braceleft",
                    "bar",
                    "braceright",
                    "similar",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "Euro",
                    "Upsilon1",
                    "minute",
                    "lessequal",
                    "fraction",
                    "infinity",
                    "florin",
                    "club",
                    "diamond",
                    "heart",
                    "spade",
                    "arrowboth",
                    "arrowleft",
                    "arrowup",
                    "arrowright",
                    "arrowdown",
                    "degree",
                    "plusminus",
                    "second",
                    "greaterequal",
                    "multiply",
                    "proportional",
                    "partialdiff",
                    "bullet",
                    "divide",
                    "notequal",
                    "equivalence",
                    "approxequal",
                    "ellipsis",
                    "arrowvertex",
                    "arrowhorizex",
                    "carriagereturn",
                    "aleph",
                    "Ifraktur",
                    "Rfraktur",
                    "weierstrass",
                    "circlemultiply",
                    "circleplus",
                    "emptyset",
                    "intersection",
                    "union",
                    "propersuperset",
                    "reflexsuperset",
                    "notsubset",
                    "propersubset",
                    "reflexsubset",
                    "element",
                    "notelement",
                    "angle",
                    "gradient",
                    "registerserif",
                    "copyrightserif",
                    "trademarkserif",
                    "product",
                    "radical",
                    "dotmath",
                    "logicalnot",
                    "logicaland",
                    "logicalor",
                    "arrowdblboth",
                    "arrowdblleft",
                    "arrowdblup",
                    "arrowdblright",
                    "arrowdbldown",
                    "lozenge",
                    "angleleft",
                    "registersans",
                    "copyrightsans",
                    "trademarksans",
                    "summation",
                    "parenlefttp",
                    "parenleftex",
                    "parenleftbt",
                    "bracketlefttp",
                    "bracketleftex",
                    "bracketleftbt",
                    "bracelefttp",
                    "braceleftmid",
                    "braceleftbt",
                    "braceex",
                    "",
                    "angleright",
                    "integral",
                    "integraltp",
                    "integralex",
                    "integralbt",
                    "parenrighttp",
                    "parenrightex",
                    "parenrightbt",
                    "bracketrighttp",
                    "bracketrightex",
                    "bracketrightbt",
                    "bracerighttp",
                    "bracerightmid",
                    "bracerightbt",
                    ""
                ];
                exports.SymbolSetEncoding = SymbolSetEncoding;
                const ZapfDingbatsEncoding = [
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "space",
                    "a1",
                    "a2",
                    "a202",
                    "a3",
                    "a4",
                    "a5",
                    "a119",
                    "a118",
                    "a117",
                    "a11",
                    "a12",
                    "a13",
                    "a14",
                    "a15",
                    "a16",
                    "a105",
                    "a17",
                    "a18",
                    "a19",
                    "a20",
                    "a21",
                    "a22",
                    "a23",
                    "a24",
                    "a25",
                    "a26",
                    "a27",
                    "a28",
                    "a6",
                    "a7",
                    "a8",
                    "a9",
                    "a10",
                    "a29",
                    "a30",
                    "a31",
                    "a32",
                    "a33",
                    "a34",
                    "a35",
                    "a36",
                    "a37",
                    "a38",
                    "a39",
                    "a40",
                    "a41",
                    "a42",
                    "a43",
                    "a44",
                    "a45",
                    "a46",
                    "a47",
                    "a48",
                    "a49",
                    "a50",
                    "a51",
                    "a52",
                    "a53",
                    "a54",
                    "a55",
                    "a56",
                    "a57",
                    "a58",
                    "a59",
                    "a60",
                    "a61",
                    "a62",
                    "a63",
                    "a64",
                    "a65",
                    "a66",
                    "a67",
                    "a68",
                    "a69",
                    "a70",
                    "a71",
                    "a72",
                    "a73",
                    "a74",
                    "a203",
                    "a75",
                    "a204",
                    "a76",
                    "a77",
                    "a78",
                    "a79",
                    "a81",
                    "a82",
                    "a83",
                    "a84",
                    "a97",
                    "a98",
                    "a99",
                    "a100",
                    "",
                    "a89",
                    "a90",
                    "a93",
                    "a94",
                    "a91",
                    "a92",
                    "a205",
                    "a85",
                    "a206",
                    "a86",
                    "a87",
                    "a88",
                    "a95",
                    "a96",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "",
                    "a101",
                    "a102",
                    "a103",
                    "a104",
                    "a106",
                    "a107",
                    "a108",
                    "a112",
                    "a111",
                    "a110",
                    "a109",
                    "a120",
                    "a121",
                    "a122",
                    "a123",
                    "a124",
                    "a125",
                    "a126",
                    "a127",
                    "a128",
                    "a129",
                    "a130",
                    "a131",
                    "a132",
                    "a133",
                    "a134",
                    "a135",
                    "a136",
                    "a137",
                    "a138",
                    "a139",
                    "a140",
                    "a141",
                    "a142",
                    "a143",
                    "a144",
                    "a145",
                    "a146",
                    "a147",
                    "a148",
                    "a149",
                    "a150",
                    "a151",
                    "a152",
                    "a153",
                    "a154",
                    "a155",
                    "a156",
                    "a157",
                    "a158",
                    "a159",
                    "a160",
                    "a161",
                    "a163",
                    "a164",
                    "a196",
                    "a165",
                    "a192",
                    "a166",
                    "a167",
                    "a168",
                    "a169",
                    "a170",
                    "a171",
                    "a172",
                    "a173",
                    "a162",
                    "a174",
                    "a175",
                    "a176",
                    "a177",
                    "a178",
                    "a179",
                    "a193",
                    "a180",
                    "a199",
                    "a181",
                    "a200",
                    "a182",
                    "",
                    "a201",
                    "a183",
                    "a184",
                    "a197",
                    "a185",
                    "a194",
                    "a198",
                    "a186",
                    "a195",
                    "a187",
                    "a188",
                    "a189",
                    "a190",
                    "a191",
                    ""
                ];
                exports.ZapfDingbatsEncoding = ZapfDingbatsEncoding;
                function getEncoding(encodingName) {
                    switch(encodingName){
                        case "WinAnsiEncoding":
                            return WinAnsiEncoding;
                        case "StandardEncoding":
                            return StandardEncoding;
                        case "MacRomanEncoding":
                            return MacRomanEncoding;
                        case "SymbolSetEncoding":
                            return SymbolSetEncoding;
                        case "ZapfDingbatsEncoding":
                            return ZapfDingbatsEncoding;
                        case "ExpertEncoding":
                            return ExpertEncoding;
                        case "MacExpertEncoding":
                            return MacExpertEncoding;
                        default:
                            return null;
                    }
                }
            /***/ },
            /* 38 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFontType = getFontType;
                exports.normalizeFontName = normalizeFontName;
                exports.recoverGlyphName = recoverGlyphName;
                exports.type1FontGlyphMapping = type1FontGlyphMapping;
                exports.SEAC_ANALYSIS_ENABLED = exports.MacStandardGlyphOrdering = exports.FontFlags = void 0;
                var _util = __w_pdfjs_require__(2);
                var _encodings = __w_pdfjs_require__(37);
                var _glyphlist = __w_pdfjs_require__(39);
                var _unicode = __w_pdfjs_require__(40);
                const SEAC_ANALYSIS_ENABLED = true;
                exports.SEAC_ANALYSIS_ENABLED = SEAC_ANALYSIS_ENABLED;
                const FontFlags = {
                    FixedPitch: 1,
                    Serif: 2,
                    Symbolic: 4,
                    Script: 8,
                    Nonsymbolic: 32,
                    Italic: 64,
                    AllCap: 65536,
                    SmallCap: 131072,
                    ForceBold: 262144
                };
                exports.FontFlags = FontFlags;
                const MacStandardGlyphOrdering = [
                    ".notdef",
                    ".null",
                    "nonmarkingreturn",
                    "space",
                    "exclam",
                    "quotedbl",
                    "numbersign",
                    "dollar",
                    "percent",
                    "ampersand",
                    "quotesingle",
                    "parenleft",
                    "parenright",
                    "asterisk",
                    "plus",
                    "comma",
                    "hyphen",
                    "period",
                    "slash",
                    "zero",
                    "one",
                    "two",
                    "three",
                    "four",
                    "five",
                    "six",
                    "seven",
                    "eight",
                    "nine",
                    "colon",
                    "semicolon",
                    "less",
                    "equal",
                    "greater",
                    "question",
                    "at",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z",
                    "bracketleft",
                    "backslash",
                    "bracketright",
                    "asciicircum",
                    "underscore",
                    "grave",
                    "a",
                    "b",
                    "c",
                    "d",
                    "e",
                    "f",
                    "g",
                    "h",
                    "i",
                    "j",
                    "k",
                    "l",
                    "m",
                    "n",
                    "o",
                    "p",
                    "q",
                    "r",
                    "s",
                    "t",
                    "u",
                    "v",
                    "w",
                    "x",
                    "y",
                    "z",
                    "braceleft",
                    "bar",
                    "braceright",
                    "asciitilde",
                    "Adieresis",
                    "Aring",
                    "Ccedilla",
                    "Eacute",
                    "Ntilde",
                    "Odieresis",
                    "Udieresis",
                    "aacute",
                    "agrave",
                    "acircumflex",
                    "adieresis",
                    "atilde",
                    "aring",
                    "ccedilla",
                    "eacute",
                    "egrave",
                    "ecircumflex",
                    "edieresis",
                    "iacute",
                    "igrave",
                    "icircumflex",
                    "idieresis",
                    "ntilde",
                    "oacute",
                    "ograve",
                    "ocircumflex",
                    "odieresis",
                    "otilde",
                    "uacute",
                    "ugrave",
                    "ucircumflex",
                    "udieresis",
                    "dagger",
                    "degree",
                    "cent",
                    "sterling",
                    "section",
                    "bullet",
                    "paragraph",
                    "germandbls",
                    "registered",
                    "copyright",
                    "trademark",
                    "acute",
                    "dieresis",
                    "notequal",
                    "AE",
                    "Oslash",
                    "infinity",
                    "plusminus",
                    "lessequal",
                    "greaterequal",
                    "yen",
                    "mu",
                    "partialdiff",
                    "summation",
                    "product",
                    "pi",
                    "integral",
                    "ordfeminine",
                    "ordmasculine",
                    "Omega",
                    "ae",
                    "oslash",
                    "questiondown",
                    "exclamdown",
                    "logicalnot",
                    "radical",
                    "florin",
                    "approxequal",
                    "Delta",
                    "guillemotleft",
                    "guillemotright",
                    "ellipsis",
                    "nonbreakingspace",
                    "Agrave",
                    "Atilde",
                    "Otilde",
                    "OE",
                    "oe",
                    "endash",
                    "emdash",
                    "quotedblleft",
                    "quotedblright",
                    "quoteleft",
                    "quoteright",
                    "divide",
                    "lozenge",
                    "ydieresis",
                    "Ydieresis",
                    "fraction",
                    "currency",
                    "guilsinglleft",
                    "guilsinglright",
                    "fi",
                    "fl",
                    "daggerdbl",
                    "periodcentered",
                    "quotesinglbase",
                    "quotedblbase",
                    "perthousand",
                    "Acircumflex",
                    "Ecircumflex",
                    "Aacute",
                    "Edieresis",
                    "Egrave",
                    "Iacute",
                    "Icircumflex",
                    "Idieresis",
                    "Igrave",
                    "Oacute",
                    "Ocircumflex",
                    "apple",
                    "Ograve",
                    "Uacute",
                    "Ucircumflex",
                    "Ugrave",
                    "dotlessi",
                    "circumflex",
                    "tilde",
                    "macron",
                    "breve",
                    "dotaccent",
                    "ring",
                    "cedilla",
                    "hungarumlaut",
                    "ogonek",
                    "caron",
                    "Lslash",
                    "lslash",
                    "Scaron",
                    "scaron",
                    "Zcaron",
                    "zcaron",
                    "brokenbar",
                    "Eth",
                    "eth",
                    "Yacute",
                    "yacute",
                    "Thorn",
                    "thorn",
                    "minus",
                    "multiply",
                    "onesuperior",
                    "twosuperior",
                    "threesuperior",
                    "onehalf",
                    "onequarter",
                    "threequarters",
                    "franc",
                    "Gbreve",
                    "gbreve",
                    "Idotaccent",
                    "Scedilla",
                    "scedilla",
                    "Cacute",
                    "cacute",
                    "Ccaron",
                    "ccaron",
                    "dcroat"
                ];
                exports.MacStandardGlyphOrdering = MacStandardGlyphOrdering;
                function getFontType(type, subtype, isStandardFont = false) {
                    switch(type){
                        case "Type1":
                            if (isStandardFont) return _util.FontType.TYPE1STANDARD;
                            return subtype === "Type1C" ? _util.FontType.TYPE1C : _util.FontType.TYPE1;
                        case "CIDFontType0":
                            return subtype === "CIDFontType0C" ? _util.FontType.CIDFONTTYPE0C : _util.FontType.CIDFONTTYPE0;
                        case "OpenType":
                            return _util.FontType.OPENTYPE;
                        case "TrueType":
                            return _util.FontType.TRUETYPE;
                        case "CIDFontType2":
                            return _util.FontType.CIDFONTTYPE2;
                        case "MMType1":
                            return _util.FontType.MMTYPE1;
                        case "Type0":
                            return _util.FontType.TYPE0;
                        default:
                            return _util.FontType.UNKNOWN;
                    }
                }
                function recoverGlyphName(name, glyphsUnicodeMap) {
                    if (glyphsUnicodeMap[name] !== undefined) return name;
                    const unicode = (0, _unicode.getUnicodeForGlyph)(name, glyphsUnicodeMap);
                    if (unicode !== -1) for(const key in glyphsUnicodeMap){
                        if (glyphsUnicodeMap[key] === unicode) return key;
                    }
                    (0, _util.info)("Unable to recover a standard glyph name for: " + name);
                    return name;
                }
                function type1FontGlyphMapping(properties, builtInEncoding, glyphNames) {
                    const charCodeToGlyphId = Object.create(null);
                    let glyphId, charCode, baseEncoding;
                    const isSymbolicFont = !!(properties.flags & FontFlags.Symbolic);
                    if (properties.isInternalFont) {
                        baseEncoding = builtInEncoding;
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            if (glyphId >= 0) charCodeToGlyphId[charCode] = glyphId;
                            else charCodeToGlyphId[charCode] = 0;
                        }
                    } else if (properties.baseEncodingName) {
                        baseEncoding = (0, _encodings.getEncoding)(properties.baseEncodingName);
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            if (glyphId >= 0) charCodeToGlyphId[charCode] = glyphId;
                            else charCodeToGlyphId[charCode] = 0;
                        }
                    } else if (isSymbolicFont) for(charCode in builtInEncoding)charCodeToGlyphId[charCode] = builtInEncoding[charCode];
                    else {
                        baseEncoding = _encodings.StandardEncoding;
                        for(charCode = 0; charCode < baseEncoding.length; charCode++){
                            glyphId = glyphNames.indexOf(baseEncoding[charCode]);
                            if (glyphId >= 0) charCodeToGlyphId[charCode] = glyphId;
                            else charCodeToGlyphId[charCode] = 0;
                        }
                    }
                    const differences = properties.differences;
                    let glyphsUnicodeMap;
                    if (differences) for(charCode in differences){
                        const glyphName = differences[charCode];
                        glyphId = glyphNames.indexOf(glyphName);
                        if (glyphId === -1) {
                            if (!glyphsUnicodeMap) glyphsUnicodeMap = (0, _glyphlist.getGlyphsUnicode)();
                            const standardGlyphName = recoverGlyphName(glyphName, glyphsUnicodeMap);
                            if (standardGlyphName !== glyphName) glyphId = glyphNames.indexOf(standardGlyphName);
                        }
                        if (glyphId >= 0) charCodeToGlyphId[charCode] = glyphId;
                        else charCodeToGlyphId[charCode] = 0;
                    }
                    return charCodeToGlyphId;
                }
                function normalizeFontName(name) {
                    return name.replace(/[,_]/g, "-").replace(/\s/g, "");
                }
            /***/ },
            /* 39 */ /***/ (__unused_webpack_module, __webpack_exports__, __w_pdfjs_require__)=>{
                __w_pdfjs_require__.r(__webpack_exports__);
                /* harmony export */ __w_pdfjs_require__.d(__webpack_exports__, {
                    /* harmony export */ "getDingbatsGlyphsUnicode": ()=>/* binding */ getDingbatsGlyphsUnicode,
                    /* harmony export */ "getGlyphsUnicode": ()=>/* binding */ getGlyphsUnicode
                });
                /* harmony import */ var _core_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __w_pdfjs_require__(9);
                const getGlyphsUnicode = (0, _core_utils_js__WEBPACK_IMPORTED_MODULE_0__.getArrayLookupTableFactory)(function() {
                    return [
                        "A",
                        0x0041,
                        "AE",
                        0x00c6,
                        "AEacute",
                        0x01fc,
                        "AEmacron",
                        0x01e2,
                        "AEsmall",
                        0xf7e6,
                        "Aacute",
                        0x00c1,
                        "Aacutesmall",
                        0xf7e1,
                        "Abreve",
                        0x0102,
                        "Abreveacute",
                        0x1eae,
                        "Abrevecyrillic",
                        0x04d0,
                        "Abrevedotbelow",
                        0x1eb6,
                        "Abrevegrave",
                        0x1eb0,
                        "Abrevehookabove",
                        0x1eb2,
                        "Abrevetilde",
                        0x1eb4,
                        "Acaron",
                        0x01cd,
                        "Acircle",
                        0x24b6,
                        "Acircumflex",
                        0x00c2,
                        "Acircumflexacute",
                        0x1ea4,
                        "Acircumflexdotbelow",
                        0x1eac,
                        "Acircumflexgrave",
                        0x1ea6,
                        "Acircumflexhookabove",
                        0x1ea8,
                        "Acircumflexsmall",
                        0xf7e2,
                        "Acircumflextilde",
                        0x1eaa,
                        "Acute",
                        0xf6c9,
                        "Acutesmall",
                        0xf7b4,
                        "Acyrillic",
                        0x0410,
                        "Adblgrave",
                        0x0200,
                        "Adieresis",
                        0x00c4,
                        "Adieresiscyrillic",
                        0x04d2,
                        "Adieresismacron",
                        0x01de,
                        "Adieresissmall",
                        0xf7e4,
                        "Adotbelow",
                        0x1ea0,
                        "Adotmacron",
                        0x01e0,
                        "Agrave",
                        0x00c0,
                        "Agravesmall",
                        0xf7e0,
                        "Ahookabove",
                        0x1ea2,
                        "Aiecyrillic",
                        0x04d4,
                        "Ainvertedbreve",
                        0x0202,
                        "Alpha",
                        0x0391,
                        "Alphatonos",
                        0x0386,
                        "Amacron",
                        0x0100,
                        "Amonospace",
                        0xff21,
                        "Aogonek",
                        0x0104,
                        "Aring",
                        0x00c5,
                        "Aringacute",
                        0x01fa,
                        "Aringbelow",
                        0x1e00,
                        "Aringsmall",
                        0xf7e5,
                        "Asmall",
                        0xf761,
                        "Atilde",
                        0x00c3,
                        "Atildesmall",
                        0xf7e3,
                        "Aybarmenian",
                        0x0531,
                        "B",
                        0x0042,
                        "Bcircle",
                        0x24b7,
                        "Bdotaccent",
                        0x1e02,
                        "Bdotbelow",
                        0x1e04,
                        "Becyrillic",
                        0x0411,
                        "Benarmenian",
                        0x0532,
                        "Beta",
                        0x0392,
                        "Bhook",
                        0x0181,
                        "Blinebelow",
                        0x1e06,
                        "Bmonospace",
                        0xff22,
                        "Brevesmall",
                        0xf6f4,
                        "Bsmall",
                        0xf762,
                        "Btopbar",
                        0x0182,
                        "C",
                        0x0043,
                        "Caarmenian",
                        0x053e,
                        "Cacute",
                        0x0106,
                        "Caron",
                        0xf6ca,
                        "Caronsmall",
                        0xf6f5,
                        "Ccaron",
                        0x010c,
                        "Ccedilla",
                        0x00c7,
                        "Ccedillaacute",
                        0x1e08,
                        "Ccedillasmall",
                        0xf7e7,
                        "Ccircle",
                        0x24b8,
                        "Ccircumflex",
                        0x0108,
                        "Cdot",
                        0x010a,
                        "Cdotaccent",
                        0x010a,
                        "Cedillasmall",
                        0xf7b8,
                        "Chaarmenian",
                        0x0549,
                        "Cheabkhasiancyrillic",
                        0x04bc,
                        "Checyrillic",
                        0x0427,
                        "Chedescenderabkhasiancyrillic",
                        0x04be,
                        "Chedescendercyrillic",
                        0x04b6,
                        "Chedieresiscyrillic",
                        0x04f4,
                        "Cheharmenian",
                        0x0543,
                        "Chekhakassiancyrillic",
                        0x04cb,
                        "Cheverticalstrokecyrillic",
                        0x04b8,
                        "Chi",
                        0x03a7,
                        "Chook",
                        0x0187,
                        "Circumflexsmall",
                        0xf6f6,
                        "Cmonospace",
                        0xff23,
                        "Coarmenian",
                        0x0551,
                        "Csmall",
                        0xf763,
                        "D",
                        0x0044,
                        "DZ",
                        0x01f1,
                        "DZcaron",
                        0x01c4,
                        "Daarmenian",
                        0x0534,
                        "Dafrican",
                        0x0189,
                        "Dcaron",
                        0x010e,
                        "Dcedilla",
                        0x1e10,
                        "Dcircle",
                        0x24b9,
                        "Dcircumflexbelow",
                        0x1e12,
                        "Dcroat",
                        0x0110,
                        "Ddotaccent",
                        0x1e0a,
                        "Ddotbelow",
                        0x1e0c,
                        "Decyrillic",
                        0x0414,
                        "Deicoptic",
                        0x03ee,
                        "Delta",
                        0x2206,
                        "Deltagreek",
                        0x0394,
                        "Dhook",
                        0x018a,
                        "Dieresis",
                        0xf6cb,
                        "DieresisAcute",
                        0xf6cc,
                        "DieresisGrave",
                        0xf6cd,
                        "Dieresissmall",
                        0xf7a8,
                        "Digammagreek",
                        0x03dc,
                        "Djecyrillic",
                        0x0402,
                        "Dlinebelow",
                        0x1e0e,
                        "Dmonospace",
                        0xff24,
                        "Dotaccentsmall",
                        0xf6f7,
                        "Dslash",
                        0x0110,
                        "Dsmall",
                        0xf764,
                        "Dtopbar",
                        0x018b,
                        "Dz",
                        0x01f2,
                        "Dzcaron",
                        0x01c5,
                        "Dzeabkhasiancyrillic",
                        0x04e0,
                        "Dzecyrillic",
                        0x0405,
                        "Dzhecyrillic",
                        0x040f,
                        "E",
                        0x0045,
                        "Eacute",
                        0x00c9,
                        "Eacutesmall",
                        0xf7e9,
                        "Ebreve",
                        0x0114,
                        "Ecaron",
                        0x011a,
                        "Ecedillabreve",
                        0x1e1c,
                        "Echarmenian",
                        0x0535,
                        "Ecircle",
                        0x24ba,
                        "Ecircumflex",
                        0x00ca,
                        "Ecircumflexacute",
                        0x1ebe,
                        "Ecircumflexbelow",
                        0x1e18,
                        "Ecircumflexdotbelow",
                        0x1ec6,
                        "Ecircumflexgrave",
                        0x1ec0,
                        "Ecircumflexhookabove",
                        0x1ec2,
                        "Ecircumflexsmall",
                        0xf7ea,
                        "Ecircumflextilde",
                        0x1ec4,
                        "Ecyrillic",
                        0x0404,
                        "Edblgrave",
                        0x0204,
                        "Edieresis",
                        0x00cb,
                        "Edieresissmall",
                        0xf7eb,
                        "Edot",
                        0x0116,
                        "Edotaccent",
                        0x0116,
                        "Edotbelow",
                        0x1eb8,
                        "Efcyrillic",
                        0x0424,
                        "Egrave",
                        0x00c8,
                        "Egravesmall",
                        0xf7e8,
                        "Eharmenian",
                        0x0537,
                        "Ehookabove",
                        0x1eba,
                        "Eightroman",
                        0x2167,
                        "Einvertedbreve",
                        0x0206,
                        "Eiotifiedcyrillic",
                        0x0464,
                        "Elcyrillic",
                        0x041b,
                        "Elevenroman",
                        0x216a,
                        "Emacron",
                        0x0112,
                        "Emacronacute",
                        0x1e16,
                        "Emacrongrave",
                        0x1e14,
                        "Emcyrillic",
                        0x041c,
                        "Emonospace",
                        0xff25,
                        "Encyrillic",
                        0x041d,
                        "Endescendercyrillic",
                        0x04a2,
                        "Eng",
                        0x014a,
                        "Enghecyrillic",
                        0x04a4,
                        "Enhookcyrillic",
                        0x04c7,
                        "Eogonek",
                        0x0118,
                        "Eopen",
                        0x0190,
                        "Epsilon",
                        0x0395,
                        "Epsilontonos",
                        0x0388,
                        "Ercyrillic",
                        0x0420,
                        "Ereversed",
                        0x018e,
                        "Ereversedcyrillic",
                        0x042d,
                        "Escyrillic",
                        0x0421,
                        "Esdescendercyrillic",
                        0x04aa,
                        "Esh",
                        0x01a9,
                        "Esmall",
                        0xf765,
                        "Eta",
                        0x0397,
                        "Etarmenian",
                        0x0538,
                        "Etatonos",
                        0x0389,
                        "Eth",
                        0x00d0,
                        "Ethsmall",
                        0xf7f0,
                        "Etilde",
                        0x1ebc,
                        "Etildebelow",
                        0x1e1a,
                        "Euro",
                        0x20ac,
                        "Ezh",
                        0x01b7,
                        "Ezhcaron",
                        0x01ee,
                        "Ezhreversed",
                        0x01b8,
                        "F",
                        0x0046,
                        "Fcircle",
                        0x24bb,
                        "Fdotaccent",
                        0x1e1e,
                        "Feharmenian",
                        0x0556,
                        "Feicoptic",
                        0x03e4,
                        "Fhook",
                        0x0191,
                        "Fitacyrillic",
                        0x0472,
                        "Fiveroman",
                        0x2164,
                        "Fmonospace",
                        0xff26,
                        "Fourroman",
                        0x2163,
                        "Fsmall",
                        0xf766,
                        "G",
                        0x0047,
                        "GBsquare",
                        0x3387,
                        "Gacute",
                        0x01f4,
                        "Gamma",
                        0x0393,
                        "Gammaafrican",
                        0x0194,
                        "Gangiacoptic",
                        0x03ea,
                        "Gbreve",
                        0x011e,
                        "Gcaron",
                        0x01e6,
                        "Gcedilla",
                        0x0122,
                        "Gcircle",
                        0x24bc,
                        "Gcircumflex",
                        0x011c,
                        "Gcommaaccent",
                        0x0122,
                        "Gdot",
                        0x0120,
                        "Gdotaccent",
                        0x0120,
                        "Gecyrillic",
                        0x0413,
                        "Ghadarmenian",
                        0x0542,
                        "Ghemiddlehookcyrillic",
                        0x0494,
                        "Ghestrokecyrillic",
                        0x0492,
                        "Gheupturncyrillic",
                        0x0490,
                        "Ghook",
                        0x0193,
                        "Gimarmenian",
                        0x0533,
                        "Gjecyrillic",
                        0x0403,
                        "Gmacron",
                        0x1e20,
                        "Gmonospace",
                        0xff27,
                        "Grave",
                        0xf6ce,
                        "Gravesmall",
                        0xf760,
                        "Gsmall",
                        0xf767,
                        "Gsmallhook",
                        0x029b,
                        "Gstroke",
                        0x01e4,
                        "H",
                        0x0048,
                        "H18533",
                        0x25cf,
                        "H18543",
                        0x25aa,
                        "H18551",
                        0x25ab,
                        "H22073",
                        0x25a1,
                        "HPsquare",
                        0x33cb,
                        "Haabkhasiancyrillic",
                        0x04a8,
                        "Hadescendercyrillic",
                        0x04b2,
                        "Hardsigncyrillic",
                        0x042a,
                        "Hbar",
                        0x0126,
                        "Hbrevebelow",
                        0x1e2a,
                        "Hcedilla",
                        0x1e28,
                        "Hcircle",
                        0x24bd,
                        "Hcircumflex",
                        0x0124,
                        "Hdieresis",
                        0x1e26,
                        "Hdotaccent",
                        0x1e22,
                        "Hdotbelow",
                        0x1e24,
                        "Hmonospace",
                        0xff28,
                        "Hoarmenian",
                        0x0540,
                        "Horicoptic",
                        0x03e8,
                        "Hsmall",
                        0xf768,
                        "Hungarumlaut",
                        0xf6cf,
                        "Hungarumlautsmall",
                        0xf6f8,
                        "Hzsquare",
                        0x3390,
                        "I",
                        0x0049,
                        "IAcyrillic",
                        0x042f,
                        "IJ",
                        0x0132,
                        "IUcyrillic",
                        0x042e,
                        "Iacute",
                        0x00cd,
                        "Iacutesmall",
                        0xf7ed,
                        "Ibreve",
                        0x012c,
                        "Icaron",
                        0x01cf,
                        "Icircle",
                        0x24be,
                        "Icircumflex",
                        0x00ce,
                        "Icircumflexsmall",
                        0xf7ee,
                        "Icyrillic",
                        0x0406,
                        "Idblgrave",
                        0x0208,
                        "Idieresis",
                        0x00cf,
                        "Idieresisacute",
                        0x1e2e,
                        "Idieresiscyrillic",
                        0x04e4,
                        "Idieresissmall",
                        0xf7ef,
                        "Idot",
                        0x0130,
                        "Idotaccent",
                        0x0130,
                        "Idotbelow",
                        0x1eca,
                        "Iebrevecyrillic",
                        0x04d6,
                        "Iecyrillic",
                        0x0415,
                        "Ifraktur",
                        0x2111,
                        "Igrave",
                        0x00cc,
                        "Igravesmall",
                        0xf7ec,
                        "Ihookabove",
                        0x1ec8,
                        "Iicyrillic",
                        0x0418,
                        "Iinvertedbreve",
                        0x020a,
                        "Iishortcyrillic",
                        0x0419,
                        "Imacron",
                        0x012a,
                        "Imacroncyrillic",
                        0x04e2,
                        "Imonospace",
                        0xff29,
                        "Iniarmenian",
                        0x053b,
                        "Iocyrillic",
                        0x0401,
                        "Iogonek",
                        0x012e,
                        "Iota",
                        0x0399,
                        "Iotaafrican",
                        0x0196,
                        "Iotadieresis",
                        0x03aa,
                        "Iotatonos",
                        0x038a,
                        "Ismall",
                        0xf769,
                        "Istroke",
                        0x0197,
                        "Itilde",
                        0x0128,
                        "Itildebelow",
                        0x1e2c,
                        "Izhitsacyrillic",
                        0x0474,
                        "Izhitsadblgravecyrillic",
                        0x0476,
                        "J",
                        0x004a,
                        "Jaarmenian",
                        0x0541,
                        "Jcircle",
                        0x24bf,
                        "Jcircumflex",
                        0x0134,
                        "Jecyrillic",
                        0x0408,
                        "Jheharmenian",
                        0x054b,
                        "Jmonospace",
                        0xff2a,
                        "Jsmall",
                        0xf76a,
                        "K",
                        0x004b,
                        "KBsquare",
                        0x3385,
                        "KKsquare",
                        0x33cd,
                        "Kabashkircyrillic",
                        0x04a0,
                        "Kacute",
                        0x1e30,
                        "Kacyrillic",
                        0x041a,
                        "Kadescendercyrillic",
                        0x049a,
                        "Kahookcyrillic",
                        0x04c3,
                        "Kappa",
                        0x039a,
                        "Kastrokecyrillic",
                        0x049e,
                        "Kaverticalstrokecyrillic",
                        0x049c,
                        "Kcaron",
                        0x01e8,
                        "Kcedilla",
                        0x0136,
                        "Kcircle",
                        0x24c0,
                        "Kcommaaccent",
                        0x0136,
                        "Kdotbelow",
                        0x1e32,
                        "Keharmenian",
                        0x0554,
                        "Kenarmenian",
                        0x053f,
                        "Khacyrillic",
                        0x0425,
                        "Kheicoptic",
                        0x03e6,
                        "Khook",
                        0x0198,
                        "Kjecyrillic",
                        0x040c,
                        "Klinebelow",
                        0x1e34,
                        "Kmonospace",
                        0xff2b,
                        "Koppacyrillic",
                        0x0480,
                        "Koppagreek",
                        0x03de,
                        "Ksicyrillic",
                        0x046e,
                        "Ksmall",
                        0xf76b,
                        "L",
                        0x004c,
                        "LJ",
                        0x01c7,
                        "LL",
                        0xf6bf,
                        "Lacute",
                        0x0139,
                        "Lambda",
                        0x039b,
                        "Lcaron",
                        0x013d,
                        "Lcedilla",
                        0x013b,
                        "Lcircle",
                        0x24c1,
                        "Lcircumflexbelow",
                        0x1e3c,
                        "Lcommaaccent",
                        0x013b,
                        "Ldot",
                        0x013f,
                        "Ldotaccent",
                        0x013f,
                        "Ldotbelow",
                        0x1e36,
                        "Ldotbelowmacron",
                        0x1e38,
                        "Liwnarmenian",
                        0x053c,
                        "Lj",
                        0x01c8,
                        "Ljecyrillic",
                        0x0409,
                        "Llinebelow",
                        0x1e3a,
                        "Lmonospace",
                        0xff2c,
                        "Lslash",
                        0x0141,
                        "Lslashsmall",
                        0xf6f9,
                        "Lsmall",
                        0xf76c,
                        "M",
                        0x004d,
                        "MBsquare",
                        0x3386,
                        "Macron",
                        0xf6d0,
                        "Macronsmall",
                        0xf7af,
                        "Macute",
                        0x1e3e,
                        "Mcircle",
                        0x24c2,
                        "Mdotaccent",
                        0x1e40,
                        "Mdotbelow",
                        0x1e42,
                        "Menarmenian",
                        0x0544,
                        "Mmonospace",
                        0xff2d,
                        "Msmall",
                        0xf76d,
                        "Mturned",
                        0x019c,
                        "Mu",
                        0x039c,
                        "N",
                        0x004e,
                        "NJ",
                        0x01ca,
                        "Nacute",
                        0x0143,
                        "Ncaron",
                        0x0147,
                        "Ncedilla",
                        0x0145,
                        "Ncircle",
                        0x24c3,
                        "Ncircumflexbelow",
                        0x1e4a,
                        "Ncommaaccent",
                        0x0145,
                        "Ndotaccent",
                        0x1e44,
                        "Ndotbelow",
                        0x1e46,
                        "Nhookleft",
                        0x019d,
                        "Nineroman",
                        0x2168,
                        "Nj",
                        0x01cb,
                        "Njecyrillic",
                        0x040a,
                        "Nlinebelow",
                        0x1e48,
                        "Nmonospace",
                        0xff2e,
                        "Nowarmenian",
                        0x0546,
                        "Nsmall",
                        0xf76e,
                        "Ntilde",
                        0x00d1,
                        "Ntildesmall",
                        0xf7f1,
                        "Nu",
                        0x039d,
                        "O",
                        0x004f,
                        "OE",
                        0x0152,
                        "OEsmall",
                        0xf6fa,
                        "Oacute",
                        0x00d3,
                        "Oacutesmall",
                        0xf7f3,
                        "Obarredcyrillic",
                        0x04e8,
                        "Obarreddieresiscyrillic",
                        0x04ea,
                        "Obreve",
                        0x014e,
                        "Ocaron",
                        0x01d1,
                        "Ocenteredtilde",
                        0x019f,
                        "Ocircle",
                        0x24c4,
                        "Ocircumflex",
                        0x00d4,
                        "Ocircumflexacute",
                        0x1ed0,
                        "Ocircumflexdotbelow",
                        0x1ed8,
                        "Ocircumflexgrave",
                        0x1ed2,
                        "Ocircumflexhookabove",
                        0x1ed4,
                        "Ocircumflexsmall",
                        0xf7f4,
                        "Ocircumflextilde",
                        0x1ed6,
                        "Ocyrillic",
                        0x041e,
                        "Odblacute",
                        0x0150,
                        "Odblgrave",
                        0x020c,
                        "Odieresis",
                        0x00d6,
                        "Odieresiscyrillic",
                        0x04e6,
                        "Odieresissmall",
                        0xf7f6,
                        "Odotbelow",
                        0x1ecc,
                        "Ogoneksmall",
                        0xf6fb,
                        "Ograve",
                        0x00d2,
                        "Ogravesmall",
                        0xf7f2,
                        "Oharmenian",
                        0x0555,
                        "Ohm",
                        0x2126,
                        "Ohookabove",
                        0x1ece,
                        "Ohorn",
                        0x01a0,
                        "Ohornacute",
                        0x1eda,
                        "Ohorndotbelow",
                        0x1ee2,
                        "Ohorngrave",
                        0x1edc,
                        "Ohornhookabove",
                        0x1ede,
                        "Ohorntilde",
                        0x1ee0,
                        "Ohungarumlaut",
                        0x0150,
                        "Oi",
                        0x01a2,
                        "Oinvertedbreve",
                        0x020e,
                        "Omacron",
                        0x014c,
                        "Omacronacute",
                        0x1e52,
                        "Omacrongrave",
                        0x1e50,
                        "Omega",
                        0x2126,
                        "Omegacyrillic",
                        0x0460,
                        "Omegagreek",
                        0x03a9,
                        "Omegaroundcyrillic",
                        0x047a,
                        "Omegatitlocyrillic",
                        0x047c,
                        "Omegatonos",
                        0x038f,
                        "Omicron",
                        0x039f,
                        "Omicrontonos",
                        0x038c,
                        "Omonospace",
                        0xff2f,
                        "Oneroman",
                        0x2160,
                        "Oogonek",
                        0x01ea,
                        "Oogonekmacron",
                        0x01ec,
                        "Oopen",
                        0x0186,
                        "Oslash",
                        0x00d8,
                        "Oslashacute",
                        0x01fe,
                        "Oslashsmall",
                        0xf7f8,
                        "Osmall",
                        0xf76f,
                        "Ostrokeacute",
                        0x01fe,
                        "Otcyrillic",
                        0x047e,
                        "Otilde",
                        0x00d5,
                        "Otildeacute",
                        0x1e4c,
                        "Otildedieresis",
                        0x1e4e,
                        "Otildesmall",
                        0xf7f5,
                        "P",
                        0x0050,
                        "Pacute",
                        0x1e54,
                        "Pcircle",
                        0x24c5,
                        "Pdotaccent",
                        0x1e56,
                        "Pecyrillic",
                        0x041f,
                        "Peharmenian",
                        0x054a,
                        "Pemiddlehookcyrillic",
                        0x04a6,
                        "Phi",
                        0x03a6,
                        "Phook",
                        0x01a4,
                        "Pi",
                        0x03a0,
                        "Piwrarmenian",
                        0x0553,
                        "Pmonospace",
                        0xff30,
                        "Psi",
                        0x03a8,
                        "Psicyrillic",
                        0x0470,
                        "Psmall",
                        0xf770,
                        "Q",
                        0x0051,
                        "Qcircle",
                        0x24c6,
                        "Qmonospace",
                        0xff31,
                        "Qsmall",
                        0xf771,
                        "R",
                        0x0052,
                        "Raarmenian",
                        0x054c,
                        "Racute",
                        0x0154,
                        "Rcaron",
                        0x0158,
                        "Rcedilla",
                        0x0156,
                        "Rcircle",
                        0x24c7,
                        "Rcommaaccent",
                        0x0156,
                        "Rdblgrave",
                        0x0210,
                        "Rdotaccent",
                        0x1e58,
                        "Rdotbelow",
                        0x1e5a,
                        "Rdotbelowmacron",
                        0x1e5c,
                        "Reharmenian",
                        0x0550,
                        "Rfraktur",
                        0x211c,
                        "Rho",
                        0x03a1,
                        "Ringsmall",
                        0xf6fc,
                        "Rinvertedbreve",
                        0x0212,
                        "Rlinebelow",
                        0x1e5e,
                        "Rmonospace",
                        0xff32,
                        "Rsmall",
                        0xf772,
                        "Rsmallinverted",
                        0x0281,
                        "Rsmallinvertedsuperior",
                        0x02b6,
                        "S",
                        0x0053,
                        "SF010000",
                        0x250c,
                        "SF020000",
                        0x2514,
                        "SF030000",
                        0x2510,
                        "SF040000",
                        0x2518,
                        "SF050000",
                        0x253c,
                        "SF060000",
                        0x252c,
                        "SF070000",
                        0x2534,
                        "SF080000",
                        0x251c,
                        "SF090000",
                        0x2524,
                        "SF100000",
                        0x2500,
                        "SF110000",
                        0x2502,
                        "SF190000",
                        0x2561,
                        "SF200000",
                        0x2562,
                        "SF210000",
                        0x2556,
                        "SF220000",
                        0x2555,
                        "SF230000",
                        0x2563,
                        "SF240000",
                        0x2551,
                        "SF250000",
                        0x2557,
                        "SF260000",
                        0x255d,
                        "SF270000",
                        0x255c,
                        "SF280000",
                        0x255b,
                        "SF360000",
                        0x255e,
                        "SF370000",
                        0x255f,
                        "SF380000",
                        0x255a,
                        "SF390000",
                        0x2554,
                        "SF400000",
                        0x2569,
                        "SF410000",
                        0x2566,
                        "SF420000",
                        0x2560,
                        "SF430000",
                        0x2550,
                        "SF440000",
                        0x256c,
                        "SF450000",
                        0x2567,
                        "SF460000",
                        0x2568,
                        "SF470000",
                        0x2564,
                        "SF480000",
                        0x2565,
                        "SF490000",
                        0x2559,
                        "SF500000",
                        0x2558,
                        "SF510000",
                        0x2552,
                        "SF520000",
                        0x2553,
                        "SF530000",
                        0x256b,
                        "SF540000",
                        0x256a,
                        "Sacute",
                        0x015a,
                        "Sacutedotaccent",
                        0x1e64,
                        "Sampigreek",
                        0x03e0,
                        "Scaron",
                        0x0160,
                        "Scarondotaccent",
                        0x1e66,
                        "Scaronsmall",
                        0xf6fd,
                        "Scedilla",
                        0x015e,
                        "Schwa",
                        0x018f,
                        "Schwacyrillic",
                        0x04d8,
                        "Schwadieresiscyrillic",
                        0x04da,
                        "Scircle",
                        0x24c8,
                        "Scircumflex",
                        0x015c,
                        "Scommaaccent",
                        0x0218,
                        "Sdotaccent",
                        0x1e60,
                        "Sdotbelow",
                        0x1e62,
                        "Sdotbelowdotaccent",
                        0x1e68,
                        "Seharmenian",
                        0x054d,
                        "Sevenroman",
                        0x2166,
                        "Shaarmenian",
                        0x0547,
                        "Shacyrillic",
                        0x0428,
                        "Shchacyrillic",
                        0x0429,
                        "Sheicoptic",
                        0x03e2,
                        "Shhacyrillic",
                        0x04ba,
                        "Shimacoptic",
                        0x03ec,
                        "Sigma",
                        0x03a3,
                        "Sixroman",
                        0x2165,
                        "Smonospace",
                        0xff33,
                        "Softsigncyrillic",
                        0x042c,
                        "Ssmall",
                        0xf773,
                        "Stigmagreek",
                        0x03da,
                        "T",
                        0x0054,
                        "Tau",
                        0x03a4,
                        "Tbar",
                        0x0166,
                        "Tcaron",
                        0x0164,
                        "Tcedilla",
                        0x0162,
                        "Tcircle",
                        0x24c9,
                        "Tcircumflexbelow",
                        0x1e70,
                        "Tcommaaccent",
                        0x0162,
                        "Tdotaccent",
                        0x1e6a,
                        "Tdotbelow",
                        0x1e6c,
                        "Tecyrillic",
                        0x0422,
                        "Tedescendercyrillic",
                        0x04ac,
                        "Tenroman",
                        0x2169,
                        "Tetsecyrillic",
                        0x04b4,
                        "Theta",
                        0x0398,
                        "Thook",
                        0x01ac,
                        "Thorn",
                        0x00de,
                        "Thornsmall",
                        0xf7fe,
                        "Threeroman",
                        0x2162,
                        "Tildesmall",
                        0xf6fe,
                        "Tiwnarmenian",
                        0x054f,
                        "Tlinebelow",
                        0x1e6e,
                        "Tmonospace",
                        0xff34,
                        "Toarmenian",
                        0x0539,
                        "Tonefive",
                        0x01bc,
                        "Tonesix",
                        0x0184,
                        "Tonetwo",
                        0x01a7,
                        "Tretroflexhook",
                        0x01ae,
                        "Tsecyrillic",
                        0x0426,
                        "Tshecyrillic",
                        0x040b,
                        "Tsmall",
                        0xf774,
                        "Twelveroman",
                        0x216b,
                        "Tworoman",
                        0x2161,
                        "U",
                        0x0055,
                        "Uacute",
                        0x00da,
                        "Uacutesmall",
                        0xf7fa,
                        "Ubreve",
                        0x016c,
                        "Ucaron",
                        0x01d3,
                        "Ucircle",
                        0x24ca,
                        "Ucircumflex",
                        0x00db,
                        "Ucircumflexbelow",
                        0x1e76,
                        "Ucircumflexsmall",
                        0xf7fb,
                        "Ucyrillic",
                        0x0423,
                        "Udblacute",
                        0x0170,
                        "Udblgrave",
                        0x0214,
                        "Udieresis",
                        0x00dc,
                        "Udieresisacute",
                        0x01d7,
                        "Udieresisbelow",
                        0x1e72,
                        "Udieresiscaron",
                        0x01d9,
                        "Udieresiscyrillic",
                        0x04f0,
                        "Udieresisgrave",
                        0x01db,
                        "Udieresismacron",
                        0x01d5,
                        "Udieresissmall",
                        0xf7fc,
                        "Udotbelow",
                        0x1ee4,
                        "Ugrave",
                        0x00d9,
                        "Ugravesmall",
                        0xf7f9,
                        "Uhookabove",
                        0x1ee6,
                        "Uhorn",
                        0x01af,
                        "Uhornacute",
                        0x1ee8,
                        "Uhorndotbelow",
                        0x1ef0,
                        "Uhorngrave",
                        0x1eea,
                        "Uhornhookabove",
                        0x1eec,
                        "Uhorntilde",
                        0x1eee,
                        "Uhungarumlaut",
                        0x0170,
                        "Uhungarumlautcyrillic",
                        0x04f2,
                        "Uinvertedbreve",
                        0x0216,
                        "Ukcyrillic",
                        0x0478,
                        "Umacron",
                        0x016a,
                        "Umacroncyrillic",
                        0x04ee,
                        "Umacrondieresis",
                        0x1e7a,
                        "Umonospace",
                        0xff35,
                        "Uogonek",
                        0x0172,
                        "Upsilon",
                        0x03a5,
                        "Upsilon1",
                        0x03d2,
                        "Upsilonacutehooksymbolgreek",
                        0x03d3,
                        "Upsilonafrican",
                        0x01b1,
                        "Upsilondieresis",
                        0x03ab,
                        "Upsilondieresishooksymbolgreek",
                        0x03d4,
                        "Upsilonhooksymbol",
                        0x03d2,
                        "Upsilontonos",
                        0x038e,
                        "Uring",
                        0x016e,
                        "Ushortcyrillic",
                        0x040e,
                        "Usmall",
                        0xf775,
                        "Ustraightcyrillic",
                        0x04ae,
                        "Ustraightstrokecyrillic",
                        0x04b0,
                        "Utilde",
                        0x0168,
                        "Utildeacute",
                        0x1e78,
                        "Utildebelow",
                        0x1e74,
                        "V",
                        0x0056,
                        "Vcircle",
                        0x24cb,
                        "Vdotbelow",
                        0x1e7e,
                        "Vecyrillic",
                        0x0412,
                        "Vewarmenian",
                        0x054e,
                        "Vhook",
                        0x01b2,
                        "Vmonospace",
                        0xff36,
                        "Voarmenian",
                        0x0548,
                        "Vsmall",
                        0xf776,
                        "Vtilde",
                        0x1e7c,
                        "W",
                        0x0057,
                        "Wacute",
                        0x1e82,
                        "Wcircle",
                        0x24cc,
                        "Wcircumflex",
                        0x0174,
                        "Wdieresis",
                        0x1e84,
                        "Wdotaccent",
                        0x1e86,
                        "Wdotbelow",
                        0x1e88,
                        "Wgrave",
                        0x1e80,
                        "Wmonospace",
                        0xff37,
                        "Wsmall",
                        0xf777,
                        "X",
                        0x0058,
                        "Xcircle",
                        0x24cd,
                        "Xdieresis",
                        0x1e8c,
                        "Xdotaccent",
                        0x1e8a,
                        "Xeharmenian",
                        0x053d,
                        "Xi",
                        0x039e,
                        "Xmonospace",
                        0xff38,
                        "Xsmall",
                        0xf778,
                        "Y",
                        0x0059,
                        "Yacute",
                        0x00dd,
                        "Yacutesmall",
                        0xf7fd,
                        "Yatcyrillic",
                        0x0462,
                        "Ycircle",
                        0x24ce,
                        "Ycircumflex",
                        0x0176,
                        "Ydieresis",
                        0x0178,
                        "Ydieresissmall",
                        0xf7ff,
                        "Ydotaccent",
                        0x1e8e,
                        "Ydotbelow",
                        0x1ef4,
                        "Yericyrillic",
                        0x042b,
                        "Yerudieresiscyrillic",
                        0x04f8,
                        "Ygrave",
                        0x1ef2,
                        "Yhook",
                        0x01b3,
                        "Yhookabove",
                        0x1ef6,
                        "Yiarmenian",
                        0x0545,
                        "Yicyrillic",
                        0x0407,
                        "Yiwnarmenian",
                        0x0552,
                        "Ymonospace",
                        0xff39,
                        "Ysmall",
                        0xf779,
                        "Ytilde",
                        0x1ef8,
                        "Yusbigcyrillic",
                        0x046a,
                        "Yusbigiotifiedcyrillic",
                        0x046c,
                        "Yuslittlecyrillic",
                        0x0466,
                        "Yuslittleiotifiedcyrillic",
                        0x0468,
                        "Z",
                        0x005a,
                        "Zaarmenian",
                        0x0536,
                        "Zacute",
                        0x0179,
                        "Zcaron",
                        0x017d,
                        "Zcaronsmall",
                        0xf6ff,
                        "Zcircle",
                        0x24cf,
                        "Zcircumflex",
                        0x1e90,
                        "Zdot",
                        0x017b,
                        "Zdotaccent",
                        0x017b,
                        "Zdotbelow",
                        0x1e92,
                        "Zecyrillic",
                        0x0417,
                        "Zedescendercyrillic",
                        0x0498,
                        "Zedieresiscyrillic",
                        0x04de,
                        "Zeta",
                        0x0396,
                        "Zhearmenian",
                        0x053a,
                        "Zhebrevecyrillic",
                        0x04c1,
                        "Zhecyrillic",
                        0x0416,
                        "Zhedescendercyrillic",
                        0x0496,
                        "Zhedieresiscyrillic",
                        0x04dc,
                        "Zlinebelow",
                        0x1e94,
                        "Zmonospace",
                        0xff3a,
                        "Zsmall",
                        0xf77a,
                        "Zstroke",
                        0x01b5,
                        "a",
                        0x0061,
                        "aabengali",
                        0x0986,
                        "aacute",
                        0x00e1,
                        "aadeva",
                        0x0906,
                        "aagujarati",
                        0x0a86,
                        "aagurmukhi",
                        0x0a06,
                        "aamatragurmukhi",
                        0x0a3e,
                        "aarusquare",
                        0x3303,
                        "aavowelsignbengali",
                        0x09be,
                        "aavowelsigndeva",
                        0x093e,
                        "aavowelsigngujarati",
                        0x0abe,
                        "abbreviationmarkarmenian",
                        0x055f,
                        "abbreviationsigndeva",
                        0x0970,
                        "abengali",
                        0x0985,
                        "abopomofo",
                        0x311a,
                        "abreve",
                        0x0103,
                        "abreveacute",
                        0x1eaf,
                        "abrevecyrillic",
                        0x04d1,
                        "abrevedotbelow",
                        0x1eb7,
                        "abrevegrave",
                        0x1eb1,
                        "abrevehookabove",
                        0x1eb3,
                        "abrevetilde",
                        0x1eb5,
                        "acaron",
                        0x01ce,
                        "acircle",
                        0x24d0,
                        "acircumflex",
                        0x00e2,
                        "acircumflexacute",
                        0x1ea5,
                        "acircumflexdotbelow",
                        0x1ead,
                        "acircumflexgrave",
                        0x1ea7,
                        "acircumflexhookabove",
                        0x1ea9,
                        "acircumflextilde",
                        0x1eab,
                        "acute",
                        0x00b4,
                        "acutebelowcmb",
                        0x0317,
                        "acutecmb",
                        0x0301,
                        "acutecomb",
                        0x0301,
                        "acutedeva",
                        0x0954,
                        "acutelowmod",
                        0x02cf,
                        "acutetonecmb",
                        0x0341,
                        "acyrillic",
                        0x0430,
                        "adblgrave",
                        0x0201,
                        "addakgurmukhi",
                        0x0a71,
                        "adeva",
                        0x0905,
                        "adieresis",
                        0x00e4,
                        "adieresiscyrillic",
                        0x04d3,
                        "adieresismacron",
                        0x01df,
                        "adotbelow",
                        0x1ea1,
                        "adotmacron",
                        0x01e1,
                        "ae",
                        0x00e6,
                        "aeacute",
                        0x01fd,
                        "aekorean",
                        0x3150,
                        "aemacron",
                        0x01e3,
                        "afii00208",
                        0x2015,
                        "afii08941",
                        0x20a4,
                        "afii10017",
                        0x0410,
                        "afii10018",
                        0x0411,
                        "afii10019",
                        0x0412,
                        "afii10020",
                        0x0413,
                        "afii10021",
                        0x0414,
                        "afii10022",
                        0x0415,
                        "afii10023",
                        0x0401,
                        "afii10024",
                        0x0416,
                        "afii10025",
                        0x0417,
                        "afii10026",
                        0x0418,
                        "afii10027",
                        0x0419,
                        "afii10028",
                        0x041a,
                        "afii10029",
                        0x041b,
                        "afii10030",
                        0x041c,
                        "afii10031",
                        0x041d,
                        "afii10032",
                        0x041e,
                        "afii10033",
                        0x041f,
                        "afii10034",
                        0x0420,
                        "afii10035",
                        0x0421,
                        "afii10036",
                        0x0422,
                        "afii10037",
                        0x0423,
                        "afii10038",
                        0x0424,
                        "afii10039",
                        0x0425,
                        "afii10040",
                        0x0426,
                        "afii10041",
                        0x0427,
                        "afii10042",
                        0x0428,
                        "afii10043",
                        0x0429,
                        "afii10044",
                        0x042a,
                        "afii10045",
                        0x042b,
                        "afii10046",
                        0x042c,
                        "afii10047",
                        0x042d,
                        "afii10048",
                        0x042e,
                        "afii10049",
                        0x042f,
                        "afii10050",
                        0x0490,
                        "afii10051",
                        0x0402,
                        "afii10052",
                        0x0403,
                        "afii10053",
                        0x0404,
                        "afii10054",
                        0x0405,
                        "afii10055",
                        0x0406,
                        "afii10056",
                        0x0407,
                        "afii10057",
                        0x0408,
                        "afii10058",
                        0x0409,
                        "afii10059",
                        0x040a,
                        "afii10060",
                        0x040b,
                        "afii10061",
                        0x040c,
                        "afii10062",
                        0x040e,
                        "afii10063",
                        0xf6c4,
                        "afii10064",
                        0xf6c5,
                        "afii10065",
                        0x0430,
                        "afii10066",
                        0x0431,
                        "afii10067",
                        0x0432,
                        "afii10068",
                        0x0433,
                        "afii10069",
                        0x0434,
                        "afii10070",
                        0x0435,
                        "afii10071",
                        0x0451,
                        "afii10072",
                        0x0436,
                        "afii10073",
                        0x0437,
                        "afii10074",
                        0x0438,
                        "afii10075",
                        0x0439,
                        "afii10076",
                        0x043a,
                        "afii10077",
                        0x043b,
                        "afii10078",
                        0x043c,
                        "afii10079",
                        0x043d,
                        "afii10080",
                        0x043e,
                        "afii10081",
                        0x043f,
                        "afii10082",
                        0x0440,
                        "afii10083",
                        0x0441,
                        "afii10084",
                        0x0442,
                        "afii10085",
                        0x0443,
                        "afii10086",
                        0x0444,
                        "afii10087",
                        0x0445,
                        "afii10088",
                        0x0446,
                        "afii10089",
                        0x0447,
                        "afii10090",
                        0x0448,
                        "afii10091",
                        0x0449,
                        "afii10092",
                        0x044a,
                        "afii10093",
                        0x044b,
                        "afii10094",
                        0x044c,
                        "afii10095",
                        0x044d,
                        "afii10096",
                        0x044e,
                        "afii10097",
                        0x044f,
                        "afii10098",
                        0x0491,
                        "afii10099",
                        0x0452,
                        "afii10100",
                        0x0453,
                        "afii10101",
                        0x0454,
                        "afii10102",
                        0x0455,
                        "afii10103",
                        0x0456,
                        "afii10104",
                        0x0457,
                        "afii10105",
                        0x0458,
                        "afii10106",
                        0x0459,
                        "afii10107",
                        0x045a,
                        "afii10108",
                        0x045b,
                        "afii10109",
                        0x045c,
                        "afii10110",
                        0x045e,
                        "afii10145",
                        0x040f,
                        "afii10146",
                        0x0462,
                        "afii10147",
                        0x0472,
                        "afii10148",
                        0x0474,
                        "afii10192",
                        0xf6c6,
                        "afii10193",
                        0x045f,
                        "afii10194",
                        0x0463,
                        "afii10195",
                        0x0473,
                        "afii10196",
                        0x0475,
                        "afii10831",
                        0xf6c7,
                        "afii10832",
                        0xf6c8,
                        "afii10846",
                        0x04d9,
                        "afii299",
                        0x200e,
                        "afii300",
                        0x200f,
                        "afii301",
                        0x200d,
                        "afii57381",
                        0x066a,
                        "afii57388",
                        0x060c,
                        "afii57392",
                        0x0660,
                        "afii57393",
                        0x0661,
                        "afii57394",
                        0x0662,
                        "afii57395",
                        0x0663,
                        "afii57396",
                        0x0664,
                        "afii57397",
                        0x0665,
                        "afii57398",
                        0x0666,
                        "afii57399",
                        0x0667,
                        "afii57400",
                        0x0668,
                        "afii57401",
                        0x0669,
                        "afii57403",
                        0x061b,
                        "afii57407",
                        0x061f,
                        "afii57409",
                        0x0621,
                        "afii57410",
                        0x0622,
                        "afii57411",
                        0x0623,
                        "afii57412",
                        0x0624,
                        "afii57413",
                        0x0625,
                        "afii57414",
                        0x0626,
                        "afii57415",
                        0x0627,
                        "afii57416",
                        0x0628,
                        "afii57417",
                        0x0629,
                        "afii57418",
                        0x062a,
                        "afii57419",
                        0x062b,
                        "afii57420",
                        0x062c,
                        "afii57421",
                        0x062d,
                        "afii57422",
                        0x062e,
                        "afii57423",
                        0x062f,
                        "afii57424",
                        0x0630,
                        "afii57425",
                        0x0631,
                        "afii57426",
                        0x0632,
                        "afii57427",
                        0x0633,
                        "afii57428",
                        0x0634,
                        "afii57429",
                        0x0635,
                        "afii57430",
                        0x0636,
                        "afii57431",
                        0x0637,
                        "afii57432",
                        0x0638,
                        "afii57433",
                        0x0639,
                        "afii57434",
                        0x063a,
                        "afii57440",
                        0x0640,
                        "afii57441",
                        0x0641,
                        "afii57442",
                        0x0642,
                        "afii57443",
                        0x0643,
                        "afii57444",
                        0x0644,
                        "afii57445",
                        0x0645,
                        "afii57446",
                        0x0646,
                        "afii57448",
                        0x0648,
                        "afii57449",
                        0x0649,
                        "afii57450",
                        0x064a,
                        "afii57451",
                        0x064b,
                        "afii57452",
                        0x064c,
                        "afii57453",
                        0x064d,
                        "afii57454",
                        0x064e,
                        "afii57455",
                        0x064f,
                        "afii57456",
                        0x0650,
                        "afii57457",
                        0x0651,
                        "afii57458",
                        0x0652,
                        "afii57470",
                        0x0647,
                        "afii57505",
                        0x06a4,
                        "afii57506",
                        0x067e,
                        "afii57507",
                        0x0686,
                        "afii57508",
                        0x0698,
                        "afii57509",
                        0x06af,
                        "afii57511",
                        0x0679,
                        "afii57512",
                        0x0688,
                        "afii57513",
                        0x0691,
                        "afii57514",
                        0x06ba,
                        "afii57519",
                        0x06d2,
                        "afii57534",
                        0x06d5,
                        "afii57636",
                        0x20aa,
                        "afii57645",
                        0x05be,
                        "afii57658",
                        0x05c3,
                        "afii57664",
                        0x05d0,
                        "afii57665",
                        0x05d1,
                        "afii57666",
                        0x05d2,
                        "afii57667",
                        0x05d3,
                        "afii57668",
                        0x05d4,
                        "afii57669",
                        0x05d5,
                        "afii57670",
                        0x05d6,
                        "afii57671",
                        0x05d7,
                        "afii57672",
                        0x05d8,
                        "afii57673",
                        0x05d9,
                        "afii57674",
                        0x05da,
                        "afii57675",
                        0x05db,
                        "afii57676",
                        0x05dc,
                        "afii57677",
                        0x05dd,
                        "afii57678",
                        0x05de,
                        "afii57679",
                        0x05df,
                        "afii57680",
                        0x05e0,
                        "afii57681",
                        0x05e1,
                        "afii57682",
                        0x05e2,
                        "afii57683",
                        0x05e3,
                        "afii57684",
                        0x05e4,
                        "afii57685",
                        0x05e5,
                        "afii57686",
                        0x05e6,
                        "afii57687",
                        0x05e7,
                        "afii57688",
                        0x05e8,
                        "afii57689",
                        0x05e9,
                        "afii57690",
                        0x05ea,
                        "afii57694",
                        0xfb2a,
                        "afii57695",
                        0xfb2b,
                        "afii57700",
                        0xfb4b,
                        "afii57705",
                        0xfb1f,
                        "afii57716",
                        0x05f0,
                        "afii57717",
                        0x05f1,
                        "afii57718",
                        0x05f2,
                        "afii57723",
                        0xfb35,
                        "afii57793",
                        0x05b4,
                        "afii57794",
                        0x05b5,
                        "afii57795",
                        0x05b6,
                        "afii57796",
                        0x05bb,
                        "afii57797",
                        0x05b8,
                        "afii57798",
                        0x05b7,
                        "afii57799",
                        0x05b0,
                        "afii57800",
                        0x05b2,
                        "afii57801",
                        0x05b1,
                        "afii57802",
                        0x05b3,
                        "afii57803",
                        0x05c2,
                        "afii57804",
                        0x05c1,
                        "afii57806",
                        0x05b9,
                        "afii57807",
                        0x05bc,
                        "afii57839",
                        0x05bd,
                        "afii57841",
                        0x05bf,
                        "afii57842",
                        0x05c0,
                        "afii57929",
                        0x02bc,
                        "afii61248",
                        0x2105,
                        "afii61289",
                        0x2113,
                        "afii61352",
                        0x2116,
                        "afii61573",
                        0x202c,
                        "afii61574",
                        0x202d,
                        "afii61575",
                        0x202e,
                        "afii61664",
                        0x200c,
                        "afii63167",
                        0x066d,
                        "afii64937",
                        0x02bd,
                        "agrave",
                        0x00e0,
                        "agujarati",
                        0x0a85,
                        "agurmukhi",
                        0x0a05,
                        "ahiragana",
                        0x3042,
                        "ahookabove",
                        0x1ea3,
                        "aibengali",
                        0x0990,
                        "aibopomofo",
                        0x311e,
                        "aideva",
                        0x0910,
                        "aiecyrillic",
                        0x04d5,
                        "aigujarati",
                        0x0a90,
                        "aigurmukhi",
                        0x0a10,
                        "aimatragurmukhi",
                        0x0a48,
                        "ainarabic",
                        0x0639,
                        "ainfinalarabic",
                        0xfeca,
                        "aininitialarabic",
                        0xfecb,
                        "ainmedialarabic",
                        0xfecc,
                        "ainvertedbreve",
                        0x0203,
                        "aivowelsignbengali",
                        0x09c8,
                        "aivowelsigndeva",
                        0x0948,
                        "aivowelsigngujarati",
                        0x0ac8,
                        "akatakana",
                        0x30a2,
                        "akatakanahalfwidth",
                        0xff71,
                        "akorean",
                        0x314f,
                        "alef",
                        0x05d0,
                        "alefarabic",
                        0x0627,
                        "alefdageshhebrew",
                        0xfb30,
                        "aleffinalarabic",
                        0xfe8e,
                        "alefhamzaabovearabic",
                        0x0623,
                        "alefhamzaabovefinalarabic",
                        0xfe84,
                        "alefhamzabelowarabic",
                        0x0625,
                        "alefhamzabelowfinalarabic",
                        0xfe88,
                        "alefhebrew",
                        0x05d0,
                        "aleflamedhebrew",
                        0xfb4f,
                        "alefmaddaabovearabic",
                        0x0622,
                        "alefmaddaabovefinalarabic",
                        0xfe82,
                        "alefmaksuraarabic",
                        0x0649,
                        "alefmaksurafinalarabic",
                        0xfef0,
                        "alefmaksurainitialarabic",
                        0xfef3,
                        "alefmaksuramedialarabic",
                        0xfef4,
                        "alefpatahhebrew",
                        0xfb2e,
                        "alefqamatshebrew",
                        0xfb2f,
                        "aleph",
                        0x2135,
                        "allequal",
                        0x224c,
                        "alpha",
                        0x03b1,
                        "alphatonos",
                        0x03ac,
                        "amacron",
                        0x0101,
                        "amonospace",
                        0xff41,
                        "ampersand",
                        0x0026,
                        "ampersandmonospace",
                        0xff06,
                        "ampersandsmall",
                        0xf726,
                        "amsquare",
                        0x33c2,
                        "anbopomofo",
                        0x3122,
                        "angbopomofo",
                        0x3124,
                        "angbracketleft",
                        0x3008,
                        "angbracketright",
                        0x3009,
                        "angkhankhuthai",
                        0x0e5a,
                        "angle",
                        0x2220,
                        "anglebracketleft",
                        0x3008,
                        "anglebracketleftvertical",
                        0xfe3f,
                        "anglebracketright",
                        0x3009,
                        "anglebracketrightvertical",
                        0xfe40,
                        "angleleft",
                        0x2329,
                        "angleright",
                        0x232a,
                        "angstrom",
                        0x212b,
                        "anoteleia",
                        0x0387,
                        "anudattadeva",
                        0x0952,
                        "anusvarabengali",
                        0x0982,
                        "anusvaradeva",
                        0x0902,
                        "anusvaragujarati",
                        0x0a82,
                        "aogonek",
                        0x0105,
                        "apaatosquare",
                        0x3300,
                        "aparen",
                        0x249c,
                        "apostrophearmenian",
                        0x055a,
                        "apostrophemod",
                        0x02bc,
                        "apple",
                        0xf8ff,
                        "approaches",
                        0x2250,
                        "approxequal",
                        0x2248,
                        "approxequalorimage",
                        0x2252,
                        "approximatelyequal",
                        0x2245,
                        "araeaekorean",
                        0x318e,
                        "araeakorean",
                        0x318d,
                        "arc",
                        0x2312,
                        "arighthalfring",
                        0x1e9a,
                        "aring",
                        0x00e5,
                        "aringacute",
                        0x01fb,
                        "aringbelow",
                        0x1e01,
                        "arrowboth",
                        0x2194,
                        "arrowdashdown",
                        0x21e3,
                        "arrowdashleft",
                        0x21e0,
                        "arrowdashright",
                        0x21e2,
                        "arrowdashup",
                        0x21e1,
                        "arrowdblboth",
                        0x21d4,
                        "arrowdbldown",
                        0x21d3,
                        "arrowdblleft",
                        0x21d0,
                        "arrowdblright",
                        0x21d2,
                        "arrowdblup",
                        0x21d1,
                        "arrowdown",
                        0x2193,
                        "arrowdownleft",
                        0x2199,
                        "arrowdownright",
                        0x2198,
                        "arrowdownwhite",
                        0x21e9,
                        "arrowheaddownmod",
                        0x02c5,
                        "arrowheadleftmod",
                        0x02c2,
                        "arrowheadrightmod",
                        0x02c3,
                        "arrowheadupmod",
                        0x02c4,
                        "arrowhorizex",
                        0xf8e7,
                        "arrowleft",
                        0x2190,
                        "arrowleftdbl",
                        0x21d0,
                        "arrowleftdblstroke",
                        0x21cd,
                        "arrowleftoverright",
                        0x21c6,
                        "arrowleftwhite",
                        0x21e6,
                        "arrowright",
                        0x2192,
                        "arrowrightdblstroke",
                        0x21cf,
                        "arrowrightheavy",
                        0x279e,
                        "arrowrightoverleft",
                        0x21c4,
                        "arrowrightwhite",
                        0x21e8,
                        "arrowtableft",
                        0x21e4,
                        "arrowtabright",
                        0x21e5,
                        "arrowup",
                        0x2191,
                        "arrowupdn",
                        0x2195,
                        "arrowupdnbse",
                        0x21a8,
                        "arrowupdownbase",
                        0x21a8,
                        "arrowupleft",
                        0x2196,
                        "arrowupleftofdown",
                        0x21c5,
                        "arrowupright",
                        0x2197,
                        "arrowupwhite",
                        0x21e7,
                        "arrowvertex",
                        0xf8e6,
                        "asciicircum",
                        0x005e,
                        "asciicircummonospace",
                        0xff3e,
                        "asciitilde",
                        0x007e,
                        "asciitildemonospace",
                        0xff5e,
                        "ascript",
                        0x0251,
                        "ascriptturned",
                        0x0252,
                        "asmallhiragana",
                        0x3041,
                        "asmallkatakana",
                        0x30a1,
                        "asmallkatakanahalfwidth",
                        0xff67,
                        "asterisk",
                        0x002a,
                        "asteriskaltonearabic",
                        0x066d,
                        "asteriskarabic",
                        0x066d,
                        "asteriskmath",
                        0x2217,
                        "asteriskmonospace",
                        0xff0a,
                        "asterisksmall",
                        0xfe61,
                        "asterism",
                        0x2042,
                        "asuperior",
                        0xf6e9,
                        "asymptoticallyequal",
                        0x2243,
                        "at",
                        0x0040,
                        "atilde",
                        0x00e3,
                        "atmonospace",
                        0xff20,
                        "atsmall",
                        0xfe6b,
                        "aturned",
                        0x0250,
                        "aubengali",
                        0x0994,
                        "aubopomofo",
                        0x3120,
                        "audeva",
                        0x0914,
                        "augujarati",
                        0x0a94,
                        "augurmukhi",
                        0x0a14,
                        "aulengthmarkbengali",
                        0x09d7,
                        "aumatragurmukhi",
                        0x0a4c,
                        "auvowelsignbengali",
                        0x09cc,
                        "auvowelsigndeva",
                        0x094c,
                        "auvowelsigngujarati",
                        0x0acc,
                        "avagrahadeva",
                        0x093d,
                        "aybarmenian",
                        0x0561,
                        "ayin",
                        0x05e2,
                        "ayinaltonehebrew",
                        0xfb20,
                        "ayinhebrew",
                        0x05e2,
                        "b",
                        0x0062,
                        "babengali",
                        0x09ac,
                        "backslash",
                        0x005c,
                        "backslashmonospace",
                        0xff3c,
                        "badeva",
                        0x092c,
                        "bagujarati",
                        0x0aac,
                        "bagurmukhi",
                        0x0a2c,
                        "bahiragana",
                        0x3070,
                        "bahtthai",
                        0x0e3f,
                        "bakatakana",
                        0x30d0,
                        "bar",
                        0x007c,
                        "barmonospace",
                        0xff5c,
                        "bbopomofo",
                        0x3105,
                        "bcircle",
                        0x24d1,
                        "bdotaccent",
                        0x1e03,
                        "bdotbelow",
                        0x1e05,
                        "beamedsixteenthnotes",
                        0x266c,
                        "because",
                        0x2235,
                        "becyrillic",
                        0x0431,
                        "beharabic",
                        0x0628,
                        "behfinalarabic",
                        0xfe90,
                        "behinitialarabic",
                        0xfe91,
                        "behiragana",
                        0x3079,
                        "behmedialarabic",
                        0xfe92,
                        "behmeeminitialarabic",
                        0xfc9f,
                        "behmeemisolatedarabic",
                        0xfc08,
                        "behnoonfinalarabic",
                        0xfc6d,
                        "bekatakana",
                        0x30d9,
                        "benarmenian",
                        0x0562,
                        "bet",
                        0x05d1,
                        "beta",
                        0x03b2,
                        "betasymbolgreek",
                        0x03d0,
                        "betdagesh",
                        0xfb31,
                        "betdageshhebrew",
                        0xfb31,
                        "bethebrew",
                        0x05d1,
                        "betrafehebrew",
                        0xfb4c,
                        "bhabengali",
                        0x09ad,
                        "bhadeva",
                        0x092d,
                        "bhagujarati",
                        0x0aad,
                        "bhagurmukhi",
                        0x0a2d,
                        "bhook",
                        0x0253,
                        "bihiragana",
                        0x3073,
                        "bikatakana",
                        0x30d3,
                        "bilabialclick",
                        0x0298,
                        "bindigurmukhi",
                        0x0a02,
                        "birusquare",
                        0x3331,
                        "blackcircle",
                        0x25cf,
                        "blackdiamond",
                        0x25c6,
                        "blackdownpointingtriangle",
                        0x25bc,
                        "blackleftpointingpointer",
                        0x25c4,
                        "blackleftpointingtriangle",
                        0x25c0,
                        "blacklenticularbracketleft",
                        0x3010,
                        "blacklenticularbracketleftvertical",
                        0xfe3b,
                        "blacklenticularbracketright",
                        0x3011,
                        "blacklenticularbracketrightvertical",
                        0xfe3c,
                        "blacklowerlefttriangle",
                        0x25e3,
                        "blacklowerrighttriangle",
                        0x25e2,
                        "blackrectangle",
                        0x25ac,
                        "blackrightpointingpointer",
                        0x25ba,
                        "blackrightpointingtriangle",
                        0x25b6,
                        "blacksmallsquare",
                        0x25aa,
                        "blacksmilingface",
                        0x263b,
                        "blacksquare",
                        0x25a0,
                        "blackstar",
                        0x2605,
                        "blackupperlefttriangle",
                        0x25e4,
                        "blackupperrighttriangle",
                        0x25e5,
                        "blackuppointingsmalltriangle",
                        0x25b4,
                        "blackuppointingtriangle",
                        0x25b2,
                        "blank",
                        0x2423,
                        "blinebelow",
                        0x1e07,
                        "block",
                        0x2588,
                        "bmonospace",
                        0xff42,
                        "bobaimaithai",
                        0x0e1a,
                        "bohiragana",
                        0x307c,
                        "bokatakana",
                        0x30dc,
                        "bparen",
                        0x249d,
                        "bqsquare",
                        0x33c3,
                        "braceex",
                        0xf8f4,
                        "braceleft",
                        0x007b,
                        "braceleftbt",
                        0xf8f3,
                        "braceleftmid",
                        0xf8f2,
                        "braceleftmonospace",
                        0xff5b,
                        "braceleftsmall",
                        0xfe5b,
                        "bracelefttp",
                        0xf8f1,
                        "braceleftvertical",
                        0xfe37,
                        "braceright",
                        0x007d,
                        "bracerightbt",
                        0xf8fe,
                        "bracerightmid",
                        0xf8fd,
                        "bracerightmonospace",
                        0xff5d,
                        "bracerightsmall",
                        0xfe5c,
                        "bracerighttp",
                        0xf8fc,
                        "bracerightvertical",
                        0xfe38,
                        "bracketleft",
                        0x005b,
                        "bracketleftbt",
                        0xf8f0,
                        "bracketleftex",
                        0xf8ef,
                        "bracketleftmonospace",
                        0xff3b,
                        "bracketlefttp",
                        0xf8ee,
                        "bracketright",
                        0x005d,
                        "bracketrightbt",
                        0xf8fb,
                        "bracketrightex",
                        0xf8fa,
                        "bracketrightmonospace",
                        0xff3d,
                        "bracketrighttp",
                        0xf8f9,
                        "breve",
                        0x02d8,
                        "brevebelowcmb",
                        0x032e,
                        "brevecmb",
                        0x0306,
                        "breveinvertedbelowcmb",
                        0x032f,
                        "breveinvertedcmb",
                        0x0311,
                        "breveinverteddoublecmb",
                        0x0361,
                        "bridgebelowcmb",
                        0x032a,
                        "bridgeinvertedbelowcmb",
                        0x033a,
                        "brokenbar",
                        0x00a6,
                        "bstroke",
                        0x0180,
                        "bsuperior",
                        0xf6ea,
                        "btopbar",
                        0x0183,
                        "buhiragana",
                        0x3076,
                        "bukatakana",
                        0x30d6,
                        "bullet",
                        0x2022,
                        "bulletinverse",
                        0x25d8,
                        "bulletoperator",
                        0x2219,
                        "bullseye",
                        0x25ce,
                        "c",
                        0x0063,
                        "caarmenian",
                        0x056e,
                        "cabengali",
                        0x099a,
                        "cacute",
                        0x0107,
                        "cadeva",
                        0x091a,
                        "cagujarati",
                        0x0a9a,
                        "cagurmukhi",
                        0x0a1a,
                        "calsquare",
                        0x3388,
                        "candrabindubengali",
                        0x0981,
                        "candrabinducmb",
                        0x0310,
                        "candrabindudeva",
                        0x0901,
                        "candrabindugujarati",
                        0x0a81,
                        "capslock",
                        0x21ea,
                        "careof",
                        0x2105,
                        "caron",
                        0x02c7,
                        "caronbelowcmb",
                        0x032c,
                        "caroncmb",
                        0x030c,
                        "carriagereturn",
                        0x21b5,
                        "cbopomofo",
                        0x3118,
                        "ccaron",
                        0x010d,
                        "ccedilla",
                        0x00e7,
                        "ccedillaacute",
                        0x1e09,
                        "ccircle",
                        0x24d2,
                        "ccircumflex",
                        0x0109,
                        "ccurl",
                        0x0255,
                        "cdot",
                        0x010b,
                        "cdotaccent",
                        0x010b,
                        "cdsquare",
                        0x33c5,
                        "cedilla",
                        0x00b8,
                        "cedillacmb",
                        0x0327,
                        "cent",
                        0x00a2,
                        "centigrade",
                        0x2103,
                        "centinferior",
                        0xf6df,
                        "centmonospace",
                        0xffe0,
                        "centoldstyle",
                        0xf7a2,
                        "centsuperior",
                        0xf6e0,
                        "chaarmenian",
                        0x0579,
                        "chabengali",
                        0x099b,
                        "chadeva",
                        0x091b,
                        "chagujarati",
                        0x0a9b,
                        "chagurmukhi",
                        0x0a1b,
                        "chbopomofo",
                        0x3114,
                        "cheabkhasiancyrillic",
                        0x04bd,
                        "checkmark",
                        0x2713,
                        "checyrillic",
                        0x0447,
                        "chedescenderabkhasiancyrillic",
                        0x04bf,
                        "chedescendercyrillic",
                        0x04b7,
                        "chedieresiscyrillic",
                        0x04f5,
                        "cheharmenian",
                        0x0573,
                        "chekhakassiancyrillic",
                        0x04cc,
                        "cheverticalstrokecyrillic",
                        0x04b9,
                        "chi",
                        0x03c7,
                        "chieuchacirclekorean",
                        0x3277,
                        "chieuchaparenkorean",
                        0x3217,
                        "chieuchcirclekorean",
                        0x3269,
                        "chieuchkorean",
                        0x314a,
                        "chieuchparenkorean",
                        0x3209,
                        "chochangthai",
                        0x0e0a,
                        "chochanthai",
                        0x0e08,
                        "chochingthai",
                        0x0e09,
                        "chochoethai",
                        0x0e0c,
                        "chook",
                        0x0188,
                        "cieucacirclekorean",
                        0x3276,
                        "cieucaparenkorean",
                        0x3216,
                        "cieuccirclekorean",
                        0x3268,
                        "cieuckorean",
                        0x3148,
                        "cieucparenkorean",
                        0x3208,
                        "cieucuparenkorean",
                        0x321c,
                        "circle",
                        0x25cb,
                        "circlecopyrt",
                        0x00a9,
                        "circlemultiply",
                        0x2297,
                        "circleot",
                        0x2299,
                        "circleplus",
                        0x2295,
                        "circlepostalmark",
                        0x3036,
                        "circlewithlefthalfblack",
                        0x25d0,
                        "circlewithrighthalfblack",
                        0x25d1,
                        "circumflex",
                        0x02c6,
                        "circumflexbelowcmb",
                        0x032d,
                        "circumflexcmb",
                        0x0302,
                        "clear",
                        0x2327,
                        "clickalveolar",
                        0x01c2,
                        "clickdental",
                        0x01c0,
                        "clicklateral",
                        0x01c1,
                        "clickretroflex",
                        0x01c3,
                        "club",
                        0x2663,
                        "clubsuitblack",
                        0x2663,
                        "clubsuitwhite",
                        0x2667,
                        "cmcubedsquare",
                        0x33a4,
                        "cmonospace",
                        0xff43,
                        "cmsquaredsquare",
                        0x33a0,
                        "coarmenian",
                        0x0581,
                        "colon",
                        0x003a,
                        "colonmonetary",
                        0x20a1,
                        "colonmonospace",
                        0xff1a,
                        "colonsign",
                        0x20a1,
                        "colonsmall",
                        0xfe55,
                        "colontriangularhalfmod",
                        0x02d1,
                        "colontriangularmod",
                        0x02d0,
                        "comma",
                        0x002c,
                        "commaabovecmb",
                        0x0313,
                        "commaaboverightcmb",
                        0x0315,
                        "commaaccent",
                        0xf6c3,
                        "commaarabic",
                        0x060c,
                        "commaarmenian",
                        0x055d,
                        "commainferior",
                        0xf6e1,
                        "commamonospace",
                        0xff0c,
                        "commareversedabovecmb",
                        0x0314,
                        "commareversedmod",
                        0x02bd,
                        "commasmall",
                        0xfe50,
                        "commasuperior",
                        0xf6e2,
                        "commaturnedabovecmb",
                        0x0312,
                        "commaturnedmod",
                        0x02bb,
                        "compass",
                        0x263c,
                        "congruent",
                        0x2245,
                        "contourintegral",
                        0x222e,
                        "control",
                        0x2303,
                        "controlACK",
                        0x0006,
                        "controlBEL",
                        0x0007,
                        "controlBS",
                        0x0008,
                        "controlCAN",
                        0x0018,
                        "controlCR",
                        0x000d,
                        "controlDC1",
                        0x0011,
                        "controlDC2",
                        0x0012,
                        "controlDC3",
                        0x0013,
                        "controlDC4",
                        0x0014,
                        "controlDEL",
                        0x007f,
                        "controlDLE",
                        0x0010,
                        "controlEM",
                        0x0019,
                        "controlENQ",
                        0x0005,
                        "controlEOT",
                        0x0004,
                        "controlESC",
                        0x001b,
                        "controlETB",
                        0x0017,
                        "controlETX",
                        0x0003,
                        "controlFF",
                        0x000c,
                        "controlFS",
                        0x001c,
                        "controlGS",
                        0x001d,
                        "controlHT",
                        0x0009,
                        "controlLF",
                        0x000a,
                        "controlNAK",
                        0x0015,
                        "controlNULL",
                        0x0000,
                        "controlRS",
                        0x001e,
                        "controlSI",
                        0x000f,
                        "controlSO",
                        0x000e,
                        "controlSOT",
                        0x0002,
                        "controlSTX",
                        0x0001,
                        "controlSUB",
                        0x001a,
                        "controlSYN",
                        0x0016,
                        "controlUS",
                        0x001f,
                        "controlVT",
                        0x000b,
                        "copyright",
                        0x00a9,
                        "copyrightsans",
                        0xf8e9,
                        "copyrightserif",
                        0xf6d9,
                        "cornerbracketleft",
                        0x300c,
                        "cornerbracketlefthalfwidth",
                        0xff62,
                        "cornerbracketleftvertical",
                        0xfe41,
                        "cornerbracketright",
                        0x300d,
                        "cornerbracketrighthalfwidth",
                        0xff63,
                        "cornerbracketrightvertical",
                        0xfe42,
                        "corporationsquare",
                        0x337f,
                        "cosquare",
                        0x33c7,
                        "coverkgsquare",
                        0x33c6,
                        "cparen",
                        0x249e,
                        "cruzeiro",
                        0x20a2,
                        "cstretched",
                        0x0297,
                        "curlyand",
                        0x22cf,
                        "curlyor",
                        0x22ce,
                        "currency",
                        0x00a4,
                        "cyrBreve",
                        0xf6d1,
                        "cyrFlex",
                        0xf6d2,
                        "cyrbreve",
                        0xf6d4,
                        "cyrflex",
                        0xf6d5,
                        "d",
                        0x0064,
                        "daarmenian",
                        0x0564,
                        "dabengali",
                        0x09a6,
                        "dadarabic",
                        0x0636,
                        "dadeva",
                        0x0926,
                        "dadfinalarabic",
                        0xfebe,
                        "dadinitialarabic",
                        0xfebf,
                        "dadmedialarabic",
                        0xfec0,
                        "dagesh",
                        0x05bc,
                        "dageshhebrew",
                        0x05bc,
                        "dagger",
                        0x2020,
                        "daggerdbl",
                        0x2021,
                        "dagujarati",
                        0x0aa6,
                        "dagurmukhi",
                        0x0a26,
                        "dahiragana",
                        0x3060,
                        "dakatakana",
                        0x30c0,
                        "dalarabic",
                        0x062f,
                        "dalet",
                        0x05d3,
                        "daletdagesh",
                        0xfb33,
                        "daletdageshhebrew",
                        0xfb33,
                        "dalethebrew",
                        0x05d3,
                        "dalfinalarabic",
                        0xfeaa,
                        "dammaarabic",
                        0x064f,
                        "dammalowarabic",
                        0x064f,
                        "dammatanaltonearabic",
                        0x064c,
                        "dammatanarabic",
                        0x064c,
                        "danda",
                        0x0964,
                        "dargahebrew",
                        0x05a7,
                        "dargalefthebrew",
                        0x05a7,
                        "dasiapneumatacyrilliccmb",
                        0x0485,
                        "dblGrave",
                        0xf6d3,
                        "dblanglebracketleft",
                        0x300a,
                        "dblanglebracketleftvertical",
                        0xfe3d,
                        "dblanglebracketright",
                        0x300b,
                        "dblanglebracketrightvertical",
                        0xfe3e,
                        "dblarchinvertedbelowcmb",
                        0x032b,
                        "dblarrowleft",
                        0x21d4,
                        "dblarrowright",
                        0x21d2,
                        "dbldanda",
                        0x0965,
                        "dblgrave",
                        0xf6d6,
                        "dblgravecmb",
                        0x030f,
                        "dblintegral",
                        0x222c,
                        "dbllowline",
                        0x2017,
                        "dbllowlinecmb",
                        0x0333,
                        "dbloverlinecmb",
                        0x033f,
                        "dblprimemod",
                        0x02ba,
                        "dblverticalbar",
                        0x2016,
                        "dblverticallineabovecmb",
                        0x030e,
                        "dbopomofo",
                        0x3109,
                        "dbsquare",
                        0x33c8,
                        "dcaron",
                        0x010f,
                        "dcedilla",
                        0x1e11,
                        "dcircle",
                        0x24d3,
                        "dcircumflexbelow",
                        0x1e13,
                        "dcroat",
                        0x0111,
                        "ddabengali",
                        0x09a1,
                        "ddadeva",
                        0x0921,
                        "ddagujarati",
                        0x0aa1,
                        "ddagurmukhi",
                        0x0a21,
                        "ddalarabic",
                        0x0688,
                        "ddalfinalarabic",
                        0xfb89,
                        "dddhadeva",
                        0x095c,
                        "ddhabengali",
                        0x09a2,
                        "ddhadeva",
                        0x0922,
                        "ddhagujarati",
                        0x0aa2,
                        "ddhagurmukhi",
                        0x0a22,
                        "ddotaccent",
                        0x1e0b,
                        "ddotbelow",
                        0x1e0d,
                        "decimalseparatorarabic",
                        0x066b,
                        "decimalseparatorpersian",
                        0x066b,
                        "decyrillic",
                        0x0434,
                        "degree",
                        0x00b0,
                        "dehihebrew",
                        0x05ad,
                        "dehiragana",
                        0x3067,
                        "deicoptic",
                        0x03ef,
                        "dekatakana",
                        0x30c7,
                        "deleteleft",
                        0x232b,
                        "deleteright",
                        0x2326,
                        "delta",
                        0x03b4,
                        "deltaturned",
                        0x018d,
                        "denominatorminusonenumeratorbengali",
                        0x09f8,
                        "dezh",
                        0x02a4,
                        "dhabengali",
                        0x09a7,
                        "dhadeva",
                        0x0927,
                        "dhagujarati",
                        0x0aa7,
                        "dhagurmukhi",
                        0x0a27,
                        "dhook",
                        0x0257,
                        "dialytikatonos",
                        0x0385,
                        "dialytikatonoscmb",
                        0x0344,
                        "diamond",
                        0x2666,
                        "diamondsuitwhite",
                        0x2662,
                        "dieresis",
                        0x00a8,
                        "dieresisacute",
                        0xf6d7,
                        "dieresisbelowcmb",
                        0x0324,
                        "dieresiscmb",
                        0x0308,
                        "dieresisgrave",
                        0xf6d8,
                        "dieresistonos",
                        0x0385,
                        "dihiragana",
                        0x3062,
                        "dikatakana",
                        0x30c2,
                        "dittomark",
                        0x3003,
                        "divide",
                        0x00f7,
                        "divides",
                        0x2223,
                        "divisionslash",
                        0x2215,
                        "djecyrillic",
                        0x0452,
                        "dkshade",
                        0x2593,
                        "dlinebelow",
                        0x1e0f,
                        "dlsquare",
                        0x3397,
                        "dmacron",
                        0x0111,
                        "dmonospace",
                        0xff44,
                        "dnblock",
                        0x2584,
                        "dochadathai",
                        0x0e0e,
                        "dodekthai",
                        0x0e14,
                        "dohiragana",
                        0x3069,
                        "dokatakana",
                        0x30c9,
                        "dollar",
                        0x0024,
                        "dollarinferior",
                        0xf6e3,
                        "dollarmonospace",
                        0xff04,
                        "dollaroldstyle",
                        0xf724,
                        "dollarsmall",
                        0xfe69,
                        "dollarsuperior",
                        0xf6e4,
                        "dong",
                        0x20ab,
                        "dorusquare",
                        0x3326,
                        "dotaccent",
                        0x02d9,
                        "dotaccentcmb",
                        0x0307,
                        "dotbelowcmb",
                        0x0323,
                        "dotbelowcomb",
                        0x0323,
                        "dotkatakana",
                        0x30fb,
                        "dotlessi",
                        0x0131,
                        "dotlessj",
                        0xf6be,
                        "dotlessjstrokehook",
                        0x0284,
                        "dotmath",
                        0x22c5,
                        "dottedcircle",
                        0x25cc,
                        "doubleyodpatah",
                        0xfb1f,
                        "doubleyodpatahhebrew",
                        0xfb1f,
                        "downtackbelowcmb",
                        0x031e,
                        "downtackmod",
                        0x02d5,
                        "dparen",
                        0x249f,
                        "dsuperior",
                        0xf6eb,
                        "dtail",
                        0x0256,
                        "dtopbar",
                        0x018c,
                        "duhiragana",
                        0x3065,
                        "dukatakana",
                        0x30c5,
                        "dz",
                        0x01f3,
                        "dzaltone",
                        0x02a3,
                        "dzcaron",
                        0x01c6,
                        "dzcurl",
                        0x02a5,
                        "dzeabkhasiancyrillic",
                        0x04e1,
                        "dzecyrillic",
                        0x0455,
                        "dzhecyrillic",
                        0x045f,
                        "e",
                        0x0065,
                        "eacute",
                        0x00e9,
                        "earth",
                        0x2641,
                        "ebengali",
                        0x098f,
                        "ebopomofo",
                        0x311c,
                        "ebreve",
                        0x0115,
                        "ecandradeva",
                        0x090d,
                        "ecandragujarati",
                        0x0a8d,
                        "ecandravowelsigndeva",
                        0x0945,
                        "ecandravowelsigngujarati",
                        0x0ac5,
                        "ecaron",
                        0x011b,
                        "ecedillabreve",
                        0x1e1d,
                        "echarmenian",
                        0x0565,
                        "echyiwnarmenian",
                        0x0587,
                        "ecircle",
                        0x24d4,
                        "ecircumflex",
                        0x00ea,
                        "ecircumflexacute",
                        0x1ebf,
                        "ecircumflexbelow",
                        0x1e19,
                        "ecircumflexdotbelow",
                        0x1ec7,
                        "ecircumflexgrave",
                        0x1ec1,
                        "ecircumflexhookabove",
                        0x1ec3,
                        "ecircumflextilde",
                        0x1ec5,
                        "ecyrillic",
                        0x0454,
                        "edblgrave",
                        0x0205,
                        "edeva",
                        0x090f,
                        "edieresis",
                        0x00eb,
                        "edot",
                        0x0117,
                        "edotaccent",
                        0x0117,
                        "edotbelow",
                        0x1eb9,
                        "eegurmukhi",
                        0x0a0f,
                        "eematragurmukhi",
                        0x0a47,
                        "efcyrillic",
                        0x0444,
                        "egrave",
                        0x00e8,
                        "egujarati",
                        0x0a8f,
                        "eharmenian",
                        0x0567,
                        "ehbopomofo",
                        0x311d,
                        "ehiragana",
                        0x3048,
                        "ehookabove",
                        0x1ebb,
                        "eibopomofo",
                        0x311f,
                        "eight",
                        0x0038,
                        "eightarabic",
                        0x0668,
                        "eightbengali",
                        0x09ee,
                        "eightcircle",
                        0x2467,
                        "eightcircleinversesansserif",
                        0x2791,
                        "eightdeva",
                        0x096e,
                        "eighteencircle",
                        0x2471,
                        "eighteenparen",
                        0x2485,
                        "eighteenperiod",
                        0x2499,
                        "eightgujarati",
                        0x0aee,
                        "eightgurmukhi",
                        0x0a6e,
                        "eighthackarabic",
                        0x0668,
                        "eighthangzhou",
                        0x3028,
                        "eighthnotebeamed",
                        0x266b,
                        "eightideographicparen",
                        0x3227,
                        "eightinferior",
                        0x2088,
                        "eightmonospace",
                        0xff18,
                        "eightoldstyle",
                        0xf738,
                        "eightparen",
                        0x247b,
                        "eightperiod",
                        0x248f,
                        "eightpersian",
                        0x06f8,
                        "eightroman",
                        0x2177,
                        "eightsuperior",
                        0x2078,
                        "eightthai",
                        0x0e58,
                        "einvertedbreve",
                        0x0207,
                        "eiotifiedcyrillic",
                        0x0465,
                        "ekatakana",
                        0x30a8,
                        "ekatakanahalfwidth",
                        0xff74,
                        "ekonkargurmukhi",
                        0x0a74,
                        "ekorean",
                        0x3154,
                        "elcyrillic",
                        0x043b,
                        "element",
                        0x2208,
                        "elevencircle",
                        0x246a,
                        "elevenparen",
                        0x247e,
                        "elevenperiod",
                        0x2492,
                        "elevenroman",
                        0x217a,
                        "ellipsis",
                        0x2026,
                        "ellipsisvertical",
                        0x22ee,
                        "emacron",
                        0x0113,
                        "emacronacute",
                        0x1e17,
                        "emacrongrave",
                        0x1e15,
                        "emcyrillic",
                        0x043c,
                        "emdash",
                        0x2014,
                        "emdashvertical",
                        0xfe31,
                        "emonospace",
                        0xff45,
                        "emphasismarkarmenian",
                        0x055b,
                        "emptyset",
                        0x2205,
                        "enbopomofo",
                        0x3123,
                        "encyrillic",
                        0x043d,
                        "endash",
                        0x2013,
                        "endashvertical",
                        0xfe32,
                        "endescendercyrillic",
                        0x04a3,
                        "eng",
                        0x014b,
                        "engbopomofo",
                        0x3125,
                        "enghecyrillic",
                        0x04a5,
                        "enhookcyrillic",
                        0x04c8,
                        "enspace",
                        0x2002,
                        "eogonek",
                        0x0119,
                        "eokorean",
                        0x3153,
                        "eopen",
                        0x025b,
                        "eopenclosed",
                        0x029a,
                        "eopenreversed",
                        0x025c,
                        "eopenreversedclosed",
                        0x025e,
                        "eopenreversedhook",
                        0x025d,
                        "eparen",
                        0x24a0,
                        "epsilon",
                        0x03b5,
                        "epsilontonos",
                        0x03ad,
                        "equal",
                        0x003d,
                        "equalmonospace",
                        0xff1d,
                        "equalsmall",
                        0xfe66,
                        "equalsuperior",
                        0x207c,
                        "equivalence",
                        0x2261,
                        "erbopomofo",
                        0x3126,
                        "ercyrillic",
                        0x0440,
                        "ereversed",
                        0x0258,
                        "ereversedcyrillic",
                        0x044d,
                        "escyrillic",
                        0x0441,
                        "esdescendercyrillic",
                        0x04ab,
                        "esh",
                        0x0283,
                        "eshcurl",
                        0x0286,
                        "eshortdeva",
                        0x090e,
                        "eshortvowelsigndeva",
                        0x0946,
                        "eshreversedloop",
                        0x01aa,
                        "eshsquatreversed",
                        0x0285,
                        "esmallhiragana",
                        0x3047,
                        "esmallkatakana",
                        0x30a7,
                        "esmallkatakanahalfwidth",
                        0xff6a,
                        "estimated",
                        0x212e,
                        "esuperior",
                        0xf6ec,
                        "eta",
                        0x03b7,
                        "etarmenian",
                        0x0568,
                        "etatonos",
                        0x03ae,
                        "eth",
                        0x00f0,
                        "etilde",
                        0x1ebd,
                        "etildebelow",
                        0x1e1b,
                        "etnahtafoukhhebrew",
                        0x0591,
                        "etnahtafoukhlefthebrew",
                        0x0591,
                        "etnahtahebrew",
                        0x0591,
                        "etnahtalefthebrew",
                        0x0591,
                        "eturned",
                        0x01dd,
                        "eukorean",
                        0x3161,
                        "euro",
                        0x20ac,
                        "evowelsignbengali",
                        0x09c7,
                        "evowelsigndeva",
                        0x0947,
                        "evowelsigngujarati",
                        0x0ac7,
                        "exclam",
                        0x0021,
                        "exclamarmenian",
                        0x055c,
                        "exclamdbl",
                        0x203c,
                        "exclamdown",
                        0x00a1,
                        "exclamdownsmall",
                        0xf7a1,
                        "exclammonospace",
                        0xff01,
                        "exclamsmall",
                        0xf721,
                        "existential",
                        0x2203,
                        "ezh",
                        0x0292,
                        "ezhcaron",
                        0x01ef,
                        "ezhcurl",
                        0x0293,
                        "ezhreversed",
                        0x01b9,
                        "ezhtail",
                        0x01ba,
                        "f",
                        0x0066,
                        "fadeva",
                        0x095e,
                        "fagurmukhi",
                        0x0a5e,
                        "fahrenheit",
                        0x2109,
                        "fathaarabic",
                        0x064e,
                        "fathalowarabic",
                        0x064e,
                        "fathatanarabic",
                        0x064b,
                        "fbopomofo",
                        0x3108,
                        "fcircle",
                        0x24d5,
                        "fdotaccent",
                        0x1e1f,
                        "feharabic",
                        0x0641,
                        "feharmenian",
                        0x0586,
                        "fehfinalarabic",
                        0xfed2,
                        "fehinitialarabic",
                        0xfed3,
                        "fehmedialarabic",
                        0xfed4,
                        "feicoptic",
                        0x03e5,
                        "female",
                        0x2640,
                        "ff",
                        0xfb00,
                        "f_f",
                        0xfb00,
                        "ffi",
                        0xfb03,
                        "ffl",
                        0xfb04,
                        "fi",
                        0xfb01,
                        "fifteencircle",
                        0x246e,
                        "fifteenparen",
                        0x2482,
                        "fifteenperiod",
                        0x2496,
                        "figuredash",
                        0x2012,
                        "filledbox",
                        0x25a0,
                        "filledrect",
                        0x25ac,
                        "finalkaf",
                        0x05da,
                        "finalkafdagesh",
                        0xfb3a,
                        "finalkafdageshhebrew",
                        0xfb3a,
                        "finalkafhebrew",
                        0x05da,
                        "finalmem",
                        0x05dd,
                        "finalmemhebrew",
                        0x05dd,
                        "finalnun",
                        0x05df,
                        "finalnunhebrew",
                        0x05df,
                        "finalpe",
                        0x05e3,
                        "finalpehebrew",
                        0x05e3,
                        "finaltsadi",
                        0x05e5,
                        "finaltsadihebrew",
                        0x05e5,
                        "firsttonechinese",
                        0x02c9,
                        "fisheye",
                        0x25c9,
                        "fitacyrillic",
                        0x0473,
                        "five",
                        0x0035,
                        "fivearabic",
                        0x0665,
                        "fivebengali",
                        0x09eb,
                        "fivecircle",
                        0x2464,
                        "fivecircleinversesansserif",
                        0x278e,
                        "fivedeva",
                        0x096b,
                        "fiveeighths",
                        0x215d,
                        "fivegujarati",
                        0x0aeb,
                        "fivegurmukhi",
                        0x0a6b,
                        "fivehackarabic",
                        0x0665,
                        "fivehangzhou",
                        0x3025,
                        "fiveideographicparen",
                        0x3224,
                        "fiveinferior",
                        0x2085,
                        "fivemonospace",
                        0xff15,
                        "fiveoldstyle",
                        0xf735,
                        "fiveparen",
                        0x2478,
                        "fiveperiod",
                        0x248c,
                        "fivepersian",
                        0x06f5,
                        "fiveroman",
                        0x2174,
                        "fivesuperior",
                        0x2075,
                        "fivethai",
                        0x0e55,
                        "fl",
                        0xfb02,
                        "florin",
                        0x0192,
                        "fmonospace",
                        0xff46,
                        "fmsquare",
                        0x3399,
                        "fofanthai",
                        0x0e1f,
                        "fofathai",
                        0x0e1d,
                        "fongmanthai",
                        0x0e4f,
                        "forall",
                        0x2200,
                        "four",
                        0x0034,
                        "fourarabic",
                        0x0664,
                        "fourbengali",
                        0x09ea,
                        "fourcircle",
                        0x2463,
                        "fourcircleinversesansserif",
                        0x278d,
                        "fourdeva",
                        0x096a,
                        "fourgujarati",
                        0x0aea,
                        "fourgurmukhi",
                        0x0a6a,
                        "fourhackarabic",
                        0x0664,
                        "fourhangzhou",
                        0x3024,
                        "fourideographicparen",
                        0x3223,
                        "fourinferior",
                        0x2084,
                        "fourmonospace",
                        0xff14,
                        "fournumeratorbengali",
                        0x09f7,
                        "fouroldstyle",
                        0xf734,
                        "fourparen",
                        0x2477,
                        "fourperiod",
                        0x248b,
                        "fourpersian",
                        0x06f4,
                        "fourroman",
                        0x2173,
                        "foursuperior",
                        0x2074,
                        "fourteencircle",
                        0x246d,
                        "fourteenparen",
                        0x2481,
                        "fourteenperiod",
                        0x2495,
                        "fourthai",
                        0x0e54,
                        "fourthtonechinese",
                        0x02cb,
                        "fparen",
                        0x24a1,
                        "fraction",
                        0x2044,
                        "franc",
                        0x20a3,
                        "g",
                        0x0067,
                        "gabengali",
                        0x0997,
                        "gacute",
                        0x01f5,
                        "gadeva",
                        0x0917,
                        "gafarabic",
                        0x06af,
                        "gaffinalarabic",
                        0xfb93,
                        "gafinitialarabic",
                        0xfb94,
                        "gafmedialarabic",
                        0xfb95,
                        "gagujarati",
                        0x0a97,
                        "gagurmukhi",
                        0x0a17,
                        "gahiragana",
                        0x304c,
                        "gakatakana",
                        0x30ac,
                        "gamma",
                        0x03b3,
                        "gammalatinsmall",
                        0x0263,
                        "gammasuperior",
                        0x02e0,
                        "gangiacoptic",
                        0x03eb,
                        "gbopomofo",
                        0x310d,
                        "gbreve",
                        0x011f,
                        "gcaron",
                        0x01e7,
                        "gcedilla",
                        0x0123,
                        "gcircle",
                        0x24d6,
                        "gcircumflex",
                        0x011d,
                        "gcommaaccent",
                        0x0123,
                        "gdot",
                        0x0121,
                        "gdotaccent",
                        0x0121,
                        "gecyrillic",
                        0x0433,
                        "gehiragana",
                        0x3052,
                        "gekatakana",
                        0x30b2,
                        "geometricallyequal",
                        0x2251,
                        "gereshaccenthebrew",
                        0x059c,
                        "gereshhebrew",
                        0x05f3,
                        "gereshmuqdamhebrew",
                        0x059d,
                        "germandbls",
                        0x00df,
                        "gershayimaccenthebrew",
                        0x059e,
                        "gershayimhebrew",
                        0x05f4,
                        "getamark",
                        0x3013,
                        "ghabengali",
                        0x0998,
                        "ghadarmenian",
                        0x0572,
                        "ghadeva",
                        0x0918,
                        "ghagujarati",
                        0x0a98,
                        "ghagurmukhi",
                        0x0a18,
                        "ghainarabic",
                        0x063a,
                        "ghainfinalarabic",
                        0xfece,
                        "ghaininitialarabic",
                        0xfecf,
                        "ghainmedialarabic",
                        0xfed0,
                        "ghemiddlehookcyrillic",
                        0x0495,
                        "ghestrokecyrillic",
                        0x0493,
                        "gheupturncyrillic",
                        0x0491,
                        "ghhadeva",
                        0x095a,
                        "ghhagurmukhi",
                        0x0a5a,
                        "ghook",
                        0x0260,
                        "ghzsquare",
                        0x3393,
                        "gihiragana",
                        0x304e,
                        "gikatakana",
                        0x30ae,
                        "gimarmenian",
                        0x0563,
                        "gimel",
                        0x05d2,
                        "gimeldagesh",
                        0xfb32,
                        "gimeldageshhebrew",
                        0xfb32,
                        "gimelhebrew",
                        0x05d2,
                        "gjecyrillic",
                        0x0453,
                        "glottalinvertedstroke",
                        0x01be,
                        "glottalstop",
                        0x0294,
                        "glottalstopinverted",
                        0x0296,
                        "glottalstopmod",
                        0x02c0,
                        "glottalstopreversed",
                        0x0295,
                        "glottalstopreversedmod",
                        0x02c1,
                        "glottalstopreversedsuperior",
                        0x02e4,
                        "glottalstopstroke",
                        0x02a1,
                        "glottalstopstrokereversed",
                        0x02a2,
                        "gmacron",
                        0x1e21,
                        "gmonospace",
                        0xff47,
                        "gohiragana",
                        0x3054,
                        "gokatakana",
                        0x30b4,
                        "gparen",
                        0x24a2,
                        "gpasquare",
                        0x33ac,
                        "gradient",
                        0x2207,
                        "grave",
                        0x0060,
                        "gravebelowcmb",
                        0x0316,
                        "gravecmb",
                        0x0300,
                        "gravecomb",
                        0x0300,
                        "gravedeva",
                        0x0953,
                        "gravelowmod",
                        0x02ce,
                        "gravemonospace",
                        0xff40,
                        "gravetonecmb",
                        0x0340,
                        "greater",
                        0x003e,
                        "greaterequal",
                        0x2265,
                        "greaterequalorless",
                        0x22db,
                        "greatermonospace",
                        0xff1e,
                        "greaterorequivalent",
                        0x2273,
                        "greaterorless",
                        0x2277,
                        "greateroverequal",
                        0x2267,
                        "greatersmall",
                        0xfe65,
                        "gscript",
                        0x0261,
                        "gstroke",
                        0x01e5,
                        "guhiragana",
                        0x3050,
                        "guillemotleft",
                        0x00ab,
                        "guillemotright",
                        0x00bb,
                        "guilsinglleft",
                        0x2039,
                        "guilsinglright",
                        0x203a,
                        "gukatakana",
                        0x30b0,
                        "guramusquare",
                        0x3318,
                        "gysquare",
                        0x33c9,
                        "h",
                        0x0068,
                        "haabkhasiancyrillic",
                        0x04a9,
                        "haaltonearabic",
                        0x06c1,
                        "habengali",
                        0x09b9,
                        "hadescendercyrillic",
                        0x04b3,
                        "hadeva",
                        0x0939,
                        "hagujarati",
                        0x0ab9,
                        "hagurmukhi",
                        0x0a39,
                        "haharabic",
                        0x062d,
                        "hahfinalarabic",
                        0xfea2,
                        "hahinitialarabic",
                        0xfea3,
                        "hahiragana",
                        0x306f,
                        "hahmedialarabic",
                        0xfea4,
                        "haitusquare",
                        0x332a,
                        "hakatakana",
                        0x30cf,
                        "hakatakanahalfwidth",
                        0xff8a,
                        "halantgurmukhi",
                        0x0a4d,
                        "hamzaarabic",
                        0x0621,
                        "hamzalowarabic",
                        0x0621,
                        "hangulfiller",
                        0x3164,
                        "hardsigncyrillic",
                        0x044a,
                        "harpoonleftbarbup",
                        0x21bc,
                        "harpoonrightbarbup",
                        0x21c0,
                        "hasquare",
                        0x33ca,
                        "hatafpatah",
                        0x05b2,
                        "hatafpatah16",
                        0x05b2,
                        "hatafpatah23",
                        0x05b2,
                        "hatafpatah2f",
                        0x05b2,
                        "hatafpatahhebrew",
                        0x05b2,
                        "hatafpatahnarrowhebrew",
                        0x05b2,
                        "hatafpatahquarterhebrew",
                        0x05b2,
                        "hatafpatahwidehebrew",
                        0x05b2,
                        "hatafqamats",
                        0x05b3,
                        "hatafqamats1b",
                        0x05b3,
                        "hatafqamats28",
                        0x05b3,
                        "hatafqamats34",
                        0x05b3,
                        "hatafqamatshebrew",
                        0x05b3,
                        "hatafqamatsnarrowhebrew",
                        0x05b3,
                        "hatafqamatsquarterhebrew",
                        0x05b3,
                        "hatafqamatswidehebrew",
                        0x05b3,
                        "hatafsegol",
                        0x05b1,
                        "hatafsegol17",
                        0x05b1,
                        "hatafsegol24",
                        0x05b1,
                        "hatafsegol30",
                        0x05b1,
                        "hatafsegolhebrew",
                        0x05b1,
                        "hatafsegolnarrowhebrew",
                        0x05b1,
                        "hatafsegolquarterhebrew",
                        0x05b1,
                        "hatafsegolwidehebrew",
                        0x05b1,
                        "hbar",
                        0x0127,
                        "hbopomofo",
                        0x310f,
                        "hbrevebelow",
                        0x1e2b,
                        "hcedilla",
                        0x1e29,
                        "hcircle",
                        0x24d7,
                        "hcircumflex",
                        0x0125,
                        "hdieresis",
                        0x1e27,
                        "hdotaccent",
                        0x1e23,
                        "hdotbelow",
                        0x1e25,
                        "he",
                        0x05d4,
                        "heart",
                        0x2665,
                        "heartsuitblack",
                        0x2665,
                        "heartsuitwhite",
                        0x2661,
                        "hedagesh",
                        0xfb34,
                        "hedageshhebrew",
                        0xfb34,
                        "hehaltonearabic",
                        0x06c1,
                        "heharabic",
                        0x0647,
                        "hehebrew",
                        0x05d4,
                        "hehfinalaltonearabic",
                        0xfba7,
                        "hehfinalalttwoarabic",
                        0xfeea,
                        "hehfinalarabic",
                        0xfeea,
                        "hehhamzaabovefinalarabic",
                        0xfba5,
                        "hehhamzaaboveisolatedarabic",
                        0xfba4,
                        "hehinitialaltonearabic",
                        0xfba8,
                        "hehinitialarabic",
                        0xfeeb,
                        "hehiragana",
                        0x3078,
                        "hehmedialaltonearabic",
                        0xfba9,
                        "hehmedialarabic",
                        0xfeec,
                        "heiseierasquare",
                        0x337b,
                        "hekatakana",
                        0x30d8,
                        "hekatakanahalfwidth",
                        0xff8d,
                        "hekutaarusquare",
                        0x3336,
                        "henghook",
                        0x0267,
                        "herutusquare",
                        0x3339,
                        "het",
                        0x05d7,
                        "hethebrew",
                        0x05d7,
                        "hhook",
                        0x0266,
                        "hhooksuperior",
                        0x02b1,
                        "hieuhacirclekorean",
                        0x327b,
                        "hieuhaparenkorean",
                        0x321b,
                        "hieuhcirclekorean",
                        0x326d,
                        "hieuhkorean",
                        0x314e,
                        "hieuhparenkorean",
                        0x320d,
                        "hihiragana",
                        0x3072,
                        "hikatakana",
                        0x30d2,
                        "hikatakanahalfwidth",
                        0xff8b,
                        "hiriq",
                        0x05b4,
                        "hiriq14",
                        0x05b4,
                        "hiriq21",
                        0x05b4,
                        "hiriq2d",
                        0x05b4,
                        "hiriqhebrew",
                        0x05b4,
                        "hiriqnarrowhebrew",
                        0x05b4,
                        "hiriqquarterhebrew",
                        0x05b4,
                        "hiriqwidehebrew",
                        0x05b4,
                        "hlinebelow",
                        0x1e96,
                        "hmonospace",
                        0xff48,
                        "hoarmenian",
                        0x0570,
                        "hohipthai",
                        0x0e2b,
                        "hohiragana",
                        0x307b,
                        "hokatakana",
                        0x30db,
                        "hokatakanahalfwidth",
                        0xff8e,
                        "holam",
                        0x05b9,
                        "holam19",
                        0x05b9,
                        "holam26",
                        0x05b9,
                        "holam32",
                        0x05b9,
                        "holamhebrew",
                        0x05b9,
                        "holamnarrowhebrew",
                        0x05b9,
                        "holamquarterhebrew",
                        0x05b9,
                        "holamwidehebrew",
                        0x05b9,
                        "honokhukthai",
                        0x0e2e,
                        "hookabovecomb",
                        0x0309,
                        "hookcmb",
                        0x0309,
                        "hookpalatalizedbelowcmb",
                        0x0321,
                        "hookretroflexbelowcmb",
                        0x0322,
                        "hoonsquare",
                        0x3342,
                        "horicoptic",
                        0x03e9,
                        "horizontalbar",
                        0x2015,
                        "horncmb",
                        0x031b,
                        "hotsprings",
                        0x2668,
                        "house",
                        0x2302,
                        "hparen",
                        0x24a3,
                        "hsuperior",
                        0x02b0,
                        "hturned",
                        0x0265,
                        "huhiragana",
                        0x3075,
                        "huiitosquare",
                        0x3333,
                        "hukatakana",
                        0x30d5,
                        "hukatakanahalfwidth",
                        0xff8c,
                        "hungarumlaut",
                        0x02dd,
                        "hungarumlautcmb",
                        0x030b,
                        "hv",
                        0x0195,
                        "hyphen",
                        0x002d,
                        "hypheninferior",
                        0xf6e5,
                        "hyphenmonospace",
                        0xff0d,
                        "hyphensmall",
                        0xfe63,
                        "hyphensuperior",
                        0xf6e6,
                        "hyphentwo",
                        0x2010,
                        "i",
                        0x0069,
                        "iacute",
                        0x00ed,
                        "iacyrillic",
                        0x044f,
                        "ibengali",
                        0x0987,
                        "ibopomofo",
                        0x3127,
                        "ibreve",
                        0x012d,
                        "icaron",
                        0x01d0,
                        "icircle",
                        0x24d8,
                        "icircumflex",
                        0x00ee,
                        "icyrillic",
                        0x0456,
                        "idblgrave",
                        0x0209,
                        "ideographearthcircle",
                        0x328f,
                        "ideographfirecircle",
                        0x328b,
                        "ideographicallianceparen",
                        0x323f,
                        "ideographiccallparen",
                        0x323a,
                        "ideographiccentrecircle",
                        0x32a5,
                        "ideographicclose",
                        0x3006,
                        "ideographiccomma",
                        0x3001,
                        "ideographiccommaleft",
                        0xff64,
                        "ideographiccongratulationparen",
                        0x3237,
                        "ideographiccorrectcircle",
                        0x32a3,
                        "ideographicearthparen",
                        0x322f,
                        "ideographicenterpriseparen",
                        0x323d,
                        "ideographicexcellentcircle",
                        0x329d,
                        "ideographicfestivalparen",
                        0x3240,
                        "ideographicfinancialcircle",
                        0x3296,
                        "ideographicfinancialparen",
                        0x3236,
                        "ideographicfireparen",
                        0x322b,
                        "ideographichaveparen",
                        0x3232,
                        "ideographichighcircle",
                        0x32a4,
                        "ideographiciterationmark",
                        0x3005,
                        "ideographiclaborcircle",
                        0x3298,
                        "ideographiclaborparen",
                        0x3238,
                        "ideographicleftcircle",
                        0x32a7,
                        "ideographiclowcircle",
                        0x32a6,
                        "ideographicmedicinecircle",
                        0x32a9,
                        "ideographicmetalparen",
                        0x322e,
                        "ideographicmoonparen",
                        0x322a,
                        "ideographicnameparen",
                        0x3234,
                        "ideographicperiod",
                        0x3002,
                        "ideographicprintcircle",
                        0x329e,
                        "ideographicreachparen",
                        0x3243,
                        "ideographicrepresentparen",
                        0x3239,
                        "ideographicresourceparen",
                        0x323e,
                        "ideographicrightcircle",
                        0x32a8,
                        "ideographicsecretcircle",
                        0x3299,
                        "ideographicselfparen",
                        0x3242,
                        "ideographicsocietyparen",
                        0x3233,
                        "ideographicspace",
                        0x3000,
                        "ideographicspecialparen",
                        0x3235,
                        "ideographicstockparen",
                        0x3231,
                        "ideographicstudyparen",
                        0x323b,
                        "ideographicsunparen",
                        0x3230,
                        "ideographicsuperviseparen",
                        0x323c,
                        "ideographicwaterparen",
                        0x322c,
                        "ideographicwoodparen",
                        0x322d,
                        "ideographiczero",
                        0x3007,
                        "ideographmetalcircle",
                        0x328e,
                        "ideographmooncircle",
                        0x328a,
                        "ideographnamecircle",
                        0x3294,
                        "ideographsuncircle",
                        0x3290,
                        "ideographwatercircle",
                        0x328c,
                        "ideographwoodcircle",
                        0x328d,
                        "ideva",
                        0x0907,
                        "idieresis",
                        0x00ef,
                        "idieresisacute",
                        0x1e2f,
                        "idieresiscyrillic",
                        0x04e5,
                        "idotbelow",
                        0x1ecb,
                        "iebrevecyrillic",
                        0x04d7,
                        "iecyrillic",
                        0x0435,
                        "ieungacirclekorean",
                        0x3275,
                        "ieungaparenkorean",
                        0x3215,
                        "ieungcirclekorean",
                        0x3267,
                        "ieungkorean",
                        0x3147,
                        "ieungparenkorean",
                        0x3207,
                        "igrave",
                        0x00ec,
                        "igujarati",
                        0x0a87,
                        "igurmukhi",
                        0x0a07,
                        "ihiragana",
                        0x3044,
                        "ihookabove",
                        0x1ec9,
                        "iibengali",
                        0x0988,
                        "iicyrillic",
                        0x0438,
                        "iideva",
                        0x0908,
                        "iigujarati",
                        0x0a88,
                        "iigurmukhi",
                        0x0a08,
                        "iimatragurmukhi",
                        0x0a40,
                        "iinvertedbreve",
                        0x020b,
                        "iishortcyrillic",
                        0x0439,
                        "iivowelsignbengali",
                        0x09c0,
                        "iivowelsigndeva",
                        0x0940,
                        "iivowelsigngujarati",
                        0x0ac0,
                        "ij",
                        0x0133,
                        "ikatakana",
                        0x30a4,
                        "ikatakanahalfwidth",
                        0xff72,
                        "ikorean",
                        0x3163,
                        "ilde",
                        0x02dc,
                        "iluyhebrew",
                        0x05ac,
                        "imacron",
                        0x012b,
                        "imacroncyrillic",
                        0x04e3,
                        "imageorapproximatelyequal",
                        0x2253,
                        "imatragurmukhi",
                        0x0a3f,
                        "imonospace",
                        0xff49,
                        "increment",
                        0x2206,
                        "infinity",
                        0x221e,
                        "iniarmenian",
                        0x056b,
                        "integral",
                        0x222b,
                        "integralbottom",
                        0x2321,
                        "integralbt",
                        0x2321,
                        "integralex",
                        0xf8f5,
                        "integraltop",
                        0x2320,
                        "integraltp",
                        0x2320,
                        "intersection",
                        0x2229,
                        "intisquare",
                        0x3305,
                        "invbullet",
                        0x25d8,
                        "invcircle",
                        0x25d9,
                        "invsmileface",
                        0x263b,
                        "iocyrillic",
                        0x0451,
                        "iogonek",
                        0x012f,
                        "iota",
                        0x03b9,
                        "iotadieresis",
                        0x03ca,
                        "iotadieresistonos",
                        0x0390,
                        "iotalatin",
                        0x0269,
                        "iotatonos",
                        0x03af,
                        "iparen",
                        0x24a4,
                        "irigurmukhi",
                        0x0a72,
                        "ismallhiragana",
                        0x3043,
                        "ismallkatakana",
                        0x30a3,
                        "ismallkatakanahalfwidth",
                        0xff68,
                        "issharbengali",
                        0x09fa,
                        "istroke",
                        0x0268,
                        "isuperior",
                        0xf6ed,
                        "iterationhiragana",
                        0x309d,
                        "iterationkatakana",
                        0x30fd,
                        "itilde",
                        0x0129,
                        "itildebelow",
                        0x1e2d,
                        "iubopomofo",
                        0x3129,
                        "iucyrillic",
                        0x044e,
                        "ivowelsignbengali",
                        0x09bf,
                        "ivowelsigndeva",
                        0x093f,
                        "ivowelsigngujarati",
                        0x0abf,
                        "izhitsacyrillic",
                        0x0475,
                        "izhitsadblgravecyrillic",
                        0x0477,
                        "j",
                        0x006a,
                        "jaarmenian",
                        0x0571,
                        "jabengali",
                        0x099c,
                        "jadeva",
                        0x091c,
                        "jagujarati",
                        0x0a9c,
                        "jagurmukhi",
                        0x0a1c,
                        "jbopomofo",
                        0x3110,
                        "jcaron",
                        0x01f0,
                        "jcircle",
                        0x24d9,
                        "jcircumflex",
                        0x0135,
                        "jcrossedtail",
                        0x029d,
                        "jdotlessstroke",
                        0x025f,
                        "jecyrillic",
                        0x0458,
                        "jeemarabic",
                        0x062c,
                        "jeemfinalarabic",
                        0xfe9e,
                        "jeeminitialarabic",
                        0xfe9f,
                        "jeemmedialarabic",
                        0xfea0,
                        "jeharabic",
                        0x0698,
                        "jehfinalarabic",
                        0xfb8b,
                        "jhabengali",
                        0x099d,
                        "jhadeva",
                        0x091d,
                        "jhagujarati",
                        0x0a9d,
                        "jhagurmukhi",
                        0x0a1d,
                        "jheharmenian",
                        0x057b,
                        "jis",
                        0x3004,
                        "jmonospace",
                        0xff4a,
                        "jparen",
                        0x24a5,
                        "jsuperior",
                        0x02b2,
                        "k",
                        0x006b,
                        "kabashkircyrillic",
                        0x04a1,
                        "kabengali",
                        0x0995,
                        "kacute",
                        0x1e31,
                        "kacyrillic",
                        0x043a,
                        "kadescendercyrillic",
                        0x049b,
                        "kadeva",
                        0x0915,
                        "kaf",
                        0x05db,
                        "kafarabic",
                        0x0643,
                        "kafdagesh",
                        0xfb3b,
                        "kafdageshhebrew",
                        0xfb3b,
                        "kaffinalarabic",
                        0xfeda,
                        "kafhebrew",
                        0x05db,
                        "kafinitialarabic",
                        0xfedb,
                        "kafmedialarabic",
                        0xfedc,
                        "kafrafehebrew",
                        0xfb4d,
                        "kagujarati",
                        0x0a95,
                        "kagurmukhi",
                        0x0a15,
                        "kahiragana",
                        0x304b,
                        "kahookcyrillic",
                        0x04c4,
                        "kakatakana",
                        0x30ab,
                        "kakatakanahalfwidth",
                        0xff76,
                        "kappa",
                        0x03ba,
                        "kappasymbolgreek",
                        0x03f0,
                        "kapyeounmieumkorean",
                        0x3171,
                        "kapyeounphieuphkorean",
                        0x3184,
                        "kapyeounpieupkorean",
                        0x3178,
                        "kapyeounssangpieupkorean",
                        0x3179,
                        "karoriisquare",
                        0x330d,
                        "kashidaautoarabic",
                        0x0640,
                        "kashidaautonosidebearingarabic",
                        0x0640,
                        "kasmallkatakana",
                        0x30f5,
                        "kasquare",
                        0x3384,
                        "kasraarabic",
                        0x0650,
                        "kasratanarabic",
                        0x064d,
                        "kastrokecyrillic",
                        0x049f,
                        "katahiraprolongmarkhalfwidth",
                        0xff70,
                        "kaverticalstrokecyrillic",
                        0x049d,
                        "kbopomofo",
                        0x310e,
                        "kcalsquare",
                        0x3389,
                        "kcaron",
                        0x01e9,
                        "kcedilla",
                        0x0137,
                        "kcircle",
                        0x24da,
                        "kcommaaccent",
                        0x0137,
                        "kdotbelow",
                        0x1e33,
                        "keharmenian",
                        0x0584,
                        "kehiragana",
                        0x3051,
                        "kekatakana",
                        0x30b1,
                        "kekatakanahalfwidth",
                        0xff79,
                        "kenarmenian",
                        0x056f,
                        "kesmallkatakana",
                        0x30f6,
                        "kgreenlandic",
                        0x0138,
                        "khabengali",
                        0x0996,
                        "khacyrillic",
                        0x0445,
                        "khadeva",
                        0x0916,
                        "khagujarati",
                        0x0a96,
                        "khagurmukhi",
                        0x0a16,
                        "khaharabic",
                        0x062e,
                        "khahfinalarabic",
                        0xfea6,
                        "khahinitialarabic",
                        0xfea7,
                        "khahmedialarabic",
                        0xfea8,
                        "kheicoptic",
                        0x03e7,
                        "khhadeva",
                        0x0959,
                        "khhagurmukhi",
                        0x0a59,
                        "khieukhacirclekorean",
                        0x3278,
                        "khieukhaparenkorean",
                        0x3218,
                        "khieukhcirclekorean",
                        0x326a,
                        "khieukhkorean",
                        0x314b,
                        "khieukhparenkorean",
                        0x320a,
                        "khokhaithai",
                        0x0e02,
                        "khokhonthai",
                        0x0e05,
                        "khokhuatthai",
                        0x0e03,
                        "khokhwaithai",
                        0x0e04,
                        "khomutthai",
                        0x0e5b,
                        "khook",
                        0x0199,
                        "khorakhangthai",
                        0x0e06,
                        "khzsquare",
                        0x3391,
                        "kihiragana",
                        0x304d,
                        "kikatakana",
                        0x30ad,
                        "kikatakanahalfwidth",
                        0xff77,
                        "kiroguramusquare",
                        0x3315,
                        "kiromeetorusquare",
                        0x3316,
                        "kirosquare",
                        0x3314,
                        "kiyeokacirclekorean",
                        0x326e,
                        "kiyeokaparenkorean",
                        0x320e,
                        "kiyeokcirclekorean",
                        0x3260,
                        "kiyeokkorean",
                        0x3131,
                        "kiyeokparenkorean",
                        0x3200,
                        "kiyeoksioskorean",
                        0x3133,
                        "kjecyrillic",
                        0x045c,
                        "klinebelow",
                        0x1e35,
                        "klsquare",
                        0x3398,
                        "kmcubedsquare",
                        0x33a6,
                        "kmonospace",
                        0xff4b,
                        "kmsquaredsquare",
                        0x33a2,
                        "kohiragana",
                        0x3053,
                        "kohmsquare",
                        0x33c0,
                        "kokaithai",
                        0x0e01,
                        "kokatakana",
                        0x30b3,
                        "kokatakanahalfwidth",
                        0xff7a,
                        "kooposquare",
                        0x331e,
                        "koppacyrillic",
                        0x0481,
                        "koreanstandardsymbol",
                        0x327f,
                        "koroniscmb",
                        0x0343,
                        "kparen",
                        0x24a6,
                        "kpasquare",
                        0x33aa,
                        "ksicyrillic",
                        0x046f,
                        "ktsquare",
                        0x33cf,
                        "kturned",
                        0x029e,
                        "kuhiragana",
                        0x304f,
                        "kukatakana",
                        0x30af,
                        "kukatakanahalfwidth",
                        0xff78,
                        "kvsquare",
                        0x33b8,
                        "kwsquare",
                        0x33be,
                        "l",
                        0x006c,
                        "labengali",
                        0x09b2,
                        "lacute",
                        0x013a,
                        "ladeva",
                        0x0932,
                        "lagujarati",
                        0x0ab2,
                        "lagurmukhi",
                        0x0a32,
                        "lakkhangyaothai",
                        0x0e45,
                        "lamaleffinalarabic",
                        0xfefc,
                        "lamalefhamzaabovefinalarabic",
                        0xfef8,
                        "lamalefhamzaaboveisolatedarabic",
                        0xfef7,
                        "lamalefhamzabelowfinalarabic",
                        0xfefa,
                        "lamalefhamzabelowisolatedarabic",
                        0xfef9,
                        "lamalefisolatedarabic",
                        0xfefb,
                        "lamalefmaddaabovefinalarabic",
                        0xfef6,
                        "lamalefmaddaaboveisolatedarabic",
                        0xfef5,
                        "lamarabic",
                        0x0644,
                        "lambda",
                        0x03bb,
                        "lambdastroke",
                        0x019b,
                        "lamed",
                        0x05dc,
                        "lameddagesh",
                        0xfb3c,
                        "lameddageshhebrew",
                        0xfb3c,
                        "lamedhebrew",
                        0x05dc,
                        "lamfinalarabic",
                        0xfede,
                        "lamhahinitialarabic",
                        0xfcca,
                        "laminitialarabic",
                        0xfedf,
                        "lamjeeminitialarabic",
                        0xfcc9,
                        "lamkhahinitialarabic",
                        0xfccb,
                        "lamlamhehisolatedarabic",
                        0xfdf2,
                        "lammedialarabic",
                        0xfee0,
                        "lammeemhahinitialarabic",
                        0xfd88,
                        "lammeeminitialarabic",
                        0xfccc,
                        "largecircle",
                        0x25ef,
                        "lbar",
                        0x019a,
                        "lbelt",
                        0x026c,
                        "lbopomofo",
                        0x310c,
                        "lcaron",
                        0x013e,
                        "lcedilla",
                        0x013c,
                        "lcircle",
                        0x24db,
                        "lcircumflexbelow",
                        0x1e3d,
                        "lcommaaccent",
                        0x013c,
                        "ldot",
                        0x0140,
                        "ldotaccent",
                        0x0140,
                        "ldotbelow",
                        0x1e37,
                        "ldotbelowmacron",
                        0x1e39,
                        "leftangleabovecmb",
                        0x031a,
                        "lefttackbelowcmb",
                        0x0318,
                        "less",
                        0x003c,
                        "lessequal",
                        0x2264,
                        "lessequalorgreater",
                        0x22da,
                        "lessmonospace",
                        0xff1c,
                        "lessorequivalent",
                        0x2272,
                        "lessorgreater",
                        0x2276,
                        "lessoverequal",
                        0x2266,
                        "lesssmall",
                        0xfe64,
                        "lezh",
                        0x026e,
                        "lfblock",
                        0x258c,
                        "lhookretroflex",
                        0x026d,
                        "lira",
                        0x20a4,
                        "liwnarmenian",
                        0x056c,
                        "lj",
                        0x01c9,
                        "ljecyrillic",
                        0x0459,
                        "ll",
                        0xf6c0,
                        "lladeva",
                        0x0933,
                        "llagujarati",
                        0x0ab3,
                        "llinebelow",
                        0x1e3b,
                        "llladeva",
                        0x0934,
                        "llvocalicbengali",
                        0x09e1,
                        "llvocalicdeva",
                        0x0961,
                        "llvocalicvowelsignbengali",
                        0x09e3,
                        "llvocalicvowelsigndeva",
                        0x0963,
                        "lmiddletilde",
                        0x026b,
                        "lmonospace",
                        0xff4c,
                        "lmsquare",
                        0x33d0,
                        "lochulathai",
                        0x0e2c,
                        "logicaland",
                        0x2227,
                        "logicalnot",
                        0x00ac,
                        "logicalnotreversed",
                        0x2310,
                        "logicalor",
                        0x2228,
                        "lolingthai",
                        0x0e25,
                        "longs",
                        0x017f,
                        "lowlinecenterline",
                        0xfe4e,
                        "lowlinecmb",
                        0x0332,
                        "lowlinedashed",
                        0xfe4d,
                        "lozenge",
                        0x25ca,
                        "lparen",
                        0x24a7,
                        "lslash",
                        0x0142,
                        "lsquare",
                        0x2113,
                        "lsuperior",
                        0xf6ee,
                        "ltshade",
                        0x2591,
                        "luthai",
                        0x0e26,
                        "lvocalicbengali",
                        0x098c,
                        "lvocalicdeva",
                        0x090c,
                        "lvocalicvowelsignbengali",
                        0x09e2,
                        "lvocalicvowelsigndeva",
                        0x0962,
                        "lxsquare",
                        0x33d3,
                        "m",
                        0x006d,
                        "mabengali",
                        0x09ae,
                        "macron",
                        0x00af,
                        "macronbelowcmb",
                        0x0331,
                        "macroncmb",
                        0x0304,
                        "macronlowmod",
                        0x02cd,
                        "macronmonospace",
                        0xffe3,
                        "macute",
                        0x1e3f,
                        "madeva",
                        0x092e,
                        "magujarati",
                        0x0aae,
                        "magurmukhi",
                        0x0a2e,
                        "mahapakhhebrew",
                        0x05a4,
                        "mahapakhlefthebrew",
                        0x05a4,
                        "mahiragana",
                        0x307e,
                        "maichattawalowleftthai",
                        0xf895,
                        "maichattawalowrightthai",
                        0xf894,
                        "maichattawathai",
                        0x0e4b,
                        "maichattawaupperleftthai",
                        0xf893,
                        "maieklowleftthai",
                        0xf88c,
                        "maieklowrightthai",
                        0xf88b,
                        "maiekthai",
                        0x0e48,
                        "maiekupperleftthai",
                        0xf88a,
                        "maihanakatleftthai",
                        0xf884,
                        "maihanakatthai",
                        0x0e31,
                        "maitaikhuleftthai",
                        0xf889,
                        "maitaikhuthai",
                        0x0e47,
                        "maitholowleftthai",
                        0xf88f,
                        "maitholowrightthai",
                        0xf88e,
                        "maithothai",
                        0x0e49,
                        "maithoupperleftthai",
                        0xf88d,
                        "maitrilowleftthai",
                        0xf892,
                        "maitrilowrightthai",
                        0xf891,
                        "maitrithai",
                        0x0e4a,
                        "maitriupperleftthai",
                        0xf890,
                        "maiyamokthai",
                        0x0e46,
                        "makatakana",
                        0x30de,
                        "makatakanahalfwidth",
                        0xff8f,
                        "male",
                        0x2642,
                        "mansyonsquare",
                        0x3347,
                        "maqafhebrew",
                        0x05be,
                        "mars",
                        0x2642,
                        "masoracirclehebrew",
                        0x05af,
                        "masquare",
                        0x3383,
                        "mbopomofo",
                        0x3107,
                        "mbsquare",
                        0x33d4,
                        "mcircle",
                        0x24dc,
                        "mcubedsquare",
                        0x33a5,
                        "mdotaccent",
                        0x1e41,
                        "mdotbelow",
                        0x1e43,
                        "meemarabic",
                        0x0645,
                        "meemfinalarabic",
                        0xfee2,
                        "meeminitialarabic",
                        0xfee3,
                        "meemmedialarabic",
                        0xfee4,
                        "meemmeeminitialarabic",
                        0xfcd1,
                        "meemmeemisolatedarabic",
                        0xfc48,
                        "meetorusquare",
                        0x334d,
                        "mehiragana",
                        0x3081,
                        "meizierasquare",
                        0x337e,
                        "mekatakana",
                        0x30e1,
                        "mekatakanahalfwidth",
                        0xff92,
                        "mem",
                        0x05de,
                        "memdagesh",
                        0xfb3e,
                        "memdageshhebrew",
                        0xfb3e,
                        "memhebrew",
                        0x05de,
                        "menarmenian",
                        0x0574,
                        "merkhahebrew",
                        0x05a5,
                        "merkhakefulahebrew",
                        0x05a6,
                        "merkhakefulalefthebrew",
                        0x05a6,
                        "merkhalefthebrew",
                        0x05a5,
                        "mhook",
                        0x0271,
                        "mhzsquare",
                        0x3392,
                        "middledotkatakanahalfwidth",
                        0xff65,
                        "middot",
                        0x00b7,
                        "mieumacirclekorean",
                        0x3272,
                        "mieumaparenkorean",
                        0x3212,
                        "mieumcirclekorean",
                        0x3264,
                        "mieumkorean",
                        0x3141,
                        "mieumpansioskorean",
                        0x3170,
                        "mieumparenkorean",
                        0x3204,
                        "mieumpieupkorean",
                        0x316e,
                        "mieumsioskorean",
                        0x316f,
                        "mihiragana",
                        0x307f,
                        "mikatakana",
                        0x30df,
                        "mikatakanahalfwidth",
                        0xff90,
                        "minus",
                        0x2212,
                        "minusbelowcmb",
                        0x0320,
                        "minuscircle",
                        0x2296,
                        "minusmod",
                        0x02d7,
                        "minusplus",
                        0x2213,
                        "minute",
                        0x2032,
                        "miribaarusquare",
                        0x334a,
                        "mirisquare",
                        0x3349,
                        "mlonglegturned",
                        0x0270,
                        "mlsquare",
                        0x3396,
                        "mmcubedsquare",
                        0x33a3,
                        "mmonospace",
                        0xff4d,
                        "mmsquaredsquare",
                        0x339f,
                        "mohiragana",
                        0x3082,
                        "mohmsquare",
                        0x33c1,
                        "mokatakana",
                        0x30e2,
                        "mokatakanahalfwidth",
                        0xff93,
                        "molsquare",
                        0x33d6,
                        "momathai",
                        0x0e21,
                        "moverssquare",
                        0x33a7,
                        "moverssquaredsquare",
                        0x33a8,
                        "mparen",
                        0x24a8,
                        "mpasquare",
                        0x33ab,
                        "mssquare",
                        0x33b3,
                        "msuperior",
                        0xf6ef,
                        "mturned",
                        0x026f,
                        "mu",
                        0x00b5,
                        "mu1",
                        0x00b5,
                        "muasquare",
                        0x3382,
                        "muchgreater",
                        0x226b,
                        "muchless",
                        0x226a,
                        "mufsquare",
                        0x338c,
                        "mugreek",
                        0x03bc,
                        "mugsquare",
                        0x338d,
                        "muhiragana",
                        0x3080,
                        "mukatakana",
                        0x30e0,
                        "mukatakanahalfwidth",
                        0xff91,
                        "mulsquare",
                        0x3395,
                        "multiply",
                        0x00d7,
                        "mumsquare",
                        0x339b,
                        "munahhebrew",
                        0x05a3,
                        "munahlefthebrew",
                        0x05a3,
                        "musicalnote",
                        0x266a,
                        "musicalnotedbl",
                        0x266b,
                        "musicflatsign",
                        0x266d,
                        "musicsharpsign",
                        0x266f,
                        "mussquare",
                        0x33b2,
                        "muvsquare",
                        0x33b6,
                        "muwsquare",
                        0x33bc,
                        "mvmegasquare",
                        0x33b9,
                        "mvsquare",
                        0x33b7,
                        "mwmegasquare",
                        0x33bf,
                        "mwsquare",
                        0x33bd,
                        "n",
                        0x006e,
                        "nabengali",
                        0x09a8,
                        "nabla",
                        0x2207,
                        "nacute",
                        0x0144,
                        "nadeva",
                        0x0928,
                        "nagujarati",
                        0x0aa8,
                        "nagurmukhi",
                        0x0a28,
                        "nahiragana",
                        0x306a,
                        "nakatakana",
                        0x30ca,
                        "nakatakanahalfwidth",
                        0xff85,
                        "napostrophe",
                        0x0149,
                        "nasquare",
                        0x3381,
                        "nbopomofo",
                        0x310b,
                        "nbspace",
                        0x00a0,
                        "ncaron",
                        0x0148,
                        "ncedilla",
                        0x0146,
                        "ncircle",
                        0x24dd,
                        "ncircumflexbelow",
                        0x1e4b,
                        "ncommaaccent",
                        0x0146,
                        "ndotaccent",
                        0x1e45,
                        "ndotbelow",
                        0x1e47,
                        "nehiragana",
                        0x306d,
                        "nekatakana",
                        0x30cd,
                        "nekatakanahalfwidth",
                        0xff88,
                        "newsheqelsign",
                        0x20aa,
                        "nfsquare",
                        0x338b,
                        "ngabengali",
                        0x0999,
                        "ngadeva",
                        0x0919,
                        "ngagujarati",
                        0x0a99,
                        "ngagurmukhi",
                        0x0a19,
                        "ngonguthai",
                        0x0e07,
                        "nhiragana",
                        0x3093,
                        "nhookleft",
                        0x0272,
                        "nhookretroflex",
                        0x0273,
                        "nieunacirclekorean",
                        0x326f,
                        "nieunaparenkorean",
                        0x320f,
                        "nieuncieuckorean",
                        0x3135,
                        "nieuncirclekorean",
                        0x3261,
                        "nieunhieuhkorean",
                        0x3136,
                        "nieunkorean",
                        0x3134,
                        "nieunpansioskorean",
                        0x3168,
                        "nieunparenkorean",
                        0x3201,
                        "nieunsioskorean",
                        0x3167,
                        "nieuntikeutkorean",
                        0x3166,
                        "nihiragana",
                        0x306b,
                        "nikatakana",
                        0x30cb,
                        "nikatakanahalfwidth",
                        0xff86,
                        "nikhahitleftthai",
                        0xf899,
                        "nikhahitthai",
                        0x0e4d,
                        "nine",
                        0x0039,
                        "ninearabic",
                        0x0669,
                        "ninebengali",
                        0x09ef,
                        "ninecircle",
                        0x2468,
                        "ninecircleinversesansserif",
                        0x2792,
                        "ninedeva",
                        0x096f,
                        "ninegujarati",
                        0x0aef,
                        "ninegurmukhi",
                        0x0a6f,
                        "ninehackarabic",
                        0x0669,
                        "ninehangzhou",
                        0x3029,
                        "nineideographicparen",
                        0x3228,
                        "nineinferior",
                        0x2089,
                        "ninemonospace",
                        0xff19,
                        "nineoldstyle",
                        0xf739,
                        "nineparen",
                        0x247c,
                        "nineperiod",
                        0x2490,
                        "ninepersian",
                        0x06f9,
                        "nineroman",
                        0x2178,
                        "ninesuperior",
                        0x2079,
                        "nineteencircle",
                        0x2472,
                        "nineteenparen",
                        0x2486,
                        "nineteenperiod",
                        0x249a,
                        "ninethai",
                        0x0e59,
                        "nj",
                        0x01cc,
                        "njecyrillic",
                        0x045a,
                        "nkatakana",
                        0x30f3,
                        "nkatakanahalfwidth",
                        0xff9d,
                        "nlegrightlong",
                        0x019e,
                        "nlinebelow",
                        0x1e49,
                        "nmonospace",
                        0xff4e,
                        "nmsquare",
                        0x339a,
                        "nnabengali",
                        0x09a3,
                        "nnadeva",
                        0x0923,
                        "nnagujarati",
                        0x0aa3,
                        "nnagurmukhi",
                        0x0a23,
                        "nnnadeva",
                        0x0929,
                        "nohiragana",
                        0x306e,
                        "nokatakana",
                        0x30ce,
                        "nokatakanahalfwidth",
                        0xff89,
                        "nonbreakingspace",
                        0x00a0,
                        "nonenthai",
                        0x0e13,
                        "nonuthai",
                        0x0e19,
                        "noonarabic",
                        0x0646,
                        "noonfinalarabic",
                        0xfee6,
                        "noonghunnaarabic",
                        0x06ba,
                        "noonghunnafinalarabic",
                        0xfb9f,
                        "nooninitialarabic",
                        0xfee7,
                        "noonjeeminitialarabic",
                        0xfcd2,
                        "noonjeemisolatedarabic",
                        0xfc4b,
                        "noonmedialarabic",
                        0xfee8,
                        "noonmeeminitialarabic",
                        0xfcd5,
                        "noonmeemisolatedarabic",
                        0xfc4e,
                        "noonnoonfinalarabic",
                        0xfc8d,
                        "notcontains",
                        0x220c,
                        "notelement",
                        0x2209,
                        "notelementof",
                        0x2209,
                        "notequal",
                        0x2260,
                        "notgreater",
                        0x226f,
                        "notgreaternorequal",
                        0x2271,
                        "notgreaternorless",
                        0x2279,
                        "notidentical",
                        0x2262,
                        "notless",
                        0x226e,
                        "notlessnorequal",
                        0x2270,
                        "notparallel",
                        0x2226,
                        "notprecedes",
                        0x2280,
                        "notsubset",
                        0x2284,
                        "notsucceeds",
                        0x2281,
                        "notsuperset",
                        0x2285,
                        "nowarmenian",
                        0x0576,
                        "nparen",
                        0x24a9,
                        "nssquare",
                        0x33b1,
                        "nsuperior",
                        0x207f,
                        "ntilde",
                        0x00f1,
                        "nu",
                        0x03bd,
                        "nuhiragana",
                        0x306c,
                        "nukatakana",
                        0x30cc,
                        "nukatakanahalfwidth",
                        0xff87,
                        "nuktabengali",
                        0x09bc,
                        "nuktadeva",
                        0x093c,
                        "nuktagujarati",
                        0x0abc,
                        "nuktagurmukhi",
                        0x0a3c,
                        "numbersign",
                        0x0023,
                        "numbersignmonospace",
                        0xff03,
                        "numbersignsmall",
                        0xfe5f,
                        "numeralsigngreek",
                        0x0374,
                        "numeralsignlowergreek",
                        0x0375,
                        "numero",
                        0x2116,
                        "nun",
                        0x05e0,
                        "nundagesh",
                        0xfb40,
                        "nundageshhebrew",
                        0xfb40,
                        "nunhebrew",
                        0x05e0,
                        "nvsquare",
                        0x33b5,
                        "nwsquare",
                        0x33bb,
                        "nyabengali",
                        0x099e,
                        "nyadeva",
                        0x091e,
                        "nyagujarati",
                        0x0a9e,
                        "nyagurmukhi",
                        0x0a1e,
                        "o",
                        0x006f,
                        "oacute",
                        0x00f3,
                        "oangthai",
                        0x0e2d,
                        "obarred",
                        0x0275,
                        "obarredcyrillic",
                        0x04e9,
                        "obarreddieresiscyrillic",
                        0x04eb,
                        "obengali",
                        0x0993,
                        "obopomofo",
                        0x311b,
                        "obreve",
                        0x014f,
                        "ocandradeva",
                        0x0911,
                        "ocandragujarati",
                        0x0a91,
                        "ocandravowelsigndeva",
                        0x0949,
                        "ocandravowelsigngujarati",
                        0x0ac9,
                        "ocaron",
                        0x01d2,
                        "ocircle",
                        0x24de,
                        "ocircumflex",
                        0x00f4,
                        "ocircumflexacute",
                        0x1ed1,
                        "ocircumflexdotbelow",
                        0x1ed9,
                        "ocircumflexgrave",
                        0x1ed3,
                        "ocircumflexhookabove",
                        0x1ed5,
                        "ocircumflextilde",
                        0x1ed7,
                        "ocyrillic",
                        0x043e,
                        "odblacute",
                        0x0151,
                        "odblgrave",
                        0x020d,
                        "odeva",
                        0x0913,
                        "odieresis",
                        0x00f6,
                        "odieresiscyrillic",
                        0x04e7,
                        "odotbelow",
                        0x1ecd,
                        "oe",
                        0x0153,
                        "oekorean",
                        0x315a,
                        "ogonek",
                        0x02db,
                        "ogonekcmb",
                        0x0328,
                        "ograve",
                        0x00f2,
                        "ogujarati",
                        0x0a93,
                        "oharmenian",
                        0x0585,
                        "ohiragana",
                        0x304a,
                        "ohookabove",
                        0x1ecf,
                        "ohorn",
                        0x01a1,
                        "ohornacute",
                        0x1edb,
                        "ohorndotbelow",
                        0x1ee3,
                        "ohorngrave",
                        0x1edd,
                        "ohornhookabove",
                        0x1edf,
                        "ohorntilde",
                        0x1ee1,
                        "ohungarumlaut",
                        0x0151,
                        "oi",
                        0x01a3,
                        "oinvertedbreve",
                        0x020f,
                        "okatakana",
                        0x30aa,
                        "okatakanahalfwidth",
                        0xff75,
                        "okorean",
                        0x3157,
                        "olehebrew",
                        0x05ab,
                        "omacron",
                        0x014d,
                        "omacronacute",
                        0x1e53,
                        "omacrongrave",
                        0x1e51,
                        "omdeva",
                        0x0950,
                        "omega",
                        0x03c9,
                        "omega1",
                        0x03d6,
                        "omegacyrillic",
                        0x0461,
                        "omegalatinclosed",
                        0x0277,
                        "omegaroundcyrillic",
                        0x047b,
                        "omegatitlocyrillic",
                        0x047d,
                        "omegatonos",
                        0x03ce,
                        "omgujarati",
                        0x0ad0,
                        "omicron",
                        0x03bf,
                        "omicrontonos",
                        0x03cc,
                        "omonospace",
                        0xff4f,
                        "one",
                        0x0031,
                        "onearabic",
                        0x0661,
                        "onebengali",
                        0x09e7,
                        "onecircle",
                        0x2460,
                        "onecircleinversesansserif",
                        0x278a,
                        "onedeva",
                        0x0967,
                        "onedotenleader",
                        0x2024,
                        "oneeighth",
                        0x215b,
                        "onefitted",
                        0xf6dc,
                        "onegujarati",
                        0x0ae7,
                        "onegurmukhi",
                        0x0a67,
                        "onehackarabic",
                        0x0661,
                        "onehalf",
                        0x00bd,
                        "onehangzhou",
                        0x3021,
                        "oneideographicparen",
                        0x3220,
                        "oneinferior",
                        0x2081,
                        "onemonospace",
                        0xff11,
                        "onenumeratorbengali",
                        0x09f4,
                        "oneoldstyle",
                        0xf731,
                        "oneparen",
                        0x2474,
                        "oneperiod",
                        0x2488,
                        "onepersian",
                        0x06f1,
                        "onequarter",
                        0x00bc,
                        "oneroman",
                        0x2170,
                        "onesuperior",
                        0x00b9,
                        "onethai",
                        0x0e51,
                        "onethird",
                        0x2153,
                        "oogonek",
                        0x01eb,
                        "oogonekmacron",
                        0x01ed,
                        "oogurmukhi",
                        0x0a13,
                        "oomatragurmukhi",
                        0x0a4b,
                        "oopen",
                        0x0254,
                        "oparen",
                        0x24aa,
                        "openbullet",
                        0x25e6,
                        "option",
                        0x2325,
                        "ordfeminine",
                        0x00aa,
                        "ordmasculine",
                        0x00ba,
                        "orthogonal",
                        0x221f,
                        "oshortdeva",
                        0x0912,
                        "oshortvowelsigndeva",
                        0x094a,
                        "oslash",
                        0x00f8,
                        "oslashacute",
                        0x01ff,
                        "osmallhiragana",
                        0x3049,
                        "osmallkatakana",
                        0x30a9,
                        "osmallkatakanahalfwidth",
                        0xff6b,
                        "ostrokeacute",
                        0x01ff,
                        "osuperior",
                        0xf6f0,
                        "otcyrillic",
                        0x047f,
                        "otilde",
                        0x00f5,
                        "otildeacute",
                        0x1e4d,
                        "otildedieresis",
                        0x1e4f,
                        "oubopomofo",
                        0x3121,
                        "overline",
                        0x203e,
                        "overlinecenterline",
                        0xfe4a,
                        "overlinecmb",
                        0x0305,
                        "overlinedashed",
                        0xfe49,
                        "overlinedblwavy",
                        0xfe4c,
                        "overlinewavy",
                        0xfe4b,
                        "overscore",
                        0x00af,
                        "ovowelsignbengali",
                        0x09cb,
                        "ovowelsigndeva",
                        0x094b,
                        "ovowelsigngujarati",
                        0x0acb,
                        "p",
                        0x0070,
                        "paampssquare",
                        0x3380,
                        "paasentosquare",
                        0x332b,
                        "pabengali",
                        0x09aa,
                        "pacute",
                        0x1e55,
                        "padeva",
                        0x092a,
                        "pagedown",
                        0x21df,
                        "pageup",
                        0x21de,
                        "pagujarati",
                        0x0aaa,
                        "pagurmukhi",
                        0x0a2a,
                        "pahiragana",
                        0x3071,
                        "paiyannoithai",
                        0x0e2f,
                        "pakatakana",
                        0x30d1,
                        "palatalizationcyrilliccmb",
                        0x0484,
                        "palochkacyrillic",
                        0x04c0,
                        "pansioskorean",
                        0x317f,
                        "paragraph",
                        0x00b6,
                        "parallel",
                        0x2225,
                        "parenleft",
                        0x0028,
                        "parenleftaltonearabic",
                        0xfd3e,
                        "parenleftbt",
                        0xf8ed,
                        "parenleftex",
                        0xf8ec,
                        "parenleftinferior",
                        0x208d,
                        "parenleftmonospace",
                        0xff08,
                        "parenleftsmall",
                        0xfe59,
                        "parenleftsuperior",
                        0x207d,
                        "parenlefttp",
                        0xf8eb,
                        "parenleftvertical",
                        0xfe35,
                        "parenright",
                        0x0029,
                        "parenrightaltonearabic",
                        0xfd3f,
                        "parenrightbt",
                        0xf8f8,
                        "parenrightex",
                        0xf8f7,
                        "parenrightinferior",
                        0x208e,
                        "parenrightmonospace",
                        0xff09,
                        "parenrightsmall",
                        0xfe5a,
                        "parenrightsuperior",
                        0x207e,
                        "parenrighttp",
                        0xf8f6,
                        "parenrightvertical",
                        0xfe36,
                        "partialdiff",
                        0x2202,
                        "paseqhebrew",
                        0x05c0,
                        "pashtahebrew",
                        0x0599,
                        "pasquare",
                        0x33a9,
                        "patah",
                        0x05b7,
                        "patah11",
                        0x05b7,
                        "patah1d",
                        0x05b7,
                        "patah2a",
                        0x05b7,
                        "patahhebrew",
                        0x05b7,
                        "patahnarrowhebrew",
                        0x05b7,
                        "patahquarterhebrew",
                        0x05b7,
                        "patahwidehebrew",
                        0x05b7,
                        "pazerhebrew",
                        0x05a1,
                        "pbopomofo",
                        0x3106,
                        "pcircle",
                        0x24df,
                        "pdotaccent",
                        0x1e57,
                        "pe",
                        0x05e4,
                        "pecyrillic",
                        0x043f,
                        "pedagesh",
                        0xfb44,
                        "pedageshhebrew",
                        0xfb44,
                        "peezisquare",
                        0x333b,
                        "pefinaldageshhebrew",
                        0xfb43,
                        "peharabic",
                        0x067e,
                        "peharmenian",
                        0x057a,
                        "pehebrew",
                        0x05e4,
                        "pehfinalarabic",
                        0xfb57,
                        "pehinitialarabic",
                        0xfb58,
                        "pehiragana",
                        0x307a,
                        "pehmedialarabic",
                        0xfb59,
                        "pekatakana",
                        0x30da,
                        "pemiddlehookcyrillic",
                        0x04a7,
                        "perafehebrew",
                        0xfb4e,
                        "percent",
                        0x0025,
                        "percentarabic",
                        0x066a,
                        "percentmonospace",
                        0xff05,
                        "percentsmall",
                        0xfe6a,
                        "period",
                        0x002e,
                        "periodarmenian",
                        0x0589,
                        "periodcentered",
                        0x00b7,
                        "periodhalfwidth",
                        0xff61,
                        "periodinferior",
                        0xf6e7,
                        "periodmonospace",
                        0xff0e,
                        "periodsmall",
                        0xfe52,
                        "periodsuperior",
                        0xf6e8,
                        "perispomenigreekcmb",
                        0x0342,
                        "perpendicular",
                        0x22a5,
                        "perthousand",
                        0x2030,
                        "peseta",
                        0x20a7,
                        "pfsquare",
                        0x338a,
                        "phabengali",
                        0x09ab,
                        "phadeva",
                        0x092b,
                        "phagujarati",
                        0x0aab,
                        "phagurmukhi",
                        0x0a2b,
                        "phi",
                        0x03c6,
                        "phi1",
                        0x03d5,
                        "phieuphacirclekorean",
                        0x327a,
                        "phieuphaparenkorean",
                        0x321a,
                        "phieuphcirclekorean",
                        0x326c,
                        "phieuphkorean",
                        0x314d,
                        "phieuphparenkorean",
                        0x320c,
                        "philatin",
                        0x0278,
                        "phinthuthai",
                        0x0e3a,
                        "phisymbolgreek",
                        0x03d5,
                        "phook",
                        0x01a5,
                        "phophanthai",
                        0x0e1e,
                        "phophungthai",
                        0x0e1c,
                        "phosamphaothai",
                        0x0e20,
                        "pi",
                        0x03c0,
                        "pieupacirclekorean",
                        0x3273,
                        "pieupaparenkorean",
                        0x3213,
                        "pieupcieuckorean",
                        0x3176,
                        "pieupcirclekorean",
                        0x3265,
                        "pieupkiyeokkorean",
                        0x3172,
                        "pieupkorean",
                        0x3142,
                        "pieupparenkorean",
                        0x3205,
                        "pieupsioskiyeokkorean",
                        0x3174,
                        "pieupsioskorean",
                        0x3144,
                        "pieupsiostikeutkorean",
                        0x3175,
                        "pieupthieuthkorean",
                        0x3177,
                        "pieuptikeutkorean",
                        0x3173,
                        "pihiragana",
                        0x3074,
                        "pikatakana",
                        0x30d4,
                        "pisymbolgreek",
                        0x03d6,
                        "piwrarmenian",
                        0x0583,
                        "plus",
                        0x002b,
                        "plusbelowcmb",
                        0x031f,
                        "pluscircle",
                        0x2295,
                        "plusminus",
                        0x00b1,
                        "plusmod",
                        0x02d6,
                        "plusmonospace",
                        0xff0b,
                        "plussmall",
                        0xfe62,
                        "plussuperior",
                        0x207a,
                        "pmonospace",
                        0xff50,
                        "pmsquare",
                        0x33d8,
                        "pohiragana",
                        0x307d,
                        "pointingindexdownwhite",
                        0x261f,
                        "pointingindexleftwhite",
                        0x261c,
                        "pointingindexrightwhite",
                        0x261e,
                        "pointingindexupwhite",
                        0x261d,
                        "pokatakana",
                        0x30dd,
                        "poplathai",
                        0x0e1b,
                        "postalmark",
                        0x3012,
                        "postalmarkface",
                        0x3020,
                        "pparen",
                        0x24ab,
                        "precedes",
                        0x227a,
                        "prescription",
                        0x211e,
                        "primemod",
                        0x02b9,
                        "primereversed",
                        0x2035,
                        "product",
                        0x220f,
                        "projective",
                        0x2305,
                        "prolongedkana",
                        0x30fc,
                        "propellor",
                        0x2318,
                        "propersubset",
                        0x2282,
                        "propersuperset",
                        0x2283,
                        "proportion",
                        0x2237,
                        "proportional",
                        0x221d,
                        "psi",
                        0x03c8,
                        "psicyrillic",
                        0x0471,
                        "psilipneumatacyrilliccmb",
                        0x0486,
                        "pssquare",
                        0x33b0,
                        "puhiragana",
                        0x3077,
                        "pukatakana",
                        0x30d7,
                        "pvsquare",
                        0x33b4,
                        "pwsquare",
                        0x33ba,
                        "q",
                        0x0071,
                        "qadeva",
                        0x0958,
                        "qadmahebrew",
                        0x05a8,
                        "qafarabic",
                        0x0642,
                        "qaffinalarabic",
                        0xfed6,
                        "qafinitialarabic",
                        0xfed7,
                        "qafmedialarabic",
                        0xfed8,
                        "qamats",
                        0x05b8,
                        "qamats10",
                        0x05b8,
                        "qamats1a",
                        0x05b8,
                        "qamats1c",
                        0x05b8,
                        "qamats27",
                        0x05b8,
                        "qamats29",
                        0x05b8,
                        "qamats33",
                        0x05b8,
                        "qamatsde",
                        0x05b8,
                        "qamatshebrew",
                        0x05b8,
                        "qamatsnarrowhebrew",
                        0x05b8,
                        "qamatsqatanhebrew",
                        0x05b8,
                        "qamatsqatannarrowhebrew",
                        0x05b8,
                        "qamatsqatanquarterhebrew",
                        0x05b8,
                        "qamatsqatanwidehebrew",
                        0x05b8,
                        "qamatsquarterhebrew",
                        0x05b8,
                        "qamatswidehebrew",
                        0x05b8,
                        "qarneyparahebrew",
                        0x059f,
                        "qbopomofo",
                        0x3111,
                        "qcircle",
                        0x24e0,
                        "qhook",
                        0x02a0,
                        "qmonospace",
                        0xff51,
                        "qof",
                        0x05e7,
                        "qofdagesh",
                        0xfb47,
                        "qofdageshhebrew",
                        0xfb47,
                        "qofhebrew",
                        0x05e7,
                        "qparen",
                        0x24ac,
                        "quarternote",
                        0x2669,
                        "qubuts",
                        0x05bb,
                        "qubuts18",
                        0x05bb,
                        "qubuts25",
                        0x05bb,
                        "qubuts31",
                        0x05bb,
                        "qubutshebrew",
                        0x05bb,
                        "qubutsnarrowhebrew",
                        0x05bb,
                        "qubutsquarterhebrew",
                        0x05bb,
                        "qubutswidehebrew",
                        0x05bb,
                        "question",
                        0x003f,
                        "questionarabic",
                        0x061f,
                        "questionarmenian",
                        0x055e,
                        "questiondown",
                        0x00bf,
                        "questiondownsmall",
                        0xf7bf,
                        "questiongreek",
                        0x037e,
                        "questionmonospace",
                        0xff1f,
                        "questionsmall",
                        0xf73f,
                        "quotedbl",
                        0x0022,
                        "quotedblbase",
                        0x201e,
                        "quotedblleft",
                        0x201c,
                        "quotedblmonospace",
                        0xff02,
                        "quotedblprime",
                        0x301e,
                        "quotedblprimereversed",
                        0x301d,
                        "quotedblright",
                        0x201d,
                        "quoteleft",
                        0x2018,
                        "quoteleftreversed",
                        0x201b,
                        "quotereversed",
                        0x201b,
                        "quoteright",
                        0x2019,
                        "quoterightn",
                        0x0149,
                        "quotesinglbase",
                        0x201a,
                        "quotesingle",
                        0x0027,
                        "quotesinglemonospace",
                        0xff07,
                        "r",
                        0x0072,
                        "raarmenian",
                        0x057c,
                        "rabengali",
                        0x09b0,
                        "racute",
                        0x0155,
                        "radeva",
                        0x0930,
                        "radical",
                        0x221a,
                        "radicalex",
                        0xf8e5,
                        "radoverssquare",
                        0x33ae,
                        "radoverssquaredsquare",
                        0x33af,
                        "radsquare",
                        0x33ad,
                        "rafe",
                        0x05bf,
                        "rafehebrew",
                        0x05bf,
                        "ragujarati",
                        0x0ab0,
                        "ragurmukhi",
                        0x0a30,
                        "rahiragana",
                        0x3089,
                        "rakatakana",
                        0x30e9,
                        "rakatakanahalfwidth",
                        0xff97,
                        "ralowerdiagonalbengali",
                        0x09f1,
                        "ramiddlediagonalbengali",
                        0x09f0,
                        "ramshorn",
                        0x0264,
                        "ratio",
                        0x2236,
                        "rbopomofo",
                        0x3116,
                        "rcaron",
                        0x0159,
                        "rcedilla",
                        0x0157,
                        "rcircle",
                        0x24e1,
                        "rcommaaccent",
                        0x0157,
                        "rdblgrave",
                        0x0211,
                        "rdotaccent",
                        0x1e59,
                        "rdotbelow",
                        0x1e5b,
                        "rdotbelowmacron",
                        0x1e5d,
                        "referencemark",
                        0x203b,
                        "reflexsubset",
                        0x2286,
                        "reflexsuperset",
                        0x2287,
                        "registered",
                        0x00ae,
                        "registersans",
                        0xf8e8,
                        "registerserif",
                        0xf6da,
                        "reharabic",
                        0x0631,
                        "reharmenian",
                        0x0580,
                        "rehfinalarabic",
                        0xfeae,
                        "rehiragana",
                        0x308c,
                        "rekatakana",
                        0x30ec,
                        "rekatakanahalfwidth",
                        0xff9a,
                        "resh",
                        0x05e8,
                        "reshdageshhebrew",
                        0xfb48,
                        "reshhebrew",
                        0x05e8,
                        "reversedtilde",
                        0x223d,
                        "reviahebrew",
                        0x0597,
                        "reviamugrashhebrew",
                        0x0597,
                        "revlogicalnot",
                        0x2310,
                        "rfishhook",
                        0x027e,
                        "rfishhookreversed",
                        0x027f,
                        "rhabengali",
                        0x09dd,
                        "rhadeva",
                        0x095d,
                        "rho",
                        0x03c1,
                        "rhook",
                        0x027d,
                        "rhookturned",
                        0x027b,
                        "rhookturnedsuperior",
                        0x02b5,
                        "rhosymbolgreek",
                        0x03f1,
                        "rhotichookmod",
                        0x02de,
                        "rieulacirclekorean",
                        0x3271,
                        "rieulaparenkorean",
                        0x3211,
                        "rieulcirclekorean",
                        0x3263,
                        "rieulhieuhkorean",
                        0x3140,
                        "rieulkiyeokkorean",
                        0x313a,
                        "rieulkiyeoksioskorean",
                        0x3169,
                        "rieulkorean",
                        0x3139,
                        "rieulmieumkorean",
                        0x313b,
                        "rieulpansioskorean",
                        0x316c,
                        "rieulparenkorean",
                        0x3203,
                        "rieulphieuphkorean",
                        0x313f,
                        "rieulpieupkorean",
                        0x313c,
                        "rieulpieupsioskorean",
                        0x316b,
                        "rieulsioskorean",
                        0x313d,
                        "rieulthieuthkorean",
                        0x313e,
                        "rieultikeutkorean",
                        0x316a,
                        "rieulyeorinhieuhkorean",
                        0x316d,
                        "rightangle",
                        0x221f,
                        "righttackbelowcmb",
                        0x0319,
                        "righttriangle",
                        0x22bf,
                        "rihiragana",
                        0x308a,
                        "rikatakana",
                        0x30ea,
                        "rikatakanahalfwidth",
                        0xff98,
                        "ring",
                        0x02da,
                        "ringbelowcmb",
                        0x0325,
                        "ringcmb",
                        0x030a,
                        "ringhalfleft",
                        0x02bf,
                        "ringhalfleftarmenian",
                        0x0559,
                        "ringhalfleftbelowcmb",
                        0x031c,
                        "ringhalfleftcentered",
                        0x02d3,
                        "ringhalfright",
                        0x02be,
                        "ringhalfrightbelowcmb",
                        0x0339,
                        "ringhalfrightcentered",
                        0x02d2,
                        "rinvertedbreve",
                        0x0213,
                        "rittorusquare",
                        0x3351,
                        "rlinebelow",
                        0x1e5f,
                        "rlongleg",
                        0x027c,
                        "rlonglegturned",
                        0x027a,
                        "rmonospace",
                        0xff52,
                        "rohiragana",
                        0x308d,
                        "rokatakana",
                        0x30ed,
                        "rokatakanahalfwidth",
                        0xff9b,
                        "roruathai",
                        0x0e23,
                        "rparen",
                        0x24ad,
                        "rrabengali",
                        0x09dc,
                        "rradeva",
                        0x0931,
                        "rragurmukhi",
                        0x0a5c,
                        "rreharabic",
                        0x0691,
                        "rrehfinalarabic",
                        0xfb8d,
                        "rrvocalicbengali",
                        0x09e0,
                        "rrvocalicdeva",
                        0x0960,
                        "rrvocalicgujarati",
                        0x0ae0,
                        "rrvocalicvowelsignbengali",
                        0x09c4,
                        "rrvocalicvowelsigndeva",
                        0x0944,
                        "rrvocalicvowelsigngujarati",
                        0x0ac4,
                        "rsuperior",
                        0xf6f1,
                        "rtblock",
                        0x2590,
                        "rturned",
                        0x0279,
                        "rturnedsuperior",
                        0x02b4,
                        "ruhiragana",
                        0x308b,
                        "rukatakana",
                        0x30eb,
                        "rukatakanahalfwidth",
                        0xff99,
                        "rupeemarkbengali",
                        0x09f2,
                        "rupeesignbengali",
                        0x09f3,
                        "rupiah",
                        0xf6dd,
                        "ruthai",
                        0x0e24,
                        "rvocalicbengali",
                        0x098b,
                        "rvocalicdeva",
                        0x090b,
                        "rvocalicgujarati",
                        0x0a8b,
                        "rvocalicvowelsignbengali",
                        0x09c3,
                        "rvocalicvowelsigndeva",
                        0x0943,
                        "rvocalicvowelsigngujarati",
                        0x0ac3,
                        "s",
                        0x0073,
                        "sabengali",
                        0x09b8,
                        "sacute",
                        0x015b,
                        "sacutedotaccent",
                        0x1e65,
                        "sadarabic",
                        0x0635,
                        "sadeva",
                        0x0938,
                        "sadfinalarabic",
                        0xfeba,
                        "sadinitialarabic",
                        0xfebb,
                        "sadmedialarabic",
                        0xfebc,
                        "sagujarati",
                        0x0ab8,
                        "sagurmukhi",
                        0x0a38,
                        "sahiragana",
                        0x3055,
                        "sakatakana",
                        0x30b5,
                        "sakatakanahalfwidth",
                        0xff7b,
                        "sallallahoualayhewasallamarabic",
                        0xfdfa,
                        "samekh",
                        0x05e1,
                        "samekhdagesh",
                        0xfb41,
                        "samekhdageshhebrew",
                        0xfb41,
                        "samekhhebrew",
                        0x05e1,
                        "saraaathai",
                        0x0e32,
                        "saraaethai",
                        0x0e41,
                        "saraaimaimalaithai",
                        0x0e44,
                        "saraaimaimuanthai",
                        0x0e43,
                        "saraamthai",
                        0x0e33,
                        "saraathai",
                        0x0e30,
                        "saraethai",
                        0x0e40,
                        "saraiileftthai",
                        0xf886,
                        "saraiithai",
                        0x0e35,
                        "saraileftthai",
                        0xf885,
                        "saraithai",
                        0x0e34,
                        "saraothai",
                        0x0e42,
                        "saraueeleftthai",
                        0xf888,
                        "saraueethai",
                        0x0e37,
                        "saraueleftthai",
                        0xf887,
                        "sarauethai",
                        0x0e36,
                        "sarauthai",
                        0x0e38,
                        "sarauuthai",
                        0x0e39,
                        "sbopomofo",
                        0x3119,
                        "scaron",
                        0x0161,
                        "scarondotaccent",
                        0x1e67,
                        "scedilla",
                        0x015f,
                        "schwa",
                        0x0259,
                        "schwacyrillic",
                        0x04d9,
                        "schwadieresiscyrillic",
                        0x04db,
                        "schwahook",
                        0x025a,
                        "scircle",
                        0x24e2,
                        "scircumflex",
                        0x015d,
                        "scommaaccent",
                        0x0219,
                        "sdotaccent",
                        0x1e61,
                        "sdotbelow",
                        0x1e63,
                        "sdotbelowdotaccent",
                        0x1e69,
                        "seagullbelowcmb",
                        0x033c,
                        "second",
                        0x2033,
                        "secondtonechinese",
                        0x02ca,
                        "section",
                        0x00a7,
                        "seenarabic",
                        0x0633,
                        "seenfinalarabic",
                        0xfeb2,
                        "seeninitialarabic",
                        0xfeb3,
                        "seenmedialarabic",
                        0xfeb4,
                        "segol",
                        0x05b6,
                        "segol13",
                        0x05b6,
                        "segol1f",
                        0x05b6,
                        "segol2c",
                        0x05b6,
                        "segolhebrew",
                        0x05b6,
                        "segolnarrowhebrew",
                        0x05b6,
                        "segolquarterhebrew",
                        0x05b6,
                        "segoltahebrew",
                        0x0592,
                        "segolwidehebrew",
                        0x05b6,
                        "seharmenian",
                        0x057d,
                        "sehiragana",
                        0x305b,
                        "sekatakana",
                        0x30bb,
                        "sekatakanahalfwidth",
                        0xff7e,
                        "semicolon",
                        0x003b,
                        "semicolonarabic",
                        0x061b,
                        "semicolonmonospace",
                        0xff1b,
                        "semicolonsmall",
                        0xfe54,
                        "semivoicedmarkkana",
                        0x309c,
                        "semivoicedmarkkanahalfwidth",
                        0xff9f,
                        "sentisquare",
                        0x3322,
                        "sentosquare",
                        0x3323,
                        "seven",
                        0x0037,
                        "sevenarabic",
                        0x0667,
                        "sevenbengali",
                        0x09ed,
                        "sevencircle",
                        0x2466,
                        "sevencircleinversesansserif",
                        0x2790,
                        "sevendeva",
                        0x096d,
                        "seveneighths",
                        0x215e,
                        "sevengujarati",
                        0x0aed,
                        "sevengurmukhi",
                        0x0a6d,
                        "sevenhackarabic",
                        0x0667,
                        "sevenhangzhou",
                        0x3027,
                        "sevenideographicparen",
                        0x3226,
                        "seveninferior",
                        0x2087,
                        "sevenmonospace",
                        0xff17,
                        "sevenoldstyle",
                        0xf737,
                        "sevenparen",
                        0x247a,
                        "sevenperiod",
                        0x248e,
                        "sevenpersian",
                        0x06f7,
                        "sevenroman",
                        0x2176,
                        "sevensuperior",
                        0x2077,
                        "seventeencircle",
                        0x2470,
                        "seventeenparen",
                        0x2484,
                        "seventeenperiod",
                        0x2498,
                        "seventhai",
                        0x0e57,
                        "sfthyphen",
                        0x00ad,
                        "shaarmenian",
                        0x0577,
                        "shabengali",
                        0x09b6,
                        "shacyrillic",
                        0x0448,
                        "shaddaarabic",
                        0x0651,
                        "shaddadammaarabic",
                        0xfc61,
                        "shaddadammatanarabic",
                        0xfc5e,
                        "shaddafathaarabic",
                        0xfc60,
                        "shaddakasraarabic",
                        0xfc62,
                        "shaddakasratanarabic",
                        0xfc5f,
                        "shade",
                        0x2592,
                        "shadedark",
                        0x2593,
                        "shadelight",
                        0x2591,
                        "shademedium",
                        0x2592,
                        "shadeva",
                        0x0936,
                        "shagujarati",
                        0x0ab6,
                        "shagurmukhi",
                        0x0a36,
                        "shalshelethebrew",
                        0x0593,
                        "shbopomofo",
                        0x3115,
                        "shchacyrillic",
                        0x0449,
                        "sheenarabic",
                        0x0634,
                        "sheenfinalarabic",
                        0xfeb6,
                        "sheeninitialarabic",
                        0xfeb7,
                        "sheenmedialarabic",
                        0xfeb8,
                        "sheicoptic",
                        0x03e3,
                        "sheqel",
                        0x20aa,
                        "sheqelhebrew",
                        0x20aa,
                        "sheva",
                        0x05b0,
                        "sheva115",
                        0x05b0,
                        "sheva15",
                        0x05b0,
                        "sheva22",
                        0x05b0,
                        "sheva2e",
                        0x05b0,
                        "shevahebrew",
                        0x05b0,
                        "shevanarrowhebrew",
                        0x05b0,
                        "shevaquarterhebrew",
                        0x05b0,
                        "shevawidehebrew",
                        0x05b0,
                        "shhacyrillic",
                        0x04bb,
                        "shimacoptic",
                        0x03ed,
                        "shin",
                        0x05e9,
                        "shindagesh",
                        0xfb49,
                        "shindageshhebrew",
                        0xfb49,
                        "shindageshshindot",
                        0xfb2c,
                        "shindageshshindothebrew",
                        0xfb2c,
                        "shindageshsindot",
                        0xfb2d,
                        "shindageshsindothebrew",
                        0xfb2d,
                        "shindothebrew",
                        0x05c1,
                        "shinhebrew",
                        0x05e9,
                        "shinshindot",
                        0xfb2a,
                        "shinshindothebrew",
                        0xfb2a,
                        "shinsindot",
                        0xfb2b,
                        "shinsindothebrew",
                        0xfb2b,
                        "shook",
                        0x0282,
                        "sigma",
                        0x03c3,
                        "sigma1",
                        0x03c2,
                        "sigmafinal",
                        0x03c2,
                        "sigmalunatesymbolgreek",
                        0x03f2,
                        "sihiragana",
                        0x3057,
                        "sikatakana",
                        0x30b7,
                        "sikatakanahalfwidth",
                        0xff7c,
                        "siluqhebrew",
                        0x05bd,
                        "siluqlefthebrew",
                        0x05bd,
                        "similar",
                        0x223c,
                        "sindothebrew",
                        0x05c2,
                        "siosacirclekorean",
                        0x3274,
                        "siosaparenkorean",
                        0x3214,
                        "sioscieuckorean",
                        0x317e,
                        "sioscirclekorean",
                        0x3266,
                        "sioskiyeokkorean",
                        0x317a,
                        "sioskorean",
                        0x3145,
                        "siosnieunkorean",
                        0x317b,
                        "siosparenkorean",
                        0x3206,
                        "siospieupkorean",
                        0x317d,
                        "siostikeutkorean",
                        0x317c,
                        "six",
                        0x0036,
                        "sixarabic",
                        0x0666,
                        "sixbengali",
                        0x09ec,
                        "sixcircle",
                        0x2465,
                        "sixcircleinversesansserif",
                        0x278f,
                        "sixdeva",
                        0x096c,
                        "sixgujarati",
                        0x0aec,
                        "sixgurmukhi",
                        0x0a6c,
                        "sixhackarabic",
                        0x0666,
                        "sixhangzhou",
                        0x3026,
                        "sixideographicparen",
                        0x3225,
                        "sixinferior",
                        0x2086,
                        "sixmonospace",
                        0xff16,
                        "sixoldstyle",
                        0xf736,
                        "sixparen",
                        0x2479,
                        "sixperiod",
                        0x248d,
                        "sixpersian",
                        0x06f6,
                        "sixroman",
                        0x2175,
                        "sixsuperior",
                        0x2076,
                        "sixteencircle",
                        0x246f,
                        "sixteencurrencydenominatorbengali",
                        0x09f9,
                        "sixteenparen",
                        0x2483,
                        "sixteenperiod",
                        0x2497,
                        "sixthai",
                        0x0e56,
                        "slash",
                        0x002f,
                        "slashmonospace",
                        0xff0f,
                        "slong",
                        0x017f,
                        "slongdotaccent",
                        0x1e9b,
                        "smileface",
                        0x263a,
                        "smonospace",
                        0xff53,
                        "sofpasuqhebrew",
                        0x05c3,
                        "softhyphen",
                        0x00ad,
                        "softsigncyrillic",
                        0x044c,
                        "sohiragana",
                        0x305d,
                        "sokatakana",
                        0x30bd,
                        "sokatakanahalfwidth",
                        0xff7f,
                        "soliduslongoverlaycmb",
                        0x0338,
                        "solidusshortoverlaycmb",
                        0x0337,
                        "sorusithai",
                        0x0e29,
                        "sosalathai",
                        0x0e28,
                        "sosothai",
                        0x0e0b,
                        "sosuathai",
                        0x0e2a,
                        "space",
                        0x0020,
                        "spacehackarabic",
                        0x0020,
                        "spade",
                        0x2660,
                        "spadesuitblack",
                        0x2660,
                        "spadesuitwhite",
                        0x2664,
                        "sparen",
                        0x24ae,
                        "squarebelowcmb",
                        0x033b,
                        "squarecc",
                        0x33c4,
                        "squarecm",
                        0x339d,
                        "squarediagonalcrosshatchfill",
                        0x25a9,
                        "squarehorizontalfill",
                        0x25a4,
                        "squarekg",
                        0x338f,
                        "squarekm",
                        0x339e,
                        "squarekmcapital",
                        0x33ce,
                        "squareln",
                        0x33d1,
                        "squarelog",
                        0x33d2,
                        "squaremg",
                        0x338e,
                        "squaremil",
                        0x33d5,
                        "squaremm",
                        0x339c,
                        "squaremsquared",
                        0x33a1,
                        "squareorthogonalcrosshatchfill",
                        0x25a6,
                        "squareupperlefttolowerrightfill",
                        0x25a7,
                        "squareupperrighttolowerleftfill",
                        0x25a8,
                        "squareverticalfill",
                        0x25a5,
                        "squarewhitewithsmallblack",
                        0x25a3,
                        "srsquare",
                        0x33db,
                        "ssabengali",
                        0x09b7,
                        "ssadeva",
                        0x0937,
                        "ssagujarati",
                        0x0ab7,
                        "ssangcieuckorean",
                        0x3149,
                        "ssanghieuhkorean",
                        0x3185,
                        "ssangieungkorean",
                        0x3180,
                        "ssangkiyeokkorean",
                        0x3132,
                        "ssangnieunkorean",
                        0x3165,
                        "ssangpieupkorean",
                        0x3143,
                        "ssangsioskorean",
                        0x3146,
                        "ssangtikeutkorean",
                        0x3138,
                        "ssuperior",
                        0xf6f2,
                        "sterling",
                        0x00a3,
                        "sterlingmonospace",
                        0xffe1,
                        "strokelongoverlaycmb",
                        0x0336,
                        "strokeshortoverlaycmb",
                        0x0335,
                        "subset",
                        0x2282,
                        "subsetnotequal",
                        0x228a,
                        "subsetorequal",
                        0x2286,
                        "succeeds",
                        0x227b,
                        "suchthat",
                        0x220b,
                        "suhiragana",
                        0x3059,
                        "sukatakana",
                        0x30b9,
                        "sukatakanahalfwidth",
                        0xff7d,
                        "sukunarabic",
                        0x0652,
                        "summation",
                        0x2211,
                        "sun",
                        0x263c,
                        "superset",
                        0x2283,
                        "supersetnotequal",
                        0x228b,
                        "supersetorequal",
                        0x2287,
                        "svsquare",
                        0x33dc,
                        "syouwaerasquare",
                        0x337c,
                        "t",
                        0x0074,
                        "tabengali",
                        0x09a4,
                        "tackdown",
                        0x22a4,
                        "tackleft",
                        0x22a3,
                        "tadeva",
                        0x0924,
                        "tagujarati",
                        0x0aa4,
                        "tagurmukhi",
                        0x0a24,
                        "taharabic",
                        0x0637,
                        "tahfinalarabic",
                        0xfec2,
                        "tahinitialarabic",
                        0xfec3,
                        "tahiragana",
                        0x305f,
                        "tahmedialarabic",
                        0xfec4,
                        "taisyouerasquare",
                        0x337d,
                        "takatakana",
                        0x30bf,
                        "takatakanahalfwidth",
                        0xff80,
                        "tatweelarabic",
                        0x0640,
                        "tau",
                        0x03c4,
                        "tav",
                        0x05ea,
                        "tavdages",
                        0xfb4a,
                        "tavdagesh",
                        0xfb4a,
                        "tavdageshhebrew",
                        0xfb4a,
                        "tavhebrew",
                        0x05ea,
                        "tbar",
                        0x0167,
                        "tbopomofo",
                        0x310a,
                        "tcaron",
                        0x0165,
                        "tccurl",
                        0x02a8,
                        "tcedilla",
                        0x0163,
                        "tcheharabic",
                        0x0686,
                        "tchehfinalarabic",
                        0xfb7b,
                        "tchehinitialarabic",
                        0xfb7c,
                        "tchehmedialarabic",
                        0xfb7d,
                        "tcircle",
                        0x24e3,
                        "tcircumflexbelow",
                        0x1e71,
                        "tcommaaccent",
                        0x0163,
                        "tdieresis",
                        0x1e97,
                        "tdotaccent",
                        0x1e6b,
                        "tdotbelow",
                        0x1e6d,
                        "tecyrillic",
                        0x0442,
                        "tedescendercyrillic",
                        0x04ad,
                        "teharabic",
                        0x062a,
                        "tehfinalarabic",
                        0xfe96,
                        "tehhahinitialarabic",
                        0xfca2,
                        "tehhahisolatedarabic",
                        0xfc0c,
                        "tehinitialarabic",
                        0xfe97,
                        "tehiragana",
                        0x3066,
                        "tehjeeminitialarabic",
                        0xfca1,
                        "tehjeemisolatedarabic",
                        0xfc0b,
                        "tehmarbutaarabic",
                        0x0629,
                        "tehmarbutafinalarabic",
                        0xfe94,
                        "tehmedialarabic",
                        0xfe98,
                        "tehmeeminitialarabic",
                        0xfca4,
                        "tehmeemisolatedarabic",
                        0xfc0e,
                        "tehnoonfinalarabic",
                        0xfc73,
                        "tekatakana",
                        0x30c6,
                        "tekatakanahalfwidth",
                        0xff83,
                        "telephone",
                        0x2121,
                        "telephoneblack",
                        0x260e,
                        "telishagedolahebrew",
                        0x05a0,
                        "telishaqetanahebrew",
                        0x05a9,
                        "tencircle",
                        0x2469,
                        "tenideographicparen",
                        0x3229,
                        "tenparen",
                        0x247d,
                        "tenperiod",
                        0x2491,
                        "tenroman",
                        0x2179,
                        "tesh",
                        0x02a7,
                        "tet",
                        0x05d8,
                        "tetdagesh",
                        0xfb38,
                        "tetdageshhebrew",
                        0xfb38,
                        "tethebrew",
                        0x05d8,
                        "tetsecyrillic",
                        0x04b5,
                        "tevirhebrew",
                        0x059b,
                        "tevirlefthebrew",
                        0x059b,
                        "thabengali",
                        0x09a5,
                        "thadeva",
                        0x0925,
                        "thagujarati",
                        0x0aa5,
                        "thagurmukhi",
                        0x0a25,
                        "thalarabic",
                        0x0630,
                        "thalfinalarabic",
                        0xfeac,
                        "thanthakhatlowleftthai",
                        0xf898,
                        "thanthakhatlowrightthai",
                        0xf897,
                        "thanthakhatthai",
                        0x0e4c,
                        "thanthakhatupperleftthai",
                        0xf896,
                        "theharabic",
                        0x062b,
                        "thehfinalarabic",
                        0xfe9a,
                        "thehinitialarabic",
                        0xfe9b,
                        "thehmedialarabic",
                        0xfe9c,
                        "thereexists",
                        0x2203,
                        "therefore",
                        0x2234,
                        "theta",
                        0x03b8,
                        "theta1",
                        0x03d1,
                        "thetasymbolgreek",
                        0x03d1,
                        "thieuthacirclekorean",
                        0x3279,
                        "thieuthaparenkorean",
                        0x3219,
                        "thieuthcirclekorean",
                        0x326b,
                        "thieuthkorean",
                        0x314c,
                        "thieuthparenkorean",
                        0x320b,
                        "thirteencircle",
                        0x246c,
                        "thirteenparen",
                        0x2480,
                        "thirteenperiod",
                        0x2494,
                        "thonangmonthothai",
                        0x0e11,
                        "thook",
                        0x01ad,
                        "thophuthaothai",
                        0x0e12,
                        "thorn",
                        0x00fe,
                        "thothahanthai",
                        0x0e17,
                        "thothanthai",
                        0x0e10,
                        "thothongthai",
                        0x0e18,
                        "thothungthai",
                        0x0e16,
                        "thousandcyrillic",
                        0x0482,
                        "thousandsseparatorarabic",
                        0x066c,
                        "thousandsseparatorpersian",
                        0x066c,
                        "three",
                        0x0033,
                        "threearabic",
                        0x0663,
                        "threebengali",
                        0x09e9,
                        "threecircle",
                        0x2462,
                        "threecircleinversesansserif",
                        0x278c,
                        "threedeva",
                        0x0969,
                        "threeeighths",
                        0x215c,
                        "threegujarati",
                        0x0ae9,
                        "threegurmukhi",
                        0x0a69,
                        "threehackarabic",
                        0x0663,
                        "threehangzhou",
                        0x3023,
                        "threeideographicparen",
                        0x3222,
                        "threeinferior",
                        0x2083,
                        "threemonospace",
                        0xff13,
                        "threenumeratorbengali",
                        0x09f6,
                        "threeoldstyle",
                        0xf733,
                        "threeparen",
                        0x2476,
                        "threeperiod",
                        0x248a,
                        "threepersian",
                        0x06f3,
                        "threequarters",
                        0x00be,
                        "threequartersemdash",
                        0xf6de,
                        "threeroman",
                        0x2172,
                        "threesuperior",
                        0x00b3,
                        "threethai",
                        0x0e53,
                        "thzsquare",
                        0x3394,
                        "tihiragana",
                        0x3061,
                        "tikatakana",
                        0x30c1,
                        "tikatakanahalfwidth",
                        0xff81,
                        "tikeutacirclekorean",
                        0x3270,
                        "tikeutaparenkorean",
                        0x3210,
                        "tikeutcirclekorean",
                        0x3262,
                        "tikeutkorean",
                        0x3137,
                        "tikeutparenkorean",
                        0x3202,
                        "tilde",
                        0x02dc,
                        "tildebelowcmb",
                        0x0330,
                        "tildecmb",
                        0x0303,
                        "tildecomb",
                        0x0303,
                        "tildedoublecmb",
                        0x0360,
                        "tildeoperator",
                        0x223c,
                        "tildeoverlaycmb",
                        0x0334,
                        "tildeverticalcmb",
                        0x033e,
                        "timescircle",
                        0x2297,
                        "tipehahebrew",
                        0x0596,
                        "tipehalefthebrew",
                        0x0596,
                        "tippigurmukhi",
                        0x0a70,
                        "titlocyrilliccmb",
                        0x0483,
                        "tiwnarmenian",
                        0x057f,
                        "tlinebelow",
                        0x1e6f,
                        "tmonospace",
                        0xff54,
                        "toarmenian",
                        0x0569,
                        "tohiragana",
                        0x3068,
                        "tokatakana",
                        0x30c8,
                        "tokatakanahalfwidth",
                        0xff84,
                        "tonebarextrahighmod",
                        0x02e5,
                        "tonebarextralowmod",
                        0x02e9,
                        "tonebarhighmod",
                        0x02e6,
                        "tonebarlowmod",
                        0x02e8,
                        "tonebarmidmod",
                        0x02e7,
                        "tonefive",
                        0x01bd,
                        "tonesix",
                        0x0185,
                        "tonetwo",
                        0x01a8,
                        "tonos",
                        0x0384,
                        "tonsquare",
                        0x3327,
                        "topatakthai",
                        0x0e0f,
                        "tortoiseshellbracketleft",
                        0x3014,
                        "tortoiseshellbracketleftsmall",
                        0xfe5d,
                        "tortoiseshellbracketleftvertical",
                        0xfe39,
                        "tortoiseshellbracketright",
                        0x3015,
                        "tortoiseshellbracketrightsmall",
                        0xfe5e,
                        "tortoiseshellbracketrightvertical",
                        0xfe3a,
                        "totaothai",
                        0x0e15,
                        "tpalatalhook",
                        0x01ab,
                        "tparen",
                        0x24af,
                        "trademark",
                        0x2122,
                        "trademarksans",
                        0xf8ea,
                        "trademarkserif",
                        0xf6db,
                        "tretroflexhook",
                        0x0288,
                        "triagdn",
                        0x25bc,
                        "triaglf",
                        0x25c4,
                        "triagrt",
                        0x25ba,
                        "triagup",
                        0x25b2,
                        "ts",
                        0x02a6,
                        "tsadi",
                        0x05e6,
                        "tsadidagesh",
                        0xfb46,
                        "tsadidageshhebrew",
                        0xfb46,
                        "tsadihebrew",
                        0x05e6,
                        "tsecyrillic",
                        0x0446,
                        "tsere",
                        0x05b5,
                        "tsere12",
                        0x05b5,
                        "tsere1e",
                        0x05b5,
                        "tsere2b",
                        0x05b5,
                        "tserehebrew",
                        0x05b5,
                        "tserenarrowhebrew",
                        0x05b5,
                        "tserequarterhebrew",
                        0x05b5,
                        "tserewidehebrew",
                        0x05b5,
                        "tshecyrillic",
                        0x045b,
                        "tsuperior",
                        0xf6f3,
                        "ttabengali",
                        0x099f,
                        "ttadeva",
                        0x091f,
                        "ttagujarati",
                        0x0a9f,
                        "ttagurmukhi",
                        0x0a1f,
                        "tteharabic",
                        0x0679,
                        "ttehfinalarabic",
                        0xfb67,
                        "ttehinitialarabic",
                        0xfb68,
                        "ttehmedialarabic",
                        0xfb69,
                        "tthabengali",
                        0x09a0,
                        "tthadeva",
                        0x0920,
                        "tthagujarati",
                        0x0aa0,
                        "tthagurmukhi",
                        0x0a20,
                        "tturned",
                        0x0287,
                        "tuhiragana",
                        0x3064,
                        "tukatakana",
                        0x30c4,
                        "tukatakanahalfwidth",
                        0xff82,
                        "tusmallhiragana",
                        0x3063,
                        "tusmallkatakana",
                        0x30c3,
                        "tusmallkatakanahalfwidth",
                        0xff6f,
                        "twelvecircle",
                        0x246b,
                        "twelveparen",
                        0x247f,
                        "twelveperiod",
                        0x2493,
                        "twelveroman",
                        0x217b,
                        "twentycircle",
                        0x2473,
                        "twentyhangzhou",
                        0x5344,
                        "twentyparen",
                        0x2487,
                        "twentyperiod",
                        0x249b,
                        "two",
                        0x0032,
                        "twoarabic",
                        0x0662,
                        "twobengali",
                        0x09e8,
                        "twocircle",
                        0x2461,
                        "twocircleinversesansserif",
                        0x278b,
                        "twodeva",
                        0x0968,
                        "twodotenleader",
                        0x2025,
                        "twodotleader",
                        0x2025,
                        "twodotleadervertical",
                        0xfe30,
                        "twogujarati",
                        0x0ae8,
                        "twogurmukhi",
                        0x0a68,
                        "twohackarabic",
                        0x0662,
                        "twohangzhou",
                        0x3022,
                        "twoideographicparen",
                        0x3221,
                        "twoinferior",
                        0x2082,
                        "twomonospace",
                        0xff12,
                        "twonumeratorbengali",
                        0x09f5,
                        "twooldstyle",
                        0xf732,
                        "twoparen",
                        0x2475,
                        "twoperiod",
                        0x2489,
                        "twopersian",
                        0x06f2,
                        "tworoman",
                        0x2171,
                        "twostroke",
                        0x01bb,
                        "twosuperior",
                        0x00b2,
                        "twothai",
                        0x0e52,
                        "twothirds",
                        0x2154,
                        "u",
                        0x0075,
                        "uacute",
                        0x00fa,
                        "ubar",
                        0x0289,
                        "ubengali",
                        0x0989,
                        "ubopomofo",
                        0x3128,
                        "ubreve",
                        0x016d,
                        "ucaron",
                        0x01d4,
                        "ucircle",
                        0x24e4,
                        "ucircumflex",
                        0x00fb,
                        "ucircumflexbelow",
                        0x1e77,
                        "ucyrillic",
                        0x0443,
                        "udattadeva",
                        0x0951,
                        "udblacute",
                        0x0171,
                        "udblgrave",
                        0x0215,
                        "udeva",
                        0x0909,
                        "udieresis",
                        0x00fc,
                        "udieresisacute",
                        0x01d8,
                        "udieresisbelow",
                        0x1e73,
                        "udieresiscaron",
                        0x01da,
                        "udieresiscyrillic",
                        0x04f1,
                        "udieresisgrave",
                        0x01dc,
                        "udieresismacron",
                        0x01d6,
                        "udotbelow",
                        0x1ee5,
                        "ugrave",
                        0x00f9,
                        "ugujarati",
                        0x0a89,
                        "ugurmukhi",
                        0x0a09,
                        "uhiragana",
                        0x3046,
                        "uhookabove",
                        0x1ee7,
                        "uhorn",
                        0x01b0,
                        "uhornacute",
                        0x1ee9,
                        "uhorndotbelow",
                        0x1ef1,
                        "uhorngrave",
                        0x1eeb,
                        "uhornhookabove",
                        0x1eed,
                        "uhorntilde",
                        0x1eef,
                        "uhungarumlaut",
                        0x0171,
                        "uhungarumlautcyrillic",
                        0x04f3,
                        "uinvertedbreve",
                        0x0217,
                        "ukatakana",
                        0x30a6,
                        "ukatakanahalfwidth",
                        0xff73,
                        "ukcyrillic",
                        0x0479,
                        "ukorean",
                        0x315c,
                        "umacron",
                        0x016b,
                        "umacroncyrillic",
                        0x04ef,
                        "umacrondieresis",
                        0x1e7b,
                        "umatragurmukhi",
                        0x0a41,
                        "umonospace",
                        0xff55,
                        "underscore",
                        0x005f,
                        "underscoredbl",
                        0x2017,
                        "underscoremonospace",
                        0xff3f,
                        "underscorevertical",
                        0xfe33,
                        "underscorewavy",
                        0xfe4f,
                        "union",
                        0x222a,
                        "universal",
                        0x2200,
                        "uogonek",
                        0x0173,
                        "uparen",
                        0x24b0,
                        "upblock",
                        0x2580,
                        "upperdothebrew",
                        0x05c4,
                        "upsilon",
                        0x03c5,
                        "upsilondieresis",
                        0x03cb,
                        "upsilondieresistonos",
                        0x03b0,
                        "upsilonlatin",
                        0x028a,
                        "upsilontonos",
                        0x03cd,
                        "uptackbelowcmb",
                        0x031d,
                        "uptackmod",
                        0x02d4,
                        "uragurmukhi",
                        0x0a73,
                        "uring",
                        0x016f,
                        "ushortcyrillic",
                        0x045e,
                        "usmallhiragana",
                        0x3045,
                        "usmallkatakana",
                        0x30a5,
                        "usmallkatakanahalfwidth",
                        0xff69,
                        "ustraightcyrillic",
                        0x04af,
                        "ustraightstrokecyrillic",
                        0x04b1,
                        "utilde",
                        0x0169,
                        "utildeacute",
                        0x1e79,
                        "utildebelow",
                        0x1e75,
                        "uubengali",
                        0x098a,
                        "uudeva",
                        0x090a,
                        "uugujarati",
                        0x0a8a,
                        "uugurmukhi",
                        0x0a0a,
                        "uumatragurmukhi",
                        0x0a42,
                        "uuvowelsignbengali",
                        0x09c2,
                        "uuvowelsigndeva",
                        0x0942,
                        "uuvowelsigngujarati",
                        0x0ac2,
                        "uvowelsignbengali",
                        0x09c1,
                        "uvowelsigndeva",
                        0x0941,
                        "uvowelsigngujarati",
                        0x0ac1,
                        "v",
                        0x0076,
                        "vadeva",
                        0x0935,
                        "vagujarati",
                        0x0ab5,
                        "vagurmukhi",
                        0x0a35,
                        "vakatakana",
                        0x30f7,
                        "vav",
                        0x05d5,
                        "vavdagesh",
                        0xfb35,
                        "vavdagesh65",
                        0xfb35,
                        "vavdageshhebrew",
                        0xfb35,
                        "vavhebrew",
                        0x05d5,
                        "vavholam",
                        0xfb4b,
                        "vavholamhebrew",
                        0xfb4b,
                        "vavvavhebrew",
                        0x05f0,
                        "vavyodhebrew",
                        0x05f1,
                        "vcircle",
                        0x24e5,
                        "vdotbelow",
                        0x1e7f,
                        "vecyrillic",
                        0x0432,
                        "veharabic",
                        0x06a4,
                        "vehfinalarabic",
                        0xfb6b,
                        "vehinitialarabic",
                        0xfb6c,
                        "vehmedialarabic",
                        0xfb6d,
                        "vekatakana",
                        0x30f9,
                        "venus",
                        0x2640,
                        "verticalbar",
                        0x007c,
                        "verticallineabovecmb",
                        0x030d,
                        "verticallinebelowcmb",
                        0x0329,
                        "verticallinelowmod",
                        0x02cc,
                        "verticallinemod",
                        0x02c8,
                        "vewarmenian",
                        0x057e,
                        "vhook",
                        0x028b,
                        "vikatakana",
                        0x30f8,
                        "viramabengali",
                        0x09cd,
                        "viramadeva",
                        0x094d,
                        "viramagujarati",
                        0x0acd,
                        "visargabengali",
                        0x0983,
                        "visargadeva",
                        0x0903,
                        "visargagujarati",
                        0x0a83,
                        "vmonospace",
                        0xff56,
                        "voarmenian",
                        0x0578,
                        "voicediterationhiragana",
                        0x309e,
                        "voicediterationkatakana",
                        0x30fe,
                        "voicedmarkkana",
                        0x309b,
                        "voicedmarkkanahalfwidth",
                        0xff9e,
                        "vokatakana",
                        0x30fa,
                        "vparen",
                        0x24b1,
                        "vtilde",
                        0x1e7d,
                        "vturned",
                        0x028c,
                        "vuhiragana",
                        0x3094,
                        "vukatakana",
                        0x30f4,
                        "w",
                        0x0077,
                        "wacute",
                        0x1e83,
                        "waekorean",
                        0x3159,
                        "wahiragana",
                        0x308f,
                        "wakatakana",
                        0x30ef,
                        "wakatakanahalfwidth",
                        0xff9c,
                        "wakorean",
                        0x3158,
                        "wasmallhiragana",
                        0x308e,
                        "wasmallkatakana",
                        0x30ee,
                        "wattosquare",
                        0x3357,
                        "wavedash",
                        0x301c,
                        "wavyunderscorevertical",
                        0xfe34,
                        "wawarabic",
                        0x0648,
                        "wawfinalarabic",
                        0xfeee,
                        "wawhamzaabovearabic",
                        0x0624,
                        "wawhamzaabovefinalarabic",
                        0xfe86,
                        "wbsquare",
                        0x33dd,
                        "wcircle",
                        0x24e6,
                        "wcircumflex",
                        0x0175,
                        "wdieresis",
                        0x1e85,
                        "wdotaccent",
                        0x1e87,
                        "wdotbelow",
                        0x1e89,
                        "wehiragana",
                        0x3091,
                        "weierstrass",
                        0x2118,
                        "wekatakana",
                        0x30f1,
                        "wekorean",
                        0x315e,
                        "weokorean",
                        0x315d,
                        "wgrave",
                        0x1e81,
                        "whitebullet",
                        0x25e6,
                        "whitecircle",
                        0x25cb,
                        "whitecircleinverse",
                        0x25d9,
                        "whitecornerbracketleft",
                        0x300e,
                        "whitecornerbracketleftvertical",
                        0xfe43,
                        "whitecornerbracketright",
                        0x300f,
                        "whitecornerbracketrightvertical",
                        0xfe44,
                        "whitediamond",
                        0x25c7,
                        "whitediamondcontainingblacksmalldiamond",
                        0x25c8,
                        "whitedownpointingsmalltriangle",
                        0x25bf,
                        "whitedownpointingtriangle",
                        0x25bd,
                        "whiteleftpointingsmalltriangle",
                        0x25c3,
                        "whiteleftpointingtriangle",
                        0x25c1,
                        "whitelenticularbracketleft",
                        0x3016,
                        "whitelenticularbracketright",
                        0x3017,
                        "whiterightpointingsmalltriangle",
                        0x25b9,
                        "whiterightpointingtriangle",
                        0x25b7,
                        "whitesmallsquare",
                        0x25ab,
                        "whitesmilingface",
                        0x263a,
                        "whitesquare",
                        0x25a1,
                        "whitestar",
                        0x2606,
                        "whitetelephone",
                        0x260f,
                        "whitetortoiseshellbracketleft",
                        0x3018,
                        "whitetortoiseshellbracketright",
                        0x3019,
                        "whiteuppointingsmalltriangle",
                        0x25b5,
                        "whiteuppointingtriangle",
                        0x25b3,
                        "wihiragana",
                        0x3090,
                        "wikatakana",
                        0x30f0,
                        "wikorean",
                        0x315f,
                        "wmonospace",
                        0xff57,
                        "wohiragana",
                        0x3092,
                        "wokatakana",
                        0x30f2,
                        "wokatakanahalfwidth",
                        0xff66,
                        "won",
                        0x20a9,
                        "wonmonospace",
                        0xffe6,
                        "wowaenthai",
                        0x0e27,
                        "wparen",
                        0x24b2,
                        "wring",
                        0x1e98,
                        "wsuperior",
                        0x02b7,
                        "wturned",
                        0x028d,
                        "wynn",
                        0x01bf,
                        "x",
                        0x0078,
                        "xabovecmb",
                        0x033d,
                        "xbopomofo",
                        0x3112,
                        "xcircle",
                        0x24e7,
                        "xdieresis",
                        0x1e8d,
                        "xdotaccent",
                        0x1e8b,
                        "xeharmenian",
                        0x056d,
                        "xi",
                        0x03be,
                        "xmonospace",
                        0xff58,
                        "xparen",
                        0x24b3,
                        "xsuperior",
                        0x02e3,
                        "y",
                        0x0079,
                        "yaadosquare",
                        0x334e,
                        "yabengali",
                        0x09af,
                        "yacute",
                        0x00fd,
                        "yadeva",
                        0x092f,
                        "yaekorean",
                        0x3152,
                        "yagujarati",
                        0x0aaf,
                        "yagurmukhi",
                        0x0a2f,
                        "yahiragana",
                        0x3084,
                        "yakatakana",
                        0x30e4,
                        "yakatakanahalfwidth",
                        0xff94,
                        "yakorean",
                        0x3151,
                        "yamakkanthai",
                        0x0e4e,
                        "yasmallhiragana",
                        0x3083,
                        "yasmallkatakana",
                        0x30e3,
                        "yasmallkatakanahalfwidth",
                        0xff6c,
                        "yatcyrillic",
                        0x0463,
                        "ycircle",
                        0x24e8,
                        "ycircumflex",
                        0x0177,
                        "ydieresis",
                        0x00ff,
                        "ydotaccent",
                        0x1e8f,
                        "ydotbelow",
                        0x1ef5,
                        "yeharabic",
                        0x064a,
                        "yehbarreearabic",
                        0x06d2,
                        "yehbarreefinalarabic",
                        0xfbaf,
                        "yehfinalarabic",
                        0xfef2,
                        "yehhamzaabovearabic",
                        0x0626,
                        "yehhamzaabovefinalarabic",
                        0xfe8a,
                        "yehhamzaaboveinitialarabic",
                        0xfe8b,
                        "yehhamzaabovemedialarabic",
                        0xfe8c,
                        "yehinitialarabic",
                        0xfef3,
                        "yehmedialarabic",
                        0xfef4,
                        "yehmeeminitialarabic",
                        0xfcdd,
                        "yehmeemisolatedarabic",
                        0xfc58,
                        "yehnoonfinalarabic",
                        0xfc94,
                        "yehthreedotsbelowarabic",
                        0x06d1,
                        "yekorean",
                        0x3156,
                        "yen",
                        0x00a5,
                        "yenmonospace",
                        0xffe5,
                        "yeokorean",
                        0x3155,
                        "yeorinhieuhkorean",
                        0x3186,
                        "yerahbenyomohebrew",
                        0x05aa,
                        "yerahbenyomolefthebrew",
                        0x05aa,
                        "yericyrillic",
                        0x044b,
                        "yerudieresiscyrillic",
                        0x04f9,
                        "yesieungkorean",
                        0x3181,
                        "yesieungpansioskorean",
                        0x3183,
                        "yesieungsioskorean",
                        0x3182,
                        "yetivhebrew",
                        0x059a,
                        "ygrave",
                        0x1ef3,
                        "yhook",
                        0x01b4,
                        "yhookabove",
                        0x1ef7,
                        "yiarmenian",
                        0x0575,
                        "yicyrillic",
                        0x0457,
                        "yikorean",
                        0x3162,
                        "yinyang",
                        0x262f,
                        "yiwnarmenian",
                        0x0582,
                        "ymonospace",
                        0xff59,
                        "yod",
                        0x05d9,
                        "yoddagesh",
                        0xfb39,
                        "yoddageshhebrew",
                        0xfb39,
                        "yodhebrew",
                        0x05d9,
                        "yodyodhebrew",
                        0x05f2,
                        "yodyodpatahhebrew",
                        0xfb1f,
                        "yohiragana",
                        0x3088,
                        "yoikorean",
                        0x3189,
                        "yokatakana",
                        0x30e8,
                        "yokatakanahalfwidth",
                        0xff96,
                        "yokorean",
                        0x315b,
                        "yosmallhiragana",
                        0x3087,
                        "yosmallkatakana",
                        0x30e7,
                        "yosmallkatakanahalfwidth",
                        0xff6e,
                        "yotgreek",
                        0x03f3,
                        "yoyaekorean",
                        0x3188,
                        "yoyakorean",
                        0x3187,
                        "yoyakthai",
                        0x0e22,
                        "yoyingthai",
                        0x0e0d,
                        "yparen",
                        0x24b4,
                        "ypogegrammeni",
                        0x037a,
                        "ypogegrammenigreekcmb",
                        0x0345,
                        "yr",
                        0x01a6,
                        "yring",
                        0x1e99,
                        "ysuperior",
                        0x02b8,
                        "ytilde",
                        0x1ef9,
                        "yturned",
                        0x028e,
                        "yuhiragana",
                        0x3086,
                        "yuikorean",
                        0x318c,
                        "yukatakana",
                        0x30e6,
                        "yukatakanahalfwidth",
                        0xff95,
                        "yukorean",
                        0x3160,
                        "yusbigcyrillic",
                        0x046b,
                        "yusbigiotifiedcyrillic",
                        0x046d,
                        "yuslittlecyrillic",
                        0x0467,
                        "yuslittleiotifiedcyrillic",
                        0x0469,
                        "yusmallhiragana",
                        0x3085,
                        "yusmallkatakana",
                        0x30e5,
                        "yusmallkatakanahalfwidth",
                        0xff6d,
                        "yuyekorean",
                        0x318b,
                        "yuyeokorean",
                        0x318a,
                        "yyabengali",
                        0x09df,
                        "yyadeva",
                        0x095f,
                        "z",
                        0x007a,
                        "zaarmenian",
                        0x0566,
                        "zacute",
                        0x017a,
                        "zadeva",
                        0x095b,
                        "zagurmukhi",
                        0x0a5b,
                        "zaharabic",
                        0x0638,
                        "zahfinalarabic",
                        0xfec6,
                        "zahinitialarabic",
                        0xfec7,
                        "zahiragana",
                        0x3056,
                        "zahmedialarabic",
                        0xfec8,
                        "zainarabic",
                        0x0632,
                        "zainfinalarabic",
                        0xfeb0,
                        "zakatakana",
                        0x30b6,
                        "zaqefgadolhebrew",
                        0x0595,
                        "zaqefqatanhebrew",
                        0x0594,
                        "zarqahebrew",
                        0x0598,
                        "zayin",
                        0x05d6,
                        "zayindagesh",
                        0xfb36,
                        "zayindageshhebrew",
                        0xfb36,
                        "zayinhebrew",
                        0x05d6,
                        "zbopomofo",
                        0x3117,
                        "zcaron",
                        0x017e,
                        "zcircle",
                        0x24e9,
                        "zcircumflex",
                        0x1e91,
                        "zcurl",
                        0x0291,
                        "zdot",
                        0x017c,
                        "zdotaccent",
                        0x017c,
                        "zdotbelow",
                        0x1e93,
                        "zecyrillic",
                        0x0437,
                        "zedescendercyrillic",
                        0x0499,
                        "zedieresiscyrillic",
                        0x04df,
                        "zehiragana",
                        0x305c,
                        "zekatakana",
                        0x30bc,
                        "zero",
                        0x0030,
                        "zeroarabic",
                        0x0660,
                        "zerobengali",
                        0x09e6,
                        "zerodeva",
                        0x0966,
                        "zerogujarati",
                        0x0ae6,
                        "zerogurmukhi",
                        0x0a66,
                        "zerohackarabic",
                        0x0660,
                        "zeroinferior",
                        0x2080,
                        "zeromonospace",
                        0xff10,
                        "zerooldstyle",
                        0xf730,
                        "zeropersian",
                        0x06f0,
                        "zerosuperior",
                        0x2070,
                        "zerothai",
                        0x0e50,
                        "zerowidthjoiner",
                        0xfeff,
                        "zerowidthnonjoiner",
                        0x200c,
                        "zerowidthspace",
                        0x200b,
                        "zeta",
                        0x03b6,
                        "zhbopomofo",
                        0x3113,
                        "zhearmenian",
                        0x056a,
                        "zhebrevecyrillic",
                        0x04c2,
                        "zhecyrillic",
                        0x0436,
                        "zhedescendercyrillic",
                        0x0497,
                        "zhedieresiscyrillic",
                        0x04dd,
                        "zihiragana",
                        0x3058,
                        "zikatakana",
                        0x30b8,
                        "zinorhebrew",
                        0x05ae,
                        "zlinebelow",
                        0x1e95,
                        "zmonospace",
                        0xff5a,
                        "zohiragana",
                        0x305e,
                        "zokatakana",
                        0x30be,
                        "zparen",
                        0x24b5,
                        "zretroflexhook",
                        0x0290,
                        "zstroke",
                        0x01b6,
                        "zuhiragana",
                        0x305a,
                        "zukatakana",
                        0x30ba,
                        ".notdef",
                        0x0000,
                        "angbracketleftbig",
                        0x2329,
                        "angbracketleftBig",
                        0x2329,
                        "angbracketleftbigg",
                        0x2329,
                        "angbracketleftBigg",
                        0x2329,
                        "angbracketrightBig",
                        0x232a,
                        "angbracketrightbig",
                        0x232a,
                        "angbracketrightBigg",
                        0x232a,
                        "angbracketrightbigg",
                        0x232a,
                        "arrowhookleft",
                        0x21aa,
                        "arrowhookright",
                        0x21a9,
                        "arrowlefttophalf",
                        0x21bc,
                        "arrowleftbothalf",
                        0x21bd,
                        "arrownortheast",
                        0x2197,
                        "arrownorthwest",
                        0x2196,
                        "arrowrighttophalf",
                        0x21c0,
                        "arrowrightbothalf",
                        0x21c1,
                        "arrowsoutheast",
                        0x2198,
                        "arrowsouthwest",
                        0x2199,
                        "backslashbig",
                        0x2216,
                        "backslashBig",
                        0x2216,
                        "backslashBigg",
                        0x2216,
                        "backslashbigg",
                        0x2216,
                        "bardbl",
                        0x2016,
                        "bracehtipdownleft",
                        0xfe37,
                        "bracehtipdownright",
                        0xfe37,
                        "bracehtipupleft",
                        0xfe38,
                        "bracehtipupright",
                        0xfe38,
                        "braceleftBig",
                        0x007b,
                        "braceleftbig",
                        0x007b,
                        "braceleftbigg",
                        0x007b,
                        "braceleftBigg",
                        0x007b,
                        "bracerightBig",
                        0x007d,
                        "bracerightbig",
                        0x007d,
                        "bracerightbigg",
                        0x007d,
                        "bracerightBigg",
                        0x007d,
                        "bracketleftbig",
                        0x005b,
                        "bracketleftBig",
                        0x005b,
                        "bracketleftbigg",
                        0x005b,
                        "bracketleftBigg",
                        0x005b,
                        "bracketrightBig",
                        0x005d,
                        "bracketrightbig",
                        0x005d,
                        "bracketrightbigg",
                        0x005d,
                        "bracketrightBigg",
                        0x005d,
                        "ceilingleftbig",
                        0x2308,
                        "ceilingleftBig",
                        0x2308,
                        "ceilingleftBigg",
                        0x2308,
                        "ceilingleftbigg",
                        0x2308,
                        "ceilingrightbig",
                        0x2309,
                        "ceilingrightBig",
                        0x2309,
                        "ceilingrightbigg",
                        0x2309,
                        "ceilingrightBigg",
                        0x2309,
                        "circledotdisplay",
                        0x2299,
                        "circledottext",
                        0x2299,
                        "circlemultiplydisplay",
                        0x2297,
                        "circlemultiplytext",
                        0x2297,
                        "circleplusdisplay",
                        0x2295,
                        "circleplustext",
                        0x2295,
                        "contintegraldisplay",
                        0x222e,
                        "contintegraltext",
                        0x222e,
                        "coproductdisplay",
                        0x2210,
                        "coproducttext",
                        0x2210,
                        "floorleftBig",
                        0x230a,
                        "floorleftbig",
                        0x230a,
                        "floorleftbigg",
                        0x230a,
                        "floorleftBigg",
                        0x230a,
                        "floorrightbig",
                        0x230b,
                        "floorrightBig",
                        0x230b,
                        "floorrightBigg",
                        0x230b,
                        "floorrightbigg",
                        0x230b,
                        "hatwide",
                        0x0302,
                        "hatwider",
                        0x0302,
                        "hatwidest",
                        0x0302,
                        "intercal",
                        0x1d40,
                        "integraldisplay",
                        0x222b,
                        "integraltext",
                        0x222b,
                        "intersectiondisplay",
                        0x22c2,
                        "intersectiontext",
                        0x22c2,
                        "logicalanddisplay",
                        0x2227,
                        "logicalandtext",
                        0x2227,
                        "logicalordisplay",
                        0x2228,
                        "logicalortext",
                        0x2228,
                        "parenleftBig",
                        0x0028,
                        "parenleftbig",
                        0x0028,
                        "parenleftBigg",
                        0x0028,
                        "parenleftbigg",
                        0x0028,
                        "parenrightBig",
                        0x0029,
                        "parenrightbig",
                        0x0029,
                        "parenrightBigg",
                        0x0029,
                        "parenrightbigg",
                        0x0029,
                        "prime",
                        0x2032,
                        "productdisplay",
                        0x220f,
                        "producttext",
                        0x220f,
                        "radicalbig",
                        0x221a,
                        "radicalBig",
                        0x221a,
                        "radicalBigg",
                        0x221a,
                        "radicalbigg",
                        0x221a,
                        "radicalbt",
                        0x221a,
                        "radicaltp",
                        0x221a,
                        "radicalvertex",
                        0x221a,
                        "slashbig",
                        0x002f,
                        "slashBig",
                        0x002f,
                        "slashBigg",
                        0x002f,
                        "slashbigg",
                        0x002f,
                        "summationdisplay",
                        0x2211,
                        "summationtext",
                        0x2211,
                        "tildewide",
                        0x02dc,
                        "tildewider",
                        0x02dc,
                        "tildewidest",
                        0x02dc,
                        "uniondisplay",
                        0x22c3,
                        "unionmultidisplay",
                        0x228e,
                        "unionmultitext",
                        0x228e,
                        "unionsqdisplay",
                        0x2294,
                        "unionsqtext",
                        0x2294,
                        "uniontext",
                        0x22c3,
                        "vextenddouble",
                        0x2225,
                        "vextendsingle",
                        0x2223
                    ];
                });
                const getDingbatsGlyphsUnicode = (0, _core_utils_js__WEBPACK_IMPORTED_MODULE_0__.getArrayLookupTableFactory)(function() {
                    return [
                        "space",
                        0x0020,
                        "a1",
                        0x2701,
                        "a2",
                        0x2702,
                        "a202",
                        0x2703,
                        "a3",
                        0x2704,
                        "a4",
                        0x260e,
                        "a5",
                        0x2706,
                        "a119",
                        0x2707,
                        "a118",
                        0x2708,
                        "a117",
                        0x2709,
                        "a11",
                        0x261b,
                        "a12",
                        0x261e,
                        "a13",
                        0x270c,
                        "a14",
                        0x270d,
                        "a15",
                        0x270e,
                        "a16",
                        0x270f,
                        "a105",
                        0x2710,
                        "a17",
                        0x2711,
                        "a18",
                        0x2712,
                        "a19",
                        0x2713,
                        "a20",
                        0x2714,
                        "a21",
                        0x2715,
                        "a22",
                        0x2716,
                        "a23",
                        0x2717,
                        "a24",
                        0x2718,
                        "a25",
                        0x2719,
                        "a26",
                        0x271a,
                        "a27",
                        0x271b,
                        "a28",
                        0x271c,
                        "a6",
                        0x271d,
                        "a7",
                        0x271e,
                        "a8",
                        0x271f,
                        "a9",
                        0x2720,
                        "a10",
                        0x2721,
                        "a29",
                        0x2722,
                        "a30",
                        0x2723,
                        "a31",
                        0x2724,
                        "a32",
                        0x2725,
                        "a33",
                        0x2726,
                        "a34",
                        0x2727,
                        "a35",
                        0x2605,
                        "a36",
                        0x2729,
                        "a37",
                        0x272a,
                        "a38",
                        0x272b,
                        "a39",
                        0x272c,
                        "a40",
                        0x272d,
                        "a41",
                        0x272e,
                        "a42",
                        0x272f,
                        "a43",
                        0x2730,
                        "a44",
                        0x2731,
                        "a45",
                        0x2732,
                        "a46",
                        0x2733,
                        "a47",
                        0x2734,
                        "a48",
                        0x2735,
                        "a49",
                        0x2736,
                        "a50",
                        0x2737,
                        "a51",
                        0x2738,
                        "a52",
                        0x2739,
                        "a53",
                        0x273a,
                        "a54",
                        0x273b,
                        "a55",
                        0x273c,
                        "a56",
                        0x273d,
                        "a57",
                        0x273e,
                        "a58",
                        0x273f,
                        "a59",
                        0x2740,
                        "a60",
                        0x2741,
                        "a61",
                        0x2742,
                        "a62",
                        0x2743,
                        "a63",
                        0x2744,
                        "a64",
                        0x2745,
                        "a65",
                        0x2746,
                        "a66",
                        0x2747,
                        "a67",
                        0x2748,
                        "a68",
                        0x2749,
                        "a69",
                        0x274a,
                        "a70",
                        0x274b,
                        "a71",
                        0x25cf,
                        "a72",
                        0x274d,
                        "a73",
                        0x25a0,
                        "a74",
                        0x274f,
                        "a203",
                        0x2750,
                        "a75",
                        0x2751,
                        "a204",
                        0x2752,
                        "a76",
                        0x25b2,
                        "a77",
                        0x25bc,
                        "a78",
                        0x25c6,
                        "a79",
                        0x2756,
                        "a81",
                        0x25d7,
                        "a82",
                        0x2758,
                        "a83",
                        0x2759,
                        "a84",
                        0x275a,
                        "a97",
                        0x275b,
                        "a98",
                        0x275c,
                        "a99",
                        0x275d,
                        "a100",
                        0x275e,
                        "a101",
                        0x2761,
                        "a102",
                        0x2762,
                        "a103",
                        0x2763,
                        "a104",
                        0x2764,
                        "a106",
                        0x2765,
                        "a107",
                        0x2766,
                        "a108",
                        0x2767,
                        "a112",
                        0x2663,
                        "a111",
                        0x2666,
                        "a110",
                        0x2665,
                        "a109",
                        0x2660,
                        "a120",
                        0x2460,
                        "a121",
                        0x2461,
                        "a122",
                        0x2462,
                        "a123",
                        0x2463,
                        "a124",
                        0x2464,
                        "a125",
                        0x2465,
                        "a126",
                        0x2466,
                        "a127",
                        0x2467,
                        "a128",
                        0x2468,
                        "a129",
                        0x2469,
                        "a130",
                        0x2776,
                        "a131",
                        0x2777,
                        "a132",
                        0x2778,
                        "a133",
                        0x2779,
                        "a134",
                        0x277a,
                        "a135",
                        0x277b,
                        "a136",
                        0x277c,
                        "a137",
                        0x277d,
                        "a138",
                        0x277e,
                        "a139",
                        0x277f,
                        "a140",
                        0x2780,
                        "a141",
                        0x2781,
                        "a142",
                        0x2782,
                        "a143",
                        0x2783,
                        "a144",
                        0x2784,
                        "a145",
                        0x2785,
                        "a146",
                        0x2786,
                        "a147",
                        0x2787,
                        "a148",
                        0x2788,
                        "a149",
                        0x2789,
                        "a150",
                        0x278a,
                        "a151",
                        0x278b,
                        "a152",
                        0x278c,
                        "a153",
                        0x278d,
                        "a154",
                        0x278e,
                        "a155",
                        0x278f,
                        "a156",
                        0x2790,
                        "a157",
                        0x2791,
                        "a158",
                        0x2792,
                        "a159",
                        0x2793,
                        "a160",
                        0x2794,
                        "a161",
                        0x2192,
                        "a163",
                        0x2194,
                        "a164",
                        0x2195,
                        "a196",
                        0x2798,
                        "a165",
                        0x2799,
                        "a192",
                        0x279a,
                        "a166",
                        0x279b,
                        "a167",
                        0x279c,
                        "a168",
                        0x279d,
                        "a169",
                        0x279e,
                        "a170",
                        0x279f,
                        "a171",
                        0x27a0,
                        "a172",
                        0x27a1,
                        "a173",
                        0x27a2,
                        "a162",
                        0x27a3,
                        "a174",
                        0x27a4,
                        "a175",
                        0x27a5,
                        "a176",
                        0x27a6,
                        "a177",
                        0x27a7,
                        "a178",
                        0x27a8,
                        "a179",
                        0x27a9,
                        "a193",
                        0x27aa,
                        "a180",
                        0x27ab,
                        "a199",
                        0x27ac,
                        "a181",
                        0x27ad,
                        "a200",
                        0x27ae,
                        "a182",
                        0x27af,
                        "a201",
                        0x27b1,
                        "a183",
                        0x27b2,
                        "a184",
                        0x27b3,
                        "a197",
                        0x27b4,
                        "a185",
                        0x27b5,
                        "a194",
                        0x27b6,
                        "a198",
                        0x27b7,
                        "a186",
                        0x27b8,
                        "a195",
                        0x27b9,
                        "a187",
                        0x27ba,
                        "a188",
                        0x27bb,
                        "a189",
                        0x27bc,
                        "a190",
                        0x27bd,
                        "a191",
                        0x27be,
                        "a89",
                        0x2768,
                        "a90",
                        0x2769,
                        "a93",
                        0x276a,
                        "a94",
                        0x276b,
                        "a91",
                        0x276c,
                        "a92",
                        0x276d,
                        "a205",
                        0x276e,
                        "a85",
                        0x276f,
                        "a206",
                        0x2770,
                        "a86",
                        0x2771,
                        "a87",
                        0x2772,
                        "a88",
                        0x2773,
                        "a95",
                        0x2774,
                        "a96",
                        0x2775,
                        ".notdef",
                        0x0000
                    ];
                });
            /***/ },
            /* 40 */ /***/ (__unused_webpack_module, __webpack_exports__, __w_pdfjs_require__)=>{
                __w_pdfjs_require__.r(__webpack_exports__);
                /* harmony export */ __w_pdfjs_require__.d(__webpack_exports__, {
                    /* harmony export */ "getNormalizedUnicodes": ()=>/* binding */ getNormalizedUnicodes,
                    /* harmony export */ "getUnicodeForGlyph": ()=>/* binding */ getUnicodeForGlyph,
                    /* harmony export */ "getUnicodeRangeFor": ()=>/* binding */ getUnicodeRangeFor,
                    /* harmony export */ "mapSpecialUnicodeValues": ()=>/* binding */ mapSpecialUnicodeValues,
                    /* harmony export */ "reverseIfRtl": ()=>/* binding */ reverseIfRtl
                });
                /* harmony import */ var _core_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __w_pdfjs_require__(9);
                const getSpecialPUASymbols = (0, _core_utils_js__WEBPACK_IMPORTED_MODULE_0__.getLookupTableFactory)(function(t) {
                    t[63721] = 0x00a9;
                    t[63193] = 0x00a9;
                    t[63720] = 0x00ae;
                    t[63194] = 0x00ae;
                    t[63722] = 0x2122;
                    t[63195] = 0x2122;
                    t[63729] = 0x23a7;
                    t[63730] = 0x23a8;
                    t[63731] = 0x23a9;
                    t[63740] = 0x23ab;
                    t[63741] = 0x23ac;
                    t[63742] = 0x23ad;
                    t[63726] = 0x23a1;
                    t[63727] = 0x23a2;
                    t[63728] = 0x23a3;
                    t[63737] = 0x23a4;
                    t[63738] = 0x23a5;
                    t[63739] = 0x23a6;
                    t[63723] = 0x239b;
                    t[63724] = 0x239c;
                    t[63725] = 0x239d;
                    t[63734] = 0x239e;
                    t[63735] = 0x239f;
                    t[63736] = 0x23a0;
                });
                function mapSpecialUnicodeValues(code) {
                    if (code >= 0xfff0 && code <= 0xffff) return 0;
                    else if (code >= 0xf600 && code <= 0xf8ff) return getSpecialPUASymbols()[code] || code;
                    else if (code === 0x00ad) return 0x002d;
                    return code;
                }
                function getUnicodeForGlyph(name, glyphsUnicodeMap) {
                    let unicode = glyphsUnicodeMap[name];
                    if (unicode !== undefined) return unicode;
                    if (!name) return -1;
                    if (name[0] === "u") {
                        const nameLen = name.length;
                        let hexStr;
                        if (nameLen === 7 && name[1] === "n" && name[2] === "i") hexStr = name.substring(3);
                        else if (nameLen >= 5 && nameLen <= 7) hexStr = name.substring(1);
                        else return -1;
                        if (hexStr === hexStr.toUpperCase()) {
                            unicode = parseInt(hexStr, 16);
                            if (unicode >= 0) return unicode;
                        }
                    }
                    return -1;
                }
                const UnicodeRanges = [
                    {
                        begin: 0x0000,
                        end: 0x007f
                    },
                    {
                        begin: 0x0080,
                        end: 0x00ff
                    },
                    {
                        begin: 0x0100,
                        end: 0x017f
                    },
                    {
                        begin: 0x0180,
                        end: 0x024f
                    },
                    {
                        begin: 0x0250,
                        end: 0x02af
                    },
                    {
                        begin: 0x02b0,
                        end: 0x02ff
                    },
                    {
                        begin: 0x0300,
                        end: 0x036f
                    },
                    {
                        begin: 0x0370,
                        end: 0x03ff
                    },
                    {
                        begin: 0x2c80,
                        end: 0x2cff
                    },
                    {
                        begin: 0x0400,
                        end: 0x04ff
                    },
                    {
                        begin: 0x0530,
                        end: 0x058f
                    },
                    {
                        begin: 0x0590,
                        end: 0x05ff
                    },
                    {
                        begin: 0xa500,
                        end: 0xa63f
                    },
                    {
                        begin: 0x0600,
                        end: 0x06ff
                    },
                    {
                        begin: 0x07c0,
                        end: 0x07ff
                    },
                    {
                        begin: 0x0900,
                        end: 0x097f
                    },
                    {
                        begin: 0x0980,
                        end: 0x09ff
                    },
                    {
                        begin: 0x0a00,
                        end: 0x0a7f
                    },
                    {
                        begin: 0x0a80,
                        end: 0x0aff
                    },
                    {
                        begin: 0x0b00,
                        end: 0x0b7f
                    },
                    {
                        begin: 0x0b80,
                        end: 0x0bff
                    },
                    {
                        begin: 0x0c00,
                        end: 0x0c7f
                    },
                    {
                        begin: 0x0c80,
                        end: 0x0cff
                    },
                    {
                        begin: 0x0d00,
                        end: 0x0d7f
                    },
                    {
                        begin: 0x0e00,
                        end: 0x0e7f
                    },
                    {
                        begin: 0x0e80,
                        end: 0x0eff
                    },
                    {
                        begin: 0x10a0,
                        end: 0x10ff
                    },
                    {
                        begin: 0x1b00,
                        end: 0x1b7f
                    },
                    {
                        begin: 0x1100,
                        end: 0x11ff
                    },
                    {
                        begin: 0x1e00,
                        end: 0x1eff
                    },
                    {
                        begin: 0x1f00,
                        end: 0x1fff
                    },
                    {
                        begin: 0x2000,
                        end: 0x206f
                    },
                    {
                        begin: 0x2070,
                        end: 0x209f
                    },
                    {
                        begin: 0x20a0,
                        end: 0x20cf
                    },
                    {
                        begin: 0x20d0,
                        end: 0x20ff
                    },
                    {
                        begin: 0x2100,
                        end: 0x214f
                    },
                    {
                        begin: 0x2150,
                        end: 0x218f
                    },
                    {
                        begin: 0x2190,
                        end: 0x21ff
                    },
                    {
                        begin: 0x2200,
                        end: 0x22ff
                    },
                    {
                        begin: 0x2300,
                        end: 0x23ff
                    },
                    {
                        begin: 0x2400,
                        end: 0x243f
                    },
                    {
                        begin: 0x2440,
                        end: 0x245f
                    },
                    {
                        begin: 0x2460,
                        end: 0x24ff
                    },
                    {
                        begin: 0x2500,
                        end: 0x257f
                    },
                    {
                        begin: 0x2580,
                        end: 0x259f
                    },
                    {
                        begin: 0x25a0,
                        end: 0x25ff
                    },
                    {
                        begin: 0x2600,
                        end: 0x26ff
                    },
                    {
                        begin: 0x2700,
                        end: 0x27bf
                    },
                    {
                        begin: 0x3000,
                        end: 0x303f
                    },
                    {
                        begin: 0x3040,
                        end: 0x309f
                    },
                    {
                        begin: 0x30a0,
                        end: 0x30ff
                    },
                    {
                        begin: 0x3100,
                        end: 0x312f
                    },
                    {
                        begin: 0x3130,
                        end: 0x318f
                    },
                    {
                        begin: 0xa840,
                        end: 0xa87f
                    },
                    {
                        begin: 0x3200,
                        end: 0x32ff
                    },
                    {
                        begin: 0x3300,
                        end: 0x33ff
                    },
                    {
                        begin: 0xac00,
                        end: 0xd7af
                    },
                    {
                        begin: 0xd800,
                        end: 0xdfff
                    },
                    {
                        begin: 0x10900,
                        end: 0x1091f
                    },
                    {
                        begin: 0x4e00,
                        end: 0x9fff
                    },
                    {
                        begin: 0xe000,
                        end: 0xf8ff
                    },
                    {
                        begin: 0x31c0,
                        end: 0x31ef
                    },
                    {
                        begin: 0xfb00,
                        end: 0xfb4f
                    },
                    {
                        begin: 0xfb50,
                        end: 0xfdff
                    },
                    {
                        begin: 0xfe20,
                        end: 0xfe2f
                    },
                    {
                        begin: 0xfe10,
                        end: 0xfe1f
                    },
                    {
                        begin: 0xfe50,
                        end: 0xfe6f
                    },
                    {
                        begin: 0xfe70,
                        end: 0xfeff
                    },
                    {
                        begin: 0xff00,
                        end: 0xffef
                    },
                    {
                        begin: 0xfff0,
                        end: 0xffff
                    },
                    {
                        begin: 0x0f00,
                        end: 0x0fff
                    },
                    {
                        begin: 0x0700,
                        end: 0x074f
                    },
                    {
                        begin: 0x0780,
                        end: 0x07bf
                    },
                    {
                        begin: 0x0d80,
                        end: 0x0dff
                    },
                    {
                        begin: 0x1000,
                        end: 0x109f
                    },
                    {
                        begin: 0x1200,
                        end: 0x137f
                    },
                    {
                        begin: 0x13a0,
                        end: 0x13ff
                    },
                    {
                        begin: 0x1400,
                        end: 0x167f
                    },
                    {
                        begin: 0x1680,
                        end: 0x169f
                    },
                    {
                        begin: 0x16a0,
                        end: 0x16ff
                    },
                    {
                        begin: 0x1780,
                        end: 0x17ff
                    },
                    {
                        begin: 0x1800,
                        end: 0x18af
                    },
                    {
                        begin: 0x2800,
                        end: 0x28ff
                    },
                    {
                        begin: 0xa000,
                        end: 0xa48f
                    },
                    {
                        begin: 0x1700,
                        end: 0x171f
                    },
                    {
                        begin: 0x10300,
                        end: 0x1032f
                    },
                    {
                        begin: 0x10330,
                        end: 0x1034f
                    },
                    {
                        begin: 0x10400,
                        end: 0x1044f
                    },
                    {
                        begin: 0x1d000,
                        end: 0x1d0ff
                    },
                    {
                        begin: 0x1d400,
                        end: 0x1d7ff
                    },
                    {
                        begin: 0xff000,
                        end: 0xffffd
                    },
                    {
                        begin: 0xfe00,
                        end: 0xfe0f
                    },
                    {
                        begin: 0xe0000,
                        end: 0xe007f
                    },
                    {
                        begin: 0x1900,
                        end: 0x194f
                    },
                    {
                        begin: 0x1950,
                        end: 0x197f
                    },
                    {
                        begin: 0x1980,
                        end: 0x19df
                    },
                    {
                        begin: 0x1a00,
                        end: 0x1a1f
                    },
                    {
                        begin: 0x2c00,
                        end: 0x2c5f
                    },
                    {
                        begin: 0x2d30,
                        end: 0x2d7f
                    },
                    {
                        begin: 0x4dc0,
                        end: 0x4dff
                    },
                    {
                        begin: 0xa800,
                        end: 0xa82f
                    },
                    {
                        begin: 0x10000,
                        end: 0x1007f
                    },
                    {
                        begin: 0x10140,
                        end: 0x1018f
                    },
                    {
                        begin: 0x10380,
                        end: 0x1039f
                    },
                    {
                        begin: 0x103a0,
                        end: 0x103df
                    },
                    {
                        begin: 0x10450,
                        end: 0x1047f
                    },
                    {
                        begin: 0x10480,
                        end: 0x104af
                    },
                    {
                        begin: 0x10800,
                        end: 0x1083f
                    },
                    {
                        begin: 0x10a00,
                        end: 0x10a5f
                    },
                    {
                        begin: 0x1d300,
                        end: 0x1d35f
                    },
                    {
                        begin: 0x12000,
                        end: 0x123ff
                    },
                    {
                        begin: 0x1d360,
                        end: 0x1d37f
                    },
                    {
                        begin: 0x1b80,
                        end: 0x1bbf
                    },
                    {
                        begin: 0x1c00,
                        end: 0x1c4f
                    },
                    {
                        begin: 0x1c50,
                        end: 0x1c7f
                    },
                    {
                        begin: 0xa880,
                        end: 0xa8df
                    },
                    {
                        begin: 0xa900,
                        end: 0xa92f
                    },
                    {
                        begin: 0xa930,
                        end: 0xa95f
                    },
                    {
                        begin: 0xaa00,
                        end: 0xaa5f
                    },
                    {
                        begin: 0x10190,
                        end: 0x101cf
                    },
                    {
                        begin: 0x101d0,
                        end: 0x101ff
                    },
                    {
                        begin: 0x102a0,
                        end: 0x102df
                    },
                    {
                        begin: 0x1f030,
                        end: 0x1f09f
                    }
                ];
                function getUnicodeRangeFor(value) {
                    for(let i = 0, ii = UnicodeRanges.length; i < ii; i++){
                        const range = UnicodeRanges[i];
                        if (value >= range.begin && value < range.end) return i;
                    }
                    return -1;
                }
                function isRTLRangeFor(value) {
                    let range = UnicodeRanges[13];
                    if (value >= range.begin && value < range.end) return true;
                    range = UnicodeRanges[11];
                    if (value >= range.begin && value < range.end) return true;
                    return false;
                }
                const getNormalizedUnicodes = (0, _core_utils_js__WEBPACK_IMPORTED_MODULE_0__.getArrayLookupTableFactory)(function() {
                    return [
                        "\xa8",
                        " ̈",
                        "\xaf",
                        " ̄",
                        "\xb4",
                        " ́",
                        "\xb5",
                        "μ",
                        "\xb8",
                        " ̧",
                        "Ĳ",
                        "IJ",
                        "ĳ",
                        "ij",
                        "Ŀ",
                        "L\xb7",
                        "ŀ",
                        "l\xb7",
                        "ŉ",
                        "ʼn",
                        "ſ",
                        "s",
                        "Ǆ",
                        "DŽ",
                        "ǅ",
                        "Dž",
                        "ǆ",
                        "dž",
                        "Ǉ",
                        "LJ",
                        "ǈ",
                        "Lj",
                        "ǉ",
                        "lj",
                        "Ǌ",
                        "NJ",
                        "ǋ",
                        "Nj",
                        "ǌ",
                        "nj",
                        "Ǳ",
                        "DZ",
                        "ǲ",
                        "Dz",
                        "ǳ",
                        "dz",
                        "˘",
                        " ̆",
                        "˙",
                        " ̇",
                        "˚",
                        " ̊",
                        "˛",
                        " ̨",
                        "˜",
                        " ̃",
                        "˝",
                        " ̋",
                        "ͺ",
                        " ͅ",
                        "΄",
                        " ́",
                        "ϐ",
                        "β",
                        "ϑ",
                        "θ",
                        "ϒ",
                        "Υ",
                        "ϕ",
                        "φ",
                        "ϖ",
                        "π",
                        "ϰ",
                        "κ",
                        "ϱ",
                        "ρ",
                        "ϲ",
                        "ς",
                        "ϴ",
                        "Θ",
                        "ϵ",
                        "ε",
                        "Ϲ",
                        "Σ",
                        "և",
                        "եւ",
                        "ٵ",
                        "اٴ",
                        "ٶ",
                        "وٴ",
                        "ٷ",
                        "ۇٴ",
                        "ٸ",
                        "يٴ",
                        "ำ",
                        "ํา",
                        "ຳ",
                        "ໍາ",
                        "ໜ",
                        "ຫນ",
                        "ໝ",
                        "ຫມ",
                        "ཷ",
                        "ྲཱྀ",
                        "ཹ",
                        "ླཱྀ",
                        "ẚ",
                        "aʾ",
                        "᾽",
                        " ̓",
                        "᾿",
                        " ̓",
                        "῀",
                        " ͂",
                        "῾",
                        " ̔",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        " ",
                        "‗",
                        " ̳",
                        "․",
                        ".",
                        "‥",
                        "..",
                        "…",
                        "...",
                        "″",
                        "′′",
                        "‴",
                        "′′′",
                        "‶",
                        "‵‵",
                        "‷",
                        "‵‵‵",
                        "‼",
                        "!!",
                        "‾",
                        " ̅",
                        "⁇",
                        "??",
                        "⁈",
                        "?!",
                        "⁉",
                        "!?",
                        "⁗",
                        "′′′′",
                        " ",
                        " ",
                        "₨",
                        "Rs",
                        "℀",
                        "a/c",
                        "℁",
                        "a/s",
                        "℃",
                        "\xb0C",
                        "℅",
                        "c/o",
                        "℆",
                        "c/u",
                        "ℇ",
                        "Ɛ",
                        "℉",
                        "\xb0F",
                        "№",
                        "No",
                        "℡",
                        "TEL",
                        "ℵ",
                        "א",
                        "ℶ",
                        "ב",
                        "ℷ",
                        "ג",
                        "ℸ",
                        "ד",
                        "℻",
                        "FAX",
                        "Ⅰ",
                        "I",
                        "Ⅱ",
                        "II",
                        "Ⅲ",
                        "III",
                        "Ⅳ",
                        "IV",
                        "Ⅴ",
                        "V",
                        "Ⅵ",
                        "VI",
                        "Ⅶ",
                        "VII",
                        "Ⅷ",
                        "VIII",
                        "Ⅸ",
                        "IX",
                        "Ⅹ",
                        "X",
                        "Ⅺ",
                        "XI",
                        "Ⅻ",
                        "XII",
                        "Ⅼ",
                        "L",
                        "Ⅽ",
                        "C",
                        "Ⅾ",
                        "D",
                        "Ⅿ",
                        "M",
                        "ⅰ",
                        "i",
                        "ⅱ",
                        "ii",
                        "ⅲ",
                        "iii",
                        "ⅳ",
                        "iv",
                        "ⅴ",
                        "v",
                        "ⅵ",
                        "vi",
                        "ⅶ",
                        "vii",
                        "ⅷ",
                        "viii",
                        "ⅸ",
                        "ix",
                        "ⅹ",
                        "x",
                        "ⅺ",
                        "xi",
                        "ⅻ",
                        "xii",
                        "ⅼ",
                        "l",
                        "ⅽ",
                        "c",
                        "ⅾ",
                        "d",
                        "ⅿ",
                        "m",
                        "∬",
                        "∫∫",
                        "∭",
                        "∫∫∫",
                        "∯",
                        "∮∮",
                        "∰",
                        "∮∮∮",
                        "⑴",
                        "(1)",
                        "⑵",
                        "(2)",
                        "⑶",
                        "(3)",
                        "⑷",
                        "(4)",
                        "⑸",
                        "(5)",
                        "⑹",
                        "(6)",
                        "⑺",
                        "(7)",
                        "⑻",
                        "(8)",
                        "⑼",
                        "(9)",
                        "⑽",
                        "(10)",
                        "⑾",
                        "(11)",
                        "⑿",
                        "(12)",
                        "⒀",
                        "(13)",
                        "⒁",
                        "(14)",
                        "⒂",
                        "(15)",
                        "⒃",
                        "(16)",
                        "⒄",
                        "(17)",
                        "⒅",
                        "(18)",
                        "⒆",
                        "(19)",
                        "⒇",
                        "(20)",
                        "⒈",
                        "1.",
                        "⒉",
                        "2.",
                        "⒊",
                        "3.",
                        "⒋",
                        "4.",
                        "⒌",
                        "5.",
                        "⒍",
                        "6.",
                        "⒎",
                        "7.",
                        "⒏",
                        "8.",
                        "⒐",
                        "9.",
                        "⒑",
                        "10.",
                        "⒒",
                        "11.",
                        "⒓",
                        "12.",
                        "⒔",
                        "13.",
                        "⒕",
                        "14.",
                        "⒖",
                        "15.",
                        "⒗",
                        "16.",
                        "⒘",
                        "17.",
                        "⒙",
                        "18.",
                        "⒚",
                        "19.",
                        "⒛",
                        "20.",
                        "⒜",
                        "(a)",
                        "⒝",
                        "(b)",
                        "⒞",
                        "(c)",
                        "⒟",
                        "(d)",
                        "⒠",
                        "(e)",
                        "⒡",
                        "(f)",
                        "⒢",
                        "(g)",
                        "⒣",
                        "(h)",
                        "⒤",
                        "(i)",
                        "⒥",
                        "(j)",
                        "⒦",
                        "(k)",
                        "⒧",
                        "(l)",
                        "⒨",
                        "(m)",
                        "⒩",
                        "(n)",
                        "⒪",
                        "(o)",
                        "⒫",
                        "(p)",
                        "⒬",
                        "(q)",
                        "⒭",
                        "(r)",
                        "⒮",
                        "(s)",
                        "⒯",
                        "(t)",
                        "⒰",
                        "(u)",
                        "⒱",
                        "(v)",
                        "⒲",
                        "(w)",
                        "⒳",
                        "(x)",
                        "⒴",
                        "(y)",
                        "⒵",
                        "(z)",
                        "⨌",
                        "∫∫∫∫",
                        "⩴",
                        "::=",
                        "⩵",
                        "==",
                        "⩶",
                        "===",
                        "⺟",
                        "母",
                        "⻳",
                        "龟",
                        "⼀",
                        "一",
                        "⼁",
                        "丨",
                        "⼂",
                        "丶",
                        "⼃",
                        "丿",
                        "⼄",
                        "乙",
                        "⼅",
                        "亅",
                        "⼆",
                        "二",
                        "⼇",
                        "亠",
                        "⼈",
                        "人",
                        "⼉",
                        "儿",
                        "⼊",
                        "入",
                        "⼋",
                        "八",
                        "⼌",
                        "冂",
                        "⼍",
                        "冖",
                        "⼎",
                        "冫",
                        "⼏",
                        "几",
                        "⼐",
                        "凵",
                        "⼑",
                        "刀",
                        "⼒",
                        "力",
                        "⼓",
                        "勹",
                        "⼔",
                        "匕",
                        "⼕",
                        "匚",
                        "⼖",
                        "匸",
                        "⼗",
                        "十",
                        "⼘",
                        "卜",
                        "⼙",
                        "卩",
                        "⼚",
                        "厂",
                        "⼛",
                        "厶",
                        "⼜",
                        "又",
                        "⼝",
                        "口",
                        "⼞",
                        "囗",
                        "⼟",
                        "土",
                        "⼠",
                        "士",
                        "⼡",
                        "夂",
                        "⼢",
                        "夊",
                        "⼣",
                        "夕",
                        "⼤",
                        "大",
                        "⼥",
                        "女",
                        "⼦",
                        "子",
                        "⼧",
                        "宀",
                        "⼨",
                        "寸",
                        "⼩",
                        "小",
                        "⼪",
                        "尢",
                        "⼫",
                        "尸",
                        "⼬",
                        "屮",
                        "⼭",
                        "山",
                        "⼮",
                        "巛",
                        "⼯",
                        "工",
                        "⼰",
                        "己",
                        "⼱",
                        "巾",
                        "⼲",
                        "干",
                        "⼳",
                        "幺",
                        "⼴",
                        "广",
                        "⼵",
                        "廴",
                        "⼶",
                        "廾",
                        "⼷",
                        "弋",
                        "⼸",
                        "弓",
                        "⼹",
                        "彐",
                        "⼺",
                        "彡",
                        "⼻",
                        "彳",
                        "⼼",
                        "心",
                        "⼽",
                        "戈",
                        "⼾",
                        "戶",
                        "⼿",
                        "手",
                        "⽀",
                        "支",
                        "⽁",
                        "攴",
                        "⽂",
                        "文",
                        "⽃",
                        "斗",
                        "⽄",
                        "斤",
                        "⽅",
                        "方",
                        "⽆",
                        "无",
                        "⽇",
                        "日",
                        "⽈",
                        "曰",
                        "⽉",
                        "月",
                        "⽊",
                        "木",
                        "⽋",
                        "欠",
                        "⽌",
                        "止",
                        "⽍",
                        "歹",
                        "⽎",
                        "殳",
                        "⽏",
                        "毋",
                        "⽐",
                        "比",
                        "⽑",
                        "毛",
                        "⽒",
                        "氏",
                        "⽓",
                        "气",
                        "⽔",
                        "水",
                        "⽕",
                        "火",
                        "⽖",
                        "爪",
                        "⽗",
                        "父",
                        "⽘",
                        "爻",
                        "⽙",
                        "爿",
                        "⽚",
                        "片",
                        "⽛",
                        "牙",
                        "⽜",
                        "牛",
                        "⽝",
                        "犬",
                        "⽞",
                        "玄",
                        "⽟",
                        "玉",
                        "⽠",
                        "瓜",
                        "⽡",
                        "瓦",
                        "⽢",
                        "甘",
                        "⽣",
                        "生",
                        "⽤",
                        "用",
                        "⽥",
                        "田",
                        "⽦",
                        "疋",
                        "⽧",
                        "疒",
                        "⽨",
                        "癶",
                        "⽩",
                        "白",
                        "⽪",
                        "皮",
                        "⽫",
                        "皿",
                        "⽬",
                        "目",
                        "⽭",
                        "矛",
                        "⽮",
                        "矢",
                        "⽯",
                        "石",
                        "⽰",
                        "示",
                        "⽱",
                        "禸",
                        "⽲",
                        "禾",
                        "⽳",
                        "穴",
                        "⽴",
                        "立",
                        "⽵",
                        "竹",
                        "⽶",
                        "米",
                        "⽷",
                        "糸",
                        "⽸",
                        "缶",
                        "⽹",
                        "网",
                        "⽺",
                        "羊",
                        "⽻",
                        "羽",
                        "⽼",
                        "老",
                        "⽽",
                        "而",
                        "⽾",
                        "耒",
                        "⽿",
                        "耳",
                        "⾀",
                        "聿",
                        "⾁",
                        "肉",
                        "⾂",
                        "臣",
                        "⾃",
                        "自",
                        "⾄",
                        "至",
                        "⾅",
                        "臼",
                        "⾆",
                        "舌",
                        "⾇",
                        "舛",
                        "⾈",
                        "舟",
                        "⾉",
                        "艮",
                        "⾊",
                        "色",
                        "⾋",
                        "艸",
                        "⾌",
                        "虍",
                        "⾍",
                        "虫",
                        "⾎",
                        "血",
                        "⾏",
                        "行",
                        "⾐",
                        "衣",
                        "⾑",
                        "襾",
                        "⾒",
                        "見",
                        "⾓",
                        "角",
                        "⾔",
                        "言",
                        "⾕",
                        "谷",
                        "⾖",
                        "豆",
                        "⾗",
                        "豕",
                        "⾘",
                        "豸",
                        "⾙",
                        "貝",
                        "⾚",
                        "赤",
                        "⾛",
                        "走",
                        "⾜",
                        "足",
                        "⾝",
                        "身",
                        "⾞",
                        "車",
                        "⾟",
                        "辛",
                        "⾠",
                        "辰",
                        "⾡",
                        "辵",
                        "⾢",
                        "邑",
                        "⾣",
                        "酉",
                        "⾤",
                        "釆",
                        "⾥",
                        "里",
                        "⾦",
                        "金",
                        "⾧",
                        "長",
                        "⾨",
                        "門",
                        "⾩",
                        "阜",
                        "⾪",
                        "隶",
                        "⾫",
                        "隹",
                        "⾬",
                        "雨",
                        "⾭",
                        "靑",
                        "⾮",
                        "非",
                        "⾯",
                        "面",
                        "⾰",
                        "革",
                        "⾱",
                        "韋",
                        "⾲",
                        "韭",
                        "⾳",
                        "音",
                        "⾴",
                        "頁",
                        "⾵",
                        "風",
                        "⾶",
                        "飛",
                        "⾷",
                        "食",
                        "⾸",
                        "首",
                        "⾹",
                        "香",
                        "⾺",
                        "馬",
                        "⾻",
                        "骨",
                        "⾼",
                        "高",
                        "⾽",
                        "髟",
                        "⾾",
                        "鬥",
                        "⾿",
                        "鬯",
                        "⿀",
                        "鬲",
                        "⿁",
                        "鬼",
                        "⿂",
                        "魚",
                        "⿃",
                        "鳥",
                        "⿄",
                        "鹵",
                        "⿅",
                        "鹿",
                        "⿆",
                        "麥",
                        "⿇",
                        "麻",
                        "⿈",
                        "黃",
                        "⿉",
                        "黍",
                        "⿊",
                        "黑",
                        "⿋",
                        "黹",
                        "⿌",
                        "黽",
                        "⿍",
                        "鼎",
                        "⿎",
                        "鼓",
                        "⿏",
                        "鼠",
                        "⿐",
                        "鼻",
                        "⿑",
                        "齊",
                        "⿒",
                        "齒",
                        "⿓",
                        "龍",
                        "⿔",
                        "龜",
                        "⿕",
                        "龠",
                        "〶",
                        "〒",
                        "〸",
                        "十",
                        "〹",
                        "卄",
                        "〺",
                        "卅",
                        "゛",
                        " ゙",
                        "゜",
                        " ゚",
                        "ㄱ",
                        "ᄀ",
                        "ㄲ",
                        "ᄁ",
                        "ㄳ",
                        "ᆪ",
                        "ㄴ",
                        "ᄂ",
                        "ㄵ",
                        "ᆬ",
                        "ㄶ",
                        "ᆭ",
                        "ㄷ",
                        "ᄃ",
                        "ㄸ",
                        "ᄄ",
                        "ㄹ",
                        "ᄅ",
                        "ㄺ",
                        "ᆰ",
                        "ㄻ",
                        "ᆱ",
                        "ㄼ",
                        "ᆲ",
                        "ㄽ",
                        "ᆳ",
                        "ㄾ",
                        "ᆴ",
                        "ㄿ",
                        "ᆵ",
                        "ㅀ",
                        "ᄚ",
                        "ㅁ",
                        "ᄆ",
                        "ㅂ",
                        "ᄇ",
                        "ㅃ",
                        "ᄈ",
                        "ㅄ",
                        "ᄡ",
                        "ㅅ",
                        "ᄉ",
                        "ㅆ",
                        "ᄊ",
                        "ㅇ",
                        "ᄋ",
                        "ㅈ",
                        "ᄌ",
                        "ㅉ",
                        "ᄍ",
                        "ㅊ",
                        "ᄎ",
                        "ㅋ",
                        "ᄏ",
                        "ㅌ",
                        "ᄐ",
                        "ㅍ",
                        "ᄑ",
                        "ㅎ",
                        "ᄒ",
                        "ㅏ",
                        "ᅡ",
                        "ㅐ",
                        "ᅢ",
                        "ㅑ",
                        "ᅣ",
                        "ㅒ",
                        "ᅤ",
                        "ㅓ",
                        "ᅥ",
                        "ㅔ",
                        "ᅦ",
                        "ㅕ",
                        "ᅧ",
                        "ㅖ",
                        "ᅨ",
                        "ㅗ",
                        "ᅩ",
                        "ㅘ",
                        "ᅪ",
                        "ㅙ",
                        "ᅫ",
                        "ㅚ",
                        "ᅬ",
                        "ㅛ",
                        "ᅭ",
                        "ㅜ",
                        "ᅮ",
                        "ㅝ",
                        "ᅯ",
                        "ㅞ",
                        "ᅰ",
                        "ㅟ",
                        "ᅱ",
                        "ㅠ",
                        "ᅲ",
                        "ㅡ",
                        "ᅳ",
                        "ㅢ",
                        "ᅴ",
                        "ㅣ",
                        "ᅵ",
                        "ㅤ",
                        "ᅠ",
                        "ㅥ",
                        "ᄔ",
                        "ㅦ",
                        "ᄕ",
                        "ㅧ",
                        "ᇇ",
                        "ㅨ",
                        "ᇈ",
                        "ㅩ",
                        "ᇌ",
                        "ㅪ",
                        "ᇎ",
                        "ㅫ",
                        "ᇓ",
                        "ㅬ",
                        "ᇗ",
                        "ㅭ",
                        "ᇙ",
                        "ㅮ",
                        "ᄜ",
                        "ㅯ",
                        "ᇝ",
                        "ㅰ",
                        "ᇟ",
                        "ㅱ",
                        "ᄝ",
                        "ㅲ",
                        "ᄞ",
                        "ㅳ",
                        "ᄠ",
                        "ㅴ",
                        "ᄢ",
                        "ㅵ",
                        "ᄣ",
                        "ㅶ",
                        "ᄧ",
                        "ㅷ",
                        "ᄩ",
                        "ㅸ",
                        "ᄫ",
                        "ㅹ",
                        "ᄬ",
                        "ㅺ",
                        "ᄭ",
                        "ㅻ",
                        "ᄮ",
                        "ㅼ",
                        "ᄯ",
                        "ㅽ",
                        "ᄲ",
                        "ㅾ",
                        "ᄶ",
                        "ㅿ",
                        "ᅀ",
                        "ㆀ",
                        "ᅇ",
                        "ㆁ",
                        "ᅌ",
                        "ㆂ",
                        "ᇱ",
                        "ㆃ",
                        "ᇲ",
                        "ㆄ",
                        "ᅗ",
                        "ㆅ",
                        "ᅘ",
                        "ㆆ",
                        "ᅙ",
                        "ㆇ",
                        "ᆄ",
                        "ㆈ",
                        "ᆅ",
                        "ㆉ",
                        "ᆈ",
                        "ㆊ",
                        "ᆑ",
                        "ㆋ",
                        "ᆒ",
                        "ㆌ",
                        "ᆔ",
                        "ㆍ",
                        "ᆞ",
                        "ㆎ",
                        "ᆡ",
                        "㈀",
                        "(ᄀ)",
                        "㈁",
                        "(ᄂ)",
                        "㈂",
                        "(ᄃ)",
                        "㈃",
                        "(ᄅ)",
                        "㈄",
                        "(ᄆ)",
                        "㈅",
                        "(ᄇ)",
                        "㈆",
                        "(ᄉ)",
                        "㈇",
                        "(ᄋ)",
                        "㈈",
                        "(ᄌ)",
                        "㈉",
                        "(ᄎ)",
                        "㈊",
                        "(ᄏ)",
                        "㈋",
                        "(ᄐ)",
                        "㈌",
                        "(ᄑ)",
                        "㈍",
                        "(ᄒ)",
                        "㈎",
                        "(가)",
                        "㈏",
                        "(나)",
                        "㈐",
                        "(다)",
                        "㈑",
                        "(라)",
                        "㈒",
                        "(마)",
                        "㈓",
                        "(바)",
                        "㈔",
                        "(사)",
                        "㈕",
                        "(아)",
                        "㈖",
                        "(자)",
                        "㈗",
                        "(차)",
                        "㈘",
                        "(카)",
                        "㈙",
                        "(타)",
                        "㈚",
                        "(파)",
                        "㈛",
                        "(하)",
                        "㈜",
                        "(주)",
                        "㈝",
                        "(오전)",
                        "㈞",
                        "(오후)",
                        "㈠",
                        "(一)",
                        "㈡",
                        "(二)",
                        "㈢",
                        "(三)",
                        "㈣",
                        "(四)",
                        "㈤",
                        "(五)",
                        "㈥",
                        "(六)",
                        "㈦",
                        "(七)",
                        "㈧",
                        "(八)",
                        "㈨",
                        "(九)",
                        "㈩",
                        "(十)",
                        "㈪",
                        "(月)",
                        "㈫",
                        "(火)",
                        "㈬",
                        "(水)",
                        "㈭",
                        "(木)",
                        "㈮",
                        "(金)",
                        "㈯",
                        "(土)",
                        "㈰",
                        "(日)",
                        "㈱",
                        "(株)",
                        "㈲",
                        "(有)",
                        "㈳",
                        "(社)",
                        "㈴",
                        "(名)",
                        "㈵",
                        "(特)",
                        "㈶",
                        "(財)",
                        "㈷",
                        "(祝)",
                        "㈸",
                        "(労)",
                        "㈹",
                        "(代)",
                        "㈺",
                        "(呼)",
                        "㈻",
                        "(学)",
                        "㈼",
                        "(監)",
                        "㈽",
                        "(企)",
                        "㈾",
                        "(資)",
                        "㈿",
                        "(協)",
                        "㉀",
                        "(祭)",
                        "㉁",
                        "(休)",
                        "㉂",
                        "(自)",
                        "㉃",
                        "(至)",
                        "㋀",
                        "1月",
                        "㋁",
                        "2月",
                        "㋂",
                        "3月",
                        "㋃",
                        "4月",
                        "㋄",
                        "5月",
                        "㋅",
                        "6月",
                        "㋆",
                        "7月",
                        "㋇",
                        "8月",
                        "㋈",
                        "9月",
                        "㋉",
                        "10月",
                        "㋊",
                        "11月",
                        "㋋",
                        "12月",
                        "㍘",
                        "0点",
                        "㍙",
                        "1点",
                        "㍚",
                        "2点",
                        "㍛",
                        "3点",
                        "㍜",
                        "4点",
                        "㍝",
                        "5点",
                        "㍞",
                        "6点",
                        "㍟",
                        "7点",
                        "㍠",
                        "8点",
                        "㍡",
                        "9点",
                        "㍢",
                        "10点",
                        "㍣",
                        "11点",
                        "㍤",
                        "12点",
                        "㍥",
                        "13点",
                        "㍦",
                        "14点",
                        "㍧",
                        "15点",
                        "㍨",
                        "16点",
                        "㍩",
                        "17点",
                        "㍪",
                        "18点",
                        "㍫",
                        "19点",
                        "㍬",
                        "20点",
                        "㍭",
                        "21点",
                        "㍮",
                        "22点",
                        "㍯",
                        "23点",
                        "㍰",
                        "24点",
                        "㏠",
                        "1日",
                        "㏡",
                        "2日",
                        "㏢",
                        "3日",
                        "㏣",
                        "4日",
                        "㏤",
                        "5日",
                        "㏥",
                        "6日",
                        "㏦",
                        "7日",
                        "㏧",
                        "8日",
                        "㏨",
                        "9日",
                        "㏩",
                        "10日",
                        "㏪",
                        "11日",
                        "㏫",
                        "12日",
                        "㏬",
                        "13日",
                        "㏭",
                        "14日",
                        "㏮",
                        "15日",
                        "㏯",
                        "16日",
                        "㏰",
                        "17日",
                        "㏱",
                        "18日",
                        "㏲",
                        "19日",
                        "㏳",
                        "20日",
                        "㏴",
                        "21日",
                        "㏵",
                        "22日",
                        "㏶",
                        "23日",
                        "㏷",
                        "24日",
                        "㏸",
                        "25日",
                        "㏹",
                        "26日",
                        "㏺",
                        "27日",
                        "㏻",
                        "28日",
                        "㏼",
                        "29日",
                        "㏽",
                        "30日",
                        "㏾",
                        "31日",
                        "ﬀ",
                        "ff",
                        "ﬁ",
                        "fi",
                        "ﬂ",
                        "fl",
                        "ﬃ",
                        "ffi",
                        "ﬄ",
                        "ffl",
                        "ﬅ",
                        "ſt",
                        "ﬆ",
                        "st",
                        "ﬓ",
                        "մն",
                        "ﬔ",
                        "մե",
                        "ﬕ",
                        "մի",
                        "ﬖ",
                        "վն",
                        "ﬗ",
                        "մխ",
                        "ﭏ",
                        "אל",
                        "ﭐ",
                        "ٱ",
                        "ﭑ",
                        "ٱ",
                        "ﭒ",
                        "ٻ",
                        "ﭓ",
                        "ٻ",
                        "ﭔ",
                        "ٻ",
                        "ﭕ",
                        "ٻ",
                        "ﭖ",
                        "پ",
                        "ﭗ",
                        "پ",
                        "ﭘ",
                        "پ",
                        "ﭙ",
                        "پ",
                        "ﭚ",
                        "ڀ",
                        "ﭛ",
                        "ڀ",
                        "ﭜ",
                        "ڀ",
                        "ﭝ",
                        "ڀ",
                        "ﭞ",
                        "ٺ",
                        "ﭟ",
                        "ٺ",
                        "ﭠ",
                        "ٺ",
                        "ﭡ",
                        "ٺ",
                        "ﭢ",
                        "ٿ",
                        "ﭣ",
                        "ٿ",
                        "ﭤ",
                        "ٿ",
                        "ﭥ",
                        "ٿ",
                        "ﭦ",
                        "ٹ",
                        "ﭧ",
                        "ٹ",
                        "ﭨ",
                        "ٹ",
                        "ﭩ",
                        "ٹ",
                        "ﭪ",
                        "ڤ",
                        "ﭫ",
                        "ڤ",
                        "ﭬ",
                        "ڤ",
                        "ﭭ",
                        "ڤ",
                        "ﭮ",
                        "ڦ",
                        "ﭯ",
                        "ڦ",
                        "ﭰ",
                        "ڦ",
                        "ﭱ",
                        "ڦ",
                        "ﭲ",
                        "ڄ",
                        "ﭳ",
                        "ڄ",
                        "ﭴ",
                        "ڄ",
                        "ﭵ",
                        "ڄ",
                        "ﭶ",
                        "ڃ",
                        "ﭷ",
                        "ڃ",
                        "ﭸ",
                        "ڃ",
                        "ﭹ",
                        "ڃ",
                        "ﭺ",
                        "چ",
                        "ﭻ",
                        "چ",
                        "ﭼ",
                        "چ",
                        "ﭽ",
                        "چ",
                        "ﭾ",
                        "ڇ",
                        "ﭿ",
                        "ڇ",
                        "ﮀ",
                        "ڇ",
                        "ﮁ",
                        "ڇ",
                        "ﮂ",
                        "ڍ",
                        "ﮃ",
                        "ڍ",
                        "ﮄ",
                        "ڌ",
                        "ﮅ",
                        "ڌ",
                        "ﮆ",
                        "ڎ",
                        "ﮇ",
                        "ڎ",
                        "ﮈ",
                        "ڈ",
                        "ﮉ",
                        "ڈ",
                        "ﮊ",
                        "ژ",
                        "ﮋ",
                        "ژ",
                        "ﮌ",
                        "ڑ",
                        "ﮍ",
                        "ڑ",
                        "ﮎ",
                        "ک",
                        "ﮏ",
                        "ک",
                        "ﮐ",
                        "ک",
                        "ﮑ",
                        "ک",
                        "ﮒ",
                        "گ",
                        "ﮓ",
                        "گ",
                        "ﮔ",
                        "گ",
                        "ﮕ",
                        "گ",
                        "ﮖ",
                        "ڳ",
                        "ﮗ",
                        "ڳ",
                        "ﮘ",
                        "ڳ",
                        "ﮙ",
                        "ڳ",
                        "ﮚ",
                        "ڱ",
                        "ﮛ",
                        "ڱ",
                        "ﮜ",
                        "ڱ",
                        "ﮝ",
                        "ڱ",
                        "ﮞ",
                        "ں",
                        "ﮟ",
                        "ں",
                        "ﮠ",
                        "ڻ",
                        "ﮡ",
                        "ڻ",
                        "ﮢ",
                        "ڻ",
                        "ﮣ",
                        "ڻ",
                        "ﮤ",
                        "ۀ",
                        "ﮥ",
                        "ۀ",
                        "ﮦ",
                        "ہ",
                        "ﮧ",
                        "ہ",
                        "ﮨ",
                        "ہ",
                        "ﮩ",
                        "ہ",
                        "ﮪ",
                        "ھ",
                        "ﮫ",
                        "ھ",
                        "ﮬ",
                        "ھ",
                        "ﮭ",
                        "ھ",
                        "ﮮ",
                        "ے",
                        "ﮯ",
                        "ے",
                        "ﮰ",
                        "ۓ",
                        "ﮱ",
                        "ۓ",
                        "ﯓ",
                        "ڭ",
                        "ﯔ",
                        "ڭ",
                        "ﯕ",
                        "ڭ",
                        "ﯖ",
                        "ڭ",
                        "ﯗ",
                        "ۇ",
                        "ﯘ",
                        "ۇ",
                        "ﯙ",
                        "ۆ",
                        "ﯚ",
                        "ۆ",
                        "ﯛ",
                        "ۈ",
                        "ﯜ",
                        "ۈ",
                        "ﯝ",
                        "ٷ",
                        "ﯞ",
                        "ۋ",
                        "ﯟ",
                        "ۋ",
                        "ﯠ",
                        "ۅ",
                        "ﯡ",
                        "ۅ",
                        "ﯢ",
                        "ۉ",
                        "ﯣ",
                        "ۉ",
                        "ﯤ",
                        "ې",
                        "ﯥ",
                        "ې",
                        "ﯦ",
                        "ې",
                        "ﯧ",
                        "ې",
                        "ﯨ",
                        "ى",
                        "ﯩ",
                        "ى",
                        "ﯪ",
                        "ئا",
                        "ﯫ",
                        "ئا",
                        "ﯬ",
                        "ئە",
                        "ﯭ",
                        "ئە",
                        "ﯮ",
                        "ئو",
                        "ﯯ",
                        "ئو",
                        "ﯰ",
                        "ئۇ",
                        "ﯱ",
                        "ئۇ",
                        "ﯲ",
                        "ئۆ",
                        "ﯳ",
                        "ئۆ",
                        "ﯴ",
                        "ئۈ",
                        "ﯵ",
                        "ئۈ",
                        "ﯶ",
                        "ئې",
                        "ﯷ",
                        "ئې",
                        "ﯸ",
                        "ئې",
                        "ﯹ",
                        "ئى",
                        "ﯺ",
                        "ئى",
                        "ﯻ",
                        "ئى",
                        "ﯼ",
                        "ی",
                        "ﯽ",
                        "ی",
                        "ﯾ",
                        "ی",
                        "ﯿ",
                        "ی",
                        "ﰀ",
                        "ئج",
                        "ﰁ",
                        "ئح",
                        "ﰂ",
                        "ئم",
                        "ﰃ",
                        "ئى",
                        "ﰄ",
                        "ئي",
                        "ﰅ",
                        "بج",
                        "ﰆ",
                        "بح",
                        "ﰇ",
                        "بخ",
                        "ﰈ",
                        "بم",
                        "ﰉ",
                        "بى",
                        "ﰊ",
                        "بي",
                        "ﰋ",
                        "تج",
                        "ﰌ",
                        "تح",
                        "ﰍ",
                        "تخ",
                        "ﰎ",
                        "تم",
                        "ﰏ",
                        "تى",
                        "ﰐ",
                        "تي",
                        "ﰑ",
                        "ثج",
                        "ﰒ",
                        "ثم",
                        "ﰓ",
                        "ثى",
                        "ﰔ",
                        "ثي",
                        "ﰕ",
                        "جح",
                        "ﰖ",
                        "جم",
                        "ﰗ",
                        "حج",
                        "ﰘ",
                        "حم",
                        "ﰙ",
                        "خج",
                        "ﰚ",
                        "خح",
                        "ﰛ",
                        "خم",
                        "ﰜ",
                        "سج",
                        "ﰝ",
                        "سح",
                        "ﰞ",
                        "سخ",
                        "ﰟ",
                        "سم",
                        "ﰠ",
                        "صح",
                        "ﰡ",
                        "صم",
                        "ﰢ",
                        "ضج",
                        "ﰣ",
                        "ضح",
                        "ﰤ",
                        "ضخ",
                        "ﰥ",
                        "ضم",
                        "ﰦ",
                        "طح",
                        "ﰧ",
                        "طم",
                        "ﰨ",
                        "ظم",
                        "ﰩ",
                        "عج",
                        "ﰪ",
                        "عم",
                        "ﰫ",
                        "غج",
                        "ﰬ",
                        "غم",
                        "ﰭ",
                        "فج",
                        "ﰮ",
                        "فح",
                        "ﰯ",
                        "فخ",
                        "ﰰ",
                        "فم",
                        "ﰱ",
                        "فى",
                        "ﰲ",
                        "في",
                        "ﰳ",
                        "قح",
                        "ﰴ",
                        "قم",
                        "ﰵ",
                        "قى",
                        "ﰶ",
                        "قي",
                        "ﰷ",
                        "كا",
                        "ﰸ",
                        "كج",
                        "ﰹ",
                        "كح",
                        "ﰺ",
                        "كخ",
                        "ﰻ",
                        "كل",
                        "ﰼ",
                        "كم",
                        "ﰽ",
                        "كى",
                        "ﰾ",
                        "كي",
                        "ﰿ",
                        "لج",
                        "ﱀ",
                        "لح",
                        "ﱁ",
                        "لخ",
                        "ﱂ",
                        "لم",
                        "ﱃ",
                        "لى",
                        "ﱄ",
                        "لي",
                        "ﱅ",
                        "مج",
                        "ﱆ",
                        "مح",
                        "ﱇ",
                        "مخ",
                        "ﱈ",
                        "مم",
                        "ﱉ",
                        "مى",
                        "ﱊ",
                        "مي",
                        "ﱋ",
                        "نج",
                        "ﱌ",
                        "نح",
                        "ﱍ",
                        "نخ",
                        "ﱎ",
                        "نم",
                        "ﱏ",
                        "نى",
                        "ﱐ",
                        "ني",
                        "ﱑ",
                        "هج",
                        "ﱒ",
                        "هم",
                        "ﱓ",
                        "هى",
                        "ﱔ",
                        "هي",
                        "ﱕ",
                        "يج",
                        "ﱖ",
                        "يح",
                        "ﱗ",
                        "يخ",
                        "ﱘ",
                        "يم",
                        "ﱙ",
                        "يى",
                        "ﱚ",
                        "يي",
                        "ﱛ",
                        "ذٰ",
                        "ﱜ",
                        "رٰ",
                        "ﱝ",
                        "ىٰ",
                        "ﱞ",
                        " ٌّ",
                        "ﱟ",
                        " ٍّ",
                        "ﱠ",
                        " َّ",
                        "ﱡ",
                        " ُّ",
                        "ﱢ",
                        " ِّ",
                        "ﱣ",
                        " ّٰ",
                        "ﱤ",
                        "ئر",
                        "ﱥ",
                        "ئز",
                        "ﱦ",
                        "ئم",
                        "ﱧ",
                        "ئن",
                        "ﱨ",
                        "ئى",
                        "ﱩ",
                        "ئي",
                        "ﱪ",
                        "بر",
                        "ﱫ",
                        "بز",
                        "ﱬ",
                        "بم",
                        "ﱭ",
                        "بن",
                        "ﱮ",
                        "بى",
                        "ﱯ",
                        "بي",
                        "ﱰ",
                        "تر",
                        "ﱱ",
                        "تز",
                        "ﱲ",
                        "تم",
                        "ﱳ",
                        "تن",
                        "ﱴ",
                        "تى",
                        "ﱵ",
                        "تي",
                        "ﱶ",
                        "ثر",
                        "ﱷ",
                        "ثز",
                        "ﱸ",
                        "ثم",
                        "ﱹ",
                        "ثن",
                        "ﱺ",
                        "ثى",
                        "ﱻ",
                        "ثي",
                        "ﱼ",
                        "فى",
                        "ﱽ",
                        "في",
                        "ﱾ",
                        "قى",
                        "ﱿ",
                        "قي",
                        "ﲀ",
                        "كا",
                        "ﲁ",
                        "كل",
                        "ﲂ",
                        "كم",
                        "ﲃ",
                        "كى",
                        "ﲄ",
                        "كي",
                        "ﲅ",
                        "لم",
                        "ﲆ",
                        "لى",
                        "ﲇ",
                        "لي",
                        "ﲈ",
                        "ما",
                        "ﲉ",
                        "مم",
                        "ﲊ",
                        "نر",
                        "ﲋ",
                        "نز",
                        "ﲌ",
                        "نم",
                        "ﲍ",
                        "نن",
                        "ﲎ",
                        "نى",
                        "ﲏ",
                        "ني",
                        "ﲐ",
                        "ىٰ",
                        "ﲑ",
                        "ير",
                        "ﲒ",
                        "يز",
                        "ﲓ",
                        "يم",
                        "ﲔ",
                        "ين",
                        "ﲕ",
                        "يى",
                        "ﲖ",
                        "يي",
                        "ﲗ",
                        "ئج",
                        "ﲘ",
                        "ئح",
                        "ﲙ",
                        "ئخ",
                        "ﲚ",
                        "ئم",
                        "ﲛ",
                        "ئه",
                        "ﲜ",
                        "بج",
                        "ﲝ",
                        "بح",
                        "ﲞ",
                        "بخ",
                        "ﲟ",
                        "بم",
                        "ﲠ",
                        "به",
                        "ﲡ",
                        "تج",
                        "ﲢ",
                        "تح",
                        "ﲣ",
                        "تخ",
                        "ﲤ",
                        "تم",
                        "ﲥ",
                        "ته",
                        "ﲦ",
                        "ثم",
                        "ﲧ",
                        "جح",
                        "ﲨ",
                        "جم",
                        "ﲩ",
                        "حج",
                        "ﲪ",
                        "حم",
                        "ﲫ",
                        "خج",
                        "ﲬ",
                        "خم",
                        "ﲭ",
                        "سج",
                        "ﲮ",
                        "سح",
                        "ﲯ",
                        "سخ",
                        "ﲰ",
                        "سم",
                        "ﲱ",
                        "صح",
                        "ﲲ",
                        "صخ",
                        "ﲳ",
                        "صم",
                        "ﲴ",
                        "ضج",
                        "ﲵ",
                        "ضح",
                        "ﲶ",
                        "ضخ",
                        "ﲷ",
                        "ضم",
                        "ﲸ",
                        "طح",
                        "ﲹ",
                        "ظم",
                        "ﲺ",
                        "عج",
                        "ﲻ",
                        "عم",
                        "ﲼ",
                        "غج",
                        "ﲽ",
                        "غم",
                        "ﲾ",
                        "فج",
                        "ﲿ",
                        "فح",
                        "ﳀ",
                        "فخ",
                        "ﳁ",
                        "فم",
                        "ﳂ",
                        "قح",
                        "ﳃ",
                        "قم",
                        "ﳄ",
                        "كج",
                        "ﳅ",
                        "كح",
                        "ﳆ",
                        "كخ",
                        "ﳇ",
                        "كل",
                        "ﳈ",
                        "كم",
                        "ﳉ",
                        "لج",
                        "ﳊ",
                        "لح",
                        "ﳋ",
                        "لخ",
                        "ﳌ",
                        "لم",
                        "ﳍ",
                        "له",
                        "ﳎ",
                        "مج",
                        "ﳏ",
                        "مح",
                        "ﳐ",
                        "مخ",
                        "ﳑ",
                        "مم",
                        "ﳒ",
                        "نج",
                        "ﳓ",
                        "نح",
                        "ﳔ",
                        "نخ",
                        "ﳕ",
                        "نم",
                        "ﳖ",
                        "نه",
                        "ﳗ",
                        "هج",
                        "ﳘ",
                        "هم",
                        "ﳙ",
                        "هٰ",
                        "ﳚ",
                        "يج",
                        "ﳛ",
                        "يح",
                        "ﳜ",
                        "يخ",
                        "ﳝ",
                        "يم",
                        "ﳞ",
                        "يه",
                        "ﳟ",
                        "ئم",
                        "ﳠ",
                        "ئه",
                        "ﳡ",
                        "بم",
                        "ﳢ",
                        "به",
                        "ﳣ",
                        "تم",
                        "ﳤ",
                        "ته",
                        "ﳥ",
                        "ثم",
                        "ﳦ",
                        "ثه",
                        "ﳧ",
                        "سم",
                        "ﳨ",
                        "سه",
                        "ﳩ",
                        "شم",
                        "ﳪ",
                        "شه",
                        "ﳫ",
                        "كل",
                        "ﳬ",
                        "كم",
                        "ﳭ",
                        "لم",
                        "ﳮ",
                        "نم",
                        "ﳯ",
                        "نه",
                        "ﳰ",
                        "يم",
                        "ﳱ",
                        "يه",
                        "ﳲ",
                        "ـَّ",
                        "ﳳ",
                        "ـُّ",
                        "ﳴ",
                        "ـِّ",
                        "ﳵ",
                        "طى",
                        "ﳶ",
                        "طي",
                        "ﳷ",
                        "عى",
                        "ﳸ",
                        "عي",
                        "ﳹ",
                        "غى",
                        "ﳺ",
                        "غي",
                        "ﳻ",
                        "سى",
                        "ﳼ",
                        "سي",
                        "ﳽ",
                        "شى",
                        "ﳾ",
                        "شي",
                        "ﳿ",
                        "حى",
                        "ﴀ",
                        "حي",
                        "ﴁ",
                        "جى",
                        "ﴂ",
                        "جي",
                        "ﴃ",
                        "خى",
                        "ﴄ",
                        "خي",
                        "ﴅ",
                        "صى",
                        "ﴆ",
                        "صي",
                        "ﴇ",
                        "ضى",
                        "ﴈ",
                        "ضي",
                        "ﴉ",
                        "شج",
                        "ﴊ",
                        "شح",
                        "ﴋ",
                        "شخ",
                        "ﴌ",
                        "شم",
                        "ﴍ",
                        "شر",
                        "ﴎ",
                        "سر",
                        "ﴏ",
                        "صر",
                        "ﴐ",
                        "ضر",
                        "ﴑ",
                        "طى",
                        "ﴒ",
                        "طي",
                        "ﴓ",
                        "عى",
                        "ﴔ",
                        "عي",
                        "ﴕ",
                        "غى",
                        "ﴖ",
                        "غي",
                        "ﴗ",
                        "سى",
                        "ﴘ",
                        "سي",
                        "ﴙ",
                        "شى",
                        "ﴚ",
                        "شي",
                        "ﴛ",
                        "حى",
                        "ﴜ",
                        "حي",
                        "ﴝ",
                        "جى",
                        "ﴞ",
                        "جي",
                        "ﴟ",
                        "خى",
                        "ﴠ",
                        "خي",
                        "ﴡ",
                        "صى",
                        "ﴢ",
                        "صي",
                        "ﴣ",
                        "ضى",
                        "ﴤ",
                        "ضي",
                        "ﴥ",
                        "شج",
                        "ﴦ",
                        "شح",
                        "ﴧ",
                        "شخ",
                        "ﴨ",
                        "شم",
                        "ﴩ",
                        "شر",
                        "ﴪ",
                        "سر",
                        "ﴫ",
                        "صر",
                        "ﴬ",
                        "ضر",
                        "ﴭ",
                        "شج",
                        "ﴮ",
                        "شح",
                        "ﴯ",
                        "شخ",
                        "ﴰ",
                        "شم",
                        "ﴱ",
                        "سه",
                        "ﴲ",
                        "شه",
                        "ﴳ",
                        "طم",
                        "ﴴ",
                        "سج",
                        "ﴵ",
                        "سح",
                        "ﴶ",
                        "سخ",
                        "ﴷ",
                        "شج",
                        "ﴸ",
                        "شح",
                        "ﴹ",
                        "شخ",
                        "ﴺ",
                        "طم",
                        "ﴻ",
                        "ظم",
                        "ﴼ",
                        "اً",
                        "ﴽ",
                        "اً",
                        "ﵐ",
                        "تجم",
                        "ﵑ",
                        "تحج",
                        "ﵒ",
                        "تحج",
                        "ﵓ",
                        "تحم",
                        "ﵔ",
                        "تخم",
                        "ﵕ",
                        "تمج",
                        "ﵖ",
                        "تمح",
                        "ﵗ",
                        "تمخ",
                        "ﵘ",
                        "جمح",
                        "ﵙ",
                        "جمح",
                        "ﵚ",
                        "حمي",
                        "ﵛ",
                        "حمى",
                        "ﵜ",
                        "سحج",
                        "ﵝ",
                        "سجح",
                        "ﵞ",
                        "سجى",
                        "ﵟ",
                        "سمح",
                        "ﵠ",
                        "سمح",
                        "ﵡ",
                        "سمج",
                        "ﵢ",
                        "سمم",
                        "ﵣ",
                        "سمم",
                        "ﵤ",
                        "صحح",
                        "ﵥ",
                        "صحح",
                        "ﵦ",
                        "صمم",
                        "ﵧ",
                        "شحم",
                        "ﵨ",
                        "شحم",
                        "ﵩ",
                        "شجي",
                        "ﵪ",
                        "شمخ",
                        "ﵫ",
                        "شمخ",
                        "ﵬ",
                        "شمم",
                        "ﵭ",
                        "شمم",
                        "ﵮ",
                        "ضحى",
                        "ﵯ",
                        "ضخم",
                        "ﵰ",
                        "ضخم",
                        "ﵱ",
                        "طمح",
                        "ﵲ",
                        "طمح",
                        "ﵳ",
                        "طمم",
                        "ﵴ",
                        "طمي",
                        "ﵵ",
                        "عجم",
                        "ﵶ",
                        "عمم",
                        "ﵷ",
                        "عمم",
                        "ﵸ",
                        "عمى",
                        "ﵹ",
                        "غمم",
                        "ﵺ",
                        "غمي",
                        "ﵻ",
                        "غمى",
                        "ﵼ",
                        "فخم",
                        "ﵽ",
                        "فخم",
                        "ﵾ",
                        "قمح",
                        "ﵿ",
                        "قمم",
                        "ﶀ",
                        "لحم",
                        "ﶁ",
                        "لحي",
                        "ﶂ",
                        "لحى",
                        "ﶃ",
                        "لجج",
                        "ﶄ",
                        "لجج",
                        "ﶅ",
                        "لخم",
                        "ﶆ",
                        "لخم",
                        "ﶇ",
                        "لمح",
                        "ﶈ",
                        "لمح",
                        "ﶉ",
                        "محج",
                        "ﶊ",
                        "محم",
                        "ﶋ",
                        "محي",
                        "ﶌ",
                        "مجح",
                        "ﶍ",
                        "مجم",
                        "ﶎ",
                        "مخج",
                        "ﶏ",
                        "مخم",
                        "ﶒ",
                        "مجخ",
                        "ﶓ",
                        "همج",
                        "ﶔ",
                        "همم",
                        "ﶕ",
                        "نحم",
                        "ﶖ",
                        "نحى",
                        "ﶗ",
                        "نجم",
                        "ﶘ",
                        "نجم",
                        "ﶙ",
                        "نجى",
                        "ﶚ",
                        "نمي",
                        "ﶛ",
                        "نمى",
                        "ﶜ",
                        "يمم",
                        "ﶝ",
                        "يمم",
                        "ﶞ",
                        "بخي",
                        "ﶟ",
                        "تجي",
                        "ﶠ",
                        "تجى",
                        "ﶡ",
                        "تخي",
                        "ﶢ",
                        "تخى",
                        "ﶣ",
                        "تمي",
                        "ﶤ",
                        "تمى",
                        "ﶥ",
                        "جمي",
                        "ﶦ",
                        "جحى",
                        "ﶧ",
                        "جمى",
                        "ﶨ",
                        "سخى",
                        "ﶩ",
                        "صحي",
                        "ﶪ",
                        "شحي",
                        "ﶫ",
                        "ضحي",
                        "ﶬ",
                        "لجي",
                        "ﶭ",
                        "لمي",
                        "ﶮ",
                        "يحي",
                        "ﶯ",
                        "يجي",
                        "ﶰ",
                        "يمي",
                        "ﶱ",
                        "ممي",
                        "ﶲ",
                        "قمي",
                        "ﶳ",
                        "نحي",
                        "ﶴ",
                        "قمح",
                        "ﶵ",
                        "لحم",
                        "ﶶ",
                        "عمي",
                        "ﶷ",
                        "كمي",
                        "ﶸ",
                        "نجح",
                        "ﶹ",
                        "مخي",
                        "ﶺ",
                        "لجم",
                        "ﶻ",
                        "كمم",
                        "ﶼ",
                        "لجم",
                        "ﶽ",
                        "نجح",
                        "ﶾ",
                        "جحي",
                        "ﶿ",
                        "حجي",
                        "ﷀ",
                        "مجي",
                        "ﷁ",
                        "فمي",
                        "ﷂ",
                        "بحي",
                        "ﷃ",
                        "كمم",
                        "ﷄ",
                        "عجم",
                        "ﷅ",
                        "صمم",
                        "ﷆ",
                        "سخي",
                        "ﷇ",
                        "نجي",
                        "﹉",
                        "‾",
                        "﹊",
                        "‾",
                        "﹋",
                        "‾",
                        "﹌",
                        "‾",
                        "﹍",
                        "_",
                        "﹎",
                        "_",
                        "﹏",
                        "_",
                        "ﺀ",
                        "ء",
                        "ﺁ",
                        "آ",
                        "ﺂ",
                        "آ",
                        "ﺃ",
                        "أ",
                        "ﺄ",
                        "أ",
                        "ﺅ",
                        "ؤ",
                        "ﺆ",
                        "ؤ",
                        "ﺇ",
                        "إ",
                        "ﺈ",
                        "إ",
                        "ﺉ",
                        "ئ",
                        "ﺊ",
                        "ئ",
                        "ﺋ",
                        "ئ",
                        "ﺌ",
                        "ئ",
                        "ﺍ",
                        "ا",
                        "ﺎ",
                        "ا",
                        "ﺏ",
                        "ب",
                        "ﺐ",
                        "ب",
                        "ﺑ",
                        "ب",
                        "ﺒ",
                        "ب",
                        "ﺓ",
                        "ة",
                        "ﺔ",
                        "ة",
                        "ﺕ",
                        "ت",
                        "ﺖ",
                        "ت",
                        "ﺗ",
                        "ت",
                        "ﺘ",
                        "ت",
                        "ﺙ",
                        "ث",
                        "ﺚ",
                        "ث",
                        "ﺛ",
                        "ث",
                        "ﺜ",
                        "ث",
                        "ﺝ",
                        "ج",
                        "ﺞ",
                        "ج",
                        "ﺟ",
                        "ج",
                        "ﺠ",
                        "ج",
                        "ﺡ",
                        "ح",
                        "ﺢ",
                        "ح",
                        "ﺣ",
                        "ح",
                        "ﺤ",
                        "ح",
                        "ﺥ",
                        "خ",
                        "ﺦ",
                        "خ",
                        "ﺧ",
                        "خ",
                        "ﺨ",
                        "خ",
                        "ﺩ",
                        "د",
                        "ﺪ",
                        "د",
                        "ﺫ",
                        "ذ",
                        "ﺬ",
                        "ذ",
                        "ﺭ",
                        "ر",
                        "ﺮ",
                        "ر",
                        "ﺯ",
                        "ز",
                        "ﺰ",
                        "ز",
                        "ﺱ",
                        "س",
                        "ﺲ",
                        "س",
                        "ﺳ",
                        "س",
                        "ﺴ",
                        "س",
                        "ﺵ",
                        "ش",
                        "ﺶ",
                        "ش",
                        "ﺷ",
                        "ش",
                        "ﺸ",
                        "ش",
                        "ﺹ",
                        "ص",
                        "ﺺ",
                        "ص",
                        "ﺻ",
                        "ص",
                        "ﺼ",
                        "ص",
                        "ﺽ",
                        "ض",
                        "ﺾ",
                        "ض",
                        "ﺿ",
                        "ض",
                        "ﻀ",
                        "ض",
                        "ﻁ",
                        "ط",
                        "ﻂ",
                        "ط",
                        "ﻃ",
                        "ط",
                        "ﻄ",
                        "ط",
                        "ﻅ",
                        "ظ",
                        "ﻆ",
                        "ظ",
                        "ﻇ",
                        "ظ",
                        "ﻈ",
                        "ظ",
                        "ﻉ",
                        "ع",
                        "ﻊ",
                        "ع",
                        "ﻋ",
                        "ع",
                        "ﻌ",
                        "ع",
                        "ﻍ",
                        "غ",
                        "ﻎ",
                        "غ",
                        "ﻏ",
                        "غ",
                        "ﻐ",
                        "غ",
                        "ﻑ",
                        "ف",
                        "ﻒ",
                        "ف",
                        "ﻓ",
                        "ف",
                        "ﻔ",
                        "ف",
                        "ﻕ",
                        "ق",
                        "ﻖ",
                        "ق",
                        "ﻗ",
                        "ق",
                        "ﻘ",
                        "ق",
                        "ﻙ",
                        "ك",
                        "ﻚ",
                        "ك",
                        "ﻛ",
                        "ك",
                        "ﻜ",
                        "ك",
                        "ﻝ",
                        "ل",
                        "ﻞ",
                        "ل",
                        "ﻟ",
                        "ل",
                        "ﻠ",
                        "ل",
                        "ﻡ",
                        "م",
                        "ﻢ",
                        "م",
                        "ﻣ",
                        "م",
                        "ﻤ",
                        "م",
                        "ﻥ",
                        "ن",
                        "ﻦ",
                        "ن",
                        "ﻧ",
                        "ن",
                        "ﻨ",
                        "ن",
                        "ﻩ",
                        "ه",
                        "ﻪ",
                        "ه",
                        "ﻫ",
                        "ه",
                        "ﻬ",
                        "ه",
                        "ﻭ",
                        "و",
                        "ﻮ",
                        "و",
                        "ﻯ",
                        "ى",
                        "ﻰ",
                        "ى",
                        "ﻱ",
                        "ي",
                        "ﻲ",
                        "ي",
                        "ﻳ",
                        "ي",
                        "ﻴ",
                        "ي",
                        "ﻵ",
                        "لآ",
                        "ﻶ",
                        "لآ",
                        "ﻷ",
                        "لأ",
                        "ﻸ",
                        "لأ",
                        "ﻹ",
                        "لإ",
                        "ﻺ",
                        "لإ",
                        "ﻻ",
                        "لا",
                        "ﻼ",
                        "لا"
                    ];
                });
                function reverseIfRtl(chars) {
                    const charsLength = chars.length;
                    if (charsLength <= 1 || !isRTLRangeFor(chars.charCodeAt(0))) return chars;
                    const buf = [];
                    for(let ii = charsLength - 1; ii >= 0; ii--)buf.push(chars[ii]);
                    return buf.join("");
                }
            /***/ },
            /* 41 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getStandardFontName = getStandardFontName;
                exports.getSymbolsFonts = exports.getSupplementalGlyphMapForCalibri = exports.getSupplementalGlyphMapForArialBlack = exports.getStdFontMap = exports.getSerifFonts = exports.getNonStdFontMap = exports.getGlyphMapForStandardFonts = exports.getFontNameToFileMap = void 0;
                var _core_utils = __w_pdfjs_require__(9);
                var _fonts_utils = __w_pdfjs_require__(38);
                const getStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["Times-Roman"] = "Times-Roman";
                    t.Helvetica = "Helvetica";
                    t.Courier = "Courier";
                    t.Symbol = "Symbol";
                    t["Times-Bold"] = "Times-Bold";
                    t["Helvetica-Bold"] = "Helvetica-Bold";
                    t["Courier-Bold"] = "Courier-Bold";
                    t.ZapfDingbats = "ZapfDingbats";
                    t["Times-Italic"] = "Times-Italic";
                    t["Helvetica-Oblique"] = "Helvetica-Oblique";
                    t["Courier-Oblique"] = "Courier-Oblique";
                    t["Times-BoldItalic"] = "Times-BoldItalic";
                    t["Helvetica-BoldOblique"] = "Helvetica-BoldOblique";
                    t["Courier-BoldOblique"] = "Courier-BoldOblique";
                    t.ArialNarrow = "Helvetica";
                    t["ArialNarrow-Bold"] = "Helvetica-Bold";
                    t["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialNarrow-Italic"] = "Helvetica-Oblique";
                    t.ArialBlack = "Helvetica";
                    t["ArialBlack-Bold"] = "Helvetica-Bold";
                    t["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique";
                    t["ArialBlack-Italic"] = "Helvetica-Oblique";
                    t["Arial-Black"] = "Helvetica";
                    t["Arial-Black-Bold"] = "Helvetica-Bold";
                    t["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-Black-Italic"] = "Helvetica-Oblique";
                    t.Arial = "Helvetica";
                    t["Arial-Bold"] = "Helvetica-Bold";
                    t["Arial-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Arial-Italic"] = "Helvetica-Oblique";
                    t["Arial-BoldItalicMT"] = "Helvetica-BoldOblique";
                    t["Arial-BoldMT"] = "Helvetica-Bold";
                    t["Arial-ItalicMT"] = "Helvetica-Oblique";
                    t.ArialMT = "Helvetica";
                    t["Courier-BoldItalic"] = "Courier-BoldOblique";
                    t["Courier-Italic"] = "Courier-Oblique";
                    t.CourierNew = "Courier";
                    t["CourierNew-Bold"] = "Courier-Bold";
                    t["CourierNew-BoldItalic"] = "Courier-BoldOblique";
                    t["CourierNew-Italic"] = "Courier-Oblique";
                    t["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique";
                    t["CourierNewPS-BoldMT"] = "Courier-Bold";
                    t["CourierNewPS-ItalicMT"] = "Courier-Oblique";
                    t.CourierNewPSMT = "Courier";
                    t["Helvetica-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Helvetica-Italic"] = "Helvetica-Oblique";
                    t["Symbol-Bold"] = "Symbol";
                    t["Symbol-BoldItalic"] = "Symbol";
                    t["Symbol-Italic"] = "Symbol";
                    t.TimesNewRoman = "Times-Roman";
                    t["TimesNewRoman-Bold"] = "Times-Bold";
                    t["TimesNewRoman-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRoman-Italic"] = "Times-Italic";
                    t.TimesNewRomanPS = "Times-Roman";
                    t["TimesNewRomanPS-Bold"] = "Times-Bold";
                    t["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic";
                    t["TimesNewRomanPS-BoldMT"] = "Times-Bold";
                    t["TimesNewRomanPS-Italic"] = "Times-Italic";
                    t["TimesNewRomanPS-ItalicMT"] = "Times-Italic";
                    t.TimesNewRomanPSMT = "Times-Roman";
                    t["TimesNewRomanPSMT-Bold"] = "Times-Bold";
                    t["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic";
                    t["TimesNewRomanPSMT-Italic"] = "Times-Italic";
                });
                exports.getStdFontMap = getStdFontMap;
                const getFontNameToFileMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = "FoxitFixed.pfb";
                    t["Courier-Bold"] = "FoxitFixedBold.pfb";
                    t["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb";
                    t["Courier-Oblique"] = "FoxitFixedItalic.pfb";
                    t.Helvetica = "FoxitSans.pfb";
                    t["Helvetica-Bold"] = "FoxitSansBold.pfb";
                    t["Helvetica-BoldOblique"] = "FoxitSansBoldItalic.pfb";
                    t["Helvetica-Oblique"] = "FoxitSansItalic.pfb";
                    t["Times-Roman"] = "FoxitSerif.pfb";
                    t["Times-Bold"] = "FoxitSerifBold.pfb";
                    t["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb";
                    t["Times-Italic"] = "FoxitSerifItalic.pfb";
                    t.Symbol = "FoxitSymbol.pfb";
                    t.ZapfDingbats = "FoxitDingbats.pfb";
                    t["LiberationSans-Regular"] = "LiberationSans-Regular.ttf";
                    t["LiberationSans-Bold"] = "LiberationSans-Bold.ttf";
                    t["LiberationSans-Italic"] = "LiberationSans-Italic.ttf";
                    t["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
                });
                exports.getFontNameToFileMap = getFontNameToFileMap;
                const getNonStdFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Calibri = "Helvetica";
                    t["Calibri-Bold"] = "Helvetica-Bold";
                    t["Calibri-BoldItalic"] = "Helvetica-BoldOblique";
                    t["Calibri-Italic"] = "Helvetica-Oblique";
                    t.CenturyGothic = "Helvetica";
                    t["CenturyGothic-Bold"] = "Helvetica-Bold";
                    t["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique";
                    t["CenturyGothic-Italic"] = "Helvetica-Oblique";
                    t.ComicSansMS = "Comic Sans MS";
                    t["ComicSansMS-Bold"] = "Comic Sans MS-Bold";
                    t["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic";
                    t["ComicSansMS-Italic"] = "Comic Sans MS-Italic";
                    t.LucidaConsole = "Courier";
                    t["LucidaConsole-Bold"] = "Courier-Bold";
                    t["LucidaConsole-BoldItalic"] = "Courier-BoldOblique";
                    t["LucidaConsole-Italic"] = "Courier-Oblique";
                    t["LucidaSans-Demi"] = "Helvetica-Bold";
                    t["MS-Gothic"] = "MS Gothic";
                    t["MS-Gothic-Bold"] = "MS Gothic-Bold";
                    t["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic";
                    t["MS-Gothic-Italic"] = "MS Gothic-Italic";
                    t["MS-Mincho"] = "MS Mincho";
                    t["MS-Mincho-Bold"] = "MS Mincho-Bold";
                    t["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic";
                    t["MS-Mincho-Italic"] = "MS Mincho-Italic";
                    t["MS-PGothic"] = "MS PGothic";
                    t["MS-PGothic-Bold"] = "MS PGothic-Bold";
                    t["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic";
                    t["MS-PGothic-Italic"] = "MS PGothic-Italic";
                    t["MS-PMincho"] = "MS PMincho";
                    t["MS-PMincho-Bold"] = "MS PMincho-Bold";
                    t["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic";
                    t["MS-PMincho-Italic"] = "MS PMincho-Italic";
                    t.NuptialScript = "Times-Italic";
                    t.SegoeUISymbol = "Helvetica";
                    t.Wingdings = "ZapfDingbats";
                    t["Wingdings-Regular"] = "ZapfDingbats";
                });
                exports.getNonStdFontMap = getNonStdFontMap;
                const getSerifFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["Adobe Jenson"] = true;
                    t["Adobe Text"] = true;
                    t.Albertus = true;
                    t.Aldus = true;
                    t.Alexandria = true;
                    t.Algerian = true;
                    t["American Typewriter"] = true;
                    t.Antiqua = true;
                    t.Apex = true;
                    t.Arno = true;
                    t.Aster = true;
                    t.Aurora = true;
                    t.Baskerville = true;
                    t.Bell = true;
                    t.Bembo = true;
                    t["Bembo Schoolbook"] = true;
                    t.Benguiat = true;
                    t["Berkeley Old Style"] = true;
                    t["Bernhard Modern"] = true;
                    t["Berthold City"] = true;
                    t.Bodoni = true;
                    t["Bauer Bodoni"] = true;
                    t["Book Antiqua"] = true;
                    t.Bookman = true;
                    t["Bordeaux Roman"] = true;
                    t["Californian FB"] = true;
                    t.Calisto = true;
                    t.Calvert = true;
                    t.Capitals = true;
                    t.Cambria = true;
                    t.Cartier = true;
                    t.Caslon = true;
                    t.Catull = true;
                    t.Centaur = true;
                    t["Century Old Style"] = true;
                    t["Century Schoolbook"] = true;
                    t.Chaparral = true;
                    t["Charis SIL"] = true;
                    t.Cheltenham = true;
                    t["Cholla Slab"] = true;
                    t.Clarendon = true;
                    t.Clearface = true;
                    t.Cochin = true;
                    t.Colonna = true;
                    t["Computer Modern"] = true;
                    t["Concrete Roman"] = true;
                    t.Constantia = true;
                    t["Cooper Black"] = true;
                    t.Corona = true;
                    t.Ecotype = true;
                    t.Egyptienne = true;
                    t.Elephant = true;
                    t.Excelsior = true;
                    t.Fairfield = true;
                    t["FF Scala"] = true;
                    t.Folkard = true;
                    t.Footlight = true;
                    t.FreeSerif = true;
                    t["Friz Quadrata"] = true;
                    t.Garamond = true;
                    t.Gentium = true;
                    t.Georgia = true;
                    t.Gloucester = true;
                    t["Goudy Old Style"] = true;
                    t["Goudy Schoolbook"] = true;
                    t["Goudy Pro Font"] = true;
                    t.Granjon = true;
                    t["Guardian Egyptian"] = true;
                    t.Heather = true;
                    t.Hercules = true;
                    t["High Tower Text"] = true;
                    t.Hiroshige = true;
                    t["Hoefler Text"] = true;
                    t["Humana Serif"] = true;
                    t.Imprint = true;
                    t["Ionic No. 5"] = true;
                    t.Janson = true;
                    t.Joanna = true;
                    t.Korinna = true;
                    t.Lexicon = true;
                    t["Liberation Serif"] = true;
                    t["Linux Libertine"] = true;
                    t.Literaturnaya = true;
                    t.Lucida = true;
                    t["Lucida Bright"] = true;
                    t.Melior = true;
                    t.Memphis = true;
                    t.Miller = true;
                    t.Minion = true;
                    t.Modern = true;
                    t["Mona Lisa"] = true;
                    t["Mrs Eaves"] = true;
                    t["MS Serif"] = true;
                    t["Museo Slab"] = true;
                    t["New York"] = true;
                    t["Nimbus Roman"] = true;
                    t["NPS Rawlinson Roadway"] = true;
                    t.NuptialScript = true;
                    t.Palatino = true;
                    t.Perpetua = true;
                    t.Plantin = true;
                    t["Plantin Schoolbook"] = true;
                    t.Playbill = true;
                    t["Poor Richard"] = true;
                    t["Rawlinson Roadway"] = true;
                    t.Renault = true;
                    t.Requiem = true;
                    t.Rockwell = true;
                    t.Roman = true;
                    t["Rotis Serif"] = true;
                    t.Sabon = true;
                    t.Scala = true;
                    t.Seagull = true;
                    t.Sistina = true;
                    t.Souvenir = true;
                    t.STIX = true;
                    t["Stone Informal"] = true;
                    t["Stone Serif"] = true;
                    t.Sylfaen = true;
                    t.Times = true;
                    t.Trajan = true;
                    t["Trinit\xe9"] = true;
                    t["Trump Mediaeval"] = true;
                    t.Utopia = true;
                    t["Vale Type"] = true;
                    t["Bitstream Vera"] = true;
                    t["Vera Serif"] = true;
                    t.Versailles = true;
                    t.Wanted = true;
                    t.Weiss = true;
                    t["Wide Latin"] = true;
                    t.Windsor = true;
                    t.XITS = true;
                });
                exports.getSerifFonts = getSerifFonts;
                const getSymbolsFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Dingbats = true;
                    t.Symbol = true;
                    t.ZapfDingbats = true;
                });
                exports.getSymbolsFonts = getSymbolsFonts;
                const getGlyphMapForStandardFonts = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[2] = 10;
                    t[3] = 32;
                    t[4] = 33;
                    t[5] = 34;
                    t[6] = 35;
                    t[7] = 36;
                    t[8] = 37;
                    t[9] = 38;
                    t[10] = 39;
                    t[11] = 40;
                    t[12] = 41;
                    t[13] = 42;
                    t[14] = 43;
                    t[15] = 44;
                    t[16] = 45;
                    t[17] = 46;
                    t[18] = 47;
                    t[19] = 48;
                    t[20] = 49;
                    t[21] = 50;
                    t[22] = 51;
                    t[23] = 52;
                    t[24] = 53;
                    t[25] = 54;
                    t[26] = 55;
                    t[27] = 56;
                    t[28] = 57;
                    t[29] = 58;
                    t[30] = 894;
                    t[31] = 60;
                    t[32] = 61;
                    t[33] = 62;
                    t[34] = 63;
                    t[35] = 64;
                    t[36] = 65;
                    t[37] = 66;
                    t[38] = 67;
                    t[39] = 68;
                    t[40] = 69;
                    t[41] = 70;
                    t[42] = 71;
                    t[43] = 72;
                    t[44] = 73;
                    t[45] = 74;
                    t[46] = 75;
                    t[47] = 76;
                    t[48] = 77;
                    t[49] = 78;
                    t[50] = 79;
                    t[51] = 80;
                    t[52] = 81;
                    t[53] = 82;
                    t[54] = 83;
                    t[55] = 84;
                    t[56] = 85;
                    t[57] = 86;
                    t[58] = 87;
                    t[59] = 88;
                    t[60] = 89;
                    t[61] = 90;
                    t[62] = 91;
                    t[63] = 92;
                    t[64] = 93;
                    t[65] = 94;
                    t[66] = 95;
                    t[67] = 96;
                    t[68] = 97;
                    t[69] = 98;
                    t[70] = 99;
                    t[71] = 100;
                    t[72] = 101;
                    t[73] = 102;
                    t[74] = 103;
                    t[75] = 104;
                    t[76] = 105;
                    t[77] = 106;
                    t[78] = 107;
                    t[79] = 108;
                    t[80] = 109;
                    t[81] = 110;
                    t[82] = 111;
                    t[83] = 112;
                    t[84] = 113;
                    t[85] = 114;
                    t[86] = 115;
                    t[87] = 116;
                    t[88] = 117;
                    t[89] = 118;
                    t[90] = 119;
                    t[91] = 120;
                    t[92] = 121;
                    t[93] = 122;
                    t[94] = 123;
                    t[95] = 124;
                    t[96] = 125;
                    t[97] = 126;
                    t[98] = 196;
                    t[99] = 197;
                    t[100] = 199;
                    t[101] = 201;
                    t[102] = 209;
                    t[103] = 214;
                    t[104] = 220;
                    t[105] = 225;
                    t[106] = 224;
                    t[107] = 226;
                    t[108] = 228;
                    t[109] = 227;
                    t[110] = 229;
                    t[111] = 231;
                    t[112] = 233;
                    t[113] = 232;
                    t[114] = 234;
                    t[115] = 235;
                    t[116] = 237;
                    t[117] = 236;
                    t[118] = 238;
                    t[119] = 239;
                    t[120] = 241;
                    t[121] = 243;
                    t[122] = 242;
                    t[123] = 244;
                    t[124] = 246;
                    t[125] = 245;
                    t[126] = 250;
                    t[127] = 249;
                    t[128] = 251;
                    t[129] = 252;
                    t[130] = 8224;
                    t[131] = 176;
                    t[132] = 162;
                    t[133] = 163;
                    t[134] = 167;
                    t[135] = 8226;
                    t[136] = 182;
                    t[137] = 223;
                    t[138] = 174;
                    t[139] = 169;
                    t[140] = 8482;
                    t[141] = 180;
                    t[142] = 168;
                    t[143] = 8800;
                    t[144] = 198;
                    t[145] = 216;
                    t[146] = 8734;
                    t[147] = 177;
                    t[148] = 8804;
                    t[149] = 8805;
                    t[150] = 165;
                    t[151] = 181;
                    t[152] = 8706;
                    t[153] = 8721;
                    t[154] = 8719;
                    t[156] = 8747;
                    t[157] = 170;
                    t[158] = 186;
                    t[159] = 8486;
                    t[160] = 230;
                    t[161] = 248;
                    t[162] = 191;
                    t[163] = 161;
                    t[164] = 172;
                    t[165] = 8730;
                    t[166] = 402;
                    t[167] = 8776;
                    t[168] = 8710;
                    t[169] = 171;
                    t[170] = 187;
                    t[171] = 8230;
                    t[210] = 218;
                    t[223] = 711;
                    t[224] = 321;
                    t[225] = 322;
                    t[227] = 353;
                    t[229] = 382;
                    t[234] = 253;
                    t[252] = 263;
                    t[253] = 268;
                    t[254] = 269;
                    t[258] = 258;
                    t[260] = 260;
                    t[261] = 261;
                    t[265] = 280;
                    t[266] = 281;
                    t[268] = 283;
                    t[269] = 313;
                    t[275] = 323;
                    t[276] = 324;
                    t[278] = 328;
                    t[284] = 345;
                    t[285] = 346;
                    t[286] = 347;
                    t[292] = 367;
                    t[295] = 377;
                    t[296] = 378;
                    t[298] = 380;
                    t[305] = 963;
                    t[306] = 964;
                    t[307] = 966;
                    t[308] = 8215;
                    t[309] = 8252;
                    t[310] = 8319;
                    t[311] = 8359;
                    t[312] = 8592;
                    t[313] = 8593;
                    t[337] = 9552;
                    t[493] = 1039;
                    t[494] = 1040;
                    t[705] = 1524;
                    t[706] = 8362;
                    t[710] = 64288;
                    t[711] = 64298;
                    t[759] = 1617;
                    t[761] = 1776;
                    t[763] = 1778;
                    t[775] = 1652;
                    t[777] = 1764;
                    t[778] = 1780;
                    t[779] = 1781;
                    t[780] = 1782;
                    t[782] = 771;
                    t[783] = 64726;
                    t[786] = 8363;
                    t[788] = 8532;
                    t[790] = 768;
                    t[791] = 769;
                    t[792] = 768;
                    t[795] = 803;
                    t[797] = 64336;
                    t[798] = 64337;
                    t[799] = 64342;
                    t[800] = 64343;
                    t[801] = 64344;
                    t[802] = 64345;
                    t[803] = 64362;
                    t[804] = 64363;
                    t[805] = 64364;
                    t[2424] = 7821;
                    t[2425] = 7822;
                    t[2426] = 7823;
                    t[2427] = 7824;
                    t[2428] = 7825;
                    t[2429] = 7826;
                    t[2430] = 7827;
                    t[2433] = 7682;
                    t[2678] = 8045;
                    t[2679] = 8046;
                    t[2830] = 1552;
                    t[2838] = 686;
                    t[2840] = 751;
                    t[2842] = 753;
                    t[2843] = 754;
                    t[2844] = 755;
                    t[2846] = 757;
                    t[2856] = 767;
                    t[2857] = 848;
                    t[2858] = 849;
                    t[2862] = 853;
                    t[2863] = 854;
                    t[2864] = 855;
                    t[2865] = 861;
                    t[2866] = 862;
                    t[2906] = 7460;
                    t[2908] = 7462;
                    t[2909] = 7463;
                    t[2910] = 7464;
                    t[2912] = 7466;
                    t[2913] = 7467;
                    t[2914] = 7468;
                    t[2916] = 7470;
                    t[2917] = 7471;
                    t[2918] = 7472;
                    t[2920] = 7474;
                    t[2921] = 7475;
                    t[2922] = 7476;
                    t[2924] = 7478;
                    t[2925] = 7479;
                    t[2926] = 7480;
                    t[2928] = 7482;
                    t[2929] = 7483;
                    t[2930] = 7484;
                    t[2932] = 7486;
                    t[2933] = 7487;
                    t[2934] = 7488;
                    t[2936] = 7490;
                    t[2937] = 7491;
                    t[2938] = 7492;
                    t[2940] = 7494;
                    t[2941] = 7495;
                    t[2942] = 7496;
                    t[2944] = 7498;
                    t[2946] = 7500;
                    t[2948] = 7502;
                    t[2950] = 7504;
                    t[2951] = 7505;
                    t[2952] = 7506;
                    t[2954] = 7508;
                    t[2955] = 7509;
                    t[2956] = 7510;
                    t[2958] = 7512;
                    t[2959] = 7513;
                    t[2960] = 7514;
                    t[2962] = 7516;
                    t[2963] = 7517;
                    t[2964] = 7518;
                    t[2966] = 7520;
                    t[2967] = 7521;
                    t[2968] = 7522;
                    t[2970] = 7524;
                    t[2971] = 7525;
                    t[2972] = 7526;
                    t[2974] = 7528;
                    t[2975] = 7529;
                    t[2976] = 7530;
                    t[2978] = 1537;
                    t[2979] = 1538;
                    t[2980] = 1539;
                    t[2982] = 1549;
                    t[2983] = 1551;
                    t[2984] = 1552;
                    t[2986] = 1554;
                    t[2987] = 1555;
                    t[2988] = 1556;
                    t[2990] = 1623;
                    t[2991] = 1624;
                    t[2995] = 1775;
                    t[2999] = 1791;
                    t[3002] = 64290;
                    t[3003] = 64291;
                    t[3004] = 64292;
                    t[3006] = 64294;
                    t[3007] = 64295;
                    t[3008] = 64296;
                    t[3011] = 1900;
                    t[3014] = 8223;
                    t[3015] = 8244;
                    t[3017] = 7532;
                    t[3018] = 7533;
                    t[3019] = 7534;
                    t[3075] = 7590;
                    t[3076] = 7591;
                    t[3079] = 7594;
                    t[3080] = 7595;
                    t[3083] = 7598;
                    t[3084] = 7599;
                    t[3087] = 7602;
                    t[3088] = 7603;
                    t[3091] = 7606;
                    t[3092] = 7607;
                    t[3095] = 7610;
                    t[3096] = 7611;
                    t[3099] = 7614;
                    t[3100] = 7615;
                    t[3103] = 7618;
                    t[3104] = 7619;
                    t[3107] = 8337;
                    t[3108] = 8338;
                    t[3116] = 1884;
                    t[3119] = 1885;
                    t[3120] = 1885;
                    t[3123] = 1886;
                    t[3124] = 1886;
                    t[3127] = 1887;
                    t[3128] = 1887;
                    t[3131] = 1888;
                    t[3132] = 1888;
                    t[3135] = 1889;
                    t[3136] = 1889;
                    t[3139] = 1890;
                    t[3140] = 1890;
                    t[3143] = 1891;
                    t[3144] = 1891;
                    t[3147] = 1892;
                    t[3148] = 1892;
                    t[3153] = 580;
                    t[3154] = 581;
                    t[3157] = 584;
                    t[3158] = 585;
                    t[3161] = 588;
                    t[3162] = 589;
                    t[3165] = 891;
                    t[3166] = 892;
                    t[3169] = 1274;
                    t[3170] = 1275;
                    t[3173] = 1278;
                    t[3174] = 1279;
                    t[3181] = 7622;
                    t[3182] = 7623;
                    t[3282] = 11799;
                    t[3316] = 578;
                    t[3379] = 42785;
                    t[3393] = 1159;
                    t[3416] = 8377;
                });
                exports.getGlyphMapForStandardFonts = getGlyphMapForStandardFonts;
                const getSupplementalGlyphMapForArialBlack = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[227] = 322;
                    t[264] = 261;
                    t[291] = 346;
                });
                exports.getSupplementalGlyphMapForArialBlack = getSupplementalGlyphMapForArialBlack;
                const getSupplementalGlyphMapForCalibri = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t[1] = 32;
                    t[4] = 65;
                    t[17] = 66;
                    t[18] = 67;
                    t[24] = 68;
                    t[28] = 69;
                    t[38] = 70;
                    t[39] = 71;
                    t[44] = 72;
                    t[47] = 73;
                    t[58] = 74;
                    t[60] = 75;
                    t[62] = 76;
                    t[68] = 77;
                    t[69] = 78;
                    t[75] = 79;
                    t[87] = 80;
                    t[89] = 81;
                    t[90] = 82;
                    t[94] = 83;
                    t[100] = 84;
                    t[104] = 85;
                    t[115] = 86;
                    t[116] = 87;
                    t[121] = 88;
                    t[122] = 89;
                    t[127] = 90;
                    t[258] = 97;
                    t[268] = 261;
                    t[271] = 98;
                    t[272] = 99;
                    t[273] = 263;
                    t[282] = 100;
                    t[286] = 101;
                    t[295] = 281;
                    t[296] = 102;
                    t[336] = 103;
                    t[346] = 104;
                    t[349] = 105;
                    t[361] = 106;
                    t[364] = 107;
                    t[367] = 108;
                    t[371] = 322;
                    t[373] = 109;
                    t[374] = 110;
                    t[381] = 111;
                    t[383] = 243;
                    t[393] = 112;
                    t[395] = 113;
                    t[396] = 114;
                    t[400] = 115;
                    t[401] = 347;
                    t[410] = 116;
                    t[437] = 117;
                    t[448] = 118;
                    t[449] = 119;
                    t[454] = 120;
                    t[455] = 121;
                    t[460] = 122;
                    t[463] = 380;
                    t[853] = 44;
                    t[855] = 58;
                    t[856] = 46;
                    t[876] = 47;
                    t[878] = 45;
                    t[882] = 45;
                    t[894] = 40;
                    t[895] = 41;
                    t[896] = 91;
                    t[897] = 93;
                    t[923] = 64;
                    t[1004] = 48;
                    t[1005] = 49;
                    t[1006] = 50;
                    t[1007] = 51;
                    t[1008] = 52;
                    t[1009] = 53;
                    t[1010] = 54;
                    t[1011] = 55;
                    t[1012] = 56;
                    t[1013] = 57;
                    t[1081] = 37;
                    t[1085] = 43;
                    t[1086] = 45;
                });
                exports.getSupplementalGlyphMapForCalibri = getSupplementalGlyphMapForCalibri;
                function getStandardFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    const stdFontMap = getStdFontMap();
                    return stdFontMap[fontName];
                }
            /***/ },
            /* 42 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ToUnicodeMap = exports.IdentityToUnicodeMap = void 0;
                var _util = __w_pdfjs_require__(2);
                class ToUnicodeMap {
                    constructor(cmap = []){
                        this._map = cmap;
                    }
                    get length() {
                        return this._map.length;
                    }
                    forEach(callback) {
                        for(const charCode in this._map)callback(charCode, this._map[charCode].charCodeAt(0));
                    }
                    has(i) {
                        return this._map[i] !== undefined;
                    }
                    get(i) {
                        return this._map[i];
                    }
                    charCodeOf(value) {
                        const map = this._map;
                        if (map.length <= 0x10000) return map.indexOf(value);
                        for(const charCode in map){
                            if (map[charCode] === value) return charCode | 0;
                        }
                        return -1;
                    }
                    amend(map) {
                        for(const charCode in map)this._map[charCode] = map[charCode];
                    }
                }
                exports.ToUnicodeMap = ToUnicodeMap;
                class IdentityToUnicodeMap {
                    constructor(firstChar, lastChar){
                        this.firstChar = firstChar;
                        this.lastChar = lastChar;
                    }
                    get length() {
                        return this.lastChar + 1 - this.firstChar;
                    }
                    forEach(callback) {
                        for(let i = this.firstChar, ii = this.lastChar; i <= ii; i++)callback(i, i);
                    }
                    has(i) {
                        return this.firstChar <= i && i <= this.lastChar;
                    }
                    get(i) {
                        if (this.firstChar <= i && i <= this.lastChar) return String.fromCharCode(i);
                        return undefined;
                    }
                    charCodeOf(v) {
                        return Number.isInteger(v) && v >= this.firstChar && v <= this.lastChar ? v : -1;
                    }
                    amend(map) {
                        (0, _util.unreachable)("Should not call amend()");
                    }
                }
                exports.IdentityToUnicodeMap = IdentityToUnicodeMap;
            /***/ },
            /* 43 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CFFFont = void 0;
                var _cff_parser = __w_pdfjs_require__(35);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _util = __w_pdfjs_require__(2);
                class CFFFont {
                    constructor(file, properties){
                        this.properties = properties;
                        const parser = new _cff_parser.CFFParser(file, properties, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        this.cff = parser.parse();
                        this.cff.duplicateFirstGlyph();
                        const compiler = new _cff_parser.CFFCompiler(this.cff);
                        this.seacs = this.cff.seacs;
                        try {
                            this.data = compiler.compile();
                        } catch (e) {
                            (0, _util.warn)("Failed to compile font " + properties.loadedName);
                            this.data = file;
                        }
                        this._createBuiltInEncoding();
                    }
                    get numGlyphs() {
                        return this.cff.charStrings.count;
                    }
                    getCharset() {
                        return this.cff.charset.charset;
                    }
                    getGlyphMapping() {
                        const cff = this.cff;
                        const properties = this.properties;
                        const charsets = cff.charset.charset;
                        let charCodeToGlyphId;
                        let glyphId;
                        if (properties.composite) {
                            charCodeToGlyphId = Object.create(null);
                            let charCode;
                            if (cff.isCIDFont) for(glyphId = 0; glyphId < charsets.length; glyphId++){
                                const cid = charsets[glyphId];
                                charCode = properties.cMap.charCodeOf(cid);
                                charCodeToGlyphId[charCode] = glyphId;
                            }
                            else for(glyphId = 0; glyphId < cff.charStrings.count; glyphId++){
                                charCode = properties.cMap.charCodeOf(glyphId);
                                charCodeToGlyphId[charCode] = glyphId;
                            }
                            return charCodeToGlyphId;
                        }
                        let encoding = cff.encoding ? cff.encoding.encoding : null;
                        if (properties.isInternalFont) encoding = properties.defaultEncoding;
                        charCodeToGlyphId = (0, _fonts_utils.type1FontGlyphMapping)(properties, encoding, charsets);
                        return charCodeToGlyphId;
                    }
                    hasGlyphId(id) {
                        return this.cff.hasGlyphId(id);
                    }
                    _createBuiltInEncoding() {
                        const { charset: charset , encoding: encoding  } = this.cff;
                        if (!charset || !encoding) return;
                        const charsets = charset.charset, encodings = encoding.encoding;
                        const map = [];
                        for(const charCode in encodings){
                            const glyphId = encodings[charCode];
                            if (glyphId >= 0) {
                                const glyphName = charsets[glyphId];
                                if (glyphName) map[charCode] = glyphName;
                            }
                        }
                        if (map.length > 0) this.properties.builtInEncoding = map;
                    }
                }
                exports.CFFFont = CFFFont;
            /***/ },
            /* 44 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontRendererFactory = void 0;
                var _util = __w_pdfjs_require__(2);
                var _cff_parser = __w_pdfjs_require__(35);
                var _glyphlist = __w_pdfjs_require__(39);
                var _encodings = __w_pdfjs_require__(37);
                var _stream = __w_pdfjs_require__(10);
                function getLong(data, offset) {
                    return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
                }
                function getUshort(data, offset) {
                    return data[offset] << 8 | data[offset + 1];
                }
                function getSubroutineBias(subrs) {
                    const numSubrs = subrs.length;
                    let bias = 32768;
                    if (numSubrs < 1240) bias = 107;
                    else if (numSubrs < 33900) bias = 1131;
                    return bias;
                }
                function parseCmap(data, start, end) {
                    const offset = getUshort(data, start + 2) === 1 ? getLong(data, start + 8) : getLong(data, start + 16);
                    const format = getUshort(data, start + offset);
                    let ranges, p, i;
                    if (format === 4) {
                        getUshort(data, start + offset + 2);
                        const segCount = getUshort(data, start + offset + 6) >> 1;
                        p = start + offset + 14;
                        ranges = [];
                        for(i = 0; i < segCount; i++, p += 2)ranges[i] = {
                            end: getUshort(data, p)
                        };
                        p += 2;
                        for(i = 0; i < segCount; i++, p += 2)ranges[i].start = getUshort(data, p);
                        for(i = 0; i < segCount; i++, p += 2)ranges[i].idDelta = getUshort(data, p);
                        for(i = 0; i < segCount; i++, p += 2){
                            let idOffset = getUshort(data, p);
                            if (idOffset === 0) continue;
                            ranges[i].ids = [];
                            for(let j = 0, jj = ranges[i].end - ranges[i].start + 1; j < jj; j++){
                                ranges[i].ids[j] = getUshort(data, p + idOffset);
                                idOffset += 2;
                            }
                        }
                        return ranges;
                    } else if (format === 12) {
                        getLong(data, start + offset + 4);
                        const groups = getLong(data, start + offset + 12);
                        p = start + offset + 16;
                        ranges = [];
                        for(i = 0; i < groups; i++){
                            ranges.push({
                                start: getLong(data, p),
                                end: getLong(data, p + 4),
                                idDelta: getLong(data, p + 8) - getLong(data, p)
                            });
                            p += 12;
                        }
                        return ranges;
                    }
                    throw new _util.FormatError(`unsupported cmap: ${format}`);
                }
                function parseCff(data, start, end, seacAnalysisEnabled) {
                    const properties = {};
                    const parser = new _cff_parser.CFFParser(new _stream.Stream(data, start, end - start), properties, seacAnalysisEnabled);
                    const cff = parser.parse();
                    return {
                        glyphs: cff.charStrings.objects,
                        subrs: cff.topDict.privateDict && cff.topDict.privateDict.subrsIndex && cff.topDict.privateDict.subrsIndex.objects,
                        gsubrs: cff.globalSubrIndex && cff.globalSubrIndex.objects,
                        isCFFCIDFont: cff.isCIDFont,
                        fdSelect: cff.fdSelect,
                        fdArray: cff.fdArray
                    };
                }
                function parseGlyfTable(glyf, loca, isGlyphLocationsLong) {
                    let itemSize, itemDecode;
                    if (isGlyphLocationsLong) {
                        itemSize = 4;
                        itemDecode = function fontItemDecodeLong(data, offset) {
                            return data[offset] << 24 | data[offset + 1] << 16 | data[offset + 2] << 8 | data[offset + 3];
                        };
                    } else {
                        itemSize = 2;
                        itemDecode = function fontItemDecode(data, offset) {
                            return data[offset] << 9 | data[offset + 1] << 1;
                        };
                    }
                    const glyphs = [];
                    let startOffset = itemDecode(loca, 0);
                    for(let j = itemSize; j < loca.length; j += itemSize){
                        const endOffset = itemDecode(loca, j);
                        glyphs.push(glyf.subarray(startOffset, endOffset));
                        startOffset = endOffset;
                    }
                    return glyphs;
                }
                function lookupCmap(ranges, unicode) {
                    const code = unicode.codePointAt(0);
                    let gid = 0, l = 0, r = ranges.length - 1;
                    while(l < r){
                        const c = l + r + 1 >> 1;
                        if (code < ranges[c].start) r = c - 1;
                        else l = c;
                    }
                    if (ranges[l].start <= code && code <= ranges[l].end) gid = ranges[l].idDelta + (ranges[l].ids ? ranges[l].ids[code - ranges[l].start] : code) & 0xffff;
                    return {
                        charCode: code,
                        glyphId: gid
                    };
                }
                function compileGlyf(code, cmds, font1) {
                    function moveTo(x, y) {
                        cmds.push({
                            cmd: "moveTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function lineTo(x, y) {
                        cmds.push({
                            cmd: "lineTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function quadraticCurveTo(xa, ya, x, y) {
                        cmds.push({
                            cmd: "quadraticCurveTo",
                            args: [
                                xa,
                                ya,
                                x,
                                y
                            ]
                        });
                    }
                    let i = 0;
                    const numberOfContours = (code[i] << 24 | code[i + 1] << 16) >> 16;
                    let flags;
                    let x = 0, y = 0;
                    i += 10;
                    if (numberOfContours < 0) do {
                        flags = code[i] << 8 | code[i + 1];
                        const glyphIndex = code[i + 2] << 8 | code[i + 3];
                        i += 4;
                        let arg1, arg2;
                        if (flags & 0x01) {
                            arg1 = (code[i] << 24 | code[i + 1] << 16) >> 16;
                            arg2 = (code[i + 2] << 24 | code[i + 3] << 16) >> 16;
                            i += 4;
                        } else {
                            arg1 = code[i++];
                            arg2 = code[i++];
                        }
                        if (flags & 0x02) {
                            x = arg1;
                            y = arg2;
                        } else {
                            x = 0;
                            y = 0;
                        }
                        let scaleX = 1, scaleY = 1, scale01 = 0, scale10 = 0;
                        if (flags & 0x08) {
                            scaleX = scaleY = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
                            i += 2;
                        } else if (flags & 0x40) {
                            scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
                            scaleY = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
                            i += 4;
                        } else if (flags & 0x80) {
                            scaleX = (code[i] << 24 | code[i + 1] << 16) / 1073741824;
                            scale01 = (code[i + 2] << 24 | code[i + 3] << 16) / 1073741824;
                            scale10 = (code[i + 4] << 24 | code[i + 5] << 16) / 1073741824;
                            scaleY = (code[i + 6] << 24 | code[i + 7] << 16) / 1073741824;
                            i += 8;
                        }
                        const subglyph = font1.glyphs[glyphIndex];
                        if (subglyph) {
                            cmds.push({
                                cmd: "save"
                            }, {
                                cmd: "transform",
                                args: [
                                    scaleX,
                                    scale01,
                                    scale10,
                                    scaleY,
                                    x,
                                    y
                                ]
                            });
                            compileGlyf(subglyph, cmds, font1);
                            cmds.push({
                                cmd: "restore"
                            });
                        }
                    }while (flags & 0x20);
                    else {
                        const endPtsOfContours = [];
                        let j, jj;
                        for(j = 0; j < numberOfContours; j++){
                            endPtsOfContours.push(code[i] << 8 | code[i + 1]);
                            i += 2;
                        }
                        const instructionLength = code[i] << 8 | code[i + 1];
                        i += 2 + instructionLength;
                        const numberOfPoints = endPtsOfContours[endPtsOfContours.length - 1] + 1;
                        const points = [];
                        while(points.length < numberOfPoints){
                            flags = code[i++];
                            let repeat = 1;
                            if (flags & 0x08) repeat += code[i++];
                            while(repeat-- > 0)points.push({
                                flags: flags
                            });
                        }
                        for(j = 0; j < numberOfPoints; j++){
                            switch(points[j].flags & 0x12){
                                case 0x00:
                                    x += (code[i] << 24 | code[i + 1] << 16) >> 16;
                                    i += 2;
                                    break;
                                case 0x02:
                                    x -= code[i++];
                                    break;
                                case 0x12:
                                    x += code[i++];
                                    break;
                            }
                            points[j].x = x;
                        }
                        for(j = 0; j < numberOfPoints; j++){
                            switch(points[j].flags & 0x24){
                                case 0x00:
                                    y += (code[i] << 24 | code[i + 1] << 16) >> 16;
                                    i += 2;
                                    break;
                                case 0x04:
                                    y -= code[i++];
                                    break;
                                case 0x24:
                                    y += code[i++];
                                    break;
                            }
                            points[j].y = y;
                        }
                        let startPoint = 0;
                        for(i = 0; i < numberOfContours; i++){
                            const endPoint = endPtsOfContours[i];
                            const contour = points.slice(startPoint, endPoint + 1);
                            if (contour[0].flags & 1) contour.push(contour[0]);
                            else if (contour[contour.length - 1].flags & 1) contour.unshift(contour[contour.length - 1]);
                            else {
                                const p = {
                                    flags: 1,
                                    x: (contour[0].x + contour[contour.length - 1].x) / 2,
                                    y: (contour[0].y + contour[contour.length - 1].y) / 2
                                };
                                contour.unshift(p);
                                contour.push(p);
                            }
                            moveTo(contour[0].x, contour[0].y);
                            for(j = 1, jj = contour.length; j < jj; j++){
                                if (contour[j].flags & 1) lineTo(contour[j].x, contour[j].y);
                                else if (contour[j + 1].flags & 1) {
                                    quadraticCurveTo(contour[j].x, contour[j].y, contour[j + 1].x, contour[j + 1].y);
                                    j++;
                                } else quadraticCurveTo(contour[j].x, contour[j].y, (contour[j].x + contour[j + 1].x) / 2, (contour[j].y + contour[j + 1].y) / 2);
                            }
                            startPoint = endPoint + 1;
                        }
                    }
                }
                function compileCharString(charStringCode, cmds, font1, glyphId) {
                    function moveTo(x, y) {
                        cmds.push({
                            cmd: "moveTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function lineTo(x, y) {
                        cmds.push({
                            cmd: "lineTo",
                            args: [
                                x,
                                y
                            ]
                        });
                    }
                    function bezierCurveTo(x1, y1, x2, y2, x, y) {
                        cmds.push({
                            cmd: "bezierCurveTo",
                            args: [
                                x1,
                                y1,
                                x2,
                                y2,
                                x,
                                y
                            ]
                        });
                    }
                    const stack = [];
                    let x = 0, y = 0;
                    let stems = 0;
                    function parse(code) {
                        let i = 0;
                        while(i < code.length){
                            let stackClean = false;
                            let v = code[i++];
                            let xa, xb, ya, yb, y1, y2, y3, n, subrCode;
                            switch(v){
                                case 1:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 3:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 4:
                                    y += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 5:
                                    while(stack.length > 0){
                                        x += stack.shift();
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 6:
                                    while(stack.length > 0){
                                        x += stack.shift();
                                        lineTo(x, y);
                                        if (stack.length === 0) break;
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 7:
                                    while(stack.length > 0){
                                        y += stack.shift();
                                        lineTo(x, y);
                                        if (stack.length === 0) break;
                                        x += stack.shift();
                                        lineTo(x, y);
                                    }
                                    break;
                                case 8:
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 10:
                                    n = stack.pop();
                                    subrCode = null;
                                    if (font1.isCFFCIDFont) {
                                        const fdIndex = font1.fdSelect.getFDIndex(glyphId);
                                        if (fdIndex >= 0 && fdIndex < font1.fdArray.length) {
                                            const fontDict = font1.fdArray[fdIndex];
                                            let subrs;
                                            if (fontDict.privateDict && fontDict.privateDict.subrsIndex) subrs = fontDict.privateDict.subrsIndex.objects;
                                            if (subrs) {
                                                n += getSubroutineBias(subrs);
                                                subrCode = subrs[n];
                                            }
                                        } else (0, _util.warn)("Invalid fd index for glyph index.");
                                    } else subrCode = font1.subrs[n + font1.subrsBias];
                                    if (subrCode) parse(subrCode);
                                    break;
                                case 11:
                                    return;
                                case 12:
                                    v = code[i++];
                                    switch(v){
                                        case 34:
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            y1 = y + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y, xb, y1, x, y1);
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y1, xb, y, x, y);
                                            break;
                                        case 35:
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            stack.pop();
                                            break;
                                        case 36:
                                            xa = x + stack.shift();
                                            y1 = y + stack.shift();
                                            xb = xa + stack.shift();
                                            y2 = y1 + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y1, xb, y2, x, y2);
                                            xa = x + stack.shift();
                                            xb = xa + stack.shift();
                                            y3 = y2 + stack.shift();
                                            x = xb + stack.shift();
                                            bezierCurveTo(xa, y2, xb, y3, x, y);
                                            break;
                                        case 37:
                                            const x0 = x, y0 = y;
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb + stack.shift();
                                            y = yb + stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            xa = x + stack.shift();
                                            ya = y + stack.shift();
                                            xb = xa + stack.shift();
                                            yb = ya + stack.shift();
                                            x = xb;
                                            y = yb;
                                            if (Math.abs(x - x0) > Math.abs(y - y0)) x += stack.shift();
                                            else y += stack.shift();
                                            bezierCurveTo(xa, ya, xb, yb, x, y);
                                            break;
                                        default:
                                            throw new _util.FormatError(`unknown operator: 12 ${v}`);
                                    }
                                    break;
                                case 14:
                                    if (stack.length >= 4) {
                                        const achar = stack.pop();
                                        const bchar = stack.pop();
                                        y = stack.pop();
                                        x = stack.pop();
                                        cmds.push({
                                            cmd: "save"
                                        }, {
                                            cmd: "translate",
                                            args: [
                                                x,
                                                y
                                            ]
                                        });
                                        let cmap = lookupCmap(font1.cmap, String.fromCharCode(font1.glyphNameMap[_encodings.StandardEncoding[achar]]));
                                        compileCharString(font1.glyphs[cmap.glyphId], cmds, font1, cmap.glyphId);
                                        cmds.push({
                                            cmd: "restore"
                                        });
                                        cmap = lookupCmap(font1.cmap, String.fromCharCode(font1.glyphNameMap[_encodings.StandardEncoding[bchar]]));
                                        compileCharString(font1.glyphs[cmap.glyphId], cmds, font1, cmap.glyphId);
                                    }
                                    return;
                                case 18:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 19:
                                    stems += stack.length >> 1;
                                    i += stems + 7 >> 3;
                                    stackClean = true;
                                    break;
                                case 20:
                                    stems += stack.length >> 1;
                                    i += stems + 7 >> 3;
                                    stackClean = true;
                                    break;
                                case 21:
                                    y += stack.pop();
                                    x += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 22:
                                    x += stack.pop();
                                    moveTo(x, y);
                                    stackClean = true;
                                    break;
                                case 23:
                                    stems += stack.length >> 1;
                                    stackClean = true;
                                    break;
                                case 24:
                                    while(stack.length > 2){
                                        xa = x + stack.shift();
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    x += stack.shift();
                                    y += stack.shift();
                                    lineTo(x, y);
                                    break;
                                case 25:
                                    while(stack.length > 6){
                                        x += stack.shift();
                                        y += stack.shift();
                                        lineTo(x, y);
                                    }
                                    xa = x + stack.shift();
                                    ya = y + stack.shift();
                                    xb = xa + stack.shift();
                                    yb = ya + stack.shift();
                                    x = xb + stack.shift();
                                    y = yb + stack.shift();
                                    bezierCurveTo(xa, ya, xb, yb, x, y);
                                    break;
                                case 26:
                                    if (stack.length % 2) x += stack.shift();
                                    while(stack.length > 0){
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb;
                                        y = yb + stack.shift();
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 27:
                                    if (stack.length % 2) y += stack.shift();
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb;
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 28:
                                    stack.push((code[i] << 24 | code[i + 1] << 16) >> 16);
                                    i += 2;
                                    break;
                                case 29:
                                    n = stack.pop() + font1.gsubrsBias;
                                    subrCode = font1.gsubrs[n];
                                    if (subrCode) parse(subrCode);
                                    break;
                                case 30:
                                    while(stack.length > 0){
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                        if (stack.length === 0) break;
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        y = yb + stack.shift();
                                        x = xb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                case 31:
                                    while(stack.length > 0){
                                        xa = x + stack.shift();
                                        ya = y;
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        y = yb + stack.shift();
                                        x = xb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                        if (stack.length === 0) break;
                                        xa = x;
                                        ya = y + stack.shift();
                                        xb = xa + stack.shift();
                                        yb = ya + stack.shift();
                                        x = xb + stack.shift();
                                        y = yb + (stack.length === 1 ? stack.shift() : 0);
                                        bezierCurveTo(xa, ya, xb, yb, x, y);
                                    }
                                    break;
                                default:
                                    if (v < 32) throw new _util.FormatError(`unknown operator: ${v}`);
                                    if (v < 247) stack.push(v - 139);
                                    else if (v < 251) stack.push((v - 247) * 256 + code[i++] + 108);
                                    else if (v < 255) stack.push(-(v - 251) * 256 - code[i++] - 108);
                                    else {
                                        stack.push((code[i] << 24 | code[i + 1] << 16 | code[i + 2] << 8 | code[i + 3]) / 65536);
                                        i += 4;
                                    }
                                    break;
                            }
                            if (stackClean) stack.length = 0;
                        }
                    }
                    parse(charStringCode);
                }
                const NOOP = [];
                class CompiledFont {
                    constructor(fontMatrix){
                        if (this.constructor === CompiledFont) (0, _util.unreachable)("Cannot initialize CompiledFont.");
                        this.fontMatrix = fontMatrix;
                        this.compiledGlyphs = Object.create(null);
                        this.compiledCharCodeToGlyphId = Object.create(null);
                    }
                    getPathJs(unicode) {
                        const { charCode: charCode , glyphId: glyphId  } = lookupCmap(this.cmap, unicode);
                        let fn = this.compiledGlyphs[glyphId];
                        if (!fn) try {
                            fn = this.compileGlyph(this.glyphs[glyphId], glyphId);
                            this.compiledGlyphs[glyphId] = fn;
                        } catch (ex) {
                            this.compiledGlyphs[glyphId] = NOOP;
                            if (this.compiledCharCodeToGlyphId[charCode] === undefined) this.compiledCharCodeToGlyphId[charCode] = glyphId;
                            throw ex;
                        }
                        if (this.compiledCharCodeToGlyphId[charCode] === undefined) this.compiledCharCodeToGlyphId[charCode] = glyphId;
                        return fn;
                    }
                    compileGlyph(code, glyphId) {
                        if (!code || code.length === 0 || code[0] === 14) return NOOP;
                        let fontMatrix = this.fontMatrix;
                        if (this.isCFFCIDFont) {
                            const fdIndex = this.fdSelect.getFDIndex(glyphId);
                            if (fdIndex >= 0 && fdIndex < this.fdArray.length) {
                                const fontDict = this.fdArray[fdIndex];
                                fontMatrix = fontDict.getByName("FontMatrix") || _util.FONT_IDENTITY_MATRIX;
                            } else (0, _util.warn)("Invalid fd index for glyph index.");
                        }
                        const cmds = [
                            {
                                cmd: "save"
                            },
                            {
                                cmd: "transform",
                                args: fontMatrix.slice()
                            },
                            {
                                cmd: "scale",
                                args: [
                                    "size",
                                    "-size"
                                ]
                            }
                        ];
                        this.compileGlyphImpl(code, cmds, glyphId);
                        cmds.push({
                            cmd: "restore"
                        });
                        return cmds;
                    }
                    compileGlyphImpl() {
                        (0, _util.unreachable)("Children classes should implement this.");
                    }
                    hasBuiltPath(unicode) {
                        const { charCode: charCode , glyphId: glyphId  } = lookupCmap(this.cmap, unicode);
                        return this.compiledGlyphs[glyphId] !== undefined && this.compiledCharCodeToGlyphId[charCode] !== undefined;
                    }
                }
                class TrueTypeCompiled extends CompiledFont {
                    constructor(glyphs, cmap, fontMatrix){
                        super(fontMatrix || [
                            0.000488,
                            0,
                            0,
                            0.000488,
                            0,
                            0
                        ]);
                        this.glyphs = glyphs;
                        this.cmap = cmap;
                    }
                    compileGlyphImpl(code, cmds) {
                        compileGlyf(code, cmds, this);
                    }
                }
                class Type2Compiled extends CompiledFont {
                    constructor(cffInfo, cmap, fontMatrix, glyphNameMap){
                        super(fontMatrix || [
                            0.001,
                            0,
                            0,
                            0.001,
                            0,
                            0
                        ]);
                        this.glyphs = cffInfo.glyphs;
                        this.gsubrs = cffInfo.gsubrs || [];
                        this.subrs = cffInfo.subrs || [];
                        this.cmap = cmap;
                        this.glyphNameMap = glyphNameMap || (0, _glyphlist.getGlyphsUnicode)();
                        this.gsubrsBias = getSubroutineBias(this.gsubrs);
                        this.subrsBias = getSubroutineBias(this.subrs);
                        this.isCFFCIDFont = cffInfo.isCFFCIDFont;
                        this.fdSelect = cffInfo.fdSelect;
                        this.fdArray = cffInfo.fdArray;
                    }
                    compileGlyphImpl(code, cmds, glyphId) {
                        compileCharString(code, cmds, this, glyphId);
                    }
                }
                class FontRendererFactory {
                    static create(font1, seacAnalysisEnabled) {
                        const data = new Uint8Array(font1.data);
                        let cmap, glyf, loca, cff, indexToLocFormat, unitsPerEm;
                        const numTables = getUshort(data, 4);
                        for(let i = 0, p = 12; i < numTables; i++, p += 16){
                            const tag = (0, _util.bytesToString)(data.subarray(p, p + 4));
                            const offset = getLong(data, p + 8);
                            const length = getLong(data, p + 12);
                            switch(tag){
                                case "cmap":
                                    cmap = parseCmap(data, offset, offset + length);
                                    break;
                                case "glyf":
                                    glyf = data.subarray(offset, offset + length);
                                    break;
                                case "loca":
                                    loca = data.subarray(offset, offset + length);
                                    break;
                                case "head":
                                    unitsPerEm = getUshort(data, offset + 18);
                                    indexToLocFormat = getUshort(data, offset + 50);
                                    break;
                                case "CFF ":
                                    cff = parseCff(data, offset, offset + length, seacAnalysisEnabled);
                                    break;
                            }
                        }
                        if (glyf) {
                            const fontMatrix = !unitsPerEm ? font1.fontMatrix : [
                                1 / unitsPerEm,
                                0,
                                0,
                                1 / unitsPerEm,
                                0,
                                0
                            ];
                            return new TrueTypeCompiled(parseGlyfTable(glyf, loca, indexToLocFormat), cmap, fontMatrix);
                        }
                        return new Type2Compiled(cff, cmap, font1.fontMatrix, font1.glyphNameMap);
                    }
                }
                exports.FontRendererFactory = FontRendererFactory;
            /***/ },
            /* 45 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlyfTable = void 0;
                const ON_CURVE_POINT = 1;
                const X_SHORT_VECTOR = 2;
                const Y_SHORT_VECTOR = 4;
                const REPEAT_FLAG = 8;
                const X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR = 16;
                const Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR = 32;
                const OVERLAP_SIMPLE = 64;
                const ARG_1_AND_2_ARE_WORDS = 1;
                const ARGS_ARE_XY_VALUES = 2;
                const WE_HAVE_A_SCALE = 8;
                const MORE_COMPONENTS = 32;
                const WE_HAVE_AN_X_AND_Y_SCALE = 64;
                const WE_HAVE_A_TWO_BY_TWO = 128;
                const WE_HAVE_INSTRUCTIONS = 256;
                class GlyfTable {
                    constructor({ glyfTable: glyfTable , isGlyphLocationsLong: isGlyphLocationsLong , locaTable: locaTable , numGlyphs: numGlyphs  }){
                        this.glyphs = [];
                        const loca = new DataView(locaTable.buffer, locaTable.byteOffset, locaTable.byteLength);
                        const glyf = new DataView(glyfTable.buffer, glyfTable.byteOffset, glyfTable.byteLength);
                        const offsetSize = isGlyphLocationsLong ? 4 : 2;
                        let prev = isGlyphLocationsLong ? loca.getUint32(0) : 2 * loca.getUint16(0);
                        let pos = 0;
                        for(let i = 0; i < numGlyphs; i++){
                            pos += offsetSize;
                            const next = isGlyphLocationsLong ? loca.getUint32(pos) : 2 * loca.getUint16(pos);
                            if (next === prev) {
                                this.glyphs.push(new Glyph({}));
                                continue;
                            }
                            const glyph = Glyph.parse(prev, glyf);
                            this.glyphs.push(glyph);
                            prev = next;
                        }
                    }
                    getSize() {
                        return this.glyphs.reduce((a, g)=>{
                            const size = g.getSize();
                            return a + (size + 3 & -4);
                        }, 0);
                    }
                    write() {
                        const totalSize = this.getSize();
                        const glyfTable = new DataView(new ArrayBuffer(totalSize));
                        const isLocationLong = totalSize > 0x1fffe;
                        const offsetSize = isLocationLong ? 4 : 2;
                        const locaTable = new DataView(new ArrayBuffer((this.glyphs.length + 1) * offsetSize));
                        if (isLocationLong) locaTable.setUint32(0, 0);
                        else locaTable.setUint16(0, 0);
                        let pos = 0;
                        let locaIndex = 0;
                        for (const glyph of this.glyphs){
                            pos += glyph.write(pos, glyfTable);
                            pos = pos + 3 & -4;
                            locaIndex += offsetSize;
                            if (isLocationLong) locaTable.setUint32(locaIndex, pos);
                            else locaTable.setUint16(locaIndex, pos >> 1);
                        }
                        return {
                            isLocationLong: isLocationLong,
                            loca: new Uint8Array(locaTable.buffer),
                            glyf: new Uint8Array(glyfTable.buffer)
                        };
                    }
                    scale(factors) {
                        for(let i = 0, ii = this.glyphs.length; i < ii; i++)this.glyphs[i].scale(factors[i]);
                    }
                }
                exports.GlyfTable = GlyfTable;
                class Glyph {
                    constructor({ header: header = null , simple: simple = null , composites: composites = null  }){
                        this.header = header;
                        this.simple = simple;
                        this.composites = composites;
                    }
                    static parse(pos, glyf) {
                        const [read, header] = GlyphHeader.parse(pos, glyf);
                        pos += read;
                        if (header.numberOfContours < 0) {
                            const composites = [];
                            while(true){
                                const [n, composite] = CompositeGlyph.parse(pos, glyf);
                                pos += n;
                                composites.push(composite);
                                if (!(composite.flags & MORE_COMPONENTS)) break;
                            }
                            return new Glyph({
                                header: header,
                                composites: composites
                            });
                        }
                        const simple = SimpleGlyph.parse(pos, glyf, header.numberOfContours);
                        return new Glyph({
                            header: header,
                            simple: simple
                        });
                    }
                    getSize() {
                        if (!this.header) return 0;
                        const size = this.simple ? this.simple.getSize() : this.composites.reduce((a, c)=>a + c.getSize(), 0);
                        return this.header.getSize() + size;
                    }
                    write(pos, buf) {
                        if (!this.header) return 0;
                        const spos = pos;
                        pos += this.header.write(pos, buf);
                        if (this.simple) pos += this.simple.write(pos, buf);
                        else for (const composite of this.composites)pos += composite.write(pos, buf);
                        return pos - spos;
                    }
                    scale(factor) {
                        if (!this.header) return;
                        const xMiddle = (this.header.xMin + this.header.xMax) / 2;
                        this.header.scale(xMiddle, factor);
                        if (this.simple) this.simple.scale(xMiddle, factor);
                        else for (const composite of this.composites)composite.scale(xMiddle, factor);
                    }
                }
                class GlyphHeader {
                    constructor({ numberOfContours: numberOfContours , xMin: xMin , yMin: yMin , xMax: xMax , yMax: yMax  }){
                        this.numberOfContours = numberOfContours;
                        this.xMin = xMin;
                        this.yMin = yMin;
                        this.xMax = xMax;
                        this.yMax = yMax;
                    }
                    static parse(pos, glyf) {
                        return [
                            10,
                            new GlyphHeader({
                                numberOfContours: glyf.getInt16(pos),
                                xMin: glyf.getInt16(pos + 2),
                                yMin: glyf.getInt16(pos + 4),
                                xMax: glyf.getInt16(pos + 6),
                                yMax: glyf.getInt16(pos + 8)
                            })
                        ];
                    }
                    getSize() {
                        return 10;
                    }
                    write(pos, buf) {
                        buf.setInt16(pos, this.numberOfContours);
                        buf.setInt16(pos + 2, this.xMin);
                        buf.setInt16(pos + 4, this.yMin);
                        buf.setInt16(pos + 6, this.xMax);
                        buf.setInt16(pos + 8, this.yMax);
                        return 10;
                    }
                    scale(x, factor) {
                        this.xMin = Math.round(x + (this.xMin - x) * factor);
                        this.xMax = Math.round(x + (this.xMax - x) * factor);
                    }
                }
                class Contour {
                    constructor({ flags: flags , xCoordinates: xCoordinates , yCoordinates: yCoordinates  }){
                        this.xCoordinates = xCoordinates;
                        this.yCoordinates = yCoordinates;
                        this.flags = flags;
                    }
                }
                class SimpleGlyph {
                    constructor({ contours: contours , instructions: instructions  }){
                        this.contours = contours;
                        this.instructions = instructions;
                    }
                    static parse(pos, glyf, numberOfContours) {
                        const endPtsOfContours = [];
                        for(let i = 0; i < numberOfContours; i++){
                            const endPt = glyf.getUint16(pos);
                            pos += 2;
                            endPtsOfContours.push(endPt);
                        }
                        const numberOfPt = endPtsOfContours[numberOfContours - 1] + 1;
                        const instructionLength = glyf.getUint16(pos);
                        pos += 2;
                        const instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                        pos += instructionLength;
                        const flags = [];
                        for(let i = 0; i < numberOfPt; pos++, i++){
                            let flag = glyf.getUint8(pos);
                            flags.push(flag);
                            if (flag & REPEAT_FLAG) {
                                const count = glyf.getUint8(++pos);
                                flag ^= REPEAT_FLAG;
                                for(let m = 0; m < count; m++)flags.push(flag);
                                i += count;
                            }
                        }
                        const allXCoordinates = [];
                        let xCoordinates = [];
                        let yCoordinates = [];
                        let pointFlags = [];
                        const contours = [];
                        let endPtsOfContoursIndex = 0;
                        let lastCoordinate = 0;
                        for(let i = 0; i < numberOfPt; i++){
                            const flag = flags[i];
                            if (flag & X_SHORT_VECTOR) {
                                const x = glyf.getUint8(pos++);
                                lastCoordinate += flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR ? x : -x;
                                xCoordinates.push(lastCoordinate);
                            } else if (flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR) xCoordinates.push(lastCoordinate);
                            else {
                                lastCoordinate += glyf.getInt16(pos);
                                pos += 2;
                                xCoordinates.push(lastCoordinate);
                            }
                            if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                                endPtsOfContoursIndex++;
                                allXCoordinates.push(xCoordinates);
                                xCoordinates = [];
                            }
                        }
                        lastCoordinate = 0;
                        endPtsOfContoursIndex = 0;
                        for(let i = 0; i < numberOfPt; i++){
                            const flag = flags[i];
                            if (flag & Y_SHORT_VECTOR) {
                                const y = glyf.getUint8(pos++);
                                lastCoordinate += flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR ? y : -y;
                                yCoordinates.push(lastCoordinate);
                            } else if (flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR) yCoordinates.push(lastCoordinate);
                            else {
                                lastCoordinate += glyf.getInt16(pos);
                                pos += 2;
                                yCoordinates.push(lastCoordinate);
                            }
                            pointFlags.push(flag & ON_CURVE_POINT | flag & OVERLAP_SIMPLE);
                            if (endPtsOfContours[endPtsOfContoursIndex] === i) {
                                xCoordinates = allXCoordinates[endPtsOfContoursIndex];
                                endPtsOfContoursIndex++;
                                contours.push(new Contour({
                                    flags: pointFlags,
                                    xCoordinates: xCoordinates,
                                    yCoordinates: yCoordinates
                                }));
                                yCoordinates = [];
                                pointFlags = [];
                            }
                        }
                        return new SimpleGlyph({
                            contours: contours,
                            instructions: instructions
                        });
                    }
                    getSize() {
                        let size = this.contours.length * 2 + 2 + this.instructions.length;
                        let lastX = 0;
                        let lastY = 0;
                        for (const contour of this.contours){
                            size += contour.flags.length;
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++){
                                const x = contour.xCoordinates[i];
                                const y = contour.yCoordinates[i];
                                let abs = Math.abs(x - lastX);
                                if (abs > 255) size += 2;
                                else if (abs > 0) size += 1;
                                lastX = x;
                                abs = Math.abs(y - lastY);
                                if (abs > 255) size += 2;
                                else if (abs > 0) size += 1;
                                lastY = y;
                            }
                        }
                        return size;
                    }
                    write(pos, buf) {
                        const spos = pos;
                        const xCoordinates = [];
                        const yCoordinates = [];
                        const flags = [];
                        let lastX = 0;
                        let lastY = 0;
                        for (const contour of this.contours){
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++){
                                let flag = contour.flags[i];
                                const x = contour.xCoordinates[i];
                                let delta = x - lastX;
                                if (delta === 0) {
                                    flag |= X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR;
                                    xCoordinates.push(0);
                                } else {
                                    const abs = Math.abs(delta);
                                    if (abs <= 255) {
                                        flag |= delta >= 0 ? X_SHORT_VECTOR | X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR : X_SHORT_VECTOR;
                                        xCoordinates.push(abs);
                                    } else xCoordinates.push(delta);
                                }
                                lastX = x;
                                const y = contour.yCoordinates[i];
                                delta = y - lastY;
                                if (delta === 0) {
                                    flag |= Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR;
                                    yCoordinates.push(0);
                                } else {
                                    const abs = Math.abs(delta);
                                    if (abs <= 255) {
                                        flag |= delta >= 0 ? Y_SHORT_VECTOR | Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR : Y_SHORT_VECTOR;
                                        yCoordinates.push(abs);
                                    } else yCoordinates.push(delta);
                                }
                                lastY = y;
                                flags.push(flag);
                            }
                            buf.setUint16(pos, xCoordinates.length - 1);
                            pos += 2;
                        }
                        buf.setUint16(pos, this.instructions.length);
                        pos += 2;
                        if (this.instructions.length) {
                            new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                            pos += this.instructions.length;
                        }
                        for (const flag of flags)buf.setUint8(pos++, flag);
                        for(let i = 0, ii = xCoordinates.length; i < ii; i++){
                            const x = xCoordinates[i];
                            const flag = flags[i];
                            if (flag & X_SHORT_VECTOR) buf.setUint8(pos++, x);
                            else if (!(flag & X_IS_SAME_OR_POSITIVE_X_SHORT_VECTOR)) {
                                buf.setInt16(pos, x);
                                pos += 2;
                            }
                        }
                        for(let i = 0, ii = yCoordinates.length; i < ii; i++){
                            const y = yCoordinates[i];
                            const flag = flags[i];
                            if (flag & Y_SHORT_VECTOR) buf.setUint8(pos++, y);
                            else if (!(flag & Y_IS_SAME_OR_POSITIVE_Y_SHORT_VECTOR)) {
                                buf.setInt16(pos, y);
                                pos += 2;
                            }
                        }
                        return pos - spos;
                    }
                    scale(x, factor) {
                        for (const contour of this.contours){
                            if (contour.xCoordinates.length === 0) continue;
                            for(let i = 0, ii = contour.xCoordinates.length; i < ii; i++)contour.xCoordinates[i] = Math.round(x + (contour.xCoordinates[i] - x) * factor);
                        }
                    }
                }
                class CompositeGlyph {
                    constructor({ flags: flags , glyphIndex: glyphIndex , argument1: argument1 , argument2: argument2 , transf: transf , instructions: instructions  }){
                        this.flags = flags;
                        this.glyphIndex = glyphIndex;
                        this.argument1 = argument1;
                        this.argument2 = argument2;
                        this.transf = transf;
                        this.instructions = instructions;
                    }
                    static parse(pos, glyf) {
                        const spos = pos;
                        const transf = [];
                        let flags = glyf.getUint16(pos);
                        const glyphIndex = glyf.getUint16(pos + 2);
                        pos += 4;
                        let argument1, argument2;
                        if (flags & ARG_1_AND_2_ARE_WORDS) {
                            if (flags & ARGS_ARE_XY_VALUES) {
                                argument1 = glyf.getInt16(pos);
                                argument2 = glyf.getInt16(pos + 2);
                            } else {
                                argument1 = glyf.getUint16(pos);
                                argument2 = glyf.getUint16(pos + 2);
                            }
                            pos += 4;
                            flags ^= ARG_1_AND_2_ARE_WORDS;
                        } else {
                            argument1 = glyf.getUint8(pos);
                            argument2 = glyf.getUint8(pos + 1);
                            if (flags & ARGS_ARE_XY_VALUES) {
                                const abs1 = argument1 & 0x7f;
                                argument1 = argument1 & 0x80 ? -abs1 : abs1;
                                const abs2 = argument2 & 0x7f;
                                argument2 = argument2 & 0x80 ? -abs2 : abs2;
                            }
                            pos += 2;
                        }
                        if (flags & WE_HAVE_A_SCALE) {
                            transf.push(glyf.getUint16(pos));
                            pos += 2;
                        } else if (flags & WE_HAVE_AN_X_AND_Y_SCALE) {
                            transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2));
                            pos += 4;
                        } else if (flags & WE_HAVE_A_TWO_BY_TWO) {
                            transf.push(glyf.getUint16(pos), glyf.getUint16(pos + 2), glyf.getUint16(pos + 4), glyf.getUint16(pos + 6));
                            pos += 8;
                        }
                        let instructions = null;
                        if (flags & WE_HAVE_INSTRUCTIONS) {
                            const instructionLength = glyf.getUint16(pos);
                            pos += 2;
                            instructions = new Uint8Array(glyf).slice(pos, pos + instructionLength);
                            pos += instructionLength;
                        }
                        return [
                            pos - spos,
                            new CompositeGlyph({
                                flags: flags,
                                glyphIndex: glyphIndex,
                                argument1: argument1,
                                argument2: argument2,
                                transf: transf,
                                instructions: instructions
                            })
                        ];
                    }
                    getSize() {
                        let size = 4 + this.transf.length * 2;
                        if (this.flags & WE_HAVE_INSTRUCTIONS) size += 2 + this.instructions.length;
                        size += 2;
                        if (this.flags & 2) {
                            if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) size += 2;
                        } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) size += 2;
                        return size;
                    }
                    write(pos, buf) {
                        const spos = pos;
                        if (this.flags & ARGS_ARE_XY_VALUES) {
                            if (!(this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127)) this.flags |= ARG_1_AND_2_ARE_WORDS;
                        } else if (!(this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255)) this.flags |= ARG_1_AND_2_ARE_WORDS;
                        buf.setUint16(pos, this.flags);
                        buf.setUint16(pos + 2, this.glyphIndex);
                        pos += 4;
                        if (this.flags & ARG_1_AND_2_ARE_WORDS) {
                            if (this.flags & ARGS_ARE_XY_VALUES) {
                                buf.setInt16(pos, this.argument1);
                                buf.setInt16(pos + 2, this.argument2);
                            } else {
                                buf.setUint16(pos, this.argument1);
                                buf.setUint16(pos + 2, this.argument2);
                            }
                            pos += 4;
                        } else {
                            buf.setUint8(pos, this.argument1);
                            buf.setUint8(pos + 1, this.argument2);
                            pos += 2;
                        }
                        if (this.flags & WE_HAVE_INSTRUCTIONS) {
                            buf.setUint16(pos, this.instructions.length);
                            pos += 2;
                            if (this.instructions.length) {
                                new Uint8Array(buf.buffer, 0, buf.buffer.byteLength).set(this.instructions, pos);
                                pos += this.instructions.length;
                            }
                        }
                        return pos - spos;
                    }
                    scale(x, factor) {}
                }
            /***/ },
            /* 46 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OpenTypeFileBuilder = void 0;
                var _core_utils = __w_pdfjs_require__(9);
                var _util = __w_pdfjs_require__(2);
                function writeInt16(dest, offset, num) {
                    dest[offset] = num >> 8 & 0xff;
                    dest[offset + 1] = num & 0xff;
                }
                function writeInt32(dest, offset, num) {
                    dest[offset] = num >> 24 & 0xff;
                    dest[offset + 1] = num >> 16 & 0xff;
                    dest[offset + 2] = num >> 8 & 0xff;
                    dest[offset + 3] = num & 0xff;
                }
                function writeData(dest, offset, data) {
                    if (data instanceof Uint8Array) dest.set(data, offset);
                    else if (typeof data === "string") for(let i = 0, ii = data.length; i < ii; i++)dest[offset++] = data.charCodeAt(i) & 0xff;
                    else for(let i = 0, ii = data.length; i < ii; i++)dest[offset++] = data[i] & 0xff;
                }
                const OTF_HEADER_SIZE = 12;
                const OTF_TABLE_ENTRY_SIZE = 16;
                class OpenTypeFileBuilder {
                    constructor(sfnt){
                        this.sfnt = sfnt;
                        this.tables = Object.create(null);
                    }
                    static getSearchParams(entriesCount, entrySize) {
                        let maxPower2 = 1, log2 = 0;
                        while((maxPower2 ^ entriesCount) > maxPower2){
                            maxPower2 <<= 1;
                            log2++;
                        }
                        const searchRange = maxPower2 * entrySize;
                        return {
                            range: searchRange,
                            entry: log2,
                            rangeShift: entrySize * entriesCount - searchRange
                        };
                    }
                    toArray() {
                        let sfnt = this.sfnt;
                        const tables = this.tables;
                        const tablesNames = Object.keys(tables);
                        tablesNames.sort();
                        const numTables = tablesNames.length;
                        let i, j, jj, table, tableName;
                        let offset = OTF_HEADER_SIZE + numTables * OTF_TABLE_ENTRY_SIZE;
                        const tableOffsets = [
                            offset
                        ];
                        for(i = 0; i < numTables; i++){
                            table = tables[tablesNames[i]];
                            const paddedLength = (table.length + 3 & -4) >>> 0;
                            offset += paddedLength;
                            tableOffsets.push(offset);
                        }
                        const file = new Uint8Array(offset);
                        for(i = 0; i < numTables; i++){
                            table = tables[tablesNames[i]];
                            writeData(file, tableOffsets[i], table);
                        }
                        if (sfnt === "true") sfnt = (0, _util.string32)(0x00010000);
                        file[0] = sfnt.charCodeAt(0) & 0xff;
                        file[1] = sfnt.charCodeAt(1) & 0xff;
                        file[2] = sfnt.charCodeAt(2) & 0xff;
                        file[3] = sfnt.charCodeAt(3) & 0xff;
                        writeInt16(file, 4, numTables);
                        const searchParams = OpenTypeFileBuilder.getSearchParams(numTables, 16);
                        writeInt16(file, 6, searchParams.range);
                        writeInt16(file, 8, searchParams.entry);
                        writeInt16(file, 10, searchParams.rangeShift);
                        offset = OTF_HEADER_SIZE;
                        for(i = 0; i < numTables; i++){
                            tableName = tablesNames[i];
                            file[offset] = tableName.charCodeAt(0) & 0xff;
                            file[offset + 1] = tableName.charCodeAt(1) & 0xff;
                            file[offset + 2] = tableName.charCodeAt(2) & 0xff;
                            file[offset + 3] = tableName.charCodeAt(3) & 0xff;
                            let checksum = 0;
                            for(j = tableOffsets[i], jj = tableOffsets[i + 1]; j < jj; j += 4){
                                const quad = (0, _core_utils.readUint32)(file, j);
                                checksum = checksum + quad >>> 0;
                            }
                            writeInt32(file, offset + 4, checksum);
                            writeInt32(file, offset + 8, tableOffsets[i]);
                            writeInt32(file, offset + 12, tables[tableName].length);
                            offset += OTF_TABLE_ENTRY_SIZE;
                        }
                        return file;
                    }
                    addTable(tag, data) {
                        if (tag in this.tables) throw new Error("Table " + tag + " already exists");
                        this.tables[tag] = data;
                    }
                }
                exports.OpenTypeFileBuilder = OpenTypeFileBuilder;
            /***/ },
            /* 47 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Type1Font = void 0;
                var _cff_parser = __w_pdfjs_require__(35);
                var _fonts_utils = __w_pdfjs_require__(38);
                var _core_utils = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(10);
                var _type1_parser = __w_pdfjs_require__(48);
                var _util = __w_pdfjs_require__(2);
                function findBlock(streamBytes, signature, startIndex) {
                    const streamBytesLength = streamBytes.length;
                    const signatureLength = signature.length;
                    const scanLength = streamBytesLength - signatureLength;
                    let i = startIndex, found = false;
                    while(i < scanLength){
                        let j = 0;
                        while(j < signatureLength && streamBytes[i + j] === signature[j])j++;
                        if (j >= signatureLength) {
                            i += j;
                            while(i < streamBytesLength && (0, _core_utils.isWhiteSpace)(streamBytes[i]))i++;
                            found = true;
                            break;
                        }
                        i++;
                    }
                    return {
                        found: found,
                        length: i
                    };
                }
                function getHeaderBlock(stream, suggestedLength) {
                    const EEXEC_SIGNATURE = [
                        0x65,
                        0x65,
                        0x78,
                        0x65,
                        0x63
                    ];
                    const streamStartPos = stream.pos;
                    let headerBytes, headerBytesLength, block;
                    try {
                        headerBytes = stream.getBytes(suggestedLength);
                        headerBytesLength = headerBytes.length;
                    } catch (ex) {}
                    if (headerBytesLength === suggestedLength) {
                        block = findBlock(headerBytes, EEXEC_SIGNATURE, suggestedLength - 2 * EEXEC_SIGNATURE.length);
                        if (block.found && block.length === suggestedLength) return {
                            stream: new _stream.Stream(headerBytes),
                            length: suggestedLength
                        };
                    }
                    (0, _util.warn)('Invalid "Length1" property in Type1 font -- trying to recover.');
                    stream.pos = streamStartPos;
                    const SCAN_BLOCK_LENGTH = 2048;
                    let actualLength;
                    while(true){
                        const scanBytes = stream.peekBytes(SCAN_BLOCK_LENGTH);
                        block = findBlock(scanBytes, EEXEC_SIGNATURE, 0);
                        if (block.length === 0) break;
                        stream.pos += block.length;
                        if (block.found) {
                            actualLength = stream.pos - streamStartPos;
                            break;
                        }
                    }
                    stream.pos = streamStartPos;
                    if (actualLength) return {
                        stream: new _stream.Stream(stream.getBytes(actualLength)),
                        length: actualLength
                    };
                    (0, _util.warn)('Unable to recover "Length1" property in Type1 font -- using as is.');
                    return {
                        stream: new _stream.Stream(stream.getBytes(suggestedLength)),
                        length: suggestedLength
                    };
                }
                function getEexecBlock(stream, suggestedLength) {
                    const eexecBytes = stream.getBytes();
                    return {
                        stream: new _stream.Stream(eexecBytes),
                        length: eexecBytes.length
                    };
                }
                class Type1Font {
                    constructor(name, file, properties){
                        const PFB_HEADER_SIZE = 6;
                        let headerBlockLength = properties.length1;
                        let eexecBlockLength = properties.length2;
                        let pfbHeader = file.peekBytes(PFB_HEADER_SIZE);
                        const pfbHeaderPresent = pfbHeader[0] === 0x80 && pfbHeader[1] === 0x01;
                        if (pfbHeaderPresent) {
                            file.skip(PFB_HEADER_SIZE);
                            headerBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                        }
                        const headerBlock = getHeaderBlock(file, headerBlockLength);
                        const headerBlockParser = new _type1_parser.Type1Parser(headerBlock.stream, false, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        headerBlockParser.extractFontHeader(properties);
                        if (pfbHeaderPresent) {
                            pfbHeader = file.getBytes(PFB_HEADER_SIZE);
                            eexecBlockLength = pfbHeader[5] << 24 | pfbHeader[4] << 16 | pfbHeader[3] << 8 | pfbHeader[2];
                        }
                        const eexecBlock = getEexecBlock(file, eexecBlockLength);
                        const eexecBlockParser = new _type1_parser.Type1Parser(eexecBlock.stream, true, _fonts_utils.SEAC_ANALYSIS_ENABLED);
                        const data = eexecBlockParser.extractFontProgram(properties);
                        for(const key in data.properties)properties[key] = data.properties[key];
                        const charstrings = data.charstrings;
                        const type2Charstrings = this.getType2Charstrings(charstrings);
                        const subrs = this.getType2Subrs(data.subrs);
                        this.charstrings = charstrings;
                        this.data = this.wrap(name, type2Charstrings, this.charstrings, subrs, properties);
                        this.seacs = this.getSeacs(data.charstrings);
                    }
                    get numGlyphs() {
                        return this.charstrings.length + 1;
                    }
                    getCharset() {
                        const charset = [
                            ".notdef"
                        ];
                        const charstrings = this.charstrings;
                        for(let glyphId = 0; glyphId < charstrings.length; glyphId++)charset.push(charstrings[glyphId].glyphName);
                        return charset;
                    }
                    getGlyphMapping(properties) {
                        const charstrings = this.charstrings;
                        if (properties.composite) {
                            const charCodeToGlyphId = Object.create(null);
                            for(let glyphId = 0, charstringsLen = charstrings.length; glyphId < charstringsLen; glyphId++){
                                const charCode = properties.cMap.charCodeOf(glyphId);
                                charCodeToGlyphId[charCode] = glyphId + 1;
                            }
                            return charCodeToGlyphId;
                        }
                        const glyphNames = [
                            ".notdef"
                        ];
                        let builtInEncoding, glyphId;
                        for(glyphId = 0; glyphId < charstrings.length; glyphId++)glyphNames.push(charstrings[glyphId].glyphName);
                        const encoding = properties.builtInEncoding;
                        if (encoding) {
                            builtInEncoding = Object.create(null);
                            for(const charCode in encoding){
                                glyphId = glyphNames.indexOf(encoding[charCode]);
                                if (glyphId >= 0) builtInEncoding[charCode] = glyphId;
                            }
                        }
                        return (0, _fonts_utils.type1FontGlyphMapping)(properties, builtInEncoding, glyphNames);
                    }
                    hasGlyphId(id) {
                        if (id < 0 || id >= this.numGlyphs) return false;
                        if (id === 0) return true;
                        const glyph = this.charstrings[id - 1];
                        return glyph.charstring.length > 0;
                    }
                    getSeacs(charstrings) {
                        const seacMap = [];
                        for(let i = 0, ii = charstrings.length; i < ii; i++){
                            const charstring = charstrings[i];
                            if (charstring.seac) seacMap[i + 1] = charstring.seac;
                        }
                        return seacMap;
                    }
                    getType2Charstrings(type1Charstrings) {
                        const type2Charstrings = [];
                        for(let i = 0, ii = type1Charstrings.length; i < ii; i++)type2Charstrings.push(type1Charstrings[i].charstring);
                        return type2Charstrings;
                    }
                    getType2Subrs(type1Subrs) {
                        let bias = 0;
                        const count = type1Subrs.length;
                        if (count < 1133) bias = 107;
                        else if (count < 33769) bias = 1131;
                        else bias = 32768;
                        const type2Subrs = [];
                        let i;
                        for(i = 0; i < bias; i++)type2Subrs.push([
                            0x0b
                        ]);
                        for(i = 0; i < count; i++)type2Subrs.push(type1Subrs[i]);
                        return type2Subrs;
                    }
                    wrap(name, glyphs, charstrings, subrs, properties) {
                        const cff = new _cff_parser.CFF();
                        cff.header = new _cff_parser.CFFHeader(1, 0, 4, 4);
                        cff.names = [
                            name
                        ];
                        const topDict = new _cff_parser.CFFTopDict();
                        topDict.setByName("version", 391);
                        topDict.setByName("Notice", 392);
                        topDict.setByName("FullName", 393);
                        topDict.setByName("FamilyName", 394);
                        topDict.setByName("Weight", 395);
                        topDict.setByName("Encoding", null);
                        topDict.setByName("FontMatrix", properties.fontMatrix);
                        topDict.setByName("FontBBox", properties.bbox);
                        topDict.setByName("charset", null);
                        topDict.setByName("CharStrings", null);
                        topDict.setByName("Private", null);
                        cff.topDict = topDict;
                        const strings = new _cff_parser.CFFStrings();
                        strings.add("Version 0.11");
                        strings.add("See original notice");
                        strings.add(name);
                        strings.add(name);
                        strings.add("Medium");
                        cff.strings = strings;
                        cff.globalSubrIndex = new _cff_parser.CFFIndex();
                        const count = glyphs.length;
                        const charsetArray = [
                            ".notdef"
                        ];
                        let i, ii;
                        for(i = 0; i < count; i++){
                            const glyphName = charstrings[i].glyphName;
                            const index = _cff_parser.CFFStandardStrings.indexOf(glyphName);
                            if (index === -1) strings.add(glyphName);
                            charsetArray.push(glyphName);
                        }
                        cff.charset = new _cff_parser.CFFCharset(false, 0, charsetArray);
                        const charStringsIndex = new _cff_parser.CFFIndex();
                        charStringsIndex.add([
                            0x8b,
                            0x0e
                        ]);
                        for(i = 0; i < count; i++)charStringsIndex.add(glyphs[i]);
                        cff.charStrings = charStringsIndex;
                        const privateDict = new _cff_parser.CFFPrivateDict();
                        privateDict.setByName("Subrs", null);
                        const fields = [
                            "BlueValues",
                            "OtherBlues",
                            "FamilyBlues",
                            "FamilyOtherBlues",
                            "StemSnapH",
                            "StemSnapV",
                            "BlueShift",
                            "BlueFuzz",
                            "BlueScale",
                            "LanguageGroup",
                            "ExpansionFactor",
                            "ForceBold",
                            "StdHW",
                            "StdVW"
                        ];
                        for(i = 0, ii = fields.length; i < ii; i++){
                            const field = fields[i];
                            if (!(field in properties.privateData)) continue;
                            const value = properties.privateData[field];
                            if (Array.isArray(value)) for(let j = value.length - 1; j > 0; j--)value[j] -= value[j - 1];
                            privateDict.setByName(field, value);
                        }
                        cff.topDict.privateDict = privateDict;
                        const subrIndex = new _cff_parser.CFFIndex();
                        for(i = 0, ii = subrs.length; i < ii; i++)subrIndex.add(subrs[i]);
                        privateDict.subrsIndex = subrIndex;
                        const compiler = new _cff_parser.CFFCompiler(cff);
                        return compiler.compile();
                    }
                }
                exports.Type1Font = Type1Font;
            /***/ },
            /* 48 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Type1Parser = void 0;
                var _encodings = __w_pdfjs_require__(37);
                var _core_utils = __w_pdfjs_require__(9);
                var _stream = __w_pdfjs_require__(10);
                var _util = __w_pdfjs_require__(2);
                const HINTING_ENABLED = false;
                const Type1CharString = function Type1CharStringClosure() {
                    const COMMAND_MAP = {
                        hstem: [
                            1
                        ],
                        vstem: [
                            3
                        ],
                        vmoveto: [
                            4
                        ],
                        rlineto: [
                            5
                        ],
                        hlineto: [
                            6
                        ],
                        vlineto: [
                            7
                        ],
                        rrcurveto: [
                            8
                        ],
                        callsubr: [
                            10
                        ],
                        flex: [
                            12,
                            35
                        ],
                        drop: [
                            12,
                            18
                        ],
                        endchar: [
                            14
                        ],
                        rmoveto: [
                            21
                        ],
                        hmoveto: [
                            22
                        ],
                        vhcurveto: [
                            30
                        ],
                        hvcurveto: [
                            31
                        ]
                    };
                    class Type1CharString {
                        constructor(){
                            this.width = 0;
                            this.lsb = 0;
                            this.flexing = false;
                            this.output = [];
                            this.stack = [];
                        }
                        convert(encoded, subrs, seacAnalysisEnabled) {
                            const count = encoded.length;
                            let error = false;
                            let wx, sbx, subrNumber;
                            for(let i = 0; i < count; i++){
                                let value = encoded[i];
                                if (value < 32) {
                                    if (value === 12) value = (value << 8) + encoded[++i];
                                    switch(value){
                                        case 1:
                                            if (!HINTING_ENABLED) {
                                                this.stack = [];
                                                break;
                                            }
                                            error = this.executeCommand(2, COMMAND_MAP.hstem);
                                            break;
                                        case 3:
                                            if (!HINTING_ENABLED) {
                                                this.stack = [];
                                                break;
                                            }
                                            error = this.executeCommand(2, COMMAND_MAP.vstem);
                                            break;
                                        case 4:
                                            if (this.flexing) {
                                                if (this.stack.length < 1) {
                                                    error = true;
                                                    break;
                                                }
                                                const dy = this.stack.pop();
                                                this.stack.push(0, dy);
                                                break;
                                            }
                                            error = this.executeCommand(1, COMMAND_MAP.vmoveto);
                                            break;
                                        case 5:
                                            error = this.executeCommand(2, COMMAND_MAP.rlineto);
                                            break;
                                        case 6:
                                            error = this.executeCommand(1, COMMAND_MAP.hlineto);
                                            break;
                                        case 7:
                                            error = this.executeCommand(1, COMMAND_MAP.vlineto);
                                            break;
                                        case 8:
                                            error = this.executeCommand(6, COMMAND_MAP.rrcurveto);
                                            break;
                                        case 9:
                                            this.stack = [];
                                            break;
                                        case 10:
                                            if (this.stack.length < 1) {
                                                error = true;
                                                break;
                                            }
                                            subrNumber = this.stack.pop();
                                            if (!subrs[subrNumber]) {
                                                error = true;
                                                break;
                                            }
                                            error = this.convert(subrs[subrNumber], subrs, seacAnalysisEnabled);
                                            break;
                                        case 11:
                                            return error;
                                        case 13:
                                            if (this.stack.length < 2) {
                                                error = true;
                                                break;
                                            }
                                            wx = this.stack.pop();
                                            sbx = this.stack.pop();
                                            this.lsb = sbx;
                                            this.width = wx;
                                            this.stack.push(wx, sbx);
                                            error = this.executeCommand(2, COMMAND_MAP.hmoveto);
                                            break;
                                        case 14:
                                            this.output.push(COMMAND_MAP.endchar[0]);
                                            break;
                                        case 21:
                                            if (this.flexing) break;
                                            error = this.executeCommand(2, COMMAND_MAP.rmoveto);
                                            break;
                                        case 22:
                                            if (this.flexing) {
                                                this.stack.push(0);
                                                break;
                                            }
                                            error = this.executeCommand(1, COMMAND_MAP.hmoveto);
                                            break;
                                        case 30:
                                            error = this.executeCommand(4, COMMAND_MAP.vhcurveto);
                                            break;
                                        case 31:
                                            error = this.executeCommand(4, COMMAND_MAP.hvcurveto);
                                            break;
                                        case 3072:
                                            this.stack = [];
                                            break;
                                        case 3073:
                                            if (!HINTING_ENABLED) {
                                                this.stack = [];
                                                break;
                                            }
                                            error = this.executeCommand(2, COMMAND_MAP.vstem);
                                            break;
                                        case 3074:
                                            if (!HINTING_ENABLED) {
                                                this.stack = [];
                                                break;
                                            }
                                            error = this.executeCommand(2, COMMAND_MAP.hstem);
                                            break;
                                        case 3078:
                                            if (seacAnalysisEnabled) {
                                                const asb = this.stack[this.stack.length - 5];
                                                this.seac = this.stack.splice(-4, 4);
                                                this.seac[0] += this.lsb - asb;
                                                error = this.executeCommand(0, COMMAND_MAP.endchar);
                                            } else error = this.executeCommand(4, COMMAND_MAP.endchar);
                                            break;
                                        case 3079:
                                            if (this.stack.length < 4) {
                                                error = true;
                                                break;
                                            }
                                            this.stack.pop();
                                            wx = this.stack.pop();
                                            const sby = this.stack.pop();
                                            sbx = this.stack.pop();
                                            this.lsb = sbx;
                                            this.width = wx;
                                            this.stack.push(wx, sbx, sby);
                                            error = this.executeCommand(3, COMMAND_MAP.rmoveto);
                                            break;
                                        case 3084:
                                            if (this.stack.length < 2) {
                                                error = true;
                                                break;
                                            }
                                            const num2 = this.stack.pop();
                                            const num1 = this.stack.pop();
                                            this.stack.push(num1 / num2);
                                            break;
                                        case 3088:
                                            if (this.stack.length < 2) {
                                                error = true;
                                                break;
                                            }
                                            subrNumber = this.stack.pop();
                                            const numArgs = this.stack.pop();
                                            if (subrNumber === 0 && numArgs === 3) {
                                                const flexArgs = this.stack.splice(this.stack.length - 17, 17);
                                                this.stack.push(flexArgs[2] + flexArgs[0], flexArgs[3] + flexArgs[1], flexArgs[4], flexArgs[5], flexArgs[6], flexArgs[7], flexArgs[8], flexArgs[9], flexArgs[10], flexArgs[11], flexArgs[12], flexArgs[13], flexArgs[14]);
                                                error = this.executeCommand(13, COMMAND_MAP.flex, true);
                                                this.flexing = false;
                                                this.stack.push(flexArgs[15], flexArgs[16]);
                                            } else if (subrNumber === 1 && numArgs === 0) this.flexing = true;
                                            break;
                                        case 3089:
                                            break;
                                        case 3105:
                                            this.stack = [];
                                            break;
                                        default:
                                            (0, _util.warn)('Unknown type 1 charstring command of "' + value + '"');
                                            break;
                                    }
                                    if (error) break;
                                    continue;
                                } else if (value <= 246) value -= 139;
                                else if (value <= 250) value = (value - 247) * 256 + encoded[++i] + 108;
                                else if (value <= 254) value = -((value - 251) * 256) - encoded[++i] - 108;
                                else value = (encoded[++i] & 0xff) << 24 | (encoded[++i] & 0xff) << 16 | (encoded[++i] & 0xff) << 8 | (encoded[++i] & 0xff) << 0;
                                this.stack.push(value);
                            }
                            return error;
                        }
                        executeCommand(howManyArgs, command, keepStack) {
                            const stackLength = this.stack.length;
                            if (howManyArgs > stackLength) return true;
                            const start = stackLength - howManyArgs;
                            for(let i = start; i < stackLength; i++){
                                let value = this.stack[i];
                                if (Number.isInteger(value)) this.output.push(28, value >> 8 & 0xff, value & 0xff);
                                else {
                                    value = 65536 * value | 0;
                                    this.output.push(255, value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                                }
                            }
                            this.output.push.apply(this.output, command);
                            if (keepStack) this.stack.splice(start, howManyArgs);
                            else this.stack.length = 0;
                            return false;
                        }
                    }
                    return Type1CharString;
                }();
                const Type1Parser = function Type1ParserClosure() {
                    const EEXEC_ENCRYPT_KEY = 55665;
                    const CHAR_STRS_ENCRYPT_KEY = 4330;
                    function isHexDigit(code) {
                        return code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102;
                    }
                    function decrypt(data, key, discardNumber) {
                        if (discardNumber >= data.length) return new Uint8Array(0);
                        const c1 = 52845, c2 = 22719;
                        let r = key | 0, i, j;
                        for(i = 0; i < discardNumber; i++)r = (data[i] + r) * c1 + c2 & 65535;
                        const count = data.length - discardNumber;
                        const decrypted = new Uint8Array(count);
                        for(i = discardNumber, j = 0; j < count; i++, j++){
                            const value = data[i];
                            decrypted[j] = value ^ r >> 8;
                            r = (value + r) * c1 + c2 & 65535;
                        }
                        return decrypted;
                    }
                    function decryptAscii(data, key, discardNumber) {
                        const c1 = 52845, c2 = 22719;
                        let r = key | 0;
                        const count = data.length, maybeLength = count >>> 1;
                        const decrypted = new Uint8Array(maybeLength);
                        let i, j;
                        for(i = 0, j = 0; i < count; i++){
                            const digit1 = data[i];
                            if (!isHexDigit(digit1)) continue;
                            i++;
                            let digit2;
                            while(i < count && !isHexDigit(digit2 = data[i]))i++;
                            if (i < count) {
                                const value = parseInt(String.fromCharCode(digit1, digit2), 16);
                                decrypted[j++] = value ^ r >> 8;
                                r = (value + r) * c1 + c2 & 65535;
                            }
                        }
                        return decrypted.slice(discardNumber, j);
                    }
                    function isSpecial(c) {
                        return c === 0x2f || c === 0x5b || c === 0x5d || c === 0x7b || c === 0x7d || c === 0x28 || c === 0x29;
                    }
                    class Type1Parser {
                        constructor(stream, encrypted, seacAnalysisEnabled){
                            if (encrypted) {
                                const data = stream.getBytes();
                                const isBinary = !((isHexDigit(data[0]) || (0, _core_utils.isWhiteSpace)(data[0])) && isHexDigit(data[1]) && isHexDigit(data[2]) && isHexDigit(data[3]) && isHexDigit(data[4]) && isHexDigit(data[5]) && isHexDigit(data[6]) && isHexDigit(data[7]));
                                stream = new _stream.Stream(isBinary ? decrypt(data, EEXEC_ENCRYPT_KEY, 4) : decryptAscii(data, EEXEC_ENCRYPT_KEY, 4));
                            }
                            this.seacAnalysisEnabled = !!seacAnalysisEnabled;
                            this.stream = stream;
                            this.nextChar();
                        }
                        readNumberArray() {
                            this.getToken();
                            const array = [];
                            while(true){
                                const token = this.getToken();
                                if (token === null || token === "]" || token === "}") break;
                                array.push(parseFloat(token || 0));
                            }
                            return array;
                        }
                        readNumber() {
                            const token = this.getToken();
                            return parseFloat(token || 0);
                        }
                        readInt() {
                            const token = this.getToken();
                            return parseInt(token || 0, 10) | 0;
                        }
                        readBoolean() {
                            const token = this.getToken();
                            return token === "true" ? 1 : 0;
                        }
                        nextChar() {
                            return this.currentChar = this.stream.getByte();
                        }
                        getToken() {
                            let comment = false;
                            let ch = this.currentChar;
                            while(true){
                                if (ch === -1) return null;
                                if (comment) {
                                    if (ch === 0x0a || ch === 0x0d) comment = false;
                                } else if (ch === 0x25) comment = true;
                                else if (!(0, _core_utils.isWhiteSpace)(ch)) break;
                                ch = this.nextChar();
                            }
                            if (isSpecial(ch)) {
                                this.nextChar();
                                return String.fromCharCode(ch);
                            }
                            let token = "";
                            do {
                                token += String.fromCharCode(ch);
                                ch = this.nextChar();
                            }while (ch >= 0 && !(0, _core_utils.isWhiteSpace)(ch) && !isSpecial(ch));
                            return token;
                        }
                        readCharStrings(bytes, lenIV) {
                            if (lenIV === -1) return bytes;
                            return decrypt(bytes, CHAR_STRS_ENCRYPT_KEY, lenIV);
                        }
                        extractFontProgram(properties) {
                            const stream = this.stream;
                            const subrs = [], charstrings = [];
                            const privateData = Object.create(null);
                            privateData.lenIV = 4;
                            const program = {
                                subrs: [],
                                charstrings: [],
                                properties: {
                                    privateData: privateData
                                }
                            };
                            let token, length, data, lenIV, encoded;
                            while((token = this.getToken()) !== null){
                                if (token !== "/") continue;
                                token = this.getToken();
                                switch(token){
                                    case "CharStrings":
                                        this.getToken();
                                        this.getToken();
                                        this.getToken();
                                        this.getToken();
                                        while(true){
                                            token = this.getToken();
                                            if (token === null || token === "end") break;
                                            if (token !== "/") continue;
                                            const glyph = this.getToken();
                                            length = this.readInt();
                                            this.getToken();
                                            data = length > 0 ? stream.getBytes(length) : new Uint8Array(0);
                                            lenIV = program.properties.privateData.lenIV;
                                            encoded = this.readCharStrings(data, lenIV);
                                            this.nextChar();
                                            token = this.getToken();
                                            if (token === "noaccess") this.getToken();
                                            charstrings.push({
                                                glyph: glyph,
                                                encoded: encoded
                                            });
                                        }
                                        break;
                                    case "Subrs":
                                        this.readInt();
                                        this.getToken();
                                        while(this.getToken() === "dup"){
                                            const index = this.readInt();
                                            length = this.readInt();
                                            this.getToken();
                                            data = length > 0 ? stream.getBytes(length) : new Uint8Array(0);
                                            lenIV = program.properties.privateData.lenIV;
                                            encoded = this.readCharStrings(data, lenIV);
                                            this.nextChar();
                                            token = this.getToken();
                                            if (token === "noaccess") this.getToken();
                                            subrs[index] = encoded;
                                        }
                                        break;
                                    case "BlueValues":
                                    case "OtherBlues":
                                    case "FamilyBlues":
                                    case "FamilyOtherBlues":
                                        const blueArray = this.readNumberArray();
                                        if (blueArray.length > 0 && blueArray.length % 2 === 0 && HINTING_ENABLED) program.properties.privateData[token] = blueArray;
                                        break;
                                    case "StemSnapH":
                                    case "StemSnapV":
                                        program.properties.privateData[token] = this.readNumberArray();
                                        break;
                                    case "StdHW":
                                    case "StdVW":
                                        program.properties.privateData[token] = this.readNumberArray()[0];
                                        break;
                                    case "BlueShift":
                                    case "lenIV":
                                    case "BlueFuzz":
                                    case "BlueScale":
                                    case "LanguageGroup":
                                    case "ExpansionFactor":
                                        program.properties.privateData[token] = this.readNumber();
                                        break;
                                    case "ForceBold":
                                        program.properties.privateData[token] = this.readBoolean();
                                        break;
                                }
                            }
                            for(let i = 0; i < charstrings.length; i++){
                                const glyph = charstrings[i].glyph;
                                encoded = charstrings[i].encoded;
                                const charString = new Type1CharString();
                                const error = charString.convert(encoded, subrs, this.seacAnalysisEnabled);
                                let output = charString.output;
                                if (error) output = [
                                    14
                                ];
                                const charStringObject = {
                                    glyphName: glyph,
                                    charstring: output,
                                    width: charString.width,
                                    lsb: charString.lsb,
                                    seac: charString.seac
                                };
                                if (glyph === ".notdef") program.charstrings.unshift(charStringObject);
                                else program.charstrings.push(charStringObject);
                                if (properties.builtInEncoding) {
                                    const index = properties.builtInEncoding.indexOf(glyph);
                                    if (index > -1 && properties.widths[index] === undefined && index >= properties.firstChar && index <= properties.lastChar) properties.widths[index] = charString.width;
                                }
                            }
                            return program;
                        }
                        extractFontHeader(properties) {
                            let token;
                            while((token = this.getToken()) !== null){
                                if (token !== "/") continue;
                                token = this.getToken();
                                switch(token){
                                    case "FontMatrix":
                                        const matrix = this.readNumberArray();
                                        properties.fontMatrix = matrix;
                                        break;
                                    case "Encoding":
                                        const encodingArg = this.getToken();
                                        let encoding;
                                        if (!/^\d+$/.test(encodingArg)) encoding = (0, _encodings.getEncoding)(encodingArg);
                                        else {
                                            encoding = [];
                                            const size = parseInt(encodingArg, 10) | 0;
                                            this.getToken();
                                            for(let j = 0; j < size; j++){
                                                token = this.getToken();
                                                while(token !== "dup" && token !== "def"){
                                                    token = this.getToken();
                                                    if (token === null) return;
                                                }
                                                if (token === "def") break;
                                                const index = this.readInt();
                                                this.getToken();
                                                const glyph = this.getToken();
                                                encoding[index] = glyph;
                                                this.getToken();
                                            }
                                        }
                                        properties.builtInEncoding = encoding;
                                        break;
                                    case "FontBBox":
                                        const fontBBox = this.readNumberArray();
                                        properties.ascent = Math.max(fontBBox[3], fontBBox[1]);
                                        properties.descent = Math.min(fontBBox[1], fontBBox[3]);
                                        properties.ascentScaled = true;
                                        break;
                                }
                            }
                        }
                    }
                    return Type1Parser;
                }();
                exports.Type1Parser = Type1Parser;
            /***/ },
            /* 49 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getTilingPatternIR = getTilingPatternIR;
                exports.Pattern = void 0;
                var _util = __w_pdfjs_require__(2);
                var _colorspace = __w_pdfjs_require__(14);
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                const ShadingType = {
                    FUNCTION_BASED: 1,
                    AXIAL: 2,
                    RADIAL: 3,
                    FREE_FORM_MESH: 4,
                    LATTICE_FORM_MESH: 5,
                    COONS_PATCH_MESH: 6,
                    TENSOR_PATCH_MESH: 7
                };
                class Pattern {
                    constructor(){
                        (0, _util.unreachable)("Cannot initialize Pattern.");
                    }
                    static parseShading(shading, matrix, xref, res, handler, pdfFunctionFactory, localColorSpaceCache) {
                        const dict = (0, _primitives.isStream)(shading) ? shading.dict : shading;
                        const type = dict.get("ShadingType");
                        try {
                            switch(type){
                                case ShadingType.AXIAL:
                                case ShadingType.RADIAL:
                                    return new RadialAxialShading(dict, matrix, xref, res, pdfFunctionFactory, localColorSpaceCache);
                                case ShadingType.FREE_FORM_MESH:
                                case ShadingType.LATTICE_FORM_MESH:
                                case ShadingType.COONS_PATCH_MESH:
                                case ShadingType.TENSOR_PATCH_MESH:
                                    return new MeshShading(shading, matrix, xref, res, pdfFunctionFactory, localColorSpaceCache);
                                default:
                                    throw new _util.FormatError("Unsupported ShadingType: " + type);
                            }
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            handler.send("UnsupportedFeature", {
                                featureId: _util.UNSUPPORTED_FEATURES.shadingPattern
                            });
                            (0, _util.warn)(ex);
                            return new DummyShading();
                        }
                    }
                }
                exports.Pattern = Pattern;
                class BaseShading {
                    static get SMALL_NUMBER() {
                        return (0, _util.shadow)(this, "SMALL_NUMBER", 1e-6);
                    }
                    constructor(){
                        if (this.constructor === BaseShading) (0, _util.unreachable)("Cannot initialize BaseShading.");
                    }
                    getIR() {
                        (0, _util.unreachable)("Abstract method `getIR` called.");
                    }
                }
                class RadialAxialShading extends BaseShading {
                    constructor(dict, matrix, xref, resources, pdfFunctionFactory, localColorSpaceCache){
                        super();
                        this.matrix = matrix;
                        this.coordsArr = dict.getArray("Coords");
                        this.shadingType = dict.get("ShadingType");
                        const cs = _colorspace.ColorSpace.parse({
                            cs: dict.getRaw("ColorSpace") || dict.getRaw("CS"),
                            xref: xref,
                            resources: resources,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        const bbox = dict.getArray("BBox");
                        if (Array.isArray(bbox) && bbox.length === 4) this.bbox = _util.Util.normalizeRect(bbox);
                        else this.bbox = null;
                        let t0 = 0.0, t1 = 1.0;
                        if (dict.has("Domain")) {
                            const domainArr = dict.getArray("Domain");
                            t0 = domainArr[0];
                            t1 = domainArr[1];
                        }
                        let extendStart = false, extendEnd = false;
                        if (dict.has("Extend")) {
                            const extendArr = dict.getArray("Extend");
                            extendStart = extendArr[0];
                            extendEnd = extendArr[1];
                        }
                        if (this.shadingType === ShadingType.RADIAL && (!extendStart || !extendEnd)) {
                            const [x1, y1, r1, x2, y2, r2] = this.coordsArr;
                            const distance = Math.hypot(x1 - x2, y1 - y2);
                            if (r1 <= r2 + distance && r2 <= r1 + distance) (0, _util.warn)("Unsupported radial gradient.");
                        }
                        this.extendStart = extendStart;
                        this.extendEnd = extendEnd;
                        const fnObj = dict.getRaw("Function");
                        const fn = pdfFunctionFactory.createFromArray(fnObj);
                        const NUMBER_OF_SAMPLES = 10;
                        const step = (t1 - t0) / NUMBER_OF_SAMPLES;
                        const colorStops = this.colorStops = [];
                        if (t0 >= t1 || step <= 0) {
                            (0, _util.info)("Bad shading domain.");
                            return;
                        }
                        const color = new Float32Array(cs.numComps), ratio = new Float32Array(1);
                        let rgbColor;
                        for(let i = 0; i <= NUMBER_OF_SAMPLES; i++){
                            ratio[0] = t0 + i * step;
                            fn(ratio, 0, color, 0);
                            rgbColor = cs.getRgb(color, 0);
                            const cssColor = _util.Util.makeHexColor(rgbColor[0], rgbColor[1], rgbColor[2]);
                            colorStops.push([
                                i / NUMBER_OF_SAMPLES,
                                cssColor
                            ]);
                        }
                        let background = "transparent";
                        if (dict.has("Background")) {
                            rgbColor = cs.getRgb(dict.get("Background"), 0);
                            background = _util.Util.makeHexColor(rgbColor[0], rgbColor[1], rgbColor[2]);
                        }
                        if (!extendStart) {
                            colorStops.unshift([
                                0,
                                background
                            ]);
                            colorStops[1][0] += BaseShading.SMALL_NUMBER;
                        }
                        if (!extendEnd) {
                            colorStops[colorStops.length - 1][0] -= BaseShading.SMALL_NUMBER;
                            colorStops.push([
                                1,
                                background
                            ]);
                        }
                        this.colorStops = colorStops;
                    }
                    getIR() {
                        const coordsArr = this.coordsArr;
                        const shadingType = this.shadingType;
                        let type, p0, p1, r0, r1;
                        if (shadingType === ShadingType.AXIAL) {
                            p0 = [
                                coordsArr[0],
                                coordsArr[1]
                            ];
                            p1 = [
                                coordsArr[2],
                                coordsArr[3]
                            ];
                            r0 = null;
                            r1 = null;
                            type = "axial";
                        } else if (shadingType === ShadingType.RADIAL) {
                            p0 = [
                                coordsArr[0],
                                coordsArr[1]
                            ];
                            p1 = [
                                coordsArr[3],
                                coordsArr[4]
                            ];
                            r0 = coordsArr[2];
                            r1 = coordsArr[5];
                            type = "radial";
                        } else (0, _util.unreachable)(`getPattern type unknown: ${shadingType}`);
                        return [
                            "RadialAxial",
                            type,
                            this.bbox,
                            this.colorStops,
                            p0,
                            p1,
                            r0,
                            r1,
                            this.matrix
                        ];
                    }
                }
                class MeshStreamReader {
                    constructor(stream, context){
                        this.stream = stream;
                        this.context = context;
                        this.buffer = 0;
                        this.bufferLength = 0;
                        const numComps = context.numComps;
                        this.tmpCompsBuf = new Float32Array(numComps);
                        const csNumComps = context.colorSpace.numComps;
                        this.tmpCsCompsBuf = context.colorFn ? new Float32Array(csNumComps) : this.tmpCompsBuf;
                    }
                    get hasData() {
                        if (this.stream.end) return this.stream.pos < this.stream.end;
                        if (this.bufferLength > 0) return true;
                        const nextByte = this.stream.getByte();
                        if (nextByte < 0) return false;
                        this.buffer = nextByte;
                        this.bufferLength = 8;
                        return true;
                    }
                    readBits(n) {
                        let buffer = this.buffer;
                        let bufferLength = this.bufferLength;
                        if (n === 32) {
                            if (bufferLength === 0) return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                            buffer = buffer << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                            const nextByte = this.stream.getByte();
                            this.buffer = nextByte & (1 << bufferLength) - 1;
                            return (buffer << 8 - bufferLength | (nextByte & 0xff) >> bufferLength) >>> 0;
                        }
                        if (n === 8 && bufferLength === 0) return this.stream.getByte();
                        while(bufferLength < n){
                            buffer = buffer << 8 | this.stream.getByte();
                            bufferLength += 8;
                        }
                        bufferLength -= n;
                        this.bufferLength = bufferLength;
                        this.buffer = buffer & (1 << bufferLength) - 1;
                        return buffer >> bufferLength;
                    }
                    align() {
                        this.buffer = 0;
                        this.bufferLength = 0;
                    }
                    readFlag() {
                        return this.readBits(this.context.bitsPerFlag);
                    }
                    readCoordinate() {
                        const bitsPerCoordinate = this.context.bitsPerCoordinate;
                        const xi = this.readBits(bitsPerCoordinate);
                        const yi = this.readBits(bitsPerCoordinate);
                        const decode = this.context.decode;
                        const scale = bitsPerCoordinate < 32 ? 1 / ((1 << bitsPerCoordinate) - 1) : 2.3283064365386963e-10;
                        return [
                            xi * scale * (decode[1] - decode[0]) + decode[0],
                            yi * scale * (decode[3] - decode[2]) + decode[2]
                        ];
                    }
                    readComponents() {
                        const numComps = this.context.numComps;
                        const bitsPerComponent = this.context.bitsPerComponent;
                        const scale = bitsPerComponent < 32 ? 1 / ((1 << bitsPerComponent) - 1) : 2.3283064365386963e-10;
                        const decode = this.context.decode;
                        const components = this.tmpCompsBuf;
                        for(let i = 0, j = 4; i < numComps; i++, j += 2){
                            const ci = this.readBits(bitsPerComponent);
                            components[i] = ci * scale * (decode[j + 1] - decode[j]) + decode[j];
                        }
                        const color = this.tmpCsCompsBuf;
                        if (this.context.colorFn) this.context.colorFn(components, 0, color, 0);
                        return this.context.colorSpace.getRgb(color, 0);
                    }
                }
                const getB = function getBClosure() {
                    function buildB(count) {
                        const lut = [];
                        for(let i = 0; i <= count; i++){
                            const t = i / count, t_ = 1 - t;
                            lut.push(new Float32Array([
                                t_ * t_ * t_,
                                3 * t * t_ * t_,
                                3 * t * t * t_,
                                t * t * t
                            ]));
                        }
                        return lut;
                    }
                    const cache = [];
                    return function(count) {
                        if (!cache[count]) cache[count] = buildB(count);
                        return cache[count];
                    };
                }();
                class MeshShading extends BaseShading {
                    static get MIN_SPLIT_PATCH_CHUNKS_AMOUNT() {
                        return (0, _util.shadow)(this, "MIN_SPLIT_PATCH_CHUNKS_AMOUNT", 3);
                    }
                    static get MAX_SPLIT_PATCH_CHUNKS_AMOUNT() {
                        return (0, _util.shadow)(this, "MAX_SPLIT_PATCH_CHUNKS_AMOUNT", 20);
                    }
                    static get TRIANGLE_DENSITY() {
                        return (0, _util.shadow)(this, "TRIANGLE_DENSITY", 20);
                    }
                    constructor(stream, matrix, xref, resources, pdfFunctionFactory, localColorSpaceCache){
                        super();
                        if (!(0, _primitives.isStream)(stream)) throw new _util.FormatError("Mesh data is not a stream");
                        const dict = stream.dict;
                        this.matrix = matrix;
                        this.shadingType = dict.get("ShadingType");
                        const bbox = dict.getArray("BBox");
                        if (Array.isArray(bbox) && bbox.length === 4) this.bbox = _util.Util.normalizeRect(bbox);
                        else this.bbox = null;
                        const cs = _colorspace.ColorSpace.parse({
                            cs: dict.getRaw("ColorSpace") || dict.getRaw("CS"),
                            xref: xref,
                            resources: resources,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        this.background = dict.has("Background") ? cs.getRgb(dict.get("Background"), 0) : null;
                        const fnObj = dict.getRaw("Function");
                        const fn = fnObj ? pdfFunctionFactory.createFromArray(fnObj) : null;
                        this.coords = [];
                        this.colors = [];
                        this.figures = [];
                        const decodeContext = {
                            bitsPerCoordinate: dict.get("BitsPerCoordinate"),
                            bitsPerComponent: dict.get("BitsPerComponent"),
                            bitsPerFlag: dict.get("BitsPerFlag"),
                            decode: dict.getArray("Decode"),
                            colorFn: fn,
                            colorSpace: cs,
                            numComps: fn ? 1 : cs.numComps
                        };
                        const reader = new MeshStreamReader(stream, decodeContext);
                        let patchMesh = false;
                        switch(this.shadingType){
                            case ShadingType.FREE_FORM_MESH:
                                this._decodeType4Shading(reader);
                                break;
                            case ShadingType.LATTICE_FORM_MESH:
                                const verticesPerRow = dict.get("VerticesPerRow") | 0;
                                if (verticesPerRow < 2) throw new _util.FormatError("Invalid VerticesPerRow");
                                this._decodeType5Shading(reader, verticesPerRow);
                                break;
                            case ShadingType.COONS_PATCH_MESH:
                                this._decodeType6Shading(reader);
                                patchMesh = true;
                                break;
                            case ShadingType.TENSOR_PATCH_MESH:
                                this._decodeType7Shading(reader);
                                patchMesh = true;
                                break;
                            default:
                                (0, _util.unreachable)("Unsupported mesh type.");
                                break;
                        }
                        if (patchMesh) {
                            this._updateBounds();
                            for(let i = 0, ii = this.figures.length; i < ii; i++)this._buildFigureFromPatch(i);
                        }
                        this._updateBounds();
                        this._packData();
                    }
                    _decodeType4Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const operators = [];
                        const ps = [];
                        let verticesLeft = 0;
                        while(reader.hasData){
                            const f = reader.readFlag();
                            const coord = reader.readCoordinate();
                            const color = reader.readComponents();
                            if (verticesLeft === 0) {
                                if (!(0 <= f && f <= 2)) throw new _util.FormatError("Unknown type4 flag");
                                switch(f){
                                    case 0:
                                        verticesLeft = 3;
                                        break;
                                    case 1:
                                        ps.push(ps[ps.length - 2], ps[ps.length - 1]);
                                        verticesLeft = 1;
                                        break;
                                    case 2:
                                        ps.push(ps[ps.length - 3], ps[ps.length - 1]);
                                        verticesLeft = 1;
                                        break;
                                }
                                operators.push(f);
                            }
                            ps.push(coords.length);
                            coords.push(coord);
                            colors.push(color);
                            verticesLeft--;
                            reader.align();
                        }
                        this.figures.push({
                            type: "triangles",
                            coords: new Int32Array(ps),
                            colors: new Int32Array(ps)
                        });
                    }
                    _decodeType5Shading(reader, verticesPerRow) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = [];
                        while(reader.hasData){
                            const coord = reader.readCoordinate();
                            const color = reader.readComponents();
                            ps.push(coords.length);
                            coords.push(coord);
                            colors.push(color);
                        }
                        this.figures.push({
                            type: "lattice",
                            coords: new Int32Array(ps),
                            colors: new Int32Array(ps),
                            verticesPerRow: verticesPerRow
                        });
                    }
                    _decodeType6Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = new Int32Array(16);
                        const cs = new Int32Array(4);
                        while(reader.hasData){
                            const f = reader.readFlag();
                            if (!(0 <= f && f <= 3)) throw new _util.FormatError("Unknown type6 flag");
                            const pi = coords.length;
                            for(let i = 0, ii = f !== 0 ? 8 : 12; i < ii; i++)coords.push(reader.readCoordinate());
                            const ci = colors.length;
                            for(let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++)colors.push(reader.readComponents());
                            let tmp1, tmp2, tmp3, tmp4;
                            switch(f){
                                case 0:
                                    ps[12] = pi + 3;
                                    ps[13] = pi + 4;
                                    ps[14] = pi + 5;
                                    ps[15] = pi + 6;
                                    ps[8] = pi + 2;
                                    ps[11] = pi + 7;
                                    ps[4] = pi + 1;
                                    ps[7] = pi + 8;
                                    ps[0] = pi;
                                    ps[1] = pi + 11;
                                    ps[2] = pi + 10;
                                    ps[3] = pi + 9;
                                    cs[2] = ci + 1;
                                    cs[3] = ci + 2;
                                    cs[0] = ci;
                                    cs[1] = ci + 3;
                                    break;
                                case 1:
                                    tmp1 = ps[12];
                                    tmp2 = ps[13];
                                    tmp3 = ps[14];
                                    tmp4 = ps[15];
                                    ps[12] = tmp4;
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = tmp3;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[2];
                                    tmp2 = cs[3];
                                    cs[2] = tmp2;
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 2:
                                    tmp1 = ps[15];
                                    tmp2 = ps[11];
                                    ps[12] = ps[3];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[7];
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[3];
                                    cs[2] = cs[1];
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 3:
                                    ps[12] = ps[0];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[1];
                                    ps[11] = pi + 3;
                                    ps[4] = ps[2];
                                    ps[7] = pi + 4;
                                    ps[0] = ps[3];
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    cs[2] = cs[0];
                                    cs[3] = ci;
                                    cs[0] = cs[1];
                                    cs[1] = ci + 1;
                                    break;
                            }
                            ps[5] = coords.length;
                            coords.push([
                                (-4 * coords[ps[0]][0] - coords[ps[15]][0] + 6 * (coords[ps[4]][0] + coords[ps[1]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[13]][0] + coords[ps[7]][0])) / 9,
                                (-4 * coords[ps[0]][1] - coords[ps[15]][1] + 6 * (coords[ps[4]][1] + coords[ps[1]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[13]][1] + coords[ps[7]][1])) / 9
                            ]);
                            ps[6] = coords.length;
                            coords.push([
                                (-4 * coords[ps[3]][0] - coords[ps[12]][0] + 6 * (coords[ps[2]][0] + coords[ps[7]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[4]][0] + coords[ps[14]][0])) / 9,
                                (-4 * coords[ps[3]][1] - coords[ps[12]][1] + 6 * (coords[ps[2]][1] + coords[ps[7]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[4]][1] + coords[ps[14]][1])) / 9
                            ]);
                            ps[9] = coords.length;
                            coords.push([
                                (-4 * coords[ps[12]][0] - coords[ps[3]][0] + 6 * (coords[ps[8]][0] + coords[ps[13]][0]) - 2 * (coords[ps[0]][0] + coords[ps[15]][0]) + 3 * (coords[ps[11]][0] + coords[ps[1]][0])) / 9,
                                (-4 * coords[ps[12]][1] - coords[ps[3]][1] + 6 * (coords[ps[8]][1] + coords[ps[13]][1]) - 2 * (coords[ps[0]][1] + coords[ps[15]][1]) + 3 * (coords[ps[11]][1] + coords[ps[1]][1])) / 9
                            ]);
                            ps[10] = coords.length;
                            coords.push([
                                (-4 * coords[ps[15]][0] - coords[ps[0]][0] + 6 * (coords[ps[11]][0] + coords[ps[14]][0]) - 2 * (coords[ps[12]][0] + coords[ps[3]][0]) + 3 * (coords[ps[2]][0] + coords[ps[8]][0])) / 9,
                                (-4 * coords[ps[15]][1] - coords[ps[0]][1] + 6 * (coords[ps[11]][1] + coords[ps[14]][1]) - 2 * (coords[ps[12]][1] + coords[ps[3]][1]) + 3 * (coords[ps[2]][1] + coords[ps[8]][1])) / 9
                            ]);
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(ps),
                                colors: new Int32Array(cs)
                            });
                        }
                    }
                    _decodeType7Shading(reader) {
                        const coords = this.coords;
                        const colors = this.colors;
                        const ps = new Int32Array(16);
                        const cs = new Int32Array(4);
                        while(reader.hasData){
                            const f = reader.readFlag();
                            if (!(0 <= f && f <= 3)) throw new _util.FormatError("Unknown type7 flag");
                            const pi = coords.length;
                            for(let i = 0, ii = f !== 0 ? 12 : 16; i < ii; i++)coords.push(reader.readCoordinate());
                            const ci = colors.length;
                            for(let i = 0, ii = f !== 0 ? 2 : 4; i < ii; i++)colors.push(reader.readComponents());
                            let tmp1, tmp2, tmp3, tmp4;
                            switch(f){
                                case 0:
                                    ps[12] = pi + 3;
                                    ps[13] = pi + 4;
                                    ps[14] = pi + 5;
                                    ps[15] = pi + 6;
                                    ps[8] = pi + 2;
                                    ps[9] = pi + 13;
                                    ps[10] = pi + 14;
                                    ps[11] = pi + 7;
                                    ps[4] = pi + 1;
                                    ps[5] = pi + 12;
                                    ps[6] = pi + 15;
                                    ps[7] = pi + 8;
                                    ps[0] = pi;
                                    ps[1] = pi + 11;
                                    ps[2] = pi + 10;
                                    ps[3] = pi + 9;
                                    cs[2] = ci + 1;
                                    cs[3] = ci + 2;
                                    cs[0] = ci;
                                    cs[1] = ci + 3;
                                    break;
                                case 1:
                                    tmp1 = ps[12];
                                    tmp2 = ps[13];
                                    tmp3 = ps[14];
                                    tmp4 = ps[15];
                                    ps[12] = tmp4;
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = tmp3;
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[2];
                                    tmp2 = cs[3];
                                    cs[2] = tmp2;
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 2:
                                    tmp1 = ps[15];
                                    tmp2 = ps[11];
                                    ps[12] = ps[3];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[7];
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = tmp2;
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = tmp1;
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    tmp1 = cs[3];
                                    cs[2] = cs[1];
                                    cs[3] = ci;
                                    cs[0] = tmp1;
                                    cs[1] = ci + 1;
                                    break;
                                case 3:
                                    ps[12] = ps[0];
                                    ps[13] = pi + 0;
                                    ps[14] = pi + 1;
                                    ps[15] = pi + 2;
                                    ps[8] = ps[1];
                                    ps[9] = pi + 9;
                                    ps[10] = pi + 10;
                                    ps[11] = pi + 3;
                                    ps[4] = ps[2];
                                    ps[5] = pi + 8;
                                    ps[6] = pi + 11;
                                    ps[7] = pi + 4;
                                    ps[0] = ps[3];
                                    ps[1] = pi + 7;
                                    ps[2] = pi + 6;
                                    ps[3] = pi + 5;
                                    cs[2] = cs[0];
                                    cs[3] = ci;
                                    cs[0] = cs[1];
                                    cs[1] = ci + 1;
                                    break;
                            }
                            this.figures.push({
                                type: "patch",
                                coords: new Int32Array(ps),
                                colors: new Int32Array(cs)
                            });
                        }
                    }
                    _buildFigureFromPatch(index) {
                        const figure = this.figures[index];
                        (0, _util.assert)(figure.type === "patch", "Unexpected patch mesh figure");
                        const coords = this.coords, colors = this.colors;
                        const pi = figure.coords;
                        const ci = figure.colors;
                        const figureMinX = Math.min(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                        const figureMinY = Math.min(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                        const figureMaxX = Math.max(coords[pi[0]][0], coords[pi[3]][0], coords[pi[12]][0], coords[pi[15]][0]);
                        const figureMaxY = Math.max(coords[pi[0]][1], coords[pi[3]][1], coords[pi[12]][1], coords[pi[15]][1]);
                        let splitXBy = Math.ceil((figureMaxX - figureMinX) * MeshShading.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
                        splitXBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitXBy));
                        let splitYBy = Math.ceil((figureMaxY - figureMinY) * MeshShading.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
                        splitYBy = Math.max(MeshShading.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(MeshShading.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, splitYBy));
                        const verticesPerRow = splitXBy + 1;
                        const figureCoords = new Int32Array((splitYBy + 1) * verticesPerRow);
                        const figureColors = new Int32Array((splitYBy + 1) * verticesPerRow);
                        let k = 0;
                        const cl = new Uint8Array(3), cr = new Uint8Array(3);
                        const c0 = colors[ci[0]], c1 = colors[ci[1]], c2 = colors[ci[2]], c3 = colors[ci[3]];
                        const bRow = getB(splitYBy), bCol = getB(splitXBy);
                        for(let row = 0; row <= splitYBy; row++){
                            cl[0] = (c0[0] * (splitYBy - row) + c2[0] * row) / splitYBy | 0;
                            cl[1] = (c0[1] * (splitYBy - row) + c2[1] * row) / splitYBy | 0;
                            cl[2] = (c0[2] * (splitYBy - row) + c2[2] * row) / splitYBy | 0;
                            cr[0] = (c1[0] * (splitYBy - row) + c3[0] * row) / splitYBy | 0;
                            cr[1] = (c1[1] * (splitYBy - row) + c3[1] * row) / splitYBy | 0;
                            cr[2] = (c1[2] * (splitYBy - row) + c3[2] * row) / splitYBy | 0;
                            for(let col = 0; col <= splitXBy; col++, k++){
                                if ((row === 0 || row === splitYBy) && (col === 0 || col === splitXBy)) continue;
                                let x = 0, y = 0;
                                let q = 0;
                                for(let i = 0; i <= 3; i++)for(let j = 0; j <= 3; j++, q++){
                                    const m = bRow[row][i] * bCol[col][j];
                                    x += coords[pi[q]][0] * m;
                                    y += coords[pi[q]][1] * m;
                                }
                                figureCoords[k] = coords.length;
                                coords.push([
                                    x,
                                    y
                                ]);
                                figureColors[k] = colors.length;
                                const newColor = new Uint8Array(3);
                                newColor[0] = (cl[0] * (splitXBy - col) + cr[0] * col) / splitXBy | 0;
                                newColor[1] = (cl[1] * (splitXBy - col) + cr[1] * col) / splitXBy | 0;
                                newColor[2] = (cl[2] * (splitXBy - col) + cr[2] * col) / splitXBy | 0;
                                colors.push(newColor);
                            }
                        }
                        figureCoords[0] = pi[0];
                        figureColors[0] = ci[0];
                        figureCoords[splitXBy] = pi[3];
                        figureColors[splitXBy] = ci[1];
                        figureCoords[verticesPerRow * splitYBy] = pi[12];
                        figureColors[verticesPerRow * splitYBy] = ci[2];
                        figureCoords[verticesPerRow * splitYBy + splitXBy] = pi[15];
                        figureColors[verticesPerRow * splitYBy + splitXBy] = ci[3];
                        this.figures[index] = {
                            type: "lattice",
                            coords: figureCoords,
                            colors: figureColors,
                            verticesPerRow: verticesPerRow
                        };
                    }
                    _updateBounds() {
                        let minX = this.coords[0][0], minY = this.coords[0][1], maxX = minX, maxY = minY;
                        for(let i = 1, ii = this.coords.length; i < ii; i++){
                            const x = this.coords[i][0], y = this.coords[i][1];
                            minX = minX > x ? x : minX;
                            minY = minY > y ? y : minY;
                            maxX = maxX < x ? x : maxX;
                            maxY = maxY < y ? y : maxY;
                        }
                        this.bounds = [
                            minX,
                            minY,
                            maxX,
                            maxY
                        ];
                    }
                    _packData() {
                        let i, ii, j, jj;
                        const coords = this.coords;
                        const coordsPacked = new Float32Array(coords.length * 2);
                        for(i = 0, j = 0, ii = coords.length; i < ii; i++){
                            const xy = coords[i];
                            coordsPacked[j++] = xy[0];
                            coordsPacked[j++] = xy[1];
                        }
                        this.coords = coordsPacked;
                        const colors = this.colors;
                        const colorsPacked = new Uint8Array(colors.length * 3);
                        for(i = 0, j = 0, ii = colors.length; i < ii; i++){
                            const c = colors[i];
                            colorsPacked[j++] = c[0];
                            colorsPacked[j++] = c[1];
                            colorsPacked[j++] = c[2];
                        }
                        this.colors = colorsPacked;
                        const figures = this.figures;
                        for(i = 0, ii = figures.length; i < ii; i++){
                            const figure = figures[i], ps = figure.coords, cs = figure.colors;
                            for(j = 0, jj = ps.length; j < jj; j++){
                                ps[j] *= 2;
                                cs[j] *= 3;
                            }
                        }
                    }
                    getIR() {
                        return [
                            "Mesh",
                            this.shadingType,
                            this.coords,
                            this.colors,
                            this.figures,
                            this.bounds,
                            this.matrix,
                            this.bbox,
                            this.background
                        ];
                    }
                }
                class DummyShading extends BaseShading {
                    getIR() {
                        return [
                            "Dummy"
                        ];
                    }
                }
                function getTilingPatternIR(operatorList, dict, color) {
                    const matrix = dict.getArray("Matrix");
                    const bbox = _util.Util.normalizeRect(dict.getArray("BBox"));
                    const xstep = dict.get("XStep");
                    const ystep = dict.get("YStep");
                    const paintType = dict.get("PaintType");
                    const tilingType = dict.get("TilingType");
                    if (bbox[2] - bbox[0] === 0 || bbox[3] - bbox[1] === 0) throw new _util.FormatError(`Invalid getTilingPatternIR /BBox array: [${bbox}].`);
                    return [
                        "TilingPattern",
                        color,
                        operatorList,
                        matrix,
                        bbox,
                        xstep,
                        ystep,
                        paintType,
                        tilingType
                    ];
                }
            /***/ },
            /* 50 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.isPDFFunction = isPDFFunction;
                exports.PostScriptEvaluator = exports.PostScriptCompiler = exports.PDFFunctionFactory = void 0;
                var _primitives = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(2);
                var _ps_parser = __w_pdfjs_require__(51);
                var _image_utils = __w_pdfjs_require__(52);
                class PDFFunctionFactory {
                    constructor({ xref: xref , isEvalSupported: isEvalSupported = true  }){
                        this.xref = xref;
                        this.isEvalSupported = isEvalSupported !== false;
                    }
                    create(fn) {
                        const cachedFunction = this.getCached(fn);
                        if (cachedFunction) return cachedFunction;
                        const parsedFunction = PDFFunction.parse({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fn: fn instanceof _primitives.Ref ? this.xref.fetch(fn) : fn
                        });
                        this._cache(fn, parsedFunction);
                        return parsedFunction;
                    }
                    createFromArray(fnObj) {
                        const cachedFunction = this.getCached(fnObj);
                        if (cachedFunction) return cachedFunction;
                        const parsedFunction = PDFFunction.parseArray({
                            xref: this.xref,
                            isEvalSupported: this.isEvalSupported,
                            fnObj: fnObj instanceof _primitives.Ref ? this.xref.fetch(fnObj) : fnObj
                        });
                        this._cache(fnObj, parsedFunction);
                        return parsedFunction;
                    }
                    getCached(cacheKey) {
                        let fnRef;
                        if (cacheKey instanceof _primitives.Ref) fnRef = cacheKey;
                        else if (cacheKey instanceof _primitives.Dict) fnRef = cacheKey.objId;
                        else if ((0, _primitives.isStream)(cacheKey)) fnRef = cacheKey.dict && cacheKey.dict.objId;
                        if (fnRef) {
                            const localFunction = this._localFunctionCache.getByRef(fnRef);
                            if (localFunction) return localFunction;
                        }
                        return null;
                    }
                    _cache(cacheKey, parsedFunction) {
                        if (!parsedFunction) throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
                        let fnRef;
                        if (cacheKey instanceof _primitives.Ref) fnRef = cacheKey;
                        else if (cacheKey instanceof _primitives.Dict) fnRef = cacheKey.objId;
                        else if ((0, _primitives.isStream)(cacheKey)) fnRef = cacheKey.dict && cacheKey.dict.objId;
                        if (fnRef) this._localFunctionCache.set(null, fnRef, parsedFunction);
                    }
                    get _localFunctionCache() {
                        return (0, _util.shadow)(this, "_localFunctionCache", new _image_utils.LocalFunctionCache());
                    }
                }
                exports.PDFFunctionFactory = PDFFunctionFactory;
                function toNumberArray(arr) {
                    if (!Array.isArray(arr)) return null;
                    const length = arr.length;
                    for(let i = 0; i < length; i++)if (typeof arr[i] !== "number") {
                        const result = new Array(length);
                        for(let j = 0; j < length; j++)result[j] = +arr[j];
                        return result;
                    }
                    return arr;
                }
                class PDFFunction {
                    static getSampleArray(size, outputSize, bps, stream) {
                        let i, ii;
                        let length = 1;
                        for(i = 0, ii = size.length; i < ii; i++)length *= size[i];
                        length *= outputSize;
                        const array = new Array(length);
                        let codeSize = 0;
                        let codeBuf = 0;
                        const sampleMul = 1.0 / (2.0 ** bps - 1);
                        const strBytes = stream.getBytes((length * bps + 7) / 8);
                        let strIdx = 0;
                        for(i = 0; i < length; i++){
                            while(codeSize < bps){
                                codeBuf <<= 8;
                                codeBuf |= strBytes[strIdx++];
                                codeSize += 8;
                            }
                            codeSize -= bps;
                            array[i] = (codeBuf >> codeSize) * sampleMul;
                            codeBuf &= (1 << codeSize) - 1;
                        }
                        return array;
                    }
                    static parse({ xref: xref , isEvalSupported: isEvalSupported , fn: fn  }) {
                        const dict = fn.dict || fn;
                        const typeNum = dict.get("FunctionType");
                        switch(typeNum){
                            case 0:
                                return this.constructSampled({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    fn: fn,
                                    dict: dict
                                });
                            case 1:
                                break;
                            case 2:
                                return this.constructInterpolated({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    dict: dict
                                });
                            case 3:
                                return this.constructStiched({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    dict: dict
                                });
                            case 4:
                                return this.constructPostScript({
                                    xref: xref,
                                    isEvalSupported: isEvalSupported,
                                    fn: fn,
                                    dict: dict
                                });
                        }
                        throw new _util.FormatError("Unknown type of function");
                    }
                    static parseArray({ xref: xref , isEvalSupported: isEvalSupported , fnObj: fnObj  }) {
                        if (!Array.isArray(fnObj)) return this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: fnObj
                        });
                        const fnArray = [];
                        for(let j = 0, jj = fnObj.length; j < jj; j++)fnArray.push(this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: xref.fetchIfRef(fnObj[j])
                        }));
                        return function(src, srcOffset, dest, destOffset) {
                            for(let i = 0, ii = fnArray.length; i < ii; i++)fnArray[i](src, srcOffset, dest, destOffset + i);
                        };
                    }
                    static constructSampled({ xref: xref , isEvalSupported: isEvalSupported , fn: fn , dict: dict  }) {
                        function toMultiArray(arr) {
                            const inputLength = arr.length;
                            const out = [];
                            let index = 0;
                            for(let i = 0; i < inputLength; i += 2)out[index++] = [
                                arr[i],
                                arr[i + 1]
                            ];
                            return out;
                        }
                        function interpolate(x, xmin, xmax, ymin, ymax) {
                            return ymin + (x - xmin) * ((ymax - ymin) / (xmax - xmin));
                        }
                        let domain = toNumberArray(dict.getArray("Domain"));
                        let range = toNumberArray(dict.getArray("Range"));
                        if (!domain || !range) throw new _util.FormatError("No domain or range");
                        const inputSize = domain.length / 2;
                        const outputSize = range.length / 2;
                        domain = toMultiArray(domain);
                        range = toMultiArray(range);
                        const size = toNumberArray(dict.getArray("Size"));
                        const bps = dict.get("BitsPerSample");
                        const order = dict.get("Order") || 1;
                        if (order !== 1) (0, _util.info)("No support for cubic spline interpolation: " + order);
                        let encode = toNumberArray(dict.getArray("Encode"));
                        if (!encode) {
                            encode = [];
                            for(let i = 0; i < inputSize; ++i)encode.push([
                                0,
                                size[i] - 1
                            ]);
                        } else encode = toMultiArray(encode);
                        let decode = toNumberArray(dict.getArray("Decode"));
                        if (!decode) decode = range;
                        else decode = toMultiArray(decode);
                        const samples = this.getSampleArray(size, outputSize, bps, fn);
                        return function constructSampledFn(src, srcOffset, dest, destOffset) {
                            const cubeVertices = 1 << inputSize;
                            const cubeN = new Float64Array(cubeVertices);
                            const cubeVertex = new Uint32Array(cubeVertices);
                            let i, j;
                            for(j = 0; j < cubeVertices; j++)cubeN[j] = 1;
                            let k = outputSize, pos = 1;
                            for(i = 0; i < inputSize; ++i){
                                const domain_2i = domain[i][0];
                                const domain_2i_1 = domain[i][1];
                                const xi = Math.min(Math.max(src[srcOffset + i], domain_2i), domain_2i_1);
                                let e = interpolate(xi, domain_2i, domain_2i_1, encode[i][0], encode[i][1]);
                                const size_i = size[i];
                                e = Math.min(Math.max(e, 0), size_i - 1);
                                const e0 = e < size_i - 1 ? Math.floor(e) : e - 1;
                                const n0 = e0 + 1 - e;
                                const n1 = e - e0;
                                const offset0 = e0 * k;
                                const offset1 = offset0 + k;
                                for(j = 0; j < cubeVertices; j++)if (j & pos) {
                                    cubeN[j] *= n1;
                                    cubeVertex[j] += offset1;
                                } else {
                                    cubeN[j] *= n0;
                                    cubeVertex[j] += offset0;
                                }
                                k *= size_i;
                                pos <<= 1;
                            }
                            for(j = 0; j < outputSize; ++j){
                                let rj = 0;
                                for(i = 0; i < cubeVertices; i++)rj += samples[cubeVertex[i] + j] * cubeN[i];
                                rj = interpolate(rj, 0, 1, decode[j][0], decode[j][1]);
                                dest[destOffset + j] = Math.min(Math.max(rj, range[j][0]), range[j][1]);
                            }
                        };
                    }
                    static constructInterpolated({ xref: xref , isEvalSupported: isEvalSupported , dict: dict  }) {
                        const c0 = toNumberArray(dict.getArray("C0")) || [
                            0
                        ];
                        const c1 = toNumberArray(dict.getArray("C1")) || [
                            1
                        ];
                        const n = dict.get("N");
                        const diff = [];
                        for(let i = 0, ii = c0.length; i < ii; ++i)diff.push(c1[i] - c0[i]);
                        const length = diff.length;
                        return function constructInterpolatedFn(src, srcOffset, dest, destOffset) {
                            const x = n === 1 ? src[srcOffset] : src[srcOffset] ** n;
                            for(let j = 0; j < length; ++j)dest[destOffset + j] = c0[j] + x * diff[j];
                        };
                    }
                    static constructStiched({ xref: xref , isEvalSupported: isEvalSupported , dict: dict  }) {
                        const domain = toNumberArray(dict.getArray("Domain"));
                        if (!domain) throw new _util.FormatError("No domain");
                        const inputSize = domain.length / 2;
                        if (inputSize !== 1) throw new _util.FormatError("Bad domain for stiched function");
                        const fnRefs = dict.get("Functions");
                        const fns = [];
                        for(let i = 0, ii = fnRefs.length; i < ii; ++i)fns.push(this.parse({
                            xref: xref,
                            isEvalSupported: isEvalSupported,
                            fn: xref.fetchIfRef(fnRefs[i])
                        }));
                        const bounds = toNumberArray(dict.getArray("Bounds"));
                        const encode = toNumberArray(dict.getArray("Encode"));
                        const tmpBuf = new Float32Array(1);
                        return function constructStichedFn(src, srcOffset, dest, destOffset) {
                            const clip = function constructStichedFromIRClip(v, min, max) {
                                if (v > max) v = max;
                                else if (v < min) v = min;
                                return v;
                            };
                            const v = clip(src[srcOffset], domain[0], domain[1]);
                            const length = bounds.length;
                            let i;
                            for(i = 0; i < length; ++i){
                                if (v < bounds[i]) break;
                            }
                            let dmin = domain[0];
                            if (i > 0) dmin = bounds[i - 1];
                            let dmax = domain[1];
                            if (i < bounds.length) dmax = bounds[i];
                            const rmin = encode[2 * i];
                            const rmax = encode[2 * i + 1];
                            tmpBuf[0] = dmin === dmax ? rmin : rmin + (v - dmin) * (rmax - rmin) / (dmax - dmin);
                            fns[i](tmpBuf, 0, dest, destOffset);
                        };
                    }
                    static constructPostScript({ xref: xref , isEvalSupported: isEvalSupported , fn: fn , dict: dict  }) {
                        const domain = toNumberArray(dict.getArray("Domain"));
                        const range = toNumberArray(dict.getArray("Range"));
                        if (!domain) throw new _util.FormatError("No domain.");
                        if (!range) throw new _util.FormatError("No range.");
                        const lexer = new _ps_parser.PostScriptLexer(fn);
                        const parser = new _ps_parser.PostScriptParser(lexer);
                        const code = parser.parse();
                        if (isEvalSupported && _util.IsEvalSupportedCached.value) {
                            const compiled = new PostScriptCompiler().compile(code, domain, range);
                            if (compiled) return new Function("src", "srcOffset", "dest", "destOffset", compiled);
                        }
                        (0, _util.info)("Unable to compile PS function");
                        const numOutputs = range.length >> 1;
                        const numInputs = domain.length >> 1;
                        const evaluator = new PostScriptEvaluator(code);
                        const cache = Object.create(null);
                        const MAX_CACHE_SIZE = 8192;
                        let cache_available = MAX_CACHE_SIZE;
                        const tmpBuf = new Float32Array(numInputs);
                        return function constructPostScriptFn(src, srcOffset, dest, destOffset) {
                            let i, value;
                            let key = "";
                            const input = tmpBuf;
                            for(i = 0; i < numInputs; i++){
                                value = src[srcOffset + i];
                                input[i] = value;
                                key += value + "_";
                            }
                            const cachedValue = cache[key];
                            if (cachedValue !== undefined) {
                                dest.set(cachedValue, destOffset);
                                return;
                            }
                            const output = new Float32Array(numOutputs);
                            const stack = evaluator.execute(input);
                            const stackIndex = stack.length - numOutputs;
                            for(i = 0; i < numOutputs; i++){
                                value = stack[stackIndex + i];
                                let bound = range[i * 2];
                                if (value < bound) value = bound;
                                else {
                                    bound = range[i * 2 + 1];
                                    if (value > bound) value = bound;
                                }
                                output[i] = value;
                            }
                            if (cache_available > 0) {
                                cache_available--;
                                cache[key] = output;
                            }
                            dest.set(output, destOffset);
                        };
                    }
                }
                function isPDFFunction(v) {
                    let fnDict;
                    if (typeof v !== "object") return false;
                    else if ((0, _primitives.isDict)(v)) fnDict = v;
                    else if ((0, _primitives.isStream)(v)) fnDict = v.dict;
                    else return false;
                    return fnDict.has("FunctionType");
                }
                class PostScriptStack {
                    static get MAX_STACK_SIZE() {
                        return (0, _util.shadow)(this, "MAX_STACK_SIZE", 100);
                    }
                    constructor(initialStack){
                        this.stack = !initialStack ? [] : Array.prototype.slice.call(initialStack, 0);
                    }
                    push(value) {
                        if (this.stack.length >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        this.stack.push(value);
                    }
                    pop() {
                        if (this.stack.length <= 0) throw new Error("PostScript function stack underflow.");
                        return this.stack.pop();
                    }
                    copy(n) {
                        if (this.stack.length + n >= PostScriptStack.MAX_STACK_SIZE) throw new Error("PostScript function stack overflow.");
                        const stack = this.stack;
                        for(let i = stack.length - n, j = n - 1; j >= 0; j--, i++)stack.push(stack[i]);
                    }
                    index(n) {
                        this.push(this.stack[this.stack.length - n - 1]);
                    }
                    roll(n, p) {
                        const stack = this.stack;
                        const l = stack.length - n;
                        const r = stack.length - 1;
                        const c = l + (p - Math.floor(p / n) * n);
                        for(let i = l, j = r; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                        for(let i = l, j = c - 1; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                        for(let i = c, j = r; i < j; i++, j--){
                            const t = stack[i];
                            stack[i] = stack[j];
                            stack[j] = t;
                        }
                    }
                }
                class PostScriptEvaluator {
                    constructor(operators){
                        this.operators = operators;
                    }
                    execute(initialStack) {
                        const stack = new PostScriptStack(initialStack);
                        let counter = 0;
                        const operators = this.operators;
                        const length = operators.length;
                        let operator, a, b;
                        while(counter < length){
                            operator = operators[counter++];
                            if (typeof operator === "number") {
                                stack.push(operator);
                                continue;
                            }
                            switch(operator){
                                case "jz":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (!a) counter = b;
                                    break;
                                case "j":
                                    a = stack.pop();
                                    counter = a;
                                    break;
                                case "abs":
                                    a = stack.pop();
                                    stack.push(Math.abs(a));
                                    break;
                                case "add":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a + b);
                                    break;
                                case "and":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) stack.push(a && b);
                                    else stack.push(a & b);
                                    break;
                                case "atan":
                                    a = stack.pop();
                                    stack.push(Math.atan(a));
                                    break;
                                case "bitshift":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if (a > 0) stack.push(a << b);
                                    else stack.push(a >> b);
                                    break;
                                case "ceiling":
                                    a = stack.pop();
                                    stack.push(Math.ceil(a));
                                    break;
                                case "copy":
                                    a = stack.pop();
                                    stack.copy(a);
                                    break;
                                case "cos":
                                    a = stack.pop();
                                    stack.push(Math.cos(a));
                                    break;
                                case "cvi":
                                    a = stack.pop() | 0;
                                    stack.push(a);
                                    break;
                                case "cvr":
                                    break;
                                case "div":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a / b);
                                    break;
                                case "dup":
                                    stack.copy(1);
                                    break;
                                case "eq":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a === b);
                                    break;
                                case "exch":
                                    stack.roll(2, 1);
                                    break;
                                case "exp":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a ** b);
                                    break;
                                case "false":
                                    stack.push(false);
                                    break;
                                case "floor":
                                    a = stack.pop();
                                    stack.push(Math.floor(a));
                                    break;
                                case "ge":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a >= b);
                                    break;
                                case "gt":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a > b);
                                    break;
                                case "idiv":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a / b | 0);
                                    break;
                                case "index":
                                    a = stack.pop();
                                    stack.index(a);
                                    break;
                                case "le":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a <= b);
                                    break;
                                case "ln":
                                    a = stack.pop();
                                    stack.push(Math.log(a));
                                    break;
                                case "log":
                                    a = stack.pop();
                                    stack.push(Math.log(a) / Math.LN10);
                                    break;
                                case "lt":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a < b);
                                    break;
                                case "mod":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a % b);
                                    break;
                                case "mul":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a * b);
                                    break;
                                case "ne":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a !== b);
                                    break;
                                case "neg":
                                    a = stack.pop();
                                    stack.push(-a);
                                    break;
                                case "not":
                                    a = stack.pop();
                                    if ((0, _util.isBool)(a)) stack.push(!a);
                                    else stack.push(~a);
                                    break;
                                case "or":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) stack.push(a || b);
                                    else stack.push(a | b);
                                    break;
                                case "pop":
                                    stack.pop();
                                    break;
                                case "roll":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.roll(a, b);
                                    break;
                                case "round":
                                    a = stack.pop();
                                    stack.push(Math.round(a));
                                    break;
                                case "sin":
                                    a = stack.pop();
                                    stack.push(Math.sin(a));
                                    break;
                                case "sqrt":
                                    a = stack.pop();
                                    stack.push(Math.sqrt(a));
                                    break;
                                case "sub":
                                    b = stack.pop();
                                    a = stack.pop();
                                    stack.push(a - b);
                                    break;
                                case "true":
                                    stack.push(true);
                                    break;
                                case "truncate":
                                    a = stack.pop();
                                    a = a < 0 ? Math.ceil(a) : Math.floor(a);
                                    stack.push(a);
                                    break;
                                case "xor":
                                    b = stack.pop();
                                    a = stack.pop();
                                    if ((0, _util.isBool)(a) && (0, _util.isBool)(b)) stack.push(a !== b);
                                    else stack.push(a ^ b);
                                    break;
                                default:
                                    throw new _util.FormatError(`Unknown operator ${operator}`);
                            }
                        }
                        return stack.stack;
                    }
                }
                exports.PostScriptEvaluator = PostScriptEvaluator;
                const PostScriptCompiler = function PostScriptCompilerClosure() {
                    class AstNode {
                        constructor(type){
                            this.type = type;
                        }
                        visit(visitor) {
                            (0, _util.unreachable)("abstract method");
                        }
                    }
                    class AstArgument extends AstNode {
                        constructor(index, min, max){
                            super("args");
                            this.index = index;
                            this.min = min;
                            this.max = max;
                        }
                        visit(visitor) {
                            visitor.visitArgument(this);
                        }
                    }
                    class AstLiteral extends AstNode {
                        constructor(number){
                            super("literal");
                            this.number = number;
                            this.min = number;
                            this.max = number;
                        }
                        visit(visitor) {
                            visitor.visitLiteral(this);
                        }
                    }
                    class AstBinaryOperation extends AstNode {
                        constructor(op, arg1, arg2, min, max){
                            super("binary");
                            this.op = op;
                            this.arg1 = arg1;
                            this.arg2 = arg2;
                            this.min = min;
                            this.max = max;
                        }
                        visit(visitor) {
                            visitor.visitBinaryOperation(this);
                        }
                    }
                    class AstMin extends AstNode {
                        constructor(arg, max){
                            super("max");
                            this.arg = arg;
                            this.min = arg.min;
                            this.max = max;
                        }
                        visit(visitor) {
                            visitor.visitMin(this);
                        }
                    }
                    class AstVariable extends AstNode {
                        constructor(index, min, max){
                            super("var");
                            this.index = index;
                            this.min = min;
                            this.max = max;
                        }
                        visit(visitor) {
                            visitor.visitVariable(this);
                        }
                    }
                    class AstVariableDefinition extends AstNode {
                        constructor(variable, arg){
                            super("definition");
                            this.variable = variable;
                            this.arg = arg;
                        }
                        visit(visitor) {
                            visitor.visitVariableDefinition(this);
                        }
                    }
                    class ExpressionBuilderVisitor {
                        constructor(){
                            this.parts = [];
                        }
                        visitArgument(arg) {
                            this.parts.push("Math.max(", arg.min, ", Math.min(", arg.max, ", src[srcOffset + ", arg.index, "]))");
                        }
                        visitVariable(variable) {
                            this.parts.push("v", variable.index);
                        }
                        visitLiteral(literal) {
                            this.parts.push(literal.number);
                        }
                        visitBinaryOperation(operation) {
                            this.parts.push("(");
                            operation.arg1.visit(this);
                            this.parts.push(" ", operation.op, " ");
                            operation.arg2.visit(this);
                            this.parts.push(")");
                        }
                        visitVariableDefinition(definition) {
                            this.parts.push("var ");
                            definition.variable.visit(this);
                            this.parts.push(" = ");
                            definition.arg.visit(this);
                            this.parts.push(";");
                        }
                        visitMin(max) {
                            this.parts.push("Math.min(");
                            max.arg.visit(this);
                            this.parts.push(", ", max.max, ")");
                        }
                        toString() {
                            return this.parts.join("");
                        }
                    }
                    function buildAddOperation(num1, num2) {
                        if (num2.type === "literal" && num2.number === 0) return num1;
                        if (num1.type === "literal" && num1.number === 0) return num2;
                        if (num2.type === "literal" && num1.type === "literal") return new AstLiteral(num1.number + num2.number);
                        return new AstBinaryOperation("+", num1, num2, num1.min + num2.min, num1.max + num2.max);
                    }
                    function buildMulOperation(num1, num2) {
                        if (num2.type === "literal") {
                            if (num2.number === 0) return new AstLiteral(0);
                            else if (num2.number === 1) return num1;
                            else if (num1.type === "literal") return new AstLiteral(num1.number * num2.number);
                        }
                        if (num1.type === "literal") {
                            if (num1.number === 0) return new AstLiteral(0);
                            else if (num1.number === 1) return num2;
                        }
                        const min = Math.min(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                        const max = Math.max(num1.min * num2.min, num1.min * num2.max, num1.max * num2.min, num1.max * num2.max);
                        return new AstBinaryOperation("*", num1, num2, min, max);
                    }
                    function buildSubOperation(num1, num2) {
                        if (num2.type === "literal") {
                            if (num2.number === 0) return num1;
                            else if (num1.type === "literal") return new AstLiteral(num1.number - num2.number);
                        }
                        if (num2.type === "binary" && num2.op === "-" && num1.type === "literal" && num1.number === 1 && num2.arg1.type === "literal" && num2.arg1.number === 1) return num2.arg2;
                        return new AstBinaryOperation("-", num1, num2, num1.min - num2.max, num1.max - num2.min);
                    }
                    function buildMinOperation(num1, max) {
                        if (num1.min >= max) return new AstLiteral(max);
                        else if (num1.max <= max) return num1;
                        return new AstMin(num1, max);
                    }
                    class PostScriptCompiler {
                        compile(code, domain, range) {
                            const stack = [];
                            const instructions = [];
                            const inputSize = domain.length >> 1, outputSize = range.length >> 1;
                            let lastRegister = 0;
                            let n, j;
                            let num1, num2, ast1, ast2, tmpVar, item;
                            for(let i = 0; i < inputSize; i++)stack.push(new AstArgument(i, domain[i * 2], domain[i * 2 + 1]));
                            for(let i = 0, ii = code.length; i < ii; i++){
                                item = code[i];
                                if (typeof item === "number") {
                                    stack.push(new AstLiteral(item));
                                    continue;
                                }
                                switch(item){
                                    case "add":
                                        if (stack.length < 2) return null;
                                        num2 = stack.pop();
                                        num1 = stack.pop();
                                        stack.push(buildAddOperation(num1, num2));
                                        break;
                                    case "cvr":
                                        if (stack.length < 1) return null;
                                        break;
                                    case "mul":
                                        if (stack.length < 2) return null;
                                        num2 = stack.pop();
                                        num1 = stack.pop();
                                        stack.push(buildMulOperation(num1, num2));
                                        break;
                                    case "sub":
                                        if (stack.length < 2) return null;
                                        num2 = stack.pop();
                                        num1 = stack.pop();
                                        stack.push(buildSubOperation(num1, num2));
                                        break;
                                    case "exch":
                                        if (stack.length < 2) return null;
                                        ast1 = stack.pop();
                                        ast2 = stack.pop();
                                        stack.push(ast1, ast2);
                                        break;
                                    case "pop":
                                        if (stack.length < 1) return null;
                                        stack.pop();
                                        break;
                                    case "index":
                                        if (stack.length < 1) return null;
                                        num1 = stack.pop();
                                        if (num1.type !== "literal") return null;
                                        n = num1.number;
                                        if (n < 0 || !Number.isInteger(n) || stack.length < n) return null;
                                        ast1 = stack[stack.length - n - 1];
                                        if (ast1.type === "literal" || ast1.type === "var") {
                                            stack.push(ast1);
                                            break;
                                        }
                                        tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                                        stack[stack.length - n - 1] = tmpVar;
                                        stack.push(tmpVar);
                                        instructions.push(new AstVariableDefinition(tmpVar, ast1));
                                        break;
                                    case "dup":
                                        if (stack.length < 1) return null;
                                        if (typeof code[i + 1] === "number" && code[i + 2] === "gt" && code[i + 3] === i + 7 && code[i + 4] === "jz" && code[i + 5] === "pop" && code[i + 6] === code[i + 1]) {
                                            num1 = stack.pop();
                                            stack.push(buildMinOperation(num1, code[i + 1]));
                                            i += 6;
                                            break;
                                        }
                                        ast1 = stack[stack.length - 1];
                                        if (ast1.type === "literal" || ast1.type === "var") {
                                            stack.push(ast1);
                                            break;
                                        }
                                        tmpVar = new AstVariable(lastRegister++, ast1.min, ast1.max);
                                        stack[stack.length - 1] = tmpVar;
                                        stack.push(tmpVar);
                                        instructions.push(new AstVariableDefinition(tmpVar, ast1));
                                        break;
                                    case "roll":
                                        if (stack.length < 2) return null;
                                        num2 = stack.pop();
                                        num1 = stack.pop();
                                        if (num2.type !== "literal" || num1.type !== "literal") return null;
                                        j = num2.number;
                                        n = num1.number;
                                        if (n <= 0 || !Number.isInteger(n) || !Number.isInteger(j) || stack.length < n) return null;
                                        j = (j % n + n) % n;
                                        if (j === 0) break;
                                        Array.prototype.push.apply(stack, stack.splice(stack.length - n, n - j));
                                        break;
                                    default:
                                        return null;
                                }
                            }
                            if (stack.length !== outputSize) return null;
                            const result = [];
                            for (const instruction of instructions){
                                const statementBuilder = new ExpressionBuilderVisitor();
                                instruction.visit(statementBuilder);
                                result.push(statementBuilder.toString());
                            }
                            for(let i = 0, ii = stack.length; i < ii; i++){
                                const expr = stack[i], statementBuilder = new ExpressionBuilderVisitor();
                                expr.visit(statementBuilder);
                                const min = range[i * 2], max = range[i * 2 + 1];
                                const out = [
                                    statementBuilder.toString()
                                ];
                                if (min > expr.min) {
                                    out.unshift("Math.max(", min, ", ");
                                    out.push(")");
                                }
                                if (max < expr.max) {
                                    out.unshift("Math.min(", max, ", ");
                                    out.push(")");
                                }
                                out.unshift("dest[destOffset + ", i, "] = ");
                                out.push(";");
                                result.push(out.join(""));
                            }
                            return result.join("\n");
                        }
                    }
                    return PostScriptCompiler;
                }();
                exports.PostScriptCompiler = PostScriptCompiler;
            /***/ },
            /* 51 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PostScriptParser = exports.PostScriptLexer = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                class PostScriptParser {
                    constructor(lexer){
                        this.lexer = lexer;
                        this.operators = [];
                        this.token = null;
                        this.prev = null;
                    }
                    nextToken() {
                        this.prev = this.token;
                        this.token = this.lexer.getToken();
                    }
                    accept(type) {
                        if (this.token.type === type) {
                            this.nextToken();
                            return true;
                        }
                        return false;
                    }
                    expect(type) {
                        if (this.accept(type)) return true;
                        throw new _util.FormatError(`Unexpected symbol: found ${this.token.type} expected ${type}.`);
                    }
                    parse() {
                        this.nextToken();
                        this.expect(PostScriptTokenTypes.LBRACE);
                        this.parseBlock();
                        this.expect(PostScriptTokenTypes.RBRACE);
                        return this.operators;
                    }
                    parseBlock() {
                        while(true){
                            if (this.accept(PostScriptTokenTypes.NUMBER)) this.operators.push(this.prev.value);
                            else if (this.accept(PostScriptTokenTypes.OPERATOR)) this.operators.push(this.prev.value);
                            else if (this.accept(PostScriptTokenTypes.LBRACE)) this.parseCondition();
                            else return;
                        }
                    }
                    parseCondition() {
                        const conditionLocation = this.operators.length;
                        this.operators.push(null, null);
                        this.parseBlock();
                        this.expect(PostScriptTokenTypes.RBRACE);
                        if (this.accept(PostScriptTokenTypes.IF)) {
                            this.operators[conditionLocation] = this.operators.length;
                            this.operators[conditionLocation + 1] = "jz";
                        } else if (this.accept(PostScriptTokenTypes.LBRACE)) {
                            const jumpLocation = this.operators.length;
                            this.operators.push(null, null);
                            const endOfTrue = this.operators.length;
                            this.parseBlock();
                            this.expect(PostScriptTokenTypes.RBRACE);
                            this.expect(PostScriptTokenTypes.IFELSE);
                            this.operators[jumpLocation] = this.operators.length;
                            this.operators[jumpLocation + 1] = "j";
                            this.operators[conditionLocation] = endOfTrue;
                            this.operators[conditionLocation + 1] = "jz";
                        } else throw new _util.FormatError("PS Function: error parsing conditional.");
                    }
                }
                exports.PostScriptParser = PostScriptParser;
                const PostScriptTokenTypes = {
                    LBRACE: 0,
                    RBRACE: 1,
                    NUMBER: 2,
                    OPERATOR: 3,
                    IF: 4,
                    IFELSE: 5
                };
                class PostScriptToken {
                    static get opCache() {
                        return (0, _util.shadow)(this, "opCache", Object.create(null));
                    }
                    constructor(type, value){
                        this.type = type;
                        this.value = value;
                    }
                    static getOperator(op) {
                        const opValue = PostScriptToken.opCache[op];
                        if (opValue) return opValue;
                        return PostScriptToken.opCache[op] = new PostScriptToken(PostScriptTokenTypes.OPERATOR, op);
                    }
                    static get LBRACE() {
                        return (0, _util.shadow)(this, "LBRACE", new PostScriptToken(PostScriptTokenTypes.LBRACE, "{"));
                    }
                    static get RBRACE() {
                        return (0, _util.shadow)(this, "RBRACE", new PostScriptToken(PostScriptTokenTypes.RBRACE, "}"));
                    }
                    static get IF() {
                        return (0, _util.shadow)(this, "IF", new PostScriptToken(PostScriptTokenTypes.IF, "IF"));
                    }
                    static get IFELSE() {
                        return (0, _util.shadow)(this, "IFELSE", new PostScriptToken(PostScriptTokenTypes.IFELSE, "IFELSE"));
                    }
                }
                class PostScriptLexer {
                    constructor(stream){
                        this.stream = stream;
                        this.nextChar();
                        this.strBuf = [];
                    }
                    nextChar() {
                        return this.currentChar = this.stream.getByte();
                    }
                    getToken() {
                        let comment = false;
                        let ch = this.currentChar;
                        while(true){
                            if (ch < 0) return _primitives.EOF;
                            if (comment) {
                                if (ch === 0x0a || ch === 0x0d) comment = false;
                            } else if (ch === 0x25) comment = true;
                            else if (!(0, _core_utils.isWhiteSpace)(ch)) break;
                            ch = this.nextChar();
                        }
                        switch(ch | 0){
                            case 0x30:
                            case 0x31:
                            case 0x32:
                            case 0x33:
                            case 0x34:
                            case 0x35:
                            case 0x36:
                            case 0x37:
                            case 0x38:
                            case 0x39:
                            case 0x2b:
                            case 0x2d:
                            case 0x2e:
                                return new PostScriptToken(PostScriptTokenTypes.NUMBER, this.getNumber());
                            case 0x7b:
                                this.nextChar();
                                return PostScriptToken.LBRACE;
                            case 0x7d:
                                this.nextChar();
                                return PostScriptToken.RBRACE;
                        }
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        strBuf[0] = String.fromCharCode(ch);
                        while((ch = this.nextChar()) >= 0 && (ch >= 0x41 && ch <= 0x5a || ch >= 0x61 && ch <= 0x7a))strBuf.push(String.fromCharCode(ch));
                        const str = strBuf.join("");
                        switch(str.toLowerCase()){
                            case "if":
                                return PostScriptToken.IF;
                            case "ifelse":
                                return PostScriptToken.IFELSE;
                            default:
                                return PostScriptToken.getOperator(str);
                        }
                    }
                    getNumber() {
                        let ch = this.currentChar;
                        const strBuf = this.strBuf;
                        strBuf.length = 0;
                        strBuf[0] = String.fromCharCode(ch);
                        while((ch = this.nextChar()) >= 0){
                            if (ch >= 0x30 && ch <= 0x39 || ch === 0x2d || ch === 0x2e) strBuf.push(String.fromCharCode(ch));
                            else break;
                        }
                        const value = parseFloat(strBuf.join(""));
                        if (isNaN(value)) throw new _util.FormatError(`Invalid floating point number: ${value}`);
                        return value;
                    }
                }
                exports.PostScriptLexer = PostScriptLexer;
            /***/ },
            /* 52 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LocalTilingPatternCache = exports.LocalImageCache = exports.LocalGStateCache = exports.LocalFunctionCache = exports.LocalColorSpaceCache = exports.GlobalImageCache = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                class BaseLocalCache {
                    constructor(options){
                        if (this.constructor === BaseLocalCache) (0, _util.unreachable)("Cannot initialize BaseLocalCache.");
                        if (!options || !options.onlyRefs) {
                            this._nameRefMap = new Map();
                            this._imageMap = new Map();
                        }
                        this._imageCache = new _primitives.RefSetCache();
                    }
                    getByName(name) {
                        const ref = this._nameRefMap.get(name);
                        if (ref) return this.getByRef(ref);
                        return this._imageMap.get(name) || null;
                    }
                    getByRef(ref) {
                        return this._imageCache.get(ref) || null;
                    }
                    set(name, ref, data) {
                        (0, _util.unreachable)("Abstract method `set` called.");
                    }
                }
                class LocalImageCache extends BaseLocalCache {
                    set(name, ref = null, data) {
                        if (typeof name !== "string") throw new Error('LocalImageCache.set - expected "name" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalImageCache = LocalImageCache;
                class LocalColorSpaceCache extends BaseLocalCache {
                    set(name = null, ref = null, data) {
                        if (typeof name !== "string" && !ref) throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            if (name !== null) this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalColorSpaceCache = LocalColorSpaceCache;
                class LocalFunctionCache extends BaseLocalCache {
                    constructor(options){
                        super({
                            onlyRefs: true
                        });
                    }
                    getByName(name) {
                        (0, _util.unreachable)("Should not call `getByName` method.");
                    }
                    set(name = null, ref, data) {
                        if (!ref) throw new Error('LocalFunctionCache.set - expected "ref" argument.');
                        if (this._imageCache.has(ref)) return;
                        this._imageCache.put(ref, data);
                    }
                }
                exports.LocalFunctionCache = LocalFunctionCache;
                class LocalGStateCache extends BaseLocalCache {
                    set(name, ref = null, data) {
                        if (typeof name !== "string") throw new Error('LocalGStateCache.set - expected "name" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalGStateCache = LocalGStateCache;
                class LocalTilingPatternCache extends BaseLocalCache {
                    set(name, ref = null, data) {
                        if (typeof name !== "string") throw new Error('LocalTilingPatternCache.set - expected "name" argument.');
                        if (ref) {
                            if (this._imageCache.has(ref)) return;
                            this._nameRefMap.set(name, ref);
                            this._imageCache.put(ref, data);
                            return;
                        }
                        if (this._imageMap.has(name)) return;
                        this._imageMap.set(name, data);
                    }
                }
                exports.LocalTilingPatternCache = LocalTilingPatternCache;
                class GlobalImageCache {
                    static get NUM_PAGES_THRESHOLD() {
                        return (0, _util.shadow)(this, "NUM_PAGES_THRESHOLD", 2);
                    }
                    static get MIN_IMAGES_TO_CACHE() {
                        return (0, _util.shadow)(this, "MIN_IMAGES_TO_CACHE", 10);
                    }
                    static get MAX_BYTE_SIZE() {
                        return (0, _util.shadow)(this, "MAX_BYTE_SIZE", 40e6);
                    }
                    constructor(){
                        this._refCache = new _primitives.RefSetCache();
                        this._imageCache = new _primitives.RefSetCache();
                    }
                    get _byteSize() {
                        let byteSize = 0;
                        this._imageCache.forEach((imageData)=>{
                            byteSize += imageData.byteSize;
                        });
                        return byteSize;
                    }
                    get _cacheLimitReached() {
                        if (this._imageCache.size < GlobalImageCache.MIN_IMAGES_TO_CACHE) return false;
                        if (this._byteSize < GlobalImageCache.MAX_BYTE_SIZE) return false;
                        return true;
                    }
                    shouldCache(ref, pageIndex) {
                        const pageIndexSet = this._refCache.get(ref);
                        const numPages = pageIndexSet ? pageIndexSet.size + (pageIndexSet.has(pageIndex) ? 0 : 1) : 1;
                        if (numPages < GlobalImageCache.NUM_PAGES_THRESHOLD) return false;
                        if (!this._imageCache.has(ref) && this._cacheLimitReached) return false;
                        return true;
                    }
                    addPageIndex(ref, pageIndex) {
                        let pageIndexSet = this._refCache.get(ref);
                        if (!pageIndexSet) {
                            pageIndexSet = new Set();
                            this._refCache.put(ref, pageIndexSet);
                        }
                        pageIndexSet.add(pageIndex);
                    }
                    addByteSize(ref, byteSize) {
                        const imageData = this._imageCache.get(ref);
                        if (!imageData) return;
                        if (imageData.byteSize) return;
                        imageData.byteSize = byteSize;
                    }
                    getData(ref, pageIndex) {
                        const pageIndexSet = this._refCache.get(ref);
                        if (!pageIndexSet) return null;
                        if (pageIndexSet.size < GlobalImageCache.NUM_PAGES_THRESHOLD) return null;
                        const imageData = this._imageCache.get(ref);
                        if (!imageData) return null;
                        pageIndexSet.add(pageIndex);
                        return imageData;
                    }
                    setData(ref, data) {
                        if (!this._refCache.has(ref)) throw new Error('GlobalImageCache.setData - expected "addPageIndex" to have been called.');
                        if (this._imageCache.has(ref)) return;
                        if (this._cacheLimitReached) {
                            (0, _util.warn)("GlobalImageCache.setData - cache limit reached.");
                            return;
                        }
                        this._imageCache.put(ref, data);
                    }
                    clear(onlyData = false) {
                        if (!onlyData) this._refCache.clear();
                        this._imageCache.clear();
                    }
                }
                exports.GlobalImageCache = GlobalImageCache;
            /***/ },
            /* 53 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.bidi = bidi;
                var _util = __w_pdfjs_require__(2);
                const baseTypes = [
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "S",
                    "B",
                    "S",
                    "WS",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "B",
                    "B",
                    "S",
                    "WS",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ES",
                    "CS",
                    "ES",
                    "CS",
                    "CS",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "CS",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "B",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "BN",
                    "CS",
                    "ON",
                    "ET",
                    "ET",
                    "ET",
                    "ET",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "BN",
                    "ON",
                    "ON",
                    "ET",
                    "ET",
                    "EN",
                    "EN",
                    "ON",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "EN",
                    "L",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "ON",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L",
                    "L"
                ];
                const arabicTypes = [
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ON",
                    "ON",
                    "AL",
                    "ET",
                    "ET",
                    "AL",
                    "CS",
                    "AL",
                    "ON",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "AN",
                    "ET",
                    "AN",
                    "AN",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AN",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "NSM",
                    "NSM",
                    "ON",
                    "NSM",
                    "NSM",
                    "NSM",
                    "NSM",
                    "AL",
                    "AL",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "EN",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL",
                    "AL"
                ];
                function isOdd(i) {
                    return (i & 1) !== 0;
                }
                function isEven(i) {
                    return (i & 1) === 0;
                }
                function findUnequal(arr, start, value) {
                    let j, jj;
                    for(j = start, jj = arr.length; j < jj; ++j){
                        if (arr[j] !== value) return j;
                    }
                    return j;
                }
                function setValues(arr, start, end, value) {
                    for(let j = start; j < end; ++j)arr[j] = value;
                }
                function reverseValues(arr, start, end) {
                    for(let i = start, j = end - 1; i < j; ++i, --j){
                        const temp = arr[i];
                        arr[i] = arr[j];
                        arr[j] = temp;
                    }
                }
                function createBidiText(str, isLTR, vertical = false) {
                    let dir = "ltr";
                    if (vertical) dir = "ttb";
                    else if (!isLTR) dir = "rtl";
                    return {
                        str: str,
                        dir: dir
                    };
                }
                const chars = [];
                const types = [];
                function bidi(str, startLevel, vertical) {
                    let isLTR = true;
                    const strLength = str.length;
                    if (strLength === 0 || vertical) return createBidiText(str, isLTR, vertical);
                    chars.length = strLength;
                    types.length = strLength;
                    let numBidi = 0;
                    let i, ii;
                    for(i = 0; i < strLength; ++i){
                        chars[i] = str.charAt(i);
                        const charCode = str.charCodeAt(i);
                        let charType = "L";
                        if (charCode <= 0x00ff) charType = baseTypes[charCode];
                        else if (0x0590 <= charCode && charCode <= 0x05f4) charType = "R";
                        else if (0x0600 <= charCode && charCode <= 0x06ff) {
                            charType = arabicTypes[charCode & 0xff];
                            if (!charType) (0, _util.warn)("Bidi: invalid Unicode character " + charCode.toString(16));
                        } else if (0x0700 <= charCode && charCode <= 0x08ac) charType = "AL";
                        if (charType === "R" || charType === "AL" || charType === "AN") numBidi++;
                        types[i] = charType;
                    }
                    if (numBidi === 0) {
                        isLTR = true;
                        return createBidiText(str, isLTR);
                    }
                    if (startLevel === -1) {
                        if (numBidi / strLength < 0.3) {
                            isLTR = true;
                            startLevel = 0;
                        } else {
                            isLTR = false;
                            startLevel = 1;
                        }
                    }
                    const levels = [];
                    for(i = 0; i < strLength; ++i)levels[i] = startLevel;
                    const e = isOdd(startLevel) ? "R" : "L";
                    const sor = e;
                    const eor = sor;
                    let lastType = sor;
                    for(i = 0; i < strLength; ++i)if (types[i] === "NSM") types[i] = lastType;
                    else lastType = types[i];
                    lastType = sor;
                    let t;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "EN") types[i] = lastType === "AL" ? "AN" : "EN";
                        else if (t === "R" || t === "L" || t === "AL") lastType = t;
                    }
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "AL") types[i] = "R";
                    }
                    for(i = 1; i < strLength - 1; ++i){
                        if (types[i] === "ES" && types[i - 1] === "EN" && types[i + 1] === "EN") types[i] = "EN";
                        if (types[i] === "CS" && (types[i - 1] === "EN" || types[i - 1] === "AN") && types[i + 1] === types[i - 1]) types[i] = types[i - 1];
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "EN") {
                        for(let j = i - 1; j >= 0; --j){
                            if (types[j] !== "ET") break;
                            types[j] = "EN";
                        }
                        for(let j = i + 1; j < strLength; ++j){
                            if (types[j] !== "ET") break;
                            types[j] = "EN";
                        }
                    }
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "WS" || t === "ES" || t === "ET" || t === "CS") types[i] = "ON";
                    }
                    lastType = sor;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (t === "EN") types[i] = lastType === "L" ? "L" : "EN";
                        else if (t === "R" || t === "L") lastType = t;
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "ON") {
                        const end = findUnequal(types, i + 1, "ON");
                        let before = sor;
                        if (i > 0) before = types[i - 1];
                        let after = eor;
                        if (end + 1 < strLength) after = types[end + 1];
                        if (before !== "L") before = "R";
                        if (after !== "L") after = "R";
                        if (before === after) setValues(types, i, end, before);
                        i = end - 1;
                    }
                    for(i = 0; i < strLength; ++i)if (types[i] === "ON") types[i] = e;
                    for(i = 0; i < strLength; ++i){
                        t = types[i];
                        if (isEven(levels[i])) {
                            if (t === "R") levels[i] += 1;
                            else if (t === "AN" || t === "EN") levels[i] += 2;
                        } else if (t === "L" || t === "AN" || t === "EN") levels[i] += 1;
                    }
                    let highestLevel = -1;
                    let lowestOddLevel = 99;
                    let level;
                    for(i = 0, ii = levels.length; i < ii; ++i){
                        level = levels[i];
                        if (highestLevel < level) highestLevel = level;
                        if (lowestOddLevel > level && isOdd(level)) lowestOddLevel = level;
                    }
                    for(level = highestLevel; level >= lowestOddLevel; --level){
                        let start = -1;
                        for(i = 0, ii = levels.length; i < ii; ++i){
                            if (levels[i] < level) {
                                if (start >= 0) {
                                    reverseValues(chars, start, i);
                                    start = -1;
                                }
                            } else if (start < 0) start = i;
                        }
                        if (start >= 0) reverseValues(chars, start, levels.length);
                    }
                    for(i = 0, ii = chars.length; i < ii; ++i){
                        const ch = chars[i];
                        if (ch === "<" || ch === ">") chars[i] = "";
                    }
                    return createBidiText(chars.join(""), isLTR);
                }
            /***/ },
            /* 54 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getMetrics = void 0;
                var _core_utils = __w_pdfjs_require__(9);
                const getMetrics = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t.Courier = 600;
                    t["Courier-Bold"] = 600;
                    t["Courier-BoldOblique"] = 600;
                    t["Courier-Oblique"] = 600;
                    t.Helvetica = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 278;
                        t.quotedbl = 355;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 667;
                        t.quoteright = 222;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 556;
                        t.at = 1015;
                        t.A = 667;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 500;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 278;
                        t.backslash = 278;
                        t.bracketright = 278;
                        t.asciicircum = 469;
                        t.underscore = 556;
                        t.quoteleft = 222;
                        t.a = 556;
                        t.b = 556;
                        t.c = 500;
                        t.d = 556;
                        t.e = 556;
                        t.f = 278;
                        t.g = 556;
                        t.h = 556;
                        t.i = 222;
                        t.j = 222;
                        t.k = 500;
                        t.l = 222;
                        t.m = 833;
                        t.n = 556;
                        t.o = 556;
                        t.p = 556;
                        t.q = 556;
                        t.r = 333;
                        t.s = 500;
                        t.t = 278;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 500;
                        t.braceleft = 334;
                        t.bar = 260;
                        t.braceright = 334;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 191;
                        t.quotedblleft = 333;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 537;
                        t.bullet = 350;
                        t.quotesinglbase = 222;
                        t.quotedblbase = 333;
                        t.quotedblright = 333;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 556;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 222;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 556;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 667;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 500;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 500;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 222;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 500;
                        t.scedilla = 500;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 556;
                        t.Amacron = 667;
                        t.rcaron = 333;
                        t.ccedilla = 500;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 643;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 584;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 500;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 260;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 333;
                        t.omacron = 556;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 222;
                        t.tcaron = 317;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 222;
                        t.Oacute = 778;
                        t.oacute = 556;
                        t.amacron = 556;
                        t.sacute = 500;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 556;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 299;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 556;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 556;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 556;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 556;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 556;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 556;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 500;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 584;
                        t.odieresis = 556;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 556;
                        t.eth = 556;
                        t.zcaron = 500;
                        t.ncommaaccent = 556;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 333;
                        t.quotedbl = 474;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 722;
                        t.quoteright = 278;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 611;
                        t.at = 975;
                        t.A = 722;
                        t.B = 722;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 556;
                        t.K = 722;
                        t.L = 611;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 584;
                        t.underscore = 556;
                        t.quoteleft = 278;
                        t.a = 556;
                        t.b = 611;
                        t.c = 556;
                        t.d = 611;
                        t.e = 556;
                        t.f = 333;
                        t.g = 611;
                        t.h = 611;
                        t.i = 278;
                        t.j = 278;
                        t.k = 556;
                        t.l = 278;
                        t.m = 889;
                        t.n = 611;
                        t.o = 611;
                        t.p = 611;
                        t.q = 611;
                        t.r = 389;
                        t.s = 556;
                        t.t = 333;
                        t.u = 611;
                        t.v = 556;
                        t.w = 778;
                        t.x = 556;
                        t.y = 556;
                        t.z = 500;
                        t.braceleft = 389;
                        t.bar = 280;
                        t.braceright = 389;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 238;
                        t.quotedblleft = 500;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 611;
                        t.fl = 611;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 556;
                        t.bullet = 350;
                        t.quotesinglbase = 278;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 611;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 611;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 722;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 556;
                        t.scommaaccent = 556;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 611;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 556;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 556;
                        t.scedilla = 556;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 611;
                        t.acircumflex = 556;
                        t.Amacron = 722;
                        t.rcaron = 389;
                        t.ccedilla = 556;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 743;
                        t.Umacron = 722;
                        t.uring = 611;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 584;
                        t.uacute = 611;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 556;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 556;
                        t.nacute = 611;
                        t.umacron = 611;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 280;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 611;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 389;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 611;
                        t.amacron = 556;
                        t.sacute = 556;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 611;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 611;
                        t.igrave = 278;
                        t.ohungarumlaut = 611;
                        t.Eogonek = 667;
                        t.dcroat = 611;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 400;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 611;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 611;
                        t.ntilde = 611;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 611;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 611;
                        t.Ccaron = 722;
                        t.ugrave = 611;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 611;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 556;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 611;
                        t.tcommaaccent = 333;
                        t.logicalnot = 584;
                        t.odieresis = 611;
                        t.udieresis = 611;
                        t.notequal = 549;
                        t.gcommaaccent = 611;
                        t.eth = 611;
                        t.zcaron = 500;
                        t.ncommaaccent = 611;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-BoldOblique"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 333;
                        t.quotedbl = 474;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 722;
                        t.quoteright = 278;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 611;
                        t.at = 975;
                        t.A = 722;
                        t.B = 722;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 556;
                        t.K = 722;
                        t.L = 611;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 584;
                        t.underscore = 556;
                        t.quoteleft = 278;
                        t.a = 556;
                        t.b = 611;
                        t.c = 556;
                        t.d = 611;
                        t.e = 556;
                        t.f = 333;
                        t.g = 611;
                        t.h = 611;
                        t.i = 278;
                        t.j = 278;
                        t.k = 556;
                        t.l = 278;
                        t.m = 889;
                        t.n = 611;
                        t.o = 611;
                        t.p = 611;
                        t.q = 611;
                        t.r = 389;
                        t.s = 556;
                        t.t = 333;
                        t.u = 611;
                        t.v = 556;
                        t.w = 778;
                        t.x = 556;
                        t.y = 556;
                        t.z = 500;
                        t.braceleft = 389;
                        t.bar = 280;
                        t.braceright = 389;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 238;
                        t.quotedblleft = 500;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 611;
                        t.fl = 611;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 556;
                        t.bullet = 350;
                        t.quotesinglbase = 278;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 611;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 611;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 722;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 556;
                        t.scommaaccent = 556;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 611;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 556;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 556;
                        t.scedilla = 556;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 611;
                        t.acircumflex = 556;
                        t.Amacron = 722;
                        t.rcaron = 389;
                        t.ccedilla = 556;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 743;
                        t.Umacron = 722;
                        t.uring = 611;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 584;
                        t.uacute = 611;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 556;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 556;
                        t.nacute = 611;
                        t.umacron = 611;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 280;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 611;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 389;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 611;
                        t.amacron = 556;
                        t.sacute = 556;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 611;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 611;
                        t.igrave = 278;
                        t.ohungarumlaut = 611;
                        t.Eogonek = 667;
                        t.dcroat = 611;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 400;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 611;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 611;
                        t.ntilde = 611;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 611;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 611;
                        t.Ccaron = 722;
                        t.ugrave = 611;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 611;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 556;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 611;
                        t.tcommaaccent = 333;
                        t.logicalnot = 584;
                        t.odieresis = 611;
                        t.udieresis = 611;
                        t.notequal = 549;
                        t.gcommaaccent = 611;
                        t.eth = 611;
                        t.zcaron = 500;
                        t.ncommaaccent = 611;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t["Helvetica-Oblique"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.exclam = 278;
                        t.quotedbl = 355;
                        t.numbersign = 556;
                        t.dollar = 556;
                        t.percent = 889;
                        t.ampersand = 667;
                        t.quoteright = 222;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 389;
                        t.plus = 584;
                        t.comma = 278;
                        t.hyphen = 333;
                        t.period = 278;
                        t.slash = 278;
                        t.zero = 556;
                        t.one = 556;
                        t.two = 556;
                        t.three = 556;
                        t.four = 556;
                        t.five = 556;
                        t.six = 556;
                        t.seven = 556;
                        t.eight = 556;
                        t.nine = 556;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 584;
                        t.equal = 584;
                        t.greater = 584;
                        t.question = 556;
                        t.at = 1015;
                        t.A = 667;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 722;
                        t.I = 278;
                        t.J = 500;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 722;
                        t.O = 778;
                        t.P = 667;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 667;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 944;
                        t.X = 667;
                        t.Y = 667;
                        t.Z = 611;
                        t.bracketleft = 278;
                        t.backslash = 278;
                        t.bracketright = 278;
                        t.asciicircum = 469;
                        t.underscore = 556;
                        t.quoteleft = 222;
                        t.a = 556;
                        t.b = 556;
                        t.c = 500;
                        t.d = 556;
                        t.e = 556;
                        t.f = 278;
                        t.g = 556;
                        t.h = 556;
                        t.i = 222;
                        t.j = 222;
                        t.k = 500;
                        t.l = 222;
                        t.m = 833;
                        t.n = 556;
                        t.o = 556;
                        t.p = 556;
                        t.q = 556;
                        t.r = 333;
                        t.s = 500;
                        t.t = 278;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 500;
                        t.braceleft = 334;
                        t.bar = 260;
                        t.braceright = 334;
                        t.asciitilde = 584;
                        t.exclamdown = 333;
                        t.cent = 556;
                        t.sterling = 556;
                        t.fraction = 167;
                        t.yen = 556;
                        t.florin = 556;
                        t.section = 556;
                        t.currency = 556;
                        t.quotesingle = 191;
                        t.quotedblleft = 333;
                        t.guillemotleft = 556;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 556;
                        t.dagger = 556;
                        t.daggerdbl = 556;
                        t.periodcentered = 278;
                        t.paragraph = 537;
                        t.bullet = 350;
                        t.quotesinglbase = 222;
                        t.quotedblbase = 333;
                        t.quotedblright = 333;
                        t.guillemotright = 556;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 611;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 370;
                        t.Lslash = 556;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 365;
                        t.ae = 889;
                        t.dotlessi = 278;
                        t.lslash = 222;
                        t.oslash = 611;
                        t.oe = 944;
                        t.germandbls = 611;
                        t.Idieresis = 278;
                        t.eacute = 556;
                        t.abreve = 556;
                        t.uhungarumlaut = 556;
                        t.ecaron = 556;
                        t.Ydieresis = 667;
                        t.divide = 584;
                        t.Yacute = 667;
                        t.Acircumflex = 667;
                        t.aacute = 556;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 500;
                        t.ecircumflex = 556;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 556;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 737;
                        t.Emacron = 667;
                        t.ccaron = 500;
                        t.aring = 556;
                        t.Ncommaaccent = 722;
                        t.lacute = 222;
                        t.agrave = 556;
                        t.Tcommaaccent = 611;
                        t.Cacute = 722;
                        t.atilde = 556;
                        t.Edotaccent = 667;
                        t.scaron = 500;
                        t.scedilla = 500;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 556;
                        t.Amacron = 667;
                        t.rcaron = 333;
                        t.ccedilla = 500;
                        t.Zdotaccent = 611;
                        t.Thorn = 667;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 667;
                        t.dcaron = 643;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 333;
                        t.Ograve = 778;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 584;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 556;
                        t.edieresis = 556;
                        t.cacute = 500;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 278;
                        t.plusminus = 584;
                        t.brokenbar = 260;
                        t.registered = 737;
                        t.Gbreve = 778;
                        t.Idotaccent = 278;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 333;
                        t.omacron = 556;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 222;
                        t.tcaron = 317;
                        t.eogonek = 556;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 556;
                        t.zacute = 500;
                        t.iogonek = 222;
                        t.Oacute = 778;
                        t.oacute = 556;
                        t.amacron = 556;
                        t.sacute = 500;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 333;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 556;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 834;
                        t.Scedilla = 667;
                        t.lcaron = 299;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 1000;
                        t.edotaccent = 556;
                        t.Igrave = 278;
                        t.Imacron = 278;
                        t.Lcaron = 556;
                        t.onehalf = 834;
                        t.lessequal = 549;
                        t.ocircumflex = 556;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 556;
                        t.gbreve = 556;
                        t.onequarter = 834;
                        t.Scaron = 667;
                        t.Scommaaccent = 667;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 556;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 556;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 556;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 778;
                        t.zdotaccent = 500;
                        t.Ecaron = 667;
                        t.Iogonek = 278;
                        t.kcommaaccent = 500;
                        t.minus = 584;
                        t.Icircumflex = 278;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 584;
                        t.odieresis = 556;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 556;
                        t.eth = 556;
                        t.zcaron = 500;
                        t.ncommaaccent = 556;
                        t.onesuperior = 333;
                        t.imacron = 278;
                        t.Euro = 556;
                    });
                    t.Symbol = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.universal = 713;
                        t.numbersign = 500;
                        t.existential = 549;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.suchthat = 439;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asteriskmath = 500;
                        t.plus = 549;
                        t.comma = 250;
                        t.minus = 549;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 549;
                        t.equal = 549;
                        t.greater = 549;
                        t.question = 444;
                        t.congruent = 549;
                        t.Alpha = 722;
                        t.Beta = 667;
                        t.Chi = 722;
                        t.Delta = 612;
                        t.Epsilon = 611;
                        t.Phi = 763;
                        t.Gamma = 603;
                        t.Eta = 722;
                        t.Iota = 333;
                        t.theta1 = 631;
                        t.Kappa = 722;
                        t.Lambda = 686;
                        t.Mu = 889;
                        t.Nu = 722;
                        t.Omicron = 722;
                        t.Pi = 768;
                        t.Theta = 741;
                        t.Rho = 556;
                        t.Sigma = 592;
                        t.Tau = 611;
                        t.Upsilon = 690;
                        t.sigma1 = 439;
                        t.Omega = 768;
                        t.Xi = 645;
                        t.Psi = 795;
                        t.Zeta = 611;
                        t.bracketleft = 333;
                        t.therefore = 863;
                        t.bracketright = 333;
                        t.perpendicular = 658;
                        t.underscore = 500;
                        t.radicalex = 500;
                        t.alpha = 631;
                        t.beta = 549;
                        t.chi = 549;
                        t.delta = 494;
                        t.epsilon = 439;
                        t.phi = 521;
                        t.gamma = 411;
                        t.eta = 603;
                        t.iota = 329;
                        t.phi1 = 603;
                        t.kappa = 549;
                        t.lambda = 549;
                        t.mu = 576;
                        t.nu = 521;
                        t.omicron = 549;
                        t.pi = 549;
                        t.theta = 521;
                        t.rho = 549;
                        t.sigma = 603;
                        t.tau = 439;
                        t.upsilon = 576;
                        t.omega1 = 713;
                        t.omega = 686;
                        t.xi = 493;
                        t.psi = 686;
                        t.zeta = 494;
                        t.braceleft = 480;
                        t.bar = 200;
                        t.braceright = 480;
                        t.similar = 549;
                        t.Euro = 750;
                        t.Upsilon1 = 620;
                        t.minute = 247;
                        t.lessequal = 549;
                        t.fraction = 167;
                        t.infinity = 713;
                        t.florin = 500;
                        t.club = 753;
                        t.diamond = 753;
                        t.heart = 753;
                        t.spade = 753;
                        t.arrowboth = 1042;
                        t.arrowleft = 987;
                        t.arrowup = 603;
                        t.arrowright = 987;
                        t.arrowdown = 603;
                        t.degree = 400;
                        t.plusminus = 549;
                        t.second = 411;
                        t.greaterequal = 549;
                        t.multiply = 549;
                        t.proportional = 713;
                        t.partialdiff = 494;
                        t.bullet = 460;
                        t.divide = 549;
                        t.notequal = 549;
                        t.equivalence = 549;
                        t.approxequal = 549;
                        t.ellipsis = 1000;
                        t.arrowvertex = 603;
                        t.arrowhorizex = 1000;
                        t.carriagereturn = 658;
                        t.aleph = 823;
                        t.Ifraktur = 686;
                        t.Rfraktur = 795;
                        t.weierstrass = 987;
                        t.circlemultiply = 768;
                        t.circleplus = 768;
                        t.emptyset = 823;
                        t.intersection = 768;
                        t.union = 768;
                        t.propersuperset = 713;
                        t.reflexsuperset = 713;
                        t.notsubset = 713;
                        t.propersubset = 713;
                        t.reflexsubset = 713;
                        t.element = 713;
                        t.notelement = 713;
                        t.angle = 768;
                        t.gradient = 713;
                        t.registerserif = 790;
                        t.copyrightserif = 790;
                        t.trademarkserif = 890;
                        t.product = 823;
                        t.radical = 549;
                        t.dotmath = 250;
                        t.logicalnot = 713;
                        t.logicaland = 603;
                        t.logicalor = 603;
                        t.arrowdblboth = 1042;
                        t.arrowdblleft = 987;
                        t.arrowdblup = 603;
                        t.arrowdblright = 987;
                        t.arrowdbldown = 603;
                        t.lozenge = 494;
                        t.angleleft = 329;
                        t.registersans = 790;
                        t.copyrightsans = 790;
                        t.trademarksans = 786;
                        t.summation = 713;
                        t.parenlefttp = 384;
                        t.parenleftex = 384;
                        t.parenleftbt = 384;
                        t.bracketlefttp = 384;
                        t.bracketleftex = 384;
                        t.bracketleftbt = 384;
                        t.bracelefttp = 494;
                        t.braceleftmid = 494;
                        t.braceleftbt = 494;
                        t.braceex = 494;
                        t.angleright = 329;
                        t.integral = 274;
                        t.integraltp = 686;
                        t.integralex = 686;
                        t.integralbt = 686;
                        t.parenrighttp = 384;
                        t.parenrightex = 384;
                        t.parenrightbt = 384;
                        t.bracketrighttp = 384;
                        t.bracketrightex = 384;
                        t.bracketrightbt = 384;
                        t.bracerighttp = 494;
                        t.bracerightmid = 494;
                        t.bracerightbt = 494;
                        t.apple = 790;
                    });
                    t["Times-Roman"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 408;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 564;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 278;
                        t.semicolon = 278;
                        t.less = 564;
                        t.equal = 564;
                        t.greater = 564;
                        t.question = 444;
                        t.at = 921;
                        t.A = 722;
                        t.B = 667;
                        t.C = 667;
                        t.D = 722;
                        t.E = 611;
                        t.F = 556;
                        t.G = 722;
                        t.H = 722;
                        t.I = 333;
                        t.J = 389;
                        t.K = 722;
                        t.L = 611;
                        t.M = 889;
                        t.N = 722;
                        t.O = 722;
                        t.P = 556;
                        t.Q = 722;
                        t.R = 667;
                        t.S = 556;
                        t.T = 611;
                        t.U = 722;
                        t.V = 722;
                        t.W = 944;
                        t.X = 722;
                        t.Y = 722;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 469;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 444;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 500;
                        t.i = 278;
                        t.j = 278;
                        t.k = 500;
                        t.l = 278;
                        t.m = 778;
                        t.n = 500;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 333;
                        t.s = 389;
                        t.t = 278;
                        t.u = 500;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 444;
                        t.braceleft = 480;
                        t.bar = 200;
                        t.braceright = 480;
                        t.asciitilde = 541;
                        t.exclamdown = 333;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 180;
                        t.quotedblleft = 444;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 453;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 444;
                        t.quotedblright = 444;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 444;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 889;
                        t.ordfeminine = 276;
                        t.Lslash = 611;
                        t.Oslash = 722;
                        t.OE = 889;
                        t.ordmasculine = 310;
                        t.ae = 667;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 500;
                        t.Idieresis = 333;
                        t.eacute = 444;
                        t.abreve = 444;
                        t.uhungarumlaut = 500;
                        t.ecaron = 444;
                        t.Ydieresis = 722;
                        t.divide = 564;
                        t.Yacute = 722;
                        t.Acircumflex = 722;
                        t.aacute = 444;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 444;
                        t.Uacute = 722;
                        t.uogonek = 500;
                        t.Edieresis = 611;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 760;
                        t.Emacron = 611;
                        t.ccaron = 444;
                        t.aring = 444;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 444;
                        t.Tcommaaccent = 611;
                        t.Cacute = 667;
                        t.atilde = 444;
                        t.Edotaccent = 611;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 667;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 500;
                        t.acircumflex = 444;
                        t.Amacron = 722;
                        t.rcaron = 333;
                        t.ccedilla = 444;
                        t.Zdotaccent = 611;
                        t.Thorn = 556;
                        t.Omacron = 722;
                        t.Racute = 667;
                        t.Sacute = 556;
                        t.dcaron = 588;
                        t.Umacron = 722;
                        t.uring = 500;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 564;
                        t.uacute = 500;
                        t.Tcaron = 611;
                        t.partialdiff = 476;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 611;
                        t.adieresis = 444;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 500;
                        t.umacron = 500;
                        t.Ncaron = 722;
                        t.Iacute = 333;
                        t.plusminus = 564;
                        t.brokenbar = 200;
                        t.registered = 760;
                        t.Gbreve = 722;
                        t.Idotaccent = 333;
                        t.summation = 600;
                        t.Egrave = 611;
                        t.racute = 333;
                        t.omacron = 500;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 326;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 444;
                        t.zacute = 444;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 444;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 500;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 611;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 344;
                        t.Kcommaaccent = 722;
                        t.Lacute = 611;
                        t.trademark = 980;
                        t.edotaccent = 444;
                        t.Igrave = 333;
                        t.Imacron = 333;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 500;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 611;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 500;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 333;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 667;
                        t.Lcommaaccent = 611;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 722;
                        t.zdotaccent = 444;
                        t.Ecaron = 611;
                        t.Iogonek = 333;
                        t.kcommaaccent = 500;
                        t.minus = 564;
                        t.Icircumflex = 333;
                        t.ncaron = 500;
                        t.tcommaaccent = 278;
                        t.logicalnot = 564;
                        t.odieresis = 500;
                        t.udieresis = 500;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 444;
                        t.ncommaaccent = 500;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-Bold"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 555;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 1000;
                        t.ampersand = 833;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 570;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 570;
                        t.equal = 570;
                        t.greater = 570;
                        t.question = 500;
                        t.at = 930;
                        t.A = 722;
                        t.B = 667;
                        t.C = 722;
                        t.D = 722;
                        t.E = 667;
                        t.F = 611;
                        t.G = 778;
                        t.H = 778;
                        t.I = 389;
                        t.J = 500;
                        t.K = 778;
                        t.L = 667;
                        t.M = 944;
                        t.N = 722;
                        t.O = 778;
                        t.P = 611;
                        t.Q = 778;
                        t.R = 722;
                        t.S = 556;
                        t.T = 667;
                        t.U = 722;
                        t.V = 722;
                        t.W = 1000;
                        t.X = 722;
                        t.Y = 722;
                        t.Z = 667;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 581;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 556;
                        t.c = 444;
                        t.d = 556;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 556;
                        t.i = 278;
                        t.j = 333;
                        t.k = 556;
                        t.l = 278;
                        t.m = 833;
                        t.n = 556;
                        t.o = 500;
                        t.p = 556;
                        t.q = 556;
                        t.r = 444;
                        t.s = 389;
                        t.t = 333;
                        t.u = 556;
                        t.v = 500;
                        t.w = 722;
                        t.x = 500;
                        t.y = 500;
                        t.z = 444;
                        t.braceleft = 394;
                        t.bar = 220;
                        t.braceright = 394;
                        t.asciitilde = 520;
                        t.exclamdown = 333;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 278;
                        t.quotedblleft = 500;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 540;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 1000;
                        t.ordfeminine = 300;
                        t.Lslash = 667;
                        t.Oslash = 778;
                        t.OE = 1000;
                        t.ordmasculine = 330;
                        t.ae = 722;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 556;
                        t.Idieresis = 389;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 556;
                        t.ecaron = 444;
                        t.Ydieresis = 722;
                        t.divide = 570;
                        t.Yacute = 722;
                        t.Acircumflex = 722;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 500;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 747;
                        t.Emacron = 667;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 667;
                        t.Cacute = 722;
                        t.atilde = 500;
                        t.Edotaccent = 667;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 722;
                        t.Gcommaaccent = 778;
                        t.ucircumflex = 556;
                        t.acircumflex = 500;
                        t.Amacron = 722;
                        t.rcaron = 444;
                        t.ccedilla = 444;
                        t.Zdotaccent = 667;
                        t.Thorn = 611;
                        t.Omacron = 778;
                        t.Racute = 722;
                        t.Sacute = 556;
                        t.dcaron = 672;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 300;
                        t.Ograve = 778;
                        t.Agrave = 722;
                        t.Abreve = 722;
                        t.multiply = 570;
                        t.uacute = 556;
                        t.Tcaron = 667;
                        t.partialdiff = 494;
                        t.ydieresis = 500;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 389;
                        t.plusminus = 570;
                        t.brokenbar = 220;
                        t.registered = 747;
                        t.Gbreve = 778;
                        t.Idotaccent = 389;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 444;
                        t.omacron = 500;
                        t.Zacute = 667;
                        t.Zcaron = 667;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 722;
                        t.lcommaaccent = 278;
                        t.tcaron = 416;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 722;
                        t.Adieresis = 722;
                        t.egrave = 444;
                        t.zacute = 444;
                        t.iogonek = 278;
                        t.Oacute = 778;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 778;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 556;
                        t.twosuperior = 300;
                        t.Odieresis = 778;
                        t.mu = 556;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 667;
                        t.dcroat = 556;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 394;
                        t.Kcommaaccent = 778;
                        t.Lacute = 667;
                        t.trademark = 1000;
                        t.edotaccent = 444;
                        t.Igrave = 389;
                        t.Imacron = 389;
                        t.Lcaron = 667;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 778;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 722;
                        t.ugrave = 556;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 444;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 722;
                        t.Lcommaaccent = 667;
                        t.Atilde = 722;
                        t.Aogonek = 722;
                        t.Aring = 722;
                        t.Otilde = 778;
                        t.zdotaccent = 444;
                        t.Ecaron = 667;
                        t.Iogonek = 389;
                        t.kcommaaccent = 556;
                        t.minus = 570;
                        t.Icircumflex = 389;
                        t.ncaron = 556;
                        t.tcommaaccent = 333;
                        t.logicalnot = 570;
                        t.odieresis = 500;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 444;
                        t.ncommaaccent = 556;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-BoldItalic"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 389;
                        t.quotedbl = 555;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 570;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 570;
                        t.equal = 570;
                        t.greater = 570;
                        t.question = 500;
                        t.at = 832;
                        t.A = 667;
                        t.B = 667;
                        t.C = 667;
                        t.D = 722;
                        t.E = 667;
                        t.F = 667;
                        t.G = 722;
                        t.H = 778;
                        t.I = 389;
                        t.J = 500;
                        t.K = 667;
                        t.L = 611;
                        t.M = 889;
                        t.N = 722;
                        t.O = 722;
                        t.P = 611;
                        t.Q = 722;
                        t.R = 667;
                        t.S = 556;
                        t.T = 611;
                        t.U = 722;
                        t.V = 667;
                        t.W = 889;
                        t.X = 667;
                        t.Y = 611;
                        t.Z = 611;
                        t.bracketleft = 333;
                        t.backslash = 278;
                        t.bracketright = 333;
                        t.asciicircum = 570;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 333;
                        t.g = 500;
                        t.h = 556;
                        t.i = 278;
                        t.j = 278;
                        t.k = 500;
                        t.l = 278;
                        t.m = 778;
                        t.n = 556;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 389;
                        t.s = 389;
                        t.t = 278;
                        t.u = 556;
                        t.v = 444;
                        t.w = 667;
                        t.x = 500;
                        t.y = 444;
                        t.z = 389;
                        t.braceleft = 348;
                        t.bar = 220;
                        t.braceright = 348;
                        t.asciitilde = 570;
                        t.exclamdown = 389;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 278;
                        t.quotedblleft = 500;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 556;
                        t.fl = 556;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 500;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 500;
                        t.quotedblright = 500;
                        t.guillemotright = 500;
                        t.ellipsis = 1000;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 1000;
                        t.AE = 944;
                        t.ordfeminine = 266;
                        t.Lslash = 611;
                        t.Oslash = 722;
                        t.OE = 944;
                        t.ordmasculine = 300;
                        t.ae = 722;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 722;
                        t.germandbls = 500;
                        t.Idieresis = 389;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 556;
                        t.ecaron = 444;
                        t.Ydieresis = 611;
                        t.divide = 570;
                        t.Yacute = 611;
                        t.Acircumflex = 667;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 444;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 556;
                        t.Edieresis = 667;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 747;
                        t.Emacron = 667;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 722;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 611;
                        t.Cacute = 667;
                        t.atilde = 500;
                        t.Edotaccent = 667;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 494;
                        t.Rcaron = 667;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 556;
                        t.acircumflex = 500;
                        t.Amacron = 667;
                        t.rcaron = 389;
                        t.ccedilla = 444;
                        t.Zdotaccent = 611;
                        t.Thorn = 611;
                        t.Omacron = 722;
                        t.Racute = 667;
                        t.Sacute = 556;
                        t.dcaron = 608;
                        t.Umacron = 722;
                        t.uring = 556;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 667;
                        t.Abreve = 667;
                        t.multiply = 570;
                        t.uacute = 556;
                        t.Tcaron = 611;
                        t.partialdiff = 494;
                        t.ydieresis = 444;
                        t.Nacute = 722;
                        t.icircumflex = 278;
                        t.Ecircumflex = 667;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 556;
                        t.umacron = 556;
                        t.Ncaron = 722;
                        t.Iacute = 389;
                        t.plusminus = 570;
                        t.brokenbar = 220;
                        t.registered = 747;
                        t.Gbreve = 722;
                        t.Idotaccent = 389;
                        t.summation = 600;
                        t.Egrave = 667;
                        t.racute = 389;
                        t.omacron = 500;
                        t.Zacute = 611;
                        t.Zcaron = 611;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 366;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 667;
                        t.Adieresis = 667;
                        t.egrave = 444;
                        t.zacute = 389;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 576;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 667;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 556;
                        t.lcaron = 382;
                        t.Kcommaaccent = 667;
                        t.Lacute = 611;
                        t.trademark = 1000;
                        t.edotaccent = 444;
                        t.Igrave = 389;
                        t.Imacron = 389;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 556;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 667;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 556;
                        t.Scommaaccent = 556;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 556;
                        t.radical = 549;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 722;
                        t.otilde = 500;
                        t.Rcommaaccent = 667;
                        t.Lcommaaccent = 611;
                        t.Atilde = 667;
                        t.Aogonek = 667;
                        t.Aring = 667;
                        t.Otilde = 722;
                        t.zdotaccent = 389;
                        t.Ecaron = 667;
                        t.Iogonek = 389;
                        t.kcommaaccent = 500;
                        t.minus = 606;
                        t.Icircumflex = 389;
                        t.ncaron = 556;
                        t.tcommaaccent = 278;
                        t.logicalnot = 606;
                        t.odieresis = 500;
                        t.udieresis = 556;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 389;
                        t.ncommaaccent = 556;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t["Times-Italic"] = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 250;
                        t.exclam = 333;
                        t.quotedbl = 420;
                        t.numbersign = 500;
                        t.dollar = 500;
                        t.percent = 833;
                        t.ampersand = 778;
                        t.quoteright = 333;
                        t.parenleft = 333;
                        t.parenright = 333;
                        t.asterisk = 500;
                        t.plus = 675;
                        t.comma = 250;
                        t.hyphen = 333;
                        t.period = 250;
                        t.slash = 278;
                        t.zero = 500;
                        t.one = 500;
                        t.two = 500;
                        t.three = 500;
                        t.four = 500;
                        t.five = 500;
                        t.six = 500;
                        t.seven = 500;
                        t.eight = 500;
                        t.nine = 500;
                        t.colon = 333;
                        t.semicolon = 333;
                        t.less = 675;
                        t.equal = 675;
                        t.greater = 675;
                        t.question = 500;
                        t.at = 920;
                        t.A = 611;
                        t.B = 611;
                        t.C = 667;
                        t.D = 722;
                        t.E = 611;
                        t.F = 611;
                        t.G = 722;
                        t.H = 722;
                        t.I = 333;
                        t.J = 444;
                        t.K = 667;
                        t.L = 556;
                        t.M = 833;
                        t.N = 667;
                        t.O = 722;
                        t.P = 611;
                        t.Q = 722;
                        t.R = 611;
                        t.S = 500;
                        t.T = 556;
                        t.U = 722;
                        t.V = 611;
                        t.W = 833;
                        t.X = 611;
                        t.Y = 556;
                        t.Z = 556;
                        t.bracketleft = 389;
                        t.backslash = 278;
                        t.bracketright = 389;
                        t.asciicircum = 422;
                        t.underscore = 500;
                        t.quoteleft = 333;
                        t.a = 500;
                        t.b = 500;
                        t.c = 444;
                        t.d = 500;
                        t.e = 444;
                        t.f = 278;
                        t.g = 500;
                        t.h = 500;
                        t.i = 278;
                        t.j = 278;
                        t.k = 444;
                        t.l = 278;
                        t.m = 722;
                        t.n = 500;
                        t.o = 500;
                        t.p = 500;
                        t.q = 500;
                        t.r = 389;
                        t.s = 389;
                        t.t = 278;
                        t.u = 500;
                        t.v = 444;
                        t.w = 667;
                        t.x = 444;
                        t.y = 444;
                        t.z = 389;
                        t.braceleft = 400;
                        t.bar = 275;
                        t.braceright = 400;
                        t.asciitilde = 541;
                        t.exclamdown = 389;
                        t.cent = 500;
                        t.sterling = 500;
                        t.fraction = 167;
                        t.yen = 500;
                        t.florin = 500;
                        t.section = 500;
                        t.currency = 500;
                        t.quotesingle = 214;
                        t.quotedblleft = 556;
                        t.guillemotleft = 500;
                        t.guilsinglleft = 333;
                        t.guilsinglright = 333;
                        t.fi = 500;
                        t.fl = 500;
                        t.endash = 500;
                        t.dagger = 500;
                        t.daggerdbl = 500;
                        t.periodcentered = 250;
                        t.paragraph = 523;
                        t.bullet = 350;
                        t.quotesinglbase = 333;
                        t.quotedblbase = 556;
                        t.quotedblright = 556;
                        t.guillemotright = 500;
                        t.ellipsis = 889;
                        t.perthousand = 1000;
                        t.questiondown = 500;
                        t.grave = 333;
                        t.acute = 333;
                        t.circumflex = 333;
                        t.tilde = 333;
                        t.macron = 333;
                        t.breve = 333;
                        t.dotaccent = 333;
                        t.dieresis = 333;
                        t.ring = 333;
                        t.cedilla = 333;
                        t.hungarumlaut = 333;
                        t.ogonek = 333;
                        t.caron = 333;
                        t.emdash = 889;
                        t.AE = 889;
                        t.ordfeminine = 276;
                        t.Lslash = 556;
                        t.Oslash = 722;
                        t.OE = 944;
                        t.ordmasculine = 310;
                        t.ae = 667;
                        t.dotlessi = 278;
                        t.lslash = 278;
                        t.oslash = 500;
                        t.oe = 667;
                        t.germandbls = 500;
                        t.Idieresis = 333;
                        t.eacute = 444;
                        t.abreve = 500;
                        t.uhungarumlaut = 500;
                        t.ecaron = 444;
                        t.Ydieresis = 556;
                        t.divide = 675;
                        t.Yacute = 556;
                        t.Acircumflex = 611;
                        t.aacute = 500;
                        t.Ucircumflex = 722;
                        t.yacute = 444;
                        t.scommaaccent = 389;
                        t.ecircumflex = 444;
                        t.Uring = 722;
                        t.Udieresis = 722;
                        t.aogonek = 500;
                        t.Uacute = 722;
                        t.uogonek = 500;
                        t.Edieresis = 611;
                        t.Dcroat = 722;
                        t.commaaccent = 250;
                        t.copyright = 760;
                        t.Emacron = 611;
                        t.ccaron = 444;
                        t.aring = 500;
                        t.Ncommaaccent = 667;
                        t.lacute = 278;
                        t.agrave = 500;
                        t.Tcommaaccent = 556;
                        t.Cacute = 667;
                        t.atilde = 500;
                        t.Edotaccent = 611;
                        t.scaron = 389;
                        t.scedilla = 389;
                        t.iacute = 278;
                        t.lozenge = 471;
                        t.Rcaron = 611;
                        t.Gcommaaccent = 722;
                        t.ucircumflex = 500;
                        t.acircumflex = 500;
                        t.Amacron = 611;
                        t.rcaron = 389;
                        t.ccedilla = 444;
                        t.Zdotaccent = 556;
                        t.Thorn = 611;
                        t.Omacron = 722;
                        t.Racute = 611;
                        t.Sacute = 500;
                        t.dcaron = 544;
                        t.Umacron = 722;
                        t.uring = 500;
                        t.threesuperior = 300;
                        t.Ograve = 722;
                        t.Agrave = 611;
                        t.Abreve = 611;
                        t.multiply = 675;
                        t.uacute = 500;
                        t.Tcaron = 556;
                        t.partialdiff = 476;
                        t.ydieresis = 444;
                        t.Nacute = 667;
                        t.icircumflex = 278;
                        t.Ecircumflex = 611;
                        t.adieresis = 500;
                        t.edieresis = 444;
                        t.cacute = 444;
                        t.nacute = 500;
                        t.umacron = 500;
                        t.Ncaron = 667;
                        t.Iacute = 333;
                        t.plusminus = 675;
                        t.brokenbar = 275;
                        t.registered = 760;
                        t.Gbreve = 722;
                        t.Idotaccent = 333;
                        t.summation = 600;
                        t.Egrave = 611;
                        t.racute = 389;
                        t.omacron = 500;
                        t.Zacute = 556;
                        t.Zcaron = 556;
                        t.greaterequal = 549;
                        t.Eth = 722;
                        t.Ccedilla = 667;
                        t.lcommaaccent = 278;
                        t.tcaron = 300;
                        t.eogonek = 444;
                        t.Uogonek = 722;
                        t.Aacute = 611;
                        t.Adieresis = 611;
                        t.egrave = 444;
                        t.zacute = 389;
                        t.iogonek = 278;
                        t.Oacute = 722;
                        t.oacute = 500;
                        t.amacron = 500;
                        t.sacute = 389;
                        t.idieresis = 278;
                        t.Ocircumflex = 722;
                        t.Ugrave = 722;
                        t.Delta = 612;
                        t.thorn = 500;
                        t.twosuperior = 300;
                        t.Odieresis = 722;
                        t.mu = 500;
                        t.igrave = 278;
                        t.ohungarumlaut = 500;
                        t.Eogonek = 611;
                        t.dcroat = 500;
                        t.threequarters = 750;
                        t.Scedilla = 500;
                        t.lcaron = 300;
                        t.Kcommaaccent = 667;
                        t.Lacute = 556;
                        t.trademark = 980;
                        t.edotaccent = 444;
                        t.Igrave = 333;
                        t.Imacron = 333;
                        t.Lcaron = 611;
                        t.onehalf = 750;
                        t.lessequal = 549;
                        t.ocircumflex = 500;
                        t.ntilde = 500;
                        t.Uhungarumlaut = 722;
                        t.Eacute = 611;
                        t.emacron = 444;
                        t.gbreve = 500;
                        t.onequarter = 750;
                        t.Scaron = 500;
                        t.Scommaaccent = 500;
                        t.Ohungarumlaut = 722;
                        t.degree = 400;
                        t.ograve = 500;
                        t.Ccaron = 667;
                        t.ugrave = 500;
                        t.radical = 453;
                        t.Dcaron = 722;
                        t.rcommaaccent = 389;
                        t.Ntilde = 667;
                        t.otilde = 500;
                        t.Rcommaaccent = 611;
                        t.Lcommaaccent = 556;
                        t.Atilde = 611;
                        t.Aogonek = 611;
                        t.Aring = 611;
                        t.Otilde = 722;
                        t.zdotaccent = 389;
                        t.Ecaron = 611;
                        t.Iogonek = 333;
                        t.kcommaaccent = 444;
                        t.minus = 675;
                        t.Icircumflex = 333;
                        t.ncaron = 500;
                        t.tcommaaccent = 278;
                        t.logicalnot = 675;
                        t.odieresis = 500;
                        t.udieresis = 500;
                        t.notequal = 549;
                        t.gcommaaccent = 500;
                        t.eth = 500;
                        t.zcaron = 389;
                        t.ncommaaccent = 500;
                        t.onesuperior = 300;
                        t.imacron = 278;
                        t.Euro = 500;
                    });
                    t.ZapfDingbats = (0, _core_utils.getLookupTableFactory)(function(t) {
                        t.space = 278;
                        t.a1 = 974;
                        t.a2 = 961;
                        t.a202 = 974;
                        t.a3 = 980;
                        t.a4 = 719;
                        t.a5 = 789;
                        t.a119 = 790;
                        t.a118 = 791;
                        t.a117 = 690;
                        t.a11 = 960;
                        t.a12 = 939;
                        t.a13 = 549;
                        t.a14 = 855;
                        t.a15 = 911;
                        t.a16 = 933;
                        t.a105 = 911;
                        t.a17 = 945;
                        t.a18 = 974;
                        t.a19 = 755;
                        t.a20 = 846;
                        t.a21 = 762;
                        t.a22 = 761;
                        t.a23 = 571;
                        t.a24 = 677;
                        t.a25 = 763;
                        t.a26 = 760;
                        t.a27 = 759;
                        t.a28 = 754;
                        t.a6 = 494;
                        t.a7 = 552;
                        t.a8 = 537;
                        t.a9 = 577;
                        t.a10 = 692;
                        t.a29 = 786;
                        t.a30 = 788;
                        t.a31 = 788;
                        t.a32 = 790;
                        t.a33 = 793;
                        t.a34 = 794;
                        t.a35 = 816;
                        t.a36 = 823;
                        t.a37 = 789;
                        t.a38 = 841;
                        t.a39 = 823;
                        t.a40 = 833;
                        t.a41 = 816;
                        t.a42 = 831;
                        t.a43 = 923;
                        t.a44 = 744;
                        t.a45 = 723;
                        t.a46 = 749;
                        t.a47 = 790;
                        t.a48 = 792;
                        t.a49 = 695;
                        t.a50 = 776;
                        t.a51 = 768;
                        t.a52 = 792;
                        t.a53 = 759;
                        t.a54 = 707;
                        t.a55 = 708;
                        t.a56 = 682;
                        t.a57 = 701;
                        t.a58 = 826;
                        t.a59 = 815;
                        t.a60 = 789;
                        t.a61 = 789;
                        t.a62 = 707;
                        t.a63 = 687;
                        t.a64 = 696;
                        t.a65 = 689;
                        t.a66 = 786;
                        t.a67 = 787;
                        t.a68 = 713;
                        t.a69 = 791;
                        t.a70 = 785;
                        t.a71 = 791;
                        t.a72 = 873;
                        t.a73 = 761;
                        t.a74 = 762;
                        t.a203 = 762;
                        t.a75 = 759;
                        t.a204 = 759;
                        t.a76 = 892;
                        t.a77 = 892;
                        t.a78 = 788;
                        t.a79 = 784;
                        t.a81 = 438;
                        t.a82 = 138;
                        t.a83 = 277;
                        t.a84 = 415;
                        t.a97 = 392;
                        t.a98 = 392;
                        t.a99 = 668;
                        t.a100 = 668;
                        t.a89 = 390;
                        t.a90 = 390;
                        t.a93 = 317;
                        t.a94 = 317;
                        t.a91 = 276;
                        t.a92 = 276;
                        t.a205 = 509;
                        t.a85 = 509;
                        t.a206 = 410;
                        t.a86 = 410;
                        t.a87 = 234;
                        t.a88 = 234;
                        t.a95 = 334;
                        t.a96 = 334;
                        t.a101 = 732;
                        t.a102 = 544;
                        t.a103 = 544;
                        t.a104 = 910;
                        t.a106 = 667;
                        t.a107 = 760;
                        t.a108 = 760;
                        t.a112 = 776;
                        t.a111 = 595;
                        t.a110 = 694;
                        t.a109 = 626;
                        t.a120 = 788;
                        t.a121 = 788;
                        t.a122 = 788;
                        t.a123 = 788;
                        t.a124 = 788;
                        t.a125 = 788;
                        t.a126 = 788;
                        t.a127 = 788;
                        t.a128 = 788;
                        t.a129 = 788;
                        t.a130 = 788;
                        t.a131 = 788;
                        t.a132 = 788;
                        t.a133 = 788;
                        t.a134 = 788;
                        t.a135 = 788;
                        t.a136 = 788;
                        t.a137 = 788;
                        t.a138 = 788;
                        t.a139 = 788;
                        t.a140 = 788;
                        t.a141 = 788;
                        t.a142 = 788;
                        t.a143 = 788;
                        t.a144 = 788;
                        t.a145 = 788;
                        t.a146 = 788;
                        t.a147 = 788;
                        t.a148 = 788;
                        t.a149 = 788;
                        t.a150 = 788;
                        t.a151 = 788;
                        t.a152 = 788;
                        t.a153 = 788;
                        t.a154 = 788;
                        t.a155 = 788;
                        t.a156 = 788;
                        t.a157 = 788;
                        t.a158 = 788;
                        t.a159 = 788;
                        t.a160 = 894;
                        t.a161 = 838;
                        t.a163 = 1016;
                        t.a164 = 458;
                        t.a196 = 748;
                        t.a165 = 924;
                        t.a192 = 748;
                        t.a166 = 918;
                        t.a167 = 927;
                        t.a168 = 928;
                        t.a169 = 928;
                        t.a170 = 834;
                        t.a171 = 873;
                        t.a172 = 828;
                        t.a173 = 924;
                        t.a162 = 924;
                        t.a174 = 917;
                        t.a175 = 930;
                        t.a176 = 931;
                        t.a177 = 463;
                        t.a178 = 883;
                        t.a179 = 836;
                        t.a193 = 836;
                        t.a180 = 867;
                        t.a199 = 867;
                        t.a181 = 696;
                        t.a200 = 696;
                        t.a182 = 874;
                        t.a201 = 874;
                        t.a183 = 760;
                        t.a184 = 946;
                        t.a197 = 771;
                        t.a185 = 865;
                        t.a194 = 771;
                        t.a198 = 888;
                        t.a186 = 967;
                        t.a195 = 888;
                        t.a187 = 831;
                        t.a188 = 873;
                        t.a189 = 927;
                        t.a190 = 970;
                        t.a191 = 918;
                    });
                });
                exports.getMetrics = getMetrics;
            /***/ },
            /* 55 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getXfaFontName = getXfaFontName;
                exports.getXfaFontWidths = getXfaFontWidths;
                var _calibri_factors = __w_pdfjs_require__(56);
                var _helvetica_factors = __w_pdfjs_require__(57);
                var _liberationsans_widths = __w_pdfjs_require__(58);
                var _myriadpro_factors = __w_pdfjs_require__(59);
                var _segoeui_factors = __w_pdfjs_require__(60);
                var _core_utils = __w_pdfjs_require__(9);
                var _fonts_utils = __w_pdfjs_require__(38);
                const getXFAFontMap = (0, _core_utils.getLookupTableFactory)(function(t) {
                    t["MyriadPro-Regular"] = t["PdfJS-Fallback-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _myriadpro_factors.MyriadProRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        lineHeight: _myriadpro_factors.MyriadProRegularLineHeight
                    };
                    t["MyriadPro-Bold"] = t["PdfJS-Fallback-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _myriadpro_factors.MyriadProBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        lineHeight: _myriadpro_factors.MyriadProBoldLineHeight
                    };
                    t["MyriadPro-It"] = t["MyriadPro-Italic"] = t["PdfJS-Fallback-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _myriadpro_factors.MyriadProItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        lineHeight: _myriadpro_factors.MyriadProItalicLineHeight
                    };
                    t["MyriadPro-BoldIt"] = t["MyriadPro-BoldItalic"] = t["PdfJS-Fallback-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _myriadpro_factors.MyriadProBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        lineHeight: _myriadpro_factors.MyriadProBoldItalicLineHeight
                    };
                    t.ArialMT = t.Arial = t["Arial-Regular"] = {
                        name: "LiberationSans-Regular",
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths
                    };
                    t["Arial-BoldMT"] = t["Arial-Bold"] = {
                        name: "LiberationSans-Bold",
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths
                    };
                    t["Arial-ItalicMT"] = t["Arial-Italic"] = {
                        name: "LiberationSans-Italic",
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths
                    };
                    t["Arial-BoldItalicMT"] = t["Arial-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths
                    };
                    t["Calibri-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _calibri_factors.CalibriRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        lineHeight: _calibri_factors.CalibriRegularLineHeight
                    };
                    t["Calibri-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _calibri_factors.CalibriBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        lineHeight: _calibri_factors.CalibriBoldLineHeight
                    };
                    t["Calibri-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _calibri_factors.CalibriItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        lineHeight: _calibri_factors.CalibriItalicLineHeight
                    };
                    t["Calibri-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _calibri_factors.CalibriBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        lineHeight: _calibri_factors.CalibriBoldItalicLineHeight
                    };
                    t["Segoeui-Regular"] = {
                        name: "LiberationSans-Regular",
                        factors: _segoeui_factors.SegoeuiRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        lineHeight: _segoeui_factors.SegoeuiRegularLineHeight
                    };
                    t["Segoeui-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _segoeui_factors.SegoeuiBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        lineHeight: _segoeui_factors.SegoeuiBoldLineHeight
                    };
                    t["Segoeui-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _segoeui_factors.SegoeuiItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        lineHeight: _segoeui_factors.SegoeuiItalicLineHeight
                    };
                    t["Segoeui-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _segoeui_factors.SegoeuiBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        lineHeight: _segoeui_factors.SegoeuiBoldItalicLineHeight
                    };
                    t["Helvetica-Regular"] = t.Helvetica = {
                        name: "LiberationSans-Regular",
                        factors: _helvetica_factors.HelveticaRegularFactors,
                        baseWidths: _liberationsans_widths.LiberationSansRegularWidths,
                        lineHeight: _helvetica_factors.HelveticaRegularLineHeight
                    };
                    t["Helvetica-Bold"] = {
                        name: "LiberationSans-Bold",
                        factors: _helvetica_factors.HelveticaBoldFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldWidths,
                        lineHeight: _helvetica_factors.HelveticaBoldLineHeight
                    };
                    t["Helvetica-Italic"] = {
                        name: "LiberationSans-Italic",
                        factors: _helvetica_factors.HelveticaItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansItalicWidths,
                        lineHeight: _helvetica_factors.HelveticaItalicLineHeight
                    };
                    t["Helvetica-BoldItalic"] = {
                        name: "LiberationSans-BoldItalic",
                        factors: _helvetica_factors.HelveticaBoldItalicFactors,
                        baseWidths: _liberationsans_widths.LiberationSansBoldItalicWidths,
                        lineHeight: _helvetica_factors.HelveticaBoldItalicLineHeight
                    };
                });
                function getXfaFontName(name) {
                    const fontName = (0, _fonts_utils.normalizeFontName)(name);
                    const fontMap = getXFAFontMap();
                    return fontMap[fontName];
                }
                function getXfaFontWidths(name) {
                    const info = getXfaFontName(name);
                    if (!info) return null;
                    const { baseWidths: baseWidths , factors: factors  } = info;
                    if (!factors) return baseWidths;
                    return baseWidths.map((w, i)=>w * factors[i]);
                }
            /***/ },
            /* 56 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CalibriRegularLineHeight = exports.CalibriRegularFactors = exports.CalibriItalicLineHeight = exports.CalibriItalicFactors = exports.CalibriBoldLineHeight = exports.CalibriBoldItalicLineHeight = exports.CalibriBoldItalicFactors = exports.CalibriBoldFactors = void 0;
                const CalibriBoldFactors = [
                    1.3877,
                    1,
                    0.83908,
                    0.77539,
                    0.77539,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.7762,
                    0.7762,
                    0.73293,
                    0.73293,
                    0.73293,
                    0.73293,
                    0.73293,
                    0.73293,
                    0.82577,
                    0.87289,
                    0.87289,
                    0.88506,
                    0.80367,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.88656,
                    0.73133,
                    0.73133,
                    0.57184,
                    0.87356,
                    0.6965,
                    0.88506,
                    0.91133,
                    0.7514,
                    0.81921,
                    0.68156,
                    0.81921,
                    0.81921,
                    1,
                    0.81921,
                    0.87356,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.91075,
                    0.87356,
                    0.95958,
                    0.76229,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.56289,
                    0.95958,
                    0.59526,
                    0.59526,
                    0.75727,
                    0.75727,
                    1,
                    0.69225,
                    0.69225,
                    0.89019,
                    0.70424,
                    1,
                    0.91926,
                    0.70823,
                    1.04924,
                    1.04924,
                    0.9121,
                    0.9121,
                    0.9121,
                    1,
                    0.9121,
                    0.9121,
                    0.86943,
                    0.87402,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.86943,
                    0.84896,
                    0.81235,
                    0.86943,
                    0.82001,
                    0.87508,
                    0.87508,
                    0.86943,
                    0.79795,
                    0.9762,
                    0.87356,
                    0.99819,
                    0.88198,
                    0.77958,
                    0.77958,
                    0.77958,
                    1,
                    0.79795,
                    0.70864,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.70572,
                    0.8,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.70864,
                    0.70864,
                    0.70864,
                    0.70864,
                    1,
                    0.78275,
                    0.81055,
                    0.81055,
                    0.81055,
                    0.81055,
                    1,
                    0.86943,
                    0.79795,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.77892,
                    0.77892,
                    0.56029,
                    0.90399,
                    0.90399,
                    0.88653,
                    0.96017,
                    0.96017,
                    0.96017,
                    0.96017,
                    0.96017,
                    0.82577,
                    0.7648,
                    0.77892,
                    0.77892,
                    0.77892,
                    0.77892,
                    0.77892,
                    0.78257,
                    0.78257,
                    0.78257,
                    0.78257,
                    0.78257,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.88762,
                    0.90323,
                    1,
                    0.88762,
                    0.8715,
                    0.8715,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.88762,
                    0.96108,
                    0.96108,
                    0.88762,
                    0.97566,
                    0.80352,
                    0.88762,
                    0.90747,
                    0.88762,
                    0.88762,
                    1.31006,
                    1.81055,
                    0.90527,
                    0.90527,
                    1.81055,
                    1.53711,
                    0.94434,
                    0.85284,
                    0.85284,
                    1.2798,
                    0.92138,
                    0.88762,
                    0.8785,
                    1.54657,
                    1.69808,
                    0.8936,
                    1,
                    0.88331,
                    0.88331,
                    0.97507,
                    0.97507,
                    1.15543,
                    1,
                    1.7801,
                    1.42259,
                    0.75241,
                    0.75241,
                    1.20528,
                    1,
                    1,
                    0.75241,
                    0.75241,
                    0.75241,
                    0.75241,
                    0.91056,
                    0.89552,
                    0.78287,
                    0.91027,
                    1.20528,
                    1,
                    1,
                    0.82845,
                    0.92794,
                    1,
                    1,
                    1.13254,
                    0.89552,
                    1,
                    0.8785,
                    0.89552,
                    0.89552,
                    0.83016,
                    0.93125,
                    0.85592,
                    0.87842,
                    1,
                    1.24487,
                    1,
                    1.06303,
                    0.90747,
                    1,
                    1,
                    0.91133,
                    0.70674,
                    0.88401,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.90518,
                    0.91133,
                    1,
                    0.71143,
                    0.90518,
                    0.90527,
                    0.89552,
                    0.8785,
                    0.90518,
                    0.96399,
                    1.01407,
                    0.85284,
                    0.85356,
                    1.23108,
                    0.89049,
                    0.89049,
                    0.8785,
                    0.97801,
                    0.97171,
                    0.97801,
                    0.95015,
                    1,
                    1,
                    1,
                    0.91133,
                    0.88525,
                    1,
                    0.56892,
                    0.91133,
                    1,
                    0.83406,
                    0.77618,
                    0.84021,
                    0.77618,
                    0.77618,
                    1,
                    0.77618,
                    0.90807,
                    0.90176,
                    1,
                    0.85284,
                    0.90747,
                    0.96839,
                    0.96839,
                    1.03372,
                    1.03372,
                    0.8785,
                    0.89608,
                    0.8785,
                    1,
                    1.44947,
                    1.45894,
                    1,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.90167,
                    0.88401,
                    1.17534,
                    1.37077,
                    0.8941,
                    0.8941,
                    0.9716,
                    1,
                    1,
                    1,
                    0.88401,
                    1.02988,
                    1.02988,
                    1.02988,
                    1.02988,
                    0.88401,
                    0.91916,
                    0.91916,
                    0.86304,
                    0.86077,
                    1,
                    0.86304,
                    0.88401,
                    0.88401,
                    0.87445,
                    0.79468,
                    1,
                    0.88175,
                    0.85284,
                    0.90747,
                    1,
                    0.91133,
                    0.85284,
                    0.9297,
                    1.08004,
                    0.94903,
                    1,
                    0.91488,
                    0.70645,
                    1,
                    1,
                    0.85284,
                    1,
                    0.92099,
                    0.85284,
                    1,
                    1,
                    0.8785,
                    0.8785,
                    0.87802,
                    0.8785,
                    1,
                    0.91133,
                    1,
                    0.90747,
                    0.8785,
                    0.84723,
                    0.89552,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.89291,
                    0.94721,
                    0.8801,
                    0.8801,
                    0.8801,
                    0.84971,
                    0.84971,
                    0.8801,
                    0.8801,
                    0.91133,
                    0.83489,
                    0.82845,
                    0.78864,
                    0.99862,
                    1.12401,
                    1.19118,
                    0.69825,
                    0.89049,
                    0.89049,
                    0.8801,
                    0.8785,
                    1.07463,
                    0.93548,
                    0.93548,
                    1.08696,
                    0.81988,
                    0.96134,
                    1.06152,
                    0.84107,
                    0.97747,
                    0.75638,
                    0.85284,
                    0.90747,
                    0.95018,
                    0.97926,
                    0.8785,
                    0.75859,
                    0.75859,
                    0.92482,
                    0.87012,
                    0.87012,
                    0.87012,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.92794,
                    0.98152,
                    0.91343,
                    0.91343,
                    0.90747,
                    0.91343,
                    1,
                    0.68787,
                    0.85284,
                    0.85714,
                    0.98387,
                    1,
                    0.7173,
                    0.7173,
                    0.7173,
                    0.7173,
                    0.7173,
                    1,
                    1,
                    0.89552,
                    0.91133,
                    0.81499,
                    1,
                    1,
                    0.79586,
                    0.78216,
                    0.91133,
                    1.54657,
                    1,
                    1,
                    0.91133,
                    0.77192,
                    1,
                    1.04106,
                    0.87965,
                    1.06452,
                    0.75841,
                    1,
                    1.00813,
                    0.8785,
                    0.91133,
                    0.88525,
                    0.84133,
                    1.33431,
                    1,
                    0.95161,
                    0.72021,
                    1,
                    1,
                    1,
                    1,
                    0.91133,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.8785,
                    0.89552,
                    0.90363,
                    1,
                    1,
                    1.01466,
                    1.0088,
                    1,
                    0.75806,
                    0.81055,
                    1.04106,
                    1,
                    0.82845,
                    0.73133,
                    0.90264,
                    0.90518,
                    0.90548,
                    1,
                    1,
                    1.4956,
                    0.93835,
                    1,
                    1,
                    2.2807,
                    1,
                    1,
                    1,
                    0.90727,
                    0.90727,
                    0.8785,
                    1,
                    0.94211,
                    0.94211,
                    0.94211,
                    0.94211,
                    0.8785,
                    0.8785,
                    0.85075,
                    0.95794,
                    0.95794,
                    0.95794,
                    0.95794,
                    0.95794,
                    0.82616,
                    0.86513,
                    0.85162,
                    0.85162,
                    0.85162,
                    0.85162,
                    0.91133,
                    0.85162,
                    0.79492,
                    0.79492,
                    0.79492,
                    0.79492,
                    0.91133,
                    0.79109
                ];
                exports.CalibriBoldFactors = CalibriBoldFactors;
                const CalibriBoldLineHeight = 1.2207;
                exports.CalibriBoldLineHeight = CalibriBoldLineHeight;
                const CalibriBoldItalicFactors = [
                    1.3877,
                    1,
                    0.83908,
                    0.77539,
                    0.77539,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.83908,
                    0.7762,
                    0.7762,
                    0.71805,
                    0.71805,
                    0.71805,
                    0.71805,
                    0.71805,
                    0.71805,
                    0.82577,
                    0.87289,
                    0.87289,
                    0.88506,
                    0.86036,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.73133,
                    0.88116,
                    0.73133,
                    0.73133,
                    0.57118,
                    0.87356,
                    0.6965,
                    0.88506,
                    0.91133,
                    0.7514,
                    0.81921,
                    0.67174,
                    0.81921,
                    0.81921,
                    1,
                    0.81921,
                    0.87356,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.91075,
                    0.87356,
                    0.95958,
                    0.76467,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.95958,
                    0.56347,
                    0.95958,
                    0.59526,
                    0.59526,
                    0.75727,
                    0.75727,
                    1,
                    0.69225,
                    0.69225,
                    0.89019,
                    0.70424,
                    1,
                    0.91926,
                    0.70823,
                    1.04924,
                    1.04924,
                    0.90872,
                    0.90872,
                    0.90872,
                    1,
                    0.90872,
                    0.90872,
                    0.85938,
                    0.87402,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.85938,
                    0.87179,
                    0.80346,
                    0.85938,
                    0.79179,
                    0.87068,
                    0.87068,
                    0.85938,
                    0.79795,
                    0.97447,
                    0.87891,
                    0.97466,
                    0.87068,
                    0.77958,
                    0.77958,
                    0.77958,
                    1,
                    0.79795,
                    0.69766,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.70572,
                    0.8,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.69766,
                    0.69766,
                    0.69766,
                    0.69766,
                    1,
                    0.7957,
                    0.81055,
                    0.81055,
                    0.81055,
                    0.81055,
                    1,
                    0.86441,
                    0.79795,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.90399,
                    0.77892,
                    0.77892,
                    0.55853,
                    0.90399,
                    0.90399,
                    0.88653,
                    0.96068,
                    0.96068,
                    0.96068,
                    0.96068,
                    0.96068,
                    0.82577,
                    0.74889,
                    0.77892,
                    0.77892,
                    0.77892,
                    0.77892,
                    0.77892,
                    0.78257,
                    0.78257,
                    0.78257,
                    0.78257,
                    0.78257,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.94908,
                    0.90323,
                    1,
                    0.94908,
                    0.85887,
                    0.85887,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94908,
                    0.94252,
                    0.94252,
                    0.94908,
                    0.97566,
                    0.80352,
                    0.94908,
                    0.90747,
                    0.94908,
                    0.94908,
                    1.3107,
                    1.81055,
                    0.90616,
                    0.90527,
                    1.81055,
                    1.53711,
                    0.94434,
                    0.85284,
                    0.85284,
                    1.2798,
                    0.92138,
                    0.94908,
                    0.86411,
                    1.529,
                    1.69808,
                    0.87411,
                    1,
                    0.88331,
                    0.88331,
                    0.97507,
                    0.97507,
                    1.15543,
                    1,
                    1.7801,
                    1.42259,
                    0.74012,
                    0.74012,
                    1.20528,
                    1,
                    1,
                    0.74012,
                    0.74012,
                    0.74012,
                    0.74012,
                    0.91056,
                    0.89552,
                    0.78022,
                    0.91027,
                    1.20528,
                    1,
                    1,
                    0.82845,
                    0.92794,
                    1,
                    1,
                    1.13254,
                    0.89552,
                    1,
                    0.86411,
                    0.89552,
                    0.89552,
                    0.79538,
                    0.92726,
                    0.85592,
                    0.8728,
                    1,
                    1.24487,
                    1,
                    1.48387,
                    0.90747,
                    1,
                    1,
                    0.91133,
                    0.70088,
                    0.88401,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.88323,
                    0.91133,
                    1,
                    0.71094,
                    0.88323,
                    0.90527,
                    0.89552,
                    0.86331,
                    0.88323,
                    0.95612,
                    0.95612,
                    0.85284,
                    0.85356,
                    1.23108,
                    0.8753,
                    0.8753,
                    0.8785,
                    0.97801,
                    0.97171,
                    0.97801,
                    0.95015,
                    1,
                    1,
                    1,
                    0.91133,
                    0.88525,
                    1,
                    0.56892,
                    0.91133,
                    1,
                    0.83406,
                    0.86411,
                    0.84021,
                    0.86411,
                    0.86411,
                    1,
                    0.86411,
                    0.90807,
                    0.90176,
                    1,
                    0.85284,
                    0.90747,
                    0.96839,
                    0.96839,
                    1.03372,
                    1.03372,
                    0.86331,
                    0.8777,
                    0.86331,
                    1,
                    1.44947,
                    1.45894,
                    1,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.88401,
                    0.90167,
                    0.88401,
                    1.17534,
                    1.37077,
                    0.8941,
                    0.8941,
                    0.9716,
                    1,
                    1,
                    1,
                    0.88401,
                    1.02988,
                    1.02988,
                    1.02988,
                    1.02988,
                    0.88401,
                    0.91916,
                    0.91916,
                    0.86304,
                    0.84814,
                    1,
                    0.86304,
                    0.88401,
                    0.88401,
                    0.87445,
                    0.77312,
                    1,
                    0.88175,
                    0.85284,
                    0.90747,
                    1,
                    0.91133,
                    0.85284,
                    0.9297,
                    1.08004,
                    0.94903,
                    1,
                    0.9039,
                    0.70645,
                    1,
                    1,
                    0.85284,
                    1,
                    0.91822,
                    0.85284,
                    1,
                    1,
                    0.86331,
                    0.86331,
                    0.86906,
                    0.86331,
                    1,
                    0.91133,
                    1,
                    0.90747,
                    0.86331,
                    0.84723,
                    0.89552,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86549,
                    0.94721,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86015,
                    0.86015,
                    0.86331,
                    0.86331,
                    0.91133,
                    0.83489,
                    0.82845,
                    0.78864,
                    0.99862,
                    1.19129,
                    1.19118,
                    0.69825,
                    0.89049,
                    0.89049,
                    0.86331,
                    0.86411,
                    1.07463,
                    0.93548,
                    0.93548,
                    1.08696,
                    0.81988,
                    0.96134,
                    1.06152,
                    0.83326,
                    0.99375,
                    0.81344,
                    0.85284,
                    0.90747,
                    0.95018,
                    0.95452,
                    0.86411,
                    0.75859,
                    0.75859,
                    0.92482,
                    0.87012,
                    0.87012,
                    0.87012,
                    0.92794,
                    0.89807,
                    0.92794,
                    0.92794,
                    0.98152,
                    0.90464,
                    0.90464,
                    0.90747,
                    0.90464,
                    1,
                    0.68787,
                    0.85284,
                    0.87581,
                    0.98387,
                    1,
                    0.70852,
                    0.70852,
                    0.70852,
                    0.70852,
                    0.70852,
                    1,
                    1,
                    0.89552,
                    0.91133,
                    0.81499,
                    1,
                    1,
                    0.82046,
                    0.76422,
                    0.91133,
                    1.56239,
                    1,
                    1,
                    0.91133,
                    0.77192,
                    1,
                    1.04106,
                    0.96057,
                    1.06452,
                    0.75841,
                    1,
                    1.02189,
                    0.86411,
                    0.91133,
                    0.88525,
                    0.84133,
                    1.33431,
                    1,
                    0.95161,
                    0.72021,
                    1,
                    1,
                    1,
                    1,
                    0.91133,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.86331,
                    0.89552,
                    0.90363,
                    1,
                    1,
                    1.01466,
                    1.0088,
                    1,
                    0.75806,
                    0.81055,
                    1.04106,
                    1,
                    0.82845,
                    0.73133,
                    0.90631,
                    0.88323,
                    0.85174,
                    1,
                    1,
                    1.4956,
                    0.92972,
                    1,
                    1,
                    2.2807,
                    1,
                    1,
                    1,
                    0.90727,
                    0.90727,
                    0.86331,
                    1,
                    0.92733,
                    0.92733,
                    0.92733,
                    0.92733,
                    0.86331,
                    0.86331,
                    0.84372,
                    0.95794,
                    0.95794,
                    0.95794,
                    0.95794,
                    0.95794,
                    0.82616,
                    0.85668,
                    0.84548,
                    0.84548,
                    0.84548,
                    0.84548,
                    0.91133,
                    0.84548,
                    0.79492,
                    0.79492,
                    0.79492,
                    0.79492,
                    0.91133,
                    0.74081
                ];
                exports.CalibriBoldItalicFactors = CalibriBoldItalicFactors;
                const CalibriBoldItalicLineHeight = 1.2207;
                exports.CalibriBoldItalicLineHeight = CalibriBoldItalicLineHeight;
                const CalibriItalicFactors = [
                    1.3877,
                    1,
                    0.8675,
                    0.76318,
                    0.76318,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.81552,
                    0.81552,
                    0.72346,
                    0.72346,
                    0.72346,
                    0.72346,
                    0.72346,
                    0.72346,
                    0.77818,
                    0.85193,
                    0.85193,
                    0.86477,
                    0.84134,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.86698,
                    0.73206,
                    0.73206,
                    0.6192,
                    0.86275,
                    0.7363,
                    0.86477,
                    0.91133,
                    0.7522,
                    0.81105,
                    0.7286,
                    0.81105,
                    0.81105,
                    1,
                    0.81105,
                    0.86275,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.90872,
                    0.86275,
                    0.90685,
                    0.77896,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.64824,
                    0.90685,
                    0.6377,
                    0.6377,
                    0.77892,
                    0.77892,
                    1,
                    0.75593,
                    0.75593,
                    0.85871,
                    0.76032,
                    1,
                    0.98156,
                    0.77261,
                    1.02638,
                    1.02638,
                    0.89249,
                    0.89249,
                    0.89249,
                    1,
                    0.89249,
                    0.89249,
                    0.84118,
                    0.8667,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.84118,
                    0.87291,
                    0.85696,
                    0.84118,
                    0.82411,
                    0.84557,
                    0.84557,
                    0.84118,
                    0.77452,
                    0.90782,
                    0.85984,
                    0.903,
                    0.85374,
                    0.75186,
                    0.75186,
                    0.75186,
                    1,
                    0.77452,
                    0.67789,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.70572,
                    0.8,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.67789,
                    0.67789,
                    0.67789,
                    0.67789,
                    1,
                    0.76466,
                    0.79776,
                    0.79776,
                    0.79776,
                    0.79776,
                    1,
                    0.84369,
                    0.77452,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.7306,
                    0.7306,
                    0.56321,
                    0.88844,
                    0.88844,
                    0.85066,
                    0.94309,
                    0.94309,
                    0.94309,
                    0.94309,
                    0.94309,
                    0.77818,
                    0.75828,
                    0.7306,
                    0.7306,
                    0.7306,
                    0.7306,
                    0.7306,
                    0.76659,
                    0.76659,
                    0.76659,
                    0.76659,
                    0.76659,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.87683,
                    1,
                    0.9245,
                    0.84843,
                    0.84843,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.9245,
                    0.99058,
                    0.99058,
                    0.9245,
                    1.02269,
                    0.90861,
                    0.9245,
                    0.90747,
                    0.9245,
                    0.9245,
                    1.28809,
                    1.81055,
                    0.90572,
                    0.90749,
                    1.81055,
                    1.55469,
                    0.94434,
                    1.06139,
                    0.85284,
                    1.2798,
                    0.88071,
                    0.9245,
                    0.9245,
                    1.38313,
                    1.77256,
                    0.92393,
                    1,
                    0.94152,
                    0.94152,
                    1.10369,
                    1.10369,
                    1.1437,
                    1,
                    1.91729,
                    1.42259,
                    0.83203,
                    0.83203,
                    1.18622,
                    1,
                    1,
                    0.83203,
                    0.83203,
                    0.83203,
                    0.83203,
                    0.92229,
                    0.89552,
                    0.78086,
                    0.91027,
                    1.18622,
                    1,
                    1,
                    0.96309,
                    0.89807,
                    1,
                    1,
                    1.13254,
                    0.89552,
                    1,
                    0.9245,
                    0.89552,
                    0.89552,
                    0.8875,
                    0.99034,
                    0.84737,
                    0.942,
                    1,
                    1.17889,
                    1,
                    1.48387,
                    0.90747,
                    1,
                    1,
                    0.91133,
                    0.67009,
                    0.82601,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.85865,
                    0.91133,
                    1,
                    0.68994,
                    0.85865,
                    0.90527,
                    0.89552,
                    0.9245,
                    0.85865,
                    1.03667,
                    1.03667,
                    0.85284,
                    0.85284,
                    1.23108,
                    0.94635,
                    0.94635,
                    0.94469,
                    1.17223,
                    1.11523,
                    0.97801,
                    1.09842,
                    1,
                    1,
                    1,
                    0.91133,
                    0.84426,
                    1,
                    0.54873,
                    0.91133,
                    1,
                    0.82616,
                    0.9245,
                    0.8916,
                    0.9245,
                    0.9245,
                    1,
                    0.9245,
                    0.86331,
                    0.8739,
                    1,
                    0.85284,
                    0.90747,
                    0.92098,
                    0.92098,
                    1.0176,
                    1.0176,
                    0.9245,
                    0.93591,
                    0.9245,
                    1,
                    1.44947,
                    1.40909,
                    1,
                    1.03297,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    1.05611,
                    0.82601,
                    1.19658,
                    1.33512,
                    0.8941,
                    0.8941,
                    0.97622,
                    1,
                    1,
                    1,
                    1.03297,
                    1.23516,
                    1.23516,
                    1.23516,
                    1.23516,
                    0.82601,
                    1.07692,
                    1.07692,
                    0.90918,
                    0.90918,
                    1,
                    0.90918,
                    1.03297,
                    1.03297,
                    0.94048,
                    0.9375,
                    1,
                    0.93407,
                    0.85284,
                    0.90747,
                    1,
                    0.91133,
                    0.85284,
                    1.09231,
                    1.0336,
                    1.11429,
                    1,
                    0.94959,
                    0.71353,
                    1,
                    1,
                    0.85284,
                    1,
                    0.98217,
                    0.85284,
                    1,
                    1,
                    0.9245,
                    0.9245,
                    0.92534,
                    0.9245,
                    1,
                    0.91133,
                    1,
                    0.90747,
                    0.9245,
                    0.89746,
                    0.89552,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.86291,
                    0.93695,
                    0.92274,
                    0.92274,
                    0.92274,
                    0.89404,
                    0.89404,
                    0.92274,
                    0.92274,
                    0.91133,
                    0.79801,
                    0.80504,
                    0.76288,
                    0.99862,
                    1.16359,
                    1.15642,
                    0.69825,
                    0.86651,
                    0.86651,
                    0.92274,
                    0.9245,
                    1.09091,
                    0.91056,
                    0.91056,
                    1.07806,
                    0.80395,
                    0.90861,
                    1.03809,
                    0.83437,
                    1.00225,
                    0.82507,
                    0.85284,
                    0.90747,
                    0.97094,
                    0.97248,
                    0.9245,
                    0.83319,
                    0.75859,
                    1.1293,
                    1.2566,
                    1.2566,
                    1.2566,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.15601,
                    1.02933,
                    1.02933,
                    0.90747,
                    1.02933,
                    1,
                    0.68787,
                    0.85284,
                    0.88832,
                    0.96334,
                    1,
                    0.77832,
                    0.77832,
                    0.77832,
                    0.77832,
                    0.77832,
                    1,
                    1,
                    0.89552,
                    0.91133,
                    0.774,
                    1,
                    1,
                    0.88178,
                    0.84438,
                    0.91133,
                    1.39543,
                    1,
                    1,
                    0.91133,
                    0.7589,
                    1,
                    1.20562,
                    1.03525,
                    1.23023,
                    0.97655,
                    1,
                    1.0297,
                    0.9245,
                    0.91133,
                    0.84426,
                    0.80972,
                    1.35191,
                    1,
                    0.95161,
                    0.70508,
                    1,
                    1,
                    1,
                    1,
                    0.91133,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.9245,
                    0.89552,
                    0.90186,
                    1,
                    1,
                    1.0088,
                    1.0044,
                    1,
                    0.739,
                    0.79776,
                    1.20562,
                    1,
                    0.96309,
                    0.73206,
                    0.89693,
                    0.85865,
                    0.90933,
                    1,
                    1,
                    1.4956,
                    0.97858,
                    1,
                    1,
                    2.01462,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    0.9245,
                    1,
                    0.9849,
                    0.9849,
                    0.9849,
                    0.9849,
                    0.9245,
                    0.9245,
                    0.8916,
                    0.98986,
                    0.98986,
                    0.98986,
                    0.98986,
                    0.98986,
                    0.86621,
                    0.84153,
                    0.89453,
                    0.89453,
                    0.89453,
                    0.89453,
                    0.91133,
                    0.89453,
                    0.79004,
                    0.79004,
                    0.79004,
                    0.79004,
                    0.91133,
                    0.75026
                ];
                exports.CalibriItalicFactors = CalibriItalicFactors;
                const CalibriItalicLineHeight = 1.2207;
                exports.CalibriItalicLineHeight = CalibriItalicLineHeight;
                const CalibriRegularFactors = [
                    1.3877,
                    1,
                    0.8675,
                    0.76318,
                    0.76318,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.86686,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.8675,
                    0.81552,
                    0.81552,
                    0.73834,
                    0.73834,
                    0.73834,
                    0.73834,
                    0.73834,
                    0.73834,
                    0.77818,
                    0.85193,
                    0.85193,
                    0.86477,
                    0.84503,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.73206,
                    0.86901,
                    0.73206,
                    0.73206,
                    0.62267,
                    0.86275,
                    0.74359,
                    0.86477,
                    0.91133,
                    0.7522,
                    0.81105,
                    0.75443,
                    0.81105,
                    0.81105,
                    1,
                    0.81105,
                    0.86275,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.90872,
                    0.86275,
                    0.90685,
                    0.77741,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.90685,
                    0.65649,
                    0.90685,
                    0.6377,
                    0.6377,
                    0.77892,
                    0.77892,
                    1,
                    0.75593,
                    0.75593,
                    0.85746,
                    0.76032,
                    1,
                    0.98156,
                    0.77261,
                    1.02638,
                    1.02638,
                    0.89385,
                    0.89385,
                    0.89385,
                    1,
                    0.89385,
                    0.89385,
                    0.85122,
                    0.8667,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.85122,
                    0.88831,
                    0.88254,
                    0.85122,
                    0.85498,
                    0.85311,
                    0.85311,
                    0.85122,
                    0.77452,
                    0.95165,
                    0.86275,
                    0.89772,
                    0.86503,
                    0.75186,
                    0.75186,
                    0.75186,
                    1,
                    0.77452,
                    0.68887,
                    0.70572,
                    0.70572,
                    0.70572,
                    0.70572,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.70572,
                    0.8,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.68887,
                    0.68887,
                    0.68887,
                    0.68887,
                    1,
                    0.74171,
                    0.79776,
                    0.79776,
                    0.79776,
                    0.79776,
                    1,
                    0.85122,
                    0.77452,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.88844,
                    0.7306,
                    0.7306,
                    0.56963,
                    0.88844,
                    0.88844,
                    0.85066,
                    0.94258,
                    0.94258,
                    0.94258,
                    0.94258,
                    0.94258,
                    0.77818,
                    0.75657,
                    0.7306,
                    0.7306,
                    0.7306,
                    0.7306,
                    0.7306,
                    0.76659,
                    0.76659,
                    0.76659,
                    0.76659,
                    0.76659,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.86128,
                    0.87683,
                    0.86128,
                    0.8693,
                    0.8693,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.86128,
                    0.98142,
                    0.98142,
                    0.86128,
                    1.02269,
                    0.90861,
                    0.86128,
                    0.90747,
                    0.86128,
                    0.86128,
                    1.28809,
                    1.81055,
                    0.90527,
                    0.90527,
                    1.81055,
                    1.55469,
                    0.94434,
                    1.06139,
                    0.85284,
                    1.2798,
                    0.88071,
                    0.86128,
                    0.94469,
                    1.39016,
                    1.77256,
                    0.9236,
                    1,
                    0.94152,
                    0.94152,
                    1.10369,
                    1.10369,
                    1.1437,
                    1.91729,
                    1.42259,
                    0.8457,
                    0.8457,
                    1.18622,
                    0.8457,
                    0.8457,
                    0.8457,
                    0.8457,
                    0.92229,
                    0.89552,
                    0.81209,
                    0.91027,
                    1.18622,
                    1,
                    0.96309,
                    0.89807,
                    1.13254,
                    0.89552,
                    0.94469,
                    0.89552,
                    0.89552,
                    0.92454,
                    0.9921,
                    0.84737,
                    0.94035,
                    1,
                    1.17889,
                    1.48387,
                    0.90747,
                    1,
                    1,
                    0.91133,
                    0.67742,
                    0.82601,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.89464,
                    0.91133,
                    0.69043,
                    0.89464,
                    0.90527,
                    0.89552,
                    0.94469,
                    0.89464,
                    1.02191,
                    1.02191,
                    0.85284,
                    0.85356,
                    1.23108,
                    0.96576,
                    0.96576,
                    0.94469,
                    1.17223,
                    1.11523,
                    0.97801,
                    1.09842,
                    1,
                    1,
                    1,
                    0.91133,
                    0.84426,
                    0.54873,
                    0.91133,
                    0.82616,
                    0.84636,
                    0.89258,
                    0.84636,
                    0.84636,
                    1,
                    0.84636,
                    0.86331,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.8739,
                    0.85284,
                    0.90747,
                    0.92098,
                    0.92098,
                    1.0176,
                    1.0176,
                    0.94469,
                    0.95786,
                    0.94469,
                    1,
                    1.44947,
                    1.40909,
                    1.03297,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    0.82601,
                    1.05611,
                    0.82601,
                    1.19658,
                    1.33512,
                    0.8941,
                    0.8941,
                    0.97622,
                    1,
                    1,
                    1,
                    1.03297,
                    1.23516,
                    1.23516,
                    1.23516,
                    1.23516,
                    0.82601,
                    1.07692,
                    1.07692,
                    0.90918,
                    0.90918,
                    1,
                    0.90918,
                    1.03297,
                    1.03297,
                    0.92578,
                    0.90452,
                    1,
                    1.11842,
                    0.85284,
                    0.90747,
                    1,
                    0.91133,
                    0.85284,
                    1.09231,
                    1.0336,
                    1.11429,
                    1,
                    0.95897,
                    0.71353,
                    1,
                    1,
                    0.85284,
                    1,
                    0.95424,
                    0.85284,
                    1,
                    1,
                    0.94469,
                    0.94469,
                    0.95877,
                    0.94469,
                    1,
                    0.91133,
                    1,
                    0.90747,
                    0.94469,
                    0.89746,
                    0.89552,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.90016,
                    0.93695,
                    0.9482,
                    0.9482,
                    0.9482,
                    0.89181,
                    0.89181,
                    0.9482,
                    0.9482,
                    0.91133,
                    0.79801,
                    0.80504,
                    0.76288,
                    0.99862,
                    1.08707,
                    1.15642,
                    0.69825,
                    0.86651,
                    0.86651,
                    0.9482,
                    0.94469,
                    1.09091,
                    0.91056,
                    0.91056,
                    1.07806,
                    0.80395,
                    0.90861,
                    1.03809,
                    0.84286,
                    1.00452,
                    0.80113,
                    0.85284,
                    0.90747,
                    0.97094,
                    0.99247,
                    0.94469,
                    0.83319,
                    0.75859,
                    1.1293,
                    1.2566,
                    1.2566,
                    1.2566,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.12308,
                    1.15601,
                    1.04692,
                    1.04692,
                    0.90747,
                    1.04692,
                    1,
                    0.68787,
                    0.85284,
                    0.89442,
                    0.96334,
                    1,
                    0.78223,
                    0.78223,
                    0.78223,
                    0.78223,
                    0.78223,
                    1,
                    1,
                    0.89552,
                    0.91133,
                    0.774,
                    1,
                    0.86155,
                    0.85208,
                    0.91133,
                    1.39016,
                    1,
                    1,
                    0.91133,
                    0.7589,
                    1,
                    1.20562,
                    0.98022,
                    1.23023,
                    0.92188,
                    1,
                    0.9561,
                    0.94469,
                    0.91133,
                    0.84426,
                    0.80972,
                    1.35191,
                    0.95161,
                    0.70508,
                    1,
                    1,
                    1,
                    1,
                    0.91133,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.94469,
                    0.89552,
                    0.90186,
                    1,
                    1,
                    1.0088,
                    1.0044,
                    1,
                    0.739,
                    0.79776,
                    1.20562,
                    1,
                    0.96309,
                    0.73206,
                    0.88844,
                    0.89464,
                    0.96766,
                    1,
                    1,
                    1.4956,
                    1.07185,
                    0.99413,
                    0.96334,
                    1.08065,
                    0.99331,
                    1,
                    1,
                    2.01462,
                    1,
                    1,
                    1,
                    1,
                    1.05859,
                    1.05859,
                    0.94469,
                    1,
                    0.99018,
                    0.99018,
                    0.99018,
                    0.99018,
                    0.94469,
                    0.94469,
                    0.90332,
                    0.98986,
                    0.98986,
                    0.98986,
                    0.98986,
                    0.98986,
                    0.86621,
                    0.83969,
                    0.90527,
                    0.90527,
                    0.90527,
                    0.90527,
                    0.91133,
                    0.90527,
                    0.79004,
                    0.79004,
                    0.79004,
                    0.79004,
                    0.91133,
                    0.78848
                ];
                exports.CalibriRegularFactors = CalibriRegularFactors;
                const CalibriRegularLineHeight = 1.2207;
                exports.CalibriRegularLineHeight = CalibriRegularLineHeight;
            /***/ },
            /* 57 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.HelveticaRegularLineHeight = exports.HelveticaRegularFactors = exports.HelveticaItalicLineHeight = exports.HelveticaItalicFactors = exports.HelveticaBoldLineHeight = exports.HelveticaBoldItalicLineHeight = exports.HelveticaBoldItalicFactors = exports.HelveticaBoldFactors = void 0;
                const HelveticaBoldFactors = [
                    0.76116,
                    1,
                    0.99977,
                    1,
                    1,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.85148,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.9998,
                    1.00001,
                    1.00001,
                    0.99997,
                    0.99977,
                    1.00026,
                    0.99977,
                    0.99973,
                    1.00026,
                    1.00022,
                    0.99988,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    0.99977,
                    0.99999,
                    0.99861,
                    0.99861,
                    1,
                    0.99977,
                    0.99977,
                    1.0006,
                    1.00042,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00078,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00026,
                    1.00026,
                    1.00001,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99999,
                    0.99999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00022,
                    1,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1,
                    1.00013,
                    1.00022,
                    1.00036,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00001,
                    1.00024,
                    0.99977,
                    0.9999,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99984,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00022,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    0.99973,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00001,
                    1.00069,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    0.99973,
                    0.99982,
                    0.99982,
                    1,
                    0.99977,
                    1.00035,
                    0.99977,
                    1.00019,
                    0.99944,
                    1.00001,
                    1.00008,
                    1.00021,
                    0.99926,
                    1.00035,
                    1.00035,
                    0.99942,
                    1.00048,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99989,
                    1.00057,
                    1.00001,
                    0.99936,
                    1.00052,
                    1.00012,
                    0.99996,
                    1.00043,
                    1,
                    1.00035,
                    0.9994,
                    0.99976,
                    1.00035,
                    1.00038,
                    0.99971,
                    1.00019,
                    0.9994,
                    1.00001,
                    1.0006,
                    1.00044,
                    0.99973,
                    1.00023,
                    1.00047,
                    1,
                    0.99942,
                    0.99989,
                    0.99973,
                    1.00052,
                    1.00041,
                    1.00119,
                    1.00037,
                    0.99973,
                    0.99973,
                    1.00002,
                    0.99986,
                    1.00041,
                    1.00041,
                    0.99902,
                    0.9996,
                    1.00034,
                    0.99999,
                    1.00026,
                    0.99999,
                    1.00026,
                    0.99973,
                    1.00052,
                    0.99973,
                    1,
                    0.99973,
                    1.00041,
                    1.00075,
                    0.9994,
                    1.0003,
                    0.99999,
                    1,
                    1.00041,
                    0.99955,
                    1,
                    0.99915,
                    1.0005,
                    1.00026,
                    1.00119,
                    0.99955,
                    0.99973,
                    1.0006,
                    0.99911,
                    1.0006,
                    1.00026,
                    0.99972,
                    1.00026,
                    0.99902,
                    0.99973,
                    1.00035,
                    1,
                    0.99999,
                    1,
                    0.99971,
                    1.00047,
                    1.00023,
                    0.99973,
                    1.00041,
                    1.00041,
                    0.99973,
                    0.99977,
                    1,
                    0.99973,
                    1.00031,
                    0.99973,
                    0.99973,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.00003,
                    1.00003,
                    0.99959,
                    0.9999,
                    0.99973,
                    1.00026,
                    1.0006,
                    1.00077,
                    0.99942,
                    1.41144,
                    0.99959,
                    0.99959,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1.00077,
                    0.99972,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00055,
                    0.99999,
                    0.99998,
                    1,
                    0.99962,
                    0.99998,
                    1.0006,
                    1,
                    1,
                    1.00025,
                    0.99973,
                    1,
                    1.00026,
                    0.99973,
                    0.99973,
                    1.03374,
                    1.00026,
                    1.00024,
                    0.99927,
                    0.9995,
                    0.99998,
                    1,
                    1.00034,
                    1.06409,
                    1.36625,
                    1.41144,
                    0.99973,
                    0.99998,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    0.99973,
                    1,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00082,
                    0.99962,
                    1.00003,
                    0.99915,
                    0.99984,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99998,
                    0.99999,
                    0.99998,
                    0.99998,
                    1,
                    0.99999,
                    1,
                    0.99973,
                    1.00002,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99998,
                    1,
                    1.00003,
                    1.00031,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00042,
                    0.99999,
                    0.99998,
                    1,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.0006,
                    1.00015,
                    1.00027,
                    0.99999,
                    0.99999,
                    0.99561,
                    0.99999,
                    0.99999,
                    0.99977,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.00069,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.03828,
                    1.0006,
                    0.99999,
                    1.00003,
                    1.00031,
                    1.41144,
                    0.99973,
                    1.00003,
                    1.0006,
                    0.99972,
                    1.0006,
                    1.40579,
                    0.99982,
                    0.60299,
                    1,
                    1,
                    1.00003,
                    1.00106,
                    0.99867,
                    1.00003,
                    1,
                    1,
                    1.00026,
                    1.00026,
                    0.9993,
                    1.00026,
                    1.00026,
                    0.99973,
                    1,
                    1.00031,
                    1.00026,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00016,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00032,
                    1.00032,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.40483,
                    0.99968,
                    0.99936,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99998,
                    0.99998,
                    0.99972,
                    0.99982,
                    1.0006,
                    1,
                    1.00023,
                    0.99954,
                    1.00049,
                    1.00003,
                    1.06409,
                    1.20985,
                    0.99945,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99974,
                    1,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00087,
                    0.99959,
                    0.99959,
                    1.00031,
                    0.99959,
                    0.99959,
                    1.00025,
                    1.00003,
                    1.00056,
                    0.99998,
                    1.41144,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99999,
                    0.99973,
                    0.99973,
                    1.00002,
                    0.99998,
                    1.40579,
                    0.99988,
                    1,
                    0.99973,
                    1.0006,
                    1,
                    0.99953,
                    0.99973,
                    1.39713,
                    1.00054,
                    0.99998,
                    0.99935,
                    0.99998,
                    0.8121,
                    0.99998,
                    1.00087,
                    1.00026,
                    0.99973,
                    1.00002,
                    1.00002,
                    0.99998,
                    1,
                    0.99998,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99955,
                    1.0006,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1.00026,
                    0.99998,
                    0.99998,
                    1,
                    1.00001,
                    0.99561,
                    0.99973,
                    1.00041,
                    1,
                    1,
                    0.99998,
                    1,
                    0.99991,
                    1,
                    1.66475,
                    1.0006,
                    1,
                    1,
                    1,
                    1,
                    1.00026,
                    1.41144,
                    0.99995,
                    0.99995,
                    0.99995,
                    0.99995,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    0.99973,
                    0.9993,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    0.99902
                ];
                exports.HelveticaBoldFactors = HelveticaBoldFactors;
                const HelveticaBoldLineHeight = 1.2;
                exports.HelveticaBoldLineHeight = HelveticaBoldLineHeight;
                const HelveticaBoldItalicFactors = [
                    0.76116,
                    1,
                    0.99977,
                    1,
                    1,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.91155,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.9998,
                    1.00001,
                    1.00001,
                    1,
                    0.99977,
                    1.00026,
                    0.99977,
                    0.99973,
                    1.00026,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    0.99977,
                    0.99999,
                    0.99861,
                    0.99861,
                    1,
                    0.99977,
                    0.99977,
                    1.0006,
                    0.99971,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99969,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00026,
                    1.00026,
                    1.00001,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99999,
                    0.99999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00022,
                    1,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1,
                    0.9998,
                    1.00022,
                    0.99972,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00001,
                    0.99968,
                    1.00032,
                    1.00047,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99944,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00022,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    0.99981,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00001,
                    0.99966,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    0.99973,
                    0.99982,
                    0.99982,
                    1,
                    0.99977,
                    0.99999,
                    0.99977,
                    1.00038,
                    0.99977,
                    1.00001,
                    1.00001,
                    0.99973,
                    1.00066,
                    0.99967,
                    0.99967,
                    1.00041,
                    0.99998,
                    0.99999,
                    0.99977,
                    1.00022,
                    0.99967,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99964,
                    1.00031,
                    1.00001,
                    0.99999,
                    0.99999,
                    1,
                    1.00023,
                    1,
                    1,
                    0.99999,
                    1.00035,
                    1.00001,
                    0.99999,
                    0.99966,
                    1.00029,
                    1.00038,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    0.99973,
                    0.99978,
                    1.00001,
                    1.00057,
                    0.99989,
                    0.99964,
                    0.99973,
                    0.99977,
                    0.99999,
                    1.00058,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99955,
                    0.9995,
                    1.00026,
                    1.00026,
                    1.00032,
                    0.99989,
                    1.00034,
                    0.99999,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.45998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00001,
                    0.99999,
                    0.99982,
                    0.99994,
                    0.99996,
                    1,
                    1.00042,
                    1.00044,
                    1.00029,
                    1.00023,
                    1.00044,
                    1.00026,
                    0.99949,
                    1.00002,
                    0.99973,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99975,
                    1.00026,
                    1.00026,
                    1.00032,
                    0.99973,
                    0.99967,
                    1,
                    1.00026,
                    1,
                    0.99971,
                    0.99978,
                    1,
                    0.99973,
                    0.99981,
                    0.99981,
                    0.99973,
                    0.99977,
                    1,
                    0.99973,
                    1.00031,
                    0.99973,
                    0.99973,
                    1.00049,
                    1,
                    1.00098,
                    1,
                    1,
                    1,
                    1,
                    1.00003,
                    1.00003,
                    0.99959,
                    0.9999,
                    0.99973,
                    1.00026,
                    1.0006,
                    1.00077,
                    1.00064,
                    1.41144,
                    0.99959,
                    0.99959,
                    0.99998,
                    0.99998,
                    0.99998,
                    1,
                    1.00077,
                    0.99972,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00063,
                    0.99999,
                    0.99998,
                    1,
                    0.99962,
                    0.99998,
                    1.0006,
                    1,
                    1,
                    1.00025,
                    0.99973,
                    1,
                    1.00026,
                    0.99973,
                    0.99973,
                    1.0044,
                    1.00026,
                    1.00024,
                    0.99942,
                    0.9995,
                    0.99998,
                    1,
                    0.99998,
                    1.06409,
                    1.36625,
                    1.41144,
                    0.99973,
                    0.99998,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    0.99973,
                    1,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00101,
                    1.00101,
                    1.00003,
                    0.99915,
                    0.99984,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99998,
                    0.99999,
                    0.99998,
                    0.99998,
                    1,
                    0.99999,
                    1,
                    0.99973,
                    1.00002,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99973,
                    1.00026,
                    0.99973,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99998,
                    1,
                    1.00003,
                    1.00031,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00042,
                    0.99999,
                    0.99998,
                    1,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.0006,
                    1.00015,
                    1.00027,
                    0.99999,
                    0.99999,
                    0.99561,
                    0.99999,
                    0.99999,
                    0.99977,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.00014,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0006,
                    0.99973,
                    1.01011,
                    1.0006,
                    0.99999,
                    1.00003,
                    1.00031,
                    1.41144,
                    0.99973,
                    1.00003,
                    1.0006,
                    0.99972,
                    1.0006,
                    1.40579,
                    0.99982,
                    0.60299,
                    1,
                    1,
                    1.00003,
                    1.00106,
                    1.01322,
                    1.00003,
                    1,
                    1,
                    1.00026,
                    1.00026,
                    0.9993,
                    1.00026,
                    1.00026,
                    0.99973,
                    1,
                    1.00031,
                    1.00026,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00016,
                    0.99998,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99943,
                    0.99943,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.40483,
                    0.99968,
                    0.99936,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99998,
                    0.99998,
                    0.99972,
                    0.99982,
                    1.0006,
                    1,
                    1,
                    1.00055,
                    1.00012,
                    1.00003,
                    1.06409,
                    1.20985,
                    1.00007,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99974,
                    1,
                    1,
                    1,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00087,
                    0.99959,
                    0.99959,
                    1.00031,
                    0.99959,
                    0.99959,
                    1.00025,
                    1.00003,
                    0.99923,
                    0.99998,
                    1.41144,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99999,
                    0.99973,
                    0.99973,
                    1.00002,
                    0.99998,
                    1.40579,
                    1.00064,
                    1,
                    0.99973,
                    1.0006,
                    1,
                    0.99953,
                    0.99973,
                    1.39713,
                    1.00054,
                    0.99998,
                    1.00076,
                    0.99998,
                    0.8121,
                    0.99998,
                    1.00069,
                    1.00026,
                    0.99973,
                    1.00002,
                    1.00002,
                    0.99998,
                    1,
                    0.99998,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99955,
                    1.0006,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1.00026,
                    0.99998,
                    0.99998,
                    1,
                    1.00001,
                    0.99967,
                    0.99973,
                    0.98685,
                    1,
                    1,
                    0.99998,
                    1,
                    0.99991,
                    1,
                    1.66475,
                    1.0006,
                    1,
                    1,
                    1,
                    1,
                    1.00026,
                    1.41144,
                    0.99948,
                    0.99948,
                    0.99948,
                    0.99948,
                    1.00026,
                    1.00026,
                    0.99973,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    0.99973,
                    1.00065,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    1.00061
                ];
                exports.HelveticaBoldItalicFactors = HelveticaBoldItalicFactors;
                const HelveticaBoldItalicLineHeight = 1.35;
                exports.HelveticaBoldItalicLineHeight = HelveticaBoldItalicLineHeight;
                const HelveticaItalicFactors = [
                    0.76116,
                    1,
                    1.00001,
                    1,
                    1,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.91221,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.9998,
                    1.00001,
                    1.00001,
                    1.00054,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99973,
                    1.00026,
                    1.00022,
                    0.99945,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    0.99977,
                    0.99999,
                    0.99861,
                    0.99861,
                    1,
                    0.99977,
                    0.99977,
                    1.0006,
                    0.99946,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00084,
                    1.0006,
                    1,
                    1,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99973,
                    0.99973,
                    1.00001,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99999,
                    0.99999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00022,
                    1,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1,
                    1.00013,
                    1.00022,
                    1.00007,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00001,
                    1.0001,
                    1.00054,
                    1.00052,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00065,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00022,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    0.99973,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00001,
                    0.99933,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    0.99973,
                    0.99982,
                    0.99982,
                    1,
                    1.00001,
                    1.00019,
                    1.00001,
                    1.0001,
                    0.99986,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00038,
                    0.99954,
                    0.99954,
                    0.9994,
                    1.00066,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00054,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.99975,
                    1.0001,
                    1.00001,
                    0.99993,
                    0.9995,
                    0.99955,
                    1.00016,
                    0.99978,
                    0.99974,
                    1.00019,
                    1.00022,
                    0.99955,
                    1.00053,
                    0.99962,
                    1.00027,
                    1.0001,
                    1.00068,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    1.00008,
                    0.99957,
                    0.99972,
                    0.9994,
                    0.99975,
                    0.99973,
                    1.00089,
                    1.00005,
                    0.99967,
                    1.00048,
                    0.99973,
                    0.99973,
                    1.00002,
                    1.00034,
                    0.99973,
                    0.99973,
                    0.99964,
                    1.00006,
                    1.00066,
                    0.99947,
                    0.99973,
                    0.98894,
                    0.99973,
                    1,
                    0.44898,
                    1,
                    0.99946,
                    1,
                    1.00039,
                    1.00082,
                    0.99991,
                    0.99991,
                    0.99985,
                    1.00022,
                    1.00023,
                    1.00061,
                    1.00006,
                    0.99966,
                    0.99895,
                    0.99973,
                    1.00019,
                    1.0008,
                    1,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99983,
                    1.00044,
                    0.99973,
                    0.99964,
                    1,
                    1.00051,
                    1,
                    0.99973,
                    1,
                    1.00423,
                    0.99925,
                    0.99999,
                    0.99973,
                    0.99945,
                    0.99945,
                    0.99973,
                    1.00001,
                    1,
                    0.99973,
                    1.00031,
                    0.99973,
                    0.99973,
                    1,
                    1,
                    1.00049,
                    1.00245,
                    1,
                    1,
                    1,
                    0.99949,
                    1.00003,
                    0.99959,
                    0.99987,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0009,
                    0.99949,
                    1.41144,
                    1.00005,
                    1.00005,
                    1.0006,
                    1.0006,
                    0.99998,
                    1,
                    1.0009,
                    0.99972,
                    1,
                    1,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99973,
                    1.00019,
                    0.99999,
                    0.99998,
                    1,
                    0.99962,
                    1.0006,
                    1.0006,
                    1,
                    1,
                    1.00025,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0288,
                    0.99973,
                    1.00024,
                    1.0006,
                    0.9995,
                    0.99998,
                    1,
                    0.99998,
                    1.06409,
                    1.36625,
                    1.41144,
                    0.99973,
                    0.99998,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    1,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99897,
                    0.99897,
                    1.00003,
                    1.00003,
                    0.99984,
                    0.99968,
                    0.99968,
                    0.99973,
                    1.0006,
                    1,
                    0.99998,
                    1.0006,
                    1,
                    0.99999,
                    1,
                    0.99973,
                    1.00002,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00026,
                    0.99998,
                    1,
                    1.00003,
                    1.00031,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00042,
                    0.99999,
                    0.99998,
                    1,
                    0.99924,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00034,
                    1.0006,
                    1.00015,
                    1.00027,
                    0.99999,
                    0.99999,
                    1.00035,
                    0.99999,
                    0.99999,
                    0.99977,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    1.0006,
                    0.99924,
                    0.99924,
                    1,
                    1,
                    1,
                    1,
                    0.99924,
                    0.99924,
                    0.99962,
                    1.06311,
                    0.99924,
                    1.00024,
                    1.00003,
                    1.00031,
                    1.41144,
                    0.99973,
                    1.00003,
                    0.99924,
                    0.95317,
                    0.99924,
                    1.40579,
                    0.99999,
                    0.60299,
                    1,
                    1,
                    1.00003,
                    1.00267,
                    1.01487,
                    1.00003,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    1.00041,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    1.00031,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00016,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00025,
                    1.00025,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.40483,
                    0.99968,
                    0.99936,
                    1,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.9998,
                    0.99998,
                    0.99998,
                    0.96329,
                    0.99982,
                    1.0006,
                    1,
                    1.00023,
                    0.99947,
                    1.00012,
                    1.00003,
                    1.06409,
                    1.20985,
                    1.00063,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.00006,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    1.00043,
                    0.99998,
                    0.99998,
                    0.8254,
                    0.99998,
                    0.99998,
                    1.00025,
                    1.00003,
                    1.00043,
                    0.99998,
                    1.41144,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99999,
                    0.99973,
                    0.99973,
                    1.00002,
                    0.99998,
                    1.40579,
                    0.99995,
                    1,
                    0.99973,
                    1.0006,
                    1,
                    0.99953,
                    0.99973,
                    1.39713,
                    1.00054,
                    1.0006,
                    0.99994,
                    1.0006,
                    0.89547,
                    1.0006,
                    0.99911,
                    0.99973,
                    0.99973,
                    1.00002,
                    1.00002,
                    0.99998,
                    1,
                    0.99998,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99955,
                    1.0006,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1.00026,
                    1.0006,
                    0.99998,
                    1,
                    1.00001,
                    0.99954,
                    0.99973,
                    0.98332,
                    1,
                    1,
                    0.99998,
                    1,
                    0.99991,
                    1,
                    1.66475,
                    1.0006,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    1.41144,
                    1.00036,
                    1.00036,
                    1.00036,
                    1.00036,
                    0.99973,
                    0.99973,
                    1,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1,
                    1.0005,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    0.99918
                ];
                exports.HelveticaItalicFactors = HelveticaItalicFactors;
                const HelveticaItalicLineHeight = 1.35;
                exports.HelveticaItalicLineHeight = HelveticaItalicLineHeight;
                const HelveticaRegularFactors = [
                    0.76116,
                    1,
                    1.00001,
                    1,
                    1,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99928,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.91621,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.9998,
                    1.00001,
                    1.00001,
                    0.99977,
                    0.99977,
                    1.00013,
                    0.99977,
                    0.99973,
                    1.00026,
                    1.00022,
                    1.0004,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    0.99977,
                    0.99999,
                    0.99861,
                    0.99861,
                    1,
                    0.99977,
                    0.99977,
                    1.0006,
                    1.00019,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00055,
                    1.0006,
                    1,
                    1,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99973,
                    0.99973,
                    1.00005,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99999,
                    0.99999,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00022,
                    1,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00022,
                    1,
                    0.99941,
                    1.00022,
                    0.99947,
                    1.00022,
                    1.00022,
                    1.00022,
                    1.00001,
                    1.00019,
                    0.99977,
                    0.99946,
                    1.00022,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.6,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.41144,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    0.99973,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00022,
                    1.00001,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00001,
                    0.99945,
                    0.99977,
                    0.99977,
                    1.00001,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00016,
                    1.00001,
                    1.00015,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00001,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99973,
                    0.99982,
                    0.99982,
                    1,
                    1.00001,
                    0.99962,
                    1.00001,
                    1.00092,
                    0.99964,
                    1.00001,
                    0.99928,
                    0.99963,
                    0.99999,
                    1.00035,
                    1.00035,
                    1.00082,
                    0.99962,
                    0.99999,
                    0.99977,
                    1.00022,
                    1.00035,
                    1.00001,
                    0.99977,
                    1.00026,
                    0.9996,
                    0.99967,
                    1.00001,
                    1.00034,
                    1.00074,
                    1.00054,
                    1.00053,
                    1.00063,
                    0.99971,
                    0.99962,
                    1.00035,
                    0.99975,
                    0.99977,
                    1.00047,
                    1.00029,
                    1.00092,
                    1.00035,
                    1.00001,
                    1.0006,
                    1.0006,
                    1,
                    0.99988,
                    0.99975,
                    1,
                    1.00082,
                    0.9996,
                    0.99973,
                    1.00043,
                    0.99953,
                    1.0007,
                    0.99915,
                    0.99973,
                    0.99973,
                    1.00008,
                    0.99892,
                    1.00073,
                    1.00073,
                    1.00114,
                    0.99915,
                    1.00073,
                    0.99955,
                    0.99973,
                    1.00092,
                    0.99973,
                    1,
                    0.99998,
                    1,
                    1.0003,
                    1,
                    1.00043,
                    1.00001,
                    0.99969,
                    1.0003,
                    1,
                    1.00035,
                    1.00001,
                    0.9995,
                    1,
                    1.00092,
                    0.99968,
                    0.99973,
                    1.0007,
                    0.9995,
                    1,
                    0.99924,
                    1.0006,
                    0.99924,
                    0.99972,
                    1.00062,
                    0.99973,
                    1.00114,
                    1,
                    1.00035,
                    1,
                    0.99955,
                    1,
                    0.99971,
                    0.99925,
                    1.00023,
                    0.99973,
                    0.99978,
                    0.99978,
                    0.99973,
                    1.00001,
                    1,
                    0.99973,
                    1.00031,
                    0.99973,
                    0.99973,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99949,
                    1.00003,
                    0.99959,
                    0.99987,
                    0.99973,
                    0.99973,
                    1.0006,
                    1.0009,
                    0.99966,
                    1.41144,
                    1.00005,
                    1.00005,
                    1.0006,
                    1.0006,
                    0.99998,
                    1.0009,
                    0.99972,
                    1,
                    1,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    0.99973,
                    1.00019,
                    0.99999,
                    0.99998,
                    0.99962,
                    1.0006,
                    1.0006,
                    1.00025,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.04596,
                    0.99973,
                    1.00024,
                    1.00065,
                    0.9995,
                    0.99998,
                    0.99998,
                    1.06409,
                    1.36625,
                    1.41144,
                    0.99973,
                    0.99998,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00045,
                    1.00045,
                    1.00003,
                    0.99915,
                    0.99984,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.0006,
                    1,
                    0.99998,
                    1.0006,
                    1,
                    0.99999,
                    1,
                    0.99973,
                    1.00002,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00026,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99998,
                    1.00003,
                    1.00031,
                    0.99973,
                    0.99973,
                    0.99998,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00042,
                    0.99999,
                    0.99998,
                    0.99924,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.0006,
                    1.00034,
                    1.0006,
                    1.00015,
                    1.00027,
                    0.99999,
                    0.99999,
                    1.00035,
                    0.99999,
                    0.99999,
                    0.99977,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    1.0006,
                    0.99924,
                    0.99924,
                    1,
                    1,
                    1,
                    1,
                    0.99924,
                    0.99924,
                    1,
                    1.02572,
                    0.99924,
                    1.00005,
                    1.00003,
                    1.00031,
                    1.41144,
                    0.99973,
                    1.00003,
                    0.99924,
                    0.95317,
                    0.99924,
                    1.40579,
                    0.99999,
                    0.60299,
                    1,
                    1,
                    1.00003,
                    1.00267,
                    0.96499,
                    1.00003,
                    1,
                    1,
                    0.99973,
                    0.99973,
                    0.99999,
                    0.99973,
                    0.99973,
                    0.99973,
                    1,
                    1.00031,
                    0.99973,
                    1,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00016,
                    0.99998,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00031,
                    1.00031,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00002,
                    1.00002,
                    1.00002,
                    1.40483,
                    0.99968,
                    0.99936,
                    1,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.9998,
                    0.99998,
                    0.99998,
                    0.96329,
                    0.99982,
                    1.0006,
                    1,
                    1.00023,
                    0.99933,
                    1.00008,
                    1.00003,
                    1.06409,
                    1.20985,
                    1.00015,
                    0.99973,
                    0.99973,
                    1.00026,
                    1.00006,
                    0.99998,
                    0.99998,
                    0.99998,
                    0.99924,
                    0.99924,
                    0.99924,
                    0.99924,
                    1.00043,
                    0.99998,
                    0.99998,
                    0.8254,
                    0.99998,
                    0.99998,
                    1.00025,
                    1.00003,
                    1.00027,
                    0.99998,
                    1.41144,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99999,
                    0.99973,
                    0.99973,
                    1.00002,
                    1.40579,
                    0.9997,
                    1,
                    0.99973,
                    1.0006,
                    1,
                    0.99953,
                    0.99973,
                    1.39713,
                    1.00054,
                    1.0006,
                    0.99995,
                    1.0006,
                    0.84533,
                    1.0006,
                    0.99973,
                    0.99973,
                    0.99973,
                    1.00002,
                    1.00002,
                    0.99998,
                    0.99998,
                    1,
                    1.00026,
                    1.00026,
                    1.00026,
                    1.00026,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99973,
                    0.99955,
                    1.0006,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1.00026,
                    1.0006,
                    0.99998,
                    1,
                    1.00001,
                    0.99561,
                    0.99973,
                    1.00073,
                    1,
                    1,
                    0.99998,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99991,
                    1,
                    1.66475,
                    1.0006,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    1.41144,
                    1.00023,
                    1.00023,
                    1.00023,
                    1.00023,
                    0.99973,
                    0.99973,
                    1,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    0.99977,
                    1,
                    1.00055,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99973,
                    1.00019
                ];
                exports.HelveticaRegularFactors = HelveticaRegularFactors;
                const HelveticaRegularLineHeight = 1.2;
                exports.HelveticaRegularLineHeight = HelveticaRegularLineHeight;
            /***/ },
            /* 58 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LiberationSansRegularWidths = exports.LiberationSansItalicWidths = exports.LiberationSansBoldWidths = exports.LiberationSansBoldItalicWidths = void 0;
                const LiberationSansBoldWidths = [
                    365,
                    0,
                    722,
                    1000,
                    1000,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    722,
                    722,
                    722,
                    719,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    723,
                    667,
                    667,
                    853,
                    722,
                    906,
                    722,
                    556,
                    611,
                    778,
                    601,
                    778,
                    778,
                    778,
                    778,
                    722,
                    604,
                    354,
                    354,
                    604,
                    722,
                    722,
                    278,
                    785,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    474,
                    278,
                    556,
                    556,
                    722,
                    722,
                    722,
                    611,
                    611,
                    667,
                    611,
                    611,
                    611,
                    611,
                    833,
                    833,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    778,
                    1000,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    802,
                    838,
                    778,
                    825,
                    778,
                    778,
                    778,
                    667,
                    821,
                    722,
                    809,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    667,
                    667,
                    667,
                    667,
                    667,
                    600,
                    611,
                    611,
                    611,
                    611,
                    611,
                    778,
                    667,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    927,
                    722,
                    722,
                    667,
                    944,
                    944,
                    944,
                    944,
                    944,
                    667,
                    644,
                    667,
                    667,
                    667,
                    667,
                    667,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    556,
                    889,
                    889,
                    1000,
                    722,
                    719,
                    722,
                    567,
                    712,
                    667,
                    669,
                    904,
                    626,
                    719,
                    719,
                    610,
                    702,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    622,
                    854,
                    667,
                    730,
                    703,
                    1005,
                    1019,
                    870,
                    979,
                    719,
                    711,
                    1031,
                    719,
                    487,
                    885,
                    567,
                    711,
                    667,
                    278,
                    276,
                    556,
                    1094,
                    1062,
                    875,
                    610,
                    622,
                    556,
                    618,
                    615,
                    417,
                    635,
                    556,
                    556,
                    709,
                    497,
                    615,
                    615,
                    500,
                    635,
                    740,
                    604,
                    611,
                    604,
                    611,
                    556,
                    490,
                    556,
                    875,
                    556,
                    615,
                    581,
                    833,
                    844,
                    729,
                    854,
                    615,
                    552,
                    854,
                    583,
                    447,
                    611,
                    417,
                    552,
                    556,
                    278,
                    281,
                    278,
                    969,
                    906,
                    611,
                    500,
                    556,
                    719,
                    778,
                    604,
                    611,
                    885,
                    489,
                    1115,
                    556,
                    615,
                    615,
                    556,
                    722,
                    333,
                    556,
                    549,
                    556,
                    556,
                    1000,
                    500,
                    1000,
                    1000,
                    500,
                    500,
                    500,
                    584,
                    584,
                    389,
                    975,
                    556,
                    611,
                    278,
                    280,
                    610,
                    708,
                    389,
                    389,
                    333,
                    333,
                    333,
                    333,
                    280,
                    350,
                    556,
                    556,
                    333,
                    333,
                    222,
                    556,
                    556,
                    556,
                    556,
                    333,
                    556,
                    576,
                    604,
                    333,
                    333,
                    656,
                    333,
                    278,
                    333,
                    222,
                    737,
                    556,
                    333,
                    611,
                    556,
                    556,
                    719,
                    611,
                    400,
                    606,
                    510,
                    333,
                    333,
                    465,
                    549,
                    729,
                    708,
                    556,
                    333,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    1000,
                    556,
                    1000,
                    556,
                    611,
                    556,
                    475,
                    451,
                    584,
                    583,
                    600,
                    611,
                    611,
                    611,
                    333,
                    604,
                    333,
                    333,
                    750,
                    604,
                    1000,
                    556,
                    834,
                    333,
                    556,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    611,
                    611,
                    611,
                    611,
                    333,
                    333,
                    584,
                    549,
                    556,
                    556,
                    333,
                    333,
                    611,
                    611,
                    611,
                    594,
                    604,
                    333,
                    333,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    556,
                    278,
                    713,
                    274,
                    604,
                    604,
                    722,
                    604,
                    604,
                    1052,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    556,
                    558,
                    556,
                    556,
                    278,
                    278,
                    556,
                    385,
                    278,
                    479,
                    584,
                    549,
                    708,
                    556,
                    584,
                    278,
                    494,
                    278,
                    708,
                    889,
                    552,
                    750,
                    333,
                    584,
                    240,
                    612,
                    584,
                    500,
                    750,
                    611,
                    611,
                    708,
                    611,
                    611,
                    556,
                    333,
                    549,
                    611,
                    556,
                    556,
                    611,
                    611,
                    611,
                    611,
                    611,
                    944,
                    333,
                    611,
                    611,
                    611,
                    845,
                    845,
                    611,
                    611,
                    556,
                    834,
                    834,
                    834,
                    354,
                    370,
                    365,
                    979,
                    611,
                    611,
                    611,
                    611,
                    556,
                    333,
                    333,
                    494,
                    889,
                    278,
                    1000,
                    1094,
                    715,
                    766,
                    584,
                    549,
                    823,
                    753,
                    611,
                    611,
                    611,
                    474,
                    500,
                    500,
                    500,
                    278,
                    278,
                    278,
                    278,
                    238,
                    389,
                    389,
                    549,
                    389,
                    389,
                    737,
                    584,
                    619,
                    333,
                    708,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    479,
                    556,
                    556,
                    834,
                    333,
                    708,
                    684,
                    520,
                    556,
                    278,
                    1021,
                    531,
                    556,
                    713,
                    917,
                    333,
                    446,
                    333,
                    479,
                    333,
                    541,
                    611,
                    556,
                    834,
                    834,
                    333,
                    333,
                    333,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    556,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    552,
                    278,
                    333,
                    333,
                    333,
                    576,
                    333,
                    611,
                    333,
                    333,
                    333,
                    667,
                    722,
                    556,
                    615,
                    333,
                    333,
                    333,
                    396,
                    768,
                    612,
                    167,
                    278,
                    750,
                    333,
                    611,
                    611,
                    611,
                    708,
                    582,
                    582,
                    582,
                    582,
                    611,
                    611,
                    556,
                    778,
                    778,
                    778,
                    778,
                    778,
                    556,
                    445,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    500,
                    500,
                    500,
                    500,
                    556,
                    460
                ];
                exports.LiberationSansBoldWidths = LiberationSansBoldWidths;
                const LiberationSansBoldItalicWidths = [
                    365,
                    0,
                    722,
                    1000,
                    1000,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    722,
                    722,
                    722,
                    671,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    723,
                    667,
                    667,
                    854,
                    722,
                    906,
                    722,
                    556,
                    611,
                    778,
                    610,
                    778,
                    778,
                    778,
                    778,
                    722,
                    604,
                    354,
                    354,
                    604,
                    722,
                    722,
                    278,
                    782,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    473,
                    278,
                    556,
                    556,
                    722,
                    722,
                    722,
                    611,
                    611,
                    667,
                    611,
                    611,
                    611,
                    611,
                    833,
                    833,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    778,
                    1000,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    781,
                    847,
                    778,
                    844,
                    778,
                    778,
                    778,
                    667,
                    822,
                    718,
                    829,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    667,
                    667,
                    667,
                    667,
                    667,
                    590,
                    611,
                    611,
                    611,
                    611,
                    611,
                    778,
                    667,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    930,
                    722,
                    722,
                    667,
                    944,
                    944,
                    944,
                    944,
                    944,
                    667,
                    657,
                    667,
                    667,
                    667,
                    667,
                    667,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    556,
                    556,
                    556,
                    333,
                    333,
                    556,
                    889,
                    889,
                    1000,
                    722,
                    708,
                    722,
                    614,
                    722,
                    667,
                    667,
                    927,
                    643,
                    719,
                    719,
                    615,
                    687,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    677,
                    781,
                    667,
                    729,
                    708,
                    979,
                    989,
                    854,
                    1000,
                    708,
                    719,
                    1042,
                    729,
                    575,
                    886,
                    614,
                    719,
                    667,
                    278,
                    278,
                    556,
                    1094,
                    1042,
                    854,
                    622,
                    677,
                    556,
                    619,
                    604,
                    534,
                    618,
                    556,
                    556,
                    736,
                    510,
                    611,
                    611,
                    507,
                    622,
                    740,
                    604,
                    611,
                    611,
                    611,
                    556,
                    889,
                    556,
                    885,
                    556,
                    646,
                    583,
                    889,
                    935,
                    707,
                    854,
                    594,
                    552,
                    865,
                    589,
                    467,
                    611,
                    469,
                    563,
                    556,
                    278,
                    278,
                    278,
                    969,
                    906,
                    611,
                    507,
                    556,
                    719,
                    778,
                    611,
                    611,
                    885,
                    516,
                    1146,
                    556,
                    620,
                    620,
                    556,
                    722,
                    333,
                    556,
                    549,
                    556,
                    556,
                    1000,
                    500,
                    999,
                    1000,
                    500,
                    500,
                    500,
                    584,
                    584,
                    389,
                    975,
                    556,
                    611,
                    278,
                    280,
                    621,
                    708,
                    389,
                    389,
                    333,
                    333,
                    333,
                    333,
                    280,
                    350,
                    556,
                    556,
                    333,
                    333,
                    222,
                    556,
                    556,
                    556,
                    556,
                    333,
                    556,
                    578,
                    604,
                    333,
                    333,
                    656,
                    333,
                    278,
                    333,
                    222,
                    737,
                    556,
                    333,
                    611,
                    556,
                    556,
                    740,
                    611,
                    400,
                    610,
                    510,
                    333,
                    333,
                    333,
                    549,
                    729,
                    708,
                    556,
                    333,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    1000,
                    556,
                    1000,
                    556,
                    611,
                    556,
                    479,
                    479,
                    584,
                    583,
                    600,
                    611,
                    611,
                    611,
                    333,
                    604,
                    333,
                    333,
                    750,
                    604,
                    1000,
                    556,
                    834,
                    333,
                    556,
                    556,
                    333,
                    556,
                    611,
                    556,
                    611,
                    611,
                    611,
                    611,
                    611,
                    333,
                    333,
                    584,
                    549,
                    556,
                    556,
                    333,
                    333,
                    611,
                    611,
                    611,
                    594,
                    604,
                    333,
                    333,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    556,
                    278,
                    713,
                    274,
                    604,
                    604,
                    722,
                    604,
                    604,
                    1052,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    556,
                    566,
                    556,
                    556,
                    278,
                    278,
                    556,
                    396,
                    278,
                    479,
                    584,
                    549,
                    708,
                    556,
                    584,
                    278,
                    494,
                    278,
                    708,
                    889,
                    552,
                    750,
                    333,
                    584,
                    240,
                    603,
                    584,
                    500,
                    750,
                    611,
                    611,
                    708,
                    611,
                    611,
                    556,
                    333,
                    549,
                    611,
                    556,
                    556,
                    611,
                    611,
                    611,
                    611,
                    611,
                    944,
                    333,
                    611,
                    611,
                    611,
                    834,
                    834,
                    611,
                    611,
                    556,
                    834,
                    834,
                    834,
                    354,
                    370,
                    365,
                    979,
                    611,
                    611,
                    611,
                    611,
                    556,
                    333,
                    333,
                    494,
                    889,
                    278,
                    1000,
                    1104,
                    704,
                    712,
                    584,
                    549,
                    823,
                    773,
                    611,
                    611,
                    611,
                    474,
                    500,
                    500,
                    500,
                    278,
                    278,
                    278,
                    278,
                    238,
                    389,
                    389,
                    549,
                    389,
                    389,
                    737,
                    584,
                    605,
                    333,
                    708,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    479,
                    556,
                    556,
                    834,
                    333,
                    708,
                    664,
                    532,
                    556,
                    278,
                    1021,
                    531,
                    556,
                    713,
                    917,
                    333,
                    409,
                    333,
                    479,
                    333,
                    558,
                    611,
                    556,
                    834,
                    834,
                    333,
                    333,
                    333,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    556,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    552,
                    278,
                    333,
                    333,
                    333,
                    576,
                    333,
                    611,
                    333,
                    333,
                    333,
                    667,
                    719,
                    556,
                    619,
                    333,
                    333,
                    333,
                    396,
                    768,
                    612,
                    167,
                    278,
                    750,
                    333,
                    611,
                    611,
                    611,
                    708,
                    591,
                    591,
                    591,
                    591,
                    611,
                    611,
                    556,
                    778,
                    778,
                    778,
                    778,
                    778,
                    556,
                    450,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    500,
                    500,
                    500,
                    500,
                    556,
                    492
                ];
                exports.LiberationSansBoldItalicWidths = LiberationSansBoldItalicWidths;
                const LiberationSansItalicWidths = [
                    365,
                    0,
                    667,
                    1000,
                    1000,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    722,
                    722,
                    722,
                    671,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    723,
                    667,
                    667,
                    789,
                    722,
                    846,
                    722,
                    556,
                    611,
                    778,
                    570,
                    778,
                    778,
                    778,
                    778,
                    722,
                    604,
                    354,
                    354,
                    604,
                    722,
                    722,
                    278,
                    733,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    389,
                    278,
                    500,
                    500,
                    667,
                    667,
                    667,
                    556,
                    556,
                    667,
                    556,
                    556,
                    556,
                    556,
                    833,
                    833,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    778,
                    1000,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    761,
                    775,
                    778,
                    794,
                    778,
                    778,
                    778,
                    667,
                    837,
                    725,
                    831,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    667,
                    667,
                    667,
                    667,
                    667,
                    600,
                    611,
                    611,
                    611,
                    611,
                    611,
                    778,
                    667,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    865,
                    722,
                    722,
                    667,
                    944,
                    944,
                    944,
                    944,
                    944,
                    667,
                    648,
                    667,
                    667,
                    667,
                    667,
                    667,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    556,
                    556,
                    556,
                    333,
                    294,
                    556,
                    889,
                    889,
                    1000,
                    667,
                    651,
                    667,
                    544,
                    704,
                    667,
                    667,
                    917,
                    614,
                    715,
                    715,
                    589,
                    686,
                    833,
                    722,
                    778,
                    725,
                    667,
                    722,
                    611,
                    639,
                    795,
                    667,
                    727,
                    673,
                    920,
                    923,
                    805,
                    886,
                    651,
                    694,
                    1022,
                    682,
                    492,
                    843,
                    544,
                    708,
                    667,
                    278,
                    278,
                    500,
                    1066,
                    982,
                    844,
                    589,
                    639,
                    556,
                    562,
                    522,
                    493,
                    553,
                    556,
                    556,
                    688,
                    465,
                    556,
                    556,
                    472,
                    564,
                    686,
                    550,
                    556,
                    556,
                    556,
                    500,
                    833,
                    500,
                    835,
                    500,
                    572,
                    518,
                    830,
                    851,
                    621,
                    736,
                    526,
                    492,
                    752,
                    534,
                    339,
                    556,
                    378,
                    496,
                    500,
                    222,
                    222,
                    222,
                    910,
                    828,
                    556,
                    472,
                    500,
                    724,
                    778,
                    556,
                    556,
                    885,
                    323,
                    1083,
                    556,
                    570,
                    570,
                    556,
                    667,
                    278,
                    556,
                    549,
                    556,
                    556,
                    1000,
                    500,
                    1000,
                    998,
                    500,
                    500,
                    500,
                    469,
                    584,
                    389,
                    1015,
                    556,
                    556,
                    278,
                    260,
                    571,
                    708,
                    334,
                    334,
                    278,
                    278,
                    333,
                    285,
                    260,
                    350,
                    500,
                    500,
                    333,
                    324,
                    222,
                    500,
                    500,
                    500,
                    500,
                    333,
                    556,
                    546,
                    604,
                    333,
                    324,
                    656,
                    278,
                    278,
                    333,
                    222,
                    737,
                    556,
                    333,
                    556,
                    556,
                    556,
                    625,
                    556,
                    400,
                    556,
                    510,
                    333,
                    316,
                    333,
                    549,
                    729,
                    708,
                    556,
                    333,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    333,
                    1000,
                    556,
                    1000,
                    556,
                    556,
                    556,
                    439,
                    439,
                    584,
                    584,
                    600,
                    555,
                    555,
                    556,
                    278,
                    500,
                    333,
                    278,
                    750,
                    604,
                    1000,
                    556,
                    834,
                    333,
                    556,
                    556,
                    333,
                    556,
                    556,
                    500,
                    556,
                    556,
                    556,
                    556,
                    611,
                    333,
                    294,
                    584,
                    549,
                    556,
                    556,
                    333,
                    333,
                    556,
                    556,
                    556,
                    594,
                    604,
                    333,
                    398,
                    222,
                    278,
                    278,
                    278,
                    278,
                    278,
                    444,
                    278,
                    713,
                    274,
                    604,
                    604,
                    719,
                    604,
                    604,
                    1052,
                    222,
                    222,
                    222,
                    222,
                    222,
                    278,
                    222,
                    222,
                    500,
                    500,
                    500,
                    500,
                    222,
                    222,
                    492,
                    281,
                    222,
                    400,
                    584,
                    549,
                    708,
                    556,
                    584,
                    222,
                    494,
                    222,
                    708,
                    833,
                    552,
                    750,
                    333,
                    584,
                    188,
                    548,
                    584,
                    500,
                    750,
                    556,
                    556,
                    615,
                    556,
                    556,
                    556,
                    333,
                    549,
                    556,
                    500,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    944,
                    333,
                    556,
                    556,
                    556,
                    779,
                    779,
                    556,
                    556,
                    556,
                    834,
                    834,
                    834,
                    354,
                    370,
                    365,
                    979,
                    611,
                    611,
                    556,
                    556,
                    537,
                    333,
                    333,
                    494,
                    889,
                    278,
                    1000,
                    1094,
                    652,
                    670,
                    584,
                    549,
                    823,
                    728,
                    556,
                    556,
                    611,
                    355,
                    333,
                    333,
                    333,
                    222,
                    222,
                    222,
                    222,
                    191,
                    333,
                    333,
                    549,
                    333,
                    333,
                    737,
                    584,
                    573,
                    333,
                    708,
                    500,
                    500,
                    500,
                    500,
                    500,
                    500,
                    354,
                    556,
                    556,
                    834,
                    333,
                    708,
                    603,
                    486,
                    556,
                    278,
                    1021,
                    531,
                    556,
                    713,
                    917,
                    278,
                    374,
                    278,
                    354,
                    278,
                    542,
                    556,
                    556,
                    834,
                    834,
                    333,
                    328,
                    333,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    552,
                    278,
                    333,
                    333,
                    333,
                    576,
                    333,
                    611,
                    278,
                    333,
                    278,
                    667,
                    715,
                    556,
                    565,
                    333,
                    333,
                    333,
                    365,
                    768,
                    612,
                    167,
                    278,
                    750,
                    333,
                    500,
                    500,
                    556,
                    708,
                    550,
                    550,
                    550,
                    550,
                    556,
                    556,
                    500,
                    722,
                    722,
                    722,
                    722,
                    722,
                    500,
                    447,
                    500,
                    500,
                    500,
                    500,
                    556,
                    500,
                    500,
                    500,
                    500,
                    500,
                    556,
                    463
                ];
                exports.LiberationSansItalicWidths = LiberationSansItalicWidths;
                const LiberationSansRegularWidths = [
                    365,
                    0,
                    667,
                    1000,
                    1000,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    722,
                    722,
                    722,
                    668,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    667,
                    723,
                    667,
                    667,
                    784,
                    722,
                    838,
                    722,
                    556,
                    611,
                    778,
                    551,
                    778,
                    778,
                    778,
                    778,
                    722,
                    604,
                    354,
                    354,
                    604,
                    722,
                    722,
                    278,
                    735,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    278,
                    384,
                    278,
                    500,
                    500,
                    667,
                    667,
                    667,
                    556,
                    556,
                    668,
                    556,
                    556,
                    556,
                    556,
                    833,
                    833,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    778,
                    1000,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    778,
                    748,
                    752,
                    778,
                    774,
                    778,
                    778,
                    778,
                    667,
                    798,
                    722,
                    835,
                    778,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    625,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    708,
                    667,
                    667,
                    667,
                    667,
                    667,
                    618,
                    611,
                    611,
                    611,
                    611,
                    611,
                    778,
                    667,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    722,
                    667,
                    667,
                    855,
                    722,
                    722,
                    667,
                    944,
                    944,
                    944,
                    944,
                    944,
                    667,
                    650,
                    667,
                    667,
                    667,
                    667,
                    667,
                    611,
                    611,
                    611,
                    611,
                    611,
                    556,
                    556,
                    556,
                    556,
                    333,
                    556,
                    889,
                    889,
                    1000,
                    667,
                    656,
                    667,
                    542,
                    677,
                    667,
                    667,
                    923,
                    604,
                    719,
                    719,
                    583,
                    656,
                    833,
                    722,
                    778,
                    719,
                    667,
                    722,
                    611,
                    635,
                    760,
                    667,
                    740,
                    667,
                    917,
                    938,
                    792,
                    885,
                    656,
                    719,
                    1010,
                    722,
                    489,
                    865,
                    542,
                    719,
                    667,
                    278,
                    278,
                    500,
                    1057,
                    1010,
                    854,
                    583,
                    635,
                    556,
                    573,
                    531,
                    365,
                    583,
                    556,
                    556,
                    669,
                    458,
                    559,
                    559,
                    438,
                    583,
                    688,
                    552,
                    556,
                    542,
                    556,
                    500,
                    458,
                    500,
                    823,
                    500,
                    573,
                    521,
                    802,
                    823,
                    625,
                    719,
                    521,
                    510,
                    750,
                    542,
                    411,
                    556,
                    365,
                    510,
                    500,
                    222,
                    278,
                    222,
                    906,
                    812,
                    556,
                    438,
                    500,
                    719,
                    778,
                    552,
                    556,
                    885,
                    323,
                    1073,
                    556,
                    578,
                    578,
                    556,
                    667,
                    278,
                    556,
                    549,
                    556,
                    556,
                    1000,
                    500,
                    1000,
                    1000,
                    500,
                    500,
                    500,
                    469,
                    584,
                    389,
                    1015,
                    556,
                    556,
                    278,
                    260,
                    575,
                    708,
                    334,
                    334,
                    278,
                    278,
                    333,
                    260,
                    350,
                    500,
                    500,
                    333,
                    500,
                    500,
                    500,
                    500,
                    333,
                    556,
                    525,
                    604,
                    333,
                    656,
                    278,
                    278,
                    737,
                    556,
                    556,
                    556,
                    556,
                    615,
                    556,
                    400,
                    557,
                    510,
                    333,
                    333,
                    549,
                    729,
                    708,
                    556,
                    333,
                    278,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    1000,
                    556,
                    1000,
                    556,
                    556,
                    556,
                    446,
                    446,
                    584,
                    583,
                    600,
                    556,
                    556,
                    556,
                    278,
                    500,
                    333,
                    278,
                    750,
                    604,
                    1000,
                    556,
                    834,
                    556,
                    556,
                    556,
                    556,
                    500,
                    556,
                    556,
                    556,
                    556,
                    611,
                    333,
                    222,
                    222,
                    294,
                    294,
                    324,
                    324,
                    316,
                    328,
                    398,
                    285,
                    333,
                    584,
                    549,
                    556,
                    556,
                    333,
                    333,
                    556,
                    556,
                    556,
                    594,
                    604,
                    333,
                    222,
                    278,
                    278,
                    278,
                    278,
                    278,
                    444,
                    278,
                    713,
                    274,
                    604,
                    604,
                    719,
                    604,
                    604,
                    1052,
                    222,
                    222,
                    222,
                    222,
                    222,
                    278,
                    222,
                    222,
                    500,
                    500,
                    500,
                    500,
                    222,
                    222,
                    500,
                    292,
                    222,
                    334,
                    584,
                    549,
                    708,
                    556,
                    584,
                    222,
                    494,
                    222,
                    708,
                    833,
                    552,
                    750,
                    333,
                    584,
                    188,
                    576,
                    584,
                    500,
                    750,
                    556,
                    556,
                    604,
                    556,
                    556,
                    556,
                    333,
                    549,
                    556,
                    500,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    944,
                    333,
                    556,
                    556,
                    556,
                    781,
                    781,
                    556,
                    556,
                    556,
                    834,
                    834,
                    834,
                    354,
                    370,
                    365,
                    979,
                    611,
                    611,
                    556,
                    556,
                    537,
                    333,
                    333,
                    494,
                    889,
                    278,
                    1000,
                    1094,
                    648,
                    690,
                    584,
                    549,
                    823,
                    713,
                    556,
                    556,
                    611,
                    355,
                    333,
                    333,
                    333,
                    222,
                    222,
                    222,
                    222,
                    191,
                    333,
                    333,
                    549,
                    333,
                    333,
                    737,
                    584,
                    569,
                    333,
                    708,
                    500,
                    500,
                    500,
                    500,
                    500,
                    500,
                    354,
                    556,
                    556,
                    834,
                    708,
                    617,
                    482,
                    556,
                    278,
                    1021,
                    531,
                    556,
                    713,
                    917,
                    278,
                    395,
                    278,
                    375,
                    278,
                    556,
                    556,
                    556,
                    834,
                    834,
                    333,
                    333,
                    1000,
                    990,
                    990,
                    990,
                    990,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    556,
                    552,
                    278,
                    333,
                    333,
                    333,
                    576,
                    333,
                    611,
                    278,
                    333,
                    278,
                    667,
                    722,
                    556,
                    559,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    333,
                    365,
                    768,
                    612,
                    167,
                    278,
                    750,
                    333,
                    333,
                    500,
                    500,
                    556,
                    708,
                    547,
                    547,
                    547,
                    547,
                    556,
                    556,
                    500,
                    722,
                    722,
                    722,
                    722,
                    722,
                    500,
                    448,
                    500,
                    500,
                    500,
                    500,
                    556,
                    500,
                    500,
                    500,
                    500,
                    500,
                    556,
                    441
                ];
                exports.LiberationSansRegularWidths = LiberationSansRegularWidths;
            /***/ },
            /* 59 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MyriadProRegularLineHeight = exports.MyriadProRegularFactors = exports.MyriadProItalicLineHeight = exports.MyriadProItalicFactors = exports.MyriadProBoldLineHeight = exports.MyriadProBoldItalicLineHeight = exports.MyriadProBoldItalicFactors = exports.MyriadProBoldFactors = void 0;
                const MyriadProBoldFactors = [
                    1.36898,
                    1,
                    0.90838,
                    0.868,
                    0.868,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.91945,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.90838,
                    0.83637,
                    0.83637,
                    0.82391,
                    0.82391,
                    0.82391,
                    0.82391,
                    0.82391,
                    0.82391,
                    0.91905,
                    0.96376,
                    0.96376,
                    0.97484,
                    0.90157,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.80061,
                    0.95417,
                    0.80061,
                    0.80061,
                    0.75261,
                    0.95407,
                    0.87992,
                    0.97484,
                    0.99793,
                    0.86275,
                    0.8768,
                    0.8019,
                    0.8768,
                    0.8768,
                    1,
                    0.8768,
                    0.95407,
                    1,
                    1,
                    1,
                    1,
                    0.97069,
                    0.95407,
                    1.0258,
                    0.887,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    1.0258,
                    0.82976,
                    1.0258,
                    0.73901,
                    0.73901,
                    0.85022,
                    0.85022,
                    1,
                    0.83655,
                    0.83655,
                    0.97153,
                    0.83655,
                    1,
                    0.83655,
                    0.84638,
                    1.0156,
                    1.0156,
                    0.95546,
                    0.95546,
                    0.95546,
                    1,
                    0.95546,
                    0.95546,
                    0.92179,
                    0.936,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.92796,
                    0.97268,
                    0.92179,
                    0.96034,
                    0.92179,
                    0.92179,
                    0.92179,
                    0.87107,
                    0.95638,
                    0.92361,
                    0.91709,
                    0.92179,
                    0.82114,
                    0.82114,
                    0.82114,
                    1,
                    0.87107,
                    0.8096,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.8096,
                    0.8096,
                    1,
                    0.8096,
                    1,
                    0.96318,
                    0.89713,
                    0.89713,
                    0.89713,
                    0.89713,
                    1,
                    0.92436,
                    0.86958,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.94438,
                    0.93704,
                    0.93704,
                    0.83689,
                    0.94438,
                    0.94438,
                    0.95353,
                    0.94083,
                    0.94083,
                    0.94083,
                    0.94083,
                    0.94083,
                    0.91905,
                    0.89192,
                    0.90406,
                    0.90406,
                    0.90406,
                    0.90406,
                    0.90406,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.90088,
                    1,
                    0.94938,
                    0.9031,
                    0.9031,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.94938,
                    0.94836,
                    0.94836,
                    0.94938,
                    0.93884,
                    0.83181,
                    0.94938,
                    1.08595,
                    0.94938,
                    0.94938,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.02058,
                    1.02058,
                    1.16661,
                    0.78966,
                    0.94938,
                    0.97898,
                    1.18777,
                    1.01149,
                    0.96174,
                    1,
                    0.80687,
                    0.80687,
                    0.94292,
                    0.94292,
                    0.90088,
                    1,
                    1.01149,
                    0.96544,
                    0.81093,
                    0.81093,
                    0.90088,
                    1,
                    1,
                    0.81093,
                    0.81093,
                    0.81093,
                    0.81093,
                    0.90088,
                    0.99793,
                    0.87548,
                    1,
                    0.90088,
                    1,
                    1,
                    0.78076,
                    0.93582,
                    1,
                    1,
                    0.91882,
                    0.99793,
                    1,
                    0.97571,
                    0.94219,
                    0.94219,
                    0.84313,
                    0.97571,
                    0.89022,
                    0.9498,
                    1,
                    0.90088,
                    1,
                    0.9358,
                    1.08595,
                    1,
                    1,
                    0.99793,
                    0.90088,
                    0.98621,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.94938,
                    0.99793,
                    1,
                    1,
                    0.94938,
                    1,
                    0.89903,
                    0.95933,
                    0.94938,
                    0.98607,
                    1.0373,
                    1.02058,
                    1,
                    1.36145,
                    0.95933,
                    0.95933,
                    0.93969,
                    0.80479,
                    1,
                    0.80479,
                    1.024,
                    1,
                    1,
                    1,
                    0.99793,
                    1,
                    1,
                    0.99793,
                    0.99793,
                    1,
                    1,
                    0.9577,
                    0.92601,
                    0.9577,
                    0.9577,
                    1,
                    0.9577,
                    0.98225,
                    0.90088,
                    1,
                    1.02058,
                    1.08595,
                    0.8361,
                    0.8361,
                    0.81079,
                    0.81079,
                    0.95933,
                    0.95933,
                    0.95933,
                    1,
                    1,
                    0.90088,
                    1,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    1.01591,
                    0.98621,
                    1.05486,
                    1.30692,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.98621,
                    1.0078,
                    1.0078,
                    1.0078,
                    1.0078,
                    0.98621,
                    1.0474,
                    1.0474,
                    0.97455,
                    0.98275,
                    1,
                    0.97455,
                    0.98981,
                    0.98981,
                    0.9314,
                    0.73977,
                    1,
                    0.73903,
                    1.02058,
                    1.08595,
                    1,
                    1,
                    1.02058,
                    1,
                    1.16161,
                    1.033,
                    1,
                    0.9672,
                    0.54324,
                    1,
                    1,
                    1.02058,
                    1,
                    0.95617,
                    1.02058,
                    1,
                    1,
                    0.95933,
                    0.95933,
                    0.8271,
                    0.95933,
                    1,
                    0.99793,
                    1,
                    1.08595,
                    0.95933,
                    0.91701,
                    0.98894,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.91964,
                    0.90088,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.86774,
                    0.86774,
                    0.9446,
                    0.9446,
                    0.99793,
                    1,
                    0.99642,
                    0.99642,
                    1,
                    1.0213,
                    1.05686,
                    1,
                    0.9446,
                    0.9446,
                    0.9446,
                    0.97898,
                    0.97455,
                    0.94292,
                    0.94292,
                    1.17173,
                    0.9897,
                    0.93582,
                    1.285,
                    1,
                    0.99394,
                    0.78367,
                    1.02058,
                    1.08595,
                    0.80535,
                    0.96361,
                    0.97407,
                    0.72851,
                    0.72851,
                    0.83734,
                    0.918,
                    0.908,
                    0.908,
                    0.93582,
                    1,
                    0.93582,
                    0.93582,
                    0.86209,
                    0.97646,
                    0.97646,
                    1.0732,
                    0.97646,
                    1,
                    0.62295,
                    1,
                    0.9553,
                    0.90088,
                    1,
                    0.78036,
                    0.78036,
                    0.78036,
                    1,
                    0.78036,
                    1,
                    1,
                    1.00872,
                    0.99793,
                    1,
                    1,
                    1,
                    0.86832,
                    1,
                    0.99793,
                    1.19137,
                    1,
                    1,
                    0.99793,
                    0.76169,
                    1,
                    1.10208,
                    1.0128,
                    1.10208,
                    0.77452,
                    1,
                    1.05453,
                    0.97898,
                    0.99793,
                    1,
                    0.99642,
                    0.90088,
                    1,
                    0.90989,
                    0.65,
                    1,
                    1,
                    1,
                    1,
                    0.99793,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.95442,
                    0.89903,
                    1,
                    0.72706,
                    0.96694,
                    1,
                    1,
                    1,
                    1,
                    0.89713,
                    1.10208,
                    0.90088,
                    0.78076,
                    1,
                    1,
                    1,
                    1,
                    0.96694,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.74854,
                    0.93582,
                    1,
                    1,
                    1,
                    1,
                    0.95442,
                    1,
                    0.95871,
                    0.95871,
                    0.95871,
                    0.95871,
                    0.95442,
                    0.95442,
                    0.95298,
                    0.97579,
                    0.97579,
                    0.97579,
                    0.97579,
                    0.97579,
                    0.9332,
                    1.05993,
                    0.94039,
                    0.94039,
                    0.94039,
                    0.94039,
                    0.99793,
                    0.94039,
                    0.938,
                    0.938,
                    0.938,
                    0.938,
                    0.99793,
                    0.95776
                ];
                exports.MyriadProBoldFactors = MyriadProBoldFactors;
                const MyriadProBoldLineHeight = 1.2;
                exports.MyriadProBoldLineHeight = MyriadProBoldLineHeight;
                const MyriadProBoldItalicFactors = [
                    1.36898,
                    1,
                    0.85576,
                    0.845,
                    0.845,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.85576,
                    0.80591,
                    0.80591,
                    0.80729,
                    0.80729,
                    0.80729,
                    0.80729,
                    0.80729,
                    0.80729,
                    0.85308,
                    0.94299,
                    0.94299,
                    0.95961,
                    0.94729,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.92098,
                    0.77512,
                    0.77512,
                    0.66862,
                    0.92222,
                    0.7927,
                    0.95961,
                    0.97276,
                    0.83655,
                    0.86523,
                    0.7805,
                    0.86523,
                    0.86523,
                    1,
                    0.86523,
                    0.92222,
                    1,
                    1,
                    1,
                    1,
                    0.92222,
                    0.92222,
                    0.98621,
                    0.86036,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.98621,
                    0.69323,
                    0.98621,
                    0.71743,
                    0.71743,
                    0.81698,
                    0.81698,
                    1,
                    0.79726,
                    0.79726,
                    0.92655,
                    0.79726,
                    1,
                    0.79726,
                    0.81691,
                    0.98558,
                    0.98558,
                    0.92222,
                    0.92222,
                    0.92222,
                    1,
                    0.92222,
                    0.92222,
                    0.90637,
                    0.909,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.90637,
                    0.92346,
                    0.89711,
                    0.90637,
                    0.88127,
                    0.90251,
                    0.90251,
                    0.90637,
                    0.83809,
                    0.93157,
                    0.90976,
                    0.83392,
                    0.90637,
                    0.80729,
                    0.80729,
                    0.80729,
                    1,
                    0.83809,
                    0.76463,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.76463,
                    0.76463,
                    1,
                    0.76463,
                    1,
                    0.94523,
                    0.86275,
                    0.86275,
                    0.86275,
                    0.86275,
                    1,
                    0.90637,
                    0.83659,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.90699,
                    0.83509,
                    0.83509,
                    0.72459,
                    0.90699,
                    0.90699,
                    0.91605,
                    0.9154,
                    0.9154,
                    0.9154,
                    0.9154,
                    0.9154,
                    0.85308,
                    0.85359,
                    0.85458,
                    0.85458,
                    0.85458,
                    0.85458,
                    0.85458,
                    0.90531,
                    0.90531,
                    0.90531,
                    0.90531,
                    0.90531,
                    0.99613,
                    0.99613,
                    0.99613,
                    0.99613,
                    1.18616,
                    1,
                    0.99613,
                    0.85811,
                    0.85811,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99613,
                    0.92886,
                    0.92886,
                    0.99613,
                    0.92222,
                    0.80178,
                    0.99613,
                    1.08595,
                    0.99613,
                    0.99613,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.02058,
                    1.02058,
                    1.16148,
                    0.76813,
                    0.99613,
                    0.91677,
                    1.21296,
                    0.8578,
                    0.90557,
                    1,
                    0.80687,
                    0.80687,
                    0.94292,
                    0.94292,
                    1.18616,
                    1,
                    0.8578,
                    0.95973,
                    0.78216,
                    0.78216,
                    1.18616,
                    1,
                    1,
                    0.78216,
                    0.78216,
                    0.78216,
                    0.78216,
                    1.18616,
                    0.97276,
                    0.81539,
                    1,
                    1.18616,
                    1,
                    1,
                    0.78076,
                    0.93582,
                    1,
                    1,
                    0.91339,
                    0.97276,
                    1,
                    0.91677,
                    0.9332,
                    0.9332,
                    0.76783,
                    0.91677,
                    0.89022,
                    0.90276,
                    1,
                    1.18616,
                    1,
                    1.30628,
                    1.08595,
                    1,
                    1,
                    0.97276,
                    1.18616,
                    0.95381,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.97276,
                    1,
                    1,
                    0.90083,
                    1,
                    0.89903,
                    0.92168,
                    0.90083,
                    0.91324,
                    0.91324,
                    1.02058,
                    1,
                    1.36145,
                    0.92168,
                    0.92168,
                    0.9135,
                    0.80779,
                    1,
                    0.80779,
                    0.98796,
                    1,
                    1,
                    1,
                    0.97276,
                    1,
                    1,
                    0.97276,
                    0.97276,
                    1,
                    1,
                    0.9135,
                    0.86847,
                    0.9135,
                    0.9135,
                    1,
                    0.9135,
                    0.94951,
                    1.18616,
                    1,
                    1.02058,
                    1.08595,
                    0.82891,
                    0.82711,
                    0.80479,
                    0.80178,
                    0.92168,
                    0.92168,
                    0.92168,
                    1,
                    1,
                    1.18616,
                    1,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.97096,
                    0.95381,
                    1.05486,
                    1.23026,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.95381,
                    0.98981,
                    0.98981,
                    0.95298,
                    0.9224,
                    1,
                    0.95298,
                    0.95381,
                    0.95381,
                    0.85408,
                    0.6894,
                    1,
                    0.74321,
                    1.02058,
                    1.08595,
                    1,
                    1,
                    1.02058,
                    1,
                    1.20006,
                    1.0006,
                    1,
                    0.93459,
                    0.71526,
                    1,
                    1,
                    1.02058,
                    1,
                    0.92699,
                    1.02058,
                    1,
                    1,
                    0.92168,
                    0.92168,
                    0.79464,
                    0.92168,
                    1,
                    0.97276,
                    1,
                    1.08595,
                    0.92168,
                    0.86847,
                    0.97276,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.87514,
                    1.18616,
                    0.91513,
                    0.91513,
                    0.91513,
                    0.85923,
                    0.85923,
                    0.91513,
                    0.91513,
                    0.97276,
                    1,
                    0.99043,
                    0.99043,
                    1,
                    1.08074,
                    1.04864,
                    1,
                    0.91677,
                    0.91677,
                    0.91513,
                    0.92004,
                    0.96736,
                    0.94292,
                    0.94292,
                    1.14542,
                    0.97733,
                    0.93582,
                    1.26,
                    1,
                    0.97355,
                    0.80487,
                    1.02058,
                    1.08595,
                    0.79199,
                    0.89398,
                    0.91677,
                    0.71541,
                    0.71541,
                    0.81625,
                    0.896,
                    0.896,
                    0.896,
                    0.91782,
                    1,
                    0.91782,
                    0.91782,
                    0.83266,
                    0.95077,
                    0.95077,
                    1.03493,
                    0.95077,
                    1,
                    0.55509,
                    1,
                    0.93481,
                    1.18616,
                    1,
                    0.748,
                    0.748,
                    0.748,
                    1,
                    0.748,
                    1,
                    1,
                    0.99973,
                    0.97276,
                    1,
                    1,
                    1,
                    0.88159,
                    1,
                    0.97276,
                    1.17337,
                    1,
                    1,
                    0.97276,
                    0.78694,
                    1,
                    1.04502,
                    1.05214,
                    1.04502,
                    0.72651,
                    1,
                    0.99531,
                    0.92332,
                    0.97276,
                    1,
                    0.99043,
                    1.18616,
                    1,
                    1.00899,
                    0.698,
                    1,
                    1,
                    1,
                    1,
                    0.97276,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.91677,
                    0.89903,
                    1,
                    0.66227,
                    0.96694,
                    1,
                    1,
                    1,
                    1,
                    0.86275,
                    1.04502,
                    1.18616,
                    0.78076,
                    1,
                    1,
                    1,
                    1,
                    0.96694,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.85633,
                    0.93582,
                    1,
                    1,
                    1,
                    1,
                    0.91677,
                    1,
                    0.90646,
                    0.90646,
                    0.90646,
                    0.90646,
                    0.91677,
                    0.91677,
                    0.92061,
                    0.94236,
                    0.94236,
                    0.94236,
                    0.94236,
                    0.94236,
                    0.89544,
                    1.0051,
                    0.89364,
                    0.89364,
                    0.89364,
                    0.89364,
                    0.97276,
                    0.89364,
                    0.9,
                    0.9,
                    0.9,
                    0.9,
                    0.97276,
                    0.86842
                ];
                exports.MyriadProBoldItalicFactors = MyriadProBoldItalicFactors;
                const MyriadProBoldItalicLineHeight = 1.2;
                exports.MyriadProBoldItalicLineHeight = MyriadProBoldItalicLineHeight;
                const MyriadProItalicFactors = [
                    1.36898,
                    1,
                    0.85158,
                    0.773,
                    0.773,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.85158,
                    0.77812,
                    0.77812,
                    0.76852,
                    0.76852,
                    0.76852,
                    0.76852,
                    0.76852,
                    0.76852,
                    0.78112,
                    0.89591,
                    0.89591,
                    0.90561,
                    0.88836,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.70466,
                    0.87396,
                    0.70466,
                    0.70466,
                    0.62264,
                    0.86822,
                    0.7646,
                    0.90561,
                    0.88465,
                    0.76125,
                    0.80094,
                    0.76449,
                    0.80094,
                    0.80094,
                    1,
                    0.80094,
                    0.86822,
                    1,
                    1,
                    1,
                    1,
                    0.86822,
                    0.86822,
                    0.83864,
                    0.81402,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.83864,
                    0.65351,
                    0.83864,
                    0.728,
                    0.728,
                    0.77212,
                    0.77212,
                    1,
                    0.79475,
                    0.79475,
                    0.85308,
                    0.79475,
                    1,
                    0.79475,
                    0.80553,
                    0.93637,
                    0.93637,
                    0.87514,
                    0.87514,
                    0.87514,
                    1,
                    0.87514,
                    0.87514,
                    0.8588,
                    0.867,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.8588,
                    0.89386,
                    0.89947,
                    0.8588,
                    0.86026,
                    0.85751,
                    0.85751,
                    0.8588,
                    0.76013,
                    0.82565,
                    0.85701,
                    0.77899,
                    0.8588,
                    0.72421,
                    0.72421,
                    0.72421,
                    1,
                    0.76013,
                    0.69866,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.69866,
                    0.69866,
                    1,
                    0.69866,
                    1,
                    0.89058,
                    0.77598,
                    0.77598,
                    0.77598,
                    0.77598,
                    1,
                    0.8588,
                    0.76013,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.85991,
                    0.8156,
                    0.8156,
                    0.69461,
                    0.85991,
                    0.85991,
                    0.80811,
                    0.87832,
                    0.87832,
                    0.87832,
                    0.87832,
                    0.87832,
                    0.78112,
                    0.82352,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.77512,
                    0.8562,
                    0.8562,
                    0.8562,
                    0.8562,
                    0.8562,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    1.15012,
                    1,
                    0.93859,
                    0.8075,
                    0.8075,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.93859,
                    0.9486,
                    0.9486,
                    0.93859,
                    0.88307,
                    0.77025,
                    0.93859,
                    1.08595,
                    0.93859,
                    0.93859,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.27014,
                    1.02058,
                    1.06383,
                    0.70926,
                    0.93859,
                    0.94399,
                    1.18417,
                    0.83537,
                    0.93298,
                    1,
                    0.85034,
                    0.85034,
                    1.0222,
                    1.0222,
                    1.15012,
                    1,
                    0.83537,
                    0.79121,
                    0.846,
                    0.846,
                    1.15012,
                    1,
                    1,
                    0.846,
                    0.846,
                    0.846,
                    0.846,
                    1.15012,
                    0.88465,
                    0.77487,
                    1,
                    1.15012,
                    1,
                    1,
                    0.75945,
                    0.75945,
                    1,
                    1,
                    0.9161,
                    0.88465,
                    1,
                    0.94399,
                    0.86847,
                    0.86847,
                    0.8544,
                    0.94399,
                    0.79519,
                    0.93942,
                    1,
                    1.15012,
                    1,
                    1.03901,
                    1.08595,
                    1,
                    1,
                    0.88465,
                    1.15012,
                    0.82424,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.81453,
                    0.88465,
                    1,
                    1,
                    0.81453,
                    1,
                    0.89903,
                    0.96017,
                    0.81453,
                    0.92388,
                    0.92388,
                    1.02058,
                    1,
                    1.36145,
                    0.96186,
                    0.96186,
                    0.9278,
                    0.84943,
                    1,
                    0.70869,
                    1.0186,
                    1,
                    1,
                    1,
                    0.88465,
                    1,
                    1,
                    0.88465,
                    0.88465,
                    1,
                    1,
                    0.94219,
                    0.878,
                    0.94219,
                    0.94219,
                    1,
                    0.94219,
                    0.88075,
                    1.15012,
                    1,
                    1.02058,
                    1.08595,
                    0.73541,
                    0.73361,
                    0.73572,
                    0.73572,
                    0.96017,
                    0.96017,
                    0.96017,
                    1,
                    1,
                    1.15012,
                    1,
                    1.03075,
                    0.82424,
                    0.82424,
                    0.82424,
                    0.82424,
                    0.82424,
                    1.02738,
                    0.82424,
                    1.02119,
                    1.06233,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.03075,
                    1.03075,
                    1.03075,
                    1.03075,
                    1.03075,
                    0.82424,
                    1.02175,
                    1.02175,
                    0.912,
                    0.922,
                    1,
                    0.912,
                    1.03075,
                    1.03075,
                    0.88787,
                    0.83911,
                    1,
                    0.66266,
                    1.02058,
                    1.08595,
                    1,
                    1,
                    1.02058,
                    1,
                    1.05233,
                    1.06676,
                    1,
                    0.96998,
                    0.69353,
                    1,
                    1,
                    1.02058,
                    1,
                    0.95829,
                    1.02058,
                    1,
                    1,
                    0.96017,
                    0.96017,
                    0.86865,
                    0.96017,
                    1,
                    0.88465,
                    1,
                    1.08595,
                    0.96017,
                    0.88,
                    0.88465,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.84759,
                    1.15012,
                    0.93859,
                    0.93859,
                    0.93859,
                    0.86799,
                    0.86799,
                    0.93859,
                    0.93859,
                    0.88465,
                    1,
                    0.9005,
                    0.9005,
                    1,
                    0.94565,
                    0.9446,
                    1,
                    0.8562,
                    0.8562,
                    0.93859,
                    0.94399,
                    0.91974,
                    0.85283,
                    0.85283,
                    1.04828,
                    0.86936,
                    0.75945,
                    1.124,
                    1,
                    0.93969,
                    0.78815,
                    1.02058,
                    1.08595,
                    0.74948,
                    0.85769,
                    0.94399,
                    0.69046,
                    0.62864,
                    0.85639,
                    1.027,
                    1.027,
                    1.027,
                    0.87321,
                    1,
                    0.87321,
                    0.87321,
                    0.86948,
                    0.95493,
                    0.95493,
                    0.98391,
                    0.95493,
                    1,
                    0.53609,
                    1,
                    0.93758,
                    1.15313,
                    1,
                    0.746,
                    0.746,
                    0.746,
                    1,
                    0.746,
                    1,
                    1,
                    0.90083,
                    0.88465,
                    1,
                    1,
                    1,
                    0.89217,
                    1,
                    0.88465,
                    1.17337,
                    1,
                    1,
                    0.88465,
                    0.75187,
                    1,
                    1.12658,
                    1.03737,
                    1.12658,
                    0.88417,
                    1,
                    0.95119,
                    0.94578,
                    0.88465,
                    1,
                    0.9005,
                    1.15012,
                    1,
                    1.08106,
                    0.669,
                    1,
                    1,
                    1,
                    1,
                    0.88465,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.94578,
                    0.89903,
                    1,
                    0.65507,
                    0.9219,
                    1,
                    1,
                    1,
                    1,
                    0.77598,
                    1.12658,
                    1.15012,
                    0.75945,
                    1,
                    1,
                    1,
                    1,
                    0.9219,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.85034,
                    0.75945,
                    1,
                    1,
                    1,
                    1,
                    0.94578,
                    1,
                    0.91123,
                    0.91123,
                    0.91123,
                    0.91123,
                    0.94578,
                    0.94578,
                    0.91,
                    0.979,
                    0.979,
                    0.979,
                    0.979,
                    0.979,
                    0.882,
                    0.93559,
                    0.882,
                    0.882,
                    0.882,
                    0.882,
                    0.88465,
                    0.882,
                    0.83,
                    0.83,
                    0.83,
                    0.83,
                    0.88465,
                    0.84596
                ];
                exports.MyriadProItalicFactors = MyriadProItalicFactors;
                const MyriadProItalicLineHeight = 1.2;
                exports.MyriadProItalicLineHeight = MyriadProItalicLineHeight;
                const MyriadProRegularFactors = [
                    1.36898,
                    1,
                    0.91755,
                    0.788,
                    0.788,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.92138,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.91755,
                    0.8126,
                    0.8126,
                    0.80314,
                    0.80314,
                    0.80314,
                    0.80314,
                    0.80314,
                    0.80314,
                    0.85608,
                    0.92222,
                    0.92222,
                    0.92915,
                    0.92819,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.73764,
                    0.90991,
                    0.73764,
                    0.73764,
                    0.7154,
                    0.90284,
                    0.86169,
                    0.92915,
                    0.92241,
                    0.79726,
                    0.83051,
                    0.81884,
                    0.83051,
                    0.83051,
                    1,
                    0.83051,
                    0.90284,
                    1,
                    1,
                    1,
                    1,
                    0.90976,
                    0.90284,
                    0.86023,
                    0.82873,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.86023,
                    0.80513,
                    0.86023,
                    0.74,
                    0.74,
                    0.8126,
                    0.8126,
                    1,
                    0.84869,
                    0.84869,
                    0.91172,
                    0.84869,
                    1,
                    0.84869,
                    0.85588,
                    0.96518,
                    0.96518,
                    0.91115,
                    0.91115,
                    0.91115,
                    1,
                    0.91115,
                    0.91115,
                    0.8858,
                    0.894,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.94307,
                    0.98612,
                    0.8858,
                    0.94007,
                    0.8858,
                    0.8858,
                    0.8858,
                    0.79761,
                    0.89992,
                    0.87791,
                    0.81992,
                    0.8858,
                    0.74498,
                    0.74498,
                    0.74498,
                    1,
                    0.79761,
                    0.73914,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.73914,
                    0.73914,
                    1,
                    0.73914,
                    1,
                    0.89297,
                    0.81363,
                    0.81363,
                    0.81363,
                    0.81363,
                    1,
                    0.8858,
                    0.79611,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.89591,
                    0.88157,
                    0.88157,
                    0.82528,
                    0.89591,
                    0.89591,
                    0.83659,
                    0.89633,
                    0.89633,
                    0.89633,
                    0.89633,
                    0.89633,
                    0.85608,
                    0.83089,
                    0.8111,
                    0.8111,
                    0.8111,
                    0.8111,
                    0.8111,
                    0.90531,
                    0.90531,
                    0.90531,
                    0.90531,
                    0.90531,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.86667,
                    0.90088,
                    0.86667,
                    0.86936,
                    0.86936,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.86667,
                    0.95308,
                    0.95308,
                    0.86667,
                    0.90706,
                    0.78105,
                    0.86667,
                    1.08595,
                    0.86667,
                    0.86667,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.27014,
                    1.02058,
                    1.0664,
                    0.72601,
                    0.86667,
                    1.0231,
                    1.22736,
                    0.92006,
                    0.97358,
                    1,
                    0.85034,
                    0.85034,
                    1.0222,
                    1.0222,
                    0.90088,
                    0.92006,
                    0.80549,
                    0.896,
                    0.896,
                    0.90088,
                    0.896,
                    0.896,
                    0.896,
                    0.896,
                    0.90088,
                    0.92241,
                    0.87064,
                    1,
                    0.90088,
                    1,
                    0.74505,
                    0.74505,
                    0.91882,
                    0.92241,
                    1.01411,
                    0.89903,
                    0.89903,
                    0.93372,
                    1.01411,
                    0.79519,
                    0.98088,
                    1,
                    0.90088,
                    1.03901,
                    1.08595,
                    1,
                    1,
                    0.92241,
                    0.90088,
                    0.84224,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.90083,
                    0.92241,
                    1,
                    0.90083,
                    1,
                    0.89903,
                    0.99793,
                    0.90083,
                    0.98699,
                    0.98699,
                    1.02058,
                    1,
                    1.36145,
                    0.99793,
                    0.99793,
                    0.97276,
                    0.82784,
                    1,
                    0.69067,
                    1.05099,
                    1,
                    1,
                    1,
                    0.92241,
                    1,
                    0.92241,
                    0.92241,
                    1,
                    1.00512,
                    0.928,
                    1.00512,
                    1.00512,
                    1,
                    1.00512,
                    0.89713,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.90088,
                    1.02058,
                    1.08595,
                    0.75339,
                    0.75339,
                    0.76575,
                    0.76575,
                    0.99793,
                    0.99793,
                    0.99793,
                    1,
                    1,
                    0.90088,
                    1.05326,
                    0.84224,
                    0.84224,
                    0.84224,
                    0.84224,
                    0.84224,
                    1.07469,
                    0.84224,
                    1.02119,
                    1.1536,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.05326,
                    1.06226,
                    1.06226,
                    1.06226,
                    1.06226,
                    0.84224,
                    1.09377,
                    1.09377,
                    0.938,
                    0.986,
                    1,
                    0.938,
                    1.06226,
                    1.06226,
                    0.944,
                    0.83704,
                    1,
                    0.81441,
                    1.02058,
                    1.08595,
                    1,
                    1,
                    1.02058,
                    1,
                    1.05638,
                    1.08927,
                    1,
                    1.00119,
                    0.54324,
                    1,
                    1,
                    1.02058,
                    1,
                    0.95978,
                    1.02058,
                    1,
                    1,
                    0.99793,
                    0.99793,
                    0.91887,
                    0.99793,
                    1,
                    0.92241,
                    1,
                    1.08595,
                    0.99793,
                    0.938,
                    0.89364,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.91434,
                    0.90088,
                    0.98714,
                    0.98714,
                    0.98714,
                    0.88888,
                    0.88888,
                    0.98714,
                    0.98714,
                    0.92241,
                    1,
                    0.91009,
                    0.91009,
                    1,
                    0.93484,
                    0.97198,
                    1,
                    0.89876,
                    0.89876,
                    0.98714,
                    1.0231,
                    0.95325,
                    0.85283,
                    0.85283,
                    1.07257,
                    0.89073,
                    0.74505,
                    1.156,
                    1,
                    0.99007,
                    0.80442,
                    1.02058,
                    1.08595,
                    0.74705,
                    0.91879,
                    1.01231,
                    0.73002,
                    0.66466,
                    0.94935,
                    1.06904,
                    1.06304,
                    1.06304,
                    0.93173,
                    1,
                    0.93173,
                    0.93173,
                    0.98472,
                    0.98196,
                    0.98196,
                    1.024,
                    0.98196,
                    1,
                    0.56866,
                    1,
                    0.98972,
                    0.90088,
                    1,
                    0.792,
                    0.792,
                    0.792,
                    1,
                    0.792,
                    1,
                    1,
                    0.9332,
                    0.92241,
                    1,
                    1,
                    0.89762,
                    1,
                    0.92241,
                    1.23456,
                    1,
                    1,
                    0.92241,
                    0.71119,
                    1,
                    1.19137,
                    1.04552,
                    1.19137,
                    0.904,
                    1,
                    0.96017,
                    1.0231,
                    0.92241,
                    1,
                    0.91009,
                    0.90088,
                    0.90388,
                    0.619,
                    1,
                    1,
                    1,
                    1,
                    0.92241,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.99074,
                    0.89903,
                    1,
                    0.76305,
                    0.9219,
                    1,
                    1,
                    1,
                    1,
                    0.81363,
                    1.19137,
                    0.90088,
                    0.74505,
                    1,
                    1,
                    1,
                    1,
                    0.9219,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.72458,
                    0.74505,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.99074,
                    1,
                    0.95817,
                    0.95817,
                    0.95817,
                    0.95817,
                    0.99074,
                    0.99074,
                    0.962,
                    1.01915,
                    1.01915,
                    1.01915,
                    1.01915,
                    1.01915,
                    0.926,
                    0.96705,
                    0.942,
                    0.942,
                    0.942,
                    0.942,
                    0.92241,
                    0.942,
                    0.856,
                    0.856,
                    0.856,
                    0.856,
                    0.92241,
                    0.92761
                ];
                exports.MyriadProRegularFactors = MyriadProRegularFactors;
                const MyriadProRegularLineHeight = 1.2;
                exports.MyriadProRegularLineHeight = MyriadProRegularLineHeight;
            /***/ },
            /* 60 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SegoeuiRegularLineHeight = exports.SegoeuiRegularFactors = exports.SegoeuiItalicLineHeight = exports.SegoeuiItalicFactors = exports.SegoeuiBoldLineHeight = exports.SegoeuiBoldItalicLineHeight = exports.SegoeuiBoldItalicFactors = exports.SegoeuiBoldFactors = void 0;
                const SegoeuiBoldFactors = [
                    1.76738,
                    1,
                    0.97363,
                    0.93506,
                    0.93506,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    1.01149,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.88776,
                    0.88776,
                    0.8641,
                    0.8641,
                    0.8641,
                    0.8641,
                    0.8641,
                    0.8641,
                    0.98243,
                    1.02096,
                    1.02096,
                    1.02096,
                    0.97826,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    0.79795,
                    1.09251,
                    0.79795,
                    0.79795,
                    0.7676,
                    1.06085,
                    0.98167,
                    1.02096,
                    1.03424,
                    0.85132,
                    0.914,
                    0.85134,
                    0.914,
                    0.914,
                    1,
                    0.914,
                    1.06085,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1.06085,
                    1.06085,
                    1.1406,
                    0.97138,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.01134,
                    1.1406,
                    0.8007,
                    0.8007,
                    0.89858,
                    0.89858,
                    1,
                    0.83693,
                    0.83693,
                    1.0388,
                    0.83693,
                    1,
                    0.83693,
                    0.83693,
                    1.14889,
                    1.14889,
                    1.09398,
                    1.09398,
                    1.09398,
                    1,
                    1.09398,
                    1.09398,
                    0.97489,
                    0.93994,
                    0.97426,
                    0.97489,
                    0.97426,
                    0.97426,
                    0.97426,
                    0.97489,
                    0.97489,
                    0.95493,
                    1.03089,
                    0.97489,
                    1.02546,
                    0.97489,
                    0.97489,
                    0.97426,
                    0.92094,
                    0.99346,
                    1.0595,
                    1.02112,
                    0.97489,
                    0.90399,
                    0.90399,
                    0.90399,
                    1,
                    0.92094,
                    0.84041,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.84041,
                    0.84041,
                    0.84041,
                    0.84041,
                    1,
                    0.94793,
                    0.95923,
                    0.95923,
                    0.95923,
                    0.95923,
                    1,
                    0.97489,
                    0.92094,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    0.90996,
                    0.90996,
                    0.84097,
                    1.00135,
                    1.00135,
                    1,
                    1.06467,
                    1.06467,
                    1.06467,
                    1.06467,
                    1.06467,
                    0.98243,
                    0.86039,
                    0.90996,
                    0.90996,
                    0.90996,
                    0.90996,
                    0.90996,
                    0.99361,
                    0.99361,
                    0.99361,
                    0.99361,
                    0.99361,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.91056,
                    1,
                    0.96752,
                    0.93136,
                    0.93136,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.96752,
                    1.03574,
                    1.03574,
                    0.96752,
                    1.17647,
                    0.81525,
                    0.96752,
                    1.29004,
                    0.96752,
                    0.96752,
                    0.86182,
                    0.94434,
                    0.86279,
                    0.86279,
                    0.94434,
                    1,
                    1,
                    1.2107,
                    1.2107,
                    1.16939,
                    0.97847,
                    0.96752,
                    1.01519,
                    1.56942,
                    1.16579,
                    1.0192,
                    1,
                    0.94856,
                    0.94856,
                    1.1085,
                    1.1085,
                    1.03959,
                    1,
                    1.16579,
                    1.20642,
                    0.86304,
                    0.86304,
                    1.15103,
                    1,
                    1,
                    0.86304,
                    0.86304,
                    0.86304,
                    0.86304,
                    0.64663,
                    1.03424,
                    0.96268,
                    1.42603,
                    1.15103,
                    1,
                    1.04315,
                    0.81378,
                    0.9754,
                    1,
                    1,
                    1.18622,
                    1,
                    1,
                    1.01359,
                    0.73047,
                    0.73047,
                    1.03057,
                    1.03517,
                    0.94994,
                    1.00886,
                    1.34163,
                    1.3871,
                    1,
                    0.87815,
                    1.28826,
                    1,
                    1,
                    1.03424,
                    0.75953,
                    1.02285,
                    0.97278,
                    0.97278,
                    0.97278,
                    0.97278,
                    0.97278,
                    0.97278,
                    0.97278,
                    0.97278,
                    1.03424,
                    1,
                    0.91211,
                    0.97278,
                    1,
                    0.89903,
                    0.99041,
                    0.97278,
                    0.97531,
                    1.02597,
                    1.2107,
                    1.21172,
                    1,
                    1.0008,
                    1.0008,
                    0.97122,
                    0.9824,
                    0.96039,
                    0.9824,
                    1.15103,
                    1,
                    1.42603,
                    1,
                    1.03424,
                    1.15749,
                    1,
                    1.03424,
                    1.03424,
                    1,
                    0.93503,
                    1.01359,
                    1.01932,
                    1.01359,
                    1.01359,
                    1,
                    1.01359,
                    1.02798,
                    0.94282,
                    1,
                    1.2107,
                    1.29004,
                    1.04478,
                    1.04478,
                    1.03372,
                    1.03372,
                    0.98561,
                    1.00879,
                    0.98561,
                    1.15296,
                    1,
                    1.21994,
                    1,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.08692,
                    1.02285,
                    1.13973,
                    2.10339,
                    1,
                    1,
                    0.9716,
                    1.42603,
                    1.42603,
                    1,
                    1.02285,
                    1.18102,
                    1.18102,
                    1.18102,
                    1.18102,
                    1.02285,
                    1.02285,
                    1.02285,
                    1.00527,
                    1.02277,
                    1,
                    1.00527,
                    1.02285,
                    1.02285,
                    0.98683,
                    0.9455,
                    1,
                    0.90418,
                    1.2107,
                    1.29004,
                    1,
                    1.03424,
                    1.2107,
                    1.07733,
                    1.18874,
                    1.13005,
                    1,
                    1.0302,
                    0.75155,
                    1,
                    1,
                    1.2107,
                    1.222,
                    1.0016,
                    1.2107,
                    1,
                    1,
                    0.99041,
                    0.99041,
                    0.96692,
                    0.99041,
                    1,
                    1.03424,
                    1,
                    1.29004,
                    0.99041,
                    0.99561,
                    1.06497,
                    1.0008,
                    1,
                    1.0008,
                    1,
                    1,
                    0.97931,
                    0.79912,
                    1,
                    1.0008,
                    1.0008,
                    0.98439,
                    0.98439,
                    1.0008,
                    1.0008,
                    1.03424,
                    1.15749,
                    1.15749,
                    1.14169,
                    0.99862,
                    1.10818,
                    1.24866,
                    0.69825,
                    1.0008,
                    1.0008,
                    1,
                    1.01519,
                    0.91572,
                    1.1085,
                    1.1085,
                    1.16897,
                    0.97529,
                    0.9754,
                    1.25635,
                    1.19687,
                    1.04983,
                    0.90434,
                    1.2107,
                    1.28826,
                    0.96085,
                    1.0499,
                    1.01359,
                    0.71703,
                    0.71703,
                    1.04016,
                    0.98633,
                    0.98633,
                    0.98633,
                    1.04394,
                    1.04394,
                    1.04394,
                    1.04394,
                    1.23203,
                    1.02258,
                    1.02258,
                    1.18416,
                    1.02258,
                    1,
                    1.18622,
                    1,
                    0.99921,
                    0.81378,
                    1,
                    0.79104,
                    0.79104,
                    0.79104,
                    0.79104,
                    0.79104,
                    1,
                    1.02956,
                    0.8727,
                    1.03424,
                    1.10948,
                    1,
                    1,
                    0.8965,
                    0.93803,
                    1.03424,
                    1.59578,
                    1,
                    1.2886,
                    1.03424,
                    0.90137,
                    1,
                    1.16862,
                    1.23085,
                    1.16862,
                    1.07034,
                    1,
                    1.13189,
                    1.01519,
                    1.03424,
                    1.15749,
                    1.17389,
                    1.15103,
                    1,
                    0.95161,
                    0.771,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.03424,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.99041,
                    0.74627,
                    0.75155,
                    0.99297,
                    1.21408,
                    1.21408,
                    1.21408,
                    1,
                    1.18328,
                    0.95923,
                    1.16862,
                    1.01173,
                    0.81378,
                    0.79795,
                    1.09466,
                    0.97278,
                    1.02065,
                    1,
                    1.21408,
                    1.24633,
                    1.12454,
                    1,
                    1,
                    1,
                    0.9754,
                    1,
                    1,
                    1.09193,
                    1.09193,
                    0.99041,
                    1,
                    1.06628,
                    1.06628,
                    1.06628,
                    1.06628,
                    0.99041,
                    0.99041,
                    0.97454,
                    1.02511,
                    1.02511,
                    1.02511,
                    1.02511,
                    1.02511,
                    0.99298,
                    1.07237,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    1.03424,
                    0.96752,
                    0.95801,
                    0.95801,
                    0.95801,
                    0.95801,
                    1.03424,
                    1.0106
                ];
                exports.SegoeuiBoldFactors = SegoeuiBoldFactors;
                const SegoeuiBoldLineHeight = 1.33008;
                exports.SegoeuiBoldLineHeight = SegoeuiBoldLineHeight;
                const SegoeuiBoldItalicFactors = [
                    1.76738,
                    1,
                    0.97363,
                    0.94385,
                    0.94385,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    1.00811,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.97363,
                    0.89723,
                    0.89723,
                    0.87897,
                    0.87897,
                    0.87897,
                    0.87897,
                    0.87897,
                    0.87897,
                    0.9817,
                    1.0426,
                    1.0426,
                    1.0426,
                    1.09818,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    0.79429,
                    1.10466,
                    0.79429,
                    0.79429,
                    0.77702,
                    1.05815,
                    0.99137,
                    1.0426,
                    1.036,
                    0.85292,
                    0.91149,
                    0.86869,
                    0.91149,
                    0.91149,
                    1,
                    0.91149,
                    1.05815,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    1.05815,
                    1.05815,
                    1.1406,
                    0.97441,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    1.1406,
                    0.95253,
                    1.1406,
                    0.79631,
                    0.79631,
                    0.90128,
                    0.90128,
                    1,
                    0.83853,
                    0.83853,
                    1.06662,
                    0.83853,
                    1,
                    0.83853,
                    0.83853,
                    1.04396,
                    1.04396,
                    1.10615,
                    1.10615,
                    1.10615,
                    1,
                    1.10615,
                    1.10615,
                    0.97552,
                    0.91602,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.98999,
                    1.07205,
                    0.97552,
                    1.0347,
                    0.97552,
                    0.97552,
                    0.97552,
                    0.94436,
                    1.00356,
                    1.04694,
                    1.01945,
                    0.97552,
                    0.88641,
                    0.88641,
                    0.88641,
                    1,
                    0.94436,
                    0.80527,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.80527,
                    0.80527,
                    0.80527,
                    0.80527,
                    1,
                    0.98015,
                    0.96083,
                    0.96083,
                    0.95923,
                    0.96083,
                    1,
                    0.97552,
                    0.94436,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    1.00135,
                    0.91142,
                    0.91142,
                    0.86142,
                    1.00135,
                    1.00135,
                    1,
                    1.06777,
                    1.06777,
                    1.06777,
                    1.06777,
                    1.06777,
                    0.9817,
                    0.84918,
                    0.91142,
                    0.91142,
                    0.91142,
                    0.91142,
                    0.91142,
                    0.99361,
                    0.99361,
                    0.99361,
                    0.99361,
                    0.99361,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.06585,
                    1.31818,
                    1,
                    1.06585,
                    0.96705,
                    0.96705,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1.06585,
                    1.04961,
                    1.04961,
                    1.06585,
                    1.10953,
                    0.83284,
                    1.06585,
                    1.29004,
                    1.06585,
                    1.06585,
                    0.86224,
                    0.94434,
                    0.86364,
                    0.86279,
                    0.94434,
                    1,
                    1,
                    1.21237,
                    1.21237,
                    1.16939,
                    0.97847,
                    1.06585,
                    0.97042,
                    1.57293,
                    1.16579,
                    0.99607,
                    1,
                    0.95107,
                    0.95107,
                    1.11144,
                    1.11144,
                    1.31818,
                    1,
                    1.16579,
                    1.20502,
                    0.83055,
                    0.83055,
                    1.31818,
                    1,
                    1,
                    0.83055,
                    0.83055,
                    0.83055,
                    0.83055,
                    1.31818,
                    1.036,
                    0.93491,
                    1.42603,
                    1.31818,
                    1,
                    1.04315,
                    0.81378,
                    0.9754,
                    1,
                    1,
                    1.18754,
                    1,
                    1,
                    0.97042,
                    0.72959,
                    0.72959,
                    1.0033,
                    0.97042,
                    0.94994,
                    1.008,
                    1.34163,
                    1.31818,
                    1,
                    1.27126,
                    1.29004,
                    1,
                    1,
                    1.036,
                    1.31818,
                    1.14236,
                    0.93503,
                    0.93503,
                    0.93503,
                    0.93503,
                    0.93503,
                    0.93503,
                    0.93503,
                    0.93503,
                    1.036,
                    1,
                    0.91406,
                    0.93503,
                    1,
                    0.89903,
                    0.97922,
                    0.93503,
                    0.9898,
                    0.9898,
                    1.21237,
                    1.21339,
                    1,
                    1.00639,
                    1.00639,
                    0.93125,
                    1.03959,
                    0.96039,
                    1.03959,
                    1.1261,
                    1,
                    1.42603,
                    1,
                    1.036,
                    1.15574,
                    1,
                    1.036,
                    1.036,
                    1,
                    0.93327,
                    0.97042,
                    1.02897,
                    0.97042,
                    0.97042,
                    1,
                    0.97042,
                    0.98721,
                    1.31818,
                    1,
                    1.21237,
                    1.29004,
                    1.05356,
                    1.05356,
                    1.03372,
                    1.03372,
                    0.97922,
                    0.97922,
                    0.97922,
                    1.15296,
                    1,
                    1.31818,
                    1,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.04302,
                    1.14236,
                    1.13904,
                    2.10339,
                    1,
                    1,
                    0.9716,
                    1.42603,
                    1.42603,
                    1,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    1.14236,
                    0.94552,
                    1.01582,
                    1.01054,
                    1.00518,
                    1,
                    1.01054,
                    1.14236,
                    1.14236,
                    0.97981,
                    1.09125,
                    1,
                    0.90418,
                    1.21237,
                    1.29004,
                    1,
                    1.03336,
                    1.21237,
                    1.23199,
                    1.18775,
                    1.19508,
                    1,
                    1.02471,
                    0.79487,
                    1,
                    1,
                    1.21237,
                    1.222,
                    1.02186,
                    1.21237,
                    1,
                    1,
                    0.97922,
                    0.97922,
                    1.01034,
                    0.97922,
                    1,
                    1.036,
                    1,
                    1.29004,
                    0.97922,
                    1,
                    1.02809,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.91981,
                    1.31818,
                    0.94165,
                    0.94165,
                    0.94165,
                    1.00351,
                    1.00351,
                    0.94165,
                    0.94165,
                    1.036,
                    1.15574,
                    1.15574,
                    1.13934,
                    0.99862,
                    1.26781,
                    1.24866,
                    0.69825,
                    0.94165,
                    0.94165,
                    0.94165,
                    0.97042,
                    0.91484,
                    1.11144,
                    1.11144,
                    1.16798,
                    0.97639,
                    0.9754,
                    1.26514,
                    1.16541,
                    1.10687,
                    0.99314,
                    1.21237,
                    1.29004,
                    0.96085,
                    1.04232,
                    0.97042,
                    0.73541,
                    0.73541,
                    1.04016,
                    0.98633,
                    0.98633,
                    0.98633,
                    1.04745,
                    1.04394,
                    1.04745,
                    1.04745,
                    1.23203,
                    1.0276,
                    1.0276,
                    1.18416,
                    1.0276,
                    1,
                    1.18622,
                    1,
                    0.98387,
                    1.31818,
                    1,
                    0.78929,
                    0.78929,
                    0.78929,
                    0.78929,
                    0.78929,
                    1,
                    1.02956,
                    0.87357,
                    1.036,
                    1.15574,
                    1,
                    1,
                    0.93377,
                    0.93028,
                    1.036,
                    1.59754,
                    1,
                    1.2886,
                    1.036,
                    0.90068,
                    1,
                    1.1261,
                    1.35125,
                    1.16862,
                    1.05403,
                    1,
                    1.11121,
                    0.97042,
                    1.036,
                    1.15574,
                    1.17389,
                    1.31818,
                    1,
                    0.95161,
                    0.771,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    1.036,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.97922,
                    0.74627,
                    0.75155,
                    0.98946,
                    1.21261,
                    1.24047,
                    1.24047,
                    1,
                    1.1349,
                    0.96083,
                    1.1261,
                    1.31818,
                    0.81378,
                    0.79429,
                    1.09097,
                    0.93503,
                    0.96609,
                    1,
                    1.21261,
                    1.24633,
                    1.09125,
                    1,
                    1,
                    1,
                    0.9754,
                    1,
                    1,
                    1.13269,
                    1.13269,
                    0.97922,
                    1,
                    1.07514,
                    1.07514,
                    1.07514,
                    1.07514,
                    0.97922,
                    0.97922,
                    0.95874,
                    1.02197,
                    1.02197,
                    1.02197,
                    1.02197,
                    1.02197,
                    0.98507,
                    1.08578,
                    0.96752,
                    0.96752,
                    0.96752,
                    0.96752,
                    1.036,
                    0.96752,
                    0.97168,
                    0.97168,
                    0.97168,
                    0.97168,
                    1.036,
                    0.95134
                ];
                exports.SegoeuiBoldItalicFactors = SegoeuiBoldItalicFactors;
                const SegoeuiBoldItalicLineHeight = 1.33008;
                exports.SegoeuiBoldItalicLineHeight = SegoeuiBoldItalicLineHeight;
                const SegoeuiItalicFactors = [
                    1.76738,
                    1,
                    0.94729,
                    0.85498,
                    0.85498,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.94729,
                    0.85944,
                    0.85944,
                    0.88506,
                    0.88506,
                    0.88506,
                    0.88506,
                    0.88506,
                    0.88506,
                    0.8858,
                    0.9858,
                    0.9858,
                    0.9858,
                    0.9607,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    0.74817,
                    1.03849,
                    0.74817,
                    0.74817,
                    0.71022,
                    0.98039,
                    0.90883,
                    0.9858,
                    0.96927,
                    0.80016,
                    0.88449,
                    0.82791,
                    0.88449,
                    0.88449,
                    1,
                    0.88449,
                    0.98039,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.98039,
                    0.98039,
                    0.95782,
                    0.84421,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.84171,
                    0.95782,
                    0.69238,
                    0.69238,
                    0.89898,
                    0.89898,
                    1,
                    0.83231,
                    0.83231,
                    0.98316,
                    0.84723,
                    1,
                    0.84723,
                    0.83231,
                    0.98183,
                    0.98183,
                    1.03989,
                    1.03989,
                    1.03989,
                    1,
                    1.03989,
                    1.03989,
                    0.96924,
                    0.92383,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    1.01284,
                    1.05734,
                    0.96924,
                    0.99877,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.86237,
                    0.90082,
                    0.97642,
                    0.97296,
                    0.96924,
                    0.80595,
                    0.80595,
                    0.80595,
                    1,
                    0.86237,
                    0.74524,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.74524,
                    0.74524,
                    0.74524,
                    0.74524,
                    1,
                    0.86075,
                    0.86091,
                    0.86091,
                    0.85771,
                    0.86091,
                    1,
                    0.96924,
                    0.86237,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.95402,
                    0.83089,
                    0.83089,
                    0.77596,
                    0.95402,
                    0.95402,
                    0.94143,
                    0.98448,
                    0.98448,
                    0.98448,
                    0.98448,
                    0.98448,
                    0.8858,
                    0.78614,
                    0.83089,
                    0.83089,
                    0.83089,
                    0.83089,
                    0.83089,
                    0.93285,
                    0.93285,
                    0.93285,
                    0.93285,
                    0.93285,
                    0.97454,
                    0.97454,
                    0.97454,
                    0.97454,
                    1.04839,
                    1,
                    0.97454,
                    0.92916,
                    0.92916,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.97454,
                    1.0976,
                    1.0976,
                    0.97454,
                    1.15373,
                    0.78032,
                    0.97454,
                    1.24822,
                    0.97454,
                    0.97454,
                    0.86182,
                    0.94434,
                    0.86321,
                    0.8649,
                    0.94434,
                    1,
                    1,
                    1.45994,
                    1.17308,
                    1.07403,
                    0.94565,
                    0.97454,
                    0.97454,
                    1.39016,
                    0.92481,
                    0.98205,
                    1,
                    0.91082,
                    0.91082,
                    1.0949,
                    1.0949,
                    1.04839,
                    1,
                    0.92481,
                    1.15621,
                    0.87207,
                    0.87207,
                    1.04839,
                    1,
                    1,
                    0.87207,
                    0.87207,
                    0.87207,
                    0.87207,
                    1.04839,
                    0.96927,
                    0.99821,
                    1.42603,
                    1.04839,
                    1,
                    1.04315,
                    0.78383,
                    0.78383,
                    1,
                    1,
                    1.23393,
                    1,
                    1,
                    0.97454,
                    0.67603,
                    0.67603,
                    0.95391,
                    0.97454,
                    0.94261,
                    1.05097,
                    1.34163,
                    1.04839,
                    1,
                    0.81965,
                    1.24822,
                    1,
                    1,
                    0.96927,
                    1.04839,
                    0.93146,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.87533,
                    0.96927,
                    1,
                    0.73584,
                    0.87533,
                    1,
                    0.89903,
                    1.01054,
                    0.87533,
                    1.04,
                    1.04,
                    1.17308,
                    1.17308,
                    1,
                    1.03342,
                    1.03342,
                    0.93854,
                    1.14763,
                    0.95996,
                    0.95748,
                    1.06151,
                    1,
                    1.42603,
                    1,
                    0.96927,
                    1.09836,
                    1,
                    0.96927,
                    0.96927,
                    1,
                    0.87709,
                    0.97454,
                    1.03809,
                    0.97454,
                    0.97454,
                    1,
                    0.97454,
                    0.88409,
                    1.04839,
                    1,
                    1.17308,
                    1.24822,
                    0.9245,
                    0.9245,
                    0.94868,
                    0.94868,
                    1.00176,
                    1.00176,
                    1.00176,
                    1.15296,
                    1,
                    1.04839,
                    1,
                    1.16484,
                    0.93146,
                    0.93146,
                    0.93146,
                    0.93146,
                    0.93146,
                    1.12761,
                    0.93146,
                    1.14589,
                    1.96791,
                    1,
                    1,
                    0.97622,
                    1.42603,
                    1.42603,
                    1,
                    1.16484,
                    1.2,
                    1.2,
                    1.2,
                    1.2,
                    0.93146,
                    1.08132,
                    1.08132,
                    0.98047,
                    1.02148,
                    1,
                    0.98047,
                    1.16484,
                    1.16484,
                    1.0119,
                    1.04861,
                    1,
                    0.78755,
                    1.17308,
                    1.24822,
                    1,
                    0.96927,
                    1.17308,
                    1.31868,
                    1.17984,
                    1.23736,
                    1,
                    1.02989,
                    0.63218,
                    1,
                    1,
                    1.17308,
                    1.22135,
                    1.04724,
                    1.17308,
                    1,
                    1,
                    1.01054,
                    1.01054,
                    0.9857,
                    1.01054,
                    1,
                    0.96927,
                    1,
                    1.24822,
                    1.01054,
                    1.0127,
                    1.06234,
                    0.96225,
                    0.96225,
                    0.96225,
                    0.96225,
                    0.96225,
                    0.90171,
                    1.04839,
                    0.96225,
                    0.96225,
                    0.96225,
                    1.0326,
                    1.0326,
                    0.96225,
                    0.96225,
                    0.96927,
                    1.09836,
                    1.13525,
                    1.09836,
                    0.99862,
                    1.1781,
                    1.22326,
                    0.69825,
                    0.8761,
                    0.8761,
                    0.96225,
                    0.97454,
                    0.85273,
                    0.91349,
                    0.91349,
                    1.083,
                    0.92586,
                    0.78383,
                    1.21191,
                    1.01473,
                    1.11826,
                    0.8965,
                    1.17308,
                    1.24822,
                    0.91578,
                    1.0557,
                    0.97454,
                    0.77349,
                    0.70424,
                    1.05365,
                    1.12317,
                    1.12317,
                    1.12317,
                    0.94945,
                    0.94945,
                    0.94945,
                    0.94945,
                    1.18414,
                    1.06598,
                    1.06598,
                    1.18416,
                    1.06598,
                    1,
                    1.20808,
                    1,
                    0.97783,
                    1.04839,
                    1,
                    0.79004,
                    0.79004,
                    0.79004,
                    0.79004,
                    0.79004,
                    1,
                    1.06483,
                    0.80597,
                    0.96927,
                    1.01522,
                    1,
                    1,
                    0.94818,
                    0.93574,
                    0.96927,
                    1.42531,
                    1,
                    1.2886,
                    0.96927,
                    0.86438,
                    1,
                    1.16344,
                    1.30679,
                    1.16344,
                    1.02759,
                    1,
                    1.05401,
                    0.97454,
                    0.96927,
                    1.09836,
                    1.15222,
                    1.04839,
                    1,
                    0.81965,
                    0.77295,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.96927,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    1.00351,
                    0.74627,
                    0.75155,
                    0.98946,
                    1.20088,
                    1.09971,
                    1.09971,
                    1,
                    1.09971,
                    0.86091,
                    1.16344,
                    1.04839,
                    0.78383,
                    0.74817,
                    1.03754,
                    0.87533,
                    0.98705,
                    1,
                    1.20088,
                    1.24633,
                    1.07497,
                    1,
                    1,
                    1,
                    0.78032,
                    1,
                    1,
                    1.10742,
                    1.10742,
                    1.00351,
                    1,
                    1.0675,
                    1.0675,
                    1.0675,
                    1.0675,
                    1.00351,
                    1.00351,
                    0.94629,
                    0.9973,
                    0.9973,
                    0.9973,
                    0.9973,
                    0.9973,
                    0.91016,
                    1.02732,
                    0.96777,
                    0.96777,
                    0.96777,
                    0.96777,
                    0.96927,
                    0.96777,
                    0.9043,
                    0.9043,
                    0.9043,
                    0.9043,
                    0.96927,
                    0.95364
                ];
                exports.SegoeuiItalicFactors = SegoeuiItalicFactors;
                const SegoeuiItalicLineHeight = 1.33008;
                exports.SegoeuiItalicLineHeight = SegoeuiItalicLineHeight;
                const SegoeuiRegularFactors = [
                    1.76738,
                    1,
                    0.96706,
                    0.86035,
                    0.86035,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96635,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.96706,
                    0.85944,
                    0.85944,
                    0.85734,
                    0.85734,
                    0.85734,
                    0.85734,
                    0.85734,
                    0.85734,
                    0.88433,
                    0.97093,
                    0.97093,
                    0.97093,
                    0.96491,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    0.75842,
                    1.03444,
                    0.75842,
                    0.75842,
                    0.72727,
                    0.9831,
                    0.92366,
                    0.97093,
                    0.96927,
                    0.79936,
                    0.88198,
                    0.85638,
                    0.88198,
                    0.88198,
                    1,
                    0.88198,
                    0.9831,
                    1,
                    0.99862,
                    0.99862,
                    1,
                    0.9831,
                    0.9831,
                    0.95782,
                    0.84784,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.95782,
                    0.98601,
                    0.95782,
                    0.71387,
                    0.71387,
                    0.86969,
                    0.86969,
                    1,
                    0.84636,
                    0.84636,
                    0.94152,
                    0.84636,
                    1,
                    0.84636,
                    0.84636,
                    1.07796,
                    1.07796,
                    1.03584,
                    1.03584,
                    1.03584,
                    1,
                    1.03584,
                    1.03584,
                    0.96924,
                    0.93066,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.96924,
                    1.0098,
                    1.09799,
                    0.96924,
                    1.03405,
                    0.96924,
                    0.96924,
                    0.96924,
                    0.83968,
                    0.94492,
                    0.98715,
                    0.9287,
                    0.96924,
                    0.82826,
                    0.82826,
                    0.82826,
                    1,
                    0.83968,
                    0.79649,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.79649,
                    0.79649,
                    0.79649,
                    0.79649,
                    1,
                    0.83491,
                    0.85771,
                    0.85771,
                    0.85771,
                    0.85771,
                    1,
                    0.96924,
                    0.83968,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.95132,
                    0.8287,
                    0.8287,
                    0.77968,
                    0.95132,
                    0.95132,
                    0.93119,
                    0.98965,
                    0.98965,
                    0.98965,
                    0.98965,
                    0.98965,
                    0.88433,
                    0.78437,
                    0.8287,
                    0.8287,
                    0.8287,
                    0.8287,
                    0.8287,
                    0.93365,
                    0.93365,
                    0.93365,
                    0.93365,
                    0.93365,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.91484,
                    0.84751,
                    0.91484,
                    0.93575,
                    0.93575,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.91484,
                    1.0625,
                    1.0625,
                    0.91484,
                    1.19985,
                    0.78032,
                    0.91484,
                    1.24822,
                    0.91484,
                    0.91484,
                    0.86182,
                    0.94434,
                    0.86279,
                    0.86279,
                    0.94434,
                    1,
                    1,
                    1.45786,
                    1.1714,
                    1.07152,
                    0.94084,
                    0.91484,
                    1.05707,
                    1.3638,
                    0.92105,
                    0.95246,
                    1,
                    0.90351,
                    0.90351,
                    1.08612,
                    1.08612,
                    0.91202,
                    0.92105,
                    1.16039,
                    0.92383,
                    0.92383,
                    1.11437,
                    0.92383,
                    0.92383,
                    0.92383,
                    0.92383,
                    0.61584,
                    0.96927,
                    1.02512,
                    1.42603,
                    1.11437,
                    1.04315,
                    0.78032,
                    0.78032,
                    1.20808,
                    0.99912,
                    1.05882,
                    0.67428,
                    0.67428,
                    1.0969,
                    1.05882,
                    0.94261,
                    1.04912,
                    1.34163,
                    1.2434,
                    0.81818,
                    1.24644,
                    1,
                    1,
                    0.96927,
                    0.60411,
                    0.8717,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.9403,
                    0.96927,
                    0.73291,
                    0.9403,
                    1,
                    0.89903,
                    1.01756,
                    0.9403,
                    0.98248,
                    0.98248,
                    1.1714,
                    1.17238,
                    1,
                    1.03424,
                    1.03424,
                    1.00527,
                    1.02285,
                    0.95996,
                    0.85337,
                    1.12654,
                    1,
                    1.42603,
                    1,
                    0.96927,
                    1.11358,
                    0.96927,
                    0.96927,
                    0.87796,
                    1.05882,
                    1.03809,
                    1.05882,
                    1.05882,
                    1,
                    1.05882,
                    0.89049,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    1,
                    0.80499,
                    1.1714,
                    1.24822,
                    0.90957,
                    0.90957,
                    0.94868,
                    0.94868,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.15296,
                    1,
                    0.97361,
                    1.09011,
                    0.8717,
                    0.8717,
                    0.8717,
                    0.8717,
                    0.8717,
                    1.11551,
                    0.8717,
                    1.14589,
                    1.9697,
                    1,
                    1,
                    0.97622,
                    1.42603,
                    1.42603,
                    1,
                    1.09011,
                    1.2,
                    1.2,
                    1.2,
                    1.2,
                    0.8717,
                    1.09011,
                    1.09011,
                    0.99414,
                    1.04785,
                    1,
                    0.99414,
                    1.09011,
                    1.09011,
                    0.99609,
                    1.0536,
                    1,
                    0.94298,
                    1.1714,
                    1.24822,
                    1,
                    0.96927,
                    1.1714,
                    1.08571,
                    1.18083,
                    1.23297,
                    1,
                    1.034,
                    0.75155,
                    1,
                    1,
                    1.1714,
                    1.22135,
                    1.00169,
                    1.1714,
                    1,
                    1,
                    1.01756,
                    1.01756,
                    1.00323,
                    1.01756,
                    1,
                    0.96927,
                    1,
                    1.24822,
                    1.01756,
                    1.05176,
                    1.06234,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.05356,
                    0.98293,
                    0.55572,
                    1.05356,
                    1.05356,
                    1.05356,
                    1.03502,
                    1.03502,
                    1.05356,
                    1.05356,
                    0.96927,
                    1.10539,
                    1.11593,
                    1.08665,
                    0.99862,
                    1.05937,
                    1.17914,
                    0.69825,
                    0.95923,
                    0.95923,
                    1.05356,
                    1.05707,
                    0.85273,
                    0.90616,
                    0.90616,
                    1.083,
                    0.92037,
                    0.78032,
                    1.20996,
                    1.01518,
                    1.07831,
                    0.9087,
                    1.1714,
                    1.24644,
                    0.91578,
                    1.05205,
                    1.05882,
                    0.80597,
                    0.73381,
                    1.10454,
                    1.13196,
                    1.13196,
                    1.13196,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.03077,
                    1.2046,
                    1.04399,
                    1.04399,
                    1.18416,
                    1.04399,
                    1,
                    1.20808,
                    1,
                    1.03004,
                    0.84164,
                    1,
                    0.84863,
                    0.84863,
                    0.84863,
                    0.84863,
                    0.84863,
                    1,
                    1.06483,
                    0.80597,
                    0.96927,
                    1.06967,
                    1,
                    0.93117,
                    0.95542,
                    0.96927,
                    1.40246,
                    1,
                    1.2886,
                    0.96927,
                    0.86507,
                    1,
                    1.21968,
                    1.23362,
                    1.21968,
                    1.17318,
                    1,
                    1.05443,
                    1.05707,
                    0.96927,
                    1.10539,
                    1.14169,
                    1.01173,
                    0.81818,
                    0.77295,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.87025,
                    0.96927,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    1.01756,
                    0.74627,
                    0.75155,
                    0.98594,
                    1.20088,
                    1.09971,
                    1.09971,
                    1,
                    1.05425,
                    0.85771,
                    1.21968,
                    0.93109,
                    0.78032,
                    0.75842,
                    1.03719,
                    0.9403,
                    1.04021,
                    1,
                    1.20088,
                    1.24633,
                    1.05425,
                    1.09971,
                    1.09971,
                    1.09971,
                    1.07497,
                    1,
                    1,
                    1,
                    0.78032,
                    1,
                    1,
                    1,
                    1.10938,
                    1.10938,
                    1.01756,
                    1,
                    1.01071,
                    1.01071,
                    1.01071,
                    1.01071,
                    1.01756,
                    1.01756,
                    0.95801,
                    1.00068,
                    1.00068,
                    1.00068,
                    1.00068,
                    1.00068,
                    0.91797,
                    0.99346,
                    0.96777,
                    0.96777,
                    0.96777,
                    0.96777,
                    0.96927,
                    0.96777,
                    0.9043,
                    0.9043,
                    0.9043,
                    0.9043,
                    0.96927,
                    1.00221
                ];
                exports.SegoeuiRegularFactors = SegoeuiRegularFactors;
                const SegoeuiRegularLineHeight = 1.33008;
                exports.SegoeuiRegularLineHeight = SegoeuiRegularLineHeight;
            /***/ },
            /* 61 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(2);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                    update(input) {
                        let data, length;
                        if ((0, _util.isString)(input)) {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        const hex1 = (h1 >>> 0).toString(16), hex2 = (h2 >>> 0).toString(16);
                        return hex1.padStart(8, "0") + hex2.padStart(8, "0");
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 62 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OperatorList = void 0;
                var _util = __w_pdfjs_require__(2);
                function addState(parentState, pattern, checkFn, iterateFn, processFn) {
                    let state = parentState;
                    for(let i = 0, ii = pattern.length - 1; i < ii; i++){
                        const item = pattern[i];
                        state = state[item] || (state[item] = []);
                    }
                    state[pattern[pattern.length - 1]] = {
                        checkFn: checkFn,
                        iterateFn: iterateFn,
                        processFn: processFn
                    };
                }
                function handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray) {
                    const iFirstPIMXO = iFirstSave + 2;
                    let i;
                    for(i = 0; i < count; i++){
                        const arg = argsArray[iFirstPIMXO + 4 * i];
                        const imageMask = arg.length === 1 && arg[0];
                        if (imageMask && imageMask.width === 1 && imageMask.height === 1 && (!imageMask.data.length || imageMask.data.length === 1 && imageMask.data[0] === 0)) {
                            fnArray[iFirstPIMXO + 4 * i] = _util.OPS.paintSolidColorImageMask;
                            continue;
                        }
                        break;
                    }
                    return count - i;
                }
                const InitialState = [];
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintInlineImageXObject,
                    _util.OPS.restore
                ], null, function iterateInlineImageGroup(context, i) {
                    const fnArray = context.fnArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            return fnArray[i] === _util.OPS.transform;
                        case 2:
                            return fnArray[i] === _util.OPS.paintInlineImageXObject;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateInlineImageGroup - invalid pos: ${pos}`);
                }, function foundInlineImageGroup(context, i) {
                    const MIN_IMAGES_IN_INLINE_IMAGES_BLOCK = 10;
                    const MAX_IMAGES_IN_INLINE_IMAGES_BLOCK = 200;
                    const MAX_WIDTH = 1000;
                    const IMAGE_PADDING = 1;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIIXO = curr - 1;
                    const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_INLINE_IMAGES_BLOCK);
                    if (count < MIN_IMAGES_IN_INLINE_IMAGES_BLOCK) return i - (i - iFirstSave) % 4;
                    let maxX = 0;
                    const map = [];
                    let maxLineHeight = 0;
                    let currentX = IMAGE_PADDING, currentY = IMAGE_PADDING;
                    for(let q = 0; q < count; q++){
                        const transform = argsArray[iFirstTransform + (q << 2)];
                        const img = argsArray[iFirstPIIXO + (q << 2)][0];
                        if (currentX + img.width > MAX_WIDTH) {
                            maxX = Math.max(maxX, currentX);
                            currentY += maxLineHeight + 2 * IMAGE_PADDING;
                            currentX = 0;
                            maxLineHeight = 0;
                        }
                        map.push({
                            transform: transform,
                            x: currentX,
                            y: currentY,
                            w: img.width,
                            h: img.height
                        });
                        currentX += img.width + 2 * IMAGE_PADDING;
                        maxLineHeight = Math.max(maxLineHeight, img.height);
                    }
                    const imgWidth = Math.max(maxX, currentX) + IMAGE_PADDING;
                    const imgHeight = currentY + maxLineHeight + IMAGE_PADDING;
                    const imgData = new Uint8ClampedArray(imgWidth * imgHeight * 4);
                    const imgRowSize = imgWidth << 2;
                    for(let q = 0; q < count; q++){
                        const data = argsArray[iFirstPIIXO + (q << 2)][0].data;
                        const rowSize = map[q].w << 2;
                        let dataOffset = 0;
                        let offset = map[q].x + map[q].y * imgWidth << 2;
                        imgData.set(data.subarray(0, rowSize), offset - imgRowSize);
                        for(let k = 0, kk = map[q].h; k < kk; k++){
                            imgData.set(data.subarray(dataOffset, dataOffset + rowSize), offset);
                            dataOffset += rowSize;
                            offset += imgRowSize;
                        }
                        imgData.set(data.subarray(dataOffset - rowSize, dataOffset), offset);
                        while(offset >= 0){
                            data[offset - 4] = data[offset];
                            data[offset - 3] = data[offset + 1];
                            data[offset - 2] = data[offset + 2];
                            data[offset - 1] = data[offset + 3];
                            data[offset + rowSize] = data[offset + rowSize - 4];
                            data[offset + rowSize + 1] = data[offset + rowSize - 3];
                            data[offset + rowSize + 2] = data[offset + rowSize - 2];
                            data[offset + rowSize + 3] = data[offset + rowSize - 1];
                            offset -= imgRowSize;
                        }
                    }
                    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintInlineImageXObjectGroup);
                    argsArray.splice(iFirstSave, count * 4, [
                        {
                            width: imgWidth,
                            height: imgHeight,
                            kind: _util.ImageKind.RGBA_32BPP,
                            data: imgData
                        },
                        map
                    ]);
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintImageMaskXObject,
                    _util.OPS.restore
                ], null, function iterateImageMaskGroup(context, i) {
                    const fnArray = context.fnArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            return fnArray[i] === _util.OPS.transform;
                        case 2:
                            return fnArray[i] === _util.OPS.paintImageMaskXObject;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateImageMaskGroup - invalid pos: ${pos}`);
                }, function foundImageMaskGroup(context, i) {
                    const MIN_IMAGES_IN_MASKS_BLOCK = 10;
                    const MAX_IMAGES_IN_MASKS_BLOCK = 100;
                    const MAX_SAME_IMAGES_IN_MASKS_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIMXO = curr - 1;
                    let count = Math.floor((i - iFirstSave) / 4);
                    count = handlePaintSolidColorImageMask(iFirstSave, count, fnArray, argsArray);
                    if (count < MIN_IMAGES_IN_MASKS_BLOCK) return i - (i - iFirstSave) % 4;
                    let isSameImage = false;
                    let iTransform, transformArgs;
                    const firstPIMXOArg0 = argsArray[iFirstPIMXO][0];
                    const firstTransformArg0 = argsArray[iFirstTransform][0], firstTransformArg1 = argsArray[iFirstTransform][1], firstTransformArg2 = argsArray[iFirstTransform][2], firstTransformArg3 = argsArray[iFirstTransform][3];
                    if (firstTransformArg1 === firstTransformArg2) {
                        isSameImage = true;
                        iTransform = iFirstTransform + 4;
                        let iPIMXO = iFirstPIMXO + 4;
                        for(let q = 1; q < count; q++, iTransform += 4, iPIMXO += 4){
                            transformArgs = argsArray[iTransform];
                            if (argsArray[iPIMXO][0] !== firstPIMXOArg0 || transformArgs[0] !== firstTransformArg0 || transformArgs[1] !== firstTransformArg1 || transformArgs[2] !== firstTransformArg2 || transformArgs[3] !== firstTransformArg3) {
                                if (q < MIN_IMAGES_IN_MASKS_BLOCK) isSameImage = false;
                                else count = q;
                                break;
                            }
                        }
                    }
                    if (isSameImage) {
                        count = Math.min(count, MAX_SAME_IMAGES_IN_MASKS_BLOCK);
                        const positions = new Float32Array(count * 2);
                        iTransform = iFirstTransform;
                        for(let q = 0; q < count; q++, iTransform += 4){
                            transformArgs = argsArray[iTransform];
                            positions[q << 1] = transformArgs[4];
                            positions[(q << 1) + 1] = transformArgs[5];
                        }
                        fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectRepeat);
                        argsArray.splice(iFirstSave, count * 4, [
                            firstPIMXOArg0,
                            firstTransformArg0,
                            firstTransformArg1,
                            firstTransformArg2,
                            firstTransformArg3,
                            positions
                        ]);
                    } else {
                        count = Math.min(count, MAX_IMAGES_IN_MASKS_BLOCK);
                        const images = [];
                        for(let q = 0; q < count; q++){
                            transformArgs = argsArray[iFirstTransform + (q << 2)];
                            const maskParams = argsArray[iFirstPIMXO + (q << 2)][0];
                            images.push({
                                data: maskParams.data,
                                width: maskParams.width,
                                height: maskParams.height,
                                transform: transformArgs
                            });
                        }
                        fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageMaskXObjectGroup);
                        argsArray.splice(iFirstSave, count * 4, [
                            images
                        ]);
                    }
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.save,
                    _util.OPS.transform,
                    _util.OPS.paintImageXObject,
                    _util.OPS.restore
                ], function(context) {
                    const argsArray = context.argsArray;
                    const iFirstTransform = context.iCurr - 2;
                    return argsArray[iFirstTransform][1] === 0 && argsArray[iFirstTransform][2] === 0;
                }, function iterateImageGroup(context, i) {
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const iFirstSave = context.iCurr - 3;
                    const pos = (i - iFirstSave) % 4;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.save;
                        case 1:
                            if (fnArray[i] !== _util.OPS.transform) return false;
                            const iFirstTransform = context.iCurr - 2;
                            const firstTransformArg0 = argsArray[iFirstTransform][0];
                            const firstTransformArg3 = argsArray[iFirstTransform][3];
                            if (argsArray[i][0] !== firstTransformArg0 || argsArray[i][1] !== 0 || argsArray[i][2] !== 0 || argsArray[i][3] !== firstTransformArg3) return false;
                            return true;
                        case 2:
                            if (fnArray[i] !== _util.OPS.paintImageXObject) return false;
                            const iFirstPIXO = context.iCurr - 1;
                            const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                            if (argsArray[i][0] !== firstPIXOArg0) return false;
                            return true;
                        case 3:
                            return fnArray[i] === _util.OPS.restore;
                    }
                    throw new Error(`iterateImageGroup - invalid pos: ${pos}`);
                }, function(context, i) {
                    const MIN_IMAGES_IN_BLOCK = 3;
                    const MAX_IMAGES_IN_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstSave = curr - 3;
                    const iFirstTransform = curr - 2;
                    const iFirstPIXO = curr - 1;
                    const firstPIXOArg0 = argsArray[iFirstPIXO][0];
                    const firstTransformArg0 = argsArray[iFirstTransform][0];
                    const firstTransformArg3 = argsArray[iFirstTransform][3];
                    const count = Math.min(Math.floor((i - iFirstSave) / 4), MAX_IMAGES_IN_BLOCK);
                    if (count < MIN_IMAGES_IN_BLOCK) return i - (i - iFirstSave) % 4;
                    const positions = new Float32Array(count * 2);
                    let iTransform = iFirstTransform;
                    for(let q = 0; q < count; q++, iTransform += 4){
                        const transformArgs = argsArray[iTransform];
                        positions[q << 1] = transformArgs[4];
                        positions[(q << 1) + 1] = transformArgs[5];
                    }
                    const args = [
                        firstPIXOArg0,
                        firstTransformArg0,
                        firstTransformArg3,
                        positions
                    ];
                    fnArray.splice(iFirstSave, count * 4, _util.OPS.paintImageXObjectRepeat);
                    argsArray.splice(iFirstSave, count * 4, args);
                    return iFirstSave + 1;
                });
                addState(InitialState, [
                    _util.OPS.beginText,
                    _util.OPS.setFont,
                    _util.OPS.setTextMatrix,
                    _util.OPS.showText,
                    _util.OPS.endText
                ], null, function iterateShowTextGroup(context, i) {
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const iFirstSave = context.iCurr - 4;
                    const pos = (i - iFirstSave) % 5;
                    switch(pos){
                        case 0:
                            return fnArray[i] === _util.OPS.beginText;
                        case 1:
                            return fnArray[i] === _util.OPS.setFont;
                        case 2:
                            return fnArray[i] === _util.OPS.setTextMatrix;
                        case 3:
                            if (fnArray[i] !== _util.OPS.showText) return false;
                            const iFirstSetFont = context.iCurr - 3;
                            const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                            const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                            if (argsArray[i][0] !== firstSetFontArg0 || argsArray[i][1] !== firstSetFontArg1) return false;
                            return true;
                        case 4:
                            return fnArray[i] === _util.OPS.endText;
                    }
                    throw new Error(`iterateShowTextGroup - invalid pos: ${pos}`);
                }, function(context, i) {
                    const MIN_CHARS_IN_BLOCK = 3;
                    const MAX_CHARS_IN_BLOCK = 1000;
                    const fnArray = context.fnArray, argsArray = context.argsArray;
                    const curr = context.iCurr;
                    const iFirstBeginText = curr - 4;
                    const iFirstSetFont = curr - 3;
                    const iFirstSetTextMatrix = curr - 2;
                    const iFirstShowText = curr - 1;
                    const iFirstEndText = curr;
                    const firstSetFontArg0 = argsArray[iFirstSetFont][0];
                    const firstSetFontArg1 = argsArray[iFirstSetFont][1];
                    let count = Math.min(Math.floor((i - iFirstBeginText) / 5), MAX_CHARS_IN_BLOCK);
                    if (count < MIN_CHARS_IN_BLOCK) return i - (i - iFirstBeginText) % 5;
                    let iFirst = iFirstBeginText;
                    if (iFirstBeginText >= 4 && fnArray[iFirstBeginText - 4] === fnArray[iFirstSetFont] && fnArray[iFirstBeginText - 3] === fnArray[iFirstSetTextMatrix] && fnArray[iFirstBeginText - 2] === fnArray[iFirstShowText] && fnArray[iFirstBeginText - 1] === fnArray[iFirstEndText] && argsArray[iFirstBeginText - 4][0] === firstSetFontArg0 && argsArray[iFirstBeginText - 4][1] === firstSetFontArg1) {
                        count++;
                        iFirst -= 5;
                    }
                    let iEndText = iFirst + 4;
                    for(let q = 1; q < count; q++){
                        fnArray.splice(iEndText, 3);
                        argsArray.splice(iEndText, 3);
                        iEndText += 2;
                    }
                    return iEndText + 1;
                });
                class NullOptimizer {
                    constructor(queue){
                        this.queue = queue;
                    }
                    _optimize() {}
                    push(fn, args) {
                        this.queue.fnArray.push(fn);
                        this.queue.argsArray.push(args);
                        this._optimize();
                    }
                    flush() {}
                    reset() {}
                }
                class QueueOptimizer extends NullOptimizer {
                    constructor(queue){
                        super(queue);
                        this.state = null;
                        this.context = {
                            iCurr: 0,
                            fnArray: queue.fnArray,
                            argsArray: queue.argsArray
                        };
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                    _optimize() {
                        const fnArray = this.queue.fnArray;
                        let i = this.lastProcessed, ii = fnArray.length;
                        let state = this.state;
                        let match = this.match;
                        if (!state && !match && i + 1 === ii && !InitialState[fnArray[i]]) {
                            this.lastProcessed = ii;
                            return;
                        }
                        const context = this.context;
                        while(i < ii){
                            if (match) {
                                const iterate = (0, match.iterateFn)(context, i);
                                if (iterate) {
                                    i++;
                                    continue;
                                }
                                i = (0, match.processFn)(context, i + 1);
                                ii = fnArray.length;
                                match = null;
                                state = null;
                                if (i >= ii) break;
                            }
                            state = (state || InitialState)[fnArray[i]];
                            if (!state || Array.isArray(state)) {
                                i++;
                                continue;
                            }
                            context.iCurr = i;
                            i++;
                            if (state.checkFn && !(0, state.checkFn)(context)) {
                                state = null;
                                continue;
                            }
                            match = state;
                            state = null;
                        }
                        this.state = state;
                        this.match = match;
                        this.lastProcessed = i;
                    }
                    flush() {
                        while(this.match){
                            const length = this.queue.fnArray.length;
                            this.lastProcessed = (0, this.match.processFn)(this.context, length);
                            this.match = null;
                            this.state = null;
                            this._optimize();
                        }
                    }
                    reset() {
                        this.state = null;
                        this.match = null;
                        this.lastProcessed = 0;
                    }
                }
                class OperatorList {
                    static get CHUNK_SIZE() {
                        return (0, _util.shadow)(this, "CHUNK_SIZE", 1000);
                    }
                    static get CHUNK_SIZE_ABOUT() {
                        return (0, _util.shadow)(this, "CHUNK_SIZE_ABOUT", this.CHUNK_SIZE - 5);
                    }
                    constructor(intent, streamSink){
                        this._streamSink = streamSink;
                        this.fnArray = [];
                        this.argsArray = [];
                        if (streamSink && !(intent && intent.startsWith("oplist-"))) this.optimizer = new QueueOptimizer(this);
                        else this.optimizer = new NullOptimizer(this);
                        this.dependencies = new Set();
                        this._totalLength = 0;
                        this.weight = 0;
                        this._resolved = streamSink ? null : Promise.resolve();
                    }
                    get length() {
                        return this.argsArray.length;
                    }
                    get ready() {
                        return this._resolved || this._streamSink.ready;
                    }
                    get totalLength() {
                        return this._totalLength + this.length;
                    }
                    addOp(fn, args) {
                        this.optimizer.push(fn, args);
                        this.weight++;
                        if (this._streamSink) {
                            if (this.weight >= OperatorList.CHUNK_SIZE) this.flush();
                            else if (this.weight >= OperatorList.CHUNK_SIZE_ABOUT && (fn === _util.OPS.restore || fn === _util.OPS.endText)) this.flush();
                        }
                    }
                    addDependency(dependency) {
                        if (this.dependencies.has(dependency)) return;
                        this.dependencies.add(dependency);
                        this.addOp(_util.OPS.dependency, [
                            dependency
                        ]);
                    }
                    addDependencies(dependencies) {
                        for (const dependency of dependencies)this.addDependency(dependency);
                    }
                    addOpList(opList) {
                        if (!(opList instanceof OperatorList)) {
                            (0, _util.warn)('addOpList - ignoring invalid "opList" parameter.');
                            return;
                        }
                        for (const dependency of opList.dependencies)this.dependencies.add(dependency);
                        for(let i = 0, ii = opList.length; i < ii; i++)this.addOp(opList.fnArray[i], opList.argsArray[i]);
                    }
                    getIR() {
                        return {
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            length: this.length
                        };
                    }
                    get _transfers() {
                        const transfers = [];
                        const { fnArray: fnArray , argsArray: argsArray , length: length  } = this;
                        for(let i = 0; i < length; i++)switch(fnArray[i]){
                            case _util.OPS.paintInlineImageXObject:
                            case _util.OPS.paintInlineImageXObjectGroup:
                            case _util.OPS.paintImageMaskXObject:
                                const arg = argsArray[i][0];
                                if (!arg.cached) transfers.push(arg.data.buffer);
                                break;
                        }
                        return transfers;
                    }
                    flush(lastChunk = false) {
                        this.optimizer.flush();
                        const length = this.length;
                        this._totalLength += length;
                        this._streamSink.enqueue({
                            fnArray: this.fnArray,
                            argsArray: this.argsArray,
                            lastChunk: lastChunk,
                            length: length
                        }, 1, this._transfers);
                        this.dependencies.clear();
                        this.fnArray.length = 0;
                        this.argsArray.length = 0;
                        this.weight = 0;
                        this.optimizer.reset();
                    }
                }
                exports.OperatorList = OperatorList;
            /***/ },
            /* 63 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFImage = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _colorspace = __w_pdfjs_require__(14);
                var _decode_stream = __w_pdfjs_require__(19);
                var _jpeg_stream = __w_pdfjs_require__(27);
                var _jpx = __w_pdfjs_require__(30);
                function decodeAndClamp(value, addend, coefficient, max) {
                    value = addend + value * coefficient;
                    if (value < 0) value = 0;
                    else if (value > max) value = max;
                    return value;
                }
                function resizeImageMask(src, bpc, w1, h1, w2, h2) {
                    const length = w2 * h2;
                    let dest;
                    if (bpc <= 8) dest = new Uint8Array(length);
                    else if (bpc <= 16) dest = new Uint16Array(length);
                    else dest = new Uint32Array(length);
                    const xRatio = w1 / w2;
                    const yRatio = h1 / h2;
                    let i, j, py, newIndex = 0, oldIndex;
                    const xScaled = new Uint16Array(w2);
                    const w1Scanline = w1;
                    for(i = 0; i < w2; i++)xScaled[i] = Math.floor(i * xRatio);
                    for(i = 0; i < h2; i++){
                        py = Math.floor(i * yRatio) * w1Scanline;
                        for(j = 0; j < w2; j++){
                            oldIndex = py + xScaled[j];
                            dest[newIndex++] = src[oldIndex];
                        }
                    }
                    return dest;
                }
                class PDFImage {
                    constructor({ xref: xref , res: res , image: image , isInline: isInline = false , smask: smask = null , mask: mask = null , isMask: isMask = false , pdfFunctionFactory: pdfFunctionFactory , localColorSpaceCache: localColorSpaceCache  }){
                        this.image = image;
                        const dict = image.dict;
                        const filter = dict.get("Filter");
                        if ((0, _primitives.isName)(filter)) switch(filter.name){
                            case "JPXDecode":
                                const jpxImage = new _jpx.JpxImage();
                                jpxImage.parseImageProperties(image.stream);
                                image.stream.reset();
                                image.width = jpxImage.width;
                                image.height = jpxImage.height;
                                image.bitsPerComponent = jpxImage.bitsPerComponent;
                                image.numComps = jpxImage.componentsCount;
                                break;
                            case "JBIG2Decode":
                                image.bitsPerComponent = 1;
                                image.numComps = 1;
                                break;
                        }
                        let width = dict.get("Width", "W");
                        let height = dict.get("Height", "H");
                        if (Number.isInteger(image.width) && image.width > 0 && Number.isInteger(image.height) && image.height > 0 && (image.width !== width || image.height !== height)) {
                            (0, _util.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary.");
                            width = image.width;
                            height = image.height;
                        }
                        if (width < 1 || height < 1) throw new _util.FormatError(`Invalid image width: ${width} or height: ${height}`);
                        this.width = width;
                        this.height = height;
                        this.interpolate = dict.get("Interpolate", "I") || false;
                        this.imageMask = dict.get("ImageMask", "IM") || false;
                        this.matte = dict.get("Matte") || false;
                        let bitsPerComponent = image.bitsPerComponent;
                        if (!bitsPerComponent) {
                            bitsPerComponent = dict.get("BitsPerComponent", "BPC");
                            if (!bitsPerComponent) {
                                if (this.imageMask) bitsPerComponent = 1;
                                else throw new _util.FormatError(`Bits per component missing in image: ${this.imageMask}`);
                            }
                        }
                        this.bpc = bitsPerComponent;
                        if (!this.imageMask) {
                            let colorSpace = dict.getRaw("ColorSpace") || dict.getRaw("CS");
                            if (!colorSpace) {
                                (0, _util.info)("JPX images (which do not require color spaces)");
                                switch(image.numComps){
                                    case 1:
                                        colorSpace = _primitives.Name.get("DeviceGray");
                                        break;
                                    case 3:
                                        colorSpace = _primitives.Name.get("DeviceRGB");
                                        break;
                                    case 4:
                                        colorSpace = _primitives.Name.get("DeviceCMYK");
                                        break;
                                    default:
                                        throw new Error(`JPX images with ${image.numComps} ` + "color components not supported.");
                                }
                            }
                            this.colorSpace = _colorspace.ColorSpace.parse({
                                cs: colorSpace,
                                xref: xref,
                                resources: isInline ? res : null,
                                pdfFunctionFactory: pdfFunctionFactory,
                                localColorSpaceCache: localColorSpaceCache
                            });
                            this.numComps = this.colorSpace.numComps;
                        }
                        this.decode = dict.getArray("Decode", "D");
                        this.needsDecode = false;
                        if (this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, bitsPerComponent) || isMask && !_colorspace.ColorSpace.isDefaultDecode(this.decode, 1))) {
                            this.needsDecode = true;
                            const max = (1 << bitsPerComponent) - 1;
                            this.decodeCoefficients = [];
                            this.decodeAddends = [];
                            const isIndexed = this.colorSpace && this.colorSpace.name === "Indexed";
                            for(let i = 0, j = 0; i < this.decode.length; i += 2, ++j){
                                const dmin = this.decode[i];
                                const dmax = this.decode[i + 1];
                                this.decodeCoefficients[j] = isIndexed ? (dmax - dmin) / max : dmax - dmin;
                                this.decodeAddends[j] = isIndexed ? dmin : max * dmin;
                            }
                        }
                        if (smask) this.smask = new PDFImage({
                            xref: xref,
                            res: res,
                            image: smask,
                            isInline: isInline,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                        else if (mask) {
                            if ((0, _primitives.isStream)(mask)) {
                                const maskDict = mask.dict, imageMask = maskDict.get("ImageMask", "IM");
                                if (!imageMask) (0, _util.warn)("Ignoring /Mask in image without /ImageMask.");
                                else this.mask = new PDFImage({
                                    xref: xref,
                                    res: res,
                                    image: mask,
                                    isInline: isInline,
                                    isMask: true,
                                    pdfFunctionFactory: pdfFunctionFactory,
                                    localColorSpaceCache: localColorSpaceCache
                                });
                            } else this.mask = mask;
                        }
                    }
                    static async buildImage({ xref: xref , res: res , image: image , isInline: isInline = false , pdfFunctionFactory: pdfFunctionFactory , localColorSpaceCache: localColorSpaceCache  }) {
                        const imageData = image;
                        let smaskData = null;
                        let maskData = null;
                        const smask = image.dict.get("SMask");
                        const mask = image.dict.get("Mask");
                        if (smask) smaskData = smask;
                        else if (mask) {
                            if ((0, _primitives.isStream)(mask) || Array.isArray(mask)) maskData = mask;
                            else (0, _util.warn)("Unsupported mask format.");
                        }
                        return new PDFImage({
                            xref: xref,
                            res: res,
                            image: imageData,
                            isInline: isInline,
                            smask: smaskData,
                            mask: maskData,
                            pdfFunctionFactory: pdfFunctionFactory,
                            localColorSpaceCache: localColorSpaceCache
                        });
                    }
                    static createMask({ imgArray: imgArray , width: width , height: height , imageIsFromDecodeStream: imageIsFromDecodeStream , inverseDecode: inverseDecode  }) {
                        const computedLength = (width + 7 >> 3) * height;
                        const actualLength = imgArray.byteLength;
                        const haveFullData = computedLength === actualLength;
                        let data, i;
                        if (imageIsFromDecodeStream && (!inverseDecode || haveFullData)) data = imgArray;
                        else if (!inverseDecode) {
                            data = new Uint8ClampedArray(actualLength);
                            data.set(imgArray);
                        } else {
                            data = new Uint8ClampedArray(computedLength);
                            data.set(imgArray);
                            for(i = actualLength; i < computedLength; i++)data[i] = 0xff;
                        }
                        if (inverseDecode) for(i = 0; i < actualLength; i++)data[i] ^= 0xff;
                        return {
                            data: data,
                            width: width,
                            height: height
                        };
                    }
                    get drawWidth() {
                        return Math.max(this.width, this.smask && this.smask.width || 0, this.mask && this.mask.width || 0);
                    }
                    get drawHeight() {
                        return Math.max(this.height, this.smask && this.smask.height || 0, this.mask && this.mask.height || 0);
                    }
                    decodeBuffer(buffer) {
                        const bpc = this.bpc;
                        const numComps = this.numComps;
                        const decodeAddends = this.decodeAddends;
                        const decodeCoefficients = this.decodeCoefficients;
                        const max = (1 << bpc) - 1;
                        let i, ii;
                        if (bpc === 1) {
                            for(i = 0, ii = buffer.length; i < ii; i++)buffer[i] = +!buffer[i];
                            return;
                        }
                        let index = 0;
                        for(i = 0, ii = this.width * this.height; i < ii; i++)for(let j = 0; j < numComps; j++){
                            buffer[index] = decodeAndClamp(buffer[index], decodeAddends[j], decodeCoefficients[j], max);
                            index++;
                        }
                    }
                    getComponents(buffer) {
                        const bpc = this.bpc;
                        if (bpc === 8) return buffer;
                        const width = this.width;
                        const height = this.height;
                        const numComps = this.numComps;
                        const length = width * height * numComps;
                        let bufferPos = 0;
                        let output;
                        if (bpc <= 8) output = new Uint8Array(length);
                        else if (bpc <= 16) output = new Uint16Array(length);
                        else output = new Uint32Array(length);
                        const rowComps = width * numComps;
                        const max = (1 << bpc) - 1;
                        let i = 0, ii, buf;
                        if (bpc === 1) {
                            let mask, loop1End, loop2End;
                            for(let j = 0; j < height; j++){
                                loop1End = i + (rowComps & -8);
                                loop2End = i + rowComps;
                                while(i < loop1End){
                                    buf = buffer[bufferPos++];
                                    output[i] = buf >> 7 & 1;
                                    output[i + 1] = buf >> 6 & 1;
                                    output[i + 2] = buf >> 5 & 1;
                                    output[i + 3] = buf >> 4 & 1;
                                    output[i + 4] = buf >> 3 & 1;
                                    output[i + 5] = buf >> 2 & 1;
                                    output[i + 6] = buf >> 1 & 1;
                                    output[i + 7] = buf & 1;
                                    i += 8;
                                }
                                if (i < loop2End) {
                                    buf = buffer[bufferPos++];
                                    mask = 128;
                                    while(i < loop2End){
                                        output[i++] = +!!(buf & mask);
                                        mask >>= 1;
                                    }
                                }
                            }
                        } else {
                            let bits = 0;
                            buf = 0;
                            for(i = 0, ii = length; i < ii; ++i){
                                if (i % rowComps === 0) {
                                    buf = 0;
                                    bits = 0;
                                }
                                while(bits < bpc){
                                    buf = buf << 8 | buffer[bufferPos++];
                                    bits += 8;
                                }
                                const remainingBits = bits - bpc;
                                let value = buf >> remainingBits;
                                if (value < 0) value = 0;
                                else if (value > max) value = max;
                                output[i] = value;
                                buf &= (1 << remainingBits) - 1;
                                bits = remainingBits;
                            }
                        }
                        return output;
                    }
                    fillOpacity(rgbaBuf, width, height, actualHeight, image) {
                        const smask = this.smask;
                        const mask = this.mask;
                        let alphaBuf, sw, sh, i, ii, j;
                        if (smask) {
                            sw = smask.width;
                            sh = smask.height;
                            alphaBuf = new Uint8ClampedArray(sw * sh);
                            smask.fillGrayBuffer(alphaBuf);
                            if (sw !== width || sh !== height) alphaBuf = resizeImageMask(alphaBuf, smask.bpc, sw, sh, width, height);
                        } else if (mask) {
                            if (mask instanceof PDFImage) {
                                sw = mask.width;
                                sh = mask.height;
                                alphaBuf = new Uint8ClampedArray(sw * sh);
                                mask.numComps = 1;
                                mask.fillGrayBuffer(alphaBuf);
                                for(i = 0, ii = sw * sh; i < ii; ++i)alphaBuf[i] = 255 - alphaBuf[i];
                                if (sw !== width || sh !== height) alphaBuf = resizeImageMask(alphaBuf, mask.bpc, sw, sh, width, height);
                            } else if (Array.isArray(mask)) {
                                alphaBuf = new Uint8ClampedArray(width * height);
                                const numComps = this.numComps;
                                for(i = 0, ii = width * height; i < ii; ++i){
                                    let opacity = 0;
                                    const imageOffset = i * numComps;
                                    for(j = 0; j < numComps; ++j){
                                        const color = image[imageOffset + j];
                                        const maskOffset = j * 2;
                                        if (color < mask[maskOffset] || color > mask[maskOffset + 1]) {
                                            opacity = 255;
                                            break;
                                        }
                                    }
                                    alphaBuf[i] = opacity;
                                }
                            } else throw new _util.FormatError("Unknown mask format.");
                        }
                        if (alphaBuf) for(i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4)rgbaBuf[j] = alphaBuf[i];
                        else for(i = 0, j = 3, ii = width * actualHeight; i < ii; ++i, j += 4)rgbaBuf[j] = 255;
                    }
                    undoPreblend(buffer, width, height) {
                        const matte = this.smask && this.smask.matte;
                        if (!matte) return;
                        const matteRgb = this.colorSpace.getRgb(matte, 0);
                        const matteR = matteRgb[0];
                        const matteG = matteRgb[1];
                        const matteB = matteRgb[2];
                        const length = width * height * 4;
                        for(let i = 0; i < length; i += 4){
                            const alpha = buffer[i + 3];
                            if (alpha === 0) {
                                buffer[i] = 255;
                                buffer[i + 1] = 255;
                                buffer[i + 2] = 255;
                                continue;
                            }
                            const k = 255 / alpha;
                            buffer[i] = (buffer[i] - matteR) * k + matteR;
                            buffer[i + 1] = (buffer[i + 1] - matteG) * k + matteG;
                            buffer[i + 2] = (buffer[i + 2] - matteB) * k + matteB;
                        }
                    }
                    createImageData(forceRGBA = false) {
                        const drawWidth = this.drawWidth;
                        const drawHeight = this.drawHeight;
                        const imgData = {
                            width: drawWidth,
                            height: drawHeight,
                            kind: 0,
                            data: null
                        };
                        const numComps = this.numComps;
                        const originalWidth = this.width;
                        const originalHeight = this.height;
                        const bpc = this.bpc;
                        const rowBytes = originalWidth * numComps * bpc + 7 >> 3;
                        let imgArray;
                        if (!forceRGBA) {
                            let kind;
                            if (this.colorSpace.name === "DeviceGray" && bpc === 1) kind = _util.ImageKind.GRAYSCALE_1BPP;
                            else if (this.colorSpace.name === "DeviceRGB" && bpc === 8 && !this.needsDecode) kind = _util.ImageKind.RGB_24BPP;
                            if (kind && !this.smask && !this.mask && drawWidth === originalWidth && drawHeight === originalHeight) {
                                imgData.kind = kind;
                                imgArray = this.getImageBytes(originalHeight * rowBytes);
                                if (this.image instanceof _decode_stream.DecodeStream) imgData.data = imgArray;
                                else {
                                    const newArray = new Uint8ClampedArray(imgArray.length);
                                    newArray.set(imgArray);
                                    imgData.data = newArray;
                                }
                                if (this.needsDecode) {
                                    (0, _util.assert)(kind === _util.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                                    const buffer = imgData.data;
                                    for(let i = 0, ii = buffer.length; i < ii; i++)buffer[i] ^= 0xff;
                                }
                                return imgData;
                            }
                            if (this.image instanceof _jpeg_stream.JpegStream && !this.smask && !this.mask) {
                                let imageLength = originalHeight * rowBytes;
                                switch(this.colorSpace.name){
                                    case "DeviceGray":
                                        imageLength *= 3;
                                    case "DeviceRGB":
                                    case "DeviceCMYK":
                                        imgData.kind = _util.ImageKind.RGB_24BPP;
                                        imgData.data = this.getImageBytes(imageLength, drawWidth, drawHeight, true);
                                        return imgData;
                                }
                            }
                        }
                        imgArray = this.getImageBytes(originalHeight * rowBytes);
                        const actualHeight = 0 | imgArray.length / rowBytes * drawHeight / originalHeight;
                        const comps = this.getComponents(imgArray);
                        let alpha01, maybeUndoPreblend;
                        if (!forceRGBA && !this.smask && !this.mask) {
                            imgData.kind = _util.ImageKind.RGB_24BPP;
                            imgData.data = new Uint8ClampedArray(drawWidth * drawHeight * 3);
                            alpha01 = 0;
                            maybeUndoPreblend = false;
                        } else {
                            imgData.kind = _util.ImageKind.RGBA_32BPP;
                            imgData.data = new Uint8ClampedArray(drawWidth * drawHeight * 4);
                            alpha01 = 1;
                            maybeUndoPreblend = true;
                            this.fillOpacity(imgData.data, drawWidth, drawHeight, actualHeight, comps);
                        }
                        if (this.needsDecode) this.decodeBuffer(comps);
                        this.colorSpace.fillRgb(imgData.data, originalWidth, originalHeight, drawWidth, drawHeight, actualHeight, bpc, comps, alpha01);
                        if (maybeUndoPreblend) this.undoPreblend(imgData.data, drawWidth, actualHeight);
                        return imgData;
                    }
                    fillGrayBuffer(buffer) {
                        const numComps = this.numComps;
                        if (numComps !== 1) throw new _util.FormatError(`Reading gray scale from a color image: ${numComps}`);
                        const width = this.width;
                        const height = this.height;
                        const bpc = this.bpc;
                        const rowBytes = width * numComps * bpc + 7 >> 3;
                        const imgArray = this.getImageBytes(height * rowBytes);
                        const comps = this.getComponents(imgArray);
                        let i, length;
                        if (bpc === 1) {
                            length = width * height;
                            if (this.needsDecode) for(i = 0; i < length; ++i)buffer[i] = comps[i] - 1 & 255;
                            else for(i = 0; i < length; ++i)buffer[i] = -comps[i] & 255;
                            return;
                        }
                        if (this.needsDecode) this.decodeBuffer(comps);
                        length = width * height;
                        const scale = 255 / ((1 << bpc) - 1);
                        for(i = 0; i < length; ++i)buffer[i] = scale * comps[i];
                    }
                    getImageBytes(length, drawWidth, drawHeight, forceRGB = false) {
                        this.image.reset();
                        this.image.drawWidth = drawWidth || this.width;
                        this.image.drawHeight = drawHeight || this.height;
                        this.image.forceRGB = !!forceRGB;
                        return this.image.getBytes(length, true);
                    }
                }
                exports.PDFImage = PDFImage;
            /***/ },
            /* 64 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Catalog = void 0;
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                var _util = __w_pdfjs_require__(2);
                var _name_number_tree = __w_pdfjs_require__(65);
                var _colorspace = __w_pdfjs_require__(14);
                var _file_spec = __w_pdfjs_require__(66);
                var _image_utils = __w_pdfjs_require__(52);
                var _metadata_parser = __w_pdfjs_require__(67);
                var _struct_tree = __w_pdfjs_require__(69);
                function fetchDestination(dest) {
                    if (dest instanceof _primitives.Dict) dest = dest.get("D");
                    return Array.isArray(dest) ? dest : null;
                }
                class Catalog {
                    constructor(pdfManager, xref){
                        this.pdfManager = pdfManager;
                        this.xref = xref;
                        this._catDict = xref.getCatalogObj();
                        if (!(0, _primitives.isDict)(this._catDict)) throw new _util.FormatError("Catalog object is not a dictionary.");
                        this.fontCache = new _primitives.RefSetCache();
                        this.builtInCMapCache = new Map();
                        this.standardFontDataCache = new Map();
                        this.globalImageCache = new _image_utils.GlobalImageCache();
                        this.pageKidsCountCache = new _primitives.RefSetCache();
                        this.pageIndexCache = new _primitives.RefSetCache();
                        this.nonBlendModesSet = new _primitives.RefSet();
                    }
                    get version() {
                        const version = this._catDict.get("Version");
                        if (!(0, _primitives.isName)(version)) return (0, _util.shadow)(this, "version", null);
                        return (0, _util.shadow)(this, "version", version.name);
                    }
                    get collection() {
                        let collection = null;
                        try {
                            const obj = this._catDict.get("Collection");
                            if ((0, _primitives.isDict)(obj) && obj.size > 0) collection = obj;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)("Cannot fetch Collection entry; assuming no collection is present.");
                        }
                        return (0, _util.shadow)(this, "collection", collection);
                    }
                    get acroForm() {
                        let acroForm = null;
                        try {
                            const obj = this._catDict.get("AcroForm");
                            if ((0, _primitives.isDict)(obj) && obj.size > 0) acroForm = obj;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
                        }
                        return (0, _util.shadow)(this, "acroForm", acroForm);
                    }
                    get metadata() {
                        const streamRef = this._catDict.getRaw("Metadata");
                        if (!(0, _primitives.isRef)(streamRef)) return (0, _util.shadow)(this, "metadata", null);
                        const suppressEncryption = !(this.xref.encrypt && this.xref.encrypt.encryptMetadata);
                        const stream = this.xref.fetch(streamRef, suppressEncryption);
                        let metadata = null;
                        if ((0, _primitives.isStream)(stream) && (0, _primitives.isDict)(stream.dict)) {
                            const type = stream.dict.get("Type");
                            const subtype = stream.dict.get("Subtype");
                            if ((0, _primitives.isName)(type, "Metadata") && (0, _primitives.isName)(subtype, "XML")) try {
                                const data = (0, _util.stringToUTF8String)(stream.getString());
                                if (data) metadata = new _metadata_parser.MetadataParser(data).serializable;
                            } catch (e) {
                                if (e instanceof _core_utils.MissingDataException) throw e;
                                (0, _util.info)("Skipping invalid metadata.");
                            }
                        }
                        return (0, _util.shadow)(this, "metadata", metadata);
                    }
                    get markInfo() {
                        let markInfo = null;
                        try {
                            markInfo = this._readMarkInfo();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read mark info.");
                        }
                        return (0, _util.shadow)(this, "markInfo", markInfo);
                    }
                    _readMarkInfo() {
                        const obj = this._catDict.get("MarkInfo");
                        if (!(0, _primitives.isDict)(obj)) return null;
                        const markInfo = Object.assign(Object.create(null), {
                            Marked: false,
                            UserProperties: false,
                            Suspects: false
                        });
                        for(const key in markInfo){
                            if (!obj.has(key)) continue;
                            const value = obj.get(key);
                            if (!(0, _util.isBool)(value)) continue;
                            markInfo[key] = value;
                        }
                        return markInfo;
                    }
                    get structTreeRoot() {
                        let structTree = null;
                        try {
                            structTree = this._readStructTreeRoot();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable read to structTreeRoot info.");
                        }
                        return (0, _util.shadow)(this, "structTreeRoot", structTree);
                    }
                    _readStructTreeRoot() {
                        const obj = this._catDict.get("StructTreeRoot");
                        if (!(0, _primitives.isDict)(obj)) return null;
                        const root = new _struct_tree.StructTreeRoot(obj);
                        root.init();
                        return root;
                    }
                    get toplevelPagesDict() {
                        const pagesObj = this._catDict.get("Pages");
                        if (!(0, _primitives.isDict)(pagesObj)) throw new _util.FormatError("Invalid top-level pages dictionary.");
                        return (0, _util.shadow)(this, "toplevelPagesDict", pagesObj);
                    }
                    get documentOutline() {
                        let obj = null;
                        try {
                            obj = this._readDocumentOutline();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read document outline.");
                        }
                        return (0, _util.shadow)(this, "documentOutline", obj);
                    }
                    _readDocumentOutline() {
                        let obj = this._catDict.get("Outlines");
                        if (!(0, _primitives.isDict)(obj)) return null;
                        obj = obj.getRaw("First");
                        if (!(0, _primitives.isRef)(obj)) return null;
                        const root = {
                            items: []
                        };
                        const queue = [
                            {
                                obj: obj,
                                parent: root
                            }
                        ];
                        const processed = new _primitives.RefSet();
                        processed.put(obj);
                        const xref = this.xref, blackColor = new Uint8ClampedArray(3);
                        while(queue.length > 0){
                            const i = queue.shift();
                            const outlineDict = xref.fetchIfRef(i.obj);
                            if (outlineDict === null) continue;
                            if (!outlineDict.has("Title")) throw new _util.FormatError("Invalid outline item encountered.");
                            const data = {
                                url: null,
                                dest: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: outlineDict,
                                resultObj: data,
                                docBaseUrl: this.pdfManager.docBaseUrl
                            });
                            const title = outlineDict.get("Title");
                            const flags = outlineDict.get("F") || 0;
                            const color = outlineDict.getArray("C");
                            const count = outlineDict.get("Count");
                            let rgbColor = blackColor;
                            if (Array.isArray(color) && color.length === 3 && (color[0] !== 0 || color[1] !== 0 || color[2] !== 0)) rgbColor = _colorspace.ColorSpace.singletons.rgb.getRgb(color, 0);
                            const outlineItem = {
                                dest: data.dest,
                                url: data.url,
                                unsafeUrl: data.unsafeUrl,
                                newWindow: data.newWindow,
                                title: (0, _util.stringToPDFString)(title),
                                color: rgbColor,
                                count: Number.isInteger(count) ? count : undefined,
                                bold: !!(flags & 2),
                                italic: !!(flags & 1),
                                items: []
                            };
                            i.parent.items.push(outlineItem);
                            obj = outlineDict.getRaw("First");
                            if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
                                queue.push({
                                    obj: obj,
                                    parent: outlineItem
                                });
                                processed.put(obj);
                            }
                            obj = outlineDict.getRaw("Next");
                            if ((0, _primitives.isRef)(obj) && !processed.has(obj)) {
                                queue.push({
                                    obj: obj,
                                    parent: i.parent
                                });
                                processed.put(obj);
                            }
                        }
                        return root.items.length > 0 ? root.items : null;
                    }
                    get permissions() {
                        let permissions = null;
                        try {
                            permissions = this._readPermissions();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read permissions.");
                        }
                        return (0, _util.shadow)(this, "permissions", permissions);
                    }
                    _readPermissions() {
                        const encrypt = this.xref.trailer.get("Encrypt");
                        if (!(0, _primitives.isDict)(encrypt)) return null;
                        let flags = encrypt.get("P");
                        if (!(0, _util.isNum)(flags)) return null;
                        flags += 2 ** 32;
                        const permissions = [];
                        for(const key in _util.PermissionFlag){
                            const value = _util.PermissionFlag[key];
                            if (flags & value) permissions.push(value);
                        }
                        return permissions;
                    }
                    get optionalContentConfig() {
                        let config = null;
                        try {
                            const properties = this._catDict.get("OCProperties");
                            if (!properties) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const defaultConfig = properties.get("D");
                            if (!defaultConfig) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const groupsData = properties.get("OCGs");
                            if (!Array.isArray(groupsData)) return (0, _util.shadow)(this, "optionalContentConfig", null);
                            const groups = [];
                            const groupRefs = [];
                            for (const groupRef of groupsData){
                                if (!(0, _primitives.isRef)(groupRef)) continue;
                                groupRefs.push(groupRef);
                                const group = this.xref.fetchIfRef(groupRef);
                                groups.push({
                                    id: groupRef.toString(),
                                    name: (0, _util.isString)(group.get("Name")) ? (0, _util.stringToPDFString)(group.get("Name")) : null,
                                    intent: (0, _util.isString)(group.get("Intent")) ? (0, _util.stringToPDFString)(group.get("Intent")) : null
                                });
                            }
                            config = this._readOptionalContentConfig(defaultConfig, groupRefs);
                            config.groups = groups;
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`Unable to read optional content config: ${ex}`);
                        }
                        return (0, _util.shadow)(this, "optionalContentConfig", config);
                    }
                    _readOptionalContentConfig(config, contentGroupRefs) {
                        function parseOnOff(refs) {
                            const onParsed = [];
                            if (Array.isArray(refs)) for (const value of refs){
                                if (!(0, _primitives.isRef)(value)) continue;
                                if (contentGroupRefs.includes(value)) onParsed.push(value.toString());
                            }
                            return onParsed;
                        }
                        function parseOrder(refs, nestedLevels = 0) {
                            if (!Array.isArray(refs)) return null;
                            const order = [];
                            for (const value of refs){
                                if ((0, _primitives.isRef)(value) && contentGroupRefs.includes(value)) {
                                    parsedOrderRefs.put(value);
                                    order.push(value.toString());
                                    continue;
                                }
                                const nestedOrder = parseNestedOrder(value, nestedLevels);
                                if (nestedOrder) order.push(nestedOrder);
                            }
                            if (nestedLevels > 0) return order;
                            const hiddenGroups = [];
                            for (const groupRef of contentGroupRefs){
                                if (parsedOrderRefs.has(groupRef)) continue;
                                hiddenGroups.push(groupRef.toString());
                            }
                            if (hiddenGroups.length) order.push({
                                name: null,
                                order: hiddenGroups
                            });
                            return order;
                        }
                        function parseNestedOrder(ref, nestedLevels) {
                            if (++nestedLevels > MAX_NESTED_LEVELS) {
                                (0, _util.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS.");
                                return null;
                            }
                            const value = xref.fetchIfRef(ref);
                            if (!Array.isArray(value)) return null;
                            const nestedName = xref.fetchIfRef(value[0]);
                            if (typeof nestedName !== "string") return null;
                            const nestedOrder = parseOrder(value.slice(1), nestedLevels);
                            if (!nestedOrder || !nestedOrder.length) return null;
                            return {
                                name: (0, _util.stringToPDFString)(nestedName),
                                order: nestedOrder
                            };
                        }
                        const xref = this.xref, parsedOrderRefs = new _primitives.RefSet(), MAX_NESTED_LEVELS = 10;
                        return {
                            name: (0, _util.isString)(config.get("Name")) ? (0, _util.stringToPDFString)(config.get("Name")) : null,
                            creator: (0, _util.isString)(config.get("Creator")) ? (0, _util.stringToPDFString)(config.get("Creator")) : null,
                            baseState: (0, _primitives.isName)(config.get("BaseState")) ? config.get("BaseState").name : null,
                            on: parseOnOff(config.get("ON")),
                            off: parseOnOff(config.get("OFF")),
                            order: parseOrder(config.get("Order")),
                            groups: null
                        };
                    }
                    get numPages() {
                        const obj = this.toplevelPagesDict.get("Count");
                        if (!Number.isInteger(obj)) throw new _util.FormatError("Page count in top-level pages dictionary is not an integer.");
                        return (0, _util.shadow)(this, "numPages", obj);
                    }
                    get destinations() {
                        const obj = this._readDests(), dests = Object.create(null);
                        if (obj instanceof _name_number_tree.NameTree) for (const [key, value] of obj.getAll()){
                            const dest = fetchDestination(value);
                            if (dest) dests[key] = dest;
                        }
                        else if (obj instanceof _primitives.Dict) obj.forEach(function(key, value) {
                            const dest = fetchDestination(value);
                            if (dest) dests[key] = dest;
                        });
                        return (0, _util.shadow)(this, "destinations", dests);
                    }
                    getDestination(id) {
                        const obj = this._readDests();
                        if (obj instanceof _name_number_tree.NameTree) {
                            const dest = fetchDestination(obj.get(id));
                            if (dest) return dest;
                            const allDest = this.destinations[id];
                            if (allDest) {
                                (0, _util.warn)(`Found "${id}" at an incorrect position in the NameTree.`);
                                return allDest;
                            }
                        } else if (obj instanceof _primitives.Dict) {
                            const dest = fetchDestination(obj.get(id));
                            if (dest) return dest;
                        }
                        return null;
                    }
                    _readDests() {
                        const obj = this._catDict.get("Names");
                        if (obj && obj.has("Dests")) return new _name_number_tree.NameTree(obj.getRaw("Dests"), this.xref);
                        else if (this._catDict.has("Dests")) return this._catDict.get("Dests");
                        return undefined;
                    }
                    get pageLabels() {
                        let obj = null;
                        try {
                            obj = this._readPageLabels();
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)("Unable to read page labels.");
                        }
                        return (0, _util.shadow)(this, "pageLabels", obj);
                    }
                    _readPageLabels() {
                        const obj = this._catDict.getRaw("PageLabels");
                        if (!obj) return null;
                        const pageLabels = new Array(this.numPages);
                        let style = null, prefix = "";
                        const numberTree = new _name_number_tree.NumberTree(obj, this.xref);
                        const nums = numberTree.getAll();
                        let currentLabel = "", currentIndex = 1;
                        for(let i = 0, ii = this.numPages; i < ii; i++){
                            const labelDict = nums.get(i);
                            if (labelDict !== undefined) {
                                if (!(0, _primitives.isDict)(labelDict)) throw new _util.FormatError("PageLabel is not a dictionary.");
                                if (labelDict.has("Type") && !(0, _primitives.isName)(labelDict.get("Type"), "PageLabel")) throw new _util.FormatError("Invalid type in PageLabel dictionary.");
                                if (labelDict.has("S")) {
                                    const s = labelDict.get("S");
                                    if (!(0, _primitives.isName)(s)) throw new _util.FormatError("Invalid style in PageLabel dictionary.");
                                    style = s.name;
                                } else style = null;
                                if (labelDict.has("P")) {
                                    const p = labelDict.get("P");
                                    if (!(0, _util.isString)(p)) throw new _util.FormatError("Invalid prefix in PageLabel dictionary.");
                                    prefix = (0, _util.stringToPDFString)(p);
                                } else prefix = "";
                                if (labelDict.has("St")) {
                                    const st = labelDict.get("St");
                                    if (!(Number.isInteger(st) && st >= 1)) throw new _util.FormatError("Invalid start in PageLabel dictionary.");
                                    currentIndex = st;
                                } else currentIndex = 1;
                            }
                            switch(style){
                                case "D":
                                    currentLabel = currentIndex;
                                    break;
                                case "R":
                                case "r":
                                    currentLabel = (0, _core_utils.toRomanNumerals)(currentIndex, style === "r");
                                    break;
                                case "A":
                                case "a":
                                    const LIMIT = 26;
                                    const A_UPPER_CASE = 0x41, A_LOWER_CASE = 0x61;
                                    const baseCharCode = style === "a" ? A_LOWER_CASE : A_UPPER_CASE;
                                    const letterIndex = currentIndex - 1;
                                    const character = String.fromCharCode(baseCharCode + letterIndex % LIMIT);
                                    const charBuf = [];
                                    for(let j = 0, jj = letterIndex / LIMIT | 0; j <= jj; j++)charBuf.push(character);
                                    currentLabel = charBuf.join("");
                                    break;
                                default:
                                    if (style) throw new _util.FormatError(`Invalid style "${style}" in PageLabel dictionary.`);
                                    currentLabel = "";
                            }
                            pageLabels[i] = prefix + currentLabel;
                            currentIndex++;
                        }
                        return pageLabels;
                    }
                    get pageLayout() {
                        const obj = this._catDict.get("PageLayout");
                        let pageLayout = "";
                        if ((0, _primitives.isName)(obj)) switch(obj.name){
                            case "SinglePage":
                            case "OneColumn":
                            case "TwoColumnLeft":
                            case "TwoColumnRight":
                            case "TwoPageLeft":
                            case "TwoPageRight":
                                pageLayout = obj.name;
                        }
                        return (0, _util.shadow)(this, "pageLayout", pageLayout);
                    }
                    get pageMode() {
                        const obj = this._catDict.get("PageMode");
                        let pageMode = "UseNone";
                        if ((0, _primitives.isName)(obj)) switch(obj.name){
                            case "UseNone":
                            case "UseOutlines":
                            case "UseThumbs":
                            case "FullScreen":
                            case "UseOC":
                            case "UseAttachments":
                                pageMode = obj.name;
                        }
                        return (0, _util.shadow)(this, "pageMode", pageMode);
                    }
                    get viewerPreferences() {
                        const ViewerPreferencesValidators = {
                            HideToolbar: _util.isBool,
                            HideMenubar: _util.isBool,
                            HideWindowUI: _util.isBool,
                            FitWindow: _util.isBool,
                            CenterWindow: _util.isBool,
                            DisplayDocTitle: _util.isBool,
                            NonFullScreenPageMode: _primitives.isName,
                            Direction: _primitives.isName,
                            ViewArea: _primitives.isName,
                            ViewClip: _primitives.isName,
                            PrintArea: _primitives.isName,
                            PrintClip: _primitives.isName,
                            PrintScaling: _primitives.isName,
                            Duplex: _primitives.isName,
                            PickTrayByPDFSize: _util.isBool,
                            PrintPageRange: Array.isArray,
                            NumCopies: Number.isInteger
                        };
                        const obj = this._catDict.get("ViewerPreferences");
                        let prefs = null;
                        if ((0, _primitives.isDict)(obj)) for(const key in ViewerPreferencesValidators){
                            if (!obj.has(key)) continue;
                            const value = obj.get(key);
                            if (!ViewerPreferencesValidators[key](value)) {
                                (0, _util.info)(`Bad value in ViewerPreferences for "${key}".`);
                                continue;
                            }
                            let prefValue;
                            switch(key){
                                case "NonFullScreenPageMode":
                                    switch(value.name){
                                        case "UseNone":
                                        case "UseOutlines":
                                        case "UseThumbs":
                                        case "UseOC":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "UseNone";
                                    }
                                    break;
                                case "Direction":
                                    switch(value.name){
                                        case "L2R":
                                        case "R2L":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "L2R";
                                    }
                                    break;
                                case "ViewArea":
                                case "ViewClip":
                                case "PrintArea":
                                case "PrintClip":
                                    switch(value.name){
                                        case "MediaBox":
                                        case "CropBox":
                                        case "BleedBox":
                                        case "TrimBox":
                                        case "ArtBox":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "CropBox";
                                    }
                                    break;
                                case "PrintScaling":
                                    switch(value.name){
                                        case "None":
                                        case "AppDefault":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "AppDefault";
                                    }
                                    break;
                                case "Duplex":
                                    switch(value.name){
                                        case "Simplex":
                                        case "DuplexFlipShortEdge":
                                        case "DuplexFlipLongEdge":
                                            prefValue = value.name;
                                            break;
                                        default:
                                            prefValue = "None";
                                    }
                                    break;
                                case "PrintPageRange":
                                    const length = value.length;
                                    if (length % 2 !== 0) break;
                                    const isValid = value.every((page, i, arr)=>{
                                        return Number.isInteger(page) && page > 0 && (i === 0 || page >= arr[i - 1]) && page <= this.numPages;
                                    });
                                    if (isValid) prefValue = value;
                                    break;
                                case "NumCopies":
                                    if (value > 0) prefValue = value;
                                    break;
                                default:
                                    if (typeof value !== "boolean") throw new _util.FormatError(`viewerPreferences - expected a boolean value for: ${key}`);
                                    prefValue = value;
                            }
                            if (prefValue !== undefined) {
                                if (!prefs) prefs = Object.create(null);
                                prefs[key] = prefValue;
                            } else (0, _util.info)(`Bad value in ViewerPreferences for "${key}".`);
                        }
                        return (0, _util.shadow)(this, "viewerPreferences", prefs);
                    }
                    get openAction() {
                        const obj = this._catDict.get("OpenAction");
                        const openAction = Object.create(null);
                        if ((0, _primitives.isDict)(obj)) {
                            const destDict = new _primitives.Dict(this.xref);
                            destDict.set("A", obj);
                            const resultObj = {
                                url: null,
                                dest: null,
                                action: null
                            };
                            Catalog.parseDestDictionary({
                                destDict: destDict,
                                resultObj: resultObj
                            });
                            if (Array.isArray(resultObj.dest)) openAction.dest = resultObj.dest;
                            else if (resultObj.action) openAction.action = resultObj.action;
                        } else if (Array.isArray(obj)) openAction.dest = obj;
                        return (0, _util.shadow)(this, "openAction", (0, _util.objectSize)(openAction) > 0 ? openAction : null);
                    }
                    get attachments() {
                        const obj = this._catDict.get("Names");
                        let attachments = null;
                        if (obj instanceof _primitives.Dict && obj.has("EmbeddedFiles")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("EmbeddedFiles"), this.xref);
                            for (const [key, value] of nameTree.getAll()){
                                const fs = new _file_spec.FileSpec(value, this.xref);
                                if (!attachments) attachments = Object.create(null);
                                attachments[(0, _util.stringToPDFString)(key)] = fs.serializable;
                            }
                        }
                        return (0, _util.shadow)(this, "attachments", attachments);
                    }
                    get xfaImages() {
                        const obj = this._catDict.get("Names");
                        let xfaImages = null;
                        if (obj instanceof _primitives.Dict && obj.has("XFAImages")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("XFAImages"), this.xref);
                            for (const [key, value] of nameTree.getAll()){
                                if (!xfaImages) xfaImages = new _primitives.Dict(this.xref);
                                xfaImages.set(key, value);
                            }
                        }
                        return (0, _util.shadow)(this, "xfaImages", xfaImages);
                    }
                    _collectJavaScript() {
                        const obj = this._catDict.get("Names");
                        let javaScript = null;
                        function appendIfJavaScriptDict(name, jsDict) {
                            if (!(jsDict instanceof _primitives.Dict)) return;
                            if (!(0, _primitives.isName)(jsDict.get("S"), "JavaScript")) return;
                            let js = jsDict.get("JS");
                            if ((0, _primitives.isStream)(js)) js = js.getString();
                            else if (typeof js !== "string") return;
                            if (javaScript === null) javaScript = new Map();
                            javaScript.set(name, (0, _util.stringToPDFString)(js));
                        }
                        if (obj instanceof _primitives.Dict && obj.has("JavaScript")) {
                            const nameTree = new _name_number_tree.NameTree(obj.getRaw("JavaScript"), this.xref);
                            for (const [key, value] of nameTree.getAll())appendIfJavaScriptDict(key, value);
                        }
                        const openAction = this._catDict.get("OpenAction");
                        if (openAction) appendIfJavaScriptDict("OpenAction", openAction);
                        return javaScript;
                    }
                    get javaScript() {
                        const javaScript = this._collectJavaScript();
                        return (0, _util.shadow)(this, "javaScript", javaScript ? [
                            ...javaScript.values()
                        ] : null);
                    }
                    get jsActions() {
                        const javaScript = this._collectJavaScript();
                        let actions = (0, _core_utils.collectActions)(this.xref, this._catDict, _util.DocumentActionEventType);
                        if (javaScript) {
                            if (!actions) actions = Object.create(null);
                            for (const [key, val] of javaScript)if (key in actions) actions[key].push(val);
                            else actions[key] = [
                                val
                            ];
                        }
                        return (0, _util.shadow)(this, "jsActions", actions);
                    }
                    fontFallback(id, handler) {
                        const promises = [];
                        this.fontCache.forEach(function(promise) {
                            promises.push(promise);
                        });
                        return Promise.all(promises).then((translatedFonts)=>{
                            for (const translatedFont of translatedFonts)if (translatedFont.loadedName === id) {
                                translatedFont.fallback(handler);
                                return;
                            }
                        });
                    }
                    cleanup(manuallyTriggered = false) {
                        (0, _primitives.clearPrimitiveCaches)();
                        this.globalImageCache.clear(manuallyTriggered);
                        this.pageKidsCountCache.clear();
                        this.pageIndexCache.clear();
                        this.nonBlendModesSet.clear();
                        const promises = [];
                        this.fontCache.forEach(function(promise) {
                            promises.push(promise);
                        });
                        return Promise.all(promises).then((translatedFonts)=>{
                            for (const { dict: dict  } of translatedFonts)delete dict.cacheKey;
                            this.fontCache.clear();
                            this.builtInCMapCache.clear();
                            this.standardFontDataCache.clear();
                        });
                    }
                    getPageDict(pageIndex) {
                        const capability = (0, _util.createPromiseCapability)();
                        const nodesToVisit = [
                            this._catDict.getRaw("Pages")
                        ];
                        const visitedNodes = new _primitives.RefSet();
                        const xref = this.xref, pageKidsCountCache = this.pageKidsCountCache;
                        let count, currentPageIndex = 0;
                        function next() {
                            while(nodesToVisit.length){
                                const currentNode = nodesToVisit.pop();
                                if ((0, _primitives.isRef)(currentNode)) {
                                    count = pageKidsCountCache.get(currentNode);
                                    if (count > 0 && currentPageIndex + count < pageIndex) {
                                        currentPageIndex += count;
                                        continue;
                                    }
                                    if (visitedNodes.has(currentNode)) {
                                        capability.reject(new _util.FormatError("Pages tree contains circular reference."));
                                        return;
                                    }
                                    visitedNodes.put(currentNode);
                                    xref.fetchAsync(currentNode).then(function(obj) {
                                        if ((0, _primitives.isDict)(obj, "Page") || (0, _primitives.isDict)(obj) && !obj.has("Kids")) {
                                            if (pageIndex === currentPageIndex) {
                                                if (currentNode && !pageKidsCountCache.has(currentNode)) pageKidsCountCache.put(currentNode, 1);
                                                capability.resolve([
                                                    obj,
                                                    currentNode
                                                ]);
                                            } else {
                                                currentPageIndex++;
                                                next();
                                            }
                                            return;
                                        }
                                        nodesToVisit.push(obj);
                                        next();
                                    }, capability.reject);
                                    return;
                                }
                                if (!(0, _primitives.isDict)(currentNode)) {
                                    capability.reject(new _util.FormatError("Page dictionary kid reference points to wrong type of object."));
                                    return;
                                }
                                count = currentNode.get("Count");
                                if (Number.isInteger(count) && count >= 0) {
                                    const objId = currentNode.objId;
                                    if (objId && !pageKidsCountCache.has(objId)) pageKidsCountCache.put(objId, count);
                                    if (currentPageIndex + count <= pageIndex) {
                                        currentPageIndex += count;
                                        continue;
                                    }
                                }
                                const kids = currentNode.get("Kids");
                                if (!Array.isArray(kids)) {
                                    if ((0, _primitives.isName)(currentNode.get("Type"), "Page") || !currentNode.has("Type") && currentNode.has("Contents")) {
                                        if (currentPageIndex === pageIndex) {
                                            capability.resolve([
                                                currentNode,
                                                null
                                            ]);
                                            return;
                                        }
                                        currentPageIndex++;
                                        continue;
                                    }
                                    capability.reject(new _util.FormatError("Page dictionary kids object is not an array."));
                                    return;
                                }
                                for(let last = kids.length - 1; last >= 0; last--)nodesToVisit.push(kids[last]);
                            }
                            capability.reject(new Error(`Page index ${pageIndex} not found.`));
                        }
                        next();
                        return capability.promise;
                    }
                    getPageIndex(pageRef) {
                        const cachedPageIndex = this.pageIndexCache.get(pageRef);
                        if (cachedPageIndex !== undefined) return Promise.resolve(cachedPageIndex);
                        const xref = this.xref;
                        function pagesBeforeRef(kidRef) {
                            let total = 0, parentRef;
                            return xref.fetchAsync(kidRef).then(function(node) {
                                if ((0, _primitives.isRefsEqual)(kidRef, pageRef) && !(0, _primitives.isDict)(node, "Page") && !((0, _primitives.isDict)(node) && !node.has("Type") && node.has("Contents"))) throw new _util.FormatError("The reference does not point to a /Page dictionary.");
                                if (!node) return null;
                                if (!(0, _primitives.isDict)(node)) throw new _util.FormatError("Node must be a dictionary.");
                                parentRef = node.getRaw("Parent");
                                return node.getAsync("Parent");
                            }).then(function(parent) {
                                if (!parent) return null;
                                if (!(0, _primitives.isDict)(parent)) throw new _util.FormatError("Parent must be a dictionary.");
                                return parent.getAsync("Kids");
                            }).then(function(kids) {
                                if (!kids) return null;
                                const kidPromises = [];
                                let found = false;
                                for(let i = 0, ii = kids.length; i < ii; i++){
                                    const kid = kids[i];
                                    if (!(0, _primitives.isRef)(kid)) throw new _util.FormatError("Kid must be a reference.");
                                    if ((0, _primitives.isRefsEqual)(kid, kidRef)) {
                                        found = true;
                                        break;
                                    }
                                    kidPromises.push(xref.fetchAsync(kid).then(function(obj) {
                                        if (!(0, _primitives.isDict)(obj)) throw new _util.FormatError("Kid node must be a dictionary.");
                                        if (obj.has("Count")) total += obj.get("Count");
                                        else total++;
                                    }));
                                }
                                if (!found) throw new _util.FormatError("Kid reference not found in parent's kids.");
                                return Promise.all(kidPromises).then(function() {
                                    return [
                                        total,
                                        parentRef
                                    ];
                                });
                            });
                        }
                        let total = 0;
                        const next = (ref)=>pagesBeforeRef(ref).then((args)=>{
                                if (!args) {
                                    this.pageIndexCache.put(pageRef, total);
                                    return total;
                                }
                                const [count, parentRef] = args;
                                total += count;
                                return next(parentRef);
                            });
                        return next(pageRef);
                    }
                    static parseDestDictionary(params) {
                        function addDefaultProtocolToUrl(url) {
                            return url.startsWith("www.") ? `http://${url}` : url;
                        }
                        function tryConvertUrlEncoding(url) {
                            try {
                                return (0, _util.stringToUTF8String)(url);
                            } catch (e) {
                                return url;
                            }
                        }
                        const destDict = params.destDict;
                        if (!(0, _primitives.isDict)(destDict)) {
                            (0, _util.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                            return;
                        }
                        const resultObj = params.resultObj;
                        if (typeof resultObj !== "object") {
                            (0, _util.warn)("parseDestDictionary: `resultObj` must be an object.");
                            return;
                        }
                        const docBaseUrl = params.docBaseUrl || null;
                        let action = destDict.get("A"), url, dest;
                        if (!(0, _primitives.isDict)(action)) {
                            if (destDict.has("Dest")) action = destDict.get("Dest");
                            else {
                                action = destDict.get("AA");
                                if ((0, _primitives.isDict)(action)) {
                                    if (action.has("D")) action = action.get("D");
                                    else if (action.has("U")) action = action.get("U");
                                }
                            }
                        }
                        if ((0, _primitives.isDict)(action)) {
                            const actionType = action.get("S");
                            if (!(0, _primitives.isName)(actionType)) {
                                (0, _util.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                                return;
                            }
                            const actionName = actionType.name;
                            switch(actionName){
                                case "URI":
                                    url = action.get("URI");
                                    if ((0, _primitives.isName)(url)) url = "/" + url.name;
                                    else if ((0, _util.isString)(url)) url = addDefaultProtocolToUrl(url);
                                    break;
                                case "GoTo":
                                    dest = action.get("D");
                                    break;
                                case "Launch":
                                case "GoToR":
                                    const urlDict = action.get("F");
                                    if ((0, _primitives.isDict)(urlDict)) url = urlDict.get("F") || null;
                                    else if ((0, _util.isString)(urlDict)) url = urlDict;
                                    let remoteDest = action.get("D");
                                    if (remoteDest) {
                                        if ((0, _primitives.isName)(remoteDest)) remoteDest = remoteDest.name;
                                        if ((0, _util.isString)(url)) {
                                            const baseUrl = url.split("#")[0];
                                            if ((0, _util.isString)(remoteDest)) url = baseUrl + "#" + remoteDest;
                                            else if (Array.isArray(remoteDest)) url = baseUrl + "#" + JSON.stringify(remoteDest);
                                        }
                                    }
                                    const newWindow = action.get("NewWindow");
                                    if ((0, _util.isBool)(newWindow)) resultObj.newWindow = newWindow;
                                    break;
                                case "Named":
                                    const namedAction = action.get("N");
                                    if ((0, _primitives.isName)(namedAction)) resultObj.action = namedAction.name;
                                    break;
                                case "JavaScript":
                                    const jsAction = action.get("JS");
                                    let js;
                                    if ((0, _primitives.isStream)(jsAction)) js = jsAction.getString();
                                    else if ((0, _util.isString)(jsAction)) js = jsAction;
                                    if (js) {
                                        const URL_OPEN_METHODS = [
                                            "app.launchURL",
                                            "window.open"
                                        ];
                                        const regex = new RegExp("^\\s*(" + URL_OPEN_METHODS.join("|").split(".").join("\\.") + ")\\((?:'|\")([^'\"]*)(?:'|\")(?:,\\s*(\\w+)\\)|\\))", "i");
                                        const jsUrl = regex.exec((0, _util.stringToPDFString)(js));
                                        if (jsUrl && jsUrl[2]) {
                                            url = jsUrl[2];
                                            if (jsUrl[3] === "true" && jsUrl[1] === "app.launchURL") resultObj.newWindow = true;
                                            break;
                                        }
                                    }
                                default:
                                    if (actionName === "JavaScript" || actionName === "ResetForm" || actionName === "SubmitForm") break;
                                    (0, _util.warn)(`parseDestDictionary - unsupported action: "${actionName}".`);
                                    break;
                            }
                        } else if (destDict.has("Dest")) dest = destDict.get("Dest");
                        if ((0, _util.isString)(url)) {
                            url = tryConvertUrlEncoding(url);
                            const absoluteUrl = (0, _util.createValidAbsoluteUrl)(url, docBaseUrl);
                            if (absoluteUrl) resultObj.url = absoluteUrl.href;
                            resultObj.unsafeUrl = url;
                        }
                        if (dest) {
                            if ((0, _primitives.isName)(dest)) dest = dest.name;
                            if ((0, _util.isString)(dest) || Array.isArray(dest)) resultObj.dest = dest;
                        }
                    }
                }
                exports.Catalog = Catalog;
            /***/ },
            /* 65 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NumberTree = exports.NameTree = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                class NameOrNumberTree {
                    constructor(root, xref, type){
                        if (this.constructor === NameOrNumberTree) (0, _util.unreachable)("Cannot initialize NameOrNumberTree.");
                        this.root = root;
                        this.xref = xref;
                        this._type = type;
                    }
                    getAll() {
                        const map = new Map();
                        if (!this.root) return map;
                        const xref = this.xref;
                        const processed = new _primitives.RefSet();
                        processed.put(this.root);
                        const queue = [
                            this.root
                        ];
                        while(queue.length > 0){
                            const obj = xref.fetchIfRef(queue.shift());
                            if (!(0, _primitives.isDict)(obj)) continue;
                            if (obj.has("Kids")) {
                                const kids = obj.get("Kids");
                                for(let i = 0, ii = kids.length; i < ii; i++){
                                    const kid = kids[i];
                                    if (processed.has(kid)) throw new _util.FormatError(`Duplicate entry in "${this._type}" tree.`);
                                    queue.push(kid);
                                    processed.put(kid);
                                }
                                continue;
                            }
                            const entries = obj.get(this._type);
                            if (!Array.isArray(entries)) continue;
                            for(let i = 0, ii = entries.length; i < ii; i += 2)map.set(xref.fetchIfRef(entries[i]), xref.fetchIfRef(entries[i + 1]));
                        }
                        return map;
                    }
                    get(key) {
                        if (!this.root) return null;
                        const xref = this.xref;
                        let kidsOrEntries = xref.fetchIfRef(this.root);
                        let loopCount = 0;
                        const MAX_LEVELS = 10;
                        while(kidsOrEntries.has("Kids")){
                            if (++loopCount > MAX_LEVELS) {
                                (0, _util.warn)(`Search depth limit reached for "${this._type}" tree.`);
                                return null;
                            }
                            const kids = kidsOrEntries.get("Kids");
                            if (!Array.isArray(kids)) return null;
                            let l = 0, r = kids.length - 1;
                            while(l <= r){
                                const m = l + r >> 1;
                                const kid = xref.fetchIfRef(kids[m]);
                                const limits = kid.get("Limits");
                                if (key < xref.fetchIfRef(limits[0])) r = m - 1;
                                else if (key > xref.fetchIfRef(limits[1])) l = m + 1;
                                else {
                                    kidsOrEntries = xref.fetchIfRef(kids[m]);
                                    break;
                                }
                            }
                            if (l > r) return null;
                        }
                        const entries = kidsOrEntries.get(this._type);
                        if (Array.isArray(entries)) {
                            let l = 0, r = entries.length - 2;
                            while(l <= r){
                                const tmp = l + r >> 1, m = tmp + (tmp & 1);
                                const currentKey = xref.fetchIfRef(entries[m]);
                                if (key < currentKey) r = m - 2;
                                else if (key > currentKey) l = m + 2;
                                else return xref.fetchIfRef(entries[m + 1]);
                            }
                        }
                        return null;
                    }
                }
                class NameTree extends NameOrNumberTree {
                    constructor(root, xref){
                        super(root, xref, "Names");
                    }
                }
                exports.NameTree = NameTree;
                class NumberTree extends NameOrNumberTree {
                    constructor(root, xref){
                        super(root, xref, "Nums");
                    }
                }
                exports.NumberTree = NumberTree;
            /***/ },
            /* 66 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FileSpec = void 0;
                var _primitives = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(2);
                function pickPlatformItem(dict) {
                    if (dict.has("UF")) return dict.get("UF");
                    else if (dict.has("F")) return dict.get("F");
                    else if (dict.has("Unix")) return dict.get("Unix");
                    else if (dict.has("Mac")) return dict.get("Mac");
                    else if (dict.has("DOS")) return dict.get("DOS");
                    return null;
                }
                class FileSpec {
                    constructor(root, xref){
                        if (!root || !(0, _primitives.isDict)(root)) return;
                        this.xref = xref;
                        this.root = root;
                        if (root.has("FS")) this.fs = root.get("FS");
                        this.description = root.has("Desc") ? (0, _util.stringToPDFString)(root.get("Desc")) : "";
                        if (root.has("RF")) (0, _util.warn)("Related file specifications are not supported");
                        this.contentAvailable = true;
                        if (!root.has("EF")) {
                            this.contentAvailable = false;
                            (0, _util.warn)("Non-embedded file specifications are not supported");
                        }
                    }
                    get filename() {
                        if (!this._filename && this.root) {
                            const filename = pickPlatformItem(this.root) || "unnamed";
                            this._filename = (0, _util.stringToPDFString)(filename).replace(/\\\\/g, "\\").replace(/\\\//g, "/").replace(/\\/g, "/");
                        }
                        return this._filename;
                    }
                    get content() {
                        if (!this.contentAvailable) return null;
                        if (!this.contentRef && this.root) this.contentRef = pickPlatformItem(this.root.get("EF"));
                        let content = null;
                        if (this.contentRef) {
                            const fileObj = this.xref.fetchIfRef(this.contentRef);
                            if (fileObj && (0, _primitives.isStream)(fileObj)) content = fileObj.getBytes();
                            else (0, _util.warn)("Embedded file specification points to non-existing/invalid content");
                        } else (0, _util.warn)("Embedded file specification does not have a content");
                        return content;
                    }
                    get serializable() {
                        return {
                            filename: this.filename,
                            content: this.content
                        };
                    }
                }
                exports.FileSpec = FileSpec;
            /***/ },
            /* 67 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MetadataParser = void 0;
                var _xml_parser = __w_pdfjs_require__(68);
                class MetadataParser {
                    constructor(data){
                        data = this._repair(data);
                        const parser = new _xml_parser.SimpleXMLParser({
                            lowerCaseName: true
                        });
                        const xmlDocument = parser.parseFromString(data);
                        this._metadataMap = new Map();
                        this._data = data;
                        if (xmlDocument) this._parse(xmlDocument);
                    }
                    _repair(data) {
                        return data.replace(/^[^<]+/, "").replace(/>\\376\\377([^<]+)/g, function(all, codes) {
                            const bytes = codes.replace(/\\([0-3])([0-7])([0-7])/g, function(code, d1, d2, d3) {
                                return String.fromCharCode(d1 * 64 + d2 * 8 + d3 * 1);
                            }).replace(/&(amp|apos|gt|lt|quot);/g, function(str, name) {
                                switch(name){
                                    case "amp":
                                        return "&";
                                    case "apos":
                                        return "'";
                                    case "gt":
                                        return ">";
                                    case "lt":
                                        return "<";
                                    case "quot":
                                        return '"';
                                }
                                throw new Error(`_repair: ${name} isn't defined.`);
                            });
                            const charBuf = [];
                            for(let i = 0, ii = bytes.length; i < ii; i += 2){
                                const code = bytes.charCodeAt(i) * 256 + bytes.charCodeAt(i + 1);
                                if (code >= 32 && code < 127 && code !== 60 && code !== 62 && code !== 38) charBuf.push(String.fromCharCode(code));
                                else charBuf.push("&#x" + (0x10000 + code).toString(16).substring(1) + ";");
                            }
                            return ">" + charBuf.join("");
                        });
                    }
                    _getSequence(entry) {
                        const name = entry.nodeName;
                        if (name !== "rdf:bag" && name !== "rdf:seq" && name !== "rdf:alt") return null;
                        return entry.childNodes.filter((node)=>node.nodeName === "rdf:li");
                    }
                    _parseArray(entry) {
                        if (!entry.hasChildNodes()) return;
                        const [seqNode] = entry.childNodes;
                        const sequence = this._getSequence(seqNode) || [];
                        this._metadataMap.set(entry.nodeName, sequence.map((node)=>node.textContent.trim()));
                    }
                    _parse(xmlDocument) {
                        let rdf = xmlDocument.documentElement;
                        if (rdf.nodeName !== "rdf:rdf") {
                            rdf = rdf.firstChild;
                            while(rdf && rdf.nodeName !== "rdf:rdf")rdf = rdf.nextSibling;
                        }
                        if (!rdf || rdf.nodeName !== "rdf:rdf" || !rdf.hasChildNodes()) return;
                        for (const desc of rdf.childNodes){
                            if (desc.nodeName !== "rdf:description") continue;
                            for (const entry of desc.childNodes){
                                const name = entry.nodeName;
                                switch(name){
                                    case "#text":
                                        continue;
                                    case "dc:creator":
                                    case "dc:subject":
                                        this._parseArray(entry);
                                        continue;
                                }
                                this._metadataMap.set(name, entry.textContent.trim());
                            }
                        }
                    }
                    get serializable() {
                        return {
                            parsedData: this._metadataMap,
                            rawData: this._data
                        };
                    }
                }
                exports.MetadataParser = MetadataParser;
            /***/ },
            /* 68 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XMLParserErrorCode = exports.XMLParserBase = exports.SimpleXMLParser = exports.SimpleDOMNode = void 0;
                var _core_utils = __w_pdfjs_require__(9);
                const XMLParserErrorCode = {
                    NoError: 0,
                    EndOfDocument: -1,
                    UnterminatedCdat: -2,
                    UnterminatedXmlDeclaration: -3,
                    UnterminatedDoctypeDeclaration: -4,
                    UnterminatedComment: -5,
                    MalformedElement: -6,
                    OutOfMemory: -7,
                    UnterminatedAttributeValue: -8,
                    UnterminatedElement: -9,
                    ElementNeverBegun: -10
                };
                exports.XMLParserErrorCode = XMLParserErrorCode;
                function isWhitespace(s, index) {
                    const ch = s[index];
                    return ch === " " || ch === "\n" || ch === "\r" || ch === "	";
                }
                function isWhitespaceString(s) {
                    for(let i = 0, ii = s.length; i < ii; i++){
                        if (!isWhitespace(s, i)) return false;
                    }
                    return true;
                }
                class XMLParserBase {
                    _resolveEntities(s) {
                        return s.replace(/&([^;]+);/g, (all, entity)=>{
                            if (entity.substring(0, 2) === "#x") return String.fromCodePoint(parseInt(entity.substring(2), 16));
                            else if (entity.substring(0, 1) === "#") return String.fromCodePoint(parseInt(entity.substring(1), 10));
                            switch(entity){
                                case "lt":
                                    return "<";
                                case "gt":
                                    return ">";
                                case "amp":
                                    return "&";
                                case "quot":
                                    return '"';
                                case "apos":
                                    return "'";
                            }
                            return this.onResolveEntity(entity);
                        });
                    }
                    _parseContent(s, start) {
                        const attributes = [];
                        let pos = start;
                        function skipWs() {
                            while(pos < s.length && isWhitespace(s, pos))++pos;
                        }
                        while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "/")++pos;
                        const name = s.substring(start, pos);
                        skipWs();
                        while(pos < s.length && s[pos] !== ">" && s[pos] !== "/" && s[pos] !== "?"){
                            skipWs();
                            let attrName = "", attrValue = "";
                            while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== "="){
                                attrName += s[pos];
                                ++pos;
                            }
                            skipWs();
                            if (s[pos] !== "=") return null;
                            ++pos;
                            skipWs();
                            const attrEndChar = s[pos];
                            if (attrEndChar !== '"' && attrEndChar !== "'") return null;
                            const attrEndIndex = s.indexOf(attrEndChar, ++pos);
                            if (attrEndIndex < 0) return null;
                            attrValue = s.substring(pos, attrEndIndex);
                            attributes.push({
                                name: attrName,
                                value: this._resolveEntities(attrValue)
                            });
                            pos = attrEndIndex + 1;
                            skipWs();
                        }
                        return {
                            name: name,
                            attributes: attributes,
                            parsed: pos - start
                        };
                    }
                    _parseProcessingInstruction(s, start) {
                        let pos = start;
                        function skipWs() {
                            while(pos < s.length && isWhitespace(s, pos))++pos;
                        }
                        while(pos < s.length && !isWhitespace(s, pos) && s[pos] !== ">" && s[pos] !== "?" && s[pos] !== "/")++pos;
                        const name = s.substring(start, pos);
                        skipWs();
                        const attrStart = pos;
                        while(pos < s.length && (s[pos] !== "?" || s[pos + 1] !== ">"))++pos;
                        const value = s.substring(attrStart, pos);
                        return {
                            name: name,
                            value: value,
                            parsed: pos - start
                        };
                    }
                    parseXml(s) {
                        let i = 0;
                        while(i < s.length){
                            const ch = s[i];
                            let j = i;
                            if (ch === "<") {
                                ++j;
                                const ch2 = s[j];
                                let q;
                                switch(ch2){
                                    case "/":
                                        ++j;
                                        q = s.indexOf(">", j);
                                        if (q < 0) {
                                            this.onError(XMLParserErrorCode.UnterminatedElement);
                                            return;
                                        }
                                        this.onEndElement(s.substring(j, q));
                                        j = q + 1;
                                        break;
                                    case "?":
                                        ++j;
                                        const pi = this._parseProcessingInstruction(s, j);
                                        if (s.substring(j + pi.parsed, j + pi.parsed + 2) !== "?>") {
                                            this.onError(XMLParserErrorCode.UnterminatedXmlDeclaration);
                                            return;
                                        }
                                        this.onPi(pi.name, pi.value);
                                        j += pi.parsed + 2;
                                        break;
                                    case "!":
                                        if (s.substring(j + 1, j + 3) === "--") {
                                            q = s.indexOf("-->", j + 3);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedComment);
                                                return;
                                            }
                                            this.onComment(s.substring(j + 3, q));
                                            j = q + 3;
                                        } else if (s.substring(j + 1, j + 8) === "[CDATA[") {
                                            q = s.indexOf("]]>", j + 8);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedCdat);
                                                return;
                                            }
                                            this.onCdata(s.substring(j + 8, q));
                                            j = q + 3;
                                        } else if (s.substring(j + 1, j + 8) === "DOCTYPE") {
                                            const q2 = s.indexOf("[", j + 8);
                                            let complexDoctype = false;
                                            q = s.indexOf(">", j + 8);
                                            if (q < 0) {
                                                this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                                                return;
                                            }
                                            if (q2 > 0 && q > q2) {
                                                q = s.indexOf("]>", j + 8);
                                                if (q < 0) {
                                                    this.onError(XMLParserErrorCode.UnterminatedDoctypeDeclaration);
                                                    return;
                                                }
                                                complexDoctype = true;
                                            }
                                            const doctypeContent = s.substring(j + 8, q + (complexDoctype ? 1 : 0));
                                            this.onDoctype(doctypeContent);
                                            j = q + (complexDoctype ? 2 : 1);
                                        } else {
                                            this.onError(XMLParserErrorCode.MalformedElement);
                                            return;
                                        }
                                        break;
                                    default:
                                        const content = this._parseContent(s, j);
                                        if (content === null) {
                                            this.onError(XMLParserErrorCode.MalformedElement);
                                            return;
                                        }
                                        let isClosed = false;
                                        if (s.substring(j + content.parsed, j + content.parsed + 2) === "/>") isClosed = true;
                                        else if (s.substring(j + content.parsed, j + content.parsed + 1) !== ">") {
                                            this.onError(XMLParserErrorCode.UnterminatedElement);
                                            return;
                                        }
                                        this.onBeginElement(content.name, content.attributes, isClosed);
                                        j += content.parsed + (isClosed ? 2 : 1);
                                        break;
                                }
                            } else {
                                while(j < s.length && s[j] !== "<")j++;
                                const text = s.substring(i, j);
                                this.onText(this._resolveEntities(text));
                            }
                            i = j;
                        }
                    }
                    onResolveEntity(name) {
                        return `&${name};`;
                    }
                    onPi(name, value) {}
                    onComment(text) {}
                    onCdata(text) {}
                    onDoctype(doctypeContent) {}
                    onText(text) {}
                    onBeginElement(name, attributes, isEmpty) {}
                    onEndElement(name) {}
                    onError(code) {}
                }
                exports.XMLParserBase = XMLParserBase;
                class SimpleDOMNode {
                    constructor(nodeName, nodeValue){
                        this.nodeName = nodeName;
                        this.nodeValue = nodeValue;
                        Object.defineProperty(this, "parentNode", {
                            value: null,
                            writable: true
                        });
                    }
                    get firstChild() {
                        return this.childNodes && this.childNodes[0];
                    }
                    get nextSibling() {
                        const childNodes = this.parentNode.childNodes;
                        if (!childNodes) return undefined;
                        const index = childNodes.indexOf(this);
                        if (index === -1) return undefined;
                        return childNodes[index + 1];
                    }
                    get textContent() {
                        if (!this.childNodes) return this.nodeValue || "";
                        return this.childNodes.map(function(child) {
                            return child.textContent;
                        }).join("");
                    }
                    hasChildNodes() {
                        return this.childNodes && this.childNodes.length > 0;
                    }
                    searchNode(paths, pos) {
                        if (pos >= paths.length) return this;
                        const component = paths[pos];
                        const stack = [];
                        let node = this;
                        while(true){
                            if (component.name === node.nodeName) {
                                if (component.pos === 0) {
                                    const res = node.searchNode(paths, pos + 1);
                                    if (res !== null) return res;
                                } else if (stack.length === 0) return null;
                                else {
                                    const [parent] = stack.pop();
                                    let siblingPos = 0;
                                    for (const child of parent.childNodes)if (component.name === child.nodeName) {
                                        if (siblingPos === component.pos) return child.searchNode(paths, pos + 1);
                                        siblingPos++;
                                    }
                                    return node.searchNode(paths, pos + 1);
                                }
                            }
                            if (node.childNodes && node.childNodes.length !== 0) {
                                stack.push([
                                    node,
                                    0
                                ]);
                                node = node.childNodes[0];
                            } else if (stack.length === 0) return null;
                            else {
                                while(stack.length !== 0){
                                    const [parent, currentPos] = stack.pop();
                                    const newPos = currentPos + 1;
                                    if (newPos < parent.childNodes.length) {
                                        stack.push([
                                            parent,
                                            newPos
                                        ]);
                                        node = parent.childNodes[newPos];
                                        break;
                                    }
                                }
                                if (stack.length === 0) return null;
                            }
                        }
                    }
                    dump(buffer) {
                        if (this.nodeName === "#text") {
                            buffer.push((0, _core_utils.encodeToXmlString)(this.nodeValue));
                            return;
                        }
                        buffer.push(`<${this.nodeName}`);
                        if (this.attributes) for (const attribute of this.attributes)buffer.push(` ${attribute.name}="${(0, _core_utils.encodeToXmlString)(attribute.value)}"`);
                        if (this.hasChildNodes()) {
                            buffer.push(">");
                            for (const child of this.childNodes)child.dump(buffer);
                            buffer.push(`</${this.nodeName}>`);
                        } else if (this.nodeValue) buffer.push(`>${(0, _core_utils.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`);
                        else buffer.push("/>");
                    }
                }
                exports.SimpleDOMNode = SimpleDOMNode;
                class SimpleXMLParser extends XMLParserBase {
                    constructor({ hasAttributes: hasAttributes = false , lowerCaseName: lowerCaseName = false  }){
                        super();
                        this._currentFragment = null;
                        this._stack = null;
                        this._errorCode = XMLParserErrorCode.NoError;
                        this._hasAttributes = hasAttributes;
                        this._lowerCaseName = lowerCaseName;
                    }
                    parseFromString(data) {
                        this._currentFragment = [];
                        this._stack = [];
                        this._errorCode = XMLParserErrorCode.NoError;
                        this.parseXml(data);
                        if (this._errorCode !== XMLParserErrorCode.NoError) return undefined;
                        const [documentElement] = this._currentFragment;
                        if (!documentElement) return undefined;
                        return {
                            documentElement: documentElement
                        };
                    }
                    onText(text) {
                        if (isWhitespaceString(text)) return;
                        const node = new SimpleDOMNode("#text", text);
                        this._currentFragment.push(node);
                    }
                    onCdata(text) {
                        const node = new SimpleDOMNode("#text", text);
                        this._currentFragment.push(node);
                    }
                    onBeginElement(name, attributes, isEmpty) {
                        if (this._lowerCaseName) name = name.toLowerCase();
                        const node = new SimpleDOMNode(name);
                        node.childNodes = [];
                        if (this._hasAttributes) node.attributes = attributes;
                        this._currentFragment.push(node);
                        if (isEmpty) return;
                        this._stack.push(this._currentFragment);
                        this._currentFragment = node.childNodes;
                    }
                    onEndElement(name) {
                        this._currentFragment = this._stack.pop() || [];
                        const lastElement = this._currentFragment[this._currentFragment.length - 1];
                        if (!lastElement) return;
                        for(let i = 0, ii = lastElement.childNodes.length; i < ii; i++)lastElement.childNodes[i].parentNode = lastElement;
                    }
                    onError(code) {
                        this._errorCode = code;
                    }
                }
                exports.SimpleXMLParser = SimpleXMLParser;
            /***/ },
            /* 69 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StructTreeRoot = exports.StructTreePage = void 0;
                var _primitives = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(2);
                var _name_number_tree = __w_pdfjs_require__(65);
                const MAX_DEPTH = 40;
                const StructElementType = {
                    PAGE_CONTENT: "PAGE_CONTENT",
                    STREAM_CONTENT: "STREAM_CONTENT",
                    OBJECT: "OBJECT",
                    ELEMENT: "ELEMENT"
                };
                class StructTreeRoot {
                    constructor(rootDict){
                        this.dict = rootDict;
                        this.roleMap = new Map();
                    }
                    init() {
                        this.readRoleMap();
                    }
                    readRoleMap() {
                        const roleMapDict = this.dict.get("RoleMap");
                        if (!(0, _primitives.isDict)(roleMapDict)) return;
                        roleMapDict.forEach((key, value)=>{
                            if (!(0, _primitives.isName)(value)) return;
                            this.roleMap.set(key, value.name);
                        });
                    }
                }
                exports.StructTreeRoot = StructTreeRoot;
                class StructElementNode {
                    constructor(tree, dict){
                        this.tree = tree;
                        this.dict = dict;
                        this.kids = [];
                        this.parseKids();
                    }
                    get role() {
                        const nameObj = this.dict.get("S");
                        const name = (0, _primitives.isName)(nameObj) ? nameObj.name : "";
                        const { root: root  } = this.tree;
                        if (root.roleMap.has(name)) return root.roleMap.get(name);
                        return name;
                    }
                    parseKids() {
                        let pageObjId = null;
                        const objRef = this.dict.getRaw("Pg");
                        if ((0, _primitives.isRef)(objRef)) pageObjId = objRef.toString();
                        const kids = this.dict.get("K");
                        if (Array.isArray(kids)) for (const kid of kids){
                            const element = this.parseKid(pageObjId, kid);
                            if (element) this.kids.push(element);
                        }
                        else {
                            const element = this.parseKid(pageObjId, kids);
                            if (element) this.kids.push(element);
                        }
                    }
                    parseKid(pageObjId, kid) {
                        if (Number.isInteger(kid)) {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            return new StructElement({
                                type: StructElementType.PAGE_CONTENT,
                                mcid: kid,
                                pageObjId: pageObjId
                            });
                        }
                        let kidDict = null;
                        if ((0, _primitives.isRef)(kid)) kidDict = this.dict.xref.fetch(kid);
                        else if ((0, _primitives.isDict)(kid)) kidDict = kid;
                        if (!kidDict) return null;
                        const pageRef = kidDict.getRaw("Pg");
                        if ((0, _primitives.isRef)(pageRef)) pageObjId = pageRef.toString();
                        const type = (0, _primitives.isName)(kidDict.get("Type")) ? kidDict.get("Type").name : null;
                        if (type === "MCR") {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            return new StructElement({
                                type: StructElementType.STREAM_CONTENT,
                                refObjId: (0, _primitives.isRef)(kidDict.getRaw("Stm")) ? kidDict.getRaw("Stm").toString() : null,
                                pageObjId: pageObjId,
                                mcid: kidDict.get("MCID")
                            });
                        }
                        if (type === "OBJR") {
                            if (this.tree.pageDict.objId !== pageObjId) return null;
                            return new StructElement({
                                type: StructElementType.OBJECT,
                                refObjId: (0, _primitives.isRef)(kidDict.getRaw("Obj")) ? kidDict.getRaw("Obj").toString() : null,
                                pageObjId: pageObjId
                            });
                        }
                        return new StructElement({
                            type: StructElementType.ELEMENT,
                            dict: kidDict
                        });
                    }
                }
                class StructElement {
                    constructor({ type: type , dict: dict = null , mcid: mcid = null , pageObjId: pageObjId = null , refObjId: refObjId = null  }){
                        this.type = type;
                        this.dict = dict;
                        this.mcid = mcid;
                        this.pageObjId = pageObjId;
                        this.refObjId = refObjId;
                        this.parentNode = null;
                    }
                }
                class StructTreePage {
                    constructor(structTreeRoot, pageDict){
                        this.root = structTreeRoot;
                        this.rootDict = structTreeRoot ? structTreeRoot.dict : null;
                        this.pageDict = pageDict;
                        this.nodes = [];
                    }
                    parse() {
                        if (!this.root || !this.rootDict) return;
                        const parentTree = this.rootDict.get("ParentTree");
                        if (!parentTree) return;
                        const id = this.pageDict.get("StructParents");
                        if (!Number.isInteger(id)) return;
                        const numberTree = new _name_number_tree.NumberTree(parentTree, this.rootDict.xref);
                        const parentArray = numberTree.get(id);
                        if (!Array.isArray(parentArray)) return;
                        const map = new Map();
                        for (const ref of parentArray)if ((0, _primitives.isRef)(ref)) this.addNode(this.rootDict.xref.fetch(ref), map);
                    }
                    addNode(dict, map, level = 0) {
                        if (level > MAX_DEPTH) {
                            (0, _util.warn)("StructTree MAX_DEPTH reached.");
                            return null;
                        }
                        if (map.has(dict)) return map.get(dict);
                        const element = new StructElementNode(this, dict);
                        map.set(dict, element);
                        const parent = dict.get("P");
                        if (!parent || (0, _primitives.isName)(parent.get("Type"), "StructTreeRoot")) {
                            if (!this.addTopLevelNode(dict, element)) map.delete(dict);
                            return element;
                        }
                        const parentNode = this.addNode(parent, map, level + 1);
                        if (!parentNode) return element;
                        let save = false;
                        for (const kid of parentNode.kids)if (kid.type === StructElementType.ELEMENT && kid.dict === dict) {
                            kid.parentNode = element;
                            save = true;
                        }
                        if (!save) map.delete(dict);
                        return element;
                    }
                    addTopLevelNode(dict, element) {
                        const obj = this.rootDict.get("K");
                        if (!obj) return false;
                        if ((0, _primitives.isDict)(obj)) {
                            if (obj.objId !== dict.objId) return false;
                            this.nodes[0] = element;
                            return true;
                        }
                        if (!Array.isArray(obj)) return true;
                        let save = false;
                        for(let i = 0; i < obj.length; i++){
                            const kidRef = obj[i];
                            if (kidRef && kidRef.toString() === dict.objId) {
                                this.nodes[i] = element;
                                save = true;
                            }
                        }
                        return save;
                    }
                    get serializable() {
                        function nodeToSerializable(node, parent, level = 0) {
                            if (level > MAX_DEPTH) {
                                (0, _util.warn)("StructTree too deep to be fully serialized.");
                                return;
                            }
                            const obj = Object.create(null);
                            obj.role = node.role;
                            obj.children = [];
                            parent.children.push(obj);
                            const alt = node.dict.get("Alt");
                            if ((0, _util.isString)(alt)) obj.alt = (0, _util.stringToPDFString)(alt);
                            for (const kid of node.kids){
                                const kidElement = kid.type === StructElementType.ELEMENT ? kid.parentNode : null;
                                if (kidElement) {
                                    nodeToSerializable(kidElement, obj, level + 1);
                                    continue;
                                } else if (kid.type === StructElementType.PAGE_CONTENT || kid.type === StructElementType.STREAM_CONTENT) obj.children.push({
                                    type: "content",
                                    id: `page${kid.pageObjId}_mcid${kid.mcid}`
                                });
                                else if (kid.type === StructElementType.OBJECT) obj.children.push({
                                    type: "object",
                                    id: kid.refObjId
                                });
                            }
                        }
                        const root = Object.create(null);
                        root.children = [];
                        root.role = "Root";
                        for (const child of this.nodes){
                            if (!child) continue;
                            nodeToSerializable(child, root);
                        }
                        return root;
                    }
                }
                exports.StructTreePage = StructTreePage;
            /***/ },
            /* 70 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ObjectLoader = void 0;
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                var _util = __w_pdfjs_require__(2);
                function mayHaveChildren(value) {
                    return value instanceof _primitives.Ref || value instanceof _primitives.Dict || Array.isArray(value) || (0, _primitives.isStream)(value);
                }
                function addChildren(node, nodesToVisit) {
                    if (node instanceof _primitives.Dict) node = node.getRawValues();
                    else if ((0, _primitives.isStream)(node)) node = node.dict.getRawValues();
                    else if (!Array.isArray(node)) return;
                    for (const rawValue of node)if (mayHaveChildren(rawValue)) nodesToVisit.push(rawValue);
                }
                class ObjectLoader {
                    constructor(dict, keys, xref){
                        this.dict = dict;
                        this.keys = keys;
                        this.xref = xref;
                        this.refSet = null;
                    }
                    async load() {
                        if (this.xref.stream.isDataLoaded) return undefined;
                        const { keys: keys , dict: dict  } = this;
                        this.refSet = new _primitives.RefSet();
                        const nodesToVisit = [];
                        for(let i = 0, ii = keys.length; i < ii; i++){
                            const rawValue = dict.getRaw(keys[i]);
                            if (rawValue !== undefined) nodesToVisit.push(rawValue);
                        }
                        return this._walk(nodesToVisit);
                    }
                    async _walk(nodesToVisit) {
                        const nodesToRevisit = [];
                        const pendingRequests = [];
                        while(nodesToVisit.length){
                            let currentNode = nodesToVisit.pop();
                            if (currentNode instanceof _primitives.Ref) {
                                if (this.refSet.has(currentNode)) continue;
                                try {
                                    this.refSet.put(currentNode);
                                    currentNode = this.xref.fetch(currentNode);
                                } catch (ex) {
                                    if (!(ex instanceof _core_utils.MissingDataException)) {
                                        (0, _util.warn)(`ObjectLoader._walk - requesting all data: "${ex}".`);
                                        this.refSet = null;
                                        const { manager: manager  } = this.xref.stream;
                                        return manager.requestAllChunks();
                                    }
                                    nodesToRevisit.push(currentNode);
                                    pendingRequests.push({
                                        begin: ex.begin,
                                        end: ex.end
                                    });
                                }
                            }
                            if ((0, _primitives.isStream)(currentNode)) {
                                const baseStreams = currentNode.getBaseStreams();
                                if (baseStreams) {
                                    let foundMissingData = false;
                                    for (const stream of baseStreams){
                                        if (stream.isDataLoaded) continue;
                                        foundMissingData = true;
                                        pendingRequests.push({
                                            begin: stream.start,
                                            end: stream.end
                                        });
                                    }
                                    if (foundMissingData) nodesToRevisit.push(currentNode);
                                }
                            }
                            addChildren(currentNode, nodesToVisit);
                        }
                        if (pendingRequests.length) {
                            await this.xref.stream.manager.requestRanges(pendingRequests);
                            for (const node of nodesToRevisit)if (node instanceof _primitives.Ref) this.refSet.remove(node);
                            return this._walk(nodesToRevisit);
                        }
                        this.refSet = null;
                        return undefined;
                    }
                }
                exports.ObjectLoader = ObjectLoader;
            /***/ },
            /* 71 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.incrementalUpdate = incrementalUpdate;
                exports.writeDict = writeDict;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _core_utils = __w_pdfjs_require__(9);
                var _xml_parser = __w_pdfjs_require__(68);
                var _crypto = __w_pdfjs_require__(72);
                function writeDict(dict, buffer, transform) {
                    buffer.push("<<");
                    for (const key of dict.getKeys()){
                        buffer.push(` /${(0, _core_utils.escapePDFName)(key)} `);
                        writeValue(dict.getRaw(key), buffer, transform);
                    }
                    buffer.push(">>");
                }
                function writeStream(stream, buffer, transform) {
                    writeDict(stream.dict, buffer, transform);
                    buffer.push(" stream\n");
                    let string = stream.getString();
                    if (transform !== null) string = transform.encryptString(string);
                    buffer.push(string, "\nendstream\n");
                }
                function writeArray(array, buffer, transform) {
                    buffer.push("[");
                    let first = true;
                    for (const val of array){
                        if (!first) buffer.push(" ");
                        else first = false;
                        writeValue(val, buffer, transform);
                    }
                    buffer.push("]");
                }
                function numberToString(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const roundedValue = Math.round(value * 100);
                    if (roundedValue % 100 === 0) return (roundedValue / 100).toString();
                    if (roundedValue % 10 === 0) return value.toFixed(1);
                    return value.toFixed(2);
                }
                function writeValue(value, buffer, transform) {
                    if ((0, _primitives.isName)(value)) buffer.push(`/${(0, _core_utils.escapePDFName)(value.name)}`);
                    else if ((0, _primitives.isRef)(value)) buffer.push(`${value.num} ${value.gen} R`);
                    else if (Array.isArray(value)) writeArray(value, buffer, transform);
                    else if (typeof value === "string") {
                        if (transform !== null) value = transform.encryptString(value);
                        buffer.push(`(${(0, _util.escapeString)(value)})`);
                    } else if (typeof value === "number") buffer.push(numberToString(value));
                    else if ((0, _primitives.isDict)(value)) writeDict(value, buffer, transform);
                    else if ((0, _primitives.isStream)(value)) writeStream(value, buffer, transform);
                }
                function writeInt(number, size, offset, buffer) {
                    for(let i = size + offset - 1; i > offset - 1; i--){
                        buffer[i] = number & 0xff;
                        number >>= 8;
                    }
                    return offset + size;
                }
                function writeString(string, offset, buffer) {
                    for(let i = 0, len = string.length; i < len; i++)buffer[offset + i] = string.charCodeAt(i) & 0xff;
                }
                function computeMD5(filesize, xrefInfo) {
                    const time = Math.floor(Date.now() / 1000);
                    const filename = xrefInfo.filename || "";
                    const md5Buffer = [
                        time.toString(),
                        filename,
                        filesize.toString()
                    ];
                    let md5BufferLen = md5Buffer.reduce((a, str)=>a + str.length, 0);
                    for (const value of Object.values(xrefInfo.info)){
                        md5Buffer.push(value);
                        md5BufferLen += value.length;
                    }
                    const array = new Uint8Array(md5BufferLen);
                    let offset = 0;
                    for (const str of md5Buffer){
                        writeString(str, offset, array);
                        offset += str.length;
                    }
                    return (0, _util.bytesToString)((0, _crypto.calculateMD5)(array));
                }
                function writeXFADataForAcroform(str, newRefs) {
                    const xml = new _xml_parser.SimpleXMLParser({
                        hasAttributes: true
                    }).parseFromString(str);
                    for (const { xfa: xfa  } of newRefs){
                        if (!xfa) continue;
                        const { path: path , value: value  } = xfa;
                        if (!path) continue;
                        const node = xml.documentElement.searchNode((0, _core_utils.parseXFAPath)(path), 0);
                        if (node) node.childNodes = [
                            new _xml_parser.SimpleDOMNode("#text", value)
                        ];
                        else (0, _util.warn)(`Node not found for path: ${path}`);
                    }
                    const buffer = [];
                    xml.documentElement.dump(buffer);
                    return buffer.join("");
                }
                function updateXFA(xfaData, datasetsRef, newRefs, xref) {
                    if (datasetsRef === null || xref === null) return;
                    if (xfaData === null) {
                        const datasets = xref.fetchIfRef(datasetsRef);
                        xfaData = writeXFADataForAcroform(datasets.getString(), newRefs);
                    }
                    const encrypt = xref.encrypt;
                    if (encrypt) {
                        const transform = encrypt.createCipherTransform(datasetsRef.num, datasetsRef.gen);
                        xfaData = transform.encryptString(xfaData);
                    }
                    const data = `${datasetsRef.num} ${datasetsRef.gen} obj\n` + `<< /Type /EmbeddedFile /Length ${xfaData.length}>>\nstream\n` + xfaData + "\nendstream\nendobj\n";
                    newRefs.push({
                        ref: datasetsRef,
                        data: data
                    });
                }
                function incrementalUpdate({ originalData: originalData , xrefInfo: xrefInfo , newRefs: newRefs , xref: xref = null , datasetsRef: datasetsRef = null , xfaData: xfaData = null  }) {
                    updateXFA(xfaData, datasetsRef, newRefs, xref);
                    const newXref = new _primitives.Dict(null);
                    const refForXrefTable = xrefInfo.newRef;
                    let buffer, baseOffset;
                    const lastByte = originalData[originalData.length - 1];
                    if (lastByte === 0x0a || lastByte === 0x0d) {
                        buffer = [];
                        baseOffset = originalData.length;
                    } else {
                        buffer = [
                            "\n"
                        ];
                        baseOffset = originalData.length + 1;
                    }
                    newXref.set("Size", refForXrefTable.num + 1);
                    newXref.set("Prev", xrefInfo.startXRef);
                    newXref.set("Type", _primitives.Name.get("XRef"));
                    if (xrefInfo.rootRef !== null) newXref.set("Root", xrefInfo.rootRef);
                    if (xrefInfo.infoRef !== null) newXref.set("Info", xrefInfo.infoRef);
                    if (xrefInfo.encryptRef !== null) newXref.set("Encrypt", xrefInfo.encryptRef);
                    newRefs.push({
                        ref: refForXrefTable,
                        data: ""
                    });
                    newRefs = newRefs.sort((a, b)=>{
                        return a.ref.num - b.ref.num;
                    });
                    const xrefTableData = [
                        [
                            0,
                            1,
                            0xffff
                        ]
                    ];
                    const indexes = [
                        0,
                        1
                    ];
                    let maxOffset = 0;
                    for (const { ref: ref , data: data  } of newRefs){
                        maxOffset = Math.max(maxOffset, baseOffset);
                        xrefTableData.push([
                            1,
                            baseOffset,
                            Math.min(ref.gen, 0xffff)
                        ]);
                        baseOffset += data.length;
                        indexes.push(ref.num, 1);
                        buffer.push(data);
                    }
                    newXref.set("Index", indexes);
                    if (Array.isArray(xrefInfo.fileIds) && xrefInfo.fileIds.length > 0) {
                        const md5 = computeMD5(baseOffset, xrefInfo);
                        newXref.set("ID", [
                            xrefInfo.fileIds[0],
                            md5
                        ]);
                    }
                    const offsetSize = Math.ceil(Math.log2(maxOffset) / 8);
                    const sizes = [
                        1,
                        offsetSize,
                        2
                    ];
                    const structSize = sizes[0] + sizes[1] + sizes[2];
                    const tableLength = structSize * xrefTableData.length;
                    newXref.set("W", sizes);
                    newXref.set("Length", tableLength);
                    buffer.push(`${refForXrefTable.num} ${refForXrefTable.gen} obj\n`);
                    writeDict(newXref, buffer, null);
                    buffer.push(" stream\n");
                    const bufferLen = buffer.reduce((a, str)=>a + str.length, 0);
                    const footer = `\nendstream\nendobj\nstartxref\n${baseOffset}\n%%EOF\n`;
                    const array = new Uint8Array(originalData.length + bufferLen + tableLength + footer.length);
                    array.set(originalData);
                    let offset = originalData.length;
                    for (const str of buffer){
                        writeString(str, offset, array);
                        offset += str.length;
                    }
                    for (const [type, objOffset, gen] of xrefTableData){
                        offset = writeInt(type, sizes[0], offset, array);
                        offset = writeInt(objOffset, sizes[1], offset, array);
                        offset = writeInt(gen, sizes[2], offset, array);
                    }
                    writeString(footer, offset, array);
                    return array;
                }
            /***/ },
            /* 72 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.calculateSHA384 = calculateSHA384;
                exports.PDF20 = exports.PDF17 = exports.CipherTransformFactory = exports.calculateSHA512 = exports.calculateSHA256 = exports.calculateMD5 = exports.ARCFourCipher = exports.AES256Cipher = exports.AES128Cipher = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _decrypt_stream = __w_pdfjs_require__(73);
                class ARCFourCipher {
                    constructor(key){
                        this.a = 0;
                        this.b = 0;
                        const s = new Uint8Array(256);
                        const keyLength = key.length;
                        for(let i = 0; i < 256; ++i)s[i] = i;
                        for(let i = 0, j = 0; i < 256; ++i){
                            const tmp = s[i];
                            j = j + tmp + key[i % keyLength] & 0xff;
                            s[i] = s[j];
                            s[j] = tmp;
                        }
                        this.s = s;
                    }
                    encryptBlock(data) {
                        let a = this.a, b = this.b;
                        const s = this.s;
                        const n = data.length;
                        const output = new Uint8Array(n);
                        for(let i = 0; i < n; ++i){
                            a = a + 1 & 0xff;
                            const tmp = s[a];
                            b = b + tmp & 0xff;
                            const tmp2 = s[b];
                            s[a] = tmp2;
                            s[b] = tmp;
                            output[i] = data[i] ^ s[tmp + tmp2 & 0xff];
                        }
                        this.a = a;
                        this.b = b;
                        return output;
                    }
                    decryptBlock(data) {
                        return this.encryptBlock(data);
                    }
                    encrypt(data) {
                        return this.encryptBlock(data);
                    }
                }
                exports.ARCFourCipher = ARCFourCipher;
                const calculateMD5 = function calculateMD5Closure() {
                    const r = new Uint8Array([
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        7,
                        12,
                        17,
                        22,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        5,
                        9,
                        14,
                        20,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        4,
                        11,
                        16,
                        23,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21,
                        6,
                        10,
                        15,
                        21
                    ]);
                    const k = new Int32Array([
                        -680876936,
                        -389564586,
                        606105819,
                        -1044525330,
                        -176418897,
                        1200080426,
                        -1473231341,
                        -45705983,
                        1770035416,
                        -1958414417,
                        -42063,
                        -1990404162,
                        1804603682,
                        -40341101,
                        -1502002290,
                        1236535329,
                        -165796510,
                        -1069501632,
                        643717713,
                        -373897302,
                        -701558691,
                        38016083,
                        -660478335,
                        -405537848,
                        568446438,
                        -1019803690,
                        -187363961,
                        1163531501,
                        -1444681467,
                        -51403784,
                        1735328473,
                        -1926607734,
                        -378558,
                        -2022574463,
                        1839030562,
                        -35309556,
                        -1530992060,
                        1272893353,
                        -155497632,
                        -1094730640,
                        681279174,
                        -358537222,
                        -722521979,
                        76029189,
                        -640364487,
                        -421815835,
                        530742520,
                        -995338651,
                        -198630844,
                        1126891415,
                        -1416354905,
                        -57434055,
                        1700485571,
                        -1894986606,
                        -1051523,
                        -2054922799,
                        1873313359,
                        -30611744,
                        -1560198380,
                        1309151649,
                        -145523070,
                        -1120210379,
                        718787259,
                        -343485551
                    ]);
                    function hash(data, offset, length) {
                        let h0 = 1732584193, h1 = -271733879, h2 = -1732584194, h3 = 271733878;
                        const paddedLength = length + 72 & -64;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 8;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = length << 3 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        const w = new Int32Array(16);
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j, i += 4)w[j] = padded[i] | padded[i + 1] << 8 | padded[i + 2] << 16 | padded[i + 3] << 24;
                            let a = h0, b = h1, c = h2, d = h3, f, g;
                            for(j = 0; j < 64; ++j){
                                if (j < 16) {
                                    f = b & c | ~b & d;
                                    g = j;
                                } else if (j < 32) {
                                    f = d & b | ~d & c;
                                    g = 5 * j + 1 & 15;
                                } else if (j < 48) {
                                    f = b ^ c ^ d;
                                    g = 3 * j + 5 & 15;
                                } else {
                                    f = c ^ (b | ~d);
                                    g = 7 * j & 15;
                                }
                                const tmp = d, rotateArg = a + f + k[j] + w[g] | 0, rotate = r[j];
                                d = c;
                                c = b;
                                b = b + (rotateArg << rotate | rotateArg >>> 32 - rotate) | 0;
                                a = tmp;
                            }
                            h0 = h0 + a | 0;
                            h1 = h1 + b | 0;
                            h2 = h2 + c | 0;
                            h3 = h3 + d | 0;
                        }
                        return new Uint8Array([
                            h0 & 0xFF,
                            h0 >> 8 & 0xFF,
                            h0 >> 16 & 0xFF,
                            h0 >>> 24 & 0xFF,
                            h1 & 0xFF,
                            h1 >> 8 & 0xFF,
                            h1 >> 16 & 0xFF,
                            h1 >>> 24 & 0xFF,
                            h2 & 0xFF,
                            h2 >> 8 & 0xFF,
                            h2 >> 16 & 0xFF,
                            h2 >>> 24 & 0xFF,
                            h3 & 0xFF,
                            h3 >> 8 & 0xFF,
                            h3 >> 16 & 0xFF,
                            h3 >>> 24 & 0xFF
                        ]);
                    }
                    return hash;
                }();
                exports.calculateMD5 = calculateMD5;
                class Word64 {
                    constructor(highInteger, lowInteger){
                        this.high = highInteger | 0;
                        this.low = lowInteger | 0;
                    }
                    and(word) {
                        this.high &= word.high;
                        this.low &= word.low;
                    }
                    xor(word) {
                        this.high ^= word.high;
                        this.low ^= word.low;
                    }
                    or(word) {
                        this.high |= word.high;
                        this.low |= word.low;
                    }
                    shiftRight(places) {
                        if (places >= 32) {
                            this.low = this.high >>> places - 32 | 0;
                            this.high = 0;
                        } else {
                            this.low = this.low >>> places | this.high << 32 - places;
                            this.high = this.high >>> places | 0;
                        }
                    }
                    shiftLeft(places) {
                        if (places >= 32) {
                            this.high = this.low << places - 32;
                            this.low = 0;
                        } else {
                            this.high = this.high << places | this.low >>> 32 - places;
                            this.low <<= places;
                        }
                    }
                    rotateRight(places) {
                        let low, high;
                        if (places & 32) {
                            high = this.low;
                            low = this.high;
                        } else {
                            low = this.low;
                            high = this.high;
                        }
                        places &= 31;
                        this.low = low >>> places | high << 32 - places;
                        this.high = high >>> places | low << 32 - places;
                    }
                    not() {
                        this.high = ~this.high;
                        this.low = ~this.low;
                    }
                    add(word) {
                        const lowAdd = (this.low >>> 0) + (word.low >>> 0);
                        let highAdd = (this.high >>> 0) + (word.high >>> 0);
                        if (lowAdd > 0xffffffff) highAdd += 1;
                        this.low = lowAdd | 0;
                        this.high = highAdd | 0;
                    }
                    copyTo(bytes, offset) {
                        bytes[offset] = this.high >>> 24 & 0xff;
                        bytes[offset + 1] = this.high >> 16 & 0xff;
                        bytes[offset + 2] = this.high >> 8 & 0xff;
                        bytes[offset + 3] = this.high & 0xff;
                        bytes[offset + 4] = this.low >>> 24 & 0xff;
                        bytes[offset + 5] = this.low >> 16 & 0xff;
                        bytes[offset + 6] = this.low >> 8 & 0xff;
                        bytes[offset + 7] = this.low & 0xff;
                    }
                    assign(word) {
                        this.high = word.high;
                        this.low = word.low;
                    }
                }
                const calculateSHA256 = function calculateSHA256Closure() {
                    function rotr(x, n) {
                        return x >>> n | x << 32 - n;
                    }
                    function ch(x, y, z) {
                        return x & y ^ ~x & z;
                    }
                    function maj(x, y, z) {
                        return x & y ^ x & z ^ y & z;
                    }
                    function sigma(x) {
                        return rotr(x, 2) ^ rotr(x, 13) ^ rotr(x, 22);
                    }
                    function sigmaPrime(x) {
                        return rotr(x, 6) ^ rotr(x, 11) ^ rotr(x, 25);
                    }
                    function littleSigma(x) {
                        return rotr(x, 7) ^ rotr(x, 18) ^ x >>> 3;
                    }
                    function littleSigmaPrime(x) {
                        return rotr(x, 17) ^ rotr(x, 19) ^ x >>> 10;
                    }
                    const k = [
                        0x428a2f98,
                        0x71374491,
                        0xb5c0fbcf,
                        0xe9b5dba5,
                        0x3956c25b,
                        0x59f111f1,
                        0x923f82a4,
                        0xab1c5ed5,
                        0xd807aa98,
                        0x12835b01,
                        0x243185be,
                        0x550c7dc3,
                        0x72be5d74,
                        0x80deb1fe,
                        0x9bdc06a7,
                        0xc19bf174,
                        0xe49b69c1,
                        0xefbe4786,
                        0x0fc19dc6,
                        0x240ca1cc,
                        0x2de92c6f,
                        0x4a7484aa,
                        0x5cb0a9dc,
                        0x76f988da,
                        0x983e5152,
                        0xa831c66d,
                        0xb00327c8,
                        0xbf597fc7,
                        0xc6e00bf3,
                        0xd5a79147,
                        0x06ca6351,
                        0x14292967,
                        0x27b70a85,
                        0x2e1b2138,
                        0x4d2c6dfc,
                        0x53380d13,
                        0x650a7354,
                        0x766a0abb,
                        0x81c2c92e,
                        0x92722c85,
                        0xa2bfe8a1,
                        0xa81a664b,
                        0xc24b8b70,
                        0xc76c51a3,
                        0xd192e819,
                        0xd6990624,
                        0xf40e3585,
                        0x106aa070,
                        0x19a4c116,
                        0x1e376c08,
                        0x2748774c,
                        0x34b0bcb5,
                        0x391c0cb3,
                        0x4ed8aa4a,
                        0x5b9cca4f,
                        0x682e6ff3,
                        0x748f82ee,
                        0x78a5636f,
                        0x84c87814,
                        0x8cc70208,
                        0x90befffa,
                        0xa4506ceb,
                        0xbef9a3f7,
                        0xc67178f2
                    ];
                    function hash(data, offset, length) {
                        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a, h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
                        const paddedLength = Math.ceil((length + 9) / 64) * 64;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 8;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length << 3 & 0xff;
                        const w = new Uint32Array(64);
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j){
                                w[j] = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                                i += 4;
                            }
                            for(j = 16; j < 64; ++j)w[j] = littleSigmaPrime(w[j - 2]) + w[j - 7] + littleSigma(w[j - 15]) + w[j - 16] | 0;
                            let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, t1, t2;
                            for(j = 0; j < 64; ++j){
                                t1 = h + sigmaPrime(e) + ch(e, f, g) + k[j] + w[j];
                                t2 = sigma(a) + maj(a, b, c);
                                h = g;
                                g = f;
                                f = e;
                                e = d + t1 | 0;
                                d = c;
                                c = b;
                                b = a;
                                a = t1 + t2 | 0;
                            }
                            h0 = h0 + a | 0;
                            h1 = h1 + b | 0;
                            h2 = h2 + c | 0;
                            h3 = h3 + d | 0;
                            h4 = h4 + e | 0;
                            h5 = h5 + f | 0;
                            h6 = h6 + g | 0;
                            h7 = h7 + h | 0;
                        }
                        return new Uint8Array([
                            h0 >> 24 & 0xFF,
                            h0 >> 16 & 0xFF,
                            h0 >> 8 & 0xFF,
                            h0 & 0xFF,
                            h1 >> 24 & 0xFF,
                            h1 >> 16 & 0xFF,
                            h1 >> 8 & 0xFF,
                            h1 & 0xFF,
                            h2 >> 24 & 0xFF,
                            h2 >> 16 & 0xFF,
                            h2 >> 8 & 0xFF,
                            h2 & 0xFF,
                            h3 >> 24 & 0xFF,
                            h3 >> 16 & 0xFF,
                            h3 >> 8 & 0xFF,
                            h3 & 0xFF,
                            h4 >> 24 & 0xFF,
                            h4 >> 16 & 0xFF,
                            h4 >> 8 & 0xFF,
                            h4 & 0xFF,
                            h5 >> 24 & 0xFF,
                            h5 >> 16 & 0xFF,
                            h5 >> 8 & 0xFF,
                            h5 & 0xFF,
                            h6 >> 24 & 0xFF,
                            h6 >> 16 & 0xFF,
                            h6 >> 8 & 0xFF,
                            h6 & 0xFF,
                            h7 >> 24 & 0xFF,
                            h7 >> 16 & 0xFF,
                            h7 >> 8 & 0xFF,
                            h7 & 0xFF
                        ]);
                    }
                    return hash;
                }();
                exports.calculateSHA256 = calculateSHA256;
                const calculateSHA512 = function calculateSHA512Closure() {
                    function ch(result, x, y, z, tmp) {
                        result.assign(x);
                        result.and(y);
                        tmp.assign(x);
                        tmp.not();
                        tmp.and(z);
                        result.xor(tmp);
                    }
                    function maj(result, x, y, z, tmp) {
                        result.assign(x);
                        result.and(y);
                        tmp.assign(x);
                        tmp.and(z);
                        result.xor(tmp);
                        tmp.assign(y);
                        tmp.and(z);
                        result.xor(tmp);
                    }
                    function sigma(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(28);
                        tmp.assign(x);
                        tmp.rotateRight(34);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.rotateRight(39);
                        result.xor(tmp);
                    }
                    function sigmaPrime(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(14);
                        tmp.assign(x);
                        tmp.rotateRight(18);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.rotateRight(41);
                        result.xor(tmp);
                    }
                    function littleSigma(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(1);
                        tmp.assign(x);
                        tmp.rotateRight(8);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.shiftRight(7);
                        result.xor(tmp);
                    }
                    function littleSigmaPrime(result, x, tmp) {
                        result.assign(x);
                        result.rotateRight(19);
                        tmp.assign(x);
                        tmp.rotateRight(61);
                        result.xor(tmp);
                        tmp.assign(x);
                        tmp.shiftRight(6);
                        result.xor(tmp);
                    }
                    const k = [
                        new Word64(0x428a2f98, 0xd728ae22),
                        new Word64(0x71374491, 0x23ef65cd),
                        new Word64(0xb5c0fbcf, 0xec4d3b2f),
                        new Word64(0xe9b5dba5, 0x8189dbbc),
                        new Word64(0x3956c25b, 0xf348b538),
                        new Word64(0x59f111f1, 0xb605d019),
                        new Word64(0x923f82a4, 0xaf194f9b),
                        new Word64(0xab1c5ed5, 0xda6d8118),
                        new Word64(0xd807aa98, 0xa3030242),
                        new Word64(0x12835b01, 0x45706fbe),
                        new Word64(0x243185be, 0x4ee4b28c),
                        new Word64(0x550c7dc3, 0xd5ffb4e2),
                        new Word64(0x72be5d74, 0xf27b896f),
                        new Word64(0x80deb1fe, 0x3b1696b1),
                        new Word64(0x9bdc06a7, 0x25c71235),
                        new Word64(0xc19bf174, 0xcf692694),
                        new Word64(0xe49b69c1, 0x9ef14ad2),
                        new Word64(0xefbe4786, 0x384f25e3),
                        new Word64(0x0fc19dc6, 0x8b8cd5b5),
                        new Word64(0x240ca1cc, 0x77ac9c65),
                        new Word64(0x2de92c6f, 0x592b0275),
                        new Word64(0x4a7484aa, 0x6ea6e483),
                        new Word64(0x5cb0a9dc, 0xbd41fbd4),
                        new Word64(0x76f988da, 0x831153b5),
                        new Word64(0x983e5152, 0xee66dfab),
                        new Word64(0xa831c66d, 0x2db43210),
                        new Word64(0xb00327c8, 0x98fb213f),
                        new Word64(0xbf597fc7, 0xbeef0ee4),
                        new Word64(0xc6e00bf3, 0x3da88fc2),
                        new Word64(0xd5a79147, 0x930aa725),
                        new Word64(0x06ca6351, 0xe003826f),
                        new Word64(0x14292967, 0x0a0e6e70),
                        new Word64(0x27b70a85, 0x46d22ffc),
                        new Word64(0x2e1b2138, 0x5c26c926),
                        new Word64(0x4d2c6dfc, 0x5ac42aed),
                        new Word64(0x53380d13, 0x9d95b3df),
                        new Word64(0x650a7354, 0x8baf63de),
                        new Word64(0x766a0abb, 0x3c77b2a8),
                        new Word64(0x81c2c92e, 0x47edaee6),
                        new Word64(0x92722c85, 0x1482353b),
                        new Word64(0xa2bfe8a1, 0x4cf10364),
                        new Word64(0xa81a664b, 0xbc423001),
                        new Word64(0xc24b8b70, 0xd0f89791),
                        new Word64(0xc76c51a3, 0x0654be30),
                        new Word64(0xd192e819, 0xd6ef5218),
                        new Word64(0xd6990624, 0x5565a910),
                        new Word64(0xf40e3585, 0x5771202a),
                        new Word64(0x106aa070, 0x32bbd1b8),
                        new Word64(0x19a4c116, 0xb8d2d0c8),
                        new Word64(0x1e376c08, 0x5141ab53),
                        new Word64(0x2748774c, 0xdf8eeb99),
                        new Word64(0x34b0bcb5, 0xe19b48a8),
                        new Word64(0x391c0cb3, 0xc5c95a63),
                        new Word64(0x4ed8aa4a, 0xe3418acb),
                        new Word64(0x5b9cca4f, 0x7763e373),
                        new Word64(0x682e6ff3, 0xd6b2b8a3),
                        new Word64(0x748f82ee, 0x5defb2fc),
                        new Word64(0x78a5636f, 0x43172f60),
                        new Word64(0x84c87814, 0xa1f0ab72),
                        new Word64(0x8cc70208, 0x1a6439ec),
                        new Word64(0x90befffa, 0x23631e28),
                        new Word64(0xa4506ceb, 0xde82bde9),
                        new Word64(0xbef9a3f7, 0xb2c67915),
                        new Word64(0xc67178f2, 0xe372532b),
                        new Word64(0xca273ece, 0xea26619c),
                        new Word64(0xd186b8c7, 0x21c0c207),
                        new Word64(0xeada7dd6, 0xcde0eb1e),
                        new Word64(0xf57d4f7f, 0xee6ed178),
                        new Word64(0x06f067aa, 0x72176fba),
                        new Word64(0x0a637dc5, 0xa2c898a6),
                        new Word64(0x113f9804, 0xbef90dae),
                        new Word64(0x1b710b35, 0x131c471b),
                        new Word64(0x28db77f5, 0x23047d84),
                        new Word64(0x32caab7b, 0x40c72493),
                        new Word64(0x3c9ebe0a, 0x15c9bebc),
                        new Word64(0x431d67c4, 0x9c100d4c),
                        new Word64(0x4cc5d4be, 0xcb3e42b6),
                        new Word64(0x597f299c, 0xfc657e2a),
                        new Word64(0x5fcb6fab, 0x3ad6faec),
                        new Word64(0x6c44198c, 0x4a475817)
                    ];
                    function hash(data, offset, length, mode384 = false) {
                        let h0, h1, h2, h3, h4, h5, h6, h7;
                        if (!mode384) {
                            h0 = new Word64(0x6a09e667, 0xf3bcc908);
                            h1 = new Word64(0xbb67ae85, 0x84caa73b);
                            h2 = new Word64(0x3c6ef372, 0xfe94f82b);
                            h3 = new Word64(0xa54ff53a, 0x5f1d36f1);
                            h4 = new Word64(0x510e527f, 0xade682d1);
                            h5 = new Word64(0x9b05688c, 0x2b3e6c1f);
                            h6 = new Word64(0x1f83d9ab, 0xfb41bd6b);
                            h7 = new Word64(0x5be0cd19, 0x137e2179);
                        } else {
                            h0 = new Word64(0xcbbb9d5d, 0xc1059ed8);
                            h1 = new Word64(0x629a292a, 0x367cd507);
                            h2 = new Word64(0x9159015a, 0x3070dd17);
                            h3 = new Word64(0x152fecd8, 0xf70e5939);
                            h4 = new Word64(0x67332667, 0xffc00b31);
                            h5 = new Word64(0x8eb44a87, 0x68581511);
                            h6 = new Word64(0xdb0c2e0d, 0x64f98fa7);
                            h7 = new Word64(0x47b5481d, 0xbefa4fa4);
                        }
                        const paddedLength = Math.ceil((length + 17) / 128) * 128;
                        const padded = new Uint8Array(paddedLength);
                        let i, j;
                        for(i = 0; i < length; ++i)padded[i] = data[offset++];
                        padded[i++] = 0x80;
                        const n = paddedLength - 16;
                        while(i < n)padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = 0;
                        padded[i++] = length >>> 29 & 0xff;
                        padded[i++] = length >> 21 & 0xff;
                        padded[i++] = length >> 13 & 0xff;
                        padded[i++] = length >> 5 & 0xff;
                        padded[i++] = length << 3 & 0xff;
                        const w = new Array(80);
                        for(i = 0; i < 80; i++)w[i] = new Word64(0, 0);
                        let a = new Word64(0, 0), b = new Word64(0, 0), c = new Word64(0, 0);
                        let d = new Word64(0, 0), e = new Word64(0, 0), f = new Word64(0, 0);
                        let g = new Word64(0, 0), h = new Word64(0, 0);
                        const t1 = new Word64(0, 0), t2 = new Word64(0, 0);
                        const tmp1 = new Word64(0, 0), tmp2 = new Word64(0, 0);
                        let tmp3;
                        for(i = 0; i < paddedLength;){
                            for(j = 0; j < 16; ++j){
                                w[j].high = padded[i] << 24 | padded[i + 1] << 16 | padded[i + 2] << 8 | padded[i + 3];
                                w[j].low = padded[i + 4] << 24 | padded[i + 5] << 16 | padded[i + 6] << 8 | padded[i + 7];
                                i += 8;
                            }
                            for(j = 16; j < 80; ++j){
                                tmp3 = w[j];
                                littleSigmaPrime(tmp3, w[j - 2], tmp2);
                                tmp3.add(w[j - 7]);
                                littleSigma(tmp1, w[j - 15], tmp2);
                                tmp3.add(tmp1);
                                tmp3.add(w[j - 16]);
                            }
                            a.assign(h0);
                            b.assign(h1);
                            c.assign(h2);
                            d.assign(h3);
                            e.assign(h4);
                            f.assign(h5);
                            g.assign(h6);
                            h.assign(h7);
                            for(j = 0; j < 80; ++j){
                                t1.assign(h);
                                sigmaPrime(tmp1, e, tmp2);
                                t1.add(tmp1);
                                ch(tmp1, e, f, g, tmp2);
                                t1.add(tmp1);
                                t1.add(k[j]);
                                t1.add(w[j]);
                                sigma(t2, a, tmp2);
                                maj(tmp1, a, b, c, tmp2);
                                t2.add(tmp1);
                                tmp3 = h;
                                h = g;
                                g = f;
                                f = e;
                                d.add(t1);
                                e = d;
                                d = c;
                                c = b;
                                b = a;
                                tmp3.assign(t1);
                                tmp3.add(t2);
                                a = tmp3;
                            }
                            h0.add(a);
                            h1.add(b);
                            h2.add(c);
                            h3.add(d);
                            h4.add(e);
                            h5.add(f);
                            h6.add(g);
                            h7.add(h);
                        }
                        let result;
                        if (!mode384) {
                            result = new Uint8Array(64);
                            h0.copyTo(result, 0);
                            h1.copyTo(result, 8);
                            h2.copyTo(result, 16);
                            h3.copyTo(result, 24);
                            h4.copyTo(result, 32);
                            h5.copyTo(result, 40);
                            h6.copyTo(result, 48);
                            h7.copyTo(result, 56);
                        } else {
                            result = new Uint8Array(48);
                            h0.copyTo(result, 0);
                            h1.copyTo(result, 8);
                            h2.copyTo(result, 16);
                            h3.copyTo(result, 24);
                            h4.copyTo(result, 32);
                            h5.copyTo(result, 40);
                        }
                        return result;
                    }
                    return hash;
                }();
                exports.calculateSHA512 = calculateSHA512;
                function calculateSHA384(data, offset, length) {
                    return calculateSHA512(data, offset, length, true);
                }
                class NullCipher {
                    decryptBlock(data) {
                        return data;
                    }
                    encrypt(data) {
                        return data;
                    }
                }
                class AESBaseCipher {
                    constructor(){
                        if (this.constructor === AESBaseCipher) (0, _util.unreachable)("Cannot initialize AESBaseCipher.");
                        this._s = new Uint8Array([
                            0x63,
                            0x7c,
                            0x77,
                            0x7b,
                            0xf2,
                            0x6b,
                            0x6f,
                            0xc5,
                            0x30,
                            0x01,
                            0x67,
                            0x2b,
                            0xfe,
                            0xd7,
                            0xab,
                            0x76,
                            0xca,
                            0x82,
                            0xc9,
                            0x7d,
                            0xfa,
                            0x59,
                            0x47,
                            0xf0,
                            0xad,
                            0xd4,
                            0xa2,
                            0xaf,
                            0x9c,
                            0xa4,
                            0x72,
                            0xc0,
                            0xb7,
                            0xfd,
                            0x93,
                            0x26,
                            0x36,
                            0x3f,
                            0xf7,
                            0xcc,
                            0x34,
                            0xa5,
                            0xe5,
                            0xf1,
                            0x71,
                            0xd8,
                            0x31,
                            0x15,
                            0x04,
                            0xc7,
                            0x23,
                            0xc3,
                            0x18,
                            0x96,
                            0x05,
                            0x9a,
                            0x07,
                            0x12,
                            0x80,
                            0xe2,
                            0xeb,
                            0x27,
                            0xb2,
                            0x75,
                            0x09,
                            0x83,
                            0x2c,
                            0x1a,
                            0x1b,
                            0x6e,
                            0x5a,
                            0xa0,
                            0x52,
                            0x3b,
                            0xd6,
                            0xb3,
                            0x29,
                            0xe3,
                            0x2f,
                            0x84,
                            0x53,
                            0xd1,
                            0x00,
                            0xed,
                            0x20,
                            0xfc,
                            0xb1,
                            0x5b,
                            0x6a,
                            0xcb,
                            0xbe,
                            0x39,
                            0x4a,
                            0x4c,
                            0x58,
                            0xcf,
                            0xd0,
                            0xef,
                            0xaa,
                            0xfb,
                            0x43,
                            0x4d,
                            0x33,
                            0x85,
                            0x45,
                            0xf9,
                            0x02,
                            0x7f,
                            0x50,
                            0x3c,
                            0x9f,
                            0xa8,
                            0x51,
                            0xa3,
                            0x40,
                            0x8f,
                            0x92,
                            0x9d,
                            0x38,
                            0xf5,
                            0xbc,
                            0xb6,
                            0xda,
                            0x21,
                            0x10,
                            0xff,
                            0xf3,
                            0xd2,
                            0xcd,
                            0x0c,
                            0x13,
                            0xec,
                            0x5f,
                            0x97,
                            0x44,
                            0x17,
                            0xc4,
                            0xa7,
                            0x7e,
                            0x3d,
                            0x64,
                            0x5d,
                            0x19,
                            0x73,
                            0x60,
                            0x81,
                            0x4f,
                            0xdc,
                            0x22,
                            0x2a,
                            0x90,
                            0x88,
                            0x46,
                            0xee,
                            0xb8,
                            0x14,
                            0xde,
                            0x5e,
                            0x0b,
                            0xdb,
                            0xe0,
                            0x32,
                            0x3a,
                            0x0a,
                            0x49,
                            0x06,
                            0x24,
                            0x5c,
                            0xc2,
                            0xd3,
                            0xac,
                            0x62,
                            0x91,
                            0x95,
                            0xe4,
                            0x79,
                            0xe7,
                            0xc8,
                            0x37,
                            0x6d,
                            0x8d,
                            0xd5,
                            0x4e,
                            0xa9,
                            0x6c,
                            0x56,
                            0xf4,
                            0xea,
                            0x65,
                            0x7a,
                            0xae,
                            0x08,
                            0xba,
                            0x78,
                            0x25,
                            0x2e,
                            0x1c,
                            0xa6,
                            0xb4,
                            0xc6,
                            0xe8,
                            0xdd,
                            0x74,
                            0x1f,
                            0x4b,
                            0xbd,
                            0x8b,
                            0x8a,
                            0x70,
                            0x3e,
                            0xb5,
                            0x66,
                            0x48,
                            0x03,
                            0xf6,
                            0x0e,
                            0x61,
                            0x35,
                            0x57,
                            0xb9,
                            0x86,
                            0xc1,
                            0x1d,
                            0x9e,
                            0xe1,
                            0xf8,
                            0x98,
                            0x11,
                            0x69,
                            0xd9,
                            0x8e,
                            0x94,
                            0x9b,
                            0x1e,
                            0x87,
                            0xe9,
                            0xce,
                            0x55,
                            0x28,
                            0xdf,
                            0x8c,
                            0xa1,
                            0x89,
                            0x0d,
                            0xbf,
                            0xe6,
                            0x42,
                            0x68,
                            0x41,
                            0x99,
                            0x2d,
                            0x0f,
                            0xb0,
                            0x54,
                            0xbb,
                            0x16
                        ]);
                        this._inv_s = new Uint8Array([
                            0x52,
                            0x09,
                            0x6a,
                            0xd5,
                            0x30,
                            0x36,
                            0xa5,
                            0x38,
                            0xbf,
                            0x40,
                            0xa3,
                            0x9e,
                            0x81,
                            0xf3,
                            0xd7,
                            0xfb,
                            0x7c,
                            0xe3,
                            0x39,
                            0x82,
                            0x9b,
                            0x2f,
                            0xff,
                            0x87,
                            0x34,
                            0x8e,
                            0x43,
                            0x44,
                            0xc4,
                            0xde,
                            0xe9,
                            0xcb,
                            0x54,
                            0x7b,
                            0x94,
                            0x32,
                            0xa6,
                            0xc2,
                            0x23,
                            0x3d,
                            0xee,
                            0x4c,
                            0x95,
                            0x0b,
                            0x42,
                            0xfa,
                            0xc3,
                            0x4e,
                            0x08,
                            0x2e,
                            0xa1,
                            0x66,
                            0x28,
                            0xd9,
                            0x24,
                            0xb2,
                            0x76,
                            0x5b,
                            0xa2,
                            0x49,
                            0x6d,
                            0x8b,
                            0xd1,
                            0x25,
                            0x72,
                            0xf8,
                            0xf6,
                            0x64,
                            0x86,
                            0x68,
                            0x98,
                            0x16,
                            0xd4,
                            0xa4,
                            0x5c,
                            0xcc,
                            0x5d,
                            0x65,
                            0xb6,
                            0x92,
                            0x6c,
                            0x70,
                            0x48,
                            0x50,
                            0xfd,
                            0xed,
                            0xb9,
                            0xda,
                            0x5e,
                            0x15,
                            0x46,
                            0x57,
                            0xa7,
                            0x8d,
                            0x9d,
                            0x84,
                            0x90,
                            0xd8,
                            0xab,
                            0x00,
                            0x8c,
                            0xbc,
                            0xd3,
                            0x0a,
                            0xf7,
                            0xe4,
                            0x58,
                            0x05,
                            0xb8,
                            0xb3,
                            0x45,
                            0x06,
                            0xd0,
                            0x2c,
                            0x1e,
                            0x8f,
                            0xca,
                            0x3f,
                            0x0f,
                            0x02,
                            0xc1,
                            0xaf,
                            0xbd,
                            0x03,
                            0x01,
                            0x13,
                            0x8a,
                            0x6b,
                            0x3a,
                            0x91,
                            0x11,
                            0x41,
                            0x4f,
                            0x67,
                            0xdc,
                            0xea,
                            0x97,
                            0xf2,
                            0xcf,
                            0xce,
                            0xf0,
                            0xb4,
                            0xe6,
                            0x73,
                            0x96,
                            0xac,
                            0x74,
                            0x22,
                            0xe7,
                            0xad,
                            0x35,
                            0x85,
                            0xe2,
                            0xf9,
                            0x37,
                            0xe8,
                            0x1c,
                            0x75,
                            0xdf,
                            0x6e,
                            0x47,
                            0xf1,
                            0x1a,
                            0x71,
                            0x1d,
                            0x29,
                            0xc5,
                            0x89,
                            0x6f,
                            0xb7,
                            0x62,
                            0x0e,
                            0xaa,
                            0x18,
                            0xbe,
                            0x1b,
                            0xfc,
                            0x56,
                            0x3e,
                            0x4b,
                            0xc6,
                            0xd2,
                            0x79,
                            0x20,
                            0x9a,
                            0xdb,
                            0xc0,
                            0xfe,
                            0x78,
                            0xcd,
                            0x5a,
                            0xf4,
                            0x1f,
                            0xdd,
                            0xa8,
                            0x33,
                            0x88,
                            0x07,
                            0xc7,
                            0x31,
                            0xb1,
                            0x12,
                            0x10,
                            0x59,
                            0x27,
                            0x80,
                            0xec,
                            0x5f,
                            0x60,
                            0x51,
                            0x7f,
                            0xa9,
                            0x19,
                            0xb5,
                            0x4a,
                            0x0d,
                            0x2d,
                            0xe5,
                            0x7a,
                            0x9f,
                            0x93,
                            0xc9,
                            0x9c,
                            0xef,
                            0xa0,
                            0xe0,
                            0x3b,
                            0x4d,
                            0xae,
                            0x2a,
                            0xf5,
                            0xb0,
                            0xc8,
                            0xeb,
                            0xbb,
                            0x3c,
                            0x83,
                            0x53,
                            0x99,
                            0x61,
                            0x17,
                            0x2b,
                            0x04,
                            0x7e,
                            0xba,
                            0x77,
                            0xd6,
                            0x26,
                            0xe1,
                            0x69,
                            0x14,
                            0x63,
                            0x55,
                            0x21,
                            0x0c,
                            0x7d
                        ]);
                        this._mix = new Uint32Array([
                            0x00000000,
                            0x0e090d0b,
                            0x1c121a16,
                            0x121b171d,
                            0x3824342c,
                            0x362d3927,
                            0x24362e3a,
                            0x2a3f2331,
                            0x70486858,
                            0x7e416553,
                            0x6c5a724e,
                            0x62537f45,
                            0x486c5c74,
                            0x4665517f,
                            0x547e4662,
                            0x5a774b69,
                            0xe090d0b0,
                            0xee99ddbb,
                            0xfc82caa6,
                            0xf28bc7ad,
                            0xd8b4e49c,
                            0xd6bde997,
                            0xc4a6fe8a,
                            0xcaaff381,
                            0x90d8b8e8,
                            0x9ed1b5e3,
                            0x8ccaa2fe,
                            0x82c3aff5,
                            0xa8fc8cc4,
                            0xa6f581cf,
                            0xb4ee96d2,
                            0xbae79bd9,
                            0xdb3bbb7b,
                            0xd532b670,
                            0xc729a16d,
                            0xc920ac66,
                            0xe31f8f57,
                            0xed16825c,
                            0xff0d9541,
                            0xf104984a,
                            0xab73d323,
                            0xa57ade28,
                            0xb761c935,
                            0xb968c43e,
                            0x9357e70f,
                            0x9d5eea04,
                            0x8f45fd19,
                            0x814cf012,
                            0x3bab6bcb,
                            0x35a266c0,
                            0x27b971dd,
                            0x29b07cd6,
                            0x038f5fe7,
                            0x0d8652ec,
                            0x1f9d45f1,
                            0x119448fa,
                            0x4be30393,
                            0x45ea0e98,
                            0x57f11985,
                            0x59f8148e,
                            0x73c737bf,
                            0x7dce3ab4,
                            0x6fd52da9,
                            0x61dc20a2,
                            0xad766df6,
                            0xa37f60fd,
                            0xb16477e0,
                            0xbf6d7aeb,
                            0x955259da,
                            0x9b5b54d1,
                            0x894043cc,
                            0x87494ec7,
                            0xdd3e05ae,
                            0xd33708a5,
                            0xc12c1fb8,
                            0xcf2512b3,
                            0xe51a3182,
                            0xeb133c89,
                            0xf9082b94,
                            0xf701269f,
                            0x4de6bd46,
                            0x43efb04d,
                            0x51f4a750,
                            0x5ffdaa5b,
                            0x75c2896a,
                            0x7bcb8461,
                            0x69d0937c,
                            0x67d99e77,
                            0x3daed51e,
                            0x33a7d815,
                            0x21bccf08,
                            0x2fb5c203,
                            0x058ae132,
                            0x0b83ec39,
                            0x1998fb24,
                            0x1791f62f,
                            0x764dd68d,
                            0x7844db86,
                            0x6a5fcc9b,
                            0x6456c190,
                            0x4e69e2a1,
                            0x4060efaa,
                            0x527bf8b7,
                            0x5c72f5bc,
                            0x0605bed5,
                            0x080cb3de,
                            0x1a17a4c3,
                            0x141ea9c8,
                            0x3e218af9,
                            0x302887f2,
                            0x223390ef,
                            0x2c3a9de4,
                            0x96dd063d,
                            0x98d40b36,
                            0x8acf1c2b,
                            0x84c61120,
                            0xaef93211,
                            0xa0f03f1a,
                            0xb2eb2807,
                            0xbce2250c,
                            0xe6956e65,
                            0xe89c636e,
                            0xfa877473,
                            0xf48e7978,
                            0xdeb15a49,
                            0xd0b85742,
                            0xc2a3405f,
                            0xccaa4d54,
                            0x41ecdaf7,
                            0x4fe5d7fc,
                            0x5dfec0e1,
                            0x53f7cdea,
                            0x79c8eedb,
                            0x77c1e3d0,
                            0x65daf4cd,
                            0x6bd3f9c6,
                            0x31a4b2af,
                            0x3fadbfa4,
                            0x2db6a8b9,
                            0x23bfa5b2,
                            0x09808683,
                            0x07898b88,
                            0x15929c95,
                            0x1b9b919e,
                            0xa17c0a47,
                            0xaf75074c,
                            0xbd6e1051,
                            0xb3671d5a,
                            0x99583e6b,
                            0x97513360,
                            0x854a247d,
                            0x8b432976,
                            0xd134621f,
                            0xdf3d6f14,
                            0xcd267809,
                            0xc32f7502,
                            0xe9105633,
                            0xe7195b38,
                            0xf5024c25,
                            0xfb0b412e,
                            0x9ad7618c,
                            0x94de6c87,
                            0x86c57b9a,
                            0x88cc7691,
                            0xa2f355a0,
                            0xacfa58ab,
                            0xbee14fb6,
                            0xb0e842bd,
                            0xea9f09d4,
                            0xe49604df,
                            0xf68d13c2,
                            0xf8841ec9,
                            0xd2bb3df8,
                            0xdcb230f3,
                            0xcea927ee,
                            0xc0a02ae5,
                            0x7a47b13c,
                            0x744ebc37,
                            0x6655ab2a,
                            0x685ca621,
                            0x42638510,
                            0x4c6a881b,
                            0x5e719f06,
                            0x5078920d,
                            0x0a0fd964,
                            0x0406d46f,
                            0x161dc372,
                            0x1814ce79,
                            0x322bed48,
                            0x3c22e043,
                            0x2e39f75e,
                            0x2030fa55,
                            0xec9ab701,
                            0xe293ba0a,
                            0xf088ad17,
                            0xfe81a01c,
                            0xd4be832d,
                            0xdab78e26,
                            0xc8ac993b,
                            0xc6a59430,
                            0x9cd2df59,
                            0x92dbd252,
                            0x80c0c54f,
                            0x8ec9c844,
                            0xa4f6eb75,
                            0xaaffe67e,
                            0xb8e4f163,
                            0xb6edfc68,
                            0x0c0a67b1,
                            0x02036aba,
                            0x10187da7,
                            0x1e1170ac,
                            0x342e539d,
                            0x3a275e96,
                            0x283c498b,
                            0x26354480,
                            0x7c420fe9,
                            0x724b02e2,
                            0x605015ff,
                            0x6e5918f4,
                            0x44663bc5,
                            0x4a6f36ce,
                            0x587421d3,
                            0x567d2cd8,
                            0x37a10c7a,
                            0x39a80171,
                            0x2bb3166c,
                            0x25ba1b67,
                            0x0f853856,
                            0x018c355d,
                            0x13972240,
                            0x1d9e2f4b,
                            0x47e96422,
                            0x49e06929,
                            0x5bfb7e34,
                            0x55f2733f,
                            0x7fcd500e,
                            0x71c45d05,
                            0x63df4a18,
                            0x6dd64713,
                            0xd731dcca,
                            0xd938d1c1,
                            0xcb23c6dc,
                            0xc52acbd7,
                            0xef15e8e6,
                            0xe11ce5ed,
                            0xf307f2f0,
                            0xfd0efffb,
                            0xa779b492,
                            0xa970b999,
                            0xbb6bae84,
                            0xb562a38f,
                            0x9f5d80be,
                            0x91548db5,
                            0x834f9aa8,
                            0x8d4697a3
                        ]);
                        this._mixCol = new Uint8Array(256);
                        for(let i = 0; i < 256; i++)if (i < 128) this._mixCol[i] = i << 1;
                        else this._mixCol[i] = i << 1 ^ 0x1b;
                        this.buffer = new Uint8Array(16);
                        this.bufferPosition = 0;
                    }
                    _expandKey(cipherKey) {
                        (0, _util.unreachable)("Cannot call `_expandKey` on the base class");
                    }
                    _decrypt(input, key) {
                        let t, u, v;
                        const state = new Uint8Array(16);
                        state.set(input);
                        for(let j = 0, k = this._keySize; j < 16; ++j, ++k)state[j] ^= key[k];
                        for(let i = this._cyclesOfRepetition - 1; i >= 1; --i){
                            t = state[13];
                            state[13] = state[9];
                            state[9] = state[5];
                            state[5] = state[1];
                            state[1] = t;
                            t = state[14];
                            u = state[10];
                            state[14] = state[6];
                            state[10] = state[2];
                            state[6] = t;
                            state[2] = u;
                            t = state[15];
                            u = state[11];
                            v = state[7];
                            state[15] = state[3];
                            state[11] = t;
                            state[7] = u;
                            state[3] = v;
                            for(let j = 0; j < 16; ++j)state[j] = this._inv_s[state[j]];
                            for(let j = 0, k = i * 16; j < 16; ++j, ++k)state[j] ^= key[k];
                            for(let j = 0; j < 16; j += 4){
                                const s0 = this._mix[state[j]];
                                const s1 = this._mix[state[j + 1]];
                                const s2 = this._mix[state[j + 2]];
                                const s3 = this._mix[state[j + 3]];
                                t = s0 ^ s1 >>> 8 ^ s1 << 24 ^ s2 >>> 16 ^ s2 << 16 ^ s3 >>> 24 ^ s3 << 8;
                                state[j] = t >>> 24 & 0xff;
                                state[j + 1] = t >> 16 & 0xff;
                                state[j + 2] = t >> 8 & 0xff;
                                state[j + 3] = t & 0xff;
                            }
                        }
                        t = state[13];
                        state[13] = state[9];
                        state[9] = state[5];
                        state[5] = state[1];
                        state[1] = t;
                        t = state[14];
                        u = state[10];
                        state[14] = state[6];
                        state[10] = state[2];
                        state[6] = t;
                        state[2] = u;
                        t = state[15];
                        u = state[11];
                        v = state[7];
                        state[15] = state[3];
                        state[11] = t;
                        state[7] = u;
                        state[3] = v;
                        for(let j = 0; j < 16; ++j){
                            state[j] = this._inv_s[state[j]];
                            state[j] ^= key[j];
                        }
                        return state;
                    }
                    _encrypt(input, key) {
                        const s = this._s;
                        let t, u, v;
                        const state = new Uint8Array(16);
                        state.set(input);
                        for(let j = 0; j < 16; ++j)state[j] ^= key[j];
                        for(let i = 1; i < this._cyclesOfRepetition; i++){
                            for(let j = 0; j < 16; ++j)state[j] = s[state[j]];
                            v = state[1];
                            state[1] = state[5];
                            state[5] = state[9];
                            state[9] = state[13];
                            state[13] = v;
                            v = state[2];
                            u = state[6];
                            state[2] = state[10];
                            state[6] = state[14];
                            state[10] = v;
                            state[14] = u;
                            v = state[3];
                            u = state[7];
                            t = state[11];
                            state[3] = state[15];
                            state[7] = v;
                            state[11] = u;
                            state[15] = t;
                            for(let j = 0; j < 16; j += 4){
                                const s0 = state[j + 0];
                                const s1 = state[j + 1];
                                const s2 = state[j + 2];
                                const s3 = state[j + 3];
                                t = s0 ^ s1 ^ s2 ^ s3;
                                state[j + 0] ^= t ^ this._mixCol[s0 ^ s1];
                                state[j + 1] ^= t ^ this._mixCol[s1 ^ s2];
                                state[j + 2] ^= t ^ this._mixCol[s2 ^ s3];
                                state[j + 3] ^= t ^ this._mixCol[s3 ^ s0];
                            }
                            for(let j = 0, k = i * 16; j < 16; ++j, ++k)state[j] ^= key[k];
                        }
                        for(let j = 0; j < 16; ++j)state[j] = s[state[j]];
                        v = state[1];
                        state[1] = state[5];
                        state[5] = state[9];
                        state[9] = state[13];
                        state[13] = v;
                        v = state[2];
                        u = state[6];
                        state[2] = state[10];
                        state[6] = state[14];
                        state[10] = v;
                        state[14] = u;
                        v = state[3];
                        u = state[7];
                        t = state[11];
                        state[3] = state[15];
                        state[7] = v;
                        state[11] = u;
                        state[15] = t;
                        for(let j = 0, k = this._keySize; j < 16; ++j, ++k)state[j] ^= key[k];
                        return state;
                    }
                    _decryptBlock2(data, finalize) {
                        const sourceLength = data.length;
                        let buffer = this.buffer, bufferLength = this.bufferPosition;
                        const result = [];
                        let iv = this.iv;
                        for(let i = 0; i < sourceLength; ++i){
                            buffer[bufferLength] = data[i];
                            ++bufferLength;
                            if (bufferLength < 16) continue;
                            const plain = this._decrypt(buffer, this._key);
                            for(let j = 0; j < 16; ++j)plain[j] ^= iv[j];
                            iv = buffer;
                            result.push(plain);
                            buffer = new Uint8Array(16);
                            bufferLength = 0;
                        }
                        this.buffer = buffer;
                        this.bufferLength = bufferLength;
                        this.iv = iv;
                        if (result.length === 0) return new Uint8Array(0);
                        let outputLength = 16 * result.length;
                        if (finalize) {
                            const lastBlock = result[result.length - 1];
                            let psLen = lastBlock[15];
                            if (psLen <= 16) {
                                for(let i = 15, ii = 16 - psLen; i >= ii; --i)if (lastBlock[i] !== psLen) {
                                    psLen = 0;
                                    break;
                                }
                                outputLength -= psLen;
                                result[result.length - 1] = lastBlock.subarray(0, 16 - psLen);
                            }
                        }
                        const output = new Uint8Array(outputLength);
                        for(let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16)output.set(result[i], j);
                        return output;
                    }
                    decryptBlock(data, finalize, iv = null) {
                        const sourceLength = data.length;
                        const buffer = this.buffer;
                        let bufferLength = this.bufferPosition;
                        if (iv) this.iv = iv;
                        else {
                            for(let i = 0; bufferLength < 16 && i < sourceLength; ++i, ++bufferLength)buffer[bufferLength] = data[i];
                            if (bufferLength < 16) {
                                this.bufferLength = bufferLength;
                                return new Uint8Array(0);
                            }
                            this.iv = buffer;
                            data = data.subarray(16);
                        }
                        this.buffer = new Uint8Array(16);
                        this.bufferLength = 0;
                        this.decryptBlock = this._decryptBlock2;
                        return this.decryptBlock(data, finalize);
                    }
                    encrypt(data, iv) {
                        const sourceLength = data.length;
                        let buffer = this.buffer, bufferLength = this.bufferPosition;
                        const result = [];
                        if (!iv) iv = new Uint8Array(16);
                        for(let i = 0; i < sourceLength; ++i){
                            buffer[bufferLength] = data[i];
                            ++bufferLength;
                            if (bufferLength < 16) continue;
                            for(let j = 0; j < 16; ++j)buffer[j] ^= iv[j];
                            const cipher = this._encrypt(buffer, this._key);
                            iv = cipher;
                            result.push(cipher);
                            buffer = new Uint8Array(16);
                            bufferLength = 0;
                        }
                        this.buffer = buffer;
                        this.bufferLength = bufferLength;
                        this.iv = iv;
                        if (result.length === 0) return new Uint8Array(0);
                        const outputLength = 16 * result.length;
                        const output = new Uint8Array(outputLength);
                        for(let i = 0, j = 0, ii = result.length; i < ii; ++i, j += 16)output.set(result[i], j);
                        return output;
                    }
                }
                class AES128Cipher extends AESBaseCipher {
                    constructor(key){
                        super();
                        this._cyclesOfRepetition = 10;
                        this._keySize = 160;
                        this._rcon = new Uint8Array([
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d,
                            0x01,
                            0x02,
                            0x04,
                            0x08,
                            0x10,
                            0x20,
                            0x40,
                            0x80,
                            0x1b,
                            0x36,
                            0x6c,
                            0xd8,
                            0xab,
                            0x4d,
                            0x9a,
                            0x2f,
                            0x5e,
                            0xbc,
                            0x63,
                            0xc6,
                            0x97,
                            0x35,
                            0x6a,
                            0xd4,
                            0xb3,
                            0x7d,
                            0xfa,
                            0xef,
                            0xc5,
                            0x91,
                            0x39,
                            0x72,
                            0xe4,
                            0xd3,
                            0xbd,
                            0x61,
                            0xc2,
                            0x9f,
                            0x25,
                            0x4a,
                            0x94,
                            0x33,
                            0x66,
                            0xcc,
                            0x83,
                            0x1d,
                            0x3a,
                            0x74,
                            0xe8,
                            0xcb,
                            0x8d
                        ]);
                        this._key = this._expandKey(key);
                    }
                    _expandKey(cipherKey) {
                        const b = 176;
                        const s = this._s;
                        const rcon = this._rcon;
                        const result = new Uint8Array(b);
                        result.set(cipherKey);
                        for(let j = 16, i = 1; j < b; ++i){
                            let t1 = result[j - 3];
                            let t2 = result[j - 2];
                            let t3 = result[j - 1];
                            let t4 = result[j - 4];
                            t1 = s[t1];
                            t2 = s[t2];
                            t3 = s[t3];
                            t4 = s[t4];
                            t1 ^= rcon[i];
                            for(let n = 0; n < 4; ++n){
                                result[j] = t1 ^= result[j - 16];
                                j++;
                                result[j] = t2 ^= result[j - 16];
                                j++;
                                result[j] = t3 ^= result[j - 16];
                                j++;
                                result[j] = t4 ^= result[j - 16];
                                j++;
                            }
                        }
                        return result;
                    }
                }
                exports.AES128Cipher = AES128Cipher;
                class AES256Cipher extends AESBaseCipher {
                    constructor(key){
                        super();
                        this._cyclesOfRepetition = 14;
                        this._keySize = 224;
                        this._key = this._expandKey(key);
                    }
                    _expandKey(cipherKey) {
                        const b = 240;
                        const s = this._s;
                        const result = new Uint8Array(b);
                        result.set(cipherKey);
                        let r = 1;
                        let t1, t2, t3, t4;
                        for(let j = 32, i = 1; j < b; ++i){
                            if (j % 32 === 16) {
                                t1 = s[t1];
                                t2 = s[t2];
                                t3 = s[t3];
                                t4 = s[t4];
                            } else if (j % 32 === 0) {
                                t1 = result[j - 3];
                                t2 = result[j - 2];
                                t3 = result[j - 1];
                                t4 = result[j - 4];
                                t1 = s[t1];
                                t2 = s[t2];
                                t3 = s[t3];
                                t4 = s[t4];
                                t1 ^= r;
                                if ((r <<= 1) >= 256) r = (r ^ 0x1b) & 0xff;
                            }
                            for(let n = 0; n < 4; ++n){
                                result[j] = t1 ^= result[j - 32];
                                j++;
                                result[j] = t2 ^= result[j - 32];
                                j++;
                                result[j] = t3 ^= result[j - 32];
                                j++;
                                result[j] = t4 ^= result[j - 32];
                                j++;
                            }
                        }
                        return result;
                    }
                }
                exports.AES256Cipher = AES256Cipher;
                class PDF17 {
                    checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerValidationSalt, password.length);
                        hashData.set(userBytes, password.length + ownerValidationSalt.length);
                        const result = calculateSHA256(hashData, 0, hashData.length);
                        return (0, _util.isArrayEqual)(result, ownerPassword);
                    }
                    checkUserPassword(password, userValidationSalt, userPassword) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userValidationSalt, password.length);
                        const result = calculateSHA256(hashData, 0, hashData.length);
                        return (0, _util.isArrayEqual)(result, userPassword);
                    }
                    getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                        const hashData = new Uint8Array(password.length + 56);
                        hashData.set(password, 0);
                        hashData.set(ownerKeySalt, password.length);
                        hashData.set(userBytes, password.length + ownerKeySalt.length);
                        const key = calculateSHA256(hashData, 0, hashData.length);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                    }
                    getUserKey(password, userKeySalt, userEncryption) {
                        const hashData = new Uint8Array(password.length + 8);
                        hashData.set(password, 0);
                        hashData.set(userKeySalt, password.length);
                        const key = calculateSHA256(hashData, 0, hashData.length);
                        const cipher = new AES256Cipher(key);
                        return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                    }
                }
                exports.PDF17 = PDF17;
                const PDF20 = function PDF20Closure() {
                    function calculatePDF20Hash(password, input, userBytes) {
                        let k = calculateSHA256(input, 0, input.length).subarray(0, 32);
                        let e = [
                            0
                        ];
                        let i = 0;
                        while(i < 64 || e[e.length - 1] > i - 32){
                            const combinedLength = password.length + k.length + userBytes.length, combinedArray = new Uint8Array(combinedLength);
                            let writeOffset = 0;
                            combinedArray.set(password, writeOffset);
                            writeOffset += password.length;
                            combinedArray.set(k, writeOffset);
                            writeOffset += k.length;
                            combinedArray.set(userBytes, writeOffset);
                            const k1 = new Uint8Array(combinedLength * 64);
                            for(let j = 0, pos = 0; j < 64; j++, pos += combinedLength)k1.set(combinedArray, pos);
                            const cipher = new AES128Cipher(k.subarray(0, 16));
                            e = cipher.encrypt(k1, k.subarray(16, 32));
                            let remainder = 0;
                            for(let z = 0; z < 16; z++){
                                remainder *= 1;
                                remainder %= 3;
                                remainder += (e[z] >>> 0) % 3;
                                remainder %= 3;
                            }
                            if (remainder === 0) k = calculateSHA256(e, 0, e.length);
                            else if (remainder === 1) k = calculateSHA384(e, 0, e.length);
                            else if (remainder === 2) k = calculateSHA512(e, 0, e.length);
                            i++;
                        }
                        return k.subarray(0, 32);
                    }
                    class PDF20 {
                        hash(password, concatBytes, userBytes) {
                            return calculatePDF20Hash(password, concatBytes, userBytes);
                        }
                        checkOwnerPassword(password, ownerValidationSalt, userBytes, ownerPassword) {
                            const hashData = new Uint8Array(password.length + 56);
                            hashData.set(password, 0);
                            hashData.set(ownerValidationSalt, password.length);
                            hashData.set(userBytes, password.length + ownerValidationSalt.length);
                            const result = calculatePDF20Hash(password, hashData, userBytes);
                            return (0, _util.isArrayEqual)(result, ownerPassword);
                        }
                        checkUserPassword(password, userValidationSalt, userPassword) {
                            const hashData = new Uint8Array(password.length + 8);
                            hashData.set(password, 0);
                            hashData.set(userValidationSalt, password.length);
                            const result = calculatePDF20Hash(password, hashData, []);
                            return (0, _util.isArrayEqual)(result, userPassword);
                        }
                        getOwnerKey(password, ownerKeySalt, userBytes, ownerEncryption) {
                            const hashData = new Uint8Array(password.length + 56);
                            hashData.set(password, 0);
                            hashData.set(ownerKeySalt, password.length);
                            hashData.set(userBytes, password.length + ownerKeySalt.length);
                            const key = calculatePDF20Hash(password, hashData, userBytes);
                            const cipher = new AES256Cipher(key);
                            return cipher.decryptBlock(ownerEncryption, false, new Uint8Array(16));
                        }
                        getUserKey(password, userKeySalt, userEncryption) {
                            const hashData = new Uint8Array(password.length + 8);
                            hashData.set(password, 0);
                            hashData.set(userKeySalt, password.length);
                            const key = calculatePDF20Hash(password, hashData, []);
                            const cipher = new AES256Cipher(key);
                            return cipher.decryptBlock(userEncryption, false, new Uint8Array(16));
                        }
                    }
                    return PDF20;
                }();
                exports.PDF20 = PDF20;
                class CipherTransform {
                    constructor(stringCipherConstructor, streamCipherConstructor){
                        this.StringCipherConstructor = stringCipherConstructor;
                        this.StreamCipherConstructor = streamCipherConstructor;
                    }
                    createStream(stream, length) {
                        const cipher = new this.StreamCipherConstructor();
                        return new _decrypt_stream.DecryptStream(stream, length, function cipherTransformDecryptStream(data, finalize) {
                            return cipher.decryptBlock(data, finalize);
                        });
                    }
                    decryptString(s) {
                        const cipher = new this.StringCipherConstructor();
                        let data = (0, _util.stringToBytes)(s);
                        data = cipher.decryptBlock(data, true);
                        return (0, _util.bytesToString)(data);
                    }
                    encryptString(s) {
                        const cipher = new this.StringCipherConstructor();
                        if (cipher instanceof AESBaseCipher) {
                            const strLen = s.length;
                            const pad = 16 - strLen % 16;
                            if (pad !== 16) s = s.padEnd(16 * Math.ceil(strLen / 16), String.fromCharCode(pad));
                            const iv = new Uint8Array(16);
                            if (typeof crypto !== "undefined") crypto.getRandomValues(iv);
                            else for(let i = 0; i < 16; i++)iv[i] = Math.floor(256 * Math.random());
                            let data = (0, _util.stringToBytes)(s);
                            data = cipher.encrypt(data, iv);
                            const buf = new Uint8Array(16 + data.length);
                            buf.set(iv);
                            buf.set(data, 16);
                            return (0, _util.bytesToString)(buf);
                        }
                        let data = (0, _util.stringToBytes)(s);
                        data = cipher.encrypt(data);
                        return (0, _util.bytesToString)(data);
                    }
                }
                const CipherTransformFactory = function CipherTransformFactoryClosure() {
                    const defaultPasswordBytes = new Uint8Array([
                        0x28,
                        0xbf,
                        0x4e,
                        0x5e,
                        0x4e,
                        0x75,
                        0x8a,
                        0x41,
                        0x64,
                        0x00,
                        0x4e,
                        0x56,
                        0xff,
                        0xfa,
                        0x01,
                        0x08,
                        0x2e,
                        0x2e,
                        0x00,
                        0xb6,
                        0xd0,
                        0x68,
                        0x3e,
                        0x80,
                        0x2f,
                        0x0c,
                        0xa9,
                        0xfe,
                        0x64,
                        0x53,
                        0x69,
                        0x7a
                    ]);
                    function createEncryptionKey20(revision, password, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms) {
                        if (password) {
                            const passwordLength = Math.min(127, password.length);
                            password = password.subarray(0, passwordLength);
                        } else password = [];
                        let pdfAlgorithm;
                        if (revision === 6) pdfAlgorithm = new PDF20();
                        else pdfAlgorithm = new PDF17();
                        if (pdfAlgorithm.checkUserPassword(password, userValidationSalt, userPassword)) return pdfAlgorithm.getUserKey(password, userKeySalt, userEncryption);
                        else if (password.length && pdfAlgorithm.checkOwnerPassword(password, ownerValidationSalt, uBytes, ownerPassword)) return pdfAlgorithm.getOwnerKey(password, ownerKeySalt, uBytes, ownerEncryption);
                        return null;
                    }
                    function prepareKeyData(fileId, password, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata) {
                        const hashDataSize = 40 + ownerPassword.length + fileId.length;
                        const hashData = new Uint8Array(hashDataSize);
                        let i = 0, j, n;
                        if (password) {
                            n = Math.min(32, password.length);
                            for(; i < n; ++i)hashData[i] = password[i];
                        }
                        j = 0;
                        while(i < 32)hashData[i++] = defaultPasswordBytes[j++];
                        for(j = 0, n = ownerPassword.length; j < n; ++j)hashData[i++] = ownerPassword[j];
                        hashData[i++] = flags & 0xff;
                        hashData[i++] = flags >> 8 & 0xff;
                        hashData[i++] = flags >> 16 & 0xff;
                        hashData[i++] = flags >>> 24 & 0xff;
                        for(j = 0, n = fileId.length; j < n; ++j)hashData[i++] = fileId[j];
                        if (revision >= 4 && !encryptMetadata) {
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                            hashData[i++] = 0xff;
                        }
                        let hash = calculateMD5(hashData, 0, i);
                        const keyLengthInBytes = keyLength >> 3;
                        if (revision >= 3) for(j = 0; j < 50; ++j)hash = calculateMD5(hash, 0, keyLengthInBytes);
                        const encryptionKey = hash.subarray(0, keyLengthInBytes);
                        let cipher, checkData;
                        if (revision >= 3) {
                            for(i = 0; i < 32; ++i)hashData[i] = defaultPasswordBytes[i];
                            for(j = 0, n = fileId.length; j < n; ++j)hashData[i++] = fileId[j];
                            cipher = new ARCFourCipher(encryptionKey);
                            checkData = cipher.encryptBlock(calculateMD5(hashData, 0, i));
                            n = encryptionKey.length;
                            const derivedKey = new Uint8Array(n);
                            for(j = 1; j <= 19; ++j){
                                for(let k = 0; k < n; ++k)derivedKey[k] = encryptionKey[k] ^ j;
                                cipher = new ARCFourCipher(derivedKey);
                                checkData = cipher.encryptBlock(checkData);
                            }
                            for(j = 0, n = checkData.length; j < n; ++j){
                                if (userPassword[j] !== checkData[j]) return null;
                            }
                        } else {
                            cipher = new ARCFourCipher(encryptionKey);
                            checkData = cipher.encryptBlock(defaultPasswordBytes);
                            for(j = 0, n = checkData.length; j < n; ++j){
                                if (userPassword[j] !== checkData[j]) return null;
                            }
                        }
                        return encryptionKey;
                    }
                    function decodeUserPassword(password, ownerPassword, revision, keyLength) {
                        const hashData = new Uint8Array(32);
                        let i = 0;
                        const n = Math.min(32, password.length);
                        for(; i < n; ++i)hashData[i] = password[i];
                        let j = 0;
                        while(i < 32)hashData[i++] = defaultPasswordBytes[j++];
                        let hash = calculateMD5(hashData, 0, i);
                        const keyLengthInBytes = keyLength >> 3;
                        if (revision >= 3) for(j = 0; j < 50; ++j)hash = calculateMD5(hash, 0, hash.length);
                        let cipher, userPassword;
                        if (revision >= 3) {
                            userPassword = ownerPassword;
                            const derivedKey = new Uint8Array(keyLengthInBytes);
                            for(j = 19; j >= 0; j--){
                                for(let k = 0; k < keyLengthInBytes; ++k)derivedKey[k] = hash[k] ^ j;
                                cipher = new ARCFourCipher(derivedKey);
                                userPassword = cipher.encryptBlock(userPassword);
                            }
                        } else {
                            cipher = new ARCFourCipher(hash.subarray(0, keyLengthInBytes));
                            userPassword = cipher.encryptBlock(ownerPassword);
                        }
                        return userPassword;
                    }
                    const identityName = _primitives.Name.get("Identity");
                    function buildObjectKey(num, gen, encryptionKey, isAes = false) {
                        const key = new Uint8Array(encryptionKey.length + 9);
                        const n = encryptionKey.length;
                        let i;
                        for(i = 0; i < n; ++i)key[i] = encryptionKey[i];
                        key[i++] = num & 0xff;
                        key[i++] = num >> 8 & 0xff;
                        key[i++] = num >> 16 & 0xff;
                        key[i++] = gen & 0xff;
                        key[i++] = gen >> 8 & 0xff;
                        if (isAes) {
                            key[i++] = 0x73;
                            key[i++] = 0x41;
                            key[i++] = 0x6c;
                            key[i++] = 0x54;
                        }
                        const hash = calculateMD5(key, 0, i);
                        return hash.subarray(0, Math.min(encryptionKey.length + 5, 16));
                    }
                    function buildCipherConstructor(cf, name, num, gen, key) {
                        if (!(0, _primitives.isName)(name)) throw new _util.FormatError("Invalid crypt filter name.");
                        const cryptFilter = cf.get(name.name);
                        let cfm;
                        if (cryptFilter !== null && cryptFilter !== undefined) cfm = cryptFilter.get("CFM");
                        if (!cfm || cfm.name === "None") return function cipherTransformFactoryBuildCipherConstructorNone() {
                            return new NullCipher();
                        };
                        if (cfm.name === "V2") return function cipherTransformFactoryBuildCipherConstructorV2() {
                            return new ARCFourCipher(buildObjectKey(num, gen, key, false));
                        };
                        if (cfm.name === "AESV2") return function cipherTransformFactoryBuildCipherConstructorAESV2() {
                            return new AES128Cipher(buildObjectKey(num, gen, key, true));
                        };
                        if (cfm.name === "AESV3") return function cipherTransformFactoryBuildCipherConstructorAESV3() {
                            return new AES256Cipher(key);
                        };
                        throw new _util.FormatError("Unknown crypto method");
                    }
                    class CipherTransformFactory {
                        constructor(dict, fileId, password){
                            const filter = dict.get("Filter");
                            if (!(0, _primitives.isName)(filter, "Standard")) throw new _util.FormatError("unknown encryption method");
                            this.dict = dict;
                            const algorithm = dict.get("V");
                            if (!Number.isInteger(algorithm) || algorithm !== 1 && algorithm !== 2 && algorithm !== 4 && algorithm !== 5) throw new _util.FormatError("unsupported encryption algorithm");
                            this.algorithm = algorithm;
                            let keyLength = dict.get("Length");
                            if (!keyLength) {
                                if (algorithm <= 3) keyLength = 40;
                                else {
                                    const cfDict = dict.get("CF");
                                    const streamCryptoName = dict.get("StmF");
                                    if ((0, _primitives.isDict)(cfDict) && (0, _primitives.isName)(streamCryptoName)) {
                                        cfDict.suppressEncryption = true;
                                        const handlerDict = cfDict.get(streamCryptoName.name);
                                        keyLength = handlerDict && handlerDict.get("Length") || 128;
                                        if (keyLength < 40) keyLength <<= 3;
                                    }
                                }
                            }
                            if (!Number.isInteger(keyLength) || keyLength < 40 || keyLength % 8 !== 0) throw new _util.FormatError("invalid key length");
                            const ownerPassword = (0, _util.stringToBytes)(dict.get("O")).subarray(0, 32);
                            const userPassword = (0, _util.stringToBytes)(dict.get("U")).subarray(0, 32);
                            const flags = dict.get("P");
                            const revision = dict.get("R");
                            const encryptMetadata = (algorithm === 4 || algorithm === 5) && dict.get("EncryptMetadata") !== false;
                            this.encryptMetadata = encryptMetadata;
                            const fileIdBytes = (0, _util.stringToBytes)(fileId);
                            let passwordBytes;
                            if (password) {
                                if (revision === 6) try {
                                    password = (0, _util.utf8StringToString)(password);
                                } catch (ex) {
                                    (0, _util.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                                }
                                passwordBytes = (0, _util.stringToBytes)(password);
                            }
                            let encryptionKey;
                            if (algorithm !== 5) encryptionKey = prepareKeyData(fileIdBytes, passwordBytes, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                            else {
                                const ownerValidationSalt = (0, _util.stringToBytes)(dict.get("O")).subarray(32, 40);
                                const ownerKeySalt = (0, _util.stringToBytes)(dict.get("O")).subarray(40, 48);
                                const uBytes = (0, _util.stringToBytes)(dict.get("U")).subarray(0, 48);
                                const userValidationSalt = (0, _util.stringToBytes)(dict.get("U")).subarray(32, 40);
                                const userKeySalt = (0, _util.stringToBytes)(dict.get("U")).subarray(40, 48);
                                const ownerEncryption = (0, _util.stringToBytes)(dict.get("OE"));
                                const userEncryption = (0, _util.stringToBytes)(dict.get("UE"));
                                const perms = (0, _util.stringToBytes)(dict.get("Perms"));
                                encryptionKey = createEncryptionKey20(revision, passwordBytes, ownerPassword, ownerValidationSalt, ownerKeySalt, uBytes, userPassword, userValidationSalt, userKeySalt, ownerEncryption, userEncryption, perms);
                            }
                            if (!encryptionKey && !password) throw new _util.PasswordException("No password given", _util.PasswordResponses.NEED_PASSWORD);
                            else if (!encryptionKey && password) {
                                const decodedPassword = decodeUserPassword(passwordBytes, ownerPassword, revision, keyLength);
                                encryptionKey = prepareKeyData(fileIdBytes, decodedPassword, ownerPassword, userPassword, flags, revision, keyLength, encryptMetadata);
                            }
                            if (!encryptionKey) throw new _util.PasswordException("Incorrect Password", _util.PasswordResponses.INCORRECT_PASSWORD);
                            this.encryptionKey = encryptionKey;
                            if (algorithm >= 4) {
                                const cf = dict.get("CF");
                                if ((0, _primitives.isDict)(cf)) cf.suppressEncryption = true;
                                this.cf = cf;
                                this.stmf = dict.get("StmF") || identityName;
                                this.strf = dict.get("StrF") || identityName;
                                this.eff = dict.get("EFF") || this.stmf;
                            }
                        }
                        createCipherTransform(num, gen) {
                            if (this.algorithm === 4 || this.algorithm === 5) return new CipherTransform(buildCipherConstructor(this.cf, this.stmf, num, gen, this.encryptionKey), buildCipherConstructor(this.cf, this.strf, num, gen, this.encryptionKey));
                            const key = buildObjectKey(num, gen, this.encryptionKey, false);
                            const cipherConstructor = function buildCipherCipherConstructor() {
                                return new ARCFourCipher(key);
                            };
                            return new CipherTransform(cipherConstructor, cipherConstructor);
                        }
                    }
                    return CipherTransformFactory;
                }();
                exports.CipherTransformFactory = CipherTransformFactory;
            /***/ },
            /* 73 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DecryptStream = void 0;
                var _decode_stream = __w_pdfjs_require__(19);
                const chunkSize = 512;
                class DecryptStream extends _decode_stream.DecodeStream {
                    constructor(str, maybeLength, decrypt){
                        super(maybeLength);
                        this.str = str;
                        this.dict = str.dict;
                        this.decrypt = decrypt;
                        this.nextChunk = null;
                        this.initialized = false;
                    }
                    readBlock() {
                        let chunk;
                        if (this.initialized) chunk = this.nextChunk;
                        else {
                            chunk = this.str.getBytes(chunkSize);
                            this.initialized = true;
                        }
                        if (!chunk || chunk.length === 0) {
                            this.eof = true;
                            return;
                        }
                        this.nextChunk = this.str.getBytes(chunkSize);
                        const hasMoreData = this.nextChunk && this.nextChunk.length > 0;
                        const decrypt = this.decrypt;
                        chunk = decrypt(chunk, !hasMoreData);
                        let bufferLength = this.bufferLength;
                        const n = chunk.length, buffer = this.ensureBuffer(bufferLength + n);
                        for(let i = 0; i < n; i++)buffer[bufferLength++] = chunk[i];
                        this.bufferLength = bufferLength;
                    }
                }
                exports.DecryptStream = DecryptStream;
            /***/ },
            /* 74 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XFAFactory = void 0;
                var _xfa_object = __w_pdfjs_require__(75);
                var _bind = __w_pdfjs_require__(79);
                var _data = __w_pdfjs_require__(85);
                var _fonts = __w_pdfjs_require__(83);
                var _utils = __w_pdfjs_require__(76);
                var _util = __w_pdfjs_require__(2);
                var _parser = __w_pdfjs_require__(86);
                class XFAFactory {
                    constructor(data){
                        try {
                            this.root = new _parser.XFAParser().parse(XFAFactory._createDocument(data));
                            const binder = new _bind.Binder(this.root);
                            this.form = binder.bind();
                            this.dataHandler = new _data.DataHandler(this.root, binder.getData());
                            this.form[_xfa_object.$globalData].template = this.form;
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during parsing and binding: ${e}`);
                        }
                    }
                    isValid() {
                        return this.root && this.form;
                    }
                    _createPages() {
                        try {
                            this.pages = this.form[_xfa_object.$toHTML]();
                            this.dims = this.pages.children.map((c)=>{
                                const { width: width , height: height  } = c.attributes.style;
                                return [
                                    0,
                                    0,
                                    parseInt(width),
                                    parseInt(height)
                                ];
                            });
                        } catch (e) {
                            (0, _util.warn)(`XFA - an error occurred during layout: ${e}`);
                        }
                    }
                    getBoundingBox(pageIndex) {
                        return this.dims[pageIndex];
                    }
                    get numberPages() {
                        if (!this.pages) this._createPages();
                        return this.dims.length;
                    }
                    setImages(images) {
                        this.form[_xfa_object.$globalData].images = images;
                    }
                    setFonts(fonts) {
                        this.form[_xfa_object.$globalData].fontFinder = new _fonts.FontFinder(fonts);
                        const missingFonts = [];
                        for (let typeface of this.form[_xfa_object.$globalData].usedTypefaces){
                            typeface = (0, _utils.stripQuotes)(typeface);
                            const font1 = this.form[_xfa_object.$globalData].fontFinder.find(typeface);
                            if (!font1) missingFonts.push(typeface);
                        }
                        if (missingFonts.length > 0) return missingFonts;
                        return null;
                    }
                    appendFonts(fonts, reallyMissingFonts) {
                        this.form[_xfa_object.$globalData].fontFinder.add(fonts, reallyMissingFonts);
                    }
                    getPages() {
                        if (!this.pages) this._createPages();
                        const pages = this.pages;
                        this.pages = null;
                        return pages;
                    }
                    serializeData(storage) {
                        return this.dataHandler.serialize(storage);
                    }
                    static _createDocument(data) {
                        if (!data["/xdp:xdp"]) return data["xdp:xdp"];
                        return Object.values(data).join("");
                    }
                }
                exports.XFAFactory = XFAFactory;
            /***/ },
            /* 75 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XmlObject = exports.XFAObjectArray = exports.XFAObject = exports.XFAAttribute = exports.StringObject = exports.OptionObject = exports.Option10 = exports.Option01 = exports.IntegerObject = exports.ContentObject = exports.$uid = exports.$toStyle = exports.$toString = exports.$toHTML = exports.$text = exports.$tabIndex = exports.$setValue = exports.$setSetAttributes = exports.$setId = exports.$searchNode = exports.$root = exports.$resolvePrototypes = exports.$removeChild = exports.$pushGlyphs = exports.$onText = exports.$onChildCheck = exports.$onChild = exports.$nsAttributes = exports.$nodeName = exports.$namespaceId = exports.$isUsable = exports.$isTransparent = exports.$isThereMoreWidth = exports.$isSplittable = exports.$isNsAgnostic = exports.$isDescendent = exports.$isDataValue = exports.$isCDATAXml = exports.$isBindable = exports.$insertAt = exports.$indexOf = exports.$ids = exports.$hasSettableValue = exports.$globalData = exports.$getTemplateRoot = exports.$getSubformParent = exports.$getRealChildrenByNameIt = exports.$getParent = exports.$getNextPage = exports.$getExtra = exports.$getDataValue = exports.$getContainedChildren = exports.$getChildrenByNameIt = exports.$getChildrenByName = exports.$getChildrenByClass = exports.$getChildren = exports.$getAvailableSpace = exports.$getAttributes = exports.$getAttributeIt = exports.$flushHTML = exports.$finalize = exports.$extra = exports.$dump = exports.$data = exports.$content = exports.$consumed = exports.$clone = exports.$cleanup = exports.$cleanPage = exports.$clean = exports.$childrenToHTML = exports.$appendChild = exports.$addHTML = exports.$acceptWhitespace = void 0;
                var _utils = __w_pdfjs_require__(76);
                var _util = __w_pdfjs_require__(2);
                var _core_utils = __w_pdfjs_require__(9);
                var _namespaces = __w_pdfjs_require__(77);
                var _som = __w_pdfjs_require__(78);
                const $acceptWhitespace = Symbol();
                exports.$acceptWhitespace = $acceptWhitespace;
                const $addHTML = Symbol();
                exports.$addHTML = $addHTML;
                const $appendChild = Symbol();
                exports.$appendChild = $appendChild;
                const $childrenToHTML = Symbol();
                exports.$childrenToHTML = $childrenToHTML;
                const $clean = Symbol();
                exports.$clean = $clean;
                const $cleanPage = Symbol();
                exports.$cleanPage = $cleanPage;
                const $cleanup = Symbol();
                exports.$cleanup = $cleanup;
                const $clone = Symbol();
                exports.$clone = $clone;
                const $consumed = Symbol();
                exports.$consumed = $consumed;
                const $content = Symbol("content");
                exports.$content = $content;
                const $data = Symbol("data");
                exports.$data = $data;
                const $dump = Symbol();
                exports.$dump = $dump;
                const $extra = Symbol("extra");
                exports.$extra = $extra;
                const $finalize = Symbol();
                exports.$finalize = $finalize;
                const $flushHTML = Symbol();
                exports.$flushHTML = $flushHTML;
                const $getAttributeIt = Symbol();
                exports.$getAttributeIt = $getAttributeIt;
                const $getAttributes = Symbol();
                exports.$getAttributes = $getAttributes;
                const $getAvailableSpace = Symbol();
                exports.$getAvailableSpace = $getAvailableSpace;
                const $getChildrenByClass = Symbol();
                exports.$getChildrenByClass = $getChildrenByClass;
                const $getChildrenByName = Symbol();
                exports.$getChildrenByName = $getChildrenByName;
                const $getChildrenByNameIt = Symbol();
                exports.$getChildrenByNameIt = $getChildrenByNameIt;
                const $getDataValue = Symbol();
                exports.$getDataValue = $getDataValue;
                const $getExtra = Symbol();
                exports.$getExtra = $getExtra;
                const $getRealChildrenByNameIt = Symbol();
                exports.$getRealChildrenByNameIt = $getRealChildrenByNameIt;
                const $getChildren = Symbol();
                exports.$getChildren = $getChildren;
                const $getContainedChildren = Symbol();
                exports.$getContainedChildren = $getContainedChildren;
                const $getNextPage = Symbol();
                exports.$getNextPage = $getNextPage;
                const $getSubformParent = Symbol();
                exports.$getSubformParent = $getSubformParent;
                const $getParent = Symbol();
                exports.$getParent = $getParent;
                const $getTemplateRoot = Symbol();
                exports.$getTemplateRoot = $getTemplateRoot;
                const $globalData = Symbol();
                exports.$globalData = $globalData;
                const $hasSettableValue = Symbol();
                exports.$hasSettableValue = $hasSettableValue;
                const $ids = Symbol();
                exports.$ids = $ids;
                const $indexOf = Symbol();
                exports.$indexOf = $indexOf;
                const $insertAt = Symbol();
                exports.$insertAt = $insertAt;
                const $isCDATAXml = Symbol();
                exports.$isCDATAXml = $isCDATAXml;
                const $isBindable = Symbol();
                exports.$isBindable = $isBindable;
                const $isDataValue = Symbol();
                exports.$isDataValue = $isDataValue;
                const $isDescendent = Symbol();
                exports.$isDescendent = $isDescendent;
                const $isNsAgnostic = Symbol();
                exports.$isNsAgnostic = $isNsAgnostic;
                const $isSplittable = Symbol();
                exports.$isSplittable = $isSplittable;
                const $isThereMoreWidth = Symbol();
                exports.$isThereMoreWidth = $isThereMoreWidth;
                const $isTransparent = Symbol();
                exports.$isTransparent = $isTransparent;
                const $isUsable = Symbol();
                exports.$isUsable = $isUsable;
                const $lastAttribute = Symbol();
                const $namespaceId = Symbol("namespaceId");
                exports.$namespaceId = $namespaceId;
                const $nodeName = Symbol("nodeName");
                exports.$nodeName = $nodeName;
                const $nsAttributes = Symbol();
                exports.$nsAttributes = $nsAttributes;
                const $onChild = Symbol();
                exports.$onChild = $onChild;
                const $onChildCheck = Symbol();
                exports.$onChildCheck = $onChildCheck;
                const $onText = Symbol();
                exports.$onText = $onText;
                const $pushGlyphs = Symbol();
                exports.$pushGlyphs = $pushGlyphs;
                const $removeChild = Symbol();
                exports.$removeChild = $removeChild;
                const $root = Symbol("root");
                exports.$root = $root;
                const $resolvePrototypes = Symbol();
                exports.$resolvePrototypes = $resolvePrototypes;
                const $searchNode = Symbol();
                exports.$searchNode = $searchNode;
                const $setId = Symbol();
                exports.$setId = $setId;
                const $setSetAttributes = Symbol();
                exports.$setSetAttributes = $setSetAttributes;
                const $setValue = Symbol();
                exports.$setValue = $setValue;
                const $tabIndex = Symbol();
                exports.$tabIndex = $tabIndex;
                const $text = Symbol();
                exports.$text = $text;
                const $toHTML = Symbol();
                exports.$toHTML = $toHTML;
                const $toString = Symbol();
                exports.$toString = $toString;
                const $toStyle = Symbol();
                exports.$toStyle = $toStyle;
                const $uid = Symbol("uid");
                exports.$uid = $uid;
                const _applyPrototype = Symbol();
                const _attributes = Symbol();
                const _attributeNames = Symbol();
                const _children = Symbol("_children");
                const _cloneAttribute = Symbol();
                const _dataValue = Symbol();
                const _defaultValue = Symbol();
                const _filteredChildrenGenerator = Symbol();
                const _getPrototype = Symbol();
                const _getUnsetAttributes = Symbol();
                const _hasChildren = Symbol();
                const _max = Symbol();
                const _options = Symbol();
                const _parent = Symbol("parent");
                const _resolvePrototypesHelper = Symbol();
                const _setAttributes = Symbol();
                const _validator = Symbol();
                let uid = 0;
                const NS_DATASETS = _namespaces.NamespaceIds.datasets.id;
                class XFAObject {
                    constructor(nsId, name, hasChildren = false){
                        this[$namespaceId] = nsId;
                        this[$nodeName] = name;
                        this[_hasChildren] = hasChildren;
                        this[_parent] = null;
                        this[_children] = [];
                        this[$uid] = `${name}${uid++}`;
                        this[$globalData] = null;
                    }
                    [$onChild](child) {
                        if (!this[_hasChildren] || !this[$onChildCheck](child)) return false;
                        const name = child[$nodeName];
                        const node = this[name];
                        if (node instanceof XFAObjectArray) {
                            if (node.push(child)) {
                                this[$appendChild](child);
                                return true;
                            }
                        } else {
                            if (node !== null) this[$removeChild](node);
                            this[name] = child;
                            this[$appendChild](child);
                            return true;
                        }
                        let id = "";
                        if (this.id) id = ` (id: ${this.id})`;
                        else if (this.name) id = ` (name: ${this.name} ${this.h.value})`;
                        (0, _util.warn)(`XFA - node "${this[$nodeName]}"${id} has already enough "${name}"!`);
                        return false;
                    }
                    [$onChildCheck](child) {
                        return this.hasOwnProperty(child[$nodeName]) && child[$namespaceId] === this[$namespaceId];
                    }
                    [$isNsAgnostic]() {
                        return false;
                    }
                    [$acceptWhitespace]() {
                        return false;
                    }
                    [$isCDATAXml]() {
                        return false;
                    }
                    [$isBindable]() {
                        return false;
                    }
                    [$setId](ids) {
                        if (this.id && this[$namespaceId] === _namespaces.NamespaceIds.template.id) ids.set(this.id, this);
                    }
                    [$getTemplateRoot]() {
                        return this[$globalData].template;
                    }
                    [$isSplittable]() {
                        return false;
                    }
                    [$isThereMoreWidth]() {
                        return false;
                    }
                    [$appendChild](child) {
                        child[_parent] = this;
                        this[_children].push(child);
                    }
                    [$removeChild](child) {
                        const i = this[_children].indexOf(child);
                        this[_children].splice(i, 1);
                    }
                    [$hasSettableValue]() {
                        return this.hasOwnProperty("value");
                    }
                    [$setValue](_) {}
                    [$onText](_) {}
                    [$finalize]() {}
                    [$clean](builder) {
                        delete this[_hasChildren];
                        if (this[$cleanup]) {
                            builder.clean(this[$cleanup]);
                            delete this[$cleanup];
                        }
                    }
                    [$indexOf](child) {
                        return this[_children].indexOf(child);
                    }
                    [$insertAt](i, child) {
                        child[_parent] = this;
                        this[_children].splice(i, 0, child);
                    }
                    [$isTransparent]() {
                        return !this.name;
                    }
                    [$lastAttribute]() {
                        return "";
                    }
                    [$text]() {
                        if (this[_children].length === 0) return this[$content];
                        return this[_children].map((c)=>c[$text]()).join("");
                    }
                    get [_attributeNames]() {
                        const proto = Object.getPrototypeOf(this);
                        if (!proto._attributes) {
                            const attributes = proto._attributes = new Set();
                            for (const name of Object.getOwnPropertyNames(this)){
                                if (this[name] === null || this[name] instanceof XFAObject || this[name] instanceof XFAObjectArray) break;
                                attributes.add(name);
                            }
                        }
                        return (0, _util.shadow)(this, _attributeNames, proto._attributes);
                    }
                    [$isDescendent](parent) {
                        let node = this;
                        while(node){
                            if (node === parent) return true;
                            node = node[$getParent]();
                        }
                        return false;
                    }
                    [$getParent]() {
                        return this[_parent];
                    }
                    [$getSubformParent]() {
                        return this[$getParent]();
                    }
                    [$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[name];
                    }
                    [$dump]() {
                        const dumped = Object.create(null);
                        if (this[$content]) dumped.$content = this[$content];
                        for (const name of Object.getOwnPropertyNames(this)){
                            const value = this[name];
                            if (value === null) continue;
                            if (value instanceof XFAObject) dumped[name] = value[$dump]();
                            else if (value instanceof XFAObjectArray) {
                                if (!value.isEmpty()) dumped[name] = value.dump();
                            } else dumped[name] = value;
                        }
                        return dumped;
                    }
                    [$toStyle]() {
                        return null;
                    }
                    [$toHTML]() {
                        return _utils.HTMLResult.EMPTY;
                    }
                    *[$getContainedChildren]() {
                        for (const node of this[$getChildren]())yield node;
                    }
                    *[_filteredChildrenGenerator](filter, include) {
                        for (const node of this[$getContainedChildren]())if (!filter || include === filter.has(node[$nodeName])) {
                            const availableSpace = this[$getAvailableSpace]();
                            const res = node[$toHTML](availableSpace);
                            if (!res.success) this[$extra].failingNode = node;
                            yield res;
                        }
                    }
                    [$flushHTML]() {
                        return null;
                    }
                    [$addHTML](html, bbox) {
                        this[$extra].children.push(html);
                    }
                    [$getAvailableSpace]() {}
                    [$childrenToHTML]({ filter: filter = null , include: include = true  }) {
                        if (!this[$extra].generator) this[$extra].generator = this[_filteredChildrenGenerator](filter, include);
                        else {
                            const availableSpace = this[$getAvailableSpace]();
                            const res = this[$extra].failingNode[$toHTML](availableSpace);
                            if (!res.success) return res;
                            if (res.html) this[$addHTML](res.html, res.bbox);
                            delete this[$extra].failingNode;
                        }
                        while(true){
                            const gen = this[$extra].generator.next();
                            if (gen.done) break;
                            const res = gen.value;
                            if (!res.success) return res;
                            if (res.html) this[$addHTML](res.html, res.bbox);
                        }
                        this[$extra].generator = null;
                        return _utils.HTMLResult.EMPTY;
                    }
                    [$setSetAttributes](attributes) {
                        this[_setAttributes] = new Set(Object.keys(attributes));
                    }
                    [_getUnsetAttributes](protoAttributes) {
                        const allAttr = this[_attributeNames];
                        const setAttr = this[_setAttributes];
                        return [
                            ...protoAttributes
                        ].filter((x)=>allAttr.has(x) && !setAttr.has(x));
                    }
                    [$resolvePrototypes](ids, ancestors = new Set()) {
                        for (const child of this[_children])child[_resolvePrototypesHelper](ids, ancestors);
                    }
                    [_resolvePrototypesHelper](ids, ancestors) {
                        const proto = this[_getPrototype](ids, ancestors);
                        if (proto) this[_applyPrototype](proto, ids, ancestors);
                        else this[$resolvePrototypes](ids, ancestors);
                    }
                    [_getPrototype](ids, ancestors) {
                        const { use: use , usehref: usehref  } = this;
                        if (!use && !usehref) return null;
                        let proto = null;
                        let somExpression = null;
                        let id = null;
                        let ref = use;
                        if (usehref) {
                            ref = usehref;
                            if (usehref.startsWith("#som(") && usehref.endsWith(")")) somExpression = usehref.slice(5, usehref.length - 1);
                            else if (usehref.startsWith(".#som(") && usehref.endsWith(")")) somExpression = usehref.slice(6, usehref.length - 1);
                            else if (usehref.startsWith("#")) id = usehref.slice(1);
                            else if (usehref.startsWith(".#")) id = usehref.slice(2);
                        } else if (use.startsWith("#")) id = use.slice(1);
                        else somExpression = use;
                        this.use = this.usehref = "";
                        if (id) proto = ids.get(id);
                        else {
                            proto = (0, _som.searchNode)(ids.get($root), this, somExpression, true, false);
                            if (proto) proto = proto[0];
                        }
                        if (!proto) {
                            (0, _util.warn)(`XFA - Invalid prototype reference: ${ref}.`);
                            return null;
                        }
                        if (proto[$nodeName] !== this[$nodeName]) {
                            (0, _util.warn)(`XFA - Incompatible prototype: ${proto[$nodeName]} !== ${this[$nodeName]}.`);
                            return null;
                        }
                        if (ancestors.has(proto)) {
                            (0, _util.warn)(`XFA - Cycle detected in prototypes use.`);
                            return null;
                        }
                        ancestors.add(proto);
                        const protoProto = proto[_getPrototype](ids, ancestors);
                        if (protoProto) proto[_applyPrototype](protoProto, ids, ancestors);
                        proto[$resolvePrototypes](ids, ancestors);
                        ancestors.delete(proto);
                        return proto;
                    }
                    [_applyPrototype](proto, ids, ancestors) {
                        if (ancestors.has(proto)) {
                            (0, _util.warn)(`XFA - Cycle detected in prototypes use.`);
                            return;
                        }
                        if (!this[$content] && proto[$content]) this[$content] = proto[$content];
                        const newAncestors = new Set(ancestors);
                        newAncestors.add(proto);
                        for (const unsetAttrName of this[_getUnsetAttributes](proto[_setAttributes])){
                            this[unsetAttrName] = proto[unsetAttrName];
                            if (this[_setAttributes]) this[_setAttributes].add(unsetAttrName);
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (this[_attributeNames].has(name)) continue;
                            const value = this[name];
                            const protoValue = proto[name];
                            if (value instanceof XFAObjectArray) {
                                for (const child of value[_children])child[_resolvePrototypesHelper](ids, ancestors);
                                for(let i = value[_children].length, ii = protoValue[_children].length; i < ii; i++){
                                    const child = proto[_children][i][$clone]();
                                    if (value.push(child)) {
                                        child[_parent] = this;
                                        this[_children].push(child);
                                        child[_resolvePrototypesHelper](ids, ancestors);
                                    } else break;
                                }
                                continue;
                            }
                            if (value !== null) {
                                value[$resolvePrototypes](ids, ancestors);
                                if (protoValue) value[_applyPrototype](protoValue, ids, ancestors);
                                continue;
                            }
                            if (protoValue !== null) {
                                const child = protoValue[$clone]();
                                child[_parent] = this;
                                this[name] = child;
                                this[_children].push(child);
                                child[_resolvePrototypesHelper](ids, ancestors);
                            }
                        }
                    }
                    static [_cloneAttribute](obj) {
                        if (Array.isArray(obj)) return obj.map((x)=>XFAObject[_cloneAttribute](x));
                        if (typeof obj === "object" && obj !== null) return Object.assign({}, obj);
                        return obj;
                    }
                    [$clone]() {
                        const clone = Object.create(Object.getPrototypeOf(this));
                        for (const $symbol of Object.getOwnPropertySymbols(this))try {
                            clone[$symbol] = this[$symbol];
                        } catch (_) {
                            (0, _util.shadow)(clone, $symbol, this[$symbol]);
                        }
                        clone[$uid] = `${clone[$nodeName]}${uid++}`;
                        clone[_children] = [];
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (this[_attributeNames].has(name)) {
                                clone[name] = XFAObject[_cloneAttribute](this[name]);
                                continue;
                            }
                            const value = this[name];
                            if (value instanceof XFAObjectArray) clone[name] = new XFAObjectArray(value[_max]);
                            else clone[name] = null;
                        }
                        for (const child of this[_children]){
                            const name = child[$nodeName];
                            const clonedChild = child[$clone]();
                            clone[_children].push(clonedChild);
                            clonedChild[_parent] = clone;
                            if (clone[name] === null) clone[name] = clonedChild;
                            else clone[name][_children].push(clonedChild);
                        }
                        return clone;
                    }
                    [$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[_children].filter((c)=>c[$nodeName] === name);
                    }
                    [$getChildrenByClass](name) {
                        return this[name];
                    }
                    [$getChildrenByName](name, allTransparent, first = true) {
                        return Array.from(this[$getChildrenByNameIt](name, allTransparent, first));
                    }
                    *[$getChildrenByNameIt](name, allTransparent, first = true) {
                        if (name === "parent") {
                            yield this[_parent];
                            return;
                        }
                        for (const child of this[_children]){
                            if (child[$nodeName] === name) yield child;
                            if (child.name === name) yield child;
                            if (allTransparent || child[$isTransparent]()) yield* child[$getChildrenByNameIt](name, allTransparent, false);
                        }
                        if (first && this[_attributeNames].has(name)) yield new XFAAttribute(this, name, this[name]);
                    }
                }
                exports.XFAObject = XFAObject;
                class XFAObjectArray {
                    constructor(max = Infinity){
                        this[_max] = max;
                        this[_children] = [];
                    }
                    push(child) {
                        const len = this[_children].length;
                        if (len <= this[_max]) {
                            this[_children].push(child);
                            return true;
                        }
                        (0, _util.warn)(`XFA - node "${child[$nodeName]}" accepts no more than ${this[_max]} children`);
                        return false;
                    }
                    isEmpty() {
                        return this[_children].length === 0;
                    }
                    dump() {
                        return this[_children].length === 1 ? this[_children][0][$dump]() : this[_children].map((x)=>x[$dump]());
                    }
                    [$clone]() {
                        const clone = new XFAObjectArray(this[_max]);
                        clone[_children] = this[_children].map((c)=>c[$clone]());
                        return clone;
                    }
                    get children() {
                        return this[_children];
                    }
                    clear() {
                        this[_children].length = 0;
                    }
                }
                exports.XFAObjectArray = XFAObjectArray;
                class XFAAttribute {
                    constructor(node, name, value){
                        this[_parent] = node;
                        this[$nodeName] = name;
                        this[$content] = value;
                        this[$consumed] = false;
                        this[$uid] = `attribute${uid++}`;
                    }
                    [$getParent]() {
                        return this[_parent];
                    }
                    [$isDataValue]() {
                        return true;
                    }
                    [$getDataValue]() {
                        return this[$content].trim();
                    }
                    [$setValue](value) {
                        value = value.value || "";
                        this[$content] = value.toString();
                    }
                    [$text]() {
                        return this[$content];
                    }
                    [$isDescendent](parent) {
                        return this[_parent] === parent || this[_parent][$isDescendent](parent);
                    }
                }
                exports.XFAAttribute = XFAAttribute;
                class XmlObject extends XFAObject {
                    constructor(nsId, name, attributes = {}){
                        super(nsId, name);
                        this[$content] = "";
                        this[_dataValue] = null;
                        if (name !== "#text") {
                            const map = new Map();
                            this[_attributes] = map;
                            for (const [attrName, value] of Object.entries(attributes))map.set(attrName, new XFAAttribute(this, attrName, value));
                            if (attributes.hasOwnProperty($nsAttributes)) {
                                const dataNode = attributes[$nsAttributes].xfa.dataNode;
                                if (dataNode !== undefined) {
                                    if (dataNode === "dataGroup") this[_dataValue] = false;
                                    else if (dataNode === "dataValue") this[_dataValue] = true;
                                }
                            }
                        }
                        this[$consumed] = false;
                    }
                    [$toString](buf) {
                        const tagName = this[$nodeName];
                        if (tagName === "#text") {
                            buf.push((0, _core_utils.encodeToXmlString)(this[$content]));
                            return;
                        }
                        const prefix = this[$namespaceId] === NS_DATASETS ? "xfa:" : "";
                        buf.push(`<${prefix}${tagName}`);
                        for (const [name, value] of this[_attributes].entries())buf.push(` ${name}="${(0, _core_utils.encodeToXmlString)(value[$content])}"`);
                        if (this[_dataValue] !== null) {
                            if (this[_dataValue]) buf.push(` xfa:dataNode="dataValue"`);
                            else buf.push(` xfa:dataNode="dataGroup"`);
                        }
                        if (!this[$content] && this[_children].length === 0) {
                            buf.push("/>");
                            return;
                        }
                        buf.push(">");
                        if (this[$content]) {
                            if (typeof this[$content] === "string") buf.push((0, _core_utils.encodeToXmlString)(this[$content]));
                            else this[$content][$toString](buf);
                        } else for (const child of this[_children])child[$toString](buf);
                        buf.push(`</${prefix}${tagName}>`);
                    }
                    [$onChild](child) {
                        if (this[$content]) {
                            const node = new XmlObject(this[$namespaceId], "#text");
                            this[$appendChild](node);
                            node[$content] = this[$content];
                            this[$content] = "";
                        }
                        this[$appendChild](child);
                        return true;
                    }
                    [$onText](str) {
                        this[$content] += str;
                    }
                    [$finalize]() {
                        if (this[$content] && this[_children].length > 0) {
                            const node = new XmlObject(this[$namespaceId], "#text");
                            this[$appendChild](node);
                            node[$content] = this[$content];
                            delete this[$content];
                        }
                    }
                    [$toHTML]() {
                        if (this[$nodeName] === "#text") return _utils.HTMLResult.success({
                            name: "#text",
                            value: this[$content]
                        });
                        return _utils.HTMLResult.EMPTY;
                    }
                    [$getChildren](name = null) {
                        if (!name) return this[_children];
                        return this[_children].filter((c)=>c[$nodeName] === name);
                    }
                    [$getAttributes]() {
                        return this[_attributes];
                    }
                    [$getChildrenByClass](name) {
                        const value = this[_attributes].get(name);
                        if (value !== undefined) return value;
                        return this[$getChildren](name);
                    }
                    *[$getChildrenByNameIt](name, allTransparent) {
                        const value = this[_attributes].get(name);
                        if (value) yield value;
                        for (const child of this[_children]){
                            if (child[$nodeName] === name) yield child;
                            if (allTransparent) yield* child[$getChildrenByNameIt](name, allTransparent);
                        }
                    }
                    *[$getAttributeIt](name, skipConsumed) {
                        const value = this[_attributes].get(name);
                        if (value && (!skipConsumed || !value[$consumed])) yield value;
                        for (const child of this[_children])yield* child[$getAttributeIt](name, skipConsumed);
                    }
                    *[$getRealChildrenByNameIt](name, allTransparent, skipConsumed) {
                        for (const child of this[_children]){
                            if (child[$nodeName] === name && (!skipConsumed || !child[$consumed])) yield child;
                            if (allTransparent) yield* child[$getRealChildrenByNameIt](name, allTransparent, skipConsumed);
                        }
                    }
                    [$isDataValue]() {
                        if (this[_dataValue] === null) return this[_children].length === 0 || this[_children][0][$namespaceId] === _namespaces.NamespaceIds.xhtml.id;
                        return this[_dataValue];
                    }
                    [$getDataValue]() {
                        if (this[_dataValue] === null) {
                            if (this[_children].length === 0) return this[$content].trim();
                            if (this[_children][0][$namespaceId] === _namespaces.NamespaceIds.xhtml.id) return this[_children][0][$text]().trim();
                            return null;
                        }
                        return this[$content].trim();
                    }
                    [$setValue](value) {
                        value = value.value || "";
                        this[$content] = value.toString();
                    }
                    [$dump]() {
                        const dumped = Object.create(null);
                        if (this[$content]) dumped.$content = this[$content];
                        dumped.$name = this[$nodeName];
                        dumped.children = [];
                        for (const child of this[_children])dumped.children.push(child[$dump]());
                        dumped.attributes = Object.create(null);
                        for (const [name, value] of this[_attributes])dumped.attributes[name] = value[$content];
                        return dumped;
                    }
                }
                exports.XmlObject = XmlObject;
                class ContentObject extends XFAObject {
                    constructor(nsId, name){
                        super(nsId, name);
                        this[$content] = "";
                    }
                    [$onText](text) {
                        this[$content] += text;
                    }
                    [$finalize]() {}
                }
                exports.ContentObject = ContentObject;
                class OptionObject extends ContentObject {
                    constructor(nsId, name, options){
                        super(nsId, name);
                        this[_options] = options;
                    }
                    [$finalize]() {
                        this[$content] = (0, _utils.getKeyword)({
                            data: this[$content],
                            defaultValue: this[_options][0],
                            validate: (k)=>this[_options].includes(k)
                        });
                    }
                    [$clean](builder) {
                        super[$clean](builder);
                        delete this[_options];
                    }
                }
                exports.OptionObject = OptionObject;
                class StringObject extends ContentObject {
                    [$finalize]() {
                        this[$content] = this[$content].trim();
                    }
                }
                exports.StringObject = StringObject;
                class IntegerObject extends ContentObject {
                    constructor(nsId, name, defaultValue, validator){
                        super(nsId, name);
                        this[_defaultValue] = defaultValue;
                        this[_validator] = validator;
                    }
                    [$finalize]() {
                        this[$content] = (0, _utils.getInteger)({
                            data: this[$content],
                            defaultValue: this[_defaultValue],
                            validate: this[_validator]
                        });
                    }
                    [$clean](builder) {
                        super[$clean](builder);
                        delete this[_defaultValue];
                        delete this[_validator];
                    }
                }
                exports.IntegerObject = IntegerObject;
                class Option01 extends IntegerObject {
                    constructor(nsId, name){
                        super(nsId, name, 0, (n)=>n === 1);
                    }
                }
                exports.Option01 = Option01;
                class Option10 extends IntegerObject {
                    constructor(nsId, name){
                        super(nsId, name, 1, (n)=>n === 0);
                    }
                }
                exports.Option10 = Option10;
            /***/ },
            /* 76 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getBBox = getBBox;
                exports.getColor = getColor;
                exports.getFloat = getFloat;
                exports.getInteger = getInteger;
                exports.getKeyword = getKeyword;
                exports.getMeasurement = getMeasurement;
                exports.getRatio = getRatio;
                exports.getRelevant = getRelevant;
                exports.getStringOption = getStringOption;
                exports.stripQuotes = stripQuotes;
                exports.HTMLResult = void 0;
                var _util = __w_pdfjs_require__(2);
                const dimConverters = {
                    pt: (x)=>x,
                    cm: (x)=>x / 2.54 * 72,
                    mm: (x)=>x / 25.4 * 72,
                    in: (x)=>x * 72,
                    px: (x)=>x
                };
                const measurementPattern = /([+-]?[0-9]+\.?[0-9]*)(.*)/;
                function stripQuotes(str) {
                    if (str.startsWith("'") || str.startsWith('"')) return str.slice(1, str.length - 1);
                    return str;
                }
                function getInteger({ data: data , defaultValue: defaultValue , validate: validate  }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    const n = parseInt(data, 10);
                    if (!isNaN(n) && validate(n)) return n;
                    return defaultValue;
                }
                function getFloat({ data: data , defaultValue: defaultValue , validate: validate  }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    const n = parseFloat(data);
                    if (!isNaN(n) && validate(n)) return n;
                    return defaultValue;
                }
                function getKeyword({ data: data , defaultValue: defaultValue , validate: validate  }) {
                    if (!data) return defaultValue;
                    data = data.trim();
                    if (validate(data)) return data;
                    return defaultValue;
                }
                function getStringOption(data, options) {
                    return getKeyword({
                        data: data,
                        defaultValue: options[0],
                        validate: (k)=>options.includes(k)
                    });
                }
                function getMeasurement(str, def = "0") {
                    def = def || "0";
                    if (!str) return getMeasurement(def);
                    const match = str.trim().match(measurementPattern);
                    if (!match) return getMeasurement(def);
                    const [, valueStr, unit] = match;
                    const value = parseFloat(valueStr);
                    if (isNaN(value)) return getMeasurement(def);
                    if (value === 0) return 0;
                    const conv = dimConverters[unit];
                    if (conv) return conv(value);
                    return value;
                }
                function getRatio(data) {
                    if (!data) return {
                        num: 1,
                        den: 1
                    };
                    const ratio = data.trim().split(/\s*:\s*/).map((x)=>parseFloat(x)).filter((x)=>!isNaN(x));
                    if (ratio.length === 1) ratio.push(1);
                    if (ratio.length === 0) return {
                        num: 1,
                        den: 1
                    };
                    const [num, den] = ratio;
                    return {
                        num: num,
                        den: den
                    };
                }
                function getRelevant(data) {
                    if (!data) return [];
                    return data.trim().split(/\s+/).map((e)=>{
                        return {
                            excluded: e[0] === "-",
                            viewname: e.substring(1)
                        };
                    });
                }
                function getColor(data, def = [
                    0,
                    0,
                    0
                ]) {
                    let [r, g, b] = def;
                    if (!data) return {
                        r: r,
                        g: g,
                        b: b
                    };
                    const color = data.trim().split(/\s*,\s*/).map((c)=>Math.min(Math.max(0, parseInt(c.trim(), 10)), 255)).map((c)=>isNaN(c) ? 0 : c);
                    if (color.length < 3) return {
                        r: r,
                        g: g,
                        b: b
                    };
                    [r, g, b] = color;
                    return {
                        r: r,
                        g: g,
                        b: b
                    };
                }
                function getBBox(data) {
                    const def = -1;
                    if (!data) return {
                        x: def,
                        y: def,
                        width: def,
                        height: def
                    };
                    const bbox = data.trim().split(/\s*,\s*/).map((m)=>getMeasurement(m, "-1"));
                    if (bbox.length < 4 || bbox[2] < 0 || bbox[3] < 0) return {
                        x: def,
                        y: def,
                        width: def,
                        height: def
                    };
                    const [x, y, width, height] = bbox;
                    return {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                }
                class HTMLResult {
                    static get FAILURE() {
                        return (0, _util.shadow)(this, "FAILURE", new HTMLResult(false, null, null, null));
                    }
                    static get EMPTY() {
                        return (0, _util.shadow)(this, "EMPTY", new HTMLResult(true, null, null, null));
                    }
                    constructor(success, html, bbox, breakNode){
                        this.success = success;
                        this.html = html;
                        this.bbox = bbox;
                        this.breakNode = breakNode;
                    }
                    isBreak() {
                        return !!this.breakNode;
                    }
                    static breakNode(node) {
                        return new HTMLResult(false, null, null, node);
                    }
                    static success(html, bbox = null) {
                        return new HTMLResult(true, html, bbox, null);
                    }
                }
                exports.HTMLResult = HTMLResult;
            /***/ },
            /* 77 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NamespaceIds = exports.$buildXFAObject = void 0;
                const $buildXFAObject = Symbol();
                exports.$buildXFAObject = $buildXFAObject;
                const NamespaceIds = {
                    config: {
                        id: 0,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xci/")
                    },
                    connectionSet: {
                        id: 1,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
                    },
                    datasets: {
                        id: 2,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-data/")
                    },
                    form: {
                        id: 3,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-form/")
                    },
                    localeSet: {
                        id: 4,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
                    },
                    pdf: {
                        id: 5,
                        check: (ns)=>ns === "http://ns.adobe.com/xdp/pdf/"
                    },
                    signature: {
                        id: 6,
                        check: (ns)=>ns === "http://www.w3.org/2000/09/xmldsig#"
                    },
                    sourceSet: {
                        id: 7,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-source-set/")
                    },
                    stylesheet: {
                        id: 8,
                        check: (ns)=>ns === "http://www.w3.org/1999/XSL/Transform"
                    },
                    template: {
                        id: 9,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xfa-template/")
                    },
                    xdc: {
                        id: 10,
                        check: (ns)=>ns.startsWith("http://www.xfa.org/schema/xdc/")
                    },
                    xdp: {
                        id: 11,
                        check: (ns)=>ns === "http://ns.adobe.com/xdp/"
                    },
                    xfdf: {
                        id: 12,
                        check: (ns)=>ns === "http://ns.adobe.com/xfdf/"
                    },
                    xhtml: {
                        id: 13,
                        check: (ns)=>ns === "http://www.w3.org/1999/xhtml"
                    },
                    xmpmeta: {
                        id: 14,
                        check: (ns)=>ns === "http://ns.adobe.com/xmpmeta/"
                    }
                };
                exports.NamespaceIds = NamespaceIds;
            /***/ },
            /* 78 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createDataNode = createDataNode;
                exports.searchNode = searchNode;
                var _xfa_object = __w_pdfjs_require__(75);
                var _util = __w_pdfjs_require__(2);
                const namePattern = /^[^.[]+/;
                const indexPattern = /^[^\]]+/;
                const operators = {
                    dot: 0,
                    dotDot: 1,
                    dotHash: 2,
                    dotBracket: 3,
                    dotParen: 4
                };
                const shortcuts = new Map([
                    [
                        "$data",
                        (root, current)=>root.datasets.data
                    ],
                    [
                        "$template",
                        (root, current)=>root.template
                    ],
                    [
                        "$connectionSet",
                        (root, current)=>root.connectionSet
                    ],
                    [
                        "$form",
                        (root, current)=>root.form
                    ],
                    [
                        "$layout",
                        (root, current)=>root.layout
                    ],
                    [
                        "$host",
                        (root, current)=>root.host
                    ],
                    [
                        "$dataWindow",
                        (root, current)=>root.dataWindow
                    ],
                    [
                        "$event",
                        (root, current)=>root.event
                    ],
                    [
                        "!",
                        (root, current)=>root.datasets
                    ],
                    [
                        "$xfa",
                        (root, current)=>root
                    ],
                    [
                        "xfa",
                        (root, current)=>root
                    ],
                    [
                        "$",
                        (root, current)=>current
                    ]
                ]);
                const somCache = new WeakMap();
                function parseIndex(index) {
                    index = index.trim();
                    if (index === "*") return Infinity;
                    return parseInt(index, 10) || 0;
                }
                function parseExpression(expr, dotDotAllowed, noExpr = true) {
                    let match = expr.match(namePattern);
                    if (!match) return null;
                    let [name] = match;
                    const parsed = [
                        {
                            name: name,
                            cacheName: "." + name,
                            index: 0,
                            js: null,
                            formCalc: null,
                            operator: operators.dot
                        }
                    ];
                    let pos = name.length;
                    while(pos < expr.length){
                        const spos = pos;
                        const char = expr.charAt(pos++);
                        if (char === "[") {
                            match = expr.slice(pos).match(indexPattern);
                            if (!match) {
                                (0, _util.warn)("XFA - Invalid index in SOM expression");
                                return null;
                            }
                            parsed[parsed.length - 1].index = parseIndex(match[0]);
                            pos += match[0].length + 1;
                            continue;
                        }
                        let operator;
                        switch(expr.charAt(pos)){
                            case ".":
                                if (!dotDotAllowed) return null;
                                pos++;
                                operator = operators.dotDot;
                                break;
                            case "#":
                                pos++;
                                operator = operators.dotHash;
                                break;
                            case "[":
                                if (noExpr) {
                                    (0, _util.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now.");
                                    return null;
                                }
                                operator = operators.dotBracket;
                                break;
                            case "(":
                                if (noExpr) {
                                    (0, _util.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now.");
                                    return null;
                                }
                                operator = operators.dotParen;
                                break;
                            default:
                                operator = operators.dot;
                                break;
                        }
                        match = expr.slice(pos).match(namePattern);
                        if (!match) break;
                        [name] = match;
                        pos += name.length;
                        parsed.push({
                            name: name,
                            cacheName: expr.slice(spos, pos),
                            operator: operator,
                            index: 0,
                            js: null,
                            formCalc: null
                        });
                    }
                    return parsed;
                }
                function searchNode(root, container, expr, dotDotAllowed = true, useCache = true) {
                    const parsed = parseExpression(expr, dotDotAllowed);
                    if (!parsed) return null;
                    const fn = shortcuts.get(parsed[0].name);
                    let i = 0;
                    let isQualified;
                    if (fn) {
                        isQualified = true;
                        root = [
                            fn(root, container)
                        ];
                        i = 1;
                    } else {
                        isQualified = container === null;
                        root = [
                            container || root
                        ];
                    }
                    for(let ii = parsed.length; i < ii; i++){
                        const { name: name , cacheName: cacheName , operator: operator , index: index  } = parsed[i];
                        const nodes = [];
                        for (const node of root){
                            if (!(node instanceof _xfa_object.XFAObject)) continue;
                            let children, cached;
                            if (useCache) {
                                cached = somCache.get(node);
                                if (!cached) {
                                    cached = new Map();
                                    somCache.set(node, cached);
                                }
                                children = cached.get(cacheName);
                            }
                            if (!children) {
                                switch(operator){
                                    case operators.dot:
                                        children = node[_xfa_object.$getChildrenByName](name, false);
                                        break;
                                    case operators.dotDot:
                                        children = node[_xfa_object.$getChildrenByName](name, true);
                                        break;
                                    case operators.dotHash:
                                        children = node[_xfa_object.$getChildrenByClass](name);
                                        if (children instanceof _xfa_object.XFAObjectArray) children = children.children;
                                        else children = [
                                            children
                                        ];
                                        break;
                                    default:
                                        break;
                                }
                                if (useCache) cached.set(cacheName, children);
                            }
                            if (children.length > 0) nodes.push(children);
                        }
                        if (nodes.length === 0 && !isQualified && i === 0) {
                            const parent = container[_xfa_object.$getParent]();
                            container = parent;
                            if (!container) return null;
                            i = -1;
                            root = [
                                container
                            ];
                            continue;
                        }
                        if (isFinite(index)) root = nodes.filter((node)=>index < node.length).map((node)=>node[index]);
                        else root = nodes.reduce((acc, node)=>acc.concat(node), []);
                    }
                    if (root.length === 0) return null;
                    return root;
                }
                function createNodes(root, path) {
                    let node = null;
                    for (const { name: name , index: index  } of path){
                        for(let i = 0, ii = !isFinite(index) ? 0 : index; i <= ii; i++){
                            node = new _xfa_object.XmlObject(root[_xfa_object.$namespaceId], name);
                            root[_xfa_object.$appendChild](node);
                        }
                        root = node;
                    }
                    return node;
                }
                function createDataNode(root, container, expr) {
                    const parsed = parseExpression(expr);
                    if (!parsed) return null;
                    if (parsed.some((x)=>x.operator === operators.dotDot)) return null;
                    const fn = shortcuts.get(parsed[0].name);
                    let i = 0;
                    if (fn) {
                        root = fn(root, container);
                        i = 1;
                    } else root = container || root;
                    for(let ii = parsed.length; i < ii; i++){
                        const { name: name , operator: operator , index: index  } = parsed[i];
                        if (!isFinite(index)) {
                            parsed[i].index = 0;
                            return createNodes(root, parsed.slice(i));
                        }
                        let children;
                        switch(operator){
                            case operators.dot:
                                children = root[_xfa_object.$getChildrenByName](name, false);
                                break;
                            case operators.dotDot:
                                children = root[_xfa_object.$getChildrenByName](name, true);
                                break;
                            case operators.dotHash:
                                children = root[_xfa_object.$getChildrenByClass](name);
                                if (children instanceof _xfa_object.XFAObjectArray) children = children.children;
                                else children = [
                                    children
                                ];
                                break;
                            default:
                                break;
                        }
                        if (children.length === 0) return createNodes(root, parsed.slice(i));
                        if (index < children.length) {
                            const child = children[index];
                            if (!(child instanceof _xfa_object.XFAObject)) {
                                (0, _util.warn)(`XFA - Cannot create a node.`);
                                return null;
                            }
                            root = child;
                        } else {
                            parsed[i].index = index - children.length;
                            return createNodes(root, parsed.slice(i));
                        }
                    }
                    return null;
                }
            /***/ },
            /* 79 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Binder = void 0;
                var _xfa_object = __w_pdfjs_require__(75);
                var _template = __w_pdfjs_require__(80);
                var _som = __w_pdfjs_require__(78);
                var _namespaces = __w_pdfjs_require__(77);
                var _util = __w_pdfjs_require__(2);
                function createText(content) {
                    const node = new _template.Text({});
                    node[_xfa_object.$content] = content;
                    return node;
                }
                class Binder {
                    constructor(root){
                        this.root = root;
                        this.datasets = root.datasets;
                        if (root.datasets && root.datasets.data) this.data = root.datasets.data;
                        else this.data = new _xfa_object.XmlObject(_namespaces.NamespaceIds.datasets.id, "data");
                        this.emptyMerge = this.data[_xfa_object.$getChildren]().length === 0;
                        this.root.form = this.form = root.template[_xfa_object.$clone]();
                    }
                    _isConsumeData() {
                        return !this.emptyMerge && this._mergeMode;
                    }
                    _isMatchTemplate() {
                        return !this._isConsumeData();
                    }
                    bind() {
                        this._bindElement(this.form, this.data);
                        return this.form;
                    }
                    getData() {
                        return this.data;
                    }
                    _bindValue(formNode, data, picture) {
                        formNode[_xfa_object.$data] = data;
                        if (formNode[_xfa_object.$hasSettableValue]()) {
                            if (data[_xfa_object.$isDataValue]()) {
                                const value = data[_xfa_object.$getDataValue]();
                                formNode[_xfa_object.$setValue](createText(value));
                            } else if (formNode instanceof _template.Field && formNode.ui && formNode.ui.choiceList && formNode.ui.choiceList.open === "multiSelect") {
                                const value = data[_xfa_object.$getChildren]().map((child)=>child[_xfa_object.$content].trim()).join("\n");
                                formNode[_xfa_object.$setValue](createText(value));
                            } else if (this._isConsumeData()) (0, _util.warn)(`XFA - Nodes haven't the same type.`);
                        } else if (!data[_xfa_object.$isDataValue]() || this._isMatchTemplate()) this._bindElement(formNode, data);
                        else (0, _util.warn)(`XFA - Nodes haven't the same type.`);
                    }
                    _findDataByNameToConsume(name, isValue, dataNode, global) {
                        if (!name) return null;
                        let generator, match;
                        for(let i = 0; i < 3; i++){
                            generator = dataNode[_xfa_object.$getRealChildrenByNameIt](name, false, true);
                            while(true){
                                match = generator.next().value;
                                if (!match) break;
                                if (isValue === match[_xfa_object.$isDataValue]()) return match;
                            }
                            if (dataNode[_xfa_object.$namespaceId] === _namespaces.NamespaceIds.datasets.id && dataNode[_xfa_object.$nodeName] === "data") break;
                            dataNode = dataNode[_xfa_object.$getParent]();
                        }
                        if (!global) return null;
                        generator = this.data[_xfa_object.$getRealChildrenByNameIt](name, true, false);
                        match = generator.next().value;
                        if (match) return match;
                        generator = this.data[_xfa_object.$getAttributeIt](name, true);
                        match = generator.next().value;
                        if (match && match[_xfa_object.$isDataValue]()) return match;
                        return null;
                    }
                    _setProperties(formNode, dataNode) {
                        if (!formNode.hasOwnProperty("setProperty")) return;
                        for (const { ref: ref , target: target , connection: connection  } of formNode.setProperty.children){
                            if (connection) continue;
                            if (!ref) continue;
                            const nodes = (0, _som.searchNode)(this.root, dataNode, ref, false, false);
                            if (!nodes) {
                                (0, _util.warn)(`XFA - Invalid reference: ${ref}.`);
                                continue;
                            }
                            const [node] = nodes;
                            if (!node[_xfa_object.$isDescendent](this.data)) {
                                (0, _util.warn)(`XFA - Invalid node: must be a data node.`);
                                continue;
                            }
                            const targetNodes = (0, _som.searchNode)(this.root, formNode, target, false, false);
                            if (!targetNodes) {
                                (0, _util.warn)(`XFA - Invalid target: ${target}.`);
                                continue;
                            }
                            const [targetNode] = targetNodes;
                            if (!targetNode[_xfa_object.$isDescendent](formNode)) {
                                (0, _util.warn)(`XFA - Invalid target: must be a property or subproperty.`);
                                continue;
                            }
                            const targetParent = targetNode[_xfa_object.$getParent]();
                            if (targetNode instanceof _template.SetProperty || targetParent instanceof _template.SetProperty) {
                                (0, _util.warn)(`XFA - Invalid target: cannot be a setProperty or one of its properties.`);
                                continue;
                            }
                            if (targetNode instanceof _template.BindItems || targetParent instanceof _template.BindItems) {
                                (0, _util.warn)(`XFA - Invalid target: cannot be a bindItems or one of its properties.`);
                                continue;
                            }
                            const content = node[_xfa_object.$text]();
                            const name = targetNode[_xfa_object.$nodeName];
                            if (targetNode instanceof _xfa_object.XFAAttribute) {
                                const attrs = Object.create(null);
                                attrs[name] = content;
                                const obj = Reflect.construct(Object.getPrototypeOf(targetParent).constructor, [
                                    attrs
                                ]);
                                targetParent[name] = obj[name];
                                continue;
                            }
                            if (!targetNode.hasOwnProperty(_xfa_object.$content)) {
                                (0, _util.warn)(`XFA - Invalid node to use in setProperty`);
                                continue;
                            }
                            targetNode[_xfa_object.$data] = node;
                            targetNode[_xfa_object.$content] = content;
                            targetNode[_xfa_object.$finalize]();
                        }
                    }
                    _bindItems(formNode, dataNode) {
                        if (!formNode.hasOwnProperty("items") || !formNode.hasOwnProperty("bindItems") || formNode.bindItems.isEmpty()) return;
                        for (const item of formNode.items.children)formNode[_xfa_object.$removeChild](item);
                        formNode.items.clear();
                        const labels = new _template.Items({});
                        const values = new _template.Items({});
                        formNode[_xfa_object.$appendChild](labels);
                        formNode.items.push(labels);
                        formNode[_xfa_object.$appendChild](values);
                        formNode.items.push(values);
                        for (const { ref: ref , labelRef: labelRef , valueRef: valueRef , connection: connection  } of formNode.bindItems.children){
                            if (connection) continue;
                            if (!ref) continue;
                            const nodes = (0, _som.searchNode)(this.root, dataNode, ref, false, false);
                            if (!nodes) {
                                (0, _util.warn)(`XFA - Invalid reference: ${ref}.`);
                                continue;
                            }
                            for (const node of nodes){
                                if (!node[_xfa_object.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid ref (${ref}): must be a datasets child.`);
                                    continue;
                                }
                                const labelNodes = (0, _som.searchNode)(this.root, node, labelRef, true, false);
                                if (!labelNodes) {
                                    (0, _util.warn)(`XFA - Invalid label: ${labelRef}.`);
                                    continue;
                                }
                                const [labelNode] = labelNodes;
                                if (!labelNode[_xfa_object.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid label: must be a datasets child.`);
                                    continue;
                                }
                                const valueNodes = (0, _som.searchNode)(this.root, node, valueRef, true, false);
                                if (!valueNodes) {
                                    (0, _util.warn)(`XFA - Invalid value: ${valueRef}.`);
                                    continue;
                                }
                                const [valueNode] = valueNodes;
                                if (!valueNode[_xfa_object.$isDescendent](this.datasets)) {
                                    (0, _util.warn)(`XFA - Invalid value: must be a datasets child.`);
                                    continue;
                                }
                                const label = createText(labelNode[_xfa_object.$text]());
                                const value = createText(valueNode[_xfa_object.$text]());
                                labels[_xfa_object.$appendChild](label);
                                labels.text.push(label);
                                values[_xfa_object.$appendChild](value);
                                values.text.push(value);
                            }
                        }
                    }
                    _bindOccurrences(formNode, matches, picture) {
                        let baseClone;
                        if (matches.length > 1) baseClone = formNode[_xfa_object.$clone]();
                        this._bindValue(formNode, matches[0], picture);
                        this._setProperties(formNode, matches[0]);
                        this._bindItems(formNode, matches[0]);
                        if (matches.length === 1) return;
                        const parent = formNode[_xfa_object.$getParent]();
                        const name = formNode[_xfa_object.$nodeName];
                        const pos = parent[_xfa_object.$indexOf](formNode);
                        for(let i = 1, ii = matches.length; i < ii; i++){
                            const match = matches[i];
                            const clone = baseClone[_xfa_object.$clone]();
                            clone.occur.min = 1;
                            clone.occur.max = 1;
                            clone.occur.initial = 1;
                            parent[name].push(clone);
                            parent[_xfa_object.$insertAt](pos + i, clone);
                            this._bindValue(clone, match, picture);
                            this._setProperties(clone, match);
                            this._bindItems(clone, match);
                        }
                    }
                    _createOccurrences(formNode) {
                        if (!this.emptyMerge) return;
                        const { occur: occur  } = formNode;
                        if (!occur || occur.initial <= 1) return;
                        const parent = formNode[_xfa_object.$getParent]();
                        const name = formNode[_xfa_object.$nodeName];
                        for(let i = 0, ii = occur.initial; i < ii; i++){
                            const clone = formNode[_xfa_object.$clone]();
                            clone.occur.min = 1;
                            clone.occur.max = 1;
                            clone.occur.initial = 1;
                            parent[name].push(clone);
                            parent[_xfa_object.$appendChild](clone);
                        }
                    }
                    _getOccurInfo(formNode) {
                        const { occur: occur  } = formNode;
                        const dataName = formNode.name;
                        if (!occur || !dataName) return [
                            1,
                            1
                        ];
                        const max = occur.max === -1 ? Infinity : occur.max;
                        return [
                            occur.min,
                            max
                        ];
                    }
                    _bindElement(formNode, dataNode) {
                        const uselessNodes = [];
                        this._createOccurrences(formNode);
                        for (const child of formNode[_xfa_object.$getChildren]()){
                            if (child[_xfa_object.$data]) continue;
                            if (this._mergeMode === undefined && child[_xfa_object.$nodeName] === "subform") {
                                this._mergeMode = child.mergeMode === "consumeData";
                                const dataChildren = dataNode[_xfa_object.$getChildren]();
                                if (dataChildren.length > 0) this._bindOccurrences(child, [
                                    dataChildren[0]
                                ], null);
                                else if (this.emptyMerge) {
                                    const dataChild = child[_xfa_object.$data] = new _xfa_object.XmlObject(dataNode[_xfa_object.$namespaceId], child.name || "root");
                                    dataNode[_xfa_object.$appendChild](dataChild);
                                    this._bindElement(child, dataChild);
                                }
                                continue;
                            }
                            if (!child[_xfa_object.$isBindable]()) continue;
                            let global = false;
                            let picture = null;
                            let ref = null;
                            let match = null;
                            if (child.bind) {
                                switch(child.bind.match){
                                    case "none":
                                        this._bindElement(child, dataNode);
                                        continue;
                                    case "global":
                                        global = true;
                                        break;
                                    case "dataRef":
                                        if (!child.bind.ref) {
                                            (0, _util.warn)(`XFA - ref is empty in node ${child[_xfa_object.$nodeName]}.`);
                                            this._bindElement(child, dataNode);
                                            continue;
                                        }
                                        ref = child.bind.ref;
                                        break;
                                    default:
                                        break;
                                }
                                if (child.bind.picture) picture = child.bind.picture[_xfa_object.$content];
                            }
                            const [min, max] = this._getOccurInfo(child);
                            if (ref) {
                                match = (0, _som.searchNode)(this.root, dataNode, ref, true, false);
                                if (match === null) {
                                    match = (0, _som.createDataNode)(this.data, dataNode, ref);
                                    if (!match) continue;
                                    if (this._isConsumeData()) match[_xfa_object.$consumed] = true;
                                    this._bindElement(child, match);
                                    continue;
                                } else {
                                    if (this._isConsumeData()) match = match.filter((node)=>!node[_xfa_object.$consumed]);
                                    if (match.length > max) match = match.slice(0, max);
                                    else if (match.length === 0) match = null;
                                    if (match && this._isConsumeData()) match.forEach((node)=>{
                                        node[_xfa_object.$consumed] = true;
                                    });
                                }
                            } else {
                                if (!child.name) {
                                    this._bindElement(child, dataNode);
                                    continue;
                                }
                                if (this._isConsumeData()) {
                                    const matches = [];
                                    while(matches.length < max){
                                        const found = this._findDataByNameToConsume(child.name, child[_xfa_object.$hasSettableValue](), dataNode, global);
                                        if (!found) break;
                                        found[_xfa_object.$consumed] = true;
                                        matches.push(found);
                                    }
                                    match = matches.length > 0 ? matches : null;
                                } else {
                                    match = dataNode[_xfa_object.$getRealChildrenByNameIt](child.name, false, this.emptyMerge).next().value;
                                    if (!match) {
                                        match = child[_xfa_object.$data] = new _xfa_object.XmlObject(dataNode[_xfa_object.$namespaceId], child.name);
                                        if (this.emptyMerge) match[_xfa_object.$consumed] = true;
                                        dataNode[_xfa_object.$appendChild](match);
                                        this._setProperties(child, match);
                                        this._bindItems(child, match);
                                        this._bindElement(child, match);
                                        continue;
                                    }
                                    if (this.emptyMerge) match[_xfa_object.$consumed] = true;
                                    match = [
                                        match
                                    ];
                                }
                            }
                            if (match) {
                                if (match.length < min) {
                                    (0, _util.warn)(`XFA - Must have at least ${min} occurrences: ${formNode[_xfa_object.$nodeName]}.`);
                                    continue;
                                }
                                this._bindOccurrences(child, match, picture);
                            } else if (min > 0) {
                                this._setProperties(child, dataNode);
                                this._bindItems(child, dataNode);
                                this._bindElement(child, dataNode);
                            } else uselessNodes.push(child);
                        }
                        uselessNodes.forEach((node)=>node[_xfa_object.$getParent]()[_xfa_object.$removeChild](node));
                    }
                }
                exports.Binder = Binder;
            /***/ },
            /* 80 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Value = exports.Text = exports.TemplateNamespace = exports.Template = exports.SetProperty = exports.Items = exports.Field = exports.BindItems = void 0;
                var _xfa_object = __w_pdfjs_require__(75);
                var _namespaces = __w_pdfjs_require__(77);
                var _layout = __w_pdfjs_require__(81);
                var _html_utils = __w_pdfjs_require__(82);
                var _utils = __w_pdfjs_require__(76);
                var _util = __w_pdfjs_require__(2);
                var _som = __w_pdfjs_require__(78);
                const TEMPLATE_NS_ID = _namespaces.NamespaceIds.template.id;
                const SVG_NS = "http://www.w3.org/2000/svg";
                const MAX_ATTEMPTS_FOR_LRTB_LAYOUT = 2;
                const MAX_EMPTY_PAGES = 3;
                function hasMargin(node) {
                    return node.margin && (node.margin.topInset || node.margin.rightInset || node.margin.bottomInset || node.margin.leftInset);
                }
                function _setValue(templateNode, value) {
                    if (!templateNode.value) {
                        const nodeValue = new Value({});
                        templateNode[_xfa_object.$appendChild](nodeValue);
                        templateNode.value = nodeValue;
                    }
                    templateNode.value[_xfa_object.$setValue](value);
                }
                function* getContainedChildren(node) {
                    for (const child of node[_xfa_object.$getChildren]()){
                        if (child instanceof SubformSet) {
                            yield* child[_xfa_object.$getContainedChildren]();
                            continue;
                        }
                        yield child;
                    }
                }
                function setTabIndex(node) {
                    while(node){
                        if (!node.traversal || node[_xfa_object.$tabIndex]) return;
                        let next = null;
                        for (const child of node.traversal[_xfa_object.$getChildren]())if (child.operation === "next") {
                            next = child;
                            break;
                        }
                        if (!next || !next.ref) return;
                        const root = node[_xfa_object.$getTemplateRoot]();
                        node[_xfa_object.$tabIndex] = ++root[_xfa_object.$tabIndex];
                        const ref = root[_xfa_object.$searchNode](next.ref, node);
                        if (!ref) return;
                        node = ref[0];
                    }
                }
                function valueToHtml(value) {
                    return _utils.HTMLResult.success({
                        name: "div",
                        attributes: {
                            class: [
                                "xfaRich"
                            ],
                            style: Object.create(null)
                        },
                        children: [
                            {
                                name: "span",
                                attributes: {
                                    style: Object.create(null)
                                },
                                value: value
                            }
                        ]
                    });
                }
                function setFirstUnsplittable(node) {
                    const root = node[_xfa_object.$getTemplateRoot]();
                    if (root[_xfa_object.$extra].firstUnsplittable === null) {
                        root[_xfa_object.$extra].firstUnsplittable = node;
                        root[_xfa_object.$extra].noLayoutFailure = true;
                    }
                }
                function unsetFirstUnsplittable(node) {
                    const root = node[_xfa_object.$getTemplateRoot]();
                    if (root[_xfa_object.$extra].firstUnsplittable === node) root[_xfa_object.$extra].noLayoutFailure = false;
                }
                function handleBreak(node) {
                    if (node[_xfa_object.$extra]) return false;
                    node[_xfa_object.$extra] = Object.create(null);
                    if (node.targetType === "auto") return false;
                    const root = node[_xfa_object.$getTemplateRoot]();
                    let target = null;
                    if (node.target) {
                        target = root[_xfa_object.$searchNode](node.target, node[_xfa_object.$getParent]());
                        if (!target) return false;
                        target = target[0];
                    }
                    const { currentPageArea: currentPageArea , currentContentArea: currentContentArea  } = root[_xfa_object.$extra];
                    if (node.targetType === "pageArea") {
                        if (!(target instanceof PageArea)) target = null;
                        if (node.startNew) {
                            node[_xfa_object.$extra].target = target || currentPageArea;
                            return true;
                        } else if (target && target !== currentPageArea) {
                            node[_xfa_object.$extra].target = target;
                            return true;
                        }
                        return false;
                    }
                    if (!(target instanceof ContentArea)) target = null;
                    const pageArea = target && target[_xfa_object.$getParent]();
                    let index;
                    if (node.startNew) {
                        if (target) {
                            const contentAreas = pageArea.contentArea.children;
                            index = contentAreas.findIndex((e)=>e === target) - 1;
                        } else index = currentPageArea.contentArea.children.findIndex((e)=>e === currentContentArea);
                    } else if (target && target !== currentContentArea) {
                        const contentAreas = pageArea.contentArea.children;
                        index = contentAreas.findIndex((e)=>e === target) - 1;
                    } else return false;
                    node[_xfa_object.$extra].target = pageArea === currentPageArea ? null : pageArea;
                    node[_xfa_object.$extra].index = index;
                    return true;
                }
                function handleOverflow(node, extraNode, space) {
                    const root = node[_xfa_object.$getTemplateRoot]();
                    const saved = root[_xfa_object.$extra].noLayoutFailure;
                    const savedMethod = extraNode[_xfa_object.$getSubformParent];
                    extraNode[_xfa_object.$getSubformParent] = ()=>node;
                    root[_xfa_object.$extra].noLayoutFailure = true;
                    const res = extraNode[_xfa_object.$toHTML](space);
                    node[_xfa_object.$addHTML](res.html, res.bbox);
                    root[_xfa_object.$extra].noLayoutFailure = saved;
                    extraNode[_xfa_object.$getSubformParent] = savedMethod;
                }
                class AppearanceFilter extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "appearanceFilter");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Arc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "arc", true);
                        this.circular = (0, _utils.getInteger)({
                            data: attributes.circular,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.startAngle = (0, _utils.getFloat)({
                            data: attributes.startAngle,
                            defaultValue: 0,
                            validate: (x)=>true
                        });
                        this.sweepAngle = (0, _utils.getFloat)({
                            data: attributes.sweepAngle,
                            defaultValue: 360,
                            validate: (x)=>true
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.edge = null;
                        this.fill = null;
                    }
                    [_xfa_object.$toHTML]() {
                        const edge = this.edge ? this.edge : new Edge({});
                        const edgeStyle = edge[_xfa_object.$toStyle]();
                        const style = Object.create(null);
                        if (this.fill && this.fill.presence === "visible") Object.assign(style, this.fill[_xfa_object.$toStyle]());
                        else style.fill = "transparent";
                        style.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                        style.stroke = edgeStyle.color;
                        let arc;
                        const attributes = {
                            xmlns: SVG_NS,
                            style: {
                                width: "100%",
                                height: "100%",
                                overflow: "visible"
                            }
                        };
                        if (this.startAngle === 0 && this.sweepAngle === 360) arc = {
                            name: "ellipse",
                            attributes: {
                                xmlns: SVG_NS,
                                cx: "50%",
                                cy: "50%",
                                rx: "50%",
                                ry: "50%",
                                style: style
                            }
                        };
                        else {
                            const startAngle = this.startAngle * Math.PI / 180;
                            const sweepAngle = this.sweepAngle * Math.PI / 180;
                            const largeArc = this.sweepAngle - this.startAngle > 180 ? 1 : 0;
                            const [x1, y1, x2, y2] = [
                                50 * (1 + Math.cos(startAngle)),
                                50 * (1 - Math.sin(startAngle)),
                                50 * (1 + Math.cos(sweepAngle)),
                                50 * (1 - Math.sin(sweepAngle))
                            ];
                            arc = {
                                name: "path",
                                attributes: {
                                    xmlns: SVG_NS,
                                    d: `M ${x1} ${y1} A 50 50 0 ${largeArc} 0 ${x2} ${y2}`,
                                    vectorEffect: "non-scaling-stroke",
                                    style: style
                                }
                            };
                            Object.assign(attributes, {
                                viewBox: "0 0 100 100",
                                preserveAspectRatio: "none"
                            });
                        }
                        const svg = {
                            name: "svg",
                            children: [
                                arc
                            ],
                            attributes: attributes
                        };
                        const parent = this[_xfa_object.$getParent]()[_xfa_object.$getParent]();
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class Area extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "area", true);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    *[_xfa_object.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_xfa_object.$isTransparent]() {
                        return true;
                    }
                    [_xfa_object.$addHTML](html, bbox) {
                        const [x, y, w, h] = bbox;
                        this[_xfa_object.$extra].width = Math.max(this[_xfa_object.$extra].width, x + w);
                        this[_xfa_object.$extra].height = Math.max(this[_xfa_object.$extra].height, y + h);
                        this[_xfa_object.$extra].children.push(html);
                    }
                    [_xfa_object.$getAvailableSpace]() {
                        return this[_xfa_object.$extra].availableSpace;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "position");
                        const attributes = {
                            style: style,
                            id: this[_xfa_object.$uid],
                            class: [
                                "xfaArea"
                            ]
                        };
                        if ((0, _html_utils.isPrintOnly)(this)) attributes.class.push("xfaPrintOnly");
                        if (this.name) attributes.xfaName = this.name;
                        const children = [];
                        this[_xfa_object.$extra] = {
                            children: children,
                            width: 0,
                            height: 0,
                            availableSpace: availableSpace
                        };
                        const result = this[_xfa_object.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "exclGroup",
                                "subform",
                                "subformSet"
                            ]),
                            include: true
                        });
                        if (!result.success) {
                            if (result.isBreak()) return result;
                            delete this[_xfa_object.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        style.width = (0, _html_utils.measureToString)(this[_xfa_object.$extra].width);
                        style.height = (0, _html_utils.measureToString)(this[_xfa_object.$extra].height);
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        const bbox = [
                            this.x,
                            this.y,
                            this[_xfa_object.$extra].width,
                            this[_xfa_object.$extra].height
                        ];
                        delete this[_xfa_object.$extra];
                        return _utils.HTMLResult.success(html, bbox);
                    }
                }
                class Assist extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "assist", true);
                        this.id = attributes.id || "";
                        this.role = attributes.role || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.speak = null;
                        this.toolTip = null;
                    }
                    [_xfa_object.$toHTML]() {
                        return this.toolTip && this.toolTip[_xfa_object.$content] ? this.toolTip[_xfa_object.$content] : null;
                    }
                }
                class Barcode extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "barcode", true);
                        this.charEncoding = (0, _utils.getKeyword)({
                            data: attributes.charEncoding ? attributes.charEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (k)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(k) || k.match(/iso-8859-[0-9]{2}/)
                        });
                        this.checksum = (0, _utils.getStringOption)(attributes.checksum, [
                            "none",
                            "1mod10",
                            "1mod10_1mod11",
                            "2mod10",
                            "auto"
                        ]);
                        this.dataColumnCount = (0, _utils.getInteger)({
                            data: attributes.dataColumnCount,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.dataLength = (0, _utils.getInteger)({
                            data: attributes.dataLength,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.dataPrep = (0, _utils.getStringOption)(attributes.dataPrep, [
                            "none",
                            "flateCompress"
                        ]);
                        this.dataRowCount = (0, _utils.getInteger)({
                            data: attributes.dataRowCount,
                            defaultValue: -1,
                            validate: (x)=>x >= 0
                        });
                        this.endChar = attributes.endChar || "";
                        this.errorCorrectionLevel = (0, _utils.getInteger)({
                            data: attributes.errorCorrectionLevel,
                            defaultValue: -1,
                            validate: (x)=>x >= 0 && x <= 8
                        });
                        this.id = attributes.id || "";
                        this.moduleHeight = (0, _utils.getMeasurement)(attributes.moduleHeight, "5mm");
                        this.moduleWidth = (0, _utils.getMeasurement)(attributes.moduleWidth, "0.25mm");
                        this.printCheckDigit = (0, _utils.getInteger)({
                            data: attributes.printCheckDigit,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.rowColumnRatio = (0, _utils.getRatio)(attributes.rowColumnRatio);
                        this.startChar = attributes.startChar || "";
                        this.textLocation = (0, _utils.getStringOption)(attributes.textLocation, [
                            "below",
                            "above",
                            "aboveEmbedded",
                            "belowEmbedded",
                            "none"
                        ]);
                        this.truncate = (0, _utils.getInteger)({
                            data: attributes.truncate,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.type = (0, _utils.getStringOption)(attributes.type ? attributes.type.toLowerCase() : "", [
                            "aztec",
                            "codabar",
                            "code2of5industrial",
                            "code2of5interleaved",
                            "code2of5matrix",
                            "code2of5standard",
                            "code3of9",
                            "code3of9extended",
                            "code11",
                            "code49",
                            "code93",
                            "code128",
                            "code128a",
                            "code128b",
                            "code128c",
                            "code128sscc",
                            "datamatrix",
                            "ean8",
                            "ean8add2",
                            "ean8add5",
                            "ean13",
                            "ean13add2",
                            "ean13add5",
                            "ean13pwcd",
                            "fim",
                            "logmars",
                            "maxicode",
                            "msi",
                            "pdf417",
                            "pdf417macro",
                            "plessey",
                            "postauscust2",
                            "postauscust3",
                            "postausreplypaid",
                            "postausstandard",
                            "postukrm4scc",
                            "postusdpbc",
                            "postusimb",
                            "postusstandard",
                            "postus5zip",
                            "qrcode",
                            "rfid",
                            "rss14",
                            "rss14expanded",
                            "rss14limited",
                            "rss14stacked",
                            "rss14stackedomni",
                            "rss14truncated",
                            "telepen",
                            "ucc128",
                            "ucc128random",
                            "ucc128sscc",
                            "upca",
                            "upcaadd2",
                            "upcaadd5",
                            "upcapwcd",
                            "upce",
                            "upceadd2",
                            "upceadd5",
                            "upcean2",
                            "upcean5",
                            "upsmaxicode"
                        ]);
                        this.upsMode = (0, _utils.getStringOption)(attributes.upsMode, [
                            "usCarrier",
                            "internationalCarrier",
                            "secureSymbol",
                            "standardSymbol"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.wideNarrowRatio = (0, _utils.getRatio)(attributes.wideNarrowRatio);
                        this.encrypt = null;
                        this.extras = null;
                    }
                }
                class Bind extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bind", true);
                        this.match = (0, _utils.getStringOption)(attributes.match, [
                            "once",
                            "dataRef",
                            "global",
                            "none"
                        ]);
                        this.ref = attributes.ref || "";
                        this.picture = null;
                    }
                }
                class BindItems extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bindItems");
                        this.connection = attributes.connection || "";
                        this.labelRef = attributes.labelRef || "";
                        this.ref = attributes.ref || "";
                        this.valueRef = attributes.valueRef || "";
                    }
                }
                exports.BindItems = BindItems;
                class Bookend extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "bookend");
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class BooleanElement extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "boolean");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return valueToHtml(this[_xfa_object.$content] === 1 ? "1" : "0");
                    }
                }
                class Border extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "border", true);
                        this.break = (0, _utils.getStringOption)(attributes.break, [
                            "close",
                            "open"
                        ]);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.corner = new _xfa_object.XFAObjectArray(4);
                        this.edge = new _xfa_object.XFAObjectArray(4);
                        this.extras = null;
                        this.fill = null;
                        this.margin = null;
                    }
                    [_xfa_object.$toStyle]() {
                        const edges = this.edge.children.slice();
                        if (edges.length < 4) {
                            const defaultEdge = edges[edges.length - 1] || new Edge({});
                            for(let i = edges.length; i < 4; i++)edges.push(defaultEdge);
                        }
                        const edgeStyles = edges.map((node)=>{
                            const style = node[_xfa_object.$toStyle]();
                            style.color = style.color || "#000000";
                            return style;
                        });
                        const widths = edges.map((edge)=>edge.thickness);
                        const insets = [
                            0,
                            0,
                            0,
                            0
                        ];
                        if (this.margin) {
                            insets[0] = this.margin.topInset;
                            insets[1] = this.margin.rightInset;
                            insets[2] = this.margin.bottomInset;
                            insets[3] = this.margin.leftInset;
                        }
                        this[_xfa_object.$extra] = {
                            widths: widths,
                            insets: insets
                        };
                        const style = Object.create(null);
                        if (this.margin) Object.assign(style, this.margin[_xfa_object.$toStyle]());
                        if (this.fill && this.fill.presence === "visible") Object.assign(style, this.fill[_xfa_object.$toStyle]());
                        if (this.corner.children.some((node)=>node.radius !== 0)) {
                            const cornerStyles = this.corner.children.map((node)=>node[_xfa_object.$toStyle]());
                            if (cornerStyles.length === 2 || cornerStyles.length === 3) {
                                const last = cornerStyles[cornerStyles.length - 1];
                                for(let i = cornerStyles.length; i < 4; i++)cornerStyles.push(last);
                            }
                            style.borderRadius = cornerStyles.map((s)=>s.radius).join(" ");
                        }
                        switch(this.presence){
                            case "invisible":
                            case "hidden":
                                style.borderStyle = "";
                                break;
                            case "inactive":
                                style.borderStyle = "none";
                                break;
                            default:
                                style.borderStyle = edgeStyles.map((s)=>s.style).join(" ");
                                break;
                        }
                        style.borderWidth = edgeStyles.map((s)=>s.width).join(" ");
                        style.borderColor = edgeStyles.map((s)=>s.color).join(" ");
                        return style;
                    }
                }
                class Break extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "break", true);
                        this.after = (0, _utils.getStringOption)(attributes.after, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.afterTarget = attributes.afterTarget || "";
                        this.before = (0, _utils.getStringOption)(attributes.before, [
                            "auto",
                            "contentArea",
                            "pageArea",
                            "pageEven",
                            "pageOdd"
                        ]);
                        this.beforeTarget = attributes.beforeTarget || "";
                        this.bookendLeader = attributes.bookendLeader || "";
                        this.bookendTrailer = attributes.bookendTrailer || "";
                        this.id = attributes.id || "";
                        this.overflowLeader = attributes.overflowLeader || "";
                        this.overflowTarget = attributes.overflowTarget || "";
                        this.overflowTrailer = attributes.overflowTrailer || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class BreakAfter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "breakAfter", true);
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.target = attributes.target || "";
                        this.targetType = (0, _utils.getStringOption)(attributes.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.script = null;
                    }
                }
                class BreakBefore extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "breakBefore", true);
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.startNew = (0, _utils.getInteger)({
                            data: attributes.startNew,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.target = attributes.target || "";
                        this.targetType = (0, _utils.getStringOption)(attributes.targetType, [
                            "auto",
                            "contentArea",
                            "pageArea"
                        ]);
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.script = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        this[_xfa_object.$extra] = {};
                        return _utils.HTMLResult.FAILURE;
                    }
                }
                class Button extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "button", true);
                        this.highlight = (0, _utils.getStringOption)(attributes.highlight, [
                            "inverted",
                            "none",
                            "outline",
                            "push"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return _utils.HTMLResult.success({
                            name: "button",
                            attributes: {
                                id: this[_xfa_object.$uid],
                                class: [
                                    "xfaButton"
                                ],
                                style: {}
                            },
                            children: []
                        });
                    }
                }
                class Calculate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "calculate", true);
                        this.id = attributes.id || "";
                        this.override = (0, _utils.getStringOption)(attributes.override, [
                            "disabled",
                            "error",
                            "ignore",
                            "warning"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.script = null;
                    }
                }
                class Caption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "caption", true);
                        this.id = attributes.id || "";
                        this.placement = (0, _utils.getStringOption)(attributes.placement, [
                            "left",
                            "bottom",
                            "inline",
                            "right",
                            "top"
                        ]);
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.reserve = Math.ceil((0, _utils.getMeasurement)(attributes.reserve));
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.font = null;
                        this.margin = null;
                        this.para = null;
                        this.value = null;
                    }
                    [_xfa_object.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_xfa_object.$getExtra](availableSpace) {
                        if (!this[_xfa_object.$extra]) {
                            let { width: width , height: height  } = availableSpace;
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    width = this.reserve <= 0 ? width : this.reserve;
                                    break;
                                case "top":
                                case "bottom":
                                    height = this.reserve <= 0 ? height : this.reserve;
                                    break;
                            }
                            this[_xfa_object.$extra] = (0, _html_utils.layoutNode)(this, {
                                width: width,
                                height: height
                            });
                        }
                        return this[_xfa_object.$extra];
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (!this.value) return _utils.HTMLResult.EMPTY;
                        const value = this.value[_xfa_object.$toHTML](availableSpace).html;
                        if (!value) return _utils.HTMLResult.EMPTY;
                        const savedReserve = this.reserve;
                        if (this.reserve <= 0) {
                            const { w: w , h: h  } = this[_xfa_object.$getExtra](availableSpace);
                            switch(this.placement){
                                case "left":
                                case "right":
                                case "inline":
                                    this.reserve = w;
                                    break;
                                case "top":
                                case "bottom":
                                    this.reserve = h;
                                    break;
                            }
                        }
                        const children = [];
                        if (typeof value === "string") children.push({
                            name: "#text",
                            value: value
                        });
                        else children.push(value);
                        const style = (0, _html_utils.toStyle)(this, "font", "margin", "visibility");
                        switch(this.placement){
                            case "left":
                            case "right":
                                if (this.reserve > 0) style.width = (0, _html_utils.measureToString)(this.reserve);
                                break;
                            case "top":
                            case "bottom":
                                if (this.reserve > 0) style.height = (0, _html_utils.measureToString)(this.reserve);
                                break;
                        }
                        (0, _html_utils.setPara)(this, null, value);
                        this.reserve = savedReserve;
                        return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: style,
                                class: [
                                    "xfaCaption"
                                ]
                            },
                            children: children
                        });
                    }
                }
                class Certificate extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "certificate");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Certificates extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "certificates", true);
                        this.credentialServerPolicy = (0, _utils.getStringOption)(attributes.credentialServerPolicy, [
                            "optional",
                            "required"
                        ]);
                        this.id = attributes.id || "";
                        this.url = attributes.url || "";
                        this.urlPolicy = attributes.urlPolicy || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encryption = null;
                        this.issuers = null;
                        this.keyUsage = null;
                        this.oids = null;
                        this.signing = null;
                        this.subjectDNs = null;
                    }
                }
                class CheckButton extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "checkButton", true);
                        this.id = attributes.id || "";
                        this.mark = (0, _utils.getStringOption)(attributes.mark, [
                            "default",
                            "check",
                            "circle",
                            "cross",
                            "diamond",
                            "square",
                            "star"
                        ]);
                        this.shape = (0, _utils.getStringOption)(attributes.shape, [
                            "square",
                            "round"
                        ]);
                        this.size = (0, _utils.getMeasurement)(attributes.size, "10pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)("margin");
                        const size = (0, _html_utils.measureToString)(this.size);
                        style.width = style.height = size;
                        let type;
                        let className;
                        let groupId;
                        const field = this[_xfa_object.$getParent]()[_xfa_object.$getParent]();
                        const items = field.items.children.length && field.items.children[0][_xfa_object.$toHTML]().html || [];
                        const exportedValue = {
                            on: (items[0] || "on").toString(),
                            off: (items[1] || "off").toString()
                        };
                        const value = field.value && field.value[_xfa_object.$text]() || "off";
                        const checked = value === exportedValue.on || undefined;
                        const container = field[_xfa_object.$getSubformParent]();
                        const fieldId = field[_xfa_object.$uid];
                        let dataId;
                        if (container instanceof ExclGroup) {
                            groupId = container[_xfa_object.$uid];
                            type = "radio";
                            className = "xfaRadio";
                            dataId = container[_xfa_object.$data] && container[_xfa_object.$data][_xfa_object.$uid] || container[_xfa_object.$uid];
                        } else {
                            type = "checkbox";
                            className = "xfaCheckbox";
                            dataId = field[_xfa_object.$data] && field[_xfa_object.$data][_xfa_object.$uid] || field[_xfa_object.$uid];
                        }
                        const input = {
                            name: "input",
                            attributes: {
                                class: [
                                    className
                                ],
                                style: style,
                                fieldId: fieldId,
                                dataId: dataId,
                                type: type,
                                checked: checked,
                                xfaOn: exportedValue.on
                            }
                        };
                        if (groupId) input.attributes.name = groupId;
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                input
                            ]
                        });
                    }
                }
                class ChoiceList extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "choiceList", true);
                        this.commitOn = (0, _utils.getStringOption)(attributes.commitOn, [
                            "select",
                            "exit"
                        ]);
                        this.id = attributes.id || "";
                        this.open = (0, _utils.getStringOption)(attributes.open, [
                            "userControl",
                            "always",
                            "multiSelect",
                            "onEntry"
                        ]);
                        this.textEntry = (0, _utils.getInteger)({
                            data: attributes.textEntry,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "margin");
                        const ui = this[_xfa_object.$getParent]();
                        const field = ui[_xfa_object.$getParent]();
                        const children = [];
                        if (field.items.children.length > 0) {
                            const items = field.items;
                            let displayedIndex = 0;
                            let saveIndex = 0;
                            if (items.children.length === 2) {
                                displayedIndex = items.children[0].save;
                                saveIndex = 1 - displayedIndex;
                            }
                            const displayed = items.children[displayedIndex][_xfa_object.$toHTML]().html;
                            const values = items.children[saveIndex][_xfa_object.$toHTML]().html;
                            let selected = false;
                            const value = field.value && field.value[_xfa_object.$text]() || "";
                            for(let i = 0, ii = displayed.length; i < ii; i++){
                                const option = {
                                    name: "option",
                                    attributes: {
                                        value: values[i] || displayed[i]
                                    },
                                    value: displayed[i]
                                };
                                if (values[i] === value) option.attributes.selected = selected = true;
                                children.push(option);
                            }
                            if (!selected) children.splice(0, 0, {
                                name: "option",
                                attributes: {
                                    hidden: true,
                                    selected: true
                                },
                                value: " "
                            });
                        }
                        const selectAttributes = {
                            class: [
                                "xfaSelect"
                            ],
                            fieldId: field[_xfa_object.$uid],
                            dataId: field[_xfa_object.$data] && field[_xfa_object.$data][_xfa_object.$uid] || field[_xfa_object.$uid],
                            style: style
                        };
                        if (this.open === "multiSelect") selectAttributes.multiple = true;
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                {
                                    name: "select",
                                    children: children,
                                    attributes: selectAttributes
                                }
                            ]
                        });
                    }
                }
                class Color extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "color", true);
                        this.cSpace = (0, _utils.getStringOption)(attributes.cSpace, [
                            "SRGB"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.value = attributes.value ? (0, _utils.getColor)(attributes.value) : "";
                        this.extras = null;
                    }
                    [_xfa_object.$hasSettableValue]() {
                        return false;
                    }
                    [_xfa_object.$toStyle]() {
                        return this.value ? _util.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
                    }
                }
                class Comb extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "comb");
                        this.id = attributes.id || "";
                        this.numberOfCells = (0, _utils.getInteger)({
                            data: attributes.numberOfCells,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Connect extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "connect", true);
                        this.connection = attributes.connection || "";
                        this.id = attributes.id || "";
                        this.ref = attributes.ref || "";
                        this.usage = (0, _utils.getStringOption)(attributes.usage, [
                            "exportAndImport",
                            "exportOnly",
                            "importOnly"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.picture = null;
                    }
                }
                class ContentArea extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "contentArea", true);
                        this.h = (0, _utils.getMeasurement)(attributes.h);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = (0, _utils.getMeasurement)(attributes.w);
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.desc = null;
                        this.extras = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const left = (0, _html_utils.measureToString)(this.x);
                        const top = (0, _html_utils.measureToString)(this.y);
                        const style = {
                            left: left,
                            top: top,
                            width: (0, _html_utils.measureToString)(this.w),
                            height: (0, _html_utils.measureToString)(this.h)
                        };
                        const classNames = [
                            "xfaContentarea"
                        ];
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        return _utils.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {
                                style: style,
                                class: classNames,
                                id: this[_xfa_object.$uid]
                            }
                        });
                    }
                }
                class Corner extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "corner", true);
                        this.id = attributes.id || "";
                        this.inverted = (0, _utils.getInteger)({
                            data: attributes.inverted,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.join = (0, _utils.getStringOption)(attributes.join, [
                            "square",
                            "round"
                        ]);
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.radius = (0, _utils.getMeasurement)(attributes.radius);
                        this.stroke = (0, _utils.getStringOption)(attributes.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, _utils.getMeasurement)(attributes.thickness, "0.5pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "visibility");
                        style.radius = (0, _html_utils.measureToString)(this.join === "square" ? 0 : this.radius);
                        return style;
                    }
                }
                class DateElement extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "date");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        const date = this[_xfa_object.$content].trim();
                        this[_xfa_object.$content] = date ? new Date(date) : null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return valueToHtml(this[_xfa_object.$content] ? this[_xfa_object.$content].toString() : "");
                    }
                }
                class DateTime extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "dateTime");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        const date = this[_xfa_object.$content].trim();
                        this[_xfa_object.$content] = date ? new Date(date) : null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return valueToHtml(this[_xfa_object.$content] ? this[_xfa_object.$content].toString() : "");
                    }
                }
                class DateTimeEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "dateTimeEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.picker = (0, _utils.getStringOption)(attributes.picker, [
                            "host",
                            "none"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        const field = this[_xfa_object.$getParent]()[_xfa_object.$getParent]();
                        const html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: field[_xfa_object.$uid],
                                dataId: field[_xfa_object.$data] && field[_xfa_object.$data][_xfa_object.$uid] || field[_xfa_object.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style
                            }
                        };
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Decimal extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "decimal");
                        this.fracDigits = (0, _utils.getInteger)({
                            data: attributes.fracDigits,
                            defaultValue: 2,
                            validate: (x)=>true
                        });
                        this.id = attributes.id || "";
                        this.leadDigits = (0, _utils.getInteger)({
                            data: attributes.leadDigits,
                            defaultValue: -1,
                            validate: (x)=>true
                        });
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        const number = parseFloat(this[_xfa_object.$content].trim());
                        this[_xfa_object.$content] = isNaN(number) ? null : number;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return valueToHtml(this[_xfa_object.$content] !== null ? this[_xfa_object.$content].toString() : "");
                    }
                }
                class DefaultUi extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "defaultUi", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class Desc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "desc", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class DigestMethod extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "digestMethod", [
                            "",
                            "SHA1",
                            "SHA256",
                            "SHA512",
                            "RIPEMD160"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class DigestMethods extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "digestMethods", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.digestMethod = new _xfa_object.XFAObjectArray();
                    }
                }
                class Draw extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "draw", true);
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.rotate = (0, _utils.getInteger)({
                            data: attributes.rotate,
                            defaultValue: 0,
                            validate: (x)=>x % 90 === 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.border = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.value = null;
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (this.presence === "hidden" || this.presence === "inactive") return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        const savedW = this.w;
                        const savedH = this.h;
                        const { w: w , h: h , isBroken: isBroken  } = (0, _html_utils.layoutNode)(this, availableSpace);
                        if (w && this.w === "") {
                            if (isBroken && this[_xfa_object.$getSubformParent]()[_xfa_object.$isThereMoreWidth]()) return _utils.HTMLResult.FAILURE;
                            this.w = w;
                        }
                        if (h && this.h === "") this.h = h;
                        setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                            this.w = savedW;
                            this.h = savedH;
                            return _utils.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const style = (0, _html_utils.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
                        (0, _html_utils.setMinMaxDimensions)(this, style);
                        if (style.margin) {
                            style.padding = style.margin;
                            delete style.margin;
                        }
                        const classNames = [
                            "xfaDraw"
                        ];
                        if (this.font) classNames.push("xfaFont");
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        const attributes = {
                            style: style,
                            id: this[_xfa_object.$uid],
                            class: classNames
                        };
                        if (this.name) attributes.xfaName = this.name;
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: []
                        };
                        const assist = this.assist ? this.assist[_xfa_object.$toHTML]() : null;
                        if (assist) html.attributes.title = assist;
                        const bbox = (0, _html_utils.computeBbox)(this, html, availableSpace);
                        const value = this.value ? this.value[_xfa_object.$toHTML](availableSpace).html : null;
                        if (value === null) {
                            this.w = savedW;
                            this.h = savedH;
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        html.children.push(value);
                        (0, _html_utils.setPara)(this, style, value);
                        this.w = savedW;
                        this.h = savedH;
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                class Edge extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "edge", true);
                        this.cap = (0, _utils.getStringOption)(attributes.cap, [
                            "square",
                            "butt",
                            "round"
                        ]);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.stroke = (0, _utils.getStringOption)(attributes.stroke, [
                            "solid",
                            "dashDot",
                            "dashDotDot",
                            "dashed",
                            "dotted",
                            "embossed",
                            "etched",
                            "lowered",
                            "raised"
                        ]);
                        this.thickness = (0, _utils.getMeasurement)(attributes.thickness, "0.5pt");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "visibility");
                        Object.assign(style, {
                            linecap: this.cap,
                            width: (0, _html_utils.measureToString)(this.thickness),
                            color: this.color ? this.color[_xfa_object.$toStyle]() : "#000000",
                            style: ""
                        });
                        if (this.presence !== "visible") style.style = "none";
                        else switch(this.stroke){
                            case "solid":
                                style.style = "solid";
                                break;
                            case "dashDot":
                                style.style = "dashed";
                                break;
                            case "dashDotDot":
                                style.style = "dashed";
                                break;
                            case "dashed":
                                style.style = "dashed";
                                break;
                            case "dotted":
                                style.style = "dotted";
                                break;
                            case "embossed":
                                style.style = "ridge";
                                break;
                            case "etched":
                                style.style = "groove";
                                break;
                            case "lowered":
                                style.style = "inset";
                                break;
                            case "raised":
                                style.style = "outset";
                                break;
                        }
                        return style;
                    }
                }
                class Encoding extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encoding", [
                            "adbe.x509.rsa_sha1",
                            "adbe.pkcs7.detached",
                            "adbe.pkcs7.sha1"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Encodings extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encodings", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encoding = new _xfa_object.XFAObjectArray();
                    }
                }
                class Encrypt extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encrypt", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = null;
                    }
                }
                class EncryptData extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptData", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "encrypt",
                            "decrypt"
                        ]);
                        this.target = attributes.target || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Encryption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryption", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class EncryptionMethod extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptionMethod", [
                            "",
                            "AES256-CBC",
                            "TRIPLEDES-CBC",
                            "AES128-CBC",
                            "AES192-CBC"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class EncryptionMethods extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "encryptionMethods", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.encryptionMethod = new _xfa_object.XFAObjectArray();
                    }
                }
                class Event extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "event", true);
                        this.activity = (0, _utils.getStringOption)(attributes.activity, [
                            "click",
                            "change",
                            "docClose",
                            "docReady",
                            "enter",
                            "exit",
                            "full",
                            "indexChange",
                            "initialize",
                            "mouseDown",
                            "mouseEnter",
                            "mouseExit",
                            "mouseUp",
                            "postExecute",
                            "postOpen",
                            "postPrint",
                            "postSave",
                            "postSign",
                            "postSubmit",
                            "preExecute",
                            "preOpen",
                            "prePrint",
                            "preSave",
                            "preSign",
                            "preSubmit",
                            "ready",
                            "validationState"
                        ]);
                        this.id = attributes.id || "";
                        this.listen = (0, _utils.getStringOption)(attributes.listen, [
                            "refOnly",
                            "refAndDescendents"
                        ]);
                        this.name = attributes.name || "";
                        this.ref = attributes.ref || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.encryptData = null;
                        this.execute = null;
                        this.script = null;
                        this.signData = null;
                        this.submit = null;
                    }
                }
                class ExData extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exData");
                        this.contentType = attributes.contentType || "";
                        this.href = attributes.href || "";
                        this.id = attributes.id || "";
                        this.maxLength = (0, _utils.getInteger)({
                            data: attributes.maxLength,
                            defaultValue: -1,
                            validate: (x)=>x >= -1
                        });
                        this.name = attributes.name || "";
                        this.rid = attributes.rid || "";
                        this.transferEncoding = (0, _utils.getStringOption)(attributes.transferEncoding, [
                            "none",
                            "base64",
                            "package"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$isCDATAXml]() {
                        return this.contentType === "text/html";
                    }
                    [_xfa_object.$onChild](child) {
                        if (this.contentType === "text/html" && child[_xfa_object.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                            this[_xfa_object.$content] = child;
                            return true;
                        }
                        if (this.contentType === "text/xml") {
                            this[_xfa_object.$content] = child;
                            return true;
                        }
                        return false;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (this.contentType !== "text/html" || !this[_xfa_object.$content]) return _utils.HTMLResult.EMPTY;
                        return this[_xfa_object.$content][_xfa_object.$toHTML](availableSpace);
                    }
                }
                class ExObject extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exObject", true);
                        this.archive = attributes.archive || "";
                        this.classId = attributes.classId || "";
                        this.codeBase = attributes.codeBase || "";
                        this.codeType = attributes.codeType || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class ExclGroup extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "exclGroup", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = attributes.accessKey || "";
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.layout = (0, _utils.getStringOption)(attributes.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$isBindable]() {
                        return true;
                    }
                    [_xfa_object.$hasSettableValue]() {
                        return true;
                    }
                    [_xfa_object.$setValue](value) {
                        for (const field of this.field.children){
                            if (!field.value) {
                                const nodeValue = new Value({});
                                field[_xfa_object.$appendChild](nodeValue);
                                field.value = nodeValue;
                            }
                            field.value[_xfa_object.$setValue](value);
                        }
                    }
                    [_xfa_object.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && this[_xfa_object.$extra].attempt === 0 && this[_xfa_object.$extra].numberInLine > 0 || this[_xfa_object.$getParent]()[_xfa_object.$isThereMoreWidth]();
                    }
                    [_xfa_object.$isSplittable]() {
                        const parent = this[_xfa_object.$getSubformParent]();
                        if (!parent[_xfa_object.$isSplittable]()) return false;
                        if (this[_xfa_object.$extra]._isSplittable !== undefined) return this[_xfa_object.$extra]._isSplittable;
                        if (this.layout === "position" || this.layout.includes("row")) {
                            this[_xfa_object.$extra]._isSplittable = false;
                            return false;
                        }
                        if (parent.layout && parent.layout.endsWith("-tb") && parent[_xfa_object.$extra].numberInLine !== 0) return false;
                        this[_xfa_object.$extra]._isSplittable = true;
                        return true;
                    }
                    [_xfa_object.$flushHTML]() {
                        return (0, _layout.flushHTML)(this);
                    }
                    [_xfa_object.$addHTML](html, bbox) {
                        (0, _layout.addHTML)(this, html, bbox);
                    }
                    [_xfa_object.$getAvailableSpace]() {
                        return (0, _layout.getAvailableSpace)(this);
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        const children = [];
                        const attributes = {
                            id: this[_xfa_object.$uid],
                            class: []
                        };
                        (0, _html_utils.setAccess)(this, attributes.class);
                        if (!this[_xfa_object.$extra]) this[_xfa_object.$extra] = Object.create(null);
                        Object.assign(this[_xfa_object.$extra], {
                            children: children,
                            attributes: attributes,
                            attempt: 0,
                            line: null,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || Infinity, availableSpace.width),
                                height: Math.min(this.h || Infinity, availableSpace.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const isSplittable = this[_xfa_object.$isSplittable]();
                        if (!isSplittable) setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) return _utils.HTMLResult.FAILURE;
                        availableSpace = {
                            width: this.w === "" ? availableSpace.width : this.w,
                            height: this.h === "" ? availableSpace.height : this.h
                        };
                        const filter = new Set([
                            "field"
                        ]);
                        if (this.layout.includes("row")) {
                            const columnWidths = this[_xfa_object.$getSubformParent]().columnWidths;
                            if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                                this[_xfa_object.$extra].columnWidths = columnWidths;
                                this[_xfa_object.$extra].currentColumn = 0;
                            }
                        }
                        const style = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                        const classNames = [
                            "xfaExclgroup"
                        ];
                        const cl = (0, _html_utils.layoutClass)(this);
                        if (cl) classNames.push(cl);
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        attributes.style = style;
                        attributes.class = classNames;
                        if (this.name) attributes.xfaName = this.name;
                        const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                        const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                        for(; this[_xfa_object.$extra].attempt < maxRun; this[_xfa_object.$extra].attempt++){
                            if (isLrTb && this[_xfa_object.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) this[_xfa_object.$extra].numberInLine = 0;
                            const result = this[_xfa_object.$childrenToHTML]({
                                filter: filter,
                                include: true
                            });
                            if (result.success) break;
                            if (result.isBreak()) return result;
                            if (isLrTb && this[_xfa_object.$extra].attempt === 0 && this[_xfa_object.$extra].numberInLine === 0 && !this[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].noLayoutFailure) {
                                this[_xfa_object.$extra].attempt = maxRun;
                                break;
                            }
                        }
                        if (!isSplittable) unsetFirstUnsplittable(this);
                        if (this[_xfa_object.$extra].attempt === maxRun) {
                            if (!isSplittable) delete this[_xfa_object.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        const width = Math.max(this[_xfa_object.$extra].width + marginH, this.w || 0);
                        const height = Math.max(this[_xfa_object.$extra].height + marginV, this.h || 0);
                        const bbox = [
                            this.x,
                            this.y,
                            width,
                            height
                        ];
                        if (this.w === "") style.width = (0, _html_utils.measureToString)(width);
                        if (this.h === "") style.height = (0, _html_utils.measureToString)(height);
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        const assist = this.assist ? this.assist[_xfa_object.$toHTML]() : null;
                        if (assist) html.attributes.title = assist;
                        delete this[_xfa_object.$extra];
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                class Execute extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "execute");
                        this.connection = attributes.connection || "";
                        this.executeType = (0, _utils.getStringOption)(attributes.executeType, [
                            "import",
                            "remerge"
                        ]);
                        this.id = attributes.id || "";
                        this.runAt = (0, _utils.getStringOption)(attributes.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Extras extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "extras", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.extras = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                }
                class Field extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "field", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.accessKey = attributes.accessKey || "";
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.rotate = (0, _utils.getInteger)({
                            data: attributes.rotate,
                            defaultValue: 0,
                            validate: (x)=>x % 90 === 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.border = null;
                        this.calculate = null;
                        this.caption = null;
                        this.desc = null;
                        this.extras = null;
                        this.font = null;
                        this.format = null;
                        this.items = new _xfa_object.XFAObjectArray(2);
                        this.keep = null;
                        this.margin = null;
                        this.para = null;
                        this.traversal = null;
                        this.ui = null;
                        this.validate = null;
                        this.value = null;
                        this.bindItems = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$isBindable]() {
                        return true;
                    }
                    [_xfa_object.$setValue](value) {
                        _setValue(this, value);
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (!this.ui) {
                            this.ui = new Ui({});
                            this.ui[_xfa_object.$globalData] = this[_xfa_object.$globalData];
                            this[_xfa_object.$appendChild](this.ui);
                            let node;
                            switch(this.items.children.length){
                                case 0:
                                    node = new TextEdit({});
                                    this.ui.textEdit = node;
                                    break;
                                case 1:
                                    node = new CheckButton({});
                                    this.ui.checkButton = node;
                                    break;
                                case 2:
                                    node = new ChoiceList({});
                                    this.ui.choiceList = node;
                                    break;
                            }
                            this.ui[_xfa_object.$appendChild](node);
                        }
                        setTabIndex(this);
                        if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0) return _utils.HTMLResult.EMPTY;
                        if (this.caption) delete this.caption[_xfa_object.$extra];
                        const caption = this.caption ? this.caption[_xfa_object.$toHTML](availableSpace).html : null;
                        const savedW = this.w;
                        const savedH = this.h;
                        if (this.w === "" || this.h === "") {
                            let marginH = 0;
                            let marginV = 0;
                            if (this.margin) {
                                marginH = this.margin.leftInset + this.margin.rightInset;
                                marginV = this.margin.topInset + this.margin.bottomInset;
                            }
                            let width = null;
                            let height = null;
                            if (this.caption) {
                                const { w: w , h: h , isBroken: isBroken  } = this.caption[_xfa_object.$getExtra](availableSpace);
                                if (isBroken && this[_xfa_object.$getSubformParent]()[_xfa_object.$isThereMoreWidth]()) return _utils.HTMLResult.FAILURE;
                                width = w;
                                height = h;
                                if (this.ui.checkButton) switch(this.caption.placement){
                                    case "left":
                                    case "right":
                                    case "inline":
                                        width += this.ui.checkButton.size;
                                        break;
                                    case "top":
                                    case "bottom":
                                        height += this.ui.checkButton.size;
                                        break;
                                }
                            }
                            if (width && this.w === "") this.w = Math.min(this.maxW <= 0 ? Infinity : this.maxW, Math.max(this.minW, width + marginH));
                            if (height && this.h === "") this.h = Math.min(this.maxH <= 0 ? Infinity : this.maxH, Math.max(this.minH, height + marginV));
                        }
                        (0, _html_utils.fixDimensions)(this);
                        setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) {
                            this.w = savedW;
                            this.h = savedH;
                            return _utils.HTMLResult.FAILURE;
                        }
                        unsetFirstUnsplittable(this);
                        const style = (0, _html_utils.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
                        (0, _html_utils.setMinMaxDimensions)(this, style);
                        const classNames = [
                            "xfaField"
                        ];
                        if (this.font) classNames.push("xfaFont");
                        if ((0, _html_utils.isPrintOnly)(this)) classNames.push("xfaPrintOnly");
                        const attributes = {
                            style: style,
                            id: this[_xfa_object.$uid],
                            class: classNames
                        };
                        if (style.margin) {
                            style.padding = style.margin;
                            delete style.margin;
                        }
                        (0, _html_utils.setAccess)(this, classNames);
                        if (this.name) attributes.xfaName = this.name;
                        const children = [];
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        const assist = this.assist ? this.assist[_xfa_object.$toHTML]() : null;
                        if (assist) html.attributes.title = assist;
                        const borderStyle = this.border ? this.border[_xfa_object.$toStyle]() : null;
                        const bbox = (0, _html_utils.computeBbox)(this, html, availableSpace);
                        const ui = this.ui[_xfa_object.$toHTML]().html;
                        if (!ui) {
                            Object.assign(style, borderStyle);
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        if (this[_xfa_object.$tabIndex]) {
                            if (ui.children && ui.children[0]) ui.children[0].attributes.tabindex = this[_xfa_object.$tabIndex];
                            else ui.attributes.tabindex = this[_xfa_object.$tabIndex];
                        }
                        if (!ui.attributes.style) ui.attributes.style = Object.create(null);
                        if (this.ui.button) Object.assign(ui.attributes.style, borderStyle);
                        else Object.assign(style, borderStyle);
                        children.push(ui);
                        if (this.value) {
                            if (this.ui.imageEdit) ui.children.push(this.value[_xfa_object.$toHTML]().html);
                            else if (!this.ui.button) {
                                let value = "";
                                if (this.value.exData) value = this.value.exData[_xfa_object.$text]();
                                else {
                                    const htmlValue = this.value[_xfa_object.$toHTML]().html;
                                    if (htmlValue !== null) value = htmlValue.children[0].value;
                                }
                                if (this.ui.textEdit && this.value.text && this.value.text.maxChars) ui.children[0].attributes.maxLength = this.value.text.maxChars;
                                if (value) {
                                    if (ui.children[0].name === "textarea") ui.children[0].attributes.textContent = value;
                                    else ui.children[0].attributes.value = value;
                                }
                            }
                        }
                        if (!caption) {
                            if (ui.attributes.class) ui.attributes.class.push("xfaLeft");
                            this.w = savedW;
                            this.h = savedH;
                            return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        }
                        if (this.ui.button) {
                            if (style.padding) delete style.padding;
                            if (caption.name === "div") caption.name = "span";
                            ui.children.push(caption);
                            return _utils.HTMLResult.success(html, bbox);
                        } else if (this.ui.checkButton) caption.attributes.class[0] = "xfaCaptionForCheckButton";
                        if (!ui.attributes.class) ui.attributes.class = [];
                        switch(this.caption.placement){
                            case "left":
                                ui.children.splice(0, 0, caption);
                                ui.attributes.class.push("xfaLeft");
                                break;
                            case "right":
                                ui.children.push(caption);
                                ui.attributes.class.push("xfaLeft");
                                break;
                            case "top":
                                ui.children.splice(0, 0, caption);
                                ui.attributes.class.push("xfaTop");
                                break;
                            case "bottom":
                                ui.children.push(caption);
                                ui.attributes.class.push("xfaTop");
                                break;
                            case "inline":
                                ui.attributes.class.push("xfaLeft");
                                break;
                        }
                        this.w = savedW;
                        this.h = savedH;
                        return _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                    }
                }
                exports.Field = Field;
                class Fill extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "fill", true);
                        this.id = attributes.id || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                        this.linear = null;
                        this.pattern = null;
                        this.radial = null;
                        this.solid = null;
                        this.stipple = null;
                    }
                    [_xfa_object.$toStyle]() {
                        const parent = this[_xfa_object.$getParent]();
                        const style = Object.create(null);
                        let propName = "color";
                        if (parent instanceof Border) propName = "background";
                        if (parent instanceof Rectangle || parent instanceof Arc) {
                            propName = "fill";
                            style.fill = "white";
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (name === "extras" || name === "color") continue;
                            const obj = this[name];
                            if (!(obj instanceof _xfa_object.XFAObject)) continue;
                            style[propName] = obj[_xfa_object.$toStyle](this.color);
                            return style;
                        }
                        if (this.color) style[propName] = this.color[_xfa_object.$toStyle]();
                        return style;
                    }
                }
                class Filter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "filter", true);
                        this.addRevocationInfo = (0, _utils.getStringOption)(attributes.addRevocationInfo, [
                            "",
                            "required",
                            "optional",
                            "none"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.version = (0, _utils.getInteger)({
                            data: this.version,
                            defaultValue: 5,
                            validate: (x)=>x >= 1 && x <= 5
                        });
                        this.appearanceFilter = null;
                        this.certificates = null;
                        this.digestMethods = null;
                        this.encodings = null;
                        this.encryptionMethods = null;
                        this.handler = null;
                        this.lockDocument = null;
                        this.mdp = null;
                        this.reasons = null;
                        this.timeStamp = null;
                    }
                }
                class Float extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "float");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        const number = parseFloat(this[_xfa_object.$content].trim());
                        this[_xfa_object.$content] = isNaN(number) ? null : number;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return valueToHtml(this[_xfa_object.$content] !== null ? this[_xfa_object.$content].toString() : "");
                    }
                }
                class Font extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "font", true);
                        this.baselineShift = (0, _utils.getMeasurement)(attributes.baselineShift);
                        this.fontHorizontalScale = (0, _utils.getFloat)({
                            data: attributes.fontHorizontalScale,
                            defaultValue: 100,
                            validate: (x)=>x >= 0
                        });
                        this.fontVerticalScale = (0, _utils.getFloat)({
                            data: attributes.fontVerticalScale,
                            defaultValue: 100,
                            validate: (x)=>x >= 0
                        });
                        this.id = attributes.id || "";
                        this.kerningMode = (0, _utils.getStringOption)(attributes.kerningMode, [
                            "none",
                            "pair"
                        ]);
                        this.letterSpacing = (0, _utils.getMeasurement)(attributes.letterSpacing, "0");
                        this.lineThrough = (0, _utils.getInteger)({
                            data: attributes.lineThrough,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.lineThroughPeriod = (0, _utils.getStringOption)(attributes.lineThroughPeriod, [
                            "all",
                            "word"
                        ]);
                        this.overline = (0, _utils.getInteger)({
                            data: attributes.overline,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.overlinePeriod = (0, _utils.getStringOption)(attributes.overlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.posture = (0, _utils.getStringOption)(attributes.posture, [
                            "normal",
                            "italic"
                        ]);
                        this.size = (0, _utils.getMeasurement)(attributes.size, "10pt");
                        this.typeface = attributes.typeface || "Courier";
                        this.underline = (0, _utils.getInteger)({
                            data: attributes.underline,
                            defaultValue: 0,
                            validate: (x)=>x === 1 || x === 2
                        });
                        this.underlinePeriod = (0, _utils.getStringOption)(attributes.underlinePeriod, [
                            "all",
                            "word"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.weight = (0, _utils.getStringOption)(attributes.weight, [
                            "normal",
                            "bold"
                        ]);
                        this.extras = null;
                        this.fill = null;
                    }
                    [_xfa_object.$clean](builder) {
                        super[_xfa_object.$clean](builder);
                        this[_xfa_object.$globalData].usedTypefaces.add(this.typeface);
                    }
                    [_xfa_object.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "fill");
                        const color = style.color;
                        if (color) {
                            if (color === "#000000") delete style.color;
                            else if (!color.startsWith("#")) {
                                style.background = color;
                                style.backgroundClip = "text";
                                style.color = "transparent";
                            }
                        }
                        if (this.baselineShift) style.verticalAlign = (0, _html_utils.measureToString)(this.baselineShift);
                        style.fontKerning = this.kerningMode === "none" ? "none" : "normal";
                        style.letterSpacing = (0, _html_utils.measureToString)(this.letterSpacing);
                        if (this.lineThrough !== 0) {
                            style.textDecoration = "line-through";
                            if (this.lineThrough === 2) style.textDecorationStyle = "double";
                        }
                        if (this.overline !== 0) {
                            style.textDecoration = "overline";
                            if (this.overline === 2) style.textDecorationStyle = "double";
                        }
                        style.fontStyle = this.posture;
                        style.fontSize = (0, _html_utils.measureToString)(0.99 * this.size);
                        (0, _html_utils.setFontFamily)(this, this[_xfa_object.$globalData].fontFinder, style);
                        if (this.underline !== 0) {
                            style.textDecoration = "underline";
                            if (this.underline === 2) style.textDecorationStyle = "double";
                        }
                        style.fontWeight = this.weight;
                        return style;
                    }
                }
                class Format extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "format", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.picture = null;
                    }
                }
                class Handler extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "handler");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Hyphenation extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "hyphenation");
                        this.excludeAllCaps = (0, _utils.getInteger)({
                            data: attributes.excludeAllCaps,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.excludeInitialCap = (0, _utils.getInteger)({
                            data: attributes.excludeInitialCap,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hyphenate = (0, _utils.getInteger)({
                            data: attributes.hyphenate,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.id = attributes.id || "";
                        this.pushCharacterCount = (0, _utils.getInteger)({
                            data: attributes.pushCharacterCount,
                            defaultValue: 3,
                            validate: (x)=>x >= 0
                        });
                        this.remainCharacterCount = (0, _utils.getInteger)({
                            data: attributes.remainCharacterCount,
                            defaultValue: 3,
                            validate: (x)=>x >= 0
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.wordCharacterCount = (0, _utils.getInteger)({
                            data: attributes.wordCharacterCount,
                            defaultValue: 7,
                            validate: (x)=>x >= 0
                        });
                    }
                }
                class Image extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "image");
                        this.aspect = (0, _utils.getStringOption)(attributes.aspect, [
                            "fit",
                            "actual",
                            "height",
                            "none",
                            "width"
                        ]);
                        this.contentType = attributes.contentType || "";
                        this.href = attributes.href || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.transferEncoding = (0, _utils.getStringOption)(attributes.transferEncoding, [
                            "base64",
                            "none",
                            "package"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$toHTML]() {
                        let buffer = this[_xfa_object.$globalData].images && this[_xfa_object.$globalData].images.get(this.href);
                        if (!buffer && (this.href || !this[_xfa_object.$content])) return _utils.HTMLResult.EMPTY;
                        if (!buffer && this.transferEncoding === "base64") buffer = (0, _util.stringToBytes)(atob(this[_xfa_object.$content]));
                        if (!buffer) return _utils.HTMLResult.EMPTY;
                        const blob = new Blob([
                            buffer
                        ], {
                            type: this.contentType
                        });
                        let style;
                        switch(this.aspect){
                            case "fit":
                            case "actual":
                                break;
                            case "height":
                                style = {
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "none":
                                style = {
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "fill"
                                };
                                break;
                            case "width":
                                style = {
                                    width: "100%",
                                    objectFit: "fill"
                                };
                                break;
                        }
                        return _utils.HTMLResult.success({
                            name: "img",
                            attributes: {
                                class: [
                                    "xfaImage"
                                ],
                                style: style,
                                src: URL.createObjectURL(blob)
                            }
                        });
                    }
                }
                class ImageEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "imageEdit", true);
                        this.data = (0, _utils.getStringOption)(attributes.data, [
                            "link",
                            "embed"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (this.data === "embed") return _utils.HTMLResult.success({
                            name: "div",
                            children: [],
                            attributes: {}
                        });
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                class Integer extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "integer");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        const number = parseInt(this[_xfa_object.$content].trim(), 10);
                        this[_xfa_object.$content] = isNaN(number) ? null : number;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return valueToHtml(this[_xfa_object.$content] !== null ? this[_xfa_object.$content].toString() : "");
                    }
                }
                class Issuers extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "issuers", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class Items extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "items", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.ref = attributes.ref || "";
                        this.save = (0, _utils.getInteger)({
                            data: attributes.save,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$toHTML]() {
                        const output = [];
                        for (const child of this[_xfa_object.$getChildren]())output.push(child[_xfa_object.$text]());
                        return _utils.HTMLResult.success(output);
                    }
                }
                exports.Items = Items;
                class Keep extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "keep", true);
                        this.id = attributes.id || "";
                        const options = [
                            "none",
                            "contentArea",
                            "pageArea"
                        ];
                        this.intact = (0, _utils.getStringOption)(attributes.intact, options);
                        this.next = (0, _utils.getStringOption)(attributes.next, options);
                        this.previous = (0, _utils.getStringOption)(attributes.previous, options);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class KeyUsage extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "keyUsage");
                        const options = [
                            "",
                            "yes",
                            "no"
                        ];
                        this.crlSign = (0, _utils.getStringOption)(attributes.crlSign, options);
                        this.dataEncipherment = (0, _utils.getStringOption)(attributes.dataEncipherment, options);
                        this.decipherOnly = (0, _utils.getStringOption)(attributes.decipherOnly, options);
                        this.digitalSignature = (0, _utils.getStringOption)(attributes.digitalSignature, options);
                        this.encipherOnly = (0, _utils.getStringOption)(attributes.encipherOnly, options);
                        this.id = attributes.id || "";
                        this.keyAgreement = (0, _utils.getStringOption)(attributes.keyAgreement, options);
                        this.keyCertSign = (0, _utils.getStringOption)(attributes.keyCertSign, options);
                        this.keyEncipherment = (0, _utils.getStringOption)(attributes.keyEncipherment, options);
                        this.nonRepudiation = (0, _utils.getStringOption)(attributes.nonRepudiation, options);
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Line extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "line", true);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.slope = (0, _utils.getStringOption)(attributes.slope, [
                            "\\",
                            "/"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.edge = null;
                    }
                    [_xfa_object.$toHTML]() {
                        const parent = this[_xfa_object.$getParent]()[_xfa_object.$getParent]();
                        const edge = this.edge ? this.edge : new Edge({});
                        const edgeStyle = edge[_xfa_object.$toStyle]();
                        const style = Object.create(null);
                        const thickness = edge.presence === "visible" ? edge.thickness : 0;
                        style.strokeWidth = (0, _html_utils.measureToString)(thickness);
                        style.stroke = edgeStyle.color;
                        let x1, y1, x2, y2;
                        let width = "100%";
                        let height = "100%";
                        if (parent.w <= thickness) {
                            [x1, y1, x2, y2] = [
                                "50%",
                                0,
                                "50%",
                                "100%"
                            ];
                            width = style.strokeWidth;
                        } else if (parent.h <= thickness) {
                            [x1, y1, x2, y2] = [
                                0,
                                "50%",
                                "100%",
                                "50%"
                            ];
                            height = style.strokeWidth;
                        } else if (this.slope === "\\") [x1, y1, x2, y2] = [
                            0,
                            0,
                            "100%",
                            "100%"
                        ];
                        else [x1, y1, x2, y2] = [
                            0,
                            "100%",
                            "100%",
                            0
                        ];
                        const line = {
                            name: "line",
                            attributes: {
                                xmlns: SVG_NS,
                                x1: x1,
                                y1: y1,
                                x2: x2,
                                y2: y2,
                                style: style
                            }
                        };
                        const svg = {
                            name: "svg",
                            children: [
                                line
                            ],
                            attributes: {
                                xmlns: SVG_NS,
                                width: width,
                                height: height,
                                style: {
                                    overflow: "visible"
                                }
                            }
                        };
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class Linear extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "linear", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "toRight",
                            "toBottom",
                            "toLeft",
                            "toTop"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle](startColor) {
                        startColor = startColor ? startColor[_xfa_object.$toStyle]() : "#FFFFFF";
                        const transf = this.type.replace(/([RBLT])/, " $1").toLowerCase();
                        const endColor = this.color ? this.color[_xfa_object.$toStyle]() : "#000000";
                        return `linear-gradient(${transf}, ${startColor}, ${endColor})`;
                    }
                }
                class LockDocument extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "lockDocument");
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = (0, _utils.getStringOption)(this[_xfa_object.$content], [
                            "auto",
                            "0",
                            "1"
                        ]);
                    }
                }
                class Manifest extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "manifest", true);
                        this.action = (0, _utils.getStringOption)(attributes.action, [
                            "include",
                            "all",
                            "exclude"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.ref = new _xfa_object.XFAObjectArray();
                    }
                }
                class Margin extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "margin", true);
                        this.bottomInset = (0, _utils.getMeasurement)(attributes.bottomInset, "0");
                        this.id = attributes.id || "";
                        this.leftInset = (0, _utils.getMeasurement)(attributes.leftInset, "0");
                        this.rightInset = (0, _utils.getMeasurement)(attributes.rightInset, "0");
                        this.topInset = (0, _utils.getMeasurement)(attributes.topInset, "0");
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle]() {
                        return {
                            margin: (0, _html_utils.measureToString)(this.topInset) + " " + (0, _html_utils.measureToString)(this.rightInset) + " " + (0, _html_utils.measureToString)(this.bottomInset) + " " + (0, _html_utils.measureToString)(this.leftInset)
                        };
                    }
                }
                class Mdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "mdp");
                        this.id = attributes.id || "";
                        this.permissions = (0, _utils.getInteger)({
                            data: attributes.permissions,
                            defaultValue: 2,
                            validate: (x)=>x === 1 || x === 3
                        });
                        this.signatureType = (0, _utils.getStringOption)(attributes.signatureType, [
                            "filler",
                            "author"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Medium extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "medium");
                        this.id = attributes.id || "";
                        this.imagingBBox = (0, _utils.getBBox)(attributes.imagingBBox);
                        this.long = (0, _utils.getMeasurement)(attributes.long);
                        this.orientation = (0, _utils.getStringOption)(attributes.orientation, [
                            "portrait",
                            "landscape"
                        ]);
                        this.short = (0, _utils.getMeasurement)(attributes.short);
                        this.stock = attributes.stock || "";
                        this.trayIn = (0, _utils.getStringOption)(attributes.trayIn, [
                            "auto",
                            "delegate",
                            "pageFront"
                        ]);
                        this.trayOut = (0, _utils.getStringOption)(attributes.trayOut, [
                            "auto",
                            "delegate"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Message extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "message", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.text = new _xfa_object.XFAObjectArray();
                    }
                }
                class NumericEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "numericEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        const field = this[_xfa_object.$getParent]()[_xfa_object.$getParent]();
                        const html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                fieldId: field[_xfa_object.$uid],
                                dataId: field[_xfa_object.$data] && field[_xfa_object.$data][_xfa_object.$uid] || field[_xfa_object.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style
                            }
                        };
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Occur extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "occur", true);
                        this.id = attributes.id || "";
                        this.initial = (0, _utils.getInteger)({
                            data: attributes.initial,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.max = (0, _utils.getInteger)({
                            data: attributes.max,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.min = (0, _utils.getInteger)({
                            data: attributes.min,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                }
                class Oid extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "oid");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Oids extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "oids", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.oid = new _xfa_object.XFAObjectArray();
                    }
                }
                class Overflow extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "overflow");
                        this.id = attributes.id || "";
                        this.leader = attributes.leader || "";
                        this.target = attributes.target || "";
                        this.trailer = attributes.trailer || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$getExtra]() {
                        if (!this[_xfa_object.$extra]) {
                            const parent = this[_xfa_object.$getParent]();
                            const root = this[_xfa_object.$getTemplateRoot]();
                            const target = root[_xfa_object.$searchNode](this.target, parent);
                            const leader = root[_xfa_object.$searchNode](this.leader, parent);
                            const trailer = root[_xfa_object.$searchNode](this.trailer, parent);
                            this[_xfa_object.$extra] = {
                                target: target && target[0] || null,
                                leader: leader && leader[0] || null,
                                trailer: trailer && trailer[0] || null,
                                addLeader: false,
                                addTrailer: false
                            };
                        }
                        return this[_xfa_object.$extra];
                    }
                }
                class PageArea extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pageArea", true);
                        this.blankOrNotBlank = (0, _utils.getStringOption)(attributes.blankOrNotBlank, [
                            "any",
                            "blank",
                            "notBlank"
                        ]);
                        this.id = attributes.id || "";
                        this.initialNumber = (0, _utils.getInteger)({
                            data: attributes.initialNumber,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.name = attributes.name || "";
                        this.numbered = (0, _utils.getInteger)({
                            data: attributes.numbered,
                            defaultValue: 1,
                            validate: (x)=>true
                        });
                        this.oddOrEven = (0, _utils.getStringOption)(attributes.oddOrEven, [
                            "any",
                            "even",
                            "odd"
                        ]);
                        this.pagePosition = (0, _utils.getStringOption)(attributes.pagePosition, [
                            "any",
                            "first",
                            "last",
                            "only",
                            "rest"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.desc = null;
                        this.extras = null;
                        this.medium = null;
                        this.occur = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.contentArea = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$isUsable]() {
                        if (!this[_xfa_object.$extra]) {
                            this[_xfa_object.$extra] = {
                                numberOfUse: 0
                            };
                            return true;
                        }
                        return !this.occur || this.occur.max === -1 || this[_xfa_object.$extra].numberOfUse < this.occur.max;
                    }
                    [_xfa_object.$cleanPage]() {
                        delete this[_xfa_object.$extra];
                    }
                    [_xfa_object.$getNextPage]() {
                        if (!this[_xfa_object.$extra]) this[_xfa_object.$extra] = {
                            numberOfUse: 0
                        };
                        const parent = this[_xfa_object.$getParent]();
                        if (parent.relation === "orderedOccurrence") {
                            if (this[_xfa_object.$isUsable]()) {
                                this[_xfa_object.$extra].numberOfUse += 1;
                                return this;
                            }
                        }
                        return parent[_xfa_object.$getNextPage]();
                    }
                    [_xfa_object.$getAvailableSpace]() {
                        return this[_xfa_object.$extra].space || {
                            width: 0,
                            height: 0
                        };
                    }
                    [_xfa_object.$toHTML]() {
                        if (!this[_xfa_object.$extra]) this[_xfa_object.$extra] = {
                            numberOfUse: 1
                        };
                        const children = [];
                        this[_xfa_object.$extra].children = children;
                        const style = Object.create(null);
                        if (this.medium && this.medium.short && this.medium.long) {
                            style.width = (0, _html_utils.measureToString)(this.medium.short);
                            style.height = (0, _html_utils.measureToString)(this.medium.long);
                            this[_xfa_object.$extra].space = {
                                width: this.medium.short,
                                height: this.medium.long
                            };
                            if (this.medium.orientation === "landscape") {
                                const x = style.width;
                                style.width = style.height;
                                style.height = x;
                                this[_xfa_object.$extra].space = {
                                    width: this.medium.long,
                                    height: this.medium.short
                                };
                            }
                        } else (0, _util.warn)("XFA - No medium specified in pageArea: please file a bug.");
                        this[_xfa_object.$childrenToHTML]({
                            filter: new Set([
                                "area",
                                "draw",
                                "field",
                                "subform"
                            ]),
                            include: true
                        });
                        this[_xfa_object.$childrenToHTML]({
                            filter: new Set([
                                "contentArea"
                            ]),
                            include: true
                        });
                        return _utils.HTMLResult.success({
                            name: "div",
                            children: children,
                            attributes: {
                                class: [
                                    "xfaPage"
                                ],
                                id: this[_xfa_object.$uid],
                                style: style,
                                xfaName: this.name
                            }
                        });
                    }
                }
                class PageSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pageSet", true);
                        this.duplexImposition = (0, _utils.getStringOption)(attributes.duplexImposition, [
                            "longEdge",
                            "shortEdge"
                        ]);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relation = (0, _utils.getStringOption)(attributes.relation, [
                            "orderedOccurrence",
                            "duplexPaginated",
                            "simplexPaginated"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.occur = null;
                        this.pageArea = new _xfa_object.XFAObjectArray();
                        this.pageSet = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$cleanPage]() {
                        for (const page of this.pageArea.children)page[_xfa_object.$cleanPage]();
                        for (const page of this.pageSet.children)page[_xfa_object.$cleanPage]();
                    }
                    [_xfa_object.$isUsable]() {
                        return !this.occur || this.occur.max === -1 || this[_xfa_object.$extra].numberOfUse < this.occur.max;
                    }
                    [_xfa_object.$getNextPage]() {
                        if (!this[_xfa_object.$extra]) this[_xfa_object.$extra] = {
                            numberOfUse: 1,
                            pageIndex: -1,
                            pageSetIndex: -1
                        };
                        if (this.relation === "orderedOccurrence") {
                            if (this[_xfa_object.$extra].pageIndex + 1 < this.pageArea.children.length) {
                                this[_xfa_object.$extra].pageIndex += 1;
                                const pageArea = this.pageArea.children[this[_xfa_object.$extra].pageIndex];
                                return pageArea[_xfa_object.$getNextPage]();
                            }
                            if (this[_xfa_object.$extra].pageSetIndex + 1 < this.pageSet.children.length) {
                                this[_xfa_object.$extra].pageSetIndex += 1;
                                return this.pageSet.children[this[_xfa_object.$extra].pageSetIndex][_xfa_object.$getNextPage]();
                            }
                            if (this[_xfa_object.$isUsable]()) {
                                this[_xfa_object.$extra].numberOfUse += 1;
                                this[_xfa_object.$extra].pageIndex = -1;
                                this[_xfa_object.$extra].pageSetIndex = -1;
                                return this[_xfa_object.$getNextPage]();
                            }
                            const parent = this[_xfa_object.$getParent]();
                            if (parent instanceof PageSet) return parent[_xfa_object.$getNextPage]();
                            this[_xfa_object.$cleanPage]();
                            return this[_xfa_object.$getNextPage]();
                        }
                        const pageNumber = this[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].pageNumber;
                        const parity = pageNumber % 2 === 0 ? "even" : "odd";
                        const position = pageNumber === 0 ? "first" : "rest";
                        let page = this.pageArea.children.find((p)=>p.oddOrEven === parity && p.pagePosition === position);
                        if (page) return page;
                        page = this.pageArea.children.find((p)=>p.oddOrEven === "any" && p.pagePosition === position);
                        if (page) return page;
                        page = this.pageArea.children.find((p)=>p.oddOrEven === "any" && p.pagePosition === "any");
                        if (page) return page;
                        return this.pageArea.children[0];
                    }
                }
                class Para extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "para", true);
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.lineHeight = attributes.lineHeight ? (0, _utils.getMeasurement)(attributes.lineHeight, "0pt") : "";
                        this.marginLeft = attributes.marginLeft ? (0, _utils.getMeasurement)(attributes.marginLeft, "0pt") : "";
                        this.marginRight = attributes.marginRight ? (0, _utils.getMeasurement)(attributes.marginRight, "0pt") : "";
                        this.orphans = (0, _utils.getInteger)({
                            data: attributes.orphans,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.preserve = attributes.preserve || "";
                        this.radixOffset = attributes.radixOffset ? (0, _utils.getMeasurement)(attributes.radixOffset, "0pt") : "";
                        this.spaceAbove = attributes.spaceAbove ? (0, _utils.getMeasurement)(attributes.spaceAbove, "0pt") : "";
                        this.spaceBelow = attributes.spaceBelow ? (0, _utils.getMeasurement)(attributes.spaceBelow, "0pt") : "";
                        this.tabDefault = attributes.tabDefault ? (0, _utils.getMeasurement)(this.tabDefault) : "";
                        this.tabStops = (attributes.tabStops || "").trim().split(/\s+/).map((x, i)=>i % 2 === 1 ? (0, _utils.getMeasurement)(x) : x);
                        this.textIndent = attributes.textIndent ? (0, _utils.getMeasurement)(attributes.textIndent, "0pt") : "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.vAlign = (0, _utils.getStringOption)(attributes.vAlign, [
                            "top",
                            "bottom",
                            "middle"
                        ]);
                        this.widows = (0, _utils.getInteger)({
                            data: attributes.widows,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.hyphenation = null;
                    }
                    [_xfa_object.$toStyle]() {
                        const style = (0, _html_utils.toStyle)(this, "hAlign");
                        if (this.marginLeft !== "") style.paddingLeft = (0, _html_utils.measureToString)(this.marginLeft);
                        if (this.marginRight !== "") style.paddingight = (0, _html_utils.measureToString)(this.marginRight);
                        if (this.spaceAbove !== "") style.paddingTop = (0, _html_utils.measureToString)(this.spaceAbove);
                        if (this.spaceBelow !== "") style.paddingBottom = (0, _html_utils.measureToString)(this.spaceBelow);
                        if (this.textIndent !== "") {
                            style.textIndent = (0, _html_utils.measureToString)(this.textIndent);
                            (0, _html_utils.fixTextIndent)(style);
                        }
                        if (this.lineHeight > 0) style.lineHeight = (0, _html_utils.measureToString)(this.lineHeight);
                        if (this.tabDefault !== "") style.tabSize = (0, _html_utils.measureToString)(this.tabDefault);
                        this.tabStops.length;
                        if (this.hyphenatation) Object.assign(style, this.hyphenatation[_xfa_object.$toStyle]());
                        return style;
                    }
                }
                class PasswordEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "passwordEdit", true);
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.passwordChar = attributes.passwordChar || "*";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.margin = null;
                    }
                }
                class Pattern extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "pattern", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "crossHatch",
                            "crossDiagonal",
                            "diagonalLeft",
                            "diagonalRight",
                            "horizontal",
                            "vertical"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle](startColor) {
                        startColor = startColor ? startColor[_xfa_object.$toStyle]() : "#FFFFFF";
                        const endColor = this.color ? this.color[_xfa_object.$toStyle]() : "#000000";
                        const width = 5;
                        const cmd = "repeating-linear-gradient";
                        const colors = `${startColor},${startColor} ${width}px,${endColor} ${width}px,${endColor} ${2 * width}px`;
                        switch(this.type){
                            case "crossHatch":
                                return `${cmd}(to top,${colors}) ${cmd}(to right,${colors})`;
                            case "crossDiagonal":
                                return `${cmd}(45deg,${colors}) ${cmd}(-45deg,${colors})`;
                            case "diagonalLeft":
                                return `${cmd}(45deg,${colors})`;
                            case "diagonalRight":
                                return `${cmd}(-45deg,${colors})`;
                            case "horizontal":
                                return `${cmd}(to top,${colors})`;
                            case "vertical":
                                return `${cmd}(to right,${colors})`;
                        }
                        return "";
                    }
                }
                class Picture extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "picture");
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Proto extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "proto", true);
                        this.appearanceFilter = new _xfa_object.XFAObjectArray();
                        this.arc = new _xfa_object.XFAObjectArray();
                        this.area = new _xfa_object.XFAObjectArray();
                        this.assist = new _xfa_object.XFAObjectArray();
                        this.barcode = new _xfa_object.XFAObjectArray();
                        this.bindItems = new _xfa_object.XFAObjectArray();
                        this.bookend = new _xfa_object.XFAObjectArray();
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.border = new _xfa_object.XFAObjectArray();
                        this.break = new _xfa_object.XFAObjectArray();
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.button = new _xfa_object.XFAObjectArray();
                        this.calculate = new _xfa_object.XFAObjectArray();
                        this.caption = new _xfa_object.XFAObjectArray();
                        this.certificate = new _xfa_object.XFAObjectArray();
                        this.certificates = new _xfa_object.XFAObjectArray();
                        this.checkButton = new _xfa_object.XFAObjectArray();
                        this.choiceList = new _xfa_object.XFAObjectArray();
                        this.color = new _xfa_object.XFAObjectArray();
                        this.comb = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.contentArea = new _xfa_object.XFAObjectArray();
                        this.corner = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.dateTimeEdit = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.defaultUi = new _xfa_object.XFAObjectArray();
                        this.desc = new _xfa_object.XFAObjectArray();
                        this.digestMethod = new _xfa_object.XFAObjectArray();
                        this.digestMethods = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.edge = new _xfa_object.XFAObjectArray();
                        this.encoding = new _xfa_object.XFAObjectArray();
                        this.encodings = new _xfa_object.XFAObjectArray();
                        this.encrypt = new _xfa_object.XFAObjectArray();
                        this.encryptData = new _xfa_object.XFAObjectArray();
                        this.encryption = new _xfa_object.XFAObjectArray();
                        this.encryptionMethod = new _xfa_object.XFAObjectArray();
                        this.encryptionMethods = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.execute = new _xfa_object.XFAObjectArray();
                        this.extras = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.fill = new _xfa_object.XFAObjectArray();
                        this.filter = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.font = new _xfa_object.XFAObjectArray();
                        this.format = new _xfa_object.XFAObjectArray();
                        this.handler = new _xfa_object.XFAObjectArray();
                        this.hyphenation = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.imageEdit = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.issuers = new _xfa_object.XFAObjectArray();
                        this.items = new _xfa_object.XFAObjectArray();
                        this.keep = new _xfa_object.XFAObjectArray();
                        this.keyUsage = new _xfa_object.XFAObjectArray();
                        this.line = new _xfa_object.XFAObjectArray();
                        this.linear = new _xfa_object.XFAObjectArray();
                        this.lockDocument = new _xfa_object.XFAObjectArray();
                        this.manifest = new _xfa_object.XFAObjectArray();
                        this.margin = new _xfa_object.XFAObjectArray();
                        this.mdp = new _xfa_object.XFAObjectArray();
                        this.medium = new _xfa_object.XFAObjectArray();
                        this.message = new _xfa_object.XFAObjectArray();
                        this.numericEdit = new _xfa_object.XFAObjectArray();
                        this.occur = new _xfa_object.XFAObjectArray();
                        this.oid = new _xfa_object.XFAObjectArray();
                        this.oids = new _xfa_object.XFAObjectArray();
                        this.overflow = new _xfa_object.XFAObjectArray();
                        this.pageArea = new _xfa_object.XFAObjectArray();
                        this.pageSet = new _xfa_object.XFAObjectArray();
                        this.para = new _xfa_object.XFAObjectArray();
                        this.passwordEdit = new _xfa_object.XFAObjectArray();
                        this.pattern = new _xfa_object.XFAObjectArray();
                        this.picture = new _xfa_object.XFAObjectArray();
                        this.radial = new _xfa_object.XFAObjectArray();
                        this.reason = new _xfa_object.XFAObjectArray();
                        this.reasons = new _xfa_object.XFAObjectArray();
                        this.rectangle = new _xfa_object.XFAObjectArray();
                        this.ref = new _xfa_object.XFAObjectArray();
                        this.script = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                        this.signData = new _xfa_object.XFAObjectArray();
                        this.signature = new _xfa_object.XFAObjectArray();
                        this.signing = new _xfa_object.XFAObjectArray();
                        this.solid = new _xfa_object.XFAObjectArray();
                        this.speak = new _xfa_object.XFAObjectArray();
                        this.stipple = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                        this.subjectDN = new _xfa_object.XFAObjectArray();
                        this.subjectDNs = new _xfa_object.XFAObjectArray();
                        this.submit = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.textEdit = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                        this.timeStamp = new _xfa_object.XFAObjectArray();
                        this.toolTip = new _xfa_object.XFAObjectArray();
                        this.traversal = new _xfa_object.XFAObjectArray();
                        this.traverse = new _xfa_object.XFAObjectArray();
                        this.ui = new _xfa_object.XFAObjectArray();
                        this.validate = new _xfa_object.XFAObjectArray();
                        this.value = new _xfa_object.XFAObjectArray();
                        this.variables = new _xfa_object.XFAObjectArray();
                    }
                }
                class Radial extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "radial", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "toEdge",
                            "toCenter"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle](startColor) {
                        startColor = startColor ? startColor[_xfa_object.$toStyle]() : "#FFFFFF";
                        const endColor = this.color ? this.color[_xfa_object.$toStyle]() : "#000000";
                        const colors = this.type === "toEdge" ? `${startColor},${endColor}` : `${endColor},${startColor}`;
                        return `radial-gradient(circle at center, ${colors})`;
                    }
                }
                class Reason extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "reason");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Reasons extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "reasons", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.reason = new _xfa_object.XFAObjectArray();
                    }
                }
                class Rectangle extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "rectangle", true);
                        this.hand = (0, _utils.getStringOption)(attributes.hand, [
                            "even",
                            "left",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.corner = new _xfa_object.XFAObjectArray(4);
                        this.edge = new _xfa_object.XFAObjectArray(4);
                        this.fill = null;
                    }
                    [_xfa_object.$toHTML]() {
                        const edge = this.edge.children.length ? this.edge.children[0] : new Edge({});
                        const edgeStyle = edge[_xfa_object.$toStyle]();
                        const style = Object.create(null);
                        if (this.fill && this.fill.presence === "visible") Object.assign(style, this.fill[_xfa_object.$toStyle]());
                        else style.fill = "transparent";
                        style.strokeWidth = (0, _html_utils.measureToString)(edge.presence === "visible" ? edge.thickness : 0);
                        style.stroke = edgeStyle.color;
                        const corner = this.corner.children.length ? this.corner.children[0] : new Corner({});
                        const cornerStyle = corner[_xfa_object.$toStyle]();
                        const rect = {
                            name: "rect",
                            attributes: {
                                xmlns: SVG_NS,
                                width: "100%",
                                height: "100%",
                                x: 0,
                                y: 0,
                                rx: cornerStyle.radius,
                                ry: cornerStyle.radius,
                                style: style
                            }
                        };
                        const svg = {
                            name: "svg",
                            children: [
                                rect
                            ],
                            attributes: {
                                xmlns: SVG_NS,
                                style: {
                                    overflow: "visible"
                                },
                                width: "100%",
                                height: "100%"
                            }
                        };
                        const parent = this[_xfa_object.$getParent]()[_xfa_object.$getParent]();
                        if (hasMargin(parent)) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                style: {
                                    display: "inline",
                                    width: "100%",
                                    height: "100%"
                                }
                            },
                            children: [
                                svg
                            ]
                        });
                        svg.attributes.style.position = "absolute";
                        return _utils.HTMLResult.success(svg);
                    }
                }
                class RefElement extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "ref");
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Script extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "script");
                        this.binding = attributes.binding || "";
                        this.contentType = attributes.contentType || "";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.runAt = (0, _utils.getStringOption)(attributes.runAt, [
                            "client",
                            "both",
                            "server"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SetProperty extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "setProperty");
                        this.connection = attributes.connection || "";
                        this.ref = attributes.ref || "";
                        this.target = attributes.target || "";
                    }
                }
                exports.SetProperty = SetProperty;
                class SignData extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signData", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "sign",
                            "clear",
                            "verify"
                        ]);
                        this.ref = attributes.ref || "";
                        this.target = attributes.target || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.filter = null;
                        this.manifest = null;
                    }
                }
                class Signature extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signature", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "PDF1.3",
                            "PDF1.6"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.border = null;
                        this.extras = null;
                        this.filter = null;
                        this.manifest = null;
                        this.margin = null;
                    }
                }
                class Signing extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "signing", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.certificate = new _xfa_object.XFAObjectArray();
                    }
                }
                class Solid extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "solid", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle](startColor) {
                        return startColor ? startColor[_xfa_object.$toStyle]() : "#FFFFFF";
                    }
                }
                class Speak extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "speak");
                        this.disable = (0, _utils.getInteger)({
                            data: attributes.disable,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.id = attributes.id || "";
                        this.priority = (0, _utils.getStringOption)(attributes.priority, [
                            "custom",
                            "caption",
                            "name",
                            "toolTip"
                        ]);
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Stipple extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "stipple", true);
                        this.id = attributes.id || "";
                        this.rate = (0, _utils.getInteger)({
                            data: attributes.rate,
                            defaultValue: 50,
                            validate: (x)=>x >= 0 && x <= 100
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.color = null;
                        this.extras = null;
                    }
                    [_xfa_object.$toStyle](bgColor) {
                        const alpha = this.rate / 100;
                        return _util.Util.makeHexColor(Math.round(bgColor.value.r * (1 - alpha) + this.value.r * alpha), Math.round(bgColor.value.g * (1 - alpha) + this.value.g * alpha), Math.round(bgColor.value.b * (1 - alpha) + this.value.b * alpha));
                    }
                }
                class Subform extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subform", true);
                        this.access = (0, _utils.getStringOption)(attributes.access, [
                            "open",
                            "nonInteractive",
                            "protected",
                            "readOnly"
                        ]);
                        this.allowMacro = (0, _utils.getInteger)({
                            data: attributes.allowMacro,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.anchorType = (0, _utils.getStringOption)(attributes.anchorType, [
                            "topLeft",
                            "bottomCenter",
                            "bottomLeft",
                            "bottomRight",
                            "middleCenter",
                            "middleLeft",
                            "middleRight",
                            "topCenter",
                            "topRight"
                        ]);
                        this.colSpan = (0, _utils.getInteger)({
                            data: attributes.colSpan,
                            defaultValue: 1,
                            validate: (n)=>n >= 1 || n === -1
                        });
                        this.columnWidths = (attributes.columnWidths || "").trim().split(/\s+/).map((x)=>x === "-1" ? -1 : (0, _utils.getMeasurement)(x));
                        this.h = attributes.h ? (0, _utils.getMeasurement)(attributes.h) : "";
                        this.hAlign = (0, _utils.getStringOption)(attributes.hAlign, [
                            "left",
                            "center",
                            "justify",
                            "justifyAll",
                            "radix",
                            "right"
                        ]);
                        this.id = attributes.id || "";
                        this.layout = (0, _utils.getStringOption)(attributes.layout, [
                            "position",
                            "lr-tb",
                            "rl-row",
                            "rl-tb",
                            "row",
                            "table",
                            "tb"
                        ]);
                        this.locale = attributes.locale || "";
                        this.maxH = (0, _utils.getMeasurement)(attributes.maxH, "0pt");
                        this.maxW = (0, _utils.getMeasurement)(attributes.maxW, "0pt");
                        this.mergeMode = (0, _utils.getStringOption)(attributes.mergeMode, [
                            "consumeData",
                            "matchTemplate"
                        ]);
                        this.minH = (0, _utils.getMeasurement)(attributes.minH, "0pt");
                        this.minW = (0, _utils.getMeasurement)(attributes.minW, "0pt");
                        this.name = attributes.name || "";
                        this.presence = (0, _utils.getStringOption)(attributes.presence, [
                            "visible",
                            "hidden",
                            "inactive",
                            "invisible"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.restoreState = (0, _utils.getStringOption)(attributes.restoreState, [
                            "manual",
                            "auto"
                        ]);
                        this.scope = (0, _utils.getStringOption)(attributes.scope, [
                            "name",
                            "none"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.w = attributes.w ? (0, _utils.getMeasurement)(attributes.w) : "";
                        this.x = (0, _utils.getMeasurement)(attributes.x, "0pt");
                        this.y = (0, _utils.getMeasurement)(attributes.y, "0pt");
                        this.assist = null;
                        this.bind = null;
                        this.bookend = null;
                        this.border = null;
                        this.break = null;
                        this.calculate = null;
                        this.desc = null;
                        this.extras = null;
                        this.keep = null;
                        this.margin = null;
                        this.occur = null;
                        this.overflow = null;
                        this.pageSet = null;
                        this.para = null;
                        this.traversal = null;
                        this.validate = null;
                        this.variables = null;
                        this.area = new _xfa_object.XFAObjectArray();
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.connect = new _xfa_object.XFAObjectArray();
                        this.draw = new _xfa_object.XFAObjectArray();
                        this.event = new _xfa_object.XFAObjectArray();
                        this.exObject = new _xfa_object.XFAObjectArray();
                        this.exclGroup = new _xfa_object.XFAObjectArray();
                        this.field = new _xfa_object.XFAObjectArray();
                        this.proto = new _xfa_object.XFAObjectArray();
                        this.setProperty = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$getSubformParent]() {
                        const parent = this[_xfa_object.$getParent]();
                        if (parent instanceof SubformSet) return parent[_xfa_object.$getSubformParent]();
                        return parent;
                    }
                    [_xfa_object.$isBindable]() {
                        return true;
                    }
                    [_xfa_object.$isThereMoreWidth]() {
                        return this.layout.endsWith("-tb") && this[_xfa_object.$extra].attempt === 0 && this[_xfa_object.$extra].numberInLine > 0 || this[_xfa_object.$getParent]()[_xfa_object.$isThereMoreWidth]();
                    }
                    *[_xfa_object.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_xfa_object.$flushHTML]() {
                        return (0, _layout.flushHTML)(this);
                    }
                    [_xfa_object.$addHTML](html, bbox) {
                        (0, _layout.addHTML)(this, html, bbox);
                    }
                    [_xfa_object.$getAvailableSpace]() {
                        return (0, _layout.getAvailableSpace)(this);
                    }
                    [_xfa_object.$isSplittable]() {
                        const parent = this[_xfa_object.$getSubformParent]();
                        if (!parent[_xfa_object.$isSplittable]()) return false;
                        const contentArea = this[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].currentContentArea;
                        if (this.overflow && this.overflow[_xfa_object.$getExtra]().target === contentArea) return false;
                        if (this[_xfa_object.$extra]._isSplittable !== undefined) return this[_xfa_object.$extra]._isSplittable;
                        if (this.layout === "position" || this.layout.includes("row")) {
                            this[_xfa_object.$extra]._isSplittable = false;
                            return false;
                        }
                        if (this.keep && this.keep.intact !== "none") {
                            this[_xfa_object.$extra]._isSplittable = false;
                            return false;
                        }
                        if (parent.layout && parent.layout.endsWith("-tb") && parent[_xfa_object.$extra].numberInLine !== 0) return false;
                        this[_xfa_object.$extra]._isSplittable = true;
                        return true;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (this.break) {
                            if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                                const node = new BreakAfter({
                                    targetType: this.break.after,
                                    target: this.break.afterTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                node[_xfa_object.$globalData] = this[_xfa_object.$globalData];
                                this[_xfa_object.$appendChild](node);
                                this.breakAfter.push(node);
                            }
                            if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                                const node = new BreakBefore({
                                    targetType: this.break.before,
                                    target: this.break.beforeTarget,
                                    startNew: this.break.startNew.toString()
                                });
                                node[_xfa_object.$globalData] = this[_xfa_object.$globalData];
                                this[_xfa_object.$appendChild](node);
                                this.breakBefore.push(node);
                            }
                            if (this.break.overflowTarget !== "") {
                                const node = new Overflow({
                                    target: this.break.overflowTarget,
                                    leader: this.break.overflowLeader,
                                    trailer: this.break.overflowTrailer
                                });
                                node[_xfa_object.$globalData] = this[_xfa_object.$globalData];
                                this[_xfa_object.$appendChild](node);
                                this.overflow.push(node);
                            }
                            this[_xfa_object.$removeChild](this.break);
                            this.break = null;
                        }
                        if (this.presence === "hidden" || this.presence === "inactive") return _utils.HTMLResult.EMPTY;
                        if (this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) (0, _util.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug.");
                        if (this.breakBefore.children.length >= 1) {
                            const breakBefore = this.breakBefore.children[0];
                            if (handleBreak(breakBefore)) return _utils.HTMLResult.breakNode(breakBefore);
                        }
                        if (this[_xfa_object.$extra] && this[_xfa_object.$extra].afterBreakAfter) return _utils.HTMLResult.EMPTY;
                        (0, _html_utils.fixDimensions)(this);
                        const children = [];
                        const attributes = {
                            id: this[_xfa_object.$uid],
                            class: []
                        };
                        (0, _html_utils.setAccess)(this, attributes.class);
                        if (!this[_xfa_object.$extra]) this[_xfa_object.$extra] = Object.create(null);
                        Object.assign(this[_xfa_object.$extra], {
                            children: children,
                            line: null,
                            attributes: attributes,
                            attempt: 0,
                            numberInLine: 0,
                            availableSpace: {
                                width: Math.min(this.w || Infinity, availableSpace.width),
                                height: Math.min(this.h || Infinity, availableSpace.height)
                            },
                            width: 0,
                            height: 0,
                            prevHeight: 0,
                            currentWidth: 0
                        });
                        const root = this[_xfa_object.$getTemplateRoot]();
                        const currentContentArea = root[_xfa_object.$extra].currentContentArea;
                        const savedNoLayoutFailure = root[_xfa_object.$extra].noLayoutFailure;
                        if (this.overflow) root[_xfa_object.$extra].noLayoutFailure = root[_xfa_object.$extra].noLayoutFailure || this.overflow[_xfa_object.$getExtra]().target === currentContentArea;
                        const isSplittable = this[_xfa_object.$isSplittable]();
                        if (!isSplittable) setFirstUnsplittable(this);
                        if (!(0, _layout.checkDimensions)(this, availableSpace)) return _utils.HTMLResult.FAILURE;
                        const filter = new Set([
                            "area",
                            "draw",
                            "exclGroup",
                            "field",
                            "subform",
                            "subformSet"
                        ]);
                        if (this.layout.includes("row")) {
                            const columnWidths = this[_xfa_object.$getSubformParent]().columnWidths;
                            if (Array.isArray(columnWidths) && columnWidths.length > 0) {
                                this[_xfa_object.$extra].columnWidths = columnWidths;
                                this[_xfa_object.$extra].currentColumn = 0;
                            }
                        }
                        const style = (0, _html_utils.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign");
                        const classNames = [
                            "xfaSubform"
                        ];
                        const cl = (0, _html_utils.layoutClass)(this);
                        if (cl) classNames.push(cl);
                        attributes.style = style;
                        attributes.class = classNames;
                        if (this.name) attributes.xfaName = this.name;
                        if (this.overflow) {
                            const overflowExtra = this.overflow[_xfa_object.$getExtra]();
                            if (overflowExtra.addLeader) {
                                overflowExtra.addLeader = false;
                                handleOverflow(this, overflowExtra.leader, availableSpace);
                            }
                        }
                        const isLrTb = this.layout === "lr-tb" || this.layout === "rl-tb";
                        const maxRun = isLrTb ? MAX_ATTEMPTS_FOR_LRTB_LAYOUT : 1;
                        for(; this[_xfa_object.$extra].attempt < maxRun; this[_xfa_object.$extra].attempt++){
                            if (isLrTb && this[_xfa_object.$extra].attempt === MAX_ATTEMPTS_FOR_LRTB_LAYOUT - 1) this[_xfa_object.$extra].numberInLine = 0;
                            const result = this[_xfa_object.$childrenToHTML]({
                                filter: filter,
                                include: true
                            });
                            if (result.success) break;
                            if (result.isBreak()) return result;
                            if (isLrTb && this[_xfa_object.$extra].attempt === 0 && this[_xfa_object.$extra].numberInLine === 0 && !root[_xfa_object.$extra].noLayoutFailure) {
                                this[_xfa_object.$extra].attempt = maxRun;
                                break;
                            }
                        }
                        if (!isSplittable) unsetFirstUnsplittable(this);
                        root[_xfa_object.$extra].noLayoutFailure = savedNoLayoutFailure;
                        if (this[_xfa_object.$extra].attempt === maxRun) {
                            if (this.overflow) this[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].overflowNode = this.overflow;
                            if (!isSplittable) delete this[_xfa_object.$extra];
                            return _utils.HTMLResult.FAILURE;
                        }
                        if (this.overflow) {
                            const overflowExtra = this.overflow[_xfa_object.$getExtra]();
                            if (overflowExtra.addTrailer) {
                                overflowExtra.addTrailer = false;
                                handleOverflow(this, overflowExtra.trailer, availableSpace);
                            }
                        }
                        let marginH = 0;
                        let marginV = 0;
                        if (this.margin) {
                            marginH = this.margin.leftInset + this.margin.rightInset;
                            marginV = this.margin.topInset + this.margin.bottomInset;
                        }
                        const width = Math.max(this[_xfa_object.$extra].width + marginH, this.w || 0);
                        const height = Math.max(this[_xfa_object.$extra].height + marginV, this.h || 0);
                        const bbox = [
                            this.x,
                            this.y,
                            width,
                            height
                        ];
                        if (this.w === "") style.width = (0, _html_utils.measureToString)(width);
                        if (this.h === "") style.height = (0, _html_utils.measureToString)(height);
                        const html = {
                            name: "div",
                            attributes: attributes,
                            children: children
                        };
                        const assist = this.assist ? this.assist[_xfa_object.$toHTML]() : null;
                        if (assist) html.attributes.title = assist;
                        const result = _utils.HTMLResult.success((0, _html_utils.createWrapper)(this, html), bbox);
                        if (this.breakAfter.children.length >= 1) {
                            const breakAfter = this.breakAfter.children[0];
                            if (handleBreak(breakAfter)) {
                                this[_xfa_object.$extra].afterBreakAfter = result;
                                return _utils.HTMLResult.breakNode(breakAfter);
                            }
                        }
                        delete this[_xfa_object.$extra];
                        return result;
                    }
                }
                class SubformSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subformSet", true);
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.relation = (0, _utils.getStringOption)(attributes.relation, [
                            "ordered",
                            "choice",
                            "unordered"
                        ]);
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.bookend = null;
                        this.break = null;
                        this.desc = null;
                        this.extras = null;
                        this.occur = null;
                        this.overflow = null;
                        this.breakAfter = new _xfa_object.XFAObjectArray();
                        this.breakBefore = new _xfa_object.XFAObjectArray();
                        this.subform = new _xfa_object.XFAObjectArray();
                        this.subformSet = new _xfa_object.XFAObjectArray();
                    }
                    *[_xfa_object.$getContainedChildren]() {
                        yield* getContainedChildren(this);
                    }
                    [_xfa_object.$getSubformParent]() {
                        let parent = this[_xfa_object.$getParent]();
                        while(!(parent instanceof Subform))parent = parent[_xfa_object.$getParent]();
                        return parent;
                    }
                }
                class SubjectDN extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subjectDN");
                        this.delimiter = attributes.delimiter || ",";
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = new Map(this[_xfa_object.$content].split(this.delimiter).map((kv)=>{
                            kv = kv.split("=", 2);
                            kv[0] = kv[0].trim();
                            return kv;
                        }));
                    }
                }
                class SubjectDNs extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "subjectDNs", true);
                        this.id = attributes.id || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.subjectDN = new _xfa_object.XFAObjectArray();
                    }
                }
                class Submit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "submit", true);
                        this.embedPDF = (0, _utils.getInteger)({
                            data: attributes.embedPDF,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.format = (0, _utils.getStringOption)(attributes.format, [
                            "xdp",
                            "formdata",
                            "pdf",
                            "urlencoded",
                            "xfd",
                            "xml"
                        ]);
                        this.id = attributes.id || "";
                        this.target = attributes.target || "";
                        this.textEncoding = (0, _utils.getKeyword)({
                            data: attributes.textEncoding ? attributes.textEncoding.toLowerCase() : "",
                            defaultValue: "",
                            validate: (k)=>[
                                    "utf-8",
                                    "big-five",
                                    "fontspecific",
                                    "gbk",
                                    "gb-18030",
                                    "gb-2312",
                                    "ksc-5601",
                                    "none",
                                    "shift-jis",
                                    "ucs-2",
                                    "utf-16"
                                ].includes(k) || k.match(/iso-8859-[0-9]{2}/)
                        });
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.xdpContent = attributes.xdpContent || "";
                        this.encrypt = null;
                        this.encryptData = new _xfa_object.XFAObjectArray();
                        this.signData = new _xfa_object.XFAObjectArray();
                    }
                }
                class Template extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "template", true);
                        this.baseProfile = (0, _utils.getStringOption)(attributes.baseProfile, [
                            "full",
                            "interactiveForms"
                        ]);
                        this.extras = null;
                        this.subform = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$finalize]() {
                        if (this.subform.children.length === 0) (0, _util.warn)("XFA - No subforms in template node.");
                        if (this.subform.children.length >= 2) (0, _util.warn)("XFA - Several subforms in template node: please file a bug.");
                        this[_xfa_object.$tabIndex] = 1000;
                    }
                    [_xfa_object.$isSplittable]() {
                        return true;
                    }
                    [_xfa_object.$searchNode](expr, container) {
                        if (expr.startsWith("#")) return [
                            this[_xfa_object.$ids].get(expr.slice(1))
                        ];
                        return (0, _som.searchNode)(this, container, expr, true, true);
                    }
                    [_xfa_object.$toHTML]() {
                        if (!this.subform.children.length) return _utils.HTMLResult.success({
                            name: "div",
                            children: []
                        });
                        this[_xfa_object.$extra] = {
                            overflowNode: null,
                            firstUnsplittable: null,
                            currentContentArea: null,
                            currentPageArea: null,
                            noLayoutFailure: false,
                            pageNumber: 1,
                            pagePosition: "first",
                            oddOrEven: "odd",
                            blankOrNotBlank: "nonBlank"
                        };
                        const root = this.subform.children[0];
                        root.pageSet[_xfa_object.$cleanPage]();
                        const pageAreas = root.pageSet.pageArea.children;
                        const mainHtml = {
                            name: "div",
                            children: []
                        };
                        let pageArea = null;
                        let breakBefore = null;
                        let breakBeforeTarget = null;
                        if (root.breakBefore.children.length >= 1) {
                            breakBefore = root.breakBefore.children[0];
                            breakBeforeTarget = breakBefore.target;
                        } else if (root.subform.children.length >= 1 && root.subform.children[0].breakBefore.children.length >= 1) {
                            breakBefore = root.subform.children[0].breakBefore.children[0];
                            breakBeforeTarget = breakBefore.target;
                        } else if (root.break && root.break.beforeTarget) {
                            breakBefore = root.break;
                            breakBeforeTarget = breakBefore.beforeTarget;
                        } else if (root.subform.children.length >= 1 && root.subform.children[0].break && root.subform.children[0].break.beforeTarget) {
                            breakBefore = root.subform.children[0].break;
                            breakBeforeTarget = breakBefore.beforeTarget;
                        }
                        if (breakBefore) {
                            const target = this[_xfa_object.$searchNode](breakBeforeTarget, breakBefore[_xfa_object.$getParent]());
                            if (target instanceof PageArea) {
                                pageArea = target;
                                breakBefore[_xfa_object.$extra] = {};
                            }
                        }
                        if (!pageArea) pageArea = pageAreas[0];
                        pageArea[_xfa_object.$extra] = {
                            numberOfUse: 1
                        };
                        const pageAreaParent = pageArea[_xfa_object.$getParent]();
                        pageAreaParent[_xfa_object.$extra] = {
                            numberOfUse: 1,
                            pageIndex: pageAreaParent.pageArea.children.indexOf(pageArea),
                            pageSetIndex: 0
                        };
                        let targetPageArea;
                        let leader = null;
                        let trailer = null;
                        let hasSomething = true;
                        let hasSomethingCounter = 0;
                        let startIndex = 0;
                        while(true){
                            if (!hasSomething) {
                                mainHtml.children.pop();
                                if (++hasSomethingCounter === MAX_EMPTY_PAGES) {
                                    (0, _util.warn)("XFA - Something goes wrong: please file a bug.");
                                    return mainHtml;
                                }
                            } else hasSomethingCounter = 0;
                            targetPageArea = null;
                            this[_xfa_object.$extra].currentPageArea = pageArea;
                            const page = pageArea[_xfa_object.$toHTML]().html;
                            mainHtml.children.push(page);
                            if (leader) {
                                this[_xfa_object.$extra].noLayoutFailure = true;
                                page.children.push(leader[_xfa_object.$toHTML](pageArea[_xfa_object.$extra].space).html);
                                leader = null;
                            }
                            if (trailer) {
                                this[_xfa_object.$extra].noLayoutFailure = true;
                                page.children.push(trailer[_xfa_object.$toHTML](pageArea[_xfa_object.$extra].space).html);
                                trailer = null;
                            }
                            const contentAreas = pageArea.contentArea.children;
                            const htmlContentAreas = page.children.filter((node)=>node.attributes.class.includes("xfaContentarea"));
                            hasSomething = false;
                            this[_xfa_object.$extra].firstUnsplittable = null;
                            this[_xfa_object.$extra].noLayoutFailure = false;
                            const flush = (index)=>{
                                const html = root[_xfa_object.$flushHTML]();
                                if (html) {
                                    hasSomething = hasSomething || html.children && html.children.length !== 0;
                                    htmlContentAreas[index].children.push(html);
                                }
                            };
                            for(let i = startIndex, ii = contentAreas.length; i < ii; i++){
                                const contentArea = this[_xfa_object.$extra].currentContentArea = contentAreas[i];
                                const space = {
                                    width: contentArea.w,
                                    height: contentArea.h
                                };
                                startIndex = 0;
                                if (leader) {
                                    htmlContentAreas[i].children.push(leader[_xfa_object.$toHTML](space).html);
                                    leader = null;
                                }
                                if (trailer) {
                                    htmlContentAreas[i].children.push(trailer[_xfa_object.$toHTML](space).html);
                                    trailer = null;
                                }
                                const html = root[_xfa_object.$toHTML](space);
                                if (html.success) {
                                    if (html.html) {
                                        hasSomething = hasSomething || html.html.children && html.html.children.length !== 0;
                                        htmlContentAreas[i].children.push(html.html);
                                    } else if (!hasSomething) mainHtml.children.pop();
                                    return mainHtml;
                                }
                                if (html.isBreak()) {
                                    const node = html.breakNode;
                                    flush(i);
                                    if (node.targetType === "auto") continue;
                                    if (node.leader) {
                                        leader = this[_xfa_object.$searchNode](node.leader, node[_xfa_object.$getParent]());
                                        leader = leader ? leader[0] : null;
                                    }
                                    if (node.trailer) {
                                        trailer = this[_xfa_object.$searchNode](node.trailer, node[_xfa_object.$getParent]());
                                        trailer = trailer ? trailer[0] : null;
                                    }
                                    if (node.targetType === "pageArea") {
                                        targetPageArea = node[_xfa_object.$extra].target;
                                        i = Infinity;
                                    } else if (!node[_xfa_object.$extra].target) i = node[_xfa_object.$extra].index;
                                    else {
                                        targetPageArea = node[_xfa_object.$extra].target;
                                        startIndex = node[_xfa_object.$extra].index + 1;
                                        i = Infinity;
                                    }
                                    continue;
                                }
                                if (this[_xfa_object.$extra].overflowNode) {
                                    const node = this[_xfa_object.$extra].overflowNode;
                                    this[_xfa_object.$extra].overflowNode = null;
                                    const overflowExtra = node[_xfa_object.$getExtra]();
                                    const target = overflowExtra.target;
                                    overflowExtra.addLeader = overflowExtra.leader !== null;
                                    overflowExtra.addTrailer = overflowExtra.trailer !== null;
                                    flush(i);
                                    i = Infinity;
                                    if (target instanceof PageArea) targetPageArea = target;
                                    else if (target instanceof ContentArea) {
                                        const index = contentAreas.findIndex((e)=>e === target);
                                        if (index !== -1) i = index - 1;
                                        else {
                                            targetPageArea = target[_xfa_object.$getParent]();
                                            startIndex = targetPageArea.contentArea.children.findIndex((e)=>e === target);
                                        }
                                    }
                                    continue;
                                }
                                flush(i);
                            }
                            this[_xfa_object.$extra].pageNumber += 1;
                            if (targetPageArea) {
                                if (targetPageArea[_xfa_object.$isUsable]()) targetPageArea[_xfa_object.$extra].numberOfUse += 1;
                                else targetPageArea = null;
                            }
                            pageArea = targetPageArea || pageArea[_xfa_object.$getNextPage]();
                        }
                    }
                }
                exports.Template = Template;
                class Text extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "text");
                        this.id = attributes.id || "";
                        this.maxChars = (0, _utils.getInteger)({
                            data: attributes.maxChars,
                            defaultValue: 0,
                            validate: (x)=>x >= 0
                        });
                        this.name = attributes.name || "";
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$acceptWhitespace]() {
                        return true;
                    }
                    [_xfa_object.$onChild](child) {
                        if (child[_xfa_object.$namespaceId] === _namespaces.NamespaceIds.xhtml.id) {
                            this[_xfa_object.$content] = child;
                            return true;
                        }
                        (0, _util.warn)(`XFA - Invalid content in Text: ${child[_xfa_object.$nodeName]}.`);
                        return false;
                    }
                    [_xfa_object.$onText](str) {
                        if (this[_xfa_object.$content] instanceof _xfa_object.XFAObject) return;
                        super[_xfa_object.$onText](str);
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        if (typeof this[_xfa_object.$content] === "string") {
                            const html = valueToHtml(this[_xfa_object.$content]).html;
                            if (this[_xfa_object.$content].includes("\u2029")) {
                                html.name = "div";
                                html.children = [];
                                this[_xfa_object.$content].split("\u2029").map((para)=>para.split(/[\u2028\n]/).reduce((acc, line)=>{
                                        acc.push({
                                            name: "span",
                                            value: line
                                        }, {
                                            name: "br"
                                        });
                                        return acc;
                                    }, [])).forEach((lines)=>{
                                    html.children.push({
                                        name: "p",
                                        children: lines
                                    });
                                });
                            } else if (/[\u2028\n]/.test(this[_xfa_object.$content])) {
                                html.name = "div";
                                html.children = [];
                                this[_xfa_object.$content].split(/[\u2028\n]/).forEach((line)=>{
                                    html.children.push({
                                        name: "span",
                                        value: line
                                    }, {
                                        name: "br"
                                    });
                                });
                            }
                            return _utils.HTMLResult.success(html);
                        }
                        return this[_xfa_object.$content][_xfa_object.$toHTML](availableSpace);
                    }
                }
                exports.Text = Text;
                class TextEdit extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "textEdit", true);
                        this.allowRichText = (0, _utils.getInteger)({
                            data: attributes.allowRichText,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.hScrollPolicy = (0, _utils.getStringOption)(attributes.hScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.id = attributes.id || "";
                        this.multiLine = attributes.multiLine || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.vScrollPolicy = (0, _utils.getStringOption)(attributes.vScrollPolicy, [
                            "auto",
                            "off",
                            "on"
                        ]);
                        this.border = null;
                        this.comb = null;
                        this.extras = null;
                        this.margin = null;
                    }
                    [_xfa_object.$clean](builder) {
                        super[_xfa_object.$clean](builder);
                        const parent = this[_xfa_object.$getParent]();
                        const defaultValue = parent instanceof Draw ? 1 : 0;
                        this.multiLine = (0, _utils.getInteger)({
                            data: this.multiLine,
                            defaultValue: defaultValue,
                            validate: (x)=>x === 0 || x === 1
                        });
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const style = (0, _html_utils.toStyle)(this, "border", "font", "margin");
                        let html;
                        const field = this[_xfa_object.$getParent]()[_xfa_object.$getParent]();
                        if (this.multiLine === 1) html = {
                            name: "textarea",
                            attributes: {
                                dataId: field[_xfa_object.$data] && field[_xfa_object.$data][_xfa_object.$uid] || field[_xfa_object.$uid],
                                fieldId: field[_xfa_object.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style
                            }
                        };
                        else html = {
                            name: "input",
                            attributes: {
                                type: "text",
                                dataId: field[_xfa_object.$data] && field[_xfa_object.$data][_xfa_object.$uid] || field[_xfa_object.$uid],
                                fieldId: field[_xfa_object.$uid],
                                class: [
                                    "xfaTextfield"
                                ],
                                style: style
                            }
                        };
                        return _utils.HTMLResult.success({
                            name: "label",
                            attributes: {
                                class: [
                                    "xfaLabel"
                                ]
                            },
                            children: [
                                html
                            ]
                        });
                    }
                }
                class Time extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "time");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                    [_xfa_object.$finalize]() {
                        const date = this[_xfa_object.$content].trim();
                        this[_xfa_object.$content] = date ? new Date(date) : null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return valueToHtml(this[_xfa_object.$content] ? this[_xfa_object.$content].toString() : "");
                    }
                }
                class TimeStamp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "timeStamp");
                        this.id = attributes.id || "";
                        this.server = attributes.server || "";
                        this.type = (0, _utils.getStringOption)(attributes.type, [
                            "optional",
                            "required"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class ToolTip extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "toolTip");
                        this.id = attributes.id || "";
                        this.rid = attributes.rid || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Traversal extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "traversal", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.traverse = new _xfa_object.XFAObjectArray();
                    }
                }
                class Traverse extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "traverse", true);
                        this.id = attributes.id || "";
                        this.operation = (0, _utils.getStringOption)(attributes.operation, [
                            "next",
                            "back",
                            "down",
                            "first",
                            "left",
                            "right",
                            "up"
                        ]);
                        this.ref = attributes.ref || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.script = null;
                    }
                    get name() {
                        return this.operation;
                    }
                    [_xfa_object.$isTransparent]() {
                        return false;
                    }
                }
                class Ui extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "ui", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.picture = null;
                        this.barcode = null;
                        this.button = null;
                        this.checkButton = null;
                        this.choiceList = null;
                        this.dateTimeEdit = null;
                        this.defaultUi = null;
                        this.imageEdit = null;
                        this.numericEdit = null;
                        this.passwordEdit = null;
                        this.signature = null;
                        this.textEdit = null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (name === "extras" || name === "picture") continue;
                            const obj = this[name];
                            if (!(obj instanceof _xfa_object.XFAObject)) continue;
                            return obj[_xfa_object.$toHTML](availableSpace);
                        }
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                class Validate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "validate", true);
                        this.formatTest = (0, _utils.getStringOption)(attributes.formatTest, [
                            "warning",
                            "disabled",
                            "error"
                        ]);
                        this.id = attributes.id || "";
                        this.nullTest = (0, _utils.getStringOption)(attributes.nullTest, [
                            "disabled",
                            "error",
                            "warning"
                        ]);
                        this.scriptTest = (0, _utils.getStringOption)(attributes.scriptTest, [
                            "error",
                            "disabled",
                            "warning"
                        ]);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.extras = null;
                        this.message = null;
                        this.picture = null;
                        this.script = null;
                    }
                }
                class Value extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "value", true);
                        this.id = attributes.id || "";
                        this.override = (0, _utils.getInteger)({
                            data: attributes.override,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.relevant = (0, _utils.getRelevant)(attributes.relevant);
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.arc = null;
                        this.boolean = null;
                        this.date = null;
                        this.dateTime = null;
                        this.decimal = null;
                        this.exData = null;
                        this.float = null;
                        this.image = null;
                        this.integer = null;
                        this.line = null;
                        this.rectangle = null;
                        this.text = null;
                        this.time = null;
                    }
                    [_xfa_object.$setValue](value) {
                        const parent = this[_xfa_object.$getParent]();
                        if (parent instanceof Field) {
                            if (parent.ui && parent.ui.imageEdit) {
                                if (!this.image) this.image = new Image({});
                                this.image[_xfa_object.$content] = value[_xfa_object.$content];
                                return;
                            }
                        }
                        const valueName = value[_xfa_object.$nodeName];
                        if (this[valueName] !== null) {
                            this[valueName][_xfa_object.$content] = value[_xfa_object.$content];
                            return;
                        }
                        for (const name of Object.getOwnPropertyNames(this)){
                            const obj = this[name];
                            if (obj instanceof _xfa_object.XFAObject) {
                                this[name] = null;
                                this[_xfa_object.$removeChild](obj);
                            }
                        }
                        this[value[_xfa_object.$nodeName]] = value;
                        this[_xfa_object.$appendChild](value);
                    }
                    [_xfa_object.$text]() {
                        if (this.exData) return this.exData[_xfa_object.$content][_xfa_object.$text]().trim();
                        for (const name of Object.getOwnPropertyNames(this)){
                            if (name === "image") continue;
                            const obj = this[name];
                            if (obj instanceof _xfa_object.XFAObject) return (obj[_xfa_object.$content] || "").toString().trim();
                        }
                        return null;
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        for (const name of Object.getOwnPropertyNames(this)){
                            const obj = this[name];
                            if (!(obj instanceof _xfa_object.XFAObject)) continue;
                            return obj[_xfa_object.$toHTML](availableSpace);
                        }
                        return _utils.HTMLResult.EMPTY;
                    }
                }
                exports.Value = Value;
                class Variables extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(TEMPLATE_NS_ID, "variables", true);
                        this.id = attributes.id || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                        this.boolean = new _xfa_object.XFAObjectArray();
                        this.date = new _xfa_object.XFAObjectArray();
                        this.dateTime = new _xfa_object.XFAObjectArray();
                        this.decimal = new _xfa_object.XFAObjectArray();
                        this.exData = new _xfa_object.XFAObjectArray();
                        this.float = new _xfa_object.XFAObjectArray();
                        this.image = new _xfa_object.XFAObjectArray();
                        this.integer = new _xfa_object.XFAObjectArray();
                        this.manifest = new _xfa_object.XFAObjectArray();
                        this.script = new _xfa_object.XFAObjectArray();
                        this.text = new _xfa_object.XFAObjectArray();
                        this.time = new _xfa_object.XFAObjectArray();
                    }
                    [_xfa_object.$isTransparent]() {
                        return true;
                    }
                }
                class TemplateNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (TemplateNamespace.hasOwnProperty(name)) {
                            const node = TemplateNamespace[name](attributes);
                            node[_xfa_object.$setSetAttributes](attributes);
                            return node;
                        }
                        return undefined;
                    }
                    static appearanceFilter(attrs) {
                        return new AppearanceFilter(attrs);
                    }
                    static arc(attrs) {
                        return new Arc(attrs);
                    }
                    static area(attrs) {
                        return new Area(attrs);
                    }
                    static assist(attrs) {
                        return new Assist(attrs);
                    }
                    static barcode(attrs) {
                        return new Barcode(attrs);
                    }
                    static bind(attrs) {
                        return new Bind(attrs);
                    }
                    static bindItems(attrs) {
                        return new BindItems(attrs);
                    }
                    static bookend(attrs) {
                        return new Bookend(attrs);
                    }
                    static boolean(attrs) {
                        return new BooleanElement(attrs);
                    }
                    static border(attrs) {
                        return new Border(attrs);
                    }
                    static break(attrs) {
                        return new Break(attrs);
                    }
                    static breakAfter(attrs) {
                        return new BreakAfter(attrs);
                    }
                    static breakBefore(attrs) {
                        return new BreakBefore(attrs);
                    }
                    static button(attrs) {
                        return new Button(attrs);
                    }
                    static calculate(attrs) {
                        return new Calculate(attrs);
                    }
                    static caption(attrs) {
                        return new Caption(attrs);
                    }
                    static certificate(attrs) {
                        return new Certificate(attrs);
                    }
                    static certificates(attrs) {
                        return new Certificates(attrs);
                    }
                    static checkButton(attrs) {
                        return new CheckButton(attrs);
                    }
                    static choiceList(attrs) {
                        return new ChoiceList(attrs);
                    }
                    static color(attrs) {
                        return new Color(attrs);
                    }
                    static comb(attrs) {
                        return new Comb(attrs);
                    }
                    static connect(attrs) {
                        return new Connect(attrs);
                    }
                    static contentArea(attrs) {
                        return new ContentArea(attrs);
                    }
                    static corner(attrs) {
                        return new Corner(attrs);
                    }
                    static date(attrs) {
                        return new DateElement(attrs);
                    }
                    static dateTime(attrs) {
                        return new DateTime(attrs);
                    }
                    static dateTimeEdit(attrs) {
                        return new DateTimeEdit(attrs);
                    }
                    static decimal(attrs) {
                        return new Decimal(attrs);
                    }
                    static defaultUi(attrs) {
                        return new DefaultUi(attrs);
                    }
                    static desc(attrs) {
                        return new Desc(attrs);
                    }
                    static digestMethod(attrs) {
                        return new DigestMethod(attrs);
                    }
                    static digestMethods(attrs) {
                        return new DigestMethods(attrs);
                    }
                    static draw(attrs) {
                        return new Draw(attrs);
                    }
                    static edge(attrs) {
                        return new Edge(attrs);
                    }
                    static encoding(attrs) {
                        return new Encoding(attrs);
                    }
                    static encodings(attrs) {
                        return new Encodings(attrs);
                    }
                    static encrypt(attrs) {
                        return new Encrypt(attrs);
                    }
                    static encryptData(attrs) {
                        return new EncryptData(attrs);
                    }
                    static encryption(attrs) {
                        return new Encryption(attrs);
                    }
                    static encryptionMethod(attrs) {
                        return new EncryptionMethod(attrs);
                    }
                    static encryptionMethods(attrs) {
                        return new EncryptionMethods(attrs);
                    }
                    static event(attrs) {
                        return new Event(attrs);
                    }
                    static exData(attrs) {
                        return new ExData(attrs);
                    }
                    static exObject(attrs) {
                        return new ExObject(attrs);
                    }
                    static exclGroup(attrs) {
                        return new ExclGroup(attrs);
                    }
                    static execute(attrs) {
                        return new Execute(attrs);
                    }
                    static extras(attrs) {
                        return new Extras(attrs);
                    }
                    static field(attrs) {
                        return new Field(attrs);
                    }
                    static fill(attrs) {
                        return new Fill(attrs);
                    }
                    static filter(attrs) {
                        return new Filter(attrs);
                    }
                    static float(attrs) {
                        return new Float(attrs);
                    }
                    static font(attrs) {
                        return new Font(attrs);
                    }
                    static format(attrs) {
                        return new Format(attrs);
                    }
                    static handler(attrs) {
                        return new Handler(attrs);
                    }
                    static hyphenation(attrs) {
                        return new Hyphenation(attrs);
                    }
                    static image(attrs) {
                        return new Image(attrs);
                    }
                    static imageEdit(attrs) {
                        return new ImageEdit(attrs);
                    }
                    static integer(attrs) {
                        return new Integer(attrs);
                    }
                    static issuers(attrs) {
                        return new Issuers(attrs);
                    }
                    static items(attrs) {
                        return new Items(attrs);
                    }
                    static keep(attrs) {
                        return new Keep(attrs);
                    }
                    static keyUsage(attrs) {
                        return new KeyUsage(attrs);
                    }
                    static line(attrs) {
                        return new Line(attrs);
                    }
                    static linear(attrs) {
                        return new Linear(attrs);
                    }
                    static lockDocument(attrs) {
                        return new LockDocument(attrs);
                    }
                    static manifest(attrs) {
                        return new Manifest(attrs);
                    }
                    static margin(attrs) {
                        return new Margin(attrs);
                    }
                    static mdp(attrs) {
                        return new Mdp(attrs);
                    }
                    static medium(attrs) {
                        return new Medium(attrs);
                    }
                    static message(attrs) {
                        return new Message(attrs);
                    }
                    static numericEdit(attrs) {
                        return new NumericEdit(attrs);
                    }
                    static occur(attrs) {
                        return new Occur(attrs);
                    }
                    static oid(attrs) {
                        return new Oid(attrs);
                    }
                    static oids(attrs) {
                        return new Oids(attrs);
                    }
                    static overflow(attrs) {
                        return new Overflow(attrs);
                    }
                    static pageArea(attrs) {
                        return new PageArea(attrs);
                    }
                    static pageSet(attrs) {
                        return new PageSet(attrs);
                    }
                    static para(attrs) {
                        return new Para(attrs);
                    }
                    static passwordEdit(attrs) {
                        return new PasswordEdit(attrs);
                    }
                    static pattern(attrs) {
                        return new Pattern(attrs);
                    }
                    static picture(attrs) {
                        return new Picture(attrs);
                    }
                    static proto(attrs) {
                        return new Proto(attrs);
                    }
                    static radial(attrs) {
                        return new Radial(attrs);
                    }
                    static reason(attrs) {
                        return new Reason(attrs);
                    }
                    static reasons(attrs) {
                        return new Reasons(attrs);
                    }
                    static rectangle(attrs) {
                        return new Rectangle(attrs);
                    }
                    static ref(attrs) {
                        return new RefElement(attrs);
                    }
                    static script(attrs) {
                        return new Script(attrs);
                    }
                    static setProperty(attrs) {
                        return new SetProperty(attrs);
                    }
                    static signData(attrs) {
                        return new SignData(attrs);
                    }
                    static signature(attrs) {
                        return new Signature(attrs);
                    }
                    static signing(attrs) {
                        return new Signing(attrs);
                    }
                    static solid(attrs) {
                        return new Solid(attrs);
                    }
                    static speak(attrs) {
                        return new Speak(attrs);
                    }
                    static stipple(attrs) {
                        return new Stipple(attrs);
                    }
                    static subform(attrs) {
                        return new Subform(attrs);
                    }
                    static subformSet(attrs) {
                        return new SubformSet(attrs);
                    }
                    static subjectDN(attrs) {
                        return new SubjectDN(attrs);
                    }
                    static subjectDNs(attrs) {
                        return new SubjectDNs(attrs);
                    }
                    static submit(attrs) {
                        return new Submit(attrs);
                    }
                    static template(attrs) {
                        return new Template(attrs);
                    }
                    static text(attrs) {
                        return new Text(attrs);
                    }
                    static textEdit(attrs) {
                        return new TextEdit(attrs);
                    }
                    static time(attrs) {
                        return new Time(attrs);
                    }
                    static timeStamp(attrs) {
                        return new TimeStamp(attrs);
                    }
                    static toolTip(attrs) {
                        return new ToolTip(attrs);
                    }
                    static traversal(attrs) {
                        return new Traversal(attrs);
                    }
                    static traverse(attrs) {
                        return new Traverse(attrs);
                    }
                    static ui(attrs) {
                        return new Ui(attrs);
                    }
                    static validate(attrs) {
                        return new Validate(attrs);
                    }
                    static value(attrs) {
                        return new Value(attrs);
                    }
                    static variables(attrs) {
                        return new Variables(attrs);
                    }
                }
                exports.TemplateNamespace = TemplateNamespace;
            /***/ },
            /* 81 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addHTML = addHTML;
                exports.checkDimensions = checkDimensions;
                exports.flushHTML = flushHTML;
                exports.getAvailableSpace = getAvailableSpace;
                var _xfa_object = __w_pdfjs_require__(75);
                var _html_utils = __w_pdfjs_require__(82);
                function createLine(node, children) {
                    return {
                        name: "div",
                        attributes: {
                            class: [
                                node.layout === "lr-tb" ? "xfaLr" : "xfaRl"
                            ]
                        },
                        children: children
                    };
                }
                function flushHTML(node) {
                    if (!node[_xfa_object.$extra]) return null;
                    const attributes = node[_xfa_object.$extra].attributes;
                    const html = {
                        name: "div",
                        attributes: attributes,
                        children: node[_xfa_object.$extra].children
                    };
                    if (node[_xfa_object.$extra].failingNode) {
                        const htmlFromFailing = node[_xfa_object.$extra].failingNode[_xfa_object.$flushHTML]();
                        if (htmlFromFailing) {
                            if (node.layout.endsWith("-tb")) html.children.push(createLine(node, [
                                htmlFromFailing
                            ]));
                            else html.children.push(htmlFromFailing);
                        }
                    }
                    if (html.children.length === 0) return null;
                    return html;
                }
                function addHTML(node, html, bbox) {
                    const extra = node[_xfa_object.$extra];
                    const availableSpace = extra.availableSpace;
                    const [x, y, w, h] = bbox;
                    switch(node.layout){
                        case "position":
                            extra.width = Math.max(extra.width, x + w);
                            extra.height = Math.max(extra.height, y + h);
                            extra.children.push(html);
                            break;
                        case "lr-tb":
                        case "rl-tb":
                            if (!extra.line || extra.attempt === 1) {
                                extra.line = createLine(node, []);
                                extra.children.push(extra.line);
                                extra.numberInLine = 0;
                            }
                            extra.numberInLine += 1;
                            extra.line.children.push(html);
                            if (extra.attempt === 0) {
                                extra.currentWidth += w;
                                extra.height = Math.max(extra.height, extra.prevHeight + h);
                            } else {
                                extra.currentWidth = w;
                                extra.prevHeight = extra.height;
                                extra.height += h;
                                extra.attempt = 0;
                            }
                            extra.width = Math.max(extra.width, extra.currentWidth);
                            break;
                        case "rl-row":
                        case "row":
                            {
                                extra.children.push(html);
                                extra.width += w;
                                extra.height = Math.max(extra.height, h);
                                const height = (0, _html_utils.measureToString)(extra.height);
                                for (const child of extra.children)child.attributes.style.height = height;
                                break;
                            }
                        case "table":
                            extra.width = Math.min(availableSpace.width, Math.max(extra.width, w));
                            extra.height += h;
                            extra.children.push(html);
                            break;
                        case "tb":
                            extra.width = availableSpace.width;
                            extra.height += h;
                            extra.children.push(html);
                            break;
                    }
                }
                function getAvailableSpace(node) {
                    const availableSpace = node[_xfa_object.$extra].availableSpace;
                    const marginV = node.margin ? node.margin.topInset + node.margin.bottomInset : 0;
                    const marginH = node.margin ? node.margin.leftInset + node.margin.rightInset : 0;
                    switch(node.layout){
                        case "lr-tb":
                        case "rl-tb":
                            if (node[_xfa_object.$extra].attempt === 0) return {
                                width: availableSpace.width - marginH - node[_xfa_object.$extra].currentWidth,
                                height: availableSpace.height - marginV - node[_xfa_object.$extra].prevHeight
                            };
                            return {
                                width: availableSpace.width - marginH,
                                height: availableSpace.height - marginV - node[_xfa_object.$extra].height
                            };
                        case "rl-row":
                        case "row":
                            const width = node[_xfa_object.$extra].columnWidths.slice(node[_xfa_object.$extra].currentColumn).reduce((a, x)=>a + x);
                            return {
                                width: width,
                                height: availableSpace.height - marginH
                            };
                        case "table":
                        case "tb":
                            return {
                                width: availableSpace.width - marginH,
                                height: availableSpace.height - marginV - node[_xfa_object.$extra].height
                            };
                        case "position":
                        default:
                            return availableSpace;
                    }
                }
                function getTransformedBBox(node) {
                    let w = node.w === "" ? NaN : node.w;
                    let h = node.h === "" ? NaN : node.h;
                    let [centerX, centerY] = [
                        0,
                        0
                    ];
                    switch(node.anchorType || ""){
                        case "bottomCenter":
                            [centerX, centerY] = [
                                w / 2,
                                h
                            ];
                            break;
                        case "bottomLeft":
                            [centerX, centerY] = [
                                0,
                                h
                            ];
                            break;
                        case "bottomRight":
                            [centerX, centerY] = [
                                w,
                                h
                            ];
                            break;
                        case "middleCenter":
                            [centerX, centerY] = [
                                w / 2,
                                h / 2
                            ];
                            break;
                        case "middleLeft":
                            [centerX, centerY] = [
                                0,
                                h / 2
                            ];
                            break;
                        case "middleRight":
                            [centerX, centerY] = [
                                w,
                                h / 2
                            ];
                            break;
                        case "topCenter":
                            [centerX, centerY] = [
                                w / 2,
                                0
                            ];
                            break;
                        case "topRight":
                            [centerX, centerY] = [
                                w,
                                0
                            ];
                            break;
                    }
                    let x, y;
                    switch(node.rotate || 0){
                        case 0:
                            [x, y] = [
                                -centerX,
                                -centerY
                            ];
                            break;
                        case 90:
                            [x, y] = [
                                -centerY,
                                centerX
                            ];
                            [w, h] = [
                                h,
                                -w
                            ];
                            break;
                        case 180:
                            [x, y] = [
                                centerX,
                                centerY
                            ];
                            [w, h] = [
                                -w,
                                -h
                            ];
                            break;
                        case 270:
                            [x, y] = [
                                centerY,
                                -centerX
                            ];
                            [w, h] = [
                                -h,
                                w
                            ];
                            break;
                    }
                    return [
                        node.x + x + Math.min(0, w),
                        node.y + y + Math.min(0, h),
                        Math.abs(w),
                        Math.abs(h)
                    ];
                }
                function checkDimensions(node, space) {
                    if (node[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].firstUnsplittable === null) return true;
                    if (node.w === 0 || node.h === 0) return true;
                    const ERROR = 2;
                    const parent = node[_xfa_object.$getSubformParent]();
                    const attempt = parent[_xfa_object.$extra] && parent[_xfa_object.$extra].attempt || 0;
                    const [, y, w, h] = getTransformedBBox(node);
                    switch(parent.layout){
                        case "lr-tb":
                        case "rl-tb":
                            if (attempt === 0) {
                                if (!node[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].noLayoutFailure) {
                                    if (node.h !== "" && Math.round(h - space.height) > ERROR) return false;
                                    if (node.w !== "") {
                                        if (Math.round(w - space.width) <= ERROR) return true;
                                        if (parent[_xfa_object.$extra].numberInLine === 0) return space.height > 0;
                                        return false;
                                    }
                                    return space.width > 0;
                                }
                                if (node.w !== "") return Math.round(w - space.width) <= ERROR;
                                return space.width > 0;
                            }
                            if (node[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].noLayoutFailure) return true;
                            if (node.h !== "" && Math.round(h - space.height) > ERROR) return false;
                            if (node.w === "" || Math.round(w - space.width) <= ERROR) return space.height > 0;
                            if (parent[_xfa_object.$isThereMoreWidth]()) return false;
                            return space.height > 0;
                        case "table":
                        case "tb":
                            if (node[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].noLayoutFailure) return true;
                            if (node.h !== "" && !node[_xfa_object.$isSplittable]()) return Math.round(h - space.height) <= ERROR;
                            if (node.w === "" || Math.round(w - space.width) <= ERROR) return space.height > 0;
                            if (parent[_xfa_object.$isThereMoreWidth]()) return false;
                            return space.height > 0;
                        case "position":
                            if (node[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].noLayoutFailure) return true;
                            if (node.h === "" || Math.round(h + y - space.height) <= ERROR) return true;
                            const area = node[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].currentContentArea;
                            return h + y > area.h;
                        case "rl-row":
                        case "row":
                            if (node[_xfa_object.$getTemplateRoot]()[_xfa_object.$extra].noLayoutFailure) return true;
                            if (node.h !== "") return Math.round(h - space.height) <= ERROR;
                            return true;
                        default:
                            return true;
                    }
                }
            /***/ },
            /* 82 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.computeBbox = computeBbox;
                exports.createWrapper = createWrapper;
                exports.fixDimensions = fixDimensions;
                exports.fixTextIndent = fixTextIndent;
                exports.isPrintOnly = isPrintOnly;
                exports.layoutClass = layoutClass;
                exports.layoutNode = layoutNode;
                exports.measureToString = measureToString;
                exports.setAccess = setAccess;
                exports.setFontFamily = setFontFamily;
                exports.setMinMaxDimensions = setMinMaxDimensions;
                exports.setPara = setPara;
                exports.toStyle = toStyle;
                var _xfa_object = __w_pdfjs_require__(75);
                var _utils = __w_pdfjs_require__(76);
                var _fonts = __w_pdfjs_require__(83);
                var _text = __w_pdfjs_require__(84);
                var _util = __w_pdfjs_require__(2);
                function measureToString(m) {
                    if (typeof m === "string") return "0px";
                    return Number.isInteger(m) ? `${m}px` : `${m.toFixed(2)}px`;
                }
                const converters = {
                    anchorType (node, style) {
                        const parent = node[_xfa_object.$getSubformParent]();
                        if (!parent || parent.layout && parent.layout !== "position") return;
                        if (!("transform" in style)) style.transform = "";
                        switch(node.anchorType){
                            case "bottomCenter":
                                style.transform += "translate(-50%, -100%)";
                                break;
                            case "bottomLeft":
                                style.transform += "translate(0,-100%)";
                                break;
                            case "bottomRight":
                                style.transform += "translate(-100%,-100%)";
                                break;
                            case "middleCenter":
                                style.transform += "translate(-50%,-50%)";
                                break;
                            case "middleLeft":
                                style.transform += "translate(0,-50%)";
                                break;
                            case "middleRight":
                                style.transform += "translate(-100%,-50%)";
                                break;
                            case "topCenter":
                                style.transform += "translate(-50%,0)";
                                break;
                            case "topRight":
                                style.transform += "translate(-100%,0)";
                                break;
                        }
                    },
                    dimensions (node, style) {
                        const parent = node[_xfa_object.$getSubformParent]();
                        let width = node.w;
                        const height = node.h;
                        if (parent.layout && parent.layout.includes("row")) {
                            const extra = parent[_xfa_object.$extra];
                            const colSpan = node.colSpan;
                            let w;
                            if (colSpan === -1) {
                                w = extra.columnWidths.slice(extra.currentColumn).reduce((a, x)=>a + x, 0);
                                extra.currentColumn = 0;
                            } else {
                                w = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, x)=>a + x, 0);
                                extra.currentColumn = (extra.currentColumn + node.colSpan) % extra.columnWidths.length;
                            }
                            if (!isNaN(w)) width = node.w = w;
                        }
                        if (width !== "") style.width = measureToString(width);
                        else style.width = "auto";
                        if (height !== "") style.height = measureToString(height);
                        else style.height = "auto";
                    },
                    position (node, style) {
                        const parent = node[_xfa_object.$getSubformParent]();
                        if (parent && parent.layout && parent.layout !== "position") return;
                        style.position = "absolute";
                        style.left = measureToString(node.x);
                        style.top = measureToString(node.y);
                    },
                    rotate (node, style) {
                        if (node.rotate) {
                            if (!("transform" in style)) style.transform = "";
                            style.transform += `rotate(-${node.rotate}deg)`;
                            style.transformOrigin = "top left";
                        }
                    },
                    presence (node, style) {
                        switch(node.presence){
                            case "invisible":
                                style.visibility = "hidden";
                                break;
                            case "hidden":
                            case "inactive":
                                style.display = "none";
                                break;
                        }
                    },
                    hAlign (node, style) {
                        if (node[_xfa_object.$nodeName] === "para") switch(node.hAlign){
                            case "justifyAll":
                                style.textAlign = "justify-all";
                                break;
                            case "radix":
                                style.textAlign = "left";
                                break;
                            default:
                                style.textAlign = node.hAlign;
                        }
                        else switch(node.hAlign){
                            case "left":
                                style.alignSelf = "start";
                                break;
                            case "center":
                                style.alignSelf = "center";
                                break;
                            case "right":
                                style.alignSelf = "end";
                                break;
                        }
                    },
                    margin (node, style) {
                        if (node.margin) style.margin = node.margin[_xfa_object.$toStyle]().margin;
                    }
                };
                function setMinMaxDimensions(node, style) {
                    const parent = node[_xfa_object.$getSubformParent]();
                    if (parent.layout === "position") {
                        if (node.minW > 0) style.minWidth = measureToString(node.minW);
                        if (node.maxW > 0) style.maxWidth = measureToString(node.maxW);
                        if (node.minH > 0) style.minHeight = measureToString(node.minH);
                        if (node.maxH > 0) style.maxHeight = measureToString(node.maxH);
                    }
                }
                function layoutText(text, xfaFont, margin, lineHeight, fontFinder, width) {
                    const measure = new _text.TextMeasure(xfaFont, margin, lineHeight, fontFinder);
                    if (typeof text === "string") measure.addString(text);
                    else text[_xfa_object.$pushGlyphs](measure);
                    return measure.compute(width);
                }
                function layoutNode(node, availableSpace) {
                    let height = null;
                    let width = null;
                    let isBroken = false;
                    if ((!node.w || !node.h) && node.value) {
                        let marginH = 0;
                        let marginV = 0;
                        if (node.margin) {
                            marginH = node.margin.leftInset + node.margin.rightInset;
                            marginV = node.margin.topInset + node.margin.bottomInset;
                        }
                        let lineHeight = null;
                        let margin = null;
                        if (node.para) {
                            margin = Object.create(null);
                            lineHeight = node.para.lineHeight === "" ? null : node.para.lineHeight;
                            margin.top = node.para.spaceAbove === "" ? 0 : node.para.spaceAbove;
                            margin.bottom = node.para.spaceBelow === "" ? 0 : node.para.spaceBelow;
                            margin.left = node.para.marginLeft === "" ? 0 : node.para.marginLeft;
                            margin.right = node.para.marginRight === "" ? 0 : node.para.marginRight;
                        }
                        let font1 = node.font;
                        if (!font1) {
                            const root = node[_xfa_object.$getTemplateRoot]();
                            let parent = node[_xfa_object.$getParent]();
                            while(parent !== root){
                                if (parent.font) {
                                    font1 = parent.font;
                                    break;
                                }
                                parent = parent[_xfa_object.$getParent]();
                            }
                        }
                        const maxWidth = !node.w ? availableSpace.width : node.w;
                        const fontFinder = node[_xfa_object.$globalData].fontFinder;
                        if (node.value.exData && node.value.exData[_xfa_object.$content] && node.value.exData.contentType === "text/html") {
                            const res = layoutText(node.value.exData[_xfa_object.$content], font1, margin, lineHeight, fontFinder, maxWidth);
                            width = res.width;
                            height = res.height;
                            isBroken = res.isBroken;
                        } else {
                            const text = node.value[_xfa_object.$text]();
                            if (text) {
                                const res = layoutText(text, font1, margin, lineHeight, fontFinder, maxWidth);
                                width = res.width;
                                height = res.height;
                                isBroken = res.isBroken;
                            }
                        }
                        if (width !== null && !node.w) width += marginH;
                        if (height !== null && !node.h) height += marginV;
                    }
                    return {
                        w: width,
                        h: height,
                        isBroken: isBroken
                    };
                }
                function computeBbox(node, html, availableSpace) {
                    let bbox;
                    if (node.w !== "" && node.h !== "") bbox = [
                        node.x,
                        node.y,
                        node.w,
                        node.h
                    ];
                    else {
                        if (!availableSpace) return null;
                        let width = node.w;
                        if (width === "") {
                            if (node.maxW === 0) {
                                const parent = node[_xfa_object.$getSubformParent]();
                                if (parent.layout === "position" && parent.w !== "") width = 0;
                                else width = node.minW;
                            } else width = Math.min(node.maxW, availableSpace.width);
                            html.attributes.style.width = measureToString(width);
                        }
                        let height = node.h;
                        if (height === "") {
                            if (node.maxH === 0) {
                                const parent = node[_xfa_object.$getSubformParent]();
                                if (parent.layout === "position" && parent.h !== "") height = 0;
                                else height = node.minH;
                            } else height = Math.min(node.maxH, availableSpace.height);
                            html.attributes.style.height = measureToString(height);
                        }
                        bbox = [
                            node.x,
                            node.y,
                            width,
                            height
                        ];
                    }
                    return bbox;
                }
                function fixDimensions(node) {
                    const parent = node[_xfa_object.$getSubformParent]();
                    if (parent.layout && parent.layout.includes("row")) {
                        const extra = parent[_xfa_object.$extra];
                        const colSpan = node.colSpan;
                        let width;
                        if (colSpan === -1) width = extra.columnWidths.slice(extra.currentColumn).reduce((a, w)=>a + w, 0);
                        else width = extra.columnWidths.slice(extra.currentColumn, extra.currentColumn + colSpan).reduce((a, w)=>a + w, 0);
                        if (!isNaN(width)) node.w = width;
                    }
                    if (parent.layout && parent.layout !== "position") node.x = node.y = 0;
                    if (node.layout === "table") {
                        if (node.w === "" && Array.isArray(node.columnWidths)) node.w = node.columnWidths.reduce((a, x)=>a + x, 0);
                    }
                }
                function layoutClass(node) {
                    switch(node.layout){
                        case "position":
                            return "xfaPosition";
                        case "lr-tb":
                            return "xfaLrTb";
                        case "rl-row":
                            return "xfaRlRow";
                        case "rl-tb":
                            return "xfaRlTb";
                        case "row":
                            return "xfaRow";
                        case "table":
                            return "xfaTable";
                        case "tb":
                            return "xfaTb";
                        default:
                            return "xfaPosition";
                    }
                }
                function toStyle(node, ...names) {
                    const style = Object.create(null);
                    for (const name of names){
                        const value = node[name];
                        if (value === null) continue;
                        if (converters.hasOwnProperty(name)) {
                            converters[name](node, style);
                            continue;
                        }
                        if (value instanceof _xfa_object.XFAObject) {
                            const newStyle = value[_xfa_object.$toStyle]();
                            if (newStyle) Object.assign(style, newStyle);
                            else (0, _util.warn)(`(DEBUG) - XFA - style for ${name} not implemented yet`);
                        }
                    }
                    return style;
                }
                function createWrapper(node, html) {
                    const { attributes: attributes  } = html;
                    const { style: style  } = attributes;
                    const wrapper = {
                        name: "div",
                        attributes: {
                            class: [
                                "xfaWrapper"
                            ],
                            style: Object.create(null)
                        },
                        children: []
                    };
                    attributes.class.push("xfaWrapped");
                    if (node.border) {
                        const { widths: widths , insets: insets  } = node.border[_xfa_object.$extra];
                        let width, height;
                        let top = insets[0];
                        let left = insets[3];
                        const insetsH = insets[0] + insets[2];
                        const insetsW = insets[1] + insets[3];
                        switch(node.border.hand){
                            case "even":
                                top -= widths[0] / 2;
                                left -= widths[3] / 2;
                                width = `calc(100% + ${(widths[1] + widths[3]) / 2 - insetsW}px)`;
                                height = `calc(100% + ${(widths[0] + widths[2]) / 2 - insetsH}px)`;
                                break;
                            case "left":
                                top -= widths[0];
                                left -= widths[3];
                                width = `calc(100% + ${widths[1] + widths[3] - insetsW}px)`;
                                height = `calc(100% + ${widths[0] + widths[2] - insetsH}px)`;
                                break;
                            case "right":
                                width = insetsW ? `calc(100% - ${insetsW}px)` : "100%";
                                height = insetsH ? `calc(100% - ${insetsH}px)` : "100%";
                                break;
                        }
                        const classNames = [
                            "xfaBorder"
                        ];
                        if (isPrintOnly(node.border)) classNames.push("xfaPrintOnly");
                        const border = {
                            name: "div",
                            attributes: {
                                class: classNames,
                                style: {
                                    top: `${top}px`,
                                    left: `${left}px`,
                                    width: width,
                                    height: height
                                }
                            },
                            children: []
                        };
                        for (const key of [
                            "border",
                            "borderWidth",
                            "borderColor",
                            "borderRadius",
                            "borderStyle"
                        ])if (style[key] !== undefined) {
                            border.attributes.style[key] = style[key];
                            delete style[key];
                        }
                        wrapper.children.push(border, html);
                    } else wrapper.children.push(html);
                    for (const key of [
                        "background",
                        "backgroundClip",
                        "top",
                        "left",
                        "width",
                        "height",
                        "minWidth",
                        "minHeight",
                        "maxWidth",
                        "maxHeight",
                        "transform",
                        "transformOrigin",
                        "visibility"
                    ])if (style[key] !== undefined) {
                        wrapper.attributes.style[key] = style[key];
                        delete style[key];
                    }
                    if (style.position === "absolute") wrapper.attributes.style.position = "absolute";
                    else wrapper.attributes.style.position = "relative";
                    delete style.position;
                    if (style.alignSelf) {
                        wrapper.attributes.style.alignSelf = style.alignSelf;
                        delete style.alignSelf;
                    }
                    return wrapper;
                }
                function fixTextIndent(styles) {
                    const indent = (0, _utils.getMeasurement)(styles.textIndent, "0px");
                    if (indent >= 0) return;
                    const align = styles.textAlign === "right" ? "right" : "left";
                    const name = "padding" + (align === "left" ? "Left" : "Right");
                    const padding = (0, _utils.getMeasurement)(styles[name], "0px");
                    styles[name] = `${padding - indent}px`;
                }
                function setAccess(node, classNames) {
                    switch(node.access){
                        case "nonInteractive":
                            classNames.push("xfaNonInteractive");
                            break;
                        case "readOnly":
                            classNames.push("xfaReadOnly");
                            break;
                        case "protected":
                            classNames.push("xfaDisabled");
                            break;
                    }
                }
                function isPrintOnly(node) {
                    return node.relevant.length > 0 && !node.relevant[0].excluded && node.relevant[0].viewname === "print";
                }
                function setPara(node, nodeStyle, value) {
                    if (value.attributes.class && value.attributes.class.includes("xfaRich")) {
                        if (nodeStyle) {
                            if (node.h === "") nodeStyle.height = "auto";
                            if (node.w === "") nodeStyle.width = "auto";
                        }
                        if (node.para) {
                            const valueStyle = value.attributes.style;
                            valueStyle.display = "flex";
                            valueStyle.flexDirection = "column";
                            switch(node.para.vAlign){
                                case "top":
                                    valueStyle.justifyContent = "start";
                                    break;
                                case "bottom":
                                    valueStyle.justifyContent = "end";
                                    break;
                                case "middle":
                                    valueStyle.justifyContent = "center";
                                    break;
                            }
                            const paraStyle = node.para[_xfa_object.$toStyle]();
                            for (const [key, val] of Object.entries(paraStyle))if (!(key in valueStyle)) valueStyle[key] = val;
                        }
                    }
                }
                function setFontFamily(xfaFont, fontFinder, style) {
                    const name = (0, _utils.stripQuotes)(xfaFont.typeface);
                    const typeface = fontFinder.find(name);
                    style.fontFamily = `"${name}"`;
                    if (typeface) {
                        const { fontFamily: fontFamily  } = typeface.regular.cssFontInfo;
                        if (fontFamily !== name) style.fontFamily = `"${fontFamily}"`;
                        if (style.lineHeight) return;
                        const pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                        if (pdfFont && pdfFont.lineHeight > 0) style.lineHeight = Math.max(1.2, pdfFont.lineHeight);
                        else style.lineHeight = 1.2;
                    }
                }
            /***/ },
            /* 83 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.selectFont = selectFont;
                exports.FontFinder = void 0;
                var _util = __w_pdfjs_require__(2);
                class FontFinder {
                    constructor(pdfFonts){
                        this.fonts = new Map();
                        this.cache = new Map();
                        this.warned = new Set();
                        this.defaultFont = null;
                        this.add(pdfFonts);
                    }
                    add(pdfFonts, reallyMissingFonts = null) {
                        for (const pdfFont of pdfFonts)this.addPdfFont(pdfFont);
                        for (const pdfFont of this.fonts.values())if (!pdfFont.regular) pdfFont.regular = pdfFont.italic || pdfFont.bold || pdfFont.bolditalic;
                        if (!reallyMissingFonts || reallyMissingFonts.size === 0) return;
                        const myriad = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
                        for (const missing of reallyMissingFonts)this.fonts.set(missing, myriad);
                    }
                    addPdfFont(pdfFont) {
                        const cssFontInfo = pdfFont.cssFontInfo;
                        const name = cssFontInfo.fontFamily;
                        let font1 = this.fonts.get(name);
                        if (!font1) {
                            font1 = Object.create(null);
                            this.fonts.set(name, font1);
                            if (!this.defaultFont) this.defaultFont = font1;
                        }
                        let property = "";
                        const fontWeight = parseFloat(cssFontInfo.fontWeight);
                        if (parseFloat(cssFontInfo.italicAngle) !== 0) property = fontWeight >= 700 ? "bolditalic" : "italic";
                        else if (fontWeight >= 700) property = "bold";
                        if (!property) {
                            if (pdfFont.name.includes("Bold") || pdfFont.psName && pdfFont.psName.includes("Bold")) property = "bold";
                            if (pdfFont.name.includes("Italic") || pdfFont.name.endsWith("It") || pdfFont.psName && (pdfFont.psName.includes("Italic") || pdfFont.psName.endsWith("It"))) property += "italic";
                        }
                        if (!property) property = "regular";
                        font1[property] = pdfFont;
                    }
                    getDefault() {
                        return this.defaultFont;
                    }
                    find(fontName, mustWarn = true) {
                        let font1 = this.fonts.get(fontName) || this.cache.get(fontName);
                        if (font1) return font1;
                        const pattern = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
                        let name = fontName.replace(pattern, "");
                        font1 = this.fonts.get(name);
                        if (font1) {
                            this.cache.set(fontName, font1);
                            return font1;
                        }
                        name = name.toLowerCase();
                        const maybe = [];
                        for (const [family, pdfFont] of this.fonts.entries())if (family.replace(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        if (maybe.length === 0) {
                            for (const [, pdfFont] of this.fonts.entries())if (pdfFont.regular.name && pdfFont.regular.name.replace(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length === 0) {
                            name = name.replace(/psmt|mt/gi, "");
                            for (const [family, pdfFont] of this.fonts.entries())if (family.replace(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length === 0) {
                            for (const pdfFont of this.fonts.values())if (pdfFont.regular.name && pdfFont.regular.name.replace(pattern, "").toLowerCase().startsWith(name)) maybe.push(pdfFont);
                        }
                        if (maybe.length >= 1) {
                            if (maybe.length !== 1 && mustWarn) (0, _util.warn)(`XFA - Too many choices to guess the correct font: ${fontName}`);
                            this.cache.set(fontName, maybe[0]);
                            return maybe[0];
                        }
                        if (mustWarn && !this.warned.has(fontName)) {
                            this.warned.add(fontName);
                            (0, _util.warn)(`XFA - Cannot find the font: ${fontName}`);
                        }
                        return null;
                    }
                }
                exports.FontFinder = FontFinder;
                function selectFont(xfaFont, typeface) {
                    if (xfaFont.posture === "italic") {
                        if (xfaFont.weight === "bold") return typeface.bolditalic;
                        return typeface.italic;
                    } else if (xfaFont.weight === "bold") return typeface.bold;
                    return typeface.regular;
                }
            /***/ },
            /* 84 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextMeasure = void 0;
                var _fonts = __w_pdfjs_require__(83);
                const WIDTH_FACTOR = 1.01;
                class FontInfo {
                    constructor(xfaFont, margin, lineHeight, fontFinder){
                        this.lineHeight = lineHeight;
                        this.paraMargin = margin || {
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                        };
                        if (!xfaFont) {
                            [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                            return;
                        }
                        this.xfaFont = {
                            typeface: xfaFont.typeface,
                            posture: xfaFont.posture,
                            weight: xfaFont.weight,
                            size: xfaFont.size,
                            letterSpacing: xfaFont.letterSpacing
                        };
                        const typeface = fontFinder.find(xfaFont.typeface);
                        if (!typeface) {
                            [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                            return;
                        }
                        this.pdfFont = (0, _fonts.selectFont)(xfaFont, typeface);
                        if (!this.pdfFont) [this.pdfFont, this.xfaFont] = this.defaultFont(fontFinder);
                    }
                    defaultFont(fontFinder) {
                        const font1 = fontFinder.find("Helvetica", false) || fontFinder.find("Myriad Pro", false) || fontFinder.find("Arial", false) || fontFinder.getDefault();
                        if (font1 && font1.regular) {
                            const pdfFont = font1.regular;
                            const info = pdfFont.cssFontInfo;
                            const xfaFont = {
                                typeface: info.fontFamily,
                                posture: "normal",
                                weight: "normal",
                                size: 10,
                                letterSpacing: 0
                            };
                            return [
                                pdfFont,
                                xfaFont
                            ];
                        }
                        const xfaFont = {
                            typeface: "Courier",
                            posture: "normal",
                            weight: "normal",
                            size: 10,
                            letterSpacing: 0
                        };
                        return [
                            null,
                            xfaFont
                        ];
                    }
                }
                class FontSelector {
                    constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder){
                        this.fontFinder = fontFinder;
                        this.stack = [
                            new FontInfo(defaultXfaFont, defaultParaMargin, defaultLineHeight, fontFinder)
                        ];
                    }
                    pushData(xfaFont, margin, lineHeight) {
                        const lastFont = this.stack[this.stack.length - 1];
                        for (const name of [
                            "typeface",
                            "posture",
                            "weight",
                            "size",
                            "letterSpacing"
                        ])if (!xfaFont[name]) xfaFont[name] = lastFont.xfaFont[name];
                        for (const name of [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ])if (isNaN(margin[name])) margin[name] = lastFont.paraMargin[name];
                        const fontInfo = new FontInfo(xfaFont, margin, lineHeight || lastFont.lineHeight, this.fontFinder);
                        if (!fontInfo.pdfFont) fontInfo.pdfFont = lastFont.pdfFont;
                        this.stack.push(fontInfo);
                    }
                    popFont() {
                        this.stack.pop();
                    }
                    topFont() {
                        return this.stack[this.stack.length - 1];
                    }
                }
                class TextMeasure {
                    constructor(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts){
                        this.glyphs = [];
                        this.fontSelector = new FontSelector(defaultXfaFont, defaultParaMargin, defaultLineHeight, fonts);
                        this.extraHeight = 0;
                    }
                    pushData(xfaFont, margin, lineHeight) {
                        this.fontSelector.pushData(xfaFont, margin, lineHeight);
                    }
                    popFont(xfaFont) {
                        return this.fontSelector.popFont();
                    }
                    addPara() {
                        const lastFont = this.fontSelector.topFont();
                        this.extraHeight += lastFont.paraMargin.top + lastFont.paraMargin.bottom;
                    }
                    addString(str) {
                        if (!str) return;
                        const lastFont = this.fontSelector.topFont();
                        const fontSize = lastFont.xfaFont.size;
                        if (lastFont.pdfFont) {
                            const letterSpacing = lastFont.xfaFont.letterSpacing;
                            const pdfFont = lastFont.pdfFont;
                            const lineHeight = lastFont.lineHeight || Math.ceil(Math.max(1.2, pdfFont.lineHeight) * fontSize);
                            const scale = fontSize / 1000;
                            for (const line of str.split(/[\u2029\n]/)){
                                const encodedLine = pdfFont.encodeString(line).join("");
                                const glyphs = pdfFont.charsToGlyphs(encodedLine);
                                for (const glyph of glyphs)this.glyphs.push([
                                    glyph.width * scale + letterSpacing,
                                    lineHeight,
                                    glyph.unicode === " ",
                                    false
                                ]);
                                this.glyphs.push([
                                    0,
                                    0,
                                    false,
                                    true
                                ]);
                            }
                            this.glyphs.pop();
                            return;
                        }
                        for (const line of str.split(/[\u2029\n]/)){
                            for (const char of line.split(""))this.glyphs.push([
                                fontSize,
                                fontSize,
                                char === " ",
                                false
                            ]);
                            this.glyphs.push([
                                0,
                                0,
                                false,
                                true
                            ]);
                        }
                        this.glyphs.pop();
                    }
                    compute(maxWidth) {
                        let lastSpacePos = -1, lastSpaceWidth = 0, width = 0, height = 0, currentLineWidth = 0, currentLineHeight = 0;
                        let isBroken = false;
                        for(let i = 0, ii = this.glyphs.length; i < ii; i++){
                            const [glyphWidth, glyphHeight, isSpace, isEOL] = this.glyphs[i];
                            if (isEOL) {
                                width = Math.max(width, currentLineWidth);
                                currentLineWidth = 0;
                                height += currentLineHeight;
                                currentLineHeight = glyphHeight;
                                lastSpacePos = -1;
                                lastSpaceWidth = 0;
                                continue;
                            }
                            if (isSpace) {
                                if (currentLineWidth + glyphWidth > maxWidth) {
                                    width = Math.max(width, currentLineWidth);
                                    currentLineWidth = 0;
                                    height += currentLineHeight;
                                    currentLineHeight = glyphHeight;
                                    lastSpacePos = -1;
                                    lastSpaceWidth = 0;
                                    isBroken = true;
                                } else {
                                    currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                                    lastSpaceWidth = currentLineWidth;
                                    currentLineWidth += glyphWidth;
                                    lastSpacePos = i;
                                }
                                continue;
                            }
                            if (currentLineWidth + glyphWidth > maxWidth) {
                                height += currentLineHeight;
                                currentLineHeight = glyphHeight;
                                if (lastSpacePos !== -1) {
                                    i = lastSpacePos;
                                    width = Math.max(width, lastSpaceWidth);
                                    currentLineWidth = 0;
                                    lastSpacePos = -1;
                                    lastSpaceWidth = 0;
                                } else {
                                    width = Math.max(width, currentLineWidth);
                                    currentLineWidth = glyphWidth;
                                }
                                isBroken = true;
                                continue;
                            }
                            currentLineWidth += glyphWidth;
                            currentLineHeight = Math.max(glyphHeight, currentLineHeight);
                        }
                        width = Math.max(width, currentLineWidth);
                        height += currentLineHeight + this.extraHeight;
                        return {
                            width: WIDTH_FACTOR * width,
                            height: height,
                            isBroken: isBroken
                        };
                    }
                }
                exports.TextMeasure = TextMeasure;
            /***/ },
            /* 85 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DataHandler = void 0;
                var _xfa_object = __w_pdfjs_require__(75);
                class DataHandler {
                    constructor(root, data){
                        this.data = data;
                        this.dataset = root.datasets || null;
                    }
                    serialize(storage) {
                        const stack = [
                            [
                                -1,
                                this.data[_xfa_object.$getChildren]()
                            ]
                        ];
                        while(stack.length > 0){
                            const last = stack[stack.length - 1];
                            const [i, children] = last;
                            if (i + 1 === children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = children[++last[0]];
                            const storageEntry = storage.get(child[_xfa_object.$uid]);
                            if (storageEntry) child[_xfa_object.$setValue](storageEntry);
                            else {
                                const attributes = child[_xfa_object.$getAttributes]();
                                for (const value of attributes.values()){
                                    const entry = storage.get(value[_xfa_object.$uid]);
                                    if (entry) {
                                        value[_xfa_object.$setValue](entry);
                                        break;
                                    }
                                }
                            }
                            const nodes = child[_xfa_object.$getChildren]();
                            if (nodes.length > 0) stack.push([
                                -1,
                                nodes
                            ]);
                        }
                        const buf = [
                            `<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">`
                        ];
                        if (this.dataset) {
                            for (const child of this.dataset[_xfa_object.$getChildren]())if (child[_xfa_object.$nodeName] !== "data") child[_xfa_object.$toString](buf);
                        }
                        this.data[_xfa_object.$toString](buf);
                        buf.push("</xfa:datasets>");
                        return buf.join("");
                    }
                }
                exports.DataHandler = DataHandler;
            /***/ },
            /* 86 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XFAParser = void 0;
                var _xfa_object = __w_pdfjs_require__(75);
                var _xml_parser = __w_pdfjs_require__(68);
                var _builder = __w_pdfjs_require__(87);
                var _util = __w_pdfjs_require__(2);
                class XFAParser extends _xml_parser.XMLParserBase {
                    constructor(){
                        super();
                        this._builder = new _builder.Builder();
                        this._stack = [];
                        this._globalData = {
                            usedTypefaces: new Set()
                        };
                        this._ids = new Map();
                        this._current = this._builder.buildRoot(this._ids);
                        this._errorCode = _xml_parser.XMLParserErrorCode.NoError;
                        this._whiteRegex = /^\s+$/;
                        this._nbsps = /\xa0+/g;
                    }
                    parse(data) {
                        this.parseXml(data);
                        if (this._errorCode !== _xml_parser.XMLParserErrorCode.NoError) return undefined;
                        this._current[_xfa_object.$finalize]();
                        return this._current.element;
                    }
                    onText(text) {
                        text = text.replace(this._nbsps, (match)=>match.slice(1) + " ");
                        if (this._current[_xfa_object.$acceptWhitespace]()) {
                            this._current[_xfa_object.$onText](text);
                            return;
                        }
                        if (this._whiteRegex.test(text)) return;
                        this._current[_xfa_object.$onText](text.trim());
                    }
                    onCdata(text) {
                        this._current[_xfa_object.$onText](text);
                    }
                    _mkAttributes(attributes, tagName) {
                        let namespace = null;
                        let prefixes = null;
                        const attributeObj = Object.create({});
                        for (const { name: name , value: value  } of attributes){
                            if (name === "xmlns") {
                                if (!namespace) namespace = value;
                                else (0, _util.warn)(`XFA - multiple namespace definition in <${tagName}>`);
                            } else if (name.startsWith("xmlns:")) {
                                const prefix = name.substring(6);
                                if (!prefixes) prefixes = [];
                                prefixes.push({
                                    prefix: prefix,
                                    value: value
                                });
                            } else {
                                const i = name.indexOf(":");
                                if (i === -1) attributeObj[name] = value;
                                else {
                                    let nsAttrs = attributeObj[_xfa_object.$nsAttributes];
                                    if (!nsAttrs) nsAttrs = attributeObj[_xfa_object.$nsAttributes] = Object.create(null);
                                    const [ns, attrName] = [
                                        name.slice(0, i),
                                        name.slice(i + 1)
                                    ];
                                    let attrs = nsAttrs[ns];
                                    if (!attrs) attrs = nsAttrs[ns] = Object.create(null);
                                    attrs[attrName] = value;
                                }
                            }
                        }
                        return [
                            namespace,
                            prefixes,
                            attributeObj
                        ];
                    }
                    _getNameAndPrefix(name, nsAgnostic) {
                        const i = name.indexOf(":");
                        if (i === -1) return [
                            name,
                            null
                        ];
                        return [
                            name.substring(i + 1),
                            nsAgnostic ? "" : name.substring(0, i)
                        ];
                    }
                    onBeginElement(tagName, attributes, isEmpty) {
                        const [namespace, prefixes, attributesObj] = this._mkAttributes(attributes, tagName);
                        const [name, nsPrefix] = this._getNameAndPrefix(tagName, this._builder.isNsAgnostic());
                        const node = this._builder.build({
                            nsPrefix: nsPrefix,
                            name: name,
                            attributes: attributesObj,
                            namespace: namespace,
                            prefixes: prefixes
                        });
                        node[_xfa_object.$globalData] = this._globalData;
                        if (isEmpty) {
                            node[_xfa_object.$finalize]();
                            if (this._current[_xfa_object.$onChild](node)) node[_xfa_object.$setId](this._ids);
                            node[_xfa_object.$clean](this._builder);
                            return;
                        }
                        this._stack.push(this._current);
                        this._current = node;
                    }
                    onEndElement(name) {
                        const node = this._current;
                        if (node[_xfa_object.$isCDATAXml]() && typeof node[_xfa_object.$content] === "string") {
                            const parser = new XFAParser();
                            parser._globalData = this._globalData;
                            const root = parser.parse(node[_xfa_object.$content]);
                            node[_xfa_object.$content] = null;
                            node[_xfa_object.$onChild](root);
                        }
                        node[_xfa_object.$finalize]();
                        this._current = this._stack.pop();
                        if (this._current[_xfa_object.$onChild](node)) node[_xfa_object.$setId](this._ids);
                        node[_xfa_object.$clean](this._builder);
                    }
                    onError(code) {
                        this._errorCode = code;
                    }
                }
                exports.XFAParser = XFAParser;
            /***/ },
            /* 87 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Builder = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                var _setup = __w_pdfjs_require__(88);
                var _template = __w_pdfjs_require__(80);
                var _unknown = __w_pdfjs_require__(97);
                var _util = __w_pdfjs_require__(2);
                class Root extends _xfa_object.XFAObject {
                    constructor(ids){
                        super(-1, "root", Object.create(null));
                        this.element = null;
                        this[_xfa_object.$ids] = ids;
                    }
                    [_xfa_object.$onChild](child) {
                        this.element = child;
                        return true;
                    }
                    [_xfa_object.$finalize]() {
                        super[_xfa_object.$finalize]();
                        if (this.element.template instanceof _template.Template) {
                            this[_xfa_object.$ids].set(_xfa_object.$root, this.element);
                            this.element.template[_xfa_object.$resolvePrototypes](this[_xfa_object.$ids]);
                            this.element.template[_xfa_object.$ids] = this[_xfa_object.$ids];
                        }
                    }
                }
                class Empty extends _xfa_object.XFAObject {
                    constructor(){
                        super(-1, "", Object.create(null));
                    }
                    [_xfa_object.$onChild](_) {
                        return false;
                    }
                }
                class Builder {
                    constructor(){
                        this._namespaceStack = [];
                        this._nsAgnosticLevel = 0;
                        this._namespacePrefixes = new Map();
                        this._namespaces = new Map();
                        this._nextNsId = Math.max(...Object.values(_namespaces.NamespaceIds).map(({ id: id  })=>id));
                        this._currentNamespace = new _unknown.UnknownNamespace(++this._nextNsId);
                    }
                    buildRoot(ids) {
                        return new Root(ids);
                    }
                    build({ nsPrefix: nsPrefix , name: name , attributes: attributes , namespace: namespace , prefixes: prefixes  }) {
                        const hasNamespaceDef = namespace !== null;
                        if (hasNamespaceDef) {
                            this._namespaceStack.push(this._currentNamespace);
                            this._currentNamespace = this._searchNamespace(namespace);
                        }
                        if (prefixes) this._addNamespacePrefix(prefixes);
                        if (attributes.hasOwnProperty(_xfa_object.$nsAttributes)) {
                            const dataTemplate = _setup.NamespaceSetUp.datasets;
                            const nsAttrs = attributes[_xfa_object.$nsAttributes];
                            let xfaAttrs = null;
                            for (const [ns, attrs] of Object.entries(nsAttrs)){
                                const nsToUse = this._getNamespaceToUse(ns);
                                if (nsToUse === dataTemplate) {
                                    xfaAttrs = {
                                        xfa: attrs
                                    };
                                    break;
                                }
                            }
                            if (xfaAttrs) attributes[_xfa_object.$nsAttributes] = xfaAttrs;
                            else delete attributes[_xfa_object.$nsAttributes];
                        }
                        const namespaceToUse = this._getNamespaceToUse(nsPrefix);
                        const node = namespaceToUse && namespaceToUse[_namespaces.$buildXFAObject](name, attributes) || new Empty();
                        if (node[_xfa_object.$isNsAgnostic]()) this._nsAgnosticLevel++;
                        if (hasNamespaceDef || prefixes || node[_xfa_object.$isNsAgnostic]()) node[_xfa_object.$cleanup] = {
                            hasNamespace: hasNamespaceDef,
                            prefixes: prefixes,
                            nsAgnostic: node[_xfa_object.$isNsAgnostic]()
                        };
                        return node;
                    }
                    isNsAgnostic() {
                        return this._nsAgnosticLevel > 0;
                    }
                    _searchNamespace(nsName) {
                        let ns = this._namespaces.get(nsName);
                        if (ns) return ns;
                        for (const [name, { check: check  }] of Object.entries(_namespaces.NamespaceIds))if (check(nsName)) {
                            ns = _setup.NamespaceSetUp[name];
                            if (ns) {
                                this._namespaces.set(nsName, ns);
                                return ns;
                            }
                            break;
                        }
                        ns = new _unknown.UnknownNamespace(++this._nextNsId);
                        this._namespaces.set(nsName, ns);
                        return ns;
                    }
                    _addNamespacePrefix(prefixes) {
                        for (const { prefix: prefix , value: value  } of prefixes){
                            const namespace = this._searchNamespace(value);
                            let prefixStack = this._namespacePrefixes.get(prefix);
                            if (!prefixStack) {
                                prefixStack = [];
                                this._namespacePrefixes.set(prefix, prefixStack);
                            }
                            prefixStack.push(namespace);
                        }
                    }
                    _getNamespaceToUse(prefix) {
                        if (!prefix) return this._currentNamespace;
                        const prefixStack = this._namespacePrefixes.get(prefix);
                        if (prefixStack && prefixStack.length > 0) return prefixStack[prefixStack.length - 1];
                        (0, _util.warn)(`Unknown namespace prefix: ${prefix}.`);
                        return null;
                    }
                    clean(data) {
                        const { hasNamespace: hasNamespace , prefixes: prefixes , nsAgnostic: nsAgnostic  } = data;
                        if (hasNamespace) this._currentNamespace = this._namespaceStack.pop();
                        if (prefixes) prefixes.forEach(({ prefix: prefix  })=>{
                            this._namespacePrefixes.get(prefix).pop();
                        });
                        if (nsAgnostic) this._nsAgnosticLevel--;
                    }
                }
                exports.Builder = Builder;
            /***/ },
            /* 88 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NamespaceSetUp = void 0;
                var _config = __w_pdfjs_require__(89);
                var _connection_set = __w_pdfjs_require__(90);
                var _datasets = __w_pdfjs_require__(91);
                var _locale_set = __w_pdfjs_require__(92);
                var _signature = __w_pdfjs_require__(93);
                var _stylesheet = __w_pdfjs_require__(94);
                var _template = __w_pdfjs_require__(80);
                var _xdp = __w_pdfjs_require__(95);
                var _xhtml = __w_pdfjs_require__(96);
                const NamespaceSetUp = {
                    config: _config.ConfigNamespace,
                    connection: _connection_set.ConnectionSetNamespace,
                    datasets: _datasets.DatasetsNamespace,
                    localeSet: _locale_set.LocaleSetNamespace,
                    signature: _signature.SignatureNamespace,
                    stylesheet: _stylesheet.StylesheetNamespace,
                    template: _template.TemplateNamespace,
                    xdp: _xdp.XdpNamespace,
                    xhtml: _xhtml.XhtmlNamespace
                };
                exports.NamespaceSetUp = NamespaceSetUp;
            /***/ },
            /* 89 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ConfigNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                var _utils = __w_pdfjs_require__(76);
                var _util = __w_pdfjs_require__(2);
                const CONFIG_NS_ID = _namespaces.NamespaceIds.config.id;
                class Acrobat extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "acrobat", true);
                        this.acrobat7 = null;
                        this.autoSave = null;
                        this.common = null;
                        this.validate = null;
                        this.validateApprovalSignatures = null;
                        this.submitUrl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Acrobat7 extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "acrobat7", true);
                        this.dynamicRender = null;
                    }
                }
                class ADBE_JSConsole extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ADBE_JSConsole", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class ADBE_JSDebugger extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ADBE_JSDebugger", [
                            "delegate",
                            "Enable",
                            "Disable"
                        ]);
                    }
                }
                class AddSilentPrint extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "addSilentPrint");
                    }
                }
                class AddViewerPreferences extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "addViewerPreferences");
                    }
                }
                class AdjustData extends _xfa_object.Option10 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "adjustData");
                    }
                }
                class AdobeExtensionLevel extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "adobeExtensionLevel", 0, (n)=>n >= 1 && n <= 8);
                    }
                }
                class Agent extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "agent", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.common = new _xfa_object.XFAObjectArray();
                    }
                }
                class AlwaysEmbed extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "alwaysEmbed");
                    }
                }
                class Amd extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "amd");
                    }
                }
                class Area extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "area");
                        this.level = (0, _utils.getInteger)({
                            data: attributes.level,
                            defaultValue: 0,
                            validate: (n)=>n >= 1 && n <= 3
                        });
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "",
                            "barcode",
                            "coreinit",
                            "deviceDriver",
                            "font",
                            "general",
                            "layout",
                            "merge",
                            "script",
                            "signature",
                            "sourceSet",
                            "templateCache"
                        ]);
                    }
                }
                class Attributes extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "attributes", [
                            "preserve",
                            "delegate",
                            "ignore"
                        ]);
                    }
                }
                class AutoSave extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "autoSave", [
                            "disabled",
                            "enabled"
                        ]);
                    }
                }
                class Base extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "base");
                    }
                }
                class BatchOutput extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "batchOutput");
                        this.format = (0, _utils.getStringOption)(attributes.format, [
                            "none",
                            "concat",
                            "zip",
                            "zipCompress"
                        ]);
                    }
                }
                class BehaviorOverride extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "behaviorOverride");
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = new Map(this[_xfa_object.$content].trim().split(/\s+/).filter((x)=>x.includes(":")).map((x)=>x.split(":", 2)));
                    }
                }
                class Cache extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "cache", true);
                        this.templateCache = null;
                    }
                }
                class Change extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "change");
                    }
                }
                class Common extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "common", true);
                        this.data = null;
                        this.locale = null;
                        this.localeSet = null;
                        this.messaging = null;
                        this.suppressBanner = null;
                        this.template = null;
                        this.validationMessaging = null;
                        this.versionControl = null;
                        this.log = new _xfa_object.XFAObjectArray();
                    }
                }
                class Compress extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compress");
                        this.scope = (0, _utils.getStringOption)(attributes.scope, [
                            "imageOnly",
                            "document"
                        ]);
                    }
                }
                class CompressLogicalStructure extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compressLogicalStructure");
                    }
                }
                class CompressObjectStream extends _xfa_object.Option10 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compressObjectStream");
                    }
                }
                class Compression extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "compression", true);
                        this.compressLogicalStructure = null;
                        this.compressObjectStream = null;
                        this.level = null;
                        this.type = null;
                    }
                }
                class Config extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "config", true);
                        this.acrobat = null;
                        this.present = null;
                        this.trace = null;
                        this.agent = new _xfa_object.XFAObjectArray();
                    }
                }
                class Conformance extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "conformance", [
                            "A",
                            "B"
                        ]);
                    }
                }
                class ContentCopy extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "contentCopy");
                    }
                }
                class Copies extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "copies", 1, (n)=>n >= 1);
                    }
                }
                class Creator extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "creator");
                    }
                }
                class CurrentPage extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "currentPage", 0, (n)=>n >= 0);
                    }
                }
                class Data extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "data", true);
                        this.adjustData = null;
                        this.attributes = null;
                        this.incrementalLoad = null;
                        this.outputXSL = null;
                        this.range = null;
                        this.record = null;
                        this.startNode = null;
                        this.uri = null;
                        this.window = null;
                        this.xsl = null;
                        this.excludeNS = new _xfa_object.XFAObjectArray();
                        this.transform = new _xfa_object.XFAObjectArray();
                    }
                }
                class Debug extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "debug", true);
                        this.uri = null;
                    }
                }
                class DefaultTypeface extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "defaultTypeface");
                        this.writingScript = (0, _utils.getStringOption)(attributes.writingScript, [
                            "*",
                            "Arabic",
                            "Cyrillic",
                            "EastEuropeanRoman",
                            "Greek",
                            "Hebrew",
                            "Japanese",
                            "Korean",
                            "Roman",
                            "SimplifiedChinese",
                            "Thai",
                            "TraditionalChinese",
                            "Vietnamese"
                        ]);
                    }
                }
                class Destination extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "destination", [
                            "pdf",
                            "pcl",
                            "ps",
                            "webClient",
                            "zpl"
                        ]);
                    }
                }
                class DocumentAssembly extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "documentAssembly");
                    }
                }
                class Driver extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "driver", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class DuplexOption extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "duplexOption", [
                            "simplex",
                            "duplexFlipLongEdge",
                            "duplexFlipShortEdge"
                        ]);
                    }
                }
                class DynamicRender extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "dynamicRender", [
                            "forbidden",
                            "required"
                        ]);
                    }
                }
                class Embed extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "embed");
                    }
                }
                class Encrypt extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encrypt");
                    }
                }
                class Encryption extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encryption", true);
                        this.encrypt = null;
                        this.encryptionLevel = null;
                        this.permissions = null;
                    }
                }
                class EncryptionLevel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "encryptionLevel", [
                            "40bit",
                            "128bit"
                        ]);
                    }
                }
                class Enforce extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "enforce");
                    }
                }
                class Equate extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "equate");
                        this.force = (0, _utils.getInteger)({
                            data: attributes.force,
                            defaultValue: 1,
                            validate: (n)=>n === 0
                        });
                        this.from = attributes.from || "";
                        this.to = attributes.to || "";
                    }
                }
                class EquateRange extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "equateRange");
                        this.from = attributes.from || "";
                        this.to = attributes.to || "";
                        this._unicodeRange = attributes.unicodeRange || "";
                    }
                    get unicodeRange() {
                        const ranges = [];
                        const unicodeRegex = /U\+([0-9a-fA-F]+)/;
                        const unicodeRange = this._unicodeRange;
                        for (let range of unicodeRange.split(",").map((x)=>x.trim()).filter((x)=>!!x)){
                            range = range.split("-", 2).map((x)=>{
                                const found = x.match(unicodeRegex);
                                if (!found) return 0;
                                return parseInt(found[1], 16);
                            });
                            if (range.length === 1) range.push(range[0]);
                            ranges.push(range);
                        }
                        return (0, _util.shadow)(this, "unicodeRange", ranges);
                    }
                }
                class Exclude extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "exclude");
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = this[_xfa_object.$content].trim().split(/\s+/).filter((x)=>x && [
                                "calculate",
                                "close",
                                "enter",
                                "exit",
                                "initialize",
                                "ready",
                                "validate"
                            ].includes(x));
                    }
                }
                class ExcludeNS extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "excludeNS");
                    }
                }
                class FlipLabel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "flipLabel", [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class FontInfo extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "fontInfo", true);
                        this.embed = null;
                        this.map = null;
                        this.subsetBelow = null;
                        this.alwaysEmbed = new _xfa_object.XFAObjectArray();
                        this.defaultTypeface = new _xfa_object.XFAObjectArray();
                        this.neverEmbed = new _xfa_object.XFAObjectArray();
                    }
                }
                class FormFieldFilling extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "formFieldFilling");
                    }
                }
                class GroupParent extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "groupParent");
                    }
                }
                class IfEmpty extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ifEmpty", [
                            "dataValue",
                            "dataGroup",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class IncludeXDPContent extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "includeXDPContent");
                    }
                }
                class IncrementalLoad extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "incrementalLoad", [
                            "none",
                            "forwardOnly"
                        ]);
                    }
                }
                class IncrementalMerge extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "incrementalMerge");
                    }
                }
                class Interactive extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "interactive");
                    }
                }
                class Jog extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "jog", [
                            "usePrinterSetting",
                            "none",
                            "pageSet"
                        ]);
                    }
                }
                class LabelPrinter extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "labelPrinter", true);
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "zpl",
                            "dpl",
                            "ipl",
                            "tcpl"
                        ]);
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Layout extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "layout", [
                            "paginate",
                            "panel"
                        ]);
                    }
                }
                class Level extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "level", 0, (n)=>n > 0);
                    }
                }
                class Linearized extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "linearized");
                    }
                }
                class Locale extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "locale");
                    }
                }
                class LocaleSet extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "localeSet");
                    }
                }
                class Log extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "log", true);
                        this.mode = null;
                        this.threshold = null;
                        this.to = null;
                        this.uri = null;
                    }
                }
                class MapElement extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "map", true);
                        this.equate = new _xfa_object.XFAObjectArray();
                        this.equateRange = new _xfa_object.XFAObjectArray();
                    }
                }
                class MediumInfo extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "mediumInfo", true);
                        this.map = null;
                    }
                }
                class Message extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "message", true);
                        this.msgId = null;
                        this.severity = null;
                    }
                }
                class Messaging extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "messaging", true);
                        this.message = new _xfa_object.XFAObjectArray();
                    }
                }
                class Mode extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "mode", [
                            "append",
                            "overwrite"
                        ]);
                    }
                }
                class ModifyAnnots extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "modifyAnnots");
                    }
                }
                class MsgId extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "msgId", 1, (n)=>n >= 1);
                    }
                }
                class NameAttr extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "nameAttr");
                    }
                }
                class NeverEmbed extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "neverEmbed");
                    }
                }
                class NumberOfCopies extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "numberOfCopies", null, (n)=>n >= 2 && n <= 5);
                    }
                }
                class OpenAction extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "openAction", true);
                        this.destination = null;
                    }
                }
                class Output extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "output", true);
                        this.to = null;
                        this.type = null;
                        this.uri = null;
                    }
                }
                class OutputBin extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "outputBin");
                    }
                }
                class OutputXSL extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "outputXSL", true);
                        this.uri = null;
                    }
                }
                class Overprint extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "overprint", [
                            "none",
                            "both",
                            "draw",
                            "field"
                        ]);
                    }
                }
                class Packets extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "packets");
                    }
                    [_xfa_object.$finalize]() {
                        if (this[_xfa_object.$content] === "*") return;
                        this[_xfa_object.$content] = this[_xfa_object.$content].trim().split(/\s+/).filter((x)=>[
                                "config",
                                "datasets",
                                "template",
                                "xfdf",
                                "xslt"
                            ].includes(x));
                    }
                }
                class PageOffset extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pageOffset");
                        this.x = (0, _utils.getInteger)({
                            data: attributes.x,
                            defaultValue: "useXDCSetting",
                            validate: (n)=>true
                        });
                        this.y = (0, _utils.getInteger)({
                            data: attributes.y,
                            defaultValue: "useXDCSetting",
                            validate: (n)=>true
                        });
                    }
                }
                class PageRange extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pageRange");
                    }
                    [_xfa_object.$finalize]() {
                        const numbers = this[_xfa_object.$content].trim().split(/\s+/).map((x)=>parseInt(x, 10));
                        const ranges = [];
                        for(let i = 0, ii = numbers.length; i < ii; i += 2)ranges.push(numbers.slice(i, i + 2));
                        this[_xfa_object.$content] = ranges;
                    }
                }
                class Pagination extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pagination", [
                            "simplex",
                            "duplexShortEdge",
                            "duplexLongEdge"
                        ]);
                    }
                }
                class PaginationOverride extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "paginationOverride", [
                            "none",
                            "forceDuplex",
                            "forceDuplexLongEdge",
                            "forceDuplexShortEdge",
                            "forceSimplex"
                        ]);
                    }
                }
                class Part extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "part", 1, (n)=>false);
                    }
                }
                class Pcl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pcl", true);
                        this.name = attributes.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.pageOffset = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Pdf extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pdf", true);
                        this.name = attributes.name || "";
                        this.adobeExtensionLevel = null;
                        this.batchOutput = null;
                        this.compression = null;
                        this.creator = null;
                        this.encryption = null;
                        this.fontInfo = null;
                        this.interactive = null;
                        this.linearized = null;
                        this.openAction = null;
                        this.pdfa = null;
                        this.producer = null;
                        this.renderPolicy = null;
                        this.scriptModel = null;
                        this.silentPrint = null;
                        this.submitFormat = null;
                        this.tagged = null;
                        this.version = null;
                        this.viewerPreferences = null;
                        this.xdc = null;
                    }
                }
                class Pdfa extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pdfa", true);
                        this.amd = null;
                        this.conformance = null;
                        this.includeXDPContent = null;
                        this.part = null;
                    }
                }
                class Permissions extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "permissions", true);
                        this.accessibleContent = null;
                        this.change = null;
                        this.contentCopy = null;
                        this.documentAssembly = null;
                        this.formFieldFilling = null;
                        this.modifyAnnots = null;
                        this.plaintextMetadata = null;
                        this.print = null;
                        this.printHighQuality = null;
                    }
                }
                class PickTrayByPDFSize extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "pickTrayByPDFSize");
                    }
                }
                class Picture extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "picture");
                    }
                }
                class PlaintextMetadata extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "plaintextMetadata");
                    }
                }
                class Presence extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "presence", [
                            "preserve",
                            "dissolve",
                            "dissolveStructure",
                            "ignore",
                            "remove"
                        ]);
                    }
                }
                class Present extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "present", true);
                        this.behaviorOverride = null;
                        this.cache = null;
                        this.common = null;
                        this.copies = null;
                        this.destination = null;
                        this.incrementalMerge = null;
                        this.layout = null;
                        this.output = null;
                        this.overprint = null;
                        this.pagination = null;
                        this.paginationOverride = null;
                        this.script = null;
                        this.validate = null;
                        this.xdp = null;
                        this.driver = new _xfa_object.XFAObjectArray();
                        this.labelPrinter = new _xfa_object.XFAObjectArray();
                        this.pcl = new _xfa_object.XFAObjectArray();
                        this.pdf = new _xfa_object.XFAObjectArray();
                        this.ps = new _xfa_object.XFAObjectArray();
                        this.submitUrl = new _xfa_object.XFAObjectArray();
                        this.webClient = new _xfa_object.XFAObjectArray();
                        this.zpl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Print extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "print");
                    }
                }
                class PrintHighQuality extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printHighQuality");
                    }
                }
                class PrintScaling extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printScaling", [
                            "appdefault",
                            "noScaling"
                        ]);
                    }
                }
                class PrinterName extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "printerName");
                    }
                }
                class Producer extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "producer");
                    }
                }
                class Ps extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "ps", true);
                        this.name = attributes.name || "";
                        this.batchOutput = null;
                        this.fontInfo = null;
                        this.jog = null;
                        this.mediumInfo = null;
                        this.outputBin = null;
                        this.staple = null;
                        this.xdc = null;
                    }
                }
                class Range extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "range");
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = this[_xfa_object.$content].trim().split(/\s*,\s*/, 2).map((range)=>range.split("-").map((x)=>parseInt(x.trim(), 10))).filter((range)=>range.every((x)=>!isNaN(x))).map((range)=>{
                            if (range.length === 1) range.push(range[0]);
                            return range;
                        });
                    }
                }
                class Record extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "record");
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = this[_xfa_object.$content].trim();
                        const n = parseInt(this[_xfa_object.$content], 10);
                        if (!isNaN(n) && n >= 0) this[_xfa_object.$content] = n;
                    }
                }
                class Relevant extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "relevant");
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = this[_xfa_object.$content].trim().split(/\s+/);
                    }
                }
                class Rename extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "rename");
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = this[_xfa_object.$content].trim();
                        if (this[_xfa_object.$content].toLowerCase().startsWith("xml") || this[_xfa_object.$content].match(new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u"))) (0, _util.warn)("XFA - Rename: invalid XFA name");
                    }
                }
                class RenderPolicy extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "renderPolicy", [
                            "server",
                            "client"
                        ]);
                    }
                }
                class RunScripts extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "runScripts", [
                            "both",
                            "client",
                            "none",
                            "server"
                        ]);
                    }
                }
                class Script extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "script", true);
                        this.currentPage = null;
                        this.exclude = null;
                        this.runScripts = null;
                    }
                }
                class ScriptModel extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "scriptModel", [
                            "XFA",
                            "none"
                        ]);
                    }
                }
                class Severity extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "severity", [
                            "ignore",
                            "error",
                            "information",
                            "trace",
                            "warning"
                        ]);
                    }
                }
                class SilentPrint extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "silentPrint", true);
                        this.addSilentPrint = null;
                        this.printerName = null;
                    }
                }
                class Staple extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "staple");
                        this.mode = (0, _utils.getStringOption)(attributes.mode, [
                            "usePrinterSetting",
                            "on",
                            "off"
                        ]);
                    }
                }
                class StartNode extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "startNode");
                    }
                }
                class StartPage extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "startPage", 0, (n)=>true);
                    }
                }
                class SubmitFormat extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "submitFormat", [
                            "html",
                            "delegate",
                            "fdf",
                            "xml",
                            "pdf"
                        ]);
                    }
                }
                class SubmitUrl extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "submitUrl");
                    }
                }
                class SubsetBelow extends _xfa_object.IntegerObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "subsetBelow", 100, (n)=>n >= 0 && n <= 100);
                    }
                }
                class SuppressBanner extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "suppressBanner");
                    }
                }
                class Tagged extends _xfa_object.Option01 {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "tagged");
                    }
                }
                class Template extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "template", true);
                        this.base = null;
                        this.relevant = null;
                        this.startPage = null;
                        this.uri = null;
                        this.xsl = null;
                    }
                }
                class Threshold extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "threshold", [
                            "trace",
                            "error",
                            "information",
                            "warning"
                        ]);
                    }
                }
                class To extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "to", [
                            "null",
                            "memory",
                            "stderr",
                            "stdout",
                            "system",
                            "uri"
                        ]);
                    }
                }
                class TemplateCache extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "templateCache");
                        this.maxEntries = (0, _utils.getInteger)({
                            data: attributes.maxEntries,
                            defaultValue: 5,
                            validate: (n)=>n >= 0
                        });
                    }
                }
                class Trace extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "trace", true);
                        this.area = new _xfa_object.XFAObjectArray();
                    }
                }
                class Transform extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "transform", true);
                        this.groupParent = null;
                        this.ifEmpty = null;
                        this.nameAttr = null;
                        this.picture = null;
                        this.presence = null;
                        this.rename = null;
                        this.whitespace = null;
                    }
                }
                class Type extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "type", [
                            "none",
                            "ascii85",
                            "asciiHex",
                            "ccittfax",
                            "flate",
                            "lzw",
                            "runLength",
                            "native",
                            "xdp",
                            "mergedXDP"
                        ]);
                    }
                }
                class Uri extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "uri");
                    }
                }
                class Validate extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validate", [
                            "preSubmit",
                            "prePrint",
                            "preExecute",
                            "preSave"
                        ]);
                    }
                }
                class ValidateApprovalSignatures extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validateApprovalSignatures");
                    }
                    [_xfa_object.$finalize]() {
                        this[_xfa_object.$content] = this[_xfa_object.$content].trim().split(/\s+/).filter((x)=>[
                                "docReady",
                                "postSign"
                            ].includes(x));
                    }
                }
                class ValidationMessaging extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "validationMessaging", [
                            "allMessagesIndividually",
                            "allMessagesTogether",
                            "firstMessageOnly",
                            "noMessages"
                        ]);
                    }
                }
                class Version extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "version", [
                            "1.7",
                            "1.6",
                            "1.5",
                            "1.4",
                            "1.3",
                            "1.2"
                        ]);
                    }
                }
                class VersionControl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "VersionControl");
                        this.outputBelow = (0, _utils.getStringOption)(attributes.outputBelow, [
                            "warn",
                            "error",
                            "update"
                        ]);
                        this.sourceAbove = (0, _utils.getStringOption)(attributes.sourceAbove, [
                            "warn",
                            "error"
                        ]);
                        this.sourceBelow = (0, _utils.getStringOption)(attributes.sourceBelow, [
                            "update",
                            "maintain"
                        ]);
                    }
                }
                class ViewerPreferences extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "viewerPreferences", true);
                        this.ADBE_JSConsole = null;
                        this.ADBE_JSDebugger = null;
                        this.addViewerPreferences = null;
                        this.duplexOption = null;
                        this.enforce = null;
                        this.numberOfCopies = null;
                        this.pageRange = null;
                        this.pickTrayByPDFSize = null;
                        this.printScaling = null;
                    }
                }
                class WebClient extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "webClient", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class Whitespace extends _xfa_object.OptionObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "whitespace", [
                            "preserve",
                            "ltrim",
                            "normalize",
                            "rtrim",
                            "trim"
                        ]);
                    }
                }
                class Window extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "window");
                    }
                    [_xfa_object.$finalize]() {
                        const pair = this[_xfa_object.$content].trim().split(/\s*,\s*/, 2).map((x)=>parseInt(x, 10));
                        if (pair.some((x)=>isNaN(x))) {
                            this[_xfa_object.$content] = [
                                0,
                                0
                            ];
                            return;
                        }
                        if (pair.length === 1) pair.push(pair[0]);
                        this[_xfa_object.$content] = pair;
                    }
                }
                class Xdc extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xdc", true);
                        this.uri = new _xfa_object.XFAObjectArray();
                        this.xsl = new _xfa_object.XFAObjectArray();
                    }
                }
                class Xdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xdp", true);
                        this.packets = null;
                    }
                }
                class Xsl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "xsl", true);
                        this.debug = null;
                        this.uri = null;
                    }
                }
                class Zpl extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONFIG_NS_ID, "zpl", true);
                        this.name = attributes.name ? attributes.name.trim() : "";
                        this.batchOutput = null;
                        this.flipLabel = null;
                        this.fontInfo = null;
                        this.xdc = null;
                    }
                }
                class ConfigNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (ConfigNamespace.hasOwnProperty(name)) return ConfigNamespace[name](attributes);
                        return undefined;
                    }
                    static acrobat(attrs) {
                        return new Acrobat(attrs);
                    }
                    static acrobat7(attrs) {
                        return new Acrobat7(attrs);
                    }
                    static ADBE_JSConsole(attrs) {
                        return new ADBE_JSConsole(attrs);
                    }
                    static ADBE_JSDebugger(attrs) {
                        return new ADBE_JSDebugger(attrs);
                    }
                    static addSilentPrint(attrs) {
                        return new AddSilentPrint(attrs);
                    }
                    static addViewerPreferences(attrs) {
                        return new AddViewerPreferences(attrs);
                    }
                    static adjustData(attrs) {
                        return new AdjustData(attrs);
                    }
                    static adobeExtensionLevel(attrs) {
                        return new AdobeExtensionLevel(attrs);
                    }
                    static agent(attrs) {
                        return new Agent(attrs);
                    }
                    static alwaysEmbed(attrs) {
                        return new AlwaysEmbed(attrs);
                    }
                    static amd(attrs) {
                        return new Amd(attrs);
                    }
                    static area(attrs) {
                        return new Area(attrs);
                    }
                    static attributes(attrs) {
                        return new Attributes(attrs);
                    }
                    static autoSave(attrs) {
                        return new AutoSave(attrs);
                    }
                    static base(attrs) {
                        return new Base(attrs);
                    }
                    static batchOutput(attrs) {
                        return new BatchOutput(attrs);
                    }
                    static behaviorOverride(attrs) {
                        return new BehaviorOverride(attrs);
                    }
                    static cache(attrs) {
                        return new Cache(attrs);
                    }
                    static change(attrs) {
                        return new Change(attrs);
                    }
                    static common(attrs) {
                        return new Common(attrs);
                    }
                    static compress(attrs) {
                        return new Compress(attrs);
                    }
                    static compressLogicalStructure(attrs) {
                        return new CompressLogicalStructure(attrs);
                    }
                    static compressObjectStream(attrs) {
                        return new CompressObjectStream(attrs);
                    }
                    static compression(attrs) {
                        return new Compression(attrs);
                    }
                    static config(attrs) {
                        return new Config(attrs);
                    }
                    static conformance(attrs) {
                        return new Conformance(attrs);
                    }
                    static contentCopy(attrs) {
                        return new ContentCopy(attrs);
                    }
                    static copies(attrs) {
                        return new Copies(attrs);
                    }
                    static creator(attrs) {
                        return new Creator(attrs);
                    }
                    static currentPage(attrs) {
                        return new CurrentPage(attrs);
                    }
                    static data(attrs) {
                        return new Data(attrs);
                    }
                    static debug(attrs) {
                        return new Debug(attrs);
                    }
                    static defaultTypeface(attrs) {
                        return new DefaultTypeface(attrs);
                    }
                    static destination(attrs) {
                        return new Destination(attrs);
                    }
                    static documentAssembly(attrs) {
                        return new DocumentAssembly(attrs);
                    }
                    static driver(attrs) {
                        return new Driver(attrs);
                    }
                    static duplexOption(attrs) {
                        return new DuplexOption(attrs);
                    }
                    static dynamicRender(attrs) {
                        return new DynamicRender(attrs);
                    }
                    static embed(attrs) {
                        return new Embed(attrs);
                    }
                    static encrypt(attrs) {
                        return new Encrypt(attrs);
                    }
                    static encryption(attrs) {
                        return new Encryption(attrs);
                    }
                    static encryptionLevel(attrs) {
                        return new EncryptionLevel(attrs);
                    }
                    static enforce(attrs) {
                        return new Enforce(attrs);
                    }
                    static equate(attrs) {
                        return new Equate(attrs);
                    }
                    static equateRange(attrs) {
                        return new EquateRange(attrs);
                    }
                    static exclude(attrs) {
                        return new Exclude(attrs);
                    }
                    static excludeNS(attrs) {
                        return new ExcludeNS(attrs);
                    }
                    static flipLabel(attrs) {
                        return new FlipLabel(attrs);
                    }
                    static fontInfo(attrs) {
                        return new FontInfo(attrs);
                    }
                    static formFieldFilling(attrs) {
                        return new FormFieldFilling(attrs);
                    }
                    static groupParent(attrs) {
                        return new GroupParent(attrs);
                    }
                    static ifEmpty(attrs) {
                        return new IfEmpty(attrs);
                    }
                    static includeXDPContent(attrs) {
                        return new IncludeXDPContent(attrs);
                    }
                    static incrementalLoad(attrs) {
                        return new IncrementalLoad(attrs);
                    }
                    static incrementalMerge(attrs) {
                        return new IncrementalMerge(attrs);
                    }
                    static interactive(attrs) {
                        return new Interactive(attrs);
                    }
                    static jog(attrs) {
                        return new Jog(attrs);
                    }
                    static labelPrinter(attrs) {
                        return new LabelPrinter(attrs);
                    }
                    static layout(attrs) {
                        return new Layout(attrs);
                    }
                    static level(attrs) {
                        return new Level(attrs);
                    }
                    static linearized(attrs) {
                        return new Linearized(attrs);
                    }
                    static locale(attrs) {
                        return new Locale(attrs);
                    }
                    static localeSet(attrs) {
                        return new LocaleSet(attrs);
                    }
                    static log(attrs) {
                        return new Log(attrs);
                    }
                    static map(attrs) {
                        return new MapElement(attrs);
                    }
                    static mediumInfo(attrs) {
                        return new MediumInfo(attrs);
                    }
                    static message(attrs) {
                        return new Message(attrs);
                    }
                    static messaging(attrs) {
                        return new Messaging(attrs);
                    }
                    static mode(attrs) {
                        return new Mode(attrs);
                    }
                    static modifyAnnots(attrs) {
                        return new ModifyAnnots(attrs);
                    }
                    static msgId(attrs) {
                        return new MsgId(attrs);
                    }
                    static nameAttr(attrs) {
                        return new NameAttr(attrs);
                    }
                    static neverEmbed(attrs) {
                        return new NeverEmbed(attrs);
                    }
                    static numberOfCopies(attrs) {
                        return new NumberOfCopies(attrs);
                    }
                    static openAction(attrs) {
                        return new OpenAction(attrs);
                    }
                    static output(attrs) {
                        return new Output(attrs);
                    }
                    static outputBin(attrs) {
                        return new OutputBin(attrs);
                    }
                    static outputXSL(attrs) {
                        return new OutputXSL(attrs);
                    }
                    static overprint(attrs) {
                        return new Overprint(attrs);
                    }
                    static packets(attrs) {
                        return new Packets(attrs);
                    }
                    static pageOffset(attrs) {
                        return new PageOffset(attrs);
                    }
                    static pageRange(attrs) {
                        return new PageRange(attrs);
                    }
                    static pagination(attrs) {
                        return new Pagination(attrs);
                    }
                    static paginationOverride(attrs) {
                        return new PaginationOverride(attrs);
                    }
                    static part(attrs) {
                        return new Part(attrs);
                    }
                    static pcl(attrs) {
                        return new Pcl(attrs);
                    }
                    static pdf(attrs) {
                        return new Pdf(attrs);
                    }
                    static pdfa(attrs) {
                        return new Pdfa(attrs);
                    }
                    static permissions(attrs) {
                        return new Permissions(attrs);
                    }
                    static pickTrayByPDFSize(attrs) {
                        return new PickTrayByPDFSize(attrs);
                    }
                    static picture(attrs) {
                        return new Picture(attrs);
                    }
                    static plaintextMetadata(attrs) {
                        return new PlaintextMetadata(attrs);
                    }
                    static presence(attrs) {
                        return new Presence(attrs);
                    }
                    static present(attrs) {
                        return new Present(attrs);
                    }
                    static print(attrs) {
                        return new Print(attrs);
                    }
                    static printHighQuality(attrs) {
                        return new PrintHighQuality(attrs);
                    }
                    static printScaling(attrs) {
                        return new PrintScaling(attrs);
                    }
                    static printerName(attrs) {
                        return new PrinterName(attrs);
                    }
                    static producer(attrs) {
                        return new Producer(attrs);
                    }
                    static ps(attrs) {
                        return new Ps(attrs);
                    }
                    static range(attrs) {
                        return new Range(attrs);
                    }
                    static record(attrs) {
                        return new Record(attrs);
                    }
                    static relevant(attrs) {
                        return new Relevant(attrs);
                    }
                    static rename(attrs) {
                        return new Rename(attrs);
                    }
                    static renderPolicy(attrs) {
                        return new RenderPolicy(attrs);
                    }
                    static runScripts(attrs) {
                        return new RunScripts(attrs);
                    }
                    static script(attrs) {
                        return new Script(attrs);
                    }
                    static scriptModel(attrs) {
                        return new ScriptModel(attrs);
                    }
                    static severity(attrs) {
                        return new Severity(attrs);
                    }
                    static silentPrint(attrs) {
                        return new SilentPrint(attrs);
                    }
                    static staple(attrs) {
                        return new Staple(attrs);
                    }
                    static startNode(attrs) {
                        return new StartNode(attrs);
                    }
                    static startPage(attrs) {
                        return new StartPage(attrs);
                    }
                    static submitFormat(attrs) {
                        return new SubmitFormat(attrs);
                    }
                    static submitUrl(attrs) {
                        return new SubmitUrl(attrs);
                    }
                    static subsetBelow(attrs) {
                        return new SubsetBelow(attrs);
                    }
                    static suppressBanner(attrs) {
                        return new SuppressBanner(attrs);
                    }
                    static tagged(attrs) {
                        return new Tagged(attrs);
                    }
                    static template(attrs) {
                        return new Template(attrs);
                    }
                    static templateCache(attrs) {
                        return new TemplateCache(attrs);
                    }
                    static threshold(attrs) {
                        return new Threshold(attrs);
                    }
                    static to(attrs) {
                        return new To(attrs);
                    }
                    static trace(attrs) {
                        return new Trace(attrs);
                    }
                    static transform(attrs) {
                        return new Transform(attrs);
                    }
                    static type(attrs) {
                        return new Type(attrs);
                    }
                    static uri(attrs) {
                        return new Uri(attrs);
                    }
                    static validate(attrs) {
                        return new Validate(attrs);
                    }
                    static validateApprovalSignatures(attrs) {
                        return new ValidateApprovalSignatures(attrs);
                    }
                    static validationMessaging(attrs) {
                        return new ValidationMessaging(attrs);
                    }
                    static version(attrs) {
                        return new Version(attrs);
                    }
                    static versionControl(attrs) {
                        return new VersionControl(attrs);
                    }
                    static viewerPreferences(attrs) {
                        return new ViewerPreferences(attrs);
                    }
                    static webClient(attrs) {
                        return new WebClient(attrs);
                    }
                    static whitespace(attrs) {
                        return new Whitespace(attrs);
                    }
                    static window(attrs) {
                        return new Window(attrs);
                    }
                    static xdc(attrs) {
                        return new Xdc(attrs);
                    }
                    static xdp(attrs) {
                        return new Xdp(attrs);
                    }
                    static xsl(attrs) {
                        return new Xsl(attrs);
                    }
                    static zpl(attrs) {
                        return new Zpl(attrs);
                    }
                }
                exports.ConfigNamespace = ConfigNamespace;
            /***/ },
            /* 90 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ConnectionSetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                const CONNECTION_SET_NS_ID = _namespaces.NamespaceIds.connectionSet.id;
                class ConnectionSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "connectionSet", true);
                        this.wsdlConnection = new _xfa_object.XFAObjectArray();
                        this.xmlConnection = new _xfa_object.XFAObjectArray();
                        this.xsdConnection = new _xfa_object.XFAObjectArray();
                    }
                }
                class EffectiveInputPolicy extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "effectiveInputPolicy");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class EffectiveOutputPolicy extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "effectiveOutputPolicy");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Operation extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "operation");
                        this.id = attributes.id || "";
                        this.input = attributes.input || "";
                        this.name = attributes.name || "";
                        this.output = attributes.output || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class RootElement extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "rootElement");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SoapAction extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "soapAction");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class SoapAddress extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "soapAddress");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class Uri extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "uri");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class WsdlAddress extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "wsdlAddress");
                        this.id = attributes.id || "";
                        this.name = attributes.name || "";
                        this.use = attributes.use || "";
                        this.usehref = attributes.usehref || "";
                    }
                }
                class WsdlConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "wsdlConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.effectiveInputPolicy = null;
                        this.effectiveOutputPolicy = null;
                        this.operation = null;
                        this.soapAction = null;
                        this.soapAddress = null;
                        this.wsdlAddress = null;
                    }
                }
                class XmlConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "xmlConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.uri = null;
                    }
                }
                class XsdConnection extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(CONNECTION_SET_NS_ID, "xsdConnection", true);
                        this.dataDescription = attributes.dataDescription || "";
                        this.name = attributes.name || "";
                        this.rootElement = null;
                        this.uri = null;
                    }
                }
                class ConnectionSetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (ConnectionSetNamespace.hasOwnProperty(name)) return ConnectionSetNamespace[name](attributes);
                        return undefined;
                    }
                    static connectionSet(attrs) {
                        return new ConnectionSet(attrs);
                    }
                    static effectiveInputPolicy(attrs) {
                        return new EffectiveInputPolicy(attrs);
                    }
                    static effectiveOutputPolicy(attrs) {
                        return new EffectiveOutputPolicy(attrs);
                    }
                    static operation(attrs) {
                        return new Operation(attrs);
                    }
                    static rootElement(attrs) {
                        return new RootElement(attrs);
                    }
                    static soapAction(attrs) {
                        return new SoapAction(attrs);
                    }
                    static soapAddress(attrs) {
                        return new SoapAddress(attrs);
                    }
                    static uri(attrs) {
                        return new Uri(attrs);
                    }
                    static wsdlAddress(attrs) {
                        return new WsdlAddress(attrs);
                    }
                    static wsdlConnection(attrs) {
                        return new WsdlConnection(attrs);
                    }
                    static xmlConnection(attrs) {
                        return new XmlConnection(attrs);
                    }
                    static xsdConnection(attrs) {
                        return new XsdConnection(attrs);
                    }
                }
                exports.ConnectionSetNamespace = ConnectionSetNamespace;
            /***/ },
            /* 91 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DatasetsNamespace = void 0;
                var _xfa_object = __w_pdfjs_require__(75);
                var _namespaces = __w_pdfjs_require__(77);
                const DATASETS_NS_ID = _namespaces.NamespaceIds.datasets.id;
                class Data extends _xfa_object.XmlObject {
                    constructor(attributes){
                        super(DATASETS_NS_ID, "data", attributes);
                    }
                    [_xfa_object.$isNsAgnostic]() {
                        return true;
                    }
                }
                class Datasets extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(DATASETS_NS_ID, "datasets", true);
                        this.data = null;
                        this.Signature = null;
                    }
                    [_xfa_object.$onChild](child) {
                        const name = child[_xfa_object.$nodeName];
                        if (name === "data" && child[_xfa_object.$namespaceId] === DATASETS_NS_ID || name === "Signature" && child[_xfa_object.$namespaceId] === _namespaces.NamespaceIds.signature.id) this[name] = child;
                        this[_xfa_object.$appendChild](child);
                    }
                }
                class DatasetsNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (DatasetsNamespace.hasOwnProperty(name)) return DatasetsNamespace[name](attributes);
                        return undefined;
                    }
                    static datasets(attributes) {
                        return new Datasets(attributes);
                    }
                    static data(attributes) {
                        return new Data(attributes);
                    }
                }
                exports.DatasetsNamespace = DatasetsNamespace;
            /***/ },
            /* 92 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.LocaleSetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                var _utils = __w_pdfjs_require__(76);
                const LOCALE_SET_NS_ID = _namespaces.NamespaceIds.localeSet.id;
                class CalendarSymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "calendarSymbols", true);
                        this.name = "gregorian";
                        this.dayNames = new _xfa_object.XFAObjectArray(2);
                        this.eraNames = null;
                        this.meridiemNames = null;
                        this.monthNames = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class CurrencySymbol extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "currencySymbol");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "symbol",
                            "isoname",
                            "decimal"
                        ]);
                    }
                }
                class CurrencySymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "currencySymbols", true);
                        this.currencySymbol = new _xfa_object.XFAObjectArray(3);
                    }
                }
                class DatePattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "datePattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class DatePatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "datePatterns", true);
                        this.datePattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class DateTimeSymbols extends _xfa_object.ContentObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "dateTimeSymbols");
                    }
                }
                class Day extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "day");
                    }
                }
                class DayNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "dayNames", true);
                        this.abbr = (0, _utils.getInteger)({
                            data: attributes.abbr,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.day = new _xfa_object.XFAObjectArray(7);
                    }
                }
                class Era extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "era");
                    }
                }
                class EraNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "eraNames", true);
                        this.era = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class Locale extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "locale", true);
                        this.desc = attributes.desc || "";
                        this.name = "isoname";
                        this.calendarSymbols = null;
                        this.currencySymbols = null;
                        this.datePatterns = null;
                        this.dateTimeSymbols = null;
                        this.numberPatterns = null;
                        this.numberSymbols = null;
                        this.timePatterns = null;
                        this.typeFaces = null;
                    }
                }
                class LocaleSet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "localeSet", true);
                        this.locale = new _xfa_object.XFAObjectArray();
                    }
                }
                class Meridiem extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "meridiem");
                    }
                }
                class MeridiemNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "meridiemNames", true);
                        this.meridiem = new _xfa_object.XFAObjectArray(2);
                    }
                }
                class Month extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "month");
                    }
                }
                class MonthNames extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "monthNames", true);
                        this.abbr = (0, _utils.getInteger)({
                            data: attributes.abbr,
                            defaultValue: 0,
                            validate: (x)=>x === 1
                        });
                        this.month = new _xfa_object.XFAObjectArray(12);
                    }
                }
                class NumberPattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberPattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class NumberPatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberPatterns", true);
                        this.numberPattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class NumberSymbol extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberSymbol");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "decimal",
                            "grouping",
                            "percent",
                            "minus",
                            "zero"
                        ]);
                    }
                }
                class NumberSymbols extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "numberSymbols", true);
                        this.numberSymbol = new _xfa_object.XFAObjectArray(5);
                    }
                }
                class TimePattern extends _xfa_object.StringObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "timePattern");
                        this.name = (0, _utils.getStringOption)(attributes.name, [
                            "full",
                            "long",
                            "med",
                            "short"
                        ]);
                    }
                }
                class TimePatterns extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "timePatterns", true);
                        this.timePattern = new _xfa_object.XFAObjectArray(4);
                    }
                }
                class TypeFace extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "typeFace", true);
                        this.name = attributes.name | "";
                    }
                }
                class TypeFaces extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(LOCALE_SET_NS_ID, "typeFaces", true);
                        this.typeFace = new _xfa_object.XFAObjectArray();
                    }
                }
                class LocaleSetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (LocaleSetNamespace.hasOwnProperty(name)) return LocaleSetNamespace[name](attributes);
                        return undefined;
                    }
                    static calendarSymbols(attrs) {
                        return new CalendarSymbols(attrs);
                    }
                    static currencySymbol(attrs) {
                        return new CurrencySymbol(attrs);
                    }
                    static currencySymbols(attrs) {
                        return new CurrencySymbols(attrs);
                    }
                    static datePattern(attrs) {
                        return new DatePattern(attrs);
                    }
                    static datePatterns(attrs) {
                        return new DatePatterns(attrs);
                    }
                    static dateTimeSymbols(attrs) {
                        return new DateTimeSymbols(attrs);
                    }
                    static day(attrs) {
                        return new Day(attrs);
                    }
                    static dayNames(attrs) {
                        return new DayNames(attrs);
                    }
                    static era(attrs) {
                        return new Era(attrs);
                    }
                    static eraNames(attrs) {
                        return new EraNames(attrs);
                    }
                    static locale(attrs) {
                        return new Locale(attrs);
                    }
                    static localeSet(attrs) {
                        return new LocaleSet(attrs);
                    }
                    static meridiem(attrs) {
                        return new Meridiem(attrs);
                    }
                    static meridiemNames(attrs) {
                        return new MeridiemNames(attrs);
                    }
                    static month(attrs) {
                        return new Month(attrs);
                    }
                    static monthNames(attrs) {
                        return new MonthNames(attrs);
                    }
                    static numberPattern(attrs) {
                        return new NumberPattern(attrs);
                    }
                    static numberPatterns(attrs) {
                        return new NumberPatterns(attrs);
                    }
                    static numberSymbol(attrs) {
                        return new NumberSymbol(attrs);
                    }
                    static numberSymbols(attrs) {
                        return new NumberSymbols(attrs);
                    }
                    static timePattern(attrs) {
                        return new TimePattern(attrs);
                    }
                    static timePatterns(attrs) {
                        return new TimePatterns(attrs);
                    }
                    static typeFace(attrs) {
                        return new TypeFace(attrs);
                    }
                    static typeFaces(attrs) {
                        return new TypeFaces(attrs);
                    }
                }
                exports.LocaleSetNamespace = LocaleSetNamespace;
            /***/ },
            /* 93 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SignatureNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                const SIGNATURE_NS_ID = _namespaces.NamespaceIds.signature.id;
                class Signature extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(SIGNATURE_NS_ID, "signature", true);
                    }
                }
                class SignatureNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (SignatureNamespace.hasOwnProperty(name)) return SignatureNamespace[name](attributes);
                        return undefined;
                    }
                    static signature(attributes) {
                        return new Signature(attributes);
                    }
                }
                exports.SignatureNamespace = SignatureNamespace;
            /***/ },
            /* 94 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StylesheetNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                const STYLESHEET_NS_ID = _namespaces.NamespaceIds.stylesheet.id;
                class Stylesheet extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(STYLESHEET_NS_ID, "stylesheet", true);
                    }
                }
                class StylesheetNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (StylesheetNamespace.hasOwnProperty(name)) return StylesheetNamespace[name](attributes);
                        return undefined;
                    }
                    static stylesheet(attributes) {
                        return new Stylesheet(attributes);
                    }
                }
                exports.StylesheetNamespace = StylesheetNamespace;
            /***/ },
            /* 95 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XdpNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                const XDP_NS_ID = _namespaces.NamespaceIds.xdp.id;
                class Xdp extends _xfa_object.XFAObject {
                    constructor(attributes){
                        super(XDP_NS_ID, "xdp", true);
                        this.uuid = attributes.uuid || "";
                        this.timeStamp = attributes.timeStamp || "";
                        this.config = null;
                        this.connectionSet = null;
                        this.datasets = null;
                        this.localeSet = null;
                        this.stylesheet = new _xfa_object.XFAObjectArray();
                        this.template = null;
                    }
                    [_xfa_object.$onChildCheck](child) {
                        const ns = _namespaces.NamespaceIds[child[_xfa_object.$nodeName]];
                        return ns && child[_xfa_object.$namespaceId] === ns.id;
                    }
                }
                class XdpNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (XdpNamespace.hasOwnProperty(name)) return XdpNamespace[name](attributes);
                        return undefined;
                    }
                    static xdp(attributes) {
                        return new Xdp(attributes);
                    }
                }
                exports.XdpNamespace = XdpNamespace;
            /***/ },
            /* 96 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XhtmlNamespace = void 0;
                var _xfa_object = __w_pdfjs_require__(75);
                var _namespaces = __w_pdfjs_require__(77);
                var _html_utils = __w_pdfjs_require__(82);
                var _utils = __w_pdfjs_require__(76);
                const XHTML_NS_ID = _namespaces.NamespaceIds.xhtml.id;
                const VALID_STYLES = new Set([
                    "color",
                    "font",
                    "font-family",
                    "font-size",
                    "font-stretch",
                    "font-style",
                    "font-weight",
                    "margin",
                    "margin-bottom",
                    "margin-left",
                    "margin-right",
                    "margin-top",
                    "letter-spacing",
                    "line-height",
                    "orphans",
                    "page-break-after",
                    "page-break-before",
                    "page-break-inside",
                    "tab-interval",
                    "tab-stop",
                    "text-align",
                    "text-decoration",
                    "text-indent",
                    "vertical-align",
                    "widows",
                    "kerning-mode",
                    "xfa-font-horizontal-scale",
                    "xfa-font-vertical-scale",
                    "xfa-spacerun",
                    "xfa-tab-stops"
                ]);
                const StyleMapping = new Map([
                    [
                        "page-break-after",
                        "breakAfter"
                    ],
                    [
                        "page-break-before",
                        "breakBefore"
                    ],
                    [
                        "page-break-inside",
                        "breakInside"
                    ],
                    [
                        "kerning-mode",
                        (value)=>value === "none" ? "none" : "normal"
                    ],
                    [
                        "xfa-font-horizontal-scale",
                        (value)=>`scaleX(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-font-vertical-scale",
                        (value)=>`scaleY(${Math.max(0, Math.min(parseInt(value) / 100)).toFixed(2)})`
                    ],
                    [
                        "xfa-spacerun",
                        ""
                    ],
                    [
                        "xfa-tab-stops",
                        ""
                    ],
                    [
                        "font-size",
                        (value, original)=>{
                            value = original.fontSize = (0, _utils.getMeasurement)(value);
                            return (0, _html_utils.measureToString)(0.99 * value);
                        }
                    ],
                    [
                        "letter-spacing",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "line-height",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-bottom",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-left",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-right",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "margin-top",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "text-indent",
                        (value)=>(0, _html_utils.measureToString)((0, _utils.getMeasurement)(value))
                    ],
                    [
                        "font-family",
                        (value)=>value
                    ]
                ]);
                const spacesRegExp = /\s+/g;
                const crlfRegExp = /[\r\n]+/g;
                function mapStyle(styleStr, fontFinder) {
                    const style = Object.create(null);
                    if (!styleStr) return style;
                    const original = Object.create(null);
                    for (const [key, value] of styleStr.split(";").map((s)=>s.split(":", 2))){
                        const mapping = StyleMapping.get(key);
                        if (mapping === "") continue;
                        let newValue = value;
                        if (mapping) {
                            if (typeof mapping === "string") newValue = mapping;
                            else newValue = mapping(value, original);
                        }
                        if (key.endsWith("scale")) {
                            if (style.transform) style.transform = `${style[key]} ${newValue}`;
                            else style.transform = newValue;
                        } else style[key.replaceAll(/-([a-zA-Z])/g, (_, x)=>x.toUpperCase())] = newValue;
                    }
                    if (style.fontFamily) (0, _html_utils.setFontFamily)({
                        typeface: style.fontFamily,
                        weight: style.fontWeight || "normal",
                        posture: style.fontStyle || "normal",
                        size: original.fontSize || 0
                    }, fontFinder, style);
                    (0, _html_utils.fixTextIndent)(style);
                    return style;
                }
                function checkStyle(node) {
                    if (!node.style) return "";
                    return node.style.trim().split(/\s*;\s*/).filter((s)=>!!s).map((s)=>s.split(/\s*:\s*/, 2)).filter(([key, value])=>{
                        if (key === "font-family") node[_xfa_object.$globalData].usedTypefaces.add(value);
                        return VALID_STYLES.has(key);
                    }).map((kv)=>kv.join(":")).join(";");
                }
                const NoWhites = new Set([
                    "body",
                    "html"
                ]);
                class XhtmlObject extends _xfa_object.XmlObject {
                    constructor(attributes, name){
                        super(XHTML_NS_ID, name);
                        this.style = attributes.style || "";
                    }
                    [_xfa_object.$clean](builder) {
                        super[_xfa_object.$clean](builder);
                        this.style = checkStyle(this);
                    }
                    [_xfa_object.$acceptWhitespace]() {
                        return !NoWhites.has(this[_xfa_object.$nodeName]);
                    }
                    [_xfa_object.$onText](str) {
                        str = str.replace(crlfRegExp, "");
                        if (!this.style.includes("xfa-spacerun:yes")) str = str.replace(spacesRegExp, " ");
                        if (str) this[_xfa_object.$content] += str;
                    }
                    [_xfa_object.$pushGlyphs](measure, mustPop = true) {
                        const xfaFont = Object.create(null);
                        const margin = {
                            top: NaN,
                            bottom: NaN,
                            left: NaN,
                            right: NaN
                        };
                        let lineHeight = null;
                        for (const [key, value] of this.style.split(";").map((s)=>s.split(":", 2)))switch(key){
                            case "font-family":
                                xfaFont.typeface = (0, _utils.stripQuotes)(value);
                                break;
                            case "font-size":
                                xfaFont.size = (0, _utils.getMeasurement)(value);
                                break;
                            case "font-weight":
                                xfaFont.weight = value;
                                break;
                            case "font-style":
                                xfaFont.posture = value;
                                break;
                            case "letter-spacing":
                                xfaFont.letterSpacing = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin":
                                const values = value.split(/ \t/).map((x)=>(0, _utils.getMeasurement)(x));
                                switch(values.length){
                                    case 1:
                                        margin.top = margin.bottom = margin.left = margin.right = values[0];
                                        break;
                                    case 2:
                                        margin.top = margin.bottom = values[0];
                                        margin.left = margin.right = values[1];
                                        break;
                                    case 3:
                                        margin.top = values[0];
                                        margin.bottom = values[2];
                                        margin.left = margin.right = values[1];
                                        break;
                                    case 4:
                                        margin.top = values[0];
                                        margin.left = values[1];
                                        margin.bottom = values[2];
                                        margin.right = values[3];
                                        break;
                                }
                                break;
                            case "margin-top":
                                margin.top = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-bottom":
                                margin.bottom = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-left":
                                margin.left = (0, _utils.getMeasurement)(value);
                                break;
                            case "margin-right":
                                margin.right = (0, _utils.getMeasurement)(value);
                                break;
                            case "line-height":
                                lineHeight = (0, _utils.getMeasurement)(value);
                                break;
                        }
                        measure.pushData(xfaFont, margin, lineHeight);
                        if (this[_xfa_object.$content]) measure.addString(this[_xfa_object.$content]);
                        else for (const child of this[_xfa_object.$getChildren]()){
                            if (child[_xfa_object.$nodeName] === "#text") {
                                measure.addString(child[_xfa_object.$content]);
                                continue;
                            }
                            child[_xfa_object.$pushGlyphs](measure);
                        }
                        if (mustPop) measure.popFont();
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const children = [];
                        this[_xfa_object.$extra] = {
                            children: children
                        };
                        this[_xfa_object.$childrenToHTML]({});
                        if (children.length === 0 && !this[_xfa_object.$content]) return _utils.HTMLResult.EMPTY;
                        return _utils.HTMLResult.success({
                            name: this[_xfa_object.$nodeName],
                            attributes: {
                                href: this.href,
                                style: mapStyle(this.style, this[_xfa_object.$globalData].fontFinder)
                            },
                            children: children,
                            value: this[_xfa_object.$content] || ""
                        });
                    }
                }
                class A extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "a");
                        this.href = attributes.href || "";
                    }
                }
                class B extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "b");
                    }
                    [_xfa_object.$pushGlyphs](measure) {
                        measure.pushFont({
                            weight: "bold"
                        });
                        super[_xfa_object.$pushGlyphs](measure);
                        measure.popFont();
                    }
                }
                class Body extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "body");
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const res = super[_xfa_object.$toHTML](availableSpace);
                        const { html: html  } = res;
                        if (!html) return _utils.HTMLResult.EMPTY;
                        html.name = "div";
                        html.attributes.class = [
                            "xfaRich"
                        ];
                        return res;
                    }
                }
                class Br extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "br");
                    }
                    [_xfa_object.$text]() {
                        return "\n";
                    }
                    [_xfa_object.$pushGlyphs](measure) {
                        measure.addString("\n");
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        return _utils.HTMLResult.success({
                            name: "br"
                        });
                    }
                }
                class Html extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "html");
                    }
                    [_xfa_object.$toHTML](availableSpace) {
                        const children = [];
                        this[_xfa_object.$extra] = {
                            children: children
                        };
                        this[_xfa_object.$childrenToHTML]({});
                        if (children.length === 0) return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            value: this[_xfa_object.$content] || ""
                        });
                        if (children.length === 1) {
                            const child = children[0];
                            if (child.attributes && child.attributes.class.includes("xfaRich")) return _utils.HTMLResult.success(child);
                        }
                        return _utils.HTMLResult.success({
                            name: "div",
                            attributes: {
                                class: [
                                    "xfaRich"
                                ],
                                style: {}
                            },
                            children: children
                        });
                    }
                }
                class I extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "i");
                    }
                    [_xfa_object.$pushGlyphs](measure) {
                        measure.pushFont({
                            posture: "italic"
                        });
                        super[_xfa_object.$pushGlyphs](measure);
                        measure.popFont();
                    }
                }
                class Li extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "li");
                    }
                }
                class Ol extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "ol");
                    }
                }
                class P extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "p");
                    }
                    [_xfa_object.$pushGlyphs](measure) {
                        super[_xfa_object.$pushGlyphs](measure, false);
                        measure.addString("\n");
                        measure.addPara();
                        measure.popFont();
                    }
                    [_xfa_object.$text]() {
                        return super[_xfa_object.$text]() + "\n";
                    }
                }
                class Span extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "span");
                    }
                }
                class Sub extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "sub");
                    }
                }
                class Sup extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "sup");
                    }
                }
                class Ul extends XhtmlObject {
                    constructor(attributes){
                        super(attributes, "ul");
                    }
                }
                class XhtmlNamespace {
                    static [_namespaces.$buildXFAObject](name, attributes) {
                        if (XhtmlNamespace.hasOwnProperty(name)) return XhtmlNamespace[name](attributes);
                        return undefined;
                    }
                    static a(attributes) {
                        return new A(attributes);
                    }
                    static b(attributes) {
                        return new B(attributes);
                    }
                    static body(attributes) {
                        return new Body(attributes);
                    }
                    static br(attributes) {
                        return new Br(attributes);
                    }
                    static html(attributes) {
                        return new Html(attributes);
                    }
                    static i(attributes) {
                        return new I(attributes);
                    }
                    static li(attributes) {
                        return new Li(attributes);
                    }
                    static ol(attributes) {
                        return new Ol(attributes);
                    }
                    static p(attributes) {
                        return new P(attributes);
                    }
                    static span(attributes) {
                        return new Span(attributes);
                    }
                    static sub(attributes) {
                        return new Sub(attributes);
                    }
                    static sup(attributes) {
                        return new Sup(attributes);
                    }
                    static ul(attributes) {
                        return new Ul(attributes);
                    }
                }
                exports.XhtmlNamespace = XhtmlNamespace;
            /***/ },
            /* 97 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.UnknownNamespace = void 0;
                var _namespaces = __w_pdfjs_require__(77);
                var _xfa_object = __w_pdfjs_require__(75);
                class UnknownNamespace {
                    constructor(nsId){
                        this.namespaceId = nsId;
                    }
                    [_namespaces.$buildXFAObject](name, attributes) {
                        return new _xfa_object.XmlObject(this.namespaceId, name, attributes);
                    }
                }
                exports.UnknownNamespace = UnknownNamespace;
            /***/ },
            /* 98 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XRef = void 0;
                var _util = __w_pdfjs_require__(2);
                var _primitives = __w_pdfjs_require__(5);
                var _parser = __w_pdfjs_require__(17);
                var _core_utils = __w_pdfjs_require__(9);
                var _crypto = __w_pdfjs_require__(72);
                class XRef {
                    constructor(stream, pdfManager){
                        this.stream = stream;
                        this.pdfManager = pdfManager;
                        this.entries = [];
                        this.xrefstms = Object.create(null);
                        this._cacheMap = new Map();
                        this.stats = {
                            streamTypes: Object.create(null),
                            fontTypes: Object.create(null)
                        };
                        this._newRefNum = null;
                    }
                    getNewRef() {
                        if (this._newRefNum === null) this._newRefNum = this.entries.length;
                        return _primitives.Ref.get(this._newRefNum++, 0);
                    }
                    resetNewRef() {
                        this._newRefNum = null;
                    }
                    setStartXRef(startXRef) {
                        this.startXRefQueue = [
                            startXRef
                        ];
                    }
                    parse(recoveryMode = false) {
                        let trailerDict;
                        if (!recoveryMode) trailerDict = this.readXRef();
                        else {
                            (0, _util.warn)("Indexing all PDF objects");
                            trailerDict = this.indexObjects();
                        }
                        trailerDict.assignXref(this);
                        this.trailer = trailerDict;
                        let encrypt;
                        try {
                            encrypt = trailerDict.get("Encrypt");
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Encrypt" reference: "${ex}".`);
                        }
                        if ((0, _primitives.isDict)(encrypt)) {
                            const ids = trailerDict.get("ID");
                            const fileId = ids && ids.length ? ids[0] : "";
                            encrypt.suppressEncryption = true;
                            this.encrypt = new _crypto.CipherTransformFactory(encrypt, fileId, this.pdfManager.password);
                        }
                        let root;
                        try {
                            root = trailerDict.get("Root");
                        } catch (ex) {
                            if (ex instanceof _core_utils.MissingDataException) throw ex;
                            (0, _util.warn)(`XRef.parse - Invalid "Root" reference: "${ex}".`);
                        }
                        if ((0, _primitives.isDict)(root) && root.has("Pages")) this.root = root;
                        else {
                            if (!recoveryMode) throw new _core_utils.XRefParseException();
                            throw new _util.FormatError("Invalid root reference");
                        }
                    }
                    processXRefTable(parser) {
                        if (!("tableState" in this)) this.tableState = {
                            entryNum: 0,
                            streamPos: parser.lexer.stream.pos,
                            parserBuf1: parser.buf1,
                            parserBuf2: parser.buf2
                        };
                        const obj = this.readXRefTable(parser);
                        if (!(0, _primitives.isCmd)(obj, "trailer")) throw new _util.FormatError("Invalid XRef table: could not find trailer dictionary");
                        let dict = parser.getObj();
                        if (!(0, _primitives.isDict)(dict) && dict.dict) dict = dict.dict;
                        if (!(0, _primitives.isDict)(dict)) throw new _util.FormatError("Invalid XRef table: could not parse trailer dictionary");
                        delete this.tableState;
                        return dict;
                    }
                    readXRefTable(parser) {
                        const stream = parser.lexer.stream;
                        const tableState = this.tableState;
                        stream.pos = tableState.streamPos;
                        parser.buf1 = tableState.parserBuf1;
                        parser.buf2 = tableState.parserBuf2;
                        let obj;
                        while(true){
                            if (!("firstEntryNum" in tableState) || !("entryCount" in tableState)) {
                                if ((0, _primitives.isCmd)(obj = parser.getObj(), "trailer")) break;
                                tableState.firstEntryNum = obj;
                                tableState.entryCount = parser.getObj();
                            }
                            let first = tableState.firstEntryNum;
                            const count = tableState.entryCount;
                            if (!Number.isInteger(first) || !Number.isInteger(count)) throw new _util.FormatError("Invalid XRef table: wrong types in subsection header");
                            for(let i = tableState.entryNum; i < count; i++){
                                tableState.streamPos = stream.pos;
                                tableState.entryNum = i;
                                tableState.parserBuf1 = parser.buf1;
                                tableState.parserBuf2 = parser.buf2;
                                const entry = {};
                                entry.offset = parser.getObj();
                                entry.gen = parser.getObj();
                                const type = parser.getObj();
                                if (type instanceof _primitives.Cmd) switch(type.cmd){
                                    case "f":
                                        entry.free = true;
                                        break;
                                    case "n":
                                        entry.uncompressed = true;
                                        break;
                                }
                                if (!Number.isInteger(entry.offset) || !Number.isInteger(entry.gen) || !(entry.free || entry.uncompressed)) throw new _util.FormatError(`Invalid entry in XRef subsection: ${first}, ${count}`);
                                if (i === 0 && entry.free && first === 1) first = 0;
                                if (!this.entries[i + first]) this.entries[i + first] = entry;
                            }
                            tableState.entryNum = 0;
                            tableState.streamPos = stream.pos;
                            tableState.parserBuf1 = parser.buf1;
                            tableState.parserBuf2 = parser.buf2;
                            delete tableState.firstEntryNum;
                            delete tableState.entryCount;
                        }
                        if (this.entries[0] && !this.entries[0].free) throw new _util.FormatError("Invalid XRef table: unexpected first object");
                        return obj;
                    }
                    processXRefStream(stream) {
                        if (!("streamState" in this)) {
                            const streamParameters = stream.dict;
                            const byteWidths = streamParameters.get("W");
                            let range = streamParameters.get("Index");
                            if (!range) range = [
                                0,
                                streamParameters.get("Size")
                            ];
                            this.streamState = {
                                entryRanges: range,
                                byteWidths: byteWidths,
                                entryNum: 0,
                                streamPos: stream.pos
                            };
                        }
                        this.readXRefStream(stream);
                        delete this.streamState;
                        return stream.dict;
                    }
                    readXRefStream(stream) {
                        let i, j;
                        const streamState = this.streamState;
                        stream.pos = streamState.streamPos;
                        const byteWidths = streamState.byteWidths;
                        const typeFieldWidth = byteWidths[0];
                        const offsetFieldWidth = byteWidths[1];
                        const generationFieldWidth = byteWidths[2];
                        const entryRanges = streamState.entryRanges;
                        while(entryRanges.length > 0){
                            const first = entryRanges[0];
                            const n = entryRanges[1];
                            if (!Number.isInteger(first) || !Number.isInteger(n)) throw new _util.FormatError(`Invalid XRef range fields: ${first}, ${n}`);
                            if (!Number.isInteger(typeFieldWidth) || !Number.isInteger(offsetFieldWidth) || !Number.isInteger(generationFieldWidth)) throw new _util.FormatError(`Invalid XRef entry fields length: ${first}, ${n}`);
                            for(i = streamState.entryNum; i < n; ++i){
                                streamState.entryNum = i;
                                streamState.streamPos = stream.pos;
                                let type = 0, offset = 0, generation = 0;
                                for(j = 0; j < typeFieldWidth; ++j)type = type << 8 | stream.getByte();
                                if (typeFieldWidth === 0) type = 1;
                                for(j = 0; j < offsetFieldWidth; ++j)offset = offset << 8 | stream.getByte();
                                for(j = 0; j < generationFieldWidth; ++j)generation = generation << 8 | stream.getByte();
                                const entry = {};
                                entry.offset = offset;
                                entry.gen = generation;
                                switch(type){
                                    case 0:
                                        entry.free = true;
                                        break;
                                    case 1:
                                        entry.uncompressed = true;
                                        break;
                                    case 2:
                                        break;
                                    default:
                                        throw new _util.FormatError(`Invalid XRef entry type: ${type}`);
                                }
                                if (!this.entries[first + i]) this.entries[first + i] = entry;
                            }
                            streamState.entryNum = 0;
                            streamState.streamPos = stream.pos;
                            entryRanges.splice(0, 2);
                        }
                    }
                    indexObjects() {
                        const TAB = 0x9, LF = 0xa, CR = 0xd, SPACE = 0x20;
                        const PERCENT = 0x25, LT = 0x3c;
                        function readToken(data, offset) {
                            let token = "", ch = data[offset];
                            while(ch !== LF && ch !== CR && ch !== LT){
                                if (++offset >= data.length) break;
                                token += String.fromCharCode(ch);
                                ch = data[offset];
                            }
                            return token;
                        }
                        function skipUntil(data, offset, what) {
                            const length = what.length, dataLength = data.length;
                            let skipped = 0;
                            while(offset < dataLength){
                                let i = 0;
                                while(i < length && data[offset + i] === what[i])++i;
                                if (i >= length) break;
                                offset++;
                                skipped++;
                            }
                            return skipped;
                        }
                        const objRegExp = /^(\d+)\s+(\d+)\s+obj\b/;
                        const endobjRegExp = /\bendobj[\b\s]$/;
                        const nestedObjRegExp = /\s+(\d+\s+\d+\s+obj[\b\s<])$/;
                        const CHECK_CONTENT_LENGTH = 25;
                        const trailerBytes = new Uint8Array([
                            116,
                            114,
                            97,
                            105,
                            108,
                            101,
                            114
                        ]);
                        const startxrefBytes = new Uint8Array([
                            115,
                            116,
                            97,
                            114,
                            116,
                            120,
                            114,
                            101,
                            102
                        ]);
                        const objBytes = new Uint8Array([
                            111,
                            98,
                            106
                        ]);
                        const xrefBytes = new Uint8Array([
                            47,
                            88,
                            82,
                            101,
                            102
                        ]);
                        this.entries.length = 0;
                        const stream = this.stream;
                        stream.pos = 0;
                        const buffer = stream.getBytes(), length = buffer.length;
                        let position = stream.start;
                        const trailers = [], xrefStms = [];
                        while(position < length){
                            let ch = buffer[position];
                            if (ch === TAB || ch === LF || ch === CR || ch === SPACE) {
                                ++position;
                                continue;
                            }
                            if (ch === PERCENT) {
                                do {
                                    ++position;
                                    if (position >= length) break;
                                    ch = buffer[position];
                                }while (ch !== LF && ch !== CR);
                                continue;
                            }
                            const token = readToken(buffer, position);
                            let m;
                            if (token.startsWith("xref") && (token.length === 4 || /\s/.test(token[4]))) {
                                position += skipUntil(buffer, position, trailerBytes);
                                trailers.push(position);
                                position += skipUntil(buffer, position, startxrefBytes);
                            } else if (m = objRegExp.exec(token)) {
                                const num = m[1] | 0, gen = m[2] | 0;
                                let contentLength, startPos = position + token.length, updateEntries = false;
                                if (!this.entries[num]) updateEntries = true;
                                else if (this.entries[num].gen === gen) try {
                                    const parser = new _parser.Parser({
                                        lexer: new _parser.Lexer(stream.makeSubStream(startPos))
                                    });
                                    parser.getObj();
                                    updateEntries = true;
                                } catch (ex) {
                                    if (ex instanceof _core_utils.ParserEOFException) (0, _util.warn)(`indexObjects -- checking object (${token}): "${ex}".`);
                                    else updateEntries = true;
                                }
                                if (updateEntries) this.entries[num] = {
                                    offset: position - stream.start,
                                    gen: gen,
                                    uncompressed: true
                                };
                                while(startPos < buffer.length){
                                    const endPos = startPos + skipUntil(buffer, startPos, objBytes) + 4;
                                    contentLength = endPos - position;
                                    const checkPos = Math.max(endPos - CHECK_CONTENT_LENGTH, startPos);
                                    const tokenStr = (0, _util.bytesToString)(buffer.subarray(checkPos, endPos));
                                    if (endobjRegExp.test(tokenStr)) break;
                                    else {
                                        const objToken = nestedObjRegExp.exec(tokenStr);
                                        if (objToken && objToken[1]) {
                                            (0, _util.warn)('indexObjects: Found new "obj" inside of another "obj", caused by missing "endobj" -- trying to recover.');
                                            contentLength -= objToken[1].length;
                                            break;
                                        }
                                    }
                                    startPos = endPos;
                                }
                                const content = buffer.subarray(position, position + contentLength);
                                const xrefTagOffset = skipUntil(content, 0, xrefBytes);
                                if (xrefTagOffset < contentLength && content[xrefTagOffset + 5] < 64) {
                                    xrefStms.push(position - stream.start);
                                    this.xrefstms[position - stream.start] = 1;
                                }
                                position += contentLength;
                            } else if (token.startsWith("trailer") && (token.length === 7 || /\s/.test(token[7]))) {
                                trailers.push(position);
                                position += skipUntil(buffer, position, startxrefBytes);
                            } else position += token.length + 1;
                        }
                        for(let i = 0, ii = xrefStms.length; i < ii; ++i){
                            this.startXRefQueue.push(xrefStms[i]);
                            this.readXRef(true);
                        }
                        let trailerDict;
                        for(let i = 0, ii = trailers.length; i < ii; ++i){
                            stream.pos = trailers[i];
                            const parser = new _parser.Parser({
                                lexer: new _parser.Lexer(stream),
                                xref: this,
                                allowStreams: true,
                                recoveryMode: true
                            });
                            const obj = parser.getObj();
                            if (!(0, _primitives.isCmd)(obj, "trailer")) continue;
                            const dict = parser.getObj();
                            if (!(0, _primitives.isDict)(dict)) continue;
                            try {
                                const rootDict = dict.get("Root");
                                if (!(rootDict instanceof _primitives.Dict)) continue;
                                const pagesDict = rootDict.get("Pages");
                                if (!(pagesDict instanceof _primitives.Dict)) continue;
                                const pagesCount = pagesDict.get("Count");
                                if (!Number.isInteger(pagesCount)) continue;
                            } catch (ex) {
                                continue;
                            }
                            if (dict.has("ID")) return dict;
                            trailerDict = dict;
                        }
                        if (trailerDict) return trailerDict;
                        throw new _util.InvalidPDFException("Invalid PDF structure.");
                    }
                    readXRef(recoveryMode = false) {
                        const stream = this.stream;
                        const startXRefParsedCache = new Set();
                        try {
                            while(this.startXRefQueue.length){
                                const startXRef = this.startXRefQueue[0];
                                if (startXRefParsedCache.has(startXRef)) {
                                    (0, _util.warn)("readXRef - skipping XRef table since it was already parsed.");
                                    this.startXRefQueue.shift();
                                    continue;
                                }
                                startXRefParsedCache.add(startXRef);
                                stream.pos = startXRef + stream.start;
                                const parser = new _parser.Parser({
                                    lexer: new _parser.Lexer(stream),
                                    xref: this,
                                    allowStreams: true
                                });
                                let obj = parser.getObj();
                                let dict;
                                if ((0, _primitives.isCmd)(obj, "xref")) {
                                    dict = this.processXRefTable(parser);
                                    if (!this.topDict) this.topDict = dict;
                                    obj = dict.get("XRefStm");
                                    if (Number.isInteger(obj)) {
                                        const pos = obj;
                                        if (!(pos in this.xrefstms)) {
                                            this.xrefstms[pos] = 1;
                                            this.startXRefQueue.push(pos);
                                        }
                                    }
                                } else if (Number.isInteger(obj)) {
                                    if (!Number.isInteger(parser.getObj()) || !(0, _primitives.isCmd)(parser.getObj(), "obj") || !(0, _primitives.isStream)(obj = parser.getObj())) throw new _util.FormatError("Invalid XRef stream");
                                    dict = this.processXRefStream(obj);
                                    if (!this.topDict) this.topDict = dict;
                                    if (!dict) throw new _util.FormatError("Failed to read XRef stream");
                                } else throw new _util.FormatError("Invalid XRef stream header");
                                obj = dict.get("Prev");
                                if (Number.isInteger(obj)) this.startXRefQueue.push(obj);
                                else if ((0, _primitives.isRef)(obj)) this.startXRefQueue.push(obj.num);
                                this.startXRefQueue.shift();
                            }
                            return this.topDict;
                        } catch (e) {
                            if (e instanceof _core_utils.MissingDataException) throw e;
                            (0, _util.info)("(while reading XRef): " + e);
                        }
                        if (recoveryMode) return undefined;
                        throw new _core_utils.XRefParseException();
                    }
                    getEntry(i) {
                        const xrefEntry = this.entries[i];
                        if (xrefEntry && !xrefEntry.free && xrefEntry.offset) return xrefEntry;
                        return null;
                    }
                    fetchIfRef(obj, suppressEncryption = false) {
                        if (obj instanceof _primitives.Ref) return this.fetch(obj, suppressEncryption);
                        return obj;
                    }
                    fetch(ref, suppressEncryption = false) {
                        if (!(ref instanceof _primitives.Ref)) throw new Error("ref object is not a reference");
                        const num = ref.num;
                        const cacheEntry = this._cacheMap.get(num);
                        if (cacheEntry !== undefined) {
                            if (cacheEntry instanceof _primitives.Dict && !cacheEntry.objId) cacheEntry.objId = ref.toString();
                            return cacheEntry;
                        }
                        let xrefEntry = this.getEntry(num);
                        if (xrefEntry === null) {
                            this._cacheMap.set(num, xrefEntry);
                            return xrefEntry;
                        }
                        if (xrefEntry.uncompressed) xrefEntry = this.fetchUncompressed(ref, xrefEntry, suppressEncryption);
                        else xrefEntry = this.fetchCompressed(ref, xrefEntry, suppressEncryption);
                        if ((0, _primitives.isDict)(xrefEntry)) xrefEntry.objId = ref.toString();
                        else if ((0, _primitives.isStream)(xrefEntry)) xrefEntry.dict.objId = ref.toString();
                        return xrefEntry;
                    }
                    fetchUncompressed(ref, xrefEntry, suppressEncryption = false) {
                        const gen = ref.gen;
                        let num = ref.num;
                        if (xrefEntry.gen !== gen) throw new _core_utils.XRefEntryException(`Inconsistent generation in XRef: ${ref}`);
                        const stream = this.stream.makeSubStream(xrefEntry.offset + this.stream.start);
                        const parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream),
                            xref: this,
                            allowStreams: true
                        });
                        const obj1 = parser.getObj();
                        const obj2 = parser.getObj();
                        const obj3 = parser.getObj();
                        if (obj1 !== num || obj2 !== gen || !(obj3 instanceof _primitives.Cmd)) throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref}`);
                        if (obj3.cmd !== "obj") {
                            if (obj3.cmd.startsWith("obj")) {
                                num = parseInt(obj3.cmd.substring(3), 10);
                                if (!Number.isNaN(num)) return num;
                            }
                            throw new _core_utils.XRefEntryException(`Bad (uncompressed) XRef entry: ${ref}`);
                        }
                        if (this.encrypt && !suppressEncryption) xrefEntry = parser.getObj(this.encrypt.createCipherTransform(num, gen));
                        else xrefEntry = parser.getObj();
                        if (!(0, _primitives.isStream)(xrefEntry)) this._cacheMap.set(num, xrefEntry);
                        return xrefEntry;
                    }
                    fetchCompressed(ref, xrefEntry, suppressEncryption = false) {
                        const tableOffset = xrefEntry.offset;
                        const stream = this.fetch(_primitives.Ref.get(tableOffset, 0));
                        if (!(0, _primitives.isStream)(stream)) throw new _util.FormatError("bad ObjStm stream");
                        const first = stream.dict.get("First");
                        const n = stream.dict.get("N");
                        if (!Number.isInteger(first) || !Number.isInteger(n)) throw new _util.FormatError("invalid first and n parameters for ObjStm stream");
                        let parser = new _parser.Parser({
                            lexer: new _parser.Lexer(stream),
                            xref: this,
                            allowStreams: true
                        });
                        const nums = new Array(n);
                        const offsets = new Array(n);
                        for(let i = 0; i < n; ++i){
                            const num = parser.getObj();
                            if (!Number.isInteger(num)) throw new _util.FormatError(`invalid object number in the ObjStm stream: ${num}`);
                            const offset = parser.getObj();
                            if (!Number.isInteger(offset)) throw new _util.FormatError(`invalid object offset in the ObjStm stream: ${offset}`);
                            nums[i] = num;
                            offsets[i] = offset;
                        }
                        const start = (stream.start || 0) + first;
                        const entries = new Array(n);
                        for(let i = 0; i < n; ++i){
                            const length = i < n - 1 ? offsets[i + 1] - offsets[i] : undefined;
                            if (length < 0) throw new _util.FormatError("Invalid offset in the ObjStm stream.");
                            parser = new _parser.Parser({
                                lexer: new _parser.Lexer(stream.makeSubStream(start + offsets[i], length, stream.dict)),
                                xref: this,
                                allowStreams: true
                            });
                            const obj = parser.getObj();
                            entries[i] = obj;
                            if ((0, _primitives.isStream)(obj)) continue;
                            const num = nums[i], entry = this.entries[num];
                            if (entry && entry.offset === tableOffset && entry.gen === i) this._cacheMap.set(num, obj);
                        }
                        xrefEntry = entries[xrefEntry.gen];
                        if (xrefEntry === undefined) throw new _core_utils.XRefEntryException(`Bad (compressed) XRef entry: ${ref}`);
                        return xrefEntry;
                    }
                    async fetchIfRefAsync(obj, suppressEncryption) {
                        if (obj instanceof _primitives.Ref) return this.fetchAsync(obj, suppressEncryption);
                        return obj;
                    }
                    async fetchAsync(ref, suppressEncryption) {
                        try {
                            return this.fetch(ref, suppressEncryption);
                        } catch (ex) {
                            if (!(ex instanceof _core_utils.MissingDataException)) throw ex;
                            await this.pdfManager.requestRange(ex.begin, ex.end);
                            return this.fetchAsync(ref, suppressEncryption);
                        }
                    }
                    getCatalogObj() {
                        return this.root;
                    }
                }
                exports.XRef = XRef;
            /***/ },
            /* 99 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(2);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (typeof reason !== "object" || reason === null) return reason;
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                class MessageHandler {
                    constructor(sourceName, targetName, comObj){
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.postMessageTransfers = true;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                this._processStreamMessage(data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                this._createStreamSink(data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this._postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = (0, _util.createPromiseCapability)();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this._postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++;
                        const sourceName = this.sourceName;
                        const targetName = this.targetName;
                        const comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = (0, _util.createPromiseCapability)();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                this._postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = (0, _util.createPromiseCapability)();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = (0, _util.createPromiseCapability)();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    _createStreamSink(data) {
                        const self1 = this;
                        const action = this.actionHandler[data.action];
                        const streamId = data.streamId;
                        const sourceName = this.sourceName;
                        const targetName = data.sourceName;
                        const comObj = this.comObj;
                        const streamSink = {
                            enqueue (chunk, size = 1, transfers) {
                                if (this.isCancelled) return;
                                const lastDesiredSize = this.desiredSize;
                                this.desiredSize -= size;
                                if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                    this.sinkCapability = (0, _util.createPromiseCapability)();
                                    this.ready = this.sinkCapability.promise;
                                }
                                self1._postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ENQUEUE,
                                    streamId: streamId,
                                    chunk: chunk
                                }, transfers);
                            },
                            close () {
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CLOSE,
                                    streamId: streamId
                                });
                                delete self1.streamSinks[streamId];
                            },
                            error (reason) {
                                (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                                if (this.isCancelled) return;
                                this.isCancelled = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.ERROR,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            },
                            sinkCapability: (0, _util.createPromiseCapability)(),
                            onPull: null,
                            onCancel: null,
                            isCancelled: false,
                            desiredSize: data.desiredSize,
                            ready: null
                        };
                        streamSink.sinkCapability.resolve();
                        streamSink.ready = streamSink.sinkCapability.promise;
                        this.streamSinks[streamId] = streamSink;
                        new Promise(function(resolve) {
                            resolve(action(data.data, streamSink));
                        }).then(function() {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                success: true
                            });
                        }, function(reason) {
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.START_COMPLETE,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        });
                    }
                    _processStreamMessage(data) {
                        const streamId = data.streamId;
                        const sourceName = this.sourceName;
                        const targetName = data.sourceName;
                        const comObj = this.comObj;
                        switch(data.stream){
                            case StreamKind.START_COMPLETE:
                                if (data.success) this.streamControllers[streamId].startCall.resolve();
                                else this.streamControllers[streamId].startCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL_COMPLETE:
                                if (data.success) this.streamControllers[streamId].pullCall.resolve();
                                else this.streamControllers[streamId].pullCall.reject(wrapReason(data.reason));
                                break;
                            case StreamKind.PULL:
                                if (!this.streamSinks[streamId]) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                    break;
                                }
                                if (this.streamSinks[streamId].desiredSize <= 0 && data.desiredSize > 0) this.streamSinks[streamId].sinkCapability.resolve();
                                this.streamSinks[streamId].desiredSize = data.desiredSize;
                                const { onPull: onPull  } = this.streamSinks[data.streamId];
                                new Promise(function(resolve) {
                                    resolve(onPull && onPull());
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.PULL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                break;
                            case StreamKind.ENQUEUE:
                                (0, _util.assert)(this.streamControllers[streamId], "enqueue should have stream controller");
                                if (this.streamControllers[streamId].isClosed) break;
                                this.streamControllers[streamId].controller.enqueue(data.chunk);
                                break;
                            case StreamKind.CLOSE:
                                (0, _util.assert)(this.streamControllers[streamId], "close should have stream controller");
                                if (this.streamControllers[streamId].isClosed) break;
                                this.streamControllers[streamId].isClosed = true;
                                this.streamControllers[streamId].controller.close();
                                this._deleteStreamController(streamId);
                                break;
                            case StreamKind.ERROR:
                                (0, _util.assert)(this.streamControllers[streamId], "error should have stream controller");
                                this.streamControllers[streamId].controller.error(wrapReason(data.reason));
                                this._deleteStreamController(streamId);
                                break;
                            case StreamKind.CANCEL_COMPLETE:
                                if (data.success) this.streamControllers[streamId].cancelCall.resolve();
                                else this.streamControllers[streamId].cancelCall.reject(wrapReason(data.reason));
                                this._deleteStreamController(streamId);
                                break;
                            case StreamKind.CANCEL:
                                if (!this.streamSinks[streamId]) break;
                                const { onCancel: onCancel  } = this.streamSinks[data.streamId];
                                new Promise(function(resolve) {
                                    resolve(onCancel && onCancel(wrapReason(data.reason)));
                                }).then(function() {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        success: true
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: sourceName,
                                        targetName: targetName,
                                        stream: StreamKind.CANCEL_COMPLETE,
                                        streamId: streamId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                this.streamSinks[streamId].sinkCapability.reject(wrapReason(data.reason));
                                this.streamSinks[streamId].isCancelled = true;
                                delete this.streamSinks[streamId];
                                break;
                            default:
                                throw new Error("Unexpected stream case");
                        }
                    }
                    async _deleteStreamController(streamId) {
                        await Promise.allSettled([
                            this.streamControllers[streamId].startCall,
                            this.streamControllers[streamId].pullCall,
                            this.streamControllers[streamId].cancelCall
                        ].map(function(capability) {
                            return capability && capability.promise;
                        }));
                        delete this.streamControllers[streamId];
                    }
                    _postMessage(message, transfers) {
                        if (transfers && this.postMessageTransfers) this.comObj.postMessage(message, transfers);
                        else this.comObj.postMessage(message);
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 100 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFWorkerStream = void 0;
                var _util = __w_pdfjs_require__(2);
                class PDFWorkerStream {
                    constructor(msgHandler){
                        this._msgHandler = msgHandler;
                        this._contentLength = null;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFWorkerStreamReader(this._msgHandler);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFWorkerStreamRangeReader(begin, end, this._msgHandler);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        if (this._fullRequestReader) this._fullRequestReader.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                }
                exports.PDFWorkerStream = PDFWorkerStream;
                class PDFWorkerStreamReader {
                    constructor(msgHandler){
                        this._msgHandler = msgHandler;
                        this.onProgress = null;
                        this._contentLength = null;
                        this._isRangeSupported = false;
                        this._isStreamingSupported = false;
                        const readableStream = this._msgHandler.sendWithStream("GetReader");
                        this._reader = readableStream.getReader();
                        this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((data)=>{
                            this._isStreamingSupported = data.isStreamingSupported;
                            this._isRangeSupported = data.isRangeSupported;
                            this._contentLength = data.contentLength;
                        });
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    async read() {
                        const { value: value , done: done  } = await this._reader.read();
                        if (done) return {
                            value: undefined,
                            done: true
                        };
                        return {
                            value: value.buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader.cancel(reason);
                    }
                }
                class PDFWorkerStreamRangeReader {
                    constructor(begin, end, msgHandler){
                        this._msgHandler = msgHandler;
                        this.onProgress = null;
                        const readableStream = this._msgHandler.sendWithStream("GetRangeReader", {
                            begin: begin,
                            end: end
                        });
                        this._reader = readableStream.getReader();
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    async read() {
                        const { value: value , done: done  } = await this._reader.read();
                        if (done) return {
                            value: undefined,
                            done: true
                        };
                        return {
                            value: value.buffer,
                            done: false
                        };
                    }
                    cancel(reason) {
                        this._reader.cancel(reason);
                    }
                }
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __w_pdfjs_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__w_pdfjs_require__.o(definition, key) && !__w_pdfjs_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __w_pdfjs_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __w_pdfjs_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "WorkerMessageHandler", {
                enumerable: true,
                get: function() {
                    return _worker.WorkerMessageHandler;
                }
            });
            var _worker = __w_pdfjs_require__(1);
            const pdfjsVersion = "2.10.377";
            const pdfjsBuild = "156762c48";
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});

var $72c4360166cb2772$exports = {};
"use strict";

$72c4360166cb2772$exports = (parcelRequire("1yLTD"));


var $9c2dbb7ea249fb70$exports = {};
var $c3efb8b60a10501d$exports = {};
"use strict";
var $9ed9042111b4a31b$exports = {};
"use strict";
var $0567ab4d6055322a$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $aaa618e447f69f06$exports = {};
var $d593813970ff8a3a$exports = {};
var $9a0ef7b863e9a57f$exports = {};
var $6c212d9340b89abe$exports = {};
$6c212d9340b89abe$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


$9a0ef7b863e9a57f$exports = !$6c212d9340b89abe$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $d593813970ff8a3a$var$FunctionPrototype = Function.prototype;
var $d593813970ff8a3a$var$call = $d593813970ff8a3a$var$FunctionPrototype.call;
var $d593813970ff8a3a$var$uncurryThisWithBind = $9a0ef7b863e9a57f$exports && $d593813970ff8a3a$var$FunctionPrototype.bind.bind($d593813970ff8a3a$var$call, $d593813970ff8a3a$var$call);
$d593813970ff8a3a$exports = $9a0ef7b863e9a57f$exports ? $d593813970ff8a3a$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $d593813970ff8a3a$var$call.apply(fn, arguments);
    };
};



var $51cc73928c08e4ea$exports = {};

var $51cc73928c08e4ea$var$toString = $d593813970ff8a3a$exports({}.toString);
var $51cc73928c08e4ea$var$stringSlice = $d593813970ff8a3a$exports("".slice);
$51cc73928c08e4ea$exports = function(it) {
    return $51cc73928c08e4ea$var$stringSlice($51cc73928c08e4ea$var$toString(it), 8, -1);
};


var $aaa618e447f69f06$var$$Object = Object;
var $aaa618e447f69f06$var$split = $d593813970ff8a3a$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$aaa618e447f69f06$exports = $6c212d9340b89abe$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$aaa618e447f69f06$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $51cc73928c08e4ea$exports(it) == "String" ? $aaa618e447f69f06$var$split(it, "") : $aaa618e447f69f06$var$$Object(it);
} : $aaa618e447f69f06$var$$Object;


var $7cdf0b67f6a079b0$exports = {};
var $ed6eb49d28c3042d$exports = {};
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$ed6eb49d28c3042d$exports = function(it) {
    return it === null || it === undefined;
};


var $7cdf0b67f6a079b0$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$7cdf0b67f6a079b0$exports = function(it) {
    if ($ed6eb49d28c3042d$exports(it)) throw $7cdf0b67f6a079b0$var$$TypeError("Can't call method on " + it);
    return it;
};


$0567ab4d6055322a$exports = function(it) {
    return $aaa618e447f69f06$exports($7cdf0b67f6a079b0$exports(it));
};


var $4b57d2408d09472f$exports = {};
$4b57d2408d09472f$exports = function() {};


var $dbb8aae4e5a7f843$exports = {};
$dbb8aae4e5a7f843$exports = {};


var $f689abe66c9adff6$exports = {};
var $2ef2f4d9c8c262ae$exports = {};
var $77860603706a0f77$exports = {};
var $77860603706a0f77$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$77860603706a0f77$exports = // eslint-disable-next-line es/no-global-this -- safe
$77860603706a0f77$var$check(typeof globalThis == "object" && globalThis) || $77860603706a0f77$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$77860603706a0f77$var$check(typeof self == "object" && self) || $77860603706a0f77$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || $77860603706a0f77$exports || Function("return this")();


var $c781bf4f9f236cf5$exports = {};
var $1b0ed2b28e8b4187$exports = {};
var $1b0ed2b28e8b4187$var$documentAll = typeof document == "object" && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var $1b0ed2b28e8b4187$var$IS_HTMLDDA = typeof $1b0ed2b28e8b4187$var$documentAll == "undefined" && $1b0ed2b28e8b4187$var$documentAll !== undefined;
$1b0ed2b28e8b4187$exports = {
    all: $1b0ed2b28e8b4187$var$documentAll,
    IS_HTMLDDA: $1b0ed2b28e8b4187$var$IS_HTMLDDA
};


var $c781bf4f9f236cf5$var$documentAll = $1b0ed2b28e8b4187$exports.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
$c781bf4f9f236cf5$exports = $1b0ed2b28e8b4187$exports.IS_HTMLDDA ? function(argument) {
    return typeof argument == "function" || argument === $c781bf4f9f236cf5$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $2ef2f4d9c8c262ae$var$WeakMap = $77860603706a0f77$exports.WeakMap;
$2ef2f4d9c8c262ae$exports = $c781bf4f9f236cf5$exports($2ef2f4d9c8c262ae$var$WeakMap) && /native code/.test(String($2ef2f4d9c8c262ae$var$WeakMap));



var $9adfe215028fa96a$exports = {};


var $9adfe215028fa96a$var$documentAll = $1b0ed2b28e8b4187$exports.all;
$9adfe215028fa96a$exports = $1b0ed2b28e8b4187$exports.IS_HTMLDDA ? function(it) {
    return typeof it == "object" ? it !== null : $c781bf4f9f236cf5$exports(it) || it === $9adfe215028fa96a$var$documentAll;
} : function(it) {
    return typeof it == "object" ? it !== null : $c781bf4f9f236cf5$exports(it);
};


var $3665666f26b5c099$exports = {};
var $c483fe5296753c65$exports = {};

// Detect IE8's incomplete defineProperty implementation
$c483fe5296753c65$exports = !$6c212d9340b89abe$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $8157edd438c44d90$export$2d1720544b23b823;

var $9c8c33df5aa2532d$exports = {};


var $53f6444582dd9bdc$exports = {};


var $53f6444582dd9bdc$var$document = $77860603706a0f77$exports.document;
// typeof document.createElement is 'object' in old IE
var $53f6444582dd9bdc$var$EXISTS = $9adfe215028fa96a$exports($53f6444582dd9bdc$var$document) && $9adfe215028fa96a$exports($53f6444582dd9bdc$var$document.createElement);
$53f6444582dd9bdc$exports = function(it) {
    return $53f6444582dd9bdc$var$EXISTS ? $53f6444582dd9bdc$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$9c8c33df5aa2532d$exports = !$c483fe5296753c65$exports && !$6c212d9340b89abe$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($53f6444582dd9bdc$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


var $bd33f65bd298931a$exports = {};


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$bd33f65bd298931a$exports = $c483fe5296753c65$exports && $6c212d9340b89abe$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});


var $c8b2cd917e169a50$exports = {};

var $c8b2cd917e169a50$var$$String = String;
var $c8b2cd917e169a50$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$c8b2cd917e169a50$exports = function(argument) {
    if ($9adfe215028fa96a$exports(argument)) return argument;
    throw $c8b2cd917e169a50$var$$TypeError($c8b2cd917e169a50$var$$String(argument) + " is not an object");
};


var $cb97a67f070a4d38$exports = {};
var $d8d8fa6582f7ae36$exports = {};
var $a118597fd6ab4fb8$exports = {};

var $a118597fd6ab4fb8$var$call = Function.prototype.call;
$a118597fd6ab4fb8$exports = $9a0ef7b863e9a57f$exports ? $a118597fd6ab4fb8$var$call.bind($a118597fd6ab4fb8$var$call) : function() {
    return $a118597fd6ab4fb8$var$call.apply($a118597fd6ab4fb8$var$call, arguments);
};



var $fb895af99b5f9b15$exports = {};
var $6cbbc5bb2c5db598$exports = {};
var $e46b5adc12f872b4$exports = {};
$e46b5adc12f872b4$exports = {};




var $6cbbc5bb2c5db598$var$aFunction = function(variable) {
    return $c781bf4f9f236cf5$exports(variable) ? variable : undefined;
};
$6cbbc5bb2c5db598$exports = function(namespace, method) {
    return arguments.length < 2 ? $6cbbc5bb2c5db598$var$aFunction($e46b5adc12f872b4$exports[namespace]) || $6cbbc5bb2c5db598$var$aFunction($77860603706a0f77$exports[namespace]) : $e46b5adc12f872b4$exports[namespace] && $e46b5adc12f872b4$exports[namespace][method] || $77860603706a0f77$exports[namespace] && $77860603706a0f77$exports[namespace][method];
};



var $5b6bbf0c049aa1bd$exports = {};

$5b6bbf0c049aa1bd$exports = $d593813970ff8a3a$exports({}.isPrototypeOf);


var $6ed10d1f3504e7b6$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $f83766784497fd8f$exports = {};
/* eslint-disable es/no-symbol -- required for testing */ var $2d7e42ffbedb91ed$exports = {};

var $5148efcd8dba02f5$exports = {};
$5148efcd8dba02f5$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $2d7e42ffbedb91ed$var$process = $77860603706a0f77$exports.process;
var $2d7e42ffbedb91ed$var$Deno = $77860603706a0f77$exports.Deno;
var $2d7e42ffbedb91ed$var$versions = $2d7e42ffbedb91ed$var$process && $2d7e42ffbedb91ed$var$process.versions || $2d7e42ffbedb91ed$var$Deno && $2d7e42ffbedb91ed$var$Deno.version;
var $2d7e42ffbedb91ed$var$v8 = $2d7e42ffbedb91ed$var$versions && $2d7e42ffbedb91ed$var$versions.v8;
var $2d7e42ffbedb91ed$var$match, $2d7e42ffbedb91ed$var$version;
if ($2d7e42ffbedb91ed$var$v8) {
    $2d7e42ffbedb91ed$var$match = $2d7e42ffbedb91ed$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $2d7e42ffbedb91ed$var$version = $2d7e42ffbedb91ed$var$match[0] > 0 && $2d7e42ffbedb91ed$var$match[0] < 4 ? 1 : +($2d7e42ffbedb91ed$var$match[0] + $2d7e42ffbedb91ed$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$2d7e42ffbedb91ed$var$version && $5148efcd8dba02f5$exports) {
    $2d7e42ffbedb91ed$var$match = $5148efcd8dba02f5$exports.match(/Edge\/(\d+)/);
    if (!$2d7e42ffbedb91ed$var$match || $2d7e42ffbedb91ed$var$match[1] >= 74) {
        $2d7e42ffbedb91ed$var$match = $5148efcd8dba02f5$exports.match(/Chrome\/(\d+)/);
        if ($2d7e42ffbedb91ed$var$match) $2d7e42ffbedb91ed$var$version = +$2d7e42ffbedb91ed$var$match[1];
    }
}
$2d7e42ffbedb91ed$exports = $2d7e42ffbedb91ed$var$version;




var $f83766784497fd8f$var$$String = $77860603706a0f77$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$f83766784497fd8f$exports = !!Object.getOwnPropertySymbols && !$6c212d9340b89abe$exports(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$f83766784497fd8f$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $2d7e42ffbedb91ed$exports && $2d7e42ffbedb91ed$exports < 41;
});


$6ed10d1f3504e7b6$exports = $f83766784497fd8f$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $fb895af99b5f9b15$var$$Object = Object;
$fb895af99b5f9b15$exports = $6ed10d1f3504e7b6$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $6cbbc5bb2c5db598$exports("Symbol");
    return $c781bf4f9f236cf5$exports($Symbol) && $5b6bbf0c049aa1bd$exports($Symbol.prototype, $fb895af99b5f9b15$var$$Object(it));
};


var $958bbb6dd5adebba$exports = {};
var $812f71e6b829da81$exports = {};

var $a1455e29d850768c$exports = {};
var $a1455e29d850768c$var$$String = String;
$a1455e29d850768c$exports = function(argument) {
    try {
        return $a1455e29d850768c$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $812f71e6b829da81$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$812f71e6b829da81$exports = function(argument) {
    if ($c781bf4f9f236cf5$exports(argument)) return argument;
    throw $812f71e6b829da81$var$$TypeError($a1455e29d850768c$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$958bbb6dd5adebba$exports = function(V, P) {
    var func = V[P];
    return $ed6eb49d28c3042d$exports(func) ? undefined : $812f71e6b829da81$exports(func);
};


var $d7e25f3f4353c3cf$exports = {};



var $d7e25f3f4353c3cf$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$d7e25f3f4353c3cf$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $c781bf4f9f236cf5$exports(fn = input.toString) && !$9adfe215028fa96a$exports(val = $a118597fd6ab4fb8$exports(fn, input))) return val;
    if ($c781bf4f9f236cf5$exports(fn = input.valueOf) && !$9adfe215028fa96a$exports(val = $a118597fd6ab4fb8$exports(fn, input))) return val;
    if (pref !== "string" && $c781bf4f9f236cf5$exports(fn = input.toString) && !$9adfe215028fa96a$exports(val = $a118597fd6ab4fb8$exports(fn, input))) return val;
    throw $d7e25f3f4353c3cf$var$$TypeError("Can't convert object to primitive value");
};


var $6040a00f5bf4e463$exports = {};

var $f2da5657fee08c8f$exports = {};
var $28c67c425d8359f4$exports = {};
$28c67c425d8359f4$exports = true;


var $370f98ac39927661$exports = {};

var $8ebdd6ad9ee03201$exports = {};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $8ebdd6ad9ee03201$var$defineProperty = Object.defineProperty;
$8ebdd6ad9ee03201$exports = function(key, value) {
    try {
        $8ebdd6ad9ee03201$var$defineProperty($77860603706a0f77$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $77860603706a0f77$exports[key] = value;
    }
    return value;
};


var $370f98ac39927661$var$SHARED = "__core-js_shared__";
var $370f98ac39927661$var$store = $77860603706a0f77$exports[$370f98ac39927661$var$SHARED] || $8ebdd6ad9ee03201$exports($370f98ac39927661$var$SHARED, {});
$370f98ac39927661$exports = $370f98ac39927661$var$store;


($f2da5657fee08c8f$exports = function(key, value) {
    return $370f98ac39927661$exports[key] || ($370f98ac39927661$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.30.2",
    mode: $28c67c425d8359f4$exports ? "pure" : "global",
    copyright: "\xa9 2014-2023 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.30.2/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $84d6a9b73b839b2c$exports = {};

var $85decdba26472647$exports = {};

var $85decdba26472647$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$85decdba26472647$exports = function(argument) {
    return $85decdba26472647$var$$Object($7cdf0b67f6a079b0$exports(argument));
};


var $84d6a9b73b839b2c$var$hasOwnProperty = $d593813970ff8a3a$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$84d6a9b73b839b2c$exports = Object.hasOwn || function hasOwn(it, key) {
    return $84d6a9b73b839b2c$var$hasOwnProperty($85decdba26472647$exports(it), key);
};


var $542696d0e20d8e81$exports = {};

var $542696d0e20d8e81$var$id = 0;
var $542696d0e20d8e81$var$postfix = Math.random();
var $542696d0e20d8e81$var$toString = $d593813970ff8a3a$exports(1.0.toString);
$542696d0e20d8e81$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $542696d0e20d8e81$var$toString(++$542696d0e20d8e81$var$id + $542696d0e20d8e81$var$postfix, 36);
};




var $6040a00f5bf4e463$var$Symbol = $77860603706a0f77$exports.Symbol;
var $6040a00f5bf4e463$var$WellKnownSymbolsStore = $f2da5657fee08c8f$exports("wks");
var $6040a00f5bf4e463$var$createWellKnownSymbol = $6ed10d1f3504e7b6$exports ? $6040a00f5bf4e463$var$Symbol["for"] || $6040a00f5bf4e463$var$Symbol : $6040a00f5bf4e463$var$Symbol && $6040a00f5bf4e463$var$Symbol.withoutSetter || $542696d0e20d8e81$exports;
$6040a00f5bf4e463$exports = function(name) {
    if (!$84d6a9b73b839b2c$exports($6040a00f5bf4e463$var$WellKnownSymbolsStore, name)) $6040a00f5bf4e463$var$WellKnownSymbolsStore[name] = $f83766784497fd8f$exports && $84d6a9b73b839b2c$exports($6040a00f5bf4e463$var$Symbol, name) ? $6040a00f5bf4e463$var$Symbol[name] : $6040a00f5bf4e463$var$createWellKnownSymbol("Symbol." + name);
    return $6040a00f5bf4e463$var$WellKnownSymbolsStore[name];
};


var $d8d8fa6582f7ae36$var$$TypeError = TypeError;
var $d8d8fa6582f7ae36$var$TO_PRIMITIVE = $6040a00f5bf4e463$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$d8d8fa6582f7ae36$exports = function(input, pref) {
    if (!$9adfe215028fa96a$exports(input) || $fb895af99b5f9b15$exports(input)) return input;
    var exoticToPrim = $958bbb6dd5adebba$exports(input, $d8d8fa6582f7ae36$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $a118597fd6ab4fb8$exports(exoticToPrim, input, pref);
        if (!$9adfe215028fa96a$exports(result) || $fb895af99b5f9b15$exports(result)) return result;
        throw $d8d8fa6582f7ae36$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $d7e25f3f4353c3cf$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$cb97a67f070a4d38$exports = function(argument) {
    var key = $d8d8fa6582f7ae36$exports(argument, "string");
    return $fb895af99b5f9b15$exports(key) ? key : key + "";
};


var $8157edd438c44d90$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $8157edd438c44d90$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $8157edd438c44d90$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $8157edd438c44d90$var$ENUMERABLE = "enumerable";
var $8157edd438c44d90$var$CONFIGURABLE = "configurable";
var $8157edd438c44d90$var$WRITABLE = "writable";
$8157edd438c44d90$export$2d1720544b23b823 = $c483fe5296753c65$exports ? $bd33f65bd298931a$exports ? function defineProperty(O, P, Attributes) {
    $c8b2cd917e169a50$exports(O);
    P = $cb97a67f070a4d38$exports(P);
    $c8b2cd917e169a50$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $8157edd438c44d90$var$WRITABLE in Attributes && !Attributes[$8157edd438c44d90$var$WRITABLE]) {
        var current = $8157edd438c44d90$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$8157edd438c44d90$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $8157edd438c44d90$var$CONFIGURABLE in Attributes ? Attributes[$8157edd438c44d90$var$CONFIGURABLE] : current[$8157edd438c44d90$var$CONFIGURABLE],
                enumerable: $8157edd438c44d90$var$ENUMERABLE in Attributes ? Attributes[$8157edd438c44d90$var$ENUMERABLE] : current[$8157edd438c44d90$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $8157edd438c44d90$var$$defineProperty(O, P, Attributes);
} : $8157edd438c44d90$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $c8b2cd917e169a50$exports(O);
    P = $cb97a67f070a4d38$exports(P);
    $c8b2cd917e169a50$exports(Attributes);
    if ($9c8c33df5aa2532d$exports) try {
        return $8157edd438c44d90$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $8157edd438c44d90$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $e5d398de47196760$exports = {};
$e5d398de47196760$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$3665666f26b5c099$exports = $c483fe5296753c65$exports ? function(object, key, value) {
    return $8157edd438c44d90$export$2d1720544b23b823(object, key, $e5d398de47196760$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $bca700e8ed862194$exports = {};


var $bca700e8ed862194$var$keys = $f2da5657fee08c8f$exports("keys");
$bca700e8ed862194$exports = function(key) {
    return $bca700e8ed862194$var$keys[key] || ($bca700e8ed862194$var$keys[key] = $542696d0e20d8e81$exports(key));
};


var $dcb9c62515ce4651$exports = {};
$dcb9c62515ce4651$exports = {};


var $f689abe66c9adff6$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $f689abe66c9adff6$var$TypeError = $77860603706a0f77$exports.TypeError;
var $f689abe66c9adff6$var$WeakMap = $77860603706a0f77$exports.WeakMap;
var $f689abe66c9adff6$var$set, $f689abe66c9adff6$var$get, $f689abe66c9adff6$var$has;
var $f689abe66c9adff6$var$enforce = function(it) {
    return $f689abe66c9adff6$var$has(it) ? $f689abe66c9adff6$var$get(it) : $f689abe66c9adff6$var$set(it, {});
};
var $f689abe66c9adff6$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$9adfe215028fa96a$exports(it) || (state = $f689abe66c9adff6$var$get(it)).type !== TYPE) throw $f689abe66c9adff6$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($2ef2f4d9c8c262ae$exports || $370f98ac39927661$exports.state) {
    var $f689abe66c9adff6$var$store = $370f98ac39927661$exports.state || ($370f98ac39927661$exports.state = new $f689abe66c9adff6$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $f689abe66c9adff6$var$store.get = $f689abe66c9adff6$var$store.get;
    $f689abe66c9adff6$var$store.has = $f689abe66c9adff6$var$store.has;
    $f689abe66c9adff6$var$store.set = $f689abe66c9adff6$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $f689abe66c9adff6$var$set = function(it, metadata) {
        if ($f689abe66c9adff6$var$store.has(it)) throw $f689abe66c9adff6$var$TypeError($f689abe66c9adff6$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f689abe66c9adff6$var$store.set(it, metadata);
        return metadata;
    };
    $f689abe66c9adff6$var$get = function(it) {
        return $f689abe66c9adff6$var$store.get(it) || {};
    };
    $f689abe66c9adff6$var$has = function(it) {
        return $f689abe66c9adff6$var$store.has(it);
    };
} else {
    var $f689abe66c9adff6$var$STATE = $bca700e8ed862194$exports("state");
    $dcb9c62515ce4651$exports[$f689abe66c9adff6$var$STATE] = true;
    $f689abe66c9adff6$var$set = function(it, metadata) {
        if ($84d6a9b73b839b2c$exports(it, $f689abe66c9adff6$var$STATE)) throw $f689abe66c9adff6$var$TypeError($f689abe66c9adff6$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3665666f26b5c099$exports(it, $f689abe66c9adff6$var$STATE, metadata);
        return metadata;
    };
    $f689abe66c9adff6$var$get = function(it) {
        return $84d6a9b73b839b2c$exports(it, $f689abe66c9adff6$var$STATE) ? it[$f689abe66c9adff6$var$STATE] : {};
    };
    $f689abe66c9adff6$var$has = function(it) {
        return $84d6a9b73b839b2c$exports(it, $f689abe66c9adff6$var$STATE);
    };
}
$f689abe66c9adff6$exports = {
    set: $f689abe66c9adff6$var$set,
    get: $f689abe66c9adff6$var$get,
    has: $f689abe66c9adff6$var$has,
    enforce: $f689abe66c9adff6$var$enforce,
    getterFor: $f689abe66c9adff6$var$getterFor
};



var $9ed9042111b4a31b$require$defineProperty = $8157edd438c44d90$export$2d1720544b23b823;
var $4effe313c6b2b628$exports = {};
"use strict";
var $2a59ac6722fddbbd$exports = {};
"use strict";

var $b6552ca1220b5acb$exports = {};

var $b6552ca1220b5acb$var$FunctionPrototype = Function.prototype;
var $b6552ca1220b5acb$var$apply = $b6552ca1220b5acb$var$FunctionPrototype.apply;
var $b6552ca1220b5acb$var$call = $b6552ca1220b5acb$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$b6552ca1220b5acb$exports = typeof Reflect == "object" && Reflect.apply || ($9a0ef7b863e9a57f$exports ? $b6552ca1220b5acb$var$call.bind($b6552ca1220b5acb$var$apply) : function() {
    return $b6552ca1220b5acb$var$call.apply($b6552ca1220b5acb$var$apply, arguments);
});


var $bdda5814135702c3$exports = {};


$bdda5814135702c3$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($51cc73928c08e4ea$exports(fn) === "Function") return $d593813970ff8a3a$exports(fn);
};



// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $342077e76519b773$export$2d1720544b23b823;


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $fa32f91970f6cbb4$export$2d1720544b23b823;
"use strict";
var $fa32f91970f6cbb4$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $fa32f91970f6cbb4$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $fa32f91970f6cbb4$var$NASHORN_BUG = $fa32f91970f6cbb4$var$getOwnPropertyDescriptor && !$fa32f91970f6cbb4$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$fa32f91970f6cbb4$export$2d1720544b23b823 = $fa32f91970f6cbb4$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $fa32f91970f6cbb4$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $fa32f91970f6cbb4$var$$propertyIsEnumerable;







// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $342077e76519b773$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$342077e76519b773$export$2d1720544b23b823 = $c483fe5296753c65$exports ? $342077e76519b773$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $0567ab4d6055322a$exports(O);
    P = $cb97a67f070a4d38$exports(P);
    if ($9c8c33df5aa2532d$exports) try {
        return $342077e76519b773$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($84d6a9b73b839b2c$exports(O, P)) return $e5d398de47196760$exports(!$a118597fd6ab4fb8$exports($fa32f91970f6cbb4$export$2d1720544b23b823, O, P), O[P]);
};


var $2a59ac6722fddbbd$require$getOwnPropertyDescriptor = $342077e76519b773$export$2d1720544b23b823;
var $b5328f3061aac49b$exports = {};


var $b5328f3061aac49b$var$replacement = /#|\.prototype\./;
var $b5328f3061aac49b$var$isForced = function(feature, detection) {
    var value = $b5328f3061aac49b$var$data[$b5328f3061aac49b$var$normalize(feature)];
    return value == $b5328f3061aac49b$var$POLYFILL ? true : value == $b5328f3061aac49b$var$NATIVE ? false : $c781bf4f9f236cf5$exports(detection) ? $6c212d9340b89abe$exports(detection) : !!detection;
};
var $b5328f3061aac49b$var$normalize = $b5328f3061aac49b$var$isForced.normalize = function(string) {
    return String(string).replace($b5328f3061aac49b$var$replacement, ".").toLowerCase();
};
var $b5328f3061aac49b$var$data = $b5328f3061aac49b$var$isForced.data = {};
var $b5328f3061aac49b$var$NATIVE = $b5328f3061aac49b$var$isForced.NATIVE = "N";
var $b5328f3061aac49b$var$POLYFILL = $b5328f3061aac49b$var$isForced.POLYFILL = "P";
$b5328f3061aac49b$exports = $b5328f3061aac49b$var$isForced;



var $38ed8e71102cfd64$exports = {};



var $38ed8e71102cfd64$var$bind = $bdda5814135702c3$exports($bdda5814135702c3$exports.bind);
// optional / simple context binding
$38ed8e71102cfd64$exports = function(fn, that) {
    $812f71e6b829da81$exports(fn);
    return that === undefined ? fn : $9a0ef7b863e9a57f$exports ? $38ed8e71102cfd64$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};




var $2a59ac6722fddbbd$var$wrapConstructor = function(NativeConstructor) {
    var Wrapper = function(a, b, c) {
        if (this instanceof Wrapper) {
            switch(arguments.length){
                case 0:
                    return new NativeConstructor();
                case 1:
                    return new NativeConstructor(a);
                case 2:
                    return new NativeConstructor(a, b);
            }
            return new NativeConstructor(a, b, c);
        }
        return $b6552ca1220b5acb$exports(NativeConstructor, this, arguments);
    };
    Wrapper.prototype = NativeConstructor.prototype;
    return Wrapper;
};
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $2a59ac6722fddbbd$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var PROTO = options.proto;
    var nativeSource = GLOBAL ? $77860603706a0f77$exports : STATIC ? $77860603706a0f77$exports[TARGET] : ($77860603706a0f77$exports[TARGET] || {}).prototype;
    var target = GLOBAL ? $e46b5adc12f872b4$exports : $e46b5adc12f872b4$exports[TARGET] || $3665666f26b5c099$exports($e46b5adc12f872b4$exports, TARGET, {})[TARGET];
    var targetPrototype = target.prototype;
    var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
    var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
    for(key in source){
        FORCED = $b5328f3061aac49b$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contains in native
        USE_NATIVE = !FORCED && nativeSource && $84d6a9b73b839b2c$exports(nativeSource, key);
        targetProperty = target[key];
        if (USE_NATIVE) {
            if (options.dontCallGetSet) {
                descriptor = $2a59ac6722fddbbd$require$getOwnPropertyDescriptor(nativeSource, key);
                nativeProperty = descriptor && descriptor.value;
            } else nativeProperty = nativeSource[key];
        }
        // export native or implementation
        sourceProperty = USE_NATIVE && nativeProperty ? nativeProperty : source[key];
        if (USE_NATIVE && typeof targetProperty == typeof sourceProperty) continue;
        // bind methods to global for calling from export context
        if (options.bind && USE_NATIVE) resultProperty = $38ed8e71102cfd64$exports(sourceProperty, $77860603706a0f77$exports);
        else if (options.wrap && USE_NATIVE) resultProperty = $2a59ac6722fddbbd$var$wrapConstructor(sourceProperty);
        else if (PROTO && $c781bf4f9f236cf5$exports(sourceProperty)) resultProperty = $bdda5814135702c3$exports(sourceProperty);
        else resultProperty = sourceProperty;
        // add a flag to not completely full polyfills
        if (options.sham || sourceProperty && sourceProperty.sham || targetProperty && targetProperty.sham) $3665666f26b5c099$exports(resultProperty, "sham", true);
        $3665666f26b5c099$exports(target, key, resultProperty);
        if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + "Prototype";
            if (!$84d6a9b73b839b2c$exports($e46b5adc12f872b4$exports, VIRTUAL_PROTOTYPE)) $3665666f26b5c099$exports($e46b5adc12f872b4$exports, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            $3665666f26b5c099$exports($e46b5adc12f872b4$exports[VIRTUAL_PROTOTYPE], key, sourceProperty);
            // export real prototype methods
            if (options.real && targetPrototype && (FORCED || !targetPrototype[key])) $3665666f26b5c099$exports(targetPrototype, key, sourceProperty);
        }
    }
};




var $4a806c210182b969$exports = {};


var $4a806c210182b969$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $4a806c210182b969$var$getDescriptor = $c483fe5296753c65$exports && Object.getOwnPropertyDescriptor;
var $4a806c210182b969$var$EXISTS = $84d6a9b73b839b2c$exports($4a806c210182b969$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $4a806c210182b969$var$PROPER = $4a806c210182b969$var$EXISTS && (function something() {}).name === "something";
var $4a806c210182b969$var$CONFIGURABLE = $4a806c210182b969$var$EXISTS && (!$c483fe5296753c65$exports || $c483fe5296753c65$exports && $4a806c210182b969$var$getDescriptor($4a806c210182b969$var$FunctionPrototype, "name").configurable);
$4a806c210182b969$exports = {
    EXISTS: $4a806c210182b969$var$EXISTS,
    PROPER: $4a806c210182b969$var$PROPER,
    CONFIGURABLE: $4a806c210182b969$var$CONFIGURABLE
};



var $2010a9bbd0ea86a3$exports = {};
"use strict";
var $158be510d4fb3a68$exports = {};
"use strict";



var $cde22291d8af72b5$exports = {};
/* global ActiveXObject -- old IE, WSH */ 
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $72e416d85600a458$export$2d1720544b23b823;





var $fde371c10b28bd89$exports = {};
var $852bf994c7ef8896$exports = {};



var $bdbce756a98fd455$exports = {};

var $9fc2ee5fb010e316$exports = {};
var $b05c2bc53ce4e128$exports = {};
var $cd0e722599acd995$exports = {};
var $cd0e722599acd995$var$ceil = Math.ceil;
var $cd0e722599acd995$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$cd0e722599acd995$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $cd0e722599acd995$var$floor : $cd0e722599acd995$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b05c2bc53ce4e128$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $cd0e722599acd995$exports(number);
};


var $9fc2ee5fb010e316$var$max = Math.max;
var $9fc2ee5fb010e316$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$9fc2ee5fb010e316$exports = function(index, length) {
    var integer = $b05c2bc53ce4e128$exports(index);
    return integer < 0 ? $9fc2ee5fb010e316$var$max(integer + length, 0) : $9fc2ee5fb010e316$var$min(integer, length);
};


var $ba1394a007e0d41a$exports = {};
var $c98f00e73d07b1f9$exports = {};

var $c98f00e73d07b1f9$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$c98f00e73d07b1f9$exports = function(argument) {
    return argument > 0 ? $c98f00e73d07b1f9$var$min($b05c2bc53ce4e128$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$ba1394a007e0d41a$exports = function(obj) {
    return $c98f00e73d07b1f9$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $bdbce756a98fd455$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $0567ab4d6055322a$exports($this);
        var length = $ba1394a007e0d41a$exports(O);
        var index = $9fc2ee5fb010e316$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$bdbce756a98fd455$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $bdbce756a98fd455$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $bdbce756a98fd455$var$createMethod(false)
};


var $852bf994c7ef8896$require$indexOf = $bdbce756a98fd455$exports.indexOf;

var $852bf994c7ef8896$var$push = $d593813970ff8a3a$exports([].push);
$852bf994c7ef8896$exports = function(object, names) {
    var O = $0567ab4d6055322a$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$84d6a9b73b839b2c$exports($dcb9c62515ce4651$exports, key) && $84d6a9b73b839b2c$exports(O, key) && $852bf994c7ef8896$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($84d6a9b73b839b2c$exports(O, key = names[i++])) ~$852bf994c7ef8896$require$indexOf(result, key) || $852bf994c7ef8896$var$push(result, key);
    return result;
};


var $61e4bd7701eca6fc$exports = {};
// IE8- don't enum bug keys
$61e4bd7701eca6fc$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$fde371c10b28bd89$exports = Object.keys || function keys(O) {
    return $852bf994c7ef8896$exports(O, $61e4bd7701eca6fc$exports);
};


$72e416d85600a458$export$2d1720544b23b823 = $c483fe5296753c65$exports && !$bd33f65bd298931a$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $c8b2cd917e169a50$exports(O);
    var props = $0567ab4d6055322a$exports(Properties);
    var keys = $fde371c10b28bd89$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$8157edd438c44d90$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $6f9c6458302c5b6a$exports = {};

$6f9c6458302c5b6a$exports = $6cbbc5bb2c5db598$exports("document", "documentElement");




var $cde22291d8af72b5$var$GT = ">";
var $cde22291d8af72b5$var$LT = "<";
var $cde22291d8af72b5$var$PROTOTYPE = "prototype";
var $cde22291d8af72b5$var$SCRIPT = "script";
var $cde22291d8af72b5$var$IE_PROTO = $bca700e8ed862194$exports("IE_PROTO");
var $cde22291d8af72b5$var$EmptyConstructor = function() {};
var $cde22291d8af72b5$var$scriptTag = function(content) {
    return $cde22291d8af72b5$var$LT + $cde22291d8af72b5$var$SCRIPT + $cde22291d8af72b5$var$GT + content + $cde22291d8af72b5$var$LT + "/" + $cde22291d8af72b5$var$SCRIPT + $cde22291d8af72b5$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $cde22291d8af72b5$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($cde22291d8af72b5$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $cde22291d8af72b5$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $53f6444582dd9bdc$exports("iframe");
    var JS = "java" + $cde22291d8af72b5$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $6f9c6458302c5b6a$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($cde22291d8af72b5$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $cde22291d8af72b5$var$activeXDocument;
var $cde22291d8af72b5$var$NullProtoObject = function() {
    try {
        $cde22291d8af72b5$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $cde22291d8af72b5$var$NullProtoObject = typeof document != "undefined" ? document.domain && $cde22291d8af72b5$var$activeXDocument ? $cde22291d8af72b5$var$NullProtoObjectViaActiveX($cde22291d8af72b5$var$activeXDocument) // old IE
     : $cde22291d8af72b5$var$NullProtoObjectViaIFrame() : $cde22291d8af72b5$var$NullProtoObjectViaActiveX($cde22291d8af72b5$var$activeXDocument); // WSH
    var length = $61e4bd7701eca6fc$exports.length;
    while(length--)delete $cde22291d8af72b5$var$NullProtoObject[$cde22291d8af72b5$var$PROTOTYPE][$61e4bd7701eca6fc$exports[length]];
    return $cde22291d8af72b5$var$NullProtoObject();
};
$dcb9c62515ce4651$exports[$cde22291d8af72b5$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$cde22291d8af72b5$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $cde22291d8af72b5$var$EmptyConstructor[$cde22291d8af72b5$var$PROTOTYPE] = $c8b2cd917e169a50$exports(O);
        result = new $cde22291d8af72b5$var$EmptyConstructor();
        $cde22291d8af72b5$var$EmptyConstructor[$cde22291d8af72b5$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$cde22291d8af72b5$var$IE_PROTO] = O;
    } else result = $cde22291d8af72b5$var$NullProtoObject();
    return Properties === undefined ? result : $72e416d85600a458$export$2d1720544b23b823(result, Properties);
};


var $3caabba690017728$exports = {};




var $18c60e844b079c94$exports = {};

$18c60e844b079c94$exports = !$6c212d9340b89abe$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $3caabba690017728$var$IE_PROTO = $bca700e8ed862194$exports("IE_PROTO");
var $3caabba690017728$var$$Object = Object;
var $3caabba690017728$var$ObjectPrototype = $3caabba690017728$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$3caabba690017728$exports = $18c60e844b079c94$exports ? $3caabba690017728$var$$Object.getPrototypeOf : function(O) {
    var object = $85decdba26472647$exports(O);
    if ($84d6a9b73b839b2c$exports(object, $3caabba690017728$var$IE_PROTO)) return object[$3caabba690017728$var$IE_PROTO];
    var constructor = object.constructor;
    if ($c781bf4f9f236cf5$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $3caabba690017728$var$$Object ? $3caabba690017728$var$ObjectPrototype : null;
};


var $7ac897d47cbbe3a7$exports = {};

$7ac897d47cbbe3a7$exports = function(target, key, value, options) {
    if (options && options.enumerable) target[key] = value;
    else $3665666f26b5c099$exports(target, key, value);
    return target;
};




var $158be510d4fb3a68$var$ITERATOR = $6040a00f5bf4e463$exports("iterator");
var $158be510d4fb3a68$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $158be510d4fb3a68$var$IteratorPrototype, $158be510d4fb3a68$var$PrototypeOfArrayIteratorPrototype, $158be510d4fb3a68$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $158be510d4fb3a68$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $158be510d4fb3a68$var$arrayIterator)) $158be510d4fb3a68$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $158be510d4fb3a68$var$PrototypeOfArrayIteratorPrototype = $3caabba690017728$exports($3caabba690017728$exports($158be510d4fb3a68$var$arrayIterator));
        if ($158be510d4fb3a68$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $158be510d4fb3a68$var$IteratorPrototype = $158be510d4fb3a68$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $158be510d4fb3a68$var$NEW_ITERATOR_PROTOTYPE = !$9adfe215028fa96a$exports($158be510d4fb3a68$var$IteratorPrototype) || $6c212d9340b89abe$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $158be510d4fb3a68$var$IteratorPrototype[$158be510d4fb3a68$var$ITERATOR].call(test) !== test;
});
if ($158be510d4fb3a68$var$NEW_ITERATOR_PROTOTYPE) $158be510d4fb3a68$var$IteratorPrototype = {};
else if ($28c67c425d8359f4$exports) $158be510d4fb3a68$var$IteratorPrototype = $cde22291d8af72b5$exports($158be510d4fb3a68$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$c781bf4f9f236cf5$exports($158be510d4fb3a68$var$IteratorPrototype[$158be510d4fb3a68$var$ITERATOR])) $7ac897d47cbbe3a7$exports($158be510d4fb3a68$var$IteratorPrototype, $158be510d4fb3a68$var$ITERATOR, function() {
    return this;
});
$158be510d4fb3a68$exports = {
    IteratorPrototype: $158be510d4fb3a68$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $158be510d4fb3a68$var$BUGGY_SAFARI_ITERATORS
};


var $2010a9bbd0ea86a3$require$IteratorPrototype = $158be510d4fb3a68$exports.IteratorPrototype;


var $9467770abfbb08d4$exports = {};
var $068685c74fe82cf8$exports = {};

var $068685c74fe82cf8$var$TO_STRING_TAG = $6040a00f5bf4e463$exports("toStringTag");
var $068685c74fe82cf8$var$test = {};
$068685c74fe82cf8$var$test[$068685c74fe82cf8$var$TO_STRING_TAG] = "z";
$068685c74fe82cf8$exports = String($068685c74fe82cf8$var$test) === "[object z]";



var $9467770abfbb08d4$require$defineProperty = $8157edd438c44d90$export$2d1720544b23b823;


var $54765e6245347e7f$exports = {};
"use strict";

var $cf236d429801739d$exports = {};




var $cf236d429801739d$var$TO_STRING_TAG = $6040a00f5bf4e463$exports("toStringTag");
var $cf236d429801739d$var$$Object = Object;
// ES3 wrong here
var $cf236d429801739d$var$CORRECT_ARGUMENTS = $51cc73928c08e4ea$exports(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $cf236d429801739d$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$cf236d429801739d$exports = $068685c74fe82cf8$exports ? $51cc73928c08e4ea$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $cf236d429801739d$var$tryGet(O = $cf236d429801739d$var$$Object(it), $cf236d429801739d$var$TO_STRING_TAG)) == "string" ? tag : $cf236d429801739d$var$CORRECT_ARGUMENTS ? $51cc73928c08e4ea$exports(O) : (result = $51cc73928c08e4ea$exports(O)) == "Object" && $c781bf4f9f236cf5$exports(O.callee) ? "Arguments" : result;
};


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$54765e6245347e7f$exports = $068685c74fe82cf8$exports ? ({}).toString : function toString() {
    return "[object " + $cf236d429801739d$exports(this) + "]";
};



var $9467770abfbb08d4$var$TO_STRING_TAG = $6040a00f5bf4e463$exports("toStringTag");
$9467770abfbb08d4$exports = function(it, TAG, STATIC, SET_METHOD) {
    if (it) {
        var target = STATIC ? it : it.prototype;
        if (!$84d6a9b73b839b2c$exports(target, $9467770abfbb08d4$var$TO_STRING_TAG)) $9467770abfbb08d4$require$defineProperty(target, $9467770abfbb08d4$var$TO_STRING_TAG, {
            configurable: true,
            value: TAG
        });
        if (SET_METHOD && !$068685c74fe82cf8$exports) $3665666f26b5c099$exports(target, "toString", $54765e6245347e7f$exports);
    }
};



var $2010a9bbd0ea86a3$var$returnThis = function() {
    return this;
};
$2010a9bbd0ea86a3$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $cde22291d8af72b5$exports($2010a9bbd0ea86a3$require$IteratorPrototype, {
        next: $e5d398de47196760$exports(+!ENUMERABLE_NEXT, next)
    });
    $9467770abfbb08d4$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $dbb8aae4e5a7f843$exports[TO_STRING_TAG] = $2010a9bbd0ea86a3$var$returnThis;
    return IteratorConstructor;
};



var $459f459be948f7d4$exports = {};
/* eslint-disable no-proto -- safe */ var $a0850b9120e0b66f$exports = {};


$a0850b9120e0b66f$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $d593813970ff8a3a$exports($812f71e6b829da81$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};



var $708659a24294eab9$exports = {};

var $708659a24294eab9$var$$String = String;
var $708659a24294eab9$var$$TypeError = TypeError;
$708659a24294eab9$exports = function(argument) {
    if (typeof argument == "object" || $c781bf4f9f236cf5$exports(argument)) return argument;
    throw $708659a24294eab9$var$$TypeError("Can't set " + $708659a24294eab9$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$459f459be948f7d4$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $a0850b9120e0b66f$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $c8b2cd917e169a50$exports(O);
        $708659a24294eab9$exports(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $4effe313c6b2b628$var$PROPER_FUNCTION_NAME = $4a806c210182b969$exports.PROPER;
var $4effe313c6b2b628$var$CONFIGURABLE_FUNCTION_NAME = $4a806c210182b969$exports.CONFIGURABLE;
var $4effe313c6b2b628$var$IteratorPrototype = $158be510d4fb3a68$exports.IteratorPrototype;
var $4effe313c6b2b628$var$BUGGY_SAFARI_ITERATORS = $158be510d4fb3a68$exports.BUGGY_SAFARI_ITERATORS;
var $4effe313c6b2b628$var$ITERATOR = $6040a00f5bf4e463$exports("iterator");
var $4effe313c6b2b628$var$KEYS = "keys";
var $4effe313c6b2b628$var$VALUES = "values";
var $4effe313c6b2b628$var$ENTRIES = "entries";
var $4effe313c6b2b628$var$returnThis = function() {
    return this;
};
$4effe313c6b2b628$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2010a9bbd0ea86a3$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$4effe313c6b2b628$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $4effe313c6b2b628$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $4effe313c6b2b628$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $4effe313c6b2b628$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$4effe313c6b2b628$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$4effe313c6b2b628$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $3caabba690017728$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$28c67c425d8359f4$exports && $3caabba690017728$exports(CurrentIteratorPrototype) !== $4effe313c6b2b628$var$IteratorPrototype) {
                if ($459f459be948f7d4$exports) $459f459be948f7d4$exports(CurrentIteratorPrototype, $4effe313c6b2b628$var$IteratorPrototype);
                else if (!$c781bf4f9f236cf5$exports(CurrentIteratorPrototype[$4effe313c6b2b628$var$ITERATOR])) $7ac897d47cbbe3a7$exports(CurrentIteratorPrototype, $4effe313c6b2b628$var$ITERATOR, $4effe313c6b2b628$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $9467770abfbb08d4$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($28c67c425d8359f4$exports) $dbb8aae4e5a7f843$exports[TO_STRING_TAG] = $4effe313c6b2b628$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($4effe313c6b2b628$var$PROPER_FUNCTION_NAME && DEFAULT == $4effe313c6b2b628$var$VALUES && nativeIterator && nativeIterator.name !== $4effe313c6b2b628$var$VALUES) {
        if (!$28c67c425d8359f4$exports && $4effe313c6b2b628$var$CONFIGURABLE_FUNCTION_NAME) $3665666f26b5c099$exports(IterablePrototype, "name", $4effe313c6b2b628$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $a118597fd6ab4fb8$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($4effe313c6b2b628$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($4effe313c6b2b628$var$KEYS),
            entries: getIterationMethod($4effe313c6b2b628$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($4effe313c6b2b628$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $7ac897d47cbbe3a7$exports(IterablePrototype, KEY, methods[KEY]);
        } else $2a59ac6722fddbbd$exports({
            target: NAME,
            proto: true,
            forced: $4effe313c6b2b628$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$28c67c425d8359f4$exports || FORCED) && IterablePrototype[$4effe313c6b2b628$var$ITERATOR] !== defaultIterator) $7ac897d47cbbe3a7$exports(IterablePrototype, $4effe313c6b2b628$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $dbb8aae4e5a7f843$exports[NAME] = defaultIterator;
    return methods;
};


var $e426263deeb9d20f$exports = {};
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$e426263deeb9d20f$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $9ed9042111b4a31b$var$ARRAY_ITERATOR = "Array Iterator";
var $9ed9042111b4a31b$var$setInternalState = $f689abe66c9adff6$exports.set;
var $9ed9042111b4a31b$var$getInternalState = $f689abe66c9adff6$exports.getterFor($9ed9042111b4a31b$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$9ed9042111b4a31b$exports = $4effe313c6b2b628$exports(Array, "Array", function(iterated, kind) {
    $9ed9042111b4a31b$var$setInternalState(this, {
        type: $9ed9042111b4a31b$var$ARRAY_ITERATOR,
        target: $0567ab4d6055322a$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $9ed9042111b4a31b$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $e426263deeb9d20f$exports(undefined, true);
    }
    if (kind == "keys") return $e426263deeb9d20f$exports(index, false);
    if (kind == "values") return $e426263deeb9d20f$exports(target[index], false);
    return $e426263deeb9d20f$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $9ed9042111b4a31b$var$values = $dbb8aae4e5a7f843$exports.Arguments = $dbb8aae4e5a7f843$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$4b57d2408d09472f$exports("keys");
$4b57d2408d09472f$exports("values");
$4b57d2408d09472f$exports("entries");
// V8 ~ Chrome 45- bug
if (!$28c67c425d8359f4$exports && $c483fe5296753c65$exports && $9ed9042111b4a31b$var$values.name !== "values") try {
    $9ed9042111b4a31b$require$defineProperty($9ed9042111b4a31b$var$values, "name", {
        value: "values"
    });
} catch (error) {}


// empty


// TODO: Remove this module from `core-js@4` since it's split to modules listed below
"use strict";


var $a0e7ca6a17d4522a$exports = {};

var $bcIJv = parcelRequire("bcIJv");

$a0e7ca6a17d4522a$exports = typeof $bcIJv != "undefined" && $51cc73928c08e4ea$exports($bcIJv) == "process";







var $cefb9e8628e865d3$exports = {};
"use strict";

var $a0899a4962f30b19$exports = {};

$a0899a4962f30b19$exports = function(target, name, descriptor) {
    return $8157edd438c44d90$export$2d1720544b23b823(target, name, descriptor);
};




var $cefb9e8628e865d3$var$SPECIES = $6040a00f5bf4e463$exports("species");
$cefb9e8628e865d3$exports = function(CONSTRUCTOR_NAME) {
    var Constructor = $6cbbc5bb2c5db598$exports(CONSTRUCTOR_NAME);
    if ($c483fe5296753c65$exports && Constructor && !Constructor[$cefb9e8628e865d3$var$SPECIES]) $a0899a4962f30b19$exports(Constructor, $cefb9e8628e865d3$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};





var $792ca80c813ea4a9$exports = {};

var $792ca80c813ea4a9$var$$TypeError = TypeError;
$792ca80c813ea4a9$exports = function(it, Prototype) {
    if ($5b6bbf0c049aa1bd$exports(Prototype, it)) return it;
    throw $792ca80c813ea4a9$var$$TypeError("Incorrect invocation");
};


var $85beb6dd381075c1$exports = {};

var $4bbb3b05f45b89e0$exports = {};
var $ba7985293dc31244$exports = {};





var $1a5a01255bf23ba0$exports = {};



var $1a5a01255bf23ba0$var$functionToString = $d593813970ff8a3a$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$c781bf4f9f236cf5$exports($370f98ac39927661$exports.inspectSource)) $370f98ac39927661$exports.inspectSource = function(it) {
    return $1a5a01255bf23ba0$var$functionToString(it);
};
$1a5a01255bf23ba0$exports = $370f98ac39927661$exports.inspectSource;


var $ba7985293dc31244$var$noop = function() {};
var $ba7985293dc31244$var$empty = [];
var $ba7985293dc31244$var$construct = $6cbbc5bb2c5db598$exports("Reflect", "construct");
var $ba7985293dc31244$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $ba7985293dc31244$var$exec = $d593813970ff8a3a$exports($ba7985293dc31244$var$constructorRegExp.exec);
var $ba7985293dc31244$var$INCORRECT_TO_STRING = !$ba7985293dc31244$var$constructorRegExp.exec($ba7985293dc31244$var$noop);
var $ba7985293dc31244$var$isConstructorModern = function isConstructor(argument) {
    if (!$c781bf4f9f236cf5$exports(argument)) return false;
    try {
        $ba7985293dc31244$var$construct($ba7985293dc31244$var$noop, $ba7985293dc31244$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $ba7985293dc31244$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$c781bf4f9f236cf5$exports(argument)) return false;
    switch($cf236d429801739d$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $ba7985293dc31244$var$INCORRECT_TO_STRING || !!$ba7985293dc31244$var$exec($ba7985293dc31244$var$constructorRegExp, $1a5a01255bf23ba0$exports(argument));
    } catch (error) {
        return true;
    }
};
$ba7985293dc31244$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$ba7985293dc31244$exports = !$ba7985293dc31244$var$construct || $6c212d9340b89abe$exports(function() {
    var called;
    return $ba7985293dc31244$var$isConstructorModern($ba7985293dc31244$var$isConstructorModern.call) || !$ba7985293dc31244$var$isConstructorModern(Object) || !$ba7985293dc31244$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $ba7985293dc31244$var$isConstructorLegacy : $ba7985293dc31244$var$isConstructorModern;



var $4bbb3b05f45b89e0$var$$TypeError = TypeError;
// `Assert: IsConstructor(argument) is true`
$4bbb3b05f45b89e0$exports = function(argument) {
    if ($ba7985293dc31244$exports(argument)) return argument;
    throw $4bbb3b05f45b89e0$var$$TypeError($a1455e29d850768c$exports(argument) + " is not a constructor");
};




var $85beb6dd381075c1$var$SPECIES = $6040a00f5bf4e463$exports("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
$85beb6dd381075c1$exports = function(O, defaultConstructor) {
    var C = $c8b2cd917e169a50$exports(O).constructor;
    var S;
    return C === undefined || $ed6eb49d28c3042d$exports(S = $c8b2cd917e169a50$exports(C)[$85beb6dd381075c1$var$SPECIES]) ? defaultConstructor : $4bbb3b05f45b89e0$exports(S);
};


var $6a25bf7a26d64b3c$exports = {};







var $7bc9df4bae3caa9d$exports = {};

$7bc9df4bae3caa9d$exports = $d593813970ff8a3a$exports([].slice);



var $a6049191af20cf48$exports = {};
var $a6049191af20cf48$var$$TypeError = TypeError;
$a6049191af20cf48$exports = function(passed, required) {
    if (passed < required) throw $a6049191af20cf48$var$$TypeError("Not enough arguments");
    return passed;
};


var $c90bb84950f7b9ae$exports = {};

// eslint-disable-next-line redos/no-vulnerable -- safe
$c90bb84950f7b9ae$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($5148efcd8dba02f5$exports);



var $6a25bf7a26d64b3c$var$set = $77860603706a0f77$exports.setImmediate;
var $6a25bf7a26d64b3c$var$clear = $77860603706a0f77$exports.clearImmediate;
var $6a25bf7a26d64b3c$var$process = $77860603706a0f77$exports.process;
var $6a25bf7a26d64b3c$var$Dispatch = $77860603706a0f77$exports.Dispatch;
var $6a25bf7a26d64b3c$var$Function = $77860603706a0f77$exports.Function;
var $6a25bf7a26d64b3c$var$MessageChannel = $77860603706a0f77$exports.MessageChannel;
var $6a25bf7a26d64b3c$var$String = $77860603706a0f77$exports.String;
var $6a25bf7a26d64b3c$var$counter = 0;
var $6a25bf7a26d64b3c$var$queue = {};
var $6a25bf7a26d64b3c$var$ONREADYSTATECHANGE = "onreadystatechange";
var $6a25bf7a26d64b3c$var$$location, $6a25bf7a26d64b3c$var$defer, $6a25bf7a26d64b3c$var$channel, $6a25bf7a26d64b3c$var$port;
$6c212d9340b89abe$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $6a25bf7a26d64b3c$var$$location = $77860603706a0f77$exports.location;
});
var $6a25bf7a26d64b3c$var$run = function(id) {
    if ($84d6a9b73b839b2c$exports($6a25bf7a26d64b3c$var$queue, id)) {
        var fn = $6a25bf7a26d64b3c$var$queue[id];
        delete $6a25bf7a26d64b3c$var$queue[id];
        fn();
    }
};
var $6a25bf7a26d64b3c$var$runner = function(id) {
    return function() {
        $6a25bf7a26d64b3c$var$run(id);
    };
};
var $6a25bf7a26d64b3c$var$eventListener = function(event) {
    $6a25bf7a26d64b3c$var$run(event.data);
};
var $6a25bf7a26d64b3c$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $77860603706a0f77$exports.postMessage($6a25bf7a26d64b3c$var$String(id), $6a25bf7a26d64b3c$var$$location.protocol + "//" + $6a25bf7a26d64b3c$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$6a25bf7a26d64b3c$var$set || !$6a25bf7a26d64b3c$var$clear) {
    $6a25bf7a26d64b3c$var$set = function setImmediate(handler) {
        $a6049191af20cf48$exports(arguments.length, 1);
        var fn = $c781bf4f9f236cf5$exports(handler) ? handler : $6a25bf7a26d64b3c$var$Function(handler);
        var args = $7bc9df4bae3caa9d$exports(arguments, 1);
        $6a25bf7a26d64b3c$var$queue[++$6a25bf7a26d64b3c$var$counter] = function() {
            $b6552ca1220b5acb$exports(fn, undefined, args);
        };
        $6a25bf7a26d64b3c$var$defer($6a25bf7a26d64b3c$var$counter);
        return $6a25bf7a26d64b3c$var$counter;
    };
    $6a25bf7a26d64b3c$var$clear = function clearImmediate(id) {
        delete $6a25bf7a26d64b3c$var$queue[id];
    };
    // Node.js 0.8-
    if ($a0e7ca6a17d4522a$exports) $6a25bf7a26d64b3c$var$defer = function(id) {
        $6a25bf7a26d64b3c$var$process.nextTick($6a25bf7a26d64b3c$var$runner(id));
    };
    else if ($6a25bf7a26d64b3c$var$Dispatch && $6a25bf7a26d64b3c$var$Dispatch.now) $6a25bf7a26d64b3c$var$defer = function(id) {
        $6a25bf7a26d64b3c$var$Dispatch.now($6a25bf7a26d64b3c$var$runner(id));
    };
    else if ($6a25bf7a26d64b3c$var$MessageChannel && !$c90bb84950f7b9ae$exports) {
        $6a25bf7a26d64b3c$var$channel = new $6a25bf7a26d64b3c$var$MessageChannel();
        $6a25bf7a26d64b3c$var$port = $6a25bf7a26d64b3c$var$channel.port2;
        $6a25bf7a26d64b3c$var$channel.port1.onmessage = $6a25bf7a26d64b3c$var$eventListener;
        $6a25bf7a26d64b3c$var$defer = $38ed8e71102cfd64$exports($6a25bf7a26d64b3c$var$port.postMessage, $6a25bf7a26d64b3c$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($77860603706a0f77$exports.addEventListener && $c781bf4f9f236cf5$exports($77860603706a0f77$exports.postMessage) && !$77860603706a0f77$exports.importScripts && $6a25bf7a26d64b3c$var$$location && $6a25bf7a26d64b3c$var$$location.protocol !== "file:" && !$6c212d9340b89abe$exports($6a25bf7a26d64b3c$var$globalPostMessageDefer)) {
        $6a25bf7a26d64b3c$var$defer = $6a25bf7a26d64b3c$var$globalPostMessageDefer;
        $77860603706a0f77$exports.addEventListener("message", $6a25bf7a26d64b3c$var$eventListener, false);
    // IE8-
    } else if ($6a25bf7a26d64b3c$var$ONREADYSTATECHANGE in $53f6444582dd9bdc$exports("script")) $6a25bf7a26d64b3c$var$defer = function(id) {
        $6f9c6458302c5b6a$exports.appendChild($53f6444582dd9bdc$exports("script"))[$6a25bf7a26d64b3c$var$ONREADYSTATECHANGE] = function() {
            $6f9c6458302c5b6a$exports.removeChild(this);
            $6a25bf7a26d64b3c$var$run(id);
        };
    };
    else $6a25bf7a26d64b3c$var$defer = function(id) {
        setTimeout($6a25bf7a26d64b3c$var$runner(id), 0);
    };
}
$6a25bf7a26d64b3c$exports = {
    set: $6a25bf7a26d64b3c$var$set,
    clear: $6a25bf7a26d64b3c$var$clear
};


var $3d51d78286b741c2$require$task = $6a25bf7a26d64b3c$exports.set;
var $4cbf3fe404fa8d7b$exports = {};



var $4cbf3fe404fa8d7b$require$getOwnPropertyDescriptor = $342077e76519b773$export$2d1720544b23b823;

var $4cbf3fe404fa8d7b$require$macrotask = $6a25bf7a26d64b3c$exports.set;
var $c3c1b42c8185232a$exports = {};
var $c3c1b42c8185232a$var$Queue = function() {
    this.head = null;
    this.tail = null;
};
$c3c1b42c8185232a$var$Queue.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        var tail = this.tail;
        if (tail) tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            var next = this.head = entry.next;
            if (next === null) this.tail = null;
            return entry.item;
        }
    }
};
$c3c1b42c8185232a$exports = $c3c1b42c8185232a$var$Queue;



var $68018ad16b6007c4$exports = {};

$68018ad16b6007c4$exports = /ipad|iphone|ipod/i.test($5148efcd8dba02f5$exports) && typeof Pebble != "undefined";


var $448e6eb0182f59c6$exports = {};

$448e6eb0182f59c6$exports = /web0s(?!.*chrome)/i.test($5148efcd8dba02f5$exports);



var $4cbf3fe404fa8d7b$var$MutationObserver = $77860603706a0f77$exports.MutationObserver || $77860603706a0f77$exports.WebKitMutationObserver;
var $4cbf3fe404fa8d7b$var$document = $77860603706a0f77$exports.document;
var $4cbf3fe404fa8d7b$var$process = $77860603706a0f77$exports.process;
var $4cbf3fe404fa8d7b$var$Promise = $77860603706a0f77$exports.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $4cbf3fe404fa8d7b$var$queueMicrotaskDescriptor = $4cbf3fe404fa8d7b$require$getOwnPropertyDescriptor($77860603706a0f77$exports, "queueMicrotask");
var $4cbf3fe404fa8d7b$var$microtask = $4cbf3fe404fa8d7b$var$queueMicrotaskDescriptor && $4cbf3fe404fa8d7b$var$queueMicrotaskDescriptor.value;
var $4cbf3fe404fa8d7b$var$notify, $4cbf3fe404fa8d7b$var$toggle, $4cbf3fe404fa8d7b$var$node, $4cbf3fe404fa8d7b$var$promise, $4cbf3fe404fa8d7b$var$then;
// modern engines have queueMicrotask method
if (!$4cbf3fe404fa8d7b$var$microtask) {
    var $4cbf3fe404fa8d7b$var$queue = new $c3c1b42c8185232a$exports();
    var $4cbf3fe404fa8d7b$var$flush = function() {
        var parent, fn;
        if ($a0e7ca6a17d4522a$exports && (parent = $4cbf3fe404fa8d7b$var$process.domain)) parent.exit();
        while(fn = $4cbf3fe404fa8d7b$var$queue.get())try {
            fn();
        } catch (error) {
            if ($4cbf3fe404fa8d7b$var$queue.head) $4cbf3fe404fa8d7b$var$notify();
            throw error;
        }
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$c90bb84950f7b9ae$exports && !$a0e7ca6a17d4522a$exports && !$448e6eb0182f59c6$exports && $4cbf3fe404fa8d7b$var$MutationObserver && $4cbf3fe404fa8d7b$var$document) {
        $4cbf3fe404fa8d7b$var$toggle = true;
        $4cbf3fe404fa8d7b$var$node = $4cbf3fe404fa8d7b$var$document.createTextNode("");
        new $4cbf3fe404fa8d7b$var$MutationObserver($4cbf3fe404fa8d7b$var$flush).observe($4cbf3fe404fa8d7b$var$node, {
            characterData: true
        });
        $4cbf3fe404fa8d7b$var$notify = function() {
            $4cbf3fe404fa8d7b$var$node.data = $4cbf3fe404fa8d7b$var$toggle = !$4cbf3fe404fa8d7b$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$68018ad16b6007c4$exports && $4cbf3fe404fa8d7b$var$Promise && $4cbf3fe404fa8d7b$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $4cbf3fe404fa8d7b$var$promise = $4cbf3fe404fa8d7b$var$Promise.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $4cbf3fe404fa8d7b$var$promise.constructor = $4cbf3fe404fa8d7b$var$Promise;
        $4cbf3fe404fa8d7b$var$then = $38ed8e71102cfd64$exports($4cbf3fe404fa8d7b$var$promise.then, $4cbf3fe404fa8d7b$var$promise);
        $4cbf3fe404fa8d7b$var$notify = function() {
            $4cbf3fe404fa8d7b$var$then($4cbf3fe404fa8d7b$var$flush);
        };
    // Node.js without promises
    } else if ($a0e7ca6a17d4522a$exports) $4cbf3fe404fa8d7b$var$notify = function() {
        $4cbf3fe404fa8d7b$var$process.nextTick($4cbf3fe404fa8d7b$var$flush);
    };
    else {
        // `webpack` dev server bug on IE global methods - use bind(fn, global)
        $4cbf3fe404fa8d7b$require$macrotask = $38ed8e71102cfd64$exports($4cbf3fe404fa8d7b$require$macrotask, $77860603706a0f77$exports);
        $4cbf3fe404fa8d7b$var$notify = function() {
            $4cbf3fe404fa8d7b$require$macrotask($4cbf3fe404fa8d7b$var$flush);
        };
    }
    $4cbf3fe404fa8d7b$var$microtask = function(fn) {
        if (!$4cbf3fe404fa8d7b$var$queue.head) $4cbf3fe404fa8d7b$var$notify();
        $4cbf3fe404fa8d7b$var$queue.add(fn);
    };
}
$4cbf3fe404fa8d7b$exports = $4cbf3fe404fa8d7b$var$microtask;


var $e622baccabafa6e3$exports = {};
$e622baccabafa6e3$exports = function(a, b) {
    try {
        // eslint-disable-next-line no-console -- safe
        arguments.length == 1 ? console.error(a) : console.error(a, b);
    } catch (error) {}
};


var $c90865f08c39280d$exports = {};
$c90865f08c39280d$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};




var $9e28074b08e3cf17$exports = {};

$9e28074b08e3cf17$exports = $77860603706a0f77$exports.Promise;


var $0617d84b33cf7b08$exports = {};






var $bc90e5b3b8d1aded$exports = {};
var $22a71e7f7444c5e2$exports = {};
/* global Deno -- Deno case */ $22a71e7f7444c5e2$exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";



$bc90e5b3b8d1aded$exports = !$22a71e7f7444c5e2$exports && !$a0e7ca6a17d4522a$exports && typeof window == "object" && typeof document == "object";





var $0617d84b33cf7b08$var$NativePromisePrototype = $9e28074b08e3cf17$exports && $9e28074b08e3cf17$exports.prototype;
var $0617d84b33cf7b08$var$SPECIES = $6040a00f5bf4e463$exports("species");
var $0617d84b33cf7b08$var$SUBCLASSING = false;
var $0617d84b33cf7b08$var$NATIVE_PROMISE_REJECTION_EVENT = $c781bf4f9f236cf5$exports($77860603706a0f77$exports.PromiseRejectionEvent);
var $0617d84b33cf7b08$var$FORCED_PROMISE_CONSTRUCTOR = $b5328f3061aac49b$exports("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $1a5a01255bf23ba0$exports($9e28074b08e3cf17$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($9e28074b08e3cf17$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $2d7e42ffbedb91ed$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($28c67c425d8359f4$exports && !($0617d84b33cf7b08$var$NativePromisePrototype["catch"] && $0617d84b33cf7b08$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$2d7e42ffbedb91ed$exports || $2d7e42ffbedb91ed$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $9e28074b08e3cf17$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$0617d84b33cf7b08$var$SPECIES] = FakePromise;
        $0617d84b33cf7b08$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$0617d84b33cf7b08$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($bc90e5b3b8d1aded$exports || $22a71e7f7444c5e2$exports) && !$0617d84b33cf7b08$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$0617d84b33cf7b08$exports = {
    CONSTRUCTOR: $0617d84b33cf7b08$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $0617d84b33cf7b08$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $0617d84b33cf7b08$var$SUBCLASSING
};


// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $870467d7ecfbcd6c$export$2d1720544b23b823;
"use strict";

var $870467d7ecfbcd6c$var$$TypeError = TypeError;
var $870467d7ecfbcd6c$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw $870467d7ecfbcd6c$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $812f71e6b829da81$exports(resolve);
    this.reject = $812f71e6b829da81$exports(reject);
};
$870467d7ecfbcd6c$export$2d1720544b23b823 = function(C) {
    return new $870467d7ecfbcd6c$var$PromiseCapability(C);
};


var $3d51d78286b741c2$var$PROMISE = "Promise";
var $3d51d78286b741c2$var$FORCED_PROMISE_CONSTRUCTOR = $0617d84b33cf7b08$exports.CONSTRUCTOR;
var $3d51d78286b741c2$var$NATIVE_PROMISE_REJECTION_EVENT = $0617d84b33cf7b08$exports.REJECTION_EVENT;
var $3d51d78286b741c2$var$NATIVE_PROMISE_SUBCLASSING = $0617d84b33cf7b08$exports.SUBCLASSING;
var $3d51d78286b741c2$var$getInternalPromiseState = $f689abe66c9adff6$exports.getterFor($3d51d78286b741c2$var$PROMISE);
var $3d51d78286b741c2$var$setInternalState = $f689abe66c9adff6$exports.set;
var $3d51d78286b741c2$var$NativePromisePrototype = $9e28074b08e3cf17$exports && $9e28074b08e3cf17$exports.prototype;
var $3d51d78286b741c2$var$PromiseConstructor = $9e28074b08e3cf17$exports;
var $3d51d78286b741c2$var$PromisePrototype = $3d51d78286b741c2$var$NativePromisePrototype;
var $3d51d78286b741c2$var$TypeError = $77860603706a0f77$exports.TypeError;
var $3d51d78286b741c2$var$document = $77860603706a0f77$exports.document;
var $3d51d78286b741c2$var$process = $77860603706a0f77$exports.process;
var $3d51d78286b741c2$var$newPromiseCapability = $870467d7ecfbcd6c$export$2d1720544b23b823;
var $3d51d78286b741c2$var$newGenericPromiseCapability = $3d51d78286b741c2$var$newPromiseCapability;
var $3d51d78286b741c2$var$DISPATCH_EVENT = !!($3d51d78286b741c2$var$document && $3d51d78286b741c2$var$document.createEvent && $77860603706a0f77$exports.dispatchEvent);
var $3d51d78286b741c2$var$UNHANDLED_REJECTION = "unhandledrejection";
var $3d51d78286b741c2$var$REJECTION_HANDLED = "rejectionhandled";
var $3d51d78286b741c2$var$PENDING = 0;
var $3d51d78286b741c2$var$FULFILLED = 1;
var $3d51d78286b741c2$var$REJECTED = 2;
var $3d51d78286b741c2$var$HANDLED = 1;
var $3d51d78286b741c2$var$UNHANDLED = 2;
var $3d51d78286b741c2$var$Internal, $3d51d78286b741c2$var$OwnPromiseCapability, $3d51d78286b741c2$var$PromiseWrapper, $3d51d78286b741c2$var$nativeThen;
// helpers
var $3d51d78286b741c2$var$isThenable = function(it) {
    var then;
    return $9adfe215028fa96a$exports(it) && $c781bf4f9f236cf5$exports(then = it.then) ? then : false;
};
var $3d51d78286b741c2$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $3d51d78286b741c2$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $3d51d78286b741c2$var$UNHANDLED) $3d51d78286b741c2$var$onHandleUnhandled(state);
                state.rejection = $3d51d78286b741c2$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($3d51d78286b741c2$var$TypeError("Promise-chain cycle"));
            else if (then = $3d51d78286b741c2$var$isThenable(result)) $a118597fd6ab4fb8$exports(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $3d51d78286b741c2$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $4cbf3fe404fa8d7b$exports(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$3d51d78286b741c2$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $3d51d78286b741c2$var$onUnhandled(state);
    });
};
var $3d51d78286b741c2$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($3d51d78286b741c2$var$DISPATCH_EVENT) {
        event = $3d51d78286b741c2$var$document.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $77860603706a0f77$exports.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$3d51d78286b741c2$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $77860603706a0f77$exports["on" + name])) handler(event);
    else if (name === $3d51d78286b741c2$var$UNHANDLED_REJECTION) $e622baccabafa6e3$exports("Unhandled promise rejection", reason);
};
var $3d51d78286b741c2$var$onUnhandled = function(state) {
    $a118597fd6ab4fb8$exports($3d51d78286b741c2$require$task, $77860603706a0f77$exports, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $3d51d78286b741c2$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $c90865f08c39280d$exports(function() {
                if ($a0e7ca6a17d4522a$exports) $3d51d78286b741c2$var$process.emit("unhandledRejection", value, promise);
                else $3d51d78286b741c2$var$dispatchEvent($3d51d78286b741c2$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $a0e7ca6a17d4522a$exports || $3d51d78286b741c2$var$isUnhandled(state) ? $3d51d78286b741c2$var$UNHANDLED : $3d51d78286b741c2$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $3d51d78286b741c2$var$isUnhandled = function(state) {
    return state.rejection !== $3d51d78286b741c2$var$HANDLED && !state.parent;
};
var $3d51d78286b741c2$var$onHandleUnhandled = function(state) {
    $a118597fd6ab4fb8$exports($3d51d78286b741c2$require$task, $77860603706a0f77$exports, function() {
        var promise = state.facade;
        if ($a0e7ca6a17d4522a$exports) $3d51d78286b741c2$var$process.emit("rejectionHandled", promise);
        else $3d51d78286b741c2$var$dispatchEvent($3d51d78286b741c2$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $3d51d78286b741c2$var$bind = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $3d51d78286b741c2$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $3d51d78286b741c2$var$REJECTED;
    $3d51d78286b741c2$var$notify(state, true);
};
var $3d51d78286b741c2$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $3d51d78286b741c2$var$TypeError("Promise can't be resolved itself");
        var then = $3d51d78286b741c2$var$isThenable(value);
        if (then) $4cbf3fe404fa8d7b$exports(function() {
            var wrapper = {
                done: false
            };
            try {
                $a118597fd6ab4fb8$exports(then, value, $3d51d78286b741c2$var$bind($3d51d78286b741c2$var$internalResolve, wrapper, state), $3d51d78286b741c2$var$bind($3d51d78286b741c2$var$internalReject, wrapper, state));
            } catch (error) {
                $3d51d78286b741c2$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $3d51d78286b741c2$var$FULFILLED;
            $3d51d78286b741c2$var$notify(state, false);
        }
    } catch (error) {
        $3d51d78286b741c2$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($3d51d78286b741c2$var$FORCED_PROMISE_CONSTRUCTOR) {
    // 25.4.3.1 Promise(executor)
    $3d51d78286b741c2$var$PromiseConstructor = function Promise(executor) {
        $792ca80c813ea4a9$exports(this, $3d51d78286b741c2$var$PromisePrototype);
        $812f71e6b829da81$exports(executor);
        $a118597fd6ab4fb8$exports($3d51d78286b741c2$var$Internal, this);
        var state = $3d51d78286b741c2$var$getInternalPromiseState(this);
        try {
            executor($3d51d78286b741c2$var$bind($3d51d78286b741c2$var$internalResolve, state), $3d51d78286b741c2$var$bind($3d51d78286b741c2$var$internalReject, state));
        } catch (error) {
            $3d51d78286b741c2$var$internalReject(state, error);
        }
    };
    $3d51d78286b741c2$var$PromisePrototype = $3d51d78286b741c2$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $3d51d78286b741c2$var$Internal = function Promise(executor) {
        $3d51d78286b741c2$var$setInternalState(this, {
            type: $3d51d78286b741c2$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $c3c1b42c8185232a$exports(),
            rejection: false,
            state: $3d51d78286b741c2$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $3d51d78286b741c2$var$Internal.prototype = $7ac897d47cbbe3a7$exports($3d51d78286b741c2$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $3d51d78286b741c2$var$getInternalPromiseState(this);
        var reaction = $3d51d78286b741c2$var$newPromiseCapability($85beb6dd381075c1$exports(this, $3d51d78286b741c2$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $c781bf4f9f236cf5$exports(onFulfilled) ? onFulfilled : true;
        reaction.fail = $c781bf4f9f236cf5$exports(onRejected) && onRejected;
        reaction.domain = $a0e7ca6a17d4522a$exports ? $3d51d78286b741c2$var$process.domain : undefined;
        if (state.state == $3d51d78286b741c2$var$PENDING) state.reactions.add(reaction);
        else $4cbf3fe404fa8d7b$exports(function() {
            $3d51d78286b741c2$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $3d51d78286b741c2$var$OwnPromiseCapability = function() {
        var promise = new $3d51d78286b741c2$var$Internal();
        var state = $3d51d78286b741c2$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $3d51d78286b741c2$var$bind($3d51d78286b741c2$var$internalResolve, state);
        this.reject = $3d51d78286b741c2$var$bind($3d51d78286b741c2$var$internalReject, state);
    };
    $870467d7ecfbcd6c$export$2d1720544b23b823 = $3d51d78286b741c2$var$newPromiseCapability = function(C) {
        return C === $3d51d78286b741c2$var$PromiseConstructor || C === $3d51d78286b741c2$var$PromiseWrapper ? new $3d51d78286b741c2$var$OwnPromiseCapability(C) : $3d51d78286b741c2$var$newGenericPromiseCapability(C);
    };
    if (!$28c67c425d8359f4$exports && $c781bf4f9f236cf5$exports($9e28074b08e3cf17$exports) && $3d51d78286b741c2$var$NativePromisePrototype !== Object.prototype) {
        $3d51d78286b741c2$var$nativeThen = $3d51d78286b741c2$var$NativePromisePrototype.then;
        if (!$3d51d78286b741c2$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $7ac897d47cbbe3a7$exports($3d51d78286b741c2$var$NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $3d51d78286b741c2$var$PromiseConstructor(function(resolve, reject) {
                $a118597fd6ab4fb8$exports($3d51d78286b741c2$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $3d51d78286b741c2$var$NativePromisePrototype.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($459f459be948f7d4$exports) $459f459be948f7d4$exports($3d51d78286b741c2$var$NativePromisePrototype, $3d51d78286b741c2$var$PromisePrototype);
    }
}
$2a59ac6722fddbbd$exports({
    global: true,
    constructor: true,
    wrap: true,
    forced: $3d51d78286b741c2$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    Promise: $3d51d78286b741c2$var$PromiseConstructor
});
$9467770abfbb08d4$exports($3d51d78286b741c2$var$PromiseConstructor, $3d51d78286b741c2$var$PROMISE, false, true);
$cefb9e8628e865d3$exports($3d51d78286b741c2$var$PROMISE);


"use strict";





var $aab58384eef3128c$exports = {};




var $7f5e6d1df7e6ec14$exports = {};


var $7f5e6d1df7e6ec14$var$ITERATOR = $6040a00f5bf4e463$exports("iterator");
var $7f5e6d1df7e6ec14$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$7f5e6d1df7e6ec14$exports = function(it) {
    return it !== undefined && ($dbb8aae4e5a7f843$exports.Array === it || $7f5e6d1df7e6ec14$var$ArrayPrototype[$7f5e6d1df7e6ec14$var$ITERATOR] === it);
};




var $eefde589cf991abe$exports = {};




var $20e102fb9a15297b$exports = {};





var $20e102fb9a15297b$var$ITERATOR = $6040a00f5bf4e463$exports("iterator");
$20e102fb9a15297b$exports = function(it) {
    if (!$ed6eb49d28c3042d$exports(it)) return $958bbb6dd5adebba$exports(it, $20e102fb9a15297b$var$ITERATOR) || $958bbb6dd5adebba$exports(it, "@@iterator") || $dbb8aae4e5a7f843$exports[$cf236d429801739d$exports(it)];
};


var $eefde589cf991abe$var$$TypeError = TypeError;
$eefde589cf991abe$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $20e102fb9a15297b$exports(argument) : usingIterator;
    if ($812f71e6b829da81$exports(iteratorMethod)) return $c8b2cd917e169a50$exports($a118597fd6ab4fb8$exports(iteratorMethod, argument));
    throw $eefde589cf991abe$var$$TypeError($a1455e29d850768c$exports(argument) + " is not iterable");
};



var $e5d60e9af5097407$exports = {};



$e5d60e9af5097407$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $c8b2cd917e169a50$exports(iterator);
    try {
        innerResult = $958bbb6dd5adebba$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $a118597fd6ab4fb8$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $c8b2cd917e169a50$exports(innerResult);
    return value;
};


var $aab58384eef3128c$var$$TypeError = TypeError;
var $aab58384eef3128c$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $aab58384eef3128c$var$ResultPrototype = $aab58384eef3128c$var$Result.prototype;
$aab58384eef3128c$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $38ed8e71102cfd64$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $e5d60e9af5097407$exports(iterator, "normal", condition);
        return new $aab58384eef3128c$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $c8b2cd917e169a50$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $20e102fb9a15297b$exports(iterable);
        if (!iterFn) throw $aab58384eef3128c$var$$TypeError($a1455e29d850768c$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($7f5e6d1df7e6ec14$exports(iterFn)) {
            for(index = 0, length = $ba1394a007e0d41a$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5b6bbf0c049aa1bd$exports($aab58384eef3128c$var$ResultPrototype, result)) return result;
            }
            return new $aab58384eef3128c$var$Result(false);
        }
        iterator = $eefde589cf991abe$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $a118597fd6ab4fb8$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $e5d60e9af5097407$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5b6bbf0c049aa1bd$exports($aab58384eef3128c$var$ResultPrototype, result)) return result;
    }
    return new $aab58384eef3128c$var$Result(false);
};


var $e5b6b6cbe3868dac$exports = {};

var $65a71d51bd62343b$exports = {};

var $65a71d51bd62343b$var$ITERATOR = $6040a00f5bf4e463$exports("iterator");
var $65a71d51bd62343b$var$SAFE_CLOSING = false;
try {
    var $65a71d51bd62343b$var$called = 0;
    var $65a71d51bd62343b$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$65a71d51bd62343b$var$called++
            };
        },
        "return": function() {
            $65a71d51bd62343b$var$SAFE_CLOSING = true;
        }
    };
    $65a71d51bd62343b$var$iteratorWithReturn[$65a71d51bd62343b$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($65a71d51bd62343b$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$65a71d51bd62343b$exports = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$65a71d51bd62343b$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$65a71d51bd62343b$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $e5b6b6cbe3868dac$require$FORCED_PROMISE_CONSTRUCTOR = $0617d84b33cf7b08$exports.CONSTRUCTOR;
$e5b6b6cbe3868dac$exports = $e5b6b6cbe3868dac$require$FORCED_PROMISE_CONSTRUCTOR || !$65a71d51bd62343b$exports(function(iterable) {
    $9e28074b08e3cf17$exports.all(iterable).then(undefined, function() {});
});


// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$2a59ac6722fddbbd$exports({
    target: "Promise",
    stat: true,
    forced: $e5b6b6cbe3868dac$exports
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $870467d7ecfbcd6c$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $c90865f08c39280d$exports(function() {
            var $promiseResolve = $812f71e6b829da81$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $aab58384eef3128c$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $a118597fd6ab4fb8$exports($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";



var $f0a920c169ff8db4$require$FORCED_PROMISE_CONSTRUCTOR = $0617d84b33cf7b08$exports.CONSTRUCTOR;




var $f0a920c169ff8db4$var$NativePromisePrototype = $9e28074b08e3cf17$exports && $9e28074b08e3cf17$exports.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$2a59ac6722fddbbd$exports({
    target: "Promise",
    proto: true,
    forced: $f0a920c169ff8db4$require$FORCED_PROMISE_CONSTRUCTOR,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!$28c67c425d8359f4$exports && $c781bf4f9f236cf5$exports($9e28074b08e3cf17$exports)) {
    var $f0a920c169ff8db4$var$method = $6cbbc5bb2c5db598$exports("Promise").prototype["catch"];
    if ($f0a920c169ff8db4$var$NativePromisePrototype["catch"] !== $f0a920c169ff8db4$var$method) $7ac897d47cbbe3a7$exports($f0a920c169ff8db4$var$NativePromisePrototype, "catch", $f0a920c169ff8db4$var$method, {
        unsafe: true
    });
}


"use strict";







// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$2a59ac6722fddbbd$exports({
    target: "Promise",
    stat: true,
    forced: $e5b6b6cbe3868dac$exports
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $870467d7ecfbcd6c$export$2d1720544b23b823(C);
        var reject = capability.reject;
        var result = $c90865f08c39280d$exports(function() {
            var $promiseResolve = $812f71e6b829da81$exports(C.resolve);
            $aab58384eef3128c$exports(iterable, function(promise) {
                $a118597fd6ab4fb8$exports($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";




var $b4df29a41e0d82f6$require$FORCED_PROMISE_CONSTRUCTOR = $0617d84b33cf7b08$exports.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$2a59ac6722fddbbd$exports({
    target: "Promise",
    stat: true,
    forced: $b4df29a41e0d82f6$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    reject: function reject(r) {
        var capability = $870467d7ecfbcd6c$export$2d1720544b23b823(this);
        $a118597fd6ab4fb8$exports(capability.reject, undefined, r);
        return capability.promise;
    }
});


"use strict";





var $4028064995c4639b$require$FORCED_PROMISE_CONSTRUCTOR = $0617d84b33cf7b08$exports.CONSTRUCTOR;
var $d3ed0d5119cc289d$exports = {};



$d3ed0d5119cc289d$exports = function(C, x) {
    $c8b2cd917e169a50$exports(C);
    if ($9adfe215028fa96a$exports(x) && x.constructor === C) return x;
    var promiseCapability = $870467d7ecfbcd6c$export$2d1720544b23b823(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};


var $4028064995c4639b$var$PromiseConstructorWrapper = $6cbbc5bb2c5db598$exports("Promise");
var $4028064995c4639b$var$CHECK_WRAPPER = $28c67c425d8359f4$exports && !$4028064995c4639b$require$FORCED_PROMISE_CONSTRUCTOR;
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$2a59ac6722fddbbd$exports({
    target: "Promise",
    stat: true,
    forced: $28c67c425d8359f4$exports || $4028064995c4639b$require$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $d3ed0d5119cc289d$exports($4028064995c4639b$var$CHECK_WRAPPER && this === $4028064995c4639b$var$PromiseConstructorWrapper ? $9e28074b08e3cf17$exports : this, x);
    }
});




"use strict";







// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$2a59ac6722fddbbd$exports({
    target: "Promise",
    stat: true,
    forced: $e5b6b6cbe3868dac$exports
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $870467d7ecfbcd6c$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $c90865f08c39280d$exports(function() {
            var promiseResolve = $812f71e6b829da81$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $aab58384eef3128c$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $a118597fd6ab4fb8$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});


"use strict";
var $ae0a3b2ab54bfb35$exports = {};


var $92685fa57c71186c$exports = {};

var $92685fa57c71186c$var$$String = String;
$92685fa57c71186c$exports = function(argument) {
    if ($cf236d429801739d$exports(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $92685fa57c71186c$var$$String(argument);
};



var $ae0a3b2ab54bfb35$var$charAt = $d593813970ff8a3a$exports("".charAt);
var $ae0a3b2ab54bfb35$var$charCodeAt = $d593813970ff8a3a$exports("".charCodeAt);
var $ae0a3b2ab54bfb35$var$stringSlice = $d593813970ff8a3a$exports("".slice);
var $ae0a3b2ab54bfb35$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $92685fa57c71186c$exports($7cdf0b67f6a079b0$exports($this));
        var position = $b05c2bc53ce4e128$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $ae0a3b2ab54bfb35$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $ae0a3b2ab54bfb35$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $ae0a3b2ab54bfb35$var$charAt(S, position) : first : CONVERT_TO_STRING ? $ae0a3b2ab54bfb35$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$ae0a3b2ab54bfb35$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $ae0a3b2ab54bfb35$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $ae0a3b2ab54bfb35$var$createMethod(true)
};


var $ef80aea24b603c04$require$charAt = $ae0a3b2ab54bfb35$exports.charAt;




var $ef80aea24b603c04$var$STRING_ITERATOR = "String Iterator";
var $ef80aea24b603c04$var$setInternalState = $f689abe66c9adff6$exports.set;
var $ef80aea24b603c04$var$getInternalState = $f689abe66c9adff6$exports.getterFor($ef80aea24b603c04$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$4effe313c6b2b628$exports(String, "String", function(iterated) {
    $ef80aea24b603c04$var$setInternalState(this, {
        type: $ef80aea24b603c04$var$STRING_ITERATOR,
        string: $92685fa57c71186c$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $ef80aea24b603c04$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $e426263deeb9d20f$exports(undefined, true);
    point = $ef80aea24b603c04$require$charAt(string, index);
    state.index += point.length;
    return $e426263deeb9d20f$exports(point, false);
});





var $c3efb8b60a10501d$var$Promise = $e46b5adc12f872b4$exports.Promise;
var $c3efb8b60a10501d$var$$allSettled = $c3efb8b60a10501d$var$Promise.allSettled;
$c3efb8b60a10501d$exports = function allSettled(iterable) {
    return $a118597fd6ab4fb8$exports($c3efb8b60a10501d$var$$allSettled, $c781bf4f9f236cf5$exports(this) ? this : $c3efb8b60a10501d$var$Promise, iterable);
};



var $334b8e75fe4ad42f$exports = {};
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$334b8e75fe4ad42f$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};







var $705daedea91992a4$var$TO_STRING_TAG = $6040a00f5bf4e463$exports("toStringTag");
for(var $705daedea91992a4$var$COLLECTION_NAME in $334b8e75fe4ad42f$exports){
    var $705daedea91992a4$var$Collection = $77860603706a0f77$exports[$705daedea91992a4$var$COLLECTION_NAME];
    var $705daedea91992a4$var$CollectionPrototype = $705daedea91992a4$var$Collection && $705daedea91992a4$var$Collection.prototype;
    if ($705daedea91992a4$var$CollectionPrototype && $cf236d429801739d$exports($705daedea91992a4$var$CollectionPrototype) !== $705daedea91992a4$var$TO_STRING_TAG) $3665666f26b5c099$exports($705daedea91992a4$var$CollectionPrototype, $705daedea91992a4$var$TO_STRING_TAG, $705daedea91992a4$var$COLLECTION_NAME);
    $dbb8aae4e5a7f843$exports[$705daedea91992a4$var$COLLECTION_NAME] = $dbb8aae4e5a7f843$exports.Array;
}


$9c2dbb7ea249fb70$exports = $c3efb8b60a10501d$exports;


var $27ef31bee71a266a$exports = {};
var $0868742811cda70d$exports = {};



var $61e9cb847ae037c3$exports = {};
"use strict";



$61e9cb847ae037c3$exports = function(object, key, value) {
    var propertyKey = $cb97a67f070a4d38$exports(key);
    if (propertyKey in object) $8157edd438c44d90$export$2d1720544b23b823(object, propertyKey, $e5d398de47196760$exports(0, value));
    else object[propertyKey] = value;
};


// `Object.fromEntries` method
// https://github.com/tc39/proposal-object-from-entries
$2a59ac6722fddbbd$exports({
    target: "Object",
    stat: true
}, {
    fromEntries: function fromEntries(iterable) {
        var obj = {};
        $aab58384eef3128c$exports(iterable, function(k, v) {
            $61e9cb847ae037c3$exports(obj, k, v);
        }, {
            AS_ENTRIES: true
        });
        return obj;
    }
});



$0868742811cda70d$exports = $e46b5adc12f872b4$exports.Object.fromEntries;



$27ef31bee71a266a$exports = $0868742811cda70d$exports;


if (!Promise.allSettled) Promise.allSettled = (0, (/*@__PURE__*/$parcel$interopDefault($9c2dbb7ea249fb70$exports)));
if (!Object.fromEntries) Object.fromEntries = (0, (/*@__PURE__*/$parcel$interopDefault($27ef31bee71a266a$exports)));


var $060c403ad4a78f54$exports = {};
"use strict";
function $060c403ad4a78f54$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($060c403ad4a78f54$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$060c403ad4a78f54$var$checkDCE();

$060c403ad4a78f54$exports = (parcelRequire("5y3eZ"));




var $g5BLJ = parcelRequire("g5BLJ");

var $g5BLJ = parcelRequire("g5BLJ");
var $fa91010a053d3dfb$exports = {};
"use strict";
var $33075bcfac4dd724$exports = {};
"use strict";
var $33075bcfac4dd724$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $33075bcfac4dd724$var$createStore = function createStore(createState) {
    return createState ? $33075bcfac4dd724$var$createStoreImpl(createState) : $33075bcfac4dd724$var$createStoreImpl;
};
var $33075bcfac4dd724$var$vanilla = function(createState) {
    return $33075bcfac4dd724$var$createStore(createState);
};
$33075bcfac4dd724$exports.createStore = $33075bcfac4dd724$var$createStore;
$33075bcfac4dd724$exports.default = $33075bcfac4dd724$var$vanilla;
$33075bcfac4dd724$exports = $33075bcfac4dd724$var$vanilla;
$33075bcfac4dd724$exports.createStore = $33075bcfac4dd724$var$createStore;
$33075bcfac4dd724$exports.default = $33075bcfac4dd724$exports;



var $g5BLJ = parcelRequire("g5BLJ");
var $2a28146ea47c9481$exports = {};
"use strict";

$2a28146ea47c9481$exports = (parcelRequire("1p7jo"));


var $fa91010a053d3dfb$var$useSyncExternalStoreWithSelector = $2a28146ea47c9481$exports.useSyncExternalStoreWithSelector;
function $fa91010a053d3dfb$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $fa91010a053d3dfb$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $g5BLJ.useDebugValue(slice);
    return slice;
}
var $fa91010a053d3dfb$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $33075bcfac4dd724$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $fa91010a053d3dfb$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $fa91010a053d3dfb$var$create = function create(createState) {
    return createState ? $fa91010a053d3dfb$var$createImpl(createState) : $fa91010a053d3dfb$var$createImpl;
};
var $fa91010a053d3dfb$var$react = function(createState) {
    return $fa91010a053d3dfb$var$create(createState);
};
$fa91010a053d3dfb$exports.create = $fa91010a053d3dfb$var$create;
$fa91010a053d3dfb$exports.default = $fa91010a053d3dfb$var$react;
$fa91010a053d3dfb$exports.useStore = $fa91010a053d3dfb$var$useStore;
Object.keys($33075bcfac4dd724$exports).forEach(function(k) {
    if (k !== "default" && !$fa91010a053d3dfb$exports.hasOwnProperty(k)) Object.defineProperty($fa91010a053d3dfb$exports, k, {
        enumerable: true,
        get: function() {
            return $33075bcfac4dd724$exports[k];
        }
    });
});
$fa91010a053d3dfb$exports = $fa91010a053d3dfb$var$react;
$fa91010a053d3dfb$exports.create = $fa91010a053d3dfb$var$create;
$fa91010a053d3dfb$exports.useStore = $fa91010a053d3dfb$var$useStore;
$fa91010a053d3dfb$exports.createStore = $33075bcfac4dd724$exports.createStore;
$fa91010a053d3dfb$exports.default = $fa91010a053d3dfb$exports;


var $440d0cabdceebdd8$exports = {};
"use strict";

var $g5BLJ = parcelRequire("g5BLJ");

function $440d0cabdceebdd8$var$_extends() {
    $440d0cabdceebdd8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $440d0cabdceebdd8$var$_extends.apply(this, arguments);
}
function $440d0cabdceebdd8$var$createContext() {
    var ZustandContext = $g5BLJ.createContext(undefined);
    var Provider = function Provider(_ref) {
        var createStore = _ref.createStore, children = _ref.children;
        var storeRef = $g5BLJ.useRef();
        if (!storeRef.current) storeRef.current = createStore();
        return $g5BLJ.createElement(ZustandContext.Provider, {
            value: storeRef.current
        }, children);
    };
    var useContextStore = function useContextStore(selector, equalityFn) {
        var store = $g5BLJ.useContext(ZustandContext);
        if (!store) throw new Error("Seems like you have not used zustand provider as an ancestor.");
        return $fa91010a053d3dfb$exports.useStore(store, selector, equalityFn);
    };
    var useStoreApi = function useStoreApi() {
        var store = $g5BLJ.useContext(ZustandContext);
        if (!store) throw new Error("Seems like you have not used zustand provider as an ancestor.");
        return $g5BLJ.useMemo(function() {
            return $440d0cabdceebdd8$var$_extends({}, store);
        }, [
            store
        ]);
    };
    return {
        Provider: Provider,
        useStore: useContextStore,
        useStoreApi: useStoreApi
    };
}
$440d0cabdceebdd8$exports = $440d0cabdceebdd8$var$createContext;


var $b2d0683bd76b8734$exports = {};
"use strict";
function $b2d0683bd76b8734$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b2d0683bd76b8734$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b2d0683bd76b8734$var$_arrayLikeToArray(o, minLen);
}
function $b2d0683bd76b8734$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b2d0683bd76b8734$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b2d0683bd76b8734$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b2d0683bd76b8734$var$shallow(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $b2d0683bd76b8734$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $b2d0683bd76b8734$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
var $b2d0683bd76b8734$var$shallow$1 = function(objA, objB) {
    return $b2d0683bd76b8734$var$shallow(objA, objB);
};
$b2d0683bd76b8734$exports.default = $b2d0683bd76b8734$var$shallow$1;
$b2d0683bd76b8734$exports.shallow = $b2d0683bd76b8734$var$shallow;
$b2d0683bd76b8734$exports = $b2d0683bd76b8734$var$shallow$1;
$b2d0683bd76b8734$exports.shallow = $b2d0683bd76b8734$var$shallow;
$b2d0683bd76b8734$exports.default = $b2d0683bd76b8734$exports;


const $f11c2b6d8f5b8d56$export$2aabb3606b6d664f = (stateCreator)=>{
    const useBaseStore = (0, (/*@__PURE__*/$parcel$interopDefault($fa91010a053d3dfb$exports)))(stateCreator);
    const useStore = (selector, deps)=>// eslint-disable-next-line react-hooks/exhaustive-deps
        useBaseStore((0, $g5BLJ.useCallback)(selector, deps), (0, $b2d0683bd76b8734$exports.shallow));
    return {
        useStore: useStore,
        useBaseStore: useBaseStore
    };
};
const $f11c2b6d8f5b8d56$export$c8d125448df6fe8e = ()=>{
    const { Provider: Provider , useStore: useBaseStore  } = (0, (/*@__PURE__*/$parcel$interopDefault($440d0cabdceebdd8$exports)))();
    const useStore = (selector, deps)=>// eslint-disable-next-line react-hooks/exhaustive-deps
        useBaseStore((0, $g5BLJ.useCallback)(selector, deps), (0, $b2d0683bd76b8734$exports.shallow));
    return {
        useStore: useStore,
        Provider: Provider
    };
};


const $620ff1ffde93974c$var$createSubSetAndGet = (dataKey, { getFull: getFull , setFull: setFull  })=>{
    const get = ()=>getFull()[dataKey];
    const set = (properties, replace = false)=>{
        // This any return type is safe-ish because of the typing of the set functions in our state files
        // and because it allows us type State as type instead of an interface so we don't need to extend Record<string,unknown>
        // Essentially it's more restrictive than it was, while still being imperfect
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setFull((state)=>{
            const updates = typeof properties === "function" ? properties(state[dataKey]) : properties;
            return {
                [dataKey]: {
                    ...replace ? {} : state[dataKey],
                    ...updates
                }
            };
        });
    };
    // Same as above
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setField = (key)=>(value)=>set({
                [key]: value
            });
    // We can't just make set field handle functions as well as direct values, because if the value we're trying
    // to set is actually a function, it will try to run it as the "set" function rather than directly set it
    const setFieldWithFunction = (key)=>(value)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
            set({
                [key]: value(get()[key])
            });
    const fetchData = {
        fetchJson: (...args)=>getFull().FetchData.fetchJson(...args),
        fetchResponse: (...args)=>getFull().FetchData.fetchResponse(...args),
        handleApiError: (...args)=>getFull().FetchData.handleApiError(...args),
        refreshPaperAccessToken: (...args)=>getFull().FetchData.refreshPaperAccessToken(...args)
    };
    return {
        set: set,
        get: get,
        setField: setField,
        setFieldWithFunction: setFieldWithFunction,
        ...fetchData
    };
};
const $620ff1ffde93974c$export$d7aa30e208e4dff3 = (key, defaultState, create)=>({ getFull: getFull , setFull: setFull  })=>({
            ...defaultState,
            ...create({
                getFull: getFull,
                setFull: setFull,
                ...$620ff1ffde93974c$var$createSubSetAndGet(key, {
                    getFull: getFull,
                    setFull: setFull
                })
            })
        });


/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $3f9a4df32f03e33e$var$DELETE = "delete";
// Constants describing the size of trie nodes.
var $3f9a4df32f03e33e$var$SHIFT = 5; // Resulted in best performance after ______?
var $3f9a4df32f03e33e$var$SIZE = 1 << $3f9a4df32f03e33e$var$SHIFT;
var $3f9a4df32f03e33e$var$MASK = $3f9a4df32f03e33e$var$SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var $3f9a4df32f03e33e$var$NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function $3f9a4df32f03e33e$var$MakeRef() {
    return {
        value: false
    };
}
function $3f9a4df32f03e33e$var$SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function $3f9a4df32f03e33e$var$OwnerID() {}
function $3f9a4df32f03e33e$var$ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate($3f9a4df32f03e33e$var$returnTrue);
    return iter.size;
}
function $3f9a4df32f03e33e$var$wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== "number") {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ("" + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? $3f9a4df32f03e33e$var$ensureSize(iter) + index : index;
}
function $3f9a4df32f03e33e$var$returnTrue() {
    return true;
}
function $3f9a4df32f03e33e$var$wholeSlice(begin, end, size) {
    return (begin === 0 && !$3f9a4df32f03e33e$var$isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function $3f9a4df32f03e33e$var$resolveBegin(begin, size) {
    return $3f9a4df32f03e33e$var$resolveIndex(begin, size, 0);
}
function $3f9a4df32f03e33e$var$resolveEnd(end, size) {
    return $3f9a4df32f03e33e$var$resolveIndex(end, size, size);
}
function $3f9a4df32f03e33e$var$resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : $3f9a4df32f03e33e$var$isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function $3f9a4df32f03e33e$var$isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var $3f9a4df32f03e33e$var$IS_COLLECTION_SYMBOL = "@@__IMMUTABLE_ITERABLE__@@";
function $3f9a4df32f03e33e$export$cea7aa84e978eba5(maybeCollection) {
    return Boolean(maybeCollection && maybeCollection[$3f9a4df32f03e33e$var$IS_COLLECTION_SYMBOL]);
}
var $3f9a4df32f03e33e$var$IS_KEYED_SYMBOL = "@@__IMMUTABLE_KEYED__@@";
function $3f9a4df32f03e33e$export$66d51e2080425364(maybeKeyed) {
    return Boolean(maybeKeyed && maybeKeyed[$3f9a4df32f03e33e$var$IS_KEYED_SYMBOL]);
}
var $3f9a4df32f03e33e$var$IS_INDEXED_SYMBOL = "@@__IMMUTABLE_INDEXED__@@";
function $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(maybeIndexed) {
    return Boolean(maybeIndexed && maybeIndexed[$3f9a4df32f03e33e$var$IS_INDEXED_SYMBOL]);
}
function $3f9a4df32f03e33e$export$9c3ce8f7b89c6d66(maybeAssociative) {
    return $3f9a4df32f03e33e$export$66d51e2080425364(maybeAssociative) || $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(maybeAssociative);
}
var $3f9a4df32f03e33e$export$fb8073518f34e6ec = function Collection(value) {
    return $3f9a4df32f03e33e$export$cea7aa84e978eba5(value) ? value : $3f9a4df32f03e33e$export$4802c350533dc67e(value);
};
var $3f9a4df32f03e33e$var$KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        return $3f9a4df32f03e33e$export$66d51e2080425364(value) ? value : $3f9a4df32f03e33e$var$KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}($3f9a4df32f03e33e$export$fb8073518f34e6ec);
var $3f9a4df32f03e33e$var$IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        return $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(value) ? value : $3f9a4df32f03e33e$var$IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}($3f9a4df32f03e33e$export$fb8073518f34e6ec);
var $3f9a4df32f03e33e$var$SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        return $3f9a4df32f03e33e$export$cea7aa84e978eba5(value) && !$3f9a4df32f03e33e$export$9c3ce8f7b89c6d66(value) ? value : $3f9a4df32f03e33e$var$SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}($3f9a4df32f03e33e$export$fb8073518f34e6ec);
$3f9a4df32f03e33e$export$fb8073518f34e6ec.Keyed = $3f9a4df32f03e33e$var$KeyedCollection;
$3f9a4df32f03e33e$export$fb8073518f34e6ec.Indexed = $3f9a4df32f03e33e$var$IndexedCollection;
$3f9a4df32f03e33e$export$fb8073518f34e6ec.Set = $3f9a4df32f03e33e$var$SetCollection;
var $3f9a4df32f03e33e$var$IS_SEQ_SYMBOL = "@@__IMMUTABLE_SEQ__@@";
function $3f9a4df32f03e33e$export$342ac1d101ffe14b(maybeSeq) {
    return Boolean(maybeSeq && maybeSeq[$3f9a4df32f03e33e$var$IS_SEQ_SYMBOL]);
}
var $3f9a4df32f03e33e$var$IS_RECORD_SYMBOL = "@@__IMMUTABLE_RECORD__@@";
function $3f9a4df32f03e33e$export$6ba840931da50680(maybeRecord) {
    return Boolean(maybeRecord && maybeRecord[$3f9a4df32f03e33e$var$IS_RECORD_SYMBOL]);
}
function $3f9a4df32f03e33e$export$f8647edfbac13b4f(maybeImmutable) {
    return $3f9a4df32f03e33e$export$cea7aa84e978eba5(maybeImmutable) || $3f9a4df32f03e33e$export$6ba840931da50680(maybeImmutable);
}
var $3f9a4df32f03e33e$var$IS_ORDERED_SYMBOL = "@@__IMMUTABLE_ORDERED__@@";
function $3f9a4df32f03e33e$export$e670b9b76442ef6c(maybeOrdered) {
    return Boolean(maybeOrdered && maybeOrdered[$3f9a4df32f03e33e$var$IS_ORDERED_SYMBOL]);
}
var $3f9a4df32f03e33e$var$ITERATE_KEYS = 0;
var $3f9a4df32f03e33e$var$ITERATE_VALUES = 1;
var $3f9a4df32f03e33e$var$ITERATE_ENTRIES = 2;
var $3f9a4df32f03e33e$var$REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
var $3f9a4df32f03e33e$var$FAUX_ITERATOR_SYMBOL = "@@iterator";
var $3f9a4df32f03e33e$var$ITERATOR_SYMBOL = $3f9a4df32f03e33e$var$REAL_ITERATOR_SYMBOL || $3f9a4df32f03e33e$var$FAUX_ITERATOR_SYMBOL;
var $3f9a4df32f03e33e$var$Iterator = function Iterator(next) {
    this.next = next;
};
$3f9a4df32f03e33e$var$Iterator.prototype.toString = function toString() {
    return "[Iterator]";
};
$3f9a4df32f03e33e$var$Iterator.KEYS = $3f9a4df32f03e33e$var$ITERATE_KEYS;
$3f9a4df32f03e33e$var$Iterator.VALUES = $3f9a4df32f03e33e$var$ITERATE_VALUES;
$3f9a4df32f03e33e$var$Iterator.ENTRIES = $3f9a4df32f03e33e$var$ITERATE_ENTRIES;
$3f9a4df32f03e33e$var$Iterator.prototype.inspect = $3f9a4df32f03e33e$var$Iterator.prototype.toSource = function() {
    return this.toString();
};
$3f9a4df32f03e33e$var$Iterator.prototype[$3f9a4df32f03e33e$var$ITERATOR_SYMBOL] = function() {
    return this;
};
function $3f9a4df32f03e33e$var$iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function $3f9a4df32f03e33e$var$iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function $3f9a4df32f03e33e$var$hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!$3f9a4df32f03e33e$var$getIteratorFn(maybeIterable);
}
function $3f9a4df32f03e33e$var$isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === "function";
}
function $3f9a4df32f03e33e$var$getIterator(iterable) {
    var iteratorFn = $3f9a4df32f03e33e$var$getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function $3f9a4df32f03e33e$var$getIteratorFn(iterable) {
    var iteratorFn = iterable && ($3f9a4df32f03e33e$var$REAL_ITERATOR_SYMBOL && iterable[$3f9a4df32f03e33e$var$REAL_ITERATOR_SYMBOL] || iterable[$3f9a4df32f03e33e$var$FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === "function") return iteratorFn;
}
function $3f9a4df32f03e33e$var$isEntriesIterable(maybeIterable) {
    var iteratorFn = $3f9a4df32f03e33e$var$getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function $3f9a4df32f03e33e$var$isKeysIterable(maybeIterable) {
    var iteratorFn = $3f9a4df32f03e33e$var$getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
var $3f9a4df32f03e33e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $3f9a4df32f03e33e$var$isArrayLike(value) {
    if (Array.isArray(value) || typeof value === "string") return true;
    return value && typeof value === "object" && Number.isInteger(value.length) && value.length >= 0 && (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    value.hasOwnProperty(value.length - 1));
}
var $3f9a4df32f03e33e$export$4802c350533dc67e = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptySequence() : $3f9a4df32f03e33e$export$f8647edfbac13b4f(value) ? value.toSeq() : $3f9a4df32f03e33e$var$seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new $3f9a4df32f03e33e$var$Iterator(function() {
                if (i === size) return $3f9a4df32f03e33e$var$iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return $3f9a4df32f03e33e$var$iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}($3f9a4df32f03e33e$export$fb8073518f34e6ec);
var $3f9a4df32f03e33e$var$KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptySequence().toKeyedSeq() : $3f9a4df32f03e33e$export$cea7aa84e978eba5(value) ? $3f9a4df32f03e33e$export$66d51e2080425364(value) ? value.toSeq() : value.fromEntrySeq() : $3f9a4df32f03e33e$export$6ba840931da50680(value) ? value.toSeq() : $3f9a4df32f03e33e$var$keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}($3f9a4df32f03e33e$export$4802c350533dc67e);
var $3f9a4df32f03e33e$var$IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptySequence() : $3f9a4df32f03e33e$export$cea7aa84e978eba5(value) ? $3f9a4df32f03e33e$export$66d51e2080425364(value) ? value.entrySeq() : value.toIndexedSeq() : $3f9a4df32f03e33e$export$6ba840931da50680(value) ? value.toSeq().entrySeq() : $3f9a4df32f03e33e$var$indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString("Seq [", "]");
    };
    return IndexedSeq;
}($3f9a4df32f03e33e$export$4802c350533dc67e);
var $3f9a4df32f03e33e$var$SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        return ($3f9a4df32f03e33e$export$cea7aa84e978eba5(value) && !$3f9a4df32f03e33e$export$9c3ce8f7b89c6d66(value) ? value : $3f9a4df32f03e33e$var$IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}($3f9a4df32f03e33e$export$4802c350533dc67e);
$3f9a4df32f03e33e$export$4802c350533dc67e.isSeq = $3f9a4df32f03e33e$export$342ac1d101ffe14b;
$3f9a4df32f03e33e$export$4802c350533dc67e.Keyed = $3f9a4df32f03e33e$var$KeyedSeq;
$3f9a4df32f03e33e$export$4802c350533dc67e.Set = $3f9a4df32f03e33e$var$SetSeq;
$3f9a4df32f03e33e$export$4802c350533dc67e.Indexed = $3f9a4df32f03e33e$var$IndexedSeq;
$3f9a4df32f03e33e$export$4802c350533dc67e.prototype[$3f9a4df32f03e33e$var$IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var $3f9a4df32f03e33e$var$ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[$3f9a4df32f03e33e$var$wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            if (i === size) return $3f9a4df32f03e33e$var$iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return $3f9a4df32f03e33e$var$iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}($3f9a4df32f03e33e$var$IndexedSeq);
var $3f9a4df32f03e33e$var$ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return $3f9a4df32f03e33e$var$hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            if (i === size) return $3f9a4df32f03e33e$var$iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return $3f9a4df32f03e33e$var$iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}($3f9a4df32f03e33e$var$KeyedSeq);
$3f9a4df32f03e33e$var$ObjectSeq.prototype[$3f9a4df32f03e33e$var$IS_ORDERED_SYMBOL] = true;
var $3f9a4df32f03e33e$var$CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = $3f9a4df32f03e33e$var$getIterator(collection);
        var iterations = 0;
        if ($3f9a4df32f03e33e$var$isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = $3f9a4df32f03e33e$var$getIterator(collection);
        if (!$3f9a4df32f03e33e$var$isIterator(iterator)) return new $3f9a4df32f03e33e$var$Iterator($3f9a4df32f03e33e$var$iteratorDone);
        var iterations = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var step = iterator.next();
            return step.done ? step : $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}($3f9a4df32f03e33e$var$IndexedSeq);
// # pragma Helper functions
var $3f9a4df32f03e33e$var$EMPTY_SEQ;
function $3f9a4df32f03e33e$var$emptySequence() {
    return $3f9a4df32f03e33e$var$EMPTY_SEQ || ($3f9a4df32f03e33e$var$EMPTY_SEQ = new $3f9a4df32f03e33e$var$ArraySeq([]));
}
function $3f9a4df32f03e33e$var$keyedSeqFromValue(value) {
    var seq = $3f9a4df32f03e33e$var$maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if (typeof value === "object") return new $3f9a4df32f03e33e$var$ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of [k, v] entries, or keyed object: " + value);
}
function $3f9a4df32f03e33e$var$indexedSeqFromValue(value) {
    var seq = $3f9a4df32f03e33e$var$maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError("Expected Array or collection object of values: " + value);
}
function $3f9a4df32f03e33e$var$seqFromValue(value) {
    var seq = $3f9a4df32f03e33e$var$maybeIndexedSeqFromValue(value);
    if (seq) return $3f9a4df32f03e33e$var$isEntriesIterable(value) ? seq.fromEntrySeq() : $3f9a4df32f03e33e$var$isKeysIterable(value) ? seq.toSetSeq() : seq;
    if (typeof value === "object") return new $3f9a4df32f03e33e$var$ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of values, or keyed object: " + value);
}
function $3f9a4df32f03e33e$var$maybeIndexedSeqFromValue(value) {
    return $3f9a4df32f03e33e$var$isArrayLike(value) ? new $3f9a4df32f03e33e$var$ArraySeq(value) : $3f9a4df32f03e33e$var$hasIterator(value) ? new $3f9a4df32f03e33e$var$CollectionSeq(value) : undefined;
}
var $3f9a4df32f03e33e$var$IS_MAP_SYMBOL = "@@__IMMUTABLE_MAP__@@";
function $3f9a4df32f03e33e$export$5c90113a285f2241(maybeMap) {
    return Boolean(maybeMap && maybeMap[$3f9a4df32f03e33e$var$IS_MAP_SYMBOL]);
}
function $3f9a4df32f03e33e$export$739bc167e02d45ee(maybeOrderedMap) {
    return $3f9a4df32f03e33e$export$5c90113a285f2241(maybeOrderedMap) && $3f9a4df32f03e33e$export$e670b9b76442ef6c(maybeOrderedMap);
}
function $3f9a4df32f03e33e$export$b24f7407c77e5bd(maybeValue) {
    return Boolean(maybeValue && typeof maybeValue.equals === "function" && typeof maybeValue.hashCode === "function");
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function $3f9a4df32f03e33e$export$226b3eccf92c9ed9(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!($3f9a4df32f03e33e$export$b24f7407c77e5bd(valueA) && $3f9a4df32f03e33e$export$b24f7407c77e5bd(valueB) && valueA.equals(valueB));
}
var $3f9a4df32f03e33e$var$imul = typeof Math.imul === "function" && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function $3f9a4df32f03e33e$var$smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var $3f9a4df32f03e33e$var$defaultValueOf = Object.prototype.valueOf;
function $3f9a4df32f03e33e$export$d6af199866bfb566(o) {
    if (o == null) return $3f9a4df32f03e33e$var$hashNullish(o);
    if (typeof o.hashCode === "function") // Drop any high bits from accidentally long hash codes.
    return $3f9a4df32f03e33e$var$smi(o.hashCode(o));
    var v = $3f9a4df32f03e33e$var$valueOf(o);
    if (v == null) return $3f9a4df32f03e33e$var$hashNullish(v);
    switch(typeof v){
        case "boolean":
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case "number":
            return $3f9a4df32f03e33e$var$hashNumber(v);
        case "string":
            return v.length > $3f9a4df32f03e33e$var$STRING_HASH_CACHE_MIN_STRLEN ? $3f9a4df32f03e33e$var$cachedHashString(v) : $3f9a4df32f03e33e$var$hashString(v);
        case "object":
        case "function":
            return $3f9a4df32f03e33e$var$hashJSObj(v);
        case "symbol":
            return $3f9a4df32f03e33e$var$hashSymbol(v);
        default:
            if (typeof v.toString === "function") return $3f9a4df32f03e33e$var$hashString(v.toString());
            throw new Error("Value type " + typeof v + " cannot be hashed.");
    }
}
function $3f9a4df32f03e33e$var$hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function $3f9a4df32f03e33e$var$hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return $3f9a4df32f03e33e$var$smi(hash);
}
function $3f9a4df32f03e33e$var$cachedHashString(string) {
    var hashed = $3f9a4df32f03e33e$var$stringHashCache[string];
    if (hashed === undefined) {
        hashed = $3f9a4df32f03e33e$var$hashString(string);
        if ($3f9a4df32f03e33e$var$STRING_HASH_CACHE_SIZE === $3f9a4df32f03e33e$var$STRING_HASH_CACHE_MAX_SIZE) {
            $3f9a4df32f03e33e$var$STRING_HASH_CACHE_SIZE = 0;
            $3f9a4df32f03e33e$var$stringHashCache = {};
        }
        $3f9a4df32f03e33e$var$STRING_HASH_CACHE_SIZE++;
        $3f9a4df32f03e33e$var$stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function $3f9a4df32f03e33e$var$hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return $3f9a4df32f03e33e$var$smi(hashed);
}
function $3f9a4df32f03e33e$var$hashSymbol(sym) {
    var hashed = $3f9a4df32f03e33e$var$symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = $3f9a4df32f03e33e$var$nextHash();
    $3f9a4df32f03e33e$var$symbolMap[sym] = hashed;
    return hashed;
}
function $3f9a4df32f03e33e$var$hashJSObj(obj) {
    var hashed;
    if ($3f9a4df32f03e33e$var$usingWeakMap) {
        hashed = $3f9a4df32f03e33e$var$weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[$3f9a4df32f03e33e$var$UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!$3f9a4df32f03e33e$var$canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[$3f9a4df32f03e33e$var$UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = $3f9a4df32f03e33e$var$getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = $3f9a4df32f03e33e$var$nextHash();
    if ($3f9a4df32f03e33e$var$usingWeakMap) $3f9a4df32f03e33e$var$weakMap.set(obj, hashed);
    else if ($3f9a4df32f03e33e$var$isExtensible !== undefined && $3f9a4df32f03e33e$var$isExtensible(obj) === false) throw new Error("Non-extensible objects are not allowed as keys.");
    else if ($3f9a4df32f03e33e$var$canDefineProperty) Object.defineProperty(obj, $3f9a4df32f03e33e$var$UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[$3f9a4df32f03e33e$var$UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[$3f9a4df32f03e33e$var$UID_HASH_KEY] = hashed;
    else throw new Error("Unable to set a non-enumerable property on object.");
    return hashed;
}
// Get references to ES5 object methods.
var $3f9a4df32f03e33e$var$isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var $3f9a4df32f03e33e$var$canDefineProperty = function() {
    try {
        Object.defineProperty({}, "@", {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function $3f9a4df32f03e33e$var$getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function $3f9a4df32f03e33e$var$valueOf(obj) {
    return obj.valueOf !== $3f9a4df32f03e33e$var$defaultValueOf && typeof obj.valueOf === "function" ? obj.valueOf(obj) : obj;
}
function $3f9a4df32f03e33e$var$nextHash() {
    var nextHash = ++$3f9a4df32f03e33e$var$_objHashUID;
    if ($3f9a4df32f03e33e$var$_objHashUID & 0x40000000) $3f9a4df32f03e33e$var$_objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
var $3f9a4df32f03e33e$var$usingWeakMap = typeof WeakMap === "function";
var $3f9a4df32f03e33e$var$weakMap;
if ($3f9a4df32f03e33e$var$usingWeakMap) $3f9a4df32f03e33e$var$weakMap = new WeakMap();
var $3f9a4df32f03e33e$var$symbolMap = Object.create(null);
var $3f9a4df32f03e33e$var$_objHashUID = 0;
var $3f9a4df32f03e33e$var$UID_HASH_KEY = "__immutablehash__";
if (typeof Symbol === "function") $3f9a4df32f03e33e$var$UID_HASH_KEY = Symbol($3f9a4df32f03e33e$var$UID_HASH_KEY);
var $3f9a4df32f03e33e$var$STRING_HASH_CACHE_MIN_STRLEN = 16;
var $3f9a4df32f03e33e$var$STRING_HASH_CACHE_MAX_SIZE = 255;
var $3f9a4df32f03e33e$var$STRING_HASH_CACHE_SIZE = 0;
var $3f9a4df32f03e33e$var$stringHashCache = {};
var $3f9a4df32f03e33e$var$ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = $3f9a4df32f03e33e$var$reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = $3f9a4df32f03e33e$var$mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}($3f9a4df32f03e33e$var$KeyedSeq);
$3f9a4df32f03e33e$var$ToKeyedSequence.prototype[$3f9a4df32f03e33e$var$IS_ORDERED_SYMBOL] = true;
var $3f9a4df32f03e33e$var$ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && $3f9a4df32f03e33e$var$ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator($3f9a4df32f03e33e$var$ITERATE_VALUES, reverse);
        var i = 0;
        reverse && $3f9a4df32f03e33e$var$ensureSize(this);
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var step = iterator.next();
            return step.done ? step : $3f9a4df32f03e33e$var$iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}($3f9a4df32f03e33e$var$IndexedSeq);
var $3f9a4df32f03e33e$var$ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator($3f9a4df32f03e33e$var$ITERATE_VALUES, reverse);
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var step = iterator.next();
            return step.done ? step : $3f9a4df32f03e33e$var$iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}($3f9a4df32f03e33e$var$SetSeq);
var $3f9a4df32f03e33e$var$FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                $3f9a4df32f03e33e$var$validateEntry(entry);
                var indexedCollection = $3f9a4df32f03e33e$export$cea7aa84e978eba5(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator($3f9a4df32f03e33e$var$ITERATE_VALUES, reverse);
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    $3f9a4df32f03e33e$var$validateEntry(entry);
                    var indexedCollection = $3f9a4df32f03e33e$export$cea7aa84e978eba5(entry);
                    return $3f9a4df32f03e33e$var$iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}($3f9a4df32f03e33e$var$KeyedSeq);
$3f9a4df32f03e33e$var$ToIndexedSequence.prototype.cacheResult = $3f9a4df32f03e33e$var$ToKeyedSequence.prototype.cacheResult = $3f9a4df32f03e33e$var$ToSetSequence.prototype.cacheResult = $3f9a4df32f03e33e$var$FromEntriesSequence.prototype.cacheResult = $3f9a4df32f03e33e$var$cacheResultThrough;
function $3f9a4df32f03e33e$var$flipFactory(collection) {
    var flipSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = $3f9a4df32f03e33e$var$cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === $3f9a4df32f03e33e$var$ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new $3f9a4df32f03e33e$var$Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === $3f9a4df32f03e33e$var$ITERATE_VALUES ? $3f9a4df32f03e33e$var$ITERATE_KEYS : $3f9a4df32f03e33e$var$ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function $3f9a4df32f03e33e$var$mapFactory(collection, mapper, context) {
    var mappedSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, $3f9a4df32f03e33e$var$NOT_SET);
        return v === $3f9a4df32f03e33e$var$NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator($3f9a4df32f03e33e$var$ITERATE_ENTRIES, reverse);
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return $3f9a4df32f03e33e$var$iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function $3f9a4df32f03e33e$var$reverseFactory(collection, useKeys) {
    var this$1$1 = this;
    var reversedSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = $3f9a4df32f03e33e$var$flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = $3f9a4df32f03e33e$var$cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && $3f9a4df32f03e33e$var$ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && $3f9a4df32f03e33e$var$ensureSize(collection);
        var iterator = collection.__iterator($3f9a4df32f03e33e$var$ITERATE_ENTRIES, !reverse);
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return $3f9a4df32f03e33e$var$iteratorValue(type, useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function $3f9a4df32f03e33e$var$filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, $3f9a4df32f03e33e$var$NOT_SET);
            return v !== $3f9a4df32f03e33e$var$NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, $3f9a4df32f03e33e$var$NOT_SET);
            return v !== $3f9a4df32f03e33e$var$NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator($3f9a4df32f03e33e$var$ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return $3f9a4df32f03e33e$var$iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function $3f9a4df32f03e33e$var$countByFactory(collection, grouper, context) {
    var groups = $3f9a4df32f03e33e$export$a5c7b93649eaf8f8().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function $3f9a4df32f03e33e$var$groupByFactory(collection, grouper, context) {
    var isKeyedIter = $3f9a4df32f03e33e$export$66d51e2080425364(collection);
    var groups = ($3f9a4df32f03e33e$export$e670b9b76442ef6c(collection) ? $3f9a4df32f03e33e$export$8e8eaa3741ef504c() : $3f9a4df32f03e33e$export$a5c7b93649eaf8f8()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = $3f9a4df32f03e33e$var$collectionClass(collection);
    return groups.map(function(arr) {
        return $3f9a4df32f03e33e$var$reify(collection, coerce(arr));
    }).asImmutable();
}
function $3f9a4df32f03e33e$var$partitionFactory(collection, predicate, context) {
    var isKeyedIter = $3f9a4df32f03e33e$export$66d51e2080425364(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = $3f9a4df32f03e33e$var$collectionClass(collection);
    return groups.map(function(arr) {
        return $3f9a4df32f03e33e$var$reify(collection, coerce(arr));
    });
}
function $3f9a4df32f03e33e$var$sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if ($3f9a4df32f03e33e$var$wholeSlice(begin, end, originalSize)) return collection;
    var resolvedBegin = $3f9a4df32f03e33e$var$resolveBegin(begin, originalSize);
    var resolvedEnd = $3f9a4df32f03e33e$var$resolveEnd(end, originalSize);
    // begin or end will be NaN if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return $3f9a4df32f03e33e$var$sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = $3f9a4df32f03e33e$var$makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && $3f9a4df32f03e33e$export$342ac1d101ffe14b(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = $3f9a4df32f03e33e$var$wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new $3f9a4df32f03e33e$var$Iterator($3f9a4df32f03e33e$var$iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return $3f9a4df32f03e33e$var$iteratorDone();
            var step = iterator.next();
            if (useKeys || type === $3f9a4df32f03e33e$var$ITERATE_VALUES || step.done) return step;
            if (type === $3f9a4df32f03e33e$var$ITERATE_KEYS) return $3f9a4df32f03e33e$var$iteratorValue(type, iterations - 1, undefined, step);
            return $3f9a4df32f03e33e$var$iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function $3f9a4df32f03e33e$var$takeWhileFactory(collection, predicate, context) {
    var takeSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator($3f9a4df32f03e33e$var$ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            if (!iterating) return $3f9a4df32f03e33e$var$iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return $3f9a4df32f03e33e$var$iteratorDone();
            }
            return type === $3f9a4df32f03e33e$var$ITERATE_ENTRIES ? step : $3f9a4df32f03e33e$var$iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function $3f9a4df32f03e33e$var$skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator($3f9a4df32f03e33e$var$ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === $3f9a4df32f03e33e$var$ITERATE_VALUES) return step;
                    if (type === $3f9a4df32f03e33e$var$ITERATE_KEYS) return $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, undefined, step);
                    return $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === $3f9a4df32f03e33e$var$ITERATE_ENTRIES ? step : $3f9a4df32f03e33e$var$iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function $3f9a4df32f03e33e$var$concatFactory(collection, values) {
    var isKeyedCollection = $3f9a4df32f03e33e$export$66d51e2080425364(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!$3f9a4df32f03e33e$export$cea7aa84e978eba5(v)) v = isKeyedCollection ? $3f9a4df32f03e33e$var$keyedSeqFromValue(v) : $3f9a4df32f03e33e$var$indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = $3f9a4df32f03e33e$var$KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && $3f9a4df32f03e33e$export$66d51e2080425364(singleton) || $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(collection) && $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(singleton)) return singleton;
    }
    var concatSeq = new $3f9a4df32f03e33e$var$ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!$3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function $3f9a4df32f03e33e$var$flattenFactory(collection, depth, useKeys) {
    var flatSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && $3f9a4df32f03e33e$export$cea7aa84e978eba5(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === $3f9a4df32f03e33e$var$ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && $3f9a4df32f03e33e$export$cea7aa84e978eba5(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, v, step);
            }
            return $3f9a4df32f03e33e$var$iteratorDone();
        });
    };
    return flatSequence;
}
function $3f9a4df32f03e33e$var$flatMapFactory(collection, mapper, context) {
    var coerce = $3f9a4df32f03e33e$var$collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function $3f9a4df32f03e33e$var$interposeFactory(collection, separator) {
    var interposedSequence = $3f9a4df32f03e33e$var$makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator($3f9a4df32f03e33e$var$ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, separator) : $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function $3f9a4df32f03e33e$var$sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = $3f9a4df32f03e33e$var$defaultComparator;
    var isKeyedCollection = $3f9a4df32f03e33e$export$66d51e2080425364(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? $3f9a4df32f03e33e$var$KeyedSeq(entries) : $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(collection) ? $3f9a4df32f03e33e$var$IndexedSeq(entries) : $3f9a4df32f03e33e$var$SetSeq(entries);
}
function $3f9a4df32f03e33e$var$maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = $3f9a4df32f03e33e$var$defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return $3f9a4df32f03e33e$var$maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return $3f9a4df32f03e33e$var$maxCompare(comparator, a, b) ? b : a;
    });
}
function $3f9a4df32f03e33e$var$maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function $3f9a4df32f03e33e$var$zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = $3f9a4df32f03e33e$var$makeSequence(keyIter);
    var sizes = new $3f9a4df32f03e33e$var$ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator($3f9a4df32f03e33e$var$ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = $3f9a4df32f03e33e$export$fb8073518f34e6ec(i), $3f9a4df32f03e33e$var$getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return $3f9a4df32f03e33e$var$iteratorDone();
            return $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function $3f9a4df32f03e33e$var$reify(iter, seq) {
    return iter === seq ? iter : $3f9a4df32f03e33e$export$342ac1d101ffe14b(iter) ? seq : iter.constructor(seq);
}
function $3f9a4df32f03e33e$var$validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
}
function $3f9a4df32f03e33e$var$collectionClass(collection) {
    return $3f9a4df32f03e33e$export$66d51e2080425364(collection) ? $3f9a4df32f03e33e$var$KeyedCollection : $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(collection) ? $3f9a4df32f03e33e$var$IndexedCollection : $3f9a4df32f03e33e$var$SetCollection;
}
function $3f9a4df32f03e33e$var$makeSequence(collection) {
    return Object.create(($3f9a4df32f03e33e$export$66d51e2080425364(collection) ? $3f9a4df32f03e33e$var$KeyedSeq : $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(collection) ? $3f9a4df32f03e33e$var$IndexedSeq : $3f9a4df32f03e33e$var$SetSeq).prototype);
}
function $3f9a4df32f03e33e$var$cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return $3f9a4df32f03e33e$export$4802c350533dc67e.prototype.cacheResult.call(this);
}
function $3f9a4df32f03e33e$var$defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
function $3f9a4df32f03e33e$var$arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function $3f9a4df32f03e33e$var$invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function $3f9a4df32f03e33e$var$assertNotInfinite(size) {
    $3f9a4df32f03e33e$var$invariant(size !== Infinity, "Cannot perform this action with an infinite size.");
}
function $3f9a4df32f03e33e$var$coerceKeyPath(keyPath) {
    if ($3f9a4df32f03e33e$var$isArrayLike(keyPath) && typeof keyPath !== "string") return keyPath;
    if ($3f9a4df32f03e33e$export$e670b9b76442ef6c(keyPath)) return keyPath.toArray();
    throw new TypeError("Invalid keyPath: expected Ordered Collection or Array: " + keyPath);
}
var $3f9a4df32f03e33e$var$toString = Object.prototype.toString;
function $3f9a4df32f03e33e$export$53b83ca8eaab0383(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || typeof value !== "object" || $3f9a4df32f03e33e$var$toString.call(value) !== "[object Object]") return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function $3f9a4df32f03e33e$var$isDataStructure(value) {
    return typeof value === "object" && ($3f9a4df32f03e33e$export$f8647edfbac13b4f(value) || Array.isArray(value) || $3f9a4df32f03e33e$export$53b83ca8eaab0383(value));
}
function $3f9a4df32f03e33e$var$quoteString(value) {
    try {
        return typeof value === "string" ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function $3f9a4df32f03e33e$export$a4f4bb6b1453fff5(collection, key) {
    return $3f9a4df32f03e33e$export$f8647edfbac13b4f(collection) ? collection.has(key) : $3f9a4df32f03e33e$var$isDataStructure(collection) && $3f9a4df32f03e33e$var$hasOwnProperty.call(collection, key);
}
function $3f9a4df32f03e33e$export$3988ae62b71be9a3(collection, key, notSetValue) {
    return $3f9a4df32f03e33e$export$f8647edfbac13b4f(collection) ? collection.get(key, notSetValue) : !$3f9a4df32f03e33e$export$a4f4bb6b1453fff5(collection, key) ? notSetValue : typeof collection.get === "function" ? collection.get(key) : collection[key];
}
function $3f9a4df32f03e33e$var$shallowCopy(from) {
    if (Array.isArray(from)) return $3f9a4df32f03e33e$var$arrCopy(from);
    var to = {};
    for(var key in from)if ($3f9a4df32f03e33e$var$hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function $3f9a4df32f03e33e$export$cd7f480d6b8286c3(collection, key) {
    if (!$3f9a4df32f03e33e$var$isDataStructure(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if ($3f9a4df32f03e33e$export$f8647edfbac13b4f(collection)) {
        if (!collection.remove) throw new TypeError("Cannot update immutable value without .remove() method: " + collection);
        return collection.remove(key);
    }
    if (!$3f9a4df32f03e33e$var$hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = $3f9a4df32f03e33e$var$shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function $3f9a4df32f03e33e$export$adaa4cf7ef1b65be(collection, key, value) {
    if (!$3f9a4df32f03e33e$var$isDataStructure(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if ($3f9a4df32f03e33e$export$f8647edfbac13b4f(collection)) {
        if (!collection.set) throw new TypeError("Cannot update immutable value without .set() method: " + collection);
        return collection.set(key, value);
    }
    if ($3f9a4df32f03e33e$var$hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = $3f9a4df32f03e33e$var$shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = $3f9a4df32f03e33e$var$updateInDeeply($3f9a4df32f03e33e$export$f8647edfbac13b4f(collection), collection, $3f9a4df32f03e33e$var$coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === $3f9a4df32f03e33e$var$NOT_SET ? notSetValue : updatedValue;
}
function $3f9a4df32f03e33e$var$updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === $3f9a4df32f03e33e$var$NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !$3f9a4df32f03e33e$var$isDataStructure(existing)) throw new TypeError("Cannot update within non-data-structure value in path [" + keyPath.slice(0, i).map($3f9a4df32f03e33e$var$quoteString) + "]: " + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? $3f9a4df32f03e33e$var$NOT_SET : $3f9a4df32f03e33e$export$3988ae62b71be9a3(existing, key, $3f9a4df32f03e33e$var$NOT_SET);
    var nextUpdated = $3f9a4df32f03e33e$var$updateInDeeply(nextExisting === $3f9a4df32f03e33e$var$NOT_SET ? inImmutable : $3f9a4df32f03e33e$export$f8647edfbac13b4f(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === $3f9a4df32f03e33e$var$NOT_SET ? $3f9a4df32f03e33e$export$cd7f480d6b8286c3(existing, key) : $3f9a4df32f03e33e$export$adaa4cf7ef1b65be(wasNotSet ? inImmutable ? $3f9a4df32f03e33e$var$emptyMap() : {} : existing, key, nextUpdated);
}
function $3f9a4df32f03e33e$export$e6bdf135a54e021b(collection, keyPath, value) {
    return $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1(collection, keyPath, $3f9a4df32f03e33e$var$NOT_SET, function() {
        return value;
    });
}
function $3f9a4df32f03e33e$var$setIn(keyPath, v) {
    return $3f9a4df32f03e33e$export$e6bdf135a54e021b(this, keyPath, v);
}
function $3f9a4df32f03e33e$export$b56fa1d8ac1a28ad(collection, keyPath) {
    return $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1(collection, keyPath, function() {
        return $3f9a4df32f03e33e$var$NOT_SET;
    });
}
function $3f9a4df32f03e33e$var$deleteIn(keyPath) {
    return $3f9a4df32f03e33e$export$b56fa1d8ac1a28ad(this, keyPath);
}
function $3f9a4df32f03e33e$export$722fbec263ad908a(collection, key, notSetValue, updater) {
    return $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1(collection, [
        key
    ], notSetValue, updater);
}
function $3f9a4df32f03e33e$var$update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : $3f9a4df32f03e33e$export$722fbec263ad908a(this, key, notSetValue, updater);
}
function $3f9a4df32f03e33e$var$updateIn(keyPath, notSetValue, updater) {
    return $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1(this, keyPath, notSetValue, updater);
}
function $3f9a4df32f03e33e$var$merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return $3f9a4df32f03e33e$var$mergeIntoKeyedWith(this, iters);
}
function $3f9a4df32f03e33e$var$mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== "function") throw new TypeError("Invalid merger function: " + merger);
    return $3f9a4df32f03e33e$var$mergeIntoKeyedWith(this, iters, merger);
}
function $3f9a4df32f03e33e$var$mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = $3f9a4df32f03e33e$var$KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            $3f9a4df32f03e33e$export$722fbec263ad908a(collection, key, $3f9a4df32f03e33e$var$NOT_SET, function(oldVal) {
                return oldVal === $3f9a4df32f03e33e$var$NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function $3f9a4df32f03e33e$export$4950aa0f605343fb(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return $3f9a4df32f03e33e$var$mergeWithSources(collection, sources);
}
function $3f9a4df32f03e33e$export$2ee76fde9ffe109d(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return $3f9a4df32f03e33e$var$mergeWithSources(collection, sources, merger);
}
function $3f9a4df32f03e33e$export$dd702b3c8240390c(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return $3f9a4df32f03e33e$var$mergeDeepWithSources(collection, sources);
}
function $3f9a4df32f03e33e$export$aa0aa29a716b1650(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return $3f9a4df32f03e33e$var$mergeDeepWithSources(collection, sources, merger);
}
function $3f9a4df32f03e33e$var$mergeDeepWithSources(collection, sources, merger) {
    return $3f9a4df32f03e33e$var$mergeWithSources(collection, sources, $3f9a4df32f03e33e$var$deepMergerWith(merger));
}
function $3f9a4df32f03e33e$var$mergeWithSources(collection, sources, merger) {
    if (!$3f9a4df32f03e33e$var$isDataStructure(collection)) throw new TypeError("Cannot merge into non-data-structure value: " + collection);
    if ($3f9a4df32f03e33e$export$f8647edfbac13b4f(collection)) return typeof merger === "function" && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? $3f9a4df32f03e33e$var$IndexedCollection : $3f9a4df32f03e33e$var$KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = $3f9a4df32f03e33e$var$shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = $3f9a4df32f03e33e$var$hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = $3f9a4df32f03e33e$var$shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function $3f9a4df32f03e33e$var$deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return $3f9a4df32f03e33e$var$isDataStructure(oldValue) && $3f9a4df32f03e33e$var$isDataStructure(newValue) && $3f9a4df32f03e33e$var$areMergeable(oldValue, newValue) ? $3f9a4df32f03e33e$var$mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function $3f9a4df32f03e33e$var$areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = $3f9a4df32f03e33e$export$4802c350533dc67e(oldDataStructure);
    var newSeq = $3f9a4df32f03e33e$export$4802c350533dc67e(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(oldSeq) === $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(newSeq) && $3f9a4df32f03e33e$export$66d51e2080425364(oldSeq) === $3f9a4df32f03e33e$export$66d51e2080425364(newSeq);
}
function $3f9a4df32f03e33e$var$mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return $3f9a4df32f03e33e$var$mergeDeepWithSources(this, iters);
}
function $3f9a4df32f03e33e$var$mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return $3f9a4df32f03e33e$var$mergeDeepWithSources(this, iters, merger);
}
function $3f9a4df32f03e33e$var$mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1(this, keyPath, $3f9a4df32f03e33e$var$emptyMap(), function(m) {
        return $3f9a4df32f03e33e$var$mergeWithSources(m, iters);
    });
}
function $3f9a4df32f03e33e$var$mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1(this, keyPath, $3f9a4df32f03e33e$var$emptyMap(), function(m) {
        return $3f9a4df32f03e33e$var$mergeDeepWithSources(m, iters);
    });
}
function $3f9a4df32f03e33e$var$withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function $3f9a4df32f03e33e$var$asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new $3f9a4df32f03e33e$var$OwnerID());
}
function $3f9a4df32f03e33e$var$asImmutable() {
    return this.__ensureOwner();
}
function $3f9a4df32f03e33e$var$wasAltered() {
    return this.__altered;
}
var $3f9a4df32f03e33e$export$a5c7b93649eaf8f8 = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptyMap() : $3f9a4df32f03e33e$export$5c90113a285f2241(value) && !$3f9a4df32f03e33e$export$e670b9b76442ef6c(value) ? value : $3f9a4df32f03e33e$var$emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            $3f9a4df32f03e33e$var$assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return $3f9a4df32f03e33e$var$emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString("Map {", "}");
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return $3f9a4df32f03e33e$var$updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return $3f9a4df32f03e33e$var$updateMap(this, k, $3f9a4df32f03e33e$var$NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = $3f9a4df32f03e33e$export$fb8073518f34e6ec(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $3f9a4df32f03e33e$var$emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return $3f9a4df32f03e33e$export$8e8eaa3741ef504c($3f9a4df32f03e33e$var$sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return $3f9a4df32f03e33e$export$8e8eaa3741ef504c($3f9a4df32f03e33e$var$sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new $3f9a4df32f03e33e$var$MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return $3f9a4df32f03e33e$var$emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return $3f9a4df32f03e33e$var$makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}($3f9a4df32f03e33e$var$KeyedCollection);
$3f9a4df32f03e33e$export$a5c7b93649eaf8f8.isMap = $3f9a4df32f03e33e$export$5c90113a285f2241;
var $3f9a4df32f03e33e$var$MapPrototype = $3f9a4df32f03e33e$export$a5c7b93649eaf8f8.prototype;
$3f9a4df32f03e33e$var$MapPrototype[$3f9a4df32f03e33e$var$IS_MAP_SYMBOL] = true;
$3f9a4df32f03e33e$var$MapPrototype[$3f9a4df32f03e33e$var$DELETE] = $3f9a4df32f03e33e$var$MapPrototype.remove;
$3f9a4df32f03e33e$var$MapPrototype.removeAll = $3f9a4df32f03e33e$var$MapPrototype.deleteAll;
$3f9a4df32f03e33e$var$MapPrototype.setIn = $3f9a4df32f03e33e$var$setIn;
$3f9a4df32f03e33e$var$MapPrototype.removeIn = $3f9a4df32f03e33e$var$MapPrototype.deleteIn = $3f9a4df32f03e33e$var$deleteIn;
$3f9a4df32f03e33e$var$MapPrototype.update = $3f9a4df32f03e33e$var$update;
$3f9a4df32f03e33e$var$MapPrototype.updateIn = $3f9a4df32f03e33e$var$updateIn;
$3f9a4df32f03e33e$var$MapPrototype.merge = $3f9a4df32f03e33e$var$MapPrototype.concat = $3f9a4df32f03e33e$var$merge$1;
$3f9a4df32f03e33e$var$MapPrototype.mergeWith = $3f9a4df32f03e33e$var$mergeWith$1;
$3f9a4df32f03e33e$var$MapPrototype.mergeDeep = $3f9a4df32f03e33e$var$mergeDeep;
$3f9a4df32f03e33e$var$MapPrototype.mergeDeepWith = $3f9a4df32f03e33e$var$mergeDeepWith;
$3f9a4df32f03e33e$var$MapPrototype.mergeIn = $3f9a4df32f03e33e$var$mergeIn;
$3f9a4df32f03e33e$var$MapPrototype.mergeDeepIn = $3f9a4df32f03e33e$var$mergeDeepIn;
$3f9a4df32f03e33e$var$MapPrototype.withMutations = $3f9a4df32f03e33e$var$withMutations;
$3f9a4df32f03e33e$var$MapPrototype.wasAltered = $3f9a4df32f03e33e$var$wasAltered;
$3f9a4df32f03e33e$var$MapPrototype.asImmutable = $3f9a4df32f03e33e$var$asImmutable;
$3f9a4df32f03e33e$var$MapPrototype["@@transducer/init"] = $3f9a4df32f03e33e$var$MapPrototype.asMutable = $3f9a4df32f03e33e$var$asMutable;
$3f9a4df32f03e33e$var$MapPrototype["@@transducer/step"] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
$3f9a4df32f03e33e$var$MapPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var $3f9a4df32f03e33e$var$ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
$3f9a4df32f03e33e$var$ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if ($3f9a4df32f03e33e$export$226b3eccf92c9ed9(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
$3f9a4df32f03e33e$var$ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === $3f9a4df32f03e33e$var$NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if ($3f9a4df32f03e33e$export$226b3eccf92c9ed9(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    $3f9a4df32f03e33e$var$SetRef(didAlter);
    (removed || !exists) && $3f9a4df32f03e33e$var$SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= $3f9a4df32f03e33e$var$MAX_ARRAY_MAP_SIZE) return $3f9a4df32f03e33e$var$createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : $3f9a4df32f03e33e$var$arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new $3f9a4df32f03e33e$var$ArrayMapNode(ownerID, newEntries);
};
var $3f9a4df32f03e33e$var$BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
$3f9a4df32f03e33e$var$BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = $3f9a4df32f03e33e$export$d6af199866bfb566(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & $3f9a4df32f03e33e$var$MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[$3f9a4df32f03e33e$var$popCount(bitmap & bit - 1)].get(shift + $3f9a4df32f03e33e$var$SHIFT, keyHash, key, notSetValue);
};
$3f9a4df32f03e33e$var$BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = $3f9a4df32f03e33e$export$d6af199866bfb566(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & $3f9a4df32f03e33e$var$MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === $3f9a4df32f03e33e$var$NOT_SET) return this;
    var idx = $3f9a4df32f03e33e$var$popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = $3f9a4df32f03e33e$var$updateNode(node, ownerID, shift + $3f9a4df32f03e33e$var$SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= $3f9a4df32f03e33e$var$MAX_BITMAP_INDEXED_SIZE) return $3f9a4df32f03e33e$var$expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && $3f9a4df32f03e33e$var$isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && $3f9a4df32f03e33e$var$isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? $3f9a4df32f03e33e$var$setAt(nodes, idx, newNode, isEditable) : $3f9a4df32f03e33e$var$spliceOut(nodes, idx, isEditable) : $3f9a4df32f03e33e$var$spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new $3f9a4df32f03e33e$var$BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var $3f9a4df32f03e33e$var$HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
$3f9a4df32f03e33e$var$HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = $3f9a4df32f03e33e$export$d6af199866bfb566(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & $3f9a4df32f03e33e$var$MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + $3f9a4df32f03e33e$var$SHIFT, keyHash, key, notSetValue) : notSetValue;
};
$3f9a4df32f03e33e$var$HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = $3f9a4df32f03e33e$export$d6af199866bfb566(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & $3f9a4df32f03e33e$var$MASK;
    var removed = value === $3f9a4df32f03e33e$var$NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = $3f9a4df32f03e33e$var$updateNode(node, ownerID, shift + $3f9a4df32f03e33e$var$SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < $3f9a4df32f03e33e$var$MIN_HASH_ARRAY_MAP_SIZE) return $3f9a4df32f03e33e$var$packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = $3f9a4df32f03e33e$var$setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new $3f9a4df32f03e33e$var$HashArrayMapNode(ownerID, newCount, newNodes);
};
var $3f9a4df32f03e33e$var$HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
$3f9a4df32f03e33e$var$HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if ($3f9a4df32f03e33e$export$226b3eccf92c9ed9(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
$3f9a4df32f03e33e$var$HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = $3f9a4df32f03e33e$export$d6af199866bfb566(key);
    var removed = value === $3f9a4df32f03e33e$var$NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        $3f9a4df32f03e33e$var$SetRef(didAlter);
        $3f9a4df32f03e33e$var$SetRef(didChangeSize);
        return $3f9a4df32f03e33e$var$mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if ($3f9a4df32f03e33e$export$226b3eccf92c9ed9(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    $3f9a4df32f03e33e$var$SetRef(didAlter);
    (removed || !exists) && $3f9a4df32f03e33e$var$SetRef(didChangeSize);
    if (removed && len === 2) return new $3f9a4df32f03e33e$var$ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : $3f9a4df32f03e33e$var$arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new $3f9a4df32f03e33e$var$HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var $3f9a4df32f03e33e$var$ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
$3f9a4df32f03e33e$var$ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return $3f9a4df32f03e33e$export$226b3eccf92c9ed9(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
$3f9a4df32f03e33e$var$ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === $3f9a4df32f03e33e$var$NOT_SET;
    var keyMatch = $3f9a4df32f03e33e$export$226b3eccf92c9ed9(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    $3f9a4df32f03e33e$var$SetRef(didAlter);
    if (removed) {
        $3f9a4df32f03e33e$var$SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new $3f9a4df32f03e33e$var$ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    $3f9a4df32f03e33e$var$SetRef(didChangeSize);
    return $3f9a4df32f03e33e$var$mergeIntoNode(this, ownerID, shift, $3f9a4df32f03e33e$export$d6af199866bfb566(key), [
        key,
        value
    ]);
};
// #pragma Iterators
$3f9a4df32f03e33e$var$ArrayMapNode.prototype.iterate = $3f9a4df32f03e33e$var$HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
$3f9a4df32f03e33e$var$BitmapIndexedNode.prototype.iterate = $3f9a4df32f03e33e$var$HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
$3f9a4df32f03e33e$var$ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var $3f9a4df32f03e33e$var$MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && $3f9a4df32f03e33e$var$mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return $3f9a4df32f03e33e$var$mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return $3f9a4df32f03e33e$var$mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return $3f9a4df32f03e33e$var$mapIteratorValue(type, subNode.entry);
                        stack = this._stack = $3f9a4df32f03e33e$var$mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return $3f9a4df32f03e33e$var$iteratorDone();
    };
    return MapIterator;
}($3f9a4df32f03e33e$var$Iterator);
function $3f9a4df32f03e33e$var$mapIteratorValue(type, entry) {
    return $3f9a4df32f03e33e$var$iteratorValue(type, entry[0], entry[1]);
}
function $3f9a4df32f03e33e$var$mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function $3f9a4df32f03e33e$var$makeMap(size, root, ownerID, hash) {
    var map = Object.create($3f9a4df32f03e33e$var$MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var $3f9a4df32f03e33e$var$EMPTY_MAP;
function $3f9a4df32f03e33e$var$emptyMap() {
    return $3f9a4df32f03e33e$var$EMPTY_MAP || ($3f9a4df32f03e33e$var$EMPTY_MAP = $3f9a4df32f03e33e$var$makeMap(0));
}
function $3f9a4df32f03e33e$var$updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === $3f9a4df32f03e33e$var$NOT_SET) return map;
        newSize = 1;
        newRoot = new $3f9a4df32f03e33e$var$ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = $3f9a4df32f03e33e$var$MakeRef();
        var didAlter = $3f9a4df32f03e33e$var$MakeRef();
        newRoot = $3f9a4df32f03e33e$var$updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === $3f9a4df32f03e33e$var$NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? $3f9a4df32f03e33e$var$makeMap(newSize, newRoot) : $3f9a4df32f03e33e$var$emptyMap();
}
function $3f9a4df32f03e33e$var$updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === $3f9a4df32f03e33e$var$NOT_SET) return node;
        $3f9a4df32f03e33e$var$SetRef(didAlter);
        $3f9a4df32f03e33e$var$SetRef(didChangeSize);
        return new $3f9a4df32f03e33e$var$ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function $3f9a4df32f03e33e$var$isLeafNode(node) {
    return node.constructor === $3f9a4df32f03e33e$var$ValueNode || node.constructor === $3f9a4df32f03e33e$var$HashCollisionNode;
}
function $3f9a4df32f03e33e$var$mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new $3f9a4df32f03e33e$var$HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & $3f9a4df32f03e33e$var$MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & $3f9a4df32f03e33e$var$MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        $3f9a4df32f03e33e$var$mergeIntoNode(node, ownerID, shift + $3f9a4df32f03e33e$var$SHIFT, keyHash, entry)
    ] : (newNode = new $3f9a4df32f03e33e$var$ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new $3f9a4df32f03e33e$var$BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function $3f9a4df32f03e33e$var$createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new $3f9a4df32f03e33e$var$OwnerID();
    var node = new $3f9a4df32f03e33e$var$ValueNode(ownerID, $3f9a4df32f03e33e$export$d6af199866bfb566(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function $3f9a4df32f03e33e$var$packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new $3f9a4df32f03e33e$var$BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function $3f9a4df32f03e33e$var$expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array($3f9a4df32f03e33e$var$SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new $3f9a4df32f03e33e$var$HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function $3f9a4df32f03e33e$var$popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function $3f9a4df32f03e33e$var$setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : $3f9a4df32f03e33e$var$arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function $3f9a4df32f03e33e$var$spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function $3f9a4df32f03e33e$var$spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var $3f9a4df32f03e33e$var$MAX_ARRAY_MAP_SIZE = $3f9a4df32f03e33e$var$SIZE / 4;
var $3f9a4df32f03e33e$var$MAX_BITMAP_INDEXED_SIZE = $3f9a4df32f03e33e$var$SIZE / 2;
var $3f9a4df32f03e33e$var$MIN_HASH_ARRAY_MAP_SIZE = $3f9a4df32f03e33e$var$SIZE / 4;
var $3f9a4df32f03e33e$var$IS_LIST_SYMBOL = "@@__IMMUTABLE_LIST__@@";
function $3f9a4df32f03e33e$export$ead95ff48ba53ffd(maybeList) {
    return Boolean(maybeList && maybeList[$3f9a4df32f03e33e$var$IS_LIST_SYMBOL]);
}
var $3f9a4df32f03e33e$export$54c2e3dc7acea9f5 = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = $3f9a4df32f03e33e$var$emptyList();
        if (value === undefined || value === null) return empty;
        if ($3f9a4df32f03e33e$export$ead95ff48ba53ffd(value)) return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) return empty;
        $3f9a4df32f03e33e$var$assertNotInfinite(size);
        if (size > 0 && size < $3f9a4df32f03e33e$var$SIZE) return $3f9a4df32f03e33e$var$makeList(0, size, $3f9a4df32f03e33e$var$SHIFT, null, new $3f9a4df32f03e33e$var$VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString("List [", "]");
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = $3f9a4df32f03e33e$var$wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = $3f9a4df32f03e33e$var$listNodeFor(this, index);
            return node && node.array[index & $3f9a4df32f03e33e$var$MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return $3f9a4df32f03e33e$var$updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = $3f9a4df32f03e33e$var$SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $3f9a4df32f03e33e$var$emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            $3f9a4df32f03e33e$var$setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return $3f9a4df32f03e33e$var$setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            $3f9a4df32f03e33e$var$setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return $3f9a4df32f03e33e$var$setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== "string" && $3f9a4df32f03e33e$var$hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return $3f9a4df32f03e33e$var$setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if ($3f9a4df32f03e33e$var$wholeSlice(begin, end, size)) return this;
        return $3f9a4df32f03e33e$var$setListBounds(this, $3f9a4df32f03e33e$var$resolveBegin(begin, size), $3f9a4df32f03e33e$var$resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = $3f9a4df32f03e33e$var$iterateList(this, reverse);
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            var value = values();
            return value === $3f9a4df32f03e33e$var$DONE ? $3f9a4df32f03e33e$var$iteratorDone() : $3f9a4df32f03e33e$var$iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = $3f9a4df32f03e33e$var$iterateList(this, reverse);
        var value;
        while((value = values()) !== $3f9a4df32f03e33e$var$DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return $3f9a4df32f03e33e$var$emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return $3f9a4df32f03e33e$var$makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}($3f9a4df32f03e33e$var$IndexedCollection);
$3f9a4df32f03e33e$export$54c2e3dc7acea9f5.isList = $3f9a4df32f03e33e$export$ead95ff48ba53ffd;
var $3f9a4df32f03e33e$var$ListPrototype = $3f9a4df32f03e33e$export$54c2e3dc7acea9f5.prototype;
$3f9a4df32f03e33e$var$ListPrototype[$3f9a4df32f03e33e$var$IS_LIST_SYMBOL] = true;
$3f9a4df32f03e33e$var$ListPrototype[$3f9a4df32f03e33e$var$DELETE] = $3f9a4df32f03e33e$var$ListPrototype.remove;
$3f9a4df32f03e33e$var$ListPrototype.merge = $3f9a4df32f03e33e$var$ListPrototype.concat;
$3f9a4df32f03e33e$var$ListPrototype.setIn = $3f9a4df32f03e33e$var$setIn;
$3f9a4df32f03e33e$var$ListPrototype.deleteIn = $3f9a4df32f03e33e$var$ListPrototype.removeIn = $3f9a4df32f03e33e$var$deleteIn;
$3f9a4df32f03e33e$var$ListPrototype.update = $3f9a4df32f03e33e$var$update;
$3f9a4df32f03e33e$var$ListPrototype.updateIn = $3f9a4df32f03e33e$var$updateIn;
$3f9a4df32f03e33e$var$ListPrototype.mergeIn = $3f9a4df32f03e33e$var$mergeIn;
$3f9a4df32f03e33e$var$ListPrototype.mergeDeepIn = $3f9a4df32f03e33e$var$mergeDeepIn;
$3f9a4df32f03e33e$var$ListPrototype.withMutations = $3f9a4df32f03e33e$var$withMutations;
$3f9a4df32f03e33e$var$ListPrototype.wasAltered = $3f9a4df32f03e33e$var$wasAltered;
$3f9a4df32f03e33e$var$ListPrototype.asImmutable = $3f9a4df32f03e33e$var$asImmutable;
$3f9a4df32f03e33e$var$ListPrototype["@@transducer/init"] = $3f9a4df32f03e33e$var$ListPrototype.asMutable = $3f9a4df32f03e33e$var$asMutable;
$3f9a4df32f03e33e$var$ListPrototype["@@transducer/step"] = function(result, arr) {
    return result.push(arr);
};
$3f9a4df32f03e33e$var$ListPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
var $3f9a4df32f03e33e$var$VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
$3f9a4df32f03e33e$var$VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & $3f9a4df32f03e33e$var$MASK;
    if (originIndex >= this.array.length) return new $3f9a4df32f03e33e$var$VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - $3f9a4df32f03e33e$var$SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = $3f9a4df32f03e33e$var$editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
$3f9a4df32f03e33e$var$VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & $3f9a4df32f03e33e$var$MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - $3f9a4df32f03e33e$var$SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = $3f9a4df32f03e33e$var$editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var $3f9a4df32f03e33e$var$DONE = {};
function $3f9a4df32f03e33e$var$iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = $3f9a4df32f03e33e$var$getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > $3f9a4df32f03e33e$var$SIZE) to = $3f9a4df32f03e33e$var$SIZE;
        return function() {
            if (from === to) return $3f9a4df32f03e33e$var$DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > $3f9a4df32f03e33e$var$SIZE) to = $3f9a4df32f03e33e$var$SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== $3f9a4df32f03e33e$var$DONE) return value;
                    values = null;
                }
                if (from === to) return $3f9a4df32f03e33e$var$DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - $3f9a4df32f03e33e$var$SHIFT, offset + (idx << level));
            }
        };
    }
}
function $3f9a4df32f03e33e$var$makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create($3f9a4df32f03e33e$var$ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var $3f9a4df32f03e33e$var$EMPTY_LIST;
function $3f9a4df32f03e33e$var$emptyList() {
    return $3f9a4df32f03e33e$var$EMPTY_LIST || ($3f9a4df32f03e33e$var$EMPTY_LIST = $3f9a4df32f03e33e$var$makeList(0, 0, $3f9a4df32f03e33e$var$SHIFT));
}
function $3f9a4df32f03e33e$var$updateList(list, index, value) {
    index = $3f9a4df32f03e33e$var$wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? $3f9a4df32f03e33e$var$setListBounds(list, index).set(0, value) : $3f9a4df32f03e33e$var$setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = $3f9a4df32f03e33e$var$MakeRef();
    if (index >= $3f9a4df32f03e33e$var$getTailOffset(list._capacity)) newTail = $3f9a4df32f03e33e$var$updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = $3f9a4df32f03e33e$var$updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return $3f9a4df32f03e33e$var$makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function $3f9a4df32f03e33e$var$updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & $3f9a4df32f03e33e$var$MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = $3f9a4df32f03e33e$var$updateVNode(lowerNode, ownerID, level - $3f9a4df32f03e33e$var$SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = $3f9a4df32f03e33e$var$editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) $3f9a4df32f03e33e$var$SetRef(didAlter);
    newNode = $3f9a4df32f03e33e$var$editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function $3f9a4df32f03e33e$var$editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new $3f9a4df32f03e33e$var$VNode(node ? node.array.slice() : [], ownerID);
}
function $3f9a4df32f03e33e$var$listNodeFor(list, rawIndex) {
    if (rawIndex >= $3f9a4df32f03e33e$var$getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + $3f9a4df32f03e33e$var$SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & $3f9a4df32f03e33e$var$MASK];
            level -= $3f9a4df32f03e33e$var$SHIFT;
        }
        return node;
    }
}
function $3f9a4df32f03e33e$var$setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new $3f9a4df32f03e33e$var$OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new $3f9a4df32f03e33e$var$VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += $3f9a4df32f03e33e$var$SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = $3f9a4df32f03e33e$var$getTailOffset(oldCapacity);
    var newTailOffset = $3f9a4df32f03e33e$var$getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + $3f9a4df32f03e33e$var$SHIFT){
        newRoot = new $3f9a4df32f03e33e$var$VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += $3f9a4df32f03e33e$var$SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? $3f9a4df32f03e33e$var$listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new $3f9a4df32f03e33e$var$VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = $3f9a4df32f03e33e$var$editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > $3f9a4df32f03e33e$var$SHIFT; level -= $3f9a4df32f03e33e$var$SHIFT){
            var idx = oldTailOffset >>> level & $3f9a4df32f03e33e$var$MASK;
            node = node.array[idx] = $3f9a4df32f03e33e$var$editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> $3f9a4df32f03e33e$var$SHIFT & $3f9a4df32f03e33e$var$MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = $3f9a4df32f03e33e$var$SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & $3f9a4df32f03e33e$var$MASK;
            if (beginIndex !== newTailOffset >>> newLevel & $3f9a4df32f03e33e$var$MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= $3f9a4df32f03e33e$var$SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return $3f9a4df32f03e33e$var$makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function $3f9a4df32f03e33e$var$getTailOffset(size) {
    return size < $3f9a4df32f03e33e$var$SIZE ? 0 : size - 1 >>> $3f9a4df32f03e33e$var$SHIFT << $3f9a4df32f03e33e$var$SHIFT;
}
var $3f9a4df32f03e33e$export$8e8eaa3741ef504c = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptyOrderedMap() : $3f9a4df32f03e33e$export$739bc167e02d45ee(value) ? value : $3f9a4df32f03e33e$var$emptyOrderedMap().withMutations(function(map) {
            var iter = $3f9a4df32f03e33e$var$KeyedCollection(value);
            $3f9a4df32f03e33e$var$assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString("OrderedMap {", "}");
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return $3f9a4df32f03e33e$var$emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return $3f9a4df32f03e33e$var$updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return $3f9a4df32f03e33e$var$updateOrderedMap(this, k, $3f9a4df32f03e33e$var$NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return $3f9a4df32f03e33e$var$emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return $3f9a4df32f03e33e$var$makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}($3f9a4df32f03e33e$export$a5c7b93649eaf8f8);
$3f9a4df32f03e33e$export$8e8eaa3741ef504c.isOrderedMap = $3f9a4df32f03e33e$export$739bc167e02d45ee;
$3f9a4df32f03e33e$export$8e8eaa3741ef504c.prototype[$3f9a4df32f03e33e$var$IS_ORDERED_SYMBOL] = true;
$3f9a4df32f03e33e$export$8e8eaa3741ef504c.prototype[$3f9a4df32f03e33e$var$DELETE] = $3f9a4df32f03e33e$export$8e8eaa3741ef504c.prototype.remove;
function $3f9a4df32f03e33e$var$makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create($3f9a4df32f03e33e$export$8e8eaa3741ef504c.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var $3f9a4df32f03e33e$var$EMPTY_ORDERED_MAP;
function $3f9a4df32f03e33e$var$emptyOrderedMap() {
    return $3f9a4df32f03e33e$var$EMPTY_ORDERED_MAP || ($3f9a4df32f03e33e$var$EMPTY_ORDERED_MAP = $3f9a4df32f03e33e$var$makeOrderedMap($3f9a4df32f03e33e$var$emptyMap(), $3f9a4df32f03e33e$var$emptyList()));
}
function $3f9a4df32f03e33e$var$updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === $3f9a4df32f03e33e$var$NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= $3f9a4df32f03e33e$var$SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return $3f9a4df32f03e33e$var$makeOrderedMap(newMap, newList);
}
var $3f9a4df32f03e33e$var$IS_STACK_SYMBOL = "@@__IMMUTABLE_STACK__@@";
function $3f9a4df32f03e33e$export$db58588880737c1c(maybeStack) {
    return Boolean(maybeStack && maybeStack[$3f9a4df32f03e33e$var$IS_STACK_SYMBOL]);
}
var $3f9a4df32f03e33e$export$694e0d28c7ffc90c = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptyStack() : $3f9a4df32f03e33e$export$db58588880737c1c(value) ? value : $3f9a4df32f03e33e$var$emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString("Stack [", "]");
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = $3f9a4df32f03e33e$var$wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $3f9a4df32f03e33e$var$makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && $3f9a4df32f03e33e$export$db58588880737c1c(iter)) return iter;
        $3f9a4df32f03e33e$var$assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $3f9a4df32f03e33e$var$makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $3f9a4df32f03e33e$var$emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if ($3f9a4df32f03e33e$var$wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = $3f9a4df32f03e33e$var$resolveBegin(begin, this.size);
        var resolvedEnd = $3f9a4df32f03e33e$var$resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return $3f9a4df32f03e33e$var$makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return $3f9a4df32f03e33e$var$emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return $3f9a4df32f03e33e$var$makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new $3f9a4df32f03e33e$var$ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new $3f9a4df32f03e33e$var$ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return $3f9a4df32f03e33e$var$iteratorValue(type, iterations++, value);
            }
            return $3f9a4df32f03e33e$var$iteratorDone();
        });
    };
    return Stack;
}($3f9a4df32f03e33e$var$IndexedCollection);
$3f9a4df32f03e33e$export$694e0d28c7ffc90c.isStack = $3f9a4df32f03e33e$export$db58588880737c1c;
var $3f9a4df32f03e33e$var$StackPrototype = $3f9a4df32f03e33e$export$694e0d28c7ffc90c.prototype;
$3f9a4df32f03e33e$var$StackPrototype[$3f9a4df32f03e33e$var$IS_STACK_SYMBOL] = true;
$3f9a4df32f03e33e$var$StackPrototype.shift = $3f9a4df32f03e33e$var$StackPrototype.pop;
$3f9a4df32f03e33e$var$StackPrototype.unshift = $3f9a4df32f03e33e$var$StackPrototype.push;
$3f9a4df32f03e33e$var$StackPrototype.unshiftAll = $3f9a4df32f03e33e$var$StackPrototype.pushAll;
$3f9a4df32f03e33e$var$StackPrototype.withMutations = $3f9a4df32f03e33e$var$withMutations;
$3f9a4df32f03e33e$var$StackPrototype.wasAltered = $3f9a4df32f03e33e$var$wasAltered;
$3f9a4df32f03e33e$var$StackPrototype.asImmutable = $3f9a4df32f03e33e$var$asImmutable;
$3f9a4df32f03e33e$var$StackPrototype["@@transducer/init"] = $3f9a4df32f03e33e$var$StackPrototype.asMutable = $3f9a4df32f03e33e$var$asMutable;
$3f9a4df32f03e33e$var$StackPrototype["@@transducer/step"] = function(result, arr) {
    return result.unshift(arr);
};
$3f9a4df32f03e33e$var$StackPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
function $3f9a4df32f03e33e$var$makeStack(size, head, ownerID, hash) {
    var map = Object.create($3f9a4df32f03e33e$var$StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var $3f9a4df32f03e33e$var$EMPTY_STACK;
function $3f9a4df32f03e33e$var$emptyStack() {
    return $3f9a4df32f03e33e$var$EMPTY_STACK || ($3f9a4df32f03e33e$var$EMPTY_STACK = $3f9a4df32f03e33e$var$makeStack(0));
}
var $3f9a4df32f03e33e$var$IS_SET_SYMBOL = "@@__IMMUTABLE_SET__@@";
function $3f9a4df32f03e33e$export$6750766a7c7ec627(maybeSet) {
    return Boolean(maybeSet && maybeSet[$3f9a4df32f03e33e$var$IS_SET_SYMBOL]);
}
function $3f9a4df32f03e33e$export$a5eec3a3b03b602f(maybeOrderedSet) {
    return $3f9a4df32f03e33e$export$6750766a7c7ec627(maybeOrderedSet) && $3f9a4df32f03e33e$export$e670b9b76442ef6c(maybeOrderedSet);
}
function $3f9a4df32f03e33e$var$deepEqual(a, b) {
    if (a === b) return true;
    if (!$3f9a4df32f03e33e$export$cea7aa84e978eba5(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || $3f9a4df32f03e33e$export$66d51e2080425364(a) !== $3f9a4df32f03e33e$export$66d51e2080425364(b) || $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(a) !== $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(b) || $3f9a4df32f03e33e$export$e670b9b76442ef6c(a) !== $3f9a4df32f03e33e$export$e670b9b76442ef6c(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !$3f9a4df32f03e33e$export$9c3ce8f7b89c6d66(a);
    if ($3f9a4df32f03e33e$export$e670b9b76442ef6c(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && $3f9a4df32f03e33e$export$226b3eccf92c9ed9(entry[1], v) && (notAssociative || $3f9a4df32f03e33e$export$226b3eccf92c9ed9(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === "function") a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !$3f9a4df32f03e33e$export$226b3eccf92c9ed9(v, a.get(k, $3f9a4df32f03e33e$var$NOT_SET)) : !$3f9a4df32f03e33e$export$226b3eccf92c9ed9(a.get(k, $3f9a4df32f03e33e$var$NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
function $3f9a4df32f03e33e$var$mixin(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function $3f9a4df32f03e33e$var$toJS(value) {
    if (!value || typeof value !== "object") return value;
    if (!$3f9a4df32f03e33e$export$cea7aa84e978eba5(value)) {
        if (!$3f9a4df32f03e33e$var$isDataStructure(value)) return value;
        value = $3f9a4df32f03e33e$export$4802c350533dc67e(value);
    }
    if ($3f9a4df32f03e33e$export$66d51e2080425364(value)) {
        var result$1 = {};
        value.__iterate(function(v, k) {
            result$1[k] = $3f9a4df32f03e33e$var$toJS(v);
        });
        return result$1;
    }
    var result = [];
    value.__iterate(function(v) {
        result.push($3f9a4df32f03e33e$var$toJS(v));
    });
    return result;
}
var $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5 = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptySet() : $3f9a4df32f03e33e$export$6750766a7c7ec627(value) && !$3f9a4df32f03e33e$export$e670b9b76442ef6c(value) ? value : $3f9a4df32f03e33e$var$emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            $3f9a4df32f03e33e$var$assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this($3f9a4df32f03e33e$var$KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = $3f9a4df32f03e33e$export$fb8073518f34e6ec(sets).toArray();
        return sets.length ? $3f9a4df32f03e33e$var$SetPrototype.intersect.apply(Set(sets.pop()), sets) : $3f9a4df32f03e33e$var$emptySet();
    };
    Set.union = function union(sets) {
        sets = $3f9a4df32f03e33e$export$fb8073518f34e6ec(sets).toArray();
        return sets.length ? $3f9a4df32f03e33e$var$SetPrototype.union.apply(Set(sets.pop()), sets) : $3f9a4df32f03e33e$var$emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString("Set {", "}");
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return $3f9a4df32f03e33e$var$updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return $3f9a4df32f03e33e$var$updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return $3f9a4df32f03e33e$var$updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = $3f9a4df32f03e33e$var$updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === "string") set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return $3f9a4df32f03e33e$export$ba0280ac83f150c1($3f9a4df32f03e33e$var$sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return $3f9a4df32f03e33e$export$ba0280ac83f150c1($3f9a4df32f03e33e$var$sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}($3f9a4df32f03e33e$var$SetCollection);
$3f9a4df32f03e33e$export$bdf4ff5a442cbbc5.isSet = $3f9a4df32f03e33e$export$6750766a7c7ec627;
var $3f9a4df32f03e33e$var$SetPrototype = $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5.prototype;
$3f9a4df32f03e33e$var$SetPrototype[$3f9a4df32f03e33e$var$IS_SET_SYMBOL] = true;
$3f9a4df32f03e33e$var$SetPrototype[$3f9a4df32f03e33e$var$DELETE] = $3f9a4df32f03e33e$var$SetPrototype.remove;
$3f9a4df32f03e33e$var$SetPrototype.merge = $3f9a4df32f03e33e$var$SetPrototype.concat = $3f9a4df32f03e33e$var$SetPrototype.union;
$3f9a4df32f03e33e$var$SetPrototype.withMutations = $3f9a4df32f03e33e$var$withMutations;
$3f9a4df32f03e33e$var$SetPrototype.asImmutable = $3f9a4df32f03e33e$var$asImmutable;
$3f9a4df32f03e33e$var$SetPrototype["@@transducer/init"] = $3f9a4df32f03e33e$var$SetPrototype.asMutable = $3f9a4df32f03e33e$var$asMutable;
$3f9a4df32f03e33e$var$SetPrototype["@@transducer/step"] = function(result, arr) {
    return result.add(arr);
};
$3f9a4df32f03e33e$var$SetPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
$3f9a4df32f03e33e$var$SetPrototype.__empty = $3f9a4df32f03e33e$var$emptySet;
$3f9a4df32f03e33e$var$SetPrototype.__make = $3f9a4df32f03e33e$var$makeSet;
function $3f9a4df32f03e33e$var$updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function $3f9a4df32f03e33e$var$makeSet(map, ownerID) {
    var set = Object.create($3f9a4df32f03e33e$var$SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var $3f9a4df32f03e33e$var$EMPTY_SET;
function $3f9a4df32f03e33e$var$emptySet() {
    return $3f9a4df32f03e33e$var$EMPTY_SET || ($3f9a4df32f03e33e$var$EMPTY_SET = $3f9a4df32f03e33e$var$makeSet($3f9a4df32f03e33e$var$emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var $3f9a4df32f03e33e$export$9a58ef0d7ad3278c = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        $3f9a4df32f03e33e$var$invariant(step !== 0, "Cannot step a Range by 0");
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if ($3f9a4df32f03e33e$var$EMPTY_RANGE) return $3f9a4df32f03e33e$var$EMPTY_RANGE;
            $3f9a4df32f03e33e$var$EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return "Range []";
        return "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + $3f9a4df32f03e33e$var$wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if ($3f9a4df32f03e33e$var$wholeSlice(begin, end, this.size)) return this;
        begin = $3f9a4df32f03e33e$var$resolveBegin(begin, this.size);
        end = $3f9a4df32f03e33e$var$resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            if (i === size) return $3f9a4df32f03e33e$var$iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return $3f9a4df32f03e33e$var$iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : $3f9a4df32f03e33e$var$deepEqual(this, other);
    };
    return Range;
}($3f9a4df32f03e33e$var$IndexedSeq);
var $3f9a4df32f03e33e$var$EMPTY_RANGE;
function $3f9a4df32f03e33e$export$c52e5867d5879e24(collection, searchKeyPath, notSetValue) {
    var keyPath = $3f9a4df32f03e33e$var$coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = $3f9a4df32f03e33e$export$3988ae62b71be9a3(collection, keyPath[i++], $3f9a4df32f03e33e$var$NOT_SET);
        if (collection === $3f9a4df32f03e33e$var$NOT_SET) return notSetValue;
    }
    return collection;
}
function $3f9a4df32f03e33e$var$getIn(searchKeyPath, notSetValue) {
    return $3f9a4df32f03e33e$export$c52e5867d5879e24(this, searchKeyPath, notSetValue);
}
function $3f9a4df32f03e33e$export$d39a4e62499f2a79(collection, keyPath) {
    return $3f9a4df32f03e33e$export$c52e5867d5879e24(collection, keyPath, $3f9a4df32f03e33e$var$NOT_SET) !== $3f9a4df32f03e33e$var$NOT_SET;
}
function $3f9a4df32f03e33e$var$hasIn(searchKeyPath) {
    return $3f9a4df32f03e33e$export$d39a4e62499f2a79(this, searchKeyPath);
}
function $3f9a4df32f03e33e$var$toObject() {
    $3f9a4df32f03e33e$var$assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
$3f9a4df32f03e33e$export$fb8073518f34e6ec.isIterable = $3f9a4df32f03e33e$export$cea7aa84e978eba5;
$3f9a4df32f03e33e$export$fb8073518f34e6ec.isKeyed = $3f9a4df32f03e33e$export$66d51e2080425364;
$3f9a4df32f03e33e$export$fb8073518f34e6ec.isIndexed = $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09;
$3f9a4df32f03e33e$export$fb8073518f34e6ec.isAssociative = $3f9a4df32f03e33e$export$9c3ce8f7b89c6d66;
$3f9a4df32f03e33e$export$fb8073518f34e6ec.isOrdered = $3f9a4df32f03e33e$export$e670b9b76442ef6c;
$3f9a4df32f03e33e$export$fb8073518f34e6ec.Iterator = $3f9a4df32f03e33e$var$Iterator;
$3f9a4df32f03e33e$var$mixin($3f9a4df32f03e33e$export$fb8073518f34e6ec, {
    // ### Conversion to other types
    toArray: function toArray() {
        $3f9a4df32f03e33e$var$assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = $3f9a4df32f03e33e$export$66d51e2080425364(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new $3f9a4df32f03e33e$var$ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return $3f9a4df32f03e33e$var$toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new $3f9a4df32f03e33e$var$ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return $3f9a4df32f03e33e$export$a5c7b93649eaf8f8(this.toKeyedSeq());
    },
    toObject: $3f9a4df32f03e33e$var$toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return $3f9a4df32f03e33e$export$8e8eaa3741ef504c(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return $3f9a4df32f03e33e$export$ba0280ac83f150c1($3f9a4df32f03e33e$export$66d51e2080425364(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5($3f9a4df32f03e33e$export$66d51e2080425364(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new $3f9a4df32f03e33e$var$ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(this) ? this.toIndexedSeq() : $3f9a4df32f03e33e$export$66d51e2080425364(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return $3f9a4df32f03e33e$export$694e0d28c7ffc90c($3f9a4df32f03e33e$export$66d51e2080425364(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return $3f9a4df32f03e33e$export$54c2e3dc7acea9f5($3f9a4df32f03e33e$export$66d51e2080425364(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return "[Collection]";
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return $3f9a4df32f03e33e$export$226b3eccf92c9ed9(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator($3f9a4df32f03e33e$var$ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        $3f9a4df32f03e33e$var$assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return $3f9a4df32f03e33e$var$partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        $3f9a4df32f03e33e$var$assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        $3f9a4df32f03e33e$var$assertNotInfinite(this.size);
        separator = separator !== undefined ? "" + separator : ",";
        var joined = "";
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : "";
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator($3f9a4df32f03e33e$var$ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return $3f9a4df32f03e33e$var$reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return $3f9a4df32f03e33e$var$reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        return !this.every($3f9a4df32f03e33e$var$not(predicate), context);
    },
    sort: function sort(comparator) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator($3f9a4df32f03e33e$var$ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return $3f9a4df32f03e33e$var$ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return $3f9a4df32f03e33e$var$countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return $3f9a4df32f03e33e$var$deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new $3f9a4df32f03e33e$var$ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map($3f9a4df32f03e33e$var$entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter($3f9a4df32f03e33e$var$not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find($3f9a4df32f03e33e$var$returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new $3f9a4df32f03e33e$var$FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return $3f9a4df32f03e33e$export$226b3eccf92c9ed9(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: $3f9a4df32f03e33e$var$getIn,
    groupBy: function groupBy(grouper, context) {
        return $3f9a4df32f03e33e$var$groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, $3f9a4df32f03e33e$var$NOT_SET) !== $3f9a4df32f03e33e$var$NOT_SET;
    },
    hasIn: $3f9a4df32f03e33e$var$hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === "function" ? iter : $3f9a4df32f03e33e$export$fb8073518f34e6ec(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === "function" ? iter : $3f9a4df32f03e33e$export$fb8073518f34e6ec(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return $3f9a4df32f03e33e$export$226b3eccf92c9ed9(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map($3f9a4df32f03e33e$var$keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return $3f9a4df32f03e33e$var$maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return $3f9a4df32f03e33e$var$maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return $3f9a4df32f03e33e$var$maxFactory(this, comparator ? $3f9a4df32f03e33e$var$neg(comparator) : $3f9a4df32f03e33e$var$defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return $3f9a4df32f03e33e$var$maxFactory(this, comparator ? $3f9a4df32f03e33e$var$neg(comparator) : $3f9a4df32f03e33e$var$defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile($3f9a4df32f03e33e$var$not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile($3f9a4df32f03e33e$var$not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = $3f9a4df32f03e33e$var$hashCollection(this));
    }
});
var $3f9a4df32f03e33e$var$CollectionPrototype = $3f9a4df32f03e33e$export$fb8073518f34e6ec.prototype;
$3f9a4df32f03e33e$var$CollectionPrototype[$3f9a4df32f03e33e$var$IS_COLLECTION_SYMBOL] = true;
$3f9a4df32f03e33e$var$CollectionPrototype[$3f9a4df32f03e33e$var$ITERATOR_SYMBOL] = $3f9a4df32f03e33e$var$CollectionPrototype.values;
$3f9a4df32f03e33e$var$CollectionPrototype.toJSON = $3f9a4df32f03e33e$var$CollectionPrototype.toArray;
$3f9a4df32f03e33e$var$CollectionPrototype.__toStringMapper = $3f9a4df32f03e33e$var$quoteString;
$3f9a4df32f03e33e$var$CollectionPrototype.inspect = $3f9a4df32f03e33e$var$CollectionPrototype.toSource = function() {
    return this.toString();
};
$3f9a4df32f03e33e$var$CollectionPrototype.chain = $3f9a4df32f03e33e$var$CollectionPrototype.flatMap;
$3f9a4df32f03e33e$var$CollectionPrototype.contains = $3f9a4df32f03e33e$var$CollectionPrototype.includes;
$3f9a4df32f03e33e$var$mixin($3f9a4df32f03e33e$var$KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return $3f9a4df32f03e33e$var$reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return $3f9a4df32f03e33e$var$reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var $3f9a4df32f03e33e$var$KeyedCollectionPrototype = $3f9a4df32f03e33e$var$KeyedCollection.prototype;
$3f9a4df32f03e33e$var$KeyedCollectionPrototype[$3f9a4df32f03e33e$var$IS_KEYED_SYMBOL] = true;
$3f9a4df32f03e33e$var$KeyedCollectionPrototype[$3f9a4df32f03e33e$var$ITERATOR_SYMBOL] = $3f9a4df32f03e33e$var$CollectionPrototype.entries;
$3f9a4df32f03e33e$var$KeyedCollectionPrototype.toJSON = $3f9a4df32f03e33e$var$toObject;
$3f9a4df32f03e33e$var$KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return $3f9a4df32f03e33e$var$quoteString(k) + ": " + $3f9a4df32f03e33e$var$quoteString(v);
};
$3f9a4df32f03e33e$var$mixin($3f9a4df32f03e33e$var$IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new $3f9a4df32f03e33e$var$ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = $3f9a4df32f03e33e$var$resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return $3f9a4df32f03e33e$var$reify(this, numArgs === 1 ? spliced : spliced.concat($3f9a4df32f03e33e$var$arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = $3f9a4df32f03e33e$var$wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = $3f9a4df32f03e33e$var$wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat($3f9a4df32f03e33e$var$arrCopy(arguments));
        var zipped = $3f9a4df32f03e33e$var$zipWithFactory(this.toSeq(), $3f9a4df32f03e33e$var$IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return $3f9a4df32f03e33e$var$reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return $3f9a4df32f03e33e$export$9a58ef0d7ad3278c(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat($3f9a4df32f03e33e$var$arrCopy(arguments));
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$zipWithFactory(this, $3f9a4df32f03e33e$var$defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat($3f9a4df32f03e33e$var$arrCopy(arguments));
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$zipWithFactory(this, $3f9a4df32f03e33e$var$defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = $3f9a4df32f03e33e$var$arrCopy(arguments);
        collections[0] = this;
        return $3f9a4df32f03e33e$var$reify(this, $3f9a4df32f03e33e$var$zipWithFactory(this, zipper, collections));
    }
});
var $3f9a4df32f03e33e$var$IndexedCollectionPrototype = $3f9a4df32f03e33e$var$IndexedCollection.prototype;
$3f9a4df32f03e33e$var$IndexedCollectionPrototype[$3f9a4df32f03e33e$var$IS_INDEXED_SYMBOL] = true;
$3f9a4df32f03e33e$var$IndexedCollectionPrototype[$3f9a4df32f03e33e$var$IS_ORDERED_SYMBOL] = true;
$3f9a4df32f03e33e$var$mixin($3f9a4df32f03e33e$var$SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var $3f9a4df32f03e33e$var$SetCollectionPrototype = $3f9a4df32f03e33e$var$SetCollection.prototype;
$3f9a4df32f03e33e$var$SetCollectionPrototype.has = $3f9a4df32f03e33e$var$CollectionPrototype.includes;
$3f9a4df32f03e33e$var$SetCollectionPrototype.contains = $3f9a4df32f03e33e$var$SetCollectionPrototype.includes;
$3f9a4df32f03e33e$var$SetCollectionPrototype.keys = $3f9a4df32f03e33e$var$SetCollectionPrototype.values;
// Mixin subclasses
$3f9a4df32f03e33e$var$mixin($3f9a4df32f03e33e$var$KeyedSeq, $3f9a4df32f03e33e$var$KeyedCollectionPrototype);
$3f9a4df32f03e33e$var$mixin($3f9a4df32f03e33e$var$IndexedSeq, $3f9a4df32f03e33e$var$IndexedCollectionPrototype);
$3f9a4df32f03e33e$var$mixin($3f9a4df32f03e33e$var$SetSeq, $3f9a4df32f03e33e$var$SetCollectionPrototype);
// #pragma Helper functions
function $3f9a4df32f03e33e$var$reduce(collection, reducer, reduction, context, useFirst, reverse) {
    $3f9a4df32f03e33e$var$assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function $3f9a4df32f03e33e$var$keyMapper(v, k) {
    return k;
}
function $3f9a4df32f03e33e$var$entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function $3f9a4df32f03e33e$var$not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function $3f9a4df32f03e33e$var$neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function $3f9a4df32f03e33e$var$defaultZipper() {
    return $3f9a4df32f03e33e$var$arrCopy(arguments);
}
function $3f9a4df32f03e33e$var$defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $3f9a4df32f03e33e$var$hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = $3f9a4df32f03e33e$export$e670b9b76442ef6c(collection);
    var keyed = $3f9a4df32f03e33e$export$66d51e2080425364(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + $3f9a4df32f03e33e$var$hashMerge($3f9a4df32f03e33e$export$d6af199866bfb566(v), $3f9a4df32f03e33e$export$d6af199866bfb566(k)) | 0;
    } : function(v, k) {
        h = h + $3f9a4df32f03e33e$var$hashMerge($3f9a4df32f03e33e$export$d6af199866bfb566(v), $3f9a4df32f03e33e$export$d6af199866bfb566(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + $3f9a4df32f03e33e$export$d6af199866bfb566(v) | 0;
    } : function(v) {
        h = h + $3f9a4df32f03e33e$export$d6af199866bfb566(v) | 0;
    });
    return $3f9a4df32f03e33e$var$murmurHashOfSize(size, h);
}
function $3f9a4df32f03e33e$var$murmurHashOfSize(size, h) {
    h = $3f9a4df32f03e33e$var$imul(h, 0xcc9e2d51);
    h = $3f9a4df32f03e33e$var$imul(h << 15 | h >>> -15, 0x1b873593);
    h = $3f9a4df32f03e33e$var$imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = $3f9a4df32f03e33e$var$imul(h ^ h >>> 16, 0x85ebca6b);
    h = $3f9a4df32f03e33e$var$imul(h ^ h >>> 13, 0xc2b2ae35);
    h = $3f9a4df32f03e33e$var$smi(h ^ h >>> 16);
    return h;
}
function $3f9a4df32f03e33e$var$hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var $3f9a4df32f03e33e$export$ba0280ac83f150c1 = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        return value === undefined || value === null ? $3f9a4df32f03e33e$var$emptyOrderedSet() : $3f9a4df32f03e33e$export$a5eec3a3b03b602f(value) ? value : $3f9a4df32f03e33e$var$emptyOrderedSet().withMutations(function(set) {
            var iter = $3f9a4df32f03e33e$var$SetCollection(value);
            $3f9a4df32f03e33e$var$assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this($3f9a4df32f03e33e$var$KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString("OrderedSet {", "}");
    };
    return OrderedSet;
}($3f9a4df32f03e33e$export$bdf4ff5a442cbbc5);
$3f9a4df32f03e33e$export$ba0280ac83f150c1.isOrderedSet = $3f9a4df32f03e33e$export$a5eec3a3b03b602f;
var $3f9a4df32f03e33e$var$OrderedSetPrototype = $3f9a4df32f03e33e$export$ba0280ac83f150c1.prototype;
$3f9a4df32f03e33e$var$OrderedSetPrototype[$3f9a4df32f03e33e$var$IS_ORDERED_SYMBOL] = true;
$3f9a4df32f03e33e$var$OrderedSetPrototype.zip = $3f9a4df32f03e33e$var$IndexedCollectionPrototype.zip;
$3f9a4df32f03e33e$var$OrderedSetPrototype.zipWith = $3f9a4df32f03e33e$var$IndexedCollectionPrototype.zipWith;
$3f9a4df32f03e33e$var$OrderedSetPrototype.zipAll = $3f9a4df32f03e33e$var$IndexedCollectionPrototype.zipAll;
$3f9a4df32f03e33e$var$OrderedSetPrototype.__empty = $3f9a4df32f03e33e$var$emptyOrderedSet;
$3f9a4df32f03e33e$var$OrderedSetPrototype.__make = $3f9a4df32f03e33e$var$makeOrderedSet;
function $3f9a4df32f03e33e$var$makeOrderedSet(map, ownerID) {
    var set = Object.create($3f9a4df32f03e33e$var$OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var $3f9a4df32f03e33e$var$EMPTY_ORDERED_SET;
function $3f9a4df32f03e33e$var$emptyOrderedSet() {
    return $3f9a4df32f03e33e$var$EMPTY_ORDERED_SET || ($3f9a4df32f03e33e$var$EMPTY_ORDERED_SET = $3f9a4df32f03e33e$var$makeOrderedSet($3f9a4df32f03e33e$var$emptyOrderedMap()));
}
var $3f9a4df32f03e33e$export$b26aa21284963439 = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function $3f9a4df32f03e33e$var$throwOnInvalidDefaultValues(defaultValues) {
    if ($3f9a4df32f03e33e$export$6ba840931da50680(defaultValues)) throw new Error("Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.");
    if ($3f9a4df32f03e33e$export$f8647edfbac13b4f(defaultValues)) throw new Error("Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.");
    if (defaultValues === null || typeof defaultValues !== "object") throw new Error("Can not call `Record` with a non-object as default values. Use a plain javascript object instead.");
}
var $3f9a4df32f03e33e$export$5b163c6d120341e7 = function Record(defaultValues, name) {
    var hasInitialized;
    $3f9a4df32f03e33e$var$throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === "object" && console.warn && console.warn("Cannot define " + $3f9a4df32f03e33e$var$recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else $3f9a4df32f03e33e$var$setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = $3f9a4df32f03e33e$export$54c2e3dc7acea9f5().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            $3f9a4df32f03e33e$var$KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create($3f9a4df32f03e33e$var$RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    return RecordType;
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.toString = function toString() {
    var str = $3f9a4df32f03e33e$var$recordName(this) + " { ";
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ", " : "") + k + ": " + $3f9a4df32f03e33e$var$quoteString(this.get(k));
    }
    return str + " }";
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.equals = function equals(other) {
    return this === other || $3f9a4df32f03e33e$export$6ba840931da50680(other) && $3f9a4df32f03e33e$var$recordSeq(this).equals($3f9a4df32f03e33e$var$recordSeq(other));
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.hashCode = function hashCode() {
    return $3f9a4df32f03e33e$var$recordSeq(this).hashCode();
};
// @pragma Access
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return $3f9a4df32f03e33e$var$makeRecord(this, newValues);
    }
    return this;
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.remove = function remove(k) {
    return this.set(k);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : $3f9a4df32f03e33e$var$makeRecord(this, newValues);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.toSeq = function toSeq() {
    return $3f9a4df32f03e33e$var$recordSeq(this);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.toJS = function toJS$1() {
    return $3f9a4df32f03e33e$var$toJS(this);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.entries = function entries() {
    return this.__iterator($3f9a4df32f03e33e$var$ITERATE_ENTRIES);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.__iterator = function __iterator(type, reverse) {
    return $3f9a4df32f03e33e$var$recordSeq(this).__iterator(type, reverse);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.__iterate = function __iterate(fn, reverse) {
    return $3f9a4df32f03e33e$var$recordSeq(this).__iterate(fn, reverse);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return $3f9a4df32f03e33e$var$makeRecord(this, newValues, ownerID);
};
$3f9a4df32f03e33e$export$5b163c6d120341e7.isRecord = $3f9a4df32f03e33e$export$6ba840931da50680;
$3f9a4df32f03e33e$export$5b163c6d120341e7.getDescriptiveName = $3f9a4df32f03e33e$var$recordName;
var $3f9a4df32f03e33e$var$RecordPrototype = $3f9a4df32f03e33e$export$5b163c6d120341e7.prototype;
$3f9a4df32f03e33e$var$RecordPrototype[$3f9a4df32f03e33e$var$IS_RECORD_SYMBOL] = true;
$3f9a4df32f03e33e$var$RecordPrototype[$3f9a4df32f03e33e$var$DELETE] = $3f9a4df32f03e33e$var$RecordPrototype.remove;
$3f9a4df32f03e33e$var$RecordPrototype.deleteIn = $3f9a4df32f03e33e$var$RecordPrototype.removeIn = $3f9a4df32f03e33e$var$deleteIn;
$3f9a4df32f03e33e$var$RecordPrototype.getIn = $3f9a4df32f03e33e$var$getIn;
$3f9a4df32f03e33e$var$RecordPrototype.hasIn = $3f9a4df32f03e33e$var$CollectionPrototype.hasIn;
$3f9a4df32f03e33e$var$RecordPrototype.merge = $3f9a4df32f03e33e$var$merge$1;
$3f9a4df32f03e33e$var$RecordPrototype.mergeWith = $3f9a4df32f03e33e$var$mergeWith$1;
$3f9a4df32f03e33e$var$RecordPrototype.mergeIn = $3f9a4df32f03e33e$var$mergeIn;
$3f9a4df32f03e33e$var$RecordPrototype.mergeDeep = $3f9a4df32f03e33e$var$mergeDeep;
$3f9a4df32f03e33e$var$RecordPrototype.mergeDeepWith = $3f9a4df32f03e33e$var$mergeDeepWith;
$3f9a4df32f03e33e$var$RecordPrototype.mergeDeepIn = $3f9a4df32f03e33e$var$mergeDeepIn;
$3f9a4df32f03e33e$var$RecordPrototype.setIn = $3f9a4df32f03e33e$var$setIn;
$3f9a4df32f03e33e$var$RecordPrototype.update = $3f9a4df32f03e33e$var$update;
$3f9a4df32f03e33e$var$RecordPrototype.updateIn = $3f9a4df32f03e33e$var$updateIn;
$3f9a4df32f03e33e$var$RecordPrototype.withMutations = $3f9a4df32f03e33e$var$withMutations;
$3f9a4df32f03e33e$var$RecordPrototype.asMutable = $3f9a4df32f03e33e$var$asMutable;
$3f9a4df32f03e33e$var$RecordPrototype.asImmutable = $3f9a4df32f03e33e$var$asImmutable;
$3f9a4df32f03e33e$var$RecordPrototype[$3f9a4df32f03e33e$var$ITERATOR_SYMBOL] = $3f9a4df32f03e33e$var$RecordPrototype.entries;
$3f9a4df32f03e33e$var$RecordPrototype.toJSON = $3f9a4df32f03e33e$var$RecordPrototype.toObject = $3f9a4df32f03e33e$var$CollectionPrototype.toObject;
$3f9a4df32f03e33e$var$RecordPrototype.inspect = $3f9a4df32f03e33e$var$RecordPrototype.toSource = function() {
    return this.toString();
};
function $3f9a4df32f03e33e$var$makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function $3f9a4df32f03e33e$var$recordName(record) {
    return record.constructor.displayName || record.constructor.name || "Record";
}
function $3f9a4df32f03e33e$var$recordSeq(record) {
    return $3f9a4df32f03e33e$var$keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function $3f9a4df32f03e33e$var$setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                $3f9a4df32f03e33e$var$invariant(this.__ownerID, "Cannot set on an immutable record.");
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var $3f9a4df32f03e33e$export$f9d61a2a6155ab51 = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if ($3f9a4df32f03e33e$var$EMPTY_REPEAT) return $3f9a4df32f03e33e$var$EMPTY_REPEAT;
            $3f9a4df32f03e33e$var$EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return "Repeat []";
        return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return $3f9a4df32f03e33e$export$226b3eccf92c9ed9(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return $3f9a4df32f03e33e$var$wholeSlice(begin, end, size) ? this : new Repeat(this._value, $3f9a4df32f03e33e$var$resolveEnd(end, size) - $3f9a4df32f03e33e$var$resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if ($3f9a4df32f03e33e$export$226b3eccf92c9ed9(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if ($3f9a4df32f03e33e$export$226b3eccf92c9ed9(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new $3f9a4df32f03e33e$var$Iterator(function() {
            return i === size ? $3f9a4df32f03e33e$var$iteratorDone() : $3f9a4df32f03e33e$var$iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? $3f9a4df32f03e33e$export$226b3eccf92c9ed9(this._value, other._value) : $3f9a4df32f03e33e$var$deepEqual(other);
    };
    return Repeat;
}($3f9a4df32f03e33e$var$IndexedSeq);
var $3f9a4df32f03e33e$var$EMPTY_REPEAT;
function $3f9a4df32f03e33e$export$fb763b55bf590791(value, converter) {
    return $3f9a4df32f03e33e$var$fromJSWith([], converter || $3f9a4df32f03e33e$var$defaultConverter, value, "", converter && converter.length > 2 ? [] : undefined, {
        "": value
    });
}
function $3f9a4df32f03e33e$var$fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== "string" && !$3f9a4df32f03e33e$export$f8647edfbac13b4f(value) && ($3f9a4df32f03e33e$var$isArrayLike(value) || $3f9a4df32f03e33e$var$hasIterator(value) || $3f9a4df32f03e33e$export$53b83ca8eaab0383(value))) {
        if (~stack.indexOf(value)) throw new TypeError("Cannot convert circular structure to Immutable");
        stack.push(value);
        keyPath && key !== "" && keyPath.push(key);
        var converted = converter.call(parentValue, key, $3f9a4df32f03e33e$export$4802c350533dc67e(value).map(function(v, k) {
            return $3f9a4df32f03e33e$var$fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function $3f9a4df32f03e33e$var$defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09(v) ? v.toList() : $3f9a4df32f03e33e$export$66d51e2080425364(v) ? v.toMap() : v.toSet();
}
var $3f9a4df32f03e33e$export$83d89fbfd8236492 = "4.3.0";
var $3f9a4df32f03e33e$var$Immutable = {
    version: $3f9a4df32f03e33e$export$83d89fbfd8236492,
    Collection: $3f9a4df32f03e33e$export$fb8073518f34e6ec,
    // Note: Iterable is deprecated
    Iterable: $3f9a4df32f03e33e$export$fb8073518f34e6ec,
    Seq: $3f9a4df32f03e33e$export$4802c350533dc67e,
    Map: $3f9a4df32f03e33e$export$a5c7b93649eaf8f8,
    OrderedMap: $3f9a4df32f03e33e$export$8e8eaa3741ef504c,
    List: $3f9a4df32f03e33e$export$54c2e3dc7acea9f5,
    Stack: $3f9a4df32f03e33e$export$694e0d28c7ffc90c,
    Set: $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5,
    OrderedSet: $3f9a4df32f03e33e$export$ba0280ac83f150c1,
    PairSorting: $3f9a4df32f03e33e$export$b26aa21284963439,
    Record: $3f9a4df32f03e33e$export$5b163c6d120341e7,
    Range: $3f9a4df32f03e33e$export$9a58ef0d7ad3278c,
    Repeat: $3f9a4df32f03e33e$export$f9d61a2a6155ab51,
    is: $3f9a4df32f03e33e$export$226b3eccf92c9ed9,
    fromJS: $3f9a4df32f03e33e$export$fb763b55bf590791,
    hash: $3f9a4df32f03e33e$export$d6af199866bfb566,
    isImmutable: $3f9a4df32f03e33e$export$f8647edfbac13b4f,
    isCollection: $3f9a4df32f03e33e$export$cea7aa84e978eba5,
    isKeyed: $3f9a4df32f03e33e$export$66d51e2080425364,
    isIndexed: $3f9a4df32f03e33e$export$3bfb5e72e8bc6e09,
    isAssociative: $3f9a4df32f03e33e$export$9c3ce8f7b89c6d66,
    isOrdered: $3f9a4df32f03e33e$export$e670b9b76442ef6c,
    isValueObject: $3f9a4df32f03e33e$export$b24f7407c77e5bd,
    isPlainObject: $3f9a4df32f03e33e$export$53b83ca8eaab0383,
    isSeq: $3f9a4df32f03e33e$export$342ac1d101ffe14b,
    isList: $3f9a4df32f03e33e$export$ead95ff48ba53ffd,
    isMap: $3f9a4df32f03e33e$export$5c90113a285f2241,
    isOrderedMap: $3f9a4df32f03e33e$export$739bc167e02d45ee,
    isStack: $3f9a4df32f03e33e$export$db58588880737c1c,
    isSet: $3f9a4df32f03e33e$export$6750766a7c7ec627,
    isOrderedSet: $3f9a4df32f03e33e$export$a5eec3a3b03b602f,
    isRecord: $3f9a4df32f03e33e$export$6ba840931da50680,
    get: $3f9a4df32f03e33e$export$3988ae62b71be9a3,
    getIn: $3f9a4df32f03e33e$export$c52e5867d5879e24,
    has: $3f9a4df32f03e33e$export$a4f4bb6b1453fff5,
    hasIn: $3f9a4df32f03e33e$export$d39a4e62499f2a79,
    merge: $3f9a4df32f03e33e$export$4950aa0f605343fb,
    mergeDeep: $3f9a4df32f03e33e$export$dd702b3c8240390c,
    mergeWith: $3f9a4df32f03e33e$export$2ee76fde9ffe109d,
    mergeDeepWith: $3f9a4df32f03e33e$export$aa0aa29a716b1650,
    remove: $3f9a4df32f03e33e$export$cd7f480d6b8286c3,
    removeIn: $3f9a4df32f03e33e$export$b56fa1d8ac1a28ad,
    set: $3f9a4df32f03e33e$export$adaa4cf7ef1b65be,
    setIn: $3f9a4df32f03e33e$export$e6bdf135a54e021b,
    update: $3f9a4df32f03e33e$export$722fbec263ad908a,
    updateIn: $3f9a4df32f03e33e$export$f3e3cd1fc9c33ca1
};
// Note: Iterable is deprecated
var $3f9a4df32f03e33e$export$6936595027d5d5e8 = $3f9a4df32f03e33e$export$fb8073518f34e6ec;
var $3f9a4df32f03e33e$export$2e2bcd8739ae039 = $3f9a4df32f03e33e$var$Immutable;


const $d5a1fd3dea1a0ab6$export$b29f828819edca8d = (list, fn)=>{
    return list.reduce(([left, right], value)=>fn(value) ? [
            left.push(value),
            right
        ] : [
            left,
            right.push(value)
        ], [
        (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
        (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
    ]);
};
const $d5a1fd3dea1a0ab6$export$27a1cb209e3caa11 = (condition, list)=>{
    return condition ? list.reverse() : list;
};
const $d5a1fd3dea1a0ab6$export$91fe4b954385285c = (set, item)=>{
    return set.has(item) ? set.delete(item) : set.add(item);
};
const $d5a1fd3dea1a0ab6$export$7a5825874deea16a = (list)=>{
    return list.get(Math.floor(Math.random() * list.size), list.first());
};
const $d5a1fd3dea1a0ab6$export$f70730c3d1fc524e = (list, fn)=>{
    return (0, $3f9a4df32f03e33e$export$8e8eaa3741ef504c)(list.map((item)=>[
            fn ? fn(item) : item,
            item
        ])).toList();
};
const $d5a1fd3dea1a0ab6$var$cleanString = (str)=>{
    return str.replace("&", "and").replace(/[^a-z0-9]/gi, "").trim().toLowerCase();
};
const $d5a1fd3dea1a0ab6$export$e3340ddcfe22553f = (query, items, nameMapper)=>items.filter((item)=>{
        const itemName = nameMapper(item);
        const cleanSearch = $d5a1fd3dea1a0ab6$var$cleanString(query);
        const cleanItemName = $d5a1fd3dea1a0ab6$var$cleanString(itemName);
        return cleanItemName.includes(cleanSearch) || itemName.includes(cleanSearch) || itemName.includes(query);
    });
const $d5a1fd3dea1a0ab6$export$8e16b83750b44988 = (list)=>{
    return list.filter(Boolean);
};




var $g5BLJ = parcelRequire("g5BLJ");


var $g5BLJ = parcelRequire("g5BLJ");

var $93d7a270b8cc5d7d$exports = {};
"use strict";

$93d7a270b8cc5d7d$exports = (parcelRequire("he7eL"));



var $g5BLJ = parcelRequire("g5BLJ");
var $c282e3068d887fa5$exports = {};
//
$c282e3068d887fa5$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $3806906573aac5d9$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\x00\x00"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\x00");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $3806906573aac5d9$export$2e2bcd8739ae039 = $3806906573aac5d9$var$stylis_min;


var $79b96c7407234d55$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $79b96c7407234d55$export$2e2bcd8739ae039 = $79b96c7407234d55$var$unitlessKeys;


function $8cee133c6682a2e9$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $2696adaeea2f65f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $2696adaeea2f65f6$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $8cee133c6682a2e9$export$2e2bcd8739ae039)(function(prop) {
    return $2696adaeea2f65f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $b2cf63d513978880$exports = {};
"use strict";
var $77f6f957cabc0057$exports = {};
"use strict";

$77f6f957cabc0057$exports = (parcelRequire("kSsR5"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $b2cf63d513978880$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b2cf63d513978880$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b2cf63d513978880$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $b2cf63d513978880$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $b2cf63d513978880$var$TYPE_STATICS = {};
$b2cf63d513978880$var$TYPE_STATICS[$77f6f957cabc0057$exports.ForwardRef] = $b2cf63d513978880$var$FORWARD_REF_STATICS;
$b2cf63d513978880$var$TYPE_STATICS[$77f6f957cabc0057$exports.Memo] = $b2cf63d513978880$var$MEMO_STATICS;
function $b2cf63d513978880$var$getStatics(component) {
    // React v16.11 and below
    if ($77f6f957cabc0057$exports.isMemo(component)) return $b2cf63d513978880$var$MEMO_STATICS;
     // React v16.12 and above
    return $b2cf63d513978880$var$TYPE_STATICS[component["$$typeof"]] || $b2cf63d513978880$var$REACT_STATICS;
}
var $b2cf63d513978880$var$defineProperty = Object.defineProperty;
var $b2cf63d513978880$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b2cf63d513978880$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b2cf63d513978880$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b2cf63d513978880$var$getPrototypeOf = Object.getPrototypeOf;
var $b2cf63d513978880$var$objectPrototype = Object.prototype;
function $b2cf63d513978880$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($b2cf63d513978880$var$objectPrototype) {
            var inheritedComponent = $b2cf63d513978880$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b2cf63d513978880$var$objectPrototype) $b2cf63d513978880$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $b2cf63d513978880$var$getOwnPropertyNames(sourceComponent);
        if ($b2cf63d513978880$var$getOwnPropertySymbols) keys = keys.concat($b2cf63d513978880$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $b2cf63d513978880$var$getStatics(targetComponent);
        var sourceStatics = $b2cf63d513978880$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$b2cf63d513978880$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $b2cf63d513978880$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $b2cf63d513978880$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$b2cf63d513978880$exports = $b2cf63d513978880$var$hoistNonReactStatics;



var $bcIJv = parcelRequire("bcIJv");
function $f2062e8c5c08e6f7$var$y() {
    return ($f2062e8c5c08e6f7$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f2062e8c5c08e6f7$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f2062e8c5c08e6f7$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $93d7a270b8cc5d7d$exports.typeOf)(t);
}, $f2062e8c5c08e6f7$var$S = Object.freeze([]), $f2062e8c5c08e6f7$var$w = Object.freeze({});
function $f2062e8c5c08e6f7$var$E(e) {
    return "function" == typeof e;
}
function $f2062e8c5c08e6f7$var$b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f2062e8c5c08e6f7$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f2062e8c5c08e6f7$var$N = ("undefined" != typeof $bcIJv && void 0 !== $bcIJv.env && undefined, "data-styled"), $f2062e8c5c08e6f7$export$83d89fbfd8236492 = "5.3.11", $f2062e8c5c08e6f7$var$C = "undefined" != typeof window && "HTMLElement" in window, $f2062e8c5c08e6f7$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $bcIJv && void 0 !== $bcIJv.env && false), $f2062e8c5c08e6f7$var$P = {}, $f2062e8c5c08e6f7$var$O = {};
function $f2062e8c5c08e6f7$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f2062e8c5c08e6f7$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f2062e8c5c08e6f7$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f2062e8c5c08e6f7$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f2062e8c5c08e6f7$var$T = new Map, $f2062e8c5c08e6f7$var$x = new Map, $f2062e8c5c08e6f7$var$k = 1, $f2062e8c5c08e6f7$var$V = function(e) {
    if ($f2062e8c5c08e6f7$var$T.has(e)) return $f2062e8c5c08e6f7$var$T.get(e);
    for(; $f2062e8c5c08e6f7$var$x.has($f2062e8c5c08e6f7$var$k);)$f2062e8c5c08e6f7$var$k++;
    var t = $f2062e8c5c08e6f7$var$k++;
    return $f2062e8c5c08e6f7$var$T.set(e, t), $f2062e8c5c08e6f7$var$x.set(t, e), t;
}, $f2062e8c5c08e6f7$var$B = function(e) {
    return $f2062e8c5c08e6f7$var$x.get(e);
}, $f2062e8c5c08e6f7$var$z = function(e, t) {
    t >= $f2062e8c5c08e6f7$var$k && ($f2062e8c5c08e6f7$var$k = t + 1), $f2062e8c5c08e6f7$var$T.set(e, t), $f2062e8c5c08e6f7$var$x.set(t, e);
}, $f2062e8c5c08e6f7$var$M = "style[" + $f2062e8c5c08e6f7$var$N + '][data-styled-version="5.3.11"]', $f2062e8c5c08e6f7$var$G = new RegExp("^" + $f2062e8c5c08e6f7$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f2062e8c5c08e6f7$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f2062e8c5c08e6f7$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f2062e8c5c08e6f7$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f2062e8c5c08e6f7$var$z(u, c), $f2062e8c5c08e6f7$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f2062e8c5c08e6f7$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $f2062e8c5c08e6f7$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f2062e8c5c08e6f7$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f2062e8c5c08e6f7$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $f2062e8c5c08e6f7$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f2062e8c5c08e6f7$var$H = function() {
    function e(e) {
        var t = this.element = $f2062e8c5c08e6f7$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f2062e8c5c08e6f7$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f2062e8c5c08e6f7$var$$ = function() {
    function e(e) {
        var t = this.element = $f2062e8c5c08e6f7$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f2062e8c5c08e6f7$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f2062e8c5c08e6f7$var$U = $f2062e8c5c08e6f7$var$C, $f2062e8c5c08e6f7$var$J = {
    isServer: !$f2062e8c5c08e6f7$var$C,
    useCSSOMInjection: !$f2062e8c5c08e6f7$var$I
}, $f2062e8c5c08e6f7$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f2062e8c5c08e6f7$var$w), void 0 === t && (t = {}), this.options = $f2062e8c5c08e6f7$var$y({}, $f2062e8c5c08e6f7$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f2062e8c5c08e6f7$var$C && $f2062e8c5c08e6f7$var$U && ($f2062e8c5c08e6f7$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($f2062e8c5c08e6f7$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f2062e8c5c08e6f7$var$N) && ($f2062e8c5c08e6f7$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f2062e8c5c08e6f7$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f2062e8c5c08e6f7$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f2062e8c5c08e6f7$var$W(o) : r ? new $f2062e8c5c08e6f7$var$H(o) : new $f2062e8c5c08e6f7$var$$(o), new $f2062e8c5c08e6f7$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f2062e8c5c08e6f7$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f2062e8c5c08e6f7$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f2062e8c5c08e6f7$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f2062e8c5c08e6f7$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f2062e8c5c08e6f7$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f2062e8c5c08e6f7$var$Z = /(a)(d)/gi, $f2062e8c5c08e6f7$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f2062e8c5c08e6f7$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f2062e8c5c08e6f7$var$K(t % 52) + n;
    return ($f2062e8c5c08e6f7$var$K(t % 52) + n).replace($f2062e8c5c08e6f7$var$Z, "$1-$2");
}
var $f2062e8c5c08e6f7$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f2062e8c5c08e6f7$var$te = function(e) {
    return $f2062e8c5c08e6f7$var$ee(5381, e);
};
function $f2062e8c5c08e6f7$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f2062e8c5c08e6f7$var$E(n) && !$f2062e8c5c08e6f7$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f2062e8c5c08e6f7$var$re = $f2062e8c5c08e6f7$var$te("5.3.11"), $f2062e8c5c08e6f7$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f2062e8c5c08e6f7$var$ne(e), this.componentId = t, this.baseHash = $f2062e8c5c08e6f7$var$ee($f2062e8c5c08e6f7$var$re, t), this.baseStyle = n, $f2062e8c5c08e6f7$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f2062e8c5c08e6f7$var$_e(this.rules, e, t, n).join(""), i = $f2062e8c5c08e6f7$var$Q($f2062e8c5c08e6f7$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f2062e8c5c08e6f7$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f2062e8c5c08e6f7$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f2062e8c5c08e6f7$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f2062e8c5c08e6f7$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f2062e8c5c08e6f7$var$se = /^\s*\/\/.*$/gm, $f2062e8c5c08e6f7$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $f2062e8c5c08e6f7$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $f2062e8c5c08e6f7$var$w : e, i = s.options, a = void 0 === i ? $f2062e8c5c08e6f7$var$w : i, c = s.plugins, u = void 0 === c ? $f2062e8c5c08e6f7$var$S : c, l = new (0, $3806906573aac5d9$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f2062e8c5c08e6f7$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f2062e8c5c08e6f7$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f2062e8c5c08e6f7$var$D(15), $f2062e8c5c08e6f7$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $f2062e8c5c08e6f7$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createContext(), $f2062e8c5c08e6f7$export$91317688fc694efa = $f2062e8c5c08e6f7$export$8c190ef828af4c86.Consumer, $f2062e8c5c08e6f7$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createContext(), $f2062e8c5c08e6f7$var$de = ($f2062e8c5c08e6f7$var$le.Consumer, new $f2062e8c5c08e6f7$var$X), $f2062e8c5c08e6f7$var$he = $f2062e8c5c08e6f7$var$ae();
function $f2062e8c5c08e6f7$var$pe() {
    return (0, $g5BLJ.useContext)($f2062e8c5c08e6f7$export$8c190ef828af4c86) || $f2062e8c5c08e6f7$var$de;
}
function $f2062e8c5c08e6f7$var$fe() {
    return (0, $g5BLJ.useContext)($f2062e8c5c08e6f7$var$le) || $f2062e8c5c08e6f7$var$he;
}
function $f2062e8c5c08e6f7$export$a473771da2f0ff7c(e) {
    var t = (0, $g5BLJ.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f2062e8c5c08e6f7$var$pe(), u = (0, $g5BLJ.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $g5BLJ.useMemo)(function() {
        return $f2062e8c5c08e6f7$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $g5BLJ.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($c282e3068d887fa5$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($f2062e8c5c08e6f7$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($f2062e8c5c08e6f7$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $f2062e8c5c08e6f7$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f2062e8c5c08e6f7$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f2062e8c5c08e6f7$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f2062e8c5c08e6f7$var$he), this.name + e.hash;
    }, e;
}(), $f2062e8c5c08e6f7$var$ve = /([A-Z])/, $f2062e8c5c08e6f7$var$ge = /([A-Z])/g, $f2062e8c5c08e6f7$var$Se = /^ms-/, $f2062e8c5c08e6f7$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $f2062e8c5c08e6f7$var$Ee(e) {
    return $f2062e8c5c08e6f7$var$ve.test(e) ? e.replace($f2062e8c5c08e6f7$var$ge, $f2062e8c5c08e6f7$var$we).replace($f2062e8c5c08e6f7$var$Se, "-ms-") : e;
}
var $f2062e8c5c08e6f7$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f2062e8c5c08e6f7$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f2062e8c5c08e6f7$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f2062e8c5c08e6f7$var$be(e)) return "";
    if ($f2062e8c5c08e6f7$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f2062e8c5c08e6f7$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f2062e8c5c08e6f7$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $f2062e8c5c08e6f7$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $f2062e8c5c08e6f7$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f2062e8c5c08e6f7$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f2062e8c5c08e6f7$var$E(t[i]) ? s.push($f2062e8c5c08e6f7$var$Ee(i) + ":", t[i], ";") : $f2062e8c5c08e6f7$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f2062e8c5c08e6f7$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $79b96c7407234d55$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f2062e8c5c08e6f7$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f2062e8c5c08e6f7$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f2062e8c5c08e6f7$var$E(e) || $f2062e8c5c08e6f7$var$g(e) ? $f2062e8c5c08e6f7$var$Ne($f2062e8c5c08e6f7$var$_e($f2062e8c5c08e6f7$var$v($f2062e8c5c08e6f7$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f2062e8c5c08e6f7$var$Ne($f2062e8c5c08e6f7$var$_e($f2062e8c5c08e6f7$var$v(e, n)));
}
var $f2062e8c5c08e6f7$var$Ce = /invalid hook call/i, $f2062e8c5c08e6f7$var$Ie = new Set, $f2062e8c5c08e6f7$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $f2062e8c5c08e6f7$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $f2062e8c5c08e6f7$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $f2062e8c5c08e6f7$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f2062e8c5c08e6f7$var$De = /(^-|-$)/g;
function $f2062e8c5c08e6f7$var$je(e) {
    return e.replace($f2062e8c5c08e6f7$var$Re, "-").replace($f2062e8c5c08e6f7$var$De, "");
}
var $f2062e8c5c08e6f7$var$Te = function(e) {
    return $f2062e8c5c08e6f7$var$Q($f2062e8c5c08e6f7$var$te(e) >>> 0);
};
function $f2062e8c5c08e6f7$var$xe(e) {
    return "string" == typeof e && true;
}
var $f2062e8c5c08e6f7$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f2062e8c5c08e6f7$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f2062e8c5c08e6f7$var$Be(e, t, n) {
    var r = e[n];
    $f2062e8c5c08e6f7$var$ke(t) && $f2062e8c5c08e6f7$var$ke(r) ? $f2062e8c5c08e6f7$var$ze(r, t) : e[n] = t;
}
function $f2062e8c5c08e6f7$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f2062e8c5c08e6f7$var$ke(i)) for(var a in i)$f2062e8c5c08e6f7$var$Ve(a) && $f2062e8c5c08e6f7$var$Be(e, i[a], a);
    }
    return e;
}
var $f2062e8c5c08e6f7$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createContext(), $f2062e8c5c08e6f7$export$b631efc24e9d5e2f = $f2062e8c5c08e6f7$export$2c657da244d00bd6.Consumer;
function $f2062e8c5c08e6f7$export$d8964aec282183a3(e) {
    var t = (0, $g5BLJ.useContext)($f2062e8c5c08e6f7$export$2c657da244d00bd6), n = (0, $g5BLJ.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f2062e8c5c08e6f7$var$D(14);
            if ($f2062e8c5c08e6f7$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f2062e8c5c08e6f7$var$D(8) : t ? $f2062e8c5c08e6f7$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($f2062e8c5c08e6f7$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f2062e8c5c08e6f7$var$Fe = {};
function $f2062e8c5c08e6f7$var$Ye(e, t, n) {
    var o = $f2062e8c5c08e6f7$export$7ba318d8d2f06c76(e), i = !$f2062e8c5c08e6f7$var$xe(e), a = t.attrs, c = void 0 === a ? $f2062e8c5c08e6f7$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f2062e8c5c08e6f7$var$je(e);
        $f2062e8c5c08e6f7$var$Fe[n] = ($f2062e8c5c08e6f7$var$Fe[n] || 0) + 1;
        var r = n + "-" + $f2062e8c5c08e6f7$var$Te("5.3.11" + n + $f2062e8c5c08e6f7$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $f2062e8c5c08e6f7$var$xe(e) ? "styled." + e : "Styled(" + $f2062e8c5c08e6f7$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $f2062e8c5c08e6f7$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $f2062e8c5c08e6f7$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $f2062e8c5c08e6f7$var$w);
                var r = $f2062e8c5c08e6f7$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f2062e8c5c08e6f7$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f2062e8c5c08e6f7$var$Oe(t, (0, $g5BLJ.useContext)($f2062e8c5c08e6f7$export$2c657da244d00bd6), a) || $f2062e8c5c08e6f7$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $f2062e8c5c08e6f7$var$pe(), s = $f2062e8c5c08e6f7$var$fe(), i = t ? e.generateAndInjectStyles($f2062e8c5c08e6f7$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $f2062e8c5c08e6f7$var$xe(b), N = v !== t ? $f2062e8c5c08e6f7$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $2696adaeea2f65f6$export$2e2bcd8739ae039), b) : !_ || (0, $2696adaeea2f65f6$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $f2062e8c5c08e6f7$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $g5BLJ.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f2062e8c5c08e6f7$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f2062e8c5c08e6f7$var$xe(e) ? e : $f2062e8c5c08e6f7$var$je($f2062e8c5c08e6f7$var$b(e)));
        return $f2062e8c5c08e6f7$var$Ye(e, $f2062e8c5c08e6f7$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f2062e8c5c08e6f7$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($b2cf63d513978880$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $f2062e8c5c08e6f7$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f2062e8c5c08e6f7$var$w), !(0, $93d7a270b8cc5d7d$exports.isValidElementType)(r)) return $f2062e8c5c08e6f7$var$D(1, String(r));
        var s = function() {
            return t(r, o, $f2062e8c5c08e6f7$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f2062e8c5c08e6f7$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f2062e8c5c08e6f7$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f2062e8c5c08e6f7$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f2062e8c5c08e6f7$var$qe[e] = $f2062e8c5c08e6f7$var$qe(e);
});
var $f2062e8c5c08e6f7$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f2062e8c5c08e6f7$var$ne(e), $f2062e8c5c08e6f7$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f2062e8c5c08e6f7$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f2062e8c5c08e6f7$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f2062e8c5c08e6f7$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f2062e8c5c08e6f7$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f2062e8c5c08e6f7$var$Te(JSON.stringify(i)), u = new $f2062e8c5c08e6f7$var$He(i, a);
    function d(e) {
        var t = $f2062e8c5c08e6f7$var$pe(), n = $f2062e8c5c08e6f7$var$fe(), o = (0, $g5BLJ.useContext)($f2062e8c5c08e6f7$export$2c657da244d00bd6), d = (0, $g5BLJ.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $g5BLJ.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f2062e8c5c08e6f7$var$P, n, o);
        else {
            var s = $f2062e8c5c08e6f7$var$y({}, t, {
                theme: $f2062e8c5c08e6f7$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo(d);
}
function $f2062e8c5c08e6f7$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f2062e8c5c08e6f7$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f2062e8c5c08e6f7$var$Te(o);
    return new $f2062e8c5c08e6f7$var$ye(s, o);
}
var $f2062e8c5c08e6f7$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f2062e8c5c08e6f7$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f2062e8c5c08e6f7$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f2062e8c5c08e6f7$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f2062e8c5c08e6f7$var$D(2);
            var n = ((t = {})[$f2062e8c5c08e6f7$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f2062e8c5c08e6f7$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement("style", $f2062e8c5c08e6f7$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f2062e8c5c08e6f7$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f2062e8c5c08e6f7$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($f2062e8c5c08e6f7$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f2062e8c5c08e6f7$var$D(3);
    }, e;
}(), $f2062e8c5c08e6f7$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).forwardRef(function(t, n) {
        var o = (0, $g5BLJ.useContext)($f2062e8c5c08e6f7$export$2c657da244d00bd6), i = e.defaultProps, a = $f2062e8c5c08e6f7$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement(e, $f2062e8c5c08e6f7$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($b2cf63d513978880$exports)))(t, e), t.displayName = "WithTheme(" + $f2062e8c5c08e6f7$var$b(e) + ")", t;
}, $f2062e8c5c08e6f7$export$93d4e7f90805808f = function() {
    return (0, $g5BLJ.useContext)($f2062e8c5c08e6f7$export$2c657da244d00bd6);
}, $f2062e8c5c08e6f7$export$5c87cfe6c475f500 = {
    StyleSheet: $f2062e8c5c08e6f7$var$X,
    masterSheet: $f2062e8c5c08e6f7$var$de
};
var $f2062e8c5c08e6f7$export$2e2bcd8739ae039 = $f2062e8c5c08e6f7$var$qe;



const $24b764039c44d1ec$var$hexToRgb = (baseHex)=>{
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    const hex = baseHex.length === 4 ? `#${baseHex.charAt(1)}${baseHex.charAt(1)}${baseHex.charAt(2)}${baseHex.charAt(2)}${baseHex.charAt(3)}${baseHex.charAt(3)}` : baseHex;
    if (hex.length !== 7) throw new Error(`Invalid hex code: ${baseHex}`);
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);
    return {
        r: r,
        g: g,
        b: b
    };
};
const $24b764039c44d1ec$var$constrainBase16 = (value)=>{
    return Math.min(Math.max(0, Math.round(value)), 255);
};
const $24b764039c44d1ec$var$rgbToHex = ({ r: r , g: g , b: b  })=>{
    const toHex = (value)=>$24b764039c44d1ec$var$constrainBase16(value).toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
const $24b764039c44d1ec$var$applyTransformation = (hex, fn)=>{
    const { r: r , g: g , b: b  } = $24b764039c44d1ec$var$hexToRgb(hex);
    return $24b764039c44d1ec$var$rgbToHex({
        r: fn(r, "r"),
        g: fn(g, "g"),
        b: fn(b, "b")
    });
};
const $24b764039c44d1ec$export$4b073707ff63303 = (hex, percentAmount)=>{
    const decimal = (0 - percentAmount) / 100;
    return $24b764039c44d1ec$var$applyTransformation(hex, (value)=>value + 255 * decimal);
};
const $24b764039c44d1ec$export$c0816ed86df316af = (hex, percentAmount)=>{
    const decimal = percentAmount / 100;
    return $24b764039c44d1ec$var$applyTransformation(hex, (value)=>value + 255 * decimal);
};
const $24b764039c44d1ec$export$4e46ac54fc82cf3b = (hex, opacity)=>{
    const { r: r , g: g , b: b  } = $24b764039c44d1ec$var$hexToRgb(hex);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
const $24b764039c44d1ec$export$2f3d5b568ae6b3c1 = {
    white: "#FFFFFF",
    black: "#000000",
    gray1: "#F7F7F7",
    gray2: "#ececec",
    gray3: "#ebebf8",
    gray4: "#CFCFCF",
    gray5: "#A6ABB6",
    gray6: "#888C94",
    gray7: "#666666",
    lightBlue: "#CDDEF6",
    primaryBlue: "#325FFF",
    readleeBlue: "#2033DF",
    paperBlue: "#0E0FE0",
    green: "#00D863",
    success: "#219653",
    danger: "#F40000",
    warning: "#F5B23E",
    backgroundDark: "#021B47",
    backgroundLight: "#F6F8FC",
    backgroundLightText: "#2B2B2B"
};
const $24b764039c44d1ec$export$8f45430ccf837300 = {
    white: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white,
        disabled: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray5,
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.white, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundLightText
    },
    black: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black,
        disabled: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray7,
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.black, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    gray1: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray1,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray1, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray1, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    gray2: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray2,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray2, 15),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray2, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    gray3: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray3,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray3, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray3, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    gray4: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray4,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray4, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray4, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    gray5: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray5,
        disabled: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray5, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray5, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    gray6: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray6,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray6, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray6, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    gray7: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray7,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray7, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.gray7, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    lightBlue: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.lightBlue,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.lightBlue, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.lightBlue, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    primaryBlue: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.primaryBlue,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.primaryBlue, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.primaryBlue, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    readleeBlue: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.readleeBlue,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.readleeBlue, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.readleeBlue, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    paperBlue: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.paperBlue,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.paperBlue, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.paperBlue, 20),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    green: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.green,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.green, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.green, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    success: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.success,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.success, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.success, 20),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    danger: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.danger,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.danger, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.danger, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    warning: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.warning,
        disabled: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.warning,
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.warning, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.black
    },
    backgroundDark: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundDark,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundDark, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundDark, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.white
    },
    backgroundLight: {
        hex: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundLight,
        disabled: $24b764039c44d1ec$export$c0816ed86df316af($24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundLight, 25),
        active: $24b764039c44d1ec$export$4b073707ff63303($24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundLight, 10),
        text: $24b764039c44d1ec$export$2f3d5b568ae6b3c1.backgroundLightText
    }
};
const $24b764039c44d1ec$var$colorHexes = Object.values($24b764039c44d1ec$export$2f3d5b568ae6b3c1);
const $24b764039c44d1ec$export$40792c0fcdd2bbbd = [
    "#30BC35",
    "#581828",
    "#6F2486",
    "#767BDC",
    "#BCBD4C",
    "#E25C4A",
    "#FA1CE8"
];
const $24b764039c44d1ec$export$803ec3cef06b0273 = [
    "#E4EEEB",
    "#E5FCE8",
    "#E6EFF3",
    "#E6F4FC",
    "#E8F1F8",
    "#E8F4F7",
    "#E8FAF4",
    "#EDE8E6",
    "#EDEAED",
    "#F0EDF7",
    "#F0F8FA",
    "#F0FBE5",
    "#F2F3F7",
    "#F3FCEF",
    "#F6EEEC",
    "#F9F2F0",
    "#FAEEE4",
    "#FBE8E5",
    "#FCF1FA",
    "#FCF2E6"
];
const $24b764039c44d1ec$export$1c7a2172b1da4dcc = [
    "#7339AB",
    "#625AD8",
    "#1F9CE4",
    "#88F4FF"
];
const $24b764039c44d1ec$export$cae13e90592f246a = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Color__ColorSwatch",
    componentId: "sc-1wyx1tg-0"
})([
    "background:",
    ";border:1px solid black;height:140px;width:140px;"
], ({ $color: $color  })=>$24b764039c44d1ec$export$8f45430ccf837300[$color].hex);


const $18ffa0398cff6303$export$22ea553521eefdfc = 14;
const $18ffa0398cff6303$export$248ca8ad75446707 = 4;
const $18ffa0398cff6303$export$66be51d536890fa7 = {
    none: "0px",
    quarter: `${$18ffa0398cff6303$export$248ca8ad75446707 / 4}px`,
    half: `${$18ffa0398cff6303$export$248ca8ad75446707 / 2}px`,
    1: `${$18ffa0398cff6303$export$248ca8ad75446707}px`,
    2: `${2 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    3: `${3 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    4: `${4 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    5: `${5 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    6: `${6 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    7: `${7 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    8: `${8 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    9: `${9 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    10: `${10 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    11: `${11 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    12: `${12 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    13: `${13 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    14: `${14 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    15: `${15 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    16: `${16 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    17: `${17 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    18: `${18 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    19: `${19 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    20: `${20 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    21: `${21 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    22: `${22 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    23: `${23 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    32: `${32 * $18ffa0398cff6303$export$248ca8ad75446707}px`,
    75: `${75 * $18ffa0398cff6303$export$248ca8ad75446707}px`
};
const $18ffa0398cff6303$export$c8e071c719aa4251 = 0.4;
const $18ffa0398cff6303$export$c68d31c234787f72 = "600px";
const $18ffa0398cff6303$export$4bd51deb3e0b36b1 = (cssName, value, defaultValue)=>{
    const realValue = value || value === 0 ? value : defaultValue;
    return Boolean(realValue) || realValue === 0 ? `${cssName}: ${realValue};` : "";
};
const $18ffa0398cff6303$export$67799b413b1b10d7 = (cssName, value, defaultValue)=>Boolean(value) || Boolean(defaultValue) ? `${cssName}: ${value || defaultValue};` : "";
const $18ffa0398cff6303$export$cb290e6c0fd3cb2e = (cssName, value, booleanCheck)=>booleanCheck ? `${cssName}: ${value};` : "";



const $66d768ad338179b8$export$c6a3dd61111e2ebc = {
    ...(0, $18ffa0398cff6303$export$66be51d536890fa7),
    input: (0, $18ffa0398cff6303$export$66be51d536890fa7)[2],
    rounded: `${10000000}px`
};



const $8259eb090983b778$export$ea413736286a3bf1 = {
    ...(0, $18ffa0398cff6303$export$66be51d536890fa7)
};



const $0c729dd84fb3d3fd$export$450f8a5aaf0e893d = {
    ...(0, $18ffa0398cff6303$export$66be51d536890fa7)
};


// You can uncomment font weights here and in reset.scss to enable more
const $e0d2d68dbe5b8d1d$export$59230918eb9bd861 = {
    // extralight: '300',
    // light: '300',
    // regular: '400',
    default: "500",
    medium: "500",
    semibold: "600",
    bold: "700"
};



var $eYBdv = parcelRequire("eYBdv");

var $g5BLJ = parcelRequire("g5BLJ");
const $4fd3b1c7dfff02ca$export$d07517a676ce386f = {
    mobileSmall: 360,
    mobileMed: 380,
    // Iphone 6/7/8+
    mobileLarge: 415,
    tabletSmall: 760,
    tablet: 930,
    desktopSmall: 1100,
    desktop: 1280
};
const $4fd3b1c7dfff02ca$var$RESIZE_THROTTLE_TIMEOUT = 50;
const $4fd3b1c7dfff02ca$export$42c02f33970a2afa = ({ throttleTimeout: throttleTimeout = $4fd3b1c7dfff02ca$var$RESIZE_THROTTLE_TIMEOUT  } = {})=>{
    const [windowSize, setWindowSize] = (0, $g5BLJ.useState)({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const windowSizeRef = (0, $g5BLJ.useRef)(windowSize);
    (0, $g5BLJ.useEffect)(()=>{
        const handleResize = (0, $eYBdv.throttle)(()=>{
            if (window.innerWidth !== windowSizeRef.current.width || window.innerHeight !== windowSizeRef.current.height) {
                const newWindowSize = {
                    width: window.innerWidth,
                    height: window.innerHeight
                };
                windowSizeRef.current = newWindowSize;
                setWindowSize(newWindowSize);
            }
        }, throttleTimeout);
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        throttleTimeout
    ]);
    return windowSize;
};
const $4fd3b1c7dfff02ca$export$e818ed21e924bde4 = ({ largerThan: largerThan , largerThanOrEqualTo: largerThanOrEqualTo , smallerThan: smallerThan , smallerThanOrEqualTo: smallerThanOrEqualTo  } = {})=>{
    const windowWidth = $4fd3b1c7dfff02ca$export$42c02f33970a2afa().width;
    let result = true;
    if (largerThan) result = result && windowWidth > $4fd3b1c7dfff02ca$export$d07517a676ce386f[largerThan];
    if (largerThanOrEqualTo) result = result && windowWidth >= $4fd3b1c7dfff02ca$export$d07517a676ce386f[largerThanOrEqualTo];
    if (smallerThan) result = result && windowWidth < $4fd3b1c7dfff02ca$export$d07517a676ce386f[smallerThan];
    if (smallerThanOrEqualTo) result = result && windowWidth <= $4fd3b1c7dfff02ca$export$d07517a676ce386f[smallerThanOrEqualTo];
    return result;
};


const $d65f64e8cabd56af$export$147720d44c0eeb27 = {
    standard: "0px 4px 11px rgba(0, 0, 0, 0.3)"
};


const $9f83aa035e9f8cbe$export$a01878c2d95345c0 = {
    normal: 0,
    raised: 1,
    modal: 2,
    toast: 3,
    dropdown: 4,
    tooltip: 5
};




const $8abe0a260c183813$var$noSpinnerStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "-moz-appearance:textfield;::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}"
]);
const $8abe0a260c183813$var$baseInputStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "outline:0;",
    ""
], (props)=>props.$noSpinner ? $8abe0a260c183813$var$noSpinnerStyles : "");
const $8abe0a260c183813$export$3eeb47dc8e6249d9 = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " width:100%;font-size:16px;padding:",
    " ",
    ";background:",
    ";border:1px solid ",
    ";border-radius:",
    ";height:44px;flex-grow:",
    ";"
], $8abe0a260c183813$var$baseInputStyles, (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (props)=>props.disabled ? (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).input, (props)=>props.$flexGrow);
const $8abe0a260c183813$export$e91d5091f3ae5c0 = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " display:inline;font-size:",
    "px;font-weight:",
    ";line-height:150%;padding:",
    " ",
    ";background:",
    ";border:0;align-self:flex-start;flex-grow:",
    ";::placeholder{color:",
    ";}"
], $8abe0a260c183813$var$baseInputStyles, ({ $fontSize: $fontSize = 14  })=>$fontSize, (0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861).medium, (0, $8259eb090983b778$export$ea413736286a3bf1)[1], (0, $8259eb090983b778$export$ea413736286a3bf1).none, (props)=>props.disabled ? (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex : "transparent", (props)=>props.$flexGrow, (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex);
const $8abe0a260c183813$var$sidebarStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " background:transparent;border:0;font-size:18px;font-weight:bold;color:",
    ";max-width:100%;flex-grow:",
    ";option{color:initial;}option:disabled{color:",
    ";}"
], $8abe0a260c183813$var$baseInputStyles, (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (props)=>props.$flexGrow, (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex);
const $8abe0a260c183813$export$a195049fd73b3fe2 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).input.withConfig({
    displayName: "InputHelpers__StyledInput",
    componentId: "sc-1rkl9x0-0"
})([
    "",
    ""
], ({ $displayType: $displayType  })=>{
    if ($displayType === "flat") return $8abe0a260c183813$export$e91d5091f3ae5c0;
    else if ($displayType === "sidebar") return $8abe0a260c183813$var$sidebarStyles;
    else return $8abe0a260c183813$export$3eeb47dc8e6249d9;
});


const $f8129efc3cc4d35c$export$f5b8910cec6cf069 = ({ onChange: onChange , disabled: disabled , icon: icon , innerRef: innerRef , flexGrow: flexGrow , fontSize: fontSize , iconPosition: iconPosition = "left" , ...basicProps })=>{
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>onChange(event.target.value, event), [
        onChange
    ]);
    return icon ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            iconPosition === "left" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: icon,
                        size: "1.5em"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8abe0a260c183813$export$a195049fd73b3fe2), {
                ...basicProps,
                disabled: disabled,
                onChange: realOnChange,
                $displayType: "flat",
                $fontSize: fontSize,
                ref: innerRef,
                $flexGrow: flexGrow
            }),
            iconPosition === "right" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: icon,
                        size: "1.5em"
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8abe0a260c183813$export$a195049fd73b3fe2), {
        ...basicProps,
        "data-test-tag": basicProps.testTag,
        disabled: disabled,
        onChange: realOnChange,
        ref: innerRef
    });
};





var $g5BLJ = parcelRequire("g5BLJ");



var $g5BLJ = parcelRequire("g5BLJ");
let $dd8c6a85a004ead6$var$currentUniqueId = 0;
const $dd8c6a85a004ead6$export$aa1a1894961eafab = ()=>{
    $dd8c6a85a004ead6$var$currentUniqueId += 1;
    return $dd8c6a85a004ead6$var$currentUniqueId;
};
const $dd8c6a85a004ead6$export$c485849f2e393253 = (originalId)=>{
    return (0, $g5BLJ.useMemo)(()=>originalId || `unique-elem-${$dd8c6a85a004ead6$export$aa1a1894961eafab()}`, [
        originalId
    ]);
};




var $g5BLJ = parcelRequire("g5BLJ");

const $7ffd711af926678d$export$20b9b571b379d631 = (startElement, fn)=>{
    if (fn(startElement)) return startElement;
    if (!startElement.parentElement || startElement.parentElement === startElement) return null;
    return $7ffd711af926678d$export$20b9b571b379d631(startElement.parentElement, fn);
};
const $7ffd711af926678d$export$b1db755df1284766 = (element, eventType, fn)=>{
    const current = element.parentElement;
    if (!current) return;
    current.addEventListener(eventType, fn);
    $7ffd711af926678d$export$b1db755df1284766(current, eventType, fn);
};
const $7ffd711af926678d$export$c2d4ecb2b67248a1 = (element, eventType, fn)=>{
    const current = element.parentElement;
    if (!current) return;
    current.removeEventListener(eventType, fn);
    $7ffd711af926678d$export$c2d4ecb2b67248a1(current, eventType, fn);
};
const $7ffd711af926678d$export$2cc93841edf1bfc3 = (event)=>{
    const files = [];
    if (event.dataTransfer.items) {
        for (const item of Array.from(event.dataTransfer.items))if (item.kind === "file") {
            const file = item.getAsFile();
            if (file) files.push(file);
        }
    } else for (const file of Array.from(event.dataTransfer.files))files.push(file);
    return (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(files);
};
const $7ffd711af926678d$export$27b6b5680688208b = (id, onExternalClickFn)=>{
    (0, $g5BLJ.useEffect)(()=>{
        if (!onExternalClickFn) return;
        const listener = (event)=>{
            const elem = event.target;
            if ($7ffd711af926678d$export$20b9b571b379d631(elem, (elem)=>id === elem.id)) return;
            onExternalClickFn();
        };
        document.addEventListener("click", listener);
        return ()=>{
            document.removeEventListener("click", listener);
        };
    }, [
        id,
        onExternalClickFn
    ]);
};


const $f4e423d3be2b137f$var$StyledFileInput = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).input.withConfig({
    displayName: "FileInput__StyledFileInput",
    componentId: "sc-va7d17-0"
})([
    "display:none;"
]);
const $f4e423d3be2b137f$var$mainStyleCss = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "width:",
    ";height:",
    ";background:",
    ";border:1px dashed ",
    ";padding:",
    ";&:hover{background:",
    ";}"
], ({ $kind: $kind  })=>$kind === "smallDropArea" ? "100%" : "500px", ({ $kind: $kind  })=>$kind === "smallDropArea" ? "200px" : "380px", ({ $draggedOver: $draggedOver  })=>$draggedOver ? (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.active : (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.active);
const $f4e423d3be2b137f$var$imageOnlyCss = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "height:115px;aspect-ratio:4/5;",
    ""
], ({ $kind: $kind  })=>{
    if ($kind === "lightImagePreview") return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "background:",
        ";border:1px dashed ",
        ";&:hover{",
        ";}"
    ], ({ $draggedOver: $draggedOver  })=>(0, $24b764039c44d1ec$export$8f45430ccf837300).white[$draggedOver ? "active" : "hex"], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex, ({ $disabled: $disabled , $hoverable: $hoverable  })=>(0, $18ffa0398cff6303$export$cb290e6c0fd3cb2e)("background", (0, $24b764039c44d1ec$export$8f45430ccf837300).white.active, !$disabled && $hoverable));
    else return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "background:",
        ";&:hover{",
        ";}"
    ], ({ $draggedOver: $draggedOver  })=>(0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, $draggedOver ? 0.2 : 0.1), ({ $disabled: $disabled , $hoverable: $hoverable  })=>(0, $18ffa0398cff6303$export$cb290e6c0fd3cb2e)("background", (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, 0.2), !$disabled && $hoverable));
});
const $f4e423d3be2b137f$var$InputContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).label.withConfig({
    displayName: "FileInput__InputContainer",
    componentId: "sc-va7d17-1"
})([
    "",
    ";border-radius:",
    ";",
    ""
], ({ $disabled: $disabled  })=>(0, $18ffa0398cff6303$export$cb290e6c0fd3cb2e)("cursor", "pointer", !$disabled), (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], ({ $imageOnly: $imageOnly  })=>$imageOnly ? $f4e423d3be2b137f$var$imageOnlyCss : $f4e423d3be2b137f$var$mainStyleCss);
const $f4e423d3be2b137f$export$1a70833be8058260 = {
    pdf: ".pdf,application/pdf",
    epub: ".epub,application/epub+zip",
    image: "image/*",
    audio: "audio/*",
    video: "video/*"
};
const $f4e423d3be2b137f$var$fileTypeNames = {
    pdf: "PDF",
    epub: "EPUB",
    image: "image",
    audio: "audio",
    video: "video"
};
const $f4e423d3be2b137f$export$b57af79a4ab2a1c6 = ({ id: id , onChange: onChange , disabled: disabled = false , value: value , accept: accept , uploading: uploading = false , errors: errors , name: name , testTag: testTag , uploadedFile: uploadedFile , iconColor: iconColor = "white" , kind: kind = "dropArea"  })=>{
    const inputContainerId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    const inputId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)(id);
    const hiddenFileInput = (0, $g5BLJ.useRef)(null);
    const [draggedOver, setDraggedOver] = (0, $g5BLJ.useState)(false);
    const dragOverIndexRef = (0, $g5BLJ.useRef)(0);
    const onDragOver = (0, $g5BLJ.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onDrop = (0, $g5BLJ.useCallback)((event)=>{
        event.preventDefault();
        const files = (0, $7ffd711af926678d$export$2cc93841edf1bfc3)(event);
        if (files.size > 0) onChange(files, event);
        setDraggedOver(false);
    }, [
        onChange
    ]);
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>{
        const fileList = event.target.files;
        const files = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(fileList ?? []);
        onChange(files, event);
    }, [
        onChange
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (hiddenFileInput.current && value.isEmpty()) hiddenFileInput.current.value = "";
    }, [
        value
    ]);
    const imageUrl = (0, $g5BLJ.useMemo)(()=>accept === "image" && value.first() ? URL.createObjectURL(value.first()) : undefined, [
        value,
        accept
    ]);
    const onDragEnter = (0, $g5BLJ.useCallback)(()=>{
        setDraggedOver(true);
        dragOverIndexRef.current += 1;
    }, []);
    const onDragLeave = (0, $g5BLJ.useCallback)(()=>{
        dragOverIndexRef.current -= 1;
        if (dragOverIndexRef.current <= 0) setDraggedOver(false);
    }, []);
    const onDragEnd = (0, $g5BLJ.useCallback)(()=>{
        dragOverIndexRef.current = 0;
        setDraggedOver(false);
    }, []);
    const imageMode = [
        "imagePreview",
        "lightImagePreview"
    ].includes(kind);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f4e423d3be2b137f$var$InputContainer, {
                id: inputContainerId,
                htmlFor: inputId,
                $imageOnly: accept === "image",
                $draggedOver: draggedOver,
                onDragOver: onDragOver,
                onDrop: onDrop,
                onDragEnter: onDragEnter,
                onDragLeave: onDragLeave,
                onDragEnd: onDragEnd,
                $disabled: disabled,
                $kind: kind,
                $hoverable: imageMode && Boolean(!imageUrl && !uploadedFile),
                children: imageMode ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        (imageUrl || uploadedFile) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$1cd1efc78cb52ca5), {
                            src: imageUrl || uploadedFile?.url || "",
                            testTag: testTag,
                            size: "medium"
                        }),
                        !uploading && !imageUrl && !uploadedFile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "center",
                            align: "center",
                            width: "100%",
                            height: "100%",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                color: iconColor,
                                icon: "upload",
                                size: "3em"
                            })
                        }),
                        uploading && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                            flex: true
                        })
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    align: "center",
                    justify: "center",
                    height: "100%",
                    width: "100%",
                    padding: kind === "smallDropArea" ? "16px" : undefined,
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            color: "primaryBlue",
                            icon: "upload",
                            size: "3em"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: kind === "smallDropArea" ? 2 : 5
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h6",
                            textAlign: "center",
                            color: "gray5",
                            weightOverride: "medium",
                            children: value.isEmpty() && !uploadedFile || uploading ? `Click or drag and drop to upload your file ${accept ? `in ${$f4e423d3be2b137f$var$fileTypeNames[accept]} format` : ""}` : "Success! Your file has been uploaded"
                        }),
                        uploading && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: kind === "smallDropArea" ? 2 : 5
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    textAlign: "center",
                                    color: "gray5",
                                    weightOverride: "medium",
                                    children: "Uploading..."
                                })
                            ]
                        }),
                        errors && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: kind === "smallDropArea" ? 2 : 5
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                                    errors: errors,
                                    errorKey: name
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f4e423d3be2b137f$var$StyledFileInput, {
                id: inputId,
                disabled: disabled,
                onChange: realOnChange,
                type: "file",
                accept: accept && $f4e423d3be2b137f$export$1a70833be8058260[accept],
                ref: hiddenFileInput,
                "data-test-tag": testTag
            })
        ]
    });
};





var $g5BLJ = parcelRequire("g5BLJ");
const $f15bed412edb7f78$export$7d15b64cf5a3a4c4 = ({ min: min , max: max , value: value  })=>{
    const ceilinged = typeof max === "number" ? Math.min(max, value) : value;
    const floored = typeof min === "number" ? Math.max(min, ceilinged) : ceilinged;
    return floored;
};
const $f15bed412edb7f78$export$7978a6ddf29f4374 = (num, decimals)=>{
    const change = 10 ** decimals;
    return Math.round(num * change) / change;
};



const $8d52bbd6b178f533$export$6bf0cd3a219bbade = ({ onChange: onChange , value: value , min: min , max: max , testTag: testTag , noSpinner: noSpinner , integerOnly: integerOnly = false , ...basicProps })=>{
    const numberValueRef = (0, $g5BLJ.useRef)(value);
    const [stringValue, setStringValue] = (0, $g5BLJ.useState)(String(value));
    (0, $g5BLJ.useEffect)(()=>{
        if (typeof value === "number" && value !== numberValueRef.current) {
            numberValueRef.current = value;
            setStringValue(String(value));
        }
    }, [
        value
    ]);
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>{
        const baseStringValue = event.target.value;
        const baseNumberValue = integerOnly ? parseInt(baseStringValue, 10) : parseFloat(baseStringValue);
        const newNumberValue = Number.isNaN(baseNumberValue) ? null : (0, $f15bed412edb7f78$export$7d15b64cf5a3a4c4)({
            value: baseNumberValue,
            min: min,
            max: max
        });
        numberValueRef.current = newNumberValue;
        const newStringValue = typeof newNumberValue === "number" && newNumberValue !== baseNumberValue ? String(newNumberValue) : baseStringValue;
        setStringValue(newStringValue);
        onChange(numberValueRef.current, newStringValue, event);
    }, [
        onChange,
        min,
        max,
        integerOnly
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8abe0a260c183813$export$a195049fd73b3fe2), {
        ...basicProps,
        $noSpinner: noSpinner,
        type: "number",
        value: stringValue,
        onChange: realOnChange,
        onKeyDown: (event)=>event.stopPropagation(),
        min: min,
        max: max,
        "data-test-tag": testTag
    });
};




var $g5BLJ = parcelRequire("g5BLJ");

const $e6028744846e21c1$export$f5603a09670563b9 = ({ onChange: onChange , value: value , ...basicProps })=>{
    const numberValueRef = (0, $g5BLJ.useRef)(value);
    const [stringValue, setStringValue] = (0, $g5BLJ.useState)(String(value));
    (0, $g5BLJ.useEffect)(()=>{
        if (value !== numberValueRef.current) setStringValue(String(value));
    }, [
        value
    ]);
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>{
        const newStringValue = event.target.value;
        const newNumberValue = parseInt(newStringValue, 10);
        numberValueRef.current = Number.isNaN(newNumberValue) ? basicProps.min : newNumberValue;
        setStringValue(newStringValue);
        onChange(numberValueRef.current, newStringValue, event);
    }, [
        onChange,
        basicProps
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8abe0a260c183813$export$a195049fd73b3fe2), {
        ...basicProps,
        type: "range",
        value: stringValue,
        onChange: realOnChange
    });
};




var $g5BLJ = parcelRequire("g5BLJ");




const $813faab610558317$var$StyledSelect = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)((0, $8abe0a260c183813$export$a195049fd73b3fe2).withComponent("select")).withConfig({
    displayName: "SelectInput__StyledSelect",
    componentId: "sc-1s7dzu3-0"
})([
    "cursor:pointer;display:",
    ";",
    ";"
], ({ $display: $display  })=>$display, ({ $displayType: $displayType  })=>$displayType === "icon" ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "border:none;appearance:none;"
    ]) : "");
function $813faab610558317$export$d6701e98ab1a6725({ onChange: onChange , value: value , options: options , displayType: displayType = "form" , display: display = "block" , icon: icon , testTag: testTag , ...basicProps }) {
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>{
        const option = options.get(event.target.selectedIndex);
        if (!option) return;
        onChange(option.value, event);
    }, [
        onChange,
        options
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        display: display.includes("inline") ? "inline-flex" : "flex",
        align: "center",
        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
        backgroundColor: displayType === "icon" ? (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex : undefined,
        border: displayType === "icon" ? `2px solid ${(0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex}` : undefined,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($813faab610558317$var$StyledSelect, {
                ...basicProps,
                $displayType: displayType,
                value: value,
                onChange: realOnChange,
                $display: display,
                "data-test-tag": testTag,
                children: options.map((option, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("option", {
                        value: option.value,
                        disabled: option.disabled,
                        children: option.label
                    }, i))
            }),
            icon && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: icon,
                        size: "2em",
                        color: "black"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 4
                    })
                ]
            })
        ]
    });
}




var $g5BLJ = parcelRequire("g5BLJ");





var $g5BLJ = parcelRequire("g5BLJ");





const $67258d8115f0c213$var$InternalSpacer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Spacer__InternalSpacer",
    componentId: "sc-1qwqqe6-0"
})([
    "height:",
    ";width:",
    ";flex-shrink:0;"
], ({ $size: $size , $horizontal: $horizontal , $square: $square  })=>($square || !$horizontal) && (0, $18ffa0398cff6303$export$66be51d536890fa7)[$size], ({ $size: $size , $horizontal: $horizontal , $square: $square  })=>($square || $horizontal) && (0, $18ffa0398cff6303$export$66be51d536890fa7)[$size]);
const $67258d8115f0c213$export$d7a54cba636a8cd6 = ({ size: size = 1 , horizontal: horizontal = false , square: square = false  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($67258d8115f0c213$var$InternalSpacer, {
        $size: size,
        $horizontal: horizontal,
        $square: square
    });






parcelRequire("g5BLJ");
const $b7bd4e22c3cde653$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                stroke: "inherit",
                d: "M11.999 8a.25.25 0 1 0 .002.5A.25.25 0 0 0 12 8",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12 12v5"
            })
        ]
    });
var $b7bd4e22c3cde653$export$2e2bcd8739ae039 = $b7bd4e22c3cde653$var$SvgInfo;



parcelRequire("g5BLJ");
const $293cb21149cfce9a$var$SvgUser = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M18.364 5.636A9 9 0 1 1 5.636 18.364 9 9 0 0 1 18.364 5.636"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M17.307 19.257C16.923 17.417 14.705 16 12 16c-2.705 0-4.923 1.417-5.307 3.257M14.121 7.879A3 3 0 1 1 9.88 12.12 3 3 0 0 1 14.12 7.88"
            })
        ]
    });
var $293cb21149cfce9a$export$2e2bcd8739ae039 = $293cb21149cfce9a$var$SvgUser;



parcelRequire("g5BLJ");
const $c0eb085ad83ca7e2$var$SvgSettings = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 22,
        height: 22,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            clipRule: "evenodd",
            d: "M15.18 17.725a1.29 1.29 0 0 0 1.823 0l.722-.722a1.29 1.29 0 0 0 0-1.823 1.324 1.324 0 0 1-.284-1.453 7.63 7.63 0 0 0 .065-.16 1.217 1.217 0 0 1 1.137-.766h.067c.712 0 1.289-.577 1.289-1.289v-1.021c0-.712-.577-1.289-1.289-1.289h-.067c-.5 0-.954-.301-1.137-.766a7.63 7.63 0 0 0-.065-.16 1.324 1.324 0 0 1 .284-1.453 1.29 1.29 0 0 0 0-1.823l-.722-.722a1.29 1.29 0 0 0-1.823 0 1.324 1.324 0 0 1-1.453.284l-.16-.065a1.227 1.227 0 0 1-.767-1.141v-.067C12.8 2.577 12.223 2 11.511 2H10.49A1.29 1.29 0 0 0 9.2 3.289v.067c0 .5-.301.954-.766 1.137-.054.022-.107.043-.16.066a1.324 1.324 0 0 1-1.453-.284 1.29 1.29 0 0 0-1.823 0l-.723.722a1.29 1.29 0 0 0 0 1.823c.382.382.494.955.284 1.453a5.419 5.419 0 0 0-.065.161 1.22 1.22 0 0 1-1.138.766h-.067C2.577 9.2 2 9.777 2 10.489v1.021c0 .713.577 1.29 1.289 1.29h.067c.5 0 .954.301 1.137.766l.065.16c.21.498.098 1.071-.284 1.453a1.29 1.29 0 0 0 0 1.823l.722.722a1.29 1.29 0 0 0 1.823 0 1.324 1.324 0 0 1 1.453-.284l.16.065c.466.183.766.637.766 1.137v.067c0 .712.577 1.289 1.289 1.289h1.021c.712 0 1.289-.577 1.289-1.289v-.067c0-.5.301-.954.766-1.137l.16-.065a1.332 1.332 0 0 1 1.457.285Zm-2.059-8.846A3 3 0 1 1 8.88 13.12 3 3 0 0 1 13.12 8.88"
        })
    });
var $c0eb085ad83ca7e2$export$2e2bcd8739ae039 = $c0eb085ad83ca7e2$var$SvgSettings;



parcelRequire("g5BLJ");
const $846099589d31fa5a$var$SvgGroup = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M13.655 10.345a2.341 2.341 0 1 1-3.31 3.31 2.341 2.341 0 0 1 3.31-3.31M21.449 10.51a2.107 2.107 0 1 1-2.98 2.98 2.107 2.107 0 0 1 2.98-2.98M5.53 10.51a2.107 2.107 0 1 1-2.979 2.98 2.107 2.107 0 0 1 2.98-2.98M17.469 3.617a2.107 2.107 0 1 1-2.98 2.98 2.107 2.107 0 0 1 2.98-2.98M9.51 17.403a2.107 2.107 0 1 1-2.979 2.98 2.107 2.107 0 0 1 2.98-2.98M9.51 3.617a2.107 2.107 0 1 1-2.979 2.98 2.107 2.107 0 0 1 2.98-2.98M17.469 17.403a2.107 2.107 0 1 1-2.98 2.98 2.107 2.107 0 0 1 2.98-2.98M9.07 17.07l1.76-3.05M9.07 6.93l1.76 3.05M17.85 12h-3.51"
        })
    });
var $846099589d31fa5a$export$2e2bcd8739ae039 = $846099589d31fa5a$var$SvgGroup;



parcelRequire("g5BLJ");
const $53c6bed73b60c260$var$SvgUsers = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M15.216 10.428a3.337 3.337 0 0 0 3.215-3.314 3.168 3.168 0 0 0-3.215-3.118"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M9.428 10.428a3.337 3.337 0 0 0 3.215-3.314 3.168 3.168 0 0 0-3.216-3.118 3.168 3.168 0 0 0-3.215 3.118 3.336 3.336 0 0 0 3.216 3.314Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M16.002 20.003v-2A4.002 4.002 0 0 0 12 14H6.998a4.002 4.002 0 0 0-4.002 4.002v2M21.004 20.003v-3A3.001 3.001 0 0 0 18.002 14"
            })
        ]
    });
var $53c6bed73b60c260$export$2e2bcd8739ae039 = $53c6bed73b60c260$var$SvgUsers;



parcelRequire("g5BLJ");
const $cd8184fc24b42937$var$SvgArrowDown = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m21 7.5-9 9-9-9"
        })
    });
var $cd8184fc24b42937$export$2e2bcd8739ae039 = $cd8184fc24b42937$var$SvgArrowDown;



parcelRequire("g5BLJ");
const $47424e8c742837f6$var$SvgArrowUp = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m21 16.5-9.011-9L3 16.5"
        })
    });
var $47424e8c742837f6$export$2e2bcd8739ae039 = $47424e8c742837f6$var$SvgArrowUp;



parcelRequire("g5BLJ");
const $fd083eefbfaa2a17$var$SvgSortDown = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 10,
        height: 6,
        viewBox: "0 0 10 6",
        fill: "none",
        transform: "rotate(180)",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M4.244 5.127a1 1 0 0 0 1.512 0l3.007-3.472A1 1 0 0 0 8.007 0H1.993a1 1 0 0 0-.756 1.655l3.007 3.472Z"
        })
    });
var $fd083eefbfaa2a17$export$2e2bcd8739ae039 = $fd083eefbfaa2a17$var$SvgSortDown;



parcelRequire("g5BLJ");
const $6bf75a755e7f8570$var$SvgSortUp = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 10,
        height: 6,
        viewBox: "0 0 10 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M4.244 5.127a1 1 0 0 0 1.512 0l3.007-3.472A1 1 0 0 0 8.007 0H1.993a1 1 0 0 0-.756 1.655l3.007 3.472Z"
        })
    });
var $6bf75a755e7f8570$export$2e2bcd8739ae039 = $6bf75a755e7f8570$var$SvgSortUp;



parcelRequire("g5BLJ");
const $93a25dad33a05086$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m10 16 4-4-4-4"
        })
    });
var $93a25dad33a05086$export$2e2bcd8739ae039 = $93a25dad33a05086$var$SvgArrowRight;



parcelRequire("g5BLJ");
const $06bebe4b0b4e2cc8$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m14 16-4-4 4-4"
        })
    });
var $06bebe4b0b4e2cc8$export$2e2bcd8739ae039 = $06bebe4b0b4e2cc8$var$SvgArrowLeft;



parcelRequire("g5BLJ");
const $23742681c932d58e$var$SvgSelectArrowUp = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 12,
        height: 8,
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m1 6.25 5-4.5 5 4.5"
        })
    });
var $23742681c932d58e$export$2e2bcd8739ae039 = $23742681c932d58e$var$SvgSelectArrowUp;



parcelRequire("g5BLJ");
const $5fc92a93ed76337d$var$SvgSelectArrowDown = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 12,
        height: 8,
        viewBox: "0 0 12 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m1 1.75 5 4.5 5-4.5"
        })
    });
var $5fc92a93ed76337d$export$2e2bcd8739ae039 = $5fc92a93ed76337d$var$SvgSelectArrowDown;



parcelRequire("g5BLJ");
const $2369ad2d37acf59f$var$SvgChatBubble = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M3 11.291c0 2.683 1.42 5.045 3.599 6.534-.001.855.001 2.007.001 3.216l3.531-1.747a9.896 9.896 0 0 0 1.869.179c4.952 0 9-3.643 9-8.182 0-4.539-4.048-8.182-9-8.182s-9 3.643-9 8.182Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M11.899 12.328v-.207c0-.678.419-1.045.839-1.327.41-.276.821-.636.821-1.3a1.659 1.659 0 0 0-3.319-.001M11.898 14.667a.148.148 0 0 0-.149.15.15.15 0 1 0 .15-.15",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $2369ad2d37acf59f$export$2e2bcd8739ae039 = $2369ad2d37acf59f$var$SvgChatBubble;



parcelRequire("g5BLJ");
const $50ed3d16f49db65f$var$SvgHeadphones = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M19 17h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2ZM6 17H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M18.5 10v-.5A6.5 6.5 0 0 0 12 3v0a6.5 6.5 0 0 0-6.5 6.5v.5",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M12.625 21.25h-1.25c-.69 0-1.25-.56-1.25-1.25v0c0-.69.56-1.25 1.25-1.25h1.25c.69 0 1.25.56 1.25 1.25v0c0 .69-.56 1.25-1.25 1.25Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M13.875 20H16a2 2 0 0 0 2-2v-1",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $50ed3d16f49db65f$export$2e2bcd8739ae039 = $50ed3d16f49db65f$var$SvgHeadphones;



parcelRequire("g5BLJ");
const $0919d31e443ef174$var$SvgMicrophone = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("title", {
                children: "Start Recording"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 15a3 3 0 0 1-3-3V6a3 3 0 1 1 6 0v6a3 3 0 0 1-3 3Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M18 10v2a6 6 0 0 1-6 6v0a6 6 0 0 1-6-6v-2M12 18v3M7.82 21h8.36",
                stroke: "inherit",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $0919d31e443ef174$export$2e2bcd8739ae039 = $0919d31e443ef174$var$SvgMicrophone;



parcelRequire("g5BLJ");
const $4ad42f8ecaf9f480$var$SvgTask = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M11.172 7.753a3.68 3.68 0 0 1 4.346-1.78 3.605 3.605 0 0 1 2.794 4.242c-.657 2.452-4.378 2.322-4.815 3.951",
                stroke: "inherit",
                strokeWidth: 3,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M4.348 12.347a2.148 2.148 0 0 1 1.786-2.08 2.105 2.105 0 0 1 2.58 1.462c.31 1.449-1.658 2.37-1.452 3.334",
                stroke: "inherit",
                strokeWidth: 1.752,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12.5 18.703a.21.21 0 1 1-.407-.109.21.21 0 0 1 .407.11",
                stroke: "inherit",
                strokeWidth: 3,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M7.95 17.687a.123.123 0 1 1-.24.051.123.123 0 0 1 .24-.051",
                stroke: "inherit",
                strokeWidth: 1.752,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $4ad42f8ecaf9f480$export$2e2bcd8739ae039 = $4ad42f8ecaf9f480$var$SvgTask;



parcelRequire("g5BLJ");
const $036d3204b05ae039$var$SvgStop = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("title", {
                children: "Stop Recording"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.417 20.25H5.583a1.833 1.833 0 0 1-1.833-1.833V5.583c0-1.013.821-1.833 1.833-1.833h12.833c1.013 0 1.833.821 1.833 1.833v12.833a1.832 1.832 0 0 1-1.832 1.834Z",
                fill: "#FFF"
            })
        ]
    });
var $036d3204b05ae039$export$2e2bcd8739ae039 = $036d3204b05ae039$var$SvgStop;



parcelRequire("g5BLJ");
const $1da2deea652b77f1$var$SvgMenu = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M2.996 5.998h18.008M17.002 12H2.996M2.996 18.003H13"
        })
    });
var $1da2deea652b77f1$export$2e2bcd8739ae039 = $1da2deea652b77f1$var$SvgMenu;



parcelRequire("g5BLJ");
const $fe8e08342d55025e$var$SvgPlay = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 11,
        height: 14,
        viewBox: "0 0 9 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("title", {
                children: "Play"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M10.5 7.866a1 1 0 0 0 0-1.732L1.5.938a1 1 0 0 0-1.5.866v10.392a1 1 0 0 0 1.5.866l9-5.196Z"
            })
        ]
    });
var $fe8e08342d55025e$export$2e2bcd8739ae039 = $fe8e08342d55025e$var$SvgPlay;



parcelRequire("g5BLJ");
const $1394cec4a1c526b7$var$SvgSpeaker = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M5.875 8.625H3.5a1 1 0 0 0-1 1v4.75a1 1 0 0 0 1 1h2.375l3.979 3.371a1 1 0 0 0 1.646-.763V6.017c0-.852-.997-1.314-1.646-.763L5.875 8.625Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M15.537 15.978c1.162-.722 1.963-2.224 1.963-3.973 0-1.749-.801-3.252-1.963-3.983M18.505 19.065c1.808-1.555 2.995-4.135 2.995-7.062 0-2.931-1.189-5.513-3-7.067"
            })
        ]
    });
var $1394cec4a1c526b7$export$2e2bcd8739ae039 = $1394cec4a1c526b7$var$SvgSpeaker;



parcelRequire("g5BLJ");
const $dda62f79b3745e94$var$SvgBackFiveSeconds = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12 5.6 9.868 3.47 12 1.336",
                stroke: "#000",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M5.2 6.905C4.131 8.329 3.474 10.08 3.474 12A8.526 8.526 0 0 0 12 20.526 8.526 8.526 0 0 0 20.526 12 8.526 8.526 0 0 0 12 3.474a8.42 8.42 0 0 0-1.898.229",
                stroke: "#000",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M10.598 13.811c.271.413.725.689 1.258.689.854 0 1.546-.692 1.546-1.545 0-.69-.56-1.25-1.25-1.25h-1.375l.25-2.205h2.161",
                stroke: "#000",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $dda62f79b3745e94$export$2e2bcd8739ae039 = $dda62f79b3745e94$var$SvgBackFiveSeconds;



parcelRequire("g5BLJ");
const $2ead01fbc64994e2$var$SvgForwardFiveSeconds = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "m12 5.6 2.132-2.131L12 1.336",
                stroke: "#000",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M18.8 6.905c1.069 1.424 1.726 3.176 1.726 5.095A8.526 8.526 0 0 1 12 20.526 8.526 8.526 0 0 1 3.474 12 8.526 8.526 0 0 1 12 3.474a8.42 8.42 0 0 1 1.898.229",
                stroke: "#000",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M10.598 13.811c.271.413.725.689 1.258.689.854 0 1.546-.692 1.546-1.545 0-.69-.56-1.25-1.25-1.25h-1.375l.25-2.205h2.161",
                stroke: "#000",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $2ead01fbc64994e2$export$2e2bcd8739ae039 = $2ead01fbc64994e2$var$SvgForwardFiveSeconds;



parcelRequire("g5BLJ");
const $1ffe3ccc6f02d018$var$SvgThreeVerticalDots = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M12 18.502a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1M12 12.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1M12 6.497a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1"
        })
    });
var $1ffe3ccc6f02d018$export$2e2bcd8739ae039 = $1ffe3ccc6f02d018$var$SvgThreeVerticalDots;



parcelRequire("g5BLJ");
const $6bafc4b38f3cb7dd$var$SvgThreeHorizontalDots = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M18.503 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M12.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.498 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
        })
    });
var $6bafc4b38f3cb7dd$export$2e2bcd8739ae039 = $6bafc4b38f3cb7dd$var$SvgThreeHorizontalDots;



parcelRequire("g5BLJ");
const $46d6f05242654fb6$var$SvgPause = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("title", {
                children: "Pause"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16 18a1.5 1.5 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 3 0v9A1.5 1.5 0 0 1 16 18ZM8 18a1.5 1.5 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 3 0v9A1.5 1.5 0 0 1 8 18Z",
                fill: "#fff"
            })
        ]
    });
var $46d6f05242654fb6$export$2e2bcd8739ae039 = $46d6f05242654fb6$var$SvgPause;



parcelRequire("g5BLJ");
const $61499f5088cb8e63$var$SvgText = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M7.463 3.75h7.627M11.25 12.75v-9M5.25 12.75V7.5M3 7.5h4.5",
            stroke: "#242938",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $61499f5088cb8e63$export$2e2bcd8739ae039 = $61499f5088cb8e63$var$SvgText;



parcelRequire("g5BLJ");
const $be79b820601f3361$var$SvgBackArrow = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M5 12h14M10 7l-5 5M10 17l-5-5",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $be79b820601f3361$export$2e2bcd8739ae039 = $be79b820601f3361$var$SvgBackArrow;



parcelRequire("g5BLJ");
const $60d64694233929c3$var$SvgForwardArrow = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M19 12H5M14 17l5-5M14 7l5 5",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $60d64694233929c3$export$2e2bcd8739ae039 = $60d64694233929c3$var$SvgForwardArrow;



parcelRequire("g5BLJ");
const $e849d92084f14fac$var$SvgBook = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 20,
        height: 16,
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M3.06.36h-.002a.713.713 0 0 0-.712.716v10.732c0 .393.321.714.716.715 1.666.004 4.457.351 6.383 2.366V3.658a.686.686 0 0 0-.099-.362C7.766.75 4.73.364 3.06.36ZM17.655 11.808V1.076a.713.713 0 0 0-.712-.716h-.002c-1.67.004-4.706.39-6.287 2.936a.686.686 0 0 0-.098.362V14.89c1.925-2.015 4.716-2.362 6.382-2.366a.718.718 0 0 0 .717-.715Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M19.284 2.835h-.519v8.972a1.831 1.831 0 0 1-1.825 1.827c-1.413.003-3.743.28-5.393 1.841 2.854-.698 5.863-.244 7.577.147a.714.714 0 0 0 .876-.698V3.551a.716.716 0 0 0-.716-.716ZM1.234 11.807V2.835H.716A.716.716 0 0 0 0 3.551v11.373a.714.714 0 0 0 .876.697c1.714-.39 4.723-.845 7.576-.146-1.65-1.561-3.98-1.838-5.393-1.841a1.831 1.831 0 0 1-1.825-1.827Z"
            })
        ]
    });
var $e849d92084f14fac$export$2e2bcd8739ae039 = $e849d92084f14fac$var$SvgBook;



parcelRequire("g5BLJ");
const $0154e479338520bd$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M12.501 16.17V9.051c0-.354-.14-.693-.39-.943l-1.887-1.886c-.25-.25-.59-.391-.943-.391H4.664c-.736 0-1.333.597-1.333 1.334v9.003c0 .737.597 1.334 1.333 1.334h6.503c.737 0 1.334-.597 1.334-1.334Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12.501 14.169h2.835c.736 0 1.333-.598 1.333-1.334v-8.67c0-.921-.746-1.668-1.667-1.668h-6.17c-.736 0-1.333.597-1.333 1.334v2"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12.501 9.167H9.833a.667.667 0 0 1-.667-.667V5.832"
            })
        ]
    });
var $0154e479338520bd$export$2e2bcd8739ae039 = $0154e479338520bd$var$SvgCopy;



parcelRequire("g5BLJ");
const $4c35734d13be34c0$var$SvgCheck = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M8.228 11.222 12.005 15l7.675-7.675C18.1 4.735 15.256 3 12 3a9 9 0 0 0-9 9 9 9 0 0 0 17.941 1",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $4c35734d13be34c0$export$2e2bcd8739ae039 = $4c35734d13be34c0$var$SvgCheck;



parcelRequire("g5BLJ");
const $5f0c52e309119168$var$SvgCheckboxChecked = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("g", {
            clipPath: "url('6d241851f5a8eca9')",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("rect", {
                    width: 20,
                    height: 20,
                    rx: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M13.314 6.793a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-2.521-2.521a1 1 0 0 1 1.414-1.414l1.814 1.814 5.293-5.293Z",
                    fill: "#FBFBFB"
                })
            ]
        })
    });
var $5f0c52e309119168$export$2e2bcd8739ae039 = $5f0c52e309119168$var$SvgCheckboxChecked;



parcelRequire("g5BLJ");
const $ebc0d6d9de5d09fe$var$SvgCheckboxUnchecked = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("g", {
            clipPath: "url('b591b91396f471bd')",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("rect", {
                x: 0.5,
                y: 0.5,
                width: 19,
                height: 19,
                rx: 2.5
            })
        })
    });
var $ebc0d6d9de5d09fe$export$2e2bcd8739ae039 = $ebc0d6d9de5d09fe$var$SvgCheckboxUnchecked;



parcelRequire("g5BLJ");
const $85802442c73ba47f$var$SvgClose = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m1 1 8 8M9 1 1 9",
            stroke: "currentColor",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $85802442c73ba47f$export$2e2bcd8739ae039 = $85802442c73ba47f$var$SvgClose;



parcelRequire("g5BLJ");
const $45b363f444944a71$var$SvgSync = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "m12 8.456-1.181-1.18L12 6.093",
                stroke: "#323232",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M18.364 5.636A9 9 0 1 1 5.636 18.364 9 9 0 0 1 18.364 5.636",
                stroke: "#323232",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M13.051 16.595a4.666 4.666 0 0 1-1.051.127A4.722 4.722 0 0 1 7.278 12c0-1.063.364-2.033.956-2.822M15.766 14.822A4.683 4.683 0 0 0 16.722 12 4.722 4.722 0 0 0 12 7.278c-.363 0-.712.049-1.051.127",
                stroke: "#323232",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "m12 15.544 1.181 1.18L12 17.907",
                stroke: "#323232",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $45b363f444944a71$export$2e2bcd8739ae039 = $45b363f444944a71$var$SvgSync;



parcelRequire("g5BLJ");
const $99a197fa792cd974$var$SvgEye = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 14,
        height: 10,
        viewBox: "0 0 14 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M13.915 4.645C12.597 2.073 9.988.333 7 .333S1.402 2.075.085 4.645a.786.786 0 0 0 0 .71C1.403 7.927 4.012 9.667 7 9.667s5.598-1.742 6.915-4.312a.786.786 0 0 0 0-.71ZM7 8.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Zm0-5.833a2.316 2.316 0 0 0-.615.092 1.163 1.163 0 0 1-1.626 1.626A2.328 2.328 0 1 0 7 2.667Z"
        })
    });
var $99a197fa792cd974$export$2e2bcd8739ae039 = $99a197fa792cd974$var$SvgEye;



parcelRequire("g5BLJ");
const $64b72209f4695b43$var$SvgPicture = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 23,
        height: 18,
        viewBox: "0 0 23 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            clipRule: "evenodd",
            d: "M3.45 0h16.1a3.49 3.49 0 0 1 2.44.989A3.338 3.338 0 0 1 23 3.375v8.898l-5.078-5.415a3.463 3.463 0 0 0-1.317-.802 3.522 3.522 0 0 0-3 .364c-.44.28-.808.653-1.077 1.093L6.161 18H3.45a3.49 3.49 0 0 1-2.44-.988A3.338 3.338 0 0 1 0 14.625V3.375C0 2.48.363 1.621 1.01.989A3.49 3.49 0 0 1 3.45 0Zm2.629 9.307a3.49 3.49 0 0 1-2.44-.989 3.338 3.338 0 0 1-1.01-2.386c0-.895.363-1.754 1.01-2.387a3.49 3.49 0 0 1 2.44-.988 3.49 3.49 0 0 1 2.44.988 3.338 3.338 0 0 1 1.01 2.387c0 .895-.364 1.753-1.01 2.386a3.49 3.49 0 0 1-2.44.989Z"
        })
    });
var $64b72209f4695b43$export$2e2bcd8739ae039 = $64b72209f4695b43$var$SvgPicture;



parcelRequire("g5BLJ");
const $346869215e059663$var$SvgCheckmark = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 12,
        height: 9,
        viewBox: "0 0 12 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M9.314.793a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0L.793 5.686a1 1 0 1 1 1.414-1.414l1.814 1.814L9.314.793Z"
        })
    });
var $346869215e059663$export$2e2bcd8739ae039 = $346869215e059663$var$SvgCheckmark;



parcelRequire("g5BLJ");
const $a2e008828e494784$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 10,
        height: 10,
        viewBox: "0 0 10 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M5 1v8M9 5H1",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $a2e008828e494784$export$2e2bcd8739ae039 = $a2e008828e494784$var$SvgPlus;



parcelRequire("g5BLJ");
const $e0de999f3b9a29cc$var$SvgPdf = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 13,
        height: 17,
        viewBox: "0 0 13 17",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M6.158 8.503c-.17-.53-.166-1.557-.068-1.557.285 0 .258 1.225.068 1.557Zm-.057 1.567c-.261.671-.586 1.438-.962 2.082.62-.232 1.32-.57 2.13-.727A4.325 4.325 0 0 1 6.1 10.07Zm-3.186 4.144c0 .027.447-.179 1.181-1.335-.226.21-.985.814-1.181 1.335Zm5.48-8.902H13v10.891a.803.803 0 0 1-.813.797H.813A.803.803 0 0 1 0 16.203V.797C0 .355.362 0 .813 0h6.77v4.516c0 .438.366.796.813.796Zm-.27 5.705c-.677-.405-1.127-.963-1.446-1.787.153-.614.393-1.547.21-2.131-.159-.976-1.435-.88-1.618-.226-.17.608-.013 1.464.274 2.557-.392.916-.971 2.145-1.38 2.848-.004 0-.004.004-.008.004-.917.461-2.491 1.477-1.845 2.258.19.229.542.332.728.332.606 0 1.209-.598 2.069-2.052.873-.283 1.831-.635 2.674-.77.735.391 1.595.647 2.167.647.988 0 1.056-1.063.667-1.441-.47-.452-1.839-.322-2.492-.24Zm4.638-7.53L9.445.231A.82.82 0 0 0 8.87 0h-.203v4.25H13v-.203a.786.786 0 0 0-.237-.56Zm-2.509 8.476c.14-.09-.084-.395-1.449-.299 1.257.525 1.45.3 1.45.3Z"
        })
    });
var $e0de999f3b9a29cc$export$2e2bcd8739ae039 = $e0de999f3b9a29cc$var$SvgPdf;



parcelRequire("g5BLJ");
const $0cd29884abfd51b5$var$SvgAdd = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "-1 -1 23 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M10.89 0A10.108 10.108 0 0 0 .78 10.11c0 5.585 4.525 10.11 10.11 10.11 5.585 0 10.11-4.525 10.11-10.11C21 4.525 16.475 0 10.89 0Zm5.87 11.252a.49.49 0 0 1-.489.489h-3.75v3.75c0 .27-.22.49-.49.49H9.75a.49.49 0 0 1-.49-.49v-3.75H5.51a.49.49 0 0 1-.49-.49V8.97c0-.27.221-.49.49-.49h3.75V4.73c0-.27.22-.49.49-.49h2.283c.269 0 .489.22.489.49v3.75h3.75c.27 0 .49.22.49.49v2.283Z",
            fill: "#fff"
        })
    });
var $0cd29884abfd51b5$export$2e2bcd8739ae039 = $0cd29884abfd51b5$var$SvgAdd;



parcelRequire("g5BLJ");
const $f6b615a02f3c130f$var$SvgHourglass = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 20,
        height: 26,
        viewBox: "0 0 20 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M14.096 10.299C15.82 8.727 18.15 6.6 18.363 1.523h1.54V0H.097v1.523h1.539C1.849 6.601 4.18 8.727 5.904 10.3c1.157 1.054 1.81 1.7 1.81 2.701 0 1.002-.653 1.647-1.81 2.701C4.18 17.273 1.85 19.4 1.637 24.477H.097V26h19.805v-1.523h-1.539c-.212-5.078-2.543-7.204-4.267-8.776-1.157-1.054-1.81-1.7-1.81-2.701 0-1.002.653-1.647 1.81-2.701Zm-4.858 8.41c-.235.05-.467.12-.694.214l-4.666 1.93c.762-1.937 1.99-3.056 3.053-4.026C8.117 15.745 9.238 14.723 9.238 13v5.71Zm3.831-1.882c1.064.97 2.29 2.09 3.053 4.026l-4.666-1.93a3.852 3.852 0 0 0-.694-.213V13c0 1.723 1.12 2.745 2.307 3.827ZM3.851 5.078c-.368-.96-.622-2.118-.689-3.555h13.676c-.067 1.437-.321 2.595-.69 3.555H3.852Z"
        })
    });
var $f6b615a02f3c130f$export$2e2bcd8739ae039 = $f6b615a02f3c130f$var$SvgHourglass;



parcelRequire("g5BLJ");
const $ffed6c569fcbc6d0$var$SvgSpeedometer = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 33,
        height: 22,
        viewBox: "0 0 33 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m32.329 19.97-.007-.21-.008-.21-.002-.053-.001-.027v-.006l-.001-.06v-.003l-.001-.01-.007-.088-.027-.353-.007-.089-.01-.116-.022-.23-.023-.229-.011-.114-.014-.105c-.039-.277-.073-.55-.122-.813-.023-.13-.044-.26-.068-.386l-.077-.367c-.047-.24-.107-.463-.157-.669l-.037-.151a196.682 196.682 0 0 0-.115-.408c-.024-.083-.045-.161-.067-.232l-.062-.196-.07-.217a.166.166 0 0 0-.204-.109l-5.41 1.542a.166.166 0 0 0-.118.19l.02.107.026.135c.009.05.015.103.024.16.01.056.018.117.028.181l.015.098.012.103c.015.141.037.292.047.454l.02.248c.006.085.009.172.013.26.012.176.01.358.013.543v.069l-.002.06a718.315 718.315 0 0 0-.007.244l-.001.061-.004.088-.015.353-.004.088V19.517l-.001-.054v.004l-.002.018-.003.034-.013.139-.012.136-.016.135c-.012.09-.019.178-.033.264l-.037.254-.042.241c-.012.079-.028.154-.043.227-.015.073-.028.144-.044.212a156.504 156.504 0 0 1-.065.281l-.02.072-.01.04h6.617c.088 0 .162-.069.165-.157v-.002l.017-.38.008-.395c.004-.134 0-.27 0-.408-.002-.069-.002-.138-.003-.208ZM30.608 13.025a.166.166 0 0 0 .088-.225l-.063-.134-.075-.158-.114-.233-.132-.264c-.023-.048-.046-.088-.07-.133l-.074-.136c-.05-.093-.102-.19-.157-.288l-.177-.304-.093-.157-.099-.16-.206-.326c-.147-.218-.294-.445-.458-.666l-.121-.168-.061-.084-.063-.082-.256-.33c-.087-.11-.176-.217-.264-.324-.045-.053-.088-.107-.133-.159l-.136-.155-.135-.153a4.5 4.5 0 0 0-.136-.15l-.272-.29c-.089-.094-.181-.183-.27-.272-.088-.088-.174-.175-.262-.256l-.253-.237c-.082-.077-.165-.147-.242-.216l-.224-.196-.208-.17-.182-.15c-.057-.046-.11-.086-.158-.123l-.175-.134a.166.166 0 0 0-.229.026l-2.904 3.515a.166.166 0 0 0 .011.223l.084.083c.03.03.065.063.1.1a161.412 161.412 0 0 1 .246.26l.14.156c.048.056.1.11.15.172l.157.188c.054.063.106.132.16.2.054.07.11.14.164.213a1064.762 1064.762 0 0 1 .245.34l.08.119.081.118c.027.04.052.081.078.122.051.082.105.163.155.245l.147.25.037.062.034.063.069.125c.094.165.173.335.257.494l.112.241.054.117.05.115c.032.076.063.15.094.22l.082.21.038.098c.012.03.027.065.035.09l.053.155.047.136.053.158.047.14c.03.091.13.138.22.102l5.034-2.023ZM15.821 6.747l.146.02.17.03.194.033c.06.01.12.024.184.038l1.833-3.749-.27-.042c-.06-.009-.12-.02-.179-.027l-.175-.02c-.116-.015-.228-.028-.337-.04l-.315-.028c-.101-.008-.198-.018-.29-.022-.092-.005-.18-.01-.261-.013l-.23-.011-.195-.003-.21-.003a.166.166 0 0 0-.167.159l-.167 3.488a.166.166 0 0 0 .143.173l.126.017ZM20.747 8.668l.14.102c.043.032.085.061.123.088l.066.049.065.048.119.09a.166.166 0 0 0 .238-.043l2.392-3.644a.166.166 0 0 0-.056-.235l-.128-.074-.071-.04-.085-.049-.22-.121-.25-.137-.265-.132c-.093-.046-.188-.096-.289-.142l-.312-.143c-.107-.05-.22-.096-.333-.144-.115-.046-.23-.098-.35-.143l-.093-.035-1.032 4.48c.057.036.111.074.164.108l.177.117ZM12.61 6.729c.045-.006.09-.014.136-.018a117.309 117.309 0 0 0 .391-.04l.24-.017.114-.008c.036-.002.073-.005.104-.005l.185-.005.162-.005a1078.24 1078.24 0 0 0 .317-.002c.096 0 .171-.082.165-.177l-.215-3.287a.166.166 0 0 0-.187-.154l-.147.02-.171.02-.239.036-.27.041c-.05.007-.094.016-.141.025l-.144.028-.306.059-.325.074-.169.039c-.057.013-.114.03-.172.044l-.354.095-.362.109c-.061.019-.123.037-.184.057-.062.02-.123.042-.185.063l-.185.063a4.1 4.1 0 0 0-.185.067l-.37.14c-.122.049-.243.102-.364.152-.06.026-.12.05-.18.077l-.177.082-.175.08c-.058.028-.116.054-.173.083l-.334.17c-.11.054-.214.115-.318.17-.103.058-.205.112-.3.17l-.282.167c-.09.053-.175.11-.258.162l-.236.152-.208.142-.182.126c-.057.039-.106.077-.152.11l-.159.118a.166.166 0 0 0-.038.226l1.365 2.007a.166.166 0 0 0 .218.051l.123-.069c.04-.022.085-.049.134-.075l.161-.084.183-.095.205-.099c.072-.033.145-.072.224-.105l.242-.106c.083-.038.17-.071.258-.107.089-.034.178-.073.27-.106l.283-.102a191.237 191.237 0 0 0 .439-.144l.15-.042c.1-.028.2-.059.3-.084l.303-.075c.05-.014.1-.024.151-.035l.151-.031.15-.032c.049-.01.099-.017.148-.026l.291-.05.283-.04ZM3.303 9.323l-.108.153-.108.153c-.036.052-.07.105-.105.157-.07.106-.14.211-.208.318l-.198.323-.05.08-.046.082-.093.162c-.126.214-.235.433-.346.64l-.153.313c-.025.05-.05.101-.073.151l-.068.15-.128.286-.112.271c-.035.087-.071.17-.101.25l-.086.227-.074.2-.058.171-.06.174a.166.166 0 0 0 .099.208l1.27.487a.166.166 0 0 0 .21-.083l.065-.139c.022-.043.045-.092.07-.145l.088-.168.099-.192c.035-.067.075-.136.116-.208l.127-.226.143-.238c.024-.04.05-.081.074-.123l.08-.124.166-.256c.12-.17.236-.347.368-.519l.098-.13.048-.066.051-.064.204-.257c.07-.085.142-.168.212-.251l.106-.124.109-.12.107-.119c.036-.04.071-.078.108-.116l.216-.223c.071-.074.145-.142.215-.21.07-.069.138-.136.208-.198l.2-.182c.065-.06.131-.113.192-.166l.177-.15.156-.124.137-.11.068-.051.065-.05.119-.089a.166.166 0 0 0 .026-.24L5.479 7.124a.166.166 0 0 0-.242-.012l-.107.103-.058.056-.067.066-.16.161-.182.185-.187.202c-.065.072-.134.143-.202.222l-.208.242c-.073.082-.143.17-.216.26-.071.09-.147.18-.219.275l-.219.29a3.73 3.73 0 0 0-.109.15ZM.675 15.263l-.03.146-.033.168-.038.21-.041.243-.022.13-.018.135c-.024.184-.055.381-.073.592l-.032.324c-.01.11-.015.224-.023.339-.018.23-.022.467-.03.708l-.002.09v.091l.002.182v.183l.001.092.004.091.015.366.004.09v.03l.002.022.004.043.012.175.013.173.018.179.017.176.009.087.01.086.043.332.048.317c.015.103.034.203.052.3l.004.022a.166.166 0 0 0 .163.136h.448c.096 0 .172-.08.166-.176a12.534 12.534 0 0 0-.005-.077c-.005-.093-.012-.189-.014-.288l-.01-.303-.002-.317v-.08l.001-.081.004-.162.003-.164.008-.173.009-.175.002-.044V19.456c0-.007 0 .007.001.005v-.006l.001-.01.007-.085.027-.341.007-.085.01-.085.02-.17.019-.168.01-.084.012-.083c.034-.221.063-.44.105-.648.02-.104.038-.207.059-.307l.065-.292c.039-.19.09-.366.131-.53l.031-.12.033-.111.061-.204c.02-.065.036-.123.055-.18l.053-.163.047-.14a.166.166 0 0 0-.115-.213l-1.122-.3a.166.166 0 0 0-.206.127ZM13.38 21.08a2.583 2.583 0 0 0 3.652-1.74l2.613-11.342.995-4.32.616-2.675c.072-.312-.176-.524-.424-.524a.407.407 0 0 0-.374.24l-1.254 2.567-1.851 3.786-5.16 10.553a2.583 2.583 0 0 0 1.187 3.456Zm1.228-3.652a1.266 1.266 0 1 1 0 2.532 1.266 1.266 0 0 1 0-2.532Z"
        })
    });
var $ffed6c569fcbc6d0$export$2e2bcd8739ae039 = $ffed6c569fcbc6d0$var$SvgSpeedometer;



parcelRequire("g5BLJ");
const $20cf88857d19edd8$var$SvgStar = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 28,
        height: 26,
        viewBox: "0 0 28 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M13.049.927c.3-.921 1.603-.921 1.902 0l2.417 7.438a1 1 0 0 0 .95.69h7.821c.969 0 1.372 1.24.588 1.81L20.4 15.46a1 1 0 0 0-.363 1.118l2.416 7.438c.3.922-.755 1.688-1.538 1.118l-6.327-4.597a1 1 0 0 0-1.176 0l-6.327 4.597c-.783.57-1.838-.197-1.539-1.118l2.417-7.438a1 1 0 0 0-.363-1.118l-6.327-4.596c-.784-.57-.38-1.81.588-1.81h7.82a1 1 0 0 0 .951-.69L13.05.927Z"
        })
    });
var $20cf88857d19edd8$export$2e2bcd8739ae039 = $20cf88857d19edd8$var$SvgStar;



parcelRequire("g5BLJ");
const $b93031204a571ee0$var$SvgTypedText = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 37,
        height: 36,
        viewBox: "0 0 37 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("g", {
            clipPath: "url('cc316e6e864dbb78')",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    d: "M1.147 27H3.75l1.26-3.9h7.092l1.284 3.9h2.604L10.375 9.72H6.763L1.147 27Zm4.632-6.252 2.76-8.52 2.796 8.52H5.779Zm16.025 6.612c2.064 0 3.62-.748 4.668-2.244V27h2.22v-7.98c0-.544-.024-1.052-.072-1.524a3.93 3.93 0 0 0-.384-1.344 3.73 3.73 0 0 0-1.896-1.872c-.856-.4-1.864-.6-3.024-.6-1.496 0-2.696.328-3.6.984-.904.656-1.512 1.54-1.824 2.652l2.34.72c.224-.72.62-1.24 1.188-1.56a3.748 3.748 0 0 1 1.872-.48c1.008 0 1.736.216 2.184.648.456.424.704 1.084.744 1.98-1.056.144-2.088.296-3.096.456a21.008 21.008 0 0 0-2.64.552c-1 .32-1.76.796-2.28 1.428-.52.632-.78 1.436-.78 2.412 0 .704.164 1.352.492 1.944.336.584.828 1.056 1.476 1.416.656.352 1.46.528 2.412.528Zm.444-2.052c-.8 0-1.392-.184-1.776-.552-.376-.368-.564-.804-.564-1.308 0-.512.168-.916.504-1.212.344-.296.772-.532 1.284-.708.544-.16 1.184-.3 1.92-.42.744-.12 1.604-.252 2.58-.396a17.59 17.59 0 0 1-.06 1.02c-.032.376-.1.712-.204 1.008-.096.424-.3.832-.612 1.224-.304.392-.716.716-1.236.972-.512.248-1.124.372-1.836.372Z"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    stroke: "inherit",
                    strokeWidth: 1.01,
                    d: "M34.167 8v20M36.667 8.5h-5M36.667 28.5h-5"
                })
            ]
        })
    });
var $b93031204a571ee0$export$2e2bcd8739ae039 = $b93031204a571ee0$var$SvgTypedText;



parcelRequire("g5BLJ");
const $3673364e03ec9a97$var$SvgUpload = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 48,
        height: 34,
        viewBox: "0 0 48 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M11.229 10.403C5.741 11.153 1.5 15.807 1.5 21.5c0 6.212 5.038 11.25 11.25 11.25H37.5a9 9 0 0 0 0-18c0-7.457-6.044-13.5-13.5-13.5-5.933 0-10.96 3.832-12.771 9.153Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M19.124 18.5 24 13.626l4.876 4.876M24 24.875v-11.25"
            })
        ]
    });
var $3673364e03ec9a97$export$2e2bcd8739ae039 = $3673364e03ec9a97$var$SvgUpload;



parcelRequire("g5BLJ");
const $1782735168b095f7$var$SvgTrash = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 25,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M15.543 21.25H8.457a2.25 2.25 0 0 1-2.244-2.078L5.247 6.619h13.506l-.966 12.553a2.25 2.25 0 0 1-2.244 2.078Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M20.003 6.62H3.997",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M9.187 3.243h5.627c.621 0 1.125.504 1.125 1.126v2.25H8.061V4.37c0-.622.504-1.126 1.126-1.126v0Z",
                fill: "none",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "m10.5 12.405 3 2.685M10.658 15.248l2.685-3.001",
                stroke: "#fff",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $1782735168b095f7$export$2e2bcd8739ae039 = $1782735168b095f7$var$SvgTrash;



parcelRequire("g5BLJ");
const $08615baf68eca345$var$SvgPencil = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 9,
        height: 9,
        viewBox: "0 0 9 9",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m8.752 2.497-.81.81a.211.211 0 0 1-.3 0l-1.95-1.951a.211.211 0 0 1 0-.3l.81-.81a.846.846 0 0 1 1.194 0l1.056 1.057c.33.329.33.863 0 1.194Zm-3.756-.744L.379 6.369.007 8.505c-.051.288.2.538.488.489l2.136-.375 4.616-4.616a.211.211 0 0 0 0-.299l-1.95-1.951a.213.213 0 0 0-.301 0ZM2.18 5.973a.245.245 0 0 1 0-.347l2.707-2.707a.245.245 0 0 1 .348 0 .245.245 0 0 1 0 .348L2.53 5.974a.245.245 0 0 1-.348 0Zm-.634 1.48h.843v.637l-1.134.199-.546-.547.198-1.134h.639v.844Z"
        })
    });
var $08615baf68eca345$export$2e2bcd8739ae039 = $08615baf68eca345$var$SvgPencil;



parcelRequire("g5BLJ");
const $75c1aa438ed076fa$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M21 13.067v5.905A2.02 2.02 0 0 1 18.987 21H5.013A2.02 2.02 0 0 1 3 18.972V6.028A2.02 2.02 0 0 1 5.013 4H12",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "m7.828 17.172 3.731-.933c.176-.044.336-.135.465-.263l8.39-8.39a2 2 0 0 0 0-2.828l-.172-.172a2 2 0 0 0-2.828 0l-8.39 8.39c-.128.128-.219.289-.263.465l-.933 3.73M15.83 6.17l3 3",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M11.546 16.24c.014-.105.032-.21.032-.32a2.5 2.5 0 0 0-2.5-2.5c-.11 0-.215.019-.321.032",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $75c1aa438ed076fa$export$2e2bcd8739ae039 = $75c1aa438ed076fa$var$SvgEdit;



parcelRequire("g5BLJ");
const $9ac076dc8482fb71$var$SvgPreview = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 20,
        height: 19,
        viewBox: "0 0 20 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M2.997 9.5c0-.553.128-1.098.371-1.594A7.88 7.88 0 0 1 10.5 3.664a7.88 7.88 0 0 1 7.131 4.242 3.602 3.602 0 0 1 0 3.188 7.88 7.88 0 0 1-7.131 4.242 7.88 7.88 0 0 1-7.132-4.242A3.624 3.624 0 0 1 2.997 9.5Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M13 9.5A2.501 2.501 0 1 1 10.5 7"
            })
        ]
    });
var $9ac076dc8482fb71$export$2e2bcd8739ae039 = $9ac076dc8482fb71$var$SvgPreview;



parcelRequire("g5BLJ");
const $ce017f0b6ef8fbd0$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M16 2v4M8 2v4M3 9h18"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M19 4H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M7.013 12.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M12.013 12.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M17.013 12.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.013 16.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M12.013 16.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5"
            })
        ]
    });
var $ce017f0b6ef8fbd0$export$2e2bcd8739ae039 = $ce017f0b6ef8fbd0$var$SvgCalendar;



parcelRequire("g5BLJ");
const $9bd2a7624fcb8782$var$SvgLink = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: 1.5,
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M11.064 12.936a2.848 2.848 0 0 0 3.746 0l.936-.936A2.649 2.649 0 0 0 12 8.254"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M21.004 12A9.004 9.004 0 0 1 12 21.004 9.004 9.004 0 0 1 2.996 12 9.004 9.004 0 0 1 12 2.996 9.004 9.004 0 0 1 21.004 12Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12.936 11.064a2.848 2.848 0 0 0-3.746 0L8.254 12A2.649 2.649 0 0 0 12 15.746"
            })
        ]
    });
var $9bd2a7624fcb8782$export$2e2bcd8739ae039 = $9bd2a7624fcb8782$var$SvgLink;



parcelRequire("g5BLJ");
const $dd006fc1d4e12e07$var$SvgFilter = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 15,
        height: 16,
        viewBox: "0 0 15 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M9.48 8.688 13.6 4.566a.791.791 0 0 0 .232-.56V1.959a.792.792 0 0 0-.791-.792H1.958a.792.792 0 0 0-.791.792v2.047c0 .21.083.412.232.56L5.52 8.688",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M5.52 8.688v4.947a.99.99 0 0 0 1.23.96l1.98-.495a.99.99 0 0 0 .75-.96V8.687",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $dd006fc1d4e12e07$export$2e2bcd8739ae039 = $dd006fc1d4e12e07$var$SvgFilter;



parcelRequire("g5BLJ");
const $c380431bb08c2dd1$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 26,
        height: 26,
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 12.059,
                cy: 12.059,
                r: 7.062,
                stroke: "#A6ABB6",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "m21.003 21.003-3.951-3.951",
                stroke: "#A6ABB6",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $c380431bb08c2dd1$export$2e2bcd8739ae039 = $c380431bb08c2dd1$var$SvgSearch;



parcelRequire("g5BLJ");
const $c425336b096579c3$var$SvgFlag = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M5 21V3.93M19 14.02V4M5 14s.875-.727 3.5-.727S12.875 15 15.5 15s3.5-.977 3.5-.977M5 3.932S5.875 3 8.5 3s4.375 1.727 7 1.727S19 4 19 4",
            stroke: "inherit",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $c425336b096579c3$export$2e2bcd8739ae039 = $c425336b096579c3$var$SvgFlag;



parcelRequire("g5BLJ");
const $f8743bdda4516c0c$var$SvgDownload = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M12 17V3M20 21H4M17 12l-5.001 5.001-5-5.001",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $f8743bdda4516c0c$export$2e2bcd8739ae039 = $f8743bdda4516c0c$var$SvgDownload;



parcelRequire("g5BLJ");
const $4b0e8b28bcfc6458$var$SvgVisibilityHidden = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M14.558 13.558a3.003 3.003 0 1 1-4.114-4.115",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M17.997 16.997A9.873 9.873 0 0 1 12 19.003a9.457 9.457 0 0 1-8.558-5.09 4.323 4.323 0 0 1 0-3.825c.829-1.65 2.149-3.001 3.779-3.867M20.427 14.135c.04-.076.093-.144.13-.222a4.323 4.323 0 0 0 0-3.825A9.457 9.457 0 0 0 12 4.998c-.225 0-.444.03-.665.044M21.004 20.003 3.997 2.996",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $4b0e8b28bcfc6458$export$2e2bcd8739ae039 = $4b0e8b28bcfc6458$var$SvgVisibilityHidden;



parcelRequire("g5BLJ");
const $ab26ef1956078a9d$var$SvgVisibilityVisible = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M3.118 12.467a.987.987 0 0 1 0-.935C5.01 8.033 8.505 5 12 5s6.99 3.033 8.882 6.533a.987.987 0 0 1 0 .935C18.99 15.967 15.495 19 12 19s-6.99-3.033-8.882-6.533Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M14.121 9.879A3 3 0 1 1 9.88 14.12 3 3 0 0 1 14.12 9.88",
                stroke: "inherit",
                strokeWidth: 1.429,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $ab26ef1956078a9d$export$2e2bcd8739ae039 = $ab26ef1956078a9d$var$SvgVisibilityVisible;



parcelRequire("g5BLJ");
const $37e2aacc2e9a5b12$var$SvgModelReading = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M21.004 11.505v6.852a.996.996 0 0 1-.975.998A15.038 15.038 0 0 0 12 21.504a15.038 15.038 0 0 0-8.03-2.149.996.996 0 0 1-.974-.998v-6.852A1.497 1.497 0 0 1 4.582 10c2.608.084 5.156.807 7.418 2.107a15.905 15.905 0 0 1 7.418-2.107 1.497 1.497 0 0 1 1.586 1.504v0Z",
                stroke: "inherit",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12 12.108v9.396",
                stroke: "inherit",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 12,
                cy: 5.497,
                r: 3.001,
                stroke: "inherit",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $37e2aacc2e9a5b12$export$2e2bcd8739ae039 = $37e2aacc2e9a5b12$var$SvgModelReading;



parcelRequire("g5BLJ");
const $ab3060344d4eafe1$var$SvgExpand = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M7.5 11H3V6.5M7.5 2H12v4.5",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $ab3060344d4eafe1$export$2e2bcd8739ae039 = $ab3060344d4eafe1$var$SvgExpand;



parcelRequire("g5BLJ");
const $f3731f10b7fb9db9$var$SvgCollapse = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M1 9h4v4M13 5H9V1",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $f3731f10b7fb9db9$export$2e2bcd8739ae039 = $f3731f10b7fb9db9$var$SvgCollapse;



parcelRequire("g5BLJ");
const $c80085630b5a7eb1$var$SvgIcUp = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("g", {
            clipPath: "url('3e0e14fb0f8965b2')",
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    d: "M22 0a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h20Z",
                    fill: "#20C9AC"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    d: "m7.05 18.364 8.606-8.606v7.906l2-.007V6.343H6.344v1.994l7.899.007-8.606 8.606 1.414 1.414Z",
                    fill: "#fff"
                })
            ]
        })
    });
var $c80085630b5a7eb1$export$2e2bcd8739ae039 = $c80085630b5a7eb1$var$SvgIcUp;



parcelRequire("g5BLJ");
const $e8c40eaf6b11dfaf$var$SvgIcDown = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("g", {
            clipPath: "url('c42f04c895e1af91')",
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    d: "M2 0a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2Z",
                    fill: "#FC3400"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    d: "m6 7.414 8.605 8.606H6.7l.007 2h11.314V6.708h-1.994l-.007 7.898L7.414 6 6 7.414Z",
                    fill: "#fff"
                })
            ]
        })
    });
var $e8c40eaf6b11dfaf$export$2e2bcd8739ae039 = $e8c40eaf6b11dfaf$var$SvgIcDown;



parcelRequire("g5BLJ");
const $4c5c8dabaa0baa08$var$SvgVocab = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M20 18H7",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M7 21h12a1 1 0 0 0 1-1v-5H7a3 3 0 0 0-3 3v0a3 3 0 0 0 3 3Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M11 7h4M11 11h4M7 3v12M4 18V6a3 3 0 0 1 3-3h12a1 1 0 0 1 1 1v11",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $4c5c8dabaa0baa08$export$2e2bcd8739ae039 = $4c5c8dabaa0baa08$var$SvgVocab;



parcelRequire("g5BLJ");
const $103ebe2ef00af802$var$SvgFolder = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            clipRule: "evenodd",
            d: "M19 6.94h-6.471a1 1 0 0 1-.827-.438l-1.405-2.065A1 1 0 0 0 9.471 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.94a2 2 0 0 0-2-2Z"
        })
    });
var $103ebe2ef00af802$export$2e2bcd8739ae039 = $103ebe2ef00af802$var$SvgFolder;



parcelRequire("g5BLJ");
const $0d69d3eac81d1e71$var$SvgAddUser = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M18 20v-.75A4.25 4.25 0 0 0 13.75 15h-7.5A4.25 4.25 0 0 0 2 19.25V20",
                stroke: "inheri",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 10,
                cy: 7,
                r: 4,
                stroke: "inheri",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M19 9v4M21 11h-4",
                stroke: "inheri",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $0d69d3eac81d1e71$export$2e2bcd8739ae039 = $0d69d3eac81d1e71$var$SvgAddUser;



parcelRequire("g5BLJ");
const $50a905f9a273dbdc$var$SvgGraduationCap = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "m9.703 4.095-6.174 3.43c-1.298.721-1.298 2.587 0 3.308l6.174 3.43a4.733 4.733 0 0 0 4.594 0l6.174-3.43c1.298-.721 1.298-2.587 0-3.308l-6.174-3.43a4.733 4.733 0 0 0-4.594 0Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M5.991 12.2v3.924c0 .949.475 1.834 1.264 2.359l1.607 1.069a5.666 5.666 0 0 0 6.275 0l1.607-1.069a2.832 2.832 0 0 0 1.264-2.359V12.2"
            })
        ]
    });
var $50a905f9a273dbdc$export$2e2bcd8739ae039 = $50a905f9a273dbdc$var$SvgGraduationCap;



parcelRequire("g5BLJ");
const $cb8c6fe7862f24f7$var$SvgSticker = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "m18.175 19.832 1.95-1.951a3.001 3.001 0 0 0 .879-2.122v-8.76a4.002 4.002 0 0 0-4.002-4.002H6.998a4.002 4.002 0 0 0-4.002 4.001v10.004a4.002 4.002 0 0 0 4.002 4.002h8.346a4.001 4.001 0 0 0 2.83-1.172Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M15.001 21.004v-4.002a2 2 0 0 1 2.001-2h4.002M14 9l-3.124 5L9 11",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $cb8c6fe7862f24f7$export$2e2bcd8739ae039 = $cb8c6fe7862f24f7$var$SvgSticker;



parcelRequire("g5BLJ");
const $5cd338a3c9539e4d$var$SvgFeedbackGiven = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 26,
        height: 26,
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M23 7.352v8.072a3.352 3.352 0 0 1-3.351 3.354h-5.092L9.279 23v-4.222H7.352A3.352 3.352 0 0 1 4 15.425v0-8.073C4 5.501 5.5 4 7.352 4h12.296C21.499 4 23 5.5 23 7.352v0Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M13.659 12.493v-.207c0-.678.419-1.045.839-1.327.41-.276.821-.636.821-1.3A1.659 1.659 0 0 0 12 9.658M13.658 14.832a.148.148 0 0 0-.15.15.15.15 0 1 0 .15-.15",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $5cd338a3c9539e4d$export$2e2bcd8739ae039 = $5cd338a3c9539e4d$var$SvgFeedbackGiven;



parcelRequire("g5BLJ");
const $a869738a87acde64$var$SvgFeedbackViewed = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 26,
        height: 26,
        viewBox: "0 0 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M23 7.352v8.072a3.352 3.352 0 0 1-3.351 3.354h-5.092L9.279 23v-4.222H7.352A3.352 3.352 0 0 1 4 15.425v0-8.073C4 5.501 5.5 4 7.352 4h12.296C21.499 4 23 5.5 23 7.352v0Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M16.5 8.5 13.251 15 11 11.937",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $a869738a87acde64$export$2e2bcd8739ae039 = $a869738a87acde64$var$SvgFeedbackViewed;



parcelRequire("g5BLJ");
const $d569caaf0139686b$var$SvgEditAvatar = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M10 3.467c1.133 1.133 1.133 2.933 0 4-1.133 1.066-2.933 1.133-4 0-1.067-1.134-1.133-2.934 0-4a2.9 2.9 0 0 1 4 0M2.667 13.333c0-1.666 1.333-3 3-3H7.4",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M9.333 14h1.534l2.266-2.267a.645.645 0 0 0 0-.933l-.6-.6a.645.645 0 0 0-.933 0l-2.267 2.267V14h0Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $d569caaf0139686b$export$2e2bcd8739ae039 = $d569caaf0139686b$var$SvgEditAvatar;



parcelRequire("g5BLJ");
const $a4458a8c3b81f078$var$SvgDice = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "m6.998 21.004-.002.75h.002v-.75Zm10.004 0v.75h.002l-.002-.75Zm4.002-4.002.75.002v-.002h-.75Zm0-10.004h.75v-.002l-.75.002Zm-4.002-4.002.002-.75h-.002v.75Zm-10.004 0v-.75h-.002l.002.75ZM2.996 6.998l-.75-.002v.002h.75Zm0 10.004h-.75v.002l.75-.002Zm14.756-9.504a.75.75 0 0 0-1.5 0h1.5Zm-1.25.25a.75.75 0 0 0 0-1.5v1.5Zm0-1.5a.75.75 0 1 0 0 1.5v-1.5Zm-.25 1.25a.75.75 0 0 0 1.5 0h-1.5Zm-7.504 0a.75.75 0 0 0-1.5 0h1.5Zm-1.25.25a.75.75 0 1 0 0-1.5v1.5Zm0-1.5a.75.75 0 0 0 0 1.5v-1.5Zm-.25 1.25a.75.75 0 0 0 1.5 0h-1.5ZM13.25 12a.75.75 0 0 0-1.5 0h1.5Zm-1.25.25a.75.75 0 0 0 0-1.5v1.5Zm0-1.5a.75.75 0 0 0 0 1.5v-1.5ZM11.75 12a.75.75 0 1 0 1.5 0h-1.5Zm6.002 4.502a.75.75 0 0 0-1.5 0h1.5Zm-1.25.25a.75.75 0 0 0 0-1.5v1.5Zm0-1.5a.75.75 0 1 0 0 1.5v-1.5Zm-.25 1.25a.75.75 0 0 0 1.5 0h-1.5Zm-7.504 0a.75.75 0 0 0-1.5 0h1.5Zm-1.25.25a.75.75 0 0 0 0-1.5v1.5Zm0-1.5a.75.75 0 0 0 0 1.5v-1.5Zm-.25 1.25a.75.75 0 0 0 1.5 0h-1.5Zm-.25 5.252h10.004v-1.5H6.998v1.5Zm10.006 0a4.763 4.763 0 0 0 4.75-4.75l-1.5-.004A3.263 3.263 0 0 1 17 20.254l.004 1.5Zm4.75-4.752V6.998h-1.5v10.004h1.5Zm0-10.006a4.763 4.763 0 0 0-4.75-4.75L17 3.746A3.263 3.263 0 0 1 20.254 7l1.5-.004Zm-4.752-4.75H6.998v1.5h10.004v-1.5Zm-10.006 0a4.763 4.763 0 0 0-4.75 4.75l1.5.004A3.263 3.263 0 0 1 7 3.746l-.004-1.5Zm-4.75 4.752v10.004h1.5V6.998h-1.5Zm0 10.006a4.763 4.763 0 0 0 4.75 4.75l.004-1.5A3.263 3.263 0 0 1 3.746 17l-1.5.004Zm14.006-9.506a.25.25 0 0 1 .25-.25v1.5c.69 0 1.25-.56 1.25-1.25h-1.5Zm.25-.25a.25.25 0 0 1 .25.25h-1.5c0 .69.56 1.25 1.25 1.25v-1.5Zm.25.25a.25.25 0 0 1-.25.25v-1.5c-.69 0-1.25.56-1.25 1.25h1.5Zm-.25.25a.25.25 0 0 1-.25-.25h1.5c0-.69-.56-1.25-1.25-1.25v1.5Zm-9.254-.25a.25.25 0 0 1 .25-.25v1.5c.69 0 1.25-.56 1.25-1.25h-1.5Zm.25-.25a.25.25 0 0 1 .25.25h-1.5c0 .69.56 1.25 1.25 1.25v-1.5Zm.25.25a.25.25 0 0 1-.25.25v-1.5c-.69 0-1.25.56-1.25 1.25h1.5Zm-.25.25a.25.25 0 0 1-.25-.25h1.5c0-.69-.56-1.25-1.25-1.25v1.5ZM11.75 12a.25.25 0 0 1 .25-.25v1.5c.69 0 1.25-.56 1.25-1.25h-1.5Zm.25-.25a.25.25 0 0 1 .25.25h-1.5c0 .69.56 1.25 1.25 1.25v-1.5Zm.25.25a.25.25 0 0 1-.25.25v-1.5c-.69 0-1.25.56-1.25 1.25h1.5Zm-.25.25a.25.25 0 0 1-.25-.25h1.5c0-.69-.56-1.25-1.25-1.25v1.5Zm4.252 4.252a.25.25 0 0 1 .25-.25v1.5c.69 0 1.25-.56 1.25-1.25h-1.5Zm.25-.25a.25.25 0 0 1 .25.25h-1.5c0 .69.56 1.25 1.25 1.25v-1.5Zm.25.25a.25.25 0 0 1-.25.25v-1.5c-.69 0-1.25.56-1.25 1.25h1.5Zm-.25.25a.25.25 0 0 1-.25-.25h1.5c0-.69-.56-1.25-1.25-1.25v1.5Zm-9.254-.25a.25.25 0 0 1 .25-.25v1.5c.69 0 1.25-.56 1.25-1.25h-1.5Zm.25-.25a.25.25 0 0 1 .25.25h-1.5c0 .69.56 1.25 1.25 1.25v-1.5Zm.25.25a.25.25 0 0 1-.25.25v-1.5c-.69 0-1.25.56-1.25 1.25h1.5Zm-.25.25a.25.25 0 0 1-.25-.25h1.5c0-.69-.56-1.25-1.25-1.25v1.5Z",
            fill: "inherit"
        })
    });
var $a4458a8c3b81f078$export$2e2bcd8739ae039 = $a4458a8c3b81f078$var$SvgDice;



parcelRequire("g5BLJ");
const $24699b838d3938df$var$SvgUltimateAssignment = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 400,
        height: 400,
        viewBox: "0 0 400 400",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M73.864 107h-.028a11.713 11.713 0 0 0-8.335 3.46A11.884 11.884 0 0 0 62 118.921v178.752c0 6.554 5.343 11.901 11.911 11.918 27.691.066 74.084 5.85 106.089 39.409V161.932c0-2.222-.566-4.31-1.635-6.037-26.268-42.389-76.747-48.83-104.5-48.895ZM317 297.675V118.921c0-3.199-1.245-6.204-3.502-8.461a11.716 11.716 0 0 0-8.333-3.46h-.03c-27.753.066-78.231 6.507-104.501 48.896-1.069 1.728-1.634 3.815-1.634 6.037V349c32.005-33.559 78.398-39.343 106.09-39.409 6.566-.017 11.91-5.364 11.91-11.916Z",
                fill: "#325FFF"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M344.064 148h-8.658v149.251c0 16.714-13.655 30.344-30.444 30.385-23.572.055-62.437 4.651-89.962 30.629 47.605-11.622 97.791-4.067 126.392 2.432 3.57.812 7.26-.026 10.122-2.3a11.825 11.825 0 0 0 4.486-9.299V159.903c.002-6.563-5.355-11.903-11.936-11.903ZM43.593 297.253V148h-8.656C28.357 148 23 153.34 23 159.903v189.194c0 3.64 1.636 7.03 4.487 9.299a11.935 11.935 0 0 0 10.122 2.301c28.601-6.501 78.787-14.055 126.391-2.432-27.525-25.977-66.39-30.571-89.962-30.628-16.787-.04-30.444-13.67-30.444-30.384Z",
                fill: "#325FFF"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("g", {
                clipPath: "url('44d159beab1d5b31')",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M259.901 266h-3.802c0-29.966-11.601-56.165-34.782-78.561-23.181-22.395-50.281-33.602-81.317-33.602v-3.674c31.036 0 58.136-11.207 81.317-33.658C244.498 94.054 256.099 67.873 256.099 38h3.802c0 29.966 11.601 56.165 34.782 78.561 23.181 22.395 50.281 33.602 81.317 33.602v3.674c-31.017 0-58.136 11.207-81.317 33.602-23.181 22.396-34.782 48.577-34.782 78.561Z",
                    fill: "#F0AD4E"
                })
            })
        ]
    });
var $24699b838d3938df$export$2e2bcd8739ae039 = $24699b838d3938df$var$SvgUltimateAssignment;



parcelRequire("g5BLJ");
const $d2dabe186fd3daf4$var$SvgUltimateAssignmentCentered = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 400,
        height: 400,
        viewBox: "0 0 400 400",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M88.864 76h-.028a11.713 11.713 0 0 0-8.335 3.46A11.884 11.884 0 0 0 77 87.921v178.752c0 6.554 5.343 11.901 11.911 11.918 27.691.066 74.084 5.85 106.089 39.409V130.932c0-2.222-.566-4.31-1.635-6.037-26.268-42.389-76.747-48.83-104.5-48.895ZM332 266.675V87.921c0-3.199-1.245-6.204-3.502-8.461a11.716 11.716 0 0 0-8.333-3.46h-.03c-27.753.066-78.231 6.507-104.501 48.896-1.069 1.728-1.634 3.815-1.634 6.037V318c32.005-33.559 78.398-39.343 106.09-39.409 6.566-.017 11.91-5.364 11.91-11.916Z",
                fill: "#325FFF"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M359.064 117h-8.658v149.251c0 16.714-13.655 30.344-30.444 30.385-23.572.055-62.437 4.651-89.962 30.629 47.605-11.622 97.791-4.067 126.392 2.432 3.57.812 7.26-.026 10.122-2.3a11.825 11.825 0 0 0 4.486-9.299V128.903c.002-6.563-5.355-11.903-11.936-11.903ZM58.593 266.253V117h-8.656C43.357 117 38 122.34 38 128.903v189.194c0 3.64 1.636 7.03 4.487 9.299a11.935 11.935 0 0 0 10.122 2.301c28.601-6.501 78.787-14.055 126.391-2.432-27.525-25.977-66.391-30.571-89.962-30.628-16.787-.04-30.444-13.67-30.444-30.384Z",
                fill: "#325FFF"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M274.901 235h-3.802c0-29.966-11.601-56.165-34.782-78.561-23.181-22.395-50.281-33.602-81.317-33.602v-3.674c31.036 0 58.136-11.207 81.317-33.658C259.498 63.054 271.099 36.873 271.099 7h3.802c0 29.966 11.601 56.165 34.782 78.561 23.181 22.395 50.281 33.602 81.317 33.602v3.674c-31.017 0-58.136 11.207-81.317 33.602-23.181 22.396-34.782 48.577-34.782 78.561Z",
                fill: "#F0AD4E"
            })
        ]
    });
var $d2dabe186fd3daf4$export$2e2bcd8739ae039 = $d2dabe186fd3daf4$var$SvgUltimateAssignmentCentered;



parcelRequire("g5BLJ");
const $9b70eab2c9ddbc15$var$SvgToken = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 200,
        height: 200,
        viewBox: "0 0 200 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 100,
                cy: 100,
                r: 100,
                fill: "#FFD600"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M123.962 110.153c9.271-4.676 15.452-13.003 15.452-25.302C139.414 67.043 126.38 55 106.965 55H68v85.251c0 2.623 2.202 4.749 4.918 4.749h8.37c2.716 0 4.918-2.126 4.918-4.749v-25.486h15.788c1.545 0 3.023-.064 4.501-.128l13.451 27.634c.811 1.666 2.545 2.729 4.451 2.729h9.512c3.647 0 6.026-3.7 4.407-6.856l-14.354-27.991ZM86.206 70.95h19.214c8.868 0 15.519 5.189 15.519 13.965 0 8.455-6.248 14.284-15.586 14.284H86.206V70.95Z",
                fill: "#00F"
            })
        ]
    });
var $9b70eab2c9ddbc15$export$2e2bcd8739ae039 = $9b70eab2c9ddbc15$var$SvgToken;



parcelRequire("g5BLJ");
const $e0fedea0cb17e9fa$var$SvgZoomIn = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M14.193 5.582a5.97 5.97 0 1 1-8.444 8.444 5.97 5.97 0 0 1 8.444-8.444M14.15 14.06 20 19.99M8 10h4M10 12V8",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $e0fedea0cb17e9fa$export$2e2bcd8739ae039 = $e0fedea0cb17e9fa$var$SvgZoomIn;



parcelRequire("g5BLJ");
const $8a6b3f8b260d9ffd$var$SvgZoomOut = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M14.193 5.582a5.97 5.97 0 1 1-8.444 8.444 5.97 5.97 0 0 1 8.444-8.444M14.15 14.06 20 19.99M8 10h4",
            stroke: "inherit",
            strokeWidth: 1.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
var $8a6b3f8b260d9ffd$export$2e2bcd8739ae039 = $8a6b3f8b260d9ffd$var$SvgZoomOut;



parcelRequire("g5BLJ");
const $505404560c715c0a$var$SvgRotate = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M20.991 12.035a8.96 8.96 0 0 1-2.627 6.328 9 9 0 0 1-12.728 0 9.014 9.014 0 0 1-1.537-2.06M3.005 11.854a8.964 8.964 0 0 1 2.631-6.218 9.001 9.001 0 0 1 12.728 0 9.036 9.036 0 0 1 1.537 2.06",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M17.612 7.696h2.812V4.883M6.388 16.303H3.576v2.812M14.475 9.525a3.5 3.5 0 1 1-4.95 4.95 3.5 3.5 0 0 1 4.95-4.95",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $505404560c715c0a$export$2e2bcd8739ae039 = $505404560c715c0a$var$SvgRotate;



parcelRequire("g5BLJ");
const $5b7b651c90a4e456$var$SvgPaperLogo = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 25,
        height: 24,
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("g", {
            clipPath: "url('b5460ee464fa6d9e')",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    d: "M.5 0v24h3.8l2.4-.8 16.2.8.4-6.6 1.2-.4V0H.5Z",
                    fill: "#0E0FE0"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                    d: "M7.692 5.628h5.596c2.922 0 5.328.784 5.328 4.135 0 3.51-2.601 4.633-6.237 4.633h-1.89l-.659 3.707H5.5L7.692 5.628Zm4.509 5.739c1.283 0 1.978-.321 1.978-1.497 0-.998-.624-1.177-1.55-1.177h-1.141l-.464 2.674h1.177Z",
                    fill: "#fff"
                })
            ]
        })
    });
var $5b7b651c90a4e456$export$2e2bcd8739ae039 = $5b7b651c90a4e456$var$SvgPaperLogo;



parcelRequire("g5BLJ");
const $25c25acbf3a994a8$var$SvgSave = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 25,
        height: 25,
        viewBox: "0 0 25 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "M19.421 21.427H5.519a2 2 0 0 1-2-1.986L3.413 5.435A2.001 2.001 0 0 1 5.415 3.42h11.177a2 2 0 0 1 1.414.587l2.83 2.829c.375.375.586.884.586 1.414v11.177a2 2 0 0 1-2.001 2Z",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M16.413 3.42V7.42a1 1 0 0 1-1 1H9.41a1 1 0 0 1-1-1V3.42",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 12.418,
                cy: 14.924,
                r: 2.501,
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $25c25acbf3a994a8$export$2e2bcd8739ae039 = $25c25acbf3a994a8$var$SvgSave;



parcelRequire("g5BLJ");
const $938457ab46d57ac6$var$SvgRedo = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 25,
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M12 4.42a8.003 8.003 0 1 0 3.827.973"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M15.827 8.47V4.931h3.537"
            })
        ]
    });
var $938457ab46d57ac6$export$2e2bcd8739ae039 = $938457ab46d57ac6$var$SvgRedo;



parcelRequire("g5BLJ");
const $a7817bc6fe45e70b$var$SvgRecordingStatus = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 31,
        height: 32,
        viewBox: "0 0 31 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 15.5,
                cy: 16,
                r: 15.5,
                opacity: "50%"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 15.5,
                cy: 16,
                r: 7.5
            })
        ]
    });
var $a7817bc6fe45e70b$export$2e2bcd8739ae039 = $a7817bc6fe45e70b$var$SvgRecordingStatus;



parcelRequire("g5BLJ");
const $ad5655279e17c83c$var$SvgCheckmarkCircle = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("circle", {
                cx: 10.949,
                cy: 10,
                r: 7.503,
                fill: "currentColor",
                stroke: "inherit",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "m7.985 10.283 1.806 1.806-.011-.011 4.075-4.076",
                stroke: "#fff",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $ad5655279e17c83c$export$2e2bcd8739ae039 = $ad5655279e17c83c$var$SvgCheckmarkCircle;



parcelRequire("g5BLJ");
const $8b4d78c798ba2ffb$var$SvgPlaybackSpeed = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M5.207 17.9a8.982 8.982 0 0 0 5.128 2.944L5.207 17.9Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M13.633 3.152a8.997 8.997 0 0 1 0 17.696M10.367 3.152A8.98 8.98 0 0 0 7.5 4.207m2.867 16.641A8.992 8.992 0 0 1 6 18.708M4.206 7.5a8.97 8.97 0 0 0-.982 2.5m.484 5.5a8.956 8.956 0 0 1-.583-2",
                stroke: "#323232",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                clipRule: "evenodd",
                d: "m10.937 9.057 3.884 2.297a.75.75 0 0 1 0 1.292l-3.884 2.297a.75.75 0 0 1-1.132-.647V9.703a.75.75 0 0 1 1.132-.646v0Z",
                stroke: "#323232",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $8b4d78c798ba2ffb$export$2e2bcd8739ae039 = $8b4d78c798ba2ffb$var$SvgPlaybackSpeed;



parcelRequire("g5BLJ");
const $0d1b5e5662d9c433$var$SvgResync = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 23,
        height: 22,
        viewBox: "0 0 23 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M22.5 11a10.98 10.98 0 0 1-3.234 7.778A11.063 11.063 0 0 1 11.46 22c-14.613-.502-14.61-21.498 0-22 2.928 0 5.736 1.159 7.807 3.222A10.98 10.98 0 0 1 22.5 11Z",
                fill: "#3263FF"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M6.795 14.261a5.63 5.63 0 0 1 .668-7.278l-.066 1.2 1.444.075.206-3.536-3.59-.193-.078 1.423 1.046.055a7.107 7.107 0 0 0-1.913 3.628 7.045 7.045 0 0 0 .42 4.068 7.164 7.164 0 0 0 2.615 3.174 7.32 7.32 0 0 0 3.954 1.24v-1.422a5.846 5.846 0 0 1-2.654-.652 5.751 5.751 0 0 1-2.052-1.782ZM17.35 6.95a7.114 7.114 0 0 0-2.55-2.26 7.045 7.045 0 0 0-3.3-.807v1.431a5.658 5.658 0 0 1 3.155.983A5.732 5.732 0 0 1 16.74 8.88a5.789 5.789 0 0 1 .311 3.316 5.758 5.758 0 0 1-1.567 2.933l.014-1.246-1.418-.018-.043 3.564 3.533.041.016-1.431-.983-.01a7.204 7.204 0 0 0 .748-9.08Z",
                fill: "#fff"
            })
        ]
    });
var $0d1b5e5662d9c433$export$2e2bcd8739ae039 = $0d1b5e5662d9c433$var$SvgResync;



parcelRequire("g5BLJ");
const $28e0f9a7d37aff17$var$SvgQuestion = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: 24,
        viewBox: "0 -960 960 960",
        width: 24,
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            stroke: "inherit",
            strokeWidth: 1.5,
            d: "M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
        })
    });
var $28e0f9a7d37aff17$export$2e2bcd8739ae039 = $28e0f9a7d37aff17$var$SvgQuestion;



const $10bc7d3c3c9731ce$export$6d49a893c897b0cc = {
    info: (0, $b7bd4e22c3cde653$export$2e2bcd8739ae039),
    microphone: (0, $0919d31e443ef174$export$2e2bcd8739ae039),
    user: (0, $293cb21149cfce9a$export$2e2bcd8739ae039),
    settings: (0, $c0eb085ad83ca7e2$export$2e2bcd8739ae039),
    group: (0, $846099589d31fa5a$export$2e2bcd8739ae039),
    users: (0, $53c6bed73b60c260$export$2e2bcd8739ae039),
    arrowDown: (0, $cd8184fc24b42937$export$2e2bcd8739ae039),
    arrowUp: (0, $47424e8c742837f6$export$2e2bcd8739ae039),
    sortDown: (0, $fd083eefbfaa2a17$export$2e2bcd8739ae039),
    sortUp: (0, $6bf75a755e7f8570$export$2e2bcd8739ae039),
    arrowRight: (0, $93a25dad33a05086$export$2e2bcd8739ae039),
    arrowLeft: (0, $06bebe4b0b4e2cc8$export$2e2bcd8739ae039),
    menu: (0, $1da2deea652b77f1$export$2e2bcd8739ae039),
    selectArrowUp: (0, $23742681c932d58e$export$2e2bcd8739ae039),
    selectArrowDown: (0, $5fc92a93ed76337d$export$2e2bcd8739ae039),
    chatBubble: (0, $2369ad2d37acf59f$export$2e2bcd8739ae039),
    headphones: (0, $50ed3d16f49db65f$export$2e2bcd8739ae039),
    task: (0, $4ad42f8ecaf9f480$export$2e2bcd8739ae039),
    play: (0, $fe8e08342d55025e$export$2e2bcd8739ae039),
    pause: (0, $46d6f05242654fb6$export$2e2bcd8739ae039),
    backFiveSeconds: (0, $dda62f79b3745e94$export$2e2bcd8739ae039),
    forwardFiveSeconds: (0, $2ead01fbc64994e2$export$2e2bcd8739ae039),
    threeVerticalDots: (0, $1ffe3ccc6f02d018$export$2e2bcd8739ae039),
    threeHorizontalDots: (0, $6bafc4b38f3cb7dd$export$2e2bcd8739ae039),
    stop: (0, $036d3204b05ae039$export$2e2bcd8739ae039),
    text: (0, $61499f5088cb8e63$export$2e2bcd8739ae039),
    backArrow: (0, $be79b820601f3361$export$2e2bcd8739ae039),
    forwardArrow: (0, $60d64694233929c3$export$2e2bcd8739ae039),
    book: (0, $e849d92084f14fac$export$2e2bcd8739ae039),
    copy: (0, $0154e479338520bd$export$2e2bcd8739ae039),
    check: (0, $4c35734d13be34c0$export$2e2bcd8739ae039),
    checkboxChecked: (0, $5f0c52e309119168$export$2e2bcd8739ae039),
    checkboxUnchecked: (0, $ebc0d6d9de5d09fe$export$2e2bcd8739ae039),
    close: (0, $85802442c73ba47f$export$2e2bcd8739ae039),
    sync: (0, $45b363f444944a71$export$2e2bcd8739ae039),
    eye: (0, $99a197fa792cd974$export$2e2bcd8739ae039),
    picture: (0, $64b72209f4695b43$export$2e2bcd8739ae039),
    preview: (0, $9ac076dc8482fb71$export$2e2bcd8739ae039),
    visibilityHidden: (0, $4b0e8b28bcfc6458$export$2e2bcd8739ae039),
    visibilityVisible: (0, $ab26ef1956078a9d$export$2e2bcd8739ae039),
    checkmark: (0, $346869215e059663$export$2e2bcd8739ae039),
    plus: (0, $a2e008828e494784$export$2e2bcd8739ae039),
    pdf: (0, $e0de999f3b9a29cc$export$2e2bcd8739ae039),
    add: (0, $0cd29884abfd51b5$export$2e2bcd8739ae039),
    hourglass: (0, $f6b615a02f3c130f$export$2e2bcd8739ae039),
    speedometer: (0, $ffed6c569fcbc6d0$export$2e2bcd8739ae039),
    star: (0, $20cf88857d19edd8$export$2e2bcd8739ae039),
    typedText: (0, $b93031204a571ee0$export$2e2bcd8739ae039),
    upload: (0, $3673364e03ec9a97$export$2e2bcd8739ae039),
    trash: (0, $1782735168b095f7$export$2e2bcd8739ae039),
    edit: (0, $75c1aa438ed076fa$export$2e2bcd8739ae039),
    pencil: (0, $08615baf68eca345$export$2e2bcd8739ae039),
    speaker: (0, $1394cec4a1c526b7$export$2e2bcd8739ae039),
    calendar: (0, $ce017f0b6ef8fbd0$export$2e2bcd8739ae039),
    link: (0, $9bd2a7624fcb8782$export$2e2bcd8739ae039),
    filter: (0, $dd006fc1d4e12e07$export$2e2bcd8739ae039),
    search: (0, $c380431bb08c2dd1$export$2e2bcd8739ae039),
    flag: (0, $c425336b096579c3$export$2e2bcd8739ae039),
    download: (0, $f8743bdda4516c0c$export$2e2bcd8739ae039),
    modelReading: (0, $37e2aacc2e9a5b12$export$2e2bcd8739ae039),
    expand: (0, $ab3060344d4eafe1$export$2e2bcd8739ae039),
    collapse: (0, $f3731f10b7fb9db9$export$2e2bcd8739ae039),
    increase: (0, $c80085630b5a7eb1$export$2e2bcd8739ae039),
    decrease: (0, $e8c40eaf6b11dfaf$export$2e2bcd8739ae039),
    vocab: (0, $4c5c8dabaa0baa08$export$2e2bcd8739ae039),
    folder: (0, $103ebe2ef00af802$export$2e2bcd8739ae039),
    graduationCap: (0, $50a905f9a273dbdc$export$2e2bcd8739ae039),
    sticker: (0, $cb8c6fe7862f24f7$export$2e2bcd8739ae039),
    ultimateAssignment: (0, $24699b838d3938df$export$2e2bcd8739ae039),
    ultimateAssignmentCentered: (0, $d2dabe186fd3daf4$export$2e2bcd8739ae039),
    feedbackGiven: (0, $5cd338a3c9539e4d$export$2e2bcd8739ae039),
    feedbackViewed: (0, $a869738a87acde64$export$2e2bcd8739ae039),
    editAvatar: (0, $d569caaf0139686b$export$2e2bcd8739ae039),
    dice: (0, $a4458a8c3b81f078$export$2e2bcd8739ae039),
    addUser: (0, $0d69d3eac81d1e71$export$2e2bcd8739ae039),
    token: (0, $9b70eab2c9ddbc15$export$2e2bcd8739ae039),
    zoomIn: (0, $e0fedea0cb17e9fa$export$2e2bcd8739ae039),
    zoomOut: (0, $8a6b3f8b260d9ffd$export$2e2bcd8739ae039),
    rotate: (0, $505404560c715c0a$export$2e2bcd8739ae039),
    paperLogo: (0, $5b7b651c90a4e456$export$2e2bcd8739ae039),
    save: (0, $25c25acbf3a994a8$export$2e2bcd8739ae039),
    redo: (0, $938457ab46d57ac6$export$2e2bcd8739ae039),
    recordingStatus: (0, $a7817bc6fe45e70b$export$2e2bcd8739ae039),
    checkmarkCircle: (0, $ad5655279e17c83c$export$2e2bcd8739ae039),
    playbackSpeed: (0, $8b4d78c798ba2ffb$export$2e2bcd8739ae039),
    resync: (0, $0d1b5e5662d9c433$export$2e2bcd8739ae039),
    question: (0, $28e0f9a7d37aff17$export$2e2bcd8739ae039)
};
const $10bc7d3c3c9731ce$var$getColor = (color)=>color === "currentColor" ? color : (0, $24b764039c44d1ec$export$8f45430ccf837300)[color].hex;
const $10bc7d3c3c9731ce$export$f04a61298a47a40f = ({ icon: icon , size: size = "1em" , color: color = "currentColor" , cssColor: cssColor , fill: fill = false , fillColor: fillColor = color , flexShrink: flexShrink , testTag: testTag , ...props })=>{
    const El = $10bc7d3c3c9731ce$export$6d49a893c897b0cc[icon];
    const actualColor = cssColor ?? $10bc7d3c3c9731ce$var$getColor(color);
    const actualFillColor = fill ? cssColor || $10bc7d3c3c9731ce$var$getColor(fillColor) : "none";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(El, {
        width: size,
        height: size,
        stroke: actualColor,
        fill: actualFillColor,
        style: {
            flexShrink: flexShrink
        },
        color: actualColor,
        "data-test-tag": testTag,
        ...props
    });
};



var $4af3e593a95aead8$exports = {};

$4af3e593a95aead8$exports = new URL((parcelRequire("3TfdU")).resolve("hpbSp"), import.meta.url).toString();


var $96106242d02d5e02$exports = {};

$96106242d02d5e02$exports = new URL((parcelRequire("3TfdU")).resolve("ekieh"), import.meta.url).toString();




const $f68f5c84230354d9$var$LmsIconStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).img.withConfig({
    displayName: "LmsIcon__LmsIconStyles",
    componentId: "sc-1exnh30-0"
})([
    "width:18px;height:18px;margin-right:",
    ";"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]);
const $f68f5c84230354d9$export$646ed93d2b98e357 = ({ lms: lms  })=>lms === "-" ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f68f5c84230354d9$var$LmsIconStyles, {
        src: lms === "Google" ? (0, (/*@__PURE__*/$parcel$interopDefault($4af3e593a95aead8$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($96106242d02d5e02$exports))),
        alt: lms
    });







const $673ec96213c6e29e$var$ellipsisCss = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
]);
const $673ec96213c6e29e$var$commonCss = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " letter-spacing:0;text-decoration:none;margin:0;font-style:",
    ";text-align:",
    ";white-space:",
    ";display:",
    ";text-transform:",
    ";word-break:",
    ";color:",
    ";:hover{color:",
    ";}",
    " ",
    " ",
    " ",
    ""
], ({ $minWidth: $minWidth , $maxWidth: $maxWidth , $minHeight: $minHeight , $maxHeight: $maxHeight , $overflowY: $overflowY , $padding: $padding  })=>`
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("min-width", $minWidth)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("max-width", $maxWidth)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("min-height", $minHeight)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("max-height", $maxHeight)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("overflow-y", $overflowY)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("padding", $padding)}
  `, ({ $fontStyle: $fontStyle  })=>$fontStyle, ({ $textAlign: $textAlign  })=>$textAlign, ({ $whiteSpace: $whiteSpace  })=>$whiteSpace, ({ $display: $display  })=>$display, ({ $textTransform: $textTransform  })=>$textTransform, ({ $wordBreak: $wordBreak  })=>$wordBreak, ({ $color: $color , $blurrify: $blurrify  })=>{
    if ($blurrify) return "transparent";
    else if ($color) return (0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex;
    else return "inherit";
}, ({ $color: $color , $blurrify: $blurrify , $hoverColor: $hoverColor  })=>{
    if ($blurrify) return "transparent";
    else if ($hoverColor) return (0, $24b764039c44d1ec$export$8f45430ccf837300)[$hoverColor].hex;
    else if ($color) return (0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex;
    else return "inherit";
}, ({ $ellipsis: $ellipsis  })=>$ellipsis && $673ec96213c6e29e$var$ellipsisCss, ({ $ellipsisAtOrBelow: $ellipsisAtOrBelow  })=>$ellipsisAtOrBelow && (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "@media (max-width:",
        "px){",
        "}"
    ], (0, $4fd3b1c7dfff02ca$export$d07517a676ce386f)[$ellipsisAtOrBelow], $673ec96213c6e29e$var$ellipsisCss), ({ $blurrify: $blurrify , $color: $color  })=>$blurrify && (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "text-shadow:0 0 7px ",
        ";user-select:none;"
    ], $color ? (0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex : "inherit"), ({ $flexGrow: $flexGrow  })=>(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("flex-grow", $flexGrow));
const $673ec96213c6e29e$var$overrideCss = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    ""
], ({ $sizeOverride: $sizeOverride , $weightOverride: $weightOverride , $lineHeightOverride: $lineHeightOverride  })=>`
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("font-size", `${$sizeOverride}px`)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("font-weight", $weightOverride ? (0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861)[$weightOverride] : undefined)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("line-height", $lineHeightOverride)}
  `);
const $673ec96213c6e29e$export$911e9fe6c3536bd5 = {
    h1: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).h1.withConfig({
        displayName: "Text__h1",
        componentId: "sc-hcm8l1-0"
    })([
        "",
        " font-weight:700;font-size:30px;line-height:130%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, $673ec96213c6e29e$var$overrideCss),
    h2: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).h2.withConfig({
        displayName: "Text__h2",
        componentId: "sc-hcm8l1-1"
    })([
        "",
        " font-weight:700;font-size:26px;line-height:120%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, $673ec96213c6e29e$var$overrideCss),
    h3: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).h3.withConfig({
        displayName: "Text__h3",
        componentId: "sc-hcm8l1-2"
    })([
        "",
        " font-weight:700;font-size:20px;line-height:140%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, $673ec96213c6e29e$var$overrideCss),
    h4: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).h4.withConfig({
        displayName: "Text__h4",
        componentId: "sc-hcm8l1-3"
    })([
        "",
        " font-weight:600;font-size:18px;line-height:140%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, $673ec96213c6e29e$var$overrideCss),
    h5: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).h5.withConfig({
        displayName: "Text__h5",
        componentId: "sc-hcm8l1-4"
    })([
        "",
        " font-weight:600;font-size:16px;line-height:140%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, $673ec96213c6e29e$var$overrideCss),
    h6: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).h6.withConfig({
        displayName: "Text__h6",
        componentId: "sc-hcm8l1-5"
    })([
        "",
        " font-weight:600;font-size:",
        "px;line-height:145%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, (0, $18ffa0398cff6303$export$22ea553521eefdfc), $673ec96213c6e29e$var$overrideCss),
    h7: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).p.withConfig({
        displayName: "Text__h7",
        componentId: "sc-hcm8l1-6"
    })([
        "",
        " font-weight:600;font-size:12px;line-height:120%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, $673ec96213c6e29e$var$overrideCss),
    largeText: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).p.withConfig({
        displayName: "Text__largeText",
        componentId: "sc-hcm8l1-7"
    })([
        "",
        " font-weight:500;font-size:16px;line-height:150%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, $673ec96213c6e29e$var$overrideCss),
    normalText: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).p.withConfig({
        displayName: "Text__normalText",
        componentId: "sc-hcm8l1-8"
    })([
        "",
        " font-weight:500;font-size:",
        "px;line-height:140%;overflow-wrap:break-word;",
        ""
    ], $673ec96213c6e29e$var$commonCss, (0, $18ffa0398cff6303$export$22ea553521eefdfc), $673ec96213c6e29e$var$overrideCss),
    ins: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).ins.withConfig({
        displayName: "Text__ins",
        componentId: "sc-hcm8l1-9"
    })([
        "",
        " font-weight:500;font-size:",
        "px;line-height:140%;text-decoration:none;",
        ""
    ], $673ec96213c6e29e$var$commonCss, (0, $18ffa0398cff6303$export$22ea553521eefdfc), $673ec96213c6e29e$var$overrideCss),
    del: (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).del.withConfig({
        displayName: "Text__del",
        componentId: "sc-hcm8l1-10"
    })([
        "",
        " font-weight:500;font-size:",
        "px;line-height:140%;",
        ""
    ], $673ec96213c6e29e$var$commonCss, (0, $18ffa0398cff6303$export$22ea553521eefdfc), $673ec96213c6e29e$var$overrideCss)
};
const $673ec96213c6e29e$var$defaultTextColor = (variant, color, blurrify)=>{
    if (color) return color;
    if (variant === "ins") return "readleeBlue";
    else if (variant === "del") return "danger";
    else if (blurrify) return color || "black";
    else return color;
};
const $673ec96213c6e29e$export$5f1af8db9871e1d6 = ({ variant: variant = "normalText" , children: children , color: color , hoverColor: hoverColor , whiteSpace: whiteSpace = "normal" , fontStyle: fontStyle = "normal" , display: display = "block" , textAlign: textAlign = "inherit" , sizeOverride: sizeOverride = false , weightOverride: weightOverride = false , lineHeightOverride: lineHeightOverride = false , minWidth: minWidth = "initial" , maxWidth: maxWidth = "initial" , minHeight: minHeight = "initial" , maxHeight: maxHeight = "initial" , textTransform: textTransform = "none" , wordBreak: wordBreak = "normal" , testTag: testTag , ellipsis: ellipsis = false , blurrify: blurrify = false , title: title , ellipsifiedTitle: ellipsifiedTitle = title , ellipsisAtOrBelow: ellipsisAtOrBelow , dangerouslySetInnerHTML: dangerouslySetInnerHTML , overflowY: overflowY , flexGrow: flexGrow , padding: padding  })=>{
    const Elem = $673ec96213c6e29e$export$911e9fe6c3536bd5[variant]; // eslint-disable-line @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(Elem, {
        $color: $673ec96213c6e29e$var$defaultTextColor(variant, color, blurrify),
        $hoverColor: hoverColor,
        $sizeOverride: sizeOverride,
        $weightOverride: weightOverride,
        $lineHeightOverride: lineHeightOverride,
        $whiteSpace: whiteSpace,
        $fontStyle: fontStyle,
        $display: display,
        $textAlign: textAlign,
        $minWidth: minWidth,
        $maxWidth: maxWidth,
        $minHeight: minHeight,
        $overflowY: overflowY,
        $maxHeight: maxHeight,
        $textTransform: textTransform,
        $wordBreak: wordBreak,
        $ellipsis: ellipsis,
        $ellipsisAtOrBelow: ellipsisAtOrBelow,
        title: ellipsis ? ellipsifiedTitle : title,
        $blurrify: blurrify,
        "data-test-tag": testTag,
        "data-blurred": blurrify || undefined,
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        $flexGrow: flexGrow,
        $padding: padding,
        children: children
    });
};




const $38eb4c3d3214e6ab$var$StyledCheckbox = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).input.withConfig({
    displayName: "CheckboxInput__StyledCheckbox",
    componentId: "sc-1o701y9-0"
})([
    "display:none;"
]);
const $38eb4c3d3214e6ab$var$Label = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).label.withConfig({
    displayName: "CheckboxInput__Label",
    componentId: "sc-1o701y9-1"
})([
    "cursor:",
    ";display:flex;align-items:center;"
], (props)=>props.disabled ? "unset" : "pointer");
const $38eb4c3d3214e6ab$var$LabelContent = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CheckboxInput__LabelContent",
    componentId: "sc-1o701y9-2"
})([
    "overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"
]);
const $38eb4c3d3214e6ab$export$d4e232ca161ccdd3 = ({ onChange: onChange , value: value , id: propId , label: label , disabled: disabled = false , fillColor: fillColor = "primaryBlue" , textColor: textColor = "black" , testTag: testTag , ...basicProps })=>{
    const id = (0, $dd8c6a85a004ead6$export$c485849f2e393253)(propId);
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>{
        onChange?.(event.target.checked, event);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($38eb4c3d3214e6ab$var$Label, {
        htmlFor: id,
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($38eb4c3d3214e6ab$var$StyledCheckbox, {
                ...basicProps,
                id: id,
                disabled: disabled,
                checked: value,
                type: "checkbox",
                onChange: realOnChange,
                "data-test-tag": testTag
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                icon: value ? "checkboxChecked" : "checkboxUnchecked",
                color: value ? "white" : "gray5",
                size: "1.25em",
                flexShrink: 0,
                fill: true,
                fillColor: value ? fillColor : "white"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2,
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($38eb4c3d3214e6ab$var$LabelContent, {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: textColor,
                    children: label
                })
            })
        ]
    });
};






var $eYBdv = parcelRequire("eYBdv");
// Position text label for multi-select above dropdown
const $05069e1e38a168fa$var$MultiSelectInputContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MultiSelectInput__MultiSelectInputContainer",
    componentId: "sc-1mt48cv-0"
})([
    "display:flex;flex-direction:column;position:relative;width:100%;"
]);
// Set style for top button in multi-select
const $05069e1e38a168fa$var$MultiSelectInputButtonContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MultiSelectInput__MultiSelectInputButtonContainer",
    componentId: "sc-1mt48cv-1"
})([
    "display:flex;flex-direction:column;min-width:100%;color:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex);
const $05069e1e38a168fa$var$messageActiveStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "border:1px solid ",
    ";",
    ""
], (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex, ({ $direction: $direction  })=>$direction === "down" ? `border-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;` : `border-top: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;`);
// Style and position of multi-select top message and arrow (inside top button)
const $05069e1e38a168fa$var$MultiSelectInputMessageContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MultiSelectInput__MultiSelectInputMessageContainer",
    componentId: "sc-1mt48cv-2"
})([
    "",
    " display:flex;align-items:center;justify-content:space-between;",
    ""
], (0, $8abe0a260c183813$export$3eeb47dc8e6249d9), (props)=>props.$isOpen ? $05069e1e38a168fa$var$messageActiveStyles : "");
// Container for holding all dropdown buttons
const $05069e1e38a168fa$var$OptionsContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MultiSelectInput__OptionsContainer",
    componentId: "sc-1mt48cv-3"
})([
    "position:fixed;z-index:",
    ";display:flex;flex-direction:column;background:",
    ";max-height:300px;overflow-y:auto;border:1px solid ",
    ";",
    ""
], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).dropdown, (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex, ({ $direction: $direction  })=>$direction === "down" ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "border-top:1px solid ",
        ";border-bottom-left-radius:",
        ";border-bottom-right-radius:",
        ";"
    ], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).input, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).input) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "border-bottom:1px solid ",
        ";border-top-left-radius:",
        ";border-top-right-radius:",
        ";"
    ], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).input, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).input));
const $05069e1e38a168fa$var$lastOptionStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "border-bottom-left-radius:",
    ";border-bottom-right-radius:",
    ";"
], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).input, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).input);
// Style for message displayed in dropdown buttons, colored primaryBlue when selected
const $05069e1e38a168fa$var$OptionDisplay = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MultiSelectInput__OptionDisplay",
    componentId: "sc-1mt48cv-4"
})([
    "border-radius:",
    ";margin:",
    " ",
    ";padding:",
    " ",
    ";width:calc(100% - ",
    ");background-color:",
    ";",
    " &:hover{background-color:",
    ";}"
], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (props)=>props.$isLast ? $05069e1e38a168fa$var$lastOptionStyles : "", (0, $24b764039c44d1ec$export$8f45430ccf837300).gray1.hex);
const $05069e1e38a168fa$var$SelectedOptions = ({ selectedOptions: selectedOptions , placeholder: placeholder , maxSelectedShown: maxSelectedShown  })=>{
    if (selectedOptions.size === 0) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: placeholder
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            selectedOptions.slice(0, maxSelectedShown).map(({ label: label  }, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                    color: "readleeBlue",
                    title: label,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        ellipsis: true,
                        children: label
                    })
                }, i)),
            selectedOptions.size > maxSelectedShown && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                color: "black",
                title: selectedOptions.slice(maxSelectedShown).map((l)=>l.label).join(", "),
                children: [
                    "+",
                    selectedOptions.size - maxSelectedShown
                ]
            })
        ]
    });
};
const $05069e1e38a168fa$export$5a8f20dde0180f76 = ({ id: baseId , options: options , onChange: onChange , value: value , placeholder: placeholder , disabled: disabled , maxSelectedShown: maxSelectedShown = 2 , testTag: testTag  })=>{
    const id = (0, $dd8c6a85a004ead6$export$c485849f2e393253)(baseId);
    const [isOpen, setIsOpen] = (0, $g5BLJ.useState)(false);
    const [optionsCoords, setOptionsCoords] = (0, $g5BLJ.useState)({
        left: 0,
        width: 0,
        top: 0,
        direction: "down"
    });
    const [buttonContainer, setButtonContainer] = (0, $g5BLJ.useState)(null);
    const buttonContainerRef = (elem)=>{
        if (elem && elem !== buttonContainer) setButtonContainer(elem);
    };
    const selectedOptions = options.filter((opt)=>value.includes(opt.value));
    (0, $g5BLJ.useEffect)(()=>{
        if (!buttonContainer) return;
        const reset = (0, $eYBdv.throttle)(()=>{
            const rect = buttonContainer.getBoundingClientRect();
            const height = 300;
            const left = rect.left;
            const width = rect.width;
            const top = rect.bottom - 3;
            if (top + height > window.innerHeight) {
                const bottom = window.innerHeight - rect.top - 3;
                setOptionsCoords({
                    left: left,
                    width: width,
                    bottom: bottom,
                    direction: "up"
                });
            } else setOptionsCoords({
                left: left,
                width: width,
                top: top,
                direction: "down"
            });
        }, 10);
        const close = (0, $eYBdv.throttle)(()=>{
            setIsOpen(false);
        }, 100);
        reset();
        window.addEventListener("resize", reset);
        document.addEventListener("scroll", close);
        (0, $7ffd711af926678d$export$b1db755df1284766)(buttonContainer, "scroll", close);
        return ()=>{
            window.removeEventListener("resize", reset);
            document.removeEventListener("scroll", close);
            (0, $7ffd711af926678d$export$c2d4ecb2b67248a1)(buttonContainer, "scroll", close);
        };
    }, [
        isOpen,
        buttonContainer
    ]);
    const close = (0, $g5BLJ.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    (0, $7ffd711af926678d$export$27b6b5680688208b)(id, close);
    const realOnChange = (0, $g5BLJ.useCallback)((option)=>(event)=>{
            event.preventDefault();
            event.stopPropagation();
            const selected = value.includes(option.value);
            onChange(selected ? value.filter((v)=>v !== option.value) : value.push(option.value));
            return false;
        }, [
        onChange,
        value
    ]);
    const { direction: direction , ...optionsStyles } = optionsCoords;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($05069e1e38a168fa$var$MultiSelectInputContainer, {
        id: id,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($05069e1e38a168fa$var$MultiSelectInputButtonContainer, {
                ref: buttonContainerRef,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "noStyles",
                    display: "block",
                    onClick: ()=>setIsOpen(!isOpen),
                    disabled: disabled,
                    testTag: testTag,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($05069e1e38a168fa$var$MultiSelectInputMessageContainer, {
                        $isOpen: isOpen,
                        disabled: disabled,
                        $direction: direction,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                minWidth: 0,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($05069e1e38a168fa$var$SelectedOptions, {
                                    placeholder: placeholder,
                                    selectedOptions: selectedOptions,
                                    maxSelectedShown: maxSelectedShown
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 1
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: isOpen ? "selectArrowUp" : "selectArrowDown",
                                size: "1em",
                                color: disabled ? "currentColor" : "primaryBlue"
                            })
                        ]
                    })
                })
            }),
            isOpen && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $121c3b2afc84f041$export$361769c4f906e73b), {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($05069e1e38a168fa$var$OptionsContainer, {
                    // Styled-components generates a new class every time you change something
                    // so we use inline styles here to clean it up
                    style: optionsStyles,
                    $direction: direction,
                    children: options.map((option, i)=>{
                        const selected = value.includes(option.value);
                        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "noStyles",
                            display: "block",
                            onClick: realOnChange(option),
                            testTag: `${testTag || id}-${option.value}`,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($05069e1e38a168fa$var$OptionDisplay, {
                                $isLast: i + 1 === options.size,
                                $selected: selected,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                    name: `${id}-option-${i}`,
                                    value: selected,
                                    label: option.label
                                })
                            })
                        }, i);
                    })
                })
            })
        ]
    });
};








var $eYBdv = parcelRequire("eYBdv");

const $e6116bf527c207db$export$cefb40c9962541b5 = (str, num, { pluralVersion: pluralVersion = null , noNumber: noNumber = false  } = {})=>{
    const plural = pluralVersion ?? `${str}s`;
    return `${noNumber ? "" : `${num} `}${num === 1 ? str : plural}`;
};
const $e6116bf527c207db$export$9a00dee1beb8f576 = (str)=>{
    return `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
};
const $e6116bf527c207db$export$cee4f836280d8474 = (str)=>{
    return str.split(" ").map($e6116bf527c207db$export$9a00dee1beb8f576).join(" ");
};
const $e6116bf527c207db$export$c8cfcdb41be1b46c = (str, maxLength)=>{
    if (str.length < maxLength) return str;
    return `${str.substring(0, maxLength)}...`;
};
const $e6116bf527c207db$var$alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
const $e6116bf527c207db$var$permuted = "kdpqoheawxnjzvurslmgytfbci9251076834";
const $e6116bf527c207db$export$92c48ccafc588071 = (0, $eYBdv.memoize)((value)=>{
    return (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(value.toLocaleLowerCase()).map((letter)=>$e6116bf527c207db$var$permuted[$e6116bf527c207db$var$alphabet.indexOf(letter)] ?? letter).join("");
});
const $e6116bf527c207db$export$c86caf1be068fb8d = (priceCents)=>{
    return (priceCents / 100).toLocaleString(undefined, {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0
    });
};


const $c92f83b3ac011911$var$WordToggleInputContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "WordToggleInput__WordToggleInputContainer",
    componentId: "sc-1dgxxfg-0"
})([
    "background-color:",
    ";padding:",
    ";border-radius:",
    ";width:fit-content;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.disabled, (0, $8259eb090983b778$export$ea413736286a3bf1)[1], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[1]);
const $c92f83b3ac011911$var$ButtonContentStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "WordToggleInput__ButtonContentStyles",
    componentId: "sc-1dgxxfg-1"
})([
    "display:inline-block;color:",
    ";background-color:",
    ";padding:",
    ";border-radius:",
    ";width:fit-content;transition:all 0.4s ease;"
], ({ $selected: $selected  })=>$selected ? (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).white.disabled, ({ $selected: $selected  })=>$selected ? (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.disabled, ({ $showMobile: $showMobile  })=>$showMobile ? `${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]}` : `${(0, $8259eb090983b778$export$ea413736286a3bf1).none} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]} ${(0, $8259eb090983b778$export$ea413736286a3bf1).none} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]}`, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[1]);
const $c92f83b3ac011911$export$567332ab922d2ec6 = ({ id: id , value: value , onChange: onChange , options: options , showMobile: showMobile = false  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c92f83b3ac011911$var$WordToggleInputContainer, {
        id: id,
        children: options.map((option)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                onClick: option.value !== value ? ()=>onChange(option.value) : undefined,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c92f83b3ac011911$var$ButtonContentStyles, {
                    title: option.label,
                    $selected: option.value === value,
                    $showMobile: showMobile,
                    children: (0, $e6116bf527c207db$export$c8cfcdb41be1b46c)(option.label, 20)
                })
            }, option.value))
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


const $2afb870564c4e4d2$var$StyledTextArea = (0, $8abe0a260c183813$export$a195049fd73b3fe2).withComponent("textarea");
const $2afb870564c4e4d2$var$TextAreaInputWrapper = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)($2afb870564c4e4d2$var$StyledTextArea).withConfig({
    displayName: "TextAreaInput__TextAreaInputWrapper",
    componentId: "sc-1li89dy-0"
})([
    "",
    " padding:",
    ";resize:",
    ";",
    " ",
    ""
], ({ $width: $width , $maxWidth: $maxWidth , $height: $height , $minHeight: $minHeight  })=>`
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("width", $width, "100%")}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("max-width", $maxWidth)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("height", $height, "100%")}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("height", $minHeight)}
  `, (0, $8259eb090983b778$export$ea413736286a3bf1)[2], ({ $resize: $resize = "none"  })=>$resize, ({ $displayType: $displayType  })=>$displayType === "flat" && `
    border: none;
    outline: none;
  `, ({ $textSize: $textSize  })=>$textSize && `font-size: ${$textSize}px;`);
const $2afb870564c4e4d2$export$ce9b1cc0c34506d0 = ({ width: width , maxWidth: maxWidth , height: height , minHeight: minHeight , resize: resize , displayType: displayType = "form" , textSize: textSize = 16 , testTag: testTag = "" , onChange: onChange , ...basicProps })=>{
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>onChange(event.target.value, event), [
        onChange
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2afb870564c4e4d2$var$TextAreaInputWrapper, {
        ...basicProps,
        $width: width,
        $maxWidth: maxWidth,
        $height: height,
        $minHeight: minHeight,
        $displayType: displayType,
        $textSize: textSize,
        $resize: resize,
        onChange: realOnChange,
        "data-test-tag": testTag
    });
};




var $g5BLJ = parcelRequire("g5BLJ");



var $eYBdv = parcelRequire("eYBdv");

const $73b0620564a5efc3$export$b4c0c30d7f4e2691 = 1000;
const $73b0620564a5efc3$export$46533eaa5c2063c0 = 60;
const $73b0620564a5efc3$export$802677262e924bef = 60;
const $73b0620564a5efc3$export$db433e91a7c4594 = 24;
const $73b0620564a5efc3$export$f669a45420d15194 = 7;
const $73b0620564a5efc3$export$74730ac5751b8bb4 = 12;
const $73b0620564a5efc3$export$18087208a00ecee7 = 30;
const $73b0620564a5efc3$export$485c1a38db39db9b = $73b0620564a5efc3$export$b4c0c30d7f4e2691 * $73b0620564a5efc3$export$46533eaa5c2063c0;
const $73b0620564a5efc3$export$750abf5956643c1a = $73b0620564a5efc3$export$b4c0c30d7f4e2691 * $73b0620564a5efc3$export$46533eaa5c2063c0 * $73b0620564a5efc3$export$802677262e924bef * $73b0620564a5efc3$export$db433e91a7c4594;
const $73b0620564a5efc3$export$d0bdf45af03a6ea3 = new Date();
$73b0620564a5efc3$export$d0bdf45af03a6ea3.setHours(0, 0, 0, 0);
const $73b0620564a5efc3$export$ea39ec197993aef0 = (date1, ...otherDates)=>{
    return otherDates.every((d)=>date1.getFullYear() === d.getFullYear() && date1.getMonth() === d.getMonth() && date1.getDate() === d.getDate());
};
const $73b0620564a5efc3$export$629b0a497aa65267 = (date)=>$73b0620564a5efc3$export$ea39ec197993aef0($73b0620564a5efc3$export$d0bdf45af03a6ea3, date);
const $73b0620564a5efc3$var$shortenedMonthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $73b0620564a5efc3$var$dayNames = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const $73b0620564a5efc3$export$cf88499e4943d988 = (date)=>{
    return $73b0620564a5efc3$var$shortenedMonthNames[date.getMonth()];
};
const $73b0620564a5efc3$export$c1cb9ab4c511e525 = (date)=>{
    const name = $73b0620564a5efc3$var$dayNames[date.getDay()];
    if (!name) throw new Error(`Couldn't get name of day ${date.getDay()}`);
    return name;
};
const $73b0620564a5efc3$export$618d60ea299da42 = (date)=>{
    return $73b0620564a5efc3$export$c1cb9ab4c511e525(date) === "Saturday" || $73b0620564a5efc3$export$c1cb9ab4c511e525(date) === "Sunday";
};
const $73b0620564a5efc3$export$3ae94a2503e890a1 = (date, { includeYear: includeYear = false , includeYearIfNotCurrent: includeYearIfNotCurrent = false  } = {})=>{
    return `${$73b0620564a5efc3$export$cf88499e4943d988(date)} ${date.getDate()}${includeYear || includeYearIfNotCurrent && date.getFullYear() !== new Date().getFullYear() ? `, ${date.getFullYear()}` : ""}`;
};
const $73b0620564a5efc3$export$bfe4ac50319c1d9b = (date)=>{
    return date.toISOString().split("T")[0];
};
const $73b0620564a5efc3$export$3203edd9e5edd663 = (date)=>{
    return `${date.getHours() % 12 || 12}:${(0, $eYBdv.padStart)(String(date.getMinutes()), 2, "0")}${date.getHours() >= 12 ? "pm" : "am"}`;
};
const $73b0620564a5efc3$export$8b492ed8828f789c = (date)=>{
    return `${$73b0620564a5efc3$export$3ae94a2503e890a1(date)}, ${$73b0620564a5efc3$export$3203edd9e5edd663(date)}`;
};
const $73b0620564a5efc3$export$b35f8ec5420f1dee = (date, { ago: ago  })=>{
    const now = new Date();
    const diff = now.valueOf() - date.valueOf();
    const secondDiff = Math.floor(diff / $73b0620564a5efc3$export$b4c0c30d7f4e2691);
    const minuteDiff = Math.floor(secondDiff / $73b0620564a5efc3$export$46533eaa5c2063c0);
    const hourDiff = Math.floor(minuteDiff / $73b0620564a5efc3$export$802677262e924bef);
    const dayDiff = Math.floor(hourDiff / $73b0620564a5efc3$export$db433e91a7c4594);
    const weekDiff = Math.floor(dayDiff / $73b0620564a5efc3$export$f669a45420d15194);
    const monthDiff = Math.floor(dayDiff / $73b0620564a5efc3$export$18087208a00ecee7);
    const agoText = ago ? ` ago` : "";
    if (monthDiff >= 12) return `${(0, $e6116bf527c207db$export$cefb40c9962541b5)("year", Math.floor(monthDiff / 12))}${agoText}`;
    if (monthDiff > 1) return `${(0, $e6116bf527c207db$export$cefb40c9962541b5)("month", monthDiff)}${agoText}`;
    if (weekDiff > 0) return `${(0, $e6116bf527c207db$export$cefb40c9962541b5)("week", weekDiff)}${agoText}`;
    if (dayDiff === 1) return `yesterday`;
    if (dayDiff > 0) return `${(0, $e6116bf527c207db$export$cefb40c9962541b5)("day", dayDiff)}${agoText}`;
    if (hourDiff > 0) return `${(0, $e6116bf527c207db$export$cefb40c9962541b5)("hour", hourDiff)}${agoText}`;
    if (minuteDiff > 0) return `${(0, $e6116bf527c207db$export$cefb40c9962541b5)("min", minuteDiff)}${agoText}`;
    return "just now";
};
const $73b0620564a5efc3$export$78ae3e68d8c394bc = (date, { ago: ago = true , capitalizeAll: capAll = false  } = {})=>{
    return capAll ? (0, $e6116bf527c207db$export$cee4f836280d8474)($73b0620564a5efc3$export$b35f8ec5420f1dee(date, {
        ago: ago
    })) : $73b0620564a5efc3$export$b35f8ec5420f1dee(date, {
        ago: ago
    });
};
const $73b0620564a5efc3$export$dd412b56f1e4d8aa = (date, days)=>{
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
const $73b0620564a5efc3$export$253ec86d3e86f2ab = (date)=>{
    const now = new Date();
    const tomorrow = $73b0620564a5efc3$export$dd412b56f1e4d8aa(now, 1);
    const sixDaysFromToday = $73b0620564a5efc3$export$dd412b56f1e4d8aa(now, 6);
    if (date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear()) return `at ${$73b0620564a5efc3$export$3203edd9e5edd663(date)}`;
    if (date.getDate() === tomorrow.getDate() && date.getMonth() === tomorrow.getMonth() && date.getFullYear() === tomorrow.getFullYear()) return `tomorrow at ${$73b0620564a5efc3$export$3203edd9e5edd663(date)}`;
    if (date > sixDaysFromToday) return `${$73b0620564a5efc3$export$c1cb9ab4c511e525(date)} at ${$73b0620564a5efc3$export$3203edd9e5edd663(date)}`;
    else return `${$73b0620564a5efc3$export$3ae94a2503e890a1(date)} at ${$73b0620564a5efc3$export$3203edd9e5edd663(date)}`;
};
const $73b0620564a5efc3$export$74b4d0aec03dadcb = (durationMillis)=>{
    // const secondDiff = Math.floor(durationMillis / MILLISECONDS_IN_SECOND);
    // const minuteDiff = Math.floor(secondDiff / SECONDS_IN_MINUTE);
    // const hourDiff = Math.floor(minuteDiff / MINUTES_IN_HOUR);
    const secondDiff = Math.floor(durationMillis / $73b0620564a5efc3$export$b4c0c30d7f4e2691 % $73b0620564a5efc3$export$46533eaa5c2063c0);
    const minuteDiff = Math.floor(durationMillis / ($73b0620564a5efc3$export$b4c0c30d7f4e2691 * $73b0620564a5efc3$export$46533eaa5c2063c0) % $73b0620564a5efc3$export$802677262e924bef);
    const hourDiff = Math.floor(durationMillis / ($73b0620564a5efc3$export$b4c0c30d7f4e2691 * $73b0620564a5efc3$export$46533eaa5c2063c0 * $73b0620564a5efc3$export$802677262e924bef));
    const secondsAndMinutes = `${minuteDiff.toString().padStart(1, "0")}:${secondDiff.toString().padStart(2, "0")}`;
    if (hourDiff > 0) return `${hourDiff}:${secondsAndMinutes}`;
    else return secondsAndMinutes;
};
const $73b0620564a5efc3$export$b7f1bc3ea3ac4145 = (milliseconds)=>milliseconds / $73b0620564a5efc3$export$b4c0c30d7f4e2691 / $73b0620564a5efc3$export$46533eaa5c2063c0;
const $73b0620564a5efc3$export$5730ec13828963aa = (durationMillis)=>{
    const durationMinutes = Math.floor(durationMillis / $73b0620564a5efc3$export$b4c0c30d7f4e2691 / $73b0620564a5efc3$export$46533eaa5c2063c0);
    if (durationMinutes < $73b0620564a5efc3$export$802677262e924bef) return `${durationMinutes} minutes`;
    else {
        const durationHours = Math.floor(durationMinutes / $73b0620564a5efc3$export$802677262e924bef);
        return `${durationHours} hours`;
    }
};
const $73b0620564a5efc3$export$2e8f853eec105774 = ()=>{
    const today = new Date();
    const month = today.getMonth();
    if (month >= 7 && month <= 10) return "fall";
    else if (month >= 11 && month <= 1) return "winter";
    return "spring";
};
const $73b0620564a5efc3$export$c3133dbc11f66777 = ()=>{
    try {
        return {
            timeZoneStatus: "assumed",
            timeZoneKey: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
    } catch (_e) {
        return {
            timeZoneStatus: "unknown"
        };
    }
};
const $73b0620564a5efc3$export$6b862160d295c8e = (dateString)=>{
    const [year, baseMonth, date] = dateString.split("-").map((x)=>parseInt(x, 10));
    if (typeof year !== "number" || typeof baseMonth !== "number" || typeof date !== "number") throw new Error(`Invalid date string: '${dateString}'`);
    const month = baseMonth - 1;
    return new Date(year, month, date);
};







var $g5BLJ = parcelRequire("g5BLJ");
const $4ded3b2c5af96cca$export$5504339c0acd1a00 = (planA, planB)=>{
    return planA.level - planB.level;
};
const $4ded3b2c5af96cca$export$a9b413430a92321a = (plans)=>{
    return plans.sort($4ded3b2c5af96cca$export$5504339c0acd1a00);
};
const $4ded3b2c5af96cca$export$fa35d849a2b6d142 = ()=>{
    return {
        id: "",
        name: "",
        tagline: "",
        description: "",
        basePlanId: null,
        features: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
        status: "hidden",
        comingSoonFeatures: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
        optionalAddOns: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
        stripeProductId: "",
        monthlyStripePriceId: "",
        annualStripePriceId: "",
        monthlyPriceUsdCents: 0,
        annualPriceUsdCents: 0,
        level: 0,
        isBasicPlan: true,
        isEnterprise: false,
        isUsageCapsEnabled: false
    };
};
const $4ded3b2c5af96cca$export$52756c3ad45aa25c = "Readlee Ultimate";
const $4ded3b2c5af96cca$export$54b31349b35ae5fd = "Ultimate";
const $4ded3b2c5af96cca$export$cff2a6c9a7debd3 = (flag, currentUser, assessment, enabledForStudents)=>{
    if (!currentUser) return false;
    if (currentUser?.flags[flag]) return true;
    if (currentUser?.accountType === "student" && enabledForStudents) return true;
    if (assessment?.isUltimate) return true;
    return false;
};
const $4ded3b2c5af96cca$var$valueProps = [
    {
        label: "Full student transcriptions",
        helpLink: "https://readleesupport.zendesk.com/hc/en-us/articles/14121208003981"
    },
    {
        label: "Advanced analytics",
        helpLink: "https://readleesupport.zendesk.com/hc/en-us/articles/14121211516685"
    },
    {
        label: "Vocabulary tasks",
        helpLink: "https://readleesupport.zendesk.com/hc/en-us/articles/14120923896205"
    },
    {
        label: "Transcriptions of audio questions",
        helpLink: ""
    }
];
const $4ded3b2c5af96cca$var$ValueProp = ({ label: label , helpLink: helpLink  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: label
                }),
                helpLink && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 1
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                            content: "Click to learn more",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                newTab: true,
                                href: helpLink,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "info",
                                    strokeWidth: 2,
                                    color: "primaryBlue"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
const $4ded3b2c5af96cca$var$UnmemoizedUltimateFeaturesList = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("ul", {
        children: $4ded3b2c5af96cca$var$valueProps.map(({ label: label , helpLink: helpLink  }, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4ded3b2c5af96cca$var$ValueProp, {
                label: label,
                helpLink: helpLink
            }, i))
    });
const $4ded3b2c5af96cca$export$9ca18bb3e989d9c3 = /*#__PURE__*/ (0, $g5BLJ.memo)($4ded3b2c5af96cca$var$UnmemoizedUltimateFeaturesList);
const $4ded3b2c5af96cca$export$5c806aff8bda9109 = (currentPlan)=>{
    if (currentPlan.isBasicPlan) return "Last 7 Days";
    else if (currentPlan.isEnterprise) return "Current Academic Year";
    else return "Last 30 Days";
};


const $97971de7222d1c39$var$currentAcademicYear = ()=>{
    return (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth() > 5 ? new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), 6, 1) : new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear() - 1, 6, 1);
};
const $97971de7222d1c39$var$prevAcademicYear = ()=>(0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth() > 5 ? new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear() - 1, 6, 1) : new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear() - 2, 6, 1);
const $97971de7222d1c39$export$7f608b480d9e7085 = {
    Today: {
        label: "Today",
        value: {
            start: (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3),
            end: (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3)
        },
        prev: {
            start: new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getDate() - 1),
            end: (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3)
        },
        isExtended: false,
        isAll: false
    },
    "Last 7 Days": {
        label: "Last 7 Days",
        value: {
            start: new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getDate() - 7),
            end: (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3)
        },
        prev: {
            start: new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getDate() - 14),
            end: new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getDate() - 7)
        },
        isExtended: false,
        isAll: false
    },
    "Last 30 Days": {
        label: "Last 30 Days",
        value: {
            start: new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getDate() - 30),
            end: (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3)
        },
        prev: {
            start: new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getDate() - 60),
            end: new Date((0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getFullYear(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getMonth(), (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3).getDate() - 30)
        },
        isExtended: true,
        isAll: false
    },
    "Current Academic Year": {
        label: "Current Academic Year",
        value: {
            start: $97971de7222d1c39$var$currentAcademicYear(),
            end: (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3)
        },
        prev: {
            start: $97971de7222d1c39$var$prevAcademicYear(),
            end: $97971de7222d1c39$var$currentAcademicYear()
        },
        isExtended: false,
        isAll: true
    },
    "All Time": {
        label: "All Time",
        value: {
            start: new Date(0),
            end: (0, $73b0620564a5efc3$export$d0bdf45af03a6ea3)
        },
        prev: null,
        isExtended: false,
        isAll: true
    }
};
const $97971de7222d1c39$export$5109c6dd95d8fb00 = ({ id: id , onChange: onChange , value: value , name: name , ...basicProps })=>{
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser, []);
    const realOnChange = (0, $g5BLJ.useCallback)((newLabel)=>{
        onChange($97971de7222d1c39$export$7f608b480d9e7085[newLabel]);
    }, [
        onChange
    ]);
    if (!currentUser) return null;
    const hasExtended = currentUser.flags.isExtendedDateFilteringEnabled;
    const hasAll = currentUser.flags.isAllDateFilteringEnabled;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            (!hasExtended || !hasAll) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
                enabled: true,
                content: "Upgrade to view more data",
                linkLocation: "plans",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    height: "100%",
                    testTag: "ultimate-tooltip",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "info",
                        strokeWidth: 2,
                        size: "24px",
                        color: "white"
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                ...basicProps,
                id: id,
                options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(Object.values($97971de7222d1c39$export$7f608b480d9e7085)).map((o)=>{
                    const proText = o.isExtended && !hasExtended ? " (Pro)" : "";
                    const schoolText = o.isAll && !hasAll ? ` (${0, $4ded3b2c5af96cca$export$52756c3ad45aa25c})` : "";
                    return {
                        label: `${o.label}${proText}${schoolText}`,
                        value: o.label,
                        disabled: o.isExtended && !hasExtended || o.isAll && !hasAll
                    };
                }),
                value: value,
                onChange: realOnChange,
                name: name,
                icon: "calendar",
                displayType: "icon"
            })
        ]
    });
};




var $g5BLJ = parcelRequire("g5BLJ");

const $e02099e89983f6fb$export$8e7f4929fe5ed49c = ()=>{
    const today = new Date();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");
    return `${today.getFullYear()}-${month}-${day}`;
};
const $e02099e89983f6fb$export$7edc06cf1783b30f = ({ onChange: onChange , min: min , max: max , testTag: testTag , ...basicProps })=>{
    const realOnChange = (0, $g5BLJ.useCallback)((event)=>onChange(event.target.value, event), [
        onChange
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8abe0a260c183813$export$a195049fd73b3fe2), {
        ...basicProps,
        type: "date",
        onChange: realOnChange,
        min: min,
        max: max,
        "data-test-tag": testTag
    });
};






const $c2511447d0cb3d32$var$SearchContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SearchInput__SearchContainer",
    componentId: "sc-cjf0q2-0"
})([
    "background:",
    ";border-radius:",
    ";border:1px solid ",
    ";padding:",
    " ",
    ";color:",
    ";font-weight:400;",
    ""
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[1], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex, ({ $displayType: $displayType  })=>$displayType === "large" ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "width:100%;padding:",
        " ",
        ";"
    ], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[5]) : "");
const $c2511447d0cb3d32$export$55d7609a8f1eccd2 = ({ displayType: displayType = "normal" , ...props })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c2511447d0cb3d32$var$SearchContainer, {
        $displayType: displayType,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f8129efc3cc4d35c$export$f5b8910cec6cf069), {
            name: "Search Bar",
            icon: "search",
            iconPosition: "left",
            flexGrow: 1,
            fontSize: displayType === "large" ? 16 : 14,
            ...props
        })
    });






var $g5BLJ = parcelRequire("g5BLJ");


const $50073ce729d6c9f2$export$5b4a6ac7cb1aeab8 = ()=>{
    const setField = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.JoinCourseData.setField, []);
    const openModal = (0, $g5BLJ.useCallback)(()=>setField("open")(true), [
        setField
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: openModal,
                height: "40px",
                children: "Join Class"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a627bf53352a32f1$export$e16988b372b2efdc), {})
        ]
    });
};




var $g5BLJ = parcelRequire("g5BLJ");

function $82acc4edbd07a320$export$2e2bcd8739ae039(o, p) {
    $82acc4edbd07a320$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $82acc4edbd07a320$export$2e2bcd8739ae039(o, p);
}


function $f56696cc08f3b12d$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $82acc4edbd07a320$export$2e2bcd8739ae039)(subClass, superClass);
}



var $g5BLJ = parcelRequire("g5BLJ");

function $dd4169cdd3471a74$export$2e2bcd8739ae039() {
    $dd4169cdd3471a74$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dd4169cdd3471a74$export$2e2bcd8739ae039.apply(this, arguments);
}


function $de29dc28e31065fa$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $de29dc28e31065fa$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $de29dc28e31065fa$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $de29dc28e31065fa$var$isAbsolute(to);
    var isFromAbs = from && $de29dc28e31065fa$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $de29dc28e31065fa$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $de29dc28e31065fa$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $de29dc28e31065fa$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $de29dc28e31065fa$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$de29dc28e31065fa$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $de29dc28e31065fa$export$2e2bcd8739ae039 = $de29dc28e31065fa$var$resolvePathname;


function $e0bd725a123dc881$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $e0bd725a123dc881$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $e0bd725a123dc881$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $e0bd725a123dc881$var$valueOf(a);
        var bValue = $e0bd725a123dc881$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $e0bd725a123dc881$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $e0bd725a123dc881$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $e0bd725a123dc881$export$2e2bcd8739ae039 = $e0bd725a123dc881$var$valueEqual;



var $d43544cd989ab1a2$var$isProduction = true;
var $d43544cd989ab1a2$var$prefix = "Invariant failed";
function $d43544cd989ab1a2$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($d43544cd989ab1a2$var$isProduction) throw new Error($d43544cd989ab1a2$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($d43544cd989ab1a2$var$prefix, ": ").concat(provided) : $d43544cd989ab1a2$var$prefix;
    throw new Error(value);
}


function $3ff0eb34a57ea9f7$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $3ff0eb34a57ea9f7$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $3ff0eb34a57ea9f7$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $3ff0eb34a57ea9f7$var$stripBasename(path, prefix) {
    return $3ff0eb34a57ea9f7$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $3ff0eb34a57ea9f7$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $3ff0eb34a57ea9f7$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $3ff0eb34a57ea9f7$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $3ff0eb34a57ea9f7$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $de29dc28e31065fa$export$2e2bcd8739ae039)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $3ff0eb34a57ea9f7$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $e0bd725a123dc881$export$2e2bcd8739ae039)(a.state, b.state);
}
function $3ff0eb34a57ea9f7$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $3ff0eb34a57ea9f7$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $3ff0eb34a57ea9f7$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $3ff0eb34a57ea9f7$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $3ff0eb34a57ea9f7$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $3ff0eb34a57ea9f7$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $3ff0eb34a57ea9f7$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $3ff0eb34a57ea9f7$var$PopStateEvent = "popstate";
var $3ff0eb34a57ea9f7$var$HashChangeEvent = "hashchange";
function $3ff0eb34a57ea9f7$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $3ff0eb34a57ea9f7$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$3ff0eb34a57ea9f7$var$canUseDOM && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canUseHistory = $3ff0eb34a57ea9f7$var$supportsHistory();
    var needsHashChangeListener = !$3ff0eb34a57ea9f7$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $3ff0eb34a57ea9f7$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $3ff0eb34a57ea9f7$var$stripTrailingSlash($3ff0eb34a57ea9f7$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $3ff0eb34a57ea9f7$var$stripBasename(path, basename);
        return $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $3ff0eb34a57ea9f7$var$createTransitionManager();
    function setState(nextState) {
        (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($3ff0eb34a57ea9f7$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($3ff0eb34a57ea9f7$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($3ff0eb34a57ea9f7$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $3ff0eb34a57ea9f7$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($3ff0eb34a57ea9f7$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($3ff0eb34a57ea9f7$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($3ff0eb34a57ea9f7$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($3ff0eb34a57ea9f7$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $3ff0eb34a57ea9f7$var$HashChangeEvent$1 = "hashchange";
var $3ff0eb34a57ea9f7$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $3ff0eb34a57ea9f7$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $3ff0eb34a57ea9f7$var$stripLeadingSlash,
        decodePath: $3ff0eb34a57ea9f7$var$addLeadingSlash
    },
    slash: {
        encodePath: $3ff0eb34a57ea9f7$var$addLeadingSlash,
        decodePath: $3ff0eb34a57ea9f7$var$addLeadingSlash
    }
};
function $3ff0eb34a57ea9f7$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $3ff0eb34a57ea9f7$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $3ff0eb34a57ea9f7$var$pushHashPath(path) {
    window.location.hash = path;
}
function $3ff0eb34a57ea9f7$var$replaceHashPath(path) {
    window.location.replace($3ff0eb34a57ea9f7$var$stripHash(window.location.href) + "#" + path);
}
function $3ff0eb34a57ea9f7$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$3ff0eb34a57ea9f7$var$canUseDOM && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $3ff0eb34a57ea9f7$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $3ff0eb34a57ea9f7$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $3ff0eb34a57ea9f7$var$stripTrailingSlash($3ff0eb34a57ea9f7$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $3ff0eb34a57ea9f7$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($3ff0eb34a57ea9f7$var$getHashPath());
        if (basename) path = $3ff0eb34a57ea9f7$var$stripBasename(path, basename);
        return $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path);
    }
    var transitionManager = $3ff0eb34a57ea9f7$var$createTransitionManager();
    function setState(nextState) {
        (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $3ff0eb34a57ea9f7$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $3ff0eb34a57ea9f7$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $3ff0eb34a57ea9f7$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($3ff0eb34a57ea9f7$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($3ff0eb34a57ea9f7$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $3ff0eb34a57ea9f7$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $3ff0eb34a57ea9f7$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $3ff0eb34a57ea9f7$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $3ff0eb34a57ea9f7$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $3ff0eb34a57ea9f7$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $3ff0eb34a57ea9f7$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $3ff0eb34a57ea9f7$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $3ff0eb34a57ea9f7$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($3ff0eb34a57ea9f7$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $3ff0eb34a57ea9f7$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $3ff0eb34a57ea9f7$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $3ff0eb34a57ea9f7$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($3ff0eb34a57ea9f7$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($3ff0eb34a57ea9f7$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($3ff0eb34a57ea9f7$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $3ff0eb34a57ea9f7$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $3ff0eb34a57ea9f7$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $3ff0eb34a57ea9f7$var$createTransitionManager();
    function setState(nextState) {
        (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $3ff0eb34a57ea9f7$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $3ff0eb34a57ea9f7$export$90c043f1c57770b8(entry, undefined, createKey()) : $3ff0eb34a57ea9f7$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $3ff0eb34a57ea9f7$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $3ff0eb34a57ea9f7$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $3ff0eb34a57ea9f7$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}




var $g5BLJ = parcelRequire("g5BLJ");

var $eb1e6ea6ce310cda$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eb1e6ea6ce310cda$var$ReactIs, $eb1e6ea6ce310cda$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$eb1e6ea6ce310cda$exports = (parcelRequire("a35Mc"))();



var $460188cc477b1ac7$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $460188cc477b1ac7$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
function $460188cc477b1ac7$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $460188cc477b1ac7$var$commonjsGlobal[key] = ($460188cc477b1ac7$var$commonjsGlobal[key] || 0) + 1;
}
function $460188cc477b1ac7$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $460188cc477b1ac7$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $460188cc477b1ac7$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $460188cc477b1ac7$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $460188cc477b1ac7$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $460188cc477b1ac7$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($460188cc477b1ac7$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $460188cc477b1ac7$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $g5BLJ.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($eb1e6ea6ce310cda$exports))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $460188cc477b1ac7$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $460188cc477b1ac7$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $460188cc477b1ac7$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $g5BLJ.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($eb1e6ea6ce310cda$exports))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $460188cc477b1ac7$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createContext || $460188cc477b1ac7$var$createReactContext;
var $460188cc477b1ac7$export$2e2bcd8739ae039 = $460188cc477b1ac7$var$index;




var $d485b6b7783f722d$exports = {};
var $9940b196af193f88$exports = {};
$9940b196af193f88$exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};


/**
 * Expose `pathToRegexp`.
 */ $d485b6b7783f722d$exports = $d485b6b7783f722d$var$pathToRegexp;
$d485b6b7783f722d$exports.parse = $d485b6b7783f722d$var$parse;
$d485b6b7783f722d$exports.compile = $d485b6b7783f722d$var$compile;
$d485b6b7783f722d$exports.tokensToFunction = $d485b6b7783f722d$var$tokensToFunction;
$d485b6b7783f722d$exports.tokensToRegExp = $d485b6b7783f722d$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $d485b6b7783f722d$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $d485b6b7783f722d$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $d485b6b7783f722d$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $d485b6b7783f722d$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $d485b6b7783f722d$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $d485b6b7783f722d$var$compile(str, options) {
    return $d485b6b7783f722d$var$tokensToFunction($d485b6b7783f722d$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $d485b6b7783f722d$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $d485b6b7783f722d$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $d485b6b7783f722d$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $d485b6b7783f722d$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $d485b6b7783f722d$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($9940b196af193f88$exports(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $d485b6b7783f722d$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $d485b6b7783f722d$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $d485b6b7783f722d$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $d485b6b7783f722d$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $d485b6b7783f722d$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $d485b6b7783f722d$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $d485b6b7783f722d$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $d485b6b7783f722d$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($d485b6b7783f722d$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $d485b6b7783f722d$var$flags(options));
    return $d485b6b7783f722d$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $d485b6b7783f722d$var$stringToRegexp(path, keys, options) {
    return $d485b6b7783f722d$var$tokensToRegExp($d485b6b7783f722d$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $d485b6b7783f722d$var$tokensToRegExp(tokens, keys, options) {
    if (!$9940b196af193f88$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $d485b6b7783f722d$var$escapeString(token);
        else {
            var prefix = $d485b6b7783f722d$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $d485b6b7783f722d$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $d485b6b7783f722d$var$attachKeys(new RegExp("^" + route, $d485b6b7783f722d$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $d485b6b7783f722d$var$pathToRegexp(path, keys, options) {
    if (!$9940b196af193f88$exports(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $d485b6b7783f722d$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($9940b196af193f88$exports(path)) return $d485b6b7783f722d$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $d485b6b7783f722d$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}


var $f94f396e7ae18161$exports = {};
"use strict";

$f94f396e7ae18161$exports = (parcelRequire("7NPHw"));


function $11899f0087ae29c7$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



// TODO: Replace with React.createContext once we can assume React 16+
var $4ab21c8a3cbff9b4$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $460188cc477b1ac7$export$2e2bcd8739ae039)();
    context.displayName = name;
    return context;
};
var $4ab21c8a3cbff9b4$export$c213558b66925821 = /*#__PURE__*/ $4ab21c8a3cbff9b4$var$createNamedContext("Router-History");
var $4ab21c8a3cbff9b4$export$63baa8ccbe60bb07 = /*#__PURE__*/ $4ab21c8a3cbff9b4$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $4ab21c8a3cbff9b4$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $4ab21c8a3cbff9b4$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3ff0eb34a57ea9f7$export$2b76ad033c6e6d08)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
var $4ab21c8a3cbff9b4$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $4ab21c8a3cbff9b4$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $4ab21c8a3cbff9b4$var$messageType;
var $4ab21c8a3cbff9b4$var$cache = {};
var $4ab21c8a3cbff9b4$var$cacheLimit = 10000;
var $4ab21c8a3cbff9b4$var$cacheCount = 0;
function $4ab21c8a3cbff9b4$var$compilePath(path) {
    if ($4ab21c8a3cbff9b4$var$cache[path]) return $4ab21c8a3cbff9b4$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($d485b6b7783f722d$exports))).compile(path);
    if ($4ab21c8a3cbff9b4$var$cacheCount < $4ab21c8a3cbff9b4$var$cacheLimit) {
        $4ab21c8a3cbff9b4$var$cache[path] = generator;
        $4ab21c8a3cbff9b4$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $4ab21c8a3cbff9b4$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $4ab21c8a3cbff9b4$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $3ff0eb34a57ea9f7$export$90c043f1c57770b8)(computedMatch ? typeof to === "string" ? $4ab21c8a3cbff9b4$export$82476f982757e71e(to, computedMatch.params) : (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, to, {
            pathname: $4ab21c8a3cbff9b4$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $3ff0eb34a57ea9f7$export$90c043f1c57770b8)(prevProps.to);
                if (!(0, $3ff0eb34a57ea9f7$export$c3e8bb440bd55b18)(prevLocation, (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $4ab21c8a3cbff9b4$var$cache$1 = {};
var $4ab21c8a3cbff9b4$var$cacheLimit$1 = 10000;
var $4ab21c8a3cbff9b4$var$cacheCount$1 = 0;
function $4ab21c8a3cbff9b4$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $4ab21c8a3cbff9b4$var$cache$1[cacheKey] || ($4ab21c8a3cbff9b4$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($d485b6b7783f722d$exports)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($4ab21c8a3cbff9b4$var$cacheCount$1 < $4ab21c8a3cbff9b4$var$cacheLimit$1) {
        pathCache[path] = result;
        $4ab21c8a3cbff9b4$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $4ab21c8a3cbff9b4$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $4ab21c8a3cbff9b4$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $4ab21c8a3cbff9b4$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Children.count(children) === 0;
}
function $4ab21c8a3cbff9b4$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $4ab21c8a3cbff9b4$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $4ab21c8a3cbff9b4$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
function $4ab21c8a3cbff9b4$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $4ab21c8a3cbff9b4$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, location, {
        pathname: $4ab21c8a3cbff9b4$var$addLeadingSlash(basename) + location.pathname
    });
}
function $4ab21c8a3cbff9b4$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $4ab21c8a3cbff9b4$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $4ab21c8a3cbff9b4$var$createURL(location) {
    return typeof location === "string" ? location : (0, $3ff0eb34a57ea9f7$export$fe53371bee54353d)(location);
}
function $4ab21c8a3cbff9b4$var$staticHandler(methodName) {
    return function() {
        (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
    };
}
function $4ab21c8a3cbff9b4$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $4ab21c8a3cbff9b4$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $4ab21c8a3cbff9b4$var$noop;
        };
        _this.handleBlock = function() {
            return $4ab21c8a3cbff9b4$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $4ab21c8a3cbff9b4$var$addBasename(basename, (0, $3ff0eb34a57ea9f7$export$90c043f1c57770b8)(location));
        context.url = $4ab21c8a3cbff9b4$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $11899f0087ae29c7$export$2e2bcd8739ae039)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $4ab21c8a3cbff9b4$var$addLeadingSlash(basename + $4ab21c8a3cbff9b4$var$createURL(path));
            },
            action: "POP",
            location: $4ab21c8a3cbff9b4$var$stripBasename(basename, (0, $3ff0eb34a57ea9f7$export$90c043f1c57770b8)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $4ab21c8a3cbff9b4$var$staticHandler("go"),
            goBack: $4ab21c8a3cbff9b4$var$staticHandler("goBack"),
            goForward: $4ab21c8a3cbff9b4$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$55185c17a0fcbe46, (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $4ab21c8a3cbff9b4$export$81336c211d5ff295(location.pathname, (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $4ab21c8a3cbff9b4$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $11899f0087ae29c7$export$2e2bcd8739ae039)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement(Component, (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($b2cf63d513978880$exports)))(C, Component);
}
var $4ab21c8a3cbff9b4$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).useContext;
function $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c() {
    return $4ab21c8a3cbff9b4$var$useContext($4ab21c8a3cbff9b4$export$c213558b66925821);
}
function $4ab21c8a3cbff9b4$export$45d76561a5302f2b() {
    return $4ab21c8a3cbff9b4$var$useContext($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07).location;
}
function $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef() {
    var match = $4ab21c8a3cbff9b4$var$useContext($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $4ab21c8a3cbff9b4$export$632be4bb944c1bc7(path) {
    var location = $4ab21c8a3cbff9b4$export$45d76561a5302f2b();
    var match = $4ab21c8a3cbff9b4$var$useContext($4ab21c8a3cbff9b4$export$63baa8ccbe60bb07).match;
    return path ? $4ab21c8a3cbff9b4$export$81336c211d5ff295(location.pathname, path) : match;
}
var $4ab21c8a3cbff9b4$var$global, $4ab21c8a3cbff9b4$var$key, $4ab21c8a3cbff9b4$var$buildNames, $4ab21c8a3cbff9b4$var$initialBuildName, $4ab21c8a3cbff9b4$var$secondaryBuildName;




var $g5BLJ = parcelRequire("g5BLJ");






/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $06f449077089668c$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3ff0eb34a57ea9f7$export$719fc203c4e16dee)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement((0, $4ab21c8a3cbff9b4$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $06f449077089668c$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $f56696cc08f3b12d$export$2e2bcd8739ae039)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3ff0eb34a57ea9f7$export$b71fdd3798280242)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement((0, $4ab21c8a3cbff9b4$export$55185c17a0fcbe46), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).Component);
var $06f449077089668c$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $06f449077089668c$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $3ff0eb34a57ea9f7$export$90c043f1c57770b8)(to, null, null, currentLocation) : to;
};
var $06f449077089668c$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $06f449077089668c$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).forwardRef;
if (typeof $06f449077089668c$var$forwardRef === "undefined") $06f449077089668c$var$forwardRef = $06f449077089668c$var$forwardRefShim;
function $06f449077089668c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $06f449077089668c$var$LinkAnchor = $06f449077089668c$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $11899f0087ae29c7$export$2e2bcd8739ae039)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$06f449077089668c$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($06f449077089668c$var$forwardRefShim !== $06f449077089668c$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $06f449077089668c$export$a6c7ac8248d6e38a = $06f449077089668c$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $06f449077089668c$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $11899f0087ae29c7$export$2e2bcd8739ae039)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement((0, $4ab21c8a3cbff9b4$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
        var history = context.history;
        var location = $06f449077089668c$var$normalizeToLocation($06f449077089668c$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $06f449077089668c$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $3ff0eb34a57ea9f7$export$fe53371bee54353d)(context.location) === (0, $3ff0eb34a57ea9f7$export$fe53371bee54353d)($06f449077089668c$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($06f449077089668c$var$forwardRefShim !== $06f449077089668c$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement(component, props);
    });
});
var $06f449077089668c$var$toType, $06f449077089668c$var$refType;
var $06f449077089668c$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $06f449077089668c$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).forwardRef;
if (typeof $06f449077089668c$var$forwardRef$1 === "undefined") $06f449077089668c$var$forwardRef$1 = $06f449077089668c$var$forwardRefShim$1;
function $06f449077089668c$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $06f449077089668c$export$b0d92dbee9b5b60d = $06f449077089668c$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $11899f0087ae29c7$export$2e2bcd8739ae039)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement((0, $4ab21c8a3cbff9b4$export$63baa8ccbe60bb07).Consumer, null, function(context) {
        !context && (0, $d43544cd989ab1a2$export$2e2bcd8739ae039)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $06f449077089668c$var$normalizeToLocation($06f449077089668c$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $06f449077089668c$var$joinClassnames(className, activeClassName);
            style = (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({}, style, activeStyle);
        }
        var props = (0, $dd4169cdd3471a74$export$2e2bcd8739ae039)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($06f449077089668c$var$forwardRefShim$1 !== $06f449077089668c$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($06f449077089668c$export$a6c7ac8248d6e38a, props);
    });
});
var $06f449077089668c$var$ariaCurrentType;




const $5557eb3ea8c47b66$var$queryCache = new Map();
const $5557eb3ea8c47b66$export$dd0a697e1782aedd = ()=>{
    const location = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)();
    const queryString = location.search;
    const cached = $5557eb3ea8c47b66$var$queryCache.get(queryString);
    if (cached) return cached;
    const value = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(new URLSearchParams(queryString).entries());
    $5557eb3ea8c47b66$var$queryCache.set(queryString, value);
    return value;
};
const $5557eb3ea8c47b66$export$e4897436d02202c9 = (queryMap)=>{
    const entries = typeof queryMap.entries === "function" ? queryMap.entries() : Object.entries(queryMap);
    const str = new URLSearchParams(Array.from(entries)).toString();
    if (str.length > 0) return `?${str}`;
    return "";
};
const $5557eb3ea8c47b66$export$dba0f9e9232b3d6d = ({ accountTypes: accountTypes = []  })=>{
    const { currentUser: currentUser , loading: loading  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            currentUser: state.AppData.currentUser,
            loading: state.AppData.loading
        }), []);
    if (!loading && currentUser && accountTypes.length > 0 && accountTypes.includes(currentUser.accountType)) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
        to: "/"
    });
    return null;
};
const $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1 = (query, updates)=>{
    const newQuery = query.merge(updates).filter(Boolean);
    return $5557eb3ea8c47b66$export$e4897436d02202c9(newQuery);
};




const $a627bf53352a32f1$export$e16988b372b2efdc = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { courseCode: courseCode , errors: errors , submit: submit , setField: setField , load: load , loading: loading , open: open , checkCode: checkCode  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.JoinCourseData, []);
    const closeModal = (0, $g5BLJ.useCallback)(()=>setField("open")(false), [
        setField
    ]);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const joinCode = query.get("joinCode") || "";
    (0, $g5BLJ.useEffect)(()=>{
        load({
            joinCode: joinCode
        });
        checkCode(joinCode);
    }, [
        load,
        joinCode,
        checkCode
    ]);
    if (!open) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: open,
        close: closeModal,
        disableFadeClose: true,
        header: "Join Class",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "end",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: closeModal,
                    inheritBgColor: true,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Close"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    disabled: loading,
                    onClick: ()=>submit(history),
                    children: "Join Class"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Please enter the class code provided by your teacher."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "courseCode",
                label: "Class Code",
                placeholder: "Enter Class Code",
                errors: errors,
                value: courseCode,
                onChange: setField("courseCode")
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $367677bc6ac034de$var$FormStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).form.withConfig({
    displayName: "Form__FormStyles",
    componentId: "sc-wptwtc-0"
})([
    "display:",
    ";",
    ";",
    " ",
    ";",
    ""
], ({ $display: $display = "block"  })=>$display, ({ $grow: $grow  })=>typeof $grow === "number" ? `flex-grow: ${$grow};` : "", ({ $minHeight: $minHeight  })=>$minHeight || $minHeight === 0 ? `min-height: ${$minHeight};` : "", ({ $flexDirection: $flexDirection  })=>$flexDirection ? `flex-direction: ${$flexDirection}` : "", ({ $height: $height  })=>(0, $18ffa0398cff6303$export$67799b413b1b10d7)("height", $height));
const $367677bc6ac034de$export$a7fed597f4b8afd8 = ({ onSubmit: onSubmit , children: children , dirty: dirty = false , forceDefault: forceDefault = false , display: display , grow: grow , minHeight: minHeight , flexDirection: flexDirection , height: height  })=>{
    const realOnSubmit = (0, $g5BLJ.useCallback)((event)=>{
        if (!forceDefault) event.preventDefault();
        return onSubmit(event);
    }, [
        onSubmit,
        forceDefault
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($367677bc6ac034de$var$FormStyles, {
        onSubmit: realOnSubmit,
        $display: display,
        $grow: grow,
        $minHeight: minHeight,
        $flexDirection: flexDirection,
        $height: height,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $99e1e58376b11da3$export$5313b17bb82557eb), {
                dirty: dirty
            }),
            children
        ]
    });
};









const $15ab8b8dc3306afa$export$b04be29aa201d4f5 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).label.withConfig({
    displayName: "FormGroup__Label",
    componentId: "sc-2szq1e-0"
})([
    "",
    ";display:block;",
    " ",
    ""
], ({ $noMargin: $noMargin  })=>$noMargin ? "margin: 0" : `margin-right: ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]}`, ({ $type: $type  })=>$type === "checkbox" ? `cursor: pointer` : "", ({ $isTextInput: $isTextInput  })=>$isTextInput && (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "color:",
        ";font-size:14px;",
        ""
    ], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray6.hex, ({ $noMargin: $noMargin  })=>$noMargin ? "" : `margin-bottom: ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1]};`));
const $15ab8b8dc3306afa$var$BaseFormGroup = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "FormGroup__BaseFormGroup",
    componentId: "sc-2szq1e-1"
})([
    "",
    " ",
    ";"
], ({ $height: $height , $width: $width  })=>`
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("height", $height)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("width", $width)}
  `, ({ $flex: $flex , $justify: $justify  })=>$flex && (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "display:flex;align-items:center;justify-content:",
        ";"
    ], $justify));
function $15ab8b8dc3306afa$export$2d00230e1e6f7fbc({ disabled: disabled = false , width: width = "100%" , ...props }) {
    const id = (0, $dd8c6a85a004ead6$export$c485849f2e393253)(props.id);
    const isTextInput = props.type === "text" || props.type === "password" || props.type === "email";
    let content = null;
    if (isTextInput) content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f8129efc3cc4d35c$export$f5b8910cec6cf069), {
        id: id,
        name: props.name,
        label: props.label,
        type: props.type,
        value: props.value,
        onChange: props.onChange,
        placeholder: props.placeholder,
        disabled: disabled,
        autoComplete: props.autoComplete,
        testTag: props.testTag,
        onKeyDown: props.onKeyDown
    });
    else if (props.type === "text-area") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2afb870564c4e4d2$export$ce9b1cc0c34506d0), {
        id: id,
        name: props.name,
        label: props.label,
        value: props.value,
        onChange: props.onChange,
        placeholder: props.placeholder,
        disabled: disabled,
        width: width,
        maxWidth: props.maxWidth,
        height: props.height,
        minHeight: props.minHeight,
        resize: props.resize,
        displayType: props.displayType,
        testTag: props.testTag
    });
    else if (props.type === "number") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8d52bbd6b178f533$export$6bf0cd3a219bbade), {
        id: id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        noSpinner: props.noSpinner,
        autoComplete: props.autoComplete,
        min: props.min,
        max: props.max,
        integerOnly: props.integerOnly
    });
    else if (props.type === "checkbox") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
        id: id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        label: props.label,
        disabled: disabled
    });
    else if (props.type === "toggle") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $55f67455b2bdf913$export$bea8ebba691c5813), {
        id: id,
        disabled: disabled,
        name: props.name,
        value: props.value,
        onChange: props.onChange
    });
    else if (props.type === "multiselect") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $05069e1e38a168fa$export$5a8f20dde0180f76), {
        id: id,
        name: props.name,
        placeholder: props.placeholder,
        options: props.options,
        value: props.value,
        onChange: props.onChange,
        maxSelectedShown: props.maxSelectedShown,
        testTag: props.testTag
    });
    else if (props.type === "select") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
        id: id,
        name: props.name,
        options: props.options,
        value: props.value,
        onChange: props.onChange,
        displayType: props.displayType,
        disabled: disabled,
        testTag: props.testTag
    });
    else if (props.type === "date-picker") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $97971de7222d1c39$export$5109c6dd95d8fb00), {
        id: id,
        name: props.name,
        value: props.value,
        onChange: props.onChange
    });
    else if (props.type === "file") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f4e423d3be2b137f$export$b57af79a4ab2a1c6), {
        id: id,
        name: props.name,
        value: props.value,
        onChange: props.onChange,
        accept: props.accept,
        disabled: disabled,
        uploading: props.uploading,
        errors: props.errors,
        testTag: props.testTag,
        uploadedFile: props.uploadedFile,
        iconColor: props.iconColor,
        kind: props.kind
    });
    else if (props.type === "textSize") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $93bf34ff9853e7af$export$1b73483dd77e9d80), {
        id: id,
        value: props.value,
        onChange: props.onChange
    });
    else if (props.type === "date") content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e02099e89983f6fb$export$7edc06cf1783b30f), {
        id: id,
        name: props.name,
        min: props.min,
        max: props.max,
        value: props.value,
        onChange: props.onChange,
        testTag: props.testTag
    });
    const label = props.type === "checkbox" || props.type === "file" || !props.label ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($15ab8b8dc3306afa$export$b04be29aa201d4f5, {
        $isTextInput: isTextInput || props.type === "select" || props.type === "multiselect" || props.type === "number" || props.type === "date" || props.type === "text-area",
        $type: props.type,
        htmlFor: id,
        children: props.label
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($15ab8b8dc3306afa$var$BaseFormGroup, {
        $flex: props.flex || false,
        $justify: props.justify || "start",
        $height: props.height,
        $width: width,
        children: [
            label,
            content,
            props.errors && props.type !== "file" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                errors: props.errors,
                errorKey: props.name
            })
        ]
    });
}





parcelRequire("g5BLJ");




const $3aa7eeb60079978b$var$ACTIVE_CLASS_NAME = "button-nav-link-active";
const $3aa7eeb60079978b$var$commonStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "display:",
    ";align-items:center;border:none;outline:none;text-decoration:none;cursor:pointer;position:relative;color:",
    ";background:",
    ";flex-grow:",
    ";flex-shrink:0;z-index:",
    ";&[disabled]{cursor:default;pointer-events:none;opacity:0.4;}&:active,&:hover{&:not([disabled]){background:",
    ";}}"
], (props)=>props.$display, (props)=>props.$textColor, (props)=>props.$inheritBgColor ? "inherit" : props.$backgroundColor, (props)=>props.$flexGrow, (props)=>(0, $9f83aa035e9f8cbe$export$a01878c2d95345c0)[props.$zIndex], (props)=>props.$activeBackgroundColor);
const $3aa7eeb60079978b$var$overrideStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " ",
    " ",
    " ",
    " &[disabled]{",
    "}"
], ({ $sizeOverride: $sizeOverride  })=>$sizeOverride && `font-size: ${$sizeOverride}px;`, ({ $weightOverride: $weightOverride  })=>$weightOverride && `font-weight: ${(0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861)[$weightOverride]};`, ({ $borderRadiusOverride: $borderRadiusOverride  })=>$borderRadiusOverride && `border-radius: ${(0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[$borderRadiusOverride]};`, ({ $paddingOverride: $paddingOverride  })=>(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("padding", $paddingOverride), ({ $disabledOpacityOverride: $disabledOpacityOverride  })=>(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("opacity", $disabledOpacityOverride));
const $3aa7eeb60079978b$var$linkStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " background:transparent;letter-spacing:'0';font-weight:",
    ";line-height:100%;padding:0;",
    ";",
    ";&:active,&.",
    "{color:",
    ";}&:hover{&:not([disabled]){color:",
    ";text-decoration:underline;}}",
    ""
], $3aa7eeb60079978b$var$commonStyles, (0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861).semibold, (props)=>props.$width ? `width: ${props.$width};` : "", ({ $linkTextStyle: $linkTextStyle  })=>{
    switch($linkTextStyle){
        case "linkOptional":
            return `font-size: 12px`;
        case "linkNavBar":
            return `font-size: 16px`;
        case "linkBasic":
        default:
            return `font-size: 14px`;
    }
}, $3aa7eeb60079978b$var$ACTIVE_CLASS_NAME, (props)=>props.$activeColor ? (0, $24b764039c44d1ec$export$8f45430ccf837300)[props.$activeColor].hex : props.$textColor, (props)=>props.$hoverColor ? (0, $24b764039c44d1ec$export$8f45430ccf837300)[props.$hoverColor].hex : props.$textColor, $3aa7eeb60079978b$var$overrideStyles);
const $3aa7eeb60079978b$var$buttonStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " border-radius:",
    ";font-weight:600;font-size:14px;line-height:145%;padding:",
    " ",
    ";text-decoration:none;cursor:pointer;height:",
    ";width:",
    ";min-width:",
    ";",
    ";"
], $3aa7eeb60079978b$var$commonStyles, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[5], (props)=>props.$height, (props)=>props.$width, (props)=>props.$minWidth, $3aa7eeb60079978b$var$overrideStyles);
const $3aa7eeb60079978b$var$outlineStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " ",
    " border:1px solid ",
    ";&:active,&:hover{&:not([disabled]){border:1px solid ",
    ";}}",
    ""
], $3aa7eeb60079978b$var$commonStyles, $3aa7eeb60079978b$var$buttonStyles, (props)=>props.$borderColor, (props)=>props.$activeBorderColor, $3aa7eeb60079978b$var$overrideStyles);
const $3aa7eeb60079978b$var$iconOnlyStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "",
    " border-radius:",
    ";display:flex;align-items:center;justify-content:center;height:",
    ";width:",
    ";",
    ""
], $3aa7eeb60079978b$var$commonStyles, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (props)=>props.$height, (props)=>props.$width, $3aa7eeb60079978b$var$overrideStyles);
const $3aa7eeb60079978b$var$unsetStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "all:unset;color:inherit;cursor:pointer;height:",
    ";width:",
    ";display:",
    ";flex-grow:",
    ";&[disabled]{cursor:default;opacity:0.4;}",
    ""
], (props)=>props.$height, (props)=>props.$width, (props)=>props.$display, (props)=>props.$flexGrow, $3aa7eeb60079978b$var$overrideStyles);
const $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Button__StyledButton",
    componentId: "sc-q691dq-0"
})([
    "",
    ""
], ({ $displayType: $displayType  })=>{
    if ($displayType === "link") return $3aa7eeb60079978b$var$linkStyles;
    else if ($displayType === "button") return $3aa7eeb60079978b$var$buttonStyles;
    else if ($displayType === "outline") return $3aa7eeb60079978b$var$outlineStyles;
    else if ($displayType === "iconOnly") return $3aa7eeb60079978b$var$iconOnlyStyles;
    else if ($displayType === "noStyles") return $3aa7eeb60079978b$var$unsetStyles;
    return null;
});
const $3aa7eeb60079978b$var$StyledAnchor = $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b.withComponent("a");
const $3aa7eeb60079978b$var$StyledLink = $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b.withComponent((0, $06f449077089668c$export$a6c7ac8248d6e38a));
const $3aa7eeb60079978b$var$StyledNavLink = $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b.withComponent((0, $06f449077089668c$export$b0d92dbee9b5b60d));
const $3aa7eeb60079978b$var$LoadingContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Button__LoadingContainer",
    componentId: "sc-q691dq-1"
})([
    "position:absolute;left:0;right:0;top:0;bottom:0;display:flex;align-items:center;justify-content:center;z-index:",
    ";"
], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised);
const $3aa7eeb60079978b$var$getButtonElement = ({ to: to , nav: nav , href: href , buttonDisabled: buttonDisabled  })=>{
    // Always use button if it's disabled, as the react-router Link just ignores the disabled attribute
    if (buttonDisabled) return $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b;
    if (typeof to === "string") {
        if (nav) return $3aa7eeb60079978b$var$StyledNavLink;
        else return $3aa7eeb60079978b$var$StyledLink;
    } else if (typeof href === "string") return $3aa7eeb60079978b$var$StyledAnchor;
    else return $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b;
};
const $3aa7eeb60079978b$var$getColors = ({ baseColor: baseColor , borderColorOverride: borderColorOverride , displayType: displayType  })=>{
    const color = baseColor ?? "primaryBlue";
    const borderColor = borderColorOverride ? borderColorOverride : color;
    if (displayType === "link") return {
        backgroundColor: "transparent",
        textColor: (0, $24b764039c44d1ec$export$8f45430ccf837300)[color].hex,
        activeBackgroundColor: "transparent",
        borderColor: "transparent",
        activeBorderColor: "transparent"
    };
    else if (displayType === "outline") return {
        backgroundColor: "transparent",
        textColor: (0, $24b764039c44d1ec$export$8f45430ccf837300)[color].hex,
        activeBackgroundColor: (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300)[color].hex, 0.08),
        borderColor: (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300)[borderColor].hex, 0.5),
        activeBorderColor: (0, $24b764039c44d1ec$export$8f45430ccf837300)[borderColor].hex
    };
    else return {
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300)[color].hex,
        textColor: (0, $24b764039c44d1ec$export$8f45430ccf837300)[color].text,
        activeBackgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300)[color].active,
        borderColor: "transparent",
        activeBorderColor: "transparent"
    };
};
const $3aa7eeb60079978b$export$353f5b6fc5456de1 = ({ nav: nav , exact: exact = false , type: type = "button" , displayType: displayType = "button" , children: children , name: name , onClick: onClick , onMouseOver: onMouseOver , onMouseOut: onMouseOut , to: to , href: href , testTag: testTag , color: baseColor , borderColorOverride: borderColorOverride , hoverColor: hoverColor , activeColor: activeColor , inheritBgColor: inheritBgColor = false , display: display = "inline-flex" , flexDisplay: flexDisplay = display , justify: justify = "center" , align: align = "center" , loading: loading = false , loadingText: loadingText , disabled: disabled = false , newTab: newTab = false , width: width = "auto" , height: height = "auto" , minWidth: minWidth = "auto" , download: download , id: id , activeBg: activeBg = "inherit" , icon: icon , iconSize: iconSize , iconColor: iconColor , iconPosition: iconPosition = "left" , iconFill: iconFill = false , iconStrokeWidth: iconStrokeWidth = 1 , iconShrink: iconShrink = 1 , linkTextStyle: linkTextStyle = "linkBasic" , sizeOverride: sizeOverride = false , weightOverride: weightOverride = false , borderRadiusOverride: borderRadiusOverride = false , paddingOverride: paddingOverride = false , flexGrow: flexGrow = "unset" , zIndex: zIndex = "normal" , disabledOpacityOverride: disabledOpacityOverride = false  })=>{
    const { backgroundColor: backgroundColor , textColor: textColor , activeBackgroundColor: activeBackgroundColor , borderColor: borderColor , activeBorderColor: activeBorderColor  } = $3aa7eeb60079978b$var$getColors({
        baseColor: baseColor,
        borderColorOverride: borderColorOverride,
        displayType: displayType
    });
    const buttonDisabled = disabled || loading;
    const basicProps = {
        id: id,
        type: type,
        to: to,
        href: href,
        download: download,
        name: name,
        onClick: onClick,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        disabled: buttonDisabled
    };
    const iconColorProps = iconColor ? {
        color: iconColor
    } : {
        cssColor: textColor
    };
    const IconElem = icon ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            iconPosition === "right" && displayType !== "iconOnly" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                ...iconColorProps,
                fill: iconFill,
                strokeWidth: iconStrokeWidth,
                icon: icon,
                size: iconSize || "1.75em",
                flexShrink: iconShrink
            }),
            iconPosition === "left" && displayType !== "iconOnly" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            })
        ]
    }) : null;
    const ButtonElem = $3aa7eeb60079978b$var$getButtonElement({
        buttonDisabled: buttonDisabled,
        to: to,
        nav: nav,
        href: href
    });
    const navProps = nav ? {
        activeClassName: $3aa7eeb60079978b$var$ACTIVE_CLASS_NAME,
        exact: exact
    } : {};
    const tabProps = newTab ? {
        target: "_blank",
        rel: "noopener noreferrer"
    } : {};
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)(ButtonElem, {
        $displayType: displayType,
        $loading: loading,
        $backgroundColor: backgroundColor,
        $textColor: textColor,
        $activeBackgroundColor: activeBackgroundColor,
        $borderColor: borderColor,
        $activeBorderColor: activeBorderColor,
        $display: display,
        $justify: justify,
        $align: align,
        $hoverColor: hoverColor,
        $activeColor: activeColor,
        $inheritBgColor: inheritBgColor,
        $activeBg: activeBg,
        $linkTextStyle: linkTextStyle,
        $sizeOverride: sizeOverride,
        $weightOverride: weightOverride,
        $width: width,
        $height: height,
        $minWidth: minWidth,
        $borderRadiusOverride: borderRadiusOverride,
        $paddingOverride: paddingOverride,
        $disabledOpacityOverride: disabledOpacityOverride,
        $flexGrow: flexGrow,
        $zIndex: zIndex,
        "data-test-tag": testTag,
        ...basicProps,
        ...navProps,
        ...tabProps,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                display: [
                    "flex",
                    "inline-flex",
                    "inherit"
                ].includes(flexDisplay) ? flexDisplay : "flex",
                align: align,
                justify: justify,
                width: "100%",
                opacity: loading && displayType !== "link" ? 0 : 1,
                children: [
                    iconPosition === "left" && IconElem,
                    children,
                    loading && displayType === "link" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                                size: "small"
                            })
                        ]
                    }),
                    iconPosition === "right" && IconElem
                ]
            }),
            loading && displayType !== "link" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($3aa7eeb60079978b$var$LoadingContainer, {
                children: [
                    loadingText && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            loadingText,
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                        darkBg: displayType !== "outline" && displayType !== "noStyles",
                        size: "medium"
                    })
                ]
            })
        ]
    });
};
const $3aa7eeb60079978b$export$29d11c0fe2fc51d8 = (props)=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($3aa7eeb60079978b$export$353f5b6fc5456de1, {
        displayType: "link",
        ...props
    });
};
const $3aa7eeb60079978b$export$590ff762cb17981c = (props)=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($3aa7eeb60079978b$export$353f5b6fc5456de1, {
        displayType: "noStyles",
        ...props
    });
};
const $3aa7eeb60079978b$export$f534bea3063673d5 = (props)=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($3aa7eeb60079978b$export$353f5b6fc5456de1, {
        displayType: "outline",
        ...props
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


var $g5BLJ = parcelRequire("g5BLJ");







var $3bV2r = parcelRequire("3bV2r");

var $g5BLJ = parcelRequire("g5BLJ");


(0, (/*@__PURE__*/$parcel$interopDefault($3bV2r))).resolvableShapes["book"] = `<svg width="20" height="16" viewBox="0 0 20 16" fill="none">
<path d="M3.0595 0.360107C3.05897 0.360107 3.05836 0.360107 3.05782 0.360107C2.86866 0.360107 2.69075 0.433845 2.5564 0.567852C2.42058 0.703341 2.34576 0.883745 2.34576 1.0758V11.8075C2.34576 12.201 2.66718 12.522 3.06233 12.523C4.7282 12.527 7.51918 12.8742 9.44458 14.889V3.65803C9.44458 3.52463 9.4105 3.39931 9.34619 3.29561C7.76592 0.750681 4.72914 0.364013 3.0595 0.360107Z" />
<path d="M17.6547 11.8076V1.0758C17.6547 0.883745 17.5798 0.703341 17.444 0.567852C17.3097 0.433845 17.1316 0.360107 16.9427 0.360107C16.9421 0.360107 16.9415 0.360107 16.9409 0.360107C15.2713 0.36408 12.2346 0.750748 10.6542 3.29567C10.5899 3.39938 10.5559 3.5247 10.5559 3.6581V14.889C12.4813 12.8742 15.2723 12.527 16.9382 12.523C17.3332 12.522 17.6547 12.201 17.6547 11.8076Z" />
<path d="M19.2842 2.83496H18.7652V11.8074C18.7652 12.8122 17.9466 13.6316 16.9402 13.6341C15.5272 13.6374 13.1974 13.9137 11.5474 15.4754C14.4011 14.7767 17.4095 15.2309 19.124 15.6216C19.338 15.6704 19.5592 15.62 19.7308 15.4833C19.9017 15.3469 19.9997 15.1431 19.9997 14.9243V3.55052C19.9998 3.15597 19.6787 2.83496 19.2842 2.83496Z" />
<path d="M1.23448 11.8074V2.83496H0.715558C0.321079 2.83496 0 3.15597 0 3.55052V14.9241C0 15.1429 0.0980475 15.3467 0.268957 15.4831C0.440338 15.6197 0.661349 15.6703 0.875761 15.6214C2.59024 15.2306 5.59867 14.7765 8.45228 15.4752C6.80231 13.9136 4.47247 13.6374 3.05947 13.634C2.05321 13.6316 1.23448 12.8122 1.23448 11.8074Z" />
</svg>`;
const $ad8e3cbc7ee8beea$var$emit = (source, angle, options = {})=>(0, (/*@__PURE__*/$parcel$interopDefault($3bV2r))).scene.current.createEmitter({
        emitterOptions: {
            loops: 1,
            duration: 8,
            ...options.emitterOptions
        },
        rendererOptions: {
            shapeFactory: [
                "square",
                "circle",
                "star",
                "book"
            ]
        },
        emissionOptions: {
            angle: (0, $3bV2r.variation).skew(angle, (0, $3bV2r.variation).evaluateVariation((0, $3bV2r.variation).range(35, 45))),
            rate: 0,
            bursts: [
                {
                    time: 0,
                    count: (0, $3bV2r.variation).range(20, 40)
                }
            ],
            initialLifetime: 8,
            initialSpeed: (0, $3bV2r.variation).range(300, 600),
            initialSize: (0, $3bV2r.variation).skew(1, 0.2),
            initialRotation: ()=>(0, $3bV2r.random).randomUnitVector().scale(180),
            initialColor: (0, $24b764039c44d1ec$export$1c7a2172b1da4dcc).map((0, (/*@__PURE__*/$parcel$interopDefault($3bV2r))).Color.fromHex),
            sourceSampler: (0, $3bV2r.sources).elementSource(source),
            ...options,
            ...options.emissionOptions
        }
    });
const $ad8e3cbc7ee8beea$var$ConfettiContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Confetti__ConfettiContainer",
    componentId: "sc-156gnmp-0"
})([
    "position:absolute;top:-20px;width:100%;"
]);
const $ad8e3cbc7ee8beea$export$cbb00bdc895f8047 = ({ enabled: enabled  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($ad8e3cbc7ee8beea$var$ConfettiContainer, {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($ad8e3cbc7ee8beea$export$c67abc3378714dd3, {
            enabled: enabled,
            angle: 270,
            loop: false,
            options: {
                emissionOptions: {
                    rate: 40,
                    bursts: [
                        {
                            time: 0,
                            count: 0
                        }
                    ],
                    initialSpeed: 100,
                    initialSize: 1
                },
                emitterOptions: {
                    duration: 2
                }
            }
        })
    });
const $ad8e3cbc7ee8beea$export$c74548264adbc916 = /*#__PURE__*/ (0, $g5BLJ.memo)($ad8e3cbc7ee8beea$export$cbb00bdc895f8047);
const $ad8e3cbc7ee8beea$var$UnmemoizedConfettiEmitter = ({ enabled: enabled , angle: angle , options: options = {} , style: style = {} , loop: loop  })=>{
    const confettiRef = (0, $g5BLJ.useRef)(null);
    (0, $g5BLJ.useEffect)(()=>{
        let id = null;
        const doIt = ()=>{
            if (!enabled || !confettiRef.current) return;
            $ad8e3cbc7ee8beea$var$emit(confettiRef.current, angle, options);
            if (!loop) return;
            id = setInterval(()=>{
                if (!confettiRef.current) return;
                $ad8e3cbc7ee8beea$var$emit(confettiRef.current, angle, options);
            }, 1250);
        };
        doIt();
        return ()=>{
            if (id) clearInterval(id);
            (0, (/*@__PURE__*/$parcel$interopDefault($3bV2r))).scene.current.clearEmitters();
        };
    }, [
        angle,
        enabled,
        options,
        loop
    ]);
    if (!enabled) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
        style: {
            height: "1px",
            ...style
        },
        ref: confettiRef
    });
};
const $ad8e3cbc7ee8beea$export$c67abc3378714dd3 = /*#__PURE__*/ (0, $g5BLJ.memo)($ad8e3cbc7ee8beea$var$UnmemoizedConfettiEmitter);



const $8526a011da4f152b$var$ModalFade = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Modal__ModalFade",
    componentId: "sc-jryzwl-0"
})([
    "display:",
    ";align-items:center;justify-content:center;background:",
    ";position:fixed;top:0;bottom:0;left:0;right:0;z-index:",
    ";"
], ({ $opened: $opened  })=>$opened ? "flex" : "none", (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).gray6.hex, 0.5), (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).modal);
const $8526a011da4f152b$export$1a3581e06df0da37 = "mobileLarge";
const $8526a011da4f152b$var$BaseModal = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Modal__BaseModal",
    componentId: "sc-jryzwl-1"
})([
    "display:",
    ";flex-direction:column;background:",
    ";",
    " ",
    ""
], ({ $opened: $opened  })=>$opened ? "flex" : "none", (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $forceFullscreenOverride: $forceFullscreenOverride , $minWidthOverride: $minWidthOverride , $maxWidthOverride: $maxWidthOverride , $minHeightOverride: $minHeightOverride , $maxHeightOverride: $maxHeightOverride , $isStudent: $isStudent , $hasFooter: $hasFooter  })=>{
    const mobileStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "width:100%;height:100vh;padding-bottom:",
        ";overflow-y:auto;"
    ], $isStudent || !$hasFooter ? "0" : "72px");
    if ($forceFullscreenOverride) return mobileStyles;
    else return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "@media (max-width:",
        "px){",
        "}@media (min-width:",
        "px){",
        " ",
        " ",
        " ",
        " border-radius:",
        ";}"
    ], (0, $4fd3b1c7dfff02ca$export$d07517a676ce386f)[$8526a011da4f152b$export$1a3581e06df0da37], mobileStyles, (0, $4fd3b1c7dfff02ca$export$d07517a676ce386f)[$8526a011da4f152b$export$1a3581e06df0da37] + 1, (0, $18ffa0398cff6303$export$67799b413b1b10d7)("min-width", $minWidthOverride, `${(0, $4fd3b1c7dfff02ca$export$d07517a676ce386f)[$8526a011da4f152b$export$1a3581e06df0da37] * 0.9}px`), (0, $18ffa0398cff6303$export$67799b413b1b10d7)("max-width", $maxWidthOverride, "90vw"), (0, $18ffa0398cff6303$export$67799b413b1b10d7)("min-height", $minHeightOverride, "0"), (0, $18ffa0398cff6303$export$67799b413b1b10d7)("max-height", $maxHeightOverride, "90vh"), (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[5]);
}, ({ $paddingOverride: $paddingOverride  })=>(0, $18ffa0398cff6303$export$67799b413b1b10d7)("padding", $paddingOverride));
const $8526a011da4f152b$export$2b77a92f1a5ad772 = (props)=>{
    const { children: children , openType: openType , close: close , showConfetti: showConfetti = false , forceFullscreen: forceFullscreen = false , paddingOverride: paddingOverride , disableFadeClose: disableFadeClose = false , hasFooter: hasFooter = true , confettiLoop: confettiLoop = true  } = props;
    const modalFadeId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    const modalId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    const fadeClose = (event)=>{
        if (!disableFadeClose && event.target.id === modalFadeId) props.close?.();
    };
    const isMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: $8526a011da4f152b$export$1a3581e06df0da37
    });
    (0, $g5BLJ.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (event.key === "Esc" || event.key === "Escape") close?.();
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        close
    ]);
    const opened = openType === "state" ? props.opened : true;
    const leftConfettiStyles = (0, $g5BLJ.useMemo)(()=>isMobile ? {
            position: "absolute",
            top: "5%",
            left: "35%"
        } : {}, [
        isMobile
    ]);
    const rightConfettiStyles = (0, $g5BLJ.useMemo)(()=>isMobile ? {
            position: "absolute",
            top: "5%",
            right: "35%"
        } : {}, [
        isMobile
    ]);
    const windowSize = (0, $4fd3b1c7dfff02ca$export$42c02f33970a2afa)();
    const isStudent = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: { currentUser: currentUser  }  })=>!currentUser || currentUser.accountType === "student", []);
    const content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $121c3b2afc84f041$export$361769c4f906e73b), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ad8e3cbc7ee8beea$export$c74548264adbc916), {
                enabled: isMobile && showConfetti
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($8526a011da4f152b$var$ModalFade, {
                id: modalFadeId,
                $opened: opened,
                onClick: fadeClose,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ad8e3cbc7ee8beea$export$c67abc3378714dd3), {
                        enabled: !isMobile && showConfetti,
                        angle: 225,
                        style: leftConfettiStyles,
                        loop: confettiLoop
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8526a011da4f152b$var$BaseModal, {
                        id: modalId,
                        $opened: opened,
                        "data-test-tag": props.testTag,
                        $minWidthOverride: props.minWidthOverride,
                        $maxWidthOverride: props.maxWidthOverride,
                        $minHeightOverride: props.minHeightOverride,
                        $maxHeightOverride: props.maxHeightOverride,
                        $forceFullscreenOverride: forceFullscreen,
                        $paddingOverride: paddingOverride,
                        $isStudent: isStudent,
                        $hasFooter: hasFooter,
                        // Deal with safari bug where 100vh takes up too much space
                        style: forceFullscreen || isMobile ? {
                            height: `${windowSize.height}px`
                        } : {},
                        children: props.onSubmit ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                            onSubmit: props.onSubmit,
                            flexDirection: "column",
                            display: "flex",
                            height: forceFullscreen || isMobile ? `${windowSize.height}px` : "auto",
                            children: children
                        }) : children
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ad8e3cbc7ee8beea$export$c67abc3378714dd3), {
                        enabled: !isMobile && showConfetti,
                        angle: 315,
                        style: rightConfettiStyles,
                        loop: confettiLoop
                    })
                ]
            })
        ]
    });
    return openType === "state" ? content : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
        path: props.openedPath,
        children: content
    });
};






const $800aabf72745714c$var$ModalHeader = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StandardModal__ModalHeader",
    componentId: "sc-ty9518-0"
})([
    "padding:",
    " ",
    ";border-bottom:1px solid ",
    ";display:flex;align-items:center;justify-content:space-between;"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $8259eb090983b778$export$ea413736286a3bf1)[6], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex);
const $800aabf72745714c$var$ModalContent = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StandardModal__ModalContent",
    componentId: "sc-ty9518-1"
})([
    "flex-grow:1;padding:",
    " ",
    ";overflow-y:auto;min-height:0;"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $8259eb090983b778$export$ea413736286a3bf1)[6]);
const $800aabf72745714c$var$ModalFooter = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StandardModal__ModalFooter",
    componentId: "sc-ty9518-2"
})([
    "padding:",
    " ",
    ";background:",
    ";display:flex;align-items:center;justify-content:flex-end;border-radius:0 0 ",
    " ",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $8259eb090983b778$export$ea413736286a3bf1)[6], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[5], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[5]);
const $800aabf72745714c$var$CLOSE_BUTTON_SIZE = "36px";
const $800aabf72745714c$export$72f77866d312088b = ({ header: header , middleHeader: middleHeader , rightHeader: rightHeader , children: children , footer: footer , disableFadeClose: disableFadeClose , disableClose: disableClose = false , ...modalProps })=>{
    const textHeader = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        title: header,
        variant: "h3",
        ellipsis: true,
        ellipsifiedTitle: header,
        maxWidth: "90%",
        children: header
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $8526a011da4f152b$export$2b77a92f1a5ad772), {
        ...modalProps,
        disableFadeClose: disableFadeClose || disableClose,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($800aabf72745714c$var$ModalHeader, {
                children: [
                    middleHeader ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        grow: 1,
                        maxWidth: "90%",
                        children: [
                            textHeader,
                            middleHeader
                        ]
                    }) : textHeader,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        children: [
                            rightHeader,
                            modalProps.close && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2,
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        color: "gray3",
                                        icon: "close",
                                        iconSize: "0.75em",
                                        width: $800aabf72745714c$var$CLOSE_BUTTON_SIZE,
                                        height: $800aabf72745714c$var$CLOSE_BUTTON_SIZE,
                                        displayType: "iconOnly",
                                        onClick: modalProps.close,
                                        testTag: "close",
                                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                        disabled: disableClose
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($800aabf72745714c$var$ModalContent, {
                children: children
            }),
            footer && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($800aabf72745714c$var$ModalFooter, {
                children: footer
            })
        ]
    });
};








const $31d38d276dc0d530$export$c10bb8791b00cf6c = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Flex__FlexStyles",
    componentId: "sc-c699k5-0"
})([
    "",
    ""
], (props)=>`
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("display", props.display, "flex")}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("flex-grow", props.grow)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("flex-shrink", props.shrink)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("flex", props.flex)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("flex-direction", props.direction)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("flex-wrap", props.wrap)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("justify-content", props.justify)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("align-items", props.align)}

    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("opacity", props.opacity)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("background", props.backgroundColor)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("border-radius", props.borderRadius)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("border", props.border)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("overflow-y", props.overflowY)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("overflow-x", props.overflowX)}
    ${(0, $18ffa0398cff6303$export$67799b413b1b10d7)("position", props.position)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("padding", props.padding, 0)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("margin", props.margin, 0)}

    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("width", props.width)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("height", props.height)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("min-width", props.minWidth)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("max-width", props.maxWidth)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("min-height", props.minHeight)}
    ${(0, $18ffa0398cff6303$export$4bd51deb3e0b36b1)("max-height", props.maxHeight)}
  `);
const $31d38d276dc0d530$var$InlineFlexStyles = $31d38d276dc0d530$export$c10bb8791b00cf6c.withComponent("span");
const $31d38d276dc0d530$export$f51f4c4ede09e011 = ({ testTag: testTag , innerRef: innerRef , display: display = "flex" , ...props })=>{
    const finalProps = {
        ...props,
        "data-test-tag": testTag,
        ref: innerRef,
        display: display
    };
    return display.includes("inline") ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($31d38d276dc0d530$var$InlineFlexStyles, {
        ...finalProps
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($31d38d276dc0d530$export$c10bb8791b00cf6c, {
        ...finalProps
    });
};
const $31d38d276dc0d530$export$33f7c4b36d836354 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Flex__FlexGrow",
    componentId: "sc-c699k5-1"
})([
    "flex-grow:",
    ";"
], (props)=>props.grow ?? 1);
const $31d38d276dc0d530$export$408f6e7a7113feed = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)($31d38d276dc0d530$export$f51f4c4ede09e011).withConfig({
    displayName: "Flex__SplitBackgroundFlex",
    componentId: "sc-c699k5-2"
})([
    "background:linear-gradient(",
    " 50%,",
    " 50%);"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex);








var $g5BLJ = parcelRequire("g5BLJ");




var $eYBdv = parcelRequire("eYBdv");

const $a31343b90c9d3d88$var$ARROW_SIZE = 8;
const $a31343b90c9d3d88$var$BUFFER_SIZE = $a31343b90c9d3d88$var$ARROW_SIZE + 2;
const $a31343b90c9d3d88$var$assumedMaxHeight = 150;
const $a31343b90c9d3d88$var$minWidth = 200;
const $a31343b90c9d3d88$var$maxWidth = 500;
const $a31343b90c9d3d88$var$mobileMinWidth = 150;
const $a31343b90c9d3d88$var$mobileMaxWidth = 250;
const $a31343b90c9d3d88$var$TooltipContent = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Tooltip__TooltipContent",
    componentId: "sc-1wjozgz-0"
})([
    "display:",
    ";padding:8px;position:fixed;background:white;color:",
    ";font-size:",
    "px;font-weight:",
    ";border-radius:",
    ";z-index:",
    ";box-shadow:",
    ";width:auto;min-width:",
    "px;max-width:",
    "px;transform:",
    ";text-align:center;white-space:pre-wrap;word-break:break-word;"
], ({ $hovered: $hovered  })=>$hovered ? "block" : "none", (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, (0, $18ffa0398cff6303$export$22ea553521eefdfc), (0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861).default, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).tooltip, (0, $d65f64e8cabd56af$export$147720d44c0eeb27).standard, ({ $showMobile: $showMobile  })=>$showMobile ? $a31343b90c9d3d88$var$mobileMinWidth : $a31343b90c9d3d88$var$minWidth, ({ $showMobile: $showMobile , $maxWidthOverride: $maxWidthOverride  })=>$maxWidthOverride || ($showMobile ? $a31343b90c9d3d88$var$mobileMaxWidth : $a31343b90c9d3d88$var$maxWidth), ({ $position: $position  })=>$position === "up" || $position === "down" ? "translateX(-50%)" : "translateY(-50%)");
const $a31343b90c9d3d88$export$44ec04c6081e3a25 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Tooltip__TooltipContainer",
    componentId: "sc-1wjozgz-1"
})([
    "position:relative;display:",
    ";line-height:",
    ";",
    " ",
    " ",
    ";"
], (props)=>props.$display, ({ $lineHeight: $lineHeight  })=>$lineHeight, (props)=>props.$display.includes("inline") ? "" : "vertical-align: middle;", ({ $display: $display  })=>$display === "block" ? "width: 100%;" : "", ({ $containerWidthOverride: $containerWidthOverride  })=>`width: ${$containerWidthOverride}`);
const $a31343b90c9d3d88$var$isValidTooltipcoordinates = (coords, isMobile)=>{
    const widthToUse = isMobile ? $a31343b90c9d3d88$var$mobileMaxWidth : $a31343b90c9d3d88$var$maxWidth;
    const widthAdjustment = widthToUse / 2;
    const heightAdjustment = $a31343b90c9d3d88$var$assumedMaxHeight / 2;
    if (coords.position === "up" || coords.position === "down") {
        if (coords.left - widthAdjustment < 0 || coords.left + widthAdjustment > window.innerWidth) return false;
    }
    if (coords.position === "up") {
        if (coords.bottom + heightAdjustment > window.innerHeight) return false;
    }
    if (coords.position === "down") {
        if (coords.top + heightAdjustment > window.innerHeight) return false;
    }
    if (coords.position === "right") {
        if (coords.left + widthToUse > window.innerWidth) return false;
    }
    if (coords.position === "left") {
        if (coords.right + widthToUse > window.innerWidth) return false;
    }
    return true;
};
const $a31343b90c9d3d88$var$UnmemoizedTooltip = ({ iconColor: iconColor = "black" , iconSize: iconSize , children: children = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
    height: "100%",
    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
        icon: "info",
        strokeWidth: 2,
        color: iconColor,
        size: iconSize
    })
}) , content: content , display: display = "inline-block" , lineHeight: lineHeight = 1 , disabled: disabled = false , hideOnClick: hideOnClick = false , maxWidthOverride: maxWidthOverride , containerWidthOverride: containerWidthOverride = "auto"  })=>{
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "mobileLarge"
    });
    const [hovered, setHovered] = (0, $g5BLJ.useState)(false);
    const active = !disabled && hovered;
    const [tooltipcoordinates, setTooltipcoordinates] = (0, $g5BLJ.useState)({
        left: -1000,
        bottom: window.innerHeight + 1000,
        position: "up"
    });
    const [tooltipContainer, setTooltipContainer] = (0, $g5BLJ.useState)(null);
    const tooltipContainerRef = (elem)=>{
        if (elem && elem !== tooltipContainer) setTooltipContainer(elem);
    };
    const onMouseEnter = (0, $g5BLJ.useCallback)(()=>{
        setHovered(true);
    }, []);
    const onMouseLeave = (0, $g5BLJ.useCallback)(()=>{
        setHovered(false);
    }, []);
    const onContainerClicked = (0, $g5BLJ.useCallback)(()=>{
        if (hideOnClick) setHovered(false);
    }, [
        hideOnClick
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!tooltipContainer || !active) return;
        const reset = (0, $eYBdv.throttle)(()=>{
            const rect = tooltipContainer.getBoundingClientRect();
            const upTooltipcoordinates = {
                left: rect.left + rect.width / 2,
                bottom: window.innerHeight - (rect.top - $a31343b90c9d3d88$var$BUFFER_SIZE),
                position: "up"
            };
            const downTooltipcoordinates = {
                left: rect.left + rect.width / 2,
                top: rect.bottom + $a31343b90c9d3d88$var$BUFFER_SIZE,
                position: "down"
            };
            const leftTooltipcoordinates = {
                right: window.innerWidth - rect.left + $a31343b90c9d3d88$var$BUFFER_SIZE,
                top: rect.top + rect.height / 2,
                position: "left"
            };
            const rightTooltipcoordinates = {
                left: rect.right + $a31343b90c9d3d88$var$BUFFER_SIZE,
                top: rect.top + rect.height / 2,
                position: "right"
            };
            const tooltipCoordinateOptions = [
                upTooltipcoordinates,
                downTooltipcoordinates,
                leftTooltipcoordinates,
                rightTooltipcoordinates
            ];
            const newTooltipcoordinates = tooltipCoordinateOptions.find((coords)=>$a31343b90c9d3d88$var$isValidTooltipcoordinates(coords, showMobile)) ?? upTooltipcoordinates;
            setTooltipcoordinates(newTooltipcoordinates);
        }, 10);
        reset();
        window.addEventListener("resize", reset);
        document.addEventListener("scroll", reset);
        (0, $7ffd711af926678d$export$b1db755df1284766)(tooltipContainer, "scroll", reset);
        return ()=>{
            window.removeEventListener("resize", reset);
            document.removeEventListener("scroll", reset);
            (0, $7ffd711af926678d$export$c2d4ecb2b67248a1)(tooltipContainer, "scroll", reset);
        };
    }, [
        tooltipContainer,
        active,
        showMobile
    ]);
    const { position: position , ...coordinates } = tooltipcoordinates;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($a31343b90c9d3d88$export$44ec04c6081e3a25, {
        $display: display,
        $lineHeight: lineHeight,
        $containerWidthOverride: containerWidthOverride,
        ref: tooltipContainerRef,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onContainerClicked,
        children: [
            children,
            !disabled && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($a31343b90c9d3d88$var$TooltipContent, {
                // Styled-components generates a new class every time you change something
                // so we use inline styles here to clean it up
                style: coordinates,
                $position: position,
                $hovered: hovered,
                $showMobile: showMobile,
                $maxWidthOverride: maxWidthOverride,
                children: [
                    content,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5a746d7ba2cd2a5b$export$21b07c8f274aebd5), {
                        direction: (0, $5a746d7ba2cd2a5b$export$b3e2dbef906ff421)(tooltipcoordinates.position),
                        size: $a31343b90c9d3d88$var$ARROW_SIZE,
                        color: "white",
                        position: tooltipcoordinates.position
                    })
                ]
            })
        ]
    });
};
const $a31343b90c9d3d88$export$28c660c63b792dea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo($a31343b90c9d3d88$var$UnmemoizedTooltip);




const $014f444f542f72d0$export$4fe1c22bc4285940 = ({ isPaperUser: isPaperUser  })=>{
    const [sharingDisclaimerOpen, setSharingDisclaimerOpen] = (0, $g5BLJ.useState)(false);
    return isPaperUser ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>setSharingDisclaimerOpen(true),
                displayType: "noStyles",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    height: "100%",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "question",
                        strokeWidth: 2,
                        color: "white",
                        fill: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
                openType: "state",
                opened: sharingDisclaimerOpen,
                header: "Disclaimer for teachers sharing content",
                close: ()=>setSharingDisclaimerOpen(false),
                maxWidthOverride: "600px",
                children: "By uploading this content, I represent and warrant that I have the proper rights to share this content broadly within the Paper Reading teacher community. I take full responsibility and shall indemnify and hold harmless Paper Education Company Inc. and its affiliates should any third party claim damages due to copyright infringement or any other intellectual property rights in this content as a result of my upload to Paper's platform. If I am unsure about whether I have the right to share this content, I should not upload it."
            })
        ]
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        iconColor: "white",
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: "Share this content with other teachers using Readlee!"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    href: "https://readleesupport.zendesk.com/hc/en-us/articles/14120752237837",
                    newTab: true,
                    children: "Learn more"
                })
            ]
        })
    });
};






parcelRequire("g5BLJ");

const $75bbc38696b505c4$export$1f54913ccc4368b1 = ({ children: children  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        justify: "center",
        height: "100%",
        children: children
    });






parcelRequire("g5BLJ");
const $fda686ea548b88eb$var$SvgLogoFullName = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 148,
        height: 27,
        viewBox: "0 0 148 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M99.362 27c.723 0 1.309-.566 1.309-1.263V1.44c0-.697-.586-1.263-1.309-1.263h-2.028c-.723 0-1.309.566-1.309 1.263v24.297c0 .698.586 1.263 1.308 1.263h2.03ZM85.919 8.551c-1.477-1.484-3.492-2.454-6.105-2.454-5.746 0-10.514 4.623-10.514 10.425 0 5.802 4.748 10.424 10.514 10.424 2.773 0 4.908-1.14 6.424-2.815l.194 1.262c.095.62.645 1.078 1.294 1.078h2.012c.722 0 1.308-.566 1.308-1.263V1.263C91.046.566 90.46 0 89.738 0h-2.511c-.723 0-1.308.566-1.308 1.263v7.288Zm-5.666 13.792c-3.332 0-5.906-2.416-5.906-5.802 0-3.367 2.594-5.86 5.906-5.86 3.352 0 6.005 2.493 6.005 5.86 0 3.386-2.673 5.802-6.005 5.802ZM61.19 8.56c-1.55-1.73-3.73-2.915-6.625-2.915-5.87 0-10.741 4.723-10.741 10.65 0 5.928 4.85 10.65 10.741 10.65 2.833 0 5.014-1.166 6.563-2.876l.13.85c.136.885.923 1.54 1.85 1.54h1.063c1.033 0 1.87-.808 1.87-1.804V7.897c0-.997-.837-1.805-1.87-1.805h-1.01c-.94 0-1.735.675-1.854 1.576l-.118.892Zm-6.176 13.682c-3.404 0-6.034-2.468-6.034-5.927 0-3.44 2.65-5.986 6.034-5.986 3.424 0 6.135 2.546 6.135 5.986 0 3.459-2.732 5.927-6.136 5.927ZM14.886 17.201c2.466-1.244 4.11-3.459 4.11-6.73 0-4.737-3.467-7.94-8.631-7.94H0v22.676c0 .698.586 1.263 1.308 1.263h2.227c.722 0 1.308-.565 1.308-1.263v-6.78h4.2c.41 0 .803-.016 1.197-.033l3.578 7.35c.215.444.677.726 1.184.726h2.53c.97 0 1.602-.984 1.172-1.823L14.886 17.2ZM4.843 6.773h5.11c2.36 0 4.129 1.38 4.129 3.715 0 2.249-1.662 3.8-4.146 3.8H4.843V6.772ZM123.644 15.227c.624-.162 1.039-.742.908-1.354-1.261-5.912-6.874-9.923-13.514-8.205-6.043 1.563-9.057 7.333-7.439 13.081 1.603 5.692 7.526 9.17 13.831 7.538 2.754-.712 4.858-2.09 6.339-3.848.42-.499.299-1.222-.217-1.632l-1.37-1.09c-.603-.479-1.498-.338-2.038.203-.909.909-2.101 1.624-3.614 2.016-2.991.774-5.91-.276-7.401-2.954l14.515-3.755Zm-11.227-5.433c2.789-.721 5.074.31 6.43 2.738l-10.711 2.772c-.042-2.768 1.613-4.82 4.281-5.51ZM147.067 15.227c.625-.162 1.039-.742.909-1.354-1.261-5.912-6.874-9.923-13.514-8.205-6.043 1.563-9.058 7.333-7.439 13.081 1.603 5.692 7.526 9.17 13.831 7.538 2.753-.712 4.857-2.09 6.338-3.848.421-.499.3-1.222-.216-1.632l-1.371-1.09c-.603-.479-1.497-.338-2.038.203-.909.909-2.101 1.624-3.613 2.016-2.991.774-5.911-.276-7.402-2.954l14.515-3.755ZM135.84 9.794c2.789-.721 5.075.31 6.431 2.738l-10.711 2.772c-.043-2.768 1.613-4.82 4.28-5.51ZM41.013 15.227c.625-.162 1.039-.742.909-1.354-1.261-5.912-6.875-9.923-13.515-8.205C22.365 7.23 19.35 13 20.968 18.749c1.603 5.692 7.526 9.17 13.832 7.538 2.753-.712 4.857-2.09 6.338-3.848.42-.499.3-1.222-.216-1.632l-1.371-1.09c-.603-.479-1.497-.338-2.038.203-.909.909-2.101 1.624-3.614 2.016-2.99.774-5.91-.276-7.401-2.954l14.515-3.755ZM29.786 9.794c2.789-.721 5.074.31 6.43 2.738l-10.71 2.772c-.043-2.768 1.613-4.82 4.28-5.51Z"
        })
    });
var $fda686ea548b88eb$export$2e2bcd8739ae039 = $fda686ea548b88eb$var$SvgLogoFullName;



parcelRequire("g5BLJ");
const $b3bab8e72a064a96$var$SvgLogoFullNamePro = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 791.756,
        height: 113.741,
        viewBox: "0 0 791.756 113.741",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M419.412 113.74c3.047 0 5.524-2.386 5.524-5.33V5.852c0-2.945-2.477-5.332-5.524-5.332h-8.567c-3.047 0-5.52 2.387-5.52 5.332v102.556c0 2.945 2.473 5.332 5.52 5.332zM362.664 36.094c-6.232-6.263-14.737-10.358-25.77-10.358-24.253 0-44.38 19.512-44.38 44.003 0 24.49 20.043 44.002 44.38 44.002 11.706 0 20.717-4.817 27.117-11.884l.818 5.327c.4 2.614 2.725 4.55 5.462 4.55h8.494c3.05 0 5.522-2.387 5.522-5.332V5.332c0-2.945-2.472-5.332-5.522-5.332h-10.6c-3.049 0-5.521 2.387-5.521 5.332zM338.747 94.31c-14.063 0-24.927-10.197-24.927-24.49 0-14.213 10.948-24.732 24.927-24.732 14.148 0 25.349 10.52 25.349 24.732 0 14.293-11.285 24.49-25.349 24.49zM258.281 36.138c-6.538-7.301-15.744-12.305-27.961-12.305-24.778 0-45.34 19.933-45.34 44.954 0 25.02 20.476 44.954 45.34 44.954 11.959 0 21.164-4.922 27.703-12.141l.55 3.59c.574 3.734 3.894 6.5 7.804 6.5h4.492c4.356 0 7.888-3.41 7.888-7.617V33.336c0-4.206-3.532-7.616-7.888-7.616h-4.266c-3.97 0-7.322 2.85-7.825 6.653zm-26.069 57.751c-14.367 0-25.465-10.418-25.465-25.02 0-14.52 11.184-25.266 25.465-25.266 14.454 0 25.897 10.746 25.897 25.266 0 14.602-11.529 25.02-25.897 25.02zM62.833 74.616c10.409-5.25 17.349-14.6 17.349-28.41 0-19.994-14.634-33.515-36.433-33.515H0v95.718c0 2.945 2.472 5.332 5.522 5.332h9.398c3.05 0 5.521-2.387 5.521-5.332V79.794h17.726c1.735 0 3.395-.072 5.054-.144l15.103 31.027c.91 1.87 2.858 3.064 4.997 3.064h10.68c4.095 0 6.766-4.154 4.948-7.697zM20.44 30.599h21.573c9.957 0 17.424 5.826 17.424 15.68 0 9.493-7.015 16.038-17.5 16.038H20.442ZM521.902 65.352c2.637-.683 4.386-3.132 3.835-5.713-5.322-24.955-29.016-41.887-57.044-34.636-25.507 6.6-38.23 30.955-31.4 55.218 6.77 24.023 31.77 38.703 58.383 31.817 11.622-3.006 20.506-8.824 26.757-16.243 1.773-2.106 1.262-5.159-.917-6.89l-5.784-4.598c-2.545-2.023-6.324-1.429-8.603.854-3.835 3.838-8.868 6.858-15.252 8.51-12.627 3.266-24.948-1.167-31.24-12.467zM474.514 42.42c11.775-3.046 21.419 1.309 27.143 11.558l-45.213 11.697c-.176-11.684 6.81-20.342 18.07-23.255zM620.775 65.352c2.637-.683 4.385-3.132 3.839-5.713-5.327-24.955-29.017-41.887-57.044-34.636-25.507 6.6-38.235 30.955-31.4 55.218 6.765 24.023 31.765 38.703 58.378 31.817 11.622-3.006 20.502-8.824 26.753-16.243 1.777-2.106 1.266-5.159-.908-6.89l-5.79-4.598c-2.544-2.023-6.319-1.429-8.602.854-3.835 3.838-8.868 6.858-15.252 8.51-12.623 3.266-24.948-1.167-31.244-12.467zM573.387 42.42c11.77-3.046 21.418 1.309 27.143 11.558l-45.21 11.697c-.18-11.684 6.807-20.342 18.067-23.255zM173.117 65.352c2.636-.683 4.385-3.132 3.835-5.713-5.323-24.955-29.017-41.887-57.045-34.636-25.506 6.6-38.232 30.955-31.399 55.218 6.766 24.023 31.767 38.703 58.382 31.817 11.62-3.006 20.501-8.824 26.753-16.243 1.774-2.106 1.265-5.159-.913-6.89l-5.784-4.598c-2.546-2.023-6.321-1.429-8.604.854-3.836 3.838-8.868 6.858-15.253 8.51-12.625 3.266-24.947-1.167-31.241-12.467zm-47.39-22.931c11.772-3.046 21.418 1.309 27.142 11.558l-45.211 11.697c-.179-11.684 6.81-20.342 18.07-23.255z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M419.412 113.74c3.047 0 5.524-2.386 5.524-5.33V5.852c0-2.945-2.477-5.332-5.524-5.332h-8.567c-3.047 0-5.52 2.387-5.52 5.332v102.556c0 2.945 2.473 5.332 5.52 5.332zM362.664 36.094c-6.232-6.263-14.737-10.358-25.77-10.358-24.253 0-44.38 19.512-44.38 44.003 0 24.49 20.043 44.002 44.38 44.002 11.706 0 20.717-4.817 27.117-11.884l.818 5.327c.4 2.614 2.725 4.55 5.462 4.55h8.494c3.05 0 5.522-2.387 5.522-5.332V5.332c0-2.945-2.472-5.332-5.522-5.332h-10.6c-3.049 0-5.521 2.387-5.521 5.332zM338.747 94.31c-14.063 0-24.927-10.197-24.927-24.49 0-14.213 10.948-24.732 24.927-24.732 14.148 0 25.349 10.52 25.349 24.732 0 14.293-11.285 24.49-25.349 24.49zM620.775 65.352c2.637-.683 4.385-3.132 3.839-5.713-5.327-24.955-29.017-41.887-57.044-34.636-25.507 6.6-38.235 30.955-31.4 55.218 6.765 24.023 31.765 38.703 58.378 31.817 11.622-3.006 20.502-8.824 26.753-16.243 1.777-2.106 1.266-5.159-.908-6.89l-5.79-4.598c-2.544-2.023-6.319-1.429-8.602.854-3.835 3.838-8.868 6.858-15.252 8.51-12.623 3.266-24.948-1.167-31.244-12.467zM573.387 42.42c11.77-3.046 21.418 1.309 27.143 11.558l-45.21 11.697c-.18-11.684 6.807-20.342 18.067-23.255zM705.352 74.613c0-10.4-6.032-17.432-17.37-17.432h-22.756v49.787c0 1.531 1.286 2.773 2.872 2.773h4.888c1.587 0 2.873-1.242 2.873-2.773V92.084h9.535c13.952 1.455 20.05-5.017 19.958-17.47zm-29.493-8.117h11.22c5.18 0 9.063 3.03 9.063 8.155 0 4.938-3.648 8.342-9.102 8.342H675.86zM770.763 66.586a21.581 21.581 0 0 0-22.162 20.985 21.581 21.581 0 0 0 20.986 22.162 21.581 21.581 0 0 0 22.161-20.985 21.581 21.581 0 0 0-20.985-22.162zm-.252 9.233a12.344 12.344 0 0 1 12.004 12.677 12.344 12.344 0 0 1-12.677 12.003 12.344 12.344 0 0 1-12.003-12.676 12.344 12.344 0 0 1 12.676-12.004zM710.232 80.402c2.03-6.034 7.904-13.684 20.25-13.803 6.962-.078 13.867 3.998 16.552 8.392.727 1.945-.858 2.506-.858 2.506l-3.552 2.549c-1.362.908-2.984-.156-2.984-.156-3.303-3.193-3.858-4.746-8.849-4.914-5.587-.188-10.037 3.59-11.317 4.88z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M709.477 106.468c.288 1.88 1.96 3.273 3.928 3.273h2.262c2.193 0 3.971-1.717 3.971-3.835V70.293c0-2.118-1.778-3.835-3.971-3.835h-2.148c-1.999 0-3.686 1.435-3.94 3.35.029 11.574.03 24.25-.102 36.66z"
            })
        ]
    });
var $b3bab8e72a064a96$export$2e2bcd8739ae039 = $b3bab8e72a064a96$var$SvgLogoFullNamePro;



parcelRequire("g5BLJ");
const $e4e7e55930cc2844$var$SvgLogoFullNameUltimate = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 982,
        height: 114,
        viewBox: "0 0 982 114",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M419.412 113.74c3.047 0 5.524-2.387 5.524-5.331V5.852c0-2.944-2.477-5.331-5.524-5.331h-8.566c-3.048 0-5.52 2.387-5.52 5.331V108.41c0 2.944 2.472 5.331 5.52 5.331h8.566ZM362.664 36.094c-6.232-6.263-14.738-10.358-25.77-10.358-24.253 0-44.38 19.512-44.38 44.002 0 24.49 20.043 44.003 44.38 44.003 11.706 0 20.717-4.817 27.117-11.884l.818 5.327c.401 2.614 2.725 4.55 5.462 4.55h8.494c3.049 0 5.522-2.387 5.522-5.332V5.332c0-2.945-2.473-5.332-5.522-5.332h-10.599c-3.05 0-5.522 2.387-5.522 5.332v30.762ZM338.747 94.31c-14.063 0-24.927-10.197-24.927-24.49 0-14.213 10.948-24.732 24.927-24.732 14.148 0 25.349 10.52 25.349 24.732 0 14.293-11.285 24.49-25.349 24.49ZM258.281 36.138c-6.539-7.301-15.745-12.305-27.961-12.305-24.778 0-45.341 19.934-45.341 44.954s20.477 44.954 45.341 44.954c11.958 0 21.164-4.922 27.703-12.141l.55 3.59c.574 3.735 3.893 6.5 7.804 6.5h4.492c4.356 0 7.888-3.41 7.888-7.617V33.336c0-4.206-3.532-7.616-7.888-7.616h-4.266c-3.971 0-7.322 2.85-7.825 6.653l-.497 3.765Zm-26.069 57.751c-14.367 0-25.465-10.418-25.465-25.02 0-14.52 11.184-25.266 25.465-25.266 14.454 0 25.897 10.746 25.897 25.266 0 14.602-11.529 25.02-25.897 25.02ZM62.833 74.615c10.409-5.25 17.349-14.6 17.349-28.409 0-19.994-14.634-33.516-36.433-33.516H0v95.719c0 2.945 2.472 5.332 5.522 5.332h9.398c3.05 0 5.521-2.387 5.521-5.332V79.794h17.726c1.735 0 3.395-.072 5.054-.144l15.103 31.027c.91 1.87 2.858 3.064 4.997 3.064h10.68c4.095 0 6.766-4.154 4.948-7.698L62.833 74.615ZM20.44 30.6h21.573c9.957 0 17.424 5.826 17.424 15.679 0 9.494-7.015 16.039-17.5 16.039H20.442V30.599ZM521.902 65.352c2.637-.683 4.386-3.132 3.835-5.713-5.322-24.955-29.016-41.887-57.044-34.636-25.507 6.6-38.23 30.955-31.4 55.218 6.77 24.023 31.77 38.703 58.383 31.817 11.621-3.006 20.506-8.824 26.757-16.243 1.773-2.106 1.262-5.159-.917-6.89l-5.785-4.598c-2.544-2.023-6.323-1.429-8.602.854-3.836 3.838-8.869 6.858-15.252 8.51-12.627 3.266-24.949-1.167-31.24-12.467l61.265-15.852ZM474.514 42.42c11.775-3.046 21.419 1.309 27.143 11.558l-45.213 11.697c-.177-11.684 6.81-20.342 18.07-23.255ZM620.775 65.352c2.637-.683 4.385-3.132 3.839-5.713-5.327-24.955-29.017-41.887-57.044-34.636-25.507 6.6-38.235 30.955-31.401 55.218 6.766 24.023 31.767 38.703 58.379 31.817 11.622-3.006 20.502-8.824 26.753-16.243 1.777-2.106 1.267-5.159-.908-6.89l-5.789-4.598c-2.545-2.023-6.32-1.429-8.603.854-3.835 3.838-8.868 6.858-15.252 8.51-12.623 3.266-24.948-1.167-31.243-12.467l61.269-15.852ZM573.387 42.42c11.77-3.046 21.418 1.309 27.143 11.558l-45.209 11.697c-.181-11.684 6.806-20.342 18.066-23.255ZM173.117 65.352c2.636-.683 4.385-3.132 3.835-5.713-5.323-24.955-29.017-41.887-57.045-34.636-25.506 6.6-38.231 30.955-31.399 55.218 6.766 24.023 31.767 38.703 58.382 31.817 11.62-3.006 20.501-8.824 26.753-16.243 1.774-2.106 1.265-5.159-.913-6.89l-5.784-4.598c-2.546-2.023-6.321-1.429-8.604.854-3.835 3.838-8.868 6.858-15.253 8.51-12.625 3.266-24.947-1.167-31.241-12.467l61.269-15.852ZM125.728 42.42c11.771-3.046 21.417 1.309 27.141 11.558l-45.211 11.697c-.179-11.684 6.81-20.342 18.07-23.255Z"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M419.412 113.74c3.047 0 5.524-2.387 5.524-5.331V5.852c0-2.944-2.477-5.331-5.524-5.331h-8.566c-3.048 0-5.52 2.387-5.52 5.331V108.41c0 2.944 2.472 5.331 5.52 5.331h8.566ZM362.664 36.094c-6.232-6.263-14.738-10.358-25.77-10.358-24.253 0-44.38 19.512-44.38 44.002 0 24.49 20.043 44.003 44.38 44.003 11.706 0 20.717-4.817 27.117-11.884l.818 5.327c.401 2.614 2.725 4.55 5.462 4.55h8.494c3.049 0 5.522-2.387 5.522-5.332V5.332c0-2.945-2.473-5.332-5.522-5.332h-10.599c-3.05 0-5.522 2.387-5.522 5.332v30.762ZM338.747 94.31c-14.063 0-24.927-10.197-24.927-24.49 0-14.213 10.948-24.732 24.927-24.732 14.148 0 25.349 10.52 25.349 24.732 0 14.293-11.285 24.49-25.349 24.49ZM620.775 65.352c2.637-.683 4.385-3.132 3.839-5.713-5.327-24.955-29.017-41.887-57.044-34.636-25.507 6.6-38.235 30.955-31.401 55.218 6.766 24.023 31.767 38.703 58.379 31.817 11.622-3.006 20.502-8.824 26.753-16.243 1.777-2.106 1.267-5.159-.908-6.89l-5.789-4.598c-2.545-2.023-6.32-1.429-8.603.854-3.835 3.838-8.868 6.858-15.252 8.51-12.623 3.266-24.948-1.167-31.243-12.467l61.269-15.852ZM573.387 42.42c11.77-3.046 21.418 1.309 27.143 11.558l-45.209 11.697c-.181-11.684 6.806-20.342 18.066-23.255ZM687.225 110.125c-4.35 0-8.175-.875-11.475-2.625-3.3-1.775-5.875-4.263-7.725-7.463-1.85-3.2-2.775-6.962-2.775-11.287V55.075L675.6 55v33.675c0 1.775.3 3.388.9 4.838.6 1.45 1.425 2.7 2.475 3.75a11.536 11.536 0 0 0 3.713 2.437c1.425.55 2.937.825 4.537.825 1.65 0 3.175-.288 4.575-.863a11.02 11.02 0 0 0 3.713-2.437c1.05-1.05 1.862-2.3 2.437-3.75.6-1.45.9-3.05.9-4.8V55h10.35v33.75c0 4.325-.925 8.088-2.775 11.287-1.85 3.2-4.425 5.688-7.725 7.463-3.3 1.75-7.125 2.625-11.475 2.625ZM720.419 109V53.875h10.2V109h-10.2Zm45.742 0c-2.8.525-5.55.75-8.25.675-2.675-.05-5.075-.512-7.2-1.388-2.1-.9-3.7-2.337-4.8-4.312-1-1.85-1.525-3.725-1.575-5.625-.05-1.925-.075-4.1-.075-6.525V57.25h10.2v33.975c0 1.575.013 3 .038 4.275.05 1.25.312 2.25.787 3 .9 1.425 2.338 2.2 4.313 2.325 1.975.125 4.162.025 6.562-.3V109Zm-28.8-32.625V68.5h28.8v7.875h-28.8Zm38.576-13.5v-9h10.2v9h-10.2Zm0 46.125V68.5h10.2V109h-10.2Zm70.192 0V85.075c0-2.675-.638-4.75-1.913-6.225-1.25-1.5-2.987-2.25-5.212-2.25-1.425 0-2.663.338-3.713 1.013-1.05.65-1.875 1.575-2.475 2.775-.575 1.174-.862 2.537-.862 4.087l-4.275-2.85c0-2.775.65-5.225 1.95-7.35a13.78 13.78 0 0 1 5.287-4.95c2.225-1.2 4.688-1.8 7.388-1.8 4.625 0 8.112 1.375 10.462 4.125 2.375 2.725 3.563 6.3 3.563 10.725V109h-10.2Zm-48.825 0V68.5h9v13.425h1.275V109h-10.275Zm24.45 0V85.075c0-2.675-.638-4.75-1.913-6.225-1.25-1.5-2.987-2.25-5.212-2.25-2.125 0-3.838.738-5.138 2.213-1.275 1.45-1.912 3.337-1.912 5.662l-4.275-3c0-2.65.662-5.025 1.987-7.125 1.325-2.1 3.1-3.762 5.325-4.987 2.25-1.225 4.763-1.838 7.538-1.838 3.175 0 5.775.675 7.8 2.025a12.09 12.09 0 0 1 4.537 5.4c.975 2.25 1.463 4.725 1.463 7.425V109h-10.2Zm55.576 1.125c-2.9 0-5.362-.55-7.387-1.65-2-1.125-3.525-2.613-4.575-4.463-1.025-1.875-1.538-3.937-1.538-6.187 0-1.875.288-3.588.863-5.138.575-1.55 1.5-2.912 2.775-4.087 1.3-1.2 3.037-2.2 5.212-3 1.5-.55 3.288-1.037 5.363-1.462 2.075-.425 4.425-.826 7.05-1.2 2.625-.4 5.512-.838 8.662-1.313l-3.675 2.025c0-2.4-.575-4.163-1.725-5.288-1.15-1.124-3.075-1.687-5.775-1.687-1.5 0-3.062.362-4.687 1.088-1.625.724-2.763 2.012-3.413 3.862l-9.225-2.925c1.025-3.35 2.95-6.075 5.775-8.175 2.825-2.1 6.675-3.15 11.55-3.15 3.575 0 6.75.55 9.525 1.65 2.775 1.1 4.875 3 6.3 5.7.8 1.5 1.275 3 1.425 4.5.15 1.5.225 3.175.225 5.025V109h-8.925v-8.325l1.275 1.725c-1.975 2.725-4.112 4.7-6.412 5.925-2.275 1.2-5.163 1.8-8.663 1.8Zm2.175-8.025c1.875 0 3.45-.325 4.725-.975 1.3-.675 2.325-1.438 3.075-2.287.775-.85 1.3-1.563 1.575-2.138.525-1.1.825-2.375.9-3.825.1-1.475.15-2.7.15-3.675l3 .75c-3.025.5-5.475.925-7.35 1.275-1.875.325-3.387.625-4.537.9a26.48 26.48 0 0 0-3.038.9c-1 .4-1.812.837-2.437 1.313-.6.45-1.05.95-1.35 1.5a4.051 4.051 0 0 0-.413 1.837c0 .925.225 1.725.675 2.4.475.65 1.138 1.15 1.988 1.5.85.35 1.862.525 3.037.525Zm54.601 6.9c-2.8.525-5.55.75-8.25.675-2.675-.05-5.075-.512-7.2-1.388-2.1-.9-3.7-2.337-4.8-4.312-1-1.85-1.525-3.725-1.575-5.625-.05-1.925-.075-4.1-.075-6.525V57.25h10.2v33.975c0 1.575.012 3 .037 4.275.05 1.25.313 2.25.788 3 .9 1.425 2.337 2.2 4.312 2.325s4.163.025 6.563-.3V109Zm-28.8-32.625V68.5h28.8v7.875h-28.8Zm54.453 33.75c-4.15 0-7.813-.887-10.988-2.663-3.15-1.8-5.625-4.262-7.425-7.387-1.775-3.15-2.662-6.75-2.662-10.8 0-4.425.875-8.275 2.625-11.55 1.75-3.275 4.162-5.813 7.237-7.612 3.075-1.826 6.613-2.738 10.613-2.738 4.25 0 7.862 1 10.837 3 2.975 2 5.175 4.813 6.6 8.438 1.425 3.624 1.925 7.887 1.5 12.787h-10.087v-3.75c0-4.125-.663-7.087-1.988-8.887-1.3-1.825-3.437-2.738-6.412-2.738-3.475 0-6.038 1.063-7.688 3.188-1.625 2.1-2.437 5.212-2.437 9.337 0 3.775.812 6.7 2.437 8.775 1.65 2.05 4.063 3.075 7.238 3.075 2 0 3.712-.438 5.137-1.313 1.425-.875 2.513-2.137 3.263-3.787l10.2 2.925c-1.525 3.7-3.938 6.575-7.238 8.625-3.275 2.05-6.862 3.075-10.762 3.075ZM946.334 91.6v-7.575h26.85V91.6h-26.85Z"
            })
        ]
    });
var $e4e7e55930cc2844$export$2e2bcd8739ae039 = $e4e7e55930cc2844$var$SvgLogoFullNameUltimate;



parcelRequire("g5BLJ");
const $3305e8433bc3fb0d$var$SvgPaperReadingLogo = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("svg", {
        width: 504,
        height: 212,
        viewBox: "0 0 504 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m468.955 195.089 4.7-26.861h-25.869l-1.823 10.52h9.657c-.724 2.004-1.822 3.497-3.293 4.477-1.45.959-3.177 1.439-5.18 1.439-1.514 0-2.782-.213-3.806-.639-1.002-.427-1.79-1.077-2.366-1.951-.938-1.364-1.407-3.059-1.407-5.084 0-1.663.149-3.443.448-5.34a28.33 28.33 0 0 1 1.407-5.309c.639-1.662 1.407-2.952 2.302-3.869.874-.895 1.833-1.524 2.878-1.886 1.045-.384 2.313-.576 3.805-.576 1.876 0 3.368.533 4.477 1.599 1.109 1.066 1.833 2.601 2.174 4.604l16.532-2.846c-1.001-4.86-3.421-8.612-7.258-11.255-3.838-2.644-8.954-3.966-15.349-3.966-6.033 0-11.171 1.152-15.413 3.454-4.221 2.281-7.429 5.575-9.625 9.881-2.175 4.285-3.262 9.39-3.262 15.317 0 4.008.768 7.472 2.303 10.392 1.556 2.9 3.794 5.127 6.715 6.683 2.942 1.535 6.448 2.303 10.52 2.303 3.027 0 5.724-.522 8.09-1.567 2.367-1.066 4.232-2.548 5.596-4.445l-.288 4.925h13.335Zm-276.057-10.297a29.269 29.269 0 0 0-.192 3.294c0 1.321.118 2.547.352 3.677a11.098 11.098 0 0 0 1.247 3.134l-.096.192h-16.916c-.703-1.322-1.055-2.953-1.055-4.893 0-.938.096-2.153.288-3.645 0-.149.021-.395.064-.736a14.52 14.52 0 0 0 .096-1.599c0-1.534-.405-2.611-1.215-3.229-.81-.618-2.153-.928-4.029-.928h-4.253l-2.148 12.015-15.062-5.136 6.625-37.704h23.823c5.33 0 9.529 1.034 12.599 3.101 3.091 2.068 4.637 5.373 4.637 9.913 0 6.417-3.134 10.67-9.402 12.759 3.156 1.492 4.733 4.178 4.733 8.058 0 .533-.032 1.109-.096 1.727Zm-19.314-15.445c2.452 0 4.274-.384 5.468-1.151 1.194-.789 1.791-2.185 1.791-4.189 0-1.087-.224-1.897-.672-2.43-.426-.554-1.044-.917-1.854-1.087-.789-.171-1.855-.256-3.198-.256h-4.477l-1.599 9.113h4.541Zm32.585-20.113h37.892l-2.014 11.543h-21.713l-.991 5.788h19.474l-1.951 10.904h-19.474l-1.055 6.076h21.649l-2.015 11.544H198.11l8.059-45.855Zm52.506 38.628h14.197l.704 7.227h16.404l-7.387-45.855h-20.817l-23.567 45.855h17.236l3.23-7.227Zm12.535-17.46.543 5.756h-7.866l2.558-5.756c.938-2.131 2.132-4.977 3.581-8.537.064-.128.128-.267.192-.416.064-.171.139-.363.224-.576h.064c.128 2.665.363 5.841.704 9.529Zm29.994-21.168h19.794c4.839 0 8.932.82 12.279 2.462 3.368 1.62 5.905 3.933 7.61 6.939 1.706 3.006 2.558 6.555 2.558 10.648 0 5.287-1.14 9.87-3.421 13.75-2.26 3.88-5.511 6.865-9.753 8.954-4.242 2.068-9.263 3.102-15.061 3.102h-22.064l8.058-45.855Zm13.43 33.991c3.901 0 6.769-1.076 8.602-3.23 2.089-2.366 3.134-5.937 3.134-10.712 0-1.087-.117-2.068-.352-2.942-.213-.874-.512-1.609-.895-2.206-.597-.959-1.471-1.62-2.622-1.983-1.13-.362-2.655-.543-4.573-.543h-2.686l-3.805 21.616h3.197Zm53.945-33.991h-16.212l-8.058 45.855h16.212l8.058-45.855Zm6.651 0h19.442l4.317 15.828c.874 3.326 1.866 7.504 2.974 12.535h.128c.256-2.004.586-4.349.991-7.035.427-2.707.778-4.86 1.056-6.459l2.59-14.869h15.189l-8.09 45.855h-19.442l-4.509-16.373-.544-2.046a592.583 592.583 0 0 1-1.407-5.564 67.573 67.573 0 0 1-.895-4.221h-.128c-.298 2.409-.65 4.956-1.055 7.642-.405 2.686-.682 4.392-.832 5.117l-2.686 15.445H367.14l8.09-45.855Z",
                fill: "#0014D1"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M504 0H0v141.439h338.885l24.113-8.194 127.403 8.194 3.409-52.644L504 85.333V0Z",
                fill: "#0014D1"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
                d: "M49.29 28.79h37.795c7.199 0 13.429.8 18.693 2.398 5.261 1.6 9.458 4.455 12.588 8.57 3.13 4.112 4.695 9.737 4.695 16.873 0 11.151-3.707 19.125-11.122 23.921-7.415 4.796-17.753 7.194-31.017 7.194H68.187l-4.402 24.915H34.5l14.79-83.871Zm30.46 38.66c4.578 0 7.943-.732 10.094-2.193 2.152-1.461 3.228-4.103 3.228-7.925 0-2.182-.42-3.85-1.261-5s-2.005-1.93-3.491-2.34c-1.488-.41-3.385-.614-5.693-.614h-7.63l-3.17 18.074h7.923v-.002ZM169.096 99.444h-26.058l-5.927 13.217h-31.634L148.73 28.79h38.207l13.557 83.871h-30.108l-1.29-13.217Zm-2.054-21.407-.997-10.527c-.627-6.745-1.058-12.554-1.291-17.43h-.117l-.411 1.024a9.687 9.687 0 0 1-.353.79c-2.661 6.512-4.851 11.717-6.572 15.616l-4.695 10.527h14.436ZM221.999 28.79h37.794c7.199 0 13.43.8 18.693 2.398 5.262 1.6 9.458 4.455 12.589 8.57 3.13 4.112 4.695 9.737 4.695 16.873 0 11.151-3.708 19.125-11.122 23.921-7.415 4.796-17.753 7.194-31.018 7.194h-12.735l-4.402 24.915h-29.285l14.791-83.871Zm30.46 38.66c4.578 0 7.943-.732 10.094-2.193 2.152-1.461 3.227-4.103 3.227-7.925 0-2.182-.419-3.85-1.261-5-.841-1.15-2.005-1.93-3.491-2.34-1.488-.41-3.385-.614-5.692-.614h-7.629l-3.169 18.074h7.921v-.002ZM307.836 28.79h69.546l-3.624 20.588h-39.852l-1.89 11.114h35.741l-3.581 19.943h-35.741l-1.936 11.114h39.732l-3.698 21.114h-69.488l14.791-83.873ZM422.604 92.776c0 .897-.058 1.872-.176 2.924-.078.625-.117 1.072-.117 1.346-.352 2.729-.528 4.951-.528 6.666 0 3.532.642 6.502 1.922 8.914l28.453-9.669a34.864 34.864 0 0 1-.149-3.104c0-1.95.117-3.957.351-6.025.118-1.13.176-2.183.176-3.158 0-7.097-2.895-12.01-8.685-14.74 11.504-3.82 17.255-11.6 17.255-23.335 0-8.305-2.828-14.35-8.48-18.132-5.655-3.781-13.373-5.673-23.152-5.673h-43.723l-14.789 83.871h29.285l4.93-27.49h7.805c3.442 0 5.909.566 7.395 1.697 1.485 1.132 2.227 3.1 2.227 5.908Zm-14.09-26.729 2.934-16.669h8.218c2.464 0 4.431.157 5.897.468 1.468.312 2.602.964 3.405 1.96.801.993 1.202 2.485 1.202 4.474 0 3.666-1.096 6.21-3.286 7.633-2.191 1.424-5.536 2.134-10.035 2.134h-8.335Z",
                fill: "#fff"
            })
        ]
    });
var $3305e8433bc3fb0d$export$2e2bcd8739ae039 = $3305e8433bc3fb0d$var$SvgPaperReadingLogo;



parcelRequire("g5BLJ");
const $1a548bb2d3837e53$var$SvgLogoFirstLetter = (props)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("svg", {
        width: 148,
        height: 27,
        viewBox: "0 0 18 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("path", {
            d: "M14.886 17.201c2.466-1.244 4.11-3.459 4.11-6.73 0-4.737-3.467-7.94-8.631-7.94H0v22.676c0 .698.586 1.263 1.308 1.263h2.227c.722 0 1.308-.565 1.308-1.263v-6.78h4.2c.41 0 .803-.016 1.197-.033l3.578 7.35c.215.444.677.726 1.184.726h2.53c.97 0 1.602-.984 1.172-1.823L14.886 17.2ZM4.843 6.773h5.11c2.36 0 4.129 1.38 4.129 3.715 0 2.249-1.662 3.8-4.146 3.8H4.843V6.772Z"
        })
    });
var $1a548bb2d3837e53$export$2e2bcd8739ae039 = $1a548bb2d3837e53$var$SvgLogoFirstLetter;



const $0f9282d054fbc03e$var$getPixelSize = (strSize, type)=>{
    if (strSize === "small") {
        if (type === "paper-reading") return "25px";
        return "16px";
    } else if (strSize === "medium") return "40px";
    else return "80px";
};
const $0f9282d054fbc03e$var$logoTypes = {
    "first-letter": (0, $1a548bb2d3837e53$export$2e2bcd8739ae039),
    "full-name": (0, $fda686ea548b88eb$export$2e2bcd8739ae039),
    "full-name-pro": (0, $b3bab8e72a064a96$export$2e2bcd8739ae039),
    "full-name-ultimate": (0, $e4e7e55930cc2844$export$2e2bcd8739ae039),
    "paper-reading": (0, $3305e8433bc3fb0d$export$2e2bcd8739ae039)
};
const $0f9282d054fbc03e$export$d57579b7226369a8 = (user, plan)=>{
    if (!user) return;
    if (user.paperSyncedAt) return "paper-reading";
    if (plan.isBasicPlan) return "full-name";
    return user.flags.isTeacherFeedbackEnabled ? "full-name-ultimate" : "full-name-pro";
};
const $0f9282d054fbc03e$export$e6ff31bff12b7ff4 = ({ size: size , color: color = (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex , type: type = "first-letter"  })=>{
    const Elem = $0f9282d054fbc03e$var$logoTypes[type];
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(Elem, {
        fill: color,
        style: {
            height: $0f9282d054fbc03e$var$getPixelSize(size, type),
            width: "auto"
        },
        width: "100%",
        height: "100%",
        stroke: color,
        strokeWidth: 0,
        "data-test-tag": `logo-${type}`
    });
};






const $7eb33c08429d75e4$export$d43ffeaaec0b2a58 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "LogoButton__LogoContainer",
    componentId: "sc-gvuij9-0"
})([
    "display:flex;align-items:center;margin:0 ",
    ";img{object-fit:scale-down;}"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4]);
const $7eb33c08429d75e4$export$ce671d21b66bb548 = ({ logoType: logoType = "full-name" , disabled: disabled = false , size: size = "small"  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7eb33c08429d75e4$export$d43ffeaaec0b2a58, {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
            testTag: logoType,
            to: "/",
            disabled: disabled,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0f9282d054fbc03e$export$e6ff31bff12b7ff4), {
                size: size,
                type: logoType
            })
        })
    });








var $5819478797754c43$exports = {};


(function(global, factory) {
    factory($5819478797754c43$exports, (parcelRequire("bA65C")), (parcelRequire("g5BLJ")));
})($5819478797754c43$exports, function(exports1, lottie, React) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var lottie__default = /*#__PURE__*/ _interopDefaultLegacy(lottie);
    var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
    function _iterableToArrayLimit(arr, i) {
        var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
        if (null != _i) {
            var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
            try {
                if (_x = (_i = _i.call(arr)).next, 0 === i) {
                    if (Object(_i) !== _i) return;
                    _n = !1;
                } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
            } catch (err) {
                _d = !0, _e = err;
            } finally{
                try {
                    if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            enumerableOnly && (symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            })), keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = null != arguments[i] ? arguments[i] : {};
            i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _defineProperty(obj, key, value) {
        key = _toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }
        return target;
    }
    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};
        var target = _objectWithoutPropertiesLoose(source, excluded);
        var key, i;
        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
            for(i = 0; i < sourceSymbolKeys.length; i++){
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    var _excluded$1 = [
        "animationData",
        "loop",
        "autoplay",
        "initialSegment",
        "onComplete",
        "onLoopComplete",
        "onEnterFrame",
        "onSegmentStart",
        "onConfigReady",
        "onDataReady",
        "onDataFailed",
        "onLoadedImages",
        "onDOMLoaded",
        "onDestroy",
        "lottieRef",
        "renderer",
        "name",
        "assetsPath",
        "rendererSettings"
    ];
    var useLottie = function useLottie(props, style) {
        var animationData = props.animationData, loop = props.loop, autoplay = props.autoplay, initialSegment = props.initialSegment, onComplete = props.onComplete, onLoopComplete = props.onLoopComplete, onEnterFrame = props.onEnterFrame, onSegmentStart = props.onSegmentStart, onConfigReady = props.onConfigReady, onDataReady = props.onDataReady, onDataFailed = props.onDataFailed, onLoadedImages = props.onLoadedImages, onDOMLoaded = props.onDOMLoaded, onDestroy = props.onDestroy;
        props.lottieRef;
        props.renderer;
        props.name;
        props.assetsPath;
        props.rendererSettings;
        var rest = _objectWithoutProperties(props, _excluded$1);
        var _useState = React.useState(false), _useState2 = _slicedToArray(_useState, 2), animationLoaded = _useState2[0], setAnimationLoaded = _useState2[1];
        var animationInstanceRef = React.useRef();
        var animationContainer = React.useRef(null);
        /*
          ======================================
              INTERACTION METHODS
          ======================================
       */ /**
     * Play
     */ var play = function play() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.play();
        };
        /**
     * Stop
     */ var stop = function stop() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.stop();
        };
        /**
     * Pause
     */ var pause = function pause() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.pause();
        };
        /**
     * Set animation speed
     * @param speed
     */ var setSpeed = function setSpeed(speed) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSpeed(speed);
        };
        /**
     * Got to frame and play
     * @param value
     * @param isFrame
     */ var goToAndPlay = function goToAndPlay(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndPlay(value, isFrame);
        };
        /**
     * Got to frame and stop
     * @param value
     * @param isFrame
     */ var goToAndStop = function goToAndStop(value, isFrame) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.goToAndStop(value, isFrame);
        };
        /**
     * Set animation direction
     * @param direction
     */ var setDirection = function setDirection(direction) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setDirection(direction);
        };
        /**
     * Play animation segments
     * @param segments
     * @param forceFlag
     */ var playSegments = function playSegments(segments, forceFlag) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.playSegments(segments, forceFlag);
        };
        /**
     * Set sub frames
     * @param useSubFrames
     */ var setSubframe = function setSubframe(useSubFrames) {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.setSubframe(useSubFrames);
        };
        /**
     * Get animation duration
     * @param inFrames
     */ var getDuration = function getDuration(inFrames) {
            var _a;
            return (_a = animationInstanceRef.current) === null || _a === void 0 ? void 0 : _a.getDuration(inFrames);
        };
        /**
     * Destroy animation
     */ var destroy = function destroy() {
            var _a;
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Removing the reference to the animation so separate cleanups are skipped.
            // Without it the internal `lottie-react` instance throws exceptions as it already cleared itself on destroy.
            animationInstanceRef.current = undefined;
        };
        /*
          ======================================
              LOTTIE
          ======================================
       */ /**
     * Load a new animation, and if it's the case, destroy the previous one
     * @param {Object} forcedConfigs
     */ var loadAnimation = function loadAnimation() {
            var forcedConfigs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _a;
            // Return if the container ref is null
            if (!animationContainer.current) return;
            // Destroy any previous instance
            (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
            // Build the animation configuration
            var config = _objectSpread2(_objectSpread2(_objectSpread2({}, props), forcedConfigs), {}, {
                container: animationContainer.current
            });
            // Save the animation instance
            animationInstanceRef.current = lottie__default["default"].loadAnimation(config);
            setAnimationLoaded(!!animationInstanceRef.current);
            // Return a function that will clean up
            return function() {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.destroy();
                animationInstanceRef.current = undefined;
            };
        };
        /**
     * (Re)Initialize when animation data changed
     */ React.useEffect(function() {
            var onUnmount = loadAnimation();
            // Clean up on unmount
            return function() {
                return onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            animationData,
            loop
        ]);
        // Update the autoplay state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            animationInstanceRef.current.autoplay = !!autoplay;
        }, [
            autoplay
        ]);
        // Update the initial segment state
        React.useEffect(function() {
            if (!animationInstanceRef.current) return;
            // When null should reset to default animation length
            if (!initialSegment) {
                animationInstanceRef.current.resetSegments(true);
                return;
            }
            // If it's not a valid segment, do nothing
            if (!Array.isArray(initialSegment) || !initialSegment.length) return;
            // If the current position it's not in the new segment
            // set the current position to start
            if (animationInstanceRef.current.currentRawFrame < initialSegment[0] || animationInstanceRef.current.currentRawFrame > initialSegment[1]) animationInstanceRef.current.currentRawFrame = initialSegment[0];
            // Update the segment
            animationInstanceRef.current.setSegment(initialSegment[0], initialSegment[1]);
        }, [
            initialSegment
        ]);
        /*
          ======================================
              EVENTS
          ======================================
       */ /**
     * Reinitialize listener on change
     */ React.useEffect(function() {
            var partialListeners = [
                {
                    name: "complete",
                    handler: onComplete
                },
                {
                    name: "loopComplete",
                    handler: onLoopComplete
                },
                {
                    name: "enterFrame",
                    handler: onEnterFrame
                },
                {
                    name: "segmentStart",
                    handler: onSegmentStart
                },
                {
                    name: "config_ready",
                    handler: onConfigReady
                },
                {
                    name: "data_ready",
                    handler: onDataReady
                },
                {
                    name: "data_failed",
                    handler: onDataFailed
                },
                {
                    name: "loaded_images",
                    handler: onLoadedImages
                },
                {
                    name: "DOMLoaded",
                    handler: onDOMLoaded
                },
                {
                    name: "destroy",
                    handler: onDestroy
                }
            ];
            var listeners = partialListeners.filter(function(listener) {
                return listener.handler != null;
            });
            if (!listeners.length) return;
            var deregisterList = listeners.map(/**
       * Handle the process of adding an event listener
       * @param {Listener} listener
       * @return {Function} Function that deregister the listener
       */ function(listener) {
                var _a;
                (_a = animationInstanceRef.current) === null || _a === void 0 || _a.addEventListener(listener.name, listener.handler);
                // Return a function to deregister this listener
                return function() {
                    var _a;
                    (_a = animationInstanceRef.current) === null || _a === void 0 || _a.removeEventListener(listener.name, listener.handler);
                };
            });
            // Deregister listeners on unmount
            return function() {
                deregisterList.forEach(function(deregister) {
                    return deregister();
                });
            };
        }, [
            onComplete,
            onLoopComplete,
            onEnterFrame,
            onSegmentStart,
            onConfigReady,
            onDataReady,
            onDataFailed,
            onLoadedImages,
            onDOMLoaded,
            onDestroy
        ]);
        /**
     * Build the animation view
     */ var View = /*#__PURE__*/ React__default["default"].createElement("div", _objectSpread2({
            style: style,
            ref: animationContainer
        }, rest));
        return {
            View: View,
            play: play,
            stop: stop,
            pause: pause,
            setSpeed: setSpeed,
            goToAndStop: goToAndStop,
            goToAndPlay: goToAndPlay,
            setDirection: setDirection,
            playSegments: playSegments,
            setSubframe: setSubframe,
            getDuration: getDuration,
            destroy: destroy,
            animationContainerRef: animationContainer,
            animationLoaded: animationLoaded,
            animationItem: animationInstanceRef.current
        };
    };
    // helpers
    function getContainerVisibility(container) {
        var _container$getBoundin = container.getBoundingClientRect(), top = _container$getBoundin.top, height = _container$getBoundin.height;
        var current = window.innerHeight - top;
        var max = window.innerHeight + height;
        return current / max;
    }
    function getContainerCursorPosition(container, cursorX, cursorY) {
        var _container$getBoundin2 = container.getBoundingClientRect(), top = _container$getBoundin2.top, left = _container$getBoundin2.left, width = _container$getBoundin2.width, height = _container$getBoundin2.height;
        var x = (cursorX - left) / width;
        var y = (cursorY - top) / height;
        return {
            x: x,
            y: y
        };
    }
    var useInitInteractivity = function useInitInteractivity(_ref) {
        var wrapperRef = _ref.wrapperRef, animationItem = _ref.animationItem, mode = _ref.mode, actions = _ref.actions;
        React.useEffect(function() {
            var wrapper = wrapperRef.current;
            if (!wrapper || !animationItem || !actions.length) return;
            animationItem.stop();
            var scrollModeHandler = function scrollModeHandler() {
                var assignedSegment = null;
                var scrollHandler = function scrollHandler() {
                    var currentPercent = getContainerVisibility(wrapper);
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref2) {
                        var visibility = _ref2.visibility;
                        return visibility && currentPercent >= visibility[0] && currentPercent <= visibility[1];
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    if (action.type === "seek" && action.visibility && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var frameToGo = action.frames[0] + Math.ceil((currentPercent - action.visibility[0]) / (action.visibility[1] - action.visibility[0]) * action.frames[1]);
                        //! goToAndStop must be relative to the start of the current segment
                        animationItem.goToAndStop(frameToGo - animationItem.firstFrame - 1, true);
                    }
                    if (action.type === "loop") {
                        // Loop: Loop a given frames
                        if (assignedSegment === null) {
                            // if not playing any segments currently. play those segments and save to state
                            animationItem.playSegments(action.frames, true);
                            assignedSegment = action.frames;
                        } else {
                            // if playing any segments currently.
                            //check if segments in state are equal to the frames selected by action
                            if (assignedSegment !== action.frames) {
                                // if they are not equal. new segments are to be loaded
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            } else if (animationItem.isPaused) {
                                // if they are equal the play method must be called only if lottie is paused
                                animationItem.playSegments(action.frames, true);
                                assignedSegment = action.frames;
                            }
                        }
                    }
                    if (action.type === "play" && animationItem.isPaused) {
                        // Play: Reset segments and continue playing full animation from current position
                        animationItem.resetSegments(true);
                        animationItem.play();
                    }
                    if (action.type === "stop") // Stop: Stop playback
                    animationItem.goToAndStop(action.frames[0] - animationItem.firstFrame - 1, true);
                };
                document.addEventListener("scroll", scrollHandler);
                return function() {
                    document.removeEventListener("scroll", scrollHandler);
                };
            };
            var cursorModeHandler = function cursorModeHandler() {
                var handleCursor = function handleCursor(_x, _y) {
                    var x = _x;
                    var y = _y;
                    // Resolve cursor position if cursor is inside container
                    if (x !== -1 && y !== -1) {
                        // Get container cursor position
                        var pos = getContainerCursorPosition(wrapper, x, y);
                        // Use the resolved position
                        x = pos.x;
                        y = pos.y;
                    }
                    // Find the first action that satisfies the current position conditions
                    var action = actions.find(function(_ref3) {
                        var position = _ref3.position;
                        if (position && Array.isArray(position.x) && Array.isArray(position.y)) return x >= position.x[0] && x <= position.x[1] && y >= position.y[0] && y <= position.y[1];
                        if (position && !Number.isNaN(position.x) && !Number.isNaN(position.y)) return x === position.x && y === position.y;
                        return false;
                    });
                    // Skip if no matching action was found!
                    if (!action) return;
                    // Process action types:
                    if (action.type === "seek" && action.position && Array.isArray(action.position.x) && Array.isArray(action.position.y) && action.frames.length === 2) {
                        // Seek: Go to a frame based on player scroll position action
                        var xPercent = (x - action.position.x[0]) / (action.position.x[1] - action.position.x[0]);
                        var yPercent = (y - action.position.y[0]) / (action.position.y[1] - action.position.y[0]);
                        animationItem.playSegments(action.frames, true);
                        animationItem.goToAndStop(Math.ceil((xPercent + yPercent) / 2 * (action.frames[1] - action.frames[0])), true);
                    }
                    if (action.type === "loop") animationItem.playSegments(action.frames, true);
                    if (action.type === "play") {
                        // Play: Reset segments and continue playing full animation from current position
                        if (animationItem.isPaused) animationItem.resetSegments(false);
                        animationItem.playSegments(action.frames);
                    }
                    if (action.type === "stop") animationItem.goToAndStop(action.frames[0], true);
                };
                var mouseMoveHandler = function mouseMoveHandler(ev) {
                    handleCursor(ev.clientX, ev.clientY);
                };
                var mouseOutHandler = function mouseOutHandler() {
                    handleCursor(-1, -1);
                };
                wrapper.addEventListener("mousemove", mouseMoveHandler);
                wrapper.addEventListener("mouseout", mouseOutHandler);
                return function() {
                    wrapper.removeEventListener("mousemove", mouseMoveHandler);
                    wrapper.removeEventListener("mouseout", mouseOutHandler);
                };
            };
            switch(mode){
                case "scroll":
                    return scrollModeHandler();
                case "cursor":
                    return cursorModeHandler();
            }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            mode,
            animationItem
        ]);
    };
    var useLottieInteractivity = function useLottieInteractivity(_ref4) {
        var actions = _ref4.actions, mode = _ref4.mode, lottieObj = _ref4.lottieObj;
        var animationItem = lottieObj.animationItem, View = lottieObj.View, animationContainerRef = lottieObj.animationContainerRef;
        useInitInteractivity({
            actions: actions,
            animationItem: animationItem,
            mode: mode,
            wrapperRef: animationContainerRef
        });
        return View;
    };
    var _excluded = [
        "style",
        "interactivity"
    ];
    var Lottie = function Lottie(props) {
        var _a, _b, _c;
        var style = props.style, interactivity = props.interactivity, lottieProps = _objectWithoutProperties(props, _excluded);
        /**
     * Initialize the 'useLottie' hook
     */ var _useLottie = useLottie(lottieProps, style), View = _useLottie.View, play = _useLottie.play, stop = _useLottie.stop, pause = _useLottie.pause, setSpeed = _useLottie.setSpeed, goToAndStop = _useLottie.goToAndStop, goToAndPlay = _useLottie.goToAndPlay, setDirection = _useLottie.setDirection, playSegments = _useLottie.playSegments, setSubframe = _useLottie.setSubframe, getDuration = _useLottie.getDuration, destroy = _useLottie.destroy, animationContainerRef = _useLottie.animationContainerRef, animationLoaded = _useLottie.animationLoaded, animationItem = _useLottie.animationItem;
        /**
     * Make the hook variables/methods available through the provided 'lottieRef'
     */ React.useEffect(function() {
            if (props.lottieRef) props.lottieRef.current = {
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndPlay: goToAndPlay,
                goToAndStop: goToAndStop,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            (_a = props.lottieRef) === null || _a === void 0 ? void 0 : _a.current
        ]);
        return useLottieInteractivity({
            lottieObj: {
                View: View,
                play: play,
                stop: stop,
                pause: pause,
                setSpeed: setSpeed,
                goToAndStop: goToAndStop,
                goToAndPlay: goToAndPlay,
                setDirection: setDirection,
                playSegments: playSegments,
                setSubframe: setSubframe,
                getDuration: getDuration,
                destroy: destroy,
                animationContainerRef: animationContainerRef,
                animationLoaded: animationLoaded,
                animationItem: animationItem
            },
            actions: (_b = interactivity === null || interactivity === void 0 ? void 0 : interactivity.actions) !== null && _b !== void 0 ? _b : [],
            mode: (_c = interactivity === null || interactivity === void 0 ? void 0 : interactivity.mode) !== null && _c !== void 0 ? _c : "scroll"
        });
    };
    Object.defineProperty(exports1, "LottiePlayer", {
        enumerable: true,
        get: function() {
            return lottie__default["default"];
        }
    });
    exports1["default"] = Lottie;
    exports1.useLottie = useLottie;
    exports1.useLottieInteractivity = useLottieInteractivity;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


var $040d2726828c9e5b$exports = {};
$040d2726828c9e5b$exports = JSON.parse('{"nm":"Vague02","mn":"","layers":[{"ty":4,"nm":"Shape Layer 4","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"td":1,"ao":0,"ks":{"a":{"a":0,"k":[9.578,23.578,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[240,240,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[399.156,399.156],"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":true,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[1,1,1],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9098,0.9098,0.9137],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[9.578,23.578],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":1},{"ty":0,"nm":"vague Outlines Comp 1","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"tt":1,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[-0.046,6.667,0],"ix":1},"s":{"a":0,"k":[896,510,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[-233.75,258,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":30,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"w":480,"h":480,"refId":"comp_0","ind":2},{"ty":0,"nm":"bateau Comp 1","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[240,240,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,257,0],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,221,0],"t":15},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,257,0],"t":32},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,221,0],"t":47},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,257,0],"t":62},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,221,0],"t":77},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,257,0],"t":91},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,221,0],"t":107},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,257,0],"t":122},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,221,0],"t":137},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,257,0],"t":151},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[227,221,0],"t":167},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[227,257,0],"t":180.00000733155}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-14],"t":0},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[18.5],"t":18},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-14],"t":40},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[18.5],"t":62},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-14],"t":80},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[18.5],"t":101},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[-14],"t":127},{"o":{"x":0.333,"y":0},"i":{"x":0.667,"y":1},"s":[18.5],"t":154},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[-14],"t":180.00000733155}],"ix":10}},"ef":[],"w":480,"h":480,"refId":"comp_1","ind":3},{"ty":4,"nm":"Shape Layer 3","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"td":1,"ao":0,"ks":{"a":{"a":0,"k":[9.578,23.578,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[240,240,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[399.156,399.156],"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":true,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[1,1,1],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9098,0.9098,0.9137],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[9.578,23.578],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":4},{"ty":0,"nm":"vague Outlines Comp 1","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"tt":1,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[-0.046,6.667,0],"ix":1},"s":{"a":0,"k":[600,300,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[28.25,258,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":30,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"w":480,"h":480,"refId":"comp_0","ind":5},{"ty":4,"nm":"Shape Layer 2","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[9.578,23.578,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[240,240,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Ellipse 1","ix":1,"cix":2,"np":3,"it":[{"ty":"el","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Ellipse","nm":"Ellipse Path 1","d":1,"p":{"a":0,"k":[0,0],"ix":3},"s":{"a":0,"k":[399.156,399.156],"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":true,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[1,1,1],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9098,0.9098,0.9137],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[9.578,23.578],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":6}],"ddd":0,"h":480,"w":480,"meta":{"a":"","k":"","d":"","g":"@lottiefiles/toolkit-js 0.21.3","tc":"#000000"},"v":"5.3.4","fr":29.9700012207031,"op":180.00000733155,"ip":0,"assets":[{"nm":"","mn":"","layers":[{"ty":4,"nm":"vague Outlines","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[408,94.639,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[248,10.361,0],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[-232,10.361,0],"t":180.00000733155}],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Group 2","ix":1,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[0,0],[0,0]],"o":[[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[0,0],[0,0],[0,0]],"v":[[-240,-349.353],[-200,-349.353],[-160,-349.353],[-120,-349.353],[-80,-349.353],[-40,-349.353],[0,-349.353],[40,-349.353],[80,-349.353],[120,-349.353],[160,-349.353],[200,-349.353],[240,-349.353],[240,550.647],[-240,550.647]]},"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[0.4314,0.4353,0.9255],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4314,0.4353,0.9255],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[880,444.353],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Group 1","ix":2,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[-12.59,-6.295],[-12.59,6.295],[0,0],[0,0]],"o":[[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[12.59,-6.295],[12.59,6.295],[0,0],[0,0],[0,0]],"v":[[-240,-349.353],[-200,-349.353],[-160,-349.353],[-120,-349.353],[-80,-349.353],[-40,-349.353],[0,-349.353],[40,-349.353],[80,-349.353],[120,-349.353],[160,-349.353],[200,-349.353],[240,-349.353],[240,550.647],[-240,550.647]]},"ix":2}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.4314,0.4353,0.9255],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"st","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[0.4314,0.4353,0.9255],"ix":3}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[400,444.353],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":1}],"id":"comp_0","fr":30},{"nm":"","mn":"","layers":[{"ty":4,"nm":"Shape Layer 1","mn":"","sr":1,"st":0,"op":600.000024438501,"ip":0,"hd":false,"cl":"","ln":"","ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6},"sk":{"a":0,"k":0},"p":{"a":0,"k":[240,240,0],"ix":2},"sa":{"a":0,"k":0},"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10}},"ef":[],"shapes":[{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Shape 2","ix":1,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[13,-8],[-32.5,51.5],[81.5,53]]},"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":10,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[0,0,0],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9961,0.9255,0.7765],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Shape 1","ix":2,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-88.5,-27],[-33.5,51.5],[80.5,52.5],[127,-24],[14,-8.5]]},"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":10,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[0,0,0],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9882,0.8549,0.549],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Shape 4","ix":3,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[24.5,-68.5],[4.5,28],[15,24]]},"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":10,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[0,0,0],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9961,0.9255,0.7765],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]},{"ty":"gr","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Group","nm":"Shape 3","ix":4,"cix":2,"np":3,"it":[{"ty":"sh","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Shape - Group","nm":"Path 1","ix":1,"d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[24.5,-68.5],[-37.5,16],[74.5,17]]},"ix":2}},{"ty":"st","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Stroke","nm":"Stroke 1","lc":1,"lj":1,"ml":4,"o":{"a":0,"k":10,"ix":4},"w":{"a":0,"k":2,"ix":5},"d":[],"c":{"a":0,"k":[0,0,0],"ix":3}},{"ty":"fl","bm":0,"cl":"","ln":"","hd":false,"mn":"ADBE Vector Graphic - Fill","nm":"Fill 1","c":{"a":0,"k":[0.9882,0.8549,0.549],"ix":4},"r":1,"o":{"a":0,"k":100,"ix":5}},{"ty":"tr","a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"sk":{"a":0,"k":0,"ix":4},"p":{"a":0,"k":[0,0],"ix":2},"r":{"a":0,"k":0,"ix":6},"sa":{"a":0,"k":0,"ix":5},"o":{"a":0,"k":100,"ix":7}}]}],"ind":1}],"id":"comp_1","fr":30}]}');


const $20484a6b5f32bbb1$var$ChildStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "position:absolute;width:100%;height:100%;max-width:100px;max-height:100px;margin:8px;border:",
    "px solid;border-radius:50%;animation:ring 1.2s cubic-bezier(0.5,0,0.5,1) infinite;",
    ""
], ({ spinnerWidth: spinnerWidth  })=>spinnerWidth, ({ darkBg: darkBg  })=>`border-color: ${darkBg ? (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).readleeBlue.hex} transparent transparent transparent;`);
const $20484a6b5f32bbb1$var$SpinnerStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Loading__SpinnerStyles",
    componentId: "sc-1ut0d3r-0"
})([
    "display:flex;justify-content:center;align-items:center;position:relative;width:",
    "px;height:",
    "px;div{",
    "}div:nth-child(1){animation-delay:-0.45s;}div:nth-child(2){animation-delay:-0.3s;}div:nth-child(3){animation-delay:-0.15s;}@keyframes ring{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"
], ({ sizeNumber: sizeNumber  })=>sizeNumber, ({ sizeNumber: sizeNumber  })=>sizeNumber, $20484a6b5f32bbb1$var$ChildStyles);
const $20484a6b5f32bbb1$var$Spinner = ({ darkBg: darkBg , sizeNumber: sizeNumber , spinnerWidth: spinnerWidth  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($20484a6b5f32bbb1$var$SpinnerStyles, {
        darkBg: darkBg,
        sizeNumber: sizeNumber,
        spinnerWidth: spinnerWidth,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {})
        ]
    });
const $20484a6b5f32bbb1$var$computeSize = (size)=>{
    if (size === "x-small") return {
        sizeNumber: 10,
        spinnerWidth: 2
    };
    else if (size === "small") return {
        sizeNumber: 15,
        spinnerWidth: 2
    };
    else if (size === "medium") return {
        sizeNumber: 25,
        spinnerWidth: 4
    };
    else if (size === "large") return {
        sizeNumber: 50,
        spinnerWidth: 6
    };
    else throw new Error(`Unrecognized spinner size ${size}`);
};
const $20484a6b5f32bbb1$export$669f6ea7d267feaf = ({ darkBg: darkBg = false , size: size = "large" , flex: flex = false , flexWidth: flexWidth = "100%" , flexHeight: flexHeight = "100%" , kind: kind = "spinner"  })=>{
    const { sizeNumber: sizeNumber , spinnerWidth: spinnerWidth  } = $20484a6b5f32bbb1$var$computeSize(size);
    const component = kind === "spinner" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($20484a6b5f32bbb1$var$Spinner, {
        darkBg: darkBg,
        sizeNumber: sizeNumber,
        spinnerWidth: spinnerWidth
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5819478797754c43$exports))), {
        animationData: (0, (/*@__PURE__*/$parcel$interopDefault($040d2726828c9e5b$exports))),
        style: {
            width: `${sizeNumber * 3}px`
        }
    });
    return flex ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        justify: "center",
        align: "center",
        height: flexHeight,
        width: flexWidth,
        children: component
    }) : component;
};









const $df6c3a1bdb65fda3$var$BaseDivider = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Divider__BaseDivider",
    componentId: "sc-1km2sye-0"
})([
    "flex-shrink:0;width:",
    ";height:",
    ";margin:",
    ";margin-top:",
    ";margin-bottom:",
    ";border:",
    ";background:",
    ";",
    ""
], ({ $vertical: $vertical  })=>$vertical ? "0" : "100%", ({ $vertical: $vertical  })=>$vertical ? "100%" : "0", ({ $noMargin: $noMargin , $vertical: $vertical  })=>$noMargin ? 0 : $vertical ? `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]}` : `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none}`, ({ $endMargin: $endMargin  })=>$endMargin, ({ $endMargin: $endMargin  })=>$endMargin, ({ $size: $size , $color: $color  })=>`${$size}px solid ${$color}`, ({ $color: $color  })=>$color, ({ $vertical: $vertical  })=>{
    if (!$vertical) return;
    return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "",
        " > &{height:auto;align-self:stretch;}"
    ], (0, $31d38d276dc0d530$export$c10bb8791b00cf6c));
});
const $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb = ({ noMargin: noMargin = false , size: size = 2 , vertical: vertical = false , color: color = (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex , endMargin: endMargin = (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($df6c3a1bdb65fda3$var$BaseDivider, {
        $noMargin: noMargin,
        $size: size,
        $vertical: vertical,
        $color: color,
        $endMargin: endMargin
    });
};






const $acaad050e5cfc31b$export$7f714e6c560938e5 = ({ message: message = null , errors: errors = null , errorKey: errorKey = null  })=>{
    let text = null;
    if (typeof message === "string") text = message;
    else if (errors && errorKey) text = errors.get(errorKey)?.join(", ");
    if (!text) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        color: "danger",
        children: text
    });
};






const $e1e3f7b78974b405$export$b534bc812df080fd = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        children: children
    });
};





var $7ebbbda8d7c15b1b$exports = {};

$7ebbbda8d7c15b1b$exports = new URL((parcelRequire("3TfdU")).resolve("eFWFP"), import.meta.url).toString();


var $49d03094e08c7e41$exports = {};

$49d03094e08c7e41$exports = new URL((parcelRequire("3TfdU")).resolve("irvV0"), import.meta.url).toString();


var $54ad604ec60d45f7$exports = {};

$54ad604ec60d45f7$exports = new URL((parcelRequire("3TfdU")).resolve("iFYDw"), import.meta.url).toString();


var $3de523d5d03b3e60$exports = {};

$3de523d5d03b3e60$exports = new URL((parcelRequire("3TfdU")).resolve("cMp5P"), import.meta.url).toString();











const $b4a9b2222f765970$var$SyncWithText = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            "Sync with ",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h6",
                fontStyle: "italic",
                children: "PAPER"
            })
        ]
    });
const $b4a9b2222f765970$export$88a5d3bdaa4e4ff2 = ({ showSyncStatus: showSyncStatus = false  })=>{
    const { sync: sync , isSyncing: isSyncing , lastSyncedAt: lastSyncedAt  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PaperSyncData: psd  })=>({
            sync: psd.sync,
            isSyncing: psd.getIsSyncing(),
            lastSyncedAt: psd.getLastSyncedAt()
        }), []);
    const lastSyncedAtText = lastSyncedAt ? (0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(lastSyncedAt)) : "Never";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        width: "fit-content",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                displayType: "outline",
                paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]}`,
                onClick: ()=>sync("manual"),
                disabled: isSyncing,
                children: isSyncing ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        }),
                        "Syncing with ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h6",
                            fontStyle: "italic",
                            children: "PAPER"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "resync",
                            strokeWidth: 0,
                            size: "25px"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b4a9b2222f765970$var$SyncWithText, {})
                    ]
                })
            }),
            showSyncStatus && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: "half"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "gray7",
                            children: [
                                "Last Synced: ",
                                lastSyncedAtText
                            ]
                        })
                    })
                ]
            })
        ]
    });
};




var $g5BLJ = parcelRequire("g5BLJ");






const $f47b237290846f5f$var$BaseToast = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Toast__BaseToast",
    componentId: "sc-1nc2uin-0"
})([
    "border-radius:",
    ";padding:",
    ";background:",
    ";color:",
    ";display:flex;align-items:center;margin-bottom:",
    ";"
], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[1], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], ({ $color: $color  })=>(0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex, ({ $color: $color  })=>(0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].text, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]);
const $f47b237290846f5f$var$Close = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Toast__Close",
    componentId: "sc-1nc2uin-1"
})([
    "margin-left:",
    ";"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1]);
const $f47b237290846f5f$export$8d8dc7d5f743331b = (props)=>{
    const { children: children , color: color , closeToast: closeToast , closeAnywhere: closeAnywhere  } = props;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: closeAnywhere ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            display: "flex",
            displayType: "noStyles",
            onClick: closeToast,
            testTag: "close-toast",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f47b237290846f5f$var$BaseToast, {
                $color: color,
                children: [
                    children,
                    " ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f47b237290846f5f$var$Close, {
                        children: "✕"
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f47b237290846f5f$var$BaseToast, {
            $color: color,
            children: [
                children,
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f47b237290846f5f$var$Close, {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "noStyles",
                        onClick: closeToast,
                        testTag: "close-toast",
                        children: "✕"
                    })
                })
            ]
        })
    });
};










// Pauses when they leave the tab and resumes when they come back

const $c92741cacc117cae$var$timeoutClearMap = new Map();
const $c92741cacc117cae$export$be218d2c2696b374 = (fn, duration)=>{
    const focusedTimeoutId = (0, $dd8c6a85a004ead6$export$aa1a1894961eafab)();
    let finished = false;
    let timeSoFar = 0;
    let currentTimeoutStartedAt = new Date().valueOf();
    let currentTimeoutId = null;
    const makeTimeout = ()=>{
        currentTimeoutStartedAt = new Date().valueOf();
        currentTimeoutId = setTimeout(()=>{
            finished = true;
            document.removeEventListener("visibilitychange", handler);
            $c92741cacc117cae$var$timeoutClearMap.delete(focusedTimeoutId);
            fn();
        }, duration - timeSoFar);
    };
    const handler = ()=>{
        if (finished) return;
        else if (document.visibilityState !== "visible") {
            timeSoFar += new Date().valueOf() - currentTimeoutStartedAt;
            if (currentTimeoutId) clearTimeout(currentTimeoutId);
        } else makeTimeout();
    };
    const cancel = ()=>{
        if (currentTimeoutId) clearTimeout(currentTimeoutId);
        document.removeEventListener("visibilitychange", handler);
        $c92741cacc117cae$var$timeoutClearMap.delete(focusedTimeoutId);
    };
    makeTimeout();
    document.addEventListener("visibilitychange", handler);
    $c92741cacc117cae$var$timeoutClearMap.set(focusedTimeoutId, cancel);
    return focusedTimeoutId;
};
const $c92741cacc117cae$export$25f8d74dfbdefed8 = (focusedTimeoutId)=>{
    if (!$c92741cacc117cae$var$timeoutClearMap.has(focusedTimeoutId)) return;
    const fn = $c92741cacc117cae$var$timeoutClearMap.get(focusedTimeoutId);
    if (fn) fn();
};


const $164dcc779e79d074$var$BaseToaster = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Toaster__BaseToaster",
    componentId: "sc-5rys21-0"
})([
    "position:fixed;bottom:",
    ";left:",
    ";display:flex;flex-direction:column;align-items:flex-start;z-index:",
    ";"
], (0, $18ffa0398cff6303$export$66be51d536890fa7)[4], (0, $18ffa0398cff6303$export$66be51d536890fa7)[4], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).toast);
const $164dcc779e79d074$var$DEFAULT_TOAST_DURATION = 5000;
const { useStore: $164dcc779e79d074$var$useToasterStore  } = (0, $f11c2b6d8f5b8d56$export$2aabb3606b6d664f)((set, get)=>{
    return {
        toastMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
        createToast: ({ closeAnywhere: closeAnywhere = true , ...toast })=>{
            const id = `toast-${(0, $dd8c6a85a004ead6$export$aa1a1894961eafab)()}`;
            set((state)=>({
                    toastMap: state.toastMap.set(id, {
                        ...toast,
                        closeAnywhere: closeAnywhere,
                        id: id,
                        createdAt: new Date().valueOf()
                    })
                }));
            if (!toast.forever) (0, $c92741cacc117cae$export$be218d2c2696b374)(()=>{
                get().closeToast(id);
            }, toast.duration ?? $164dcc779e79d074$var$DEFAULT_TOAST_DURATION);
            return id;
        },
        closeToast: (id)=>{
            set((state)=>({
                    toastMap: state.toastMap.delete(id)
                }));
        }
    };
});
const $164dcc779e79d074$export$f46171b59bb094f9 = ()=>{
    const { toastMap: toastMap , createToast: createToast , closeToast: closeToast  } = $164dcc779e79d074$var$useToasterStore((state)=>state, []);
    return {
        toastMap: toastMap,
        createToast: createToast,
        closeToast: closeToast
    };
};
const $164dcc779e79d074$export$fb98e3a2a4cd92d7 = ()=>{
    const { toastMap: toastMap , closeToast: closeToast  } = $164dcc779e79d074$export$f46171b59bb094f9();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $121c3b2afc84f041$export$361769c4f906e73b), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($164dcc779e79d074$var$BaseToaster, {
            children: toastMap.toList().sortBy((t)=>t.createdAt).map((toast)=>{
                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f47b237290846f5f$export$8d8dc7d5f743331b), {
                    closeToast: ()=>closeToast(toast.id),
                    color: toast.color ?? "success",
                    closeAnywhere: toast.closeAnywhere ?? false,
                    children: toast.children
                }, toast.id);
            })
        })
    });
};







const $cd425c641c724592$var$VIDEO_TYPES = [
    "webm",
    "ogg",
    "mp4",
    "x-matroska"
];
const $cd425c641c724592$var$AUDIO_TYPES = [
    "webm",
    "ogg",
    "mp3",
    "mp4",
    "x-matroska"
];
const $cd425c641c724592$var$CODECS = [
    "vp9",
    "vp9.0",
    "vp8",
    "vp8.0",
    "avc1",
    "av1",
    "h265",
    "h.265",
    "h264",
    "h.264",
    "opus",
    "pcm",
    "aac",
    "mpeg",
    "mp4a"
];
const $cd425c641c724592$export$3a0ce4ea5a7dfe10 = (mediaType)=>{
    const contentTypes = mediaType === "video" ? $cd425c641c724592$var$VIDEO_TYPES : $cd425c641c724592$var$AUDIO_TYPES;
    return contentTypes.flatMap((contentType)=>{
        const basicMimeType = {
            mediaType: mediaType,
            contentType: contentType,
            codec: null,
            mimeType: `${mediaType}/${contentType}`
        };
        const mimeTypeDetails = [
            basicMimeType,
            ...$cd425c641c724592$var$CODECS.flatMap((codec)=>{
                const baseWithCodec = {
                    mediaType: mediaType,
                    contentType: contentType,
                    codec: codec,
                    mimeType: `${mediaType}/${contentType}`
                };
                const mimeType1 = `${mediaType}/${contentType};codecs=${codec}`;
                const mimeType2 = `${mediaType}/${contentType};codecs:${codec}`;
                const mimeType3 = `${mediaType}/${contentType};codecs=${codec.toUpperCase()}`;
                const mimeType4 = `${mediaType}/${contentType};codecs:${codec.toUpperCase()}`;
                return [
                    {
                        ...baseWithCodec,
                        mimeType: mimeType1
                    },
                    {
                        ...baseWithCodec,
                        mimeType: mimeType2
                    },
                    {
                        ...baseWithCodec,
                        mimeType: mimeType3
                    },
                    {
                        ...baseWithCodec,
                        mimeType: mimeType4
                    }
                ];
            })
        ];
        return mimeTypeDetails.filter((mt)=>MediaRecorder.isTypeSupported(mt.mimeType));
    });
};
class $cd425c641c724592$export$50b6c389561e7490 extends Error {
    constructor(message, supportedMimeTypes){
        super(message);
        this.supportedMimeTypes = supportedMimeTypes;
    }
}


let $1ce946abade47122$var$initialized = false;

const $1ce946abade47122$export$2cd8252107eb640b = async ()=>{
    const Sentry = await (parcelRequire("bKfU0"));
    if (!$1ce946abade47122$var$initialized) {
        Sentry.init({
            dsn: "https://a8ae54fa39334640b54e854b88a5d7dd@o75207.ingest.sentry.io/4504560938450944",
            environment: "development",
            ignoreErrors: [
                // Random plugins/extensions
                "top.GLOBALS",
                // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
                "originalCreateNotification",
                "canvas.contentDocument",
                "MyApp_RemoveAllHighlights",
                "http://tt.epicplay.com",
                "Can't find variable: ZiteReader",
                "jigsaw is not defined",
                "ComboSearch is not defined",
                "http://loading.retry.widdit.com/",
                "atomicFindClose",
                // Facebook borked
                "fb_xd_fragment",
                // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
                // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
                "bmi_SafeAddOnload",
                "EBCallBackMessageReceived",
                // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
                "conduitPage",
                "Object Not Found Matching Id",
                "ResizeObserver loop limit exceeded",
                "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.",
                // Avast extension error
                "_avast_submit",
                // Audio/Video Memes
                "The play() request was interrupted by",
                "play() failed because the user",
                "The fetching process for the media resource was aborted by the user agent at the user's request",
                "not allowed by the user agent or the platform in the current context, possibly because the user denied permission"
            ],
            denyUrls: [
                // Google Adsense
                /pagead\/js/i,
                // Facebook flakiness
                /graph\.facebook\.com/i,
                // Facebook blocked
                /connect\.facebook\.net\/en_US\/all\.js/i,
                // Woopra flakiness
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                // Chrome extensions
                /extensions\//i,
                /chrome-extension:\//i,
                /^chrome:\/\//i,
                // Other plugins
                /127\.0\.0\.1:4001\/isrunning/i,
                // Cacaoweb
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
                /asset\.goguardian/i
            ]
        });
        $1ce946abade47122$var$initialized = true;
    }
    return Sentry;
};
class $1ce946abade47122$export$1ee61ec16d0f6c5c extends Error {
    constructor(message, meta){
        super(message);
        this.meta = meta;
    }
}
const $1ce946abade47122$export$b33b857ad1d9900e = async (error, extras)=>{
    console.error(error);
    const Sentry = await $1ce946abade47122$export$2cd8252107eb640b();
    if (!Sentry) return;
    if (error instanceof Error) return Sentry.withScope((scope)=>{
        if (window.localStorage.getItem("mobileWebviewOpened") === "true") scope.setTag("mobileApp", "true");
        if (extras) scope.setExtras({
            ...extras
        });
        if (error instanceof (0, $cd425c641c724592$export$50b6c389561e7490)) {
            scope.setExtras({
                supportedMimeTypes: error.supportedMimeTypes
            });
            Sentry.captureException(error);
        } else if (error instanceof $1ce946abade47122$export$1ee61ec16d0f6c5c) {
            scope.setExtras({
                ...error.meta
            });
            Sentry.captureException(error);
        } else Sentry.captureException(error);
    });
    else {
        console.warn("This error is not an actual error, try to always throw actual errors when possible so you get real stack traces.");
        return Sentry.captureMessage(`${error}`);
    }
};
const $1ce946abade47122$export$8b6bb3dd62a01be2 = async (user)=>{
    const Sentry = await $1ce946abade47122$export$2cd8252107eb640b();
    Sentry?.setUser(user && {
        id: user.id,
        name: user.displayName,
        email: user.email ?? undefined,
        username: user.username
    });
};
const $1ce946abade47122$export$87f1de260de95016 = (fn)=>{
    try {
        return fn();
    } catch (error) {
        // Don't let this error kill what's currently happening, but still report it
        $1ce946abade47122$export$b33b857ad1d9900e(error);
        return null;
    }
};
const $1ce946abade47122$export$62165d89d29d615c = async (fn)=>{
    try {
        return fn();
    } catch (error) {
        // Don't let this error kill what's currently happening, but still report it
        $1ce946abade47122$export$b33b857ad1d9900e(error);
        return null;
    }
};


const $86ce6205c10768ba$export$e7f3fc3f3e5b470f = (...args)=>{
    $1ce946abade47122$export$87f1de260de95016(()=>{
        if (typeof window.gtag === "function") window.gtag(...args);
    });
};
const $86ce6205c10768ba$export$617201f1ca055ae9 = (widget, action, options)=>{
    return;
};
const $86ce6205c10768ba$export$68306590b07bdc01 = ()=>{
    $86ce6205c10768ba$export$617201f1ca055ae9("webWidget", "open");
};
const $86ce6205c10768ba$export$dd8891c5e530f23d = (fn)=>{
    return;
};
const $86ce6205c10768ba$export$6e636fdf34644712 = (fn)=>{
    const Appcues = window.Appcues;
    Appcues && typeof Appcues.identify;
};
const $86ce6205c10768ba$export$158e064e680ef045 = (eventName, options)=>{
    return;
};
let $86ce6205c10768ba$var$amplitudeInstanceCache = null;
let $86ce6205c10768ba$var$amplitudeInstanceFetched = false;
let $86ce6205c10768ba$var$amplitudeInstancePromise = null;
const $86ce6205c10768ba$export$5003c5cccf091294 = async ()=>{
    return null;
};
const $86ce6205c10768ba$export$bb45b2e06acf3cf9 = async (event, options)=>{
    const amplitude = await $86ce6205c10768ba$export$5003c5cccf091294();
    amplitude?.logEvent(event, options);
};
const $86ce6205c10768ba$export$2cd8252107eb640b = async ()=>{
    $1ce946abade47122$export$2cd8252107eb640b();
    await $86ce6205c10768ba$export$5003c5cccf091294();
};


const $0a7b3b5a37006e2b$var$BaseBanner = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PaperSyncBanner__BaseBanner",
    componentId: "sc-1p6phic-0"
})([
    "width:100%;"
]);
const $0a7b3b5a37006e2b$export$ba70b582dbd4aee9 = ()=>{
    const { currentUser: currentUser , notificationKind: notificationKind , closeBanner: closeBanner , loadClasses: loadClasses , reloadUser: reloadUser , reloadAssignModal: reloadAssignModal , sync: sync , setField: setField , getStatus: getStatus , loadStudents: loadStudents  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            notificationKind: s.PaperSyncData.notificationKind,
            closeBanner: s.PaperSyncData.closeBanner,
            sync: s.PaperSyncData.sync,
            setField: s.PaperSyncData.setField,
            getStatus: s.PaperSyncData.getStatus,
            currentUser: s.AppData.currentUser,
            reloadUser: s.AppData.load,
            loadStudents: s.TeacherStudentListData.load,
            loadClasses: s.TeacherCourseListData.load,
            reloadAssignModal: s.AssignToData.load
        }), []);
    const status = getStatus();
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const assessmentId = query.get("assessmentId") || "";
    const courseId = query.get("selectedCourseId") || "";
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const onClassesPage = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/t/classes"));
    const onStudentsPage = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/t/students"));
    const showToast = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, [
        "/t/reading-builder",
        "/t/assignment-builder",
        "/reading-studio"
    ]));
    const onAssignModal = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, [
        "/t/assignments/:id/assign",
        "/t/assignments/assign"
    ]));
    const syncCount = currentUser ? currentUser.paperRosterAutoSyncCount + currentUser.paperRosterManualSyncCount : 0;
    const onUserMessage = (0, $g5BLJ.useCallback)(({ action: action , payload: { status: status , lastSyncedAt: lastSyncedAt , kind: kind  }  })=>{
        if (action === "roster_sync") {
            setField("localStatus")(status);
            setField("localLastSyncedAt")(lastSyncedAt);
            if (status === "finished") {
                reloadUser({
                    skipStateReset: true
                });
                if (onAssignModal) {
                    reloadAssignModal({
                        assessmentId: assessmentId,
                        courseId: courseId
                    });
                    setField("notificationKind")("hidden");
                    return;
                }
                if (onClassesPage) loadClasses({
                    history: history,
                    pathname: pathname
                });
                if (onStudentsPage) loadStudents();
                if (kind !== "auto" || syncCount === 0) {
                    if (showToast) {
                        setField("notificationKind")("toast");
                        createToast({
                            children: "Your classes have synced!",
                            color: "success"
                        });
                    } else setField("notificationKind")("banner");
                }
            } else setField("notificationKind")("banner");
        }
    }, [
        setField,
        onAssignModal,
        showToast,
        onClassesPage,
        onStudentsPage,
        syncCount,
        reloadAssignModal,
        assessmentId,
        courseId,
        createToast,
        loadClasses,
        history,
        pathname,
        reloadUser,
        loadStudents
    ]);
    if (!currentUser) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $018cce6940d253d6$export$b5b6bb8bb5273115), {
                channel: "UserChannel",
                id: currentUser.id,
                onMessage: onUserMessage
            }),
            notificationKind === "banner" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($0a7b3b5a37006e2b$var$BaseBanner, {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    backgroundColor: status === "finished" ? (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).warning.hex,
                    padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                    align: "center",
                    children: [
                        status === "finished" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            grow: 1,
                            justify: "center",
                            align: "center",
                            testTag: "syncing-banner",
                            children: onClassesPage ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "largeText",
                                color: "white",
                                children: "Your classes have been synced!"
                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "largeText",
                                        color: "white",
                                        children: "Your classes have been synced! Click"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        color: "white",
                                        onClick: ()=>setField("notificationKind")("hidden"),
                                        to: "/t/classes",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "largeText",
                                            color: "white",
                                            weightOverride: "bold",
                                            children: "here"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "largeText",
                                        color: "white",
                                        children: "to see your classes"
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            grow: 1,
                            justify: "center",
                            align: "center",
                            testTag: "syncing-error-banner",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "largeText",
                                    color: "white",
                                    children: "There was an error syncing your classes. Click"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                    color: "white",
                                    onClick: ()=>sync("manual"),
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "largeText",
                                        color: "white",
                                        weightOverride: "bold",
                                        children: "here"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "largeText",
                                    color: "white",
                                    children: "to try again or"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                    color: "white",
                                    onClick: (0, $86ce6205c10768ba$export$68306590b07bdc01),
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "largeText",
                                        color: "white",
                                        weightOverride: "bold",
                                        children: "contact support"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "end",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                displayType: "iconOnly",
                                icon: "close",
                                iconColor: "white",
                                iconSize: "1em",
                                width: "32px",
                                height: "32px",
                                color: status === "finished" ? "primaryBlue" : "warning",
                                testTag: "close-syncing-banner",
                                onClick: closeBanner
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $59a194a8bf3cf685$export$94f6678e4fa81f5c), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        testTag: "simulate-failed-sync",
                        onClick: ()=>onUserMessage({
                                action: "roster_sync",
                                payload: {
                                    status: "errored",
                                    lastSyncedAt: null,
                                    kind: "manual"
                                }
                            }),
                        children: "Simulate Failed Sync"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        testTag: "simulate-successful-sync",
                        onClick: ()=>onUserMessage({
                                action: "roster_sync",
                                payload: {
                                    status: "finished",
                                    lastSyncedAt: null,
                                    kind: "manual"
                                }
                            }),
                        children: "Simulate Successful Sync"
                    })
                ]
            })
        ]
    });
};









const $3ce8826ee790ff14$export$9096f1709a33668c = ({ displayType: displayType  })=>{
    const { createFreeRead: createFreeRead , freeReadLoading: freeReadLoading  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            currentUser: s.AppData.currentUser,
            createFreeRead: s.AssignmentBuilderData.createFreeRead,
            freeReadLoading: s.AssignmentBuilderData.freeReadLoading
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        color: "primaryBlue",
        displayType: displayType,
        loading: freeReadLoading,
        onClick: ()=>createFreeRead(history),
        height: "40px",
        children: "Free Read"
    });
};






var $g5BLJ = parcelRequire("g5BLJ");





const $6234d1c039c99c3b$export$55a3ade3f7a671f4 = ({ openedPath: openedPath , closedPath: closedPath  })=>{
    const { courseName: courseName , errors: errors , submit: submit , setField: setField , load: load , loadCourses: loadCourses , isCoTeachersEnabled: isCoTeachersEnabled = false  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            courseName: s.CreateCourseData.courseName,
            errors: s.CreateCourseData.errors,
            submit: s.CreateCourseData.submit,
            setField: s.CreateCourseData.setField,
            load: s.CreateCourseData.load,
            loadCourses: s.TeacherCourseListData.load,
            isCoTeachersEnabled: s.AppData.currentUser?.flags?.isCoTeachersEnabled
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const closeModal = (0, $g5BLJ.useCallback)(()=>{
        setField("courseName")("");
        setField("errors")((0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)());
        history.replace(closedPath);
    }, [
        history,
        closedPath,
        setField
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "path",
        header: "Create Class",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "end",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: closeModal,
                    inheritBgColor: true,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Close"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    type: "submit",
                    onClick: ()=>submit((course)=>{
                            loadCourses({
                                history: history,
                                pathname: pathname
                            });
                            history.push(`/t/classes/create?editIds=${course.id}`);
                        }),
                    children: "Create Class"
                })
            ]
        }),
        openedPath: openedPath,
        close: closeModal,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "We recommend importing your classes for easy student sign-in."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c8a864413785e08a$export$dc1434c1a71d39bc), {
                scopeKey: "import_class",
                successUrl: "/t/classes/google_import",
                children: "Import from Google Classroom"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6b95aaca78d83e60$export$800b563f63fbe24a), {
                successUrl: "/t/classes/clever_import",
                children: "Import from Clever"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $305adc5b3dd45e98$export$405b1ba3701f58c6), {
                children: "OR"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h4",
                children: "Manually create a class"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "name",
                label: "Class Name",
                errors: errors,
                value: courseName,
                onChange: setField("courseName")
            }),
            !isCoTeachersEnabled && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: [
                                    "Upgrade to ",
                                    (0, $4ded3b2c5af96cca$export$52756c3ad45aa25c),
                                    " to sync co-teachers!"
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                href: "https://www.readlee.com/pricing",
                                newTab: true,
                                children: "View Plans and Pricing"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





const $cf6c99bc3c73c975$export$eb50220e1d599d2e = ({ openedPath: openedPath , closedPath: closedPath , displayType: displayType  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                to: openedPath,
                displayType: displayType,
                children: "Create Class"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6234d1c039c99c3b$export$55a3ade3f7a671f4), {
                openedPath: openedPath,
                closedPath: closedPath
            })
        ]
    });
};






const $52ff035cf18eb297$var$KINDS = {
    independentReading: {
        primaryText: "Independent Reading",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            textAlign: "center",
            display: "inline",
            children: "Let students choose what they want to read. They will record themselves reading. You will get the recording, transcript, words per minute, and more."
        }),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports))),
        helpHref: null
    },
    assignments: {
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    children: "Create an assignment to get fluency data and transcripts when your students read, saving you valuable class time."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    display: "inline",
                    children: 'Click the "New Assignment" button in the top right corner to get started.'
                })
            ]
        }),
        helpHref: "https://readleesupport.zendesk.com/hc/en-us/articles/14120276613773",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports))),
        width: "400px"
    },
    assignmentsPaper: {
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    children: "Create an assignment to get fluency data and transcripts when your students read, saving you valuable class time."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "primaryBlue",
                    to: "/t/reading-builder/content",
                    height: "40px",
                    testTag: "new-assignments-empty-state",
                    children: "New Assignment"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    children: 'You can also click the "New Assignment" button in the top right corner at any time to create a new assignment.'
                })
            ]
        }),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports))),
        width: "400px"
    },
    archivedAssignments: {
        primaryText: "No Archived Assignments",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            textAlign: "center",
            display: "inline",
            children: "There are no archived assignments in this course"
        }),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports))),
        helpHref: ""
    },
    assignedStudents: {
        primaryText: "No Students Assigned",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            textAlign: "center",
            display: "inline",
            children: "Assign students to this assignment to see student progress here"
        }),
        helpHref: "https://readleesupport.zendesk.com/hc/en-us/articles/14120276613773",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($49d03094e08c7e41$exports)))
    },
    classes: {
        primaryText: "No Classes",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    display: "inline",
                    children: "Import your class from Google Classroom or Clever to start monitoring student reading progress."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    display: "inline",
                    children: "You can also create a class manually, then ask your students to join via a class link or class code."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    display: "inline",
                    children: "Click on the ‘Create Class’ button in the top right corner to start."
                })
            ]
        }),
        helpHref: "https://readleesupport.zendesk.com/hc/en-us/articles/14120321804301",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($49d03094e08c7e41$exports)))
    },
    assignToClasses: {
        primaryText: "No Classes",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    display: "inline",
                    children: "Import your class from Google Classroom or Clever to start monitoring student reading progress."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    display: "inline",
                    children: "You can also create a class manually, then ask your students to join via a class link or class code."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $cf6c99bc3c73c975$export$eb50220e1d599d2e), {
                    displayType: "button",
                    openedPath: "/t/classes/new",
                    closedPath: "/t/classes"
                })
            ]
        }),
        helpHref: "",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($54ad604ec60d45f7$exports)))
    },
    progressMonitoringPaper: {
        primaryText: "Create and assign a reading assignment to your students to start seeing their reading progress!",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "primaryBlue",
                    to: "/t/reading-builder/content",
                    height: "40px",
                    testTag: "pm-new-assignment",
                    children: "New Assignment"
                })
            ]
        }),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($49d03094e08c7e41$exports)))
    },
    classesPaper: {
        primaryText: "Looks like you don't have any classes yet",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray6",
                    children: "Sync your classes and assign your first reading."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 5
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b4a9b2222f765970$export$88a5d3bdaa4e4ff2), {})
            ]
        }),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($54ad604ec60d45f7$exports))),
        illustrationHeight: "150px",
        width: "550px"
    },
    noClassesPaper: {
        primaryText: "Looks like we weren't able to find any classes",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray6",
                    children: [
                        "Sync successful, but no classes were found. If you were expecting to see any classes please",
                        " ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            display: "inline",
                            flexDisplay: "inline-flex",
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                            onClick: (0, $86ce6205c10768ba$export$68306590b07bdc01),
                            children: "contact support"
                        }),
                        " "
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 5
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b4a9b2222f765970$export$88a5d3bdaa4e4ff2), {})
            ]
        }),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($54ad604ec60d45f7$exports))),
        illustrationHeight: "150px",
        width: "550px"
    },
    classesPaperSyncing: {
        primaryText: "We're importing your students and classes. Please wait for this finish before asking your students to visit.",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray6",
                    children: "We will notify you once we're done. Feel free to explore the rest of Paper Reading while you wait!"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 5
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b4a9b2222f765970$export$88a5d3bdaa4e4ff2), {})
            ]
        }),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($3de523d5d03b3e60$exports))),
        illustrationHeight: "110px",
        width: "500px"
    },
    progressMonitoring: {
        primaryText: "Want to see the reading progress of your students? Get started in 3 quick steps:",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("ol", {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    textAlign: "left",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                                        children: "Create a reading assignment for your students"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "iconOnly",
                                    icon: "forwardArrow",
                                    color: "backgroundLight",
                                    iconColor: "primaryBlue",
                                    height: "100%",
                                    to: "/t/reading-builder/content"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    textAlign: "left",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                                        children: "Create your class or import it from Google Classroom or Clever"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "iconOnly",
                                    icon: "forwardArrow",
                                    color: "backgroundLight",
                                    iconColor: "primaryBlue",
                                    height: "100%",
                                    to: "/t/classes/new"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    textAlign: "left",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                                        children: "Assign the assignment to students from your class"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "iconOnly",
                                    icon: "forwardArrow",
                                    color: "backgroundLight",
                                    iconColor: "primaryBlue",
                                    height: "100%",
                                    to: "/t/assignments"
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        helpHref: "",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($49d03094e08c7e41$exports)))
    },
    students: {
        primaryText: "No Students",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    display: "inline",
                    children: "There are currently no students assigned to this class."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    display: "inline",
                    children: 'Use the "Add New Student" button to manually add students to this class, or use the class filter above to view the students in another class.'
                })
            ]
        }),
        helpHref: "https://readleesupport.zendesk.com/hc/en-us/articles/14127882029453",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($49d03094e08c7e41$exports)))
    },
    emptyAssignedDashboard: {
        helpHref: "",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports))),
        primaryText: "You're all caught up!",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h5",
                    children: 'Click "Free Read" to start reading!'
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "center",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3ce8826ee790ff14$export$9096f1709a33668c), {
                        displayType: "button"
                    })
                })
            ]
        })
    },
    emptySubmittedDashboard: {
        primaryText: "No Submissions",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            textAlign: "center",
            display: "inline",
            children: "Submitted assignments will display here once you have turned them in."
        }),
        helpHref: "",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($49d03094e08c7e41$exports)))
    },
    emptyStudentProgress: {
        primaryText: "No Submissions to display",
        secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            textAlign: "center",
            display: "inline",
            children: "Try adjusting the Class and Date Range Filter to view more data."
        }),
        helpHref: "",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports)))
    },
    emptyComments: {
        primaryText: "Leave your student motivational feedback to encourage their reading habits!",
        secondaryText: "",
        helpHref: "",
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports)))
    }
};
const $52ff035cf18eb297$export$fddf379e22a74b00 = ({ kind: kind , ...props })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0a5d8e8de2fe8d78$export$40d7a77ab2e3394), {
        testTag: `empty-state-${kind}`,
        ...$52ff035cf18eb297$var$KINDS[kind],
        ...props
    });





const $0a5d8e8de2fe8d78$var$emptyStatePadding = (displayType)=>{
    switch(displayType){
        case "minimal":
            return (0, $8259eb090983b778$export$ea413736286a3bf1).none;
        case "compact":
            return (0, $8259eb090983b778$export$ea413736286a3bf1)[2];
        default:
            return (0, $8259eb090983b778$export$ea413736286a3bf1)[10];
    }
};
const $0a5d8e8de2fe8d78$export$40d7a77ab2e3394 = ({ primaryText: primaryText , secondaryText: secondaryText , helpHref: helpHref , illustration: illustration , illustrationHeight: illustrationHeight , testTag: testTag , displayType: displayType = "normal" , width: width  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        maxWidth: width ? width : "350px",
        width: width,
        padding: $0a5d8e8de2fe8d78$var$emptyStatePadding(displayType),
        testTag: testTag,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                style: {
                    maxHeight: displayType === "minimal" ? "200px" : "300px",
                    height: illustrationHeight
                },
                src: illustration
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: displayType === "minimal" ? 2 : 8
            }),
            primaryText && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                textAlign: "center",
                variant: "h4",
                children: primaryText
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
                style: {
                    textAlign: "center"
                },
                children: [
                    secondaryText,
                    helpHref && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                display: "inline",
                                children: " ("
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                newTab: true,
                                href: helpHref,
                                display: "inline",
                                flexDisplay: "inherit",
                                children: "learn more"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                display: "inline",
                                children: ")"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





parcelRequire("g5BLJ");

const $4ae13af7ccf5d135$export$caec2af78bcc877f = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        children: children
    });
};







const $2a5e7b0563ceb985$export$cd95088e3160fae9 = ({ loading: loading , children: children  })=>{
    return loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: children
    });
};





parcelRequire("g5BLJ");


const $1f943c9568288b22$export$b05581f4e764e162 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).tr.withConfig({
    displayName: "Table__TableRow",
    componentId: "sc-5ak72r-0"
})([
    "",
    " &:nth-child(even){background:",
    ";border-radius:",
    ";}padding:",
    ";"
], ({ clickable: clickable  })=>clickable ? `
        cursor: pointer;
        &:hover {
          background: ${(0, $24b764039c44d1ec$export$8f45430ccf837300).white.active};
        }
        &:nth-child(even) {
          &:hover {
            background ${(0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.active}
          }
        }
      ` : "", (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], (0, $8259eb090983b778$export$ea413736286a3bf1)[2]);
const $1f943c9568288b22$export$76ccd210b9029917 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).tbody.withConfig({
    displayName: "Table__TableBody",
    componentId: "sc-5ak72r-1"
})([
    ""
]);
const $1f943c9568288b22$export$2f4a7be4f0dcc2 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).thead.withConfig({
    displayName: "Table__TableHead",
    componentId: "sc-5ak72r-2"
})([
    "border-bottom:1px solid ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex);
const $1f943c9568288b22$export$4e51856b23757e08 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).th.withConfig({
    displayName: "Table__TableHeaderEntry",
    componentId: "sc-5ak72r-3"
})([
    "text-align:",
    ";padding:",
    ";color:",
    ";vertical-align:bottom;"
], (props)=>props.$textAlign || "left", (0, $8259eb090983b778$export$ea413736286a3bf1)[1], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray7.hex);
const $1f943c9568288b22$export$60938ba9f9a17048 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).td.withConfig({
    displayName: "Table__TableEntry",
    componentId: "sc-5ak72r-4"
})([
    "text-align:",
    ";padding:",
    " ",
    ";&:first-child{border-top-left-radius:",
    ";border-bottom-left-radius:",
    ";}&:last-child{border-top-right-radius:",
    ";border-bottom-right-radius:",
    ";}"
], (props)=>props.$textAlign || "left", (0, $8259eb090983b778$export$ea413736286a3bf1)[3], (0, $8259eb090983b778$export$ea413736286a3bf1)[1], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4]);
const $1f943c9568288b22$export$2a511c47e1cb5779 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Table__EmptyStateContainer",
    componentId: "sc-5ak72r-5"
})([
    "display:flex;align-items:center;justify-content:center;width:100%;background:",
    ";border-bottom-left-radius:",
    ";border-bottom-right-radius:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3]);
const $1f943c9568288b22$var$BaseTable = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).table.withConfig({
    displayName: "Table__BaseTable",
    componentId: "sc-5ak72r-6"
})([
    "width:100%;border-collapse:collapse;background:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex);
const $1f943c9568288b22$var$TableCard = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Table__TableCard",
    componentId: "sc-5ak72r-7"
})([
    "background:",
    ";padding:",
    ";width:100%;height:fit-content;",
    ""
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $noPadding: $noPadding  })=>$noPadding ? (0, $8259eb090983b778$export$ea413736286a3bf1).none : (0, $8259eb090983b778$export$ea413736286a3bf1)[4], ({ $showEmptyState: $showEmptyState  })=>$showEmptyState ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "border-top-left-radius:",
        ";border-top-right-radius:",
        ";"
    ], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3]) : `border-radius: ${(0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3]};`);
const $1f943c9568288b22$export$54ec01a60f47d33d = ({ children: children , noPadding: noPadding = false , showEmptyState: showEmptyState = false  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($1f943c9568288b22$var$TableCard, {
        $noPadding: noPadding,
        $showEmptyState: showEmptyState,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($1f943c9568288b22$var$BaseTable, {
            children: children
        })
    });
};




var $g5BLJ = parcelRequire("g5BLJ");



const $9d88166725471d61$var$getNewSortSettings = (sortSettings, column)=>{
    if (sortSettings.columnId !== column.id || !sortSettings.sortDirection) return {
        columnId: column.id,
        sortDirection: column.defaultSortDirection ?? "asc"
    };
    return {
        columnId: column.id,
        sortDirection: sortSettings.sortDirection === "asc" ? "desc" : "asc"
    };
};
const $9d88166725471d61$var$sortRows = (rows, sortSettings, columns)=>{
    if (!(sortSettings.columnId && sortSettings.sortDirection)) return rows;
    const sortColumn = columns.find((column)=>column.sortType !== "none" && column.id === sortSettings.columnId);
    if (!sortColumn || sortColumn.sortType === "none") throw new Error(`Attempting to sort on bad column ${sortSettings.columnId}`);
    let sorted = rows;
    if (sortColumn.sortType === "sortBy") sorted = rows.sortBy(sortColumn.sortBy);
    else if (sortColumn.sortType === "sort") sorted = rows.sort(sortColumn.sort);
    if (sortSettings.sortDirection === "asc") return sorted;
    else return sorted.reverse();
};
const $9d88166725471d61$var$getRows = (rows, columns, getRowId, rowClickable, onRowClick)=>rows.map((row)=>{
        const clickable = typeof rowClickable === "boolean" ? rowClickable : rowClickable?.(row) ?? false;
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1f943c9568288b22$export$b05581f4e764e162), {
            clickable: clickable,
            onClick: ()=>clickable && onRowClick?.(row),
            children: columns.map((column, index)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1f943c9568288b22$export$60938ba9f9a17048), {
                    children: column.render(row, index)
                }, `${getRowId(row)}-${column.id}`))
        }, getRowId(row));
    });
const $9d88166725471d61$export$19e77af6aa9459e3 = ({ columns: columns , rows: rows , getRowId: getRowId , onRowClick: onRowClick , rowClickable: rowClickable , initialSortSettings: initialSortSettings , queryParam: queryParam , noPadding: noPadding , emptyStateContent: emptyStateContent , fixedTopRows: fixedTopRows = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()  })=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const directionQueryParam = `${queryParam}Direction`;
    const getSortSettings = ()=>{
        const param = query.get(queryParam);
        const direction = query.get(directionQueryParam);
        if (param) return {
            columnId: param,
            sortDirection: direction ?? "asc"
        };
        else if (initialSortSettings) return initialSortSettings;
        return {
            columnId: null,
            sortDirection: null
        };
    };
    const [sortSettings, setSortSettingsState] = (0, $g5BLJ.useState)(getSortSettings());
    const setSortSettings = (0, $g5BLJ.useCallback)((sortSettings)=>()=>{
            setSortSettingsState(sortSettings);
            history.replace(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                [queryParam]: sortSettings.columnId,
                [directionQueryParam]: sortSettings.sortDirection
            })}`);
        }, [
        history,
        pathname,
        query,
        queryParam,
        directionQueryParam
    ]);
    const sortedRows = (0, $g5BLJ.useMemo)(()=>$9d88166725471d61$var$sortRows(rows, sortSettings, columns), [
        rows,
        sortSettings,
        columns
    ]);
    const sortedFixedRows = (0, $g5BLJ.useMemo)(()=>$9d88166725471d61$var$sortRows(fixedTopRows, sortSettings, columns), [
        fixedTopRows,
        sortSettings,
        columns
    ]);
    const showEmptyState = Boolean(emptyStateContent) && sortedRows.isEmpty() && sortedFixedRows.isEmpty();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $1f943c9568288b22$export$54ec01a60f47d33d), {
                noPadding: noPadding,
                showEmptyState: showEmptyState,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1f943c9568288b22$export$2f4a7be4f0dcc2), {
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1f943c9568288b22$export$b05581f4e764e162), {
                            children: columns.map((column)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1f943c9568288b22$export$4e51856b23757e08), {
                                    $textAlign: column.textAlign,
                                    children: column.sortType !== "none" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                        disabled: !column.tooltipContent,
                                        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            color: "black",
                                            children: column.tooltipContent
                                        }),
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                            displayType: "noStyles",
                                            onClick: setSortSettings($9d88166725471d61$var$getNewSortSettings(sortSettings, column)),
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                align: "center",
                                                justify: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                        variant: "h6",
                                                        color: "gray7",
                                                        children: column.name
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        horizontal: true
                                                    }),
                                                    sortSettings.columnId === column.id && sortSettings.sortDirection && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2910b332f5f2547f$export$6c0766c1b5806024), {
                                                        direction: sortSettings.sortDirection
                                                    })
                                                ]
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h6",
                                        color: "gray7",
                                        children: column.name
                                    })
                                }, column.id))
                        })
                    }),
                    !showEmptyState && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $1f943c9568288b22$export$76ccd210b9029917), {
                        children: [
                            $9d88166725471d61$var$getRows(sortedFixedRows, columns, getRowId, rowClickable, onRowClick),
                            $9d88166725471d61$var$getRows(sortedRows, columns, getRowId, rowClickable, onRowClick)
                        ]
                    })
                ]
            }),
            showEmptyState && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1f943c9568288b22$export$2a511c47e1cb5779), {
                children: emptyStateContent
            })
        ]
    });
};








const $2910b332f5f2547f$var$BaseSortArrow = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SortArrow__BaseSortArrow",
    componentId: "sc-1envcpy-0"
})([
    "margin-left:",
    ";display:flex;"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1]);
const $2910b332f5f2547f$export$6c0766c1b5806024 = ({ direction: direction  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2910b332f5f2547f$var$BaseSortArrow, {
        children: direction === "asc" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
            icon: "sortUp",
            size: "1em",
            color: "white",
            fill: true,
            fillColor: "primaryBlue"
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
            icon: "sortDown",
            size: "1em",
            color: "white",
            fill: true,
            fillColor: "primaryBlue"
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


const $55832b297ed0598b$var$fallbackCopyTextToClipboard = (text)=>{
    const textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    let success = false;
    try {
        success = document.execCommand("copy");
    } catch (err) {
        (0, $1ce946abade47122$export$b33b857ad1d9900e)(err);
        success = false;
    }
    document.body.removeChild(textArea);
    return success;
};
const $55832b297ed0598b$export$f980440e1ab4537d = async (text)=>{
    if (!navigator.clipboard) return $55832b297ed0598b$var$fallbackCopyTextToClipboard(text);
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (err) {
        return $55832b297ed0598b$var$fallbackCopyTextToClipboard(text);
    }
};




const $362ac0aa9af5ef61$var$COPYABLE_TIMEOUT = 3000;
const $362ac0aa9af5ef61$var$LinkBox = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Copyable__LinkBox",
    componentId: "sc-x13ohg-0"
})([
    "background:",
    ";border:1px solid ",
    ";border-right:none;border-radius:",
    ";padding:",
    ";display:flex;align-items:center;height:100%;overflow:hidden;width:100%;> *{white-space:nowrap !important;}"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[3]);
const $362ac0aa9af5ef61$var$CopyStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Copyable__CopyStyles",
    componentId: "sc-x13ohg-1"
})([
    "display:",
    ";"
], ({ displayType: displayType  })=>displayType);
const $362ac0aa9af5ef61$export$e5ff2bc79de811b1 = ({ copyContent: copyContent , children: children , copyIconSize: copyIconSize = "1.5em" , copyDisplayType: copyDisplayType = "block" , copyText: copyText = "Copy Link" , kind: kind , onSuccess: onSuccess , ...buttonProps })=>{
    const { createToast: createToast , closeToast: closeToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const [disabled, setDisabled] = (0, $g5BLJ.useState)(false);
    const [copied, setCopied] = (0, $g5BLJ.useState)(false);
    const cb = (0, $g5BLJ.useCallback)(async ()=>{
        setDisabled(true);
        const copyingId = createToast({
            children: "Copying...",
            color: "success",
            duration: $362ac0aa9af5ef61$var$COPYABLE_TIMEOUT,
            closeAnywhere: true
        });
        const success = await (0, $55832b297ed0598b$export$f980440e1ab4537d)(copyContent);
        closeToast(copyingId);
        if (success) {
            onSuccess?.();
            createToast({
                children: "Text copied!",
                color: "success",
                duration: $362ac0aa9af5ef61$var$COPYABLE_TIMEOUT
            });
            setCopied(true);
            setTimeout(()=>{
                setDisabled(false);
                setCopied(false);
            }, $362ac0aa9af5ef61$var$COPYABLE_TIMEOUT);
        } else {
            createToast({
                children: "Text failed to copy.",
                color: "danger",
                duration: $362ac0aa9af5ef61$var$COPYABLE_TIMEOUT
            });
            setDisabled(false);
        }
    }, [
        copyContent,
        createToast,
        closeToast,
        onSuccess
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($362ac0aa9af5ef61$var$CopyStyles, {
        displayType: copyDisplayType,
        onClick: (e)=>e.stopPropagation(),
        children: [
            [
                "scrollable",
                "buttonOnly"
            ].includes(kind) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    kind === "scrollable" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($362ac0aa9af5ef61$var$LinkBox, {
                                children: children
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2,
                                horizontal: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: copied ? "outline" : "button",
                        height: "40px",
                        icon: "copy",
                        width: buttonProps.width || "150px",
                        onClick: cb,
                        disabled: copied,
                        testTag: "copyable-button",
                        children: copied ? "Copied!" : copyText
                    })
                ]
            }),
            kind === "link" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                testTag: "copyable-button",
                icon: disabled ? "check" : "copy",
                iconSize: copyIconSize,
                onClick: cb,
                disabled: disabled,
                paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                iconShrink: 0,
                ...buttonProps,
                children: children
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


const $121c3b2afc84f041$var$getBodyPortalRoot = ()=>{
    const existing = document.getElementById("portal-root");
    if (existing) return existing;
    const portalRoot = document.createElement("div");
    portalRoot.id = "portal-root";
    document.body.appendChild(portalRoot);
    return portalRoot;
};
const $121c3b2afc84f041$export$361769c4f906e73b = ({ children: children  })=>{
    const parentElementId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    const [parentElement, setParentElement] = (0, $g5BLJ.useState)(null);
    (0, $g5BLJ.useEffect)(()=>{
        if (!parentElement) {
            const portalRoot = $121c3b2afc84f041$var$getBodyPortalRoot();
            const newParentElement = document.createElement("div");
            newParentElement.id = `portal-${parentElementId}`;
            portalRoot.appendChild(newParentElement);
            setParentElement(newParentElement);
        }
        return ()=>{
            if (parentElement) parentElement.remove();
        };
    }, [
        parentElementId,
        parentElement,
        setParentElement
    ]);
    if (!parentElement) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($060c403ad4a78f54$exports))).createPortal(children, parentElement);
};






var $g5BLJ = parcelRequire("g5BLJ");




const $6e3aa8aeb4209bd7$var$CONTEXT_OFFSET = 50;
const $6e3aa8aeb4209bd7$var$skeumorphicStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "background:",
    ";color:",
    ";border-bottom:none;border-radius:",
    " ",
    " 0 0;padding:",
    " ",
    ";max-width:14em;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-align:center;"
], ({ $active: $active  })=>$active ? (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).gray4.hex, ({ $active: $active  })=>$active ? (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]);
const $6e3aa8aeb4209bd7$var$TabName = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TabView__TabName",
    componentId: "sc-13c66bn-0"
})([
    "font-weight:",
    ";margin-right:",
    ";display:inline-block;color:",
    ";border-bottom:",
    ";",
    ""
], ({ $active: $active  })=>$active ? (0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861).bold : (0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861).default, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (props)=>props.$active ? (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).gray7.hex, ({ $active: $active  })=>$active ? `${(0, $18ffa0398cff6303$export$66be51d536890fa7).half} solid ${(0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex}` : "none", ({ $skeumorphic: $skeumorphic  })=>$skeumorphic ? $6e3aa8aeb4209bd7$var$skeumorphicStyles : null);
const $6e3aa8aeb4209bd7$var$shouldScroll = (current, target, tabsLength)=>target - current > 0 ? target >= 2 : target <= tabsLength - 2;
const $6e3aa8aeb4209bd7$var$useActiveTab = ({ queryParam: queryParam , tabs: tabs  })=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const currentTabId = query.get(queryParam);
    const activeTab = currentTabId ? tabs.find((t)=>t.id === currentTabId) : tabs.first();
    return activeTab;
};
const $6e3aa8aeb4209bd7$export$e8ac093818ac58be = ({ tabs: tabs , queryParam: queryParam  })=>{
    const activeTab = $6e3aa8aeb4209bd7$var$useActiveTab({
        queryParam: queryParam,
        tabs: tabs
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: tabs.filter((tab)=>tab.content && tab.id === activeTab?.id).map((tab)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
                children: tab.content
            }, tab.id))
    });
};
const $6e3aa8aeb4209bd7$export$44c45b2b7f09d2a6 = (props)=>{
    const { tabs: tabs , queryParam: queryParam , skeumorphic: skeumorphic = false , noContent: noContent = false  } = props;
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const containerRef = (0, $g5BLJ.useRef)(null);
    const activeTab = $6e3aa8aeb4209bd7$var$useActiveTab({
        queryParam: queryParam,
        tabs: tabs
    });
    const currentIndex = tabs.findIndex((t)=>t.id === activeTab?.id);
    const previousTab = currentIndex > 0 ? tabs.get(currentIndex - 1) : null;
    const nextTab = currentIndex < tabs.size - 1 ? tabs.get(currentIndex + 1) : null;
    const moveTab = (targetId)=>()=>{
            const container = containerRef.current;
            const targetIndex = tabs.findIndex((t)=>t.id === targetId);
            if (targetIndex === -1) return;
            const tab = tabs.get(targetIndex);
            if (!tab) return;
            if (container && $6e3aa8aeb4209bd7$var$shouldScroll(currentIndex, targetIndex, tabs.size)) {
                const child = container.children[targetIndex];
                if (child instanceof HTMLElement) container.scrollTo({
                    left: child.offsetLeft - $6e3aa8aeb4209bd7$var$CONTEXT_OFFSET,
                    behavior: "smooth"
                });
            }
            if (tab.to) history.push(tab.to);
            else history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                [queryParam]: tab.id
            })}`);
        };
    const showMobileLayout = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "mobileLarge"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            !showMobileLayout ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                position: "relative",
                align: "end",
                backgroundColor: skeumorphic ? (0, $24b764039c44d1ec$export$8f45430ccf837300)["backgroundDark"].hex : "inherit",
                width: "100%",
                minWidth: 0,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        margin: `0 ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0 0`,
                        grow: 1,
                        innerRef: containerRef,
                        overflowX: "hidden",
                        minWidth: 0,
                        children: tabs.map((tab)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                children: [
                                    !skeumorphic && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        displayType: "noStyles",
                                        onClick: moveTab(tab.id),
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($6e3aa8aeb4209bd7$var$TabName, {
                                            $active: tab.id === activeTab?.id,
                                            $skeumorphic: skeumorphic,
                                            title: tab.name,
                                            children: [
                                                tab.name,
                                                typeof tab.count === "number" ? ` (${tab.count})` : ""
                                            ]
                                        })
                                    })
                                ]
                            }, tab.id))
                    }),
                    skeumorphic && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        margin: "6px 6px 6px auto",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                icon: "arrowLeft",
                                iconStrokeWidth: 2,
                                displayType: "iconOnly",
                                color: "gray4",
                                onClick: previousTab ? moveTab(previousTab.id) : undefined,
                                disabled: !previousTab || previousTab.onlyClick,
                                id: "tabBack",
                                testTag: "back-tab-button",
                                height: "28px",
                                width: "28px"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                icon: "arrowRight",
                                displayType: "iconOnly",
                                color: "gray4",
                                onClick: nextTab ? moveTab(nextTab.id) : undefined,
                                disabled: !nextTab || nextTab.onlyClick,
                                id: "tabForward",
                                testTag: "forward-tab-button",
                                height: "28px",
                                width: "28px",
                                iconStrokeWidth: 2
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "end",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                            name: "class",
                            value: activeTab?.id,
                            options: tabs.map((tab)=>({
                                    label: tab.name,
                                    value: tab.id
                                })),
                            onChange: (tabId)=>{
                                const tab = tabs.find((t)=>t.id === tabId);
                                if (!tab) return;
                                if (tab.to) history.push(tab.to);
                                else history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                                    [queryParam]: tab.id
                                })}`);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            noContent ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6e3aa8aeb4209bd7$export$e8ac093818ac58be, {
                ...props
            })
        ]
    });
};







const $790c5f81004ab1af$var$NavigationTabWrapper = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "NavigationTabView__NavigationTabWrapper",
    componentId: "sc-haz8uw-0"
})([
    "border-bottom:",
    ";width:100%;cursor:",
    ";margin:0 8px;"
], ({ $active: $active , $disabled: $disabled  })=>$active && !$disabled ? `${(0, $18ffa0398cff6303$export$66be51d536890fa7).half} solid ${(0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex}` : "none", ({ $disabled: $disabled  })=>$disabled ? "none" : "pointer");
const $790c5f81004ab1af$var$RightAlign = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "NavigationTabView__RightAlign",
    componentId: "sc-haz8uw-1"
})([
    "position:absolute;right:10px;"
]);
const $790c5f81004ab1af$var$useActiveTab = ({ queryParam: queryParam , tabs: tabs  })=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const currentTabId = query.get(queryParam);
    const activeTab = currentTabId ? tabs.find((t)=>t.id === currentTabId) : tabs.first();
    return activeTab;
};
const $790c5f81004ab1af$export$883e4287fbbf0055 = (props)=>{
    const { tabs: tabs , queryParam: queryParam , noContent: noContent = false  } = props;
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const activeTab = $790c5f81004ab1af$var$useActiveTab({
        queryParam: queryParam,
        tabs: tabs
    });
    const moveTab = (targetId)=>()=>{
            const tab = tabs.filter((t)=>t.id === targetId).first();
            if (!tab) return;
            if (tab.to) {
                history.push(tab.to);
                return;
            }
            history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                [queryParam]: tab.id
            })}`);
        };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                children: tabs.map((tab)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($790c5f81004ab1af$var$NavigationTabWrapper, {
                        $disabled: tab.disabled,
                        $active: tab.id === activeTab?.id,
                        onClick: tab.disabled ? undefined : moveTab(tab.id),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            position: "relative",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    grow: 1,
                                    justify: "center",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        displayType: "noStyles",
                                        disabled: tab.disabled,
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            align: "center",
                                            justify: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: tab.icon,
                                                    color: tab.disabled ? "gray7" : tab.id === activeTab?.id ? "primaryBlue" : "black",
                                                    size: "24px"
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    horizontal: true
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                    color: tab.disabled ? "gray7" : "black",
                                                    weightOverride: tab.disabled ? "default" : "bold",
                                                    children: tab.name
                                                })
                                            ]
                                        })
                                    })
                                }),
                                tab.rightComponent && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "center",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($790c5f81004ab1af$var$RightAlign, {
                                        children: tab.rightComponent
                                    })
                                })
                            ]
                        })
                    }, tab.id))
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            noContent || activeTab?.disabled || !activeTab?.content ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
                children: activeTab.content
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");







const $f9d4fe70f15fa820$var$MenuItemContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "DropdownMenu__MenuItemContainer",
    componentId: "sc-11n94uu-0"
})([
    "position:absolute;z-index:",
    ";display:flex;flex-direction:column;min-width:100%;border-radius:",
    ";background:",
    ";box-shadow:",
    ";overflow:auto;",
    ";",
    " ",
    ";"
], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).dropdown, ({ $mobile: $mobile  })=>$mobile ? `${(0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4]} ${(0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4]} 0 0` : (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $d65f64e8cabd56af$export$147720d44c0eeb27).standard, ({ $direction: $direction  })=>$direction === "down" ? "top: 100%" : "bottom: 100%", ({ $mobile: $mobile  })=>(0, $18ffa0398cff6303$export$cb290e6c0fd3cb2e)("bottom", "0px", $mobile), ({ $rightAligned: $rightAligned  })=>$rightAligned ? "right: 0" : "left: 0");
const $f9d4fe70f15fa820$var$MenuItem = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "DropdownMenu__MenuItem",
    componentId: "sc-11n94uu-1"
})([
    "width:100%;white-space:nowrap;padding:",
    " ",
    ";",
    " ",
    ":first-child &,",
    ":first-child &{padding-top:",
    ";border-radius:",
    " ",
    " 0 0;}",
    ":last-child &,",
    ":last-child &{padding-bottom:",
    ";border-radius:0 0 ",
    " ",
    ";}"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], ({ $disabled: $disabled , $color: $color  })=>$disabled ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "cursor:default;color:",
        ";"
    ], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "&:hover{background:",
        ";}",
        ";"
    ], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $18ffa0398cff6303$export$67799b413b1b10d7)("color", (0, $24b764039c44d1ec$export$8f45430ccf837300)[$color || "black"].hex)), (0, $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b), (0, $a31343b90c9d3d88$export$44ec04c6081e3a25), (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $3aa7eeb60079978b$export$2d5d2ba3c7c8c40b), (0, $a31343b90c9d3d88$export$44ec04c6081e3a25), (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2]);
const $f9d4fe70f15fa820$var$BaseDropdownMenu = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "DropdownMenu__BaseDropdownMenu",
    componentId: "sc-11n94uu-2"
})([
    "position:",
    ";display:inline-flex;align-items:center;"
], ({ $mobile: $mobile  })=>$mobile ? "inherit" : "relative");
const $f9d4fe70f15fa820$export$e44a253a59704894 = ({ options: options , children: children , color: color , rightAligned: rightAligned = false , noButtonPadding: noButtonPadding = false , direction: direction = "down" , displayType: displayType , icon: icon , iconSize: iconSize , iconColor: iconColor , iconPosition: iconPosition , width: width , height: height , testTag: testTag , inheritBgColor: inheritBgColor = false , mobile: mobile = false , disabled: disabled = false  })=>{
    const dropdownMenuId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    const buttonId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    const [opened, setOpened] = (0, $g5BLJ.useState)(false);
    const toggle = (0, $g5BLJ.useCallback)(()=>{
        setOpened(!opened);
    }, [
        opened
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!opened) return;
        const listener = (event)=>{
            const elem = event.target;
            // Check to see if they clicked on the button to open this dropdown.
            if ((0, $7ffd711af926678d$export$20b9b571b379d631)(elem, (e)=>e.id === buttonId)) return;
            // Check to see if they clicked on a disabled element within the dropdown
            if ((0, $7ffd711af926678d$export$20b9b571b379d631)(elem, (e)=>e.id === dropdownMenuId) && (0, $7ffd711af926678d$export$20b9b571b379d631)(elem, (e)=>e.hasAttribute("disabled"))) return;
            setOpened(false);
        };
        document.addEventListener("click", listener);
        return ()=>{
            document.removeEventListener("click", listener);
        };
    }, [
        buttonId,
        dropdownMenuId,
        opened,
        toggle
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f9d4fe70f15fa820$var$BaseDropdownMenu, {
        id: dropdownMenuId,
        onClick: (e)=>{
            e.stopPropagation();
        },
        $mobile: mobile,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                color: color,
                paddingOverride: noButtonPadding ? (0, $8259eb090983b778$export$ea413736286a3bf1).none : "",
                display: "flex",
                id: buttonId,
                onClick: toggle,
                displayType: displayType,
                width: width,
                height: height,
                icon: icon,
                iconSize: iconSize,
                iconColor: iconColor,
                iconPosition: iconPosition,
                testTag: testTag,
                inheritBgColor: inheritBgColor,
                disabled: disabled,
                children: children
            }),
            opened && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f9d4fe70f15fa820$var$MenuItemContainer, {
                $rightAligned: rightAligned,
                $direction: direction,
                $mobile: mobile,
                children: options.map((option, i)=>{
                    const { children: children , tooltipProps: tooltipProps , color: color , onClick: onClick , ...buttonProps } = option;
                    const content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f9d4fe70f15fa820$var$MenuItem, {
                        $disabled: buttonProps.disabled,
                        $color: color,
                        children: children
                    });
                    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "noStyles",
                        display: "block",
                        onClick: (event)=>{
                            setOpened(false);
                            if (onClick) onClick(event);
                        },
                        disabledOpacityOverride: "1",
                        ...buttonProps,
                        children: tooltipProps ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                            display: "block",
                            ...tooltipProps,
                            children: content
                        }) : content
                    }, i);
                })
            })
        ]
    });
};





parcelRequire("g5BLJ");



const $305adc5b3dd45e98$var$Container = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "WordDivider__Container",
    componentId: "sc-1dry99y-0"
})([
    "display:flex;align-items:center;min-height:40px;"
]);
const $305adc5b3dd45e98$var$HalfDivider = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "WordDivider__HalfDivider",
    componentId: "sc-1dry99y-1"
})([
    "width:100%;border-width:1px;border-style:solid;border-color:",
    ";"
], ({ color: color  })=>(0, $24b764039c44d1ec$export$8f45430ccf837300)[color].hex);
const $305adc5b3dd45e98$export$405b1ba3701f58c6 = ({ children: children , color: color = "primaryBlue"  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($305adc5b3dd45e98$var$Container, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($305adc5b3dd45e98$var$HalfDivider, {
                color: color
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                color: color,
                variant: "h6",
                children: children
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($305adc5b3dd45e98$var$HalfDivider, {
                color: color
            })
        ]
    });








const $93bf34ff9853e7af$var$MaxSize = 48;
const $93bf34ff9853e7af$var$MinSize = 12;
const $93bf34ff9853e7af$export$1b73483dd77e9d80 = ({ id: propId , value: value , onChange: onChange  })=>{
    const id = (0, $dd8c6a85a004ead6$export$c485849f2e393253)(propId);
    const decreaseFont = ()=>{
        onChange(value - 1);
    };
    const increaseFont = ()=>{
        onChange(value + 1);
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
        id: id,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                height: "75px",
                align: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    sizeOverride: value,
                    lineHeightOverride: "100%",
                    children: "Example Text Size"
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        display: "flex",
                        justify: "center",
                        align: "center",
                        width: "40px",
                        height: "40px",
                        onClick: decreaseFont,
                        disabled: value <= $93bf34ff9853e7af$var$MinSize,
                        displayType: "outline",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "primaryBlue",
                            variant: "h1",
                            children: "-"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4,
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        display: "flex",
                        justify: "center",
                        align: "center",
                        width: "40px",
                        height: "40px",
                        onClick: increaseFont,
                        disabled: value >= $93bf34ff9853e7af$var$MaxSize,
                        displayType: "outline",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "primaryBlue",
                            variant: "h1",
                            children: "+"
                        })
                    })
                ]
            })
        ]
    });
};








const $55f67455b2bdf913$var$ToggleContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Toggle__ToggleContainer",
    componentId: "sc-3xbdrh-0"
})([
    "box-sizing:border-box;width:40px;height:22px;padding:2px;border-radius:11px;background-color:",
    ";opacity:",
    ";cursor:pointer;transition:background-color 0.5s;"
], ({ $value: $value  })=>$value ? (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).gray7.hex, ({ $disabled: $disabled  })=>$disabled ? (0, $18ffa0398cff6303$export$c8e071c719aa4251) : "1");
const $55f67455b2bdf913$var$ToggleSwitch = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Toggle__ToggleSwitch",
    componentId: "sc-3xbdrh-1"
})([
    "width:18px;height:18px;border-radius:100%;background-color:",
    ";margin-left:",
    "%;transition:margin-left 0.25s;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $value: $value  })=>$value ? "50" : "0");
const $55f67455b2bdf913$export$bea8ebba691c5813 = ({ id: id , name: name , value: value , disabled: disabled = false , onChange: onChange  })=>{
    const onClick = ()=>{
        if (!disabled) onChange(!value);
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        id: id,
        displayType: "noStyles",
        name: name,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($55f67455b2bdf913$var$ToggleContainer, {
            $value: value,
            $disabled: disabled,
            "data-test-tag": "toggle-container",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($55f67455b2bdf913$var$ToggleSwitch, {
                $value: value,
                $disabled: disabled
            })
        })
    });
};





const $a1ba98bbc2222182$export$95aa4184327d6b72 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).span.withConfig({
    displayName: "Bold",
    componentId: "sc-1o69jz3-0"
})([
    "font-weight:bold;"
]);







var $g5BLJ = parcelRequire("g5BLJ");



var $ffcba89735501708$exports = {};

$ffcba89735501708$exports = new URL((parcelRequire("3TfdU")).resolve("llCLW"), import.meta.url).toString();


const $b6a7894f2ced43d4$var$sizes = {
    extraLarge: {
        height: 260,
        font: "22px",
        lineHeight: "30px"
    },
    large: {
        height: 175,
        font: "14px",
        lineHeight: "20px"
    },
    medium: {
        height: 115,
        font: "10px",
        lineHeight: "12px"
    },
    small: {
        height: 75,
        font: "7px",
        lineHeight: "8px"
    }
};
const $b6a7894f2ced43d4$var$PlaceholderBackground = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Thumbnail__PlaceholderBackground",
    componentId: "sc-1isbc2e-0"
})([
    "height:",
    "px;aspect-ratio:4/5;background-image:url('",
    "');background-repeat:no-repeat;background-size:contain;background-position:center;border-radius:",
    ";"
], ({ $size: $size  })=>$b6a7894f2ced43d4$var$sizes[$size].height, (0, (/*@__PURE__*/$parcel$interopDefault($ffcba89735501708$exports))), (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2]);
const $b6a7894f2ced43d4$var$PlaceholderText = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).p.withConfig({
    displayName: "Thumbnail__PlaceholderText",
    componentId: "sc-1isbc2e-1"
})([
    "display:-webkit-box;position:absolute;color:white;width:",
    "px;font-size:",
    ";overflow:hidden;text-align:center;padding:",
    "px ",
    " ",
    " ",
    ";word-break:break-word;-webkit-line-clamp:2;-webkit-box-orient:vertical;line-height:",
    ";user-select:none;"
], ({ $size: $size  })=>$b6a7894f2ced43d4$var$sizes[$size].height * 4 / 5, ({ $size: $size  })=>$b6a7894f2ced43d4$var$sizes[$size].font, ({ $size: $size  })=>$b6a7894f2ced43d4$var$sizes[$size].height / 8, (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1).none, (0, $8259eb090983b778$export$ea413736286a3bf1)[2], ({ $size: $size  })=>$b6a7894f2ced43d4$var$sizes[$size].lineHeight);
const $b6a7894f2ced43d4$var$PlaceholderContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Thumbnail__PlaceholderContainer",
    componentId: "sc-1isbc2e-2"
})([
    "position:relative;display:flex;"
]);
const $b6a7894f2ced43d4$var$UnmemoedCoverImagePlaceholder = ({ size: size , title: title  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($b6a7894f2ced43d4$var$PlaceholderContainer, {
        "data-test-tag": "thumbnail-cover-image",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b6a7894f2ced43d4$var$PlaceholderBackground, {
                $size: size
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b6a7894f2ced43d4$var$PlaceholderText, {
                $size: size,
                children: title || "Unknown Book Title"
            })
        ]
    });
const $b6a7894f2ced43d4$var$CoverImagePlaceholder = /*#__PURE__*/ (0, $g5BLJ.memo)($b6a7894f2ced43d4$var$UnmemoedCoverImagePlaceholder);
const $b6a7894f2ced43d4$var$BaseImage = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).img.withConfig({
    displayName: "Thumbnail__BaseImage",
    componentId: "sc-1isbc2e-3"
})([
    "border-radius:",
    ";box-shadow:",
    ";background-color:",
    ";aspect-ratio:4/5;object-fit:cover;height:",
    "px;min-width:",
    "px;"
], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $d65f64e8cabd56af$export$147720d44c0eeb27).standard, (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, ({ $size: $size  })=>$b6a7894f2ced43d4$var$sizes[$size].height, ({ $size: $size  })=>$b6a7894f2ced43d4$var$sizes[$size].height * 4 / 5);
const $b6a7894f2ced43d4$export$1cd1efc78cb52ca5 = ({ src: src , testTag: testTag , to: to , size: size = "small" , title: title , onMouseOver: onMouseOver , onMouseOut: onMouseOut  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
        to: to,
        disabled: !to,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        disabledOpacityOverride: "1",
        children: src ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b6a7894f2ced43d4$var$BaseImage, {
            src: src,
            "data-test-tag": testTag,
            $size: size
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b6a7894f2ced43d4$var$CoverImagePlaceholder, {
            size: size,
            title: title
        })
    });
};
const $b6a7894f2ced43d4$export$2e6fda2350c5bcdc = ({ src: src , testTag: testTag , title: title , size: size = "small"  })=>{
    if (src) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b6a7894f2ced43d4$var$BaseImage, {
        src: src,
        "data-test-tag": testTag,
        $size: size
    });
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b6a7894f2ced43d4$var$CoverImagePlaceholder, {
        size: size,
        title: title
    });
};






var $g5BLJ = parcelRequire("g5BLJ");

const $75cd274e63beb59b$export$f4c189d701d05230 = [
    "admin"
];
const $75cd274e63beb59b$export$6daa78a239ae789b = $75cd274e63beb59b$export$f4c189d701d05230.concat([
    "moderator"
]);
const $75cd274e63beb59b$export$c9d7c668277c2067 = $75cd274e63beb59b$export$6daa78a239ae789b.concat([
    "teacher"
]);
const $75cd274e63beb59b$export$74d9cec7d2c95116 = 16;
const $75cd274e63beb59b$export$55afbd7775430ed = (kind)=>{
    switch(kind){
        case "eyes":
            return "avatarEyes";
        case "hat":
            return "avatarHat";
        case "mouth":
            return "avatarMouth";
        case "skin":
            return "avatarSkin";
    }
};
const $75cd274e63beb59b$export$a6bcaa27097f2a04 = {
    id: "",
    paperId: null,
    paperDistrictId: null,
    username: "",
    name: "",
    avatarColor: null,
    displayName: "",
    givenName: null,
    familyName: null,
    email: "",
    accountType: "student",
    emailConfirmationStatus: "needed",
    completionPercentageEnabled: true,
    accuracyEnabled: true,
    wordsPerMinuteEnabled: true,
    textSize: $75cd274e63beb59b$export$74d9cec7d2c95116,
    lastActiveAt: new Date().toString(),
    isSso: false,
    hasGoogleSso: false,
    hasCleverSso: false,
    status: "active",
    googleSyncedAt: null,
    cleverSyncedAt: null,
    createdAt: new Date().toString(),
    updatedAt: new Date().toString(),
    onboardingStatus: "needed",
    trialMonthsAvailable: 0,
    positions: "",
    teachesEll: "unanswered",
    teachesSpecialEducation: "unanswered",
    ellPercentage: null,
    avatarSkin: "blue",
    avatarMouth: "smile",
    avatarEyes: "regular",
    avatarHat: "nothing",
    currentStreak: 0,
    currentStreakStatus: "none",
    currentStreakEndsOn: null,
    ultimateAssessmentsAvailable: 0,
    pointBalance: 0,
    paperSyncedAt: null,
    paperRosterSyncStatus: "not_needed",
    paperRosterSyncedAt: null,
    paperRosterAutoSyncCount: 0,
    paperRosterManualSyncCount: 0
};
const $75cd274e63beb59b$export$be7c6faf5b1d35b2 = {
    ...$75cd274e63beb59b$export$a6bcaa27097f2a04,
    profileImageFile: null,
    flags: {
        isCoTeachersEnabled: false,
        isAdvancedAnalyticsEnabled: false,
        isFullTranscriptionEnabled: false,
        isPrioritizedSupportEnabled: false,
        isExtendedDateFilteringEnabled: false,
        isDataVisualizationEnabled: false,
        isAllDateFilteringEnabled: false,
        isReadleeLibraryContentEnabled: false,
        isCsvExportEnabled: false,
        isVocabularyEnabled: false,
        isComprehensionTranscriptEnabled: false,
        isTeacherFeedbackEnabled: false,
        isStudentLibraryEnabled: false,
        isStudentHomepageLibraryEnabled: false
    },
    paperGradeLevel: null
};
const $75cd274e63beb59b$export$ff24787c53446ab3 = {
    ...$75cd274e63beb59b$export$a6bcaa27097f2a04,
    firstName: "",
    lastName: "",
    newPassword: "",
    passwordConfirmation: "",
    emailConfirmationStatus: "needed",
    lastActiveAt: new Date().toString()
};
const $75cd274e63beb59b$export$78c97a006b62508f = (student)=>{
    if (student.hasGoogleSso) return "Google";
    if (student.hasCleverSso) return "Clever";
    return "-";
};
const $75cd274e63beb59b$export$61b6a526e2f145be = (student)=>{
    if (student.familyName && student.givenName) return `${student.familyName}, ${student.givenName}`;
    else if (student.familyName) return student.familyName;
    else if (student.givenName) return student.givenName;
    else if (student.displayName) return student.displayName;
    else return "--";
};
const $75cd274e63beb59b$export$523342e99617f4a9 = (accountType)=>{
    return $75cd274e63beb59b$export$f4c189d701d05230.includes(accountType);
};
const $75cd274e63beb59b$export$a71c09bab744fd37 = (accountType)=>{
    return $75cd274e63beb59b$export$6daa78a239ae789b.includes(accountType);
};
const $75cd274e63beb59b$export$21d5f40a3f7d2451 = (accountType)=>{
    return $75cd274e63beb59b$export$c9d7c668277c2067.includes(accountType);
};





const $9858807ed795496b$export$2a5014b41ca47a55 = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    "user",
    "shared",
    "library",
    "community",
    "school",
    "district"
]);
const $9858807ed795496b$export$903a24f29188015 = (ownershipType, isBasicPlan, isPaperUser)=>{
    switch(ownershipType){
        case "user":
            return "My Content";
        case "library":
            return isPaperUser ? "Paper Library" : `Readlee Library ${isBasicPlan ? " (Ultimate)" : ""}`;
        case "shared":
            return "Shared with Me";
        case "community":
            return isPaperUser ? "Paper Community" : `Readlee Community${isBasicPlan ? " (Free)" : ""}`;
        case "school":
            return "School Library";
        case "district":
            return "District Library";
        default:
            throw new Error(`unknown ownership type: ${ownershipType}`);
    }
};
const $9858807ed795496b$var$SHARING_LICENSE_TYPES = [
    "open_source",
    "open_source_needs_review",
    "district",
    "school"
];
const $9858807ed795496b$export$e6ae6bdeba4fc9e3 = (licenseType)=>$9858807ed795496b$var$SHARING_LICENSE_TYPES.includes(licenseType ?? "");
const $9858807ed795496b$var$SHARABLE_LICENSE_TYPES = [
    "open_source",
    "open_source_needs_review",
    "private_user_content",
    "district",
    "school"
];
const $9858807ed795496b$export$d59e58cf0ab884d5 = (licenseType)=>$9858807ed795496b$var$SHARABLE_LICENSE_TYPES.includes(licenseType ?? "");








const { origin: $0fe4eaef81db718a$var$origin , pathname: $0fe4eaef81db718a$var$pathname  } = window.location;
const $0fe4eaef81db718a$export$3bf57e33594fa3fe = "/reading";
const $0fe4eaef81db718a$export$2cba2d9d62933240 = Boolean($0fe4eaef81db718a$var$pathname.match(new RegExp(`^${$0fe4eaef81db718a$export$3bf57e33594fa3fe}($|/)`)));
const $0fe4eaef81db718a$export$625c2ae8ba020e36 = $0fe4eaef81db718a$export$2cba2d9d62933240 ? `${$0fe4eaef81db718a$var$origin}${$0fe4eaef81db718a$export$3bf57e33594fa3fe}` : $0fe4eaef81db718a$var$origin;
const $0fe4eaef81db718a$export$a96b260801e6da33 = `${$0fe4eaef81db718a$var$origin}/login/student`;


const $d157168146708baf$export$ad3f3afa9ef03a5f = (courseCode)=>`${0, $0fe4eaef81db718a$export$625c2ae8ba020e36}/j/?courseCode=${encodeURIComponent(courseCode)}`;
const $d157168146708baf$export$94b15cf31beab72d = ({ courseCode: courseCode , onSuccess: onSuccess , fetchJson: fetchJson  })=>fetchJson(`/api/course_codes/${encodeURIComponent(courseCode)}`, {
        onSuccess: (data)=>{
            onSuccess?.(data);
        }
    });
const $d157168146708baf$export$a46f8bc61117165 = ({ course: course , onSuccess: onSuccess , fetchJson: fetchJson , editingInModal: editingInModal , newSubjectIds: newSubjectIds = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)() , oldSubjectIds: oldSubjectIds = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()  })=>fetchJson(`/api/courses/${course.id}`, {
        method: "PATCH",
        data: {
            course: {
                ...course,
                editingInModal: editingInModal
            },
            newSubjectIds: newSubjectIds,
            oldSubjectIds: oldSubjectIds
        },
        onSuccess: onSuccess
    });
const $d157168146708baf$export$1d221c892c3cb676 = (kind, query, courseIds)=>{
    const status = query.get("status") || "";
    return `/t/classes/${kind}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
        status: status,
        editIds: courseIds.join(",")
    }).filter(Boolean))}`;
};
const $d157168146708baf$export$75f5706b792e2254 = (query, courseId)=>`/t/classes/roster${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
        editIds: courseId
    })}`;
const $d157168146708baf$var$courseFilterOptions = (courses, teachersMap, currentUser)=>{
    const [myCourses, othersCourses] = (0, $d5a1fd3dea1a0ab6$export$b29f828819edca8d)(courses, (course)=>course.creatorId === currentUser?.id);
    const mine = myCourses.map((c)=>({
            ...c,
            value: c.id,
            label: c.name,
            name: c.name
        }));
    const others = othersCourses.map((c)=>{
        const ogLastName = teachersMap.get(c.creatorId, {
            displayName: ""
        }).displayName.split(" ").pop();
        const displayName = `${ogLastName ? `${ogLastName} - ` : ""}${c.name}`;
        return {
            ...c,
            value: c.id,
            label: displayName,
            name: displayName
        };
    });
    const allDisplayName = `All Classes (${mine.size + others.size})`;
    const allEntry = {
        id: "all",
        value: "all",
        name: allDisplayName,
        label: allDisplayName
    };
    const mineDisplayName = `My Classes (${mine.size})`;
    const mineEntry = {
        id: "mine",
        value: "mine",
        name: mineDisplayName,
        label: mineDisplayName
    };
    return (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
        allEntry,
        mineEntry
    ]).concat(mine.sortBy((c)=>c.name)).concat(others.sortBy((c)=>c.name));
};
const $d157168146708baf$export$5fd64473d0c0b9a5 = (courses, teachersMap, currentUser)=>$d157168146708baf$var$courseFilterOptions(courses, teachersMap, currentUser);
const $d157168146708baf$export$7c91aea2d259c517 = (courses, teachersMap, currentUser)=>{
    const courseTabs = $d157168146708baf$var$courseFilterOptions(courses, teachersMap, currentUser);
    const isPaperUser = Boolean(currentUser?.paperSyncedAt);
    return isPaperUser ? courseTabs : courseTabs.push({
        id: "add-new",
        name: "Add Class +",
        to: "/t/classes/new",
        onlyClick: true
    });
};














const $3e76d4bc3268f884$var$STAT_COUNT_UP_DURATION = 1.5;
const $3e76d4bc3268f884$export$b646428dfc4f79b1 = {
    unique_words: {
        id: "unique_words",
        icon: "star",
        label: "Unique Words",
        format: "number",
        iconSize: "1.75em",
        mobileIconSize: "1.25em",
        tooltip: "This tracks each new word you say! Most fluent, adult readers know about 40,000 different words!"
    },
    total_words: {
        id: "total_words",
        icon: "typedText",
        label: "Total Words",
        format: "number",
        iconSize: "2.25em",
        mobileIconSize: "1.75em",
        tooltip: "This counts all the words you read! How many can you read?"
    },
    completion: {
        id: "completion",
        icon: "eye",
        label: "% Read",
        format: "percentage",
        iconSize: "2em",
        mobileIconSize: "1.5em"
    },
    wcpm: {
        id: "wcpm",
        icon: "speedometer",
        label: "Speed (WCPM)",
        format: "number",
        iconSize: "2em",
        mobileIconSize: "1.5em",
        tooltip: "This keeps track of how many words you say correctly a minute."
    },
    wpm: {
        id: "wpm",
        icon: "speedometer",
        label: "Speed (WPM)",
        format: "number",
        iconSize: "2em",
        mobileIconSize: "1.5em",
        tooltip: "This keeps track of how many words you say per minute."
    },
    time_read: {
        id: "time_read",
        icon: "hourglass",
        label: "Minutes Read",
        format: "time_spent",
        iconSize: "1.6em",
        mobileIconSize: "1.1em",
        tooltip: "Did you know if you read for 15 minutes a day or more you’ll become a stronger reader?"
    },
    time_taken: {
        id: "time_taken",
        icon: "hourglass",
        label: "Avg. Time",
        format: "average_time",
        iconSize: "2em",
        mobileIconSize: "1.5em"
    }
};
const $3e76d4bc3268f884$export$f5dd818bff069720 = (value)=>value.toLocaleString("en-US");
const $3e76d4bc3268f884$var$formatTimeSpentFull = (milliseconds)=>{
    const seconds = Math.round(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    return `${$3e76d4bc3268f884$export$f5dd818bff069720(minutes)}m ${seconds % 60}s`;
};
const $3e76d4bc3268f884$export$96f8125d9e02bc94 = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)($3e76d4bc3268f884$export$b646428dfc4f79b1);
const $3e76d4bc3268f884$export$252ba770fa56b422 = (stat, value)=>{
    if (stat.format === "number") return `${$3e76d4bc3268f884$export$f5dd818bff069720((0, $f15bed412edb7f78$export$7978a6ddf29f4374)(value, 0))}`;
    else if (stat.format === "percentage") return `${(0, $f15bed412edb7f78$export$7978a6ddf29f4374)(value * 100, 0)}%`;
    else if (stat.format === "time_spent") return `${$3e76d4bc3268f884$export$f5dd818bff069720(Math.ceil((0, $73b0620564a5efc3$export$b7f1bc3ea3ac4145)(value)))}`;
    else if (stat.format === "average_time") return $3e76d4bc3268f884$var$formatTimeSpentFull(value);
    else throw new Error(`Unknown stat format '${value}'`);
};
const $3e76d4bc3268f884$export$9814c0e4001b161d = (milliseconds)=>{
    const seconds = Math.round(milliseconds / 1000);
    return seconds % 60;
};
const $3e76d4bc3268f884$export$30c35cbf580cab77 = (milliseconds)=>{
    const seconds = Math.round(milliseconds / 1000);
    const minutes = Math.floor(seconds / 60);
    return minutes;
};
const $3e76d4bc3268f884$export$4de72258f75d3400 = (stat, value)=>{
    if (stat.format === "number") return (0, $f15bed412edb7f78$export$7978a6ddf29f4374)(value, 0);
    else if (stat.format === "percentage") return (0, $f15bed412edb7f78$export$7978a6ddf29f4374)(value * 100, 0);
    else if (stat.format === "time_spent") return Math.ceil((0, $73b0620564a5efc3$export$b7f1bc3ea3ac4145)(value));
    else throw new Error(`Unknown stat format '${value}'`);
};
const $3e76d4bc3268f884$export$6c23520b987bb01d = (stat)=>{
    if (stat.format === "number" || stat.format === "time_spent") return "";
    else if (stat.format === "percentage") return "%";
    else throw new Error(`Unknown stat format '${stat.format}'`);
};
const $3e76d4bc3268f884$export$a5654a21fe306c9a = ({ stat: stat , value: value  })=>{
    return stat.format === "average_time" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9ce31e4f950f6dfa$export$1567cc001e3d0c1d), {
                value: $3e76d4bc3268f884$export$30c35cbf580cab77(value),
                duration: $3e76d4bc3268f884$var$STAT_COUNT_UP_DURATION
            }),
            "m",
            " ",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9ce31e4f950f6dfa$export$1567cc001e3d0c1d), {
                value: $3e76d4bc3268f884$export$9814c0e4001b161d(value),
                duration: $3e76d4bc3268f884$var$STAT_COUNT_UP_DURATION
            }),
            "s"
        ]
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9ce31e4f950f6dfa$export$1567cc001e3d0c1d), {
                value: $3e76d4bc3268f884$export$4de72258f75d3400(stat, value),
                duration: $3e76d4bc3268f884$var$STAT_COUNT_UP_DURATION
            }),
            $3e76d4bc3268f884$export$6c23520b987bb01d(stat)
        ]
    });
};
const $3e76d4bc3268f884$export$b2ef177cbdfa8dca = (stats)=>stats.filter((s)=>s.name !== "wpm");




const $62e5f0fd429b4502$export$f96fbc986381319f = "/t/public-preview";
const $62e5f0fd429b4502$export$62ef7d89649eaf64 = (assessment, taskSubmissionDetailsMap)=>assessment?.taskOrder?.every((to)=>{
        const taskSubmissionDetails = taskSubmissionDetailsMap.get(to.taskId);
        if (!taskSubmissionDetails) return true;
        return (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails);
    });
const $62e5f0fd429b4502$export$171369378300601 = ({ assessment: assessment , totalWords: totalWords , submissions: submissions , userIds: userIds , averageRating: averageRating  })=>{
    const finishedSubmissions = submissions.filter((s)=>s.status === "finished" && userIds.includes(s.userId));
    const avgWpcm = Math.ceil(finishedSubmissions.map((s)=>s.wcpm).reduce((a, b)=>a + b, 0) / finishedSubmissions.size || 0);
    const avgMinutes = finishedSubmissions.map((s)=>s.duration).reduce((a, b)=>a + b, 0) / finishedSubmissions.size || 0;
    const metrics = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
        ...averageRating !== null ? [
            {
                label: "Avg. Student Interest",
                value: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h4",
                            children: averageRating.toFixed(1)
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            size: "0.75em",
                            icon: "star",
                            color: "warning",
                            fillColor: "warning",
                            fill: true
                        })
                    ]
                })
            }
        ] : [],
        ...!assessment.independentOnly ? [
            {
                label: "Total Words",
                value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words, totalWords || 0)
            }
        ] : [],
        {
            label: "Submissions",
            value: `${finishedSubmissions.size}/${userIds.size}`
        }
    ].concat(avgWpcm !== 0 ? [
        {
            label: "Avg. Time",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, avgMinutes)
        },
        {
            label: assessment.independentOnly ? "Avg. WPM" : "Avg. WCPM",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, avgWpcm || 0)
        }
    ] : []));
    return metrics;
};
const $62e5f0fd429b4502$export$c9df4e1f27f016e5 = (assessment)=>{
    if (!assessment) return "";
    if (assessment.instructions) return assessment.instructions;
    if (assessment.isFreeRead) return "Record yourself reading from any text out loud!";
    if (assessment.independentOnly) return "Read from your own copy of the reading, based on your teacher’s directions.";
    return 'Complete the tasks in the "My Tasks" list.';
};
const $62e5f0fd429b4502$export$6f2a8f5fb5b5ba40 = (assessment, author)=>{
    if (author) return author.name;
    if (assessment?.isFreeRead) return (0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(assessment.createdAt), {
        includeYear: true
    });
    return "";
};
const $62e5f0fd429b4502$export$74634d91e494b98a = (status)=>status !== "private";


















const $82a43f48d9c20dff$export$83f25f0085c5a6ed = 5;
const $82a43f48d9c20dff$export$6ee8c29b7cccc937 = (submission, hasFeedback)=>{
    if (hasFeedback) return {
        label: "New Feedback",
        color: "success"
    };
    if (submission?.status === "finished") return {
        label: "Submitted",
        color: "primaryBlue"
    };
    return {
        label: "To Do",
        color: "primaryBlue"
    };
};




const $dfca2c43c391cf73$export$86cab8d3a8167972 = (task)=>{
    switch(task.type){
        case "ModelTask":
            return "modelReading";
        case "ComprehensionTask":
            return "task";
        case "ReadingTask":
            return "microphone";
        case "VocabTask":
            return "vocab";
    }
};


const $2f14aa3b16c7856e$export$762b2163c3ce6757 = (taskSubmissionDetails)=>{
    if (taskSubmissionDetails.type === "ReadingTask") {
        const { recordingSequence: recordingSequence , audioFile: audioFile  } = taskSubmissionDetails;
        return Boolean(recordingSequence.processingStatus !== "waiting" || audioFile);
    } else if (taskSubmissionDetails.type === "ComprehensionTask") {
        const { task: task , taskSubmission: taskSubmission  } = taskSubmissionDetails;
        const recordingValid = ()=>{
            const { responseRecordingSequence: responseRecordingSequence , responseAudioFile: responseAudioFile  } = taskSubmissionDetails;
            return Boolean(responseRecordingSequence.processingStatus !== "waiting" || responseAudioFile);
        };
        const writtenValid = ()=>taskSubmission.responseContent.length > 0;
        if (task.responseType === "recorded") return recordingValid();
        else if (task.responseType === "written") return writtenValid();
        else if (task.responseType === "student_choice") return writtenValid() || recordingValid();
        else throw new Error(`Invalid comprehension task response type ${task.responseType}`);
    } else if (taskSubmissionDetails.type === "ModelTask") return taskSubmissionDetails.taskSubmission.completed;
    else if (taskSubmissionDetails.type === "VocabTask") return taskSubmissionDetails.taskSubmission.completed;
    else throw new Error(`Unrecognized task type ${JSON.stringify(taskSubmissionDetails)}`);
};


const $dc42676e288e1d72$export$5bbf46c666d38142 = (taskDetails, readingPartType)=>{
    if (readingPartType === "chapters") {
        if (taskDetails.contentFile?.type === "EpubStoredFile") {
            const chapters = taskDetails.contentFile.tableOfContents;
            const firstChapter = chapters.first();
            const lastChapter = chapters.last();
            if (!firstChapter || !lastChapter) throw new Error("This epub does not have chapters");
            return {
                ...taskDetails,
                task: {
                    ...taskDetails.task,
                    readingPartType: readingPartType,
                    startPoint: firstChapter,
                    endPoint: lastChapter
                }
            };
        } else throw new Error("Chapter selection is only valid with epub files.");
    } else if (readingPartType === "pages") {
        if (taskDetails.contentFile?.type === "PdfStoredFile" || taskDetails.contentFile?.type === "PdfByPageStoredFile") return {
            ...taskDetails,
            task: {
                ...taskDetails.task,
                readingPartType: readingPartType,
                startPoint: {
                    pageNumber: 0
                },
                endPoint: {
                    pageNumber: taskDetails.contentFile.pageCount - 1
                }
            }
        };
        else throw new Error("Page selection is only valid with PDF files.");
    } else if (readingPartType === "start_and_end_index") return {
        ...taskDetails,
        task: {
            ...taskDetails.task,
            readingPartType: readingPartType,
            newBasicText: "",
            startPoint: {},
            endPoint: {}
        }
    };
    return {
        ...taskDetails,
        task: {
            ...taskDetails.task,
            readingPartType: readingPartType
        }
    };
};


const $e5b5f83b06fa9066$export$9b6c44d21ec830b4 = (taskSubmissionDetails)=>{
    return taskSubmissionDetails.audioFile?.processingStatus === "errored";
};
const $e5b5f83b06fa9066$export$1fa8d6d6ddd4ed27 = (taskSubmissionDetails)=>{
    if (taskSubmissionDetails.recordingSequence.processingStatus === "waiting") return false;
    if (taskSubmissionDetails.audioFile?.processingStatus === "errored") return false;
    return taskSubmissionDetails.recordingSequence.processingStatus !== "finished" || taskSubmissionDetails.audioFile && taskSubmissionDetails.audioFile.processingStatus !== "finished" || taskSubmissionDetails.taskSubmission.processingStatus !== "finished";
};
















const $344b0bc9424ec409$export$8662384f20eca84d = ()=>({
        id: "",
        name: "",
        city: "",
        state: "",
        country: "",
        stateAbbreviation: null,
        street: null,
        zipCode: null,
        districtId: null,
        county: null,
        isPrivate: false,
        isUserCreated: false,
        schoolCode: ""
    });







const $1efad0e185f7a777$export$4c9c6fc2c1b59749 = (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)([
    -2
]);
const $1efad0e185f7a777$export$b9b91d2c498f0b3b = (gradeLevels)=>gradeLevels.filter((grade)=>!$1efad0e185f7a777$export$4c9c6fc2c1b59749.has(grade.level));
const $1efad0e185f7a777$var$gradeLevelToBand = (gradeLevel)=>{
    if (gradeLevel === undefined) return "";
    return (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)($1efad0e185f7a777$export$fffa6fe4f5a324be).reduce((acc, val, key)=>val.includes(gradeLevel) ? key : acc, "");
};
const $1efad0e185f7a777$export$4465baac62bc8a48 = (gradeLevelId, autoGradeLevelId, gradeLevels)=>{
    const filteredGradeLevels = $1efad0e185f7a777$export$b9b91d2c498f0b3b(gradeLevels);
    const gradeLevel = filteredGradeLevels.find((gl)=>gl.id === gradeLevelId)?.level;
    const autoGradeLevel = filteredGradeLevels.find((gl)=>gl.id === autoGradeLevelId)?.level;
    return $1efad0e185f7a777$var$gradeLevelToBand(gradeLevel) || $1efad0e185f7a777$var$gradeLevelToBand(autoGradeLevel) || "--";
};
const $1efad0e185f7a777$export$fffa6fe4f5a324be = {
    "K-1st": [
        -1,
        1
    ],
    "2nd-3rd": [
        2,
        3
    ],
    "4th-6th": [
        4,
        5,
        6
    ],
    "7th-8th": [
        7,
        8
    ],
    "9th-10th": [
        9,
        10
    ],
    "11th-12th": [
        11,
        12
    ],
    College: [
        13
    ]
};
const $1efad0e185f7a777$export$54948edc12631795 = {
    "-1": "K-1st",
    "1": "K-1st",
    "2": "2nd-3rd",
    "3": "2nd-3rd",
    "4": "4th-6th",
    "5": "4th-6th",
    "6": "4th-6th",
    "7": "7th-8th",
    "8": "7th-8th",
    "9": "9th-10th",
    "10": "9th-10th",
    "11": "11th-12th",
    "12": "11th-12th",
    "13": "College"
};
const $1efad0e185f7a777$var$immutableGradeBandsToLevels = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)($1efad0e185f7a777$export$fffa6fe4f5a324be);
const $1efad0e185f7a777$export$72e35e20ef873369 = (bands, gradeLevels)=>{
    const levels = bands.reduce((acc, val)=>acc.concat($1efad0e185f7a777$var$immutableGradeBandsToLevels.get(val, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)())), (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
    return gradeLevels.filter((gl)=>levels.includes(gl.level)).map((gl)=>gl.id);
};



















var $c383c67e37e2d43e$exports = {};

$c383c67e37e2d43e$exports = new URL((parcelRequire("3TfdU")).resolve("aTldh"), import.meta.url).toString();


var $f775556f914f7316$exports = {};

$f775556f914f7316$exports = new URL((parcelRequire("3TfdU")).resolve("32t4s"), import.meta.url).toString();


var $39a0e4ce38295d48$exports = {};

$39a0e4ce38295d48$exports = new URL((parcelRequire("3TfdU")).resolve("03HQx"), import.meta.url).toString();


var $24190320950b9ab3$exports = {};

$24190320950b9ab3$exports = new URL((parcelRequire("3TfdU")).resolve("71wke"), import.meta.url).toString();


var $83d95ba819fa0745$exports = {};

$83d95ba819fa0745$exports = new URL((parcelRequire("3TfdU")).resolve("5SyIQ"), import.meta.url).toString();


var $81599026453c25a7$exports = {};

$81599026453c25a7$exports = new URL((parcelRequire("3TfdU")).resolve("28Zr6"), import.meta.url).toString();


var $943192a6905b1b29$exports = {};

$943192a6905b1b29$exports = new URL((parcelRequire("3TfdU")).resolve("cE8Ut"), import.meta.url).toString();


var $40a0c0dda7ad43a5$exports = {};

$40a0c0dda7ad43a5$exports = new URL((parcelRequire("3TfdU")).resolve("8YVpU"), import.meta.url).toString();


var $bb7b1f81b2745447$exports = {};

$bb7b1f81b2745447$exports = new URL((parcelRequire("3TfdU")).resolve("f12TZ"), import.meta.url).toString();


var $673eb4d741bffc18$exports = {};

$673eb4d741bffc18$exports = new URL((parcelRequire("3TfdU")).resolve("gLslO"), import.meta.url).toString();


var $3437b0454efbd148$exports = {};

$3437b0454efbd148$exports = new URL((parcelRequire("3TfdU")).resolve("iL5q3"), import.meta.url).toString();


var $1d2c6dacdbdb7ed1$exports = {};

$1d2c6dacdbdb7ed1$exports = new URL((parcelRequire("3TfdU")).resolve("fQ1B0"), import.meta.url).toString();


var $82ff8714e52b43b5$exports = {};

$82ff8714e52b43b5$exports = new URL((parcelRequire("3TfdU")).resolve("1Pc2X"), import.meta.url).toString();


var $7d0ecf589e34b09f$exports = {};

$7d0ecf589e34b09f$exports = new URL((parcelRequire("3TfdU")).resolve("7DQCL"), import.meta.url).toString();


var $84ce06a6e0d763bd$exports = {};

$84ce06a6e0d763bd$exports = new URL((parcelRequire("3TfdU")).resolve("fWBNV"), import.meta.url).toString();


var $fff35c3b025ab517$exports = {};

$fff35c3b025ab517$exports = new URL((parcelRequire("3TfdU")).resolve("fiDOe"), import.meta.url).toString();


var $a8da4e9b73e7eb43$exports = {};

$a8da4e9b73e7eb43$exports = new URL((parcelRequire("3TfdU")).resolve("03aIk"), import.meta.url).toString();


var $dd24ea1349fbe4a5$exports = {};

$dd24ea1349fbe4a5$exports = new URL((parcelRequire("3TfdU")).resolve("cvhv3"), import.meta.url).toString();


var $8b3d7187d06e2b4c$exports = {};

$8b3d7187d06e2b4c$exports = new URL((parcelRequire("3TfdU")).resolve("eFsoQ"), import.meta.url).toString();


var $d2e629c0939f49f6$exports = {};

$d2e629c0939f49f6$exports = new URL((parcelRequire("3TfdU")).resolve("chluQ"), import.meta.url).toString();


var $9f59b9ab6b39713b$exports = {};

$9f59b9ab6b39713b$exports = new URL((parcelRequire("3TfdU")).resolve("hqQ4I"), import.meta.url).toString();


var $1b4cdffaaad65789$exports = {};

$1b4cdffaaad65789$exports = new URL((parcelRequire("3TfdU")).resolve("bswq8"), import.meta.url).toString();


var $9800bfa1fe3daac8$exports = {};

$9800bfa1fe3daac8$exports = new URL((parcelRequire("3TfdU")).resolve("6xIlG"), import.meta.url).toString();


var $7dca7f1321f0b4b7$exports = {};

$7dca7f1321f0b4b7$exports = new URL((parcelRequire("3TfdU")).resolve("g9emV"), import.meta.url).toString();


var $343611b17e2384d8$exports = {};

$343611b17e2384d8$exports = new URL((parcelRequire("3TfdU")).resolve("aBi0g"), import.meta.url).toString();


var $ab882f3cf061fd26$exports = {};

$ab882f3cf061fd26$exports = new URL((parcelRequire("3TfdU")).resolve("9Wsxh"), import.meta.url).toString();


var $a79d9a5577e91568$exports = {};

$a79d9a5577e91568$exports = new URL((parcelRequire("3TfdU")).resolve("fJT1c"), import.meta.url).toString();


var $cccb738017aa3174$exports = {};

$cccb738017aa3174$exports = new URL((parcelRequire("3TfdU")).resolve("jJwwO"), import.meta.url).toString();


var $99d0eb33b4b97f11$exports = {};

$99d0eb33b4b97f11$exports = new URL((parcelRequire("3TfdU")).resolve("d60Eb"), import.meta.url).toString();


var $591b90398acf93c5$exports = {};

$591b90398acf93c5$exports = new URL((parcelRequire("3TfdU")).resolve("72ohN"), import.meta.url).toString();


var $32bcb6d0ef16e306$exports = {};

$32bcb6d0ef16e306$exports = new URL((parcelRequire("3TfdU")).resolve("evfM7"), import.meta.url).toString();


var $5840351c8579fe94$exports = {};

$5840351c8579fe94$exports = new URL((parcelRequire("3TfdU")).resolve("6j5FN"), import.meta.url).toString();


var $d9c6802ce0d1c268$exports = {};

$d9c6802ce0d1c268$exports = new URL((parcelRequire("3TfdU")).resolve("lovBB"), import.meta.url).toString();


var $45486248541915af$exports = {};

$45486248541915af$exports = new URL((parcelRequire("3TfdU")).resolve("8yJPr"), import.meta.url).toString();


var $987c366c46fc3c75$exports = {};

$987c366c46fc3c75$exports = new URL((parcelRequire("3TfdU")).resolve("tOumv"), import.meta.url).toString();


var $ddca8e2a5256f99c$exports = {};

$ddca8e2a5256f99c$exports = new URL((parcelRequire("3TfdU")).resolve("VyCqo"), import.meta.url).toString();


var $3a27697efdeebc02$exports = {};

$3a27697efdeebc02$exports = new URL((parcelRequire("3TfdU")).resolve("bTbXi"), import.meta.url).toString();


var $7179985e0c2df754$exports = {};

$7179985e0c2df754$exports = new URL((parcelRequire("3TfdU")).resolve("l2W3b"), import.meta.url).toString();


var $773467caf6b5aeda$exports = {};

$773467caf6b5aeda$exports = new URL((parcelRequire("3TfdU")).resolve("f1itH"), import.meta.url).toString();


var $ab0d6953a49e9b1f$exports = {};

$ab0d6953a49e9b1f$exports = new URL((parcelRequire("3TfdU")).resolve("9R0J4"), import.meta.url).toString();


var $16c1b36d57f724d8$exports = {};

$16c1b36d57f724d8$exports = new URL((parcelRequire("3TfdU")).resolve("dkMYU"), import.meta.url).toString();


var $331ad496d74dcad9$exports = {};

$331ad496d74dcad9$exports = new URL((parcelRequire("3TfdU")).resolve("cUbVZ"), import.meta.url).toString();


var $a290fcbce6555e48$exports = {};

$a290fcbce6555e48$exports = new URL((parcelRequire("3TfdU")).resolve("c8KZA"), import.meta.url).toString();


var $601724827ccac82a$exports = {};

$601724827ccac82a$exports = new URL((parcelRequire("3TfdU")).resolve("cH51a"), import.meta.url).toString();


var $af027138dbac36d0$exports = {};

$af027138dbac36d0$exports = new URL((parcelRequire("3TfdU")).resolve("2bsGC"), import.meta.url).toString();


var $af08281ab2ddbae6$exports = {};

$af08281ab2ddbae6$exports = new URL((parcelRequire("3TfdU")).resolve("dlvQa"), import.meta.url).toString();


var $70a578650ee94500$exports = {};

$70a578650ee94500$exports = new URL((parcelRequire("3TfdU")).resolve("b6Daq"), import.meta.url).toString();


var $56bf9a3c19c6f937$exports = {};

$56bf9a3c19c6f937$exports = new URL((parcelRequire("3TfdU")).resolve("yKExW"), import.meta.url).toString();


var $aa0581f089cc3785$exports = {};

$aa0581f089cc3785$exports = new URL((parcelRequire("3TfdU")).resolve("abFtT"), import.meta.url).toString();


var $7dc5551a3f03f9ff$exports = {};

$7dc5551a3f03f9ff$exports = new URL((parcelRequire("3TfdU")).resolve("k9rTs"), import.meta.url).toString();


var $d7dbdc34133b897c$exports = {};

$d7dbdc34133b897c$exports = new URL((parcelRequire("3TfdU")).resolve("mkRGR"), import.meta.url).toString();


var $77bf4800a10788b1$exports = {};

$77bf4800a10788b1$exports = new URL((parcelRequire("3TfdU")).resolve("3vOSj"), import.meta.url).toString();


var $f6d49fbd2ebde509$exports = {};

$f6d49fbd2ebde509$exports = new URL((parcelRequire("3TfdU")).resolve("1Ntof"), import.meta.url).toString();


var $d7bb9b63012caa26$exports = {};

$d7bb9b63012caa26$exports = new URL((parcelRequire("3TfdU")).resolve("bEyBa"), import.meta.url).toString();


var $3d4a3d86ed3390f7$exports = {};

$3d4a3d86ed3390f7$exports = new URL((parcelRequire("3TfdU")).resolve("UqbCu"), import.meta.url).toString();


var $b86a4155865b42a0$exports = {};

$b86a4155865b42a0$exports = new URL((parcelRequire("3TfdU")).resolve("g2DWH"), import.meta.url).toString();


var $3db6e4a252b41e4a$exports = {};

$3db6e4a252b41e4a$exports = new URL((parcelRequire("3TfdU")).resolve("AKDpw"), import.meta.url).toString();


var $afa37f161f862a37$exports = {};

$afa37f161f862a37$exports = new URL((parcelRequire("3TfdU")).resolve("8a6x0"), import.meta.url).toString();


var $54d5f5fd6280e5a7$exports = {};

$54d5f5fd6280e5a7$exports = new URL((parcelRequire("3TfdU")).resolve("2NmPs"), import.meta.url).toString();


var $10fd32d05fce3ac4$exports = {};

$10fd32d05fce3ac4$exports = new URL((parcelRequire("3TfdU")).resolve("3nmzK"), import.meta.url).toString();


var $a394419ac6c11c23$exports = {};

$a394419ac6c11c23$exports = new URL((parcelRequire("3TfdU")).resolve("kPZGz"), import.meta.url).toString();


var $11376f87703e1902$exports = {};

$11376f87703e1902$exports = new URL((parcelRequire("3TfdU")).resolve("6lec4"), import.meta.url).toString();


var $0b6fbf03a63b6dc4$exports = {};

$0b6fbf03a63b6dc4$exports = new URL((parcelRequire("3TfdU")).resolve("21lTN"), import.meta.url).toString();


var $90979865b14fb08e$exports = {};

$90979865b14fb08e$exports = new URL((parcelRequire("3TfdU")).resolve("78tNm"), import.meta.url).toString();


var $25376931041fe56d$exports = {};

$25376931041fe56d$exports = new URL((parcelRequire("3TfdU")).resolve("iJ9WC"), import.meta.url).toString();


var $28f7614149e0c134$exports = {};

$28f7614149e0c134$exports = new URL((parcelRequire("3TfdU")).resolve("x0Zlc"), import.meta.url).toString();


var $88ca0be74818be99$exports = {};

$88ca0be74818be99$exports = new URL((parcelRequire("3TfdU")).resolve("26l8s"), import.meta.url).toString();


var $ea23ed283e46558b$exports = {};

$ea23ed283e46558b$exports = new URL((parcelRequire("3TfdU")).resolve("13E4E"), import.meta.url).toString();


var $6154a37f7120fe19$exports = {};

$6154a37f7120fe19$exports = new URL((parcelRequire("3TfdU")).resolve("4KbPz"), import.meta.url).toString();


var $7d26a2b76cf6b442$exports = {};

$7d26a2b76cf6b442$exports = new URL((parcelRequire("3TfdU")).resolve("5Y0ET"), import.meta.url).toString();


var $fcff67b61af92aa3$exports = {};

$fcff67b61af92aa3$exports = new URL((parcelRequire("3TfdU")).resolve("hV8sP"), import.meta.url).toString();


var $e4a2ce59b778ca8c$exports = {};

$e4a2ce59b778ca8c$exports = new URL((parcelRequire("3TfdU")).resolve("q4565"), import.meta.url).toString();


var $b929231cd2abd1b4$exports = {};

$b929231cd2abd1b4$exports = new URL((parcelRequire("3TfdU")).resolve("3GXAD"), import.meta.url).toString();


var $19442cb0e62163d3$exports = {};

$19442cb0e62163d3$exports = new URL((parcelRequire("3TfdU")).resolve("8hfr8"), import.meta.url).toString();


var $f24c2cb746860bbb$exports = {};

$f24c2cb746860bbb$exports = new URL((parcelRequire("3TfdU")).resolve("8d0sg"), import.meta.url).toString();


var $5e4e209b6e9fd6b2$exports = {};

$5e4e209b6e9fd6b2$exports = new URL((parcelRequire("3TfdU")).resolve("c7T8P"), import.meta.url).toString();


var $faf4be990cf6eb87$exports = {};

$faf4be990cf6eb87$exports = new URL((parcelRequire("3TfdU")).resolve("kD4lu"), import.meta.url).toString();


var $54a7841b1a27c705$exports = {};

$54a7841b1a27c705$exports = new URL((parcelRequire("3TfdU")).resolve("4KaiE"), import.meta.url).toString();


var $a074453a0b909c10$exports = {};

$a074453a0b909c10$exports = new URL((parcelRequire("3TfdU")).resolve("iDeL8"), import.meta.url).toString();


var $4cb838e00dab2ba4$exports = {};

$4cb838e00dab2ba4$exports = new URL((parcelRequire("3TfdU")).resolve("jIFpF"), import.meta.url).toString();


var $ad30570522aa6aaf$exports = {};

$ad30570522aa6aaf$exports = new URL((parcelRequire("3TfdU")).resolve("74FBy"), import.meta.url).toString();


var $7f5769039714d43a$exports = {};

$7f5769039714d43a$exports = new URL((parcelRequire("3TfdU")).resolve("kdtJ2"), import.meta.url).toString();


var $b355ff833d93338d$exports = {};

$b355ff833d93338d$exports = new URL((parcelRequire("3TfdU")).resolve("alAdV"), import.meta.url).toString();


var $fb2c7f7b3ac404bc$exports = {};

$fb2c7f7b3ac404bc$exports = new URL((parcelRequire("3TfdU")).resolve("jqQSq"), import.meta.url).toString();


var $b5b53c653c3ed829$exports = {};

$b5b53c653c3ed829$exports = new URL((parcelRequire("3TfdU")).resolve("2JLNA"), import.meta.url).toString();


var $80f1ac8b7c3a0468$exports = {};

$80f1ac8b7c3a0468$exports = new URL((parcelRequire("3TfdU")).resolve("lgler"), import.meta.url).toString();


var $84824f1b531b121c$exports = {};

$84824f1b531b121c$exports = new URL((parcelRequire("3TfdU")).resolve("eadQh"), import.meta.url).toString();


const $7b0ba46fad863bdb$export$1fe81be1fd50fe28 = (attribute)=>{
    switch(attribute){
        case "chocolate":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c383c67e37e2d43e$exports));
        case "caramel":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f775556f914f7316$exports));
        case "blue":
            return 0, (/*@__PURE__*/$parcel$interopDefault($39a0e4ce38295d48$exports));
        case "red":
            return 0, (/*@__PURE__*/$parcel$interopDefault($83d95ba819fa0745$exports));
        case "purple":
            return 0, (/*@__PURE__*/$parcel$interopDefault($24190320950b9ab3$exports));
        case "pink":
            return 0, (/*@__PURE__*/$parcel$interopDefault($81599026453c25a7$exports));
        case "ziggy":
            return 0, (/*@__PURE__*/$parcel$interopDefault($943192a6905b1b29$exports));
        case "odd_yellow":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bb7b1f81b2745447$exports));
        case "green_warrior":
            return 0, (/*@__PURE__*/$parcel$interopDefault($40a0c0dda7ad43a5$exports));
        case "tie_dye":
            return 0, (/*@__PURE__*/$parcel$interopDefault($673eb4d741bffc18$exports));
        case "air_bender":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3437b0454efbd148$exports));
        case "freckles":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1d2c6dacdbdb7ed1$exports));
        default:
            throw new Error("unknown avatar skin");
    }
};
const $7b0ba46fad863bdb$export$386693e1a9f87fca = (attribute)=>{
    switch(attribute){
        case "regular":
            return 0, (/*@__PURE__*/$parcel$interopDefault($82ff8714e52b43b5$exports));
        case "almond":
            return 0, (/*@__PURE__*/$parcel$interopDefault($84ce06a6e0d763bd$exports));
        case "wide":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7d0ecf589e34b09f$exports));
        case "cyclops":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fff35c3b025ab517$exports));
        case "big":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a8da4e9b73e7eb43$exports));
        case "sunglasses":
            return 0, (/*@__PURE__*/$parcel$interopDefault($dd24ea1349fbe4a5$exports));
        case "flaming":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8b3d7187d06e2b4c$exports));
        case "hotdog":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d2e629c0939f49f6$exports));
        case "kushite_king":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1b4cdffaaad65789$exports));
        case "raphael_wannabee":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9f59b9ab6b39713b$exports));
        case "space_skiing":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9800bfa1fe3daac8$exports));
        case "speck_tackle":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7dca7f1321f0b4b7$exports));
        case "sharingan":
            return 0, (/*@__PURE__*/$parcel$interopDefault($343611b17e2384d8$exports));
        default:
            throw new Error("unknown avatar eyes");
    }
};
const $7b0ba46fad863bdb$export$27e8a706b960b377 = (attribute)=>{
    switch(attribute){
        case "regular":
            return 0, (/*@__PURE__*/$parcel$interopDefault($11376f87703e1902$exports));
        case "almond":
            return 0, (/*@__PURE__*/$parcel$interopDefault($90979865b14fb08e$exports));
        case "wide":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0b6fbf03a63b6dc4$exports));
        case "cyclops":
            return 0, (/*@__PURE__*/$parcel$interopDefault($25376931041fe56d$exports));
        case "big":
            return 0, (/*@__PURE__*/$parcel$interopDefault($28f7614149e0c134$exports));
        case "sunglasses":
            return 0, (/*@__PURE__*/$parcel$interopDefault($88ca0be74818be99$exports));
        case "flaming":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ea23ed283e46558b$exports));
        case "hotdog":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6154a37f7120fe19$exports));
        case "kushite_king":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fcff67b61af92aa3$exports));
        case "raphael_wannabee":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7d26a2b76cf6b442$exports));
        case "space_skiing":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e4a2ce59b778ca8c$exports));
        case "speck_tackle":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b929231cd2abd1b4$exports));
        case "sharingan":
            return 0, (/*@__PURE__*/$parcel$interopDefault($19442cb0e62163d3$exports));
        default:
            throw new Error("unknown avatar eyes");
    }
};
const $7b0ba46fad863bdb$export$eafcc3332342f066 = (attribute)=>{
    switch(attribute){
        case "smile":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ab882f3cf061fd26$exports));
        case "scary":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a79d9a5577e91568$exports));
        case "oh":
            return 0, (/*@__PURE__*/$parcel$interopDefault($cccb738017aa3174$exports));
        case "toothy_smile":
            return 0, (/*@__PURE__*/$parcel$interopDefault($591b90398acf93c5$exports));
        case "closed":
            return 0, (/*@__PURE__*/$parcel$interopDefault($99d0eb33b4b97f11$exports));
        case "bugs":
            return 0, (/*@__PURE__*/$parcel$interopDefault($32bcb6d0ef16e306$exports));
        case "purple_lips":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5840351c8579fe94$exports));
        case "square_tooth":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d9c6802ce0d1c268$exports));
        case "stitch":
            return 0, (/*@__PURE__*/$parcel$interopDefault($45486248541915af$exports));
        case "tongue":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ddca8e2a5256f99c$exports));
        case "vampire":
            return 0, (/*@__PURE__*/$parcel$interopDefault($987c366c46fc3c75$exports));
        case "big_smile":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3a27697efdeebc02$exports));
        default:
            throw new Error("unknown avatar mouth");
    }
};
const $7b0ba46fad863bdb$export$5b7a0513ec3da4c6 = (attribute)=>{
    switch(attribute){
        case "smile":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7dc5551a3f03f9ff$exports));
        case "scary":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d7dbdc34133b897c$exports));
        case "oh":
            return 0, (/*@__PURE__*/$parcel$interopDefault($77bf4800a10788b1$exports));
        case "toothy_smile":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d7bb9b63012caa26$exports));
        case "closed":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f6d49fbd2ebde509$exports));
        case "bugs":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3d4a3d86ed3390f7$exports));
        case "purple_lips":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b86a4155865b42a0$exports));
        case "square_tooth":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3db6e4a252b41e4a$exports));
        case "stitch":
            return 0, (/*@__PURE__*/$parcel$interopDefault($afa37f161f862a37$exports));
        case "tongue":
            return 0, (/*@__PURE__*/$parcel$interopDefault($10fd32d05fce3ac4$exports));
        case "vampire":
            return 0, (/*@__PURE__*/$parcel$interopDefault($54d5f5fd6280e5a7$exports));
        case "big_smile":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a394419ac6c11c23$exports));
        default:
            throw new Error("unknown avatar mouth");
    }
};
const $7b0ba46fad863bdb$export$4c3d7c0ad733edde = (attribute)=>{
    switch(attribute){
        case "blue_hair":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7179985e0c2df754$exports));
        case "pizza":
            return 0, (/*@__PURE__*/$parcel$interopDefault($773467caf6b5aeda$exports));
        case "unicorn":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a290fcbce6555e48$exports));
        case "winter":
            return 0, (/*@__PURE__*/$parcel$interopDefault($16c1b36d57f724d8$exports));
        case "octopus":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ab0d6953a49e9b1f$exports));
        case "headphones":
            return 0, (/*@__PURE__*/$parcel$interopDefault($331ad496d74dcad9$exports));
        case "antennae_eyes":
            return 0, (/*@__PURE__*/$parcel$interopDefault($601724827ccac82a$exports));
        case "astronaut":
            return 0, (/*@__PURE__*/$parcel$interopDefault($af027138dbac36d0$exports));
        case "banana":
            return 0, (/*@__PURE__*/$parcel$interopDefault($af08281ab2ddbae6$exports));
        case "chia_pet":
            return 0, (/*@__PURE__*/$parcel$interopDefault($56bf9a3c19c6f937$exports));
        case "hip_plant":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70a578650ee94500$exports));
        case "frog":
            return 0, (/*@__PURE__*/$parcel$interopDefault($aa0581f089cc3785$exports));
        case "nothing":
            return;
        default:
            throw new Error("unknown avatar hat");
    }
};
const $7b0ba46fad863bdb$export$55d4ab65442f4526 = (attribute)=>{
    switch(attribute){
        case "blue_hair":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f24c2cb746860bbb$exports));
        case "pizza":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5e4e209b6e9fd6b2$exports));
        case "unicorn":
            return 0, (/*@__PURE__*/$parcel$interopDefault($4cb838e00dab2ba4$exports));
        case "winter":
            return 0, (/*@__PURE__*/$parcel$interopDefault($54a7841b1a27c705$exports));
        case "octopus":
            return 0, (/*@__PURE__*/$parcel$interopDefault($faf4be990cf6eb87$exports));
        case "headphones":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a074453a0b909c10$exports));
        case "antennae_eyes":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ad30570522aa6aaf$exports));
        case "astronaut":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7f5769039714d43a$exports));
        case "banana":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b355ff833d93338d$exports));
        case "chia_pet":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b5b53c653c3ed829$exports));
        case "hip_plant":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fb2c7f7b3ac404bc$exports));
        case "frog":
            return 0, (/*@__PURE__*/$parcel$interopDefault($80f1ac8b7c3a0468$exports));
        case "nothing":
            return 0, (/*@__PURE__*/$parcel$interopDefault($84824f1b531b121c$exports));
        default:
            throw new Error("unknown avatar hat");
    }
};
const $7b0ba46fad863bdb$export$f53d309096cb8713 = (feature)=>{
    switch(feature){
        case "skin":
            return "avatarSkin";
        case "mouth":
            return "avatarMouth";
        case "eyes":
            return "avatarEyes";
        case "hat":
            return "avatarHat";
    }
};
const $7b0ba46fad863bdb$export$735ee1799fd02602 = (kind, attribute)=>{
    switch(kind){
        case "skin":
            return $7b0ba46fad863bdb$export$1fe81be1fd50fe28(attribute);
        case "mouth":
            return $7b0ba46fad863bdb$export$5b7a0513ec3da4c6(attribute);
        case "eyes":
            return $7b0ba46fad863bdb$export$27e8a706b960b377(attribute);
        case "hat":
            return $7b0ba46fad863bdb$export$55d4ab65442f4526(attribute);
    }
};
const $7b0ba46fad863bdb$export$642e3bed1b9f118a = [
    {
        kind: "skin",
        buttonName: "Skin",
        fieldName: "avatarSkin"
    },
    {
        kind: "hat",
        buttonName: "Hat",
        fieldName: "avatarHat"
    },
    {
        kind: "eyes",
        buttonName: "Eyes",
        fieldName: "avatarEyes"
    },
    {
        kind: "mouth",
        buttonName: "Mouth",
        fieldName: "avatarMouth"
    }
];







const $d66224a7b1518c5a$export$88bee8c1f4ff1cd = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        value: "student",
        label: "Student"
    },
    {
        value: "teacher",
        label: "Teacher"
    },
    {
        value: "pro_teacher",
        label: "Pro Teacher"
    },
    {
        value: "school_license_teacher",
        label: "Ultimate Teacher"
    },
    {
        value: "moderator",
        label: "Moderator"
    }
]);
const $d66224a7b1518c5a$export$1d1a8ee647677bd3 = ()=>({
        id: "",
        name: "",
        ranking: 0,
        status: "active",
        visibleRoles: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
        enabled: false
    });
const $d66224a7b1518c5a$export$4efca973fe331688 = (resultCount)=>{
    return {
        id: "continue-reading",
        name: "Continue Reading",
        ranking: -1,
        status: "active",
        visibleRoles: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
            "student"
        ]),
        enabled: resultCount > 0
    };
};




const $1242a71da44ee8f3$export$d636fa3b02762e7b = {
    startPoint: {},
    endPoint: {}
};










var $g5BLJ = parcelRequire("g5BLJ");
const $663e996bc3c0fcdd$var$TextContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TextViewer__TextContainer",
    componentId: "sc-118up41-0"
})([
    "font-size:",
    "px;white-space:pre-wrap;max-width:",
    ";",
    " overflow-y:auto;background:linear-gradient(",
    " 30%,",
    "),linear-gradient(",
    ",",
    " 70%) 0 100%,radial-gradient( farthest-side at 50% 0,",
    ",",
    " ),radial-gradient( farthest-side at 50% 100%,",
    ",",
    " ) 0 100%;background-repeat:no-repeat;background-size:100% 40px,100% 40px,100% 20px,100% 20px;background-attachment:local,local,scroll,scroll;"
], ({ $textSize: $textSize  })=>$textSize, (0, $18ffa0398cff6303$export$c68d31c234787f72), ({ $compactLayout: $compactLayout  })=>$compactLayout ? `min-width: 0; flex-grow: 1;` : `min-width: 350px;`, (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, 0.3), (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, 0), (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex, 0.3), (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, 0), (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex, 0.3), (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, 0));
const $663e996bc3c0fcdd$var$getPlaceholderContent = (loading, errored)=>{
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {});
    if (errored) return "There was an error fetching your content";
    return "No content available to read";
};
const $663e996bc3c0fcdd$var$bottomSpacerHeight = (compactLayout, drawerOpen)=>{
    if (compactLayout) return 18;
    else if (drawerOpen) return 75;
    else return 22;
};
const $663e996bc3c0fcdd$var$UnmemoizedTextViewer = ({ children: children , loading: loading = false , errored: errored = false , testTag: testTag , drawerOpen: drawerOpen = false , compactLayout: compactLayout = false , onClick: onClick , onMouseOver: onMouseOver  })=>{
    const textSize = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.AppData.currentUser?.textSize, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        height: "100%",
        justify: "center",
        minHeight: 0,
        testTag: testTag,
        padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]}`,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($663e996bc3c0fcdd$var$TextContainer, {
            $textSize: textSize || (0, $75cd274e63beb59b$export$74d9cec7d2c95116),
            $compactLayout: compactLayout,
            "data-test-tag": "reader",
            onClick: onClick,
            onMouseOver: onMouseOver,
            children: children ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: compactLayout ? 2 : 8
                    }),
                    children,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: $663e996bc3c0fcdd$var$bottomSpacerHeight(compactLayout, drawerOpen)
                    })
                ]
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                height: "100%",
                justify: "center",
                align: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h1",
                    children: $663e996bc3c0fcdd$var$getPlaceholderContent(loading, errored)
                })
            })
        })
    });
};
const $663e996bc3c0fcdd$export$7f86637430bae410 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo($663e996bc3c0fcdd$var$UnmemoizedTextViewer);












const $2dee512fbabf1618$var$VocabTaskOverviewStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "VocabTaskOverview__VocabTaskOverviewStyles",
    componentId: "sc-pmrf9n-0"
})([
    "display:flex;border:1px solid ",
    ";padding:",
    ";border-radius:",
    ";height:auto;justify-content:space-between;",
    ""
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[6], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], ({ $compactLayout: $compactLayout  })=>$compactLayout ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "flex-wrap:wrap;margin:",
        ";align-self:stretch;flex:1;"
    ], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "min-width:600px;margin:",
        ";max-height:75%;align-self:center;"
    ], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[12]));
const $2dee512fbabf1618$var$VocabImageStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).img.withConfig({
    displayName: "VocabTaskOverview__VocabImageStyles",
    componentId: "sc-pmrf9n-1"
})([
    "max-height:300px;object-fit:contain;",
    ";"
], ({ $compactLayout: $compactLayout  })=>$compactLayout ? `max-width: 80vw` : "max-width: 400px");
const $2dee512fbabf1618$export$854dd595c92520ae = ({ word: word , task: task  })=>{
    return word?.audioUrl ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2,
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                src: word.audioUrl,
                displayType: "iconOnly",
                icon: "speaker",
                iconColor: "black",
                testTag: "vocab-audio",
                subText: word?.lemmaWord && word.lemmaWord.toLowerCase() !== task.customWord.toLowerCase() ? (0, $e6116bf527c207db$export$9a00dee1beb8f576)(word.lemmaWord) : undefined
            })
        ]
    }) : null;
};
const $2dee512fbabf1618$export$3ff687953a83247d = ({ task: task  })=>{
    const textSize = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser?.textSize, []) || (0, $75cd274e63beb59b$export$74d9cec7d2c95116);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h6",
                color: "gray7",
                sizeOverride: textSize,
                children: "Definition"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                whiteSpace: "pre-wrap",
                overflowY: "auto",
                sizeOverride: textSize,
                children: task.definition
            })
        ]
    });
};
const $2dee512fbabf1618$export$6e4e2906c67366e6 = ({ imageFile: imageFile , task: task , compactLayout: compactLayout  })=>{
    if (!imageFile?.url) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 20
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2dee512fbabf1618$var$VocabImageStyles, {
                $compactLayout: compactLayout,
                src: imageFile.url,
                alt: task.customWord,
                "data-test-tag": "vocab-image"
            })
        ]
    });
};
const $2dee512fbabf1618$export$e2ebe3e47482b39b = (props)=>{
    const { compactLayout: compactLayout , taskDetails: taskDetails  } = props;
    const { task: task , word: word , imageFile: imageFile  } = taskDetails;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($2dee512fbabf1618$var$VocabTaskOverviewStyles, {
        $compactLayout: compactLayout,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h3",
                                children: (0, $e6116bf527c207db$export$9a00dee1beb8f576)(task.customWord)
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2dee512fbabf1618$export$854dd595c92520ae, {
                                word: word,
                                task: task
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2dee512fbabf1618$export$3ff687953a83247d, {
                        task: task
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2dee512fbabf1618$export$6e4e2906c67366e6, {
                imageFile: imageFile,
                task: task,
                compactLayout: compactLayout
            })
        ]
    });
};
const $2dee512fbabf1618$export$55b733b0e3e0b1be = (props)=>{
    const { compactLayout: compactLayout , taskDetails: taskDetails  } = props;
    const { task: task , word: word , imageFile: imageFile  } = taskDetails;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: (0, $e6116bf527c207db$export$9a00dee1beb8f576)(task.customWord),
        middleHeader: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2dee512fbabf1618$export$854dd595c92520ae, {
            word: word,
            task: task
        }),
        openType: "state",
        opened: true,
        close: props.close,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            wrap: compactLayout ? "wrap" : "unset",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2dee512fbabf1618$export$3ff687953a83247d, {
                        task: task
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2dee512fbabf1618$export$6e4e2906c67366e6, {
                    imageFile: imageFile,
                    task: task,
                    compactLayout: compactLayout
                })
            ]
        })
    });
};




const $ee42914c60200b71$var$checkInTextRange = (startIndex, textRange, hoveredIndex)=>{
    if (typeof textRange.startPoint.index !== "number") return false;
    if (typeof textRange.endPoint.index === "number") return startIndex >= textRange.startPoint.index && startIndex < textRange.endPoint.index;
    else if (startIndex === textRange.startPoint.index) return true;
    else if (typeof hoveredIndex === "number") return startIndex >= textRange.startPoint.index && startIndex <= hoveredIndex || startIndex <= textRange.startPoint.index && startIndex >= hoveredIndex;
    return false;
};
const $ee42914c60200b71$var$parseSpanElement = (elem)=>{
    const startIndexStr = elem.getAttribute("data-start-index");
    const startIndex = startIndexStr ? parseInt(startIndexStr, 10) : 0;
    return {
        isWord: elem.getAttribute("data-elem-type") === "word",
        startIndex: startIndex,
        content: elem.innerText
    };
};
const $ee42914c60200b71$var$UnmemoizedPlainTextReader = ({ textFile: textFile , textContent: textContent , displayType: displayType = "textOnly" , enableTextRangeSelection: enableTextRangeSelection , textRange: textRange = (0, $1242a71da44ee8f3$export$d636fa3b02762e7b) , drawerOpen: drawerOpen = false , highlightedWord: highlightedWord , onTextRangeSelected: onTextRangeSelected , setVocabWord: setVocabWord , vocabTaskDetailsList: vocabTaskDetailsList , compactLayout: compactLayout , languageCodeDetails: languageCodeDetails  })=>{
    const { textSize: textSize , searchDictionary: searchDictionary  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            textSize: state.AppData.currentUser?.textSize,
            searchDictionary: state.DictionaryData.searchDictionary
        }), []);
    const [openedVocabWord, setOpenedVocabWord] = (0, $g5BLJ.useState)();
    const { fetchResponse: fetchResponse  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const [loading, setLoading] = (0, $g5BLJ.useState)(true);
    const [fileContent, setFileContent] = (0, $g5BLJ.useState)(null);
    const [errored, setErrored] = (0, $g5BLJ.useState)(false);
    const [hoveredIndex, setHoveredIndex] = (0, $g5BLJ.useState)(null);
    const content = textContent ?? fileContent ?? "";
    const canSetTextRange = displayType === "setTextRange" && enableTextRangeSelection;
    (0, $g5BLJ.useEffect)(()=>{
        if (!textFile?.url) return;
        const onError = ()=>{
            setErrored(true);
            setLoading(false);
        };
        fetchResponse(textFile.url, {
            retrySchedule: [
                0,
                1000,
                10000
            ],
            onSuccess: async (response)=>{
                const text = await response.text();
                setFileContent(text);
                setLoading(false);
            },
            onUnknownError: onError,
            onNotAuthenticated: onError,
            onNotAuthorized: onError,
            noRedirect: true
        });
    }, [
        textFile?.url,
        fetchResponse
    ]);
    const setTextRange = (0, $g5BLJ.useCallback)((item)=>{
        if (typeof textRange.startPoint.index !== "number" || typeof textRange.startPoint.wordLength !== "number" || typeof textRange.endPoint.index === "number") onTextRangeSelected?.({
            startPoint: {
                index: item.startIndex,
                wordLength: item.content.length
            },
            endPoint: {}
        }, "");
        else if (item.startIndex < textRange.startPoint.index) {
            const startIndex = item.startIndex;
            const endIndex = textRange.startPoint.index + textRange.startPoint.wordLength;
            onTextRangeSelected?.({
                startPoint: {
                    index: startIndex
                },
                endPoint: {
                    index: endIndex
                }
            }, content.substring(startIndex, endIndex));
        } else {
            const startIndex = textRange.startPoint.index;
            const endIndex = item.startIndex + item.content.length;
            onTextRangeSelected?.({
                startPoint: {
                    index: startIndex
                },
                endPoint: {
                    index: endIndex
                }
            }, content.substring(startIndex, endIndex));
        }
    }, [
        onTextRangeSelected,
        textRange,
        content
    ]);
    let splitContent = null;
    if (displayType !== "textOnly") {
        let currentIndex = 0;
        splitContent = content.split(/([^a-zA-Z0-9'’]+)/).map((content)=>{
            const isWord = /[a-zA-Z0-9]+['’]*[a-zA-Z0-9]*/.test(content);
            const startIndex = currentIndex;
            currentIndex += content.length;
            return {
                startIndex: startIndex,
                content: content,
                isWord: isWord,
                inTextRange: $ee42914c60200b71$var$checkInTextRange(startIndex, textRange, hoveredIndex)
            };
        });
    }
    const handleClick = (0, $g5BLJ.useCallback)((clickEvent)=>{
        if (!clickEvent.target) return;
        const elem = clickEvent.target;
        const item = $ee42914c60200b71$var$parseSpanElement(elem);
        if (displayType === "setVocabWord" && item.isWord && setVocabWord) setVocabWord(item.content);
        else if (displayType === "dictionary" || displayType === "setTextRange" && !enableTextRangeSelection) {
            if (item.isWord) {
                const lowerContent = item.content.toLowerCase();
                const clickedVocabWord = vocabTaskDetailsList?.find((td)=>td.task.customWord.toLowerCase() === lowerContent || td.word?.content?.toLowerCase() === lowerContent);
                if (clickedVocabWord) setOpenedVocabWord(clickedVocabWord);
                else if (languageCodeDetails?.dictionaryEnabled) searchDictionary(lowerContent);
            }
        } else if (displayType === "setTextRange") {
            if (!canSetTextRange) return;
            if (item.isWord) setTextRange(item);
        }
    }, [
        searchDictionary,
        displayType,
        setTextRange,
        vocabTaskDetailsList,
        setOpenedVocabWord,
        canSetTextRange,
        setVocabWord,
        languageCodeDetails,
        enableTextRangeSelection
    ]);
    const handleMouseOver = (0, $g5BLJ.useCallback)((event)=>{
        if (!canSetTextRange || typeof textRange.startPoint.index !== "number" || typeof textRange.endPoint.index === "number") return;
        if (!event.target) return;
        const elem = event.target;
        const item = $ee42914c60200b71$var$parseSpanElement(elem);
        if (item.isWord && item.startIndex !== hoveredIndex) setHoveredIndex(item.startIndex);
    }, [
        hoveredIndex,
        canSetTextRange,
        textRange
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $663e996bc3c0fcdd$export$7f86637430bae410), {
        loading: loading,
        errored: errored,
        drawerOpen: drawerOpen,
        onClick: handleClick,
        onMouseOver: handleMouseOver,
        compactLayout: compactLayout,
        children: [
            displayType !== "textOnly" && splitContent ? splitContent.map((item, i)=>{
                const lowerContent = item.content.toLowerCase();
                const highlightWord = lowerContent === highlightedWord?.toLowerCase() || vocabTaskDetailsList?.some((vt)=>vt.task.customWord.toLowerCase() === lowerContent || vt.word?.content.toLowerCase() === lowerContent);
                const bgcolor = highlightWord ? "#f9c642" : "transparent";
                // This is a native span element because there may be many thousands of these
                // on screen and optimizations demand simpler elements.
                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {
                    "data-elem-type": item.isWord ? "word" : "other",
                    "data-start-index": item.startIndex,
                    style: {
                        fontSize: `${textSize || (0, $75cd274e63beb59b$export$74d9cec7d2c95116)}px`,
                        whiteSpace: "pre-wrap",
                        cursor: "pointer",
                        color: item.inTextRange || !textRange || displayType === "dictionary" || displayType === "setVocabWord" ? (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex,
                        backgroundColor: bgcolor,
                        padding: highlightWord ? (0, $8259eb090983b778$export$ea413736286a3bf1).half : (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).half
                    },
                    children: item.content
                }, i);
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                sizeOverride: textSize || (0, $75cd274e63beb59b$export$74d9cec7d2c95116),
                whiteSpace: "pre-wrap",
                children: content
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $64f69cfb05c6e0a4$export$d71b1ece068cd974), {}),
            openedVocabWord && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2dee512fbabf1618$export$55b733b0e3e0b1be), {
                taskDetails: openedVocabWord,
                close: ()=>setOpenedVocabWord(undefined),
                compactLayout: compactLayout || false
            })
        ]
    });
};
const $ee42914c60200b71$export$3df8925a20fc7cae = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo($ee42914c60200b71$var$UnmemoizedPlainTextReader);












const $9eb4c76372bd8ce8$var$getRadius = (type, size)=>{
    if (type === "round") return "rounded";
    if (size === "normal" || size === "slightlyLarge") return "2";
    return "4";
};
const $9eb4c76372bd8ce8$var$sizes = {
    normal: (0, $18ffa0398cff6303$export$66be51d536890fa7)[8],
    slightlyLarge: (0, $18ffa0398cff6303$export$66be51d536890fa7)[9],
    large: (0, $18ffa0398cff6303$export$66be51d536890fa7)[12],
    extraLarge: "90px"
};
const $9eb4c76372bd8ce8$var$BaseAvatarStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "BaseAvatar__BaseAvatarStyles",
    componentId: "sc-s9pc2u-0"
})([
    "display:grid;align-items:center;justify-content:center;background:",
    ";height:",
    ";width:",
    ";border-radius:",
    ";user-select:none;&:hover{background:",
    ";}"
], ({ $backgroundColor: $backgroundColor  })=>$backgroundColor, ({ $size: $size  })=>$9eb4c76372bd8ce8$var$sizes[$size], ({ $size: $size  })=>$9eb4c76372bd8ce8$var$sizes[$size], ({ $radiusType: $radiusType , $size: $size  })=>(0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[$9eb4c76372bd8ce8$var$getRadius($radiusType, $size)], ({ $backgroundColor: $backgroundColor  })=>(0, $24b764039c44d1ec$export$4b073707ff63303)($backgroundColor, 10));
const $9eb4c76372bd8ce8$export$7ea8120a9a9e6a18 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).img.withConfig({
    displayName: "BaseAvatar__BaseProfilePicture",
    componentId: "sc-s9pc2u-1"
})([
    "height:",
    ";width:",
    ";object-fit:cover;border-radius:",
    ";user-select:none;"
], ({ $height: $height  })=>$height, ({ $width: $width  })=>$width, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded);
const $9eb4c76372bd8ce8$var$getAcronym = (name, overflow)=>{
    if (overflow) return `${name}`;
    const [first, ...rest] = name.split(" ").filter(Boolean);
    if (first && rest.length > 0) {
        const firstChar = rest[0]?.charAt(0);
        if (firstChar) return `${first[0]}${firstChar}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
};
const $9eb4c76372bd8ce8$var$getTextSize = (size)=>{
    switch(size){
        case "extraLarge":
            return "h1";
        case "large":
            return "h5";
        case "normal":
        default:
            return "h7";
    }
};
const $9eb4c76372bd8ce8$export$2dbb3732372a3bc8 = ({ name: name , nameList: nameList , backgroundColor: backgroundColor , size: size = "normal" , textColor: textColor = "white" , radiusType: radiusType , disabledTooltip: disabledTooltip = false , overflow: overflow = false , testTag: testTag , user: user , showAvatar: showAvatar = false , imageUrl: imageUrl = null  })=>{
    const textSize = $9eb4c76372bd8ce8$var$getTextSize(size);
    const formattedNames = nameList?.join(", ");
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: overflow ? formattedNames : name,
        disabled: disabledTooltip,
        children: showAvatar && user ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b22773065c4c76be$export$7334e79c2ba625e7), {
            kind: "profile",
            user: user
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($9eb4c76372bd8ce8$var$BaseAvatarStyles, {
            $size: size,
            $backgroundColor: backgroundColor,
            $radiusType: radiusType,
            children: imageUrl ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($9eb4c76372bd8ce8$export$7ea8120a9a9e6a18, {
                "data-test-tag": "top-profile-picture",
                $height: "30px",
                $width: "30px",
                src: imageUrl
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                lineHeightOverride: "100%",
                color: textColor,
                variant: textSize,
                weightOverride: "semibold",
                testTag: testTag,
                children: $9eb4c76372bd8ce8$var$getAcronym(name, overflow)
            })
        })
    });
};
const $9eb4c76372bd8ce8$export$e3b3c301f3d5fc3d = ({ size: size = "normal" , radiusType: radiusType , ...buttonProps })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        ...buttonProps,
        icon: "plus",
        displayType: "iconOnly",
        iconColor: "primaryBlue",
        color: "lightBlue",
        width: $9eb4c76372bd8ce8$var$sizes[size],
        height: $9eb4c76372bd8ce8$var$sizes[size],
        borderRadiusOverride: $9eb4c76372bd8ce8$var$getRadius(radiusType, size)
    });
};


const $15861ad172906a95$export$d0fa4d83f877a210 = (props)=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9eb4c76372bd8ce8$export$2dbb3732372a3bc8), {
        ...props,
        radiusType: "mostlyRound",
        textColor: "white"
    });
};




const $c2bde156fbc0eb06$export$6c0524ba53950d9f = (props)=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9eb4c76372bd8ce8$export$2dbb3732372a3bc8), {
        ...props,
        radiusType: "round",
        textColor: props.overflow ? "white" : "black"
    });
};







const $e03e507529e9b7f0$export$1d6c1feb46596a6f = ({ avatar: avatar , primaryText: primaryText , secondaryText: secondaryText , textColor: textColor = "black" , secondaryTextColor: secondaryTextColor = "gray5" , testTag: testTag , tooltip: tooltip  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            avatar,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: tooltip,
                        display: "block",
                        disabled: !tooltip,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: textColor,
                            variant: "h6",
                            testTag: testTag,
                            children: primaryText
                        })
                    }),
                    secondaryText && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h7",
                        color: secondaryTextColor,
                        children: secondaryText
                    })
                ]
            })
        ]
    });






var $g5BLJ = parcelRequire("g5BLJ");


const $d5c80744df37e284$export$5e6afd1881cf511 = ({ scopeKey: scopeKey , successUrl: successUrl , history: history , userAttributes: userAttributes , fetchJson: fetchJson , forceOauth: forceOauth = false  })=>{
    fetchJson(`/api/google_oauths/create_link`, {
        method: "POST",
        data: {
            ...userAttributes,
            scopeKey: scopeKey,
            successUrl: successUrl
        },
        onSuccess: (data)=>{
            if (data.alreadyValid && !forceOauth) history.push(successUrl);
            else window.location.href = data.authUrl;
        }
    });
};



const $c8a864413785e08a$export$dc1434c1a71d39bc = ({ scopeKey: scopeKey = "default" , children: children = "Login with Google" , successUrl: successUrl = "/" , userAttributes: userAttributes = {} , forceOauth: forceOauth = false  })=>{
    const [loading, setLoading] = (0, $g5BLJ.useState)(false);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const onClick = (0, $g5BLJ.useCallback)(()=>{
        setLoading(true);
        (0, $d5c80744df37e284$export$5e6afd1881cf511)({
            scopeKey: scopeKey,
            successUrl: successUrl,
            history: history,
            userAttributes: userAttributes,
            fetchJson: fetchJson,
            forceOauth: forceOauth
        });
    }, [
        scopeKey,
        successUrl,
        history,
        userAttributes,
        fetchJson,
        forceOauth
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        color: "black",
        borderColorOverride: "gray5",
        displayType: "outline",
        onClick: onClick,
        loading: loading,
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f68f5c84230354d9$export$646ed93d2b98e357), {
                lms: "Google"
            }),
            children
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");
var $71e8849bfc9a21c0$exports = {};
"use strict";
Object.defineProperty($71e8849bfc9a21c0$exports, "__esModule", {
    value: true
});

var $g5BLJ = parcelRequire("g5BLJ");
var $bc150aac5f91fd36$var$t = function() {
    return $bc150aac5f91fd36$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $bc150aac5f91fd36$var$t.apply(this, arguments);
}, $bc150aac5f91fd36$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.6.2", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $bc150aac5f91fd36$var$t($bc150aac5f91fd36$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


function $71e8849bfc9a21c0$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $71e8849bfc9a21c0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $71e8849bfc9a21c0$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $71e8849bfc9a21c0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $71e8849bfc9a21c0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $71e8849bfc9a21c0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $71e8849bfc9a21c0$var$_defineProperty(obj, key, value) {
    key = $71e8849bfc9a21c0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71e8849bfc9a21c0$var$_extends() {
    $71e8849bfc9a21c0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71e8849bfc9a21c0$var$_extends.apply(this, arguments);
}
function $71e8849bfc9a21c0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $71e8849bfc9a21c0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $71e8849bfc9a21c0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $71e8849bfc9a21c0$var$_slicedToArray(arr, i) {
    return $71e8849bfc9a21c0$var$_arrayWithHoles(arr) || $71e8849bfc9a21c0$var$_iterableToArrayLimit(arr, i) || $71e8849bfc9a21c0$var$_unsupportedIterableToArray(arr, i) || $71e8849bfc9a21c0$var$_nonIterableRest();
}
function $71e8849bfc9a21c0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $71e8849bfc9a21c0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $71e8849bfc9a21c0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $71e8849bfc9a21c0$var$_arrayLikeToArray(o, minLen);
}
function $71e8849bfc9a21c0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $71e8849bfc9a21c0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $71e8849bfc9a21c0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $71e8849bfc9a21c0$var$_toPropertyKey(arg) {
    var key = $71e8849bfc9a21c0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
/**
 * Silence SSR Warnings.
 * Borrowed from Formik v2.1.1, Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */ var $71e8849bfc9a21c0$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? $g5BLJ.useLayoutEffect : $g5BLJ.useEffect;
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Create a stable reference to a callback which is updated after each render is committed.
 * Typed version borrowed from Formik v2.2.1. Licensed MIT.
 *
 * https://github.com/formium/formik/blob/9316a864478f8fcd4fa99a0735b1d37afdf507dc/LICENSE
 */ function $71e8849bfc9a21c0$var$useEventCallback(fn) {
    var ref = $g5BLJ.useRef(fn);
    // we copy a ref to the callback scoped to the current state/props on each render
    $71e8849bfc9a21c0$var$useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return $g5BLJ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
var $71e8849bfc9a21c0$var$createCountUpInstance = function createCountUpInstance(el, props) {
    var decimal = props.decimal, decimals = props.decimals, duration = props.duration, easingFn = props.easingFn, end = props.end, formattingFn = props.formattingFn, numerals = props.numerals, prefix = props.prefix, separator = props.separator, start = props.start, suffix = props.suffix, useEasing = props.useEasing, useGrouping = props.useGrouping, useIndianSeparators = props.useIndianSeparators, enableScrollSpy = props.enableScrollSpy, scrollSpyDelay = props.scrollSpyDelay, scrollSpyOnce = props.scrollSpyOnce;
    return new $bc150aac5f91fd36$export$1567cc001e3d0c1d(el, end, {
        startVal: start,
        duration: duration,
        decimal: decimal,
        decimalPlaces: decimals,
        easingFn: easingFn,
        formattingFn: formattingFn,
        numerals: numerals,
        separator: separator,
        prefix: prefix,
        suffix: suffix,
        useEasing: useEasing,
        useIndianSeparators: useIndianSeparators,
        useGrouping: useGrouping,
        enableScrollSpy: enableScrollSpy,
        scrollSpyDelay: scrollSpyDelay,
        scrollSpyOnce: scrollSpyOnce
    });
};
var $71e8849bfc9a21c0$var$_excluded$1 = [
    "ref",
    "startOnMount",
    "enableReinitialize",
    "delay",
    "onEnd",
    "onStart",
    "onPauseResume",
    "onReset",
    "onUpdate"
];
var $71e8849bfc9a21c0$var$DEFAULTS = {
    decimal: ".",
    separator: ",",
    delay: null,
    prefix: "",
    suffix: "",
    duration: 2,
    start: 0,
    decimals: 0,
    startOnMount: true,
    enableReinitialize: true,
    useEasing: true,
    useGrouping: true,
    useIndianSeparators: false
};
var $71e8849bfc9a21c0$var$useCountUp = function useCountUp(props) {
    var filteredProps = Object.fromEntries(Object.entries(props).filter(function(_ref) {
        var _ref2 = $71e8849bfc9a21c0$var$_slicedToArray(_ref, 2), value = _ref2[1];
        return value !== undefined;
    }));
    var _useMemo = $g5BLJ.useMemo(function() {
        return $71e8849bfc9a21c0$var$_objectSpread2($71e8849bfc9a21c0$var$_objectSpread2({}, $71e8849bfc9a21c0$var$DEFAULTS), filteredProps);
    }, [
        props
    ]), ref = _useMemo.ref, startOnMount = _useMemo.startOnMount, enableReinitialize = _useMemo.enableReinitialize, delay = _useMemo.delay, onEnd = _useMemo.onEnd, onStart = _useMemo.onStart, onPauseResume = _useMemo.onPauseResume, onReset = _useMemo.onReset, onUpdate = _useMemo.onUpdate, instanceProps = $71e8849bfc9a21c0$var$_objectWithoutProperties(_useMemo, $71e8849bfc9a21c0$var$_excluded$1);
    var countUpRef = $g5BLJ.useRef();
    var timerRef = $g5BLJ.useRef();
    var isInitializedRef = $g5BLJ.useRef(false);
    var createInstance = $71e8849bfc9a21c0$var$useEventCallback(function() {
        return $71e8849bfc9a21c0$var$createCountUpInstance(typeof ref === "string" ? ref : ref.current, instanceProps);
    });
    var getCountUp = $71e8849bfc9a21c0$var$useEventCallback(function(recreate) {
        var countUp = countUpRef.current;
        if (countUp && !recreate) return countUp;
        var newCountUp = createInstance();
        countUpRef.current = newCountUp;
        return newCountUp;
    });
    var start = $71e8849bfc9a21c0$var$useEventCallback(function() {
        var run = function run() {
            return getCountUp(true).start(function() {
                onEnd === null || onEnd === void 0 || onEnd({
                    pauseResume: pauseResume,
                    reset: reset,
                    start: restart,
                    update: update
                });
            });
        };
        if (delay && delay > 0) timerRef.current = setTimeout(run, delay * 1000);
        else run();
        onStart === null || onStart === void 0 || onStart({
            pauseResume: pauseResume,
            reset: reset,
            update: update
        });
    });
    var pauseResume = $71e8849bfc9a21c0$var$useEventCallback(function() {
        getCountUp().pauseResume();
        onPauseResume === null || onPauseResume === void 0 || onPauseResume({
            reset: reset,
            start: restart,
            update: update
        });
    });
    var reset = $71e8849bfc9a21c0$var$useEventCallback(function() {
        // Quick fix for https://github.com/glennreyes/react-countup/issues/736 - should be investigated
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (getCountUp().el) {
            timerRef.current && clearTimeout(timerRef.current);
            getCountUp().reset();
            onReset === null || onReset === void 0 || onReset({
                pauseResume: pauseResume,
                start: restart,
                update: update
            });
        }
    });
    var update = $71e8849bfc9a21c0$var$useEventCallback(function(newEnd) {
        getCountUp().update(newEnd);
        onUpdate === null || onUpdate === void 0 || onUpdate({
            pauseResume: pauseResume,
            reset: reset,
            start: restart
        });
    });
    var restart = $71e8849bfc9a21c0$var$useEventCallback(function() {
        reset();
        start();
    });
    var maybeInitialize = $71e8849bfc9a21c0$var$useEventCallback(function(shouldReset) {
        if (startOnMount) {
            if (shouldReset) reset();
            start();
        }
    });
    $g5BLJ.useEffect(function() {
        if (!isInitializedRef.current) {
            isInitializedRef.current = true;
            maybeInitialize();
        } else if (enableReinitialize) maybeInitialize(true);
    }, [
        enableReinitialize,
        isInitializedRef,
        maybeInitialize,
        delay,
        props.start,
        props.suffix,
        props.prefix,
        props.duration,
        props.separator,
        props.decimals,
        props.decimal,
        props.formattingFn
    ]);
    $g5BLJ.useEffect(function() {
        return function() {
            reset();
        };
    }, [
        reset
    ]);
    return {
        start: restart,
        pauseResume: pauseResume,
        reset: reset,
        update: update,
        getCountUp: getCountUp
    };
};
var $71e8849bfc9a21c0$var$_excluded = [
    "className",
    "redraw",
    "containerProps",
    "children",
    "style"
];
var $71e8849bfc9a21c0$var$CountUp = function CountUp(props) {
    var className = props.className, redraw = props.redraw, containerProps = props.containerProps, children = props.children, style = props.style, useCountUpProps = $71e8849bfc9a21c0$var$_objectWithoutProperties(props, $71e8849bfc9a21c0$var$_excluded);
    var containerRef = $g5BLJ.useRef(null);
    var isInitializedRef = $g5BLJ.useRef(false);
    var _useCountUp = $71e8849bfc9a21c0$var$useCountUp($71e8849bfc9a21c0$var$_objectSpread2($71e8849bfc9a21c0$var$_objectSpread2({}, useCountUpProps), {}, {
        ref: containerRef,
        startOnMount: typeof children !== "function" || props.delay === 0,
        // component manually restarts
        enableReinitialize: false
    })), start = _useCountUp.start, reset = _useCountUp.reset, updateCountUp = _useCountUp.update, pauseResume = _useCountUp.pauseResume, getCountUp = _useCountUp.getCountUp;
    var restart = $71e8849bfc9a21c0$var$useEventCallback(function() {
        start();
    });
    var update = $71e8849bfc9a21c0$var$useEventCallback(function(end) {
        if (!props.preserveValue) reset();
        updateCountUp(end);
    });
    var initializeOnMount = $71e8849bfc9a21c0$var$useEventCallback(function() {
        if (typeof props.children === "function") // Warn when user didn't use containerRef at all
        {
            if (!(containerRef.current instanceof Element)) {
                console.error('Couldn\'t find attached element to hook the CountUp instance into! Try to attach "containerRef" from the render prop to a an Element, eg. <span ref={containerRef} />.');
                return;
            }
        }
        // unlike the hook, the CountUp component initializes on mount
        getCountUp();
    });
    $g5BLJ.useEffect(function() {
        initializeOnMount();
    }, [
        initializeOnMount
    ]);
    $g5BLJ.useEffect(function() {
        if (isInitializedRef.current) update(props.end);
    }, [
        props.end,
        update
    ]);
    var redrawDependencies = redraw && props;
    // if props.redraw, call this effect on every props change
    $g5BLJ.useEffect(function() {
        if (redraw && isInitializedRef.current) restart();
    }, [
        restart,
        redraw,
        redrawDependencies
    ]);
    // if not props.redraw, call this effect only when certain props are changed
    $g5BLJ.useEffect(function() {
        if (!redraw && isInitializedRef.current) restart();
    }, [
        restart,
        redraw,
        props.start,
        props.suffix,
        props.prefix,
        props.duration,
        props.separator,
        props.decimals,
        props.decimal,
        props.className,
        props.formattingFn
    ]);
    $g5BLJ.useEffect(function() {
        isInitializedRef.current = true;
    }, []);
    if (typeof children === "function") // TypeScript forces functional components to return JSX.Element | null.
    return children({
        countUpRef: containerRef,
        start: start,
        reset: reset,
        update: updateCountUp,
        pauseResume: pauseResume,
        getCountUp: getCountUp
    });
    return /*#__PURE__*/ $g5BLJ.createElement("span", $71e8849bfc9a21c0$var$_extends({
        className: className,
        ref: containerRef,
        style: style
    }, containerProps), typeof props.start !== "undefined" ? getCountUp().formattingFn(props.start) : "");
};
$71e8849bfc9a21c0$exports.default = $71e8849bfc9a21c0$var$CountUp;
$71e8849bfc9a21c0$exports.useCountUp = $71e8849bfc9a21c0$var$useCountUp;


const $9ce31e4f950f6dfa$export$e904ddd26e22235f = ({ value: value , duration: duration = 1.5  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($71e8849bfc9a21c0$exports))), {
        end: value,
        duration: duration,
        formattingFn: (v)=>v.toLocaleString("en-US")
    });
};
const $9ce31e4f950f6dfa$export$1567cc001e3d0c1d = /*#__PURE__*/ (0, $g5BLJ.memo)($9ce31e4f950f6dfa$export$e904ddd26e22235f);







const $5a746d7ba2cd2a5b$var$getPositionCss = (pos)=>{
    if (pos === "up") return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "width:24px;height:12px;top:100%;left:50%;transform:translate(-50%,0%);padding:0 50px;"
    ]);
    else if (pos === "down") return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "bottom:100%;left:50%;width:24px;height:12px;transform:translate(-50%,0%);padding:0 50px;"
    ]);
    else if (pos === "left") return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "left:100%;top:50%;width:12px;height:24px;transform:translate(0,-50%);padding:50px 0;"
    ]);
    else return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "right:100%;top:50%;width:12px;height:24px;transform:translate(0,-50%);padding:50px 0;"
    ]);
};
const $5a746d7ba2cd2a5b$var$getPseudoCss = (direction)=>{
    if (direction === "up") return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "left:50%;transform:translate(-50%,50%) rotate(45deg);"
    ]);
    else if (direction === "down") return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "left:50%;transform:translate(-50%,-50%) rotate(45deg);"
    ]);
    else if (direction === "left") return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "left:100%;top:50%;transform:translate(-50%,-50%) rotate(-45deg);"
    ]);
    else return (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "right:100%;top:50%;transform:translate(50%,-50%) rotate(-45deg);"
    ]);
};
const $5a746d7ba2cd2a5b$var$opposites = {
    up: "down",
    down: "up",
    left: "right",
    right: "left"
};
const $5a746d7ba2cd2a5b$export$b3e2dbef906ff421 = (pos)=>{
    return $5a746d7ba2cd2a5b$var$opposites[pos];
};
const $5a746d7ba2cd2a5b$export$268a2e5c07677246 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Arrow__BaseArrow",
    componentId: "sc-141o0pf-0"
})([
    "position:absolute;overflow:hidden;",
    " &::after{content:'';position:absolute;width:12px;height:12px;background-color:",
    ";box-shadow:0 0 8px -2px rgb(0 0 0 / 50%);border-radius:2px;",
    "}"
], ({ $position: $position  })=>$5a746d7ba2cd2a5b$var$getPositionCss($position), (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $direction: $direction  })=>$5a746d7ba2cd2a5b$var$getPseudoCss($direction));
const $5a746d7ba2cd2a5b$export$21b07c8f274aebd5 = ({ direction: direction , size: size , color: color , position: position  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($5a746d7ba2cd2a5b$export$268a2e5c07677246, {
        $direction: direction,
        $size: size,
        $color: color,
        $position: position
    });
};




const $7cc97c59f534605a$export$221a5fbe6bef8a05 = ({ children: children , onLeftClick: onLeftClick , onRightClick: onRightClick , leftDisabled: leftDisabled , rightDisabled: rightDisabled  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: onLeftClick,
                icon: "backArrow",
                displayType: "iconOnly",
                iconColor: leftDisabled ? "gray6" : "black",
                color: "gray1",
                height: "46px",
                width: "46px",
                disabled: leftDisabled
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4,
                horizontal: true
            }),
            children,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4,
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: onRightClick,
                icon: "forwardArrow",
                displayType: "iconOnly",
                iconColor: rightDisabled ? "gray6" : "black",
                color: "gray1",
                height: "46px",
                width: "46px",
                disabled: rightDisabled
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");

const $ea53b83fae57f249$export$23a69314da92e79b = ({ successUrl: successUrl , history: history , userAttributes: userAttributes , fetchJson: fetchJson , forceOauth: forceOauth = false  })=>{
    fetchJson(`/api/clever_oauths/create_link`, {
        method: "POST",
        data: {
            ...userAttributes,
            successUrl: successUrl
        },
        onSuccess: (data)=>{
            if (data.alreadyValid && !forceOauth) history.push(successUrl);
            else window.location.href = data.authUrl;
        }
    });
};




const $6b95aaca78d83e60$export$800b563f63fbe24a = ({ children: children = "Login with Clever" , successUrl: successUrl = "/" , userAttributes: userAttributes = {} , forceOauth: forceOauth = false  })=>{
    const [loading, setLoading] = (0, $g5BLJ.useState)(false);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const onClick = (0, $g5BLJ.useCallback)(()=>{
        setLoading(true);
        (0, $ea53b83fae57f249$export$23a69314da92e79b)({
            successUrl: successUrl,
            history: history,
            userAttributes: userAttributes,
            fetchJson: fetchJson,
            forceOauth: forceOauth
        });
    }, [
        successUrl,
        history,
        userAttributes,
        fetchJson,
        forceOauth
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        color: "black",
        displayType: "outline",
        borderColorOverride: "gray5",
        onClick: onClick,
        loading: loading,
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f68f5c84230354d9$export$646ed93d2b98e357), {
                lms: "Clever"
            }),
            children
        ]
    });
};







var $g5BLJ = parcelRequire("g5BLJ");







const $7026505adadcfc0e$var$LOCAL_STORAGE_TEST_KEY = "LOCAL_STORAGE_TEST_KEY";
const $7026505adadcfc0e$var$LOCAL_STORAGE_TEST_VALUE = "LOCAL_STORAGE_TEST_VALUE";
// Sometimes the browser does not allow access to localStorage, check to see
// if it's working
const $7026505adadcfc0e$var$checkLocalStorage = ()=>{
    try {
        localStorage.setItem($7026505adadcfc0e$var$LOCAL_STORAGE_TEST_KEY, $7026505adadcfc0e$var$LOCAL_STORAGE_TEST_VALUE);
        const value = localStorage.getItem($7026505adadcfc0e$var$LOCAL_STORAGE_TEST_KEY);
        localStorage.removeItem($7026505adadcfc0e$var$LOCAL_STORAGE_TEST_KEY);
        return value === $7026505adadcfc0e$var$LOCAL_STORAGE_TEST_VALUE;
    } catch (e) {
        return false;
    }
};
let $7026505adadcfc0e$var$localStorageChecked = false;
let $7026505adadcfc0e$var$localStorageWorking = false;
const $7026505adadcfc0e$var$getMemoryStorage = ()=>{
    const map = new Map();
    return {
        setItem: (key, value)=>{
            map.set(key, value);
        },
        getItem: (key)=>{
            return map.get(key);
        },
        removeItem: (key)=>{
            map.delete(key);
        }
    };
};
const $7026505adadcfc0e$var$memoryStorage = $7026505adadcfc0e$var$getMemoryStorage();
const $7026505adadcfc0e$var$getStorage = ()=>{
    if (!$7026505adadcfc0e$var$localStorageChecked) {
        $7026505adadcfc0e$var$localStorageWorking = $7026505adadcfc0e$var$checkLocalStorage();
        $7026505adadcfc0e$var$localStorageChecked = true;
    }
    if ($7026505adadcfc0e$var$localStorageWorking) return localStorage;
    else return $7026505adadcfc0e$var$memoryStorage;
};
const $7026505adadcfc0e$export$8a8216c44337cd5 = (key, value)=>{
    return $7026505adadcfc0e$var$getStorage().setItem(key, value);
};
const $7026505adadcfc0e$export$f92dfeb71e9bb569 = (key)=>{
    return $7026505adadcfc0e$var$getStorage().getItem(key);
};
const $7026505adadcfc0e$export$fe2d9b4e03920b4c = (key)=>{
    return $7026505adadcfc0e$var$getStorage().removeItem(key);
};


var $41ca9d84833422ae$exports = {};

$41ca9d84833422ae$exports = new URL((parcelRequire("3TfdU")).resolve("9RUyW"), import.meta.url).toString();


/// #endif
const $c1fa64c16b04d0e5$var$DATA_INTERVAL_SECONDS = (0, $73b0620564a5efc3$export$46533eaa5c2063c0);
const $c1fa64c16b04d0e5$var$RECORDING_DATA_INTERVAL = (0, $73b0620564a5efc3$export$b4c0c30d7f4e2691) * $c1fa64c16b04d0e5$var$DATA_INTERVAL_SECONDS;
const $c1fa64c16b04d0e5$export$80670e9bc195d6e3 = [
    0,
    100,
    1000,
    10000
];
const $c1fa64c16b04d0e5$export$f50cb32cd0c08c57 = $c1fa64c16b04d0e5$var$DATA_INTERVAL_SECONDS;
let $c1fa64c16b04d0e5$var$microphoneDeviceId = undefined;
let $c1fa64c16b04d0e5$var$microphoneDeviceIdFetched = false;
const $c1fa64c16b04d0e5$export$b54d4e79c2e8d9be = ()=>{
    if ($c1fa64c16b04d0e5$var$microphoneDeviceIdFetched) return $c1fa64c16b04d0e5$var$microphoneDeviceId;
    $c1fa64c16b04d0e5$var$microphoneDeviceId = $7026505adadcfc0e$export$f92dfeb71e9bb569("selectedMicrophoneDeviceId") ?? undefined;
    $c1fa64c16b04d0e5$var$microphoneDeviceIdFetched = true;
    return $c1fa64c16b04d0e5$var$microphoneDeviceId;
};
const $c1fa64c16b04d0e5$export$fe212e19a2cce390 = (value)=>{
    $c1fa64c16b04d0e5$var$microphoneDeviceId = value;
    $c1fa64c16b04d0e5$var$microphoneDeviceIdFetched = true;
    $7026505adadcfc0e$export$8a8216c44337cd5("selectedMicrophoneDeviceId", value);
};
const $c1fa64c16b04d0e5$export$2733ac1dd963ac73 = async ()=>{
    const currentMic = $c1fa64c16b04d0e5$export$b54d4e79c2e8d9be();
    const audioOptions = currentMic ? {
        deviceId: $c1fa64c16b04d0e5$export$b54d4e79c2e8d9be()
    } : {
        audio: true
    };
    const mediaStream = await navigator.mediaDevices.getUserMedia({
        audio: audioOptions
    });
    return mediaStream;
};
const $c1fa64c16b04d0e5$export$576d9c895f1ac7e6 = async ()=>{
    if (!(typeof MediaRecorder !== "undefined" && typeof MediaStream !== "undefined" && navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) return "unsupported";
    try {
        const mediaStream = await $c1fa64c16b04d0e5$export$2733ac1dd963ac73();
        $c1fa64c16b04d0e5$export$4ba141db3233526e(mediaStream);
        return "granted";
    } catch (err) {
        return "failed";
    }
};
const $c1fa64c16b04d0e5$export$ef74f01a8ec6e3a5 = {
    mediaType: "audio",
    contentType: "webm",
    codec: null,
    mimeType: "audio/webm"
};
const $c1fa64c16b04d0e5$var$ORDERED_AUDIO_MIME_TYPE_DETAILS = [
    $c1fa64c16b04d0e5$export$ef74f01a8ec6e3a5,
    {
        mediaType: "audio",
        contentType: "mp4",
        codec: null,
        mimeType: "audio/mp4"
    }
];
const $c1fa64c16b04d0e5$export$9be9afda50c84681 = async ({ onDataAvailable: onDataAvailable , onStop: onStop , onVolumeLevel: onVolumeLevel , onStart: onStart  })=>{
    const mimeTypeDetails = $c1fa64c16b04d0e5$var$ORDERED_AUDIO_MIME_TYPE_DETAILS.find((mtd)=>MediaRecorder.isTypeSupported(mtd.mimeType));
    if (!mimeTypeDetails) {
        const supportedMimeTypes = (0, $cd425c641c724592$export$3a0ce4ea5a7dfe10)("audio");
        const error = new (0, $cd425c641c724592$export$50b6c389561e7490)(`Unable to find a mime type that works on this machine. See metadata to see what this machine appears to be able to support.`, supportedMimeTypes);
        (0, $1ce946abade47122$export$b33b857ad1d9900e)(error);
        return null;
    }
    let mediaStream = null;
    try {
        mediaStream = await $c1fa64c16b04d0e5$export$2733ac1dd963ac73();
    } catch (error) {
        (0, $1ce946abade47122$export$b33b857ad1d9900e)(error);
        return null;
    }
    let trackingVolume = false;
    let audioContext = null;
    let workletNode = null;
    let microphone = null;
    // Hack to deal with storybook's webpack not being able to handle these worklets
    // Parcel does not parse these tags, so any code in these if statements will be
    // included by parcel but ignored by storybook's webpack builder.
    /// #if !STORYBOOK
    try {
        audioContext = new AudioContext();
        await audioContext.audioWorklet.addModule((0, (/*@__PURE__*/$parcel$interopDefault($41ca9d84833422ae$exports))));
        microphone = audioContext.createMediaStreamSource(mediaStream);
        workletNode = new AudioWorkletNode(audioContext, "vumeter");
        workletNode.port.onmessage = (event)=>{
            if (event.data.type === "volume-measurement") onVolumeLevel(event.data);
        };
        microphone.connect(workletNode).connect(audioContext.destination);
        trackingVolume = true;
    } catch (e) {
        // Ignore if we can't set up the volume checker
        (0, $1ce946abade47122$export$b33b857ad1d9900e)(e);
    }
    /// #endif
    const mediaRecorder = new MediaRecorder(mediaStream, {
        mimeType: mimeTypeDetails.mimeType
    });
    mediaRecorder.addEventListener("dataavailable", (event)=>{
        const blob = event.data;
        if (blob.size > 0) onDataAvailable(blob, event);
    });
    mediaRecorder.addEventListener("error", (event)=>{
        (0, $1ce946abade47122$export$b33b857ad1d9900e)(event, {
            state: mediaRecorder.state
        });
    });
    mediaRecorder.addEventListener("stop", (event)=>{
        onStop(event);
        audioContext?.close();
        workletNode?.disconnect();
        microphone?.disconnect();
    });
    mediaRecorder.start($c1fa64c16b04d0e5$var$RECORDING_DATA_INTERVAL);
    if (onStart) onStart();
    return {
        mediaStream: mediaStream,
        mediaRecorder: mediaRecorder,
        mimeTypeDetails: mimeTypeDetails,
        trackingVolume: trackingVolume
    };
};
const $c1fa64c16b04d0e5$export$4ba141db3233526e = (mediaStream)=>{
    mediaStream?.getTracks().forEach((track)=>track.stop());
};
const $c1fa64c16b04d0e5$export$767f50271002f8b6 = ({ mediaRecorder: mediaRecorder , mediaStream: mediaStream  })=>{
    mediaRecorder?.stop();
    $c1fa64c16b04d0e5$export$4ba141db3233526e(mediaStream);
};









const $d13f732dca9f066a$export$1e8300ff22deb189 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MobileRecorder__MobileControlsContainer",
    componentId: "sc-1lbb2rt-0"
})([
    "width:100%;position:absolute;bottom:0;background:",
    ";padding:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[3]);
const $d13f732dca9f066a$export$d980ca5f7658f3cf = ({ audioFile: audioFile , displayType: displayType , status: status , startedAt: startedAt , recordingEndedAt: recordingEndedAt , volumeLevel: volumeLevel , hasJustStarted: hasJustStarted , disabled: disabled , dirty: dirty , recordingSequence: recordingSequence , onSave: onSave , openMicSettings: openMicSettings , startRestart: startRestart , startDeleting: startDeleting , stop: stop , beginRecording: beginRecording  })=>{
    const audioReady = !(status === "not_started" && !audioFile || status === "loading" || status === "processing" || status === "recording");
    const saved = Boolean(audioFile) && (status === "finished" || status === "not_started") && !dirty;
    const doneRecording = audioFile && status !== "recording" && status !== "processing";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$1ed32bb4777eea61), {
        displayType: displayType,
        saved: saved,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($d13f732dca9f066a$export$1e8300ff22deb189, {
            children: [
                saved && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$459e828546a2b677), {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "checkmarkCircle",
                        color: "green",
                        size: "1.5em"
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    align: "center",
                    justify: "center",
                    children: [
                        doneRecording ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                            src: audioFile.url,
                            displayType: displayType,
                            showSkipButtons: false,
                            trackMinWidth: "150px"
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a38793a2bd724173$export$324f12ab8f3589ca), {
                                    $color: status === "recording" ? "danger" : "gray5",
                                    $recording: status === "recording"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 4
                                }),
                                status === "recording" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$1cf1c9b0aa495972), {
                                    startedAt: startedAt,
                                    recordingLength: recordingSequence.duration
                                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "largeText",
                                    testTag: "recording-length",
                                    children: (0, $73b0620564a5efc3$export$74b4d0aec03dadcb)(Math.max(recordingEndedAt.valueOf() - startedAt.valueOf() + recordingSequence.duration, 0))
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 5
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $054b91a79229120e$export$6e618a41e8433cac), {
                                    displayType: "mobile",
                                    volumeLevel: volumeLevel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                            testTag: "audio-recorder-extra-settings",
                            displayType: "noStyles",
                            rightAligned: true,
                            direction: "up",
                            icon: "threeVerticalDots",
                            iconColor: "gray7",
                            mobile: true,
                            options: [
                                {
                                    onClick: openMicSettings,
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                icon: "settings",
                                                size: "1.5em",
                                                fill: true,
                                                strokeWidth: 0
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 2
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h5",
                                                whiteSpace: "nowrap",
                                                children: "Microphone Settings"
                                            })
                                        ]
                                    })
                                },
                                {
                                    onClick: beginRecording,
                                    disabled: !audioReady,
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                icon: "microphone",
                                                size: "1.5em"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 2
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h5",
                                                whiteSpace: "nowrap",
                                                children: "Continue Recording"
                                            })
                                        ]
                                    })
                                },
                                {
                                    onClick: startRestart,
                                    disabled: !audioReady,
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                icon: "redo",
                                                size: "1.5em",
                                                color: audioReady ? "primaryBlue" : "gray5"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 2
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h5",
                                                whiteSpace: "nowrap",
                                                color: audioReady ? "primaryBlue" : "gray5",
                                                children: "Start Over"
                                            })
                                        ]
                                    })
                                },
                                {
                                    onClick: startDeleting,
                                    disabled: !audioReady,
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                icon: "trash",
                                                size: "1.5em",
                                                fill: true,
                                                color: audioReady ? "danger" : "gray5"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 2
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h5",
                                                whiteSpace: "nowrap",
                                                color: audioReady ? "danger" : "gray5",
                                                children: "Delete"
                                            })
                                        ]
                                    })
                                }
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                doneRecording ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    justify: "center",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: beginRecording,
                            loading: status === "loading",
                            activeColor: "white",
                            color: "warning",
                            disabled: disabled,
                            borderRadiusOverride: "10",
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                            flexGrow: 1,
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "microphone",
                                    color: "white",
                                    strokeWidth: 0,
                                    size: "1.25em"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    color: "white",
                                    children: "Continue"
                                })
                            ]
                        }),
                        !saved && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 3
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    onClick: onSave,
                                    loading: status === "loading",
                                    displayType: "outline",
                                    color: "gray4",
                                    disabled: disabled,
                                    borderRadiusOverride: "10",
                                    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                    flexGrow: 1,
                                    testTag: "save-recording",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                            icon: "save",
                                            color: "black",
                                            strokeWidth: 0,
                                            size: "1.25em"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h6",
                                            color: "black",
                                            children: "Save"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                    children: status === "recording" || status === "processing" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                width: "100%",
                                loading: status === "processing",
                                color: "warning",
                                borderRadiusOverride: "10",
                                paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[3],
                                disabled: disabled || hasJustStarted,
                                onClick: stop,
                                testTag: status === "recording" ? "stop-recording-button" : "start-recording-button",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: "pause",
                                        color: "white",
                                        size: "24px"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        color: "white",
                                        children: "Pause"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 17
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        width: "100%",
                        color: "danger",
                        loading: status === "loading",
                        onClick: beginRecording,
                        borderRadiusOverride: "10",
                        testTag: "start-recording-button",
                        disabled: disabled,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: "microphone",
                                strokeWidth: 0,
                                size: "1.15em"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            "Record"
                        ]
                    })
                })
            ]
        })
    });
};






const $4ccb467b13491c27$export$c6c880725c5127f9 = ({ audioFile: audioFile , status: status , startedAt: startedAt , recordingEndedAt: recordingEndedAt , volumeLevel: volumeLevel , hasJustStarted: hasJustStarted , displayType: displayType = "desktop" , disabled: disabled = false , dirty: dirty = false , recordingSequence: recordingSequence , onSave: onSave , openMicSettings: openMicSettings , startRestart: startRestart , startDeleting: startDeleting , stop: stop , beginRecording: beginRecording  })=>{
    const saved = Boolean(audioFile) && (status === "finished" || status === "not_started") && !dirty;
    const doneRecording = audioFile && status !== "recording" && status !== "processing";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$1ed32bb4777eea61), {
        displayType: displayType,
        saved: saved,
        children: doneRecording ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
            src: audioFile.url,
            displayType: displayType,
            showSkipButtons: true,
            trackMinWidth: "80px",
            additionalControls: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: "Continue Recording",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: beginRecording,
                            loading: status === "loading",
                            activeColor: "white",
                            color: "warning",
                            disabled: disabled,
                            borderRadiusOverride: "10",
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                            testTag: "start-recording-button",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: "microphone",
                                color: "white",
                                strokeWidth: 0,
                                size: "1.75em"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    dirty && onSave ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: "Save Recording",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "outline",
                            onClick: onSave,
                            loading: status === "loading",
                            disabled: disabled,
                            color: "gray7",
                            borderRadiusOverride: "10",
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                            testTag: "save-recording",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: "save",
                                color: "black",
                                size: "1.75em"
                            })
                        })
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$6fc3d951b68e69bd), {
                        status: status,
                        audioFile: audioFile,
                        startDeleting: startDeleting,
                        startRestart: startRestart,
                        openMicSettings: openMicSettings
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "space-evenly",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a38793a2bd724173$export$324f12ab8f3589ca), {
                    $color: status === "recording" ? "danger" : "gray5",
                    $recording: status === "recording"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        status === "recording" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$1cf1c9b0aa495972), {
                            startedAt: startedAt,
                            recordingLength: recordingSequence.duration
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "largeText",
                            testTag: "recording-length",
                            children: (0, $73b0620564a5efc3$export$74b4d0aec03dadcb)(Math.max(recordingEndedAt.valueOf() - startedAt.valueOf() + recordingSequence.duration, 0))
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 5
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $054b91a79229120e$export$6e618a41e8433cac), {
                            displayType: "desktopSmall",
                            volumeLevel: volumeLevel
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        }),
                        status === "recording" || status === "processing" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    loading: status === "processing",
                                    color: "warning",
                                    borderRadiusOverride: "10",
                                    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                    disabled: disabled || hasJustStarted,
                                    onClick: stop,
                                    testTag: status === "recording" ? "stop-recording-button" : "start-recording-button",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: "pause",
                                        color: "white",
                                        size: "24px"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 17
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            color: "danger",
                            loading: status === "loading",
                            onClick: beginRecording,
                            disabled: disabled,
                            borderRadiusOverride: "10",
                            testTag: "start-recording-button",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "microphone",
                                    strokeWidth: 0,
                                    size: "1.15em"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                "Record"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$6fc3d951b68e69bd), {
                    status: status,
                    audioFile: audioFile,
                    startDeleting: startDeleting,
                    startRestart: startRestart,
                    openMicSettings: openMicSettings
                })
            ]
        })
    });
};






const $795d937b576f1510$export$3c50855bbde476c8 = ({ audioFile: audioFile , status: status , startedAt: startedAt , recordingEndedAt: recordingEndedAt , volumeLevel: volumeLevel , hasJustStarted: hasJustStarted , displayType: displayType = "desktop" , disabled: disabled = false , dirty: dirty = false , recordingSequence: recordingSequence , onSave: onSave , openMicSettings: openMicSettings , startRestart: startRestart , startDeleting: startDeleting , stop: stop , beginRecording: beginRecording  })=>{
    const saved = Boolean(audioFile) && (status === "finished" || status === "not_started") && !dirty;
    const doneRecording = audioFile && status !== "recording" && status !== "processing";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$1ed32bb4777eea61), {
        displayType: displayType,
        saved: saved,
        children: doneRecording ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
            src: audioFile.url,
            displayType: displayType,
            showSkipButtons: true,
            trackMinWidth: "150px",
            additionalControls: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: "Continue Recording",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: beginRecording,
                            loading: status === "loading",
                            activeColor: "white",
                            color: "warning",
                            disabled: disabled,
                            borderRadiusOverride: "10",
                            paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "microphone",
                                    color: "white",
                                    strokeWidth: 0,
                                    size: "1.15em"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    weightOverride: "bold",
                                    color: "white",
                                    children: "Continue"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    dirty && onSave ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: "Save Recording",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "outline",
                            onClick: onSave,
                            loading: status === "loading",
                            disabled: disabled,
                            color: "gray7",
                            borderRadiusOverride: "10",
                            paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
                            testTag: "save-recording",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "save",
                                    color: "black",
                                    size: "1.15em"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    weightOverride: "bold",
                                    color: "black",
                                    children: "Save"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$6fc3d951b68e69bd), {
                        status: status,
                        audioFile: audioFile,
                        startDeleting: startDeleting,
                        startRestart: startRestart,
                        openMicSettings: openMicSettings
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "space-evenly",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a38793a2bd724173$export$324f12ab8f3589ca), {
                    $color: status === "recording" ? "danger" : "gray5",
                    $recording: status === "recording"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        status === "recording" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$1cf1c9b0aa495972), {
                            startedAt: startedAt,
                            recordingLength: recordingSequence.duration
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "largeText",
                            testTag: "recording-length",
                            children: (0, $73b0620564a5efc3$export$74b4d0aec03dadcb)(Math.max(recordingEndedAt.valueOf() - startedAt.valueOf() + recordingSequence.duration, 0))
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 5
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $054b91a79229120e$export$6e618a41e8433cac), {
                            displayType: "desktop",
                            volumeLevel: volumeLevel
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        }),
                        status === "recording" || status === "processing" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            loading: status === "processing",
                            color: "warning",
                            borderRadiusOverride: "10",
                            paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
                            disabled: disabled || hasJustStarted,
                            onClick: stop,
                            testTag: status === "recording" ? "stop-recording-button" : "start-recording-button",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "pause",
                                    color: "white",
                                    size: "24px"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    weightOverride: "bold",
                                    color: "white",
                                    children: "Pause"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            color: "danger",
                            loading: status === "loading",
                            onClick: beginRecording,
                            borderRadiusOverride: "10",
                            testTag: "start-recording-button",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "microphone",
                                    strokeWidth: 0,
                                    size: "1.15em"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                "Record"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 20
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$6fc3d951b68e69bd), {
                    status: status,
                    audioFile: audioFile,
                    startDeleting: startDeleting,
                    startRestart: startRestart,
                    openMicSettings: openMicSettings
                })
            ]
        })
    });
};




/* stylelint-disable keyframes-name-pattern -- styled components violates this rule and we can't fix it */ const $a38793a2bd724173$var$recording = ({ $color: $color  })=>(0, $f2062e8c5c08e6f7$export$d25ddfdf17c3ad3e)([
        "0%{transform:scale(0.95);box-shadow:0 0 0 0 ",
        ";}70%{transform:scale(1);box-shadow:0 0 0 10px  ",
        ";}100%{transform:scale(0.95);box-shadow:0 0 0 0 ",
        ";}"
    ], (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex, 0.7), (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex, 0), (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex, 0));
const $a38793a2bd724173$export$324f12ab8f3589ca = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "RecordingDot__RecordingStatus",
    componentId: "sc-8j6wr1-0"
})([
    "display:flex;align-items:center;justify-content:center;background:",
    ";border-radius:",
    ";margin:",
    ";height:20px;width:20px;",
    ""
], ({ $color: $color  })=>(0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1], ({ $recording: $recording  })=>$recording && (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "animation-name:",
        ";animation-duration:1.5s;animation-iteration-count:infinite;"
    ], $a38793a2bd724173$var$recording));





const $054b91a79229120e$export$c2efc888eb597627 = 15;
const $054b91a79229120e$export$e73a477ffa3a873 = 12;
const $054b91a79229120e$export$f02f4518f09cf18b = 23;
const $054b91a79229120e$var$getNumBars = (displayType)=>{
    switch(displayType){
        case "desktop":
            return $054b91a79229120e$export$c2efc888eb597627;
        case "desktopSmall":
            return $054b91a79229120e$export$e73a477ffa3a873;
        default:
            return $054b91a79229120e$export$f02f4518f09cf18b;
    }
};
const $054b91a79229120e$var$VolumeTick = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "VolumeMeter__VolumeTick",
    componentId: "sc-1fldbfh-0"
})([
    "width:",
    ";height:15px;border-radius:",
    ";z-index:",
    ";margin-right:4px;"
], (0, $18ffa0398cff6303$export$66be51d536890fa7)[1], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised);
const $054b91a79229120e$export$6e618a41e8433cac = ({ volumeLevel: volumeLevel , displayType: displayType  })=>{
    const numTicks = $054b91a79229120e$var$getNumBars(displayType);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: Array.from({
            length: numTicks
        }).map((_, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($054b91a79229120e$var$VolumeTick, {
                style: {
                    background: volumeLevel > i * (100 / numTicks) ? (0, $24b764039c44d1ec$export$8f45430ccf837300).green.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex
                }
            }, i))
    });
};







/* stylelint-disable keyframes-name-pattern -- styled components violates this rule and we can't fix it */ const $aeea4a93290ff4af$var$FadeAnimation = (0, $f2062e8c5c08e6f7$export$d25ddfdf17c3ad3e)([
    "0%{opacity:0;}15%{opacity:1;}85%{opacity:1;}100%{opacity:0;}"
]);
const $aeea4a93290ff4af$var$Fade = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Countdown__Fade",
    componentId: "sc-1wf5ez5-0"
})([
    "display:",
    ";align-items:center;justify-content:center;background:",
    ";position:fixed;top:0;bottom:0;left:0;right:0;z-index:",
    ";animation-name:",
    ";animation-duration:5.5s;animation-iteration-count:1;"
], ({ $opened: $opened  })=>$opened ? "flex" : "none", (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, 0.5), (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).modal, $aeea4a93290ff4af$var$FadeAnimation);
const $aeea4a93290ff4af$var$CountdownContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Countdown__CountdownContainer",
    componentId: "sc-1wf5ez5-1"
})([
    "display:flex;align-items:center;justify-content:center;height:100px;overflow:hidden;",
    ";"
], ({ $displayType: $displayType  })=>$displayType !== "mobile" && `margin-left: 300px`);
/* stylelint-disable keyframes-name-pattern -- styled components violates this rule and we can't fix it */ const $aeea4a93290ff4af$var$CountdownAnimation = (0, $f2062e8c5c08e6f7$export$d25ddfdf17c3ad3e)([
    "0%{transform:translateY(70%);}20%{transform:translateY(38%);}40%{transform:translateY(13%);}60%{transform:translateY(-12%);}80%{transform:translateY(-37%);}100%{transform:translateY(-37%);}"
]);
const $aeea4a93290ff4af$var$StyledCountdown = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Countdown__StyledCountdown",
    componentId: "sc-1wf5ez5-2"
})([
    "animation-name:",
    ";animation-duration:5.5s;animation-iteration-count:1;animation-timing-function:steps;"
], $aeea4a93290ff4af$var$CountdownAnimation);
const $aeea4a93290ff4af$export$53819c0e58f98d49 = ({ opened: opened = false , displayType: displayType  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($aeea4a93290ff4af$var$Fade, {
        $opened: opened,
        "data-test-tag": "countdown",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($aeea4a93290ff4af$var$CountdownContainer, {
            $displayType: displayType,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($aeea4a93290ff4af$var$StyledCountdown, {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        sizeOverride: 100,
                        color: "white",
                        textAlign: "center",
                        children: "3"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        sizeOverride: 100,
                        color: "white",
                        textAlign: "center",
                        children: "2"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        sizeOverride: 100,
                        color: "white",
                        textAlign: "center",
                        children: "1"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        sizeOverride: 100,
                        color: "white",
                        textAlign: "center",
                        children: "Read!"
                    })
                ]
            })
        })
    });
};



const $b73bb7e0f32bbc6d$export$35b96c5a286f4d3e = (message)=>{
    const isMobileWebviewOpened = window.localStorage.getItem("mobileWebviewOpened");
    if (isMobileWebviewOpened && window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify(message), "*");
};


// Trying to debug safari issues via fullstory
const $d997a72120805c5c$var$log = (...args)=>{
    /* eslint-disable no-console */ console.log(...args);
/* eslint-enable no-console */ };
const $d997a72120805c5c$export$1cf1c9b0aa495972 = ({ startedAt: startedAt , recordingLength: recordingLength  })=>{
    const [now, setNow] = (0, $g5BLJ.useState)(new Date());
    (0, $g5BLJ.useEffect)(()=>{
        const id = setInterval(()=>{
            setNow(new Date());
        }, 1000);
        return ()=>{
            clearInterval(id);
        };
    }, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        minWidth: "35px",
        children: (0, $73b0620564a5efc3$export$74b4d0aec03dadcb)(Math.max(now.valueOf() - startedAt.valueOf() + recordingLength, 0))
    });
};
const $d997a72120805c5c$export$459e828546a2b677 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AudioRecorder__GreenCheckContainer",
    componentId: "sc-7nwc1y-0"
})([
    "position:absolute;margin:",
    ";top:0;right:0;"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).half);
const $d997a72120805c5c$export$1ed32bb4777eea61 = ({ children: children , displayType: displayType , saved: saved  })=>{
    return displayType === "mobile" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        width: "100%",
        align: "end",
        children: children
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
        saved: saved,
        displayType: displayType,
        children: children
    });
};
const $d997a72120805c5c$var$SUCCESS_TOAST_DURATION = 2000;
const $d997a72120805c5c$export$6fc3d951b68e69bd = ({ status: status , audioFile: audioFile , startDeleting: startDeleting , startRestart: startRestart , openMicSettings: openMicSettings  })=>{
    const audioReady = !(status === "not_started" && !audioFile || status === "loading" || status === "processing" || status === "recording");
    const audioProcessing = status === "loading" || status === "processing" || status === "recording";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                content: "Delete your recording",
                disabled: !audioReady,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "noStyles",
                    onClick: startDeleting,
                    disabled: !audioReady,
                    height: "40px",
                    width: "40px",
                    testTag: "delete-recording",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "trash",
                        size: "2em",
                        color: !audioReady ? "gray5" : "danger",
                        fill: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                content: "Start over",
                disabled: !audioReady,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "noStyles",
                    disabled: !audioReady,
                    onClick: startRestart,
                    height: "40px",
                    width: "40px",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "redo",
                        size: "2em",
                        strokeWidth: 1.5,
                        color: !audioReady ? "gray5" : "primaryBlue",
                        strokeLinecap: "round"
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                content: "Change your settings",
                disabled: audioProcessing,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "noStyles",
                    onClick: openMicSettings,
                    disabled: audioProcessing,
                    height: "40px",
                    width: "40px",
                    testTag: "recorder-settings",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "settings",
                        size: "1.8em",
                        color: audioProcessing ? "gray5" : "gray7",
                        strokeWidth: 0,
                        fill: true
                    })
                })
            })
        ]
    });
};
const $d997a72120805c5c$export$de95611a92ae0566 = ({ recordingSequence: recordingSequence , audioFile: audioFile , onAudioRecorderStatus: onAudioRecorderStatus , onRecordingSequenceStatus: onRecordingSequenceStatus , displayType: displayType = "desktop" , disabled: disabled = false , dirty: dirty = false , showCountdown: showCountdown = false , onSave: onSave , onRecordingStart: onRecordingStart , onRecordingStop: onRecordingStop  })=>{
    const setField = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.setField, []);
    const { createToast: createToast , closeToast: closeToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const mediaStreamRef = (0, $g5BLJ.useRef)();
    const mediaRecorderRef = (0, $g5BLJ.useRef)();
    const mimeTypeDetailsRef = (0, $g5BLJ.useRef)();
    const chunkPromisesRef = (0, $g5BLJ.useRef)();
    const recordingRef = (0, $g5BLJ.useRef)(null);
    const hasReceivedSoundRef = (0, $g5BLJ.useRef)(false);
    const noSoundWarningTimeoutIdRef = (0, $g5BLJ.useRef)(null);
    const noSoundWarningToastIdRef = (0, $g5BLJ.useRef)(null);
    const [status, setBaseStatus] = (0, $g5BLJ.useState)("not_started");
    const setStatus = (0, $g5BLJ.useCallback)((s)=>{
        setBaseStatus(s);
        onAudioRecorderStatus?.(s);
        setField("isRecording")(s === "recording");
    }, [
        onAudioRecorderStatus,
        setField
    ]);
    const [deletingOpened, setDeletingOpened] = (0, $g5BLJ.useState)(false);
    const [restartOpened, setRestartOpened] = (0, $g5BLJ.useState)(false);
    const [micSettingsOpened, setMicSettingsOpened] = (0, $g5BLJ.useState)(false);
    const [hasJustStarted, setHasJustStarted] = (0, $g5BLJ.useState)(false);
    const [volumeLevel, setVolumeLevel] = (0, $g5BLJ.useState)(0);
    const [countingDown, setCountingDown] = (0, $g5BLJ.useState)(false);
    const [startedAt, setStartedAt] = (0, $g5BLJ.useState)(new Date());
    const [recordingEndedAt, setRecordingEnded] = (0, $g5BLJ.useState)(new Date());
    const startFakeRecording = (0, $g5BLJ.useCallback)(()=>{
        setStatus("loading");
        fetchJson(`/api/recordings`, {
            method: "POST",
            onSuccess: async (data)=>{
                const newRecording = data.recording;
                recordingRef.current = newRecording;
                chunkPromisesRef.current = [];
                setStatus("recording");
                setStartedAt(new Date());
                createToast({
                    children: "Recording started!",
                    color: "success",
                    duration: $d997a72120805c5c$var$SUCCESS_TOAST_DURATION
                });
            }
        });
    }, [
        createToast,
        fetchJson,
        setStatus
    ]);
    const uploadRecordingPart = (0, $g5BLJ.useCallback)((blob)=>{
        $d997a72120805c5c$var$log("uploadRecordingPart", recordingRef.current, chunkPromisesRef.current?.length);
        if (!recordingRef.current) return;
        const recording = recordingRef.current;
        chunkPromisesRef.current || (chunkPromisesRef.current = []);
        const index = chunkPromisesRef.current.length;
        const mimeTypeDetails = mimeTypeDetailsRef.current ?? (0, $c1fa64c16b04d0e5$export$ef74f01a8ec6e3a5);
        const promise = fetchJson(`/api/recordings/${recording.id}/recording_parts`, {
            method: "POST",
            retrySchedule: (0, $c1fa64c16b04d0e5$export$80670e9bc195d6e3),
            data: {
                index: index,
                mimeTypeDetails: mimeTypeDetails
            },
            files: {
                blob: blob
            }
        });
        chunkPromisesRef.current.push(promise);
    }, [
        fetchJson
    ]);
    const uploadFakeRecordingPart = (0, $g5BLJ.useCallback)((fileList)=>{
        const file = fileList.first();
        if (!file) return;
        uploadRecordingPart(file);
    }, [
        uploadRecordingPart
    ]);
    const onRecordingFinished = (0, $g5BLJ.useCallback)(async ()=>{
        $d997a72120805c5c$var$log("onRecordingFinished", recordingRef.current, chunkPromisesRef.current?.length, mediaRecorderRef.current?.state);
        if (!recordingRef.current) return;
        if (!chunkPromisesRef.current) return;
        const recording = recordingRef.current;
        if (onRecordingStop) onRecordingStop(recording.id);
        setRecordingEnded(new Date());
        setStatus("processing");
        const onError = ()=>{
            recordingRef.current = null;
            setStatus("failed");
            createToast({
                color: "danger",
                children: "This recording failed to process, please try again."
            });
            (0, $1ce946abade47122$export$b33b857ad1d9900e)(new Error("This recording failed to process, please try again."));
        };
        // Give time for the last call to go through
        await (0, $8a14245e3a78cfb1$export$5c069c93d2b7493f)(1000);
        $d997a72120805c5c$var$log("onRecordingFinished 2", chunkPromisesRef.current.length, mediaRecorderRef.current?.state);
        // If somehow there is still no recording data, keep waiting until there is
        for(let i = 0; i < (0, $c1fa64c16b04d0e5$export$f50cb32cd0c08c57) && chunkPromisesRef.current.length === 0; i += 1)await (0, $8a14245e3a78cfb1$export$5c069c93d2b7493f)(1000);
        $d997a72120805c5c$var$log("onRecordingFinished 3", chunkPromisesRef.current.length, mediaRecorderRef.current?.state);
        if (chunkPromisesRef.current.length === 0) {
            onError();
            return;
        }
        const results = await Promise.all(chunkPromisesRef.current);
        // If a request is cancelled by the user leaving the page, each request promise will
        // finish, it will just return null.
        const allSuccessful = results.every(Boolean);
        if (allSuccessful) fetchJson(`/api/recordings/${recording.id}`, {
            method: "PATCH",
            data: {
                recordingSequenceId: recordingSequence.id
            },
            retrySchedule: (0, $c1fa64c16b04d0e5$export$80670e9bc195d6e3),
            onSuccess: (data)=>{
                if (data.success) onRecordingSequenceStatus({
                    recordingSequence: data.recordingSequence,
                    audioFile: null,
                    pointsEarned: data.pointsEarned,
                    pointBalance: data.pointBalance
                });
                else onError();
            }
        });
        else createToast({
            children: "Recording not saved. Make sure you press the stop button when you are finished.",
            color: "danger"
        });
    }, [
        setStatus,
        createToast,
        fetchJson,
        recordingSequence.id,
        onRecordingSequenceStatus,
        onRecordingStop
    ]);
    const onVolumeLevel = (0, $g5BLJ.useCallback)((data)=>{
        setVolumeLevel(Math.round(data.smoothedVolume));
        if (data.smoothedVolume > 0) {
            hasReceivedSoundRef.current = true;
            if (noSoundWarningTimeoutIdRef.current) clearTimeout(noSoundWarningTimeoutIdRef.current);
            if (noSoundWarningToastIdRef.current) closeToast(noSoundWarningToastIdRef.current);
            noSoundWarningTimeoutIdRef.current = null;
            noSoundWarningToastIdRef.current = null;
        }
    }, [
        closeToast
    ]);
    const record = (0, $g5BLJ.useCallback)(async ()=>{
        $d997a72120805c5c$var$log("record", chunkPromisesRef.current?.length);
        setStatus("loading");
        fetchJson(`/api/recordings`, {
            method: "POST",
            onSuccess: async (data)=>{
                const newRecording = data.recording;
                recordingRef.current = newRecording;
                chunkPromisesRef.current = [];
                const result = await (0, $c1fa64c16b04d0e5$export$9be9afda50c84681)({
                    onDataAvailable: uploadRecordingPart,
                    onStop: onRecordingFinished,
                    onVolumeLevel: onVolumeLevel,
                    onStart: ()=>onRecordingStart?.(newRecording.id)
                });
                if (!result) {
                    setStatus("failed");
                    createToast({
                        color: "danger",
                        children: "There was an error starting your recording, we have logged a bug report"
                    });
                    return;
                }
                const { mediaStream: mediaStream , mediaRecorder: mediaRecorder , mimeTypeDetails: mimeTypeDetails , trackingVolume: trackingVolume  } = result;
                mediaStreamRef.current = mediaStream;
                mediaRecorderRef.current = mediaRecorder;
                mimeTypeDetailsRef.current = mimeTypeDetails;
                setStatus("recording");
                setStartedAt(new Date());
                setHasJustStarted(true);
                // Do not allow them to stop the recording unless they've recorded for a full second
                // this prevents issues where users rapid click on the "Record" button and immediately
                // stop recording, which produces an audio clip too short for AWS Transcribe to process.
                setTimeout(()=>{
                    setHasJustStarted(false);
                }, 1000);
                createToast({
                    children: "Recording started!",
                    color: "success",
                    duration: $d997a72120805c5c$var$SUCCESS_TOAST_DURATION
                });
                hasReceivedSoundRef.current = false;
                if (trackingVolume) noSoundWarningTimeoutIdRef.current = setTimeout(()=>{
                    if (!hasReceivedSoundRef.current) noSoundWarningToastIdRef.current = createToast({
                        children: `Looks like we haven't gotten any input from your microphone, make sure you are not muted and check your settings.`,
                        color: "danger",
                        forever: true,
                        closeAnywhere: true
                    });
                }, 5000);
            }
        });
    }, [
        createToast,
        onRecordingFinished,
        uploadRecordingPart,
        fetchJson,
        setStatus,
        onVolumeLevel,
        onRecordingStart
    ]);
    const stop = (0, $g5BLJ.useCallback)(()=>{
        $d997a72120805c5c$var$log("stop", mediaRecorderRef.current?.state);
        if (mediaRecorderRef.current?.state === "recording") mediaRecorderRef.current.requestData();
        (0, $c1fa64c16b04d0e5$export$767f50271002f8b6)({
            mediaRecorder: mediaRecorderRef.current,
            mediaStream: mediaStreamRef.current
        });
        $d997a72120805c5c$var$log("stop 2", mediaRecorderRef.current?.state);
        mediaRecorderRef.current = undefined;
        mediaStreamRef.current = undefined;
        setVolumeLevel(0);
        setStatus("processing");
    }, [
        setStatus
    ]);
    const recordingSequenceStatusChanged = (0, $g5BLJ.useCallback)((data)=>{
        if (data.recordingSequence.processingStatus === "finished") {
            setStatus("finished");
            onRecordingSequenceStatus(data);
            createToast({
                children: "Recording saved!",
                color: "success",
                duration: $d997a72120805c5c$var$SUCCESS_TOAST_DURATION
            });
        }
    }, [
        onRecordingSequenceStatus,
        createToast,
        setStatus
    ]);
    const startDeleting = (0, $g5BLJ.useCallback)(()=>{
        setDeletingOpened(true);
    }, []);
    const closeDeleting = (0, $g5BLJ.useCallback)(()=>{
        setDeletingOpened(false);
    }, []);
    const startRestart = (0, $g5BLJ.useCallback)(()=>{
        setRestartOpened(true);
    }, []);
    const closeRestart = (0, $g5BLJ.useCallback)(()=>{
        setRestartOpened(false);
    }, []);
    const deleteRecordingSequence = (0, $g5BLJ.useCallback)((onSuccess)=>{
        setStatus("loading");
        fetchJson(`/api/recording_sequences/${recordingSequence.id}`, {
            method: "DELETE",
            onSuccess: (data)=>{
                setStatus("not_started");
                setDeletingOpened(false);
                setRestartOpened(false);
                setStartedAt(new Date());
                setRecordingEnded(new Date());
                onRecordingSequenceStatus({
                    recordingSequence: data.recordingSequence,
                    audioFile: data.audioFile,
                    pointsEarned: data.pointsEarned,
                    pointBalance: data.pointBalance
                });
                if (onSuccess) onSuccess();
            }
        });
    }, [
        recordingSequence,
        onRecordingSequenceStatus,
        fetchJson,
        setStatus
    ]);
    const openMicSettings = (0, $g5BLJ.useCallback)(async ()=>{
        setMicSettingsOpened(true);
    }, []);
    const closeMicSettings = (0, $g5BLJ.useCallback)(()=>{
        setMicSettingsOpened(false);
    }, []);
    const beginRecording = (0, $g5BLJ.useCallback)(async ()=>{
        const status = await (0, $c1fa64c16b04d0e5$export$576d9c895f1ac7e6)();
        if (status !== "granted") {
            if (status === "unsupported") createToast({
                color: "danger",
                children: "Your browser does not support recording, please try a different browser."
            });
            else {
                (0, $b73bb7e0f32bbc6d$export$35b96c5a286f4d3e)({
                    message: "webview_ask_recording_permission"
                });
                createToast({
                    color: "danger",
                    children: "We don't have access to your microphone, please check your browser settings."
                });
            }
            setStatus("failed");
            return;
        }
        if (showCountdown) {
            setCountingDown(true);
            const countdownTimeoutId = setTimeout(()=>{
                setCountingDown(false);
            }, 5500);
            const recordTimeoutId = setTimeout(()=>{
                record();
            }, 3500);
            return ()=>{
                clearTimeout(countdownTimeoutId);
                clearTimeout(recordTimeoutId);
            };
        } else record();
        return;
    }, [
        createToast,
        record,
        setStatus,
        showCountdown
    ]);
    // Try to gracefully handle navigating away
    (0, $g5BLJ.useEffect)(()=>{
        return ()=>{
            stop();
        };
    // Only want this to run when the entire component is unmounting, not every time `stop` changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const RecorderComponent = (()=>{
        switch(displayType){
            case "desktop":
                return 0, $795d937b576f1510$export$3c50855bbde476c8;
            case "desktopSmall":
                return 0, $4ccb467b13491c27$export$c6c880725c5127f9;
            case "mobile":
                return 0, $d13f732dca9f066a$export$d980ca5f7658f3cf;
        }
    })();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $aeea4a93290ff4af$export$53819c0e58f98d49), {
                opened: countingDown,
                displayType: displayType
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $99e1e58376b11da3$export$5313b17bb82557eb), {
                dirty: status === "recording"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $59a194a8bf3cf685$export$94f6678e4fa81f5c), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: startFakeRecording,
                        zIndex: "toast",
                        children: "Start"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f4e423d3be2b137f$export$b57af79a4ab2a1c6), {
                        kind: "dropArea",
                        value: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                        name: "testFile",
                        onChange: uploadFakeRecordingPart
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: onRecordingFinished,
                        zIndex: "toast",
                        children: "Finish"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(RecorderComponent, {
                audioFile: audioFile,
                displayType: displayType,
                disabled: disabled,
                dirty: dirty,
                status: status,
                startedAt: startedAt,
                recordingEndedAt: recordingEndedAt,
                volumeLevel: volumeLevel,
                hasJustStarted: hasJustStarted,
                recordingSequence: recordingSequence,
                onSave: onSave,
                openMicSettings: openMicSettings,
                startRestart: startRestart,
                startDeleting: startDeleting,
                stop: stop,
                beginRecording: beginRecording
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
                openType: "state",
                opened: deletingOpened,
                close: closeDeleting,
                header: "Delete Recording?",
                footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: closeDeleting,
                            inheritBgColor: true,
                            displayType: "link",
                            color: "primaryBlue",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            loading: status === "loading",
                            onClick: ()=>deleteRecordingSequence(),
                            color: "danger",
                            children: "Delete"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: [
                        "Your ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                            children: "entire"
                        }),
                        " recording will be ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                            children: "permanently"
                        }),
                        " deleted. Are you sure?"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
                openType: "state",
                opened: restartOpened,
                close: closeRestart,
                header: "Restart Recording?",
                footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: closeRestart,
                            inheritBgColor: true,
                            displayType: "link",
                            color: "primaryBlue",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            loading: status === "loading",
                            onClick: ()=>deleteRecordingSequence(beginRecording),
                            color: "danger",
                            children: "Restart"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: [
                        "Your ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                            children: "entire"
                        }),
                        " recording will be ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                            children: "permanently"
                        }),
                        " deleted. Are you sure?"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0770e766331d4fe1$export$b39a1b7d06ee214f), {
                opened: micSettingsOpened,
                close: closeMicSettings
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $018cce6940d253d6$export$b5b6bb8bb5273115), {
                channel: "RecordingSequenceChannel",
                id: recordingSequence.id,
                onMessage: recordingSequenceStatusChanged
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


var $fa3517cd95b24ef9$export$1761c188a41008af = {
    logger: self.console,
    WebSocket: self.WebSocket
};
var $fa3517cd95b24ef9$export$af88d00dbe7f521 = {
    log (...messages) {
        if (this.enabled) {
            messages.push(Date.now());
            $fa3517cd95b24ef9$export$1761c188a41008af.logger.log("[ActionCable]", ...messages);
        }
    }
};
const $fa3517cd95b24ef9$var$now = ()=>(new Date).getTime();
const $fa3517cd95b24ef9$var$secondsSince = (time)=>($fa3517cd95b24ef9$var$now() - time) / 1e3;
class $fa3517cd95b24ef9$export$3ef8dc0174655dd9 {
    constructor(connection){
        this.visibilityDidChange = this.visibilityDidChange.bind(this);
        this.connection = connection;
        this.reconnectAttempts = 0;
    }
    start() {
        if (!this.isRunning()) {
            this.startedAt = $fa3517cd95b24ef9$var$now();
            delete this.stoppedAt;
            this.startPolling();
            addEventListener("visibilitychange", this.visibilityDidChange);
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`ConnectionMonitor started. stale threshold = ${this.constructor.staleThreshold} s`);
        }
    }
    stop() {
        if (this.isRunning()) {
            this.stoppedAt = $fa3517cd95b24ef9$var$now();
            this.stopPolling();
            removeEventListener("visibilitychange", this.visibilityDidChange);
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log("ConnectionMonitor stopped");
        }
    }
    isRunning() {
        return this.startedAt && !this.stoppedAt;
    }
    recordPing() {
        this.pingedAt = $fa3517cd95b24ef9$var$now();
    }
    recordConnect() {
        this.reconnectAttempts = 0;
        this.recordPing();
        delete this.disconnectedAt;
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log("ConnectionMonitor recorded connect");
    }
    recordDisconnect() {
        this.disconnectedAt = $fa3517cd95b24ef9$var$now();
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log("ConnectionMonitor recorded disconnect");
    }
    startPolling() {
        this.stopPolling();
        this.poll();
    }
    stopPolling() {
        clearTimeout(this.pollTimeout);
    }
    poll() {
        this.pollTimeout = setTimeout(()=>{
            this.reconnectIfStale();
            this.poll();
        }, this.getPollInterval());
    }
    getPollInterval() {
        const { staleThreshold: staleThreshold , reconnectionBackoffRate: reconnectionBackoffRate  } = this.constructor;
        const backoff = Math.pow(1 + reconnectionBackoffRate, Math.min(this.reconnectAttempts, 10));
        const jitterMax = this.reconnectAttempts === 0 ? 1 : reconnectionBackoffRate;
        const jitter = jitterMax * Math.random();
        return staleThreshold * 1e3 * backoff * (1 + jitter);
    }
    reconnectIfStale() {
        if (this.connectionIsStale()) {
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`ConnectionMonitor detected stale connection. reconnectAttempts = ${this.reconnectAttempts}, time stale = ${$fa3517cd95b24ef9$var$secondsSince(this.refreshedAt)} s, stale threshold = ${this.constructor.staleThreshold} s`);
            this.reconnectAttempts++;
            if (this.disconnectedRecently()) $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`ConnectionMonitor skipping reopening recent disconnect. time disconnected = ${$fa3517cd95b24ef9$var$secondsSince(this.disconnectedAt)} s`);
            else {
                $fa3517cd95b24ef9$export$af88d00dbe7f521.log("ConnectionMonitor reopening");
                this.connection.reopen();
            }
        }
    }
    get refreshedAt() {
        return this.pingedAt ? this.pingedAt : this.startedAt;
    }
    connectionIsStale() {
        return $fa3517cd95b24ef9$var$secondsSince(this.refreshedAt) > this.constructor.staleThreshold;
    }
    disconnectedRecently() {
        return this.disconnectedAt && $fa3517cd95b24ef9$var$secondsSince(this.disconnectedAt) < this.constructor.staleThreshold;
    }
    visibilityDidChange() {
        if (document.visibilityState === "visible") setTimeout(()=>{
            if (this.connectionIsStale() || !this.connection.isOpen()) {
                $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`ConnectionMonitor reopening stale connection on visibilitychange. visibilityState = ${document.visibilityState}`);
                this.connection.reopen();
            }
        }, 200);
    }
}
$fa3517cd95b24ef9$export$3ef8dc0174655dd9.staleThreshold = 6;
$fa3517cd95b24ef9$export$3ef8dc0174655dd9.reconnectionBackoffRate = .15;
var $fa3517cd95b24ef9$export$e32e5bb0446b4e6 = {
    message_types: {
        welcome: "welcome",
        disconnect: "disconnect",
        ping: "ping",
        confirmation: "confirm_subscription",
        rejection: "reject_subscription"
    },
    disconnect_reasons: {
        unauthorized: "unauthorized",
        invalid_request: "invalid_request",
        server_restart: "server_restart"
    },
    default_mount_path: "/cable",
    protocols: [
        "actioncable-v1-json",
        "actioncable-unsupported"
    ]
};
const { message_types: $fa3517cd95b24ef9$var$message_types , protocols: $fa3517cd95b24ef9$var$protocols  } = $fa3517cd95b24ef9$export$e32e5bb0446b4e6;
const $fa3517cd95b24ef9$var$supportedProtocols = $fa3517cd95b24ef9$var$protocols.slice(0, $fa3517cd95b24ef9$var$protocols.length - 1);
const $fa3517cd95b24ef9$var$indexOf = [].indexOf;
class $fa3517cd95b24ef9$export$98b66c25bb38499d {
    constructor(consumer){
        this.open = this.open.bind(this);
        this.consumer = consumer;
        this.subscriptions = this.consumer.subscriptions;
        this.monitor = new $fa3517cd95b24ef9$export$3ef8dc0174655dd9(this);
        this.disconnected = true;
    }
    send(data) {
        if (this.isOpen()) {
            this.webSocket.send(JSON.stringify(data));
            return true;
        } else return false;
    }
    open() {
        if (this.isActive()) {
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`Attempted to open WebSocket, but existing socket is ${this.getState()}`);
            return false;
        } else {
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`Opening WebSocket, current state is ${this.getState()}, subprotocols: ${$fa3517cd95b24ef9$var$protocols}`);
            if (this.webSocket) this.uninstallEventHandlers();
            this.webSocket = new $fa3517cd95b24ef9$export$1761c188a41008af.WebSocket(this.consumer.url, $fa3517cd95b24ef9$var$protocols);
            this.installEventHandlers();
            this.monitor.start();
            return true;
        }
    }
    close({ allowReconnect: allowReconnect  } = {
        allowReconnect: true
    }) {
        if (!allowReconnect) this.monitor.stop();
        if (this.isOpen()) return this.webSocket.close();
    }
    reopen() {
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`Reopening WebSocket, current state is ${this.getState()}`);
        if (this.isActive()) try {
            return this.close();
        } catch (error) {
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log("Failed to reopen WebSocket", error);
        } finally{
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`Reopening WebSocket in ${this.constructor.reopenDelay}ms`);
            setTimeout(this.open, this.constructor.reopenDelay);
        }
        else return this.open();
    }
    getProtocol() {
        if (this.webSocket) return this.webSocket.protocol;
    }
    isOpen() {
        return this.isState("open");
    }
    isActive() {
        return this.isState("open", "connecting");
    }
    isProtocolSupported() {
        return $fa3517cd95b24ef9$var$indexOf.call($fa3517cd95b24ef9$var$supportedProtocols, this.getProtocol()) >= 0;
    }
    isState(...states) {
        return $fa3517cd95b24ef9$var$indexOf.call(states, this.getState()) >= 0;
    }
    getState() {
        if (this.webSocket) for(let state in $fa3517cd95b24ef9$export$1761c188a41008af.WebSocket){
            if ($fa3517cd95b24ef9$export$1761c188a41008af.WebSocket[state] === this.webSocket.readyState) return state.toLowerCase();
        }
        return null;
    }
    installEventHandlers() {
        for(let eventName in this.events){
            const handler = this.events[eventName].bind(this);
            this.webSocket[`on${eventName}`] = handler;
        }
    }
    uninstallEventHandlers() {
        for(let eventName in this.events)this.webSocket[`on${eventName}`] = function() {};
    }
}
$fa3517cd95b24ef9$export$98b66c25bb38499d.reopenDelay = 500;
$fa3517cd95b24ef9$export$98b66c25bb38499d.prototype.events = {
    message (event) {
        if (!this.isProtocolSupported()) return;
        const { identifier: identifier , message: message , reason: reason , reconnect: reconnect , type: type  } = JSON.parse(event.data);
        switch(type){
            case $fa3517cd95b24ef9$var$message_types.welcome:
                this.monitor.recordConnect();
                return this.subscriptions.reload();
            case $fa3517cd95b24ef9$var$message_types.disconnect:
                $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`Disconnecting. Reason: ${reason}`);
                return this.close({
                    allowReconnect: reconnect
                });
            case $fa3517cd95b24ef9$var$message_types.ping:
                return this.monitor.recordPing();
            case $fa3517cd95b24ef9$var$message_types.confirmation:
                this.subscriptions.confirmSubscription(identifier);
                return this.subscriptions.notify(identifier, "connected");
            case $fa3517cd95b24ef9$var$message_types.rejection:
                return this.subscriptions.reject(identifier);
            default:
                return this.subscriptions.notify(identifier, "received", message);
        }
    },
    open () {
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`WebSocket onopen event, using '${this.getProtocol()}' subprotocol`);
        this.disconnected = false;
        if (!this.isProtocolSupported()) {
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log("Protocol is unsupported. Stopping monitor and disconnecting.");
            return this.close({
                allowReconnect: false
            });
        }
    },
    close (event) {
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log("WebSocket onclose event");
        if (this.disconnected) return;
        this.disconnected = true;
        this.monitor.recordDisconnect();
        return this.subscriptions.notifyAll("disconnected", {
            willAttemptReconnect: this.monitor.isRunning()
        });
    },
    error () {
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log("WebSocket onerror event");
    }
};
const $fa3517cd95b24ef9$var$extend = function(object, properties) {
    if (properties != null) for(let key in properties){
        const value = properties[key];
        object[key] = value;
    }
    return object;
};
class $fa3517cd95b24ef9$export$f55210826850c514 {
    constructor(consumer, params = {}, mixin){
        this.consumer = consumer;
        this.identifier = JSON.stringify(params);
        $fa3517cd95b24ef9$var$extend(this, mixin);
    }
    perform(action, data = {}) {
        data.action = action;
        return this.send(data);
    }
    send(data) {
        return this.consumer.send({
            command: "message",
            identifier: this.identifier,
            data: JSON.stringify(data)
        });
    }
    unsubscribe() {
        return this.consumer.subscriptions.remove(this);
    }
}
class $fa3517cd95b24ef9$export$b406de9d35d5578b {
    constructor(subscriptions){
        this.subscriptions = subscriptions;
        this.pendingSubscriptions = [];
    }
    guarantee(subscription) {
        if (this.pendingSubscriptions.indexOf(subscription) == -1) {
            $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`SubscriptionGuarantor guaranteeing ${subscription.identifier}`);
            this.pendingSubscriptions.push(subscription);
        } else $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`SubscriptionGuarantor already guaranteeing ${subscription.identifier}`);
        this.startGuaranteeing();
    }
    forget(subscription) {
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`SubscriptionGuarantor forgetting ${subscription.identifier}`);
        this.pendingSubscriptions = this.pendingSubscriptions.filter((s)=>s !== subscription);
    }
    startGuaranteeing() {
        this.stopGuaranteeing();
        this.retrySubscribing();
    }
    stopGuaranteeing() {
        clearTimeout(this.retryTimeout);
    }
    retrySubscribing() {
        this.retryTimeout = setTimeout(()=>{
            if (this.subscriptions && typeof this.subscriptions.subscribe === "function") this.pendingSubscriptions.map((subscription)=>{
                $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`SubscriptionGuarantor resubscribing ${subscription.identifier}`);
                this.subscriptions.subscribe(subscription);
            });
        }, 500);
    }
}
class $fa3517cd95b24ef9$export$d73dcc2e0bdfb5bd {
    constructor(consumer){
        this.consumer = consumer;
        this.guarantor = new $fa3517cd95b24ef9$export$b406de9d35d5578b(this);
        this.subscriptions = [];
    }
    create(channelName, mixin) {
        const channel = channelName;
        const params = typeof channel === "object" ? channel : {
            channel: channel
        };
        const subscription = new $fa3517cd95b24ef9$export$f55210826850c514(this.consumer, params, mixin);
        return this.add(subscription);
    }
    add(subscription) {
        this.subscriptions.push(subscription);
        this.consumer.ensureActiveConnection();
        this.notify(subscription, "initialized");
        this.subscribe(subscription);
        return subscription;
    }
    remove(subscription) {
        this.forget(subscription);
        if (!this.findAll(subscription.identifier).length) this.sendCommand(subscription, "unsubscribe");
        return subscription;
    }
    reject(identifier) {
        return this.findAll(identifier).map((subscription)=>{
            this.forget(subscription);
            this.notify(subscription, "rejected");
            return subscription;
        });
    }
    forget(subscription) {
        this.guarantor.forget(subscription);
        this.subscriptions = this.subscriptions.filter((s)=>s !== subscription);
        return subscription;
    }
    findAll(identifier) {
        return this.subscriptions.filter((s)=>s.identifier === identifier);
    }
    reload() {
        return this.subscriptions.map((subscription)=>this.subscribe(subscription));
    }
    notifyAll(callbackName, ...args) {
        return this.subscriptions.map((subscription)=>this.notify(subscription, callbackName, ...args));
    }
    notify(subscription, callbackName, ...args) {
        let subscriptions;
        if (typeof subscription === "string") subscriptions = this.findAll(subscription);
        else subscriptions = [
            subscription
        ];
        return subscriptions.map((subscription)=>typeof subscription[callbackName] === "function" ? subscription[callbackName](...args) : undefined);
    }
    subscribe(subscription) {
        if (this.sendCommand(subscription, "subscribe")) this.guarantor.guarantee(subscription);
    }
    confirmSubscription(identifier) {
        $fa3517cd95b24ef9$export$af88d00dbe7f521.log(`Subscription confirmed ${identifier}`);
        this.findAll(identifier).map((subscription)=>this.guarantor.forget(subscription));
    }
    sendCommand(subscription, command) {
        const { identifier: identifier  } = subscription;
        return this.consumer.send({
            command: command,
            identifier: identifier
        });
    }
}
class $fa3517cd95b24ef9$export$b3bffd4bb7da6b8f {
    constructor(url){
        this._url = url;
        this.subscriptions = new $fa3517cd95b24ef9$export$d73dcc2e0bdfb5bd(this);
        this.connection = new $fa3517cd95b24ef9$export$98b66c25bb38499d(this);
    }
    get url() {
        return $fa3517cd95b24ef9$export$c98131997e57b39f(this._url);
    }
    send(data) {
        return this.connection.send(data);
    }
    connect() {
        return this.connection.open();
    }
    disconnect() {
        return this.connection.close({
            allowReconnect: false
        });
    }
    ensureActiveConnection() {
        if (!this.connection.isActive()) return this.connection.open();
    }
}
function $fa3517cd95b24ef9$export$c98131997e57b39f(url) {
    if (typeof url === "function") url = url();
    if (url && !/^wss?:/i.test(url)) {
        const a = document.createElement("a");
        a.href = url;
        a.href = a.href;
        a.protocol = a.protocol.replace("http", "ws");
        return a.href;
    } else return url;
}
function $fa3517cd95b24ef9$export$799d131dbb74b992(url = $fa3517cd95b24ef9$export$44487a86467333c3("url") || $fa3517cd95b24ef9$export$e32e5bb0446b4e6.default_mount_path) {
    return new $fa3517cd95b24ef9$export$b3bffd4bb7da6b8f(url);
}
function $fa3517cd95b24ef9$export$44487a86467333c3(name) {
    const element = document.head.querySelector(`meta[name='action-cable-${name}']`);
    if (element) return element.getAttribute("content");
}



const $3f04ff595cf374a2$export$5bc1fa349af17903 = (0, $fa3517cd95b24ef9$export$799d131dbb74b992)(`${(0, $0fe4eaef81db718a$export$625c2ae8ba020e36)}/api/cable`);
const $3f04ff595cf374a2$export$40bdc60b7542ca86 = ()=>{
    // Disconnecting and reconnecting re-establishes the connection,
    // which is needed to authenticate a differnet user, and re-creates
    // the subscriptions
    $3f04ff595cf374a2$export$5bc1fa349af17903.disconnect();
    $3f04ff595cf374a2$export$5bc1fa349af17903.connect();
};
const $3f04ff595cf374a2$var$resetInSeconds = 5000; // gcp load balancer kills connections after 6000 seconds, refresh a bit early
setInterval(()=>{
    $3f04ff595cf374a2$export$40bdc60b7542ca86();
}, $3f04ff595cf374a2$var$resetInSeconds * 1000);


const $018cce6940d253d6$export$b5b6bb8bb5273115 = ({ channel: channel , id: id , onMessage: onMessage , onConnected: onConnected , onDisconnected: onDisconnected , onNotAuthenticated: onNotAuthenticated , onNotAuthorized: onNotAuthorized , onUnknownError: onUnknownError , noRedirect: noRedirect = false  })=>{
    const { handleApiError: handleApiError  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const [connected, setConnected] = (0, $g5BLJ.useState)(false);
    (0, $g5BLJ.useEffect)(()=>{
        const subscription = (0, $3f04ff595cf374a2$export$5bc1fa349af17903).subscriptions.create({
            channel: channel,
            id: id
        }, {
            received: (data)=>{
                const parsedData = (0, $8a14245e3a78cfb1$export$6a2346df6883ad7f)(data);
                if (parsedData.isRejectionMessage) {
                    const errorData = parsedData;
                    handleApiError({
                        errorType: errorData.errorType,
                        message: errorData.message,
                        onNotAuthenticated: onNotAuthenticated,
                        onNotAuthorized: onNotAuthorized,
                        onUnknownError: onUnknownError,
                        noRedirect: noRedirect
                    });
                } else onMessage(parsedData);
            },
            connected: ()=>{
                onConnected?.();
            },
            disconnected: ()=>{
                onDisconnected?.();
            }
        });
        setConnected(true);
        return ()=>{
            setConnected(false);
            subscription.unsubscribe();
        };
    }, [
        channel,
        onMessage,
        onConnected,
        onDisconnected,
        id,
        onNotAuthenticated,
        onUnknownError,
        onNotAuthorized,
        noRedirect,
        handleApiError
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $59a194a8bf3cf685$export$94f6678e4fa81f5c), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("p", {
            children: [
                channel,
                "-",
                id,
                " status: ",
                String(connected)
            ]
        })
    });
};









var $g5BLJ = parcelRequire("g5BLJ");
const $935e14606ff3af21$var$THUMB_SIZE = 16;
const $935e14606ff3af21$var$BaseAudioTrack = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AudioTrack__BaseAudioTrack",
    componentId: "sc-1v0icdh-0"
})([
    "position:relative;height:",
    ";margin:",
    ";min-width:",
    ";border-radius:",
    ";cursor:pointer;flex-grow:1;"
], (0, $18ffa0398cff6303$export$66be51d536890fa7)[6], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1], ({ $minWidth: $minWidth  })=>$minWidth, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded);
const $935e14606ff3af21$var$UnfilledAudioTrack = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AudioTrack__UnfilledAudioTrack",
    componentId: "sc-1v0icdh-1"
})([
    "position:relative;left:0;right:0;top:50%;transform:translateY(-50%);background:",
    ";height:",
    ";border-radius:",
    ";cursor:pointer;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray4.hex, (0, $18ffa0398cff6303$export$66be51d536890fa7)[1], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded);
const $935e14606ff3af21$var$FilledAudioTrack = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AudioTrack__FilledAudioTrack",
    componentId: "sc-1v0icdh-2"
})([
    "position:absolute;top:50%;transform:translateY(-50%);background:",
    ";height:",
    ";border-radius:",
    ";width:",
    ";cursor:pointer;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, (0, $18ffa0398cff6303$export$66be51d536890fa7)[1], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (props)=>`${(0, $f15bed412edb7f78$export$7d15b64cf5a3a4c4)({
        value: 100 * props.$playProgress / props.$duration,
        min: 0,
        max: 100
    })}%`);
const $935e14606ff3af21$var$ThumbContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AudioTrack__ThumbContainer",
    componentId: "sc-1v0icdh-3"
})([
    "position:absolute;left:",
    "px;right:",
    "px;top:50%;"
], $935e14606ff3af21$var$THUMB_SIZE / 2, $935e14606ff3af21$var$THUMB_SIZE / 2);
const $935e14606ff3af21$var$AudioTrackThumb = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AudioTrack__AudioTrackThumb",
    componentId: "sc-1v0icdh-4"
})([
    "position:absolute;left:",
    ";top:50%;transform:translate(-50%,-50%);background:",
    ";border-radius:",
    ";height:",
    "px;width:",
    "px;cursor:pointer;"
], (props)=>`${(0, $f15bed412edb7f78$export$7d15b64cf5a3a4c4)({
        value: 100 * props.$playProgress / props.$duration,
        min: 0,
        max: 100
    })}%`, (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, $935e14606ff3af21$var$THUMB_SIZE, $935e14606ff3af21$var$THUMB_SIZE);
let $935e14606ff3af21$var$lastX = null;
const $935e14606ff3af21$export$bd55cd45903b61d9 = ({ playProgress: playProgress , duration: duration , seek: seek , minWidth: minWidth = "150px"  })=>{
    const [mouseDown, setMouseDown] = (0, $g5BLJ.useState)(false);
    const baseTrackRef = (0, $g5BLJ.useRef)(null);
    const seekOnTrackFn = (event)=>{
        if (!event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        const x = event.clientX - rect.left;
        seek(x / rect.width * duration);
    };
    const seekOnTrack = (0, $g5BLJ.useCallback)(seekOnTrackFn, [
        seek,
        duration
    ]);
    const startDrag = (0, $g5BLJ.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        event.stopPropagation();
        setMouseDown(true);
        $935e14606ff3af21$var$lastX = event.clientX;
    }, []);
    (0, $g5BLJ.useEffect)(()=>{
        const onMouseChange = (event)=>{
            event.stopPropagation();
            if (!baseTrackRef.current) return;
            // If the cursor has moved 10 pixels or more
            const xChangedSignificantly = $935e14606ff3af21$var$lastX === null || $935e14606ff3af21$var$lastX - event.clientX > 10 || $935e14606ff3af21$var$lastX - event.clientX < -10;
            // OR the left mouse button has been released
            if (xChangedSignificantly || event.buttons !== 1) {
                $935e14606ff3af21$var$lastX = event.clientX;
                const rect = baseTrackRef.current.getBoundingClientRect();
                const x = event.clientX - rect.left;
                seek(x / rect.width * duration);
            }
            if (event.buttons !== 1) {
                setMouseDown(false);
                detach();
            }
        };
        const detach = ()=>{
            document.removeEventListener("mousemove", onMouseChange);
            document.removeEventListener("mouseup", onMouseChange);
        };
        if (mouseDown) {
            document.addEventListener("mousemove", onMouseChange);
            document.addEventListener("mouseup", onMouseChange);
        }
        return detach;
    }, [
        mouseDown,
        duration,
        seek
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($935e14606ff3af21$var$BaseAudioTrack, {
        $duration: duration,
        $playProgress: playProgress,
        onClick: seekOnTrack,
        ref: baseTrackRef,
        $minWidth: minWidth,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($935e14606ff3af21$var$UnfilledAudioTrack, {
                $duration: duration,
                $playProgress: playProgress,
                $minWidth: minWidth
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($935e14606ff3af21$var$FilledAudioTrack, {
                $duration: duration,
                $playProgress: playProgress,
                $minWidth: minWidth
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($935e14606ff3af21$var$ThumbContainer, {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($935e14606ff3af21$var$AudioTrackThumb, {
                    $duration: duration,
                    $playProgress: playProgress,
                    $minWidth: minWidth,
                    onMouseDown: startDrag
                })
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");










const $d788be8ee80c1671$export$945402dec5eae1c0 = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    0.25,
    0.5,
    0.75,
    1,
    1.25,
    1.5,
    1.75,
    2
]);
const $d788be8ee80c1671$export$969aaa38a87124e6 = {
    0.25: "0.25x",
    0.5: "0.5x",
    0.75: "0.75x",
    1: "Normal",
    1.25: "1.25x",
    1.5: "1.5x",
    1.75: "1.75x",
    2: "2x"
};
const $d788be8ee80c1671$export$ac61760386c6d05e = ({ playbackRate: playbackRate , open: open , close: close , onChange: onChange  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: open,
        header: "Select Playback Speed",
        close: close,
        disableFadeClose: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            onClick: close,
            children: "Save"
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
            name: "Speed",
            label: "",
            type: "select",
            testTag: "playback-speed",
            value: playbackRate,
            onChange: onChange,
            options: $d788be8ee80c1671$export$945402dec5eae1c0.map((speed)=>({
                    value: speed,
                    label: $d788be8ee80c1671$export$969aaa38a87124e6[speed]
                }))
        })
    });
};


const $62067085360d9386$var$Placeholder = ({ children: children  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            children: children
        })
    });
};
const $62067085360d9386$export$832cc5475f11d8b4 = ({ src: src , audioFileId: audioFileId , initialPlayProgress: initialPlayProgress , playIndex: playIndex , showSkipButtons: showSkipButtons = true , placeholder: placeholder , testTag: testTag , onPlay: onPlay , iconColor: iconColor , displayType: displayType = "desktop" , icon: icon , additionalControls: additionalControls , trackMinWidth: trackMinWidth = "200px" , disabled: disabled = false  })=>{
    const { accountType: accountType , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            accountType: s.AppData.currentUser?.accountType,
            isRecording: s.AppData.isRecording
        }), []);
    const audioRef = (0, $g5BLJ.useRef)(null);
    const playIntervalRef = (0, $g5BLJ.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, $g5BLJ.useState)(false);
    const [playbackRate, setPlaybackRate] = (0, $g5BLJ.useState)(1);
    const [playProgress, setPlayProgress] = (0, $g5BLJ.useState)(0);
    const [duration, setDuration] = (0, $g5BLJ.useState)(0);
    const [played, setPlayed] = (0, $g5BLJ.useState)(false);
    const [isEditingSpeed, setIsEditingSpeed] = (0, $g5BLJ.useState)(false);
    const showPlaybackControls = (0, $75cd274e63beb59b$export$21d5f40a3f7d2451)(accountType || "student") && audioFileId;
    const onAudioLoaded = (0, $g5BLJ.useCallback)(()=>{
        if (audioRef.current) {
            audioRef.current.playbackRate = playbackRate;
            setDuration(audioRef.current.duration * 1000);
        }
    }, [
        playbackRate
    ]);
    const play = (0, $g5BLJ.useCallback)(async ()=>{
        if (!audioRef.current) return;
        await audioRef.current.play();
        setIsPlaying(true);
        setPlayed(true);
        setPlayProgress(audioRef.current.currentTime * 1000);
        if (playIntervalRef.current) clearInterval(playIntervalRef.current);
        playIntervalRef.current = setInterval(()=>{
            setPlayProgress((audioRef.current?.currentTime ?? 0) * 1000);
        }, 100);
        onPlay?.();
    }, [
        onPlay
    ]);
    const pause = (0, $g5BLJ.useCallback)(()=>{
        if (!isPlaying) return;
        setIsPlaying(false);
        audioRef.current?.pause();
        if (playIntervalRef.current) clearInterval(playIntervalRef.current);
    }, [
        isPlaying
    ]);
    const seek = (0, $g5BLJ.useCallback)((timestamp)=>{
        if (audioRef.current) {
            const value = (0, $f15bed412edb7f78$export$7d15b64cf5a3a4c4)({
                value: timestamp / 1000,
                min: 0,
                max: duration
            });
            audioRef.current.currentTime = value;
            setPlayProgress(timestamp);
        }
    }, [
        duration
    ]);
    const changePlaybackRate = (newRate)=>{
        if (audioRef.current) {
            audioFileId && $7026505adadcfc0e$export$8a8216c44337cd5(`audio-playback-rate-${audioFileId}`, newRate.toString());
            audioRef.current.playbackRate = newRate;
            setPlaybackRate(newRate);
        }
    };
    (0, $g5BLJ.useEffect)(()=>{
        if (typeof initialPlayProgress === "number" && typeof playIndex === "number") seek(initialPlayProgress);
    }, [
        initialPlayProgress,
        seek,
        playIndex
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        const savedPlaybackRate = audioFileId && Number($7026505adadcfc0e$export$f92dfeb71e9bb569(`audio-playback-rate-${audioFileId}`)) || playbackRate;
        if (playbackRate !== savedPlaybackRate) setPlaybackRate(savedPlaybackRate);
    }, [
        audioFileId,
        playbackRate
    ]);
    const onAudioFinished = (0, $g5BLJ.useCallback)(()=>{
        setIsPlaying(false);
        setPlayProgress(duration);
        if (playIntervalRef.current) clearInterval(playIntervalRef.current);
    }, [
        duration
    ]);
    const backFive = (0, $g5BLJ.useCallback)(()=>{
        if (audioRef.current) seek((audioRef.current.currentTime - 5) * 1000);
    }, [
        seek
    ]);
    const forwardFive = (0, $g5BLJ.useCallback)(()=>{
        if (audioRef.current) seek((audioRef.current.currentTime + 5) * 1000);
    }, [
        seek
    ]);
    const buttonSize = (0, $18ffa0398cff6303$export$66be51d536890fa7)[8];
    const sharedIconProps = {
        iconSize: buttonSize,
        width: (0, $18ffa0398cff6303$export$66be51d536890fa7)[6],
        height: (0, $18ffa0398cff6303$export$66be51d536890fa7)[6],
        displayType: "iconOnly",
        color: "backgroundLight",
        iconColor: "black",
        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
        disabled: disabled
    };
    const audio = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("audio", {
        ref: audioRef,
        src: src,
        onCanPlayThrough: onAudioLoaded,
        onDurationChange: onAudioLoaded,
        onEnded: onAudioFinished
    });
    const skipButtonsVisible = showSkipButtons && (!placeholder || played);
    const sharedPlayButtonProps = {
        displayType: "iconOnly",
        onClick: isPlaying ? pause : play,
        icon: icon || (isPlaying ? "pause" : "play"),
        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
        height: buttonSize,
        width: buttonSize,
        iconColor: iconColor ?? "white",
        testTag: testTag,
        disabled: disabled
    };
    const playControls = displayType === "iconOnly" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        color: "white",
        ...sharedPlayButtonProps
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            skipButtonsVisible && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        icon: "backFiveSeconds",
                        onClick: backFive,
                        ...sharedIconProps
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                color: "primaryBlue",
                iconSize: isPlaying ? "20px" : "14px",
                iconFill: true,
                ...sharedPlayButtonProps
            }),
            skipButtonsVisible && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        icon: "forwardFiveSeconds",
                        onClick: forwardFive,
                        ...sharedIconProps
                    })
                ]
            })
        ]
    });
    const track = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: placeholder && !played ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($62067085360d9386$var$Placeholder, {
            children: placeholder
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $935e14606ff3af21$export$bd55cd45903b61d9), {
            playProgress: playProgress,
            duration: duration,
            seek: seek,
            minWidth: trackMinWidth
        })
    });
    const timestamps = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            variant: "h7",
            color: "gray7",
            testTag: `playback-location-${(0, $73b0620564a5efc3$export$74b4d0aec03dadcb)(duration)}`,
            weightOverride: "semibold",
            whiteSpace: "nowrap",
            minWidth: "70px",
            textAlign: "right",
            children: [
                placeholder && !played ? null : `${(0, $73b0620564a5efc3$export$74b4d0aec03dadcb)((0, $f15bed412edb7f78$export$7d15b64cf5a3a4c4)({
                    value: playProgress,
                    max: duration,
                    min: 0
                }))} / `,
                (0, $73b0620564a5efc3$export$74b4d0aec03dadcb)(duration)
            ]
        })
    });
    if (displayType === "iconOnly") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            audio,
            playControls
        ]
    });
    else if (displayType === "mobile") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        width: "100%",
        children: [
            playControls,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            audio,
            track,
            timestamps
        ]
    });
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        width: "100%",
        children: [
            audio,
            playControls,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 4
            }),
            track,
            timestamps,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 3
            }),
            additionalControls,
            !additionalControls && showPlaybackControls && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                        testTag: "audio-player-menu",
                        displayType: "noStyles",
                        rightAligned: true,
                        direction: "up",
                        icon: "threeVerticalDots",
                        iconColor: "gray7",
                        disabled: isRecording,
                        options: [
                            {
                                onClick: ()=>setIsEditingSpeed(true),
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                            icon: "playbackSpeed",
                                            size: "1.5em"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true,
                                            size: 2
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h5",
                                            whiteSpace: "nowrap",
                                            children: "Playback Speed"
                                        })
                                    ]
                                })
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d788be8ee80c1671$export$ac61760386c6d05e), {
                        audioFileId: audioFileId,
                        open: isEditingSpeed,
                        close: ()=>setIsEditingSpeed(false),
                        onChange: changePlaybackRate,
                        playbackRate: playbackRate
                    })
                ]
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $0770e766331d4fe1$export$b39a1b7d06ee214f = ({ opened: opened , close: close  })=>{
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const [loading, setLoading] = (0, $g5BLJ.useState)(true);
    const [devices, setDevices] = (0, $g5BLJ.useState)((0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
    const [selectedDeviceId, setSelectedDeviceId] = (0, $g5BLJ.useState)(undefined);
    const [error, setError] = (0, $g5BLJ.useState)("");
    (0, $g5BLJ.useEffect)(()=>{
        const doStuff = async ()=>{
            try {
                const mediaStream = await (0, $c1fa64c16b04d0e5$export$2733ac1dd963ac73)();
                const foundDevices = await navigator.mediaDevices.enumerateDevices();
                (0, $c1fa64c16b04d0e5$export$4ba141db3233526e)(mediaStream);
                setDevices((0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(foundDevices));
                setSelectedDeviceId((0, $c1fa64c16b04d0e5$export$b54d4e79c2e8d9be)() || "");
                setLoading(false);
            } catch  {
                createToast({
                    children: "Failed to load your audio devices!",
                    color: "danger"
                });
            }
        };
        if (opened) doStuff();
    }, [
        opened,
        createToast
    ]);
    const save = (0, $g5BLJ.useCallback)(()=>{
        if (selectedDeviceId) {
            setError("");
            (0, $c1fa64c16b04d0e5$export$fe212e19a2cce390)(selectedDeviceId);
            createToast({
                children: "Your microphone has been changed!"
            });
            close();
        } else setError("You must select a microphone to save!");
    }, [
        selectedDeviceId,
        createToast,
        close
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: opened,
        header: "Microphone Settings",
        close: close,
        disableFadeClose: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: close,
                    inheritBgColor: true,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: save,
                    children: "Save"
                })
            ]
        }),
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
            name: "deviceId",
            label: "Select Microphone",
            type: "select",
            value: selectedDeviceId,
            onChange: setSelectedDeviceId,
            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                deviceId: [
                    error
                ]
            }),
            options: devices.filter((device)=>device.kind === "audioinput").map((device)=>({
                    value: device.deviceId,
                    label: device.label
                })).unshift({
                value: "",
                label: "No device selected"
            })
        })
    });
};










const $ed14308b705832ba$export$f0753697e9ebcd44 = ({ opened: opened , close: close  })=>{
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const { currentUser: currentUser , setUserField: setUserField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: s  })=>({
            currentUser: s.currentUser,
            setUserField: s.setUserField
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: opened,
        close: close,
        header: "Text Settings",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            onClick: close,
            children: "Close"
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
            label: "Text Size",
            type: "textSize",
            name: "textSize",
            value: currentUser?.textSize ?? 16,
            onChange: setUserField("textSize", createToast, false)
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");

const $59a194a8bf3cf685$var$modifiedWindow = window;
$59a194a8bf3cf685$var$modifiedWindow.testModeEnabled = false;
$59a194a8bf3cf685$var$modifiedWindow.testModeEnabledSubscribers = [];
$59a194a8bf3cf685$var$modifiedWindow.setTestModeEnabled = (value)=>{
    $59a194a8bf3cf685$var$modifiedWindow.testModeEnabled = value;
    $59a194a8bf3cf685$var$modifiedWindow.testModeEnabledSubscribers.forEach((fn)=>{
        fn(value);
    });
};
const $59a194a8bf3cf685$export$94f6678e4fa81f5c = ({ children: children  })=>{
    const [testModeEnabled, setTestModeEnabled] = (0, $g5BLJ.useState)(false);
    (0, $g5BLJ.useEffect)(()=>{
        setTestModeEnabled($59a194a8bf3cf685$var$modifiedWindow.testModeEnabled);
        const subscriber = (value)=>{
            setTestModeEnabled(value);
        };
        $59a194a8bf3cf685$var$modifiedWindow.testModeEnabledSubscribers.push(subscriber);
        return ()=>{
            $59a194a8bf3cf685$var$modifiedWindow.testModeEnabledSubscribers = $59a194a8bf3cf685$var$modifiedWindow.testModeEnabledSubscribers.filter((fn)=>fn !== subscriber);
        };
    }, []);
    if (!testModeEnabled) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $121c3b2afc84f041$export$361769c4f906e73b), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
            className: "test-mode",
            children: children
        })
    });
};







parcelRequire("g5BLJ");



var $g5BLJ = parcelRequire("g5BLJ");


const $647763111c79c7a8$export$13c02bdda694746 = "en-US";
let $647763111c79c7a8$var$languageCodesFetched = false;
let $647763111c79c7a8$var$languageCodesPromise = null;
let $647763111c79c7a8$var$cachedLanguageCodes = {};
const $647763111c79c7a8$export$ef854e77bb157b0a = ()=>{
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const [fetched, setFetched] = (0, $g5BLJ.useState)($647763111c79c7a8$var$languageCodesFetched);
    if (fetched) return $647763111c79c7a8$var$cachedLanguageCodes;
    else if ($647763111c79c7a8$var$languageCodesPromise) $647763111c79c7a8$var$languageCodesPromise.then(()=>{
        setFetched(true);
    });
    else $647763111c79c7a8$var$languageCodesPromise = new Promise((resolve)=>{
        fetchJson(`/api/language_codes`, {
            onSuccess: (data)=>{
                $647763111c79c7a8$var$cachedLanguageCodes = data.languageCodes;
                $647763111c79c7a8$var$languageCodesFetched = true;
                setFetched(true);
                resolve(data.languageCodes);
            }
        });
    });
    return $647763111c79c7a8$var$cachedLanguageCodes;
};
const $647763111c79c7a8$export$e4fbdc12184e8049 = (languageCode)=>{
    const languageCodes = $647763111c79c7a8$export$ef854e77bb157b0a();
    return languageCodes[languageCode] || null;
};
let $647763111c79c7a8$var$cachedSelectOptions = null;
const $647763111c79c7a8$export$51bafe10e07ca70f = ()=>{
    const languageCodes = $647763111c79c7a8$export$ef854e77bb157b0a();
    if ($647763111c79c7a8$var$cachedSelectOptions && $647763111c79c7a8$var$cachedSelectOptions.size > 0) return $647763111c79c7a8$var$cachedSelectOptions;
    $647763111c79c7a8$var$cachedSelectOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(Object.entries(languageCodes).filter(([_, value])=>value.enabled).sort(([aCode, aValue], [bCode, bValue])=>{
        if (aCode === $647763111c79c7a8$export$13c02bdda694746) return -1;
        if (bCode === $647763111c79c7a8$export$13c02bdda694746) return 1;
        return aValue.name.localeCompare(bValue.name);
    }).map(([code, value])=>({
            value: code,
            label: `${value.name}${value.beta ? " (Beta)" : ""}`
        })));
    return $647763111c79c7a8$var$cachedSelectOptions;
};


const $2eb83a4c56813824$export$7365296e18286c25 = ({ children: children  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        height: "100%",
        width: "100%",
        align: "center",
        justify: "center",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            variant: "h1",
            children: children || "No content"
        })
    });
const $2eb83a4c56813824$export$2f7a2f0e90c07dc4 = ({ readingTaskDetails: readingTaskDetails , vocabTask: vocabTask , onTextRangeSelected: onTextRangeSelected , drawerOpen: drawerOpen = false , instructions: instructions , highlightedWord: highlightedWord , setVocabWord: setVocabWord , enableTextRangeSelection: baseEnableTextRangeSelection , vocabTaskDetailsList: vocabTaskDetailsList , displayTypeOverride: displayTypeOverride , compactLayout: compactLayout  })=>{
    const languageCodeDetails = (0, $647763111c79c7a8$export$e4fbdc12184e8049)(readingTaskDetails?.reading?.languageCode || (0, $647763111c79c7a8$export$13c02bdda694746));
    if (!readingTaskDetails) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2eb83a4c56813824$export$7365296e18286c25, {});
    const { contentFile: contentFile , basicTextFile: basicTextFile , task: task , reading: reading  } = readingTaskDetails;
    const enableTextRangeSelection = Boolean(baseEnableTextRangeSelection && onTextRangeSelected && task.readingPartType === "start_and_end_index");
    const textRange = task.readingPartType === "start_and_end_index" ? task : (0, $1242a71da44ee8f3$export$d636fa3b02762e7b);
    const displayType = (()=>{
        if (displayTypeOverride) return displayTypeOverride;
        else if (vocabTask) return "setVocabWord";
        else if (enableTextRangeSelection) return "setTextRange";
        else if (onTextRangeSelected) return "textOnly";
        else return "dictionary";
    })();
    if (reading.contentType === "independent") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[compactLayout ? 2 : 10],
        width: "100%",
        justify: "center",
        grow: 1,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            maxWidth: "700px",
            width: "100%",
            direction: "column",
            align: "center",
            justify: "center",
            height: "100%",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0a5d8e8de2fe8d78$export$40d7a77ab2e3394), {
                testTag: "empty-state-independentReading",
                illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports))),
                primaryText: reading.name,
                secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    whiteSpace: "break-spaces",
                    children: instructions
                }),
                displayType: compactLayout ? "minimal" : "normal"
            })
        })
    });
    else if ([
        "PdfStoredFile",
        "PdfByPageStoredFile"
    ].includes(contentFile?.type || "")) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $614d018fbd2bc9dd$export$c2b566b1ee6fc458), {
        readingTaskDetails: readingTaskDetails,
        drawerOpen: drawerOpen,
        kind: compactLayout ? "compact" : "full"
    });
    else if (vocabTask) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ee42914c60200b71$export$3df8925a20fc7cae), {
        languageCodeDetails: languageCodeDetails,
        textFile: contentFile?.type === "TextStoredFile" ? contentFile : basicTextFile,
        displayType: displayType,
        textRange: textRange,
        enableTextRangeSelection: enableTextRangeSelection,
        drawerOpen: drawerOpen,
        highlightedWord: highlightedWord,
        setVocabWord: setVocabWord,
        vocabTaskDetailsList: vocabTaskDetailsList,
        compactLayout: compactLayout
    });
    else if (contentFile?.type === "TextStoredFile") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ee42914c60200b71$export$3df8925a20fc7cae), {
        languageCodeDetails: languageCodeDetails,
        textFile: onTextRangeSelected ? contentFile : basicTextFile,
        displayType: displayType,
        onTextRangeSelected: onTextRangeSelected,
        textRange: textRange,
        enableTextRangeSelection: enableTextRangeSelection,
        drawerOpen: drawerOpen,
        vocabTaskDetailsList: vocabTaskDetailsList,
        compactLayout: compactLayout
    });
    else if (!basicTextFile) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2eb83a4c56813824$export$7365296e18286c25, {});
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ee42914c60200b71$export$3df8925a20fc7cae), {
        languageCodeDetails: languageCodeDetails,
        textFile: basicTextFile,
        displayType: displayType,
        onTextRangeSelected: onTextRangeSelected,
        textRange: textRange,
        enableTextRangeSelection: enableTextRangeSelection,
        drawerOpen: drawerOpen,
        vocabTaskDetailsList: vocabTaskDetailsList,
        compactLayout: compactLayout
    });
};






var $g5BLJ = parcelRequire("g5BLJ");





var $g5BLJ = parcelRequire("g5BLJ");


var $bR7Up = parcelRequire("bR7Up");
var $087451f2aecdbc78$exports = {};

/* Copyright 2021 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (typeof window !== "undefined" ? window : {}).pdfjsWorker = (parcelRequire("51nHm"));





$bR7Up.GlobalWorkerOptions.workerSrc = $087451f2aecdbc78$exports;
const $4f2c22192550730b$var$CanvasContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PDFJsWrapper__CanvasContainer",
    componentId: "sc-1xefw3v-0"
})([
    "margin:0 auto;outline:none;"
]);
const $4f2c22192550730b$var$imgStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "display:flex;height:",
    "px;min-width:",
    "px;border-radius:",
    ";user-select:none;"
], ({ $height: $height  })=>$height, ({ $width: $width  })=>$width, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2]);
const $4f2c22192550730b$var$ThumbnailImg = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).img.withConfig({
    displayName: "PDFJsWrapper__ThumbnailImg",
    componentId: "sc-1xefw3v-1"
})([
    "",
    " cursor:pointer;"
], $4f2c22192550730b$var$imgStyles);
const $4f2c22192550730b$var$LoadingImg = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PDFJsWrapper__LoadingImg",
    componentId: "sc-1xefw3v-2"
})([
    "",
    " align-items:center;justify-content:center;overflow:hidden;"
], $4f2c22192550730b$var$imgStyles);
const $4f2c22192550730b$var$ThumbnailContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PDFJsWrapper__ThumbnailContainer",
    componentId: "sc-1xefw3v-3"
})([
    "margin:",
    " ",
    " ",
    ";border-radius:",
    ";width:fit-content;",
    ";"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[3], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], ({ $selected: $selected  })=>{
    const borderColor = $selected ? (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).gray4.hex;
    return `box-shadow: 0 0 0 2px ${borderColor};`;
});
const $4f2c22192550730b$var$PDFContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PDFJsWrapper__PDFContainer",
    componentId: "sc-1xefw3v-4"
})([
    "display:flex;flex-direction:column;flex-grow:1;align-items:",
    ";justify-content:center;overflow-y:auto;"
], ({ $showMobile: $showMobile  })=>$showMobile ? "start" : "center");
const $4f2c22192550730b$var$smoothScrollRefIntoView = (ref)=>{
    if (!ref.current) return;
    ref.current.scrollIntoView({
        block: "nearest",
        inline: "center"
    });
};
const $4f2c22192550730b$var$UnmemoizedThumbnailList = ({ thumbnails: thumbnails , setCurrentPage: setCurrentPage , currentPage: currentPage , height: height = 200 , width: width = 130  })=>{
    const selectedRef = (0, $g5BLJ.useRef)(null);
    (0, $g5BLJ.useEffect)(()=>$4f2c22192550730b$var$smoothScrollRefIntoView(selectedRef), [
        currentPage
    ]);
    return thumbnails.length === 0 ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: thumbnails.map(({ image: image , page: page  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4f2c22192550730b$var$ThumbnailContainer, {
                        $selected: currentPage === page,
                        children: image ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4f2c22192550730b$var$ThumbnailImg, {
                            ref: currentPage === page ? selectedRef : null,
                            onClick: ()=>setCurrentPage(page),
                            src: image,
                            $height: height,
                            $width: width,
                            alt: `Thumbnail of page ${page}`,
                            title: `Page ${page}`,
                            "data-test-tag": `thumbnail-${page}`
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4f2c22192550730b$var$LoadingImg, {
                            $height: height,
                            $width: width,
                            title: `Page ${page}`,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                                size: "large"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: page
                    })
                ]
            }, page))
    });
};
const $4f2c22192550730b$var$ThumbnailList = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo($4f2c22192550730b$var$UnmemoizedThumbnailList);
const $4f2c22192550730b$var$UnmemoizedPdfJsWrapper = ({ scale: scale = 1 , rotation: rotation , src: src , currentPage: currentPage = 1 , startPage: baseStartPage = 1 , endPage: baseEndPage = 999999 , setCurrentPage: setCurrentPage , hideThumbnails: hideThumbnails = false , drawerOpen: drawerOpen = false , kind: kind  })=>{
    const [loading, setLoading] = (0, $g5BLJ.useState)(true);
    const [pdf, setPDF] = (0, $g5BLJ.useState)(null);
    const [errored, setErrored] = (0, $g5BLJ.useState)();
    const [generatedThumbnails, setGeneratedThumbnails] = (0, $g5BLJ.useState)([]);
    const canvasRef = (0, $g5BLJ.useRef)(null);
    const canvasContainerRef = (0, $g5BLJ.useRef)(null);
    const thumbCanvasRef = (0, $g5BLJ.useRef)(null);
    const pageToRenderRef = (0, $g5BLJ.useRef)(null);
    const renderingPageRef = (0, $g5BLJ.useRef)(null);
    const generatingThumbnailsRef = (0, $g5BLJ.useRef)(false);
    const regenerateThumbnailsNeededRef = (0, $g5BLJ.useRef)(null);
    const thumbnailCacheRef = (0, $g5BLJ.useRef)(new Map());
    const thumbnailDimensionsRef = (0, $g5BLJ.useRef)(new Map());
    const lastSrcUrlRef = (0, $g5BLJ.useRef)();
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tablet"
    });
    const startPage = pdf ? Math.max(baseStartPage, 1) : baseStartPage;
    const endPage = pdf ? Math.min(baseEndPage, pdf.numPages) : baseEndPage;
    const updatePage = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const width = document.body.clientWidth;
        const side = event.clientX > width / 2 ? "right" : "left";
        setCurrentPage(side === "right" ? currentPage + 1 : currentPage - 1);
    };
    (0, $g5BLJ.useEffect)(()=>{
        const newSrcUrl = new URL(src);
        // Don't re-render if it's a new version of the same PDF
        if (lastSrcUrlRef.current && newSrcUrl.host === lastSrcUrlRef.current.host && newSrcUrl.pathname === lastSrcUrlRef.current.pathname) return;
        const fetchPdf = async ()=>{
            const pdfDoc = await $bR7Up.getDocument({
                url: src
            }).promise;
            thumbnailCacheRef.current.clear();
            setPDF(pdfDoc);
            setLoading(false);
            lastSrcUrlRef.current = newSrcUrl;
        };
        fetchPdf();
    }, [
        src
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        const generateThumbnails = async (start, end)=>{
            const canvas = thumbCanvasRef.current;
            if (hideThumbnails || kind === "compact") return;
            if (pdf === null) return;
            if (canvas === null) return;
            if (generatingThumbnailsRef.current) {
                regenerateThumbnailsNeededRef.current = [
                    start,
                    end
                ];
                return;
            }
            generatingThumbnailsRef.current = true;
            const loadingImagelist = [];
            for(let pageNo = start; pageNo <= end; pageNo++){
                const cachedThumbnail = thumbnailCacheRef.current.get(rotation)?.get(pageNo);
                if (cachedThumbnail) loadingImagelist.push(cachedThumbnail);
                else loadingImagelist.push({
                    page: pageNo,
                    image: null
                });
            }
            setGeneratedThumbnails(loadingImagelist);
            if (loadingImagelist.some((x)=>!x.image)) {
                const imageList = [];
                for(let pageNo = start; pageNo <= end; pageNo++){
                    const cachedThumbnail = thumbnailCacheRef.current.get(rotation)?.get(pageNo);
                    if (cachedThumbnail) {
                        imageList.push(cachedThumbnail);
                        continue;
                    }
                    const page = await pdf.getPage(pageNo);
                    const viewport = page.getViewport({
                        scale: 0.25,
                        rotation: page.rotate + rotation
                    });
                    // Prepare canvas using PDF page dimensions
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    // Render PDF page into canvas context
                    const canvasContext = canvas.getContext("2d");
                    canvasContext?.clearRect(0, 0, canvas.width, canvas.height);
                    canvasContext?.beginPath();
                    const renderTask = page.render({
                        canvasContext: canvasContext || {},
                        viewport: viewport
                    });
                    await renderTask.promise;
                    if (!thumbnailDimensionsRef.current.has(rotation)) thumbnailDimensionsRef.current.set(rotation, {
                        height: viewport.height,
                        width: viewport.width
                    });
                    const thumbnail = {
                        image: canvas.toDataURL("image/png"),
                        page: pageNo
                    };
                    if (!thumbnailCacheRef.current.has(rotation)) {
                        const newMap = new Map().set(pageNo, thumbnail);
                        thumbnailCacheRef.current.set(rotation, newMap);
                    } else thumbnailCacheRef.current.get(rotation)?.set(pageNo, thumbnail);
                    imageList.push(thumbnail);
                }
                setGeneratedThumbnails(imageList);
            }
            generatingThumbnailsRef.current = false;
            if (regenerateThumbnailsNeededRef.current) {
                const [newStart, newEnd] = regenerateThumbnailsNeededRef.current;
                regenerateThumbnailsNeededRef.current = null;
                generateThumbnails(newStart, newEnd);
            }
        };
        generateThumbnails(startPage, endPage);
    }, [
        kind,
        hideThumbnails,
        pdf,
        startPage,
        endPage,
        rotation
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        const updateCurrentPage = async (pageNumber)=>{
            pageToRenderRef.current = pageNumber;
            const canvas = canvasRef.current;
            if (!pdf) return;
            if (!canvas) return;
            if (typeof renderingPageRef.current === "number") return;
            renderingPageRef.current = pageNumber;
            try {
                const page = await pdf.getPage(pageNumber);
                const viewport = page.getViewport({
                    scale: scale,
                    rotation: page.rotate + rotation
                });
                // Prepare canvas using PDF page dimensions
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                // Render PDF page into canvas context
                const canvasContext = canvas.getContext("2d");
                canvasContext?.clearRect(0, 0, canvas.width, canvas.height);
                canvasContext?.beginPath();
                const renderTask = page.render({
                    canvasContext: canvasContext || {},
                    viewport: viewport
                });
                await renderTask.promise;
                $4f2c22192550730b$var$smoothScrollRefIntoView(canvasContainerRef);
                renderingPageRef.current = null;
                const currentPageToRender = pageToRenderRef.current;
                if (typeof currentPageToRender === "number" && currentPageToRender !== pageNumber) await updateCurrentPage(currentPageToRender);
            } catch (error) {
                (0, $1ce946abade47122$export$b33b857ad1d9900e)(error);
                setErrored(true);
            }
        };
        updateCurrentPage(currentPage);
    }, [
        currentPage,
        generatedThumbnails,
        hideThumbnails,
        pdf,
        scale,
        rotation,
        setCurrentPage
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        const onKeyDown = (event)=>{
            if (!canvasContainerRef.current) return;
            if ([
                "ArrowDown",
                "ArrowUp"
            ].includes(event.key)) canvasContainerRef.current.focus();
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        height: "100%",
        width: "100%",
        justify: "center",
        children: [
            !hideThumbnails && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                overflowY: "auto",
                overflowX: "hidden",
                width: "fit-content",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("canvas", {
                        style: {
                            display: "none"
                        },
                        onContextMenu: (e)=>e.preventDefault(),
                        ref: thumbCanvasRef,
                        width: 100
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4f2c22192550730b$var$ThumbnailList, {
                        thumbnails: generatedThumbnails,
                        setCurrentPage: setCurrentPage,
                        currentPage: currentPage,
                        width: thumbnailDimensionsRef.current.get(rotation)?.width,
                        height: thumbnailDimensionsRef.current.get(rotation)?.height
                    })
                ]
            }),
            kind === "thumbnailsOnly" ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4f2c22192550730b$var$PDFContainer, {
                onClick: updatePage,
                $showMobile: showMobile,
                "data-test-tag": "pdf-container",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    height: "100%",
                    grow: 1,
                    overflowY: "auto",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 8
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($4f2c22192550730b$var$CanvasContainer, {
                            ref: canvasContainerRef,
                            tabIndex: 0,
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                }),
                                loading && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    align: "center",
                                    justify: "center",
                                    height: "100%",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h2",
                                            children: "This awesome PDF will be ready in just a moment"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 8
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {})
                                    ]
                                }),
                                errored && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h1",
                                    children: "Failed to load this reading, please talk your instructor"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("canvas", {
                                    onContextMenu: (e)=>e.preventDefault(),
                                    ref: canvasRef,
                                    width: 100,
                                    height: window.innerHeight,
                                    "data-test-tag": "main-pdf-canvas"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: drawerOpen ? 75 : 32
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
const $4f2c22192550730b$export$10fd58948268050c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo($4f2c22192550730b$var$UnmemoizedPdfJsWrapper);





const $614d018fbd2bc9dd$var$MAX_TAB_HINTS = 40;
const $614d018fbd2bc9dd$var$PageIndicator = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PDFReader__PageIndicator",
    componentId: "sc-tec1cv-0"
})([
    "background-color:",
    ";height:",
    ";width:100%;margin:",
    ";border-radius:10px;cursor:pointer;"
], ({ $tabColor: $tabColor  })=>$tabColor, (0, $18ffa0398cff6303$export$66be51d536890fa7)[1], (0, $18ffa0398cff6303$export$66be51d536890fa7)[1]);
const $614d018fbd2bc9dd$var$ZoomButtons = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PDFReader__ZoomButtons",
    componentId: "sc-tec1cv-1"
})([
    "display:flex;position:absolute;bottom:",
    ";right:",
    ";z-index:",
    ";user-select:none;"
], ({ $isMobile: $isMobile = false  })=>$isMobile ? "100px" : "25px", ({ $isMobile: $isMobile = false  })=>$isMobile ? "0" : "25px", (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised);
const $614d018fbd2bc9dd$var$getPages = (task, contentFile)=>{
    if (task?.readingPartType === "pages") return {
        startPage: task.startPoint.pageNumber + 1,
        endPage: task.endPoint.pageNumber + 1
    };
    return {
        startPage: 1,
        endPage: contentFile?.pageCount ?? 10000
    };
};
const $614d018fbd2bc9dd$var$UnmemoizedPDFReader = ({ readingTaskDetails: readingTaskDetails , src: src , drawerOpen: drawerOpen = false , rotation: rotation = 0 , onRotatePDF: onRotatePDF , kind: kind = "full" , currentPage: propCurrentPage , setCurrentPage: propSetCurrentPage , hideTopBar: hideTopBar = false  })=>{
    const contentFile = readingTaskDetails?.contentFile;
    if (contentFile && contentFile.type !== "PdfStoredFile" && contentFile.type !== "PdfByPageStoredFile") throw new Error(`Trying to render a non PDF file as a PDF (is ${contentFile.type})`);
    const { startPage: startPage , endPage: endPage  } = $614d018fbd2bc9dd$var$getPages(readingTaskDetails?.task, contentFile);
    const [internalCurrentPage, internalSetCurrentPage] = (0, $g5BLJ.useState)(startPage);
    const currentPage = (0, $g5BLJ.useMemo)(()=>propCurrentPage ?? internalCurrentPage, [
        propCurrentPage,
        internalCurrentPage
    ]);
    const setCurrentPageToUse = (0, $g5BLJ.useMemo)(()=>propSetCurrentPage ?? internalSetCurrentPage, [
        propSetCurrentPage,
        internalSetCurrentPage
    ]);
    const savedScales = JSON.parse($7026505adadcfc0e$export$f92dfeb71e9bb569("selectedZoomScales") || "null");
    const scaleMap = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(savedScales);
    const savedZoomScale = readingTaskDetails && scaleMap.get(readingTaskDetails.task.id);
    const [scale, setScale] = (0, $g5BLJ.useState)(savedZoomScale ?? 1);
    const tabs = (0, $g5BLJ.useMemo)(()=>{
        return endPage + 1 - startPage <= $614d018fbd2bc9dd$var$MAX_TAB_HINTS && startPage <= endPage ? (0, $3f9a4df32f03e33e$export$9a58ef0d7ad3278c)(startPage, endPage + 1).toList() : (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)();
    }, [
        startPage,
        endPage
    ]);
    const setCurrentPage = (0, $g5BLJ.useCallback)((page)=>{
        if (page >= startPage && page <= endPage) setCurrentPageToUse(page);
    }, [
        startPage,
        endPage,
        setCurrentPageToUse
    ]);
    const setZoomScale = (zoomScale)=>{
        if (readingTaskDetails) {
            const newMap = scaleMap.set(readingTaskDetails.task.id, zoomScale);
            $7026505adadcfc0e$export$8a8216c44337cd5("selectedZoomScales", JSON.stringify(newMap));
        }
        setScale(zoomScale);
    };
    (0, $g5BLJ.useEffect)(()=>{
        if (kind === "thumbnailsOnly") return;
        const onKeyDown = (event)=>{
            if (event.key === "ArrowRight") setCurrentPage(currentPage + 1);
            else if (event.key === "ArrowLeft") setCurrentPage(currentPage - 1);
        };
        document.addEventListener("keydown", onKeyDown);
        return ()=>{
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        currentPage,
        kind,
        setCurrentPage
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (currentPage < startPage || currentPage > endPage) setCurrentPage((0, $f15bed412edb7f78$export$7d15b64cf5a3a4c4)({
            value: currentPage,
            min: startPage,
            max: endPage
        }));
    }, [
        currentPage,
        setCurrentPage,
        startPage,
        endPage
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        width: kind === "thumbnailsOnly" ? "auto" : "100%",
        minHeight: 0,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[5]}`,
                children: hideTopBar || kind === "thumbnailsOnly" ? null : tabs.size < 2 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                    noMargin: true
                }) : tabs.map((tab)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "noStyles",
                        onClick: ()=>setCurrentPage(tab),
                        flexGrow: 1,
                        testTag: `page-button-${tab}`,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($614d018fbd2bc9dd$var$PageIndicator, {
                            $tabColor: tab === currentPage ? (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).gray4.hex
                        })
                    }, tab))
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                height: "100%",
                minHeight: 0,
                grow: 1,
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4f2c22192550730b$export$10fd58948268050c), {
                    currentPage: currentPage,
                    scale: scale,
                    rotation: rotation,
                    setCurrentPage: setCurrentPage,
                    src: src || contentFile?.url || "",
                    hideThumbnails: false,
                    startPage: startPage,
                    endPage: endPage,
                    drawerOpen: drawerOpen,
                    kind: kind
                })
            }),
            kind === "compact" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($614d018fbd2bc9dd$var$ZoomButtons, {
                $isMobile: true,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            icon: "zoomIn",
                            iconPosition: "right",
                            iconSize: "2.25em",
                            displayType: "noStyles",
                            disabled: scale >= 5,
                            onClick: ()=>setZoomScale(Math.min(5, scale + 0.1)),
                            iconColor: "primaryBlue",
                            paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            icon: "zoomOut",
                            iconPosition: "right",
                            iconSize: "2.25em",
                            displayType: "noStyles",
                            disabled: scale <= 0.1,
                            onClick: ()=>setZoomScale(Math.max(scale - 0.1, 0.1)),
                            iconColor: "primaryBlue",
                            color: "white",
                            paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`
                        })
                    ]
                })
            }),
            kind === "full" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($614d018fbd2bc9dd$var$ZoomButtons, {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                    backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex,
                    borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
                    children: [
                        onRotatePDF && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    icon: "rotate",
                                    displayType: "outline",
                                    onClick: onRotatePDF,
                                    children: "Rotate"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            icon: "zoomIn",
                            displayType: "outline",
                            disabled: scale >= 5,
                            onClick: ()=>setZoomScale(Math.min(5, scale + 0.1)),
                            children: "Zoom In"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            icon: "zoomOut",
                            displayType: "outline",
                            disabled: scale <= 0.1,
                            onClick: ()=>setZoomScale(Math.max(scale - 0.1, 0.1)),
                            children: "Zoom Out"
                        })
                    ]
                })
            })
        ]
    });
};
const $614d018fbd2bc9dd$export$c2b566b1ee6fc458 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo($614d018fbd2bc9dd$var$UnmemoizedPDFReader);






var $g5BLJ = parcelRequire("g5BLJ");






const $833286d0285c78bf$var$fillerVariant = (showAdditions, prevAction = "", nextAction = "")=>(prevAction === "missed" || prevAction === "replaced" && !showAdditions) && [
        "missed",
        "replaced"
    ].includes(nextAction) ? "del" : undefined;
const $833286d0285c78bf$export$7cebf6ef7d19a95 = ({ blur: blur = false , children: children , variant: variant , color: color , textSizeOverride: textSizeOverride  })=>{
    const textSize = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser?.textSize, []) || (0, $75cd274e63beb59b$export$74d9cec7d2c95116);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        display: "inline",
        blurrify: blur,
        sizeOverride: textSizeOverride || textSize,
        testTag: "diff-item",
        variant: variant || "normalText",
        whiteSpace: "pre-wrap",
        color: color,
        children: children
    });
};
const $833286d0285c78bf$var$tooltipContent = `Upgrade to ${(0, $4ded3b2c5af96cca$export$52756c3ad45aa25c)} to view substitutions spoken by your student!`;
const $833286d0285c78bf$var$independentReadingTooltipContent = `Upgrade to ${(0, $4ded3b2c5af96cca$export$52756c3ad45aa25c)} to view the full transcription of what your student read!`;
const $833286d0285c78bf$var$MissingWord = ({ tooltipEnabled: tooltipEnabled = false , children: children , index: index , corrected: corrected  })=>{
    const disputeError = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.SubmissionOverviewData.disputeError, []);
    const onClick = (0, $g5BLJ.useCallback)(()=>disputeError(index), [
        disputeError,
        index
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            onClick: onClick,
            children: "Report as Correct"
        }),
        disabled: !tooltipEnabled || corrected,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($833286d0285c78bf$export$7cebf6ef7d19a95, {
            variant: corrected ? undefined : "del",
            color: corrected ? "success" : undefined,
            children: children
        })
    });
};
const $833286d0285c78bf$var$DiffItemViewer = ({ prevItem: prevItem , diffItem: diffItem , nextItem: nextItem , onTimeSelected: onTimeSelected , showAdditions: showAdditions , blurAll: blurAll , blur: blur , showReportError: showReportError , index: index , corrected: corrected , disabled: disabled , startAssignmentUpgrade: startAssignmentUpgrade , usageCapsEnabled: usageCapsEnabled , availableUltimateAssessments: availableUltimateAssessments  })=>{
    const onClick = (0, $g5BLJ.useCallback)(()=>{
        if (diffItem.action === "added" || diffItem.action === "correct" || diffItem.action === "replaced") onTimeSelected(diffItem.startTime);
    }, [
        diffItem,
        onTimeSelected
    ]);
    if (diffItem.action === "added") return showAdditions ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
                content: $833286d0285c78bf$var$tooltipContent,
                linkLocation: "contact",
                enabled: blur,
                usageCapsEnabled: usageCapsEnabled,
                availableUltimateAssessments: availableUltimateAssessments,
                onClick: startAssignmentUpgrade,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    testTag: "diff-item",
                    displayType: "noStyles",
                    onClick: onClick,
                    disabled: disabled || blur,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($833286d0285c78bf$export$7cebf6ef7d19a95, {
                        variant: "ins",
                        blur: blur,
                        children: [
                            prevItem?.action !== "added" && "[",
                            blur ? (0, $e6116bf527c207db$export$92c48ccafc588071)(diffItem.transcriptWord) : diffItem.transcriptWord,
                            nextItem?.action !== "added" && "]"
                        ]
                    })
                })
            }),
            nextItem?.action !== "filler" && " "
        ]
    }) : null;
    else if (diffItem.action === "missed") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($833286d0285c78bf$var$MissingWord, {
        tooltipEnabled: showReportError,
        index: index,
        corrected: corrected,
        children: diffItem.originalWord
    });
    else if (diffItem.action === "correct") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        testTag: "diff-item",
        displayType: "noStyles",
        onClick: onClick,
        disabled: disabled || blurAll,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($833286d0285c78bf$export$7cebf6ef7d19a95, {
            blur: blurAll,
            children: blurAll ? (0, $e6116bf527c207db$export$92c48ccafc588071)(diffItem.originalWord) : diffItem.originalWord
        })
    });
    else if (diffItem.action === "filler") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($833286d0285c78bf$export$7cebf6ef7d19a95, {
        blur: blurAll,
        variant: $833286d0285c78bf$var$fillerVariant(showAdditions, prevItem?.action, nextItem?.action),
        children: diffItem.originalWord
    });
    else if (diffItem.action === "replaced") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($833286d0285c78bf$var$MissingWord, {
                tooltipEnabled: showReportError,
                index: index,
                corrected: corrected,
                children: diffItem.originalWord
            }),
            showAdditions ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
                        content: $833286d0285c78bf$var$tooltipContent,
                        enabled: blur,
                        linkLocation: "contact",
                        usageCapsEnabled: usageCapsEnabled,
                        availableUltimateAssessments: availableUltimateAssessments,
                        onClick: startAssignmentUpgrade,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                testTag: "diff-item",
                                displayType: "noStyles",
                                onClick: onClick,
                                disabled: disabled || blur,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($833286d0285c78bf$export$7cebf6ef7d19a95, {
                                    variant: "ins",
                                    blur: blur,
                                    children: [
                                        "[",
                                        blur ? (0, $e6116bf527c207db$export$92c48ccafc588071)(diffItem.transcriptWord) : diffItem.transcriptWord,
                                        "]"
                                    ]
                                })
                            }),
                            nextItem?.action !== "filler" && " "
                        ]
                    })
                ]
            }) : null
        ]
    });
    else // eslint-disable-next-line @typescript-eslint/no-explicit-any
    throw new Error(`Unregonized diff item action: ${diffItem.action}`);
};
const $833286d0285c78bf$var$UnmemoizedDiffViewer = ({ textDiff: textDiff , errorDisputes: errorDisputes , onTimeSelected: onTimeSelected , showAdditions: showAdditions = true , showReportError: showReportError = false , disabled: disabled = false , blur: blur , blurAll: blurAll , startAssignmentUpgrade: startAssignmentUpgrade , usageCapsEnabled: usageCapsEnabled , availableUltimateAssessments: availableUltimateAssessments  })=>{
    const disputeIndices = errorDisputes.map((ed)=>ed.index);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
        linkLocation: "contact",
        content: $833286d0285c78bf$var$independentReadingTooltipContent,
        enabled: blurAll,
        usageCapsEnabled: usageCapsEnabled,
        availableUltimateAssessments: availableUltimateAssessments,
        onClick: startAssignmentUpgrade,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $663e996bc3c0fcdd$export$7f86637430bae410), {
            testTag: "diff-viewer",
            drawerOpen: true,
            children: [
                textDiff.prunedItems.map((diffItem, i)=>{
                    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($833286d0285c78bf$var$DiffItemViewer, {
                        index: i,
                        prevItem: i > 0 ? textDiff.prunedItems.get(i - 1) : null,
                        diffItem: diffItem,
                        nextItem: textDiff.prunedItems.get(i + 1),
                        onTimeSelected: onTimeSelected,
                        showAdditions: showAdditions,
                        blur: blur,
                        blurAll: blurAll,
                        showReportError: showReportError,
                        corrected: disputeIndices.includes(i),
                        disabled: disabled,
                        startAssignmentUpgrade: startAssignmentUpgrade,
                        usageCapsEnabled: usageCapsEnabled,
                        availableUltimateAssessments: availableUltimateAssessments
                    }, i);
                }),
                textDiff.isPruned ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            children: [
                                "This transcription was cut down due to being too long to show in the browser.",
                                " ",
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                    display: "inline",
                                    flexDisplay: "inline-flex",
                                    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                    onClick: (0, $86ce6205c10768ba$export$68306590b07bdc01),
                                    children: "Contact support"
                                }),
                                " ",
                                "to get the full transcript."
                            ]
                        })
                    ]
                }) : null
            ]
        })
    });
};
const $833286d0285c78bf$export$c365c0e83f659e4b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).memo($833286d0285c78bf$var$UnmemoizedDiffViewer);








const $f83bc0215c679685$export$7a4af5518e2bbe67 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Tag__StyledTag",
    componentId: "sc-9vsctr-0"
})([
    "display:flex;min-width:",
    ";",
    " ",
    ";border-radius:",
    ";color:",
    ";font-weight:",
    ";",
    ";margin-right:",
    ";",
    ""
], (0, $18ffa0398cff6303$export$66be51d536890fa7)[8], ({ $align: $align  })=>(0, $18ffa0398cff6303$export$67799b413b1b10d7)("align-items", $align, "baseline"), ({ $paddingOverride: $paddingOverride  })=>(0, $18ffa0398cff6303$export$67799b413b1b10d7)("padding", $paddingOverride, `${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]}`), (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (props)=>(0, $24b764039c44d1ec$export$8f45430ccf837300)[props.$color].hex, (0, $e0d2d68dbe5b8d1d$export$59230918eb9bd861).semibold, ({ $color: $color , $removeable: $removeable  })=>(0, $18ffa0398cff6303$export$cb290e6c0fd3cb2e)("background", (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex, 0.2), !$removeable), (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1], ({ $removeable: $removeable  })=>(0, $18ffa0398cff6303$export$cb290e6c0fd3cb2e)("border", "1px solid white", $removeable));
const $f83bc0215c679685$export$3288d34c523a1192 = ({ color: color , children: children , removeable: removeable = false , disabled: disabled = false , testTag: testTag , title: title , onRemove: onRemove , paddingOverride: paddingOverride = false , align: align = "baseline"  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f83bc0215c679685$export$7a4af5518e2bbe67, {
        $color: color,
        $removeable: removeable,
        "data-test-tag": testTag,
        title: title,
        $paddingOverride: paddingOverride,
        $align: align,
        children: [
            children,
            removeable && !disabled && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "iconOnly",
                        icon: "close",
                        iconSize: ".5em",
                        iconColor: "white",
                        color: "gray5",
                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).half,
                        inheritBgColor: true,
                        onClick: onRemove,
                        testTag: "remove-tag"
                    })
                ]
            })
        ]
    });







var $g5BLJ = parcelRequire("g5BLJ");


const $6306ab50056d7219$var$AccordionContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Accordion__AccordionContainer",
    componentId: "sc-wd8090-0"
})([
    "display:flex;flex-direction:column;width:100%;"
]);
const $6306ab50056d7219$var$BaseAccordionChildren = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)((0, $31d38d276dc0d530$export$f51f4c4ede09e011)).withConfig({
    displayName: "Accordion__BaseAccordionChildren",
    componentId: "sc-wd8090-1"
})([
    "margin-top:-",
    ";z-index:0;"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]);
const $6306ab50056d7219$var$AccordionChildrenV1 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)($6306ab50056d7219$var$BaseAccordionChildren).withConfig({
    displayName: "Accordion__AccordionChildrenV1",
    componentId: "sc-wd8090-2"
})([
    "border:2px solid ",
    ";border-top:none;border-radius:0 0 ",
    " ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2]);
const $6306ab50056d7219$var$AccordionChildrenV2 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)($6306ab50056d7219$var$BaseAccordionChildren).withConfig({
    displayName: "Accordion__AccordionChildrenV2",
    componentId: "sc-wd8090-3"
})([
    ""
]);
const $6306ab50056d7219$var$AccordionHeader = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)((0, $31d38d276dc0d530$export$f51f4c4ede09e011)).withConfig({
    displayName: "Accordion__AccordionHeader",
    componentId: "sc-wd8090-4"
})([
    "z-index:",
    ";"
], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised);
const $6306ab50056d7219$var$Rotate = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Accordion__Rotate",
    componentId: "sc-wd8090-5"
})([
    "display:flex;transition:transform 0.12s linear;",
    ""
], ({ $opened: $opened , $rotationDeg: $rotationDeg  })=>$opened ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "transform:rotate(",
        "deg);"
    ], $rotationDeg) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "transform:rotate(0);"
    ]));
const $6306ab50056d7219$export$a766cd26d0d69044 = ({ children: children , label: label , type: type = "v1" , defaultOpen: defaultOpen = false  })=>{
    const [opened, setOpened] = (0, $g5BLJ.useState)(defaultOpen);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6306ab50056d7219$var$AccordionContainer, {
        children: type === "v1" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                    onClick: ()=>setOpened(!opened),
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($6306ab50056d7219$var$AccordionHeader, {
                        justify: "space-between",
                        align: "center",
                        width: "100%",
                        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[3],
                        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h4",
                                color: "white",
                                testTag: "accordionLabel",
                                children: label
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6306ab50056d7219$var$Rotate, {
                                $opened: opened,
                                $rotationDeg: 180,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "arrowDown",
                                    color: "white",
                                    strokeWidth: 3
                                })
                            })
                        ]
                    })
                }),
                opened && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6306ab50056d7219$var$AccordionChildrenV1, {
                    padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]}`,
                    children: children
                })
            ]
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                    onClick: ()=>setOpened(!opened),
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($6306ab50056d7219$var$AccordionHeader, {
                        justify: "space-between",
                        align: "center",
                        width: "100%",
                        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
                        overflowX: "hidden",
                        overflowY: "hidden",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h6",
                                color: opened ? "primaryBlue" : "black",
                                testTag: "accordionLabel",
                                children: label
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6306ab50056d7219$var$Rotate, {
                                $opened: opened,
                                $rotationDeg: 90,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "arrowRight",
                                    color: opened ? "primaryBlue" : "black",
                                    size: "25px",
                                    strokeWidth: 2
                                })
                            })
                        ]
                    })
                }),
                opened && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 5
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6306ab50056d7219$var$AccordionChildrenV2, {
                            children: children
                        })
                    ]
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $edbf486fc173eb77$var$BaseBanner = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReleaseBanner__BaseBanner",
    componentId: "sc-xw7yit-0"
})([
    "",
    ";width:100%;"
], ($visible)=>!$visible && "display: none;");
const $edbf486fc173eb77$export$3db2ef6eb526d0db = ()=>{
    const [newVersionAvailable, setNewVersionAvailable] = (0, $g5BLJ.useState)(false);
    const onPublicMessage = (0, $g5BLJ.useCallback)(({ action: action  })=>{
        if (action === "new_release") setNewVersionAvailable(true);
    }, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($edbf486fc173eb77$var$BaseBanner, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $018cce6940d253d6$export$b5b6bb8bb5273115), {
                channel: "PublicChannel",
                id: "public",
                onMessage: onPublicMessage
            }),
            newVersionAvailable && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex,
                padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        grow: 1,
                        justify: "center",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "largeText",
                                color: "white",
                                children: "A new version of the app has just been released! Click"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                color: "white",
                                onClick: ()=>window.location.reload(),
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "largeText",
                                    color: "white",
                                    weightOverride: "bold",
                                    children: "here"
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "largeText",
                                color: "white",
                                children: "to update!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "end",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "iconOnly",
                            icon: "close",
                            iconColor: "white",
                            iconSize: "1em",
                            width: "32px",
                            height: "32px",
                            color: "primaryBlue",
                            testTag: "close-release-banner",
                            onClick: ()=>setNewVersionAvailable(false)
                        })
                    })
                ]
            })
        ]
    });
};








const $d0e0401e7c6ddc0a$var$TagButtonStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TagButton__TagButtonStyles",
    componentId: "sc-12bcfoh-0"
})([
    "border-radius:",
    ";background:",
    ";padding:",
    " ",
    ";"
], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, ({ $active: $active  })=>(0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, $active ? 0.3 : 0.1), (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]);
const $d0e0401e7c6ddc0a$export$434199a0f9f2515 = ({ onClick: onClick , active: active = false , children: children  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
        onClick: onClick,
        disabled: active,
        disabledOpacityOverride: "1",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($d0e0401e7c6ddc0a$var$TagButtonStyles, {
            $active: active,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                color: "white",
                weightOverride: "bold",
                variant: "h6",
                whiteSpace: "nowrap",
                children: children
            })
        })
    });
};








const $8842f591f4d16288$var$StudioButton = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TaskButton__StudioButton",
    componentId: "sc-1j5untt-0"
})([
    "width:100%;color:",
    ";background:",
    ";display:flex;flex-grow:0;align-items:center;border:none;border-radius:",
    ";margin-bottom:",
    ";padding:",
    " ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $active: $active = false , $completed: $completed  })=>{
    return $completed ? $active ? (0, $24b764039c44d1ec$export$8f45430ccf837300).success.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).success.active : (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, $active ? 0.3 : 0.1);
}, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[1], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[3]);
const $8842f591f4d16288$var$RightContent = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TaskButton__RightContent",
    componentId: "sc-1j5untt-1"
})([
    "margin-left:auto;display:flex;align-items:center;"
]);
const $8842f591f4d16288$export$fd1e41c372d10c35 = ({ to: to , onClick: onClick , icon: icon , reaction: reaction , children: children , active: active , rightIcon: rightIcon = false , rightText: rightText , rightTextColor: rightTextColor = "white" , loading: loading = false , disabled: disabled = false , completed: completed = false  })=>{
    const reactionContent = reaction ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ba614b87bf9c7fa$export$d2ae4167a30cf6bb), {
        kind: reaction
    }) : null;
    const iconContent = icon ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
        icon: icon,
        color: disabled ? "gray5" : "white",
        size: icon === "pdf" ? "1em" : "1.25em",
        fill: icon === "pdf" || icon === "book",
        fillColor: "white",
        strokeWidth: icon === "book" || icon === "pdf" ? 0 : 1
    }) : null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        display: "block",
        displayType: "noStyles",
        to: to,
        onClick: onClick,
        width: "100%",
        loading: loading,
        disabled: disabled,
        testTag: "task-button",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($8842f591f4d16288$var$StudioButton, {
            $active: active,
            $completed: completed,
            children: [
                !rightIcon ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        reactionContent || iconContent,
                        " ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    whiteSpace: "nowrap",
                    color: "white",
                    variant: "h6",
                    children: children
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($8842f591f4d16288$var$RightContent, {
                    children: [
                        rightText && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            whiteSpace: "nowrap",
                            color: rightTextColor,
                            variant: "h6",
                            children: rightText
                        }),
                        rightIcon && (reactionContent || iconContent),
                        completed && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "check",
                            size: "1.25em"
                        })
                    ]
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");




const $eb878214d715ad44$var$StatsItemContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StatsBanner__StatsItemContainer",
    componentId: "sc-za063m-0"
})([
    "min-height:",
    ";",
    ";"
], ({ $showMobile: $showMobile  })=>$showMobile ? "0px" : "56px", ({ $showMobile: $showMobile  })=>$showMobile ? "width: 45%" : "");
const $eb878214d715ad44$var$StatItem = ({ id: id , value: value , showMobile: showMobile = false  })=>{
    const stat = (0, $3e76d4bc3268f884$export$96f8125d9e02bc94).get(id);
    if (!stat) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($eb878214d715ad44$var$StatsItemContainer, {
        $showMobile: showMobile,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "stretch",
            height: showMobile ? "inherit" : "100%",
            padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: stat.icon,
                        strokeWidth: 0,
                        size: showMobile ? stat.mobileIconSize : stat.iconSize,
                        color: "primaryBlue",
                        fill: true
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    justify: "space-between",
                    align: "start",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: showMobile ? "h3" : "h2",
                            weightOverride: "medium",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3e76d4bc3268f884$export$a5654a21fe306c9a), {
                                stat: stat,
                                value: value
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h7",
                                    color: "gray5",
                                    whiteSpace: "nowrap",
                                    children: stat.label
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 1
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                    disabled: !stat?.tooltip,
                                    content: stat?.tooltip ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        color: "black",
                                        children: stat.tooltip
                                    }) : ""
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $eb878214d715ad44$var$BorderedFlex = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)((0, $31d38d276dc0d530$export$f51f4c4ede09e011)).withConfig({
    displayName: "StatsBanner__BorderedFlex",
    componentId: "sc-za063m-1"
})([
    "border:1px solid ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex);
const $eb878214d715ad44$var$StatsRow = ({ stats: stats , showMobile: showMobile  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: stats.interpose("div").map((stat, idx)=>stat === "div" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                vertical: true,
                size: 1
            }, `div-${idx}`) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($eb878214d715ad44$var$StatItem, {
                id: stat.name,
                value: stat.value,
                showMobile: showMobile
            }, stat.name))
    });
const $eb878214d715ad44$var$UnmemoizedStatsBanner = ({ stats: stats  })=>{
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    return showMobile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($eb878214d715ad44$var$BorderedFlex, {
        justify: "space-between",
        align: "stretch",
        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4],
        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex,
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($eb878214d715ad44$var$StatsRow, {
                    stats: stats.slice(0, stats.size / 2),
                    showMobile: showMobile
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                size: 1,
                noMargin: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($eb878214d715ad44$var$StatsRow, {
                    stats: stats.slice(stats.size / 2),
                    showMobile: showMobile
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($eb878214d715ad44$var$BorderedFlex, {
        justify: "space-between",
        align: "stretch",
        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4],
        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[4],
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($eb878214d715ad44$var$StatsRow, {
            stats: stats,
            showMobile: showMobile
        })
    });
};
const $eb878214d715ad44$export$70a4f6c59796db88 = /*#__PURE__*/ (0, $g5BLJ.memo)($eb878214d715ad44$var$UnmemoizedStatsBanner);






var $g5BLJ = parcelRequire("g5BLJ");





var $g5BLJ = parcelRequire("g5BLJ");







const $6e573b4e0f0f7464$var$ToggleCardOpen = ({ open: open , visible: visible , onToggleCardOpen: onToggleCardOpen  })=>!visible ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                displayType: "noStyles",
                onClick: onToggleCardOpen,
                testTag: "toggle",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                    icon: `arrow${open ? "Up" : "Down"}`,
                    strokeWidth: 2,
                    color: "gray7",
                    cssColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).gray7.hex
                })
            })
        ]
    });
const $6e573b4e0f0f7464$export$3636ab0104e3317e = ({ to: to , title: title , subTitle: subTitle , readingName: readingName , coverImg: coverImg , children: children , metrics: metrics , showMobile: showMobile , onToggleCardOpen: onToggleCardOpen , setHoveringClickableArea: setHoveringClickableArea , open: open , ultimate: ultimate , isStudent: isStudent  })=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        height: "100%",
        children: showMobile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                    onClick: ()=>to ? history.push(to) : null,
                    onMouseOver: ()=>setHoveringClickableArea(true),
                    onMouseOut: ()=>setHoveringClickableArea(false),
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$2e6fda2350c5bcdc), {
                            src: coverImg,
                            size: "small",
                            title: readingName
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "column",
                            align: "start",
                            width: "100%",
                            minWidth: 0,
                            children: [
                                ultimate && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                            content: "Upgraded to Ultimate Assignment",
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                icon: "ultimateAssignmentCentered",
                                                size: "1.5em",
                                                testTag: "ultimate-assessment"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true,
                                            size: 2
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h5",
                                    weightOverride: "bold",
                                    testTag: "assignment-card-title",
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    ellipsis: true,
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                }),
                                subTitle
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6e573b4e0f0f7464$var$ToggleCardOpen, {
                    visible: Boolean(metrics),
                    open: open,
                    onToggleCardOpen: onToggleCardOpen
                })
            ]
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$1cd1efc78cb52ca5), {
                    to: to,
                    src: coverImg,
                    size: "medium",
                    onMouseOver: ()=>setHoveringClickableArea(true),
                    onMouseOut: ()=>setHoveringClickableArea(false),
                    title: readingName
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        height: "100%",
                        children: [
                            isStudent ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                                to: to,
                                flexGrow: 1,
                                onMouseOver: ()=>setHoveringClickableArea(true),
                                onMouseOut: ()=>setHoveringClickableArea(false),
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    flex: 2,
                                    width: "100%",
                                    padding: `0 ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[10]} 0 0`,
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        width: "100%",
                                        align: "start",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                align: "stretch",
                                                children: [
                                                    ultimate && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                        height: "100%",
                                                        padding: "0 5px 0 0",
                                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                            content: "Upgraded to Ultimate Assignment",
                                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                                icon: "ultimateAssignment",
                                                                size: "1.5em",
                                                                testTag: "ultimate-assessment"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                        variant: "h3",
                                                        testTag: "assignment-card-title",
                                                        children: title
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                size: 2
                                            }),
                                            subTitle
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                flex: 2,
                                width: "100%",
                                padding: `0 ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[10]} 0 0`,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    width: "100%",
                                    align: "start",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                                            to: to,
                                            flexGrow: 1,
                                            onMouseOver: ()=>setHoveringClickableArea(true),
                                            onMouseOut: ()=>setHoveringClickableArea(false),
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                align: "stretch",
                                                children: [
                                                    ultimate && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                        height: "100%",
                                                        padding: "0 5px 0 0",
                                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                            content: "Upgraded to Ultimate Assignment",
                                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                                icon: "ultimateAssignment",
                                                                size: "1.5em",
                                                                testTag: "ultimate-assessment"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                        variant: "h3",
                                                        testTag: "assignment-card-title",
                                                        children: title
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 2
                                        }),
                                        subTitle
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                flex: 1,
                                width: "100%",
                                height: "100%",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "center",
                                    justify: "space-between",
                                    width: "100%",
                                    children: [
                                        isStudent ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                                            to: to,
                                            flexGrow: 1,
                                            onMouseOver: ()=>isStudent && setHoveringClickableArea(true),
                                            onMouseOut: ()=>isStudent && setHoveringClickableArea(false),
                                            disabled: !isStudent,
                                            children: children
                                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                            children: [
                                                " ",
                                                children,
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6e573b4e0f0f7464$var$ToggleCardOpen, {
                                            visible: Boolean(metrics),
                                            open: open,
                                            onToggleCardOpen: onToggleCardOpen
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


const $537b6aedceb28a63$var$AssignmentCardContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AssignmentCard__AssignmentCardContainer",
    componentId: "sc-nygt66-0"
})([
    "width:100%;display:flex;flex-direction:column;background:",
    ";padding:",
    ";margin-bottom:",
    ";border-radius:",
    ";border:1px solid ",
    ";"
], (p)=>p.$clickable && p.$hovering ? (0, $24b764039c44d1ec$export$8f45430ccf837300).white.active : (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (showMobile)=>showMobile ? `${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}` : (0, $8259eb090983b778$export$ea413736286a3bf1)[5], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex);
const $537b6aedceb28a63$export$1912f0963782feff = ({ testTag: testTag , open: open , onToggleCardOpen: onToggleCardOpen , coverImg: coverImg , to: to , title: title , subTitle: subTitle , children: children , metrics: metrics , readingName: readingName , showMobile: showMobile = false , ultimate: ultimate = false , isStudent: isStudent = false  })=>{
    const [hoveringClickableArea, setHoveringClickableArea] = (0, $g5BLJ.useState)(false);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($537b6aedceb28a63$var$AssignmentCardContainer, {
        "data-test-tag": `assignment-card-${testTag}`,
        $clickable: Boolean(to),
        $hovering: hoveringClickableArea,
        $showMobile: showMobile,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e573b4e0f0f7464$export$3636ab0104e3317e), {
                to: to,
                title: title,
                subTitle: subTitle,
                coverImg: coverImg,
                metrics: metrics,
                open: open,
                showMobile: showMobile,
                onToggleCardOpen: onToggleCardOpen,
                setHoveringClickableArea: setHoveringClickableArea,
                ultimate: ultimate,
                isStudent: isStudent,
                readingName: readingName,
                children: children
            }),
            metrics && open && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                children: isStudent ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                    to: to,
                    onMouseOver: ()=>setHoveringClickableArea(true),
                    onMouseOut: ()=>setHoveringClickableArea(false),
                    justify: "start",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]} 0 0 0`,
                        wrap: "wrap",
                        children: metrics.map((metric)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $92a022f5017e679f$export$efdd3e096bc27746), {
                                ...metric
                            }, metric.label))
                    })
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]} 0 0 0`,
                    wrap: "wrap",
                    children: metrics.map((metric)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $92a022f5017e679f$export$efdd3e096bc27746), {
                            ...metric
                        }, metric.label))
                })
            })
        ]
    });
};
const $537b6aedceb28a63$export$c3554b6de8b50f8e = /*#__PURE__*/ (0, $g5BLJ.memo)($537b6aedceb28a63$export$1912f0963782feff);




const $a679044e49a453d7$var$AssignedCourses = ({ courseIds: courseIds , assessment: assessment , courseMap: courseMap  })=>{
    const visible = courseIds.slice(0, 3);
    const overflow = courseIds.slice(3);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: visible.map((id)=>{
            const course = courseMap.get(id);
            if (!course) return null;
            return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                        name: course.name,
                        backgroundColor: course.avatarColor || (0, $24b764039c44d1ec$export$40792c0fcdd2bbbd)[0],
                        testTag: `assigned-course-${course.id}`
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    })
                ]
            }, id);
        }).push(overflow.isEmpty() ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
            name: `+${overflow.size}`,
            nameList: overflow.map((id)=>courseMap.get(id, {
                    name: ""
                }).name),
            backgroundColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).black,
            overflow: true
        }, `${assessment.id}-overflow-avatar`)).filter(Boolean)
    });
};
const $a679044e49a453d7$var$UnmemoizedTeacherAssignmentCard = ({ assessment: assessment , courseIds: courseIds , courseMap: courseMap , canAssign: canAssign , assignToPath: assignToPath , hideViewDetails: hideViewDetails , hideShare: hideShare = false , ...baseAssignmentCardProps })=>{
    const { startAssignmentUpgrade: startAssignmentUpgrade , openStatusUpdateModal: openStatusUpdateModal , openDuplicateModal: openDuplicateModal , openShareModal: openShareModal , currentPlan: currentPlan , currentUser: currentUser , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            startAssignmentUpgrade: s.UpgradeAssignmentModalData.startAssignmentUpgrade,
            openStatusUpdateModal: s.UpdateAssignmentStatusModalData.openStatusUpdateModal,
            openDuplicateModal: s.DuplicateModalData.openDuplicateModal,
            openShareModal: s.ShareModalData.openShareModal,
            currentUser: s.AppData.currentUser,
            currentPlan: s.AppData.currentPlan,
            setField: s.AppData.setField
        }), []);
    const showUltimate = currentPlan.isUsageCapsEnabled && assessment.isUltimate;
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    const moderatorPlus = (0, $75cd274e63beb59b$export$a71c09bab744fd37)(currentUser?.accountType || "student");
    const shouldSeeUseUpgradeButton = ()=>{
        if (assessment.isUltimate) return false;
        if (moderatorPlus) return true;
        if (!currentPlan.isUsageCapsEnabled) return false;
        return true;
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $537b6aedceb28a63$export$c3554b6de8b50f8e), {
        ...baseAssignmentCardProps,
        testTag: assessment.id,
        showMobile: showMobile,
        title: assessment.name,
        ultimate: showUltimate,
        subTitle: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "stretch",
            height: "32px",
            direction: "row",
            justify: "center",
            children: [
                moderatorPlus && assessment.isSample && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                    color: "danger",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h3",
                        children: "SAMPLE ASSIGNMENT"
                    })
                }),
                canAssign && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            to: assignToPath,
                            displayType: "outline",
                            color: "primaryBlue",
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                            testTag: `${assessment.id}-assign-to-button`,
                            onClick: (e)=>e.stopPropagation(),
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: "plus",
                                        size: "0.75em"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    "Assign"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($a679044e49a453d7$var$AssignedCourses, {
                    courseMap: courseMap,
                    assessment: assessment,
                    courseIds: courseIds
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "end",
            align: "end",
            grow: 1,
            padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} 0 0`,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                displayType: "outline",
                options: [
                    ...shouldSeeUseUpgradeButton() ? [
                        {
                            children: "Upgrade Assignment",
                            onClick: currentUser?.ultimateAssessmentsAvailable === 0 && !moderatorPlus ? ()=>setField("ultimateAssessmentsOverviewOpened")(true) : ()=>startAssignmentUpgrade(assessment.id, "assignmentCard"),
                            color: "primaryBlue"
                        }
                    ] : [],
                    ...hideViewDetails ? [] : [
                        {
                            children: "View Details",
                            to: baseAssignmentCardProps.to
                        }
                    ],
                    {
                        children: "Assign",
                        to: assignToPath
                    },
                    {
                        children: "Edit",
                        to: `/t/assignment-builder/${assessment.id}`
                    },
                    ...hideShare ? [] : [
                        {
                            children: "Share",
                            onClick: ()=>openShareModal(assessment.id)
                        }
                    ],
                    {
                        children: "Duplicate",
                        onClick: ()=>openDuplicateModal(assessment.id)
                    },
                    {
                        children: `${assessment.status === "archived" ? "Una" : "A"}rchive`,
                        onClick: ()=>openStatusUpdateModal(assessment, "toggleArchive")
                    },
                    {
                        children: "Delete",
                        onClick: ()=>openStatusUpdateModal(assessment, "delete"),
                        color: "danger"
                    }
                ],
                children: "Actions"
            })
        })
    });
};
const $a679044e49a453d7$export$81dfe1808f15259c = /*#__PURE__*/ (0, $g5BLJ.memo)($a679044e49a453d7$var$UnmemoizedTeacherAssignmentCard);




var $g5BLJ = parcelRequire("g5BLJ");




const $b80951e1033e6596$var$TimeEstimateStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039)((0, $31d38d276dc0d530$export$f51f4c4ede09e011)).withConfig({
    displayName: "StudentAssignmentCard__TimeEstimateStyles",
    componentId: "sc-1gx509a-0"
})([
    "overflow:none;visibility:",
    ";"
], (props)=>props.visible ? "visible" : "hidden");
const $b80951e1033e6596$export$5d2fdc840dd37092 = ({ assessment: assessment , status: status , courseIds: courseIds , courseMap: courseMap , reaction: reaction , ...baseAssignmentCardProps })=>{
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    const statusTag = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $f83bc0215c679685$export$3288d34c523a1192), {
        color: status.color,
        align: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h6",
                children: status.label
            }),
            reaction !== "undecided" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ba614b87bf9c7fa$export$d2ae4167a30cf6bb), {
                        kind: reaction
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $537b6aedceb28a63$export$c3554b6de8b50f8e), {
        ...baseAssignmentCardProps,
        testTag: assessment.id,
        coverImg: assessment.coverImageUrl,
        title: assessment.name,
        isStudent: true,
        subTitle: showMobile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
                    children: statusTag
                }),
                !assessment.independentOnly && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                            vertical: true,
                            size: 1
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($b80951e1033e6596$var$TimeEstimateStyles, {
                            visible: !assessment.independentOnly,
                            direction: "column",
                            align: "start",
                            width: "80px",
                            padding: `0 0 0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]}`,
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    color: "primaryBlue",
                                    variant: "h5",
                                    whiteSpace: "nowrap",
                                    children: [
                                        assessment.estimatedReadingTime,
                                        " min"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    color: "gray5",
                                    variant: "h7",
                                    children: "Est. Read"
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "stretch",
            children: statusTag
        }),
        showMobile: showMobile,
        children: !showMobile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            justify: "end",
            align: "center",
            grow: 1,
            padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
            children: [
                courseIds.map((courseId)=>{
                    const course = courseMap.get(courseId);
                    return !course ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                                backgroundColor: course.avatarColor,
                                name: course.name
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            })
                        ]
                    }, courseId);
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 5
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                    vertical: true,
                    size: 1,
                    noMargin: true,
                    color: assessment.independentOnly ? "transparent" : undefined
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 5
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($b80951e1033e6596$var$TimeEstimateStyles, {
                    visible: !assessment.independentOnly,
                    direction: "column",
                    align: "start",
                    width: "80px",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "primaryBlue",
                            variant: "h4",
                            whiteSpace: "nowrap",
                            children: [
                                assessment.estimatedReadingTime,
                                " min"
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "gray5",
                            variant: "h7",
                            children: "Est. Read"
                        })
                    ]
                })
            ]
        })
    });
};








const $f74c17054336d2ed$var$xPadding = (0, $8259eb090983b778$export$ea413736286a3bf1)[4];
const $f74c17054336d2ed$var$DrawerStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Drawer__DrawerStyles",
    componentId: "sc-1cjz80p-0"
})([
    "display:flex;background-color:",
    ";padding:",
    ";border-radius:",
    ";",
    " ",
    " ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray1.hex, ({ $saved: $saved  })=>$saved ? `${(0, $8259eb090983b778$export$ea413736286a3bf1).half} ${(0, $8259eb090983b778$export$ea413736286a3bf1).half} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}` : `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} ${$f74c17054336d2ed$var$xPadding}`, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], ({ $expanded: $expanded  })=>$expanded && "width: 100%;", ({ $saved: $saved  })=>`border: 1px solid ${$saved ? (0, $24b764039c44d1ec$export$8f45430ccf837300).green.hex : "transparent"};`, ({ $displayType: $displayType  })=>$displayType === "desktop" && `margin-bottom: ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]};`);
const $f74c17054336d2ed$var$DrawerHeader = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Drawer__DrawerHeader",
    componentId: "sc-1cjz80p-1"
})([
    "display:flex;align-items:start;max-height:125px;"
]);
const $f74c17054336d2ed$var$DrawerDivider = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Drawer__DrawerDivider",
    componentId: "sc-1cjz80p-2"
})([
    "height:1px;flex-shrink:0;background-color:",
    ";align-self:stretch;margin:",
    " ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray4.hex, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], `-${$f74c17054336d2ed$var$xPadding}`);
const $f74c17054336d2ed$var$DrawerContent = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Drawer__DrawerContent",
    componentId: "sc-1cjz80p-3"
})([
    "display:flex;width:100%;align-items:",
    ";align-self:flex-start;justify-content:center;",
    ""
], ({ expanded: expanded  })=>expanded ? "start" : "center", ({ expanded: expanded  })=>expanded && `min-height: 0; height: 100%; `);
const $f74c17054336d2ed$export$4071300121a182f5 = ({ children: children , header: header , expanded: expanded = false , saved: saved = false , displayType: displayType = "desktop"  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f74c17054336d2ed$var$DrawerStyles, {
        $expanded: expanded,
        $saved: saved,
        $displayType: displayType,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                width: "100%",
                children: [
                    saved && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    header && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f74c17054336d2ed$var$DrawerHeader, {
                        children: header
                    }),
                    header && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f74c17054336d2ed$var$DrawerDivider, {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f74c17054336d2ed$var$DrawerContent, {
                        expanded: expanded,
                        children: children
                    })
                ]
            }),
            saved && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                icon: "checkmarkCircle",
                color: "green",
                size: "1.75em"
            })
        ]
    });
};







const $e4ad9cb1b5a13026$var$QuestionContent = ({ currentTaskSubmissionDetails: currentTaskSubmissionDetails , displayType: displayType , textSize: textSize = 16  })=>{
    const { task: task , questionAudioFile: questionAudioFile  } = currentTaskSubmissionDetails;
    const isRecording = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: AppData  })=>AppData.isRecording, []);
    if (task.questionType === "recorded") {
        if (questionAudioFile?.url) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            align: "center",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                placeholder: "Listen to the Question",
                audioFileId: questionAudioFile.id,
                src: questionAudioFile.url,
                displayType: "desktopSmall",
                disabled: isRecording,
                testTag: "comprehension-play-button"
            })
        });
        else return null;
    } else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        whiteSpace: "pre-wrap",
        maxWidth: displayType === "drawerClosed" ? "400px" : "100%",
        maxHeight: displayType === "drawerClosed" ? "75px" : "100%",
        overflowY: "auto",
        sizeOverride: textSize,
        children: task.writtenContent
    });
};
const $e4ad9cb1b5a13026$export$6f0f9793d5b4ba54 = ({ displayType: displayType , toggleOpen: toggleOpen , currentTaskSubmissionDetails: currentTaskSubmissionDetails , textSize: textSize  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        width: "100%",
        justify: "space-between",
        height: displayType === "mainContent" ? undefined : "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Question prompt:"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 10
                    }),
                    displayType !== "mainContent" && toggleOpen ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2364f311682cff2$export$7029a83b832ebcac), {
                        expanded: displayType === "drawerOpen",
                        toggleOpen: toggleOpen
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e4ad9cb1b5a13026$var$QuestionContent, {
                currentTaskSubmissionDetails: currentTaskSubmissionDetails,
                displayType: displayType,
                textSize: textSize
            })
        ]
    });






var $g5BLJ = parcelRequire("g5BLJ");

const $99e1e58376b11da3$export$5313b17bb82557eb = ({ dirty: dirty , children: children , message: message = "Leave without saving your changes?"  })=>{
    // When dirty changes, we want to set window.onbeforeunload to true
    // so that our prompt shows if the user tries to leave the website
    (0, $g5BLJ.useEffect)(()=>{
        const onBeforeUnload = (event)=>{
            // Cancel the event as stated by the standard.
            event.preventDefault();
            // Chrome requires returnValue to be set.
            event.returnValue = "";
        };
        if (dirty) window.addEventListener("beforeunload", onBeforeUnload);
        else window.removeEventListener("beforeunload", onBeforeUnload);
        return ()=>{
            window.removeEventListener("beforeunload", onBeforeUnload);
        };
    }, [
        dirty
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$83716a4aa1642908), {
                message: message,
                when: dirty
            }),
            children
        ]
    });
};






const $be64e7ee3b40f0c7$export$13c138588c4d3358 = ({ children: children , enabled: enabled , content: content , display: display , linkLocation: linkLocation , onClick: onClick , usageCapsEnabled: usageCapsEnabled , availableUltimateAssessments: availableUltimateAssessments = 0  })=>{
    if (usageCapsEnabled && availableUltimateAssessments > 0) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        display: display,
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "black",
                            children: "Use an Ultimate Assignment"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 1
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "ultimateAssignmentCentered",
                            size: "1.2em"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 1
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            children: "to access this feature!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    justify: "center",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            onClick: onClick,
                            display: "inline",
                            flexDisplay: "inline-flex",
                            children: "Upgrade Assignment"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "black",
                            children: [
                                "(",
                                availableUltimateAssessments,
                                " remaining)"
                            ]
                        })
                    ]
                })
            ]
        }),
        disabled: !enabled,
        children: children
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        display: display,
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            color: "black",
            children: [
                content,
                " ",
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    to: linkLocation !== "contact" ? "/t/plans" : undefined,
                    display: "inline",
                    flexDisplay: "inline-flex",
                    href: linkLocation === "contact" ? "https://www.readlee.com/contact" : undefined,
                    newTab: linkLocation === "contact",
                    children: linkLocation === "contact" ? "Contact Us!" : "View Plans and Pricing"
                })
            ]
        }),
        disabled: !enabled,
        children: children
    });
};






var $g5BLJ = parcelRequire("g5BLJ");






const $64f69cfb05c6e0a4$var$DefinitionList = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).ol.withConfig({
    displayName: "DictionaryModal__DefinitionList",
    componentId: "sc-67aqoy-0"
})([
    "padding:",
    " ",
    " ",
    " ",
    ";margin:",
    " ",
    " ",
    " ",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1).none, (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $8259eb090983b778$export$ea413736286a3bf1).none, (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[1], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none);
const $64f69cfb05c6e0a4$var$Definition = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).li.withConfig({
    displayName: "DictionaryModal__Definition",
    componentId: "sc-67aqoy-1"
})([
    "padding:",
    ";margin:",
    ";font-size:",
    "px;"
], (0, $8259eb090983b778$export$ea413736286a3bf1).none, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none, (0, $75cd274e63beb59b$export$74d9cec7d2c95116));
const $64f69cfb05c6e0a4$export$d71b1ece068cd974 = ()=>{
    const { displayWord: displayWord , word: word , open: open , audioUrl: audioUrl , displayDefinitions: displayDefinitions , definitions: definitions , synonyms: synonyms , isLoading: isLoading , load: load , report: report , setField: setField , error: error  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            ...s.DictionaryData
        }), []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    (0, $g5BLJ.useEffect)(load, [
        load
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: (0, $e6116bf527c207db$export$9a00dee1beb8f576)(displayWord?.content || word),
        openType: "state",
        opened: open,
        close: load,
        middleHeader: audioUrl ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2,
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                    src: audioUrl,
                    displayType: "iconOnly",
                    icon: "speaker",
                    iconColor: "black",
                    subText: displayWord?.lemmaWord && displayWord.lemmaWord.toLowerCase() !== displayWord.content.toLowerCase() ? (0, $e6116bf527c207db$export$9a00dee1beb8f576)(displayWord.lemmaWord) : undefined
                })
            ]
        }) : null,
        rightHeader: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                    content: "Report inappropriate definition",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        icon: "flag",
                        testTag: "report-button",
                        displayType: "iconOnly",
                        color: "white",
                        iconColor: "danger",
                        iconSize: "1.25em",
                        width: "30px",
                        height: "30px",
                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                        onClick: ()=>report(displayWord?.id || null, createToast)
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                })
            ]
        }),
        children: error ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            variant: "h5",
            children: error
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
            children: isLoading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                margin: (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5],
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                    flex: true
                })
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        display: "inline-flex",
                        wrap: "wrap",
                        padding: `0 0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} 0`,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                            children: synonyms.isEmpty() ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: "Could not find synonyms at this time"
                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                                children: synonyms.map((synonym, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]} 0`,
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                                color: "backgroundDark",
                                                title: synonym,
                                                children: synonym
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                size: 1,
                                                horizontal: true
                                            })
                                        ]
                                    }, i))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                        testTag: "definitions-button",
                        icon: displayDefinitions ? "arrowUp" : "arrowDown",
                        display: "flex",
                        justify: "space-between",
                        iconColor: "black",
                        iconPosition: "right",
                        iconSize: "20px",
                        onClick: ()=>setField("displayDefinitions")(!displayDefinitions),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h4",
                            children: "Definitions"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($64f69cfb05c6e0a4$var$DefinitionList, {
                        children: displayDefinitions && definitions.map((d, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($64f69cfb05c6e0a4$var$Definition, {
                                children: d
                            }, i))
                    })
                ]
            })
        })
    });
};





var $g5BLJ = parcelRequire("g5BLJ");
const $fa8c2e5d82ef81ca$export$f99233281efd08a0 = ({ title: title  })=>{
    (0, $g5BLJ.useEffect)(()=>{
        document.title = `${title} | Readlee`;
        return ()=>{
            document.title = "Readlee";
        };
    }, [
        title
    ]);
    return null;
};






var $g5BLJ = parcelRequire("g5BLJ");






const $c804cca3b5e1a4fd$var$Stat = ({ name: name , value: value  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h5",
                color: "white",
                children: value
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h7",
                color: "gray5",
                children: name
            })
        ]
    });
};
const $c804cca3b5e1a4fd$var$PremiumStat = ({ name: name , value: value , blur: blur  })=>{
    const renderedValue = (0, $g5BLJ.useMemo)(()=>blur ? Math.round(Math.random() * 10 ** String(value).length) : value, [
        blur,
        value
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        color: "gray5",
                        children: [
                            name,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        color: "white",
                        blurrify: blur,
                        children: renderedValue
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
        ]
    });
};
const $c804cca3b5e1a4fd$var$FreeStats = ({ readingTaskSubmissionDetails: readingTaskSubmissionDetails , lastSubmitted: lastSubmitted  })=>{
    const { taskSubmission: taskSubmission , task: task  } = readingTaskSubmissionDetails;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$Stat, {
                        name: "Total Time Read",
                        value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, taskSubmission.totalTime)
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$Stat, {
                        name: "Last Submitted",
                        value: (0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(lastSubmitted))
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$Stat, {
                        name: "Total Words",
                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.wordSaidCount)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                children: [
                    task.readingPartType === "independent" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$Stat, {
                        name: "Speed (WPM)",
                        value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, taskSubmission.wordsPerMinute)
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$Stat, {
                                name: "Completion",
                                value: `${(0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, taskSubmission.simpleCompletion)}`
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$Stat, {
                                name: "Speed (WCPM)",
                                value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, taskSubmission.wordsCorrectPerMinute)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$Stat, {
                        name: "Unique Words Read",
                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.uniqueWordSaidCount)
                    })
                ]
            })
        ]
    });
};
const $c804cca3b5e1a4fd$var$PremiumStats = ({ readingTaskSubmissionDetails: readingTaskSubmissionDetails  })=>{
    const { currentUser: currentUser , currentPlan: currentPlan , assessment: assessment , startAssignmentUpgrade: startAssignmentUpgrade  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            currentUser: s.AppData.currentUser,
            currentPlan: s.AppData.currentPlan,
            assessment: s.SubmissionOverviewData.assessment,
            startAssignmentUpgrade: s.UpgradeAssignmentModalData.startAssignmentUpgrade
        }), []);
    const [showAdvancedStats, setShowAdvancedStats] = (0, $g5BLJ.useState)(false);
    const { taskSubmission: taskSubmission , task: task  } = readingTaskSubmissionDetails;
    const isAdvancedAnalyticsEnabled = (0, $4ded3b2c5af96cca$export$cff2a6c9a7debd3)("isAdvancedAnalyticsEnabled", currentUser, assessment, false);
    const blur = !isAdvancedAnalyticsEnabled;
    const usageCapsEnabled = currentPlan.isUsageCapsEnabled;
    const availableUltimateAssessments = currentUser?.ultimateAssessmentsAvailable ?? 0;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        color: "white",
                        onClick: ()=>setShowAdvancedStats(!showAdvancedStats),
                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                        children: [
                            "ADVANCED STATS",
                            !isAdvancedAnalyticsEnabled ? ` - ${(0, $4ded3b2c5af96cca$export$54b31349b35ae5fd).toUpperCase()}` : "",
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: showAdvancedStats ? "selectArrowUp" : "selectArrowDown",
                                size: "1em"
                            })
                        ]
                    })
                ]
            }),
            showAdvancedStats && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
                        content: `Upgrade to ${(0, $4ded3b2c5af96cca$export$52756c3ad45aa25c)} to unlock advanced reading data to drive academic outcomes`,
                        linkLocation: "contact",
                        enabled: !isAdvancedAnalyticsEnabled,
                        usageCapsEnabled: usageCapsEnabled,
                        availableUltimateAssessments: availableUltimateAssessments,
                        onClick: ()=>startAssignmentUpgrade(assessment?.id ?? "", "advancedStats"),
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                name: "Reading Time",
                                value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, taskSubmission.readingTime),
                                blur: blur
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                name: "Non-Reading Time",
                                value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, taskSubmission.emptyTime),
                                blur: blur
                            }),
                            task.readingPartType !== "independent" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Words Assigned",
                                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.wordAssignedCount),
                                        blur: blur
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Unique Words Assigned",
                                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.uniqueWordAssignedCount),
                                        blur: blur
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Correct Words Read",
                                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.correctWordSaidCount),
                                        blur: blur
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Words Added",
                                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.addedWordSaidCount),
                                        blur: blur
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Words Missed",
                                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.missedWordSaidCount),
                                        blur: blur
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Words Replaced",
                                        value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmission.replacedWordSaidCount),
                                        blur: blur
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Speed (WPM)",
                                        value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, taskSubmission.wordsPerMinute),
                                        blur: blur
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStat, {
                                        name: "Accuracy",
                                        value: `${(0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, taskSubmission.correctCompletion)}`,
                                        blur: blur
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $c804cca3b5e1a4fd$export$9703f6f83eb29232 = ({ processing: processing , user: user , readingTaskSubmissionDetails: readingTaskSubmissionDetails , hasPremiumStats: hasPremiumStats = false , lastSubmitted: lastSubmitted , isMobileView: isMobileView = false  })=>{
    return readingTaskSubmissionDetails && user && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        children: processing ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "largeText",
                    textAlign: "center",
                    color: "white",
                    children: "This recording is being processed, please wait..."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                    flex: true
                })
            ]
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    textTransform: "uppercase",
                    color: "white",
                    textAlign: isMobileView ? "center" : "left",
                    children: "My Reading Stats"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$FreeStats, {
                    lastSubmitted: lastSubmitted,
                    readingTaskSubmissionDetails: readingTaskSubmissionDetails
                }),
                hasPremiumStats && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c804cca3b5e1a4fd$var$PremiumStats, {
                    readingTaskSubmissionDetails: readingTaskSubmissionDetails
                })
            ]
        })
    });
};











var $g5BLJ = parcelRequire("g5BLJ");


const $8e7c3ca28aed7cf6$var$TaskCardStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TaskCard__TaskCardStyles",
    componentId: "sc-1j4ka2k-0"
})([
    "background:",
    ";margin-bottom:",
    ";border-radius:",
    ";border:1px solid ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[3], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex);
const $8e7c3ca28aed7cf6$var$ToggleCardOpen = ({ open: open , visible: visible , onToggleCardOpen: onToggleCardOpen , taskId: taskId  })=>!visible ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        displayType: "noStyles",
        onClick: onToggleCardOpen,
        testTag: `toggle-${taskId}`,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
            icon: `arrow${open ? "Up" : "Down"}`,
            strokeWidth: 2,
            color: "gray5",
            cssColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex
        })
    });
const $8e7c3ca28aed7cf6$var$UserBreakdown = ({ label: label , users: users , taskId: taskId , toggleTestTag: toggleTestTag  })=>{
    const [open, toggleOpened] = (0, $g5BLJ.useState)(false);
    const visibleUsers = users.slice(0, 3);
    const overflowUsers = users.slice(3);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        minWidth: "150px",
                        children: [
                            label,
                            " (",
                            users.size,
                            "):"
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            minHeight: "32px",
                            justify: "end",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 8
                                }),
                                visibleUsers.map((user)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                                                name: user.displayName,
                                                backgroundColor: user.avatarColor || (0, $24b764039c44d1ec$export$803ec3cef06b0273)[0]
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true
                                            })
                                        ]
                                    }, user.id)),
                                !overflowUsers.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                                            name: `+${overflowUsers.size}`,
                                            nameList: overflowUsers.map((s)=>s.displayName),
                                            backgroundColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).black,
                                            overflow: true
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true
                                        })
                                    ]
                                }, `${taskId}-completed-overflow`),
                                !users.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "link",
                                    color: "black",
                                    onClick: ()=>toggleOpened(!open),
                                    icon: open ? "arrowUp" : "arrowDown",
                                    iconPosition: "right",
                                    iconSize: "1em",
                                    testTag: toggleTestTag,
                                    children: open ? "Collapse" : "Show All"
                                })
                            ]
                        })
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
                children: users.map((user)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                                        name: user.displayName,
                                        backgroundColor: user.avatarColor || (0, $24b764039c44d1ec$export$803ec3cef06b0273)[0]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        children: (0, $75cd274e63beb59b$export$61b6a526e2f145be)(user)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            })
                        ]
                    }, user.id))
            })
        ]
    });
};
const $8e7c3ca28aed7cf6$var$TaskIcon = ({ icon: icon  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
        align: "center",
        justify: "center",
        minWidth: "68px",
        height: "68px",
        testTag: "large-cover-image-placeholder",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "center",
            justify: "center",
            backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex,
            width: "52px",
            height: "52px",
            borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                icon: icon,
                size: "26px",
                color: "readleeBlue"
            })
        })
    });
const $8e7c3ca28aed7cf6$export$45966d051be1808a = ({ taskDetails: taskDetails , completedStudents: completedStudents , incompleteStudents: incompleteStudents , open: open , onToggleCardOpen: onToggleCardOpen  })=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const onTaskOverviewPage = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/t/assignments/task"));
    const linkToTask = `/t/assignments/task/${taskDetails.type}/${taskDetails.task.id}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
        backPath: `${pathname}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
    })}`;
    const BottomContent = ()=>{
        if (taskDetails.type === "ModelTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray7",
                    children: "Listen To Model Reading"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                        audioFileId: taskDetails.audioFile?.id || "",
                        src: taskDetails.audioFile?.url || ""
                    })
                })
            ]
        });
        else if (taskDetails.type === "ComprehensionTask" && taskDetails.questionAudioFile) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray7",
                    children: [
                        "Listen To ",
                        taskDetails.task.name
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                        testTag: "play-question",
                        src: taskDetails.questionAudioFile.url,
                        audioFileId: taskDetails.questionAudioFile.id
                    })
                })
            ]
        });
        else if (taskDetails.type === "ComprehensionTask" && !taskDetails.questionAudioFile) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray7",
                    children: taskDetails.task.name
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: taskDetails.task.writtenContent
                })
            ]
        });
        else if (taskDetails.type === "VocabTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h4",
                                    children: taskDetails.task.customWord
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2dee512fbabf1618$export$854dd595c92520ae), {
                                    word: taskDetails.word,
                                    task: taskDetails.task
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2dee512fbabf1618$export$3ff687953a83247d), {
                            task: taskDetails.task
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2dee512fbabf1618$export$6e4e2906c67366e6), {
                    imageFile: taskDetails.imageFile,
                    task: taskDetails.task,
                    compactLayout: false
                })
            ]
        });
        else return null;
    };
    const hasBottomContent = taskDetails.type !== "ReadingTask";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8e7c3ca28aed7cf6$var$TaskCardStyles, {
        "data-test-tag": `task-card-${taskDetails.task.id}`,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            width: "100%",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "stretch",
                    width: "100%",
                    padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[5],
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8e7c3ca28aed7cf6$var$TaskIcon, {
                            icon: (0, $dfca2c43c391cf73$export$86cab8d3a8167972)(taskDetails.task)
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "column",
                            width: "100%",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                            displayType: "noStyles",
                                            disabled: onTaskOverviewPage,
                                            to: linkToTask,
                                            disabledOpacityOverride: "1",
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h3",
                                                children: [
                                                    taskDetails.type === "VocabTask" && "Word: ",
                                                    taskDetails.task.name
                                                ]
                                            })
                                        }),
                                        !onTaskOverviewPage && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    horizontal: true,
                                                    size: 2
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                                    to: linkToTask,
                                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                        whiteSpace: "nowrap",
                                                        children: "View Responses"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8e7c3ca28aed7cf6$var$UserBreakdown, {
                                            label: taskDetails.type === "ModelTask" ? "Listened" : "Submitted",
                                            users: completedStudents.sortBy((0, $75cd274e63beb59b$export$61b6a526e2f145be)),
                                            taskId: taskDetails.task.id,
                                            toggleTestTag: `toggle-complete-${taskDetails.task.id}`
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 2
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8e7c3ca28aed7cf6$var$UserBreakdown, {
                                            label: `Did Not ${taskDetails.type === "ModelTask" ? "Listen" : "Submit"}`,
                                            users: incompleteStudents.sortBy((0, $75cd274e63beb59b$export$61b6a526e2f145be)),
                                            taskId: taskDetails.task.id,
                                            toggleTestTag: `toggle-incomplete-${taskDetails.task.id}`
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8e7c3ca28aed7cf6$var$ToggleCardOpen, {
                            visible: hasBottomContent,
                            open: open,
                            onToggleCardOpen: onToggleCardOpen,
                            taskId: taskDetails.task.id
                        })
                    ]
                }),
                hasBottomContent && open && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                            size: 1,
                            noMargin: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[10]}`,
                            direction: "column",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(BottomContent, {})
                        })
                    ]
                })
            ]
        })
    });
};











const $c0758e9270a48b15$export$f360dbd072c6a22a = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TaskSubmissionCard__TaskSubmissionCardStyles",
    componentId: "sc-e5j6gd-0"
})([
    "background:",
    ";padding:",
    ";margin-bottom:",
    ";border-radius:",
    ";border:1px solid ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[5], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[3], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex);
const $c0758e9270a48b15$export$7b5f1f2941347758 = ({ usageCapsEnabled: usageCapsEnabled , availableUltimateAssessments: availableUltimateAssessments , toolTipOnClick: toolTipOnClick , user: user , taskDetails: taskDetails , taskSubmissionDetails: taskSubmissionDetails , assignedCourses: assignedCourses , submissionMap: submissionMap , comprehensionTextDiff: comprehensionTextDiff , canSeeTranscription: canSeeTranscription  })=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const hasSubmission = submissionMap.has(user.id);
    const submission = submissionMap.get(user.id);
    const backPath = `/t/assignments/task/${taskDetails.type}/${taskDetails.task.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`;
    const submissionLink = !submission ? "" : `/submissions/${submission.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
        backPath: backPath
    }))}&currentTaskId=${taskDetails.task.id}`;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c0758e9270a48b15$export$f360dbd072c6a22a, {
        "data-test-tag": `task-submission-card-${user.id}`,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "space-between",
            align: "start",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                    name: user.displayName,
                    backgroundColor: user.avatarColor || (0, $24b764039c44d1ec$export$803ec3cef06b0273)[0],
                    size: "large"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "noStyles",
                                    disabled: !hasSubmission,
                                    to: submissionLink,
                                    disabledOpacityOverride: "1",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h3",
                                        testTag: "task-submission-card-title",
                                        children: (0, $75cd274e63beb59b$export$61b6a526e2f145be)(user)
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 3
                                }),
                                !submission ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                    disabled: hasSubmission,
                                    content: "Assignment not started",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                        to: submissionLink,
                                        children: "View Submission"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "gray7",
                            children: assignedCourses.map((c)=>c.name).join(", ")
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2135cded5d0ee362$export$9d291641d34dfc61), {
                            submission: submission,
                            taskDetails: taskDetails,
                            taskSubmissionDetails: taskSubmissionDetails,
                            comprehensionTextDiff: comprehensionTextDiff,
                            canSeeTranscription: canSeeTranscription,
                            usageCapsEnabled: usageCapsEnabled,
                            availableUltimateAssessments: availableUltimateAssessments,
                            toolTipOnClick: toolTipOnClick
                        })
                    ]
                })
            ]
        })
    });
};









var $g5BLJ = parcelRequire("g5BLJ");


const $2135cded5d0ee362$var$noAnswerText = (taskDetails)=>{
    switch(taskDetails.type){
        case "ModelTask":
            return "Student did not listen to the model reading";
        case "ComprehensionTask":
            return "Student did not answer";
        case "ReadingTask":
            return "Student did not submit recording";
        case "VocabTask":
            return "Student did not view the vocab task";
        default:
            throw new Error(`Unrecognized task type "${JSON.stringify(taskDetails)}"`);
    }
};
const $2135cded5d0ee362$var$NoAnswer = ({ taskDetails: taskDetails  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        variant: "h6",
        children: $2135cded5d0ee362$var$noAnswerText(taskDetails)
    });
};
const $2135cded5d0ee362$var$ReadingSubmissionViewer = ({ submission: submission , taskSubmissionDetails: taskSubmissionDetails , initialPlayProgress: initialPlayProgress , playIndex: playIndex , showStats: showStats  })=>{
    if (!submission || !taskSubmissionDetails) return null;
    const metricsTopRow = [
        {
            label: "Total Time Read",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, submission?.timeRead || 0)
        },
        {
            label: taskSubmissionDetails.reading.contentType === "independent" ? "WPM" : "WCPM",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, taskSubmissionDetails.taskSubmission.wordsCorrectPerMinute)
        },
        {
            label: "Total Words",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words, submission.totalWords || 0)
        },
        {
            label: "Unique Words",
            value: (0, $3e76d4bc3268f884$export$f5dd818bff069720)(taskSubmissionDetails.taskSubmission.uniqueWordSaidCount)
        },
        {
            label: "Last Submitted",
            value: (0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(submission?.finishedAt))
        }
    ].concat(taskSubmissionDetails.reading.contentType !== "independent" ? [
        {
            label: "Completion",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, taskSubmissionDetails.taskSubmission.simpleCompletion)
        }
    ] : []);
    return taskSubmissionDetails.audioFile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                    initialPlayProgress: initialPlayProgress,
                    src: taskSubmissionDetails.audioFile.url,
                    audioFileId: taskSubmissionDetails.audioFile.id,
                    playIndex: playIndex,
                    testTag: `play-submission-${taskSubmissionDetails.taskSubmission.id}`
                })
            }),
            showStats && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4]} 0 0 0`,
                wrap: "wrap",
                children: metricsTopRow.map((metric)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $92a022f5017e679f$export$efdd3e096bc27746), {
                        ...metric
                    }, metric.label))
            })
        ]
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$NoAnswer, {
        taskDetails: taskSubmissionDetails
    });
};
const $2135cded5d0ee362$var$ComprehensionSubmissionViewer = ({ taskSubmissionDetails: taskSubmissionDetails , drawerExpanded: drawerExpanded , textSize: textSize , comprehensionTextDiff: comprehensionTextDiff , canSeeTranscription: canSeeTranscription = false , usageCapsEnabled: usageCapsEnabled , availableUltimateAssessments: availableUltimateAssessments , toolTipOnClick: toolTipOnClick  })=>{
    const responseType = taskSubmissionDetails.task.responseType;
    const hasAudioResponse = [
        "recorded",
        "student_choice"
    ].includes(responseType) && Boolean(taskSubmissionDetails.responseAudioFile?.url);
    const hasTextResponse = [
        "written",
        "student_choice"
    ].includes(responseType) && Boolean(taskSubmissionDetails.taskSubmission.responseContent);
    const [showText, setShowText] = (0, $g5BLJ.useState)(true);
    const [showTranscript, setShowTranscript] = (0, $g5BLJ.useState)(false);
    const [time, setTime] = (0, $g5BLJ.useState)(0);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        width: "100%",
        align: "start",
        maxHeight: drawerExpanded ? "100%" : "300px",
        children: [
            hasAudioResponse && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h6",
                                children: "Audio Response:"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 11
                            }),
                            comprehensionTextDiff && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
                                enabled: !canSeeTranscription,
                                content: `Upgrade to ${(0, $4ded3b2c5af96cca$export$52756c3ad45aa25c)} and unlock student response transcripts`,
                                linkLocation: "contact",
                                usageCapsEnabled: usageCapsEnabled,
                                availableUltimateAssessments: availableUltimateAssessments,
                                onClick: toolTipOnClick,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "link",
                                    disabled: !canSeeTranscription,
                                    onClick: ()=>setShowTranscript(!showTranscript),
                                    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                    children: showTranscript ? "Hide Transcript" : "Show Transcript"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        align: "center",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                            placeholder: "Student Audio",
                            src: taskSubmissionDetails.responseAudioFile?.url || "",
                            audioFileId: taskSubmissionDetails.responseAudioFile?.id,
                            displayType: "desktopSmall",
                            testTag: `play-response-${taskSubmissionDetails.taskSubmission.id}`,
                            playIndex: time,
                            initialPlayProgress: time
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    showTranscript && comprehensionTextDiff && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        testTag: "transcript-container",
                        whiteSpace: "pre-wrap",
                        maxWidth: drawerExpanded ? undefined : "400px",
                        minHeight: showTranscript ? "50px" : "0px",
                        flexGrow: 1,
                        overflowY: "auto",
                        sizeOverride: textSize,
                        wordBreak: "break-all",
                        children: comprehensionTextDiff.map((word, i)=>{
                            const nextWord = comprehensionTextDiff.get(i + 1);
                            return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        onClick: ()=>setTime(word.startTime),
                                        display: "inline",
                                        flexDisplay: "inline-flex",
                                        displayType: "noStyles",
                                        sizeOverride: textSize,
                                        children: word.content
                                    }),
                                    nextWord?.type === "punctuation" ? "" : " "
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            hasAudioResponse && hasTextResponse && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            hasTextResponse && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h6",
                                children: "Written Response:"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                displayType: "link",
                                onClick: ()=>setShowText(!showText),
                                paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                children: showText ? "Hide Response" : "Show Response"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    showText && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        whiteSpace: "pre-wrap",
                        maxWidth: "400px",
                        minWidth: "100%",
                        flexGrow: 1,
                        overflowY: "auto",
                        sizeOverride: textSize,
                        minHeight: showText ? "50px" : "0px",
                        wordBreak: "break-all",
                        children: taskSubmissionDetails.taskSubmission.responseContent
                    })
                ]
            }),
            !hasAudioResponse && !hasTextResponse && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$NoAnswer, {
                taskDetails: taskSubmissionDetails
            })
        ]
    });
};
const $2135cded5d0ee362$var$ModelTaskStudio = ({ taskSubmissionDetails: taskSubmissionDetails  })=>{
    if (taskSubmissionDetails.taskSubmission.completed) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                icon: "check",
                color: "success",
                size: (0, $18ffa0398cff6303$export$66be51d536890fa7)[6]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h6",
                children: "Student listened to the model reading"
            })
        ]
    });
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$NoAnswer, {
        taskDetails: taskSubmissionDetails
    });
};
const $2135cded5d0ee362$var$VocabTaskViewer = ({ taskSubmissionDetails: taskSubmissionDetails  })=>{
    if (taskSubmissionDetails.taskSubmission.completed) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                icon: "check",
                color: "success",
                size: (0, $18ffa0398cff6303$export$66be51d536890fa7)[6]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h6",
                children: "Student viewed the vocab task"
            })
        ]
    });
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$NoAnswer, {
        taskDetails: taskSubmissionDetails
    });
};
const $2135cded5d0ee362$export$9d291641d34dfc61 = ({ submission: submission , taskDetails: taskDetails , taskSubmissionDetails: taskSubmissionDetails , initialPlayProgress: initialPlayProgress , playIndex: playIndex , comprehensionTextDiff: comprehensionTextDiff , showStats: showStats = true , drawerExpanded: drawerExpanded = false , canSeeTranscription: canSeeTranscription = false , textSize: textSize = 16 , usageCapsEnabled: usageCapsEnabled , availableUltimateAssessments: availableUltimateAssessments , toolTipOnClick: toolTipOnClick  })=>{
    if (!taskSubmissionDetails) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$NoAnswer, {
        taskDetails: taskDetails
    });
    if (taskSubmissionDetails.type === "ReadingTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$ReadingSubmissionViewer, {
        submission: submission,
        taskSubmissionDetails: taskSubmissionDetails,
        initialPlayProgress: initialPlayProgress || 0,
        playIndex: playIndex || 0,
        showStats: showStats
    });
    else if (taskSubmissionDetails.type === "ComprehensionTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$ComprehensionSubmissionViewer, {
        taskSubmissionDetails: taskSubmissionDetails,
        drawerExpanded: drawerExpanded,
        textSize: textSize,
        comprehensionTextDiff: comprehensionTextDiff,
        canSeeTranscription: canSeeTranscription,
        usageCapsEnabled: usageCapsEnabled,
        availableUltimateAssessments: availableUltimateAssessments,
        toolTipOnClick: toolTipOnClick
    });
    else if (taskSubmissionDetails.type === "ModelTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$ModelTaskStudio, {
        taskSubmissionDetails: taskSubmissionDetails
    });
    else if (taskSubmissionDetails.type === "VocabTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2135cded5d0ee362$var$VocabTaskViewer, {
        taskSubmissionDetails: taskSubmissionDetails
    });
    else throw new Error("Unrecognized task type");
};








const $92a022f5017e679f$var$MetricContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Metric__MetricContainer",
    componentId: "sc-f4xmkd-0"
})([
    "background-color:",
    ";padding:",
    ";border-radius:",
    ";margin:",
    ";"
], (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex, 0.05), (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]);
const $92a022f5017e679f$export$efdd3e096bc27746 = ({ value: value , label: label  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
        grow: 0,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($92a022f5017e679f$var$MetricContainer, {
            "data-test-tag": "metric",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h4",
                    color: "primaryBlue",
                    children: value
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "normalText",
                    color: "gray5",
                    whiteSpace: "nowrap",
                    children: label
                })
            ]
        })
    });
};







const $c2364f311682cff2$export$7029a83b832ebcac = (props)=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        displayType: "link",
        height: "fit-content",
        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
        color: "primaryBlue",
        onClick: props.toggleOpen,
        width: "fit-content",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h7",
                    lineHeightOverride: "100%",
                    children: props.expanded ? "Exit Full Screen" : "Open in Full Screen"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                    icon: props.expanded ? "collapse" : "expand"
                })
            ]
        })
    });
};







const $eff21641a640db3b$export$94e686fa7071a8d3 = (props)=>{
    const { task: task  } = props.currentTaskSubmissionDetails;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            variant: "h5",
            children: [
                "Vocabulary Word: ",
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                    children: task.customWord
                })
            ]
        })
    });
};







var $g5BLJ = parcelRequire("g5BLJ");

var $208cbee73c04ef85$exports = {};

$208cbee73c04ef85$exports = new URL((parcelRequire("3TfdU")).resolve("cu1C5"), import.meta.url).toString();


var $37822f7e373cec24$exports = {};

$37822f7e373cec24$exports = new URL((parcelRequire("3TfdU")).resolve("3jwEy"), import.meta.url).toString();


var $47513437ba91c7ea$exports = {};

$47513437ba91c7ea$exports = new URL((parcelRequire("3TfdU")).resolve("7D7V6"), import.meta.url).toString();


var $74183a995aff37da$exports = {};

$74183a995aff37da$exports = new URL((parcelRequire("3TfdU")).resolve("800DG"), import.meta.url).toString();


var $8a4e2463e0c40061$exports = {};

$8a4e2463e0c40061$exports = new URL((parcelRequire("3TfdU")).resolve("czTho"), import.meta.url).toString();


var $c736adc89dc7e5a0$exports = {};

$c736adc89dc7e5a0$exports = new URL((parcelRequire("3TfdU")).resolve("e1xMz"), import.meta.url).toString();




const $4ba614b87bf9c7fa$var$reactions = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
    check: {
        value: "check",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($208cbee73c04ef85$exports)))
    },
    clapping: {
        value: "clapping",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($37822f7e373cec24$exports)))
    },
    one_hundred: {
        value: "one_hundred",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($47513437ba91c7ea$exports)))
    },
    rocket: {
        value: "rocket",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($74183a995aff37da$exports)))
    },
    thinking: {
        value: "thinking",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8a4e2463e0c40061$exports)))
    },
    parrot: {
        value: "parrot",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c736adc89dc7e5a0$exports)))
    }
});
const $4ba614b87bf9c7fa$export$d2ae4167a30cf6bb = ({ kind: kind , size: size = "small"  })=>{
    const reaction = $4ba614b87bf9c7fa$var$reactions.get(kind);
    if (!reaction) return null;
    const sizeToUse = size === "small" ? "24px" : "64px";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
        "data-test-tag": `reaction-${kind}`,
        src: reaction.src,
        style: {
            height: sizeToUse,
            width: sizeToUse
        }
    });
};
const $4ba614b87bf9c7fa$var$sharedProps = {
    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
    displayType: "iconOnly",
    width: "36px",
    height: "36px",
    color: "gray2",
    iconColor: "black",
    iconSize: "24px"
};
const $4ba614b87bf9c7fa$export$6ce3894c36b53067 = ({ onClick: onClick , loading: loading  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "space-around",
            children: $4ba614b87bf9c7fa$var$reactions.toList().map((reaction)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            ...$4ba614b87bf9c7fa$var$sharedProps,
                            onClick: ()=>onClick(reaction.value),
                            testTag: `reaction-${reaction.value}`,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4ba614b87bf9c7fa$export$d2ae4167a30cf6bb, {
                                kind: reaction.value
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        })
                    ]
                }, reaction.value))
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            color: "primaryBlue",
            icon: "sticker",
            loading: loading,
            children: "React"
        })
    });
};









const $c22743a123dd1ca8$var$BLOCK_LIST = [
    "/t/assignments/:id",
    "/t/assignments/task/:type/:id",
    "/t/classes",
    "/t/students",
    "/t/progress-monitoring",
    "/t/reading-builder",
    "/t/assignment-builder",
    "/t/public-preview"
];
const $c22743a123dd1ca8$export$c68f88c44d66a8f8 = ()=>{
    const { submit: submit , sending: sending , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            ...s.MobileGateData,
            currentUser: s.AppData.currentUser
        }), []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const showMobileLayout = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const onBlockedPath = $c22743a123dd1ca8$var$BLOCK_LIST.some((p)=>Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, p)));
    return !showMobileLayout || !onBlockedPath ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8526a011da4f152b$export$2b77a92f1a5ad772), {
        forceFullscreen: true,
        openType: "state",
        opened: true,
        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[8],
            height: "100%",
            justify: "space-between",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "center",
                    margin: (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4],
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7eb33c08429d75e4$export$ce671d21b66bb548), {
                        logoType: currentUser?.paperSyncedAt ? "paper-reading" : "full-name",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    justify: "center",
                    height: "100%",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h3",
                            textAlign: "center",
                            children: "You need a bigger screen to access all the features on this page!"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 8
                        }),
                        currentUser?.email && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h4",
                                    children: "1. Click the button below to email yourself a link to this page"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h4",
                                    children: "2. Open up the link on a laptop or desktop computer"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h4",
                                    children: "3. Pick up where you left off"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    align: "center",
                    children: [
                        currentUser?.email && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: submit(createToast),
                            loading: sending,
                            children: "Send Email"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "outline",
                            to: "/",
                            children: "Go Home"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6
                        })
                    ]
                })
            ]
        })
    });
};








var $g5BLJ = parcelRequire("g5BLJ");
const $aebf6eac7f74b94e$export$76529f19140ac2e7 = ({ rating: rating , borderColor: borderColor , onClick: onClick  })=>{
    const [starHover, setStarHover] = (0, $g5BLJ.useState)(0);
    const buttonFilled = (val)=>val < starHover || val < (rating ?? 0) && starHover === 0;
    const iconFill = (val)=>onClick ? buttonFilled(val) : val < rating;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        children: [
            ...Array((0, $82a43f48d9c20dff$export$83f25f0085c5a6ed))
        ].map((_, val)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                testTag: `star-${val + 1}-${iconFill(val) ? "filled" : "empty"}`,
                children: onClick ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "white",
                    displayType: "noStyles",
                    icon: "star",
                    iconColor: buttonFilled(val) ? "warning" : borderColor,
                    iconFill: buttonFilled(val),
                    onMouseOver: ()=>setStarHover(val + 1),
                    onMouseOut: ()=>setStarHover(0),
                    onClick: ()=>onClick(val)
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                    icon: "star",
                    fill: true,
                    fillColor: val < rating ? "warning" : "white",
                    color: val < rating ? "warning" : borderColor
                })
            }, val))
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


const $f68db7b49184ba1f$export$d4f0dafeee17594b = ({ url: url , title: title = "Readlee Assignment" , body: body = "Click the link below to complete your assignment on Readlee." , tooltipContent: tooltipContent = "Click here to share in Google Classroom" , itemType: itemType = "assignment" , size: size = 32 , googleCourseId: googleCourseId  })=>{
    const baseId = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    (0, $g5BLJ.useEffect)(()=>{
        const script = document.createElement("script");
        script.src = "https://apis.google.com/js/platform.js";
        script.async = true;
        script.defer = true;
        script.addEventListener("load", (_)=>{
            window.gapi.sharetoclassroom.render(`google-share-button-${baseId}`, {
                itemtype: itemType,
                courseid: googleCourseId,
                body: body,
                url: url,
                size: size,
                title: title
            });
        });
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script);
        };
    }, [
        url,
        itemType,
        size,
        googleCourseId,
        title,
        body,
        baseId
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
            "data-test-tag": "google-share-button",
            id: `google-share-button-${baseId}`
        })
    });
};








var $3133a4696ba5e0e5$exports = {};

$3133a4696ba5e0e5$exports = new URL((parcelRequire("3TfdU")).resolve("baZ4y"), import.meta.url).toString();


const $b22773065c4c76be$var$AvatarContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentAvatar__AvatarContainer",
    componentId: "sc-pizhu2-0"
})([
    "position:relative;height:",
    "px;width:",
    "px;background:",
    ";border-radius:",
    ";box-shadow:",
    ";"
], ({ $size: $size  })=>$size, ({ $size: $size  })=>$size, (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $borderRadius: $borderRadius  })=>$borderRadius, ({ $boxShadow: $boxShadow  })=>$boxShadow);
const $b22773065c4c76be$var$AvatarElement = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).img.withConfig({
    displayName: "StudentAvatar__AvatarElement",
    componentId: "sc-pizhu2-1"
})([
    "position:absolute;left:0;right:0;top:0;bottom:0;"
]);
const $b22773065c4c76be$export$c39250ac1434c848 = ({ avatarSkin: avatarSkin , avatarEyes: avatarEyes , avatarMouth: avatarMouth , avatarHat: avatarHat , kind: kind , testTag: testTag  })=>{
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "mobileLarge"
    });
    const getAttributes = ()=>{
        switch(kind){
            case "builder":
                return {
                    size: showMobile ? "200" : "300",
                    borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3],
                    boxShadow: `3px 3px 10px ${(0, $24b764039c44d1ec$export$8f45430ccf837300).gray7.hex}`
                };
            case "dashboard":
                return {
                    size: "80",
                    borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3],
                    boxShadow: `3px 3px 10px ${(0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex}`
                };
            case "submission":
                return {
                    size: "60",
                    borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3],
                    boxShadow: `3px 3px 10px ${(0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex}`
                };
            case "profile":
            default:
                return {
                    size: "40",
                    borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[1],
                    boxShadow: `1px 1px 5px ${(0, $24b764039c44d1ec$export$8f45430ccf837300).gray5.hex}`
                };
        }
    };
    const { size: size , borderRadius: borderRadius , boxShadow: boxShadow  } = getAttributes();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($b22773065c4c76be$var$AvatarContainer, {
        $size: size,
        $borderRadius: borderRadius,
        $boxShadow: boxShadow,
        "data-test-tag": testTag,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b22773065c4c76be$var$AvatarElement, {
                src: (0, $7b0ba46fad863bdb$export$1fe81be1fd50fe28)(avatarSkin),
                "data-test-tag": `avatar-color-${avatarSkin}`
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b22773065c4c76be$var$AvatarElement, {
                src: (0, $7b0ba46fad863bdb$export$386693e1a9f87fca)(avatarEyes),
                "data-test-tag": `avatar-eyes-${avatarEyes}`
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b22773065c4c76be$var$AvatarElement, {
                src: (0, $7b0ba46fad863bdb$export$eafcc3332342f066)(avatarMouth),
                "data-test-tag": `avatar-mouth-${avatarMouth}`
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b22773065c4c76be$var$AvatarElement, {
                src: (0, $7b0ba46fad863bdb$export$4c3d7c0ad733edde)(avatarHat),
                "data-test-tag": `avatar-hat-${avatarHat}`
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b22773065c4c76be$var$AvatarElement, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($3133a4696ba5e0e5$exports))),
                "data-test-tag": "avatar-border"
            })
        ]
    });
};
const $b22773065c4c76be$export$7334e79c2ba625e7 = ({ user: user , ...baseProps })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b22773065c4c76be$export$c39250ac1434c848, {
        ...baseProps,
        ...user
    });







const $9e0eec0a21547834$var$tooltipContent = (user, isCurrent)=>{
    if (isCurrent) return `You have a reading streak of ${(0, $e6116bf527c207db$export$cefb40c9962541b5)("day", user.currentStreak)}!${user.currentStreakStatus === "expiring" ? " Read before the end of the day to keep your streak alive!" : ""}`;
    else return `${user.name} has a reading streak of ${(0, $e6116bf527c207db$export$cefb40c9962541b5)("day", user.currentStreak)}.`;
};
const $9e0eec0a21547834$export$a3afbf2185482701 = ({ user: user , isCurrent: isCurrent  })=>{
    if (user && user.currentStreakStatus !== "none") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: $9e0eec0a21547834$var$tooltipContent(user, isCurrent),
        display: "inline",
        children: [
            " ",
            "\uD83D\uDD25",
            user.currentStreak,
            " ",
            isCurrent && user.currentStreakStatus === "expiring" ? `⌛` : ""
        ]
    });
    else return null;
};







const $0230275b783b39cd$export$acbce29fea0b3d95 = ({ newTagName: newTagName , tagNameList: tagNameList , disabled: disabled = false , errors: errors , updateTag: updateTag , addTag: addTag , removeTag: removeTag  })=>{
    const onKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === "Tab") {
            event.preventDefault();
            addTag();
        }
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "tags",
                        type: "text",
                        value: newTagName || "",
                        onChange: updateTag,
                        errors: errors,
                        testTag: "tag-input",
                        onKeyDown: onKeyDown,
                        disabled: disabled
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: addTag,
                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                        disabled: disabled,
                        children: "Add Tag"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                wrap: "wrap",
                children: tagNameList.map((tagName, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                color: "white",
                                removeable: true,
                                onRemove: removeTag(tagName),
                                testTag: `tag-${tagName}`,
                                disabled: disabled,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    lineHeightOverride: "120%",
                                    whiteSpace: "nowrap",
                                    overflowY: "hidden",
                                    ellipsis: true,
                                    maxWidth: "75px",
                                    title: tagName,
                                    children: tagName
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                        ]
                    }, i))
            })
        ]
    });
};








const $822922ed63c79903$export$1a6938bd84cc541a = (props)=>{
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const { saving: saving , errors: errors , opened: opened , loading: loading , closeModal: closeModal , upgradeAssignment: upgradeAssignment , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            saving: state.UpgradeAssignmentModalData.saving,
            errors: state.UpgradeAssignmentModalData.errors,
            opened: state.UpgradeAssignmentModalData.opened,
            loading: state.UpgradeAssignmentModalData.loading,
            closeModal: state.UpgradeAssignmentModalData.closeModal,
            upgradeAssignment: state.UpgradeAssignmentModalData.upgradeAssignment,
            currentUser: state.AppData.currentUser
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        opened: opened,
        openType: "state",
        header: "Upgrade to free Ultimate Assignment",
        middleHeader: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                    icon: "ultimateAssignmentCentered",
                    size: "1.35em"
                })
            ]
        }),
        close: closeModal,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: closeModal,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    testTag: "upgrade-assignment-button",
                    onClick: ()=>upgradeAssignment(createToast, props.onSuccess),
                    loading: saving,
                    children: "Upgrade Assignment"
                })
            ]
        }),
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h5",
                    children: "Unlock some of our favorite features!"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ded3b2c5af96cca$export$9ca18bb3e989d9c3), {}),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h5",
                    textAlign: "center",
                    children: "Use one of your remaining Ultimate Assignments to upgrade."
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    width: "100%",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h2",
                                    lineHeightOverride: "100%",
                                    color: "primaryBlue",
                                    testTag: "ultimate-assessments-available",
                                    children: currentUser?.ultimateAssessmentsAvailable
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "ultimateAssignmentCentered",
                                    size: "2.25em"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "forwardArrow",
                            size: "2.25em",
                            color: "primaryBlue"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h2",
                                    lineHeightOverride: "100%",
                                    color: "primaryBlue",
                                    testTag: "ultimate-assessments-available",
                                    children: (currentUser?.ultimateAssessmentsAvailable ?? 1) - 1
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "ultimateAssignmentCentered",
                                    size: "2.25em"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                    errors: errors,
                    errorKey: "assessment"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                    errors: errors,
                    errorKey: "user"
                })
            ]
        })
    });
};










const $1f775af71fb7b827$var$Dot = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "DotNav__Dot",
    componentId: "sc-100sask-0"
})([
    "height:8px;width:8px;background-color:",
    ";border-radius:",
    ";margin:",
    ";"
], ({ $color: $color  })=>(0, $24b764039c44d1ec$export$8f45430ccf837300)[$color].hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded, (0, $8259eb090983b778$export$ea413736286a3bf1).half);
const $1f775af71fb7b827$var$DotUnderline = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "DotNav__DotUnderline",
    componentId: "sc-100sask-1"
})([
    "width:8px;height:0;border:1px solid ",
    ";box-shadow:0 4px 4px ",
    ";border-radius:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex, (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, 0.25), (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded);
const $1f775af71fb7b827$export$e48f2a666b26b773 = ({ dotList: dotList , activeDot: activeDot , onClick: onClick  })=>{
    if (dotList.isEmpty()) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        children: dotList.map(({ key: key , color: color  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "noStyles",
                        onClick: ()=>onClick(key),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($1f775af71fb7b827$var$Dot, {
                            $color: color
                        })
                    }),
                    activeDot === key && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: "half"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($1f775af71fb7b827$var$DotUnderline, {})
                        ]
                    })
                ]
            }, key))
    });
};









const $5d1a86368f52f068$export$26411c8811cbaaba = ({ children: children  })=>{
    const { currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            currentUser: s.AppData.currentUser
        }), []);
    return currentUser ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
};












var $g5BLJ = parcelRequire("g5BLJ");

const $eb30321ced29024b$export$a06f1c675e846f6f = ({ accountType: accountType = "student"  })=>{
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    const [showDisclaimer, setShowDisclaimer] = (0, $g5BLJ.useState)(false);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        direction: showMobile ? "column" : "row",
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]}`,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "\xa9 ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                        children: "Paper 2023 All rights reserved"
                    })
                ]
            }),
            showMobile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1).none} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
                children: "•"
            }),
            accountType === "student" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                href: "https://pages.paper.co/privacy-statement",
                newTab: true,
                children: "Privacy Policy"
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: ()=>setShowDisclaimer(!showDisclaimer),
                        displayType: "link",
                        children: "Platform Disclaimer"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
                        openType: "state",
                        opened: showDisclaimer,
                        close: ()=>setShowDisclaimer(false),
                        header: "Platform Disclaimer",
                        maxWidthOverride: "700px",
                        children: "Links to content shared by end users or tutors anywhere in the Platform are not endorsed by Paper Education Company Inc. and/or its affiliates (“Paper”). Paper does not represent or warrant it has any rights in or to such content or materials, and disclaims any liability in regards to the use or reliance on such materials or content. Reliance on and use of such materials is at the sole discretion of the end user, and at their own risk. Any user that uploads information or content represents and warrants that they have full legal authority to share such content to the platform and more broadly as applicable, including but not limited to the Paper Reading teacher community, and takes full legal responsibility for and shall indemnify Paper and hold it harmless in the event of any third party claims due to copyright or other intellectual property infringement claims arising as a result of such material and content uploads, or the reliance thereon."
                    })
                ]
            })
        ]
    });
};










function $e83acd29c1368427$var$e(e) {
    this.message = e;
}
$e83acd29c1368427$var$e.prototype = new Error, $e83acd29c1368427$var$e.prototype.name = "InvalidCharacterError";
var $e83acd29c1368427$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $e83acd29c1368427$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $e83acd29c1368427$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($e83acd29c1368427$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $e83acd29c1368427$var$r(t);
    }
}
function $e83acd29c1368427$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $e83acd29c1368427$var$o(e, r) {
    if ("string" != typeof e) throw new $e83acd29c1368427$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($e83acd29c1368427$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $e83acd29c1368427$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$e83acd29c1368427$export$b9721ef022f71a68.prototype = new Error, $e83acd29c1368427$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $e83acd29c1368427$export$2e2bcd8739ae039 = $e83acd29c1368427$var$o;


var $d795d7cf0a6376b8$exports = {};

$parcel$export($d795d7cf0a6376b8$exports, "default", function () { return $d795d7cf0a6376b8$export$2e2bcd8739ae039; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $04ce6dc3660a5604$export$98e6a39c04603d36;
var $04ce6dc3660a5604$export$dfdc1655ccc5b9cb;
"use strict";
$04ce6dc3660a5604$export$98e6a39c04603d36 = $04ce6dc3660a5604$var$parse;
$04ce6dc3660a5604$export$dfdc1655ccc5b9cb = $04ce6dc3660a5604$var$serialize;
/**
 * Module variables.
 * @private
 */ var $04ce6dc3660a5604$var$decode = decodeURIComponent;
var $04ce6dc3660a5604$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $04ce6dc3660a5604$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $04ce6dc3660a5604$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $04ce6dc3660a5604$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $04ce6dc3660a5604$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $04ce6dc3660a5604$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $04ce6dc3660a5604$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$04ce6dc3660a5604$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$04ce6dc3660a5604$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$04ce6dc3660a5604$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$04ce6dc3660a5604$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $04ce6dc3660a5604$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}



function $34f00be6608dbe21$export$56232575010ba89() {
    // Can we get/set cookies on document.cookie?
    return typeof document === "object" && typeof document.cookie === "string";
}
function $34f00be6608dbe21$export$bfce569af136abdc() {
    document.cookie.split(";").forEach(function(c) {
        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
}
function $34f00be6608dbe21$export$d2e637738f5e6ae8(cookies, options) {
    if (typeof cookies === "string") return $04ce6dc3660a5604$export$98e6a39c04603d36(cookies, options);
    else if (typeof cookies === "object" && cookies !== null) return cookies;
    else return {};
}
function $34f00be6608dbe21$export$9f55e081dbb22cd9(value, doNotParse) {
    if (typeof doNotParse === "undefined") // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== "{" && value[0] !== "[" && value[0] !== '"';
    return !doNotParse;
}
function $34f00be6608dbe21$export$bead674655ff515d(value, options) {
    if (options === void 0) options = {};
    var cleanValue = $34f00be6608dbe21$var$cleanupCookieValue(value);
    if ($34f00be6608dbe21$export$9f55e081dbb22cd9(cleanValue, options.doNotParse)) try {
        return JSON.parse(cleanValue);
    } catch (e) {
    // At least we tried
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function $34f00be6608dbe21$var$cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === "j" && value[1] === ":") return value.substr(2);
    return value;
}


var $d795d7cf0a6376b8$var$__assign = undefined && undefined.__assign || function() {
    $d795d7cf0a6376b8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d795d7cf0a6376b8$var$__assign.apply(this, arguments);
};
var $d795d7cf0a6376b8$var$Cookies = /** @class */ function() {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = (0, $34f00be6608dbe21$export$d2e637738f5e6ae8)(cookies, options);
        new Promise(function() {
            _this.HAS_DOCUMENT_COOKIE = (0, $34f00be6608dbe21$export$56232575010ba89)();
        }).catch(function() {});
    }
    Cookies.prototype._updateBrowserValues = function(parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) return;
        this.cookies = $04ce6dc3660a5604$export$98e6a39c04603d36(document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function(params) {
        for(var i = 0; i < this.changeListeners.length; ++i)this.changeListeners[i](params);
    };
    Cookies.prototype.get = function(name, options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        return (0, $34f00be6608dbe21$export$bead674655ff515d)(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function(options, parseOptions) {
        if (options === void 0) options = {};
        this._updateBrowserValues(parseOptions);
        var result = {};
        for(var name_1 in this.cookies)result[name_1] = (0, $34f00be6608dbe21$export$bead674655ff515d)(this.cookies[name_1], options);
        return result;
    };
    Cookies.prototype.set = function(name, value, options) {
        var _a;
        if (typeof value === "object") value = JSON.stringify(value);
        this.cookies = $d795d7cf0a6376b8$var$__assign($d795d7cf0a6376b8$var$__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $04ce6dc3660a5604$export$dfdc1655ccc5b9cb(name, value, options);
        this._emitChange({
            name: name,
            value: value,
            options: options
        });
    };
    Cookies.prototype.remove = function(name, options) {
        var finalOptions = options = $d795d7cf0a6376b8$var$__assign($d795d7cf0a6376b8$var$__assign({}, options), {
            expires: new Date(1970, 1, 1, 0, 0, 1),
            maxAge: 0
        });
        this.cookies = $d795d7cf0a6376b8$var$__assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) document.cookie = $04ce6dc3660a5604$export$dfdc1655ccc5b9cb(name, "", finalOptions);
        this._emitChange({
            name: name,
            value: undefined,
            options: options
        });
    };
    Cookies.prototype.addChangeListener = function(callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function(callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) this.changeListeners.splice(idx, 1);
    };
    return Cookies;
}();
var $d795d7cf0a6376b8$export$2e2bcd8739ae039 = $d795d7cf0a6376b8$var$Cookies;


var $a9b04a2a4bb8dddc$export$2e2bcd8739ae039 = (0, $d795d7cf0a6376b8$exports.default);



const $8a14245e3a78cfb1$export$a8a6810e16d5704b = "Something went wrong!";
const $8a14245e3a78cfb1$var$NOT_AUTHORIZED = 401;
const $8a14245e3a78cfb1$var$NOT_AUTHENTICATED = 403;
const $8a14245e3a78cfb1$var$GATEWAY_TIMEOUT = 504;
const $8a14245e3a78cfb1$var$GATEWAY_TIMEOUT_RETRY_SCHEDULE = [
    0,
    2000,
    10000
];
// Longer initial delay here so if the page is being closed the new
// request won't be fired off immediately
const $8a14245e3a78cfb1$var$NO_INTERNET_RETRY_SCHEDULE = [
    1000,
    2000,
    10000
];
const $8a14245e3a78cfb1$export$e9a1d00aaa71b08c = ()=>(0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)();
const $8a14245e3a78cfb1$var$deepUseImmutable = (json)=>{
    if (Array.isArray(json)) return (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(json.map((item)=>$8a14245e3a78cfb1$var$deepUseImmutable(item)));
    else if (json && typeof json === "object") {
        if (json.__map__) return (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(json.__map__.map(([key, value])=>[
                key,
                $8a14245e3a78cfb1$var$deepUseImmutable(value)
            ]));
        else return Object.fromEntries(Object.entries(json).map(([key, value])=>[
                key,
                $8a14245e3a78cfb1$var$deepUseImmutable(value)
            ]));
    } else return json;
};
const $8a14245e3a78cfb1$export$6a2346df6883ad7f = $8a14245e3a78cfb1$var$deepUseImmutable;
const $8a14245e3a78cfb1$export$29b2cd4e7e093283 = ({ method: method = "GET" , files: files , data: data , headers: headers = {} , query: query = {}  })=>{
    if (method === "GET") {
        if (files) throw new Error("Can not send files in GET request.");
        return {
            headers: headers,
            bodyOptions: {},
            queryObject: data ? {
                __json__: JSON.stringify(data),
                ...query
            } : query
        };
    } else if (files) {
        if (headers["Content-Type"]) throw new Error("You can not set content type on a FormData request (i.e. one with files).");
        const formData = new FormData();
        Object.entries(files).forEach(([key, file])=>{
            if (Array.isArray(file)) file.forEach((filePart)=>{
                // Rails will interpret ?key[]=thing&key[]=thing2 as [thing, thing2]
                formData.append(`${key}[]`, filePart);
            });
            else formData.append(key, file);
        });
        formData.append("__json__", JSON.stringify(data || {}));
        return {
            headers: headers,
            bodyOptions: {
                body: formData
            },
            queryObject: query
        };
    } else return {
        headers: {
            "Content-Type": "application/json",
            ...headers
        },
        bodyOptions: {
            body: JSON.stringify(data)
        },
        queryObject: query
    };
};
const $8a14245e3a78cfb1$export$68d86b99fdaf2fad = (queryObject)=>{
    const str = Object.entries(queryObject).map(([key, value])=>`${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
    return str.length > 0 ? `?${str}` : "";
};
const $8a14245e3a78cfb1$export$5c069c93d2b7493f = (time)=>{
    return new Promise((resolve)=>{
        setTimeout(()=>{
            resolve();
        }, time);
    });
};
const $8a14245e3a78cfb1$export$97131b3b5327c27f = new (0, $a9b04a2a4bb8dddc$export$2e2bcd8739ae039)();
const $8a14245e3a78cfb1$export$2ee3e7cd2cd68642 = ()=>$8a14245e3a78cfb1$export$97131b3b5327c27f.get("access_token");
const $8a14245e3a78cfb1$export$246aae0e6bbe96f3 = ()=>$8a14245e3a78cfb1$export$97131b3b5327c27f.get("refresh_token");
const $8a14245e3a78cfb1$export$5dc2ea5ebf4fac10 = ()=>$8a14245e3a78cfb1$export$97131b3b5327c27f.get("token_client");
const $8a14245e3a78cfb1$export$d7aa3ca5dfa60ce0 = ()=>Boolean($8a14245e3a78cfb1$export$97131b3b5327c27f.get("refresh_token"));
const $8a14245e3a78cfb1$export$6f1e17d9a5e45aed = ()=>{
    // NOTE: this will turn null after the jwt expires because the access_token
    // cookie is set to expire, but we want to refresh early
    const token = $8a14245e3a78cfb1$export$2ee3e7cd2cd68642();
    if (token) try {
        return (0, $e83acd29c1368427$export$2e2bcd8739ae039)(token);
    } catch  {
        return;
    }
    return;
};
const $8a14245e3a78cfb1$var$REFRESH_TOKEN_DURATION = 15552000000; // 180 Days
const $8a14245e3a78cfb1$var$isValidRefreshResponse = (data)=>typeof data === "object" && data !== null && "access_token" in data && "refresh_token" in data && "expires_in" in data;
const $8a14245e3a78cfb1$var$createRefreshPaperAccessTokenHook = ()=>{
    let refreshing = false;
    let freeLock;
    let lock;
    const createLock = ()=>{
        lock = new Promise((resolve)=>freeLock = resolve);
    };
    createLock();
    return ()=>{
        return (0, $g5BLJ.useCallback)(()=>{
            const refreshUrl = `${window.location.origin}/laravel/refresh-token`;
            return new Promise((resolve)=>{
                const refreshDone = ()=>{
                    refreshing = false;
                    freeLock();
                    resolve();
                };
                if (!$8a14245e3a78cfb1$export$d7aa3ca5dfa60ce0()) {
                    refreshDone();
                    return;
                }
                if (!refreshing) {
                    refreshing = true;
                    createLock();
                    const accessToken = $8a14245e3a78cfb1$export$2ee3e7cd2cd68642();
                    const tokenClient = $8a14245e3a78cfb1$export$5dc2ea5ebf4fac10();
                    const isMobileWebviewOpened = window.localStorage.getItem("mobileWebviewOpened") === "true";
                    const fetchRefreshToken = async ()=>{
                        let valid = false;
                        let parsedJson = false;
                        try {
                            const response = await fetch(refreshUrl, {
                                headers: {
                                    Authorization: `Bearer ${accessToken}`,
                                    Accept: "application/json",
                                    "Content-Type": "application/json",
                                    ...isMobileWebviewOpened && tokenClient ? {
                                        "token-client": tokenClient
                                    } : {}
                                },
                                method: "POST",
                                body: JSON.stringify({
                                    refresh_token: $8a14245e3a78cfb1$export$246aae0e6bbe96f3()
                                })
                            });
                            const data = await response.json();
                            parsedJson = true;
                            if ($8a14245e3a78cfb1$var$isValidRefreshResponse(data)) {
                                valid = true;
                                $8a14245e3a78cfb1$export$97131b3b5327c27f.set("refresh_token", data["refresh_token"], {
                                    expires: new Date(new Date().getTime() + $8a14245e3a78cfb1$var$REFRESH_TOKEN_DURATION),
                                    path: "/",
                                    secure: true
                                });
                                $8a14245e3a78cfb1$export$97131b3b5327c27f.set("access_token", data["access_token"], {
                                    expires: new Date(new Date().getTime() + 1000 * data["expires_in"]),
                                    path: "/",
                                    secure: true
                                });
                            }
                        } finally{
                            if (valid) {
                                (0, $b73bb7e0f32bbc6d$export$35b96c5a286f4d3e)({
                                    message: "webview_updated_refresh_token",
                                    refreshToken: $8a14245e3a78cfb1$export$246aae0e6bbe96f3() // we know it's a string because of the valid check above
                                });
                                refreshDone();
                            } else if (!parsedJson && true) refreshDone();
                            else window.location.href = `${0, $0fe4eaef81db718a$export$625c2ae8ba020e36}/logout`;
                        }
                    };
                    fetchRefreshToken();
                } else lock.then(()=>refreshDone());
            });
        }, []);
    };
};
const $8a14245e3a78cfb1$export$b648cbd21f3b338f = $8a14245e3a78cfb1$var$createRefreshPaperAccessTokenHook();
const $8a14245e3a78cfb1$var$getPathname = ()=>window.location.pathname.replace(new RegExp(`^${(0, $0fe4eaef81db718a$export$3bf57e33594fa3fe)}`), "");
const $8a14245e3a78cfb1$var$getOriginalPath = ()=>{
    const pathname = $8a14245e3a78cfb1$var$getPathname();
    const { search: search , hash: hash  } = window.location;
    return `${pathname}${search}${hash}`;
};
// These errors indicate a request was cancelled (usually by navigating away) and should not
// be retried
const $8a14245e3a78cfb1$var$cancelledRequestErrors = [
    {
        name: "TypeError",
        message: "cancelled"
    },
    {
        name: "AbortError",
        message: "The operation was aborted."
    },
    {
        name: "Error",
        message: "aborted"
    }
];
// These errors indicate either a cancelled request or that the user has no internet,
// we want to retry them but after a delay to see which it was.
const $8a14245e3a78cfb1$var$noInternetErrors = [
    {
        name: "TypeError",
        message: "NetworkError when attempting to fetch resource."
    },
    {
        name: "TypeError",
        message: "Failed to fetch"
    },
    {
        name: "TypeError",
        message: "Load failed"
    }
];
const $8a14245e3a78cfb1$export$d852f5f778460fa4 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    if (!history) throw new Error("You tried to use `useFetch` in a context where `useHistory` was not available.");
    const { createToast: createToast , closeToast: closeToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const refreshPaperAccessToken = $8a14245e3a78cfb1$export$b648cbd21f3b338f();
    const handleApiError = (0, $g5BLJ.useCallback)(async ({ errorType: errorType , message: message , onNotAuthenticated: onNotAuthenticated , onNotAuthorized: onNotAuthorized , onUnknownError: onUnknownError , onFailedConnectionError: onFailedConnectionError , noRedirect: noRedirect , meta: meta  })=>{
        const finalMessage = message || $8a14245e3a78cfb1$export$a8a6810e16d5704b;
        const redirect = (path)=>noRedirect ? null : history.replace(path);
        const originalPath = $8a14245e3a78cfb1$var$getOriginalPath();
        if (errorType === "NotAuthenticatedError") {
            if (onNotAuthenticated) onNotAuthenticated({
                originalPath: originalPath
            });
            redirect(`/login${$8a14245e3a78cfb1$export$68d86b99fdaf2fad({
                redirectPath: originalPath
            })}`);
        } else if (errorType === "NotAuthorizedError") {
            const errorQuery = $8a14245e3a78cfb1$export$68d86b99fdaf2fad({
                message: finalMessage,
                originalPath: originalPath
            });
            if (onNotAuthorized) onNotAuthorized({
                message: finalMessage,
                originalPath: originalPath
            });
            redirect(`/404${errorQuery}`);
        } else if (errorType === "FailedConnectionError") {
            if (onFailedConnectionError) onFailedConnectionError({
                originalPath: originalPath
            });
            createToast({
                children: "Could not connect to the internet, please check your connection and reload the page.",
                color: "danger",
                forever: true,
                closeAnywhere: false
            });
        } else {
            if (onUnknownError) onUnknownError({
                message: finalMessage,
                originalPath: originalPath
            });
            const errorQuery = $8a14245e3a78cfb1$export$68d86b99fdaf2fad({
                message: finalMessage,
                originalPath: originalPath
            });
            redirect(`/500${errorQuery}`);
            (0, $1ce946abade47122$export$b33b857ad1d9900e)(new (0, $1ce946abade47122$export$1ee61ec16d0f6c5c)(finalMessage, meta || {}));
        }
    }, [
        history,
        createToast
    ]);
    const fetchResponse = (0, $g5BLJ.useCallback)(async (originalUrl, options = {})=>{
        if ((0, $0fe4eaef81db718a$export$2cba2d9d62933240) && !options.refreshingPaperAccessToken && $8a14245e3a78cfb1$var$getPathname() !== "/logout") {
            const now = Date.now() / 1000;
            const refreshTime = ($8a14245e3a78cfb1$export$6f1e17d9a5e45aed()?.exp ?? 0) - 180; // refresh 3 minutes early
            if (now > refreshTime) await refreshPaperAccessToken();
        }
        const url = originalUrl.startsWith("/api/") ? `${0, $0fe4eaef81db718a$export$625c2ae8ba020e36}${originalUrl}` : originalUrl;
        const { bodyOptions: bodyOptions , queryObject: queryObject , headers: headers  } = $8a14245e3a78cfb1$export$29b2cd4e7e093283(options);
        const queryString = $8a14245e3a78cfb1$export$68d86b99fdaf2fad(queryObject);
        let response = null;
        try {
            response = await fetch(`${url}${queryString}`, {
                method: options.method || "GET",
                headers: headers,
                ...bodyOptions
            });
        } catch (err) {
            const error = err;
            if (!(error instanceof Error)) throw error;
            if ($8a14245e3a78cfb1$var$cancelledRequestErrors.some((e)=>e.name === error.name && e.message === error.message)) // Cancel request and return immediately
            return null;
            else if ($8a14245e3a78cfb1$var$noInternetErrors.some((e)=>e.name === error.name && e.message === error.message)) // Continue and process as a no internet error
            response = null;
            else throw error;
        }
        const isNoInternetError = !response;
        const isGatewayTimeoutError = response?.status === $8a14245e3a78cfb1$var$GATEWAY_TIMEOUT;
        const isFailedConnectionError = isNoInternetError || isGatewayTimeoutError;
        let schedule = null;
        if (options.retrySchedule) schedule = options.retrySchedule;
        else if (isNoInternetError) schedule = $8a14245e3a78cfb1$var$NO_INTERNET_RETRY_SCHEDULE;
        else if (isGatewayTimeoutError) schedule = $8a14245e3a78cfb1$var$GATEWAY_TIMEOUT_RETRY_SCHEDULE;
        if (!response || response.status >= 400 || response.status === 0) {
            let body = null;
            let message = $8a14245e3a78cfb1$export$a8a6810e16d5704b;
            if (response) try {
                body = await response.clone().text();
                message = JSON.parse(body).message;
            } catch (error) {
                message = $8a14245e3a78cfb1$export$a8a6810e16d5704b;
            }
            const handleSharedOptions = {
                onNotAuthenticated: options.onNotAuthenticated,
                onNotAuthorized: options.onNotAuthorized,
                onUnknownError: options.onUnknownError,
                onFailedConnectionError: options.onFailedConnectionError,
                message: message,
                noRedirect: options.noRedirect,
                meta: {
                    url: originalUrl,
                    method: options.method,
                    code: response?.status ?? -1,
                    body: body,
                    message: message
                }
            };
            if (response?.status === $8a14245e3a78cfb1$var$NOT_AUTHENTICATED) await handleApiError({
                ...handleSharedOptions,
                errorType: "NotAuthenticatedError",
                message: "Not logged in"
            });
            else if (response?.status === $8a14245e3a78cfb1$var$NOT_AUTHORIZED) await handleApiError({
                ...handleSharedOptions,
                errorType: "NotAuthorizedError"
            });
            else if (schedule && schedule.length > 0 && typeof schedule[0] === "number") {
                let failedConnectionRetryToastId = options.failedConnectionRetryToastId;
                if (isFailedConnectionError && !failedConnectionRetryToastId) failedConnectionRetryToastId = createToast({
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: "Could not connect to Readlee, attempting to reconnect..."
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                                size: "small"
                            })
                        ]
                    }),
                    forever: true,
                    color: "warning",
                    closeAnywhere: false
                });
                const time = schedule[0];
                await $8a14245e3a78cfb1$export$5c069c93d2b7493f(time);
                const retryResult = await fetchResponse(originalUrl, {
                    ...options,
                    failedConnectionRetryToastId: failedConnectionRetryToastId,
                    retrySchedule: schedule.slice(1)
                });
                return retryResult;
            } else if (isFailedConnectionError) {
                if (options.failedConnectionRetryToastId) closeToast(options.failedConnectionRetryToastId);
                await handleApiError({
                    ...handleSharedOptions,
                    errorType: "FailedConnectionError",
                    message: $8a14245e3a78cfb1$export$a8a6810e16d5704b
                });
            } else await handleApiError({
                ...handleSharedOptions,
                errorType: "UnknownError"
            });
        // Success
        } else if (response) {
            if (options.failedConnectionRetryToastId) closeToast(options.failedConnectionRetryToastId);
            if (options.onSuccess) await options.onSuccess(response);
        }
        return response;
    }, [
        refreshPaperAccessToken,
        handleApiError,
        createToast,
        closeToast
    ]);
    const fetchJson = (0, $g5BLJ.useCallback)(async function(url, options = {}) {
        return fetchResponse(url, {
            ...options,
            onSuccess: async (response)=>{
                if (options.onSuccess) try {
                    const result = await response.json();
                    options.onSuccess($8a14245e3a78cfb1$export$6a2346df6883ad7f(result), response);
                } catch (err) {
                    if (options.onUnknownError) {
                        const originalPath = $8a14245e3a78cfb1$var$getOriginalPath();
                        if (err instanceof Error) options.onUnknownError({
                            message: err.message,
                            originalPath: originalPath
                        });
                        else options.onUnknownError({
                            message: "UnknownError",
                            originalPath: originalPath
                        });
                    }
                }
            }
        });
    }, [
        fetchResponse
    ]);
    return {
        handleApiError: handleApiError,
        fetchResponse: fetchResponse,
        fetchJson: fetchJson,
        refreshPaperAccessToken: refreshPaperAccessToken
    };
};


const $4150fa1176669ff8$export$49d5fc8cba920a0 = {
    username: "",
    password: "",
    success: false,
    submitting: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};


const $2edc2fe23f14ee94$export$9b2688cc9a867f81 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("LoginData", (0, $4150fa1176669ff8$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , getFull: getFull , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>set((0, $4150fa1176669ff8$export$49d5fc8cba920a0)),
        submit: ({ redirectPath: redirectPath , courseCode: courseCode , history: history  })=>{
            const { username: username , password: password  } = get();
            set({
                errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
                submitting: true
            });
            fetchJson(`/api/user_sessions`, {
                method: "POST",
                data: {
                    username: username,
                    password: password
                },
                onSuccess: ({ success: success , errors: errors , user: user  })=>{
                    if (!success) {
                        set({
                            success: success,
                            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                            submitting: false
                        });
                        return;
                    }
                    getFull().AppData.onLoggedIn({
                        courseCode: user.accountType === "student" ? courseCode : null,
                        redirectPath: redirectPath,
                        history: history,
                        method: "password"
                    });
                }
            });
        }
    }));




const $d06794c9022003ea$export$49d5fc8cba920a0 = {
    username: "",
    success: false,
    sentToTeacher: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    submitting: false,
    resent: false
};



const $4c0241bac80236b6$export$ca5fa5af1dfc879e = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ForgotPasswordData", (0, $d06794c9022003ea$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        reset: ()=>set((s)=>({
                    ...(0, $d06794c9022003ea$export$49d5fc8cba920a0),
                    username: s.username
                })),
        submit: ()=>{
            const { username: username  } = get();
            set({
                errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
                submitting: true
            });
            fetchJson(`/api/password_resets`, {
                method: "POST",
                data: {
                    username: username
                },
                onSuccess: ({ success: success , errors: errors , sentToTeacher: sentToTeacher  })=>{
                    set({
                        success: success,
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                        sentToTeacher: sentToTeacher,
                        submitting: false
                    });
                }
            });
        }
    }));





const $0df58b4923207593$export$49d5fc8cba920a0 = {
    currentUser: null,
    loading: true,
    schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    currentPlan: (0, $4ded3b2c5af96cca$export$fa35d849a2b6d142)(),
    profileImageFile: null,
    profileImageStoredFile: null,
    dirty: false,
    uploadingProfileImage: false,
    ultimateAssessmentsOverviewOpened: false,
    courseCount: 0,
    isRecording: false
};








var $g5BLJ = parcelRequire("g5BLJ");


var $eYBdv = parcelRequire("eYBdv");
let $a43aa4efcef0fffa$var$zendeskHiders = 0;
const $a43aa4efcef0fffa$var$shouldShowZendesk = (user)=>{
    return user && (user.accountType !== "student" || user.paperId) && $a43aa4efcef0fffa$var$zendeskHiders <= 0;
};
const $a43aa4efcef0fffa$export$3a8a63c2fd80d3b0 = (props)=>{
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: AppData  })=>AppData.currentUser, []);
    const passesBreakpoint = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)(props);
    (0, $g5BLJ.useEffect)(()=>{
        if (passesBreakpoint) {
            $a43aa4efcef0fffa$var$zendeskHiders += 1;
            (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", "hide");
            return ()=>{
                $a43aa4efcef0fffa$var$zendeskHiders -= 1;
                if ($a43aa4efcef0fffa$var$shouldShowZendesk(currentUser)) (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", "show");
            };
        } else return 0, $eYBdv.noop;
    }, [
        currentUser,
        passesBreakpoint
    ]);
};
const $a43aa4efcef0fffa$export$65e5b62a4c490288 = async ({ user: user  })=>{
    $1ce946abade47122$export$8b6bb3dd62a01be2(user);
    const zendeskIdentity = {
        name: user.accountType === "student" ? `${user.givenName}-${user.paperId}` : user.displayName,
        email: user.accountType === "student" ? "" : user.email || user.username || user.id
    };
    if (user.accountType === "student") window.zESettings = {
        webWidget: {
            contactForm: {
                suppress: true
            }
        }
    };
    (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", $a43aa4efcef0fffa$var$shouldShowZendesk(user) ? "show" : "hide");
    (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", "identify", {
        ...zendeskIdentity
    });
    (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", "prefill", {
        name: {
            value: zendeskIdentity.name
        },
        email: {
            value: zendeskIdentity.email
        }
    });
    (0, $86ce6205c10768ba$export$dd8891c5e530f23d)((zd)=>{
        zd.livechat.set({
            name: zendeskIdentity.name,
            email: zendeskIdentity.email ?? ""
        });
        zd.livechat.addTags(`accountType:${user.accountType}`, `status:${user.status}`, `paper_id:${user.paperId || "N/A"}`, `district_id:${user.paperDistrictId || "N/A"}`);
    });
    const { accountType: accountType , ...userAttrs } = user;
    (0, $86ce6205c10768ba$export$6e636fdf34644712)((ac)=>{
        ac.identify(user.username, {
            userType: accountType,
            ...userAttrs
        });
    });
    (0, $86ce6205c10768ba$export$e7f3fc3f3e5b470f)("config", "G-QS97X20YKN");
    (0, $86ce6205c10768ba$export$e7f3fc3f3e5b470f)("set", "user_properties", user);
    const amplitude = await (0, $86ce6205c10768ba$export$5003c5cccf091294)();
    amplitude?.setUserId(user.id);
    amplitude?.setUserProperties({
        ...user
    });
};
const $a43aa4efcef0fffa$export$6817c7e1956cd0c9 = async ()=>{
    (0, $86ce6205c10768ba$export$6e636fdf34644712)((ac)=>{
        ac.identify("anonymous-user", {
            loggedIn: false
        });
    });
};
const $a43aa4efcef0fffa$export$97d28ebd5eab63bb = async ()=>{
    $1ce946abade47122$export$8b6bb3dd62a01be2(null);
    (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", "hide");
    (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", "logout");
    (0, $86ce6205c10768ba$export$617201f1ca055ae9)("webWidget", "clear");
    (0, $86ce6205c10768ba$export$dd8891c5e530f23d)((zd)=>zd.livechat.clearAll());
    (0, $86ce6205c10768ba$export$6e636fdf34644712)((ac)=>ac.reset());
    const amplitude = await (0, $86ce6205c10768ba$export$5003c5cccf091294)();
    amplitude?.setUserId(null);
    amplitude?.regenerateDeviceId();
    $a43aa4efcef0fffa$export$6817c7e1956cd0c9();
};


const $0d509ab7f782af11$var$devEventPrefix = "__dev__";
const $0d509ab7f782af11$var$trackEvent = async (eventName, options = {})=>{
    const prefix = $0d509ab7f782af11$var$devEventPrefix;
    const event = `${prefix}${eventName}`;
    const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const extendedOptions = {
        ...options,
        path: path,
        url: window.location.href,
        pathname: window.location.pathname,
        host: window.location.host,
        query: window.location.search,
        hash: window.location.hash,
        origin: window.location.origin
    };
    (0, $86ce6205c10768ba$export$158e064e680ef045)(event, extendedOptions);
    await (0, $86ce6205c10768ba$export$bb45b2e06acf3cf9)(event, extendedOptions);
};
const $0d509ab7f782af11$export$92ab14d0aa42e41e = ({ loading: loading  })=>// eslint-disable-next-line react/display-name
    ()=>{
        if (!loading) {
            (0, $86ce6205c10768ba$export$6e636fdf34644712)((ac)=>{
                ac.page();
            });
            const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            (0, $86ce6205c10768ba$export$e7f3fc3f3e5b470f)("set", "page_path", path);
            $0d509ab7f782af11$var$trackEvent("page_view");
        }
        return null;
    };
const $0d509ab7f782af11$export$682f4f7f34b277fa = async ({ method: method , user: user , schools: schools  })=>{
    await (0, $a43aa4efcef0fffa$export$65e5b62a4c490288)({
        user: user,
        schools: schools
    });
    await $0d509ab7f782af11$var$trackEvent("login", {
        method: method,
        userId: user.id
    });
};
const $0d509ab7f782af11$export$e73d5273c65fcb57 = async ({ method: method , user: user , schools: schools  })=>{
    await (0, $a43aa4efcef0fffa$export$65e5b62a4c490288)({
        user: user,
        schools: schools
    });
    await $0d509ab7f782af11$var$trackEvent(`${user.accountType}_signup`, {
        method: method,
        userId: user.id
    });
};
const $0d509ab7f782af11$export$5983f165d101388e = async ({ assessment: assessment  })=>{
    await $0d509ab7f782af11$var$trackEvent("create_assessment", {
        assessmentId: assessment.id,
        assessmentName: assessment.name,
        timestamp: assessment.createdAt
    });
};
const $0d509ab7f782af11$export$9f9795024f215d86 = async ({ assessment: assessment , upgradedFor: upgradedFor  })=>{
    await $0d509ab7f782af11$var$trackEvent("upgrade_assessment", {
        assessmentId: assessment.id,
        assessmentName: assessment.name,
        timestamp: assessment.createdAt,
        upgradedFor: upgradedFor
    });
};
const $0d509ab7f782af11$export$b7b5c2a690fb344a = async ({ course: course  })=>{
    await $0d509ab7f782af11$var$trackEvent("create_course", {
        courseId: course.id,
        courseName: course.name,
        timestamp: course.createdAt
    });
};
const $0d509ab7f782af11$export$46d6102056f3fb8d = async ({ course: course  })=>{
    await $0d509ab7f782af11$var$trackEvent("import_course", {
        courseId: course.id,
        courseName: course.name,
        timestamp: course.createdAt
    });
};
const $0d509ab7f782af11$export$fbd1812d64ca88a8 = async ({ assessmentId: assessmentId  })=>{
    await $0d509ab7f782af11$var$trackEvent("assign_assessment", {
        assessmentId: assessmentId
    });
};
const $0d509ab7f782af11$export$ffb9c781421d54d7 = async (options)=>{
    await $0d509ab7f782af11$var$trackEvent("submit_assignment", {
        ...options,
        timestamp: String(new Date().getTime())
    });
};
const $0d509ab7f782af11$export$dd4c7e0a5fc61d5e = async (options)=>{
    await $0d509ab7f782af11$var$trackEvent("recording_completed_event", {
        ...options,
        timestamp: String(new Date().getTime())
    });
};






const $4c4b79d66bfb847b$export$9c754abe2a209721 = (currentUser, fetchJson, event)=>{
    if (!currentUser?.paperSyncedAt) return;
    const { type: type , ...data } = event;
    fetchJson(`/api/paper_events/${type}`, {
        method: "POST",
        data: data
    });
};


const $f880e2ff7e39c6d4$export$bd07b18b9b0c3af1 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("AppData", (0, $0df58b4923207593$export$49d5fc8cba920a0), ({ set: set , get: get , fetchJson: fetchJson , getFull: getFull , setField: setField  })=>({
        setField: setField,
        load: ({ onSuccess: onSuccess , skipStateReset: skipStateReset  } = {})=>{
            if (!skipStateReset) set({
                ...(0, $0df58b4923207593$export$49d5fc8cba920a0),
                loading: true
            });
            fetchJson(`/api/users/me`, {
                noRedirect: true,
                data: {
                    timeZone: (0, $73b0620564a5efc3$export$c3133dbc11f66777)()
                },
                onNotAuthenticated: async ()=>{
                    set({
                        loading: false
                    });
                    await (0, $a43aa4efcef0fffa$export$6817c7e1956cd0c9)();
                },
                onUnknownError: ()=>set({
                        loading: false
                    }),
                onNotAuthorized: ()=>set({
                        loading: false
                    }),
                onSuccess: (data)=>{
                    set({
                        currentUser: data.currentUser,
                        currentPlan: data.currentPlan,
                        loading: false,
                        schools: data.schools,
                        profileImageStoredFile: data.currentUser.profileImageFile,
                        courseCount: data.courseCount
                    });
                    (0, $a43aa4efcef0fffa$export$65e5b62a4c490288)({
                        user: data.currentUser,
                        schools: data.schools
                    });
                    onSuccess?.(data);
                    const { paperId: paperId , accountType: accountType , paperRosterSyncedAt: paperRosterSyncedAt  } = data.currentUser;
                    if (!paperId || !(0, $75cd274e63beb59b$export$21d5f40a3f7d2451)(accountType)) return;
                    if (!paperRosterSyncedAt || new Date().valueOf() - new Date(paperRosterSyncedAt).valueOf() > (0, $73b0620564a5efc3$export$750abf5956643c1a)) getFull().PaperSyncData.sync("auto");
                }
            });
        },
        onSignedUp: ({ user: user , schools: schools , redirectPath: redirectPath , history: history , courseCode: courseCode , method: method , replace: replace = false , replaceLocation: replaceLocation  })=>{
            (0, $0d509ab7f782af11$export$e73d5273c65fcb57)({
                user: user,
                method: method,
                schools: schools
            });
            get().onLoggedIn({
                redirectPath: redirectPath,
                history: history,
                courseCode: courseCode,
                method: method,
                replace: replace,
                replaceLocation: replaceLocation
            });
        },
        onLoggedIn: ({ redirectPath: redirectPath , history: history , courseCode: courseCode , method: method , replace: replace = false , replaceLocation: replaceLocation  })=>{
            (0, $3f04ff595cf374a2$export$40bdc60b7542ca86)();
            const loadUserAndRedirect = (path)=>{
                get().load({
                    onSuccess: (data)=>{
                        (0, $0d509ab7f782af11$export$682f4f7f34b277fa)({
                            method: method,
                            user: data.currentUser,
                            schools: data.schools
                        });
                        const finalPath = path || redirectPath || "/";
                        if (replace) {
                            if (replaceLocation) window.location.replace(finalPath);
                            else history.replace(finalPath);
                        } else history.push(finalPath);
                    }
                });
            };
            if (courseCode) fetchJson(`/api/registrations`, {
                method: "POST",
                data: {
                    courseCode: courseCode
                },
                onSuccess: ()=>loadUserAndRedirect()
            });
            else loadUserAndRedirect();
        },
        logout: (history)=>{
            set((0, $0df58b4923207593$export$49d5fc8cba920a0));
            fetchJson(`/api/user_sessions`, {
                method: "DELETE",
                onSuccess: ()=>{
                    history.replace("/login");
                    (0, $a43aa4efcef0fffa$export$97d28ebd5eab63bb)();
                    (0, $3f04ff595cf374a2$export$40bdc60b7542ca86)();
                    getFull().StudentProgressMonitoringData.clearCache();
                    getFull().ProgressMonitoringData.clearCache();
                    (0, $8a14245e3a78cfb1$export$97131b3b5327c27f).remove("refresh_token");
                    (0, $8a14245e3a78cfb1$export$97131b3b5327c27f).remove("access_token");
                }
            });
        },
        setUserField: (field, createToast, successToast = true, onSuccess)=>(v)=>{
                const { currentUser: currentUser  } = get();
                const update = {
                    [field]: v
                };
                if (!currentUser) return;
                set({
                    currentUser: {
                        ...currentUser,
                        ...update
                    }
                });
                fetchJson(`/api/users/${currentUser.id}`, {
                    method: "PATCH",
                    data: update,
                    onSuccess: ({ success: success , user: user  })=>{
                        if (success) {
                            set({
                                currentUser: user
                            });
                            successToast && createToast({
                                children: "Setting updated!",
                                color: "success",
                                duration: 1000
                            });
                            onSuccess?.();
                        } else {
                            set({
                                currentUser: {
                                    ...currentUser
                                }
                            });
                            createToast({
                                children: "Setting failed to update!",
                                color: "danger"
                            });
                        }
                    }
                });
            },
        setUserFields: (fields, createToast, successToast = true, onSuccess)=>{
            const { currentUser: currentUser  } = get();
            if (!currentUser) return;
            set({
                currentUser: {
                    ...currentUser,
                    ...fields.toObject()
                }
            });
            fetchJson(`/api/users/${currentUser.id}`, {
                method: "PATCH",
                data: fields,
                onSuccess: ({ success: success , user: user  })=>{
                    if (success) {
                        set({
                            currentUser: user
                        });
                        successToast && createToast({
                            children: "Setting updated!",
                            color: "success",
                            duration: 1000
                        });
                        onSuccess?.();
                    } else {
                        set({
                            currentUser: {
                                ...currentUser
                            }
                        });
                        createToast({
                            children: "Setting failed to update!",
                            color: "danger"
                        });
                    }
                }
            });
        },
        uploadProfileImage: (files, createToast)=>{
            const file = files.get(0, null);
            const { currentUser: currentUser  } = get();
            if (!currentUser || !file) return;
            set({
                uploadingProfileImage: true
            });
            fetchJson(`/api/image_stored_files`, {
                method: "POST",
                files: {
                    file: file
                },
                onSuccess: ({ storedFile: storedFile  })=>{
                    fetchJson(`/api/users/${currentUser.id}`, {
                        method: "PATCH",
                        data: {
                            profileImageFileId: storedFile.id
                        },
                        onSuccess: ({ success: success , user: user  })=>{
                            if (success) {
                                set({
                                    currentUser: user,
                                    profileImageStoredFile: storedFile,
                                    profileImageFile: file,
                                    uploadingProfileImage: false
                                });
                                createToast?.({
                                    children: "Setting updated!",
                                    color: "success",
                                    duration: 1000
                                });
                            } else {
                                set({
                                    currentUser: {
                                        ...currentUser
                                    }
                                });
                                createToast?.({
                                    children: "Setting failed to update!",
                                    color: "danger"
                                });
                            }
                        }
                    });
                }
            });
        },
        emitPaperEvent: (event)=>{
            (0, $4c4b79d66bfb847b$export$9c754abe2a209721)(getFull().AppData.currentUser, fetchJson, event);
        }
    }));





const $f77d4152e74f8317$export$49d5fc8cba920a0 = {
    passwordReset: null,
    user: {
        newPassword: "",
        passwordConfirmation: ""
    },
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    submitting: false,
    loading: true
};


const $60cc79729b3515bc$export$c0d0fe2438d83e0c = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ResetPasswordData", (0, $f77d4152e74f8317$export$49d5fc8cba920a0), ({ get: get , set: set , fetchJson: fetchJson  })=>({
        load: (passwordReset)=>{
            set((0, $f77d4152e74f8317$export$49d5fc8cba920a0));
            fetchJson(`/api/password_resets/${passwordReset.id}`, {
                data: {
                    token: passwordReset.token
                },
                onSuccess: ()=>{
                    set({
                        passwordReset: passwordReset,
                        loading: false
                    });
                }
            });
        },
        submit: (history)=>()=>{
                const { passwordReset: passwordReset , user: user  } = get();
                if (!passwordReset) return;
                set({
                    submitting: true
                });
                fetchJson(`/api/password_resets/${passwordReset.id}`, {
                    method: "PATCH",
                    data: {
                        token: passwordReset.token,
                        user: user
                    },
                    onSuccess: (data)=>{
                        if (data.success) history.replace(`/login?justReset=true`);
                        else set({
                            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors),
                            submitting: false
                        });
                    }
                });
            },
        setUserField: (key)=>(value)=>{
                set((state)=>({
                        user: {
                            ...state.user,
                            [key]: value
                        }
                    }));
            }
    }));





const $1483f0c1ae09fb14$export$49d5fc8cba920a0 = {
    loading: true,
    assessment: null,
    submission: null,
    taskSubmissionDetailsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    currentTaskId: null,
    submitting: false,
    showFinishedModal: false,
    taskErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    dirty: false,
    confirmingFinished: false,
    drawerExpanded: false,
    rating: null,
    mobileTaskListOpened: false,
    audioRecorderStatus: "not_started",
    contentModalOpened: false,
    leaving: false,
    profileImageFile: null,
    instructionDetails: null
};





const $21c1499056429a76$export$bf9acc230921b0c0 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ReadingStudioData", (0, $1483f0c1ae09fb14$export$49d5fc8cba920a0), ({ set: set , get: get , setFull: setFull , setField: setField , fetchJson: fetchJson  })=>{
    const setComprehensionTaskField = (key)=>(value)=>{
            set((state)=>{
                const taskSubmissionDetails = state.currentTaskId && state.taskSubmissionDetailsMap.get(state.currentTaskId);
                if (!taskSubmissionDetails || taskSubmissionDetails.type !== "ComprehensionTask") return state;
                return {
                    ...state,
                    dirty: true,
                    taskSubmissionDetailsMap: state.taskSubmissionDetailsMap.set(taskSubmissionDetails.task.id, {
                        ...taskSubmissionDetails,
                        taskSubmission: {
                            ...taskSubmissionDetails.taskSubmission,
                            [key]: value
                        }
                    })
                };
            });
        };
    const setTaskField = (taskSubmissionDetails)=>(key)=>(value)=>{
                set((state)=>{
                    return {
                        ...state,
                        dirty: true,
                        taskSubmissionDetailsMap: state.taskSubmissionDetailsMap.set(taskSubmissionDetails.task.id, {
                            ...taskSubmissionDetails,
                            taskSubmission: {
                                ...taskSubmissionDetails.taskSubmission,
                                [key]: value
                            }
                        })
                    };
                });
            };
    return {
        setField: setField,
        load: ({ assessmentId: assessmentId , isPublicPreview: isPublicPreview  })=>{
            set((0, $1483f0c1ae09fb14$export$49d5fc8cba920a0));
            fetchJson(`/api/readings/studio`, {
                data: {
                    assessmentId: assessmentId,
                    isPublicPreview: isPublicPreview
                },
                onSuccess: (data)=>{
                    set({
                        assessment: data.assessment,
                        taskSubmissionDetailsMap: data.taskSubmissionDetailsMap,
                        instructionDetails: data.instructionDetails,
                        submission: data.submission,
                        rating: data.submission?.rating ?? null,
                        profileImageFile: data.profileImageFile,
                        loading: false
                    });
                }
            });
        },
        setResponseType: setComprehensionTaskField("responseType"),
        setResponseContent: setComprehensionTaskField("responseContent"),
        onRecordingSequenceStatus: (data)=>{
            const { taskSubmissionDetailsMap: taskSubmissionDetailsMap , submit: submit , assessment: assessment  } = get();
            const taskSubmissionDetails = taskSubmissionDetailsMap.find((taskSubmissionDetails)=>taskSubmissionDetails.type === "ReadingTask" && taskSubmissionDetails.recordingSequence.id === data.recordingSequence.id);
            if (!taskSubmissionDetails || taskSubmissionDetails.type !== "ReadingTask" || !assessment) return;
            if (data.recordingSequence.processingStatus === "finished") (0, $0d509ab7f782af11$export$dd4c7e0a5fc61d5e)({
                assessmentId: assessment.id,
                taskId: taskSubmissionDetails.task.id,
                taskType: taskSubmissionDetails.task.type,
                durationInMilliseconds: String(data.recordingSequence.duration),
                kind: taskSubmissionDetails.recordingSequence.duration > 0 ? "extension" : "new"
            });
            set({
                taskSubmissionDetailsMap: taskSubmissionDetailsMap.set(taskSubmissionDetails.task.id, {
                    ...taskSubmissionDetails,
                    audioFile: data.audioFile,
                    recordingSequence: data.recordingSequence,
                    taskSubmission: {
                        ...taskSubmissionDetails.taskSubmission,
                        pointsEarned: data.pointsEarned
                    }
                })
            });
            setFull((state)=>({
                    ...state,
                    AppData: {
                        ...state.AppData,
                        currentUser: {
                            ...state.AppData.currentUser || (0, $75cd274e63beb59b$export$be7c6faf5b1d35b2),
                            pointBalance: data.pointBalance
                        }
                    }
                }));
            if (data.recordingSequence.processingStatus === "finished") submit({});
        },
        onResponseRecordingSequenceStatus: (data)=>{
            const { taskSubmissionDetailsMap: taskSubmissionDetailsMap , assessment: assessment , submit: submit  } = get();
            const taskSubmissionDetails = taskSubmissionDetailsMap.find((taskSubmissionDetails)=>taskSubmissionDetails.type === "ComprehensionTask" && taskSubmissionDetails.responseRecordingSequence.id === data.recordingSequence.id);
            if (!taskSubmissionDetails || taskSubmissionDetails.type !== "ComprehensionTask" || !assessment) return;
            set({
                taskSubmissionDetailsMap: taskSubmissionDetailsMap.set(taskSubmissionDetails.task.id, {
                    ...taskSubmissionDetails,
                    responseAudioFile: data.audioFile,
                    responseRecordingSequence: data.recordingSequence
                })
            });
            if (data.recordingSequence.processingStatus === "finished") {
                (0, $0d509ab7f782af11$export$dd4c7e0a5fc61d5e)({
                    assessmentId: assessment.id,
                    taskId: taskSubmissionDetails.task.id,
                    taskType: taskSubmissionDetails.task.type,
                    durationInMilliseconds: String(data.recordingSequence.duration),
                    kind: taskSubmissionDetails.responseRecordingSequence.duration > 0 ? "extension" : "new"
                });
                submit({});
            }
        },
        onCompleteTask: (taskSubmissionDetails)=>{
            const { submit: submit  } = get();
            if (taskSubmissionDetails && (taskSubmissionDetails.type === "ModelTask" || taskSubmissionDetails.type === "VocabTask") && !taskSubmissionDetails.taskSubmission.completed) {
                setTaskField(taskSubmissionDetails)("completed")(true);
                submit({
                    clearDirty: true
                });
            }
        },
        submitRating: (rate)=>{
            const { submit: submit  } = get();
            set({
                rating: rate
            });
            submit({
                finished: true,
                override: true,
                clearDirty: true
            });
        },
        onAudioRecorderStatus: (audioRecorderStatus)=>{
            if (audioRecorderStatus === "finished") set({
                dirty: true
            });
            set({
                audioRecorderStatus: audioRecorderStatus
            });
        },
        setCurrentTask: (taskId)=>{
            set((state)=>({
                    ...state,
                    currentTaskId: taskId,
                    drawerExpanded: false
                }));
        },
        submit: ({ finished: finished = false , onSuccess: onSuccess , override: override = false , clearDirty: clearDirty = false  })=>{
            const { submission: submission , taskSubmissionDetailsMap: taskSubmissionDetailsMap , assessment: assessment , rating: rating  } = get();
            if (!submission || !assessment) return;
            const allDone = assessment?.taskOrder?.every((to)=>{
                const taskSubmissionDetails = taskSubmissionDetailsMap.get(to.taskId);
                if (!taskSubmissionDetails) return true;
                if (assessment.isFreeRead && taskSubmissionDetails.type !== "ReadingTask") return true;
                return (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails);
            });
            if (finished && !override && !allDone) {
                set({
                    confirmingFinished: true
                });
                return;
            }
            set({
                submitting: true,
                dirty: !clearDirty
            });
            fetchJson(`/api/submissions/${submission.id}`, {
                method: "PATCH",
                data: {
                    submission: {
                        status: finished ? "finished" : "started",
                        rating: rating
                    },
                    taskSubmissionDetails: taskSubmissionDetailsMap.toList()
                },
                onSuccess: (data)=>{
                    set((newState)=>({
                            ...newState,
                            submitting: false,
                            dirty: newState.dirty || !data.success,
                            submission: data.submission,
                            taskErrors: data.taskErrors.map((errors)=>(0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors)),
                            ...data.success ? {
                                showFinishedModal: newState.showFinishedModal || finished,
                                confirmingFinished: false
                            } : {}
                        }));
                    onSuccess?.(data);
                    (0, $0d509ab7f782af11$export$ffb9c781421d54d7)({
                        assessmentId: assessment.id,
                        kind: submission.finishedAt ? "resubmit" : "submit"
                    });
                }
            });
        },
        leave: (backPath, history)=>()=>{
                const { taskSubmissionDetailsMap: taskSubmissionDetailsMap , assessment: assessment  } = get();
                const allDone = assessment?.taskOrder?.every((to)=>{
                    const taskSubmissionDetails = taskSubmissionDetailsMap.get(to.taskId);
                    if (!taskSubmissionDetails) return true;
                    if (assessment.isFreeRead && taskSubmissionDetails.type !== "ReadingTask") return true;
                    return (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails);
                });
                if (!allDone) {
                    set({
                        confirmingFinished: true,
                        leaving: true
                    });
                    return;
                } else history.push(backPath);
            },
        switchTask: ({ taskId: taskId , history: history , query: query , isPublicPreview: isPublicPreview  })=>()=>{
                const { dirty: dirty , submit: submit  } = get();
                set({
                    confirmingFinished: false,
                    mobileTaskListOpened: false
                });
                const doIt = ()=>{
                    history.push(`${isPublicPreview ? "/t/public-preview" : "/reading-studio"}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                        currentTaskId: taskId
                    })}`);
                };
                if (dirty) submit({
                    clearDirty: true,
                    onSuccess: (data)=>{
                        if (data.success) doIt();
                    }
                });
                else doIt();
            },
        addToLibrary: ({ history: history , createToast: createToast  })=>()=>{
                const { assessment: assessment  } = get();
                if (!assessment) return;
                set({
                    submitting: true
                });
                fetchJson(`/api/assessments/${assessment.id}/duplicate`, {
                    method: "POST",
                    data: {
                        name: assessment.name
                    },
                    onSuccess: (data)=>{
                        if (data.success) {
                            history.push(`/t/assignments/${data.assessment.id}`);
                            createToast({
                                children: "Assignment has copied to your library!"
                            });
                        } else createToast({
                            children: "Unable to add assignment to your library!",
                            color: "danger"
                        });
                    }
                });
            },
        toggleMobileTaskList: ()=>set(({ mobileTaskListOpened: opened  })=>({
                    mobileTaskListOpened: !opened
                })),
        openContentModal: ()=>set({
                contentModalOpened: true
            }),
        closeContentModal: ()=>set({
                contentModalOpened: false
            }),
        closeConfirmationModal: ()=>set({
                confirmingFinished: false,
                leaving: false
            })
    };
});





const $08d9551370e68599$export$49d5fc8cba920a0 = {
    submitting: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    course: {
        courseCode: ""
    }
};




const $34b1ef82f2d30d45$export$29262a68c4fcfbb5 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("SignUpClassCodeData", (0, $08d9551370e68599$export$49d5fc8cba920a0), ({ set: set , fetchJson: fetchJson  })=>({
        load: ()=>set((0, $08d9551370e68599$export$49d5fc8cba920a0)),
        setCourseField: (key)=>(value)=>{
                set((state)=>({
                        course: {
                            ...state.course,
                            [key]: value
                        }
                    }));
            },
        submit: ({ history: history , query: query , courseCodeDeclined: courseCodeDeclined , courseCode: courseCode , replace: replace = false  })=>()=>{
                const finish = ()=>{
                    const url = `/sign-up/student/register${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                        courseCode: courseCode
                    })}`;
                    replace ? history.replace(url) : history.push(url);
                };
                if (courseCodeDeclined) finish();
                else {
                    if (!courseCode) return;
                    set({
                        submitting: true
                    });
                    (0, $d157168146708baf$export$94b15cf31beab72d)({
                        courseCode: courseCode,
                        fetchJson: fetchJson,
                        onSuccess: ({ success: success , errors: errors  })=>{
                            if (success) finish();
                            else set({
                                errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                                submitting: false
                            });
                        }
                    });
                }
            }
    }));





const $4593370d7a8a5e68$export$49d5fc8cba920a0 = {
    submitting: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    schoolCode: ""
};



const $0f5497214284f049$export$b38f3ef336c8d636 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("SignUpSchoolCodeData", (0, $4593370d7a8a5e68$export$49d5fc8cba920a0), ({ set: set , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>set({
                ...(0, $4593370d7a8a5e68$export$49d5fc8cba920a0)
            }),
        submit: ({ history: history , query: query , schoolCode: schoolCode , replace: replace  })=>()=>{
                if (!schoolCode) return;
                set({
                    submitting: true
                });
                fetchJson(`/api/school_codes/${encodeURIComponent(schoolCode)}`, {
                    onSuccess: (data)=>{
                        if (data.success) {
                            const url = `/sign-up/teacher/register${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                                schoolCode: schoolCode
                            })}`;
                            replace ? history.replace(url) : history.push(url);
                        }
                        set({
                            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors),
                            submitting: false
                        });
                    }
                });
            }
    }));








const $73e9cad064b82d46$export$49d5fc8cba920a0 = {
    user: (0, $75cd274e63beb59b$export$ff24787c53446ab3),
    submitting: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    course: null,
    loading: true,
    sso: undefined,
    fieldsMissing: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    school: null
};



const $9c6025a5567e93a6$export$f5c6616af6b6a031 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("SignUpRegisterData", (0, $73e9cad064b82d46$export$49d5fc8cba920a0), ({ get: get , set: set , fetchJson: fetchJson , getFull: getFull  })=>({
        load: ({ accountType: accountType , courseCode: courseCode , schoolCode: schoolCode , query: query , history: history  })=>{
            const errorsInQuery = query.get("errors");
            let errors = (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)();
            if (errorsInQuery) try {
                errors = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(JSON.parse(errorsInQuery));
            } catch (err) {
                (0, $1ce946abade47122$export$b33b857ad1d9900e)(err);
            }
            set({
                ...(0, $73e9cad064b82d46$export$49d5fc8cba920a0),
                loading: true,
                errors: errors,
                user: {
                    ...(0, $73e9cad064b82d46$export$49d5fc8cba920a0).user,
                    accountType: accountType,
                    email: query.get("email", "")
                }
            });
            const sso = query.get("sso");
            const fieldsMissingStr = query.get("fieldsMissing");
            set({
                sso: sso,
                fieldsMissing: fieldsMissingStr ? (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(fieldsMissingStr.split(",")) : (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)()
            });
            if (sso && !query.has("fieldsMissing")) fetchJson(`/api/${sso}_oauths/set_attributes`, {
                method: "POST",
                data: {
                    accountType: accountType,
                    courseCode: courseCode,
                    schoolCode: schoolCode,
                    courseCodeDeclined: !courseCode
                },
                onSuccess: ()=>{
                    history.replace(`/${sso}-oauth-callback?oauthComplete=true`);
                }
            });
            else {
                if (courseCode && accountType === "student") fetchJson(`/api/course_codes/${encodeURIComponent(courseCode)}`, {
                    onSuccess: ({ course: course  })=>{
                        set({
                            course: course,
                            loading: false
                        });
                    }
                });
                if (schoolCode && accountType === "teacher") fetchJson(`/api/school_codes/${encodeURIComponent(schoolCode)}`, {
                    onSuccess: ({ school: school  })=>{
                        set({
                            school: school,
                            loading: false
                        });
                    }
                });
                if (!courseCode && !schoolCode) set({
                    loading: false
                });
            }
        },
        setUserField: (key)=>(value)=>{
                set((state)=>({
                        user: {
                            ...state.user,
                            [key]: value
                        }
                    }));
            },
        submit: (history, query)=>()=>{
                const { user: originalUser , course: originalCourse , school: school , sso: sso  } = get();
                set({
                    submitting: true
                });
                const referralCode = query.get("referralCode");
                const userParams = {
                    ...originalUser,
                    name: originalCourse?.disableName ? null : `${originalUser.firstName} ${originalUser.lastName}`.trim(),
                    storedGivenName: originalUser.firstName.trim(),
                    storedFamilyName: originalUser.lastName.trim(),
                    passwordConfirmation: originalCourse?.disableEmail ? originalUser.passwordConfirmation : originalUser.newPassword
                };
                if (sso) fetchJson(`/api/${sso}_oauths/set_attributes`, {
                    method: "POST",
                    data: {
                        email: userParams.email,
                        name: userParams.name,
                        accountType: userParams.accountType,
                        courseCode: originalCourse?.courseCode,
                        courseCodeDeclined: !originalCourse?.courseCode,
                        schoolCode: school?.schoolCode
                    },
                    onSuccess: ()=>{
                        history.replace(`/${sso}-oauth-callback?oauthComplete=true`);
                    }
                });
                else fetchJson(`/api/users`, {
                    method: "POST",
                    data: {
                        sso: sso,
                        user: userParams,
                        courseCode: originalCourse?.courseCode,
                        schoolCode: school?.schoolCode,
                        referralCode: referralCode
                    },
                    onSuccess: ({ success: success , errors: errors , user: user  })=>{
                        if (success) {
                            if (user.email && user.emailConfirmationStatus === "needed") history.push(`/confirmation-sent${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                                email: user.email,
                                firstName: originalUser.firstName
                            })}`);
                            else getFull().AppData.onSignedUp({
                                redirectPath: query.get("redirectPath") || "",
                                user: user,
                                schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                                history: history,
                                method: "password"
                            });
                        } else set({
                            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                            submitting: false
                        });
                    }
                });
            }
    }));





const $4bc7d3d5bae45cf2$export$49d5fc8cba920a0 = {
    resending: false,
    resent: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};


let $49eee2604105da03$var$resentTimeoutId = null;
const $49eee2604105da03$export$881b893aa2f6685 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("SignUpConfirmationSentData", (0, $4bc7d3d5bae45cf2$export$49d5fc8cba920a0), ({ set: set , fetchJson: fetchJson  })=>({
        load: ()=>{
            set((0, $4bc7d3d5bae45cf2$export$49d5fc8cba920a0));
        },
        resend: (email)=>()=>{
                if (!email) return;
                if ($49eee2604105da03$var$resentTimeoutId) clearTimeout($49eee2604105da03$var$resentTimeoutId);
                set({
                    resending: true,
                    resent: false,
                    errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
                });
                fetchJson(`/api/confirmation_email_tokens`, {
                    method: "POST",
                    data: {
                        email: email
                    },
                    onSuccess: ({ errors: errors , success: success  })=>{
                        set({
                            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                            resent: success,
                            resending: false
                        });
                        $49eee2604105da03$var$resentTimeoutId = setTimeout(()=>{
                            set({
                                resent: false,
                                errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
                            });
                        }, 60000);
                    }
                });
            }
    }));






const $7d6287e1ae323b8a$export$49d5fc8cba920a0 = {
    loading: true,
    syncLoadingCourseIds: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    courses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    students: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    registrations: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    studentCounts: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    unsavedRegistrations: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    editSubmitting: false,
    editingCourse: null,
    editingCourseSubjects: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    subjects: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    courseIdsToEdit: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    gradeLevels: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    editErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    coursesToSync: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    tempEditingCourseSubjectIds: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    courseSubjectsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    assessmentCountMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
};








const $ecfd359a2bb9123c$export$ed0678645689dba6 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("TeacherCourseListData", (0, $7d6287e1ae323b8a$export$49d5fc8cba920a0), ({ set: set , get: get , getFull: getFull , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ({ courseIdsToEdit: courseIdsToEdit = (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)() , onSuccess: onSuccess , history: history , pathname: pathname  })=>{
            set({
                ...(0, $7d6287e1ae323b8a$export$49d5fc8cba920a0)
            });
            fetchJson(`/api/courses`, {
                onSuccess: (data)=>{
                    if (data.currentUser.onboardingStatus === "needed") history.replace(`/t/onboarding${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        redirectPath: pathname
                    })}`);
                    else {
                        const filteredCourseIdsToEdit = data.courses.filter((c)=>courseIdsToEdit.has(c.id)).map((c)=>c.id);
                        const editingCourse = filteredCourseIdsToEdit.size > 0 ? data.courses.find((c)=>c.id === filteredCourseIdsToEdit.first()) || null : null;
                        const editingCourseSubjects = data.subjectMap.get(editingCourse?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
                        const unsavedRegistrations = data.registrations.get(editingCourse?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).map(({ userId: userId  })=>userId).toSet();
                        set({
                            loading: false,
                            courses: data.courses,
                            students: data.students,
                            registrations: data.registrations,
                            studentCounts: data.studentCounts,
                            courseSubjectsMap: data.subjectMap,
                            subjects: data.subjects,
                            unsavedRegistrations: unsavedRegistrations,
                            editingCourse: editingCourse,
                            editingCourseSubjects: editingCourseSubjects,
                            tempEditingCourseSubjectIds: editingCourseSubjects.map((s)=>s.id),
                            courseIdsToEdit: filteredCourseIdsToEdit,
                            gradeLevels: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(data.gradeLevels).map((gl)=>(0, $1efad0e185f7a777$export$4c9c6fc2c1b59749).has(gl.level) ? {
                                    id: gl.id,
                                    level: gl.level,
                                    name: "Select a Grade Level"
                                } : gl),
                            assessmentCountMap: data.assessmentCountMap
                        });
                        onSuccess?.();
                    }
                }
            });
        },
        archive: (course, createToast, onSuccess)=>()=>{
                const updatedCourse = {
                    ...course,
                    status: course.status === "active" ? "archived" : "active"
                };
                set((state)=>({
                        courses: state.courses.filter((c)=>c.id !== course.id).push(updatedCourse)
                    }));
                (0, $d157168146708baf$export$a46f8bc61117165)({
                    course: updatedCourse,
                    fetchJson: fetchJson,
                    editingInModal: false,
                    onSuccess: ({ success: success  })=>{
                        if (success) {
                            createToast({
                                children: `Course ${updatedCourse.status === "archived" ? "archived" : "unarchived"}!`
                            });
                            onSuccess?.();
                        } else createToast({
                            color: "danger",
                            children: "Failed to update course."
                        });
                    }
                });
            },
        setEditCourseField: (field)=>(value)=>{
                set((state)=>{
                    if (!state.editingCourse) return state;
                    return {
                        ...state,
                        editingCourse: {
                            ...state.editingCourse,
                            [field]: value
                        }
                    };
                });
            },
        editCourse: (history, query, isCreate = false)=>{
            const { editSubmitting: editSubmitting , editingCourse: editingCourse , editingCourseSubjects: editingCourseSubjects , tempEditingCourseSubjectIds: newSubjects  } = get();
            if (!editingCourse || editSubmitting) return;
            const editingCourseSubjectIds = editingCourseSubjects.map((subject)=>subject.id);
            const toDelete = editingCourseSubjectIds.filter((id)=>!newSubjects.contains(id));
            const toAdd = newSubjects.filter((id)=>!editingCourseSubjectIds.contains(id));
            set({
                editSubmitting: true
            });
            (0, $d157168146708baf$export$a46f8bc61117165)({
                editingInModal: true,
                course: editingCourse,
                newSubjectIds: toAdd,
                oldSubjectIds: toDelete,
                fetchJson: fetchJson,
                onSuccess: ({ course: course , success: success , errors: errors  })=>{
                    if (success) {
                        const { courses: courses , courseIdsToEdit: courseIdsToEdit , courseSubjectsMap: courseSubjectsMap  } = get();
                        const updatedCourses = courses.filter((c)=>c.id !== course.id).push(course);
                        const currentIndex = courseIdsToEdit.findIndex((id)=>id === course.id);
                        const nextEditingCourse = (currentIndex === -1 ? null : updatedCourses.find((c)=>c.id === courseIdsToEdit.get(currentIndex + 1, null))) || null;
                        set({
                            courses: updatedCourses,
                            editErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                            editSubmitting: false,
                            editingCourse: nextEditingCourse,
                            editingCourseSubjects: courseSubjectsMap.get(nextEditingCourse?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()),
                            tempEditingCourseSubjectIds: courseSubjectsMap.get(nextEditingCourse?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).map((subject)=>subject.id)
                        });
                        if (nextEditingCourse === null) {
                            if (isCreate) history.replace(`/t/classes/${editingCourse.id}/finished${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                            else history.replace(`/t/classes${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query.remove("editIds"))}`);
                        }
                    } else set({
                        editErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                        editSubmitting: false
                    });
                }
            });
        },
        startSyncCourse: ({ history: history , query: query , courses: courses , isGoogle: isGoogle  })=>()=>{
                const courseIds = courses.map(({ id: id  })=>id);
                set({
                    syncLoadingCourseIds: courseIds.toSet(),
                    coursesToSync: courses
                });
                const sharedAttributes = {
                    successUrl: `/t/classes/sync_lms${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                        courseIds: courseIds.join(","),
                        isGoogle: isGoogle ? "true" : "false"
                    })}`,
                    history: history,
                    userAttributes: {},
                    fetchJson: fetchJson
                };
                if (isGoogle) (0, $d5c80744df37e284$export$5e6afd1881cf511)({
                    scopeKey: "import_class",
                    ...sharedAttributes
                });
                else (0, $ea53b83fae57f249$export$23a69314da92e79b)(sharedAttributes);
            },
        syncAllCourses: (courses, history, pathname, createToast, isGoogle)=>()=>{
                if (courses.isEmpty()) return;
                const syncKind = isGoogle ? "google" : "clever";
                set({
                    syncLoadingCourseIds: courses.map(({ id: id  })=>id).toSet()
                });
                fetchJson(`/api/${syncKind}_courses`, {
                    method: "POST",
                    data: {
                        courses: courses.map((c)=>({
                                id: c.id,
                                avatarColor: c.avatarColor
                            }))
                    },
                    onSuccess: ({ hasScopes: hasScopes  })=>{
                        history.replace("/t/classes");
                        get().load({
                            history: history,
                            pathname: pathname,
                            onSuccess: ()=>{
                                set({
                                    syncLoadingCourseIds: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
                                    coursesToSync: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
                                });
                                const pluralCourse = (0, $e6116bf527c207db$export$cefb40c9962541b5)("course", courses.size, {
                                    noNumber: true
                                });
                                if (hasScopes) createToast({
                                    children: `${(0, $e6116bf527c207db$export$9a00dee1beb8f576)(syncKind)} ${pluralCourse} synced!`
                                });
                                else createToast({
                                    children: `${(0, $e6116bf527c207db$export$9a00dee1beb8f576)(syncKind)} ${pluralCourse} failed to sync, please try again.`,
                                    color: "danger"
                                });
                            }
                        });
                    }
                });
            },
        toggleRegistration: (id)=>{
            set((state)=>({
                    ...state,
                    unsavedRegistrations: (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(state.unsavedRegistrations, id)
                }));
        },
        updateClassStudents: (createToast, closeModal)=>{
            const { students: students , editingCourse: editingCourse , unsavedRegistrations: unsavedRegistrations  } = get();
            if (!editingCourse) return;
            fetchJson(`/api/courses/${editingCourse.id}/bulk_update_registrations`, {
                method: "PATCH",
                data: {
                    registrationUpdates: students.reduce((acc, student)=>acc.set(student.id, unsavedRegistrations.has(student.id)), (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()).entrySeq()
                },
                onSuccess: ({ success: success , registrations: registrations  })=>{
                    if (success) {
                        set((state)=>({
                                ...state,
                                registrations: registrations
                            }));
                        getFull().ProgressMonitoringData.clearCache();
                        getFull().StudentProgressMonitoringData.clearCache();
                        createToast({
                            children: `${editingCourse?.name} roster updated!`,
                            color: "success"
                        });
                        closeModal();
                    }
                }
            });
        },
        generateClassCode: ()=>{
            fetchJson(`/api/course_codes/generate`, {
                onSuccess: ({ courseCode: courseCode  })=>{
                    get().setEditCourseField("courseCode")(courseCode);
                }
            });
        }
    }));




const $7cdc15f862e40cc1$export$49d5fc8cba920a0 = {
    loading: false,
    course: null,
    courseName: "",
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};





const $46c8eaab361a18d8$export$e8993eda502ba080 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("CreateCourseData", (0, $7cdc15f862e40cc1$export$49d5fc8cba920a0), ({ set: set , get: get , getFull: getFull , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>set((0, $7cdc15f862e40cc1$export$49d5fc8cba920a0)),
        submit: (onSuccess)=>{
            set({
                loading: true
            });
            fetchJson(`/api/courses`, {
                method: "POST",
                data: {
                    courseName: get().courseName,
                    avatarColor: (0, $d5a1fd3dea1a0ab6$export$7a5825874deea16a)((0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)((0, $24b764039c44d1ec$export$40792c0fcdd2bbbd)))
                },
                onSuccess: ({ success: success , course: course , errors: errors  })=>{
                    if (success) {
                        set((0, $7cdc15f862e40cc1$export$49d5fc8cba920a0));
                        onSuccess?.(course);
                        (0, $0d509ab7f782af11$export$b7b5c2a690fb344a)({
                            course: course
                        });
                        getFull().AppData.load({
                            skipStateReset: true
                        });
                    } else set({
                        course: course,
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                        loading: false
                    });
                }
            });
        }
    }));





const $19f0aefc4204baf8$export$49d5fc8cba920a0 = {
    loading: true,
    hasScopes: false,
    submitting: false,
    googleCourses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    selectedGoogleCourseIds: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    studentCountMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
};





const $230c2c1a78a99720$export$8baece80af8da911 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ImportGoogleCourseData", (0, $19f0aefc4204baf8$export$49d5fc8cba920a0), ({ set: set , get: get , fetchJson: fetchJson , getFull: getFull  })=>({
        load: ()=>{
            set((0, $19f0aefc4204baf8$export$49d5fc8cba920a0));
            fetchJson(`/api/google_courses`, {
                onSuccess: (data)=>{
                    set({
                        hasScopes: data.hasScopes,
                        googleCourses: data.googleCourses.map((c)=>({
                                ...c,
                                avatarColor: data.courseMap.get(c.id, {
                                    avatarColor: (0, $d5a1fd3dea1a0ab6$export$7a5825874deea16a)((0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)((0, $24b764039c44d1ec$export$40792c0fcdd2bbbd)))
                                }).avatarColor
                            })),
                        courseMap: data.courseMap,
                        studentCountMap: data.studentCountMap,
                        selectedGoogleCourseIds: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(data.googleCourses.map((c)=>c.id)),
                        loading: false
                    });
                }
            });
        },
        submit: (history, pathname, query)=>()=>{
                set({
                    submitting: true
                });
                const { googleCourses: googleCourses , selectedGoogleCourseIds: selectedGoogleCourseIds , courseMap: originalCourseMap  } = get();
                fetchJson(`/api/google_courses`, {
                    method: "POST",
                    data: {
                        googleCourses: googleCourses.filter((c)=>selectedGoogleCourseIds.has(c.id)).map(({ id: id , avatarColor: avatarColor  })=>({
                                id: id,
                                avatarColor: avatarColor
                            }))
                    },
                    onSuccess: ({ success: success , courses: courses  })=>{
                        if (success) {
                            getFull().TeacherCourseListData.load({
                                history: history,
                                pathname: pathname,
                                onSuccess: ()=>{
                                    history.replace((0, $d157168146708baf$export$1d221c892c3cb676)("create", query, courses.map((c)=>c.id)));
                                    set({
                                        submitting: false
                                    });
                                }
                            });
                            const originalCourseIds = originalCourseMap.map((oc)=>oc.id);
                            courses.filter((c)=>!originalCourseIds.includes(c.id)).forEach((course)=>{
                                (0, $0d509ab7f782af11$export$46d6102056f3fb8d)({
                                    course: course
                                });
                                (0, $0d509ab7f782af11$export$b7b5c2a690fb344a)({
                                    course: course
                                });
                            });
                        } else set({
                            hasScopes: false
                        });
                    }
                });
            },
        setAll: ()=>{
            set((s)=>({
                    selectedGoogleCourseIds: s.selectedGoogleCourseIds.isEmpty() ? (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(s.googleCourses.map((c)=>c.id)) : (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)()
                }));
        },
        setSelected: (googleCourseId)=>()=>{
                set((state)=>({
                        selectedGoogleCourseIds: (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(state.selectedGoogleCourseIds, googleCourseId)
                    }));
            }
    }));





const $0e401fc373ec3235$export$49d5fc8cba920a0 = {
    loading: true,
    hasScopes: false,
    submitting: false,
    cleverSections: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    selectedCleverSectionIds: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
};





const $a502c63c8f7f9b55$export$5dbce76456314a8e = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ImportCleverCourseData", (0, $0e401fc373ec3235$export$49d5fc8cba920a0), ({ set: set , get: get , fetchJson: fetchJson , getFull: getFull  })=>({
        load: ()=>{
            set((0, $0e401fc373ec3235$export$49d5fc8cba920a0));
            fetchJson(`/api/clever_courses`, {
                onSuccess: (data)=>{
                    set({
                        hasScopes: data.hasScopes,
                        cleverSections: data.cleverSections.map((s)=>({
                                ...s,
                                avatarColor: data.courseMap.get(s.id, {
                                    avatarColor: (0, $d5a1fd3dea1a0ab6$export$7a5825874deea16a)((0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)((0, $24b764039c44d1ec$export$40792c0fcdd2bbbd)))
                                }).avatarColor
                            })),
                        courseMap: data.courseMap,
                        selectedCleverSectionIds: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(data.cleverSections.map((s)=>s.id)),
                        loading: false
                    });
                }
            });
        },
        submit: (history, pathname, query)=>()=>{
                set({
                    submitting: true
                });
                const { selectedCleverSectionIds: selectedCleverSectionIds , cleverSections: cleverSections , courseMap: originalCourseMap  } = get();
                fetchJson(`/api/clever_courses`, {
                    method: "POST",
                    data: {
                        cleverSections: cleverSections.filter((s)=>selectedCleverSectionIds.has(s.id)).map((s)=>({
                                id: s.id,
                                avatarColor: s.avatarColor
                            }))
                    },
                    onSuccess: ({ success: success , courses: courses  })=>{
                        if (success) {
                            getFull().TeacherCourseListData.load({
                                history: history,
                                pathname: pathname,
                                onSuccess: ()=>{
                                    history.replace((0, $d157168146708baf$export$1d221c892c3cb676)("create", query, courses.map((c)=>c.id)));
                                    set({
                                        submitting: false
                                    });
                                }
                            });
                            const originalCourseIds = originalCourseMap.map((oc)=>oc.id);
                            courses.filter((c)=>!originalCourseIds.includes(c.id)).forEach((course)=>{
                                (0, $0d509ab7f782af11$export$46d6102056f3fb8d)({
                                    course: course
                                });
                                (0, $0d509ab7f782af11$export$b7b5c2a690fb344a)({
                                    course: course
                                });
                            });
                        } else set({
                            hasScopes: false
                        });
                    }
                });
            },
        setAll: ()=>{
            set((s)=>({
                    selectedCleverSectionIds: s.selectedCleverSectionIds.isEmpty() ? (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(s.cleverSections.map((c)=>c.id)) : (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)()
                }));
        },
        setSelected: (cleverSectionId)=>()=>{
                set((state)=>({
                        selectedCleverSectionIds: (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(state.selectedCleverSectionIds, cleverSectionId)
                    }));
            }
    }));






const $6b0066b3371f5956$export$f0bd57e5cb39e51d = ()=>({
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        avatarColor: null
    });
const $6b0066b3371f5956$export$49d5fc8cba920a0 = {
    loading: true,
    passwordHidden: true,
    students: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    registrationMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    tempName: "",
    tempEmail: "",
    assignedMap: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    newStudentErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    creatingNewStudent: false,
    changingPassword: false,
    newUser: $6b0066b3371f5956$export$f0bd57e5cb39e51d(),
    newPassword: "",
    passwordConfirmation: ""
};



const $f76a4cfdb2b0781a$export$1efe6abc7f0c2a72 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("TeacherStudentListData", (0, $6b0066b3371f5956$export$49d5fc8cba920a0), ({ get: get , set: set , getFull: getFull , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>{
            set((0, $6b0066b3371f5956$export$49d5fc8cba920a0));
            fetchJson(`/api/students`, {
                onSuccess: (data)=>{
                    set({
                        loading: false,
                        students: data.students,
                        registrationMap: data.registrationMap,
                        courseMap: data.courseMap
                    });
                }
            });
        },
        loadChangePasswordModal: ()=>set({
                passwordHidden: true,
                newPassword: "",
                passwordConfirmation: ""
            }),
        loadNewStudentModal: ()=>{
            set({
                newUser: (0, $6b0066b3371f5956$export$f0bd57e5cb39e51d)()
            });
            get().generatePassword({
                newUser: true
            })();
        },
        loadEditStudentModal: (student)=>set({
                tempName: student?.name || "",
                tempEmail: student?.email || student?.username || "",
                errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
            }),
        loadManageStudentCoursesModal: (student)=>{
            if (!student) return;
            const { courseMap: courseMap , registrationMap: registrationMap  } = get();
            const courseRegistrations = courseMap.map(({ id: id  })=>id).filter((courseId)=>registrationMap.get(student.id)?.some((registration)=>registration.status === "active" && registration.courseId === courseId)).toSet();
            set({
                assignedMap: courseRegistrations
            });
        },
        updateStudent: ({ selectedStudent: selectedStudent , closeModal: closeModal , createToast: createToast  })=>{
            if (!selectedStudent) return;
            const { tempName: tempName , tempEmail: tempEmail  } = get();
            const splitName = tempName.split(" ");
            const givenName = splitName[0] || "";
            const familyName = splitName.slice(1).join(" ");
            const data = selectedStudent.email ? {
                name: tempName,
                email: tempEmail,
                givenName: givenName,
                familyName: familyName
            } : {
                name: tempName,
                username: tempEmail,
                givenName: givenName,
                familyName: familyName
            };
            fetchJson(`/api/users/${selectedStudent.id}`, {
                method: "PATCH",
                data: data,
                onSuccess: ({ success: success , errors: errors  })=>{
                    if (success) {
                        createToast({
                            children: "Student updated!",
                            duration: 2000
                        });
                        const updatedStudent = selectedStudent.email ? {
                            ...selectedStudent,
                            email: tempEmail,
                            name: tempName,
                            givenName: givenName,
                            familyName: familyName
                        } : {
                            ...selectedStudent,
                            username: tempEmail,
                            name: tempName,
                            givenName: givenName,
                            familyName: familyName
                        };
                        set((state)=>({
                                students: state.students.filter((student)=>student.id !== updatedStudent.id).push(updatedStudent)
                            }));
                        closeModal();
                    } else {
                        set({
                            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors)
                        });
                        createToast({
                            children: "Student failed to update!",
                            color: "danger"
                        });
                    }
                }
            });
        },
        changePassword: ({ selectedStudent: selectedStudent , closeModal: closeModal , createToast: createToast  })=>{
            if (!selectedStudent) return;
            const { newPassword: newPassword , passwordConfirmation: passwordConfirmation  } = get();
            let errors = (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)();
            if (newPassword.length === 0) errors = errors.set("newPassword", [
                "can't be blank"
            ]);
            if (passwordConfirmation.length === 0) errors = errors.set("passwordConfirmation", [
                "can't be blank"
            ]);
            if (!errors.isEmpty()) {
                set({
                    errors: errors
                });
                return;
            }
            fetchJson(`/api/users/${selectedStudent.id}`, {
                method: "PATCH",
                data: {
                    newPassword: newPassword,
                    passwordConfirmation: passwordConfirmation
                },
                onSuccess: ({ success: success , errors: errors  })=>{
                    if (success) {
                        createToast({
                            children: "Password Updated!"
                        });
                        set({
                            newPassword: "",
                            passwordConfirmation: ""
                        });
                        closeModal();
                    }
                    set({
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors)
                    });
                }
            });
        },
        updateStudentClasses: ({ selectedStudent: selectedStudent , closeModal: closeModal  })=>()=>{
                if (!selectedStudent) return;
                const { assignedMap: assignedMap , courseMap: courseMap , load: load  } = get();
                fetchJson(`/api/users/${selectedStudent.id}/bulk_update_registrations`, {
                    method: "PATCH",
                    data: {
                        registrationUpdates: courseMap.reduce((acc, course)=>acc.set(course.id, assignedMap.has(course.id)), (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()).entrySeq()
                    },
                    onSuccess: ({ success: success  })=>{
                        if (success) {
                            closeModal();
                            load();
                            getFull().ProgressMonitoringData.clearCache();
                            getFull().StudentProgressMonitoringData.clearCache();
                        }
                    }
                });
            },
        createStudent: ({ currentQueryString: currentQueryString , history: history  })=>{
            set({
                creatingNewStudent: true
            });
            const { newUser: newUser  } = get();
            fetchJson(`/api/users/create_student`, {
                method: "POST",
                data: {
                    user: {
                        name: `${newUser.firstName} ${newUser.lastName}`.trim(),
                        newPassword: newUser.password,
                        ...newUser.username.includes("@") ? {
                            email: newUser.username
                        } : {
                            username: newUser.username
                        }
                    }
                },
                onSuccess: ({ success: success , errors: errors , user: user  })=>{
                    set({
                        newStudentErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                        creatingNewStudent: false
                    });
                    if (success) {
                        set((s)=>({
                                students: s.students.push(user)
                            }));
                        history.push(`/t/students/${user.id}/edit-classes${currentQueryString}`);
                    }
                }
            });
        },
        setUserField: (field)=>(value)=>set((state)=>{
                    return {
                        ...state,
                        newUser: {
                            ...state.newUser,
                            [field]: value
                        }
                    };
                }),
        generatePassword: ({ newUser: newUser  })=>()=>fetchJson(`/api/short_ids/generate`, {
                    onSuccess: ({ id: id  })=>{
                        if (newUser) get().setUserField("password")(id);
                        else set({
                            newPassword: id,
                            passwordConfirmation: id
                        });
                        set({
                            passwordHidden: false
                        });
                    }
                })
    }));




const $e336b7177ba62f1c$export$49d5fc8cba920a0 = {
    assessmentMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    submissionMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    taskSubmissions: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    stats: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    assessmentToCourseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    loading: true,
    openAssignmentCardSet: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    commentMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    readingNameMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
};



const $e08a10c7dd7f7d96$export$da82b2441ca8a7a3 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("StudentDashboardData", (0, $e336b7177ba62f1c$export$49d5fc8cba920a0), ({ set: set , fetchJson: fetchJson  })=>({
        load: ()=>{
            set({
                ...(0, $e336b7177ba62f1c$export$49d5fc8cba920a0),
                loading: true
            });
            fetchJson(`/api/users/student_dashboard`, {
                onSuccess: (data)=>{
                    set({
                        assessmentToCourseMap: data.assessmentToCourseMap,
                        assessmentMap: data.assessmentMap,
                        submissionMap: data.submissionMap,
                        taskSubmissions: data.taskSubmissions,
                        courseMap: data.courseMap,
                        stats: data.stats,
                        commentMap: data.commentMap,
                        readingNameMap: data.readingNameMap,
                        loading: false
                    });
                }
            });
        },
        toggleAssignmentCardOpen: (value)=>{
            set(({ openAssignmentCardSet: openAssignmentCardSet  })=>({
                    openAssignmentCardSet: (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(openAssignmentCardSet, value)
                }));
        }
    }));




const $16a730305e655a95$export$49d5fc8cba920a0 = {
    open: false,
    loading: false,
    courseCode: "",
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};




const $29c44711cd8f3c7d$export$2639b2ce4beaf7ac = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("JoinCourseData", (0, $16a730305e655a95$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ({ joinCode: joinCode  })=>set({
                ...(0, $16a730305e655a95$export$49d5fc8cba920a0),
                courseCode: joinCode,
                open: Boolean(joinCode)
            }),
        checkCode: (courseCode)=>{
            if (!courseCode) return;
            set({
                loading: true
            });
            (0, $d157168146708baf$export$94b15cf31beab72d)({
                fetchJson: fetchJson,
                courseCode: courseCode,
                onSuccess: ({ errors: errors  })=>{
                    set({
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                        loading: false
                    });
                }
            });
        },
        submit: (history)=>{
            set({
                loading: true
            });
            fetchJson(`/api/registrations`, {
                method: "POST",
                data: {
                    courseCode: get().courseCode
                },
                onSuccess: ({ success: success , errors: errors  })=>{
                    if (success) {
                        set((0, $16a730305e655a95$export$49d5fc8cba920a0));
                        history.push("/");
                    } else set({
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors),
                        loading: false
                    });
                }
            });
        }
    }));




const $14e57d570ba4ddb6$export$49d5fc8cba920a0 = {
    loading: true,
    assessmentMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    studentMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    readingNameMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    openAssignmentCardSet: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    search: ""
};




const $1cf325e08d7f60b6$export$28c9377f65595c31 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("TeacherAssignmentListData", (0, $14e57d570ba4ddb6$export$49d5fc8cba920a0), ({ set: set , setField: setField , get: get , fetchJson: fetchJson  })=>({
        setField: setField,
        toggleAssignmentCardOpen: (value)=>{
            set(({ openAssignmentCardSet: openAssignmentCardSet  })=>({
                    openAssignmentCardSet: (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(openAssignmentCardSet, value)
                }));
        },
        load: (history, pathname)=>{
            set((0, $14e57d570ba4ddb6$export$49d5fc8cba920a0));
            fetchJson(`/api/assessments/teacher_index`, {
                onSuccess: (data)=>{
                    if (data.currentUser.onboardingStatus === "needed") history.replace(`/t/onboarding${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        redirectPath: pathname
                    })}`);
                    else set({
                        assessmentMap: data.assessmentMap,
                        courseMap: data.courseMap,
                        studentMap: data.studentMap,
                        loading: false
                    });
                }
            });
        },
        updateAssessments: (assessment)=>{
            const stale = get().assessmentMap.get(assessment.id);
            if (stale) set(({ assessmentMap: assessmentMap  })=>({
                    assessmentMap: assessmentMap.set(assessment.id, {
                        ...stale,
                        assessment: {
                            ...stale.assessment,
                            ...assessment
                        }
                    })
                }));
        }
    }));





const $0ae2f850117922a5$export$49d5fc8cba920a0 = {
    loading: true,
    assignmentCardOpen: true,
    assessmentDetail: null,
    submitting: false,
    reassigning: false,
    reassigningErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    reassigningName: "",
    submissionMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    userMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    courseToStudentIdsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    taskDetailsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    studentToTaskSubmissionDetailsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    openTaskCardSet: (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(),
    taskCompletionMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    commentMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    deleteSubmissionModalOpened: false,
    deleteSubmissionStudent: null,
    confirmDeleteText: "",
    submissionToDelete: null
};





const $6c952083be51382a$export$7b35e6ec51f6f8d8 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("TeacherAssignmentOverviewData", (0, $0ae2f850117922a5$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: (id)=>{
            set((0, $0ae2f850117922a5$export$49d5fc8cba920a0));
            fetchJson(`/api/assessments/${id}/teacher_show`, {
                onSuccess: (data)=>{
                    set({
                        commentMap: data.commentMap,
                        assessmentDetail: data.assessmentDetail,
                        submissionMap: data.submissionMap,
                        userMap: data.userMap,
                        courseMap: data.courseMap,
                        courseToStudentIdsMap: data.courseToStudentIdsMap,
                        taskDetailsMap: data.taskDetailsMap,
                        studentToTaskSubmissionDetailsMap: data.studentToTaskSubmissionDetailsMap,
                        taskCompletionMap: data.taskCompletionMap,
                        loading: false
                    });
                }
            });
        },
        updateSubmissionMap: ({ submission: submission  })=>{
            set((state)=>({
                    ...state,
                    submissionMap: state.submissionMap.map((value)=>value.id === submission.id ? submission : value)
                }));
        },
        startReassigning: ()=>{
            const { assessmentDetail: assessmentDetail  } = get();
            set({
                reassigning: true,
                reassigningName: assessmentDetail ? `${assessmentDetail.assessment.name} - ${(0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(), {
                    includeYear: true
                })}` : "",
                reassigningErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
            });
        },
        submitReassign: ({ history: history , createToast: createToast  })=>()=>{
                const { assessmentDetail: assessmentDetail , reassigningName: reassigningName  } = get();
                if (!assessmentDetail) return;
                set({
                    submitting: true
                });
                fetchJson(`/api/assessments/${assessmentDetail.assessment.id}/duplicate`, {
                    method: "POST",
                    data: {
                        name: reassigningName,
                        reassign: true
                    },
                    onSuccess: (data)=>{
                        set({
                            submitting: false,
                            reassigning: !data.success,
                            reassigningErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors)
                        });
                        if (data.success) {
                            history.push(`/t/assignments/${data.assessment.id}`);
                            createToast({
                                children: "Assignment has been duplicated and reassigned!"
                            });
                        }
                    }
                });
            },
        toggleTaskCardOpen: (value)=>()=>{
                set(({ openTaskCardSet: openTaskCardSet  })=>({
                        openTaskCardSet: (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(openTaskCardSet, value)
                    }));
            },
        openDeleteSubmissionModal: (student, submission)=>{
            set({
                deleteSubmissionModalOpened: true,
                deleteSubmissionStudent: student,
                submissionToDelete: submission
            });
        },
        closeDeleteSubmissionModal: ()=>{
            set({
                deleteSubmissionModalOpened: false,
                deleteSubmissionStudent: null,
                submissionToDelete: null,
                confirmDeleteText: ""
            });
        },
        deleteSubmission: (createToast)=>()=>{
                const { submissionToDelete: submissionToDelete , deleteSubmissionStudent: deleteSubmissionStudent , submissionMap: submissionMap , taskCompletionMap: taskCompletionMap , closeDeleteSubmissionModal: closeDeleteSubmissionModal  } = get();
                if (submissionToDelete && deleteSubmissionStudent) fetchJson(`/api/submissions/${submissionToDelete.id}`, {
                    method: "DELETE",
                    onSuccess: (data)=>{
                        if (data.success) {
                            const newSubmissionMap = submissionMap.delete(deleteSubmissionStudent.id);
                            const newTaskCompletionMap = taskCompletionMap.delete(deleteSubmissionStudent.id);
                            set({
                                submissionMap: newSubmissionMap,
                                taskCompletionMap: newTaskCompletionMap
                            });
                            closeDeleteSubmissionModal();
                            createToast({
                                children: "Submission has been deleted"
                            });
                        } else createToast({
                            children: "Submission was unable to be deleted",
                            color: "danger"
                        });
                    }
                });
            }
    }));





const $c57db1366069be44$export$49d5fc8cba920a0 = {
    loading: true,
    creatingRecordingSequence: false,
    savingComment: false,
    user: null,
    submission: null,
    assessment: null,
    currentTaskId: null,
    showAdvancedStats: false,
    initialPlayProgress: 0,
    playIndex: 0,
    taskSubmissionDetailsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    textDiffMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    errorDisputesMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    drawerExpanded: false,
    userToSubmissionIdMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    userMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    commentModalOpened: false,
    comments: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    editingCommentType: "undecided",
    editingWrittenContent: "",
    editingRecordingSequence: null,
    editingAudioFile: null,
    transcriptionVisible: false
};



const $57ce8a6e7ab158ea$export$137388e90d2cd091 = (assessment, taskSubmissionDetailsMap)=>{
    if (!assessment) return null;
    const readingTaskData = assessment.taskOrder.find(({ taskId: taskId , type: type  })=>type === "ReadingTask" && taskSubmissionDetailsMap.has(taskId));
    if (!readingTaskData) return null;
    const readingTaskId = readingTaskData.taskId;
    const readingTaskSubmissionDetails = taskSubmissionDetailsMap.get(readingTaskId);
    if (!readingTaskSubmissionDetails || readingTaskSubmissionDetails.type !== "ReadingTask") return null;
    return readingTaskSubmissionDetails;
};
const $57ce8a6e7ab158ea$export$c44a57905a1523a2 = ()=>{
    const { assessment: assessment , taskSubmissionDetailsMap: taskSubmissionDetailsMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ SubmissionOverviewData: s  })=>({
            assessment: s.assessment,
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap
        }), []);
    return $57ce8a6e7ab158ea$export$137388e90d2cd091(assessment, taskSubmissionDetailsMap);
};
const $57ce8a6e7ab158ea$export$387094ddcc67c137 = ()=>{
    const { taskSubmissionDetailsMap: taskSubmissionDetailsMap , currentTaskId: currentTaskId  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ SubmissionOverviewData: s  })=>({
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap,
            currentTaskId: s.currentTaskId
        }), []);
    const currentTaskSubmissionDetails = currentTaskId ? taskSubmissionDetailsMap.get(currentTaskId, null) : null;
    return currentTaskSubmissionDetails;
};


const $cfaafe48b695104a$export$d2a589e02c3dc021 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("SubmissionOverviewData", (0, $c57db1366069be44$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , fetchJson: fetchJson , getFull: getFull  })=>({
        setField: setField,
        setPlayProgress: (value)=>{
            set(({ playIndex: playIndex  })=>({
                    initialPlayProgress: value,
                    playIndex: playIndex + 1
                }));
        },
        load: ({ id: id , openComments: openComments  })=>{
            set((0, $c57db1366069be44$export$49d5fc8cba920a0));
            fetchJson(`/api/submissions/${id}`, {
                onSuccess: (data)=>{
                    set({
                        ...data,
                        loading: false
                    });
                    if (openComments) get().openCommentModal();
                }
            });
        },
        setCurrentTask: (taskId)=>{
            set((state)=>({
                    ...state,
                    currentTaskId: taskId,
                    drawerExpanded: false
                }));
        },
        onSubmissionStatus: (data)=>{
            set((state)=>({
                    submission: data.submission,
                    taskSubmissionDetailsMap: data.taskSubmissionDetailsMap,
                    textDiffMap: state.textDiffMap.merge(data.textDiffMap)
                }));
        },
        disputeError: (index)=>{
            const { user: user , submission: submission , assessment: assessment , taskSubmissionDetailsMap: taskSubmissionDetailsMap , errorDisputesMap: errorDisputesMap , textDiffMap: textDiffMap  } = get();
            const readingTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$137388e90d2cd091)(assessment, taskSubmissionDetailsMap);
            if (!(user && readingTaskSubmissionDetails)) return;
            const { task: task  } = readingTaskSubmissionDetails;
            const textDiff = textDiffMap.get(task.id);
            if (!textDiff) return;
            set({
                errorDisputesMap: errorDisputesMap.set(task.id, errorDisputesMap.get(task.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).push({
                    index: index,
                    userId: user.id,
                    textDiffId: textDiff.id
                }))
            });
            fetchJson(`/api/error_disputes`, {
                method: "POST",
                data: {
                    dispute: {
                        userId: user.id,
                        textDiffId: textDiff.id,
                        index: index
                    },
                    submissionId: submission?.id
                }
            });
        },
        createComment: (comment)=>{
            const { submission: submission  } = get();
            if (!submission) return;
            set({
                savingComment: true
            });
            fetchJson(`/api/comments`, {
                method: "POST",
                data: {
                    submissionId: submission.id,
                    comment: comment
                },
                onSuccess: (data)=>{
                    set((s)=>({
                            savingComment: false,
                            comments: s.comments.filter((c)=>c.comment.id !== data.comment.comment.id).push(data.comment),
                            editingCommentType: "undecided",
                            editingWrittenContent: "",
                            editingRecordingSequence: null
                        }));
                }
            });
        },
        createReactionComment: (reaction)=>{
            const { createComment: createComment  } = get();
            createComment({
                reaction: reaction,
                commentType: "reaction"
            });
        },
        createWrittenComment: ()=>{
            const { createComment: createComment , editingWrittenContent: editingWrittenContent  } = get();
            createComment({
                writtenContent: editingWrittenContent,
                commentType: "written"
            });
        },
        createAudioComment: ()=>{
            const { createComment: createComment , editingRecordingSequence: editingRecordingSequence  } = get();
            if (!editingRecordingSequence) return;
            createComment({
                recordingSequenceId: editingRecordingSequence.id,
                commentType: "recorded"
            });
        },
        deleteComment: (id)=>{
            const initialComments = get().comments;
            set((s)=>({
                    comments: s.comments.filter((c)=>c.comment.id !== id)
                }));
            fetchJson(`/api/comments/${id}`, {
                method: "DELETE",
                onSuccess: (data)=>{
                    if (!data.success) set({
                        comments: initialComments
                    });
                }
            });
        },
        createRecordingSequence: ()=>{
            set({
                creatingRecordingSequence: true
            });
            fetchJson(`/api/recording_sequences`, {
                method: "POST",
                data: {},
                onSuccess: ({ recordingSequence: recordingSequence  })=>{
                    set({
                        creatingRecordingSequence: false,
                        editingCommentType: "recorded",
                        editingRecordingSequence: recordingSequence,
                        editingAudioFile: null
                    });
                }
            });
        },
        onRecordingSequenceStatus: (data)=>set({
                editingAudioFile: data.audioFile,
                editingRecordingSequence: data.recordingSequence
            }),
        openCommentModal: ()=>{
            set({
                commentModalOpened: true
            });
            const { submission: submission  } = get();
            const currentUser = getFull().AppData.currentUser;
            if (!submission || !currentUser || currentUser.id !== submission.userId) return;
            fetchJson(`/api/submissions/${submission.id}/mark_comments_viewed`, {
                method: "PATCH",
                onSuccess: ()=>{
                    set((s)=>({
                            comments: s.comments.map((c)=>({
                                    ...c,
                                    comment: {
                                        ...c.comment,
                                        viewed: true
                                    }
                                }))
                        }));
                }
            });
        },
        upgradeAssessment: ()=>set((s)=>{
                if (!s.assessment) return s;
                return {
                    assessment: {
                        ...s.assessment,
                        isUltimate: true
                    }
                };
            })
    }));




const $8aeaaf6ed1b02cb4$export$49d5fc8cba920a0 = {
    loading: false,
    saving: false,
    error: false,
    saved: false,
    courses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    selectedCourse: null,
    assessmentId: null,
    title: "",
    reading: null,
    currRegistrationAssessments: null,
    courseRegistrationAssessments: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    courseAssessmentsAssigned: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
};



const $38c89b47fddf8e30$export$9df7688c6b6ddf07 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("AssignToData", (0, $8aeaaf6ed1b02cb4$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        submit: (createToast)=>{
            const { currRegistrationAssessments: currRegistrationAssessments , courseAssessmentsAssigned: courseAssessmentsAssigned , assessmentId: assessmentId , selectedCourse: selectedCourse , load: load  } = get();
            if (!assessmentId || !selectedCourse?.id) return;
            set({
                saving: true,
                saved: false,
                error: false
            });
            fetchJson(`/api/registration_assessments/${assessmentId}`, {
                method: "PATCH",
                data: {
                    registrationAssessmentList: currRegistrationAssessments,
                    courseAssessment: courseAssessmentsAssigned.find((ca)=>ca.courseId === selectedCourse.id),
                    courseId: selectedCourse.id
                },
                onSuccess: ({ success: success , currentUserStatus: currentUserStatus  })=>{
                    load({
                        assessmentId: assessmentId,
                        setDefault: false
                    });
                    if (currentUserStatus === "needs_subscription") createToast({
                        children: "You are now eligible for a free trial of Readlee Pro! Check your email for details",
                        color: "success"
                    });
                    (0, $0d509ab7f782af11$export$fbd1812d64ca88a8)({
                        assessmentId: assessmentId
                    });
                    setTimeout(()=>set({
                            saving: false,
                            saved: true,
                            error: !success
                        }), 500);
                }
            });
        },
        setSelectedCourse: (course)=>{
            const { courseRegistrationAssessments: courseRegistrationAssessments  } = get();
            const registrationAssessmentData = courseRegistrationAssessments.get(course.id);
            set({
                selectedCourse: course,
                currRegistrationAssessments: registrationAssessmentData || null,
                saving: false,
                saved: false
            });
        },
        load: ({ assessmentId: assessmentId , courseId: courseId , setDefault: setDefault = true  })=>{
            if (setDefault) set({
                ...(0, $8aeaaf6ed1b02cb4$export$49d5fc8cba920a0),
                loading: true
            });
            fetchJson(`/api/registration_assessments/${assessmentId}`, {
                onSuccess: (data)=>{
                    set({
                        loading: false,
                        courses: data.courses,
                        courseRegistrationAssessments: data.courseRegistrationAssessments,
                        courseAssessmentsAssigned: data.courseAssessmentsAssigned,
                        assessmentId: assessmentId,
                        title: data.assessmentTitle
                    });
                    const course = data.courses.find((c)=>c.id === courseId) || null;
                    if (course) get().setSelectedCourse(course);
                }
            });
        },
        updateCheckbox: (registrationAssessment, createToast)=>()=>{
                const { submit: submit  } = get();
                set((state)=>{
                    const { currRegistrationAssessments: currRegistrationAssessments  } = state;
                    if (!currRegistrationAssessments) return state;
                    const index = currRegistrationAssessments.findIndex((a)=>a === registrationAssessment);
                    const newAssignments = currRegistrationAssessments.setIn([
                        index,
                        "assigned"
                    ], !registrationAssessment.assigned);
                    return {
                        ...state,
                        currRegistrationAssessments: newAssignments
                    };
                });
                submit(createToast);
            },
        updateVisibilitySettings: (registrationAssessment, value, createToast)=>()=>{
                const { submit: submit  } = get();
                set((state)=>{
                    const { currRegistrationAssessments: currRegistrationAssessments  } = state;
                    if (!currRegistrationAssessments) return state;
                    const index = currRegistrationAssessments.findIndex((a)=>a === registrationAssessment);
                    const newAssignments = currRegistrationAssessments.setIn([
                        index,
                        "submissionVisibility"
                    ], value);
                    return {
                        ...state,
                        currRegistrationAssessments: newAssignments
                    };
                });
                submit(createToast);
            },
        updateCourseAssessment: (createToast)=>()=>{
                const { submit: submit , optimisticUpdateCourseAssessment: optimisticUpdateCourseAssessment  } = get();
                optimisticUpdateCourseAssessment();
                submit(createToast);
            },
        optimisticUpdateCourseAssessment: ()=>{
            const { courseAssessmentsAssigned: courseAssessmentsAssigned , assessmentId: assessmentId , selectedCourse: selectedCourse  } = get();
            if (!assessmentId || !selectedCourse?.id) return;
            const courseAssessment = courseAssessmentsAssigned.find((ca)=>ca.courseId === selectedCourse.id);
            if (!courseAssessment) return;
            set({
                courseAssessmentsAssigned: courseAssessmentsAssigned.filter((ca)=>ca.courseId !== selectedCourse?.id).push({
                    ...courseAssessment,
                    assigned: !courseAssessment.assigned
                })
            });
        },
        toggleAll: (selected, createToast)=>()=>{
                const { submit: submit , optimisticUpdateCourseAssessment: optimisticUpdateCourseAssessment , courseAssessmentsAssigned: courseAssessmentsAssigned , assessmentId: assessmentId , selectedCourse: selectedCourse  } = get();
                if (!assessmentId || !selectedCourse?.id) return;
                set((state)=>{
                    if (!state.currRegistrationAssessments) return state;
                    return {
                        ...state,
                        currRegistrationAssessments: state.currRegistrationAssessments?.map((assignment)=>({
                                ...assignment,
                                assigned: !selected
                            }))
                    };
                });
                const courseAssessment = courseAssessmentsAssigned.find((ca)=>ca.courseId === selectedCourse.id);
                if (selected === courseAssessment?.assigned) optimisticUpdateCourseAssessment();
                submit(createToast);
            }
    }));





const $8118a53f15ca0ceb$export$49d5fc8cba920a0 = {
    loading: true,
    freeReadLoading: false,
    assessment: null,
    originalAssessment: null,
    reading: null,
    dirty: false,
    saving: false,
    taskDetailsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    originalTaskDetailsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    editingInstructions: false,
    editingWrittenInstructions: "",
    editingTitle: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    taskErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    cancelling: false,
    deletingTaskId: undefined,
    creatingTask: false,
    drawerExpanded: false,
    vocabTaskStep: "word",
    vocabWord: "",
    vocabImageFile: null,
    vocabImageFileUrl: "",
    uploading: false,
    primaryLicenseType: null,
    instructionDetails: null,
    sharingOpen: false,
    editingPublishingStatus: "private"
};





const $07d94146543f9064$export$fe7beb72791a1387 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("AssignmentBuilderData", (0, $8118a53f15ca0ceb$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>{
    const setPage = (key)=>(taskId, pageNumber)=>{
            set((state)=>{
                const taskDetails = state.taskDetailsMap.get(taskId);
                if (!taskDetails || taskDetails.type !== "ReadingTask" || taskDetails.task.readingPartType !== "pages") return state;
                return {
                    ...state,
                    dirty: true,
                    taskDetailsMap: state.taskDetailsMap.set(taskId, {
                        ...taskDetails,
                        task: {
                            ...taskDetails.task,
                            [key]: {
                                pageNumber: pageNumber
                            }
                        }
                    })
                };
            });
        };
    const setComprehensionTaskField = (taskId, key, value)=>{
        set((state)=>{
            const taskDetails = state.taskDetailsMap.get(taskId);
            const switchingToRecorded = key === "questionType" && value === "recorded";
            if (!taskDetails || taskDetails.type !== "ComprehensionTask") return {
                ...state,
                drawerExpanded: false
            };
            return {
                ...state,
                taskDetailsMap: state.taskDetailsMap.set(taskDetails.task.id, {
                    ...taskDetails,
                    task: {
                        ...taskDetails.task,
                        [key]: value
                    }
                }),
                drawerExpanded: switchingToRecorded ? false : state.drawerExpanded
            };
        });
    };
    const setVocabTaskField = (taskId, key, value)=>{
        set((state)=>{
            const taskDetails = state.taskDetailsMap.get(taskId);
            if (!taskDetails || taskDetails.type !== "VocabTask") return state;
            return {
                ...state,
                taskDetailsMap: state.taskDetailsMap.set(taskDetails.task.id, {
                    ...taskDetails,
                    task: {
                        ...taskDetails.task,
                        [key]: value
                    }
                })
            };
        });
    };
    const createTask = (taskType)=>(history)=>{
            const assessment = get().assessment;
            if (!assessment) return;
            set({
                creatingTask: true
            });
            const taskToMethodMap = {
                ComprehensionTask: "comprehension_tasks",
                ModelTask: "model_tasks",
                ReadingTask: "reading_tasks",
                VocabTask: "vocab_tasks"
            };
            fetchJson(`/api/assessments/${assessment.id}/${taskToMethodMap[taskType]}`, {
                method: "POST",
                data: {},
                onSuccess: (data)=>{
                    set((state)=>({
                            creatingTask: false,
                            taskDetailsMap: state.taskDetailsMap.set(data.taskDetails.task.id, data.taskDetails),
                            vocabTaskStep: "word"
                        }));
                    history.push(`/t/assignment-builder/${assessment.id}/tasks?currentTaskId=${data.taskDetails.task.id}`);
                }
            });
        };
    return {
        load: ({ assessmentId: assessmentId , readingId: readingId , currentTaskId: currentTaskId  })=>{
            set((0, $8118a53f15ca0ceb$export$49d5fc8cba920a0));
            // Fetch stuff
            fetchJson(`/api/assessments/${assessmentId}/edit`, {
                data: {
                    readingId: readingId
                },
                onSuccess: (data)=>{
                    const currentTaskDetails = currentTaskId ? data.taskDetailsMap.get(currentTaskId, null) : null;
                    set({
                        loading: false,
                        assessment: data.assessment,
                        originalAssessment: data.assessment,
                        reading: data.reading,
                        taskDetailsMap: data.taskDetailsMap,
                        instructionDetails: data.instructionDetails,
                        originalTaskDetailsMap: data.taskDetailsMap,
                        vocabTaskStep: currentTaskDetails?.type === "VocabTask" && currentTaskDetails?.word ? "details" : "word",
                        primaryLicenseType: data.primaryLicenseType,
                        editingWrittenInstructions: data.assessment.instructions,
                        editingPublishingStatus: data.assessment.publishingStatus
                    });
                }
            });
        },
        setReadingPartType: (taskId, readingPartType)=>{
            set((state)=>{
                const taskDetails = state.taskDetailsMap.get(taskId);
                if (!taskDetails) return state;
                if (taskDetails.type !== "ReadingTask") return state;
                return {
                    ...state,
                    dirty: true,
                    taskDetailsMap: state.taskDetailsMap.set(taskId, (0, $dc42676e288e1d72$export$5bbf46c666d38142)(taskDetails, readingPartType))
                };
            });
        },
        setTextRange: (taskId)=>(textRange, text)=>{
                set((state)=>{
                    const taskDetails = state.taskDetailsMap.get(taskId);
                    if (!taskDetails || taskDetails.type !== "ReadingTask" || taskDetails.task.readingPartType !== "start_and_end_index") return state;
                    return {
                        ...state,
                        dirty: true,
                        taskDetailsMap: state.taskDetailsMap.set(taskId, {
                            ...taskDetails,
                            task: {
                                ...taskDetails.task,
                                ...textRange,
                                newBasicText: text
                            }
                        })
                    };
                });
            },
        setVocabWord: (word)=>set({
                vocabWord: word
            }),
        setStartPage: setPage("startPoint"),
        setEndPage: setPage("endPoint"),
        submit: ({ query: query , history: history , taskOrder: baseTaskOrder = null  })=>{
            const { assessment: assessment , taskDetailsMap: taskDetailsMap , editingWrittenInstructions: editingWrittenInstructions  } = get();
            if (!assessment) return;
            assessment.instructions = editingWrittenInstructions;
            const taskOrder = baseTaskOrder || assessment.taskOrder;
            set({
                saving: true,
                dirty: false
            });
            fetchJson(`/api/assessments/${assessment.id}`, {
                method: "PATCH",
                data: {
                    assessment: assessment,
                    taskDetails: taskOrder.map(({ taskId: taskId  })=>taskDetailsMap.get(taskId)).toList().filter(Boolean)
                },
                onSuccess: (data)=>{
                    set((state)=>({
                            dirty: state.dirty || !data.success,
                            saving: false,
                            errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors),
                            taskErrors: data.taskErrors.map((errors)=>(0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors))
                        }));
                    if (data.success) {
                        set({
                            assessment: data.assessment,
                            originalAssessment: data.assessment,
                            taskDetailsMap: data.taskDetailsMap,
                            originalTaskDetailsMap: data.taskDetailsMap,
                            editingInstructions: false,
                            editingTitle: false,
                            deletingTaskId: undefined,
                            vocabWord: ""
                        });
                        history.replace(`/t/assignment-builder/${assessment.id}/tasks${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                            currentTaskId: null
                        })}`);
                    }
                }
            });
        },
        cancel: ()=>{
            set((state)=>({
                    ...state,
                    dirty: false,
                    editingTitle: false,
                    editingInstructions: false,
                    errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
                    assessment: state.originalAssessment,
                    editingWrittenInstructions: state.assessment?.instructions
                }));
        },
        cancelTask: (currentTaskId)=>{
            if (!currentTaskId) {
                set({
                    dirty: false,
                    cancelling: true,
                    vocabTaskStep: "word"
                });
                return;
            }
            const { taskDetailsMap: taskDetailsMap , originalTaskDetailsMap: originalTaskDetailsMap  } = get();
            const oldTaskDetails = originalTaskDetailsMap.get(currentTaskId);
            set({
                dirty: false,
                cancelling: true,
                taskDetailsMap: oldTaskDetails ? taskDetailsMap.set(currentTaskId, oldTaskDetails) : taskDetailsMap.remove(currentTaskId),
                vocabImageFile: null,
                vocabImageFileUrl: ""
            });
        },
        deleteTask: (currentTaskId, query, history)=>{
            const { assessment: assessment  } = get();
            if (!assessment) return;
            get().submit({
                query: query,
                history: history,
                taskOrder: assessment.taskOrder.filter((to)=>to.taskId !== currentTaskId)
            });
        },
        finishCancel: ({ query: query , history: history  })=>{
            const { assessment: assessment  } = get();
            if (!assessment) return;
            set({
                cancelling: false
            });
            history.replace(`/t/assignment-builder/${assessment.id}/tasks${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                currentTaskId: null
            })}`);
        },
        setField: setField,
        setAssessmentField: (key)=>(value)=>{
                set((state)=>state.assessment ? {
                        ...state,
                        assessment: {
                            ...state.assessment,
                            [key]: value
                        },
                        dirty: true
                    } : state);
            },
        createComprehensionTask: createTask("ComprehensionTask"),
        createModelReading: createTask("ModelTask"),
        createVocabTask: createTask("VocabTask"),
        onRecordingSequenceStatus: (data)=>{
            set((state)=>{
                const taskDetails = state.taskDetailsMap.find((taskDetails)=>taskDetails.type === "ComprehensionTask" && taskDetails.questionRecordingSequence.id === data.recordingSequence.id || taskDetails.type === "ModelTask" && taskDetails.recordingSequence.id === data.recordingSequence.id);
                if (taskDetails && taskDetails.type === "ComprehensionTask") return {
                    ...state,
                    taskDetailsMap: state.taskDetailsMap.set(taskDetails.task.id, {
                        ...taskDetails,
                        questionRecordingSequence: data.recordingSequence,
                        questionAudioFile: data.audioFile
                    })
                };
                else if (taskDetails && taskDetails.type === "ModelTask") return {
                    ...state,
                    taskDetailsMap: state.taskDetailsMap.set(taskDetails.task.id, {
                        ...taskDetails,
                        recordingSequence: data.recordingSequence,
                        audioFile: data.audioFile
                    })
                };
                return state;
            });
        },
        onInstructionsRecordingSequenceStatus: (data)=>set({
                instructionDetails: {
                    audioFile: data.audioFile,
                    instructionsRecordingSequence: data.recordingSequence
                }
            }),
        setQuestionType: (taskId, questionType)=>{
            setComprehensionTaskField(taskId, "questionType", questionType);
        },
        setResponseType: (taskId, responseType)=>{
            setComprehensionTaskField(taskId, "responseType", responseType);
        },
        setWrittenContent: (taskId, writtenContent)=>{
            setComprehensionTaskField(taskId, "writtenContent", writtenContent);
        },
        setDefinition: (taskId, definition)=>{
            setVocabTaskField(taskId, "definition", definition);
        },
        setCustomWord: (taskId, customWord)=>{
            setVocabTaskField(taskId, "customWord", customWord);
            setVocabTaskField(taskId, "name", customWord);
        },
        setWordContent: (taskId, word)=>{
            set((state)=>{
                const taskDetails = state.taskDetailsMap.get(taskId);
                if (!taskDetails || taskDetails.type !== "VocabTask") return state;
                return {
                    ...state,
                    taskDetailsMap: state.taskDetailsMap.set(taskDetails.task.id, {
                        ...taskDetails,
                        word: {
                            lemmaWord: word,
                            content: word,
                            id: "",
                            audioUrl: "",
                            definitions: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
                        }
                    })
                };
            });
        },
        setVocabImage: (taskId, imageFile)=>{
            set((state)=>{
                const taskDetails = state.taskDetailsMap.get(taskId);
                if (!taskDetails || taskDetails.type !== "VocabTask") return state;
                return {
                    ...state,
                    taskDetailsMap: state.taskDetailsMap.set(taskDetails.task.id, {
                        ...taskDetails,
                        task: {
                            ...taskDetails.task,
                            imageFileId: imageFile ? taskDetails.task.imageFileId : ""
                        },
                        imageFile: imageFile
                    })
                };
            });
        },
        saveTask: ({ taskDetails: taskDetails , query: query , history: history  })=>{
            const { assessment: assessment  } = get();
            if (!assessment) return;
            let taskOrder = assessment.taskOrder;
            if (!taskOrder.some((t)=>t.taskId === taskDetails.task.id && t.type === taskDetails.type)) {
                if (taskDetails.type === "ModelTask") {
                    const index = (taskOrder.findIndex((t)=>t.type === "ModelTask") ?? -1) + 1;
                    taskOrder = taskOrder.insert(index, {
                        taskId: taskDetails.task.id,
                        type: taskDetails.type
                    });
                } else if (taskDetails.type === "VocabTask") {
                    const index = (taskOrder.findIndex((t)=>t.type === "VocabTask") ?? -1) + 1;
                    taskOrder = taskOrder.insert(index, {
                        taskId: taskDetails.task.id,
                        type: taskDetails.type
                    });
                } else taskOrder = taskOrder.push({
                    taskId: taskDetails.task.id,
                    type: taskDetails.type
                });
            }
            get().submit({
                query: query,
                history: history,
                taskOrder: taskOrder
            });
        },
        saveWord: (taskId)=>{
            const { vocabWord: vocabWord  } = get();
            set({
                saving: true
            });
            fetchJson(`/api/words/definition`, {
                noRedirect: true,
                data: {
                    word: vocabWord
                },
                onSuccess: ({ displayWord: displayWord  })=>{
                    set((state)=>{
                        const taskDetails = state.taskDetailsMap.get(taskId);
                        if (!taskDetails || taskDetails.type !== "VocabTask") return state;
                        return {
                            ...state,
                            saving: false,
                            vocabTaskStep: "details",
                            taskDetailsMap: state.taskDetailsMap.set(taskDetails.task.id, {
                                ...taskDetails,
                                task: {
                                    ...taskDetails.task,
                                    wordId: displayWord.id,
                                    definition: !displayWord.definitions.isEmpty() ? displayWord.definitions.join("\n\n") : "Definition could not be autofilled"
                                },
                                word: displayWord
                            })
                        };
                    });
                }
            });
        },
        togglePublishingStatus: (isPaperUser)=>{
            const { assessment: assessment , editingPublishingStatus: editingPublishingStatus  } = get();
            if (!assessment) return;
            const defaultPublishingStatus = isPaperUser ? "district" : "public_preview";
            const newPublishingStatus = (0, $62e5f0fd429b4502$export$74634d91e494b98a)(editingPublishingStatus) ? "private" : defaultPublishingStatus;
            set({
                editingPublishingStatus: newPublishingStatus
            });
        },
        updatePublishingStatus: ()=>{
            const { assessment: assessment , editingPublishingStatus: editingPublishingStatus  } = get();
            if (!assessment) return;
            fetchJson(`/api/assessments/${assessment.id}/simple_update`, {
                method: "PATCH",
                data: {
                    assessment: {
                        publishingStatus: editingPublishingStatus
                    }
                },
                onSuccess: ({ assessment: { publishingStatus: publishingStatus  }  })=>{
                    set({
                        assessment: {
                            ...assessment,
                            publishingStatus: publishingStatus
                        },
                        editingPublishingStatus: publishingStatus,
                        sharingOpen: false
                    });
                }
            });
        },
        updateSampleStatus: (isSample)=>{
            const assessment = get().assessment;
            if (!assessment) return;
            set({
                assessment: {
                    ...assessment,
                    isSample: isSample
                }
            });
            fetchJson(`/api/assessments/${assessment.id}/simple_update`, {
                method: "PATCH",
                data: {
                    assessment: {
                        isSample: isSample
                    }
                }
            });
        },
        createFreeRead: (history)=>{
            set({
                freeReadLoading: true
            });
            fetchJson(`/api/free_reads`, {
                method: "POST",
                onSuccess: ({ success: success , assessment: assessment  })=>{
                    set({
                        freeReadLoading: false
                    });
                    if (success) history.push(`/reading-studio?assessmentId=${assessment.id}`);
                }
            });
        },
        uploadVocabImage: (taskId)=>(files)=>{
                const file = files.get(0, null);
                if (file) {
                    set({
                        vocabImageFileUrl: file ? URL.createObjectURL(file) : "",
                        uploading: true
                    });
                    fetchJson(`/api/image_stored_files`, {
                        method: "POST",
                        files: {
                            file: file
                        },
                        onSuccess: ({ storedFile: storedFile  })=>{
                            const { taskDetailsMap: taskDetailsMap  } = get();
                            const currentTask = taskDetailsMap.get(taskId);
                            if (!currentTask || currentTask.type !== "VocabTask") return;
                            set({
                                vocabImageFileUrl: null,
                                uploading: false,
                                taskDetailsMap: taskDetailsMap.set(taskId, {
                                    ...currentTask,
                                    imageFile: storedFile,
                                    task: {
                                        ...currentTask.task,
                                        imageFileId: storedFile.id
                                    }
                                })
                            });
                        }
                    });
                }
            },
        upgradeAssessmentAndStartVocab: (history)=>()=>{
                set((s)=>{
                    if (!s.assessment) return s;
                    return {
                        assessment: {
                            ...s.assessment,
                            isUltimate: true
                        }
                    };
                });
                get().createVocabTask(history);
            },
        startSharing: ()=>{
            set((s)=>({
                    sharingOpen: true,
                    editingPublishingStatus: s.assessment?.publishingStatus
                }));
        }
    };
});






const $febb58b3af68b217$export$49d5fc8cba920a0 = {
    loading: true,
    submitting: false,
    contentType: "text",
    reading: null,
    uploadedPdfFile: null,
    basicText: "",
    pdfFile: null,
    pdfFileUrl: null,
    pdfRotation: 0,
    coverImage: null,
    coverImageFile: null,
    coverImageFileUrl: "",
    basicTextFile: null,
    name: "",
    authorName: "",
    assessmentId: "",
    readingId: "",
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    scrapeErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    uploadingPdf: false,
    webModalOpen: false,
    scrapingWebSourceUrl: false,
    webSourceUrl: "",
    editingWebSourceUrl: "",
    selectedLicenseType: "open_source_needs_review",
    gradeLevels: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    tags: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    languageCode: (0, $647763111c79c7a8$export$13c02bdda694746),
    tagNameList: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    newTagName: "",
    selectedPlaylistIds: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    playlists: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    primaryLicenseType: null,
    isEll: false,
    isSpecialEducation: false,
    pdfTextDirty: false,
    peekPdf: false
};







const $f6504f597cf0744e$var$INVALID_URL_ERROR_MAP = {
    scrapeErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
        webSourceUrl: [
            "The provided URL is not valid"
        ]
    })
};
const $f6504f597cf0744e$var$setErrorState = (s)=>({
        errors: s.errors.set("contentFile", [
            "Could not upload file, please try again"
        ]),
        uploadingPdf: false,
        uploadedPdfFile: null
    });
const $f6504f597cf0744e$export$2ac9b3317e596ee9 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ReadingBuilderData", (0, $febb58b3af68b217$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>{
    const createOrUpdateReading = (url, method, onSuccess)=>{
        const { coverImage: coverImage , basicText: basicText , name: name , authorName: authorName , contentType: contentType , pdfFile: pdfFile , pdfRotation: pdfRotation , webSourceUrl: webSourceUrl , coverImageFile: coverImageFile , selectedLicenseType: selectedLicenseType , gradeLevelId: gradeLevelId , languageCode: languageCode , tagNameList: tagNameList , selectedPlaylistIds: selectedPlaylistIds , isEll: isEll , isSpecialEducation: isSpecialEducation  } = get();
        const isPdfFile = contentType === "pdf" || contentType === "pdf_by_page";
        fetchJson(url, {
            method: method,
            data: {
                contentType: contentType,
                name: name,
                authorName: authorName,
                basicText: basicText,
                pdfFileId: isPdfFile ? pdfFile?.id : null,
                pdfRotation: pdfRotation,
                webSourceUrl: contentType === "web" ? webSourceUrl : null,
                coverImageFileId: coverImageFile?.id,
                licenseType: selectedLicenseType,
                gradeLevelId: gradeLevelId,
                languageCode: languageCode,
                tagNameList: tagNameList,
                selectedPlaylistIds: selectedPlaylistIds,
                isEll: isEll,
                isSpecialEducation: isSpecialEducation
            },
            files: {
                ...coverImage ? {
                    coverImage: coverImage
                } : {}
            },
            onSuccess: onSuccess
        });
    };
    return {
        setField: setField,
        load: ({ assessmentId: assessmentId , readingId: readingId , isPaperUser: isPaperUser  })=>{
            set({
                ...(0, $febb58b3af68b217$export$49d5fc8cba920a0),
                assessmentId: assessmentId,
                readingId: readingId,
                loading: true
            });
            // Fetch stuff
            if (readingId) fetchJson(`/api/readings/${readingId}`, {
                onSuccess: (data)=>{
                    const { reading: reading , contentFile: contentFile , coverImageFile: coverImageFile , author: author , basicText: basicText , gradeLevels: gradeLevels , gradeLevel: gradeLevel , tags: tags , languageCode: languageCode , selectedPlaylistIds: selectedPlaylistIds , playlists: playlists , primaryLicenseType: primaryLicenseType  } = data;
                    const isPdfFile = contentFile.type === "PdfStoredFile" || contentFile.type === "PdfByPageStoredFile";
                    set({
                        reading: reading,
                        contentType: reading.contentType,
                        webSourceUrl: reading.webSourceUrl || "",
                        pdfFile: isPdfFile ? {
                            ...contentFile,
                            ...contentFile.type === "PdfByPageStoredFile" ? {
                                jsonText: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(contentFile.jsonText)
                            } : {}
                        } : null,
                        pdfFileUrl: isPdfFile ? contentFile.url : null,
                        basicTextFile: !isPdfFile ? contentFile : null,
                        basicText: basicText || "",
                        name: reading.name,
                        authorName: author?.name || "",
                        coverImageFile: coverImageFile || null,
                        coverImageFileUrl: coverImageFile?.thumbnailUrl,
                        gradeLevels: gradeLevels,
                        gradeLevelId: gradeLevel?.id,
                        tags: tags,
                        tagNameList: tags.map((t)=>t.name),
                        selectedLicenseType: reading.license,
                        languageCode: languageCode,
                        selectedPlaylistIds: selectedPlaylistIds,
                        playlists: playlists,
                        primaryLicenseType: primaryLicenseType,
                        isEll: reading.isEll,
                        isSpecialEducation: reading.isSpecialEducation
                    });
                    if (reading.contentType === "pdf") {
                        if (!contentFile || contentFile.type !== "PdfStoredFile") return;
                        fetchJson(`/api/pdf_by_page_stored_files/${contentFile.id}/convert_to_pdf_by_page`, {
                            method: "POST",
                            onSuccess: ({ storedFile: storedFile  })=>{
                                set({
                                    contentType: "pdf_by_page",
                                    pdfFile: storedFile,
                                    pdfFileUrl: storedFile.url,
                                    loading: false
                                });
                            }
                        });
                    } else set({
                        loading: false
                    });
                }
            });
            else fetchJson(`/api/readings/new`, {
                onSuccess: ({ gradeLevels: gradeLevels , playlists: playlists  })=>{
                    set({
                        gradeLevels: gradeLevels,
                        playlists: playlists,
                        loading: false,
                        selectedLicenseType: isPaperUser ? "district" : "open_source_needs_review"
                    });
                }
            });
        },
        toggleSharing: (isPaperUser)=>()=>{
                const defaultLicense = isPaperUser ? "district" : "open_source_needs_review";
                set(({ selectedLicenseType: selectedLicenseType  })=>({
                        selectedLicenseType: (0, $9858807ed795496b$export$e6ae6bdeba4fc9e3)(selectedLicenseType) ? "private_user_content" : defaultLicense
                    }));
            },
        rotatePdf: ()=>set((s)=>({
                    pdfRotation: (s.pdfRotation + 90) % 360
                })),
        uploadPdfFile: (files)=>{
            const file = files.first();
            if (!file) {
                set({
                    uploadedPdfFile: null,
                    pdfFile: null,
                    pdfFileUrl: null,
                    pdfRotation: 0,
                    contentType: "pdf_by_page"
                });
                return;
            }
            set({
                uploadingPdf: true
            });
            fetchJson(`/api/${get().contentType === "pdf" ? "pdf_stored_files" : "pdf_by_page_stored_files"}`, {
                method: "POST",
                files: {
                    file: file
                },
                onSuccess: ({ success: success , storedFile: storedFile  })=>{
                    if (success) set({
                        pdfFile: storedFile,
                        uploadedPdfFile: file,
                        pdfFileUrl: storedFile.url,
                        uploadingPdf: false
                    });
                    else set($f6504f597cf0744e$var$setErrorState);
                }
            });
        },
        submitForProcessing: (history, query)=>()=>{
                const onSuccess = ()=>history.push(`/t/reading-builder/processing${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                const { pdfRotation: pdfRotation , createRotatedPdf: createRotatedPdf , contentType: contentType  } = get();
                if ([
                    "pdf",
                    "pdf_by_page"
                ].includes(contentType) && pdfRotation !== 0) createRotatedPdf(onSuccess);
                else onSuccess();
            },
        createRotatedPdf: (onSuccess)=>{
            const { pdfFile: pdfFile  } = get();
            if (!pdfFile) return;
            set({
                submitting: true
            });
            fetchJson(`/api/${get().contentType === "pdf" ? "pdf_stored_files" : "pdf_by_page_stored_files"}/${pdfFile.id}/rotate`, {
                method: "POST",
                data: {
                    rotation: get().pdfRotation
                },
                onSuccess: ({ success: success , storedFile: storedFile  })=>{
                    set({
                        submitting: false
                    });
                    if (success) {
                        set({
                            pdfFile: storedFile,
                            pdfFileUrl: storedFile.url,
                            pdfRotation: 0
                        });
                        onSuccess?.();
                    } else set($f6504f597cf0744e$var$setErrorState);
                }
            });
        },
        submit: ({ history: history , query: query  })=>()=>{
                const { reading: reading  } = get();
                const readingUrl = `/api/readings/${reading ? reading.id : ""}`;
                const method = reading ? "PATCH" : "POST";
                set({
                    submitting: true
                });
                createOrUpdateReading(readingUrl, method, ({ success: success , errors: errors , reading: reading , tags: tags  })=>{
                    const errorMap = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors);
                    set({
                        submitting: false,
                        errors: errorMap,
                        reading: reading,
                        tags: tags
                    });
                    if (!success) {
                        if (errorMap.has("contentFile") || errorMap.has("webSourceUrl")) {
                            history.push(`/t/reading-builder/content${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                            if (errorMap.has("webSourceUrl")) get().openWebSourceUrlModal();
                        } else history.push(`/t/reading-builder/metadata${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                    } else get().goToAssignmentBuilder({
                        history: history
                    });
                });
            },
        goToAssignmentBuilder: ({ history: history  })=>{
            const { reading: reading , assessmentId: assessmentId  } = get();
            if (!reading) return;
            const assessmentUrl = `/api/assessments${assessmentId ? `/${assessmentId}/update_reading` : ""}`;
            const method = assessmentId ? "PATCH" : "POST";
            fetchJson(assessmentUrl, {
                method: method,
                data: {
                    readingId: reading.id
                },
                onSuccess: (data)=>{
                    const query = (0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                        readingId: reading.id,
                        assessmentId: data.assessment.id
                    }));
                    if (!assessmentId) (0, $0d509ab7f782af11$export$5983f165d101388e)({
                        assessment: data.assessment
                    });
                    history.replace(`/t/reading-builder/metadata${query}`);
                    const assignmentBuilderQuery = reading.contentType === "independent" ? {} : {
                        currentTaskId: data.readingTask.id
                    };
                    history.push(`/t/assignment-builder/${data.assessment.id}${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)(assignmentBuilderQuery)}`);
                }
            });
        },
        onPdfProcessingStatus: (data)=>{
            const pdfFile = {
                ...data.storedFile,
                ...data.storedFile.type === "PdfByPageStoredFile" ? {
                    jsonText: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.storedFile.jsonText)
                } : {}
            };
            set({
                pdfFile: pdfFile
            });
        },
        fetchArticle: ()=>{
            const editingWebSourceUrl = get().editingWebSourceUrl;
            if (editingWebSourceUrl.length > 0) try {
                new window.URL(editingWebSourceUrl || "");
            } catch (e) {
                set($f6504f597cf0744e$var$INVALID_URL_ERROR_MAP);
                return;
            }
            set({
                scrapingWebSourceUrl: true,
                scrapeErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
            });
            fetchJson(`/api/website_metadata`, {
                method: "POST",
                data: {
                    url: editingWebSourceUrl
                },
                onSuccess: (data)=>{
                    set((s)=>({
                            webModalOpen: !data.success,
                            scrapeErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors),
                            name: data.title || "Unknown Title",
                            authorName: data.author || "Unknown Author",
                            coverImageFile: data.coverImageFile,
                            coverImageFileUrl: data.coverImageFile?.thumbnailUrl || "",
                            scrapingWebSourceUrl: false,
                            webSourceUrl: data.success ? editingWebSourceUrl : s.webSourceUrl
                        }));
                }
            });
        },
        openWebSourceUrlModal: ()=>set((s)=>({
                    contentType: "web",
                    webModalOpen: true,
                    editingWebSourceUrl: s.webSourceUrl,
                    scrapeErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
                })),
        adminUpdate: (history, query, createToast)=>()=>{
                const { reading: reading  } = get();
                if (!reading) return;
                set({
                    submitting: true
                });
                createOrUpdateReading(`/api/readings/${reading.id}/moderator_update`, "PATCH", ({ success: success , errors: errors , reading: reading , tags: tags  })=>{
                    const errorMap = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors);
                    set({
                        submitting: false,
                        errors: errorMap,
                        reading: reading,
                        tags: tags
                    });
                    if (success) {
                        createToast({
                            children: "Content Updated!",
                            color: "success",
                            duration: 1000
                        });
                        return;
                    }
                    if (errorMap.has("contentFile") || errorMap.has("webSourceUrl")) {
                        history.push(`/t/reading-builder/content${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                        if (errorMap.has("webSourceUrl")) get().openWebSourceUrlModal();
                    } else history.push(`/t/reading-builder/metadata${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                    createToast({
                        children: "Updated failed!",
                        color: "danger",
                        duration: 5000
                    });
                });
            },
        removeTag: (tagName)=>()=>{
                set((state)=>({
                        tagNameList: state.tagNameList.filter((t)=>t !== tagName)
                    }));
            },
        addTag: ()=>{
            const { newTagName: newTagName , tagNameList: tagNameList  } = get();
            const cleanTagContent = (str)=>{
                return str.replace(/[,;]/g, " ").trim();
            };
            if (newTagName) set({
                tagNameList: tagNameList.push(cleanTagContent(newTagName)),
                newTagName: ""
            });
        },
        setPdfPageText: (page, pageText)=>{
            set((state)=>{
                if (!state.pdfFile || state.pdfFile?.type === "PdfStoredFile") return state;
                return {
                    pdfTextDirty: true,
                    pdfFile: {
                        ...state.pdfFile,
                        jsonText: state.pdfFile.jsonText.set(String(page), pageText)
                    }
                };
            });
        },
        overridePdfJsonText: ({ history: history , query: query  })=>()=>{
                const { pdfFile: pdfFile , pdfTextDirty: pdfTextDirty  } = get();
                if (!pdfFile || pdfFile.type === "PdfStoredFile") return;
                const onSuccess = get().submit({
                    history: history,
                    query: query
                });
                if (!pdfTextDirty) {
                    onSuccess();
                    return;
                }
                set({
                    submitting: true
                });
                const jsonText = JSON.stringify(pdfFile.jsonText.toJSON());
                fetchJson(`/api/pdf_by_page_stored_files/${pdfFile.id}/override_json_text`, {
                    method: "PATCH",
                    data: {
                        jsonText: jsonText
                    },
                    onSuccess: ({ success: success  })=>{
                        if (success) onSuccess();
                        else set($f6504f597cf0744e$var$setErrorState);
                    }
                });
            }
    };
});




const $948ab9c7c48ab5cc$export$49d5fc8cba920a0 = {
    open: false,
    displayDefinitions: false,
    word: "",
    error: "",
    displayWord: null,
    definitions: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([]),
    synonyms: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([]),
    audioUrl: null,
    isLoading: false
};


const $d1a2ea48cb8084b5$var$dictionaryCache = {};
const $d1a2ea48cb8084b5$export$4178dd420e169c2c = "Could not load definitions or synonyms at this time";
const $d1a2ea48cb8084b5$export$da4235c10b3b66ef = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("DictionaryData", (0, $948ab9c7c48ab5cc$export$49d5fc8cba920a0), ({ set: set , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>set((0, $948ab9c7c48ab5cc$export$49d5fc8cba920a0)),
        searchDictionary: (query)=>{
            set({
                open: true,
                isLoading: true,
                word: query
            });
            const cacheResult = $d1a2ea48cb8084b5$var$dictionaryCache[query];
            if (cacheResult) {
                const { definitions: definitions , synonyms: synonyms , audioUrl: audioUrl , displayWord: displayWord  } = cacheResult;
                set({
                    displayWord: displayWord,
                    definitions: definitions,
                    synonyms: synonyms,
                    audioUrl: audioUrl,
                    error: "",
                    isLoading: false,
                    displayDefinitions: true
                });
                return;
            }
            fetchJson(`/api/words/definition`, {
                noRedirect: true,
                data: {
                    word: query
                },
                onUnknownError: ()=>set({
                        error: $d1a2ea48cb8084b5$export$4178dd420e169c2c,
                        isLoading: false
                    }),
                onSuccess: ({ definitions: definitions , synonyms: synonyms , audioUrl: audioUrl , error: error , displayWord: displayWord  })=>{
                    if (error) {
                        set({
                            error: $d1a2ea48cb8084b5$export$4178dd420e169c2c,
                            isLoading: false
                        });
                        return;
                    }
                    $d1a2ea48cb8084b5$var$dictionaryCache[query] = {
                        definitions: definitions,
                        synonyms: synonyms,
                        audioUrl: audioUrl,
                        displayWord: displayWord
                    };
                    set({
                        definitions: definitions,
                        synonyms: synonyms,
                        audioUrl: audioUrl,
                        displayWord: displayWord,
                        isLoading: false,
                        displayDefinitions: true,
                        error: ""
                    });
                }
            });
        },
        report: (wordId, createToast)=>{
            if (!wordId) return;
            fetchJson(`/api/dictionary_reports`, {
                method: "POST",
                data: {
                    wordId: wordId
                },
                onSuccess: ()=>createToast({
                        children: "Word reported for review!",
                        color: "success"
                    })
            });
        }
    }));





const $8219c4962c2bc43c$export$49d5fc8cba920a0 = {
    loading: true,
    currentUser: null,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    addedManualSchool: false,
    userSchools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    tempPositions: "",
    tempTeachesSpecialEd: "unanswered",
    tempTeachesEll: "unanswered"
};



const $1f564b4eac6a5c8c$export$305db408278f668b = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("TeacherOnboardingData", (0, $8219c4962c2bc43c$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , fetchJson: fetchJson  })=>{
    return {
        ...(0, $8219c4962c2bc43c$export$49d5fc8cba920a0),
        setField: setField,
        load: ()=>{
            set({
                ...(0, $8219c4962c2bc43c$export$49d5fc8cba920a0),
                loading: true
            });
            fetchJson(`/api/users/me`, {
                onSuccess: (data)=>{
                    set({
                        currentUser: data.currentUser,
                        tempPositions: data.currentUser.positions || "",
                        tempTeachesSpecialEd: data.currentUser.teachesSpecialEducation,
                        tempTeachesEll: data.currentUser.teachesEll,
                        userSchools: data.schools,
                        loading: false
                    });
                }
            });
        },
        submitSchool: (history, query, schools, savedSchools)=>()=>{
                const { currentUser: currentUser  } = get();
                if (!currentUser || schools.size === 0 && savedSchools.size === 0) return;
                fetchJson(`/api/users/${currentUser.id}/update_schools`, {
                    method: "PATCH",
                    data: {
                        onboardingStatus: "completed",
                        schoolIds: schools.isEmpty() ? savedSchools.map((s)=>s.id) : schools.map((s)=>s.id)
                    },
                    onSuccess: ()=>{
                        history.push(`/t/onboarding/questions${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                    }
                });
            },
        submitResponses: (history, redirectPath)=>()=>{
                const { currentUser: currentUser , tempPositions: tempPositions , tempTeachesSpecialEd: tempTeachesSpecialEd , tempTeachesEll: tempTeachesEll  } = get();
                if (!currentUser) return;
                fetchJson(`/api/users/${currentUser.id}`, {
                    method: "PATCH",
                    data: {
                        positions: tempPositions,
                        teachesSpecialEducation: tempTeachesSpecialEd,
                        teachesEll: tempTeachesEll
                    },
                    onSuccess: ()=>{
                        history.push(redirectPath || "/");
                    }
                });
            },
        skip: (history, redirectPath)=>{
            const { currentUser: currentUser  } = get();
            if (!currentUser) return;
            if (currentUser.onboardingStatus === "completed") {
                history.push(redirectPath || "/");
                return;
            }
            fetchJson(`/api/users/${currentUser.id}/update_schools`, {
                method: "PATCH",
                data: {
                    onboardingStatus: "skipped"
                },
                onSuccess: ()=>{
                    history.push(redirectPath || "/");
                }
            });
        }
    };
});





const $9b4d3476d22e5b1b$export$49d5fc8cba920a0 = {
    loading: false,
    trialEndDate: "",
    searchQuery: "",
    generalError: "",
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    results: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
};





const $f55503dc0a13f803$export$26ccd03c178861a6 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("UserSearchData", (0, $9b4d3476d22e5b1b$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>{
    const onSuccessfulAction = (history, query)=>({ success: success , errors: errors  })=>{
            if (success) get().submit(history, query, `/m/user-search${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
            else set({
                generalError: errors ? "" : "Something went wrong! Reach out to #engineering for help!",
                errors: errors ? (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors) : (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
            });
        };
    return {
        setField: setField,
        load: ({ searchQuery: searchQuery , onSuccess: onSuccess  })=>{
            set({
                ...(0, $9b4d3476d22e5b1b$export$49d5fc8cba920a0),
                searchQuery: searchQuery
            });
            onSuccess();
        },
        submit: (history, query, targetUrl)=>{
            set({
                loading: true
            });
            const { searchQuery: searchQuery  } = get();
            fetchJson(`/api/users/admin_search?query=${searchQuery}`, {
                method: "GET",
                onSuccess: ({ results: results  })=>{
                    set({
                        ...(0, $9b4d3476d22e5b1b$export$49d5fc8cba920a0),
                        results: results,
                        searchQuery: searchQuery
                    });
                    history.push(targetUrl || `${history.location.pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                        query: searchQuery
                    })}`);
                }
            });
        },
        updateUser: (user, history, query, param, value)=>{
            fetchJson(`/api/users/${user.id}/admin_update`, {
                method: "PATCH",
                data: {
                    [param]: value
                },
                onSuccess: onSuccessfulAction(history, query)
            });
        },
        updateUserSchool: (userSchool, role, history, query)=>{
            fetchJson(`/api/user_schools/${userSchool.id}`, {
                method: "PATCH",
                data: {
                    role: role
                },
                onSuccess: onSuccessfulAction(history, query)
            });
        },
        closeTrialModal: (history, query)=>()=>{
                set({
                    trialEndDate: "",
                    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
                });
                history.push(`/m/user-search${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
            },
        deleteUser: (user, history, query)=>()=>{
                fetchJson(`/api/users/${user.id}`, {
                    method: "DELETE",
                    onSuccess: onSuccessfulAction(history, query)
                });
            },
        grantTrial: (user, history, query)=>{
            const { trialEndDate: trialEndDate  } = get();
            if (!user || !trialEndDate) return;
            fetchJson(`/api/users/${user.id}/grant_trial`, {
                method: "POST",
                data: {
                    trialEndDate: new Date(trialEndDate)
                },
                onSuccess: onSuccessfulAction(history, query)
            });
        }
    };
});




const $cafecabfdafd7ad2$export$49d5fc8cba920a0 = {
    courses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    students: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    teachersMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    stats: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    studentSubmissionsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    cache: {
        courses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
        stats: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
    },
    isLoading: false,
    search: "",
    dateRange: "Last 7 Days"
};



const $e5496bf32b428d53$export$e985477e60703611 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ProgressMonitoringData", (0, $cafecabfdafd7ad2$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: (id, startTime, dateRange)=>{
            set({
                isLoading: true
            });
            const { cache: cache  } = get();
            const courseCache = cache.stats.get(id);
            const queryCache = courseCache?.get(dateRange);
            if (queryCache && cache.courses) set({
                isLoading: false,
                courses: cache.courses,
                stats: queryCache
            });
            else fetchJson(`/api/courses/course_summary`, {
                data: {
                    id: id,
                    startTime: startTime
                },
                onSuccess: ({ stats: stats , courses: courses , teachersMap: teachersMap  })=>{
                    // Caching has been messing people up more and more, let's incur the cost to see if people complain
                    // const courseMap =
                    //   courseCache || ImmutableMap<TimeLabel, ImmutableMap<string, StatResponse>>();
                    // const updatedCourseMap = courseMap.set(dateRange, ImmutableMap(stats));
                    // const updatedStatsCache = cache.stats.set(id, updatedCourseMap);
                    set({
                        isLoading: false,
                        courses: courses,
                        stats: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(stats),
                        teachersMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(teachersMap)
                    });
                }
            });
        },
        clearCache: ()=>set({
                cache: {
                    courses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                    stats: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
                }
            })
    }));





const $af8d4c05013ec42c$export$49d5fc8cba920a0 = {
    submissionResults: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    students: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    stats: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    prevStats: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    loading: false,
    user: null,
    assessmentMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    assessmentToCourseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    gradeLevelMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    monitoringCache: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    teacherMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    gradeLevel: 1,
    season: (0, $73b0620564a5efc3$export$2e8f853eec105774)(),
    wcpmTooltipProps: {
        top: "0",
        left: "0",
        display: "none",
        xAlign: "right",
        yAlign: "center"
    },
    readingTooltipProps: {
        top: "0",
        left: "0",
        display: "none",
        xAlign: "right",
        yAlign: "center"
    },
    wcpmTooltipData: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    readingTooltipData: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    search: ""
};





const $a38013169270959c$export$aeac15d37b072318 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("StudentProgressMonitoringData", (0, $af8d4c05013ec42c$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , setFieldWithFunction: setFieldWithFunction , fetchJson: fetchJson  })=>({
        setField: setField,
        clearCache: ()=>set({
                monitoringCache: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
            }),
        load: (id, startTime, endTime, prevStartTime, prevEndTime, dateRange)=>{
            const { monitoringCache: monitoringCache , user: user  } = get();
            if (user?.id !== id) set({
                monitoringCache: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
            });
            else {
                const cachedResponse = monitoringCache.get(id)?.get(dateRange);
                if (cachedResponse) {
                    set({
                        ...cachedResponse
                    });
                    return;
                }
            }
            set({
                loading: true
            });
            fetchJson(`/api/users/${id}/progress_monitoring`, {
                data: {
                    startTime: startTime,
                    endTime: endTime,
                    prevStartTime: prevStartTime,
                    prevEndTime: prevEndTime
                },
                onSuccess: (data)=>{
                    // Caching has been messing people up more and more, let's incur the cost to see if people complain
                    // const updatedMonitoringCache = monitoringCache.update(id, (dateCache) =>
                    //   dateCache
                    //     ? dateCache.set(dateRange, data)
                    //     : ImmutableMap<TimeLabel, StudentProgressMonitoringResponse>(),
                    // );
                    const storedGradeLevelStr = $7026505adadcfc0e$export$f92dfeb71e9bb569(`progress-monitoring-gradeLevel-${data.user.id}`);
                    const storedGradeLevel = storedGradeLevelStr ? parseInt(storedGradeLevelStr, 10) : null;
                    const storedSeason = $7026505adadcfc0e$export$f92dfeb71e9bb569(`progress-monitoring-season-${data.user.id}`);
                    set({
                        ...data,
                        gradeLevel: typeof storedGradeLevel === "number" && !Number.isNaN(storedGradeLevel) ? storedGradeLevel : Math.min(data.gradeLevelMap.filter((v)=>v).maxBy((v)=>v.level)?.level ?? 1, 6),
                        season: storedSeason ?? (0, $73b0620564a5efc3$export$2e8f853eec105774)(),
                        // monitoringCache: updatedMonitoringCache,
                        loading: false
                    });
                }
            });
        },
        setWcpmTooltipProps: setFieldWithFunction("wcpmTooltipProps"),
        setWcpmTooltipData: setField("wcpmTooltipData"),
        setReadingTooltipProps: setFieldWithFunction("readingTooltipProps"),
        setReadingTooltipData: setField("readingTooltipData")
    }));





const $df3ac23c4a0b59e4$export$49d5fc8cba920a0 = {
    loading: true,
    currentUser: null,
    currentPlan: (0, $4ded3b2c5af96cca$export$fa35d849a2b6d142)(),
    currentSubscription: null,
    creatingSession: false,
    plans: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    downgradingPlan: null
};



const $280312fb5aa46101$export$96819a30c233ec3a = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("PlanListData", (0, $df3ac23c4a0b59e4$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , fetchJson: fetchJson  })=>{
    const onPlanActivated = (createToast)=>{
        createToast({
            children: "Payment successful! Your plan has been activated!"
        });
    };
    const loadWithoutReset = (createToast, history)=>{
        fetchJson(`/api/plans`, {
            onSuccess: (data)=>{
                set({
                    ...data,
                    loading: false
                });
                const query = new URLSearchParams(window.location.search);
                if (query.get("payment-status") === "success" && data.currentSubscription) {
                    onPlanActivated(createToast);
                    history.replace(`/t/plans`);
                } else if (query.get("payment-status") === "cancelled") {
                    createToast({
                        children: "Payment cancelled, you have not been charged and your plan has not been changed.",
                        color: "warning"
                    });
                    history.replace(`/t/plans`);
                }
            }
        });
    };
    return {
        ...(0, $df3ac23c4a0b59e4$export$49d5fc8cba920a0),
        setField: setField,
        load: (createToast, history)=>{
            set((0, $df3ac23c4a0b59e4$export$49d5fc8cba920a0));
            loadWithoutReset(createToast, history);
        },
        startDowngrade: (plan)=>()=>{
                set({
                    downgradingPlan: plan
                });
            },
        downgrade: (plan, createToast)=>()=>{
                const { currentPlan: currentPlan , currentSubscription: currentSubscription  } = get();
                if (!currentPlan || !currentSubscription) return;
                set({
                    creatingSession: true,
                    downgradingPlan: null
                });
                fetchJson(`/api/plans/downgrade`, {
                    method: "POST",
                    data: {
                        planId: plan.id,
                        paymentInterval: "month"
                    },
                    onSuccess: (data)=>{
                        set({
                            ...data,
                            creatingSession: false
                        });
                        const endsAt = new Date(currentSubscription.currentPeriodEndsAt);
                        createToast({
                            children: `Your subscription has been cancelled and you will not be charged
              next ${currentSubscription.paymentInterval}. You can keep using your Readlee
              ${currentPlan.name} subscription until the current payment period ends on
              ${(0, $73b0620564a5efc3$export$3ae94a2503e890a1)(endsAt)} at ${(0, $73b0620564a5efc3$export$3203edd9e5edd663)(endsAt)}.`,
                            color: "warning"
                        });
                    }
                });
            },
        startPaymentSession: (planId, paymentInterval)=>()=>{
                set({
                    creatingSession: true
                });
                fetchJson(`/api/plans/create_session`, {
                    method: "POST",
                    data: {
                        planId: planId,
                        paymentInterval: paymentInterval
                    },
                    onSuccess: (data)=>{
                        window.location.replace(data.sessionUrl);
                        set({
                            creatingSession: false
                        });
                    }
                });
            },
        onSubscriptionStatus: ({ createToast: createToast , action: action , payload: payload  })=>{
            set({
                currentPlan: payload.plan,
                currentSubscription: payload.subscription
            });
            if (action === "payment_completed") onPlanActivated(createToast);
        },
        onSubscriptionConnected: (createToast, history)=>{
            // Avoid race conditions with the initial load and websocket by re-fetching when it's connected
            loadWithoutReset(createToast, history);
        }
    };
});




const $618fd83185e8e110$export$49d5fc8cba920a0 = {
    loading: true,
    assessment: null,
    taskDetails: null,
    submissionMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    studentIdToAssignedCoursesMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    submissionIdToTaskSubmissionDetailsMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    taskCardOpen: true,
    userMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    courseMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
};


const $e7adb81014cf150f$export$4ee661ef11c2c07b = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("TaskOverviewData", (0, $618fd83185e8e110$export$49d5fc8cba920a0), ({ set: set , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        upgradeAssessment: ()=>set((s)=>{
                if (!s.assessment) return s;
                return {
                    assessment: {
                        ...s.assessment,
                        isUltimate: true
                    }
                };
            }),
        load: (taskId, type)=>{
            set({
                loading: true
            });
            fetchJson(`/api/tasks/${taskId}`, {
                method: "GET",
                data: {
                    taskType: type
                },
                onSuccess: ({ success: _ , ...data })=>{
                    set({
                        ...data,
                        loading: false
                    });
                }
            });
        }
    }));



const $894a122b12e6ac71$export$49d5fc8cba920a0 = {
    opened: false,
    confirmDeleteText: "",
    action: "toggleArchive"
};


const $a1c01af30dd2368f$export$5c933a982a4a896b = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("UpdateAssignmentStatusModalData", (0, $894a122b12e6ac71$export$49d5fc8cba920a0), ({ fetchJson: fetchJson , get: get , set: set , setField: setField , getFull: getFull  })=>({
        openStatusUpdateModal: (assessment, action)=>set({
                assessment: assessment,
                action: action,
                opened: true,
                confirmDeleteText: ""
            }),
        confirmUpdateAssignmentStatus: (history, createToast, onSuccess)=>()=>{
                const { assessment: assessment , action: action , getActionName: getActionName  } = get();
                if (!assessment) return;
                const getStatus = ()=>{
                    if (action === "toggleArchive") return assessment?.status === "active" ? "archived" : "active";
                    return "deleted";
                };
                fetchJson(`/api/assessments/${assessment.id}/simple_update`, {
                    method: "PATCH",
                    data: {
                        status: getStatus()
                    },
                    onSuccess: ({ assessment: assessment  })=>{
                        history.push("/t/assignments");
                        createToast({
                            children: `Assessment ${getActionName()}d!`,
                            color: "success"
                        });
                        set({
                            opened: false
                        });
                        getFull().ProgressMonitoringData.clearCache();
                        getFull().StudentProgressMonitoringData.clearCache();
                        onSuccess?.(assessment);
                    }
                });
            },
        getActionName: ()=>{
            const { assessment: assessment , action: action  } = get();
            if (action === "toggleArchive") return assessment?.status === "active" ? "archive" : "restore";
            return "delete";
        },
        setField: setField
    }));




const $d7193383d426ba4c$export$49d5fc8cba920a0 = {
    assessmentId: "",
    opened: false,
    submitting: false,
    sharingEmail: "",
    sharingErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};



const $39d47d3074b85f2b$export$9036313b5e595c3f = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ShareModalData", (0, $d7193383d426ba4c$export$49d5fc8cba920a0), ({ set: set , setField: setField , get: get , fetchJson: fetchJson  })=>({
        setField: setField,
        openShareModal: (assessmentId)=>set({
                assessmentId: assessmentId,
                opened: true
            }),
        submitShare: (createToast)=>()=>{
                const { sharingEmail: sharingEmail , assessmentId: assessmentId  } = get();
                set({
                    submitting: true
                });
                fetchJson(`/api/assessments/${assessmentId}/share`, {
                    method: "POST",
                    data: {
                        email: sharingEmail
                    },
                    onSuccess: (data)=>{
                        set({
                            submitting: false,
                            sharingErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors)
                        });
                        if (data.success) {
                            set({
                                sharingEmail: "",
                                opened: false
                            });
                            createToast({
                                children: "Assignment has been shared!"
                            });
                        }
                    }
                });
            }
    }));




const $a06a62f21f104d07$export$49d5fc8cba920a0 = {
    assessmentId: "",
    opened: false,
    submitting: false,
    duplicatingName: "",
    duplicatingErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};



const $4b3c83274eabf86f$export$89571c7e2b3ab301 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("DuplicateModalData", (0, $a06a62f21f104d07$export$49d5fc8cba920a0), ({ set: set , setField: setField , get: get , fetchJson: fetchJson  })=>({
        setField: setField,
        openDuplicateModal: (assessmentId)=>set({
                assessmentId: assessmentId,
                opened: true
            }),
        submitDuplicate: (createToast, history)=>()=>{
                const { assessmentId: assessmentId , duplicatingName: duplicatingName  } = get();
                if (!assessmentId) return;
                set({
                    submitting: true
                });
                fetchJson(`/api/assessments/${assessmentId}/duplicate`, {
                    method: "POST",
                    data: {
                        name: duplicatingName
                    },
                    onSuccess: (data)=>{
                        set({
                            submitting: false,
                            duplicatingErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors)
                        });
                        if (data.success) {
                            set({
                                duplicatingName: "",
                                opened: false
                            });
                            history.push(`/t/assignments/${data.assessment.id}`);
                            createToast({
                                children: "Assignment has been duplicated!"
                            });
                        }
                    }
                });
            }
    }));



var $eYBdv = parcelRequire("eYBdv");



const $1cdada3b012c649b$export$49d5fc8cba920a0 = {
    gradeLevels: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    searchResults: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    playlistResults: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    submissionMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    continueReadingMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    loading: false,
    gradeLevelsLoading: false,
    initialSearch: true,
    totalResults: 0,
    selectionModalOpen: false,
    assignmentsLoading: false,
    selectedSearchResult: null,
    assessmentResults: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    userMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    playlists: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
};




var $g5BLJ = parcelRequire("g5BLJ");





const $3935c2aa64ec7a52$export$b356a74f1d7cab6e = ({ minWords: minWords , maxWords: maxWords  })=>`${minWords}-${maxWords || "max"}`;
const $3935c2aa64ec7a52$export$ad126554effc3578 = ({ minWords: minWords , maxWords: maxWords  })=>{
    if (typeof maxWords !== "number") return `${minWords}+`;
    else if (minWords === 1) return `< ${maxWords}`;
    else return `${minWords}-${maxWords}`;
};
const $3935c2aa64ec7a52$export$b3465c55a23f9775 = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        minWords: 1,
        maxWords: 100
    },
    {
        minWords: 100,
        maxWords: 250
    },
    {
        minWords: 250,
        maxWords: 500
    },
    {
        minWords: 500,
        maxWords: 1000
    },
    {
        minWords: 1000,
        maxWords: null
    }
]);
const $3935c2aa64ec7a52$export$e9acd43c1fb0fd1e = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)($3935c2aa64ec7a52$export$b3465c55a23f9775.map((v)=>[
        $3935c2aa64ec7a52$export$b356a74f1d7cab6e(v),
        v
    ]));
const $3935c2aa64ec7a52$export$b72f3303d4547637 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const baseSearchText = query.get("searchText");
    const baseGradeBands = query.get("gradeBands");
    const baseOwnershipTypes = query.get("ownershipTypes");
    const basePageNumber = query.get("pageNumber");
    const baseWordCounts = query.get("wordCounts");
    const baseTagIds = query.get("tagIds");
    const baseAdditionalFilters = query.get("additionalFilters");
    const pageNumber = (0, $g5BLJ.useMemo)(()=>parseInt(basePageNumber ?? "0"), [
        basePageNumber
    ]);
    const searchText = (0, $g5BLJ.useMemo)(()=>baseSearchText ?? "", [
        baseSearchText
    ]);
    const tagIds = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(baseTagIds?.split(",") ?? []), [
        baseTagIds
    ]);
    const gradeBands = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(baseGradeBands?.split(",") ?? []), [
        baseGradeBands
    ]);
    const ownershipTypes = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(baseOwnershipTypes?.split(",") ?? []), [
        baseOwnershipTypes
    ]);
    const wordCounts = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(baseWordCounts?.split(",") ?? []), [
        baseWordCounts
    ]);
    const additionalFilters = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(baseAdditionalFilters?.split(",") ?? []), [
        baseAdditionalFilters
    ]);
    const searchData = (0, $g5BLJ.useMemo)(()=>({
            searchText: searchText,
            gradeBands: gradeBands,
            ownershipTypes: ownershipTypes,
            pageNumber: pageNumber,
            wordCounts: wordCounts,
            tagIds: tagIds,
            additionalFilters: additionalFilters
        }), [
        searchText,
        gradeBands,
        ownershipTypes,
        pageNumber,
        wordCounts,
        tagIds,
        additionalFilters
    ]);
    return searchData;
};
const $3935c2aa64ec7a52$export$2d38afb37916ea3b = ()=>{
    const setField = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ContentLibraryData.setField, []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const setQuery = (0, $g5BLJ.useCallback)((updates)=>{
        setField("loading")(true);
        history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            ...updates,
            pageNumber: "0",
            playlistId: null
        })}`);
    }, [
        history,
        pathname,
        query,
        setField
    ]);
    return setQuery;
};
const $3935c2aa64ec7a52$export$b10469f2a2292df6 = ()=>{
    const setQuery = $3935c2aa64ec7a52$export$2d38afb37916ea3b();
    const searchData = $3935c2aa64ec7a52$export$b72f3303d4547637();
    const selectedWordCounts = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(searchData.wordCounts), [
        searchData.wordCounts
    ]);
    const toggleWordCount = (0, $g5BLJ.useCallback)((s)=>()=>{
            const update = (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(selectedWordCounts, s);
            setQuery({
                wordCounts: update.size ? update.join(",") : null
            });
        }, [
        setQuery,
        selectedWordCounts
    ]);
    const selectedBands = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(searchData.gradeBands), [
        searchData.gradeBands
    ]);
    const toggleBand = (0, $g5BLJ.useCallback)((value)=>()=>{
            const update = (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(selectedBands, value);
            setQuery({
                gradeBands: update.size ? update.join(",") : null
            });
        }, [
        selectedBands,
        setQuery
    ]);
    const selectedAdditionalFilters = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(searchData.additionalFilters), [
        searchData.additionalFilters
    ]);
    const toggleAdditionalFilter = (0, $g5BLJ.useCallback)((s)=>{
        const update = (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(selectedAdditionalFilters, s);
        setQuery({
            additionalFilters: update.size ? update.join(",") : null
        });
    }, [
        setQuery,
        selectedAdditionalFilters
    ]);
    const selectedOwnershipTypes = (0, $g5BLJ.useMemo)(()=>(0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(searchData.ownershipTypes), [
        searchData.ownershipTypes
    ]);
    const toggleOwnershipType = (0, $g5BLJ.useCallback)((s)=>()=>{
            const update = (0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(selectedOwnershipTypes, s);
            setQuery({
                ownershipTypes: update.size ? update.join(",") : null
            });
        }, [
        setQuery,
        selectedOwnershipTypes
    ]);
    return {
        selectedWordCounts: selectedWordCounts,
        toggleWordCount: toggleWordCount,
        selectedBands: selectedBands,
        toggleBand: toggleBand,
        selectedOwnershipTypes: selectedOwnershipTypes,
        toggleOwnershipType: toggleOwnershipType,
        additionalFilters: searchData.additionalFilters,
        toggleAdditionalFilter: toggleAdditionalFilter
    };
};
const $3935c2aa64ec7a52$export$f07514158026f5aa = ()=>{
    const playlists = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ContentLibraryData.playlists, []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    if (!query.has("playlistId")) return null;
    return playlists.find((playlist)=>playlist.id === query.get("playlistId"));
};
const $3935c2aa64ec7a52$export$beebad6512239b8a = ({ searchText: searchText , gradeBands: gradeBands , ownershipTypes: ownershipTypes , wordCounts: wordCounts , tagIds: tagIds , additionalFilters: additionalFilters  })=>{
    return searchText.length > 0 || gradeBands.size > 0 || ownershipTypes.size > 0 || wordCounts.size > 0 || tagIds.size > 0 || additionalFilters.size > 0;
};
const $3935c2aa64ec7a52$export$3d6ed0715468a113 = ({ children: children  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
        variant: "h3",
        children: children
    });
const $3935c2aa64ec7a52$export$2daf7b8111a8922 = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        justify: "center",
        width: "100%",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            kind: "boat"
        })
    });




const $5310d68946b3986f$export$41fc5037e67aae41 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ContentLibraryData", (0, $1cdada3b012c649b$export$49d5fc8cba920a0), ({ set: set , get: get , setField: setField , fetchJson: fetchJson  })=>{
    const search = (0, $eYBdv.debounce)((params)=>{
        set({
            loading: true
        });
        const { searchText: searchText , gradeBands: gradeBands , ownershipTypes: ownershipTypes , pageNumber: pageNumber , wordCounts: wordCounts , tagIds: tagIds , additionalFilters: additionalFilters  } = params;
        fetchJson("/api/readings/search", {
            method: "POST",
            data: {
                query: searchText,
                gradeLevelIds: (0, $1efad0e185f7a777$export$72e35e20ef873369)(gradeBands, get().gradeLevels),
                ownershipTypes: ownershipTypes,
                page: pageNumber,
                wordCounts: wordCounts.map((key)=>(0, $3935c2aa64ec7a52$export$e9acd43c1fb0fd1e).get(key)),
                tagIds: tagIds,
                additionalFilters: additionalFilters
            },
            onSuccess: (data)=>{
                set({
                    searchResults: data.results,
                    playlistResults: data.playlistResults,
                    totalResults: data.total,
                    playlists: data.playlists.push((0, $d66224a7b1518c5a$export$4efca973fe331688)(data.continueReadingMap.size)),
                    gradeLevels: data.gradeLevels,
                    submissionMap: data.submissionMap,
                    continueReadingMap: data.continueReadingMap,
                    loading: false,
                    initialSearch: false
                });
            }
        });
    }, 200);
    return {
        load: ()=>{
            set((s)=>({
                    ...(0, $1cdada3b012c649b$export$49d5fc8cba920a0),
                    gradeLevels: s.gradeLevels
                }));
            if (get().gradeLevels.isEmpty()) fetchJson(`/api/grade_levels`, {
                method: "GET",
                onSuccess: (data)=>{
                    set({
                        gradeLevels: data.gradeLevels,
                        gradeLevelsLoading: false
                    });
                }
            });
            else set({
                gradeLevelsLoading: false
            });
        },
        search: search,
        setField: setField,
        getAssignments: (result, onSuccess)=>{
            set({
                selectionModalOpen: true,
                assignmentsLoading: true,
                selectedSearchResult: result
            });
            fetchJson(`/api/readings/${result.reading.id}/assessments`, {
                method: "GET",
                onSuccess: (data)=>{
                    set({
                        assignmentsLoading: false,
                        assessmentResults: data.assessments,
                        userMap: data.userMap
                    });
                    onSuccess();
                }
            });
        },
        launchStudentLibraryReading: (id, history, query, pathname, existingAssessmentId)=>{
            const { submissionMap: submissionMap  } = get();
            const submissionId = submissionMap.get(id);
            if (existingAssessmentId) history.push(`/reading-studio${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)({
                backPath: `${pathname}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                assessmentId: existingAssessmentId
            })}`);
            else if (submissionId) history.push(`/submissions/${submissionId}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)({
                backPath: `${pathname}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
            })}`);
            else fetchJson(`/api/free_reads`, {
                method: "POST",
                data: {
                    reading_id: id
                },
                onSuccess: ({ success: success , assessment: assessment  })=>{
                    if (success) history.push(`/reading-studio${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)({
                        backPath: `${pathname}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                        assessmentId: assessment.id
                    })}`);
                }
            });
        }
    };
});



const $53fd91c4822a46a0$export$49d5fc8cba920a0 = {
    sending: false
};


const $c22c5ad5766b6eb1$export$a3d463dabb4f1e4e = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("MobileGateData", {}, ({ fetchJson: fetchJson , set: set  })=>({
        ...(0, $53fd91c4822a46a0$export$49d5fc8cba920a0),
        submit: (createToast)=>()=>{
                set({
                    sending: true
                });
                fetchJson(`/api/users/send_mobile_link_email`, {
                    method: "POST",
                    data: {
                        url: window.location.href
                    },
                    onSuccess: (data)=>{
                        set({
                            sending: false
                        });
                        if (data.success) createToast({
                            children: "Link sent!",
                            color: "success",
                            duration: 1000
                        });
                        else createToast({
                            children: "Link failed to send",
                            color: "danger",
                            duration: 1000
                        });
                    }
                });
            }
    }));





const $f4a5daf57574988f$export$49d5fc8cba920a0 = {
    opened: false,
    saving: false,
    currentPassword: "",
    newPassword: "",
    passwordConfirmation: "",
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};


const $2a905b6fb6a2321b$export$b1c1ba7bb015462b = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("ChangePasswordModalData", (0, $f4a5daf57574988f$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , fetchJson: fetchJson  })=>({
        openModal: ()=>set({
                opened: true
            }),
        closeModal: ()=>set((0, $f4a5daf57574988f$export$49d5fc8cba920a0)),
        changePassword: (createToast)=>{
            const { currentPassword: currentPassword , newPassword: newPassword , passwordConfirmation: passwordConfirmation  } = get();
            set({
                saving: true
            });
            fetchJson(`/api/users/update_teacher_password`, {
                method: "PATCH",
                data: {
                    currentPassword: currentPassword,
                    newPassword: newPassword,
                    passwordConfirmation: passwordConfirmation
                },
                onSuccess: (data)=>{
                    if (data.success) {
                        set((0, $f4a5daf57574988f$export$49d5fc8cba920a0));
                        createToast({
                            children: "Password updated!",
                            color: "success"
                        });
                    } else set({
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors),
                        saving: false
                    });
                }
            });
        },
        setField: setField
    }));






const $716f3a9b69b65271$export$49d5fc8cba920a0 = {
    customizingSelection: "skin",
    dirty: false,
    saving: false,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    localUser: null,
    purchasedItems: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    itemsToBuy: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    itemToBuy: null,
    previousUserState: null,
    purchasing: false,
    confirmModalOpen: false
};



const $584bd2b7d5e222bd$export$6c835b5b355c722c = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("AvatarBuilderData", (0, $716f3a9b69b65271$export$49d5fc8cba920a0), ({ setField: setField , set: set , setFull: setFull , get: get , getFull: getFull , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>{
            getFull().AppData.load({
                skipStateReset: true,
                onSuccess: (data)=>set({
                        localUser: data.currentUser,
                        dirty: false,
                        itemToBuy: null
                    })
            });
            fetchJson(`/api/store_items`, {
                onSuccess: ({ itemsToBuy: itemsToBuy , purchasedItems: purchasedItems  })=>set({
                        itemsToBuy: itemsToBuy,
                        purchasedItems: purchasedItems
                    })
            });
        },
        save: (createToast)=>{
            const { localUser: localUser  } = get();
            if (!localUser) return;
            set({
                saving: true
            });
            getFull().AppData.setUserFields((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                avatarSkin: localUser.avatarSkin,
                avatarMouth: localUser.avatarMouth,
                avatarEyes: localUser.avatarEyes,
                avatarHat: localUser.avatarHat
            }), createToast, false, ()=>set({
                    saving: false,
                    dirty: false
                }));
        },
        undo: ()=>{
            set({
                localUser: getFull().AppData.currentUser,
                dirty: false
            });
        },
        rollDice: ()=>{
            const { localUser: localUser , purchasedItems: purchasedItems  } = get();
            const skins = purchasedItems.filter((item)=>item.itemType === "skin").map((skin)=>skin.name);
            const eyes = purchasedItems.filter((item)=>item.itemType === "eyes").map((skin)=>skin.name);
            const mouths = purchasedItems.filter((item)=>item.itemType === "mouth").map((skin)=>skin.name);
            const hats = purchasedItems.filter((item)=>item.itemType === "hat").map((skin)=>skin.name);
            if (localUser) set({
                dirty: true,
                itemToBuy: null,
                localUser: {
                    ...localUser,
                    avatarSkin: (0, $d5a1fd3dea1a0ab6$export$7a5825874deea16a)(skins) || "blue",
                    avatarEyes: (0, $d5a1fd3dea1a0ab6$export$7a5825874deea16a)(eyes) || "regular",
                    avatarMouth: (0, $d5a1fd3dea1a0ab6$export$7a5825874deea16a)(mouths) || "smile",
                    avatarHat: (0, $d5a1fd3dea1a0ab6$export$7a5825874deea16a)(hats) || "nothing"
                }
            });
        },
        setAttribute: (key)=>(value)=>{
                const { localUser: localUser  } = get();
                if (!localUser) return;
                set({
                    dirty: true,
                    localUser: {
                        ...localUser,
                        [key]: value
                    }
                });
            },
        setItem: (item, fieldName)=>()=>{
                const { localUser: localUser , purchasedItems: purchasedItems , itemToBuy: itemToBuy , setAttribute: setAttribute  } = get();
                const purchased = purchasedItems.contains(item);
                if (purchased) set({
                    itemToBuy: null
                });
                else if (itemToBuy) set({
                    itemToBuy: item
                });
                else set({
                    itemToBuy: item,
                    previousUserState: localUser
                });
                setAttribute(fieldName)(item.name);
            },
        cancelPurchase: ()=>{
            const { previousUserState: previousUserState  } = get();
            set({
                localUser: previousUserState,
                itemToBuy: null,
                previousUserState: null
            });
        },
        purchaseItem: (createToast)=>{
            const { itemToBuy: itemToBuy , save: save  } = get();
            set({
                purchasing: true
            });
            if (!itemToBuy) return;
            fetchJson(`/api/transactions`, {
                method: "POST",
                data: {
                    itemId: itemToBuy.id
                },
                onSuccess: ({ success: success , errors: errors , currentUser: currentUser , transaction: transaction  })=>{
                    if (success) {
                        setFull((state)=>({
                                ...state,
                                AppData: {
                                    ...state.AppData,
                                    currentUser: currentUser
                                }
                            }));
                        save(createToast);
                        set((state)=>({
                                errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
                                itemToBuy: null,
                                previousUserState: null,
                                purchasing: false,
                                confirmModalOpen: false,
                                itemsToBuy: state.itemsToBuy.filter((item)=>item.id !== transaction.storeItemId),
                                purchasedItems: state.purchasedItems.push(itemToBuy)
                            }));
                        createToast({
                            children: "Purchase Successful!",
                            color: "success"
                        });
                    } else set({
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors)
                    });
                }
            });
        }
    }));




const $09f23b9fe3c0bc19$export$49d5fc8cba920a0 = {
    loading: true,
    page: 0,
    total: 0,
    avatars: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
};


const $244287a829cb2d43$export$ffbca0b4425411d4 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("AvatarGalleryData", (0, $09f23b9fe3c0bc19$export$49d5fc8cba920a0), ({ setField: setField , set: set , get: get , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>{
            set({
                ...(0, $09f23b9fe3c0bc19$export$49d5fc8cba920a0)
            });
            get().loadMore();
        },
        loadMore: ()=>{
            const { page: page , avatars: avatars  } = get();
            fetchJson(`/api/users/avatar_gallery`, {
                data: {
                    page: page
                },
                onSuccess: ({ page: page , total: total , avatars: newAvatars  })=>{
                    set({
                        loading: false,
                        page: page + 1,
                        total: total,
                        avatars: avatars.concat(newAvatars)
                    });
                }
            });
        }
    }));





const $9da70f12004a94cc$export$49d5fc8cba920a0 = {
    opened: false,
    loading: true,
    saving: false,
    assessmentId: "",
    assessment: null,
    upgradingFor: "",
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};




const $80ee4c7ae203b23b$export$70fb04bc05425133 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("UpgradeAssignmentModalData", (0, $9da70f12004a94cc$export$49d5fc8cba920a0), ({ set: set , setField: setField , get: get , getFull: getFull , fetchJson: fetchJson  })=>({
        ...(0, $9da70f12004a94cc$export$49d5fc8cba920a0),
        setField: setField,
        closeModal: ()=>set((0, $9da70f12004a94cc$export$49d5fc8cba920a0)),
        startAssignmentUpgrade: (assessmentId, upgradingFor)=>{
            set({
                ...(0, $9da70f12004a94cc$export$49d5fc8cba920a0),
                opened: true,
                upgradingFor: upgradingFor
            });
            fetchJson(`/api/assessments/${assessmentId}/edit`, {
                onSuccess: ({ assessment: assessment  })=>set({
                        assessment: assessment,
                        loading: false
                    })
            });
        },
        upgradeAssignment: (createToast, onSuccess)=>{
            const { assessment: assessment , closeModal: closeModal , upgradingFor: upgradingFor  } = get();
            if (!assessment) return;
            set({
                saving: true,
                errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
            });
            fetchJson(`/api/assessments/${assessment.id}/upgrade`, {
                method: "POST",
                onSuccess: ({ success: success , errors: errors , assessment: assessment  })=>{
                    if (success) {
                        createToast({
                            children: `${assessment.name} has been upgraded!`
                        });
                        closeModal();
                        onSuccess(assessment);
                        getFull().AppData.load({
                            skipStateReset: true
                        });
                        (0, $0d509ab7f782af11$export$9f9795024f215d86)({
                            assessment: assessment,
                            upgradedFor: upgradingFor
                        });
                    } else set({
                        saving: false,
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors)
                    });
                }
            });
        }
    }));





const $4d3162b9bcda1653$export$49d5fc8cba920a0 = {
    loading: true,
    playlists: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    editingPlaylist: null,
    deletingPlaylist: null,
    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)()
};





const $90f6156b7ffa1cff$export$14c7f685e922741f = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("PlaylistManagerData", (0, $4d3162b9bcda1653$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , fetchJson: fetchJson  })=>({
        setField: setField,
        load: ()=>{
            set((0, $4d3162b9bcda1653$export$49d5fc8cba920a0));
            fetchJson(`/api/playlists`, {
                onSuccess: (data)=>set({
                        ...data,
                        loading: false
                    })
            });
        },
        setEditingPlaylistField: (key)=>(value)=>{
                const playlist = get().editingPlaylist;
                if (!playlist) return;
                set({
                    editingPlaylist: {
                        ...playlist,
                        [key]: value
                    }
                });
            },
        startCreate: ()=>{
            set((state)=>({
                    errors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
                    editingPlaylist: {
                        ...(0, $d66224a7b1518c5a$export$1d1a8ee647677bd3)(),
                        ranking: (state.playlists.max((p)=>p.ranking)?.ranking ?? 0) + 1
                    }
                }));
        },
        savePlaylist: ()=>{
            const { editingPlaylist: editingPlaylist , playlists: playlists  } = get();
            if (!editingPlaylist) return;
            const method = editingPlaylist.id ? "PATCH" : "POST";
            const url = `/api/playlists/${editingPlaylist.id || ""}`;
            fetchJson(url, {
                method: method,
                data: {
                    playlist: editingPlaylist
                },
                onSuccess: ({ success: success , errors: errors , playlist: playlist  })=>{
                    if (success) set({
                        editingPlaylist: null,
                        playlists: playlists.filter((p)=>p.id !== playlist.id).push(playlist)
                    });
                    else set({
                        errors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors)
                    });
                }
            });
        },
        updatePlaylistRank: (playlist, ranking)=>{
            fetchJson(`/api/playlists/${playlist.id}`, {
                method: "PATCH",
                data: {
                    playlist: {
                        ...playlist,
                        ranking: ranking
                    }
                },
                onSuccess: ({ success: success , playlist: playlist  })=>{
                    if (success) set({
                        editingPlaylist: null,
                        playlists: get().playlists.filter((p)=>p.id !== playlist.id).push(playlist)
                    });
                }
            });
        },
        confirmDelete: ()=>{
            const { deletingPlaylist: deletingPlaylist , playlists: playlists  } = get();
            if (!deletingPlaylist) return;
            set({
                deletingPlaylist: null,
                playlists: playlists.filter((p)=>p.id !== deletingPlaylist.id)
            });
            fetchJson(`/api/playlists/${deletingPlaylist.id}`, {
                method: "PATCH",
                data: {
                    playlist: {
                        ...deletingPlaylist,
                        status: "deleted",
                        enabled: false
                    }
                }
            });
        }
    }));



const $1acb1d4a76f03eee$export$49d5fc8cba920a0 = {
    notificationKind: "hidden",
    localStatus: null,
    localLastSyncedAt: null
};


const $767d600767a52872$export$cc5772939b343524 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("PaperSyncData", (0, $1acb1d4a76f03eee$export$49d5fc8cba920a0), ({ set: set , get: get , getFull: getFull , setField: setField , fetchJson: fetchJson , refreshPaperAccessToken: refreshPaperAccessToken  })=>({
        setField: setField,
        sync: async (kind)=>{
            if (get().getIsSyncing()) return;
            set({
                notificationKind: "hidden",
                localStatus: "started"
            });
            await refreshPaperAccessToken();
            fetchJson(`/api/paper_auths/roster`, {
                method: "POST",
                data: {
                    kind: kind
                }
            });
        },
        closeBanner: ()=>{
            set({
                notificationKind: "hidden"
            });
        },
        getStatus () {
            return get().localStatus ?? getFull().AppData.currentUser?.paperRosterSyncStatus ?? null;
        },
        getIsSyncing () {
            return get().getStatus() === "started";
        },
        getLastSyncedAt () {
            return get().localLastSyncedAt ?? getFull().AppData.currentUser?.paperRosterSyncedAt ?? null;
        }
    }));






const $91ce446312f370b6$export$49d5fc8cba920a0 = {
    loading: false,
    currentUser: null,
    schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    schoolQuery: "",
    schoolResults: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    schoolDomains: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
    suggestedSchoolMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(),
    usedDomain: false,
    searching: false,
    waitingToSearch: false,
    manualSchoolErrors: (0, $8a14245e3a78cfb1$export$e9a1d00aaa71b08c)(),
    manualSchool: (0, $344b0bc9424ec409$export$8662384f20eca84d)(),
    saving: false,
    stateAbbreviation: undefined,
    districtMap: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
};




var $eYBdv = parcelRequire("eYBdv");

const $060eebe0fb38efd0$export$2a446f50fc1be1b6 = (0, $620ff1ffde93974c$export$d7aa30e208e4dff3)("SchoolSearchData", (0, $91ce446312f370b6$export$49d5fc8cba920a0), ({ get: get , set: set , setField: setField , fetchJson: fetchJson  })=>{
    const search = (0, $eYBdv.debounce)((query, stateAbbreviation)=>{
        if (query.length === 0) return;
        set({
            searching: true,
            waitingToSearch: false
        });
        fetchJson(`/api/schools/search`, {
            method: "POST",
            data: {
                query: query,
                stateAbbreviation: stateAbbreviation
            },
            onSuccess: (data)=>{
                set((state)=>({
                        schoolResults: data.schools,
                        districtMap: state.districtMap.merge(data.districtMap),
                        searching: false
                    }));
            }
        });
    }, 200);
    return {
        ...(0, $91ce446312f370b6$export$49d5fc8cba920a0),
        setField: setField,
        load: ()=>{
            set((0, $91ce446312f370b6$export$49d5fc8cba920a0));
            fetchJson(`/api/users/me`, {
                onSuccess: (data)=>{
                    set({
                        districtMap: data.districtMap,
                        schoolDomains: data.schoolDomains,
                        suggestedSchoolMap: data.suggestedSchoolMap
                    });
                }
            });
        },
        setSchool: (school, onSuccess)=>{
            set({
                schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                    school
                ])
            });
            onSuccess();
        },
        setSchoolQuery: (value)=>{
            set({
                schoolQuery: value,
                schoolResults: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                waitingToSearch: value !== ""
            });
            search(value, get().stateAbbreviation);
        },
        setStateAbbreviation: (stateAbbreviation)=>{
            set({
                stateAbbreviation: stateAbbreviation
            });
            search(get().schoolQuery, stateAbbreviation);
        },
        submitSchool: (history, query)=>{
            const { currentUser: currentUser , schools: schools  } = get();
            if (!currentUser || schools.size === 0) return;
            fetchJson(`/api/users/${currentUser.id}/update_schools`, {
                method: "PATCH",
                data: {
                    onboardingStatus: "completed",
                    schoolIds: schools.map((s)=>s.id)
                },
                onSuccess: ()=>{
                    history.push(`/t/onboarding/questions${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                }
            });
        },
        setManualSchoolField: (key)=>(value)=>{
                set((state)=>({
                        manualSchool: {
                            ...state.manualSchool,
                            [key]: value
                        }
                    }));
            },
        saveManualSchool: (onSuccess)=>{
            const { manualSchool: manualSchool  } = get();
            set({
                saving: true
            });
            fetchJson(`/api/schools`, {
                method: "POST",
                data: {
                    school: manualSchool
                },
                onSuccess: (data)=>{
                    if (data.success) {
                        set({
                            schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                data.school
                            ]),
                            manualSchool: data.school,
                            saving: false,
                            manualSchoolErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()
                        });
                        onSuccess();
                    } else set({
                        manualSchoolErrors: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors),
                        saving: false
                    });
                }
            });
        }
    };
});


const $cd6b4158b51f2e58$export$de5e90bd767c5d82 = (FetchData)=>{
    const createState = (setFull, getFull)=>{
        return {
            ForgotPasswordData: (0, $4c0241bac80236b6$export$ca5fa5af1dfc879e)({
                setFull: setFull,
                getFull: getFull
            }),
            LoginData: (0, $2edc2fe23f14ee94$export$9b2688cc9a867f81)({
                setFull: setFull,
                getFull: getFull
            }),
            AppData: (0, $f880e2ff7e39c6d4$export$bd07b18b9b0c3af1)({
                setFull: setFull,
                getFull: getFull
            }),
            ResetPasswordData: (0, $60cc79729b3515bc$export$c0d0fe2438d83e0c)({
                setFull: setFull,
                getFull: getFull
            }),
            ReadingStudioData: (0, $21c1499056429a76$export$bf9acc230921b0c0)({
                setFull: setFull,
                getFull: getFull
            }),
            SignUpClassCodeData: (0, $34b1ef82f2d30d45$export$29262a68c4fcfbb5)({
                setFull: setFull,
                getFull: getFull
            }),
            SignUpSchoolCodeData: (0, $0f5497214284f049$export$b38f3ef336c8d636)({
                setFull: setFull,
                getFull: getFull
            }),
            SignUpRegisterData: (0, $9c6025a5567e93a6$export$f5c6616af6b6a031)({
                setFull: setFull,
                getFull: getFull
            }),
            SignUpConfirmationSentData: (0, $49eee2604105da03$export$881b893aa2f6685)({
                setFull: setFull,
                getFull: getFull
            }),
            TeacherCourseListData: (0, $ecfd359a2bb9123c$export$ed0678645689dba6)({
                setFull: setFull,
                getFull: getFull
            }),
            CreateCourseData: (0, $46c8eaab361a18d8$export$e8993eda502ba080)({
                setFull: setFull,
                getFull: getFull
            }),
            ImportGoogleCourseData: (0, $230c2c1a78a99720$export$8baece80af8da911)({
                setFull: setFull,
                getFull: getFull
            }),
            ImportCleverCourseData: (0, $a502c63c8f7f9b55$export$5dbce76456314a8e)({
                setFull: setFull,
                getFull: getFull
            }),
            TeacherStudentListData: (0, $f76a4cfdb2b0781a$export$1efe6abc7f0c2a72)({
                setFull: setFull,
                getFull: getFull
            }),
            JoinCourseData: (0, $29c44711cd8f3c7d$export$2639b2ce4beaf7ac)({
                setFull: setFull,
                getFull: getFull
            }),
            StudentDashboardData: (0, $e08a10c7dd7f7d96$export$da82b2441ca8a7a3)({
                setFull: setFull,
                getFull: getFull
            }),
            TeacherAssignmentListData: (0, $1cf325e08d7f60b6$export$28c9377f65595c31)({
                setFull: setFull,
                getFull: getFull
            }),
            TeacherAssignmentOverviewData: (0, $6c952083be51382a$export$7b35e6ec51f6f8d8)({
                setFull: setFull,
                getFull: getFull
            }),
            SubmissionOverviewData: (0, $cfaafe48b695104a$export$d2a589e02c3dc021)({
                setFull: setFull,
                getFull: getFull
            }),
            AssignToData: (0, $38c89b47fddf8e30$export$9df7688c6b6ddf07)({
                setFull: setFull,
                getFull: getFull
            }),
            AssignmentBuilderData: (0, $07d94146543f9064$export$fe7beb72791a1387)({
                setFull: setFull,
                getFull: getFull
            }),
            ReadingBuilderData: (0, $f6504f597cf0744e$export$2ac9b3317e596ee9)({
                setFull: setFull,
                getFull: getFull
            }),
            UserSearchData: (0, $f55503dc0a13f803$export$26ccd03c178861a6)({
                setFull: setFull,
                getFull: getFull
            }),
            DictionaryData: (0, $d1a2ea48cb8084b5$export$da4235c10b3b66ef)({
                setFull: setFull,
                getFull: getFull
            }),
            TeacherOnboardingData: (0, $1f564b4eac6a5c8c$export$305db408278f668b)({
                setFull: setFull,
                getFull: getFull
            }),
            ProgressMonitoringData: (0, $e5496bf32b428d53$export$e985477e60703611)({
                setFull: setFull,
                getFull: getFull
            }),
            StudentProgressMonitoringData: (0, $a38013169270959c$export$aeac15d37b072318)({
                setFull: setFull,
                getFull: getFull
            }),
            PlanListData: (0, $280312fb5aa46101$export$96819a30c233ec3a)({
                setFull: setFull,
                getFull: getFull
            }),
            TaskOverviewData: (0, $e7adb81014cf150f$export$4ee661ef11c2c07b)({
                setFull: setFull,
                getFull: getFull
            }),
            UpdateAssignmentStatusModalData: (0, $a1c01af30dd2368f$export$5c933a982a4a896b)({
                setFull: setFull,
                getFull: getFull
            }),
            ShareModalData: (0, $39d47d3074b85f2b$export$9036313b5e595c3f)({
                setFull: setFull,
                getFull: getFull
            }),
            DuplicateModalData: (0, $4b3c83274eabf86f$export$89571c7e2b3ab301)({
                setFull: setFull,
                getFull: getFull
            }),
            FetchData: FetchData,
            ContentLibraryData: (0, $5310d68946b3986f$export$41fc5037e67aae41)({
                setFull: setFull,
                getFull: getFull
            }),
            ChangePasswordModalData: (0, $2a905b6fb6a2321b$export$b1c1ba7bb015462b)({
                setFull: setFull,
                getFull: getFull
            }),
            MobileGateData: (0, $c22c5ad5766b6eb1$export$a3d463dabb4f1e4e)({
                setFull: setFull,
                getFull: getFull
            }),
            AvatarBuilderData: (0, $584bd2b7d5e222bd$export$6c835b5b355c722c)({
                setFull: setFull,
                getFull: getFull
            }),
            AvatarGalleryData: (0, $244287a829cb2d43$export$ffbca0b4425411d4)({
                setFull: setFull,
                getFull: getFull
            }),
            UpgradeAssignmentModalData: (0, $80ee4c7ae203b23b$export$70fb04bc05425133)({
                setFull: setFull,
                getFull: getFull
            }),
            SchoolSearchData: (0, $060eebe0fb38efd0$export$2a446f50fc1be1b6)({
                setFull: setFull,
                getFull: getFull
            }),
            PlaylistManagerData: (0, $90f6156b7ffa1cff$export$14c7f685e922741f)({
                setFull: setFull,
                getFull: getFull
            }),
            PaperSyncData: (0, $767d600767a52872$export$cc5772939b343524)({
                setFull: setFull,
                getFull: getFull
            })
        };
    };
    return createState;
};
const { useStore: $cd6b4158b51f2e58$export$6ccbb43953eebf8 , Provider: $cd6b4158b51f2e58$export$2881499e37b75b9a  } = (0, $f11c2b6d8f5b8d56$export$c8d125448df6fe8e)();






var $g5BLJ = parcelRequire("g5BLJ");










var $g5BLJ = parcelRequire("g5BLJ");






const $74edf34b4b7a68bf$var$getEmptyStateKind = (assessmentStatusFilterParam)=>{
    if (assessmentStatusFilterParam === "turned_in") return "emptySubmittedDashboard";
    return "emptyAssignedDashboard";
};
const $74edf34b4b7a68bf$var$assignmentLink = (submission, assessment, hasFeedback)=>{
    if (submission && hasFeedback) return `/submissions/${submission.id}?openComments=true`;
    else if (submission?.status === "finished") return `/submissions/${submission.id}`;
    return `/reading-studio${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
        assessmentId: assessment.id,
        showInstructions: "true"
    })}`;
};
const $74edf34b4b7a68bf$export$5c030a7951d3fc5e = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const assessmentStatusFilterParam = query.get("assessmentStatusFilter") || "new";
    const sortByParam = query.get("sortBy") || "desc";
    const { currentUser: currentUser , submissionMap: submissionMap , taskSubmissions: taskSubmissions , load: load , loading: loading , stats: stats , courseMap: courseMap , assessmentMap: assessmentMap , assessmentToCourseMap: assessmentToCourseMap , openAssignmentCardSet: openAssignmentCardSet , toggleAssignmentCardOpen: toggleAssignmentCardOpen , commentMap: commentMap , readingNameMap: readingNameMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            submissionMap: state.StudentDashboardData.submissionMap,
            taskSubmissions: state.StudentDashboardData.taskSubmissions,
            load: state.StudentDashboardData.load,
            loading: state.StudentDashboardData.loading,
            stats: state.StudentDashboardData.stats,
            courseMap: state.StudentDashboardData.courseMap,
            assessmentMap: state.StudentDashboardData.assessmentMap,
            assessmentToCourseMap: state.StudentDashboardData.assessmentToCourseMap,
            openAssignmentCardSet: state.StudentDashboardData.openAssignmentCardSet,
            toggleAssignmentCardOpen: state.StudentDashboardData.toggleAssignmentCardOpen,
            commentMap: state.StudentDashboardData.commentMap,
            readingNameMap: state.StudentDashboardData.readingNameMap,
            currentUser: state.AppData.currentUser
        }), []);
    const updateAssessmentStatusFilter = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            assessmentStatusFilter: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const updateSortBy = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            sortBy: value
        })}`), [
        history,
        pathname,
        query
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const sortedFilteredAssessments = (0, $d5a1fd3dea1a0ab6$export$27a1cb209e3caa11)(sortByParam === "desc", assessmentMap.toList().map((a)=>{
        const submission = submissionMap.get(a.id);
        const comments = commentMap.get(submission?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
        const viewedComments = comments.filter((c)=>c.viewed);
        const hasFeedback = viewedComments.size !== comments.size;
        return {
            assessment: a,
            submission: submission,
            comments: comments,
            hasFeedback: hasFeedback
        };
    }).filter(({ submission: submission , hasFeedback: hasFeedback  })=>{
        const statusToWordToggle = submission?.status === "finished" && !hasFeedback ? "turned_in" : "new";
        return statusToWordToggle === assessmentStatusFilterParam;
    }).sortBy(({ assessment: { createdAt: createdAt , isSample: isSample  } , hasFeedback: hasFeedback  })=>{
        return [
            !isSample,
            hasFeedback,
            Date.parse(createdAt)
        ];
    }));
    const getMetrics = (assessment, completedTaskCount, totalTaskCount, submission)=>{
        let metrics = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)();
        if (submission?.status !== "finished") return undefined;
        if (assessment.independentOnly) metrics = metrics.push({
            label: "WPM",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wpm, submission.wcpm || 0)
        });
        else metrics = metrics.push({
            label: "WCPM",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, submission.wcpm || 0)
        });
        metrics = metrics.push({
            label: "Words Read",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words, submission.totalWords || 0)
        }, {
            label: "Time Read",
            value: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, submission.timeRead)
        });
        if (totalTaskCount > 0) metrics = metrics.push({
            label: "Tasks",
            value: `${completedTaskCount}/${totalTaskCount}`
        });
        return metrics;
    };
    const emptyStateKind = $74edf34b4b7a68bf$var$getEmptyStateKind(assessmentStatusFilterParam);
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        height: "100%",
        direction: "column",
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
        minWidth: 0,
        overflowY: "auto",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]}`,
                minWidth: 0,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    padding: `${showMobile ? (0, $8259eb090983b778$export$ea413736286a3bf1)[5] : (0, $8259eb090983b778$export$ea413736286a3bf1)[6]} 0 0`,
                    direction: "column",
                    align: "stretch",
                    minWidth: 0,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        justify: showMobile ? "center" : "space-between",
                        align: "center",
                        wrap: "wrap",
                        minWidth: 0,
                        direction: showMobile ? "column" : "row",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: showMobile ? "center" : "end",
                                direction: showMobile ? "column" : "row",
                                children: [
                                    currentUser && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                content: "Click here to edit your avatar!",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                                                    to: "/s/avatar",
                                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b22773065c4c76be$export$7334e79c2ba625e7), {
                                                        user: currentUser,
                                                        kind: "dashboard",
                                                        testTag: "dashboard-avatar"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 3
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h1",
                                        color: "white",
                                        lineHeightOverride: "140%",
                                        testTag: "user-name",
                                        children: [
                                            currentUser?.displayName,
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9e0eec0a21547834$export$a3afbf2185482701), {
                                                user: currentUser,
                                                isCurrent: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                justify: "end",
                                margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c92f83b3ac011911$export$567332ab922d2ec6), {
                                    id: "assignmentStatus",
                                    value: assessmentStatusFilterParam,
                                    onChange: updateAssessmentStatusFilter,
                                    options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                        {
                                            label: "New",
                                            value: "new"
                                        },
                                        {
                                            label: "Turned In",
                                            value: "turned_in"
                                        }
                                    ]),
                                    showMobile: showMobile
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$408f6e7a7113feed), {
                width: "100%",
                height: "auto",
                direction: "column",
                align: "center",
                padding: showMobile ? (0, $8259eb090983b778$export$ea413736286a3bf1)[3] : (0, $8259eb090983b778$export$ea413736286a3bf1)[6],
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    maxWidth: "900px",
                    width: showMobile ? "auto" : "100%",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eb878214d715ad44$export$70a4f6c59796db88), {
                        stats: (0, $3e76d4bc3268f884$export$b2ef177cbdfa8dca)(stats)
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                children: sortedFilteredAssessments.isEmpty() ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    justify: "center",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
                            kind: emptyStateKind,
                            displayType: "minimal"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 8
                        })
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "start",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    display: "inline",
                                    color: "gray6",
                                    children: "Sort By:"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                                    id: "sortBySelect",
                                    displayType: "flat",
                                    name: "assignmentSort",
                                    value: sortByParam,
                                    onChange: updateSortBy,
                                    options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                        {
                                            label: "Newest",
                                            value: "desc"
                                        },
                                        {
                                            label: "Oldest",
                                            value: "asc"
                                        }
                                    ])
                                })
                            ]
                        }),
                        !showMobile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6
                        }),
                        sortedFilteredAssessments.map(({ assessment: assessment , submission: submission , hasFeedback: hasFeedback , comments: comments  })=>{
                            const taskSubmissionDetailsMap = taskSubmissions.find((taskSubmission)=>taskSubmission.submissionId === submission?.id)?.taskSubmissionDetailsMap;
                            const reaction = comments.filter((c)=>c.reaction !== "undecided").last()?.reaction;
                            const totalTaskCount = assessment.taskOrder.size;
                            const completedTaskCount = taskSubmissionDetailsMap ? taskSubmissionDetailsMap.filter((0, $2f14aa3b16c7856e$export$762b2163c3ce6757)).size : 0;
                            return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b80951e1033e6596$export$5d2fdc840dd37092), {
                                assessment: assessment,
                                courseIds: assessmentToCourseMap.get(assessment.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()),
                                courseMap: courseMap,
                                status: (0, $82a43f48d9c20dff$export$6ee8c29b7cccc937)(submission, hasFeedback),
                                reaction: reaction ?? "undecided",
                                open: openAssignmentCardSet.has(assessment.id),
                                onToggleCardOpen: ()=>toggleAssignmentCardOpen(assessment.id),
                                to: $74edf34b4b7a68bf$var$assignmentLink(submission, assessment, hasFeedback),
                                metrics: getMetrics(assessment, completedTaskCount, totalTaskCount, submission),
                                readingName: readingNameMap.get(assessment.id)
                            }, assessment.id);
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 22
                        })
                    ]
                })
            }),
            currentUser?.paperId && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eb30321ced29024b$export$a06f1c675e846f6f), {
                accountType: "student"
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");








const $d9b5fc1617cb258c$export$a5da2e560921fb7f = ()=>{
    const { opened: opened , saving: saving , currentPassword: currentPassword , newPassword: newPassword , passwordConfirmation: passwordConfirmation , errors: errors , closeModal: closeModal , setField: setField , changePassword: changePassword  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ChangePasswordModalData, []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        header: "Change Password",
        opened: opened,
        close: closeModal,
        disableFadeClose: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: closeModal,
                    inheritBgColor: true,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    type: "submit",
                    loading: saving,
                    onClick: ()=>changePassword(createToast),
                    children: "Save"
                })
            ]
        }),
        testTag: "change-password-modal",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "password",
                name: "password",
                label: "Current Password",
                value: currentPassword,
                onChange: setField("currentPassword"),
                errors: errors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                size: 1
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "password",
                name: "newPassword",
                label: "New Password",
                value: newPassword,
                onChange: setField("newPassword"),
                errors: errors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "password",
                name: "passwordConfirmation",
                label: "Confirm Password",
                value: passwordConfirmation,
                onChange: setField("passwordConfirmation"),
                errors: errors
            })
        ]
    });
};





const $f183dd4b89f089d3$var$UserProfileContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "UserProfile__UserProfileContainer",
    componentId: "sc-lwrsef-0"
})([
    "max-width:550px;"
]);
const $f183dd4b89f089d3$var$Card = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "UserProfile__Card",
    componentId: "sc-lwrsef-1"
})([
    "padding:",
    " ",
    ";margin-bottom:",
    ";background:",
    ";border-radius:",
    ";max-width:550px;"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[8], (0, $8259eb090983b778$export$ea413736286a3bf1)[6], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3]);
const $f183dd4b89f089d3$export$b7b58f2e100445f7 = ({ ContentElement: ContentElement  })=>{
    const { load: load , loading: loading , currentUser: currentUser , currentPlan: currentPlan , setUserFields: setUserFields , setUserField: setUserField , schools: schools , setField: setField , dirty: dirty , profileImageStoredFile: profileImageStoredFile , uploadProfileImage: uploadProfileImage , profileImageFile: profileImageFile , uploadingProfileImage: uploadingProfileImage  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: s  })=>({
            load: s.load,
            loading: s.loading,
            currentUser: s.currentUser,
            currentPlan: s.currentPlan,
            setUserFields: s.setUserFields,
            setUserField: s.setUserField,
            schools: s.schools,
            setField: s.setField,
            dirty: s.dirty,
            profileImageStoredFile: s.profileImageStoredFile,
            uploadProfileImage: s.uploadProfileImage,
            profileImageFile: s.profileImageFile,
            uploadingProfileImage: s.uploadingProfileImage
        }), []);
    const openChangePasswordModal = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ChangePasswordModalData.openModal, []);
    const [submitLoading, setSubmitLoading] = (0, $g5BLJ.useState)(false);
    const [micSettings, setMicSettings] = (0, $g5BLJ.useState)(false);
    // Local name variable that can be edited
    const [localUser, setLocalUser] = (0, $g5BLJ.useState)(currentUser);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    // Set local name when current user is updated
    (0, $g5BLJ.useEffect)(()=>{
        load({
            onSuccess: (data)=>{
                setLocalUser(data.currentUser);
            }
        });
    }, [
        load
    ]);
    // save user data function
    const save = ()=>{
        setSubmitLoading(true);
        const updates = {
            name: localUser?.name ?? "",
            displayName: localUser?.name ?? "",
            profileImageFileId: profileImageStoredFile?.id ?? null
        };
        setUserFields((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(updates), createToast);
        setField("dirty")(false);
        setSubmitLoading(false);
    };
    const deleteProfilePicture = ()=>{
        setSubmitLoading(true);
        const updates = {
            profileImageFileId: null
        };
        setUserFields((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(updates), createToast);
        setField("dirty")(false);
        setField("profileImageStoredFile")(null);
        setField("profileImageFile")(null);
        setSubmitLoading(false);
    };
    const disabledEmailText = (currentUser)=>{
        if (currentUser.accountType === "student") return "Contact your teacher to change your email";
        return currentUser.isSso ? "Please use your LMS to control this information" : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                "Need to change your email?",
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    onClick: (0, $86ce6205c10768ba$export$68306590b07bdc01),
                    sizeOverride: 16,
                    children: "Contact customer support"
                })
            ]
        });
    };
    const disabledNameText = (currentUser)=>{
        return currentUser.accountType === "student" ? "Contact your teacher to change your name" : "Please use your LMS to control this information";
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(ContentElement, {
                headerText: "My Profile",
                headerActionButton: !currentUser?.paperSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: save,
                    disabled: !dirty,
                    loading: submitLoading,
                    children: "Save Changes"
                }),
                loading: loading,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f183dd4b89f089d3$var$UserProfileContainer, {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                        onSubmit: save,
                        dirty: dirty,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                direction: "column",
                                children: [
                                    (0, $75cd274e63beb59b$export$21d5f40a3f7d2451)(currentUser?.accountType ?? "student") && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        align: "start",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$b04be29aa201d4f5), {
                                                $isTextInput: true,
                                                children: "Profile Picture"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                                    name: "profileImageFile",
                                                    type: "file",
                                                    kind: "lightImagePreview",
                                                    width: "auto",
                                                    value: profileImageFile ? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                                        profileImageFile
                                                    ]) : (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                                                    onChange: (files)=>uploadProfileImage(files, createToast),
                                                    accept: "image",
                                                    testTag: "profile-image",
                                                    flex: true,
                                                    uploadedFile: profileImageStoredFile,
                                                    iconColor: "black",
                                                    uploading: uploadingProfileImage
                                                })
                                            }),
                                            profileImageStoredFile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                                onClick: deleteProfilePicture,
                                                color: "primaryBlue",
                                                paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                                children: "Remove Image"
                                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        size: 3
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        size: "half"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 5
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                        disabled: !currentUser?.isSso,
                                        content: disabledNameText(currentUser || (0, $75cd274e63beb59b$export$a6bcaa27097f2a04)),
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                            type: "text",
                                            name: "Name",
                                            label: "Name",
                                            testTag: "name-input",
                                            value: localUser?.name || localUser?.displayName || "Loading...",
                                            disabled: loading || !localUser?.name || currentUser?.isSso || currentUser?.paperSyncedAt !== null,
                                            onChange: (s)=>{
                                                if (s !== currentUser?.name) setField("dirty")(true);
                                                if (localUser) setLocalUser({
                                                    ...localUser,
                                                    name: s
                                                });
                                            }
                                        })
                                    }),
                                    !currentUser?.paperSyncedAt && currentUser?.email && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                size: 6
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                content: disabledEmailText(currentUser || (0, $75cd274e63beb59b$export$a6bcaa27097f2a04)),
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                                    name: currentUser.accountType === "teacher" ? "Faculty Email" : "Email",
                                                    label: currentUser.accountType === "teacher" ? "Faculty Email" : "Email",
                                                    type: "text",
                                                    value: currentUser.email,
                                                    disabled: true,
                                                    onChange: ()=>{
                                                        return;
                                                    }
                                                })
                                            }),
                                            (0, $75cd274e63beb59b$export$21d5f40a3f7d2451)(currentUser?.accountType) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        size: 4
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                        justify: "end",
                                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                                            displayType: "link",
                                                            onClick: openChangePasswordModal,
                                                            children: "Change Password"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 6
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                        name: "Role",
                                        label: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            align: "center",
                                            children: [
                                                "Role",
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    horizontal: true
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                    iconColor: "gray6",
                                                    content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                                children: "Wrong role?"
                                                            }),
                                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                                horizontal: true
                                                            }),
                                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                                                newTab: true,
                                                                onClick: (0, $86ce6205c10768ba$export$68306590b07bdc01),
                                                                children: "Contact support."
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        type: "text",
                                        value: (0, $e6116bf527c207db$export$9a00dee1beb8f576)(currentUser?.accountType || ""),
                                        disabled: true,
                                        onChange: ()=>{
                                            return;
                                        }
                                    }),
                                    !currentUser?.paperSyncedAt && currentUser?.accountType !== "student" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                size: 6
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                                name: "planName",
                                                label: "Current Plan",
                                                type: "text",
                                                value: currentPlan?.name || "Basic",
                                                disabled: true,
                                                onChange: ()=>{
                                                    return;
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                width: "100%",
                                                justify: "end",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                                    displayType: "link",
                                                    to: "/t/plans",
                                                    children: currentPlan.isBasicPlan ? "View Plans and Pricing" : "Manage Your Subscription"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 6
                                    }),
                                    !currentUser?.paperSyncedAt && currentUser?.accountType === "teacher" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                                name: "school",
                                                label: (0, $e6116bf527c207db$export$cefb40c9962541b5)("School", schools.size, {
                                                    noNumber: true
                                                }),
                                                type: "text",
                                                value: schools.map((s)=>s.name).join(", ") || "Not Set",
                                                disabled: true,
                                                onChange: ()=>{
                                                    return;
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                width: "100%",
                                                justify: "end",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                                    displayType: "link",
                                                    to: `/t/onboarding${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                                                        redirectPath: "/t/profile"
                                                    })}`,
                                                    children: "Change your School"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                size: 6
                                            })
                                        ]
                                    }) : null
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f183dd4b89f089d3$var$Card, {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        direction: "row",
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h3",
                                                weightOverride: "bold",
                                                children: "Text Size"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                content: "Adjust your default text size for readings"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                        label: "",
                                        type: "textSize",
                                        name: "textSize",
                                        value: currentUser?.textSize ?? 16,
                                        onChange: setUserField("textSize", createToast, false)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f183dd4b89f089d3$var$Card, {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h3",
                                        weightOverride: "bold",
                                        children: "Microphone Settings"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        displayType: "outline",
                                        onClick: ()=>setMicSettings(true),
                                        children: "Change Settings"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 22
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d9b5fc1617cb258c$export$a5da2e560921fb7f), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0770e766331d4fe1$export$b39a1b7d06ee214f), {
                opened: micSettings,
                close: ()=>setMicSettings(false)
            })
        ]
    });
};










const $dba6c5da69120483$export$6988a55f9afa8b34 = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "flex-grow:1;max-width:100vw;min-height:0;overflow-y:auto;"
]);




var $g5BLJ = parcelRequire("g5BLJ");











var $g5BLJ = parcelRequire("g5BLJ");


const $801ead61ffc78bb9$var$LearnMoreModal = ()=>{
    const { availableAssignments: availableAssignments , setField: setField , ultimateAssessmentsOverviewOpened: ultimateAssessmentsOverviewOpened  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            setField: s.AppData.setField,
            availableAssignments: s.AppData.currentUser?.ultimateAssessmentsAvailable ?? 0,
            ultimateAssessmentsOverviewOpened: s.AppData.ultimateAssessmentsOverviewOpened
        }), []);
    const close = (0, $g5BLJ.useCallback)(()=>setField("ultimateAssessmentsOverviewOpened")(false), [
        setField
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: ultimateAssessmentsOverviewOpened,
        header: availableAssignments > 0 ? `You have ${availableAssignments} free Ultimate Assignments` : "Want more Ultimate Assignments?",
        middleHeader: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                    icon: "ultimateAssignmentCentered",
                    size: "1.35em"
                })
            ]
        }),
        close: close,
        footer: availableAssignments ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            width: "100%",
            onClick: close,
            children: "Got it!"
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            width: "100%",
            onClick: close,
            href: "https://www.readlee.com/contact",
            newTab: true,
            children: "Contact Us!"
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
            children: availableAssignments === 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Upgrade to Readlee Ultimate to have unlimited access to the best Readlee features"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ded3b2c5af96cca$export$9ca18bb3e989d9c3), {})
                ]
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Use your free Ultimate Assignments to try out our favorite features before making any commitments."
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ded3b2c5af96cca$export$9ca18bb3e989d9c3), {})
                ]
            })
        })
    });
};
const $801ead61ffc78bb9$export$c2cd34bf87e26c0f = ()=>{
    const { ultimateAssessmentsAvailable: ultimateAssessmentsAvailable , currentPlan: currentPlan , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            setField: s.AppData.setField,
            currentPlan: s.AppData.currentPlan,
            ultimateAssessmentsAvailable: s.AppData.currentUser?.ultimateAssessmentsAvailable ?? 0
        }), []);
    if (!currentPlan.isUsageCapsEnabled) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                displayType: "iconOnly",
                color: "white",
                onClick: ()=>setField("ultimateAssessmentsOverviewOpened")(true),
                testTag: "ultimateAssessmentsIndicator",
                paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "end",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h3",
                            lineHeightOverride: "100%",
                            color: "primaryBlue",
                            testTag: "ultimate-assessments-available",
                            children: ultimateAssessmentsAvailable
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "ultimateAssignment",
                            size: "1.5em"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($801ead61ffc78bb9$var$LearnMoreModal, {})
        ]
    });
};





const $9ffde62705db8bc2$export$c1fc55d657ab8c44 = ()=>{
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser, []);
    if (!currentUser?.accountType) return null;
    if (currentUser?.accountType === "student") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        justify: "space-around",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3ce8826ee790ff14$export$9096f1709a33668c), {
                displayType: currentUser?.paperSyncedAt ? "button" : "outline"
            }),
            !currentUser?.paperSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $50073ce729d6c9f2$export$5b4a6ac7cb1aeab8), {})
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        justify: "space-around",
        align: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $801ead61ffc78bb9$export$c2cd34bf87e26c0f), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                color: "primaryBlue",
                to: "/t/reading-builder/content",
                height: "40px",
                children: "New Assignment"
            })
        ]
    });
};
const $9ffde62705db8bc2$export$329cf2036fdf6f5a = ({ path: path , label: label , upperCase: upperCase , textColor: textColor , ...baseButtonProps })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
        nav: true,
        to: path,
        color: textColor || "white",
        hoverColor: "primaryBlue",
        activeColor: "primaryBlue",
        linkTextStyle: "linkNavBar",
        ...baseButtonProps,
        children: upperCase ? label.toUpperCase() : label
    });
};
const $9ffde62705db8bc2$var$links = (currentUser)=>(0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
        {
            showTeacher: true,
            showStudent: true,
            dropdownLink: false,
            mobileOnly: false,
            desktopOnly: false,
            exact: currentUser.accountType === "student",
            path: `${currentUser.accountType === "student" ? "/s/assignments" : "/t/assignments"}`,
            label: "Assignments",
            studentRank: currentUser.flags?.isStudentHomepageLibraryEnabled ? 2 : 1,
            teacherRank: 1
        },
        {
            showTeacher: true,
            showStudent: false,
            dropdownLink: false,
            mobileOnly: false,
            desktopOnly: false,
            path: "/t/classes",
            label: "Classes",
            teacherRank: 2
        },
        {
            showTeacher: true,
            showStudent: false,
            dropdownLink: false,
            mobileOnly: false,
            desktopOnly: false,
            path: "/t/progress-monitoring",
            label: "Progress Monitoring",
            teacherRank: 3
        },
        {
            showTeacher: true,
            showStudent: currentUser.flags?.isStudentLibraryEnabled ?? false,
            dropdownLink: false,
            mobileOnly: false,
            desktopOnly: false,
            path: `${currentUser.accountType === "student" ? "/s" : "/t"}/library`,
            label: "Library",
            studentRank: currentUser.flags?.isStudentHomepageLibraryEnabled ? 1 : 2,
            teacherRank: 4
        },
        {
            showTeacher: true,
            showStudent: true,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            path: `${currentUser.accountType === "student" ? "/s/" : "/t/"}profile`,
            label: "My Profile",
            studentRank: 11,
            teacherRank: 10
        },
        {
            showTeacher: false,
            showStudent: true,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            path: "/s/avatar",
            label: "Edit Avatar",
            studentRank: 10
        },
        {
            showTeacher: true,
            showStudent: false,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            onClick: (0, $86ce6205c10768ba$export$68306590b07bdc01),
            label: "Contact Support",
            newTab: true,
            teacherRank: 11
        },
        {
            showTeacher: true,
            showStudent: false,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            newTab: true,
            href: "https://readleesupport.zendesk.com/hc/en-us/",
            label: "Help Center",
            teacherRank: 12
        },
        {
            showTeacher: true,
            showStudent: true,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            readleeOnly: true,
            path: "/logout",
            label: "Log out",
            studentRank: 12,
            teacherRank: 13
        },
        {
            showTeacher: true,
            showStudent: true,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            paperOnly: true,
            path: "/back-to-paper",
            label: "Back To Paper",
            studentRank: 12,
            teacherRank: 13
        },
        {
            showTeacher: false,
            showStudent: false,
            showAdmin: true,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            href: `${(0, $0fe4eaef81db718a$export$625c2ae8ba020e36)}/api/admin`,
            label: "Admin Dashboard",
            teacherRank: 20
        },
        {
            showTeacher: false,
            showStudent: false,
            showAdmin: true,
            showModerator: true,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            path: `/m/user-search`,
            label: "Admin User Search",
            teacherRank: 21
        },
        {
            showTeacher: false,
            showStudent: false,
            showAdmin: true,
            showModerator: true,
            dropdownLink: true,
            mobileOnly: false,
            desktopOnly: false,
            path: `/m/playlists`,
            label: "Playlist Manager",
            teacherRank: 22
        }
    ]);
const $9ffde62705db8bc2$var$filterByRole = (currentUser, l, isPaperUser)=>{
    if (l.paperOnly && !isPaperUser) return false;
    if (l.readleeOnly && isPaperUser) return false;
    if (currentUser.accountType === "student") return l.showStudent;
    if (currentUser.accountType === "teacher") return l.showTeacher;
    if (currentUser.accountType === "moderator") return Boolean(l.showTeacher || l.showModerator);
    if (currentUser.accountType === "admin") return Boolean(l.showAdmin || l.showModerator || l.showTeacher);
    return false;
};
const $9ffde62705db8bc2$export$a901108f07ae0578 = (currentUser, isPaperUser)=>$9ffde62705db8bc2$var$links(currentUser).filter((l)=>$9ffde62705db8bc2$var$filterByRole(currentUser, l, isPaperUser) && !l.dropdownLink && !l.mobileOnly && !l.desktopOnly).sortBy((l)=>currentUser.accountType === "student" ? l.studentRank : l.teacherRank);
const $9ffde62705db8bc2$export$bc9079d15a8f761c = (currentUser, isPaperUser)=>$9ffde62705db8bc2$var$links(currentUser).filter((l)=>l.dropdownLink && $9ffde62705db8bc2$var$filterByRole(currentUser, l, isPaperUser)).sortBy((l)=>currentUser.accountType === "student" ? l.studentRank : l.teacherRank);
const $9ffde62705db8bc2$export$2932a8ec276de5d4 = (currentUser, isPaperUser)=>$9ffde62705db8bc2$var$links(currentUser).filter((l)=>$9ffde62705db8bc2$var$filterByRole(currentUser, l, isPaperUser) && !l.desktopOnly).sortBy((l)=>currentUser.accountType === "student" ? l.studentRank : l.teacherRank);



const $74b195a20ec26994$var$TopBarStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TopBar__TopBarStyles",
    componentId: "sc-1k9h94s-0"
})([
    "border-bottom:1px solid ",
    ";padding:",
    ";align-items:center;display:flex;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[2]);
const $74b195a20ec26994$var$MenuOverlay = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TopBar__MenuOverlay",
    componentId: "sc-1k9h94s-1"
})([
    "display:flex;align-items:start;justify-content:center;background:",
    ";position:fixed;overflow-y:auto;z-index:",
    ";top:53px;bottom:0;left:0;right:0;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex, (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised);
const $74b195a20ec26994$export$c4e96258f3b6511 = ({ navLinksOverride: navLinksOverride , primaryAction: primaryAction , secondaryAction: secondaryAction , mobileAction: mobileAction , showProfile: showProfile = true , showPrimaryAction: showPrimaryAction = true , alwaysShowSecondaryAction: alwaysShowSecondaryAction = false , logoDisabled: logoDisabled = false  })=>{
    const isMobileWebviewOpened = window.localStorage.getItem("mobileWebviewOpened") === "true";
    const [opened, setOpened] = (0, $g5BLJ.useState)(false);
    const showMobileLayout = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "desktopSmall"
    });
    const { loading: loading , currentUser: currentUser , currentPlan: currentPlan  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            loading: state.AppData.loading,
            currentUser: state.AppData.currentUser ?? {
                ...(0, $75cd274e63beb59b$export$be7c6faf5b1d35b2)
            },
            currentPlan: state.AppData.currentPlan
        }), []);
    const mobileLinks = navLinksOverride || (0, $9ffde62705db8bc2$export$2932a8ec276de5d4)(currentUser, Boolean(currentUser.paperSyncedAt));
    const showMobileNav = !isMobileWebviewOpened && (mobileLinks.size > 0 || secondaryAction && !alwaysShowSecondaryAction || showPrimaryAction);
    const readleePoints = !loading && currentUser && currentUser.accountType === "student" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                to: "/s/avatar",
                id: "reading-points",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        testTag: "point-balance",
                        children: currentUser.pointBalance
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 1
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "token",
                        size: "1.75em",
                        color: "white"
                    })
                ]
            })
        ]
    }) : null;
    const logoType = (0, $0f9282d054fbc03e$export$d57579b7226369a8)(currentUser, currentPlan);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($74b195a20ec26994$var$TopBarStyles, {
        children: [
            !isMobileWebviewOpened && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    showMobileNav && showMobileLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: ()=>setOpened(!opened),
                        displayType: "iconOnly",
                        icon: opened ? "close" : "menu",
                        iconSize: opened ? "0.5em" : "3em",
                        color: "white",
                        width: "24px",
                        height: "24px",
                        testTag: "mobile-nav-toggle",
                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7eb33c08429d75e4$export$ce671d21b66bb548), {
                        size: logoType === "paper-reading" ? "medium" : "small",
                        logoType: logoType,
                        disabled: logoDisabled
                    }),
                    currentUser.paperSyncedAt && !showMobileLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                displayType: "outline",
                                color: "paperBlue",
                                icon: "paperLogo",
                                iconStrokeWidth: 0,
                                to: "/back-to-paper",
                                height: "40px",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    "Back To Paper"
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                                color: (0, $24b764039c44d1ec$export$8f45430ccf837300).gray4.hex,
                                vertical: true,
                                size: 0.5,
                                noMargin: true,
                                endMargin: (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 8
                    })
                ]
            }),
            isMobileWebviewOpened && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            (!showMobileLayout || isMobileWebviewOpened) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: (navLinksOverride ?? (0, $9ffde62705db8bc2$export$a901108f07ae0578)(currentUser, Boolean(currentUser.paperSyncedAt))).map((props, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9ffde62705db8bc2$export$329cf2036fdf6f5a), {
                                textColor: "gray6",
                                ...props
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: isMobileWebviewOpened ? 4 : 12
                            })
                        ]
                    }, i))
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
            !showMobileLayout && !isMobileWebviewOpened && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    showPrimaryAction ? primaryAction || /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9ffde62705db8bc2$export$c1fc55d657ab8c44), {}) : null,
                    secondaryAction ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2,
                                horizontal: true
                            }),
                            secondaryAction
                        ]
                    }) : null,
                    readleePoints,
                    showProfile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                                testTag: "profile-settings-button",
                                color: "white",
                                displayType: "noStyles",
                                rightAligned: true,
                                noButtonPadding: true,
                                options: (0, $9ffde62705db8bc2$export$bc9079d15a8f761c)(currentUser, Boolean(currentUser.paperSyncedAt)).map((l)=>({
                                        ...l,
                                        children: l.label,
                                        to: l.path,
                                        href: l.href
                                    })).toArray(),
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                                        name: currentUser.name || "",
                                        backgroundColor: currentUser.avatarColor || (0, $24b764039c44d1ec$export$803ec3cef06b0273)[0],
                                        disabledTooltip: true,
                                        user: currentUser,
                                        showAvatar: currentUser.accountType === "student",
                                        imageUrl: currentUser.profileImageFile?.url
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: "arrowDown"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    })
                ]
            }),
            showMobileLayout && alwaysShowSecondaryAction && secondaryAction ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: secondaryAction
            }) : null,
            showMobileLayout && !isMobileWebviewOpened && readleePoints && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    readleePoints,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4,
                        horizontal: true
                    })
                ]
            }),
            (showMobileLayout && mobileAction || isMobileWebviewOpened) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: mobileAction
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $121c3b2afc84f041$export$361769c4f906e73b), {
                children: opened && showMobileNav && showMobileLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($74b195a20ec26994$var$MenuOverlay, {
                    $opened: opened,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        height: "100%",
                        width: "100%",
                        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[5]}`,
                        testTag: "mobile-overlay",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 5
                            }),
                            mobileLinks.map((props, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9ffde62705db8bc2$export$329cf2036fdf6f5a), {
                                            upperCase: true,
                                            onClick: ()=>setOpened(false),
                                            ...props
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 6
                                        })
                                    ]
                                }, i)),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                            showPrimaryAction ? primaryAction || /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9ffde62705db8bc2$export$c1fc55d657ab8c44), {}) : null,
                            secondaryAction ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2,
                                        horizontal: true
                                    }),
                                    secondaryAction
                                ]
                            }) : null
                        ]
                    })
                })
            })
        ]
    });
};








var $g5BLJ = parcelRequire("g5BLJ");







var $g5BLJ = parcelRequire("g5BLJ");


const $9a82166a8c02eb5b$export$ef25a3afb477934e = ()=>{
    const { confirmModalOpen: confirmModalOpen , itemToBuy: itemToBuy , currentUser: currentUser , purchaseItem: purchaseItem , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            confirmModalOpen: state.AvatarBuilderData.confirmModalOpen,
            itemToBuy: state.AvatarBuilderData.itemToBuy,
            purchaseItem: state.AvatarBuilderData.purchaseItem,
            setField: state.AvatarBuilderData.setField,
            currentUser: state.AppData.currentUser
        }), []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const close = (0, $g5BLJ.useCallback)(()=>setField("confirmModalOpen")(false), [
        setField
    ]);
    if (!confirmModalOpen || !currentUser || !itemToBuy) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        testTag: "confirm-purchase",
        openType: "state",
        opened: confirmModalOpen,
        header: "Buy Item",
        close: close,
        onSubmit: ()=>purchaseItem(createToast),
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: close,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    type: "submit",
                    children: "Buy"
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "center",
            align: "center",
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h5",
                    textAlign: "center",
                    children: "Are you sure you want to buy this item?"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h5",
                            textAlign: "center",
                            children: [
                                "Cost: ",
                                itemToBuy.price
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "token",
                            size: "1.25em",
                            color: "white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 6
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h5",
                    weightOverride: "bold",
                    textAlign: "center",
                    children: "Your Points"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h5",
                            textAlign: "center",
                            children: currentUser?.pointBalance
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "token",
                            size: "1.25em",
                            color: "white"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "forwardArrow",
                            size: "2em",
                            color: "primaryBlue"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h5",
                            textAlign: "center",
                            children: currentUser.pointBalance - itemToBuy.price
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                            icon: "token",
                            size: "1.25em",
                            color: "white"
                        })
                    ]
                })
            ]
        })
    });
};



const $b046a4d40ca74a4f$var$ElementSelector = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AvatarBuilder__ElementSelector",
    componentId: "sc-1utsy4i-0"
})([
    "position:relative;display:flex;justify-content:start;align-items:end;height:",
    ";width:",
    ";margin:0 ",
    " ",
    " ",
    ";border:1px solid ",
    ";",
    ";&:hover,&:active{border:3px solid ",
    ";}"
], ({ $showMobile: $showMobile  })=>$showMobile ? "75px" : "100px", ({ $showMobile: $showMobile  })=>$showMobile ? "75px" : "100px", (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex, ({ $active: $active = false  })=>(0, $18ffa0398cff6303$export$cb290e6c0fd3cb2e)("border", `3px solid ${(0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex}`, $active), (0, $24b764039c44d1ec$export$8f45430ccf837300).black.hex);
const $b046a4d40ca74a4f$var$SaveButtonContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AvatarBuilder__SaveButtonContainer",
    componentId: "sc-1utsy4i-1"
})([
    "display:flex;",
    ";"
], ({ $showMobile: $showMobile  })=>$showMobile && `
      background-color: ${(0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex};
      width: 100%;
      position: absolute;
      bottom: 0;
  `);
const $b046a4d40ca74a4f$var$PriceTag = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AvatarBuilder__PriceTag",
    componentId: "sc-1utsy4i-2"
})([
    "display:flex;align-items:center;background:white;color:black;position:absolute;border-right:1px solid black;border-top:1px solid black;border-radius:0 ",
    " 0 0;padding:",
    " ",
    ";"
], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $8259eb090983b778$export$ea413736286a3bf1).none, (0, $8259eb090983b778$export$ea413736286a3bf1)[1]);
const $b046a4d40ca74a4f$var$NewTag = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AvatarBuilder__NewTag",
    componentId: "sc-1utsy4i-3"
})([
    "display:flex;align-items:center;background:",
    ";color:white;position:absolute;border-bottom:1px solid black;border-left:1px solid black;border-radius:0 0 0 ",
    ";padding:",
    " ",
    ";top:0;right:0;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).danger.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $8259eb090983b778$export$ea413736286a3bf1).none, (0, $8259eb090983b778$export$ea413736286a3bf1)[1]);
const $b046a4d40ca74a4f$export$6550daf4ecbb4e45 = ({ ContentElement: ContentElement  })=>{
    const { customizingSelection: customizingSelection , dirty: dirty , saving: saving , errors: errors , localUser: localUser , purchasedItems: purchasedItems , itemsToBuy: itemsToBuy , itemToBuy: itemToBuy , setField: setField , load: load , save: save , setItem: setItem , undo: undo , rollDice: rollDice , cancelPurchase: cancelPurchase , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            customizingSelection: state.AvatarBuilderData.customizingSelection,
            dirty: state.AvatarBuilderData.dirty,
            saving: state.AvatarBuilderData.saving,
            errors: state.AvatarBuilderData.errors,
            localUser: state.AvatarBuilderData.localUser,
            purchasedItems: state.AvatarBuilderData.purchasedItems,
            itemsToBuy: state.AvatarBuilderData.itemsToBuy,
            itemToBuy: state.AvatarBuilderData.itemToBuy,
            setField: state.AvatarBuilderData.setField,
            load: state.AvatarBuilderData.load,
            save: state.AvatarBuilderData.save,
            setItem: state.AvatarBuilderData.setItem,
            undo: state.AvatarBuilderData.undo,
            rollDice: state.AvatarBuilderData.rollDice,
            cancelPurchase: state.AvatarBuilderData.cancelPurchase,
            currentUser: state.AppData.currentUser
        }), []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    if (!localUser || !currentUser) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    const notEnoughPoints = itemToBuy ? currentUser.pointBalance < itemToBuy.price : false;
    const fieldName = (0, $75cd274e63beb59b$export$55afbd7775430ed)(customizingSelection);
    const filteredPurchasedItems = purchasedItems.filter((i)=>i.itemType === customizingSelection);
    const filteredItemsToBuy = itemsToBuy.filter((item)=>item.itemType === customizingSelection).sortBy((item)=>item.price);
    const FloatingBuyButton = ()=>itemToBuy && !showMobile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 20
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h3",
                                    children: [
                                        "Cost: ",
                                        itemToBuy.price
                                    ]
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "token",
                                    size: "1.75em",
                                    color: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                            disabled: !notEnoughPoints,
                            content: "Keep reading to earn more points!",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                disabled: notEnoughPoints,
                                loading: saving,
                                onClick: ()=>setField("confirmModalOpen")(true),
                                width: "100%",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h3",
                                    children: "Buy"
                                })
                            })
                        })
                    ]
                })
            ]
        }) : null;
    const StoreOption = ({ item: item , purchased: purchased  })=>{
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
            onClick: setItem(item, fieldName),
            testTag: item.name,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($b046a4d40ca74a4f$var$ElementSelector, {
                $active: localUser[fieldName] === item.name,
                $showMobile: showMobile,
                children: [
                    !purchased && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($b046a4d40ca74a4f$var$PriceTag, {
                                children: [
                                    item.price,
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: "half"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: "token",
                                        size: "1.25em",
                                        color: "white"
                                    })
                                ]
                            }),
                            item.isNew && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b046a4d40ca74a4f$var$NewTag, {
                                "data-test-tag": `${item.id}-is-new`,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h7",
                                    padding: (0, $8259eb090983b778$export$ea413736286a3bf1).half,
                                    children: "New!"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                        src: (0, $7b0ba46fad863bdb$export$735ee1799fd02602)(item.itemType, item.name)
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "start",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        paddingOverride: showMobile ? `${(0, $8259eb090983b778$export$ea413736286a3bf1)[5]} 0 0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[5]}` : `${(0, $8259eb090983b778$export$ea413736286a3bf1)[5]} 0 0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[10]}`,
                        color: "black",
                        to: "/s/",
                        icon: "backArrow",
                        children: "Back"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)(ContentElement, {
                headerText: "Avatar",
                loading: false,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        align: showMobile ? "center" : "start",
                        overflowY: "auto",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b22773065c4c76be$export$7334e79c2ba625e7), {
                                        user: localUser,
                                        kind: "builder",
                                        testTag: "builder-avatar"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(FloatingBuyButton, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                onClick: rollDice,
                                icon: "dice",
                                iconFill: true,
                                children: "Roll the dice!"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "start",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                        content: "Buy the selected item or click cancel to continue",
                                        disabled: Boolean(!itemToBuy),
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            direction: "column",
                                            children: (0, $7b0ba46fad863bdb$export$642e3bed1b9f118a).map(({ kind: kind , buttonName: buttonName  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                                            displayType: customizingSelection === kind ? "button" : "outline",
                                                            onClick: ()=>setField("customizingSelection")(kind),
                                                            testTag: `customize-${kind}`,
                                                            disabled: Boolean(itemToBuy),
                                                            children: buttonName
                                                        }),
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                            size: 2
                                                        })
                                                    ]
                                                }, kind))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        wrap: "wrap",
                                        children: [
                                            filteredPurchasedItems.map((item)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(StoreOption, {
                                                    item: item,
                                                    purchased: true
                                                }, item.id)),
                                            filteredItemsToBuy.map((item)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(StoreOption, {
                                                    item: item,
                                                    purchased: false
                                                }, item.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 20
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                                errorKey: "transaction",
                                errors: errors
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                                errorKey: "user",
                                errors: errors
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($b046a4d40ca74a4f$var$SaveButtonContainer, {
                                $showMobile: showMobile,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        disabled: !dirty,
                                        loading: saving,
                                        displayType: "outline",
                                        onClick: itemToBuy ? cancelPurchase : undo,
                                        borderRadiusOverride: showMobile && "none",
                                        paddingOverride: showMobile ? (0, $8259eb090983b778$export$ea413736286a3bf1)[5] : "",
                                        width: showMobile ? "40%" : "auto",
                                        children: itemToBuy ? "Cancel" : "Undo Changes"
                                    }),
                                    !showMobile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 4
                                    }),
                                    itemToBuy ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                        disabled: !notEnoughPoints,
                                        content: "Keep reading to earn more points!",
                                        containerWidthOverride: "100%",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                            disabled: notEnoughPoints,
                                            loading: saving,
                                            onClick: ()=>setField("confirmModalOpen")(true),
                                            borderRadiusOverride: showMobile && "none",
                                            paddingOverride: showMobile ? (0, $8259eb090983b778$export$ea413736286a3bf1)[5] : "",
                                            width: showMobile ? "100%" : "auto",
                                            height: "100%",
                                            children: [
                                                "Buy for ",
                                                itemToBuy.price,
                                                " ",
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    horizontal: true
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: "token",
                                                    size: "1.25em"
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        disabled: !dirty,
                                        loading: saving,
                                        onClick: ()=>save(createToast),
                                        borderRadiusOverride: showMobile && "none",
                                        paddingOverride: showMobile ? (0, $8259eb090983b778$export$ea413736286a3bf1)[5] : "",
                                        width: showMobile ? "60%" : "auto",
                                        children: "Save Changes"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 4
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9a82166a8c02eb5b$export$ef25a3afb477934e), {})
                ]
            })
        ]
    });
};







const $81498f85426d0c12$export$900d6118d6e87fe5 = ({ children: children , centeredMaxWidth: centeredMaxWidth = "1150px" , ...flexProps })=>{
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        align: "center",
        direction: "column",
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
        padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[showMobile ? 3 : 8]}`,
        ...flexProps,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            maxWidth: centeredMaxWidth,
            width: "100%",
            height: "100%",
            minWidth: flexProps.minWidth,
            children: children
        })
    });
};








const $983442d63718d5de$export$2ab6bab701a9bc81 = ({ headerText: headerText , headerActionButton: headerActionButton , children: children , loading: loading , backPath: backPath  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[7]} 0`,
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                children: [
                    backPath && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                        minWidth: 0,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                to: backPath,
                                icon: "backArrow",
                                color: "gray4",
                                children: "Back"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "space-between",
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h2",
                                    color: "white",
                                    children: headerText
                                }),
                                headerActionButton
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                height: "100%",
                children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                    flex: true,
                    kind: "boat"
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        }),
                        children
                    ]
                })
            })
        ]
    });
};




var $g5BLJ = parcelRequire("g5BLJ");





var $g5BLJ = parcelRequire("g5BLJ");












const $c0639dd78ac8be4e$var$TagsContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TeacherReadingTile__TagsContainer",
    componentId: "sc-1ygrmzb-0"
})([
    "display:flex;flex-flow:row wrap;align-items:end;overflow:hidden;height:100%;"
]);
const $c0639dd78ac8be4e$var$TileTemplate = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TeacherReadingTile__TileTemplate",
    componentId: "sc-1ygrmzb-1"
})([
    "height:250px;width:100%;border:1px solid ",
    ";border-radius:",
    ";padding:",
    ";display:flex;flex-direction:column;cursor:pointer;background-color:",
    ";",
    ""
], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[5], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $disabled: $disabled  })=>$disabled ? "cursor: not-allowed;" : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "&:hover{background-color:",
        ";}"
    ], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.active));
const $c0639dd78ac8be4e$var$TileLabel = ({ icon: icon , label: label , iconFill: iconFill = false , reversed: reversed = false  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        direction: reversed ? "row-reverse" : "row",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                size: "20px",
                color: "gray6",
                icon: icon,
                flexShrink: 0,
                fill: iconFill
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h6",
                color: "gray6",
                ellipsis: true,
                title: label,
                children: label
            })
        ]
    });
};
const $c0639dd78ac8be4e$export$a8679887b15c69a3 = ({ result: result , gradeLevels: gradeLevels , reversed: reversed = false  })=>{
    const isBasicPlan = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentPlan?.isBasicPlan ?? true, []);
    const paperSyncedAt = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser?.paperSyncedAt, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        minWidth: 0,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c0639dd78ac8be4e$var$TileLabel, {
                icon: "typedText",
                iconFill: true,
                label: result.reading?.totalWords !== 0 ? (0, $3e76d4bc3268f884$export$f5dd818bff069720)(result.reading?.totalWords) : "--",
                reversed: reversed
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c0639dd78ac8be4e$var$TileLabel, {
                icon: "folder",
                label: (0, $9858807ed795496b$export$903a24f29188015)(result.ownershipType, isBasicPlan, Boolean(paperSyncedAt)),
                reversed: reversed
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c0639dd78ac8be4e$var$TileLabel, {
                icon: "graduationCap",
                label: (0, $1efad0e185f7a777$export$4465baac62bc8a48)(result.reading.gradeLevelId, result.reading.autoGradeLevelId, gradeLevels),
                reversed: reversed
            })
        ]
    });
};
const $c0639dd78ac8be4e$export$f804e4b6aa0076f3 = ({ id: id , result: result , testTag: testTag  })=>{
    const { gradeLevels: gradeLevels , loading: loading , getAssignments: getAssignments , hasContentLibrary: hasContentLibrary , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            gradeLevels: s.ContentLibraryData.gradeLevels,
            loading: s.ContentLibraryData.loading,
            getAssignments: s.ContentLibraryData.getAssignments,
            setField: s.ContentLibraryData.setField,
            hasContentLibrary: s.AppData.currentUser?.flags.isReadleeLibraryContentEnabled
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
        enabled: !hasContentLibrary && result.ownershipType === "library",
        content: "Unlock Unlimited Readlee Content",
        linkLocation: "plans",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            id: id,
            displayType: "noStyles",
            onClick: ()=>getAssignments(result, ()=>setField("loading")(false)),
            testTag: testTag,
            disabled: !hasContentLibrary && result.ownershipType === "library",
            width: "100%",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c0639dd78ac8be4e$var$TileTemplate, {
                $disabled: !hasContentLibrary && result.ownershipType === "library",
                "data-test-tag": `reading-${result.reading.id}`,
                children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                    flex: true
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$2e6fda2350c5bcdc), {
                                    src: result.imageStoredFile?.thumbnailUrl ?? undefined,
                                    testTag: "reading-studio-layout-top-bar-image",
                                    size: "small",
                                    title: result.reading.name
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c0639dd78ac8be4e$export$a8679887b15c69a3, {
                                    result: result,
                                    gradeLevels: gradeLevels
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 5
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h3",
                                    title: result.reading.name,
                                    ellipsis: true,
                                    children: result.reading.name
                                }),
                                result.author && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    color: "gray6",
                                    title: result.author.name,
                                    ellipsis: true,
                                    children: result.author.name.toUpperCase()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($c0639dd78ac8be4e$var$TagsContainer, {
                            children: [
                                result.tags.slice(0, 2).map((tag, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                                color: "gray7",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                    variant: "h6",
                                                    lineHeightOverride: "120%",
                                                    title: tag.name,
                                                    overflowY: "hidden",
                                                    whiteSpace: "nowrap",
                                                    ellipsis: true,
                                                    maxWidth: "80px",
                                                    children: tag.name
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                                        ]
                                    }, i)),
                                result.tags.size > 2 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                    content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        wrap: "wrap",
                                        justify: "center",
                                        children: result.tags.slice(2).map((tag, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                direction: "column",
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                                        color: "gray7",
                                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                            variant: "h6",
                                                            lineHeightOverride: "120%",
                                                            title: tag.name,
                                                            whiteSpace: "nowrap",
                                                            children: tag.name
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                                                ]
                                            }, i))
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                            color: "gray7",
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h6",
                                                lineHeightOverride: "120%",
                                                whiteSpace: "nowrap",
                                                children: [
                                                    "+ ",
                                                    result.tags.slice(2).size
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};





const $06712caf59d22777$export$18fc517eef81d627 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { selectionModalOpen: selectionModalOpen , assignmentsLoading: assignmentsLoading , selectedSearchResult: selectedSearchResult , gradeLevels: gradeLevels , assessmentResults: assessmentResults , userMap: userMap , setField: setField , accountType: accountType  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ContentLibraryData: ContentLibraryData , AppData: AppData  })=>({
            selectionModalOpen: ContentLibraryData.selectionModalOpen,
            assignmentsLoading: ContentLibraryData.assignmentsLoading,
            selectedSearchResult: ContentLibraryData.selectedSearchResult,
            gradeLevels: ContentLibraryData.gradeLevels,
            assessmentResults: ContentLibraryData.assessmentResults,
            userMap: ContentLibraryData.userMap,
            setField: ContentLibraryData.setField,
            accountType: AppData.currentUser?.accountType || "student"
        }), []);
    const closeModal = ()=>setField("selectionModalOpen")(false);
    const columns = (0, $g5BLJ.useMemo)(()=>[
            {
                id: "name",
                name: "Title",
                render: ({ name: name  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h6",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 8
                            })
                        ]
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ name: name  })=>name
            },
            {
                id: "total_words",
                name: "Word Count",
                render: ({ totalWords: totalWords  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: totalWords
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ totalWords: totalWords  })=>totalWords
            },
            {
                id: "tasks",
                name: "Tasks",
                render: ({ taskOrder: taskOrder  })=>{
                    const readingTaskCount = taskOrder.count((task)=>task.type === "ReadingTask");
                    const comprehensionTaskCount = taskOrder.count((task)=>task.type === "ComprehensionTask");
                    const modelTaskCount = taskOrder.count((task)=>task.type === "ModelTask");
                    const vocabTaskCount = taskOrder.count((task)=>task.type === "VocabTask");
                    const TooltipContent = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            readingTaskCount > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: (0, $e6116bf527c207db$export$cefb40c9962541b5)("Reading Task", readingTaskCount)
                            }),
                            comprehensionTaskCount > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: (0, $e6116bf527c207db$export$cefb40c9962541b5)("Comprehension Task", comprehensionTaskCount)
                            }),
                            modelTaskCount > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: (0, $e6116bf527c207db$export$cefb40c9962541b5)("Model Reading Task", modelTaskCount)
                            }),
                            vocabTaskCount > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: (0, $e6116bf527c207db$export$cefb40c9962541b5)("Vocab Task", vocabTaskCount)
                            })
                        ]
                    });
                    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: TooltipContent,
                        display: "flex",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h6",
                            children: taskOrder.size
                        })
                    });
                },
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ taskOrder: taskOrder  })=>taskOrder.size
            },
            {
                id: "creator",
                name: "Creator",
                render: ({ id: id  })=>{
                    const creator = userMap.get(id);
                    return creator && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                        testTag: "creator-tag",
                        primaryText: (0, $75cd274e63beb59b$export$61b6a526e2f145be)(creator),
                        avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                            backgroundColor: creator.avatarColor || (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex,
                            name: creator.displayName
                        }, creator.displayName)
                    });
                },
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ id: id  })=>(0, $75cd274e63beb59b$export$61b6a526e2f145be)(userMap.get(id) || (0, $75cd274e63beb59b$export$a6bcaa27097f2a04))
            }
        ], [
        userMap
    ]);
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const previewPath = selectedSearchResult ? `/t/reading-builder/metadata${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
        backPath: `/t/library${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
        readingId: selectedSearchResult.reading.id,
        viewMode: "preview"
    }))}` : "";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: selectionModalOpen,
        header: "Select an Assignment",
        close: closeModal,
        hasFooter: false,
        children: selectedSearchResult && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: showMobile ? "column" : "row",
                    align: "start",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$1cd1efc78cb52ca5), {
                                    src: selectedSearchResult.imageStoredFile?.thumbnailUrl ?? undefined,
                                    size: "medium",
                                    title: selectedSearchResult.reading.name
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h3",
                                            title: selectedSearchResult.reading.name,
                                            ellipsis: true,
                                            children: selectedSearchResult.reading.name
                                        }),
                                        selectedSearchResult.author && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h6",
                                            color: "gray6",
                                            title: selectedSearchResult.author.name,
                                            ellipsis: true,
                                            children: selectedSearchResult.author.name.toUpperCase()
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h5",
                                            color: "gray6",
                                            title: selectedSearchResult.tags.map((tag)=>tag.name).join(", "),
                                            ellipsis: true,
                                            children: selectedSearchResult.tags.map((tag)=>tag.name).join(", ")
                                        })
                                    ]
                                })
                            ]
                        }),
                        showMobile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 8
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c0639dd78ac8be4e$export$a8679887b15c69a3), {
                            result: selectedSearchResult,
                            gradeLevels: gradeLevels,
                            reversed: !showMobile
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 8
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1)[3],
                    to: previewPath,
                    children: "Preview Reading"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                (0, $75cd274e63beb59b$export$a71c09bab744fd37)(accountType) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            width: "100%",
                            displayType: "outline",
                            to: `/t/reading-builder/metadata?readingId=${selectedSearchResult.reading.id}`,
                            children: "Edit Reading (Moderator)"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $305adc5b3dd45e98$export$405b1ba3701f58c6), {
                    color: "gray5",
                    children: "OR"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h4",
                    weightOverride: "bold",
                    textAlign: "center",
                    children: "Select Pre-Built Assignment"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                assignmentsLoading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 8
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                            flex: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 8
                        })
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                    children: assessmentResults.isEmpty() ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                textAlign: "center",
                                children: [
                                    "No pre-built assignments available.",
                                    " ",
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        to: previewPath,
                                        children: "Create a new assignment"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 4
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                        columns: columns,
                        rows: assessmentResults,
                        getRowId: (assessment)=>assessment.id,
                        queryParam: "sortBy",
                        rowClickable: true,
                        onRowClick: ({ id: id  })=>{
                            history.push(`/t/public-preview?assessmentId=${id}`);
                        },
                        noPadding: true,
                        emptyStateContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    textAlign: "center",
                                    children: [
                                        "No pre-built assignments available.",
                                        " ",
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                            to: previewPath,
                                            children: "Create a new assignment"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 4
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};




var $g5BLJ = parcelRequire("g5BLJ");









const $a0c3f554753e0b09$var$FilterContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Filters__FilterContainer",
    componentId: "sc-jsjuer-0"
})([
    "overflow-y:auto;height:100%;",
    ""
], ({ $isMobile: $isMobile  })=>$isMobile ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        ""
    ]) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "padding-bottom:150px;"
    ]));
const $a0c3f554753e0b09$export$92a576f896a9bf72 = ()=>{
    const { selectedWordCounts: selectedWordCounts , toggleWordCount: toggleWordCount , selectedBands: selectedBands , toggleBand: toggleBand , selectedOwnershipTypes: selectedOwnershipTypes , toggleOwnershipType: toggleOwnershipType , additionalFilters: additionalFilters , toggleAdditionalFilter: toggleAdditionalFilter  } = (0, $3935c2aa64ec7a52$export$b10469f2a2292df6)();
    const { isBasicPlan: isBasicPlan , paperSyncedAt: paperSyncedAt , paperGradeLevel: paperGradeLevel , initialSearch: initialSearch , accountType: accountType  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: a , ContentLibraryData: s  })=>({
            isBasicPlan: a.currentPlan?.isBasicPlan ?? true,
            paperSyncedAt: a.currentUser?.paperSyncedAt,
            paperGradeLevel: a.currentUser?.paperGradeLevel,
            accountType: a.currentUser?.accountType,
            initialSearch: s.initialSearch
        }), []);
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isStudent = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/s/library"));
    const isMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThan: "tabletSmall"
    });
    const setQuery = (0, $3935c2aa64ec7a52$export$2d38afb37916ea3b)();
    (0, $g5BLJ.useEffect)(()=>{
        if (initialSearch && paperGradeLevel && accountType === "student" && !selectedBands.size) {
            const levelAsString = paperGradeLevel.level.toString();
            if (levelAsString in (0, $1efad0e185f7a777$export$54948edc12631795)) setQuery({
                gradeBands: (0, $1efad0e185f7a777$export$54948edc12631795)[levelAsString]
            });
        }
    }, [
        accountType,
        initialSearch,
        paperGradeLevel,
        selectedBands.size,
        setQuery,
        toggleBand
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h3",
                children: "Content Library"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 5
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($a0c3f554753e0b09$var$FilterContainer, {
                $isMobile: isMobile,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6306ab50056d7219$export$a766cd26d0d69044), {
                        type: "v2",
                        label: "Grade",
                        defaultOpen: isStudent,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)((0, $1efad0e185f7a777$export$fffa6fe4f5a324be)).keySeq().map((value)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                            name: value,
                                            value: selectedBands.has(value),
                                            onChange: toggleBand(value),
                                            label: value,
                                            textColor: "black"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 4
                                        })
                                    ]
                                }, value))
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/t/library",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6306ab50056d7219$export$a766cd26d0d69044), {
                                type: "v2",
                                label: "Content Sources",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    children: (0, $9858807ed795496b$export$2a5014b41ca47a55).map((type)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                                    name: type,
                                                    value: selectedOwnershipTypes.has(type),
                                                    onChange: toggleOwnershipType(type),
                                                    label: (0, $9858807ed795496b$export$903a24f29188015)(type, isBasicPlan, Boolean(paperSyncedAt)),
                                                    textColor: "black"
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    size: 4
                                                })
                                            ]
                                        }, type))
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6306ab50056d7219$export$a766cd26d0d69044), {
                                type: "v2",
                                label: "Word Count",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    children: (0, $3935c2aa64ec7a52$export$b3465c55a23f9775).map((range)=>{
                                        const value = (0, $3935c2aa64ec7a52$export$b356a74f1d7cab6e)(range);
                                        const label = (0, $3935c2aa64ec7a52$export$ad126554effc3578)(range);
                                        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                                    name: label,
                                                    value: selectedWordCounts.has(value.toString()),
                                                    onChange: toggleWordCount(value.toString()),
                                                    label: label,
                                                    textColor: "black"
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    size: 4
                                                })
                                            ]
                                        }, value);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 8
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6306ab50056d7219$export$a766cd26d0d69044), {
                                type: "v2",
                                label: "Additional Filters",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                            name: "specialEducation",
                                            value: additionalFilters.contains("specialEducation"),
                                            onChange: ()=>toggleAdditionalFilter("specialEducation"),
                                            label: "Special Education",
                                            testTag: "specialEducation",
                                            textColor: "black"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 4
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                            name: "ell",
                                            value: additionalFilters.contains("ell"),
                                            onChange: ()=>toggleAdditionalFilter("ell"),
                                            label: "English Language Learner",
                                            testTag: "ell",
                                            textColor: "black"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



















var $g5BLJ = parcelRequire("g5BLJ");


const $038071ca248e98e1$var$READING_TILE_HEIGHT = "260px";
const $038071ca248e98e1$var$READING_TILE_WIDTH = "208px";
const $038071ca248e98e1$var$sharedStyles = (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
    "height:",
    ";width:",
    ";border-radius:",
    ";"
], $038071ca248e98e1$var$READING_TILE_HEIGHT, $038071ca248e98e1$var$READING_TILE_WIDTH, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2]);
const $038071ca248e98e1$var$TileContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentReadingTile__TileContainer",
    componentId: "sc-1iuvtg9-0"
})([
    "",
    " position:relative;"
], $038071ca248e98e1$var$sharedStyles);
const $038071ca248e98e1$var$ImageContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentReadingTile__ImageContainer",
    componentId: "sc-1iuvtg9-1"
})([
    "position:absolute;"
]);
const $038071ca248e98e1$var$Description = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentReadingTile__Description",
    componentId: "sc-1iuvtg9-2"
})([
    "",
    " opacity:0;transition:opacity 0.35s ease-in-out;display:flex;align-items:end;background:linear-gradient( 180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.550042) 40.87%,#000000 100% );z-index:",
    ";position:absolute;&:hover{opacity:1;transition:opacity 0.25s ease-in-out;}"
], $038071ca248e98e1$var$sharedStyles, (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised);
const $038071ca248e98e1$export$51a73b93f2c11f69 = ({ id: id , result: result , testTag: testTag , existingAssessmentId: existingAssessmentId  })=>{
    const { gradeLevels: gradeLevels , loading: loading , launchStudentLibraryReading: launchStudentLibraryReading  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            gradeLevels: s.ContentLibraryData.gradeLevels,
            loading: s.ContentLibraryData.loading,
            launchStudentLibraryReading: s.ContentLibraryData.launchStudentLibraryReading
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        id: id,
        displayType: "noStyles",
        onClick: ()=>launchStudentLibraryReading(result.reading.id, history, query, pathname, existingAssessmentId),
        testTag: testTag,
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true,
            kind: "boat"
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($038071ca248e98e1$var$TileContainer, {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($038071ca248e98e1$var$ImageContainer, {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$2e6fda2350c5bcdc), {
                        src: result.imageStoredFile?.thumbnailUrl ?? undefined,
                        testTag: "library-image",
                        size: "extraLarge",
                        title: result.reading.name
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($038071ca248e98e1$var$Description, {
                    "data-test-tag": `student-reading-tile-${result.reading.id}`,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        width: $038071ca248e98e1$var$READING_TILE_WIDTH,
                        justify: "end",
                        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h5",
                                color: "white",
                                title: result.reading.name,
                                ellipsis: true,
                                children: result.reading.name
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h7",
                                weightOverride: "medium",
                                color: "white",
                                title: result.author?.name || "Author Unknown",
                                ellipsis: true,
                                children: result.author?.name || "Author Unknown"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 3
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                wrap: "wrap",
                                children: [
                                    result.tags.slice(0, 2).map((tag, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                                    color: "gray6",
                                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                        variant: "h7",
                                                        weightOverride: "medium",
                                                        color: "white",
                                                        children: tag.name
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    horizontal: true
                                                })
                                            ]
                                        }, i)),
                                    result.tags.size > 2 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            wrap: "wrap",
                                            justify: "center",
                                            children: result.tags.slice(2).map((tag, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                                            color: "gray6",
                                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                                variant: "h7",
                                                                title: tag.name,
                                                                color: "black",
                                                                children: tag.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                            horizontal: true
                                                        })
                                                    ]
                                                }, i))
                                        }),
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                            color: "gray6",
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h7",
                                                weightOverride: "medium",
                                                color: "white",
                                                children: [
                                                    "+ ",
                                                    result.tags.slice(2).size
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            !result.tags.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 3
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h7",
                                weightOverride: "medium",
                                color: "white",
                                children: [
                                    (0, $3e76d4bc3268f884$export$f5dd818bff069720)(result.reading.totalWords),
                                    " Words \xb7",
                                    " ",
                                    (0, $1efad0e185f7a777$export$4465baac62bc8a48)(result.reading.gradeLevelId, result.reading.autoGradeLevelId, gradeLevels)
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};




const $d83e59545c54a87c$export$3ee0286f1bde52db = (props)=>{
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isStudent = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/s/library"));
    return isStudent ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $038071ca248e98e1$export$51a73b93f2c11f69), {
        ...props
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c0639dd78ac8be4e$export$f804e4b6aa0076f3), {
        ...props
    });
};


const $e26606266d1a0b21$export$cdd798f1ed2a74ac = ()=>{
    const { playlistResults: playlistResults , loading: loading , continueReadingMap: continueReadingMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ContentLibraryData: s  })=>({
            playlistResults: s.playlistResults,
            continueReadingMap: s.continueReadingMap,
            loading: s.loading
        }), []);
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isStudent = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/s/library"));
    const playlist = (0, $3935c2aa64ec7a52$export$f07514158026f5aa)();
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3935c2aa64ec7a52$export$2daf7b8111a8922), {});
    if (!playlist) return null;
    const results = playlist.id === "continue-reading" ? continueReadingMap.toList() : playlistResults.get(playlist.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
        centeredMaxWidth: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 8
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1).none} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        icon: "backArrow",
                        color: "backgroundLight",
                        to: `/${isStudent ? "s" : "t"}/library`,
                        paddingOverride: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]}`,
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3,
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h2",
                        children: playlist.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $37cf5c497e358388$export$e04042801ea527f0), {
                testTag: `playlist-results-${playlist.id}`,
                children: results.sortBy((res)=>res.reading.name.toLocaleLowerCase()).map((res, idx)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d83e59545c54a87c$export$3ee0286f1bde52db), {
                        id: `playlist-result-${idx}`,
                        result: res,
                        testTag: `playlist-result-${idx}`,
                        existingAssessmentId: res.assessmentId
                    }, res.reading.id))
            })
        ]
    });
};




var $g5BLJ = parcelRequire("g5BLJ");








var $eYBdv = parcelRequire("eYBdv");

const $7a500581de4d11b8$export$a7f9a17ce88d8bab = ()=>{
    const { searchResults: searchResults , playlists: playlists , playlistResults: playlistResults , loading: loading , continueReadingMap: continueReadingMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ContentLibraryData: { searchResults: searchResults , playlists: playlists , playlistResults: playlistResults , loading: loading , continueReadingMap: continueReadingMap  }  })=>({
            searchResults: searchResults,
            playlistResults: playlistResults,
            playlists: playlists,
            loading: loading,
            continueReadingMap: continueReadingMap
        }), []);
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isStudent = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/s/library"));
    const isMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThan: "tabletSmall"
    });
    const [resultsPerRow, setResultsPerRow] = (0, $g5BLJ.useState)(10);
    const windowSize = (0, $4fd3b1c7dfff02ca$export$42c02f33970a2afa)();
    const searchData = (0, $3935c2aa64ec7a52$export$b72f3303d4547637)();
    const searching = (0, $3935c2aa64ec7a52$export$beebad6512239b8a)(searchData);
    (0, $g5BLJ.useEffect)(()=>{
        if (loading) return;
        const searchResultContainer = document.getElementById("readings-search-results");
        if (!searchResultContainer) return;
        const firstResult = document.getElementById(`search-result-0`);
        if (!firstResult) return;
        const computedStyle = getComputedStyle(searchResultContainer);
        const paddingLeft = computedStyle.paddingLeft || "0px";
        const paddingRight = computedStyle.paddingLeft || "0px";
        const paddingNumberLeft = parseInt((0, $eYBdv.trimEnd)(paddingLeft, "px"), 10);
        const paddingNumberRight = parseInt((0, $eYBdv.trimEnd)(paddingRight, "px"), 10);
        const totalPadding = paddingNumberLeft + paddingNumberRight;
        const extraPaddingToAvoidWrapping = isStudent ? 8 : 0;
        const containerWidth = searchResultContainer.getBoundingClientRect().width - totalPadding;
        const resultWidth = firstResult.getBoundingClientRect().width + extraPaddingToAvoidWrapping;
        const perRow = Math.floor(containerWidth / resultWidth);
        setResultsPerRow(perRow);
    }, [
        loading,
        windowSize,
        isStudent
    ]);
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3935c2aa64ec7a52$export$2daf7b8111a8922), {});
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            !searching && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
                "data-test-tag": "all-playlists",
                children: playlists.sortBy((p)=>p.ranking).map((playlist)=>{
                    const results = playlist.id === "continue-reading" ? continueReadingMap.toList() : playlistResults.get(playlist.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
                    if (results.isEmpty()) return null;
                    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
                        "data-test-tag": `playlist-container-${playlist.id}`,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} 0 0 0`,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3935c2aa64ec7a52$export$3d6ed0715468a113), {
                                        children: playlist.name
                                    }),
                                    resultsPerRow < results.size && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        icon: "forwardArrow",
                                        iconPosition: "right",
                                        iconSize: "1.3em",
                                        to: `/${isStudent ? "s" : "t"}/library${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)({
                                            playlistId: playlist.id
                                        })}`,
                                        children: "View More"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $37cf5c497e358388$export$e04042801ea527f0), {
                                testTag: `playlist-results-${playlist.id}`,
                                children: results.sortBy((res)=>res.reading.name.toLocaleLowerCase()).take(resultsPerRow).map((res, idx)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d83e59545c54a87c$export$3ee0286f1bde52db), {
                                        id: `playlist-result-${idx}`,
                                        result: res,
                                        testTag: `playlist-result-${idx}`,
                                        existingAssessmentId: res.assessmentId
                                    }, res.reading.id))
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 4
                            })
                        ]
                    }, playlist.id);
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
                children: [
                    searching || playlists.isEmpty() ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3935c2aa64ec7a52$export$3d6ed0715468a113), {
                        children: "More Content"
                    }),
                    searchResults.count() > 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $37cf5c497e358388$export$e04042801ea527f0), {
                        id: "readings-search-results",
                        testTag: "readings-search-results",
                        children: searchResults.map((res, idx)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d83e59545c54a87c$export$3ee0286f1bde52db), {
                                id: `search-result-${idx}`,
                                result: res,
                                testTag: `search-result-${idx}`
                            }, res.reading.id))
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: isMobile ? "start" : "center",
                        justify: "center",
                        width: "100%",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h4",
                            children: "No readings match your search criteria"
                        })
                    })
                ]
            })
        ]
    });
};



const $e19a31b8e757b290$var$ContentLibraryDetails = ()=>{
    const { loading: loading , totalResults: totalResults , searchResults: searchResults , search: search  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ContentLibraryData: s  })=>({
            search: s.search,
            loading: s.loading,
            totalResults: s.totalResults,
            searchResults: s.searchResults
        }), []);
    const searchData = (0, $3935c2aa64ec7a52$export$b72f3303d4547637)();
    (0, $g5BLJ.useEffect)(()=>{
        search(searchData);
    }, [
        search,
        searchData
    ]);
    const setQuery = (0, $3935c2aa64ec7a52$export$2d38afb37916ea3b)();
    const onSearch = (0, $g5BLJ.useCallback)((text)=>setQuery({
            searchText: text
        }), [
        setQuery
    ]);
    const playlist = (0, $3935c2aa64ec7a52$export$f07514158026f5aa)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            playlist ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e26606266d1a0b21$export$cdd798f1ed2a74ac), {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $37cf5c497e358388$export$ce6636bfa4e9f0e8), {
                filters: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a0c3f554753e0b09$export$92a576f896a9bf72), {}),
                searchValue: searchData.searchText,
                searchAction: onSearch,
                searchPlaceholder: "Search Content",
                resultCount: searchResults.count(),
                resultTotal: totalResults,
                loading: loading,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7a500581de4d11b8$export$a7f9a17ce88d8bab), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $06712caf59d22777$export$18fc517eef81d627), {})
        ]
    });
};
const $e19a31b8e757b290$export$b94d3ffef634e7de = ()=>{
    const { load: load , gradeLevelsLoading: gradeLevelsLoading  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ContentLibraryData: s  })=>({
            load: s.load,
            gradeLevelsLoading: s.gradeLevelsLoading
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return gradeLevelsLoading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        kind: "boat",
        flex: true
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e19a31b8e757b290$var$ContentLibraryDetails, {});
};




const $5885484d0186045a$var$BaseStudentLayoutStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentLayout__BaseStudentLayoutStyles",
    componentId: "sc-adiio9-0"
})([
    "",
    " display:grid;grid-template-columns:1fr;grid-template-rows:auto 1fr;"
], (0, $dba6c5da69120483$export$6988a55f9afa8b34));
const $5885484d0186045a$export$73f77934ec61f509 = ()=>{
    const { createFreeRead: createFreeRead , freeReadLoading: freeReadLoading , isStudentHomepageLibraryEnabled: isStudentHomepageLibraryEnabled , isStudentLibraryEnabled: isStudentLibraryEnabled  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            createFreeRead: s.AssignmentBuilderData.createFreeRead,
            freeReadLoading: s.AssignmentBuilderData.freeReadLoading,
            isStudentLibraryEnabled: s.AppData.currentUser?.flags?.isStudentLibraryEnabled ?? false,
            isStudentHomepageLibraryEnabled: s.AppData.currentUser?.flags?.isStudentHomepageLibraryEnabled ?? false
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($5885484d0186045a$var$BaseStudentLayoutStyles, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5557eb3ea8c47b66$export$dba0f9e9232b3d6d), {
                accountTypes: [
                    "teacher"
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $74b195a20ec26994$export$c4e96258f3b6511), {
                mobileAction: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    newTab: true,
                    color: "primaryBlue",
                    onClick: ()=>createFreeRead(history),
                    disabled: freeReadLoading,
                    loading: freeReadLoading,
                    children: "Free Read"
                }),
                alwaysShowSecondaryAction: false
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/s/profile",
                        exact: true,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                title: "My Profile"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f183dd4b89f089d3$export$b7b58f2e100445f7), {
                                ContentElement: (0, $983442d63718d5de$export$2ab6bab701a9bc81)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/s/avatar",
                        exact: true,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                title: "Edit Avatar"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b046a4d40ca74a4f$export$6550daf4ecbb4e45), {
                                    ContentElement: (0, $a8456ce4f5e5d303$export$75338fdd217ab44a)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/s/assignments",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                title: "Assignments"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $74edf34b4b7a68bf$export$5c030a7951d3fc5e), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/s/library",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e19a31b8e757b290$export$b94d3ffef634e7de), {})
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5d1a86368f52f068$export$26411c8811cbaaba), {
                        children: isStudentLibraryEnabled ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
                            to: isStudentHomepageLibraryEnabled ? "/s/library" : "/s/assignments"
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
                            to: "/s/assignments"
                        })
                    })
                ]
            })
        ]
    });
};






const $a8456ce4f5e5d303$var$StudentLayoutContentHeaderStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentLayoutContent__StudentLayoutContentHeaderStyles",
    componentId: "sc-1naj3b3-0"
})([
    "display:grid;grid-template-columns:auto 1fr auto;padding:",
    ";background:",
    ";color:",
    ";"
], ({ $showMobile: $showMobile  })=>$showMobile ? (0, $8259eb090983b778$export$ea413736286a3bf1)[5] : (0, $8259eb090983b778$export$ea413736286a3bf1)[10], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.text);
const $a8456ce4f5e5d303$export$7abf697a310a6576 = ({ headerText: headerText , headerActionButton: headerActionButton = null , showMobile: showMobile  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($a8456ce4f5e5d303$var$StudentLayoutContentHeaderStyles, {
        $showMobile: showMobile,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h2",
                children: headerText
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {}),
            headerActionButton
        ]
    });
};
const $a8456ce4f5e5d303$var$ContentStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentLayoutContent__ContentStyles",
    componentId: "sc-1naj3b3-1"
})([
    "height:100%;background:",
    ";color:",
    ";display:grid;grid-template-rows:auto 1fr;grid-column:span 2;overflow-x:auto;overflow-y:auto;@media (min-width:",
    "px){grid-column:span 1;}"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.text, (0, $4fd3b1c7dfff02ca$export$d07517a676ce386f).tablet);
const $a8456ce4f5e5d303$var$ChildrenContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentLayoutContent__ChildrenContainer",
    componentId: "sc-1naj3b3-2"
})([
    "height:100%;padding:",
    ";"
], ({ $showMobile: $showMobile  })=>$showMobile ? `${(0, $8259eb090983b778$export$ea413736286a3bf1).none} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[5]}` : `${(0, $8259eb090983b778$export$ea413736286a3bf1).none} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[10]}`);
const $a8456ce4f5e5d303$export$75338fdd217ab44a = ({ headerText: headerText , headerActionButton: headerActionButton , children: children , loading: loading = false  })=>{
    const headerProps = {
        headerText: headerText,
        headerActionButton: headerActionButton
    };
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "mobileLarge"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($a8456ce4f5e5d303$var$ContentStyles, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($a8456ce4f5e5d303$export$7abf697a310a6576, {
                ...headerProps,
                showMobile: showMobile
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($a8456ce4f5e5d303$var$ChildrenContainer, {
                $showMobile: showMobile,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2a5e7b0563ceb985$export$cd95088e3160fae9), {
                    loading: loading,
                    children: children
                })
            })
        ]
    });
};










var $g5BLJ = parcelRequire("g5BLJ");











var $g5BLJ = parcelRequire("g5BLJ");





const $318562eb70a288cb$export$f661dd54e314fed7 = ()=>{
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const closeModal = (0, $g5BLJ.useCallback)(()=>history.replace("/t/classes"), [
        history
    ]);
    const location = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)();
    const isCreate = location.pathname.includes("create");
    const { courseIdsToEdit: courseIdsToEdit , editingCourse: editingCourse , editCourse: editCourse , setEditCourseField: setEditCourseField , gradeLevels: gradeLevels , editErrors: editErrors , archive: archive , generateClassCode: generateClassCode , subjects: subjects , tempEditingCourseSubjectIds: tempEditingCourseSubjectIds , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ TeacherCourseListData: s  })=>({
            courseIdsToEdit: s.courseIdsToEdit,
            editingCourse: s.editingCourse,
            editCourse: s.editCourse,
            setEditCourseField: s.setEditCourseField,
            gradeLevels: s.gradeLevels,
            editErrors: s.editErrors,
            archive: s.archive,
            generateClassCode: s.generateClassCode,
            subjects: s.subjects,
            tempEditingCourseSubjectIds: s.tempEditingCourseSubjectIds,
            setField: s.setField
        }), []);
    if (!editingCourse) return null;
    const editingCourseIndex = courseIdsToEdit.findIndex((id)=>id === editingCourse.id);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "path",
        header: `${isCreate ? "Create" : "Edit"} Class
          ${courseIdsToEdit.size > 1 ? ` — ${editingCourseIndex + 1} of ${courseIdsToEdit.size}` : ""}`,
        openedPath: "/t/classes/(create|edit)",
        close: closeModal,
        disableFadeClose: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            width: "100%",
            onClick: ()=>editCourse(history, query, isCreate),
            children: "Save Class"
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                        name: editingCourse.name || "",
                        backgroundColor: editingCourse.avatarColor || (0, $24b764039c44d1ec$export$40792c0fcdd2bbbd)[0],
                        size: "extraLarge"
                    }),
                    !isCreate && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: archive(editingCourse, createToast, ()=>history.replace("/t/classes")),
                        children: [
                            editingCourse.status === "active" ? "Archive" : "Unarchive",
                            " Class"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "name",
                label: "Class Name",
                value: editingCourse.name,
                onChange: setEditCourseField("name"),
                disabled: editingCourse.isLms,
                errors: editErrors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "select",
                label: "Grade",
                name: "gradeLevel",
                options: gradeLevels.map((gl)=>({
                        value: gl.id,
                        label: gl.name,
                        disabled: (0, $1efad0e185f7a777$export$4c9c6fc2c1b59749).has(gl.level)
                    })),
                value: editingCourse.gradeLevelId || gradeLevels.find((gl)=>(0, $1efad0e185f7a777$export$4c9c6fc2c1b59749).has(gl.level))?.id,
                onChange: setEditCourseField("gradeLevelId"),
                errors: editErrors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "multiselect",
                label: "Subjects",
                name: "subjects",
                options: subjects.map((subject)=>({
                        value: subject.id,
                        label: subject.name
                    })),
                value: tempEditingCourseSubjectIds,
                onChange: setField("tempEditingCourseSubjectIds"),
                testTag: "subjects",
                errors: editErrors
            }),
            !editingCourse.isLms && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "text",
                        name: "courseCode",
                        label: "Class Code",
                        value: editingCourse.courseCode,
                        onChange: setEditCourseField("courseCode"),
                        errors: editErrors
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        justify: "end",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "link",
                            onClick: generateClassCode,
                            children: "Generate New Class Code"
                        })
                    })
                ]
            })
        ]
    });
};




var $g5BLJ = parcelRequire("g5BLJ");







const $6876bf5c04591371$var$CheckboxListItem = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ImportGoogleCourseModal__CheckboxListItem",
    componentId: "sc-r5oh10-0"
})([
    "display:flex;align-items:center;cursor:pointer;margin:",
    " 0;"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[6]);
const $6876bf5c04591371$var$CoursesContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ImportGoogleCourseModal__CoursesContainer",
    componentId: "sc-r5oh10-1"
})([
    "overflow-y:auto;max-height:300px;padding:0 ",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[6]);
const $6876bf5c04591371$export$fa03d64d62bf773a = ({ openedPath: openedPath , closedPath: closedPath  })=>{
    const { googleCourses: googleCourses , submit: submit , load: load , loading: loading , courseMap: courseMap , studentCountMap: studentCountMap , selectedGoogleCourseIds: selectedGoogleCourseIds , setSelected: setSelected , hasScopes: hasScopes , submitting: submitting , setAll: setAll  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ImportGoogleCourseData, []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const closeModal = (0, $g5BLJ.useCallback)(()=>history.replace(closedPath), [
        history,
        closedPath
    ]);
    const opened = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, openedPath));
    (0, $g5BLJ.useEffect)(()=>{
        if (opened) load();
    }, [
        load,
        opened
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "path",
        header: "Import Google Classrooms",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                width: "100%",
                loading: submitting,
                type: "submit",
                onClick: submit(history, pathname, query),
                disabled: !hasScopes || selectedGoogleCourseIds.size === 0,
                children: "Import Classes"
            })
        }),
        openedPath: openedPath,
        close: closeModal,
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h4",
                            children: [
                                "Classes (",
                                googleCourses.size,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            onClick: setAll,
                            color: "primaryBlue",
                            children: selectedGoogleCourseIds.isEmpty() ? "Select All" : "Deselect All"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($6876bf5c04591371$var$CoursesContainer, {
                    children: hasScopes && googleCourses.size > 0 ? googleCourses.map((googleCourse)=>{
                        const course = courseMap.get(googleCourse.id);
                        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($6876bf5c04591371$var$CheckboxListItem, {
                            onClick: setSelected(googleCourse.id),
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                                    avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                                        size: "large",
                                        backgroundColor: googleCourse.avatarColor,
                                        name: googleCourse.name
                                    }),
                                    primaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        align: "center",
                                        children: [
                                            googleCourse.name,
                                            course && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        horizontal: true
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                        icon: "sync",
                                                        size: "1.5em"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: course ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                            children: [
                                                "Last Synced",
                                                " ",
                                                course.googleSyncedAt ? (0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(course.googleSyncedAt)) : "Unknown"
                                            ]
                                        }) : (0, $e6116bf527c207db$export$cefb40c9962541b5)("Student", studentCountMap.get(googleCourse.id, 0))
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 8
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                    onChange: setSelected(googleCourse.id),
                                    name: googleCourse.id,
                                    value: selectedGoogleCourseIds.has(googleCourse.id)
                                })
                            ]
                        }, googleCourse.id);
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                maxWidth: "400px",
                                children: "We're having trouble finding your Google Classrooms. Click below to let Readlee see your classes on Google Classroom."
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 4
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c8a864413785e08a$export$dc1434c1a71d39bc), {
                                scopeKey: "import_class",
                                successUrl: "/t/classes/google_import",
                                forceOauth: true,
                                children: "Authorize Google Classroom"
                            })
                        ]
                    })
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");







const $f6374acbb4da9e6e$var$CheckboxListItem = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ImportCleverCourseModal__CheckboxListItem",
    componentId: "sc-652f5z-0"
})([
    "display:flex;align-items:center;cursor:pointer;margin:",
    " 0;"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[6]);
const $f6374acbb4da9e6e$var$CoursesContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ImportCleverCourseModal__CoursesContainer",
    componentId: "sc-652f5z-1"
})([
    "overflow-y:auto;max-height:300px;padding:0 ",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[6]);
const $f6374acbb4da9e6e$export$c787609239ab33c4 = ({ openedPath: openedPath , closedPath: closedPath  })=>{
    const { cleverSections: cleverSections , submit: submit , load: load , loading: loading , courseMap: courseMap , selectedCleverSectionIds: selectedCleverSectionIds , setSelected: setSelected , hasScopes: hasScopes , submitting: submitting , setAll: setAll  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ImportCleverCourseData, []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const opened = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, openedPath));
    const closeModal = (0, $g5BLJ.useCallback)(()=>history.replace(closedPath), [
        history,
        closedPath
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (opened) load();
    }, [
        load,
        opened
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "path",
        header: "Import from Clever",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                width: "100%",
                loading: submitting,
                type: "submit",
                onClick: submit(history, pathname, query),
                disabled: !hasScopes || selectedCleverSectionIds.size === 0,
                children: "Import Classes"
            })
        }),
        openedPath: openedPath,
        close: closeModal,
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    justify: "space-between",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h4",
                            children: [
                                "Classes (",
                                cleverSections.size,
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            onClick: setAll,
                            color: "primaryBlue",
                            children: selectedCleverSectionIds.isEmpty() ? "Select All" : "Deselect All"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f6374acbb4da9e6e$var$CoursesContainer, {
                    children: hasScopes ? cleverSections.map((cleverSection)=>{
                        const course = courseMap.get(cleverSection.id);
                        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($f6374acbb4da9e6e$var$CheckboxListItem, {
                            onClick: setSelected(cleverSection.id),
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                                    avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                                        size: "large",
                                        backgroundColor: cleverSection.avatarColor,
                                        name: cleverSection.name
                                    }),
                                    primaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        align: "center",
                                        children: [
                                            cleverSection.name,
                                            course && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        horizontal: true
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                        icon: "sync",
                                                        size: "1.5em"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    secondaryText: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: course ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                            children: [
                                                "Last Synced",
                                                " ",
                                                course.cleverSyncedAt ? (0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(course.cleverSyncedAt)) : "Unknown"
                                            ]
                                        }) : (0, $e6116bf527c207db$export$cefb40c9962541b5)("Student", cleverSection.students.size)
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 8
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                    onChange: setSelected(cleverSection.id),
                                    name: cleverSection.id,
                                    value: selectedCleverSectionIds.has(cleverSection.id)
                                })
                            ]
                        }, cleverSection.id);
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: "Please authorize Readlee to access your courses on Clever Classroom."
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6b95aaca78d83e60$export$800b563f63fbe24a), {
                                successUrl: "/t/classes/clever_import",
                                children: "Authorize Clever Classroom"
                            })
                        ]
                    })
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");






const $4dc048a240f420a7$export$82cd31a1acaef633 = ()=>{
    const { isCoTeachersEnabled: isCoTeachersEnabled = false , courses: courses , loading: loading , startSyncCourse: startSyncCourse  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            isCoTeachersEnabled: s.AppData.currentUser?.flags?.isCoTeachersEnabled,
            courses: s.TeacherCourseListData.courses,
            loading: s.TeacherCourseListData.loading,
            startSyncCourse: s.TeacherCourseListData.startSyncCourse
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const closeModal = (0, $g5BLJ.useCallback)(()=>history.push("/t/classes"), [
        history
    ]);
    const courseId = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)().courseId;
    const course = courses.find((c)=>c.id === courseId);
    if (!course) return null;
    const upgradeNeeded = !isCoTeachersEnabled;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "path",
        header: upgradeNeeded ? `${0, $4ded3b2c5af96cca$export$52756c3ad45aa25c} Feature` : "Manage Co-Teachers",
        openedPath: "/t/classes/:courseId/co-teachers",
        close: closeModal,
        maxWidthOverride: "350px",
        minWidthOverride: "350px",
        children: upgradeNeeded ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: [
                        "Upgrade to ",
                        (0, $4ded3b2c5af96cca$export$52756c3ad45aa25c),
                        " to enable Co-teachers to track progress, assign readings and more."
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    href: "https://www.readlee.com/contact",
                    width: "100%",
                    newTab: true,
                    children: "Contact Us!"
                })
            ]
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: 'For imported classes (Google Class or Clever), you can manage co-teachers directly in your LMS. To update, press "sync."'
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            children: "To add a teacher manually,"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            onClick: (0, $86ce6205c10768ba$export$68306590b07bdc01),
                            children: "contact support."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    width: "100%",
                    loading: loading,
                    onClick: startSyncCourse({
                        history: history,
                        query: query,
                        pathname: pathname,
                        courses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                            course
                        ]),
                        isGoogle: Boolean(course.googleSyncedAt)
                    }),
                    disabled: !course.isLms,
                    children: "Sync Co-Teachers"
                })
            ]
        })
    });
};



var $g5BLJ = parcelRequire("g5BLJ");




const $eb042bee730d29fc$export$8ce43885d4c11088 = ()=>{
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const { syncAllCourses: syncAllCourses , courses: courses  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            syncAllCourses: s.TeacherCourseListData.syncAllCourses,
            courses: s.TeacherCourseListData.courses
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isGoogle = (0, $g5BLJ.useMemo)(()=>query.get("isGoogle") === "true", [
        query
    ]);
    const coursesToSync = (0, $g5BLJ.useMemo)(()=>{
        const courseIds = (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)(query.get("courseIds")?.split(","));
        return courses.filter((c)=>courseIds.has(c.id));
    }, [
        courses,
        query
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        syncAllCourses(coursesToSync, history, pathname, createToast, isGoogle)();
    }, [
        history,
        createToast,
        syncAllCourses,
        coursesToSync,
        isGoogle,
        pathname
    ]);
    return null;
};




var $g5BLJ = parcelRequire("g5BLJ");







const $8c4c7c3c51b0d7a5$export$455d1a84d2fbff0f = ()=>{
    const { editingCourse: editingCourse , students: students , registrations: registrations , unsavedRegistrations: unsavedRegistrations , toggleRegistration: toggleRegistration , updateClassStudents: updateClassStudents  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherCourseListData, []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const closeModal = (0, $g5BLJ.useCallback)(()=>history.push(`/t/classes${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`), [
        history,
        query
    ]);
    const courseRegistrations = (0, $g5BLJ.useMemo)(()=>registrations.get(editingCourse?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()), [
        editingCourse,
        registrations
    ]);
    if (!editingCourse) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "path",
        header: `${(0, $e6116bf527c207db$export$c8cfcdb41be1b46c)(editingCourse.name, 30)} Roster`,
        openedPath: "/t/classes/roster",
        close: closeModal,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            width: "100%",
            onClick: ()=>{
                updateClassStudents(createToast, closeModal);
            },
            children: "Save Class"
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            maxHeight: "500px",
            overflowY: "auto",
            children: students.sortBy((student)=>(0, $75cd274e63beb59b$export$61b6a526e2f145be)(student).toLowerCase()).map((s)=>{
                const registered = courseRegistrations.some((r)=>r.userId === s.id);
                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "space-between",
                    margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4]}`,
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                            avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                                name: s.displayName || "",
                                backgroundColor: s.avatarColor || "#E4EEEB",
                                size: "large"
                            }),
                            primaryText: (0, $75cd274e63beb59b$export$61b6a526e2f145be)(s),
                            secondaryText: registered && "Registered"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            height: "100%",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                onClick: ()=>{
                                    toggleRegistration(s.id);
                                },
                                color: "primaryBlue",
                                children: unsavedRegistrations.get(s.id) ? "Remove" : "Add"
                            })
                        })
                    ]
                }, s.id);
            })
        })
    });
};


















var $c254cb34016773ea$exports = {};

$c254cb34016773ea$exports = new URL((parcelRequire("3TfdU")).resolve("huPld"), import.meta.url).toString();


var $cf212d8300655c90$exports = {};

$cf212d8300655c90$exports = new URL((parcelRequire("3TfdU")).resolve("gEkJN"), import.meta.url).toString();


const $e61827ccfb86b733$var$loginUrl = `${(0, $0fe4eaef81db718a$export$625c2ae8ba020e36)}/login`;
const $e61827ccfb86b733$var$NumberContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "LmsConfirmation__NumberContainer",
    componentId: "sc-16v1lim-0"
})([
    "display:grid;align-items:center;justify-items:center;background:",
    ";color:",
    ";border-radius:",
    ";min-width:25px;height:25px;"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.text, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc).rounded);
const $e61827ccfb86b733$var$Step = ({ number: number , children: children  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e61827ccfb86b733$var$NumberContainer, {
                children: number
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            children
        ]
    });
const $e61827ccfb86b733$export$27437caca4b62179 = ({ lms: lms  })=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const studentCounts = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherCourseListData.studentCounts, []);
    const courseIds = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)((query.get("editIds") || "").split(",")).filter(Boolean);
    const studentTotal = courseIds.reduce((acc, courseId)=>acc + studentCounts.get(courseId, 0), 0);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h3",
                        weightOverride: "medium",
                        children: "Congratulations!"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: [
                            "You've imported ",
                            (0, $e6116bf527c207db$export$cefb40c9962541b5)("class", courseIds.size, {
                                pluralVersion: "classes"
                            }),
                            " ",
                            "and ",
                            (0, $e6116bf527c207db$export$cefb40c9962541b5)("student", studentTotal),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 7
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                        "data-test-tag": lms,
                        src: lms === "google" ? (0, (/*@__PURE__*/$parcel$interopDefault($cf212d8300655c90$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($c254cb34016773ea$exports))),
                        style: {
                            width: "50%",
                            height: "auto"
                        }
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        height: "100%",
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e61827ccfb86b733$var$Step, {
                                number: 1,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    children: [
                                        "Invite students to visit the",
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("br", {}),
                                        "Readlee login page"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 3
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e61827ccfb86b733$var$Step, {
                                number: 2,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    children: [
                                        "Ask your students to use the",
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("b", {
                                            children: [
                                                "Login with ",
                                                (0, $e6116bf527c207db$export$9a00dee1beb8f576)(lms)
                                            ]
                                        }),
                                        " button"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 6
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                                copyContent: $e61827ccfb86b733$var$loginUrl,
                                displayType: "link",
                                kind: "buttonOnly",
                                color: "primaryBlue",
                                copyText: "Copy Login Link",
                                width: "175px"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};







const $39a760556b00c5e6$export$f731a86a4befeaab = ({ course: course  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h3",
                        weightOverride: "medium",
                        children: [
                            "Your class",
                            " ",
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h3",
                                color: "primaryBlue",
                                display: "inline",
                                weightOverride: "medium",
                                testTag: "courseName",
                                title: course.name,
                                children: [
                                    '"',
                                    (0, $e6116bf527c207db$export$c8cfcdb41be1b46c)(course.name || "", 20),
                                    '"'
                                ]
                            }),
                            " ",
                            "was created successfully"
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Now it's time to add your students"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[6],
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
                borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
                border: `1px solid ${(0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex}`,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h4",
                                weightOverride: "bold",
                                children: "Share the class link"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2,
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f83bc0215c679685$export$3288d34c523a1192), {
                                color: "success",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    children: "Recommended"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 1
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: [
                            "Students can join your class by signing up with ",
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("b", {
                                children: "Google and Clever"
                            }),
                            " or by creating their own username and password."
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]}`,
                        backgroundColor: (0, $24b764039c44d1ec$export$4e46ac54fc82cf3b)((0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex, 0.15),
                        borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: "info",
                                strokeWidth: 2,
                                size: "1.25em",
                                color: "primaryBlue"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2,
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                weightOverride: "semibold",
                                children: [
                                    "90% of students prefer to login with ",
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("b", {
                                        children: "Google or Clever"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$b04be29aa201d4f5), {
                        $isTextInput: true,
                        children: "Share Link"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                        copyContent: (0, $d157168146708baf$export$ad3f3afa9ef03a5f)(course.courseCode),
                        displayType: "link",
                        color: "primaryBlue",
                        kind: "scrollable",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            wordBreak: "break-word",
                            children: (0, $d157168146708baf$export$ad3f3afa9ef03a5f)(course.courseCode)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 10
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h4",
                        weightOverride: "bold",
                        children: "Alternative Methods"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2,
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: "Protecting students privacy is extremely important to us. We will not ask to collect the names of students who sign up with a class link or class code. Please instruct your students on what format to use for their unique username.",
                        iconColor: "primaryBlue",
                        iconSize: "1.25em"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6306ab50056d7219$export$a766cd26d0d69044), {
                label: "Add students manually",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            children: "Enter your students' information and create usernames and passwords for each student."
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            width: "100%",
                            justify: "end",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                displayType: "outline",
                                icon: "addUser",
                                to: "/t/students/new",
                                children: "Add Students"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6306ab50056d7219$export$a766cd26d0d69044), {
                label: "Share the class code",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            children: 'If your students already have a Readlee account, they can login, click the "Join Class" button, and enter the class code displayed below.'
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                            copyContent: course.courseCode,
                            displayType: "link",
                            color: "primaryBlue",
                            kind: "scrollable",
                            copyText: "Copy Code",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: course.courseCode
                            })
                        })
                    ]
                })
            })
        ]
    });
};


const $7cf71406d0b12b1b$var$Container = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CreatedClassCompleteModal__Container",
    componentId: "sc-1fdul36-0"
})([
    "position:relative;height:auto;overflow-y:auto;"
]);
const $7cf71406d0b12b1b$var$ModalCloseButtonWrapper = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).span.withConfig({
    displayName: "CreatedClassCompleteModal__ModalCloseButtonWrapper",
    componentId: "sc-1fdul36-1"
})([
    "position:absolute;top:",
    ";right:",
    ";"
], (0, $18ffa0398cff6303$export$66be51d536890fa7)[7], (0, $18ffa0398cff6303$export$66be51d536890fa7)[7]);
const $7cf71406d0b12b1b$export$4c58f5e6cf58ec2 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const courseId = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)().courseId;
    const courses = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherCourseListData.courses, []);
    const course = courses.find((c)=>c.id === courseId);
    if (!course) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8526a011da4f152b$export$2b77a92f1a5ad772), {
        openType: "state",
        opened: true,
        maxWidthOverride: "720px",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($7cf71406d0b12b1b$var$Container, {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7cf71406d0b12b1b$var$ModalCloseButtonWrapper, {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        color: "gray3",
                        icon: "close",
                        iconSize: "0.75em",
                        width: "36px",
                        height: "36px",
                        displayType: "iconOnly",
                        onClick: ()=>history.push("/t/classes"),
                        testTag: "close",
                        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    justify: "center",
                    padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[7]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[18]}`,
                    overflowY: "auto",
                    children: [
                        course.googleSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e61827ccfb86b733$export$27437caca4b62179), {
                            lms: "google"
                        }),
                        course.cleverSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e61827ccfb86b733$export$27437caca4b62179), {
                            lms: "clever"
                        }),
                        !course.googleSyncedAt && !course.cleverSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $39a760556b00c5e6$export$f731a86a4befeaab), {
                            course: course
                        })
                    ]
                })
            ]
        })
    });
};




const $c412961da9d63a78$var$courseNameLength = 40;
const $c412961da9d63a78$var$EmptyClasses = ({ isPaperUser: isPaperUser , isSyncing: isSyncing , syncCount: syncCount  })=>{
    const paperEmptyState = ()=>{
        if (isSyncing) return "classesPaperSyncing";
        return syncCount > 0 ? "noClassesPaper" : "classesPaper";
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        height: "100%",
        width: "100%",
        align: "center",
        justify: "center",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
            kind: isPaperUser ? paperEmptyState() : "classes"
        })
    });
};
const $c412961da9d63a78$var$getCourseSecondaryText = (course, syncLoadingCourseIds)=>{
    if (course && syncLoadingCourseIds.has(course.id)) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            "Syncing",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                size: "x-small"
            })
        ]
    });
    else if (course.googleSyncedAt) return `Last Synced ${(0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(course.googleSyncedAt))}`;
    else if (course.cleverSyncedAt) return `Last Synced ${(0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(course.cleverSyncedAt))}`;
    return null;
};
const $c412961da9d63a78$export$26dd609890808aaf = ({ ContentElement: ContentElement  })=>{
    const { loading: loading , load: load , courses: courses , studentCounts: studentCounts , archive: archive , startSyncCourse: startSyncCourse , syncLoadingCourseIds: syncLoadingCourseIds , assessmentCountMap: assessmentCountMap , isSyncing: isSyncing  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            isSyncing: state.PaperSyncData.getIsSyncing(),
            loading: state.TeacherCourseListData.loading,
            load: state.TeacherCourseListData.load,
            courses: state.TeacherCourseListData.courses,
            studentCounts: state.TeacherCourseListData.studentCounts,
            archive: state.TeacherCourseListData.archive,
            startSyncCourse: state.TeacherCourseListData.startSyncCourse,
            syncLoadingCourseIds: state.TeacherCourseListData.syncLoadingCourseIds,
            assessmentCountMap: state.TeacherCourseListData.assessmentCountMap
        }), []);
    const { paperSyncedAt: paperSyncedAt , paperRosterManualSyncCount: paperRosterManualSyncCount , paperRosterAutoSyncCount: paperRosterAutoSyncCount  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: { currentUser: currentUser  }  })=>({
            paperSyncedAt: currentUser?.paperSyncedAt,
            paperRosterManualSyncCount: currentUser?.paperRosterManualSyncCount || 0,
            paperRosterAutoSyncCount: currentUser?.paperRosterAutoSyncCount || 0
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const courseIdsQueryParam = query.get("editIds");
    (0, $g5BLJ.useEffect)(()=>{
        const courseIdsToEdit = (0, $3f9a4df32f03e33e$export$bdf4ff5a442cbbc5)((courseIdsQueryParam || "").split(","));
        load({
            courseIdsToEdit: courseIdsToEdit,
            history: history,
            pathname: pathname
        });
    }, [
        load,
        courseIdsQueryParam,
        history,
        pathname
    ]);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const [activeCourses, archivedCourses] = (0, $d5a1fd3dea1a0ab6$export$b29f828819edca8d)(courses, (c)=>c.status === "active");
    const lmsCourses = courses.filter((course)=>course.isLms);
    const [googleCourses, cleverCourses] = (0, $d5a1fd3dea1a0ab6$export$b29f828819edca8d)(lmsCourses, (c)=>c.googleSyncedAt);
    const columns = [
        {
            id: "name",
            name: "Class Name",
            render: (course)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                    primaryText: (0, $e6116bf527c207db$export$c8cfcdb41be1b46c)(course.name, $c412961da9d63a78$var$courseNameLength),
                    tooltip: course.name.length > $c412961da9d63a78$var$courseNameLength ? course.name : undefined,
                    secondaryText: $c412961da9d63a78$var$getCourseSecondaryText(course, syncLoadingCourseIds),
                    avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                        backgroundColor: course.avatarColor,
                        name: course.name
                    }, course.id)
                }),
            sortType: "sortBy",
            sortBy: (course)=>course.name,
            isPaperColumn: true,
            isPaperOnly: false
        },
        {
            id: "studentCount",
            name: "Students",
            render: (course)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: studentCounts.get(course.id) ?? 0
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (course)=>studentCounts.get(course.id) ?? 0,
            isPaperColumn: true,
            isPaperOnly: false
        },
        {
            id: "classCode",
            name: "Class Code",
            render: (course)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: course.isLms ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    display: "inline",
                                    children: "Invite students to go to "
                                }),
                                " ",
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                                    kind: "link",
                                    displayType: "link",
                                    color: "primaryBlue",
                                    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                    copyContent: "https://app.readlee.com/login",
                                    copyIconSize: "0.8em",
                                    copyDisplayType: "inline",
                                    children: "https://app.readlee.com/login"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    display: "inline",
                                    children: `, then login with their school ${course.googleSyncedAt ? "Google" : "Clever"} account. They will automatically join your Readlee class.`
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f68f5c84230354d9$export$646ed93d2b98e357), {
                                    lms: course.googleSyncedAt ? "Google" : "Clever"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    color: "gray5",
                                    children: "Synced"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                        kind: "link",
                        displayType: "link",
                        color: "primaryBlue",
                        copyContent: course.courseCode,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h6",
                            color: "black",
                            children: course.courseCode
                        })
                    })
                }),
            sortType: "none",
            isPaperColumn: false,
            isPaperOnly: false
        },
        {
            id: "classLink",
            name: "Class Link",
            render: (course)=>course.isLms ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                    content: `Students can sign up with their ${course.googleSyncedAt ? "Google" : "Clever"} accounts automatically. No class link necessary!`,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[10]} 0 0`,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h3",
                            color: "gray5",
                            children: "-"
                        })
                    })
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                        kind: "link",
                        displayType: "link",
                        color: "primaryBlue",
                        copyContent: (0, $d157168146708baf$export$ad3f3afa9ef03a5f)(course.courseCode),
                        children: "Invite Link"
                    })
                }),
            sortType: "none",
            isPaperColumn: false,
            isPaperOnly: false
        },
        {
            id: "assignmentCount",
            name: "Assignments Assigned",
            render: (course)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: assessmentCountMap.get(course.id, 0)
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (course)=>assessmentCountMap.get(course.id, 0),
            isPaperColumn: true,
            isPaperOnly: true
        },
        {
            id: "settings",
            name: "Actions",
            textAlign: "right",
            render: (course)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    justify: "end",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                        rightAligned: true,
                        displayType: "iconOnly",
                        color: "white",
                        iconColor: "gray7",
                        icon: "threeVerticalDots",
                        iconSize: "2em",
                        testTag: "settings",
                        inheritBgColor: true,
                        noButtonPadding: true,
                        options: course.status === "active" ? [
                            {
                                children: "Edit Class",
                                to: (0, $d157168146708baf$export$1d221c892c3cb676)("edit", query, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                    course.id
                                ]))
                            },
                            {
                                children: "Edit Students",
                                to: (0, $d157168146708baf$export$75f5706b792e2254)(query, course.id),
                                disabled: course.isLms,
                                tooltipProps: {
                                    content: "Manage students directly in your LMS, e.g. GoogleClass",
                                    disabled: !course.isLms,
                                    containerWidthOverride: "100%"
                                }
                            },
                            ...course.isLms ? [
                                {
                                    children: "Sync with LMS",
                                    onClick: startSyncCourse({
                                        history: history,
                                        pathname: pathname,
                                        query: query,
                                        courses: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                            course
                                        ]),
                                        isGoogle: Boolean(course.googleSyncedAt)
                                    })
                                }
                            ] : [],
                            {
                                children: "Manage Co-Teachers",
                                to: `/t/classes/${course.id}/co-teachers`
                            },
                            {
                                children: "Archive",
                                onClick: archive(course, createToast)
                            }
                        ] : [
                            {
                                children: "Unarchive",
                                onClick: archive(course, createToast)
                            }
                        ]
                    })
                }),
            sortType: "none",
            isPaperColumn: false
        }
    ];
    const filteredColumns = columns.filter((column)=>paperSyncedAt ? column.isPaperColumn : !column.isPaperOnly);
    const syncCount = paperRosterAutoSyncCount + paperRosterManualSyncCount;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)(ContentElement, {
                headerText: "Classes",
                headerActionButton: !paperSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $cf6c99bc3c73c975$export$eb50220e1d599d2e), {
                    displayType: "button",
                    openedPath: "/t/classes/new",
                    closedPath: "/t/classes"
                }),
                loading: loading,
                children: [
                    !paperSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "end",
                        direction: "column",
                        children: [
                            !googleCourses.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                onClick: startSyncCourse({
                                    history: history,
                                    query: query,
                                    pathname: pathname,
                                    courses: googleCourses,
                                    isGoogle: true
                                }),
                                displayType: "link",
                                children: "Sync Google Courses"
                            }),
                            !googleCourses.isEmpty() && !cleverCourses.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                            !cleverCourses.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                onClick: startSyncCourse({
                                    history: history,
                                    query: query,
                                    pathname: pathname,
                                    courses: cleverCourses,
                                    isGoogle: false
                                }),
                                displayType: "link",
                                children: "Sync Clever Courses"
                            })
                        ]
                    }),
                    paperSyncedAt && (!activeCourses.isEmpty() || !archivedCourses.isEmpty()) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        align: "end",
                        width: "100%",
                        margin: `0 0 -${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]} 0`,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b4a9b2222f765970$export$88a5d3bdaa4e4ff2), {
                            showSyncStatus: true
                        })
                    }),
                    loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                        flex: true,
                        kind: "boat"
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e3aa8aeb4209bd7$export$44c45b2b7f09d2a6), {
                        queryParam: "status",
                        tabs: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                            {
                                id: "active",
                                name: "Active Classes",
                                content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                                    columns: filteredColumns,
                                    rows: isSyncing ? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)() : activeCourses,
                                    getRowId: (course)=>course.id,
                                    queryParam: "sortBy",
                                    initialSortSettings: {
                                        columnId: "name",
                                        sortDirection: "asc"
                                    },
                                    rowClickable: true,
                                    onRowClick: (course)=>history.push(`/t/students?selectedCourseId=${course.id}`),
                                    emptyStateContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c412961da9d63a78$var$EmptyClasses, {
                                        isPaperUser: Boolean(paperSyncedAt),
                                        isSyncing: isSyncing,
                                        syncCount: syncCount
                                    })
                                })
                            },
                            {
                                id: "archived",
                                name: "Archived Classes",
                                content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                                    columns: filteredColumns,
                                    rows: isSyncing ? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)() : archivedCourses,
                                    getRowId: (course)=>course.id,
                                    queryParam: "sortBy",
                                    initialSortSettings: {
                                        columnId: "name",
                                        sortDirection: "asc"
                                    },
                                    rowClickable: true,
                                    onRowClick: (course)=>history.push(`/t/students?selectedCourseId=${course.id}`),
                                    emptyStateContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c412961da9d63a78$var$EmptyClasses, {
                                        isPaperUser: Boolean(paperSyncedAt),
                                        isSyncing: isSyncing,
                                        syncCount: syncCount
                                    })
                                })
                            }
                        ]).filterNot((tab)=>archivedCourses.isEmpty() && tab.id === "archived")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 22
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $318562eb70a288cb$export$f661dd54e314fed7), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6876bf5c04591371$export$fa03d64d62bf773a), {
                openedPath: "/t/classes/google_import",
                closedPath: "/t/classes"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f6374acbb4da9e6e$export$c787609239ab33c4), {
                openedPath: "/t/classes/clever_import",
                closedPath: "/t/classes"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/classes/:courseId/co-teachers",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4dc048a240f420a7$export$82cd31a1acaef633), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/classes/sync_lms",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eb042bee730d29fc$export$8ce43885d4c11088), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/classes/:courseId/finished",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7cf71406d0b12b1b$export$4c58f5e6cf58ec2), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8c4c7c3c51b0d7a5$export$455d1a84d2fbff0f), {})
        ]
    });
};







var $g5BLJ = parcelRequire("g5BLJ");









var $g5BLJ = parcelRequire("g5BLJ");


var $g5BLJ = parcelRequire("g5BLJ");



const $e47c8c7a2cd05280$export$f6f096ab30df4370 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const params = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const currentQueryString = (0, $g5BLJ.useMemo)(()=>(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query), [
        query
    ]);
    const closeModal = (0, $g5BLJ.useCallback)(()=>history.push(`/t/students${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`), [
        history,
        query
    ]);
    const { students: students  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherStudentListData, []);
    const selectedStudent = (0, $g5BLJ.useMemo)(()=>students.find((s)=>s.id === params.id), [
        params.id,
        students
    ]);
    return {
        closeModal: closeModal,
        selectedStudent: selectedStudent,
        createToast: createToast,
        currentQueryString: currentQueryString,
        history: history
    };
};



const $a281347d99db7a73$export$220877ec7a03c8ee = ()=>{
    const { createStudent: createStudent , setUserField: setUserField , newUser: newUser , newStudentErrors: newStudentErrors , creatingNewStudent: creatingNewStudent , passwordHidden: passwordHidden , generatePassword: generatePassword , loadNewStudentModal: loadNewStudentModal , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ TeacherStudentListData: s  })=>({
            createStudent: s.createStudent,
            setUserField: s.setUserField,
            newUser: s.newUser,
            newStudentErrors: s.newStudentErrors,
            creatingNewStudent: s.creatingNewStudent,
            passwordHidden: s.passwordHidden,
            generatePassword: s.generatePassword,
            loadNewStudentModal: s.loadNewStudentModal,
            setField: s.setField
        }), []);
    const helpers = (0, $e47c8c7a2cd05280$export$f6f096ab30df4370)();
    const submit = (0, $g5BLJ.useCallback)(()=>createStudent(helpers), [
        createStudent,
        helpers
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        loadNewStudentModal();
    }, [
        loadNewStudentModal
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        testTag: "new-student-modal",
        openType: "state",
        opened: true,
        header: "Create Student",
        close: helpers.closeModal,
        disableFadeClose: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            width: "100%",
            loading: creatingNewStudent,
            onClick: submit,
            children: "Next"
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
            onSubmit: submit,
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $e1e3f7b78974b405$export$b534bc812df080fd), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            name: "name",
                            label: "First Name",
                            errors: newStudentErrors,
                            type: "text",
                            value: newUser.firstName,
                            onChange: setUserField("firstName")
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            name: "lastName",
                            label: "Last Name",
                            errors: newStudentErrors,
                            type: "text",
                            value: newUser.lastName,
                            onChange: setUserField("lastName")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                    type: "text",
                    name: newUser.username.includes("@") ? "email" : "username",
                    label: "Username or Email",
                    errors: newStudentErrors,
                    value: newUser.username,
                    onChange: setUserField("username")
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                    name: "newPassword",
                    label: "Password",
                    errors: newStudentErrors,
                    type: passwordHidden ? "password" : "text",
                    value: newUser.password,
                    onChange: setUserField("password")
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    justify: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            onClick: ()=>setField("passwordHidden")(!passwordHidden),
                            children: [
                                passwordHidden ? "Show" : "Hide",
                                " password"
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            onClick: generatePassword({
                                newUser: true
                            }),
                            children: "Generate Password"
                        })
                    ]
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $7335247658ceb8c3$export$1babf9ceff205f5a = ()=>{
    const { setField: setField , tempName: tempName , tempEmail: tempEmail , updateStudent: updateStudent , errors: errors , loadEditStudentModal: loadEditStudentModal  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherStudentListData, []);
    const helpers = (0, $e47c8c7a2cd05280$export$f6f096ab30df4370)();
    const { selectedStudent: selectedStudent , closeModal: closeModal , currentQueryString: currentQueryString  } = helpers;
    (0, $g5BLJ.useEffect)(()=>{
        loadEditStudentModal(selectedStudent);
    }, [
        selectedStudent,
        loadEditStudentModal
    ]);
    if (!selectedStudent) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        opened: true,
        openType: "state",
        close: closeModal,
        disableFadeClose: true,
        header: "Edit Student",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "end",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    onClick: closeModal,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: ()=>updateStudent(helpers),
                    disabled: selectedStudent.isSso,
                    children: "Save"
                })
            ]
        }),
        testTag: `edit-student-modal-${selectedStudent.id}`,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                    disabled: !selectedStudent.isSso,
                    content: "This student was imported from your LMS. Use your LMS to edit this student’s information",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "text",
                        label: "Name",
                        name: "name",
                        errors: errors,
                        disabled: selectedStudent.isSso,
                        value: tempName,
                        onChange: setField("tempName")
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                    disabled: !selectedStudent.isSso,
                    content: "This student was imported from your LMS. Use your LMS to edit this student’s information",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "text",
                        label: selectedStudent.email ? "Email" : "Username",
                        name: selectedStudent.email ? "email" : "username",
                        errors: errors,
                        disabled: selectedStudent.isSso,
                        value: tempEmail,
                        onChange: setField("tempEmail")
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: `/t/students/${selectedStudent.id}/change-password${currentQueryString}`,
                        children: "Change Password"
                    })
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $66ba96e3c05eb587$export$a5da2e560921fb7f = ()=>{
    const { errors: errors , newPassword: newPassword , setField: setField , passwordConfirmation: passwordConfirmation , changingPassword: changingPassword , changePassword: changePassword , generatePassword: generatePassword , passwordHidden: passwordHidden , loadChangePasswordModal: loadChangePasswordModal  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherStudentListData, []);
    const helpers = (0, $e47c8c7a2cd05280$export$f6f096ab30df4370)();
    (0, $g5BLJ.useEffect)(()=>{
        loadChangePasswordModal();
    }, [
        loadChangePasswordModal
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        opened: true,
        openType: "state",
        header: `Change Password for ${helpers.selectedStudent?.displayName}`,
        close: helpers.closeModal,
        disableFadeClose: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "end",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    onClick: helpers.closeModal,
                    children: "Close"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    disabled: changingPassword,
                    onClick: ()=>changePassword(helpers),
                    children: "Save"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: passwordHidden ? "password" : "text",
                label: "New Password",
                name: "newPassword",
                value: newPassword,
                onChange: setField("newPassword"),
                errors: errors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                justify: "space-between",
                children: [
                    newPassword.length > 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        onClick: ()=>setField("passwordHidden")(!passwordHidden),
                        children: [
                            passwordHidden ? "Show" : "Hide",
                            " password"
                        ]
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        onClick: generatePassword({
                            newUser: false
                        }),
                        children: "Generate Password"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 5
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "password",
                label: "Confirm Password",
                name: "passwordConfirmation",
                value: passwordConfirmation,
                onChange: setField("passwordConfirmation"),
                errors: errors
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");




const $75ed250e336f8d19$export$dd2adbbd99c89847 = ()=>{
    const { setField: setField , registrationMap: registrationMap , courseMap: courseMap , assignedMap: assignedMap , updateStudentClasses: updateStudentClasses , loadManageStudentCoursesModal: loadManageStudentCoursesModal  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherStudentListData, []);
    const helpers = (0, $e47c8c7a2cd05280$export$f6f096ab30df4370)();
    const { selectedStudent: selectedStudent , closeModal: closeModal  } = helpers;
    (0, $g5BLJ.useEffect)(()=>{
        loadManageStudentCoursesModal(selectedStudent);
    }, [
        loadManageStudentCoursesModal,
        selectedStudent
    ]);
    if (!selectedStudent) return null;
    const currClasses = registrationMap.get(selectedStudent.id);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: `${selectedStudent.displayName}'s Classes`,
        close: closeModal,
        disableFadeClose: true,
        openType: "state",
        opened: true,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                maxHeight: "500px",
                overflowY: "auto",
                children: courseMap.valueSeq().sortBy((course)=>course.name.toLowerCase()).map((course, key)=>{
                    const registered = currClasses?.some((registration)=>registration.status === "active" && registration.courseId === course.id);
                    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "space-between",
                        margin: "10px 16px",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                                avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                                    name: course.name,
                                    backgroundColor: course.avatarColor,
                                    size: "large"
                                }),
                                primaryText: course.name,
                                secondaryText: registered && "Assigned"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                content: "This class roster is managed by your LMS. Visit your LMS to edit this roster.",
                                disabled: !course.isLms,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "center",
                                    height: "100%",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        onClick: ()=>{
                                            setField("assignedMap")((0, $d5a1fd3dea1a0ab6$export$91fe4b954385285c)(assignedMap, course.id));
                                        },
                                        color: "primaryBlue",
                                        disabled: course.isLms,
                                        children: assignedMap.get(course.id) ? "Remove" : "Add"
                                    })
                                })
                            })
                        ]
                    }, key);
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                width: "100%",
                onClick: updateStudentClasses(helpers),
                children: "Save Changes"
            })
        ]
    });
};







const $f5fadce82629066f$var$getStudentSecondaryText = (student)=>{
    if (student.status === "pre_registered") return "Pre-Registered";
    else if (student.googleSyncedAt) return `Last Synced ${(0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(student.googleSyncedAt))}`;
    else if (student.cleverSyncedAt) return `Last Synced ${(0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(student.cleverSyncedAt))}`;
    return null;
};
const $f5fadce82629066f$var$disabledTooltip = (lms)=>{
    return `This student was imported from ${lms}. Use ${lms} to edit this student’s information`;
};
const $f5fadce82629066f$export$bda4a123e9c64662 = ({ ContentElement: ContentElement  })=>{
    const { loading: loading , load: load , students: students , registrationMap: registrationMap , courseMap: courseMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.TeacherStudentListData, []);
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.AppData.currentUser, []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const location = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const unassignedStudents = students.filter((user)=>{
        const registrations = registrationMap.get(user.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
        return registrations.isEmpty();
    });
    const selectedCourseId = query.get("selectedCourseId") || "all";
    (0, $g5BLJ.useEffect)(()=>{
        if (!loading && unassignedStudents.isEmpty() && selectedCourseId === "unassigned") history.replace("/t/students?selectedCourseId=all");
    }, [
        loading,
        history,
        selectedCourseId,
        unassignedStudents
    ]);
    const baseCourseOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(courseMap.toList().sortBy((course)=>course.status).map((course)=>({
            label: course.status === "archived" ? `(ARCHIVED) ${course.name}` : course.name,
            value: course.id
        })).unshift({
        label: "All Active Classes",
        value: "all"
    }));
    const courseOptions = unassignedStudents.isEmpty() ? baseCourseOptions : baseCourseOptions.push({
        label: "Unassigned Students",
        value: "unassigned"
    });
    const activeCourseIds = courseMap.filter((course)=>course.status === "active").map((course)=>course.id);
    const selectedStudents = (0, $g5BLJ.useMemo)(()=>{
        switch(selectedCourseId){
            case "all":
                return students.filter((user)=>{
                    const registrations = registrationMap.get(user.id)?.map((registration)=>registration.courseId);
                    return registrations?.some((registration)=>activeCourseIds.contains(registration));
                });
            case "unassigned":
                return unassignedStudents;
            default:
                return students.filter((user)=>{
                    const registrations = registrationMap.get(user.id)?.map((registration)=>registration.courseId);
                    return registrations?.contains(selectedCourseId);
                });
        }
    }, [
        activeCourseIds,
        registrationMap,
        selectedCourseId,
        students,
        unassignedStudents
    ]);
    const lmsButtonProps = (student)=>({
            tooltipProps: {
                content: $f5fadce82629066f$var$disabledTooltip((0, $75cd274e63beb59b$export$78c97a006b62508f)(student)),
                disabled: !student.isSso,
                position: "left",
                width: "200px",
                containerWidthOverride: "100%"
            },
            disabled: student.isSso
        });
    const overflowAvatar = (student)=>{
        const extraRegistrations = registrationMap.get(student.id)?.skip(3);
        const courseNames = extraRegistrations?.map((registration)=>courseMap.get(registration.courseId)?.name || "");
        return courseNames && courseNames.size > 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
            backgroundColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).black,
            name: `+${courseNames.size}`,
            nameList: courseNames,
            overflow: true,
            testTag: "class"
        }) : "";
    };
    const columns = [
        {
            id: "name",
            name: "Student",
            render: (student)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                    avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                        name: student.displayName,
                        backgroundColor: student?.avatarColor || (0, $24b764039c44d1ec$export$803ec3cef06b0273)[0]
                    }),
                    primaryText: (0, $75cd274e63beb59b$export$61b6a526e2f145be)(student),
                    secondaryText: $f5fadce82629066f$var$getStudentSecondaryText(student),
                    textColor: student.status === "pre_registered" ? "gray5" : "black"
                }),
            sortType: "sortBy",
            sortBy: (0, $75cd274e63beb59b$export$61b6a526e2f145be),
            isPaperColumn: true
        },
        {
            id: "email",
            name: "Email / Username",
            render: (student)=>{
                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f68f5c84230354d9$export$646ed93d2b98e357), {
                            lms: (0, $75cd274e63beb59b$export$78c97a006b62508f)(student)
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h6",
                            color: student.status === "pre_registered" ? "gray5" : "black",
                            children: student.email ?? student.username
                        })
                    ]
                });
            },
            sortType: "sortBy",
            sortBy: (student)=>student.email ?? student.username,
            isPaperColumn: false
        },
        {
            id: "classes",
            name: "Classes",
            render: (student)=>registrationMap.get(student.id) ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        registrationMap.get(student.id)?.slice(0, 3).map((registration)=>{
                            const course = courseMap.get(registration.courseId);
                            return course && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                testTag: "class",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                                        backgroundColor: course.status === "archived" ? (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).gray5 : course.avatarColor,
                                        name: course.name,
                                        testTag: "class"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    })
                                ]
                            }, course.id);
                        }),
                        overflowAvatar(student)
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "start",
                    children: "-"
                }),
            sortType: "none",
            isPaperColumn: true
        },
        {
            id: "lastActiveAt",
            name: "Last Active",
            render: (student)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "right",
                    color: student.status === "pre_registered" ? "danger" : "black",
                    children: student.status === "pre_registered" ? "Never" : (0, $73b0620564a5efc3$export$78ae3e68d8c394bc)(new Date(student.lastActiveAt))
                }),
            sortType: "sortBy",
            sortBy: (student)=>new Date(student.lastActiveAt).valueOf(),
            textAlign: "right",
            isPaperColumn: true
        },
        {
            id: "settings",
            name: "Actions",
            textAlign: "right",
            render: (student)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    justify: "end",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                        rightAligned: true,
                        displayType: "iconOnly",
                        color: "white",
                        iconColor: "gray7",
                        icon: "threeVerticalDots",
                        iconSize: "2em",
                        testTag: "settings",
                        inheritBgColor: true,
                        noButtonPadding: true,
                        options: [
                            {
                                ...lmsButtonProps(student),
                                children: "Edit Student",
                                to: `/t/students/${student.id}/edit-student${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                            },
                            {
                                children: "Edit Classes",
                                to: `/t/students/${student.id}/edit-classes${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                            },
                            {
                                ...lmsButtonProps(student),
                                children: "Change Password",
                                to: `/t/students/${student.id}/change-password${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                            }
                        ]
                    })
                }),
            sortType: "none",
            isPaperColumn: false
        }
    ];
    const filteredColumns = columns.filter((column)=>currentUser?.paperSyncedAt ? column.isPaperColumn : true);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)(ContentElement, {
        headerText: "Students",
        backPath: "/t/classes",
        headerActionButton: !currentUser?.paperSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            to: `/t/students/new${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
            children: "Add New Student"
        }),
        loading: loading,
        children: [
            currentUser?.paperSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "end",
                width: "100%",
                margin: `0 0 -${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]} 0`,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b4a9b2222f765970$export$88a5d3bdaa4e4ff2), {
                    showSyncStatus: true
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "filter",
                        color: "readleeBlue",
                        fill: selectedCourseId !== "all",
                        strokeWidth: 1.5,
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "select",
                        options: courseOptions,
                        value: selectedCourseId,
                        name: "courses",
                        displayType: "flat",
                        onChange: (id)=>history.replace(`/t/students?selectedCourseId=${id}`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                columns: filteredColumns,
                rows: selectedStudents,
                getRowId: (student)=>student.id,
                queryParam: "sortBy",
                rowClickable: true,
                onRowClick: (user)=>history.push(`/t/progress-monitoring/${user.id}${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        backPath: `${location.pathname}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                    })}`),
                initialSortSettings: {
                    columnId: "name",
                    sortDirection: "asc"
                },
                emptyStateContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "center",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        maxWidth: "375px",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 5
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                textAlign: "center",
                                display: "inline",
                                children: "There are currently no students assigned to this class."
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 3
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                textAlign: "center",
                                display: "inline",
                                children: 'Use the "Add New Student" button to manually add students to this class, or use the class filter above to view the students in another class.'
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 8
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 22
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/students/:id/edit-student",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7335247658ceb8c3$export$1babf9ceff205f5a), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/students/:id/change-password",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $66ba96e3c05eb587$export$a5da2e560921fb7f), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/students/new",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a281347d99db7a73$export$220877ec7a03c8ee), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/students/:id/edit-classes",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $75ed250e336f8d19$export$dd2adbbd99c89847), {})
            })
        ]
    });
};








var $g5BLJ = parcelRequire("g5BLJ");



var $g5BLJ = parcelRequire("g5BLJ");











var $g5BLJ = parcelRequire("g5BLJ");


const $005fefce7850bc4a$export$698afe153b56aac2 = "tablet";
const $005fefce7850bc4a$export$78e9c8e9276d9c86 = ()=>(0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThan: $005fefce7850bc4a$export$698afe153b56aac2
    });
const $005fefce7850bc4a$export$4c367fc78c5a8f05 = ()=>{
    const { courseAssessmentsAssigned: courseAssessmentsAssigned , selectedCourse: selectedCourse  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AssignToData, []);
    const hasCourseAssessment = (0, $g5BLJ.useMemo)(()=>courseAssessmentsAssigned.some((courseAssessmentData)=>courseAssessmentData.courseId === selectedCourse?.id && courseAssessmentData.assigned), [
        courseAssessmentsAssigned,
        selectedCourse
    ]);
    return {
        hasCourseAssessment: hasCourseAssessment
    };
};


const $30571a1c09685112$export$af7bbf6ceed412e7 = ()=>{
    const { currRegistrationAssessments: currRegistrationAssessments , updateCheckbox: updateCheckbox , updateCourseAssessment: updateCourseAssessment , updateVisibilitySettings: updateVisibilitySettings  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AssignToData, []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const { hasCourseAssessment: hasCourseAssessment  } = (0, $005fefce7850bc4a$export$4c367fc78c5a8f05)();
    const showCompactLayout = (0, $005fefce7850bc4a$export$78e9c8e9276d9c86)();
    if (!currRegistrationAssessments) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        align: "center",
        overflowY: "auto",
        height: "100%",
        margin: `0 0 ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]} 0`,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                justify: "space-between",
                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1).none}`,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                        onClick: updateCourseAssessment(createToast),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                            content: "When checked, Students will be assigned this content when they join your class",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h5",
                                color: "success",
                                children: "Assign New Students"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                        onChange: updateCourseAssessment(createToast),
                        value: hasCourseAssessment,
                        name: "assign-new",
                        testTag: "assign-courseAssessment-checkbox"
                    })
                ]
            }, "assign-new"),
            currRegistrationAssessments.map((data)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    justify: "space-between",
                    padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1).none}`,
                    testTag: `student-${data.student.id}`,
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                            onClick: updateCheckbox(data, createToast),
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h5",
                                children: data.student.displayName
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            children: [
                                data.assigned && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                    disabled: showCompactLayout,
                                    hideOnClick: true,
                                    content: data.submissionVisibility === "hidden" ? "Student will not be able to see their transcription results after they submit their assignment." : "Student will be able to view their transcription results after they submit.",
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                                        testTag: "visibility-dropdown",
                                        color: "white",
                                        displayType: "noStyles",
                                        rightAligned: true,
                                        noButtonPadding: true,
                                        options: [
                                            {
                                                onClick: updateVisibilitySettings(data, "visible", createToast),
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                            icon: "visibilityVisible"
                                                        }),
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                            horizontal: true
                                                        }),
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                            children: "Visible"
                                                        })
                                                    ]
                                                })
                                            },
                                            {
                                                onClick: updateVisibilitySettings(data, "hidden", createToast),
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                            icon: "visibilityHidden"
                                                        }),
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                            horizontal: true
                                                        }),
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                            children: "Hidden"
                                                        })
                                                    ]
                                                })
                                            }
                                        ],
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                            size: "1.25em",
                                            icon: data.submissionVisibility === "hidden" ? "visibilityHidden" : "visibilityVisible",
                                            testTag: `visibility-value-${data.submissionVisibility}`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                                    onChange: updateCheckbox(data, createToast),
                                    value: data.assigned,
                                    name: data.student.id,
                                    testTag: `assign-checkbox-${data.student.id}`
                                })
                            ]
                        })
                    ]
                }, data.student.id))
        ]
    });
};






const $559af2704fbacda4$export$8e869808dc369abd = ()=>{
    const { updateCourseAssessment: updateCourseAssessment  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AssignToData, []);
    const { hasCourseAssessment: hasCourseAssessment  } = (0, $005fefce7850bc4a$export$4c367fc78c5a8f05)();
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    return hasCourseAssessment ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        justify: "center",
        align: "center",
        direction: "column",
        grow: 1,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h4",
                color: "success",
                children: "Assigned!"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                textAlign: "center",
                children: "Students will automatically be assigned this reading as they join this class"
            })
        ]
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        justify: "center",
        align: "center",
        direction: "column",
        height: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        display: "inline",
                        textAlign: "center",
                        children: "Click"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        display: "inline",
                        onClick: updateCourseAssessment(createToast),
                        children: "Assign Class"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                display: "inline",
                textAlign: "center",
                children: "to add students automatically as they join this class"
            })
        ]
    });
};







const $6e948091528240b9$export$3bd48cc9eea1364e = ()=>{
    const { currRegistrationAssessments: currRegistrationAssessments , selectedCourse: selectedCourse , updateCourseAssessment: updateCourseAssessment , toggleAll: toggleAll  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AssignToData, []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const selectedCount = currRegistrationAssessments?.filter((registration)=>registration.assigned).size;
    const allAssigned = currRegistrationAssessments?.every((registrationAssessment)=>registrationAssessment.assigned) || false;
    const { hasCourseAssessment: hasCourseAssessment  } = (0, $005fefce7850bc4a$export$4c367fc78c5a8f05)();
    const showCompactLayout = (0, $005fefce7850bc4a$export$78e9c8e9276d9c86)();
    const showSuperCompactLayout = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "mobileLarge"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            showCompactLayout && selectedCourse && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h4",
                        children: selectedCourse?.name
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "space-between",
                align: "center",
                wrap: "wrap",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
                        children: [
                            !showSuperCompactLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                display: "inline",
                                variant: showCompactLayout ? "h5" : "h3",
                                weightOverride: "medium",
                                children: [
                                    "Assigned to",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: showCompactLayout ? "h6" : "h3",
                                weightOverride: "medium",
                                color: "primaryBlue",
                                display: "inline",
                                children: selectedCount
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: showCompactLayout ? "h6" : "h3",
                                weightOverride: "medium",
                                color: "gray6",
                                display: "inline",
                                children: [
                                    "/",
                                    currRegistrationAssessments?.size
                                ]
                            }),
                            " ",
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                display: "inline",
                                variant: showCompactLayout ? "h5" : "h3",
                                weightOverride: "medium",
                                children: showSuperCompactLayout ? "Assigned" : "students assigned"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    currRegistrationAssessments?.size ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                        onClick: toggleAll(allAssigned, createToast),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "primaryBlue",
                            weightOverride: "bold",
                            children: allAssigned ? "Unassign All" : "Assign All"
                        })
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                        onClick: updateCourseAssessment(createToast),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "primaryBlue",
                            weightOverride: "bold",
                            children: hasCourseAssessment ? "Unassign Class" : "Assign Class"
                        })
                    })
                ]
            })
        ]
    });
};









const $36a3c14c6917cb69$var$SelectionCard = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "RightContent__SelectionCard",
    componentId: "sc-1ybcc6o-0"
})([
    "background:",
    ";width:100%;border-radius:",
    ";@media (min-width:",
    "px){padding:",
    ";width:45%;}"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], (0, $005fefce7850bc4a$export$698afe153b56aac2), (0, $8259eb090983b778$export$ea413736286a3bf1)[3]);
const $36a3c14c6917cb69$export$11dbab4b39f15d6b = ()=>{
    const { error: error , saving: saving , saved: saved , currRegistrationAssessments: currRegistrationAssessments , selectedCourse: selectedCourse , assessmentId: assessmentId = "" , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            error: s.AssignToData.error,
            saving: s.AssignToData.saving,
            saved: s.AssignToData.saved,
            currRegistrationAssessments: s.AssignToData.currRegistrationAssessments,
            selectedCourse: s.AssignToData.selectedCourse,
            assessmentId: s.AssignToData.assessmentId,
            currentUser: s.AppData.currentUser
        }), []);
    const showCompactLayout = (0, $005fefce7850bc4a$export$78e9c8e9276d9c86)();
    const showSuperCompactLayout = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "mobileSmall"
    });
    const getSavingText = ()=>{
        if (error) return "There was an error. Please try again.";
        if (saved) return "Changes Saved";
        return saving ? "Saving..." : "";
    };
    if (selectedCourse && assessmentId) {
        const assignUrl = `${(0, $0fe4eaef81db718a$export$625c2ae8ba020e36)}/a${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
            assessmentId: assessmentId,
            courseId: selectedCourse.id,
            courseCode: selectedCourse.courseCode
        })}`;
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($36a3c14c6917cb69$var$SelectionCard, {
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                height: "100%",
                width: "100%",
                padding: showCompactLayout ? (0, $8259eb090983b778$export$ea413736286a3bf1)[2] : (0, $8259eb090983b778$export$ea413736286a3bf1)[5],
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e948091528240b9$export$3bd48cc9eea1364e), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    !currentUser?.paperSyncedAt && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        wrap: "wrap",
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$b04be29aa201d4f5), {
                                        children: "Share with Class"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                        content: "Students who use the link will be taken directly to this assignment in Readlee."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                                        kind: "link",
                                        copyContent: assignUrl,
                                        displayType: "link",
                                        color: "primaryBlue",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            weightOverride: "bold",
                                            children: "Copy Link"
                                        })
                                    }),
                                    selectedCourse.googleId && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 2
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                weightOverride: "bold",
                                                children: "OR"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 2
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f68db7b49184ba1f$export$d4f0dafeee17594b), {
                                                googleCourseId: selectedCourse.googleId,
                                                url: assignUrl
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                        color: "#CECECE",
                        size: 1
                    }),
                    currRegistrationAssessments?.size ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $30571a1c09685112$export$af7bbf6ceed412e7), {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $559af2704fbacda4$export$8e869808dc369abd), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                    !saving && !saved ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        color: error ? "danger" : "gray7",
                        children: getSavingText()
                    })
                ]
            })
        });
    } else if (!showSuperCompactLayout) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($36a3c14c6917cb69$var$SelectionCard, {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            align: "center",
            justify: "center",
            height: "100%",
            padding: showCompactLayout ? (0, $8259eb090983b778$export$ea413736286a3bf1)[2] : (0, $8259eb090983b778$export$ea413736286a3bf1)[5],
            children: [
                !showCompactLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($49d03094e08c7e41$exports)))
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "center",
                    variant: showCompactLayout ? "h4" : "h1",
                    children: "Select a class"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray6",
                    variant: "largeText",
                    textAlign: "center",
                    children: "Choose a class from the left to assign this task to your students"
                })
            ]
        })
    });
    return null;
};








const $c139552c3b8d5101$var$ClassButton = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CourseSelector__ClassButton",
    componentId: "sc-185r7l0-0"
})([
    "background:",
    ";opacity:",
    "%;cursor:pointer;margin-bottom:",
    ";border:none;flex:1;border-radius:",
    ";padding:",
    ";@media (min-width:",
    "px){padding:",
    ";width:300px;}"
], ({ $selected: $selected  })=>$selected ? (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex : (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, ({ $selected: $selected , $showCompactLayout: $showCompactLayout  })=>$selected || !$showCompactLayout ? 100 : 60, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $005fefce7850bc4a$export$698afe153b56aac2), (0, $8259eb090983b778$export$ea413736286a3bf1)[3]);
const $c139552c3b8d5101$export$9ba3e4dae3593fc0 = ()=>{
    const { courses: courses , courseRegistrationAssessments: courseRegistrationAssessments , courseAssessmentsAssigned: courseAssessmentsAssigned , selectedCourse: selectedCourse , setSelectedCourse: setSelectedCourse , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            courses: s.AssignToData.courses,
            courseRegistrationAssessments: s.AssignToData.courseRegistrationAssessments,
            courseAssessmentsAssigned: s.AssignToData.courseAssessmentsAssigned,
            selectedCourse: s.AssignToData.selectedCourse,
            setSelectedCourse: s.AssignToData.setSelectedCourse,
            currentUser: s.AppData.currentUser
        }), []);
    const showCompactLayout = (0, $005fefce7850bc4a$export$78e9c8e9276d9c86)();
    const getAssignedText = (courseId)=>{
        const students = courseRegistrationAssessments.get(courseId);
        const assignedCount = students?.filter((student)=>student.assigned).size;
        const currentCourseHasCourseAssessment = courseAssessmentsAssigned.some((courseAssessmentData)=>courseAssessmentData.courseId === courseId && courseAssessmentData.assigned);
        if (currentCourseHasCourseAssessment && assignedCount === students?.size) return "Assigned to Class";
        return assignedCount !== 0 || currentCourseHasCourseAssessment ? `Assigned ${assignedCount}/${students?.size}` : "Unassigned";
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        overflowY: "auto",
        shrink: 0,
        width: showCompactLayout && !selectedCourse ? "55%" : "auto",
        maxWidth: "300px",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "stretch",
                overflowY: "auto",
                children: [
                    courses.map((course)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                            onClick: ()=>setSelectedCourse(course),
                            testTag: `assign-modal-list-${course.id}`,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c139552c3b8d5101$var$ClassButton, {
                                $selected: course.id === selectedCourse?.id,
                                $showCompactLayout: showCompactLayout,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    justify: "space-between",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15861ad172906a95$export$d0fa4d83f877a210), {
                                                    size: "large",
                                                    backgroundColor: course.avatarColor,
                                                    name: course.name,
                                                    disabledTooltip: true
                                                }),
                                                !showCompactLayout || !selectedCourse ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                            horizontal: true,
                                                            size: 2
                                                        }),
                                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                            direction: "column",
                                                            children: [
                                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                                    variant: "h5",
                                                                    wordBreak: showCompactLayout ? "break-word" : "normal",
                                                                    children: course.name
                                                                }),
                                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                                    variant: "h6",
                                                                    weightOverride: "medium",
                                                                    color: "gray6",
                                                                    children: getAssignedText(course.id)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : null
                                            ]
                                        }),
                                        !showCompactLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                            icon: "arrowRight",
                                            color: "gray5",
                                            size: "1.5em",
                                            flexShrink: 0
                                        })
                                    ]
                                })
                            })
                        }, course.id)),
                    showCompactLayout && selectedCourse && !currentUser?.paperSyncedAt ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9eb4c76372bd8ce8$export$e3b3c301f3d5fc3d), {
                                        to: "/t/classes/new",
                                        size: "large",
                                        radiusType: "mostlyRound",
                                        testTag: "avatar-plus-button"
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            (!showCompactLayout || !selectedCourse) && !currentUser?.paperSyncedAt ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "outline",
                        to: "/t/classes/new",
                        children: "Create New Class"
                    })
                ]
            }) : null
        ]
    });
};


const $2e8ec3dcad793a80$var$MAX_TITLE_LENGTH = 40;
const $2e8ec3dcad793a80$export$f6fbd0397182c331 = ({ closedPath: closedPath , openedPath: openedPath , preserveQuery: preserveQuery = false , onClose: onClose  })=>{
    const { loading: loading , isSyncing: isSyncing , title: title , courses: courses , load: load , setField: setField , isPaperUser: isPaperUser , paperRosterAutoSyncCount: paperRosterAutoSyncCount , paperRosterManualSyncCount: paperRosterManualSyncCount  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            loading: s.AssignToData.loading,
            title: s.AssignToData.title,
            courses: s.AssignToData.courses,
            load: s.AssignToData.load,
            setField: s.AssignToData.setField,
            isSyncing: s.PaperSyncData.getIsSyncing(),
            isPaperUser: Boolean(s.AppData.currentUser?.paperSyncedAt),
            paperRosterAutoSyncCount: s.AppData.currentUser?.paperRosterAutoSyncCount || 0,
            paperRosterManualSyncCount: s.AppData.currentUser?.paperRosterManualSyncCount || 0
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const assessmentId = query.get("assessmentId");
    const courseId = query.get("selectedCourseId") || "";
    (0, $g5BLJ.useEffect)(()=>{
        assessmentId && load({
            assessmentId: assessmentId,
            courseId: courseId
        });
    }, [
        load,
        assessmentId,
        courseId
    ]);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const closeModal = (0, $g5BLJ.useCallback)(()=>{
        setField("selectedCourse")(null);
        onClose?.();
        history.replace(`${closedPath}${preserveQuery ? (0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query) : ""}`);
    }, [
        closedPath,
        history,
        preserveQuery,
        query,
        onClose,
        setField
    ]);
    const syncCount = paperRosterAutoSyncCount + paperRosterManualSyncCount;
    const getPaperEmptyState = ()=>{
        if (isSyncing) return "classesPaperSyncing";
        return syncCount > 0 ? "noClassesPaper" : "classesPaper";
    };
    const modalContent = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            isPaperUser && courses.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
                    kind: getPaperEmptyState()
                })
            }),
            !isPaperUser && courses.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
                    kind: "assignToClasses"
                })
            }),
            !courses.isEmpty() && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                minHeight: "300px",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c139552c3b8d5101$export$9ba3e4dae3593fc0), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $36a3c14c6917cb69$export$11dbab4b39f15d6b), {})
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: `Assign "${(0, $e6116bf527c207db$export$c8cfcdb41be1b46c)(title, $2e8ec3dcad793a80$var$MAX_TITLE_LENGTH)}" to a selected class`,
        openedPath: openedPath,
        close: closeModal,
        openType: "path",
        testTag: "assign-to-modal",
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true
        }) : modalContent
    });
};












var $g5BLJ = parcelRequire("g5BLJ");





const $ba33eea4285d55d4$var$assessmentStatusWordToggleOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        value: "active",
        label: "Active"
    },
    {
        value: "archived",
        label: "Archived"
    }
]);
const $ba33eea4285d55d4$export$96f5005e323ee05e = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const statusFilter = query.get("assessmentStatusFilter") || "active";
    const updateAssessmentStatusFilter = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            assessmentStatusFilter: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
        padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]}`,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            justify: showMobile ? "center" : "space-between",
            align: "center",
            wrap: "wrap",
            padding: `${showMobile ? (0, $8259eb090983b778$export$ea413736286a3bf1)[5] : (0, $8259eb090983b778$export$ea413736286a3bf1)[7]} 0`,
            margin: `-${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    margin: showMobile ? `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0` : `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[8]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h2",
                        color: "white",
                        textAlign: "center",
                        children: "Assignments"
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "end",
                    margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c92f83b3ac011911$export$567332ab922d2ec6), {
                        onChange: updateAssessmentStatusFilter,
                        value: statusFilter,
                        options: $ba33eea4285d55d4$var$assessmentStatusWordToggleOptions,
                        showMobile: showMobile
                    })
                })
            ]
        })
    });
};



var $g5BLJ = parcelRequire("g5BLJ");



const $4d50e01c6781e4b0$export$bbf08c6edc8d3b8 = ()=>{
    const { courseMap: courseMap , assessmentMap: assessmentMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherAssignmentListData, []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const sortByParam = query.get("sortBy") || "desc";
    const assessmentStatusFilterParam = query.get("assessmentStatusFilter") || "active";
    const filterAndSortAssessmentList = (0, $g5BLJ.useCallback)((assessmentList)=>{
        const filtered = assessmentList.filter(({ assessment: { status: status  }  })=>status === assessmentStatusFilterParam);
        if (sortByParam === "alphAsc" || sortByParam === "alphDesc") return (0, $d5a1fd3dea1a0ab6$export$27a1cb209e3caa11)(sortByParam === "alphAsc", filtered.sortBy((details)=>details.assessment.name));
        else return (0, $d5a1fd3dea1a0ab6$export$27a1cb209e3caa11)(sortByParam === "desc", filtered.sortBy((details)=>Date.parse(details.assessment.createdAt)));
    }, [
        sortByParam,
        assessmentStatusFilterParam
    ]);
    return (0, $g5BLJ.useMemo)(()=>{
        const assessmentList = assessmentMap.toList();
        return courseMap.map((course)=>filterAndSortAssessmentList(assessmentList.filter(({ courseIds: courseIds  })=>courseIds.includes(course.id)))).set("all", filterAndSortAssessmentList(assessmentList));
    }, [
        courseMap,
        assessmentMap,
        filterAndSortAssessmentList
    ]);
};
const $4d50e01c6781e4b0$var$ADD_CLASS_TAB = {
    id: "add-new",
    name: "Add Class +",
    to: "/t/classes/new",
    onlyClick: true
};
const $4d50e01c6781e4b0$export$5585eed89133d2ac = ()=>{
    const { courseMap: courseMap , isPaperUser: isPaperUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            courseMap: s.TeacherAssignmentListData.courseMap,
            isPaperUser: Boolean(s.AppData.currentUser?.paperSyncedAt)
        }), []);
    const courseIdToAssessmentListMap = $4d50e01c6781e4b0$export$bbf08c6edc8d3b8();
    return (0, $g5BLJ.useMemo)(()=>{
        const map = courseMap.toList().map(({ id: id , name: name  })=>({
                id: id,
                name: name,
                count: courseIdToAssessmentListMap.get(id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).size
            })).unshift({
            id: "all",
            name: "All",
            count: courseIdToAssessmentListMap.get("all", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).size
        });
        return isPaperUser ? map : map.push($4d50e01c6781e4b0$var$ADD_CLASS_TAB);
    }, [
        courseIdToAssessmentListMap,
        courseMap,
        isPaperUser
    ]);
};




var $g5BLJ = parcelRequire("g5BLJ");





const $516ca276bdef158a$export$b2de5102d893289e = ({ onSuccess: onSuccess  })=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const { confirmUpdateAssignmentStatus: confirmUpdateAssignmentStatus , opened: opened , action: action , getActionName: getActionName , setField: setField , assessment: assessment , openStatusUpdateModal: openStatusUpdateModal , confirmDeleteText: confirmDeleteText  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ UpdateAssignmentStatusModalData: s  })=>({
            confirmUpdateAssignmentStatus: s.confirmUpdateAssignmentStatus,
            opened: s.opened,
            action: s.action,
            getActionName: s.getActionName,
            setField: s.setField,
            assessment: s.assessment,
            openStatusUpdateModal: s.openStatusUpdateModal,
            confirmDeleteText: s.confirmDeleteText
        }), []);
    const actionName = getActionName();
    const close = (0, $g5BLJ.useCallback)(()=>setField("opened")(false), [
        setField
    ]);
    if (!assessment) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: opened,
        header: "Are you sure?",
        close: close,
        testTag: "update-status-modal",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "primaryBlue",
                    displayType: "link",
                    inheritBgColor: true,
                    onClick: close,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    type: "submit",
                    onClick: confirmUpdateAssignmentStatus(history, createToast, onSuccess),
                    color: action === "delete" ? "danger" : undefined,
                    disabled: action === "delete" && confirmDeleteText.trim() !== assessment.name.trim(),
                    children: (0, $e6116bf527c207db$export$9a00dee1beb8f576)(actionName)
                })
            ]
        }),
        children: action === "toggleArchive" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: [
                        "Are you sure you want to ",
                        actionName,
                        " this assignment?"
                    ]
                }),
                actionName === "archive" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            color: "primaryBlue",
                            displayType: "link",
                            inheritBgColor: true,
                            onClick: ()=>openStatusUpdateModal(assessment, "delete"),
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                            children: "Delete Assignment Instead?"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: [
                        "This will delete the assignment ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("em", {
                            children: assessment.name
                        }),
                        " from all your classes, graphs, submissions, etc."
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                assessment.status !== "archived" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            color: "primaryBlue",
                            displayType: "link",
                            inheritBgColor: true,
                            onClick: ()=>openStatusUpdateModal(assessment, "toggleArchive"),
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                            children: "Archive Assignment Instead?"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f8129efc3cc4d35c$export$f5b8910cec6cf069), {
                    name: "Confirm Delete Assignment",
                    placeholder: "Type the assignment name to confirm",
                    value: confirmDeleteText,
                    onChange: (text)=>setField("confirmDeleteText")(text)
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


const $ec1a16ba48052160$export$3a7541004f18f50c = ()=>{
    const { sharingEmail: sharingEmail , submitting: submitting , sharingErrors: sharingErrors , submitShare: submitShare , setField: setField , opened: opened  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.ShareModalData, []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const close = (0, $g5BLJ.useCallback)(()=>setField("opened")(false), [
        setField
    ]);
    if (!opened) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        testTag: "share",
        openType: "state",
        opened: opened,
        header: "Share With Teacher",
        close: close,
        onSubmit: submitShare(createToast),
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: close,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    loading: submitting,
                    type: "submit",
                    children: "Share"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Sharing sends other teachers a copy of your assignment to use with their own students."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "email",
                label: "Teacher Email",
                errors: sharingErrors,
                value: sharingEmail,
                onChange: setField("sharingEmail")
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $acaf5d97e00bcd9f$export$9f25cea84f01c4af = ()=>{
    const { duplicatingName: duplicatingName , submitting: submitting , duplicatingErrors: duplicatingErrors , submitDuplicate: submitDuplicate , setField: setField , opened: opened  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.DuplicateModalData, []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const close = (0, $g5BLJ.useCallback)(()=>setField("opened")(false), [
        setField
    ]);
    if (!opened) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        testTag: "duplicate",
        openType: "state",
        opened: opened,
        header: "Duplicate Assignment",
        close: close,
        onSubmit: submitDuplicate(createToast, history),
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: close,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    loading: submitting,
                    type: "submit",
                    children: "Duplicate"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Create a copy of this assignment. Student submissions will not be copied."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "name",
                testTag: "duplicate-input",
                label: "New Assignment Name",
                errors: duplicatingErrors,
                value: duplicatingName,
                onChange: setField("duplicatingName")
            })
        ]
    });
};




const $81a0282c82c60f2f$var$emptyStateKind = (filter, isPaperUser)=>filter === "active" ? isPaperUser ? "assignmentsPaper" : "assignments" : "archivedAssignments";
const $81a0282c82c60f2f$var$sortOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        value: "desc",
        label: "Newest"
    },
    {
        value: "asc",
        label: "Oldest"
    },
    {
        value: "alphDesc",
        label: "A-Z"
    },
    {
        value: "alphAsc",
        label: "Z-A"
    }
]);
const $81a0282c82c60f2f$var$Assignments = ({ selectedCourseId: selectedCourseId , statusFilter: statusFilter  })=>{
    const { courseMap: courseMap , openAssignmentCardSet: openAssignmentCardSet , toggleAssignmentCardOpen: toggleAssignmentCardOpen , search: search  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherAssignmentListData, []);
    const courseIdToAssessmentListMap = (0, $4d50e01c6781e4b0$export$bbf08c6edc8d3b8)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const assessmentList = (0, $d5a1fd3dea1a0ab6$export$e3340ddcfe22553f)(search, courseIdToAssessmentListMap.get(selectedCourseId, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()), (ad)=>ad.assessment.name);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        height: "100%",
        direction: "column",
        align: "center",
        children: [
            assessmentList.map((assignmentDetails)=>{
                const { assessment: assessment , coverImageUrl: coverImageUrl , courseIds: courseIds , primaryLicenseType: primaryLicenseType , readingName: readingName  } = assignmentDetails;
                const metrics = (0, $62e5f0fd429b4502$export$171369378300601)(assignmentDetails);
                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a679044e49a453d7$export$81dfe1808f15259c), {
                    assessment: assessment,
                    courseIds: courseIds,
                    courseMap: courseMap,
                    canAssign: statusFilter !== "archived",
                    to: `/t/assignments/${assessment.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                        backPath: `/t/assignments${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                        selectedClass: selectedCourseId
                    }))}`,
                    open: openAssignmentCardSet.has(assessment.id),
                    onToggleCardOpen: ()=>toggleAssignmentCardOpen(assessment.id),
                    coverImg: coverImageUrl,
                    metrics: metrics,
                    assignToPath: `/t/assignments/assign${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                        assessmentId: assessment.id
                    })}`,
                    hideShare: primaryLicenseType === "open_source",
                    readingName: readingName
                }, assessment.id);
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 20
            })
        ]
    });
};
const $81a0282c82c60f2f$export$aa9f939ec92d7b12 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { search: search , setField: setField , loading: loading , load: load , updateAssessments: updateAssessments , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            search: state.TeacherAssignmentListData.search,
            setField: state.TeacherAssignmentListData.setField,
            loading: state.TeacherAssignmentListData.loading,
            load: state.TeacherAssignmentListData.load,
            updateAssessments: state.TeacherAssignmentListData.updateAssessments,
            currentUser: state.AppData.currentUser
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        load(history, pathname);
    }, [
        load,
        history,
        pathname
    ]);
    const selectedCourseId = query.get("selectedCourseId") || "all";
    const assessmentStatusFilterParam = query.get("assessmentStatusFilter") || "active";
    const sortByParam = query.get("sortBy") || "desc";
    const updateSortBy = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            sortBy: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const courseIdToAssessmentListMap = (0, $4d50e01c6781e4b0$export$bbf08c6edc8d3b8)();
    const courseTabs = (0, $4d50e01c6781e4b0$export$5585eed89133d2ac)();
    const showMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "mobileLarge"
    });
    const showTablet = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                height: "100%",
                minWidth: 0,
                minHeight: 0,
                direction: "column",
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
                overflowY: "auto",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ba33eea4285d55d4$export$96f5005e323ee05e), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                        minWidth: 0,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                minWidth: 0,
                                maxWidth: "100%",
                                justify: "center",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e3aa8aeb4209bd7$export$44c45b2b7f09d2a6), {
                                    skeumorphic: true,
                                    queryParam: "selectedCourseId",
                                    tabs: courseTabs
                                })
                            }),
                            showMobile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                        minHeight: 0,
                        height: "100%",
                        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
                        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                            flex: true,
                            kind: "boat"
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
                            children: courseIdToAssessmentListMap.get(selectedCourseId, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).isEmpty() ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                width: "100%",
                                height: "100%",
                                direction: "column",
                                align: "center",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
                                    kind: $81a0282c82c60f2f$var$emptyStateKind(assessmentStatusFilterParam, Boolean(currentUser?.paperSyncedAt))
                                })
                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        justify: "space-between",
                                        align: "center",
                                        height: showTablet ? "auto" : "60px",
                                        direction: showTablet ? "column-reverse" : "row",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                justify: "start",
                                                align: "center",
                                                margin: showTablet ? `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[3]} 0 0 0` : `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4]} 0`,
                                                width: "100%",
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                        display: "inline",
                                                        color: "gray6",
                                                        children: "Sort By:"
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        horizontal: true
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                                                        id: "sortBySelect",
                                                        displayType: "flat",
                                                        name: "Sort Assessments By",
                                                        value: sortByParam,
                                                        onChange: updateSortBy,
                                                        options: $81a0282c82c60f2f$var$sortOptions
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2511447d0cb3d32$export$55d7609a8f1eccd2), {
                                                value: search,
                                                onChange: setField("search"),
                                                placeholder: "Search Assignments",
                                                displayType: showTablet ? "large" : "normal"
                                            }),
                                            showTablet && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                size: 3
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($81a0282c82c60f2f$var$Assignments, {
                                        selectedCourseId: selectedCourseId,
                                        statusFilter: assessmentStatusFilterParam
                                    })
                                ]
                            })
                        })
                    }),
                    currentUser?.paperId && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eb30321ced29024b$export$a06f1c675e846f6f), {
                        accountType: "teacher"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2e8ec3dcad793a80$export$f6fbd0397182c331), {
                openedPath: "/t/assignments/assign",
                closedPath: "/t/assignments",
                onClose: ()=>load(history, pathname),
                preserveQuery: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $516ca276bdef158a$export$b2de5102d893289e), {
                onSuccess: updateAssessments
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $822922ed63c79903$export$1a6938bd84cc541a), {
                onSuccess: updateAssessments
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ec1a16ba48052160$export$3a7541004f18f50c), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaf5d97e00bcd9f$export$9f25cea84f01c4af), {})
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");













const $b8a3307ba6f0f480$export$90d8f29463c659f0 = ()=>{
    const { submitting: submitting , reassigning: reassigning , submitReassign: submitReassign , reassigningName: reassigningName , reassigningErrors: reassigningErrors , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ TeacherAssignmentOverviewData: taod  })=>({
            submitting: taod.submitting,
            reassigning: taod.reassigning,
            submitReassign: taod.submitReassign,
            reassigningName: taod.reassigningName,
            reassigningErrors: taod.reassigningErrors,
            setField: taod.setField
        }), []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const close = ()=>setField("reassigning")(false);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        testTag: "reassign",
        openType: "state",
        opened: reassigning,
        header: "Reassign Assignment",
        close: close,
        onSubmit: submitReassign({
            history: history,
            createToast: createToast
        }),
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: close,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    loading: submitting,
                    type: "submit",
                    children: "Reassign"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "This will create a copy of this assignment, and automatically reassign ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("strong", {
                        children: "ALL"
                    }),
                    " ",
                    "the currently assigned students."
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                testTag: "reassign-input",
                name: "name",
                label: "New Assignment Name",
                errors: reassigningErrors,
                value: reassigningName,
                onChange: setField("reassigningName")
            })
        ]
    });
};





const $438c2fba1c8fa207$export$35193a8a641bb1b = ({ data: data , filename: filename , fetchJson: fetchJson  })=>()=>{
        const date = new Date();
        fetchJson(`/api/csv/create_csv`, {
            method: "POST",
            data: {
                data: data,
                name: `${filename}-${(0, $73b0620564a5efc3$export$bfe4ac50319c1d9b)(date)}`
            },
            onSuccess: (data)=>{
                window.location.href = data.url;
            }
        });
    };





var $g5BLJ = parcelRequire("g5BLJ");









const $de2ffa87b5a3a4b8$var$Empty = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        color: "gray5",
        testTag: "empty",
        children: "-"
    });
const $de2ffa87b5a3a4b8$var$EmptyAssignedStudents = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        height: "100%",
        width: "100%",
        justify: "center",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
            kind: "assignedStudents"
        })
    });
const $de2ffa87b5a3a4b8$var$getSubmissionSecondaryText = (submission, accountType)=>{
    if (accountType !== "student") return "Teacher Submission";
    if (!submission) return "";
    if (submission.status === "waiting") return "Not yet started";
    if (submission.status === "finished") return "Submitted";
    return `${(0, $e6116bf527c207db$export$9a00dee1beb8f576)(submission.status)}`;
};
const $de2ffa87b5a3a4b8$var$renderStat = ({ userId: userId , key: key , style: style , submissionMap: submissionMap  })=>{
    const submission = submissionMap.get(userId);
    if (!submission || submission.status === "waiting") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($de2ffa87b5a3a4b8$var$Empty, {});
    const value = submission[key];
    if (key === "rating" && typeof value === "number") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $aebf6eac7f74b94e$export$76529f19140ac2e7), {
        rating: value,
        borderColor: "black"
    });
    else if (typeof value === "number" && style) return (0, $3e76d4bc3268f884$export$252ba770fa56b422)(style, value);
    else if (typeof value === "string") return (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(value));
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($de2ffa87b5a3a4b8$var$Empty, {});
};
const $de2ffa87b5a3a4b8$export$98b14d297b92183b = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { assessmentDetail: assessmentDetail , submissionMap: submissionMap , userMap: userMap , courseToStudentIdsMap: courseToStudentIdsMap , taskCompletionMap: taskCompletionMap , commentMap: commentMap , openDeleteSubmissionModal: openDeleteSubmissionModal  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ TeacherAssignmentOverviewData: taod  })=>({
            assessmentDetail: taod.assessmentDetail,
            submissionMap: taod.submissionMap,
            userMap: taod.userMap,
            courseToStudentIdsMap: taod.courseToStudentIdsMap,
            taskCompletionMap: taod.taskCompletionMap,
            commentMap: taod.commentMap,
            openDeleteSubmissionModal: taod.openDeleteSubmissionModal
        }), []);
    const selectedClassParam = query.get("selectedClass") || "all";
    const filteredRows = (0, $g5BLJ.useMemo)(()=>userMap.toList().filter((u)=>{
            if (u.accountType !== "student" && !submissionMap.has(u.id)) return false;
            if (selectedClassParam === "teachers") return u.accountType !== "student";
            return selectedClassParam === "all" || courseToStudentIdsMap.get(selectedClassParam, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).includes(u.id);
        }), [
        courseToStudentIdsMap,
        selectedClassParam,
        userMap,
        submissionMap
    ]);
    const [rows, teacherRows] = (0, $g5BLJ.useMemo)(()=>(0, $d5a1fd3dea1a0ab6$export$b29f828819edca8d)(filteredRows, (u)=>u.accountType === "student"), [
        filteredRows
    ]);
    const getRowId = (0, $g5BLJ.useCallback)((user)=>user.id, []);
    const renderName = (0, $g5BLJ.useCallback)((user)=>{
        const submission = submissionMap.get(user.id);
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
            testTag: "submission-user-name",
            avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                name: user.displayName,
                backgroundColor: user.avatarColor || (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex
            }),
            primaryText: (0, $75cd274e63beb59b$export$61b6a526e2f145be)(user),
            textColor: submission && submission?.status !== "waiting" ? "black" : "gray5",
            secondaryText: $de2ffa87b5a3a4b8$var$getSubmissionSecondaryText(submission, user.accountType)
        });
    }, [
        submissionMap
    ]);
    const renderFeedback = (0, $g5BLJ.useCallback)((user)=>{
        const submission = submissionMap.get(user.id);
        const comments = commentMap.get(submission?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
        const viewedComments = comments.filter((c)=>c.viewed);
        const allViewed = viewedComments.size >= comments.size;
        if (!submission || comments.isEmpty()) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
            content: "No feedback was sent to this student.",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($de2ffa87b5a3a4b8$var$Empty, {})
        });
        const icon = allViewed ? "feedbackViewed" : "feedbackGiven";
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
            content: `${viewedComments.size}/${comments.size} comments viewed`,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                icon: icon,
                color: allViewed ? "success" : "black",
                size: "1.75em",
                testTag: `feedback-icon-${allViewed ? "feedbackViewed" : "feedbackGiven"}`
            })
        });
    }, [
        commentMap,
        submissionMap
    ]);
    const sortByComments = (0, $g5BLJ.useCallback)((user)=>{
        const submission = submissionMap.get(user.id);
        const comments = commentMap.get(submission?.id || "", (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
        const viewedComments = comments.filter((c)=>c.viewed);
        if (comments.isEmpty()) return 0;
        if (viewedComments.size < comments.size) return 1;
        if (viewedComments.size === comments.size) return 2;
        return -1;
    }, [
        commentMap,
        submissionMap
    ]);
    const sortByNumber = (0, $g5BLJ.useCallback)((key)=>({ id: id  })=>{
            const submission = submissionMap.get(id);
            if (!submission || submission.status === "waiting") return -1;
            if (key === "rating" && submission[key] === null) return -1;
            return submission[key] ?? -1;
        }, [
        submissionMap
    ]);
    const renderPercentRead = (0, $g5BLJ.useCallback)((user)=>$de2ffa87b5a3a4b8$var$renderStat({
            userId: user.id,
            key: "percentRead",
            style: (0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion,
            submissionMap: submissionMap
        }), [
        submissionMap
    ]);
    const percentReadColumn = (0, $g5BLJ.useMemo)(()=>({
            id: "percentRead",
            name: "% Read",
            render: renderPercentRead,
            sortType: "sortBy",
            sortBy: sortByNumber("percentRead")
        }), [
        renderPercentRead,
        sortByNumber
    ]);
    const commentsColumn = (0, $g5BLJ.useMemo)(()=>({
            id: "feedback",
            name: "Feedback",
            render: renderFeedback,
            sortType: "sortBy",
            sortBy: sortByComments
        }), [
        renderFeedback,
        sortByComments
    ]);
    const columns = [
        {
            id: "name",
            name: "Name",
            render: renderName,
            sortType: "sortBy",
            sortBy: (0, $75cd274e63beb59b$export$61b6a526e2f145be)
        },
        ...commentMap.isEmpty() ? [] : [
            commentsColumn
        ],
        {
            id: "rating",
            name: "Student Interest",
            tooltipContent: 'Student response to "How interesting was the reading?"',
            render: (0, $g5BLJ.useCallback)(({ id: id  })=>$de2ffa87b5a3a4b8$var$renderStat({
                    userId: id,
                    key: "rating",
                    submissionMap: submissionMap
                }), [
                submissionMap
            ]),
            sortType: "sortBy",
            sortBy: sortByNumber("rating")
        },
        ...assessmentDetail?.assessment.independentOnly ? [] : [
            percentReadColumn
        ],
        {
            id: "wcpm",
            name: assessmentDetail?.assessment.independentOnly ? "(WPM)" : "WCPM",
            tooltipContent: assessmentDetail?.assessment.independentOnly ? "Words Per Minute" : "Words Correct Per Minute",
            render: (0, $g5BLJ.useCallback)(({ id: id  })=>$de2ffa87b5a3a4b8$var$renderStat({
                    userId: id,
                    key: "wcpm",
                    style: assessmentDetail?.assessment.independentOnly ? (0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wpm : (0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm,
                    submissionMap: submissionMap
                }), [
                submissionMap,
                assessmentDetail
            ]),
            sortType: "sortBy",
            sortBy: sortByNumber("wcpm")
        },
        {
            id: "total_words",
            name: "Words",
            render: (0, $g5BLJ.useCallback)(({ id: id  })=>$de2ffa87b5a3a4b8$var$renderStat({
                    userId: id,
                    key: "totalWords",
                    style: (0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words,
                    submissionMap: submissionMap
                }), [
                submissionMap
            ]),
            sortType: "sortBy",
            sortBy: sortByNumber("totalWords")
        },
        {
            id: "time_read",
            name: "Time",
            render: (0, $g5BLJ.useCallback)(({ id: id  })=>$de2ffa87b5a3a4b8$var$renderStat({
                    userId: id,
                    key: "timeRead",
                    style: (0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken,
                    submissionMap: submissionMap
                }), [
                submissionMap
            ]),
            sortType: "sortBy",
            sortBy: sortByNumber("timeRead")
        },
        {
            id: "tasks",
            name: "Tasks",
            render: (0, $g5BLJ.useCallback)(({ id: id  })=>{
                const studentTasks = taskCompletionMap.get(id);
                return studentTasks ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: [
                        studentTasks.completed,
                        " / ",
                        studentTasks.total
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($de2ffa87b5a3a4b8$var$Empty, {});
            }, [
                taskCompletionMap
            ]),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (0, $g5BLJ.useCallback)(({ id: id  })=>taskCompletionMap.get(id)?.completed ?? 0, [
                taskCompletionMap
            ])
        },
        {
            id: "submission_date",
            name: "Date",
            render: (0, $g5BLJ.useCallback)(({ id: id  })=>$de2ffa87b5a3a4b8$var$renderStat({
                    userId: id,
                    key: "finishedAt",
                    submissionMap: submissionMap
                }), [
                submissionMap
            ]),
            sortType: "sortBy",
            sortBy: (0, $g5BLJ.useCallback)(({ id: id  })=>new Date(submissionMap.get(id, {
                    finishedAt: 1
                }).finishedAt).valueOf(), [
                submissionMap
            ])
        },
        {
            id: "actions",
            name: "Actions",
            render: (student)=>{
                const submission = submissionMap.get(student.id);
                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    justify: "end",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                        rightAligned: true,
                        displayType: "iconOnly",
                        color: "white",
                        iconColor: "gray7",
                        icon: "threeVerticalDots",
                        testTag: "submission-settings",
                        inheritBgColor: true,
                        noButtonPadding: true,
                        options: [
                            {
                                children: "Delete Submission",
                                onClick: ()=>submission && openDeleteSubmissionModal(student, submission),
                                disabled: !submission,
                                color: "danger"
                            }
                        ]
                    })
                });
            },
            sortType: "none"
        }
    ];
    return {
        rows: rows,
        teacherRows: teacherRows,
        columns: columns,
        getRowId: getRowId
    };
};
const $de2ffa87b5a3a4b8$export$e9bfb03f5fea5564 = ({ assessment: assessment , rows: rows , teacherRows: teacherRows , columns: columns , getRowId: getRowId , submissionMap: submissionMap  })=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                columns: columns,
                rows: rows,
                getRowId: getRowId,
                rowClickable: ({ id: id  })=>Boolean(submissionMap.get(id, {
                        id: null
                    }).id),
                queryParam: "sortBy",
                onRowClick: ({ id: id  })=>{
                    const submissionId = submissionMap.get(id, {
                        id: null
                    }).id;
                    if (!id) return;
                    const backPath = `/t/assignments/${assessment.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`;
                    history.push(`/submissions/${submissionId}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                        backPath: backPath
                    }))}`);
                },
                fixedTopRows: teacherRows,
                emptyStateContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($de2ffa87b5a3a4b8$var$EmptyAssignedStudents, {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 22
            })
        ]
    });
};








const $6f84dc064809121e$export$38d0d292406cc6eb = ()=>{
    const { assessmentDetail: assessmentDetail , taskDetailsMap: taskDetailsMap , studentToTaskSubmissionDetailsMap: studentToTaskSubmissionDetailsMap , userMap: userMap , openTaskCardSet: openTaskCardSet , courseToStudentIdsMap: courseToStudentIdsMap , submissionMap: submissionMap , toggleTaskCardOpen: toggleTaskCardOpen  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ TeacherAssignmentOverviewData: taod  })=>({
            assessmentDetail: taod.assessmentDetail,
            taskDetailsMap: taod.taskDetailsMap,
            studentToTaskSubmissionDetailsMap: taod.studentToTaskSubmissionDetailsMap,
            userMap: taod.userMap,
            openTaskCardSet: taod.openTaskCardSet,
            courseToStudentIdsMap: taod.courseToStudentIdsMap,
            submissionMap: taod.submissionMap,
            toggleTaskCardOpen: taod.toggleTaskCardOpen
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const selectedClassParam = query.get("selectedClass") || "all";
    if (!assessmentDetail) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
        children: [
            assessmentDetail.assessment.taskOrder.map(({ taskId: taskId  })=>taskDetailsMap.get(taskId)).filter((el)=>Boolean(el)).map((taskDetails)=>{
                const completedStudents = studentToTaskSubmissionDetailsMap.filter((taskSubmissionDetailsMap)=>{
                    const taskSubmissionDetails = taskSubmissionDetailsMap.get(taskDetails.task.id);
                    return taskSubmissionDetails && (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails);
                }).map((_v, userId)=>userMap.get(userId)).toList().filter((user)=>{
                    if (!user) return false;
                    if (user.accountType !== "student" && !submissionMap.has(user.id)) return false;
                    if (selectedClassParam === "teachers") return user.accountType !== "student";
                    return selectedClassParam === "all" || courseToStudentIdsMap.get(selectedClassParam, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).includes(user.id);
                });
                const incompleteStudents = userMap.toList().filter((user)=>{
                    if (completedStudents.contains(user)) return false;
                    if (user.accountType !== "student" && !submissionMap.has(user.id)) return false;
                    if (selectedClassParam === "teachers") return user.accountType !== "student";
                    return selectedClassParam === "all" || courseToStudentIdsMap.get(selectedClassParam, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).includes(user.id);
                });
                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8e7c3ca28aed7cf6$export$45966d051be1808a), {
                    taskDetails: taskDetails,
                    completedStudents: completedStudents,
                    incompleteStudents: incompleteStudents,
                    open: openTaskCardSet.contains(taskDetails.task.id),
                    onToggleCardOpen: toggleTaskCardOpen(taskDetails.task.id)
                }, taskDetails.task.id);
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 22
            })
        ]
    });
};







const $12e02e63f68a5d05$export$df38d4adf8abd6a2 = ()=>{
    const { submitting: submitting , deleteSubmissionModalOpened: deleteSubmissionModalOpened , assessmentDetail: assessmentDetail , deleteSubmissionStudent: deleteSubmissionStudent , confirmDeleteText: confirmDeleteText , closeDeleteSubmissionModal: closeDeleteSubmissionModal , deleteSubmission: deleteSubmission , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.TeacherAssignmentOverviewData, []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        testTag: "delete",
        openType: "state",
        opened: deleteSubmissionModalOpened,
        header: "Are You Sure?",
        close: closeDeleteSubmissionModal,
        onSubmit: deleteSubmission(createToast),
        maxWidthOverride: "700px",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: closeDeleteSubmissionModal,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "danger",
                    loading: submitting,
                    type: "submit",
                    disabled: confirmDeleteText.toLowerCase().trim() !== deleteSubmissionStudent?.displayName.toLowerCase(),
                    children: "Delete"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "This will the delete ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                        children: [
                            deleteSubmissionStudent?.displayName,
                            "'s"
                        ]
                    }),
                    " submission for ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                        children: assessmentDetail?.assessment.name
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "It will remove all data (recordings, responses to comprehension questions, comments from teachers, etc) for this submission."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "deleteSubmission",
                value: confirmDeleteText,
                placeholder: "Type the student's name to confirm",
                onChange: setField("confirmDeleteText"),
                testTag: "confirm-delete"
            })
        ]
    });
};




const $7e214028cab82381$var$queryParam = "viewId";
const $7e214028cab82381$export$c5b18d8844d125d = ()=>{
    const { id: id  } = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const { load: load , assessmentDetail: assessmentDetail , submissionMap: submissionMap , assignmentCardOpen: assignmentCardOpen , userMap: userMap , courseMap: courseMap , setField: setField , updateSubmissionMap: updateSubmissionMap , loading: loading , studentToTaskSubmissionDetailsMap: studentToTaskSubmissionDetailsMap , startReassigning: startReassigning , isCsvExportEnabled: isCsvExportEnabled = false , isPaperUser: isPaperUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: ad , TeacherAssignmentOverviewData: taod  })=>({
            load: taod.load,
            assessmentDetail: taod.assessmentDetail,
            submissionMap: taod.submissionMap,
            assignmentCardOpen: taod.assignmentCardOpen,
            userMap: taod.userMap,
            courseMap: taod.courseMap,
            setField: taod.setField,
            updateSubmissionMap: taod.updateSubmissionMap,
            loading: taod.loading,
            studentToTaskSubmissionDetailsMap: taod.studentToTaskSubmissionDetailsMap,
            startReassigning: taod.startReassigning,
            isCsvExportEnabled: ad.currentUser?.flags.isCsvExportEnabled,
            isPaperUser: Boolean(ad.currentUser?.paperId)
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        load(id);
    }, [
        load,
        id
    ]);
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const selectedClassParam = query.get("selectedClass") || "all";
    const updateClassParam = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            selectedClass: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const backPath = query.get("backPath") || "/t/assignments";
    const selectedClassOptions = (0, $g5BLJ.useMemo)(()=>{
        const courseFilters = courseMap.toList().map((c)=>({
                value: c.id,
                label: c.name
            }));
        const teacherFilter = submissionMap.some((s)=>userMap.filter((u)=>u.accountType !== "student").keySeq().includes(s.userId)) ? [
            {
                value: "teachers",
                label: "Teacher Submissions"
            }
        ] : [];
        const allFilter = {
            value: "all",
            label: "All Classes"
        };
        return courseFilters.unshift(allFilter).concat(teacherFilter);
    }, [
        courseMap,
        submissionMap,
        userMap
    ]);
    const { rows: rows , teacherRows: teacherRows , columns: columns , getRowId: getRowId  } = (0, $de2ffa87b5a3a4b8$export$98b14d297b92183b)();
    const studentData = (0, $g5BLJ.useMemo)(()=>rows.map((user)=>{
            const submission = submissionMap.get(user.id);
            const taskSubmissions = studentToTaskSubmissionDetailsMap.get(user.id);
            const readingTaskSubmissionDetails = taskSubmissions?.find((task)=>task.type === "ReadingTask");
            return [
                user.familyName || user.displayName,
                user.givenName || "",
                submission && submission.wcpm !== 0 ? (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, submission.percentRead) : "",
                submission && submission.wcpm !== 0 ? (0, $3e76d4bc3268f884$export$252ba770fa56b422)(assessmentDetail?.assessment.independentOnly ? (0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wpm : (0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, submission.wcpm) : "",
                submission && submission.totalWords !== 0 ? (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words, submission.totalWords) : "",
                submission && submission.timeRead !== 0 ? (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, submission.timeRead) : "",
                submission ? (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(submission.finishedAt)) : "",
                ...readingTaskSubmissionDetails ? [
                    (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, readingTaskSubmissionDetails.taskSubmission.readingTime),
                    (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, readingTaskSubmissionDetails.taskSubmission.emptyTime),
                    (0, $3e76d4bc3268f884$export$f5dd818bff069720)(readingTaskSubmissionDetails.taskSubmission.wordAssignedCount),
                    (0, $3e76d4bc3268f884$export$f5dd818bff069720)(readingTaskSubmissionDetails.taskSubmission.uniqueWordAssignedCount),
                    (0, $3e76d4bc3268f884$export$f5dd818bff069720)(readingTaskSubmissionDetails.taskSubmission.correctWordSaidCount),
                    (0, $3e76d4bc3268f884$export$f5dd818bff069720)(readingTaskSubmissionDetails.taskSubmission.addedWordSaidCount),
                    (0, $3e76d4bc3268f884$export$f5dd818bff069720)(readingTaskSubmissionDetails.taskSubmission.missedWordSaidCount),
                    (0, $3e76d4bc3268f884$export$f5dd818bff069720)(readingTaskSubmissionDetails.taskSubmission.replacedWordSaidCount),
                    (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, readingTaskSubmissionDetails.taskSubmission.wordsPerMinute),
                    (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, readingTaskSubmissionDetails.taskSubmission.correctCompletion)
                ] : []
            ];
        }), [
        rows,
        submissionMap,
        assessmentDetail,
        studentToTaskSubmissionDetailsMap
    ]);
    if (!assessmentDetail) return null;
    const { assessment: assessment , coverImageUrl: coverImageUrl , courseIds: courseIds , readingName: readingName  } = assessmentDetail;
    const columnNames = [
        "Last Name/Username",
        "First Name",
        "% Read",
        "WCPM",
        "Words",
        "Time",
        "Date",
        `Reading Time`,
        `Non Reading Time`,
        `Words Assigned`,
        `Unique Words Assigned`,
        `Correct Words Read`,
        `Words Added`,
        `Words Missed`,
        `Words Replaced`,
        `Words Per Minute`,
        `Accuracy`
    ];
    const fileData = studentData.insert(0, columnNames);
    const tabs = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
        {
            id: "summary",
            name: `Summary`,
            content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $de2ffa87b5a3a4b8$export$e9bfb03f5fea5564), {
                rows: rows,
                teacherRows: teacherRows,
                columns: columns,
                getRowId: getRowId,
                assessment: assessment,
                submissionMap: submissionMap
            })
        },
        {
            id: "tasks",
            name: `Task Details`,
            content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6f84dc064809121e$export$38d0d292406cc6eb), {})
        }
    ]);
    const metrics = (0, $62e5f0fd429b4502$export$171369378300601)(assessmentDetail);
    const previewPath = `/reading-studio${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
        assessmentId: assessment?.id,
        backPath: `${pathname}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
        showInstructions: true
    })}`;
    const hasCsvExport = Boolean(isCsvExportEnabled);
    const TooltipElem = hasCsvExport ? (0, $a31343b90c9d3d88$export$28c660c63b792dea) : (0, $be64e7ee3b40f0c7$export$13c138588c4d3358);
    const tooltipProps = {
        content: hasCsvExport ? "Export Table as CSV" : `Upgrade to ${0, $4ded3b2c5af96cca$export$52756c3ad45aa25c} to seamlessly export all your data`,
        linkLocation: "contact"
    };
    const content = loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            submissionMap.toList().map((s)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $018cce6940d253d6$export$b5b6bb8bb5273115), {
                    channel: "SubmissionChannel",
                    id: s.id,
                    onMessage: updateSubmissionMap
                }, s.id)),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} 0`,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        color: "black",
                        to: backPath,
                        icon: "backArrow",
                        children: "Back"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        color: "primaryBlue",
                        displayType: "link",
                        onClick: startReassigning,
                        children: "Reassign"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        iconColor: "primaryBlue",
                        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    textAlign: "left",
                                    children: "Reassign an assignment to all students originally assigned to easily benchmark students with the same texts"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 3
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    textAlign: "left",
                                    children: [
                                        "Looking to fix a student's submission or have them resubmit?",
                                        " ",
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                            newTab: true,
                                            href: "https://readleesupport.zendesk.com/hc/en-us/articles/14127695073677",
                                            children: "Click Here"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 7
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        color: "primaryBlue",
                        icon: "preview",
                        iconPosition: "right",
                        iconSize: "1.5em",
                        to: previewPath,
                        children: "Preview"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 7
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        color: "primaryBlue",
                        to: `/t/assignment-builder/${assessment.id}`,
                        children: "Edit Assignment"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(TooltipElem, {
                        enabled: true,
                        ...tooltipProps,
                        display: "flex",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "link",
                            icon: "download",
                            iconSize: "1.25em",
                            iconPosition: "right",
                            color: "primaryBlue",
                            width: "100%",
                            disabled: !isCsvExportEnabled,
                            onClick: (0, $438c2fba1c8fa207$export$35193a8a641bb1b)({
                                data: fileData,
                                filename: `${assessment.name.substring(0, 20)}-progress-report`,
                                fetchJson: fetchJson
                            }),
                            children: "Export CSV"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a679044e49a453d7$export$81dfe1808f15259c), {
                assessment: assessment,
                courseIds: courseIds,
                courseMap: courseMap,
                open: assignmentCardOpen,
                onToggleCardOpen: ()=>setField("assignmentCardOpen")(!assignmentCardOpen),
                coverImg: coverImageUrl,
                metrics: metrics,
                canAssign: assessment.status !== "archived",
                assignToPath: `/t/assignments/${assessment.id}/assign${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                    assessmentId: assessment.id
                })}`,
                hideViewDetails: true,
                hideShare: assessmentDetail.primaryLicenseType === "open_source",
                readingName: readingName
            }, assessment.id),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e3aa8aeb4209bd7$export$44c45b2b7f09d2a6), {
                        noContent: true,
                        tabs: tabs,
                        queryParam: $7e214028cab82381$var$queryParam
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: "filter",
                                color: "readleeBlue",
                                fill: selectedClassParam !== "all",
                                strokeWidth: 1.5,
                                strokeLinecap: "round"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                                id: "sortBySelect",
                                displayType: "flat",
                                name: "Sort Assessments By",
                                value: selectedClassParam,
                                onChange: updateClassParam,
                                options: selectedClassOptions
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e3aa8aeb4209bd7$export$e8ac093818ac58be), {
                tabs: tabs,
                queryParam: $7e214028cab82381$var$queryParam
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2e8ec3dcad793a80$export$f6fbd0397182c331), {
                openedPath: `/t/assignments/${assessment.id}/assign`,
                closedPath: `/t/assignments/${assessment.id}`,
                onClose: ()=>load(assessment.id)
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ec1a16ba48052160$export$3a7541004f18f50c), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaf5d97e00bcd9f$export$9f25cea84f01c4af), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b8a3307ba6f0f480$export$90d8f29463c659f0), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $516ca276bdef158a$export$b2de5102d893289e), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $822922ed63c79903$export$1a6938bd84cc541a), {
                onSuccess: ({ id: id  })=>load(id)
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $12e02e63f68a5d05$export$df38d4adf8abd6a2), {})
        ]
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                title: assessment.name
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                overflowY: "auto",
                children: content
            }),
            isPaperUser && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eb30321ced29024b$export$a06f1c675e846f6f), {
                accountType: "teacher"
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");








const $ffcf15e3b286680e$var$sortOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        value: "nameDesc",
        label: "Name (A-Z)"
    },
    {
        value: "nameAsc",
        label: "Name (Z-A)"
    },
    {
        value: "completion",
        label: "Completion"
    }
]);
const $ffcf15e3b286680e$export$fb4388f3ff92f17b = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const { type: type , id: id  } = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const { load: load , assessment: assessment , loading: loading , taskDetails: taskDetails , submissionMap: submissionMap , submissionIdToTaskSubmissionDetailsMap: submissionIdToTaskSubmissionDetailsMap , studentIdToAssignedCoursesMap: studentIdToAssignedCoursesMap , taskCardOpen: taskCardOpen , userMap: userMap , courseMap: courseMap , setField: setField , upgradeAssessment: upgradeAssessment , currentUser: currentUser , currentPlan: currentPlan , startAssignmentUpgrade: startAssignmentUpgrade  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            load: state.TaskOverviewData.load,
            assessment: state.TaskOverviewData.assessment,
            loading: state.TaskOverviewData.loading,
            taskDetails: state.TaskOverviewData.taskDetails,
            submissionMap: state.TaskOverviewData.submissionMap,
            submissionIdToTaskSubmissionDetailsMap: state.TaskOverviewData.submissionIdToTaskSubmissionDetailsMap,
            studentIdToAssignedCoursesMap: state.TaskOverviewData.studentIdToAssignedCoursesMap,
            taskCardOpen: state.TaskOverviewData.taskCardOpen,
            userMap: state.TaskOverviewData.userMap,
            courseMap: state.TaskOverviewData.courseMap,
            setField: state.TaskOverviewData.setField,
            upgradeAssessment: state.TaskOverviewData.upgradeAssessment,
            currentUser: state.AppData.currentUser,
            currentPlan: state.AppData.currentPlan,
            startAssignmentUpgrade: state.UpgradeAssignmentModalData.startAssignmentUpgrade
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        load(id, type);
    }, [
        load,
        id,
        type
    ]);
    const selectedClassParam = query.get("selectedClass") || "all";
    const sortByParam = query.get("sortBy") || "name";
    const backPath = query.get("backPath") || `/t/assignments/${assessment?.id}`;
    const usageCapsEnabled = currentPlan.isUsageCapsEnabled;
    const availableUltimateAssessments = currentUser?.ultimateAssessmentsAvailable ?? 0;
    const updateClassParam = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            selectedClass: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const updateSortBy = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            sortBy: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const selectedClassOptions = (0, $g5BLJ.useMemo)(()=>{
        const courseFilters = courseMap.toList().map((c)=>({
                value: c.id,
                label: c.name
            }));
        const teacherFilter = submissionMap.some((s)=>userMap.filter((u)=>u.accountType !== "student").keySeq().includes(s.userId)) ? [
            {
                value: "teachers",
                label: "Teacher Submissions"
            }
        ] : [];
        const allFilter = {
            value: "all",
            label: "All Classes"
        };
        return courseFilters.unshift(allFilter).concat(teacherFilter);
    }, [
        courseMap,
        submissionMap,
        userMap
    ]);
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    if (!taskDetails) return null;
    const currentTaskIndex = assessment?.taskOrder.findIndex((ti)=>ti.taskId === taskDetails.task.id && ti.type === taskDetails.type) || 0;
    const previousTaskInfo = currentTaskIndex > 0 ? assessment?.taskOrder.get(currentTaskIndex - 1) : null;
    const nextTaskInfo = assessment && currentTaskIndex < assessment.taskOrder.size ? assessment?.taskOrder.get(currentTaskIndex + 1) : null;
    const baseUsers = userMap.toList().filter((u)=>u.accountType === "student" || submissionMap.has(u.id));
    const [completedStudents, incompleteStudents] = (0, $d5a1fd3dea1a0ab6$export$b29f828819edca8d)(baseUsers, (s)=>{
        const submission = submissionMap.get(s.id);
        if (!submission) return false;
        const taskSubmissionDetails = submissionIdToTaskSubmissionDetailsMap.get(submission.id);
        if (!taskSubmissionDetails) return false;
        return (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails);
    });
    const filteredUsers = (0, $d5a1fd3dea1a0ab6$export$27a1cb209e3caa11)(sortByParam === "nameAsc", baseUsers.filter((s)=>{
        if (selectedClassParam === "all") return true;
        if (selectedClassParam === "teachers") return (0, $75cd274e63beb59b$export$21d5f40a3f7d2451)(s.accountType);
        const courses = studentIdToAssignedCoursesMap.get(s.id);
        return courses && !courses?.filter((c)=>c.id === selectedClassParam).isEmpty();
    }).sortBy((s)=>{
        if (sortByParam === "completion") {
            const completed = completedStudents.map((u)=>u.id).includes(s.id) ? 0 : 1;
            return [
                completed,
                (0, $75cd274e63beb59b$export$61b6a526e2f145be)(s)
            ];
        }
        return (0, $75cd274e63beb59b$export$61b6a526e2f145be)(s);
    }));
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
        overflowY: "auto",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                title: "Question 1"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} 0`,
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                color: "black",
                                to: backPath,
                                icon: "backArrow",
                                children: "Back to Assignment"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        color: "black",
                                        to: `/t/assignments/task/${previousTaskInfo?.type}/${previousTaskInfo?.taskId}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                                        icon: "arrowLeft",
                                        disabled: !previousTaskInfo,
                                        children: "Previous"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 4
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        color: "black",
                                        to: `/t/assignments/task/${nextTaskInfo?.type}/${nextTaskInfo?.taskId}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                                        icon: "arrowRight",
                                        iconPosition: "right",
                                        disabled: !nextTaskInfo,
                                        children: "Next"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8e7c3ca28aed7cf6$export$45966d051be1808a), {
                        taskDetails: taskDetails,
                        completedStudents: completedStudents,
                        incompleteStudents: incompleteStudents,
                        open: taskCardOpen,
                        onToggleCardOpen: ()=>setField("taskCardOpen")(!taskCardOpen)
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "space-between",
                        align: "center",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        display: "inline",
                                        color: "gray6",
                                        children: "Sort By:"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                                        id: "sortBySelect",
                                        displayType: "flat",
                                        name: "Sort Assessments By",
                                        value: sortByParam,
                                        onChange: updateSortBy,
                                        options: $ffcf15e3b286680e$var$sortOptions
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: "filter",
                                        color: "readleeBlue",
                                        fill: selectedClassParam !== "all",
                                        strokeWidth: 1.5,
                                        strokeLinecap: "round"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                                        id: "filterClassSelect",
                                        displayType: "flat",
                                        name: "Sort Assessments By",
                                        value: selectedClassParam,
                                        onChange: updateClassParam,
                                        options: selectedClassOptions
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    filteredUsers.map((student)=>{
                        const submission = submissionMap.get(student.id);
                        const taskSubmissionDetails = submission ? submissionIdToTaskSubmissionDetailsMap.get(submission.id, null) : null;
                        const textDiffs = taskSubmissionDetails?.type === "ComprehensionTask" ? taskSubmissionDetails.responseAudioFile?.transcriptItems : undefined;
                        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c0758e9270a48b15$export$7b5f1f2941347758), {
                            usageCapsEnabled: usageCapsEnabled,
                            availableUltimateAssessments: availableUltimateAssessments,
                            toolTipOnClick: ()=>startAssignmentUpgrade(assessment?.id ?? "", "comprehensionTranscription"),
                            taskDetails: taskDetails,
                            taskSubmissionDetails: taskSubmissionDetails,
                            assignedCourses: studentIdToAssignedCoursesMap.get(student.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()),
                            user: student,
                            submissionMap: submissionMap,
                            comprehensionTextDiff: textDiffs,
                            canSeeTranscription: (0, $4ded3b2c5af96cca$export$cff2a6c9a7debd3)("isComprehensionTranscriptEnabled", currentUser, assessment, true)
                        }, student.id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 22
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $822922ed63c79903$export$1a6938bd84cc541a), {
                onSuccess: upgradeAssessment
            })
        ]
    });
};







var $g5BLJ = parcelRequire("g5BLJ");















const $e7e70b92446d9f0d$var$SideBarContent = ()=>{
    const { contentType: contentType , name: name , authorName: authorName , coverImage: coverImage , setField: setField , errors: errors , coverImageFile: coverImageFile , coverImageFileUrl: coverImageFileUrl , uploadedPdfFile: uploadedPdfFile , uploadPdfFile: uploadPdfFile , pdfFile: pdfFile , webSourceUrl: webSourceUrl , openWebSourceUrlModal: openWebSourceUrlModal , selectedLicenseType: selectedLicenseType , gradeLevelId: gradeLevelId , languageCode: languageCode , newTagName: newTagName , tagNameList: tagNameList , removeTag: removeTag , addTag: addTag , toggleSharing: toggleSharing , reading: reading , playlists: playlists , selectedPlaylistIds: selectedPlaylistIds , primaryLicenseType: primaryLicenseType , isSpecialEducation: isSpecialEducation , isEll: isEll , readingId: readingId , gradeLevels: gradeLevels , peekPdf: peekPdf  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ReadingBuilderData, []);
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser, []);
    const languageCodeSelectOptions = (0, $647763111c79c7a8$export$51bafe10e07ca70f)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const viewMode = query.get("viewMode") || "";
    const canShare = (primaryLicenseType, licenseType)=>{
        if ((0, $75cd274e63beb59b$export$a71c09bab744fd37)(currentUser?.accountType || "student")) return true;
        if (viewMode === "preview" || currentUser?.accountType !== "teacher") return false;
        if (primaryLicenseType) return false;
        if (!reading) return true;
        return !licenseType || (0, $9858807ed795496b$export$d59e58cf0ab884d5)(licenseType);
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: [
                    "/t/reading-builder/content",
                    "/t/reading-builder"
                ],
                exact: true,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    align: "stretch",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h4",
                            children: "Pick an Assignment Type"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            onClick: ()=>setField("contentType")("text"),
                            active: contentType === "text",
                            icon: "copy",
                            children: "Copy & Paste (text only)"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            onClick: ()=>setField("contentType")("pdf_by_page"),
                            active: contentType === "pdf_by_page",
                            icon: "pdf",
                            children: "Upload PDF"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            onClick: ()=>setField("contentType")("independent"),
                            active: contentType === "independent",
                            icon: "book",
                            children: "Independent Reading"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            to: "/t/library",
                            active: false,
                            icon: "search",
                            children: "Content Library"
                        }),
                        (contentType === "pdf" || contentType === "pdf_by_page") && (uploadedPdfFile || pdfFile) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 10
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h5",
                                    color: "white",
                                    children: "Uploaded File"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 3
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "center",
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            grow: 1,
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: "pdf",
                                                    fill: true,
                                                    fillColor: "white",
                                                    strokeWidth: 0
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                    horizontal: true,
                                                    size: 4
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                    variant: "h6",
                                                    color: "white",
                                                    lineHeightOverride: "100%",
                                                    maxWidth: "150px",
                                                    title: uploadedPdfFile ? uploadedPdfFile.name : pdfFile?.name,
                                                    ellipsis: true,
                                                    children: uploadedPdfFile ? uploadedPdfFile.name : pdfFile?.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                                            download: true,
                                            href: pdfFile?.url,
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                content: "Download PDF",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: "download",
                                                    color: "primaryBlue",
                                                    fill: true,
                                                    fillColor: "primaryBlue",
                                                    size: "1.5em",
                                                    strokeWidth: 0
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true,
                                            size: 2
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                                            onClick: ()=>uploadPdfFile((0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()),
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                content: "Delete PDF",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: "trash",
                                                    color: "danger",
                                                    fill: true,
                                                    fillColor: "danger",
                                                    size: "1.5em",
                                                    strokeWidth: 0
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        contentType === "web" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 10
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h5",
                                    color: "white",
                                    children: "Source URL"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 3
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "start",
                                    justify: "space-between",
                                    children: !webSourceUrl ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        onClick: openWebSourceUrlModal,
                                        icon: "add",
                                        iconSize: "1.25em",
                                        width: "100%",
                                        children: "Add Source URL"
                                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                        icon: "link",
                                                        fillColor: "white",
                                                        size: "1.5em",
                                                        strokeWidth: 1.5
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        horizontal: true,
                                                        size: 4
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                        variant: "h6",
                                                        color: "white",
                                                        lineHeightOverride: "100%",
                                                        maxWidth: "150px",
                                                        title: webSourceUrl,
                                                        ellipsis: true,
                                                        children: new window.URL(webSourceUrl).hostname
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        horizontal: true,
                                                        size: 2
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                                                onClick: ()=>setField("webSourceUrl")(""),
                                                testTag: "remove-web-url",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: "trash",
                                                    fill: true,
                                                    fillColor: "danger",
                                                    size: "1em",
                                                    strokeWidth: 0
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/reading-builder/metadata",
                exact: true,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "end",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                    id: "cover-image-input",
                                    name: "coverImageFile",
                                    type: "file",
                                    kind: "imagePreview",
                                    width: "auto",
                                    value: coverImage ? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                        coverImage
                                    ]) : (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                                    onChange: (files)=>{
                                        const file = files.get(0, null);
                                        setField("coverImageFileUrl")(file ? URL.createObjectURL(file) : "");
                                        setField("coverImage")(file);
                                    },
                                    accept: "image",
                                    testTag: "sidebar-image",
                                    flex: true,
                                    uploadedFile: coverImageFile,
                                    disabled: viewMode === "preview"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 3
                                }),
                                coverImageFileUrl || coverImageFile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "start",
                                    justify: "space-between",
                                    direction: "column",
                                    maxWidth: "130px",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h6",
                                            color: "white",
                                            lineHeightOverride: "100%",
                                            title: coverImage ? coverImage.name : coverImageFile?.name,
                                            ellipsis: true,
                                            maxWidth: "100%",
                                            children: coverImage ? coverImage.name : coverImageFile?.name
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 2
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                            onClick: ()=>{
                                                setField("coverImageFileUrl")("");
                                                setField("coverImage")(null);
                                                setField("coverImageFile")(null);
                                            },
                                            color: "primaryBlue",
                                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                            children: "Remove Image"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    color: "white",
                                    variant: "h6",
                                    maxWidth: "130px",
                                    children: "Upload Cover Image (optional)"
                                })
                            ]
                        }),
                        errors && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                            errors: errors,
                            errorKey: "coverImageFile"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 10
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            name: "name",
                            type: "text",
                            value: name,
                            label: `Title of Text${contentType === "independent" ? " (Optional)" : ""}`,
                            onChange: setField("name"),
                            errors: errors,
                            disabled: viewMode === "preview"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            name: "author",
                            type: "text",
                            value: authorName,
                            label: `Author${contentType === "independent" ? " (Optional)" : ""}`,
                            onChange: setField("authorName"),
                            errors: errors,
                            disabled: viewMode === "preview"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            type: "select",
                            label: "Language",
                            name: "language",
                            options: languageCodeSelectOptions,
                            value: languageCode,
                            onChange: setField("languageCode"),
                            disabled: viewMode === "preview"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            type: "select",
                            label: "Grade Level",
                            name: "gradeLevel",
                            errors: errors,
                            disabled: viewMode === "preview",
                            options: gradeLevels.map((gl)=>({
                                    value: gl.id,
                                    label: gl.name,
                                    disabled: readingId ? (0, $1efad0e185f7a777$export$4c9c6fc2c1b59749).has(gl.level) : false
                                })),
                            value: gradeLevelId,
                            onChange: setField("gradeLevelId")
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                            name: "specialEd",
                            label: "Special Education Students",
                            value: isSpecialEducation,
                            onChange: setField("isSpecialEducation"),
                            textColor: "white"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $38eb4c3d3214e6ab$export$d4e232ca161ccdd3), {
                            name: "ell",
                            label: "English Language Learners",
                            value: isEll,
                            onChange: setField("isEll"),
                            textColor: "white"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$b04be29aa201d4f5), {
                                    $isTextInput: true,
                                    $noMargin: true,
                                    children: "Tags"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                    content: "Add tags to help others find your content",
                                    iconColor: "gray6"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0230275b783b39cd$export$acbce29fea0b3d95), {
                            newTagName: newTagName,
                            tagNameList: tagNameList,
                            errors: errors,
                            updateTag: setField("newTagName"),
                            addTag: addTag,
                            removeTag: removeTag,
                            disabled: viewMode === "preview"
                        }),
                        canShare(primaryLicenseType, reading?.license) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 3
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h5",
                                            children: "Sharing"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true,
                                            size: 1
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $014f444f542f72d0$export$4fe1c22bc4285940), {
                                            isPaperUser: Boolean(currentUser?.paperSyncedAt)
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true,
                                            size: 3
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                            flex: true,
                                            type: "toggle",
                                            name: "toggleSharing",
                                            value: (0, $9858807ed795496b$export$e6ae6bdeba4fc9e3)(selectedLicenseType),
                                            onChange: toggleSharing(Boolean(currentUser?.paperId)),
                                            width: "auto",
                                            disabled: viewMode === "preview"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 3
                                }),
                                (0, $9858807ed795496b$export$e6ae6bdeba4fc9e3)(selectedLicenseType) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                            name: "licenseType",
                                            type: "select",
                                            value: selectedLicenseType,
                                            onChange: setField("selectedLicenseType"),
                                            options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                                {
                                                    value: "school",
                                                    label: "Sharing with my School"
                                                },
                                                {
                                                    value: "district",
                                                    label: "Sharing with my District"
                                                },
                                                {
                                                    value: "open_source_needs_review",
                                                    label: "Sharing with Everyone"
                                                },
                                                ...currentUser && (0, $75cd274e63beb59b$export$a71c09bab744fd37)(currentUser.accountType) ? [
                                                    {
                                                        value: "open_source",
                                                        label: "Open Source"
                                                    },
                                                    {
                                                        value: "private_final",
                                                        label: "Private User Content (User Cannot Change)"
                                                    },
                                                    {
                                                        value: "in_copyright",
                                                        label: "In Copyright (unused)"
                                                    }
                                                ] : []
                                            ])
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 3
                                        })
                                    ]
                                })
                            ]
                        }),
                        currentUser && (0, $75cd274e63beb59b$export$a71c09bab744fd37)(currentUser.accountType) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                    type: "multiselect",
                                    label: "Playlists",
                                    name: "playlists",
                                    options: playlists.sortBy((p)=>[
                                            p.ranking,
                                            p.name
                                        ]).map((playlist)=>({
                                            value: playlist.id,
                                            label: `${playlist.name}${playlist.enabled ? "" : " (Hidden)"}`
                                        })),
                                    value: selectedPlaylistIds,
                                    onChange: setField("selectedPlaylistIds")
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                        displayType: "link",
                                        to: "/m/playlists",
                                        color: "white",
                                        children: "Manage Playlists"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 3
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/reading-builder/processing",
                exact: true,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/reading-builder/edit-pdf-text",
                exact: true,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h3",
                        children: "PDF Text Validation"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: "We've extracted the PDF's content for calculating your student's fluency metrics, like accuracy and completion percentage."
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: "For optimal results, edit and refine this text (e.g., removing headers and copyright info) to include only the desired reading material. Click on each thumbnail to view and edit page text. Give it a try!"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 9
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: "Click this button to view the PDF page if you need to reference it!"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: ()=>setField("peekPdf")(!peekPdf),
                        children: "Toggle PDF View"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {})
                ]
            })
        ]
    });
};
const $e7e70b92446d9f0d$export$c93fc5b9669dc224 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const viewMode = query.get("viewMode") || "";
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const accountType = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser?.accountType || "teacher", []);
    const { contentType: contentType , uploadingPdf: uploadingPdf , submitting: submitting , adminUpdate: adminUpdate , reading: reading , basicText: basicText , pdfFile: pdfFile , webSourceUrl: webSourceUrl , overridePdfJsonText: overridePdfJsonText  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.ReadingBuilderData, []);
    const contentSubmitted = contentType === "text" && basicText !== "" || (contentType === "pdf" || contentType === "pdf_by_page") && Boolean(pdfFile) || contentType === "web" && basicText !== "" && webSourceUrl !== "" || contentType === "independent";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1941c1cb7fdcc73d$export$206b65ea4daedc5b), {
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e7e70b92446d9f0d$var$SideBarContent, {}),
        primaryButton: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            align: "stretch",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: [
                            "/t/reading-builder/content",
                            "/t/reading-builder"
                        ],
                        exact: true,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                            content: "Add content before moving on",
                            disabled: contentSubmitted,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                disabled: !contentType || !contentSubmitted,
                                loading: uploadingPdf,
                                to: `/t/reading-builder/metadata${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                                width: "100%",
                                children: "Next"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/t/reading-builder/metadata",
                        exact: true,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                reading?.id && (0, $75cd274e63beb59b$export$a71c09bab744fd37)(accountType) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                    display: "block",
                                    content: "By using this action Moderators can update the Cover Image, Title, Author, License Type, Grade Level, and Tags in the content library",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                            width: "100%",
                                            onClick: adminUpdate(history, query, createToast),
                                            loading: submitting,
                                            color: "danger",
                                            icon: "info",
                                            children: "Moderator Update"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 2
                                        })
                                    ]
                                }),
                                viewMode !== "preview" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    to: `/t/reading-builder/content${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                                    displayType: "outline",
                                    color: "white",
                                    children: "Back"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    loading: submitting,
                                    type: "submit",
                                    children: viewMode === "preview" ? "Create Assignment" : "Next"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/t/reading-builder/processing",
                        exact: true,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            to: `/t/reading-builder/metadata${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                            displayType: "outline",
                            color: "white",
                            children: "Back"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/t/reading-builder/edit-pdf-text",
                        exact: true,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                to: `/t/reading-builder/metadata${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                                displayType: "outline",
                                color: "white",
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                loading: submitting,
                                onClick: overridePdfJsonText({
                                    history: history,
                                    query: query
                                }),
                                children: "Next"
                            })
                        ]
                    })
                ]
            })
        })
    });
};







const $b80bae6789662861$export$fd103e0b4a088351 = ()=>{
    const { name: name , authorName: authorName , coverImageFileUrl: coverImageFileUrl , coverImageFile: coverImageFile , webSourceUrl: webSourceUrl , contentType: contentType  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingBuilderData: s  })=>({
            name: s.name,
            authorName: s.authorName,
            coverImageFileUrl: s.coverImageFileUrl,
            coverImageFile: s.coverImageFile,
            webSourceUrl: s.webSourceUrl,
            contentType: s.contentType
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const backPath = query.get("backPath");
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d361bb1339f62201$export$d390129da57cce20), {
        leftButton: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            color: "gray2",
            nav: true,
            to: backPath || "/t",
            children: "Cancel"
        }),
        thumbnailUrl: coverImageFileUrl || coverImageFile?.thumbnailUrl,
        readingTitle: name,
        authorName: authorName,
        webSourceUrl: contentType === "web" ? webSourceUrl : null
    });
};










const $b84f6289185fcebb$export$9d2b4227a95687cc = ({ children: children , justify: justify = "center"  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[10],
        width: "100%",
        justify: "center",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            maxWidth: "700px",
            width: "100%",
            direction: "column",
            align: "center",
            justify: justify,
            height: "100%",
            children: children
        })
    });


const $6a9ddec85d4a60f8$export$b1a4851f990d0bfc = ()=>{
    const { contentType: contentType , uploadedPdfFile: uploadedPdfFile , basicText: basicText , setField: setField , errors: errors , uploadPdfFile: uploadPdfFile , uploadingPdf: uploadingPdf , pdfFile: pdfFile , rotatePdf: rotatePdf , pdfRotation: pdfRotation , pdfFileUrl: pdfFileUrl  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingBuilderData: s  })=>({
            contentType: s.contentType,
            uploadedPdfFile: s.uploadedPdfFile,
            basicText: s.basicText,
            setField: s.setField,
            errors: s.errors,
            uploadPdfFile: s.uploadPdfFile,
            uploadingPdf: s.uploadingPdf,
            pdfFile: s.pdfFile,
            rotatePdf: s.rotatePdf,
            pdfRotation: s.pdfRotation,
            pdfFileUrl: s.pdfFileUrl
        }), []);
    if ([
        "text",
        "web"
    ].includes(contentType)) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $b84f6289185fcebb$export$9d2b4227a95687cc), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                errors: errors,
                errorKey: "contentFile"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                label: null,
                name: "contentFile",
                type: "text-area",
                displayType: "flat",
                value: basicText,
                onChange: setField("basicText"),
                placeholder: "✏️ Copy and paste a short story, news article, poem, or excerpt from a book here for students to read.",
                height: "100%",
                maxWidth: (0, $18ffa0398cff6303$export$c68d31c234787f72)
            })
        ]
    });
    else if (contentType === "pdf" || contentType === "pdf_by_page") return pdfFileUrl ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $614d018fbd2bc9dd$export$c2b566b1ee6fc458), {
        onRotatePDF: rotatePdf,
        rotation: pdfRotation,
        src: pdfFileUrl,
        hideTopBar: true
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b84f6289185fcebb$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
            id: "cover-image-input",
            type: "file",
            kind: "dropArea",
            value: uploadedPdfFile ? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                uploadedPdfFile
            ]) : (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
            name: "contentFile",
            onChange: uploadPdfFile,
            accept: "pdf",
            errors: errors,
            flex: true,
            justify: "center",
            uploading: uploadingPdf,
            uploadedFile: pdfFile
        })
    });
    else if (contentType === "independent") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b84f6289185fcebb$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
            kind: "independentReading"
        })
    });
    else throw new Error(`Unsupported content type '${contentType}'`);
};





const $652867cd06ecccb4$export$b4299e13b158bd8 = ()=>{
    const { webModalOpen: webModalOpen , fetchArticle: fetchArticle , scrapingWebSourceUrl: scrapingWebSourceUrl , scrapeErrors: scrapeErrors , errors: errors , setField: setField , editingWebSourceUrl: editingWebSourceUrl  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingBuilderData: rbd  })=>({
            webModalOpen: rbd.webModalOpen,
            fetchArticle: rbd.fetchArticle,
            scrapingWebSourceUrl: rbd.scrapingWebSourceUrl,
            scrapeErrors: rbd.scrapeErrors,
            errors: rbd.errors,
            setField: rbd.setField,
            editingWebSourceUrl: rbd.editingWebSourceUrl
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: webModalOpen,
        header: "Source Web URL",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "end",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: ()=>setField("webModalOpen")(false),
                    displayType: "link",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: fetchArticle,
                    loading: scrapingWebSourceUrl,
                    type: "submit",
                    children: "Save"
                })
            ]
        }),
        disableFadeClose: true,
        close: ()=>setField("webModalOpen")(false),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                maxWidth: "600px",
                children: "Readlee will sync the title, thumbnail, and author from the website and provide a url to the source material. You will still need to copy and paste the text you would like to assign."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                name: "webSourceUrl",
                type: "text",
                label: "Web URL",
                value: editingWebSourceUrl,
                onChange: setField("editingWebSourceUrl"),
                errors: scrapeErrors.merge(errors),
                disabled: scrapingWebSourceUrl
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $0be3931bd7df52bd$export$88348e9fa2524052 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { pdfFile: pdfFile , uploadingPdf: uploadingPdf , submit: submit , contentType: contentType , accountType: accountType  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            ...state.ReadingBuilderData,
            accountType: state.AppData.currentUser?.accountType || "student"
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        if (contentType === "pdf_by_page" && (!pdfFile || pdfFile?.processingStatus === "finished")) {
            history.push(`/t/reading-builder/edit-pdf-text${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
            return;
        }
        if (!uploadingPdf && (!pdfFile || pdfFile?.processingStatus === "finished")) submit({
            history: history,
            query: query
        })();
    }, [
        pdfFile,
        uploadingPdf,
        history,
        submit,
        query,
        contentType,
        accountType
    ]);
    return pdfFile?.processingStatus === "errored" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        justify: "center",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h1",
                children: "Something went wrong!"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h3",
                children: "There was an error processing your text, please try a different file."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                to: `/t/reading-builder/content${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                children: "Back"
            })
        ]
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        justify: "center",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h1",
                children: "Hang in there!"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h3",
                children: "We're processing your text, this may take a moment..."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {})
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");






const $3e41bfbdb486cb48$export$7ac324985cf3478 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { pdfFile: pdfFile , pdfFileUrl: pdfFileUrl , uploadingPdf: uploadingPdf , submit: submit , errors: errors , setPdfPageText: setPdfPageText , peekPdf: peekPdf  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            pdfFile: state.ReadingBuilderData.pdfFile,
            pdfFileUrl: state.ReadingBuilderData.pdfFileUrl,
            uploadingPdf: state.ReadingBuilderData.uploadingPdf,
            submit: state.ReadingBuilderData.submit,
            errors: state.ReadingBuilderData.errors,
            setPdfPageText: state.ReadingBuilderData.setPdfPageText,
            peekPdf: state.ReadingBuilderData.peekPdf
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        if (!pdfFile || pdfFile.type !== "PdfByPageStoredFile") history.push(`/t/reading-builder/content${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
    }, [
        pdfFile,
        uploadingPdf,
        history,
        submit,
        query
    ]);
    const [currentPage, setCurrentPage] = (0, $g5BLJ.useState)(0);
    if (!pdfFileUrl || !pdfFile || pdfFile.type !== "PdfByPageStoredFile") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
        children: "could not display content"
    });
    const currentPageText = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(pdfFile?.jsonText ?? {}).get(String(currentPage - 1), "");
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        height: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $614d018fbd2bc9dd$export$c2b566b1ee6fc458), {
                src: pdfFileUrl,
                kind: peekPdf ? "full" : "thumbnailsOnly",
                currentPage: currentPage,
                setCurrentPage: setCurrentPage,
                hideTopBar: true
            }),
            !peekPdf && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $b84f6289185fcebb$export$9d2b4227a95687cc), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                        errors: errors,
                        errorKey: "contentFile"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        label: null,
                        name: "contentFile",
                        type: "text-area",
                        displayType: "flat",
                        value: currentPageText,
                        onChange: (text)=>setPdfPageText(currentPage - 1, text),
                        placeholder: "Update the text student should be reading aloud for this PDF page.",
                        height: "100%",
                        maxWidth: (0, $18ffa0398cff6303$export$c68d31c234787f72),
                        testTag: "edit-pdf-text-step-text-area"
                    })
                ]
            })
        ]
    });
};









const $a94a654354edd99d$export$ebc58c644d61e0ad = ()=>{
    const { contentType: contentType , pdfFileUrl: pdfFileUrl , rotatePdf: rotatePdf , pdfRotation: pdfRotation , basicText: basicText , basicTextFile: basicTextFile , languageCode: languageCode  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingBuilderData: rbd  })=>({
            contentType: rbd.contentType,
            pdfFileUrl: rbd.pdfFileUrl,
            rotatePdf: rbd.rotatePdf,
            pdfRotation: rbd.pdfRotation,
            basicText: rbd.basicText,
            basicTextFile: rbd.basicTextFile,
            languageCode: rbd.languageCode
        }), []);
    const languageCodeDetails = (0, $647763111c79c7a8$export$e4fbdc12184e8049)(languageCode);
    if ([
        "text",
        "web"
    ].includes(contentType)) {
        if (basicText) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ee42914c60200b71$export$3df8925a20fc7cae), {
            languageCodeDetails: languageCodeDetails,
            textContent: basicText,
            enableTextRangeSelection: false
        });
        else if (basicTextFile) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ee42914c60200b71$export$3df8925a20fc7cae), {
            languageCodeDetails: languageCodeDetails,
            textFile: basicTextFile,
            enableTextRangeSelection: false
        });
        else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            children: "Nothing to display"
        });
    } else if (contentType === "pdf" || contentType === "pdf_by_page") {
        if (!pdfFileUrl) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
            children: "could not display content"
        });
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $614d018fbd2bc9dd$export$c2b566b1ee6fc458), {
            onRotatePDF: rotatePdf,
            rotation: pdfRotation,
            src: pdfFileUrl
        });
    } else if (contentType === "independent") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b84f6289185fcebb$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
            kind: "independentReading"
        })
    });
    else throw new Error("Unsupported content type");
};






const $553bb6ab579eed1c$export$5838c3b7a4a3fc78 = ()=>{
    const { loading: loading , load: load , pdfFileUrl: pdfFileUrl , contentType: contentType , submitForProcessing: submitForProcessing , onPdfProcessingStatus: onPdfProcessingStatus , pdfFile: pdfFile  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingBuilderData: rbd  })=>({
            loading: rbd.loading,
            load: rbd.load,
            pdfFileUrl: rbd.pdfFileUrl,
            contentType: rbd.contentType,
            submitForProcessing: rbd.submitForProcessing,
            onPdfProcessingStatus: rbd.onPdfProcessingStatus,
            pdfFile: rbd.pdfFile
        }), []);
    const isPaperUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>Boolean(s.AppData.currentUser?.paperId), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    (0, $g5BLJ.useEffect)(()=>{
        const assessmentId = query.get("assessmentId") || "";
        const readingId = query.get("readingId") || "";
        load({
            assessmentId: assessmentId,
            readingId: readingId,
            isPaperUser: isPaperUser
        });
    }, [
        load,
        query,
        isPaperUser
    ]);
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const metadataStep = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/t/reading-builder/metadata"));
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2a0812bc157eca24$export$69546dc4b644da69), {
        showTopBarDivider: !metadataStep || ![
            "pdf",
            "pdf_by_page"
        ].includes(contentType) || !pdfFileUrl,
        loading: loading,
        topBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b80bae6789662861$export$fd103e0b4a088351), {}),
        sideBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e7e70b92446d9f0d$export$c93fc5b9669dc224), {}),
        onSubmit: submitForProcessing(history, query),
        mainContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            height: "100%",
            width: "100%",
            justify: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                            path: [
                                "/t/reading-builder/content",
                                "/t/reading-builder"
                            ],
                            exact: true,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6a9ddec85d4a60f8$export$b1a4851f990d0bfc), {})
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                            path: "/t/reading-builder/metadata",
                            exact: true,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a94a654354edd99d$export$ebc58c644d61e0ad), {})
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                            path: "/t/reading-builder/processing",
                            exact: true,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0be3931bd7df52bd$export$88348e9fa2524052), {})
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                            path: "/t/reading-builder/edit-pdf-text",
                            exact: true,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3e41bfbdb486cb48$export$7ac324985cf3478), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $652867cd06ecccb4$export$b4299e13b158bd8), {}),
                pdfFile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $018cce6940d253d6$export$b5b6bb8bb5273115), {
                    channel: "StoredFileChannel",
                    id: pdfFile.id,
                    onMessage: onPdfProcessingStatus
                })
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");








var $g5BLJ = parcelRequire("g5BLJ");






var $g5BLJ = parcelRequire("g5BLJ");



const $287cdf9ff6f919ba$export$298ffe52626b705d = ()=>{
    const { assessment: assessment , taskDetailsMap: taskDetailsMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s  })=>({
            assessment: s.assessment,
            taskDetailsMap: s.taskDetailsMap
        }), []);
    if (!assessment) return null;
    const readingTaskData = assessment.taskOrder.find(({ taskId: taskId , type: type  })=>type === "ReadingTask" && taskDetailsMap.has(taskId));
    if (!readingTaskData) return null;
    const readingTaskId = readingTaskData.taskId;
    const readingTaskDetails = taskDetailsMap.get(readingTaskId);
    if (!readingTaskDetails || readingTaskDetails.type !== "ReadingTask") return null;
    return readingTaskDetails;
};
const $287cdf9ff6f919ba$export$af9af7e2c4e0b6ed = ()=>{
    const { taskDetailsMap: taskDetailsMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s  })=>({
            taskDetailsMap: s.taskDetailsMap
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const currentTaskId = query.get("currentTaskId", null);
    const currentTaskDetails = currentTaskId ? taskDetailsMap.get(currentTaskId, null) : null;
    return currentTaskDetails;
};
const $287cdf9ff6f919ba$export$f79545bc5672622d = ()=>{
    const { taskDetailsMap: taskDetailsMap , assessment: assessment  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s  })=>({
            taskDetailsMap: s.taskDetailsMap,
            assessment: s.assessment
        }), []);
    const vocabTaskDetailsList = (0, $g5BLJ.useMemo)(()=>{
        return (assessment?.taskOrder || (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).map((ti)=>taskDetailsMap.get(ti.taskId)).filter((t)=>t && t.type === "VocabTask").toList();
    }, [
        taskDetailsMap,
        assessment?.taskOrder
    ]);
    return vocabTaskDetailsList;
};


const $877a5d4aca591210$var$textTypes = {
    TextStoredFile: [
        "whole_text",
        "start_and_end_index"
    ],
    EpubStoredFile: [
        "whole_text",
        "chapters"
    ],
    PdfStoredFile: [
        "whole_text",
        "pages"
    ],
    PdfByPageStoredFile: [
        "whole_text",
        "pages"
    ]
};
const $877a5d4aca591210$var$prettyReadingPartTypes = {
    whole_text: "Full Text",
    start_and_end_index: "Select Text",
    pages: "Select Pages",
    chapters: "Select Chapters"
};
const $877a5d4aca591210$var$SelectTextHelpText = ({ currentTaskDetails: currentTaskDetails , taskErrors: taskErrors  })=>currentTaskDetails.task.readingPartType !== "start_and_end_index" ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Click a word to start selecting, then click another word to finish selecting."
            }),
            taskErrors.get(currentTaskDetails.task.id)?.has("endPoint") && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                message: "Please click on your end word to continue"
            })
        ]
    });
const $877a5d4aca591210$var$PageSelector = ({ currentTaskDetails: currentTaskDetails , setStartPage: setStartPage , setEndPage: setEndPage , badPages: badPages  })=>{
    const { task: task , contentFile: contentFile  } = currentTaskDetails;
    if (task.readingPartType !== "pages") return null;
    if (contentFile?.type !== "PdfStoredFile" && contentFile?.type !== "PdfByPageStoredFile") return null;
    const startValue = task.startPoint.pageNumber + 1;
    const endValue = task.endPoint.pageNumber + 1;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8d52bbd6b178f533$export$6bf0cd3a219bbade), {
                        name: "startPoint",
                        value: startValue,
                        onChange: (value)=>{
                            if (typeof value === "number") setStartPage(task.id, value - 1);
                        },
                        max: contentFile.pageCount,
                        min: 1,
                        testTag: "start-point-page",
                        integerOnly: true
                    }),
                    " ",
                    "—",
                    " ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8d52bbd6b178f533$export$6bf0cd3a219bbade), {
                        name: "endPoint",
                        value: endValue,
                        onChange: (value)=>{
                            if (typeof value === "number") setEndPage(task.id, value - 1);
                        },
                        max: contentFile.pageCount,
                        min: 1,
                        testTag: "end-point-page",
                        integerOnly: true
                    })
                ]
            }),
            badPages && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                message: "Invalid range, end page must be higher than start page"
            })
        ]
    });
};
const $877a5d4aca591210$var$responseTypeOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        value: "student_choice",
        label: "Student Choice"
    },
    {
        value: "written",
        label: "Written"
    },
    {
        value: "recorded",
        label: "Recorded"
    }
]);
const $877a5d4aca591210$export$fc37fd1a65ee0d47 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { saving: saving , assessment: assessment , setReadingPartType: setReadingPartType , cancelTask: cancelTask , deleteTask: deleteTask , setField: setField , deletingTaskId: deletingTaskId , taskDetailsMap: taskDetailsMap , setStartPage: setStartPage , setEndPage: setEndPage , setQuestionType: setQuestionType , setResponseType: setResponseType , saveTask: saveTask , vocabTaskStep: vocabTaskStep , vocabWord: vocabWord , saveWord: saveWord , setCustomWord: setCustomWord , setWordContent: setWordContent , uploading: uploading , taskErrors: taskErrors , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s , AppData: a  })=>({
            saving: s.saving,
            assessment: s.assessment,
            setReadingPartType: s.setReadingPartType,
            taskDetailsMap: s.taskDetailsMap,
            setField: s.setField,
            deletingTaskId: s.deletingTaskId,
            cancelTask: s.cancelTask,
            deleteTask: s.deleteTask,
            setStartPage: s.setStartPage,
            setEndPage: s.setEndPage,
            setQuestionType: s.setQuestionType,
            setResponseType: s.setResponseType,
            saveTask: s.saveTask,
            vocabTaskStep: s.vocabTaskStep,
            vocabWord: s.vocabWord,
            saveWord: s.saveWord,
            setCustomWord: s.setCustomWord,
            setWordContent: s.setWordContent,
            uploading: s.uploading,
            taskErrors: s.taskErrors,
            isRecording: a.isRecording
        }), []);
    const currentTaskDetails = (0, $287cdf9ff6f919ba$export$af9af7e2c4e0b6ed)();
    const readingTaskDetails = (0, $287cdf9ff6f919ba$export$298ffe52626b705d)();
    if (!currentTaskDetails) return null;
    if (!assessment) return null;
    const badPages = currentTaskDetails.type === "ReadingTask" && currentTaskDetails.task.readingPartType === "pages" ? currentTaskDetails.task.endPoint.pageNumber < currentTaskDetails.task.startPoint.pageNumber : false;
    const deletingTask = deletingTaskId ? taskDetailsMap.get(deletingTaskId) : null;
    const deleteButton = (currentTaskDetails.type === "ComprehensionTask" || currentTaskDetails.type === "ModelTask" || currentTaskDetails.type === "VocabTask") && currentTaskDetails.task.status !== "empty" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>setField("deletingTaskId")(currentTaskDetails.task.id),
                loading: saving,
                color: "danger",
                displayType: "outline",
                disabled: isRecording,
                children: "Delete"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            })
        ]
    });
    const deleteModal = deletingTask && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: Boolean(deletingTask),
        close: ()=>setField("deletingTaskId")(undefined),
        header: "Delete Task?",
        testTag: "delete-task-modal",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "link",
                    color: "primaryBlue",
                    onClick: ()=>setField("deletingTaskId")(undefined),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "primaryBlue",
                    onClick: ()=>deleteTask(deletingTask.task.id, query, history),
                    children: "Delete"
                })
            ]
        }),
        children: [
            "Are you sure you would like to delete ",
            deletingTask.task.name,
            "?"
        ]
    });
    if (currentTaskDetails.type === "ReadingTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "How much of the text do you want to assign?"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        wrap: "wrap",
                        children: $877a5d4aca591210$var$textTypes[currentTaskDetails.contentFile?.type ?? "TextStoredFile"].map((textType)=>{
                            return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d0e0401e7c6ddc0a$export$434199a0f9f2515), {
                                        onClick: ()=>setReadingPartType(currentTaskDetails.task.id, textType),
                                        active: currentTaskDetails.task.readingPartType === textType,
                                        children: $877a5d4aca591210$var$prettyReadingPartTypes[textType]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 2
                                    })
                                ]
                            }, textType);
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($877a5d4aca591210$var$SelectTextHelpText, {
                        currentTaskDetails: currentTaskDetails,
                        taskErrors: taskErrors
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($877a5d4aca591210$var$PageSelector, {
                        currentTaskDetails: currentTaskDetails,
                        setStartPage: setStartPage,
                        setEndPage: setEndPage,
                        badPages: badPages
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>cancelTask(currentTaskDetails.task.id),
                loading: saving,
                displayType: "outline",
                color: "white",
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                type: "submit",
                loading: saving,
                disabled: badPages,
                children: "Save Task"
            })
        ]
    });
    else if (currentTaskDetails.type === "ComprehensionTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 1,
                direction: "column",
                align: "stretch",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Task Format"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Comprehension Question"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 6
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Question Format"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                        active: currentTaskDetails.task.questionType === "recorded",
                        icon: "microphone",
                        onClick: ()=>setQuestionType(currentTaskDetails.task.id, "recorded"),
                        disabled: isRecording,
                        children: "Record Question"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 1
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                        active: currentTaskDetails.task.questionType === "written",
                        icon: "edit",
                        onClick: ()=>setQuestionType(currentTaskDetails.task.id, "written"),
                        disabled: isRecording,
                        children: "Written Question"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 6
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Response Settings"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                        name: "responseType",
                        value: currentTaskDetails.task.responseType,
                        options: $877a5d4aca591210$var$responseTypeOptions,
                        onChange: (value)=>setResponseType(currentTaskDetails.task.id, value),
                        disabled: isRecording
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            deleteButton,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>cancelTask(currentTaskDetails.task.id),
                loading: saving,
                displayType: "outline",
                color: "white",
                disabled: isRecording,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>saveTask({
                        taskDetails: currentTaskDetails,
                        query: query,
                        history: history
                    }),
                loading: saving,
                disabled: isRecording || currentTaskDetails.task.questionType === "undecided" || currentTaskDetails.task.questionType === "recorded" && currentTaskDetails.questionRecordingSequence.processingStatus === "waiting" && !currentTaskDetails.questionAudioFile,
                children: "Save Question"
            }),
            deleteModal
        ]
    });
    else if (currentTaskDetails.type === "ModelTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 1,
                direction: "column",
                align: "stretch",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Task Format"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Model Reading"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 6
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Modeling a reading is scientifically proven to help your students become better readers. Try recording yourself reading some or all of the text to give your students a reference."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            deleteButton,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>cancelTask(currentTaskDetails.task.id),
                loading: saving,
                displayType: "outline",
                color: "white",
                disabled: isRecording,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>saveTask({
                        taskDetails: currentTaskDetails,
                        query: query,
                        history: history
                    }),
                loading: saving,
                disabled: isRecording || currentTaskDetails.recordingSequence.processingStatus === "waiting" && !currentTaskDetails.audioFile,
                children: "Save Model Reading"
            }),
            deleteModal
        ]
    });
    else if (currentTaskDetails.type === "VocabTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 1,
                direction: "column",
                align: "stretch",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Task Format"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Vocabulary Task"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 8
                    }),
                    vocabTaskStep === "word" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            readingTaskDetails?.reading.contentType === "independent" || readingTaskDetails?.reading.contentType === "pdf" || readingTaskDetails?.reading.contentType === "pdf_by_page" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h5",
                                        children: "Enter the word you wish to scaffold"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                                ]
                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h5",
                                        children: "Click on the word in the reading that you wish to scaffold"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $305adc5b3dd45e98$export$405b1ba3701f58c6), {
                                        color: "gray2",
                                        children: "OR"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h5",
                                        children: "Enter word manually"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                name: "vocabWord",
                                label: "Vocabulary Word",
                                type: "text",
                                value: currentTaskDetails.word?.content || "",
                                onChange: (word)=>{
                                    setField("vocabWord")(word);
                                    setWordContent(currentTaskDetails.task.id, word);
                                    setCustomWord(currentTaskDetails.task.id, word);
                                }
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: [
                            "According to the science of reading, previewing vocabulary is one of the most effective ways to augment student vocabulary acquisition.",
                            " ",
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                                href: "https://readleesupport.zendesk.com/hc/en-us/articles/14127734413325",
                                newTab: true,
                                children: "See blog post."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            deleteButton,
            vocabTaskStep === "details" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "outline",
                        color: "white",
                        onClick: ()=>{
                            setField("vocabTaskStep")("word");
                            setField("vocabWord")(currentTaskDetails.word?.content || "");
                        },
                        loading: saving,
                        children: "Change Word"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>cancelTask(currentTaskDetails.task.id),
                loading: saving,
                displayType: "outline",
                color: "white",
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>vocabTaskStep === "word" ? saveWord(currentTaskDetails.task.id) : saveTask({
                        taskDetails: currentTaskDetails,
                        query: query,
                        history: history
                    }),
                loading: saving,
                disabled: vocabTaskStep === "word" && !vocabWord || uploading,
                children: vocabTaskStep === "word" ? "Continue" : "Save Vocabulary Task"
            }),
            deleteModal
        ]
    });
    else throw new Error("Unrecognized task type");
};




var $g5BLJ = parcelRequire("g5BLJ");












const $b029ba57e367a36d$var$HeaderTag = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "AssignmentInstructions__HeaderTag",
    componentId: "sc-1l81xo0-0"
})([
    "background:",
    ";color:",
    ";padding:",
    ";border-radius:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[1]);
const $b029ba57e367a36d$export$4d4333860014341f = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { assessment: assessment , editingInstructions: editingInstructions , instructionDetails: instructionDetails , editingWrittenInstructions: editingWrittenInstructions , setField: setField , errors: errors , saving: saving , cancel: cancel , submit: submit , onInstructionsRecordingSequenceStatus: onInstructionsRecordingSequenceStatus , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s , AppData: a  })=>({
            assessment: s.assessment,
            editingInstructions: s.editingInstructions,
            instructionDetails: s.instructionDetails,
            editingWrittenInstructions: s.editingWrittenInstructions,
            setField: s.setField,
            setAssessmentField: s.setAssessmentField,
            errors: s.errors,
            saving: s.saving,
            cancel: s.cancel,
            submit: s.submit,
            onInstructionsRecordingSequenceStatus: s.onInstructionsRecordingSequenceStatus,
            isRecording: a.isRecording
        }), []);
    if (!assessment) return null;
    const getInstructionsText = ()=>{
        if (assessment.instructions && instructionDetails?.audioFile?.url) return "You added written and recorded instructions";
        else if (assessment.instructions) return "You added written instructions";
        else if (instructionDetails?.audioFile?.url) return "You added recorded instructions";
        else return "No instructions given";
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Instructions"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        onClick: ()=>setField("editingInstructions")(true),
                        color: "primaryBlue",
                        testTag: "startEditInstructions",
                        children: "Edit"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                testTag: "assessmentInstructions",
                children: getInstructionsText()
            }),
            editingInstructions && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
                openType: "state",
                opened: editingInstructions,
                header: "Assignment Instructions",
                close: cancel,
                disableFadeClose: true,
                disableClose: isRecording,
                footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: cancel,
                            displayType: "link",
                            color: "primaryBlue",
                            disabled: isRecording || saving,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            loading: saving,
                            onClick: ()=>submit({
                                    query: query,
                                    history: history
                                }),
                            disabled: isRecording,
                            children: "Save"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "500px",
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            weightOverride: "bold",
                            children: "You can add written instructions, recorded instructions, or both to the assignment to help guide your students."
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 8
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b029ba57e367a36d$var$HeaderTag, {
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h5",
                                children: "Written Instructions"
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            type: "text-area",
                            name: "instructions",
                            label: "",
                            placeholder: "Your students will see any written instructions you put here.",
                            value: editingWrittenInstructions,
                            onChange: setField("editingWrittenInstructions"),
                            errors: errors,
                            width: "100%",
                            height: "250px",
                            disabled: isRecording
                        }),
                        instructionDetails?.instructionsRecordingSequence && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 8
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b029ba57e367a36d$var$HeaderTag, {
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h5",
                                        children: "Recorded Instructions"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 4
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    align: "center",
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            color: "gray7",
                                            children: "Your students will be able to listen to any instructions you record here."
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 4
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            align: "center",
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$de95611a92ae0566), {
                                                recordingSequence: instructionDetails.instructionsRecordingSequence,
                                                audioFile: instructionDetails.audioFile,
                                                onRecordingSequenceStatus: onInstructionsRecordingSequenceStatus,
                                                displayType: "desktopSmall"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};






const $53e7cb0543813ac5$export$26fb4cef31a03047 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { assessment: assessment , editingTitle: editingTitle , setField: setField , setAssessmentField: setAssessmentField , errors: errors , saving: saving , cancel: cancel , submit: submit  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s  })=>({
            assessment: s.assessment,
            editingTitle: s.editingTitle,
            setField: s.setField,
            setAssessmentField: s.setAssessmentField,
            errors: s.errors,
            saving: s.saving,
            cancel: s.cancel,
            submit: s.submit
        }), []);
    if (!assessment) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Title"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        onClick: ()=>setField("editingTitle")(true),
                        color: "primaryBlue",
                        testTag: "startEditTitle",
                        children: "Edit"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h4",
                testTag: "assessmentName",
                children: assessment.name
            }),
            editingTitle && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
                openType: "state",
                opened: editingTitle,
                header: "Assignment Title",
                close: cancel,
                disableFadeClose: true,
                footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: cancel,
                            displayType: "link",
                            color: "primaryBlue",
                            disabled: saving,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            loading: saving,
                            onClick: ()=>submit({
                                    query: query,
                                    history: history
                                }),
                            children: "Save"
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                    type: "text",
                    name: "name",
                    label: "Assignment Title",
                    value: assessment.name,
                    onChange: setAssessmentField("name"),
                    errors: errors
                })
            })
        ]
    });
};








const $c2a48b73d9e6e418$var$EXPLANATIONS = {
    private: "Your assignment will not be shared with other teachers.",
    school: "Your assignment will be shared with all teachers in your school.",
    district: "Your assignment will be shared with all teachers in your district.",
    public_preview: "Your assignment will be shared with all other teachers."
};
const $c2a48b73d9e6e418$export$ce815b8ed8689ade = ()=>{
    const { sharingOpen: sharingOpen , setField: setField , editingPublishingStatus: editingPublishingStatus , updatePublishingStatus: updatePublishingStatus , togglePublishingStatus: togglePublishingStatus , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s , AppData: a  })=>({
            sharingOpen: s.sharingOpen,
            setField: s.setField,
            editingPublishingStatus: s.editingPublishingStatus,
            updatePublishingStatus: s.updatePublishingStatus,
            togglePublishingStatus: s.togglePublishingStatus,
            currentUser: a.currentUser
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: sharingOpen,
        header: "Assignment Sharing Settings",
        close: ()=>setField("sharingOpen")(false),
        disableFadeClose: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            onClick: updatePublishingStatus,
            testTag: "sharingSaveButton",
            children: (0, $62e5f0fd429b4502$export$74634d91e494b98a)(editingPublishingStatus) ? "Share with teachers" : "Do not share with teachers"
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Share assignment with other teachers?"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2,
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        flex: true,
                        type: "toggle",
                        name: "toggleSharing",
                        value: (0, $62e5f0fd429b4502$export$74634d91e494b98a)(editingPublishingStatus),
                        onChange: ()=>togglePublishingStatus(Boolean(currentUser?.paperId)),
                        width: "auto"
                    })
                ]
            }),
            (0, $62e5f0fd429b4502$export$74634d91e494b98a)(editingPublishingStatus) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "publishingType",
                        type: "select",
                        value: editingPublishingStatus,
                        onChange: setField("editingPublishingStatus"),
                        options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                            {
                                value: "school",
                                label: "Sharing with my School"
                            },
                            {
                                value: "district",
                                label: "Sharing with my District"
                            },
                            {
                                value: "public_preview",
                                label: "Sharing with Everyone"
                            }
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 6
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h6",
                color: "paperBlue",
                children: $c2a48b73d9e6e418$var$EXPLANATIONS[editingPublishingStatus]
            })
        ]
    });
};


const $7661d18c15d0a1f5$export$40b3d8a82e37a5ce = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const showSampleToggle = query.get("showSample");
    const { assessment: assessment , taskDetailsMap: taskDetailsMap , saving: saving , currentUser: currentUser , primaryLicenseType: primaryLicenseType , updateSampleStatus: updateSampleStatus , setField: setField , startSharing: startSharing  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s , AppData: a  })=>({
            assessment: s.assessment,
            taskDetailsMap: s.taskDetailsMap,
            saving: s.saving,
            dirty: s.dirty,
            startSharing: s.startSharing,
            setField: s.setField,
            currentUser: a.currentUser,
            primaryLicenseType: s.primaryLicenseType,
            updateSampleStatus: s.updateSampleStatus
        }), []);
    const rts = (0, $287cdf9ff6f919ba$export$298ffe52626b705d)();
    if (!assessment) return null;
    if (!currentUser) return null;
    const canShare = (primaryLicenseType, licenseType)=>{
        if ((0, $75cd274e63beb59b$export$a71c09bab744fd37)(currentUser.accountType)) return true;
        if (primaryLicenseType) return [
            "open_source",
            "open_source_needs_review",
            "school",
            "district"
        ].includes(primaryLicenseType);
        return [
            "open_source",
            "open_source_needs_review",
            "private_user_content",
            "school",
            "district"
        ].includes(licenseType ?? "");
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        grow: 1,
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 1,
                direction: "column",
                align: "stretch",
                overflowY: "auto",
                minHeight: 0,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $53e7cb0543813ac5$export$26fb4cef31a03047), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 10
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b029ba57e367a36d$export$4d4333860014341f), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 10
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "Manage Tasks"
                    }),
                    assessment.taskOrder.map(({ taskId: taskId  })=>{
                        const taskDetails = taskDetailsMap.get(taskId);
                        if (!taskDetails) return null;
                        const commonProps = {
                            to: `/t/assignment-builder/${assessment.id}/tasks${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                                currentTaskId: taskId
                            })}`,
                            active: taskId === taskDetails.task.id,
                            children: taskDetails.task.name,
                            rightText: "Edit",
                            onClick: ()=>setField("drawerExpanded")(false)
                        };
                        if (taskDetails.type === "ReadingTask") {
                            const isIndependent = taskDetails.reading.contentType === "independent";
                            return /*#__PURE__*/ (0, $g5BLJ.createElement)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                                ...commonProps,
                                key: taskId,
                                icon: "microphone",
                                disabled: isIndependent,
                                rightText: isIndependent ? "" : "Edit"
                            });
                        } else if (taskDetails.type === "ComprehensionTask") return /*#__PURE__*/ (0, $g5BLJ.createElement)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            ...commonProps,
                            key: taskId,
                            icon: "task"
                        });
                        else if (taskDetails.type === "ModelTask") return /*#__PURE__*/ (0, $g5BLJ.createElement)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            ...commonProps,
                            key: taskId,
                            icon: "microphone"
                        });
                        else if (taskDetails.type === "VocabTask") return /*#__PURE__*/ (0, $g5BLJ.createElement)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            ...commonProps,
                            key: taskId,
                            icon: "vocab",
                            onClick: ()=>setField("vocabTaskStep")("details")
                        });
                        else throw new Error(`Unrecognized task type.`);
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                        to: `/t/assignment-builder/${assessment.id}/tasks/new`,
                        active: false,
                        icon: "add",
                        rightIcon: true,
                        children: "Add Task"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3
                    }),
                    canShare(primaryLicenseType, rts?.reading?.license) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h5",
                                        children: "Sharing"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 1,
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $014f444f542f72d0$export$4fe1c22bc4285940), {
                                        isPaperUser: Boolean(currentUser?.paperSyncedAt)
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2,
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        testTag: "sharing-on-off",
                                        children: (0, $62e5f0fd429b4502$export$74634d91e494b98a)(assessment.publishingStatus) ? "ON" : "OFF"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        onClick: startSharing,
                                        color: "primaryBlue",
                                        testTag: "startEditSharing",
                                        children: "Edit"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2a48b73d9e6e418$export$ce815b8ed8689ade), {})
                        ]
                    }),
                    (0, $75cd274e63beb59b$export$a71c09bab744fd37)(currentUser.accountType) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            assessment.publishingStatus === "public_preview" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                children: [
                                    "Published! ",
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $362ac0aa9af5ef61$export$e5ff2bc79de811b1), {
                                        kind: "link",
                                        copyContent: `${(0, $0fe4eaef81db718a$export$625c2ae8ba020e36)}/t/public-preview?assessmentId=${assessment.id}`,
                                        children: "Copy link here!"
                                    })
                                ]
                            }),
                            showSampleToggle === "1" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                        flex: true,
                                        type: "toggle",
                                        name: "isSample",
                                        label: "Sample Assignment",
                                        value: assessment.isSample,
                                        onChange: updateSampleStatus
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                to: `/reading-studio${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                    assessmentId: assessment?.id,
                    backPath: `${pathname}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                    showInstructions: true
                })}`,
                loading: saving,
                disabled: !assessment.name,
                displayType: "outline",
                color: "white",
                children: "Preview Assignment"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                to: `/t/assignments/${assessment.id}/assign?assessmentId=${assessment.id}`,
                loading: saving,
                disabled: !assessment.name,
                children: "Finish & Review"
            })
        ]
    });
};







const $dbe04f197b9794be$export$1d819c4eff1f3a5a = ()=>{
    const { createComprehensionTask: createComprehensionTask , createModelReading: createModelReading , creatingTask: creatingTask , cancelTask: cancelTask , createVocabTask: createVocabTask , assessment: assessment , currentUser: currentUser , currentPlan: currentPlan , startAssignmentUpgrade: startAssignmentUpgrade , upgradeAssessmentAndStartVocab: upgradeAssessmentAndStartVocab  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s , AppData: ad , UpgradeAssignmentModalData: ua  })=>({
            upgradeAssessmentAndStartVocab: s.upgradeAssessmentAndStartVocab,
            assessment: s.assessment,
            cancelTask: s.cancelTask,
            createComprehensionTask: s.createComprehensionTask,
            createModelReading: s.createModelReading,
            createVocabTask: s.createVocabTask,
            creatingTask: s.creatingTask,
            currentUser: ad.currentUser,
            currentPlan: ad.currentPlan,
            startAssignmentUpgrade: ua.startAssignmentUpgrade
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const vocabEnabled = (0, $4ded3b2c5af96cca$export$cff2a6c9a7debd3)("isVocabularyEnabled", currentUser, assessment, false);
    const usageCapsEnabled = currentPlan.isUsageCapsEnabled;
    const availableUltimateAssessments = currentUser?.ultimateAssessmentsAvailable ?? 0;
    const canUseUltimateAssessment = usageCapsEnabled && availableUltimateAssessments > 0;
    const hasModelTask = !assessment?.taskOrder.filter((task)=>task.type === "ModelTask").isEmpty();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        grow: 1,
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        textTransform: "uppercase",
                        children: "New Task"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h2",
                        children: "Select Task Format"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                        active: false,
                        icon: "task",
                        onClick: ()=>createComprehensionTask(history),
                        loading: creatingTask,
                        children: "Comprehension Question"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                        content: "You can only add one model reading per assignment",
                        disabled: !hasModelTask,
                        containerWidthOverride: "100%",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            active: false,
                            icon: "microphone",
                            onClick: ()=>createModelReading(history),
                            loading: creatingTask,
                            disabled: hasModelTask,
                            children: "Model Reading"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
                        enabled: !vocabEnabled,
                        content: `Upgrade to ${(0, $4ded3b2c5af96cca$export$52756c3ad45aa25c)} and unlock vocabulary scaffolding`,
                        linkLocation: "contact",
                        display: "flex",
                        usageCapsEnabled: usageCapsEnabled,
                        availableUltimateAssessments: availableUltimateAssessments,
                        onClick: ()=>startAssignmentUpgrade(assessment?.id ?? "", "vocabTask"),
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            disabled: !vocabEnabled && !canUseUltimateAssessment,
                            active: false,
                            icon: "vocab",
                            onClick: !vocabEnabled && !assessment?.isUltimate ? ()=>startAssignmentUpgrade(assessment?.id ?? "", "vocabTask") : ()=>createVocabTask(history),
                            rightText: vocabEnabled ? "" : (0, $4ded3b2c5af96cca$export$52756c3ad45aa25c),
                            rightTextColor: "gray5",
                            children: "Vocabulary"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>cancelTask(),
                displayType: "outline",
                color: "white",
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $822922ed63c79903$export$1a6938bd84cc541a), {
                onSuccess: upgradeAssessmentAndStartVocab(history)
            })
        ]
    });
};




const $70ac9ebe4c7f99a2$export$ccb1900960625edf = ()=>{
    const currentTaskDetails = (0, $287cdf9ff6f919ba$export$af9af7e2c4e0b6ed)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1941c1cb7fdcc73d$export$206b65ea4daedc5b), {
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                    path: "/t/assignment-builder/:assessmentId/tasks/new",
                    exact: true,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $dbe04f197b9794be$export$1d819c4eff1f3a5a), {})
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                    children: currentTaskDetails ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $877a5d4aca591210$export$fc37fd1a65ee0d47), {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7661d18c15d0a1f5$export$40b3d8a82e37a5ce), {})
                })
            ]
        })
    });
};







const $5e17a246a489abcb$export$6ccddfc5b72bae18 = ()=>{
    const { assessment: assessment , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s , AppData: a  })=>({
            assessment: s.assessment,
            isRecording: a.isRecording
        }), []);
    const { coverImageFile: coverImageFile , reading: reading , author: author  } = (0, $287cdf9ff6f919ba$export$298ffe52626b705d)() ?? {};
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d361bb1339f62201$export$d390129da57cce20), {
        rightButtons: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
            children: assessment && reading && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                displayType: "outline",
                to: `/t/reading-builder?assessmentId=${assessment.id}&readingId=${reading.id}`,
                disabled: isRecording,
                children: reading.contentType === "independent" ? "Add Content" : "Edit Text"
            })
        }),
        thumbnailUrl: coverImageFile?.thumbnailUrl,
        readingTitle: reading?.name,
        authorName: author?.name,
        webSourceUrl: reading?.webSourceUrl
    });
};








const $45fae8392b5279fd$var$VocabImageStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).img.withConfig({
    displayName: "AssignmentBuilder__VocabImageStyles",
    componentId: "sc-18u9gt0-0"
})([
    "max-height:300px;max-width:400px;object-fit:contain;object-position:left;"
]);
const $45fae8392b5279fd$var$MainContent = ()=>{
    const readingTaskDetails = (0, $287cdf9ff6f919ba$export$298ffe52626b705d)();
    const currentTaskDetails = (0, $287cdf9ff6f919ba$export$af9af7e2c4e0b6ed)();
    const vocabTaskDetailsList = (0, $287cdf9ff6f919ba$export$f79545bc5672622d)();
    const taskType = currentTaskDetails ? currentTaskDetails.type : "";
    const drawerOpen = taskType === "ComprehensionTask";
    const { setTextRange: setTextRange , assessment: assessment , vocabTaskStep: vocabTaskStep , setField: setField , vocabImageFileUrl: vocabImageFileUrl , setDefinition: setDefinition , setCustomWord: setCustomWord , setVocabImage: setVocabImage , uploadVocabImage: uploadVocabImage , setWordContent: setWordContent  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s  })=>({
            setTextRange: s.setTextRange,
            assessment: s.assessment,
            setVocabWord: s.setVocabWord,
            vocabTaskStep: s.vocabTaskStep,
            setField: s.setField,
            vocabImageFileUrl: s.vocabImageFileUrl,
            setDefinition: s.setDefinition,
            setCustomWord: s.setCustomWord,
            setVocabImage: s.setVocabImage,
            uploadVocabImage: s.uploadVocabImage,
            setWordContent: s.setWordContent
        }), []);
    return vocabTaskStep === "details" && currentTaskDetails && currentTaskDetails.type === "VocabTask" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        justify: "start",
        align: "start",
        width: "100%",
        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[20],
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            width: "100%",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray6",
                    children: "Word"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            name: "vocabWord",
                            type: "text",
                            value: currentTaskDetails.task.customWord,
                            onChange: (word)=>setCustomWord(currentTaskDetails.task.id, word),
                            width: "200px"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        }),
                        currentTaskDetails.word?.audioUrl && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                            src: currentTaskDetails.word.audioUrl,
                            displayType: "iconOnly",
                            icon: "speaker",
                            iconColor: "black",
                            testTag: "vocab-audio"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                    name: "definition",
                    type: "text-area",
                    value: currentTaskDetails.task.definition,
                    onChange: (definition)=>setDefinition(currentTaskDetails.task.id, definition),
                    label: "Definition",
                    resize: "vertical",
                    minHeight: "150px"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray6",
                    children: "Image (optional)"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                vocabImageFileUrl || currentTaskDetails.imageFile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($45fae8392b5279fd$var$VocabImageStyles, {
                            src: vocabImageFileUrl || currentTaskDetails.imageFile?.url,
                            alt: currentTaskDetails.task.customWord,
                            "data-test-tag": "vocab-image"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h6",
                            ellipsis: true,
                            maxWidth: "100%",
                            children: currentTaskDetails.imageFile?.name || /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    "Uploading... ",
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            onClick: ()=>{
                                setField("vocabImageFileUrl")("");
                                setField("vocabImageFile")(null);
                                setVocabImage(currentTaskDetails.task.id, null);
                            },
                            color: "danger",
                            paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
                            width: "fit-content",
                            children: "Remove Image"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    border: `1px solid ${(0, $24b764039c44d1ec$export$8f45430ccf837300)["primaryBlue"].hex}`,
                    borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
                    width: "fit-content",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        id: "vocab-image-input",
                        name: "vocabImageFile",
                        type: "file",
                        width: "auto",
                        value: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                        onChange: uploadVocabImage(currentTaskDetails.task.id),
                        accept: "image",
                        testTag: "vocab-image",
                        flex: true,
                        iconColor: "primaryBlue",
                        kind: "imagePreview"
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2eb83a4c56813824$export$2f7a2f0e90c07dc4), {
        instructions: (0, $62e5f0fd429b4502$export$c9df4e1f27f016e5)(assessment),
        readingTaskDetails: readingTaskDetails,
        onTextRangeSelected: readingTaskDetails ? setTextRange(readingTaskDetails.task.id) : undefined,
        drawerOpen: drawerOpen,
        selectableText: currentTaskDetails?.type === "VocabTask",
        vocabTask: currentTaskDetails?.type === "VocabTask" ? currentTaskDetails.task : null,
        highlightedWord: currentTaskDetails?.type === "VocabTask" ? currentTaskDetails.word?.content : undefined,
        setVocabWord: (word)=>{
            setField("vocabWord")(word);
            if (currentTaskDetails) {
                setWordContent(currentTaskDetails?.task.id, word);
                setCustomWord(currentTaskDetails?.task.id, word);
            }
        },
        enableTextRangeSelection: !(currentTaskDetails?.type !== "VocabTask" && currentTaskDetails?.type !== "ReadingTask"),
        vocabTaskDetailsList: currentTaskDetails?.type !== "VocabTask" ? vocabTaskDetailsList : undefined,
        displayTypeOverride: currentTaskDetails?.type !== "VocabTask" && currentTaskDetails?.type !== "ReadingTask" ? readingTaskDetails?.task.readingPartType === "start_and_end_index" ? "setTextRange" : "dictionary" : undefined,
        compactLayout: false
    });
};
const $45fae8392b5279fd$var$DrawerContent = ()=>{
    const { assessment: assessment , onRecordingSequenceStatus: onRecordingSequenceStatus , setWrittenContent: setWrittenContent , taskErrors: taskErrors , drawerExpanded: drawerExpanded , setField: setField , emitPaperEvent: emitPaperEvent  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s , AppData: ad  })=>({
            assessment: s.assessment,
            onRecordingSequenceStatus: s.onRecordingSequenceStatus,
            setWrittenContent: s.setWrittenContent,
            taskErrors: s.taskErrors,
            drawerExpanded: s.drawerExpanded,
            setField: s.setField,
            emitPaperEvent: ad.emitPaperEvent
        }), []);
    const currentTaskDetails = (0, $287cdf9ff6f919ba$export$af9af7e2c4e0b6ed)();
    const recordingSequenceId = currentTaskDetails?.type === "ComprehensionTask" && currentTaskDetails.task.questionType === "recorded" ? currentTaskDetails.questionRecordingSequence.id : currentTaskDetails?.type === "ModelTask" ? currentTaskDetails.recordingSequence.id : "";
    if (currentTaskDetails?.type === "ComprehensionTask") {
        if (currentTaskDetails.task.questionType === "recorded") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$de95611a92ae0566), {
                        recordingSequence: currentTaskDetails.questionRecordingSequence,
                        audioFile: currentTaskDetails.questionAudioFile,
                        onRecordingSequenceStatus: onRecordingSequenceStatus,
                        onRecordingStart: (recordingId)=>{
                            if (!assessment || !recordingSequenceId) return;
                            emitPaperEvent({
                                type: "literacy_recording_started_v3",
                                taskId: currentTaskDetails.task.id,
                                assessmentId: assessment.id,
                                recordingSequenceId: recordingSequenceId,
                                recordingId: recordingId
                            });
                        },
                        onRecordingStop: (recordingId)=>{
                            if (!assessment || !recordingSequenceId) return;
                            emitPaperEvent({
                                type: "literacy_recording_ended_v3",
                                taskId: currentTaskDetails?.task.id,
                                assessmentId: assessment?.id,
                                recordingId: recordingId,
                                recordingSequenceId: recordingSequenceId
                            });
                        },
                        displayType: "desktopSmall"
                    })
                })
            })
        });
        else if (currentTaskDetails.task.questionType === "written") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
            expanded: drawerExpanded,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "end",
                width: "100%",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "space-between",
                        align: "center",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h5",
                                children: "Question prompt:"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2364f311682cff2$export$7029a83b832ebcac), {
                                expanded: drawerExpanded,
                                toggleOpen: ()=>setField("drawerExpanded")(!drawerExpanded)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: drawerExpanded ? "100%" : "500px",
                        direction: "column",
                        height: "100%",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2afb870564c4e4d2$export$ce9b1cc0c34506d0), {
                                name: "writtenContent",
                                value: currentTaskDetails.task.writtenContent,
                                onChange: (value)=>setWrittenContent(currentTaskDetails.task.id, value),
                                placeholder: "Write your question here",
                                height: "100%"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                                errors: taskErrors.get(currentTaskDetails.task.id, (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()),
                                errorKey: "writtenContent"
                            })
                        ]
                    })
                ]
            })
        });
    } else if (currentTaskDetails?.type === "ModelTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$de95611a92ae0566), {
                recordingSequence: currentTaskDetails.recordingSequence,
                audioFile: currentTaskDetails.audioFile,
                onRecordingSequenceStatus: onRecordingSequenceStatus,
                displayType: "desktopSmall",
                onRecordingStart: (recordingId)=>{
                    if (!assessment || !recordingSequenceId) return;
                    emitPaperEvent({
                        type: "literacy_recording_started_v3",
                        taskId: currentTaskDetails.task.id,
                        assessmentId: assessment.id,
                        recordingSequenceId: recordingSequenceId,
                        recordingId: recordingId
                    });
                },
                onRecordingStop: (recordingId)=>{
                    if (!assessment || !recordingSequenceId) return;
                    emitPaperEvent({
                        type: "literacy_recording_ended_v3",
                        taskId: currentTaskDetails?.task.id,
                        assessmentId: assessment?.id,
                        recordingId: recordingId,
                        recordingSequenceId: recordingSequenceId
                    });
                }
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            })
        ]
    });
    return null;
};
const $45fae8392b5279fd$export$17173192ecbde129 = ()=>{
    const params = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const { assessmentId: assessmentId  } = params;
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const readingId = query.get("readingId", null);
    const currentTaskId = query.get("currentTaskId", null);
    const readingTaskDetails = (0, $287cdf9ff6f919ba$export$298ffe52626b705d)();
    const { loading: loading , load: load , submit: submit , dirty: dirty , cancelling: cancelling , finishCancel: finishCancel , drawerExpanded: drawerExpanded  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AssignmentBuilderData: s  })=>({
            loading: s.loading,
            load: s.load,
            submit: s.submit,
            dirty: s.dirty,
            cancelling: s.cancelling,
            finishCancel: s.finishCancel,
            drawerExpanded: s.drawerExpanded
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        load({
            assessmentId: assessmentId,
            readingId: readingId,
            currentTaskId: currentTaskId
        });
    }, [
        load,
        assessmentId,
        readingId,
        currentTaskId
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (cancelling && !dirty) finishCancel({
            history: history,
            query: query
        });
    }, [
        cancelling,
        dirty,
        finishCancel,
        query,
        history
    ]);
    (0, $a43aa4efcef0fffa$export$3a8a63c2fd80d3b0)({
        smallerThan: "desktop"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2a0812bc157eca24$export$69546dc4b644da69), {
        showTopBarDivider: ![
            "PdfStoredFile",
            "PdfByPageStoredFile"
        ].includes(readingTaskDetails?.contentFile?.type || ""),
        loading: loading,
        topBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5e17a246a489abcb$export$6ccddfc5b72bae18), {}),
        sideBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $70ac9ebe4c7f99a2$export$ccb1900960625edf), {}),
        onSubmit: ()=>submit({
                query: query,
                history: history
            }),
        dirty: dirty,
        mainContent: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true,
            kind: "boat"
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($45fae8392b5279fd$var$MainContent, {}),
        drawerContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($45fae8392b5279fd$var$DrawerContent, {}),
        drawerExpanded: drawerExpanded
    });
};






var $g5BLJ = parcelRequire("g5BLJ");





parcelRequire("g5BLJ");





const $8910ef7e15ad2bff$export$78e9c8e9276d9c86 = ()=>{
    return (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tablet"
    });
};


const $2a0812bc157eca24$var$ReadingStudioLayoutBase = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingStudioLayout__ReadingStudioLayoutBase",
    componentId: "sc-91u7fl-0"
})([
    "",
    " display:flex;flex-direction:column;background-color:",
    ";"
], (0, $dba6c5da69120483$export$6988a55f9afa8b34), (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex);
const $2a0812bc157eca24$var$DrawerContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingStudioLayout__DrawerContainer",
    componentId: "sc-91u7fl-1"
})([
    "position:absolute;bottom:0;left:0;right:0;display:flex;justify-content:center;",
    ""
], ({ expanded: expanded  })=>expanded && " top: 82px;");
const $2a0812bc157eca24$var$BottomBar = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingStudioLayout__BottomBar",
    componentId: "sc-91u7fl-2"
})([
    ""
]);
const $2a0812bc157eca24$export$69546dc4b644da69 = ({ loading: loading , bannerContent: bannerContent , showTopBarDivider: showTopBarDivider , mainContent: mainContent , drawerContent: drawerContent , topBar: topBar , sideBar: sideBar , bottomBar: bottomBar , onSubmit: onSubmit , dirty: dirty , drawerExpanded: drawerExpanded = false  })=>{
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    const content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            sideBar,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                grow: 1,
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex,
                borderRadius: compactLayout ? "0" : `${(0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[5]} 0 0 ${(0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[5]}`,
                height: "100%",
                width: "100%",
                position: "relative",
                minWidth: 0,
                minHeight: 0,
                justify: "center",
                children: [
                    topBar,
                    showTopBarDivider && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[5]}`,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {
                            noMargin: true
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        grow: 1,
                        width: "100%",
                        height: "100%",
                        minHeight: 0,
                        overflowY: "auto",
                        justify: "center",
                        children: mainContent
                    }),
                    drawerContent ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2a0812bc157eca24$var$DrawerContainer, {
                        expanded: drawerExpanded,
                        children: drawerContent
                    }) : null,
                    bottomBar ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2a0812bc157eca24$var$BottomBar, {
                        children: bottomBar
                    }) : null
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($2a0812bc157eca24$var$ReadingStudioLayoutBase, {
        children: [
            bannerContent || null,
            onSubmit ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                onSubmit: onSubmit,
                dirty: dirty,
                display: "flex",
                grow: 1,
                minHeight: 0,
                children: content
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 1,
                minHeight: 0,
                children: content
            })
        ]
    });
};











const $67f615b76749e13f$export$2eacb1d819a74aad = ({ thumbnailUrl: thumbnailUrl , readingTitle: readingTitle , authorName: authorName , webSourceUrl: webSourceUrl , justify: justify = "center"  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        grow: 2,
        width: "100%",
        align: "center",
        justify: justify,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$1cd1efc78cb52ca5), {
                src: thumbnailUrl,
                testTag: "reading-studio-layout-top-bar-image",
                size: "small",
                title: readingTitle
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                maxWidth: "280px",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        ellipsis: true,
                        ellipsifiedTitle: readingTitle || "Unknown Book Title",
                        testTag: "reading-studio-layout-top-bar-title",
                        children: readingTitle || "Unknown Book Title"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        children: [
                            webSourceUrl && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        newTab: true,
                                        href: webSourceUrl,
                                        children: new window.URL(webSourceUrl).hostname
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 1,
                                        horizontal: true
                                    }),
                                    "-",
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 1,
                                        horizontal: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h7",
                                color: "gray5",
                                ellipsis: true,
                                ellipsifiedTitle: authorName || "Unknown Author",
                                testTag: "reading-studio-layout-top-bar-author",
                                children: authorName || "Unknown Author"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $d361bb1339f62201$var$DrawerStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingStudioLayoutTopBar__DrawerStyles",
    componentId: "sc-94aia6-0"
})([
    "position:absolute;top:100%;left:0;right:0;color:",
    ";background:",
    ";max-height:calc(100vh - 150px);padding:",
    ";border-radius:0 0 ",
    " ",
    ";z-index:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[3], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised);
const $d361bb1339f62201$var$Drawer = ({ children: children , closeDrawer: closeDrawer  })=>{
    const id = (0, $dd8c6a85a004ead6$export$c485849f2e393253)();
    (0, $7ffd711af926678d$export$27b6b5680688208b)(id, closeDrawer);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($d361bb1339f62201$var$DrawerStyles, {
        id: id,
        children: children
    });
};
const $d361bb1339f62201$export$d390129da57cce20 = ({ leftButton: leftButton , rightButtons: rightButtons , thumbnailUrl: thumbnailUrl , readingTitle: readingTitle , authorName: authorName , webSourceUrl: webSourceUrl , drawer: drawer , closeDrawer: closeDrawer  })=>{
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        justify: "space-between",
        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[compactLayout ? 3 : 5]}`,
        position: "relative",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        grow: 1,
                        width: "100%",
                        children: leftButton || /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {})
                    }),
                    !compactLayout ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67f615b76749e13f$export$2eacb1d819a74aad), {
                        thumbnailUrl: thumbnailUrl,
                        readingTitle: readingTitle,
                        authorName: authorName,
                        webSourceUrl: webSourceUrl
                    }) : null,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        grow: 1,
                        width: "100%",
                        justify: "end",
                        children: rightButtons || /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {})
                    })
                ]
            }),
            drawer && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($d361bb1339f62201$var$Drawer, {
                closeDrawer: closeDrawer,
                children: drawer
            })
        ]
    });
};






const $1941c1cb7fdcc73d$var$SideBarContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingStudioLayoutSideBar__SideBarContainer",
    componentId: "sc-gkp45w-0"
})([
    "width:400px;padding:",
    " ",
    " ",
    " ",
    ";color:",
    ";background:",
    ";min-height:0;overflow-y:auto;"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[8], (0, $8259eb090983b778$export$ea413736286a3bf1)[8], (0, $8259eb090983b778$export$ea413736286a3bf1)[5], (0, $8259eb090983b778$export$ea413736286a3bf1)[8], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex);
const $1941c1cb7fdcc73d$export$206b65ea4daedc5b = ({ primaryButton: primaryButton , content: content  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($1941c1cb7fdcc73d$var$SideBarContainer, {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            justify: "space-between",
            height: "100%",
            children: [
                content || /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {}),
                primaryButton || /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {})
            ]
        })
    });
};






var $g5BLJ = parcelRequire("g5BLJ");





var $g5BLJ = parcelRequire("g5BLJ");







const $e2d3c1727333757d$export$c44a57905a1523a2 = ()=>{
    const { assessment: assessment , taskSubmissionDetailsMap: taskSubmissionDetailsMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            assessment: s.assessment,
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap
        }), []);
    if (!assessment) return null;
    const readingTaskData = assessment.taskOrder.find(({ taskId: taskId , type: type  })=>type === "ReadingTask" && taskSubmissionDetailsMap.has(taskId));
    if (!readingTaskData) return null;
    const readingTaskId = readingTaskData.taskId;
    const readingTaskSubmissionDetails = taskSubmissionDetailsMap.get(readingTaskId);
    if (!readingTaskSubmissionDetails || readingTaskSubmissionDetails.type !== "ReadingTask") return null;
    return readingTaskSubmissionDetails;
};
const $e2d3c1727333757d$export$412252664fd9dc64 = ()=>{
    const { assessment: assessment , taskSubmissionDetailsMap: taskSubmissionDetailsMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            assessment: s.assessment,
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap
        }), []);
    if (!assessment) return null;
    const modelTaskData = assessment.taskOrder.find(({ taskId: taskId , type: type  })=>type === "ModelTask" && taskSubmissionDetailsMap.has(taskId));
    if (!modelTaskData) return null;
    const modelTaskId = modelTaskData.taskId;
    const modelTaskSubmissionDetails = taskSubmissionDetailsMap.get(modelTaskId);
    if (!modelTaskSubmissionDetails || modelTaskSubmissionDetails.type !== "ModelTask") return null;
    return modelTaskSubmissionDetails;
};
const $e2d3c1727333757d$export$387094ddcc67c137 = ()=>{
    const { taskSubmissionDetailsMap: taskSubmissionDetailsMap , currentTaskId: currentTaskId  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap,
            currentTaskId: s.currentTaskId
        }), []);
    const currentTaskSubmissionDetails = currentTaskId ? taskSubmissionDetailsMap.get(currentTaskId, null) : null;
    return currentTaskSubmissionDetails;
};
const $e2d3c1727333757d$export$f79545bc5672622d = ()=>{
    const { taskSubmissionDetailsMap: taskSubmissionDetailsMap , assessment: assessment  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap,
            currentTaskId: s.currentTaskId,
            assessment: s.assessment
        }), []);
    const vocabTaskDetailsList = (0, $g5BLJ.useMemo)(()=>{
        return (assessment?.taskOrder || (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).map((ti)=>taskSubmissionDetailsMap.get(ti.taskId)).filter((t)=>t && t.type === "VocabTask").toList();
    }, [
        taskSubmissionDetailsMap,
        assessment?.taskOrder
    ]);
    return vocabTaskDetailsList;
};
const $e2d3c1727333757d$export$862ae1b5debe05be = ()=>{
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isPublicPreview = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, (0, $62e5f0fd429b4502$export$f96fbc986381319f)));
    return isPublicPreview;
};
const $e2d3c1727333757d$export$287d668d6cc9dd7e = ()=>{
    const { assessment: assessment , taskSubmissionDetailsMap: taskSubmissionDetailsMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            assessment: s.assessment,
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const realCurrentTaskId = query.get("currentTaskId");
    const compactLayout = (0, $005fefce7850bc4a$export$78e9c8e9276d9c86)();
    const currentTaskSubmissionDetails = realCurrentTaskId ? taskSubmissionDetailsMap.get(realCurrentTaskId) : null;
    const currentTaskIndex = assessment?.taskOrder.findIndex((to)=>to.taskId === realCurrentTaskId);
    const taskDetailsList = (0, $d5a1fd3dea1a0ab6$export$8e16b83750b44988)((assessment?.taskOrder || (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()).map((to)=>taskSubmissionDetailsMap.get(to.taskId)));
    return Boolean(compactLayout && taskDetailsList.some((t)=>t.type === "ReadingTask" && t.reading.contentType !== "independent") && (!realCurrentTaskId || assessment?.taskOrder.some((ti)=>ti.type === "ModelTask") && (!currentTaskSubmissionDetails || typeof currentTaskIndex !== "number" || currentTaskIndex === 0 && currentTaskSubmissionDetails.type === "ModelTask")));
};
const $e2d3c1727333757d$export$d88f91fd007bca06 = ()=>{
    const { assessment: assessment , userType: userType  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            assessment: state.ReadingStudioData.assessment,
            userType: state.AppData.currentUser?.accountType || ""
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const backPathParam = query.get("backPath");
    const defaultBackPath = userType === "student" ? "/" : `/t/assignments/${assessment?.id}`;
    return backPathParam || defaultBackPath;
};
const $e2d3c1727333757d$export$3b4170a88823ed17 = ()=>{
    const { assessment: assessment , taskSubmissionDetailsMap: taskSubmissionDetailsMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            assessment: s.assessment,
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap
        }), []);
    const readingTaskSubmissionDetails = $e2d3c1727333757d$export$c44a57905a1523a2();
    if (!assessment) return null;
    const incompleteTask = assessment.taskOrder.map((to)=>taskSubmissionDetailsMap.find((tsd)=>tsd.task.id === to.taskId)).find((tds)=>Boolean(tds && !(0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(tds)));
    const incompleteTaskId = incompleteTask?.task.id ?? readingTaskSubmissionDetails?.task.id;
    return incompleteTaskId;
};
const $e2d3c1727333757d$export$1d4b116713d110e4 = ()=>{
    const { assessment: assessment , currentTaskId: currentTaskId , switchTask: switchTask  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            assessment: s.assessment,
            currentTaskId: s.currentTaskId,
            switchTask: s.switchTask
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const isPublicPreview = $e2d3c1727333757d$export$862ae1b5debe05be();
    const currentTaskSubmissionDetails = $e2d3c1727333757d$export$387094ddcc67c137();
    const backPath = $e2d3c1727333757d$export$d88f91fd007bca06();
    const isInstructionsPage = $e2d3c1727333757d$export$287d668d6cc9dd7e();
    const leaveButton = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        to: backPath,
        borderRadiusOverride: "none",
        color: "gray2",
        children: "Leave"
    });
    if (isInstructionsPage || !currentTaskId || !assessment || !currentTaskSubmissionDetails) return leaveButton;
    const currentTaskIndex = assessment.taskOrder.findIndex((to)=>to.taskId === currentTaskId);
    if (currentTaskIndex === -1 || currentTaskIndex === 0) return leaveButton;
    const prevTaskOrderItem = assessment.taskOrder.get(currentTaskIndex - 1);
    if (!prevTaskOrderItem) return leaveButton;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        onClick: switchTask({
            taskId: prevTaskOrderItem?.taskId,
            query: query,
            history: history,
            isPublicPreview: isPublicPreview
        }),
        testTag: "previous-task-button",
        color: "gray2",
        borderRadiusOverride: "none",
        children: "Previous"
    });
};
const $e2d3c1727333757d$var$submissionButtonLabel = (status, freeRead = false)=>{
    if (freeRead) return status === "finished" ? "Re-Submit" : "Submit";
    return status === "finished" ? "Re-Submit Assignment" : "Turn In Assignment";
};
const $e2d3c1727333757d$export$8b7b7cdfb85d78c5 = ()=>{
    const { assessment: assessment , submission: submission , submitting: submitting , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s , AppData: a  })=>({
            assessment: s.assessment,
            submission: s.submission,
            submitting: s.submitting,
            isRecording: a.isRecording
        }), []);
    const compactLayout = (0, $005fefce7850bc4a$export$78e9c8e9276d9c86)();
    if (!submission) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        type: "submit",
        loading: submitting,
        flexGrow: 1,
        testTag: "submit-assignment-button",
        borderRadiusOverride: compactLayout ? "none" : undefined,
        disabled: isRecording,
        children: $e2d3c1727333757d$var$submissionButtonLabel(submission.status, assessment?.isFreeRead)
    });
};
const $e2d3c1727333757d$export$d32f9c3a9c514093 = ()=>{
    const { assessment: assessment , switchTask: switchTask , currentTaskId: currentTaskId  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            assessment: s.assessment,
            switchTask: s.switchTask,
            currentTaskId: s.currentTaskId
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const isInstructionsPage = $e2d3c1727333757d$export$287d668d6cc9dd7e();
    const isPublicPreview = $e2d3c1727333757d$export$862ae1b5debe05be();
    if (!assessment) return null;
    let currentTaskIndex = null;
    if (isInstructionsPage) {
        if (assessment.taskOrder.some((t)=>t.type === "ModelTask")) currentTaskIndex = 0;
        else currentTaskIndex = -1;
    } else currentTaskIndex = assessment.taskOrder.findIndex((to)=>to.taskId === currentTaskId);
    const nextTaskOrderItem = assessment.taskOrder.get(currentTaskIndex + 1);
    if (!nextTaskOrderItem) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e2d3c1727333757d$export$8b7b7cdfb85d78c5, {});
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        onClick: switchTask({
            taskId: nextTaskOrderItem.taskId,
            query: query,
            history: history,
            isPublicPreview: isPublicPreview
        }),
        flexGrow: 1,
        testTag: "next-task-button",
        borderRadiusOverride: "none",
        children: "Next"
    });
};










const $526117c8dcb45fd6$export$771a55a10b0a40ae = ({ showClose: showClose = false  })=>{
    const { assessment: assessment , taskSubmissionDetailsMap: taskSubmissionDetailsMap , currentTaskId: currentTaskId , isRecording: isRecording , switchTask: switchTask , toggleMobileTaskList: toggleMobileTaskList  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s , AppData: a  })=>({
            assessment: s.assessment,
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap,
            currentTaskId: s.currentTaskId,
            isRecording: a.isRecording,
            switchTask: s.switchTask,
            toggleMobileTaskList: s.toggleMobileTaskList
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isPublicPreview = (0, $e2d3c1727333757d$export$862ae1b5debe05be)();
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    const isInstructionsPage = (0, $e2d3c1727333757d$export$287d668d6cc9dd7e)();
    const firstModelTaskInfo = assessment?.taskOrder.find((to)=>to.type === "ModelTask");
    const firstModelTask = firstModelTaskInfo ? taskSubmissionDetailsMap.get(firstModelTaskInfo.taskId) : null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h4",
                        color: "white",
                        children: "My Tasks"
                    }),
                    showClose && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        displayType: "noStyles",
                        icon: "close",
                        testTag: "close-mobile-task-list",
                        iconColor: "white",
                        iconSize: "1em",
                        onClick: toggleMobileTaskList,
                        disabled: isRecording
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            compactLayout && assessment?.taskOrder.some((ti)=>ti.type === "ModelTask") && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                icon: "modelReading",
                active: isInstructionsPage,
                onClick: switchTask({
                    taskId: null,
                    query: query,
                    history: history,
                    isPublicPreview: isPublicPreview
                }),
                completed: firstModelTask ? (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(firstModelTask) : true,
                disabled: isRecording,
                children: "Instructions"
            }),
            !compactLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                icon: "modelReading",
                active: false,
                onClick: ()=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                        showInstructions: "true"
                    })}`),
                disabled: isRecording,
                children: "Instructions"
            }),
            assessment?.taskOrder.map(({ taskId: taskId  })=>taskSubmissionDetailsMap.get(taskId)?.task).map((task)=>{
                const taskSubmissionDetails = task && taskSubmissionDetailsMap.get(task.id);
                return task && !(compactLayout && task.id === firstModelTask?.task.id) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                    icon: (0, $dfca2c43c391cf73$export$86cab8d3a8167972)(task),
                    active: !isInstructionsPage && task.id === currentTaskId,
                    onClick: switchTask({
                        taskId: task.id,
                        query: query,
                        history: history,
                        isPublicPreview: isPublicPreview
                    }),
                    completed: taskSubmissionDetails && (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails),
                    disabled: isRecording,
                    children: task.name
                }, task.id);
            })
        ]
    });
};





const $8150120c85fc2f4a$export$3f806a8218ef6728 = ()=>{
    const [micSettingsOpened, setMicSettingsOpened] = (0, $g5BLJ.useState)(false);
    const [textSettingsOpened, setTextSettingsOpened] = (0, $g5BLJ.useState)(false);
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    const openMicSettings = (0, $g5BLJ.useCallback)(()=>setMicSettingsOpened(true), []);
    const closeMicSettings = (0, $g5BLJ.useCallback)(()=>setMicSettingsOpened(false), []);
    const openTextSettings = (0, $g5BLJ.useCallback)(()=>setTextSettingsOpened(true), []);
    const closeTextSettings = (0, $g5BLJ.useCallback)(()=>setTextSettingsOpened(false), []);
    const { loading: loading , assessment: assessment , mobileTaskListOpened: mobileTaskListOpened , isRecording: isRecording , toggleMobileTaskList: toggleMobileTaskList , setField: setField , leave: leave  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s , AppData: a  })=>({
            loading: s.loading,
            assessment: s.assessment,
            mobileTaskListOpened: s.mobileTaskListOpened,
            isRecording: a.isRecording,
            toggleMobileTaskList: s.toggleMobileTaskList,
            setField: s.setField,
            leave: s.leave
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const readingTaskSubmissionDetails = (0, $e2d3c1727333757d$export$c44a57905a1523a2)();
    const isPublicPreview = (0, $e2d3c1727333757d$export$862ae1b5debe05be)();
    const { reading: reading , coverImageFile: coverImageFile , author: author  } = readingTaskSubmissionDetails || {};
    const backPath = (0, $e2d3c1727333757d$export$d88f91fd007bca06)();
    const iconSharedProps = {
        paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none,
        displayType: "iconOnly",
        width: "36px",
        height: "36px",
        color: "gray2",
        iconColor: "black",
        iconSize: "24px"
    };
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                flex: true,
                flexHeight: "auto"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            })
        ]
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d361bb1339f62201$export$d390129da57cce20), {
        leftButton: isPublicPreview ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            color: "gray2",
            nav: true,
            onClick: leave(backPath, history),
            icon: "backArrow",
            disabled: isRecording,
            children: "Leave"
        }),
        rightButtons: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            children: [
                compactLayout && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            icon: "menu",
                            onClick: toggleMobileTaskList,
                            testTag: "mobile-task-list",
                            disabled: isRecording,
                            ...iconSharedProps
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        })
                    ]
                }),
                ![
                    "PdfStoredFile",
                    "PdfByPageStoredFile"
                ].includes(readingTaskSubmissionDetails?.contentFile?.type || "") && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            icon: "text",
                            onClick: openTextSettings,
                            testTag: "text-settings",
                            ...iconSharedProps
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 3
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    icon: "settings",
                    onClick: openMicSettings,
                    ...iconSharedProps,
                    disabled: isRecording,
                    testTag: "top-bar-recording-settings"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0770e766331d4fe1$export$b39a1b7d06ee214f), {
                    opened: micSettingsOpened,
                    close: closeMicSettings
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ed14308b705832ba$export$f0753697e9ebcd44), {
                    opened: textSettingsOpened,
                    close: closeTextSettings
                })
            ]
        }),
        thumbnailUrl: coverImageFile?.thumbnailUrl,
        readingTitle: reading?.name,
        authorName: (0, $62e5f0fd429b4502$export$6f2a8f5fb5b5ba40)(assessment, author),
        webSourceUrl: reading?.webSourceUrl,
        drawer: compactLayout && mobileTaskListOpened ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $526117c8dcb45fd6$export$771a55a10b0a40ae), {
            showClose: true
        }) : null,
        closeDrawer: ()=>setField("mobileTaskListOpened")(false)
    });
};











const $ccb83b7f0365d244$var$ViewSubmissionButton = ()=>{
    const { submission: submission , dirty: dirty , currentUser: currentUser , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s , AppData: a  })=>({
            submission: s.submission,
            dirty: s.dirty,
            currentUser: a.currentUser,
            isRecording: a.isRecording
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const isStudent = currentUser?.accountType === "student";
    if (submission?.status !== "finished" || dirty) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                width: "100%",
                displayType: "outline",
                to: `/submissions/${submission?.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                    backPath: `/reading-studio${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                }))}`,
                color: "white",
                disabled: isRecording,
                children: [
                    "View Your ",
                    isStudent ? "Results" : "Submission"
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            })
        ]
    });
};
const $ccb83b7f0365d244$export$b84a8e4acaa1b65 = ()=>{
    const { loading: loading , submission: submission , submitting: submitting , profileImageFile: profileImageFile , addToLibrary: addToLibrary  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>({
            loading: s.loading,
            submission: s.submission,
            submitting: s.submitting,
            profileImageFile: s.profileImageFile,
            addToLibrary: s.addToLibrary
        }), []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const isPublicPreview = (0, $e2d3c1727333757d$export$862ae1b5debe05be)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    if (compactLayout) return null;
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        flexWidth: "400px"
    });
    if (!submission) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1941c1cb7fdcc73d$export$206b65ea4daedc5b), {
        primaryButton: isPublicPreview ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            onClick: addToLibrary({
                history: history,
                createToast: createToast
            }),
            loading: submitting,
            children: "Create Assignment"
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($ccb83b7f0365d244$var$ViewSubmissionButton, {}),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e2d3c1727333757d$export$8b7b7cdfb85d78c5), {})
            ]
        }),
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
            children: [
                profileImageFile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9eb4c76372bd8ce8$export$7ea8120a9a9e6a18), {
                            "data-test-tag": "studio-profile-picture",
                            src: profileImageFile.url,
                            $height: "50px",
                            $width: "50px"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $526117c8dcb45fd6$export$771a55a10b0a40ae), {})
            ]
        })
    });
};





const $64a2b28b7be06b59$var$ReadingStudioBottomBarStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingStudioBottomBar__ReadingStudioBottomBarStyles",
    componentId: "sc-r1if7-0"
})([
    "display:flex;"
]);
const $64a2b28b7be06b59$export$c6e02978809c8fd4 = ()=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($64a2b28b7be06b59$var$ReadingStudioBottomBarStyles, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e2d3c1727333757d$export$1d4b116713d110e4), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e2d3c1727333757d$export$d32f9c3a9c514093), {})
        ]
    });
};
















const $70c6b5b3acb559a1$export$bcdb5cfbfff4f581 = ({ taskSubmissionDetails: taskSubmissionDetails  })=>{
    const onCompleteTask = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>s.onCompleteTask, []);
    if (!taskSubmissionDetails.audioFile) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
        audioFileId: taskSubmissionDetails.audioFile.id,
        src: taskSubmissionDetails.audioFile.url,
        placeholder: "Listen to Model Reading",
        onPlay: ()=>onCompleteTask(taskSubmissionDetails),
        testTag: "play-model-reading",
        trackMinWidth: "150px"
    });
};







const $0222fbc4adcd4eb4$var$ReadingStudioInstructionsStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingStudioInstructions__ReadingStudioInstructionsStyles",
    componentId: "sc-1hr959j-0"
})([
    "width:100%;padding:",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]);
const $0222fbc4adcd4eb4$export$ba51040f686558fa = ()=>{
    const assessment = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s  })=>s.assessment, []);
    const readingTaskSubmissionDetails = (0, $e2d3c1727333757d$export$c44a57905a1523a2)();
    const modelTaskSubmissionDetails = (0, $e2d3c1727333757d$export$412252664fd9dc64)();
    const instructions = (0, $62e5f0fd429b4502$export$c9df4e1f27f016e5)(assessment || undefined);
    const { reading: reading , coverImageFile: coverImageFile , author: author  } = readingTaskSubmissionDetails || {};
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($0222fbc4adcd4eb4$var$ReadingStudioInstructionsStyles, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67f615b76749e13f$export$2eacb1d819a74aad), {
                thumbnailUrl: coverImageFile?.thumbnailUrl,
                readingTitle: reading?.name,
                authorName: (0, $62e5f0fd429b4502$export$6f2a8f5fb5b5ba40)(assessment, author),
                webSourceUrl: reading?.webSourceUrl,
                justify: "center"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            instructions && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h4",
                        children: "Teacher Instructions"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: instructions
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            modelTaskSubmissionDetails && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $70c6b5b3acb559a1$export$bcdb5cfbfff4f581), {
                            taskSubmissionDetails: modelTaskSubmissionDetails
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $515d271b9d6a305d$export$f2d63d5699572406), {
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2eb83a4c56813824$export$2f7a2f0e90c07dc4), {
                            instructions: (0, $62e5f0fd429b4502$export$c9df4e1f27f016e5)(assessment),
                            readingTaskDetails: readingTaskSubmissionDetails,
                            enableTextRangeSelection: false,
                            compactLayout: compactLayout
                        })
                    })
                ]
            })
        ]
    });
};










const $b5c673caa29ac11a$var$MobileRecorder = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ReadingTaskStudio__MobileRecorder",
    componentId: "sc-1gogepk-0"
})([
    "display:flex;align-items:center;justify-content:center;width:100%;"
]);
const $b5c673caa29ac11a$export$613dee1b1b3094d9 = ()=>{
    const { dirty: dirty , assessment: assessment , onRecordingSequenceStatus: onRecordingSequenceStatus , onAudioRecorderStatus: onAudioRecorderStatus , submit: submit , emitPaperEvent: emitPaperEvent  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s , AppData: ad  })=>({
            assessment: s.assessment,
            dirty: s.dirty,
            onRecordingSequenceStatus: s.onRecordingSequenceStatus,
            onAudioRecorderStatus: s.onAudioRecorderStatus,
            submit: s.submit,
            emitPaperEvent: ad.emitPaperEvent
        }), []);
    const isPublicPreview = (0, $e2d3c1727333757d$export$862ae1b5debe05be)();
    const currentTaskSubmissionDetails = (0, $e2d3c1727333757d$export$387094ddcc67c137)();
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    if (!currentTaskSubmissionDetails) return null;
    if (currentTaskSubmissionDetails.type !== "ReadingTask") return null;
    if (isPublicPreview) return null;
    const recorder = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$de95611a92ae0566), {
        recordingSequence: currentTaskSubmissionDetails.recordingSequence,
        audioFile: currentTaskSubmissionDetails.audioFile,
        onRecordingSequenceStatus: onRecordingSequenceStatus,
        onAudioRecorderStatus: onAudioRecorderStatus,
        displayType: compactLayout ? "mobile" : "desktop",
        dirty: dirty,
        onSave: ()=>submit({
                clearDirty: true
            }),
        showCountdown: true,
        onRecordingStart: (recordingId)=>{
            if (!assessment) return;
            emitPaperEvent({
                type: "literacy_recording_started_v3",
                taskId: currentTaskSubmissionDetails.task.id,
                assessmentId: assessment.id,
                recordingSequenceId: currentTaskSubmissionDetails.recordingSequence.id,
                recordingId: recordingId
            });
        },
        onRecordingStop: (recordingId)=>{
            if (!assessment) return;
            emitPaperEvent({
                type: "literacy_recording_ended_v3",
                taskId: currentTaskSubmissionDetails.task.id,
                assessmentId: assessment.id,
                recordingSequenceId: currentTaskSubmissionDetails.recordingSequence.id,
                recordingId: recordingId
            });
        }
    });
    if (compactLayout) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($b5c673caa29ac11a$var$MobileRecorder, {
        children: recorder
    });
    return recorder;
};





var $g5BLJ = parcelRequire("g5BLJ");





const $9964fd7ef0e18c7e$var$responseTypeSelectOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        value: "recorded",
        label: "Record Response",
        icon: "microphone"
    },
    {
        value: "written",
        label: "Write Response",
        icon: "pencil"
    }
]);
const $9964fd7ef0e18c7e$export$7387a38f9da5b958 = ({ currentTaskSubmissionDetails: currentTaskSubmissionDetails , displayType: displayType , textSize: textSize = 16 , openContentModal: openContentModal  })=>{
    const { taskErrors: taskErrors , dirty: dirty , assessment: assessment , isRecording: isRecording , setResponseType: setResponseType , onResponseRecordingSequenceStatus: onResponseRecordingSequenceStatus , setResponseContent: setResponseContent , onAudioRecorderStatus: onAudioRecorderStatus , submit: submit , emitPaperEvent: emitPaperEvent  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ ReadingStudioData: s , AppData: a  })=>({
            taskErrors: s.taskErrors,
            dirty: s.dirty,
            assessment: s.assessment,
            isRecording: a.isRecording,
            setResponseType: s.setResponseType,
            onResponseRecordingSequenceStatus: s.onResponseRecordingSequenceStatus,
            setResponseContent: s.setResponseContent,
            onAudioRecorderStatus: s.onAudioRecorderStatus,
            submit: s.submit,
            emitPaperEvent: a.emitPaperEvent
        }), []);
    const isPublicPreview = (0, $e2d3c1727333757d$export$862ae1b5debe05be)();
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    const { task: task , taskSubmission: taskSubmission , responseRecordingSequence: responseRecordingSequence , responseAudioFile: responseAudioFile  } = currentTaskSubmissionDetails;
    const responseTypeSelect = task.responseType === "student_choice" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
        displayType: "flat",
        value: taskSubmission.responseType,
        name: "responseType",
        onChange: setResponseType,
        options: $9964fd7ef0e18c7e$var$responseTypeSelectOptions,
        disabled: isRecording
    }) : null;
    const contentWidth = displayType === "drawerClosed" ? "500px" : "100%";
    const contentModalContent = openContentModal && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                width: "100%",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    onClick: openContentModal,
                    children: "View Reading"
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            })
        ]
    });
    if (task.responseType === "student_choice" && (taskSubmission.responseType === "undecided" || isPublicPreview)) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: $9964fd7ef0e18c7e$var$responseTypeSelectOptions.map((option)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $g5BLJ.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: ()=>setResponseType(option.value),
                        icon: option.icon,
                        iconFill: option.icon === "pencil",
                        iconStrokeWidth: option.icon === "pencil" ? 0 : 1,
                        disabled: isPublicPreview,
                        children: option.label
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        square: true,
                        size: 2
                    })
                ]
            }, option.value))
    });
    else if (task.responseType === "recorded" || taskSubmission.responseType === "recorded") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: contentWidth,
        direction: "column",
        justify: "space-between",
        height: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                children: [
                    contentModalContent,
                    responseTypeSelect
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$de95611a92ae0566), {
                    recordingSequence: responseRecordingSequence,
                    audioFile: isPublicPreview ? null : responseAudioFile,
                    onRecordingSequenceStatus: onResponseRecordingSequenceStatus,
                    displayType: compactLayout ? "mobile" : "desktopSmall",
                    disabled: isPublicPreview,
                    dirty: dirty,
                    onAudioRecorderStatus: onAudioRecorderStatus,
                    onSave: ()=>submit({
                            clearDirty: true
                        }),
                    onRecordingStart: (recordingId)=>{
                        if (!assessment) return;
                        emitPaperEvent({
                            type: "literacy_recording_started_v3",
                            taskId: task.id,
                            assessmentId: assessment.id,
                            recordingSequenceId: responseRecordingSequence.id,
                            recordingId: recordingId
                        });
                    },
                    onRecordingStop: (recordingId)=>{
                        if (!assessment) return;
                        emitPaperEvent({
                            type: "literacy_recording_ended_v3",
                            taskId: task.id,
                            assessmentId: assessment.id,
                            recordingId: recordingId,
                            recordingSequenceId: responseRecordingSequence.id
                        });
                    }
                })
            })
        ]
    });
    else if (task.responseType === "written" || taskSubmission.responseType === "written") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: contentWidth,
        direction: "column",
        height: "100%",
        justify: "center",
        children: [
            contentModalContent,
            responseTypeSelect,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2afb870564c4e4d2$export$ce9b1cc0c34506d0), {
                disabled: isPublicPreview,
                name: "writtenContent",
                value: isPublicPreview ? "" : taskSubmission.responseContent,
                onChange: setResponseContent,
                placeholder: "Write your answer here",
                height: "100%",
                width: "100%",
                textSize: textSize
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                errors: taskErrors.get(task.id, (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)()),
                errorKey: "writtenContent"
            })
        ]
    });
    else return null;
};



const $515d271b9d6a305d$export$f2d63d5699572406 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MainContent__MobileReader",
    componentId: "sc-g6xzz0-0"
})([
    "display:flex;flex-direction:column;justify-content:space-between;position:relative;width:100%;"
]);
const $515d271b9d6a305d$var$MobileComprehension = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MainContent__MobileComprehension",
    componentId: "sc-g6xzz0-1"
})([
    "display:flex;flex-direction:column;width:100%;padding:",
    ";position:relative;"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]);
const $515d271b9d6a305d$export$5c0547b091a4b556 = ()=>{
    const { assessment: assessment , currentUser: currentUser , openContentModal: openContentModal , contentModalOpened: contentModalOpened , closeContentModal: closeContentModal  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            assessment: state.ReadingStudioData.assessment,
            openContentModal: state.ReadingStudioData.openContentModal,
            contentModalOpened: state.ReadingStudioData.contentModalOpened,
            closeContentModal: state.ReadingStudioData.closeContentModal,
            currentUser: state.AppData.currentUser
        }), []);
    const readingTaskSubmissionDetails = (0, $e2d3c1727333757d$export$c44a57905a1523a2)();
    const currentTaskSubmissionDetails = (0, $e2d3c1727333757d$export$387094ddcc67c137)();
    const vocabTaskDetailsList = (0, $e2d3c1727333757d$export$f79545bc5672622d)();
    const isInstructionsPage = (0, $e2d3c1727333757d$export$287d668d6cc9dd7e)();
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    const taskType = currentTaskSubmissionDetails ? currentTaskSubmissionDetails.type : "";
    const drawerOpen = taskType === "ComprehensionTask";
    if (isInstructionsPage) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0222fbc4adcd4eb4$export$ba51040f686558fa), {});
    if (currentTaskSubmissionDetails?.type === "VocabTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2dee512fbabf1618$export$e2ebe3e47482b39b), {
        taskDetails: currentTaskSubmissionDetails,
        compactLayout: compactLayout
    });
    if (!readingTaskSubmissionDetails) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2eb83a4c56813824$export$2f7a2f0e90c07dc4), {
        instructions: (0, $62e5f0fd429b4502$export$c9df4e1f27f016e5)(assessment),
        readingTaskDetails: null,
        enableTextRangeSelection: false,
        vocabTaskDetailsList: vocabTaskDetailsList,
        compactLayout: compactLayout
    });
    const reader = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2eb83a4c56813824$export$2f7a2f0e90c07dc4), {
        instructions: (0, $62e5f0fd429b4502$export$c9df4e1f27f016e5)(assessment),
        readingTaskDetails: readingTaskSubmissionDetails,
        drawerOpen: drawerOpen,
        enableTextRangeSelection: false,
        vocabTaskDetailsList: vocabTaskDetailsList,
        compactLayout: compactLayout
    });
    if (compactLayout) {
        if (currentTaskSubmissionDetails?.type === "ReadingTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($515d271b9d6a305d$export$f2d63d5699572406, {
            children: [
                reader,
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b5c673caa29ac11a$export$613dee1b1b3094d9), {})
            ]
        });
        else if (currentTaskSubmissionDetails?.type === "ComprehensionTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($515d271b9d6a305d$var$MobileComprehension, {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e4ad9cb1b5a13026$export$6f0f9793d5b4ba54), {
                    currentTaskSubmissionDetails: currentTaskSubmissionDetails,
                    displayType: "mainContent",
                    textSize: currentUser?.textSize
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9964fd7ef0e18c7e$export$7387a38f9da5b958), {
                    currentTaskSubmissionDetails: currentTaskSubmissionDetails,
                    displayType: "mainContent",
                    textSize: currentUser?.textSize,
                    openContentModal: readingTaskSubmissionDetails.task.readingPartType !== "independent" ? openContentModal : undefined
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
                    openType: "state",
                    opened: contentModalOpened,
                    header: "Content",
                    close: closeContentModal,
                    children: reader
                })
            ]
        });
    }
    return reader;
};









const $e57b1f852218d6bd$export$57ca055474bc0056 = ()=>{
    const { drawerExpanded: drawerExpanded , setField: setField , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            drawerExpanded: state.ReadingStudioData.drawerExpanded,
            setField: state.ReadingStudioData.setField,
            currentUser: state.AppData.currentUser
        }), []);
    const currentTaskSubmissionDetails = (0, $e2d3c1727333757d$export$387094ddcc67c137)();
    if (!currentTaskSubmissionDetails) return null;
    if (currentTaskSubmissionDetails.type === "ReadingTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b5c673caa29ac11a$export$613dee1b1b3094d9), {});
    else if (currentTaskSubmissionDetails.type === "ComprehensionTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
        header: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e4ad9cb1b5a13026$export$6f0f9793d5b4ba54), {
            currentTaskSubmissionDetails: currentTaskSubmissionDetails,
            displayType: drawerExpanded ? "drawerOpen" : "drawerClosed",
            toggleOpen: ()=>setField("drawerExpanded")(!drawerExpanded),
            textSize: currentUser?.textSize
        }),
        expanded: drawerExpanded,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9964fd7ef0e18c7e$export$7387a38f9da5b958), {
            currentTaskSubmissionDetails: currentTaskSubmissionDetails,
            displayType: drawerExpanded ? "drawerOpen" : "drawerClosed",
            textSize: currentUser?.textSize
        })
    });
    else if (currentTaskSubmissionDetails.type === "ModelTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $70c6b5b3acb559a1$export$bcdb5cfbfff4f581), {
            taskSubmissionDetails: currentTaskSubmissionDetails
        })
    });
    else if (currentTaskSubmissionDetails.type === "VocabTask") return null;
    else throw new Error(`Unrecognized task type ${JSON.stringify(currentTaskSubmissionDetails)}`);
};










const $44f087984ac9741a$export$c3c14e5d29d0051a = ()=>{
    const { loading: loading , setField: setField , showFinishedModal: showFinishedModal , submission: submission , submitRating: submitRating , rating: rating , taskSubmissionDetailsMap: taskSubmissionDetailsMap , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            loading: state.ReadingStudioData.loading,
            setField: state.ReadingStudioData.setField,
            showFinishedModal: state.ReadingStudioData.showFinishedModal,
            submission: state.ReadingStudioData.submission,
            submitRating: state.ReadingStudioData.submitRating,
            rating: state.ReadingStudioData.rating,
            taskSubmissionDetailsMap: state.ReadingStudioData.taskSubmissionDetailsMap,
            currentUser: state.AppData.currentUser
        }), []);
    const readingTaskSubmissionDetails = (0, $e2d3c1727333757d$export$c44a57905a1523a2)();
    const pointsEarned = readingTaskSubmissionDetails?.taskSubmission.pointsEarned || 0;
    const backPath = (0, $e2d3c1727333757d$export$d88f91fd007bca06)();
    const processing = taskSubmissionDetailsMap.some((t)=>t.type === "ReadingTask" && t.recordingSequence.processingStatus !== "finished");
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: "Turned In!",
        openType: "state",
        showConfetti: showFinishedModal,
        opened: !loading && showFinishedModal,
        close: ()=>setField("showFinishedModal")(false),
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            justify: "end",
            align: "center",
            width: "100%",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    width: "auto",
                    displayType: "outline",
                    color: "primaryBlue",
                    to: backPath,
                    children: currentUser?.accountType === "teacher" ? "Back to Assignment" : "Home"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    to: `/submissions/${submission?.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                        backPath: backPath
                    }))}`,
                    color: "primaryBlue",
                    children: "View My Results"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "You can review your results or click home to find more content to read!"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "center",
                children: processing ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "token",
                                    color: "white",
                                    size: "1.5em"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h4",
                                    weightOverride: "medium",
                                    children: "Calculating points now!"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                    icon: "token",
                                    color: "white",
                                    size: "1.5em"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        " ",
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                            size: "medium"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                    children: pointsEarned === 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h3",
                                weightOverride: "medium",
                                children: "Keep reading throughout the week to earn more points!"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: "token",
                                color: "white",
                                size: "1.5em"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h3",
                                        weightOverride: "medium",
                                        children: [
                                            "You earned ",
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                                                children: pointsEarned
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: "token",
                                        color: "white",
                                        size: "1.5em"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h3",
                                weightOverride: "medium",
                                children: "on this reading!"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                textAlign: "center",
                variant: "h4",
                children: "How interesting was the reading?"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $aebf6eac7f74b94e$export$76529f19140ac2e7), {
                    onClick: (val)=>submitRating(val + 1),
                    rating: rating ?? -1,
                    borderColor: "black"
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            })
        ]
    });
};







const $576cbe0ab75bab5e$export$a3b5072840a90301 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { submit: submit , confirmingFinished: confirmingFinished , submitting: submitting , switchTask: switchTask , leaving: leaving , closeConfirmationModal: closeConfirmationModal  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            submit: state.ReadingStudioData.submit,
            confirmingFinished: state.ReadingStudioData.confirmingFinished,
            submitting: state.ReadingStudioData.submitting,
            switchTask: state.ReadingStudioData.switchTask,
            leaving: state.ReadingStudioData.leaving,
            closeConfirmationModal: state.ReadingStudioData.closeConfirmationModal
        }), []);
    const incompleteTaskId = (0, $e2d3c1727333757d$export$3b4170a88823ed17)();
    const backPath = (0, $e2d3c1727333757d$export$d88f91fd007bca06)();
    const isPublicPreview = (0, $e2d3c1727333757d$export$862ae1b5debe05be)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: "You have unfinished tasks",
        openType: "state",
        opened: confirmingFinished,
        close: closeConfirmationModal,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                incompleteTaskId && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    inheritBgColor: true,
                    displayType: "link",
                    color: "primaryBlue",
                    onClick: switchTask({
                        taskId: incompleteTaskId,
                        history: history,
                        query: query,
                        isPublicPreview: isPublicPreview
                    }),
                    children: "Keep Working"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    loading: submitting,
                    onClick: ()=>{
                        submit({
                            finished: !leaving,
                            clearDirty: true,
                            override: true,
                            onSuccess: ()=>{
                                if (leaving) history.push(backPath);
                            }
                        });
                    },
                    children: [
                        leaving ? "Leave" : "Submit",
                        " Anyway"
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            children: [
                "You have unfinished tasks. Are you sure you would like to ",
                leaving ? "leave" : "submit",
                "?"
            ]
        })
    });
};




var $f3de0fccbd8f8df4$exports = {};

$f3de0fccbd8f8df4$exports = new URL((parcelRequire("3TfdU")).resolve("7IIJ7"), import.meta.url).toString();



var $g5BLJ = parcelRequire("g5BLJ");






const $aa6e9aaeec63830a$var$InstructionsContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "InstructionsModal__InstructionsContainer",
    componentId: "sc-1dc44l3-0"
})([
    "font-size:",
    "px;white-space:pre-wrap;word-break:break-word;max-width:600px;overflow-y:auto;"
], ({ $textSize: $textSize  })=>$textSize);
const $aa6e9aaeec63830a$var$InstructionsEmptyState = ({ textSize: textSize , isFreeRead: isFreeRead  })=>{
    const isIndependent = (0, $e2d3c1727333757d$export$c44a57905a1523a2)()?.task.readingPartType === "independent";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("ul", {
        children: [
            !isFreeRead && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    sizeOverride: textSize,
                    children: 'Complete the tasks in the "My Tasks" list.'
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    sizeOverride: textSize,
                    children: [
                        "Record yourself reading ",
                        isIndependent ? "from any" : "the",
                        " text out loud",
                        " ",
                        isFreeRead ? "" : "during the Read Aloud task."
                    ]
                })
            }),
            isFreeRead && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    sizeOverride: textSize,
                    children: "Then, answer the question to tell us what you read."
                })
            })
        ]
    });
};
const $aa6e9aaeec63830a$export$788cb893d96254c8 = ()=>{
    const { loading: loading , assessment: assessment , instructionDetails: instructionDetails , textSize: textSize , profileImageFile: profileImageFile  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            loading: state.ReadingStudioData.loading,
            assessment: state.ReadingStudioData.assessment,
            instructionDetails: state.ReadingStudioData.instructionDetails,
            profileImageFile: state.ReadingStudioData.profileImageFile,
            textSize: state.AppData.currentUser?.textSize || (0, $75cd274e63beb59b$export$74d9cec7d2c95116)
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const showInstructions = Boolean(query.get("showInstructions"));
    const profileSize = "80px";
    const compactLayout = (0, $005fefce7850bc4a$export$78e9c8e9276d9c86)();
    const close = (0, $g5BLJ.useCallback)(()=>{
        history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            showInstructions: null
        })}`);
    }, [
        history,
        pathname,
        query
    ]);
    if (compactLayout) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: `${assessment?.instructions && !assessment?.isFreeRead ? "Your Teacher's " : ""}Instructions`,
        openType: "state",
        opened: showInstructions,
        close: close,
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "center",
                    testTag: "instructions-modal-open",
                    children: profileImageFile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9eb4c76372bd8ce8$export$7ea8120a9a9e6a18), {
                        "data-test-tag": "instructions-profile-picture",
                        src: profileImageFile.url,
                        $height: profileSize,
                        $width: profileSize
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                        style: {
                            height: profileSize,
                            width: profileSize
                        },
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f3de0fccbd8f8df4$exports)))
                    })
                }),
                instructionDetails?.audioFile?.url && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            width: "fit-content",
                            margin: "auto",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                                audioFileId: instructionDetails.audioFile.id,
                                src: instructionDetails.audioFile.url,
                                showSkipButtons: false,
                                placeholder: "Listen to the Instructions"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 6
                }),
                assessment?.instructions && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($aa6e9aaeec63830a$var$InstructionsContainer, {
                            $textSize: textSize,
                            children: assessment?.instructions
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6
                        })
                    ]
                }),
                !assessment?.instructions && !instructionDetails?.audioFile?.url && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($aa6e9aaeec63830a$var$InstructionsEmptyState, {
                            isFreeRead: Boolean(assessment?.isFreeRead),
                            textSize: textSize
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "center",
                    align: "center",
                    width: "100%",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: close,
                        color: "primaryBlue",
                        children: "Got it!"
                    })
                })
            ]
        })
    });
};


const $399acaba3991b874$export$bdcffb184229ae9 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const assessmentId = query.get("assessmentId");
    const currentQueryTaskId = query.get("currentTaskId");
    const { loading: loading , load: load , assessment: assessment , setCurrentTask: setCurrentTask , dirty: dirty , submit: submit , drawerExpanded: drawerExpanded , onCompleteTask: onCompleteTask , audioRecorderStatus: audioRecorderStatus , userType: userType  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            loading: state.ReadingStudioData.loading,
            load: state.ReadingStudioData.load,
            assessment: state.ReadingStudioData.assessment,
            setCurrentTask: state.ReadingStudioData.setCurrentTask,
            dirty: state.ReadingStudioData.dirty,
            submit: state.ReadingStudioData.submit,
            drawerExpanded: state.ReadingStudioData.drawerExpanded,
            onCompleteTask: state.ReadingStudioData.onCompleteTask,
            audioRecorderStatus: state.ReadingStudioData.audioRecorderStatus,
            userType: state.AppData.currentUser?.accountType || "student"
        }), []);
    const currentTaskSubmissionDetails = (0, $e2d3c1727333757d$export$387094ddcc67c137)();
    const readingTaskSubmissionDetails = (0, $e2d3c1727333757d$export$c44a57905a1523a2)();
    const isPublicPreview = (0, $e2d3c1727333757d$export$862ae1b5debe05be)();
    (0, $g5BLJ.useEffect)(()=>{
        load({
            assessmentId: assessmentId,
            isPublicPreview: isPublicPreview
        });
    }, [
        assessmentId,
        load,
        isPublicPreview
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        const firstTaskId = assessment?.taskOrder?.first()?.type !== "VocabTask" ? assessment?.taskOrder?.first()?.taskId : null;
        setCurrentTask(currentQueryTaskId ?? firstTaskId ?? null);
    }, [
        setCurrentTask,
        currentQueryTaskId,
        assessment
    ]);
    (0, $a43aa4efcef0fffa$export$3a8a63c2fd80d3b0)({
        smallerThan: "desktop"
    });
    const compactLayout = (0, $8910ef7e15ad2bff$export$78e9c8e9276d9c86)();
    (0, $g5BLJ.useEffect)(()=>{
        if (currentTaskSubmissionDetails?.type === "VocabTask") onCompleteTask(currentTaskSubmissionDetails);
    }, [
        onCompleteTask,
        currentTaskSubmissionDetails
    ]);
    // This prevents a glitchtip we get where, for a single moment, the page is rendered using the
    // previous assessmentId, which can cause errors with fetching files from S3 with now expired
    // URLs.
    if (loading || !assessmentId || assessmentId !== assessment?.id) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                title: assessment?.name ?? "Reading Studio"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2a0812bc157eca24$export$69546dc4b644da69), {
                loading: loading,
                sideBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ccb83b7f0365d244$export$b84a8e4acaa1b65), {}),
                topBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8150120c85fc2f4a$export$3f806a8218ef6728), {}),
                bottomBar: compactLayout && audioRecorderStatus !== "recording" && audioRecorderStatus !== "loading" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $64a2b28b7be06b59$export$c6e02978809c8fd4), {}) : null,
                showTopBarDivider: ![
                    "PdfStoredFile",
                    "PdfByPageStoredFile"
                ].includes(readingTaskSubmissionDetails?.contentFile?.type || ""),
                bannerContent: (0, $75cd274e63beb59b$export$21d5f40a3f7d2451)(userType) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "center",
                    backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex,
                    padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "largeText",
                        color: "white",
                        children: isPublicPreview ? "Previewing Assignment" : "Previewing as a Student"
                    })
                }),
                onSubmit: ()=>submit({
                        finished: true,
                        clearDirty: true,
                        history: history
                    }),
                dirty: dirty,
                mainContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $515d271b9d6a305d$export$5c0547b091a4b556), {}),
                drawerContent: !compactLayout ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e57b1f852218d6bd$export$57ca055474bc0056), {}) : null,
                drawerExpanded: drawerExpanded
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $576cbe0ab75bab5e$export$a3b5072840a90301), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $44f087984ac9741a$export$c3c14e5d29d0051a), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $aa6e9aaeec63830a$export$788cb893d96254c8), {})
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");









const $0ab93016cd04b13d$var$BaseOnboardingLayoutStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "OnboardingLayout__BaseOnboardingLayoutStyles",
    componentId: "sc-1mnelo3-0"
})([
    "",
    " display:grid;grid-template-rows:auto 1fr;grid-template-columns:1fr;"
], (0, $dba6c5da69120483$export$6988a55f9afa8b34));
const $0ab93016cd04b13d$export$c9e4449cfc3bfc22 = ({ children: children , secondaryAction: secondaryAction , ...flexProps })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($0ab93016cd04b13d$var$BaseOnboardingLayoutStyles, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $74b195a20ec26994$export$c4e96258f3b6511), {
                navLinksOverride: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                secondaryAction: secondaryAction,
                showProfile: false,
                showPrimaryAction: false,
                alwaysShowSecondaryAction: true,
                logoDisabled: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 1,
                width: "100%",
                align: "center",
                direction: "column",
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
                overflowY: "auto",
                ...flexProps,
                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]}`,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    maxWidth: "500px",
                    width: "100%",
                    minWidth: flexProps.minWidth,
                    children: children
                })
            })
        ]
    });
};







var $g5BLJ = parcelRequire("g5BLJ");


const $a677f84877f39ea5$export$c7abf7bea9707490 = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    PR: "Puerto Rico",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming"
};
const $a677f84877f39ea5$var$BASE_US_STATE_OPTIONS = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)($a677f84877f39ea5$export$c7abf7bea9707490)).map(([abbreviation, state])=>({
        label: state,
        value: abbreviation
    })).sortBy(({ label: label  })=>label.toLocaleLowerCase());
const $a677f84877f39ea5$export$a61875b271517a9a = $a677f84877f39ea5$var$BASE_US_STATE_OPTIONS.unshift({
    label: "Everywhere",
    value: undefined
});
const $a677f84877f39ea5$var$BASE_US_STATE_ABBREVIATED_OPTIONS = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)($a677f84877f39ea5$export$c7abf7bea9707490).keys()).map((abbreviation)=>({
        label: abbreviation,
        value: abbreviation
    })).sortBy(({ label: label  })=>label.toLocaleLowerCase());
const $a677f84877f39ea5$export$80f783ba4fb83a5d = $a677f84877f39ea5$var$BASE_US_STATE_ABBREVIATED_OPTIONS.unshift({
    label: "-",
    value: undefined
});








const $3842341f999eff36$var$SchoolChipStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SchoolChip__SchoolChipStyles",
    componentId: "sc-pnp3yy-0"
})([
    "background:",
    ";padding:",
    ";border-radius:",
    ";width:100%;flex:1;margin-bottom:",
    ";border:1px solid ",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex);
const $3842341f999eff36$export$dc63c679b7b753d8 = ({ school: school , district: district , choose: choose , suggested: suggested = false  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        displayType: "noStyles",
        onClick: choose,
        width: "100%",
        disabled: !choose,
        disabledOpacityOverride: "100%",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($3842341f999eff36$var$SchoolChipStyles, {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h4",
                    children: school.name
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                district && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h5",
                    children: district.name
                }),
                school.isPrivate && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h5",
                    children: "Private School"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: school.street ? `${school.street}, ` : ""
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: [
                        school.city ? `${school.city}, ` : "",
                        school.stateAbbreviation || school.state ? `${school.stateAbbreviation || school.state}, ` : "",
                        school.country,
                        " ",
                        school.zipCode
                    ]
                }),
                suggested ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "end",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                color: "primaryBlue",
                                children: "Suggested based on your email address"
                            })
                        })
                    ]
                }) : null
            ]
        })
    });
};


const $717fdd83bb441254$export$877f7a553b47eb14 = ({ onSetSchool: onSetSchool , manualLink: manualLink , loadUserSchools: loadUserSchools = true  })=>{
    const { schoolQuery: schoolQuery , schoolResults: schoolResults , schoolDomains: schoolDomains , suggestedSchoolMap: suggestedSchoolMap , searching: searching , waitingToSearch: waitingToSearch , stateAbbreviation: stateAbbreviation , districtMap: districtMap , setStateAbbreviation: setStateAbbreviation , setSchoolQuery: setSchoolQuery , setSchool: setSchool , load: load  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.SchoolSearchData, []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    (0, $g5BLJ.useEffect)(()=>{
        if (loadUserSchools) load(history, query);
    }, [
        load,
        history,
        query,
        loadUserSchools
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "text",
                        name: "schoolQuery",
                        value: schoolQuery,
                        onChange: setSchoolQuery,
                        autoComplete: "off",
                        placeholder: "Search for your school",
                        label: "School Name"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "select",
                        name: "stateAbbreviation",
                        options: (0, $a677f84877f39ea5$export$80f783ba4fb83a5d),
                        value: stateAbbreviation,
                        onChange: setStateAbbreviation,
                        width: "100px",
                        label: "State"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "Can't find your school? ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: manualLink,
                        children: "Add it manually"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 8
            }),
            schoolResults.size > 0 || schoolDomains.size > 0 || searching || waitingToSearch ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h3",
                        children: [
                            "Matching Schools (",
                            schoolQuery.length === 0 ? schoolDomains.size : schoolResults.size,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    })
                ]
            }) : null,
            searching || waitingToSearch ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    schoolQuery.length === 0 && schoolDomains.map((sd)=>{
                        const school = suggestedSchoolMap.get(sd.schoolId);
                        if (!school) return;
                        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3842341f999eff36$export$dc63c679b7b753d8), {
                            school: school,
                            district: school.districtId ? districtMap.get(school.districtId, null) : null,
                            choose: ()=>setSchool(school, onSetSchool),
                            suggested: true
                        }, sd.id);
                    }),
                    schoolQuery.length > 0 && schoolResults.map((s)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3842341f999eff36$export$dc63c679b7b753d8), {
                            school: s,
                            district: s.districtId ? districtMap.get(s.districtId, null) : null,
                            choose: ()=>setSchool(s, onSetSchool)
                        }, s.id)),
                    schoolQuery.length > 0 && schoolResults.size === 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "No results."
                    }) : null
                ]
            })
        ]
    });
};





const $fb08ac18878fdfe0$export$1c6dce84f704ec3b = ({ cancelLink: cancelLink , onSaveSuccess: onSaveSuccess  })=>{
    const { manualSchool: manualSchool , saving: saving , manualSchoolErrors: manualSchoolErrors , setManualSchoolField: setManualSchoolField , saveManualSchool: saveManualSchool  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.SchoolSearchData, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
        onSubmit: ()=>saveManualSchool(onSaveSuccess),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                label: "Name",
                name: "name",
                value: manualSchool.name,
                onChange: setManualSchoolField("name"),
                errors: manualSchoolErrors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                label: "City",
                name: "city",
                value: manualSchool.city,
                onChange: setManualSchoolField("city"),
                errors: manualSchoolErrors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                label: "State",
                name: "state",
                value: manualSchool.state,
                onChange: setManualSchoolField("state"),
                errors: manualSchoolErrors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                label: "Country",
                name: "country",
                value: manualSchool.country,
                onChange: setManualSchoolField("country"),
                errors: manualSchoolErrors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "number",
                label: "Zip Code",
                name: "zipCode",
                value: manualSchool.zipCode,
                onChange: setManualSchoolField("zipCode"),
                errors: manualSchoolErrors,
                noSpinner: true,
                integerOnly: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "end",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: cancelLink,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        type: "submit",
                        loading: saving,
                        children: "Continue"
                    })
                ]
            })
        ]
    });
};







const $1a5c664f001dac7d$export$3b2790fa1e11399a = ({ onConfirm: onConfirm , cancelLink: cancelLink  })=>{
    const { schools: schools , districtMap: districtMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.SchoolSearchData, []);
    const { savedSchools: savedSchools  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            savedSchools: s.AppData.schools
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Is this your school?"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            schools.isEmpty() ? savedSchools?.map((school)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3842341f999eff36$export$dc63c679b7b753d8), {
                    school: school,
                    district: districtMap.get(school?.districtId || "", null)
                }, school.id)) : schools.map((school)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3842341f999eff36$export$dc63c679b7b753d8), {
                    school: school,
                    district: districtMap.get(school?.districtId || "", null)
                }, school.id)),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                justify: "end",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: ()=>history.replace(cancelLink),
                        children: "Change"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true,
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: onConfirm,
                        disabled: schools.size === 0 && savedSchools.size === 0,
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
};




const $37368a4402105327$var$SchoolForm = ()=>{
    const { currentUser: currentUser , addedManualSchool: addedManualSchool , tempPositions: tempPositions , tempTeachesSpecialEd: tempTeachesSpecialEd , tempTeachesEll: tempTeachesEll , setField: setField , submitResponses: submitResponses , submitSchool: submitSchool , savedSchools: savedSchools , schools: schools  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            currentUser: s.TeacherOnboardingData.currentUser,
            addedManualSchool: s.TeacherOnboardingData.addedManualSchool,
            tempPositions: s.TeacherOnboardingData.tempPositions,
            tempTeachesSpecialEd: s.TeacherOnboardingData.tempTeachesSpecialEd,
            tempTeachesEll: s.TeacherOnboardingData.tempTeachesEll,
            setField: s.TeacherOnboardingData.setField,
            submitResponses: s.TeacherOnboardingData.submitResponses,
            submitSchool: s.TeacherOnboardingData.submitSchool,
            schools: s.SchoolSearchData.schools,
            savedSchools: s.AppData.schools
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const redirectPath = query.get("redirectPath");
    if (!currentUser) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/onboarding/finished",
                exact: true,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Confirm Your School"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1a5c664f001dac7d$export$3b2790fa1e11399a), {
                        onConfirm: submitSchool(history, query, schools, savedSchools),
                        cancelLink: addedManualSchool ? `/t/onboarding/manual${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}` : `/t/onboarding/searching${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/onboarding/searching",
                exact: true,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Select Your School"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $717fdd83bb441254$export$877f7a553b47eb14), {
                        manualLink: `/t/onboarding/manual${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                        onSetSchool: ()=>{
                            setField("addedManualSchool")(false);
                            history.replace(`/t/onboarding/finished${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/onboarding/manual",
                exact: true,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Add Your School"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fb08ac18878fdfe0$export$1c6dce84f704ec3b), {
                        cancelLink: `/t/onboarding/searching${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                        onSaveSuccess: ()=>{
                            setField("addedManualSchool")(true);
                            history.replace(`/t/onboarding/finished${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/onboarding/questions",
                exact: true,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Tell Us About Yourself!"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "text",
                        name: "position",
                        value: tempPositions,
                        onChange: setField("tempPositions"),
                        label: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "black",
                            children: "What is/are your position(s) at your school?"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 6
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "specialEd",
                        type: "select",
                        value: tempTeachesSpecialEd,
                        onChange: setField("tempTeachesSpecialEd"),
                        options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                            {
                                label: "",
                                value: "unanswered"
                            },
                            {
                                label: "Yes",
                                value: "yes"
                            },
                            {
                                label: "No",
                                value: "no"
                            }
                        ]),
                        label: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "black",
                            children: "Do you teach special education?"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 6
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "ell",
                        type: "select",
                        value: tempTeachesEll,
                        onChange: setField("tempTeachesEll"),
                        options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                            {
                                label: "",
                                value: "unanswered"
                            },
                            {
                                label: "Yes",
                                value: "yes"
                            },
                            {
                                label: "No",
                                value: "no"
                            }
                        ]),
                        label: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            color: "black",
                            children: "Do you teach English Language Learners (ELL)?"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 10
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: submitResponses(history, redirectPath),
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
const $37368a4402105327$export$dbf6b52a6eb81de8 = ()=>{
    const { currentUser: currentUser , load: load , loading: loading , skip: skip , userSchools: userSchools  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ TeacherOnboardingData: tod  })=>({
            currentUser: tod.currentUser,
            load: tod.load,
            loading: tod.loading,
            skip: tod.skip,
            userSchools: tod.userSchools
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const redirectPath = query.get("redirectPath");
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (loading) return;
        if ((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, [
            "/t/onboarding/questions",
            "/t/onboarding/finished",
            "/t/onboarding/manual"
        ])) return;
        if (userSchools.size === 0) history.replace(`/t/onboarding/searching${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
        else history.replace(`/t/onboarding/finished${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
    }, [
        history,
        loading,
        pathname,
        query,
        userSchools.size
    ]);
    if (!currentUser) return null;
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        kind: "boat"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $0ab93016cd04b13d$export$c9e4449cfc3bfc22), {
        secondaryAction: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
            onClick: ()=>skip(history, redirectPath),
            children: "Skip"
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($37368a4402105327$var$SchoolForm, {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 22
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");












const $7b25f9b5308f7290$var$Empty = ({ tooltipText: tooltipText  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            children: tooltipText || "No data for this time period or class"
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            color: "black",
            children: "--"
        })
    });
const $7b25f9b5308f7290$var$studentProgressMonitoringColumnIds = [
    "assignment",
    "completion",
    "wordsCountPerMinute",
    "words",
    "time",
    "tasks",
    "submittedAt"
];
const $7b25f9b5308f7290$export$a5c423535959af60 = ()=>{
    const { load: load , isLoading: isLoading , courses: courses , stats: stats , teachersMap: teachersMap , search: search , dateRange: dateRange , setField: setField , currentUser: currentUser , currentPlan: currentPlan  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            load: s.ProgressMonitoringData.load,
            isLoading: s.ProgressMonitoringData.isLoading,
            courses: s.ProgressMonitoringData.courses,
            stats: s.ProgressMonitoringData.stats,
            teachersMap: s.ProgressMonitoringData.teachersMap,
            search: s.ProgressMonitoringData.search,
            dateRange: s.ProgressMonitoringData.dateRange,
            setField: s.ProgressMonitoringData.setField,
            currentUser: s.AppData.currentUser,
            currentPlan: s.AppData.currentPlan
        }), []);
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const selectedCourseId = query.get("selectedCourseId") || "all";
    const selectedTimeLabelParam = query.get("selectedTime");
    const sortBy = query.get("sortBy") ?? "";
    const [startTime, setStartTime] = (0, $g5BLJ.useState)((0, $97971de7222d1c39$export$7f608b480d9e7085)[dateRange].value.start);
    const [startTimeLoaded, setStartTimeLoaded] = (0, $g5BLJ.useState)(false);
    const [dateRangeLoaded, setDateRangeLoaded] = (0, $g5BLJ.useState)(false);
    const columns = [
        {
            id: "student",
            name: "Student",
            render: ({ student: student , submissionCount: submissionCount  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e03e507529e9b7f0$export$1d6c1feb46596a6f), {
                    testTag: "student-tag",
                    primaryText: (0, $75cd274e63beb59b$export$61b6a526e2f145be)(student),
                    secondaryText: `${(0, $e6116bf527c207db$export$cefb40c9962541b5)("Submission", submissionCount)}`,
                    avatar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                        backgroundColor: student.avatarColor || (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex,
                        name: student.displayName
                    }, student.displayName)
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: ({ student: student  })=>(0, $75cd274e63beb59b$export$61b6a526e2f145be)(student)
        },
        {
            id: "completion",
            name: "Completion",
            tooltipContent: "Total Words Correct / Total Words Assigned",
            render: ({ submissionCount: submissionCount , independentOnly: independentOnly , completion: completion  })=>submissionCount === 0 || independentOnly ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7b25f9b5308f7290$var$Empty, {
                    tooltipText: submissionCount === 0 ? undefined : "Cannot calculate completion for independent readings"
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, completion)
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (student)=>student.completion
        },
        {
            id: "wordsCorrectPerMinute",
            name: "WCPM",
            tooltipContent: "Words Correct Per Minute (Total Words Correct / Total Time Read)",
            render: ({ wordsCorrectPerMinute: wordsCorrectPerMinute , submissionCount: submissionCount , independentOnly: independentOnly  })=>submissionCount === 0 || independentOnly ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7b25f9b5308f7290$var$Empty, {
                    tooltipText: submissionCount === 0 ? undefined : "Cannot calculate WCPM for independent readings"
                }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, wordsCorrectPerMinute)
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (student)=>student.wordsCorrectPerMinute
        },
        {
            id: "wordsPerMinute",
            name: "WPM",
            tooltipContent: "Words Per Minute",
            render: ({ wordsPerMinute: wordsPerMinute , submissionCount: submissionCount  })=>submissionCount === 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7b25f9b5308f7290$var$Empty, {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, wordsPerMinute)
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (student)=>student.wordsPerMinute
        },
        {
            id: "words",
            name: "Words Read",
            render: ({ wordsSaidCount: wordsSaidCount , submissionCount: submissionCount  })=>submissionCount === 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7b25f9b5308f7290$var$Empty, {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words, wordsSaidCount)
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (student)=>student.wordsSaidCount
        },
        {
            id: "time",
            name: "Time",
            render: ({ totalTime: totalTime , submissionCount: submissionCount  })=>submissionCount === 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7b25f9b5308f7290$var$Empty, {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, totalTime)
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (student)=>student.totalTime
        },
        {
            id: "tasks",
            name: "Tasks",
            render: (student)=>student.submissionCount === 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7b25f9b5308f7290$var$Empty, {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    children: [
                        student.totalFinishedTasks,
                        " / ",
                        student.totalTasks
                    ]
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (student)=>student.totalFinishedTasks
        },
        {
            id: "online",
            name: "Last Online",
            render: (student)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    color: student.student.status === "pre_registered" ? "danger" : "black",
                    children: student.student.status === "pre_registered" ? "Never" : (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(student.online))
                }),
            sortType: "sortBy",
            defaultSortDirection: "desc",
            sortBy: (student)=>student.online
        }
    ];
    const studentResults = (0, $g5BLJ.useMemo)(()=>{
        return stats.toList();
    }, [
        stats
    ]);
    const memoedCourseTabs = (0, $g5BLJ.useMemo)(()=>(0, $d157168146708baf$export$7c91aea2d259c517)(courses, teachersMap, currentUser), [
        courses,
        currentUser,
        teachersMap
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!currentUser) return;
        if (selectedTimeLabelParam) setField("dateRange")(selectedTimeLabelParam);
        else setField("dateRange")((0, $4ded3b2c5af96cca$export$5c806aff8bda9109)(currentPlan));
        setDateRangeLoaded(true);
    }, [
        currentPlan,
        selectedTimeLabelParam,
        currentUser,
        setField,
        setStartTime
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (dateRangeLoaded) {
            setStartTime((0, $97971de7222d1c39$export$7f608b480d9e7085)[dateRange].value.start);
            setStartTimeLoaded(true);
        }
    }, [
        dateRange,
        dateRangeLoaded
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!startTimeLoaded) return;
        load(selectedCourseId, startTime, dateRange);
    }, [
        load,
        selectedCourseId,
        startTime,
        dateRange,
        startTimeLoaded
    ]);
    const updateTimeParam = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            selectedTime: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const columnNames = [
        "Last Name/Username",
        "First Name",
        "Completion",
        "WCPM",
        "WPM",
        "Words Read",
        "Time",
        "Tasks",
        "Last Online"
    ];
    const studentData = (0, $g5BLJ.useMemo)(()=>studentResults.map(({ student: student , ...stats })=>[
                student.familyName || student.displayName,
                student.givenName || "",
                stats.completion === 0 ? "" : (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, stats.completion),
                stats.wordsCorrectPerMinute === 0 ? "" : (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, stats.wordsCorrectPerMinute),
                stats.wordsSaidCount === 0 ? "" : stats.wordsSaidCount.toString(),
                stats.totalTime === 0 ? "" : (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, stats.totalTime),
                !stats.totalFinishedTasks && !stats.totalTasks ? "" : `${stats.totalFinishedTasks} / ${stats.totalTasks}`,
                (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(stats.online))
            ]), [
        studentResults
    ]);
    const fileData = studentData.insert(0, columnNames);
    const getFilename = ()=>{
        const course = courses.find((course)=>course.id === selectedCourseId);
        return `${course?.name.substring(0, 20) || "All Students"}-progress-report`;
    };
    const hasCsvExport = Boolean(currentUser?.flags.isCsvExportEnabled);
    const TooltipElem = hasCsvExport ? (0, $a31343b90c9d3d88$export$28c660c63b792dea) : (0, $be64e7ee3b40f0c7$export$13c138588c4d3358);
    const tooltipProps = {
        content: hasCsvExport ? "Export Table as CSV" : `Upgrade to ${0, $4ded3b2c5af96cca$export$52756c3ad45aa25c} to seamlessly export all your data`,
        linkLocation: "contact"
    };
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        minWidth: 0,
        height: "100%",
        direction: "column",
        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
        overflowY: "auto",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]}`,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[7]} 0`,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        justify: "space-between",
                        align: "center",
                        wrap: "wrap",
                        margin: `-${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[8]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h2",
                                    color: "white",
                                    children: "Progress Monitoring"
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                justify: "end",
                                margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $97971de7222d1c39$export$5109c6dd95d8fb00), {
                                        value: dateRange,
                                        name: "assessmentDatePicker",
                                        onChange: (v)=>{
                                            setField("dateRange")(v.label);
                                            setStartTime(v.label === "All Time" ? null : v.value.start);
                                            updateTimeParam(v.label);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(TooltipElem, {
                                        enabled: true,
                                        ...tooltipProps,
                                        display: "flex",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                            testTag: "export-csv-button",
                                            displayType: "iconOnly",
                                            icon: "download",
                                            color: "white",
                                            width: "70px",
                                            borderRadiusOverride: "2",
                                            disabled: !hasCsvExport,
                                            onClick: (0, $438c2fba1c8fa207$export$35193a8a641bb1b)({
                                                data: fileData,
                                                filename: getFilename(),
                                                fetchJson: fetchJson
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                minWidth: 0,
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    minWidth: 0,
                    maxWidth: "100%",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e3aa8aeb4209bd7$export$44c45b2b7f09d2a6), {
                        skeumorphic: true,
                        queryParam: "selectedCourseId",
                        tabs: memoedCourseTabs
                    })
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                justify: "space-between",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[6]} 0 ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e3aa8aeb4209bd7$export$44c45b2b7f09d2a6), {
                            tabs: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                {
                                    id: "all",
                                    name: "Students"
                                }
                            ]),
                            queryParam: ""
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2511447d0cb3d32$export$55d7609a8f1eccd2), {
                            value: search,
                            onChange: setField("search"),
                            placeholder: "Search Students"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                minWidth: 0,
                minHeight: 0,
                height: "100%",
                children: [
                    isLoading || !startTimeLoaded ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                        flex: true,
                        kind: "boat"
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                        columns: columns,
                        rows: (0, $d5a1fd3dea1a0ab6$export$e3340ddcfe22553f)(search, studentResults, (sr)=>(0, $75cd274e63beb59b$export$61b6a526e2f145be)(sr.student)),
                        getRowId: ({ student: student  })=>student.id,
                        queryParam: "sortBy",
                        rowClickable: true,
                        onRowClick: ({ student: student  })=>{
                            history.push(`/t/progress-monitoring/${student.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                                backPath: `/t/progress-monitoring${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                                selectedCourseId: selectedCourseId,
                                selectedTime: dateRange,
                                sortBy: $7b25f9b5308f7290$var$studentProgressMonitoringColumnIds.includes(sortBy) ? sortBy : "",
                                sortByDirection: query.get("sortByDirection") ?? ""
                            }))}`);
                        },
                        initialSortSettings: {
                            columnId: "student",
                            sortDirection: "asc"
                        },
                        emptyStateContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
                            kind: currentUser?.paperSyncedAt ? "progressMonitoringPaper" : "progressMonitoring"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 5
                    })
                ]
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");
/*!
 * Chart.js v4.3.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.3.0
 * https://www.chartjs.org
 * (c) 2023 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */ function $eff34e1dbfb9b161$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $eff34e1dbfb9b161$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $eff34e1dbfb9b161$export$bcc6e673dfa14d36(v) {
    return $eff34e1dbfb9b161$export$837ba5c449269406($eff34e1dbfb9b161$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $eff34e1dbfb9b161$export$869b26d4e1bbdb63(v) {
    return $eff34e1dbfb9b161$export$837ba5c449269406($eff34e1dbfb9b161$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6(v) {
    return $eff34e1dbfb9b161$export$837ba5c449269406($eff34e1dbfb9b161$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $eff34e1dbfb9b161$export$dbf961a8d278dbef(v) {
    return $eff34e1dbfb9b161$export$837ba5c449269406($eff34e1dbfb9b161$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $eff34e1dbfb9b161$export$aa35ef1f24408ab9(v) {
    return $eff34e1dbfb9b161$export$837ba5c449269406($eff34e1dbfb9b161$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $eff34e1dbfb9b161$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $eff34e1dbfb9b161$var$hex = [
    ..."0123456789ABCDEF"
];
const $eff34e1dbfb9b161$var$h1 = (b)=>$eff34e1dbfb9b161$var$hex[b & 0xF];
const $eff34e1dbfb9b161$var$h2 = (b)=>$eff34e1dbfb9b161$var$hex[(b & 0xF0) >> 4] + $eff34e1dbfb9b161$var$hex[b & 0xF];
const $eff34e1dbfb9b161$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $eff34e1dbfb9b161$var$isShort = (v)=>$eff34e1dbfb9b161$var$eq(v.r) && $eff34e1dbfb9b161$var$eq(v.g) && $eff34e1dbfb9b161$var$eq(v.b) && $eff34e1dbfb9b161$var$eq(v.a);
function $eff34e1dbfb9b161$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === "#") {
        if (len === 4 || len === 5) ret = {
            r: 255 & $eff34e1dbfb9b161$var$map$1[str[1]] * 17,
            g: 255 & $eff34e1dbfb9b161$var$map$1[str[2]] * 17,
            b: 255 & $eff34e1dbfb9b161$var$map$1[str[3]] * 17,
            a: len === 5 ? $eff34e1dbfb9b161$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $eff34e1dbfb9b161$var$map$1[str[1]] << 4 | $eff34e1dbfb9b161$var$map$1[str[2]],
            g: $eff34e1dbfb9b161$var$map$1[str[3]] << 4 | $eff34e1dbfb9b161$var$map$1[str[4]],
            b: $eff34e1dbfb9b161$var$map$1[str[5]] << 4 | $eff34e1dbfb9b161$var$map$1[str[6]],
            a: len === 9 ? $eff34e1dbfb9b161$var$map$1[str[7]] << 4 | $eff34e1dbfb9b161$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $eff34e1dbfb9b161$var$alpha = (a, f)=>a < 255 ? f(a) : "";
function $eff34e1dbfb9b161$export$1b06654353ef9f67(v) {
    var f = $eff34e1dbfb9b161$var$isShort(v) ? $eff34e1dbfb9b161$var$h1 : $eff34e1dbfb9b161$var$h2;
    return v ? "#" + f(v.r) + f(v.g) + f(v.b) + $eff34e1dbfb9b161$var$alpha(v.a, f) : undefined;
}
const $eff34e1dbfb9b161$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $eff34e1dbfb9b161$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $eff34e1dbfb9b161$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $eff34e1dbfb9b161$var$hwb2rgbn(h, w, b) {
    const rgb = $eff34e1dbfb9b161$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $eff34e1dbfb9b161$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $eff34e1dbfb9b161$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $eff34e1dbfb9b161$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $eff34e1dbfb9b161$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($eff34e1dbfb9b161$export$ed9bd8dcaeba14f6);
}
function $eff34e1dbfb9b161$export$4c15bd42559b811d(h, s, l) {
    return $eff34e1dbfb9b161$var$calln($eff34e1dbfb9b161$var$hsl2rgbn, h, s, l);
}
function $eff34e1dbfb9b161$export$e2710022c70fc9ee(h, w, b) {
    return $eff34e1dbfb9b161$var$calln($eff34e1dbfb9b161$var$hwb2rgbn, h, w, b);
}
function $eff34e1dbfb9b161$export$b785a357c84e4a04(h, s, v) {
    return $eff34e1dbfb9b161$var$calln($eff34e1dbfb9b161$var$hsv2rgbn, h, s, v);
}
function $eff34e1dbfb9b161$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $eff34e1dbfb9b161$export$5e91288c399be4f9(str) {
    const m = $eff34e1dbfb9b161$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $eff34e1dbfb9b161$export$bcc6e673dfa14d36(+m[5]) : $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $eff34e1dbfb9b161$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === "hwb") v = $eff34e1dbfb9b161$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === "hsv") v = $eff34e1dbfb9b161$export$b785a357c84e4a04(h, p1, p2);
    else v = $eff34e1dbfb9b161$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $eff34e1dbfb9b161$export$bb628a54ab399bc9(v, deg) {
    var h = $eff34e1dbfb9b161$export$b5ba70b240f8f7f(v);
    h[0] = $eff34e1dbfb9b161$var$hue(h[0] + deg);
    h = $eff34e1dbfb9b161$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $eff34e1dbfb9b161$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $eff34e1dbfb9b161$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $eff34e1dbfb9b161$export$aa35ef1f24408ab9(a[1]);
    const l = $eff34e1dbfb9b161$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$eff34e1dbfb9b161$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $eff34e1dbfb9b161$var$map = {
    x: "dark",
    Z: "light",
    Y: "re",
    X: "blu",
    W: "gr",
    V: "medium",
    U: "slate",
    A: "ee",
    T: "ol",
    S: "or",
    B: "ra",
    C: "lateg",
    D: "ights",
    R: "in",
    Q: "turquois",
    E: "hi",
    P: "ro",
    O: "al",
    N: "le",
    M: "de",
    L: "yello",
    F: "en",
    K: "ch",
    G: "arks",
    H: "ea",
    I: "ightg",
    J: "wh"
};
const $eff34e1dbfb9b161$var$names$1 = {
    OiceXe: "f0f8ff",
    antiquewEte: "faebd7",
    aqua: "ffff",
    aquamarRe: "7fffd4",
    azuY: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "0",
    blanKedOmond: "ffebcd",
    Xe: "ff",
    XeviTet: "8a2be2",
    bPwn: "a52a2a",
    burlywood: "deb887",
    caMtXe: "5f9ea0",
    KartYuse: "7fff00",
    KocTate: "d2691e",
    cSO: "ff7f50",
    cSnflowerXe: "6495ed",
    cSnsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "ffff",
    xXe: "8b",
    xcyan: "8b8b",
    xgTMnPd: "b8860b",
    xWay: "a9a9a9",
    xgYF: "6400",
    xgYy: "a9a9a9",
    xkhaki: "bdb76b",
    xmagFta: "8b008b",
    xTivegYF: "556b2f",
    xSange: "ff8c00",
    xScEd: "9932cc",
    xYd: "8b0000",
    xsOmon: "e9967a",
    xsHgYF: "8fbc8f",
    xUXe: "483d8b",
    xUWay: "2f4f4f",
    xUgYy: "2f4f4f",
    xQe: "ced1",
    xviTet: "9400d3",
    dAppRk: "ff1493",
    dApskyXe: "bfff",
    dimWay: "696969",
    dimgYy: "696969",
    dodgerXe: "1e90ff",
    fiYbrick: "b22222",
    flSOwEte: "fffaf0",
    foYstWAn: "228b22",
    fuKsia: "ff00ff",
    gaRsbSo: "dcdcdc",
    ghostwEte: "f8f8ff",
    gTd: "ffd700",
    gTMnPd: "daa520",
    Way: "808080",
    gYF: "8000",
    gYFLw: "adff2f",
    gYy: "808080",
    honeyMw: "f0fff0",
    hotpRk: "ff69b4",
    RdianYd: "cd5c5c",
    Rdigo: "4b0082",
    ivSy: "fffff0",
    khaki: "f0e68c",
    lavFMr: "e6e6fa",
    lavFMrXsh: "fff0f5",
    lawngYF: "7cfc00",
    NmoncEffon: "fffacd",
    ZXe: "add8e6",
    ZcSO: "f08080",
    Zcyan: "e0ffff",
    ZgTMnPdLw: "fafad2",
    ZWay: "d3d3d3",
    ZgYF: "90ee90",
    ZgYy: "d3d3d3",
    ZpRk: "ffb6c1",
    ZsOmon: "ffa07a",
    ZsHgYF: "20b2aa",
    ZskyXe: "87cefa",
    ZUWay: "778899",
    ZUgYy: "778899",
    ZstAlXe: "b0c4de",
    ZLw: "ffffe0",
    lime: "ff00",
    limegYF: "32cd32",
    lRF: "faf0e6",
    magFta: "ff00ff",
    maPon: "800000",
    VaquamarRe: "66cdaa",
    VXe: "cd",
    VScEd: "ba55d3",
    VpurpN: "9370db",
    VsHgYF: "3cb371",
    VUXe: "7b68ee",
    VsprRggYF: "fa9a",
    VQe: "48d1cc",
    VviTetYd: "c71585",
    midnightXe: "191970",
    mRtcYam: "f5fffa",
    mistyPse: "ffe4e1",
    moccasR: "ffe4b5",
    navajowEte: "ffdead",
    navy: "80",
    Tdlace: "fdf5e6",
    Tive: "808000",
    TivedBb: "6b8e23",
    Sange: "ffa500",
    SangeYd: "ff4500",
    ScEd: "da70d6",
    pOegTMnPd: "eee8aa",
    pOegYF: "98fb98",
    pOeQe: "afeeee",
    pOeviTetYd: "db7093",
    papayawEp: "ffefd5",
    pHKpuff: "ffdab9",
    peru: "cd853f",
    pRk: "ffc0cb",
    plum: "dda0dd",
    powMrXe: "b0e0e6",
    purpN: "800080",
    YbeccapurpN: "663399",
    Yd: "ff0000",
    Psybrown: "bc8f8f",
    PyOXe: "4169e1",
    saddNbPwn: "8b4513",
    sOmon: "fa8072",
    sandybPwn: "f4a460",
    sHgYF: "2e8b57",
    sHshell: "fff5ee",
    siFna: "a0522d",
    silver: "c0c0c0",
    skyXe: "87ceeb",
    UXe: "6a5acd",
    UWay: "708090",
    UgYy: "708090",
    snow: "fffafa",
    sprRggYF: "ff7f",
    stAlXe: "4682b4",
    tan: "d2b48c",
    teO: "8080",
    tEstN: "d8bfd8",
    tomato: "ff6347",
    Qe: "40e0d0",
    viTet: "ee82ee",
    JHt: "f5deb3",
    wEte: "ffffff",
    wEtesmoke: "f5f5f5",
    Lw: "ffff00",
    LwgYF: "9acd32"
};
function $eff34e1dbfb9b161$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($eff34e1dbfb9b161$var$names$1);
    const tkeys = Object.keys($eff34e1dbfb9b161$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $eff34e1dbfb9b161$var$map[k]);
        }
        k = parseInt($eff34e1dbfb9b161$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $eff34e1dbfb9b161$var$names;
function $eff34e1dbfb9b161$export$b2f06b640faad956(str) {
    if (!$eff34e1dbfb9b161$var$names) {
        $eff34e1dbfb9b161$var$names = $eff34e1dbfb9b161$var$unpack();
        $eff34e1dbfb9b161$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $eff34e1dbfb9b161$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $eff34e1dbfb9b161$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $eff34e1dbfb9b161$export$91aedb20f296e541(str) {
    const m = $eff34e1dbfb9b161$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $eff34e1dbfb9b161$export$bcc6e673dfa14d36(v) : $eff34e1dbfb9b161$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $eff34e1dbfb9b161$export$bcc6e673dfa14d36(r) : $eff34e1dbfb9b161$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $eff34e1dbfb9b161$export$bcc6e673dfa14d36(g) : $eff34e1dbfb9b161$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $eff34e1dbfb9b161$export$bcc6e673dfa14d36(b) : $eff34e1dbfb9b161$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $eff34e1dbfb9b161$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$eff34e1dbfb9b161$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $eff34e1dbfb9b161$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $eff34e1dbfb9b161$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $eff34e1dbfb9b161$var$interpolate(rgb1, rgb2, t) {
    const r = $eff34e1dbfb9b161$var$from($eff34e1dbfb9b161$export$dbf961a8d278dbef(rgb1.r));
    const g = $eff34e1dbfb9b161$var$from($eff34e1dbfb9b161$export$dbf961a8d278dbef(rgb1.g));
    const b = $eff34e1dbfb9b161$var$from($eff34e1dbfb9b161$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6($eff34e1dbfb9b161$var$to(r + t * ($eff34e1dbfb9b161$var$from($eff34e1dbfb9b161$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6($eff34e1dbfb9b161$var$to(g + t * ($eff34e1dbfb9b161$var$from($eff34e1dbfb9b161$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6($eff34e1dbfb9b161$var$to(b + t * ($eff34e1dbfb9b161$var$from($eff34e1dbfb9b161$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $eff34e1dbfb9b161$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $eff34e1dbfb9b161$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $eff34e1dbfb9b161$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $eff34e1dbfb9b161$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $eff34e1dbfb9b161$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $eff34e1dbfb9b161$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $eff34e1dbfb9b161$var$functionParse(str) {
    if (str.charAt(0) === "r") return $eff34e1dbfb9b161$export$91aedb20f296e541(str);
    return $eff34e1dbfb9b161$export$5e91288c399be4f9(str);
}
class $eff34e1dbfb9b161$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $eff34e1dbfb9b161$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === "object") v = $eff34e1dbfb9b161$var$fromObject(input);
        else if (type === "string") v = $eff34e1dbfb9b161$export$625a38b961e8b5e9(input) || $eff34e1dbfb9b161$export$b2f06b640faad956(input) || $eff34e1dbfb9b161$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $eff34e1dbfb9b161$var$clone(this._rgb);
        if (v) v.a = $eff34e1dbfb9b161$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $eff34e1dbfb9b161$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $eff34e1dbfb9b161$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $eff34e1dbfb9b161$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $eff34e1dbfb9b161$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $eff34e1dbfb9b161$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $eff34e1dbfb9b161$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $eff34e1dbfb9b161$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $eff34e1dbfb9b161$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $eff34e1dbfb9b161$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $eff34e1dbfb9b161$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $eff34e1dbfb9b161$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $eff34e1dbfb9b161$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $eff34e1dbfb9b161$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $eff34e1dbfb9b161$export$2e2bcd8739ae039(input) {
    return new $eff34e1dbfb9b161$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $9bad38c73ebb867d$export$cf2f7c5792f80b46() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $9bad38c73ebb867d$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $9bad38c73ebb867d$export$342063e11d6c3cad(value) {
    return value === null || typeof value === "undefined";
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $9bad38c73ebb867d$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $9bad38c73ebb867d$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $9bad38c73ebb867d$export$39b482c5e57630a8(value) {
    return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $9bad38c73ebb867d$export$c4ce752e73470fba(value, defaultValue) {
    return $9bad38c73ebb867d$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $9bad38c73ebb867d$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === "undefined" ? defaultValue : value;
}
const $9bad38c73ebb867d$export$953cecd6e717a553 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 : +value / dimension;
const $9bad38c73ebb867d$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $9bad38c73ebb867d$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === "function") return fn.apply(thisArg, args);
}
function $9bad38c73ebb867d$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($9bad38c73ebb867d$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($9bad38c73ebb867d$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $9bad38c73ebb867d$export$995eb9fca571757(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $9bad38c73ebb867d$export$d377dcb2b61d6c4e(source) {
    if ($9bad38c73ebb867d$export$8b22cf2602fb60ce(source)) return source.map($9bad38c73ebb867d$export$d377dcb2b61d6c4e);
    if ($9bad38c73ebb867d$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $9bad38c73ebb867d$export$d377dcb2b61d6c4e(source[keys[k]]);
        return target;
    }
    return source;
}
function $9bad38c73ebb867d$var$isValidKey(key) {
    return [
        "__proto__",
        "prototype",
        "constructor"
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $9bad38c73ebb867d$export$667d3bf0c5f83305(key, target, source, options) {
    if (!$9bad38c73ebb867d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($9bad38c73ebb867d$export$23f2a1d2818174ef(tval) && $9bad38c73ebb867d$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $9bad38c73ebb867d$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $9bad38c73ebb867d$export$d377dcb2b61d6c4e(sval);
}
function $9bad38c73ebb867d$export$efca4cbe5dd06740(target, source, options) {
    const sources = $9bad38c73ebb867d$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$9bad38c73ebb867d$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $9bad38c73ebb867d$export$667d3bf0c5f83305;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$9bad38c73ebb867d$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $9bad38c73ebb867d$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $9bad38c73ebb867d$export$efca4cbe5dd06740(target, source, {
        merger: $9bad38c73ebb867d$export$317a3d46287192d8
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $9bad38c73ebb867d$export$317a3d46287192d8(key, target, source) {
    if (!$9bad38c73ebb867d$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($9bad38c73ebb867d$export$23f2a1d2818174ef(tval) && $9bad38c73ebb867d$export$23f2a1d2818174ef(sval)) $9bad38c73ebb867d$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $9bad38c73ebb867d$export$d377dcb2b61d6c4e(sval);
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$1ee57be6f6687d2c(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $9bad38c73ebb867d$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    "": (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $9bad38c73ebb867d$export$9d0e2d13d04f7070(key) {
    const parts = key.split(".");
    const keys = [];
    let tmp = "";
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith("\\")) tmp = tmp.slice(0, -1) + ".";
        else {
            keys.push(tmp);
            tmp = "";
        }
    }
    return keys;
}
function $9bad38c73ebb867d$var$_getKeyResolver(key) {
    const keys = $9bad38c73ebb867d$export$9d0e2d13d04f7070(key);
    return (obj)=>{
        for (const k of keys){
            if (k === "") break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $9bad38c73ebb867d$export$2d1720544b23b823(obj, key) {
    const resolver = $9bad38c73ebb867d$var$keyResolvers[key] || ($9bad38c73ebb867d$var$keyResolvers[key] = $9bad38c73ebb867d$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $9bad38c73ebb867d$export$dda1d9f60106f0e9 = (value)=>typeof value !== "undefined";
const $9bad38c73ebb867d$export$a93c5207d687da10 = (value)=>typeof value === "function";
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $9bad38c73ebb867d$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $9bad38c73ebb867d$export$f38c853ae54ed474(e) {
    return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $9bad38c73ebb867d$export$56c0d5a1e737357d = Math.PI;
const $9bad38c73ebb867d$export$971d5caa766a69d7 = 2 * $9bad38c73ebb867d$export$56c0d5a1e737357d;
const $9bad38c73ebb867d$export$d29e374196577086 = $9bad38c73ebb867d$export$971d5caa766a69d7 + $9bad38c73ebb867d$export$56c0d5a1e737357d;
const $9bad38c73ebb867d$export$2ec5befb9e6c97d4 = Number.POSITIVE_INFINITY;
const $9bad38c73ebb867d$export$53c86fa97d611818 = $9bad38c73ebb867d$export$56c0d5a1e737357d / 180;
const $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd = $9bad38c73ebb867d$export$56c0d5a1e737357d / 2;
const $9bad38c73ebb867d$export$39c1cc7c062529d4 = $9bad38c73ebb867d$export$56c0d5a1e737357d / 4;
const $9bad38c73ebb867d$export$7a0bdf7d4a91ea88 = $9bad38c73ebb867d$export$56c0d5a1e737357d * 2 / 3;
const $9bad38c73ebb867d$export$9f4f30ee63539e24 = Math.log10;
const $9bad38c73ebb867d$export$2408f22a0fab9ae5 = Math.sign;
function $9bad38c73ebb867d$export$a05254e7c3aeba6e(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $9bad38c73ebb867d$export$a33b77bbdbb8366c(range) {
    const roundedRange = Math.round(range);
    range = $9bad38c73ebb867d$export$a05254e7c3aeba6e(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($9bad38c73ebb867d$export$9f4f30ee63539e24(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $9bad38c73ebb867d$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
function $9bad38c73ebb867d$export$d141bba7fdc215a3(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
function $9bad38c73ebb867d$export$b9a6b53f9be3734(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$53a70dd1ebbae346(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $9bad38c73ebb867d$export$625550452a3fa3ec(degrees) {
    return degrees * ($9bad38c73ebb867d$export$56c0d5a1e737357d / 180);
}
function $9bad38c73ebb867d$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $9bad38c73ebb867d$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $9bad38c73ebb867d$export$23ebac1979863676(x) {
    if (!$9bad38c73ebb867d$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $9bad38c73ebb867d$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $9bad38c73ebb867d$export$56c0d5a1e737357d) angle += $9bad38c73ebb867d$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $9bad38c73ebb867d$export$158acd800e1ef08b(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $9bad38c73ebb867d$export$c18d01048907ea92(a, b) {
    return (a - b + $9bad38c73ebb867d$export$d29e374196577086) % $9bad38c73ebb867d$export$971d5caa766a69d7 - $9bad38c73ebb867d$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $9bad38c73ebb867d$export$28f7fcd39efa255(a) {
    return (a % $9bad38c73ebb867d$export$971d5caa766a69d7 + $9bad38c73ebb867d$export$971d5caa766a69d7) % $9bad38c73ebb867d$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $9bad38c73ebb867d$export$28f7fcd39efa255(angle);
    const s = $9bad38c73ebb867d$export$28f7fcd39efa255(start);
    const e = $9bad38c73ebb867d$export$28f7fcd39efa255(end);
    const angleToStart = $9bad38c73ebb867d$export$28f7fcd39efa255(s - a);
    const angleToEnd = $9bad38c73ebb867d$export$28f7fcd39efa255(e - a);
    const startToAngle = $9bad38c73ebb867d$export$28f7fcd39efa255(a - s);
    const endToAngle = $9bad38c73ebb867d$export$28f7fcd39efa255(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $9bad38c73ebb867d$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $9bad38c73ebb867d$export$71cec2538cb2c617(value) {
    return $9bad38c73ebb867d$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $9bad38c73ebb867d$export$3b513254972cfc9c(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $9bad38c73ebb867d$export$2ed0fc6709e59212(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $9bad38c73ebb867d$export$ef35774e6d314e91 = (table, key, value, last)=>$9bad38c73ebb867d$export$2ed0fc6709e59212(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $9bad38c73ebb867d$export$ebd11618f299a286 = (table, key, value)=>$9bad38c73ebb867d$export$2ed0fc6709e59212(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $9bad38c73ebb867d$export$c03999cb2f36933f(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $9bad38c73ebb867d$var$arrayEvents = [
    "push",
    "pop",
    "shift",
    "splice",
    "unshift"
];
function $9bad38c73ebb867d$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, "_chartjs", {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $9bad38c73ebb867d$var$arrayEvents.forEach((key)=>{
        const method = "_onData" + $9bad38c73ebb867d$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === "function") object[method](...args);
                });
                return res;
            }
        });
    });
}
function $9bad38c73ebb867d$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $9bad38c73ebb867d$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $9bad38c73ebb867d$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $9bad38c73ebb867d$export$fef3dfd9bad05307(pixelSize, fontStyle, fontFamily) {
    return fontStyle + " " + pixelSize + "px " + fontFamily;
}
/**
* Request animation polyfill
*/ const $9bad38c73ebb867d$export$43caf9889c228507 = function() {
    if (typeof window === "undefined") return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $9bad38c73ebb867d$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $9bad38c73ebb867d$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $9bad38c73ebb867d$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $9bad38c73ebb867d$export$3c2fa207a37baaea = (align)=>align === "start" ? "left" : align === "end" ? "right" : "center";
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $9bad38c73ebb867d$export$ce26c07117d59d6a = (align, start, end)=>align === "start" ? start : align === "end" ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $9bad38c73ebb867d$export$9d398bebfec1c039 = (align, left, right, rtl)=>{
    const check = rtl ? "left" : "right";
    return align === check ? right : align === "center" ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $9bad38c73ebb867d$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale , _parsed: _parsed  } = meta;
        const axis = iScale.axis;
        const { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = iScale.getUserBounds();
        if (minDefined) start = $9bad38c73ebb867d$export$25ce5a424b770e84(Math.min($9bad38c73ebb867d$export$ef35774e6d314e91(_parsed, iScale.axis, min).lo, animationsDisabled ? pointCount : $9bad38c73ebb867d$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo), 0, pointCount - 1);
        if (maxDefined) count = $9bad38c73ebb867d$export$25ce5a424b770e84(Math.max($9bad38c73ebb867d$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $9bad38c73ebb867d$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1), start, pointCount) - start;
        else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $9bad38c73ebb867d$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale , yScale: yScale , _scaleRanges: _scaleRanges  } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $9bad38c73ebb867d$var$atEdge = (t)=>t === 0 || t === 1;
const $9bad38c73ebb867d$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $9bad38c73ebb867d$export$971d5caa766a69d7 / p));
const $9bad38c73ebb867d$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $9bad38c73ebb867d$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $9bad38c73ebb867d$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($9bad38c73ebb867d$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$9bad38c73ebb867d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$9bad38c73ebb867d$var$atEdge(t) ? t : $9bad38c73ebb867d$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$9bad38c73ebb867d$var$atEdge(t) ? t : $9bad38c73ebb867d$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $9bad38c73ebb867d$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $9bad38c73ebb867d$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $9bad38c73ebb867d$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $9bad38c73ebb867d$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $9bad38c73ebb867d$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $9bad38c73ebb867d$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $9bad38c73ebb867d$export$f96d196f7728bb5(value) {
    if (value && typeof value === "object") {
        const type = value.toString();
        return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
    }
    return false;
}
function $9bad38c73ebb867d$export$db3b6bfb95261072(value) {
    return $9bad38c73ebb867d$export$f96d196f7728bb5(value) ? value : new (0, $eff34e1dbfb9b161$export$892596cec99bc70e)(value);
}
function $9bad38c73ebb867d$export$738ab4df8bf92ae9(value) {
    return $9bad38c73ebb867d$export$f96d196f7728bb5(value) ? value : new (0, $eff34e1dbfb9b161$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $9bad38c73ebb867d$var$numbers = [
    "x",
    "y",
    "borderWidth",
    "radius",
    "tension"
];
const $9bad38c73ebb867d$var$colors = [
    "color",
    "borderColor",
    "backgroundColor"
];
function $9bad38c73ebb867d$var$applyAnimationsDefaults(defaults) {
    defaults.set("animation", {
        delay: undefined,
        duration: 1000,
        easing: "easeOutQuart",
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe("animation", {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== "onProgress" && name !== "onComplete" && name !== "fn"
    });
    defaults.set("animations", {
        colors: {
            type: "color",
            properties: $9bad38c73ebb867d$var$colors
        },
        numbers: {
            type: "number",
            properties: $9bad38c73ebb867d$var$numbers
        }
    });
    defaults.describe("animations", {
        _fallback: "animation"
    });
    defaults.set("transitions", {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: "transparent"
                },
                visible: {
                    type: "boolean",
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: "transparent"
                },
                visible: {
                    type: "boolean",
                    easing: "linear",
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $9bad38c73ebb867d$var$applyLayoutsDefaults(defaults) {
    defaults.set("layout", {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $9bad38c73ebb867d$var$intlCache = new Map();
function $9bad38c73ebb867d$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $9bad38c73ebb867d$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $9bad38c73ebb867d$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $9bad38c73ebb867d$export$ae1af26003f05816(num, locale, options) {
    return $9bad38c73ebb867d$var$getNumberFormat(locale, options).format(num);
}
const $9bad38c73ebb867d$var$formatters = {
    values (value) {
        return $9bad38c73ebb867d$export$8b22cf2602fb60ce(value) ? value : "" + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = "scientific";
            delta = $9bad38c73ebb867d$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $9bad38c73ebb867d$export$9f4f30ee63539e24(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $9bad38c73ebb867d$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return "0";
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($9bad38c73ebb867d$export$9f4f30ee63539e24(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $9bad38c73ebb867d$var$formatters.numeric.call(this, tickValue, index, ticks);
        return "";
    }
};
function $9bad38c73ebb867d$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $9bad38c73ebb867d$export$91477dc880baac21 = {
    formatters: $9bad38c73ebb867d$var$formatters
};
function $9bad38c73ebb867d$var$applyScaleDefaults(defaults) {
    defaults.set("scale", {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: "ticks",
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: "",
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: "",
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $9bad38c73ebb867d$export$91477dc880baac21.formatters.values,
            minor: {},
            major: {},
            align: "center",
            crossAlign: "near",
            showLabelBackdrop: false,
            backdropColor: "rgba(255, 255, 255, 0.75)",
            backdropPadding: 2
        }
    });
    defaults.route("scale.ticks", "color", "", "color");
    defaults.route("scale.grid", "color", "", "borderColor");
    defaults.route("scale.border", "color", "", "borderColor");
    defaults.route("scale.title", "color", "", "color");
    defaults.describe("scale", {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
        _indexable: (name)=>name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
    });
    defaults.describe("scales", {
        _fallback: "scale"
    });
    defaults.describe("scale.ticks", {
        _scriptable: (name)=>name !== "backdropPadding" && name !== "callback",
        _indexable: (name)=>name !== "backdropPadding"
    });
}
const $9bad38c73ebb867d$export$6559d589eb85fbb6 = Object.create(null);
const $9bad38c73ebb867d$export$2e2af4578d910ddf = Object.create(null);
function $9bad38c73ebb867d$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split(".");
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $9bad38c73ebb867d$var$set(root, scope, values) {
    if (typeof scope === "string") return $9bad38c73ebb867d$export$efca4cbe5dd06740($9bad38c73ebb867d$var$getScope$1(root, scope), values);
    return $9bad38c73ebb867d$export$efca4cbe5dd06740($9bad38c73ebb867d$var$getScope$1(root, ""), scope);
}
class $9bad38c73ebb867d$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this.borderColor = "rgba(0,0,0,0.1)";
        this.color = "#666";
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            "mousemove",
            "mouseout",
            "click",
            "touchstart",
            "touchmove"
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: "normal",
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$9bad38c73ebb867d$export$738ab4df8bf92ae9(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$9bad38c73ebb867d$export$738ab4df8bf92ae9(options.borderColor);
        this.hoverColor = (ctx, options)=>$9bad38c73ebb867d$export$738ab4df8bf92ae9(options.color);
        this.indexAxis = "x";
        this.interaction = {
            mode: "nearest",
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $9bad38c73ebb867d$var$set(this, scope, values);
    }
    get(scope) {
        return $9bad38c73ebb867d$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $9bad38c73ebb867d$var$set($9bad38c73ebb867d$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $9bad38c73ebb867d$var$set($9bad38c73ebb867d$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $9bad38c73ebb867d$var$getScope$1(this, scope);
        const targetScopeObject = $9bad38c73ebb867d$var$getScope$1(this, targetScope);
        const privateName = "_" + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($9bad38c73ebb867d$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $9bad38c73ebb867d$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $9bad38c73ebb867d$export$4368d992c4eafac0 = /* #__PURE__ */ new $9bad38c73ebb867d$var$Defaults({
    _scriptable: (name)=>!name.startsWith("on"),
    _indexable: (name)=>name !== "events",
    hover: {
        _fallback: "interaction"
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $9bad38c73ebb867d$var$applyAnimationsDefaults,
    $9bad38c73ebb867d$var$applyLayoutsDefaults,
    $9bad38c73ebb867d$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $9bad38c73ebb867d$export$1a8f5705751d8277(font) {
    if (!font || $9bad38c73ebb867d$export$342063e11d6c3cad(font.size) || $9bad38c73ebb867d$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $9bad38c73ebb867d$export$faec65b429be379(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$9bad38c73ebb867d$export$8b22cf2602fb60ce(thing)) longest = $9bad38c73ebb867d$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($9bad38c73ebb867d$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$9bad38c73ebb867d$export$8b22cf2602fb60ce(nestedThing)) longest = $9bad38c73ebb867d$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $9bad38c73ebb867d$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $9bad38c73ebb867d$export$c9170ad7d4cd7e57(canvas, ctx) {
    ctx = ctx || canvas.getContext("2d");
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $9bad38c73ebb867d$export$493d36ec626b6698(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $9bad38c73ebb867d$export$24baa2b76016ce0e(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $9bad38c73ebb867d$export$24baa2b76016ce0e(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $9bad38c73ebb867d$export$53c86fa97d611818;
    if (style && typeof style === "object") {
        type = style.toString();
        if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $9bad38c73ebb867d$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $9bad38c73ebb867d$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case "triangle":
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $9bad38c73ebb867d$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $9bad38c73ebb867d$export$7a0bdf7d4a91ea88;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case "rectRounded":
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $9bad38c73ebb867d$export$39c1cc7c062529d4) * size;
            xOffsetW = Math.cos(rad + $9bad38c73ebb867d$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $9bad38c73ebb867d$export$39c1cc7c062529d4) * size;
            yOffsetW = Math.sin(rad + $9bad38c73ebb867d$export$39c1cc7c062529d4) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $9bad38c73ebb867d$export$56c0d5a1e737357d, rad - $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd, rad + $9bad38c73ebb867d$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case "rect":
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $9bad38c73ebb867d$export$39c1cc7c062529d4;
        /* falls through */ case "rectRot":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case "crossRot":
            rad += $9bad38c73ebb867d$export$39c1cc7c062529d4;
        /* falls through */ case "cross":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "star":
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $9bad38c73ebb867d$export$39c1cc7c062529d4;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case "line":
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case "dash":
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $9bad38c73ebb867d$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $9bad38c73ebb867d$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $9bad38c73ebb867d$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$d24c54395ce0c509(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === "middle") {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === "after" !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$6554612db691658e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $9bad38c73ebb867d$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$9bad38c73ebb867d$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $9bad38c73ebb867d$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $9bad38c73ebb867d$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $9bad38c73ebb867d$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $9bad38c73ebb867d$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $9bad38c73ebb867d$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $9bad38c73ebb867d$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$9bad38c73ebb867d$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $9bad38c73ebb867d$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $9bad38c73ebb867d$export$1fbe638ecf81657e(ctx, rect) {
    const { x: x , y: y , w: w , h: h , radius: radius  } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, -$9bad38c73ebb867d$export$7f8ddf7c7c20b3cd, $9bad38c73ebb867d$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $9bad38c73ebb867d$export$56c0d5a1e737357d, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$9bad38c73ebb867d$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $9bad38c73ebb867d$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $9bad38c73ebb867d$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $9bad38c73ebb867d$export$8c78c7c36408ea29(value, size) {
    const matches = ("" + value).match($9bad38c73ebb867d$var$LINE_HEIGHT);
    if (!matches || matches[1] === "normal") return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case "px":
            return value;
        case "%":
            value /= 100;
            break;
    }
    return size * value;
}
const $9bad38c73ebb867d$var$numberOrZero = (v)=>+v || 0;
function $9bad38c73ebb867d$export$21579262ef46735b(value, props) {
    const ret = {};
    const objProps = $9bad38c73ebb867d$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $9bad38c73ebb867d$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$9bad38c73ebb867d$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $9bad38c73ebb867d$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $9bad38c73ebb867d$export$d66dc83d8cfc8dd(value) {
    return $9bad38c73ebb867d$export$21579262ef46735b(value, {
        top: "y",
        right: "x",
        bottom: "y",
        left: "x"
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $9bad38c73ebb867d$export$92108d983e8ee699(value) {
    return $9bad38c73ebb867d$export$21579262ef46735b(value, [
        "topLeft",
        "topRight",
        "bottomLeft",
        "bottomRight"
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $9bad38c73ebb867d$export$a9c23c6ac3fc3eca(value) {
    const obj = $9bad38c73ebb867d$export$d66dc83d8cfc8dd(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $9bad38c73ebb867d$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $9bad38c73ebb867d$export$4368d992c4eafac0.font;
    let size = $9bad38c73ebb867d$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === "string") size = parseInt(size, 10);
    let style = $9bad38c73ebb867d$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !("" + style).match($9bad38c73ebb867d$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $9bad38c73ebb867d$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $9bad38c73ebb867d$export$8c78c7c36408ea29($9bad38c73ebb867d$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $9bad38c73ebb867d$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ""
    };
    font.string = $9bad38c73ebb867d$export$1a8f5705751d8277(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $9bad38c73ebb867d$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === "function") {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $9bad38c73ebb867d$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $9bad38c73ebb867d$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min , max: max  } = minmax;
    const change = $9bad38c73ebb867d$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $9bad38c73ebb867d$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $9bad38c73ebb867d$export$a9c996f45e5784d0(scopes, prefixes = [
    ""
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === "undefined") fallback = $9bad38c73ebb867d$var$_resolve("_fallback", scopes);
    const cache = {
        [Symbol.toStringTag]: "Object",
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$9bad38c73ebb867d$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $9bad38c73ebb867d$var$_cached(target, prop, ()=>$9bad38c73ebb867d$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $9bad38c73ebb867d$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $9bad38c73ebb867d$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $9bad38c73ebb867d$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $9bad38c73ebb867d$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$9bad38c73ebb867d$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$9bad38c73ebb867d$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $9bad38c73ebb867d$var$_cached(target, prop, ()=>$9bad38c73ebb867d$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable , _indexable: _indexable = defaults.indexable , _allKeys: _allKeys = defaults.allKeys  } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $9bad38c73ebb867d$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $9bad38c73ebb867d$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $9bad38c73ebb867d$var$readKey = (prefix, name)=>prefix ? prefix + $9bad38c73ebb867d$export$a8550f7dbe79f93a(name) : name;
const $9bad38c73ebb867d$var$needsSubResolver = (prop, value)=>$9bad38c73ebb867d$export$23f2a1d2818174ef(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $9bad38c73ebb867d$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop)) return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $9bad38c73ebb867d$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy , _context: _context , _subProxy: _subProxy , _descriptors: descriptors  } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($9bad38c73ebb867d$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $9bad38c73ebb867d$var$_resolveScriptable(prop, value, target, receiver);
    if ($9bad38c73ebb867d$export$8b22cf2602fb60ce(value) && value.length) value = $9bad38c73ebb867d$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($9bad38c73ebb867d$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $9bad38c73ebb867d$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $9bad38c73ebb867d$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy , _context: _context , _subProxy: _subProxy , _stack: _stack  } = target;
    if (_stack.has(prop)) throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($9bad38c73ebb867d$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $9bad38c73ebb867d$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $9bad38c73ebb867d$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy , _context: _context , _subProxy: _subProxy , _descriptors: descriptors  } = target;
    if (typeof _context.index !== "undefined" && isIndexable(prop)) return value[_context.index % value.length];
    else if ($9bad38c73ebb867d$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $9bad38c73ebb867d$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($9bad38c73ebb867d$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $9bad38c73ebb867d$var$resolveFallback(fallback, prop, value) {
    return $9bad38c73ebb867d$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $9bad38c73ebb867d$var$getScope = (key, parent)=>key === true ? parent : typeof key === "string" ? $9bad38c73ebb867d$export$2d1720544b23b823(parent, key) : undefined;
function $9bad38c73ebb867d$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $9bad38c73ebb867d$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $9bad38c73ebb867d$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $9bad38c73ebb867d$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $9bad38c73ebb867d$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $9bad38c73ebb867d$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== "undefined" && fallback !== prop) {
        key = $9bad38c73ebb867d$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $9bad38c73ebb867d$export$a9c996f45e5784d0(Array.from(set), [
        ""
    ], rootScopes, fallback, ()=>$9bad38c73ebb867d$var$subGetTarget(resolver, prop, value));
}
function $9bad38c73ebb867d$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $9bad38c73ebb867d$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $9bad38c73ebb867d$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($9bad38c73ebb867d$export$8b22cf2602fb60ce(target) && $9bad38c73ebb867d$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $9bad38c73ebb867d$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $9bad38c73ebb867d$var$_resolve($9bad38c73ebb867d$var$readKey(prefix, prop), scopes);
        if (typeof value !== "undefined") return $9bad38c73ebb867d$var$needsSubResolver(prop, value) ? $9bad38c73ebb867d$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $9bad38c73ebb867d$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== "undefined") return value;
    }
}
function $9bad38c73ebb867d$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $9bad38c73ebb867d$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $9bad38c73ebb867d$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith("_")))set.add(key);
    return Array.from(set);
}
function $9bad38c73ebb867d$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale  } = meta;
    const { key: key = "r"  } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($9bad38c73ebb867d$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $9bad38c73ebb867d$var$EPSILON = Number.EPSILON || 1e-14;
const $9bad38c73ebb867d$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $9bad38c73ebb867d$var$getValueAxis = (indexAxis)=>indexAxis === "x" ? "y" : "x";
function $9bad38c73ebb867d$export$e171bab687b50e0(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $9bad38c73ebb867d$export$158acd800e1ef08b(current, previous);
    const d12 = $9bad38c73ebb867d$export$158acd800e1ef08b(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $9bad38c73ebb867d$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $9bad38c73ebb867d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $9bad38c73ebb867d$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($9bad38c73ebb867d$export$a05254e7c3aeba6e(deltaK[i], 0, $9bad38c73ebb867d$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $9bad38c73ebb867d$var$monotoneCompute(points, mK, indexAxis = "x") {
    const valueAxis = $9bad38c73ebb867d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $9bad38c73ebb867d$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $9bad38c73ebb867d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $9bad38c73ebb867d$export$527e9aa3390079e9(points, indexAxis = "x") {
    const valueAxis = $9bad38c73ebb867d$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $9bad38c73ebb867d$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $9bad38c73ebb867d$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $9bad38c73ebb867d$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $9bad38c73ebb867d$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $9bad38c73ebb867d$var$monotoneAdjust(points, deltaK, mK);
    $9bad38c73ebb867d$var$monotoneCompute(points, mK, indexAxis);
}
function $9bad38c73ebb867d$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $9bad38c73ebb867d$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $9bad38c73ebb867d$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $9bad38c73ebb867d$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $9bad38c73ebb867d$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $9bad38c73ebb867d$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $9bad38c73ebb867d$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $9bad38c73ebb867d$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$ab83b03e4111b1d0(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === "monotone") $9bad38c73ebb867d$export$527e9aa3390079e9(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $9bad38c73ebb867d$export$e171bab687b50e0(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $9bad38c73ebb867d$var$capBezierPoints(points, area);
}
/**
 * Note: typedefs are auto-exported, so use a made-up `dom` namespace where
 * necessary to avoid duplicates with `export * from './helpers`; see
 * https://github.com/microsoft/TypeScript/issues/46011
 * @typedef { import('../core/core.controller.js').default } dom.Chart
 * @typedef { import('../../types').ChartEvent } ChartEvent
 */ /**
 * @private
 */ function $9bad38c73ebb867d$export$3a1a48c8f6ef640e() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === "[object ShadowRoot]") parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $9bad38c73ebb867d$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === "string") {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf("%") !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $9bad38c73ebb867d$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $9bad38c73ebb867d$export$a17c37559e1db147(el, property) {
    return $9bad38c73ebb867d$var$getComputedStyle(el).getPropertyValue(property);
}
const $9bad38c73ebb867d$var$positions = [
    "top",
    "right",
    "bottom",
    "left"
];
function $9bad38c73ebb867d$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? "-" + suffix : "";
    for(let i = 0; i < 4; i++){
        const pos = $9bad38c73ebb867d$var$positions[i];
        result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $9bad38c73ebb867d$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $9bad38c73ebb867d$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX , offsetY: offsetY  } = source;
    let box = false;
    let x, y;
    if ($9bad38c73ebb867d$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $9bad38c73ebb867d$export$df995fae86a55f06(event, chart) {
    if ("native" in event) return event;
    const { canvas: canvas , currentDevicePixelRatio: currentDevicePixelRatio  } = chart;
    const style = $9bad38c73ebb867d$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === "border-box";
    const paddings = $9bad38c73ebb867d$var$getPositionedStyle(style, "padding");
    const borders = $9bad38c73ebb867d$var$getPositionedStyle(style, "border", "width");
    const { x: x , y: y , box: box  } = $9bad38c73ebb867d$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width , height: height  } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $9bad38c73ebb867d$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = $9bad38c73ebb867d$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $9bad38c73ebb867d$var$getComputedStyle(container);
            const containerBorder = $9bad38c73ebb867d$var$getPositionedStyle(containerStyle, "border", "width");
            const containerPadding = $9bad38c73ebb867d$var$getPositionedStyle(containerStyle, "padding");
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $9bad38c73ebb867d$var$parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
            maxHeight = $9bad38c73ebb867d$var$parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $9bad38c73ebb867d$export$2ec5befb9e6c97d4,
        maxHeight: maxHeight || $9bad38c73ebb867d$export$2ec5befb9e6c97d4
    };
}
const $9bad38c73ebb867d$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $9bad38c73ebb867d$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $9bad38c73ebb867d$var$getComputedStyle(canvas);
    const margins = $9bad38c73ebb867d$var$getPositionedStyle(style, "margin");
    const maxWidth = $9bad38c73ebb867d$var$parseMaxStyle(style.maxWidth, canvas, "clientWidth") || $9bad38c73ebb867d$export$2ec5befb9e6c97d4;
    const maxHeight = $9bad38c73ebb867d$var$parseMaxStyle(style.maxHeight, canvas, "clientHeight") || $9bad38c73ebb867d$export$2ec5befb9e6c97d4;
    const containerSize = $9bad38c73ebb867d$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width , height: height  } = containerSize;
    if (style.boxSizing === "content-box") {
        const borders = $9bad38c73ebb867d$var$getPositionedStyle(style, "border", "width");
        const paddings = $9bad38c73ebb867d$var$getPositionedStyle(style, "padding");
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $9bad38c73ebb867d$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $9bad38c73ebb867d$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $9bad38c73ebb867d$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $9bad38c73ebb867d$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $9bad38c73ebb867d$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = Math.floor(chart.height * pixelRatio);
    const deviceWidth = Math.floor(chart.width * pixelRatio);
    chart.height = Math.floor(chart.height);
    chart.width = Math.floor(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $9bad38c73ebb867d$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        window.addEventListener("test", null, options);
        window.removeEventListener("test", null, options);
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $9bad38c73ebb867d$export$b4171a6734a65d42(element, property) {
    const value = $9bad38c73ebb867d$export$a17c37559e1db147(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$7a38258bbe170828(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $9bad38c73ebb867d$export$2f6ca3d3b1f80bf5(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $9bad38c73ebb867d$export$8a5498727ef6be21(p1, cp1, t);
    const b = $9bad38c73ebb867d$export$8a5498727ef6be21(cp1, cp2, t);
    const c = $9bad38c73ebb867d$export$8a5498727ef6be21(cp2, p2, t);
    const d = $9bad38c73ebb867d$export$8a5498727ef6be21(a, b, t);
    const e = $9bad38c73ebb867d$export$8a5498727ef6be21(b, c, t);
    return $9bad38c73ebb867d$export$8a5498727ef6be21(d, e, t);
}
const $9bad38c73ebb867d$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === "center") return align;
            return align === "right" ? "left" : "right";
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $9bad38c73ebb867d$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $9bad38c73ebb867d$export$3d12bd131bb975d1(rtl, rectX, width) {
    return rtl ? $9bad38c73ebb867d$var$getRightToLeftAdapter(rectX, width) : $9bad38c73ebb867d$var$getLeftToRightAdapter();
}
function $9bad38c73ebb867d$export$91c6e00c14e7e6fd(ctx, direction) {
    let style, original;
    if (direction === "ltr" || direction === "rtl") {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue("direction"),
            style.getPropertyPriority("direction")
        ];
        style.setProperty("direction", direction, "important");
        ctx.prevTextDirection = original;
    }
}
function $9bad38c73ebb867d$export$890c4ad488842ce7(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty("direction", original[0], original[1]);
    }
}
function $9bad38c73ebb867d$var$propertyFn(property) {
    if (property === "angle") return {
        between: $9bad38c73ebb867d$export$ffb5f4729a158638,
        compare: $9bad38c73ebb867d$export$c18d01048907ea92,
        normalize: $9bad38c73ebb867d$export$28f7fcd39efa255
    };
    return {
        between: $9bad38c73ebb867d$export$3b513254972cfc9c,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $9bad38c73ebb867d$var$normalizeSegment({ start: start , end: end , count: count , loop: loop , style: style  }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $9bad38c73ebb867d$var$getSegment(segment, points, bounds) {
    const { property: property , start: startBound , end: endBound  } = bounds;
    const { between: between , normalize: normalize  } = $9bad38c73ebb867d$var$propertyFn(property);
    const count = points.length;
    let { start: start , end: end , loop: loop  } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $9bad38c73ebb867d$export$9fa96a7d116ea3ce(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property , start: startBound , end: endBound  } = bounds;
    const count = points.length;
    const { compare: compare , between: between , normalize: normalize  } = $9bad38c73ebb867d$var$propertyFn(property);
    const { start: start , end: end , loop: loop , style: style  } = $9bad38c73ebb867d$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($9bad38c73ebb867d$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($9bad38c73ebb867d$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $9bad38c73ebb867d$export$306ddfe3a8403e2(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $9bad38c73ebb867d$export$9fa96a7d116ea3ce(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $9bad38c73ebb867d$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $9bad38c73ebb867d$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $9bad38c73ebb867d$export$1a82df3d29112e01(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start , end: end  } = $9bad38c73ebb867d$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $9bad38c73ebb867d$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $9bad38c73ebb867d$var$splitByStyles(line, $9bad38c73ebb867d$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $9bad38c73ebb867d$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $9bad38c73ebb867d$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $9bad38c73ebb867d$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $9bad38c73ebb867d$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex , options: { spanGaps: spanGaps  }  } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $9bad38c73ebb867d$var$readStyle(segmentOptions.setContext($9bad38c73ebb867d$export$35e795649ee09318(chartContext, {
                type: "segment",
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($9bad38c73ebb867d$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $9bad38c73ebb867d$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $9bad38c73ebb867d$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$9bad38c73ebb867d$export$f96d196f7728bb5(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}



class $5297880dd24cc5ea$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $9bad38c73ebb867d$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, "progress");
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, "complete");
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), "complete");
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $5297880dd24cc5ea$export$a424a0aa8f687495 = /* #__PURE__ */ new $5297880dd24cc5ea$var$Animator();
const $5297880dd24cc5ea$var$transparent = "transparent";
const $5297880dd24cc5ea$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $9bad38c73ebb867d$export$db3b6bfb95261072)(from || $5297880dd24cc5ea$var$transparent);
        const c1 = c0.valid && (0, $9bad38c73ebb867d$export$db3b6bfb95261072)(to || $5297880dd24cc5ea$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $5297880dd24cc5ea$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $9bad38c73ebb867d$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $9bad38c73ebb867d$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $5297880dd24cc5ea$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $9bad38c73ebb867d$export$f1e1789686576879)[cfg.easing] || (0, $9bad38c73ebb867d$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $9bad38c73ebb867d$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $9bad38c73ebb867d$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? "res" : "rej";
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $5297880dd24cc5ea$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $9bad38c73ebb867d$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $5297880dd24cc5ea$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $5297880dd24cc5ea$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === "$") continue;
            if (prop === "options") {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $5297880dd24cc5ea$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $5297880dd24cc5ea$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $5297880dd24cc5ea$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $5297880dd24cc5ea$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $5297880dd24cc5ea$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $5297880dd24cc5ea$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $5297880dd24cc5ea$var$scaleClip(xScale, allowedOverflow);
    const y = $5297880dd24cc5ea$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $5297880dd24cc5ea$var$toClip(value) {
    let t, r, b, l;
    if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $5297880dd24cc5ea$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $5297880dd24cc5ea$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === "single";
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $9bad38c73ebb867d$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(value) === (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    return value;
}
function $5297880dd24cc5ea$var$convertObjectDataToArray(data) {
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            x: key,
            y: data[key]
        };
    }
    return adata;
}
function $5297880dd24cc5ea$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $5297880dd24cc5ea$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $5297880dd24cc5ea$var$getUserBounds(scale) {
    const { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $5297880dd24cc5ea$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $5297880dd24cc5ea$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $5297880dd24cc5ea$var$updateStacks(controller, parsed) {
    const { chart: chart , _cachedMeta: meta  } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale , vScale: vScale , index: datasetIndex  } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $5297880dd24cc5ea$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index , [vAxis]: value  } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $5297880dd24cc5ea$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $5297880dd24cc5ea$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $5297880dd24cc5ea$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $5297880dd24cc5ea$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $5297880dd24cc5ea$var$createDatasetContext(parent, index) {
    return (0, $9bad38c73ebb867d$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: "default",
        type: "dataset"
    });
}
function $5297880dd24cc5ea$var$createDataContext(parent, index, element) {
    return (0, $9bad38c73ebb867d$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: "default",
        type: "data"
    });
}
function $5297880dd24cc5ea$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $5297880dd24cc5ea$var$isDirectUpdateMode = (mode)=>mode === "reset" || mode === "none";
const $5297880dd24cc5ea$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $5297880dd24cc5ea$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $5297880dd24cc5ea$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $5297880dd24cc5ea$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled("filler")) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $5297880dd24cc5ea$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === "x" ? x : axis === "r" ? r : y;
        const xid = meta.xAxisID = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(dataset.xAxisID, $5297880dd24cc5ea$var$getFirstScaleId(chart, "x"));
        const yid = meta.yAxisID = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(dataset.yAxisID, $5297880dd24cc5ea$var$getFirstScaleId(chart, "y"));
        const rid = meta.rAxisID = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(dataset.rAxisID, $5297880dd24cc5ea$var$getFirstScaleId(chart, "r"));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update("reset");
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $9bad38c73ebb867d$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $5297880dd24cc5ea$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(data)) this._data = $5297880dd24cc5ea$var$convertObjectDataToArray(data);
        else if (_data !== data) {
            if (_data) {
                (0, $9bad38c73ebb867d$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $5297880dd24cc5ea$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $9bad38c73ebb867d$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $5297880dd24cc5ea$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $5297880dd24cc5ea$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) $5297880dd24cc5ea$var$updateStacks(this, meta._parsed);
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta , _data: data  } = this;
        const { iScale: iScale , _stacked: _stacked  } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $5297880dd24cc5ea$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale , vScale: vScale  } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale , yScale: yScale  } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale , yScale: yScale  } = meta;
        const { xAxisKey: xAxisKey = "x" , yAxisKey: yAxisKey = "y"  } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $9bad38c73ebb867d$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $9bad38c73ebb867d$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $5297880dd24cc5ea$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $5297880dd24cc5ea$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $5297880dd24cc5ea$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $5297880dd24cc5ea$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin , max: otherMax  } = $5297880dd24cc5ea$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $9bad38c73ebb867d$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $9bad38c73ebb867d$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
            value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || "default");
        meta._clip = $5297880dd24cc5ea$var$toClip((0, $9bad38c73ebb867d$export$90a7f3efeed30595)(this.options.clip, $5297880dd24cc5ea$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? "active" : "default";
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $5297880dd24cc5ea$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $5297880dd24cc5ea$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = "default", index) {
        const active = mode === "active";
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + "-" + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $9bad38c73ebb867d$export$dda1d9f60106f0e9)(index);
        if (cached) return $5297880dd24cc5ea$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            "hover",
            elementType,
            ""
        ] : [
            elementType,
            ""
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $9bad38c73ebb867d$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($5297880dd24cc5ea$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $5297880dd24cc5ea$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $5297880dd24cc5ea$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($5297880dd24cc5ea$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$5297880dd24cc5ea$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, "active", true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, "active", true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, "reset");
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $5297880dd24cc5ea$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            "_insertElements",
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            "_removeElements",
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            "_removeElements",
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            "_removeElements",
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            "_insertElements",
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            "_insertElements",
            0,
            arguments.length
        ]);
    }
}
function $5297880dd24cc5ea$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $9bad38c73ebb867d$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $5297880dd24cc5ea$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $5297880dd24cc5ea$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $9bad38c73ebb867d$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $5297880dd24cc5ea$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $5297880dd24cc5ea$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $5297880dd24cc5ea$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $5297880dd24cc5ea$var$parseValue(entry, item, vScale, i) {
    if ((0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(entry)) $5297880dd24cc5ea$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $5297880dd24cc5ea$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($5297880dd24cc5ea$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $5297880dd24cc5ea$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $5297880dd24cc5ea$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $5297880dd24cc5ea$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = "left";
        end = "right";
    } else {
        reverse = properties.base < properties.y;
        start = "bottom";
        end = "top";
    }
    if (reverse) {
        top = "end";
        bottom = "start";
    } else {
        top = "start";
        bottom = "end";
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $5297880dd24cc5ea$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start , end: end , reverse: reverse , top: top , bottom: bottom  } = $5297880dd24cc5ea$var$borderProps(properties);
    if (edge === "middle" && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$5297880dd24cc5ea$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$5297880dd24cc5ea$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $5297880dd24cc5ea$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $5297880dd24cc5ea$var$swap(edge, a, b);
        edge = $5297880dd24cc5ea$var$startEnd(edge, b, a);
    } else edge = $5297880dd24cc5ea$var$startEnd(edge, a, b);
    return edge;
}
function $5297880dd24cc5ea$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $5297880dd24cc5ea$var$startEnd(v, start, end) {
    return v === "start" ? start : v === "end" ? end : v;
}
function $5297880dd24cc5ea$var$setInflateAmount(properties, { inflateAmount: inflateAmount  }, ratio) {
    properties.inflateAmount = inflateAmount === "auto" ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $5297880dd24cc5ea$export$e97d5dc64e999004 extends $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static id = "bar";
    static defaults = {
        datasetElementType: false,
        dataElementType: "bar",
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "base",
                    "width",
                    "height"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category",
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: "linear",
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $5297880dd24cc5ea$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $5297880dd24cc5ea$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale , vScale: vScale  } = meta;
        const { xAxisKey: xAxisKey = "x" , yAxisKey: yAxisKey = "y"  } = this._parsing;
        const iAxisKey = iScale.axis === "x" ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === "x" ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $9bad38c73ebb867d$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($5297880dd24cc5ea$var$parseValue((0, $9bad38c73ebb867d$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale , vScale: vScale  } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $5297880dd24cc5ea$var$isFloatBar(custom) ? "[" + custom.start + ", " + custom.end + "]" : "" + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: "" + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === "reset";
        const { index: index , _cachedMeta: { vScale: vScale  }  } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions , includeOptions: includeOptions  } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $9bad38c73ebb867d$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $5297880dd24cc5ea$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? "active" : mode);
            const options = properties.options || bars[i].options;
            $5297880dd24cc5ea$var$setBorderSkipped(properties, options, stack, index);
            $5297880dd24cc5ea$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale  } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const skipNull = (meta)=>{
            const parsed = meta.controller.getParsed(dataIndex);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $5297880dd24cc5ea$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale , _stacked: _stacked , index: datasetIndex  } , options: { base: baseValue , minBarLength: minBarLength  }  } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $5297880dd24cc5ea$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(value) !== (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $5297880dd24cc5ea$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === "flex" ? $5297880dd24cc5ea$var$computeFlexCategoryTraits(index, ruler, options, stackCount) : $5297880dd24cc5ea$var$computeFitCategoryTraits(index, ruler, options, stackCount);
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined);
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null) rects[i].draw(this._ctx);
    }
}
class $5297880dd24cc5ea$export$19b5c4773f17abe extends $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static id = "bubble";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "borderWidth",
                    "radius"
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale , yScale: yScale  } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + (r ? ", " + r : "") + ")"
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale , vScale: vScale  } = this._cachedMeta;
        const { sharedOptions: sharedOptions , includeOptions: includeOptions  } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== "active") values.radius = 0;
        values.radius += (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $5297880dd24cc5ea$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $9bad38c73ebb867d$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $9bad38c73ebb867d$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $9bad38c73ebb867d$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $9bad38c73ebb867d$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $9bad38c73ebb867d$export$56c0d5a1e737357d) + (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $5297880dd24cc5ea$export$e04603e7d8b77172 extends $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static id = "doughnut";
    static defaults = {
        datasetElementType: false,
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "circumference",
                    "endAngle",
                    "innerRadius",
                    "outerRadius",
                    "startAngle",
                    "x",
                    "y",
                    "offset",
                    "borderWidth",
                    "spacing"
                ]
            }
        },
        cutout: "50%",
        rotation: 0,
        circumference: 360,
        radius: "100%",
        spacing: 0,
        indexAxis: "r"
    };
    static descriptors = {
        _scriptable: (name)=>name !== "spacing",
        _indexable: (name)=>name !== "spacing" && !name.startsWith("borderDash") && !name.startsWith("hoverBorderDash")
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle , color: color  }  } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = "value"  } = this._parsing;
                getter = (i)=>+(0, $9bad38c73ebb867d$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $9bad38c73ebb867d$export$971d5caa766a69d7);
        let max = -(0, $9bad38c73ebb867d$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea  } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $9bad38c73ebb867d$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference , rotation: rotation  } = this._getRotationExtents();
        const { ratioX: ratioX , ratioY: ratioY , offsetX: offsetX , offsetY: offsetY  } = $5297880dd24cc5ea$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $9bad38c73ebb867d$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $9bad38c73ebb867d$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions , includeOptions: includeOptions  } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? "active" : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $9bad38c73ebb867d$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $9bad38c73ebb867d$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== "inner") max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $9bad38c73ebb867d$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $5297880dd24cc5ea$export$3c9b5d28c11cbfd0 extends $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static id = "line";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: "category"
            },
            _value_: {
                type: "linear"
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line , data: points = [] , _dataset: _dataset  } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start , count: count  } = (0, $9bad38c73ebb867d$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $9bad38c73ebb867d$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale , vScale: vScale , _stacked: _stacked , _dataset: _dataset  } = this._cachedMeta;
        const { sharedOptions: sharedOptions , includeOptions: includeOptions  } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps , segment: segment  } = this.options;
        const maxGapLength = (0, $9bad38c73ebb867d$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $9bad38c73ebb867d$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $5297880dd24cc5ea$export$2a270b3a0d973c85 extends $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static id = "polarArea";
    static defaults = {
        dataElementType: "arc",
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "startAngle",
                    "endAngle",
                    "innerRadius",
                    "outerRadius"
                ]
            }
        },
        indexAxis: "r",
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle , color: color  }  } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: "radialLinear",
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $9bad38c73ebb867d$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || "",
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $9bad38c73ebb867d$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === "reset";
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $9bad38c73ebb867d$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? "active" : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $5297880dd24cc5ea$export$b21a3f1286706191 extends $5297880dd24cc5ea$export$e04603e7d8b77172 {
    static id = "pie";
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: "100%"
    };
}
class $5297880dd24cc5ea$export$48dbc6ac651bf8be extends $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static id = "radar";
    static defaults = {
        datasetElementType: "line",
        dataElementType: "point",
        indexAxis: "r",
        showLine: true,
        elements: {
            line: {
                fill: "start"
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: "radialLinear"
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: "" + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $9bad38c73ebb867d$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== "resize") {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === "reset";
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? "active" : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $5297880dd24cc5ea$export$b2f2bae6713db87 extends $5297880dd24cc5ea$export$75572ec5c55b4048 {
    static id = "scatter";
    static defaults = {
        datasetElementType: false,
        dataElementType: "point",
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: "point"
        },
        scales: {
            x: {
                type: "linear"
            },
            y: {
                type: "linear"
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale , yScale: yScale  } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || "",
            value: "(" + x + ", " + y + ")"
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = []  } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start , count: count  } = (0, $9bad38c73ebb867d$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $9bad38c73ebb867d$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            const { dataset: line , _dataset: _dataset  } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine  } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement("line");
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === "reset";
        const { iScale: iScale , vScale: vScale , _stacked: _stacked , _dataset: _dataset  } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps , segment: segment  } = this.options;
        const maxGapLength = (0, $9bad38c73ebb867d$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $9bad38c73ebb867d$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $5297880dd24cc5ea$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $5297880dd24cc5ea$export$e97d5dc64e999004,
    BubbleController: $5297880dd24cc5ea$export$19b5c4773f17abe,
    DoughnutController: $5297880dd24cc5ea$export$e04603e7d8b77172,
    LineController: $5297880dd24cc5ea$export$3c9b5d28c11cbfd0,
    PieController: $5297880dd24cc5ea$export$b21a3f1286706191,
    PolarAreaController: $5297880dd24cc5ea$export$2a270b3a0d973c85,
    RadarController: $5297880dd24cc5ea$export$48dbc6ac651bf8be,
    ScatterController: $5297880dd24cc5ea$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $5297880dd24cc5ea$var$abstract() {
    throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $5297880dd24cc5ea$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($5297880dd24cc5ea$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $5297880dd24cc5ea$var$abstract();
    }
    parse() {
        return $5297880dd24cc5ea$var$abstract();
    }
    format() {
        return $5297880dd24cc5ea$var$abstract();
    }
    add() {
        return $5297880dd24cc5ea$var$abstract();
    }
    diff() {
        return $5297880dd24cc5ea$var$abstract();
    }
    startOf() {
        return $5297880dd24cc5ea$var$abstract();
    }
    endOf() {
        return $5297880dd24cc5ea$var$abstract();
    }
}
var $5297880dd24cc5ea$export$f32766ea09ec8bc4 = {
    _date: $5297880dd24cc5ea$var$DateAdapterBase
};
function $5297880dd24cc5ea$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller , data: data , _sorted: _sorted  } = metaset;
    const iScale = controller._cachedMeta.iScale;
    if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $9bad38c73ebb867d$export$ebd11618f299a286) : (0, $9bad38c73ebb867d$export$ef35774e6d314e91);
        if (!intersect) return lookupMethod(data, axis, value);
        else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === "function" && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $5297880dd24cc5ea$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index , data: data  } = metasets[i];
        const { lo: lo , hi: hi  } = $5297880dd24cc5ea$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $5297880dd24cc5ea$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf("x") !== -1;
    const useY = axis.indexOf("y") !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $5297880dd24cc5ea$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $9bad38c73ebb867d$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $5297880dd24cc5ea$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $5297880dd24cc5ea$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle , endAngle: endAngle  } = element.getProps([
            "startAngle",
            "endAngle"
        ], useFinalPosition);
        const { angle: angle  } = (0, $9bad38c73ebb867d$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $9bad38c73ebb867d$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $5297880dd24cc5ea$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $5297880dd24cc5ea$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $5297880dd24cc5ea$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $5297880dd24cc5ea$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $5297880dd24cc5ea$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === "r" && !intersect ? $5297880dd24cc5ea$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $5297880dd24cc5ea$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $5297880dd24cc5ea$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
    let intersectsItem = false;
    $5297880dd24cc5ea$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $5297880dd24cc5ea$export$a13296960cae0384 = {
    evaluateInteractionItems: $5297880dd24cc5ea$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $9bad38c73ebb867d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "x";
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $5297880dd24cc5ea$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $5297880dd24cc5ea$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $9bad38c73ebb867d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $5297880dd24cc5ea$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $5297880dd24cc5ea$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $9bad38c73ebb867d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $5297880dd24cc5ea$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $9bad38c73ebb867d$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || "xy";
            const includeInvisible = options.includeInvisible || false;
            return $5297880dd24cc5ea$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $9bad38c73ebb867d$export$df995fae86a55f06)(e, chart);
            return $5297880dd24cc5ea$var$getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $9bad38c73ebb867d$export$df995fae86a55f06)(e, chart);
            return $5297880dd24cc5ea$var$getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
        }
    }
};
const $5297880dd24cc5ea$var$STATIC_POSITIONS = [
    "left",
    "top",
    "right",
    "bottom"
];
function $5297880dd24cc5ea$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $5297880dd24cc5ea$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$5297880dd24cc5ea$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $5297880dd24cc5ea$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $5297880dd24cc5ea$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos , options: { stack: stack , stackWeight: stackWeight = 1  }  } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $5297880dd24cc5ea$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack , pos: pos , stackWeight: stackWeight  } = wrap;
        if (!stack || !$5297880dd24cc5ea$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $5297880dd24cc5ea$var$setLayoutDims(layouts, params) {
    const stacks = $5297880dd24cc5ea$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth , hBoxMaxHeight: hBoxMaxHeight  } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize  } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $5297880dd24cc5ea$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $5297880dd24cc5ea$var$wrapBoxes(boxes);
    const fullSize = $5297880dd24cc5ea$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $5297880dd24cc5ea$var$sortByWeight($5297880dd24cc5ea$var$filterByPosition(layoutBoxes, "left"), true);
    const right = $5297880dd24cc5ea$var$sortByWeight($5297880dd24cc5ea$var$filterByPosition(layoutBoxes, "right"));
    const top = $5297880dd24cc5ea$var$sortByWeight($5297880dd24cc5ea$var$filterByPosition(layoutBoxes, "top"), true);
    const bottom = $5297880dd24cc5ea$var$sortByWeight($5297880dd24cc5ea$var$filterByPosition(layoutBoxes, "bottom"));
    const centerHorizontal = $5297880dd24cc5ea$var$filterDynamicPositionByAxis(layoutBoxes, "x");
    const centerVertical = $5297880dd24cc5ea$var$filterDynamicPositionByAxis(layoutBoxes, "y");
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $5297880dd24cc5ea$var$filterByPosition(layoutBoxes, "chartArea"),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $5297880dd24cc5ea$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $5297880dd24cc5ea$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $5297880dd24cc5ea$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos , box: box  } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $5297880dd24cc5ea$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $5297880dd24cc5ea$var$getCombinedMax(maxPadding, chartArea, "left", "right"));
    const newHeight = Math.max(0, params.outerHeight - $5297880dd24cc5ea$var$getCombinedMax(maxPadding, chartArea, "top", "bottom"));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $5297880dd24cc5ea$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos("top");
    chartArea.x += updatePos("left");
    updatePos("right");
    updatePos("bottom");
}
function $5297880dd24cc5ea$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        "left",
        "right"
    ]) : marginForPositions([
        "top",
        "bottom"
    ]);
}
function $5297880dd24cc5ea$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $5297880dd24cc5ea$var$getMargins(layout.horizontal, chartArea));
        const { same: same , other: other  } = $5297880dd24cc5ea$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $5297880dd24cc5ea$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $5297880dd24cc5ea$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $5297880dd24cc5ea$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x , y: y  } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $9bad38c73ebb867d$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $5297880dd24cc5ea$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $5297880dd24cc5ea$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $9bad38c73ebb867d$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $5297880dd24cc5ea$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $5297880dd24cc5ea$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $5297880dd24cc5ea$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || "top";
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $5297880dd24cc5ea$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $9bad38c73ebb867d$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === "function") box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $5297880dd24cc5ea$var$updateMaxPadding(maxPadding, (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $5297880dd24cc5ea$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $5297880dd24cc5ea$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $5297880dd24cc5ea$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($5297880dd24cc5ea$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $5297880dd24cc5ea$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $5297880dd24cc5ea$var$handleMaxPadding(chartArea);
        $5297880dd24cc5ea$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $5297880dd24cc5ea$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $9bad38c73ebb867d$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $5297880dd24cc5ea$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $5297880dd24cc5ea$export$a40a96b24b46cf35 extends $5297880dd24cc5ea$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext("2d") || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $5297880dd24cc5ea$var$EXPANDO_KEY = "$chartjs";
const $5297880dd24cc5ea$var$EVENT_TYPES = {
    touchstart: "mousedown",
    touchmove: "mousemove",
    touchend: "mouseup",
    pointerenter: "mouseenter",
    pointerdown: "mousedown",
    pointermove: "mousemove",
    pointerup: "mouseup",
    pointerleave: "mouseout",
    pointerout: "mouseout"
};
const $5297880dd24cc5ea$var$isNullOrEmpty = (value)=>value === null || value === "";
function $5297880dd24cc5ea$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute("height");
    const renderWidth = canvas.getAttribute("width");
    canvas[$5297880dd24cc5ea$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || "block";
    style.boxSizing = style.boxSizing || "border-box";
    if ($5297880dd24cc5ea$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $9bad38c73ebb867d$export$b4171a6734a65d42)(canvas, "width");
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($5297880dd24cc5ea$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === "") canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $9bad38c73ebb867d$export$b4171a6734a65d42)(canvas, "height");
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $5297880dd24cc5ea$var$eventListenerOptions = (0, $9bad38c73ebb867d$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $5297880dd24cc5ea$var$addListener(node, type, listener) {
    node.addEventListener(type, listener, $5297880dd24cc5ea$var$eventListenerOptions);
}
function $5297880dd24cc5ea$var$removeListener(chart, type, listener) {
    chart.canvas.removeEventListener(type, listener, $5297880dd24cc5ea$var$eventListenerOptions);
}
function $5297880dd24cc5ea$var$fromNativeEvent(event, chart) {
    const type = $5297880dd24cc5ea$var$EVENT_TYPES[event.type] || event.type;
    const { x: x , y: y  } = (0, $9bad38c73ebb867d$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $5297880dd24cc5ea$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $5297880dd24cc5ea$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $5297880dd24cc5ea$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$5297880dd24cc5ea$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $5297880dd24cc5ea$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $5297880dd24cc5ea$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$5297880dd24cc5ea$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $5297880dd24cc5ea$var$drpListeningCharts = new Map();
let $5297880dd24cc5ea$var$oldDevicePixelRatio = 0;
function $5297880dd24cc5ea$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $5297880dd24cc5ea$var$oldDevicePixelRatio) return;
    $5297880dd24cc5ea$var$oldDevicePixelRatio = dpr;
    $5297880dd24cc5ea$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $5297880dd24cc5ea$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$5297880dd24cc5ea$var$drpListeningCharts.size) window.addEventListener("resize", $5297880dd24cc5ea$var$onWindowResize);
    $5297880dd24cc5ea$var$drpListeningCharts.set(chart, resize);
}
function $5297880dd24cc5ea$var$unlistenDevicePixelRatioChanges(chart) {
    $5297880dd24cc5ea$var$drpListeningCharts.delete(chart);
    if (!$5297880dd24cc5ea$var$drpListeningCharts.size) window.removeEventListener("resize", $5297880dd24cc5ea$var$onWindowResize);
}
function $5297880dd24cc5ea$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $9bad38c73ebb867d$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $9bad38c73ebb867d$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $5297880dd24cc5ea$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $5297880dd24cc5ea$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === "resize") $5297880dd24cc5ea$var$unlistenDevicePixelRatioChanges(chart);
}
function $5297880dd24cc5ea$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $9bad38c73ebb867d$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($5297880dd24cc5ea$var$fromNativeEvent(event, chart));
    }, chart);
    $5297880dd24cc5ea$var$addListener(canvas, type, proxy);
    return proxy;
}
class $5297880dd24cc5ea$export$f02da7f882cf6b2e extends $5297880dd24cc5ea$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext("2d");
        if (context && context.canvas === canvas) {
            $5297880dd24cc5ea$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$5297880dd24cc5ea$var$EXPANDO_KEY]) return false;
        const initial = canvas[$5297880dd24cc5ea$var$EXPANDO_KEY].initial;
        [
            "height",
            "width"
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$5297880dd24cc5ea$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $5297880dd24cc5ea$var$createAttachObserver,
            detach: $5297880dd24cc5ea$var$createDetachObserver,
            resize: $5297880dd24cc5ea$var$createResizeObserver
        };
        const handler = handlers[type] || $5297880dd24cc5ea$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $5297880dd24cc5ea$var$releaseObserver,
            detach: $5297880dd24cc5ea$var$releaseObserver,
            resize: $5297880dd24cc5ea$var$releaseObserver
        };
        const handler = handlers[type] || $5297880dd24cc5ea$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $9bad38c73ebb867d$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = (0, $9bad38c73ebb867d$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $5297880dd24cc5ea$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $9bad38c73ebb867d$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) return $5297880dd24cc5ea$export$a40a96b24b46cf35;
    return $5297880dd24cc5ea$export$f02da7f882cf6b2e;
}
class $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x , y: y  } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $9bad38c73ebb867d$export$d141bba7fdc215a3)(this.x) && (0, $9bad38c73ebb867d$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $5297880dd24cc5ea$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $5297880dd24cc5ea$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $5297880dd24cc5ea$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $5297880dd24cc5ea$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $5297880dd24cc5ea$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $5297880dd24cc5ea$var$skip(ticks, newTicks, spacing, (0, $9bad38c73ebb867d$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$5297880dd24cc5ea$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $5297880dd24cc5ea$var$skip(ticks, newTicks, spacing, last, (0, $9bad38c73ebb867d$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $5297880dd24cc5ea$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $5297880dd24cc5ea$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $5297880dd24cc5ea$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $5297880dd24cc5ea$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $9bad38c73ebb867d$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $5297880dd24cc5ea$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $5297880dd24cc5ea$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $5297880dd24cc5ea$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $9bad38c73ebb867d$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $5297880dd24cc5ea$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $5297880dd24cc5ea$var$reverseAlign = (align)=>align === "left" ? "right" : align === "right" ? "left" : align;
const $5297880dd24cc5ea$var$offsetFromEdge = (scale, edge, offset)=>edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
const $5297880dd24cc5ea$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $5297880dd24cc5ea$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $5297880dd24cc5ea$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $5297880dd24cc5ea$var$garbageCollect(caches, length) {
    (0, $9bad38c73ebb867d$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $5297880dd24cc5ea$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $5297880dd24cc5ea$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $5297880dd24cc5ea$var$createScaleContext(parent, scale) {
    return (0, $9bad38c73ebb867d$export$35e795649ee09318)(parent, {
        scale: scale,
        type: "scale"
    });
}
function $5297880dd24cc5ea$var$createTickContext(parent, index, tick) {
    return (0, $9bad38c73ebb867d$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: "tick"
    });
}
function $5297880dd24cc5ea$var$titleAlign(align, position, reverse) {
    let ret = (0, $9bad38c73ebb867d$export$3c2fa207a37baaea)(align);
    if (reverse && position !== "right" || !reverse && position === "right") ret = $5297880dd24cc5ea$var$reverseAlign(ret);
    return ret;
}
function $5297880dd24cc5ea$var$titleArgs(scale, offset, position, align) {
    const { top: top , left: left , bottom: bottom , right: right , chart: chart  } = scale;
    const { chartArea: chartArea , scales: scales  } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === "center") titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $5297880dd24cc5ea$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === "center") titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $5297880dd24cc5ea$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === "left" ? -(0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd) : (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $5297880dd24cc5ea$export$d60cfc58d3c358b6 extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin , _userMax: _userMax , _suggestedMin: _suggestedMin , _suggestedMax: _suggestedMax  } = this;
        _userMin = (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(min, (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(max, min)),
            max: (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(max, (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero , grace: grace , ticks: tickOpts  } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $9bad38c73ebb867d$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $5297880dd24cc5ea$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
            this.ticks = $5297880dd24cc5ea$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks("beforeDataLimits");
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks("afterDataLimits");
    }
    beforeBuildTicks() {
        this._callHooks("beforeBuildTicks");
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks("afterBuildTicks");
    }
    beforeTickToLabelConversion() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $5297880dd24cc5ea$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $5297880dd24cc5ea$var$getTickMarkLength(options.grid) - tickOpts.padding - $5297880dd24cc5ea$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $9bad38c73ebb867d$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $9bad38c73ebb867d$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $9bad38c73ebb867d$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $9bad38c73ebb867d$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart , options: { ticks: tickOpts , title: titleOpts , grid: gridOpts  }  } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $5297880dd24cc5ea$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $5297880dd24cc5ea$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $5297880dd24cc5ea$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first , last: last , widest: widest , highest: highest  } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align , padding: padding  } , position: position  } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== "top" && this.axis === "x";
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === "start") paddingRight = last.width;
            else if (align === "end") paddingLeft = first.width;
            else if (align !== "inner") {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === "start") {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === "end") {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis , position: position  } = this.options;
        return position === "top" || position === "bottom" || axis === "x";
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $5297880dd24cc5ea$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx , _longestTextCache: caches  } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $5297880dd24cc5ea$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(label) && !(0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(label)) {
                width = (0, $9bad38c73ebb867d$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(nestedLabel) && !(0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $9bad38c73ebb867d$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $5297880dd24cc5ea$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $9bad38c73ebb867d$export$71cec2538cb2c617)(this._alignToPixels ? (0, $9bad38c73ebb867d$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min , max: max  } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $5297880dd24cc5ea$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $5297880dd24cc5ea$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== "auto") return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid , position: position , border: border  } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $5297880dd24cc5ea$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $9bad38c73ebb867d$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === "top") {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === "bottom") {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === "left") {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === "right") {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === "x") {
            if (position === "center") borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === "y") {
            if (position === "center") borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $5297880dd24cc5ea$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $9bad38c73ebb867d$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position , ticks: optionTicks  } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align , crossAlign: crossAlign , padding: padding , mirror: mirror  } = optionTicks;
        const tl = $5297880dd24cc5ea$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = "middle";
        if (position === "top") {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "bottom") {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === "left") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === "right") {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === "x") {
            if (position === "center") y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === "y") {
            if (position === "center") x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === "y") {
            if (align === "start") textBaseline = "top";
            else if (align === "end") textBaseline = "bottom";
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === "inner") {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? "right" : "left";
                    else if (i === 0) tickTextAlign = !this.options.reverse ? "left" : "right";
                    else tickTextAlign = "center";
                }
                if (position === "top") {
                    if (crossAlign === "near" || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === "center") textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === "near" || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === "center") textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case "middle":
                        top -= height / 2;
                        break;
                    case "bottom":
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case "center":
                        left -= width / 2;
                        break;
                    case "right":
                        left -= width;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position , ticks: ticks  } = this.options;
        const rotation = -(0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === "top" ? "left" : "right";
        let align = "center";
        if (ticks.align === "start") align = "left";
        else if (ticks.align === "end") align = "right";
        else if (ticks.align === "inner") align = "inner";
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position , ticks: { crossAlign: crossAlign , mirror: mirror , padding: padding  }  } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === "left") {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x = this.left;
                }
            }
        } else if (position === "right") {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === "near") textAlign = "right";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x -= widest / 2;
                } else {
                    textAlign = "left";
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === "near") textAlign = "left";
                else if (crossAlign === "center") {
                    textAlign = "center";
                    x += widest / 2;
                } else {
                    textAlign = "right";
                    x = this.right;
                }
            }
        } else textAlign = "right";
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === "left" || position === "right") return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === "top" || position === "bottom") return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx , options: { backgroundColor: backgroundColor  } , left: left , top: top , width: width , height: height  } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart , ctx: ctx , options: { border: border , grid: grid  }  } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $9bad38c73ebb867d$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $9bad38c73ebb867d$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $9bad38c73ebb867d$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $9bad38c73ebb867d$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $9bad38c73ebb867d$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $9bad38c73ebb867d$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $9bad38c73ebb867d$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx , options: { position: position , title: title , reverse: reverse  }  } = this;
        if (!title.display) return;
        const font = (0, $9bad38c73ebb867d$export$34aec0b863436764)(title.font);
        const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === "bottom" || position === "center" || (0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX , titleY: titleY , maxWidth: maxWidth , rotation: rotation  } = $5297880dd24cc5ea$var$titleArgs(this, offset, position, align);
        (0, $9bad38c73ebb867d$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $5297880dd24cc5ea$var$titleAlign(align, position, reverse),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $5297880dd24cc5ea$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + "AxisID";
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $9bad38c73ebb867d$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $5297880dd24cc5ea$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($5297880dd24cc5ea$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + "." + id;
        if (!id) throw new Error("class does not have id: " + item);
        if (id in items) return scope;
        items[id] = item;
        $5297880dd24cc5ea$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $9bad38c73ebb867d$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $9bad38c73ebb867d$export$4368d992c4eafac0)[scope]) {
            delete (0, $9bad38c73ebb867d$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $9bad38c73ebb867d$export$6559d589eb85fbb6)[id];
        }
    }
}
function $5297880dd24cc5ea$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $9bad38c73ebb867d$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $9bad38c73ebb867d$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $9bad38c73ebb867d$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $9bad38c73ebb867d$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $5297880dd24cc5ea$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $9bad38c73ebb867d$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $5297880dd24cc5ea$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split(".");
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join(".");
        const parts = routes[property].split(".");
        const targetName = parts.pop();
        const targetScope = parts.join(".");
        (0, $9bad38c73ebb867d$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $5297880dd24cc5ea$var$isIChartComponent(proto) {
    return "id" in proto && "defaults" in proto;
}
class $5297880dd24cc5ea$var$Registry {
    constructor(){
        this.controllers = new $5297880dd24cc5ea$var$TypedRegistry($5297880dd24cc5ea$export$75572ec5c55b4048, "datasets", true);
        this.elements = new $5297880dd24cc5ea$var$TypedRegistry($5297880dd24cc5ea$export$db77ccec0bb4ccac, "elements");
        this.plugins = new $5297880dd24cc5ea$var$TypedRegistry(Object, "plugins");
        this.scales = new $5297880dd24cc5ea$var$TypedRegistry($5297880dd24cc5ea$export$d60cfc58d3c358b6, "scales");
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each("register", args);
    }
    remove(...args) {
        this._each("unregister", args);
    }
    addControllers(...args) {
        this._each("register", args, this.controllers);
    }
    addElements(...args) {
        this._each("register", args, this.elements);
    }
    addPlugins(...args) {
        this._each("register", args, this.plugins);
    }
    addScales(...args) {
        this._each("register", args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, "controller");
    }
    getElement(id) {
        return this._get(id, this.elements, "element");
    }
    getPlugin(id) {
        return this._get(id, this.plugins, "plugin");
    }
    getScale(id) {
        return this._get(id, this.scales, "scale");
    }
    removeControllers(...args) {
        this._each("unregister", args, this.controllers);
    }
    removeElements(...args) {
        this._each("unregister", args, this.elements);
    }
    removePlugins(...args) {
        this._each("unregister", args, this.plugins);
    }
    removeScales(...args) {
        this._each("unregister", args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $9bad38c73ebb867d$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $9bad38c73ebb867d$export$a8550f7dbe79f93a)(method);
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(component["before" + camelMethod], [], component);
        registry[method](component);
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(component["after" + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + ".");
        return item;
    }
}
var $5297880dd24cc5ea$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $5297880dd24cc5ea$var$Registry();
class $5297880dd24cc5ea$var$PluginService {
    constructor(){
        this._init = [];
    }
    notify(chart, hook, args, filter) {
        if (hook === "beforeInit") {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, "install");
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === "afterDestroy") {
            this._notify(descriptors, chart, "stop");
            this._notify(this._init, chart, "uninstall");
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $5297880dd24cc5ea$var$allPlugins(config);
        return options === false && !all ? [] : $5297880dd24cc5ea$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, "stop");
        this._notify(diff(descriptors, previousDescriptors), chart, "start");
    }
}
function $5297880dd24cc5ea$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($5297880dd24cc5ea$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($5297880dd24cc5ea$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $5297880dd24cc5ea$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $5297880dd24cc5ea$var$createDescriptors(chart, { plugins: plugins , localIds: localIds  }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $5297880dd24cc5ea$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $5297880dd24cc5ea$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $5297880dd24cc5ea$var$pluginOpts(config, { plugin: plugin , local: local  }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ""
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $5297880dd24cc5ea$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $9bad38c73ebb867d$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function $5297880dd24cc5ea$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === "_index_") axis = indexAxis;
    else if (id === "_value_") axis = indexAxis === "x" ? "y" : "x";
    return axis;
}
function $5297880dd24cc5ea$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? "_index_" : "_value_";
}
function $5297880dd24cc5ea$var$idMatchesAxis(id) {
    if (id === "x" || id === "y" || id === "r") return id;
}
function $5297880dd24cc5ea$var$axisFromPosition(position) {
    if (position === "top" || position === "bottom") return "x";
    if (position === "left" || position === "right") return "y";
}
function $5297880dd24cc5ea$var$determineAxis(id, ...scaleOptions) {
    if ($5297880dd24cc5ea$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $5297880dd24cc5ea$var$axisFromPosition(opts.position) || id.length > 1 && $5297880dd24cc5ea$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $5297880dd24cc5ea$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + "AxisID"] === id) return {
        axis: axis
    };
}
function $5297880dd24cc5ea$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $5297880dd24cc5ea$var$getAxisFromDataset(id, "x", boundDs[0]) || $5297880dd24cc5ea$var$getAxisFromDataset(id, "y", boundDs[0]);
    }
    return {};
}
function $5297880dd24cc5ea$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $9bad38c73ebb867d$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $5297880dd24cc5ea$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $5297880dd24cc5ea$var$determineAxis(id, scaleConf, $5297880dd24cc5ea$var$retrieveAxisFromDatasets(id, config), (0, $9bad38c73ebb867d$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $5297880dd24cc5ea$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $9bad38c73ebb867d$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $5297880dd24cc5ea$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $9bad38c73ebb867d$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $5297880dd24cc5ea$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + "AxisID"] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $9bad38c73ebb867d$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $9bad38c73ebb867d$export$555508cbc6add439)(scale, [
            (0, $9bad38c73ebb867d$export$4368d992c4eafac0).scales[scale.type],
            (0, $9bad38c73ebb867d$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $5297880dd24cc5ea$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $5297880dd24cc5ea$var$mergeScaleConfig(config, options);
}
function $5297880dd24cc5ea$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $5297880dd24cc5ea$var$initConfig(config) {
    config = config || {};
    config.data = $5297880dd24cc5ea$var$initData(config.data);
    $5297880dd24cc5ea$var$initOptions(config);
    return config;
}
const $5297880dd24cc5ea$var$keyCache = new Map();
const $5297880dd24cc5ea$var$keysCached = new Set();
function $5297880dd24cc5ea$var$cachedKeys(cacheKey, generate) {
    let keys = $5297880dd24cc5ea$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $5297880dd24cc5ea$var$keyCache.set(cacheKey, keys);
        $5297880dd24cc5ea$var$keysCached.add(keys);
    }
    return keys;
}
const $5297880dd24cc5ea$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $9bad38c73ebb867d$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $5297880dd24cc5ea$var$Config {
    constructor(config){
        this._config = $5297880dd24cc5ea$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $5297880dd24cc5ea$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $5297880dd24cc5ea$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $5297880dd24cc5ea$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $5297880dd24cc5ea$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ""
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $5297880dd24cc5ea$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ""
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $5297880dd24cc5ea$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options , type: type  } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$5297880dd24cc5ea$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$5297880dd24cc5ea$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$5297880dd24cc5ea$var$addIfFound(scopes, (0, $9bad38c73ebb867d$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$5297880dd24cc5ea$var$addIfFound(scopes, (0, $9bad38c73ebb867d$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$5297880dd24cc5ea$var$addIfFound(scopes, (0, $9bad38c73ebb867d$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($5297880dd24cc5ea$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options , type: type  } = this;
        return [
            options,
            (0, $9bad38c73ebb867d$export$6559d589eb85fbb6)[type] || {},
            (0, $9bad38c73ebb867d$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $9bad38c73ebb867d$export$4368d992c4eafac0),
            (0, $9bad38c73ebb867d$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ""
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver , subPrefixes: subPrefixes  } = $5297880dd24cc5ea$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($5297880dd24cc5ea$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $9bad38c73ebb867d$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $9bad38c73ebb867d$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ""
    ], descriptorDefaults) {
        const { resolver: resolver  } = $5297880dd24cc5ea$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(context) ? (0, $9bad38c73ebb867d$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $5297880dd24cc5ea$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $9bad38c73ebb867d$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes("hover"))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $5297880dd24cc5ea$var$hasFunction = (value)=>(0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).reduce((acc, key)=>acc || (0, $9bad38c73ebb867d$export$a93c5207d687da10)(value[key]), false);
function $5297880dd24cc5ea$var$needContext(proxy, names) {
    const { isScriptable: isScriptable , isIndexable: isIndexable  } = (0, $9bad38c73ebb867d$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $9bad38c73ebb867d$export$a93c5207d687da10)(value) || $5297880dd24cc5ea$var$hasFunction(value)) || indexable && (0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $5297880dd24cc5ea$var$version = "4.3.0";
const $5297880dd24cc5ea$var$KNOWN_POSITIONS = [
    "top",
    "bottom",
    "left",
    "right",
    "chartArea"
];
function $5297880dd24cc5ea$var$positionIsHorizontal(position, axis) {
    return position === "top" || position === "bottom" || $5297880dd24cc5ea$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function $5297880dd24cc5ea$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $5297880dd24cc5ea$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins("afterRender");
    (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $5297880dd24cc5ea$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $5297880dd24cc5ea$var$getCanvas(item) {
    if ((0, $9bad38c73ebb867d$export$3a1a48c8f6ef640e)() && typeof item === "string") item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $5297880dd24cc5ea$var$instances = {};
const $5297880dd24cc5ea$var$getChart = (key)=>{
    const canvas = $5297880dd24cc5ea$var$getCanvas(key);
    return Object.values($5297880dd24cc5ea$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $5297880dd24cc5ea$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $5297880dd24cc5ea$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === "mouseout") return null;
    if (isClick) return lastEvent;
    return e;
}
function $5297880dd24cc5ea$var$getDatasetArea(meta) {
    const { xScale: xScale , yScale: yScale  } = meta;
    if (xScale && yScale) return {
        left: xScale.left,
        right: xScale.right,
        top: yScale.top,
        bottom: yScale.bottom
    };
}
class $5297880dd24cc5ea$export$acaa6426d77a227e {
    static defaults = (0, $9bad38c73ebb867d$export$4368d992c4eafac0);
    static instances = $5297880dd24cc5ea$var$instances;
    static overrides = (0, $9bad38c73ebb867d$export$6559d589eb85fbb6);
    static registry = $5297880dd24cc5ea$export$4bb7493d241fd8a5;
    static version = $5297880dd24cc5ea$var$version;
    static getChart = $5297880dd24cc5ea$var$getChart;
    static register(...items) {
        $5297880dd24cc5ea$export$4bb7493d241fd8a5.add(...items);
        $5297880dd24cc5ea$var$invalidatePlugins();
    }
    static unregister(...items) {
        $5297880dd24cc5ea$export$4bb7493d241fd8a5.remove(...items);
        $5297880dd24cc5ea$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $5297880dd24cc5ea$var$Config(userConfig);
        const initialCanvas = $5297880dd24cc5ea$var$getCanvas(item);
        const existingChart = $5297880dd24cc5ea$var$getChart(initialCanvas);
        if (existingChart) throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "'" + " must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $5297880dd24cc5ea$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $9bad38c73ebb867d$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $5297880dd24cc5ea$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $9bad38c73ebb867d$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $5297880dd24cc5ea$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $5297880dd24cc5ea$export$a424a0aa8f687495.listen(this, "complete", $5297880dd24cc5ea$var$onAnimationsComplete);
        $5297880dd24cc5ea$export$a424a0aa8f687495.listen(this, "progress", $5297880dd24cc5ea$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio , maintainAspectRatio: maintainAspectRatio  } , width: width , height: height , _aspectRatio: _aspectRatio  } = this;
        if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $5297880dd24cc5ea$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins("beforeInit");
        if (this.options.responsive) this.resize();
        else (0, $9bad38c73ebb867d$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins("afterInit");
        return this;
    }
    clear() {
        (0, $9bad38c73ebb867d$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $5297880dd24cc5ea$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$5297880dd24cc5ea$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? "resize" : "attach";
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $9bad38c73ebb867d$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins("resize", {
            size: newSize
        });
        (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $9bad38c73ebb867d$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $5297880dd24cc5ea$var$determineAxis(id, scaleOptions);
            const isRadial = axis === "r";
            const isHorizontal = axis === "x";
            return {
                options: scaleOptions,
                dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
                dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
            };
        }));
        (0, $9bad38c73ebb867d$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $5297880dd24cc5ea$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $5297880dd24cc5ea$var$positionIsHorizontal(scaleOptions.position, axis) !== $5297880dd24cc5ea$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $5297880dd24cc5ea$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $9bad38c73ebb867d$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $9bad38c73ebb867d$export$d66501df72047452)(scales, (scale)=>{
            $5297880dd24cc5ea$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $5297880dd24cc5ea$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($5297880dd24cc5ea$var$compare2Level("order", "index"));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets , data: { datasets: datasets  }  } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $5297880dd24cc5ea$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = "" + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $5297880dd24cc5ea$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType , dataElementType: dataElementType  } = (0, $9bad38c73ebb867d$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $5297880dd24cc5ea$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $5297880dd24cc5ea$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins("reset");
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins("beforeUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins("beforeElementsUpdate");
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller  } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $9bad38c73ebb867d$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins("afterUpdate", {
            mode: mode
        });
        this._layers.sort($5297880dd24cc5ea$var$compare2Level("z", "_idx"));
        const { _active: _active , _lastEvent: _lastEvent  } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this.scales, (scale)=>{
            $5297880dd24cc5ea$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $9bad38c73ebb867d$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices  } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method , start: start , count: count  } of changes){
            const move = method === "_removeElements" ? -count : count;
            $5297880dd24cc5ea$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + "," + c.splice(1).join(",")));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $9bad38c73ebb867d$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(",")).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins("beforeLayout", {
            cancelable: true
        }) === false) return;
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === "chartArea") return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins("afterLayout");
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins("beforeDatasetsUpdate", {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $9bad38c73ebb867d$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins("afterDatasetsUpdate", {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetUpdate", args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetUpdate", args);
    }
    render() {
        if (this.notifyPlugins("beforeRender", {
            cancelable: true
        }) === false) return;
        if ($5297880dd24cc5ea$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$5297880dd24cc5ea$export$a424a0aa8f687495.running(this)) $5297880dd24cc5ea$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $5297880dd24cc5ea$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width , height: height  } = this._resizeBeforeDraw;
            this._resize(width, height);
            this._resizeBeforeDraw = null;
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins("beforeDraw", {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins("afterDraw");
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins("beforeDatasetsDraw", {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins("afterDatasetsDraw");
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const clip = meta._clip;
        const useClip = !clip.disabled;
        const area = $5297880dd24cc5ea$var$getDatasetArea(meta) || this.chartArea;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        if (this.notifyPlugins("beforeDatasetDraw", args) === false) return;
        if (useClip) (0, $9bad38c73ebb867d$export$8743009a87fcb00f)(ctx, {
            left: clip.left === false ? 0 : area.left - clip.left,
            right: clip.right === false ? this.width : area.right + clip.right,
            top: clip.top === false ? 0 : area.top - clip.top,
            bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
        });
        meta.controller.draw();
        if (useClip) (0, $9bad38c73ebb867d$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins("afterDatasetDraw", args);
    }
    isPointInArea(point) {
        return (0, $9bad38c73ebb867d$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $5297880dd24cc5ea$export$a13296960cae0384.modes[mode];
        if (typeof method === "function") return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $9bad38c73ebb867d$export$35e795649ee09318)(null, {
            chart: this,
            type: "chart"
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? "show" : "hide";
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $9bad38c73ebb867d$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $5297880dd24cc5ea$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins("beforeDestroy");
        const { canvas: canvas , ctx: ctx  } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $9bad38c73ebb867d$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $5297880dd24cc5ea$var$instances[this.id];
        this.notifyPlugins("afterDestroy");
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove("attach", attached);
            this.attached = true;
            this.resize();
            _add("resize", listener);
            _add("detach", detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove("resize", listener);
            this._stop();
            this._resize(0, 0);
            _add("attach", attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? "set" : "remove";
        let meta, item, i, ilen;
        if (mode === "dataset") {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller["_" + prefix + "DatasetHoverStyle"]();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex , index: index  })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("No dataset found at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $9bad38c73ebb867d$export$995eb9fca571757)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins("afterEvent", args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [] , options: options  } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $9bad38c73ebb867d$export$f38c853ae54ed474)(e);
        const lastEvent = $5297880dd24cc5ea$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $9bad38c73ebb867d$export$995eb9fca571757)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $5297880dd24cc5ea$var$invalidatePlugins() {
    return (0, $9bad38c73ebb867d$export$d66501df72047452)($5297880dd24cc5ea$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $5297880dd24cc5ea$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle , pixelMargin: pixelMargin , x: x , y: y , outerRadius: outerRadius , innerRadius: innerRadius  } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd), startAngle - (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $5297880dd24cc5ea$var$toRadiusCorners(value) {
    return (0, $9bad38c73ebb867d$export$21579262ef46735b)(value, [
        "outerStart",
        "outerEnd",
        "innerStart",
        "innerEnd"
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $5297880dd24cc5ea$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $5297880dd24cc5ea$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $5297880dd24cc5ea$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $5297880dd24cc5ea$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x , y: y , startAngle: start , pixelMargin: pixelMargin , innerRadius: innerR  } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $9bad38c73ebb867d$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart , outerEnd: outerEnd , innerStart: innerStart , innerEnd: innerEnd  } = $5297880dd24cc5ea$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $5297880dd24cc5ea$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $5297880dd24cc5ea$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $5297880dd24cc5ea$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $5297880dd24cc5ea$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $5297880dd24cc5ea$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $5297880dd24cc5ea$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $5297880dd24cc5ea$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles , startAngle: startAngle , circumference: circumference  } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $5297880dd24cc5ea$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $9bad38c73ebb867d$export$971d5caa766a69d7) || (0, $9bad38c73ebb867d$export$971d5caa766a69d7));
    }
    $5297880dd24cc5ea$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $5297880dd24cc5ea$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles , startAngle: startAngle , circumference: circumference , options: options  } = element;
    const { borderWidth: borderWidth , borderJoinStyle: borderJoinStyle , borderDash: borderDash , borderDashOffset: borderDashOffset  } = options;
    const inner = options.borderAlign === "inner";
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || "round";
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || "bevel";
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $5297880dd24cc5ea$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $9bad38c73ebb867d$export$971d5caa766a69d7) || (0, $9bad38c73ebb867d$export$971d5caa766a69d7));
    }
    if (inner) $5297880dd24cc5ea$var$clipArc(ctx, element, endAngle);
    if (!fullCircles) {
        $5297880dd24cc5ea$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $5297880dd24cc5ea$export$d48203c759d6a1fc extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    static id = "arc";
    static defaults = {
        borderAlign: "center",
        borderColor: "#fff",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash"
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        const { angle: angle , distance: distance  } = (0, $9bad38c73ebb867d$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle , endAngle: endAngle , innerRadius: innerRadius , outerRadius: outerRadius , circumference: circumference  } = this.getProps([
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius",
            "circumference"
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const betweenAngles = _circumference >= (0, $9bad38c73ebb867d$export$971d5caa766a69d7) || (0, $9bad38c73ebb867d$export$ffb5f4729a158638)(angle, startAngle, endAngle);
        const withinRadius = (0, $9bad38c73ebb867d$export$3b513254972cfc9c)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x , y: y , startAngle: startAngle , endAngle: endAngle , innerRadius: innerRadius , outerRadius: outerRadius  } = this.getProps([
            "x",
            "y",
            "startAngle",
            "endAngle",
            "innerRadius",
            "outerRadius"
        ], useFinalPosition);
        const { offset: offset , spacing: spacing  } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options , circumference: circumference  } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === "inner" ? 0.33 : 0;
        this.fullCircles = circumference > (0, $9bad38c73ebb867d$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $9bad38c73ebb867d$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $9bad38c73ebb867d$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $5297880dd24cc5ea$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $5297880dd24cc5ea$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $5297880dd24cc5ea$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $9bad38c73ebb867d$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $5297880dd24cc5ea$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $5297880dd24cc5ea$var$getLineMethod(options) {
    if (options.stepped) return 0, $9bad38c73ebb867d$export$d24c54395ce0c509;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $9bad38c73ebb867d$export$6554612db691658e;
    return $5297880dd24cc5ea$var$lineTo;
}
function $5297880dd24cc5ea$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0 , end: paramsEnd = count - 1  } = params;
    const { start: segmentStart , end: segmentEnd  } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $5297880dd24cc5ea$var$pathSegment(ctx, line, segment, params) {
    const { points: points , options: options  } = line;
    const { count: count , start: start , loop: loop , ilen: ilen  } = $5297880dd24cc5ea$var$pathVars(points, segment, params);
    const lineMethod = $5297880dd24cc5ea$var$getLineMethod(options);
    let { move: move = true , reverse: reverse  } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $5297880dd24cc5ea$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count , start: start , ilen: ilen  } = $5297880dd24cc5ea$var$pathVars(points, segment, params);
    const { move: move = true , reverse: reverse  } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $5297880dd24cc5ea$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
    return useFastPath ? $5297880dd24cc5ea$var$fastPathSegment : $5297880dd24cc5ea$var$pathSegment;
}
function $5297880dd24cc5ea$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $9bad38c73ebb867d$export$7a38258bbe170828;
    if (options.tension || options.cubicInterpolationMode === "monotone") return 0, $9bad38c73ebb867d$export$2f6ca3d3b1f80bf5;
    return 0, $9bad38c73ebb867d$export$8a5498727ef6be21;
}
function $5297880dd24cc5ea$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $5297880dd24cc5ea$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $5297880dd24cc5ea$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments , options: options  } = line;
    const segmentMethod = $5297880dd24cc5ea$var$_getSegmentMethod(line);
    for (const segment of segments){
        $5297880dd24cc5ea$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $5297880dd24cc5ea$var$usePath2D = typeof Path2D === "function";
function $5297880dd24cc5ea$var$draw(ctx, line, start, count) {
    if ($5297880dd24cc5ea$var$usePath2D && !line.options.segment) $5297880dd24cc5ea$var$strokePathWithCache(ctx, line, start, count);
    else $5297880dd24cc5ea$var$strokePathDirect(ctx, line, start, count);
}
class $5297880dd24cc5ea$export$55e463fa7bcd3469 extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    static id = "line";
    static defaults = {
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: "miter",
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: "default",
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== "borderDash" && name !== "fill"
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $9bad38c73ebb867d$export$ab83b03e4111b1d0)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $9bad38c73ebb867d$export$1a82df3d29112e01)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $9bad38c73ebb867d$export$306ddfe3a8403e2)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $5297880dd24cc5ea$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start , end: end  } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $5297880dd24cc5ea$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $5297880dd24cc5ea$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $5297880dd24cc5ea$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $5297880dd24cc5ea$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value  } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $5297880dd24cc5ea$export$bd159b522b230b7a extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    static id = "point";
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: "circle",
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x , y: y  } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $5297880dd24cc5ea$var$inRange$1(this, mouseX, "x", useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $5297880dd24cc5ea$var$inRange$1(this, mouseY, "y", useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x , y: y  } = this.getProps([
            "x",
            "y"
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $9bad38c73ebb867d$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $9bad38c73ebb867d$export$493d36ec626b6698)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $5297880dd24cc5ea$var$getBarBounds(bar, useFinalPosition) {
    const { x: x , y: y , base: base , width: width , height: height  } = bar.getProps([
        "x",
        "y",
        "base",
        "width",
        "height"
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $5297880dd24cc5ea$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(value, min, max);
}
function $5297880dd24cc5ea$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $9bad38c73ebb867d$export$d66dc83d8cfc8dd)(value);
    return {
        t: $5297880dd24cc5ea$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $5297880dd24cc5ea$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $5297880dd24cc5ea$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $5297880dd24cc5ea$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $5297880dd24cc5ea$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius  } = bar.getProps([
        "enableBorderRadius"
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $9bad38c73ebb867d$export$92108d983e8ee699)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $5297880dd24cc5ea$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $5297880dd24cc5ea$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $5297880dd24cc5ea$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $5297880dd24cc5ea$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $5297880dd24cc5ea$var$boundingRects(bar) {
    const bounds = $5297880dd24cc5ea$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $5297880dd24cc5ea$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $5297880dd24cc5ea$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $5297880dd24cc5ea$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $5297880dd24cc5ea$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $9bad38c73ebb867d$export$3b513254972cfc9c)(x, bounds.left, bounds.right)) && (skipY || (0, $9bad38c73ebb867d$export$3b513254972cfc9c)(y, bounds.top, bounds.bottom));
}
function $5297880dd24cc5ea$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $5297880dd24cc5ea$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $5297880dd24cc5ea$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $5297880dd24cc5ea$export$a16ed71bf4b07672 extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    static id = "bar";
    static defaults = {
        borderSkipped: "start",
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: "auto",
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: "backgroundColor",
        borderColor: "borderColor"
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount , options: { borderColor: borderColor , backgroundColor: backgroundColor  }  } = this;
        const { inner: inner , outer: outer  } = $5297880dd24cc5ea$var$boundingRects(this);
        const addRectPath = $5297880dd24cc5ea$var$hasRadius(outer.radius) ? (0, $9bad38c73ebb867d$export$1fbe638ecf81657e) : $5297880dd24cc5ea$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $5297880dd24cc5ea$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $5297880dd24cc5ea$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill("evenodd");
        }
        ctx.beginPath();
        addRectPath(ctx, $5297880dd24cc5ea$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $5297880dd24cc5ea$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $5297880dd24cc5ea$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $5297880dd24cc5ea$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x , y: y , base: base , horizontal: horizontal  } = this.getProps([
            "x",
            "y",
            "base",
            "horizontal"
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === "x" ? this.width / 2 : this.height / 2;
    }
}
var $5297880dd24cc5ea$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $5297880dd24cc5ea$export$d48203c759d6a1fc,
    BarElement: $5297880dd24cc5ea$export$a16ed71bf4b07672,
    LineElement: $5297880dd24cc5ea$export$55e463fa7bcd3469,
    PointElement: $5297880dd24cc5ea$export$bd159b522b230b7a
});
const $5297880dd24cc5ea$var$BORDER_COLORS = [
    "rgb(54, 162, 235)",
    "rgb(255, 99, 132)",
    "rgb(255, 159, 64)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "rgb(153, 102, 255)",
    "rgb(201, 203, 207)" // grey
];
// Border colors with 50% transparency
const $5297880dd24cc5ea$var$BACKGROUND_COLORS = /* #__PURE__ */ $5297880dd24cc5ea$var$BORDER_COLORS.map((color)=>color.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function $5297880dd24cc5ea$var$getBorderColor(i) {
    return $5297880dd24cc5ea$var$BORDER_COLORS[i % $5297880dd24cc5ea$var$BORDER_COLORS.length];
}
function $5297880dd24cc5ea$var$getBackgroundColor(i) {
    return $5297880dd24cc5ea$var$BACKGROUND_COLORS[i % $5297880dd24cc5ea$var$BACKGROUND_COLORS.length];
}
function $5297880dd24cc5ea$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $5297880dd24cc5ea$var$getBorderColor(i);
    dataset.backgroundColor = $5297880dd24cc5ea$var$getBackgroundColor(i);
    return ++i;
}
function $5297880dd24cc5ea$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$5297880dd24cc5ea$var$getBorderColor(i++));
    return i;
}
function $5297880dd24cc5ea$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$5297880dd24cc5ea$var$getBackgroundColor(i++));
    return i;
}
function $5297880dd24cc5ea$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $5297880dd24cc5ea$export$e04603e7d8b77172) i = $5297880dd24cc5ea$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $5297880dd24cc5ea$export$2a270b3a0d973c85) i = $5297880dd24cc5ea$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $5297880dd24cc5ea$var$colorizeDefaultDataset(dataset, i);
    };
}
function $5297880dd24cc5ea$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $5297880dd24cc5ea$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
var $5297880dd24cc5ea$export$c537fa0d021d010b = {
    id: "colors",
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets  } , options: chartOptions  } = chart.config;
        const { elements: elements  } = chartOptions;
        if (!options.forceOverride && ($5297880dd24cc5ea$var$containsColorsDefinitions(datasets) || $5297880dd24cc5ea$var$containsColorsDefinition(chartOptions) || elements && $5297880dd24cc5ea$var$containsColorsDefinitions(elements))) return;
        const colorizer = $5297880dd24cc5ea$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $5297880dd24cc5ea$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx , y: pointAy  } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $5297880dd24cc5ea$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(minIndex) && !(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $5297880dd24cc5ea$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, "data", {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $5297880dd24cc5ea$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $5297880dd24cc5ea$var$cleanDecimatedDataset(dataset);
    });
}
function $5297880dd24cc5ea$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale  } = meta;
    const { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = iScale.getUserBounds();
    if (minDefined) start = (0, $9bad38c73ebb867d$export$25ce5a424b770e84)((0, $9bad38c73ebb867d$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $9bad38c73ebb867d$export$25ce5a424b770e84)((0, $9bad38c73ebb867d$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $5297880dd24cc5ea$export$be17f937e9aa7533 = {
    id: "decimation",
    defaults: {
        algorithm: "min-max",
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $5297880dd24cc5ea$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data , indexAxis: indexAxis  } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $9bad38c73ebb867d$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === "y") return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== "linear" && xAxis.type !== "time") return;
            if (chart.options.parsing) return;
            let { start: start , count: count  } = $5297880dd24cc5ea$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $5297880dd24cc5ea$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, "data", {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case "lttb":
                    decimated = $5297880dd24cc5ea$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case "min-max":
                    decimated = $5297880dd24cc5ea$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $5297880dd24cc5ea$var$cleanDecimatedData(chart);
    }
};
function $5297880dd24cc5ea$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start , end: end  } = segment;
        end = $5297880dd24cc5ea$var$_findSegmentEnd(start, end, points);
        const bounds = $5297880dd24cc5ea$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $9bad38c73ebb867d$export$306ddfe3a8403e2)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $5297880dd24cc5ea$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $9bad38c73ebb867d$export$9fa96a7d116ea3ce)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $5297880dd24cc5ea$var$_getEdge(bounds, subBounds, "start", Math.max)
                },
                end: {
                    [property]: $5297880dd24cc5ea$var$_getEdge(bounds, subBounds, "end", Math.min)
                }
            });
        }
    }
    return parts;
}
function $5297880dd24cc5ea$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === "angle") {
        start = (0, $9bad38c73ebb867d$export$28f7fcd39efa255)(start);
        end = (0, $9bad38c73ebb867d$export$28f7fcd39efa255)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $5297880dd24cc5ea$var$_pointsFromSegments(boundary, line) {
    const { x: x = null , y: y = null  } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start , end: end  })=>{
        end = $5297880dd24cc5ea$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $5297880dd24cc5ea$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $5297880dd24cc5ea$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $5297880dd24cc5ea$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $5297880dd24cc5ea$var$_pointsFromSegments(boundary, line);
    return points.length ? new $5297880dd24cc5ea$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $5297880dd24cc5ea$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $5297880dd24cc5ea$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $9bad38c73ebb867d$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $5297880dd24cc5ea$var$_decodeFill(line, index, count) {
    const fill = $5297880dd24cc5ea$var$parseFillOption(line);
    if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $9bad38c73ebb867d$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $5297880dd24cc5ea$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        "origin",
        "start",
        "end",
        "stack",
        "shape"
    ].indexOf(fill) >= 0 && fill;
}
function $5297880dd24cc5ea$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === "-" || firstCh === "+") target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $5297880dd24cc5ea$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === "start") pixel = scale.bottom;
    else if (fill === "end") pixel = scale.top;
    else if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $5297880dd24cc5ea$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === "start") value = startValue;
    else if (fill === "end") value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $5297880dd24cc5ea$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return "origin";
    return fill;
}
function $5297880dd24cc5ea$var$_buildStackLine(source) {
    const { scale: scale , index: index , line: line  } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $5297880dd24cc5ea$var$getLinesBelow(scale, index);
    linesBelow.push($5297880dd24cc5ea$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$5297880dd24cc5ea$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $5297880dd24cc5ea$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $5297880dd24cc5ea$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas("line");
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $5297880dd24cc5ea$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first , last: last , point: point  } = $5297880dd24cc5ea$var$findPoint(line, sourcePoint, "x");
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $5297880dd24cc5ea$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $9bad38c73ebb867d$export$3b513254972cfc9c)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $5297880dd24cc5ea$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x , y: y , radius: radius  } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $9bad38c73ebb867d$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x , y: y , radius: radius  } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $5297880dd24cc5ea$var$_getTarget(source) {
    const { chart: chart , fill: fill , line: line  } = source;
    if ((0, $9bad38c73ebb867d$export$39b482c5e57630a8)(fill)) return $5297880dd24cc5ea$var$getLineByIndex(chart, fill);
    if (fill === "stack") return $5297880dd24cc5ea$var$_buildStackLine(source);
    if (fill === "shape") return true;
    const boundary = $5297880dd24cc5ea$var$computeBoundary(source);
    if (boundary instanceof $5297880dd24cc5ea$var$simpleArc) return boundary;
    return $5297880dd24cc5ea$var$_createBoundaryLine(boundary, line);
}
function $5297880dd24cc5ea$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $5297880dd24cc5ea$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $5297880dd24cc5ea$var$computeCircularBoundary(source);
    return $5297880dd24cc5ea$var$computeLinearBoundary(source);
}
function $5297880dd24cc5ea$var$computeLinearBoundary(source) {
    const { scale: scale = {} , fill: fill  } = source;
    const pixel = $5297880dd24cc5ea$var$_getTargetPixel(fill, scale);
    if ((0, $9bad38c73ebb867d$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $5297880dd24cc5ea$var$computeCircularBoundary(source) {
    const { scale: scale , fill: fill  } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $5297880dd24cc5ea$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $5297880dd24cc5ea$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $5297880dd24cc5ea$var$_drawfill(ctx, source, area) {
    const target = $5297880dd24cc5ea$var$_getTarget(source);
    const { line: line , scale: scale , axis: axis  } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color , below: below = color  } = fillOption || {};
    if (target && line.points.length) {
        (0, $9bad38c73ebb867d$export$8743009a87fcb00f)(ctx, area);
        $5297880dd24cc5ea$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis
        });
        (0, $9bad38c73ebb867d$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $5297880dd24cc5ea$var$doFill(ctx, cfg) {
    const { line: line , target: target , above: above , below: below , area: area , scale: scale  } = cfg;
    const property = line._loop ? "angle" : cfg.axis;
    ctx.save();
    if (property === "x" && below !== above) {
        $5297880dd24cc5ea$var$clipVertical(ctx, target, area.top);
        $5297880dd24cc5ea$var$fill(ctx, {
            line: line,
            target: target,
            color: above,
            scale: scale,
            property: property
        });
        ctx.restore();
        ctx.save();
        $5297880dd24cc5ea$var$clipVertical(ctx, target, area.bottom);
    }
    $5297880dd24cc5ea$var$fill(ctx, {
        line: line,
        target: target,
        color: below,
        scale: scale,
        property: property
    });
    ctx.restore();
}
function $5297880dd24cc5ea$var$clipVertical(ctx, target, clipY) {
    const { segments: segments , points: points  } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start , end: end  } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$5297880dd24cc5ea$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $5297880dd24cc5ea$var$fill(ctx, cfg) {
    const { line: line , target: target , property: property , color: color , scale: scale  } = cfg;
    const segments = $5297880dd24cc5ea$var$_segments(line, target, property);
    for (const { source: src , target: tgt , start: start , end: end  } of segments){
        const { style: { backgroundColor: backgroundColor = color  } = {}  } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $5297880dd24cc5ea$var$clipBounds(ctx, scale, notShape && $5297880dd24cc5ea$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $5297880dd24cc5ea$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $5297880dd24cc5ea$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? "evenodd" : "nonzero");
        ctx.restore();
    }
}
function $5297880dd24cc5ea$var$clipBounds(ctx, scale, bounds) {
    const { top: top , bottom: bottom  } = scale.chart.chartArea;
    const { property: property , start: start , end: end  } = bounds || {};
    if (property === "x") {
        ctx.beginPath();
        ctx.rect(start, top, end - start, bottom - top);
        ctx.clip();
    }
}
function $5297880dd24cc5ea$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $5297880dd24cc5ea$export$d19ba4d812bed757 = {
    id: "filler",
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $5297880dd24cc5ea$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $5297880dd24cc5ea$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $5297880dd24cc5ea$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === "beforeDraw";
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $5297880dd24cc5ea$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== "beforeDatasetsDraw") return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($5297880dd24cc5ea$var$_shouldApplyFill(source)) $5297880dd24cc5ea$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$5297880dd24cc5ea$var$_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") return;
        $5297880dd24cc5ea$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: "beforeDatasetDraw"
    }
};
const $5297880dd24cc5ea$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize , boxWidth: boxWidth = fontSize  } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $5297880dd24cc5ea$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $5297880dd24cc5ea$var$Legend extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options , ctx: ctx  } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth , itemHeight: itemHeight  } = $5297880dd24cc5ea$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx , maxWidth: maxWidth , options: { labels: { padding: padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx , maxHeight: maxHeight , options: { labels: { padding: padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth , itemHeight: itemHeight  } = $5297880dd24cc5ea$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes , options: { align: align , labels: { padding: padding  } , rtl: rtl  }  } = this;
        const rtlHelper = (0, $9bad38c73ebb867d$export$3d12bd131bb975d1)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === "top" || this.options.position === "bottom";
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $9bad38c73ebb867d$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $9bad38c73ebb867d$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts , columnSizes: columnSizes , lineWidths: lineWidths , ctx: ctx  } = this;
        const { align: align , labels: labelOpts  } = opts;
        const defaultColor = (0, $9bad38c73ebb867d$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $9bad38c73ebb867d$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const labelFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding  } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign("left");
        ctx.textBaseline = "middle";
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth , boxHeight: boxHeight , itemHeight: itemHeight  } = $5297880dd24cc5ea$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(legendItem.lineCap, "butt");
            ctx.lineDashOffset = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(legendItem.lineJoin, "miter");
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $9bad38c73ebb867d$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $9bad38c73ebb867d$export$24baa2b76016ce0e)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $9bad38c73ebb867d$export$92108d983e8ee699)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $9bad38c73ebb867d$export$1fbe638ecf81657e)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $9bad38c73ebb867d$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $9bad38c73ebb867d$export$91c6e00c14e7e6fd)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $9bad38c73ebb867d$export$9d398bebfec1c039)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== "string") {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $5297880dd24cc5ea$var$calculateLegendItemHeight(legendItem, fontLineHeight);
            } else cursor.y += lineHeight;
        });
        (0, $9bad38c73ebb867d$export$890c4ad488842ce7)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $9bad38c73ebb867d$export$3d12bd131bb975d1)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $9bad38c73ebb867d$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = "middle";
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $9bad38c73ebb867d$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $9bad38c73ebb867d$export$3b513254972cfc9c)(x, this.left, this.right) && (0, $9bad38c73ebb867d$export$3b513254972cfc9c)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $9bad38c73ebb867d$export$3b513254972cfc9c)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $9bad38c73ebb867d$export$3b513254972cfc9c)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$5297880dd24cc5ea$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === "mousemove" || e.type === "mouseout") {
            const previous = this._hoveredItem;
            const sameItem = $5297880dd24cc5ea$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $5297880dd24cc5ea$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $5297880dd24cc5ea$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $5297880dd24cc5ea$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $5297880dd24cc5ea$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== "string") legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $5297880dd24cc5ea$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== "string") itemHeight = $5297880dd24cc5ea$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $5297880dd24cc5ea$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length + 0.5 : 0;
    return fontLineHeight * labelHeight;
}
function $5297880dd24cc5ea$var$isListened(type, opts) {
    if ((type === "mousemove" || type === "mouseout") && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === "click" || type === "mouseup")) return true;
    return false;
}
var $5297880dd24cc5ea$export$ed247974535929c7 = {
    id: "legend",
    _element: $5297880dd24cc5ea$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $5297880dd24cc5ea$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: "top",
        align: "center",
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle , pointStyle: pointStyle , textAlign: textAlign , color: color , useBorderRadius: useBorderRadius , borderRadius: borderRadius  }  } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: "center",
            text: ""
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith("on"),
        labels: {
            _scriptable: (name)=>![
                    "generateLabels",
                    "filter",
                    "sort"
                ].includes(name)
        }
    }
};
class $5297880dd24cc5ea$var$Title extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $9bad38c73ebb867d$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === "top" || pos === "bottom";
    }
    _drawArgs(offset) {
        const { top: top , left: left , bottom: bottom , right: right , options: options  } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === "left") {
                titleX = left + offset;
                titleY = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $9bad38c73ebb867d$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $9bad38c73ebb867d$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $9bad38c73ebb867d$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $9bad38c73ebb867d$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX , titleY: titleY , maxWidth: maxWidth , rotation: rotation  } = this._drawArgs(offset);
        (0, $9bad38c73ebb867d$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $9bad38c73ebb867d$export$3c2fa207a37baaea)(opts.align),
            textBaseline: "middle",
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $5297880dd24cc5ea$var$createTitle(chart, titleOpts) {
    const title = new $5297880dd24cc5ea$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $5297880dd24cc5ea$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $5297880dd24cc5ea$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $5297880dd24cc5ea$export$f99233281efd08a0 = {
    id: "title",
    _element: $5297880dd24cc5ea$var$Title,
    start (chart, _args, options) {
        $5297880dd24cc5ea$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "bold"
        },
        fullSize: true,
        padding: 10,
        position: "top",
        text: "",
        weight: 2000
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $5297880dd24cc5ea$var$map = new WeakMap();
var $5297880dd24cc5ea$export$d5c56664638992a4 = {
    id: "subtitle",
    start (chart, _args, options) {
        const title = new $5297880dd24cc5ea$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.configure(chart, title, options);
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.addBox(chart, title);
        $5297880dd24cc5ea$var$map.set(chart, title);
    },
    stop (chart) {
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.removeBox(chart, $5297880dd24cc5ea$var$map.get(chart));
        $5297880dd24cc5ea$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $5297880dd24cc5ea$var$map.get(chart);
        $5297880dd24cc5ea$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: "center",
        display: false,
        font: {
            weight: "normal"
        },
        fullSize: true,
        padding: 0,
        position: "top",
        text: "",
        weight: 1500
    },
    defaultRoutes: {
        color: "color"
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $5297880dd24cc5ea$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let x = 0;
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                x += pos.x;
                y += pos.y;
                ++count;
            }
        }
        return {
            x: x / count,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $9bad38c73ebb867d$export$158acd800e1ef08b)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $5297880dd24cc5ea$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $5297880dd24cc5ea$var$splitNewlines(str) {
    if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) return str.split("\n");
    return str;
}
function $5297880dd24cc5ea$var$createTooltipItem(chart, item) {
    const { element: element , datasetIndex: datasetIndex , index: index  } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label , value: value  } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $5297880dd24cc5ea$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body , footer: footer , title: title  } = tooltip;
    const { boxWidth: boxWidth , boxHeight: boxHeight  } = options;
    const bodyFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $9bad38c73ebb867d$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $9bad38c73ebb867d$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $9bad38c73ebb867d$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $9bad38c73ebb867d$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $9bad38c73ebb867d$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $9bad38c73ebb867d$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $9bad38c73ebb867d$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $5297880dd24cc5ea$var$determineYAlign(chart, size) {
    const { y: y , height: height  } = size;
    if (y < height / 2) return "top";
    else if (y > chart.height - height / 2) return "bottom";
    return "center";
}
function $5297880dd24cc5ea$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x , width: width  } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === "left" && x + width + caret > chart.width) return true;
    if (xAlign === "right" && x - width - caret < 0) return true;
}
function $5297880dd24cc5ea$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x , width: width  } = size;
    const { width: chartWidth , chartArea: { left: left , right: right  }  } = chart;
    let xAlign = "center";
    if (yAlign === "center") xAlign = x <= (left + right) / 2 ? "left" : "right";
    else if (x <= width / 2) xAlign = "left";
    else if (x >= chartWidth - width / 2) xAlign = "right";
    if ($5297880dd24cc5ea$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = "center";
    return xAlign;
}
function $5297880dd24cc5ea$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $5297880dd24cc5ea$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $5297880dd24cc5ea$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $5297880dd24cc5ea$var$alignX(size, xAlign) {
    let { x: x , width: width  } = size;
    if (xAlign === "right") x -= width;
    else if (xAlign === "center") x -= width / 2;
    return x;
}
function $5297880dd24cc5ea$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y , height: height  } = size;
    if (yAlign === "top") y += paddingAndSize;
    else if (yAlign === "bottom") y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $5297880dd24cc5ea$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize , caretPadding: caretPadding , cornerRadius: cornerRadius  } = options;
    const { xAlign: xAlign , yAlign: yAlign  } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft , topRight: topRight , bottomLeft: bottomLeft , bottomRight: bottomRight  } = (0, $9bad38c73ebb867d$export$92108d983e8ee699)(cornerRadius);
    let x = $5297880dd24cc5ea$var$alignX(size, xAlign);
    const y = $5297880dd24cc5ea$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === "center") {
        if (xAlign === "left") x += paddingAndSize;
        else if (xAlign === "right") x -= paddingAndSize;
    } else if (xAlign === "left") x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === "right") x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $5297880dd24cc5ea$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(options.padding);
    return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $5297880dd24cc5ea$var$getBeforeAfterBodyLines(callback) {
    return $5297880dd24cc5ea$var$pushOrConcat([], $5297880dd24cc5ea$var$splitNewlines(callback));
}
function $5297880dd24cc5ea$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $9bad38c73ebb867d$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: "tooltip"
    });
}
function $5297880dd24cc5ea$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $5297880dd24cc5ea$var$defaultCallbacks = {
    beforeTitle: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === "dataset") return item.dataset.label || "";
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return "";
    },
    afterTitle: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    beforeBody: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    beforeLabel: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === "dataset") return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || "";
        if (label) label += ": ";
        const value = tooltipItem.formattedValue;
        if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    afterBody: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    beforeFooter: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    footer: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46),
    afterFooter: (0, $9bad38c73ebb867d$export$cf2f7c5792f80b46)
};
function $5297880dd24cc5ea$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === "undefined") return $5297880dd24cc5ea$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $5297880dd24cc5ea$var$Tooltip extends $5297880dd24cc5ea$export$db77ccec0bb4ccac {
    static positioners = $5297880dd24cc5ea$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $5297880dd24cc5ea$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $5297880dd24cc5ea$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks  } = options;
        const beforeTitle = $5297880dd24cc5ea$var$invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
        const title = $5297880dd24cc5ea$var$invokeCallbackWithFallback(callbacks, "title", this, context);
        const afterTitle = $5297880dd24cc5ea$var$invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
        let lines = [];
        lines = $5297880dd24cc5ea$var$pushOrConcat(lines, $5297880dd24cc5ea$var$splitNewlines(beforeTitle));
        lines = $5297880dd24cc5ea$var$pushOrConcat(lines, $5297880dd24cc5ea$var$splitNewlines(title));
        lines = $5297880dd24cc5ea$var$pushOrConcat(lines, $5297880dd24cc5ea$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $5297880dd24cc5ea$var$getBeforeAfterBodyLines($5297880dd24cc5ea$var$invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks  } = options;
        const bodyItems = [];
        (0, $9bad38c73ebb867d$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $5297880dd24cc5ea$var$overrideCallbacks(callbacks, context);
            $5297880dd24cc5ea$var$pushOrConcat(bodyItem.before, $5297880dd24cc5ea$var$splitNewlines($5297880dd24cc5ea$var$invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
            $5297880dd24cc5ea$var$pushOrConcat(bodyItem.lines, $5297880dd24cc5ea$var$invokeCallbackWithFallback(scoped, "label", this, context));
            $5297880dd24cc5ea$var$pushOrConcat(bodyItem.after, $5297880dd24cc5ea$var$splitNewlines($5297880dd24cc5ea$var$invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $5297880dd24cc5ea$var$getBeforeAfterBodyLines($5297880dd24cc5ea$var$invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks  } = options;
        const beforeFooter = $5297880dd24cc5ea$var$invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
        const footer = $5297880dd24cc5ea$var$invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
        const afterFooter = $5297880dd24cc5ea$var$invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
        let lines = [];
        lines = $5297880dd24cc5ea$var$pushOrConcat(lines, $5297880dd24cc5ea$var$splitNewlines(beforeFooter));
        lines = $5297880dd24cc5ea$var$pushOrConcat(lines, $5297880dd24cc5ea$var$splitNewlines(footer));
        lines = $5297880dd24cc5ea$var$pushOrConcat(lines, $5297880dd24cc5ea$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($5297880dd24cc5ea$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $9bad38c73ebb867d$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $5297880dd24cc5ea$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($5297880dd24cc5ea$var$invokeCallbackWithFallback(scoped, "labelColor", this, context));
            labelPointStyles.push($5297880dd24cc5ea$var$invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
            labelTextColors.push($5297880dd24cc5ea$var$invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $5297880dd24cc5ea$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $5297880dd24cc5ea$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $5297880dd24cc5ea$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $5297880dd24cc5ea$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign , yAlign: yAlign  } = this;
        const { caretSize: caretSize , cornerRadius: cornerRadius  } = options;
        const { topLeft: topLeft , topRight: topRight , bottomLeft: bottomLeft , bottomRight: bottomRight  } = (0, $9bad38c73ebb867d$export$92108d983e8ee699)(cornerRadius);
        const { x: ptX , y: ptY  } = tooltipPoint;
        const { width: width , height: height  } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === "center") {
            y2 = ptY + height / 2;
            if (xAlign === "left") {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === "left") x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === "right") x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === "top") {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $9bad38c73ebb867d$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $5297880dd24cc5ea$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = "middle";
            titleFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight , boxWidth: boxWidth  } = options;
        const bodyFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.bodyFont);
        const colorX = $5297880dd24cc5ea$var$getAlignedX(this, "left", options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $9bad38c73ebb867d$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $9bad38c73ebb867d$export$493d36ec626b6698)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $9bad38c73ebb867d$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $9bad38c73ebb867d$export$92108d983e8ee699)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $9bad38c73ebb867d$export$1fbe638ecf81657e)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $9bad38c73ebb867d$export$1fbe638ecf81657e)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body  } = this;
        const { bodySpacing: bodySpacing , bodyAlign: bodyAlign , displayColors: displayColors , boxHeight: boxHeight , boxWidth: boxWidth , boxPadding: boxPadding  } = options;
        const bodyFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $9bad38c73ebb867d$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = "middle";
        ctx.font = bodyFont.string;
        pt.x = $5297880dd24cc5ea$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $9bad38c73ebb867d$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $9bad38c73ebb867d$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $9bad38c73ebb867d$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $9bad38c73ebb867d$export$3d12bd131bb975d1)(options.rtl, this.x, this.width);
            pt.x = $5297880dd24cc5ea$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = "middle";
            footerFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign , yAlign: yAlign  } = this;
        const { x: x , y: y  } = pt;
        const { width: width , height: height  } = tooltipSize;
        const { topLeft: topLeft , topRight: topRight , bottomLeft: bottomLeft , bottomRight: bottomRight  } = (0, $9bad38c73ebb867d$export$92108d983e8ee699)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === "top") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === "center" && xAlign === "right") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === "bottom") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === "center" && xAlign === "left") this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $5297880dd24cc5ea$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $5297880dd24cc5ea$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $5297880dd24cc5ea$var$determineAlignment(chart, options, positionAndSize);
            const point = $5297880dd24cc5ea$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $9bad38c73ebb867d$export$91c6e00c14e7e6fd)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $9bad38c73ebb867d$export$890c4ad488842ce7)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex , index: index  })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error("Cannot find a dataset at index " + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $9bad38c73ebb867d$export$995eb9fca571757)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $9bad38c73ebb867d$export$995eb9fca571757)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === "mouseout") return [];
        if (!inChartArea) return lastActive;
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX , caretY: caretY , options: options  } = this;
        const position = $5297880dd24cc5ea$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $5297880dd24cc5ea$export$28c660c63b792dea = {
    id: "tooltip",
    _element: $5297880dd24cc5ea$var$Tooltip,
    positioners: $5297880dd24cc5ea$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $5297880dd24cc5ea$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins("beforeTooltipDraw", {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins("afterTooltipDraw", args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: "average",
        backgroundColor: "rgba(0,0,0,0.8)",
        titleColor: "#fff",
        titleFont: {
            weight: "bold"
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: "left",
        bodyColor: "#fff",
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: "left",
        footerColor: "#fff",
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: "bold"
        },
        footerAlign: "left",
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: "#fff",
        displayColors: true,
        boxPadding: 0,
        borderColor: "rgba(0,0,0,0)",
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: "easeOutQuart"
        },
        animations: {
            numbers: {
                type: "number",
                properties: [
                    "x",
                    "y",
                    "width",
                    "height",
                    "caretX",
                    "caretY"
                ]
            },
            opacity: {
                easing: "linear",
                duration: 200
            }
        },
        callbacks: $5297880dd24cc5ea$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: "font",
        footerFont: "font",
        titleFont: "font"
    },
    descriptors: {
        _scriptable: (name)=>name !== "filter" && name !== "itemSort" && name !== "external",
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: "animation"
        }
    },
    additionalOptionScopes: [
        "interaction"
    ]
};
var $5297880dd24cc5ea$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $5297880dd24cc5ea$export$c537fa0d021d010b,
    Decimation: $5297880dd24cc5ea$export$be17f937e9aa7533,
    Filler: $5297880dd24cc5ea$export$d19ba4d812bed757,
    Legend: $5297880dd24cc5ea$export$ed247974535929c7,
    SubTitle: $5297880dd24cc5ea$export$d5c56664638992a4,
    Title: $5297880dd24cc5ea$export$f99233281efd08a0,
    Tooltip: $5297880dd24cc5ea$export$28c660c63b792dea
});
const $5297880dd24cc5ea$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === "string") {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $5297880dd24cc5ea$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $5297880dd24cc5ea$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $5297880dd24cc5ea$var$validIndex = (index, max)=>index === null ? null : (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $5297880dd24cc5ea$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $5297880dd24cc5ea$export$29e663ba4d09fe7 extends $5297880dd24cc5ea$export$d60cfc58d3c358b6 {
    static id = "category";
    static defaults = {
        ticks: {
            callback: $5297880dd24cc5ea$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index , label: label  } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $5297880dd24cc5ea$var$findOrAddLabel(labels, raw, (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $5297880dd24cc5ea$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let { min: min , max: max  } = this.getMinMax(true);
        if (this.options.bounds === "ticks") {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $5297880dd24cc5ea$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== "number") value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $5297880dd24cc5ea$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds , step: step , min: min , max: max , precision: precision , count: count , maxTicks: maxTicks , maxDigits: maxDigits , includeBounds: includeBounds  } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin , max: rmax  } = dataRange;
    const minDefined = !(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $9bad38c73ebb867d$export$a33b77bbdbb8366c)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $9bad38c73ebb867d$export$a33b77bbdbb8366c)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === "ticks") {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $9bad38c73ebb867d$export$b9a6b53f9be3734)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $9bad38c73ebb867d$export$a05254e7c3aeba6e)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $9bad38c73ebb867d$export$23ebac1979863676)(spacing), (0, $9bad38c73ebb867d$export$23ebac1979863676)(niceMin));
    factor = Math.pow(10, (0, $9bad38c73ebb867d$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $9bad38c73ebb867d$export$a05254e7c3aeba6e)(Math.round((niceMin + j * spacing) * factor) / factor, min, $5297880dd24cc5ea$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $9bad38c73ebb867d$export$a05254e7c3aeba6e)(ticks[ticks.length - 1].value, max, $5297880dd24cc5ea$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $5297880dd24cc5ea$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal , minRotation: minRotation  }) {
    const rad = (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ("" + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $5297880dd24cc5ea$var$LinearScaleBase extends $5297880dd24cc5ea$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero  } = this.options;
        const { minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let { min: min , max: max  } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $9bad38c73ebb867d$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit , stepSize: stepSize  } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $5297880dd24cc5ea$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === "ticks") (0, $9bad38c73ebb867d$export$53a70dd1ebbae346)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $9bad38c73ebb867d$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $5297880dd24cc5ea$export$e7f4e5e8656f0b93 extends $5297880dd24cc5ea$var$LinearScaleBase {
    static id = "linear";
    static defaults = {
        ticks: {
            callback: (0, $9bad38c73ebb867d$export$91477dc880baac21).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min , max: max  } = this.getMinMax(true);
        this.min = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $5297880dd24cc5ea$var$log10Floor = (v)=>Math.floor((0, $9bad38c73ebb867d$export$9f4f30ee63539e24)(v));
const $5297880dd24cc5ea$var$changeExponent = (v, m)=>Math.pow(10, $5297880dd24cc5ea$var$log10Floor(v) + m);
function $5297880dd24cc5ea$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $5297880dd24cc5ea$var$log10Floor(tickVal));
    return remain === 1;
}
function $5297880dd24cc5ea$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $5297880dd24cc5ea$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $5297880dd24cc5ea$var$log10Floor(range);
    while($5297880dd24cc5ea$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($5297880dd24cc5ea$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $5297880dd24cc5ea$var$log10Floor(min));
}
function $5297880dd24cc5ea$var$generateTicks(generationOptions, { min: min , max: max  }) {
    min = (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $5297880dd24cc5ea$var$log10Floor(min);
    let exp = $5297880dd24cc5ea$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $5297880dd24cc5ea$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $9bad38c73ebb867d$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $5297880dd24cc5ea$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $5297880dd24cc5ea$export$85295eaf7cb3ac3e extends $5297880dd24cc5ea$export$d60cfc58d3c358b6 {
    static id = "logarithmic";
    static defaults = {
        ticks: {
            callback: (0, $9bad38c73ebb867d$export$91477dc880baac21).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $5297880dd24cc5ea$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min , max: max  } = this.getMinMax(true);
        this.min = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $9bad38c73ebb867d$export$39b482c5e57630a8)(this._userMin)) this.min = min === $5297880dd24cc5ea$var$changeExponent(this.min, 0) ? $5297880dd24cc5ea$var$changeExponent(this.min, -1) : $5297880dd24cc5ea$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($5297880dd24cc5ea$var$changeExponent(min, -1));
                setMax($5297880dd24cc5ea$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($5297880dd24cc5ea$var$changeExponent(max, -1));
        if (max <= 0) setMax($5297880dd24cc5ea$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $5297880dd24cc5ea$var$generateTicks(generationOptions, this);
        if (opts.bounds === "ticks") (0, $9bad38c73ebb867d$export$53a70dd1ebbae346)(ticks, this, "value");
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? "0" : (0, $9bad38c73ebb867d$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $9bad38c73ebb867d$export$9f4f30ee63539e24)(start);
        this._valueRange = (0, $9bad38c73ebb867d$export$9f4f30ee63539e24)(this.max) - (0, $9bad38c73ebb867d$export$9f4f30ee63539e24)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $9bad38c73ebb867d$export$9f4f30ee63539e24)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $5297880dd24cc5ea$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $9bad38c73ebb867d$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $5297880dd24cc5ea$var$measureLabelSize(ctx, font, label) {
    label = (0, $9bad38c73ebb867d$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $9bad38c73ebb867d$export$faec65b429be379)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $5297880dd24cc5ea$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $5297880dd24cc5ea$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $9bad38c73ebb867d$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(opts.font);
        const textSize = $5297880dd24cc5ea$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $9bad38c73ebb867d$export$28f7fcd39efa255)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $9bad38c73ebb867d$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $5297880dd24cc5ea$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $5297880dd24cc5ea$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $5297880dd24cc5ea$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $5297880dd24cc5ea$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $5297880dd24cc5ea$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $5297880dd24cc5ea$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra , additionalAngle: additionalAngle , padding: padding , size: size  } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $9bad38c73ebb867d$export$3a6d5c9ae78a2c08)((0, $9bad38c73ebb867d$export$28f7fcd39efa255)(pointLabelPosition.angle + (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd))));
    const y = $5297880dd24cc5ea$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $5297880dd24cc5ea$var$getTextAlignForAngle(angle);
    const left = $5297880dd24cc5ea$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $5297880dd24cc5ea$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left , top: top , right: right , bottom: bottom  } = item;
    const apexesInArea = (0, $9bad38c73ebb867d$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $9bad38c73ebb867d$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $9bad38c73ebb867d$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $9bad38c73ebb867d$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $5297880dd24cc5ea$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels , display: display  } = opts.pointLabels;
    const itemOpts = {
        extra: $5297880dd24cc5ea$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $9bad38c73ebb867d$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $5297880dd24cc5ea$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === "auto") {
            item.visible = $5297880dd24cc5ea$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $5297880dd24cc5ea$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return "center";
    else if (angle < 180) return "left";
    return "right";
}
function $5297880dd24cc5ea$var$leftForTextAlign(x, w, align) {
    if (align === "right") x -= w;
    else if (align === "center") x -= w / 2;
    return x;
}
function $5297880dd24cc5ea$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $5297880dd24cc5ea$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left , top: top , right: right , bottom: bottom  } = item;
    const { backdropColor: backdropColor  } = opts;
    if (!(0, $9bad38c73ebb867d$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $9bad38c73ebb867d$export$92108d983e8ee699)(opts.borderRadius);
        const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $9bad38c73ebb867d$export$1fbe638ecf81657e)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $5297880dd24cc5ea$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx , options: { pointLabels: pointLabels  }  } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $5297880dd24cc5ea$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x , y: y , textAlign: textAlign  } = item;
        (0, $9bad38c73ebb867d$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: "middle"
        });
    }
}
function $5297880dd24cc5ea$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx  } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $9bad38c73ebb867d$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $5297880dd24cc5ea$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color , lineWidth: lineWidth  } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $5297880dd24cc5ea$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $5297880dd24cc5ea$var$createPointLabelContext(parent, index, label) {
    return (0, $9bad38c73ebb867d$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: "pointLabel"
    });
}
class $5297880dd24cc5ea$export$cfafc36d95386d38 extends $5297880dd24cc5ea$var$LinearScaleBase {
    static id = "radialLinear";
    static defaults = {
        display: true,
        animate: true,
        position: "chartArea",
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $9bad38c73ebb867d$export$91477dc880baac21).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        "angleLines.color": "borderColor",
        "pointLabels.color": "color",
        "ticks.color": "color"
    };
    static descriptors = {
        angleLines: {
            _fallback: "grid"
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)($5297880dd24cc5ea$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min , max: max  } = this.getMinMax(false);
        this.min = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $5297880dd24cc5ea$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $5297880dd24cc5ea$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : "";
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $5297880dd24cc5ea$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $9bad38c73ebb867d$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $9bad38c73ebb867d$export$28f7fcd39efa255)(index * angleMultiplier + (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $5297880dd24cc5ea$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $9bad38c73ebb867d$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left , top: top , right: right , bottom: bottom  } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor , grid: { circular: circular  }  } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $5297880dd24cc5ea$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines , grid: grid , border: border  } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $5297880dd24cc5ea$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $5297880dd24cc5ea$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color , lineWidth: lineWidth  } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $9bad38c73ebb867d$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $9bad38c73ebb867d$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $9bad38c73ebb867d$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $5297880dd24cc5ea$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $5297880dd24cc5ea$var$UNITS = /* #__PURE__ */ Object.keys($5297880dd24cc5ea$var$INTERVALS);
function $5297880dd24cc5ea$var$sorter(a, b) {
    return a - b;
}
function $5297880dd24cc5ea$var$parse(scale, input) {
    if ((0, $9bad38c73ebb867d$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser , round: round , isoWeekday: isoWeekday  } = scale._parseOpts;
    let value = input;
    if (typeof parser === "function") value = parser(value);
    if (!(0, $9bad38c73ebb867d$export$39b482c5e57630a8)(value)) value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === "week" && ((0, $9bad38c73ebb867d$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $5297880dd24cc5ea$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $5297880dd24cc5ea$var$UNITS.length;
    for(let i = $5297880dd24cc5ea$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $5297880dd24cc5ea$var$INTERVALS[$5297880dd24cc5ea$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $5297880dd24cc5ea$var$UNITS[i];
    }
    return $5297880dd24cc5ea$var$UNITS[ilen - 1];
}
function $5297880dd24cc5ea$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $5297880dd24cc5ea$var$UNITS.length - 1; i >= $5297880dd24cc5ea$var$UNITS.indexOf(minUnit); i--){
        const unit = $5297880dd24cc5ea$var$UNITS[i];
        if ($5297880dd24cc5ea$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $5297880dd24cc5ea$var$UNITS[minUnit ? $5297880dd24cc5ea$var$UNITS.indexOf(minUnit) : 0];
}
function $5297880dd24cc5ea$var$determineMajorUnit(unit) {
    for(let i = $5297880dd24cc5ea$var$UNITS.indexOf(unit) + 1, ilen = $5297880dd24cc5ea$var$UNITS.length; i < ilen; ++i){
        if ($5297880dd24cc5ea$var$INTERVALS[$5297880dd24cc5ea$var$UNITS[i]].common) return $5297880dd24cc5ea$var$UNITS[i];
    }
}
function $5297880dd24cc5ea$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo , hi: hi  } = (0, $9bad38c73ebb867d$export$2ed0fc6709e59212)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $5297880dd24cc5ea$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $5297880dd24cc5ea$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $5297880dd24cc5ea$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $5297880dd24cc5ea$export$a894c72689ff3ec extends $5297880dd24cc5ea$export$d60cfc58d3c358b6 {
    static id = "time";
    static defaults = {
        bounds: "data",
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: "millisecond",
            displayFormats: {}
        },
        ticks: {
            source: "auto",
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = "day";
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $5297880dd24cc5ea$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $9bad38c73ebb867d$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $5297880dd24cc5ea$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || "day";
        let { min: min , max: max , minDefined: minDefined , maxDefined: maxDefined  } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== "ticks" || options.ticks.source !== "labels") _applyBounds(this.getMinMax(false));
        }
        min = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $9bad38c73ebb867d$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === "ticks" && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $9bad38c73ebb867d$export$c03999cb2f36933f)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $5297880dd24cc5ea$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $5297880dd24cc5ea$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? undefined : $5297880dd24cc5ea$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $5297880dd24cc5ea$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $9bad38c73ebb867d$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $5297880dd24cc5ea$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $9bad38c73ebb867d$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === "week" ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $9bad38c73ebb867d$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, "isoWeek", weekday);
        first = +adapter.startOf(first, hasWeekday ? "day" : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
        const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$5297880dd24cc5ea$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === "ticks" || count === 1) $5297880dd24cc5ea$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort((a, b)=>a - b).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $9bad38c73ebb867d$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $9bad38c73ebb867d$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $5297880dd24cc5ea$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($5297880dd24cc5ea$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $9bad38c73ebb867d$export$71511d61b312f219)(values.sort($5297880dd24cc5ea$var$sorter));
    }
}
function $5297880dd24cc5ea$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo , hi: hi  } = (0, $9bad38c73ebb867d$export$ef35774e6d314e91)(table, "pos", val));
        ({ pos: prevSource , time: prevTarget  } = table[lo]);
        ({ pos: nextSource , time: nextTarget  } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo , hi: hi  } = (0, $9bad38c73ebb867d$export$ef35774e6d314e91)(table, "time", val));
        ({ time: prevSource , pos: prevTarget  } = table[lo]);
        ({ time: nextSource , pos: nextTarget  } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $5297880dd24cc5ea$export$85df64a8eb6dc986 extends $5297880dd24cc5ea$export$a894c72689ff3ec {
    static id = "timeseries";
    static defaults = $5297880dd24cc5ea$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $5297880dd24cc5ea$var$interpolate(table, this.min);
        this._tableRange = $5297880dd24cc5ea$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min , max: max  } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($5297880dd24cc5ea$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $5297880dd24cc5ea$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $5297880dd24cc5ea$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $5297880dd24cc5ea$export$29e663ba4d09fe7,
    LinearScale: $5297880dd24cc5ea$export$e7f4e5e8656f0b93,
    LogarithmicScale: $5297880dd24cc5ea$export$85295eaf7cb3ac3e,
    RadialLinearScale: $5297880dd24cc5ea$export$cfafc36d95386d38,
    TimeScale: $5297880dd24cc5ea$export$a894c72689ff3ec,
    TimeSeriesScale: $5297880dd24cc5ea$export$85df64a8eb6dc986
});
const $5297880dd24cc5ea$export$e8959e79e3af550f = [
    $5297880dd24cc5ea$export$a6506504f799c5d5,
    $5297880dd24cc5ea$export$7a5d735b2ab6389d,
    $5297880dd24cc5ea$export$8b3ca321c77fdea6,
    $5297880dd24cc5ea$export$bcac1c16f1530ec2
];


(0, $5297880dd24cc5ea$export$acaa6426d77a227e).register(...(0, $5297880dd24cc5ea$export$e8959e79e3af550f));
var $954e8aaaef9a8f94$export$2e2bcd8739ae039 = (0, $5297880dd24cc5ea$export$acaa6426d77a227e);















var $g5BLJ = parcelRequire("g5BLJ");






var $g5BLJ = parcelRequire("g5BLJ");








var $g5BLJ = parcelRequire("g5BLJ");






const $cb4888a7efbc2790$export$8dbb20f2bd92e70f = (change)=>`${Math.abs(change * 100).toFixed(1)}%`;
const $cb4888a7efbc2790$export$3be14461f103972e = ({ submission: s  })=>Math.ceil(Date.parse(s.finishedAt) / (0, $73b0620564a5efc3$export$750abf5956643c1a)) * (0, $73b0620564a5efc3$export$750abf5956643c1a);
const $cb4888a7efbc2790$export$147c4fe28b21c4c5 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const dateLabel = query.get("selectedTime") || "Last 7 Days";
    const dateOption = (0, $97971de7222d1c39$export$7f608b480d9e7085)[dateLabel];
    return {
        dateLabel: dateLabel,
        dateOption: dateOption.value.start,
        datePrev: dateOption.prev
    };
};
const $cb4888a7efbc2790$export$2bb1426558579a57 = ()=>{
    const sr = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.StudentProgressMonitoringData.submissionResults, []);
    return (0, $g5BLJ.useMemo)(()=>sr.filter(({ submission: s  })=>s.finishedAt).groupBy($cb4888a7efbc2790$export$3be14461f103972e).toMap(), [
        sr
    ]);
};
const $cb4888a7efbc2790$export$9e0a7047517708af = (group, assessmentMap, getter)=>group.toList().map((sr)=>({
            name: assessmentMap.get(sr.assessmentId)?.name,
            submissionId: sr.submission.id,
            finishedAt: sr.submission.finishedAt,
            contentType: sr.contentType,
            ...getter(sr)
        }));
const $cb4888a7efbc2790$export$ef5518122137f023 = (data, startDate)=>data.filter((_, key)=>new Date(key) > ((0, $73b0620564a5efc3$export$629b0a497aa65267)(startDate) ? (0, $73b0620564a5efc3$export$dd412b56f1e4d8aa)(startDate, -1) : startDate ?? 0)).sortBy((_v, k)=>k).mapKeys((k)=>(0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(k), {
            includeYear: true
        }));
const $cb4888a7efbc2790$export$a238cb463698c900 = (origin)=>Array.from(new Array(Math.max(Math.ceil((Date.now() - origin.getTime()) / (0, $73b0620564a5efc3$export$750abf5956643c1a)), 2))).map((_, idx, arr)=>(0, $73b0620564a5efc3$export$3ae94a2503e890a1)((0, $73b0620564a5efc3$export$dd412b56f1e4d8aa)(new Date(), 1 + idx - arr.length), {
            includeYear: true
        }));
const $cb4888a7efbc2790$export$783060840635baf5 = (ms)=>`${Math.floor(ms / (0, $73b0620564a5efc3$export$485c1a38db39db9b))}m ${Math.floor(ms % (0, $73b0620564a5efc3$export$485c1a38db39db9b) / (0, $73b0620564a5efc3$export$b4c0c30d7f4e2691))}s`;
const $cb4888a7efbc2790$export$69d8d19507872af6 = (startDate, submissionResults)=>{
    if (!startDate || startDate.getTime() === 0) return (0, $73b0620564a5efc3$export$dd412b56f1e4d8aa)(submissionResults.filter(({ submission: s  })=>s.finishedAt).map(({ submission: s  })=>new Date(s.finishedAt)).min() ?? new Date(), -1);
    else if (Date.now() - (startDate.getTime() ?? Date.now()) < (0, $73b0620564a5efc3$export$750abf5956643c1a)) return (0, $73b0620564a5efc3$export$dd412b56f1e4d8aa)(startDate, -1);
    return startDate;
};
const $cb4888a7efbc2790$export$82b89dab63ed731f = (startDate, data)=>data.filter((_, key)=>{
        const isBeforeStart = new Date(key) < (startDate ?? Infinity);
        return isBeforeStart || startDate && !(0, $73b0620564a5efc3$export$629b0a497aa65267)(startDate) && (0, $73b0620564a5efc3$export$ea39ec197993aef0)(startDate, new Date(key));
    }).sortBy((_, key)=>key).last(0);
const $cb4888a7efbc2790$export$1690e12b840569b9 = (ttm)=>{
    const rect = ttm.chart.canvas.getBoundingClientRect();
    return {
        left: `${rect.left + window.scrollX + ttm.caretX}px`,
        top: `${rect.top + window.scrollY + ttm.caretY}px`
    };
};
const $cb4888a7efbc2790$export$2292b015f66e146 = ({ excludeIndependent: excludeIndependent  })=>{
    const submissionResults = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.StudentProgressMonitoringData.submissionResults, []);
    const { dateOption: d  } = $cb4888a7efbc2790$export$147c4fe28b21c4c5();
    const sr = (0, $g5BLJ.useMemo)(()=>submissionResults.filter((s)=>!(excludeIndependent && s.contentType === "independent")), [
        submissionResults,
        excludeIndependent
    ]);
    return (0, $g5BLJ.useMemo)(()=>$cb4888a7efbc2790$export$69d8d19507872af6(d, sr), [
        d,
        sr
    ]);
};
const $cb4888a7efbc2790$export$b22ca96a1a22bfba = (obj)=>typeof obj === "object" && Boolean(obj);
const $cb4888a7efbc2790$export$d44c42759f372e2c = (obj, prop)=>Object.hasOwnProperty.call(obj, prop);
const $cb4888a7efbc2790$export$27649cd34d715801 = (obj, prop, type)=>$cb4888a7efbc2790$export$d44c42759f372e2c(obj, prop) && typeof obj[prop] === type;
const $cb4888a7efbc2790$export$4fdd4e4d863e47a3 = (obj)=>$cb4888a7efbc2790$export$b22ca96a1a22bfba(obj) && $cb4888a7efbc2790$export$27649cd34d715801(obj, "name", "string") && $cb4888a7efbc2790$export$27649cd34d715801(obj, "submissionId", "string") && $cb4888a7efbc2790$export$27649cd34d715801(obj, "finishedAt", "string");
const $cb4888a7efbc2790$export$9404510d070e9a44 = (map)=>map.map((y, x)=>({
            x: x,
            y: y
        })).valueSeq().toArray();
const $cb4888a7efbc2790$var$timeLabelSpacingMap = {
    Today: 1,
    "Last 7 Days": 2,
    "Last 30 Days": 4,
    "Current Academic Year": 5,
    "All Time": 10
};
const $cb4888a7efbc2790$var$plugins = {
    legend: {
        display: false
    },
    tooltip: {
        enabled: false,
        intersect: false,
        mode: "nearest",
        axis: "xy",
        callbacks: {
            label: (ctx)=>$cb4888a7efbc2790$export$b22ca96a1a22bfba(ctx.raw) && $cb4888a7efbc2790$export$d44c42759f372e2c(ctx.raw, "assignments") && (0, $3f9a4df32f03e33e$export$ead95ff48ba53ffd)(ctx.raw.assignments) ? ctx.raw?.assignments.map(()=>"").toArray() : []
        }
    }
};
const $cb4888a7efbc2790$export$b8ae39f344200a7d = ()=>{
    const { dateLabel: label  } = $cb4888a7efbc2790$export$147c4fe28b21c4c5();
    return (0, $g5BLJ.useMemo)(()=>{
        const scales = {
            x: {
                ticks: {
                    callback: (_, idx, ticks)=>idx % $cb4888a7efbc2790$var$timeLabelSpacingMap[label] ? "" : (0, $73b0620564a5efc3$export$3ae94a2503e890a1)((0, $73b0620564a5efc3$export$dd412b56f1e4d8aa)(new Date(), idx + 1 - ticks.length)),
                    minRotation: 45,
                    maxRotation: 45
                }
            }
        };
        return {
            scales: scales,
            parsing: false,
            normalized: true,
            plugins: $cb4888a7efbc2790$var$plugins,
            maintainAspectRatio: false,
            tension: 0.2
        };
    }, [
        label
    ]);
};
const $cb4888a7efbc2790$var$isPartialFontSpec = (scriptable)=>{
    return typeof scriptable !== "function" && typeof scriptable.family !== "function";
};
const $cb4888a7efbc2790$var$rawDataIsValid = (raw)=>$cb4888a7efbc2790$export$b22ca96a1a22bfba(raw) && $cb4888a7efbc2790$export$27649cd34d715801(raw, "x", "string");
const $cb4888a7efbc2790$export$72715278dc2ae8bc = (setTooltipProps, formatTooltipData)=>(ctx)=>{
        const ttm = ctx.tooltip;
        const position = $cb4888a7efbc2790$export$1690e12b840569b9(ttm);
        if (!$cb4888a7efbc2790$var$isPartialFontSpec(ttm.options.bodyFont)) return;
        if (ttm.opacity === 0) {
            setTooltipProps((p)=>({
                    ...p,
                    display: "none"
                }));
            return;
        }
        const raw = ttm.dataPoints[0]?.raw;
        if ($cb4888a7efbc2790$var$rawDataIsValid(raw)) {
            formatTooltipData(raw, ttm.dataPoints[0]?.datasetIndex ?? 0);
            setTooltipProps(()=>({
                    ...position,
                    display: "block",
                    xAlign: ttm.xAlign,
                    yAlign: ttm.yAlign
                }));
        }
    };
const $cb4888a7efbc2790$export$c0f34ddbfa39d154 = [
    {
        id: "meme",
        beforeEvent: (_chart, args)=>{
            const nativeEv = args.event.native;
            if (args.cancelable && nativeEv && args.event.type === "mouseout") {
                if (nativeEv.relatedTarget) {
                    const relatedTarget = nativeEv.relatedTarget;
                    return !(relatedTarget.matches((0, $309b3f47c9dc9b6b$export$64b703266355cdfb).toString()) || relatedTarget.closest((0, $309b3f47c9dc9b6b$export$64b703266355cdfb).toString()));
                }
            }
            return true;
        }
    }
];


const $309b3f47c9dc9b6b$export$ad3c2ee386592d19 = 240;
const $309b3f47c9dc9b6b$export$8ba719520b473d7d = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentProgressChartComponents__GraphContainer",
    componentId: "sc-1sawyh0-0"
})([
    "background:",
    ";border-radius:",
    ";padding:",
    ";width:",
    ";margin-bottom:",
    ";"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], ({ $width: $width = "100%"  })=>$width, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]);
const $309b3f47c9dc9b6b$var$statChange = (stat, change)=>{
    if (stat === "time_read") return (change || 0) < 0 ? "less" : "more";
    return (change || 0) < 0 ? "slower" : "faster";
};
const $309b3f47c9dc9b6b$export$3b3fcb46d934e77c = ({ label: label , stat: stat  })=>{
    const { stats: stats , prevStats: prevStats , user: user  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            stats: s.stats,
            prevStats: s.prevStats,
            user: s.user
        }), []);
    const { datePrev: datePrev  } = (0, $cb4888a7efbc2790$export$147c4fe28b21c4c5)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const current = stats.find((el)=>el.name === stat)?.value || 0;
    const prev = prevStats.find((el)=>el.name === stat)?.value || 0;
    const percentChange = prev ? (current - prev) / prev : null;
    const prevValue = datePrev && prev ? `Prev. ${(prev || 0).toFixed(1)}` : null;
    const dateLabel = query.get("selectedTime");
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h2",
                        testTag: `${stat}-value`,
                        children: stat === "time_read" ? (0, $cb4888a7efbc2790$export$783060840635baf5)(current) : `${current.toFixed(1)} Avg`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 0,
                children: prevValue && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                    content: datePrev && `${user?.displayName} has read ${(0, $cb4888a7efbc2790$export$8dbb20f2bd92e70f)(percentChange || 0)} ${$309b3f47c9dc9b6b$var$statChange(stat, percentChange)} than they did ${dateLabel === "Current Academic Year" ? "last academic school year." : `between ${(0, $73b0620564a5efc3$export$3ae94a2503e890a1)(datePrev.start)} and ${(0, $73b0620564a5efc3$export$3ae94a2503e890a1)(datePrev.end)}.`}`,
                    display: "block",
                    disabled: !datePrev,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        align: "end",
                        children: [
                            percentChange && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h3",
                                        testTag: `${stat}-percent-change`,
                                        children: (0, $cb4888a7efbc2790$export$8dbb20f2bd92e70f)(percentChange)
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2,
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                        icon: percentChange > 0 ? "increase" : "decrease",
                                        strokeWidth: 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                testTag: `${stat}-prev`,
                                children: [
                                    "Prev. ",
                                    stat === "time_read" ? (0, $cb4888a7efbc2790$export$783060840635baf5)(prev) : `${prev.toFixed(1)} Avg`
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
const $309b3f47c9dc9b6b$var$xAlignTransforms = {
    right: `translateX(-100%) translateX(-${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]})`,
    // this is weird because of chart.js
    center: `translateX(-50%) translateX(-${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]})`,
    left: `translateX(${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]})`
};
const $309b3f47c9dc9b6b$var$yAlignTransform = {
    bottom: `translateY(-100%) translateY(-${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]})`,
    center: `translateY(-50%) translateY(-${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]})`,
    top: "translateY(0)"
};
const $309b3f47c9dc9b6b$export$64b703266355cdfb = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentProgressChartComponents__ChartTooltipContainer",
    componentId: "sc-1sawyh0-1"
})([
    "max-width:260px;max-height:160px;overflow-y:auto;position:absolute;top:",
    ";left:",
    ";padding:",
    ";background-color:",
    ";border-radius:",
    ";display:",
    ";box-shadow:",
    ";transform:",
    ";"
], (p)=>p.$top, (p)=>p.$left, (0, $8259eb090983b778$export$ea413736286a3bf1)[3], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (p)=>p.$display, (0, $d65f64e8cabd56af$export$147720d44c0eeb27).standard, (p)=>`${$309b3f47c9dc9b6b$var$xAlignTransforms[p.$xAlign]} ${$309b3f47c9dc9b6b$var$yAlignTransform[p.$yAlign]}`);
const $309b3f47c9dc9b6b$export$56e790e66e4f8ae1 = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "StudentProgressChartComponents__TooltipContentContainer",
    componentId: "sc-1sawyh0-2"
})([
    "padding:",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[2]);
const $309b3f47c9dc9b6b$var$UnmemoizedChartTooltip = ({ tooltipStateSetter: tooltipStateSetter , ...props })=>{
    const mouseLeaveHandler = (0, $g5BLJ.useCallback)((ev)=>{
        const relatedTarget = ev.relatedTarget;
        if (!relatedTarget?.matches?.("canvas")) tooltipStateSetter((tt)=>({
                ...tt,
                display: "none"
            }));
    }, [
        tooltipStateSetter
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $121c3b2afc84f041$export$361769c4f906e73b), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($309b3f47c9dc9b6b$export$64b703266355cdfb, {
            $top: props.top,
            $left: props.left,
            $display: props.display,
            $xAlign: props.xAlign,
            $yAlign: props.yAlign,
            onMouseLeave: mouseLeaveHandler,
            children: props.children
        })
    });
};
const $309b3f47c9dc9b6b$export$1190a21963505760 = /*#__PURE__*/ (0, $g5BLJ.memo)($309b3f47c9dc9b6b$var$UnmemoizedChartTooltip);
const $309b3f47c9dc9b6b$export$11cfa98fd8572b86 = ({ submissionId: submissionId  })=>{
    const userId = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)().userId;
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {
        style: {
            pointerEvents: "auto"
        },
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
            to: `/submissions/${submissionId}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                backPath: `/t/progress-monitoring/${userId}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
            }))}`,
            children: [
                "View Submission ",
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                    icon: "arrowRight",
                    color: "readleeBlue"
                })
            ]
        })
    });
};
const $309b3f47c9dc9b6b$export$c92f8b17a6e05251 = {
    fall: "November 30",
    winter: "February 28",
    spring: "July 23"
};
const $309b3f47c9dc9b6b$var$wcpmStandards = [
    false,
    {
        fall: {
            min: 0,
            max: 8
        },
        winter: {
            min: 29,
            max: 58
        },
        spring: {
            min: 60,
            max: 90
        }
    },
    {
        fall: {
            min: 50,
            max: 83
        },
        winter: {
            min: 84,
            max: 108
        },
        spring: {
            min: 100,
            max: 123
        }
    },
    {
        fall: {
            min: 83,
            max: 103
        },
        winter: {
            min: 97,
            max: 136
        },
        spring: {
            min: 112,
            max: 138
        }
    },
    {
        fall: {
            min: 94,
            max: 124
        },
        winter: {
            min: 120,
            max: 142
        },
        spring: {
            min: 133,
            max: 159
        }
    },
    {
        fall: {
            min: 121,
            max: 140
        },
        winter: {
            min: 133,
            max: 170
        },
        spring: {
            min: 146,
            max: 170
        }
    }
];
const $309b3f47c9dc9b6b$export$fef151b94550e9f5 = (gradeLevel, seasonOpt)=>{
    const sample = $309b3f47c9dc9b6b$var$wcpmStandards[gradeLevel];
    if (sample) {
        const season = seasonOpt ?? (0, $73b0620564a5efc3$export$2e8f853eec105774)();
        return sample[season];
    } else return {
        min: 146
    };
};
const $309b3f47c9dc9b6b$export$e7e603fcfe95ef16 = (gradeLevel, seasonOpt)=>{
    const range = $309b3f47c9dc9b6b$export$fef151b94550e9f5(gradeLevel, seasonOpt);
    return `${range.min}${"max" in range ? `-${range.max}` : ""}+`;
};
const $309b3f47c9dc9b6b$export$fd83d96d4e1a52bd = ({ label: label , tooltip: tooltip , testTag: testTag  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: tooltip,
        lineHeight: "130%",
        maxWidthOverride: 450,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            variant: "h3",
            testTag: `${testTag}-label`,
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {
                        children: label
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    " ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                        icon: "info"
                    })
                ]
            })
        })
    });
const $309b3f47c9dc9b6b$export$1f3a67491eefba2 = /*#__PURE__*/ (0, $g5BLJ.memo)($309b3f47c9dc9b6b$export$fd83d96d4e1a52bd);





var $g5BLJ = parcelRequire("g5BLJ");

var $g5BLJ = parcelRequire("g5BLJ");

const $be5a01be92839536$var$defaultDatasetIdKey = "label";
function $be5a01be92839536$var$reforwardRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $be5a01be92839536$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $be5a01be92839536$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $be5a01be92839536$var$setDatasets(currentData, nextDatasets) {
    let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $be5a01be92839536$var$defaultDatasetIdKey;
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $be5a01be92839536$var$cloneData(data) {
    let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $be5a01be92839536$var$defaultDatasetIdKey;
    const nextData = {
        labels: [],
        datasets: []
    };
    $be5a01be92839536$var$setLabels(nextData, data.labels);
    $be5a01be92839536$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $be5a01be92839536$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "dataset", {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $be5a01be92839536$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "nearest", {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $be5a01be92839536$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, "index", {
        intersect: true
    }, false);
}
function $be5a01be92839536$var$ChartComponent(props, ref) {
    const { height: height = 150 , width: width = 300 , redraw: redraw = false , datasetIdKey: datasetIdKey , type: type , data: data , options: options , plugins: plugins = [] , fallbackContent: fallbackContent , updateMode: updateMode , ...canvasProps } = props;
    const canvasRef = (0, $g5BLJ.useRef)(null);
    const chartRef = (0, $g5BLJ.useRef)();
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $5297880dd24cc5ea$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $be5a01be92839536$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $be5a01be92839536$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $be5a01be92839536$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $g5BLJ.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $be5a01be92839536$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!redraw && chartRef.current) $be5a01be92839536$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $be5a01be92839536$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement("canvas", Object.assign({
        ref: canvasRef,
        role: "img",
        height: height,
        width: width
    }, canvasProps), fallbackContent);
}
const $be5a01be92839536$export$acaa6426d77a227e = /*#__PURE__*/ (0, $g5BLJ.forwardRef)($be5a01be92839536$var$ChartComponent);
function $be5a01be92839536$var$createTypedChart(type, registerables) {
    (0, $5297880dd24cc5ea$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $g5BLJ.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5BLJ))).createElement($be5a01be92839536$export$acaa6426d77a227e, Object.assign({}, props, {
            ref: ref,
            type: type
        })));
}
const $be5a01be92839536$export$17d680238e50603e = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("line", (0, $5297880dd24cc5ea$export$3c9b5d28c11cbfd0));
const $be5a01be92839536$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("bar", (0, $5297880dd24cc5ea$export$e97d5dc64e999004));
const $be5a01be92839536$export$bace472c466fdd25 = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("radar", (0, $5297880dd24cc5ea$export$48dbc6ac651bf8be));
const $be5a01be92839536$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("doughnut", (0, $5297880dd24cc5ea$export$e04603e7d8b77172));
const $be5a01be92839536$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("polarArea", (0, $5297880dd24cc5ea$export$2a270b3a0d973c85));
const $be5a01be92839536$export$646feb54fbadbe06 = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("bubble", (0, $5297880dd24cc5ea$export$19b5c4773f17abe));
const $be5a01be92839536$export$2ae8800cf67c848c = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("pie", (0, $5297880dd24cc5ea$export$b21a3f1286706191));
const $be5a01be92839536$export$1c460fb4285edadc = /* #__PURE__ */ $be5a01be92839536$var$createTypedChart("scatter", (0, $5297880dd24cc5ea$export$b2f2bae6713db87));





const $05cb8afcf5fbe1d0$export$c346d1f4081fda47 = ({ datasetIdKey: datasetIdKey , data: data , maxValue: maxValue , tooltipPropsHandler: tooltipPropsHandler  })=>{
    const baseOptions = (0, $cb4888a7efbc2790$export$b8ae39f344200a7d)();
    const options = (0, $g5BLJ.useMemo)(()=>({
            ...baseOptions,
            scales: {
                ...baseOptions.scales,
                y: {
                    min: 0,
                    max: maxValue
                }
            },
            parsing: false,
            normalized: true,
            plugins: {
                ...baseOptions.plugins,
                tooltip: {
                    ...baseOptions.plugins.tooltip,
                    external: tooltipPropsHandler
                }
            }
        }), [
        baseOptions,
        maxValue,
        tooltipPropsHandler
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be5a01be92839536$export$17d680238e50603e), {
            datasetIdKey: datasetIdKey,
            data: data,
            options: options,
            plugins: (0, $cb4888a7efbc2790$export$c0f34ddbfa39d154),
            height: (0, $309b3f47c9dc9b6b$export$ad3c2ee386592d19)
        })
    });
};


const $7fa021ffce176ec5$var$isReadingTooltipData = (obj)=>(0, $cb4888a7efbc2790$export$4fdd4e4d863e47a3)(obj) && (0, $cb4888a7efbc2790$export$27649cd34d715801)(obj, "readingTime", "number") && (0, $cb4888a7efbc2790$export$27649cd34d715801)(obj, "totalTime", "number");
const $7fa021ffce176ec5$var$findTimeRead = (s)=>s.name === "time_read";
const $7fa021ffce176ec5$export$7ed63adc57d2802d = ()=>{
    const { submissionResults: submissionResults , assessmentMap: assessmentMap , stats: stats , setReadingTooltipData: setReadingTooltipData , setReadingTooltipProps: setReadingTooltipProps  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            submissionResults: s.submissionResults,
            assessmentMap: s.assessmentMap,
            stats: s.stats,
            setReadingTooltipData: s.setReadingTooltipData,
            setReadingTooltipProps: s.setReadingTooltipProps
        }), []);
    const { dateOption: startDate  } = (0, $cb4888a7efbc2790$export$147c4fe28b21c4c5)();
    const submissionResponses = (0, $cb4888a7efbc2790$export$2bb1426558579a57)();
    const durationData = (0, $g5BLJ.useMemo)(()=>submissionResponses.map((group)=>({
                totalTime: group.reduce((acc, { submission: s  })=>acc + s.timeRead, 0),
                assignments: (0, $cb4888a7efbc2790$export$9e0a7047517708af)(group, assessmentMap, (sr)=>({
                        readingTime: sr.submission.timeRead
                    }))
            })).map((item, key, self)=>{
            const totalPrevTime = self.reduce((acc, cur, k)=>k < key ? acc + cur.totalTime : acc, 0);
            const totalDaysTime = item.assignments.reduce((acc, cur)=>acc + cur.readingTime, 0);
            return {
                totalTime: totalPrevTime + totalDaysTime,
                assignments: item.assignments.map((a, _idx, assignments)=>({
                        ...a,
                        totalTime: assignments.reduce((acc, cur)=>Date.parse(cur.finishedAt) < Date.parse(a.finishedAt) ? acc + cur.readingTime : acc, totalPrevTime + a.readingTime)
                    }))
            };
        }), [
        submissionResponses,
        assessmentMap
    ]);
    const currentTimeRead = stats.find($7fa021ffce176ec5$var$findTimeRead)?.value || 0;
    const dataset = (0, $g5BLJ.useMemo)(()=>(0, $cb4888a7efbc2790$export$ef5518122137f023)(durationData, startDate).map((v)=>({
                ...v,
                totalGraphedTime: v.totalTime / (0, $73b0620564a5efc3$export$485c1a38db39db9b)
            })), [
        durationData,
        startDate
    ]);
    const data = (0, $g5BLJ.useMemo)(()=>{
        const origin = (0, $cb4888a7efbc2790$export$69d8d19507872af6)(startDate, submissionResults);
        return {
            labels: (0, $cb4888a7efbc2790$export$a238cb463698c900)(origin),
            datasets: [
                {
                    data: (0, $cb4888a7efbc2790$export$9404510d070e9a44)(dataset.map((el)=>el.totalTime / (0, $73b0620564a5efc3$export$485c1a38db39db9b))),
                    borderColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).readleeBlue,
                    backgroundColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).readleeBlue
                }
            ]
        };
    }, [
        dataset,
        startDate,
        submissionResults
    ]);
    const maxValue = (0, $g5BLJ.useMemo)(()=>currentTimeRead / (0, $73b0620564a5efc3$export$485c1a38db39db9b) * 10 / 9, [
        currentTimeRead
    ]);
    const tooltipHandler = (0, $g5BLJ.useMemo)(()=>(0, $cb4888a7efbc2790$export$72715278dc2ae8bc)(setReadingTooltipProps, (raw)=>{
            const items = dataset.get(raw.x)?.assignments.filter($7fa021ffce176ec5$var$isReadingTooltipData) ?? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)();
            setReadingTooltipData(items);
        }), [
        dataset,
        setReadingTooltipData,
        setReadingTooltipProps
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $309b3f47c9dc9b6b$export$8ba719520b473d7d), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$3b3fcb46d934e77c), {
                label: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$1f3a67491eefba2), {
                    label: "Total Time Read",
                    tooltip: "Cumulative time spent reading during the selected period",
                    testTag: "time_read-label"
                }),
                stat: "time_read"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $05cb8afcf5fbe1d0$export$c346d1f4081fda47), {
                datasetIdKey: "readingtime",
                data: data,
                maxValue: maxValue,
                tooltipPropsHandler: tooltipHandler
            })
        ]
    });
};








const $4555b5d0e1b5d537$var$ReadingTooltipContent = ({ name: name , readingTime: readingTime , submissionId: submissionId , finishedAt: finishedAt , totalTime: totalTime  })=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $309b3f47c9dc9b6b$export$56e790e66e4f8ae1), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h3",
                ellipsis: true,
                children: name
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "Total Time Read: ",
                    (0, $cb4888a7efbc2790$export$783060840635baf5)(totalTime)
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "Submission Time Read: ",
                    (0, $cb4888a7efbc2790$export$783060840635baf5)(readingTime)
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "Submission Date: ",
                    (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(finishedAt))
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$11cfa98fd8572b86), {
                submissionId: submissionId
            })
        ]
    });
};
const $4555b5d0e1b5d537$export$7d7f7c1ebaac506d = ()=>{
    const { readingTooltipProps: readingTooltipProps , readingTooltipData: readingTooltipData , setReadingTooltipProps: setReadingTooltipProps  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            readingTooltipProps: s.readingTooltipProps,
            readingTooltipData: s.readingTooltipData,
            setReadingTooltipProps: s.setReadingTooltipProps
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$1190a21963505760), {
        ...readingTooltipProps,
        tooltipStateSetter: setReadingTooltipProps,
        children: readingTooltipData.map((a)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($4555b5d0e1b5d537$var$ReadingTooltipContent, {
                ...a
            }, a.submissionId))
    });
};




var $g5BLJ = parcelRequire("g5BLJ");








const $e44985cb59eb8fd1$var$isTooltipSubmissionData = (obj)=>(0, $cb4888a7efbc2790$export$4fdd4e4d863e47a3)(obj) && (0, $cb4888a7efbc2790$export$27649cd34d715801)(obj, "wcpm", "number");
const $e44985cb59eb8fd1$var$transparent = "rgba(0,0,0,0)";
const $e44985cb59eb8fd1$var$gray5 = "rgba(0,0,0,.2)";
const $e44985cb59eb8fd1$var$standardsOptions = {
    borderColor: $e44985cb59eb8fd1$var$gray5,
    backgroundColor: $e44985cb59eb8fd1$var$gray5,
    pointBackgroundColor: $e44985cb59eb8fd1$var$transparent,
    pointBorderColor: $e44985cb59eb8fd1$var$transparent,
    borderDash: [
        6,
        6
    ]
};
const $e44985cb59eb8fd1$var$flatLine = (labels, wcpm)=>labels.map((l)=>({
            x: l,
            y: wcpm
        }));
const $e44985cb59eb8fd1$var$getStandards = (gradeLevel, labels, season)=>{
    const range = (0, $309b3f47c9dc9b6b$export$fef151b94550e9f5)(gradeLevel, season);
    const datasets = [
        {
            ...$e44985cb59eb8fd1$var$standardsOptions,
            label: "min",
            id: 1,
            data: $e44985cb59eb8fd1$var$flatLine(labels, range.min),
            fill: false
        },
        {
            ...$e44985cb59eb8fd1$var$standardsOptions,
            label: "max",
            id: 2,
            data: "max" in range ? $e44985cb59eb8fd1$var$flatLine(labels, range.max) : [],
            fill: {
                target: "-1",
                above: $e44985cb59eb8fd1$var$gray5,
                below: $e44985cb59eb8fd1$var$transparent
            }
        }
    ];
    return datasets;
};
const $e44985cb59eb8fd1$var$SeasonSelector = ()=>{
    const { season: season , setField: setField , user: user  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            season: s.season,
            setField: s.setField,
            user: s.user
        }), []);
    const onChange = (0, $g5BLJ.useCallback)((v)=>{
        if (user) $7026505adadcfc0e$export$8a8216c44337cd5(`progress-monitoring-season-${user.id}`, v.toString());
        setField("season")(v);
    }, [
        setField,
        user
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            " ",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                display: "inline",
                children: "by"
            }),
            " ",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                id: "selectSeason",
                name: "Select Season",
                displayType: "flat",
                display: "inline",
                value: season,
                onChange: onChange,
                options: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(Object.entries((0, $309b3f47c9dc9b6b$export$c92f8b17a6e05251)).map(([key, value])=>({
                        label: value,
                        value: key
                    })))
            })
        ]
    });
};
const $e44985cb59eb8fd1$var$gradeLevelOptions = (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
    {
        label: "1st Grade",
        value: 1
    },
    {
        label: "2nd Grade",
        value: 2
    },
    {
        label: "3rd Grade",
        value: 3
    },
    {
        label: "4th Grade",
        value: 4
    },
    {
        label: "5th Grade",
        value: 5
    },
    {
        label: "6th Grade+",
        value: 6
    }
]);
const $e44985cb59eb8fd1$var$StandardSelector = ()=>{
    const { gradeLevel: gradeLevel , season: season , setField: setField , user: user  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            gradeLevel: s.gradeLevel,
            season: s.season,
            user: s.user,
            setField: s.setField
        }), []);
    const onChange = (0, $g5BLJ.useCallback)((v)=>{
        if (user) $7026505adadcfc0e$export$8a8216c44337cd5(`progress-monitoring-gradeLevel-${user.id}`, v.toString());
        setField("gradeLevel")(v);
    }, [
        setField,
        user
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                display: "inline",
                children: "The national benchmark for"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                id: "selectGrade",
                name: "Select Grade Standards",
                display: "inline",
                displayType: "flat",
                value: gradeLevel,
                onChange: onChange,
                options: $e44985cb59eb8fd1$var$gradeLevelOptions
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                display: "inline",
                children: [
                    "is ",
                    (0, $309b3f47c9dc9b6b$export$e7e603fcfe95ef16)(gradeLevel, season),
                    " WCPM"
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true
            }),
            gradeLevel < 6 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e44985cb59eb8fd1$var$SeasonSelector, {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                display: "flex",
                lineHeight: "140%",
                content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    display: "inline",
                    newTab: true,
                    href: "https://readleesupport.zendesk.com/hc/en-us/articles/14128804631693",
                    children: "Learn more about this data"
                }),
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                    icon: "info",
                    strokeWidth: 2
                })
            })
        ]
    });
};
const $e44985cb59eb8fd1$export$838f942bc1360459 = ()=>{
    const { assessmentMap: assessmentMap , gradeLevel: gradeLevel , season: season , setWcpmTooltipData: setWcpmTooltipData , setWcpmTooltipProps: setWcpmTooltipProps  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            assessmentMap: s.assessmentMap,
            gradeLevel: s.gradeLevel,
            season: s.season,
            setWcpmTooltipData: s.setWcpmTooltipData,
            setWcpmTooltipProps: s.setWcpmTooltipProps
        }), []);
    const { dateOption: dateOption  } = (0, $cb4888a7efbc2790$export$147c4fe28b21c4c5)();
    const submissionResponses = (0, $cb4888a7efbc2790$export$2bb1426558579a57)();
    const wcpmData = (0, $g5BLJ.useMemo)(()=>submissionResponses.map((group)=>({
                wcpm: Math.round(group.reduce((acc, { submission: s  })=>acc + s.wcpm, 0) / group.count()),
                assignments: (0, $cb4888a7efbc2790$export$9e0a7047517708af)(group, assessmentMap, (sr)=>({
                        wcpm: Math.round(sr.submission.wcpm)
                    })).filter((r)=>r.contentType !== "independent")
            })).filter((item)=>item.assignments.count() > 0), [
        submissionResponses,
        assessmentMap
    ]);
    const origin = (0, $cb4888a7efbc2790$export$2292b015f66e146)({
        excludeIndependent: true
    });
    const graphData = (0, $g5BLJ.useMemo)(()=>(0, $cb4888a7efbc2790$export$ef5518122137f023)(wcpmData, dateOption), [
        wcpmData,
        dateOption
    ]);
    const standards = (0, $g5BLJ.useMemo)(()=>(0, $309b3f47c9dc9b6b$export$fef151b94550e9f5)(gradeLevel, season), [
        gradeLevel,
        season
    ]);
    const standardsGraph = (0, $g5BLJ.useMemo)(()=>$e44985cb59eb8fd1$var$getStandards(gradeLevel, (0, $cb4888a7efbc2790$export$a238cb463698c900)(origin), season), [
        gradeLevel,
        origin,
        season
    ]);
    const data = (0, $g5BLJ.useMemo)(()=>({
            labels: (0, $cb4888a7efbc2790$export$a238cb463698c900)(origin),
            datasets: [
                ...standardsGraph,
                {
                    label: "(WCPM)",
                    id: 3,
                    data: (0, $cb4888a7efbc2790$export$9404510d070e9a44)(graphData.map((v)=>v.wcpm)),
                    borderColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).readleeBlue,
                    backgroundColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).readleeBlue,
                    fill: false
                }
            ]
        }), [
        origin,
        standardsGraph,
        graphData
    ]);
    const maxValue = (0, $g5BLJ.useMemo)(()=>Math.max((graphData.maxBy((a)=>a.wcpm)?.wcpm ?? 0) + 10, ("max" in standards ? standards.max : standards.min) + 10), [
        graphData,
        standards
    ]);
    const tooltipHandler = (0, $g5BLJ.useMemo)(()=>(0, $cb4888a7efbc2790$export$72715278dc2ae8bc)(setWcpmTooltipProps, (raw, datasetIdx)=>{
            const items = datasetIdx === standardsGraph.length ? graphData.get(raw.x)?.assignments.filter($e44985cb59eb8fd1$var$isTooltipSubmissionData).map((el)=>({
                    ...el,
                    value: el.wcpm,
                    stat: "wcpm"
                })) ?? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)() : (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)();
            setWcpmTooltipData(items);
        }), [
        graphData,
        standardsGraph,
        setWcpmTooltipProps,
        setWcpmTooltipData
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $309b3f47c9dc9b6b$export$8ba719520b473d7d), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$3b3fcb46d934e77c), {
                label: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$1f3a67491eefba2), {
                    label: "WCPM",
                    tooltip: "Words Correct Per Minute (WCPM, Total Words Correct / Total Time Read) is shown for all assessments with an assigned reading.",
                    testTag: "wcpm"
                }),
                stat: "wcpm"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $05cb8afcf5fbe1d0$export$c346d1f4081fda47), {
                datasetIdKey: "wcpm",
                data: data,
                maxValue: maxValue,
                tooltipPropsHandler: tooltipHandler
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($e44985cb59eb8fd1$var$StandardSelector, {})
        ]
    });
};




var $g5BLJ = parcelRequire("g5BLJ");






const $64e123a426ba4d93$var$isTooltipSubmissionData = (obj)=>(0, $cb4888a7efbc2790$export$4fdd4e4d863e47a3)(obj) && (0, $cb4888a7efbc2790$export$27649cd34d715801)(obj, "wpm", "number");
const $64e123a426ba4d93$export$2aef95b255c235ce = ()=>{
    const { assessmentMap: assessmentMap , setWcpmTooltipProps: setWcpmTooltipProps , setWcpmTooltipData: setWcpmTooltipData  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            assessmentMap: s.assessmentMap,
            setWcpmTooltipProps: s.setWcpmTooltipProps,
            setWcpmTooltipData: s.setWcpmTooltipData
        }), []);
    const { dateOption: dateOption  } = (0, $cb4888a7efbc2790$export$147c4fe28b21c4c5)();
    const submissionResponses = (0, $cb4888a7efbc2790$export$2bb1426558579a57)();
    const wpmData = (0, $g5BLJ.useMemo)(()=>submissionResponses.map((group)=>({
                wpm: Math.round(group.reduce((acc, { submission: s  })=>acc + s.wpm, 0) / group.count()),
                assignments: (0, $cb4888a7efbc2790$export$9e0a7047517708af)(group, assessmentMap, (sr)=>({
                        wpm: Math.round(sr.submission.wpm)
                    }))
            })), [
        submissionResponses,
        assessmentMap
    ]);
    const origin = (0, $cb4888a7efbc2790$export$2292b015f66e146)({
        excludeIndependent: false
    });
    const graphData = (0, $g5BLJ.useMemo)(()=>(0, $cb4888a7efbc2790$export$ef5518122137f023)(wpmData, dateOption), [
        wpmData,
        dateOption
    ]);
    const data = (0, $g5BLJ.useMemo)(()=>({
            labels: (0, $cb4888a7efbc2790$export$a238cb463698c900)(origin),
            datasets: [
                {
                    label: "(WPM)",
                    id: 4,
                    data: (0, $cb4888a7efbc2790$export$9404510d070e9a44)(graphData.map((el)=>el.wpm)),
                    borderColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).readleeBlue,
                    backgroundColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).readleeBlue,
                    fill: false
                }
            ]
        }), [
        origin,
        graphData
    ]);
    const maxValue = (0, $g5BLJ.useMemo)(()=>(graphData.maxBy((a)=>a.wpm)?.wpm ?? 0) + 10, [
        graphData
    ]);
    const tooltipHandler = (0, $g5BLJ.useMemo)(()=>(0, $cb4888a7efbc2790$export$72715278dc2ae8bc)(setWcpmTooltipProps, (raw)=>{
            const items = graphData.get(raw.x)?.assignments.filter($64e123a426ba4d93$var$isTooltipSubmissionData).map((el)=>({
                    ...el,
                    value: el.wpm,
                    stat: "wpm"
                })) ?? (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)();
            setWcpmTooltipData(items);
        }), [
        graphData,
        setWcpmTooltipProps,
        setWcpmTooltipData
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $309b3f47c9dc9b6b$export$8ba719520b473d7d), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$3b3fcb46d934e77c), {
                label: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$1f3a67491eefba2), {
                    label: "WPM",
                    tooltip: "Words Per Minute (WPM, Total Words Said / Total Time Read) is shown for all assessments.",
                    testTag: "wpm"
                }),
                stat: "wpm"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $05cb8afcf5fbe1d0$export$c346d1f4081fda47), {
                datasetIdKey: "wpm",
                data: data,
                maxValue: maxValue,
                tooltipPropsHandler: tooltipHandler
            })
        ]
    });
};







const $5fdb6057227b7c7d$var$NationalStandardsTooltipContent = ()=>{
    const { gradeLevel: gradeLevel , season: season  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            gradeLevel: s.gradeLevel,
            season: s.season
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        children: [
            "The national benchmark for ",
            gradeLevel,
            " graders is ",
            (0, $309b3f47c9dc9b6b$export$e7e603fcfe95ef16)(gradeLevel, season),
            " WCPM by",
            " ",
            (0, $309b3f47c9dc9b6b$export$c92f8b17a6e05251)[season]
        ]
    });
};
const $5fdb6057227b7c7d$var$WcpmTooltipContent = ({ name: name , value: value , submissionId: submissionId , finishedAt: finishedAt , stat: stat  })=>{
    return value ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $309b3f47c9dc9b6b$export$56e790e66e4f8ae1), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h3",
                ellipsis: true,
                children: name
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    stat === "wpm" ? "WPM" : "WCPM",
                    ": ",
                    value
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "Submission Date: ",
                    (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(finishedAt))
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$11cfa98fd8572b86), {
                submissionId: submissionId
            })
        ]
    }) : null;
};
const $5fdb6057227b7c7d$export$59a12f0dbe4b73ad = ()=>{
    const { wcpmTooltipProps: wcpmTooltipProps , wcpmTooltipData: wcpmTooltipData , setWcpmTooltipProps: setWcpmTooltipProps  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            wcpmTooltipProps: s.wcpmTooltipProps,
            wcpmTooltipData: s.wcpmTooltipData,
            setWcpmTooltipProps: s.setWcpmTooltipProps
        }), []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $309b3f47c9dc9b6b$export$1190a21963505760), {
        ...wcpmTooltipProps,
        tooltipStateSetter: setWcpmTooltipProps,
        children: wcpmTooltipData.size ? wcpmTooltipData.map((a)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($5fdb6057227b7c7d$var$WcpmTooltipContent, {
                ...a
            }, a.submissionId)) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($5fdb6057227b7c7d$var$NationalStandardsTooltipContent, {})
    });
};




var $g5BLJ = parcelRequire("g5BLJ");






const $051fff5c145dbdfb$var$getAssessmentSubtext = (courseNames, assessment, canView)=>{
    if (!canView) return "Private Submission";
    if (courseNames) return courseNames;
    if (assessment.isFreeRead) return (0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(assessment.createdAt), {
        includeYear: true
    });
    return "";
};
const $051fff5c145dbdfb$var$Empty = ({ tooltipText: tooltipText  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
        content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            children: tooltipText
        }),
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            color: "black",
            children: "--"
        })
    });
const $051fff5c145dbdfb$export$d3e39749caa9b13e = ({ rows: rows  })=>{
    const { assessmentMap: assessmentMap , courseMap: courseMap , assessmentToCourseMap: assessmentToCourseMap  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ StudentProgressMonitoringData: s  })=>({
            assessmentMap: s.assessmentMap,
            courseMap: s.courseMap,
            assessmentToCourseMap: s.assessmentToCourseMap
        }), []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const studentId = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)().userId;
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const columns = (0, $g5BLJ.useMemo)(()=>[
            {
                id: "assignment",
                name: "Assignment",
                render: ({ assessmentId: assessmentId , canView: canView , readingName: readingName  })=>{
                    const assessment = assessmentMap.get(assessmentId);
                    if (!assessment) return null;
                    const assessmentCourses = assessmentToCourseMap.get(assessment.id);
                    const courseNames = assessmentCourses?.map((ac)=>courseMap.get(ac)?.name).filter(Boolean).join(", ");
                    const subtext = $051fff5c145dbdfb$var$getAssessmentSubtext(courseNames, assessment, canView);
                    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$1cd1efc78cb52ca5), {
                                src: assessment.coverImageUrl,
                                title: readingName
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 4,
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                direction: "column",
                                maxWidth: "250px",
                                justify: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        align: "center",
                                        children: [
                                            assessment.isUltimate && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                height: "100%",
                                                padding: "0 5px 0 0",
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                                    content: "Upgraded to Ultimate Assignment",
                                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                        icon: "ultimateAssignmentCentered",
                                                        size: "1.25em",
                                                        testTag: "ultimate-assessment"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h6",
                                                ellipsis: true,
                                                title: assessment.name,
                                                testTag: "assessment-name",
                                                children: assessment.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                                        disabled: canView,
                                        content: "You cannot view this submission because it belongs to another teacher",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h7",
                                            color: "gray5",
                                            title: subtext,
                                            ellipsis: true,
                                            children: subtext
                                        })
                                    })
                                ]
                            })
                        ]
                    });
                },
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ assessmentId: assessmentId  })=>assessmentMap.get(assessmentId, {
                        name: ""
                    }).name
            },
            {
                id: "completion",
                name: "Completion",
                render: ({ submission: submission , contentType: contentType  })=>contentType === "independent" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($051fff5c145dbdfb$var$Empty, {
                        tooltipText: "Cannot calculate completion for independent readings."
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, submission.percentRead)
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ submission: submission  })=>submission.percentRead ?? 0
            },
            {
                id: "wordsCorrectPerMinute",
                name: "WCPM",
                tooltipContent: "Words Correct Per Minute (Total Words Correct / Total Time Read)",
                render: ({ submission: submission , contentType: contentType  })=>contentType === "independent" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($051fff5c145dbdfb$var$Empty, {
                        tooltipText: "Cannot calculate WCPM for independent readings"
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, submission.wcpm)
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ submission: submission , contentType: contentType  })=>contentType === "independent" ? submission.wcpm ?? 0 : 0
            },
            {
                id: "wordsPerMinute",
                name: "WPM",
                tooltipContent: "Words Per Minute (Total Words / Total Time Read)",
                render: ({ submission: submission  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, submission.wpm)
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ submission: submission  })=>submission.wpm ?? 0
            },
            {
                id: "words",
                name: "Words Read",
                render: ({ submission: submission  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words, submission.totalWords) ?? 0
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ submission: submission  })=>submission.totalWords ?? 0
            },
            {
                id: "time",
                name: "Time",
                render: ({ submission: submission  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, submission.timeRead)
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ submission: submission  })=>submission.timeRead ?? 0
            },
            {
                id: "tasks",
                name: "Tasks",
                render: (result)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        children: [
                            result.completedTasksCount ?? 0,
                            " / ",
                            result.totalTasksCount ?? 0
                        ]
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ completedTasksCount: completedTasksCount  })=>completedTasksCount ?? 0
            },
            {
                id: "updatedAt",
                name: "Student Edited",
                render: ({ submission: submission  })=>submission.updatedAt ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h6",
                        testTag: "student-edited",
                        children: (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(submission.updatedAt))
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($051fff5c145dbdfb$var$Empty, {
                        tooltipText: "Student has not submitted their assignment."
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ submission: submission  })=>new Date(submission.updatedAt).valueOf()
            },
            {
                id: "submittedAt",
                name: "Turned In",
                textAlign: "left",
                render: ({ submission: submission  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        justify: "center",
                        children: submission.finishedAt ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a31343b90c9d3d88$export$28c660c63b792dea), {
                            content: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: [
                                    "Student turned in their assignment on",
                                    " ",
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("b", {
                                        "data-test-tag": "submitted-at",
                                        children: (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(submission.finishedAt))
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                icon: "checkmark",
                                color: "success",
                                fill: true,
                                testTag: "submitted"
                            })
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($051fff5c145dbdfb$var$Empty, {
                            tooltipText: "Student has not submitted their assignment."
                        })
                    }),
                sortType: "sortBy",
                defaultSortDirection: "desc",
                sortBy: ({ submission: submission  })=>new Date(submission.finishedAt).valueOf()
            }
        ], [
        assessmentMap,
        assessmentToCourseMap,
        courseMap
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
        columns: columns,
        rows: rows,
        getRowId: ({ submission: submission  })=>submission.id,
        queryParam: "sortBy",
        rowClickable: ({ canView: canView  })=>canView,
        onRowClick: ({ submission: submission  })=>history.push(`/submissions/${submission.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)({
                backPath: `/t/progress-monitoring/${studentId}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
            }))}`),
        initialSortSettings: {
            columnId: "submittedAt",
            sortDirection: "desc"
        },
        emptyStateContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
            kind: "emptyStudentProgress"
        })
    });
};
const $051fff5c145dbdfb$export$d730a2a97bde9950 = /*#__PURE__*/ (0, $g5BLJ.memo)($051fff5c145dbdfb$export$d3e39749caa9b13e);





var $9bcea984281f0cdc$exports = {};

$9bcea984281f0cdc$exports = new URL((parcelRequire("3TfdU")).resolve("4Gzg5"), import.meta.url).toString();


var $b8453d324075a202$exports = {};

$b8453d324075a202$exports = new URL((parcelRequire("3TfdU")).resolve("lwIgm"), import.meta.url).toString();



const $f8dadc0bc1af6b2f$export$fce4ddddc53e9da3 = ()=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2],
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex,
                direction: "column",
                padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[4],
                testTag: "data-visualization-paywall",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h2",
                        textAlign: "center",
                        children: "Unlock Data Visualizations"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        textAlign: "center",
                        variant: "h4",
                        children: [
                            "Upgrade to ",
                            (0, $4ded3b2c5af96cca$export$52756c3ad45aa25c),
                            " to unlock insights for improving student achievement"
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            href: "https://www.readlee.com/contact",
                            width: "auto",
                            newTab: true,
                            children: "Contact Us!"
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        direction: "column",
                        align: "center",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($9bcea984281f0cdc$exports))),
                            style: {
                                width: "75%",
                                height: "auto"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        textAlign: "center",
                        variant: "h4",
                        children: "Monitor growth and track progress against national benchmarks"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 10
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        direction: "column",
                        align: "center",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b8453d324075a202$exports))),
                            style: {
                                width: "75%",
                                height: "auto"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        textAlign: "center",
                        variant: "h4",
                        children: "Track and celebrate your student's growing reading habits"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 22
            })
        ]
    });
};



const $1332d5cf233f1131$var$columnNames = [
    "Assignment",
    "Completion",
    "WCPM",
    "WPM",
    "Words Read",
    "Time",
    "Tasks",
    "Turned In"
];
const $1332d5cf233f1131$export$6d5b1fe761cbe354 = ()=>{
    const { load: load , loading: loading , stats: stats , user: user , courseMap: courseMap , submissionResults: submissionResults , assessmentMap: assessmentMap , assessmentToCourseMap: assessmentToCourseMap , teacherMap: teacherMap , search: search , setField: setField , currentPlan: currentPlan , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            load: s.StudentProgressMonitoringData.load,
            loading: s.StudentProgressMonitoringData.loading,
            stats: s.StudentProgressMonitoringData.stats,
            user: s.StudentProgressMonitoringData.user,
            courseMap: s.StudentProgressMonitoringData.courseMap,
            submissionResults: s.StudentProgressMonitoringData.submissionResults,
            assessmentMap: s.StudentProgressMonitoringData.assessmentMap,
            assessmentToCourseMap: s.StudentProgressMonitoringData.assessmentToCourseMap,
            teacherMap: s.StudentProgressMonitoringData.teacherMap,
            search: s.StudentProgressMonitoringData.search,
            setField: s.StudentProgressMonitoringData.setField,
            currentUser: s.AppData.currentUser,
            currentPlan: s.AppData.currentPlan
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const backPath = query.get("backPath");
    const studentId = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)().userId;
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const selectedClassParam = query.get("selectedCourseId") || "all";
    const selectedTimeLabelParam = query.get("selectedTime") || (0, $4ded3b2c5af96cca$export$5c806aff8bda9109)(currentPlan);
    const [dateRange, setDateRange] = (0, $g5BLJ.useState)(selectedTimeLabelParam);
    const startTime = (0, $g5BLJ.useMemo)(()=>(0, $97971de7222d1c39$export$7f608b480d9e7085)[dateRange].value?.start ?? null, [
        dateRange
    ]);
    const endTime = null;
    const prevStartTime = (0, $g5BLJ.useMemo)(()=>(0, $97971de7222d1c39$export$7f608b480d9e7085)[dateRange].prev?.start ?? null, [
        dateRange
    ]);
    const prevEndTime = (0, $g5BLJ.useMemo)(()=>(0, $97971de7222d1c39$export$7f608b480d9e7085)[dateRange].prev?.end ?? null, [
        dateRange
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        load(studentId, startTime, endTime, prevStartTime, prevEndTime, dateRange);
    }, [
        load,
        studentId,
        startTime,
        endTime,
        prevStartTime,
        prevEndTime,
        dateRange
    ]);
    const updateClassParam = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            selectedCourseId: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const updateTimeParam = (0, $g5BLJ.useCallback)((value)=>history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            selectedTime: value
        })}`), [
        history,
        pathname,
        query
    ]);
    const selectedClassOptions = (0, $g5BLJ.useMemo)(()=>(0, $d157168146708baf$export$5fd64473d0c0b9a5)(courseMap.toList(), teacherMap, currentUser), [
        teacherMap,
        courseMap,
        currentUser
    ]);
    const filteredResults = (0, $g5BLJ.useMemo)(()=>submissionResults.filter((result)=>{
            const assessment = assessmentMap.get(result.assessmentId);
            if (selectedClassParam === "all") return true;
            if (!assessment) return false;
            if (assessment.isFreeRead) return true;
            const assessmentCourses = assessmentToCourseMap.get(assessment.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
            if (assessmentCourses.isEmpty()) return false;
            if (selectedClassParam === "mine") return assessmentCourses.map((ac)=>courseMap.get(ac)?.creatorId).filter((creatorId)=>Boolean(creatorId) && creatorId === currentUser?.id).size > 0;
            return assessmentCourses.map((ac)=>courseMap.get(ac)?.id).filter(Boolean).includes(selectedClassParam);
        }), [
        submissionResults,
        selectedClassParam,
        assessmentMap,
        assessmentToCourseMap,
        courseMap,
        currentUser?.id
    ]);
    const studentData = (0, $g5BLJ.useMemo)(()=>filteredResults.map((submissionResponse)=>{
            return [
                assessmentMap.get(submissionResponse.assessmentId)?.name || "",
                submissionResponse.contentType === "independent" || submissionResponse.submission.percentRead === 0 ? "" : (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).completion, submissionResponse.submission.percentRead),
                submissionResponse.submission.wcpm === 0 ? "" : (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).wcpm, submissionResponse.submission.wcpm),
                submissionResponse.submission.totalWords === 0 ? "" : (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).total_words, submissionResponse.submission.totalWords),
                submissionResponse.submission.timeRead === 0 ? "" : (0, $3e76d4bc3268f884$export$252ba770fa56b422)((0, $3e76d4bc3268f884$export$b646428dfc4f79b1).time_taken, submissionResponse.submission.timeRead),
                !submissionResponse.completedTasksCount && !submissionResponse.totalTasksCount ? "" : `${submissionResponse.completedTasksCount ?? 0} / ${submissionResponse.totalTasksCount ?? 0}`,
                (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(submissionResponse.submission.finishedAt))
            ];
        }), [
        assessmentMap,
        filteredResults
    ]);
    const fileData = studentData.insert(0, $1332d5cf233f1131$var$columnNames);
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const hasCsvExport = Boolean(currentUser?.flags.isCsvExportEnabled);
    const TooltipElem = hasCsvExport ? (0, $a31343b90c9d3d88$export$28c660c63b792dea) : (0, $be64e7ee3b40f0c7$export$13c138588c4d3358);
    const tooltipProps = {
        content: hasCsvExport ? "Export Table as CSV" : `Upgrade to ${0, $4ded3b2c5af96cca$export$52756c3ad45aa25c} to seamlessly export all your data`,
        linkLocation: "contact"
    };
    const submissionRows = (0, $g5BLJ.useMemo)(()=>(0, $d5a1fd3dea1a0ab6$export$e3340ddcfe22553f)(search, filteredResults, (r)=>assessmentMap.get(r.assessmentId)?.name || ""), [
        search,
        filteredResults,
        assessmentMap
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                title: user?.displayName ?? "Student"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
                minWidth: 0,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                        minWidth: 0,
                        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} 0`,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                to: backPath || "/t/progress-monitoring",
                                icon: "backArrow",
                                color: "gray4",
                                children: "Back"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                        backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            width: "100%",
                            justify: "space-between",
                            align: "center",
                            wrap: "wrap",
                            margin: `-${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[8]} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h2",
                                        color: "white",
                                        testTag: "user-name",
                                        children: [
                                            loading && studentId !== user?.id ? "Loading..." : user?.displayName,
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9e0eec0a21547834$export$a3afbf2185482701), {
                                                user: user,
                                                isCurrent: false
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    justify: "end",
                                    margin: `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[2]} 0`,
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $97971de7222d1c39$export$5109c6dd95d8fb00), {
                                            value: dateRange,
                                            name: "assessmentDatePicker",
                                            onChange: (v)=>{
                                                setDateRange(v.label);
                                                updateTimeParam(v.label);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            horizontal: true,
                                            size: 2
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(TooltipElem, {
                                            enabled: true,
                                            ...tooltipProps,
                                            display: "flex",
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                                testTag: "export-csv-button",
                                                displayType: "iconOnly",
                                                icon: "download",
                                                color: "white",
                                                width: "70px",
                                                borderRadiusOverride: "2",
                                                disabled: !hasCsvExport,
                                                onClick: (0, $438c2fba1c8fa207$export$35193a8a641bb1b)({
                                                    data: fileData,
                                                    filename: `${user?.displayName}-progress-monitoring`,
                                                    fetchJson: fetchJson
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$408f6e7a7113feed), {
                        width: "100%",
                        height: "auto",
                        direction: "column",
                        align: "center",
                        padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[6],
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "column",
                            maxWidth: "900px",
                            width: "100%",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eb878214d715ad44$export$70a4f6c59796db88), {
                                stats: stats
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                        minWidth: 0,
                        minHeight: 0,
                        height: "100%",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                justify: "space-between",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6e3aa8aeb4209bd7$export$44c45b2b7f09d2a6), {
                                        tabs: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)([
                                            {
                                                id: "all",
                                                name: "Submissions"
                                            }
                                        ]),
                                        queryParam: "taskId"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        justify: "end",
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2511447d0cb3d32$export$55d7609a8f1eccd2), {
                                                value: search,
                                                onChange: setField("search"),
                                                placeholder: "Search Assignments"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 4
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                        icon: "filter",
                                                        color: "readleeBlue",
                                                        fill: selectedClassParam !== "all",
                                                        strokeWidth: 1.5,
                                                        strokeLinecap: "round"
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                        horizontal: true
                                                    }),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                                                        id: "sortBySelect",
                                                        displayType: "flat",
                                                        name: "Filter By Course",
                                                        value: selectedClassParam,
                                                        onChange: updateClassParam,
                                                        options: selectedClassOptions
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                                flex: true,
                                kind: "boat"
                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        direction: "column",
                                        overflowY: "auto",
                                        overflowX: "auto",
                                        grow: 1,
                                        maxHeight: "560px",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $051fff5c145dbdfb$export$d730a2a97bde9950), {
                                            rows: submissionRows
                                        })
                                    }),
                                    filteredResults.size > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                size: 8
                                            }),
                                            currentUser?.flags.isDataVisualizationEnabled ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("div", {
                                                "data-test-tag": "data-visualization-content",
                                                children: [
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7fa021ffce176ec5$export$7ed63adc57d2802d), {}),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e44985cb59eb8fd1$export$838f942bc1360459), {}),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $64e123a426ba4d93$export$2aef95b255c235ce), {}),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5fdb6057227b7c7d$export$59a12f0dbe4b73ad), {}),
                                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4555b5d0e1b5d537$export$7d7f7c1ebaac506d), {})
                                                ]
                                            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f8dadc0bc1af6b2f$export$fce4ddddc53e9da3), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 5
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");











var $g5BLJ = parcelRequire("g5BLJ");


const $cf7bafd1f1d50571$export$5aadc41d183ec7a6 = ()=>{
    const { startPaymentSession: startPaymentSession  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlanListData: PlanListData  })=>PlanListData, []);
    const { id: planId , paymentInterval: paymentInterval  } = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    (0, $g5BLJ.useEffect)(()=>{
        startPaymentSession(planId, paymentInterval)();
    }, [
        planId,
        paymentInterval,
        startPaymentSession
    ]);
    return null;
};




const $7f4114e3cb613038$var$PlanListContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PlanList__PlanListContainer",
    componentId: "sc-1akdwnl-0"
})([
    "",
    " background:",
    ";"
], (0, $dba6c5da69120483$export$6988a55f9afa8b34), (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex);
const $7f4114e3cb613038$var$PlansContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PlanList__PlansContainer",
    componentId: "sc-1akdwnl-1"
})([
    "display:flex;flex-wrap:wrap;margin:",
    " ",
    " ",
    " ",
    ";justify-content:center;"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none, (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[32], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4]);
const $7f4114e3cb613038$var$PlanBox = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PlanList__PlanBox",
    componentId: "sc-1akdwnl-2"
})([
    "flex:1;padding:",
    ";margin-right:",
    ";margin-bottom:",
    ";border-radius:",
    ";min-width:300px;max-width:375px;border:1px solid ",
    ";background:",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[8], ({ $last: $last  })=>$last ? (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none : (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4], ({ $last: $last  })=>$last ? (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none : (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[4], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $24b764039c44d1ec$export$8f45430ccf837300).gray2.hex, (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex);
const $7f4114e3cb613038$var$List = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).ul.withConfig({
    displayName: "PlanList__List",
    componentId: "sc-1akdwnl-3"
})([
    "margin:0;padding:0;padding-left:",
    ";"
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[6]);
const $7f4114e3cb613038$var$ListItem = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).li.withConfig({
    displayName: "PlanList__ListItem",
    componentId: "sc-1akdwnl-4"
})([
    ""
]);
const $7f4114e3cb613038$var$PricingContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "PlanList__PricingContainer",
    componentId: "sc-1akdwnl-5"
})([
    "min-height:220px;"
]);
const $7f4114e3cb613038$var$startPaymentSessionLink = (plan, paymentInterval)=>`/t/plans/${plan.id}/${paymentInterval}/create_session`;
const $7f4114e3cb613038$var$PlanButton = ({ plan: plan , currentUser: currentUser  })=>{
    const { plans: plans , startDowngrade: startDowngrade , currentPlan: currentPlan , currentSubscription: currentSubscription , creatingSession: creatingSession  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlanListData: PlanListData  })=>PlanListData, []);
    const isGrandfathered = plans.every((p)=>p.id !== plan.id);
    const comparison = (0, $4ded3b2c5af96cca$export$5504339c0acd1a00)(currentPlan || (0, $4ded3b2c5af96cca$export$fa35d849a2b6d142)(), plan);
    const currentPlanTag = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        disabled: true,
        testTag: "current-plan-tag",
        width: "100%",
        children: "Your Current Plan"
    });
    if (currentPlan?.isEnterprise) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            plan.id === currentPlan.id && currentPlanTag,
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Want to make a change?"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                newTab: true,
                href: "https://www.readlee.com/contact",
                width: "100%",
                children: "Chat With Us"
            })
        ]
    });
    if (plan.id === currentPlan?.id || plan.isBasicPlan && !currentPlan) {
        if (plan.isBasicPlan) return currentPlanTag;
        else if (currentSubscription?.status === "cancelled" && currentSubscription.isActivated) {
            const endsAt = new Date(currentSubscription.currentPeriodEndsAt);
            return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    currentPlanTag,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: [
                            "Your plan has been cancelled and will end on",
                            " ",
                            (0, $73b0620564a5efc3$export$3ae94a2503e890a1)(endsAt, {
                                includeYearIfNotCurrent: true
                            }),
                            " at ",
                            (0, $73b0620564a5efc3$export$3203edd9e5edd663)(endsAt),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        loading: creatingSession,
                        to: $7f4114e3cb613038$var$startPaymentSessionLink(plan, "month"),
                        width: "100%",
                        children: "Re-Activate"
                    })
                ]
            });
        } else if (isGrandfathered) return currentPlanTag;
        else {
            const isMonthly = currentSubscription?.paymentInterval === "month";
            return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    currentPlanTag,
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        loading: creatingSession,
                        to: $7f4114e3cb613038$var$startPaymentSessionLink(plan, isMonthly ? "annual" : "month"),
                        width: "100%",
                        children: [
                            "Switch to ",
                            isMonthly ? "Annual" : "Monthly",
                            " Payments"
                        ]
                    })
                ]
            });
        }
    } else if (plan.isEnterprise) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        href: "https://www.readlee.com/contact",
        width: "100%",
        newTab: true,
        children: "Contact Us!"
    });
    else if (plan.isBasicPlan) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
        children: currentSubscription?.status === "cancelled" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            children: [
                "Your plan has been cancelled and you will revert to the basic plan on",
                " ",
                (0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(currentSubscription.currentPeriodEndsAt), {
                    includeYearIfNotCurrent: true
                }),
                " ",
                "at ",
                (0, $73b0620564a5efc3$export$3203edd9e5edd663)(new Date(currentSubscription.currentPeriodEndsAt)),
                "."
            ]
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            loading: creatingSession,
            onClick: startDowngrade(plan),
            width: "100%",
            children: "Downgrade"
        })
    });
    else if (currentUser.trialMonthsAvailable) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        loading: creatingSession,
        to: $7f4114e3cb613038$var$startPaymentSessionLink(plan, "month"),
        width: "100%",
        children: "Activate Free Trial"
    });
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
        loading: creatingSession,
        to: $7f4114e3cb613038$var$startPaymentSessionLink(plan, "month"),
        width: "100%",
        children: comparison > 0 ? "Change Plan" : "Upgrade"
    });
};
const $7f4114e3cb613038$var$PlanPriceTag = ({ plan: plan , currentUser: currentUser  })=>{
    const { currentPlan: currentPlan , currentSubscription: currentSubscription  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlanListData: PlanListData  })=>PlanListData, []);
    if (plan.isBasicPlan) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        children: [
            "Free until ",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("b", {
                children: "December 2023"
            })
        ]
    });
    else if (plan.isEnterprise) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        children: "Custom pricing for schools and districts"
    });
    else if (plan.status === "deprecated") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        children: "This plan is no longer available, but your subscription has been grandfathered in and you can keep using it."
    });
    else if (currentUser.trialMonthsAvailable) return null;
    else if (currentSubscription && currentPlan?.id === plan.id && currentSubscription.paymentInterval === "month" && plan.annualPriceUsdCents / 12 < plan.monthlyPriceUsdCents && currentSubscription.status === "active") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        children: [
            "Switch to yearly payments and save",
            " ",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("b", {
                children: (0, $e6116bf527c207db$export$c86caf1be068fb8d)(plan.monthlyPriceUsdCents - plan.annualPriceUsdCents / 12)
            }),
            " per month!"
        ]
    });
    else {
        const cheaperYearlyPrice = Math.min(plan.monthlyPriceUsdCents * 12, plan.annualPriceUsdCents);
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            children: [
                "From ",
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("b", {
                    children: (0, $e6116bf527c207db$export$c86caf1be068fb8d)(cheaperYearlyPrice)
                }),
                " per year"
            ]
        });
    }
};
const $7f4114e3cb613038$export$f3a26c928d7bab44 = ({ children: children  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
        variant: "h6",
        weightOverride: "bold",
        children: children
    });
const $7f4114e3cb613038$export$aa18130def4b6cb4 = ({ features: features  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$var$List, {
        children: features.map((featureText, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$var$ListItem, {
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    dangerouslySetInnerHTML: {
                        __html: featureText
                    }
                })
            }, i))
    });
const $7f4114e3cb613038$export$3ecb36a5bcbd6da8 = ()=>{
    const { load: load , loading: loading , currentUser: currentUser , currentPlan: currentPlan , plans: plans , onSubscriptionStatus: onSubscriptionStatus , onSubscriptionConnected: onSubscriptionConnected , currentSubscription: currentSubscription , downgrade: downgrade , downgradingPlan: downgradingPlan , setField: setField  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlanListData: PlanListData  })=>PlanListData, []);
    const { createToast: createToast  } = (0, $164dcc779e79d074$export$f46171b59bb094f9)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    (0, $g5BLJ.useEffect)(()=>{
        load(createToast, history);
    }, [
        load,
        createToast,
        history
    ]);
    const onSub = (0, $g5BLJ.useCallback)(()=>{
        onSubscriptionConnected(createToast, history);
    }, [
        onSubscriptionConnected,
        createToast,
        history
    ]);
    const onSubStatus = (0, $g5BLJ.useCallback)((data)=>{
        onSubscriptionStatus({
            createToast: createToast,
            ...data
        });
    }, [
        onSubscriptionStatus,
        createToast
    ]);
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    if (!currentUser) return null;
    const allPlans = (0, $4ded3b2c5af96cca$export$a9b413430a92321a)(plans.concat((0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(// Handle if they are on a no longer visible plan, e.g. a grandfathered old pro version
    currentPlan && plans.every((p)=>p.id !== currentPlan.id) ? [
        currentPlan
    ] : [])));
    const closeDowngrade = ()=>setField("downgradingPlan")(null);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($7f4114e3cb613038$var$PlanListContainer, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 8
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$590ff762cb17981c), {
                        href: "https://drive.google.com/file/d/1rVYHdwrGH8_pVOpUtOK-2zX3lYP9BA8q/view?usp=sharing",
                        newTab: true,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            backgroundColor: (0, $24b764039c44d1ec$export$2f3d5b568ae6b3c1).primaryBlue,
                            borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4],
                            justify: "center",
                            padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[6]}`,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                color: "white",
                                variant: "h5",
                                children: "We are proud to announce that Readlee is joining Paper! Click here for a letter from our Founders"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 8
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Select Your Plan"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h4",
                        textAlign: "center",
                        children: "Upgrade and accelerate your students' literacy growth"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 8
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$var$PlansContainer, {
                children: allPlans.map((plan, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($7f4114e3cb613038$var$PlanBox, {
                        $last: i === allPlans.size,
                        "data-test-tag": `plan-box-${plan.id}`,
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($7f4114e3cb613038$var$PricingContainer, {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h1",
                                        children: plan.name
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h4",
                                        minHeight: (0, $18ffa0398cff6303$export$66be51d536890fa7)[15],
                                        dangerouslySetInnerHTML: {
                                            __html: plan.tagline
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$var$PlanButton, {
                                        plan: plan,
                                        currentUser: currentUser
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 2
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$var$PlanPriceTag, {
                                        plan: plan,
                                        currentUser: currentUser
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h6",
                                weightOverride: "bold",
                                minHeight: (0, $18ffa0398cff6303$export$66be51d536890fa7)[17],
                                dangerouslySetInnerHTML: {
                                    __html: plan.description
                                }
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$export$aa18130def4b6cb4, {
                                features: plan.features
                            }),
                            plan.comingSoonFeatures.size > 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 3
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$export$f3a26c928d7bab44, {
                                        children: "Coming Soon:"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$export$aa18130def4b6cb4, {
                                        features: plan.comingSoonFeatures
                                    })
                                ]
                            }) : null,
                            plan.optionalAddOns.size > 0 ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 3
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$export$f3a26c928d7bab44, {
                                        children: "Optional Add Ons:"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($7f4114e3cb613038$export$aa18130def4b6cb4, {
                                        features: plan.optionalAddOns
                                    })
                                ]
                            }) : null
                        ]
                    }, plan.id))
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/t/plans/:id/:paymentInterval/create_session",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $cf7bafd1f1d50571$export$5aadc41d183ec7a6), {})
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $018cce6940d253d6$export$b5b6bb8bb5273115), {
                channel: "SubscriptionChannel",
                onMessage: onSubStatus,
                onConnected: onSub
            }),
            downgradingPlan && currentPlan && currentSubscription && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
                openType: "state",
                opened: Boolean(downgradingPlan),
                close: closeDowngrade,
                header: "Cancel your plan",
                maxWidthOverride: "800px",
                footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: closeDowngrade,
                            inheritBgColor: true,
                            displayType: "link",
                            color: "primaryBlue",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: downgrade(downgradingPlan, createToast),
                            color: "danger",
                            children: "Cancel my Plan"
                        })
                    ]
                }),
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: [
                            "Are you sure you want to cancel your plan for Readlee ",
                            currentPlan.name,
                            "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: [
                            "Your subscription will be cancelled and you will not be charged next",
                            " ",
                            currentSubscription.paymentInterval,
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: [
                            "You will be able to keep using your ",
                            currentPlan.name,
                            " features until the current payment period ends on",
                            " ",
                            (0, $73b0620564a5efc3$export$3ae94a2503e890a1)(new Date(currentSubscription.currentPeriodEndsAt), {
                                includeYearIfNotCurrent: true
                            }),
                            " ",
                            "at ",
                            (0, $73b0620564a5efc3$export$3203edd9e5edd663)(new Date(currentSubscription.currentPeriodEndsAt)),
                            "."
                        ]
                    })
                ]
            })
        ]
    });
};








const $f76706aa6d2d1de5$var$BaseTeacherLayoutStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "TeacherLayout__BaseTeacherLayoutStyles",
    componentId: "sc-a21nt8-0"
})([
    "",
    " display:grid;grid-template-rows:auto 1fr;grid-template-columns:1fr;"
], (0, $dba6c5da69120483$export$6988a55f9afa8b34));
const $f76706aa6d2d1de5$var$routes = [
    {
        path: [
            "/t/assignments",
            "/t/assignments/assign"
        ],
        exact: true,
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $81a0282c82c60f2f$export$aa9f939ec92d7b12), {}),
        title: "Assignments"
    },
    {
        path: [
            "/t/assignments/:id",
            "/t/assignments/:id/assign",
            "/t/assignments/:id/archive",
            "/t/assignments/:id/restore"
        ],
        exact: true,
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7e214028cab82381$export$c5b18d8844d125d), {})
    },
    {
        path: [
            "/t/assignments/task/:type/:id"
        ],
        exact: true,
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ffcf15e3b286680e$export$fb4388f3ff92f17b), {})
    },
    {
        path: "/t/progress-monitoring",
        exact: true,
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7b25f9b5308f7290$export$a5c423535959af60), {}),
        title: "Progress Monitoring"
    },
    {
        path: "/t/progress-monitoring/:userId",
        exact: true,
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1332d5cf233f1131$export$6d5b1fe761cbe354), {})
    },
    {
        path: "/t/library",
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e19a31b8e757b290$export$b94d3ffef634e7de), {})
    },
    {
        path: "/t/profile",
        exact: true,
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f183dd4b89f089d3$export$b7b58f2e100445f7), {
            ContentElement: (0, $983442d63718d5de$export$2ab6bab701a9bc81)
        }),
        title: "My Profile"
    },
    {
        path: "/t/classes",
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c412961da9d63a78$export$26dd609890808aaf), {
            ContentElement: (0, $983442d63718d5de$export$2ab6bab701a9bc81)
        }),
        title: "Classes"
    },
    {
        path: "/t/students",
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f5fadce82629066f$export$bda4a123e9c64662), {
            ContentElement: (0, $983442d63718d5de$export$2ab6bab701a9bc81)
        }),
        title: "Students"
    },
    {
        path: "/t/plans",
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7f4114e3cb613038$export$3ecb36a5bcbd6da8), {}),
        title: "Plans"
    }
];
const $f76706aa6d2d1de5$export$a838d1491e7ec857 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5557eb3ea8c47b66$export$dba0f9e9232b3d6d), {
                accountTypes: [
                    "student"
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/t/reading-builder",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                title: "Reading Builder"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $553bb6ab579eed1c$export$5838c3b7a4a3fc78), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/t/assignment-builder/:assessmentId",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                title: "Assignment Builder"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $45fae8392b5279fd$export$17173192ecbde129), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: "/t/onboarding",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                title: "Teacher Onboarding"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $37368a4402105327$export$dbf6b52a6eb81de8), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        path: (0, $62e5f0fd429b4502$export$f96fbc986381319f),
                        exact: true,
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $399acaba3991b874$export$bdcffb184229ae9), {})
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($f76706aa6d2d1de5$var$BaseTeacherLayoutStyles, {
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
                                children: [
                                    $f76706aa6d2d1de5$var$routes.map(({ component: component , title: title , ...routeProps }, index)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                            ...routeProps,
                                            children: [
                                                title && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                                    title: title
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $74b195a20ec26994$export$c4e96258f3b6511), {}),
                                                component
                                            ]
                                        }, index)),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
                                            to: {
                                                pathname: "/t/assignments",
                                                search: (0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)
                                            }
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};













var $g5BLJ = parcelRequire("g5BLJ");









const $8362073d8e8b0505$var$InternalConfirmSwitchTypeModal = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const params = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const { results: results , updateUser: updateUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.UserSearchData, []);
    const user = results.find(({ user: user  })=>user.id === params.id)?.user;
    if (!user) return null;
    const close = ()=>history.push(`/m/user-search${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
    const targetType = user.accountType === "teacher" ? "student" : "teacher";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: "Warning!",
        close: close,
        openType: "state",
        opened: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: close,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: ()=>updateUser(user, history, query, "accountType", targetType),
                    children: [
                        "Set to ",
                        (0, $e6116bf527c207db$export$9a00dee1beb8f576)(targetType)
                    ]
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                weightOverride: "bold",
                children: "Switching this account's user type will delete all their registrations!"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Students will no longer be registered to any classes, and teachers will not have access to their classes"
            })
        ]
    });
};
const $8362073d8e8b0505$export$8c90ef4ca92a1f85 = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
        path: "/m/user-search/:id/confirm",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8362073d8e8b0505$var$InternalConfirmSwitchTypeModal, {})
    });







const $581cefe8e2c5757f$export$95b8e59856e43f23 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const params = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const { results: results , grantTrial: grantTrial , trialEndDate: trialEndDate , setField: setField , errors: errors , closeTrialModal: closeTrialModal  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.UserSearchData, []);
    const user = results.find(({ user: user  })=>user.id === params.id)?.user;
    if (!user) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: "Grant Trial",
        close: closeTrialModal(history, query),
        openType: "state",
        opened: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: closeTrialModal(history, query),
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 3,
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    disabled: !trialEndDate,
                    onClick: ()=>grantTrial(user, history, query),
                    children: "Save Trial"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "If the user has an existing plan, the plan will be cancelled, prorated, and a new plan will begin under the name Readlee Ultimate (Trial)."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                width: "auto",
                label: "Trial End Date",
                type: "date",
                name: "plan",
                min: (0, $e02099e89983f6fb$export$8e7f4929fe5ed49c)(),
                value: trialEndDate,
                onChange: setField("trialEndDate"),
                errors: errors,
                testTag: "trial-end-date"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            trialEndDate && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h4",
                children: [
                    user.displayName,
                    " will have a free trial until ",
                    trialEndDate
                ]
            })
        ]
    });
};
const $581cefe8e2c5757f$export$c57a1b3d37c362b0 = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
        path: "/m/user-search/:id/grant-trial",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($581cefe8e2c5757f$export$95b8e59856e43f23, {})
    });







const $8c16636bbb5f553f$var$InternalDeleteAccountModal = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const params = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const { results: results , deleteUser: deleteUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.UserSearchData, []);
    const { user: user = null , hasCoTeachers: hasCoTeachers = null  } = results.find(({ user: user  })=>user.id === params.id) || {};
    if (!user) return null;
    const close = ()=>history.push(`/m/user-search${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        header: `Delete Confirmation for ${user.displayName}`,
        close: close,
        openType: "state",
        opened: true,
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    onClick: close,
                    displayType: "link",
                    color: "primaryBlue",
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "danger",
                    onClick: deleteUser(user, history, query),
                    children: "Confirm Delete"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h4",
                children: [
                    "You are about to delete ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $a1ba98bbc2222182$export$95aa4184327d6b72), {
                        children: [
                            user.displayName,
                            "'s"
                        ]
                    }),
                    " account!"
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                        children: "Deleting this account will also delete all associated registrations, disassociate any SSO IDs, and hide all comments created by the teacher!"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                        children: "This DOES NOT delete their data from our systems"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                        children: "This will not fulfil GDPR obligations"
                    }),
                    hasCoTeachers && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("b", {
                            children: "This teacher has co-teachers! Contact engineering to verify if we want to delete this user!"
                        })
                    })
                ]
            })
        ]
    });
};
const $8c16636bbb5f553f$export$92d028d636262c3b = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
        path: "/m/user-search/:id/delete",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($8c16636bbb5f553f$var$InternalDeleteAccountModal, {})
    });






const $db90b2163305025a$export$6b48bc8e0b9347a5 = ()=>{
    const { searchQuery: searchQuery , submit: submit , setField: setField , results: results , loading: loading , load: load , generalError: generalError , updateUserSchool: updateUserSchool  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.UserSearchData, []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const realSubmit = (0, $g5BLJ.useCallback)(()=>submit(history, query), [
        history,
        query,
        submit
    ]);
    const searchQueryParam = query.get("query");
    (0, $g5BLJ.useEffect)(()=>{
        load({
            searchQuery: searchQueryParam || "",
            onSuccess: realSubmit
        });
    }, [
        searchQueryParam,
        load,
        realSubmit
    ]);
    const columns = [
        {
            id: "name",
            name: "Display Name",
            sortType: "sortBy",
            render: ({ user: user  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: user.displayName
                }),
            sortBy: ({ user: user  })=>user.displayName
        },
        {
            id: "email",
            name: "Email / Username",
            sortType: "sortBy",
            render: ({ user: user  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: user.email ?? user.username
                }),
            sortBy: ({ user: user  })=>user.email ?? user.username
        },
        {
            id: "schoolName",
            name: "School Name",
            render: ({ school: school  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: school?.name || "--"
                }),
            sortBy: ({ school: school  })=>school?.name || "--",
            sortType: "sortBy"
        },
        {
            id: "schoolRole",
            name: "School Role",
            render: ({ userSchool: userSchool  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    children: userSchool?.role || "--"
                }),
            sortBy: ({ userSchool: userSchool  })=>userSchool?.role || "z",
            sortType: "sortBy"
        },
        {
            id: "planName",
            name: "Plan Type",
            render: ({ plan: plan  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "right",
                    color: plan?.isBasicPlan ? "danger" : "black",
                    children: plan?.name || "No Plan"
                }),
            sortBy: ({ plan: plan  })=>plan?.name || "No Plan",
            sortType: "sortBy",
            textAlign: "right"
        },
        {
            id: "subscriptionEndDate",
            name: "Period ends at",
            render: ({ subscription: subscription  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "right",
                    children: subscription?.currentPeriodEndsAt ? (0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(subscription?.currentPeriodEndsAt)) : "--"
                }),
            sortBy: ({ subscription: subscription  })=>new Date(subscription?.currentPeriodEndsAt ?? 0).valueOf(),
            sortType: "sortBy",
            textAlign: "right"
        },
        {
            id: "role",
            name: "Role",
            render: ({ user: user  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    textAlign: "right",
                    testTag: `${user.id}-accountType`,
                    children: user.accountType
                }),
            sortBy: ({ user: user  })=>user.accountType,
            sortType: "sortBy",
            textAlign: "right"
        },
        {
            id: "settings",
            name: "Actions",
            textAlign: "right",
            sortType: "none",
            render: ({ user: user , userSchool: userSchool  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    justify: "end",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                        rightAligned: true,
                        displayType: "iconOnly",
                        color: "white",
                        iconColor: "gray7",
                        icon: "threeVerticalDots",
                        iconSize: "2em",
                        testTag: "settings",
                        inheritBgColor: true,
                        noButtonPadding: true,
                        options: [
                            {
                                children: "Copy User ID",
                                onClick: async ()=>await (0, $55832b297ed0598b$export$f980440e1ab4537d)(user.id)
                            },
                            {
                                children: `Set to ${user.accountType === "teacher" ? "Student" : "Teacher"}`,
                                to: `/m/user-search/${user.id}/confirm${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                            },
                            ...user.accountType !== "teacher" ? [] : [
                                {
                                    children: "Grant Trial",
                                    to: `/m/user-search/${user.id}/grant-trial${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                                }
                            ],
                            ...!userSchool || user.accountType === "student" ? [] : [
                                {
                                    children: userSchool.role === "admin" ? "Demote Admin" : "Promote to School Admin",
                                    onClick: ()=>updateUserSchool(userSchool, userSchool.role === "admin" ? "teacher" : "admin", history, query)
                                }
                            ],
                            {
                                children: "Delete Account",
                                color: "danger",
                                to: `/m/user-search/${user.id}/delete${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`
                            }
                        ]
                    })
                })
        }
    ];
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
        onSubmit: realSubmit,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                width: "100%",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        width: "100%",
                        maxWidth: "1000px",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                type: "text",
                                name: "query",
                                placeholder: "Search by User Name or Email, or by School name!",
                                value: searchQuery,
                                onChange: setField("searchQuery")
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                onClick: realSubmit,
                                loading: loading,
                                children: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        width: "100%",
                        maxWidth: "1000px",
                        children: results.isEmpty() ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            children: "No users to display"
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                generalError,
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                                    queryParam: "sortBy",
                                    columns: columns,
                                    rows: results,
                                    getRowId: ({ user: user  })=>user.id
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8362073d8e8b0505$export$8c90ef4ca92a1f85), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8c16636bbb5f553f$export$92d028d636262c3b), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $581cefe8e2c5757f$export$c57a1b3d37c362b0), {})
        ]
    });
};







var $g5BLJ = parcelRequire("g5BLJ");





const $021ee68397031257$export$518969a92910ac8c = ()=>{
    const { deletingPlaylist: deletingPlaylist , setField: setField , confirmDelete: confirmDelete  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlaylistManagerData: PlaylistManagerData  })=>PlaylistManagerData, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        openType: "state",
        opened: Boolean(deletingPlaylist),
        header: "Delete Playlist?",
        close: ()=>setField("deletingPlaylist")(null),
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "link",
                    color: "primaryBlue",
                    onClick: ()=>setField("deletingPlaylist")(null),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    color: "danger",
                    onClick: confirmDelete,
                    children: "Delete"
                })
            ]
        }),
        children: [
            'Delete "',
            deletingPlaylist?.name,
            '"?'
        ]
    });
};






const $965080c81efd786a$export$d7aaeb8e7709b55e = ()=>{
    const { editingPlaylist: editingPlaylist , savePlaylist: savePlaylist , setEditingPlaylistField: setEditingPlaylistField , setField: setField , errors: errors  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlaylistManagerData: PlaylistManagerData  })=>PlaylistManagerData, []);
    if (!editingPlaylist?.id) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        disableFadeClose: true,
        openType: "state",
        opened: true,
        header: "Edit Playlist",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "link",
                    color: "primaryBlue",
                    onClick: ()=>setField("editingPlaylist")(null),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    type: "submit",
                    children: "Save"
                })
            ]
        }),
        close: ()=>setField("editingPlaylist")(null),
        onSubmit: savePlaylist,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "name",
                label: "Name",
                value: editingPlaylist.name,
                onChange: setEditingPlaylistField("name"),
                errors: errors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "multiselect",
                name: "visibleRoles",
                label: "Visible Roles",
                value: editingPlaylist.visibleRoles,
                options: (0, $d66224a7b1518c5a$export$88bee8c1f4ff1cd),
                onChange: setEditingPlaylistField("visibleRoles"),
                errors: errors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "toggle",
                name: "enabled",
                label: "Visible",
                value: editingPlaylist.enabled,
                onChange: setEditingPlaylistField("enabled"),
                errors: errors
            })
        ]
    });
};






const $f9287d69c08f0ed2$export$902fe3c7eab50382 = ()=>{
    const { editingPlaylist: editingPlaylist , savePlaylist: savePlaylist , setEditingPlaylistField: setEditingPlaylistField , setField: setField , errors: errors  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlaylistManagerData: PlaylistManagerData  })=>PlaylistManagerData, []);
    if (editingPlaylist?.id !== "") return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $800aabf72745714c$export$72f77866d312088b), {
        disableFadeClose: true,
        openType: "state",
        opened: true,
        header: "Create Playlist",
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    displayType: "link",
                    color: "primaryBlue",
                    onClick: ()=>setField("editingPlaylist")(null),
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true,
                    size: 3
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    type: "submit",
                    children: "Save"
                })
            ]
        }),
        close: ()=>setField("editingPlaylist")(null),
        onSubmit: savePlaylist,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "text",
                name: "name",
                label: "Name",
                value: editingPlaylist.name,
                onChange: setEditingPlaylistField("name"),
                errors: errors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "multiselect",
                name: "visibleRoles",
                label: "Visible Roles",
                value: editingPlaylist.visibleRoles,
                options: (0, $d66224a7b1518c5a$export$88bee8c1f4ff1cd),
                onChange: setEditingPlaylistField("visibleRoles"),
                errors: errors
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                type: "toggle",
                name: "enabled",
                label: "Visible",
                value: editingPlaylist.enabled,
                onChange: setEditingPlaylistField("enabled"),
                errors: errors
            })
        ]
    });
};





const $e09be262c6c46161$export$eb396a6a4cf7e868 = ()=>{
    const { load: load , loading: loading , playlists: playlists , updatePlaylistRank: updatePlaylistRank , setField: setField , startCreate: startCreate  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ PlaylistManagerData: PlaylistManagerData  })=>PlaylistManagerData, []);
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const getRowId = (0, $g5BLJ.useCallback)((p)=>p.id, []);
    const columns = (0, $g5BLJ.useMemo)(()=>[
            {
                id: "name",
                name: "Name",
                render: (playlist)=>playlist.name,
                sortType: "none"
            },
            {
                id: "rank",
                name: "Rank (Lower Means Higher on Page)",
                render: (playlist)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                icon: "selectArrowUp",
                                onClick: ()=>updatePlaylistRank(playlist, (playlist.ranking || 0) - 1),
                                displayType: "iconOnly",
                                color: "white",
                                iconColor: "gray7",
                                iconSize: "1em",
                                testTag: "rank-up"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                onClick: ()=>updatePlaylistRank(playlist, (playlist.ranking || 0) + 1),
                                icon: "selectArrowDown",
                                displayType: "iconOnly",
                                color: "white",
                                iconColor: "gray7",
                                iconSize: "1em",
                                testTag: "rank-down"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 2
                            }),
                            playlist.ranking
                        ]
                    }),
                sortBy: (playlist)=>playlist.ranking || 0,
                sortType: "sortBy",
                defaultSortDirection: "asc"
            },
            {
                id: "status",
                name: "Status",
                render: ({ enabled: enabled  })=>enabled ? "Visible" : "Hidden",
                sortType: "none"
            },
            {
                id: "actions",
                name: "",
                sortType: "none",
                render: (playlist)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                        displayType: "outline",
                        options: [
                            {
                                children: "Edit",
                                onClick: ()=>setField("editingPlaylist")(playlist)
                            },
                            {
                                children: "Delete",
                                color: "danger",
                                onClick: ()=>setField("deletingPlaylist")(playlist)
                            }
                        ],
                        children: "Actions"
                    })
            }
        ], [
        setField,
        updatePlaylistRank
    ]);
    if (loading) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {});
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $81498f85426d0c12$export$900d6118d6e87fe5), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 6
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Playlists"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: startCreate,
                        children: "Add Playlist"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 6
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $9d88166725471d61$export$19e77af6aa9459e3), {
                columns: columns,
                rows: playlists.filter((p)=>p.status === "active"),
                getRowId: getRowId,
                queryParam: "playlists",
                initialSortSettings: {
                    columnId: "rank",
                    sortDirection: "asc"
                }
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9287d69c08f0ed2$export$902fe3c7eab50382), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $965080c81efd786a$export$d7aaeb8e7709b55e), {}),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $021ee68397031257$export$518969a92910ac8c), {})
        ]
    });
};




const $7c7d85f4f27b738b$var$BaseModeratorLayoutStyles = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ModeratorLayout__BaseModeratorLayoutStyles",
    componentId: "sc-pkj4zr-0"
})([
    "",
    " display:grid;grid-template-rows:auto 1fr;grid-template-columns:1fr;"
], (0, $dba6c5da69120483$export$6988a55f9afa8b34));
const $7c7d85f4f27b738b$var$routes = [
    {
        path: "/m/user-search",
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $db90b2163305025a$export$6b48bc8e0b9347a5), {}),
        title: "User Search"
    },
    {
        path: "/m/playlists",
        component: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e09be262c6c46161$export$eb396a6a4cf7e868), {}),
        title: "Playlist Manager"
    }
];
const $7c7d85f4f27b738b$export$709cb64239384269 = ()=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($7c7d85f4f27b738b$var$BaseModeratorLayoutStyles, {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5557eb3ea8c47b66$export$dba0f9e9232b3d6d), {
                accountTypes: [
                    "student",
                    "teacher"
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
                children: [
                    $7c7d85f4f27b738b$var$routes.map(({ component: component , title: title , ...routeProps }, index)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                            ...routeProps,
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $74b195a20ec26994$export$c4e96258f3b6511), {}),
                                title && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                    title: title
                                }),
                                component
                            ]
                        }, index)),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
                            to: "/"
                        })
                    })
                ]
            })
        ]
    });










const $2758239e67023940$var$SIMPLE_LAYOUT_MAX_WIDTH = "500px";
const $2758239e67023940$var$SIMPLE_LAYOUT_MIN_WIDTH = "300px";
const $2758239e67023940$var$BaseSimpleLayout = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SimpleLayout__BaseSimpleLayout",
    componentId: "sc-15fd5o3-0"
})([
    "",
    " display:flex;flex-direction:column;align-items:center;background:",
    ";"
], (0, $dba6c5da69120483$export$6988a55f9afa8b34), (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex);
const $2758239e67023940$var$SimpleLayoutPanel = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SimpleLayout__SimpleLayoutPanel",
    componentId: "sc-15fd5o3-1"
})([
    "padding:",
    " ",
    ";background:",
    ";border-radius:",
    ";width:100%;max-width:",
    ";min-width:",
    ";border:1px solid ",
    ";"
], (0, $8259eb090983b778$export$ea413736286a3bf1)[6], (0, $8259eb090983b778$export$ea413736286a3bf1)[8], (0, $24b764039c44d1ec$export$8f45430ccf837300).white.hex, (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4], $2758239e67023940$var$SIMPLE_LAYOUT_MAX_WIDTH, $2758239e67023940$var$SIMPLE_LAYOUT_MIN_WIDTH, (0, $24b764039c44d1ec$export$8f45430ccf837300).gray3.hex);
const $2758239e67023940$export$981215d1ec34b273 = ({ children: children , loading: loading , footer: footer  })=>{
    const isMobileLayout = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThan: "mobileLarge"
    });
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2758239e67023940$var$BaseSimpleLayout, {
        children: loading ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
            flex: true,
            kind: "boat"
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            grow: 1,
            width: "100%",
            justify: "center",
            margin: isMobileLayout ? (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5] : (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none,
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: isMobileLayout ? "center" : "space-between",
                    padding: isMobileLayout ? `${(0, $8259eb090983b778$export$ea413736286a3bf1).none}` : `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[2]}`,
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7eb33c08429d75e4$export$ce671d21b66bb548), {
                        logoType: currentUser?.paperId ? "paper-reading" : "full-name",
                        size: isMobileLayout || currentUser?.paperId ? "medium" : "small"
                    })
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    grow: isMobileLayout ? 0 : 1,
                    align: "center",
                    justify: "center",
                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        align: "center",
                        justify: "center",
                        margin: isMobileLayout ? `${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d).none} ${(0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5]}` : (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5],
                        maxWidth: $2758239e67023940$var$SIMPLE_LAYOUT_MAX_WIDTH,
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 10
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($2758239e67023940$var$SimpleLayoutPanel, {
                                children: children || null
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 4
                            }),
                            footer
                        ]
                    })
                })
            ]
        })
    });
};








var $g5BLJ = parcelRequire("g5BLJ");








const $37cf5c497e358388$var$BaseContentLayout = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ContentLayout__BaseContentLayout",
    componentId: "sc-1ylqo5k-0"
})([
    "",
    " background:",
    ";padding:",
    ";",
    ""
], (0, $dba6c5da69120483$export$6988a55f9afa8b34), (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[4], ({ $fixedSearchBar: $fixedSearchBar  })=>$fixedSearchBar && (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "padding-top:0;"
    ]));
const $37cf5c497e358388$var$FiltersArea = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ContentLayout__FiltersArea",
    componentId: "sc-1ylqo5k-1"
})([
    "margin-bottom:",
    ";",
    ""
], (0, $0c729dd84fb3d3fd$export$450f8a5aaf0e893d)[5], ({ $isMobile: $isMobile , $fixedSearchBar: $fixedSearchBar  })=>$isMobile ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "padding:",
        ";min-width:250px;"
    ], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "position:fixed;padding:",
        " ",
        " ",
        " ",
        ";width:250px;height:100%;"
    ], $fixedSearchBar ? (0, $8259eb090983b778$export$ea413736286a3bf1)[6] : (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[2], (0, $8259eb090983b778$export$ea413736286a3bf1)[2]));
const $37cf5c497e358388$var$SearchContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ContentLayout__SearchContainer",
    componentId: "sc-1ylqo5k-2"
})([
    "",
    ""
], ({ $fixedSearchBar: $fixedSearchBar  })=>$fixedSearchBar ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "position:fixed;z-index:",
        ";padding:",
        " ",
        " ",
        ";background:",
        ";width:calc(100% - 298px);"
    ], (0, $9f83aa035e9f8cbe$export$a01878c2d95345c0).raised, (0, $8259eb090983b778$export$ea413736286a3bf1)[7], (0, $8259eb090983b778$export$ea413736286a3bf1)[3], (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "padding:",
        ";"
    ], (0, $8259eb090983b778$export$ea413736286a3bf1)[3]));
const $37cf5c497e358388$export$ce6636bfa4e9f0e8 = ({ filters: filters , searchValue: searchValue , searchAction: searchAction , searchPlaceholder: searchPlaceholder = "Search" , resultCount: resultCount = 0 , resultTotal: resultTotal , loading: loading , children: children  })=>{
    const isMobile = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThan: "tabletSmall"
    });
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser, []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const PAGE_SIZE = 30;
    const page = parseInt(query.get("pageNumber") ?? "0");
    const total = Math.ceil(resultTotal / PAGE_SIZE);
    const isTeacher = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/t/library"));
    (0, $g5BLJ.useEffect)(()=>{
        if (page >= total && total > 0) history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
            pageNumber: "0"
        })}`);
    }, [
        page,
        total,
        history,
        query,
        pathname
    ]);
    const fixedSearchBar = !isMobile && isTeacher;
    const filterSection = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($37cf5c497e358388$var$FiltersArea, {
        $isMobile: isMobile,
        $fixedSearchBar: fixedSearchBar,
        children: filters
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($37cf5c497e358388$var$BaseContentLayout, {
        $fixedSearchBar: fixedSearchBar,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            children: [
                !isMobile && filterSection,
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    width: "100%",
                    height: "100%",
                    direction: "column",
                    padding: isMobile ? "0" : "0 0 0 266px",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                            path: "/t/library",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)($37cf5c497e358388$var$SearchContainer, {
                                $fixedSearchBar: fixedSearchBar,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2511447d0cb3d32$export$55d7609a8f1eccd2), {
                                        value: searchValue,
                                        onChange: searchAction,
                                        placeholder: searchPlaceholder,
                                        displayType: "large"
                                    }),
                                    fixedSearchBar && searchValue.length > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        justify: "space-between",
                                        align: "center",
                                        padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[3]} 0 0 0`,
                                        wrap: "wrap",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            maxWidth: "75%",
                                            children: [
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                    variant: "h3",
                                                    ellipsis: true,
                                                    padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
                                                    children: [
                                                        'Searching for "',
                                                        searchValue,
                                                        '"'
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                                    to: "/t/library",
                                                    children: "Clear"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        isMobile && filterSection,
                        !fixedSearchBar && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "space-between",
                            align: "center",
                            padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[7]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[1]} 0`,
                            wrap: "wrap",
                            children: searchValue.length > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                maxWidth: "75%",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h3",
                                        ellipsis: true,
                                        padding: `0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
                                        children: [
                                            'Searching for "',
                                            searchValue,
                                            '"'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                        to: "/t/library",
                                        children: "Clear"
                                    })
                                ]
                            })
                        }),
                        fixedSearchBar && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: searchValue.length > 0 ? 32 : 23
                        }),
                        children,
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "center",
                            children: !loading && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        justify: "end",
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                                displayType: "noStyles",
                                                disabled: page <= 0,
                                                testTag: "prev-page",
                                                onClick: ()=>{
                                                    history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                                                        pageNumber: (page - 1).toString()
                                                    })}`);
                                                },
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: "arrowLeft",
                                                    size: "2em",
                                                    color: page <= 0 ? "gray5" : "black"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h5",
                                                children: total === 0 ? "1 / 1" : `${page + 1} / ${total}`
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                                displayType: "noStyles",
                                                disabled: page + 1 >= total,
                                                testTag: "next-page",
                                                onClick: ()=>{
                                                    history.push(`${pathname}${(0, $5557eb3ea8c47b66$export$4d1bf8b2f67bcb1)(query, {
                                                        pageNumber: (page + 1).toString()
                                                    })}`);
                                                },
                                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                                    icon: "arrowRight",
                                                    size: "2em",
                                                    color: page + 1 >= total ? "gray5" : "black"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 3
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        align: "center",
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$b04be29aa201d4f5), {
                                            $isTextInput: true,
                                            $noMargin: true,
                                            children: resultTotal === 0 ? "0 Results" : `${page * PAGE_SIZE + 1} - ${page * PAGE_SIZE + resultCount} of ${resultTotal} Results`
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        horizontal: true,
                                        size: 2
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            justify: "center",
                            children: currentUser?.paperId && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eb30321ced29024b$export$a06f1c675e846f6f), {
                                accountType: currentUser.accountType
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        })
                    ]
                })
            ]
        })
    });
};
const $37cf5c497e358388$var$GridContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "ContentLayout__GridContainer",
    componentId: "sc-1ylqo5k-3"
})([
    "",
    " padding:",
    " ",
    ";"
], ({ $isStudent: $isStudent  })=>$isStudent ? (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "display:grid;grid-template-columns:repeat(auto-fill,208px);grid-gap:",
        ";justify-content:center;"
    ], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]) : (0, $f2062e8c5c08e6f7$export$dbf350e5966cf602)([
        "display:grid;grid-template-columns:repeat(auto-fill,minmax(min(250px,100%),1fr));grid-gap:",
        ";"
    ], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]), (0, $8259eb090983b778$export$ea413736286a3bf1)[3], (0, $8259eb090983b778$export$ea413736286a3bf1)[4]);
const $37cf5c497e358388$export$e04042801ea527f0 = ({ id: id , testTag: testTag , children: children  })=>{
    const pathname = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)().pathname;
    const isStudent = Boolean((0, $4ab21c8a3cbff9b4$export$81336c211d5ff295)(pathname, "/s/library"));
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($37cf5c497e358388$var$GridContainer, {
        id: id,
        "data-test-tag": testTag,
        $isStudent: isStudent,
        children: children
    });
};








const $040604a74daf8ed4$var$NUM_AVATAR_RESULTS = 12;
const $040604a74daf8ed4$export$1c06ee2b629770df = ()=>{
    const { load: load , loadMore: loadMore , page: page , total: total , loading: loading , avatars: avatars  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            load: state.AvatarGalleryData.load,
            loadMore: state.AvatarGalleryData.loadMore,
            page: state.AvatarGalleryData.page,
            total: state.AvatarGalleryData.total,
            loading: state.AvatarGalleryData.loading,
            avatars: state.AvatarGalleryData.avatars
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: false,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                align: "center",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        textAlign: "center",
                        children: "Avatars of Readlee"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        wrap: "wrap",
                        align: "center",
                        justify: "center",
                        children: avatars.map(({ avatarSkin: avatarSkin , avatarEyes: avatarEyes , avatarMouth: avatarMouth , avatarHat: avatarHat  }, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                padding: "16px",
                                direction: "column",
                                height: "auto",
                                testTag: "avatar",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b22773065c4c76be$export$c39250ac1434c848), {
                                    kind: "dashboard",
                                    avatarSkin: avatarSkin,
                                    avatarEyes: avatarEyes,
                                    avatarMouth: avatarMouth,
                                    avatarHat: avatarHat
                                })
                            }, i))
                    }),
                    $040604a74daf8ed4$var$moreToLoad(page, total) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        onClick: loadMore,
                        loading: loading,
                        width: "200px",
                        children: "Load More"
                    })
                ]
            })
        })
    });
};
function $040604a74daf8ed4$var$moreToLoad(page, total) {
    return page * $040604a74daf8ed4$var$NUM_AVATAR_RESULTS < total;
}










var $g5BLJ = parcelRequire("g5BLJ");


const $699c44e06e97d7c3$export$21a94553ffa41578 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const courseCode = query.get("courseCode") || "";
    const skipRedirect = query.get("skipRedirect") || "";
    const redirectPath = query.get("redirectPath") || "";
    const ssoSuccessUrl = redirectPath || "/";
    (0, $g5BLJ.useEffect)(()=>{
        if ((0, $0fe4eaef81db718a$export$2cba2d9d62933240) && !skipRedirect) {
            if (redirectPath) window.sessionStorage.setItem("postLoginRedirectUri", `${(0, $0fe4eaef81db718a$export$3bf57e33594fa3fe)}${redirectPath}`); // translate to paper's login redirect system if we have a redirect url
            else window.sessionStorage.removeItem("postLoginRedirectUri");
            window.location.href = (0, $0fe4eaef81db718a$export$a96b260801e6da33);
        }
    }, [
        redirectPath,
        skipRedirect
    ]);
    const { username: username , password: password , setField: setField , submit: submit , success: success , errors: errors , submitting: submitting , load: load  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.LoginData, []);
    (0, $g5BLJ.useEffect)(()=>{
        load();
    }, [
        load
    ]);
    const onSubmit = (0, $g5BLJ.useCallback)(()=>submit({
            redirectPath: redirectPath,
            courseCode: courseCode,
            history: history
        }), [
        redirectPath,
        courseCode,
        history,
        submit
    ]);
    if ((0, $0fe4eaef81db718a$export$2cba2d9d62933240) && !skipRedirect) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        footer: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1).none} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]}`,
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray5",
                    variant: "h7",
                    weightOverride: "medium",
                    children: "By proceeding you also agree to our"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    sizeOverride: 10,
                    href: "https://www.readlee.com/terms-of-service",
                    children: "Terms of Service"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    color: "gray5",
                    variant: "h7",
                    weightOverride: "medium",
                    children: "and"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    horizontal: true
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                    sizeOverride: 10,
                    href: "https://www.readlee.com/privacy-policy",
                    children: "Privacy Policy"
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h2",
                children: "Log In"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Don't have an account? "
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: `${courseCode ? "/sign-up/student/class-code" : "/sign-up"}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                        children: "Sign up"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c8a864413785e08a$export$dc1434c1a71d39bc), {
                scopeKey: "just_name",
                successUrl: ssoSuccessUrl,
                forceOauth: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6b95aaca78d83e60$export$800b563f63fbe24a), {
                successUrl: ssoSuccessUrl,
                forceOauth: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $305adc5b3dd45e98$export$405b1ba3701f58c6), {
                color: "gray5",
                children: "or"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            query.get("justReset") && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ae13af7ccf5d135$export$caec2af78bcc877f), {
                children: "Your password has been reset, please log in with your new password"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "text",
                        name: "username",
                        label: "Username or Email",
                        errors: errors,
                        value: username,
                        onChange: setField("username")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "password",
                        label: "Password",
                        errors: errors,
                        type: "password",
                        value: password,
                        onChange: setField("password")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: "/forgot-password",
                        children: "Forgot password?"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        type: "submit",
                        loading: submitting,
                        width: "100%",
                        children: "Login"
                    }),
                    success && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Login success!"
                    })
                ]
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $e5efd731bbd156e5$export$cad1a703886b4e3a = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const logout = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.AppData.logout, []);
    (0, $g5BLJ.useEffect)(()=>{
        logout(history);
    }, [
        logout,
        history
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true
    });
};










var $g5BLJ = parcelRequire("g5BLJ");
const $b24f2e6ffde017b3$export$f139e6fb7d5f99a = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const sso = query.get("sso");
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const courseCodeParam = query.get("courseCode") || "";
    const { errors: errors , course: course , setCourseField: setCourseField , submit: submit , submitting: submitting , load: load  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.SignUpClassCodeData, []);
    (0, $g5BLJ.useEffect)(()=>{
        load();
        setCourseField("courseCode")(courseCodeParam);
        submit({
            history: history,
            query: query,
            courseCodeDeclined: false,
            courseCode: courseCodeParam,
            replace: true
        })();
    }, [
        load,
        submit,
        setCourseField,
        courseCodeParam,
        history,
        query
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                onSubmit: submit({
                    history: history,
                    query: query,
                    courseCode: course.courseCode,
                    courseCodeDeclined: false
                }),
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Enter your class code"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "courseCode",
                        label: "Class Code",
                        errors: errors,
                        type: "text",
                        value: course.courseCode,
                        onChange: setCourseField("courseCode")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        loading: submitting,
                        type: "submit",
                        disabled: course.courseCode.length === 0,
                        children: "Next"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Don't have a class code? Ask your teacher!"
            }),
            !sso && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Already a user?"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: `/login${courseCodeParam && `?courseCode=${encodeURIComponent(courseCodeParam)}`}`,
                        children: "Sign In"
                    })
                ]
            })
        ]
    });
};










var $g5BLJ = parcelRequire("g5BLJ");
const $71df25e57226b7c0$export$790383dda4f4f96a = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const { accountType: accountType  } = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const courseCode = query.get("courseCode") || "";
    const schoolCode = query.get("schoolCode") || "";
    const redirectPathParam = query.get("redirectPath") || "";
    const redirectPath = redirectPathParam || "/";
    const { loading: loading , errors: errors , user: user , course: course , school: school , setUserField: setUserField , submit: submit , submitting: submitting , load: load , fieldsMissing: fieldsMissing  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ SignUpRegisterData: surd  })=>({
            loading: surd.loading,
            errors: surd.errors,
            user: surd.user,
            course: surd.course,
            school: surd.school,
            setUserField: surd.setUserField,
            submit: surd.submit,
            submitting: surd.submitting,
            load: surd.load,
            fieldsMissing: surd.fieldsMissing
        }), []);
    (0, $g5BLJ.useEffect)(()=>load({
            accountType: accountType,
            courseCode: courseCode,
            schoolCode: schoolCode,
            query: query,
            history: history
        }), [
        accountType,
        courseCode,
        load,
        query,
        history,
        schoolCode
    ]);
    const referralCode = query.get("referralCode");
    const restrictFields = fieldsMissing.size > 0;
    const userAttributes = {
        accountType: accountType,
        courseCode: courseCode,
        courseCodeDeclined: !courseCode,
        referralCode: referralCode
    };
    (0, $g5BLJ.useEffect)(()=>{
        if (loading) return;
        if (user.accountType === "student" && !course) history.push(`/sign-up/student/class-code${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
        if (user.accountType === "teacher" && !school) history.push(`/sign-up/teacher/school-code${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
    }, [
        course,
        courseCode,
        history,
        loading,
        query,
        school,
        user.accountType
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: loading,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h1",
                children: [
                    "Let's get you signed up with a ",
                    user.accountType,
                    " account!"
                ]
            }),
            !restrictFields && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Make sure you sign up using your school accounts!"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c8a864413785e08a$export$dc1434c1a71d39bc), {
                        scopeKey: accountType === "student" ? "just_name" : "full_info",
                        userAttributes: userAttributes,
                        forceOauth: true,
                        successUrl: redirectPath,
                        children: "Sign Up with Google"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $6b95aaca78d83e60$export$800b563f63fbe24a), {
                        userAttributes: userAttributes,
                        forceOauth: true,
                        successUrl: redirectPath,
                        children: "Sign Up with Clever"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $305adc5b3dd45e98$export$405b1ba3701f58c6), {
                        children: "OR"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                onSubmit: submit(history, query),
                children: [
                    !course?.disableName && (!restrictFields || fieldsMissing.has("name")) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $e1e3f7b78974b405$export$b534bc812df080fd), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                name: "name",
                                label: "First Name",
                                errors: errors,
                                type: "text",
                                value: user.firstName,
                                onChange: setUserField("firstName")
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                name: "lastName",
                                label: "Last Name",
                                errors: errors,
                                type: "text",
                                value: user.lastName,
                                onChange: setUserField("lastName")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    (!restrictFields || fieldsMissing.has("email")) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                        children: course?.disableEmail ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            name: "username",
                            label: "Username",
                            errors: errors,
                            type: "text",
                            value: user.username,
                            onChange: setUserField("username")
                        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                            name: "email",
                            label: "Email",
                            errors: errors,
                            type: "email",
                            value: user.email || "",
                            onChange: setUserField("email")
                        })
                    }),
                    (!restrictFields || fieldsMissing.has("password")) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                name: "newPassword",
                                label: "Password",
                                errors: errors,
                                type: "password",
                                value: user.newPassword,
                                onChange: setUserField("newPassword")
                            })
                        ]
                    }),
                    course?.disableEmail && (!restrictFields || fieldsMissing.has("password")) && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                                name: "passwordConfirmation",
                                label: "Confirm Password",
                                errors: errors,
                                type: "password",
                                value: user.passwordConfirmation,
                                onChange: setUserField("passwordConfirmation")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                        errors: errors,
                        errorKey: "accountType"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        loading: submitting,
                        type: "submit",
                        children: "Create Account"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "By signing up for Readlee, you agree to"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                display: "inline-flex",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "our"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        display: "inline",
                        href: "https://www.readlee.com/terms-of-service",
                        children: "Terms of Service"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "and"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        display: "inline",
                        href: "https://www.readlee.com/privacy-policy",
                        children: "Privacy Policy"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
            !restrictFields && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Already a user?"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: `/login${courseCode ? `?courseCode=${encodeURIComponent(courseCode)}` : ""}`,
                        children: "Sign In"
                    })
                ]
            })
        ]
    });
};










var $g5BLJ = parcelRequire("g5BLJ");
const $95800f2107d69bea$export$dd6c7ffd63972e64 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const email = query.get("email");
    const firstName = query.get("firstName");
    const { resend: resend , resending: resending , resent: resent , load: load , errors: errors  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.SignUpConfirmationSentData, []);
    (0, $g5BLJ.useEffect)(load, [
        load
    ]);
    const str = `Thanks${firstName ? `  ${firstName}` : ""}!`;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h1",
                ellipsis: true,
                ellipsifiedTitle: str,
                children: str
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 5
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "You’re almost ready to get started."
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "We sent an email to ",
                    email || "your email",
                    " to verify your email to activate your Readlee account."
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 3
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "Didn’t receive an email?",
                    " ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        onClick: resend(email),
                        loading: resending,
                        disabled: resent,
                        children: "Resend Confirmation"
                    })
                ]
            }),
            resent && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: "Reset sent!"
            }),
            errors && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
                errors: errors,
                errorKey: "email"
            })
        ]
    });
};









var $g5BLJ = parcelRequire("g5BLJ");



const $2335734de65df94d$export$c4f8259ad3f94df5 = ()=>{
    const { id: id , token: token  } = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const [loading, setLoading] = (0, $g5BLJ.useState)(true);
    const [success, setSuccess] = (0, $g5BLJ.useState)(false);
    const [errors, setErrors] = (0, $g5BLJ.useState)((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)());
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const onSignedUp = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.AppData.onSignedUp, []);
    (0, $g5BLJ.useEffect)(()=>{
        setLoading(true);
        fetchJson(`/api/confirmation_email_tokens/${id}`, {
            method: "PATCH",
            data: {
                token: token
            },
            onSuccess: ({ success: success , errors: errors , user: user  })=>{
                setSuccess(success);
                setLoading(false);
                setErrors((0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(errors));
                if (success) onSignedUp({
                    user: user,
                    schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                    history: history,
                    redirectPath: user.accountType === "teacher" ? `/t/assignments` : "/",
                    method: "password",
                    replace: true
                });
            }
        });
    }, [
        id,
        token,
        history,
        onSignedUp,
        fetchJson
    ]);
    if (loading || success) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2758239e67023940$export$981215d1ec34b273), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $acaad050e5cfc31b$export$7f714e6c560938e5), {
            errors: errors,
            errorKey: "token"
        })
    });
};









const $461144fc90d852b8$export$c120a0e80fd44ca6 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const originalPath = query.get("originalPath");
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: false,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                children: [
                    "Error! ",
                    query.get("message") || (0, $8a14245e3a78cfb1$export$a8a6810e16d5704b)
                ]
            }),
            originalPath && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                to: originalPath,
                children: "Try Again!"
            }),
            " ",
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                to: "/",
                children: "Home"
            })
        ]
    });
};








const $2f4970606729f4c9$export$b597ee422a3143dc = ()=>{
    const { username: username , sentToTeacher: sentToTeacher , setField: setField , submit: submit , success: success , errors: errors , submitting: submitting , reset: reset  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.ForgotPasswordData, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h1",
                children: "Forgot Password?"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 5
            }),
            success ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "If your username or email is valid, you will receive an email with password reset instructions!"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    !sentToTeacher && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Check your email and open the link to continue."
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    }),
                    sentToTeacher ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: "Ask your instructor to check their email for request instructions or have them follow our help guide"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                to: "/help-docs-on-teacher-reset",
                                children: "here."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: "Didn't receive a message?"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                onClick: reset,
                                loading: submitting,
                                children: "Try again."
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                onSubmit: submit,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Enter your email or username to receive password reset instructions."
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        type: "text",
                        name: "username",
                        label: "Username or Email",
                        errors: errors,
                        value: username,
                        onChange: setField("username")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        type: "submit",
                        loading: submitting,
                        children: "Reset Password"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                children: "If you do not have access to your email, reach out to support"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                                newTab: true,
                                href: "https://readleesupport.zendesk.com/hc/en-us/requests/new",
                                children: "here."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");




const $47c745fcbea6bfbf$export$a4c3d56613a57187 = ()=>{
    const { id: id , token: token  } = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const { user: user , setUserField: setUserField , submit: submit , errors: errors , load: load , loading: loading  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.ResetPasswordData, []);
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    (0, $g5BLJ.useEffect)(()=>load({
            id: id,
            token: token
        }), [
        id,
        token,
        load
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: loading,
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h1",
                children: "Reset Password"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                onSubmit: submit(history),
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "newPassword",
                        label: "New Password",
                        errors: errors,
                        type: "password",
                        value: user.newPassword,
                        onChange: setUserField("newPassword")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "passwordConfirmation",
                        label: "Confirm Password",
                        errors: errors,
                        type: "password",
                        value: user.passwordConfirmation,
                        onChange: setUserField("passwordConfirmation")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        type: "submit",
                        children: "Reset Password"
                    })
                ]
            })
        ]
    });
};








var $b2151c2130174016$exports = {};

$b2151c2130174016$exports = new URL((parcelRequire("3TfdU")).resolve("eaQrv"), import.meta.url).toString();


var $1931fdeb9524a9ec$exports = {};

$1931fdeb9524a9ec$exports = new URL((parcelRequire("3TfdU")).resolve("01Mhl"), import.meta.url).toString();




const $769b74e7bc4a6320$var$TypeButtonContainer = (0, $f2062e8c5c08e6f7$export$2e2bcd8739ae039).div.withConfig({
    displayName: "SignUpAccountType__TypeButtonContainer",
    componentId: "sc-1f0nrio-0"
})([
    "background:",
    ";padding:",
    " ",
    ";border-radius:",
    ";:hover{background:",
    ";}"
], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex, (0, $8259eb090983b778$export$ea413736286a3bf1)[4], (0, $8259eb090983b778$export$ea413736286a3bf1)[8], (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[2], (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.active);
const $769b74e7bc4a6320$export$390727f371aa8966 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const sso = query.get("sso");
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2758239e67023940$export$981215d1ec34b273), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            align: "center",
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    justify: "center",
                    align: "end",
                    padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[8]}`,
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "noStyles",
                            to: `/sign-up/teacher/school-code${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($769b74e7bc4a6320$var$TypeButtonContainer, {
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    justify: "center",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                                            style: {
                                                maxHeight: "80px",
                                                maxWidth: "80px"
                                            },
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($b2151c2130174016$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 3
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h5",
                                            weightOverride: "medium",
                                            whiteSpace: "nowrap",
                                            children: "I'm a teacher"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 6,
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "noStyles",
                            to: `/sign-up/student/class-code${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($769b74e7bc4a6320$var$TypeButtonContainer, {
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    direction: "column",
                                    justify: "center",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("img", {
                                            style: {
                                                maxHeight: "80px",
                                                maxWidth: "80px"
                                            },
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($1931fdeb9524a9ec$exports)))
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                            size: 3
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            variant: "h5",
                                            weightOverride: "medium",
                                            whiteSpace: "nowrap",
                                            children: "I'm a student"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                !sso && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            children: "Already a user?"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                            to: "/login",
                            children: "Sign In"
                        })
                    ]
                })
            ]
        })
    });
};







var $g5BLJ = parcelRequire("g5BLJ");





const $b7e632a982aaf1ec$export$439b170cdb31c6a5 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const [loading, setLoading] = (0, $g5BLJ.useState)(true);
    const { onLoggedIn: onLoggedIn , onSignedUp: onSignedUp  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            onLoggedIn: state.AppData.onLoggedIn,
            onSignedUp: state.AppData.onSignedUp
        }), []);
    const code = query.get("code");
    const scope = query.get("scope");
    const state = query.get("state");
    const oauthComplete = query.get("oauthComplete");
    (0, $g5BLJ.useEffect)(()=>{
        setLoading(true);
        if (!(code || oauthComplete)) {
            const message = `Clever login failed.`;
            history.replace(`/500?message=${encodeURIComponent(message)}&originalPath=${encodeURIComponent("/login")}`);
        }
        fetchJson(`/api/clever_oauths`, {
            method: "POST",
            data: {
                code: code,
                scope: scope,
                state: state
            },
            onSuccess: (data)=>{
                if (data.status === "success") {
                    if (data.user && data.isNew) onSignedUp({
                        redirectPath: data.successUrl,
                        history: history,
                        method: "clever",
                        user: data.user,
                        schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)(),
                        replace: true
                    });
                    else onLoggedIn({
                        redirectPath: data.successUrl,
                        history: history,
                        method: "clever",
                        replace: true
                    });
                } else if (data.status === "oauth_required") history.replace(`/login${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                    redirectPath: data.successUrl ?? ""
                })}`);
                else if (data.status === "errored") {
                    const message = `Clever login failed.`;
                    history.replace(`/500${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        message: message,
                        originalPath: `/login${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                            redirectPath: data.successUrl ?? ""
                        })}`
                    })}`);
                } else if (data.status === "needs_email_confirmation") history.push(`/confirmation-sent${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)(data.user?.email ? {
                    email: data.user.email,
                    firstName: data.user.displayName
                } : {})}`);
                else if (data.status === "fields_missing") {
                    const errors = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors || {});
                    if (errors.has("accountType")) history.replace(`/sign-up${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        sso: "clever",
                        ssoName: "Clever",
                        redirectPath: data.successUrl ?? ""
                    })}`);
                    else history.replace(`/sign-up/${data.user?.accountType ?? "student"}/register${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        sso: "clever",
                        ssoName: "Clever",
                        fieldsMissing: Array.from(errors.keys()).join(","),
                        errors: JSON.stringify(data.errors || {}),
                        email: data.user?.email ? data.user.email : "",
                        redirectPath: data.successUrl ?? ""
                    })}`);
                }
            }
        });
    }, [
        code,
        oauthComplete,
        history,
        onLoggedIn,
        scope,
        state,
        onSignedUp,
        fetchJson
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: loading,
        children: "Clever Login"
    });
};






var $g5BLJ = parcelRequire("g5BLJ");






const $7a90f0a50792e5f0$export$4b780e52ee975c43 = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const [loading, setLoading] = (0, $g5BLJ.useState)(true);
    const [errored, setErrored] = (0, $g5BLJ.useState)(false);
    const [successUrl, setSuccessUrl] = (0, $g5BLJ.useState)();
    const [attemptedScopeKey, setAttemptedScopeKey] = (0, $g5BLJ.useState)();
    const [requiredScopeKey, setRequiredScopeKey] = (0, $g5BLJ.useState)();
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const { onLoggedIn: onLoggedIn , onSignedUp: onSignedUp  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            onLoggedIn: state.AppData.onLoggedIn,
            onSignedUp: state.AppData.onSignedUp
        }), []);
    const code = query.get("code");
    const oauthComplete = query.get("oauthComplete");
    (0, $g5BLJ.useEffect)(()=>{
        setLoading(true);
        if (!(code || oauthComplete)) {
            const message = `Google login failed.`;
            history.replace(`/500?message=${encodeURIComponent(message)}&originalPath=${encodeURIComponent("/login")}`);
        }
        fetchJson(`/api/google_oauths`, {
            method: "POST",
            data: {
                code: code
            },
            onSuccess: (data)=>{
                if (data.status === "success") {
                    if (data.user && data.isNew) onSignedUp({
                        redirectPath: data.successUrl,
                        replace: true,
                        history: history,
                        method: "google",
                        user: data.user,
                        schools: (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)()
                    });
                    else onLoggedIn({
                        redirectPath: data.successUrl,
                        replace: true,
                        history: history,
                        method: "google"
                    });
                } else if (data.status === "oauth_required") history.replace(`/login${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                    redirectPath: data.successUrl ?? ""
                })}`);
                else if (data.status === "errored") {
                    setErrored(true);
                    setLoading(false);
                    setSuccessUrl(data.successUrl);
                    setAttemptedScopeKey(data.scopeKey);
                } else if (data.status === "fields_missing") {
                    const errors = (0, $3f9a4df32f03e33e$export$a5c7b93649eaf8f8)(data.errors || {});
                    if (errors.has("accountType")) history.replace(`/sign-up${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        sso: "google",
                        ssoName: "Google",
                        redirectPath: data.successUrl ?? ""
                    })}`);
                    else if (errors.has("email") && errors.has("name")) {
                        setRequiredScopeKey("full_info");
                        setLoading(false);
                    } else if (errors.has("email")) {
                        setRequiredScopeKey("just_email");
                        setLoading(false);
                    } else if (errors.has("name")) {
                        setRequiredScopeKey("just_name");
                        setLoading(false);
                    } else history.replace(`/sign-up/${data.user?.accountType ?? "student"}/register${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                        sso: "google",
                        ssoName: "Google",
                        fieldsMissing: Array.from(errors.keys()).join(","),
                        errors: JSON.stringify(data.errors || {}),
                        email: data.user?.email ? data.user.email : "",
                        redirectPath: data.successUrl ?? ""
                    })}`);
                } else if (data.status === "needs_email_confirmation") history.replace(`/confirmation-sent${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)(data.user?.email ? {
                    email: data.user.email,
                    firstName: data.user.displayName
                } : {})}`);
            }
        });
    }, [
        code,
        oauthComplete,
        history,
        onLoggedIn,
        onSignedUp,
        fetchJson
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: loading,
        children: [
            requiredScopeKey && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    "We need a bit more information from Google to complete your account, please authorize again:",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c8a864413785e08a$export$dc1434c1a71d39bc), {
                        scopeKey: requiredScopeKey,
                        successUrl: successUrl,
                        forceOauth: true,
                        children: "Authorize with Google"
                    })
                ]
            }),
            errored && attemptedScopeKey && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    "There was an error trying to login, please click the button below to try again:",
                    " ",
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c8a864413785e08a$export$dc1434c1a71d39bc), {
                        scopeKey: attemptedScopeKey,
                        successUrl: successUrl,
                        forceOauth: true,
                        children: "Try Again"
                    })
                ]
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $8425b1a29ae87055$export$ca4a3f934baefe2f = ()=>{
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const courseCode = query.get("courseCode") || "";
    const { loading: loading , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData, []);
    (0, $g5BLJ.useEffect)(()=>{
        const doIt = ()=>{
            if (loading) return;
            if (!currentUser) return history.replace(`/sign-up/student/class-code?courseCode=${encodeURIComponent(courseCode)}`);
            if (currentUser.accountType === "teacher") return history.replace("/t/");
            history.replace(`/s/assignments?joinCode=${encodeURIComponent(courseCode)}`);
        };
        doIt();
    }, [
        courseCode,
        currentUser,
        history,
        loading
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: loading
    });
};






var $g5BLJ = parcelRequire("g5BLJ");




const $da3724cfaff11bbc$export$1aac3b59d92526db = ()=>{
    const { fetchJson: fetchJson  } = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { pathname: pathname , search: search  } = (0, $4ab21c8a3cbff9b4$export$45d76561a5302f2b)();
    const courseId = query.get("courseId") || "";
    const assessmentId = query.get("assessmentId") || "";
    const { loading: loading , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData, []);
    (0, $g5BLJ.useEffect)(()=>{
        const doIt = ()=>{
            if (loading) return;
            if (!currentUser) return history.replace(`/login${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                courseCode: query.get("courseCode") || "",
                redirectPath: pathname + search
            })}`);
            const successUrl = `/reading-studio${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                assessmentId: assessmentId,
                showInstructions: true
            })}`;
            if (currentUser.accountType !== "student") return history.replace(successUrl);
            else fetchJson(`/api/registration_assessments/create_from_link`, {
                method: "POST",
                data: {
                    assessmentId: assessmentId,
                    courseId: courseId
                },
                onSuccess: (data)=>{
                    if (data.success) history.replace(successUrl);
                }
            });
        };
        doIt();
    }, [
        assessmentId,
        courseId,
        currentUser,
        fetchJson,
        history,
        loading,
        pathname,
        search,
        query
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2758239e67023940$export$981215d1ec34b273), {
        loading: loading
    });
};






var $g5BLJ = parcelRequire("g5BLJ");



const $a3b80250b48427c2$export$1a08df822e05c415 = ()=>{
    (0, $g5BLJ.useEffect)(()=>{
        (0, $8a14245e3a78cfb1$export$97131b3b5327c27f).remove("user_session_id");
        (0, $8a14245e3a78cfb1$export$97131b3b5327c27f).remove("user_session_token");
        window.location.href = `${window.location.origin}${(0, $0fe4eaef81db718a$export$2cba2d9d62933240) ? "" : "/login"}`;
    }, []);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
};






var $g5BLJ = parcelRequire("g5BLJ");
















const $d5dd97f70cef244c$var$TranscriptionKey = ()=>{
    const { currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData, []);
    const isStudent = currentUser?.accountType === "student";
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                backgroundColor: "#4B7AC1",
                borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3],
                padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h4",
                        children: "Pro Tip"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h5",
                        children: "Click on any word to jump to that part of the recording."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("span", {
                style: {
                    color: "black"
                },
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    direction: "column",
                    backgroundColor: "#ECF0FD",
                    borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[3],
                    padding: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]} 0 ${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`,
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h4",
                            children: "What do the colors mean?"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)("ul", {
                            style: {
                                paddingLeft: `${(0, $8259eb090983b778$export$ea413736286a3bf1)[4]}`
                            },
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h5",
                                        children: "We understood this"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 1
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $833286d0285c78bf$export$7cebf6ef7d19a95), {
                                        textSizeOverride: 16,
                                        variant: "del",
                                        children: "We didn't hear this"
                                    })
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    size: 1
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("li", {
                                    children: isStudent ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $833286d0285c78bf$export$7cebf6ef7d19a95), {
                                        textSizeOverride: 16,
                                        color: "success",
                                        children: "You marked this as correct"
                                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $833286d0285c78bf$export$7cebf6ef7d19a95), {
                                        textSizeOverride: 16,
                                        variant: "ins",
                                        children: "We heard this instead"
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 4
            })
        ]
    });
};
const $d5dd97f70cef244c$export$cdea73a9a403baa2 = ()=>{
    const { submission: submission , taskSubmissionDetailsMap: taskSubmissionDetailsMap , assessment: assessment , currentTaskId: currentTaskId , user: user , currentUser: currentUser , userToSubmissionIdMap: userToSubmissionIdMap , userMap: userMap , comments: comments , openCommentModal: openCommentModal , transcriptionVisible: transcriptionVisible  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            submission: state.SubmissionOverviewData.submission,
            taskSubmissionDetailsMap: state.SubmissionOverviewData.taskSubmissionDetailsMap,
            assessment: state.SubmissionOverviewData.assessment,
            currentTaskId: state.SubmissionOverviewData.currentTaskId,
            user: state.SubmissionOverviewData.user,
            userToSubmissionIdMap: state.SubmissionOverviewData.userToSubmissionIdMap,
            userMap: state.SubmissionOverviewData.userMap,
            comments: state.SubmissionOverviewData.comments,
            openCommentModal: state.SubmissionOverviewData.openCommentModal,
            transcriptionVisible: state.SubmissionOverviewData.transcriptionVisible,
            currentUser: state.AppData.currentUser
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const readingTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$c44a57905a1523a2)();
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const processing = taskSubmissionDetailsMap.some((t)=>t.type === "ReadingTask" && (0, $e5b5f83b06fa9066$export$1fa8d6d6ddd4ed27)(t));
    const isStudent = currentUser?.accountType === "student";
    const sortedUserList = userMap.toList().sortBy((u)=>[
            !userToSubmissionIdMap?.has(u.id),
            (0, $75cd274e63beb59b$export$61b6a526e2f145be)(u)
        ]);
    const sortedUsersWithSubmissions = sortedUserList.filter((student)=>userToSubmissionIdMap?.has(student.id));
    const studentOptions = sortedUserList.map((user)=>({
            label: `${userToSubmissionIdMap?.has(user.id) ? "" : "(DNC) "}${(0, $e6116bf527c207db$export$c8cfcdb41be1b46c)(user.displayName, 20)}`,
            value: user.id,
            disabled: !userToSubmissionIdMap?.has(user.id)
        }));
    if (!readingTaskSubmissionDetails || !submission) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        flexWidth: "400px"
    });
    const submissionIndex = sortedUsersWithSubmissions.findIndex((s)=>s.id === user?.id);
    const previous = submissionIndex > 0 ? sortedUsersWithSubmissions.get(submissionIndex - 1) : null;
    const previousSubmission = previous ? userToSubmissionIdMap?.get(previous.id) : null;
    const next = sortedUsersWithSubmissions.get(submissionIndex + 1);
    const nextSubmission = next ? userToSubmissionIdMap?.get(next.id) : null;
    const reaction = comments.filter(({ comment: comment  })=>comment.reaction !== "undecided").last()?.comment.reaction;
    const showNavigation = sortedUserList.count() > 1;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $1941c1cb7fdcc73d$export$206b65ea4daedc5b), {
        content: readingTaskSubmissionDetails && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            grow: 1,
            children: [
                !isStudent && showNavigation && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            direction: "row",
                            align: "center",
                            justify: "space-between",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "noStyles",
                                    color: "backgroundDark",
                                    disabled: !previous,
                                    testTag: "prev-submission",
                                    to: previousSubmission ? `/submissions/${previousSubmission}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}` : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                            icon: "arrowLeft",
                                            size: "1.75em",
                                            color: previous ? "white" : "gray7"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            color: previous ? "white" : "gray7",
                                            variant: "h6",
                                            children: "Previous"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                    displayType: "noStyles",
                                    color: "backgroundDark",
                                    disabled: !next,
                                    testTag: "next-submission",
                                    to: nextSubmission ? `/submissions/${nextSubmission}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}` : undefined,
                                    children: [
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            color: next ? "white" : "gray7",
                                            variant: "h6",
                                            children: "Next"
                                        }),
                                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $10bc7d3c3c9731ce$export$f04a61298a47a40f), {
                                            icon: "arrowRight",
                                            size: "1.75em",
                                            color: next ? "white" : "gray7"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        })
                    ]
                }),
                isStudent && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    children: [
                        user && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b22773065c4c76be$export$7334e79c2ba625e7), {
                                    user: user,
                                    kind: "submission",
                                    testTag: "submission-avatar"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                            variant: "h3",
                            children: user?.displayName
                        })
                    ]
                }),
                !isStudent && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $72c4360166cb2772$exports.Fragment), {
                    children: showNavigation ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $813faab610558317$export$d6701e98ab1a6725), {
                        id: "studentSelect",
                        displayType: "sidebar",
                        name: "Student Select",
                        value: user?.id,
                        title: user?.name ?? undefined,
                        onChange: (newVal)=>{
                            const next = userToSubmissionIdMap?.get(newVal);
                            if (next) history.push(`/submissions/${next}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query)}`);
                        },
                        options: studentOptions
                    }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h4",
                        children: user?.name
                    })
                }),
                submission.rating !== null && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 4
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                    variant: "h6",
                                    children: "STUDENT INTEREST:"
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                    horizontal: true,
                                    size: 2
                                }),
                                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $aebf6eac7f74b94e$export$76529f19140ac2e7), {
                                    rating: submission.rating,
                                    borderColor: "white"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c804cca3b5e1a4fd$export$9703f6f83eb29232), {
                    processing: processing,
                    user: user,
                    readingTaskSubmissionDetails: readingTaskSubmissionDetails,
                    hasPremiumStats: !isStudent,
                    lastSubmitted: submission.finishedAt
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                    variant: "h6",
                    color: "white",
                    children: "MY TASKS"
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 4
                }),
                assessment?.taskOrder.map((task)=>taskSubmissionDetailsMap.get(task.taskId)).filter((t)=>Boolean(t)).map((taskSubmissionDetails)=>{
                    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                        icon: (0, $dfca2c43c391cf73$export$86cab8d3a8167972)(taskSubmissionDetails.task),
                        active: taskSubmissionDetails.task.id === currentTaskId,
                        to: `/submissions/${submission.id}${(0, $5557eb3ea8c47b66$export$e4897436d02202c9)(query.set("currentTaskId", taskSubmissionDetails.task.id))}`,
                        completed: taskSubmissionDetails && (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails),
                        children: taskSubmissionDetails.task.name
                    }, taskSubmissionDetails.task.id);
                }),
                isStudent && comments.size > 0 && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $df6c3a1bdb65fda3$export$2e0a83ec2e27ecbb), {}),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                            reaction: reaction,
                            icon: "chatBubble",
                            onClick: openCommentModal,
                            completed: comments.every((c)=>c.comment.viewed === true),
                            active: false,
                            children: [
                                "Teacher Feedback (",
                                comments.size,
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {}),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                transcriptionVisible && readingTaskSubmissionDetails.task.readingPartType !== "independent" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($d5dd97f70cef244c$var$TranscriptionKey, {}),
                isStudent && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "outline",
                            color: "white",
                            to: `/reading-studio?assessmentId=${assessment?.id}`,
                            children: [
                                "Edit My Submission",
                                " "
                            ]
                        })
                    ]
                })
            ]
        })
    });
};




var $g5BLJ = parcelRequire("g5BLJ");







const $cb1f9a14dfa6f6ce$export$37d641b7d6b469f8 = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const { assessment: assessment , openCommentModal: openCommentModal , comments: comments , startAssignmentUpgrade: startAssignmentUpgrade  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ SubmissionOverviewData: s , UpgradeAssignmentModalData: ua  })=>({
            assessment: s.assessment,
            openCommentModal: s.openCommentModal,
            comments: s.comments,
            startAssignmentUpgrade: ua.startAssignmentUpgrade
        }), []);
    const currentUser = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentUser, []);
    const currentPlan = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>s.AppData.currentPlan, []);
    const [textSettingsOpened, setTextSettingsOpened] = (0, $g5BLJ.useState)(false);
    const readingTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$c44a57905a1523a2)();
    const isStudent = currentUser?.accountType === "student";
    const defaultBackPath = isStudent ? "/s" : `/t/assignments/${assessment?.id}`;
    const backPath = isStudent ? query.get("backPath") || "/s" : query.get("backPath");
    const usageCapsEnabled = currentPlan.isUsageCapsEnabled;
    const availableUltimateAssessments = currentUser?.ultimateAssessmentsAvailable ?? 0;
    const canGiveFeedback = (0, $4ded3b2c5af96cca$export$cff2a6c9a7debd3)("isTeacherFeedbackEnabled", currentUser, assessment, false);
    const startUpgrade = (0, $g5BLJ.useCallback)(()=>startAssignmentUpgrade(assessment?.id ?? "", "feedback"), [
        assessment?.id,
        startAssignmentUpgrade
    ]);
    if (!readingTaskSubmissionDetails) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                flex: true,
                flexHeight: "auto"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            })
        ]
    });
    const { reading: reading , coverImageFile: coverImageFile , author: author , contentFile: contentFile  } = readingTaskSubmissionDetails || {};
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d361bb1339f62201$export$d390129da57cce20), {
        leftButton: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
            color: "gray2",
            nav: true,
            to: backPath || defaultBackPath,
            icon: "backArrow",
            children: "Back"
        }),
        thumbnailUrl: coverImageFile?.thumbnailUrl,
        readingTitle: reading?.name,
        authorName: (0, $62e5f0fd429b4502$export$6f2a8f5fb5b5ba40)(assessment, author),
        rightButtons: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "center",
            children: [
                !isStudent && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $be64e7ee3b40f0c7$export$13c138588c4d3358), {
                            enabled: !canGiveFeedback,
                            content: `Upgrade to ${(0, $4ded3b2c5af96cca$export$52756c3ad45aa25c)} to provide your students individualized feedback on their assignments!`,
                            linkLocation: "contact",
                            usageCapsEnabled: usageCapsEnabled,
                            availableUltimateAssessments: availableUltimateAssessments,
                            onClick: startUpgrade,
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                onClick: openCommentModal,
                                testTag: "teacher-open-comments",
                                disabled: !canGiveFeedback,
                                children: [
                                    "Student Feedback",
                                    comments.isEmpty() ? "" : ` (${comments.size})`
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            horizontal: true,
                            size: 2
                        })
                    ]
                }),
                ![
                    "PdfStoredFile",
                    "PdfByPageStoredFile"
                ].includes(contentFile?.type || "") && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                    icon: "text",
                    onClick: ()=>setTextSettingsOpened(true),
                    testTag: "text-settings",
                    displayType: "iconOnly",
                    width: "36px",
                    height: "36px",
                    color: "gray2",
                    iconColor: "black",
                    iconSize: "24px",
                    paddingOverride: (0, $8259eb090983b778$export$ea413736286a3bf1).none
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ed14308b705832ba$export$f0753697e9ebcd44), {
                    opened: textSettingsOpened,
                    close: ()=>setTextSettingsOpened(false)
                })
            ]
        })
    });
};








const $18f2ca4099601740$export$b217475cf0d7b767 = ()=>{
    const { onRecordingSequenceStatus: onRecordingSequenceStatus , createRecordingSequence: createRecordingSequence , createReactionComment: createReactionComment , createWrittenComment: createWrittenComment , createAudioComment: createAudioComment , creatingRecordingSequence: creatingRecordingSequence , savingComment: savingComment , setField: setField , editingCommentType: editingCommentType , editingRecordingSequence: editingRecordingSequence , editingAudioFile: editingAudioFile , editingWrittenContent: editingWrittenContent , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            onRecordingSequenceStatus: s.SubmissionOverviewData.onRecordingSequenceStatus,
            createRecordingSequence: s.SubmissionOverviewData.createRecordingSequence,
            createReactionComment: s.SubmissionOverviewData.createReactionComment,
            createWrittenComment: s.SubmissionOverviewData.createWrittenComment,
            createAudioComment: s.SubmissionOverviewData.createAudioComment,
            creatingRecordingSequence: s.SubmissionOverviewData.creatingRecordingSequence,
            savingComment: s.SubmissionOverviewData.savingComment,
            setField: s.SubmissionOverviewData.setField,
            editingCommentType: s.SubmissionOverviewData.editingCommentType,
            editingRecordingSequence: s.SubmissionOverviewData.editingRecordingSequence,
            editingAudioFile: s.SubmissionOverviewData.editingAudioFile,
            editingWrittenContent: s.SubmissionOverviewData.editingWrittenContent,
            isRecording: s.AppData.isRecording
        }), []);
    if (editingCommentType === "undecided") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        align: "stretch",
        height: "40px",
        justify: "center",
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                onClick: ()=>setField("editingCommentType")("written"),
                icon: "pencil",
                iconFill: true,
                iconStrokeWidth: 0,
                iconSize: "1.25em",
                zIndex: "toast",
                children: "Write"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2,
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                loading: creatingRecordingSequence,
                onClick: createRecordingSequence,
                icon: "microphone",
                iconStrokeWidth: 1,
                children: "Record"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2,
                horizontal: true
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ba614b87bf9c7fa$export$6ce3894c36b53067), {
                onClick: createReactionComment,
                loading: savingComment
            })
        ]
    });
    const ActionButtons = ({ action: action  })=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                    size: 2
                }),
                /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                    align: "center",
                    justify: "end",
                    children: [
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            displayType: "link",
                            onClick: ()=>setField("editingCommentType")("undecided"),
                            disabled: isRecording,
                            testTag: "cancel-recording",
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                            size: 2,
                            horizontal: true
                        }),
                        /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                            onClick: action,
                            loading: savingComment,
                            disabled: isRecording || editingCommentType === "written" && !editingWrittenContent,
                            children: "Send"
                        })
                    ]
                })
            ]
        });
    if (editingCommentType === "recorded" && editingRecordingSequence) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        justify: "center",
        align: "stretch",
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "center",
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        justify: "center",
                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d997a72120805c5c$export$de95611a92ae0566), {
                            recordingSequence: editingRecordingSequence,
                            audioFile: editingAudioFile,
                            onRecordingSequenceStatus: onRecordingSequenceStatus,
                            displayType: "desktopSmall"
                        })
                    }),
                    !editingAudioFile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                displayType: "link",
                                onClick: ()=>setField("editingCommentType")("undecided"),
                                disabled: isRecording,
                                testTag: "cancel-recording",
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            }),
            editingAudioFile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(ActionButtons, {
                action: createAudioComment
            })
        ]
    });
    else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        direction: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2afb870564c4e4d2$export$ce9b1cc0c34506d0), {
                name: "writtenContent",
                value: editingWrittenContent,
                onChange: setField("editingWrittenContent"),
                placeholder: "Write your feedback here",
                height: "100%",
                width: "100%"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)(ActionButtons, {
                action: createWrittenComment
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");




const $d30d73ea111b78d4$export$4d299b491347818a = ({ commentDetails: commentDetails , isLast: isLast  })=>{
    const { deleteComment: deleteComment , currentUser: currentUser , userMap: userMap , commentModalOpened: commentModalOpened , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((s)=>({
            deleteComment: s.SubmissionOverviewData.deleteComment,
            userMap: s.SubmissionOverviewData.userMap,
            commentModalOpened: s.SubmissionOverviewData.commentModalOpened,
            currentUser: s.AppData.currentUser,
            isRecording: s.AppData.isRecording
        }), []);
    const bottomRef = (0, $g5BLJ.useRef)(null);
    (0, $g5BLJ.useEffect)(()=>{
        if (isLast && commentModalOpened) bottomRef.current?.scrollIntoView({
            behavior: "auto"
        });
    }, [
        isLast,
        bottomRef,
        commentModalOpened
    ]);
    if (!currentUser) return null;
    const { comment: comment , audioFile: audioFile  } = commentDetails;
    const commenter = userMap.set(currentUser.id, currentUser).get(comment.creatorId);
    if (!commenter) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "start",
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c2bde156fbc0eb06$export$6c0524ba53950d9f), {
                        backgroundColor: commenter.avatarColor || (0, $24b764039c44d1ec$export$8f45430ccf837300).primaryBlue.hex,
                        name: `${commenter.displayName} - ${(0, $73b0620564a5efc3$export$8b492ed8828f789c)(new Date(comment.createdAt))}`
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2,
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        align: "center",
                        width: "100%",
                        testTag: "comment",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundLight.hex,
                                borderRadius: (0, $66d768ad338179b8$export$c6a3dd61111e2ebc)[4],
                                padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[2],
                                align: "center",
                                justify: "start",
                                width: "fit-content",
                                children: [
                                    comment.commentType === "written" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                            color: "black",
                                            children: comment.writtenContent
                                        })
                                    }),
                                    comment.commentType === "recorded" && audioFile && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
                                        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                            align: "center",
                                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                                                placeholder: "Listen to the comment",
                                                audioFileId: audioFile.id,
                                                src: audioFile.url,
                                                displayType: "desktopSmall",
                                                trackMinWidth: "140px",
                                                disabled: isRecording,
                                                testTag: "recorded-comment"
                                            })
                                        })
                                    }),
                                    comment.commentType === "reaction" && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ba614b87bf9c7fa$export$d2ae4167a30cf6bb), {
                                        kind: comment.reaction,
                                        size: "large"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 2,
                                horizontal: true
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$33f7c4b36d836354), {
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                    justify: "end",
                                    children: currentUser.id === comment.creatorId && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f9d4fe70f15fa820$export$e44a253a59704894), {
                                        displayType: "iconOnly",
                                        color: "backgroundLight",
                                        iconColor: "black",
                                        icon: "threeVerticalDots",
                                        iconSize: "1.5em",
                                        testTag: `comment-settings-${comment.id}`,
                                        noButtonPadding: true,
                                        rightAligned: true,
                                        disabled: isRecording,
                                        options: [
                                            {
                                                children: "Delete Comment",
                                                onClick: ()=>deleteComment(comment.id)
                                            }
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            isLast && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)("div", {
                ref: bottomRef
            })
        ]
    });
};



const $e5d32e57759481ba$export$dd62f1fd0d4a469b = ()=>{
    const { setField: setField , commentModalOpened: commentModalOpened , accountType: accountType = "student" , comments: comments , currentUser: currentUser , assessment: assessment , isRecording: isRecording  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: AppData , SubmissionOverviewData: SubmissionOverviewData  })=>({
            setField: SubmissionOverviewData.setField,
            assessment: SubmissionOverviewData.assessment,
            commentModalOpened: SubmissionOverviewData.commentModalOpened,
            comments: SubmissionOverviewData.comments,
            currentUser: AppData.currentUser,
            accountType: AppData.currentUser?.accountType,
            isRecording: AppData.isRecording
        }), []);
    const canOpenFeedback = (0, $4ded3b2c5af96cca$export$cff2a6c9a7debd3)("isTeacherFeedbackEnabled", currentUser, assessment, true);
    const width = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThan: "tabletSmall"
    }) ? "90%" : "550px";
    const height = "600px";
    if (!canOpenFeedback || !commentModalOpened) return null;
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $800aabf72745714c$export$72f77866d312088b), {
        opened: true,
        openType: "state",
        maxWidthOverride: width,
        minWidthOverride: width,
        minHeightOverride: height,
        maxHeightOverride: height,
        header: accountType === "student" ? "Teacher Feedback" : "Leave Comments",
        close: ()=>setField("commentModalOpened")(false),
        disableFadeClose: true,
        footer: accountType === "student" ? null : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            width: "100%",
            testTag: "create-comment-footer",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $18f2ca4099601740$export$b217475cf0d7b767), {})
        }),
        disableClose: isRecording,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            children: comments.isEmpty() ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                align: "center",
                justify: "center",
                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $52ff035cf18eb297$export$fddf379e22a74b00), {
                    kind: "emptyComments",
                    displayType: "minimal"
                })
            }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    comments.sortBy((c)=>c.comment.createdAt).map((comment, i)=>/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d30d73ea111b78d4$export$4d299b491347818a), {
                            commentDetails: comment,
                            isLast: i === comments.size - 1
                        }, comment.comment.id)),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 4
                    })
                ]
            })
        })
    });
};












const $544a9166e5cb34f0$export$cad57e1d4bf5ceb3 = ()=>{
    const { loading: loading , submission: submission , taskSubmissionDetailsMap: taskSubmissionDetailsMap , assessment: assessment , user: user , currentUser: currentUser  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ SubmissionOverviewData: s , AppData: a  })=>({
            loading: s.loading,
            submission: s.submission,
            taskSubmissionDetailsMap: s.taskSubmissionDetailsMap,
            assessment: s.assessment,
            user: s.user,
            currentUser: a.currentUser
        }), []);
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const readingTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$c44a57905a1523a2)();
    const isStudent = currentUser?.accountType === "student";
    const defaultBackPath = isStudent ? "/s" : `/t/assignments/${assessment?.id}`;
    const backPath = isStudent ? query.get("backPath") || "/s" : query.get("backPath");
    const processing = taskSubmissionDetailsMap.some((t)=>t.type === "ReadingTask" && (0, $e5b5f83b06fa9066$export$1fa8d6d6ddd4ed27)(t));
    const { reading: reading , coverImageFile: coverImageFile , author: author  } = readingTaskSubmissionDetails || {};
    if (loading || !submission) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $ad8e3cbc7ee8beea$export$c74548264adbc916), {
                enabled: !processing
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                direction: "column",
                flex: 1,
                backgroundColor: (0, $24b764039c44d1ec$export$8f45430ccf837300).backgroundDark.hex,
                padding: (0, $8259eb090983b778$export$ea413736286a3bf1)[3],
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                color: "gray2",
                                nav: true,
                                to: backPath || defaultBackPath,
                                icon: "backArrow",
                                children: "Back"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                horizontal: true,
                                size: 2
                            }),
                            isStudent && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                                displayType: "outline",
                                color: "white",
                                to: `/reading-studio?assessmentId=${assessment?.id}`,
                                children: "Edit My Submission"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 6
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                direction: "column",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b6a7894f2ced43d4$export$1cd1efc78cb52ca5), {
                                        src: coverImageFile?.thumbnailUrl,
                                        size: "large",
                                        title: reading?.name
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h5",
                                        ellipsis: true,
                                        ellipsifiedTitle: reading?.name || "Unknown Book Title",
                                        testTag: "reading-studio-layout-top-bar-title",
                                        color: "white",
                                        maxWidth: "100%",
                                        children: reading?.name || "Unknown Book Title"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                        variant: "h6",
                                        color: "gray5",
                                        ellipsis: true,
                                        ellipsifiedTitle: (0, $62e5f0fd429b4502$export$6f2a8f5fb5b5ba40)(assessment, author) || "Unknown Author",
                                        testTag: "reading-studio-layout-top-bar-author",
                                        maxWidth: "100%",
                                        children: (0, $62e5f0fd429b4502$export$6f2a8f5fb5b5ba40)(assessment, author) || "Unknown Author"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 6
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                justify: "center",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c804cca3b5e1a4fd$export$9703f6f83eb29232), {
                                    processing: processing,
                                    user: user,
                                    readingTaskSubmissionDetails: readingTaskSubmissionDetails,
                                    hasPremiumStats: !isStudent,
                                    lastSubmitted: submission.finishedAt,
                                    isMobileView: true
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                size: 6
                            }),
                            submission.rating !== null && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                                        align: "center",
                                        justify: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                                variant: "h6",
                                                color: "white",
                                                children: "STUDENT INTEREST:"
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                                horizontal: true,
                                                size: 2
                                            }),
                                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $aebf6eac7f74b94e$export$76529f19140ac2e7), {
                                                rating: submission.rating,
                                                borderColor: "white"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                                        size: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                                variant: "h6",
                                color: "white",
                                textAlign: "center",
                                children: "MY TASKS"
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {}),
                            assessment?.taskOrder.map((task)=>taskSubmissionDetailsMap.get(task.taskId)).filter((t)=>Boolean(t)).map((taskSubmissionDetails)=>{
                                return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8842f591f4d16288$export$fd1e41c372d10c35), {
                                    icon: (0, $dfca2c43c391cf73$export$86cab8d3a8167972)(taskSubmissionDetails.task),
                                    active: false,
                                    completed: taskSubmissionDetails && (0, $2f14aa3b16c7856e$export$762b2163c3ce6757)(taskSubmissionDetails),
                                    children: taskSubmissionDetails.task.name
                                }, taskSubmissionDetails.task.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



const $70060919ba5e42cc$var$DrawerContent = ()=>{
    const { initialPlayProgress: initialPlayProgress , playIndex: playIndex , submission: submission , drawerExpanded: drawerExpanded , assessment: assessment , setField: setField , currentUser: currentUser , currentPlan: currentPlan , startAssignmentUpgrade: startAssignmentUpgrade  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            assessment: state.SubmissionOverviewData.assessment,
            initialPlayProgress: state.SubmissionOverviewData.initialPlayProgress,
            playIndex: state.SubmissionOverviewData.playIndex,
            submission: state.SubmissionOverviewData.submission,
            drawerExpanded: state.SubmissionOverviewData.drawerExpanded,
            setField: state.SubmissionOverviewData.setField,
            currentUser: state.AppData.currentUser,
            currentPlan: state.AppData.currentPlan,
            startAssignmentUpgrade: state.UpgradeAssignmentModalData.startAssignmentUpgrade
        }), []);
    const currentTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$387094ddcc67c137)();
    const textDiffs = currentTaskSubmissionDetails?.type === "ComprehensionTask" ? currentTaskSubmissionDetails.responseAudioFile?.transcriptItems : undefined;
    if (!currentTaskSubmissionDetails) return null;
    const usageCapsEnabled = currentPlan.isUsageCapsEnabled;
    const availableUltimateAssessments = currentUser?.ultimateAssessmentsAvailable ?? 0;
    const content = /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2135cded5d0ee362$export$9d291641d34dfc61), {
        showStats: false,
        submission: submission || undefined,
        taskDetails: currentTaskSubmissionDetails,
        taskSubmissionDetails: currentTaskSubmissionDetails,
        playIndex: playIndex,
        initialPlayProgress: initialPlayProgress,
        drawerExpanded: drawerExpanded,
        textSize: currentUser?.textSize,
        canSeeTranscription: (0, $4ded3b2c5af96cca$export$cff2a6c9a7debd3)("isComprehensionTranscriptEnabled", currentUser, assessment, true),
        comprehensionTextDiff: textDiffs,
        usageCapsEnabled: usageCapsEnabled,
        availableUltimateAssessments: availableUltimateAssessments,
        toolTipOnClick: ()=>startAssignmentUpgrade(assessment?.id ?? "", "comprehensionTranscription")
    });
    if (currentTaskSubmissionDetails.type === "ReadingTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
        expanded: drawerExpanded,
        children: content
    });
    else if (currentTaskSubmissionDetails.type === "ComprehensionTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
        header: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e4ad9cb1b5a13026$export$6f0f9793d5b4ba54), {
            currentTaskSubmissionDetails: currentTaskSubmissionDetails,
            displayType: drawerExpanded ? "drawerOpen" : "drawerClosed",
            toggleOpen: ()=>setField("drawerExpanded")(!drawerExpanded),
            textSize: currentUser?.textSize
        }),
        expanded: drawerExpanded,
        children: content
    });
    else if (currentTaskSubmissionDetails.type === "ModelTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
        header: currentTaskSubmissionDetails.audioFile ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            align: "center",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $62067085360d9386$export$832cc5475f11d8b4), {
                displayType: "desktopSmall",
                src: currentTaskSubmissionDetails.audioFile?.url,
                audioFileId: currentTaskSubmissionDetails.audioFile?.id,
                placeholder: "Listen to Model Reading",
                testTag: "play-model-reading"
            })
        }) : null,
        expanded: drawerExpanded,
        children: content
    });
    else if (currentTaskSubmissionDetails.type === "VocabTask") return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f74c17054336d2ed$export$4071300121a182f5), {
        header: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $eff21641a640db3b$export$94e686fa7071a8d3), {
            currentTaskSubmissionDetails: currentTaskSubmissionDetails
        }),
        children: content
    });
    else throw new Error("Unrecognized task type");
};
const $70060919ba5e42cc$var$MainContent = ()=>{
    const { setPlayProgress: setPlayProgress , textDiffMap: textDiffMap , errorDisputesMap: errorDisputesMap , taskSubmissionDetailsMap: taskSubmissionDetailsMap , transcriptionVisible: transcriptionVisible , currentUser: currentUser , currentPlan: currentPlan , assessment: assessment , startAssignmentUpgrade: startAssignmentUpgrade  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>({
            assessment: state.SubmissionOverviewData.assessment,
            setPlayProgress: state.SubmissionOverviewData.setPlayProgress,
            textDiffMap: state.SubmissionOverviewData.textDiffMap,
            errorDisputesMap: state.SubmissionOverviewData.errorDisputesMap,
            taskSubmissionDetailsMap: state.SubmissionOverviewData.taskSubmissionDetailsMap,
            transcriptionVisible: state.SubmissionOverviewData.transcriptionVisible,
            currentUser: state.AppData.currentUser,
            currentPlan: state.AppData.currentPlan,
            startAssignmentUpgrade: state.UpgradeAssignmentModalData.startAssignmentUpgrade
        }), []);
    const startUpgrade = (0, $g5BLJ.useCallback)(()=>startAssignmentUpgrade(assessment?.id ?? "", "fullTranscription"), [
        assessment?.id,
        startAssignmentUpgrade
    ]);
    const readingTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$c44a57905a1523a2)();
    const currentTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$387094ddcc67c137)();
    if (!readingTaskSubmissionDetails) return null;
    const errored = taskSubmissionDetailsMap.some((t)=>t.type === "ReadingTask" && (0, $e5b5f83b06fa9066$export$9b6c44d21ec830b4)(t));
    const processing = taskSubmissionDetailsMap.some((t)=>t.type === "ReadingTask" && (0, $e5b5f83b06fa9066$export$1fa8d6d6ddd4ed27)(t));
    const isStudent = currentUser?.accountType === "student";
    const textDiff = textDiffMap.get(readingTaskSubmissionDetails.task.id);
    const errorDisputes = errorDisputesMap.get(readingTaskSubmissionDetails.task.id, (0, $3f9a4df32f03e33e$export$54c2e3dc7acea9f5)());
    if (errored) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        height: "100%",
        width: "100%",
        align: "center",
        justify: "center",
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
            variant: "h1",
            children: "There was an error processing this submission, please check the recording."
        })
    });
    else if (processing) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        height: "100%",
        width: "100%",
        align: "center",
        justify: "center",
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                variant: "h1",
                children: "Processing"
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                horizontal: true,
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
                size: "large"
            })
        ]
    });
    else if (!transcriptionVisible) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
        width: "100%",
        justify: "center",
        grow: 1,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
            direction: "column",
            align: "center",
            justify: "center",
            maxWidth: "700px",
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0a5d8e8de2fe8d78$export$40d7a77ab2e3394), {
                testTag: "empty-state-submission-hidden",
                illustration: (0, (/*@__PURE__*/$parcel$interopDefault($7ebbbda8d7c15b1b$exports))),
                primaryText: "Listen to your recording and check out your reading stats!"
            })
        })
    });
    else if (textDiff && textDiff.prunedItems.size > 0) {
        const isIndependent = readingTaskSubmissionDetails.reading.contentType === "independent";
        const blur = !(0, $4ded3b2c5af96cca$export$cff2a6c9a7debd3)("isFullTranscriptionEnabled", currentUser, assessment, true);
        const blurAll = blur && isIndependent;
        const usageCapsEnabled = currentPlan.isUsageCapsEnabled;
        const availableUltimateAssessments = currentUser?.ultimateAssessmentsAvailable ?? 0;
        return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $833286d0285c78bf$export$c365c0e83f659e4b), {
            textDiff: textDiff,
            errorDisputes: errorDisputes,
            onTimeSelected: setPlayProgress,
            showAdditions: !isStudent,
            showReportError: isStudent,
            disabled: currentTaskSubmissionDetails?.type !== "ReadingTask",
            blur: blur,
            blurAll: blurAll,
            startAssignmentUpgrade: startUpgrade,
            usageCapsEnabled: usageCapsEnabled,
            availableUltimateAssessments: availableUltimateAssessments
        });
    } else return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2eb83a4c56813824$export$7365296e18286c25), {
        children: isStudent ? "You have not submitted audio" : "Student did not submit audio"
    });
};
const $70060919ba5e42cc$export$6ddf11c9cd1a51a5 = ()=>{
    const { id: id  } = (0, $4ab21c8a3cbff9b4$export$99eaa27ddbbb95ef)();
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const currentQueryTaskId = query.get("currentTaskId");
    const openComments = query.get("openComments") === "true";
    const { loading: loading , load: load , submission: submission , assessment: assessment , onSubmissionStatus: onSubmissionStatus , setCurrentTask: setCurrentTask , user: user , drawerExpanded: drawerExpanded , upgradeAssessment: upgradeAssessment  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ SubmissionOverviewData: s  })=>({
            loading: s.loading,
            load: s.load,
            submission: s.submission,
            assessment: s.assessment,
            onSubmissionStatus: s.onSubmissionStatus,
            setCurrentTask: s.setCurrentTask,
            user: s.user,
            drawerExpanded: s.drawerExpanded,
            upgradeAssessment: s.upgradeAssessment
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        load({
            id: id,
            openComments: openComments
        });
    }, [
        load,
        id,
        openComments
    ]);
    (0, $g5BLJ.useEffect)(()=>{
        setCurrentTask(currentQueryTaskId ?? assessment?.taskOrder?.find((t)=>t.type === "ReadingTask")?.taskId ?? null);
    }, [
        setCurrentTask,
        currentQueryTaskId,
        assessment
    ]);
    const readingTaskSubmissionDetails = (0, $57ce8a6e7ab158ea$export$c44a57905a1523a2)();
    const showMobileLayout = (0, $4fd3b1c7dfff02ca$export$e818ed21e924bde4)({
        smallerThanOrEqualTo: "tabletSmall"
    });
    if (!readingTaskSubmissionDetails || !submission) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $20484a6b5f32bbb1$export$669f6ea7d267feaf), {
        flex: true,
        kind: "boat"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                title: `${assessment?.name} - ${user?.displayName}`
            }),
            submission && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $018cce6940d253d6$export$b5b6bb8bb5273115), {
                channel: "SubmissionChannel",
                id: submission.id,
                onMessage: onSubmissionStatus
            }),
            showMobileLayout ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $544a9166e5cb34f0$export$cad57e1d4bf5ceb3), {}) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2a0812bc157eca24$export$69546dc4b644da69), {
                        showTopBarDivider: true,
                        loading: loading,
                        topBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $cb1f9a14dfa6f6ce$export$37d641b7d6b469f8), {}),
                        sideBar: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $d5dd97f70cef244c$export$cdea73a9a403baa2), {}),
                        mainContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                            minHeight: 0,
                            height: "100%",
                            width: "100%",
                            overflowY: "auto",
                            align: "center",
                            direction: "column",
                            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($70060919ba5e42cc$var$MainContent, {})
                        }),
                        drawerContent: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($70060919ba5e42cc$var$DrawerContent, {}),
                        drawerExpanded: drawerExpanded
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e5d32e57759481ba$export$dd62f1fd0d4a469b), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $822922ed63c79903$export$1a6938bd84cc541a), {
                        onSuccess: upgradeAssessment
                    })
                ]
            })
        ]
    });
};















var $g5BLJ = parcelRequire("g5BLJ");
const $7a0191745355a036$export$60a63df60e603c6e = ()=>{
    const query = (0, $5557eb3ea8c47b66$export$dd0a697e1782aedd)();
    const sso = query.get("sso");
    const history = (0, $4ab21c8a3cbff9b4$export$3420e1dc2c4a518c)();
    const schoolCodeParam = query.get("schoolCode") || "";
    const { errors: errors , schoolCode: schoolCode , setField: setField , submit: submit , submitting: submitting , load: load  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)((state)=>state.SignUpSchoolCodeData, []);
    (0, $g5BLJ.useEffect)(()=>{
        load();
        setField("schoolCode")(schoolCodeParam);
        submit({
            history: history,
            query: query,
            schoolCode: schoolCodeParam,
            replace: true
        })();
    }, [
        load,
        submit,
        schoolCodeParam,
        history,
        query,
        setField
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $2758239e67023940$export$981215d1ec34b273), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $367677bc6ac034de$export$a7fed597f4b8afd8), {
                onSubmit: submit({
                    history: history,
                    query: query,
                    schoolCode: schoolCode,
                    replace: false
                }),
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        variant: "h1",
                        children: "Enter your school code"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 3
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $15ab8b8dc3306afa$export$2d00230e1e6f7fbc), {
                        name: "schoolCode",
                        label: "School Code",
                        errors: errors,
                        type: "text",
                        value: schoolCode,
                        onChange: setField("schoolCode")
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        size: 2
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$353f5b6fc5456de1), {
                        loading: submitting,
                        type: "submit",
                        disabled: schoolCode.trim().length === 0,
                        children: "Next"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                size: 2
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Don't have a school code?"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        href: "https://readleesupport.zendesk.com/hc/en-us/requests/new",
                        children: "Contact us for help!"
                    })
                ]
            }),
            !sso && /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $673ec96213c6e29e$export$5f1af8db9871e1d6), {
                        children: "Already a user?"
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $67258d8115f0c213$export$d7a54cba636a8cd6), {
                        horizontal: true
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $3aa7eeb60079978b$export$29d11c0fe2fc51d8), {
                        to: `/login${schoolCodeParam && `?schoolCode=${encodeURIComponent(schoolCodeParam)}`}`,
                        children: "Sign In"
                    })
                ]
            })
        ]
    });
};




$86ce6205c10768ba$export$2cd8252107eb640b();
const $c9a82e54f1631545$var$RootRouteRedirect = ()=>{
    const { currentUser: currentUser , loading: loading  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: AppData  })=>({
            currentUser: AppData.currentUser,
            loading: AppData.loading
        }), []);
    if (!loading && !currentUser) return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
        to: "/login"
    });
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2a5e7b0563ceb985$export$cd95088e3160fae9), {
        loading: loading,
        children: currentUser?.accountType === "student" ? /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
            to: "/s/"
        }) : /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
            to: "/t/"
        })
    });
};
const $c9a82e54f1631545$export$86fbec116b87613f = ()=>{
    const { load: load , loading: loading  } = (0, $cd6b4158b51f2e58$export$6ccbb43953eebf8)(({ AppData: AppData  })=>({
            load: AppData.load,
            loading: AppData.loading
        }), []);
    (0, $g5BLJ.useEffect)(()=>{
        if (!window.location.pathname.includes("/login-from-paper/")) load();
    }, [
        load
    ]);
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $72c4360166cb2772$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                path: "/",
                component: $0d509ab7f782af11$export$92ab14d0aa42e41e({
                    loading: loading
                })
            }),
            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $31d38d276dc0d530$export$f51f4c4ede09e011), {
                grow: 1,
                direction: "column",
                minHeight: 0,
                children: [
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $edbf486fc173eb77$export$3db2ef6eb526d0db), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $0a7b3b5a37006e2b$export$ba70b582dbd4aee9), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c22743a123dd1ca8$export$c68f88c44d66a8f8), {}),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$b5d5cf8927ab7262), {
                        children: [
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: [
                                    "/404",
                                    "/500"
                                ],
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Error"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $461144fc90d852b8$export$c120a0e80fd44ca6), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/login",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Login"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $699c44e06e97d7c3$export$21a94553ffa41578), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/google-oauth-callback",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7a90f0a50792e5f0$export$4b780e52ee975c43), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/clever-oauth-callback",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b7e632a982aaf1ec$export$439b170cdb31c6a5), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/sign-up",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Sign Up"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $769b74e7bc4a6320$export$390727f371aa8966), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/logout",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $e5efd731bbd156e5$export$cad1a703886b4e3a), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/back-to-paper",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $a3b80250b48427c2$export$1a08df822e05c415), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/forgot-password",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Forgot Password"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2f4970606729f4c9$export$b597ee422a3143dc), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/sign-up/student",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
                                    to: "/sign-up/student/class-code"
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/sign-up/teacher",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
                                    to: "/sign-up/teacher/register"
                                })
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/sign-up/teacher/school-code",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Sign Up"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7a0191745355a036$export$60a63df60e603c6e), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/sign-up/student/class-code",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Sign Up"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $b24f2e6ffde017b3$export$f139e6fb7d5f99a), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/sign-up/:accountType/register",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Sign Up"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $71df25e57226b7c0$export$790383dda4f4f96a), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/confirmation-sent",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Confirmation Sent"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $95800f2107d69bea$export$dd6c7ffd63972e64), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/confirm-email/:id/:token",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $2335734de65df94d$export$c4f8259ad3f94df5), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/password-resets/:id/:token",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Reset Password"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $47c745fcbea6bfbf$export$a4c3d56613a57187), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/reading-studio",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $399acaba3991b874$export$bdcffb184229ae9), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/submissions/:id",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $70060919ba5e42cc$export$6ddf11c9cd1a51a5), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/j/",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $8425b1a29ae87055$export$ca4a3f934baefe2f), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/a/",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $da3724cfaff11bbc$export$1aac3b59d92526db), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/q/",
                                component: ()=>{
                                    window.location.href = "https://www.readlee.com/contact";
                                    return null;
                                }
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/t/",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $f76706aa6d2d1de5$export$a838d1491e7ec857), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/s/",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $5885484d0186045a$export$73f77934ec61f509), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/m/",
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $7c7d85f4f27b738b$export$709cb64239384269), {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/",
                                exact: true,
                                children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($c9a82e54f1631545$var$RootRouteRedirect, {})
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsxs)((0, $4ab21c8a3cbff9b4$export$e7b0ac011bb776c6), {
                                path: "/avatar-gallery",
                                exact: true,
                                children: [
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $fa8c2e5d82ef81ca$export$f99233281efd08a0), {
                                        title: "Avatars of Readlee"
                                    }),
                                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $040604a74daf8ed4$export$1c06ee2b629770df), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $4ab21c8a3cbff9b4$export$2d8d895a0a0f636e), {
                                to: `/404${(0, $8a14245e3a78cfb1$export$68d86b99fdaf2fad)({
                                    message: "Page Not Found!"
                                })}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $164dcc779e79d074$export$fb98e3a2a4cd92d7), {})
                ]
            })
        ]
    });
};






var $g5BLJ = parcelRequire("g5BLJ");


const $37cf4edf96130a70$var$AppContainer = ()=>{
    const fetchData = (0, $8a14245e3a78cfb1$export$d852f5f778460fa4)();
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $cd6b4158b51f2e58$export$2881499e37b75b9a), {
        createStore: ()=>(0, $f11c2b6d8f5b8d56$export$2aabb3606b6d664f)((0, $cd6b4158b51f2e58$export$de5e90bd767c5d82)(fetchData)).useBaseStore,
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $c9a82e54f1631545$export$86fbec116b87613f), {})
    });
};
const $37cf4edf96130a70$var$Base = ()=>{
    return /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $g5BLJ.StrictMode), {
        children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)((0, $06f449077089668c$export$9ba4e89fdfa1fc54), {
            basename: (0, $0fe4eaef81db718a$export$2cba2d9d62933240) ? (0, $0fe4eaef81db718a$export$3bf57e33594fa3fe) : "",
            children: /*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($37cf4edf96130a70$var$AppContainer, {})
        })
    });
};
const $37cf4edf96130a70$var$rootElement = document.getElementById("app");
(0, $060c403ad4a78f54$exports.render)(/*#__PURE__*/ (0, $72c4360166cb2772$exports.jsx)($37cf4edf96130a70$var$Base, {}), $37cf4edf96130a70$var$rootElement);
// Should swap out for this at some point (broke local last time)
// if (rootElement) {
//   const root = createRoot(rootElement);
//   root.render(<Base />);
// } else {
//   throw new Error('Could not find `app` element.');
// }
if (null) null.accept();


//# sourceMappingURL=index.0a109e1e.js.map
